(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

const asn1 = exports;

asn1.bignum = require('bn.js');

asn1.define = require('./asn1/api').define;
asn1.base = require('./asn1/base');
asn1.constants = require('./asn1/constants');
asn1.decoders = require('./asn1/decoders');
asn1.encoders = require('./asn1/encoders');

},{"./asn1/api":2,"./asn1/base":4,"./asn1/constants":8,"./asn1/decoders":10,"./asn1/encoders":13,"bn.js":15}],2:[function(require,module,exports){
'use strict';

const encoders = require('./encoders');
const decoders = require('./decoders');
const inherits = require('inherits');

const api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
}

Entity.prototype._createNamed = function createNamed(Base) {
  const name = this.name;

  function Generated(entity) {
    this._initNamed(entity, name);
  }
  inherits(Generated, Base);
  Generated.prototype._initNamed = function _initNamed(entity, name) {
    Base.call(this, entity, name);
  };

  return new Generated(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};

},{"./decoders":10,"./encoders":13,"inherits":622}],3:[function(require,module,exports){
'use strict';

const inherits = require('inherits');
const Reporter = require('../base/reporter').Reporter;
const Buffer = require('safer-buffer').Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
  if (data instanceof DecoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    Buffer.isBuffer(data.base) &&
    data.constructor.name === 'DecoderBuffer' &&
    typeof data.offset === 'number' &&
    typeof data.length === 'number' &&
    typeof data.save === 'function' &&
    typeof data.restore === 'function' &&
    typeof data.isEmpty === 'function' &&
    typeof data.readUInt8 === 'function' &&
    typeof data.skip === 'function' &&
    typeof data.raw === 'function';

  return isCompatible;
};

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  const res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
};

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  const res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
};

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
};

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!EncoderBuffer.isEncoderBuffer(item))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
  if (data instanceof EncoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    data.constructor.name === 'EncoderBuffer' &&
    typeof data.length === 'number' &&
    typeof data.join === 'function';

  return isCompatible;
};

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = Buffer.alloc(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};

},{"../base/reporter":6,"inherits":622,"safer-buffer":677}],4:[function(require,module,exports){
'use strict';

const base = exports;

base.Reporter = require('./reporter').Reporter;
base.DecoderBuffer = require('./buffer').DecoderBuffer;
base.EncoderBuffer = require('./buffer').EncoderBuffer;
base.Node = require('./node');

},{"./buffer":3,"./node":5,"./reporter":6}],5:[function(require,module,exports){
'use strict';

const Reporter = require('../base/reporter').Reporter;
const EncoderBuffer = require('../base/buffer').EncoderBuffer;
const DecoderBuffer = require('../base/buffer').DecoderBuffer;
const assert = require('minimalistic-assert');

// Supported tags
const tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
const methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
const overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent, name) {
  const state = {};
  this._baseState = state;

  state.name = name;
  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

const stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  const state = this._baseState;
  const cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  const res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  const state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      const clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  const state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  const state = this._baseState;

  // Filter children and args
  const children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      const res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        const value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    const state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  const state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  const state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  const state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  const state = this._baseState;
  const args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  const state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  const state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  const state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  const state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  let result = state['default'];
  let present = true;

  let prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    let tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      const save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  let prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      const explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    const start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      let save;
      if (state.any)
        save = input.save();
      const body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any) {
      // no-op
    } else if (state.choice === null) {
      result = this._decodeGeneric(state.tag, input, options);
    } else {
      result = this._decodeChoice(input, options);
    }

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      const data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
        ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  const state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
      ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  const state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  const state = this._baseState;
  let result = null;
  let match = false;

  Object.keys(state.choice).some(function(key) {
    const save = input.save();
    const node = state.choice[key];
    try {
      const value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  const state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  const result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  let result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default'];
    else
      return;
  }

  // Encode children first
  let content = null;
  let primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      const prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      const res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      const child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        const state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  if (!state.any && state.choice === null) {
    const tag = state.implicit !== null ? state.implicit : state.tag;
    const cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  const state = this._baseState;

  const node = state.choice[data.type];
  if (!node) {
    assert(
      false,
      data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  const state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

},{"../base/buffer":3,"../base/reporter":6,"minimalistic-assert":632}],6:[function(require,module,exports){
'use strict';

const inherits = require('inherits');

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  const state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  const state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  const state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  const state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  const state = this._reporterState;

  const prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  const state = this._reporterState;

  const now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  let err;
  const state = this._reporterState;

  const inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  const state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
}
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};

},{"inherits":622}],7:[function(require,module,exports){
'use strict';

// Helper
function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
}

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = reverse(exports.tag);

},{}],8:[function(require,module,exports){
'use strict';

const constants = exports;

// Helper
constants._reverse = function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = require('./der');

},{"./der":7}],9:[function(require,module,exports){
'use strict';

const inherits = require('inherits');

const bignum = require('bn.js');
const DecoderBuffer = require('../base/buffer').DecoderBuffer;
const Node = require('../base/node');

// Import DER constants
const der = require('../constants/der');

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!DecoderBuffer.isDecoderBuffer(data)) {
    data = new DecoderBuffer(data, options);
  }

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  const state = buffer.save();
  const decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  const decodedTag = derDecodeTag(buffer,
    'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  let len = derDecodeLen(buffer,
    decodedTag.primitive,
    'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  const state = buffer.save();
  const res = this._skipUntilEnd(
    buffer,
    'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  for (;;) {
    const tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    const len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    let res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len);
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
  options) {
  const result = [];
  while (!buffer.isEmpty()) {
    const possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    const res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    const unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    const raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    let str = '';
    for (let i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    const numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    const printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  let result;
  const identifiers = [];
  let ident = 0;
  let subident = 0;
  while (!buffer.isEmpty()) {
    subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  const first = (identifiers[0] / 40) | 0;
  const second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    let tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  const str = buffer.raw().toString();

  let year;
  let mon;
  let day;
  let hour;
  let min;
  let sec;
  if (tag === 'gentime') {
    year = str.slice(0, 4) | 0;
    mon = str.slice(4, 6) | 0;
    day = str.slice(6, 8) | 0;
    hour = str.slice(8, 10) | 0;
    min = str.slice(10, 12) | 0;
    sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    year = str.slice(0, 2) | 0;
    mon = str.slice(2, 4) | 0;
    day = str.slice(4, 6) | 0;
    hour = str.slice(6, 8) | 0;
    min = str.slice(8, 10) | 0;
    sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull() {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  const res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  const raw = buffer.raw();
  let res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  let tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  const cls = der.tagClass[tag >> 6];
  const primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    let oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  const tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  let len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  const num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (let i = 0; i < num; i++) {
    len <<= 8;
    const j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}

},{"../base/buffer":3,"../base/node":5,"../constants/der":7,"bn.js":15,"inherits":622}],10:[function(require,module,exports){
'use strict';

const decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');

},{"./der":9,"./pem":11}],11:[function(require,module,exports){
'use strict';

const inherits = require('inherits');
const Buffer = require('safer-buffer').Buffer;

const DERDecoder = require('./der');

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  const lines = data.toString().split(/[\r\n]+/g);

  const label = options.label.toUpperCase();

  const re = /^-----(BEGIN|END) ([^-]+)-----$/;
  let start = -1;
  let end = -1;
  for (let i = 0; i < lines.length; i++) {
    const match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  const base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9+/=]+/gi, '');

  const input = Buffer.from(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};

},{"./der":9,"inherits":622,"safer-buffer":677}],12:[function(require,module,exports){
'use strict';

const inherits = require('inherits');
const Buffer = require('safer-buffer').Buffer;
const Node = require('../base/node');

// Import DER constants
const der = require('../constants/der');

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
  primitive,
  cls,
  content) {
  const encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    const header = Buffer.alloc(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  let lenOctets = 1;
  for (let i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  const header = Buffer.alloc(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    const buf = Buffer.alloc(str.length * 2);
    for (let i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s.]+/g);
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  let size = 0;
  for (let i = 0; i < id.length; i++) {
    let ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  const objid = Buffer.alloc(size);
  let offset = objid.length - 1;
  for (let i = id.length - 1; i >= 0; i--) {
    let ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  let str;
  const date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getUTCFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getUTCFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    const numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = Buffer.from(numArray);
  }

  if (Buffer.isBuffer(num)) {
    let size = num.length;
    if (num.length === 0)
      size++;

    const out = Buffer.alloc(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0;
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  let size = 1;
  for (let i = num; i >= 0x100; i >>= 8)
    size++;

  const out = new Array(size);
  for (let i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(Buffer.from(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  const state = this._baseState;
  let i;
  if (state['default'] === null)
    return false;

  const data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  let res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}

},{"../base/node":5,"../constants/der":7,"inherits":622,"safer-buffer":677}],13:[function(require,module,exports){
'use strict';

const encoders = exports;

encoders.der = require('./der');
encoders.pem = require('./pem');

},{"./der":12,"./pem":14}],14:[function(require,module,exports){
'use strict';

const inherits = require('inherits');

const DEREncoder = require('./der');

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  const buf = DEREncoder.prototype.encode.call(this, data);

  const p = buf.toString('base64');
  const out = [ '-----BEGIN ' + options.label + '-----' ];
  for (let i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};

},{"./der":12,"inherits":622}],15:[function(require,module,exports){
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = require('buffer').Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

},{"buffer":49}],16:[function(require,module,exports){
(function (global){
"use strict";

require("core-js/shim");

require("regenerator-runtime/runtime");

require("core-js/fn/regexp/escape");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"core-js/fn/regexp/escape":101,"core-js/shim":544,"regenerator-runtime/runtime":674}],17:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":102}],18:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":103}],19:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };
},{"core-js/library/fn/is-iterable":104}],20:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
},{"core-js/library/fn/json/stringify":105}],21:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/math/trunc"), __esModule: true };
},{"core-js/library/fn/math/trunc":106}],22:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":107}],23:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":108}],24:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":109}],25:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/entries"), __esModule: true };
},{"core-js/library/fn/object/entries":110}],26:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/get-prototype-of":111}],27:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":112}],28:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/set-prototype-of":113}],29:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/values"), __esModule: true };
},{"core-js/library/fn/object/values":114}],30:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":115}],31:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":116}],32:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":117}],33:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _promise = require("../core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
},{"../core-js/promise":30}],34:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],35:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":24}],36:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
},{"../core-js/object/define-property":24}],37:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
},{"../core-js/object/assign":22}],38:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require("../core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require("../core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
},{"../core-js/object/create":23,"../core-js/object/set-prototype-of":28,"../helpers/typeof":42}],39:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
},{"../helpers/typeof":42}],40:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _isIterable2 = require("../core-js/is-iterable");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require("../core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
},{"../core-js/get-iterator":18,"../core-js/is-iterable":19}],41:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":17}],42:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":31,"../core-js/symbol/iterator":32}],43:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

},{"./runtime":44}],44:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);

},{}],45:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":43}],46:[function(require,module,exports){
var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}(typeof exports === 'undefined' ? (this.base64js = {}) : exports))

},{}],47:[function(require,module,exports){
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = require('buffer').Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this._strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    var z = 0;
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      var b;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        b = c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }

      r |= b;
      z |= b;
    }

    assert(!(z & 0xf0), 'Invalid character in ' + str);
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

},{"buffer":49}],48:[function(require,module,exports){
var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = require('crypto');
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}

},{"crypto":49}],49:[function(require,module,exports){

},{}],50:[function(require,module,exports){
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = require('safe-buffer').Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES

},{"safe-buffer":676}],51:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')
var GHASH = require('./ghash')
var xor = require('buffer-xor')
var incr32 = require('./incr32')

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher

},{"./aes":50,"./ghash":55,"./incr32":56,"buffer-xor":95,"cipher-base":98,"inherits":622,"safe-buffer":676}],52:[function(require,module,exports){
var ciphers = require('./encrypter')
var deciphers = require('./decrypter')
var modes = require('./modes/list.json')

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"./decrypter":53,"./encrypter":54,"./modes/list.json":64}],53:[function(require,module,exports){
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var MODES = require('./modes')
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv

},{"./aes":50,"./authCipher":51,"./modes":63,"./streamCipher":66,"cipher-base":98,"evp_bytestokey":585,"inherits":622,"safe-buffer":676}],54:[function(require,module,exports){
var MODES = require('./modes')
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher

},{"./aes":50,"./authCipher":51,"./modes":63,"./streamCipher":66,"cipher-base":98,"evp_bytestokey":585,"inherits":622,"safe-buffer":676}],55:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH

},{"safe-buffer":676}],56:[function(require,module,exports){
function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32

},{}],57:[function(require,module,exports){
var xor = require('buffer-xor')

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}

},{"buffer-xor":95}],58:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var xor = require('buffer-xor')

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}

},{"buffer-xor":95,"safe-buffer":676}],59:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":676}],60:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":676}],61:[function(require,module,exports){
var xor = require('buffer-xor')
var Buffer = require('safe-buffer').Buffer
var incr32 = require('../incr32')

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

},{"../incr32":56,"buffer-xor":95,"safe-buffer":676}],62:[function(require,module,exports){
exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}

},{}],63:[function(require,module,exports){
var modeModules = {
  ECB: require('./ecb'),
  CBC: require('./cbc'),
  CFB: require('./cfb'),
  CFB8: require('./cfb8'),
  CFB1: require('./cfb1'),
  OFB: require('./ofb'),
  CTR: require('./ctr'),
  GCM: require('./ctr')
}

var modes = require('./list.json')

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes

},{"./cbc":57,"./cfb":58,"./cfb1":59,"./cfb8":60,"./ctr":61,"./ecb":62,"./list.json":64,"./ofb":65}],64:[function(require,module,exports){
module.exports={
  "aes-128-ecb": {
    "cipher": "AES",
    "key": 128,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-192-ecb": {
    "cipher": "AES",
    "key": 192,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-256-ecb": {
    "cipher": "AES",
    "key": 256,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-128-cbc": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-192-cbc": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-256-cbc": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes128": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes192": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes256": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-128-cfb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-192-cfb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-256-cfb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-128-cfb8": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-192-cfb8": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-256-cfb8": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-128-cfb1": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-192-cfb1": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-256-cfb1": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-128-ofb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-192-ofb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-256-ofb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-128-ctr": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-192-ctr": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-256-ctr": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-128-gcm": {
    "cipher": "AES",
    "key": 128,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-192-gcm": {
    "cipher": "AES",
    "key": 192,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-256-gcm": {
    "cipher": "AES",
    "key": 256,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  }
}

},{}],65:[function(require,module,exports){
(function (Buffer){
var xor = require('buffer-xor')

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

}).call(this,require("buffer").Buffer)
},{"buffer":96,"buffer-xor":95}],66:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher

},{"./aes":50,"cipher-base":98,"inherits":622,"safe-buffer":676}],67:[function(require,module,exports){
var DES = require('browserify-des')
var aes = require('browserify-aes/browser')
var aesModes = require('browserify-aes/modes')
var desModes = require('browserify-des/modes')
var ebtk = require('evp_bytestokey')

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"browserify-aes/browser":52,"browserify-aes/modes":63,"browserify-des":68,"browserify-des/modes":69,"evp_bytestokey":585}],68:[function(require,module,exports){
var CipherBase = require('cipher-base')
var des = require('des.js')
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}

},{"cipher-base":98,"des.js":555,"inherits":622,"safe-buffer":676}],69:[function(require,module,exports){
exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}

},{}],70:[function(require,module,exports){
(function (Buffer){
var BN = require('bn.js')
var randomBytes = require('randombytes')

function blind (priv) {
  var r = getr(priv)
  var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed()
  return { blinder: blinder, unblinder: r.invm(priv.modulus) }
}

function getr (priv) {
  var len = priv.modulus.byteLength()
  var r
  do {
    r = new BN(randomBytes(len))
  } while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))
  return r
}

function crt (msg, priv) {
  var blinds = blind(priv)
  var len = priv.modulus.byteLength()
  var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus)
  var c1 = blinded.toRed(BN.mont(priv.prime1))
  var c2 = blinded.toRed(BN.mont(priv.prime2))
  var qinv = priv.coefficient
  var p = priv.prime1
  var q = priv.prime2
  var m1 = c1.redPow(priv.exponent1).fromRed()
  var m2 = c2.redPow(priv.exponent2).fromRed()
  var h = m1.isub(m2).imul(qinv).umod(p).imul(q)
  return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len)
}
crt.getr = getr

module.exports = crt

}).call(this,require("buffer").Buffer)
},{"bn.js":47,"buffer":96,"randombytes":657}],71:[function(require,module,exports){
module.exports = require('./browser/algorithms.json')

},{"./browser/algorithms.json":72}],72:[function(require,module,exports){
module.exports={
  "sha224WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "RSA-SHA224": {
    "sign": "ecdsa/rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "sha256WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "RSA-SHA256": {
    "sign": "ecdsa/rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "sha384WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "RSA-SHA384": {
    "sign": "ecdsa/rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "sha512WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA512": {
    "sign": "ecdsa/rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    "sign": "rsa",
    "hash": "sha1",
    "id": "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    "sign": "ecdsa",
    "hash": "sha1",
    "id": ""
  },
  "sha256": {
    "sign": "ecdsa",
    "hash": "sha256",
    "id": ""
  },
  "sha224": {
    "sign": "ecdsa",
    "hash": "sha224",
    "id": ""
  },
  "sha384": {
    "sign": "ecdsa",
    "hash": "sha384",
    "id": ""
  },
  "sha512": {
    "sign": "ecdsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-SHA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-SHA1": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-WITH-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-WITH-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-WITH-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-WITH-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-RIPEMD160": {
    "sign": "dsa",
    "hash": "rmd160",
    "id": ""
  },
  "ripemd160WithRSA": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "RSA-RIPEMD160": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "md5WithRSAEncryption": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  },
  "RSA-MD5": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  }
}

},{}],73:[function(require,module,exports){
module.exports={
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
}

},{}],74:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var createHash = require('create-hash')
var stream = require('readable-stream')
var inherits = require('inherits')
var sign = require('./sign')
var verify = require('./verify')

var algorithms = require('./algorithms.json')
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = Buffer.from(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

},{"./algorithms.json":72,"./sign":75,"./verify":76,"create-hash":548,"inherits":622,"readable-stream":91,"safe-buffer":92}],75:[function(require,module,exports){
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require('safe-buffer').Buffer
var createHmac = require('create-hmac')
var crt = require('browserify-rsa')
var EC = require('elliptic').ec
var BN = require('bn.js')
var parseKeys = require('parse-asn1')
var curves = require('./curves.json')

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [0, 1]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return Buffer.from(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [0].concat(r)
  if (s[0] & 0x80) s = [0].concat(s)

  var total = r.length + s.length + 4
  var res = [0x30, total, 0x02, r.length]
  res = res.concat(r, [0x02, s.length], s)
  return Buffer.from(res)
}

function getKey (x, q, hash, algo) {
  x = Buffer.from(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length)
    x = Buffer.concat([zeros, x])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = Buffer.alloc(hlen)
  v.fill(1)
  var k = Buffer.alloc(hlen)
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = Buffer.from(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length)
    out = Buffer.concat([zeros, out])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = Buffer.alloc(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([t, kv.v])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

},{"./curves.json":73,"bn.js":47,"browserify-rsa":70,"create-hmac":550,"elliptic":566,"parse-asn1":639,"safe-buffer":92}],76:[function(require,module,exports){
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require('safe-buffer').Buffer
var BN = require('bn.js')
var EC = require('elliptic').ec
var parseKeys = require('parse-asn1')
var curves = require('./curves.json')

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [1]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = Buffer.from(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = Buffer.from(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

},{"./curves.json":73,"bn.js":47,"elliptic":566,"parse-asn1":639,"safe-buffer":92}],77:[function(require,module,exports){
'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],78:[function(require,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';
/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];

  for (var key in obj) {
    keys.push(key);
  }

  return keys;
};
/*</replacement>*/


module.exports = Duplex;

var Readable = require('./_stream_readable');

var Writable = require('./_stream_writable');

require('inherits')(Duplex, Readable);

{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);

  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;

  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;

    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
}); // the no-half-open enforcer

function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return; // no more data can be written.
  // But allow more writes to happen in this tick.

  process.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }

    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
}).call(this,require('_process'))
},{"./_stream_readable":80,"./_stream_writable":82,"_process":649,"inherits":622}],79:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

module.exports = PassThrough;

var Transform = require('./_stream_transform');

require('inherits')(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":81,"inherits":622}],80:[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

module.exports = Readable;
/*<replacement>*/

var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;
/*<replacement>*/

var EE = require('events').EventEmitter;

var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/


var Stream = require('./internal/streams/stream');
/*</replacement>*/


var Buffer = require('buffer').Buffer;

var OurUint8Array = global.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/


var debugUtil = require('util');

var debug;

if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/


var BufferList = require('./internal/streams/buffer_list');

var destroyImpl = require('./internal/streams/destroy');

var _require = require('./internal/streams/state'),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = require('../errors').codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.


var StringDecoder;
var createReadableStreamAsyncIterator;
var from;

require('inherits')(Readable, Stream);

var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.

  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"

  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()

  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.

  this.sync = true; // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.

  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')

  this.autoDestroy = !!options.autoDestroy; // has it been destroyed

  this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

  this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;

  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');
  if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex); // legacy

  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }

    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;

Readable.prototype._destroy = function (err, cb) {
  cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.


Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;

      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }

      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()


Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;

  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);

    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;

        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  } // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.


  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }

  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;

  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }

  return er;
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
}; // backwards compatibility.


Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8

  this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:

  var p = this._readableState.buffer.head;
  var content = '';

  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }

  this._readableState.buffer.clear();

  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
}; // Don't raise the hwm > 1GB


var MAX_HWM = 0x40000000;

function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }

  return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.


function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;

  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  } // If we're asking for more than the current hwm, then raise the hwm.


  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n; // Don't have enough

  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }

  return state.length;
} // you can override either this method, or the async _read(n) below.


Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.

  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  } // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.
  // if we need a readable event, then we need to do some reading.


  var doRead = state.needReadable;
  debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  } // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.


  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true; // if the length is currently zero, then we *need* a readable event.

    if (state.length === 0) state.needReadable = true; // call internal read method

    this._read(state.highWaterMark);

    state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.

    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);
  return ret;
};

function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;

  if (state.decoder) {
    var chunk = state.decoder.end();

    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }

  state.ended = true;

  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;

    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.


function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;

  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}

function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);

  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  } // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.


  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.


function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length) // didn't get any data, stop spinning.
      break;
  }

  state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.


Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;

    case 1:
      state.pipes = [state.pipes, dest];
      break;

    default:
      state.pipes.push(dest);
      break;
  }

  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);

  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');

    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  } // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.


  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;

  function cleanup() {
    debug('cleanup'); // cleanup event handlers once the pipe is broken

    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true; // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.

    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  src.on('data', ondata);

  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);

    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }

      src.pause();
    }
  } // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.


  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  } // Make sure our error handler is attached before userland ones.


  prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }

  dest.once('close', onclose);

  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }

  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  } // tell the dest that it's being piped to


  dest.emit('pipe', src); // start the flow if it hasn't been started already.

  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;

    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  }; // if we're not piping anywhere, then do nothing.

  if (state.pipesCount === 0) return this; // just one destination.  most common case.

  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes; // got a match.

    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  } // slow case. multiple pipe destinations.


  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      });
    }

    return this;
  } // try to find the right one.


  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something


Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;

  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused

    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);

      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }

  return res;
};

Readable.prototype.addListener = Readable.prototype.on;

Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);

  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);

  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;

  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.


Readable.prototype.resume = function () {
  var state = this._readableState;

  if (!state.flowing) {
    debug('resume'); // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()

    state.flowing = !state.readableListening;
    resume(this, state);
  }

  state.paused = false;
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  debug('resume', state.reading);

  if (!state.reading) {
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);

  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }

  this._readableState.paused = true;
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);

  while (state.flowing && stream.read() !== null) {
    ;
  }
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.


Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');

    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);

    if (!ret) {
      paused = true;
      stream.pause();
    }
  }); // proxy all the other methods.
  // important when wrapping filters and duplexes.

  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  } // proxy certain important events.


  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  } // when we try to consume some more bytes, simply unpause the
  // underlying stream.


  this._read = function (n) {
    debug('wrapped _read', n);

    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = require('./internal/streams/async_iterator');
    }

    return createReadableStreamAsyncIterator(this);
  };
}

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
}); // exposed for testing purposes only.

Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.

function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);

  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.

  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');

    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;

      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}

if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = require('./internal/streams/from');
    }

    return from(Readable, iterable, opts);
  };
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }

  return -1;
}
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../errors":77,"./_stream_duplex":78,"./internal/streams/async_iterator":83,"./internal/streams/buffer_list":84,"./internal/streams/destroy":85,"./internal/streams/from":87,"./internal/streams/state":89,"./internal/streams/stream":90,"_process":649,"buffer":96,"events":584,"inherits":622,"string_decoder/":93,"util":49}],81:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';

module.exports = Transform;

var _require$codes = require('../errors').codes,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
    ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var Duplex = require('./_stream_duplex');

require('inherits')(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;

  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }

  ts.writechunk = null;
  ts.writecb = null;
  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;

  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }; // start out asking for a readable event once data is transformed.

  this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.

  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  } // When the writable side finishes, then flush out anything remaining.


  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.


Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;

  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.


Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;

    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided

  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}
},{"../errors":77,"./_stream_duplex":78,"inherits":622}],82:[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

module.exports = Writable;
/* <replacement> */

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream


function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/


var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;
/*<replacement>*/

var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/

var Stream = require('./internal/streams/stream');
/*</replacement>*/


var Buffer = require('buffer').Buffer;

var OurUint8Array = global.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

var destroyImpl = require('./internal/streams/destroy');

var _require = require('./internal/streams/state'),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = require('../errors').codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
    ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
    ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
    ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;

var errorOrDestroy = destroyImpl.errorOrDestroy;

require('inherits')(Writable, Stream);

function nop() {}

function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
  // contains buffers or objects.

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()

  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called

  this.finalCalled = false; // drain event flag.

  this.needDrain = false; // at the start of calling end()

  this.ending = false; // when end() has been called, and returned

  this.ended = false; // when 'finish' is emitted

  this.finished = false; // has it been destroyed

  this.destroyed = false; // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.

  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.

  this.length = 0; // a flag to see when we're in the middle of a write.

  this.writing = false; // when true all writes will be buffered until .uncork() call

  this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.

  this.sync = true; // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.

  this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

  this.onwrite = function (er) {
    onwrite(stream, er);
  }; // the callback that the user supplies to write(chunk,encoding,cb)


  this.writecb = null; // the amount that is being written when _write is called.

  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted

  this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams

  this.prefinished = false; // True if the error was already emitted and should not be thrown again

  this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')

  this.autoDestroy = !!options.autoDestroy; // count buffered requests

  this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two

  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];

  while (current) {
    out.push(current);
    current = current.next;
  }

  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.


var realHasInstance;

if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex'); // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.
  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex); // legacy.

  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.


Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};

function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb

  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.


function validChunk(stream, state, chunk, cb) {
  var er;

  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }

  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }

  return true;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};

Writable.prototype.cork = function () {
  this._writableState.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }

  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.

function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);

    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }

  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };

    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }

    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er); // this can emit finish, and it will always happen
    // after error

    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er); // this can emit finish, but finish must
    // always follow error

    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.


function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
} // if there's something in the buffer waiting, then process it


function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;

    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }

    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite

    state.pendingcb++;
    state.lastBufferedRequest = null;

    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }

    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.

      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

  if (state.corked) {
    state.corked = 1;
    this.uncork();
  } // ignore unnecessary end() calls.


  if (!state.ending) endWritable(this, state, cb);
  return this;
};

Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;

    if (err) {
      errorOrDestroy(stream, err);
    }

    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}

function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);

  if (need) {
    prefinish(stream, state);

    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');

      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;

        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }

  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);

  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }

  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;

  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  } // reuse the free corkReq.


  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }

    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;

Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../errors":77,"./_stream_duplex":78,"./internal/streams/destroy":85,"./internal/streams/state":89,"./internal/streams/stream":90,"_process":649,"buffer":96,"inherits":622,"util-deprecate":693}],83:[function(require,module,exports){
(function (process){
'use strict';

var _Object$setPrototypeO;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var finished = require('./end-of-stream');

var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');

function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}

function readAndResolve(iter) {
  var resolve = iter[kLastResolve];

  if (resolve !== null) {
    var data = iter[kStream].read(); // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'

    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}

function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}

function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }

      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}

var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },

  next: function next() {
    var _this = this;

    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];

    if (error !== null) {
      return Promise.reject(error);
    }

    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }

    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    } // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time


    var lastPromise = this[kLastPromise];
    var promise;

    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();

      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }

      promise = new Promise(this[kHandlePromise]);
    }

    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;

  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }

      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);

var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;

  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();

      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
      // returned by next() and store the error

      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }

      iterator[kError] = err;
      return;
    }

    var resolve = iterator[kLastResolve];

    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }

    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};

module.exports = createReadableStreamAsyncIterator;
}).call(this,require('_process'))
},{"./end-of-stream":86,"_process":649}],84:[function(require,module,exports){
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = require('buffer'),
    Buffer = _require.Buffer;

var _require2 = require('util'),
    inspect = _require2.inspect;

var custom = inspect && inspect.custom || 'inspect';

function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}

module.exports =
/*#__PURE__*/
function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;

      while (p = p.next) {
        ret += s + p.data;
      }

      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;

      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }

      return ret;
    } // Consumes a specified amount of bytes or characters from the buffered data.

  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;

      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }

      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    } // Consumes a specified amount of characters from the buffered data.

  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;

      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;

        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Consumes a specified amount of bytes from the buffered data.

  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;

      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;

        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Make sure the linked list only shows the minimal necessary information.

  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread({}, options, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);

  return BufferList;
}();
},{"buffer":96,"util":49}],85:[function(require,module,exports){
(function (process){
'use strict'; // undocumented cb() API, needed for core, not for public API

function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  } // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks


  if (this._readableState) {
    this._readableState.destroyed = true;
  } // if this is a duplex stream mark the writable part as destroyed as well


  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });

  return this;
}

function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}

function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.
  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
}).call(this,require('_process'))
},{"_process":649}],86:[function(require,module,exports){
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var ERR_STREAM_PREMATURE_CLOSE = require('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    callback.apply(this, args);
  };
}

function noop() {}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;

  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };

  var writableEnded = stream._writableState && stream._writableState.finished;

  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };

  var readableEnded = stream._readableState && stream._readableState.endEmitted;

  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };

  var onerror = function onerror(err) {
    callback.call(stream, err);
  };

  var onclose = function onclose() {
    var err;

    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }

    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };

  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };

  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }

  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}

module.exports = eos;
},{"../../../errors":77}],87:[function(require,module,exports){
module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};

},{}],88:[function(require,module,exports){
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var eos;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}

var _require$codes = require('../../../errors').codes,
    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;

function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = require('./end-of-stream');
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true; // request.destroy just do .end - .abort is what we want

    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}

function call(fn) {
  fn();
}

function pipe(from, to) {
  return from.pipe(to);
}

function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}

function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }

  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];

  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }

  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}

module.exports = pipeline;
},{"../../../errors":77,"./end-of-stream":86}],89:[function(require,module,exports){
'use strict';

var ERR_INVALID_OPT_VALUE = require('../../../errors').codes.ERR_INVALID_OPT_VALUE;

function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}

function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);

  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }

    return Math.floor(hwm);
  } // Default value


  return state.objectMode ? 16 : 16 * 1024;
}

module.exports = {
  getHighWaterMark: getHighWaterMark
};
},{"../../../errors":77}],90:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":584}],91:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');
exports.finished = require('./lib/internal/streams/end-of-stream.js');
exports.pipeline = require('./lib/internal/streams/pipeline.js');

},{"./lib/_stream_duplex.js":78,"./lib/_stream_passthrough.js":79,"./lib/_stream_readable.js":80,"./lib/_stream_transform.js":81,"./lib/_stream_writable.js":82,"./lib/internal/streams/end-of-stream.js":86,"./lib/internal/streams/pipeline.js":88}],92:[function(require,module,exports){
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":96}],93:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":92}],94:[function(require,module,exports){
arguments[4][49][0].apply(exports,arguments)
},{"dup":49}],95:[function(require,module,exports){
(function (Buffer){
module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

}).call(this,require("buffer").Buffer)
},{"buffer":96}],96:[function(require,module,exports){
(function (global){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')
var isArray = require('isarray')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50
Buffer.poolSize = 8192 // not used by this implementation

var rootParent = {}

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
 *     on objects.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

function typedArraySupport () {
  function Bar () {}
  try {
    var arr = new Uint8Array(1)
    arr.foo = function () { return 42 }
    arr.constructor = Bar
    return arr.foo() === 42 && // typed array instances can be augmented
        arr.constructor === Bar && // constructor can be set
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

/**
 * Class: Buffer
 * =============
 *
 * The Buffer constructor returns instances of `Uint8Array` that are augmented
 * with function properties for all the node `Buffer` API functions. We use
 * `Uint8Array` so that square bracket notation works as expected -- it returns
 * a single octet.
 *
 * By augmenting the instances, we can avoid modifying the `Uint8Array`
 * prototype.
 */
function Buffer (arg) {
  if (!(this instanceof Buffer)) {
    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
    if (arguments.length > 1) return new Buffer(arg, arguments[1])
    return new Buffer(arg)
  }

  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    this.length = 0
    this.parent = undefined
  }

  // Common case.
  if (typeof arg === 'number') {
    return fromNumber(this, arg)
  }

  // Slightly less common case.
  if (typeof arg === 'string') {
    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
  }

  // Unusual.
  return fromObject(this, arg)
}

function fromNumber (that, length) {
  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < length; i++) {
      that[i] = 0
    }
  }
  return that
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'

  // Assumption: byteLength() return value is always < kMaxLength.
  var length = byteLength(string, encoding) | 0
  that = allocate(that, length)

  that.write(string, encoding)
  return that
}

function fromObject (that, object) {
  if (Buffer.isBuffer(object)) return fromBuffer(that, object)

  if (isArray(object)) return fromArray(that, object)

  if (object == null) {
    throw new TypeError('must start with number, buffer, array or string')
  }

  if (typeof ArrayBuffer !== 'undefined') {
    if (object.buffer instanceof ArrayBuffer) {
      return fromTypedArray(that, object)
    }
    if (object instanceof ArrayBuffer) {
      return fromArrayBuffer(that, object)
    }
  }

  if (object.length) return fromArrayLike(that, object)

  return fromJsonObject(that, object)
}

function fromBuffer (that, buffer) {
  var length = checked(buffer.length) | 0
  that = allocate(that, length)
  buffer.copy(that, 0, 0, length)
  return that
}

function fromArray (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

// Duplicate of fromArray() to keep fromArray() monomorphic.
function fromTypedArray (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  // Truncating the elements is probably not what people expect from typed
  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
  // of the old Buffer constructor.
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array) {
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    array.byteLength
    that = Buffer._augment(new Uint8Array(array))
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromTypedArray(that, new Uint8Array(array))
  }
  return that
}

function fromArrayLike (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
// Returns a zero-length buffer for inputs that don't conform to the spec.
function fromJsonObject (that, object) {
  var array
  var length = 0

  if (object.type === 'Buffer' && isArray(object.data)) {
    array = object.data
    length = checked(array.length) | 0
  }
  that = allocate(that, length)

  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
} else {
  // pre-set for values that may exist in the future
  Buffer.prototype.length = undefined
  Buffer.prototype.parent = undefined
}

function allocate (that, length) {
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = Buffer._augment(new Uint8Array(length))
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that.length = length
    that._isBuffer = true
  }

  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
  if (fromPool) that.parent = rootParent

  return that
}

function checked (length) {
  // Note: cannot use `length < kMaxLength` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (subject, encoding) {
  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)

  var buf = new Buffer(subject, encoding)
  delete buf.parent
  return buf
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  var i = 0
  var len = Math.min(x, y)
  while (i < len) {
    if (a[i] !== b[i]) break

    ++i
  }

  if (i !== len) {
    x = a[i]
    y = b[i]
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'raw':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')

  if (list.length === 0) {
    return new Buffer(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; i++) {
      length += list[i].length
    }
  }

  var buf = new Buffer(length)
  var pos = 0
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    item.copy(buf, pos)
    pos += item.length
  }
  return buf
}

function byteLength (string, encoding) {
  if (typeof string !== 'string') string = '' + string

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'binary':
      // Deprecated
      case 'raw':
      case 'raws':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  start = start | 0
  end = end === undefined || end === Infinity ? this.length : end | 0

  if (!encoding) encoding = 'utf8'
  if (start < 0) start = 0
  if (end > this.length) end = this.length
  if (end <= start) return ''

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'binary':
        return binarySlice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return 0
  return Buffer.compare(this, b)
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
  byteOffset >>= 0

  if (this.length === 0) return -1
  if (byteOffset >= this.length) return -1

  // Negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)

  if (typeof val === 'string') {
    if (val.length === 0) return -1 // special case: looking for empty string always fails
    return String.prototype.indexOf.call(this, val, byteOffset)
  }
  if (Buffer.isBuffer(val)) {
    return arrayIndexOf(this, val, byteOffset)
  }
  if (typeof val === 'number') {
    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
    }
    return arrayIndexOf(this, [ val ], byteOffset)
  }

  function arrayIndexOf (arr, val, byteOffset) {
    var foundIndex = -1
    for (var i = 0; byteOffset + i < arr.length; i++) {
      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
      } else {
        foundIndex = -1
      }
    }
    return -1
  }

  throw new TypeError('val must be string, number or Buffer')
}

// `get` is deprecated
Buffer.prototype.get = function get (offset) {
  console.log('.get() is deprecated. Access using array indexes instead.')
  return this.readUInt8(offset)
}

// `set` is deprecated
Buffer.prototype.set = function set (v, offset) {
  console.log('.set() is deprecated. Access using array indexes instead.')
  return this.writeUInt8(v, offset)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new Error('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; i++) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) throw new Error('Invalid hex string')
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function binaryWrite (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    var swap = encoding
    encoding = offset
    offset = length | 0
    length = swap
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'binary':
        return binaryWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function binarySlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; i++) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = Buffer._augment(this.subarray(start, end))
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; i++) {
      newBuf[i] = this[i + start]
    }
  }

  if (newBuf.length) newBuf.parent = this.parent || this

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('value is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = value < 0 ? 1 : 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = value < 0 ? 1 : 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (value > max || value < min) throw new RangeError('value is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('index out of range')
  if (offset < 0) throw new RangeError('index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; i--) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; i++) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    target._set(this.subarray(start, start + len), targetStart)
  }

  return len
}

// fill(value, start=0, end=buffer.length)
Buffer.prototype.fill = function fill (value, start, end) {
  if (!value) value = 0
  if (!start) start = 0
  if (!end) end = this.length

  if (end < start) throw new RangeError('end < start')

  // Fill 0 bytes; we're done
  if (end === start) return
  if (this.length === 0) return

  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')

  var i
  if (typeof value === 'number') {
    for (i = start; i < end; i++) {
      this[i] = value
    }
  } else {
    var bytes = utf8ToBytes(value.toString())
    var len = bytes.length
    for (i = start; i < end; i++) {
      this[i] = bytes[i % len]
    }
  }

  return this
}

/**
 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
 */
Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
  if (typeof Uint8Array !== 'undefined') {
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      return (new Buffer(this)).buffer
    } else {
      var buf = new Uint8Array(this.length)
      for (var i = 0, len = buf.length; i < len; i += 1) {
        buf[i] = this[i]
      }
      return buf.buffer
    }
  } else {
    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
  }
}

// HELPER FUNCTIONS
// ================

var BP = Buffer.prototype

/**
 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
 */
Buffer._augment = function _augment (arr) {
  arr.constructor = Buffer
  arr._isBuffer = true

  // save reference to original Uint8Array set method before overwriting
  arr._set = arr.set

  // deprecated
  arr.get = BP.get
  arr.set = BP.set

  arr.write = BP.write
  arr.toString = BP.toString
  arr.toLocaleString = BP.toString
  arr.toJSON = BP.toJSON
  arr.equals = BP.equals
  arr.compare = BP.compare
  arr.indexOf = BP.indexOf
  arr.copy = BP.copy
  arr.slice = BP.slice
  arr.readUIntLE = BP.readUIntLE
  arr.readUIntBE = BP.readUIntBE
  arr.readUInt8 = BP.readUInt8
  arr.readUInt16LE = BP.readUInt16LE
  arr.readUInt16BE = BP.readUInt16BE
  arr.readUInt32LE = BP.readUInt32LE
  arr.readUInt32BE = BP.readUInt32BE
  arr.readIntLE = BP.readIntLE
  arr.readIntBE = BP.readIntBE
  arr.readInt8 = BP.readInt8
  arr.readInt16LE = BP.readInt16LE
  arr.readInt16BE = BP.readInt16BE
  arr.readInt32LE = BP.readInt32LE
  arr.readInt32BE = BP.readInt32BE
  arr.readFloatLE = BP.readFloatLE
  arr.readFloatBE = BP.readFloatBE
  arr.readDoubleLE = BP.readDoubleLE
  arr.readDoubleBE = BP.readDoubleBE
  arr.writeUInt8 = BP.writeUInt8
  arr.writeUIntLE = BP.writeUIntLE
  arr.writeUIntBE = BP.writeUIntBE
  arr.writeUInt16LE = BP.writeUInt16LE
  arr.writeUInt16BE = BP.writeUInt16BE
  arr.writeUInt32LE = BP.writeUInt32LE
  arr.writeUInt32BE = BP.writeUInt32BE
  arr.writeIntLE = BP.writeIntLE
  arr.writeIntBE = BP.writeIntBE
  arr.writeInt8 = BP.writeInt8
  arr.writeInt16LE = BP.writeInt16LE
  arr.writeInt16BE = BP.writeInt16BE
  arr.writeInt32LE = BP.writeInt32LE
  arr.writeInt32BE = BP.writeInt32BE
  arr.writeFloatLE = BP.writeFloatLE
  arr.writeFloatBE = BP.writeFloatBE
  arr.writeDoubleLE = BP.writeDoubleLE
  arr.writeDoubleBE = BP.writeDoubleBE
  arr.fill = BP.fill
  arr.inspect = BP.inspect
  arr.toArrayBuffer = BP.toArrayBuffer

  return arr
}

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; i++) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; i++) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"base64-js":46,"ieee754":621,"isarray":97}],97:[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],98:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var Transform = require('stream').Transform
var StringDecoder = require('string_decoder').StringDecoder
var inherits = require('inherits')

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase

},{"inherits":622,"safe-buffer":676,"stream":690,"string_decoder":691}],99:[function(require,module,exports){
(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module', 'select'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});
},{"select":679}],100:[function(require,module,exports){
(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module', './clipboard-action', 'tiny-emitter', 'good-listener'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});
},{"./clipboard-action":99,"good-listener":589,"tiny-emitter":692}],101:[function(require,module,exports){
require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;

},{"../../modules/_core":238,"../../modules/core.regexp.escape":346}],102:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":125,"../../modules/es6.array.from":197,"../../modules/es6.string.iterator":208}],103:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');

},{"../modules/core.get-iterator":195,"../modules/es6.string.iterator":208,"../modules/web.dom.iterable":216}],104:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');

},{"../modules/core.is-iterable":196,"../modules/es6.string.iterator":208,"../modules/web.dom.iterable":216}],105:[function(require,module,exports){
var core = require('../../modules/_core');
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

},{"../../modules/_core":125}],106:[function(require,module,exports){
require('../../modules/es6.math.trunc');
module.exports = require('../../modules/_core').Math.trunc;

},{"../../modules/_core":125,"../../modules/es6.math.trunc":199}],107:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":125,"../../modules/es6.object.assign":200}],108:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

},{"../../modules/_core":125,"../../modules/es6.object.create":201}],109:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

},{"../../modules/_core":125,"../../modules/es6.object.define-property":202}],110:[function(require,module,exports){
require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;

},{"../../modules/_core":125,"../../modules/es7.object.entries":210}],111:[function(require,module,exports){
require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;

},{"../../modules/_core":125,"../../modules/es6.object.get-prototype-of":203}],112:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;

},{"../../modules/_core":125,"../../modules/es6.object.keys":204}],113:[function(require,module,exports){
require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;

},{"../../modules/_core":125,"../../modules/es6.object.set-prototype-of":205}],114:[function(require,module,exports){
require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;

},{"../../modules/_core":125,"../../modules/es7.object.values":211}],115:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.promise.finally');
require('../modules/es7.promise.try');
module.exports = require('../modules/_core').Promise;

},{"../modules/_core":125,"../modules/es6.object.to-string":206,"../modules/es6.promise":207,"../modules/es6.string.iterator":208,"../modules/es7.promise.finally":212,"../modules/es7.promise.try":213,"../modules/web.dom.iterable":216}],116:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":125,"../../modules/es6.object.to-string":206,"../../modules/es6.symbol":209,"../../modules/es7.symbol.async-iterator":214,"../../modules/es7.symbol.observable":215}],117:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":192,"../../modules/es6.string.iterator":208,"../../modules/web.dom.iterable":216}],118:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],119:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],120:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],121:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":145}],122:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":183,"./_to-iobject":185,"./_to-length":186}],123:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":124,"./_wks":193}],124:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],125:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],126:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":158,"./_property-desc":172}],127:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":118}],128:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],129:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":134}],130:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":136,"./_is-object":145}],131:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],132:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":163,"./_object-keys":166,"./_object-pie":167}],133:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":125,"./_ctx":127,"./_global":136,"./_has":137,"./_hide":138}],134:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],135:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":121,"./_ctx":127,"./_is-array-iter":143,"./_iter-call":146,"./_to-length":186,"./core.get-iterator-method":194}],136:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],137:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],138:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":129,"./_object-dp":158,"./_property-desc":172}],139:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":136}],140:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":129,"./_dom-create":130,"./_fails":134}],141:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],142:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":124}],143:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":151,"./_wks":193}],144:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":124}],145:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],146:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":121}],147:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":138,"./_object-create":157,"./_property-desc":172,"./_set-to-string-tag":177,"./_wks":193}],148:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":133,"./_hide":138,"./_iter-create":147,"./_iterators":151,"./_library":152,"./_object-gpo":164,"./_redefine":174,"./_set-to-string-tag":177,"./_wks":193}],149:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":193}],150:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],151:[function(require,module,exports){
module.exports = {};

},{}],152:[function(require,module,exports){
module.exports = true;

},{}],153:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":134,"./_has":137,"./_is-object":145,"./_object-dp":158,"./_uid":189}],154:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":124,"./_global":136,"./_task":182}],155:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":118}],156:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"./_descriptors":129,"./_fails":134,"./_iobject":142,"./_object-gops":163,"./_object-keys":166,"./_object-pie":167,"./_to-object":187}],157:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":121,"./_dom-create":130,"./_enum-bug-keys":131,"./_html":139,"./_object-dps":159,"./_shared-key":178}],158:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":121,"./_descriptors":129,"./_ie8-dom-define":140,"./_to-primitive":188}],159:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":121,"./_descriptors":129,"./_object-dp":158,"./_object-keys":166}],160:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":129,"./_has":137,"./_ie8-dom-define":140,"./_object-pie":167,"./_property-desc":172,"./_to-iobject":185,"./_to-primitive":188}],161:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":162,"./_to-iobject":185}],162:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":131,"./_object-keys-internal":165}],163:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],164:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":137,"./_shared-key":178,"./_to-object":187}],165:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":122,"./_has":137,"./_shared-key":178,"./_to-iobject":185}],166:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":131,"./_object-keys-internal":165}],167:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],168:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":125,"./_export":133,"./_fails":134}],169:[function(require,module,exports){
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

},{"./_descriptors":129,"./_object-keys":166,"./_object-pie":167,"./_to-iobject":185}],170:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],171:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":121,"./_is-object":145,"./_new-promise-capability":155}],172:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],173:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

},{"./_hide":138}],174:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":138}],175:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":121,"./_ctx":127,"./_is-object":145,"./_object-gopd":160}],176:[function(require,module,exports){
'use strict';
var global = require('./_global');
var core = require('./_core');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_core":125,"./_descriptors":129,"./_global":136,"./_object-dp":158,"./_wks":193}],177:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":137,"./_object-dp":158,"./_wks":193}],178:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":179,"./_uid":189}],179:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":125,"./_global":136,"./_library":152}],180:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":118,"./_an-object":121,"./_wks":193}],181:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":128,"./_to-integer":184}],182:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":124,"./_ctx":127,"./_dom-create":130,"./_global":136,"./_html":139,"./_invoke":141}],183:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":184}],184:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],185:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":128,"./_iobject":142}],186:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":184}],187:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":128}],188:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":145}],189:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],190:[function(require,module,exports){
var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"./_global":136}],191:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":125,"./_global":136,"./_library":152,"./_object-dp":158,"./_wks-ext":192}],192:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":193}],193:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":136,"./_shared":179,"./_uid":189}],194:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":123,"./_core":125,"./_iterators":151,"./_wks":193}],195:[function(require,module,exports){
var anObject = require('./_an-object');
var get = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

},{"./_an-object":121,"./_core":125,"./core.get-iterator-method":194}],196:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};

},{"./_classof":123,"./_core":125,"./_iterators":151,"./_wks":193}],197:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":126,"./_ctx":127,"./_export":133,"./_is-array-iter":143,"./_iter-call":146,"./_iter-detect":149,"./_to-length":186,"./_to-object":187,"./core.get-iterator-method":194}],198:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":119,"./_iter-define":148,"./_iter-step":150,"./_iterators":151,"./_to-iobject":185}],199:[function(require,module,exports){
// 20.2.2.34 Math.trunc(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

},{"./_export":133}],200:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":133,"./_object-assign":156}],201:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":133,"./_object-create":157}],202:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":129,"./_export":133,"./_object-dp":158}],203:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":164,"./_object-sap":168,"./_to-object":187}],204:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":166,"./_object-sap":168,"./_to-object":187}],205:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":133,"./_set-proto":175}],206:[function(require,module,exports){
arguments[4][49][0].apply(exports,arguments)
},{"dup":49}],207:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var userAgent = require('./_user-agent');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":118,"./_an-instance":120,"./_classof":123,"./_core":125,"./_ctx":127,"./_export":133,"./_for-of":135,"./_global":136,"./_is-object":145,"./_iter-detect":149,"./_library":152,"./_microtask":154,"./_new-promise-capability":155,"./_perform":170,"./_promise-resolve":171,"./_redefine-all":173,"./_set-species":176,"./_set-to-string-tag":177,"./_species-constructor":180,"./_task":182,"./_user-agent":190,"./_wks":193}],208:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":148,"./_string-at":181}],209:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toObject = require('./_to-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $GOPS = require('./_object-gops');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":121,"./_descriptors":129,"./_enum-keys":132,"./_export":133,"./_fails":134,"./_global":136,"./_has":137,"./_hide":138,"./_is-array":144,"./_is-object":145,"./_library":152,"./_meta":153,"./_object-create":157,"./_object-dp":158,"./_object-gopd":160,"./_object-gopn":162,"./_object-gopn-ext":161,"./_object-gops":163,"./_object-keys":166,"./_object-pie":167,"./_property-desc":172,"./_redefine":174,"./_set-to-string-tag":177,"./_shared":179,"./_to-iobject":185,"./_to-object":187,"./_to-primitive":188,"./_uid":189,"./_wks":193,"./_wks-define":191,"./_wks-ext":192}],210:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

},{"./_export":133,"./_object-to-array":169}],211:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"./_export":133,"./_object-to-array":169}],212:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":125,"./_export":133,"./_global":136,"./_promise-resolve":171,"./_species-constructor":180}],213:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":133,"./_new-promise-capability":155,"./_perform":170}],214:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":191}],215:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":191}],216:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":136,"./_hide":138,"./_iterators":151,"./_wks":193,"./es6.array.iterator":198}],217:[function(require,module,exports){
arguments[4][118][0].apply(exports,arguments)
},{"dup":118}],218:[function(require,module,exports){
var cof = require('./_cof');
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

},{"./_cof":233}],219:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"./_hide":258,"./_wks":344}],220:[function(require,module,exports){
'use strict';
var at = require('./_string-at')(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

},{"./_string-at":321}],221:[function(require,module,exports){
arguments[4][120][0].apply(exports,arguments)
},{"dup":120}],222:[function(require,module,exports){
arguments[4][121][0].apply(exports,arguments)
},{"./_is-object":267,"dup":121}],223:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

},{"./_to-absolute-index":329,"./_to-length":333,"./_to-object":334}],224:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"./_to-absolute-index":329,"./_to-length":333,"./_to-object":334}],225:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":254}],226:[function(require,module,exports){
arguments[4][122][0].apply(exports,arguments)
},{"./_to-absolute-index":329,"./_to-iobject":332,"./_to-length":333,"dup":122}],227:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":230,"./_ctx":240,"./_iobject":263,"./_to-length":333,"./_to-object":334}],228:[function(require,module,exports){
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var toLength = require('./_to-length');

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

},{"./_a-function":217,"./_iobject":263,"./_to-length":333,"./_to-object":334}],229:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":265,"./_is-object":267,"./_wks":344}],230:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":229}],231:[function(require,module,exports){
'use strict';
var aFunction = require('./_a-function');
var isObject = require('./_is-object');
var invoke = require('./_invoke');
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

},{"./_a-function":217,"./_invoke":262,"./_is-object":267}],232:[function(require,module,exports){
arguments[4][123][0].apply(exports,arguments)
},{"./_cof":233,"./_wks":344,"dup":123}],233:[function(require,module,exports){
arguments[4][124][0].apply(exports,arguments)
},{"dup":124}],234:[function(require,module,exports){
'use strict';
var dP = require('./_object-dp').f;
var create = require('./_object-create');
var redefineAll = require('./_redefine-all');
var ctx = require('./_ctx');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var $iterDefine = require('./_iter-define');
var step = require('./_iter-step');
var setSpecies = require('./_set-species');
var DESCRIPTORS = require('./_descriptors');
var fastKey = require('./_meta').fastKey;
var validate = require('./_validate-collection');
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"./_an-instance":221,"./_ctx":240,"./_descriptors":244,"./_for-of":254,"./_iter-define":271,"./_iter-step":273,"./_meta":281,"./_object-create":286,"./_object-dp":287,"./_redefine-all":306,"./_set-species":315,"./_validate-collection":341}],235:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof');
var from = require('./_array-from-iterable');
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

},{"./_array-from-iterable":225,"./_classof":232}],236:[function(require,module,exports){
'use strict';
var redefineAll = require('./_redefine-all');
var getWeak = require('./_meta').getWeak;
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var createArrayMethod = require('./_array-methods');
var $has = require('./_has');
var validate = require('./_validate-collection');
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

},{"./_an-instance":221,"./_an-object":222,"./_array-methods":227,"./_for-of":254,"./_has":257,"./_is-object":267,"./_meta":281,"./_redefine-all":306,"./_validate-collection":341}],237:[function(require,module,exports){
'use strict';
var global = require('./_global');
var $export = require('./_export');
var redefine = require('./_redefine');
var redefineAll = require('./_redefine-all');
var meta = require('./_meta');
var forOf = require('./_for-of');
var anInstance = require('./_an-instance');
var isObject = require('./_is-object');
var fails = require('./_fails');
var $iterDetect = require('./_iter-detect');
var setToStringTag = require('./_set-to-string-tag');
var inheritIfRequired = require('./_inherit-if-required');

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"./_an-instance":221,"./_export":248,"./_fails":250,"./_for-of":254,"./_global":256,"./_inherit-if-required":261,"./_is-object":267,"./_iter-detect":272,"./_meta":281,"./_redefine":307,"./_redefine-all":306,"./_set-to-string-tag":316}],238:[function(require,module,exports){
arguments[4][125][0].apply(exports,arguments)
},{"dup":125}],239:[function(require,module,exports){
arguments[4][126][0].apply(exports,arguments)
},{"./_object-dp":287,"./_property-desc":305,"dup":126}],240:[function(require,module,exports){
arguments[4][127][0].apply(exports,arguments)
},{"./_a-function":217,"dup":127}],241:[function(require,module,exports){
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = require('./_fails');
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

},{"./_fails":250}],242:[function(require,module,exports){
'use strict';
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

},{"./_an-object":222,"./_to-primitive":335}],243:[function(require,module,exports){
arguments[4][128][0].apply(exports,arguments)
},{"dup":128}],244:[function(require,module,exports){
arguments[4][129][0].apply(exports,arguments)
},{"./_fails":250,"dup":129}],245:[function(require,module,exports){
arguments[4][130][0].apply(exports,arguments)
},{"./_global":256,"./_is-object":267,"dup":130}],246:[function(require,module,exports){
arguments[4][131][0].apply(exports,arguments)
},{"dup":131}],247:[function(require,module,exports){
arguments[4][132][0].apply(exports,arguments)
},{"./_object-gops":293,"./_object-keys":296,"./_object-pie":297,"dup":132}],248:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":238,"./_ctx":240,"./_global":256,"./_hide":258,"./_redefine":307}],249:[function(require,module,exports){
var MATCH = require('./_wks')('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

},{"./_wks":344}],250:[function(require,module,exports){
arguments[4][134][0].apply(exports,arguments)
},{"dup":134}],251:[function(require,module,exports){
'use strict';
require('./es6.regexp.exec');
var redefine = require('./_redefine');
var hide = require('./_hide');
var fails = require('./_fails');
var defined = require('./_defined');
var wks = require('./_wks');
var regexpExec = require('./_regexp-exec');

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

},{"./_defined":243,"./_fails":250,"./_hide":258,"./_redefine":307,"./_regexp-exec":309,"./_wks":344,"./es6.regexp.exec":441}],252:[function(require,module,exports){
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = require('./_an-object');
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

},{"./_an-object":222}],253:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = require('./_is-array');
var isObject = require('./_is-object');
var toLength = require('./_to-length');
var ctx = require('./_ctx');
var IS_CONCAT_SPREADABLE = require('./_wks')('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

},{"./_ctx":240,"./_is-array":265,"./_is-object":267,"./_to-length":333,"./_wks":344}],254:[function(require,module,exports){
arguments[4][135][0].apply(exports,arguments)
},{"./_an-object":222,"./_ctx":240,"./_is-array-iter":264,"./_iter-call":269,"./_to-length":333,"./core.get-iterator-method":345,"dup":135}],255:[function(require,module,exports){
module.exports = require('./_shared')('native-function-to-string', Function.toString);

},{"./_shared":318}],256:[function(require,module,exports){
arguments[4][136][0].apply(exports,arguments)
},{"dup":136}],257:[function(require,module,exports){
arguments[4][137][0].apply(exports,arguments)
},{"dup":137}],258:[function(require,module,exports){
arguments[4][138][0].apply(exports,arguments)
},{"./_descriptors":244,"./_object-dp":287,"./_property-desc":305,"dup":138}],259:[function(require,module,exports){
arguments[4][139][0].apply(exports,arguments)
},{"./_global":256,"dup":139}],260:[function(require,module,exports){
arguments[4][140][0].apply(exports,arguments)
},{"./_descriptors":244,"./_dom-create":245,"./_fails":250,"dup":140}],261:[function(require,module,exports){
var isObject = require('./_is-object');
var setPrototypeOf = require('./_set-proto').set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

},{"./_is-object":267,"./_set-proto":314}],262:[function(require,module,exports){
arguments[4][141][0].apply(exports,arguments)
},{"dup":141}],263:[function(require,module,exports){
arguments[4][142][0].apply(exports,arguments)
},{"./_cof":233,"dup":142}],264:[function(require,module,exports){
arguments[4][143][0].apply(exports,arguments)
},{"./_iterators":274,"./_wks":344,"dup":143}],265:[function(require,module,exports){
arguments[4][144][0].apply(exports,arguments)
},{"./_cof":233,"dup":144}],266:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"./_is-object":267}],267:[function(require,module,exports){
arguments[4][145][0].apply(exports,arguments)
},{"dup":145}],268:[function(require,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object');
var cof = require('./_cof');
var MATCH = require('./_wks')('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

},{"./_cof":233,"./_is-object":267,"./_wks":344}],269:[function(require,module,exports){
arguments[4][146][0].apply(exports,arguments)
},{"./_an-object":222,"dup":146}],270:[function(require,module,exports){
arguments[4][147][0].apply(exports,arguments)
},{"./_hide":258,"./_object-create":286,"./_property-desc":305,"./_set-to-string-tag":316,"./_wks":344,"dup":147}],271:[function(require,module,exports){
arguments[4][148][0].apply(exports,arguments)
},{"./_export":248,"./_hide":258,"./_iter-create":270,"./_iterators":274,"./_library":275,"./_object-gpo":294,"./_redefine":307,"./_set-to-string-tag":316,"./_wks":344,"dup":148}],272:[function(require,module,exports){
arguments[4][149][0].apply(exports,arguments)
},{"./_wks":344,"dup":149}],273:[function(require,module,exports){
arguments[4][150][0].apply(exports,arguments)
},{"dup":150}],274:[function(require,module,exports){
arguments[4][151][0].apply(exports,arguments)
},{"dup":151}],275:[function(require,module,exports){
module.exports = false;

},{}],276:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

},{}],277:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var sign = require('./_math-sign');
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

},{"./_math-sign":280}],278:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

},{}],279:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

},{}],280:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

},{}],281:[function(require,module,exports){
arguments[4][153][0].apply(exports,arguments)
},{"./_fails":250,"./_has":257,"./_is-object":267,"./_object-dp":287,"./_uid":339,"dup":153}],282:[function(require,module,exports){
var Map = require('./es6.map');
var $export = require('./_export');
var shared = require('./_shared')('metadata');
var store = shared.store || (shared.store = new (require('./es6.weak-map'))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

},{"./_export":248,"./_shared":318,"./es6.map":376,"./es6.weak-map":483}],283:[function(require,module,exports){
arguments[4][154][0].apply(exports,arguments)
},{"./_cof":233,"./_global":256,"./_task":328,"dup":154}],284:[function(require,module,exports){
arguments[4][155][0].apply(exports,arguments)
},{"./_a-function":217,"dup":155}],285:[function(require,module,exports){
arguments[4][156][0].apply(exports,arguments)
},{"./_descriptors":244,"./_fails":250,"./_iobject":263,"./_object-gops":293,"./_object-keys":296,"./_object-pie":297,"./_to-object":334,"dup":156}],286:[function(require,module,exports){
arguments[4][157][0].apply(exports,arguments)
},{"./_an-object":222,"./_dom-create":245,"./_enum-bug-keys":246,"./_html":259,"./_object-dps":288,"./_shared-key":317,"dup":157}],287:[function(require,module,exports){
arguments[4][158][0].apply(exports,arguments)
},{"./_an-object":222,"./_descriptors":244,"./_ie8-dom-define":260,"./_to-primitive":335,"dup":158}],288:[function(require,module,exports){
arguments[4][159][0].apply(exports,arguments)
},{"./_an-object":222,"./_descriptors":244,"./_object-dp":287,"./_object-keys":296,"dup":159}],289:[function(require,module,exports){
'use strict';
// Forced replacement prototype accessors methods
module.exports = require('./_library') || !require('./_fails')(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete require('./_global')[K];
});

},{"./_fails":250,"./_global":256,"./_library":275}],290:[function(require,module,exports){
arguments[4][160][0].apply(exports,arguments)
},{"./_descriptors":244,"./_has":257,"./_ie8-dom-define":260,"./_object-pie":297,"./_property-desc":305,"./_to-iobject":332,"./_to-primitive":335,"dup":160}],291:[function(require,module,exports){
arguments[4][161][0].apply(exports,arguments)
},{"./_object-gopn":292,"./_to-iobject":332,"dup":161}],292:[function(require,module,exports){
arguments[4][162][0].apply(exports,arguments)
},{"./_enum-bug-keys":246,"./_object-keys-internal":295,"dup":162}],293:[function(require,module,exports){
arguments[4][163][0].apply(exports,arguments)
},{"dup":163}],294:[function(require,module,exports){
arguments[4][164][0].apply(exports,arguments)
},{"./_has":257,"./_shared-key":317,"./_to-object":334,"dup":164}],295:[function(require,module,exports){
arguments[4][165][0].apply(exports,arguments)
},{"./_array-includes":226,"./_has":257,"./_shared-key":317,"./_to-iobject":332,"dup":165}],296:[function(require,module,exports){
arguments[4][166][0].apply(exports,arguments)
},{"./_enum-bug-keys":246,"./_object-keys-internal":295,"dup":166}],297:[function(require,module,exports){
arguments[4][167][0].apply(exports,arguments)
},{"dup":167}],298:[function(require,module,exports){
arguments[4][168][0].apply(exports,arguments)
},{"./_core":238,"./_export":248,"./_fails":250,"dup":168}],299:[function(require,module,exports){
arguments[4][169][0].apply(exports,arguments)
},{"./_descriptors":244,"./_object-keys":296,"./_object-pie":297,"./_to-iobject":332,"dup":169}],300:[function(require,module,exports){
// all object keys, includes non-enumerable and symbols
var gOPN = require('./_object-gopn');
var gOPS = require('./_object-gops');
var anObject = require('./_an-object');
var Reflect = require('./_global').Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

},{"./_an-object":222,"./_global":256,"./_object-gopn":292,"./_object-gops":293}],301:[function(require,module,exports){
var $parseFloat = require('./_global').parseFloat;
var $trim = require('./_string-trim').trim;

module.exports = 1 / $parseFloat(require('./_string-ws') + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

},{"./_global":256,"./_string-trim":326,"./_string-ws":327}],302:[function(require,module,exports){
var $parseInt = require('./_global').parseInt;
var $trim = require('./_string-trim').trim;
var ws = require('./_string-ws');
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

},{"./_global":256,"./_string-trim":326,"./_string-ws":327}],303:[function(require,module,exports){
arguments[4][170][0].apply(exports,arguments)
},{"dup":170}],304:[function(require,module,exports){
arguments[4][171][0].apply(exports,arguments)
},{"./_an-object":222,"./_is-object":267,"./_new-promise-capability":284,"dup":171}],305:[function(require,module,exports){
arguments[4][172][0].apply(exports,arguments)
},{"dup":172}],306:[function(require,module,exports){
var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};

},{"./_redefine":307}],307:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var $toString = require('./_function-to-string');
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":238,"./_function-to-string":255,"./_global":256,"./_has":257,"./_hide":258,"./_uid":339}],308:[function(require,module,exports){
'use strict';

var classof = require('./_classof');
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

},{"./_classof":232}],309:[function(require,module,exports){
'use strict';

var regexpFlags = require('./_flags');

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;

},{"./_flags":252}],310:[function(require,module,exports){
module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

},{}],311:[function(require,module,exports){
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],312:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');
var aFunction = require('./_a-function');
var ctx = require('./_ctx');
var forOf = require('./_for-of');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

},{"./_a-function":217,"./_ctx":240,"./_export":248,"./_for-of":254}],313:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

},{"./_export":248}],314:[function(require,module,exports){
arguments[4][175][0].apply(exports,arguments)
},{"./_an-object":222,"./_ctx":240,"./_is-object":267,"./_object-gopd":290,"dup":175}],315:[function(require,module,exports){
'use strict';
var global = require('./_global');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_descriptors":244,"./_global":256,"./_object-dp":287,"./_wks":344}],316:[function(require,module,exports){
arguments[4][177][0].apply(exports,arguments)
},{"./_has":257,"./_object-dp":287,"./_wks":344,"dup":177}],317:[function(require,module,exports){
arguments[4][178][0].apply(exports,arguments)
},{"./_shared":318,"./_uid":339,"dup":178}],318:[function(require,module,exports){
arguments[4][179][0].apply(exports,arguments)
},{"./_core":238,"./_global":256,"./_library":275,"dup":179}],319:[function(require,module,exports){
arguments[4][180][0].apply(exports,arguments)
},{"./_a-function":217,"./_an-object":222,"./_wks":344,"dup":180}],320:[function(require,module,exports){
'use strict';
var fails = require('./_fails');

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

},{"./_fails":250}],321:[function(require,module,exports){
arguments[4][181][0].apply(exports,arguments)
},{"./_defined":243,"./_to-integer":331,"dup":181}],322:[function(require,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp');
var defined = require('./_defined');

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

},{"./_defined":243,"./_is-regexp":268}],323:[function(require,module,exports){
var $export = require('./_export');
var fails = require('./_fails');
var defined = require('./_defined');
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

},{"./_defined":243,"./_export":248,"./_fails":250}],324:[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var toLength = require('./_to-length');
var repeat = require('./_string-repeat');
var defined = require('./_defined');

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

},{"./_defined":243,"./_string-repeat":325,"./_to-length":333}],325:[function(require,module,exports){
'use strict';
var toInteger = require('./_to-integer');
var defined = require('./_defined');

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

},{"./_defined":243,"./_to-integer":331}],326:[function(require,module,exports){
var $export = require('./_export');
var defined = require('./_defined');
var fails = require('./_fails');
var spaces = require('./_string-ws');
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

},{"./_defined":243,"./_export":248,"./_fails":250,"./_string-ws":327}],327:[function(require,module,exports){
module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],328:[function(require,module,exports){
arguments[4][182][0].apply(exports,arguments)
},{"./_cof":233,"./_ctx":240,"./_dom-create":245,"./_global":256,"./_html":259,"./_invoke":262,"dup":182}],329:[function(require,module,exports){
arguments[4][183][0].apply(exports,arguments)
},{"./_to-integer":331,"dup":183}],330:[function(require,module,exports){
// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

},{"./_to-integer":331,"./_to-length":333}],331:[function(require,module,exports){
arguments[4][184][0].apply(exports,arguments)
},{"dup":184}],332:[function(require,module,exports){
arguments[4][185][0].apply(exports,arguments)
},{"./_defined":243,"./_iobject":263,"dup":185}],333:[function(require,module,exports){
arguments[4][186][0].apply(exports,arguments)
},{"./_to-integer":331,"dup":186}],334:[function(require,module,exports){
arguments[4][187][0].apply(exports,arguments)
},{"./_defined":243,"dup":187}],335:[function(require,module,exports){
arguments[4][188][0].apply(exports,arguments)
},{"./_is-object":267,"dup":188}],336:[function(require,module,exports){
'use strict';
if (require('./_descriptors')) {
  var LIBRARY = require('./_library');
  var global = require('./_global');
  var fails = require('./_fails');
  var $export = require('./_export');
  var $typed = require('./_typed');
  var $buffer = require('./_typed-buffer');
  var ctx = require('./_ctx');
  var anInstance = require('./_an-instance');
  var propertyDesc = require('./_property-desc');
  var hide = require('./_hide');
  var redefineAll = require('./_redefine-all');
  var toInteger = require('./_to-integer');
  var toLength = require('./_to-length');
  var toIndex = require('./_to-index');
  var toAbsoluteIndex = require('./_to-absolute-index');
  var toPrimitive = require('./_to-primitive');
  var has = require('./_has');
  var classof = require('./_classof');
  var isObject = require('./_is-object');
  var toObject = require('./_to-object');
  var isArrayIter = require('./_is-array-iter');
  var create = require('./_object-create');
  var getPrototypeOf = require('./_object-gpo');
  var gOPN = require('./_object-gopn').f;
  var getIterFn = require('./core.get-iterator-method');
  var uid = require('./_uid');
  var wks = require('./_wks');
  var createArrayMethod = require('./_array-methods');
  var createArrayIncludes = require('./_array-includes');
  var speciesConstructor = require('./_species-constructor');
  var ArrayIterators = require('./es6.array.iterator');
  var Iterators = require('./_iterators');
  var $iterDetect = require('./_iter-detect');
  var setSpecies = require('./_set-species');
  var arrayFill = require('./_array-fill');
  var arrayCopyWithin = require('./_array-copy-within');
  var $DP = require('./_object-dp');
  var $GOPD = require('./_object-gopd');
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };

},{"./_an-instance":221,"./_array-copy-within":223,"./_array-fill":224,"./_array-includes":226,"./_array-methods":227,"./_classof":232,"./_ctx":240,"./_descriptors":244,"./_export":248,"./_fails":250,"./_global":256,"./_has":257,"./_hide":258,"./_is-array-iter":264,"./_is-object":267,"./_iter-detect":272,"./_iterators":274,"./_library":275,"./_object-create":286,"./_object-dp":287,"./_object-gopd":290,"./_object-gopn":292,"./_object-gpo":294,"./_property-desc":305,"./_redefine-all":306,"./_set-species":315,"./_species-constructor":319,"./_to-absolute-index":329,"./_to-index":330,"./_to-integer":331,"./_to-length":333,"./_to-object":334,"./_to-primitive":335,"./_typed":338,"./_typed-buffer":337,"./_uid":339,"./_wks":344,"./core.get-iterator-method":345,"./es6.array.iterator":357}],337:[function(require,module,exports){
'use strict';
var global = require('./_global');
var DESCRIPTORS = require('./_descriptors');
var LIBRARY = require('./_library');
var $typed = require('./_typed');
var hide = require('./_hide');
var redefineAll = require('./_redefine-all');
var fails = require('./_fails');
var anInstance = require('./_an-instance');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var toIndex = require('./_to-index');
var gOPN = require('./_object-gopn').f;
var dP = require('./_object-dp').f;
var arrayFill = require('./_array-fill');
var setToStringTag = require('./_set-to-string-tag');
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

},{"./_an-instance":221,"./_array-fill":224,"./_descriptors":244,"./_fails":250,"./_global":256,"./_hide":258,"./_library":275,"./_object-dp":287,"./_object-gopn":292,"./_redefine-all":306,"./_set-to-string-tag":316,"./_to-index":330,"./_to-integer":331,"./_to-length":333,"./_typed":338}],338:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var uid = require('./_uid');
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

},{"./_global":256,"./_hide":258,"./_uid":339}],339:[function(require,module,exports){
arguments[4][189][0].apply(exports,arguments)
},{"dup":189}],340:[function(require,module,exports){
arguments[4][190][0].apply(exports,arguments)
},{"./_global":256,"dup":190}],341:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"./_is-object":267}],342:[function(require,module,exports){
arguments[4][191][0].apply(exports,arguments)
},{"./_core":238,"./_global":256,"./_library":275,"./_object-dp":287,"./_wks-ext":343,"dup":191}],343:[function(require,module,exports){
arguments[4][192][0].apply(exports,arguments)
},{"./_wks":344,"dup":192}],344:[function(require,module,exports){
arguments[4][193][0].apply(exports,arguments)
},{"./_global":256,"./_shared":318,"./_uid":339,"dup":193}],345:[function(require,module,exports){
arguments[4][194][0].apply(exports,arguments)
},{"./_classof":232,"./_core":238,"./_iterators":274,"./_wks":344,"dup":194}],346:[function(require,module,exports){
// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export');
var $re = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });

},{"./_export":248,"./_replacer":310}],347:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { copyWithin: require('./_array-copy-within') });

require('./_add-to-unscopables')('copyWithin');

},{"./_add-to-unscopables":219,"./_array-copy-within":223,"./_export":248}],348:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $every = require('./_array-methods')(4);

$export($export.P + $export.F * !require('./_strict-method')([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":227,"./_export":248,"./_strict-method":320}],349:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { fill: require('./_array-fill') });

require('./_add-to-unscopables')('fill');

},{"./_add-to-unscopables":219,"./_array-fill":224,"./_export":248}],350:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $filter = require('./_array-methods')(2);

$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":227,"./_export":248,"./_strict-method":320}],351:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":219,"./_array-methods":227,"./_export":248}],352:[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":219,"./_array-methods":227,"./_export":248}],353:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $forEach = require('./_array-methods')(0);
var STRICT = require('./_strict-method')([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":227,"./_export":248,"./_strict-method":320}],354:[function(require,module,exports){
arguments[4][197][0].apply(exports,arguments)
},{"./_create-property":239,"./_ctx":240,"./_export":248,"./_is-array-iter":264,"./_iter-call":269,"./_iter-detect":272,"./_to-length":333,"./_to-object":334,"./core.get-iterator-method":345,"dup":197}],355:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $indexOf = require('./_array-includes')(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

},{"./_array-includes":226,"./_export":248,"./_strict-method":320}],356:[function(require,module,exports){
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });

},{"./_export":248,"./_is-array":265}],357:[function(require,module,exports){
arguments[4][198][0].apply(exports,arguments)
},{"./_add-to-unscopables":219,"./_iter-define":271,"./_iter-step":273,"./_iterators":274,"./_to-iobject":332,"dup":198}],358:[function(require,module,exports){
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (require('./_iobject') != Object || !require('./_strict-method')(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

},{"./_export":248,"./_iobject":263,"./_strict-method":320,"./_to-iobject":332}],359:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

},{"./_export":248,"./_strict-method":320,"./_to-integer":331,"./_to-iobject":332,"./_to-length":333}],360:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $map = require('./_array-methods')(1);

$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":227,"./_export":248,"./_strict-method":320}],361:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var createProperty = require('./_create-property');

// WebKit Array.of isn't generic
$export($export.S + $export.F * require('./_fails')(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

},{"./_create-property":239,"./_export":248,"./_fails":250}],362:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

},{"./_array-reduce":228,"./_export":248,"./_strict-method":320}],363:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

},{"./_array-reduce":228,"./_export":248,"./_strict-method":320}],364:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var html = require('./_html');
var cof = require('./_cof');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * require('./_fails')(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

},{"./_cof":233,"./_export":248,"./_fails":250,"./_html":259,"./_to-absolute-index":329,"./_to-length":333}],365:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $some = require('./_array-methods')(3);

$export($export.P + $export.F * !require('./_strict-method')([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":227,"./_export":248,"./_strict-method":320}],366:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var fails = require('./_fails');
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !require('./_strict-method')($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

},{"./_a-function":217,"./_export":248,"./_fails":250,"./_strict-method":320,"./_to-object":334}],367:[function(require,module,exports){
require('./_set-species')('Array');

},{"./_set-species":315}],368:[function(require,module,exports){
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require('./_export');

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });

},{"./_export":248}],369:[function(require,module,exports){
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = require('./_export');
var toISOString = require('./_date-to-iso-string');

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

},{"./_date-to-iso-string":241,"./_export":248}],370:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');

$export($export.P + $export.F * require('./_fails')(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"./_export":248,"./_fails":250,"./_to-object":334,"./_to-primitive":335}],371:[function(require,module,exports){
var TO_PRIMITIVE = require('./_wks')('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) require('./_hide')(proto, TO_PRIMITIVE, require('./_date-to-primitive'));

},{"./_date-to-primitive":242,"./_hide":258,"./_wks":344}],372:[function(require,module,exports){
var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  require('./_redefine')(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

},{"./_redefine":307}],373:[function(require,module,exports){
// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = require('./_export');

$export($export.P, 'Function', { bind: require('./_bind') });

},{"./_bind":231,"./_export":248}],374:[function(require,module,exports){
'use strict';
var isObject = require('./_is-object');
var getPrototypeOf = require('./_object-gpo');
var HAS_INSTANCE = require('./_wks')('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) require('./_object-dp').f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });

},{"./_is-object":267,"./_object-dp":287,"./_object-gpo":294,"./_wks":344}],375:[function(require,module,exports){
var dP = require('./_object-dp').f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || require('./_descriptors') && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

},{"./_descriptors":244,"./_object-dp":287}],376:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var MAP = 'Map';

// 23.1 Map Objects
module.exports = require('./_collection')(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"./_collection":237,"./_collection-strong":234,"./_validate-collection":341}],377:[function(require,module,exports){
// 20.2.2.3 Math.acosh(x)
var $export = require('./_export');
var log1p = require('./_math-log1p');
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

},{"./_export":248,"./_math-log1p":278}],378:[function(require,module,exports){
// 20.2.2.5 Math.asinh(x)
var $export = require('./_export');
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

},{"./_export":248}],379:[function(require,module,exports){
// 20.2.2.7 Math.atanh(x)
var $export = require('./_export');
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

},{"./_export":248}],380:[function(require,module,exports){
// 20.2.2.9 Math.cbrt(x)
var $export = require('./_export');
var sign = require('./_math-sign');

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

},{"./_export":248,"./_math-sign":280}],381:[function(require,module,exports){
// 20.2.2.11 Math.clz32(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

},{"./_export":248}],382:[function(require,module,exports){
// 20.2.2.12 Math.cosh(x)
var $export = require('./_export');
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

},{"./_export":248}],383:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $export = require('./_export');
var $expm1 = require('./_math-expm1');

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

},{"./_export":248,"./_math-expm1":276}],384:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', { fround: require('./_math-fround') });

},{"./_export":248,"./_math-fround":277}],385:[function(require,module,exports){
// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = require('./_export');
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

},{"./_export":248}],386:[function(require,module,exports){
// 20.2.2.18 Math.imul(x, y)
var $export = require('./_export');
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * require('./_fails')(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"./_export":248,"./_fails":250}],387:[function(require,module,exports){
// 20.2.2.21 Math.log10(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

},{"./_export":248}],388:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', { log1p: require('./_math-log1p') });

},{"./_export":248,"./_math-log1p":278}],389:[function(require,module,exports){
// 20.2.2.22 Math.log2(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

},{"./_export":248}],390:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });

},{"./_export":248,"./_math-sign":280}],391:[function(require,module,exports){
// 20.2.2.30 Math.sinh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * require('./_fails')(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

},{"./_export":248,"./_fails":250,"./_math-expm1":276}],392:[function(require,module,exports){
// 20.2.2.33 Math.tanh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

},{"./_export":248,"./_math-expm1":276}],393:[function(require,module,exports){
arguments[4][199][0].apply(exports,arguments)
},{"./_export":248,"dup":199}],394:[function(require,module,exports){
'use strict';
var global = require('./_global');
var has = require('./_has');
var cof = require('./_cof');
var inheritIfRequired = require('./_inherit-if-required');
var toPrimitive = require('./_to-primitive');
var fails = require('./_fails');
var gOPN = require('./_object-gopn').f;
var gOPD = require('./_object-gopd').f;
var dP = require('./_object-dp').f;
var $trim = require('./_string-trim').trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(require('./_object-create')(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = require('./_descriptors') ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  require('./_redefine')(global, NUMBER, $Number);
}

},{"./_cof":233,"./_descriptors":244,"./_fails":250,"./_global":256,"./_has":257,"./_inherit-if-required":261,"./_object-create":286,"./_object-dp":287,"./_object-gopd":290,"./_object-gopn":292,"./_redefine":307,"./_string-trim":326,"./_to-primitive":335}],395:[function(require,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

},{"./_export":248}],396:[function(require,module,exports){
// 20.1.2.2 Number.isFinite(number)
var $export = require('./_export');
var _isFinite = require('./_global').isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

},{"./_export":248,"./_global":256}],397:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });

},{"./_export":248,"./_is-integer":266}],398:[function(require,module,exports){
// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

},{"./_export":248}],399:[function(require,module,exports){
// 20.1.2.5 Number.isSafeInteger(number)
var $export = require('./_export');
var isInteger = require('./_is-integer');
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

},{"./_export":248,"./_is-integer":266}],400:[function(require,module,exports){
// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

},{"./_export":248}],401:[function(require,module,exports){
// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

},{"./_export":248}],402:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

},{"./_export":248,"./_parse-float":301}],403:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

},{"./_export":248,"./_parse-int":302}],404:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toInteger = require('./_to-integer');
var aNumberValue = require('./_a-number-value');
var repeat = require('./_string-repeat');
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !require('./_fails')(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

},{"./_a-number-value":218,"./_export":248,"./_fails":250,"./_string-repeat":325,"./_to-integer":331}],405:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $fails = require('./_fails');
var aNumberValue = require('./_a-number-value');
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

},{"./_a-number-value":218,"./_export":248,"./_fails":250}],406:[function(require,module,exports){
arguments[4][200][0].apply(exports,arguments)
},{"./_export":248,"./_object-assign":285,"dup":200}],407:[function(require,module,exports){
arguments[4][201][0].apply(exports,arguments)
},{"./_export":248,"./_object-create":286,"dup":201}],408:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperties: require('./_object-dps') });

},{"./_descriptors":244,"./_export":248,"./_object-dps":288}],409:[function(require,module,exports){
arguments[4][202][0].apply(exports,arguments)
},{"./_descriptors":244,"./_export":248,"./_object-dp":287,"dup":202}],410:[function(require,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

},{"./_is-object":267,"./_meta":281,"./_object-sap":298}],411:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":290,"./_object-sap":298,"./_to-iobject":332}],412:[function(require,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});

},{"./_object-gopn-ext":291,"./_object-sap":298}],413:[function(require,module,exports){
arguments[4][203][0].apply(exports,arguments)
},{"./_object-gpo":294,"./_object-sap":298,"./_to-object":334,"dup":203}],414:[function(require,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

},{"./_is-object":267,"./_object-sap":298}],415:[function(require,module,exports){
// 19.1.2.12 Object.isFrozen(O)
var isObject = require('./_is-object');

require('./_object-sap')('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

},{"./_is-object":267,"./_object-sap":298}],416:[function(require,module,exports){
// 19.1.2.13 Object.isSealed(O)
var isObject = require('./_is-object');

require('./_object-sap')('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

},{"./_is-object":267,"./_object-sap":298}],417:[function(require,module,exports){
// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', { is: require('./_same-value') });

},{"./_export":248,"./_same-value":311}],418:[function(require,module,exports){
arguments[4][204][0].apply(exports,arguments)
},{"./_object-keys":296,"./_object-sap":298,"./_to-object":334,"dup":204}],419:[function(require,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

},{"./_is-object":267,"./_meta":281,"./_object-sap":298}],420:[function(require,module,exports){
// 19.1.2.17 Object.seal(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

},{"./_is-object":267,"./_meta":281,"./_object-sap":298}],421:[function(require,module,exports){
arguments[4][205][0].apply(exports,arguments)
},{"./_export":248,"./_set-proto":314,"dup":205}],422:[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof');
var test = {};
test[require('./_wks')('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  require('./_redefine')(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

},{"./_classof":232,"./_redefine":307,"./_wks":344}],423:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

},{"./_export":248,"./_parse-float":301}],424:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

},{"./_export":248,"./_parse-int":302}],425:[function(require,module,exports){
arguments[4][207][0].apply(exports,arguments)
},{"./_a-function":217,"./_an-instance":221,"./_classof":232,"./_core":238,"./_ctx":240,"./_export":248,"./_for-of":254,"./_global":256,"./_is-object":267,"./_iter-detect":272,"./_library":275,"./_microtask":283,"./_new-promise-capability":284,"./_perform":303,"./_promise-resolve":304,"./_redefine-all":306,"./_set-species":315,"./_set-to-string-tag":316,"./_species-constructor":319,"./_task":328,"./_user-agent":340,"./_wks":344,"dup":207}],426:[function(require,module,exports){
// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = require('./_export');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var rApply = (require('./_global').Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !require('./_fails')(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

},{"./_a-function":217,"./_an-object":222,"./_export":248,"./_fails":250,"./_global":256}],427:[function(require,module,exports){
// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = require('./_export');
var create = require('./_object-create');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var fails = require('./_fails');
var bind = require('./_bind');
var rConstruct = (require('./_global').Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"./_a-function":217,"./_an-object":222,"./_bind":231,"./_export":248,"./_fails":250,"./_global":256,"./_is-object":267,"./_object-create":286}],428:[function(require,module,exports){
// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = require('./_object-dp');
var $export = require('./_export');
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * require('./_fails')(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":222,"./_export":248,"./_fails":250,"./_object-dp":287,"./_to-primitive":335}],429:[function(require,module,exports){
// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = require('./_export');
var gOPD = require('./_object-gopd').f;
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

},{"./_an-object":222,"./_export":248,"./_object-gopd":290}],430:[function(require,module,exports){
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
require('./_iter-create')(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

},{"./_an-object":222,"./_export":248,"./_iter-create":270}],431:[function(require,module,exports){
// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = require('./_object-gopd');
var $export = require('./_export');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

},{"./_an-object":222,"./_export":248,"./_object-gopd":290}],432:[function(require,module,exports){
// 26.1.8 Reflect.getPrototypeOf(target)
var $export = require('./_export');
var getProto = require('./_object-gpo');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

},{"./_an-object":222,"./_export":248,"./_object-gpo":294}],433:[function(require,module,exports){
// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var isObject = require('./_is-object');
var anObject = require('./_an-object');

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

},{"./_an-object":222,"./_export":248,"./_has":257,"./_is-object":267,"./_object-gopd":290,"./_object-gpo":294}],434:[function(require,module,exports){
// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

},{"./_export":248}],435:[function(require,module,exports){
// 26.1.10 Reflect.isExtensible(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

},{"./_an-object":222,"./_export":248}],436:[function(require,module,exports){
// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });

},{"./_export":248,"./_own-keys":300}],437:[function(require,module,exports){
// 26.1.12 Reflect.preventExtensions(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":222,"./_export":248}],438:[function(require,module,exports){
// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = require('./_export');
var setProto = require('./_set-proto');

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_export":248,"./_set-proto":314}],439:[function(require,module,exports){
// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = require('./_object-dp');
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var createDesc = require('./_property-desc');
var anObject = require('./_an-object');
var isObject = require('./_is-object');

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

},{"./_an-object":222,"./_export":248,"./_has":257,"./_is-object":267,"./_object-dp":287,"./_object-gopd":290,"./_object-gpo":294,"./_property-desc":305}],440:[function(require,module,exports){
var global = require('./_global');
var inheritIfRequired = require('./_inherit-if-required');
var dP = require('./_object-dp').f;
var gOPN = require('./_object-gopn').f;
var isRegExp = require('./_is-regexp');
var $flags = require('./_flags');
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (require('./_descriptors') && (!CORRECT_NEW || require('./_fails')(function () {
  re2[require('./_wks')('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  require('./_redefine')(global, 'RegExp', $RegExp);
}

require('./_set-species')('RegExp');

},{"./_descriptors":244,"./_fails":250,"./_flags":252,"./_global":256,"./_inherit-if-required":261,"./_is-regexp":268,"./_object-dp":287,"./_object-gopn":292,"./_redefine":307,"./_set-species":315,"./_wks":344}],441:[function(require,module,exports){
'use strict';
var regexpExec = require('./_regexp-exec');
require('./_export')({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});

},{"./_export":248,"./_regexp-exec":309}],442:[function(require,module,exports){
// 21.2.5.3 get RegExp.prototype.flags()
if (require('./_descriptors') && /./g.flags != 'g') require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});

},{"./_descriptors":244,"./_flags":252,"./_object-dp":287}],443:[function(require,module,exports){
'use strict';

var anObject = require('./_an-object');
var toLength = require('./_to-length');
var advanceStringIndex = require('./_advance-string-index');
var regExpExec = require('./_regexp-exec-abstract');

// @@match logic
require('./_fix-re-wks')('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

},{"./_advance-string-index":220,"./_an-object":222,"./_fix-re-wks":251,"./_regexp-exec-abstract":308,"./_to-length":333}],444:[function(require,module,exports){
'use strict';

var anObject = require('./_an-object');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var advanceStringIndex = require('./_advance-string-index');
var regExpExec = require('./_regexp-exec-abstract');
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
require('./_fix-re-wks')('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

},{"./_advance-string-index":220,"./_an-object":222,"./_fix-re-wks":251,"./_regexp-exec-abstract":308,"./_to-integer":331,"./_to-length":333,"./_to-object":334}],445:[function(require,module,exports){
'use strict';

var anObject = require('./_an-object');
var sameValue = require('./_same-value');
var regExpExec = require('./_regexp-exec-abstract');

// @@search logic
require('./_fix-re-wks')('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

},{"./_an-object":222,"./_fix-re-wks":251,"./_regexp-exec-abstract":308,"./_same-value":311}],446:[function(require,module,exports){
'use strict';

var isRegExp = require('./_is-regexp');
var anObject = require('./_an-object');
var speciesConstructor = require('./_species-constructor');
var advanceStringIndex = require('./_advance-string-index');
var toLength = require('./_to-length');
var callRegExpExec = require('./_regexp-exec-abstract');
var regexpExec = require('./_regexp-exec');
var fails = require('./_fails');
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
require('./_fix-re-wks')('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});

},{"./_advance-string-index":220,"./_an-object":222,"./_fails":250,"./_fix-re-wks":251,"./_is-regexp":268,"./_regexp-exec":309,"./_regexp-exec-abstract":308,"./_species-constructor":319,"./_to-length":333}],447:[function(require,module,exports){
'use strict';
require('./es6.regexp.flags');
var anObject = require('./_an-object');
var $flags = require('./_flags');
var DESCRIPTORS = require('./_descriptors');
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  require('./_redefine')(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (require('./_fails')(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

},{"./_an-object":222,"./_descriptors":244,"./_fails":250,"./_flags":252,"./_redefine":307,"./es6.regexp.flags":442}],448:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var SET = 'Set';

// 23.2 Set Objects
module.exports = require('./_collection')(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

},{"./_collection":237,"./_collection-strong":234,"./_validate-collection":341}],449:[function(require,module,exports){
'use strict';
// B.2.3.2 String.prototype.anchor(name)
require('./_string-html')('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

},{"./_string-html":323}],450:[function(require,module,exports){
'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

},{"./_string-html":323}],451:[function(require,module,exports){
'use strict';
// B.2.3.4 String.prototype.blink()
require('./_string-html')('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

},{"./_string-html":323}],452:[function(require,module,exports){
'use strict';
// B.2.3.5 String.prototype.bold()
require('./_string-html')('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

},{"./_string-html":323}],453:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $at = require('./_string-at')(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

},{"./_export":248,"./_string-at":321}],454:[function(require,module,exports){
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

},{"./_export":248,"./_fails-is-regexp":249,"./_string-context":322,"./_to-length":333}],455:[function(require,module,exports){
'use strict';
// B.2.3.6 String.prototype.fixed()
require('./_string-html')('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

},{"./_string-html":323}],456:[function(require,module,exports){
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
require('./_string-html')('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

},{"./_string-html":323}],457:[function(require,module,exports){
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
require('./_string-html')('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

},{"./_string-html":323}],458:[function(require,module,exports){
var $export = require('./_export');
var toAbsoluteIndex = require('./_to-absolute-index');
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

},{"./_export":248,"./_to-absolute-index":329}],459:[function(require,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export = require('./_export');
var context = require('./_string-context');
var INCLUDES = 'includes';

$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"./_export":248,"./_fails-is-regexp":249,"./_string-context":322}],460:[function(require,module,exports){
'use strict';
// B.2.3.9 String.prototype.italics()
require('./_string-html')('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

},{"./_string-html":323}],461:[function(require,module,exports){
arguments[4][208][0].apply(exports,arguments)
},{"./_iter-define":271,"./_string-at":321,"dup":208}],462:[function(require,module,exports){
'use strict';
// B.2.3.10 String.prototype.link(url)
require('./_string-html')('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

},{"./_string-html":323}],463:[function(require,module,exports){
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

},{"./_export":248,"./_to-iobject":332,"./_to-length":333}],464:[function(require,module,exports){
var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});

},{"./_export":248,"./_string-repeat":325}],465:[function(require,module,exports){
'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

},{"./_string-html":323}],466:[function(require,module,exports){
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

},{"./_export":248,"./_fails-is-regexp":249,"./_string-context":322,"./_to-length":333}],467:[function(require,module,exports){
'use strict';
// B.2.3.12 String.prototype.strike()
require('./_string-html')('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

},{"./_string-html":323}],468:[function(require,module,exports){
'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

},{"./_string-html":323}],469:[function(require,module,exports){
'use strict';
// B.2.3.14 String.prototype.sup()
require('./_string-html')('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

},{"./_string-html":323}],470:[function(require,module,exports){
'use strict';
// 21.1.3.25 String.prototype.trim()
require('./_string-trim')('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

},{"./_string-trim":326}],471:[function(require,module,exports){
arguments[4][209][0].apply(exports,arguments)
},{"./_an-object":222,"./_descriptors":244,"./_enum-keys":247,"./_export":248,"./_fails":250,"./_global":256,"./_has":257,"./_hide":258,"./_is-array":265,"./_is-object":267,"./_library":275,"./_meta":281,"./_object-create":286,"./_object-dp":287,"./_object-gopd":290,"./_object-gopn":292,"./_object-gopn-ext":291,"./_object-gops":293,"./_object-keys":296,"./_object-pie":297,"./_property-desc":305,"./_redefine":307,"./_set-to-string-tag":316,"./_shared":318,"./_to-iobject":332,"./_to-object":334,"./_to-primitive":335,"./_uid":339,"./_wks":344,"./_wks-define":342,"./_wks-ext":343,"dup":209}],472:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $typed = require('./_typed');
var buffer = require('./_typed-buffer');
var anObject = require('./_an-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var isObject = require('./_is-object');
var ArrayBuffer = require('./_global').ArrayBuffer;
var speciesConstructor = require('./_species-constructor');
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * require('./_fails')(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

require('./_set-species')(ARRAY_BUFFER);

},{"./_an-object":222,"./_export":248,"./_fails":250,"./_global":256,"./_is-object":267,"./_set-species":315,"./_species-constructor":319,"./_to-absolute-index":329,"./_to-length":333,"./_typed":338,"./_typed-buffer":337}],473:[function(require,module,exports){
var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});

},{"./_export":248,"./_typed":338,"./_typed-buffer":337}],474:[function(require,module,exports){
require('./_typed-array')('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":336}],475:[function(require,module,exports){
require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":336}],476:[function(require,module,exports){
require('./_typed-array')('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":336}],477:[function(require,module,exports){
require('./_typed-array')('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":336}],478:[function(require,module,exports){
require('./_typed-array')('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":336}],479:[function(require,module,exports){
require('./_typed-array')('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":336}],480:[function(require,module,exports){
require('./_typed-array')('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":336}],481:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":336}],482:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

},{"./_typed-array":336}],483:[function(require,module,exports){
'use strict';
var global = require('./_global');
var each = require('./_array-methods')(0);
var redefine = require('./_redefine');
var meta = require('./_meta');
var assign = require('./_object-assign');
var weak = require('./_collection-weak');
var isObject = require('./_is-object');
var validate = require('./_validate-collection');
var NATIVE_WEAK_MAP = require('./_validate-collection');
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = require('./_collection')(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

},{"./_array-methods":227,"./_collection":237,"./_collection-weak":236,"./_global":256,"./_is-object":267,"./_meta":281,"./_object-assign":285,"./_redefine":307,"./_validate-collection":341}],484:[function(require,module,exports){
'use strict';
var weak = require('./_collection-weak');
var validate = require('./_validate-collection');
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
require('./_collection')(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

},{"./_collection":237,"./_collection-weak":236,"./_validate-collection":341}],485:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var aFunction = require('./_a-function');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

require('./_add-to-unscopables')('flatMap');

},{"./_a-function":217,"./_add-to-unscopables":219,"./_array-species-create":230,"./_export":248,"./_flatten-into-array":253,"./_to-length":333,"./_to-object":334}],486:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

require('./_add-to-unscopables')('flatten');

},{"./_add-to-unscopables":219,"./_array-species-create":230,"./_export":248,"./_flatten-into-array":253,"./_to-integer":331,"./_to-length":333,"./_to-object":334}],487:[function(require,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = require('./_export');
var $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');

},{"./_add-to-unscopables":219,"./_array-includes":226,"./_export":248}],488:[function(require,module,exports){
// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = require('./_export');
var microtask = require('./_microtask')();
var process = require('./_global').process;
var isNode = require('./_cof')(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

},{"./_cof":233,"./_export":248,"./_global":256,"./_microtask":283}],489:[function(require,module,exports){
// https://github.com/ljharb/proposal-is-error
var $export = require('./_export');
var cof = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

},{"./_cof":233,"./_export":248}],490:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });

},{"./_export":248,"./_global":256}],491:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

},{"./_set-collection-from":312}],492:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

},{"./_set-collection-of":313}],493:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });

},{"./_collection-to-json":235,"./_export":248}],494:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});

},{"./_export":248}],495:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

},{"./_export":248}],496:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});

},{"./_export":248}],497:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var scale = require('./_math-scale');
var fround = require('./_math-fround');

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});

},{"./_export":248,"./_math-fround":277,"./_math-scale":279}],498:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

},{"./_export":248}],499:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

},{"./_export":248}],500:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

},{"./_export":248}],501:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

},{"./_export":248}],502:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});

},{"./_export":248}],503:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });

},{"./_export":248,"./_math-scale":279}],504:[function(require,module,exports){
// http://jfbastien.github.io/papers/Math.signbit.html
var $export = require('./_export');

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });

},{"./_export":248}],505:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

},{"./_export":248}],506:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":217,"./_descriptors":244,"./_export":248,"./_object-dp":287,"./_object-forced-pam":289,"./_to-object":334}],507:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":217,"./_descriptors":244,"./_export":248,"./_object-dp":287,"./_object-forced-pam":289,"./_to-object":334}],508:[function(require,module,exports){
arguments[4][210][0].apply(exports,arguments)
},{"./_export":248,"./_object-to-array":299,"dup":210}],509:[function(require,module,exports){
// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = require('./_export');
var ownKeys = require('./_own-keys');
var toIObject = require('./_to-iobject');
var gOPD = require('./_object-gopd');
var createProperty = require('./_create-property');

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

},{"./_create-property":239,"./_export":248,"./_object-gopd":290,"./_own-keys":300,"./_to-iobject":332}],510:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":244,"./_export":248,"./_object-forced-pam":289,"./_object-gopd":290,"./_object-gpo":294,"./_to-object":334,"./_to-primitive":335}],511:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":244,"./_export":248,"./_object-forced-pam":289,"./_object-gopd":290,"./_object-gpo":294,"./_to-object":334,"./_to-primitive":335}],512:[function(require,module,exports){
arguments[4][211][0].apply(exports,arguments)
},{"./_export":248,"./_object-to-array":299,"dup":211}],513:[function(require,module,exports){
'use strict';
// https://github.com/zenparsing/es-observable
var $export = require('./_export');
var global = require('./_global');
var core = require('./_core');
var microtask = require('./_microtask')();
var OBSERVABLE = require('./_wks')('observable');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var anInstance = require('./_an-instance');
var redefineAll = require('./_redefine-all');
var hide = require('./_hide');
var forOf = require('./_for-of');
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

require('./_set-species')('Observable');

},{"./_a-function":217,"./_an-instance":221,"./_an-object":222,"./_core":238,"./_export":248,"./_for-of":254,"./_global":256,"./_hide":258,"./_microtask":283,"./_redefine-all":306,"./_set-species":315,"./_wks":344}],514:[function(require,module,exports){
arguments[4][212][0].apply(exports,arguments)
},{"./_core":238,"./_export":248,"./_global":256,"./_promise-resolve":304,"./_species-constructor":319,"dup":212}],515:[function(require,module,exports){
arguments[4][213][0].apply(exports,arguments)
},{"./_export":248,"./_new-promise-capability":284,"./_perform":303,"dup":213}],516:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });

},{"./_an-object":222,"./_metadata":282}],517:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });

},{"./_an-object":222,"./_metadata":282}],518:[function(require,module,exports){
var Set = require('./es6.set');
var from = require('./_array-from-iterable');
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":222,"./_array-from-iterable":225,"./_metadata":282,"./_object-gpo":294,"./es6.set":448}],519:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":222,"./_metadata":282,"./_object-gpo":294}],520:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":222,"./_metadata":282}],521:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":222,"./_metadata":282}],522:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":222,"./_metadata":282,"./_object-gpo":294}],523:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":222,"./_metadata":282}],524:[function(require,module,exports){
var $metadata = require('./_metadata');
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });

},{"./_a-function":217,"./_an-object":222,"./_metadata":282}],525:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');

},{"./_set-collection-from":312}],526:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');

},{"./_set-collection-of":313}],527:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Set', { toJSON: require('./_collection-to-json')('Set') });

},{"./_collection-to-json":235,"./_export":248}],528:[function(require,module,exports){
'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = require('./_export');
var $at = require('./_string-at')(true);
var $fails = require('./_fails');

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

},{"./_export":248,"./_fails":250,"./_string-at":321}],529:[function(require,module,exports){
'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export = require('./_export');
var defined = require('./_defined');
var toLength = require('./_to-length');
var isRegExp = require('./_is-regexp');
var getFlags = require('./_flags');
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

require('./_iter-create')($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

},{"./_defined":243,"./_export":248,"./_flags":252,"./_is-regexp":268,"./_iter-create":270,"./_to-length":333}],530:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

},{"./_export":248,"./_string-pad":324,"./_user-agent":340}],531:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

},{"./_export":248,"./_string-pad":324,"./_user-agent":340}],532:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

},{"./_string-trim":326}],533:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

},{"./_string-trim":326}],534:[function(require,module,exports){
arguments[4][214][0].apply(exports,arguments)
},{"./_wks-define":342,"dup":214}],535:[function(require,module,exports){
arguments[4][215][0].apply(exports,arguments)
},{"./_wks-define":342,"dup":215}],536:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });

},{"./_export":248,"./_global":256}],537:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');

},{"./_set-collection-from":312}],538:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');

},{"./_set-collection-of":313}],539:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');

},{"./_set-collection-from":312}],540:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');

},{"./_set-collection-of":313}],541:[function(require,module,exports){
var $iterators = require('./es6.array.iterator');
var getKeys = require('./_object-keys');
var redefine = require('./_redefine');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var wks = require('./_wks');
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}

},{"./_global":256,"./_hide":258,"./_iterators":274,"./_object-keys":296,"./_redefine":307,"./_wks":344,"./es6.array.iterator":357}],542:[function(require,module,exports){
var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

},{"./_export":248,"./_task":328}],543:[function(require,module,exports){
// ie9- setTimeout & setInterval additional parameters fix
var global = require('./_global');
var $export = require('./_export');
var userAgent = require('./_user-agent');
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

},{"./_export":248,"./_global":256,"./_user-agent":340}],544:[function(require,module,exports){
require('./modules/es6.symbol');
require('./modules/es6.object.create');
require('./modules/es6.object.define-property');
require('./modules/es6.object.define-properties');
require('./modules/es6.object.get-own-property-descriptor');
require('./modules/es6.object.get-prototype-of');
require('./modules/es6.object.keys');
require('./modules/es6.object.get-own-property-names');
require('./modules/es6.object.freeze');
require('./modules/es6.object.seal');
require('./modules/es6.object.prevent-extensions');
require('./modules/es6.object.is-frozen');
require('./modules/es6.object.is-sealed');
require('./modules/es6.object.is-extensible');
require('./modules/es6.object.assign');
require('./modules/es6.object.is');
require('./modules/es6.object.set-prototype-of');
require('./modules/es6.object.to-string');
require('./modules/es6.function.bind');
require('./modules/es6.function.name');
require('./modules/es6.function.has-instance');
require('./modules/es6.parse-int');
require('./modules/es6.parse-float');
require('./modules/es6.number.constructor');
require('./modules/es6.number.to-fixed');
require('./modules/es6.number.to-precision');
require('./modules/es6.number.epsilon');
require('./modules/es6.number.is-finite');
require('./modules/es6.number.is-integer');
require('./modules/es6.number.is-nan');
require('./modules/es6.number.is-safe-integer');
require('./modules/es6.number.max-safe-integer');
require('./modules/es6.number.min-safe-integer');
require('./modules/es6.number.parse-float');
require('./modules/es6.number.parse-int');
require('./modules/es6.math.acosh');
require('./modules/es6.math.asinh');
require('./modules/es6.math.atanh');
require('./modules/es6.math.cbrt');
require('./modules/es6.math.clz32');
require('./modules/es6.math.cosh');
require('./modules/es6.math.expm1');
require('./modules/es6.math.fround');
require('./modules/es6.math.hypot');
require('./modules/es6.math.imul');
require('./modules/es6.math.log10');
require('./modules/es6.math.log1p');
require('./modules/es6.math.log2');
require('./modules/es6.math.sign');
require('./modules/es6.math.sinh');
require('./modules/es6.math.tanh');
require('./modules/es6.math.trunc');
require('./modules/es6.string.from-code-point');
require('./modules/es6.string.raw');
require('./modules/es6.string.trim');
require('./modules/es6.string.iterator');
require('./modules/es6.string.code-point-at');
require('./modules/es6.string.ends-with');
require('./modules/es6.string.includes');
require('./modules/es6.string.repeat');
require('./modules/es6.string.starts-with');
require('./modules/es6.string.anchor');
require('./modules/es6.string.big');
require('./modules/es6.string.blink');
require('./modules/es6.string.bold');
require('./modules/es6.string.fixed');
require('./modules/es6.string.fontcolor');
require('./modules/es6.string.fontsize');
require('./modules/es6.string.italics');
require('./modules/es6.string.link');
require('./modules/es6.string.small');
require('./modules/es6.string.strike');
require('./modules/es6.string.sub');
require('./modules/es6.string.sup');
require('./modules/es6.date.now');
require('./modules/es6.date.to-json');
require('./modules/es6.date.to-iso-string');
require('./modules/es6.date.to-string');
require('./modules/es6.date.to-primitive');
require('./modules/es6.array.is-array');
require('./modules/es6.array.from');
require('./modules/es6.array.of');
require('./modules/es6.array.join');
require('./modules/es6.array.slice');
require('./modules/es6.array.sort');
require('./modules/es6.array.for-each');
require('./modules/es6.array.map');
require('./modules/es6.array.filter');
require('./modules/es6.array.some');
require('./modules/es6.array.every');
require('./modules/es6.array.reduce');
require('./modules/es6.array.reduce-right');
require('./modules/es6.array.index-of');
require('./modules/es6.array.last-index-of');
require('./modules/es6.array.copy-within');
require('./modules/es6.array.fill');
require('./modules/es6.array.find');
require('./modules/es6.array.find-index');
require('./modules/es6.array.species');
require('./modules/es6.array.iterator');
require('./modules/es6.regexp.constructor');
require('./modules/es6.regexp.exec');
require('./modules/es6.regexp.to-string');
require('./modules/es6.regexp.flags');
require('./modules/es6.regexp.match');
require('./modules/es6.regexp.replace');
require('./modules/es6.regexp.search');
require('./modules/es6.regexp.split');
require('./modules/es6.promise');
require('./modules/es6.map');
require('./modules/es6.set');
require('./modules/es6.weak-map');
require('./modules/es6.weak-set');
require('./modules/es6.typed.array-buffer');
require('./modules/es6.typed.data-view');
require('./modules/es6.typed.int8-array');
require('./modules/es6.typed.uint8-array');
require('./modules/es6.typed.uint8-clamped-array');
require('./modules/es6.typed.int16-array');
require('./modules/es6.typed.uint16-array');
require('./modules/es6.typed.int32-array');
require('./modules/es6.typed.uint32-array');
require('./modules/es6.typed.float32-array');
require('./modules/es6.typed.float64-array');
require('./modules/es6.reflect.apply');
require('./modules/es6.reflect.construct');
require('./modules/es6.reflect.define-property');
require('./modules/es6.reflect.delete-property');
require('./modules/es6.reflect.enumerate');
require('./modules/es6.reflect.get');
require('./modules/es6.reflect.get-own-property-descriptor');
require('./modules/es6.reflect.get-prototype-of');
require('./modules/es6.reflect.has');
require('./modules/es6.reflect.is-extensible');
require('./modules/es6.reflect.own-keys');
require('./modules/es6.reflect.prevent-extensions');
require('./modules/es6.reflect.set');
require('./modules/es6.reflect.set-prototype-of');
require('./modules/es7.array.includes');
require('./modules/es7.array.flat-map');
require('./modules/es7.array.flatten');
require('./modules/es7.string.at');
require('./modules/es7.string.pad-start');
require('./modules/es7.string.pad-end');
require('./modules/es7.string.trim-left');
require('./modules/es7.string.trim-right');
require('./modules/es7.string.match-all');
require('./modules/es7.symbol.async-iterator');
require('./modules/es7.symbol.observable');
require('./modules/es7.object.get-own-property-descriptors');
require('./modules/es7.object.values');
require('./modules/es7.object.entries');
require('./modules/es7.object.define-getter');
require('./modules/es7.object.define-setter');
require('./modules/es7.object.lookup-getter');
require('./modules/es7.object.lookup-setter');
require('./modules/es7.map.to-json');
require('./modules/es7.set.to-json');
require('./modules/es7.map.of');
require('./modules/es7.set.of');
require('./modules/es7.weak-map.of');
require('./modules/es7.weak-set.of');
require('./modules/es7.map.from');
require('./modules/es7.set.from');
require('./modules/es7.weak-map.from');
require('./modules/es7.weak-set.from');
require('./modules/es7.global');
require('./modules/es7.system.global');
require('./modules/es7.error.is-error');
require('./modules/es7.math.clamp');
require('./modules/es7.math.deg-per-rad');
require('./modules/es7.math.degrees');
require('./modules/es7.math.fscale');
require('./modules/es7.math.iaddh');
require('./modules/es7.math.isubh');
require('./modules/es7.math.imulh');
require('./modules/es7.math.rad-per-deg');
require('./modules/es7.math.radians');
require('./modules/es7.math.scale');
require('./modules/es7.math.umulh');
require('./modules/es7.math.signbit');
require('./modules/es7.promise.finally');
require('./modules/es7.promise.try');
require('./modules/es7.reflect.define-metadata');
require('./modules/es7.reflect.delete-metadata');
require('./modules/es7.reflect.get-metadata');
require('./modules/es7.reflect.get-metadata-keys');
require('./modules/es7.reflect.get-own-metadata');
require('./modules/es7.reflect.get-own-metadata-keys');
require('./modules/es7.reflect.has-metadata');
require('./modules/es7.reflect.has-own-metadata');
require('./modules/es7.reflect.metadata');
require('./modules/es7.asap');
require('./modules/es7.observable');
require('./modules/web.timers');
require('./modules/web.immediate');
require('./modules/web.dom.iterable');
module.exports = require('./modules/_core');

},{"./modules/_core":238,"./modules/es6.array.copy-within":347,"./modules/es6.array.every":348,"./modules/es6.array.fill":349,"./modules/es6.array.filter":350,"./modules/es6.array.find":352,"./modules/es6.array.find-index":351,"./modules/es6.array.for-each":353,"./modules/es6.array.from":354,"./modules/es6.array.index-of":355,"./modules/es6.array.is-array":356,"./modules/es6.array.iterator":357,"./modules/es6.array.join":358,"./modules/es6.array.last-index-of":359,"./modules/es6.array.map":360,"./modules/es6.array.of":361,"./modules/es6.array.reduce":363,"./modules/es6.array.reduce-right":362,"./modules/es6.array.slice":364,"./modules/es6.array.some":365,"./modules/es6.array.sort":366,"./modules/es6.array.species":367,"./modules/es6.date.now":368,"./modules/es6.date.to-iso-string":369,"./modules/es6.date.to-json":370,"./modules/es6.date.to-primitive":371,"./modules/es6.date.to-string":372,"./modules/es6.function.bind":373,"./modules/es6.function.has-instance":374,"./modules/es6.function.name":375,"./modules/es6.map":376,"./modules/es6.math.acosh":377,"./modules/es6.math.asinh":378,"./modules/es6.math.atanh":379,"./modules/es6.math.cbrt":380,"./modules/es6.math.clz32":381,"./modules/es6.math.cosh":382,"./modules/es6.math.expm1":383,"./modules/es6.math.fround":384,"./modules/es6.math.hypot":385,"./modules/es6.math.imul":386,"./modules/es6.math.log10":387,"./modules/es6.math.log1p":388,"./modules/es6.math.log2":389,"./modules/es6.math.sign":390,"./modules/es6.math.sinh":391,"./modules/es6.math.tanh":392,"./modules/es6.math.trunc":393,"./modules/es6.number.constructor":394,"./modules/es6.number.epsilon":395,"./modules/es6.number.is-finite":396,"./modules/es6.number.is-integer":397,"./modules/es6.number.is-nan":398,"./modules/es6.number.is-safe-integer":399,"./modules/es6.number.max-safe-integer":400,"./modules/es6.number.min-safe-integer":401,"./modules/es6.number.parse-float":402,"./modules/es6.number.parse-int":403,"./modules/es6.number.to-fixed":404,"./modules/es6.number.to-precision":405,"./modules/es6.object.assign":406,"./modules/es6.object.create":407,"./modules/es6.object.define-properties":408,"./modules/es6.object.define-property":409,"./modules/es6.object.freeze":410,"./modules/es6.object.get-own-property-descriptor":411,"./modules/es6.object.get-own-property-names":412,"./modules/es6.object.get-prototype-of":413,"./modules/es6.object.is":417,"./modules/es6.object.is-extensible":414,"./modules/es6.object.is-frozen":415,"./modules/es6.object.is-sealed":416,"./modules/es6.object.keys":418,"./modules/es6.object.prevent-extensions":419,"./modules/es6.object.seal":420,"./modules/es6.object.set-prototype-of":421,"./modules/es6.object.to-string":422,"./modules/es6.parse-float":423,"./modules/es6.parse-int":424,"./modules/es6.promise":425,"./modules/es6.reflect.apply":426,"./modules/es6.reflect.construct":427,"./modules/es6.reflect.define-property":428,"./modules/es6.reflect.delete-property":429,"./modules/es6.reflect.enumerate":430,"./modules/es6.reflect.get":433,"./modules/es6.reflect.get-own-property-descriptor":431,"./modules/es6.reflect.get-prototype-of":432,"./modules/es6.reflect.has":434,"./modules/es6.reflect.is-extensible":435,"./modules/es6.reflect.own-keys":436,"./modules/es6.reflect.prevent-extensions":437,"./modules/es6.reflect.set":439,"./modules/es6.reflect.set-prototype-of":438,"./modules/es6.regexp.constructor":440,"./modules/es6.regexp.exec":441,"./modules/es6.regexp.flags":442,"./modules/es6.regexp.match":443,"./modules/es6.regexp.replace":444,"./modules/es6.regexp.search":445,"./modules/es6.regexp.split":446,"./modules/es6.regexp.to-string":447,"./modules/es6.set":448,"./modules/es6.string.anchor":449,"./modules/es6.string.big":450,"./modules/es6.string.blink":451,"./modules/es6.string.bold":452,"./modules/es6.string.code-point-at":453,"./modules/es6.string.ends-with":454,"./modules/es6.string.fixed":455,"./modules/es6.string.fontcolor":456,"./modules/es6.string.fontsize":457,"./modules/es6.string.from-code-point":458,"./modules/es6.string.includes":459,"./modules/es6.string.italics":460,"./modules/es6.string.iterator":461,"./modules/es6.string.link":462,"./modules/es6.string.raw":463,"./modules/es6.string.repeat":464,"./modules/es6.string.small":465,"./modules/es6.string.starts-with":466,"./modules/es6.string.strike":467,"./modules/es6.string.sub":468,"./modules/es6.string.sup":469,"./modules/es6.string.trim":470,"./modules/es6.symbol":471,"./modules/es6.typed.array-buffer":472,"./modules/es6.typed.data-view":473,"./modules/es6.typed.float32-array":474,"./modules/es6.typed.float64-array":475,"./modules/es6.typed.int16-array":476,"./modules/es6.typed.int32-array":477,"./modules/es6.typed.int8-array":478,"./modules/es6.typed.uint16-array":479,"./modules/es6.typed.uint32-array":480,"./modules/es6.typed.uint8-array":481,"./modules/es6.typed.uint8-clamped-array":482,"./modules/es6.weak-map":483,"./modules/es6.weak-set":484,"./modules/es7.array.flat-map":485,"./modules/es7.array.flatten":486,"./modules/es7.array.includes":487,"./modules/es7.asap":488,"./modules/es7.error.is-error":489,"./modules/es7.global":490,"./modules/es7.map.from":491,"./modules/es7.map.of":492,"./modules/es7.map.to-json":493,"./modules/es7.math.clamp":494,"./modules/es7.math.deg-per-rad":495,"./modules/es7.math.degrees":496,"./modules/es7.math.fscale":497,"./modules/es7.math.iaddh":498,"./modules/es7.math.imulh":499,"./modules/es7.math.isubh":500,"./modules/es7.math.rad-per-deg":501,"./modules/es7.math.radians":502,"./modules/es7.math.scale":503,"./modules/es7.math.signbit":504,"./modules/es7.math.umulh":505,"./modules/es7.object.define-getter":506,"./modules/es7.object.define-setter":507,"./modules/es7.object.entries":508,"./modules/es7.object.get-own-property-descriptors":509,"./modules/es7.object.lookup-getter":510,"./modules/es7.object.lookup-setter":511,"./modules/es7.object.values":512,"./modules/es7.observable":513,"./modules/es7.promise.finally":514,"./modules/es7.promise.try":515,"./modules/es7.reflect.define-metadata":516,"./modules/es7.reflect.delete-metadata":517,"./modules/es7.reflect.get-metadata":519,"./modules/es7.reflect.get-metadata-keys":518,"./modules/es7.reflect.get-own-metadata":521,"./modules/es7.reflect.get-own-metadata-keys":520,"./modules/es7.reflect.has-metadata":522,"./modules/es7.reflect.has-own-metadata":523,"./modules/es7.reflect.metadata":524,"./modules/es7.set.from":525,"./modules/es7.set.of":526,"./modules/es7.set.to-json":527,"./modules/es7.string.at":528,"./modules/es7.string.match-all":529,"./modules/es7.string.pad-end":530,"./modules/es7.string.pad-start":531,"./modules/es7.string.trim-left":532,"./modules/es7.string.trim-right":533,"./modules/es7.symbol.async-iterator":534,"./modules/es7.symbol.observable":535,"./modules/es7.system.global":536,"./modules/es7.weak-map.from":537,"./modules/es7.weak-map.of":538,"./modules/es7.weak-set.from":539,"./modules/es7.weak-set.of":540,"./modules/web.dom.iterable":541,"./modules/web.immediate":542,"./modules/web.timers":543}],545:[function(require,module,exports){
(function (Buffer){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

}).call(this,{"isBuffer":require("../../insert-module-globals/node_modules/is-buffer/index.js")})
},{"../../insert-module-globals/node_modules/is-buffer/index.js":623}],546:[function(require,module,exports){
(function (Buffer){
var elliptic = require('elliptic')
var BN = require('bn.js')

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

}).call(this,require("buffer").Buffer)
},{"bn.js":547,"buffer":96,"elliptic":566}],547:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"buffer":49,"dup":15}],548:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var MD5 = require('md5.js')
var RIPEMD160 = require('ripemd160')
var sha = require('sha.js')
var Base = require('cipher-base')

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}

},{"cipher-base":98,"inherits":622,"md5.js":629,"ripemd160":675,"sha.js":681}],549:[function(require,module,exports){
var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}

},{"md5.js":629}],550:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Legacy = require('./legacy')
var Base = require('cipher-base')
var Buffer = require('safe-buffer').Buffer
var md5 = require('create-hash/md5')
var RIPEMD160 = require('ripemd160')

var sha = require('sha.js')

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}

},{"./legacy":551,"cipher-base":98,"create-hash/md5":549,"inherits":622,"ripemd160":675,"safe-buffer":676,"sha.js":681}],551:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var Base = require('cipher-base')

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac

},{"cipher-base":98,"inherits":622,"safe-buffer":676}],552:[function(require,module,exports){
'use strict'

exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = require('randombytes')
exports.createHash = exports.Hash = require('create-hash')
exports.createHmac = exports.Hmac = require('create-hmac')

var algos = require('browserify-sign/algos')
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = require('pbkdf2')
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = require('browserify-cipher')

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = require('diffie-hellman')

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = require('browserify-sign')

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = require('create-ecdh')

var publicEncrypt = require('public-encrypt')

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = require('randomfill')

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}

},{"browserify-cipher":67,"browserify-sign":74,"browserify-sign/algos":71,"create-ecdh":546,"create-hash":548,"create-hmac":550,"diffie-hellman":561,"pbkdf2":641,"public-encrypt":650,"randombytes":657,"randomfill":658}],553:[function(require,module,exports){
var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;

},{}],554:[function(require,module,exports){
var closest = require('./closest');

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;

},{"./closest":553}],555:[function(require,module,exports){
'use strict';

exports.utils = require('./des/utils');
exports.Cipher = require('./des/cipher');
exports.DES = require('./des/des');
exports.CBC = require('./des/cbc');
exports.EDE = require('./des/ede');

},{"./des/cbc":556,"./des/cipher":557,"./des/des":558,"./des/ede":559,"./des/utils":560}],556:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};

},{"inherits":622,"minimalistic-assert":632}],557:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};

},{"minimalistic-assert":632}],558:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var utils = require('./utils');
var Cipher = require('./cipher');

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};

},{"./cipher":557,"./utils":560,"inherits":622,"minimalistic-assert":632}],559:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var Cipher = require('./cipher');
var DES = require('./des');

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;

},{"./cipher":557,"./des":558,"inherits":622,"minimalistic-assert":632}],560:[function(require,module,exports){
'use strict';

exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};

},{}],561:[function(require,module,exports){
(function (Buffer){
var generatePrime = require('./lib/generatePrime')
var primes = require('./lib/primes.json')

var DH = require('./lib/dh')

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

}).call(this,require("buffer").Buffer)
},{"./lib/dh":562,"./lib/generatePrime":563,"./lib/primes.json":564,"buffer":96}],562:[function(require,module,exports){
(function (Buffer){
var BN = require('bn.js');
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = require('./generatePrime');
var randomBytes = require('randombytes');
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

}).call(this,require("buffer").Buffer)
},{"./generatePrime":563,"bn.js":565,"buffer":96,"miller-rabin":630,"randombytes":657}],563:[function(require,module,exports){
var randomBytes = require('randombytes');
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = require('bn.js');
var TWENTYFOUR = new BN(24);
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}

},{"bn.js":565,"miller-rabin":630,"randombytes":657}],564:[function(require,module,exports){
module.exports={
    "modp1": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
    },
    "modp2": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
    },
    "modp5": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
    },
    "modp14": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
    },
    "modp15": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
    },
    "modp16": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
    },
    "modp17": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
    },
    "modp18": {
        "gen": "02",
        "prime": "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"
    }
}
},{}],565:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"buffer":49,"dup":15}],566:[function(require,module,exports){
'use strict';

var elliptic = exports;

elliptic.version = require('../package.json').version;
elliptic.utils = require('./elliptic/utils');
elliptic.rand = require('brorand');
elliptic.curve = require('./elliptic/curve');
elliptic.curves = require('./elliptic/curves');

// Protocols
elliptic.ec = require('./elliptic/ec');
elliptic.eddsa = require('./elliptic/eddsa');

},{"../package.json":582,"./elliptic/curve":569,"./elliptic/curves":572,"./elliptic/ec":573,"./elliptic/eddsa":576,"./elliptic/utils":580,"brorand":48}],567:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};

},{"../utils":580,"bn.js":581}],568:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"../utils":580,"./base":567,"bn.js":581,"inherits":622}],569:[function(require,module,exports){
'use strict';

var curve = exports;

curve.base = require('./base');
curve.short = require('./short');
curve.mont = require('./mont');
curve.edwards = require('./edwards');

},{"./base":567,"./edwards":568,"./mont":570,"./short":571}],570:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var utils = require('../utils');

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};

},{"../utils":580,"./base":567,"bn.js":581,"inherits":622}],571:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

},{"../utils":580,"./base":567,"bn.js":581,"inherits":622}],572:[function(require,module,exports){
'use strict';

var curves = exports;

var hash = require('hash.js');
var curve = require('./curve');
var utils = require('./utils');

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = require('./precomputed/secp256k1');
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});

},{"./curve":569,"./precomputed/secp256k1":579,"./utils":580,"hash.js":608}],573:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var HmacDRBG = require('hmac-drbg');
var utils = require('../utils');
var curves = require('../curves');
var rand = require('brorand');
var assert = utils.assert;

var KeyPair = require('./key');
var Signature = require('./signature');

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};

},{"../curves":572,"../utils":580,"./key":574,"./signature":575,"bn.js":581,"brorand":48,"hmac-drbg":620}],574:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

},{"../utils":580,"bn.js":581}],575:[function(require,module,exports){
'use strict';

var BN = require('bn.js');

var utils = require('../utils');
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};

},{"../utils":580,"bn.js":581}],576:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var curves = require('../curves');
var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require('./key');
var Signature = require('./signature');

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};

},{"../curves":572,"../utils":580,"./key":577,"./signature":578,"hash.js":608}],577:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;

},{"../utils":580}],578:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;

},{"../utils":580,"bn.js":581}],579:[function(require,module,exports){
module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};

},{}],580:[function(require,module,exports){
'use strict';

var utils = exports;
var BN = require('bn.js');
var minAssert = require('minimalistic-assert');
var minUtils = require('minimalistic-crypto-utils');

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;


},{"bn.js":581,"minimalistic-assert":632,"minimalistic-crypto-utils":633}],581:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"buffer":49,"dup":15}],582:[function(require,module,exports){
module.exports={
  "_args": [
    [
      "elliptic@6.5.3",
      "/var/www/barntrax"
    ]
  ],
  "_from": "elliptic@6.5.3",
  "_id": "elliptic@6.5.3",
  "_inBundle": false,
  "_integrity": "sha512-IMqzv5wNQf+E6aHeIqATs0tOLeOTwj1QKbRcS3jBbYkl5oLAserA8yJTT7/VyHUYG91PRmPyeQDObKLPpeS4dw==",
  "_location": "/elliptic",
  "_phantomChildren": {},
  "_requested": {
    "type": "version",
    "registry": true,
    "raw": "elliptic@6.5.3",
    "name": "elliptic",
    "escapedName": "elliptic",
    "rawSpec": "6.5.3",
    "saveSpec": null,
    "fetchSpec": "6.5.3"
  },
  "_requiredBy": [
    "/browserify-sign",
    "/create-ecdh"
  ],
  "_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-6.5.3.tgz",
  "_spec": "6.5.3",
  "_where": "/var/www/barntrax",
  "author": {
    "name": "Fedor Indutny",
    "email": "fedor@indutny.com"
  },
  "bugs": {
    "url": "https://github.com/indutny/elliptic/issues"
  },
  "dependencies": {
    "bn.js": "^4.4.0",
    "brorand": "^1.0.1",
    "hash.js": "^1.0.0",
    "hmac-drbg": "^1.0.0",
    "inherits": "^2.0.1",
    "minimalistic-assert": "^1.0.0",
    "minimalistic-crypto-utils": "^1.0.0"
  },
  "description": "EC cryptography",
  "devDependencies": {
    "brfs": "^1.4.3",
    "coveralls": "^3.0.8",
    "grunt": "^1.0.4",
    "grunt-browserify": "^5.0.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-connect": "^1.0.0",
    "grunt-contrib-copy": "^1.0.0",
    "grunt-contrib-uglify": "^1.0.1",
    "grunt-mocha-istanbul": "^3.0.1",
    "grunt-saucelabs": "^9.0.1",
    "istanbul": "^0.4.2",
    "jscs": "^3.0.7",
    "jshint": "^2.10.3",
    "mocha": "^6.2.2"
  },
  "files": [
    "lib"
  ],
  "homepage": "https://github.com/indutny/elliptic",
  "keywords": [
    "EC",
    "Elliptic",
    "curve",
    "Cryptography"
  ],
  "license": "MIT",
  "main": "lib/elliptic.js",
  "name": "elliptic",
  "repository": {
    "type": "git",
    "url": "git+ssh://git@github.com/indutny/elliptic.git"
  },
  "scripts": {
    "jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
    "jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
    "lint": "npm run jscs && npm run jshint",
    "test": "npm run lint && npm run unit",
    "unit": "istanbul test _mocha --reporter=spec test/index.js",
    "version": "grunt dist && git add dist/"
  },
  "version": "6.5.3"
}

},{}],583:[function(require,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));





}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":649}],584:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      }
      throw TypeError('Uncaught, unspecified "error" event.');
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        len = arguments.length;
        args = new Array(len - 1);
        for (i = 1; i < len; i++)
          args[i - 1] = arguments[i];
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    len = arguments.length;
    args = new Array(len - 1);
    for (i = 1; i < len; i++)
      args[i - 1] = arguments[i];

    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    var m;
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  var ret;
  if (!emitter._events || !emitter._events[type])
    ret = 0;
  else if (isFunction(emitter._events[type]))
    ret = 1;
  else
    ret = emitter._events[type].length;
  return ret;
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

},{}],585:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var MD5 = require('md5.js')

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey

},{"md5.js":629,"safe-buffer":676}],586:[function(require,module,exports){
module.exports = FsmError;

function FsmError(message, options) {
  Error.captureStackTrace(this, this.constructor);
  this.name = 'FsmError';
  this.message = message;
  this.trigger = options.name;
  this.current = options.from;
}

FsmError.prototype = Object.create(Error.prototype);
FsmError.prototype.constructor = FsmError;

},{}],587:[function(require,module,exports){
(function (global){
/*
 * @author Vlad Stirbu
 * @license MIT
 *
 * Copyright © 2014-2016
 */

'use strict';

var FsmError = require('./fsm-error');
var stampit = require('stampit');
var _ = require('lodash');
var EventEmitter = require('events').EventEmitter;

var AssignFirstArgument = stampit({
  init: function init(opts) {
    Object.assign(this, opts);
  }
});

var StateMachine = stampit({
  props: {
    // can be an object or an array
    events: [],
    pseudoStates: {},
    responses: {},
    pseudoEvents: {},
    callbacks: {},
    states: {},
    final: null,
    initial: 'none',
    current: 'none'
  },
  statics: {
    Promise: global.Promise || require('es6-promise').Promise,
    FsmError: FsmError,
    callbackPrefix: 'on',
    noChoiceFound: 'no-choice',
    type: function type (options) {
      var Type = this.Type;
      if (options.from === options.to || _.isUndefined(options.to)) {
        return Type.NOOP;
      } else if (options.from === '*') {
        return Type.GENERAL;
      }
      return Type.INTER;
    },
    Type: {
      NOOP: 0,
      INTER: 1,
      GENERAL: 2
    },
    isConditional: function isConditional (event) {
      return _.isFunction(event.condition) && _.isArray(event.to);
    },
    pseudoEvent: function pseudoEvent (state, name) {
      return state + '--' + name;
    }
  },
  methods: {
    emit: _.noop,
    canTransition: function canTransition (options) {
      var factory = this.factory;
      var Type = factory.Type;
      switch (factory.type(options)) {
        case Type.NOOP:
          if (this.inTransition) {
            throw new factory.FsmError('Previous transition pending', options);
          }
          break;
        case Type.INTER:
          if (this.states[this.current].noopTransition >
            0 ||
            this.inTransition) {
            throw new factory.FsmError('Previous transition pending', options);
          }
          break;
        default:
      }

      return options;
    },
    can: function can (name) {
      return Boolean(this.events[name][this.current]);
    },
    cannot: function cannot (name) {
      return !this.can(name);
    },
    hasState: function hasState (state) {
      return Boolean(this.states[state]);
    },
    is: function is (state) {
      return state == this.current;
    },
    isFinal: function isFinal (state) {
      state = state || this.current;
      if (_.isArray(this.final)) {
        return _.includes(this.final, state);
      }
      return this.final === state;
    },
    isValidEvent: function isValidEvent (options) {
      if (this.cannot(options.name)) {
        throw new this.factory.FsmError('Invalid event in current state', options);
      }

      return options;
    },
    addEvents: function addEvents (events) {
      _.forEach(events, function (event) {
        this.addEvent(event);
      }.bind(this));
    },
    addEvent: function addEvent (event) {
      this.events[event.name] = this.events[event.name] || {};

      //NOTE: Add the choice pseudo-state for conditional transition
      if (this.factory.isConditional(event)) {
        return this.addConditionalEvent(event);
      }
      this.addBasicEvent(event);
    },
    addBasicEvent: function addBasicEvent (event) {
      if (_.isArray(event.to)) {
        throw new this.factory.FsmError('Ambigous transition', event);
      }

      event.from = [].concat(event.from || []);

      _.forEach(event.from, function (from) {
        this.events[event.name][from] = event.to || from;
      }.bind(this));
    },
    addConditionalEvent: function addConditionalEvent (event) {
      var pseudoState;
      var factory = this.factory;
      var callbackPrefix = factory.callbackPrefix;
      var noChoiceFound = factory.noChoiceFound;
      var pseudoEvent = factory.pseudoEvent;
      var Promise = factory.Promise;

      if (_.isArray(event.from)) {
        return _.forEach(event.from, function (from) {
          this.addConditionalEvent({
            name: event.name,
            from: from,
            to: event.to,
            condition: event.condition
          });
        }.bind(this));
      }
      pseudoState = event.from + '__' + event.name;

      this.pseudoStates[pseudoState] = event.from;

      this.addState(pseudoState);

      this.addEvent({
        name: event.name,
        from: event.from,
        to: pseudoState
      });

      this.addEvent({
        name: pseudoEvent(pseudoState, noChoiceFound),
        from: pseudoState,
        to: event.from
      });

      this.pseudoEvents[pseudoEvent(pseudoState, noChoiceFound)] = event.name;

      _.forEach(event.to, function (toState) {
        this.addEvent({
          name: pseudoEvent(pseudoState, toState),
          from: pseudoState,
          to: toState
        });

        this.pseudoEvents[pseudoEvent(pseudoState, toState)] = event.name;
      }.bind(this));

      this.callbacks[callbackPrefix + 'entered' + pseudoState] = function (options) {
        var target = this.target;

        _.defaults(options, {
          args: []
        });

        return new Promise(function (resolve) {
          resolve(event.condition(options));
        })
          .then(function (index) {
            var toState;

            if (_.isNumber(index)) {
              toState = event.to[index];
            } else if (_.includes(event.to, index)) {
              toState = index;
            }

            if (_.isUndefined(toState)) {
              return target[pseudoEvent(pseudoState, noChoiceFound)]()
                .then(function () {
                  throw new factory.FsmError('Choice index out of range', event);
                });
            } else {
              return target[pseudoEvent(pseudoState, toState)].apply(target,
                options.args);
            }
          }.bind(this));
      }.bind(this);
    },
    addState: function addState (state) {
      var states = this.states;
      state = [].concat(state || []);
      state.forEach(function (name) {
        states[name] = states[name] || {
            noopTransition: 0
          };
      });
    },
    preprocessPseudoState: function preprocessPseudoState (name, options) {
      var responses = this.responses;

      // transition to choice state in a conditional event
      Object.defineProperty(options, 'res', {
        get: function getRes () {
          return responses[name];
        },
        set: function setRes (value) {
          responses[name] = value;
        }
      });

      // reset previous results
      delete responses[name];

      return options;
    },
    preprocessPseudoEvent: function preprocessPseudoEvent (name, options) {
      // transition from choice state in a conditional event
      var pseudoEvent = this.pseudoEvents[name];
      var responses = this.responses;
      var pseudoStates = this.pseudoStates;
      var pOptions = {
        name: pseudoEvent,
        from: pseudoStates[this.current],
        to: options.to,
        args: options.args
      };

      Object.defineProperties(pOptions, {
        res: {
          get: function () {
            return responses[pseudoEvent];
          },
          set: function (val) {
            responses[pseudoEvent] = val;
          }
        }
      });

      return pOptions;
    },
    buildEvent: function buildEvent (name) {
      var callbacks = this.callbacks;
      var pseudoEvents = this.pseudoEvents;
      var pseudoStates = this.pseudoStates;
      var events = this.events;
      var Type = this.factory.Type;
      var callbackPrefix = this.factory.callbackPrefix;

      return function triggerEvent () {
        var args = _.toArray(arguments);
        var current = this.current;
        var target = this.target;
        var options = {
          name: name,
          from: current,
          to: events[name][current],
          args: args
        };
        var pOptions;
        var isPseudo = pseudoEvents[name];

        if (pseudoStates[options.to]) {
          options = this.preprocessPseudoState(name, options);
        }

        if (isPseudo) {
          pOptions = this.preprocessPseudoEvent(name, options);
        }

        return new this.factory.Promise(function (resolve) {
          resolve(options);
        })
          .then(this.isValidEvent.bind(this))
          .then(this.canTransition.bind(this))
          .then(callbacks[callbackPrefix + 'leave' + current] ? callbacks[callbackPrefix + 'leave' +
          current].bind(target, options) : _.identity)
          .then(callbacks.onleave
            ? callbacks.onleave.bind(target, options)
            : _.identity)
          .then(onleavestate.bind(this, options))
          .then(callbacks[callbackPrefix + name] ? callbacks[callbackPrefix + name].bind(target,
            options) : _.identity)
          //in the case of the transition from choice pseudostate we provide
          // the options of the original transition
          .then(callbacks[callbackPrefix + 'enter' + events[name][current]]
            ? callbacks[callbackPrefix + 'enter' + events[name][current]].bind(target,
            isPseudo ? pOptions : options)
            : _.identity)
          .then(callbacks.onenter ? callbacks.onenter.bind(target,
            isPseudo ? pOptions : options) : _.identity)
          .then(onenterstate.bind(this, options))
          .then(callbacks[callbackPrefix + 'entered' + events[name][current]]
            ? callbacks[callbackPrefix + 'entered' + events[name][current]].bind(target,
            isPseudo ? pOptions : options)
            : _.identity)
          .then(callbacks.onentered ? callbacks.onentered.bind(target,
            isPseudo ? pOptions : options) : _.identity)
          .then(returnValue.bind(this, options))
          .catch(revert.bind(this));

        function returnValue (options) {
          return options.res || options;
        }

        function onleavestate (options) {
          switch (this.factory.type(options)) {
            case Type.NOOP:
              this.states[this.current].noopTransition += 1;
              break;
            default:
              this.inTransition = true;
          }

          return options;
        }

        function onenterstate (options) {
          switch (this.factory.type(options)) {
            case Type.NOOP:
              this.states[this.current].noopTransition -= 1;
              break;
            default:
              this.inTransition = false;
              this.current = options.to;
              this.emit('state', this.current);
          }

          return options;
        }

        //NOTE: Internal error handling stub
        function revert (err) {
          switch (this.factory.type(options)) {
            case Type.INTER:
              this.inTransition = false;
              break;
            case Type.NOOP:
              if (this.states[this.current].noopTransition > 0) {
                this.states[this.current].noopTransition -= 1;
              }
              break;
            default:
          }
          throw err;
        }
      }.bind(this);
    },
    initTarget: function initTarget(target) {
      var mixin;

      if (!_.isObject(target)) {
        target = new EventEmitter();
      }

      if (_.isFunction(target.emit)) {
        this.emit = function emit () {
          return target.emit.apply(target, arguments);
        };
      }

      mixin = _.mapValues(this.events, function (event, name) {
        return this.buildEvent(name);
      }.bind(this));

      _.assign(target, mixin, {
        can: this.can.bind(this),
        cannot: this.cannot.bind(this),
        is: this.is.bind(this),
        hasState: this.hasState.bind(this),
        isFinal: this.isFinal.bind(this)
      });

      Object.defineProperty(target, 'current', {
        get: function getCurrent () {
          return this.current;
        }.bind(this)
      });

      this.target = target;

      return target;
    }
  },
  init: function init (opts, context) {
    this.factory = context.stamp;

    var events = this.events;
    this.events = {};
    _.forEach(events, function (event, name) {
      if (_.isString(name)) {
        event.name = name;
      }

      this.addEvent(event);

      //NOTE: Add states
      this.addState(event.from);
      this.addState(event.to);
    }.bind(this));

    this.current = this.initial;
    // return this.initTarget(_.first(context.args));
    return this.initTarget(context.args[1]);
  }
});

StateMachine = AssignFirstArgument.compose(StateMachine);

module.exports = StateMachine;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./fsm-error":586,"es6-promise":583,"events":584,"lodash":628,"stampit":689}],588:[function(require,module,exports){
/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};

},{}],589:[function(require,module,exports){
var is = require('./is');
var delegate = require('delegate');

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;

},{"./is":588,"delegate":554}],590:[function(require,module,exports){
'use strict'
var Buffer = require('safe-buffer').Buffer
var Transform = require('readable-stream').Transform
var inherits = require('inherits')

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase

},{"inherits":622,"readable-stream":605,"safe-buffer":606}],591:[function(require,module,exports){
arguments[4][77][0].apply(exports,arguments)
},{"dup":77}],592:[function(require,module,exports){
arguments[4][78][0].apply(exports,arguments)
},{"./_stream_readable":594,"./_stream_writable":596,"_process":649,"dup":78,"inherits":622}],593:[function(require,module,exports){
arguments[4][79][0].apply(exports,arguments)
},{"./_stream_transform":595,"dup":79,"inherits":622}],594:[function(require,module,exports){
arguments[4][80][0].apply(exports,arguments)
},{"../errors":591,"./_stream_duplex":592,"./internal/streams/async_iterator":597,"./internal/streams/buffer_list":598,"./internal/streams/destroy":599,"./internal/streams/from":601,"./internal/streams/state":603,"./internal/streams/stream":604,"_process":649,"buffer":96,"dup":80,"events":584,"inherits":622,"string_decoder/":607,"util":49}],595:[function(require,module,exports){
arguments[4][81][0].apply(exports,arguments)
},{"../errors":591,"./_stream_duplex":592,"dup":81,"inherits":622}],596:[function(require,module,exports){
arguments[4][82][0].apply(exports,arguments)
},{"../errors":591,"./_stream_duplex":592,"./internal/streams/destroy":599,"./internal/streams/state":603,"./internal/streams/stream":604,"_process":649,"buffer":96,"dup":82,"inherits":622,"util-deprecate":693}],597:[function(require,module,exports){
arguments[4][83][0].apply(exports,arguments)
},{"./end-of-stream":600,"_process":649,"dup":83}],598:[function(require,module,exports){
arguments[4][84][0].apply(exports,arguments)
},{"buffer":96,"dup":84,"util":49}],599:[function(require,module,exports){
arguments[4][85][0].apply(exports,arguments)
},{"_process":649,"dup":85}],600:[function(require,module,exports){
arguments[4][86][0].apply(exports,arguments)
},{"../../../errors":591,"dup":86}],601:[function(require,module,exports){
arguments[4][87][0].apply(exports,arguments)
},{"dup":87}],602:[function(require,module,exports){
arguments[4][88][0].apply(exports,arguments)
},{"../../../errors":591,"./end-of-stream":600,"dup":88}],603:[function(require,module,exports){
arguments[4][89][0].apply(exports,arguments)
},{"../../../errors":591,"dup":89}],604:[function(require,module,exports){
arguments[4][90][0].apply(exports,arguments)
},{"dup":90,"events":584}],605:[function(require,module,exports){
arguments[4][91][0].apply(exports,arguments)
},{"./lib/_stream_duplex.js":592,"./lib/_stream_passthrough.js":593,"./lib/_stream_readable.js":594,"./lib/_stream_transform.js":595,"./lib/_stream_writable.js":596,"./lib/internal/streams/end-of-stream.js":600,"./lib/internal/streams/pipeline.js":602,"dup":91}],606:[function(require,module,exports){
arguments[4][92][0].apply(exports,arguments)
},{"buffer":96,"dup":92}],607:[function(require,module,exports){
arguments[4][93][0].apply(exports,arguments)
},{"dup":93,"safe-buffer":606}],608:[function(require,module,exports){
var hash = exports;

hash.utils = require('./hash/utils');
hash.common = require('./hash/common');
hash.sha = require('./hash/sha');
hash.ripemd = require('./hash/ripemd');
hash.hmac = require('./hash/hmac');

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"./hash/common":609,"./hash/hmac":610,"./hash/ripemd":611,"./hash/sha":612,"./hash/utils":619}],609:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};

},{"./utils":619,"minimalistic-assert":632}],610:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};

},{"./utils":619,"minimalistic-assert":632}],611:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var common = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];

},{"./common":609,"./utils":619}],612:[function(require,module,exports){
'use strict';

exports.sha1 = require('./sha/1');
exports.sha224 = require('./sha/224');
exports.sha256 = require('./sha/256');
exports.sha384 = require('./sha/384');
exports.sha512 = require('./sha/512');

},{"./sha/1":613,"./sha/224":614,"./sha/256":615,"./sha/384":616,"./sha/512":617}],613:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":609,"../utils":619,"./common":618}],614:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var SHA256 = require('./256');

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};


},{"../utils":619,"./256":615}],615:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');
var assert = require('minimalistic-assert');

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":609,"../utils":619,"./common":618,"minimalistic-assert":632}],616:[function(require,module,exports){
'use strict';

var utils = require('../utils');

var SHA512 = require('./512');

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};

},{"../utils":619,"./512":617}],617:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var assert = require('minimalistic-assert');

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

},{"../common":609,"../utils":619,"minimalistic-assert":632}],618:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;

},{"../utils":619}],619:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"inherits":622,"minimalistic-assert":632}],620:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var utils = require('minimalistic-crypto-utils');
var assert = require('minimalistic-assert');

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};

},{"hash.js":608,"minimalistic-assert":632,"minimalistic-crypto-utils":633}],621:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],622:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],623:[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],624:[function(require,module,exports){
require('babel-polyfill');
require('webrtc-adapter');

var Instascan = {
  Scanner: require('./src/scanner'),
  Camera: require('./src/camera')
};

module.exports = Instascan;

},{"./src/camera":625,"./src/scanner":626,"babel-polyfill":16,"webrtc-adapter":699}],625:[function(require,module,exports){
'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cameraName(label) {
  var clean = label.replace(/\s*\([0-9a-f]+(:[0-9a-f]+)?\)\s*$/, '');
  return clean || label || null;
}

var Camera = function () {
  function Camera(id, name) {
    (0, _classCallCheck3.default)(this, Camera);

    this.id = id;
    this.name = name;
    this._stream = null;
  }

  (0, _createClass3.default)(Camera, [{
    key: 'start',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var constraints;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                constraints = {
                  audio: false,
                  video: {
                    mandatory: {
                      sourceId: this.id,
                      minWidth: 600,
                      maxWidth: 800,
                      minAspectRatio: 1.6
                    },
                    optional: []
                  }
                };
                _context.next = 3;
                return navigator.mediaDevices.getUserMedia(constraints);

              case 3:
                this._stream = _context.sent;
                return _context.abrupt('return', window.URL.createObjectURL(this._stream));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _ref.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: 'stop',
    value: function stop() {
      if (!this._stream) {
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this._stream.getVideoTracks()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stream = _step.value;

          stream.stop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this._stream = null;
    }
  }], [{
    key: 'getCameras',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var devices;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return navigator.mediaDevices.enumerateDevices();

              case 2:
                devices = _context2.sent;
                return _context2.abrupt('return', devices.filter(function (d) {
                  return d.kind === 'videoinput';
                }).map(function (d) {
                  return new Camera(d.deviceId, cameraName(d.label));
                }));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCameras() {
        return _ref2.apply(this, arguments);
      }

      return getCameras;
    }()
  }]);
  return Camera;
}();

module.exports = Camera;

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/helpers/asyncToGenerator":33,"babel-runtime/helpers/classCallCheck":34,"babel-runtime/helpers/createClass":35,"babel-runtime/regenerator":45}],626:[function(require,module,exports){
'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _trunc = require('babel-runtime/core-js/math/trunc');

var _trunc2 = _interopRequireDefault(_trunc);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventEmitter = require('events');
var ZXing = require('./zxing')();
var Visibility = require('visibilityjs');
var StateMachine = require('fsm-as-promised');

var ScanProvider = function () {
  function ScanProvider(emitter, analyzer, captureImage, scanPeriod, refractoryPeriod) {
    (0, _classCallCheck3.default)(this, ScanProvider);

    this.scanPeriod = scanPeriod;
    this.captureImage = captureImage;
    this.refractoryPeriod = refractoryPeriod;
    this._emitter = emitter;
    this._frameCount = 0;
    this._analyzer = analyzer;
    this._lastResult = null;
    this._active = false;
  }

  (0, _createClass3.default)(ScanProvider, [{
    key: 'start',
    value: function start() {
      var _this = this;

      this._active = true;
      requestAnimationFrame(function () {
        return _this._scan();
      });
    }
  }, {
    key: 'stop',
    value: function stop() {
      this._active = false;
    }
  }, {
    key: 'scan',
    value: function scan() {
      return this._analyze(false);
    }
  }, {
    key: '_analyze',
    value: function _analyze(skipDups) {
      var _this2 = this;

      var analysis = this._analyzer.analyze();
      if (!analysis) {
        return null;
      }

      var result = analysis.result,
          canvas = analysis.canvas;

      if (!result) {
        return null;
      }

      if (skipDups && result === this._lastResult) {
        return null;
      }

      clearTimeout(this.refractoryTimeout);
      this.refractoryTimeout = setTimeout(function () {
        _this2._lastResult = null;
      }, this.refractoryPeriod);

      var image = this.captureImage ? canvas.toDataURL('image/webp', 0.8) : null;

      this._lastResult = result;

      var payload = { content: result };
      if (image) {
        payload.image = image;
      }

      return payload;
    }
  }, {
    key: '_scan',
    value: function _scan() {
      var _this3 = this;

      if (!this._active) {
        return;
      }

      requestAnimationFrame(function () {
        return _this3._scan();
      });

      if (++this._frameCount !== this.scanPeriod) {
        return;
      } else {
        this._frameCount = 0;
      }

      var result = this._analyze(true);
      if (result) {
        setTimeout(function () {
          _this3._emitter.emit('scan', result.content, result.image || null);
        }, 0);
      }
    }
  }]);
  return ScanProvider;
}();

var Analyzer = function () {
  function Analyzer(video) {
    (0, _classCallCheck3.default)(this, Analyzer);

    this.video = video;

    this.imageBuffer = null;
    this.sensorLeft = null;
    this.sensorTop = null;
    this.sensorWidth = null;
    this.sensorHeight = null;

    this.canvas = document.createElement('canvas');
    this.canvas.style.display = 'none';
    this.canvasContext = null;

    this.decodeCallback = ZXing.Runtime.addFunction(function (ptr, len, resultIndex, resultCount) {
      var result = new Uint8Array(ZXing.HEAPU8.buffer, ptr, len);
      var str = String.fromCharCode.apply(null, result);
      if (resultIndex === 0) {
        window.zxDecodeResult = '';
      }
      window.zxDecodeResult += str;
    });
  }

  (0, _createClass3.default)(Analyzer, [{
    key: 'analyze',
    value: function analyze() {
      if (!this.video.videoWidth) {
        return null;
      }

      if (!this.imageBuffer) {
        var videoWidth = this.video.videoWidth;
        var videoHeight = this.video.videoHeight;

        this.sensorWidth = videoWidth;
        this.sensorHeight = videoHeight;
        this.sensorLeft = Math.floor(videoWidth / 2 - this.sensorWidth / 2);
        this.sensorTop = Math.floor(videoHeight / 2 - this.sensorHeight / 2);

        this.canvas.width = this.sensorWidth;
        this.canvas.height = this.sensorHeight;

        this.canvasContext = this.canvas.getContext('2d');
        this.imageBuffer = ZXing._resize(this.sensorWidth, this.sensorHeight);
        return null;
      }

      this.canvasContext.drawImage(this.video, this.sensorLeft, this.sensorTop, this.sensorWidth, this.sensorHeight);

      var data = this.canvasContext.getImageData(0, 0, this.sensorWidth, this.sensorHeight).data;
      for (var i = 0, j = 0; i < data.length; i += 4, j++) {
        var _ref = [data[i], data[i + 1], data[i + 2]],
            r = _ref[0],
            g = _ref[1],
            b = _ref[2];

        ZXing.HEAPU8[this.imageBuffer + j] = (0, _trunc2.default)((r + g + b) / 3);
      }

      var err = ZXing._decode_qr(this.decodeCallback);
      if (err) {
        return null;
      }

      var result = window.zxDecodeResult;
      if (result != null) {
        return { result: result, canvas: this.canvas };
      }

      return null;
    }
  }]);
  return Analyzer;
}();

var Scanner = function (_EventEmitter) {
  (0, _inherits3.default)(Scanner, _EventEmitter);

  function Scanner(opts) {
    (0, _classCallCheck3.default)(this, Scanner);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (Scanner.__proto__ || (0, _getPrototypeOf2.default)(Scanner)).call(this));

    _this4.video = _this4._configureVideo(opts);
    _this4.mirror = opts.mirror !== false;
    _this4.backgroundScan = opts.backgroundScan || false;
    _this4._continuous = opts.continuous !== false;
    _this4._analyzer = new Analyzer(_this4.video);
    _this4._camera = null;

    var captureImage = opts.captureImage || false;
    var scanPeriod = opts.scanPeriod || 1;
    var refractoryPeriod = opts.refractoryPeriod || 5 * 1000;

    _this4._scanner = new ScanProvider(_this4, _this4._analyzer, captureImage, scanPeriod, refractoryPeriod);
    _this4._fsm = _this4._createStateMachine();

    Visibility.change(function (e, state) {
      if (state === 'visible') {
        setTimeout(function () {
          if (_this4._fsm.can('activate')) {
            _this4._fsm.activate();
          }
        }, 0);
      } else {
        if (!_this4.backgroundScan && _this4._fsm.can('deactivate')) {
          _this4._fsm.deactivate();
        }
      }
    });

    _this4.addListener('active', function () {
      _this4.video.classList.remove('inactive');
      _this4.video.classList.add('active');
    });

    _this4.addListener('inactive', function () {
      _this4.video.classList.remove('active');
      _this4.video.classList.add('inactive');
    });

    _this4.emit('inactive');
    return _this4;
  }

  (0, _createClass3.default)(Scanner, [{
    key: 'scan',
    value: function scan() {
      return this._scanner.scan();
    }
  }, {
    key: 'start',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var camera = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._fsm.can('start')) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this._fsm.start(camera);

              case 3:
                _context.next = 9;
                break;

              case 5:
                _context.next = 7;
                return this._fsm.stop();

              case 7:
                _context.next = 9;
                return this._fsm.start(camera);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _ref2.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: 'stop',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._fsm.can('stop')) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this._fsm.stop();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _ref3.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: '_enableScan',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(camera) {
        var streamUrl;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._camera = camera || this._camera;

                if (this._camera) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('Camera is not defined.');

              case 3:
                _context3.next = 5;
                return this._camera.start();

              case 5:
                streamUrl = _context3.sent;

                this.video.src = streamUrl;

                if (this._continuous) {
                  this._scanner.start();
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _enableScan(_x2) {
        return _ref4.apply(this, arguments);
      }

      return _enableScan;
    }()
  }, {
    key: '_disableScan',
    value: function _disableScan() {
      this.video.src = '';

      if (this._scanner) {
        this._scanner.stop();
      }

      if (this._camera) {
        this._camera.stop();
      }
    }
  }, {
    key: '_configureVideo',
    value: function _configureVideo(opts) {
      if (opts.video) {
        if (opts.video.tagName !== 'VIDEO') {
          throw new Error('Video must be a <video> element.');
        }
      }

      var video = opts.video || document.createElement('video');
      video.setAttribute('autoplay', 'autoplay');

      return video;
    }
  }, {
    key: '_createStateMachine',
    value: function _createStateMachine() {
      var _this5 = this;

      return StateMachine.create({
        initial: 'stopped',
        events: [{
          name: 'start',
          from: 'stopped',
          to: 'started'
        }, {
          name: 'stop',
          from: ['started', 'active', 'inactive'],
          to: 'stopped'
        }, {
          name: 'activate',
          from: ['started', 'inactive'],
          to: ['active', 'inactive'],
          condition: function condition(options) {
            if (Visibility.state() === 'visible' || this.backgroundScan) {
              return 'active';
            } else {
              return 'inactive';
            }
          }
        }, {
          name: 'deactivate',
          from: ['started', 'active'],
          to: 'inactive'
        }],
        callbacks: {
          onenteractive: function () {
            var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(options) {
              return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return _this5._enableScan(options.args[0]);

                    case 2:
                      _this5.emit('active');

                    case 3:
                    case 'end':
                      return _context4.stop();
                  }
                }
              }, _callee4, _this5);
            }));

            return function onenteractive(_x3) {
              return _ref5.apply(this, arguments);
            };
          }(),
          onleaveactive: function onleaveactive() {
            _this5._disableScan();
            _this5.emit('inactive');
          },
          onenteredstarted: function () {
            var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(options) {
              return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return _this5._fsm.activate(options.args[0]);

                    case 2:
                    case 'end':
                      return _context5.stop();
                  }
                }
              }, _callee5, _this5);
            }));

            return function onenteredstarted(_x4) {
              return _ref6.apply(this, arguments);
            };
          }()
        }
      });
    }
  }, {
    key: 'captureImage',
    set: function set(capture) {
      this._scanner.captureImage = capture;
    },
    get: function get() {
      return this._scanner.captureImage;
    }
  }, {
    key: 'scanPeriod',
    set: function set(period) {
      this._scanner.scanPeriod = period;
    },
    get: function get() {
      return this._scanner.scanPeriod;
    }
  }, {
    key: 'refractoryPeriod',
    set: function set(period) {
      this._scanner.refractoryPeriod = period;
    },
    get: function get() {
      return this._scanner.refractoryPeriod;
    }
  }, {
    key: 'continuous',
    set: function set(continuous) {
      this._continuous = continuous;

      if (continuous && this._fsm.current === 'active') {
        this._scanner.start();
      } else {
        this._scanner.stop();
      }
    },
    get: function get() {
      return this._continuous;
    }
  }, {
    key: 'mirror',
    set: function set(mirror) {
      this._mirror = mirror;

      if (mirror) {
        this.video.style.MozTransform = 'scaleX(-1)';
        this.video.style.webkitTransform = 'scaleX(-1)';
        this.video.style.OTransform = 'scaleX(-1)';
        this.video.style.msFilter = 'FlipH';
        this.video.style.filter = 'FlipH';
        this.video.style.transform = 'scaleX(-1)';
      } else {
        this.video.style.MozTransform = null;
        this.video.style.webkitTransform = null;
        this.video.style.OTransform = null;
        this.video.style.msFilter = null;
        this.video.style.filter = null;
        this.video.style.transform = null;
      }
    },
    get: function get() {
      return this._mirror;
    }
  }]);
  return Scanner;
}(EventEmitter);

module.exports = Scanner;

},{"./zxing":627,"babel-runtime/core-js/math/trunc":21,"babel-runtime/core-js/object/get-prototype-of":26,"babel-runtime/helpers/asyncToGenerator":33,"babel-runtime/helpers/classCallCheck":34,"babel-runtime/helpers/createClass":35,"babel-runtime/helpers/inherits":38,"babel-runtime/helpers/possibleConstructorReturn":39,"babel-runtime/regenerator":45,"events":584,"fsm-as-promised":587,"visibilityjs":694}],627:[function(require,module,exports){
(function (process,Buffer,__dirname){
module.exports = function(Module) {
  Module = Module || {};

var Module;if(!Module)Module=(typeof ZXing!=="undefined"?ZXing:null)||{};var moduleOverrides={};for(var key in Module){if(Module.hasOwnProperty(key)){moduleOverrides[key]=Module[key]}}var ENVIRONMENT_IS_WEB=typeof window==="object";var ENVIRONMENT_IS_WORKER=typeof importScripts==="function";var ENVIRONMENT_IS_NODE=typeof process==="object"&&typeof require==="function"&&!ENVIRONMENT_IS_WEB&&!ENVIRONMENT_IS_WORKER;var ENVIRONMENT_IS_SHELL=!ENVIRONMENT_IS_WEB&&!ENVIRONMENT_IS_NODE&&!ENVIRONMENT_IS_WORKER;if(ENVIRONMENT_IS_NODE){if(!Module["print"])Module["print"]=function print(x){process["stdout"].write(x+"\n")};if(!Module["printErr"])Module["printErr"]=function printErr(x){process["stderr"].write(x+"\n")};var nodeFS=require("fs");var nodePath=require("path");Module["read"]=function read(filename,binary){filename=nodePath["normalize"](filename);var ret=nodeFS["readFileSync"](filename);if(!ret&&filename!=nodePath["resolve"](filename)){filename=path.join(__dirname,"..","src",filename);ret=nodeFS["readFileSync"](filename)}if(ret&&!binary)ret=ret.toString();return ret};Module["readBinary"]=function readBinary(filename){var ret=Module["read"](filename,true);if(!ret.buffer){ret=new Uint8Array(ret)}assert(ret.buffer);return ret};Module["load"]=function load(f){globalEval(read(f))};if(!Module["thisProgram"]){if(process["argv"].length>1){Module["thisProgram"]=process["argv"][1].replace(/\\/g,"/")}else{Module["thisProgram"]="unknown-program"}}Module["arguments"]=process["argv"].slice(2);if(typeof module!=="undefined"){module["exports"]=Module}process["on"]("uncaughtException",(function(ex){if(!(ex instanceof ExitStatus)){throw ex}}));Module["inspect"]=(function(){return"[Emscripten Module object]"})}else if(ENVIRONMENT_IS_SHELL){if(!Module["print"])Module["print"]=print;if(typeof printErr!="undefined")Module["printErr"]=printErr;if(typeof read!="undefined"){Module["read"]=read}else{Module["read"]=function read(){throw"no read() available (jsc?)"}}Module["readBinary"]=function readBinary(f){if(typeof readbuffer==="function"){return new Uint8Array(readbuffer(f))}var data=read(f,"binary");assert(typeof data==="object");return data};if(typeof scriptArgs!="undefined"){Module["arguments"]=scriptArgs}else if(typeof arguments!="undefined"){Module["arguments"]=arguments}}else if(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER){Module["read"]=function read(url){var xhr=new XMLHttpRequest;xhr.open("GET",url,false);xhr.send(null);return xhr.responseText};if(typeof arguments!="undefined"){Module["arguments"]=arguments}if(typeof console!=="undefined"){if(!Module["print"])Module["print"]=function print(x){console.log(x)};if(!Module["printErr"])Module["printErr"]=function printErr(x){console.log(x)}}else{var TRY_USE_DUMP=false;if(!Module["print"])Module["print"]=TRY_USE_DUMP&&typeof dump!=="undefined"?(function(x){dump(x)}):(function(x){})}if(ENVIRONMENT_IS_WORKER){Module["load"]=importScripts}if(typeof Module["setWindowTitle"]==="undefined"){Module["setWindowTitle"]=(function(title){document.title=title})}}else{throw"Unknown runtime environment. Where are we?"}function globalEval(x){eval.call(null,x)}if(!Module["load"]&&Module["read"]){Module["load"]=function load(f){globalEval(Module["read"](f))}}if(!Module["print"]){Module["print"]=(function(){})}if(!Module["printErr"]){Module["printErr"]=Module["print"]}if(!Module["arguments"]){Module["arguments"]=[]}if(!Module["thisProgram"]){Module["thisProgram"]="./this.program"}Module.print=Module["print"];Module.printErr=Module["printErr"];Module["preRun"]=[];Module["postRun"]=[];for(var key in moduleOverrides){if(moduleOverrides.hasOwnProperty(key)){Module[key]=moduleOverrides[key]}}var Runtime={setTempRet0:(function(value){tempRet0=value}),getTempRet0:(function(){return tempRet0}),stackSave:(function(){return STACKTOP}),stackRestore:(function(stackTop){STACKTOP=stackTop}),getNativeTypeSize:(function(type){switch(type){case"i1":case"i8":return 1;case"i16":return 2;case"i32":return 4;case"i64":return 8;case"float":return 4;case"double":return 8;default:{if(type[type.length-1]==="*"){return Runtime.QUANTUM_SIZE}else if(type[0]==="i"){var bits=parseInt(type.substr(1));assert(bits%8===0);return bits/8}else{return 0}}}}),getNativeFieldSize:(function(type){return Math.max(Runtime.getNativeTypeSize(type),Runtime.QUANTUM_SIZE)}),STACK_ALIGN:16,prepVararg:(function(ptr,type){if(type==="double"||type==="i64"){if(ptr&7){assert((ptr&7)===4);ptr+=4}}else{assert((ptr&3)===0)}return ptr}),getAlignSize:(function(type,size,vararg){if(!vararg&&(type=="i64"||type=="double"))return 8;if(!type)return Math.min(size,8);return Math.min(size||(type?Runtime.getNativeFieldSize(type):0),Runtime.QUANTUM_SIZE)}),dynCall:(function(sig,ptr,args){if(args&&args.length){if(!args.splice)args=Array.prototype.slice.call(args);args.splice(0,0,ptr);return Module["dynCall_"+sig].apply(null,args)}else{return Module["dynCall_"+sig].call(null,ptr)}}),functionPointers:[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],addFunction:(function(func){for(var i=0;i<Runtime.functionPointers.length;i++){if(!Runtime.functionPointers[i]){Runtime.functionPointers[i]=func;return 2*(1+i)}}throw"Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS."}),removeFunction:(function(index){Runtime.functionPointers[(index-2)/2]=null}),warnOnce:(function(text){if(!Runtime.warnOnce.shown)Runtime.warnOnce.shown={};if(!Runtime.warnOnce.shown[text]){Runtime.warnOnce.shown[text]=1;Module.printErr(text)}}),funcWrappers:{},getFuncWrapper:(function(func,sig){assert(sig);if(!Runtime.funcWrappers[sig]){Runtime.funcWrappers[sig]={}}var sigCache=Runtime.funcWrappers[sig];if(!sigCache[func]){sigCache[func]=function dynCall_wrapper(){return Runtime.dynCall(sig,func,arguments)}}return sigCache[func]}),getCompilerSetting:(function(name){throw"You must build with -s RETAIN_COMPILER_SETTINGS=1 for Runtime.getCompilerSetting or emscripten_get_compiler_setting to work"}),stackAlloc:(function(size){var ret=STACKTOP;STACKTOP=STACKTOP+size|0;STACKTOP=STACKTOP+15&-16;return ret}),staticAlloc:(function(size){var ret=STATICTOP;STATICTOP=STATICTOP+size|0;STATICTOP=STATICTOP+15&-16;return ret}),dynamicAlloc:(function(size){var ret=DYNAMICTOP;DYNAMICTOP=DYNAMICTOP+size|0;DYNAMICTOP=DYNAMICTOP+15&-16;if(DYNAMICTOP>=TOTAL_MEMORY){var success=enlargeMemory();if(!success){DYNAMICTOP=ret;return 0}}return ret}),alignMemory:(function(size,quantum){var ret=size=Math.ceil(size/(quantum?quantum:16))*(quantum?quantum:16);return ret}),makeBigInt:(function(low,high,unsigned){var ret=unsigned?+(low>>>0)+ +(high>>>0)*+4294967296:+(low>>>0)+ +(high|0)*+4294967296;return ret}),GLOBAL_BASE:8,QUANTUM_SIZE:4,__dummy__:0};Module["Runtime"]=Runtime;var __THREW__=0;var ABORT=false;var EXITSTATUS=0;var undef=0;var tempValue,tempInt,tempBigInt,tempInt2,tempBigInt2,tempPair,tempBigIntI,tempBigIntR,tempBigIntS,tempBigIntP,tempBigIntD,tempDouble,tempFloat;var tempI64,tempI64b;var tempRet0,tempRet1,tempRet2,tempRet3,tempRet4,tempRet5,tempRet6,tempRet7,tempRet8,tempRet9;function assert(condition,text){if(!condition){abort("Assertion failed: "+text)}}var globalScope=this;function getCFunc(ident){var func=Module["_"+ident];if(!func){try{func=eval("_"+ident)}catch(e){}}assert(func,"Cannot call unknown function "+ident+" (perhaps LLVM optimizations or closure removed it?)");return func}var cwrap,ccall;((function(){var JSfuncs={"stackSave":(function(){Runtime.stackSave()}),"stackRestore":(function(){Runtime.stackRestore()}),"arrayToC":(function(arr){var ret=Runtime.stackAlloc(arr.length);writeArrayToMemory(arr,ret);return ret}),"stringToC":(function(str){var ret=0;if(str!==null&&str!==undefined&&str!==0){ret=Runtime.stackAlloc((str.length<<2)+1);writeStringToMemory(str,ret)}return ret})};var toC={"string":JSfuncs["stringToC"],"array":JSfuncs["arrayToC"]};ccall=function ccallFunc(ident,returnType,argTypes,args,opts){var func=getCFunc(ident);var cArgs=[];var stack=0;if(args){for(var i=0;i<args.length;i++){var converter=toC[argTypes[i]];if(converter){if(stack===0)stack=Runtime.stackSave();cArgs[i]=converter(args[i])}else{cArgs[i]=args[i]}}}var ret=func.apply(null,cArgs);if(returnType==="string")ret=Pointer_stringify(ret);if(stack!==0){if(opts&&opts.async){EmterpreterAsync.asyncFinalizers.push((function(){Runtime.stackRestore(stack)}));return}Runtime.stackRestore(stack)}return ret};var sourceRegex=/^function\s*\(([^)]*)\)\s*{\s*([^*]*?)[\s;]*(?:return\s*(.*?)[;\s]*)?}$/;function parseJSFunc(jsfunc){var parsed=jsfunc.toString().match(sourceRegex).slice(1);return{arguments:parsed[0],body:parsed[1],returnValue:parsed[2]}}var JSsource={};for(var fun in JSfuncs){if(JSfuncs.hasOwnProperty(fun)){JSsource[fun]=parseJSFunc(JSfuncs[fun])}}cwrap=function cwrap(ident,returnType,argTypes){argTypes=argTypes||[];var cfunc=getCFunc(ident);var numericArgs=argTypes.every((function(type){return type==="number"}));var numericRet=returnType!=="string";if(numericRet&&numericArgs){return cfunc}var argNames=argTypes.map((function(x,i){return"$"+i}));var funcstr="(function("+argNames.join(",")+") {";var nargs=argTypes.length;if(!numericArgs){funcstr+="var stack = "+JSsource["stackSave"].body+";";for(var i=0;i<nargs;i++){var arg=argNames[i],type=argTypes[i];if(type==="number")continue;var convertCode=JSsource[type+"ToC"];funcstr+="var "+convertCode.arguments+" = "+arg+";";funcstr+=convertCode.body+";";funcstr+=arg+"="+convertCode.returnValue+";"}}var cfuncname=parseJSFunc((function(){return cfunc})).returnValue;funcstr+="var ret = "+cfuncname+"("+argNames.join(",")+");";if(!numericRet){var strgfy=parseJSFunc((function(){return Pointer_stringify})).returnValue;funcstr+="ret = "+strgfy+"(ret);"}if(!numericArgs){funcstr+=JSsource["stackRestore"].body.replace("()","(stack)")+";"}funcstr+="return ret})";return eval(funcstr)}}))();Module["ccall"]=ccall;Module["cwrap"]=cwrap;function setValue(ptr,value,type,noSafe){type=type||"i8";if(type.charAt(type.length-1)==="*")type="i32";switch(type){case"i1":HEAP8[ptr>>0]=value;break;case"i8":HEAP8[ptr>>0]=value;break;case"i16":HEAP16[ptr>>1]=value;break;case"i32":HEAP32[ptr>>2]=value;break;case"i64":tempI64=[value>>>0,(tempDouble=value,+Math_abs(tempDouble)>=+1?tempDouble>+0?(Math_min(+Math_floor(tempDouble/+4294967296),+4294967295)|0)>>>0:~~+Math_ceil((tempDouble- +(~~tempDouble>>>0))/+4294967296)>>>0:0)],HEAP32[ptr>>2]=tempI64[0],HEAP32[ptr+4>>2]=tempI64[1];break;case"float":HEAPF32[ptr>>2]=value;break;case"double":HEAPF64[ptr>>3]=value;break;default:abort("invalid type for setValue: "+type)}}Module["setValue"]=setValue;function getValue(ptr,type,noSafe){type=type||"i8";if(type.charAt(type.length-1)==="*")type="i32";switch(type){case"i1":return HEAP8[ptr>>0];case"i8":return HEAP8[ptr>>0];case"i16":return HEAP16[ptr>>1];case"i32":return HEAP32[ptr>>2];case"i64":return HEAP32[ptr>>2];case"float":return HEAPF32[ptr>>2];case"double":return HEAPF64[ptr>>3];default:abort("invalid type for setValue: "+type)}return null}Module["getValue"]=getValue;var ALLOC_NORMAL=0;var ALLOC_STACK=1;var ALLOC_STATIC=2;var ALLOC_DYNAMIC=3;var ALLOC_NONE=4;Module["ALLOC_NORMAL"]=ALLOC_NORMAL;Module["ALLOC_STACK"]=ALLOC_STACK;Module["ALLOC_STATIC"]=ALLOC_STATIC;Module["ALLOC_DYNAMIC"]=ALLOC_DYNAMIC;Module["ALLOC_NONE"]=ALLOC_NONE;function allocate(slab,types,allocator,ptr){var zeroinit,size;if(typeof slab==="number"){zeroinit=true;size=slab}else{zeroinit=false;size=slab.length}var singleType=typeof types==="string"?types:null;var ret;if(allocator==ALLOC_NONE){ret=ptr}else{ret=[_malloc,Runtime.stackAlloc,Runtime.staticAlloc,Runtime.dynamicAlloc][allocator===undefined?ALLOC_STATIC:allocator](Math.max(size,singleType?1:types.length))}if(zeroinit){var ptr=ret,stop;assert((ret&3)==0);stop=ret+(size&~3);for(;ptr<stop;ptr+=4){HEAP32[ptr>>2]=0}stop=ret+size;while(ptr<stop){HEAP8[ptr++>>0]=0}return ret}if(singleType==="i8"){if(slab.subarray||slab.slice){HEAPU8.set(slab,ret)}else{HEAPU8.set(new Uint8Array(slab),ret)}return ret}var i=0,type,typeSize,previousType;while(i<size){var curr=slab[i];if(typeof curr==="function"){curr=Runtime.getFunctionIndex(curr)}type=singleType||types[i];if(type===0){i++;continue}if(type=="i64")type="i32";setValue(ret+i,curr,type);if(previousType!==type){typeSize=Runtime.getNativeTypeSize(type);previousType=type}i+=typeSize}return ret}Module["allocate"]=allocate;function getMemory(size){if(!staticSealed)return Runtime.staticAlloc(size);if(typeof _sbrk!=="undefined"&&!_sbrk.called||!runtimeInitialized)return Runtime.dynamicAlloc(size);return _malloc(size)}Module["getMemory"]=getMemory;function Pointer_stringify(ptr,length){if(length===0||!ptr)return"";var hasUtf=0;var t;var i=0;while(1){t=HEAPU8[ptr+i>>0];hasUtf|=t;if(t==0&&!length)break;i++;if(length&&i==length)break}if(!length)length=i;var ret="";if(hasUtf<128){var MAX_CHUNK=1024;var curr;while(length>0){curr=String.fromCharCode.apply(String,HEAPU8.subarray(ptr,ptr+Math.min(length,MAX_CHUNK)));ret=ret?ret+curr:curr;ptr+=MAX_CHUNK;length-=MAX_CHUNK}return ret}return Module["UTF8ToString"](ptr)}Module["Pointer_stringify"]=Pointer_stringify;function AsciiToString(ptr){var str="";while(1){var ch=HEAP8[ptr++>>0];if(!ch)return str;str+=String.fromCharCode(ch)}}Module["AsciiToString"]=AsciiToString;function stringToAscii(str,outPtr){return writeAsciiToMemory(str,outPtr,false)}Module["stringToAscii"]=stringToAscii;function UTF8ArrayToString(u8Array,idx){var u0,u1,u2,u3,u4,u5;var str="";while(1){u0=u8Array[idx++];if(!u0)return str;if(!(u0&128)){str+=String.fromCharCode(u0);continue}u1=u8Array[idx++]&63;if((u0&224)==192){str+=String.fromCharCode((u0&31)<<6|u1);continue}u2=u8Array[idx++]&63;if((u0&240)==224){u0=(u0&15)<<12|u1<<6|u2}else{u3=u8Array[idx++]&63;if((u0&248)==240){u0=(u0&7)<<18|u1<<12|u2<<6|u3}else{u4=u8Array[idx++]&63;if((u0&252)==248){u0=(u0&3)<<24|u1<<18|u2<<12|u3<<6|u4}else{u5=u8Array[idx++]&63;u0=(u0&1)<<30|u1<<24|u2<<18|u3<<12|u4<<6|u5}}}if(u0<65536){str+=String.fromCharCode(u0)}else{var ch=u0-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023)}}}Module["UTF8ArrayToString"]=UTF8ArrayToString;function UTF8ToString(ptr){return UTF8ArrayToString(HEAPU8,ptr)}Module["UTF8ToString"]=UTF8ToString;function stringToUTF8Array(str,outU8Array,outIdx,maxBytesToWrite){if(!(maxBytesToWrite>0))return 0;var startIdx=outIdx;var endIdx=outIdx+maxBytesToWrite-1;for(var i=0;i<str.length;++i){var u=str.charCodeAt(i);if(u>=55296&&u<=57343)u=65536+((u&1023)<<10)|str.charCodeAt(++i)&1023;if(u<=127){if(outIdx>=endIdx)break;outU8Array[outIdx++]=u}else if(u<=2047){if(outIdx+1>=endIdx)break;outU8Array[outIdx++]=192|u>>6;outU8Array[outIdx++]=128|u&63}else if(u<=65535){if(outIdx+2>=endIdx)break;outU8Array[outIdx++]=224|u>>12;outU8Array[outIdx++]=128|u>>6&63;outU8Array[outIdx++]=128|u&63}else if(u<=2097151){if(outIdx+3>=endIdx)break;outU8Array[outIdx++]=240|u>>18;outU8Array[outIdx++]=128|u>>12&63;outU8Array[outIdx++]=128|u>>6&63;outU8Array[outIdx++]=128|u&63}else if(u<=67108863){if(outIdx+4>=endIdx)break;outU8Array[outIdx++]=248|u>>24;outU8Array[outIdx++]=128|u>>18&63;outU8Array[outIdx++]=128|u>>12&63;outU8Array[outIdx++]=128|u>>6&63;outU8Array[outIdx++]=128|u&63}else{if(outIdx+5>=endIdx)break;outU8Array[outIdx++]=252|u>>30;outU8Array[outIdx++]=128|u>>24&63;outU8Array[outIdx++]=128|u>>18&63;outU8Array[outIdx++]=128|u>>12&63;outU8Array[outIdx++]=128|u>>6&63;outU8Array[outIdx++]=128|u&63}}outU8Array[outIdx]=0;return outIdx-startIdx}Module["stringToUTF8Array"]=stringToUTF8Array;function stringToUTF8(str,outPtr,maxBytesToWrite){return stringToUTF8Array(str,HEAPU8,outPtr,maxBytesToWrite)}Module["stringToUTF8"]=stringToUTF8;function lengthBytesUTF8(str){var len=0;for(var i=0;i<str.length;++i){var u=str.charCodeAt(i);if(u>=55296&&u<=57343)u=65536+((u&1023)<<10)|str.charCodeAt(++i)&1023;if(u<=127){++len}else if(u<=2047){len+=2}else if(u<=65535){len+=3}else if(u<=2097151){len+=4}else if(u<=67108863){len+=5}else{len+=6}}return len}Module["lengthBytesUTF8"]=lengthBytesUTF8;function UTF16ToString(ptr){var i=0;var str="";while(1){var codeUnit=HEAP16[ptr+i*2>>1];if(codeUnit==0)return str;++i;str+=String.fromCharCode(codeUnit)}}Module["UTF16ToString"]=UTF16ToString;function stringToUTF16(str,outPtr,maxBytesToWrite){if(maxBytesToWrite===undefined){maxBytesToWrite=2147483647}if(maxBytesToWrite<2)return 0;maxBytesToWrite-=2;var startPtr=outPtr;var numCharsToWrite=maxBytesToWrite<str.length*2?maxBytesToWrite/2:str.length;for(var i=0;i<numCharsToWrite;++i){var codeUnit=str.charCodeAt(i);HEAP16[outPtr>>1]=codeUnit;outPtr+=2}HEAP16[outPtr>>1]=0;return outPtr-startPtr}Module["stringToUTF16"]=stringToUTF16;function lengthBytesUTF16(str){return str.length*2}Module["lengthBytesUTF16"]=lengthBytesUTF16;function UTF32ToString(ptr){var i=0;var str="";while(1){var utf32=HEAP32[ptr+i*4>>2];if(utf32==0)return str;++i;if(utf32>=65536){var ch=utf32-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023)}else{str+=String.fromCharCode(utf32)}}}Module["UTF32ToString"]=UTF32ToString;function stringToUTF32(str,outPtr,maxBytesToWrite){if(maxBytesToWrite===undefined){maxBytesToWrite=2147483647}if(maxBytesToWrite<4)return 0;var startPtr=outPtr;var endPtr=startPtr+maxBytesToWrite-4;for(var i=0;i<str.length;++i){var codeUnit=str.charCodeAt(i);if(codeUnit>=55296&&codeUnit<=57343){var trailSurrogate=str.charCodeAt(++i);codeUnit=65536+((codeUnit&1023)<<10)|trailSurrogate&1023}HEAP32[outPtr>>2]=codeUnit;outPtr+=4;if(outPtr+4>endPtr)break}HEAP32[outPtr>>2]=0;return outPtr-startPtr}Module["stringToUTF32"]=stringToUTF32;function lengthBytesUTF32(str){var len=0;for(var i=0;i<str.length;++i){var codeUnit=str.charCodeAt(i);if(codeUnit>=55296&&codeUnit<=57343)++i;len+=4}return len}Module["lengthBytesUTF32"]=lengthBytesUTF32;function demangle(func){var hasLibcxxabi=!!Module["___cxa_demangle"];if(hasLibcxxabi){try{var buf=_malloc(func.length);writeStringToMemory(func.substr(1),buf);var status=_malloc(4);var ret=Module["___cxa_demangle"](buf,0,0,status);if(getValue(status,"i32")===0&&ret){return Pointer_stringify(ret)}}catch(e){}finally{if(buf)_free(buf);if(status)_free(status);if(ret)_free(ret)}}var i=3;var basicTypes={"v":"void","b":"bool","c":"char","s":"short","i":"int","l":"long","f":"float","d":"double","w":"wchar_t","a":"signed char","h":"unsigned char","t":"unsigned short","j":"unsigned int","m":"unsigned long","x":"long long","y":"unsigned long long","z":"..."};var subs=[];var first=true;function dump(x){if(x)Module.print(x);Module.print(func);var pre="";for(var a=0;a<i;a++)pre+=" ";Module.print(pre+"^")}function parseNested(){i++;if(func[i]==="K")i++;var parts=[];while(func[i]!=="E"){if(func[i]==="S"){i++;var next=func.indexOf("_",i);var num=func.substring(i,next)||0;parts.push(subs[num]||"?");i=next+1;continue}if(func[i]==="C"){parts.push(parts[parts.length-1]);i+=2;continue}var size=parseInt(func.substr(i));var pre=size.toString().length;if(!size||!pre){i--;break}var curr=func.substr(i+pre,size);parts.push(curr);subs.push(curr);i+=pre+size}i++;return parts}function parse(rawList,limit,allowVoid){limit=limit||Infinity;var ret="",list=[];function flushList(){return"("+list.join(", ")+")"}var name;if(func[i]==="N"){name=parseNested().join("::");limit--;if(limit===0)return rawList?[name]:name}else{if(func[i]==="K"||first&&func[i]==="L")i++;var size=parseInt(func.substr(i));if(size){var pre=size.toString().length;name=func.substr(i+pre,size);i+=pre+size}}first=false;if(func[i]==="I"){i++;var iList=parse(true);var iRet=parse(true,1,true);ret+=iRet[0]+" "+name+"<"+iList.join(", ")+">"}else{ret=name}paramLoop:while(i<func.length&&limit-->0){var c=func[i++];if(c in basicTypes){list.push(basicTypes[c])}else{switch(c){case"P":list.push(parse(true,1,true)[0]+"*");break;case"R":list.push(parse(true,1,true)[0]+"&");break;case"L":{i++;var end=func.indexOf("E",i);var size=end-i;list.push(func.substr(i,size));i+=size+2;break};case"A":{var size=parseInt(func.substr(i));i+=size.toString().length;if(func[i]!=="_")throw"?";i++;list.push(parse(true,1,true)[0]+" ["+size+"]");break};case"E":break paramLoop;default:ret+="?"+c;break paramLoop}}}if(!allowVoid&&list.length===1&&list[0]==="void")list=[];if(rawList){if(ret){list.push(ret+"?")}return list}else{return ret+flushList()}}var parsed=func;try{if(func=="Object._main"||func=="_main"){return"main()"}if(typeof func==="number")func=Pointer_stringify(func);if(func[0]!=="_")return func;if(func[1]!=="_")return func;if(func[2]!=="Z")return func;switch(func[3]){case"n":return"operator new()";case"d":return"operator delete()"}parsed=parse()}catch(e){parsed+="?"}if(parsed.indexOf("?")>=0&&!hasLibcxxabi){Runtime.warnOnce("warning: a problem occurred in builtin C++ name demangling; build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling")}return parsed}function demangleAll(text){return text.replace(/__Z[\w\d_]+/g,(function(x){var y=demangle(x);return x===y?x:x+" ["+y+"]"}))}function jsStackTrace(){var err=new Error;if(!err.stack){try{throw new Error(0)}catch(e){err=e}if(!err.stack){return"(no stack trace available)"}}return err.stack.toString()}function stackTrace(){return demangleAll(jsStackTrace())}Module["stackTrace"]=stackTrace;var PAGE_SIZE=4096;function alignMemoryPage(x){if(x%4096>0){x+=4096-x%4096}return x}var HEAP;var HEAP8,HEAPU8,HEAP16,HEAPU16,HEAP32,HEAPU32,HEAPF32,HEAPF64;var STATIC_BASE=0,STATICTOP=0,staticSealed=false;var STACK_BASE=0,STACKTOP=0,STACK_MAX=0;var DYNAMIC_BASE=0,DYNAMICTOP=0;function abortOnCannotGrowMemory(){abort("Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value "+TOTAL_MEMORY+", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which adjusts the size at runtime but prevents some optimizations, (3) set Module.TOTAL_MEMORY to a higher value before the program runs, or if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 ")}function enlargeMemory(){abortOnCannotGrowMemory()}var TOTAL_STACK=Module["TOTAL_STACK"]||5242880;var TOTAL_MEMORY=Module["TOTAL_MEMORY"]||16777216;var totalMemory=64*1024;while(totalMemory<TOTAL_MEMORY||totalMemory<2*TOTAL_STACK){if(totalMemory<16*1024*1024){totalMemory*=2}else{totalMemory+=16*1024*1024}}if(totalMemory!==TOTAL_MEMORY){TOTAL_MEMORY=totalMemory}assert(typeof Int32Array!=="undefined"&&typeof Float64Array!=="undefined"&&!!(new Int32Array(1))["subarray"]&&!!(new Int32Array(1))["set"],"JS engine does not provide full typed array support");var buffer;buffer=new ArrayBuffer(TOTAL_MEMORY);HEAP8=new Int8Array(buffer);HEAP16=new Int16Array(buffer);HEAP32=new Int32Array(buffer);HEAPU8=new Uint8Array(buffer);HEAPU16=new Uint16Array(buffer);HEAPU32=new Uint32Array(buffer);HEAPF32=new Float32Array(buffer);HEAPF64=new Float64Array(buffer);HEAP32[0]=255;assert(HEAPU8[0]===255&&HEAPU8[3]===0,"Typed arrays 2 must be run on a little-endian system");Module["HEAP"]=HEAP;Module["buffer"]=buffer;Module["HEAP8"]=HEAP8;Module["HEAP16"]=HEAP16;Module["HEAP32"]=HEAP32;Module["HEAPU8"]=HEAPU8;Module["HEAPU16"]=HEAPU16;Module["HEAPU32"]=HEAPU32;Module["HEAPF32"]=HEAPF32;Module["HEAPF64"]=HEAPF64;function callRuntimeCallbacks(callbacks){while(callbacks.length>0){var callback=callbacks.shift();if(typeof callback=="function"){callback();continue}var func=callback.func;if(typeof func==="number"){if(callback.arg===undefined){Runtime.dynCall("v",func)}else{Runtime.dynCall("vi",func,[callback.arg])}}else{func(callback.arg===undefined?null:callback.arg)}}}var __ATPRERUN__=[];var __ATINIT__=[];var __ATMAIN__=[];var __ATEXIT__=[];var __ATPOSTRUN__=[];var runtimeInitialized=false;var runtimeExited=false;function preRun(){if(Module["preRun"]){if(typeof Module["preRun"]=="function")Module["preRun"]=[Module["preRun"]];while(Module["preRun"].length){addOnPreRun(Module["preRun"].shift())}}callRuntimeCallbacks(__ATPRERUN__)}function ensureInitRuntime(){if(runtimeInitialized)return;runtimeInitialized=true;callRuntimeCallbacks(__ATINIT__)}function preMain(){callRuntimeCallbacks(__ATMAIN__)}function exitRuntime(){callRuntimeCallbacks(__ATEXIT__);runtimeExited=true}function postRun(){if(Module["postRun"]){if(typeof Module["postRun"]=="function")Module["postRun"]=[Module["postRun"]];while(Module["postRun"].length){addOnPostRun(Module["postRun"].shift())}}callRuntimeCallbacks(__ATPOSTRUN__)}function addOnPreRun(cb){__ATPRERUN__.unshift(cb)}Module["addOnPreRun"]=addOnPreRun;function addOnInit(cb){__ATINIT__.unshift(cb)}Module["addOnInit"]=addOnInit;function addOnPreMain(cb){__ATMAIN__.unshift(cb)}Module["addOnPreMain"]=addOnPreMain;function addOnExit(cb){__ATEXIT__.unshift(cb)}Module["addOnExit"]=addOnExit;function addOnPostRun(cb){__ATPOSTRUN__.unshift(cb)}Module["addOnPostRun"]=addOnPostRun;function intArrayFromString(stringy,dontAddNull,length){var len=length>0?length:lengthBytesUTF8(stringy)+1;var u8array=new Array(len);var numBytesWritten=stringToUTF8Array(stringy,u8array,0,u8array.length);if(dontAddNull)u8array.length=numBytesWritten;return u8array}Module["intArrayFromString"]=intArrayFromString;function intArrayToString(array){var ret=[];for(var i=0;i<array.length;i++){var chr=array[i];if(chr>255){chr&=255}ret.push(String.fromCharCode(chr))}return ret.join("")}Module["intArrayToString"]=intArrayToString;function writeStringToMemory(string,buffer,dontAddNull){var array=intArrayFromString(string,dontAddNull);var i=0;while(i<array.length){var chr=array[i];HEAP8[buffer+i>>0]=chr;i=i+1}}Module["writeStringToMemory"]=writeStringToMemory;function writeArrayToMemory(array,buffer){for(var i=0;i<array.length;i++){HEAP8[buffer++>>0]=array[i]}}Module["writeArrayToMemory"]=writeArrayToMemory;function writeAsciiToMemory(str,buffer,dontAddNull){for(var i=0;i<str.length;++i){HEAP8[buffer++>>0]=str.charCodeAt(i)}if(!dontAddNull)HEAP8[buffer>>0]=0}Module["writeAsciiToMemory"]=writeAsciiToMemory;function unSign(value,bits,ignore){if(value>=0){return value}return bits<=32?2*Math.abs(1<<bits-1)+value:Math.pow(2,bits)+value}function reSign(value,bits,ignore){if(value<=0){return value}var half=bits<=32?Math.abs(1<<bits-1):Math.pow(2,bits-1);if(value>=half&&(bits<=32||value>half)){value=-2*half+value}return value}if(!Math["imul"]||Math["imul"](4294967295,5)!==-5)Math["imul"]=function imul(a,b){var ah=a>>>16;var al=a&65535;var bh=b>>>16;var bl=b&65535;return al*bl+(ah*bl+al*bh<<16)|0};Math.imul=Math["imul"];if(!Math["clz32"])Math["clz32"]=(function(x){x=x>>>0;for(var i=0;i<32;i++){if(x&1<<31-i)return i}return 32});Math.clz32=Math["clz32"];var Math_abs=Math.abs;var Math_cos=Math.cos;var Math_sin=Math.sin;var Math_tan=Math.tan;var Math_acos=Math.acos;var Math_asin=Math.asin;var Math_atan=Math.atan;var Math_atan2=Math.atan2;var Math_exp=Math.exp;var Math_log=Math.log;var Math_sqrt=Math.sqrt;var Math_ceil=Math.ceil;var Math_floor=Math.floor;var Math_pow=Math.pow;var Math_imul=Math.imul;var Math_fround=Math.fround;var Math_min=Math.min;var Math_clz32=Math.clz32;var runDependencies=0;var runDependencyWatcher=null;var dependenciesFulfilled=null;function getUniqueRunDependency(id){return id}function addRunDependency(id){runDependencies++;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies)}}Module["addRunDependency"]=addRunDependency;function removeRunDependency(id){runDependencies--;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies)}if(runDependencies==0){if(runDependencyWatcher!==null){clearInterval(runDependencyWatcher);runDependencyWatcher=null}if(dependenciesFulfilled){var callback=dependenciesFulfilled;dependenciesFulfilled=null;callback()}}}Module["removeRunDependency"]=removeRunDependency;Module["preloadedImages"]={};Module["preloadedAudios"]={};var memoryInitializer=null;var ASM_CONSTS=[];STATIC_BASE=8;STATICTOP=STATIC_BASE+62208;__ATINIT__.push({func:(function(){__GLOBAL__sub_I_zxing_js_cpp()})},{func:(function(){__GLOBAL__sub_I_CharacterSetECI_cpp()})},{func:(function(){__GLOBAL__sub_I_GlobalHistogramBinarizer_cpp()})},{func:(function(){__GLOBAL__sub_I_GenericGF_cpp()})},{func:(function(){__GLOBAL__sub_I_Version_cpp()})},{func:(function(){__GLOBAL__sub_I_DecodeHints_cpp()})},{func:(function(){__GLOBAL__sub_I_Code39Reader_cpp()})},{func:(function(){__GLOBAL__sub_I_Code93Reader_cpp()})},{func:(function(){__GLOBAL__sub_I_ITFReader_cpp()})},{func:(function(){__GLOBAL__sub_I_UPCEANReader_cpp()})},{func:(function(){__GLOBAL__sub_I_UPCEReader_cpp()})},{func:(function(){__GLOBAL__sub_I_DecodedBitStreamParser_cpp()})},{func:(function(){__GLOBAL__sub_I_ModulusGF_cpp()})},{func:(function(){__GLOBAL__sub_I_LinesSampler_cpp()})},{func:(function(){__GLOBAL__sub_I_DataMask_cpp()})},{func:(function(){__GLOBAL__sub_I_Mode_cpp()})},{func:(function(){__GLOBAL__sub_I_ErrorCorrectionLevel_cpp()})},{func:(function(){__GLOBAL__sub_I_Version_cpp733()})},{func:(function(){__GLOBAL__sub_I_bind_cpp()})});allocate([4,138,0,0,254,176,0,0,0,7,0,0,0,0,0,0,4,138,0,0,228,176,0,0,8,0,0,0,0,0,0,0,4,138,0,0,17,177,0,0,96,1,0,0,0,0,0,0,220,137,0,0,58,177,0,0,4,138,0,0,37,177,0,0,56,0,0,0,0,0,0,0,4,138,0,0,75,177,0,0,56,0,0,0,0,0,0,0,4,138,0,0,93,177,0,0,56,0,0,0,0,0,0,0,4,138,0,0,140,177,0,0,40,3,0,0,0,0,0,0,4,138,0,0,168,177,0,0,56,0,0,0,0,0,0,0,4,138,0,0,187,177,0,0,56,0,0,0,0,0,0,0,4,138,0,0,210,177,0,0,24,0,0,0,0,0,0,0,4,138,0,0,238,177,0,0,56,0,0,0,0,0,0,0,4,138,0,0,0,178,0,0,56,0,0,0,0,0,0,0,4,138,0,0,20,178,0,0,128,0,0,0,0,0,0,0,4,138,0,0,56,178,0,0,208,0,0,0,0,0,0,0,4,138,0,0,82,178,0,0,8,0,0,0,0,0,0,0,4,138,0,0,117,178,0,0,8,0,0,0,0,0,0,0,4,138,0,0,148,178,0,0,40,3,0,0,0,0,0,0,4,138,0,0,70,179,0,0,56,0,0,0,0,0,0,0,4,138,0,0,100,179,0,0,56,0,0,0,0,0,0,0,4,138,0,0,129,179,0,0,24,0,0,0,0,0,0,0,4,138,0,0,155,179,0,0,96,1,0,0,0,0,0,0,4,138,0,0,189,179,0,0,56,0,0,0,0,0,0,0,4,138,0,0,215,179,0,0,128,1,0,0,0,0,0,0,4,138,0,0,4,180,0,0,56,0,0,0,0,0,0,0,4,138,0,0,42,180,0,0,248,2,0,0,0,0,0,0,44,138,0,0,72,180,0,0,0,0,0,0,1,0,0,0,144,3,0,0,0,4,0,0,44,138,0,0,113,180,0,0,1,0,0,0,2,0,0,0,8,3,0,0,2,0,0,0,128,1,0,0,2,12,0,0,4,138,0,0,147,180,0,0,40,3,0,0,0,0,0,0,4,138,0,0,175,180,0,0,120,2,0,0,0,0,0,0,4,138,0,0,204,180,0,0,120,2,0,0,0,0,0,0,4,138,0,0,233,180,0,0,120,2,0,0,0,0,0,0,4,138,0,0,5,181,0,0,120,2,0,0,0,0,0,0,4,138,0,0,33,181,0,0,152,2,0,0,0,0,0,0,4,138,0,0,60,181,0,0,152,2,0,0,0,0,0,0,4,138,0,0,86,181,0,0,120,2,0,0,0,0,0,0,4,138,0,0,110,181,0,0,120,2,0,0,0,0,0,0,4,138,0,0,147,181,0,0,120,2,0,0,0,0,0,0,4,138,0,0,186,181,0,0,40,3,0,0,0,0,0,0,4,138,0,0,212,181,0,0,152,2,0,0,0,0,0,0,4,138,0,0,238,181,0,0,120,2,0,0,0,0,0,0,4,138,0,0,10,182,0,0,152,2,0,0,0,0,0,0,4,138,0,0,90,182,0,0,56,0,0,0,0,0,0,0,4,138,0,0,130,182,0,0,40,3,0,0,0,0,0,0,4,138,0,0,160,182,0,0,56,0,0,0,0,0,0,0,4,138,0,0,230,182,0,0,56,0,0,0,0,0,0,0,4,138,0,0,14,183,0,0,56,0,0,0,0,0,0,0,4,138,0,0,39,183,0,0,40,3,0,0,0,0,0,0,4,138,0,0,69,183,0,0,56,0,0,0,0,0,0,0,4,138,0,0,93,183,0,0,56,0,0,0,0,0,0,0,4,138,0,0,109,183,0,0,56,0,0,0,0,0,0,0,4,138,0,0,125,183,0,0,56,0,0,0,0,0,0,0,4,138,0,0,98,206,0,0,24,0,0,0,0,0,0,0,4,138,0,0,89,202,0,0,24,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,84,138,0,0,235,200,0,0,0,0,0,0,240,0,0,0,220,137,0,0,98,198,0,0,4,138,0,0,32,199,0,0,56,0,0,0,0,0,0,0,4,138,0,0,67,199,0,0,56,0,0,0,0,0,0,0,4,138,0,0,102,199,0,0,72,3,0,0,0,0,0,0,4,138,0,0,133,199,0,0,72,3,0,0,0,0,0,0,4,138,0,0,167,199,0,0,56,0,0,0,0,0,0,0,4,138,0,0,200,199,0,0,216,2,0,0,0,0,0,0,4,138,0,0,229,199,0,0,216,2,0,0,0,0,0,0,4,138,0,0,2,200,0,0,216,2,0,0,0,0,0,0,4,138,0,0,31,200,0,0,216,2,0,0,0,0,0,0,4,138,0,0,60,200,0,0,216,2,0,0,0,0,0,0,4,138,0,0,89,200,0,0,216,2,0,0,0,0,0,0,4,138,0,0,118,200,0,0,216,2,0,0,0,0,0,0,4,138,0,0,147,200,0,0,216,2,0,0,0,0,0,0,4,138,0,0,176,200,0,0,56,0,0,0,0,0,0,0,4,138,0,0,202,200,0,0,56,0,0,0,0,0,0,0,4,138,0,0,15,201,0,0,56,0,0,0,0,0,0,0,4,138,0,0,59,201,0,0,56,0,0,0,0,0,0,0,4,138,0,0,91,201,0,0,56,0,0,0,0,0,0,0,4,138,0,0,120,201,0,0,56,0,0,0,0,0,0,0,4,138,0,0,161,201,0,0,72,3,0,0,0,0,0,0,4,138,0,0,192,201,0,0,56,0,0,0,0,0,0,0,4,138,0,0,241,201,0,0,56,0,0,0,0,0,0,0,4,138,0,0,4,202,0,0,56,0,0,0,0,0,0,0,4,138,0,0,35,202,0,0,56,0,0,0,0,0,0,0,4,138,0,0,73,202,0,0,56,0,0,0,0,0,0,0,4,138,0,0,121,202,0,0,56,0,0,0,0,0,0,0,4,138,0,0,145,202,0,0,56,0,0,0,0,0,0,0,4,138,0,0,164,202,0,0,56,0,0,0,0,0,0,0,4,138,0,0,195,202,0,0,56,0,0,0,0,0,0,0,4,138,0,0,220,202,0,0,56,0,0,0,0,0,0,0,4,138,0,0,248,202,0,0,56,0,0,0,0,0,0,0,4,138,0,0,16,203,0,0,56,0,0,0,0,0,0,0,4,138,0,0,75,205,0,0,72,8,0,0,0,0,0,0,4,138,0,0,141,205,0,0,80,8,0,0,0,0,0,0,4,138,0,0,250,205,0,0,56,0,0,0,0,0,0,0,4,138,0,0,15,206,0,0,56,0,0,0,0,0,0,0,4,138,0,0,33,206,0,0,56,0,0,0,0,0,0,0,4,138,0,0,77,206,0,0,56,0,0,0,0,0,0,0,4,138,0,0,126,206,0,0,56,0,0,0,0,0,0,0,4,138,0,0,190,207,0,0,56,0,0,0,0,0,0,0,4,138,0,0,213,207,0,0,56,0,0,0,0,0,0,0,4,138,0,0,237,207,0,0,88,5,0,0,0,0,0,0,44,138,0,0,207,213,0,0,0,0,0,0,1,0,0,0,232,6,0,0,0,0,0,0,44,138,0,0,144,213,0,0,0,0,0,0,1,0,0,0,232,6,0,0,0,0,0,0,44,138,0,0,43,213,0,0,0,0,0,0,1,0,0,0,232,6,0,0,0,0,0,0,220,137,0,0,24,213,0,0,220,137,0,0,249,212,0,0,220,137,0,0,32,212,0,0,220,137,0,0,1,212,0,0,220,137,0,0,226,211,0,0,220,137,0,0,195,211,0,0,220,137,0,0,164,211,0,0,220,137,0,0,63,212,0,0,220,137,0,0,94,212,0,0,220,137,0,0,125,212,0,0,220,137,0,0,156,212,0,0,220,137,0,0,187,212,0,0,220,137,0,0,218,212,0,0,220,137,0,0,106,213,0,0,4,138,0,0,14,214,0,0,0,7,0,0,0,0,0,0,220,137,0,0,27,214,0,0,4,138,0,0,40,214,0,0,0,7,0,0,0,0,0,0,220,137,0,0,58,214,0,0,4,138,0,0,71,214,0,0,0,7,0,0,0,0,0,0,4,138,0,0,83,214,0,0,24,7,0,0,0,0,0,0,4,138,0,0,116,214,0,0,48,7,0,0,0,0,0,0,4,138,0,0,186,214,0,0,48,7,0,0,0,0,0,0,4,138,0,0,150,214,0,0,80,7,0,0,0,0,0,0,4,138,0,0,220,214,0,0,48,7,0,0,0,0,0,0,192,137,0,0,122,207,0,0,192,137,0,0,4,215,0,0,192,137,0,0,84,207,0,0,192,137,0,0,86,207,0,0,84,138,0,0,7,215,0,0,1,0,0,0,152,7,0,0,192,137,0,0,96,207,0,0,192,137,0,0,82,207,0,0,192,137,0,0,116,207,0,0,192,137,0,0,118,207,0,0,192,137,0,0,98,207,0,0,192,137,0,0,100,207,0,0,192,137,0,0,68,239,0,0,192,137,0,0,104,207,0,0,192,137,0,0,92,207,0,0,192,137,0,0,88,207,0,0,4,138,0,0,11,215,0,0,64,7,0,0,0,0,0,0,4,138,0,0,48,215,0,0,64,7,0,0,0,0,0,0,4,138,0,0,192,232,0,0,120,15,0,0,0,0,0,0,220,137,0,0,218,232,0,0,4,138,0,0,236,232,0,0,48,8,0,0,0,0,0,0,220,137,0,0,22,233,0,0,44,138,0,0,71,233,0,0,0,0,0,0,1,0,0,0,56,8,0,0,3,244,255,255,4,138,0,0,118,233,0,0,144,15,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,138,0,0,242,233,0,0,112,15,0,0,0,0,0,0,44,138,0,0,8,234,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,160,14,0,0,2,0,0,0,44,138,0,0,26,234,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,168,14,0,0,2,0,0,0,44,138,0,0,60,234,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,168,14,0,0,2,0,0,0,44,138,0,0,95,234,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,168,14,0,0,2,0,0,0,4,138,0,0,130,234,0,0,240,8,0,0,0,0,0,0,4,138,0,0,164,234,0,0,240,8,0,0,0,0,0,0,44,138,0,0,199,234,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,168,14,0,0,2,0,0,0,4,138,0,0,233,234,0,0,128,8,0,0,0,0,0,0,4,138,0,0,255,234,0,0,128,8,0,0,0,0,0,0,4,138,0,0,19,235,0,0,128,8,0,0,0,0,0,0,44,138,0,0,39,235,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,160,14,0,0,2,0,0,0,4,138,0,0,57,235,0,0,128,8,0,0,0,0,0,0,4,138,0,0,78,235,0,0,128,8,0,0,0,0,0,0,44,138,0,0,99,235,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,176,14,0,0,0,0,0,0,44,138,0,0,167,235,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,200,14,0,0,0,0,0,0,44,138,0,0,235,235,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,224,14,0,0,0,0,0,0,44,138,0,0,47,236,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,248,14,0,0,0,0,0,0,44,138,0,0,115,236,0,0,0,0,0,0,3,0,0,0,128,8,0,0,2,0,0,0,16,15,0,0,2,0,0,0,24,15,0,0,0,8,0,0,44,138,0,0,184,236,0,0,0,0,0,0,3,0,0,0,128,8,0,0,2,0,0,0,16,15,0,0,2,0,0,0,32,15,0,0,0,8,0,0,44,138,0,0,253,236,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,40,15,0,0,0,8,0,0,44,138,0,0,66,237,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,40,15,0,0,0,8,0,0,44,138,0,0,135,237,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,48,15,0,0,2,0,0,0,44,138,0,0,163,237,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,48,15,0,0,2,0,0,0,44,138,0,0,191,237,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,48,15,0,0,2,0,0,0,44,138,0,0,219,237,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,48,15,0,0,2,0,0,0,44,138,0,0,247,237,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,56,15,0,0,0,0,0,0,44,138,0,0,61,238,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,64,15,0,0,0,0,0,0,44,138,0,0,131,238,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,72,15,0,0,0,0,0,0,44,138,0,0,201,238,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,80,15,0,0,0,0,0,0,44,138,0,0,15,239,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,88,15,0,0,2,0,0,0,44,138,0,0,36,239,0,0,0,0,0,0,2,0,0,0,128,8,0,0,2,0,0,0,88,15,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,220,137,0,0,128,242,0,0,220,137,0,0,105,242,0,0,44,138,0,0,83,242,0,0,0,0,0,0,1,0,0,0,104,15,0,0,0,0,0,0,44,138,0,0,36,242,0,0,0,0,0,0,1,0,0,0,104,15,0,0,0,0,0,0,44,138,0,0,14,242,0,0,0,0,0,0,1,0,0,0,96,15,0,0,0,0,0,0,44,138,0,0,223,241,0,0,0,0,0,0,1,0,0,0,96,15,0,0,0,0,0,0,220,137,0,0,204,241,0,0,220,137,0,0,170,241,0,0,220,137,0,0,136,241,0,0,220,137,0,0,115,241,0,0,220,137,0,0,94,241,0,0,220,137,0,0,69,241,0,0,220,137,0,0,44,241,0,0,220,137,0,0,19,241,0,0,220,137,0,0,250,240,0,0,220,137,0,0,226,240,0,0,220,137,0,0,245,241,0,0,220,137,0,0,58,242,0,0,220,137,0,0,149,242,0,0,4,138,0,0,174,242,0,0,8,7,0,0,0,0,0,0,220,137,0,0,197,242,0,0,4,138,0,0,222,242,0,0,136,15,0,0,0,0,0,0,0,0,0,0,40,0,0,0,42,0,0,0,43,0,0,0,42,0,0,0,42,0,0,0,42,0,0,0,42,0,0,0,43,0,0,0,44,0,0,0,45,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,44,0,0,0,45,0,0,0,0,0,0,0,80,0,0,0,46,0,0,0,47,0,0,0,0,0,0,0,96,0,0,0,48,0,0,0,49,0,0,0,0,0,0,0,112,0,0,0,50,0,0,0,51,0,0,0,42,0,0,0,42,0,0,0,0,0,0,0,128,0,0,0,52,0,0,0,53,0,0,0,42,0,0,0,42,0,0,0,42,0,0,0,0,0,0,0,144,0,0,0,54,0,0,0,55,0,0,0,0,0,0,0,160,0,0,0,56,0,0,0,57,0,0,0,46,0,0,0,0,0,0,0,176,0,0,0,58,0,0,0,59,0,0,0,0,0,0,0,192,0,0,0,60,0,0,0,61,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,30,0,0,0,1,0,0,0,0,0,0,0,208,0,0,0,62,0,0,0,63,0,0,0,43,0,0,0,47,0,0,0,43,0,0,0,0,0,0,0,224,0,0,0,64,0,0,0,65,0,0,0,43,0,0,0,48,0,0,0,44,0,0,0,0,0,0,0,240,0,0,0,66,0,0,0,67,0,0,0,46,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,68,0,0,0,69,0,0,0,46,0,0,0,94,203,0,0,0,0,0,0,16,1,0,0,70,0,0,0,71,0,0,0,45,0,0,0,44,0,0,0,0,0,0,0,32,1,0,0,72,0,0,0,73,0,0,0,42,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,48,1,0,0,74,0,0,0,75,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,1,0,0,76,0,0,0,77,0,0,0,46,0,0,0,0,0,0,0,80,1,0,0,78,0,0,0,79,0,0,0,43,0,0,0,43,0,0,0,49,0,0,0,43,0,0,0,50,0,0,0,51,0,0,0,52,0,0,0,0,0,0,0,96,1,0,0,80,0,0,0,81,0,0,0,42,0,0,0,42,0,0,0,42,0,0,0,42,0,0,0,43,0,0,0,44,0,0,0,45,0,0,0,0,0,0,0,112,1,0,0,82,0,0,0,83,0,0,0,42,0,0,0,44,0,0,0,0,0,0,0,144,1,0,0,84,0,0,0,85,0,0,0,42,0,0,0,43,0,0,0,0,0,0,0,160,1,0,0,86,0,0,0,87,0,0,0,44,0,0,0,0,0,0,0,184,1,0,0,88,0,0,0,89,0,0,0,45,0,0,0,45,0,0,0,45,0,0,0,244,255,255,255,184,1,0,0,90,0,0,0,91,0,0,0,42,0,0,0,46,0,0,0,0,0,0,0,216,1,0,0,92,0,0,0,93,0,0,0,46,0,0,0,46,0,0,0,0,0,0,0,232,1,0,0,94,0,0,0,95,0,0,0,45,0,0,0,47,0,0,0,48,0,0,0,0,0,0,0,248,1,0,0,96,0,0,0,97,0,0,0,45,0,0,0,47,0,0,0,49,0,0,0,0,0,0,0,8,2,0,0,98,0,0,0,99,0,0,0,45,0,0,0,47,0,0,0,50,0,0,0,0,0,0,0,24,2,0,0,100,0,0,0,101,0,0,0,45,0,0,0,47,0,0,0,51,0,0,0,0,0,0,0,40,2,0,0,102,0,0,0,103,0,0,0,45,0,0,0,47,0,0,0,52,0,0,0,47,0,0,0,42,0,0,0,43,0,0,0,47,0,0,0,53,0,0,0,0,0,0,0,56,2,0,0,104,0,0,0,105,0,0,0,45,0,0,0,47,0,0,0,52,0,0,0,47,0,0,0,44,0,0,0,43,0,0,0,47,0,0,0,54,0,0,0,0,0,0,0,72,2,0,0,106,0,0,0,107,0,0,0,45,0,0,0,47,0,0,0,53,0,0,0,0,0,0,0,88,2,0,0,108,0,0,0,109,0,0,0,45,0,0,0,47,0,0,0,54,0,0,0,0,0,0,0,104,2,0,0,110,0,0,0,111,0,0,0,45,0,0,0,47,0,0,0,55,0,0,0,0,0,0,0,120,2,0,0,112,0,0,0,113,0,0,0,45,0,0,0,47,0,0,0,42,0,0,0,0,0,0,0,136,2,0,0,114,0,0,0,115,0,0,0,45,0,0,0,56,0,0,0,57,0,0,0,47,0,0,0,45,0,0,0,46,0,0,0,47,0,0,0,55,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,152,2,0,0,116,0,0,0,117,0,0,0,45,0,0,0,47,0,0,0,52,0,0,0,47,0,0,0,42,0,0,0,43,0,0,0,47,0,0,0,42,0,0,0,0,0,0,0,168,2,0,0,118,0,0,0,119,0,0,0,45,0,0,0,47,0,0,0,52,0,0,0,48,0,0,0,47,0,0,0,43,0,0,0,48,0,0,0,56,0,0,0,227,10,0,0,94,2,1,0,122,2,1,0,158,2,1,0,188,2,1,0,242,2,1,0,244,2,1,0,46,3,1,0,78,3,1,0,92,3,1,0,150,3,1,0,166,3,1,0,172,3,1,0,34,4,1,0,40,4,1,0,54,4,1,0,66,4,1,0,68,4,1,0,72,4,1,0,80,4,1,0,94,4,1,0,102,4,1,0,108,4,1,0,122,4,1,0,130,4,1,0,158,4,1,0,160,4,1,0,188,4,1,0,198,4,1,0,216,4,1,0,238,4,1,0,242,4,1,0,244,4,1,0,4,5,1,0,8,5,1,0,16,5,1,0,30,5,1,0,32,5,1,0,60,5,1,0,64,5,1,0,120,5,1,0,134,5,1,0,140,5,1,0,152,5,1,0,176,5,1,0,190,5,1,0,206,5,1,0,220,5,1,0,226,5,1,0,228,5,1,0,232,5,1,0,246,5,1,0,46,6,1,0,78,6,1,0,92,6,1,0,142,6,1,0,156,6,1,0,184,6,1,0,222,6,1,0,250,6,1,0,22,7,1,0,38,7,1,0,44,7,1,0,70,7,1,0,76,7,1,0,88,7,1,0,110,7,1,0,146,7,1,0,148,7,1,0,162,7,1,0,164,7,1,0,168,7,1,0,182,7,1,0,34,8,1,0,40,8,1,0,66,8,1,0,72,8,1,0,80,8,1,0,94,8,1,0,102,8,1,0,108,8,1,0,122,8,1,0,130,8,1,0,132,8,1,0,144,8,1,0,158,8,1,0,160,8,1,0,188,8,1,0,198,8,1,0,204,8,1,0,216,8,1,0,238,8,1,0,242,8,1,0,244,8,1,0,2,9,1,0,8,9,1,0,30,9,1,0,32,9,1,0,60,9,1,0,64,9,1,0,120,9,1,0,134,9,1,0,152,9,1,0,176,9,1,0,190,9,1,0,206,9,1,0,220,9,1,0,226,9,1,0,228,9,1,0,232,9,1,0,246,9,1,0,8,10,1,0,16,10,1,0,30,10,1,0,32,10,1,0,60,10,1,0,64,10,1,0,120,10,1,0,240,10,1,0,6,11,1,0,12,11,1,0,24,11,1,0,48,11,1,0,62,11,1,0,96,11,1,0,124,11,1,0,142,11,1,0,156,11,1,0,184,11,1,0,194,11,1,0,196,11,1,0,200,11,1,0,208,11,1,0,222,11,1,0,230,11,1,0,236,11,1,0,46,12,1,0,78,12,1,0,92,12,1,0,98,12,1,0,100,12,1,0,104,12,1,0,118,12,1,0,142,12,1,0,156,12,1,0,184,12,1,0,194,12,1,0,196,12,1,0,200,12,1,0,208,12,1,0,222,12,1,0,230,12,1,0,236,12,1,0,250,12,1,0,14,13,1,0,28,13,1,0,56,13,1,0,112,13,1,0,126,13,1,0,130,13,1,0,132,13,1,0,136,13,1,0,144,13,1,0,158,13,1,0,160,13,1,0,188,13,1,0,198,13,1,0,204,13,1,0,216,13,1,0,238,13,1,0,242,13,1,0,244,13,1,0,22,14,1,0,38,14,1,0,44,14,1,0,70,14,1,0,88,14,1,0,110,14,1,0,134,14,1,0,140,14,1,0,152,14,1,0,176,14,1,0,190,14,1,0,206,14,1,0,220,14,1,0,10,15,1,0,18,15,1,0,20,15,1,0,34,15,1,0,40,15,1,0,54,15,1,0,66,15,1,0,68,15,1,0,72,15,1,0,80,15,1,0,94,15,1,0,102,15,1,0,108,15,1,0,178,15,1,0,180,15,1,0,34,16,1,0,40,16,1,0,66,16,1,0,72,16,1,0,80,16,1,0,94,16,1,0,122,16,1,0,130,16,1,0,132,16,1,0,144,16,1,0,158,16,1,0,160,16,1,0,188,16,1,0,198,16,1,0,204,16,1,0,216,16,1,0,238,16,1,0,242,16,1,0,244,16,1,0,2,17,1,0,30,17,1,0,32,17,1,0,60,17,1,0,64,17,1,0,120,17,1,0,134,17,1,0,152,17,1,0,176,17,1,0,190,17,1,0,206,17,1,0,220,17,1,0,226,17,1,0,228,17,1,0,232,17,1,0,246,17,1,0,8,18,1,0,30,18,1,0,32,18,1,0,120,18,1,0,240,18,1,0,12,19,1,0,48,19,1,0,62,19,1,0,96,19,1,0,124,19,1,0,142,19,1,0,156,19,1,0,184,19,1,0,194,19,1,0,200,19,1,0,208,19,1,0,222,19,1,0,230,19,1,0,236,19,1,0,8,20,1,0,16,20,1,0,30,20,1,0,32,20,1,0,60,20,1,0,64,20,1,0,120,20,1,0,240,20,1,0,224,21,1,0,12,22,1,0,24,22,1,0,48,22,1,0,62,22,1,0,96,22,1,0,124,22,1,0,192,22,1,0,248,22,1,0,28,23,1,0,56,23,1,0,112,23,1,0,126,23,1,0,130,23,1,0,132,23,1,0,136,23,1,0,144,23,1,0,158,23,1,0,160,23,1,0,188,23,1,0,198,23,1,0,204,23,1,0,216,23,1,0,238,23,1,0,46,24,1,0,52,24,1,0,78,24,1,0,92,24,1,0,98,24,1,0,100,24,1,0,104,24,1,0,118,24,1,0,142,24,1,0,156,24,1,0,184,24,1,0,194,24,1,0,200,24,1,0,208,24,1,0,222,24,1,0,230,24,1,0,236,24,1,0,250,24,1,0,14,25,1,0,28,25,1,0,56,25,1,0,112,25,1,0,126,25,1,0,130,25,1,0,132,25,1,0,144,25,1,0,158,25,1,0,160,25,1,0,188,25,1,0,198,25,1,0,204,25,1,0,216,25,1,0,238,25,1,0,242,25,1,0,244,25,1,0,14,26,1,0,28,26,1,0,56,26,1,0,112,26,1,0,126,26,1,0,224,26,1,0,252,26,1,0,8,27,1,0,16,27,1,0,30,27,1,0,32,27,1,0,60,27,1,0,64,27,1,0,120,27,1,0,140,27,1,0,152,27,1,0,176,27,1,0,190,27,1,0,206,27,1,0,220,27,1,0,226,27,1,0,228,27,1,0,232,27,1,0,246,27,1,0,22,28,1,0,38,28,1,0,44,28,1,0,70,28,1,0,76,28,1,0,88,28,1,0,110,28,1,0,134,28,1,0,152,28,1,0,176,28,1,0,190,28,1,0,206,28,1,0,220,28,1,0,226,28,1,0,228,28,1,0,232,28,1,0,246,28,1,0,6,29,1,0,12,29,1,0,24,29,1,0,48,29,1,0,62,29,1,0,96,29,1,0,124,29,1,0,142,29,1,0,156,29,1,0,184,29,1,0,196,29,1,0,200,29,1,0,208,29,1,0,222,29,1,0,230,29,1,0,236,29,1,0,250,29,1,0,10,30,1,0,18,30,1,0,20,30,1,0,34,30,1,0,36,30,1,0,40,30,1,0,54,30,1,0,66,30,1,0,68,30,1,0,80,30,1,0,94,30,1,0,102,30,1,0,108,30,1,0,130,30,1,0,132,30,1,0,136,30,1,0,144,30,1,0,158,30,1,0,160,30,1,0,188,30,1,0,198,30,1,0,204,30,1,0,216,30,1,0,238,30,1,0,26,31,1,0,46,31,1,0,50,31,1,0,52,31,1,0,78,31,1,0,92,31,1,0,98,31,1,0,100,31,1,0,104,31,1,0,118,31,1,0,72,32,1,0,94,32,1,0,130,32,1,0,132,32,1,0,144,32,1,0,158,32,1,0,160,32,1,0,188,32,1,0,216,32,1,0,242,32,1,0,244,32,1,0,8,33,1,0,30,33,1,0,32,33,1,0,60,33,1,0,64,33,1,0,120,33,1,0,134,33,1,0,152,33,1,0,176,33,1,0,190,33,1,0,226,33,1,0,228,33,1,0,232,33,1,0,246,33,1,0,4,34,1,0,16,34,1,0,30,34,1,0,32,34,1,0,120,34,1,0,240,34,1,0,6,35,1,0,12,35,1,0,48,35,1,0,62,35,1,0,96,35,1,0,124,35,1,0,142,35,1,0,156,35,1,0,184,35,1,0,194,35,1,0,200,35,1,0,208,35,1,0,230,35,1,0,236,35,1,0,30,36,1,0,32,36,1,0,60,36,1,0,240,36,1,0,224,37,1,0,24,38,1,0,62,38,1,0,96,38,1,0,124,38,1,0,192,38,1,0,248,38,1,0,56,39,1,0,112,39,1,0,126,39,1,0,130,39,1,0,132,39,1,0,144,39,1,0,158,39,1,0,160,39,1,0,188,39,1,0,198,39,1,0,204,39,1,0,216,39,1,0,238,39,1,0,32,40,1,0,60,40,1,0,64,40,1,0,120,40,1,0,240,40,1,0,224,41,1,0,192,43,1,0,24,44,1,0,48,44,1,0,62,44,1,0,96,44,1,0,124,44,1,0,192,44,1,0,248,44,1,0,240,45,1,0,28,46,1,0,56,46,1,0,112,46,1,0,126,46,1,0,224,46,1,0,252,46,1,0,4,47,1,0,8,47,1,0,16,47,1,0,32,47,1,0,60,47,1,0,64,47,1,0,120,47,1,0,134,47,1,0,140,47,1,0,152,47,1,0,176,47,1,0,190,47,1,0,206,47,1,0,220,47,1,0,46,48,1,0,78,48,1,0,92,48,1,0,98,48,1,0,104,48,1,0,142,48,1,0,156,48,1,0,184,48,1,0,194,48,1,0,200,48,1,0,208,48,1,0,222,48,1,0,236,48,1,0,250,48,1,0,14,49,1,0,56,49,1,0,112,49,1,0,126,49,1,0,130,49,1,0,132,49,1,0,144,49,1,0,158,49,1,0,160,49,1,0,188,49,1,0,198,49,1,0,204,49,1,0,216,49,1,0,242,49,1,0,244,49,1,0,14,50,1,0,28,50,1,0,112,50,1,0,126,50,1,0,224,50,1,0,252,50,1,0,8,51,1,0,30,51,1,0,32,51,1,0,60,51,1,0,64,51,1,0,120,51,1,0,134,51,1,0,152,51,1,0,176,51,1,0,190,51,1,0,206,51,1,0,220,51,1,0,226,51,1,0,228,51,1,0,232,51,1,0,246,51,1,0,14,52,1,0,28,52,1,0,56,52,1,0,112,52,1,0,126,52,1,0,224,52,1,0,252,52,1,0,192,53,1,0,248,53,1,0,8,54,1,0,16,54,1,0,30,54,1,0,32,54,1,0,60,54,1,0,64,54,1,0,120,54,1,0,240,54,1,0,12,55,1,0,24,55,1,0,48,55,1,0,62,55,1,0,96,55,1,0,124,55,1,0,156,55,1,0,184,55,1,0,194,55,1,0,196,55,1,0,200,55,1,0,208,55,1,0,222,55,1,0,230,55,1,0,236,55,1,0,22,56,1,0,38,56,1,0,44,56,1,0,70,56,1,0,76,56,1,0,88,56,1,0,110,56,1,0,116,56,1,0,134,56,1,0,152,56,1,0,176,56,1,0,190,56,1,0,206,56,1,0,220,56,1,0,226,56,1,0,228,56,1,0,232,56,1,0,6,57,1,0,12,57,1,0,48,57,1,0,62,57,1,0,96,57,1,0,124,57,1,0,142,57,1,0,156,57,1,0,184,57,1,0,200,57,1,0,208,57,1,0,222,57,1,0,230,57,1,0,236,57,1,0,250,57,1,0,6,58,1,0,12,58,1,0,24,58,1,0,48,58,1,0,62,58,1,0,96,58,1,0,124,58,1,0,192,58,1,0,248,58,1,0,14,59,1,0,28,59,1,0,56,59,1,0,112,59,1,0,126,59,1,0,136,59,1,0,144,59,1,0,158,59,1,0,160,59,1,0,188,59,1,0,204,59,1,0,216,59,1,0,238,59,1,0,242,59,1,0,244,59,1,0,18,60,1,0,20,60,1,0,34,60,1,0,36,60,1,0,40,60,1,0,54,60,1,0,66,60,1,0,72,60,1,0,80,60,1,0,94,60,1,0,102,60,1,0,108,60,1,0,130,60,1,0,132,60,1,0,144,60,1,0,158,60,1,0,160,60,1,0,188,60,1,0,198,60,1,0,204,60,1,0,216,60,1,0,238,60,1,0,2,61,1,0,4,61,1,0,8,61,1,0,16,61,1,0,30,61,1,0,32,61,1,0,60,61,1,0,64,61,1,0,120,61,1,0,134,61,1,0,140,61,1,0,152,61,1,0,176,61,1,0,190,61,1,0,206,61,1,0,220,61,1,0,228,61,1,0,232,61,1,0,246,61,1,0,26,62,1,0,46,62,1,0,50,62,1,0,52,62,1,0,78,62,1,0,92,62,1,0,98,62,1,0,100,62,1,0,104,62,1,0,118,62,1,0,142,62,1,0,156,62,1,0,184,62,1,0,194,62,1,0,196,62,1,0,200,62,1,0,208,62,1,0,222,62,1,0,230,62,1,0,236,62,1,0,38,63,1,0,44,63,1,0,58,63,1,0,70,63,1,0,76,63,1,0,88,63,1,0,110,63,1,0,114,63,1,0,116,63,1,0,130,64,1,0,158,64,1,0,160,64,1,0,188,64,1,0,4,65,1,0,8,65,1,0,16,65,1,0,30,65,1,0,32,65,1,0,60,65,1,0,64,65,1,0,120,65,1,0,140,65,1,0,152,65,1,0,176,65,1,0,190,65,1,0,226,65,1,0,228,65,1,0,232,65,1,0,8,66,1,0,16,66,1,0,30,66,1,0,32,66,1,0,60,66,1,0,64,66,1,0,120,66,1,0,240,66,1,0,6,67,1,0,12,67,1,0,24,67,1,0,48,67,1,0,62,67,1,0,96,67,1,0,124,67,1,0,142,67,1,0,194,67,1,0,196,67,1,0,200,67,1,0,208,67,1,0,230,67,1,0,236,67,1,0,8,68,1,0,16,68,1,0,30,68,1,0,32,68,1,0,60,68,1,0,64,68,1,0,120,68,1,0,240,68,1,0,224,69,1,0,12,70,1,0,24,70,1,0,48,70,1,0,62,70,1,0,96,70,1,0,124,70,1,0,192,70,1,0,248,70,1,0,28,71,1,0,56,71,1,0,112,71,1,0,126,71,1,0,130,71,1,0,132,71,1,0,136,71,1,0,144,71,1,0,160,71,1,0,188,71,1,0,198,71,1,0,204,71,1,0,216,71,1,0,238,71,1,0,16,72,1,0,32,72,1,0,60,72,1,0,64,72,1,0,120,72,1,0,240,72,1,0,224,73,1,0,192,75,1,0,48,76,1,0,62,76,1,0,96,76,1,0,124,76,1,0,192,76,1,0,248,76,1,0,240,77,1,0,56,78,1,0,112,78,1,0,126,78,1,0,224,78,1,0,252,78,1,0,4,79,1,0,8,79,1,0,16,79,1,0,30,79,1,0,32,79,1,0,60,79,1,0,64,79,1,0,120,79,1,0,134,79,1,0,140,79,1,0,152,79,1,0,176,79,1,0,206,79,1,0,220,79,1,0,32,80,1,0,64,80,1,0,120,80,1,0,240,80,1,0,224,81,1,0,192,83,1,0,96,88,1,0,124,88,1,0,192,88,1,0,248,88,1,0,240,89,1,0,224,91,1,0,112,92,1,0,126,92,1,0,224,92,1,0,252,92,1,0,192,93,1,0,248,93,1,0,8,94,1,0,16,94,1,0,32,94,1,0,64,94,1,0,120,94,1,0,240,94,1,0,12,95,1,0,24,95,1,0,48,95,1,0,96,95,1,0,124,95,1,0,142,95,1,0,156,95,1,0,184,95,1,0,78,96,1,0,92,96,1,0,142,96,1,0,156,96,1,0,184,96,1,0,194,96,1,0,196,96,1,0,200,96,1,0,222,96,1,0,14,97,1,0,28,97,1,0,56,97,1,0,112,97,1,0,126,97,1,0,132,97,1,0,136,97,1,0,144,97,1,0,158,97,1,0,160,97,1,0,188,97,1,0,198,97,1,0,204,97,1,0,216,97,1,0,242,97,1,0,244,97,1,0,14,98,1,0,28,98,1,0,56,98,1,0,112,98,1,0,126,98,1,0,224,98,1,0,252,98,1,0,4,99,1,0,8,99,1,0,16,99,1,0,30,99,1,0,32,99,1,0,60,99,1,0,64,99,1,0,120,99,1,0,134,99,1,0,140,99,1,0,152,99,1,0,176,99,1,0,190,99,1,0,206,99,1,0,220,99,1,0,226,99,1,0,228,99,1,0,232,99,1,0,246,99,1,0,14,100,1,0,28,100,1,0,56,100,1,0,112,100,1,0,126,100,1,0,224,100,1,0,252,100,1,0,192,101,1,0,248,101,1,0,16,102,1,0,30,102,1,0,32,102,1,0,60,102,1,0,64,102,1,0,120,102,1,0,240,102,1,0,24,103,1,0,48,103,1,0,62,103,1,0,96,103,1,0,124,103,1,0,142,103,1,0,156,103,1,0,184,103,1,0,194,103,1,0,196,103,1,0,200,103,1,0,208,103,1,0,222,103,1,0,230,103,1,0,236,103,1,0,28,104,1,0,56,104,1,0,112,104,1,0,224,104,1,0,252,104,1,0,192,105,1,0,248,105,1,0,240,107,1,0,16,108,1,0,30,108,1,0,32,108,1,0,60,108,1,0,64,108,1,0,120,108,1,0,240,108,1,0,224,109,1,0,24,110,1,0,48,110,1,0,62,110,1,0,96,110,1,0,124,110,1,0,192,110,1,0,248,110,1,0,28,111,1,0,56,111,1,0,112,111,1,0,126,111,1,0,132,111,1,0,136,111,1,0,144,111,1,0,158,111,1,0,160,111,1,0,188,111,1,0,198,111,1,0,204,111,1,0,216,111,1,0,38,112,1,0,44,112,1,0,70,112,1,0,76,112,1,0,88,112,1,0,110,112,1,0,134,112,1,0,140,112,1,0,152,112,1,0,176,112,1,0,190,112,1,0,206,112,1,0,220,112,1,0,232,112,1,0,6,113,1,0,12,113,1,0,24,113,1,0,48,113,1,0,62,113,1,0,96,113,1,0,124,113,1,0,142,113,1,0,156,113,1,0,184,113,1,0,194,113,1,0,196,113,1,0,200,113,1,0,208,113,1,0,222,113,1,0,230,113,1,0,236,113,1,0,250,113,1,0,6,114,1,0,12,114,1,0,24,114,1,0,48,114,1,0,62,114,1,0,96,114,1,0,124,114,1,0,192,114,1,0,248,114,1,0,14,115,1,0,28,115,1,0,56,115,1,0,112,115,1,0,126,115,1,0,136,115,1,0,144,115,1,0,158,115,1,0,160,115,1,0,188,115,1,0,204,115,1,0,216,115,1,0,238,115,1,0,242,115,1,0,244,115,1,0,12,116,1,0,24,116,1,0,48,116,1,0,62,116,1,0,96,116,1,0,124,116,1,0,192,116,1,0,248,116,1,0,240,117,1,0,14,118,1,0,28,118,1,0,56,118,1,0,112,118,1,0,126,118,1,0,224,118,1,0,252,118,1,0,8,119,1,0,16,119,1,0,30,119,1,0,32,119,1,0,60,119,1,0,64,119,1,0,120,119,1,0,152,119,1,0,176,119,1,0,190,119,1,0,220,119,1,0,226,119,1,0,228,119,1,0,232,119,1,0,34,120,1,0,36,120,1,0,40,120,1,0,54,120,1,0,66,120,1,0,68,120,1,0,72,120,1,0,80,120,1,0,94,120,1,0,102,120,1,0,108,120,1,0,130,120,1,0,132,120,1,0,136,120,1,0,144,120,1,0,158,120,1,0,160,120,1,0,188,120,1,0,198,120,1,0,204,120,1,0,216,120,1,0,238,120,1,0,242,120,1,0,244,120,1,0,2,121,1,0,4,121,1,0,8,121,1,0,16,121,1,0,30,121,1,0,32,121,1,0,60,121,1,0,64,121,1,0,120,121,1,0,134,121,1,0,140,121,1,0,152,121,1,0,176,121,1,0,190,121,1,0,206,121,1,0,220,121,1,0,226,121,1,0,228,121,1,0,232,121,1,0,246,121,1,0,4,122,1,0,8,122,1,0,16,122,1,0,30,122,1,0,32,122,1,0,60,122,1,0,64,122,1,0,120,122,1,0,240,122,1,0,6,123,1,0,12,123,1,0,24,123,1,0,48,123,1,0,62,123,1,0,96,123,1,0,124,123,1,0,142,123,1,0,156,123,1,0,184,123,1,0,196,123,1,0,200,123,1,0,208,123,1,0,222,123,1,0,230,123,1,0,236,123,1,0,46,124,1,0,50,124,1,0,52,124,1,0,78,124,1,0,92,124,1,0,98,124,1,0,100,124,1,0,104,124,1,0,118,124,1,0,142,124,1,0,156,124,1,0,184,124,1,0,194,124,1,0,196,124,1,0,200,124,1,0,208,124,1,0,222,124,1,0,230,124,1,0,236,124,1,0,14,125,1,0,28,125,1,0,56,125,1,0,112,125,1,0,130,125,1,0,132,125,1,0,136,125,1,0,144,125,1,0,158,125,1,0,160,125,1,0,188,125,1,0,198,125,1,0,204,125,1,0,216,125,1,0,238,125,1,0,38,126,1,0,44,126,1,0,58,126,1,0,70,126,1,0,76,126,1,0,88,126,1,0,110,126,1,0,114,126,1,0,116,126,1,0,134,126,1,0,140,126,1,0,152,126,1,0,176,126,1,0,206,126,1,0,220,126,1,0,226,126,1,0,228,126,1,0,232,126,1,0,246,126,1,0,58,129,1,0,114,129,1,0,116,129,1,0,22,130,1,0,38,130,1,0,58,130,1,0,76,130,1,0,88,130,1,0,110,130,1,0,114,130,1,0,116,130,1,0,152,130,1,0,190,130,1,0,226,130,1,0,228,130,1,0,232,130,1,0,246,130,1,0,94,131,1,0,122,131,1,0,174,131,1,0,214,131,1,0,22,132,1,0,38,132,1,0,44,132,1,0,58,132,1,0,70,132,1,0,88,132,1,0,110,132,1,0,114,132,1,0,116,132,1,0,134,132,1,0,176,132,1,0,190,132,1,0,206,132,1,0,220,132,1,0,226,132,1,0,228,132,1,0,232,132,1,0,246,132,1,0,6,133,1,0,12,133,1,0,24,133,1,0,48,133,1,0,62,133,1,0,96,133,1,0,124,133,1,0,142,133,1,0,156,133,1,0,184,133,1,0,194,133,1,0,196,133,1,0,200,133,1,0,208,133,1,0,222,133,1],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE);allocate([230,133,1,0,236,133,1,0,250,133,1,0,18,134,1,0,20,134,1,0,34,134,1,0,40,134,1,0,54,134,1,0,66,134,1,0,80,134,1,0,94,134,1,0,122,134,1,0,130,134,1,0,132,134,1,0,136,134,1,0,144,134,1,0,158,134,1,0,160,134,1,0,188,134,1,0,198,134,1,0,204,134,1,0,216,134,1,0,238,134,1,0,242,134,1,0,244,134,1,0,46,135,1,0,78,135,1,0,92,135,1,0,150,135,1,0,166,135,1,0,172,135,1,0,210,135,1,0,212,135,1,0,38,136,1,0,44,136,1,0,58,136,1,0,70,136,1,0,76,136,1,0,88,136,1,0,110,136,1,0,114,136,1,0,116,136,1,0,134,136,1,0,152,136,1,0,176,136,1,0,190,136,1,0,206,136,1,0,220,136,1,0,226,136,1,0,228,136,1,0,232,136,1,0,246,136,1,0,12,137,1,0,48,137,1,0,62,137,1,0,96,137,1,0,124,137,1,0,142,137,1,0,184,137,1,0,194,137,1,0,200,137,1,0,208,137,1,0,222,137,1,0,230,137,1,0,236,137,1,0,250,137,1,0,24,138,1,0,48,138,1,0,62,138,1,0,96,138,1,0,124,138,1,0,192,138,1,0,248,138,1,0,28,139,1,0,56,139,1,0,112,139,1,0,126,139,1,0,130,139,1,0,132,139,1,0,136,139,1,0,144,139,1,0,158,139,1,0,160,139,1,0,188,139,1,0,198,139,1,0,204,139,1,0,216,139,1,0,238,139,1,0,242,139,1,0,244,139,1,0,34,140,1,0,36,140,1,0,40,140,1,0,54,140,1,0,66,140,1,0,72,140,1,0,80,140,1,0,94,140,1,0,102,140,1,0,122,140,1,0,130,140,1,0,132,140,1,0,144,140,1,0,158,140,1,0,160,140,1,0,188,140,1,0,204,140,1,0,242,140,1,0,244,140,1,0,4,141,1,0,8,141,1,0,16,141,1,0,30,141,1,0,32,141,1,0,60,141,1,0,64,141,1,0,120,141,1,0,134,141,1,0,152,141,1,0,206,141,1,0,226,141,1,0,228,141,1,0,232,141,1,0,46,142,1,0,50,142,1,0,52,142,1,0,78,142,1,0,92,142,1,0,98,142,1,0,100,142,1,0,104,142,1,0,142,142,1,0,156,142,1,0,184,142,1,0,194,142,1,0,196,142,1,0,200,142,1,0,208,142,1,0,250,142,1,0,22,143,1,0,38,143,1,0,44,143,1,0,70,143,1,0,76,143,1,0,88,143,1,0,110,143,1,0,138,143,1,0,146,143,1,0,148,143,1,0,162,143,1,0,164,143,1,0,168,143,1,0,182,143,1,0,44,144,1,0,58,144,1,0,70,144,1,0,76,144,1,0,88,144,1,0,114,144,1,0,116,144,1,0,134,144,1,0,152,144,1,0,176,144,1,0,190,144,1,0,206,144,1,0,220,144,1,0,226,144,1,0,232,144,1,0,246,144,1,0,6,145,1,0,12,145,1,0,48,145,1,0,62,145,1,0,96,145,1,0,124,145,1,0,142,145,1,0,156,145,1,0,184,145,1,0,194,145,1,0,200,145,1,0,208,145,1,0,222,145,1,0,230,145,1,0,236,145,1,0,250,145,1,0,24,146,1,0,62,146,1,0,96,146,1,0,124,146,1,0,192,146,1,0,248,146,1,0,56,147,1,0,112,147,1,0,126,147,1,0,130,147,1,0,132,147,1,0,144,147,1,0,158,147,1,0,160,147,1,0,188,147,1,0,198,147,1,0,204,147,1,0,216,147,1,0,238,147,1,0,242,147,1,0,244,147,1,0,48,148,1,0,62,148,1,0,96,148,1,0,124,148,1,0,192,148,1,0,248,148,1,0,240,149,1,0,56,150,1,0,112,150,1,0,126,150,1,0,224,150,1,0,252,150,1,0,2,151,1,0,4,151,1,0,8,151,1,0,16,151,1,0,32,151,1,0,60,151,1,0,64,151,1,0,120,151,1,0,134,151,1,0,140,151,1,0,152,151,1,0,176,151,1,0,190,151,1,0,206,151,1,0,220,151,1,0,226,151,1,0,228,151,1,0,232,151,1,0,34,152,1,0,36,152,1,0,66,152,1,0,72,152,1,0,80,152,1,0,94,152,1,0,102,152,1,0,122,152,1,0,130,152,1,0,132,152,1,0,144,152,1,0,158,152,1,0,160,152,1,0,188,152,1,0,204,152,1,0,242,152,1,0,244,152,1,0,2,153,1,0,8,153,1,0,30,153,1,0,32,153,1,0,60,153,1,0,64,153,1,0,120,153,1,0,134,153,1,0,152,153,1,0,206,153,1,0,226,153,1,0,228,153,1,0,232,153,1,0,8,154,1,0,16,154,1,0,30,154,1,0,32,154,1,0,60,154,1,0,64,154,1,0,120,154,1,0,240,154,1,0,24,155,1,0,62,155,1,0,96,155,1,0,156,155,1,0,194,155,1,0,196,155,1,0,200,155,1,0,208,155,1,0,230,155,1,0,46,156,1,0,52,156,1,0,78,156,1,0,92,156,1,0,98,156,1,0,100,156,1,0,104,156,1,0,142,156,1,0,156,156,1,0,184,156,1,0,194,156,1,0,200,156,1,0,208,156,1,0,230,156,1,0,250,156,1,0,14,157,1,0,28,157,1,0,56,157,1,0,112,157,1,0,126,157,1,0,130,157,1,0,132,157,1,0,136,157,1,0,144,157,1,0,160,157,1,0,204,157,1,0,242,157,1,0,244,157,1,0,22,158,1,0,38,158,1,0,44,158,1,0,70,158,1,0,76,158,1,0,88,158,1,0,116,158,1,0,134,158,1,0,140,158,1,0,152,158,1,0,176,158,1,0,190,158,1,0,206,158,1,0,226,158,1,0,228,158,1,0,232,158,1,0,10,159,1,0,18,159,1,0,20,159,1,0,34,159,1,0,36,159,1,0,40,159,1,0,66,159,1,0,68,159,1,0,72,159,1,0,80,159,1,0,94,159,1,0,108,159,1,0,154,159,1,0,174,159,1,0,178,159,1,0,180,159,1,0,70,160,1,0,76,160,1,0,114,160,1,0,116,160,1,0,134,160,1,0,140,160,1,0,152,160,1,0,176,160,1,0,190,160,1,0,226,160,1,0,228,160,1,0,232,160,1,0,246,160,1,0,6,161,1,0,12,161,1,0,24,161,1,0,48,161,1,0,62,161,1,0,96,161,1,0,124,161,1,0,142,161,1,0,156,161,1,0,184,161,1,0,194,161,1,0,196,161,1,0,200,161,1,0,208,161,1,0,222,161,1,0,230,161,1,0,236,161,1,0,24,162,1,0,48,162,1,0,62,162,1,0,96,162,1,0,124,162,1,0,192,162,1,0,248,162,1,0,28,163,1,0,56,163,1,0,112,163,1,0,126,163,1,0,130,163,1,0,132,163,1,0,136,163,1,0,144,163,1,0,158,163,1,0,160,163,1,0,188,163,1,0,198,163,1,0,204,163,1,0,216,163,1,0,238,163,1,0,242,163,1,0,244,163,1,0,24,164,1,0,48,164,1,0,62,164,1,0,96,164,1,0,124,164,1,0,192,164,1,0,248,164,1,0,240,165,1,0,28,166,1,0,56,166,1,0,112,166,1,0,126,166,1,0,224,166,1,0,252,166,1,0,2,167,1,0,4,167,1,0,8,167,1,0,16,167,1,0,30,167,1,0,32,167,1,0,60,167,1,0,64,167,1,0,120,167,1,0,134,167,1,0,140,167,1,0,152,167,1,0,176,167,1,0,190,167,1,0,206,167,1,0,220,167,1,0,226,167,1,0,228,167,1,0,232,167,1,0,48,168,1,0,96,168,1,0,124,168,1,0,192,168,1,0,248,168,1,0,240,169,1,0,224,171,1,0,112,172,1,0,126,172,1,0,224,172,1,0,252,172,1,0,192,173,1,0,248,173,1,0,4,174,1,0,8,174,1,0,16,174,1,0,32,174,1,0,60,174,1,0,64,174,1,0,120,174,1,0,240,174,1,0,6,175,1,0,12,175,1,0,24,175,1,0,48,175,1,0,62,175,1,0,96,175,1,0,124,175,1,0,142,175,1,0,156,175,1,0,184,175,1,0,196,175,1,0,200,175,1,0,208,175,1,0,222,175,1,0,66,176,1,0,94,176,1,0,122,176,1,0,130,176,1,0,132,176,1,0,136,176,1,0,144,176,1,0,158,176,1,0,160,176,1,0,188,176,1,0,204,176,1,0,242,176,1,0,244,176,1,0,2,177,1,0,4,177,1,0,8,177,1,0,16,177,1,0,30,177,1,0,32,177,1,0,60,177,1,0,64,177,1,0,120,177,1,0,134,177,1,0,152,177,1,0,206,177,1,0,226,177,1,0,228,177,1,0,232,177,1,0,4,178,1,0,8,178,1,0,16,178,1,0,30,178,1,0,32,178,1,0,60,178,1,0,64,178,1,0,120,178,1,0,240,178,1,0,12,179,1,0,62,179,1,0,96,179,1,0,156,179,1,0,194,179,1,0,196,179,1,0,200,179,1,0,208,179,1,0,230,179,1,0,16,180,1,0,30,180,1,0,32,180,1,0,60,180,1,0,64,180,1,0,120,180,1,0,240,180,1,0,224,181,1,0,24,182,1,0,96,182,1,0,124,182,1,0,192,182,1,0,56,183,1,0,130,183,1,0,132,183,1,0,136,183,1,0,144,183,1,0,158,183,1,0,160,183,1,0,204,183,1,0,46,184,1,0,78,184,1,0,92,184,1,0,142,184,1,0,156,184,1,0,184,184,1,0,194,184,1,0,196,184,1,0,200,184,1,0,208,184,1,0,230,184,1,0,250,184,1,0,14,185,1,0,28,185,1,0,56,185,1,0,112,185,1,0,126,185,1,0,130,185,1,0,132,185,1,0,136,185,1,0,144,185,1,0,158,185,1,0,160,185,1,0,204,185,1,0,242,185,1,0,244,185,1,0,14,186,1,0,28,186,1,0,56,186,1,0,112,186,1,0,126,186,1,0,224,186,1,0,252,186,1,0,8,187,1,0,16,187,1,0,32,187,1,0,60,187,1,0,64,187,1,0,152,187,1,0,206,187,1,0,226,187,1,0,228,187,1,0,232,187,1,0,22,188,1,0,38,188,1,0,44,188,1,0,70,188,1,0,76,188,1,0,88,188,1,0,114,188,1,0,116,188,1,0,134,188,1,0,140,188,1,0,152,188,1,0,176,188,1,0,190,188,1,0,206,188,1,0,226,188,1,0,228,188,1,0,232,188,1,0,6,189,1,0,12,189,1,0,24,189,1,0,48,189,1,0,62,189,1,0,96,189,1,0,124,189,1,0,156,189,1,0,194,189,1,0,196,189,1,0,200,189,1,0,208,189,1,0,230,189,1,0,250,189,1,0,18,190,1,0,20,190,1,0,34,190,1,0,36,190,1,0,40,190,1,0,66,190,1,0,68,190,1,0,72,190,1,0,80,190,1,0,94,190,1,0,102,190,1,0,130,190,1,0,132,190,1,0,136,190,1,0,144,190,1,0,158,190,1,0,160,190,1,0,188,190,1,0,204,190,1,0,244,190,1,0,26,191,1,0,46,191,1,0,50,191,1,0,52,191,1,0,78,191,1,0,92,191,1,0,98,191,1,0,100,191,1,0,104,191,1,0,154,192,1,0,178,192,1,0,180,192,1,0,26,193,1,0,50,193,1,0,52,193,1,0,98,193,1,0,100,193,1,0,104,193,1,0,118,193,1,0,186,193,1,0,26,194,1,0,50,194,1,0,52,194,1,0,78,194,1,0,92,194,1,0,98,194,1,0,100,194,1,0,104,194,1,0,118,194,1,0,142,194,1,0,194,194,1,0,196,194,1,0,200,194,1,0,208,194,1,0,222,194,1,0,230,194,1,0,236,194,1,0,250,194,1,0,22,195,1,0,38,195,1,0,58,195,1,0,70,195,1,0,76,195,1,0,114,195,1,0,116,195,1,0,26,196,1,0,46,196,1,0,50,196,1,0,52,196,1,0,78,196,1,0,92,196,1,0,98,196,1,0,100,196,1,0,104,196,1,0,118,196,1,0,142,196,1,0,156,196,1,0,184,196,1,0,194,196,1,0,200,196,1,0,208,196,1,0,222,196,1,0,230,196,1,0,236,196,1,0,250,196,1,0,28,197,1,0,56,197,1,0,112,197,1,0,126,197,1,0,130,197,1,0,132,197,1,0,136,197,1,0,144,197,1,0,158,197,1,0,160,197,1,0,188,197,1,0,198,197,1,0,204,197,1,0,216,197,1,0,238,197,1,0,242,197,1,0,244,197,1,0,22,198,1,0,38,198,1,0,44,198,1,0,58,198,1,0,70,198,1,0,76,198,1,0,88,198,1,0,110,198,1,0,114,198,1,0,116,198,1,0,134,198,1,0,140,198,1,0,152,198,1,0,176,198,1,0,190,198,1,0,206,198,1,0,220,198,1,0,226,198,1,0,228,198,1,0,232,198,1,0,18,199,1,0,20,199,1,0,34,199,1,0,40,199,1,0,54,199,1,0,66,199,1,0,68,199,1,0,72,199,1,0,80,199,1,0,94,199,1,0,102,199,1,0,108,199,1,0,122,199,1,0,174,199,1,0,214,199,1,0,234,199,1,0,26,200,1,0,46,200,1,0,50,200,1,0,52,200,1,0,78,200,1,0,92,200,1,0,98,200,1,0,100,200,1,0,104,200,1,0,118,200,1,0,142,200,1,0,156,200,1,0,184,200,1,0,194,200,1,0,200,200,1,0,208,200,1,0,222,200,1,0,230,200,1,0,236,200,1,0,250,200,1,0,14,201,1,0,56,201,1,0,112,201,1,0,126,201,1,0,130,201,1,0,132,201,1,0,144,201,1,0,158,201,1,0,160,201,1,0,188,201,1,0,198,201,1,0,204,201,1,0,216,201,1,0,238,201,1,0,242,201,1,0,244,201,1,0,56,202,1,0,112,202,1,0,126,202,1,0,224,202,1,0,252,202,1,0,2,203,1,0,4,203,1,0,8,203,1,0,16,203,1,0,32,203,1,0,60,203,1,0,64,203,1,0,120,203,1,0,134,203,1,0,140,203,1,0,152,203,1,0,176,203,1,0,190,203,1,0,206,203,1,0,220,203,1,0,226,203,1,0,228,203,1,0,232,203,1,0,246,203,1,0,22,204,1,0,38,204,1,0,44,204,1,0,58,204,1,0,70,204,1,0,88,204,1,0,114,204,1,0,116,204,1,0,134,204,1,0,176,204,1,0,190,204,1,0,206,204,1,0,226,204,1,0,228,204,1,0,232,204,1,0,6,205,1,0,12,205,1,0,24,205,1,0,48,205,1,0,62,205,1,0,96,205,1,0,124,205,1,0,156,205,1,0,194,205,1,0,196,205,1,0,200,205,1,0,208,205,1,0,222,205,1,0,230,205,1,0,250,205,1,0,34,206,1,0,40,206,1,0,66,206,1,0,80,206,1,0,94,206,1,0,102,206,1,0,122,206,1,0,130,206,1,0,132,206,1,0,136,206,1,0,144,206,1,0,158,206,1,0,160,206,1,0,188,206,1,0,204,206,1,0,242,206,1,0,244,206,1,0,46,207,1,0,50,207,1,0,52,207,1,0,78,207,1,0,92,207,1,0,98,207,1,0,100,207,1,0,104,207,1,0,150,207,1,0,166,207,1,0,172,207,1,0,202,207,1,0,210,207,1,0,212,207,1,0,46,208,1,0,50,208,1,0,52,208,1,0,78,208,1,0,92,208,1,0,98,208,1,0,100,208,1,0,104,208,1,0,118,208,1,0,142,208,1,0,156,208,1,0,184,208,1,0,194,208,1,0,196,208,1,0,200,208,1,0,208,208,1,0,222,208,1,0,230,208,1,0,236,208,1,0,250,208,1,0,28,209,1,0,56,209,1,0,112,209,1,0,126,209,1,0,130,209,1,0,132,209,1,0,136,209,1,0,144,209,1,0,158,209,1,0,160,209,1,0,188,209,1,0,198,209,1,0,204,209,1,0,216,209,1,0,238,209,1,0,242,209,1,0,244,209,1,0,28,210,1,0,56,210,1,0,112,210,1,0,126,210,1,0,224,210,1,0,252,210,1,0,2,211,1,0,4,211,1,0,8,211,1,0,16,211,1,0,30,211,1,0,32,211,1,0,60,211,1,0,64,211,1,0,120,211,1,0,134,211,1,0,140,211,1,0,152,211,1,0,176,211,1,0,190,211,1,0,206,211,1,0,220,211,1,0,226,211,1,0,228,211,1,0,232,211,1,0,246,211,1,0,112,212,1,0,126,212,1,0,224,212,1,0,252,212,1,0,192,213,1,0,248,213,1,0,4,214,1,0,8,214,1,0,16,214,1,0,32,214,1,0,64,214,1,0,120,214,1,0,240,214,1,0,6,215,1,0,12,215,1,0,24,215,1,0,48,215,1,0,62,215,1,0,96,215,1,0,124,215,1,0,142,215,1,0,156,215,1,0,184,215,1,0,194,215,1,0,196,215,1,0,200,215,1,0,208,215,1,0,222,215,1,0,230,215,1,0,236,215,1,0,38,216,1,0,44,216,1,0,58,216,1,0,70,216,1,0,76,216,1,0,88,216,1,0,114,216,1,0,116,216,1,0,134,216,1,0,140,216,1,0,152,216,1,0,176,216,1,0,190,216,1,0,206,216,1,0,226,216,1,0,228,216,1,0,232,216,1,0,246,216,1,0,12,217,1,0,24,217,1,0,48,217,1,0,62,217,1,0,96,217,1,0,124,217,1,0,156,217,1,0,194,217,1,0,196,217,1,0,200,217,1,0,208,217,1,0,230,217,1,0,250,217,1,0,12,218,1,0,24,218,1,0,48,218,1,0,62,218,1,0,96,218,1,0,124,218,1,0,192,218,1,0,248,218,1,0,56,219,1,0,130,219,1,0,132,219,1,0,136,219,1,0,144,219,1,0,158,219,1,0,160,219,1,0,204,219,1,0,242,219,1,0,244,219,1,0,34,220,1,0,66,220,1,0,68,220,1,0,72,220,1,0,80,220,1,0,94,220,1,0,102,220,1,0,122,220,1,0,130,220,1,0,132,220,1,0,136,220,1,0,144,220,1,0,158,220,1,0,160,220,1,0,188,220,1,0,204,220,1,0,242,220,1,0,244,220,1,0,4,221,1,0,8,221,1,0,16,221,1,0,30,221,1,0,32,221,1,0,60,221,1,0,64,221,1,0,120,221,1,0,134,221,1,0,152,221,1,0,206,221,1,0,226,221,1,0,228,221,1,0,232,221,1,0,46,222,1,0,50,222,1,0,52,222,1,0,78,222,1,0,92,222,1,0,98,222,1,0,100,222,1,0,104,222,1,0,142,222,1,0,156,222,1,0,184,222,1,0,194,222,1,0,196,222,1,0,200,222,1,0,208,222,1,0,230,222,1,0,250,222,1,0,22,223,1,0,38,223,1,0,44,223,1,0,70,223,1,0,76,223,1,0,88,223,1,0,114,223,1,0,116,223,1,0,138,223,1,0,146,223,1,0,148,223,1,0,162,223,1,0,164,223,1,0,168,223,1,0,138,224,1,0,146,224,1,0,148,224,1,0,162,224,1,0,164,224,1,0,168,224,1,0,182,224,1,0,218,224,1,0,10,225,1,0,18,225,1,0,20,225,1,0,34,225,1,0,36,225,1,0,40,225,1,0,54,225,1,0,66,225,1,0,68,225,1,0,72,225,1,0,80,225,1,0,102,225,1,0,108,225,1,0,122,225,1,0,154,225,1,0,178,225,1,0,180,225,1,0,10,226,1,0,18,226,1,0,20,226,1,0,34,226,1,0,36,226,1,0,40,226,1,0,54,226,1,0,66,226,1,0,72,226,1,0,80,226,1,0,94,226,1,0,102,226,1,0,108,226,1,0,122,226,1,0,130,226,1,0,132,226,1,0,136,226,1,0,144,226,1,0,160,226,1,0,188,226,1,0,198,226,1,0,204,226,1,0,216,226,1,0,238,226,1,0,242,226,1,0,244,226,1,0,26,227,1,0,50,227,1,0,52,227,1,0,92,227,1,0,98,227,1,0,100,227,1,0,104,227,1,0,186,227,1,0,10,228,1,0,18,228,1,0,20,228,1,0,34,228,1,0,40,228,1,0,54,228,1,0,66,228,1,0,72,228,1,0,80,228,1,0,94,228,1,0,102,228,1,0,108,228,1,0,122,228,1,0,130,228,1,0,132,228,1,0,144,228,1,0,158,228,1,0,160,228,1,0,188,228,1,0,198,228,1,0,204,228,1,0,216,228,1,0,238,228,1,0,242,228,1,0,244,228,1,0,2,229,1,0,4,229,1,0,8,229,1,0,16,229,1,0,30,229,1,0,32,229,1,0,60,229,1,0,64,229,1,0,120,229,1,0,134,229,1,0,140,229,1,0,152,229,1,0,176,229,1,0,190,229,1,0,206,229,1,0,220,229,1,0,226,229,1,0,228,229,1,0,232,229,1,0,246,229,1,0,26,230,1,0,46,230,1,0,50,230,1,0,52,230,1,0,78,230,1,0,92,230,1,0,98,230,1,0,104,230,1,0,142,230,1,0,156,230,1,0,184,230,1,0,194,230,1,0,196,230,1,0,200,230,1,0,208,230,1,0,230,230,1,0,250,230,1,0,22,231,1,0,38,231,1,0,44,231,1,0,58,231,1,0,70,231,1,0,76,231,1,0,88,231,1,0,114,231,1,0,116,231,1,0,146,231,1,0,148,231,1,0,162,231,1,0,164,231,1,0,168,231,1,0,182,231,1,0,18,232,1,0,20,232,1,0,34,232,1,0,36,232,1,0,40,232,1,0,54,232,1,0,66,232,1,0,68,232,1,0,72,232,1,0,80,232,1,0,94,232,1,0,102,232,1,0,108,232,1,0,122,232,1,0,130,232,1,0,132,232,1,0,136,232,1,0,144,232,1,0,158,232,1,0,160,232,1,0,188,232,1,0,198,232,1,0,204,232,1,0,216,232,1,0,238,232,1,0,242,232,1,0,244,232,1,0,2,233,1,0,4,233,1,0,8,233,1,0,16,233,1,0,32,233,1,0,60,233,1,0,64,233,1,0,120,233,1,0,134,233,1,0,140,233,1,0,152,233,1,0,176,233,1,0,190,233,1,0,206,233,1,0,220,233,1,0,226,233,1,0,228,233,1,0,232,233,1,0,246,233,1,0,4,234,1,0,8,234,1,0,16,234,1,0,32,234,1,0,64,234,1,0,120,234,1,0,240,234,1,0,6,235,1,0,12,235,1,0,24,235,1,0,48,235,1,0,62,235,1,0,96,235,1,0,124,235,1,0,142,235,1,0,156,235,1,0,184,235,1,0,194,235,1,0,196,235,1,0,200,235,1,0,208,235,1,0,222,235,1,0,230,235,1,0,236,235,1,0,26,236,1,0,46,236,1,0,50,236,1,0,52,236,1,0,78,236,1,0,92,236,1,0,98,236,1,0,100,236,1,0,104,236,1,0,142,236,1,0,156,236,1,0,184,236,1,0,194,236,1,0,196,236,1,0,200,236,1,0,208,236,1,0,230,236,1,0,250,236,1,0,14,237,1,0,28,237,1,0,56,237,1,0,112,237,1,0,126,237,1,0,130,237,1,0,132,237,1,0,136,237,1,0,144,237,1,0,158,237,1,0,160,237,1,0,204,237,1,0,242,237,1,0,244,237,1,0,22,238,1,0,38,238,1,0,44,238,1,0,58,238,1,0,70,238,1,0,76,238,1,0,88,238,1,0,110,238,1,0,114,238,1,0,116,238,1,0,134,238,1,0,140,238,1,0,152,238,1,0,176,238,1,0,190,238,1,0,206,238,1,0,220,238,1,0,226,238,1,0,228,238,1,0,232,238,1,0,18,239,1,0,34,239,1,0,36,239,1,0,40,239,1,0,54,239,1,0,66,239,1,0,68,239,1,0,72,239,1,0,80,239,1,0,94,239,1,0,102,239,1,0,108,239,1,0,122,239,1,0,174,239,1,0,178,239,1,0,180,239,1,0,214,239,1,0,150,240,1,0,166,240,1,0,172,240,1,0,186,240,1,0,202,240,1,0,210,240,1,0,212,240,1,0,22,241,1,0,38,241,1,0,44,241,1,0,58,241,1,0,70,241,1,0,76,241,1,0,88,241,1,0,110,241,1,0,114,241,1,0,116,241,1,0,138,241,1,0,146,241,1,0,148,241,1,0,162,241,1,0,164,241,1,0,168,241,1,0,218,241,1,0,22,242,1,0,38,242,1,0,44,242,1,0,58,242,1,0,70,242,1,0,88,242,1,0,110,242,1,0,114,242,1,0,116,242,1,0,134,242,1,0,140,242,1,0,152,242,1,0,176,242,1,0,190,242,1,0,206,242,1,0,220,242,1,0,226,242,1,0,228,242,1,0,232,242,1,0,246,242,1,0,10,243,1,0,18,243,1,0,20,243,1,0,34,243,1,0,40,243,1,0,66,243,1,0,68,243,1,0,72,243,1,0,80,243,1,0,94,243,1,0,102,243,1,0,122,243,1,0,154,243,1,0,174,243,1,0,178,243,1,0,180,243,1,0,22,244,1,0,38,244,1,0,44,244,1,0,58,244,1,0,70,244,1,0,76,244,1,0,88,244,1,0,110,244,1,0,114,244,1,0,116,244,1,0,134,244,1,0,140,244,1,0,152,244,1,0,176,244,1,0,190,244,1,0,206,244,1,0,220,244,1,0,226,244,1,0,228,244,1,0,232,244,1,0,246,244,1,0,6,245,1,0,12,245,1,0,24,245,1,0,48,245,1,0,62,245,1,0,96,245,1,0,124,245,1,0,142,245,1,0,156,245,1,0,184,245,1,0,194,245,1,0,196,245,1,0,200,245,1,0,208,245,1,0,222,245,1,0,230,245,1,0,236,245,1,0,250,245,1,0,10,246,1,0,18,246,1,0,20,246,1,0,34,246,1,0,36,246,1,0,40,246,1,0,54,246,1,0,66,246,1,0,68,246,1,0,72,246,1,0,80,246,1,0,94,246,1,0,102,246,1,0,122,246,1,0,130,246,1,0,132,246,1,0,136,246,1,0,144,246,1,0,158,246,1,0,160,246,1,0,188,246,1,0,204,246,1,0,242,246,1,0,244,246,1,0,26,247,1,0,46,247,1,0,50,247,1,0,52,247,1,0,78,247,1,0,92,247,1,0,98,247,1,0,100,247,1,0,104,247,1,0,118,247,1,0,150,247,1,0,166,247,1,0,172,247,1,0,186,247,1,0,210,247,1,0,212,247,1,0,154,248,1,0,174,248,1,0,178,248,1,0,180,248,1,0,214,248,1,0,234,248,1,0,26,249,1,0,46,249,1,0,50,249,1,0,52,249,1,0,78,249,1,0,92,249,1,0,98,249,1,0,100,249,1,0,104,249,1,0,118,249,1,0,150,249,1,0,166,249,1,0,172,249,1,0,186,249,1,0,202,249,1,0,210,249,1,0,212,249,1,0,26,250,1,0,46,250,1,0,50,250,1,0,52,250,1,0,78,250,1,0,92,250,1,0,98,250,1,0,100,250,1,0,104,250,1,0,118,250,1,0,142,250,1,0,156,250,1,0,184,250,1,0,194,250,1,0,196,250,1,0,200,250,1,0,208,250,1,0,222,250,1,0,230,250,1,0,236,250,1,0,22,251,1,0,38,251,1,0,44,251,1,0,58,251,1,0,70,251,1,0,76,251,1,0,88,251,1,0,110,251,1,0,114,251,1,0,116,251,1,0,138,251,1,0,146,251,1,0,148,251,1,0,162,251,1,0,164,251,1,0,168,251,1,0,182,251,1,0,218,251,1,0,67,10,0,0,27,7,0,0,62,10,0,0,61,10,0,0,21,7,0,0,20,7,0,0,169,10,0,0,164,10,0,0,163,10,0,0,219,10,0,0,214,10,0,0,213,10,0,0,134,3,0,0,128,3,0,0,140,3,0,0,100,3,0,0,97,3,0,0,93,3,0,0,91,3,0,0,207,9,0,0,105,3,0,0,103,3,0,0,244,6,0,0,67,3,0,0,189,9,0,0,57,3,0,0,187,9,0,0,74,3,0,0,69,3,0,0,76,3,0,0,228,6,0,0,226,6,0,0,43,3,0,0,42,3,0,0,41,3,0,0,179,9,0,0,39,3,0,0,178,9,0,0,38,3,0,0,176,9,0,0,47,3,0,0,46,3,0,0,45,3,0,0,44,3,0,0,180,9,0,0,49,3,0,0,48,3,0,0,209,6,0,0,208,6,0,0,206,6,0,0,210,6,0,0,95,10,0,0,77,10,0,0,75,10,0,0,66,10,0,0,65,10,0,0,63,10,0,0,68,10,0,0,28,7,0,0,192,10,0,0,179,10,0,0,177,10,0,0,168,10,0,0,167,10,0,0,165,10,0,0,170,10,0,0,225,10,0,0,223,10,0,0,218,10,0,0,217,10,0,0,215,10,0,0,220,10,0,0,19,3,0,0,13,3,0,0,235,2,0,0,227,2,0,0,224,2,0,0,109,9,0,0,242,2,0,0,240,2,0,0,183,6,0,0,180,2,0,0,177,2,0,0,169,2,0,0,67,9,0,0,166,2,0,0,65,9,0,0,188,2,0,0,185,2,0,0,182,2,0,0,191,2,0,0,152,6,0,0,150,6,0,0,130,2,0,0,126,2,0,0,39,9,0,0,119,2,0,0,37,9,0,0,115,2,0,0,34,9,0,0,139,2,0,0,134,2,0,0,131,2,0,0,41,9,0,0,142,2,0,0,140,2,0,0,116,6,0,0,114,6,0,0,111,6,0,0,118,6,0,0,89,2,0,0,87,2,0,0,18,9,0,0,84,2,0,0,17,9,0,0,82,2,0,0,15,9,0,0,13,9,0,0,99,2,0,0,98,2,0,0,96,2,0,0,94,2,0,0,20,9,0,0,91,2,0,0,19,9,0,0,103,2,0,0,102,2,0,0,100,2,0,0,81,6,0,0,80,6,0,0,78,6,0,0,76,6,0,0,104,2,0,0,83,6,0,0,82,6,0,0,15,10,0,0,234,9,0,0,232,9,0,0,137,3,0,0,133,3,0,0,130,3,0,0,141,3,0,0,205,9,0,0,203,9,0,0,200,9,0,0,102,3,0,0,99,3,0,0,96,3,0,0,92,3,0,0,208,9,0,0,107,3,0,0,104,3,0,0,245,6,0,0,186,9,0,0,185,9,0,0,183,9,0,0,181,9,0,0,212,6,0,0,68,3,0,0,66,3,0,0,64,3,0,0,62,3,0,0,190,9,0,0,59,3,0,0,188,9,0,0,75,3,0,0,73,3,0,0,71,3,0,0,77,3,0,0,229,6,0,0,227,6,0,0,141,10,0,0,116,10,0,0,114,10,0,0,93,10,0,0,88,10,0,0,96,10,0,0,74,10,0,0,73,10,0,0,71,10,0,0,69,10,0,0,29,7,0,0,78,10,0,0,76,10,0,0,210,10,0,0,203,10,0,0,201,10,0,0,190,10,0,0,185,10,0,0,193,10,0,0,176,10,0,0,175,10,0,0,173,10,0,0,171,10,0,0,56,7,0,0,180,10,0,0,178,10,0,0,226,10,0,0,224,10,0,0,79,2,0,0,76,2,0,0,64,2,0,0,57,2,0,0,54,2,0,0,248,8,0,0,54,6,0,0,25,2,0,0,22,2,0,0,14,2,0,0,228,8,0,0,10,2,0,0,226,8,0,0,33,2,0,0,30,2,0,0,27,2,0,0,36,2,0,0,36,6,0,0,34,6,0,0,225,1,0,0,197,8,0,0,210,1,0,0,194,8,0,0,206,1,0,0,191,8,0,0,236,1,0,0,229,1,0,0,226,1,0,0,201,8,0,0,240,1,0,0,238,1,0,0,254,5,0,0,251,5,0,0,248,5,0,0,2,6,0,0,157,1,0,0,148,8,0,0,150,1,0,0,143,8,0,0,140,8,0,0,169,1,0,0,163,1,0,0,154,8,0,0,159,1,0,0,151,8,0,0,176,1,0,0,174,1,0,0,171,1,0,0,192,5,0,0,187,5,0,0,184,5,0,0,177,1,0,0,196,5,0,0,194,5,0,0,112,1,0,0,111,1,0,0,112,8,0,0,109,1,0,0,111,8,0,0,106,1,0,0,109,8,0,0,107,8,0,0,104,8,0,0,122,1,0,0,121,1,0,0,119,1,0,0,118,8,0,0,116,1,0,0,117,8,0,0,113,1,0,0,114,8,0,0,127,1,0,0,125,1,0,0,123,1,0,0,120,8,0,0,139,5,0,0,138,5,0,0,136,5,0,0,134,5,0,0,129,1,0,0,131,5,0,0,128,1,0,0,143,5,0,0,142,5,0,0,140,5,0,0,144,5,0,0,157,9,0,0,34,3,0,0,137,9,0,0,135,9,0,0,22,3,0,0,18,3,0,0,15,3,0,0,26,3,0,0,105,9,0,0,102,9,0,0,99,9,0,0,238,2,0,0,230,2,0,0,226,2,0,0,110,9,0,0,244,2,0,0,241,2,0,0,184,6,0,0,63,9,0,0,61,9,0,0,58,9,0,0,55,9,0,0,127,6,0,0,181,2,0,0,179,2,0,0,172,2,0,0,69,9,0,0,168,2,0,0,66,9,0,0,190,2,0,0,187,2,0,0,184,2,0,0,192,2,0,0,154,6,0,0,151,6,0,0,33,9,0,0,32,9,0,0,30,9,0,0,28,9,0,0,88,6,0,0,25,9,0,0,86,6,0,0,128,2,0,0,125,2,0,0,40,9,0,0,122,2,0,0,38,9,0,0,118,2,0,0,36,9,0,0,138,2,0,0,136,2,0,0,133,2,0,0,42,9,0,0,143,2,0,0,141,2,0,0,117,6,0,0,115,6,0,0,113,6,0,0,119,6,0,0,52,10,0,0,37,10,0,0,35,10,0,0,11,10,0,0,8,10,0,0,5,10,0,0,16,10,0,0,230,9,0,0,225,9,0,0,222,9,0,0,251,6,0,0,236,9,0,0,233,9,0,0,139,3,0,0,136,3,0,0,132,3,0,0,142,3,0,0,199,9,0,0,198,9,0,0,196,9,0,0,194,9,0,0,232,6,0,0,191,9,0,0,231,6,0,0,206,9,0,0,204,9,0,0,202,9,0,0,101,3,0,0,98,3,0,0,95,3,0,0,209,9,0,0,108,3,0,0,106,3,0,0,246,6,0,0,160,10,0,0,153,10,0,0,151,10,0,0,137,10,0,0,134,10,0,0,131,10,0,0,142,10,0,0,112,10,0,0,110,10,0,0,104,10,0,0,36,7,0,0,118,10,0,0,115,10,0,0,87,10,0,0,86,10,0,0,84,10,0,0,82,10,0,0,31,7,0,0,79,10,0,0,30,7,0,0,94,10,0,0,92,10,0,0,90,10,0,0,97,10,0,0,211,10,0,0,63,7,0,0,205,10,0,0,202,10,0,0,58,7,0,0,57,7,0,0,191,10,0,0,189,10,0,0,187,10,0,0,194,10,0,0,97,1,0,0,100,8,0,0,88,1,0,0,86,1,0,0,80,1,0,0,94,8,0,0,76,1,0,0,92,8,0,0,89,1,0,0,95,5,0,0,93,5,0,0,50,1,0,0,82,8,0,0,43,1,0,0,80,8,0,0,39,1,0,0,77,8,0,0,63,1,0,0,58,1,0,0,55,1,0,0,84,8,0,0,74,5,0,0,72,5,0,0,69,5,0,0,76,5,0,0,6,1,0,0,1,1,0,0,53,8,0,0,253,0,0,0,48,8,0,0,45,8,0,0,18,1,0,0,17,1,0,0,11,1,0,0,59,8,0,0,7,1,0,0,56,8,0,0,24,1,0,0,22,1,0,0,19,1,0,0,36,5,0,0,31,5,0,0,28,5,0,0,40,5,0,0,38,5,0,0,4,8,0,0,202,0,0,0,2,8,0,0,252,7,0,0,248,7,0,0,219,0,0,0,15,8,0,0,212,0,0,0,12,8,0,0,208,0,0,0,7,8,0,0,224,0,0,0,221,0,0,0,18,8,0,0,236,4,0,0,234,4,0,0,228,4,0,0,231,0,0,0,224,4,0,0,229,0,0,0,242,4,0,0,240,4,0,0,237,4,0,0,244,4,0,0,155,0,0,0,206,7,0,0,153,0,0,0,204,7,0,0,202,7,0,0,199,7,0,0,196,7,0,0,165,0,0,0,164,0,0,0,215,7,0,0,162,0,0,0,214,7,0,0,159,0,0,0,211,7,0,0,208,7,0,0,172,0,0,0,171,0,0,0,169,0,0,0,220,7,0,0,166,0,0,0,218,7,0,0,162,4,0,0,160,4,0,0,158,4,0,0,155,4,0,0,175,0,0,0,152,4,0,0,173,0,0,0,168,4,0,0,167,4,0,0,165,4,0,0,163,4,0,0,176,0,0,0,170,4,0,0,169,4,0,0,9,9,0,0,3,9,0,0,1,9,0,0,80,2,0,0,77,2,0,0,246,8,0,0,244,8,0,0,241,8,0,0,66,2,0,0,60,2,0,0,56,2,0,0,249,8,0,0,68,2,0,0,55,6,0,0,224,8,0,0,219,8,0,0,216,8,0,0,11,6,0,0,26,2,0,0,24,2,0,0,17,2,0,0,230,8,0,0,13,2,0,0,227,8,0,0,35,2,0,0,32,2,0,0,29,2,0,0,38,6,0,0,35,6,0,0,189,8,0,0,187,8,0,0,181,8,0,0,213,5,0,0,177,8,0,0,209,5,0,0,222,1,0,0,199,8,0,0,214,1,0,0,196,8,0,0,209,1,0,0,193,8,0,0,237,1,0,0,232,1,0,0,228,1,0,0,202,8,0,0,242,1,0,0,239,1,0,0,0,6,0,0,253,5,0,0,250,5,0,0,3,6,0,0,139,8,0,0,138,8,0,0,136,8,0,0,134,8,0,0,152,5,0,0,131,8,0,0,150,5,0,0,128,8,0,0,147,5,0,0,158,1,0,0,156,1,0,0,149,8,0,0,153,1,0,0,147,8,0,0,149,1,0,0,145,8,0,0,142,8,0,0,170,1,0,0,168,1,0,0,165,1,0,0,155,8,0,0,162,1,0,0,153,8,0,0,175,1,0,0,173,1,0,0,193,5,0,0,191,5,0,0,189,5,0,0,186,5,0,0,178,1,0,0,197,5,0,0,195,5,0,0,174,9,0,0,168,9,0,0,166,9,0,0,155,9,0,0,153,9,0,0,150,9,0,0,158,9,0,0,35,3,0,0,133,9,0,0,128,9,0,0,125,9,0,0,190,6,0,0,139,9,0,0,136,9,0,0,24,3,0,0,21,3,0,0,17,3,0,0,97,9,0,0,95,9,0,0,89,9,0,0,166,6,0,0,85,9,0,0,163,6,0,0,107,9,0,0,104,9,0,0,101,9,0,0,233,2,0,0,229,2,0,0,111,9,0,0,246,2,0,0,243,2,0,0,185,6,0,0,54,9,0,0,53,9,0,0,51,9,0,0,49,9,0,0,125,6,0,0,46,9,0,0,124,6,0,0,43,9,0,0,121,6,0,0,64,9,0,0,62,9,0,0,60,9,0,0,57,9,0,0,130,6,0,0,178,2,0,0,175,2,0,0,70,9,0,0,171,2,0,0,68,9,0,0,189,2,0,0,186,2,0,0,193,2,0,0,155,6,0,0,153,6,0,0,59,10,0,0,57,10,0,0,50,10,0,0,48,10,0,0,45,10,0,0,53,10,0,0,33,10,0,0,28,10,0,0,25,10,0,0,11,7,0,0,39,10,0,0,36,10,0,0,3,10,0,0,1,10,0,0,251,9,0,0,5,7,0,0,247,9,0,0,3,7,0,0,13,10,0,0,10,10,0,0,7,10,0,0,17,10,0,0,221,9,0,0,220,9,0,0,218,9,0,0,216,9,0,0,250,6,0,0,213,9,0,0,249,6,0,0,210,9,0,0,247,6,0,0,231,9,0,0,229,9,0,0,227,9,0,0,224,9,0,0,252,6,0,0,237,9,0,0,235,9,0,0,138,3,0,0,135,3,0,0,143,3,0,0,161,10,0,0,52,7,0,0,155,10,0,0,152,10,0,0,46,7,0,0,44,7,0,0,139,10,0,0,136,10,0,0,133,10,0,0,143,10,0,0,35,7,0,0,34,7,0,0,32,7,0,0,113,10,0,0,111,10,0,0,109,10,0,0,106,10,0,0,37,7,0,0,119,10,0,0,117,10,0,0,66,7,0,0,65,7,0,0,212,10,0,0,62,7,0,0,61,7,0,0,59,7,0,0,64,7,0,0,206,10,0,0,204,10,0,0,143,0,0,0,195,7,0,0,139,0,0,0,194,7,0,0,135,0,0,0,133,0,0,0,131,0,0,0,192,7,0,0,128,0,0,0,191,7,0,0,125,0,0,0,189,7,0,0,138,0,0,0,137,0,0,0,136,0,0,0,193,7,0,0,109,4,0,0,108,4,0,0,106,4,0,0,112,0,0,0,110,0,0,0,182,7,0,0,107,0,0,0,181,7,0,0,104,0,0,0,179,7,0,0,177,7,0,0,122,0,0,0,121,0,0,0,119,0,0,0,117,0,0,0,185,7,0,0,114,0,0,0,184,7,0,0,124,0,0,0,91,4,0,0,90,4,0,0,88,4,0,0,86,4,0,0,93,4,0,0,92,4,0,0,84,0,0,0,83,0,0,0,161,7,0,0,81,0,0,0,160,7,0,0,78,0,0,0,158,7,0,0,156,7,0,0,153,7,0,0,94,0,0,0,93,0,0,0,91,0,0,0,167,7,0,0,88,0,0,0,166,7,0,0,85,0,0,0,163,7,0,0,99,0,0,0,97,0,0,0,95,0,0,0,169,7,0,0,62,4,0,0,61,4,0,0,59,4,0,0,57,4,0,0,54,4,0,0,100,0,0,0,66,4,0,0,65,4,0,0,63,4,0,0,67,4,0,0,49,0,0,0,47,0,0,0,125,7,0,0,44,0,0,0,123,7,0,0,121,7,0,0,118,7,0,0,115,7,0,0,59,0,0,0,134,7,0,0,56,0,0,0,133,7,0,0,53,0,0,0,130,7,0,0,127,7,0,0,66,0,0,0,64,0,0,0,139,7,0,0,61,0,0,0,137,7,0,0,18,4,0,0,16,4,0,0,14,4,0,0,71,0,0,0,11,4,0,0,70,0,0,0,8,4,0,0,68,0,0,0,24,4,0,0,23,4,0,0,21,4,0,0,19,4,0,0,26,4,0,0,25,4,0,0,12,0,0,0,10,0,0,0,77,7,0,0,75,7,0,0,72,7,0,0,69,7,0,0,21,0,0,0,88,7,0,0,19,0,0,0,85,7,0,0,82,7,0,0,79,7,0,0,28,0,0,0,96,7,0,0,25,0,0,0,94,7,0,0,22,0,0,0,91,7,0,0,214,3,0,0,212,3,0,0,209,3,0,0,206,3,0,0,32,0,0,0,30,0,0,0,223,3,0,0,221,3,0,0,219,3,0,0,216,3,0,0,34,0,0,0,227,3,0,0,226,3,0,0,224,3,0,0,103,8,0,0,102,8,0,0,99,8,0,0,98,8,0,0,96,8,0,0,100,1,0,0,99,1,0,0,98,1,0,0,101,8,0,0,91,8,0,0,90,8,0,0,88,8,0,0,86,8,0,0,79,5,0,0,87,1,0,0,85,1,0,0,82,1,0,0,95,8,0,0,79,1,0,0,93,8,0,0,92,1,0,0,91,1,0,0,90,1,0,0,96,5,0,0,94,5,0,0,76,8,0,0,75,8,0,0,73,8,0,0,71,8,0,0,46,5,0,0,68,8,0,0,44,5,0,0,54,1,0,0,52,1,0,0,49,1,0,0,83,8,0,0,46,1,0,0,81,8,0,0,42,1,0,0,79,8,0,0,64,1,0,0,62,1,0,0,60,1,0,0,57,1,0,0,85,8,0,0,66,1,0,0,65,1,0,0,75,5,0,0,73,5,0,0,71,5,0,0,77,5,0,0,44,8,0,0,43,8,0,0,41,8,0,0,39,8,0,0,252,4,0,0,36,8,0,0,250,4,0,0,33,8,0,0,247,4,0,0,3,1,0,0,54,8,0,0,0,1,0,0,52,8,0,0,252,0,0,0,50,8,0,0,47,8,0,0,16,1,0,0,13,1,0,0,60,8,0,0,10,1,0,0,58,8,0,0,25,1,0,0,23,1,0,0,21,1,0,0,37,5,0,0,35,5,0,0,33,5,0,0,30,5,0,0,26,1,0,0,41,5,0,0,39,5,0,0,247,7,0,0,245,7,0,0,243,7,0,0,240,7,0,0,179,4,0,0,237,7,0,0,176,4,0,0,173,4,0,0,207,0,0,0,5,8,0,0,205,0,0,0,3,8,0,0,201,0,0,0,1,8,0,0,254,7,0,0,251,7,0,0,220,0,0,0,218,0,0,0,16,8,0,0,215,0,0,0,14,8,0,0,211,0,0,0,11,8,0,0,228,0,0,0,226,0,0,0,223,0,0,0,21,8,0,0,235,4,0,0,233,4,0,0,230,4,0,0,232,0,0,0,227,4,0,0,230,0,0,0,243,4,0,0,241,4,0,0,239,4,0,0,12,9,0,0,11,9,0,0,8,9,0,0,7,9,0,0,5,9,0,0,10,9,0,0,0,9,0,0,255,8,0,0,253,8,0,0,251,8,0,0,57,6,0,0,4,9,0,0,2,9,0,0,78,2,0,0,240,8,0,0,239,8,0,0,237,8,0,0,235,8,0,0,42,6,0,0,232,8,0,0,41,6,0,0,247,8,0,0,245,8,0,0,243,8,0,0,67,2,0,0,65,2,0,0,62,2,0,0,59,2,0,0,250,8,0,0,70,2,0,0,69,2,0,0,56,6,0,0,215,8,0,0,214,8,0,0,212,8],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE+10240);allocate([210,8,0,0,9,6,0,0,207,8,0,0,8,6,0,0,204,8,0,0,5,6,0,0,225,8,0,0,223,8,0,0,221,8,0,0,218,8,0,0,14,6,0,0,23,2,0,0,20,2,0,0,231,8,0,0,16,2,0,0,229,8,0,0,34,2,0,0,31,2,0,0,37,2,0,0,39,6,0,0,37,6,0,0,176,8,0,0,174,8,0,0,172,8,0,0,206,5,0,0,169,8,0,0,205,5,0,0,166,8,0,0,202,5,0,0,199,5,0,0,190,8,0,0,188,8,0,0,186,8,0,0,183,8,0,0,216,5,0,0,180,8,0,0,212,5,0,0,224,1,0,0,221,1,0,0,200,8,0,0,217,1,0,0,198,8,0,0,213,1,0,0,195,8,0,0,234,1,0,0,231,1,0,0,203,8,0,0,241,1,0,0,1,6,0,0,255,5,0,0,252,5,0,0,173,9,0,0,172,9,0,0,170,9,0,0,175,9,0,0,165,9,0,0,164,9,0,0,162,9,0,0,160,9,0,0,194,6,0,0,169,9,0,0,167,9,0,0,149,9,0,0,148,9,0,0,146,9,0,0,144,9,0,0,193,6,0,0,141,9,0,0,192,6,0,0,156,9,0,0,154,9,0,0,152,9,0,0,159,9,0,0,37,3,0,0,36,3,0,0,124,9,0,0,123,9,0,0,121,9,0,0,119,9,0,0,189,6,0,0,116,9,0,0,188,6,0,0,113,9,0,0,186,6,0,0,134,9,0,0,132,9,0,0,130,9,0,0,127,9,0,0,191,6,0,0,140,9,0,0,138,9,0,0,25,3,0,0,23,3,0,0,20,3,0,0,27,3,0,0,84,9,0,0,82,9,0,0,80,9,0,0,161,6,0,0,77,9,0,0,160,6,0,0,74,9,0,0,158,6,0,0,156,6,0,0,98,9,0,0,96,9,0,0,94,9,0,0,91,9,0,0,167,6,0,0,88,9,0,0,165,6,0,0,108,9,0,0,106,9,0,0,103,9,0,0,239,2,0,0,236,2,0,0,232,2,0,0,112,9,0,0,247,2,0,0,245,2,0,0,15,7,0,0,60,10,0,0,58,10,0,0,14,7,0,0,13,7,0,0,51,10,0,0,49,10,0,0,47,10,0,0,54,10,0,0,10,7,0,0,9,7,0,0,7,7,0,0,34,10,0,0,32,10,0,0,30,10,0,0,27,10,0,0,12,7,0,0,40,10,0,0,38,10,0,0,2,7,0,0,1,7,0,0,255,6,0,0,253,6,0,0,4,10,0,0,2,10,0,0,0,10,0,0,253,9,0,0,6,7,0,0,250,9,0,0,4,7,0,0,14,10,0,0,12,10,0,0,9,10,0,0,18,10,0,0,55,7,0,0,54,7,0,0,162,10,0,0,51,7,0,0,50,7,0,0,48,7,0,0,53,7,0,0,156,10,0,0,154,10,0,0,43,7,0,0,42,7,0,0,40,7,0,0,38,7,0,0,47,7,0,0,45,7,0,0,140,10,0,0,138,10,0,0,135,10,0,0,144,10,0,0,25,7,0,0,19,7,0,0,18,7,0,0,129,3,0,0,94,3,0,0,241,6,0,0,61,3,0,0,58,3,0,0,70,3,0,0,224,6,0,0,222,6,0,0,40,3,0,0,177,9,0,0,205,6,0,0,204,6,0,0,202,6,0,0,207,6,0,0,64,10,0,0,26,7,0,0,166,10,0,0,216,10,0,0,14,3,0,0,228,2,0,0,225,2,0,0,179,6,0,0,174,2,0,0,167,2,0,0,183,2,0,0,146,6,0,0,144,6,0,0,127,2,0,0,116,2,0,0,35,9,0,0,135,2,0,0,132,2,0,0,109,6,0,0,107,6,0,0,104,6,0,0,112,6,0,0,90,2,0,0,88,2,0,0,85,2,0,0,83,2,0,0,16,9,0,0,81,2,0,0,14,9,0,0,97,2,0,0,95,2,0,0,92,2,0,0,75,6,0,0,74,6,0,0,72,6,0,0,70,6,0,0,101,2,0,0,79,6,0,0,77,6,0,0,24,9,0,0,158,3,0,0,156,3,0,0,124,3,0,0,118,3,0,0,131,3,0,0,89,3,0,0,82,3,0,0,201,9,0,0,242,6,0,0,56,3,0,0,55,3,0,0,53,3,0,0,51,3,0,0,184,9,0,0,50,3,0,0,182,9,0,0,65,3,0,0,63,3,0,0,60,3,0,0,72,3,0,0,225,6,0,0,223,6,0,0,89,10,0,0,72,10,0,0,70,10,0,0,186,10,0,0,174,10,0,0,172,10,0,0,222,10,0,0,221,10,0,0,58,2,0,0,55,2,0,0,51,6,0,0,19,2,0,0,15,2,0,0,11,2,0,0,28,2,0,0,30,6,0,0,28,6,0,0,220,1,0,0,211,1,0,0,207,1,0,0,192,8,0,0,230,1,0,0,227,1,0,0,244,5,0,0,241,5,0,0,238,5,0,0,249,5,0,0,155,1,0,0,147,1,0,0,144,8,0,0,143,1,0,0,141,8,0,0,167,1,0,0,160,1,0,0,182,5,0,0,177,5,0,0,174,5,0,0,172,1,0,0,188,5,0,0,185,5,0,0,162,8,0,0,110,1,0,0,107,1,0,0,110,8,0,0,104,1,0,0,108,8,0,0,101,1,0,0,105,8,0,0,120,1,0,0,117,1,0,0,114,1,0,0,115,8,0,0,130,5,0,0,129,5,0,0,127,5,0,0,125,5,0,0,126,1,0,0,122,5,0,0,124,1,0,0,137,5,0,0,135,5,0,0,132,5,0,0,141,5,0,0,127,8,0,0,126,8,0,0,9,3,0,0,6,3,0,0,3,3,0,0,16,3,0,0,220,2,0,0,213,2,0,0,210,2,0,0,100,9,0,0,231,2,0,0,180,6,0,0,164,2,0,0,162,2,0,0,156,2,0,0,59,9,0,0,153,2,0,0,56,9,0,0,173,2,0,0,148,6,0,0,145,6,0,0,114,2,0,0,112,2,0,0,110,2,0,0,31,9,0,0,108,2,0,0,29,9,0,0,105,2,0,0,26,9,0,0,129,2,0,0,123,2,0,0,137,2,0,0,110,6,0,0,108,6,0,0,106,6,0,0,6,10,0,0,160,3,0,0,157,3,0,0,226,9,0,0,223,9,0,0,126,3,0,0,123,3,0,0,120,3,0,0,197,9,0,0,195,9,0,0,192,9,0,0,90,3,0,0,88,3,0,0,86,3,0,0,83,3,0,0,243,6,0,0,132,10,0,0,108,10,0,0,105,10,0,0,85,10,0,0,83,10,0,0,80,10,0,0,91,10,0,0,208,10,0,0,199,10,0,0,197,10,0,0,184,10,0,0,183,10,0,0,181,10,0,0,188,10,0,0,96,1,0,0,102,5,0,0,84,1,0,0,81,1,0,0,77,1,0,0,91,5,0,0,89,5,0,0,51,1,0,0,44,1,0,0,40,1,0,0,78,8,0,0,59,1,0,0,56,1,0,0,67,5,0,0,62,5,0,0,70,5,0,0,5,1,0,0,2,1,0,0,250,0,0,0,49,8,0,0,246,0,0,0,46,8,0,0,15,1,0,0,12,1,0,0,8,1,0,0,26,5,0,0,21,5,0,0,18,5,0,0,20,1,0,0,32,5,0,0,29,5,0,0,67,8,0,0,203,0,0,0,0,8,0,0,195,0,0,0,253,7,0,0,191,0,0,0,249,7,0,0,213,0,0,0,209,0,0,0,8,8,0,0,222,4,0,0,220,4,0,0,214,4,0,0,225,0,0,0,210,4,0,0,222,0,0,0,232,4,0,0,229,4,0,0,225,4,0,0,238,4,0,0,32,8,0,0,31,8,0,0,154,0,0,0,205,7,0,0,150,0,0,0,203,7,0,0,147,0,0,0,200,7,0,0,197,7,0,0,163,0,0,0,160,0,0,0,212,7,0,0,156,0,0,0,209,7,0,0,151,4,0,0,150,4,0,0,148,4,0,0,146,4,0,0,143,4,0,0,170,0,0,0,140,4,0,0,167,0,0,0,161,4,0,0,159,4,0,0,156,4,0,0,153,4,0,0,174,0,0,0,166,4,0,0,164,4,0,0,233,7,0,0,232,7,0,0,230,7,0,0,75,2,0,0,74,2,0,0,52,2,0,0,47,2,0,0,44,2,0,0,242,8,0,0,61,2,0,0,52,6,0,0,8,2,0,0,6,2,0,0,0,2,0,0,220,8,0,0,252,1,0,0,217,8,0,0,18,2,0,0,32,6,0,0,29,6,0,0,205,1,0,0,201,1,0,0,185,8,0,0,194,1,0,0,182,8,0,0,190,1,0,0,178,8,0,0,223,1,0,0,215,1,0,0,233,1,0,0,246,5,0,0,243,5,0,0,240,5,0,0,141,1,0,0,139,1,0,0,137,8,0,0,136,1,0,0,135,8,0,0,133,1,0,0,132,8,0,0,129,8,0,0,154,1,0,0,146,8,0,0,146,1,0,0,166,1,0,0,183,5,0,0,181,5,0,0,179,5,0,0,176,5,0,0,190,5,0,0,151,9,0,0,31,3,0,0,129,9,0,0,126,9,0,0,11,3,0,0,8,3,0,0,5,3,0,0,93,9,0,0,90,9,0,0,86,9,0,0,222,2,0,0,216,2,0,0,212,2,0,0,234,2,0,0,181,6,0,0,52,9,0,0,50,9,0,0,47,9,0,0,44,9,0,0,122,6,0,0,165,2,0,0,163,2,0,0,161,2,0,0,158,2,0,0,155,2,0,0,176,2,0,0,149,6,0,0,147,6,0,0,46,10,0,0,29,10,0,0,26,10,0,0,255,9,0,0,252,9,0,0,248,9,0,0,159,3,0,0,219,9,0,0,217,9,0,0,214,9,0,0,211,9,0,0,248,6,0,0,228,9,0,0,127,3,0,0,125,3,0,0,122,3,0,0,158,10,0,0,149,10,0,0,147,10,0,0,129,10,0,0,127,10,0,0,124,10,0,0,103,10,0,0,102,10,0,0,100,10,0,0,98,10,0,0,33,7,0,0,107,10,0,0,209,10,0,0,60,7,0,0,200,10,0,0,198,10,0,0,142,0,0,0,141,0,0,0,115,4,0,0,114,4,0,0,134,0,0,0,132,0,0,0,129,0,0,0,126,0,0,0,190,7,0,0,105,4,0,0,104,4,0,0,102,4,0,0,107,4,0,0,113,0,0,0,111,0,0,0,108,0,0,0,105,0,0,0,180,7,0,0,101,0,0,0,178,7,0,0,120,0,0,0,118,0,0,0,115,0,0,0,85,4,0,0,84,4,0,0,82,4,0,0,80,4,0,0,123,0,0,0,89,4,0,0,87,4,0,0,82,0,0,0,79,0,0,0,159,7,0,0,75,0,0,0,157,7,0,0,72,0,0,0,154,7,0,0,92,0,0,0,89,0,0,0,86,0,0,0,164,7,0,0,53,4,0,0,52,4,0,0,50,4,0,0,48,4,0,0,98,0,0,0,45,4,0,0,96,0,0,0,60,4,0,0,58,4,0,0,55,4,0,0,64,4,0,0,176,7,0,0,175,7,0,0,48,0,0,0,45,0,0,0,124,7,0,0,42,0,0,0,122,7,0,0,39,0,0,0,119,7,0,0,116,7,0,0,60,0,0,0,57,0,0,0,54,0,0,0,131,7,0,0,50,0,0,0,128,7,0,0,7,4,0,0,6,4,0,0,4,4,0,0,2,4,0,0,67,0,0,0,255,3,0,0,65,0,0,0,252,3,0,0,62,0,0,0,17,4,0,0,15,4,0,0,12,4,0,0,9,4,0,0,69,0,0,0,22,4,0,0,20,4,0,0,152,7,0,0,151,7,0,0,149,7,0,0,11,0,0,0,9,0,0,0,76,7,0,0,7,0,0,0,73,7,0,0,70,7,0,0,67,7,0,0,20,0,0,0,86,7,0,0,16,0,0,0,83,7,0,0,13,0,0,0,80,7,0,0,202,3,0,0,200,3,0,0,198,3,0,0,195,3,0,0,29,0,0,0,192,3,0,0,26,0,0,0,23,0,0,0,215,3,0,0,213,3,0,0,210,3,0,0,207,3,0,0,33,0,0,0,203,3,0,0,31,0,0,0,222,3,0,0,220,3,0,0,217,3,0,0,114,7,0,0,112,7,0,0,110,7,0,0,225,3,0,0,95,1,0,0,97,8,0,0,103,5,0,0,75,1,0,0,74,1,0,0,72,1,0,0,70,1,0,0,89,8,0,0,67,1,0,0,87,8,0,0,83,1,0,0,92,5,0,0,90,5,0,0,38,1,0,0,37,1,0,0,35,1,0,0,33,1,0,0,74,8,0,0,30,1,0,0,72,8,0,0,27,1,0,0,69,8,0,0,53,1,0,0,47,1,0,0,61,1,0,0,68,5,0,0,66,5,0,0,64,5,0,0,245,0,0,0,244,0,0,0,242,0,0,0,42,8,0,0,239,0,0,0,40,8,0,0,236,0,0,0,37,8,0,0,34,8,0,0,4,1,0,0,51,8,0,0,249,0,0,0,14,1,0,0,27,5,0,0,25,5,0,0,23,5,0,0,20,5,0,0,34,5,0,0,189,0,0,0,246,7,0,0,186,0,0,0,244,7,0,0,183,0,0,0,241,7,0,0,238,7,0,0,234,7,0,0,206,0,0,0,198,0,0,0,255,7,0,0,194,0,0,0,216,0,0,0,223,4,0,0,221,4,0,0,219,4,0,0,216,4,0,0,227,0,0,0,213,4,0,0,231,4,0,0,6,9,0,0,254,8,0,0,252,8,0,0,238,8,0,0,236,8,0,0,233,8,0,0,53,2,0,0,51,2,0,0,49,2,0,0,46,2,0,0,63,2,0,0,53,6,0,0,213,8,0,0,211,8,0,0,208,8,0,0,205,8,0,0,6,6,0,0,9,2,0,0,7,2,0,0,5,2,0,0,2,2,0,0,222,8,0,0,255,1,0,0,21,2,0,0,33,6,0,0,31,6,0,0,175,8,0,0,173,8,0,0,170,8,0,0,167,8,0,0,203,5,0,0,163,8,0,0,200,5,0,0,203,1,0,0,200,1,0,0,197,1,0,0,184,8,0,0,193,1,0,0,218,1,0,0,235,1,0,0,247,5,0,0,245,5,0,0,242,5,0,0,171,9,0,0,163,9,0,0,161,9,0,0,147,9,0,0,145,9,0,0,142,9,0,0,33,3,0,0,32,3,0,0,122,9,0,0,120,9,0,0,117,9,0,0,114,9,0,0,187,6,0,0,131,9,0,0,12,3,0,0,10,3,0,0,7,3,0,0,83,9,0,0,81,9,0,0,78,9,0,0,75,9,0,0,159,6,0,0,71,9,0,0,157,6,0,0,92,9,0,0,223,2,0,0,221,2,0,0,218,2,0,0,215,2,0,0,237,2,0,0,182,6,0,0,56,10,0,0,55,10,0,0,44,10,0,0,43,10,0,0,41,10,0,0,24,10,0,0,23,10,0,0,21,10,0,0,19,10,0,0,8,7,0,0,31,10,0,0,246,9,0,0,245,9,0,0,243,9,0,0,241,9,0,0,0,7,0,0,238,9,0,0,254,6,0,0,254,9,0,0,161,3,0,0,159,10,0,0,49,7,0,0,150,10,0,0,148,10,0,0,41,7,0,0,39,7,0,0,130,10,0,0,128,10,0,0,126,10,0,0,23,7,0,0,17,7,0,0,16,7,0,0,238,6,0,0,220,6,0,0,218,6,0,0,201,6,0,0,200,6,0,0,198,6,0,0,203,6,0,0,24,7,0,0,175,6,0,0,140,6,0,0,138,6,0,0,121,2,0,0,117,2,0,0,102,6,0,0,100,6,0,0,97,6,0,0,105,6,0,0,86,2,0,0,69,6,0,0,68,6,0,0,66,6,0,0,64,6,0,0,93,2,0,0,73,6,0,0,71,6,0,0,23,9,0,0,119,3,0,0,85,3,0,0,239,6,0,0,54,3,0,0,52,3,0,0,221,6,0,0,219,6,0,0,48,6,0,0,12,2,0,0,24,6,0,0,22,6,0,0,212,1,0,0,208,1,0,0,234,5,0,0,231,5,0,0,228,5,0,0,239,5,0,0,152,1,0,0,148,1,0,0,144,1,0,0,172,5,0,0,167,5,0,0,164,5,0,0,161,1,0,0,178,5,0,0,175,5,0,0,160,8,0,0,108,1,0,0,105,1,0,0,102,1,0,0,106,8,0,0,121,5,0,0,120,5,0,0,118,5,0,0,116,5,0,0,118,1,0,0,113,5,0,0,115,1,0,0,128,5,0,0,126,5,0,0,123,5,0,0,133,5,0,0,125,8,0,0,124,8,0,0,4,3,0,0,214,2,0,0,211,2,0,0,176,6,0,0,160,2,0,0,157,2,0,0,154,2,0,0,170,2,0,0,142,6,0,0,139,6,0,0,113,2,0,0,111,2,0,0,109,2,0,0,106,2,0,0,27,9,0,0,124,2,0,0,120,2,0,0,103,6,0,0,101,6,0,0,99,6,0,0,152,3,0,0,150,3,0,0,116,3,0,0,112,3,0,0,121,3,0,0,81,3,0,0,80,3,0,0,79,3,0,0,78,3,0,0,193,9,0,0,87,3,0,0,84,3,0,0,240,6,0,0,81,10,0,0,182,10,0,0,227,10,0,0,100,5,0,0,78,1,0,0,87,5,0,0,85,5,0,0,45,1,0,0,41,1,0,0,60,5,0,0,58,5,0,0,55,5,0,0,63,5,0,0,255,0,0,0,251,0,0,0,247,0,0,0,16,5,0,0,11,5,0,0,8,5,0,0,9,1,0,0,22,5,0,0,19,5,0,0,65,8,0,0,204,0,0,0,196,0,0,0,192,0,0,0,250,7,0,0,208,4,0,0,206,4,0,0,200,4,0,0,214,0,0,0,196,4,0,0,210,0,0,0,218,4,0,0,215,4,0,0,211,4,0,0,226,4,0,0,29,8,0,0,27,8,0,0,151,0,0,0,148,0,0,0,201,7,0,0,144,0,0,0,198,7,0,0,139,4,0,0,138,4,0,0,136,4,0,0,134,4,0,0,131,4,0,0,161,0,0,0,128,4,0,0,157,0,0,0,149,4,0,0,147,4,0,0,144,4,0,0,141,4,0,0,168,0,0,0,157,4,0,0,154,4,0,0,229,7,0,0,228,7,0,0,226,7,0,0,231,7,0,0,73,2,0,0,48,2,0,0,45,2,0,0,49,6,0,0,4,2,0,0,253,1,0,0,26,6,0,0,23,6,0,0,202,1,0,0,191,1,0,0,179,8,0,0,216,1,0,0,236,5,0,0,233,5,0,0,230,5,0,0,142,1,0,0,140,1,0,0,137,1,0,0,134,1,0,0,133,8,0,0,130,1,0,0,130,8,0,0,151,1,0,0,173,5,0,0,171,5,0,0,169,5,0,0,166,5,0,0,164,1,0,0,180,5,0,0,161,8,0,0,1,3,0,0,252,2,0,0,208,2,0,0,200,2,0,0,87,9,0,0,217,2,0,0,177,6,0,0,152,2,0,0,151,2,0,0,149,2,0,0,147,2,0,0,48,9,0,0,144,2,0,0,45,9,0,0,159,2,0,0,143,6,0,0,141,6,0,0,249,9,0,0,154,3,0,0,151,3,0,0,215,9,0,0,212,9,0,0,117,3,0,0,115,3,0,0,113,3,0,0,125,10,0,0,101,10,0,0,99,10,0,0,207,10,0,0,196,10,0,0,195,10,0,0,140,0,0,0,113,4,0,0,112,4,0,0,130,0,0,0,127,0,0,0,101,4,0,0,100,4,0,0,98,4,0,0,103,4,0,0,109,0,0,0,106,0,0,0,102,0,0,0,79,4,0,0,78,4,0,0,76,4,0,0,74,4,0,0,116,0,0,0,83,4,0,0,81,4,0,0,188,7,0,0,80,0,0,0,76,0,0,0,73,0,0,0,155,7,0,0,44,4,0,0,43,4,0,0,41,4,0,0,39,4,0,0,90,0,0,0,36,4,0,0,87,0,0,0,51,4,0,0,49,4,0,0,46,4,0,0,56,4,0,0,174,7,0,0,173,7,0,0,46,0,0,0,43,0,0,0,40,0,0,0,120,7,0,0,36,0,0,0,117,7,0,0,251,3,0,0,250,3,0,0,248,3,0,0,246,3,0,0,58,0,0,0,243,3,0,0,55,0,0,0,240,3,0,0,51,0,0,0,5,4,0,0,3,4,0,0,0,4,0,0,253,3,0,0,63,0,0,0,13,4,0,0,10,4,0,0,148,7,0,0,147,7,0,0,145,7,0,0,150,7,0,0,8,0,0,0,74,7,0,0,4,0,0,0,71,7,0,0,1,0,0,0,68,7,0,0,188,3,0,0,186,3,0,0,184,3,0,0,181,3,0,0,178,3,0,0,17,0,0,0,14,0,0,0,201,3,0,0,199,3,0,0,196,3,0,0,193,3,0,0,27,0,0,0,189,3,0,0,24,0,0,0,211,3,0,0,208,3,0,0,204,3,0,0,109,7,0,0,108,7,0,0,106,7,0,0,104,7,0,0,218,3,0,0,113,7,0,0,111,7,0,0,94,1,0,0,93,1,0,0,101,5,0,0,73,1,0,0,71,1,0,0,68,1,0,0,88,5,0,0,86,5,0,0,36,1,0,0,34,1,0,0,31,1,0,0,28,1,0,0,70,8,0,0,48,1,0,0,61,5,0,0,59,5,0,0,57,5,0,0,65,5,0,0,243,0,0,0,240,0,0,0,237,0,0,0,38,8,0,0,233,0,0,0,35,8,0,0,254,0,0,0,17,5,0,0,15,5,0,0,13,5,0,0,10,5,0,0,24,5,0,0,66,8,0,0,190,0,0,0,187,0,0,0,184,0,0,0,242,7,0,0,180,0,0,0,239,7,0,0,177,0,0,0,235,7,0,0,199,0,0,0,209,4,0,0,207,4,0,0,205,4,0,0,202,4,0,0,217,0,0,0,199,4,0,0,217,4,0,0,30,8,0,0,28,8,0,0,72,2,0,0,43,2,0,0,42,2,0,0,40,2,0,0,38,2,0,0,234,8,0,0,50,2,0,0,50,6,0,0,251,1,0,0,250,1,0,0,248,1,0,0,246,1,0,0,209,8,0,0,243,1,0,0,206,8,0,0,3,2,0,0,27,6,0,0,25,6,0,0,189,1,0,0,187,1,0,0,185,1,0,0,171,8,0,0,182,1,0,0,168,8,0,0,179,1,0,0,164,8,0,0,204,1,0,0,198,1,0,0,219,1,0,0,237,5,0,0,235,5,0,0,232,5,0,0,143,9,0,0,30,3,0,0,29,3,0,0,118,9,0,0,115,9,0,0,2,3,0,0,0,3,0,0,254,2,0,0,79,9,0,0,76,9,0,0,72,9,0,0,209,2,0,0,207,2,0,0,205,2,0,0,202,2,0,0,219,2,0,0,178,6,0,0,42,10,0,0,22,10,0,0,20,10,0,0,244,9,0,0,242,9,0,0,239,9,0,0,155,3,0,0,153,3,0,0,157,10,0,0,146,10,0,0,145,10,0,0,123,10,0,0,122,10,0,0,120,10,0,0,235,6,0,0,216,6,0,0,214,6,0,0,197,6,0,0,196,6,0,0,195,6,0,0,199,6,0,0,22,7,0,0,171,6,0,0,134,6,0,0,132,6,0,0,95,6,0,0,93,6,0,0,90,6,0,0,98,6,0,0,63,6,0,0,62,6,0,0,60,6,0,0,58,6,0,0,67,6,0,0,65,6,0,0,22,9,0,0,236,6,0,0,217,6,0,0,215,6,0,0,45,6,0,0,18,6,0,0,16,6,0,0,224,5,0,0,221,5,0,0,218,5,0,0,229,5,0,0,162,5,0,0,157,5,0,0,154,5,0,0,145,1,0,0,168,5,0,0,165,5,0,0,158,8,0,0,112,5,0,0,111,5,0,0,109,5,0,0,107,5,0,0,104,5,0,0,103,1,0,0,119,5,0,0,117,5,0,0,114,5,0,0,124,5,0,0,123,8,0,0,122,8,0,0,172,6,0,0,136,6,0,0,133,6,0,0,107,2,0,0,96,6,0,0,94,6,0,0,92,6,0,0,237,6,0,0,98,5,0,0,83,5,0,0,81,5,0,0,53,5,0,0,48,5,0,0,56,5,0,0,6,5,0,0,1,5,0,0,254,4,0,0,248,0,0,0,12,5,0,0,9,5,0,0,63,8,0,0,194,4,0,0,192,4,0,0,186,4,0,0,197,0,0,0,182,4,0,0,193,0,0,0,204,4,0,0,201,4,0,0,197,4,0,0,212,4,0,0,25,8,0,0,23,8,0,0,127,4,0,0,126,4,0,0,124,4,0,0,122,4,0,0,152,0,0,0,119,4,0,0,149,0,0,0,116,4,0,0,145,0,0,0,137,4,0,0,135,4,0,0,132,4,0,0,129,4,0,0,158,0,0,0,145,4,0,0,142,4,0,0,225,7,0,0,224,7,0,0,222,7,0,0,227,7,0,0,46,6,0,0,254,1,0,0,20,6,0,0,17,6,0,0,196,1,0,0,192,1,0,0,226,5,0,0,220,5,0,0,138,1,0,0,135,1,0,0,131,1,0,0,163,5,0,0,161,5,0,0,159,5,0,0,156,5,0,0,170,5,0,0,159,8,0,0,253,2,0,0,204,2,0,0,201,2,0,0,173,6,0,0,150,2,0,0,148,2,0,0,145,2,0,0,137,6,0,0,135,6,0,0,148,3,0,0,146,3,0,0,111,3,0,0,110,3,0,0,109,3,0,0,114,3,0,0,111,4,0,0,110,4,0,0,97,4,0,0,96,4,0,0,94,4,0,0,99,4,0,0,73,4,0,0,72,4,0,0,70,4,0,0,68,4,0,0,103,0,0,0,77,4,0,0,75,4,0,0,187,7,0,0,35,4,0,0,34,4,0,0,32,4,0,0,30,4,0,0,77,0,0,0,27,4,0,0,74,0,0,0,42,4,0,0,40,4,0,0,37,4,0,0,47,4,0,0,172,7,0,0,171,7,0,0,239,3,0,0,238,3,0,0,236,3,0,0,234,3,0,0,231,3,0,0,41,0,0,0,228,3,0,0,37,0,0,0,249,3,0,0,247,3,0,0,244,3,0,0,241,3,0,0,52,0,0,0,1,4,0,0,254,3,0,0,144,7,0,0,143,7,0,0,141,7,0,0,146,7,0,0,174,3,0,0,172,3,0,0,170,3,0,0,167,3,0,0,164,3,0,0,5,0,0,0,2,0,0,0,187,3,0,0,185,3,0,0,182,3,0,0,179,3,0,0,18,0,0,0,175,3,0,0,15,0,0,0,197,3,0,0,194,3,0,0,190,3,0,0,103,7,0,0,102,7,0,0,100,7,0,0,98,7,0,0,205,3,0,0,107,7,0,0,105,7,0,0,99,5,0,0,69,1,0,0,84,5,0,0,82,5,0,0,32,1,0,0,29,1,0,0,54,5,0,0,52,5,0,0,50,5,0,0,241,0,0,0,238,0,0,0,234,0,0,0,7,5,0,0,5,5,0,0,3,5,0,0,0,5,0,0,14,5,0,0,64,8,0,0,188,0,0,0,185,0,0,0,181,0,0,0,178,0,0,0,236,7,0,0,195,4,0,0,193,4,0,0,191,4,0,0,188,4,0,0,200,0,0,0,185,4,0,0,203,4,0,0,26,8,0,0,24,8,0,0,71,2,0,0,41,2,0,0,39,2,0,0,47,6,0,0,249,1,0,0,247,1,0,0,244,1,0,0,1,2,0,0,21,6,0,0,19,6,0,0,188,1,0,0,186,1,0,0,183,1,0,0,180,1,0,0,165,8,0,0,199,1,0,0,195,1,0,0,227,5,0,0,225,5,0,0,222,5,0,0,28,3,0,0,251,2,0,0,250,2,0,0,248,2,0,0,255,2,0,0,199,2,0,0,198,2,0,0,196,2,0,0,194,2,0,0,73,9,0,0,206,2,0,0,203,2,0,0,174,6,0,0,240,9,0,0,149,3,0,0,147,3,0,0,121,10,0,0,91,6,0,0,61,6,0,0,59,6,0,0,21,9,0,0,233,6,0,0,213,6,0,0,211,6,0,0,219,5,0,0,158,5,0,0,155,5,0,0,156,8,0,0,110,5,0,0,108,5,0,0,105,5,0,0,115,5,0,0,121,8,0,0,119,8,0,0,168,6,0,0,129,6,0,0,126,6,0,0,89,6,0,0,87,6,0,0,84,6,0,0,234,6,0,0,49,5,0,0,2,5,0,0,255,4,0,0,61,8,0,0,190,4,0,0,183,4,0,0,198,4,0,0,20,8,0,0,17,8,0,0,125,4,0,0,123,4,0,0,120,4,0,0,117,4,0,0,146,0,0,0,133,4,0,0,130,4,0,0,221,7,0,0,219,7,0,0,216,7,0,0,223,7,0,0,43,6,0,0,13,6,0,0,10,6,0,0,215,5,0,0,207,5,0,0,153,5,0,0,151,5,0,0,148,5,0,0,145,5,0,0,132,1,0,0,160,5,0,0,157,8,0,0,169,6,0,0,146,2,0,0,131,6,0,0,128,6,0,0,95,4,0,0,71,4,0,0,69,4,0,0,186,7,0,0,33,4,0,0,31,4,0,0,28,4,0,0,38,4,0,0,170,7,0,0,168,7,0,0,237,3,0,0,235,3,0,0,232,3,0,0,229,3,0,0,38,0,0,0,245,3,0,0,242,3,0,0,140,7,0,0,138,7,0,0,135,7,0,0,142,7,0,0,173,3,0,0,171,3,0,0,168,3,0,0,165,3,0,0,6,0,0,0,162,3,0,0,3,0,0,0,183,3,0,0,180,3,0,0,176,3,0,0,97,7,0,0,95,7,0,0,92,7,0,0,89,7,0,0,191,3,0,0,101,7,0,0,99,7,0,0,35,0,0,0,97,5,0,0,80,5,0,0,78,5,0,0,47,5,0,0,45,5,0,0,42,5,0,0,51,5,0,0,253,4,0,0,251,4,0,0,248,4,0,0,245,4,0,0,235,0,0,0,4,5,0,0,62,8,0,0,181,4,0,0,180,4,0,0,177,4,0,0,174,4,0,0,182,0,0,0,171,4,0,0,179,0,0,0,189,4,0,0,22,8,0,0,19,8,0,0,44,6,0,0,245,1,0,0,15,6,0,0,12,6,0,0,184,1,0,0,181,1,0,0,217,5,0,0,214,5,0,0,210,5,0,0,223,5,0,0,249,2,0,0,197,2,0,0,195,2,0,0,170,6,0,0,145,3,0,0,144,3,0,0,150,8,0,0,106,5,0,0,116,8,0,0,113,8,0,0,85,6,0,0,230,6,0,0,55,8,0,0,184,4,0,0,10,8,0,0,6,8,0,0,121,4,0,0,118,4,0,0,213,7,0,0,210,7,0,0,207,7,0,0,217,7,0,0,208,5,0,0,149,5,0,0,146,5,0,0,152,8,0,0,162,6,0,0,123,6,0,0,120,6,0,0,183,7,0,0,29,4,0,0,165,7,0,0,162,7,0,0,233,3,0,0,230,3,0,0,132,7,0,0,129,7,0,0,126,7,0,0,136,7,0,0,169,3,0,0,166,3,0,0,163,3,0,0,87,7,0,0,84,7,0,0,81,7,0,0,78,7,0,0,177,3,0,0,93,7,0,0,90,7,0,0,43,5,0,0,249,4,0,0,246,4,0,0,57,8,0,0,178,4,0,0,175,4,0,0,172,4,0,0,187,4,0,0,13,8,0,0,9,8,0,0,40,6,0,0,7,6,0,0,4,6,0,0,204,5,0,0,201,5,0,0,198,5,0,0,211,5,0,0,164,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,2,0,0,120,0,0,0,121,0,0,0,8,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,8,0,0,0,7,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,200,2,0,0,122,0,0,0,123,0,0,0,45,0,0,0,58,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,232,2,0,0,124,0,0,0,125,0,0,0,0,0,0,0,248,2,0,0,126,0,0,0,127,0,0,0,42,0,0,0,2,0,0,0,3,0,0,0,57,0,0,0,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,228,109,0,0,208,109,0,0,12,110,0,0,248,109,0,0,18,84,0,0,18,84,0,0,0,0,0,0,37,81,0,0,1,0,0,0,124,94,0,0,2,0,0,0,75,91,0,0,3,0,0,0,249,69,0,0,4,0,0,0,206,64,0,0,5,0,0,0,151,79,0,0,6,0,0,0,160,74,0,0,7,0,0,0,196,119,0,0,8,0,0,0,243,114,0,0,9,0,0,0,170,125,0,0,10,0,0,0,157,120,0,0,11,0,0,0,47,102,0,0,12,0,0,0,24,99,0,0,13,0,0,0,65,108,0,0,14,0,0,0,118,105,0,0,15,0,0,0,137,22,0,0,16,0,0,0,190,19,0,0,17,0,0,0,231,28,0,0,18,0,0,0,208,25,0,0,19,0,0,0,98,7,0,0,20,0,0,0,85,2,0,0,21,0,0,0,12,13,0,0,22,0,0,0,59,8,0,0,23,0,0,0,95,53,0,0,24,0,0,0,104,48,0,0,25,0,0,0,49,63,0,0,26,0,0,0,6,58,0,0,27,0,0,0,180,36,0,0,28,0,0,0,131,33,0,0,29,0,0,0,218,46,0,0,30,0,0,0,237,43,0,0,31,0,0,0,32,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,3,0,0,0,3,0,0,0,4,0,0,0,0,0,0,0,8,3,0,0,128,0,0,0,129,0,0,0,45,0,0,0,45,0,0,0,148,124,0,0,188,133,0,0,153,154,0,0,211,164,0,0,246,187,0,0,98,199,0,0,71,216,0,0,13,230,0,0,40,249,0,0,120,11,1,0,93,20,1,0,23,42,1,0,50,53,1,0,166,73,1,0,131,86,1,0,201,104,1,0,236,119,1,0,196,142,1,0,225,145,1,0,171,175,1,0,142,176,1,0,26,204,1,0,63,211,1,0,117,237,1,0,80,242,1,0,213,9,2,0,240,22,2,0,186,40,2,0,159,55,2,0,11,75,2,0,46,84,2,0,100,106,2,0,65,117,2,0,105,140,2,0,34,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,3,0,0,130,0,0,0,131,0,0,0,0,0,0,0,56,3,0,0,132,0,0,0,133,0,0,0,0,0,0,0,72,3,0,0,134,0,0,0,135,0,0,0,42,0,0,0,43,0,0,0,0,0,0,0,40,6,0,0,136,0,0,0,137,0,0,0,0,0,0,0,24,6,0,0,138,0,0,0,139,0,0,0,0,0,0,0,8,6,0,0,140,0,0,0,141,0,0,0,159,206,0,0,167,206,0,0,148,207,0,0,150,207,0,0,60,239,0,0,152,207,0,0,154,207,0,0,156,207,0,0,158,207,0,0,21,208,0,0,160,207,0,0,162,207,0,0,164,207,0,0,74,239,0,0,17,208,0,0,166,207,0,0,168,207,0,0,170,207,0,0,19,208,0,0,172,207,0,0,174,207,0,0,176,207,0,0,178,207,0,0,180,207,0,0,182,207,0,0,184,207,0,0,186,207,0,0,188,207,0,0,58,207,0,0,132,207,0,0,140,207,0,0,74,207,0,0,159,206,0,0,167,206,0,0,82,207,0,0,84,207,0,0,86,207,0,0,88,207,0,0,90,207,0,0,92,207,0,0,94,207,0,0,96,207,0,0,98,207,0,0,100,207,0,0,102,207,0,0,68,239,0,0,104,207,0,0,106,207,0,0,108,207,0,0,110,207,0,0,112,207,0,0,114,207,0,0,116,207,0,0,118,207,0,0,120,207,0,0,122,207,0,0,124,207,0,0,126,207,0,0,128,207,0,0,130,207,0,0,199,206,0,0,132,207,0,0,140,207,0,0,74,207,0,0,159,206,0,0,167,206,0,0,8,207,0,0,10,207,0,0,12,207,0,0,14,207,0,0,16,207,0,0,18,207,0,0,20,207,0,0,22,207,0,0,24,207,0,0,26,207,0,0,28,207,0,0,30,207,0,0,207,206,0,0,32,207,0,0,34,207,0,0,36,207,0,0,38,207,0,0,40,207,0,0,42,207,0,0,44,207,0,0,46,207,0,0,48,207,0,0,50,207,0,0,52,207,0,0,54,207,0,0,56,207,0,0,58,207,0,0,191,206,0,0,66,207,0,0,74,207,0,0,73,239,0,0,207,206,0,0,209,206,0,0,212,206,0,0,215,206,0,0,245,242,0,0,218,206,0,0,220,206,0,0,222,206,0,0,224,206,0,0,226,206,0,0,228,206,0,0,230,206,0,0,232,206,0,0,234,206,0,0,236,206,0,0,238,206,0,0,189,206,0,0,240,206,0,0,190,232,0,0,242,206,0,0,244,206,0,0,246,206,0,0,248,206,0,0,250,206,0,0,252,206,0,0,254,206,0,0,0,207,0,0,2,207,0,0,4,207,0,0,6,207,0,0,191,206,0,0,159,206,0,0,167,206,0,0,169,206,0,0,171,206,0,0,173,206,0,0,175,206,0,0,177,206,0,0,179,206,0,0,181,206,0,0,183,206,0,0,185,206,0,0,187,206,0,0,189,206,0,0,190,232,0,0,191,206,0,0,199,206,0,0,0,0,0,0,104,0,0,0,240,0,0,0,152,1,0,0,96,2,0,0,0,0,0,0,17,0,0,0,40,0,0,0,51,0,0,0,76,0,0,0,0,0,0,0,128,0,0,0,32,1,0,0,224,1,0,0,192,2,0,0,192,3,0,0,224,4,0,0,32,6,0,0,128,7,0,0,0,9,0,0,160,10,0,0,96,12,0,0,64,14,0,0,64,16,0,0,96,18,0,0,160,20,0,0,0,23,0,0,128,25,0,0,32,28,0,0,224,30,0,0,192,33,0,0,192,36,0,0,224,39,0,0,32,43,0,0,128,46,0,0,0,50,0,0,160,53,0,0,96,57,0,0,64,61,0,0,64,65,0,0,96,69,0,0,160,73,0,0,0,78,0,0,0,0,0,0,21,0,0,0,48,0,0,0,60,0,0,0,88,0,0,0,120,0,0,0,156,0,0,0,196,0,0,0,240,0,0,0,230,0,0,0,16,1,0,0,60,1,0,0,108,1,0,0,160,1,0,0,214,1,0,0,16,2,0,0,76,2,0,0,140,2,0,0,208,2,0,0,22,3,0,0,96,3,0,0,172,3,0,0,252,3,0,0,152,3,0,0,224,3,0,0,42,4,0,0,120,4,0,0,200,4,0,0,26,5,0,0,112,5,0,0,200,5,0,0,34,6,0,0,128,6,0,0,0,0,0,0,248,5,0,0,142,0,0,0,143,0,0,0,0,0,0,0,232,5,0,0,144,0,0,0,145,0,0,0,0,0,0,0,24,0,0,0,146,0,0,0,147,0,0,0,46,0,0,0,0,0,0,0,216,5,0,0,148,0,0,0,149,0,0,0,0,0,0,0,184,5,0,0,150,0,0,0,151,0,0,0,56,0,0,0,0,0,0,0,80,8,0,0,152,0,0,0,153,0,0,0,200,255,255,255,200,255,255,255,80,8,0,0,154,0,0,0,155,0,0,0,56,0,0,0,0,0,0,0,168,5,0,0,156,0,0,0,157,0,0,0,200,255,255,255,200,255,255,255,168,5,0,0,158,0,0,0,159,0,0,0,0,0,0,0,152,5,0,0,160,0,0,0,161,0,0,0,44,0,0,0,59,0,0,0,42,0,0,0,49,0,0,0,57,0,0,0,58,0,0,0,60,0,0,0,59,0,0,0,60,0,0,0,49,0,0,0,61,0,0,0,50,0,0,0,136,116,0,0,96,116,0,0,116,116,0,0,156,116,0,0,0,0,0,0,2,0,0,0,255,255,255,255,69,205,0,0,0,0,0,0,1,0,0,0,3,0,0,0,255,255,255,255,48,205,0,0,58,205,0,0,0,0,0,0,4,0,0,0,255,255,255,255,27,205,0,0,37,205,0,0,0,0,0,0,5,0,0,0,255,255,255,255,6,205,0,0,16,205,0,0,0,0,0,0,6,0,0,0,255,255,255,255,241,204,0,0,251,204,0,0,0,0,0,0,7,0,0,0,255,255,255,255,220,204,0,0,230,204,0,0,0,0,0,0,8,0,0,0,255,255,255,255,199,204,0,0,209,204,0,0,0,0,0,0,9,0,0,0,255,255,255,255,178,204,0,0,188,204,0,0,0,0,0,0,10,0,0,0,255,255,255,255,157,204,0,0,167,204,0,0,0,0,0,0,11,0,0,0,255,255,255,255,136,204,0,0,146,204,0,0,0,0,0,0,12,0,0,0,255,255,255,255,113,204,0,0,124,204,0,0,0,0,0,0,13,0,0,0,255,255,255,255,90,204,0,0,101,204,0,0,0,0,0,0,15,0,0,0,255,255,255,255,67,204,0,0,78,204,0,0,0,0,0,0,16,0,0,0,255,255,255,255,44,204,0,0,55,204,0,0,0,0,0,0,17,0,0,0,255,255,255,255,21,204,0,0,32,204,0,0,0,0,0,0,18,0,0,0,255,255,255,255,254,203,0,0,9,204,0,0,0,0,0,0,20,0,0,0,255,255,255,255,239,203,0,0,244,203,0,0,0,0,0,0,21,0,0,0,255,255,255,255,219,203,0,0,226,203,0,0,0,0,0,0,22,0,0,0,255,255,255,255,199,203,0,0,206,203,0,0,0,0,0,0,23,0,0,0,255,255,255,255,179,203,0,0,186,203,0,0,0,0,0,0,24,0,0,0,255,255,255,255,159,203,0,0,166,203,0,0,0,0,0,0,25,0,0,0,255,255,255,255,120,203,0,0,139,203,0,0,148,203,0,0,0,0,0,0,26,0,0,0,255,255,255,255,109,203,0,0,114,203,0,0,0,0,0,0,27,0,0,0,170,0,0,0,255,255,255,255,94,203,0,0,100,203,0,0,0,0,0,0,28,0,0,0,255,255,255,255,89,203,0,0,0,0,0,0,29,0,0,0,255,255,255,255,63,203,0,0,71,203,0,0,78,203,0,0,85,203,0,0,0,0,0,0,30,0,0,0,255,255,255,255,49,203,0,0,56,203,0,0,0,0,0,0,0,0,0,0,136,5,0,0,144,0,0,0,162,0,0,0,0,0,0,0,120,5,0,0,163,0,0,0,164,0,0,0,0,0,0,0,104,5,0,0,165,0,0,0,166,0,0,0,0,0,0,0,88,3,0,0,146,0,0,0,167,0,0,0,46,0,0,0,0,0,0,0,88,5,0,0,136,0,0,0,168,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,72,5,0,0,144,0,0,0,169,0,0,0,0,0,0,0,56,5,0,0,170,0,0,0,171,0,0,0,0,0,0,0,40,5,0,0,172,0,0,0,173,0,0,0,0,0,0,0,104,3,0,0,146,0,0,0,174,0,0,0,46,0,0,0,0,0,0,0,24,5,0,0,175,0,0,0,176,0,0,0,0,0,0,0,8,5,0,0,177,0,0,0,178,0,0,0,0,0,0,0,248,4,0,0,179,0,0,0,180,0,0,0,0,0,0,0,216,4,0,0,181,0,0,0,182],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE+20480);allocate([3,0,0,0,6,0,0,0,9,0,0,0,96,0,0,0,18,0,0,0,66,0,0,0,33,0,0,0,36,0,0,0,48,0,0,0,72,0,0,0,12,0,0,0,24,0,0,0,69,0,0,0,81,0,0,0,84,0,0,0,21,0,0,0,26,0,0,0,41,0,0,0,11,0,0,0,14,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,4,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,52,0,0,0,33,1,0,0,97,0,0,0,96,1,0,0,49,0,0,0,48,1,0,0,112,0,0,0,37,0,0,0,36,1,0,0,100,0,0,0,9,1,0,0,73,0,0,0,72,1,0,0,25,0,0,0,24,1,0,0,88,0,0,0,13,0,0,0,12,1,0,0,76,0,0,0,28,0,0,0,3,1,0,0,67,0,0,0,66,1,0,0,19,0,0,0,18,1,0,0,82,0,0,0,7,0,0,0,6,1,0,0,70,0,0,0,22,0,0,0,129,1,0,0,193,0,0,0,192,1,0,0,145,0,0,0,144,1,0,0,208,0,0,0,133,0,0,0,132,1,0,0,196,0,0,0,148,0,0,0,168,0,0,0,162,0,0,0,138,0,0,0,42,0,0,0,0,0,0,0,20,1,0,0,72,1,0,0,68,1,0,0,66,1,0,0,40,1,0,0,36,1,0,0,34,1,0,0,80,1,0,0,18,1,0,0,10,1,0,0,168,1,0,0,164,1,0,0,162,1,0,0,148,1,0,0,146,1,0,0,138,1,0,0,104,1,0,0,100,1,0,0,98,1,0,0,52,1,0,0,26,1,0,0,88,1,0,0,76,1,0,0,70,1,0,0,44,1,0,0,22,1,0,0,180,1,0,0,178,1,0,0,172,1,0,0,166,1,0,0,150,1,0,0,154,1,0,0,108,1,0,0,102,1,0,0,54,1,0,0,58,1,0,0,46,1,0,0,212,1,0,0,210,1,0,0,202,1,0,0,110,1,0,0,118,1,0,0,174,1,0,0,38,1,0,0,218,1,0,0,214,1,0,0,50,1,0,0,94,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,13,0,0,0,14,0,0,0,19,0,0,0,25,0,0,0,28,0,0,0,21,0,0,0,22,0,0,0,26,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,0,0,0,0,200,4,0,0,134,0,0,0,183,0,0,0,42,0,0,0,43,0,0,0,56,0,0,0,52,0,0,0,50,0,0,0,49,0,0,0,44,0,0,0,38,0,0,0,35,0,0,0,42,0,0,0,41,0,0,0,37,0,0,0,7,0,0,0,11,0,0,0,13,0,0,0,14,0,0,0,19,0,0,0,25,0,0,0,28,0,0,0,21,0,0,0,22,0,0,0,26,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,4,0,0,184,0,0,0,185,0,0,0,0,0,0,0,136,4,0,0,144,0,0,0,186,0,0,0,0,0,0,0,120,4,0,0,187,0,0,0,188,0,0,0,0,0,0,0,104,4,0,0,189,0,0,0,190,0,0,0,0,0,0,0,88,4,0,0,191,0,0,0,192,0,0,0,62,0,0,0,0,0,0,0,72,4,0,0,191,0,0,0,193,0,0,0,63,0,0,0,0,0,0,0,56,4,0,0,191,0,0,0,194,0,0,0,64,0,0,0,0,0,0,0,40,4,0,0,191,0,0,0,195,0,0,0,65,0,0,0,0,0,0,0,24,4,0,0,191,0,0,0,196,0,0,0,66,0,0,0,0,0,0,0,8,4,0,0,191,0,0,0,197,0,0,0,67,0,0,0,0,0,0,0,248,3,0,0,191,0,0,0,198,0,0,0,68,0,0,0,0,0,0,0,232,3,0,0,191,0,0,0,199,0,0,0,69,0,0,0,0,0,0,0,200,3,0,0,134,0,0,0,200,0,0,0,42,0,0,0,43,0,0,0,0,0,0,0,184,3,0,0,134,0,0,0,201,0,0,0,42,0,0,0,43,0,0,0,0,0,0,0,168,3,0,0,202,0,0,0,203,0,0,0,0,0,0,0,152,3,0,0,144,0,0,0,204,0,0,0,0,0,0,0,0,0,0,0,216,3,0,0,205,0,0,0,206,0,0,0,0,0,0,0,152,4,0,0,207,0,0,0,208,0,0,0,0,0,0,0,168,4,0,0,209,0,0,0,210,0,0,0,0,0,0,0,8,0,0,0,146,0,0,0,211,0,0,0,46,0,0,0,0,0,0,0,232,4,0,0,212,0,0,0,213,0,0,0,0,0,0,0,200,5,0,0,214,0,0,0,215,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,2,0,0,0,1,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,3,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,48,0,0,0,44,0,0,0,24,0,0,0,20,0,0,0,18,0,0,0,16,0,0,0,14,0,0,0,12,0,0,0,10,0,0,0,8,0,0,0,6,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,43,0,0,0,0,0,0,0,240,6,0,0,216,0,0,0,217,0,0,0,61,0,0,0,0,0,0,0,0,0,0,0,8,7,0,0,218,0,0,0,219,0,0,0,62,0,0,0,0,0,0,0,32,7,0,0,220,0,0,0,221,0,0,0,63,0,0,0,0,0,0,0,112,7,0,0,222,0,0,0,223,0,0,0,224,0,0,0,225,0,0,0,70,0,0,0,0,0,0,0,64,7,0,0,222,0,0,0,226,0,0,0,224,0,0,0,225,0,0,0,71,0,0,0,43,0,0,0,42,0,0,0,50,0,0,0,0,0,0,0,0,8,0,0,222,0,0,0,227,0,0,0,224,0,0,0,225,0,0,0,71,0,0,0,44,0,0,0,43,0,0,0,51,0,0,0,0,0,0,0,16,8,0,0,222,0,0,0,228,0,0,0,224,0,0,0,225,0,0,0,71,0,0,0,45,0,0,0,44,0,0,0,52,0,0,0,0,0,0,0,96,7,0,0,222,0,0,0,229,0,0,0,224,0,0,0,225,0,0,0,72,0,0,0,0,0,0,0,0,0,0,0,20,218,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0,192,3,0,0,192,4,0,0,192,5,0,0,192,6,0,0,192,7,0,0,192,8,0,0,192,9,0,0,192,10,0,0,192,11,0,0,192,12,0,0,192,13,0,0,192,14,0,0,192,15,0,0,192,16,0,0,192,17,0,0,192,18,0,0,192,19,0,0,192,20,0,0,192,21,0,0,192,22,0,0,192,23,0,0,192,24,0,0,192,25,0,0,192,26,0,0,192,27,0,0,192,28,0,0,192,29,0,0,192,30,0,0,192,31,0,0,192,0,0,0,179,1,0,0,195,2,0,0,195,3,0,0,195,4,0,0,195,5,0,0,195,6,0,0,195,7,0,0,195,8,0,0,195,9,0,0,195,10,0,0,195,11,0,0,195,12,0,0,195,13,0,0,211,14,0,0,195,15,0,0,195,0,0,12,187,1,0,12,195,2,0,12,195,3,0,12,195,4,0,12,211,28,140,0,0,140,140,0,0,228,174,0,0,252,148,0,0,252,142,0,0,0,0,0,0,10,0,0,0,100,0,0,0,232,3,0,0,16,39,0,0,160,134,1,0,64,66,15,0,128,150,152,0,0,225,245,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255,255,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,74,0,0,0,75,0,0,0,170,230,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255,255,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0,0,75,0,0,0,162,226,0,0,0,4,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,255,255,255,255,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,4,0,0,0,5,0,0,0,6,0,0,0,7,0,0,0,8,0,0,0,9,0,0,0,10,0,0,0,11,0,0,0,12,0,0,0,13,0,0,0,14,0,0,0,15,0,0,0,16,0,0,0,17,0,0,0,18,0,0,0,19,0,0,0,20,0,0,0,21,0,0,0,22,0,0,0,23,0,0,0,24,0,0,0,25,0,0,0,26,0,0,0,27,0,0,0,28,0,0,0,29,0,0,0,30,0,0,0,31,0,0,0,32,0,0,0,33,0,0,0,34,0,0,0,35,0,0,0,36,0,0,0,37,0,0,0,38,0,0,0,39,0,0,0,40,0,0,0,41,0,0,0,42,0,0,0,43,0,0,0,44,0,0,0,45,0,0,0,46,0,0,0,47,0,0,0,48,0,0,0,49,0,0,0,50,0,0,0,51,0,0,0,52,0,0,0,53,0,0,0,54,0,0,0,55,0,0,0,56,0,0,0,57,0,0,0,58,0,0,0,59,0,0,0,60,0,0,0,61,0,0,0,62,0,0,0,63,0,0,0,64,0,0,0,65,0,0,0,66,0,0,0,67,0,0,0,68,0,0,0,69,0,0,0,70,0,0,0,71,0,0,0,72,0,0,0,73,0,0,0,74,0,0,0,75,0,0,0,76,0,0,0,77,0,0,0,78,0,0,0,79,0,0,0,80,0,0,0,81,0,0,0,82,0,0,0,83,0,0,0,84,0,0,0,85,0,0,0,86,0,0,0,87,0,0,0,88,0,0,0,89,0,0,0,90,0,0,0,91,0,0,0,92,0,0,0,93,0,0,0,94,0,0,0,95,0,0,0,96,0,0,0,65,0,0,0,66,0,0,0,67,0,0,0,68,0,0,0,69,0,0,0,70,0,0,0,71,0,0,0,72,0,0,0,73,0,0,0,74,0,0,0,75,0,0,0,76,0,0,0,77,0,0,0,78,0,0,0,79,0,0,0,80,0,0,0,81,0,0,0,82,0,0,0,83,0,0,0,84,0,0,0,85,0,0,0,86,0,0,0,87,0,0,0,88,0,0,0,89,0,0,0,90,0,0,0,123,0,0,0,124,0,0,0,125,0,0,0,126,0,0,0,127],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE+30728);allocate([1,0,0,0,2,0,0,0,3,0,0,0,4,0,0,0,5,0,0,0,6,0,0,0,7,0,0,0,8,0,0,0,9,0,0,0,10,0,0,0,11,0,0,0,12,0,0,0,13,0,0,0,14,0,0,0,15,0,0,0,16,0,0,0,17,0,0,0,18,0,0,0,19,0,0,0,20,0,0,0,21,0,0,0,22,0,0,0,23,0,0,0,24,0,0,0,25,0,0,0,26,0,0,0,27,0,0,0,28,0,0,0,29,0,0,0,30,0,0,0,31,0,0,0,32,0,0,0,33,0,0,0,34,0,0,0,35,0,0,0,36,0,0,0,37,0,0,0,38,0,0,0,39,0,0,0,40,0,0,0,41,0,0,0,42,0,0,0,43,0,0,0,44,0,0,0,45,0,0,0,46,0,0,0,47,0,0,0,48,0,0,0,49,0,0,0,50,0,0,0,51,0,0,0,52,0,0,0,53,0,0,0,54,0,0,0,55,0,0,0,56,0,0,0,57,0,0,0,58,0,0,0,59,0,0,0,60,0,0,0,61,0,0,0,62,0,0,0,63,0,0,0,64,0,0,0,97,0,0,0,98,0,0,0,99,0,0,0,100,0,0,0,101,0,0,0,102,0,0,0,103,0,0,0,104,0,0,0,105,0,0,0,106,0,0,0,107,0,0,0,108,0,0,0,109,0,0,0,110,0,0,0,111,0,0,0,112,0,0,0,113,0,0,0,114,0,0,0,115,0,0,0,116,0,0,0,117,0,0,0,118,0,0,0,119,0,0,0,120,0,0,0,121,0,0,0,122,0,0,0,91,0,0,0,92,0,0,0,93,0,0,0,94,0,0,0,95,0,0,0,96,0,0,0,97,0,0,0,98,0,0,0,99,0,0,0,100,0,0,0,101,0,0,0,102,0,0,0,103,0,0,0,104,0,0,0,105,0,0,0,106,0,0,0,107,0,0,0,108,0,0,0,109,0,0,0,110,0,0,0,111,0,0,0,112,0,0,0,113,0,0,0,114,0,0,0,115,0,0,0,116,0,0,0,117,0,0,0,118,0,0,0,119,0,0,0,120,0,0,0,121,0,0,0,122,0,0,0,123,0,0,0,124,0,0,0,125,0,0,0,126,0,0,0,127,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,72,8,0,0,230,0,0,0,231,0,0,0,44,0,0,0,59,0,0,0,46,0,0,0,53,0,0,0,57,0,0,0,58,0,0,0,60,0,0,0,65,0,0,0,60,0,0,0,51,0,0,0,61,0,0,0,52,0,0,0,0,0,0,0,32,8,0,0,232,0,0,0,233,0,0,0,62,0,0,0,0,0,0,0,48,8,0,0,234,0,0,0,235,0,0,0,0,0,0,0,104,8,0,0,236,0,0,0,237,0,0,0,66,0,0,0,45,0,0,0,77,0,0,0,78,0,0,0,46,0,0,0,0,0,0,0,0,0,0,0,96,9,0,0,238,0,0,0,239,0,0,0,240,0,0,0,44,0,0,0,54,0,0,0,79,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,112,9,0,0,241,0,0,0,242,0,0,0,240,0,0,0,45,0,0,0,55,0,0,0,80,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,192,9,0,0,243,0,0,0,244,0,0,0,240,0,0,0,43,0,0,0,44,0,0,0,45,0,0,0,46,0,0,0,47,0,0,0,48,0,0,0,49,0,0,0,50,0,0,0,51,0,0,0,52,0,0,0,53,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,224,9,0,0,245,0,0,0,246,0,0,0,240,0,0,0,54,0,0,0,55,0,0,0,56,0,0,0,57,0,0,0,58,0,0,0,59,0,0,0,60,0,0,0,61,0,0,0,62,0,0,0,63,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,247,0,0,0,248,0,0,0,240,0,0,0,46,0,0,0,47,0,0,0,65,0,0,0,48,0,0,0,66,0,0,0,42,0,0,0,43,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,32,10,0,0,249,0,0,0,250,0,0,0,240,0,0,0,50,0,0,0,51,0,0,0,67,0,0,0,52,0,0,0,68,0,0,0,44,0,0,0,45,0,0,0,53,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,10,0,0,251,0,0,0,252,0,0,0,240,0,0,0,67,0,0,0,69,0,0,0,70,0,0,0,71,0,0,0,72,0,0,0,73,0,0,0,42,0,0,0,248,255,255,255,64,10,0,0,68,0,0,0,69,0,0,0,70,0,0,0,71,0,0,0,72,0,0,0,73,0,0,0,74,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,104,10,0,0,253,0,0,0,254,0,0,0,240,0,0,0,75,0,0,0,74,0,0,0,75,0,0,0,76,0,0,0,77,0,0,0,78,0,0,0,43,0,0,0,248,255,255,255,104,10,0,0,76,0,0,0,77,0,0,0,78,0,0,0,79,0,0,0,80,0,0,0,81,0,0,0,82,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,144,10,0,0,255,0,0,0,0,1,0,0,240,0,0,0,43,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,176,10,0,0,1,1,0,0,2,1,0,0,240,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,208,10,0,0,3,1,0,0,4,1,0,0,240,0,0,0,83,0,0,0,84,0,0,0,45,0,0,0,46,0,0,0,47,0,0,0,48,0,0,0,85,0,0,0,49,0,0,0,50,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,240,10,0,0,5,1,0,0,6,1,0,0,240,0,0,0,86,0,0,0,87,0,0,0,51,0,0,0,52,0,0,0,53,0,0,0,54,0,0,0,88,0,0,0,55,0,0,0,56,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,11,0,0,7,1,0,0,8,1,0,0,240,0,0,0,89,0,0,0,90,0,0,0,57,0,0,0,58,0,0,0,59,0,0,0,60,0,0,0,91,0,0,0,61,0,0,0,62,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,48,11,0,0,9,1,0,0,10,1,0,0,240,0,0,0,92,0,0,0,93,0,0,0,63,0,0,0,64,0,0,0,65,0,0,0,66,0,0,0,94,0,0,0,67,0,0,0,68,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,80,11,0,0,11,1,0,0,12,1,0,0,240,0,0,0,45,0,0,0,46,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,112,11,0,0,13,1,0,0,14,1,0,0,240,0,0,0,47,0,0,0,48,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,144,11,0,0,15,1,0,0,16,1,0,0,240,0,0,0,42,0,0,0,79,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,176,11,0,0,17,1,0,0,18,1,0,0,240,0,0,0,43,0,0,0,80,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,208,11,0,0,19,1,0,0,20,1,0,0,240,0,0,0,81,0,0,0,47,0,0,0,69,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,240,11,0,0,21,1,0,0,22,1,0,0,240,0,0,0,82,0,0,0,48,0,0,0,70,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,80,9,0,0,23,1,0,0,24,1,0,0,240,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,128,9,0,0,25,1,0,0,26,1,0,0,240,0,0,0,53,0,0,0,83,0,0,0,54,0,0,0,84,0,0,0,55,0,0,0,48,0,0,0,85,0,0,0,54,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,48,9,0,0,27,1,0,0,28,1,0,0,240,0,0,0,44,0,0,0,45,0,0,0,55,0,0,0,95,0,0,0,96,0,0,0,56,0,0,0,97,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,160,9,0,0,29,1,0,0,30,1,0,0,240,0,0,0,98,0,0,0,99,0,0,0,71,0,0,0,72,0,0,0,73,0,0,0,0,0,0,0,176,9,0,0,31,1,0,0,32,1,0,0,240,0,0,0,100,0,0,0,101,0,0,0,74,0,0,0,75,0,0,0,76,0,0,0,0,0,0,0,128,8,0,0,33,1,0,0,34,1,0,0,240,0,0,0,0,0,0,0,144,8,0,0,33,1,0,0,35,1,0,0,240,0,0,0,86,0,0,0,49,0,0,0,50,0,0,0,51,0,0,0,56,0,0,0,87,0,0,0,57,0,0,0,88,0,0,0,58,0,0,0,52,0,0,0,89,0,0,0,57,0,0,0,0,0,0,0,176,8,0,0,33,1,0,0,36,1,0,0,240,0,0,0,46,0,0,0,47,0,0,0,58,0,0,0,102,0,0,0,103,0,0,0,59,0,0,0,104,0,0,0,0,0,0,0,208,8,0,0,33,1,0,0,37,1,0,0,240,0,0,0,48,0,0,0,49,0,0,0,60,0,0,0,105,0,0,0,106,0,0,0,61,0,0,0,107,0,0,0,0,0,0,0,240,8,0,0,33,1,0,0,38,1,0,0,240,0,0,0,50,0,0,0,51,0,0,0,62,0,0,0,108,0,0,0,109,0,0,0,63,0,0,0,110,0,0,0,0,0,0,0,16,9,0,0,33,1,0,0,39,1,0,0,240,0,0,0,50,0,0,0,51,0,0,0,62,0,0,0,108,0,0,0,109,0,0,0,63,0,0,0,110,0,0,0,0,0,0,0,32,9,0,0,33,1,0,0,40,1,0,0,240,0,0,0,50,0,0,0,51,0,0,0,62,0,0,0,108,0,0,0,109,0,0,0,63,0,0,0,110,0,0,0,0,0,0,0,37,0,0,0,72,0,0,0,58,0,0,0,37,0,0,0,77,0,0,0,58,0,0,0,37,0,0,0,83,0,0,0,37,0,0,0,109,0,0,0,47,0,0,0,37,0,0,0,100,0,0,0,47,0,0,0,37,0,0,0,121,0,0,0,37,0,0,0,89,0,0,0,45,0,0,0,37,0,0,0,109,0,0,0,45,0,0,0,37,0,0,0,100,0,0,0,37,0,0,0,73,0,0,0,58,0,0,0,37,0,0,0,77,0,0,0,58,0,0,0,37,0,0,0,83,0,0,0,32,0,0,0,37,0,0,0,112,0,0,0,37,0,0,0,72,0,0,0,58,0,0,0,37,0,0,0,77,0,0,0,37,0,0,0,72,0,0,0,58,0,0,0,37,0,0,0,77,0,0,0,58,0,0,0,37,0,0,0,83,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,116,0,0,0,114,0,0,0,117,0,0,0,101,0,0,0,0,0,0,0,102,0,0,0,97,0,0,0,108,0,0,0,115,0,0,0,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,83,0,0,0,117,0,0,0,110,0,0,0,100,0,0,0,97,0,0,0,121,0,0,0,0,0,0,0,77,0,0,0,111,0,0,0,110,0,0,0,100,0,0,0,97,0,0,0,121,0,0,0,0,0,0,0,84,0,0,0,117,0,0,0,101,0,0,0,115,0,0,0,100,0,0,0,97,0,0,0,121,0,0,0,0,0,0,0,87,0,0,0,101,0,0,0,100,0,0,0,110,0,0,0,101,0,0,0,115,0,0,0,100,0,0,0,97,0,0,0,121,0,0,0,0,0,0,0,84,0,0,0,104,0,0,0,117,0,0,0,114,0,0,0,115,0,0,0,100,0,0,0,97,0,0,0,121,0,0,0,0,0,0,0,70,0,0,0,114,0,0,0,105,0,0,0,100,0,0,0,97,0,0,0,121,0,0,0,0,0,0,0,83,0,0,0,97,0,0,0,116,0,0,0,117,0,0,0,114,0,0,0,100,0,0,0,97,0,0,0,121,0,0,0,0,0,0,0,83,0,0,0,117,0,0,0,110,0,0,0,0,0,0,0,77,0,0,0,111,0,0,0,110,0,0,0,0,0,0,0,84,0,0,0,117,0,0,0,101,0,0,0,0,0,0,0,87,0,0,0,101,0,0,0,100,0,0,0,0,0,0,0,84,0,0,0,104,0,0,0,117,0,0,0,0,0,0,0,70,0,0,0,114,0,0,0,105,0,0,0,0,0,0,0,83,0,0,0,97,0,0,0,116,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,74,0,0,0,97,0,0,0,110,0,0,0,117,0,0,0,97,0,0,0,114,0,0,0,121,0,0,0,0,0,0,0,70,0,0,0,101,0,0,0,98,0,0,0,114,0,0,0,117,0,0,0,97,0,0,0,114,0,0,0,121,0,0,0,0,0,0,0,77,0,0,0,97,0,0,0,114,0,0,0,99,0,0,0,104,0,0,0,0,0,0,0,65,0,0,0,112,0,0,0,114,0,0,0,105,0,0,0,108,0,0,0,0,0,0,0,77,0,0,0,97,0,0,0,121,0,0,0,0,0,0,0,74,0,0,0,117,0,0,0,110,0,0,0,101,0,0,0,0,0,0,0,74,0,0,0,117,0,0,0,108,0,0,0,121,0,0,0,0,0,0,0,65,0,0,0,117,0,0,0,103,0,0,0,117,0,0,0,115,0,0,0,116,0,0,0,0,0,0,0,83,0,0,0,101,0,0,0,112,0,0,0,116,0,0,0,101,0,0,0,109,0,0,0,98,0,0,0,101,0,0,0,114,0,0,0,0,0,0,0,79,0,0,0,99,0,0,0,116,0,0,0,111,0,0,0,98,0,0,0,101,0,0,0,114,0,0,0,0,0,0,0,78,0,0,0,111,0,0,0,118,0,0,0,101,0,0,0,109,0,0,0,98,0,0,0,101,0,0,0,114,0,0,0,0,0,0,0,68,0,0,0,101,0,0,0,99,0,0,0,101,0,0,0,109,0,0,0,98,0,0,0,101,0,0,0,114,0,0,0,0,0,0,0,74,0,0,0,97,0,0,0,110,0,0,0,0,0,0,0,70,0,0,0,101,0,0,0,98,0,0,0,0,0,0,0,77,0,0,0,97,0,0,0,114,0,0,0,0,0,0,0,65,0,0,0,112,0,0,0,114,0,0,0,0,0,0,0,74,0,0,0,117,0,0,0,110,0,0,0,0,0,0,0,74,0,0,0,117,0,0,0,108,0,0,0,0,0,0,0,65,0,0,0,117,0,0,0,103,0,0,0,0,0,0,0,83,0,0,0,101,0,0,0,112,0,0,0,0,0,0,0,79,0,0,0,99,0,0,0,116,0,0,0,0,0,0,0,78,0,0,0,111,0,0,0,118,0,0,0,0,0,0,0,68,0,0,0,101,0,0,0,99,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,65,0,0,0,77,0,0,0,0,0,0,0,80,0,0,0,77,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,37,0,0,0,109,0,0,0,47,0,0,0,37,0,0,0,100,0,0,0,47,0,0,0,37,0,0,0,121,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,37,0,0,0,72,0,0,0,58,0,0,0,37,0,0,0,77,0,0,0,58,0,0,0,37,0,0,0,83,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,37,0,0,0,97,0,0,0,32,0,0,0,37,0,0,0,98,0,0,0,32,0,0,0,37,0,0,0,100,0,0,0,32,0,0,0,37,0,0,0,72,0,0,0,58,0,0,0,37,0,0,0,77,0,0,0,58,0,0,0,37,0,0,0,83,0,0,0,32,0,0,0,37,0,0,0,89,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,37,0,0,0,73,0,0,0,58,0,0,0,37,0,0,0,77,0,0,0,58,0,0,0,37,0,0,0,83,0,0,0,32,0,0,0,37,0,0,0,112,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,120,15,0,0,41,1,0,0,42,1,0,0,62,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,3,32,2,32,2,32,2,32,2,32,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,96,4,192,4,192,4,192,4,192,4,192,4,192,4,192,4,192,4,192,4,192,4,192,4,192,4,192,4,192,4,192,8,216,8,216,8,216,8,216,8,216,8,216,8,216,8,216,8,216,8,216,4,192,4,192,4,192,4,192,4,192,4,192,4,192,8,213,8,213,8,213,8,213,8,213,8,213,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,8,197,4,192,4,192,4,192,4,192,4,192,4,192,8,214,8,214,8,214,8,214,8,214,8,214,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,8,198,4,192,4,192,4,192,4,192,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,78,53,122,120,105,110,103,49,53,82,101,97,100,101,114,69,120,99,101,112,116,105,111,110,69,0,78,53,122,120,105,110,103,57,69,120,99,101,112,116,105,111,110,69,0,49,55,73,109,97,103,101,82,101,97,100,101,114,83,111,117,114,99,101,0,78,53,122,120,105,110,103,56,65,114,114,97,121,82,101,102,73,99,69,69,0,78,53,122,120,105,110,103,55,67,111,117,110,116,101,100,69,0,78,53,122,120,105,110,103,53,65,114,114,97,121,73,99,69,69,0,78,53,122,120,105,110,103,56,65,114,114,97,121,82,101,102,73,78,83,95,51,82,101,102,73,78,83,95,49,49,82,101,115,117,108,116,80,111,105,110,116,69,69,69,69,69,0,78,53,122,120,105,110,103,53,97,122,116,101,99,49,49,65,122,116,101,99,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,57,66,105,110,97,114,105,122,101,114,69,0,78,53,122,120,105,110,103,49,50,66,105,110,97,114,121,66,105,116,109,97,112,69,0,78,53,122,120,105,110,103,49,55,67,104,101,99,107,115,117,109,69,120,99,101,112,116,105,111,110,69,0,78,53,122,120,105,110,103,56,66,105,116,65,114,114,97,121,69,0,78,53,122,120,105,110,103,57,66,105,116,77,97,116,114,105,120,69,0,0,78,53,122,120,105,110,103,50,52,71,108,111,98,97,108,72,105,115,116,111,103,114,97,109,66,105,110,97,114,105,122,101,114,69,0,0,78,53,122,120,105,110,103,49,53,72,121,98,114,105,100,66,105,110,97,114,105,122,101,114,69,0,78,53,122,120,105,110,103,50,52,73,108,108,101,103,97,108,65,114,103,117,109,101,110,116,69,120,99,101,112,116,105,111,110,69,0,78,53,122,120,105,110,103,50,48,82,101,101,100,83,111,108,111,109,111,110,69,120,99,101,112,116,105,111,110,69,0,78,53,122,120,105,110,103,49,48,100,97,116,97,109,97,116,114,105,120,49,54,68,97,116,97,77,97,116,114,105,120,82,101,97,100,101,114,69,0,42,42,42,32,48,49,50,51,52,53,54,55,56,57,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,58,59,60,61,62,63,64,91,92,93,94,95,42,42,42,32,48,49,50,51,52,53,54,55,56,57,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,39,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,123,124,125,126,127,78,53,122,120,105,110,103,49,48,100,97,116,97,109,97,116,114,105,120,56,68,101,116,101,99,116,111,114,69,0,78,53,122,120,105,110,103,49,48,100,97,116,97,109,97,116,114,105,120,55,86,101,114,115,105,111,110,69,0,78,53,122,120,105,110,103,49,53,70,111,114,109,97,116,69,120,99,101,112,116,105,111,110,69,0,78,53,122,120,105,110,103,50,51,73,110,118,101,114,116,101,100,76,117,109,105,110,97,110,99,101,83,111,117,114,99,101,69,0,78,53,122,120,105,110,103,49,53,76,117,109,105,110,97,110,99,101,83,111,117,114,99,101,69,0,78,53,122,120,105,110,103,53,109,117,108,116,105,50,56,71,101,110,101,114,105,99,77,117,108,116,105,112,108,101,66,97,114,99,111,100,101,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,53,109,117,108,116,105,50,49,77,117,108,116,105,112,108,101,66,97,114,99,111,100,101,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,53,109,117,108,116,105,49,51,77,117,108,116,105,68,101,116,101,99,116,111,114,69,0,78,53,122,120,105,110,103,53,109,117,108,116,105,50,52,77,117,108,116,105,70,105,110,100,101,114,80,97,116,116,101,114,110,70,105,110,100,101,114,69,0,78,53,122,120,105,110,103,53,109,117,108,116,105,49,55,81,82,67,111,100,101,77,117,108,116,105,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,49,55,77,117,108,116,105,70,111,114,109,97,116,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,51,67,111,100,97,66,97,114,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,51,67,111,100,101,49,50,56,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,50,67,111,100,101,51,57,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,50,67,111,100,101,57,51,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,49,69,65,78,49,51,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,48,69,65,78,56,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,57,73,84,70,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,50,49,77,117,108,116,105,70,111,114,109,97,116,79,110,101,68,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,50,51,77,117,108,116,105,70,111,114,109,97,116,85,80,67,69,65,78,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,48,79,110,101,68,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,48,85,80,67,65,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,50,85,80,67,69,65,78,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,48,85,80,67,69,82,101,97,100,101,114,69,0,59,60,62,64,91,92,125,95,96,126,33,13,9,44,58,10,45,46,36,47,34,124,42,40,41,63,123,125,39,48,49,50,51,52,53,54,55,56,57,38,13,9,44,58,35,45,46,36,47,43,37,42,61,94,78,53,122,120,105,110,103,54,112,100,102,52,49,55,55,100,101,99,111,100,101,114,50,101,99,49,49,77,111,100,117,108,117,115,80,111,108,121,69,0,78,53,122,120,105,110,103,54,112,100,102,52,49,55,49,50,80,68,70,52,49,55,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,56,68,97,116,97,77,97,115,107,69,0,48,49,50,51,52,53,54,55,56,57,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,32,36,37,42,43,45,46,47,58,78,53,122,120,105,110,103,54,113,114,99,111,100,101,50,50,65,108,105,103,110,109,101,110,116,80,97,116,116,101,114,110,70,105,110,100,101,114,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,56,68,101,116,101,99,116,111,114,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,50,81,82,67,111,100,101,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,55,86,101,114,115,105,111,110,69,0,78,53,122,120,105,110,103,54,82,101,97,100,101,114,69,0,78,53,122,120,105,110,103,54,82,101,115,117,108,116,69,0,78,53,122,120,105,110,103,49,49,82,101,115,117,108,116,80,111,105,110,116,69,0,100,97,116,97,32,105,115,32,116,111,111,32,108,111,110,103,0,114,115,32,100,101,99,111,100,105,110,103,32,102,97,105,108,101,100,0,98,105,116,32,119,97,115,32,110,111,116,32,105,110,118,101,114,116,101,100,0,105,110,118,97,108,105,100,32,105,110,112,117,116,32,100,97,116,97,0,67,84,82,76,95,0,101,110,99,111,117,110,116,101,114,101,100,32,119,114,111,110,103,32,98,117,108,108,115,101,121,101,32,114,105,110,103,32,99,111,117,110,116,0,98,117,108,108,115,101,121,101,32,101,120,116,101,110,100,115,32,111,118,101,114,32,105,109,97,103,101,32,98,111,117,110,100,115,0,99,111,117,108,100,32,110,111,116,32,100,101,116,101,114,109,105,110,101,32,111,114,105,101,110,116,97,116,105,111,110,0,109,97,116,114,105,120,32,101,120,116,101,110,100,115,32,111,118,101,114,32,105,109,97,103,101,32,98,111,117,110,100,115,0,102,97,105,108,101,100,32,116,111,32,100,101,99,111,100,101,32,112,97,114,97,109,101,116,101,114,32,100,97,116,97,0,76,101,102,116,32,97,110,100,32,116,111,112,32,109,117,115,116,32,98,101,32,110,111,110,110,101,103,97,116,105,118,101,0,72,101,105,103,104,116,32,97,110,100,32,119,105,100,116,104,32,109,117,115,116,32,98,101,32,97,116,32,108,101,97,115,116,32,49,0,84,104,101,32,114,101,103,105,111,110,32,109,117,115,116,32,102,105,116,32,105,110,115,105,100,101,32,116,104,101,32,109,97,116,114,105,120,0,73,110,118,97,108,105,100,32,100,105,109,101,110,115,105,111,110,115,32,87,104,105,116,101,82,101,99,116,97,110,103,108,101,68,101,116,101,99,116,111,114,0,122,32,61,61,32,78,85,76,76,0,116,32,61,61,32,78,85,76,76,0,120,32,61,61,32,78,85,76,76,0,121,32,61,61,32,78,85,76,76,0,78,111,32,98,108,97,99,107,32,112,111,105,110,116,32,102,111,117,110,100,32,111,110,32,98,111,114,100,101,114,0,84,114,97,110,115,102,111,114,109,101,100,32,112,111,105,110,116,32,111,117,116,32,111,102,32,98,111,117,110,100,115,32,97,116,32,0,68,101,103,114,101,101,32,109,117,115,116,32,98,101,32,110,111,110,45,110,101,103,97,116,105,118,101,0,99,97,110,110,111,116,32,103,105,118,101,32,108,111,103,40,48,41,0,67,97,110,110,111,116,32,99,97,108,99,117,108,97,116,101,32,116,104,101,32,105,110,118,101,114,115,101,32,111,102,32,48,0,110,101,101,100,32,99,111,101,102,102,105,99,105,101,110,116,115,0,71,101,110,101,114,105,99,71,70,80,111,108,121,115,32,100,111,32,110,111,116,32,104,97,118,101,32,115,97,109,101,32,71,101,110,101,114,105,99,71,70,32,102,105,101,108,100,0,100,101,103,114,101,101,32,109,117,115,116,32,110,111,116,32,98,101,32,108,101,115,115,32,116,104,101,110,32,48,0,66,97,100,32,101,114,114,111,114,32,108,111,99,97,116,105,111,110,0,114,95,123,105,45,49,125,32,119,97,115,32,122,101,114,111,0,68,105,118,105,115,105,111,110,32,97,108,103,111,114,105,116,104,109,32,102,97,105,108,101,100,32,116,111,32,114,101,100,117,99,101,32,112,111,108,121,110,111,109,105,97,108,63,0,115,105,103,109,97,84,105,108,100,101,40,48,41,32,119,97,115,32,122,101,114,111,0,69,114,114,111,114,32,108,111,99,97,116,111,114,32,100,101,103,114,101,101,32,100,111,101,115,32,110,111,116,32,109,97,116,99,104,32,110,117,109,98,101,114,32,111,102,32,114,111,111,116,115,0,83,72,73,70,84,95,74,73,83,0,73,83,79,56,56,53,57,45,49,0,68,105,109,101,110,115,105,111,110,32,109,117,115,116,32,98,101,32,101,118,101,110,44,32,62,32,56,32,60,32,49,52,52,0,67,111,117,108,100,110,39,116,32,100,101,99,111,100,101,32,118,101,114,115,105,111,110,0,68,105,109,101,110,115,105,111,110,32,111,102,32,98,105,116,77,97,116,114,105,120,32,109,117,115,116,32,109,97,116,99,104,32,116,104,101,32,118,101,114,115,105,111,110,32,115,105,122,101,0,85,110,115,117,112,112,111,114,116,101,100,32,109,111,100,101,32,105,110,100,105,99,97,116,111,114,0,78,111,116,32,101,110,111,117,103,104,32,98,105,116,115,32,116,111,32,100,101,99,111,100,101,0,91,41,62,82,83,48,53,71,83,0,82,83,69,79,84,0,91,41,62,82,83,48,54,71,83,0,78,111,116,32,116,111,32,98,101,32,117,115,101,100,32,105,110,32,65,83,67,73,73,32,101,110,99,111,100,97,116,105,111,110,0,100,101,99,111,100,101,67,52,48,83,101,103,109,101,110,116,58,32,85,112,112,101,114,32,83,104,105,102,116,0,100,101,99,111,100,101,67,52,48,83,101,103,109,101,110,116,58,32,110,111,32,99,97,115,101,0,100,101,99,111,100,101,84,101,120,116,83,101,103,109,101,110,116,58,32,85,112,112,101,114,32,83,104,105,102,116,0,100,101,99,111,100,101,84,101,120,116,83,101,103,109,101,110,116,58,32,110,111,32,99,97,115,101,0,100,101,99,111,100,101,65,110,115,105,88,49,50,83,101,103,109,101,110,116,58,32,110,111,32,99,97,115,101,0,78,101,103,97,116,105,118,101,65,114,114,97,121,83,105,122,101,69,120,99,101,112,116,105,111,110,0,98,121,116,101,83,101,103,109,101,110,116,115,0,78,117,109,98,101,114,32,111,102,32,114,111,119,115,32,97,110,100,32,99,111,108,117,109,110,115,32,109,117,115,116,32,98,101,32,101,118,101,110,0,69,114,114,111,114,32,118,101,114,115,105,111,110,32,110,111,116,32,102,111,117,110,100,0,85,110,114,101,99,111,103,110,105,122,100,32,98,97,114,99,111,100,101,32,102,111,114,109,97,116,0,84,104,105,115,32,108,117,109,105,110,97,110,99,101,32,115,111,117,114,99,101,32,100,111,101,115],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE+38136);allocate([32,110,111,116,32,115,117,112,112,111,114,116,32,99,114,111,112,112,105,110,103,46,0,84,104,105,115,32,108,117,109,105,110,97,110,99,101,32,115,111,117,114,99,101,32,100,111,101,115,32,110,111,116,32,115,117,112,112,111,114,116,32,114,111,116,97,116,105,111,110,46,0,78,111,32,99,111,100,101,32,100,101,116,101,99,116,101,100,0,48,49,50,51,52,53,54,55,56,57,45,36,58,47,46,43,65,66,67,68,0,65,66,67,68,0,48,49,50,51,52,53,54,55,56,57,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,45,46,32,42,36,47,43,37,0,48,49,50,51,52,53,54,55,56,57,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,45,46,32,36,47,43,37,97,98,99,100,42,0,48,48,48,48,0,48,48,48,48,48,0,66,105,116,77,97,116,114,105,120,80,97,114,115,101,114,58,58,114,101,97,100,67,111,100,101,119,111,114,100,115,40,80,68,70,41,58,32,84,111,111,32,109,97,110,121,32,114,111,119,115,33,0,66,105,116,77,97,116,114,105,120,80,97,114,115,101,114,58,58,112,114,111,99,101,115,115,82,111,119,40,80,68,70,52,49,55,41,58,32,101,114,97,115,101,67,111,117,110,116,32,116,111,111,32,98,105,103,33,0,66,105,116,77,97,116,114,105,120,80,97,114,115,101,114,58,58,112,114,111,99,101,115,115,82,111,119,40,80,68,70,52,49,55,41,58,32,99,111,100,101,119,111,114,100,115,32,105,110,100,101,120,32,111,117,116,32,111,102,32,98,111,117,110,100,46,0,66,105,116,77,97,116,114,105,120,80,97,114,115,101,114,58,58,116,114,105,109,65,114,114,97,121,58,32,110,101,103,97,116,105,118,101,32,115,105,122,101,33,0,68,101,99,111,100,101,100,66,105,116,83,116,114,101,97,109,80,97,114,115,101,114,58,58,100,101,99,111,100,101,66,97,115,101,57,48,48,116,111,66,97,115,101,49,48,58,32,83,116,114,105,110,103,32,100,111,101,115,32,110,111,116,32,98,101,103,105,110,32,119,105,116,104,32,49,0,80,68,70,58,68,101,99,111,100,101,114,58,100,101,99,111,100,101,58,32,99,97,110,110,111,116,32,114,101,97,100,32,99,111,100,101,119,111,114,100,115,0,80,68,70,58,68,101,99,111,100,101,114,58,99,111,114,114,101,99,116,69,114,114,111,114,115,58,32,84,111,111,32,109,97,110,121,32,101,114,114,111,114,115,32,111,114,32,69,67,32,67,111,100,101,119,111,114,100,115,32,99,111,114,114,117,112,116,101,100,0,80,68,70,58,68,101,99,111,100,101,114,58,99,111,114,114,101,99,116,69,114,114,111,114,115,58,32,69,114,114,111,114,32,99,111,114,114,101,99,116,105,111,110,32,100,105,100,32,110,111,116,32,115,117,99,99,101,101,100,33,0,80,68,70,58,68,101,99,111,100,101,114,58,118,101,114,105,102,121,67,111,100,101,119,111,114,100,67,111,117,110,116,58,32,99,111,100,101,119,111,114,100,32,97,114,114,97,121,32,116,111,111,32,115,109,97,108,108,33,0,80,68,70,58,68,101,99,111,100,101,114,58,118,101,114,105,102,121,67,111,100,101,119,111,114,100,67,111,117,110,116,58,32,98,97,100,32,99,111,100,101,119,111,114,100,32,110,117,109,98,101,114,32,100,101,115,99,114,105,112,116,111,114,33,0,80,68,70,58,68,101,99,111,100,101,114,58,118,101,114,105,102,121,67,111,100,101,119,111,114,100,67,111,117,110,116,58,32,98,97,100,32,101,114,114,111,114,32,99,111,114,114,101,99,116,105,111,110,32,99,119,32,110,117,109,98,101,114,33,0,66,97,100,32,101,114,114,111,114,32,108,111,99,97,116,105,111,110,33,0,69,117,99,108,105,100,101,97,110,32,97,108,103,111,114,105,116,104,109,32,97,108,114,101,97,100,121,32,116,101,114,109,105,110,97,116,101,100,63,0,115,105,103,109,97,84,105,108,100,101,32,61,32,48,33,0,69,114,114,111,114,32,110,117,109,98,101,114,32,105,110,99,111,110,115,105,115,116,101,110,99,121,33,0,109,111,110,111,109,105,97,108,58,32,100,101,103,114,101,101,32,60,32,48,33,0,108,111,103,32,111,102,32,122,101,114,111,33,0,105,110,118,101,114,115,101,32,111,102,32,122,101,114,111,33,0,110,111,32,99,111,101,102,102,105,99,105,101,110,116,115,33,0,77,111,100,117,108,117,115,80,111,108,121,115,32,100,111,32,110,111,116,32,104,97,118,101,32,115,97,109,101,32,77,111,100,117,108,117,115,71,70,32,102,105,101,108,100,0,110,101,103,97,116,105,118,101,32,100,101,103,114,101,101,33,0,78,111,32,118,101,114,116,105,99,101,115,32,102,111,117,110,100,46,0,66,97,100,32,109,111,100,117,108,101,32,119,105,100,116,104,46,0,66,97,100,32,100,105,109,101,110,115,105,111,110,46,0,67,97,110,110,111,116,32,102,105,110,100,32,101,110,111,117,103,104,32,80,68,70,52,49,55,32,103,117,97,114,100,32,112,97,116,116,101,114,110,115,33,0,80,68,70,58,68,101,116,101,99,116,111,114,58,32,99,97,110,110,111,116,32,102,105,110,100,32,116,104,101,32,99,114,111,115,115,105,110,103,32,111,102,32,112,97,114,97,108,108,101,108,32,108,105,110,101,115,33,0,80,68,70,58,68,101,116,101,99,116,111,114,58,32,99,114,111,115,115,105,110,103,32,112,111,105,110,116,115,32,111,117,116,32,111,102,32,114,101,103,105,111,110,33,0,73,110,99,111,110,115,105,115,116,101,110,116,32,110,117,109,98,101,114,32,111,102,32,115,121,109,98,111,108,115,32,105,110,32,116,104,105,115,32,108,105,110,101,46,0,68,105,109,101,110,115,105,111,110,32,109,117,115,116,32,98,101,32,49,32,109,111,100,32,52,32,97,110,100,32,62,61,32,50,49,0,67,111,117,108,100,32,110,111,116,32,100,101,99,111,100,101,32,102,111,114,109,97,116,32,105,110,102,111,114,109,97,116,105,111,110,0,67,111,117,108,100,32,110,111,116,32,100,101,99,111,100,101,32,118,101,114,115,105,111,110,0,68,105,100,32,110,111,116,32,114,101,97,100,32,97,108,108,32,99,111,100,101,119,111,114,100,115,0,68,97,116,97,32,98,108,111,99,107,32,115,105,122,101,115,32,100,105,102,102,101,114,32,98,121,32,109,111,114,101,32,116,104,97,110,32,49,0,114,97,119,67,111,100,101,119,111,114,100,115,79,102,102,115,101,116,32,33,61,32,114,97,119,67,111,100,101,119,111,114,100,115,46,108,101,110,103,116,104,0,114,101,102,101,114,101,110,99,101,32,109,117,115,116,32,98,101,32,98,101,116,119,101,101,110,32,48,32,97,110,100,32,55,0,102,111,114,109,97,116,32,101,120,99,101,112,116,105,111,110,0,73,108,108,101,103,97,108,32,118,97,108,117,101,32,102,111,114,32,51,45,100,105,103,105,116,32,117,110,105,116,58,32,0,73,108,108,101,103,97,108,32,118,97,108,117,101,32,102,111,114,32,50,45,100,105,103,105,116,32,117,110,105,116,58,32,0,73,108,108,101,103,97,108,32,118,97,108,117,101,32,102,111,114,32,100,105,103,105,116,32,117,110,105,116,58,32,0,73,108,108,101,103,97,108,32,109,111,100,101,32,98,105,116,115,58,32,0,67,111,117,108,100,32,110,111,116,32,102,105,110,100,32,97,108,105,103,110,109,101,110,116,32,112,97,116,116,101,114,110,0,98,97,100,32,109,111,100,117,108,101,32,115,105,122,101,0,66,97,100,32,100,105,109,101,110,115,105,111,110,58,32,0,114,101,103,105,111,110,32,116,111,111,32,115,109,97,108,108,32,116,111,32,104,111,108,100,32,97,108,105,103,110,109,101,110,116,32,112,97,116,116,101,114,110,0,67,111,117,108,100,32,110,111,116,32,102,105,110,100,32,116,104,114,101,101,32,102,105,110,100,101,114,32,112,97,116,116,101,114,110,115,0,69,108,108,101,103,97,108,32,101,114,114,111,114,32,99,111,114,114,101,99,116,105,111,110,32,108,101,118,101,108,32,98,105,116,115,0,118,101,114,115,105,111,110,78,117,109,98,101,114,32,109,117,115,116,32,98,101,32,98,101,116,119,101,101,110,32,49,32,97,110,100,32,52,48,0,66,105,103,85,110,115,105,103,110,101,100,58,58,115,117,98,116,114,97,99,116,58,32,78,101,103,97,116,105,118,101,32,114,101,115,117,108,116,32,105,110,32,117,110,115,105,103,110,101,100,32,99,97,108,99,117,108,97,116,105,111,110,0,66,105,103,85,110,115,105,103,110,101,100,58,58,100,105,118,105,100,101,87,105,116,104,82,101,109,97,105,110,100,101,114,58,32,67,97,110,110,111,116,32,119,114,105,116,101,32,113,117,111,116,105,101,110,116,32,97,110,100,32,114,101,109,97,105,110,100,101,114,32,105,110,116,111,32,116,104,101,32,115,97,109,101,32,118,97,114,105,97,98,108,101,0,66,105,103,85,110,115,105,103,110,101,100,73,110,65,66,97,115,101,40,66,105,103,85,110,115,105,103,110,101,100,44,32,66,97,115,101,41,58,32,84,104,101,32,98,97,115,101,32,109,117,115,116,32,98,101,32,97,116,32,108,101,97,115,116,32,50,0,66,105,103,85,110,115,105,103,110,101,100,73,110,65,66,97,115,101,32,61,61,62,32,115,116,100,58,58,115,116,114,105,110,103,58,32,84,104,101,32,100,101,102,97,117,108,116,32,115,116,114,105,110,103,32,99,111,110,118,101,114,115,105,111,110,32,114,111,117,116,105,110,101,115,32,117,115,101,32,116,104,101,32,115,121,109,98,111,108,32,115,101,116,32,48,45,57,44,32,65,45,90,32,97,110,100,32,116,104,101,114,101,102,111,114,101,32,115,117,112,112,111,114,116,32,111,110,108,121,32,117,112,32,116,111,32,98,97,115,101,32,51,54,46,32,32,89,111,117,32,116,114,105,101,100,32,97,32,99,111,110,118,101,114,115,105,111,110,32,119,105,116,104,32,97,32,98,97,115,101,32,111,118,101,114,32,51,54,59,32,119,114,105,116,101,32,121,111,117,114,32,111,119,110,32,115,116,114,105,110,103,32,99,111,110,118,101,114,115,105,111,110,32,114,111,117,116,105,110,101,46,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,57,70,105,110,100,101,114,80,97,116,116,101,114,110,70,105,110,100,101,114,69,0,66,105,103,85,110,115,105,103,110,101,100,58,58,116,111,60,80,114,105,109,105,116,105,118,101,62,58,32,86,97,108,117,101,32,105,115,32,116,111,111,32,98,105,103,32,116,111,32,102,105,116,32,105,110,32,116,104,101,32,114,101,113,117,101,115,116,101,100,32,116,121,112,101,0,66,105,103,85,110,115,105,103,110,101,100,32,99,111,110,115,116,114,117,99,116,111,114,58,32,67,97,110,110,111,116,32,99,111,110,115,116,114,117,99,116,32,97,32,66,105,103,85,110,115,105,103,110,101,100,32,102,114,111,109,32,97,32,110,101,103,97,116,105,118,101,32,110,117,109,98,101,114,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,55,70,111,114,109,97,116,73,110,102,111,114,109,97,116,105,111,110,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,55,70,105,110,100,101,114,80,97,116,116,101,114,110,73,110,102,111,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,51,70,105,110,100,101,114,80,97,116,116,101,114,110,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,54,65,108,105,103,110,109,101,110,116,80,97,116,116,101,114,110,69,0,78,53,122,120,105,110,103,53,65,114,114,97,121,73,78,83,95,56,65,114,114,97,121,82,101,102,73,99,69,69,69,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,49,68,97,116,97,77,97,115,107,49,49,49,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,49,68,97,116,97,77,97,115,107,49,49,48,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,49,68,97,116,97,77,97,115,107,49,48,49,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,49,68,97,116,97,77,97,115,107,49,48,48,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,49,68,97,116,97,77,97,115,107,48,49,49,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,49,68,97,116,97,77,97,115,107,48,49,48,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,49,68,97,116,97,77,97,115,107,48,48,49,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,49,68,97,116,97,77,97,115,107,48,48,48,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,57,68,97,116,97,66,108,111,99,107,69,0,78,53,122,120,105,110,103,54,113,114,99,111,100,101,49,53,66,105,116,77,97,116,114,105,120,80,97,114,115,101,114,69,0,80,78,53,122,120,105,110,103,50,52,73,108,108,101,103,97,108,65,114,103,117,109,101,110,116,69,120,99,101,112,116,105,111,110,69,0,78,53,122,120,105,110,103,54,112,100,102,52,49,55,55,100,101,99,111,100,101,114,50,101,99,49,53,69,114,114,111,114,67,111,114,114,101,99,116,105,111,110,69,0,78,53,122,120,105,110,103,56,65,114,114,97,121,82,101,102,73,49,48,66,105,103,73,110,116,101,103,101,114,69,69,0,78,53,122,120,105,110,103,53,65,114,114,97,121,73,49,48,66,105,103,73,110,116,101,103,101,114,69,69,0,78,53,122,120,105,110,103,54,112,100,102,52,49,55,55,100,101,99,111,100,101,114,49,53,66,105,116,77,97,116,114,105,120,80,97,114,115,101,114,69,0,78,53,122,120,105,110,103,52,111,110,101,100,49,53,79,110,101,68,82,101,115,117,108,116,80,111,105,110,116,69,0,78,53,122,120,105,110,103,49,48,100,97,116,97,109,97,116,114,105,120,50,54,82,101,115,117,108,116,80,111,105,110,116,115,65,110,100,84,114,97,110,115,105,116,105,111,110,115,69,0,78,53,122,120,105,110,103,57,66,105,116,83,111,117,114,99,101,69,0,78,53,122,120,105,110,103,49,48,100,97,116,97,109,97,116,114,105,120,57,68,97,116,97,66,108,111,99,107,69,0,78,53,122,120,105,110,103,49,48,100,97,116,97,109,97,116,114,105,120,49,53,66,105,116,77,97,116,114,105,120,80,97,114,115,101,114,69,0,78,53,122,120,105,110,103,54,83,116,114,105,110,103,69,0,78,53,122,120,105,110,103,50,49,73,108,108,101,103,97,108,83,116,97,116,101,69,120,99,101,112,116,105,111,110,69,0,78,53,122,120,105,110,103,49,51,71,101,110,101,114,105,99,71,70,80,111,108,121,69,0,78,53,122,120,105,110,103,57,71,101,110,101,114,105,99,71,70,69,0,78,53,122,120,105,110,103,50,48,80,101,114,115,112,101,99,116,105,118,101,84,114,97,110,115,102,111,114,109,69,0,78,53,122,120,105,110,103,49,52,68,101,116,101,99,116,111,114,82,101,115,117,108,116,69,0,78,53,122,120,105,110,103,56,65,114,114,97,121,82,101,102,73,78,83,48,95,73,99,69,69,69,69,0,78,53,122,120,105,110,103,49,51,68,101,99,111,100,101,114,82,101,115,117,108,116,69,0,78,53,122,120,105,110,103,54,99,111,109,109,111,110,49,53,67,104,97,114,97,99,116,101,114,83,101,116,69,67,73,69,0,69,85,67,95,75,82,0,69,85,67,45,75,82,0,71,66,49,56,48,51,48,0,71,66,50,51,49,50,0,69,85,67,95,67,78,0,71,66,75,0,66,105,103,53,0,65,83,67,73,73,0,85,83,45,65,83,67,73,73,0,85,84,70,56,0,85,84,70,45,56,0,85,110,105,99,111,100,101,66,105,103,85,110,109,97,114,107,101,100,0,85,84,70,45,49,54,66,69,0,85,110,105,99,111,100,101,66,105,103,0,67,112,49,50,53,54,0,119,105,110,100,111,119,115,45,49,50,53,54,0,67,112,49,50,53,50,0,119,105,110,100,111,119,115,45,49,50,53,50,0,67,112,49,50,53,49,0,119,105,110,100,111,119,115,45,49,50,53,49,0,67,112,49,50,53,48,0,119,105,110,100,111,119,115,45,49,50,53,48,0,83,74,73,83,0,83,104,105,102,116,95,74,73,83,0,73,83,79,56,56,53,57,95,49,54,0,73,83,79,45,56,56,53,57,45,49,54,0,73,83,79,56,56,53,57,95,49,53,0,73,83,79,45,56,56,53,57,45,49,53,0,73,83,79,56,56,53,57,95,49,52,0,73,83,79,45,56,56,53,57,45,49,52,0,73,83,79,56,56,53,57,95,49,51,0,73,83,79,45,56,56,53,57,45,49,51,0,73,83,79,56,56,53,57,95,49,49,0,73,83,79,45,56,56,53,57,45,49,49,0,73,83,79,56,56,53,57,95,49,48,0,73,83,79,45,56,56,53,57,45,49,48,0,73,83,79,56,56,53,57,95,57,0,73,83,79,45,56,56,53,57,45,57,0,73,83,79,56,56,53,57,95,56,0,73,83,79,45,56,56,53,57,45,56,0,73,83,79,56,56,53,57,95,55,0,73,83,79,45,56,56,53,57,45,55,0,73,83,79,56,56,53,57,95,54,0,73,83,79,45,56,56,53,57,45,54,0,73,83,79,56,56,53,57,95,53,0,73,83,79,45,56,56,53,57,45,53,0,73,83,79,56,56,53,57,95,52,0,73,83,79,45,56,56,53,57,45,52,0,73,83,79,56,56,53,57,95,51,0,73,83,79,45,56,56,53,57,45,51,0,73,83,79,56,56,53,57,95,50,0,73,83,79,45,56,56,53,57,45,50,0,73,83,79,56,56,53,57,95,49,0,73,83,79,45,56,56,53,57,45,49,0,67,112,52,51,55,0,78,83,116,51,95,95,49,49,53,98,97,115,105,99,95,115,116,114,105,110,103,98,117,102,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,78,83,95,57,97,108,108,111,99,97,116,111,114,73,99,69,69,69,69,0,78,83,116,51,95,95,49,49,57,98,97,115,105,99,95,111,115,116,114,105,110,103,115,116,114,101,97,109,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,78,83,95,57,97,108,108,111,99,97,116,111,114,73,99,69,69,69,69,0,66,111,116,104,32,100,105,109,101,110,115,105,111,110,115,32,109,117,115,116,32,98,101,32,103,114,101,97,116,101,114,32,116,104,97,110,32,48,0,78,53,122,120,105,110,103,56,65,114,114,97,121,82,101,102,73,105,69,69,0,78,53,122,120,105,110,103,53,65,114,114,97,121,73,105,69,69,0,78,53,122,120,105,110,103,53,65,114,114,97,121,73,78,83,95,51,82,101,102,73,78,83,95,49,49,82,101,115,117,108,116,80,111,105,110,116,69,69,69,69,69,0,78,53,122,120,105,110,103,53,97,122,116,101,99,53,80,111,105,110,116,69,0,78,53,122,120,105,110,103,49,55,78,111,116,70,111,117,110,100,69,120,99,101,112,116,105,111,110,69,0,78,53,122,120,105,110,103,50,50,87,104,105,116,101,82,101,99,116,97,110,103,108,101,68,101,116,101,99,116,111,114,69,0,67,84,82,76,95,80,83,0,32,0,48,0,49,0,50,0,51,0,52,0,53,0,54,0,55,0,56,0,57,0,44,0,67,84,82,76,95,85,76,0,67,84,82,76,95,85,83,0,13,0,13,10,0,46,32,0,44,32,0,33,0,34,0,35,0,36,0,37,0,38,0,39,0,40,0,41,0,42,0,43,0,45,0,47,0,58,0,59,0,60,0,61,0,62,0,63,0,91,0,93,0,123,0,125,0,1,0,2,0,3,0,4,0,5,0,6,0,7,0,8,0,9,0,10,0,11,0,12,0,27,0,28,0,29,0,30,0,31,0,64,0,92,0,94,0,95,0,96,0,124,0,126,0,127,0,67,84,82,76,95,76,76,0,67,84,82,76,95,80,76,0,67,84,82,76,95,66,83,0,97,0,98,0,99,0,100,0,101,0,102,0,103,0,104,0,105,0,106,0,107,0,109,0,110,0,111,0,112,0,113,0,114,0,115,0,116,0,117,0,118,0,119,0,120,0,121,0,122,0,67,84,82,76,95,77,76,0,67,84,82,76,95,68,76,0,65,0,66,0,68,0,69,0,70,0,71,0,73,0,74,0,75,0,78,0,79,0,80,0,82,0,83,0,84,0,85,0,86,0,87,0,88,0,89,0,90,0,78,53,122,120,105,110,103,53,97,122,116,101,99,55,68,101,99,111,100,101,114,69,0,78,53,122,120,105,110,103,53,97,122,116,101,99,56,68,101,116,101,99,116,111,114,69,0,78,53,122,120,105,110,103,53,97,122,116,101,99,49,57,65,122,116,101,99,68,101,116,101,99,116,111,114,82,101,115,117,108,116,69,0,77,0,81,0,72,0,84,69,82,77,73,78,65,84,79,82,0,78,85,77,69,82,73,67,0,65,76,80,72,65,78,85,77,69,82,73,67,0,83,84,82,85,67,84,85,82,69,68,95,65,80,80,69,78,68,0,66,89,84,69,0,69,67,73,0,75,65,78,74,73,0,70,78,67,49,95,70,73,82,83,84,95,80,79,83,73,84,73,79,78,0,70,78,67,49,95,83,69,67,79,78,68,95,80,79,83,73,84,73,79,78,0,72,65,78,90,73,0,118,111,105,100,0,98,111,111,108,0,99,104,97,114,0,115,105,103,110,101,100,32,99,104,97,114,0,117,110,115,105,103,110,101,100,32,99,104,97,114,0,115,104,111,114,116,0,117,110,115,105,103,110,101,100,32,115,104,111,114,116,0,105,110,116,0,117,110,115,105,103,110,101,100,32,105,110,116,0,108,111,110,103,0,117,110,115,105,103,110,101,100,32,108,111,110,103,0,102,108,111,97,116,0,100,111,117,98,108,101,0,115,116,100,58,58,115,116,114,105,110,103,0,115,116,100,58,58,98,97,115,105,99,95,115,116,114,105,110,103,60,117,110,115,105,103,110,101,100,32,99,104,97,114,62,0,115,116,100,58,58,119,115,116,114,105,110,103,0,101,109,115,99,114,105,112,116,101,110,58,58,118,97,108,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,99,104,97,114,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,115,105,103,110,101,100,32,99,104,97,114,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,117,110,115,105,103,110,101,100,32,99,104,97,114,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,115,104,111,114,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,117,110,115,105,103,110,101,100,32,115,104,111,114,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,105,110,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,117,110,115,105,103,110,101,100,32,105,110,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,108,111,110,103,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,117,110,115,105,103,110,101,100,32,108,111,110,103,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,105,110,116,56,95,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,117,105,110,116,56,95,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,105,110,116,49,54,95,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,117,105,110,116,49,54,95,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,105,110,116,51,50,95,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,117,105,110,116,51,50,95,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,102,108,111,97,116,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,100,111,117,98,108,101,62,0,101,109,115,99,114,105,112,116,101,110,58,58,109,101,109,111,114,121,95,118,105,101,119,60,108,111,110,103,32,100,111,117,98,108,101,62,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,101,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,100,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,102,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,109,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,108,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,106,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,105,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,116,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,115,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,104,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,97,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,49,49,109,101,109,111,114,121,95,118,105,101,119,73,99,69,69,0,78,49,48,101,109,115,99,114,105,112,116,101,110,51,118,97,108,69,0,78,83,116,51,95,95,49,49,50,98,97,115,105,99,95,115,116,114,105,110,103,73,119,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,119,69,69,78,83,95,57,97,108,108,111,99,97,116,111,114,73,119,69,69,69,69,0,78,83,116,51,95,95,49,50,49,95,95,98,97,115,105,99,95,115,116,114,105,110,103,95,99,111,109,109,111,110,73,76,98,49,69,69,69,0,78,83,116,51,95,95,49,49,50,98,97,115,105,99,95,115,116,114,105,110,103,73,104,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,104,69,69,78,83,95,57,97,108,108,111,99,97,116,111,114,73,104,69,69,69,69,0,78,83,116,51,95,95,49,49,50,98,97,115,105,99,95,115,116,114,105,110,103,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,78,83,95,57,97,108,108,111,99,97,116,111,114,73,99,69,69,69,69,0,83,116,57,98,97,100,95,97,108,108,111,99,0,83,116,57,101,120,99,101,112,116,105,111,110,0,83,116,49,51,114,117,110,116,105,109,101,95,101,114,114,111,114,0,83,116,57,116,121,112,101,95,105,110,102,111,0,83,116,56,98,97,100,95,99,97,115,116,0,78,49,48,95,95,99,120,120,97,98,105,118,49,49,54,95,95,115,104,105,109,95,116,121,112,101,95,105,110,102,111,69,0,78,49,48,95,95,99,120,120,97,98,105,118,49,49,55,95,95,99,108,97,115,115,95,116,121,112,101,95,105,110,102,111,69,0,78,49,48,95,95,99,120,120,97,98,105,118,49,49,57,95,95,112,111,105,110,116,101,114,95,116,121,112,101,95,105,110,102,111,69,0,78,49,48,95,95,99,120,120,97,98,105,118,49,49,55,95,95,112,98,97,115,101,95,116,121,112,101,95,105,110,102,111,69,0,78,49,48,95,95,99,120,120,97,98,105,118,49,50,51,95,95,102,117,110,100,97,109,101,110,116,97,108,95,116,121,112,101,95,105,110,102,111,69,0,68,110,0,80,75,99,0,78,49,48,95,95,99,120,120,97,98,105,118,49,50,48,95,95,115,105,95,99,108,97,115,115,95,116,121,112,101,95,105,110,102,111,69,0,78,49,48,95,95,99,120,120,97,98,105,118,49,50,49,95,95,118,109,105,95,99,108,97,115,115,95,116,121,112,101,95,105,110,102,111,69,0,33,34,98,97,115,105,99,95,115,116,114,105,110,103,32,108,101,110,103,116,104,95,101,114,114,111,114,34,0,47,85,115,101,114,115,47,105,108,109,97,114,105,47,68,111,119,110,108,111,97,100,115,47,101,109,115,100,107,95,112,111,114,116,97,98,108,101,47,101,109,115,99,114,105,112,116,101,110,47,49,46,51,53,46,48,47,115,121,115,116,101,109,47,105,110,99,108,117,100,101,47,108,105,98,99,120,120,47,115,116,114,105,110,103,0,95,95,116,104,114,111,119,95,108,101,110,103,116,104,95,101,114,114,111,114,0,33,34,118,101,99,116,111,114,32,108,101,110,103,116,104,95,101,114,114,111,114,34,0,47,85,115,101,114,115,47,105,108,109,97,114,105,47,68,111,119,110,108,111,97,100,115,47,101,109,115,100,107,95,112,111,114,116,97,98,108,101,47,101,109,115,99,114,105,112,116,101,110,47,49,46,51,53,46,48,47,115,121,115,116,101,109,47,105,110,99,108,117,100,101,47,108,105,98,99,120,120,47,118,101,99,116,111,114,0,112,116,104,114,101,97,100,95,111,110,99,101,32,102,97,105,108,117,114,101,32,105,110,32,95,95,99,120,97,95,103,101,116,95,103,108,111,98,97,108,115,95,102,97,115,116,40,41,0,115,116,100,58,58,98,97,100,95,97,108,108,111,99,0,116,101,114,109,105,110,97,116,101,95,104,97,110,100,108,101,114,32,117,110,101,120,112,101,99,116,101,100,108,121,32,114,101,116,117,114,110,101,100,0,116,101,114,109,105,110,97,116,101,95,104,97,110,100,108,101,114,32,117,110,101,120,112,101,99,116,101,100,108,121,32,116,104,114,101,119,32,97,110,32,101,120,99,101,112,116,105,111,110,0,115,116,100,58,58,98,97,100,95,99,97,115,116,0,99,97,110,110,111,116,32,99,114,101,97,116,101,32,112,116,104,114,101,97,100,32,107,101,121,32,102,111,114,32,95,95,99,120,97,95,103,101,116,95,103,108,111,98,97,108,115,40,41,0,99,97,110,110,111,116,32,122,101,114,111,32,111,117,116,32,116,104,114,101,97,100,32,118,97,108,117,101,32,102,111,114,32,95,95,99,120,97,95,103,101,116,95,103,108,111,98,97,108,115,40,41,0,33,34,98,97,115,105,99,95,115,116,114,105,110,103,32,111,117,116,95,111,102,95,114,97,110,103,101,34,0,95,95,116,104,114,111,119,95,111,117,116,95,111,102,95,114,97,110,103,101,0,116,101,114,109,105,110,97,116,105,110,103,32,119,105,116,104,32,37,115,32,101,120,99,101,112,116,105,111,110,32,111,102,32,116,121,112,101,32,37,115,58,32,37,115,0,116,101,114,109,105,110,97,116,105,110,103,32,119,105,116,104,32,37,115,32,101,120,99,101,112,116,105,111,110,32,111,102,32,116,121,112,101,32,37,115,0,116,101,114,109,105,110,97,116,105,110,103,32,119,105,116,104,32,37,115,32,102,111,114,101,105,103,110,32,101,120,99,101,112,116,105,111,110,0,116,101,114,109,105,110,97,116,105,110,103,0,117,110,99,97,117,103,104,116,0,84,33,34,25,13,1,2,3,17,75,28,12,16,4,11,29,18,30,39,104,110,111,112,113,98,32,5,6,15,19,20,21,26,8,22,7,40,36,23,24,9,10,14,27,31,37,35,131,130,125,38,42,43,60,61,62,63,67,71,74,77,88,89,90,91,92,93,94,95,96,97,99,100,101,102,103,105,106,107,108,114,115,116,121,122,123,124,0,73,108,108,101,103,97,108,32,98,121,116,101,32,115,101,113,117,101,110,99,101,0,68,111,109,97,105,110,32,101,114,114,111,114,0,82,101,115,117,108,116,32,110,111,116,32,114,101,112,114,101,115,101,110,116,97,98,108,101,0,78,111,116,32,97,32,116,116,121,0,80,101,114,109,105,115,115,105,111,110,32,100,101,110,105,101,100,0,79,112,101,114,97,116,105,111,110,32,110,111,116,32,112,101,114,109,105,116,116,101,100,0,78,111,32,115,117,99,104,32,102,105,108,101,32,111,114,32,100,105,114,101,99,116,111,114,121,0,78,111,32,115,117,99,104,32,112,114,111,99,101,115,115,0,70,105,108,101,32,101,120,105,115,116,115,0,86,97,108,117,101,32,116,111,111,32,108,97,114,103,101,32,102,111,114,32,100,97,116,97,32,116,121,112,101,0,78,111,32,115,112,97,99,101,32,108,101,102,116,32,111,110,32,100,101,118,105,99,101,0,79,117,116,32,111,102,32,109,101,109,111,114,121,0,82,101,115,111,117,114,99,101,32,98,117,115,121,0,73,110,116,101,114,114,117,112,116,101,100,32,115,121,115,116,101,109,32,99,97,108,108,0,82,101,115,111,117,114,99,101,32,116,101,109,112,111,114,97,114,105,108,121,32,117,110,97,118,97,105,108,97,98,108,101,0,73,110,118,97,108,105,100,32,115,101,101,107,0,67,114,111,115,115,45,100,101,118,105,99,101,32,108,105,110,107,0,82,101,97,100,45,111,110,108,121,32,102,105,108,101,32,115,121,115,116,101,109,0,68,105,114,101,99,116,111,114,121,32,110,111,116,32,101,109,112,116,121,0,67,111,110,110,101,99,116,105,111,110,32,114,101,115,101,116,32,98,121,32,112,101,101,114,0,79,112,101,114,97,116,105,111,110,32,116,105,109,101,100,32,111,117,116,0,67,111,110,110,101,99,116,105,111,110,32,114,101,102,117,115,101,100,0,72,111,115,116,32,105,115,32,100,111,119,110,0,72,111,115,116,32,105,115,32,117,110,114,101,97,99,104,97,98,108,101,0,65,100,100,114,101,115,115,32,105,110,32,117,115,101,0,66,114,111,107,101,110,32,112,105,112,101,0,73,47,79,32,101,114,114,111,114,0,78,111,32,115,117,99,104,32,100,101,118,105,99,101,32,111,114,32,97,100,100,114,101,115,115,0,66,108,111,99,107,32,100,101,118,105,99,101,32,114,101,113,117,105,114,101,100,0,78,111,32,115,117,99,104,32,100,101,118,105,99,101,0,78,111,116,32,97,32,100,105,114,101,99,116,111,114,121,0,73,115,32,97,32,100,105,114,101,99,116,111,114,121,0,84,101,120,116,32,102,105,108,101,32,98,117,115,121,0,69,120,101,99,32,102,111,114,109,97,116,32,101,114,114,111,114,0,73,110,118,97,108,105,100,32,97,114,103,117,109,101,110,116,0,65,114,103,117,109,101,110,116,32,108,105,115,116,32,116,111,111,32,108,111,110,103,0,83,121,109,98,111,108,105,99,32,108,105,110,107,32,108,111,111,112,0,70,105,108,101,110,97,109,101,32,116,111,111,32,108,111,110,103,0,84,111,111,32,109,97,110,121,32,111,112,101,110,32,102,105,108,101,115,32,105,110,32,115,121,115,116,101,109,0,78,111,32,102,105,108,101,32,100,101,115,99,114,105,112,116,111,114,115,32,97,118,97,105,108,97,98,108,101,0,66,97,100,32,102,105,108,101,32,100,101,115,99,114,105,112,116,111,114,0,78,111,32,99,104,105,108,100,32,112,114,111,99,101,115,115,0,66,97,100,32,97,100,100,114,101,115,115,0,70,105,108,101,32,116,111,111,32,108,97,114,103,101,0,84,111,111,32,109,97,110,121,32,108,105,110,107,115,0,78,111,32,108,111,99,107,115,32,97,118,97,105,108,97,98,108,101,0,82,101,115,111,117,114,99,101,32,100,101,97,100,108,111,99,107,32,119,111,117,108,100,32,111,99,99,117,114,0,83,116,97,116,101,32,110,111,116,32,114,101,99,111,118,101,114,97,98,108,101,0,80,114,101,118,105,111,117,115,32,111,119,110,101,114,32,100,105,101,100,0,79,112,101,114,97,116,105,111,110,32,99,97,110,99,101,108,101,100,0,70,117,110,99,116,105,111,110,32,110,111,116,32,105,109,112,108,101,109,101,110,116,101,100,0,78,111,32,109,101,115,115,97,103,101,32,111,102,32,100,101,115,105,114,101,100,32,116,121,112,101,0,73,100,101,110,116,105,102,105,101,114,32,114,101,109,111,118,101,100,0,68,101,118,105,99,101,32,110,111,116,32,97,32,115,116,114,101,97,109,0,78,111,32,100,97,116,97,32,97,118,97,105,108,97,98,108,101,0,68,101,118,105,99,101,32,116,105,109,101,111,117,116,0,79,117,116,32,111,102,32,115,116,114,101,97,109,115,32,114,101,115,111,117,114,99,101,115,0,76,105,110,107,32,104,97,115,32,98,101,101,110,32,115,101,118,101,114,101,100,0,80,114,111,116,111,99,111,108,32,101,114,114,111,114,0,66,97,100,32,109,101,115,115,97,103,101,0,70,105,108,101,32,100,101,115,99,114,105,112,116,111,114,32,105,110,32,98,97,100,32,115,116,97,116,101,0,78,111,116,32,97,32,115,111,99,107,101,116,0,68,101,115,116,105,110,97,116,105,111,110,32,97,100,100,114,101,115,115,32,114,101,113,117,105,114,101,100,0,77,101,115,115,97,103,101,32,116,111,111,32,108,97,114,103,101,0,80,114,111,116,111,99,111,108,32,119,114,111,110,103,32,116,121,112,101,32,102,111,114,32,115,111,99,107,101,116,0,80,114,111,116,111,99,111,108,32,110,111,116,32,97,118,97,105,108,97,98,108,101,0,80,114,111,116,111,99,111,108,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,83,111,99,107,101,116,32,116,121,112,101,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,78,111,116,32,115,117,112,112,111,114,116,101,100,0,80,114,111,116,111,99,111,108,32,102,97,109,105,108,121,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,65,100,100,114,101,115,115,32,102,97,109,105,108,121,32,110,111,116,32,115,117,112,112,111,114,116,101,100,32,98,121,32,112,114,111,116,111,99,111,108,0,65,100,100,114,101,115,115,32,110,111,116,32,97,118,97,105,108,97,98,108,101,0,78,101,116,119,111,114,107,32,105,115,32,100,111,119,110,0,78,101,116,119,111,114,107,32,117,110,114,101,97,99,104,97,98,108,101,0,67,111,110,110,101,99,116,105,111,110,32,114,101,115,101,116,32,98,121,32,110,101,116,119,111,114,107,0,67,111,110,110,101,99,116,105,111,110,32,97,98,111,114,116,101,100,0,78,111,32,98,117,102,102,101,114,32,115,112,97,99,101,32,97,118,97,105,108,97,98,108,101,0,83,111,99,107,101,116,32,105,115,32,99,111,110,110,101,99,116,101,100,0,83,111,99,107,101,116,32,110,111,116,32,99,111,110,110,101,99,116,101,100,0,67,97,110,110,111,116,32,115,101,110,100,32,97,102,116,101,114,32,115,111,99,107,101,116,32,115,104,117,116,100,111,119,110,0,79,112,101,114,97,116,105,111,110,32,97,108,114,101,97,100,121,32,105,110,32,112,114,111,103,114,101,115,115,0,79,112,101,114,97,116,105,111,110,32,105,110,32,112,114,111,103,114,101,115,115,0,83,116,97,108,101,32,102,105,108,101,32,104,97,110,100,108,101,0,82,101,109,111,116,101,32,73,47,79,32,101,114,114,111,114,0,81,117,111,116,97,32,101,120,99,101,101,100,101,100,0,78,111,32,109,101,100,105,117,109,32,102,111,117,110,100,0,87,114,111,110,103,32,109,101,100,105,117,109,32,116,121,112,101,0,78,111,32,101,114,114,111,114,32,105,110,102,111,114,109,97,116,105,111,110,0,0,105,110,102,105,110,105,116,121,0,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,0,1,2,3,4,5,6,7,8,9,255,255,255,255,255,255,255,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,255,255,255,255,255,255,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,0,1,2,4,7,3,6,5,0,80,79,83,73,88],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE+48376);allocate([17,0,10,0,17,17,17,0,0,0,0,5,0,0,0,0,0,0,9,0,0,0,0,11,0,0,0,0,0,0,0,0,17,0,15,10,17,17,17,3,10,7,0,1,19,9,11,11,0,0,9,6,11,0,0,11,0,6,17,0,0,0,17,17,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,17,0,10,10,17,17,17,0,10,0,0,2,0,9,11,0,0,0,9,0,11,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,0,0,0,0,12,0,0,0,0,12,0,0,0,0,9,12,0,0,0,0,0,12,0,0,12,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,4,13,0,0,0,0,9,14,0,0,0,0,0,14,0,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,15,0,0,0,0,15,0,0,0,0,9,16,0,0,0,0,0,16,0,0,16,0,0,18,0,0,0,18,18,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,18,0,0,0,18,18,18,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,10,0,0,0,0,9,11,0,0,0,0,0,11,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,0,0,0,0,12,0,0,0,0,12,0,0,0,0,9,12,0,0,0,0,0,12,0,0,12,0,0,48,49,50,51,52,53,54,55,56,57,65,66,67,68,69,70,45,43,32,32,32,48,88,48,120,0,40,110,117,108,108,41,0,45,48,88,43,48,88,32,48,88,45,48,120,43,48,120,32,48,120,0,105,110,102,0,73,78,70,0,110,97,110,0,78,65,78,0,46,0,78,83,116,51,95,95,49,56,105,111,115,95,98,97,115,101,55,102,97,105,108,117,114,101,69,0,78,83,116,51,95,95,49,56,105,111,115,95,98,97,115,101,69,0,78,83,116,51,95,95,49,57,98,97,115,105,99,95,105,111,115,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,69,69,0,78,83,116,51,95,95,49,49,53,98,97,115,105,99,95,115,116,114,101,97,109,98,117,102,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,69,69,0,78,83,116,51,95,95,49,49,51,98,97,115,105,99,95,111,115,116,114,101,97,109,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,69,69,0,78,83,116,51,95,95,49,49,57,95,95,105,111,115,116,114,101,97,109,95,99,97,116,101,103,111,114,121,69,0,105,111,115,95,98,97,115,101,58,58,99,108,101,97,114,0,105,111,115,116,114,101,97,109,0,117,110,115,112,101,99,105,102,105,101,100,32,105,111,115,116,114,101,97,109,95,99,97,116,101,103,111,114,121,32,101,114,114,111,114,0,48,49,50,51,52,53,54,55,56,57,97,98,99,100,101,102,65,66,67,68,69,70,120,88,43,45,112,80,105,73,110,78,0,78,83,116,51,95,95,49,54,108,111,99,97,108,101,53,102,97,99,101,116,69,0,78,83,116,51,95,95,49,53,99,116,121,112,101,73,119,69,69,0,78,83,116,51,95,95,49,55,99,111,100,101,99,118,116,73,99,99,49,49,95,95,109,98,115,116,97,116,101,95,116,69,69,0,78,83,116,51,95,95,49,55,99,111,100,101,99,118,116,73,68,115,99,49,49,95,95,109,98,115,116,97,116,101,95,116,69,69,0,78,83,116,51,95,95,49,55,99,111,100,101,99,118,116,73,68,105,99,49,49,95,95,109,98,115,116,97,116,101,95,116,69,69,0,78,83,116,51,95,95,49,49,54,95,95,110,97,114,114,111,119,95,116,111,95,117,116,102,56,73,76,106,51,50,69,69,69,0,78,83,116,51,95,95,49,49,55,95,95,119,105,100,101,110,95,102,114,111,109,95,117,116,102,56,73,76,106,51,50,69,69,69,0,78,83,116,51,95,95,49,55,99,111,100,101,99,118,116,73,119,99,49,49,95,95,109,98,115,116,97,116,101,95,116,69,69,0,78,83,116,51,95,95,49,54,108,111,99,97,108,101,53,95,95,105,109,112,69,0,78,83,116,51,95,95,49,55,99,111,108,108,97,116,101,73,99,69,69,0,78,83,116,51,95,95,49,55,99,111,108,108,97,116,101,73,119,69,69,0,78,83,116,51,95,95,49,53,99,116,121,112,101,73,99,69,69,0,78,83,116,51,95,95,49,56,110,117,109,112,117,110,99,116,73,99,69,69,0,78,83,116,51,95,95,49,56,110,117,109,112,117,110,99,116,73,119,69,69,0,78,83,116,51,95,95,49,55,110,117,109,95,103,101,116,73,99,78,83,95,49,57,105,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,69,69,69,69,0,78,83,116,51,95,95,49,55,110,117,109,95,103,101,116,73,119,78,83,95,49,57,105,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,119,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,119,69,69,69,69,69,69,0,78,83,116,51,95,95,49,55,110,117,109,95,112,117,116,73,99,78,83,95,49,57,111,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,69,69,69,69,0,78,83,116,51,95,95,49,55,110,117,109,95,112,117,116,73,119,78,83,95,49,57,111,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,119,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,119,69,69,69,69,69,69,0,78,83,116,51,95,95,49,56,116,105,109,101,95,103,101,116,73,99,78,83,95,49,57,105,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,69,69,69,69,0,78,83,116,51,95,95,49,56,116,105,109,101,95,103,101,116,73,119,78,83,95,49,57,105,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,119,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,119,69,69,69,69,69,69,0,78,83,116,51,95,95,49,56,116,105,109,101,95,112,117,116,73,99,78,83,95,49,57,111,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,69,69,69,69,0,78,83,116,51,95,95,49,56,116,105,109,101,95,112,117,116,73,119,78,83,95,49,57,111,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,119,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,119,69,69,69,69,69,69,0,78,83,116,51,95,95,49,49,48,109,111,110,101,121,112,117,110,99,116,73,99,76,98,48,69,69,69,0,78,83,116,51,95,95,49,49,48,109,111,110,101,121,112,117,110,99,116,73,99,76,98,49,69,69,69,0,78,83,116,51,95,95,49,49,48,109,111,110,101,121,112,117,110,99,116,73,119,76,98,48,69,69,69,0,78,83,116,51,95,95,49,49,48,109,111,110,101,121,112,117,110,99,116,73,119,76,98,49,69,69,69,0,78,83,116,51,95,95,49,57,109,111,110,101,121,95,103,101,116,73,99,78,83,95,49,57,105,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,69,69,69,69,0,78,83,116,51,95,95,49,57,109,111,110,101,121,95,103,101,116,73,119,78,83,95,49,57,105,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,119,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,119,69,69,69,69,69,69,0,78,83,116,51,95,95,49,57,109,111,110,101,121,95,112,117,116,73,99,78,83,95,49,57,111,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,99,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,99,69,69,69,69,69,69,0,78,83,116,51,95,95,49,57,109,111,110,101,121,95,112,117,116,73,119,78,83,95,49,57,111,115,116,114,101,97,109,98,117,102,95,105,116,101,114,97,116,111,114,73,119,78,83,95,49,49,99,104,97,114,95,116,114,97,105,116,115,73,119,69,69,69,69,69,69,0,78,83,116,51,95,95,49,56,109,101,115,115,97,103,101,115,73,99,69,69,0,78,83,116,51,95,95,49,56,109,101,115,115,97,103,101,115,73,119,69,69,0,37,112,0,67,0,37,0,0,0,0,0,108,0,108,108,0,0,76,0,37,112,0,0,0,0,37,72,58,37,77,58,37,83,37,109,47,37,100,47,37,121,37,89,45,37,109,45,37,100,37,73,58,37,77,58,37,83,32,37,112,37,72,58,37,77,37,72,58,37,77,58,37,83,108,111,99,97,108,101,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,48,49,50,51,52,53,54,55,56,57,0,37,76,102,0,109,111,110,101,121,95,103,101,116,32,101,114,114,111,114,0,48,49,50,51,52,53,54,55,56,57,0,37,46,48,76,102,0,116,114,117,101,0,102,97,108,115,101,0,83,117,110,100,97,121,0,77,111,110,100,97,121,0,84,117,101,115,100,97,121,0,87,101,100,110,101,115,100,97,121,0,84,104,117,114,115,100,97,121,0,70,114,105,100,97,121,0,83,97,116,117,114,100,97,121,0,83,117,110,0,77,111,110,0,84,117,101,0,87,101,100,0,84,104,117,0,70,114,105,0,83,97,116,0,74,97,110,117,97,114,121,0,70,101,98,114,117,97,114,121,0,77,97,114,99,104,0,65,112,114,105,108,0,77,97,121,0,74,117,110,101,0,74,117,108,121,0,65,117,103,117,115,116,0,83,101,112,116,101,109,98,101,114,0,79,99,116,111,98,101,114,0,78,111,118,101,109,98,101,114,0,68,101,99,101,109,98,101,114,0,74,97,110,0,70,101,98,0,77,97,114,0,65,112,114,0,74,117,110,0,74,117,108,0,65,117,103,0,83,101,112,0,79,99,116,0,78,111,118,0,68,101,99,0,65,77,0,80,77,0,37,109,47,37,100,47,37,121,0,37,72,58,37,77,58,37,83,0,37,97,32,37,98,32,37,100,32,37,72,58,37,77,58,37,83,32,37,89,0,37,73,58,37,77,58,37,83,32,37,112,0,78,83,116,51,95,95,49,49,51,109,101,115,115,97,103,101,115,95,98,97,115,101,69,0,78,83,116,51,95,95,49,49,49,95,95,109,111,110,101,121,95,112,117,116,73,119,69,69,0,78,83,116,51,95,95,49,49,49,95,95,109,111,110,101,121,95,112,117,116,73,99,69,69,0,78,83,116,51,95,95,49,49,49,95,95,109,111,110,101,121,95,103,101,116,73,119,69,69,0,78,83,116,51,95,95,49,49,49,95,95,109,111,110,101,121,95,103,101,116,73,99,69,69,0,78,83,116,51,95,95,49,49,48,109,111,110,101,121,95,98,97,115,101,69,0,78,83,116,51,95,95,49,49,48,95,95,116,105,109,101,95,112,117,116,69,0,78,83,116,51,95,95,49,50,48,95,95,116,105,109,101,95,103,101,116,95,99,95,115,116,111,114,97,103,101,73,119,69,69,0,78,83,116,51,95,95,49,50,48,95,95,116,105,109,101,95,103,101,116,95,99,95,115,116,111,114,97,103,101,73,99,69,69,0,78,83,116,51,95,95,49,57,116,105,109,101,95,98,97,115,101,69,0,78,83,116,51,95,95,49,57,95,95,110,117,109,95,112,117,116,73,119,69,69,0,78,83,116,51,95,95,49,49,52,95,95,110,117,109,95,112,117,116,95,98,97,115,101,69,0,78,83,116,51,95,95,49,57,95,95,110,117,109,95,112,117,116,73,99,69,69,0,78,83,116,51,95,95,49,57,95,95,110,117,109,95,103,101,116,73,119,69,69,0,78,83,116,51,95,95,49,49,52,95,95,110,117,109,95,103,101,116,95,98,97,115,101,69,0,78,83,116,51,95,95,49,57,95,95,110,117,109,95,103,101,116,73,99,69,69,0,78,83,116,51,95,95,49,49,50,99,111,100,101,99,118,116,95,98,97,115,101,69,0,78,83,116,51,95,95,49,49,48,99,116,121,112,101,95,98,97,115,101,69,0,78,83,116,51,95,95,49,49,52,95,95,115,104,97,114,101,100,95,99,111,117,110,116,69,0,78,83,116,51,95,95,49,49,50,115,121,115,116,101,109,95,101,114,114,111,114,69,0,78,83,116,51,95,95,49,49,52,101,114,114,111,114,95,99,97,116,101,103,111,114,121,69,0,78,83,116,51,95,95,49,49,50,95,95,100,111,95,109,101,115,115,97,103,101,69,0,58,32,0],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE+59042);var tempDoublePtr=Runtime.alignMemory(allocate(12,"i8",ALLOC_STATIC),8);assert(tempDoublePtr%8==0);function copyTempFloat(ptr){HEAP8[tempDoublePtr]=HEAP8[ptr];HEAP8[tempDoublePtr+1]=HEAP8[ptr+1];HEAP8[tempDoublePtr+2]=HEAP8[ptr+2];HEAP8[tempDoublePtr+3]=HEAP8[ptr+3]}function copyTempDouble(ptr){HEAP8[tempDoublePtr]=HEAP8[ptr];HEAP8[tempDoublePtr+1]=HEAP8[ptr+1];HEAP8[tempDoublePtr+2]=HEAP8[ptr+2];HEAP8[tempDoublePtr+3]=HEAP8[ptr+3];HEAP8[tempDoublePtr+4]=HEAP8[ptr+4];HEAP8[tempDoublePtr+5]=HEAP8[ptr+5];HEAP8[tempDoublePtr+6]=HEAP8[ptr+6];HEAP8[tempDoublePtr+7]=HEAP8[ptr+7]}function _atexit(func,arg){__ATEXIT__.unshift({func:func,arg:arg})}function ___cxa_atexit(){return _atexit.apply(null,arguments)}Module["_i64Add"]=_i64Add;Module["_i64Subtract"]=_i64Subtract;var _fabsf=Math_abs;var _floorf=Math_floor;function __ZSt18uncaught_exceptionv(){return!!__ZSt18uncaught_exceptionv.uncaught_exception}var EXCEPTIONS={last:0,caught:[],infos:{},deAdjust:(function(adjusted){if(!adjusted||EXCEPTIONS.infos[adjusted])return adjusted;for(var ptr in EXCEPTIONS.infos){var info=EXCEPTIONS.infos[ptr];if(info.adjusted===adjusted){return ptr}}return adjusted}),addRef:(function(ptr){if(!ptr)return;var info=EXCEPTIONS.infos[ptr];info.refcount++}),decRef:(function(ptr){if(!ptr)return;var info=EXCEPTIONS.infos[ptr];assert(info.refcount>0);info.refcount--;if(info.refcount===0){if(info.destructor){Runtime.dynCall("vi",info.destructor,[ptr])}delete EXCEPTIONS.infos[ptr];___cxa_free_exception(ptr)}}),clearRef:(function(ptr){if(!ptr)return;var info=EXCEPTIONS.infos[ptr];info.refcount=0})};function ___resumeException(ptr){if(!EXCEPTIONS.last){EXCEPTIONS.last=ptr}EXCEPTIONS.clearRef(EXCEPTIONS.deAdjust(ptr));throw ptr}function ___cxa_find_matching_catch(){var thrown=EXCEPTIONS.last;if(!thrown){return(asm["setTempRet0"](0),0)|0}var info=EXCEPTIONS.infos[thrown];var throwntype=info.type;if(!throwntype){return(asm["setTempRet0"](0),thrown)|0}var typeArray=Array.prototype.slice.call(arguments);var pointer=Module["___cxa_is_pointer_type"](throwntype);if(!___cxa_find_matching_catch.buffer)___cxa_find_matching_catch.buffer=_malloc(4);HEAP32[___cxa_find_matching_catch.buffer>>2]=thrown;thrown=___cxa_find_matching_catch.buffer;for(var i=0;i<typeArray.length;i++){if(typeArray[i]&&Module["___cxa_can_catch"](typeArray[i],throwntype,thrown)){thrown=HEAP32[thrown>>2];info.adjusted=thrown;return(asm["setTempRet0"](typeArray[i]),thrown)|0}}thrown=HEAP32[thrown>>2];return(asm["setTempRet0"](throwntype),thrown)|0}function ___cxa_throw(ptr,type,destructor){EXCEPTIONS.infos[ptr]={ptr:ptr,adjusted:ptr,type:type,destructor:destructor,refcount:0};EXCEPTIONS.last=ptr;if(!("uncaught_exception"in __ZSt18uncaught_exceptionv)){__ZSt18uncaught_exceptionv.uncaught_exception=1}else{__ZSt18uncaught_exceptionv.uncaught_exception++}throw ptr}function getShiftFromSize(size){switch(size){case 1:return 0;case 2:return 1;case 4:return 2;case 8:return 3;default:throw new TypeError("Unknown type size: "+size)}}function embind_init_charCodes(){var codes=new Array(256);for(var i=0;i<256;++i){codes[i]=String.fromCharCode(i)}embind_charCodes=codes}var embind_charCodes=undefined;function readLatin1String(ptr){var ret="";var c=ptr;while(HEAPU8[c]){ret+=embind_charCodes[HEAPU8[c++]]}return ret}var awaitingDependencies={};var registeredTypes={};var typeDependencies={};var char_0=48;var char_9=57;function makeLegalFunctionName(name){if(undefined===name){return"_unknown"}name=name.replace(/[^a-zA-Z0-9_]/g,"$");var f=name.charCodeAt(0);if(f>=char_0&&f<=char_9){return"_"+name}else{return name}}function createNamedFunction(name,body){name=makeLegalFunctionName(name);return(new Function("body","return function "+name+"() {\n"+'    "use strict";'+"    return body.apply(this, arguments);\n"+"};\n"))(body)}function extendError(baseErrorType,errorName){var errorClass=createNamedFunction(errorName,(function(message){this.name=errorName;this.message=message;var stack=(new Error(message)).stack;if(stack!==undefined){this.stack=this.toString()+"\n"+stack.replace(/^Error(:[^\n]*)?\n/,"")}}));errorClass.prototype=Object.create(baseErrorType.prototype);errorClass.prototype.constructor=errorClass;errorClass.prototype.toString=(function(){if(this.message===undefined){return this.name}else{return this.name+": "+this.message}});return errorClass}var BindingError=undefined;function throwBindingError(message){throw new BindingError(message)}var InternalError=undefined;function throwInternalError(message){throw new InternalError(message)}function whenDependentTypesAreResolved(myTypes,dependentTypes,getTypeConverters){myTypes.forEach((function(type){typeDependencies[type]=dependentTypes}));function onComplete(typeConverters){var myTypeConverters=getTypeConverters(typeConverters);if(myTypeConverters.length!==myTypes.length){throwInternalError("Mismatched type converter count")}for(var i=0;i<myTypes.length;++i){registerType(myTypes[i],myTypeConverters[i])}}var typeConverters=new Array(dependentTypes.length);var unregisteredTypes=[];var registered=0;dependentTypes.forEach((function(dt,i){if(registeredTypes.hasOwnProperty(dt)){typeConverters[i]=registeredTypes[dt]}else{unregisteredTypes.push(dt);if(!awaitingDependencies.hasOwnProperty(dt)){awaitingDependencies[dt]=[]}awaitingDependencies[dt].push((function(){typeConverters[i]=registeredTypes[dt];++registered;if(registered===unregisteredTypes.length){onComplete(typeConverters)}}))}}));if(0===unregisteredTypes.length){onComplete(typeConverters)}}function registerType(rawType,registeredInstance,options){options=options||{};if(!("argPackAdvance"in registeredInstance)){throw new TypeError("registerType registeredInstance requires argPackAdvance")}var name=registeredInstance.name;if(!rawType){throwBindingError('type "'+name+'" must have a positive integer typeid pointer')}if(registeredTypes.hasOwnProperty(rawType)){if(options.ignoreDuplicateRegistrations){return}else{throwBindingError("Cannot register type '"+name+"' twice")}}registeredTypes[rawType]=registeredInstance;delete typeDependencies[rawType];if(awaitingDependencies.hasOwnProperty(rawType)){var callbacks=awaitingDependencies[rawType];delete awaitingDependencies[rawType];callbacks.forEach((function(cb){cb()}))}}function __embind_register_bool(rawType,name,size,trueValue,falseValue){var shift=getShiftFromSize(size);name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":(function(wt){return!!wt}),"toWireType":(function(destructors,o){return o?trueValue:falseValue}),"argPackAdvance":8,"readValueFromPointer":(function(pointer){var heap;if(size===1){heap=HEAP8}else if(size===2){heap=HEAP16}else if(size===4){heap=HEAP32}else{throw new TypeError("Unknown boolean type size: "+name)}return this["fromWireType"](heap[pointer>>shift])}),destructorFunction:null})}var _emscripten_landingpad=true;function _free(){}Module["_free"]=_free;function ___cxa_free_exception(ptr){try{return _free(ptr)}catch(e){}}function ___cxa_end_catch(){if(___cxa_end_catch.rethrown){___cxa_end_catch.rethrown=false;return}asm["setThrew"](0);var ptr=EXCEPTIONS.caught.pop();if(ptr){EXCEPTIONS.decRef(EXCEPTIONS.deAdjust(ptr));EXCEPTIONS.last=0}}function _embind_repr(v){if(v===null){return"null"}var t=typeof v;if(t==="object"||t==="array"||t==="function"){return v.toString()}else{return""+v}}function integerReadValueFromPointer(name,shift,signed){switch(shift){case 0:return signed?function readS8FromPointer(pointer){return HEAP8[pointer]}:function readU8FromPointer(pointer){return HEAPU8[pointer]};case 1:return signed?function readS16FromPointer(pointer){return HEAP16[pointer>>1]}:function readU16FromPointer(pointer){return HEAPU16[pointer>>1]};case 2:return signed?function readS32FromPointer(pointer){return HEAP32[pointer>>2]}:function readU32FromPointer(pointer){return HEAPU32[pointer>>2]};default:throw new TypeError("Unknown integer type: "+name)}}function __embind_register_integer(primitiveType,name,size,minRange,maxRange){name=readLatin1String(name);if(maxRange===-1){maxRange=4294967295}var shift=getShiftFromSize(size);var fromWireType=(function(value){return value});if(minRange===0){var bitshift=32-8*size;fromWireType=(function(value){return value<<bitshift>>>bitshift})}registerType(primitiveType,{name:name,"fromWireType":fromWireType,"toWireType":(function(destructors,value){if(typeof value!=="number"&&typeof value!=="boolean"){throw new TypeError('Cannot convert "'+_embind_repr(value)+'" to '+this.name)}if(value<minRange||value>maxRange){throw new TypeError('Passing a number "'+_embind_repr(value)+'" from JS side to C/C++ side to an argument of type "'+name+'", which is outside the valid range ['+minRange+", "+maxRange+"]!")}return value|0}),"argPackAdvance":8,"readValueFromPointer":integerReadValueFromPointer(name,shift,minRange!==0),destructorFunction:null})}var _sqrtf=Math_sqrt;function ___setErrNo(value){if(Module["___errno_location"])HEAP32[Module["___errno_location"]()>>2]=value;return value}var ERRNO_CODES={EPERM:1,ENOENT:2,ESRCH:3,EINTR:4,EIO:5,ENXIO:6,E2BIG:7,ENOEXEC:8,EBADF:9,ECHILD:10,EAGAIN:11,EWOULDBLOCK:11,ENOMEM:12,EACCES:13,EFAULT:14,ENOTBLK:15,EBUSY:16,EEXIST:17,EXDEV:18,ENODEV:19,ENOTDIR:20,EISDIR:21,EINVAL:22,ENFILE:23,EMFILE:24,ENOTTY:25,ETXTBSY:26,EFBIG:27,ENOSPC:28,ESPIPE:29,EROFS:30,EMLINK:31,EPIPE:32,EDOM:33,ERANGE:34,ENOMSG:42,EIDRM:43,ECHRNG:44,EL2NSYNC:45,EL3HLT:46,EL3RST:47,ELNRNG:48,EUNATCH:49,ENOCSI:50,EL2HLT:51,EDEADLK:35,ENOLCK:37,EBADE:52,EBADR:53,EXFULL:54,ENOANO:55,EBADRQC:56,EBADSLT:57,EDEADLOCK:35,EBFONT:59,ENOSTR:60,ENODATA:61,ETIME:62,ENOSR:63,ENONET:64,ENOPKG:65,EREMOTE:66,ENOLINK:67,EADV:68,ESRMNT:69,ECOMM:70,EPROTO:71,EMULTIHOP:72,EDOTDOT:73,EBADMSG:74,ENOTUNIQ:76,EBADFD:77,EREMCHG:78,ELIBACC:79,ELIBBAD:80,ELIBSCN:81,ELIBMAX:82,ELIBEXEC:83,ENOSYS:38,ENOTEMPTY:39,ENAMETOOLONG:36,ELOOP:40,EOPNOTSUPP:95,EPFNOSUPPORT:96,ECONNRESET:104,ENOBUFS:105,EAFNOSUPPORT:97,EPROTOTYPE:91,ENOTSOCK:88,ENOPROTOOPT:92,ESHUTDOWN:108,ECONNREFUSED:111,EADDRINUSE:98,ECONNABORTED:103,ENETUNREACH:101,ENETDOWN:100,ETIMEDOUT:110,EHOSTDOWN:112,EHOSTUNREACH:113,EINPROGRESS:115,EALREADY:114,EDESTADDRREQ:89,EMSGSIZE:90,EPROTONOSUPPORT:93,ESOCKTNOSUPPORT:94,EADDRNOTAVAIL:99,ENETRESET:102,EISCONN:106,ENOTCONN:107,ETOOMANYREFS:109,EUSERS:87,EDQUOT:122,ESTALE:116,ENOTSUP:95,ENOMEDIUM:123,EILSEQ:84,EOVERFLOW:75,ECANCELED:125,ENOTRECOVERABLE:131,EOWNERDEAD:130,ESTRPIPE:86};function _sysconf(name){switch(name){case 30:return PAGE_SIZE;case 85:return totalMemory/PAGE_SIZE;case 132:case 133:case 12:case 137:case 138:case 15:case 235:case 16:case 17:case 18:case 19:case 20:case 149:case 13:case 10:case 236:case 153:case 9:case 21:case 22:case 159:case 154:case 14:case 77:case 78:case 139:case 80:case 81:case 82:case 68:case 67:case 164:case 11:case 29:case 47:case 48:case 95:case 52:case 51:case 46:return 200809;case 79:return 0;case 27:case 246:case 127:case 128:case 23:case 24:case 160:case 161:case 181:case 182:case 242:case 183:case 184:case 243:case 244:case 245:case 165:case 178:case 179:case 49:case 50:case 168:case 169:case 175:case 170:case 171:case 172:case 97:case 76:case 32:case 173:case 35:return-1;case 176:case 177:case 7:case 155:case 8:case 157:case 125:case 126:case 92:case 93:case 129:case 130:case 131:case 94:case 91:return 1;case 74:case 60:case 69:case 70:case 4:return 1024;case 31:case 42:case 72:return 32;case 87:case 26:case 33:return 2147483647;case 34:case 1:return 47839;case 38:case 36:return 99;case 43:case 37:return 2048;case 0:return 2097152;case 3:return 65536;case 28:return 32768;case 44:return 32767;case 75:return 16384;case 39:return 1e3;case 89:return 700;case 71:return 256;case 40:return 255;case 2:return 100;case 180:return 64;case 25:return 20;case 5:return 16;case 6:return 6;case 73:return 4;case 84:{if(typeof navigator==="object")return navigator["hardwareConcurrency"]||1;return 1}}___setErrNo(ERRNO_CODES.EINVAL);return-1}var _emscripten_postinvoke=true;var PTHREAD_SPECIFIC={};var PTHREAD_SPECIFIC_NEXT_KEY=1;function _pthread_key_create(key,destructor){if(key==0){return ERRNO_CODES.EINVAL}HEAP32[key>>2]=PTHREAD_SPECIFIC_NEXT_KEY;PTHREAD_SPECIFIC[PTHREAD_SPECIFIC_NEXT_KEY]=0;PTHREAD_SPECIFIC_NEXT_KEY++;return 0}var emval_free_list=[];var emval_handle_array=[{},{value:undefined},{value:null},{value:true},{value:false}];function __emval_decref(handle){if(handle>4&&0===--emval_handle_array[handle].refcount){emval_handle_array[handle]=undefined;emval_free_list.push(handle)}}function count_emval_handles(){var count=0;for(var i=5;i<emval_handle_array.length;++i){if(emval_handle_array[i]!==undefined){++count}}return count}function get_first_emval(){for(var i=5;i<emval_handle_array.length;++i){if(emval_handle_array[i]!==undefined){return emval_handle_array[i]}}return null}function init_emval(){Module["count_emval_handles"]=count_emval_handles;Module["get_first_emval"]=get_first_emval}function __emval_register(value){switch(value){case undefined:{return 1};case null:{return 2};case true:{return 3};case false:{return 4};default:{var handle=emval_free_list.length?emval_free_list.pop():emval_handle_array.length;emval_handle_array[handle]={refcount:1,value:value};return handle}}}function simpleReadValueFromPointer(pointer){return this["fromWireType"](HEAPU32[pointer>>2])}function __embind_register_emval(rawType,name){name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":(function(handle){var rv=emval_handle_array[handle].value;__emval_decref(handle);return rv}),"toWireType":(function(destructors,value){return __emval_register(value)}),"argPackAdvance":8,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction:null})}var ERRNO_MESSAGES={0:"Success",1:"Not super-user",2:"No such file or directory",3:"No such process",4:"Interrupted system call",5:"I/O error",6:"No such device or address",7:"Arg list too long",8:"Exec format error",9:"Bad file number",10:"No children",11:"No more processes",12:"Not enough core",13:"Permission denied",14:"Bad address",15:"Block device required",16:"Mount device busy",17:"File exists",18:"Cross-device link",19:"No such device",20:"Not a directory",21:"Is a directory",22:"Invalid argument",23:"Too many open files in system",24:"Too many open files",25:"Not a typewriter",26:"Text file busy",27:"File too large",28:"No space left on device",29:"Illegal seek",30:"Read only file system",31:"Too many links",32:"Broken pipe",33:"Math arg out of domain of func",34:"Math result not representable",35:"File locking deadlock error",36:"File or path name too long",37:"No record locks available",38:"Function not implemented",39:"Directory not empty",40:"Too many symbolic links",42:"No message of desired type",43:"Identifier removed",44:"Channel number out of range",45:"Level 2 not synchronized",46:"Level 3 halted",47:"Level 3 reset",48:"Link number out of range",49:"Protocol driver not attached",50:"No CSI structure available",51:"Level 2 halted",52:"Invalid exchange",53:"Invalid request descriptor",54:"Exchange full",55:"No anode",56:"Invalid request code",57:"Invalid slot",59:"Bad font file fmt",60:"Device not a stream",61:"No data (for no delay io)",62:"Timer expired",63:"Out of streams resources",64:"Machine is not on the network",65:"Package not installed",66:"The object is remote",67:"The link has been severed",68:"Advertise error",69:"Srmount error",70:"Communication error on send",71:"Protocol error",72:"Multihop attempted",73:"Cross mount point (not really error)",74:"Trying to read unreadable message",75:"Value too large for defined data type",76:"Given log. name not unique",77:"f.d. invalid for this operation",78:"Remote address changed",79:"Can   access a needed shared lib",80:"Accessing a corrupted shared lib",81:".lib section in a.out corrupted",82:"Attempting to link in too many libs",83:"Attempting to exec a shared library",84:"Illegal byte sequence",86:"Streams pipe error",87:"Too many users",88:"Socket operation on non-socket",89:"Destination address required",90:"Message too long",91:"Protocol wrong type for socket",92:"Protocol not available",93:"Unknown protocol",94:"Socket type not supported",95:"Not supported",96:"Protocol family not supported",97:"Address family not supported by protocol family",98:"Address already in use",99:"Address not available",100:"Network interface is not configured",101:"Network is unreachable",102:"Connection reset by network",103:"Connection aborted",104:"Connection reset by peer",105:"No buffer space available",106:"Socket is already connected",107:"Socket is not connected",108:"Can't send after socket shutdown",109:"Too many references",110:"Connection timed out",111:"Connection refused",112:"Host is down",113:"Host is unreachable",114:"Socket already connected",115:"Connection already in progress",116:"Stale file handle",122:"Quota exceeded",123:"No medium (in tape drive)",125:"Operation canceled",130:"Previous owner died",131:"State not recoverable"};var PATH={splitPath:(function(filename){var splitPathRe=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;return splitPathRe.exec(filename).slice(1)}),normalizeArray:(function(parts,allowAboveRoot){var up=0;for(var i=parts.length-1;i>=0;i--){var last=parts[i];if(last==="."){parts.splice(i,1)}else if(last===".."){parts.splice(i,1);up++}else if(up){parts.splice(i,1);up--}}if(allowAboveRoot){for(;up--;up){parts.unshift("..")}}return parts}),normalize:(function(path){var isAbsolute=path.charAt(0)==="/",trailingSlash=path.substr(-1)==="/";path=PATH.normalizeArray(path.split("/").filter((function(p){return!!p})),!isAbsolute).join("/");if(!path&&!isAbsolute){path="."}if(path&&trailingSlash){path+="/"}return(isAbsolute?"/":"")+path}),dirname:(function(path){var result=PATH.splitPath(path),root=result[0],dir=result[1];if(!root&&!dir){return"."}if(dir){dir=dir.substr(0,dir.length-1)}return root+dir}),basename:(function(path){if(path==="/")return"/";var lastSlash=path.lastIndexOf("/");if(lastSlash===-1)return path;return path.substr(lastSlash+1)}),extname:(function(path){return PATH.splitPath(path)[3]}),join:(function(){var paths=Array.prototype.slice.call(arguments,0);return PATH.normalize(paths.join("/"))}),join2:(function(l,r){return PATH.normalize(l+"/"+r)}),resolve:(function(){var resolvedPath="",resolvedAbsolute=false;for(var i=arguments.length-1;i>=-1&&!resolvedAbsolute;i--){var path=i>=0?arguments[i]:FS.cwd();if(typeof path!=="string"){throw new TypeError("Arguments to path.resolve must be strings")}else if(!path){return""}resolvedPath=path+"/"+resolvedPath;resolvedAbsolute=path.charAt(0)==="/"}resolvedPath=PATH.normalizeArray(resolvedPath.split("/").filter((function(p){return!!p})),!resolvedAbsolute).join("/");return(resolvedAbsolute?"/":"")+resolvedPath||"."}),relative:(function(from,to){from=PATH.resolve(from).substr(1);to=PATH.resolve(to).substr(1);function trim(arr){var start=0;for(;start<arr.length;start++){if(arr[start]!=="")break}var end=arr.length-1;for(;end>=0;end--){if(arr[end]!=="")break}if(start>end)return[];return arr.slice(start,end-start+1)}var fromParts=trim(from.split("/"));var toParts=trim(to.split("/"));var length=Math.min(fromParts.length,toParts.length);var samePartsLength=length;for(var i=0;i<length;i++){if(fromParts[i]!==toParts[i]){samePartsLength=i;break}}var outputParts=[];for(var i=samePartsLength;i<fromParts.length;i++){outputParts.push("..")}outputParts=outputParts.concat(toParts.slice(samePartsLength));return outputParts.join("/")})};var TTY={ttys:[],init:(function(){}),shutdown:(function(){}),register:(function(dev,ops){TTY.ttys[dev]={input:[],output:[],ops:ops};FS.registerDevice(dev,TTY.stream_ops)}),stream_ops:{open:(function(stream){var tty=TTY.ttys[stream.node.rdev];if(!tty){throw new FS.ErrnoError(ERRNO_CODES.ENODEV)}stream.tty=tty;stream.seekable=false}),close:(function(stream){stream.tty.ops.flush(stream.tty)}),flush:(function(stream){stream.tty.ops.flush(stream.tty)}),read:(function(stream,buffer,offset,length,pos){if(!stream.tty||!stream.tty.ops.get_char){throw new FS.ErrnoError(ERRNO_CODES.ENXIO)}var bytesRead=0;for(var i=0;i<length;i++){var result;try{result=stream.tty.ops.get_char(stream.tty)}catch(e){throw new FS.ErrnoError(ERRNO_CODES.EIO)}if(result===undefined&&bytesRead===0){throw new FS.ErrnoError(ERRNO_CODES.EAGAIN)}if(result===null||result===undefined)break;bytesRead++;buffer[offset+i]=result}if(bytesRead){stream.node.timestamp=Date.now()}return bytesRead}),write:(function(stream,buffer,offset,length,pos){if(!stream.tty||!stream.tty.ops.put_char){throw new FS.ErrnoError(ERRNO_CODES.ENXIO)}for(var i=0;i<length;i++){try{stream.tty.ops.put_char(stream.tty,buffer[offset+i])}catch(e){throw new FS.ErrnoError(ERRNO_CODES.EIO)}}if(length){stream.node.timestamp=Date.now()}return i})},default_tty_ops:{get_char:(function(tty){if(!tty.input.length){var result=null;if(ENVIRONMENT_IS_NODE){var BUFSIZE=256;var buf=new Buffer(BUFSIZE);var bytesRead=0;var fd=process.stdin.fd;var usingDevice=false;try{fd=fs.openSync("/dev/stdin","r");usingDevice=true}catch(e){}bytesRead=fs.readSync(fd,buf,0,BUFSIZE,null);if(usingDevice){fs.closeSync(fd)}if(bytesRead>0){result=buf.slice(0,bytesRead).toString("utf-8")}else{result=null}}else if(typeof window!="undefined"&&typeof window.prompt=="function"){result=window.prompt("Input: ");if(result!==null){result+="\n"}}else if(typeof readline=="function"){result=readline();if(result!==null){result+="\n"}}if(!result){return null}tty.input=intArrayFromString(result,true)}return tty.input.shift()}),put_char:(function(tty,val){if(val===null||val===10){Module["print"](UTF8ArrayToString(tty.output,0));tty.output=[]}else{if(val!=0)tty.output.push(val)}}),flush:(function(tty){if(tty.output&&tty.output.length>0){Module["print"](UTF8ArrayToString(tty.output,0));tty.output=[]}})},default_tty1_ops:{put_char:(function(tty,val){if(val===null||val===10){Module["printErr"](UTF8ArrayToString(tty.output,0));tty.output=[]}else{if(val!=0)tty.output.push(val)}}),flush:(function(tty){if(tty.output&&tty.output.length>0){Module["printErr"](UTF8ArrayToString(tty.output,0));tty.output=[]}})}};var MEMFS={ops_table:null,mount:(function(mount){return MEMFS.createNode(null,"/",16384|511,0)}),createNode:(function(parent,name,mode,dev){if(FS.isBlkdev(mode)||FS.isFIFO(mode)){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}if(!MEMFS.ops_table){MEMFS.ops_table={dir:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr,lookup:MEMFS.node_ops.lookup,mknod:MEMFS.node_ops.mknod,rename:MEMFS.node_ops.rename,unlink:MEMFS.node_ops.unlink,rmdir:MEMFS.node_ops.rmdir,readdir:MEMFS.node_ops.readdir,symlink:MEMFS.node_ops.symlink},stream:{llseek:MEMFS.stream_ops.llseek}},file:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr},stream:{llseek:MEMFS.stream_ops.llseek,read:MEMFS.stream_ops.read,write:MEMFS.stream_ops.write,allocate:MEMFS.stream_ops.allocate,mmap:MEMFS.stream_ops.mmap,msync:MEMFS.stream_ops.msync}},link:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr,readlink:MEMFS.node_ops.readlink},stream:{}},chrdev:{node:{getattr:MEMFS.node_ops.getattr,setattr:MEMFS.node_ops.setattr},stream:FS.chrdev_stream_ops}}}var node=FS.createNode(parent,name,mode,dev);if(FS.isDir(node.mode)){node.node_ops=MEMFS.ops_table.dir.node;node.stream_ops=MEMFS.ops_table.dir.stream;node.contents={}}else if(FS.isFile(node.mode)){node.node_ops=MEMFS.ops_table.file.node;node.stream_ops=MEMFS.ops_table.file.stream;node.usedBytes=0;node.contents=null}else if(FS.isLink(node.mode)){node.node_ops=MEMFS.ops_table.link.node;node.stream_ops=MEMFS.ops_table.link.stream}else if(FS.isChrdev(node.mode)){node.node_ops=MEMFS.ops_table.chrdev.node;node.stream_ops=MEMFS.ops_table.chrdev.stream}node.timestamp=Date.now();if(parent){parent.contents[name]=node}return node}),getFileDataAsRegularArray:(function(node){if(node.contents&&node.contents.subarray){var arr=[];for(var i=0;i<node.usedBytes;++i)arr.push(node.contents[i]);return arr}return node.contents}),getFileDataAsTypedArray:(function(node){if(!node.contents)return new Uint8Array;if(node.contents.subarray)return node.contents.subarray(0,node.usedBytes);return new Uint8Array(node.contents)}),expandFileStorage:(function(node,newCapacity){if(node.contents&&node.contents.subarray&&newCapacity>node.contents.length){node.contents=MEMFS.getFileDataAsRegularArray(node);node.usedBytes=node.contents.length}if(!node.contents||node.contents.subarray){var prevCapacity=node.contents?node.contents.buffer.byteLength:0;if(prevCapacity>=newCapacity)return;var CAPACITY_DOUBLING_MAX=1024*1024;newCapacity=Math.max(newCapacity,prevCapacity*(prevCapacity<CAPACITY_DOUBLING_MAX?2:1.125)|0);if(prevCapacity!=0)newCapacity=Math.max(newCapacity,256);var oldContents=node.contents;node.contents=new Uint8Array(newCapacity);if(node.usedBytes>0)node.contents.set(oldContents.subarray(0,node.usedBytes),0);return}if(!node.contents&&newCapacity>0)node.contents=[];while(node.contents.length<newCapacity)node.contents.push(0)}),resizeFileStorage:(function(node,newSize){if(node.usedBytes==newSize)return;if(newSize==0){node.contents=null;node.usedBytes=0;return}if(!node.contents||node.contents.subarray){var oldContents=node.contents;node.contents=new Uint8Array(new ArrayBuffer(newSize));if(oldContents){node.contents.set(oldContents.subarray(0,Math.min(newSize,node.usedBytes)))}node.usedBytes=newSize;return}if(!node.contents)node.contents=[];if(node.contents.length>newSize)node.contents.length=newSize;else while(node.contents.length<newSize)node.contents.push(0);node.usedBytes=newSize}),node_ops:{getattr:(function(node){var attr={};attr.dev=FS.isChrdev(node.mode)?node.id:1;attr.ino=node.id;attr.mode=node.mode;attr.nlink=1;attr.uid=0;attr.gid=0;attr.rdev=node.rdev;if(FS.isDir(node.mode)){attr.size=4096}else if(FS.isFile(node.mode)){attr.size=node.usedBytes}else if(FS.isLink(node.mode)){attr.size=node.link.length}else{attr.size=0}attr.atime=new Date(node.timestamp);attr.mtime=new Date(node.timestamp);attr.ctime=new Date(node.timestamp);attr.blksize=4096;attr.blocks=Math.ceil(attr.size/attr.blksize);return attr}),setattr:(function(node,attr){if(attr.mode!==undefined){node.mode=attr.mode}if(attr.timestamp!==undefined){node.timestamp=attr.timestamp}if(attr.size!==undefined){MEMFS.resizeFileStorage(node,attr.size)}}),lookup:(function(parent,name){throw FS.genericErrors[ERRNO_CODES.ENOENT]}),mknod:(function(parent,name,mode,dev){return MEMFS.createNode(parent,name,mode,dev)}),rename:(function(old_node,new_dir,new_name){if(FS.isDir(old_node.mode)){var new_node;try{new_node=FS.lookupNode(new_dir,new_name)}catch(e){}if(new_node){for(var i in new_node.contents){throw new FS.ErrnoError(ERRNO_CODES.ENOTEMPTY)}}}delete old_node.parent.contents[old_node.name];old_node.name=new_name;new_dir.contents[new_name]=old_node;old_node.parent=new_dir}),unlink:(function(parent,name){delete parent.contents[name]}),rmdir:(function(parent,name){var node=FS.lookupNode(parent,name);for(var i in node.contents){throw new FS.ErrnoError(ERRNO_CODES.ENOTEMPTY)}delete parent.contents[name]}),readdir:(function(node){var entries=[".",".."];for(var key in node.contents){if(!node.contents.hasOwnProperty(key)){continue}entries.push(key)}return entries}),symlink:(function(parent,newname,oldpath){var node=MEMFS.createNode(parent,newname,511|40960,0);node.link=oldpath;return node}),readlink:(function(node){if(!FS.isLink(node.mode)){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}return node.link})},stream_ops:{read:(function(stream,buffer,offset,length,position){var contents=stream.node.contents;if(position>=stream.node.usedBytes)return 0;var size=Math.min(stream.node.usedBytes-position,length);assert(size>=0);if(size>8&&contents.subarray){buffer.set(contents.subarray(position,position+size),offset)}else{for(var i=0;i<size;i++)buffer[offset+i]=contents[position+i]}return size}),write:(function(stream,buffer,offset,length,position,canOwn){if(!length)return 0;var node=stream.node;node.timestamp=Date.now();if(buffer.subarray&&(!node.contents||node.contents.subarray)){if(canOwn){node.contents=buffer.subarray(offset,offset+length);node.usedBytes=length;return length}else if(node.usedBytes===0&&position===0){node.contents=new Uint8Array(buffer.subarray(offset,offset+length));node.usedBytes=length;return length}else if(position+length<=node.usedBytes){node.contents.set(buffer.subarray(offset,offset+length),position);return length}}MEMFS.expandFileStorage(node,position+length);if(node.contents.subarray&&buffer.subarray)node.contents.set(buffer.subarray(offset,offset+length),position);else{for(var i=0;i<length;i++){node.contents[position+i]=buffer[offset+i]}}node.usedBytes=Math.max(node.usedBytes,position+length);return length}),llseek:(function(stream,offset,whence){var position=offset;if(whence===1){position+=stream.position}else if(whence===2){if(FS.isFile(stream.node.mode)){position+=stream.node.usedBytes}}if(position<0){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}return position}),allocate:(function(stream,offset,length){MEMFS.expandFileStorage(stream.node,offset+length);stream.node.usedBytes=Math.max(stream.node.usedBytes,offset+length)}),mmap:(function(stream,buffer,offset,length,position,prot,flags){if(!FS.isFile(stream.node.mode)){throw new FS.ErrnoError(ERRNO_CODES.ENODEV)}var ptr;var allocated;var contents=stream.node.contents;if(!(flags&2)&&(contents.buffer===buffer||contents.buffer===buffer.buffer)){allocated=false;ptr=contents.byteOffset}else{if(position>0||position+length<stream.node.usedBytes){if(contents.subarray){contents=contents.subarray(position,position+length)}else{contents=Array.prototype.slice.call(contents,position,position+length)}}allocated=true;ptr=_malloc(length);if(!ptr){throw new FS.ErrnoError(ERRNO_CODES.ENOMEM)}buffer.set(contents,ptr)}return{ptr:ptr,allocated:allocated}}),msync:(function(stream,buffer,offset,length,mmapFlags){if(!FS.isFile(stream.node.mode)){throw new FS.ErrnoError(ERRNO_CODES.ENODEV)}if(mmapFlags&2){return 0}var bytesWritten=MEMFS.stream_ops.write(stream,buffer,0,length,offset,false);return 0})}};var IDBFS={dbs:{},indexedDB:(function(){if(typeof indexedDB!=="undefined")return indexedDB;var ret=null;if(typeof window==="object")ret=window.indexedDB||window.mozIndexedDB||window.webkitIndexedDB||window.msIndexedDB;assert(ret,"IDBFS used, but indexedDB not supported");return ret}),DB_VERSION:21,DB_STORE_NAME:"FILE_DATA",mount:(function(mount){return MEMFS.mount.apply(null,arguments)}),syncfs:(function(mount,populate,callback){IDBFS.getLocalSet(mount,(function(err,local){if(err)return callback(err);IDBFS.getRemoteSet(mount,(function(err,remote){if(err)return callback(err);var src=populate?remote:local;var dst=populate?local:remote;IDBFS.reconcile(src,dst,callback)}))}))}),getDB:(function(name,callback){var db=IDBFS.dbs[name];if(db){return callback(null,db)}var req;try{req=IDBFS.indexedDB().open(name,IDBFS.DB_VERSION)}catch(e){return callback(e)}req.onupgradeneeded=(function(e){var db=e.target.result;var transaction=e.target.transaction;var fileStore;if(db.objectStoreNames.contains(IDBFS.DB_STORE_NAME)){fileStore=transaction.objectStore(IDBFS.DB_STORE_NAME)}else{fileStore=db.createObjectStore(IDBFS.DB_STORE_NAME)}if(!fileStore.indexNames.contains("timestamp")){fileStore.createIndex("timestamp","timestamp",{unique:false})}});req.onsuccess=(function(){db=req.result;IDBFS.dbs[name]=db;callback(null,db)});req.onerror=(function(e){callback(this.error);e.preventDefault()})}),getLocalSet:(function(mount,callback){var entries={};function isRealDir(p){return p!=="."&&p!==".."}function toAbsolute(root){return(function(p){return PATH.join2(root,p)})}var check=FS.readdir(mount.mountpoint).filter(isRealDir).map(toAbsolute(mount.mountpoint));while(check.length){var path=check.pop();var stat;try{stat=FS.stat(path)}catch(e){return callback(e)}if(FS.isDir(stat.mode)){check.push.apply(check,FS.readdir(path).filter(isRealDir).map(toAbsolute(path)))}entries[path]={timestamp:stat.mtime}}return callback(null,{type:"local",entries:entries})}),getRemoteSet:(function(mount,callback){var entries={};IDBFS.getDB(mount.mountpoint,(function(err,db){if(err)return callback(err);var transaction=db.transaction([IDBFS.DB_STORE_NAME],"readonly");transaction.onerror=(function(e){callback(this.error);e.preventDefault()});var store=transaction.objectStore(IDBFS.DB_STORE_NAME);var index=store.index("timestamp");index.openKeyCursor().onsuccess=(function(event){var cursor=event.target.result;if(!cursor){return callback(null,{type:"remote",db:db,entries:entries})}entries[cursor.primaryKey]={timestamp:cursor.key};cursor.continue()})}))}),loadLocalEntry:(function(path,callback){var stat,node;try{var lookup=FS.lookupPath(path);node=lookup.node;stat=FS.stat(path)}catch(e){return callback(e)}if(FS.isDir(stat.mode)){return callback(null,{timestamp:stat.mtime,mode:stat.mode})}else if(FS.isFile(stat.mode)){node.contents=MEMFS.getFileDataAsTypedArray(node);return callback(null,{timestamp:stat.mtime,mode:stat.mode,contents:node.contents})}else{return callback(new Error("node type not supported"))}}),storeLocalEntry:(function(path,entry,callback){try{if(FS.isDir(entry.mode)){FS.mkdir(path,entry.mode)}else if(FS.isFile(entry.mode)){FS.writeFile(path,entry.contents,{encoding:"binary",canOwn:true})}else{return callback(new Error("node type not supported"))}FS.chmod(path,entry.mode);FS.utime(path,entry.timestamp,entry.timestamp)}catch(e){return callback(e)}callback(null)}),removeLocalEntry:(function(path,callback){try{var lookup=FS.lookupPath(path);var stat=FS.stat(path);if(FS.isDir(stat.mode)){FS.rmdir(path)}else if(FS.isFile(stat.mode)){FS.unlink(path)}}catch(e){return callback(e)}callback(null)}),loadRemoteEntry:(function(store,path,callback){var req=store.get(path);req.onsuccess=(function(event){callback(null,event.target.result)});req.onerror=(function(e){callback(this.error);e.preventDefault()})}),storeRemoteEntry:(function(store,path,entry,callback){var req=store.put(entry,path);req.onsuccess=(function(){callback(null)});req.onerror=(function(e){callback(this.error);e.preventDefault()})}),removeRemoteEntry:(function(store,path,callback){var req=store.delete(path);req.onsuccess=(function(){callback(null)});req.onerror=(function(e){callback(this.error);e.preventDefault()})}),reconcile:(function(src,dst,callback){var total=0;var create=[];Object.keys(src.entries).forEach((function(key){var e=src.entries[key];var e2=dst.entries[key];if(!e2||e.timestamp>e2.timestamp){create.push(key);total++}}));var remove=[];Object.keys(dst.entries).forEach((function(key){var e=dst.entries[key];var e2=src.entries[key];if(!e2){remove.push(key);total++}}));if(!total){return callback(null)}var errored=false;var completed=0;var db=src.type==="remote"?src.db:dst.db;var transaction=db.transaction([IDBFS.DB_STORE_NAME],"readwrite");var store=transaction.objectStore(IDBFS.DB_STORE_NAME);function done(err){if(err){if(!done.errored){done.errored=true;return callback(err)}return}if(++completed>=total){return callback(null)}}transaction.onerror=(function(e){done(this.error);e.preventDefault()});create.sort().forEach((function(path){if(dst.type==="local"){IDBFS.loadRemoteEntry(store,path,(function(err,entry){if(err)return done(err);IDBFS.storeLocalEntry(path,entry,done)}))}else{IDBFS.loadLocalEntry(path,(function(err,entry){if(err)return done(err);IDBFS.storeRemoteEntry(store,path,entry,done)}))}}));remove.sort().reverse().forEach((function(path){if(dst.type==="local"){IDBFS.removeLocalEntry(path,done)}else{IDBFS.removeRemoteEntry(store,path,done)}}))})};var NODEFS={isWindows:false,staticInit:(function(){NODEFS.isWindows=!!process.platform.match(/^win/)}),mount:(function(mount){assert(ENVIRONMENT_IS_NODE);return NODEFS.createNode(null,"/",NODEFS.getMode(mount.opts.root),0)}),createNode:(function(parent,name,mode,dev){if(!FS.isDir(mode)&&!FS.isFile(mode)&&!FS.isLink(mode)){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}var node=FS.createNode(parent,name,mode);node.node_ops=NODEFS.node_ops;node.stream_ops=NODEFS.stream_ops;return node}),getMode:(function(path){var stat;try{stat=fs.lstatSync(path);if(NODEFS.isWindows){stat.mode=stat.mode|(stat.mode&146)>>1}}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}return stat.mode}),realPath:(function(node){var parts=[];while(node.parent!==node){parts.push(node.name);node=node.parent}parts.push(node.mount.opts.root);parts.reverse();return PATH.join.apply(null,parts)}),flagsToPermissionStringMap:{0:"r",1:"r+",2:"r+",64:"r",65:"r+",66:"r+",129:"rx+",193:"rx+",514:"w+",577:"w",578:"w+",705:"wx",706:"wx+",1024:"a",1025:"a",1026:"a+",1089:"a",1090:"a+",1153:"ax",1154:"ax+",1217:"ax",1218:"ax+",4096:"rs",4098:"rs+"},flagsToPermissionString:(function(flags){flags&=~32768;if(flags in NODEFS.flagsToPermissionStringMap){return NODEFS.flagsToPermissionStringMap[flags]}else{throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}}),node_ops:{getattr:(function(node){var path=NODEFS.realPath(node);var stat;try{stat=fs.lstatSync(path)}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}if(NODEFS.isWindows&&!stat.blksize){stat.blksize=4096}if(NODEFS.isWindows&&!stat.blocks){stat.blocks=(stat.size+stat.blksize-1)/stat.blksize|0}return{dev:stat.dev,ino:stat.ino,mode:stat.mode,nlink:stat.nlink,uid:stat.uid,gid:stat.gid,rdev:stat.rdev,size:stat.size,atime:stat.atime,mtime:stat.mtime,ctime:stat.ctime,blksize:stat.blksize,blocks:stat.blocks}}),setattr:(function(node,attr){var path=NODEFS.realPath(node);try{if(attr.mode!==undefined){fs.chmodSync(path,attr.mode);node.mode=attr.mode}if(attr.timestamp!==undefined){var date=new Date(attr.timestamp);fs.utimesSync(path,date,date)}if(attr.size!==undefined){fs.truncateSync(path,attr.size)}}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}}),lookup:(function(parent,name){var path=PATH.join2(NODEFS.realPath(parent),name);var mode=NODEFS.getMode(path);return NODEFS.createNode(parent,name,mode)}),mknod:(function(parent,name,mode,dev){var node=NODEFS.createNode(parent,name,mode,dev);var path=NODEFS.realPath(node);try{if(FS.isDir(node.mode)){fs.mkdirSync(path,node.mode)}else{fs.writeFileSync(path,"",{mode:node.mode})}}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}return node}),rename:(function(oldNode,newDir,newName){var oldPath=NODEFS.realPath(oldNode);var newPath=PATH.join2(NODEFS.realPath(newDir),newName);try{fs.renameSync(oldPath,newPath)}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}}),unlink:(function(parent,name){var path=PATH.join2(NODEFS.realPath(parent),name);try{fs.unlinkSync(path)}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}}),rmdir:(function(parent,name){var path=PATH.join2(NODEFS.realPath(parent),name);try{fs.rmdirSync(path)}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}}),readdir:(function(node){var path=NODEFS.realPath(node);try{return fs.readdirSync(path)}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}}),symlink:(function(parent,newName,oldPath){var newPath=PATH.join2(NODEFS.realPath(parent),newName);try{fs.symlinkSync(oldPath,newPath)}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}}),readlink:(function(node){var path=NODEFS.realPath(node);try{path=fs.readlinkSync(path);path=NODEJS_PATH.relative(NODEJS_PATH.resolve(node.mount.opts.root),path);return path}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}})},stream_ops:{open:(function(stream){var path=NODEFS.realPath(stream.node);try{if(FS.isFile(stream.node.mode)){stream.nfd=fs.openSync(path,NODEFS.flagsToPermissionString(stream.flags))}}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}}),close:(function(stream){try{if(FS.isFile(stream.node.mode)&&stream.nfd){fs.closeSync(stream.nfd)}}catch(e){if(!e.code)throw e;throw new FS.ErrnoError(ERRNO_CODES[e.code])}}),read:(function(stream,buffer,offset,length,position){if(length===0)return 0;var nbuffer=new Buffer(length);var res;try{res=fs.readSync(stream.nfd,nbuffer,0,length,position)}catch(e){throw new FS.ErrnoError(ERRNO_CODES[e.code])}if(res>0){for(var i=0;i<res;i++){buffer[offset+i]=nbuffer[i]}}return res}),write:(function(stream,buffer,offset,length,position){var nbuffer=new Buffer(buffer.subarray(offset,offset+length));var res;try{res=fs.writeSync(stream.nfd,nbuffer,0,length,position)}catch(e){throw new FS.ErrnoError(ERRNO_CODES[e.code])}return res}),llseek:(function(stream,offset,whence){var position=offset;if(whence===1){position+=stream.position}else if(whence===2){if(FS.isFile(stream.node.mode)){try{var stat=fs.fstatSync(stream.nfd);position+=stat.size}catch(e){throw new FS.ErrnoError(ERRNO_CODES[e.code])}}}if(position<0){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}return position})}};var WORKERFS={DIR_MODE:16895,FILE_MODE:33279,reader:null,mount:(function(mount){assert(ENVIRONMENT_IS_WORKER);if(!WORKERFS.reader)WORKERFS.reader=new FileReaderSync;var root=WORKERFS.createNode(null,"/",WORKERFS.DIR_MODE,0);var createdParents={};function ensureParent(path){var parts=path.split("/");var parent=root;for(var i=0;i<parts.length-1;i++){var curr=parts.slice(0,i+1).join("/");if(!createdParents[curr]){createdParents[curr]=WORKERFS.createNode(parent,curr,WORKERFS.DIR_MODE,0)}parent=createdParents[curr]}return parent}function base(path){var parts=path.split("/");return parts[parts.length-1]}Array.prototype.forEach.call(mount.opts["files"]||[],(function(file){WORKERFS.createNode(ensureParent(file.name),base(file.name),WORKERFS.FILE_MODE,0,file,file.lastModifiedDate)}));(mount.opts["blobs"]||[]).forEach((function(obj){WORKERFS.createNode(ensureParent(obj["name"]),base(obj["name"]),WORKERFS.FILE_MODE,0,obj["data"])}));(mount.opts["packages"]||[]).forEach((function(pack){pack["metadata"].files.forEach((function(file){var name=file.filename.substr(1);WORKERFS.createNode(ensureParent(name),base(name),WORKERFS.FILE_MODE,0,pack["blob"].slice(file.start,file.end))}))}));return root}),createNode:(function(parent,name,mode,dev,contents,mtime){var node=FS.createNode(parent,name,mode);node.mode=mode;node.node_ops=WORKERFS.node_ops;node.stream_ops=WORKERFS.stream_ops;node.timestamp=(mtime||new Date).getTime();assert(WORKERFS.FILE_MODE!==WORKERFS.DIR_MODE);if(mode===WORKERFS.FILE_MODE){node.size=contents.size;node.contents=contents}else{node.size=4096;node.contents={}}if(parent){parent.contents[name]=node}return node}),node_ops:{getattr:(function(node){return{dev:1,ino:undefined,mode:node.mode,nlink:1,uid:0,gid:0,rdev:undefined,size:node.size,atime:new Date(node.timestamp),mtime:new Date(node.timestamp),ctime:new Date(node.timestamp),blksize:4096,blocks:Math.ceil(node.size/4096)}}),setattr:(function(node,attr){if(attr.mode!==undefined){node.mode=attr.mode}if(attr.timestamp!==undefined){node.timestamp=attr.timestamp}}),lookup:(function(parent,name){throw new FS.ErrnoError(ERRNO_CODES.ENOENT)}),mknod:(function(parent,name,mode,dev){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}),rename:(function(oldNode,newDir,newName){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}),unlink:(function(parent,name){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}),rmdir:(function(parent,name){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}),readdir:(function(node){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}),symlink:(function(parent,newName,oldPath){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}),readlink:(function(node){throw new FS.ErrnoError(ERRNO_CODES.EPERM)})},stream_ops:{read:(function(stream,buffer,offset,length,position){if(position>=stream.node.size)return 0;var chunk=stream.node.contents.slice(position,position+length);var ab=WORKERFS.reader.readAsArrayBuffer(chunk);buffer.set(new Uint8Array(ab),offset);return chunk.size}),write:(function(stream,buffer,offset,length,position){throw new FS.ErrnoError(ERRNO_CODES.EIO)}),llseek:(function(stream,offset,whence){var position=offset;if(whence===1){position+=stream.position}else if(whence===2){if(FS.isFile(stream.node.mode)){position+=stream.node.size}}if(position<0){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}return position})}};var _stdin=allocate(1,"i32*",ALLOC_STATIC);var _stdout=allocate(1,"i32*",ALLOC_STATIC);var _stderr=allocate(1,"i32*",ALLOC_STATIC);var FS={root:null,mounts:[],devices:[null],streams:[],nextInode:1,nameTable:null,currentPath:"/",initialized:false,ignorePermissions:true,trackingDelegate:{},tracking:{openFlags:{READ:1,WRITE:2}},ErrnoError:null,genericErrors:{},filesystems:null,handleFSError:(function(e){if(!(e instanceof FS.ErrnoError))throw e+" : "+stackTrace();return ___setErrNo(e.errno)}),lookupPath:(function(path,opts){path=PATH.resolve(FS.cwd(),path);opts=opts||{};if(!path)return{path:"",node:null};var defaults={follow_mount:true,recurse_count:0};for(var key in defaults){if(opts[key]===undefined){opts[key]=defaults[key]}}if(opts.recurse_count>8){throw new FS.ErrnoError(ERRNO_CODES.ELOOP)}var parts=PATH.normalizeArray(path.split("/").filter((function(p){return!!p})),false);var current=FS.root;var current_path="/";for(var i=0;i<parts.length;i++){var islast=i===parts.length-1;if(islast&&opts.parent){break}current=FS.lookupNode(current,parts[i]);current_path=PATH.join2(current_path,parts[i]);if(FS.isMountpoint(current)){if(!islast||islast&&opts.follow_mount){current=current.mounted.root}}if(!islast||opts.follow){var count=0;while(FS.isLink(current.mode)){var link=FS.readlink(current_path);current_path=PATH.resolve(PATH.dirname(current_path),link);var lookup=FS.lookupPath(current_path,{recurse_count:opts.recurse_count});current=lookup.node;if(count++>40){throw new FS.ErrnoError(ERRNO_CODES.ELOOP)}}}}return{path:current_path,node:current}}),getPath:(function(node){var path;while(true){if(FS.isRoot(node)){var mount=node.mount.mountpoint;if(!path)return mount;return mount[mount.length-1]!=="/"?mount+"/"+path:mount+path}path=path?node.name+"/"+path:node.name;node=node.parent}}),hashName:(function(parentid,name){var hash=0;for(var i=0;i<name.length;i++){hash=(hash<<5)-hash+name.charCodeAt(i)|0}return(parentid+hash>>>0)%FS.nameTable.length}),hashAddNode:(function(node){var hash=FS.hashName(node.parent.id,node.name);node.name_next=FS.nameTable[hash];FS.nameTable[hash]=node}),hashRemoveNode:(function(node){var hash=FS.hashName(node.parent.id,node.name);if(FS.nameTable[hash]===node){FS.nameTable[hash]=node.name_next}else{var current=FS.nameTable[hash];while(current){if(current.name_next===node){current.name_next=node.name_next;break}current=current.name_next}}}),lookupNode:(function(parent,name){var err=FS.mayLookup(parent);if(err){throw new FS.ErrnoError(err,parent)}var hash=FS.hashName(parent.id,name);for(var node=FS.nameTable[hash];node;node=node.name_next){var nodeName=node.name;if(node.parent.id===parent.id&&nodeName===name){return node}}return FS.lookup(parent,name)}),createNode:(function(parent,name,mode,rdev){if(!FS.FSNode){FS.FSNode=(function(parent,name,mode,rdev){if(!parent){parent=this}this.parent=parent;this.mount=parent.mount;this.mounted=null;this.id=FS.nextInode++;this.name=name;this.mode=mode;this.node_ops={};this.stream_ops={};this.rdev=rdev});FS.FSNode.prototype={};var readMode=292|73;var writeMode=146;Object.defineProperties(FS.FSNode.prototype,{read:{get:(function(){return(this.mode&readMode)===readMode}),set:(function(val){val?this.mode|=readMode:this.mode&=~readMode})},write:{get:(function(){return(this.mode&writeMode)===writeMode}),set:(function(val){val?this.mode|=writeMode:this.mode&=~writeMode})},isFolder:{get:(function(){return FS.isDir(this.mode)})},isDevice:{get:(function(){return FS.isChrdev(this.mode)})}})}var node=new FS.FSNode(parent,name,mode,rdev);FS.hashAddNode(node);return node}),destroyNode:(function(node){FS.hashRemoveNode(node)}),isRoot:(function(node){return node===node.parent}),isMountpoint:(function(node){return!!node.mounted}),isFile:(function(mode){return(mode&61440)===32768}),isDir:(function(mode){return(mode&61440)===16384}),isLink:(function(mode){return(mode&61440)===40960}),isChrdev:(function(mode){return(mode&61440)===8192}),isBlkdev:(function(mode){return(mode&61440)===24576}),isFIFO:(function(mode){return(mode&61440)===4096}),isSocket:(function(mode){return(mode&49152)===49152}),flagModes:{"r":0,"rs":1052672,"r+":2,"w":577,"wx":705,"xw":705,"w+":578,"wx+":706,"xw+":706,"a":1089,"ax":1217,"xa":1217,"a+":1090,"ax+":1218,"xa+":1218},modeStringToFlags:(function(str){var flags=FS.flagModes[str];if(typeof flags==="undefined"){throw new Error("Unknown file open mode: "+str)}return flags}),flagsToPermissionString:(function(flag){var perms=["r","w","rw"][flag&3];if(flag&512){perms+="w"}return perms}),nodePermissions:(function(node,perms){if(FS.ignorePermissions){return 0}if(perms.indexOf("r")!==-1&&!(node.mode&292)){return ERRNO_CODES.EACCES}else if(perms.indexOf("w")!==-1&&!(node.mode&146)){return ERRNO_CODES.EACCES}else if(perms.indexOf("x")!==-1&&!(node.mode&73)){return ERRNO_CODES.EACCES}return 0}),mayLookup:(function(dir){var err=FS.nodePermissions(dir,"x");if(err)return err;if(!dir.node_ops.lookup)return ERRNO_CODES.EACCES;return 0}),mayCreate:(function(dir,name){try{var node=FS.lookupNode(dir,name);return ERRNO_CODES.EEXIST}catch(e){}return FS.nodePermissions(dir,"wx")}),mayDelete:(function(dir,name,isdir){var node;try{node=FS.lookupNode(dir,name)}catch(e){return e.errno}var err=FS.nodePermissions(dir,"wx");if(err){return err}if(isdir){if(!FS.isDir(node.mode)){return ERRNO_CODES.ENOTDIR}if(FS.isRoot(node)||FS.getPath(node)===FS.cwd()){return ERRNO_CODES.EBUSY}}else{if(FS.isDir(node.mode)){return ERRNO_CODES.EISDIR}}return 0}),mayOpen:(function(node,flags){if(!node){return ERRNO_CODES.ENOENT}if(FS.isLink(node.mode)){return ERRNO_CODES.ELOOP}else if(FS.isDir(node.mode)){if((flags&2097155)!==0||flags&512){return ERRNO_CODES.EISDIR}}return FS.nodePermissions(node,FS.flagsToPermissionString(flags))}),MAX_OPEN_FDS:4096,nextfd:(function(fd_start,fd_end){fd_start=fd_start||0;fd_end=fd_end||FS.MAX_OPEN_FDS;for(var fd=fd_start;fd<=fd_end;fd++){if(!FS.streams[fd]){return fd}}throw new FS.ErrnoError(ERRNO_CODES.EMFILE)}),getStream:(function(fd){return FS.streams[fd]}),createStream:(function(stream,fd_start,fd_end){if(!FS.FSStream){FS.FSStream=(function(){});FS.FSStream.prototype={};Object.defineProperties(FS.FSStream.prototype,{object:{get:(function(){return this.node}),set:(function(val){this.node=val})},isRead:{get:(function(){return(this.flags&2097155)!==1})},isWrite:{get:(function(){return(this.flags&2097155)!==0})},isAppend:{get:(function(){return this.flags&1024})}})}var newStream=new FS.FSStream;for(var p in stream){newStream[p]=stream[p]}stream=newStream;var fd=FS.nextfd(fd_start,fd_end);stream.fd=fd;FS.streams[fd]=stream;return stream}),closeStream:(function(fd){FS.streams[fd]=null}),chrdev_stream_ops:{open:(function(stream){var device=FS.getDevice(stream.node.rdev);stream.stream_ops=device.stream_ops;if(stream.stream_ops.open){stream.stream_ops.open(stream)}}),llseek:(function(){throw new FS.ErrnoError(ERRNO_CODES.ESPIPE)})},major:(function(dev){return dev>>8}),minor:(function(dev){return dev&255}),makedev:(function(ma,mi){return ma<<8|mi}),registerDevice:(function(dev,ops){FS.devices[dev]={stream_ops:ops}}),getDevice:(function(dev){return FS.devices[dev]}),getMounts:(function(mount){var mounts=[];var check=[mount];while(check.length){var m=check.pop();mounts.push(m);check.push.apply(check,m.mounts)}return mounts}),syncfs:(function(populate,callback){if(typeof populate==="function"){callback=populate;populate=false}var mounts=FS.getMounts(FS.root.mount);var completed=0;function done(err){if(err){if(!done.errored){done.errored=true;return callback(err)}return}if(++completed>=mounts.length){callback(null)}}mounts.forEach((function(mount){if(!mount.type.syncfs){return done(null)}mount.type.syncfs(mount,populate,done)}))}),mount:(function(type,opts,mountpoint){var root=mountpoint==="/";var pseudo=!mountpoint;var node;if(root&&FS.root){throw new FS.ErrnoError(ERRNO_CODES.EBUSY)}else if(!root&&!pseudo){var lookup=FS.lookupPath(mountpoint,{follow_mount:false});mountpoint=lookup.path;node=lookup.node;if(FS.isMountpoint(node)){throw new FS.ErrnoError(ERRNO_CODES.EBUSY)}if(!FS.isDir(node.mode)){throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR)}}var mount={type:type,opts:opts,mountpoint:mountpoint,mounts:[]};var mountRoot=type.mount(mount);mountRoot.mount=mount;mount.root=mountRoot;if(root){FS.root=mountRoot}else if(node){node.mounted=mount;if(node.mount){node.mount.mounts.push(mount)}}return mountRoot}),unmount:(function(mountpoint){var lookup=FS.lookupPath(mountpoint,{follow_mount:false});if(!FS.isMountpoint(lookup.node)){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}var node=lookup.node;var mount=node.mounted;var mounts=FS.getMounts(mount);Object.keys(FS.nameTable).forEach((function(hash){var current=FS.nameTable[hash];while(current){var next=current.name_next;if(mounts.indexOf(current.mount)!==-1){FS.destroyNode(current)}current=next}}));node.mounted=null;var idx=node.mount.mounts.indexOf(mount);assert(idx!==-1);node.mount.mounts.splice(idx,1)}),lookup:(function(parent,name){return parent.node_ops.lookup(parent,name)}),mknod:(function(path,mode,dev){var lookup=FS.lookupPath(path,{parent:true});var parent=lookup.node;var name=PATH.basename(path);if(!name||name==="."||name===".."){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}var err=FS.mayCreate(parent,name);if(err){throw new FS.ErrnoError(err)}if(!parent.node_ops.mknod){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}return parent.node_ops.mknod(parent,name,mode,dev)}),create:(function(path,mode){mode=mode!==undefined?mode:438;mode&=4095;mode|=32768;return FS.mknod(path,mode,0)}),mkdir:(function(path,mode){mode=mode!==undefined?mode:511;mode&=511|512;mode|=16384;return FS.mknod(path,mode,0)}),mkdev:(function(path,mode,dev){if(typeof dev==="undefined"){dev=mode;mode=438}mode|=8192;return FS.mknod(path,mode,dev)}),symlink:(function(oldpath,newpath){if(!PATH.resolve(oldpath)){throw new FS.ErrnoError(ERRNO_CODES.ENOENT)}var lookup=FS.lookupPath(newpath,{parent:true});var parent=lookup.node;if(!parent){throw new FS.ErrnoError(ERRNO_CODES.ENOENT)}var newname=PATH.basename(newpath);var err=FS.mayCreate(parent,newname);if(err){throw new FS.ErrnoError(err)}if(!parent.node_ops.symlink){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}return parent.node_ops.symlink(parent,newname,oldpath)}),rename:(function(old_path,new_path){var old_dirname=PATH.dirname(old_path);var new_dirname=PATH.dirname(new_path);var old_name=PATH.basename(old_path);var new_name=PATH.basename(new_path);var lookup,old_dir,new_dir;try{lookup=FS.lookupPath(old_path,{parent:true});old_dir=lookup.node;lookup=FS.lookupPath(new_path,{parent:true});new_dir=lookup.node}catch(e){throw new FS.ErrnoError(ERRNO_CODES.EBUSY)}if(!old_dir||!new_dir)throw new FS.ErrnoError(ERRNO_CODES.ENOENT);if(old_dir.mount!==new_dir.mount){throw new FS.ErrnoError(ERRNO_CODES.EXDEV)}var old_node=FS.lookupNode(old_dir,old_name);var relative=PATH.relative(old_path,new_dirname);if(relative.charAt(0)!=="."){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}relative=PATH.relative(new_path,old_dirname);if(relative.charAt(0)!=="."){throw new FS.ErrnoError(ERRNO_CODES.ENOTEMPTY)}var new_node;try{new_node=FS.lookupNode(new_dir,new_name)}catch(e){}if(old_node===new_node){return}var isdir=FS.isDir(old_node.mode);var err=FS.mayDelete(old_dir,old_name,isdir);if(err){throw new FS.ErrnoError(err)}err=new_node?FS.mayDelete(new_dir,new_name,isdir):FS.mayCreate(new_dir,new_name);if(err){throw new FS.ErrnoError(err)}if(!old_dir.node_ops.rename){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}if(FS.isMountpoint(old_node)||new_node&&FS.isMountpoint(new_node)){throw new FS.ErrnoError(ERRNO_CODES.EBUSY)}if(new_dir!==old_dir){err=FS.nodePermissions(old_dir,"w");if(err){throw new FS.ErrnoError(err)}}try{if(FS.trackingDelegate["willMovePath"]){FS.trackingDelegate["willMovePath"](old_path,new_path)}}catch(e){console.log("FS.trackingDelegate['willMovePath']('"+old_path+"', '"+new_path+"') threw an exception: "+e.message)}FS.hashRemoveNode(old_node);try{old_dir.node_ops.rename(old_node,new_dir,new_name)}catch(e){throw e}finally{FS.hashAddNode(old_node)}try{if(FS.trackingDelegate["onMovePath"])FS.trackingDelegate["onMovePath"](old_path,new_path)}catch(e){console.log("FS.trackingDelegate['onMovePath']('"+old_path+"', '"+new_path+"') threw an exception: "+e.message)}}),rmdir:(function(path){var lookup=FS.lookupPath(path,{parent:true});var parent=lookup.node;var name=PATH.basename(path);var node=FS.lookupNode(parent,name);var err=FS.mayDelete(parent,name,true);if(err){throw new FS.ErrnoError(err)}if(!parent.node_ops.rmdir){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}if(FS.isMountpoint(node)){throw new FS.ErrnoError(ERRNO_CODES.EBUSY)}try{if(FS.trackingDelegate["willDeletePath"]){FS.trackingDelegate["willDeletePath"](path)}}catch(e){console.log("FS.trackingDelegate['willDeletePath']('"+path+"') threw an exception: "+e.message)}parent.node_ops.rmdir(parent,name);FS.destroyNode(node);try{if(FS.trackingDelegate["onDeletePath"])FS.trackingDelegate["onDeletePath"](path)}catch(e){console.log("FS.trackingDelegate['onDeletePath']('"+path+"') threw an exception: "+e.message)}}),readdir:(function(path){var lookup=FS.lookupPath(path,{follow:true});var node=lookup.node;if(!node.node_ops.readdir){throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR)}return node.node_ops.readdir(node)}),unlink:(function(path){var lookup=FS.lookupPath(path,{parent:true});var parent=lookup.node;var name=PATH.basename(path);var node=FS.lookupNode(parent,name);var err=FS.mayDelete(parent,name,false);if(err){if(err===ERRNO_CODES.EISDIR)err=ERRNO_CODES.EPERM;throw new FS.ErrnoError(err)}if(!parent.node_ops.unlink){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}if(FS.isMountpoint(node)){throw new FS.ErrnoError(ERRNO_CODES.EBUSY)}try{if(FS.trackingDelegate["willDeletePath"]){FS.trackingDelegate["willDeletePath"](path)}}catch(e){console.log("FS.trackingDelegate['willDeletePath']('"+path+"') threw an exception: "+e.message)}parent.node_ops.unlink(parent,name);FS.destroyNode(node);try{if(FS.trackingDelegate["onDeletePath"])FS.trackingDelegate["onDeletePath"](path)}catch(e){console.log("FS.trackingDelegate['onDeletePath']('"+path+"') threw an exception: "+e.message)}}),readlink:(function(path){var lookup=FS.lookupPath(path);var link=lookup.node;if(!link){throw new FS.ErrnoError(ERRNO_CODES.ENOENT)}if(!link.node_ops.readlink){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}return PATH.resolve(FS.getPath(link.parent),link.node_ops.readlink(link))}),stat:(function(path,dontFollow){var lookup=FS.lookupPath(path,{follow:!dontFollow});var node=lookup.node;if(!node){throw new FS.ErrnoError(ERRNO_CODES.ENOENT)}if(!node.node_ops.getattr){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}return node.node_ops.getattr(node)}),lstat:(function(path){return FS.stat(path,true)}),chmod:(function(path,mode,dontFollow){var node;if(typeof path==="string"){var lookup=FS.lookupPath(path,{follow:!dontFollow});node=lookup.node}else{node=path}if(!node.node_ops.setattr){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}node.node_ops.setattr(node,{mode:mode&4095|node.mode&~4095,timestamp:Date.now()})}),lchmod:(function(path,mode){FS.chmod(path,mode,true)}),fchmod:(function(fd,mode){var stream=FS.getStream(fd);if(!stream){throw new FS.ErrnoError(ERRNO_CODES.EBADF)}FS.chmod(stream.node,mode)}),chown:(function(path,uid,gid,dontFollow){var node;if(typeof path==="string"){var lookup=FS.lookupPath(path,{follow:!dontFollow});node=lookup.node}else{node=path}if(!node.node_ops.setattr){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}node.node_ops.setattr(node,{timestamp:Date.now()})}),lchown:(function(path,uid,gid){FS.chown(path,uid,gid,true)}),fchown:(function(fd,uid,gid){var stream=FS.getStream(fd);if(!stream){throw new FS.ErrnoError(ERRNO_CODES.EBADF)}FS.chown(stream.node,uid,gid)}),truncate:(function(path,len){if(len<0){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}var node;if(typeof path==="string"){var lookup=FS.lookupPath(path,{follow:true});node=lookup.node}else{node=path}if(!node.node_ops.setattr){throw new FS.ErrnoError(ERRNO_CODES.EPERM)}if(FS.isDir(node.mode)){throw new FS.ErrnoError(ERRNO_CODES.EISDIR)}if(!FS.isFile(node.mode)){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}var err=FS.nodePermissions(node,"w");if(err){throw new FS.ErrnoError(err)}node.node_ops.setattr(node,{size:len,timestamp:Date.now()})}),ftruncate:(function(fd,len){var stream=FS.getStream(fd);if(!stream){throw new FS.ErrnoError(ERRNO_CODES.EBADF)}if((stream.flags&2097155)===0){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}FS.truncate(stream.node,len)}),utime:(function(path,atime,mtime){var lookup=FS.lookupPath(path,{follow:true});var node=lookup.node;node.node_ops.setattr(node,{timestamp:Math.max(atime,mtime)})}),open:(function(path,flags,mode,fd_start,fd_end){if(path===""){throw new FS.ErrnoError(ERRNO_CODES.ENOENT)}flags=typeof flags==="string"?FS.modeStringToFlags(flags):flags;mode=typeof mode==="undefined"?438:mode;if(flags&64){mode=mode&4095|32768}else{mode=0}var node;if(typeof path==="object"){node=path}else{path=PATH.normalize(path);try{var lookup=FS.lookupPath(path,{follow:!(flags&131072)});node=lookup.node}catch(e){}}var created=false;if(flags&64){if(node){if(flags&128){throw new FS.ErrnoError(ERRNO_CODES.EEXIST)}}else{node=FS.mknod(path,mode,0);created=true}}if(!node){throw new FS.ErrnoError(ERRNO_CODES.ENOENT)}if(FS.isChrdev(node.mode)){flags&=~512}if(flags&65536&&!FS.isDir(node.mode)){throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR)}if(!created){var err=FS.mayOpen(node,flags);if(err){throw new FS.ErrnoError(err)}}if(flags&512){FS.truncate(node,0)}flags&=~(128|512);var stream=FS.createStream({node:node,path:FS.getPath(node),flags:flags,seekable:true,position:0,stream_ops:node.stream_ops,ungotten:[],error:false},fd_start,fd_end);if(stream.stream_ops.open){stream.stream_ops.open(stream)}if(Module["logReadFiles"]&&!(flags&1)){if(!FS.readFiles)FS.readFiles={};if(!(path in FS.readFiles)){FS.readFiles[path]=1;Module["printErr"]("read file: "+path)}}try{if(FS.trackingDelegate["onOpenFile"]){var trackingFlags=0;if((flags&2097155)!==1){trackingFlags|=FS.tracking.openFlags.READ}if((flags&2097155)!==0){trackingFlags|=FS.tracking.openFlags.WRITE}FS.trackingDelegate["onOpenFile"](path,trackingFlags)}}catch(e){console.log("FS.trackingDelegate['onOpenFile']('"+path+"', flags) threw an exception: "+e.message)}return stream}),close:(function(stream){if(stream.getdents)stream.getdents=null;try{if(stream.stream_ops.close){stream.stream_ops.close(stream)}}catch(e){throw e}finally{FS.closeStream(stream.fd)}}),llseek:(function(stream,offset,whence){if(!stream.seekable||!stream.stream_ops.llseek){throw new FS.ErrnoError(ERRNO_CODES.ESPIPE)}stream.position=stream.stream_ops.llseek(stream,offset,whence);stream.ungotten=[];return stream.position}),read:(function(stream,buffer,offset,length,position){if(length<0||position<0){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}if((stream.flags&2097155)===1){throw new FS.ErrnoError(ERRNO_CODES.EBADF)}if(FS.isDir(stream.node.mode)){throw new FS.ErrnoError(ERRNO_CODES.EISDIR)}if(!stream.stream_ops.read){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}var seeking=true;if(typeof position==="undefined"){position=stream.position;seeking=false}else if(!stream.seekable){throw new FS.ErrnoError(ERRNO_CODES.ESPIPE)}var bytesRead=stream.stream_ops.read(stream,buffer,offset,length,position);if(!seeking)stream.position+=bytesRead;return bytesRead}),write:(function(stream,buffer,offset,length,position,canOwn){if(length<0||position<0){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}if((stream.flags&2097155)===0){throw new FS.ErrnoError(ERRNO_CODES.EBADF)}if(FS.isDir(stream.node.mode)){throw new FS.ErrnoError(ERRNO_CODES.EISDIR)}if(!stream.stream_ops.write){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}if(stream.flags&1024){FS.llseek(stream,0,2)}var seeking=true;if(typeof position==="undefined"){position=stream.position;seeking=false}else if(!stream.seekable){throw new FS.ErrnoError(ERRNO_CODES.ESPIPE)}var bytesWritten=stream.stream_ops.write(stream,buffer,offset,length,position,canOwn);if(!seeking)stream.position+=bytesWritten;try{if(stream.path&&FS.trackingDelegate["onWriteToFile"])FS.trackingDelegate["onWriteToFile"](stream.path)}catch(e){console.log("FS.trackingDelegate['onWriteToFile']('"+path+"') threw an exception: "+e.message)}return bytesWritten}),allocate:(function(stream,offset,length){if(offset<0||length<=0){throw new FS.ErrnoError(ERRNO_CODES.EINVAL)}if((stream.flags&2097155)===0){throw new FS.ErrnoError(ERRNO_CODES.EBADF)}if(!FS.isFile(stream.node.mode)&&!FS.isDir(node.mode)){throw new FS.ErrnoError(ERRNO_CODES.ENODEV)}if(!stream.stream_ops.allocate){throw new FS.ErrnoError(ERRNO_CODES.EOPNOTSUPP)}stream.stream_ops.allocate(stream,offset,length)}),mmap:(function(stream,buffer,offset,length,position,prot,flags){if((stream.flags&2097155)===1){throw new FS.ErrnoError(ERRNO_CODES.EACCES)}if(!stream.stream_ops.mmap){throw new FS.ErrnoError(ERRNO_CODES.ENODEV)}return stream.stream_ops.mmap(stream,buffer,offset,length,position,prot,flags)}),msync:(function(stream,buffer,offset,length,mmapFlags){if(!stream||!stream.stream_ops.msync){return 0}return stream.stream_ops.msync(stream,buffer,offset,length,mmapFlags)}),munmap:(function(stream){return 0}),ioctl:(function(stream,cmd,arg){if(!stream.stream_ops.ioctl){throw new FS.ErrnoError(ERRNO_CODES.ENOTTY)}return stream.stream_ops.ioctl(stream,cmd,arg)}),readFile:(function(path,opts){opts=opts||{};opts.flags=opts.flags||"r";opts.encoding=opts.encoding||"binary";if(opts.encoding!=="utf8"&&opts.encoding!=="binary"){throw new Error('Invalid encoding type "'+opts.encoding+'"')}var ret;var stream=FS.open(path,opts.flags);var stat=FS.stat(path);var length=stat.size;var buf=new Uint8Array(length);FS.read(stream,buf,0,length,0);if(opts.encoding==="utf8"){ret=UTF8ArrayToString(buf,0)}else if(opts.encoding==="binary"){ret=buf}FS.close(stream);return ret}),writeFile:(function(path,data,opts){opts=opts||{};opts.flags=opts.flags||"w";opts.encoding=opts.encoding||"utf8";if(opts.encoding!=="utf8"&&opts.encoding!=="binary"){throw new Error('Invalid encoding type "'+opts.encoding+'"')}var stream=FS.open(path,opts.flags,opts.mode);if(opts.encoding==="utf8"){var buf=new Uint8Array(lengthBytesUTF8(data)+1);var actualNumBytes=stringToUTF8Array(data,buf,0,buf.length);FS.write(stream,buf,0,actualNumBytes,0,opts.canOwn)}else if(opts.encoding==="binary"){FS.write(stream,data,0,data.length,0,opts.canOwn)}FS.close(stream)}),cwd:(function(){return FS.currentPath}),chdir:(function(path){var lookup=FS.lookupPath(path,{follow:true});if(!FS.isDir(lookup.node.mode)){throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR)}var err=FS.nodePermissions(lookup.node,"x");if(err){throw new FS.ErrnoError(err)}FS.currentPath=lookup.path}),createDefaultDirectories:(function(){FS.mkdir("/tmp");FS.mkdir("/home");FS.mkdir("/home/web_user")}),createDefaultDevices:(function(){FS.mkdir("/dev");FS.registerDevice(FS.makedev(1,3),{read:(function(){return 0}),write:(function(stream,buffer,offset,length,pos){return length})});FS.mkdev("/dev/null",FS.makedev(1,3));TTY.register(FS.makedev(5,0),TTY.default_tty_ops);TTY.register(FS.makedev(6,0),TTY.default_tty1_ops);FS.mkdev("/dev/tty",FS.makedev(5,0));FS.mkdev("/dev/tty1",FS.makedev(6,0));var random_device;if(typeof crypto!=="undefined"){var randomBuffer=new Uint8Array(1);random_device=(function(){crypto.getRandomValues(randomBuffer);return randomBuffer[0]})}else if(ENVIRONMENT_IS_NODE){random_device=(function(){return require("crypto").randomBytes(1)[0]})}else{random_device=(function(){return Math.random()*256|0})}FS.createDevice("/dev","random",random_device);FS.createDevice("/dev","urandom",random_device);FS.mkdir("/dev/shm");FS.mkdir("/dev/shm/tmp")}),createSpecialDirectories:(function(){FS.mkdir("/proc");FS.mkdir("/proc/self");FS.mkdir("/proc/self/fd");FS.mount({mount:(function(){var node=FS.createNode("/proc/self","fd",16384|511,73);node.node_ops={lookup:(function(parent,name){var fd=+name;var stream=FS.getStream(fd);if(!stream)throw new FS.ErrnoError(ERRNO_CODES.EBADF);var ret={parent:null,mount:{mountpoint:"fake"},node_ops:{readlink:(function(){return stream.path})}};ret.parent=ret;return ret})};return node})},{},"/proc/self/fd")}),createStandardStreams:(function(){if(Module["stdin"]){FS.createDevice("/dev","stdin",Module["stdin"])}else{FS.symlink("/dev/tty","/dev/stdin")}if(Module["stdout"]){FS.createDevice("/dev","stdout",null,Module["stdout"])}else{FS.symlink("/dev/tty","/dev/stdout")}if(Module["stderr"]){FS.createDevice("/dev","stderr",null,Module["stderr"])}else{FS.symlink("/dev/tty1","/dev/stderr")}var stdin=FS.open("/dev/stdin","r");assert(stdin.fd===0,"invalid handle for stdin ("+stdin.fd+")");var stdout=FS.open("/dev/stdout","w");assert(stdout.fd===1,"invalid handle for stdout ("+stdout.fd+")");var stderr=FS.open("/dev/stderr","w");assert(stderr.fd===2,"invalid handle for stderr ("+stderr.fd+")")}),ensureErrnoError:(function(){if(FS.ErrnoError)return;FS.ErrnoError=function ErrnoError(errno,node){this.node=node;this.setErrno=(function(errno){this.errno=errno;for(var key in ERRNO_CODES){if(ERRNO_CODES[key]===errno){this.code=key;break}}});this.setErrno(errno);this.message=ERRNO_MESSAGES[errno]};FS.ErrnoError.prototype=new Error;FS.ErrnoError.prototype.constructor=FS.ErrnoError;[ERRNO_CODES.ENOENT].forEach((function(code){FS.genericErrors[code]=new FS.ErrnoError(code);FS.genericErrors[code].stack="<generic error, no stack>"}))}),staticInit:(function(){FS.ensureErrnoError();FS.nameTable=new Array(4096);FS.mount(MEMFS,{},"/");FS.createDefaultDirectories();FS.createDefaultDevices();FS.createSpecialDirectories();FS.filesystems={"MEMFS":MEMFS,"IDBFS":IDBFS,"NODEFS":NODEFS,"WORKERFS":WORKERFS}}),init:(function(input,output,error){assert(!FS.init.initialized,"FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)");FS.init.initialized=true;FS.ensureErrnoError();Module["stdin"]=input||Module["stdin"];Module["stdout"]=output||Module["stdout"];Module["stderr"]=error||Module["stderr"];FS.createStandardStreams()}),quit:(function(){FS.init.initialized=false;var fflush=Module["_fflush"];if(fflush)fflush(0);for(var i=0;i<FS.streams.length;i++){var stream=FS.streams[i];if(!stream){continue}FS.close(stream)}}),getMode:(function(canRead,canWrite){var mode=0;if(canRead)mode|=292|73;if(canWrite)mode|=146;return mode}),joinPath:(function(parts,forceRelative){var path=PATH.join.apply(null,parts);if(forceRelative&&path[0]=="/")path=path.substr(1);return path}),absolutePath:(function(relative,base){return PATH.resolve(base,relative)}),standardizePath:(function(path){return PATH.normalize(path)}),findObject:(function(path,dontResolveLastLink){var ret=FS.analyzePath(path,dontResolveLastLink);if(ret.exists){return ret.object}else{___setErrNo(ret.error);return null}}),analyzePath:(function(path,dontResolveLastLink){try{var lookup=FS.lookupPath(path,{follow:!dontResolveLastLink});path=lookup.path}catch(e){}var ret={isRoot:false,exists:false,error:0,name:null,path:null,object:null,parentExists:false,parentPath:null,parentObject:null};try{var lookup=FS.lookupPath(path,{parent:true});ret.parentExists=true;ret.parentPath=lookup.path;ret.parentObject=lookup.node;ret.name=PATH.basename(path);lookup=FS.lookupPath(path,{follow:!dontResolveLastLink});ret.exists=true;ret.path=lookup.path;ret.object=lookup.node;ret.name=lookup.node.name;ret.isRoot=lookup.path==="/"}catch(e){ret.error=e.errno}return ret}),createFolder:(function(parent,name,canRead,canWrite){var path=PATH.join2(typeof parent==="string"?parent:FS.getPath(parent),name);var mode=FS.getMode(canRead,canWrite);return FS.mkdir(path,mode)}),createPath:(function(parent,path,canRead,canWrite){parent=typeof parent==="string"?parent:FS.getPath(parent);var parts=path.split("/").reverse();while(parts.length){var part=parts.pop();if(!part)continue;var current=PATH.join2(parent,part);try{FS.mkdir(current)}catch(e){}parent=current}return current}),createFile:(function(parent,name,properties,canRead,canWrite){var path=PATH.join2(typeof parent==="string"?parent:FS.getPath(parent),name);var mode=FS.getMode(canRead,canWrite);return FS.create(path,mode)}),createDataFile:(function(parent,name,data,canRead,canWrite,canOwn){var path=name?PATH.join2(typeof parent==="string"?parent:FS.getPath(parent),name):parent;var mode=FS.getMode(canRead,canWrite);var node=FS.create(path,mode);if(data){if(typeof data==="string"){var arr=new Array(data.length);for(var i=0,len=data.length;i<len;++i)arr[i]=data.charCodeAt(i);data=arr}FS.chmod(node,mode|146);var stream=FS.open(node,"w");FS.write(stream,data,0,data.length,0,canOwn);FS.close(stream);FS.chmod(node,mode)}return node}),createDevice:(function(parent,name,input,output){var path=PATH.join2(typeof parent==="string"?parent:FS.getPath(parent),name);var mode=FS.getMode(!!input,!!output);if(!FS.createDevice.major)FS.createDevice.major=64;var dev=FS.makedev(FS.createDevice.major++,0);FS.registerDevice(dev,{open:(function(stream){stream.seekable=false}),close:(function(stream){if(output&&output.buffer&&output.buffer.length){output(10)}}),read:(function(stream,buffer,offset,length,pos){var bytesRead=0;for(var i=0;i<length;i++){var result;try{result=input()}catch(e){throw new FS.ErrnoError(ERRNO_CODES.EIO)}if(result===undefined&&bytesRead===0){throw new FS.ErrnoError(ERRNO_CODES.EAGAIN)}if(result===null||result===undefined)break;bytesRead++;buffer[offset+i]=result}if(bytesRead){stream.node.timestamp=Date.now()}return bytesRead}),write:(function(stream,buffer,offset,length,pos){for(var i=0;i<length;i++){try{output(buffer[offset+i])}catch(e){throw new FS.ErrnoError(ERRNO_CODES.EIO)}}if(length){stream.node.timestamp=Date.now()}return i})});return FS.mkdev(path,mode,dev)}),createLink:(function(parent,name,target,canRead,canWrite){var path=PATH.join2(typeof parent==="string"?parent:FS.getPath(parent),name);return FS.symlink(target,path)}),forceLoadFile:(function(obj){if(obj.isDevice||obj.isFolder||obj.link||obj.contents)return true;var success=true;if(typeof XMLHttpRequest!=="undefined"){throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.")}else if(Module["read"]){try{obj.contents=intArrayFromString(Module["read"](obj.url),true);obj.usedBytes=obj.contents.length}catch(e){success=false}}else{throw new Error("Cannot load without read() or XMLHttpRequest.")}if(!success)___setErrNo(ERRNO_CODES.EIO);return success}),createLazyFile:(function(parent,name,url,canRead,canWrite){function LazyUint8Array(){this.lengthKnown=false;this.chunks=[]}LazyUint8Array.prototype.get=function LazyUint8Array_get(idx){if(idx>this.length-1||idx<0){return undefined}var chunkOffset=idx%this.chunkSize;var chunkNum=idx/this.chunkSize|0;return this.getter(chunkNum)[chunkOffset]};LazyUint8Array.prototype.setDataGetter=function LazyUint8Array_setDataGetter(getter){this.getter=getter};LazyUint8Array.prototype.cacheLength=function LazyUint8Array_cacheLength(){var xhr=new XMLHttpRequest;xhr.open("HEAD",url,false);xhr.send(null);if(!(xhr.status>=200&&xhr.status<300||xhr.status===304))throw new Error("Couldn't load "+url+". Status: "+xhr.status);var datalength=Number(xhr.getResponseHeader("Content-length"));var header;var hasByteServing=(header=xhr.getResponseHeader("Accept-Ranges"))&&header==="bytes";var chunkSize=1024*1024;if(!hasByteServing)chunkSize=datalength;var doXHR=(function(from,to){if(from>to)throw new Error("invalid range ("+from+", "+to+") or no bytes requested!");if(to>datalength-1)throw new Error("only "+datalength+" bytes available! programmer error!");var xhr=new XMLHttpRequest;xhr.open("GET",url,false);if(datalength!==chunkSize)xhr.setRequestHeader("Range","bytes="+from+"-"+to);if(typeof Uint8Array!="undefined")xhr.responseType="arraybuffer";if(xhr.overrideMimeType){xhr.overrideMimeType("text/plain; charset=x-user-defined")}xhr.send(null);if(!(xhr.status>=200&&xhr.status<300||xhr.status===304))throw new Error("Couldn't load "+url+". Status: "+xhr.status);if(xhr.response!==undefined){return new Uint8Array(xhr.response||[])}else{return intArrayFromString(xhr.responseText||"",true)}});var lazyArray=this;lazyArray.setDataGetter((function(chunkNum){var start=chunkNum*chunkSize;var end=(chunkNum+1)*chunkSize-1;end=Math.min(end,datalength-1);if(typeof lazyArray.chunks[chunkNum]==="undefined"){lazyArray.chunks[chunkNum]=doXHR(start,end)}if(typeof lazyArray.chunks[chunkNum]==="undefined")throw new Error("doXHR failed!");return lazyArray.chunks[chunkNum]}));this._length=datalength;this._chunkSize=chunkSize;this.lengthKnown=true};if(typeof XMLHttpRequest!=="undefined"){if(!ENVIRONMENT_IS_WORKER)throw"Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";var lazyArray=new LazyUint8Array;Object.defineProperty(lazyArray,"length",{get:(function(){if(!this.lengthKnown){this.cacheLength()}return this._length})});Object.defineProperty(lazyArray,"chunkSize",{get:(function(){if(!this.lengthKnown){this.cacheLength()}return this._chunkSize})});var properties={isDevice:false,contents:lazyArray}}else{var properties={isDevice:false,url:url}}var node=FS.createFile(parent,name,properties,canRead,canWrite);if(properties.contents){node.contents=properties.contents}else if(properties.url){node.contents=null;node.url=properties.url}Object.defineProperty(node,"usedBytes",{get:(function(){return this.contents.length})});var stream_ops={};var keys=Object.keys(node.stream_ops);keys.forEach((function(key){var fn=node.stream_ops[key];stream_ops[key]=function forceLoadLazyFile(){if(!FS.forceLoadFile(node)){throw new FS.ErrnoError(ERRNO_CODES.EIO)}return fn.apply(null,arguments)}}));stream_ops.read=function stream_ops_read(stream,buffer,offset,length,position){if(!FS.forceLoadFile(node)){throw new FS.ErrnoError(ERRNO_CODES.EIO)}var contents=stream.node.contents;if(position>=contents.length)return 0;var size=Math.min(contents.length-position,length);assert(size>=0);if(contents.slice){for(var i=0;i<size;i++){buffer[offset+i]=contents[position+i]}}else{for(var i=0;i<size;i++){buffer[offset+i]=contents.get(position+i)}}return size};node.stream_ops=stream_ops;return node}),createPreloadedFile:(function(parent,name,url,canRead,canWrite,onload,onerror,dontCreateFile,canOwn,preFinish){Browser.init();var fullname=name?PATH.resolve(PATH.join2(parent,name)):parent;var dep=getUniqueRunDependency("cp "+fullname);function processData(byteArray){function finish(byteArray){if(preFinish)preFinish();if(!dontCreateFile){FS.createDataFile(parent,name,byteArray,canRead,canWrite,canOwn)}if(onload)onload();removeRunDependency(dep)}var handled=false;Module["preloadPlugins"].forEach((function(plugin){if(handled)return;if(plugin["canHandle"](fullname)){plugin["handle"](byteArray,fullname,finish,(function(){if(onerror)onerror();removeRunDependency(dep)}));handled=true}}));if(!handled)finish(byteArray)}addRunDependency(dep);if(typeof url=="string"){Browser.asyncLoad(url,(function(byteArray){processData(byteArray)}),onerror)}else{processData(url)}}),indexedDB:(function(){return window.indexedDB||window.mozIndexedDB||window.webkitIndexedDB||window.msIndexedDB}),DB_NAME:(function(){return"EM_FS_"+window.location.pathname}),DB_VERSION:20,DB_STORE_NAME:"FILE_DATA",saveFilesToDB:(function(paths,onload,onerror){onload=onload||(function(){});onerror=onerror||(function(){});var indexedDB=FS.indexedDB();try{var openRequest=indexedDB.open(FS.DB_NAME(),FS.DB_VERSION)}catch(e){return onerror(e)}openRequest.onupgradeneeded=function openRequest_onupgradeneeded(){console.log("creating db");var db=openRequest.result;db.createObjectStore(FS.DB_STORE_NAME)};openRequest.onsuccess=function openRequest_onsuccess(){var db=openRequest.result;var transaction=db.transaction([FS.DB_STORE_NAME],"readwrite");var files=transaction.objectStore(FS.DB_STORE_NAME);var ok=0,fail=0,total=paths.length;function finish(){if(fail==0)onload();else onerror()}paths.forEach((function(path){var putRequest=files.put(FS.analyzePath(path).object.contents,path);putRequest.onsuccess=function putRequest_onsuccess(){ok++;if(ok+fail==total)finish()};putRequest.onerror=function putRequest_onerror(){fail++;if(ok+fail==total)finish()}}));transaction.onerror=onerror};openRequest.onerror=onerror}),loadFilesFromDB:(function(paths,onload,onerror){onload=onload||(function(){});onerror=onerror||(function(){});var indexedDB=FS.indexedDB();try{var openRequest=indexedDB.open(FS.DB_NAME(),FS.DB_VERSION)}catch(e){return onerror(e)}openRequest.onupgradeneeded=onerror;openRequest.onsuccess=function openRequest_onsuccess(){var db=openRequest.result;try{var transaction=db.transaction([FS.DB_STORE_NAME],"readonly")}catch(e){onerror(e);return}var files=transaction.objectStore(FS.DB_STORE_NAME);var ok=0,fail=0,total=paths.length;function finish(){if(fail==0)onload();else onerror()}paths.forEach((function(path){var getRequest=files.get(path);getRequest.onsuccess=function getRequest_onsuccess(){if(FS.analyzePath(path).exists){FS.unlink(path)}FS.createDataFile(PATH.dirname(path),PATH.basename(path),getRequest.result,true,true,true);ok++;if(ok+fail==total)finish()};getRequest.onerror=function getRequest_onerror(){fail++;if(ok+fail==total)finish()}}));transaction.onerror=onerror};openRequest.onerror=onerror})};var SYSCALLS={DEFAULT_POLLMASK:5,mappings:{},umask:511,calculateAt:(function(dirfd,path){if(path[0]!=="/"){var dir;if(dirfd===-100){dir=FS.cwd()}else{var dirstream=FS.getStream(dirfd);if(!dirstream)throw new FS.ErrnoError(ERRNO_CODES.EBADF);dir=dirstream.path}path=PATH.join2(dir,path)}return path}),doStat:(function(func,path,buf){try{var stat=func(path)}catch(e){if(e&&e.node&&PATH.normalize(path)!==PATH.normalize(FS.getPath(e.node))){return-ERRNO_CODES.ENOTDIR}throw e}HEAP32[buf>>2]=stat.dev;HEAP32[buf+4>>2]=0;HEAP32[buf+8>>2]=stat.ino;HEAP32[buf+12>>2]=stat.mode;HEAP32[buf+16>>2]=stat.nlink;HEAP32[buf+20>>2]=stat.uid;HEAP32[buf+24>>2]=stat.gid;HEAP32[buf+28>>2]=stat.rdev;HEAP32[buf+32>>2]=0;HEAP32[buf+36>>2]=stat.size;HEAP32[buf+40>>2]=4096;HEAP32[buf+44>>2]=stat.blocks;HEAP32[buf+48>>2]=stat.atime.getTime()/1e3|0;HEAP32[buf+52>>2]=0;HEAP32[buf+56>>2]=stat.mtime.getTime()/1e3|0;HEAP32[buf+60>>2]=0;HEAP32[buf+64>>2]=stat.ctime.getTime()/1e3|0;HEAP32[buf+68>>2]=0;HEAP32[buf+72>>2]=stat.ino;return 0}),doMsync:(function(addr,stream,len,flags){var buffer=new Uint8Array(HEAPU8.subarray(addr,addr+len));FS.msync(stream,buffer,0,len,flags)}),doMkdir:(function(path,mode){path=PATH.normalize(path);if(path[path.length-1]==="/")path=path.substr(0,path.length-1);FS.mkdir(path,mode,0);return 0}),doMknod:(function(path,mode,dev){switch(mode&61440){case 32768:case 8192:case 24576:case 4096:case 49152:break;default:return-ERRNO_CODES.EINVAL}FS.mknod(path,mode,dev);return 0}),doReadlink:(function(path,buf,bufsize){if(bufsize<=0)return-ERRNO_CODES.EINVAL;var ret=FS.readlink(path);ret=ret.slice(0,Math.max(0,bufsize));writeStringToMemory(ret,buf,true);return ret.length}),doAccess:(function(path,amode){if(amode&~7){return-ERRNO_CODES.EINVAL}var node;var lookup=FS.lookupPath(path,{follow:true});node=lookup.node;var perms="";if(amode&4)perms+="r";if(amode&2)perms+="w";if(amode&1)perms+="x";if(perms&&FS.nodePermissions(node,perms)){return-ERRNO_CODES.EACCES}return 0}),doDup:(function(path,flags,suggestFD){var suggest=FS.getStream(suggestFD);if(suggest)FS.close(suggest);return FS.open(path,flags,0,suggestFD,suggestFD).fd}),doReadv:(function(stream,iov,iovcnt,offset){var ret=0;for(var i=0;i<iovcnt;i++){var ptr=HEAP32[iov+i*8>>2];var len=HEAP32[iov+(i*8+4)>>2];var curr=FS.read(stream,HEAP8,ptr,len,offset);if(curr<0)return-1;ret+=curr;if(curr<len)break}return ret}),doWritev:(function(stream,iov,iovcnt,offset){var ret=0;for(var i=0;i<iovcnt;i++){var ptr=HEAP32[iov+i*8>>2];var len=HEAP32[iov+(i*8+4)>>2];var curr=FS.write(stream,HEAP8,ptr,len,offset);if(curr<0)return-1;ret+=curr}return ret}),varargs:0,get:(function(varargs){SYSCALLS.varargs+=4;var ret=HEAP32[SYSCALLS.varargs-4>>2];return ret}),getStr:(function(){var ret=Pointer_stringify(SYSCALLS.get());return ret}),getStreamFromFD:(function(){var stream=FS.getStream(SYSCALLS.get());if(!stream)throw new FS.ErrnoError(ERRNO_CODES.EBADF);return stream}),getSocketFromFD:(function(){var socket=SOCKFS.getSocket(SYSCALLS.get());if(!socket)throw new FS.ErrnoError(ERRNO_CODES.EBADF);return socket}),getSocketAddress:(function(allowNull){var addrp=SYSCALLS.get(),addrlen=SYSCALLS.get();if(allowNull&&addrp===0)return null;var info=__read_sockaddr(addrp,addrlen);if(info.errno)throw new FS.ErrnoError(info.errno);info.addr=DNS.lookup_addr(info.addr)||info.addr;return info}),get64:(function(){var low=SYSCALLS.get(),high=SYSCALLS.get();if(low>=0)assert(high===0);else assert(high===-1);return low}),getZero:(function(){assert(SYSCALLS.get()===0)})};function ___syscall54(which,varargs){SYSCALLS.varargs=varargs;try{var stream=SYSCALLS.getStreamFromFD(),op=SYSCALLS.get();switch(op){case 21505:{if(!stream.tty)return-ERRNO_CODES.ENOTTY;return 0};case 21506:{if(!stream.tty)return-ERRNO_CODES.ENOTTY;return 0};case 21519:{if(!stream.tty)return-ERRNO_CODES.ENOTTY;var argp=SYSCALLS.get();HEAP32[argp>>2]=0;return 0};case 21520:{if(!stream.tty)return-ERRNO_CODES.ENOTTY;return-ERRNO_CODES.EINVAL};case 21531:{var argp=SYSCALLS.get();return FS.ioctl(stream,op,argp)};default:abort("bad ioctl syscall "+op)}}catch(e){if(typeof FS==="undefined"||!(e instanceof FS.ErrnoError))abort(e);return-e.errno}}Module["_bitshift64Ashr"]=_bitshift64Ashr;Module["_bitshift64Lshr"]=_bitshift64Lshr;var _BDtoIHigh=true;function _pthread_cleanup_push(routine,arg){__ATEXIT__.push((function(){Runtime.dynCall("vi",routine,[arg])}));_pthread_cleanup_push.level=__ATEXIT__.length}function _pthread_cond_broadcast(){return 0}var _emscripten_resume=true;function _pthread_cleanup_pop(){assert(_pthread_cleanup_push.level==__ATEXIT__.length,"cannot pop if something else added meanwhile!");__ATEXIT__.pop();_pthread_cleanup_push.level=__ATEXIT__.length}function _pthread_mutex_unlock(){}function _emscripten_memcpy_big(dest,src,num){HEAPU8.set(HEAPU8.subarray(src,src+num),dest);return dest}Module["_memcpy"]=_memcpy;function _pthread_mutex_lock(){}function _sbrk(bytes){var self=_sbrk;if(!self.called){DYNAMICTOP=alignMemoryPage(DYNAMICTOP);self.called=true;assert(Runtime.dynamicAlloc);self.alloc=Runtime.dynamicAlloc;Runtime.dynamicAlloc=(function(){abort("cannot dynamically allocate, sbrk now has control")})}var ret=DYNAMICTOP;if(bytes!=0){var success=self.alloc(bytes);if(!success)return-1>>>0}return ret}function __isLeapYear(year){return year%4===0&&(year%100!==0||year%400===0)}function __arraySum(array,index){var sum=0;for(var i=0;i<=index;sum+=array[i++]);return sum}var __MONTH_DAYS_LEAP=[31,29,31,30,31,30,31,31,30,31,30,31];var __MONTH_DAYS_REGULAR=[31,28,31,30,31,30,31,31,30,31,30,31];function __addDays(date,days){var newDate=new Date(date.getTime());while(days>0){var leap=__isLeapYear(newDate.getFullYear());var currentMonth=newDate.getMonth();var daysInCurrentMonth=(leap?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR)[currentMonth];if(days>daysInCurrentMonth-newDate.getDate()){days-=daysInCurrentMonth-newDate.getDate()+1;newDate.setDate(1);if(currentMonth<11){newDate.setMonth(currentMonth+1)}else{newDate.setMonth(0);newDate.setFullYear(newDate.getFullYear()+1)}}else{newDate.setDate(newDate.getDate()+days);return newDate}}return newDate}function _strftime(s,maxsize,format,tm){var tm_zone=HEAP32[tm+40>>2];var date={tm_sec:HEAP32[tm>>2],tm_min:HEAP32[tm+4>>2],tm_hour:HEAP32[tm+8>>2],tm_mday:HEAP32[tm+12>>2],tm_mon:HEAP32[tm+16>>2],tm_year:HEAP32[tm+20>>2],tm_wday:HEAP32[tm+24>>2],tm_yday:HEAP32[tm+28>>2],tm_isdst:HEAP32[tm+32>>2],tm_gmtoff:HEAP32[tm+36>>2],tm_zone:tm_zone?Pointer_stringify(tm_zone):""};var pattern=Pointer_stringify(format);var EXPANSION_RULES_1={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S"};for(var rule in EXPANSION_RULES_1){pattern=pattern.replace(new RegExp(rule,"g"),EXPANSION_RULES_1[rule])}var WEEKDAYS=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];var MONTHS=["January","February","March","April","May","June","July","August","September","October","November","December"];function leadingSomething(value,digits,character){var str=typeof value==="number"?value.toString():value||"";while(str.length<digits){str=character[0]+str}return str}function leadingNulls(value,digits){return leadingSomething(value,digits,"0")}function compareByDay(date1,date2){function sgn(value){return value<0?-1:value>0?1:0}var compare;if((compare=sgn(date1.getFullYear()-date2.getFullYear()))===0){if((compare=sgn(date1.getMonth()-date2.getMonth()))===0){compare=sgn(date1.getDate()-date2.getDate())}}return compare}function getFirstWeekStartDate(janFourth){switch(janFourth.getDay()){case 0:return new Date(janFourth.getFullYear()-1,11,29);case 1:return janFourth;case 2:return new Date(janFourth.getFullYear(),0,3);case 3:return new Date(janFourth.getFullYear(),0,2);case 4:return new Date(janFourth.getFullYear(),0,1);case 5:return new Date(janFourth.getFullYear()-1,11,31);case 6:return new Date(janFourth.getFullYear()-1,11,30)}}function getWeekBasedYear(date){var thisDate=__addDays(new Date(date.tm_year+1900,0,1),date.tm_yday);var janFourthThisYear=new Date(thisDate.getFullYear(),0,4);var janFourthNextYear=new Date(thisDate.getFullYear()+1,0,4);var firstWeekStartThisYear=getFirstWeekStartDate(janFourthThisYear);var firstWeekStartNextYear=getFirstWeekStartDate(janFourthNextYear);if(compareByDay(firstWeekStartThisYear,thisDate)<=0){if(compareByDay(firstWeekStartNextYear,thisDate)<=0){return thisDate.getFullYear()+1}else{return thisDate.getFullYear()}}else{return thisDate.getFullYear()-1}}var EXPANSION_RULES_2={"%a":(function(date){return WEEKDAYS[date.tm_wday].substring(0,3)}),"%A":(function(date){return WEEKDAYS[date.tm_wday]}),"%b":(function(date){return MONTHS[date.tm_mon].substring(0,3)}),"%B":(function(date){return MONTHS[date.tm_mon]}),"%C":(function(date){var year=date.tm_year+1900;return leadingNulls(year/100|0,2)}),"%d":(function(date){return leadingNulls(date.tm_mday,2)}),"%e":(function(date){return leadingSomething(date.tm_mday,2," ")}),"%g":(function(date){return getWeekBasedYear(date).toString().substring(2)}),"%G":(function(date){return getWeekBasedYear(date)}),"%H":(function(date){return leadingNulls(date.tm_hour,2)}),"%I":(function(date){return leadingNulls(date.tm_hour<13?date.tm_hour:date.tm_hour-12,2)}),"%j":(function(date){return leadingNulls(date.tm_mday+__arraySum(__isLeapYear(date.tm_year+1900)?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR,date.tm_mon-1),3)}),"%m":(function(date){return leadingNulls(date.tm_mon+1,2)}),"%M":(function(date){return leadingNulls(date.tm_min,2)}),"%n":(function(){return"\n"}),"%p":(function(date){if(date.tm_hour>0&&date.tm_hour<13){return"AM"}else{return"PM"}}),"%S":(function(date){return leadingNulls(date.tm_sec,2)}),"%t":(function(){return"\t"}),"%u":(function(date){var day=new Date(date.tm_year+1900,date.tm_mon+1,date.tm_mday,0,0,0,0);return day.getDay()||7}),"%U":(function(date){var janFirst=new Date(date.tm_year+1900,0,1);var firstSunday=janFirst.getDay()===0?janFirst:__addDays(janFirst,7-janFirst.getDay());var endDate=new Date(date.tm_year+1900,date.tm_mon,date.tm_mday);if(compareByDay(firstSunday,endDate)<0){var februaryFirstUntilEndMonth=__arraySum(__isLeapYear(endDate.getFullYear())?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR,endDate.getMonth()-1)-31;var firstSundayUntilEndJanuary=31-firstSunday.getDate();var days=firstSundayUntilEndJanuary+februaryFirstUntilEndMonth+endDate.getDate();return leadingNulls(Math.ceil(days/7),2)}return compareByDay(firstSunday,janFirst)===0?"01":"00"}),"%V":(function(date){var janFourthThisYear=new Date(date.tm_year+1900,0,4);var janFourthNextYear=new Date(date.tm_year+1901,0,4);var firstWeekStartThisYear=getFirstWeekStartDate(janFourthThisYear);var firstWeekStartNextYear=getFirstWeekStartDate(janFourthNextYear);var endDate=__addDays(new Date(date.tm_year+1900,0,1),date.tm_yday);if(compareByDay(endDate,firstWeekStartThisYear)<0){return"53"}if(compareByDay(firstWeekStartNextYear,endDate)<=0){return"01"}var daysDifference;if(firstWeekStartThisYear.getFullYear()<date.tm_year+1900){daysDifference=date.tm_yday+32-firstWeekStartThisYear.getDate()}else{daysDifference=date.tm_yday+1-firstWeekStartThisYear.getDate()}return leadingNulls(Math.ceil(daysDifference/7),2)}),"%w":(function(date){var day=new Date(date.tm_year+1900,date.tm_mon+1,date.tm_mday,0,0,0,0);return day.getDay()}),"%W":(function(date){var janFirst=new Date(date.tm_year,0,1);var firstMonday=janFirst.getDay()===1?janFirst:__addDays(janFirst,janFirst.getDay()===0?1:7-janFirst.getDay()+1);var endDate=new Date(date.tm_year+1900,date.tm_mon,date.tm_mday);if(compareByDay(firstMonday,endDate)<0){var februaryFirstUntilEndMonth=__arraySum(__isLeapYear(endDate.getFullYear())?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR,endDate.getMonth()-1)-31;var firstMondayUntilEndJanuary=31-firstMonday.getDate();var days=firstMondayUntilEndJanuary+februaryFirstUntilEndMonth+endDate.getDate();return leadingNulls(Math.ceil(days/7),2)}return compareByDay(firstMonday,janFirst)===0?"01":"00"}),"%y":(function(date){return(date.tm_year+1900).toString().substring(2)}),"%Y":(function(date){return date.tm_year+1900}),"%z":(function(date){var off=date.tm_gmtoff;var ahead=off>=0;off=Math.abs(off)/60;off=off/60*100+off%60;return(ahead?"+":"-")+String("0000"+off).slice(-4)}),"%Z":(function(date){return date.tm_zone}),"%%":(function(){return"%"})};for(var rule in EXPANSION_RULES_2){if(pattern.indexOf(rule)>=0){pattern=pattern.replace(new RegExp(rule,"g"),EXPANSION_RULES_2[rule](date))}}var bytes=intArrayFromString(pattern,false);if(bytes.length>maxsize){return 0}writeArrayToMemory(bytes,s);return bytes.length-1}function _strftime_l(s,maxsize,format,tm){return _strftime(s,maxsize,format,tm)}function ___cxa_guard_abort(){}Module["_memmove"]=_memmove;var _emscripten_preinvoke=true;var _BItoD=true;function _pthread_cond_wait(){return 0}function ___cxa_rethrow(){___cxa_end_catch.rethrown=true;var ptr=EXCEPTIONS.caught.pop();EXCEPTIONS.last=ptr;throw ptr}function __embind_register_memory_view(rawType,dataTypeIndex,name){var typeMapping=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array];var TA=typeMapping[dataTypeIndex];function decodeMemoryView(handle){handle=handle>>2;var heap=HEAPU32;var size=heap[handle];var data=heap[handle+1];return new TA(heap["buffer"],data,size)}name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":decodeMemoryView,"argPackAdvance":8,"readValueFromPointer":decodeMemoryView},{ignoreDuplicateRegistrations:true})}function ___cxa_guard_release(){}function _malloc(bytes){var ptr=Runtime.dynamicAlloc(bytes+8);return ptr+8&4294967288}Module["_malloc"]=_malloc;function __embind_register_std_string(rawType,name){name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":(function(value){var length=HEAPU32[value>>2];var a=new Array(length);for(var i=0;i<length;++i){a[i]=String.fromCharCode(HEAPU8[value+4+i])}_free(value);return a.join("")}),"toWireType":(function(destructors,value){if(value instanceof ArrayBuffer){value=new Uint8Array(value)}function getTAElement(ta,index){return ta[index]}function getStringElement(string,index){return string.charCodeAt(index)}var getElement;if(value instanceof Uint8Array){getElement=getTAElement}else if(value instanceof Int8Array){getElement=getTAElement}else if(typeof value==="string"){getElement=getStringElement}else{throwBindingError("Cannot pass non-string to std::string")}var length=value.length;var ptr=_malloc(4+length);HEAPU32[ptr>>2]=length;for(var i=0;i<length;++i){var charCode=getElement(value,i);if(charCode>255){_free(ptr);throwBindingError("String has UTF-16 code units that do not fit in 8 bits")}HEAPU8[ptr+4+i]=charCode}if(destructors!==null){destructors.push(_free,ptr)}return ptr}),"argPackAdvance":8,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction:(function(ptr){_free(ptr)})})}function ___assert_fail(condition,filename,line,func){ABORT=true;throw"Assertion failed: "+Pointer_stringify(condition)+", at: "+[filename?Pointer_stringify(filename):"unknown filename",line,func?Pointer_stringify(func):"unknown function"]+" at "+stackTrace()}function __embind_register_void(rawType,name){name=readLatin1String(name);registerType(rawType,{isVoid:true,name:name,"argPackAdvance":0,"fromWireType":(function(){return undefined}),"toWireType":(function(destructors,o){return undefined})})}Module["_memset"]=_memset;var _BDtoILow=true;function ___gxx_personality_v0(){}Module["_bitshift64Shl"]=_bitshift64Shl;function _abort(){Module["abort"]()}function _pthread_once(ptr,func){if(!_pthread_once.seen)_pthread_once.seen={};if(ptr in _pthread_once.seen)return;Runtime.dynCall("v",func);_pthread_once.seen[ptr]=1}function ___lock(){}function ___unlock(){}function _pthread_getspecific(key){return PTHREAD_SPECIFIC[key]||0}var _fabs=Math_abs;function _emscripten_set_main_loop_timing(mode,value){Browser.mainLoop.timingMode=mode;Browser.mainLoop.timingValue=value;if(!Browser.mainLoop.func){return 1}if(mode==0){Browser.mainLoop.scheduler=function Browser_mainLoop_scheduler_setTimeout(){setTimeout(Browser.mainLoop.runner,value)};Browser.mainLoop.method="timeout"}else if(mode==1){Browser.mainLoop.scheduler=function Browser_mainLoop_scheduler_rAF(){Browser.requestAnimationFrame(Browser.mainLoop.runner)};Browser.mainLoop.method="rAF"}else if(mode==2){if(!window["setImmediate"]){var setImmediates=[];var emscriptenMainLoopMessageId="__emcc";function Browser_setImmediate_messageHandler(event){if(event.source===window&&event.data===emscriptenMainLoopMessageId){event.stopPropagation();setImmediates.shift()()}}window.addEventListener("message",Browser_setImmediate_messageHandler,true);window["setImmediate"]=function Browser_emulated_setImmediate(func){setImmediates.push(func);window.postMessage(emscriptenMainLoopMessageId,"*")}}Browser.mainLoop.scheduler=function Browser_mainLoop_scheduler_setImmediate(){window["setImmediate"](Browser.mainLoop.runner)};Browser.mainLoop.method="immediate"}return 0}function _emscripten_set_main_loop(func,fps,simulateInfiniteLoop,arg,noSetTiming){Module["noExitRuntime"]=true;assert(!Browser.mainLoop.func,"emscripten_set_main_loop: there can only be one main loop function at once: call emscripten_cancel_main_loop to cancel the previous one before setting a new one with different parameters.");Browser.mainLoop.func=func;Browser.mainLoop.arg=arg;var thisMainLoopId=Browser.mainLoop.currentlyRunningMainloop;Browser.mainLoop.runner=function Browser_mainLoop_runner(){if(ABORT)return;if(Browser.mainLoop.queue.length>0){var start=Date.now();var blocker=Browser.mainLoop.queue.shift();blocker.func(blocker.arg);if(Browser.mainLoop.remainingBlockers){var remaining=Browser.mainLoop.remainingBlockers;var next=remaining%1==0?remaining-1:Math.floor(remaining);if(blocker.counted){Browser.mainLoop.remainingBlockers=next}else{next=next+.5;Browser.mainLoop.remainingBlockers=(8*remaining+next)/9}}console.log('main loop blocker "'+blocker.name+'" took '+(Date.now()-start)+" ms");Browser.mainLoop.updateStatus();setTimeout(Browser.mainLoop.runner,0);return}if(thisMainLoopId<Browser.mainLoop.currentlyRunningMainloop)return;Browser.mainLoop.currentFrameNumber=Browser.mainLoop.currentFrameNumber+1|0;if(Browser.mainLoop.timingMode==1&&Browser.mainLoop.timingValue>1&&Browser.mainLoop.currentFrameNumber%Browser.mainLoop.timingValue!=0){Browser.mainLoop.scheduler();return}if(Browser.mainLoop.method==="timeout"&&Module.ctx){Module.printErr("Looks like you are rendering without using requestAnimationFrame for the main loop. You should use 0 for the frame rate in emscripten_set_main_loop in order to use requestAnimationFrame, as that can greatly improve your frame rates!");Browser.mainLoop.method=""}Browser.mainLoop.runIter((function(){if(typeof arg!=="undefined"){Runtime.dynCall("vi",func,[arg])}else{Runtime.dynCall("v",func)}}));if(thisMainLoopId<Browser.mainLoop.currentlyRunningMainloop)return;if(typeof SDL==="object"&&SDL.audio&&SDL.audio.queueNewAudioData)SDL.audio.queueNewAudioData();Browser.mainLoop.scheduler()};if(!noSetTiming){if(fps&&fps>0)_emscripten_set_main_loop_timing(0,1e3/fps);else _emscripten_set_main_loop_timing(1,1);Browser.mainLoop.scheduler()}if(simulateInfiniteLoop){throw"SimulateInfiniteLoop"}}var Browser={mainLoop:{scheduler:null,method:"",currentlyRunningMainloop:0,func:null,arg:0,timingMode:0,timingValue:0,currentFrameNumber:0,queue:[],pause:(function(){Browser.mainLoop.scheduler=null;Browser.mainLoop.currentlyRunningMainloop++}),resume:(function(){Browser.mainLoop.currentlyRunningMainloop++;var timingMode=Browser.mainLoop.timingMode;var timingValue=Browser.mainLoop.timingValue;var func=Browser.mainLoop.func;Browser.mainLoop.func=null;_emscripten_set_main_loop(func,0,false,Browser.mainLoop.arg,true);_emscripten_set_main_loop_timing(timingMode,timingValue);Browser.mainLoop.scheduler()}),updateStatus:(function(){if(Module["setStatus"]){var message=Module["statusMessage"]||"Please wait...";var remaining=Browser.mainLoop.remainingBlockers;var expected=Browser.mainLoop.expectedBlockers;if(remaining){if(remaining<expected){Module["setStatus"](message+" ("+(expected-remaining)+"/"+expected+")")}else{Module["setStatus"](message)}}else{Module["setStatus"]("")}}}),runIter:(function(func){if(ABORT)return;if(Module["preMainLoop"]){var preRet=Module["preMainLoop"]();if(preRet===false){return}}try{func()}catch(e){if(e instanceof ExitStatus){return}else{if(e&&typeof e==="object"&&e.stack)Module.printErr("exception thrown: "+[e,e.stack]);throw e}}if(Module["postMainLoop"])Module["postMainLoop"]()})},isFullScreen:false,pointerLock:false,moduleContextCreatedCallbacks:[],workers:[],init:(function(){if(!Module["preloadPlugins"])Module["preloadPlugins"]=[];if(Browser.initted)return;Browser.initted=true;try{new Blob;Browser.hasBlobConstructor=true}catch(e){Browser.hasBlobConstructor=false;console.log("warning: no blob constructor, cannot create blobs with mimetypes")}Browser.BlobBuilder=typeof MozBlobBuilder!="undefined"?MozBlobBuilder:typeof WebKitBlobBuilder!="undefined"?WebKitBlobBuilder:!Browser.hasBlobConstructor?console.log("warning: no BlobBuilder"):null;Browser.URLObject=typeof window!="undefined"?window.URL?window.URL:window.webkitURL:undefined;if(!Module.noImageDecoding&&typeof Browser.URLObject==="undefined"){console.log("warning: Browser does not support creating object URLs. Built-in browser image decoding will not be available.");Module.noImageDecoding=true}var imagePlugin={};imagePlugin["canHandle"]=function imagePlugin_canHandle(name){return!Module.noImageDecoding&&/\.(jpg|jpeg|png|bmp)$/i.test(name)};imagePlugin["handle"]=function imagePlugin_handle(byteArray,name,onload,onerror){var b=null;if(Browser.hasBlobConstructor){try{b=new Blob([byteArray],{type:Browser.getMimetype(name)});if(b.size!==byteArray.length){b=new Blob([(new Uint8Array(byteArray)).buffer],{type:Browser.getMimetype(name)})}}catch(e){Runtime.warnOnce("Blob constructor present but fails: "+e+"; falling back to blob builder")}}if(!b){var bb=new Browser.BlobBuilder;bb.append((new Uint8Array(byteArray)).buffer);b=bb.getBlob()}var url=Browser.URLObject.createObjectURL(b);var img=new Image;img.onload=function img_onload(){assert(img.complete,"Image "+name+" could not be decoded");var canvas=document.createElement("canvas");canvas.width=img.width;canvas.height=img.height;var ctx=canvas.getContext("2d");ctx.drawImage(img,0,0);Module["preloadedImages"][name]=canvas;Browser.URLObject.revokeObjectURL(url);if(onload)onload(byteArray)};img.onerror=function img_onerror(event){console.log("Image "+url+" could not be decoded");if(onerror)onerror()};img.src=url};Module["preloadPlugins"].push(imagePlugin);var audioPlugin={};audioPlugin["canHandle"]=function audioPlugin_canHandle(name){return!Module.noAudioDecoding&&name.substr(-4)in{".ogg":1,".wav":1,".mp3":1}};audioPlugin["handle"]=function audioPlugin_handle(byteArray,name,onload,onerror){var done=false;function finish(audio){if(done)return;done=true;Module["preloadedAudios"][name]=audio;if(onload)onload(byteArray)}function fail(){if(done)return;done=true;Module["preloadedAudios"][name]=new Audio;if(onerror)onerror()}if(Browser.hasBlobConstructor){try{var b=new Blob([byteArray],{type:Browser.getMimetype(name)})}catch(e){return fail()}var url=Browser.URLObject.createObjectURL(b);var audio=new Audio;audio.addEventListener("canplaythrough",(function(){finish(audio)}),false);audio.onerror=function audio_onerror(event){if(done)return;console.log("warning: browser could not fully decode audio "+name+", trying slower base64 approach");function encode64(data){var BASE="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var PAD="=";var ret="";var leftchar=0;var leftbits=0;for(var i=0;i<data.length;i++){leftchar=leftchar<<8|data[i];leftbits+=8;while(leftbits>=6){var curr=leftchar>>leftbits-6&63;leftbits-=6;ret+=BASE[curr]}}if(leftbits==2){ret+=BASE[(leftchar&3)<<4];ret+=PAD+PAD}else if(leftbits==4){ret+=BASE[(leftchar&15)<<2];ret+=PAD}return ret}audio.src="data:audio/x-"+name.substr(-3)+";base64,"+encode64(byteArray);finish(audio)};audio.src=url;Browser.safeSetTimeout((function(){finish(audio)}),1e4)}else{return fail()}};Module["preloadPlugins"].push(audioPlugin);var canvas=Module["canvas"];function pointerLockChange(){Browser.pointerLock=document["pointerLockElement"]===canvas||document["mozPointerLockElement"]===canvas||document["webkitPointerLockElement"]===canvas||document["msPointerLockElement"]===canvas}if(canvas){canvas.requestPointerLock=canvas["requestPointerLock"]||canvas["mozRequestPointerLock"]||canvas["webkitRequestPointerLock"]||canvas["msRequestPointerLock"]||(function(){});canvas.exitPointerLock=document["exitPointerLock"]||document["mozExitPointerLock"]||document["webkitExitPointerLock"]||document["msExitPointerLock"]||(function(){});canvas.exitPointerLock=canvas.exitPointerLock.bind(document);document.addEventListener("pointerlockchange",pointerLockChange,false);document.addEventListener("mozpointerlockchange",pointerLockChange,false);document.addEventListener("webkitpointerlockchange",pointerLockChange,false);document.addEventListener("mspointerlockchange",pointerLockChange,false);if(Module["elementPointerLock"]){canvas.addEventListener("click",(function(ev){if(!Browser.pointerLock&&canvas.requestPointerLock){canvas.requestPointerLock();ev.preventDefault()}}),false)}}}),createContext:(function(canvas,useWebGL,setInModule,webGLContextAttributes){if(useWebGL&&Module.ctx&&canvas==Module.canvas)return Module.ctx;var ctx;var contextHandle;if(useWebGL){var contextAttributes={antialias:false,alpha:false};if(webGLContextAttributes){for(var attribute in webGLContextAttributes){contextAttributes[attribute]=webGLContextAttributes[attribute]}}contextHandle=GL.createContext(canvas,contextAttributes);if(contextHandle){ctx=GL.getContext(contextHandle).GLctx}canvas.style.backgroundColor="black"}else{ctx=canvas.getContext("2d")}if(!ctx)return null;if(setInModule){if(!useWebGL)assert(typeof GLctx==="undefined","cannot set in module if GLctx is used, but we are a non-GL context that would replace it");Module.ctx=ctx;if(useWebGL)GL.makeContextCurrent(contextHandle);Module.useWebGL=useWebGL;Browser.moduleContextCreatedCallbacks.forEach((function(callback){callback()}));Browser.init()}return ctx}),destroyContext:(function(canvas,useWebGL,setInModule){}),fullScreenHandlersInstalled:false,lockPointer:undefined,resizeCanvas:undefined,requestFullScreen:(function(lockPointer,resizeCanvas,vrDevice){Browser.lockPointer=lockPointer;Browser.resizeCanvas=resizeCanvas;Browser.vrDevice=vrDevice;if(typeof Browser.lockPointer==="undefined")Browser.lockPointer=true;if(typeof Browser.resizeCanvas==="undefined")Browser.resizeCanvas=false;if(typeof Browser.vrDevice==="undefined")Browser.vrDevice=null;var canvas=Module["canvas"];function fullScreenChange(){Browser.isFullScreen=false;var canvasContainer=canvas.parentNode;if((document["webkitFullScreenElement"]||document["webkitFullscreenElement"]||document["mozFullScreenElement"]||document["mozFullscreenElement"]||document["fullScreenElement"]||document["fullscreenElement"]||document["msFullScreenElement"]||document["msFullscreenElement"]||document["webkitCurrentFullScreenElement"])===canvasContainer){canvas.cancelFullScreen=document["cancelFullScreen"]||document["mozCancelFullScreen"]||document["webkitCancelFullScreen"]||document["msExitFullscreen"]||document["exitFullscreen"]||(function(){});canvas.cancelFullScreen=canvas.cancelFullScreen.bind(document);if(Browser.lockPointer)canvas.requestPointerLock();Browser.isFullScreen=true;if(Browser.resizeCanvas)Browser.setFullScreenCanvasSize()}else{canvasContainer.parentNode.insertBefore(canvas,canvasContainer);canvasContainer.parentNode.removeChild(canvasContainer);if(Browser.resizeCanvas)Browser.setWindowedCanvasSize()}if(Module["onFullScreen"])Module["onFullScreen"](Browser.isFullScreen);Browser.updateCanvasDimensions(canvas)}if(!Browser.fullScreenHandlersInstalled){Browser.fullScreenHandlersInstalled=true;document.addEventListener("fullscreenchange",fullScreenChange,false);document.addEventListener("mozfullscreenchange",fullScreenChange,false);document.addEventListener("webkitfullscreenchange",fullScreenChange,false);document.addEventListener("MSFullscreenChange",fullScreenChange,false)}var canvasContainer=document.createElement("div");canvas.parentNode.insertBefore(canvasContainer,canvas);canvasContainer.appendChild(canvas);canvasContainer.requestFullScreen=canvasContainer["requestFullScreen"]||canvasContainer["mozRequestFullScreen"]||canvasContainer["msRequestFullscreen"]||(canvasContainer["webkitRequestFullScreen"]?(function(){canvasContainer["webkitRequestFullScreen"](Element["ALLOW_KEYBOARD_INPUT"])}):null);if(vrDevice){canvasContainer.requestFullScreen({vrDisplay:vrDevice})}else{canvasContainer.requestFullScreen()}}),nextRAF:0,fakeRequestAnimationFrame:(function(func){var now=Date.now();if(Browser.nextRAF===0){Browser.nextRAF=now+1e3/60}else{while(now+2>=Browser.nextRAF){Browser.nextRAF+=1e3/60}}var delay=Math.max(Browser.nextRAF-now,0);setTimeout(func,delay)}),requestAnimationFrame:function requestAnimationFrame(func){if(typeof window==="undefined"){Browser.fakeRequestAnimationFrame(func)}else{if(!window.requestAnimationFrame){window.requestAnimationFrame=window["requestAnimationFrame"]||window["mozRequestAnimationFrame"]||window["webkitRequestAnimationFrame"]||window["msRequestAnimationFrame"]||window["oRequestAnimationFrame"]||Browser.fakeRequestAnimationFrame}window.requestAnimationFrame(func)}},safeCallback:(function(func){return(function(){if(!ABORT)return func.apply(null,arguments)})}),allowAsyncCallbacks:true,queuedAsyncCallbacks:[],pauseAsyncCallbacks:(function(){Browser.allowAsyncCallbacks=false}),resumeAsyncCallbacks:(function(){Browser.allowAsyncCallbacks=true;if(Browser.queuedAsyncCallbacks.length>0){var callbacks=Browser.queuedAsyncCallbacks;Browser.queuedAsyncCallbacks=[];callbacks.forEach((function(func){func()}))}}),safeRequestAnimationFrame:(function(func){return Browser.requestAnimationFrame((function(){if(ABORT)return;if(Browser.allowAsyncCallbacks){func()}else{Browser.queuedAsyncCallbacks.push(func)}}))}),safeSetTimeout:(function(func,timeout){Module["noExitRuntime"]=true;return setTimeout((function(){if(ABORT)return;if(Browser.allowAsyncCallbacks){func()}else{Browser.queuedAsyncCallbacks.push(func)}}),timeout)}),safeSetInterval:(function(func,timeout){Module["noExitRuntime"]=true;return setInterval((function(){if(ABORT)return;if(Browser.allowAsyncCallbacks){func()}}),timeout)}),getMimetype:(function(name){return{"jpg":"image/jpeg","jpeg":"image/jpeg","png":"image/png","bmp":"image/bmp","ogg":"audio/ogg","wav":"audio/wav","mp3":"audio/mpeg"}[name.substr(name.lastIndexOf(".")+1)]}),getUserMedia:(function(func){if(!window.getUserMedia){window.getUserMedia=navigator["getUserMedia"]||navigator["mozGetUserMedia"]}window.getUserMedia(func)}),getMovementX:(function(event){return event["movementX"]||event["mozMovementX"]||event["webkitMovementX"]||0}),getMovementY:(function(event){return event["movementY"]||event["mozMovementY"]||event["webkitMovementY"]||0}),getMouseWheelDelta:(function(event){var delta=0;switch(event.type){case"DOMMouseScroll":delta=event.detail;break;case"mousewheel":delta=event.wheelDelta;break;case"wheel":delta=event["deltaY"];break;default:throw"unrecognized mouse wheel event: "+event.type}return delta}),mouseX:0,mouseY:0,mouseMovementX:0,mouseMovementY:0,touches:{},lastTouches:{},calculateMouseEvent:(function(event){if(Browser.pointerLock){if(event.type!="mousemove"&&"mozMovementX"in event){Browser.mouseMovementX=Browser.mouseMovementY=0}else{Browser.mouseMovementX=Browser.getMovementX(event);Browser.mouseMovementY=Browser.getMovementY(event)}if(typeof SDL!="undefined"){Browser.mouseX=SDL.mouseX+Browser.mouseMovementX;Browser.mouseY=SDL.mouseY+Browser.mouseMovementY}else{Browser.mouseX+=Browser.mouseMovementX;Browser.mouseY+=Browser.mouseMovementY}}else{var rect=Module["canvas"].getBoundingClientRect();var cw=Module["canvas"].width;var ch=Module["canvas"].height;var scrollX=typeof window.scrollX!=="undefined"?window.scrollX:window.pageXOffset;var scrollY=typeof window.scrollY!=="undefined"?window.scrollY:window.pageYOffset;if(event.type==="touchstart"||event.type==="touchend"||event.type==="touchmove"){var touch=event.touch;if(touch===undefined){return}var adjustedX=touch.pageX-(scrollX+rect.left);var adjustedY=touch.pageY-(scrollY+rect.top);adjustedX=adjustedX*(cw/rect.width);adjustedY=adjustedY*(ch/rect.height);var coords={x:adjustedX,y:adjustedY};if(event.type==="touchstart"){Browser.lastTouches[touch.identifier]=coords;Browser.touches[touch.identifier]=coords}else if(event.type==="touchend"||event.type==="touchmove"){var last=Browser.touches[touch.identifier];if(!last)last=coords;Browser.lastTouches[touch.identifier]=last;Browser.touches[touch.identifier]=coords}return}var x=event.pageX-(scrollX+rect.left);var y=event.pageY-(scrollY+rect.top);x=x*(cw/rect.width);y=y*(ch/rect.height);Browser.mouseMovementX=x-Browser.mouseX;Browser.mouseMovementY=y-Browser.mouseY;Browser.mouseX=x;Browser.mouseY=y}}),xhrLoad:(function(url,onload,onerror){var xhr=new XMLHttpRequest;xhr.open("GET",url,true);xhr.responseType="arraybuffer";xhr.onload=function xhr_onload(){if(xhr.status==200||xhr.status==0&&xhr.response){onload(xhr.response)}else{onerror()}};xhr.onerror=onerror;xhr.send(null)}),asyncLoad:(function(url,onload,onerror,noRunDep){Browser.xhrLoad(url,(function(arrayBuffer){assert(arrayBuffer,'Loading data file "'+url+'" failed (no arrayBuffer).');onload(new Uint8Array(arrayBuffer));if(!noRunDep)removeRunDependency("al "+url)}),(function(event){if(onerror){onerror()}else{throw'Loading data file "'+url+'" failed.'}}));if(!noRunDep)addRunDependency("al "+url)}),resizeListeners:[],updateResizeListeners:(function(){var canvas=Module["canvas"];Browser.resizeListeners.forEach((function(listener){listener(canvas.width,canvas.height)}))}),setCanvasSize:(function(width,height,noUpdates){var canvas=Module["canvas"];Browser.updateCanvasDimensions(canvas,width,height);if(!noUpdates)Browser.updateResizeListeners()}),windowedWidth:0,windowedHeight:0,setFullScreenCanvasSize:(function(){if(typeof SDL!="undefined"){var flags=HEAPU32[SDL.screen+Runtime.QUANTUM_SIZE*0>>2];flags=flags|8388608;HEAP32[SDL.screen+Runtime.QUANTUM_SIZE*0>>2]=flags}Browser.updateResizeListeners()}),setWindowedCanvasSize:(function(){if(typeof SDL!="undefined"){var flags=HEAPU32[SDL.screen+Runtime.QUANTUM_SIZE*0>>2];flags=flags&~8388608;HEAP32[SDL.screen+Runtime.QUANTUM_SIZE*0>>2]=flags}Browser.updateResizeListeners()}),updateCanvasDimensions:(function(canvas,wNative,hNative){if(wNative&&hNative){canvas.widthNative=wNative;canvas.heightNative=hNative}else{wNative=canvas.widthNative;hNative=canvas.heightNative}var w=wNative;var h=hNative;if(Module["forcedAspectRatio"]&&Module["forcedAspectRatio"]>0){if(w/h<Module["forcedAspectRatio"]){w=Math.round(h*Module["forcedAspectRatio"])}else{h=Math.round(w/Module["forcedAspectRatio"])}}if((document["webkitFullScreenElement"]||document["webkitFullscreenElement"]||document["mozFullScreenElement"]||document["mozFullscreenElement"]||document["fullScreenElement"]||document["fullscreenElement"]||document["msFullScreenElement"]||document["msFullscreenElement"]||document["webkitCurrentFullScreenElement"])===canvas.parentNode&&typeof screen!="undefined"){var factor=Math.min(screen.width/w,screen.height/h);w=Math.round(w*factor);h=Math.round(h*factor)}if(Browser.resizeCanvas){if(canvas.width!=w)canvas.width=w;if(canvas.height!=h)canvas.height=h;if(typeof canvas.style!="undefined"){canvas.style.removeProperty("width");canvas.style.removeProperty("height")}}else{if(canvas.width!=wNative)canvas.width=wNative;if(canvas.height!=hNative)canvas.height=hNative;if(typeof canvas.style!="undefined"){if(w!=wNative||h!=hNative){canvas.style.setProperty("width",w+"px","important");canvas.style.setProperty("height",h+"px","important")}else{canvas.style.removeProperty("width");canvas.style.removeProperty("height")}}}}),wgetRequests:{},nextWgetRequestHandle:0,getNextWgetRequestHandle:(function(){var handle=Browser.nextWgetRequestHandle;Browser.nextWgetRequestHandle++;return handle})};function _pthread_setspecific(key,value){if(!(key in PTHREAD_SPECIFIC)){return ERRNO_CODES.EINVAL}PTHREAD_SPECIFIC[key]=value;return 0}function ___cxa_allocate_exception(size){return _malloc(size)}function ___cxa_pure_virtual(){ABORT=true;throw"Pure virtual function called!"}function floatReadValueFromPointer(name,shift){switch(shift){case 2:return(function(pointer){return this["fromWireType"](HEAPF32[pointer>>2])});case 3:return(function(pointer){return this["fromWireType"](HEAPF64[pointer>>3])});default:throw new TypeError("Unknown float type: "+name)}}function __embind_register_float(rawType,name,size){var shift=getShiftFromSize(size);name=readLatin1String(name);registerType(rawType,{name:name,"fromWireType":(function(value){return value}),"toWireType":(function(destructors,value){if(typeof value!=="number"&&typeof value!=="boolean"){throw new TypeError('Cannot convert "'+_embind_repr(value)+'" to '+this.name)}return value}),"argPackAdvance":8,"readValueFromPointer":floatReadValueFromPointer(name,shift),destructorFunction:null})}function ___cxa_guard_acquire(variable){if(!HEAP8[variable>>0]){HEAP8[variable>>0]=1;return 1}return 0}function ___cxa_begin_catch(ptr){__ZSt18uncaught_exceptionv.uncaught_exception--;EXCEPTIONS.caught.push(ptr);EXCEPTIONS.addRef(EXCEPTIONS.deAdjust(ptr));return ptr}function _llvm_eh_typeid_for(type){return type}function ___syscall6(which,varargs){SYSCALLS.varargs=varargs;try{var stream=SYSCALLS.getStreamFromFD();FS.close(stream);return 0}catch(e){if(typeof FS==="undefined"||!(e instanceof FS.ErrnoError))abort(e);return-e.errno}}function ___cxa_call_unexpected(exception){Module.printErr("Unexpected exception thrown, this is not properly supported - aborting");ABORT=true;throw exception}function __embind_register_std_wstring(rawType,charSize,name){name=readLatin1String(name);var getHeap,shift;if(charSize===2){getHeap=(function(){return HEAPU16});shift=1}else if(charSize===4){getHeap=(function(){return HEAPU32});shift=2}registerType(rawType,{name:name,"fromWireType":(function(value){var HEAP=getHeap();var length=HEAPU32[value>>2];var a=new Array(length);var start=value+4>>shift;for(var i=0;i<length;++i){a[i]=String.fromCharCode(HEAP[start+i])}_free(value);return a.join("")}),"toWireType":(function(destructors,value){var HEAP=getHeap();var length=value.length;var ptr=_malloc(4+length*charSize);HEAPU32[ptr>>2]=length;var start=ptr+4>>shift;for(var i=0;i<length;++i){HEAP[start+i]=value.charCodeAt(i)}if(destructors!==null){destructors.push(_free,ptr)}return ptr}),"argPackAdvance":8,"readValueFromPointer":simpleReadValueFromPointer,destructorFunction:(function(ptr){_free(ptr)})})}function _time(ptr){var ret=Date.now()/1e3|0;if(ptr){HEAP32[ptr>>2]=ret}return ret}function _pthread_self(){return 0}function ___syscall140(which,varargs){SYSCALLS.varargs=varargs;try{var stream=SYSCALLS.getStreamFromFD(),offset_high=SYSCALLS.get(),offset_low=SYSCALLS.get(),result=SYSCALLS.get(),whence=SYSCALLS.get();var offset=offset_low;assert(offset_high===0);FS.llseek(stream,offset,whence);HEAP32[result>>2]=stream.position;if(stream.getdents&&offset===0&&whence===0)stream.getdents=null;return 0}catch(e){if(typeof FS==="undefined"||!(e instanceof FS.ErrnoError))abort(e);return-e.errno}}function ___syscall146(which,varargs){SYSCALLS.varargs=varargs;try{var stream=SYSCALLS.getStreamFromFD(),iov=SYSCALLS.get(),iovcnt=SYSCALLS.get();return SYSCALLS.doWritev(stream,iov,iovcnt)}catch(e){if(typeof FS==="undefined"||!(e instanceof FS.ErrnoError))abort(e);return-e.errno}}var ___dso_handle=allocate(1,"i32*",ALLOC_STATIC);embind_init_charCodes();BindingError=Module["BindingError"]=extendError(Error,"BindingError");InternalError=Module["InternalError"]=extendError(Error,"InternalError");init_emval();FS.staticInit();__ATINIT__.unshift((function(){if(!Module["noFSInit"]&&!FS.init.initialized)FS.init()}));__ATMAIN__.push((function(){FS.ignorePermissions=false}));__ATEXIT__.push((function(){FS.quit()}));Module["FS_createFolder"]=FS.createFolder;Module["FS_createPath"]=FS.createPath;Module["FS_createDataFile"]=FS.createDataFile;Module["FS_createPreloadedFile"]=FS.createPreloadedFile;Module["FS_createLazyFile"]=FS.createLazyFile;Module["FS_createLink"]=FS.createLink;Module["FS_createDevice"]=FS.createDevice;Module["FS_unlink"]=FS.unlink;__ATINIT__.unshift((function(){TTY.init()}));__ATEXIT__.push((function(){TTY.shutdown()}));if(ENVIRONMENT_IS_NODE){var fs=require("fs");var NODEJS_PATH=require("path");NODEFS.staticInit()}Module["requestFullScreen"]=function Module_requestFullScreen(lockPointer,resizeCanvas,vrDevice){Browser.requestFullScreen(lockPointer,resizeCanvas,vrDevice)};Module["requestAnimationFrame"]=function Module_requestAnimationFrame(func){Browser.requestAnimationFrame(func)};Module["setCanvasSize"]=function Module_setCanvasSize(width,height,noUpdates){Browser.setCanvasSize(width,height,noUpdates)};Module["pauseMainLoop"]=function Module_pauseMainLoop(){Browser.mainLoop.pause()};Module["resumeMainLoop"]=function Module_resumeMainLoop(){Browser.mainLoop.resume()};Module["getUserMedia"]=function Module_getUserMedia(){Browser.getUserMedia()};Module["createContext"]=function Module_createContext(canvas,useWebGL,setInModule,webGLContextAttributes){return Browser.createContext(canvas,useWebGL,setInModule,webGLContextAttributes)};STACK_BASE=STACKTOP=Runtime.alignMemory(STATICTOP);staticSealed=true;STACK_MAX=STACK_BASE+TOTAL_STACK;DYNAMIC_BASE=DYNAMICTOP=Runtime.alignMemory(STACK_MAX);assert(DYNAMIC_BASE<TOTAL_MEMORY,"TOTAL_MEMORY not big enough for stack");var cttz_i8=allocate([8,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,6,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,7,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,6,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0],"i8",ALLOC_DYNAMIC);function invoke_iiiiiiii(index,a1,a2,a3,a4,a5,a6,a7){try{return Module["dynCall_iiiiiiii"](index,a1,a2,a3,a4,a5,a6,a7)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiiiiii(index,a1,a2,a3,a4,a5,a6,a7){return Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7)}function invoke_iiiiiid(index,a1,a2,a3,a4,a5,a6){try{return Module["dynCall_iiiiiid"](index,a1,a2,a3,a4,a5,a6)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiiiid(index,a1,a2,a3,a4,a5,a6){return Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6)}function invoke_viiiii(index,a1,a2,a3,a4,a5){try{Module["dynCall_viiiii"](index,a1,a2,a3,a4,a5)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viiiii(index,a1,a2,a3,a4,a5){Runtime.functionPointers[index](a1,a2,a3,a4,a5)}function invoke_vi(index,a1){try{Module["dynCall_vi"](index,a1)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_vi(index,a1){Runtime.functionPointers[index](a1)}function invoke_vii(index,a1,a2){try{Module["dynCall_vii"](index,a1,a2)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_vii(index,a1,a2){Runtime.functionPointers[index](a1,a2)}function invoke_iiiiiii(index,a1,a2,a3,a4,a5,a6){try{return Module["dynCall_iiiiiii"](index,a1,a2,a3,a4,a5,a6)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiiiii(index,a1,a2,a3,a4,a5,a6){return Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6)}function invoke_ii(index,a1){try{return Module["dynCall_ii"](index,a1)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_ii(index,a1){return Runtime.functionPointers[index](a1)}function invoke_idddddddd(index,a1,a2,a3,a4,a5,a6,a7,a8){try{return Module["dynCall_idddddddd"](index,a1,a2,a3,a4,a5,a6,a7,a8)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_idddddddd(index,a1,a2,a3,a4,a5,a6,a7,a8){return Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7,a8)}function invoke_iiiiiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11){try{return Module["dynCall_iiiiiiiiiiii"](index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiiiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11){return Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11)}function invoke_vidd(index,a1,a2,a3){try{Module["dynCall_vidd"](index,a1,a2,a3)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_vidd(index,a1,a2,a3){Runtime.functionPointers[index](a1,a2,a3)}function invoke_iiii(index,a1,a2,a3){try{return Module["dynCall_iiii"](index,a1,a2,a3)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiii(index,a1,a2,a3){return Runtime.functionPointers[index](a1,a2,a3)}function invoke_viiiiiiiiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15){try{Module["dynCall_viiiiiiiiiiiiiii"](index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viiiiiiiiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15){Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15)}function invoke_viiiiii(index,a1,a2,a3,a4,a5,a6){try{Module["dynCall_viiiiii"](index,a1,a2,a3,a4,a5,a6)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viiiiii(index,a1,a2,a3,a4,a5,a6){Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6)}function invoke_diiii(index,a1,a2,a3,a4){try{return Module["dynCall_diiii"](index,a1,a2,a3,a4)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_diiii(index,a1,a2,a3,a4){return Runtime.functionPointers[index](a1,a2,a3,a4)}function invoke_iidiid(index,a1,a2,a3,a4,a5){try{return Module["dynCall_iidiid"](index,a1,a2,a3,a4,a5)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iidiid(index,a1,a2,a3,a4,a5){return Runtime.functionPointers[index](a1,a2,a3,a4,a5)}function invoke_viddd(index,a1,a2,a3,a4){try{Module["dynCall_viddd"](index,a1,a2,a3,a4)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viddd(index,a1,a2,a3,a4){Runtime.functionPointers[index](a1,a2,a3,a4)}function invoke_di(index,a1){try{return Module["dynCall_di"](index,a1)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_di(index,a1){return Runtime.functionPointers[index](a1)}function invoke_iiiiidddddddd(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12){try{return Module["dynCall_iiiiidddddddd"](index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiiidddddddd(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12){return Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12)}function invoke_viiiiiii(index,a1,a2,a3,a4,a5,a6,a7){try{Module["dynCall_viiiiiii"](index,a1,a2,a3,a4,a5,a6,a7)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viiiiiii(index,a1,a2,a3,a4,a5,a6,a7){Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7)}function invoke_iiddd(index,a1,a2,a3,a4){try{return Module["dynCall_iiddd"](index,a1,a2,a3,a4)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiddd(index,a1,a2,a3,a4){return Runtime.functionPointers[index](a1,a2,a3,a4)}function invoke_viiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8,a9){try{Module["dynCall_viiiiiiiii"](index,a1,a2,a3,a4,a5,a6,a7,a8,a9)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8,a9){Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7,a8,a9)}function invoke_viiiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10){try{Module["dynCall_viiiiiiiiii"](index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viiiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10){Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7,a8,a9,a10)}function invoke_iii(index,a1,a2){try{return Module["dynCall_iii"](index,a1,a2)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iii(index,a1,a2){return Runtime.functionPointers[index](a1,a2)}function invoke_iiiiii(index,a1,a2,a3,a4,a5){try{return Module["dynCall_iiiiii"](index,a1,a2,a3,a4,a5)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiiii(index,a1,a2,a3,a4,a5){return Runtime.functionPointers[index](a1,a2,a3,a4,a5)}function invoke_diii(index,a1,a2,a3){try{return Module["dynCall_diii"](index,a1,a2,a3)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_diii(index,a1,a2,a3){return Runtime.functionPointers[index](a1,a2,a3)}function invoke_iiiidddddddddddddddd(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19){try{return Module["dynCall_iiiidddddddddddddddd"](index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiidddddddddddddddd(index,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19){return Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19)}function invoke_viiiiiidi(index,a1,a2,a3,a4,a5,a6,a7,a8){try{Module["dynCall_viiiiiidi"](index,a1,a2,a3,a4,a5,a6,a7,a8)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viiiiiidi(index,a1,a2,a3,a4,a5,a6,a7,a8){Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7,a8)}function invoke_dii(index,a1,a2){try{return Module["dynCall_dii"](index,a1,a2)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_dii(index,a1,a2){return Runtime.functionPointers[index](a1,a2)}function invoke_i(index){try{return Module["dynCall_i"](index)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_i(index){return Runtime.functionPointers[index]()}function invoke_iiiid(index,a1,a2,a3,a4){try{return Module["dynCall_iiiid"](index,a1,a2,a3,a4)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiid(index,a1,a2,a3,a4){return Runtime.functionPointers[index](a1,a2,a3,a4)}function invoke_iiiii(index,a1,a2,a3,a4){try{return Module["dynCall_iiiii"](index,a1,a2,a3,a4)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiii(index,a1,a2,a3,a4){return Runtime.functionPointers[index](a1,a2,a3,a4)}function invoke_viii(index,a1,a2,a3){try{Module["dynCall_viii"](index,a1,a2,a3)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viii(index,a1,a2,a3){Runtime.functionPointers[index](a1,a2,a3)}function invoke_v(index){try{Module["dynCall_v"](index)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_v(index){Runtime.functionPointers[index]()}function invoke_iiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8){try{return Module["dynCall_iiiiiiiii"](index,a1,a2,a3,a4,a5,a6,a7,a8)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiiiiiii(index,a1,a2,a3,a4,a5,a6,a7,a8){return Runtime.functionPointers[index](a1,a2,a3,a4,a5,a6,a7,a8)}function invoke_iiiiid(index,a1,a2,a3,a4,a5){try{return Module["dynCall_iiiiid"](index,a1,a2,a3,a4,a5)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_iiiiid(index,a1,a2,a3,a4,a5){return Runtime.functionPointers[index](a1,a2,a3,a4,a5)}function invoke_viiii(index,a1,a2,a3,a4){try{Module["dynCall_viiii"](index,a1,a2,a3,a4)}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0)}}function jsCall_viiii(index,a1,a2,a3,a4){Runtime.functionPointers[index](a1,a2,a3,a4)}Module.asmGlobalArg={"Math":Math,"Int8Array":Int8Array,"Int16Array":Int16Array,"Int32Array":Int32Array,"Uint8Array":Uint8Array,"Uint16Array":Uint16Array,"Uint32Array":Uint32Array,"Float32Array":Float32Array,"Float64Array":Float64Array,"NaN":NaN,"Infinity":Infinity};Module.asmLibraryArg={"abort":abort,"assert":assert,"invoke_iiiiiiii":invoke_iiiiiiii,"jsCall_iiiiiiii":jsCall_iiiiiiii,"invoke_iiiiiid":invoke_iiiiiid,"jsCall_iiiiiid":jsCall_iiiiiid,"invoke_viiiii":invoke_viiiii,"jsCall_viiiii":jsCall_viiiii,"invoke_vi":invoke_vi,"jsCall_vi":jsCall_vi,"invoke_vii":invoke_vii,"jsCall_vii":jsCall_vii,"invoke_iiiiiii":invoke_iiiiiii,"jsCall_iiiiiii":jsCall_iiiiiii,"invoke_ii":invoke_ii,"jsCall_ii":jsCall_ii,"invoke_idddddddd":invoke_idddddddd,"jsCall_idddddddd":jsCall_idddddddd,"invoke_iiiiiiiiiiii":invoke_iiiiiiiiiiii,"jsCall_iiiiiiiiiiii":jsCall_iiiiiiiiiiii,"invoke_vidd":invoke_vidd,"jsCall_vidd":jsCall_vidd,"invoke_iiii":invoke_iiii,"jsCall_iiii":jsCall_iiii,"invoke_viiiiiiiiiiiiiii":invoke_viiiiiiiiiiiiiii,"jsCall_viiiiiiiiiiiiiii":jsCall_viiiiiiiiiiiiiii,"invoke_viiiiii":invoke_viiiiii,"jsCall_viiiiii":jsCall_viiiiii,"invoke_diiii":invoke_diiii,"jsCall_diiii":jsCall_diiii,"invoke_iidiid":invoke_iidiid,"jsCall_iidiid":jsCall_iidiid,"invoke_viddd":invoke_viddd,"jsCall_viddd":jsCall_viddd,"invoke_di":invoke_di,"jsCall_di":jsCall_di,"invoke_iiiiidddddddd":invoke_iiiiidddddddd,"jsCall_iiiiidddddddd":jsCall_iiiiidddddddd,"invoke_viiiiiii":invoke_viiiiiii,"jsCall_viiiiiii":jsCall_viiiiiii,"invoke_iiddd":invoke_iiddd,"jsCall_iiddd":jsCall_iiddd,"invoke_viiiiiiiii":invoke_viiiiiiiii,"jsCall_viiiiiiiii":jsCall_viiiiiiiii,"invoke_viiiiiiiiii":invoke_viiiiiiiiii,"jsCall_viiiiiiiiii":jsCall_viiiiiiiiii,"invoke_iii":invoke_iii,"jsCall_iii":jsCall_iii,"invoke_iiiiii":invoke_iiiiii,"jsCall_iiiiii":jsCall_iiiiii,"invoke_diii":invoke_diii,"jsCall_diii":jsCall_diii,"invoke_iiiidddddddddddddddd":invoke_iiiidddddddddddddddd,"jsCall_iiiidddddddddddddddd":jsCall_iiiidddddddddddddddd,"invoke_viiiiiidi":invoke_viiiiiidi,"jsCall_viiiiiidi":jsCall_viiiiiidi,"invoke_dii":invoke_dii,"jsCall_dii":jsCall_dii,"invoke_i":invoke_i,"jsCall_i":jsCall_i,"invoke_iiiid":invoke_iiiid,"jsCall_iiiid":jsCall_iiiid,"invoke_iiiii":invoke_iiiii,"jsCall_iiiii":jsCall_iiiii,"invoke_viii":invoke_viii,"jsCall_viii":jsCall_viii,"invoke_v":invoke_v,"jsCall_v":jsCall_v,"invoke_iiiiiiiii":invoke_iiiiiiiii,"jsCall_iiiiiiiii":jsCall_iiiiiiiii,"invoke_iiiiid":invoke_iiiiid,"jsCall_iiiiid":jsCall_iiiiid,"invoke_viiii":invoke_viiii,"jsCall_viiii":jsCall_viiii,"_fabs":_fabs,"_pthread_cleanup_pop":_pthread_cleanup_pop,"_pthread_cond_wait":_pthread_cond_wait,"___lock":___lock,"floatReadValueFromPointer":floatReadValueFromPointer,"simpleReadValueFromPointer":simpleReadValueFromPointer,"_sqrtf":_sqrtf,"__embind_register_memory_view":__embind_register_memory_view,"throwInternalError":throwInternalError,"get_first_emval":get_first_emval,"_abort":_abort,"___cxa_guard_acquire":___cxa_guard_acquire,"___setErrNo":___setErrNo,"___gxx_personality_v0":___gxx_personality_v0,"__embind_register_integer":__embind_register_integer,"_fabsf":_fabsf,"___assert_fail":___assert_fail,"___cxa_free_exception":___cxa_free_exception,"___cxa_allocate_exception":___cxa_allocate_exception,"__ZSt18uncaught_exceptionv":__ZSt18uncaught_exceptionv,"extendError":extendError,"getShiftFromSize":getShiftFromSize,"__embind_register_emval":__embind_register_emval,"__addDays":__addDays,"_strftime_l":_strftime_l,"throwBindingError":throwBindingError,"_emscripten_set_main_loop_timing":_emscripten_set_main_loop_timing,"_llvm_eh_typeid_for":_llvm_eh_typeid_for,"_sbrk":_sbrk,"__embind_register_void":__embind_register_void,"_emscripten_memcpy_big":_emscripten_memcpy_big,"___cxa_end_catch":___cxa_end_catch,"__embind_register_bool":__embind_register_bool,"___resumeException":___resumeException,"___cxa_find_matching_catch":___cxa_find_matching_catch,"_sysconf":_sysconf,"_embind_repr":_embind_repr,"___cxa_begin_catch":___cxa_begin_catch,"_strftime":_strftime,"createNamedFunction":createNamedFunction,"__emval_register":__emval_register,"embind_init_charCodes":embind_init_charCodes,"readLatin1String":readLatin1String,"_pthread_self":_pthread_self,"___cxa_call_unexpected":___cxa_call_unexpected,"__emval_decref":__emval_decref,"_pthread_once":_pthread_once,"_pthread_mutex_unlock":_pthread_mutex_unlock,"_pthread_getspecific":_pthread_getspecific,"___cxa_guard_abort":___cxa_guard_abort,"__embind_register_float":__embind_register_float,"_floorf":_floorf,"makeLegalFunctionName":makeLegalFunctionName,"whenDependentTypesAreResolved":whenDependentTypesAreResolved,"___syscall54":___syscall54,"___unlock":___unlock,"__embind_register_std_wstring":__embind_register_std_wstring,"init_emval":init_emval,"__isLeapYear":__isLeapYear,"_emscripten_set_main_loop":_emscripten_set_main_loop,"___cxa_guard_release":___cxa_guard_release,"_pthread_setspecific":_pthread_setspecific,"___cxa_atexit":___cxa_atexit,"integerReadValueFromPointer":integerReadValueFromPointer,"registerType":registerType,"___cxa_throw":___cxa_throw,"_pthread_cond_broadcast":_pthread_cond_broadcast,"___cxa_rethrow":___cxa_rethrow,"__arraySum":__arraySum,"___syscall6":___syscall6,"_pthread_cleanup_push":_pthread_cleanup_push,"count_emval_handles":count_emval_handles,"_time":_time,"_pthread_mutex_lock":_pthread_mutex_lock,"_pthread_key_create":_pthread_key_create,"_atexit":_atexit,"___syscall140":___syscall140,"__embind_register_std_string":__embind_register_std_string,"___cxa_pure_virtual":___cxa_pure_virtual,"___syscall146":___syscall146,"STACKTOP":STACKTOP,"STACK_MAX":STACK_MAX,"tempDoublePtr":tempDoublePtr,"ABORT":ABORT,"cttz_i8":cttz_i8,"___dso_handle":___dso_handle};// EMSCRIPTEN_START_ASM
var asm=(function(global,env,buffer) {
"use asm";var a=new global.Int8Array(buffer);var b=new global.Int16Array(buffer);var c=new global.Int32Array(buffer);var d=new global.Uint8Array(buffer);var e=new global.Uint16Array(buffer);var f=new global.Uint32Array(buffer);var g=new global.Float32Array(buffer);var h=new global.Float64Array(buffer);var i=env.STACKTOP|0;var j=env.STACK_MAX|0;var k=env.tempDoublePtr|0;var l=env.ABORT|0;var m=env.cttz_i8|0;var n=env.___dso_handle|0;var o=0;var p=0;var q=0;var r=0;var s=global.NaN,t=global.Infinity;var u=0,v=0,w=0,x=0,y=0.0,z=0,A=0,B=0,C=0.0;var D=0;var E=0;var F=0;var G=0;var H=0;var I=0;var J=0;var K=0;var L=0;var M=0;var N=global.Math.floor;var O=global.Math.abs;var P=global.Math.sqrt;var Q=global.Math.pow;var R=global.Math.cos;var S=global.Math.sin;var T=global.Math.tan;var U=global.Math.acos;var V=global.Math.asin;var W=global.Math.atan;var X=global.Math.atan2;var Y=global.Math.exp;var Z=global.Math.log;var _=global.Math.ceil;var $=global.Math.imul;var aa=global.Math.min;var ba=global.Math.clz32;var ca=env.abort;var da=env.assert;var ea=env.invoke_iiiiiiii;var fa=env.jsCall_iiiiiiii;var ga=env.invoke_iiiiiid;var ha=env.jsCall_iiiiiid;var ia=env.invoke_viiiii;var ja=env.jsCall_viiiii;var ka=env.invoke_vi;var la=env.jsCall_vi;var ma=env.invoke_vii;var na=env.jsCall_vii;var oa=env.invoke_iiiiiii;var pa=env.jsCall_iiiiiii;var qa=env.invoke_ii;var ra=env.jsCall_ii;var sa=env.invoke_idddddddd;var ta=env.jsCall_idddddddd;var ua=env.invoke_iiiiiiiiiiii;var va=env.jsCall_iiiiiiiiiiii;var wa=env.invoke_vidd;var xa=env.jsCall_vidd;var ya=env.invoke_iiii;var za=env.jsCall_iiii;var Aa=env.invoke_viiiiiiiiiiiiiii;var Ba=env.jsCall_viiiiiiiiiiiiiii;var Ca=env.invoke_viiiiii;var Da=env.jsCall_viiiiii;var Ea=env.invoke_diiii;var Fa=env.jsCall_diiii;var Ga=env.invoke_iidiid;var Ha=env.jsCall_iidiid;var Ia=env.invoke_viddd;var Ja=env.jsCall_viddd;var Ka=env.invoke_di;var La=env.jsCall_di;var Ma=env.invoke_iiiiidddddddd;var Na=env.jsCall_iiiiidddddddd;var Oa=env.invoke_viiiiiii;var Pa=env.jsCall_viiiiiii;var Qa=env.invoke_iiddd;var Ra=env.jsCall_iiddd;var Sa=env.invoke_viiiiiiiii;var Ta=env.jsCall_viiiiiiiii;var Ua=env.invoke_viiiiiiiiii;var Va=env.jsCall_viiiiiiiiii;var Wa=env.invoke_iii;var Xa=env.jsCall_iii;var Ya=env.invoke_iiiiii;var Za=env.jsCall_iiiiii;var _a=env.invoke_diii;var $a=env.jsCall_diii;var ab=env.invoke_iiiidddddddddddddddd;var bb=env.jsCall_iiiidddddddddddddddd;var cb=env.invoke_viiiiiidi;var db=env.jsCall_viiiiiidi;var eb=env.invoke_dii;var fb=env.jsCall_dii;var gb=env.invoke_i;var hb=env.jsCall_i;var ib=env.invoke_iiiid;var jb=env.jsCall_iiiid;var kb=env.invoke_iiiii;var lb=env.jsCall_iiiii;var mb=env.invoke_viii;var nb=env.jsCall_viii;var ob=env.invoke_v;var pb=env.jsCall_v;var qb=env.invoke_iiiiiiiii;var rb=env.jsCall_iiiiiiiii;var sb=env.invoke_iiiiid;var tb=env.jsCall_iiiiid;var ub=env.invoke_viiii;var vb=env.jsCall_viiii;var wb=env._fabs;var xb=env._pthread_cleanup_pop;var yb=env._pthread_cond_wait;var zb=env.___lock;var Ab=env.floatReadValueFromPointer;var Bb=env.simpleReadValueFromPointer;var Cb=env._sqrtf;var Db=env.__embind_register_memory_view;var Eb=env.throwInternalError;var Fb=env.get_first_emval;var Gb=env._abort;var Hb=env.___cxa_guard_acquire;var Ib=env.___setErrNo;var Jb=env.___gxx_personality_v0;var Kb=env.__embind_register_integer;var Lb=env._fabsf;var Mb=env.___assert_fail;var Nb=env.___cxa_free_exception;var Ob=env.___cxa_allocate_exception;var Pb=env.__ZSt18uncaught_exceptionv;var Qb=env.extendError;var Rb=env.getShiftFromSize;var Sb=env.__embind_register_emval;var Tb=env.__addDays;var Ub=env._strftime_l;var Vb=env.throwBindingError;var Wb=env._emscripten_set_main_loop_timing;var Xb=env._llvm_eh_typeid_for;var Yb=env._sbrk;var Zb=env.__embind_register_void;var _b=env._emscripten_memcpy_big;var $b=env.___cxa_end_catch;var ac=env.__embind_register_bool;var bc=env.___resumeException;var cc=env.___cxa_find_matching_catch;var dc=env._sysconf;var ec=env._embind_repr;var fc=env.___cxa_begin_catch;var gc=env._strftime;var hc=env.createNamedFunction;var ic=env.__emval_register;var jc=env.embind_init_charCodes;var kc=env.readLatin1String;var lc=env._pthread_self;var mc=env.___cxa_call_unexpected;var nc=env.__emval_decref;var oc=env._pthread_once;var pc=env._pthread_mutex_unlock;var qc=env._pthread_getspecific;var rc=env.___cxa_guard_abort;var sc=env.__embind_register_float;var tc=env._floorf;var uc=env.makeLegalFunctionName;var vc=env.whenDependentTypesAreResolved;var wc=env.___syscall54;var xc=env.___unlock;var yc=env.__embind_register_std_wstring;var zc=env.init_emval;var Ac=env.__isLeapYear;var Bc=env._emscripten_set_main_loop;var Cc=env.___cxa_guard_release;var Dc=env._pthread_setspecific;var Ec=env.___cxa_atexit;var Fc=env.integerReadValueFromPointer;var Gc=env.registerType;var Hc=env.___cxa_throw;var Ic=env._pthread_cond_broadcast;var Jc=env.___cxa_rethrow;var Kc=env.__arraySum;var Lc=env.___syscall6;var Mc=env._pthread_cleanup_push;var Nc=env.count_emval_handles;var Oc=env._time;var Pc=env._pthread_mutex_lock;var Qc=env._pthread_key_create;var Rc=env._atexit;var Sc=env.___syscall140;var Tc=env.__embind_register_std_string;var Uc=env.___cxa_pure_virtual;var Vc=env.___syscall146;var Wc=0.0;
// EMSCRIPTEN_START_FUNCS
function Po(a){a=a|0;return c[a+8>>2]|0}function Qo(a){a=a|0;return c[a+12>>2]|0}function Ro(a){a=a|0;return c[a+28>>2]|0}function So(a){a=a|0;return (c[a+8>>2]<<2)+17|0}function To(a,b){a=a|0;b=b|0;b=to(b)|0;return c[(c[a+16>>2]|0)+(b<<2)>>2]|0}function Uo(a){a=a|0;var b=0,c=0;do if(((a|0)%4|0|0)==1){o=0;a=qa(189,a+-17>>2|0)|0;c=o;o=0;if(!(c&1))return a|0;a=cc(240)|0;c=D;if((c|0)==(Xb(240)|0)){fc(a|0)|0;a=Ob(8)|0;o=0;ka(308,a|0);c=o;o=0;if(c&1){c=cc()|0;Nb(a|0);a=c}else{o=0;mb(55,a|0,320,76);o=0;a=cc()|0}o=0;ob(44);c=o;o=0;if(c&1){c=cc(0)|0;oq(c)}else b=a}else b=a}else{a=Ob(8)|0;o=0;ka(308,a|0);c=o;o=0;if(c&1){b=cc()|0;Nb(a|0);break}else Hc(a|0,320,76)}while(0);bc(b|0);return 0}function Vo(a){a=a|0;if((a|0)<1|(c[8619]|0)<(a|0)){a=Ob(8)|0;zq(a,50292);c[a>>2]=29736;Hc(a|0,24,146)}else return c[(c[7175]|0)+(a+-1<<2)>>2]|0;return 0}function Wo(a,b,d,e,f,g,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0;c[a+4>>2]=0;c[a>>2]=28720;c[a+8>>2]=b;c[a+12>>2]=d;b=a+16|0;Qt(b,4);i=a+28|0;c[i>>2]=0;c[c[b>>2]>>2]=e;c[(c[b>>2]|0)+4>>2]=f;c[(c[b>>2]|0)+8>>2]=g;c[(c[b>>2]|0)+12>>2]=h;f=c[e>>2]|0;g=c[e+4>>2]|0;a=(c[e+8>>2]|0)-g>>2;if(!a)d=0;else{b=0;d=0;do{e=c[g+(b<<2)>>2]|0;d=($((c[e+4>>2]|0)+f|0,c[e>>2]|0)|0)+d|0;b=b+1|0}while((b|0)!=(a|0))}c[i>>2]=d;return}function Xo(a){a=a|0;var b=0,d=0,e=0;c[a>>2]=28720;b=c[a+12>>2]|0;if(b){br(b);Uz(b)}e=a+16|0;d=a+20|0;b=c[e>>2]|0;if((c[d>>2]|0)!=(b|0)){a=0;do{b=c[b+(a<<2)>>2]|0;if(b){No(b);Uz(b)}a=a+1|0;b=c[e>>2]|0}while(a>>>0<(c[d>>2]|0)-b>>2>>>0)}Rt(e);return}function Yo(a){a=a|0;Xo(a);Uz(a);return}function Zo(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;do if((c[7174]|0)>0){d=2147483647;f=0;b=0;while(1){e=c[28560+(b<<2)>>2]|0;if((e|0)==(a|0)){e=3;break}e=zo(a,e)|0;g=(e|0)<(d|0);f=g?b+7|0:f;d=g?e:d;b=b+1|0;if((b|0)>=(c[7174]|0)){b=f;e=5;break}}if((e|0)==3){b=Vo(b+7|0)|0;break}else if((e|0)==5){d=(d|0)<4;e=6;break}}else{d=0;b=0;e=6}while(0);if((e|0)==6)if(d)b=Vo(b)|0;else b=0;return b|0}function _o(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;r=i;i=i+16|0;s=r;m=a+8|0;n=c[m>>2]<<2;b=Sz(32)|0;o=0;ma(110,b|0,n+17|0);p=o;o=0;if(p&1){s=cc()|0;Uz(b);b=s}else{c[s>>2]=0;Ke(s,b);p=c[s>>2]|0;o=0;ia(54,p|0,0,0,9,9);l=o;o=0;a:do if((!(l&1)?(d=n+9|0,o=0,ia(54,p|0,d|0,0,8,9),l=o,o=0,!(l&1)):0)?(o=0,ia(54,p|0,0,d|0,9,8),l=o,o=0,!(l&1)):0){b=a+12|0;d=c[b>>2]|0;d=(c[d+4>>2]|0)-(c[d>>2]|0)>>2;a=d+-1|0;b:do if(d){e=(d|0)==0;k=0;c:while(1){f=(c[(c[c[b>>2]>>2]|0)+(k<<2)>>2]|0)+-2|0;g=(k|0)==0;h=(k|0)==(a|0);if(!e){l=0;do{j=(l|0)==0;if(g){if(!(j|(l|0)==(a|0)|h&(l|0)==0))q=15}else if(!(h&j))q=15;if((q|0)==15?(q=0,o=0,ia(54,p|0,(c[(c[c[b>>2]>>2]|0)+(l<<2)>>2]|0)+-2|0,f|0,5,5),j=o,o=0,j&1):0)break c;l=l+1|0}while(l>>>0<d>>>0)}k=k+1|0;if(k>>>0>=d>>>0)break b}b=cc()|0;break a}while(0);o=0;ia(54,p|0,6,9,1,n|0);q=o;o=0;if(!(q&1)?(o=0,ia(54,p|0,9,6,n|0,1),q=o,o=0,!(q&1)):0){if((c[m>>2]|0)>6){b=n+6|0;o=0;ia(54,p|0,b|0,0,3,6);q=o;o=0;if(q&1){q=13;break}o=0;ia(54,p|0,0,b|0,6,3);q=o;o=0;if(q&1){q=13;break}}i=r;return p|0}else q=13}else q=13;while(0);if((q|0)==13)b=cc()|0;Yd(s)}bc(b|0);return 0}function $o(a){a=a|0;return}function ap(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;f=i;i=i+16|0;d=f+8|0;e=f;g=c[(c[a>>2]|0)+12>>2]|0;_d(d,b);$d(e,4500);o=0;b=ya(g|0,a|0,d|0,e|0)|0;a=o;o=0;if(a&1){g=cc()|0;ze(e+4|0);ce(d);bc(g|0)}else{ze(e+4|0);ce(d);i=f;return b|0}return 0}function bp(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;c[a+4>>2]=0;c[a>>2]=28736;Sq(a+8|0,b);Pd(a+12|0,d);oe(a+24|0,e);c[a+36>>2]=c[f>>2];return}function cp(a){a=a|0;c[a>>2]=28736;pe(a+24|0);Sd(a+12|0);ne(a+8|0);return}function dp(a){a=a|0;cp(a);Uz(a);return}function ep(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;Sq(b,a+8|0);i=d;return c[b>>2]|0}function fp(a,b){a=a|0;b=b|0;Pd(a,b+12|0);return}function gp(a){a=a|0;return a+24|0}function hp(a){a=a|0;return c[a+36>>2]|0}function ip(a,b,d){a=a|0;b=+b;d=+d;c[a+4>>2]=0;c[a>>2]=28752;g[a+8>>2]=b;g[a+12>>2]=d;return}function jp(a){a=a|0;return}function kp(a){a=a|0;Uz(a);return}function lp(a){a=a|0;return +(+g[a+8>>2])}function mp(a){a=a|0;return +(+g[a+12>>2])}function np(a,b){a=a|0;b=b|0;var d=0,e=0.0;e=+g[a+8>>2];d=c[b>>2]|0;if(e==+ld[c[(c[d>>2]|0)+8>>2]&63](d)){e=+g[a+12>>2];b=c[b>>2]|0;b=e==+ld[c[(c[b>>2]|0)+12>>2]&63](b)}else b=0;return b|0}function op(a){a=a|0;var b=0,d=0,e=0.0,f=0.0,g=0.0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0.0,t=0.0,u=0;r=i;i=i+32|0;n=r+24|0;p=r+20|0;q=r+16|0;j=r+12|0;k=r+8|0;l=r+4|0;m=r;h=c[c[a>>2]>>2]|0;t=+ld[c[(c[h>>2]|0)+8>>2]&63](h);h=c[(c[a>>2]|0)+4>>2]|0;s=+ld[c[(c[h>>2]|0)+8>>2]&63](h);h=c[c[a>>2]>>2]|0;e=+ld[c[(c[h>>2]|0)+12>>2]&63](h);h=c[(c[a>>2]|0)+4>>2]|0;s=t-s;e=e-+ld[c[(c[h>>2]|0)+12>>2]&63](h);e=+P(+(s*s+e*e));h=c[(c[a>>2]|0)+4>>2]|0;s=+ld[c[(c[h>>2]|0)+8>>2]&63](h);h=c[(c[a>>2]|0)+8>>2]|0;t=+ld[c[(c[h>>2]|0)+8>>2]&63](h);h=c[(c[a>>2]|0)+4>>2]|0;f=+ld[c[(c[h>>2]|0)+12>>2]&63](h);h=c[(c[a>>2]|0)+8>>2]|0;t=s-t;f=f-+ld[c[(c[h>>2]|0)+12>>2]&63](h);f=+P(+(t*t+f*f));h=c[c[a>>2]>>2]|0;t=+ld[c[(c[h>>2]|0)+8>>2]&63](h);h=c[(c[a>>2]|0)+8>>2]|0;s=+ld[c[(c[h>>2]|0)+8>>2]&63](h);h=c[c[a>>2]>>2]|0;g=+ld[c[(c[h>>2]|0)+12>>2]&63](h);h=c[(c[a>>2]|0)+8>>2]|0;s=t-s;g=g-+ld[c[(c[h>>2]|0)+12>>2]&63](h);g=+P(+(s*s+g*g));c[n>>2]=0;vq(n,0);c[p>>2]=0;vq(p,0);c[q>>2]=0;vq(q,0);do if(!(f>=e)|!(f>=g)){b=c[a>>2]|0;if(!(g>=f)|!(g>=e)){vq(p,c[b+8>>2]|0);vq(n,c[c[a>>2]>>2]|0);vq(q,c[(c[a>>2]|0)+4>>2]|0);break}else{vq(p,c[b+4>>2]|0);vq(n,c[c[a>>2]>>2]|0);vq(q,c[(c[a>>2]|0)+8>>2]|0);break}}else{vq(p,c[c[a>>2]>>2]|0);vq(n,c[(c[a>>2]|0)+4>>2]|0);vq(q,c[(c[a>>2]|0)+8>>2]|0)}while(0);c[j>>2]=0;d=c[n>>2]|0;vq(j,d);c[k>>2]=0;h=c[p>>2]|0;vq(k,h);c[l>>2]=0;b=c[q>>2]|0;vq(l,b);o=0;e=+_a(43,j|0,k|0,l|0);u=o;o=0;if(u&1){u=cc()|0;uq(l);uq(k);uq(j);uq(q);uq(p);uq(n);bc(u|0)}uq(l);uq(k);uq(j);if(e<0.0){c[m>>2]=0;vq(m,d);vq(n,b);vq(q,c[m>>2]|0);uq(m);d=c[n>>2]|0;b=c[q>>2]|0}vq(c[a>>2]|0,d);vq((c[a>>2]|0)+4|0,h);vq((c[a>>2]|0)+8|0,b);uq(q);uq(p);uq(n);i=r;return}function pp(a,b,d){a=a|0;b=b|0;d=d|0;var e=0.0,f=0.0,g=0.0,h=0;h=c[b>>2]|0;e=+ld[c[(c[h>>2]|0)+8>>2]&63](h);b=c[b>>2]|0;f=+ld[c[(c[b>>2]|0)+12>>2]&63](b);b=c[d>>2]|0;g=+ld[c[(c[b>>2]|0)+8>>2]&63](b)-e;b=c[a>>2]|0;g=g*(+ld[c[(c[b>>2]|0)+12>>2]&63](b)-f);d=c[d>>2]|0;f=+ld[c[(c[d>>2]|0)+12>>2]&63](d)-f;d=c[a>>2]|0;return +(g-f*(+ld[c[(c[d>>2]|0)+8>>2]&63](d)-e))}function qp(a,b){a=a|0;b=b|0;var d=0.0,e=0.0;a=c[a>>2]|0;b=c[b>>2]|0;e=+g[a+8>>2]-+g[b+8>>2];d=+g[a+12>>2]-+g[b+12>>2];return +(+P(+(e*e+d*d)))}function rp(a,b){a=a|0;b=b|0;if((a|0)!=(b|0)){c[a>>2]=c[b>>2];St(a+4|0,b+4|0)}return}function sp(a,b){a=a|0;b=b|0;c[a>>2]=(b|0)==0?0:(b|0)>0?1:-1;xp(a+4|0,(b|0)<0?0-b|0:b);return}function tp(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;h=i;i=i+32|0;e=h+16|0;g=h;a:do if((a|0)==(b|0)|(a|0)==(d|0)){c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=0;c[e+12>>2]=0;o=0;mb(105,e|0,b|0,d|0);d=o;o=0;if(!(d&1)?(o=0,ma(155,a|0,e|0),a=o,o=0,!(a&1)):0){Ds(e+4|0);f=18;break}f=cc()|0;Ds(e+4|0);e=f;f=19}else{e=c[b>>2]|0;if(!e){rp(a,d);f=18;break}f=c[d>>2]|0;if(!f){rp(a,b);f=18;break}if((e|0)==(f|0)){c[a>>2]=e;Cp(a+4|0,b+4|0,d+4|0);f=18;break}e=b+4|0;f=d+4|0;switch(Bp(e,f)|0){case 0:{zp(g,0);o=0;ma(186,a+4|0,g|0);d=o;o=0;if(d&1){e=cc()|0;Ds(g);f=19;break a}else{Ds(g);c[a>>2]=0;f=18;break a}}case 1:{c[a>>2]=c[b>>2];Dp(a+4|0,e,f);f=18;break a}case -1:{c[a>>2]=c[d>>2];Dp(a+4|0,f,e);f=18;break a}default:{f=18;break a}}}while(0);if((f|0)==18){i=h;return}else if((f|0)==19)bc(e|0)}function up(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;h=i;i=i+32|0;e=h+16|0;f=h;do if(!((a|0)==(b|0)|(a|0)==(d|0))){e=c[b>>2]|0;if((e|0)!=0?(g=c[d>>2]|0,(g|0)!=0):0){c[a>>2]=(e|0)==(g|0)?1:-1;Ep(a+4|0,b+4|0,d+4|0);f=12;break}c[a>>2]=0;zp(f,0);o=0;ma(186,a+4|0,f|0);a=o;o=0;if(a&1){e=cc()|0;Ds(f);f=13;break}else{Ds(f);f=12;break}}else{c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=0;c[e+12>>2]=0;o=0;mb(106,e|0,b|0,d|0);d=o;o=0;if(!(d&1)?(o=0,ma(155,a|0,e|0),a=o,o=0,!(a&1)):0){Ds(e+4|0);f=12;break}f=cc()|0;Ds(e+4|0);e=f;f=13}while(0);if((f|0)==12){i=h;return}else if((f|0)==13)bc(e|0)}function vp(a,b){a=a|0;b=b|0;var c=0,d=0;d=i;i=i+16|0;c=d;Gp(c,b,10);o=0;ma(187,a|0,c|0);b=o;o=0;if(b&1){d=cc()|0;Vt(c);bc(d|0)}else{Vt(c);i=d;return}}function wp(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0;g=i;i=i+32|0;f=g+12|0;e=g;a:do if((c[d>>2]|0)!=-1){o=0;ma(188,b|0,d+4|0);f=o;o=0;if(f&1){d=cc()|0;e=11}else e=6}else{FC(f,52976,1);o=0;ma(188,e|0,d+4|0);d=o;o=0;do if(!(d&1)){d=a[e>>0]|0;h=(d&1)==0;o=0;d=ya(90,f|0,(h?e+1|0:c[e+8>>2]|0)|0,(h?(d&255)>>>1:c[e+4>>2]|0)|0)|0;h=o;o=0;if(h&1){d=cc()|0;IC(e);break}else{c[b>>2]=c[d>>2];c[b+4>>2]=c[d+4>>2];c[b+8>>2]=c[d+8>>2];c[d>>2]=0;c[d+4>>2]=0;c[d+8>>2]=0;IC(e);IC(f);e=6;break a}}else d=cc()|0;while(0);IC(f);e=11}while(0);if((e|0)==6){i=g;return}else if((e|0)==11)bc(d|0)}function xp(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;o=0;ma(189,a|0,b|0);b=o;o=0;if(b&1){b=cc()|0;Ds(a);bc(b|0)}else return}function yp(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;o=0;ma(190,a|0,b|0);b=o;o=0;if(b&1){b=cc()|0;Ds(a);bc(b|0)}else return}function zp(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;o=0;ma(191,a|0,b|0);b=o;o=0;if(b&1){b=cc()|0;Ds(a);bc(b|0)}else return}function Ap(a){a=a|0;return Zt(a)|0}function Bp(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;e=c[a+4>>2]|0;d=c[b+4>>2]|0;a:do if(e>>>0>=d>>>0)if(e>>>0>d>>>0)d=1;else{f=a+8|0;b=c[b+8>>2]|0;do{if(!e){d=0;break a}e=e+-1|0;a=c[(c[f>>2]|0)+(e<<2)>>2]|0;d=c[b+(e<<2)>>2]|0}while((a|0)==(d|0));d=a>>>0>d>>>0?1:-1}else d=-1;while(0);return d|0}function Cp(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0;p=i;i=i+16|0;e=p;do if(!((a|0)==(b|0)|(a|0)==(d|0))){e=c[b+4>>2]|0;if(!e){St(a,d);break}f=c[d+4>>2]|0;if(!f){St(a,b);break}e=e>>>0<f>>>0;l=e?d:b;e=e?b:d;k=l+4|0;f=(c[k>>2]|0)+1|0;n=a+4|0;c[n>>2]=f;au(a,f);f=c[e+4>>2]|0;l=l+8|0;m=a+8|0;if(!f)e=0;else{j=c[l>>2]|0;a=c[e+8>>2]|0;g=c[m>>2]|0;d=0;h=0;while(1){e=c[j+(h<<2)>>2]|0;b=(c[a+(h<<2)>>2]|0)+e|0;e=b>>>0<e>>>0;if(d){b=b+1|0;e=((b|0)==0|e&1|0)!=0}c[g+(h<<2)>>2]=b;h=h+1|0;if((h|0)==(f|0))break;else d=e}}h=c[k>>2]|0;if(e&f>>>0<h>>>0){b=c[l>>2]|0;d=c[m>>2]|0;do{k=(c[b+(f<<2)>>2]|0)+1|0;e=(k|0)==0;c[d+(f<<2)>>2]=k;f=f+1|0}while(e&f>>>0<h>>>0)}g=f>>>0>h>>>0;if(f>>>0<h>>>0){b=c[l>>2]|0;d=c[m>>2]|0;a=f;do{c[d+(a<<2)>>2]=c[b+(a<<2)>>2];a=a+1|0}while(a>>>0<h>>>0)}if(e){c[(c[m>>2]|0)+((g?f:h)<<2)>>2]=1;break}else{c[n>>2]=(c[n>>2]|0)+-1;break}}else{c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=0;o=0;mb(107,e|0,b|0,d|0);n=o;o=0;if(!(n&1)?(o=0,ma(186,a|0,e|0),n=o,o=0,!(n&1)):0){Ds(e);break}p=cc()|0;Ds(e);bc(p|0)}while(0);i=p;return}function Dp(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;r=i;i=i+16|0;e=r;do if((a|0)==(b|0)|(a|0)==(d|0)){c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=0;o=0;mb(108,e|0,b|0,d|0);q=o;o=0;if(!(q&1)?(o=0,ma(186,a|0,e|0),a=o,o=0,!(a&1)):0){Ds(e);break}r=cc()|0;Ds(e);bc(r|0)}else{f=d+4|0;e=c[f>>2]|0;if(!e){St(a,b);break}m=b+4|0;g=c[m>>2]|0;if(g>>>0<e>>>0){r=Ob(4)|0;c[r>>2]=50331;Hc(r|0,1952,0)}q=a+4|0;c[q>>2]=g;au(a,g);e=c[f>>2]|0;p=c[b+8>>2]|0;j=c[d+8>>2]|0;n=a+8|0;if(!e)f=0;else{k=c[n>>2]|0;h=0;l=0;while(1){b=c[p+(l<<2)>>2]|0;d=c[j+(l<<2)>>2]|0;g=b-d|0;f=g>>>0>b>>>0;if(h){f=(f&1|(b|0)==(d|0)|0)!=0;g=g+-1|0}c[k+(l<<2)>>2]=g;l=l+1|0;if((l|0)==(e|0))break;else h=f}}b=c[m>>2]|0;if(f&e>>>0<b>>>0){g=c[n>>2]|0;do{m=c[p+(e<<2)>>2]|0;f=(m|0)==0;c[g+(e<<2)>>2]=m+-1;e=e+1|0}while(f&e>>>0<b>>>0)}if(f){c[q>>2]=0;r=Ob(4)|0;c[r>>2]=50331;Hc(r|0,1952,0)}if(e>>>0<b>>>0){f=c[n>>2]|0;do{c[f+(e<<2)>>2]=c[p+(e<<2)>>2];e=e+1|0}while(e>>>0<b>>>0)}_t(a)}while(0);i=r;return}function Ep(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;s=i;i=i+16|0;e=s;do if((a|0)==(b|0)|(a|0)==(d|0)){c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=0;o=0;mb(109,e|0,b|0,d|0);d=o;o=0;if(!(d&1)?(o=0,ma(186,a|0,e|0),d=o,o=0,!(d&1)):0){Ds(e);break}s=cc()|0;Ds(e);bc(s|0)}else{q=b+4|0;e=c[q>>2]|0;if((e|0)!=0?(r=d+4|0,f=c[r>>2]|0,(f|0)!=0):0){m=f+e|0;p=a+4|0;c[p>>2]=m;au(a,m);m=c[p>>2]|0;n=a+8|0;if(m){e=c[n>>2]|0;f=0;do{c[e+(f<<2)>>2]=0;f=f+1|0}while((f|0)!=(m|0))}j=b+8|0;if(c[q>>2]|0){k=0;do{l=0;do{if(c[(c[j>>2]|0)+(k<<2)>>2]&1<<l){b=0;h=0;e=k;while(1){g=(c[n>>2]|0)+(e<<2)|0;a=c[g>>2]|0;f=(bu(d,h,l)|0)+a|0;a=f>>>0<a>>>0;if(b){f=f+1|0;a=((f|0)==0|a&1|0)!=0}c[g>>2]=f;h=h+1|0;e=e+1|0;if(h>>>0>(c[r>>2]|0)>>>0)break;else b=a}if(a){f=c[n>>2]|0;while(1){g=f+(e<<2)|0;h=(c[g>>2]|0)+1|0;c[g>>2]=h;if(!h)e=e+1|0;else break}}}l=l+1|0}while((l|0)!=32);k=k+1|0}while(k>>>0<(c[q>>2]|0)>>>0)}e=m+-1|0;if(c[(c[n>>2]|0)+(e<<2)>>2]|0)break;c[p>>2]=e;break}c[a+4>>2]=0}while(0);i=s;return}function Fp(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;x=i;i=i+16|0;e=x;if((a|0)==(d|0)){x=Ob(4)|0;c[x>>2]=50394;Hc(x|0,1952,0)}do if((a|0)==(b|0)|(d|0)==(b|0)){Tt(e,b);o=0;mb(110,a|0,e|0,d|0);a=o;o=0;if(a&1){x=cc()|0;Ds(e);bc(x|0)}else{Ds(e);break}}else{w=b+4|0;f=c[w>>2]|0;if(!f){c[d+4>>2]=0;break}e=a+4|0;v=c[e>>2]|0;if(v>>>0<f>>>0){c[d+4>>2]=0;break}$t(a,v+1|0);t=(c[e>>2]|0)+1|0;c[e>>2]=t;q=a+8|0;c[(c[q>>2]|0)+(v<<2)>>2]=0;t=Tz(t>>>0>1073741823?-1:t<<2)|0;r=v-(c[w>>2]|0)+1|0;u=d+4|0;c[u>>2]=r;au(d,r);r=c[u>>2]|0;s=c[d+8>>2]|0;if(r){e=0;do{c[s+(e<<2)>>2]=0;e=e+1|0}while((e|0)!=(r|0))}if(r){n=r;do{n=n+-1|0;m=s+(n<<2)|0;c[m>>2]=0;p=32;do{p=p+-1|0;k=c[w>>2]|0;j=0;l=0;d=n;while(1){g=c[(c[q>>2]|0)+(d<<2)>>2]|0;h=bu(b,l,p)|0;f=g-h|0;e=f>>>0>g>>>0;if(j){e=(e&1|(g|0)==(h|0)|0)!=0;f=f+-1|0}c[t+(d<<2)>>2]=f;l=l+1|0;d=d+1|0;if(l>>>0>k>>>0)break;else j=e}if(d>>>0<v>>>0&e){f=c[q>>2]|0;do{l=c[f+(d<<2)>>2]|0;e=(l|0)==0;c[t+(d<<2)>>2]=l+-1;d=d+1|0}while(d>>>0<v>>>0&e)}if(!e?(c[m>>2]=c[m>>2]|1<<p,d>>>0>n>>>0):0){f=c[q>>2]|0;e=d;do{e=e+-1|0;c[f+(e<<2)>>2]=c[t+(e<<2)>>2]}while(e>>>0>n>>>0)}}while((p|0)!=0)}while((n|0)!=0)}e=r+-1|0;if(!(c[s+(e<<2)>>2]|0))c[u>>2]=e;_t(a);Vz(t)}while(0);i=x;return}function Gp(a,d,e){a=a|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0;n=i;i=i+48|0;q=n+24|0;p=n+12|0;l=n;c[a>>2]=0;m=a+4|0;c[m>>2]=0;k=a+8|0;c[k>>2]=0;if((e&65535)>=2){b[a+12>>1]=e;h=c[d+4>>2]|0;if(!(e<<16>>16))f=-1;else{g=e&65535;f=0;while(1){g=g>>>1;if(!g)break;else f=f+1|0}}h=(((h<<5)+-1+f|0)>>>0)/(f>>>0)|0;c[m>>2]=h;o=0;ma(192,a|0,h|0);h=o;o=0;if(!(h&1)?(o=0,ma(193,q|0,d|0),d=o,o=0,!(d&1)):0){o=0;ma(194,p|0,e|0);d=o;o=0;a:do if(d&1)f=cc()|0;else{h=q+4|0;b:do if(!(c[h>>2]|0))f=0;else{f=0;while(1){o=0;ma(193,l|0,q|0);j=o;o=0;if(j&1){j=16;break}o=0;mb(110,l|0,p|0,q|0);j=o;o=0;if(j&1){j=17;break}o=0;g=qa(190,l|0)|0;j=o;o=0;if(j&1){j=17;break}b[(c[k>>2]|0)+(f<<1)>>1]=g;f=f+1|0;Ds(l);if(!(c[h>>2]|0))break b}if((j|0)==16)f=cc()|0;else if((j|0)==17){f=cc()|0;Ds(l)}Ds(p);break a}while(0);c[m>>2]=f;Ds(p);Ds(q);i=n;return}while(0);Ds(q)}else j=3}else{j=Ob(4)|0;c[j>>2]=50487;o=0;mb(55,j|0,1952,0);o=0;j=3}if((j|0)==3)f=cc()|0;Vt(a);bc(f|0)}function Hp(d,f){d=d|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;k=l;if((e[f+12>>1]|0)>36){l=Ob(4)|0;c[l>>2]=50554;Hc(l|0,1952,0)}h=c[f+4>>2]|0;if(!h)FC(d,52905,1);else{j=Tz(h+1|0)|0;a[j+h>>0]=0;f=c[f+8>>2]|0;g=0;do{m=b[f+(h+~g<<1)>>1]|0;a[j+g>>0]=(m&65535)+((m&65535)<10?48:55);g=g+1|0}while((g|0)!=(h|0));FC(k,j,iC(j)|0);Vz(j);c[d>>2]=c[k>>2];c[d+4>>2]=c[k+4>>2];c[d+8>>2]=c[k+8>>2];c[k>>2]=0;c[k+4>>2]=0;c[k+8>>2]=0;IC(k)}i=l;return}function Ip(){c[1062]=0;c[1063]=0;c[1061]=4248;Ec(326,4244,n|0)|0;c[1065]=0;c[1066]=0;c[1064]=4260;Ec(327,4256,n|0)|0;mg()|0;a[45587]=1;return}function Jp(){Rd(30580,0);Ec(44,30580,n|0)|0;return}function Kp(){var a=0,b=0;a=Sz(56)|0;o=0;ub(70,a|0,4201,4096,1);b=o;o=0;if(b&1){b=cc()|0;Uz(a);bc(b|0)}c[1088]=0;jq(4352,a);Ec(328,4352,n|0)|0;a=Sz(56)|0;o=0;ub(70,a|0,1033,1024,1);b=o;o=0;if(b&1){b=cc()|0;Uz(a);bc(b|0)}c[1089]=0;jq(4356,a);Ec(328,4356,n|0)|0;a=Sz(56)|0;o=0;ub(70,a|0,67,64,1);b=o;o=0;if(b&1){b=cc()|0;Uz(a);bc(b|0)}c[1090]=0;jq(4360,a);Ec(328,4360,n|0)|0;a=Sz(56)|0;o=0;ub(70,a|0,19,16,1);b=o;o=0;if(b&1){b=cc()|0;Uz(a);bc(b|0)}c[1091]=0;jq(4364,a);Ec(328,4364,n|0)|0;a=Sz(56)|0;o=0;ub(70,a|0,285,256,0);b=o;o=0;if(b&1){b=cc()|0;Uz(a);bc(b|0)}c[1092]=0;jq(4368,a);Ec(328,4368,n|0)|0;a=Sz(56)|0;o=0;ub(70,a|0,301,256,1);b=o;o=0;if(b&1){b=cc()|0;Uz(a);bc(b|0)}else{c[1093]=0;jq(4372,a);Ec(328,4372,n|0)|0;iq(4376,4372);Ec(328,4376,n|0)|0;iq(4380,4360);Ec(328,4380,n|0)|0;return}}function Lp(){c[1113]=0;c[1114]=0;c[1115]=0;Ec(329,4452,n|0)|0;c[7681]=Qi()|0;return}function Mp(){var a=0,b=0,c=0,d=0,e=0,f=0,g=0,h=0;a=i;i=i+64|0;g=a+48|0;e=a+40|0;c=a+32|0;b=a+24|0;d=a+16|0;f=a+8|0;h=a;bj(4484,106880);Ec(330,4484,n|0)|0;bj(g,572);$i(4492,g,4484);ze(g+4|0);Ec(330,4492,n|0)|0;bj(b,4096);$i(c,4492,b);bj(d,64);$i(e,c,d);bj(f,2);$i(g,e,f);bj(h,2048);$i(4500,g,h);ze(h+4|0);ze(g+4|0);ze(f+4|0);ze(e+4|0);ze(d+4|0);ze(c+4|0);ze(b+4|0);Ec(330,4500,n|0)|0;i=a;return}function Np(){FC(33384,48499,44);Ec(331,33384,n|0)|0;return}function Op(){FC(33768,48544,48);Ec(331,33768,n|0)|0;c[8393]=350;return}function Pp(){var a=0,b=0;a=Sz(20)|0;o=0;mb(111,a|0,35116,35160);b=o;o=0;if(b&1){b=cc()|0;Uz(a);bc(b|0)}else{Fq(33820,a);Ec(150,33820,n|0)|0;rz(33832,35160,35176);Ec(332,33832,n|0)|0;rz(33844,35176,35188);Ec(332,33844,n|0)|0;return}}function Qp(){rz(5128,34604,34616);Ec(332,5128,n|0)|0;rz(5140,34616,34636);Ec(332,5140,n|0)|0;sz(5152,34636,34796);Ec(333,5152,n|0)|0;sz(5164,34796,35116);Ec(333,5164,n|0)|0;return}function Rp(){rz(34160,34580,34604);Ec(332,34160,n|0)|0;return}function Sp(){Tl(27572);Ec(207,27572,n|0)|0;return}function Tp(){gm(27584,929,3);Ec(334,27584,n|0)|0;return}function Up(){Sm(27772);Ec(335,27772,n|0)|0;return}function Vp(){c[6952]=0;c[6953]=0;c[6954]=0;Ec(336,27808,n|0)|0;ln()|0;return}function Wp(){An(27820,0,0,0,0,53271);Ec(337,27820,n|0)|0;An(27844,10,12,14,0,53282);Ec(337,27844,n|0)|0;An(27868,9,11,13,0,53290);Ec(337,27868,n|0)|0;An(27892,0,0,0,0,53303);Ec(337,27892,n|0)|0;An(27916,8,16,16,0,53321);Ec(337,27916,n|0)|0;An(27940,0,0,0,0,53326);Ec(337,27940,n|0)|0;An(27964,8,10,12,0,53330);Ec(337,27964,n|0)|0;An(27988,0,0,0,0,53336);Ec(337,27988,n|0)|0;An(28012,0,0,0,0,53356);Ec(337,28012,n|0)|0;An(28036,8,10,12,0,53377);Ec(337,28036,n|0)|0;return}function Xp(){so(28112,0,1,61258);Ec(338,28112,n|0)|0;so(28132,1,0,53265);Ec(338,28132,n|0)|0;so(28152,2,3,53267);Ec(338,28152,n|0)|0;so(28172,3,2,53269);Ec(338,28172,n|0)|0;return}function Yp(){c[7175]=0;c[7176]=0;c[7177]=0;Ec(339,28700,n|0)|0;c[8619]=Oo()|0;return}function Zp(a,b){a=a|0;b=b|0;c[a>>2]=0;Ke(a,c[b>>2]|0);return}function _p(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function $p(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function aq(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function bq(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function cq(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function dq(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function eq(a,b,d){a=a|0;b=b|0;d=d|0;d=($(c[a+16>>2]|0,d)|0)+(b>>5)|0;return (c[(c[(c[a+28>>2]|0)+8>>2]|0)+(d<<2)>>2]&1<<(b&31)|0)!=0|0}function fq(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;f=i;i=i+16|0;d=f;c[a>>2]=0;e=a+4|0;c[e>>2]=0;c[a+8>>2]=0;if(b){fz(a,b);g=c[e>>2]|0;c[e>>2]=g+b;c[d>>2]=(c[a>>2]|0)+(g>>>5<<2);c[d+4>>2]=g&31;gz(d,b)}i=f;return}function gq(a){a=a|0;var b=0;b=c[a>>2]|0;if(b){Uz(b);c[a>>2]=0;c[a+8>>2]=0;c[a+4>>2]=0}return}function hq(a){a=a|0;a=c[a>>2]|0;if(a)Uz(a);return}function iq(a,b){a=a|0;b=b|0;c[a>>2]=0;jq(a,c[b>>2]|0);return}function jq(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function kq(a,b){a=a|0;b=b|0;var d=0,e=0;c[a+4>>2]=0;c[a>>2]=29772;c[a+8>>2]=0;o=0;d=qa(111,20)|0;e=o;o=0;do if(!(e&1)){o=0;ma(102,d|0,b|0);e=o;o=0;if(e&1){e=cc()|0;Uz(d);d=e;break}else{Hq(a,d);return}}else d=cc()|0;while(0);bc(d|0)}function lq(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function mq(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=29772;c[a+8>>2]=0;Hq(a,c[b+8>>2]|0);return}function nq(a){a=a|0;var b=0;c[a>>2]=29772;a=a+8|0;b=c[a>>2]|0;if(b)ye(b);c[a>>2]=0;return}function oq(a){a=a|0;fc(a|0)|0;$z()}function pq(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function qq(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function rq(a,b){a=a|0;b=b|0;var d=0,e=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;d=b+4|0;e=(c[d>>2]|0)-(c[b>>2]|0)>>2;do if(e){o=0;ma(195,a|0,e|0);e=o;o=0;if(e&1){b=cc()|0;sq(a);bc(b|0)}else{ez(a,c[b>>2]|0,c[d>>2]|0);break}}while(0);return}function sq(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;qq(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function tq(a,b){a=a|0;b=b|0;c[a>>2]=0;vq(a,c[b>>2]|0);return}function uq(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function vq(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function wq(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;uq(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function xq(a){a=a|0;var b=0,d=0,e=0;e=i;i=i+16|0;b=e;d=Sz(16)|0;o=0;wa(42,d|0,+(+(c[a+8>>2]|0)),+(+(c[a+12>>2]|0)));a=o;o=0;if(a&1){e=cc()|0;Uz(d);bc(e|0)}else{c[b>>2]=0;vq(b,d);i=e;return c[b>>2]|0}return 0}function yq(a,b){a=a|0;b=b|0;c[a>>2]=0;pq(a,c[b>>2]|0);return}function zq(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=34536;o=0;b=qa(191,b|0)|0;d=o;o=0;if(d&1){d=cc()|0;mc(d|0)}else{c[a+4>>2]=b;return}}function Aq(a){a=a|0;c[a>>2]=34536;if((c[a+4>>2]|0)!=0?(o=0,ka(340,a|0),a=o,o=0,a&1):0){a=cc()|0;mc(a|0)}return}function Bq(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Yy(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;yq(f,b);c[g>>2]=f+4;Zy(a,h);_y(h);i=j;return}function Cq(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Ty(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;tq(f,b);c[g>>2]=f+4;Uy(a,h);Vy(h);i=j;return}function Dq(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=4116;c[a+8>>2]=0;Te(a,b);return}function Eq(a,b){a=a|0;b=b|0;var d=0,e=0;d=i;i=i+16|0;e=d;c[a+4>>2]=0;c[a>>2]=34572;c[e>>2]=0;ms(a+8|0,b,e);i=d;return}function Fq(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=29772;c[a+8>>2]=0;Hq(a,b);return}function Gq(a,b){a=a|0;b=b|0;c[a>>2]=0;Le(a,c[b>>2]|0);return}function Hq(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}a=a+8|0;d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Iq(a){a=a|0;var b=0,c=0,d=0;if(!a)a=32;else{c=a<<16;d=(c|0)==0;a=d?a:c;d=d?31:15;c=a<<8;b=(c|0)==0;c=b?a:c;d=b?d:d+-8|0;b=c<<4;a=(b|0)==0;b=a?c:b;d=a?d:d+-4|0;a=b<<2;c=(a|0)==0;a=(c?d:d+-2|0)-((c?b:a)>>>30&1)|0}return a|0}function Jq(b,c){b=b|0;c=c|0;var d=0,e=0;d=i;i=i+16|0;e=d;a[e>>0]=c;b=dy(b,e,1)|0;i=d;return b|0}function Kq(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;f=i;i=i+16|0;e=f;if(!((b|0)<1|(d|0)<1)){c[a+8>>2]=b;c[a+12>>2]=d;b=b+31>>5;c[a+16>>2]=b;kq(e,$(b,d)|0);Hq(a+20|0,c[e+8>>2]|0);nq(e);i=f;return}e=Ob(8)|0;o=0;ma(103,e|0,52691);f=o;o=0;if(f&1){f=cc()|0;Nb(e|0);bc(f|0)}else Hc(e|0,240,66)}function Lq(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;i=b+32|0;JC(i,d)|0;h=b+44|0;c[h>>2]=0;j=b+48|0;g=c[j>>2]|0;if(g&8){d=a[i>>0]|0;if(!(d&1)){d=((d&255)>>>1)+(i+1)|0;c[h>>2]=d;e=i+1|0;f=i+1|0}else{d=(c[b+40>>2]|0)+(c[b+36>>2]|0)|0;c[h>>2]=d;f=c[b+40>>2]|0;e=f}c[b+8>>2]=e;c[b+12>>2]=f;c[b+16>>2]=d}if(g&16){d=a[i>>0]|0;if(!(d&1)){g=(d&255)>>>1;c[h>>2]=i+1+g;d=10;h=g}else{g=c[b+36>>2]|0;c[h>>2]=(c[b+40>>2]|0)+g;d=(c[i>>2]&-2)+-1|0;h=g}MC(i,d,0);d=a[i>>0]|0;if(!(d&1)){g=i+1|0;f=(d&255)>>>1;e=i+1|0}else{e=c[b+40>>2]|0;g=e;f=c[b+36>>2]|0}d=b+24|0;c[d>>2]=e;c[b+20>>2]=e;c[b+28>>2]=g+f;if(c[j>>2]&3)c[d>>2]=e+h}return}function Mq(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;d=c[b+48>>2]|0;do if(!(d&16))if(!(d&8)){c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;break}else{Gy(a,c[b+8>>2]|0,c[b+16>>2]|0);break}else{e=b+44|0;d=c[e>>2]|0;f=c[b+24>>2]|0;if(d>>>0<f>>>0){c[e>>2]=f;d=f}Gy(a,c[b+20>>2]|0,d)}while(0);return}function Nq(a){a=a|0;Ey(a,29924);iD(a+56|0);return}function Oq(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Pq(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;h=i;i=i+16|0;g=h+12|0;f=h;e=Ay(a,g,b)|0;d=c[e>>2]|0;if(!d){By(f,a,b);d=c[f>>2]|0;Cy(a,c[g>>2]|0,e,d);c[f>>2]=0}i=h;return d+20|0}function Qq(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;h=i;i=i+16|0;g=h+12|0;f=h;e=xy(a,g,b)|0;d=c[e>>2]|0;if(!d){zy(f,a,b);d=c[f>>2]|0;yy(a,c[g>>2]|0,e,d);c[f>>2]=0}i=h;return d+28|0}function Rq(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Sq(a,b){a=a|0;b=b|0;c[a>>2]=0;cq(a,c[b>>2]|0);return}function Tq(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=30536;c[a+8>>2]=0;iv(a,c[b+8>>2]|0);return}function Uq(a){a=a|0;var b=0;c[a>>2]=30536;a=a+8|0;b=c[a>>2]|0;if(b)ye(b);c[a>>2]=0;return}function Vq(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(196,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;wq(a);bc(d|0)}else{ty(a,b);break}}while(0);return}function Wq(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;c[a>>2]=0;f=a+4|0;c[f>>2]=0;c[a+8>>2]=0;if(b){o=0;ma(197,a|0,b|0);e=o;o=0;if(e&1){d=cc()|0;Xq(a);bc(d|0)}g=c[f>>2]|0;e=g+(b<<2)|0;a=b;b=g;while(1){c[b>>2]=c[d>>2];a=a+-1|0;if(!a)break;else b=b+4|0}c[f>>2]=e}return}function Xq(a){a=a|0;var b=0,d=0;d=c[a>>2]|0;if(d){b=a+4|0;a=c[b>>2]|0;if((a|0)!=(d|0)){do a=a+-4|0;while((a|0)!=(d|0));c[b>>2]=a}Uz(d)}return}function Yq(a,b){a=a|0;b=b|0;return dy(a,b,iC(b)|0)|0}function Zq(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function _q(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function $q(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function ar(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function br(a){a=a|0;var b=0,d=0;d=c[a>>2]|0;if(d){b=a+4|0;a=c[b>>2]|0;if((a|0)!=(d|0)){do a=a+-4|0;while((a|0)!=(d|0));c[b>>2]=a}Uz(d)}return}function cr(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;h=a+4|0;d=c[h>>2]|0;e=c[a>>2]|0;f=d-e>>2;if(f>>>0>=b>>>0){if(f>>>0>b>>>0?(g=e+(b<<2)|0,(d|0)!=(g|0)):0){do d=d+-4|0;while((d|0)!=(g|0));c[h>>2]=d}}else my(a,b-f|0);return}function dr(a,b){a=a|0;b=b|0;c[a>>2]=0;$q(a,c[b>>2]|0);return}function er(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(198,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;fr(a);bc(d|0)}else{jy(a,b);break}}while(0);return}function fr(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;ar(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function gr(b,d){b=b|0;d=d|0;var e=0,f=0;e=a[d>>0]|0;f=(e&1)==0;return dy(b,f?d+1|0:c[d+8>>2]|0,f?(e&255)>>>1:c[d+4>>2]|0)|0}function hr(a,b){a=a|0;b=b|0;var d=0,e=0;e=a+4|0;d=c[b>>2]|0;b=c[e>>2]|0;a:do if(!b)a=e;else{a=e;do{while(1){if((c[b+16>>2]|0)>>>0>=d>>>0){a=b;break}b=c[b+4>>2]|0;if(!b)break a}b=c[a>>2]|0}while((b|0)!=0)}while(0);if(!((a|0)!=(e|0)?d>>>0>=(c[a+16>>2]|0)>>>0:0))a=e;return a|0}function ir(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function jr(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function kr(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function lr(a,b){a=a|0;b=b|0;c[a>>2]=0;jr(a,c[b>>2]|0);return}function mr(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;c[a>>2]=0;f=a+4|0;c[f>>2]=0;c[a+8>>2]=0;e=b+4|0;d=(c[e>>2]|0)-(c[b>>2]|0)>>2;if(d){o=0;ma(199,a|0,d|0);d=o;o=0;if(d&1){f=cc()|0;qr(a);bc(f|0)}d=c[b>>2]|0;b=c[e>>2]|0;if((d|0)!=(b|0))do{c[c[f>>2]>>2]=c[d>>2];c[f>>2]=(c[f>>2]|0)+4;d=d+4|0}while((d|0)!=(b|0))}return}function nr(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(200,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;rr(a);bc(d|0)}else{$x(a,b);break}}while(0);return}function or(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function pr(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function qr(a){a=a|0;var b=0,d=0;d=c[a>>2]|0;if(d){b=a+4|0;a=c[b>>2]|0;if((a|0)!=(d|0)){do a=a+-4|0;while((a|0)!=(d|0));c[b>>2]=a}Uz(d)}return}function rr(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;pr(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function sr(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=34556;Pd(a+8|0,b);c[a+20>>2]=0;c[a+24>>2]=0;return}function tr(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function ur(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function vr(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0;c[b>>2]=0;h=b+4|0;c[h>>2]=0;c[b+8>>2]=0;g=d+4|0;e=c[g>>2]|0;f=c[d>>2]|0;if((e|0)!=(f|0)){o=0;ma(83,b|0,e-f|0);f=o;o=0;if(f&1){h=cc()|0;He(b);bc(h|0)}e=c[d>>2]|0;f=c[g>>2]|0;if((e|0)!=(f|0))do{a[c[h>>2]>>0]=a[e>>0]|0;c[h>>2]=(c[h>>2]|0)+1;e=e+1|0}while((e|0)!=(f|0))}return}function wr(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+32|0;j=k;h=b+4|0;e=c[b>>2]|0;g=(c[h>>2]|0)-e+1|0;if((g|0)<0)Qz(b);f=e;e=(c[b+8>>2]|0)-f|0;if(e>>>0<1073741823){e=e<<1;e=e>>>0<g>>>0?g:e}else e=2147483647;Vx(j,e,(c[h>>2]|0)-f|0,b+8|0);h=j+8|0;g=c[h>>2]|0;a[g>>0]=a[d>>0]|0;c[h>>2]=g+1;Wx(b,j);Xx(j);i=k;return}function xr(a,b){a=a|0;b=b|0;c[a>>2]=0;or(a,c[b>>2]|0);return}function yr(a){a=a|0;c[a>>2]=30684;Yd(a+16|0);kr(a+12|0);Yd(a+8|0);return}function zr(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Ar(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(201,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;Jr(a);bc(d|0)}else{Sx(a,b);break}}while(0);return}function Br(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Cr(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Dr(a,b){a=a|0;b=b|0;c[a>>2]=0;Br(a,c[b>>2]|0);return}function Er(a,b){a=a|0;b=b|0;a=Nx(a,b)|0;c[a>>2]=(c[a>>2]|0)+1;return}function Fr(a){a=a|0;var b=0;b=c[a+4>>2]|0;if(!b)while(1){b=c[a+8>>2]|0;if((c[b>>2]|0)==(a|0))break;else a=b}else while(1){a=c[b>>2]|0;if(!a)break;else b=a}return b|0}function Gr(a,b){a=a|0;b=b|0;var d=0,e=0;e=i;i=i+16|0;d=e;c[a+4>>2]=0;c[a>>2]=29756;c[d>>2]=0;vq(d,0);o=0;mb(112,a+8|0,b|0,d|0);a=o;o=0;if(a&1){e=cc()|0;uq(d);bc(e|0)}else{uq(d);i=e;return}}function Hr(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Ir(a){a=a|0;Kx(a,c[a+4>>2]|0);return}function Jr(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;Cr(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function Kr(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Lr(a,b){a=a|0;b=b|0;c[a>>2]=0;Zq(a,c[b>>2]|0);return}function Mr(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;c[a>>2]=0;e=a+4|0;c[e>>2]=0;c[a+8>>2]=0;if(b){o=0;ma(199,a|0,b|0);f=o;o=0;if(f&1){f=cc()|0;qr(a);bc(f|0)}a=c[e>>2]|0;do{c[a>>2]=c[d>>2];a=(c[e>>2]|0)+4|0;c[e>>2]=a;b=b+-1|0}while((b|0)!=0)}return}function Nr(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Gx(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;c[f>>2]=c[b>>2];c[g>>2]=f+4;Hx(a,h);Ix(h);i=j;return}function Or(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Dx(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;lr(f,b);c[g>>2]=f+4;Ex(a,h);Fx(h);i=j;return}function Pr(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;hx(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;Pe(f,b);c[g>>2]=f+4;ix(a,h);jx(h);i=j;return}function Qr(a){a=a|0;c[a>>2]=28084;ze(a+12|0);Yd(a+8|0);return}function Rr(a,b){a=a|0;b=b|0;c[a>>2]=0;_r(a,c[b>>2]|0);return}function Sr(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;zx(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;Ax(f,b);c[g>>2]=f+4;Bx(a,h);Cx(h);i=j;return}function Tr(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Ur(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;Tr(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function Vr(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;ir(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function Wr(a){a=a|0;ze(a+20|0);Zr(a+4|0);Yd(a);return}function Xr(a,b){a=a|0;b=b|0;var d=0,e=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;d=b+4|0;e=(c[d>>2]|0)-(c[b>>2]|0)>>2;do if(e){o=0;ma(202,a|0,e|0);e=o;o=0;if(e&1){b=cc()|0;Zr(a);bc(b|0)}else{yx(a,c[b>>2]|0,c[d>>2]|0);break}}while(0);return}function Yr(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;fs(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0);c[a+8>>2]=0;c[e>>2]=0;c[a>>2]=0}return}function Zr(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;fs(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function _r(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function $r(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;vx(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;Rr(f,b);c[g>>2]=f+4;wx(a,h);xx(h);i=j;return}function as(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;Zr(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function bs(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=(((c[g>>2]|0)-d|0)/12|0)+1|0;if(f>>>0>357913941)Qz(a);e=d;d=((c[a+8>>2]|0)-e|0)/12|0;if(d>>>0<178956970){d=d<<1;d=d>>>0<f>>>0?f:d}else d=357913941;sx(h,d,((c[g>>2]|0)-e|0)/12|0,a+8|0);d=h+8|0;e=c[d>>2]|0;o=0;ma(133,e|0,b|0);b=o;o=0;if(b&1){j=cc()|0;ux(h);bc(j|0)}else{c[d>>2]=e+12;tx(a,h);ux(h);i=j;return}}function cs(a,b){a=a|0;b=b|0;var d=0.0;d=+$n(c[a>>2]|0);return d-+$n(c[b>>2]|0)<0.0|0}function ds(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0;L=i;i=i+96|0;J=L+80|0;H=L+76|0;I=L+72|0;y=L+68|0;z=L+64|0;A=L+60|0;B=L+56|0;C=L+52|0;D=L+48|0;E=L+44|0;F=L+40|0;n=L+36|0;p=L+32|0;q=L+28|0;r=L+24|0;s=L+20|0;t=L+16|0;u=L+12|0;v=L+8|0;w=L+4|0;x=L;a:while(1){m=b;G=b+-4|0;b:while(1){l=a;e=m-l|0;f=e>>2;switch(f|0){case 1:case 0:{K=69;break a}case 2:{f=G;e=G;K=4;break a}case 3:{b=G;K=8;break a}case 4:{b=G;K=9;break a}case 5:{b=G;K=10;break a}default:{}}if((e|0)<28){K=12;break a}g=(f|0)/2|0;h=a+(g<<2)|0;if((e|0)>3996){f=(f|0)/4|0;f=px(a,a+(f<<2)|0,h,a+(f+g<<2)|0,G,d)|0}else f=nx(a,h,G,d)|0;e=c[d>>2]|0;es(y,a);es(z,h);o=0;e=Wa(e|0,y|0,z|0)|0;k=o;o=0;if(k&1){K=22;break a}fs(z);fs(y);do if(e)g=G;else{e=G;while(1){e=e+-4|0;if((a|0)==(e|0))break;g=c[d>>2]|0;es(q,e);es(r,h);o=0;g=Wa(g|0,q|0,r|0)|0;k=o;o=0;if(k&1){K=44;break a}fs(r);fs(q);if(g){K=43;break}}if((K|0)==43){K=0;es(J,a);hs(a,c[e>>2]|0);hs(e,c[J>>2]|0);fs(J);g=e;f=f+1|0;break}e=a+4|0;f=c[d>>2]|0;es(A,a);es(B,G);o=0;f=Wa(f|0,A|0,B|0)|0;l=o;o=0;if(l&1){K=23;break a}fs(B);fs(A);if(!f){if((e|0)==(G|0)){K=69;break a}else f=a;while(1){g=c[d>>2]|0;es(C,a);es(D,e);o=0;g=Wa(g|0,C|0,D|0)|0;l=o;o=0;if(l&1){K=27;break a}fs(D);fs(C);if(g)break;f=e+4|0;if((f|0)==(G|0)){K=69;break a}else{l=e;e=f;f=l}}es(J,e);hs(e,c[G>>2]|0);hs(G,c[J>>2]|0);fs(J);e=f+8|0}if((e|0)==(G|0)){K=69;break a}else f=G;while(1){while(1){g=c[d>>2]|0;es(E,a);es(F,e);o=0;g=Wa(g|0,E|0,F|0)|0;l=o;o=0;if(l&1){K=35;break a}fs(F);fs(E);if(g)break;e=e+4|0}do{g=c[d>>2]|0;es(n,a);f=f+-4|0;es(p,f);o=0;g=Wa(g|0,n|0,p|0)|0;l=o;o=0;if(l&1){K=38;break a}fs(p);fs(n)}while(g);if(e>>>0>=f>>>0){a=e;continue b}es(J,e);hs(e,c[f>>2]|0);hs(f,c[J>>2]|0);fs(J);e=e+4|0}}while(0);e=a+4|0;c:do if(e>>>0<g>>>0){k=g;while(1){while(1){g=c[d>>2]|0;es(s,e);es(t,h);o=0;g=Wa(g|0,s|0,t|0)|0;j=o;o=0;if(j&1){K=51;break a}fs(t);fs(s);if(!g){j=e;break}e=e+4|0}e=k;while(1){g=c[d>>2]|0;e=e+-4|0;es(u,e);es(v,h);o=0;g=Wa(g|0,u|0,v|0)|0;k=o;o=0;if(k&1){K=54;break a}fs(v);fs(u);if(g){g=e;break}}if(j>>>0>g>>>0){e=j;break c}es(J,j);hs(j,c[g>>2]|0);hs(g,c[J>>2]|0);fs(J);e=j+4|0;k=g;h=(h|0)==(j|0)?g:h;f=f+1|0}}while(0);if((e|0)!=(h|0)){g=c[d>>2]|0;es(w,h);es(x,e);o=0;g=Wa(g|0,w|0,x|0)|0;k=o;o=0;if(k&1){K=61;break a}fs(x);fs(w);if(g){es(J,e);hs(e,c[h>>2]|0);hs(h,c[J>>2]|0);fs(J);f=f+1|0}}if(!f){f=rx(a,e,d)|0;g=e+4|0;if(rx(g,b,d)|0){K=64;break}if(f){a=g;continue}}k=e;if((k-l|0)>=(m-k|0)){K=68;break}ds(a,e,d);a=e+4|0}if((K|0)==64){K=0;if(f){K=69;break}else{b=e;continue}}else if((K|0)==68){K=0;ds(e+4|0,b,d);b=e;continue}}switch(K|0){case 4:{b=c[d>>2]|0;es(H,f);es(I,a);o=0;b=Wa(b|0,H|0,I|0)|0;K=o;o=0;if(K&1){b=cc()|0;fs(I);fs(H);K=70;break}fs(I);fs(H);if(b){es(J,a);hs(a,c[e>>2]|0);hs(f,c[J>>2]|0);fs(J);K=69}else K=69;break}case 8:{nx(a,a+4|0,b,d)|0;K=69;break}case 9:{ox(a,a+4|0,a+8|0,b,d)|0;K=69;break}case 10:{px(a,a+4|0,a+8|0,a+12|0,b,d)|0;K=69;break}case 12:{qx(a,b,d);K=69;break}case 22:{b=cc()|0;fs(z);fs(y);K=70;break}case 23:{b=cc()|0;fs(B);fs(A);K=70;break}case 27:{b=cc()|0;fs(D);fs(C);K=70;break}case 35:{b=cc()|0;fs(F);fs(E);K=70;break}case 38:{b=cc()|0;fs(p);fs(n);K=70;break}case 44:{b=cc()|0;fs(r);fs(q);K=70;break}case 51:{b=cc()|0;fs(t);fs(s);K=70;break}case 54:{b=cc()|0;fs(v);fs(u);K=70;break}case 61:{b=cc()|0;fs(x);fs(w);K=70;break}}if((K|0)==69){i=L;return}else if((K|0)==70)bc(b|0)}function es(a,b){a=a|0;b=b|0;c[a>>2]=0;hs(a,c[b>>2]|0);return}function fs(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function gs(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;kx(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;es(f,b);c[g>>2]=f+4;lx(a,h);mx(h);i=j;return}function hs(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function is(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;hx(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;Pe(f,b);c[g>>2]=f+4;ix(a,h);jx(h);i=j;return}function js(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;de(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function ks(a,b){a=a|0;b=b|0;c[a>>2]=c[b>>2];xe(a+4|0,c[b+4>>2]|0);return a|0}function ls(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;dx(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;ex(f,b);c[g>>2]=f+4;fx(a,h);gx(h);i=j;return}function ms(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;c[a>>2]=0;g=a+4|0;c[g>>2]=0;c[a+8>>2]=0;if(b){o=0;ma(203,a|0,b|0);f=o;o=0;if(f&1){d=cc()|0;br(a);bc(d|0)}e=c[g>>2]|0;a=b;f=e;while(1){c[f>>2]=c[d>>2];a=a+-1|0;if(!a)break;else f=f+4|0}c[g>>2]=e+(b<<2)}return}function ns(a,b){a=a|0;b=b|0;var d=0,e=0;c[a+4>>2]=0;c[a>>2]=4116;c[a+8>>2]=0;o=0;d=qa(111,20)|0;e=o;o=0;do if(!(e&1)){o=0;ma(124,d|0,b|0);e=o;o=0;if(e&1){e=cc()|0;Uz(d);d=e;break}else{Te(a,d);return}}else d=cc()|0;while(0);bc(d|0)}function os(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function ps(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function qs(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Yv(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;c[f>>2]=c[b>>2];c[g>>2]=f+4;Zv(a,h);_v(h);i=j;return}function rs(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=34536;o=0;b=qa(191,c[b+4>>2]|0)|0;d=o;o=0;if(d&1){d=cc()|0;mc(d|0)}else{c[a+4>>2]=b;return}}function ss(a,b){a=a|0;b=b|0;var d=0,e=0;c[a>>2]=0;d=a+4|0;c[d>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(203,a|0,b|0);e=o;o=0;if(e&1){e=cc()|0;br(a);bc(e|0)}else{e=c[d>>2]|0;ZL(e|0,0,b<<2|0)|0;c[d>>2]=e+(b<<2);break}}while(0);return}function ts(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function us(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;_w(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;$w(f,b);c[g>>2]=f+4;ax(a,h);bx(h);i=j;return}function vs(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function ws(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;vs(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function xs(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function ys(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Xw(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;Bs(f,b);c[g>>2]=f+4;Yw(a,h);Zw(h);i=j;return}function zs(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function As(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;zs(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function Bs(a,b){a=a|0;b=b|0;c[a>>2]=0;xs(a,c[b>>2]|0);return}function Cs(a,b){a=a|0;b=b|0;var d=0,e=0;c[a+4>>2]=0;c[a>>2]=34504;c[a+8>>2]=0;o=0;d=qa(111,20)|0;e=o;o=0;do if(!(e&1)){o=0;ma(204,d|0,b|0);e=o;o=0;if(e&1){e=cc()|0;Uz(d);d=e;break}else{Pw(a,d);return}}else d=cc()|0;while(0);bc(d|0)}function Ds(a){a=a|0;a=c[a+8>>2]|0;if(a)Vz(a);return}function Es(a,b,d){a=a|0;b=b|0;d=d|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;c[a+12>>2]=0;o=0;mb(106,a|0,b|0,d|0);d=o;o=0;if(d&1){d=cc()|0;Ds(a+4|0);bc(d|0)}else return}function Fs(a){a=a|0;var b=0;c[a>>2]=34504;a=a+8|0;b=c[a>>2]|0;if(b)ye(b);c[a>>2]=0;return}function Gs(a,b,d){a=a|0;b=b|0;d=d|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;c[a+12>>2]=0;o=0;mb(105,a|0,b|0,d|0);d=o;o=0;if(d&1){d=cc()|0;Ds(a+4|0);bc(d|0)}else return}function Hs(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0;g=c[d>>2]|0;i=c[e>>2]|0;j=i-g|0;f=a[b>>0]|0;if(!(f&1))h=10;else{f=c[b>>2]|0;h=(f&-2)+-1|0;f=f&255}if(j>>>0>h>>>0){if(!(f&1))f=(f&255)>>>1;else f=c[b+4>>2]|0;TC(b,h,j-h|0,f,0,f,0);f=a[b>>0]|0}if(!(f&1))f=b+1|0;else f=c[b+8>>2]|0;if((g|0)!=(i|0))do{a[f>>0]=a[g>>0]|0;g=(c[d>>2]|0)+1|0;c[d>>2]=g;f=f+1|0}while((g|0)!=(c[e>>2]|0));a[f>>0]=0;if(!(a[b>>0]&1))a[b>>0]=j<<1;else c[b+4>>2]=j;return b|0}function Is(a){a=a|0;c[a>>2]=34180;nq(a+52|0);Yd(a+8|0);return}function Js(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Ks(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Ls(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Ms(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Ns(a,b){a=a|0;b=b|0;c[a>>2]=0;Ls(a,c[b>>2]|0);return}function Os(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;Ms(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function Ps(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(205,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;Os(a);bc(d|0)}else{Lw(a,b);break}}while(0);return}function Qs(a,b){a=a|0;b=b|0;if((a|0)!=(b|0))Jw(a+8|0,c[b+8>>2]|0,c[b+12>>2]|0);return a|0}function Rs(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=a+8|0;i=c[a>>2]|0;f=i;do if((c[e>>2]|0)-f>>2>>>0>=b>>>0){j=a+4|0;e=c[j>>2]|0;g=e-f>>2;h=g>>>0<b>>>0;f=h?g:b;if(f){a=i;while(1){c[a>>2]=c[d>>2];f=f+-1|0;if(!f)break;else a=a+4|0}}if(h){a=b-g|0;f=a;g=e;while(1){c[g>>2]=c[d>>2];f=f+-1|0;if(!f)break;else g=g+4|0}c[j>>2]=e+(a<<2);break}else{f=i+(b<<2)|0;if((e|0)==(f|0))break;do e=e+-4|0;while((e|0)!=(f|0));c[j>>2]=e;break}}else{Xv(a);if(b>>>0>1073741823)Qz(a);e=(c[e>>2]|0)-(c[a>>2]|0)|0;if(e>>2>>>0<536870911){e=e>>1;e=e>>>0<b>>>0?b:e}else e=1073741823;Iw(a,e);a=a+4|0;f=c[a>>2]|0;e=b;g=f;while(1){c[g>>2]=c[d>>2];e=e+-1|0;if(!e)break;else g=g+4|0}c[a>>2]=f+(b<<2)}while(0);return}function Ss(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(206,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;Us(a);bc(d|0)}else{Hw(a,b);break}}while(0);return}function Ts(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;h=a+4|0;d=c[h>>2]|0;e=c[a>>2]|0;f=d-e>>2;if(f>>>0>=b>>>0){if(f>>>0>b>>>0?(g=e+(b<<2)|0,(d|0)!=(g|0)):0){do d=d+-4|0;while((d|0)!=(g|0));c[h>>2]=d}}else Fw(a,b-f|0);return}function Us(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;Xq(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function Vs(a,b){a=a|0;b=b|0;var d=0,e=0;c[a>>2]=0;d=a+4|0;c[d>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(197,a|0,b|0);e=o;o=0;if(e&1){e=cc()|0;Xq(a);bc(e|0)}else{e=c[d>>2]|0;ZL(e|0,0,b<<2|0)|0;c[d>>2]=e+(b<<2);break}}while(0);return}function Ws(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(207,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;_s(a);bc(d|0)}else{zw(a,b);break}}while(0);return}function Xs(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;i=a+4|0;e=c[i>>2]|0;f=c[a>>2]|0;g=e-f>>2;if(g>>>0>=b>>>0){if(g>>>0>b>>>0?(h=f+(b<<2)|0,(e|0)!=(h|0)):0){do e=e+-4|0;while((e|0)!=(h|0));c[i>>2]=e}}else Cw(a,b-g|0,d);return}function Ys(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0;a[b>>0]=0;h=b+4|0;c[h>>2]=0;e=c[d>>2]|0;g=d+4|0;if((e|0)!=(g|0)){f=0;while(1){d=c[e+20>>2]|0;if((d|0)<=(f|0))if((d|0)==(f|0)){a[b>>0]=1;d=f}else d=f;else{c[h>>2]=c[e+16>>2];a[b>>0]=0}e=Fr(e)|0;if((e|0)==(g|0))break;else f=d}}return}function Zs(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;g=a+4|0;d=c[g>>2]|0;e=c[a>>2]|0;f=(d-e|0)/12|0;if(f>>>0>=b>>>0){if(f>>>0>b>>>0?(h=e+(b*12|0)|0,(d|0)!=(h|0)):0)do{a=d+-12|0;c[g>>2]=a;br(a);d=c[g>>2]|0}while((d|0)!=(h|0))}else yw(a,b-f|0);return}function _s(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;br(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function $s(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;aw(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function at(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;vw(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;c[f>>2]=c[b>>2];c[g>>2]=f+4;ww(a,h);xw(h);i=j;return}function bt(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;i=a+4|0;e=c[i>>2]|0;f=c[a>>2]|0;g=e-f>>2;if(g>>>0>=b>>>0){if(g>>>0>b>>>0?(h=f+(b<<2)|0,(e|0)!=(h|0)):0){do e=e+-4|0;while((e|0)!=(h|0));c[i>>2]=e}}else uw(a,b-g|0,d);return}function ct(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(208,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;$s(a);bc(d|0)}else{bw(a,b);break}}while(0);return}function dt(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;g=a+4|0;d=c[g>>2]|0;e=c[a>>2]|0;f=(d-e|0)/12|0;if(f>>>0>=b>>>0){if(f>>>0>b>>>0?(h=e+(b*12|0)|0,(d|0)!=(h|0)):0)do{a=d+-12|0;c[g>>2]=a;gt(a);d=c[g>>2]|0}while((d|0)!=(h|0))}else nw(a,b-f|0);return}function et(a){a=a|0;var b=0;b=a+4|0;gw(a,c[b>>2]|0);c[a+8>>2]=0;c[a>>2]=b;c[b>>2]=0;return}function ft(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;h=i;i=i+16|0;g=h+12|0;f=h;e=hw(a,g,b)|0;d=c[e>>2]|0;if(!d){iw(f,a,b);d=c[f>>2]|0;jw(a,c[g>>2]|0,e,d);c[f>>2]=0}i=h;return d+20|0}function gt(a){a=a|0;gw(a,c[a+4>>2]|0);return}function ht(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;g=a+4|0;d=c[g>>2]|0;e=c[a>>2]|0;f=(d-e|0)/12|0;if(f>>>0>=b>>>0){if(f>>>0>b>>>0?(h=e+(b*12|0)|0,(d|0)!=(h|0)):0)do{a=d+-12|0;c[g>>2]=a;aw(a);d=c[g>>2]|0}while((d|0)!=(h|0))}else $v(a,b-f|0);return}function it(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Yv(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;c[f>>2]=c[b>>2];c[g>>2]=f+4;Zv(a,h);_v(h);i=j;return}function jt(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;r=i;i=i+32|0;l=r+21|0;m=r+20|0;q=r;h=c[b>>2]|0;d=c[d>>2]|0;p=d;f=h;g=(p-f|0)/12|0;j=b+4|0;k=c[j>>2]|0;n=c[b+8>>2]|0;do if(k>>>0<n>>>0)if((d|0)==(k|0)){c[d>>2]=0;q=d+4|0;c[q>>2]=0;c[d+8>>2]=0;c[d>>2]=c[e>>2];b=e+4|0;c[q>>2]=c[b>>2];q=e+8|0;c[d+8>>2]=c[q>>2];c[q>>2]=0;c[b>>2]=0;c[e>>2]=0;c[j>>2]=(c[j>>2]|0)+12;break}else{Qv(b,d,k,h+((g+1|0)*12|0)|0);a[l>>0]=a[m>>0]|0;Rv(d,e,l);break}else{g=((k-f|0)/12|0)+1|0;if(g>>>0>357913941)Qz(b);f=(n-h|0)/12|0;if(f>>>0<178956970){f=f<<1;f=f>>>0<g>>>0?g:f}else f=357913941;Sv(q,f,(p-h|0)/12|0,b+8|0);o=0;ma(209,q|0,e|0);e=o;o=0;if(e&1){r=cc()|0;Vv(q);bc(r|0)}else{d=Uv(b,q,d)|0;Vv(q);break}}while(0);i=r;return d|0}function kt(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function lt(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function mt(a,b){a=a|0;b=b|0;c[a>>2]=0;kt(a,c[b>>2]|0);return}function nt(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;c[a>>2]=0;f=a+4|0;c[f>>2]=0;c[a+8>>2]=0;e=b+4|0;d=(c[e>>2]|0)-(c[b>>2]|0)>>2;if(d){o=0;ma(210,a|0,d|0);d=o;o=0;if(d&1){f=cc()|0;rt(a);bc(f|0)}d=c[b>>2]|0;b=c[e>>2]|0;if((d|0)!=(b|0))do{c[c[f>>2]>>2]=c[d>>2];c[f>>2]=(c[f>>2]|0)+4;d=d+4|0}while((d|0)!=(b|0))}return}function ot(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(211,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;st(a);bc(d|0)}else{Mv(a,b);break}}while(0);return}function pt(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function qt(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function rt(a){a=a|0;var b=0,d=0;d=c[a>>2]|0;if(d){b=a+4|0;a=c[b>>2]|0;if((a|0)!=(d|0)){do a=a+-4|0;while((a|0)!=(d|0));c[b>>2]=a}Uz(d)}return}function st(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;qt(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function tt(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function ut(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Fv(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;Gv(f,b);c[g>>2]=f+4;Hv(a,h);Iv(h);i=j;return}function vt(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function wt(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=(((c[g>>2]|0)-d|0)/12|0)+1|0;if(f>>>0>357913941)Qz(a);e=d;d=((c[a+8>>2]|0)-e|0)/12|0;if(d>>>0<178956970){d=d<<1;d=d>>>0<f>>>0?f:d}else d=357913941;ov(h,d,((c[g>>2]|0)-e|0)/12|0,a+8|0);g=h+8|0;f=c[g>>2]|0;Pd(f,b);c[g>>2]=f+12;pv(a,h);qv(h);i=j;return}function xt(a,b){a=a|0;b=b|0;var d=0,e=0;c[a+4>>2]=0;c[a>>2]=30536;c[a+8>>2]=0;o=0;d=qa(111,20)|0;e=o;o=0;do if(!(e&1)){o=0;ma(212,d|0,b|0);e=o;o=0;if(e&1){e=cc()|0;Uz(d);d=e;break}else{iv(a,d);return}}else d=cc()|0;while(0);bc(d|0)}function yt(a,b){a=a|0;b=b|0;c[a>>2]=0;pt(a,c[b>>2]|0);return}function zt(a){a=a|0;gv(a,c[a+4>>2]|0);return}function At(a){a=a|0;c[a>>2]=34212;lt(a+16|0);Yd(a+8|0);return}function Bt(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Ct(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Dt(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;cv(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;c[f>>2]=c[b>>2];c[g>>2]=f+4;dv(a,h);ev(h);i=j;return}function Et(a){a=a|0;var b=0,d=0;d=c[a>>2]|0;if(d){b=a+4|0;a=c[b>>2]|0;if((a|0)!=(d|0)){do a=a+-4|0;while((a|0)!=(d|0));c[b>>2]=a}Uz(d)}return}function Ft(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0;O=i;i=i+112|0;N=O+96|0;J=O+84|0;M=O+80|0;K=O+72|0;L=O+60|0;H=O+92|0;I=O+88|0;C=O+76|0;D=O+68|0;E=O+64|0;F=O+56|0;G=O+52|0;p=O+48|0;q=O+44|0;r=O+40|0;s=O+36|0;t=O+32|0;u=O+28|0;v=O+24|0;w=O+20|0;x=O+16|0;y=O+12|0;z=O+8|0;A=O+4|0;B=O;a:while(1){n=b;e=b+-4|0;b:while(1){m=a;f=n-m|0;g=f>>2;switch(g|0){case 1:case 0:{P=82;break a}case 2:{g=e;f=e;P=4;break a}case 3:{P=8;break a}case 4:{P=9;break a}case 5:{P=10;break a}default:{}}if((f|0)<28){P=12;break a}h=(g|0)/2|0;j=a+(h<<2)|0;if((f|0)>3996){f=(g|0)/4|0;f=$u(a,a+(f<<2)|0,j,a+(f+h<<2)|0,e,d)|0}else f=Zu(a,j,e,d)|0;es(C,a);es(D,j);o=0;g=ya(118,d|0,C|0,D|0)|0;l=o;o=0;if(l&1){P=35;break a}fs(D);fs(C);do if(g)g=e;else{g=e;while(1){g=g+-4|0;if((a|0)==(g|0))break;es(u,g);es(v,j);o=0;h=ya(118,d|0,u|0,v|0)|0;l=o;o=0;if(l&1){P=57;break a}fs(v);fs(u);if(h){P=56;break}}if((P|0)==56){P=0;es(N,a);hs(a,c[g>>2]|0);hs(g,c[N>>2]|0);fs(N);f=f+1|0;break}f=a+4|0;es(E,a);es(F,e);o=0;g=ya(118,d|0,E|0,F|0)|0;m=o;o=0;if(m&1){P=36;break a}fs(F);fs(E);if(!g){if((f|0)==(e|0)){P=82;break a}else g=a;while(1){es(G,a);es(p,f);o=0;h=ya(118,d|0,G|0,p|0)|0;m=o;o=0;if(m&1){P=40;break a}fs(p);fs(G);if(h)break;g=f+4|0;if((g|0)==(e|0)){P=82;break a}else{m=f;f=g;g=m}}es(N,f);hs(f,c[e>>2]|0);hs(e,c[N>>2]|0);fs(N);f=g+8|0}if((f|0)==(e|0)){P=82;break a}else g=e;while(1){while(1){es(q,a);es(r,f);o=0;h=ya(118,d|0,q|0,r|0)|0;m=o;o=0;if(m&1){P=48;break a}fs(r);fs(q);if(h)break;f=f+4|0}do{es(s,a);g=g+-4|0;es(t,g);o=0;h=ya(118,d|0,s|0,t|0)|0;m=o;o=0;if(m&1){P=51;break a}fs(t);fs(s)}while(h);if(f>>>0>=g>>>0){a=f;continue b}es(N,f);hs(f,c[g>>2]|0);hs(g,c[N>>2]|0);fs(N);f=f+4|0}}while(0);h=a+4|0;c:do if(h>>>0<g>>>0){l=j;while(1){while(1){es(w,h);es(x,l);o=0;j=ya(118,d|0,w|0,x|0)|0;k=o;o=0;if(k&1){P=64;break a}fs(x);fs(w);if(!j){k=h;break}h=h+4|0}while(1){g=g+-4|0;es(y,g);es(z,l);o=0;h=ya(118,d|0,y|0,z|0)|0;j=o;o=0;if(j&1){P=67;break a}fs(z);fs(y);if(h){j=g;break}}if(k>>>0>j>>>0){h=k;j=l;break c}es(N,k);hs(k,c[j>>2]|0);hs(j,c[N>>2]|0);fs(N);h=k+4|0;g=j;l=(l|0)==(k|0)?j:l;f=f+1|0}}while(0);if((h|0)!=(j|0)){es(A,j);es(B,h);o=0;g=ya(118,d|0,A|0,B|0)|0;l=o;o=0;if(l&1){P=74;break a}fs(B);fs(A);if(g){es(N,h);hs(h,c[j>>2]|0);hs(j,c[N>>2]|0);fs(N);f=f+1|0}}if(!f){f=av(a,h,d)|0;g=h+4|0;if(av(g,b,d)|0){P=77;break}if(f){a=g;continue}}l=h;if((l-m|0)>=(n-l|0)){e=h;P=81;break}Ft(a,h,d);a=h+4|0}if((P|0)==77){P=0;if(f){P=82;break}else{b=h;continue}}else if((P|0)==81){P=0;Ft(e+4|0,b,d);b=e;continue}}switch(P|0){case 4:{es(H,g);es(I,a);o=0;e=ya(118,d|0,H|0,I|0)|0;P=o;o=0;if(P&1){e=cc()|0;fs(I);fs(H);P=83;break}fs(I);fs(H);if(e){es(N,a);hs(a,c[f>>2]|0);hs(g,c[N>>2]|0);fs(N);P=82}else P=82;break}case 8:{Zu(a,a+4|0,e,d)|0;P=82;break}case 9:{_u(a,a+4|0,a+8|0,e,d)|0;P=82;break}case 10:{$u(a,a+4|0,a+8|0,a+12|0,e,d)|0;P=82;break}case 12:{f=a+8|0;Zu(a,a+4|0,f,d)|0;e=a+12|0;d:do if((e|0)!=(b|0)){e:while(1){es(N,e);es(J,f);o=0;g=ya(118,d|0,N|0,J|0)|0;I=o;o=0;if(I&1){P=21;break}fs(J);fs(N);if(g){es(M,e);g=e;while(1){hs(g,c[f>>2]|0);if((f|0)==(a|0)){P=17;break}c[K>>2]=0;g=c[M>>2]|0;hs(K,g);h=f+-4|0;es(L,h);o=0;j=ya(118,d|0,K|0,L|0)|0;I=o;o=0;if(I&1){P=22;break e}fs(L);fs(K);if(j){g=f;f=h}else break}if((P|0)==17){P=0;g=c[M>>2]|0;f=a}hs(f,g);fs(M)}f=e+4|0;if((f|0)==(b|0))break d;else{I=e;e=f;f=I}}if((P|0)==21){e=cc()|0;fs(J);fs(N)}else if((P|0)==22){e=cc()|0;fs(L);fs(K);fs(M)}bc(e|0)}while(0);P=82;break}case 35:{e=cc()|0;fs(D);fs(C);P=83;break}case 36:{e=cc()|0;fs(F);fs(E);P=83;break}case 40:{e=cc()|0;fs(p);fs(G);P=83;break}case 48:{e=cc()|0;fs(r);fs(q);P=83;break}case 51:{e=cc()|0;fs(t);fs(s);P=83;break}case 57:{e=cc()|0;fs(v);fs(u);P=83;break}case 64:{e=cc()|0;fs(x);fs(w);P=83;break}case 67:{e=cc()|0;fs(z);fs(y);P=83;break}case 74:{e=cc()|0;fs(B);fs(A);P=83;break}}if((P|0)==82){i=O;return}else if((P|0)==83)bc(e|0)}function Gt(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0;O=i;i=i+112|0;N=O+96|0;J=O+84|0;M=O+80|0;K=O+72|0;L=O+60|0;H=O+92|0;I=O+88|0;C=O+76|0;D=O+68|0;E=O+64|0;F=O+56|0;G=O+52|0;p=O+48|0;q=O+44|0;r=O+40|0;s=O+36|0;t=O+32|0;u=O+28|0;v=O+24|0;w=O+20|0;x=O+16|0;y=O+12|0;z=O+8|0;A=O+4|0;B=O;a:while(1){n=b;e=b+-4|0;b:while(1){m=a;f=n-m|0;g=f>>2;switch(g|0){case 1:case 0:{P=82;break a}case 2:{g=e;f=e;P=4;break a}case 3:{P=8;break a}case 4:{P=9;break a}case 5:{P=10;break a}default:{}}if((f|0)<28){P=12;break a}h=(g|0)/2|0;j=a+(h<<2)|0;if((f|0)>3996){f=(g|0)/4|0;f=Wu(a,a+(f<<2)|0,j,a+(f+h<<2)|0,e,d)|0}else f=Uu(a,j,e,d)|0;es(C,a);es(D,j);o=0;g=ya(119,d|0,C|0,D|0)|0;l=o;o=0;if(l&1){P=35;break a}fs(D);fs(C);do if(g)g=e;else{g=e;while(1){g=g+-4|0;if((a|0)==(g|0))break;es(u,g);es(v,j);o=0;h=ya(119,d|0,u|0,v|0)|0;l=o;o=0;if(l&1){P=57;break a}fs(v);fs(u);if(h){P=56;break}}if((P|0)==56){P=0;es(N,a);hs(a,c[g>>2]|0);hs(g,c[N>>2]|0);fs(N);f=f+1|0;break}f=a+4|0;es(E,a);es(F,e);o=0;g=ya(119,d|0,E|0,F|0)|0;m=o;o=0;if(m&1){P=36;break a}fs(F);fs(E);if(!g){if((f|0)==(e|0)){P=82;break a}else g=a;while(1){es(G,a);es(p,f);o=0;h=ya(119,d|0,G|0,p|0)|0;m=o;o=0;if(m&1){P=40;break a}fs(p);fs(G);if(h)break;g=f+4|0;if((g|0)==(e|0)){P=82;break a}else{m=f;f=g;g=m}}es(N,f);hs(f,c[e>>2]|0);hs(e,c[N>>2]|0);fs(N);f=g+8|0}if((f|0)==(e|0)){P=82;break a}else g=e;while(1){while(1){es(q,a);es(r,f);o=0;h=ya(119,d|0,q|0,r|0)|0;m=o;o=0;if(m&1){P=48;break a}fs(r);fs(q);if(h)break;f=f+4|0}do{es(s,a);g=g+-4|0;es(t,g);o=0;h=ya(119,d|0,s|0,t|0)|0;m=o;o=0;if(m&1){P=51;break a}fs(t);fs(s)}while(h);if(f>>>0>=g>>>0){a=f;continue b}es(N,f);hs(f,c[g>>2]|0);hs(g,c[N>>2]|0);fs(N);f=f+4|0}}while(0);h=a+4|0;c:do if(h>>>0<g>>>0){l=j;while(1){while(1){es(w,h);es(x,l);o=0;j=ya(119,d|0,w|0,x|0)|0;k=o;o=0;if(k&1){P=64;break a}fs(x);fs(w);if(!j){k=h;break}h=h+4|0}while(1){g=g+-4|0;es(y,g);es(z,l);o=0;h=ya(119,d|0,y|0,z|0)|0;j=o;o=0;if(j&1){P=67;break a}fs(z);fs(y);if(h){j=g;break}}if(k>>>0>j>>>0){h=k;j=l;break c}es(N,k);hs(k,c[j>>2]|0);hs(j,c[N>>2]|0);fs(N);h=k+4|0;g=j;l=(l|0)==(k|0)?j:l;f=f+1|0}}while(0);if((h|0)!=(j|0)){es(A,j);es(B,h);o=0;g=ya(119,d|0,A|0,B|0)|0;l=o;o=0;if(l&1){P=74;break a}fs(B);fs(A);if(g){es(N,h);hs(h,c[j>>2]|0);hs(j,c[N>>2]|0);fs(N);f=f+1|0}}if(!f){f=Xu(a,h,d)|0;g=h+4|0;if(Xu(g,b,d)|0){P=77;break}if(f){a=g;continue}}l=h;if((l-m|0)>=(n-l|0)){e=h;P=81;break}Gt(a,h,d);a=h+4|0}if((P|0)==77){P=0;if(f){P=82;break}else{b=h;continue}}else if((P|0)==81){P=0;Gt(e+4|0,b,d);b=e;continue}}switch(P|0){case 4:{es(H,g);es(I,a);o=0;e=ya(119,d|0,H|0,I|0)|0;P=o;o=0;if(P&1){e=cc()|0;fs(I);fs(H);P=83;break}fs(I);fs(H);if(e){es(N,a);hs(a,c[f>>2]|0);hs(g,c[N>>2]|0);fs(N);P=82}else P=82;break}case 8:{Uu(a,a+4|0,e,d)|0;P=82;break}case 9:{Vu(a,a+4|0,a+8|0,e,d)|0;P=82;break}case 10:{Wu(a,a+4|0,a+8|0,a+12|0,e,d)|0;P=82;break}case 12:{f=a+8|0;Uu(a,a+4|0,f,d)|0;e=a+12|0;d:do if((e|0)!=(b|0)){e:while(1){es(N,e);es(J,f);o=0;g=ya(119,d|0,N|0,J|0)|0;I=o;o=0;if(I&1){P=21;break}fs(J);fs(N);if(g){es(M,e);g=e;while(1){hs(g,c[f>>2]|0);if((f|0)==(a|0)){P=17;break}c[K>>2]=0;g=c[M>>2]|0;hs(K,g);h=f+-4|0;es(L,h);o=0;j=ya(119,d|0,K|0,L|0)|0;I=o;o=0;if(I&1){P=22;break e}fs(L);fs(K);if(j){g=f;f=h}else break}if((P|0)==17){P=0;g=c[M>>2]|0;f=a}hs(f,g);fs(M)}f=e+4|0;if((f|0)==(b|0))break d;else{I=e;e=f;f=I}}if((P|0)==21){e=cc()|0;fs(J);fs(N)}else if((P|0)==22){e=cc()|0;fs(L);fs(K);fs(M)}bc(e|0)}while(0);P=82;break}case 35:{e=cc()|0;fs(D);fs(C);P=83;break}case 36:{e=cc()|0;fs(F);fs(E);P=83;break}case 40:{e=cc()|0;fs(p);fs(G);P=83;break}case 48:{e=cc()|0;fs(r);fs(q);P=83;break}case 51:{e=cc()|0;fs(t);fs(s);P=83;break}case 57:{e=cc()|0;fs(v);fs(u);P=83;break}case 64:{e=cc()|0;fs(x);fs(w);P=83;break}case 67:{e=cc()|0;fs(z);fs(y);P=83;break}case 74:{e=cc()|0;fs(B);fs(A);P=83;break}}if((P|0)==82){i=O;return}else if((P|0)==83)bc(e|0)}function Ht(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;f=c[a>>2]|0;h=c[b>>2]|0;e=h;b=c[d>>2]|0;if((h|0)!=(b|0)){g=f+((b-e>>2)+(e-f>>2)<<2)|0;a=a+4|0;d=c[a>>2]|0;f=d;if((g|0)!=(d|0)){b=h;e=g;while(1){hs(b,c[e>>2]|0);e=e+4|0;if((e|0)==(d|0))break;else b=b+4|0}}e=h+((f-g|0)>>>2<<2)|0;b=c[a>>2]|0;if((b|0)!=(e|0))do{g=b+-4|0;c[a>>2]=g;fs(g);b=c[a>>2]|0}while((b|0)!=(e|0))}return h|0}function It(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(202,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;Zr(a);bc(d|0)}else{Su(a,b);break}}while(0);return}function Jt(a,b){a=a|0;b=b|0;c[a>>2]=0;vq(a,c[b>>2]|0);return}function Kt(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;c[a>>2]=0;e=a+4|0;c[e>>2]=0;c[a+8>>2]=0;if(b){o=0;ma(210,a|0,b|0);f=o;o=0;if(f&1){f=cc()|0;rt(a);bc(f|0)}a=c[e>>2]|0;do{c[a>>2]=c[d>>2];a=(c[e>>2]|0)+4|0;c[e>>2]=a;b=b+-1|0}while((b|0)!=0)}return}function Lt(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Ju(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;c[f>>2]=c[b>>2];c[g>>2]=f+4;Ku(a,h);Lu(h);i=j;return}function Mt(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;g=i;i=i+16|0;f=g;c[f>>2]=b;b=Sz(12)|0;o=0;ma(213,b|0,a|0);e=o;o=0;if(e&1){g=cc()|0;Uz(b);bc(g|0)}if(a){d=c[b>>2]|0;e=0;do{j=(c[f>>2]|0)+(4-1)&~(4-1);h=c[j>>2]|0;c[f>>2]=j+4;c[d+(e<<2)>>2]=h;e=e+1|0}while((e|0)!=(a|0))}i=g;return b|0}function Nt(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Ot(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;h=j;g=a+4|0;d=c[a>>2]|0;f=((c[g>>2]|0)-d>>2)+1|0;if(f>>>0>1073741823)Qz(a);e=d;d=(c[a+8>>2]|0)-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;Fu(h,d,(c[g>>2]|0)-e>>2,a+8|0);g=h+8|0;f=c[g>>2]|0;Gu(f,b);c[g>>2]=f+4;Hu(a,h);Iu(h);i=j;return}function Pt(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Qt(a,b){a=a|0;b=b|0;var d=0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;do if(b){o=0;ma(214,a|0,b|0);d=o;o=0;if(d&1){d=cc()|0;Rt(a);bc(d|0)}else{Eu(a,b);break}}while(0);return}function Rt(a){a=a|0;var b=0,d=0;d=c[a>>2]|0;if(d){b=a+4|0;a=c[b>>2]|0;if((a|0)!=(d|0)){do a=a+-4|0;while((a|0)!=(d|0));c[b>>2]=a}Uz(d)}return}function St(a,b){a=a|0;b=b|0;var d=0,e=0;if((a|0)!=(b|0)?(e=c[b+4>>2]|0,d=a+4|0,c[d>>2]=e,au(a,e),d=c[d>>2]|0,e=c[b+8>>2]|0,(d|0)!=0):0){a=c[a+8>>2]|0;b=0;do{c[a+(b<<2)>>2]=c[e+(b<<2)>>2];b=b+1|0}while((b|0)!=(d|0))}return}function Tt(a,b){a=a|0;b=b|0;var d=0,e=0;d=c[b+4>>2]|0;c[a+4>>2]=d;c[a>>2]=d;e=Tz(d>>>0>1073741823?-1:d<<2)|0;c[a+8>>2]=e;a=c[b+8>>2]|0;if(d){b=0;do{c[e+(b<<2)>>2]=c[a+(b<<2)>>2];b=b+1|0}while((b|0)!=(d|0))}return}function Ut(a,b){a=a|0;b=b|0;c[a>>2]=c[b>>2];Tt(a+4|0,b+4|0);return}function Vt(a){a=a|0;a=c[a+8>>2]|0;if(a)Vz(a);return}function Wt(a,b){a=a|0;b=b|0;var d=0;if(b){c[a>>2]=1;d=Tz(4)|0;c[a+8>>2]=d;c[a+4>>2]=1;c[d>>2]=b}return}function Xt(a,b){a=a|0;b=b|0;var d=0;if(b<<16>>16){c[a>>2]=1;d=Tz(4)|0;c[a+8>>2]=d;c[a+4>>2]=1;c[d>>2]=b&65535}return}function Yt(a,b){a=a|0;b=b|0;if((b|0)<0){b=Ob(4)|0;c[b>>2]=50897;Hc(b|0,1952,0)}else{Cu(a,b);return}}function Zt(a){a=a|0;var b=0;switch(c[a+4>>2]|0){case 0:{a=0;b=5;break}case 1:{a=c[c[a+8>>2]>>2]|0;if((a&65535|0)==(a|0)){a=a&65535;b=5}else b=4;break}default:b=4}if((b|0)==4){b=Ob(4)|0;c[b>>2]=50823;Hc(b|0,1952,0)}else if((b|0)==5)return a|0;return 0}function _t(a){a=a|0;var b=0,d=0;d=a+4|0;b=c[d>>2]|0;a:do if(b){a=c[a+8>>2]|0;do{b=b+-1|0;if(c[a+(b<<2)>>2]|0)break a;c[d>>2]=b}while((b|0)!=0)}while(0);return}function $t(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;if((c[a>>2]|0)>>>0<b>>>0){f=a+8|0;e=c[f>>2]|0;c[a>>2]=b;d=Tz(b>>>0>1073741823?-1:b<<2)|0;c[f>>2]=d;b=c[a+4>>2]|0;if(b){a=0;do{c[d+(a<<2)>>2]=c[e+(a<<2)>>2];a=a+1|0}while((a|0)!=(b|0))}if(e)Vz(e)}return}function au(a,b){a=a|0;b=b|0;var d=0,e=0;if((c[a>>2]|0)>>>0<b>>>0){d=a+8|0;e=c[d>>2]|0;if(e)Vz(e);c[a>>2]=b;c[d>>2]=Tz(b>>>0>1073741823?-1:b<<2)|0}return}function bu(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;if((b|0)==0|(d|0)==0)e=0;else e=(c[(c[a+8>>2]|0)+(b+-1<<2)>>2]|0)>>>(32-d|0);if((c[a+4>>2]|0)==(b|0))a=0;else a=c[(c[a+8>>2]|0)+(b<<2)>>2]<<d;return a|e|0}function cu(a,b){a=a|0;b=b|0;var d=0,e=0;if((c[a>>2]|0)>>>0<b>>>0){d=a+8|0;e=c[d>>2]|0;if(e)Vz(e);c[a>>2]=b;c[d>>2]=Tz(b>>>0>2147483647?-1:b<<1)|0}return}function du(a){a=a|0;a=c[a+4>>2]|0;return ((a|0)==0?61257:a)|0}function eu(a){a=a|0;c[a>>2]=4440;Yd(a+8|0);return}function fu(a){a=a|0;c[a>>2]=4440;Yd(a+8|0);Uz(a);return}function gu(a){a=a|0;c[a>>2]=4536;Vd(a+16|0);return}function hu(a){a=a|0;gu(a);Uz(a);return}function iu(a){a=a|0;c[a>>2]=4768;br(a+20|0);IC(a+8|0);il(a);return}function ju(a){a=a|0;iu(a);Uz(a);return}function ku(a){a=a|0;c[a>>2]=4824;br(a+24|0);IC(a+12|0);il(a);return}function lu(a){a=a|0;ku(a);Uz(a);return}function mu(a){a=a|0;c[a>>2]=4852;br(a+20|0);IC(a+8|0);il(a);return}function nu(a){a=a|0;mu(a);Uz(a);return}function ou(a){a=a|0;c[a>>2]=4880;br(a+20|0);Cl(a);return}function pu(a){a=a|0;ou(a);Uz(a);return}function qu(a){a=a|0;c[a>>2]=4928;br(a+20|0);Cl(a);return}function ru(a){a=a|0;qu(a);Uz(a);return}function su(a){a=a|0;c[a>>2]=5004;ws(a+8|0);il(a);return}function tu(a){a=a|0;su(a);Uz(a);return}function uu(a){a=a|0;c[a>>2]=5032;As(a+8|0);il(a);return}function vu(a){a=a|0;uu(a);Uz(a);return}function wu(a){a=a|0;c[a>>2]=5088;ou(a+20|0);Cl(a);return}function xu(a){a=a|0;wu(a);Uz(a);return}function yu(a){a=a|0;c[a>>2]=5232;br(a+20|0);Cl(a);return}function zu(a){a=a|0;yu(a);Uz(a);return}function Au(a){a=a|0;Uz(a);return}function Bu(a){a=a|0;Qr(a);Uz(a);return}function Cu(a,b){a=a|0;b=b|0;var d=0;if(b){c[a>>2]=1;d=Tz(4)|0;c[a+8>>2]=d;c[a+4>>2]=1;c[d>>2]=b}return}function Du(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Eu(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b>>2]=0;b=(c[d>>2]|0)+4|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function Fu(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Gu(a,b){a=a|0;b=b|0;c[a>>2]=0;Nt(a,c[b>>2]|0);return}function Hu(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;Gu((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function Iu(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;Pt(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function Ju(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Ku(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;e=c[a>>2]|0;g=a+4|0;d=b+4|0;f=(c[g>>2]|0)-e|0;h=(c[d>>2]|0)+(0-(f>>2)<<2)|0;c[d>>2]=h;XL(h|0,e|0,f|0)|0;f=c[a>>2]|0;c[a>>2]=c[d>>2];c[d>>2]=f;f=b+8|0;e=c[g>>2]|0;c[g>>2]=c[f>>2];c[f>>2]=e;f=a+8|0;a=b+12|0;e=c[f>>2]|0;c[f>>2]=c[a>>2];c[a>>2]=e;c[b>>2]=c[d>>2];return}function Lu(a){a=a|0;var b=0,d=0,e=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0)){do b=b+-4|0;while((b|0)!=(d|0));c[e>>2]=b}b=c[a>>2]|0;if(b)Uz(b);return}function Mu(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Nu(a){a=a|0;return}function Ou(a){a=a|0;Uz(a);return}function Pu(a){a=a|0;c[a>>2]=34452;fs(a+16|0);fs(a+12|0);fs(a+8|0);return}function Qu(a){a=a|0;Pu(a);Uz(a);return}function Ru(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Su(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b>>2]=0;hs(b,0);b=(c[d>>2]|0)+4|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function Tu(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0.0,h=0.0;e=_n(c[b>>2]|0)|0;e=(e|0)==(_n(c[d>>2]|0)|0);b=c[b>>2]|0;if(e){h=+$n(b);h=+O(+(h-+g[a>>2]));f=+$n(c[d>>2]|0);b=h<+O(+(f-+g[a>>2]))}else{b=_n(b)|0;b=(b|0)>(_n(c[d>>2]|0)|0)}return b|0}function Uu(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;t=i;i=i+48|0;s=t+40|0;f=t+36|0;g=t+32|0;j=t+28|0;k=t+24|0;n=t+20|0;p=t+16|0;l=t+12|0;m=t+8|0;q=t+4|0;r=t;es(f,b);es(g,a);o=0;h=ya(119,e|0,f|0,g|0)|0;u=o;o=0;a:do if(u&1){u=cc()|0;fs(g);fs(f);f=u}else{fs(g);fs(f);do if(h){es(l,d);es(m,b);o=0;f=ya(119,e|0,l|0,m|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(m);fs(l);break a}fs(m);fs(l);if(f){es(s,a);hs(a,c[d>>2]|0);hs(d,c[s>>2]|0);fs(s);f=1;break}es(s,a);hs(a,c[b>>2]|0);hs(b,c[s>>2]|0);fs(s);es(q,d);es(r,b);o=0;f=ya(119,e|0,q|0,r|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(r);fs(q);break a}fs(r);fs(q);if(f){es(s,b);hs(b,c[d>>2]|0);hs(d,c[s>>2]|0);fs(s);f=2}else f=1}else{es(j,d);es(k,b);o=0;f=ya(119,e|0,j|0,k|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(k);fs(j);break a}fs(k);fs(j);if(f){es(s,b);hs(b,c[d>>2]|0);hs(d,c[s>>2]|0);fs(s);es(n,b);es(p,a);o=0;f=ya(119,e|0,n|0,p|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(p);fs(n);break a}fs(p);fs(n);if(f){es(s,a);hs(a,c[b>>2]|0);hs(b,c[s>>2]|0);fs(s);f=2}else f=1}else f=0}while(0);i=t;return f|0}while(0);bc(f|0);return 0}function Vu(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;r=i;i=i+32|0;q=r+24|0;g=r+20|0;h=r+16|0;k=r+12|0;l=r+8|0;m=r+4|0;n=r;p=Uu(a,b,d,f)|0;es(g,e);es(h,d);o=0;j=ya(119,f|0,g|0,h|0)|0;s=o;o=0;do if(s&1){s=cc()|0;fs(h);fs(g);g=s}else{fs(h);fs(g);if(j){es(q,d);hs(d,c[e>>2]|0);hs(e,c[q>>2]|0);fs(q);es(k,d);es(l,b);o=0;h=ya(119,f|0,k|0,l|0)|0;s=o;o=0;if(s&1){g=cc()|0;fs(l);fs(k);break}g=p+1|0;fs(l);fs(k);if(h){es(q,b);hs(b,c[d>>2]|0);hs(d,c[q>>2]|0);fs(q);es(m,b);es(n,a);o=0;g=ya(119,f|0,m|0,n|0)|0;s=o;o=0;if(s&1){g=cc()|0;fs(n);fs(m);break}fs(n);fs(m);if(g){es(q,a);hs(a,c[b>>2]|0);hs(b,c[q>>2]|0);fs(q);g=p+3|0}else g=p+2|0}}else g=p;i=r;return g|0}while(0);bc(g|0);return 0}function Wu(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;u=i;i=i+48|0;t=u+32|0;h=u+28|0;j=u+24|0;l=u+20|0;m=u+16|0;n=u+12|0;p=u+8|0;q=u+4|0;r=u;s=Vu(a,b,d,e,g)|0;es(h,f);es(j,e);o=0;k=ya(119,g|0,h|0,j|0)|0;v=o;o=0;do if(v&1){v=cc()|0;fs(j);fs(h);h=v}else{fs(j);fs(h);if(k){es(t,e);hs(e,c[f>>2]|0);hs(f,c[t>>2]|0);fs(t);es(l,e);es(m,d);o=0;j=ya(119,g|0,l|0,m|0)|0;v=o;o=0;if(v&1){h=cc()|0;fs(m);fs(l);break}h=s+1|0;fs(m);fs(l);if(j){es(t,d);hs(d,c[e>>2]|0);hs(e,c[t>>2]|0);fs(t);es(n,d);es(p,b);o=0;j=ya(119,g|0,n|0,p|0)|0;v=o;o=0;if(v&1){h=cc()|0;fs(p);fs(n);break}h=s+2|0;fs(p);fs(n);if(j){es(t,b);hs(b,c[d>>2]|0);hs(d,c[t>>2]|0);fs(t);es(q,b);es(r,a);o=0;h=ya(119,g|0,q|0,r|0)|0;v=o;o=0;if(v&1){h=cc()|0;fs(r);fs(q);break}fs(r);fs(q);if(h){es(t,a);hs(a,c[b>>2]|0);hs(b,c[t>>2]|0);fs(t);h=s+4|0}else h=s+3|0}}}else h=s;i=u;return h|0}while(0);bc(h|0);return 0}function Xu(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;t=i;i=i+32|0;j=t+28|0;g=t+24|0;h=t+20|0;m=t+16|0;n=t+12|0;r=t+8|0;p=t+4|0;q=t;a:do switch(b-a>>2|0){case 1:case 0:{e=1;s=21;break}case 2:{f=b+-4|0;es(g,f);es(h,a);o=0;e=ya(119,d|0,g|0,h|0)|0;s=o;o=0;if(s&1){e=cc()|0;fs(h);fs(g);s=22;break a}fs(h);fs(g);if(e){es(j,a);hs(a,c[f>>2]|0);hs(f,c[j>>2]|0);fs(j);e=1;s=21}else{e=1;s=21}break}case 3:{Uu(a,a+4|0,b+-4|0,d)|0;e=1;s=21;break}case 4:{Vu(a,a+4|0,a+8|0,b+-4|0,d)|0;e=1;s=21;break}case 5:{Wu(a,a+4|0,a+8|0,a+12|0,b+-4|0,d)|0;e=1;s=21;break}default:{g=a+8|0;Uu(a,a+4|0,g,d)|0;f=a+12|0;if((f|0)!=(b|0)){e=0;l=0;b:while(1){es(m,f);es(n,g);o=0;h=ya(119,d|0,m|0,n|0)|0;k=o;o=0;if(k&1){s=18;break}fs(n);fs(m);if(h){es(r,f);h=f;while(1){hs(h,c[g>>2]|0);if((g|0)==(a|0)){s=14;break}c[p>>2]=0;h=c[r>>2]|0;hs(p,h);j=g+-4|0;es(q,j);o=0;k=ya(119,d|0,p|0,q|0)|0;u=o;o=0;if(u&1){s=19;break b}fs(q);fs(p);if(k){h=g;g=j}else break}if((s|0)==14){s=0;h=c[r>>2]|0;g=a}hs(g,h);g=l+1|0;j=(g|0)==8;k=f+4|0;e=j?(k|0)==(b|0):e;fs(r);if(j){s=21;break a}else{h=g;g=j?k:f}}else{h=l;g=f}f=g+4|0;if((f|0)==(b|0)){e=1;s=21;break a}else l=h}if((s|0)==18){e=cc()|0;fs(n);fs(m);s=22;break a}else if((s|0)==19){e=cc()|0;fs(q);fs(p);fs(r);s=22;break a}}else{e=1;s=21}}}while(0);if((s|0)==21){i=t;return e|0}else if((s|0)==22)bc(e|0);return 0}function Yu(a,b,d){a=a|0;b=b|0;d=d|0;var e=0.0,f=0.0;f=+$n(c[b>>2]|0);f=+O(+(f-+g[a>>2]));e=+$n(c[d>>2]|0);return f>+O(+(e-+g[a>>2]))|0}function Zu(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;t=i;i=i+48|0;s=t+40|0;f=t+36|0;g=t+32|0;j=t+28|0;k=t+24|0;n=t+20|0;p=t+16|0;l=t+12|0;m=t+8|0;q=t+4|0;r=t;es(f,b);es(g,a);o=0;h=ya(118,e|0,f|0,g|0)|0;u=o;o=0;a:do if(u&1){u=cc()|0;fs(g);fs(f);f=u}else{fs(g);fs(f);do if(h){es(l,d);es(m,b);o=0;f=ya(118,e|0,l|0,m|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(m);fs(l);break a}fs(m);fs(l);if(f){es(s,a);hs(a,c[d>>2]|0);hs(d,c[s>>2]|0);fs(s);f=1;break}es(s,a);hs(a,c[b>>2]|0);hs(b,c[s>>2]|0);fs(s);es(q,d);es(r,b);o=0;f=ya(118,e|0,q|0,r|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(r);fs(q);break a}fs(r);fs(q);if(f){es(s,b);hs(b,c[d>>2]|0);hs(d,c[s>>2]|0);fs(s);f=2}else f=1}else{es(j,d);es(k,b);o=0;f=ya(118,e|0,j|0,k|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(k);fs(j);break a}fs(k);fs(j);if(f){es(s,b);hs(b,c[d>>2]|0);hs(d,c[s>>2]|0);fs(s);es(n,b);es(p,a);o=0;f=ya(118,e|0,n|0,p|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(p);fs(n);break a}fs(p);fs(n);if(f){es(s,a);hs(a,c[b>>2]|0);hs(b,c[s>>2]|0);fs(s);f=2}else f=1}else f=0}while(0);i=t;return f|0}while(0);bc(f|0);return 0}function _u(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;r=i;i=i+32|0;q=r+24|0;g=r+20|0;h=r+16|0;k=r+12|0;l=r+8|0;m=r+4|0;n=r;p=Zu(a,b,d,f)|0;es(g,e);es(h,d);o=0;j=ya(118,f|0,g|0,h|0)|0;s=o;o=0;do if(s&1){s=cc()|0;fs(h);fs(g);g=s}else{fs(h);fs(g);if(j){es(q,d);hs(d,c[e>>2]|0);hs(e,c[q>>2]|0);fs(q);es(k,d);es(l,b);o=0;h=ya(118,f|0,k|0,l|0)|0;s=o;o=0;if(s&1){g=cc()|0;fs(l);fs(k);break}g=p+1|0;fs(l);fs(k);if(h){es(q,b);hs(b,c[d>>2]|0);hs(d,c[q>>2]|0);fs(q);es(m,b);es(n,a);o=0;g=ya(118,f|0,m|0,n|0)|0;s=o;o=0;if(s&1){g=cc()|0;fs(n);fs(m);break}fs(n);fs(m);if(g){es(q,a);hs(a,c[b>>2]|0);hs(b,c[q>>2]|0);fs(q);g=p+3|0}else g=p+2|0}}else g=p;i=r;return g|0}while(0);bc(g|0);return 0}function $u(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;u=i;i=i+48|0;t=u+32|0;h=u+28|0;j=u+24|0;l=u+20|0;m=u+16|0;n=u+12|0;p=u+8|0;q=u+4|0;r=u;s=_u(a,b,d,e,g)|0;es(h,f);es(j,e);o=0;k=ya(118,g|0,h|0,j|0)|0;v=o;o=0;do if(v&1){v=cc()|0;fs(j);fs(h);h=v}else{fs(j);fs(h);if(k){es(t,e);hs(e,c[f>>2]|0);hs(f,c[t>>2]|0);fs(t);es(l,e);es(m,d);o=0;j=ya(118,g|0,l|0,m|0)|0;v=o;o=0;if(v&1){h=cc()|0;fs(m);fs(l);break}h=s+1|0;fs(m);fs(l);if(j){es(t,d);hs(d,c[e>>2]|0);hs(e,c[t>>2]|0);fs(t);es(n,d);es(p,b);o=0;j=ya(118,g|0,n|0,p|0)|0;v=o;o=0;if(v&1){h=cc()|0;fs(p);fs(n);break}h=s+2|0;fs(p);fs(n);if(j){es(t,b);hs(b,c[d>>2]|0);hs(d,c[t>>2]|0);fs(t);es(q,b);es(r,a);o=0;h=ya(118,g|0,q|0,r|0)|0;v=o;o=0;if(v&1){h=cc()|0;fs(r);fs(q);break}fs(r);fs(q);if(h){es(t,a);hs(a,c[b>>2]|0);hs(b,c[t>>2]|0);fs(t);h=s+4|0}else h=s+3|0}}}else h=s;i=u;return h|0}while(0);bc(h|0);return 0}function av(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;t=i;i=i+32|0;j=t+28|0;g=t+24|0;h=t+20|0;m=t+16|0;n=t+12|0;r=t+8|0;p=t+4|0;q=t;a:do switch(b-a>>2|0){case 1:case 0:{e=1;s=21;break}case 2:{f=b+-4|0;es(g,f);es(h,a);o=0;e=ya(118,d|0,g|0,h|0)|0;s=o;o=0;if(s&1){e=cc()|0;fs(h);fs(g);s=22;break a}fs(h);fs(g);if(e){es(j,a);hs(a,c[f>>2]|0);hs(f,c[j>>2]|0);fs(j);e=1;s=21}else{e=1;s=21}break}case 3:{Zu(a,a+4|0,b+-4|0,d)|0;e=1;s=21;break}case 4:{_u(a,a+4|0,a+8|0,b+-4|0,d)|0;e=1;s=21;break}case 5:{$u(a,a+4|0,a+8|0,a+12|0,b+-4|0,d)|0;e=1;s=21;break}default:{g=a+8|0;Zu(a,a+4|0,g,d)|0;f=a+12|0;if((f|0)!=(b|0)){e=0;l=0;b:while(1){es(m,f);es(n,g);o=0;h=ya(118,d|0,m|0,n|0)|0;k=o;o=0;if(k&1){s=18;break}fs(n);fs(m);if(h){es(r,f);h=f;while(1){hs(h,c[g>>2]|0);if((g|0)==(a|0)){s=14;break}c[p>>2]=0;h=c[r>>2]|0;hs(p,h);j=g+-4|0;es(q,j);o=0;k=ya(118,d|0,p|0,q|0)|0;u=o;o=0;if(u&1){s=19;break b}fs(q);fs(p);if(k){h=g;g=j}else break}if((s|0)==14){s=0;h=c[r>>2]|0;g=a}hs(g,h);g=l+1|0;j=(g|0)==8;k=f+4|0;e=j?(k|0)==(b|0):e;fs(r);if(j){s=21;break a}else{h=g;g=j?k:f}}else{h=l;g=f}f=g+4|0;if((f|0)==(b|0)){e=1;s=21;break a}else l=h}if((s|0)==18){e=cc()|0;fs(n);fs(m);s=22;break a}else if((s|0)==19){e=cc()|0;fs(q);fs(p);fs(r);s=22;break a}}else{e=1;s=21}}}while(0);if((s|0)==21){i=t;return e|0}else if((s|0)==22)bc(e|0);return 0}function bv(a){a=a|0;Uz(a);return}function cv(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function dv(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;e=c[a>>2]|0;g=a+4|0;d=b+4|0;f=(c[g>>2]|0)-e|0;h=(c[d>>2]|0)+(0-(f>>2)<<2)|0;c[d>>2]=h;XL(h|0,e|0,f|0)|0;f=c[a>>2]|0;c[a>>2]=c[d>>2];c[d>>2]=f;f=b+8|0;e=c[g>>2]|0;c[g>>2]=c[f>>2];c[f>>2]=e;f=a+8|0;a=b+12|0;e=c[f>>2]|0;c[f>>2]=c[a>>2];c[a>>2]=e;c[b>>2]=c[d>>2];return}function ev(a){a=a|0;var b=0,d=0,e=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0)){do b=b+-4|0;while((b|0)!=(d|0));c[e>>2]=b}b=c[a>>2]|0;if(b)Uz(b);return}function fv(a){a=a|0;Uz(a);return}function gv(a,b){a=a|0;b=b|0;if(!b)return;else{gv(a,c[b>>2]|0);gv(a,c[b+4>>2]|0);IC(b+20|0);Uz(b);return}}function hv(a,b){a=a|0;b=b|0;var d=0,e=0;e=i;i=i+16|0;d=e;c[a+4>>2]=0;c[a>>2]=34488;c[d+4>>2]=0;c[d>>2]=4084;c[d+8>>2]=0;o=0;mb(113,a+8|0,b|0,d|0);a=o;o=0;if(a&1){e=cc()|0;Sd(d);bc(e|0)}else{Sd(d);i=e;return}}function iv(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}a=a+8|0;d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function jv(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;c[a>>2]=0;e=a+4|0;c[e>>2]=0;c[a+8>>2]=0;if(b){o=0;ma(215,a|0,b|0);f=o;o=0;if(f&1){f=cc()|0;lv(a);bc(f|0)}a=c[e>>2]|0;do{Pd(a,d);a=(c[e>>2]|0)+12|0;c[e>>2]=a;b=b+-1|0}while((b|0)!=0)}return}function kv(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>357913941)Qz(a);else{d=Sz(b*12|0)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b*12|0);return}}function lv(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;_c[c[c[f>>2]>>2]&511](f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function mv(a){a=a|0;c[a>>2]=34488;lv(a+8|0);return}function nv(a){a=a|0;c[a>>2]=34488;lv(a+8|0);Uz(a);return}function ov(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b*12|0)|0;c[a>>2]=e;d=e+(d*12|0)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b*12|0);return}function pv(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-12|0;Pd((c[g>>2]|0)+-12|0,d);c[g>>2]=(c[g>>2]|0)+-12}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function qv(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;_c[c[c[f>>2]>>2]&511](f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function rv(a){a=a|0;Uz(a);return}function sv(a,b,c){a=a|0;b=b|0;c=c|0;return (c+b+((($(c,b)|0)>>>0)%3|0)&1|0)==0|0}function tv(a){a=a|0;Uz(a);return}function uv(a,b,c){a=a|0;b=b|0;c=c|0;c=$(c,b)|0;return (((c>>>0)%3|0)+c&1|0)==0|0}function vv(a){a=a|0;Uz(a);return}function wv(a,b,c){a=a|0;b=b|0;c=c|0;c=$(c,b)|0;return (c&1|0)==(0-((c>>>0)%3|0)|0)|0}function xv(a){a=a|0;Uz(a);return}function yv(a,b,c){a=a|0;b=b|0;c=c|0;return (((c>>>0)/3|0)+(b>>>1)&1|0)==0|0}function zv(a){a=a|0;Uz(a);return}function Av(a,b,c){a=a|0;b=b|0;c=c|0;return (((c+b|0)>>>0)%3|0|0)==0|0}function Bv(a){a=a|0;Uz(a);return}function Cv(a,b,c){a=a|0;b=b|0;c=c|0;return ((c>>>0)%3|0|0)==0|0}function Dv(a){a=a|0;Uz(a);return}function Ev(a,b,c){a=a|0;b=b|0;c=c|0;return (b&1|0)==0|0}function Fv(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Gv(a,b){a=a|0;b=b|0;c[a>>2]=0;tt(a,c[b>>2]|0);return}function Hv(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;Gv((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function Iv(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;vt(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function Jv(a){a=a|0;Uz(a);return}function Kv(a,b,c){a=a|0;b=b|0;c=c|0;return (c+b&1|0)==0|0}function Lv(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Mv(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b>>2]=0;pt(b,0);b=(c[d>>2]|0)+4|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function Nv(a){a=a|0;c[a>>2]=34228;Sd(a+12|0);return}function Ov(a){a=a|0;c[a>>2]=34228;Sd(a+12|0);Uz(a);return}function Pv(a){a=a|0;At(a);Uz(a);return}function Qv(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;n=i;i=i+16|0;l=n+1|0;m=n;h=b+4|0;g=c[h>>2]|0;b=d+(((g-f|0)/12|0)*12|0)|0;if(b>>>0<e>>>0){j=g;k=b;do{c[j>>2]=0;p=j+4|0;c[p>>2]=0;c[j+8>>2]=0;c[j>>2]=c[k>>2];o=k+4|0;c[p>>2]=c[o>>2];p=k+8|0;c[j+8>>2]=c[p>>2];c[p>>2]=0;c[o>>2]=0;c[k>>2]=0;k=k+12|0;j=(c[h>>2]|0)+12|0;c[h>>2]=j}while(k>>>0<e>>>0)}if((g|0)!=(f|0))do{g=g+-12|0;b=b+-12|0;a[l>>0]=a[m>>0]|0;Rv(g,b,l)}while((b|0)!=(d|0));i=n;return}function Rv(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;Xv(a);c[a>>2]=c[b>>2];d=b+4|0;c[a+4>>2]=c[d>>2];e=b+8|0;c[a+8>>2]=c[e>>2];c[e>>2]=0;c[d>>2]=0;c[b>>2]=0;return}function Sv(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b*12|0)|0;c[a>>2]=e;d=e+(d*12|0)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b*12|0);return}function Tv(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;q=i;i=i+48|0;m=q+32|0;l=q+28|0;j=q+8|0;f=q+4|0;g=q;p=b+8|0;e=c[p>>2]|0;h=b+12|0;do if((e|0)==(c[h>>2]|0)){n=b+4|0;o=c[n>>2]|0;k=c[b>>2]|0;if(o>>>0<=k>>>0){e=(e|0)==(k|0)?1:((e-k|0)/12|0)<<1;Sv(j,e,e>>>2,c[b+16>>2]|0);c[f>>2]=c[n>>2];c[g>>2]=c[p>>2];c[l>>2]=c[f>>2];c[m>>2]=c[g>>2];Wv(j,l,m);e=c[b>>2]|0;c[b>>2]=c[j>>2];c[j>>2]=e;e=j+4|0;o=c[n>>2]|0;c[n>>2]=c[e>>2];c[e>>2]=o;e=j+8|0;o=c[p>>2]|0;c[p>>2]=c[e>>2];c[e>>2]=o;e=j+12|0;o=c[h>>2]|0;c[h>>2]=c[e>>2];c[e>>2]=o;Vv(j);e=c[p>>2]|0;break}b=o;h=(((b-k|0)/12|0)+1|0)/-2|0;j=e;if((o|0)!=(e|0)){f=o+(h*12|0)|0;g=o;while(1){a[m>>0]=a[l>>0]|0;Rv(f,g,m);g=g+12|0;if((g|0)==(e|0))break;else f=f+12|0}}e=o+(((((j-b|0)>>>0)/12|0)+h|0)*12|0)|0;c[p>>2]=e;c[n>>2]=(c[n>>2]|0)+(h*12|0)}while(0);c[e>>2]=0;n=e+4|0;c[n>>2]=0;c[e+8>>2]=0;c[e>>2]=c[d>>2];o=d+4|0;c[n>>2]=c[o>>2];n=d+8|0;c[e+8>>2]=c[n>>2];c[n>>2]=0;c[o>>2]=0;c[d>>2]=0;c[p>>2]=(c[p>>2]|0)+12;i=q;return}function Uv(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;i=b+4|0;j=c[i>>2]|0;f=c[a>>2]|0;if((f|0)!=(d|0)){e=d;g=j;do{h=g+-12|0;k=e;e=e+-12|0;c[h>>2]=0;l=g+-8|0;c[l>>2]=0;c[g+-4>>2]=0;c[h>>2]=c[e>>2];h=k+-8|0;c[l>>2]=c[h>>2];k=k+-4|0;c[g+-4>>2]=c[k>>2];c[k>>2]=0;c[h>>2]=0;c[e>>2]=0;g=(c[i>>2]|0)+-12|0;c[i>>2]=g}while((e|0)!=(f|0))}f=a+4|0;g=c[f>>2]|0;h=b+8|0;if((g|0)!=(d|0)){e=d;do{d=c[h>>2]|0;c[d>>2]=0;k=d+4|0;c[k>>2]=0;c[d+8>>2]=0;c[d>>2]=c[e>>2];l=e+4|0;c[k>>2]=c[l>>2];k=e+8|0;c[d+8>>2]=c[k>>2];c[k>>2]=0;c[l>>2]=0;c[e>>2]=0;e=e+12|0;c[h>>2]=(c[h>>2]|0)+12}while((e|0)!=(g|0))}l=c[a>>2]|0;c[a>>2]=c[i>>2];c[i>>2]=l;l=c[f>>2]|0;c[f>>2]=c[h>>2];c[h>>2]=l;a=a+8|0;l=b+12|0;k=c[a>>2]|0;c[a>>2]=c[l>>2];c[l>>2]=k;c[b>>2]=c[i>>2];return j|0}function Vv(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;br(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function Wv(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=c[d>>2]|0;a=a+8|0;d=c[b>>2]|0;if((d|0)!=(e|0))do{h=c[a>>2]|0;c[h>>2]=0;g=h+4|0;c[g>>2]=0;c[h+8>>2]=0;c[h>>2]=c[d>>2];f=d+4|0;c[g>>2]=c[f>>2];g=d+8|0;c[h+8>>2]=c[g>>2];c[g>>2]=0;c[f>>2]=0;c[d>>2]=0;c[a>>2]=(c[a>>2]|0)+12;d=d+12|0;c[b>>2]=d}while((d|0)!=(e|0));return}function Xv(a){a=a|0;var b=0,d=0,e=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0)){do b=b+-4|0;while((b|0)!=(d|0));c[e>>2]=b}Uz(d);c[a+8>>2]=0;c[e>>2]=0;c[a>>2]=0}return}function Yv(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Zv(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;e=c[a>>2]|0;g=a+4|0;d=b+4|0;f=(c[g>>2]|0)-e|0;h=(c[d>>2]|0)+(0-(f>>2)<<2)|0;c[d>>2]=h;XL(h|0,e|0,f|0)|0;f=c[a>>2]|0;c[a>>2]=c[d>>2];c[d>>2]=f;f=b+8|0;e=c[g>>2]|0;c[g>>2]=c[f>>2];c[f>>2]=e;f=a+8|0;a=b+12|0;e=c[f>>2]|0;c[f>>2]=c[a>>2];c[a>>2]=e;c[b>>2]=c[d>>2];return}function _v(a){a=a|0;var b=0,d=0,e=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0)){do b=b+-4|0;while((b|0)!=(d|0));c[e>>2]=b}b=c[a>>2]|0;if(b)Uz(b);return}function $v(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+32|0;j=k;f=c[a+8>>2]|0;h=a+4|0;d=c[h>>2]|0;if(((f-d|0)/12|0)>>>0<b>>>0){e=c[a>>2]|0;g=((d-e|0)/12|0)+b|0;if(g>>>0>357913941)Qz(a);d=(f-e|0)/12|0;if(d>>>0<178956970){d=d<<1;d=d>>>0<g>>>0?g:d}else d=357913941;cw(j,d,((c[h>>2]|0)-e|0)/12|0,a+8|0);dw(j,b);ew(a,j);fw(j)}else bw(a,b);i=k;return}function aw(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;gt(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function bw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;e=a+4|0;d=c[e>>2]|0;a=b;f=d;while(1){c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;a=a+-1|0;if(!a)break;else f=f+12|0}c[e>>2]=d+(b*12|0);return}function cw(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b*12|0)|0;c[a>>2]=e;d=e+(d*12|0)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b*12|0);return}function dw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;e=a+8|0;d=c[e>>2]|0;a=b;f=d;while(1){c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;a=a+-1|0;if(!a)break;else f=f+12|0}c[e>>2]=d+(b*12|0);return}function ew(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{j=c[g>>2]|0;h=j+-12|0;i=d;d=d+-12|0;c[h>>2]=0;k=j+-8|0;c[k>>2]=0;c[j+-4>>2]=0;c[h>>2]=c[d>>2];h=i+-8|0;c[k>>2]=c[h>>2];i=i+-4|0;c[j+-4>>2]=c[i>>2];c[i>>2]=0;c[h>>2]=0;c[d>>2]=0;c[g>>2]=(c[g>>2]|0)+-12}while((d|0)!=(e|0));i=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=i;i=b+8|0;k=c[f>>2]|0;c[f>>2]=c[i>>2];c[i>>2]=k;i=a+8|0;k=b+12|0;j=c[i>>2]|0;c[i>>2]=c[k>>2];c[k>>2]=j;c[b>>2]=c[g>>2];return}function fw(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;aw(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function gw(a,b){a=a|0;b=b|0;if(!b)return;else{gw(a,c[b>>2]|0);gw(a,c[b+4>>2]|0);Uz(b);return}}function hw(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;a=a+4|0;e=c[a>>2]|0;do if(e){f=c[d>>2]|0;while(1){a=c[e+16>>2]|0;if((f|0)<(a|0)){a=c[e>>2]|0;if(!a){a=e;d=5;break}}else{if((a|0)>=(f|0)){a=e;d=10;break}a=e+4|0;d=c[a>>2]|0;if(!d){d=9;break}else a=d}e=a}if((d|0)==5){c[b>>2]=e;break}else if((d|0)==9){c[b>>2]=e;break}else if((d|0)==10){c[b>>2]=a;a=b;break}}else c[b>>2]=a;while(0);return a|0}function iw(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;e=Sz(24)|0;c[e+16>>2]=c[d>>2];c[e+20>>2]=0;c[a>>2]=e;a=a+4|0;c[a>>2]=b+4;c[a+4>>2]=257;return}function jw(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=b;c[d>>2]=e;b=c[a>>2]|0;if(c[b>>2]|0){c[a>>2]=c[b>>2];e=c[d>>2]|0}kw(c[a+4>>2]|0,e);a=a+8|0;c[a>>2]=(c[a>>2]|0)+1;return}function kw(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;a[d+12>>0]=(d|0)==(b|0)&1;a:do if((d|0)!=(b|0)){while(1){e=c[d+8>>2]|0;i=e+12|0;if(a[i>>0]|0)break a;f=e+8|0;h=d;d=c[f>>2]|0;g=c[d>>2]|0;if((g|0)==(e|0)){g=c[d+4>>2]|0;if(!g){g=h;h=7;break}g=g+12|0;if(a[g>>0]|0){g=h;h=7;break}a[i>>0]=1;a[d+12>>0]=(d|0)==(b|0)&1;a[g>>0]=1}else{if(!g){g=h;h=14;break}g=g+12|0;if(a[g>>0]|0){g=h;h=14;break}a[i>>0]=1;a[d+12>>0]=(d|0)==(b|0)&1;a[g>>0]=1}if((d|0)==(b|0))break a}if((h|0)==7){if((c[e>>2]|0)!=(g|0)){lw(e);d=c[f>>2]|0;e=d;d=c[d+8>>2]|0}a[e+12>>0]=1;a[d+12>>0]=0;mw(d);break}else if((h|0)==14){if((c[e>>2]|0)==(g|0)){mw(e);d=c[f>>2]|0;e=d;d=c[d+8>>2]|0}a[e+12>>0]=1;a[d+12>>0]=0;lw(d);break}}while(0);return}function lw(a){a=a|0;var b=0,d=0,e=0;d=a+4|0;e=c[d>>2]|0;b=c[e>>2]|0;c[d>>2]=b;if(b)c[b+8>>2]=a;b=a+8|0;c[e+8>>2]=c[b>>2];d=c[b>>2]|0;if((c[d>>2]|0)==(a|0))c[d>>2]=e;else c[d+4>>2]=e;c[e>>2]=a;c[b>>2]=e;return}function mw(a){a=a|0;var b=0,d=0,e=0,f=0;e=c[a>>2]|0;f=e+4|0;b=c[f>>2]|0;c[a>>2]=b;if(b)c[b+8>>2]=a;b=a+8|0;c[e+8>>2]=c[b>>2];d=c[b>>2]|0;if((c[d>>2]|0)==(a|0))c[d>>2]=e;else c[d+4>>2]=e;c[f>>2]=a;c[b>>2]=e;return}function nw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+32|0;j=k;f=c[a+8>>2]|0;h=a+4|0;d=c[h>>2]|0;if(((f-d|0)/12|0)>>>0<b>>>0){e=c[a>>2]|0;g=((d-e|0)/12|0)+b|0;if(g>>>0>357913941)Qz(a);d=(f-e|0)/12|0;if(d>>>0<178956970){d=d<<1;d=d>>>0<g>>>0?g:d}else d=357913941;pw(j,d,((c[h>>2]|0)-e|0)/12|0,a+8|0);f=j+8|0;e=c[f>>2]|0;d=b;g=e;while(1){c[g+4>>2]=0;c[g+8>>2]=0;c[g>>2]=g+4;d=d+-1|0;if(!d)break;else g=g+12|0}c[f>>2]=e+(b*12|0);qw(a,j);rw(j)}else ow(a,b);i=k;return}function ow(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b+4>>2]=0;c[b+8>>2]=0;c[b>>2]=b+4;b=(c[d>>2]|0)+12|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function pw(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b*12|0)|0;c[a>>2]=e;d=e+(d*12|0)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b*12|0);return}function qw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-12|0;sw((c[g>>2]|0)+-12|0,d);c[g>>2]=(c[g>>2]|0)+-12}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function rw(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;gt(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function sw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;c[a>>2]=c[b>>2];d=c[b+4>>2]|0;c[a+4>>2]=d;e=b+8|0;g=c[e>>2]|0;c[a+8>>2]=g;f=a+4|0;if(!g)c[a>>2]=f;else{c[d+8>>2]=f;g=b+4|0;c[b>>2]=g;c[g>>2]=0;c[e>>2]=0}return}function tw(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>357913941)Qz(a);else{d=Sz(b*12|0)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b*12|0);return}}function uw(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;l=i;i=i+32|0;k=l;h=c[a+8>>2]|0;j=a+4|0;e=c[j>>2]|0;f=e;if(h-f>>2>>>0<b>>>0){e=c[a>>2]|0;f=(f-e>>2)+b|0;if(f>>>0>1073741823)Qz(a);g=e;e=h-g|0;if(e>>2>>>0<536870911){e=e>>1;e=e>>>0<f>>>0?f:e}else e=1073741823;vw(k,e,(c[j>>2]|0)-g>>2,a+8|0);f=k+8|0;e=c[f>>2]|0;g=e+(b<<2)|0;while(1){c[e>>2]=c[d>>2];b=b+-1|0;if(!b)break;else e=e+4|0}c[f>>2]=g;ww(a,k);xw(k)}else{f=e+(b<<2)|0;while(1){c[e>>2]=c[d>>2];b=b+-1|0;if(!b)break;else e=e+4|0}c[j>>2]=f}i=l;return}function vw(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function ww(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;e=c[a>>2]|0;g=a+4|0;d=b+4|0;f=(c[g>>2]|0)-e|0;h=(c[d>>2]|0)+(0-(f>>2)<<2)|0;c[d>>2]=h;XL(h|0,e|0,f|0)|0;f=c[a>>2]|0;c[a>>2]=c[d>>2];c[d>>2]=f;f=b+8|0;e=c[g>>2]|0;c[g>>2]=c[f>>2];c[f>>2]=e;f=a+8|0;a=b+12|0;e=c[f>>2]|0;c[f>>2]=c[a>>2];c[a>>2]=e;c[b>>2]=c[d>>2];return}function xw(a){a=a|0;var b=0,d=0,e=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0)){do b=b+-4|0;while((b|0)!=(d|0));c[e>>2]=b}b=c[a>>2]|0;if(b)Uz(b);return}function yw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+32|0;j=k;f=c[a+8>>2]|0;h=a+4|0;d=c[h>>2]|0;if(((f-d|0)/12|0)>>>0<b>>>0){e=c[a>>2]|0;g=((d-e|0)/12|0)+b|0;if(g>>>0>357913941)Qz(a);d=(f-e|0)/12|0;if(d>>>0<178956970){d=d<<1;d=d>>>0<g>>>0?g:d}else d=357913941;Sv(j,d,((c[h>>2]|0)-e|0)/12|0,a+8|0);Aw(j,b);Bw(a,j);Vv(j)}else zw(a,b);i=k;return}function zw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;e=a+4|0;d=c[e>>2]|0;a=b;f=d;while(1){c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;a=a+-1|0;if(!a)break;else f=f+12|0}c[e>>2]=d+(b*12|0);return}function Aw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;e=a+8|0;d=c[e>>2]|0;a=b;f=d;while(1){c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;a=a+-1|0;if(!a)break;else f=f+12|0}c[e>>2]=d+(b*12|0);return}function Bw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{j=c[g>>2]|0;h=j+-12|0;i=d;d=d+-12|0;c[h>>2]=0;k=j+-8|0;c[k>>2]=0;c[j+-4>>2]=0;c[h>>2]=c[d>>2];h=i+-8|0;c[k>>2]=c[h>>2];i=i+-4|0;c[j+-4>>2]=c[i>>2];c[i>>2]=0;c[h>>2]=0;c[d>>2]=0;c[g>>2]=(c[g>>2]|0)+-12}while((d|0)!=(e|0));i=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=i;i=b+8|0;k=c[f>>2]|0;c[f>>2]=c[i>>2];c[i>>2]=k;i=a+8|0;k=b+12|0;j=c[i>>2]|0;c[i>>2]=c[k>>2];c[k>>2]=j;c[b>>2]=c[g>>2];return}function Cw(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;l=i;i=i+32|0;k=l;h=c[a+8>>2]|0;j=a+4|0;g=c[j>>2]|0;f=g;if(h-f>>2>>>0<b>>>0){e=c[a>>2]|0;f=(f-e>>2)+b|0;if(f>>>0>1073741823)Qz(a);g=e;e=h-g|0;if(e>>2>>>0<536870911){e=e>>1;e=e>>>0<f>>>0?f:e}else e=1073741823;Yv(k,e,(c[j>>2]|0)-g>>2,a+8|0);g=k+8|0;f=c[g>>2]|0;e=b;h=f;while(1){c[h>>2]=c[d>>2];e=e+-1|0;if(!e)break;else h=h+4|0}c[g>>2]=f+(b<<2);Zv(a,k);_v(k)}else{e=b;f=g;while(1){c[f>>2]=c[d>>2];e=e+-1|0;if(!e)break;else f=f+4|0}c[j>>2]=g+(b<<2)}i=l;return}function Dw(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>357913941)Qz(a);else{d=Sz(b*12|0)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b*12|0);return}}function Ew(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Fw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+32|0;j=k;g=c[a+8>>2]|0;h=a+4|0;d=c[h>>2]|0;e=d;if(g-e>>2>>>0<b>>>0){d=c[a>>2]|0;e=(e-d>>2)+b|0;if(e>>>0>1073741823)Qz(a);f=d;d=g-f|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<e>>>0?e:d}else d=1073741823;vw(j,d,(c[h>>2]|0)-f>>2,a+8|0);h=j+8|0;g=c[h>>2]|0;ZL(g|0,0,b<<2|0)|0;c[h>>2]=g+(b<<2);ww(a,j);xw(j)}else{ZL(d|0,0,b<<2|0)|0;c[h>>2]=d+(b<<2)}i=k;return}function Gw(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>357913941)Qz(a);else{d=Sz(b*12|0)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b*12|0);return}}function Hw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;e=a+4|0;d=c[e>>2]|0;a=b;f=d;while(1){c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;a=a+-1|0;if(!a)break;else f=f+12|0}c[e>>2]=d+(b*12|0);return}function Iw(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Jw(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;g=b;h=d-g>>2;e=a+8|0;i=c[a>>2]|0;f=i;do if(h>>>0>(c[e>>2]|0)-f>>2>>>0){Xv(a);if(h>>>0>1073741823)Qz(a);e=(c[e>>2]|0)-(c[a>>2]|0)|0;if(e>>2>>>0<536870911){e=e>>1;e=e>>>0<h>>>0?h:e}else e=1073741823;Iw(a,e);f=a+4|0;if((b|0)!=(d|0)){e=c[f>>2]|0;do{c[e>>2]=c[b>>2];e=e+4|0;b=b+4|0}while((b|0)!=(d|0));c[f>>2]=e}}else{a=a+4|0;e=(c[a>>2]|0)-f>>2;h=h>>>0>e>>>0;e=h?b+(e<<2)|0:d;g=e-g|0;YL(i|0,b|0,g|0)|0;b=i+(g>>2<<2)|0;if(!h){e=c[a>>2]|0;if((e|0)==(b|0))break;do e=e+-4|0;while((e|0)!=(b|0));c[a>>2]=e;break}if((e|0)!=(d|0)){b=e;e=c[a>>2]|0;do{c[e>>2]=c[b>>2];e=e+4|0;b=b+4|0}while((b|0)!=(d|0));c[a>>2]=e}}while(0);return}function Kw(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Lw(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b>>2]=0;Ls(b,0);b=(c[d>>2]|0)+4|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function Mw(a){a=a|0;Uz(a);return}function Nw(a){a=a|0;Fs(a);Uz(a);return}function Ow(a,b){a=a|0;b=b|0;var d=0,e=0;e=i;i=i+16|0;d=e;c[a+4>>2]=0;c[a>>2]=34520;c[d>>2]=0;c[d+4>>2]=0;c[d+8>>2]=0;c[d+12>>2]=0;o=0;mb(114,a+8|0,b|0,d|0);a=o;o=0;if(a&1){e=cc()|0;Ds(d+4|0);bc(e|0)}else{Ds(d+4|0);i=e;return}}function Pw(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}a=a+8|0;d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Qw(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;c[a>>2]=0;f=a+4|0;c[f>>2]=0;c[a+8>>2]=0;a:do if(b){o=0;ma(216,a|0,b|0);e=o;o=0;if(e&1)b=cc()|0;else{e=c[f>>2]|0;while(1){o=0;ma(217,e|0,d|0);e=o;o=0;if(e&1)break;e=(c[f>>2]|0)+16|0;c[f>>2]=e;b=b+-1|0;if(!b)break a}b=cc()|0}Sw(a);bc(b|0)}while(0);return}function Rw(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>268435455)Qz(a);else{d=Sz(b<<4)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<4);return}}function Sw(a){a=a|0;var b=0,d=0,e=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{c[e>>2]=b+-16;Ds(b+-12|0);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function Tw(a){a=a|0;c[a>>2]=34520;Sw(a+8|0);return}function Uw(a){a=a|0;c[a>>2]=34520;Sw(a+8|0);Uz(a);return}function Vw(a){a=a|0;Is(a);Uz(a);return}function Ww(a){a=a|0;Uz(a);return}function Xw(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Yw(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;Bs((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function Zw(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;zs(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function _w(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function $w(a,b){a=a|0;b=b|0;c[a>>2]=0;ts(a,c[b>>2]|0);return}function ax(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;$w((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function bx(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;vs(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function cx(a){a=a|0;Aq(a);Uz(a);return}function dx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function ex(a,b){a=a|0;b=b|0;c[a>>2]=0;Me(a,c[b>>2]|0);return}function fx(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;ex((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function gx(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;de(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function hx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function ix(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;Pe((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function jx(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;be(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function kx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function lx(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;es((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function mx(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;fs(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function nx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;t=i;i=i+48|0;s=t+40|0;f=t+36|0;g=t+32|0;j=t+28|0;k=t+24|0;n=t+20|0;p=t+16|0;l=t+12|0;m=t+8|0;q=t+4|0;r=t;h=c[e>>2]|0;es(f,b);es(g,a);o=0;h=Wa(h|0,f|0,g|0)|0;u=o;o=0;a:do if(u&1){u=cc()|0;fs(g);fs(f);f=u}else{fs(g);fs(f);f=c[e>>2]|0;do if(h){es(l,d);es(m,b);o=0;f=Wa(f|0,l|0,m|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(m);fs(l);break a}fs(m);fs(l);if(f){es(s,a);hs(a,c[d>>2]|0);hs(d,c[s>>2]|0);fs(s);f=1;break}es(s,a);hs(a,c[b>>2]|0);hs(b,c[s>>2]|0);fs(s);f=c[e>>2]|0;es(q,d);es(r,b);o=0;f=Wa(f|0,q|0,r|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(r);fs(q);break a}fs(r);fs(q);if(f){es(s,b);hs(b,c[d>>2]|0);hs(d,c[s>>2]|0);fs(s);f=2}else f=1}else{es(j,d);es(k,b);o=0;f=Wa(f|0,j|0,k|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(k);fs(j);break a}fs(k);fs(j);if(f){es(s,b);hs(b,c[d>>2]|0);hs(d,c[s>>2]|0);fs(s);f=c[e>>2]|0;es(n,b);es(p,a);o=0;f=Wa(f|0,n|0,p|0)|0;u=o;o=0;if(u&1){f=cc()|0;fs(p);fs(n);break a}fs(p);fs(n);if(f){es(s,a);hs(a,c[b>>2]|0);hs(b,c[s>>2]|0);fs(s);f=2}else f=1}else f=0}while(0);i=t;return f|0}while(0);bc(f|0);return 0}function ox(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;r=i;i=i+32|0;q=r+24|0;g=r+20|0;h=r+16|0;k=r+12|0;l=r+8|0;m=r+4|0;n=r;p=nx(a,b,d,f)|0;j=c[f>>2]|0;es(g,e);es(h,d);o=0;j=Wa(j|0,g|0,h|0)|0;s=o;o=0;do if(s&1){s=cc()|0;fs(h);fs(g);g=s}else{fs(h);fs(g);if(j){es(q,d);hs(d,c[e>>2]|0);hs(e,c[q>>2]|0);fs(q);h=c[f>>2]|0;es(k,d);es(l,b);o=0;h=Wa(h|0,k|0,l|0)|0;s=o;o=0;if(s&1){g=cc()|0;fs(l);fs(k);break}g=p+1|0;fs(l);fs(k);if(h){es(q,b);hs(b,c[d>>2]|0);hs(d,c[q>>2]|0);fs(q);g=c[f>>2]|0;es(m,b);es(n,a);o=0;g=Wa(g|0,m|0,n|0)|0;s=o;o=0;if(s&1){g=cc()|0;fs(n);fs(m);break}fs(n);fs(m);if(g){es(q,a);hs(a,c[b>>2]|0);hs(b,c[q>>2]|0);fs(q);g=p+3|0}else g=p+2|0}}else g=p;i=r;return g|0}while(0);bc(g|0);return 0}function px(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;u=i;i=i+48|0;t=u+32|0;h=u+28|0;j=u+24|0;l=u+20|0;m=u+16|0;n=u+12|0;p=u+8|0;q=u+4|0;r=u;s=ox(a,b,d,e,g)|0;k=c[g>>2]|0;es(h,f);es(j,e);o=0;k=Wa(k|0,h|0,j|0)|0;v=o;o=0;do if(v&1){v=cc()|0;fs(j);fs(h);h=v}else{fs(j);fs(h);if(k){es(t,e);hs(e,c[f>>2]|0);hs(f,c[t>>2]|0);fs(t);j=c[g>>2]|0;es(l,e);es(m,d);o=0;j=Wa(j|0,l|0,m|0)|0;v=o;o=0;if(v&1){h=cc()|0;fs(m);fs(l);break}h=s+1|0;fs(m);fs(l);if(j){es(t,d);hs(d,c[e>>2]|0);hs(e,c[t>>2]|0);fs(t);j=c[g>>2]|0;es(n,d);es(p,b);o=0;j=Wa(j|0,n|0,p|0)|0;v=o;o=0;if(v&1){h=cc()|0;fs(p);fs(n);break}h=s+2|0;fs(p);fs(n);if(j){es(t,b);hs(b,c[d>>2]|0);hs(d,c[t>>2]|0);fs(t);h=c[g>>2]|0;es(q,b);es(r,a);o=0;h=Wa(h|0,q|0,r|0)|0;v=o;o=0;if(v&1){h=cc()|0;fs(r);fs(q);break}fs(r);fs(q);if(h){es(t,a);hs(a,c[b>>2]|0);hs(b,c[t>>2]|0);fs(t);h=s+4|0}else h=s+3|0}}}else h=s;i=u;return h|0}while(0);bc(h|0);return 0}function qx(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;q=i;i=i+32|0;k=q+16|0;l=q+12|0;p=q+8|0;m=q+4|0;n=q;f=a+8|0;nx(a,a+4|0,f,d)|0;e=a+12|0;a:do if((e|0)!=(b|0)){j=e;b:while(1){e=c[d>>2]|0;es(k,j);es(l,f);o=0;e=Wa(e|0,k|0,l|0)|0;h=o;o=0;if(h&1){r=10;break}fs(l);fs(k);if(e){es(p,j);e=j;while(1){hs(e,c[f>>2]|0);if((f|0)==(a|0)){r=6;break}h=c[d>>2]|0;c[m>>2]=0;e=c[p>>2]|0;hs(m,e);g=f+-4|0;es(n,g);o=0;h=Wa(h|0,m|0,n|0)|0;s=o;o=0;if(s&1){r=11;break b}fs(n);fs(m);if(h){e=f;f=g}else break}if((r|0)==6){r=0;e=c[p>>2]|0;f=a}hs(f,e);fs(p)}e=j+4|0;if((e|0)==(b|0))break a;else{f=j;j=e}}if((r|0)==10){e=cc()|0;fs(l);fs(k)}else if((r|0)==11){e=cc()|0;fs(n);fs(m);fs(p)}bc(e|0)}while(0);i=q;return}function rx(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;t=i;i=i+32|0;j=t+28|0;g=t+24|0;h=t+20|0;m=t+16|0;n=t+12|0;r=t+8|0;p=t+4|0;q=t;a:do switch(b-a>>2|0){case 1:case 0:{e=1;s=21;break}case 2:{f=c[d>>2]|0;e=b+-4|0;es(g,e);es(h,a);o=0;f=Wa(f|0,g|0,h|0)|0;s=o;o=0;if(s&1){e=cc()|0;fs(h);fs(g);s=22;break a}fs(h);fs(g);if(f){es(j,a);hs(a,c[e>>2]|0);hs(e,c[j>>2]|0);fs(j);e=1;s=21}else{e=1;s=21}break}case 3:{nx(a,a+4|0,b+-4|0,d)|0;e=1;s=21;break}case 4:{ox(a,a+4|0,a+8|0,b+-4|0,d)|0;e=1;s=21;break}case 5:{px(a,a+4|0,a+8|0,a+12|0,b+-4|0,d)|0;e=1;s=21;break}default:{g=a+8|0;nx(a,a+4|0,g,d)|0;f=a+12|0;if((f|0)!=(b|0)){e=0;l=0;b:while(1){h=c[d>>2]|0;es(m,f);es(n,g);o=0;h=Wa(h|0,m|0,n|0)|0;k=o;o=0;if(k&1){s=18;break}fs(n);fs(m);if(h){es(r,f);h=f;while(1){hs(h,c[g>>2]|0);if((g|0)==(a|0)){s=14;break}k=c[d>>2]|0;c[p>>2]=0;h=c[r>>2]|0;hs(p,h);j=g+-4|0;es(q,j);o=0;k=Wa(k|0,p|0,q|0)|0;u=o;o=0;if(u&1){s=19;break b}fs(q);fs(p);if(k){h=g;g=j}else break}if((s|0)==14){s=0;h=c[r>>2]|0;g=a}hs(g,h);g=l+1|0;j=(g|0)==8;k=f+4|0;e=j?(k|0)==(b|0):e;fs(r);if(j){s=21;break a}else{h=g;g=j?k:f}}else{h=l;g=f}f=g+4|0;if((f|0)==(b|0)){e=1;s=21;break a}else l=h}if((s|0)==18){e=cc()|0;fs(n);fs(m);s=22;break a}else if((s|0)==19){e=cc()|0;fs(q);fs(p);fs(r);s=22;break a}}else{e=1;s=21}}}while(0);if((s|0)==21){i=t;return e|0}else if((s|0)==22)bc(e|0);return 0}function sx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b*12|0)|0;c[a>>2]=e;d=e+(d*12|0)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b*12|0);return}function tx(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{j=c[g>>2]|0;h=j+-12|0;i=d;d=d+-12|0;c[h>>2]=0;k=j+-8|0;c[k>>2]=0;c[j+-4>>2]=0;c[h>>2]=c[d>>2];h=i+-8|0;c[k>>2]=c[h>>2];i=i+-4|0;c[j+-4>>2]=c[i>>2];c[i>>2]=0;c[h>>2]=0;c[d>>2]=0;c[g>>2]=(c[g>>2]|0)+-12}while((d|0)!=(e|0));i=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=i;i=b+8|0;k=c[f>>2]|0;c[f>>2]=c[i>>2];c[i>>2]=k;i=a+8|0;k=b+12|0;j=c[i>>2]|0;c[i>>2]=c[k>>2];c[k>>2]=j;c[b>>2]=c[g>>2];return}function ux(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-12|0;c[e>>2]=f;Zr(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function vx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function wx(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;Rr((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function xx(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;Tr(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function yx(a,b,d){a=a|0;b=b|0;d=d|0;a=a+4|0;if((b|0)!=(d|0))do{es(c[a>>2]|0,b);c[a>>2]=(c[a>>2]|0)+4;b=b+4|0}while((b|0)!=(d|0));return}function zx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Ax(a,b){a=a|0;b=b|0;c[a>>2]=0;Hr(a,c[b>>2]|0);return}function Bx(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;Ax((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function Cx(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;ir(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function Dx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Ex(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;lr((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function Fx(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;kr(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function Gx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Hx(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;e=c[a>>2]|0;g=a+4|0;d=b+4|0;f=(c[g>>2]|0)-e|0;h=(c[d>>2]|0)+(0-(f>>2)<<2)|0;c[d>>2]=h;XL(h|0,e|0,f|0)|0;f=c[a>>2]|0;c[a>>2]=c[d>>2];c[d>>2]=f;f=b+8|0;e=c[g>>2]|0;c[g>>2]=c[f>>2];c[f>>2]=e;f=a+8|0;a=b+12|0;e=c[f>>2]|0;c[f>>2]=c[a>>2];c[a>>2]=e;c[b>>2]=c[d>>2];return}function Ix(a){a=a|0;var b=0,d=0,e=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0)){do b=b+-4|0;while((b|0)!=(d|0));c[e>>2]=b}b=c[a>>2]|0;if(b)Uz(b);return}function Jx(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Kx(a,b){a=a|0;b=b|0;if(!b)return;else{Kx(a,c[b>>2]|0);Kx(a,c[b+4>>2]|0);uq(b+16|0);Uz(b);return}}function Lx(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;c[a>>2]=0;e=a+4|0;c[e>>2]=0;c[a+8>>2]=0;if(b){o=0;ma(196,a|0,b|0);f=o;o=0;if(f&1){f=cc()|0;wq(a);bc(f|0)}a=c[e>>2]|0;do{tq(a,d);a=(c[e>>2]|0)+4|0;c[e>>2]=a;b=b+-1|0}while((b|0)!=0)}return}function Mx(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Nx(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;h=i;i=i+16|0;g=h+12|0;f=h;e=Ox(a,g,b)|0;d=c[e>>2]|0;if(!d){Px(f,a,b);d=c[f>>2]|0;Qx(a,c[g>>2]|0,e,d);c[f>>2]=0}i=h;return d+20|0}function Ox(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;a=a+4|0;e=c[a>>2]|0;do if(e){f=c[d>>2]|0;while(1){a=c[e+16>>2]|0;if(f>>>0<a>>>0){a=c[e>>2]|0;if(!a){a=e;d=5;break}}else{if(a>>>0>=f>>>0){a=e;d=10;break}a=e+4|0;d=c[a>>2]|0;if(!d){d=9;break}else a=d}e=a}if((d|0)==5){c[b>>2]=e;break}else if((d|0)==9){c[b>>2]=e;break}else if((d|0)==10){c[b>>2]=a;a=b;break}}else c[b>>2]=a;while(0);return a|0}function Px(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;e=Sz(24)|0;tq(e+16|0,d);c[e+20>>2]=0;c[a>>2]=e;a=a+4|0;c[a>>2]=b+4;c[a+4>>2]=257;return}function Qx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=b;c[d>>2]=e;b=c[a>>2]|0;if(c[b>>2]|0){c[a>>2]=c[b>>2];e=c[d>>2]|0}kw(c[a+4>>2]|0,e);a=a+8|0;c[a>>2]=(c[a>>2]|0)+1;return}function Rx(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Sx(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b>>2]=0;Br(b,0);b=(c[d>>2]|0)+4|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function Tx(a){a=a|0;c[a>>2]=30716;uq(a+12|0);uq(a+8|0);return}function Ux(a){a=a|0;Tx(a);Uz(a);return}function Vx(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b)|0;c[a>>2]=e;d=e+d|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+b;return}function Wx(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;e=c[a>>2]|0;g=a+4|0;d=b+4|0;f=(c[g>>2]|0)-e|0;h=(c[d>>2]|0)+(0-f)|0;c[d>>2]=h;XL(h|0,e|0,f|0)|0;f=c[a>>2]|0;c[a>>2]=c[d>>2];c[d>>2]=f;f=b+8|0;e=c[g>>2]|0;c[g>>2]=c[f>>2];c[f>>2]=e;f=a+8|0;a=b+12|0;e=c[f>>2]|0;c[f>>2]=c[a>>2];c[a>>2]=e;c[b>>2]=c[d>>2];return}function Xx(a){a=a|0;var b=0,d=0,e=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0)){do b=b+-1|0;while((b|0)!=(d|0));c[e>>2]=b}Uz(c[a>>2]|0);return}function Yx(a){a=a|0;c[a>>2]=34556;Sd(a+8|0);return}function Zx(a){a=a|0;c[a>>2]=34556;Sd(a+8|0);Uz(a);return}function _x(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function $x(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b>>2]=0;or(b,0);b=(c[d>>2]|0)+4|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function ay(a){a=a|0;c[a>>2]=30700;Sd(a+12|0);return}function by(a){a=a|0;c[a>>2]=30700;Sd(a+12|0);Uz(a);return}function cy(a){a=a|0;yr(a);Uz(a);return}function dy(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;q=i;i=i+32|0;j=q+16|0;n=q+8|0;k=q;o=0;ma(218,n|0,b|0);m=o;o=0;a:do if(m&1){e=cc(0)|0;f=b;g=b;p=15}else{do if(a[n>>0]|0){f=c[(c[b>>2]|0)+-12>>2]|0;c[k>>2]=c[b+(f+24)>>2];l=b+f|0;m=c[b+(f+4)>>2]|0;g=d+e|0;f=b+(f+76)|0;e=c[f>>2]|0;do if((e|0)==-1){o=0;e=qa(192,l|0)|0;r=o;o=0;if(r&1)p=13;else{c[j>>2]=e;o=0;e=Wa(115,j|0,40904)|0;r=o;o=0;if(!(r&1)?(o=0,h=Wa(c[(c[e>>2]|0)+28>>2]|0,e|0,32)|0,r=o,o=0,!(r&1)):0){aI(j);e=h<<24>>24;c[f>>2]=e;p=9;break}e=cc(0)|0;aI(j)}}else p=9;while(0);if((p|0)==9){o=0;c[j>>2]=c[k>>2];e=oa(83,j|0,d|0,((m&176|0)==32?g:d)|0,g|0,l|0,e&255|0)|0;r=o;o=0;if(!(r&1)){if(e)break;r=c[(c[b>>2]|0)+-12>>2]|0;o=0;ma(146,b+r|0,c[b+(r+16)>>2]|5|0);r=o;o=0;if(!(r&1))break;else p=13}else p=13}if((p|0)==13)e=cc(0)|0;KD(n);f=b;g=b;p=15;break a}while(0);KD(n)}while(0);do if((p|0)==15){fc(e|0)|0;o=0;ka(341,f+(c[(c[g>>2]|0)+-12>>2]|0)|0);r=o;o=0;if(!(r&1)){$b();break}e=cc()|0;o=0;ob(44);r=o;o=0;if(r&1){r=cc(0)|0;oq(r)}else bc(e|0)}while(0);i=q;return b|0}function ey(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0;p=i;i=i+16|0;n=p;j=c[b>>2]|0;a:do if(!j)j=0;else{q=d;l=f-q|0;m=g+12|0;k=c[m>>2]|0;l=(k|0)>(l|0)?k-l|0:0;k=e;g=k-q|0;if((g|0)>0?(fd[c[(c[j>>2]|0)+48>>2]&127](j,d,g)|0)!=(g|0):0){c[b>>2]=0;j=0;break}do if((l|0)>0){GC(n,l,h);o=0;g=ya(c[(c[j>>2]|0)+48>>2]|0,j|0,((a[n>>0]&1)==0?n+1|0:c[n+8>>2]|0)|0,l|0)|0;q=o;o=0;if(q&1){q=cc()|0;IC(n);bc(q|0)}if((g|0)==(l|0)){IC(n);break}else{c[b>>2]=0;IC(n);j=0;break a}}while(0);f=f-k|0;if((f|0)>0?(fd[c[(c[j>>2]|0)+48>>2]&127](j,e,f)|0)!=(f|0):0){c[b>>2]=0;j=0;break}c[m>>2]=0}while(0);i=p;return j|0}function fy(a){a=a|0;c[a>>2]=30668;IC(a+8|0);return}function gy(a){a=a|0;c[a>>2]=30668;IC(a+8|0);Uz(a);return}function hy(a){a=a|0;Aq(a);Uz(a);return}function iy(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function jy(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b>>2]=0;$q(b,0);b=(c[d>>2]|0)+4|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function ky(a){a=a|0;c[a>>2]=30632;nq(a+12|0);return}function ly(a){a=a|0;c[a>>2]=30632;nq(a+12|0);Uz(a);return}function my(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+32|0;j=k;g=c[a+8>>2]|0;h=a+4|0;d=c[h>>2]|0;e=d;if(g-e>>2>>>0<b>>>0){d=c[a>>2]|0;e=(e-d>>2)+b|0;if(e>>>0>1073741823)Qz(a);f=d;d=g-f|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<e>>>0?e:d}else d=1073741823;Yv(j,d,(c[h>>2]|0)-f>>2,a+8|0);h=j+8|0;g=c[h>>2]|0;ZL(g|0,0,b<<2|0)|0;c[h>>2]=g+(b<<2);Zv(a,j);_v(j)}else{ZL(d|0,0,b<<2|0)|0;c[h>>2]=d+(b<<2)}i=k;return}function ny(a){a=a|0;c[a>>2]=30616;ar(a+36|0);ar(a+32|0);br(a+20|0);br(a+8|0);return}function oy(a){a=a|0;ny(a);Uz(a);return}
function MC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;f=a[b>>0]|0;g=(f&1)==0;if(g)f=(f&255)>>>1;else f=c[b+4>>2]|0;do if(f>>>0>=d>>>0)if(g){a[b+1+d>>0]=0;a[b>>0]=d<<1;break}else{a[(c[b+8>>2]|0)+d>>0]=0;c[b+4>>2]=d;break}else NC(b,d-f|0,e)|0;while(0);return}function NC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;if(d){f=a[b>>0]|0;if(!(f&1))g=10;else{f=c[b>>2]|0;g=(f&-2)+-1|0;f=f&255}if(!(f&1))h=(f&255)>>>1;else h=c[b+4>>2]|0;if((g-h|0)>>>0<d>>>0){TC(b,g,d-g+h|0,h,h,0,0);f=a[b>>0]|0}if(!(f&1))g=b+1|0;else g=c[b+8>>2]|0;ZL(g+h|0,e|0,d|0)|0;f=h+d|0;if(!(a[b>>0]&1))a[b>>0]=f<<1;else c[b+4>>2]=f;a[g+f>>0]=0}return b|0}function OC(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;if(d>>>0>4294967279)Pz(b);e=a[b>>0]|0;if(!(e&1))f=10;else{e=c[b>>2]|0;f=(e&-2)+-1|0;e=e&255}if(!(e&1))j=(e&255)>>>1;else j=c[b+4>>2]|0;d=j>>>0>d>>>0?j:d;if(d>>>0<11)i=10;else i=(d+16&-16)+-1|0;a:do if((i|0)!=(f|0)){do if((i|0)!=10){d=i+1|0;if(i>>>0<=f>>>0){o=0;d=qa(111,d|0)|0;h=o;o=0;if(h&1){b=cc(0)|0;fc(b|0)|0;$b();break a}}else d=Sz(d)|0;if(!(e&1)){f=1;g=b+1|0;h=0;break}else{f=1;g=c[b+8>>2]|0;h=1;break}}else{d=b+1|0;f=0;g=c[b+8>>2]|0;h=1}while(0);if(!(e&1))e=(e&255)>>>1;else e=c[b+4>>2]|0;XL(d|0,g|0,e+1|0)|0;if(h)Uz(g);if(f){c[b>>2]=i+1|1;c[b+4>>2]=j;c[b+8>>2]=d;break}else{a[b>>0]=j<<1;break}}while(0);return}function PC(a,b){a=a|0;b=b|0;return RC(a,b,iC(b)|0)|0}function QC(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=a[b>>0]|0;f=(e&1)!=0;if(f){g=(c[b>>2]&-2)+-1|0;h=c[b+4>>2]|0}else{g=10;h=(e&255)>>>1}if((h|0)==(g|0)){TC(b,g,1,g,g,0,0);if(!(a[b>>0]&1))g=7;else g=8}else if(f)g=8;else g=7;if((g|0)==7){a[b>>0]=(h<<1)+2;e=b+1|0;f=h+1|0}else if((g|0)==8){e=c[b+8>>2]|0;f=h+1|0;c[b+4>>2]=f}a[e+h>>0]=d;a[e+f>>0]=0;return}function RC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;f=a[b>>0]|0;if(!(f&1))g=10;else{f=c[b>>2]|0;g=(f&-2)+-1|0;f=f&255}if(!(f&1))h=(f&255)>>>1;else h=c[b+4>>2]|0;if((g-h|0)>>>0>=e>>>0){if(e){if(!(f&1))g=b+1|0;else g=c[b+8>>2]|0;XL(g+h|0,d|0,e|0)|0;f=h+e|0;if(!(a[b>>0]&1))a[b>>0]=f<<1;else c[b+4>>2]=f;a[g+f>>0]=0}}else SC(b,g,e-g+h|0,h,h,0,e,d);return b|0}function SC(b,d,e,f,g,h,i,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;var k=0,l=0,m=0;if((-18-d|0)>>>0<e>>>0)Pz(b);if(!(a[b>>0]&1))m=b+1|0;else m=c[b+8>>2]|0;if(d>>>0<2147483623){k=e+d|0;l=d<<1;k=k>>>0<l>>>0?l:k;k=k>>>0<11?11:k+16&-16}else k=-17;l=Sz(k)|0;if(g)XL(l|0,m|0,g|0)|0;if(i)XL(l+g|0,j|0,i|0)|0;e=f-h|0;if((e|0)!=(g|0))XL(l+(i+g)|0,m+(h+g)|0,e-g|0)|0;if((d|0)!=10)Uz(m);c[b+8>>2]=l;c[b>>2]=k|1;d=e+i|0;c[b+4>>2]=d;a[l+d>>0]=0;return}function TC(b,d,e,f,g,h,i){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;var j=0,k=0,l=0;if((-17-d|0)>>>0<e>>>0)Pz(b);if(!(a[b>>0]&1))l=b+1|0;else l=c[b+8>>2]|0;if(d>>>0<2147483623){j=e+d|0;k=d<<1;j=j>>>0<k>>>0?k:j;j=j>>>0<11?11:j+16&-16}else j=-17;k=Sz(j)|0;if(g)XL(k|0,l|0,g|0)|0;e=f-h|0;if((e|0)!=(g|0))XL(k+(i+g)|0,l+(h+g)|0,e-g|0)|0;if((d|0)!=10)Uz(l);c[b+8>>2]=k;c[b>>2]=j|1;return}function UC(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0;g=a[b>>0]|0;h=(g&1)==0;if(h)i=(g&255)>>>1;else i=c[b+4>>2]|0;if(i>>>0<d>>>0)RA(b);if(e){if(h)h=10;else{g=c[b>>2]|0;h=(g&-2)+-1|0;g=g&255}if((h-i|0)>>>0>=e>>>0){if(!(g&1))g=b+1|0;else g=c[b+8>>2]|0;if((i|0)==(d|0))h=g;else{YL(g+(e+d)|0,g+d|0,i-d|0)|0;h=g}}else{TC(b,h,i+e-h|0,i,d,0,e);h=c[b+8>>2]|0}ZL(h+d|0,f|0,e|0)|0;g=i+e|0;if(!(a[b>>0]&1))a[b>>0]=g<<1;else c[b+4>>2]=g;a[h+g>>0]=0}return b|0}function VC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;g=a[b>>0]|0;f=(g&1)==0;if(f)i=(g&255)>>>1;else i=c[b+4>>2]|0;if(i>>>0<d>>>0)RA(b);if(e){if(f)h=b+1|0;else h=c[b+8>>2]|0;f=i-d|0;e=f>>>0<e>>>0?f:e;if((f|0)!=(e|0)){YL(h+d|0,h+(e+d)|0,f-e|0)|0;g=a[b>>0]|0}f=i-e|0;if(!(g&1))a[b>>0]=f<<1;else c[b+4>>2]=f;a[h+f>>0]=0}return b|0}function WC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;f=a[b>>0]|0;if(!(f&1)){g=(f&255)>>>1;f=b+1|0}else{g=c[b+4>>2]|0;f=c[b+8>>2]|0}if(g>>>0>e>>>0?(h=aC(f+e|0,d&255,g-e|0)|0,(h|0)!=0):0)f=h-f|0;else f=-1;return f|0}function XC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;if(e>>>0>1073741807)Pz(b);if(e>>>0<2){a[b>>0]=e<<1;b=b+4|0}else{g=e+4&-4;f=Sz(g<<2)|0;c[b+8>>2]=f;c[b>>2]=g|1;c[b+4>>2]=e;b=f}kC(b,d,e)|0;c[b+(e<<2)>>2]=0;return}function YC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;if(d>>>0>1073741807)Pz(b);if(d>>>0<2){a[b>>0]=d<<1;b=b+4|0}else{g=d+4&-4;f=Sz(g<<2)|0;c[b+8>>2]=f;c[b>>2]=g|1;c[b+4>>2]=d;b=f}mC(b,e,d)|0;c[b+(d<<2)>>2]=0;return}function ZC(b){b=b|0;if(a[b>>0]&1)Uz(c[b+8>>2]|0);return}function _C(a,b){a=a|0;b=b|0;return $C(a,b,jC(b)|0)|0}function $C(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;f=a[b>>0]|0;if(!(f&1))h=1;else{f=c[b>>2]|0;h=(f&-2)+-1|0;f=f&255}g=(f&1)==0;do if(h>>>0>=e>>>0){if(g)f=b+4|0;else f=c[b+8>>2]|0;lC(f,d,e)|0;c[f+(e<<2)>>2]=0;if(!(a[b>>0]&1)){a[b>>0]=e<<1;break}else{c[b+4>>2]=e;break}}else{if(g)f=(f&255)>>>1;else f=c[b+4>>2]|0;cD(b,h,e-h|0,f,0,f,e,d)}while(0);return b|0}function aD(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;if(d>>>0>1073741807)Pz(b);e=a[b>>0]|0;if(!(e&1))f=1;else{e=c[b>>2]|0;f=(e&-2)+-1|0;e=e&255}if(!(e&1))j=(e&255)>>>1;else j=c[b+4>>2]|0;d=j>>>0>d>>>0?j:d;if(d>>>0<2)i=1;else i=(d+4&-4)+-1|0;a:do if((i|0)!=(f|0)){do if((i|0)!=1){d=(i<<2)+4|0;if(i>>>0<=f>>>0){o=0;d=qa(111,d|0)|0;h=o;o=0;if(h&1){b=cc(0)|0;fc(b|0)|0;$b();break a}}else d=Sz(d)|0;if(!(e&1)){f=1;g=b+4|0;h=0;break}else{f=1;g=c[b+8>>2]|0;h=1;break}}else{d=b+4|0;f=0;g=c[b+8>>2]|0;h=1}while(0);if(!(e&1))e=(e&255)>>>1;else e=c[b+4>>2]|0;kC(d,g,e+1|0)|0;if(h)Uz(g);if(f){c[b>>2]=i+1|1;c[b+4>>2]=j;c[b+8>>2]=d;break}else{a[b>>0]=j<<1;break}}while(0);return}function bD(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=a[b>>0]|0;f=(e&1)!=0;if(f){g=(c[b>>2]&-2)+-1|0;h=c[b+4>>2]|0}else{g=1;h=(e&255)>>>1}if((h|0)==(g|0)){dD(b,g,1,g,g,0,0);if(!(a[b>>0]&1))g=7;else g=8}else if(f)g=8;else g=7;if((g|0)==7){a[b>>0]=(h<<1)+2;e=b+4|0;f=h+1|0}else if((g|0)==8){e=c[b+8>>2]|0;f=h+1|0;c[b+4>>2]=f}c[e+(h<<2)>>2]=d;c[e+(f<<2)>>2]=0;return}function cD(b,d,e,f,g,h,i,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;var k=0,l=0,m=0;if((1073741806-d|0)>>>0<e>>>0)Pz(b);if(!(a[b>>0]&1))m=b+4|0;else m=c[b+8>>2]|0;if(d>>>0<536870887){k=e+d|0;l=d<<1;k=k>>>0<l>>>0?l:k;k=k>>>0<2?2:k+4&-4}else k=1073741807;l=Sz(k<<2)|0;if(g)kC(l,m,g)|0;if(i)kC(l+(g<<2)|0,j,i)|0;e=f-h|0;if((e|0)!=(g|0))kC(l+(i+g<<2)|0,m+(h+g<<2)|0,e-g|0)|0;if((d|0)!=1)Uz(m);c[b+8>>2]=l;c[b>>2]=k|1;d=e+i|0;c[b+4>>2]=d;c[l+(d<<2)>>2]=0;return}function dD(b,d,e,f,g,h,i){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;var j=0,k=0,l=0;if((1073741807-d|0)>>>0<e>>>0)Pz(b);if(!(a[b>>0]&1))l=b+4|0;else l=c[b+8>>2]|0;if(d>>>0<536870887){j=e+d|0;k=d<<1;j=j>>>0<k>>>0?k:j;j=j>>>0<2?2:j+4&-4}else j=1073741807;k=Sz(j<<2)|0;if(g)kC(k,l,g)|0;e=f-h|0;if((e|0)!=(g|0))kC(k+(i+g<<2)|0,l+(h+g<<2)|0,e-g|0)|0;if((d|0)!=1)Uz(l);c[b+8>>2]=k;c[b>>2]=j|1;return}function eD(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;g=d;f=e-g|0;if(f>>>0>4294967279)Pz(b);if(f>>>0<11){a[b>>0]=f<<1;h=b+1|0}else{i=f+16&-16;h=Sz(i)|0;c[b+8>>2]=h;c[b>>2]=i|1;c[b+4>>2]=f}b=e-g|0;if((d|0)!=(e|0)){f=h;while(1){a[f>>0]=a[d>>0]|0;d=d+1|0;if((d|0)==(e|0))break;else f=f+1|0}}a[h+b>>0]=0;return}function fD(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;h=d;f=e-h|0;g=f>>2;if(g>>>0>1073741807)Pz(b);if(g>>>0<2){a[b>>0]=f>>>1;b=b+4|0}else{i=g+4&-4;f=Sz(i<<2)|0;c[b+8>>2]=f;c[b>>2]=i|1;c[b+4>>2]=g;b=f}g=(e-h|0)>>>2;if((d|0)!=(e|0)){f=b;while(1){c[f>>2]=c[d>>2];d=d+4|0;if((d|0)==(e|0))break;else f=f+4|0}}c[b+(g<<2)>>2]=0;return}function gD(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;d=i;i=i+16|0;e=d;f=(c[a+24>>2]|0)==0;c[a+16>>2]=f&1|b;if(!((f&1|b)&c[a+20>>2])){i=d;return}b=Ob(16)|0;OD()|0;c[e>>2]=1;c[e+4>>2]=39796;o=0;mb(115,b|0,59796,e|0);f=o;o=0;if(f&1){f=cc()|0;Nb(b|0);bc(f|0)}else Hc(b|0,2080,232)}function hD(a){a=a|0;var b=0;c[a>>2]=39752;o=0;ma(221,a|0,0);b=o;o=0;if(b&1){b=cc(0)|0;oq(b)}else{aI(a+28|0);zC(c[a+32>>2]|0);zC(c[a+36>>2]|0);zC(c[a+48>>2]|0);zC(c[a+60>>2]|0);return}}function iD(a){a=a|0;hD(a);return}function jD(a){a=a|0;hD(a);Uz(a);return}function kD(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;d=c[a+40>>2]|0;e=a+32|0;f=a+36|0;if(d)do{d=d+-1|0;Ad[c[(c[e>>2]|0)+(d<<2)>>2]&127](b,a,c[(c[f>>2]|0)+(d<<2)>>2]|0)}while((d|0)!=0);return}function lD(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;$H(b,a+28|0);i=d;return c[b>>2]|0}function mD(a,b){a=a|0;b=b|0;var d=0;c[a+24>>2]=b;c[a+16>>2]=(b|0)==0&1;c[a+20>>2]=0;c[a+4>>2]=4098;c[a+12>>2]=0;c[a+8>>2]=6;d=a+28|0;b=a+32|0;a=b+40|0;do{c[b>>2]=0;b=b+4|0}while((b|0)<(a|0));_H(d);return}function nD(a){a=a|0;c[a>>2]=39668;aI(a+4|0);return}function oD(a){a=a|0;c[a>>2]=39668;aI(a+4|0);Uz(a);return}function pD(a){a=a|0;c[a>>2]=39668;_H(a+4|0);a=a+8|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;c[a+12>>2]=0;c[a+16>>2]=0;c[a+20>>2]=0;return}function qD(a,b){a=a|0;b=b|0;return}function rD(a,b,c){a=a|0;b=b|0;c=c|0;return a|0}function sD(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;b=a;c[b>>2]=0;c[b+4>>2]=0;b=a+8|0;c[b>>2]=-1;c[b+4>>2]=-1;return}function tD(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;b=a;c[b>>2]=0;c[b+4>>2]=0;b=a+8|0;c[b>>2]=-1;c[b+4>>2]=-1;return}function uD(a){a=a|0;return 0}function vD(a){a=a|0;return 0}function wD(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;h=b+12|0;i=b+16|0;a:do if((e|0)>0){g=d;d=0;while(1){f=c[h>>2]|0;if(f>>>0<(c[i>>2]|0)>>>0){c[h>>2]=f+1;f=a[f>>0]|0}else{f=bd[c[(c[b>>2]|0)+40>>2]&255](b)|0;if((f|0)==-1)break a;f=f&255}a[g>>0]=f;d=d+1|0;if((d|0)<(e|0))g=g+1|0;else break}}else d=0;while(0);return d|0}function xD(a){a=a|0;return -1}function yD(a){a=a|0;var b=0;if((bd[c[(c[a>>2]|0)+36>>2]&255](a)|0)==-1)a=-1;else{b=a+12|0;a=c[b>>2]|0;c[b>>2]=a+1;a=d[a>>0]|0}return a|0}function zD(a,b){a=a|0;b=b|0;return -1}function AD(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0;i=b+24|0;j=b+28|0;a:do if((f|0)>0){h=e;e=0;while(1){g=c[i>>2]|0;if(g>>>0>=(c[j>>2]|0)>>>0){if((rd[c[(c[b>>2]|0)+52>>2]&127](b,d[h>>0]|0)|0)==-1)break a}else{k=a[h>>0]|0;c[i>>2]=g+1;a[g>>0]=k}e=e+1|0;if((e|0)<(f|0))h=h+1|0;else break}}else e=0;while(0);return e|0}function BD(a,b){a=a|0;b=b|0;return -1}function CD(b){b=b|0;var d=0,e=0,f=0,g=0;f=i;i=i+16|0;e=f;a:do if(c[b+((c[(c[b>>2]|0)+-12>>2]|0)+24)>>2]|0){o=0;ma(218,e|0,b|0);d=o;o=0;b:do if(d&1)d=cc(0)|0;else{do if(a[e>>0]|0){d=c[b+((c[(c[b>>2]|0)+-12>>2]|0)+24)>>2]|0;o=0;d=qa(c[(c[d>>2]|0)+24>>2]|0,d|0)|0;g=o;o=0;if(!(g&1)){if((d|0)!=-1)break;g=c[(c[b>>2]|0)+-12>>2]|0;o=0;ma(146,b+g|0,c[b+(g+16)>>2]|1|0);g=o;o=0;if(!(g&1))break}d=cc(0)|0;KD(e);break b}while(0);KD(e);break a}while(0);fc(d|0)|0;o=0;ka(341,b+(c[(c[b>>2]|0)+-12>>2]|0)|0);g=o;o=0;if(!(g&1)){$b();break}d=cc()|0;o=0;ob(44);g=o;o=0;if(g&1){g=cc(0)|0;oq(g)}else bc(d|0)}while(0);i=f;return b|0}function DD(a){a=a|0;var b=0;b=a+16|0;c[b>>2]=c[b>>2]|1;if(!(c[a+20>>2]&1))return;else Jc()}function ED(a,b){a=a|0;b=b|0;return}function FD(a){a=a|0;hD(a+4|0);return}function GD(a){a=a|0;hD(a+((c[(c[a>>2]|0)+-12>>2]|0)+4)|0);return}function HD(a){a=a|0;hD(a+4|0);Uz(a);return}function ID(a){a=a|0;HD(a+(c[(c[a>>2]|0)+-12>>2]|0)|0);return}function JD(b,d){b=b|0;d=d|0;var e=0;a[b>>0]=0;c[b+4>>2]=d;e=c[(c[d>>2]|0)+-12>>2]|0;if(!(c[d+(e+16)>>2]|0)){e=c[d+(e+72)>>2]|0;if(e)CD(e)|0;a[b>>0]=1}return}function KD(a){a=a|0;var b=0,d=0;a=a+4|0;d=c[a>>2]|0;b=c[(c[d>>2]|0)+-12>>2]|0;do if((((c[d+(b+24)>>2]|0)!=0?(c[d+(b+16)>>2]|0)==0:0)?(c[d+(b+4)>>2]&8192|0)!=0:0)?!(Pb()|0):0){b=c[a>>2]|0;b=c[b+((c[(c[b>>2]|0)+-12>>2]|0)+24)>>2]|0;o=0;b=qa(c[(c[b>>2]|0)+24>>2]|0,b|0)|0;d=o;o=0;if(!(d&1)){if((b|0)!=-1)break;b=c[a>>2]|0;d=c[(c[b>>2]|0)+-12>>2]|0;o=0;ma(146,b+d|0,c[b+(d+16)>>2]|1|0);d=o;o=0;if(!(d&1))break}d=cc(0)|0;fc(d|0)|0;o=0;ob(44);d=o;o=0;if(d&1){d=cc(0)|0;oq(d)}}while(0);return}function LD(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;q=i;i=i+32|0;k=q+20|0;l=q+16|0;n=q+8|0;e=q;o=0;ma(218,n|0,b|0);m=o;o=0;a:do if(m&1){e=cc(0)|0;f=b;g=b;p=19}else{do if(a[n>>0]|0){c[e>>2]=lD(b+(c[(c[b>>2]|0)+-12>>2]|0)|0)|0;o=0;m=Wa(115,e|0,40076)|0;j=o;o=0;if(j&1){p=cc(0)|0;aI(e);e=p}else{aI(e);g=c[(c[b>>2]|0)+-12>>2]|0;j=c[b+(g+24)>>2]|0;f=b+g|0;g=b+(g+76)|0;e=c[g>>2]|0;do if((e|0)==-1){c[k>>2]=lD(f)|0;o=0;e=Wa(115,k|0,40904)|0;r=o;o=0;if(!(r&1)?(o=0,h=Wa(c[(c[e>>2]|0)+28>>2]|0,e|0,32)|0,r=o,o=0,!(r&1)):0){aI(k);e=h<<24>>24;c[g>>2]=e;p=10;break}e=cc(0)|0;aI(k)}else p=10;while(0);if((p|0)==10){r=c[(c[m>>2]|0)+16>>2]|0;c[l>>2]=j;o=0;c[k>>2]=c[l>>2];e=Ya(r|0,m|0,k|0,f|0,e&255|0,d|0)|0;r=o;o=0;if(!(r&1)){if(e)break;r=c[(c[b>>2]|0)+-12>>2]|0;o=0;ma(146,b+r|0,c[b+(r+16)>>2]|5|0);r=o;o=0;if(!(r&1))break}e=cc(0)|0}}KD(n);f=b;g=b;p=19;break a}while(0);KD(n)}while(0);do if((p|0)==19){fc(e|0)|0;o=0;ka(341,f+(c[(c[g>>2]|0)+-12>>2]|0)|0);r=o;o=0;if(!(r&1)){$b();break}e=cc()|0;o=0;ob(44);r=o;o=0;if(r&1){r=cc(0)|0;oq(r)}else bc(e|0)}while(0);i=q;return b|0}function MD(a){a=a|0;return 59812}function ND(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)!=1&(c|0)<257)LL(a,b,c);else FC(a,59821,35);return}function OD(){if((a[2168]|0)==0?(Hb(2168)|0)!=0:0){c[9949]=39768;Ec(236,39796,n|0)|0;Cc(2168)}return 39796}function PD(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0;e=i;i=i+16|0;f=e+8|0;g=e;j=d;h=c[j+4>>2]|0;d=g;c[d>>2]=c[j>>2];c[d+4>>2]=h;c[f>>2]=c[g>>2];c[f+4>>2]=c[g+4>>2];NL(a,f,b);c[a>>2]=39732;i=e;return}function QD(a){a=a|0;OL(a);return}function RD(a){a=a|0;OL(a);Uz(a);return}function SD(a){a=a|0;hD(a);Uz(a);return}function TD(a){a=a|0;Uz(a);return}function UD(a){a=a|0;return}function VD(a){a=a|0;return}function WD(a){a=a|0;Uz(a);return}function XD(b,c,d,e,f){b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;a:do if((e|0)==(f|0))h=6;else while(1){if((c|0)==(d|0)){c=-1;break a}b=a[c>>0]|0;g=a[e>>0]|0;if(b<<24>>24<g<<24>>24){c=-1;break a}if(g<<24>>24<b<<24>>24){c=1;break a}c=c+1|0;e=e+1|0;if((e|0)==(f|0)){h=6;break}}while(0);if((h|0)==6)c=(c|0)!=(d|0)&1;return c|0}function YD(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;eD(a,c,d);return}function ZD(b,c,d){b=b|0;c=c|0;d=d|0;var e=0;if((c|0)==(d|0))b=0;else{b=0;do{b=(a[c>>0]|0)+(b<<4)|0;e=b&-268435456;b=(e>>>24|e)^b;c=c+1|0}while((c|0)!=(d|0))}return b|0}function _D(a){a=a|0;return}function $D(a){a=a|0;Uz(a);return}function aE(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;a:do if((e|0)==(f|0))h=6;else while(1){if((b|0)==(d|0)){b=-1;break a}a=c[b>>2]|0;g=c[e>>2]|0;if((a|0)<(g|0)){b=-1;break a}if((g|0)<(a|0)){b=1;break a}b=b+4|0;e=e+4|0;if((e|0)==(f|0)){h=6;break}}while(0);if((h|0)==6)b=(b|0)!=(d|0)&1;return b|0}function bE(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;fD(a,c,d);return}function cE(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;if((b|0)==(d|0))a=0;else{a=0;do{a=(c[b>>2]|0)+(a<<4)|0;e=a&-268435456;a=(e>>>24|e)^a;b=b+4|0}while((b|0)!=(d|0))}return a|0}function dE(a){a=a|0;return}function eE(a){a=a|0;Uz(a);return}function fE(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0;s=i;i=i+64|0;q=s+56|0;j=s+52|0;n=s+48|0;k=s+44|0;l=s+40|0;m=s+36|0;p=s+32|0;t=s+8|0;r=s;a:do if(!(c[f+4>>2]&1)){c[n>>2]=-1;t=c[(c[b>>2]|0)+16>>2]|0;c[k>>2]=c[d>>2];c[l>>2]=c[e>>2];c[j>>2]=c[k>>2];c[q>>2]=c[l>>2];j=ad[t&127](b,j,q,f,g,n)|0;c[d>>2]=j;switch(c[n>>2]|0){case 0:{a[h>>0]=0;break a}case 1:{a[h>>0]=1;break a}default:{a[h>>0]=1;c[g>>2]=4;break a}}}else{j=lD(f)|0;c[m>>2]=j;o=0;b=Wa(115,m|0,40904)|0;n=o;o=0;do if(!(n&1)){EL(j)|0;j=lD(f)|0;c[p>>2]=j;o=0;l=Wa(115,p|0,41044)|0;p=o;o=0;if(p&1){t=cc()|0;EL(j)|0;j=t;break}EL(j)|0;o=0;ma(c[(c[l>>2]|0)+24>>2]|0,t|0,l|0);p=o;o=0;if(!(p&1)){k=t+12|0;o=0;ma(c[(c[l>>2]|0)+28>>2]|0,k|0,l|0);p=o;o=0;if(!(p&1)){c[r>>2]=c[e>>2];o=0;c[q>>2]=c[r>>2];j=ea(50,d|0,q|0,t|0,t+24|0,b|0,g|0,1)|0;g=o;o=0;if(g&1){j=cc()|0;IC(t+12|0);IC(t);break}else{a[h>>0]=(j|0)==(t|0)&1;j=c[d>>2]|0;IC(t+12|0);IC(t);break a}}}else k=t;j=cc()|0;l=D;if((t|0)!=(k|0))do{k=k+-12|0;IC(k)}while((k|0)!=(t|0))}else{t=cc()|0;EL(j)|0;j=t}while(0);bc(j|0)}while(0);i=s;return j|0}function gE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=UJ(a,k,j,e,f,g)|0;i=h;return a|0}function hE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=VJ(a,k,j,e,f,g)|0;i=h;return a|0}function iE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=WJ(a,k,j,e,f,g)|0;i=h;return a|0}function jE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=XJ(a,k,j,e,f,g)|0;i=h;return a|0}function kE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=YJ(a,k,j,e,f,g)|0;i=h;return a|0}function lE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=ZJ(a,k,j,e,f,g)|0;i=h;return a|0}function mE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=_J(a,k,j,e,f,g)|0;i=h;return a|0}function nE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=$J(a,k,j,e,f,g)|0;i=h;return a|0}function oE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=aK(a,k,j,e,f,g)|0;i=h;return a|0}function pE(b,e,f,g,h,j){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;C=i;i=i+240|0;x=C;s=C+208|0;E=C+32|0;b=C+28|0;D=C+16|0;w=C+12|0;u=C+48|0;v=C+8|0;t=C+4|0;c[E>>2]=0;c[E+4>>2]=0;c[E+8>>2]=0;o=0;g=qa(192,g|0)|0;r=o;o=0;do if(r&1)b=cc()|0;else{c[b>>2]=g;o=0;b=Wa(115,b|0,40904)|0;r=o;o=0;if(!(r&1)?(o=0,kb(c[(c[b>>2]|0)+32>>2]|0,b|0,59857,59883,s|0)|0,r=o,o=0,!(r&1)):0){EL(g)|0;c[D>>2]=0;c[D+4>>2]=0;c[D+8>>2]=0;if(!(a[D>>0]&1))b=10;else b=(c[D>>2]&-2)+-1|0;o=0;mb(80,D|0,b|0,0);r=o;o=0;a:do if(!(r&1)){q=D+8|0;r=D+1|0;g=(a[D>>0]&1)==0?r:c[q>>2]|0;c[w>>2]=g;c[v>>2]=u;c[t>>2]=0;p=D+4|0;b=c[e>>2]|0;b:while(1){if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;k=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;n=o;o=0;if(n&1){F=29;break}if((k|0)==-1){c[e>>2]=0;b=0}}}else b=0;l=(b|0)==0;k=c[f>>2]|0;do if(k){if((c[k+12>>2]|0)!=(c[k+16>>2]|0))if(l)break;else break b;o=0;m=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;n=o;o=0;if(n&1){F=29;break b}if((m|0)!=-1)if(l)break;else break b;else{c[f>>2]=0;F=19;break}}else F=19;while(0);if((F|0)==19){F=0;if(l){k=0;break}else k=0}l=a[D>>0]|0;l=(l&1)==0?(l&255)>>>1:c[p>>2]|0;if((c[w>>2]|0)==(g+l|0)){o=0;mb(80,D|0,l<<1|0,0);n=o;o=0;if(n&1){F=29;break}if(!(a[D>>0]&1))g=10;else g=(c[D>>2]&-2)+-1|0;o=0;mb(80,D|0,g|0,0);n=o;o=0;if(n&1){F=29;break}g=(a[D>>0]&1)==0?r:c[q>>2]|0;c[w>>2]=g+l}m=b+12|0;l=c[m>>2]|0;n=b+16|0;if((l|0)==(c[n>>2]|0)){o=0;l=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;G=o;o=0;if(G&1){F=29;break}}else l=d[l>>0]|0;if(qE(l&255,16,g,w,t,0,E,u,v,s)|0)break;k=c[m>>2]|0;if((k|0)==(c[n>>2]|0)){o=0;qa(c[(c[b>>2]|0)+40>>2]|0,b|0)|0;G=o;o=0;if(G&1){F=29;break}else continue}else{c[m>>2]=k+1;continue}}if((F|0)==29){b=cc()|0;break}o=0;mb(80,D|0,(c[w>>2]|0)-g|0,0);G=o;o=0;if((!(G&1)?(y=a[D>>0]|0,z=c[q>>2]|0,o=0,A=gb(45)|0,G=o,o=0,!(G&1)):0)?(o=0,c[x>>2]=j,B=kb(64,((y&1)==0?r:z)|0,A|0,61241,x|0)|0,G=o,o=0,!(G&1)):0){if((B|0)!=1)c[h>>2]=4;if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;g=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;G=o;o=0;if(G&1){F=30;break}if((g|0)==-1){c[e>>2]=0;b=0}}}else b=0;g=(b|0)==0;do if(k){if((c[k+12>>2]|0)==(c[k+16>>2]|0)){o=0;b=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;G=o;o=0;if(G&1){F=30;break a}if((b|0)==-1){c[f>>2]=0;F=55;break}}if(!g)F=56}else F=55;while(0);if((F|0)==55?g:0)F=56;if((F|0)==56)c[h>>2]=c[h>>2]|2;G=c[e>>2]|0;IC(D);IC(E);i=C;return G|0}else F=30}else F=30;while(0);if((F|0)==30)b=cc()|0;IC(D);break}b=cc()|0;EL(g)|0}while(0);IC(E);bc(b|0);return 0}function qE(b,d,e,f,g,h,i,j,k,l){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;var m=0,n=0,o=0,p=0;o=c[f>>2]|0;p=(o|0)==(e|0);do if(p){m=(a[l+24>>0]|0)==b<<24>>24;if(!m?(a[l+25>>0]|0)!=b<<24>>24:0){n=5;break}c[f>>2]=e+1;a[e>>0]=m?43:45;c[g>>2]=0;m=0}else n=5;while(0);a:do if((n|0)==5){n=a[i>>0]|0;if(b<<24>>24==h<<24>>24?(((n&1)==0?(n&255)>>>1:c[i+4>>2]|0)|0)!=0:0){m=c[k>>2]|0;if((m-j|0)>=160){m=0;break}d=c[g>>2]|0;c[k>>2]=m+4;c[m>>2]=d;c[g>>2]=0;m=0;break}i=l+26|0;m=l;while(1){if((a[m>>0]|0)==b<<24>>24)break;m=m+1|0;if((m|0)==(i|0)){m=i;break}}m=m-l|0;if((m|0)>23)m=-1;else{switch(d|0){case 10:case 8:{if((m|0)>=(d|0)){m=-1;break a}break}case 16:{if((m|0)>=22){if(p){m=-1;break a}if((o-e|0)>=3){m=-1;break a}if((a[o+-1>>0]|0)!=48){m=-1;break a}c[g>>2]=0;m=a[59857+m>>0]|0;c[f>>2]=o+1;a[o>>0]=m;m=0;break a}break}default:{}}m=a[59857+m>>0]|0;c[f>>2]=o+1;a[o>>0]=m;c[g>>2]=(c[g>>2]|0)+1;m=0}}while(0);return m|0}function rE(){var b=0,d=0;do if((a[3088]|0)==0?(Hb(3088)|0)!=0:0){o=0;b=ya(121,2147483647,61244,0)|0;d=o;o=0;if(d&1){d=cc()|0;rc(3088);bc(d|0)}else{c[10367]=b;Cc(3088);break}}while(0);return c[10367]|0}function sE(a){a=a|0;return}function tE(a){a=a|0;Uz(a);return}function uE(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0;s=i;i=i+64|0;q=s+56|0;j=s+52|0;n=s+48|0;k=s+44|0;l=s+40|0;m=s+36|0;p=s+32|0;t=s+8|0;r=s;a:do if(!(c[f+4>>2]&1)){c[n>>2]=-1;t=c[(c[b>>2]|0)+16>>2]|0;c[k>>2]=c[d>>2];c[l>>2]=c[e>>2];c[j>>2]=c[k>>2];c[q>>2]=c[l>>2];j=ad[t&127](b,j,q,f,g,n)|0;c[d>>2]=j;switch(c[n>>2]|0){case 0:{a[h>>0]=0;break a}case 1:{a[h>>0]=1;break a}default:{a[h>>0]=1;c[g>>2]=4;break a}}}else{j=lD(f)|0;c[m>>2]=j;o=0;b=Wa(115,m|0,40896)|0;n=o;o=0;do if(!(n&1)){EL(j)|0;j=lD(f)|0;c[p>>2]=j;o=0;l=Wa(115,p|0,41052)|0;p=o;o=0;if(p&1){t=cc()|0;EL(j)|0;j=t;break}EL(j)|0;o=0;ma(c[(c[l>>2]|0)+24>>2]|0,t|0,l|0);p=o;o=0;if(!(p&1)){k=t+12|0;o=0;ma(c[(c[l>>2]|0)+28>>2]|0,k|0,l|0);p=o;o=0;if(!(p&1)){c[r>>2]=c[e>>2];o=0;c[q>>2]=c[r>>2];j=ea(51,d|0,q|0,t|0,t+24|0,b|0,g|0,1)|0;g=o;o=0;if(g&1){j=cc()|0;ZC(t+12|0);ZC(t);break}else{a[h>>0]=(j|0)==(t|0)&1;j=c[d>>2]|0;ZC(t+12|0);ZC(t);break a}}}else k=t;j=cc()|0;l=D;if((t|0)!=(k|0))do{k=k+-12|0;ZC(k)}while((k|0)!=(t|0))}else{t=cc()|0;EL(j)|0;j=t}while(0);bc(j|0)}while(0);i=s;return j|0}function vE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=dK(a,k,j,e,f,g)|0;i=h;return a|0}function wE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=eK(a,k,j,e,f,g)|0;i=h;return a|0}function xE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=fK(a,k,j,e,f,g)|0;i=h;return a|0}function yE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=gK(a,k,j,e,f,g)|0;i=h;return a|0}function zE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=hK(a,k,j,e,f,g)|0;i=h;return a|0}function AE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=iK(a,k,j,e,f,g)|0;i=h;return a|0}function BE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=jK(a,k,j,e,f,g)|0;i=h;return a|0}function CE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=kK(a,k,j,e,f,g)|0;i=h;return a|0}function DE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=lK(a,k,j,e,f,g)|0;i=h;return a|0}function EE(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0;B=i;i=i+320|0;w=B;r=B+208|0;D=B+32|0;b=B+28|0;C=B+16|0;v=B+12|0;t=B+48|0;u=B+8|0;s=B+4|0;c[D>>2]=0;c[D+4>>2]=0;c[D+8>>2]=0;o=0;f=qa(192,f|0)|0;q=o;o=0;do if(q&1)b=cc()|0;else{c[b>>2]=f;o=0;b=Wa(115,b|0,40896)|0;q=o;o=0;if(!(q&1)?(o=0,kb(c[(c[b>>2]|0)+48>>2]|0,b|0,59857,59883,r|0)|0,q=o,o=0,!(q&1)):0){EL(f)|0;c[C>>2]=0;c[C+4>>2]=0;c[C+8>>2]=0;if(!(a[C>>0]&1))b=10;else b=(c[C>>2]&-2)+-1|0;o=0;mb(80,C|0,b|0,0);q=o;o=0;a:do if(!(q&1)){p=C+8|0;q=C+1|0;b=(a[C>>0]&1)==0?q:c[p>>2]|0;c[v>>2]=b;c[u>>2]=t;c[s>>2]=0;n=C+4|0;j=c[d>>2]|0;b:while(1){if(j){f=c[j+12>>2]|0;if((f|0)==(c[j+16>>2]|0)){o=0;f=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;m=o;o=0;if(m&1){E=30;break}}else f=c[f>>2]|0;if((f|0)==-1){c[d>>2]=0;f=0;k=1}else{f=j;k=0}}else{f=0;k=1}l=c[e>>2]|0;do if(l){j=c[l+12>>2]|0;if((j|0)==(c[l+16>>2]|0)){o=0;j=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;m=o;o=0;if(m&1){E=30;break b}}else j=c[j>>2]|0;if((j|0)!=-1)if(k){j=l;break}else{j=l;break b}else{c[e>>2]=0;E=20;break}}else E=20;while(0);if((E|0)==20){E=0;if(k){j=0;break}else j=0}k=a[C>>0]|0;k=(k&1)==0?(k&255)>>>1:c[n>>2]|0;if((c[v>>2]|0)==(b+k|0)){o=0;mb(80,C|0,k<<1|0,0);m=o;o=0;if(m&1){E=30;break}if(!(a[C>>0]&1))b=10;else b=(c[C>>2]&-2)+-1|0;o=0;mb(80,C|0,b|0,0);m=o;o=0;if(m&1){E=30;break}b=(a[C>>0]&1)==0?q:c[p>>2]|0;c[v>>2]=b+k}l=f+12|0;k=c[l>>2]|0;m=f+16|0;if((k|0)==(c[m>>2]|0)){o=0;k=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;F=o;o=0;if(F&1){E=30;break}}else k=c[k>>2]|0;if(FE(k,16,b,v,s,0,D,t,u,r)|0)break;j=c[l>>2]|0;if((j|0)==(c[m>>2]|0)){o=0;qa(c[(c[f>>2]|0)+40>>2]|0,f|0)|0;F=o;o=0;if(F&1){E=30;break}else{j=f;continue}}else{c[l>>2]=j+4;j=f;continue}}if((E|0)==30){b=cc()|0;break}o=0;mb(80,C|0,(c[v>>2]|0)-b|0,0);F=o;o=0;if((!(F&1)?(x=a[C>>0]|0,y=c[p>>2]|0,o=0,z=gb(45)|0,F=o,o=0,!(F&1)):0)?(o=0,c[w>>2]=h,A=kb(64,((x&1)==0?q:y)|0,z|0,61241,w|0)|0,F=o,o=0,!(F&1)):0){if((A|0)!=1)c[g>>2]=4;if(f){b=c[f+12>>2]|0;if((b|0)==(c[f+16>>2]|0)){o=0;b=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;F=o;o=0;if(F&1){E=31;break}}else b=c[b>>2]|0;if((b|0)==-1){c[d>>2]=0;f=1}else f=0}else f=1;do if(j){b=c[j+12>>2]|0;if((b|0)==(c[j+16>>2]|0)){o=0;b=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;F=o;o=0;if(F&1){E=31;break a}}else b=c[b>>2]|0;if((b|0)!=-1)if(f)break;else{E=59;break}else{c[e>>2]=0;E=57;break}}else E=57;while(0);if((E|0)==57?f:0)E=59;if((E|0)==59)c[g>>2]=c[g>>2]|2;F=c[d>>2]|0;IC(C);IC(D);i=B;return F|0}else E=31}else E=31;while(0);if((E|0)==31)b=cc()|0;IC(C);break}b=cc()|0;EL(f)|0}while(0);IC(D);bc(b|0);return 0}function FE(b,d,e,f,g,h,i,j,k,l){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;var m=0,n=0,o=0,p=0;o=c[f>>2]|0;p=(o|0)==(e|0);do if(p){m=(c[l+96>>2]|0)==(b|0);if(!m?(c[l+100>>2]|0)!=(b|0):0){n=5;break}c[f>>2]=e+1;a[e>>0]=m?43:45;c[g>>2]=0;m=0}else n=5;while(0);a:do if((n|0)==5){n=a[i>>0]|0;if((b|0)==(h|0)?(((n&1)==0?(n&255)>>>1:c[i+4>>2]|0)|0)!=0:0){m=c[k>>2]|0;if((m-j|0)>=160){m=0;break}d=c[g>>2]|0;c[k>>2]=m+4;c[m>>2]=d;c[g>>2]=0;m=0;break}i=l+104|0;m=l;while(1){if((c[m>>2]|0)==(b|0))break;m=m+4|0;if((m|0)==(i|0)){m=i;break}}m=m-l|0;i=m>>2;if((m|0)>92)m=-1;else{switch(d|0){case 10:case 8:{if((i|0)>=(d|0)){m=-1;break a}break}case 16:{if((m|0)>=88){if(p){m=-1;break a}if((o-e|0)>=3){m=-1;break a}if((a[o+-1>>0]|0)!=48){m=-1;break a}c[g>>2]=0;m=a[59857+i>>0]|0;c[f>>2]=o+1;a[o>>0]=m;m=0;break a}break}default:{}}m=a[59857+i>>0]|0;c[f>>2]=o+1;a[o>>0]=m;c[g>>2]=(c[g>>2]|0)+1;m=0}}while(0);return m|0}function GE(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;k=l;d=lD(d)|0;c[k>>2]=d;o=0;g=Wa(115,k|0,40904)|0;m=o;o=0;if((((!(m&1)?(o=0,kb(c[(c[g>>2]|0)+32>>2]|0,g|0,59857,59883,e|0)|0,m=o,o=0,!(m&1)):0)?(o=0,j=Wa(115,k|0,41044)|0,m=o,o=0,!(m&1)):0)?(o=0,h=qa(c[(c[j>>2]|0)+16>>2]|0,j|0)|0,m=o,o=0,!(m&1)):0)?(a[f>>0]=h,o=0,ma(c[(c[j>>2]|0)+20>>2]|0,b|0,j|0),m=o,o=0,!(m&1)):0){EL(d)|0;i=l;return}m=cc()|0;EL(d)|0;bc(m|0)}function HE(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0;n=i;i=i+16|0;m=n;d=lD(d)|0;c[m>>2]=d;o=0;h=Wa(115,m|0,40904)|0;p=o;o=0;if(((((!(p&1)?(o=0,kb(c[(c[h>>2]|0)+32>>2]|0,h|0,59857,59889,e|0)|0,p=o,o=0,!(p&1)):0)?(o=0,l=Wa(115,m|0,41044)|0,p=o,o=0,!(p&1)):0)?(o=0,j=qa(c[(c[l>>2]|0)+12>>2]|0,l|0)|0,p=o,o=0,!(p&1)):0)?(a[f>>0]=j,o=0,k=qa(c[(c[l>>2]|0)+16>>2]|0,l|0)|0,p=o,o=0,!(p&1)):0)?(a[g>>0]=k,o=0,ma(c[(c[l>>2]|0)+20>>2]|0,b|0,l|0),p=o,o=0,!(p&1)):0){EL(d)|0;i=n;return}p=cc()|0;EL(d)|0;bc(p|0)}function IE(b,e,f,g,h,i,j,k,l,m,n,o){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;var p=0,q=0;a:do if(b<<24>>24==i<<24>>24)if(a[e>>0]|0){a[e>>0]=0;f=c[h>>2]|0;c[h>>2]=f+1;a[f>>0]=46;f=a[k>>0]|0;if((((f&1)==0?(f&255)>>>1:c[k+4>>2]|0)|0)!=0?(p=c[m>>2]|0,(p-l|0)<160):0){l=c[n>>2]|0;c[m>>2]=p+4;c[p>>2]=l;p=0}else p=0}else p=-1;else{if(b<<24>>24==j<<24>>24?(j=a[k>>0]|0,(((j&1)==0?(j&255)>>>1:c[k+4>>2]|0)|0)!=0):0){if(!(a[e>>0]|0)){p=-1;break}p=c[m>>2]|0;if((p-l|0)>=160){p=0;break}l=c[n>>2]|0;c[m>>2]=p+4;c[p>>2]=l;c[n>>2]=0;p=0;break}i=o+32|0;p=o;while(1){if((a[p>>0]|0)==b<<24>>24)break;p=p+1|0;if((p|0)==(i|0)){p=i;break}}i=p-o|0;if((i|0)>31)p=-1;else{j=a[59857+i>>0]|0;switch(i|0){case 24:case 25:{p=c[h>>2]|0;if((p|0)!=(g|0)?(d[p+-1>>0]&95|0)!=(d[f>>0]&127|0):0){p=-1;break a}c[h>>2]=p+1;a[p>>0]=j;p=0;break a}case 23:case 22:{a[f>>0]=80;p=c[h>>2]|0;c[h>>2]=p+1;a[p>>0]=j;p=0;break a}default:{p=j&95;if((((p|0)==(a[f>>0]|0)?(a[f>>0]=p|128,(a[e>>0]|0)!=0):0)?(a[e>>0]=0,f=a[k>>0]|0,(((f&1)==0?(f&255)>>>1:c[k+4>>2]|0)|0)!=0):0)?(q=c[m>>2]|0,(q-l|0)<160):0){l=c[n>>2]|0;c[m>>2]=q+4;c[q>>2]=l}m=c[h>>2]|0;c[h>>2]=m+1;a[m>>0]=j;if((i|0)>21){p=0;break a}c[n>>2]=(c[n>>2]|0)+1;p=0;break a}}}}while(0);return p|0}function JE(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0;k=i;i=i+16|0;j=k;b=lD(b)|0;c[j>>2]=b;o=0;f=Wa(115,j|0,40896)|0;l=o;o=0;if((((!(l&1)?(o=0,kb(c[(c[f>>2]|0)+48>>2]|0,f|0,59857,59883,d|0)|0,l=o,o=0,!(l&1)):0)?(o=0,h=Wa(115,j|0,41052)|0,l=o,o=0,!(l&1)):0)?(o=0,g=qa(c[(c[h>>2]|0)+16>>2]|0,h|0)|0,l=o,o=0,!(l&1)):0)?(c[e>>2]=g,o=0,ma(c[(c[h>>2]|0)+20>>2]|0,a|0,h|0),l=o,o=0,!(l&1)):0){EL(b)|0;i=k;return}l=cc()|0;EL(b)|0;bc(l|0)}function KE(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0;m=i;i=i+16|0;l=m;b=lD(b)|0;c[l>>2]=b;o=0;g=Wa(115,l|0,40896)|0;n=o;o=0;if(((((!(n&1)?(o=0,kb(c[(c[g>>2]|0)+48>>2]|0,g|0,59857,59889,d|0)|0,n=o,o=0,!(n&1)):0)?(o=0,k=Wa(115,l|0,41052)|0,n=o,o=0,!(n&1)):0)?(o=0,h=qa(c[(c[k>>2]|0)+12>>2]|0,k|0)|0,n=o,o=0,!(n&1)):0)?(c[e>>2]=h,o=0,j=qa(c[(c[k>>2]|0)+16>>2]|0,k|0)|0,n=o,o=0,!(n&1)):0)?(c[f>>2]=j,o=0,ma(c[(c[k>>2]|0)+20>>2]|0,a|0,k|0),n=o,o=0,!(n&1)):0){EL(b)|0;i=m;return}n=cc()|0;EL(b)|0;bc(n|0)}function LE(b,e,f,g,h,i,j,k,l,m,n,o){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;var p=0,q=0;a:do if((b|0)==(i|0))if(a[e>>0]|0){a[e>>0]=0;f=c[h>>2]|0;c[h>>2]=f+1;a[f>>0]=46;f=a[k>>0]|0;if((((f&1)==0?(f&255)>>>1:c[k+4>>2]|0)|0)!=0?(p=c[m>>2]|0,(p-l|0)<160):0){l=c[n>>2]|0;c[m>>2]=p+4;c[p>>2]=l;p=0}else p=0}else p=-1;else{if((b|0)==(j|0)?(j=a[k>>0]|0,(((j&1)==0?(j&255)>>>1:c[k+4>>2]|0)|0)!=0):0){if(!(a[e>>0]|0)){p=-1;break}p=c[m>>2]|0;if((p-l|0)>=160){p=0;break}l=c[n>>2]|0;c[m>>2]=p+4;c[p>>2]=l;c[n>>2]=0;p=0;break}i=o+128|0;p=o;while(1){if((c[p>>2]|0)==(b|0))break;p=p+4|0;if((p|0)==(i|0)){p=i;break}}i=p-o|0;p=i>>2;if((i|0)<=124){j=a[59857+p>>0]|0;switch(p|0){case 24:case 25:{p=c[h>>2]|0;if((p|0)!=(g|0)?(d[p+-1>>0]&95|0)!=(d[f>>0]&127|0):0){p=-1;break a}c[h>>2]=p+1;a[p>>0]=j;p=0;break a}case 23:case 22:{a[f>>0]=80;break}default:{p=j&95;if((((p|0)==(a[f>>0]|0)?(a[f>>0]=p|128,(a[e>>0]|0)!=0):0)?(a[e>>0]=0,f=a[k>>0]|0,(((f&1)==0?(f&255)>>>1:c[k+4>>2]|0)|0)!=0):0)?(q=c[m>>2]|0,(q-l|0)<160):0){l=c[n>>2]|0;c[m>>2]=q+4;c[q>>2]=l}}}m=c[h>>2]|0;c[h>>2]=m+1;a[m>>0]=j;if((i|0)>84)p=0;else{c[n>>2]=(c[n>>2]|0)+1;p=0}}else p=-1}while(0);return p|0}function ME(a){a=a|0;return}function NE(a){a=a|0;Uz(a);return}function OE(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0;n=i;i=i+32|0;h=n+20|0;j=n+16|0;k=n+12|0;m=n;a:do if(!(c[e+4>>2]&1)){m=c[(c[b>>2]|0)+24>>2]|0;c[j>>2]=c[d>>2];c[h>>2]=c[j>>2];h=sd[m&127](b,h,e,f,g&1)|0}else{h=lD(e)|0;c[k>>2]=h;o=0;j=Wa(115,k|0,41044)|0;l=o;o=0;b:do if(l&1){n=cc()|0;EL(h)|0;h=n}else{EL(h)|0;h=c[j>>2]|0;if(g)$c[c[h+24>>2]&511](m,j);else $c[c[h+28>>2]&511](m,j);b=a[m>>0]|0;l=(b&1)==0;h=m+1|0;g=m+8|0;k=l?h:m+1|0;h=l?h:c[m+8>>2]|0;l=m+4|0;e=(b&1)==0;c:do if((h|0)!=((e?k:c[g>>2]|0)+(e?(b&255)>>>1:c[l>>2]|0)|0)){d:while(1){j=a[h>>0]|0;f=c[d>>2]|0;do if(f){e=f+24|0;b=c[e>>2]|0;if((b|0)!=(c[f+28>>2]|0)){c[e>>2]=b+1;a[b>>0]=j;break}o=0;j=Wa(c[(c[f>>2]|0)+52>>2]|0,f|0,j&255|0)|0;b=o;o=0;if(b&1)break d;if((j|0)==-1)c[d>>2]=0}while(0);h=h+1|0;b=a[m>>0]|0;e=(b&1)==0;if((h|0)==((e?k:c[g>>2]|0)+(e?(b&255)>>>1:c[l>>2]|0)|0))break c}h=cc()|0;IC(m);break b}while(0);h=c[d>>2]|0;IC(m);break a}while(0);bc(h|0)}while(0);i=n;return h|0}function PE(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;n=i;i=i+64|0;h=n;q=n+56|0;r=n+44|0;k=n+20|0;m=n+16|0;l=n+12|0;p=n+8|0;j=n+4|0;a[q>>0]=a[61246]|0;a[q+1>>0]=a[61247]|0;a[q+2>>0]=a[61248]|0;a[q+3>>0]=a[61249]|0;a[q+4>>0]=a[61250]|0;a[q+5>>0]=a[61251]|0;QE(q+1|0,61252,1,c[e+4>>2]|0);b=rE()|0;c[h>>2]=g;g=r+(mK(r,12,b,q,h)|0)|0;q=RE(r,g,e)|0;b=lD(e)|0;c[p>>2]=b;o=0;Oa(46,r|0,q|0,g|0,k|0,m|0,l|0,p|0);g=o;o=0;if(g&1){r=cc()|0;EL(b)|0;bc(r|0)}else{EL(b)|0;c[j>>2]=c[d>>2];q=c[m>>2]|0;r=c[l>>2]|0;c[h>>2]=c[j>>2];r=ey(h,k,q,r,e,f)|0;i=n;return r|0}return 0}function QE(b,c,d,e){b=b|0;c=c|0;d=d|0;e=e|0;var f=0,g=0;if(e&2048){a[b>>0]=43;b=b+1|0}if(e&512){a[b>>0]=35;b=b+1|0}f=a[c>>0]|0;if(f<<24>>24){g=c;while(1){g=g+1|0;c=b+1|0;a[b>>0]=f;f=a[g>>0]|0;if(!(f<<24>>24)){b=c;break}else b=c}}a:do switch(e&74|0){case 64:{a[b>>0]=111;break}case 8:if(!(e&16384)){a[b>>0]=120;break a}else{a[b>>0]=88;break a}default:if(d){a[b>>0]=100;break a}else{a[b>>0]=117;break a}}while(0);return}function RE(b,d,e){b=b|0;d=d|0;e=e|0;var f=0;a:do switch(c[e+4>>2]&176|0){case 16:{e=a[b>>0]|0;switch(e<<24>>24){case 43:case 45:{b=b+1|0;break a}default:{}}if((d-b|0)>1&e<<24>>24==48){switch(a[b+1>>0]|0){case 88:case 120:break;default:{f=7;break a}}b=b+2|0}else f=7;break}case 32:{b=d;break}default:f=7}while(0);return b|0}function SE(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;v=i;i=i+16|0;w=v;t=cI(j,40904)|0;m=cI(j,41044)|0;$c[c[(c[m>>2]|0)+20>>2]&511](w,m);r=a[w>>0]|0;s=w+4|0;a:do if(!(((r&1)==0?(r&255)>>>1:c[s>>2]|0)|0)){o=0;kb(c[(c[t>>2]|0)+32>>2]|0,t|0,b|0,e|0,f|0)|0;u=o;o=0;if(u&1)u=5;else{j=f+(e-b)|0;c[h>>2]=j;u=29}}else{c[h>>2]=f;j=a[b>>0]|0;switch(j<<24>>24){case 43:case 45:{o=0;j=Wa(c[(c[t>>2]|0)+28>>2]|0,t|0,j|0)|0;r=o;o=0;if(r&1){u=5;break a}l=c[h>>2]|0;c[h>>2]=l+1;a[l>>0]=j;l=b+1|0;break}default:l=b}b:do if((e-l|0)>1?(a[l>>0]|0)==48:0){j=l+1|0;switch(a[j>>0]|0){case 88:case 120:break;default:break b}o=0;k=Wa(c[(c[t>>2]|0)+28>>2]|0,t|0,48)|0;r=o;o=0;if(r&1){u=5;break a}r=c[h>>2]|0;c[h>>2]=r+1;a[r>>0]=k;o=0;j=Wa(c[(c[t>>2]|0)+28>>2]|0,t|0,a[j>>0]|0)|0;r=o;o=0;if(r&1){u=5;break a}r=c[h>>2]|0;c[h>>2]=r+1;a[r>>0]=j;l=l+2|0}while(0);if((l|0)!=(e|0)?(n=e+-1|0,l>>>0<n>>>0):0){k=l;j=n;do{r=a[k>>0]|0;a[k>>0]=a[j>>0]|0;a[j>>0]=r;k=k+1|0;j=j+-1|0}while(k>>>0<j>>>0)}o=0;n=qa(c[(c[m>>2]|0)+16>>2]|0,m|0)|0;r=o;o=0;if(!(r&1)){p=w+8|0;q=w+1|0;c:do if(l>>>0<e>>>0){j=0;k=0;r=l;while(1){m=a[((a[w>>0]&1)==0?q:c[p>>2]|0)+k>>0]|0;if(m<<24>>24!=0&(j|0)==(m<<24>>24|0)){j=c[h>>2]|0;c[h>>2]=j+1;a[j>>0]=n;j=a[w>>0]|0;m=0;k=(k>>>0<(((j&1)==0?(j&255)>>>1:c[s>>2]|0)+-1|0)>>>0&1)+k|0}else m=j;o=0;j=Wa(c[(c[t>>2]|0)+28>>2]|0,t|0,a[r>>0]|0)|0;x=o;o=0;if(x&1)break;x=c[h>>2]|0;c[h>>2]=x+1;a[x>>0]=j;r=r+1|0;if(r>>>0>=e>>>0)break c;else j=m+1|0}j=cc()|0;break a}while(0);k=b;j=f+(l-k)|0;b=c[h>>2]|0;if((j|0)==(b|0)){b=k;u=29}else{b=b+-1|0;if(j>>>0<b>>>0)do{x=a[j>>0]|0;a[j>>0]=a[b>>0]|0;a[b>>0]=x;j=j+1|0;b=b+-1|0}while(j>>>0<b>>>0);b=k;j=c[h>>2]|0;u=29}}else u=5}while(0);if((u|0)==5)j=cc()|0;else if((u|0)==29){c[g>>2]=(d|0)==(e|0)?j:f+(d-b)|0;IC(w);i=v;return}IC(w);bc(j|0)}function TE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;n=i;i=i+96|0;h=n+8|0;a=n;q=n+74|0;k=n+32|0;m=n+28|0;l=n+24|0;p=n+20|0;j=n+16|0;r=a;c[r>>2]=37;c[r+4>>2]=0;QE(a+1|0,61254,1,c[d+4>>2]|0);r=rE()|0;s=h;c[s>>2]=f;c[s+4>>2]=g;g=q+(mK(q,22,r,a,h)|0)|0;f=RE(q,g,d)|0;a=lD(d)|0;c[p>>2]=a;o=0;Oa(46,q|0,f|0,g|0,k|0,m|0,l|0,p|0);g=o;o=0;if(g&1){s=cc()|0;EL(a)|0;bc(s|0)}else{EL(a)|0;c[j>>2]=c[b>>2];r=c[m>>2]|0;s=c[l>>2]|0;c[h>>2]=c[j>>2];s=ey(h,k,r,s,d,e)|0;i=n;return s|0}return 0}function UE(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;n=i;i=i+64|0;h=n;q=n+56|0;r=n+44|0;k=n+20|0;m=n+16|0;l=n+12|0;p=n+8|0;j=n+4|0;a[q>>0]=a[61246]|0;a[q+1>>0]=a[61247]|0;a[q+2>>0]=a[61248]|0;a[q+3>>0]=a[61249]|0;a[q+4>>0]=a[61250]|0;a[q+5>>0]=a[61251]|0;QE(q+1|0,61252,0,c[e+4>>2]|0);b=rE()|0;c[h>>2]=g;g=r+(mK(r,12,b,q,h)|0)|0;q=RE(r,g,e)|0;b=lD(e)|0;c[p>>2]=b;o=0;Oa(46,r|0,q|0,g|0,k|0,m|0,l|0,p|0);g=o;o=0;if(g&1){r=cc()|0;EL(b)|0;bc(r|0)}else{EL(b)|0;c[j>>2]=c[d>>2];q=c[m>>2]|0;r=c[l>>2]|0;c[h>>2]=c[j>>2];r=ey(h,k,q,r,e,f)|0;i=n;return r|0}return 0}function VE(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;n=i;i=i+112|0;h=n+8|0;a=n;q=n+75|0;k=n+32|0;m=n+28|0;l=n+24|0;p=n+20|0;j=n+16|0;r=a;c[r>>2]=37;c[r+4>>2]=0;QE(a+1|0,61254,0,c[d+4>>2]|0);r=rE()|0;s=h;c[s>>2]=f;c[s+4>>2]=g;g=q+(mK(q,23,r,a,h)|0)|0;f=RE(q,g,d)|0;a=lD(d)|0;c[p>>2]=a;o=0;Oa(46,q|0,f|0,g|0,k|0,m|0,l|0,p|0);g=o;o=0;if(g&1){s=cc()|0;EL(a)|0;bc(s|0)}else{EL(a)|0;c[j>>2]=c[b>>2];r=c[m>>2]|0;s=c[l>>2]|0;c[h>>2]=c[j>>2];s=ey(h,k,r,s,d,e)|0;i=n;return s|0}return 0}function WE(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=+f;var g=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;z=i;i=i+176|0;u=z+84|0;q=z+48|0;p=z+32|0;l=z+24|0;g=z+8|0;n=z;s=z+88|0;t=z+80|0;k=z+118|0;y=z+76|0;x=z+72|0;v=z+68|0;w=z+64|0;m=n;c[m>>2]=37;c[m+4>>2]=0;m=XE(n+1|0,61257,c[d+4>>2]|0)|0;c[t>>2]=s;a=rE()|0;if(m){c[g>>2]=c[d+8>>2];h[g+8>>3]=f;g=mK(s,30,a,n,g)|0}else{h[l>>3]=f;g=mK(s,30,a,n,l)|0}a:do if((g|0)>29){o=0;a=gb(45)|0;g=o;o=0;g=g&1;if(m){if(!g?(o=0,c[p>>2]=c[d+8>>2],h[p+8>>3]=f,j=kb(65,t|0,a|0,n|0,p|0)|0,r=o,o=0,!(r&1)):0)A=12}else if(!g?(o=0,c[q>>2]=c[d+8>>2],h[q+8>>3]=f,r=kb(65,t|0,a|0,n|0,q|0)|0,q=o,o=0,!(q&1)):0){j=r;A=12}do if((A|0)==12){a=c[t>>2]|0;if(!a){o=0;ob(46);r=o;o=0;if(r&1)break;g=c[t>>2]|0}else g=a;a=g;n=g;A=16;break a}while(0);a=cc()|0}else{a=c[t>>2]|0;n=0;j=g;A=16}while(0);if((A|0)==16){l=a+j|0;m=RE(a,l,d)|0;do if((a|0)==(s|0)){a=s;g=0;A=22}else{j=yC(j<<1)|0;if(!j){o=0;ob(46);A=o;o=0;if(A&1){g=0;A=20;break}a=c[t>>2]|0}g=j;k=j;A=22}while(0);do if((A|0)==22){o=0;j=qa(192,d|0)|0;t=o;o=0;if(!(t&1)){c[v>>2]=j;o=0;Oa(47,a|0,m|0,l|0,k|0,y|0,x|0,v|0);v=o;o=0;if(v&1){a=cc()|0;EL(j)|0;break}EL(j)|0;c[w>>2]=c[b>>2];A=c[y>>2]|0;a=c[x>>2]|0;o=0;c[u>>2]=c[w>>2];a=oa(83,u|0,k|0,A|0,a|0,d|0,e|0)|0;A=o;o=0;if(!(A&1)){c[b>>2]=a;if(g)zC(g);if(n)zC(n);i=z;return a|0}else A=20}else A=20}while(0);if((A|0)==20)a=cc()|0;if(g)zC(g);if(n)zC(n)}bc(a|0);return 0}function XE(b,c,d){b=b|0;c=c|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;if(d&2048){a[b>>0]=43;b=b+1|0}if(d&1024){a[b>>0]=35;b=b+1|0}h=d&260;f=d>>>14;i=(h|0)==260;if(i)g=0;else{a[b>>0]=46;a[b+1>>0]=42;b=b+2|0;g=1}d=a[c>>0]|0;if(d<<24>>24){e=b;while(1){c=c+1|0;b=e+1|0;a[e>>0]=d;d=a[c>>0]|0;if(!(d<<24>>24))break;else e=b}}a:do switch(h|0){case 4:if(!(f&1)){a[b>>0]=102;break a}else{a[b>>0]=70;break a}case 256:if(!(f&1)){a[b>>0]=101;break a}else{a[b>>0]=69;break a}default:{d=(f&1|0)!=0;if(i)if(d){a[b>>0]=65;break a}else{a[b>>0]=97;break a}else if(d){a[b>>0]=71;break a}else{a[b>>0]=103;break a}}}while(0);return g|0}function YE(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;z=i;i=i+16|0;A=z;y=cI(j,40904)|0;w=cI(j,41044)|0;$c[c[(c[w>>2]|0)+20>>2]&511](A,w);c[h>>2]=f;j=a[b>>0]|0;switch(j<<24>>24){case 43:case 45:{o=0;j=Wa(c[(c[y>>2]|0)+28>>2]|0,y|0,j|0)|0;x=o;o=0;if(x&1)v=8;else{n=c[h>>2]|0;c[h>>2]=n+1;a[n>>0]=j;n=b+1|0;v=10}break}default:{n=b;v=10}}a:do if((v|0)==10){x=e;b:do if((x-n|0)>1?(a[n>>0]|0)==48:0){l=n+1|0;switch(a[l>>0]|0){case 88:case 120:break;default:{v=11;break b}}o=0;j=Wa(c[(c[y>>2]|0)+28>>2]|0,y|0,48)|0;u=o;o=0;if(u&1){v=8;break a}u=c[h>>2]|0;c[h>>2]=u+1;a[u>>0]=j;n=n+2|0;o=0;j=Wa(c[(c[y>>2]|0)+28>>2]|0,y|0,a[l>>0]|0)|0;u=o;o=0;if(u&1){v=8;break a}u=c[h>>2]|0;c[h>>2]=u+1;a[u>>0]=j;if(n>>>0<e>>>0){j=n;while(1){l=a[j>>0]|0;o=0;m=gb(45)|0;u=o;o=0;if(u&1)break;o=0;l=Wa(116,l<<24>>24|0,m|0)|0;u=o;o=0;if(u&1)break;if(!l){u=n;break b}j=j+1|0;if(j>>>0>=e>>>0){u=n;break b}}j=cc()|0;break a}else{u=n;j=n}}else v=11;while(0);c:do if((v|0)==11)if(n>>>0<e>>>0){j=n;while(1){l=a[j>>0]|0;o=0;m=gb(45)|0;u=o;o=0;if(u&1)break;o=0;l=Wa(117,l<<24>>24|0,m|0)|0;u=o;o=0;if(u&1)break;if(!l){u=n;break c}j=j+1|0;if(j>>>0>=e>>>0){u=n;break c}}j=cc()|0;break a}else{u=n;j=n}while(0);s=a[A>>0]|0;t=A+4|0;if(((s&1)==0?(s&255)>>>1:c[t>>2]|0)|0){if((u|0)!=(j|0)?(p=j+-1|0,u>>>0<p>>>0):0){m=u;l=p;do{s=a[m>>0]|0;a[m>>0]=a[l>>0]|0;a[l>>0]=s;m=m+1|0;l=l+-1|0}while(m>>>0<l>>>0)}o=0;p=qa(c[(c[w>>2]|0)+16>>2]|0,w|0)|0;s=o;o=0;if(s&1){v=8;break}q=A+8|0;r=A+1|0;d:do if(u>>>0<j>>>0){l=0;m=0;s=u;while(1){n=a[((a[A>>0]&1)==0?r:c[q>>2]|0)+m>>0]|0;if(n<<24>>24>0&(l|0)==(n<<24>>24|0)){l=c[h>>2]|0;c[h>>2]=l+1;a[l>>0]=p;l=a[A>>0]|0;n=0;m=(m>>>0<(((l&1)==0?(l&255)>>>1:c[t>>2]|0)+-1|0)>>>0&1)+m|0}else n=l;o=0;l=Wa(c[(c[y>>2]|0)+28>>2]|0,y|0,a[s>>0]|0)|0;B=o;o=0;if(B&1)break;B=c[h>>2]|0;c[h>>2]=B+1;a[B>>0]=l;s=s+1|0;if(s>>>0>=j>>>0)break d;else l=n+1|0}j=cc()|0;break a}while(0);l=f+(u-b)|0;m=c[h>>2]|0;if((l|0)!=(m|0)?(k=m+-1|0,l>>>0<k>>>0):0){do{B=a[l>>0]|0;a[l>>0]=a[k>>0]|0;a[k>>0]=B;l=l+1|0;k=k+-1|0}while(l>>>0<k>>>0);l=y}else l=y}else{o=0;kb(c[(c[y>>2]|0)+32>>2]|0,y|0,u|0,j|0,c[h>>2]|0)|0;B=o;o=0;if(B&1){v=8;break}c[h>>2]=(c[h>>2]|0)+(j-u);l=y}e:do if(j>>>0<e>>>0){while(1){k=a[j>>0]|0;if(k<<24>>24==46)break;o=0;k=Wa(c[(c[l>>2]|0)+28>>2]|0,y|0,k|0)|0;B=o;o=0;if(B&1){v=4;break}B=c[h>>2]|0;c[h>>2]=B+1;a[B>>0]=k;j=j+1|0;if(j>>>0>=e>>>0)break e}if((v|0)==4){j=cc()|0;break a}o=0;k=qa(c[(c[w>>2]|0)+12>>2]|0,w|0)|0;B=o;o=0;if(B&1){v=8;break a}B=c[h>>2]|0;c[h>>2]=B+1;a[B>>0]=k;j=j+1|0}while(0);o=0;kb(c[(c[y>>2]|0)+32>>2]|0,y|0,j|0,e|0,c[h>>2]|0)|0;B=o;o=0;if(B&1)v=8;else{B=(c[h>>2]|0)+(x-j)|0;c[h>>2]=B;c[g>>2]=(d|0)==(e|0)?B:f+(d-b)|0;IC(A);i=z;return}}while(0);if((v|0)==8)j=cc()|0;IC(A);bc(j|0)}function ZE(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=+f;var g=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;z=i;i=i+176|0;u=z+76|0;q=z+48|0;p=z+32|0;l=z+24|0;g=z+8|0;n=z;s=z+80|0;t=z+72|0;k=z+110|0;y=z+68|0;x=z+64|0;v=z+60|0;w=z+56|0;m=n;c[m>>2]=37;c[m+4>>2]=0;m=XE(n+1|0,61258,c[d+4>>2]|0)|0;c[t>>2]=s;a=rE()|0;if(m){c[g>>2]=c[d+8>>2];h[g+8>>3]=f;g=mK(s,30,a,n,g)|0}else{h[l>>3]=f;g=mK(s,30,a,n,l)|0}a:do if((g|0)>29){o=0;a=gb(45)|0;g=o;o=0;g=g&1;if(m){if(!g?(o=0,c[p>>2]=c[d+8>>2],h[p+8>>3]=f,j=kb(65,t|0,a|0,n|0,p|0)|0,r=o,o=0,!(r&1)):0)A=12}else if(!g?(o=0,h[q>>3]=f,r=kb(65,t|0,a|0,n|0,q|0)|0,q=o,o=0,!(q&1)):0){j=r;A=12}do if((A|0)==12){a=c[t>>2]|0;if(!a){o=0;ob(46);r=o;o=0;if(r&1)break;g=c[t>>2]|0}else g=a;a=g;n=g;A=16;break a}while(0);a=cc()|0}else{a=c[t>>2]|0;n=0;j=g;A=16}while(0);if((A|0)==16){l=a+j|0;m=RE(a,l,d)|0;do if((a|0)==(s|0)){a=s;g=0;A=22}else{j=yC(j<<1)|0;if(!j){o=0;ob(46);A=o;o=0;if(A&1){g=0;A=20;break}a=c[t>>2]|0}g=j;k=j;A=22}while(0);do if((A|0)==22){o=0;j=qa(192,d|0)|0;t=o;o=0;if(!(t&1)){c[v>>2]=j;o=0;Oa(47,a|0,m|0,l|0,k|0,y|0,x|0,v|0);v=o;o=0;if(v&1){a=cc()|0;EL(j)|0;break}EL(j)|0;c[w>>2]=c[b>>2];A=c[y>>2]|0;a=c[x>>2]|0;o=0;c[u>>2]=c[w>>2];a=oa(83,u|0,k|0,A|0,a|0,d|0,e|0)|0;A=o;o=0;if(!(A&1)){c[b>>2]=a;if(g)zC(g);if(n)zC(n);i=z;return a|0}else A=20}else A=20}while(0);if((A|0)==20)a=cc()|0;if(g)zC(g);if(n)zC(n)}bc(a|0);return 0}function _E(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;q=i;i=i+80|0;l=q;b=q+70|0;n=q+12|0;p=q+32|0;k=q+8|0;m=q+4|0;a[b>>0]=a[61260]|0;a[b+1>>0]=a[61261]|0;a[b+2>>0]=a[61262]|0;a[b+3>>0]=a[61263]|0;a[b+4>>0]=a[61264]|0;a[b+5>>0]=a[61265]|0;h=rE()|0;c[l>>2]=g;b=mK(n,20,h,b,l)|0;g=n+b|0;h=RE(n,g,e)|0;j=lD(e)|0;c[k>>2]=j;o=0;k=Wa(115,k|0,40904)|0;r=o;o=0;if(r&1){r=cc()|0;EL(j)|0;bc(r|0)}else{EL(j)|0;zd[c[(c[k>>2]|0)+32>>2]&127](k,n,g,p)|0;r=p+b|0;c[m>>2]=c[d>>2];c[l>>2]=c[m>>2];r=ey(l,p,(h|0)==(g|0)?r:p+(h-n)|0,r,e,f)|0;i=q;return r|0}return 0}function $E(a){a=a|0;return}function aF(a){a=a|0;Uz(a);return}function bF(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;m=i;i=i+32|0;h=m+20|0;j=m+16|0;k=m+12|0;l=m;a:do if(!(c[e+4>>2]&1)){l=c[(c[b>>2]|0)+24>>2]|0;c[j>>2]=c[d>>2];c[h>>2]=c[j>>2];h=sd[l&127](b,h,e,f,g&1)|0}else{h=lD(e)|0;c[k>>2]=h;o=0;j=Wa(115,k|0,41052)|0;k=o;o=0;b:do if(k&1){m=cc()|0;EL(h)|0;h=m}else{EL(h)|0;h=c[j>>2]|0;if(g)$c[c[h+24>>2]&511](l,j);else $c[c[h+28>>2]&511](l,j);b=a[l>>0]|0;e=(b&1)==0;h=l+4|0;g=l+8|0;k=e?h:l+4|0;h=e?h:c[l+8>>2]|0;e=(b&1)==0;c:do if((h|0)!=((e?k:c[g>>2]|0)+((e?(b&255)>>>1:c[k>>2]|0)<<2)|0)){while(1){j=c[h>>2]|0;f=c[d>>2]|0;if(f){e=f+24|0;b=c[e>>2]|0;if((b|0)==(c[f+28>>2]|0)){o=0;j=Wa(c[(c[f>>2]|0)+52>>2]|0,f|0,j|0)|0;b=o;o=0;if(b&1)break}else{c[e>>2]=b+4;c[b>>2]=j}if((j|0)==-1)c[d>>2]=0}h=h+4|0;b=a[l>>0]|0;e=(b&1)==0;if((h|0)==((e?k:c[g>>2]|0)+((e?(b&255)>>>1:c[k>>2]|0)<<2)|0))break c}h=cc()|0;ZC(l);break b}while(0);h=c[d>>2]|0;ZC(l);break a}while(0);bc(h|0)}while(0);i=m;return h|0}function cF(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;n=i;i=i+128|0;h=n;q=n+116|0;r=n+104|0;k=n+20|0;m=n+16|0;l=n+12|0;p=n+8|0;j=n+4|0;a[q>>0]=a[61246]|0;a[q+1>>0]=a[61247]|0;a[q+2>>0]=a[61248]|0;a[q+3>>0]=a[61249]|0;a[q+4>>0]=a[61250]|0;a[q+5>>0]=a[61251]|0;QE(q+1|0,61252,1,c[e+4>>2]|0);b=rE()|0;c[h>>2]=g;g=r+(mK(r,12,b,q,h)|0)|0;q=RE(r,g,e)|0;b=lD(e)|0;c[p>>2]=b;o=0;Oa(48,r|0,q|0,g|0,k|0,m|0,l|0,p|0);g=o;o=0;if(g&1){r=cc()|0;EL(b)|0;bc(r|0)}else{EL(b)|0;c[j>>2]=c[d>>2];q=c[m>>2]|0;r=c[l>>2]|0;c[h>>2]=c[j>>2];r=oK(h,k,q,r,e,f)|0;i=n;return r|0}return 0}function dF(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;v=i;i=i+16|0;w=v;t=cI(j,40896)|0;m=cI(j,41052)|0;$c[c[(c[m>>2]|0)+20>>2]&511](w,m);r=a[w>>0]|0;s=w+4|0;a:do if(!(((r&1)==0?(r&255)>>>1:c[s>>2]|0)|0)){o=0;kb(c[(c[t>>2]|0)+48>>2]|0,t|0,b|0,e|0,f|0)|0;u=o;o=0;if(u&1)u=5;else{j=f+(e-b<<2)|0;c[h>>2]=j;u=28}}else{c[h>>2]=f;j=a[b>>0]|0;switch(j<<24>>24){case 43:case 45:{o=0;j=Wa(c[(c[t>>2]|0)+44>>2]|0,t|0,j|0)|0;r=o;o=0;if(r&1){u=5;break a}l=c[h>>2]|0;c[h>>2]=l+4;c[l>>2]=j;l=b+1|0;break}default:l=b}b:do if((e-l|0)>1?(a[l>>0]|0)==48:0){j=l+1|0;switch(a[j>>0]|0){case 88:case 120:break;default:{r=l;break b}}o=0;k=Wa(c[(c[t>>2]|0)+44>>2]|0,t|0,48)|0;r=o;o=0;if(r&1){u=5;break a}r=c[h>>2]|0;c[h>>2]=r+4;c[r>>2]=k;o=0;j=Wa(c[(c[t>>2]|0)+44>>2]|0,t|0,a[j>>0]|0)|0;r=o;o=0;if(r&1){u=5;break a}r=c[h>>2]|0;c[h>>2]=r+4;c[r>>2]=j;r=l+2|0}else r=l;while(0);if((r|0)!=(e|0)?(n=e+-1|0,r>>>0<n>>>0):0){k=r;j=n;do{q=a[k>>0]|0;a[k>>0]=a[j>>0]|0;a[j>>0]=q;k=k+1|0;j=j+-1|0}while(k>>>0<j>>>0)}o=0;m=qa(c[(c[m>>2]|0)+16>>2]|0,m|0)|0;q=o;o=0;if(!(q&1)){n=w+8|0;p=w+1|0;c:do if(r>>>0<e>>>0){j=0;k=0;q=r;while(1){l=a[((a[w>>0]&1)==0?p:c[n>>2]|0)+k>>0]|0;if(l<<24>>24!=0&(j|0)==(l<<24>>24|0)){j=c[h>>2]|0;c[h>>2]=j+4;c[j>>2]=m;j=a[w>>0]|0;l=0;k=(k>>>0<(((j&1)==0?(j&255)>>>1:c[s>>2]|0)+-1|0)>>>0&1)+k|0}else l=j;o=0;j=Wa(c[(c[t>>2]|0)+44>>2]|0,t|0,a[q>>0]|0)|0;x=o;o=0;if(x&1)break;x=c[h>>2]|0;c[h>>2]=x+4;c[x>>2]=j;q=q+1|0;if(q>>>0>=e>>>0)break c;else j=l+1|0}j=cc()|0;break a}while(0);l=b;j=f+(r-l<<2)|0;k=c[h>>2]|0;if((j|0)!=(k|0)){b=k+-4|0;if(j>>>0<b>>>0){do{x=c[j>>2]|0;c[j>>2]=c[b>>2];c[b>>2]=x;j=j+4|0;b=b+-4|0}while(j>>>0<b>>>0);b=l;j=k;u=28}else{b=l;j=k;u=28}}else{b=l;u=28}}else u=5}while(0);if((u|0)==5)j=cc()|0;else if((u|0)==28){c[g>>2]=(d|0)==(e|0)?j:f+(d-b<<2)|0;IC(w);i=v;return}IC(w);bc(j|0)}function eF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;n=i;i=i+224|0;h=n+8|0;a=n;q=n+196|0;k=n+32|0;m=n+28|0;l=n+24|0;p=n+20|0;j=n+16|0;r=a;c[r>>2]=37;c[r+4>>2]=0;QE(a+1|0,61254,1,c[d+4>>2]|0);r=rE()|0;s=h;c[s>>2]=f;c[s+4>>2]=g;g=q+(mK(q,22,r,a,h)|0)|0;f=RE(q,g,d)|0;a=lD(d)|0;c[p>>2]=a;o=0;Oa(48,q|0,f|0,g|0,k|0,m|0,l|0,p|0);g=o;o=0;if(g&1){s=cc()|0;EL(a)|0;bc(s|0)}else{EL(a)|0;c[j>>2]=c[b>>2];r=c[m>>2]|0;s=c[l>>2]|0;c[h>>2]=c[j>>2];s=oK(h,k,r,s,d,e)|0;i=n;return s|0}return 0}function fF(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;n=i;i=i+128|0;h=n;q=n+116|0;r=n+104|0;k=n+20|0;m=n+16|0;l=n+12|0;p=n+8|0;j=n+4|0;a[q>>0]=a[61246]|0;a[q+1>>0]=a[61247]|0;a[q+2>>0]=a[61248]|0;a[q+3>>0]=a[61249]|0;a[q+4>>0]=a[61250]|0;a[q+5>>0]=a[61251]|0;QE(q+1|0,61252,0,c[e+4>>2]|0);b=rE()|0;c[h>>2]=g;g=r+(mK(r,12,b,q,h)|0)|0;q=RE(r,g,e)|0;b=lD(e)|0;c[p>>2]=b;o=0;Oa(48,r|0,q|0,g|0,k|0,m|0,l|0,p|0);g=o;o=0;if(g&1){r=cc()|0;EL(b)|0;bc(r|0)}else{EL(b)|0;c[j>>2]=c[d>>2];q=c[m>>2]|0;r=c[l>>2]|0;c[h>>2]=c[j>>2];r=oK(h,k,q,r,e,f)|0;i=n;return r|0}return 0}function gF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;n=i;i=i+240|0;h=n+8|0;a=n;q=n+204|0;k=n+32|0;m=n+28|0;l=n+24|0;p=n+20|0;j=n+16|0;r=a;c[r>>2]=37;c[r+4>>2]=0;QE(a+1|0,61254,0,c[d+4>>2]|0);r=rE()|0;s=h;c[s>>2]=f;c[s+4>>2]=g;g=q+(mK(q,23,r,a,h)|0)|0;f=RE(q,g,d)|0;a=lD(d)|0;c[p>>2]=a;o=0;Oa(48,q|0,f|0,g|0,k|0,m|0,l|0,p|0);g=o;o=0;if(g&1){s=cc()|0;EL(a)|0;bc(s|0)}else{EL(a)|0;c[j>>2]=c[b>>2];r=c[m>>2]|0;s=c[l>>2]|0;c[h>>2]=c[j>>2];s=oK(h,k,r,s,d,e)|0;i=n;return s|0}return 0}function hF(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=+f;var g=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;z=i;i=i+352|0;u=z+312|0;q=z+48|0;p=z+32|0;l=z+24|0;g=z+8|0;n=z;s=z+316|0;t=z+80|0;k=z+84|0;y=z+76|0;x=z+72|0;v=z+68|0;w=z+64|0;m=n;c[m>>2]=37;c[m+4>>2]=0;m=XE(n+1|0,61257,c[d+4>>2]|0)|0;c[t>>2]=s;a=rE()|0;if(m){c[g>>2]=c[d+8>>2];h[g+8>>3]=f;g=mK(s,30,a,n,g)|0}else{h[l>>3]=f;g=mK(s,30,a,n,l)|0}a:do if((g|0)>29){o=0;a=gb(45)|0;g=o;o=0;g=g&1;if(m){if(!g?(o=0,c[p>>2]=c[d+8>>2],h[p+8>>3]=f,j=kb(65,t|0,a|0,n|0,p|0)|0,r=o,o=0,!(r&1)):0)A=12}else if(!g?(o=0,c[q>>2]=c[d+8>>2],h[q+8>>3]=f,r=kb(65,t|0,a|0,n|0,q|0)|0,q=o,o=0,!(q&1)):0){j=r;A=12}do if((A|0)==12){a=c[t>>2]|0;if(!a){o=0;ob(46);r=o;o=0;if(r&1)break;g=c[t>>2]|0}else g=a;a=g;n=g;A=16;break a}while(0);a=cc()|0}else{a=c[t>>2]|0;n=0;j=g;A=16}while(0);if((A|0)==16){l=a+j|0;m=RE(a,l,d)|0;do if((a|0)==(s|0)){a=s;g=0;A=22}else{j=yC(j<<3)|0;if(!j){o=0;ob(46);A=o;o=0;if(A&1){g=0;A=20;break}a=c[t>>2]|0}g=j;k=j;A=22}while(0);do if((A|0)==22){o=0;j=qa(192,d|0)|0;t=o;o=0;if(!(t&1)){c[v>>2]=j;o=0;Oa(49,a|0,m|0,l|0,k|0,y|0,x|0,v|0);v=o;o=0;if(v&1){a=cc()|0;EL(j)|0;break}EL(j)|0;c[w>>2]=c[b>>2];A=c[y>>2]|0;a=c[x>>2]|0;o=0;c[u>>2]=c[w>>2];a=oa(84,u|0,k|0,A|0,a|0,d|0,e|0)|0;A=o;o=0;if(!(A&1)){c[b>>2]=a;if(g)zC(g);if(n)zC(n);i=z;return a|0}else A=20}else A=20}while(0);if((A|0)==20)a=cc()|0;if(g)zC(g);if(n)zC(n)}bc(a|0);return 0}function iF(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;y=i;i=i+16|0;z=y;x=cI(j,40896)|0;v=cI(j,41052)|0;$c[c[(c[v>>2]|0)+20>>2]&511](z,v);c[h>>2]=f;j=a[b>>0]|0;switch(j<<24>>24){case 43:case 45:{o=0;j=Wa(c[(c[x>>2]|0)+44>>2]|0,x|0,j|0)|0;w=o;o=0;if(w&1)u=8;else{m=c[h>>2]|0;c[h>>2]=m+4;c[m>>2]=j;m=b+1|0;u=10}break}default:{m=b;u=10}}a:do if((u|0)==10){w=e;b:do if((w-m|0)>1?(a[m>>0]|0)==48:0){k=m+1|0;switch(a[k>>0]|0){case 88:case 120:break;default:{u=11;break b}}o=0;j=Wa(c[(c[x>>2]|0)+44>>2]|0,x|0,48)|0;t=o;o=0;if(t&1){u=8;break a}t=c[h>>2]|0;c[h>>2]=t+4;c[t>>2]=j;m=m+2|0;o=0;j=Wa(c[(c[x>>2]|0)+44>>2]|0,x|0,a[k>>0]|0)|0;t=o;o=0;if(t&1){u=8;break a}t=c[h>>2]|0;c[h>>2]=t+4;c[t>>2]=j;if(m>>>0<e>>>0){j=m;while(1){k=a[j>>0]|0;o=0;l=gb(45)|0;t=o;o=0;if(t&1)break;o=0;k=Wa(116,k<<24>>24|0,l|0)|0;t=o;o=0;if(t&1)break;if(!k){t=m;break b}j=j+1|0;if(j>>>0>=e>>>0){t=m;break b}}j=cc()|0;break a}else{t=m;j=m}}else u=11;while(0);c:do if((u|0)==11)if(m>>>0<e>>>0){j=m;while(1){k=a[j>>0]|0;o=0;l=gb(45)|0;t=o;o=0;if(t&1)break;o=0;k=Wa(117,k<<24>>24|0,l|0)|0;t=o;o=0;if(t&1)break;if(!k){t=m;break c}j=j+1|0;if(j>>>0>=e>>>0){t=m;break c}}j=cc()|0;break a}else{t=m;j=m}while(0);r=a[z>>0]|0;s=z+4|0;if(((r&1)==0?(r&255)>>>1:c[s>>2]|0)|0){if((t|0)!=(j|0)?(n=j+-1|0,t>>>0<n>>>0):0){l=t;k=n;do{r=a[l>>0]|0;a[l>>0]=a[k>>0]|0;a[k>>0]=r;l=l+1|0;k=k+-1|0}while(l>>>0<k>>>0)}o=0;n=qa(c[(c[v>>2]|0)+16>>2]|0,v|0)|0;r=o;o=0;if(r&1){u=8;break}p=z+8|0;q=z+1|0;d:do if(t>>>0<j>>>0){k=0;l=0;r=t;while(1){m=a[((a[z>>0]&1)==0?q:c[p>>2]|0)+l>>0]|0;if(m<<24>>24>0&(k|0)==(m<<24>>24|0)){k=c[h>>2]|0;c[h>>2]=k+4;c[k>>2]=n;k=a[z>>0]|0;m=0;l=(l>>>0<(((k&1)==0?(k&255)>>>1:c[s>>2]|0)+-1|0)>>>0&1)+l|0}else m=k;o=0;k=Wa(c[(c[x>>2]|0)+44>>2]|0,x|0,a[r>>0]|0)|0;A=o;o=0;if(A&1)break;A=c[h>>2]|0;c[h>>2]=A+4;c[A>>2]=k;r=r+1|0;if(r>>>0>=j>>>0)break d;else k=m+1|0}j=cc()|0;break a}while(0);k=f+(t-b<<2)|0;m=c[h>>2]|0;if((k|0)!=(m|0)){l=m+-4|0;if(k>>>0<l>>>0){do{A=c[k>>2]|0;c[k>>2]=c[l>>2];c[l>>2]=A;k=k+4|0;l=l+-4|0}while(k>>>0<l>>>0);n=x;k=m}else{n=x;k=m}}else n=x}else{o=0;kb(c[(c[x>>2]|0)+48>>2]|0,x|0,t|0,j|0,c[h>>2]|0)|0;A=o;o=0;if(A&1){u=8;break}k=(c[h>>2]|0)+(j-t<<2)|0;c[h>>2]=k;n=x}e:do if(j>>>0<e>>>0){while(1){k=a[j>>0]|0;if(k<<24>>24==46){l=j;break}o=0;l=Wa(c[(c[n>>2]|0)+44>>2]|0,x|0,k|0)|0;A=o;o=0;if(A&1){u=4;break}A=c[h>>2]|0;k=A+4|0;c[h>>2]=k;c[A>>2]=l;j=j+1|0;if(j>>>0>=e>>>0)break e}if((u|0)==4){j=cc()|0;break a}o=0;j=qa(c[(c[v>>2]|0)+12>>2]|0,v|0)|0;A=o;o=0;if(A&1){u=8;break a}A=c[h>>2]|0;k=A+4|0;c[h>>2]=k;c[A>>2]=j;j=l+1|0}while(0);o=0;kb(c[(c[x>>2]|0)+48>>2]|0,x|0,j|0,e|0,k|0)|0;A=o;o=0;if(A&1)u=8;else{A=(c[h>>2]|0)+(w-j<<2)|0;c[h>>2]=A;c[g>>2]=(d|0)==(e|0)?A:f+(d-b<<2)|0;IC(z);i=y;return}}while(0);if((u|0)==8)j=cc()|0;IC(z);bc(j|0)}function jF(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=+f;var g=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;z=i;i=i+352|0;u=z+304|0;q=z+48|0;p=z+32|0;l=z+24|0;g=z+8|0;n=z;s=z+308|0;t=z+72|0;k=z+76|0;y=z+68|0;x=z+64|0;v=z+60|0;w=z+56|0;m=n;c[m>>2]=37;c[m+4>>2]=0;m=XE(n+1|0,61258,c[d+4>>2]|0)|0;c[t>>2]=s;a=rE()|0;if(m){c[g>>2]=c[d+8>>2];h[g+8>>3]=f;g=mK(s,30,a,n,g)|0}else{h[l>>3]=f;g=mK(s,30,a,n,l)|0}a:do if((g|0)>29){o=0;a=gb(45)|0;g=o;o=0;g=g&1;if(m){if(!g?(o=0,c[p>>2]=c[d+8>>2],h[p+8>>3]=f,j=kb(65,t|0,a|0,n|0,p|0)|0,r=o,o=0,!(r&1)):0)A=12}else if(!g?(o=0,h[q>>3]=f,r=kb(65,t|0,a|0,n|0,q|0)|0,q=o,o=0,!(q&1)):0){j=r;A=12}do if((A|0)==12){a=c[t>>2]|0;if(!a){o=0;ob(46);r=o;o=0;if(r&1)break;g=c[t>>2]|0}else g=a;a=g;n=g;A=16;break a}while(0);a=cc()|0}else{a=c[t>>2]|0;n=0;j=g;A=16}while(0);if((A|0)==16){l=a+j|0;m=RE(a,l,d)|0;do if((a|0)==(s|0)){a=s;g=0;A=22}else{j=yC(j<<3)|0;if(!j){o=0;ob(46);A=o;o=0;if(A&1){g=0;A=20;break}a=c[t>>2]|0}g=j;k=j;A=22}while(0);do if((A|0)==22){o=0;j=qa(192,d|0)|0;t=o;o=0;if(!(t&1)){c[v>>2]=j;o=0;Oa(49,a|0,m|0,l|0,k|0,y|0,x|0,v|0);v=o;o=0;if(v&1){a=cc()|0;EL(j)|0;break}EL(j)|0;c[w>>2]=c[b>>2];A=c[y>>2]|0;a=c[x>>2]|0;o=0;c[u>>2]=c[w>>2];a=oa(84,u|0,k|0,A|0,a|0,d|0,e|0)|0;A=o;o=0;if(!(A&1)){c[b>>2]=a;if(g)zC(g);if(n)zC(n);i=z;return a|0}else A=20}else A=20}while(0);if((A|0)==20)a=cc()|0;if(g)zC(g);if(n)zC(n)}bc(a|0);return 0}function kF(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;q=i;i=i+192|0;l=q;b=q+180|0;n=q+160|0;p=q+12|0;k=q+8|0;m=q+4|0;a[b>>0]=a[61260]|0;a[b+1>>0]=a[61261]|0;a[b+2>>0]=a[61262]|0;a[b+3>>0]=a[61263]|0;a[b+4>>0]=a[61264]|0;a[b+5>>0]=a[61265]|0;h=rE()|0;c[l>>2]=g;b=mK(n,20,h,b,l)|0;g=n+b|0;h=RE(n,g,e)|0;j=lD(e)|0;c[k>>2]=j;o=0;k=Wa(115,k|0,40896)|0;r=o;o=0;if(r&1){r=cc()|0;EL(j)|0;bc(r|0)}else{EL(j)|0;zd[c[(c[k>>2]|0)+48>>2]&127](k,n,g,p)|0;r=p+(b<<2)|0;c[m>>2]=c[d>>2];c[l>>2]=c[m>>2];r=oK(l,p,(h|0)==(g|0)?r:p+(h-n<<2)|0,r,e,f)|0;i=q;return r|0}return 0}function lF(e,f,g,h,j,k,l,m){e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0;C=i;i=i+32|0;w=C+16|0;v=C+12|0;z=C+8|0;x=C+4|0;y=C;n=lD(h)|0;c[z>>2]=n;o=0;z=Wa(115,z|0,40904)|0;u=o;o=0;if(u&1){C=cc()|0;EL(n)|0;bc(C|0)}EL(n)|0;c[j>>2]=0;u=z+8|0;n=c[f>>2]|0;a:do if((l|0)!=(m|0)){b:while(1){p=n;if(n){if((c[n+12>>2]|0)==(c[n+16>>2]|0)?(bd[c[(c[n>>2]|0)+36>>2]&255](n)|0)==-1:0){c[f>>2]=0;n=0;p=0}}else n=0;s=(n|0)==0;r=c[g>>2]|0;q=r;do if(r){if((c[r+12>>2]|0)==(c[r+16>>2]|0)?(bd[c[(c[r>>2]|0)+36>>2]&255](r)|0)==-1:0){c[g>>2]=0;q=0;B=12;break}if(!s){B=13;break b}}else B=12;while(0);if((B|0)==12){B=0;if(s){B=13;break}else r=0}c:do if((fd[c[(c[z>>2]|0)+36>>2]&127](z,a[l>>0]|0,0)|0)<<24>>24==37){r=l+1|0;if((r|0)==(m|0)){B=17;break b}t=fd[c[(c[z>>2]|0)+36>>2]&127](z,a[r>>0]|0,0)|0;switch(t<<24>>24){case 48:case 69:{s=l+2|0;if((s|0)==(m|0)){B=20;break b}l=r;r=fd[c[(c[z>>2]|0)+36>>2]&127](z,a[s>>0]|0,0)|0;n=t;break}default:{r=t;n=0}}t=c[(c[e>>2]|0)+36>>2]|0;c[x>>2]=p;c[y>>2]=q;c[v>>2]=c[x>>2];c[w>>2]=c[y>>2];c[f>>2]=Cd[t&63](e,v,w,h,j,k,r,n)|0;l=l+2|0}else{p=a[l>>0]|0;if(p<<24>>24>-1?(A=c[u>>2]|0,(b[A+(p<<24>>24<<1)>>1]&8192)!=0):0){do{l=l+1|0;if((l|0)==(m|0)){l=m;break}p=a[l>>0]|0;if(p<<24>>24<=-1)break}while((b[A+(p<<24>>24<<1)>>1]&8192)!=0);p=r;while(1){if(n){if((c[n+12>>2]|0)==(c[n+16>>2]|0)?(bd[c[(c[n>>2]|0)+36>>2]&255](n)|0)==-1:0){c[f>>2]=0;n=0}}else n=0;q=(n|0)==0;do if(r){if((c[r+12>>2]|0)!=(c[r+16>>2]|0))if(q){t=p;break}else break c;if((bd[c[(c[r>>2]|0)+36>>2]&255](r)|0)!=-1)if(q^(p|0)==0){t=p;r=p;break}else break c;else{c[g>>2]=0;p=0;B=39;break}}else B=39;while(0);if((B|0)==39){B=0;if(q)break c;else{t=p;r=0}}q=n+12|0;p=c[q>>2]|0;s=n+16|0;if((p|0)==(c[s>>2]|0))p=bd[c[(c[n>>2]|0)+36>>2]&255](n)|0;else p=d[p>>0]|0;if((p&255)<<24>>24<=-1)break c;if(!(b[(c[u>>2]|0)+(p<<24>>24<<1)>>1]&8192))break c;p=c[q>>2]|0;if((p|0)==(c[s>>2]|0)){bd[c[(c[n>>2]|0)+40>>2]&255](n)|0;p=t;continue}else{c[q>>2]=p+1;p=t;continue}}}q=n+12|0;p=c[q>>2]|0;r=n+16|0;if((p|0)==(c[r>>2]|0))p=bd[c[(c[n>>2]|0)+36>>2]&255](n)|0;else p=d[p>>0]|0;t=rd[c[(c[z>>2]|0)+12>>2]&127](z,p&255)|0;if(t<<24>>24!=(rd[c[(c[z>>2]|0)+12>>2]&127](z,a[l>>0]|0)|0)<<24>>24){B=57;break b}p=c[q>>2]|0;if((p|0)==(c[r>>2]|0))bd[c[(c[n>>2]|0)+40>>2]&255](n)|0;else c[q>>2]=p+1;l=l+1|0}while(0);n=c[f>>2]|0;if(!((l|0)!=(m|0)&(c[j>>2]|0)==0))break a}if((B|0)==13){c[j>>2]=4;break}else if((B|0)==17){c[j>>2]=4;break}else if((B|0)==20){c[j>>2]=4;break}else if((B|0)==57){c[j>>2]=4;n=c[f>>2]|0;break}}while(0);if(n){if((c[n+12>>2]|0)==(c[n+16>>2]|0)?(bd[c[(c[n>>2]|0)+36>>2]&255](n)|0)==-1:0){c[f>>2]=0;n=0}}else n=0;l=(n|0)==0;p=c[g>>2]|0;do if(p){if((c[p+12>>2]|0)==(c[p+16>>2]|0)?(bd[c[(c[p>>2]|0)+36>>2]&255](p)|0)==-1:0){c[g>>2]=0;B=67;break}if(!l)B=68}else B=67;while(0);if((B|0)==67?l:0)B=68;if((B|0)==68)c[j>>2]=c[j>>2]|2;i=C;return n|0}function mF(a){a=a|0;return}function nF(a){a=a|0;Uz(a);return}function oF(a){a=a|0;return 2}function pF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=lF(a,k,j,e,f,g,61266,61274)|0;i=h;return a|0}function qF(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0;j=i;i=i+16|0;k=j+12|0;l=j+8|0;n=j+4|0;m=j;o=b+8|0;o=bd[c[(c[o>>2]|0)+20>>2]&255](o)|0;c[n>>2]=c[d>>2];c[m>>2]=c[e>>2];e=a[o>>0]|0;p=(e&1)==0;d=p?o+1|0:c[o+8>>2]|0;e=d+(p?(e&255)>>>1:c[o+4>>2]|0)|0;c[l>>2]=c[n>>2];c[k>>2]=c[m>>2];b=lF(b,l,k,f,g,h,d,e)|0;i=j;return b|0}function rF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;j=l+8|0;h=l+4|0;k=l;e=lD(e)|0;c[h>>2]=e;o=0;h=Wa(115,h|0,40904)|0;m=o;o=0;if(m&1){m=cc()|0;EL(e)|0;bc(m|0)}else{EL(e)|0;c[k>>2]=c[d>>2];c[j>>2]=c[k>>2];sF(a,g+24|0,b,j,f,h);i=l;return c[b>>2]|0}return 0}function sF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0;h=i;i=i+16|0;j=h+4|0;k=h;a=a+8|0;a=bd[c[c[a>>2]>>2]&255](a)|0;c[k>>2]=c[e>>2];c[j>>2]=c[k>>2];d=(TJ(d,j,a,a+168|0,g,f,0)|0)-a|0;if((d|0)<168)c[b>>2]=((d|0)/12|0|0)%7|0;i=h;return}function tF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;j=l+8|0;h=l+4|0;k=l;e=lD(e)|0;c[h>>2]=e;o=0;h=Wa(115,h|0,40904)|0;m=o;o=0;if(m&1){m=cc()|0;EL(e)|0;bc(m|0)}else{EL(e)|0;c[k>>2]=c[d>>2];c[j>>2]=c[k>>2];uF(a,g+16|0,b,j,f,h);i=l;return c[b>>2]|0}return 0}function uF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0;h=i;i=i+16|0;j=h+4|0;k=h;a=a+8|0;a=bd[c[(c[a>>2]|0)+4>>2]&255](a)|0;c[k>>2]=c[e>>2];c[j>>2]=c[k>>2];d=(TJ(d,j,a,a+288|0,g,f,0)|0)-a|0;if((d|0)<288)c[b>>2]=((d|0)/12|0|0)%12|0;i=h;return}function vF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;j=l+8|0;h=l+4|0;k=l;e=lD(e)|0;c[h>>2]=e;o=0;h=Wa(115,h|0,40904)|0;m=o;o=0;if(m&1){m=cc()|0;EL(e)|0;bc(m|0)}else{EL(e)|0;c[k>>2]=c[d>>2];c[j>>2]=c[k>>2];wF(a,g+20|0,b,j,f,h);i=l;return c[b>>2]|0}return 0}function wF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,4)|0;if(!(c[f>>2]&4)){if((a|0)<69)a=a+2e3|0;else a=(a+-69|0)>>>0<31?a+1900|0:a;c[b>>2]=a+-1900}i=h;return}function xF(b,d,e,f,g,h,j,k){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0;U=i;i=i+144|0;l=U+132|0;k=U+116|0;N=U+128|0;x=U+124|0;I=U+120|0;O=U+112|0;P=U+108|0;Q=U+104|0;R=U+100|0;S=U+96|0;T=U+92|0;m=U+88|0;n=U+84|0;p=U+80|0;q=U+76|0;r=U+72|0;s=U+68|0;t=U+64|0;u=U+60|0;v=U+56|0;w=U+52|0;y=U+48|0;z=U+44|0;A=U+40|0;B=U+36|0;C=U+32|0;D=U+28|0;E=U+24|0;F=U+20|0;G=U+16|0;H=U+12|0;J=U+8|0;K=U+4|0;L=U;c[g>>2]=0;M=lD(f)|0;c[N>>2]=M;o=0;N=Wa(115,N|0,40904)|0;W=o;o=0;if(W&1){W=cc()|0;EL(M)|0;bc(W|0)}EL(M)|0;do switch(j<<24>>24|0){case 65:case 97:{c[x>>2]=c[e>>2];c[l>>2]=c[x>>2];sF(b,h+24|0,d,l,g,N);V=28;break}case 104:case 66:case 98:{c[I>>2]=c[e>>2];c[l>>2]=c[I>>2];uF(b,h+16|0,d,l,g,N);V=28;break}case 99:{V=b+8|0;V=bd[c[(c[V>>2]|0)+12>>2]&255](V)|0;c[O>>2]=c[d>>2];c[P>>2]=c[e>>2];j=a[V>>0]|0;e=(j&1)==0;W=e?V+1|0:c[V+8>>2]|0;V=W+(e?(j&255)>>>1:c[V+4>>2]|0)|0;c[k>>2]=c[O>>2];c[l>>2]=c[P>>2];c[d>>2]=lF(b,k,l,f,g,h,W,V)|0;V=28;break}case 101:case 100:{c[Q>>2]=c[e>>2];c[l>>2]=c[Q>>2];yF(b,h+12|0,d,l,g,N);V=28;break}case 68:{c[R>>2]=c[d>>2];c[S>>2]=c[e>>2];c[k>>2]=c[R>>2];c[l>>2]=c[S>>2];c[d>>2]=lF(b,k,l,f,g,h,61274,61282)|0;V=28;break}case 70:{c[T>>2]=c[d>>2];c[m>>2]=c[e>>2];c[k>>2]=c[T>>2];c[l>>2]=c[m>>2];c[d>>2]=lF(b,k,l,f,g,h,61282,61290)|0;V=28;break}case 72:{c[n>>2]=c[e>>2];c[l>>2]=c[n>>2];zF(b,h+8|0,d,l,g,N);V=28;break}case 73:{c[p>>2]=c[e>>2];c[l>>2]=c[p>>2];AF(b,h+8|0,d,l,g,N);V=28;break}case 106:{c[q>>2]=c[e>>2];c[l>>2]=c[q>>2];BF(b,h+28|0,d,l,g,N);V=28;break}case 109:{c[r>>2]=c[e>>2];c[l>>2]=c[r>>2];CF(b,h+16|0,d,l,g,N);V=28;break}case 77:{c[s>>2]=c[e>>2];c[l>>2]=c[s>>2];DF(b,h+4|0,d,l,g,N);V=28;break}case 116:case 110:{c[t>>2]=c[e>>2];c[l>>2]=c[t>>2];EF(b,d,l,g,N);V=28;break}case 112:{c[u>>2]=c[e>>2];c[l>>2]=c[u>>2];FF(b,h+8|0,d,l,g,N);V=28;break}case 114:{c[v>>2]=c[d>>2];c[w>>2]=c[e>>2];c[k>>2]=c[v>>2];c[l>>2]=c[w>>2];c[d>>2]=lF(b,k,l,f,g,h,61290,61301)|0;V=28;break}case 82:{c[y>>2]=c[d>>2];c[z>>2]=c[e>>2];c[k>>2]=c[y>>2];c[l>>2]=c[z>>2];c[d>>2]=lF(b,k,l,f,g,h,61301,61306)|0;V=28;break}case 83:{c[A>>2]=c[e>>2];c[l>>2]=c[A>>2];GF(b,h,d,l,g,N);V=28;break}case 84:{c[B>>2]=c[d>>2];c[C>>2]=c[e>>2];c[k>>2]=c[B>>2];c[l>>2]=c[C>>2];c[d>>2]=lF(b,k,l,f,g,h,61306,61314)|0;V=28;break}case 119:{c[D>>2]=c[e>>2];c[l>>2]=c[D>>2];HF(b,h+24|0,d,l,g,N);V=28;break}case 120:{W=c[(c[b>>2]|0)+20>>2]|0;c[E>>2]=c[d>>2];c[F>>2]=c[e>>2];c[k>>2]=c[E>>2];c[l>>2]=c[F>>2];k=ad[W&127](b,k,l,f,g,h)|0;break}case 88:{V=b+8|0;V=bd[c[(c[V>>2]|0)+24>>2]&255](V)|0;c[G>>2]=c[d>>2];c[H>>2]=c[e>>2];j=a[V>>0]|0;e=(j&1)==0;W=e?V+1|0:c[V+8>>2]|0;V=W+(e?(j&255)>>>1:c[V+4>>2]|0)|0;c[k>>2]=c[G>>2];c[l>>2]=c[H>>2];c[d>>2]=lF(b,k,l,f,g,h,W,V)|0;V=28;break}case 121:{c[J>>2]=c[e>>2];c[l>>2]=c[J>>2];wF(b,h+20|0,d,l,g,N);V=28;break}case 89:{c[K>>2]=c[e>>2];c[l>>2]=c[K>>2];IF(b,h+20|0,d,l,g,N);V=28;break}case 37:{c[L>>2]=c[e>>2];c[l>>2]=c[L>>2];JF(b,d,l,g,N);V=28;break}default:{c[g>>2]=c[g>>2]|4;V=28}}while(0);if((V|0)==28)k=c[d>>2]|0;i=U;return k|0}function yF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a+-1|0)>>>0<31&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function zF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a|0)<24&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function AF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a+-1|0)>>>0<12&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function BF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,3)|0;d=c[f>>2]|0;if((a|0)<366&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function CF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a|0)<13&(d&4|0)==0)c[b>>2]=a+-1;else c[f>>2]=d|4;i=h;return}function DF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a|0)<60&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function EF(a,e,f,g,h){a=a|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0;j=h+8|0;a:while(1){h=c[e>>2]|0;do if(h){if((c[h+12>>2]|0)==(c[h+16>>2]|0))if((bd[c[(c[h>>2]|0)+36>>2]&255](h)|0)==-1){c[e>>2]=0;h=0;break}else{h=c[e>>2]|0;break}}else h=0;while(0);h=(h|0)==0;a=c[f>>2]|0;do if(a){if((c[a+12>>2]|0)!=(c[a+16>>2]|0))if(h)break;else break a;if((bd[c[(c[a>>2]|0)+36>>2]&255](a)|0)!=-1)if(h)break;else break a;else{c[f>>2]=0;k=12;break}}else k=12;while(0);if((k|0)==12){k=0;if(h){a=0;break}else a=0}h=c[e>>2]|0;i=c[h+12>>2]|0;if((i|0)==(c[h+16>>2]|0))h=bd[c[(c[h>>2]|0)+36>>2]&255](h)|0;else h=d[i>>0]|0;if((h&255)<<24>>24<=-1)break;if(!(b[(c[j>>2]|0)+(h<<24>>24<<1)>>1]&8192))break;h=c[e>>2]|0;a=h+12|0;i=c[a>>2]|0;if((i|0)==(c[h+16>>2]|0)){bd[c[(c[h>>2]|0)+40>>2]&255](h)|0;continue}else{c[a>>2]=i+1;continue}}h=c[e>>2]|0;do if(h){if((c[h+12>>2]|0)==(c[h+16>>2]|0))if((bd[c[(c[h>>2]|0)+36>>2]&255](h)|0)==-1){c[e>>2]=0;h=0;break}else{h=c[e>>2]|0;break}}else h=0;while(0);h=(h|0)==0;do if(a){if((c[a+12>>2]|0)==(c[a+16>>2]|0)?(bd[c[(c[a>>2]|0)+36>>2]&255](a)|0)==-1:0){c[f>>2]=0;k=32;break}if(!h)k=33}else k=32;while(0);if((k|0)==32?h:0)k=33;if((k|0)==33)c[g>>2]=c[g>>2]|2;return}function FF(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0;n=i;i=i+16|0;k=n+4|0;l=n;m=b+8|0;m=bd[c[(c[m>>2]|0)+8>>2]&255](m)|0;b=a[m>>0]|0;if(!(b&1))j=(b&255)>>>1;else j=c[m+4>>2]|0;b=a[m+12>>0]|0;if(!(b&1))b=(b&255)>>>1;else b=c[m+16>>2]|0;do if((j|0)!=(0-b|0)){c[l>>2]=c[f>>2];c[k>>2]=c[l>>2];b=TJ(e,k,m,m+24|0,h,g,0)|0;j=c[d>>2]|0;if((b|0)==(m|0)&(j|0)==12){c[d>>2]=0;break}if((j|0)<12&(b-m|0)==12)c[d>>2]=j+12}else c[g>>2]=c[g>>2]|4;while(0);i=n;return}function GF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a|0)<61&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function HF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,1)|0;d=c[f>>2]|0;if((a|0)<7&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function IF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=pK(d,a,f,g,4)|0;if(!(c[f>>2]&4))c[b>>2]=a+-1900;i=h;return}function JF(a,b,e,f,g){a=a|0;b=b|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0;a=c[b>>2]|0;do if(a){if((c[a+12>>2]|0)==(c[a+16>>2]|0))if((bd[c[(c[a>>2]|0)+36>>2]&255](a)|0)==-1){c[b>>2]=0;a=0;break}else{a=c[b>>2]|0;break}}else a=0;while(0);h=(a|0)==0;a=c[e>>2]|0;do if(a){if((c[a+12>>2]|0)==(c[a+16>>2]|0)?(bd[c[(c[a>>2]|0)+36>>2]&255](a)|0)==-1:0){c[e>>2]=0;j=11;break}if(h){i=a;j=13}else j=12}else j=11;while(0);if((j|0)==11)if(h)j=12;else{i=0;j=13}a:do if((j|0)==12)c[f>>2]=c[f>>2]|6;else if((j|0)==13){a=c[b>>2]|0;h=c[a+12>>2]|0;if((h|0)==(c[a+16>>2]|0))a=bd[c[(c[a>>2]|0)+36>>2]&255](a)|0;else a=d[h>>0]|0;if((fd[c[(c[g>>2]|0)+36>>2]&127](g,a&255,0)|0)<<24>>24!=37){c[f>>2]=c[f>>2]|4;break}a=c[b>>2]|0;h=a+12|0;g=c[h>>2]|0;if((g|0)==(c[a+16>>2]|0)){bd[c[(c[a>>2]|0)+40>>2]&255](a)|0;a=c[b>>2]|0;if(!a)a=0;else j=21}else{c[h>>2]=g+1;j=21}do if((j|0)==21)if((c[a+12>>2]|0)==(c[a+16>>2]|0))if((bd[c[(c[a>>2]|0)+36>>2]&255](a)|0)==-1){c[b>>2]=0;a=0;break}else{a=c[b>>2]|0;break}while(0);a=(a|0)==0;do if(i){if((c[i+12>>2]|0)==(c[i+16>>2]|0)?(bd[c[(c[i>>2]|0)+36>>2]&255](i)|0)==-1:0){c[e>>2]=0;j=30;break}if(a)break a}else j=30;while(0);if((j|0)==30?!a:0)break;c[f>>2]=c[f>>2]|2}while(0);return}function KF(a,b,d,e,f,g,h,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;x=i;i=i+32|0;s=x+16|0;r=x+12|0;v=x+8|0;t=x+4|0;u=x;k=lD(e)|0;c[v>>2]=k;o=0;v=Wa(115,v|0,40896)|0;q=o;o=0;if(q&1){x=cc()|0;EL(k)|0;bc(x|0)}EL(k)|0;c[f>>2]=0;k=c[b>>2]|0;a:do if((h|0)!=(j|0)){b:while(1){m=k;if(k){l=c[k+12>>2]|0;if((l|0)==(c[k+16>>2]|0))l=bd[c[(c[k>>2]|0)+36>>2]&255](k)|0;else l=c[l>>2]|0;if((l|0)==-1){c[b>>2]=0;k=0;p=1;q=0}else{p=0;q=m}}else{k=0;p=1;q=m}n=c[d>>2]|0;l=n;do if(n){m=c[n+12>>2]|0;if((m|0)==(c[n+16>>2]|0))m=bd[c[(c[n>>2]|0)+36>>2]&255](n)|0;else m=c[m>>2]|0;if((m|0)!=-1)if(p)break;else{w=17;break b}else{c[d>>2]=0;l=0;w=15;break}}else w=15;while(0);if((w|0)==15){w=0;if(p){w=17;break}else n=0}c:do if((fd[c[(c[v>>2]|0)+52>>2]&127](v,c[h>>2]|0,0)|0)<<24>>24==37){m=h+4|0;if((m|0)==(j|0)){w=21;break b}p=fd[c[(c[v>>2]|0)+52>>2]&127](v,c[m>>2]|0,0)|0;switch(p<<24>>24){case 48:case 69:{n=h+8|0;if((n|0)==(j|0)){w=24;break b}h=m;m=fd[c[(c[v>>2]|0)+52>>2]&127](v,c[n>>2]|0,0)|0;k=p;break}default:{m=p;k=0}}p=c[(c[a>>2]|0)+36>>2]|0;c[t>>2]=q;c[u>>2]=l;c[r>>2]=c[t>>2];c[s>>2]=c[u>>2];c[b>>2]=Cd[p&63](a,r,s,e,f,g,m,k)|0;h=h+8|0}else{if(!(fd[c[(c[v>>2]|0)+12>>2]&127](v,8192,c[h>>2]|0)|0)){m=k+12|0;l=c[m>>2]|0;n=k+16|0;if((l|0)==(c[n>>2]|0))l=bd[c[(c[k>>2]|0)+36>>2]&255](k)|0;else l=c[l>>2]|0;q=rd[c[(c[v>>2]|0)+28>>2]&127](v,l)|0;if((q|0)!=(rd[c[(c[v>>2]|0)+28>>2]&127](v,c[h>>2]|0)|0)){w=61;break b}l=c[m>>2]|0;if((l|0)==(c[n>>2]|0))bd[c[(c[k>>2]|0)+40>>2]&255](k)|0;else c[m>>2]=l+4;h=h+4|0;break}do{h=h+4|0;if((h|0)==(j|0)){h=j;break}}while(fd[c[(c[v>>2]|0)+12>>2]&127](v,8192,c[h>>2]|0)|0);l=n;p=n;while(1){if(k){m=c[k+12>>2]|0;if((m|0)==(c[k+16>>2]|0))m=bd[c[(c[k>>2]|0)+36>>2]&255](k)|0;else m=c[m>>2]|0;if((m|0)==-1){c[b>>2]=0;n=1;k=0}else n=0}else{n=1;k=0}do if(p){m=c[p+12>>2]|0;if((m|0)==(c[p+16>>2]|0))m=bd[c[(c[p>>2]|0)+36>>2]&255](p)|0;else m=c[m>>2]|0;if((m|0)!=-1)if(n^(l|0)==0){q=l;p=l;break}else break c;else{c[d>>2]=0;l=0;w=44;break}}else w=44;while(0);if((w|0)==44){w=0;if(n)break c;else{q=l;p=0}}m=k+12|0;l=c[m>>2]|0;n=k+16|0;if((l|0)==(c[n>>2]|0))l=bd[c[(c[k>>2]|0)+36>>2]&255](k)|0;else l=c[l>>2]|0;if(!(fd[c[(c[v>>2]|0)+12>>2]&127](v,8192,l)|0))break c;l=c[m>>2]|0;if((l|0)==(c[n>>2]|0)){bd[c[(c[k>>2]|0)+40>>2]&255](k)|0;l=q;continue}else{c[m>>2]=l+4;l=q;continue}}}while(0);k=c[b>>2]|0;if(!((h|0)!=(j|0)&(c[f>>2]|0)==0))break a}if((w|0)==17){c[f>>2]=4;break}else if((w|0)==21){c[f>>2]=4;break}else if((w|0)==24){c[f>>2]=4;break}else if((w|0)==61){c[f>>2]=4;k=c[b>>2]|0;break}}while(0);if(k){h=c[k+12>>2]|0;if((h|0)==(c[k+16>>2]|0))h=bd[c[(c[k>>2]|0)+36>>2]&255](k)|0;else h=c[h>>2]|0;if((h|0)==-1){c[b>>2]=0;k=0;m=1}else m=0}else{k=0;m=1}h=c[d>>2]|0;do if(h){l=c[h+12>>2]|0;if((l|0)==(c[h+16>>2]|0))h=bd[c[(c[h>>2]|0)+36>>2]&255](h)|0;else h=c[l>>2]|0;if((h|0)!=-1)if(m)break;else{w=76;break}else{c[d>>2]=0;w=74;break}}else w=74;while(0);if((w|0)==74?m:0)w=76;if((w|0)==76)c[f>>2]=c[f>>2]|2;i=x;return k|0}function LF(a){a=a|0;return}function MF(a){a=a|0;Uz(a);return}function NF(a){a=a|0;return 2}function OF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+16|0;j=h+12|0;k=h+8|0;m=h+4|0;l=h;c[m>>2]=c[b>>2];c[l>>2]=c[d>>2];c[k>>2]=c[m>>2];c[j>>2]=c[l>>2];a=KF(a,k,j,e,f,g,41472,41504)|0;i=h;return a|0}function PF(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;j=i;i=i+16|0;k=j+12|0;l=j+8|0;n=j+4|0;m=j;q=b+8|0;q=bd[c[(c[q>>2]|0)+20>>2]&255](q)|0;c[n>>2]=c[d>>2];c[m>>2]=c[e>>2];o=a[q>>0]|0;p=(o&1)==0;e=q+4|0;d=p?e:c[q+8>>2]|0;e=d+((p?(o&255)>>>1:c[e>>2]|0)<<2)|0;c[l>>2]=c[n>>2];c[k>>2]=c[m>>2];b=KF(b,l,k,f,g,h,d,e)|0;i=j;return b|0}function QF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;j=l+8|0;h=l+4|0;k=l;e=lD(e)|0;c[h>>2]=e;o=0;h=Wa(115,h|0,40896)|0;m=o;o=0;if(m&1){m=cc()|0;EL(e)|0;bc(m|0)}else{EL(e)|0;c[k>>2]=c[d>>2];c[j>>2]=c[k>>2];RF(a,g+24|0,b,j,f,h);i=l;return c[b>>2]|0}return 0}function RF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0;h=i;i=i+16|0;j=h+4|0;k=h;a=a+8|0;a=bd[c[c[a>>2]>>2]&255](a)|0;c[k>>2]=c[e>>2];c[j>>2]=c[k>>2];d=(cK(d,j,a,a+168|0,g,f,0)|0)-a|0;if((d|0)<168)c[b>>2]=((d|0)/12|0|0)%7|0;i=h;return}function SF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;j=l+8|0;h=l+4|0;k=l;e=lD(e)|0;c[h>>2]=e;o=0;h=Wa(115,h|0,40896)|0;m=o;o=0;if(m&1){m=cc()|0;EL(e)|0;bc(m|0)}else{EL(e)|0;c[k>>2]=c[d>>2];c[j>>2]=c[k>>2];TF(a,g+16|0,b,j,f,h);i=l;return c[b>>2]|0}return 0}function TF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0;h=i;i=i+16|0;j=h+4|0;k=h;a=a+8|0;a=bd[c[(c[a>>2]|0)+4>>2]&255](a)|0;c[k>>2]=c[e>>2];c[j>>2]=c[k>>2];d=(cK(d,j,a,a+288|0,g,f,0)|0)-a|0;if((d|0)<288)c[b>>2]=((d|0)/12|0|0)%12|0;i=h;return}function UF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;j=l+8|0;h=l+4|0;k=l;e=lD(e)|0;c[h>>2]=e;o=0;h=Wa(115,h|0,40896)|0;m=o;o=0;if(m&1){m=cc()|0;EL(e)|0;bc(m|0)}else{EL(e)|0;c[k>>2]=c[d>>2];c[j>>2]=c[k>>2];VF(a,g+20|0,b,j,f,h);i=l;return c[b>>2]|0}return 0}function VF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,4)|0;if(!(c[f>>2]&4)){if((a|0)<69)a=a+2e3|0;else a=(a+-69|0)>>>0<31?a+1900|0:a;c[b>>2]=a+-1900}i=h;return}function WF(b,d,e,f,g,h,j,k){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0;U=i;i=i+144|0;l=U+132|0;k=U+116|0;N=U+128|0;x=U+124|0;I=U+120|0;O=U+112|0;P=U+108|0;Q=U+104|0;R=U+100|0;S=U+96|0;T=U+92|0;m=U+88|0;n=U+84|0;p=U+80|0;q=U+76|0;r=U+72|0;s=U+68|0;t=U+64|0;u=U+60|0;v=U+56|0;w=U+52|0;y=U+48|0;z=U+44|0;A=U+40|0;B=U+36|0;C=U+32|0;D=U+28|0;E=U+24|0;F=U+20|0;G=U+16|0;H=U+12|0;J=U+8|0;K=U+4|0;L=U;c[g>>2]=0;M=lD(f)|0;c[N>>2]=M;o=0;N=Wa(115,N|0,40896)|0;W=o;o=0;if(W&1){W=cc()|0;EL(M)|0;bc(W|0)}EL(M)|0;do switch(j<<24>>24|0){case 65:case 97:{c[x>>2]=c[e>>2];c[l>>2]=c[x>>2];RF(b,h+24|0,d,l,g,N);V=28;break}case 104:case 66:case 98:{c[I>>2]=c[e>>2];c[l>>2]=c[I>>2];TF(b,h+16|0,d,l,g,N);V=28;break}case 99:{W=b+8|0;W=bd[c[(c[W>>2]|0)+12>>2]&255](W)|0;c[O>>2]=c[d>>2];c[P>>2]=c[e>>2];j=a[W>>0]|0;e=(j&1)==0;V=W+4|0;W=e?V:c[W+8>>2]|0;V=W+((e?(j&255)>>>1:c[V>>2]|0)<<2)|0;c[k>>2]=c[O>>2];c[l>>2]=c[P>>2];c[d>>2]=KF(b,k,l,f,g,h,W,V)|0;V=28;break}case 101:case 100:{c[Q>>2]=c[e>>2];c[l>>2]=c[Q>>2];XF(b,h+12|0,d,l,g,N);V=28;break}case 68:{c[R>>2]=c[d>>2];c[S>>2]=c[e>>2];c[k>>2]=c[R>>2];c[l>>2]=c[S>>2];c[d>>2]=KF(b,k,l,f,g,h,41504,41536)|0;V=28;break}case 70:{c[T>>2]=c[d>>2];c[m>>2]=c[e>>2];c[k>>2]=c[T>>2];c[l>>2]=c[m>>2];c[d>>2]=KF(b,k,l,f,g,h,41536,41568)|0;V=28;break}case 72:{c[n>>2]=c[e>>2];c[l>>2]=c[n>>2];YF(b,h+8|0,d,l,g,N);V=28;break}case 73:{c[p>>2]=c[e>>2];c[l>>2]=c[p>>2];ZF(b,h+8|0,d,l,g,N);V=28;break}case 106:{c[q>>2]=c[e>>2];c[l>>2]=c[q>>2];_F(b,h+28|0,d,l,g,N);V=28;break}case 109:{c[r>>2]=c[e>>2];c[l>>2]=c[r>>2];$F(b,h+16|0,d,l,g,N);V=28;break}case 77:{c[s>>2]=c[e>>2];c[l>>2]=c[s>>2];aG(b,h+4|0,d,l,g,N);V=28;break}case 116:case 110:{c[t>>2]=c[e>>2];c[l>>2]=c[t>>2];bG(b,d,l,g,N);V=28;break}case 112:{c[u>>2]=c[e>>2];c[l>>2]=c[u>>2];cG(b,h+8|0,d,l,g,N);V=28;break}case 114:{c[v>>2]=c[d>>2];c[w>>2]=c[e>>2];c[k>>2]=c[v>>2];c[l>>2]=c[w>>2];c[d>>2]=KF(b,k,l,f,g,h,41568,41612)|0;V=28;break}case 82:{c[y>>2]=c[d>>2];c[z>>2]=c[e>>2];c[k>>2]=c[y>>2];c[l>>2]=c[z>>2];c[d>>2]=KF(b,k,l,f,g,h,41612,41632)|0;V=28;break}case 83:{c[A>>2]=c[e>>2];c[l>>2]=c[A>>2];dG(b,h,d,l,g,N);V=28;break}case 84:{c[B>>2]=c[d>>2];c[C>>2]=c[e>>2];c[k>>2]=c[B>>2];c[l>>2]=c[C>>2];c[d>>2]=KF(b,k,l,f,g,h,41632,41664)|0;V=28;break}case 119:{c[D>>2]=c[e>>2];c[l>>2]=c[D>>2];eG(b,h+24|0,d,l,g,N);V=28;break}case 120:{W=c[(c[b>>2]|0)+20>>2]|0;c[E>>2]=c[d>>2];c[F>>2]=c[e>>2];c[k>>2]=c[E>>2];c[l>>2]=c[F>>2];k=ad[W&127](b,k,l,f,g,h)|0;break}case 88:{W=b+8|0;W=bd[c[(c[W>>2]|0)+24>>2]&255](W)|0;c[G>>2]=c[d>>2];c[H>>2]=c[e>>2];j=a[W>>0]|0;e=(j&1)==0;V=W+4|0;W=e?V:c[W+8>>2]|0;V=W+((e?(j&255)>>>1:c[V>>2]|0)<<2)|0;c[k>>2]=c[G>>2];c[l>>2]=c[H>>2];c[d>>2]=KF(b,k,l,f,g,h,W,V)|0;V=28;break}case 121:{c[J>>2]=c[e>>2];c[l>>2]=c[J>>2];VF(b,h+20|0,d,l,g,N);V=28;break}case 89:{c[K>>2]=c[e>>2];c[l>>2]=c[K>>2];fG(b,h+20|0,d,l,g,N);V=28;break}case 37:{c[L>>2]=c[e>>2];c[l>>2]=c[L>>2];gG(b,d,l,g,N);V=28;break}default:{c[g>>2]=c[g>>2]|4;V=28}}while(0);if((V|0)==28)k=c[d>>2]|0;i=U;return k|0}function XF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a+-1|0)>>>0<31&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function YF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a|0)<24&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function ZF(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a+-1|0)>>>0<12&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function _F(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,3)|0;d=c[f>>2]|0;if((a|0)<366&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function $F(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a|0)<13&(d&4|0)==0)c[b>>2]=a+-1;else c[f>>2]=d|4;i=h;return}function aG(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a|0)<60&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function bG(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0;a:while(1){a=c[b>>2]|0;do if(a){g=c[a+12>>2]|0;if((g|0)==(c[a+16>>2]|0))a=bd[c[(c[a>>2]|0)+36>>2]&255](a)|0;else a=c[g>>2]|0;if((a|0)==-1){c[b>>2]=0;h=1;break}else{h=(c[b>>2]|0)==0;break}}else h=1;while(0);g=c[d>>2]|0;do if(g){a=c[g+12>>2]|0;if((a|0)==(c[g+16>>2]|0))a=bd[c[(c[g>>2]|0)+36>>2]&255](g)|0;else a=c[a>>2]|0;if((a|0)!=-1)if(h){h=g;break}else{h=g;break a}else{c[d>>2]=0;i=15;break}}else i=15;while(0);if((i|0)==15){i=0;if(h){h=0;break}else h=0}a=c[b>>2]|0;g=c[a+12>>2]|0;if((g|0)==(c[a+16>>2]|0))a=bd[c[(c[a>>2]|0)+36>>2]&255](a)|0;else a=c[g>>2]|0;if(!(fd[c[(c[f>>2]|0)+12>>2]&127](f,8192,a)|0))break;a=c[b>>2]|0;g=a+12|0;h=c[g>>2]|0;if((h|0)==(c[a+16>>2]|0)){bd[c[(c[a>>2]|0)+40>>2]&255](a)|0;continue}else{c[g>>2]=h+4;continue}}a=c[b>>2]|0;do if(a){g=c[a+12>>2]|0;if((g|0)==(c[a+16>>2]|0))a=bd[c[(c[a>>2]|0)+36>>2]&255](a)|0;else a=c[g>>2]|0;if((a|0)==-1){c[b>>2]=0;g=1;break}else{g=(c[b>>2]|0)==0;break}}else g=1;while(0);do if(h){a=c[h+12>>2]|0;if((a|0)==(c[h+16>>2]|0))a=bd[c[(c[h>>2]|0)+36>>2]&255](h)|0;else a=c[a>>2]|0;if((a|0)!=-1)if(g)break;else{i=39;break}else{c[d>>2]=0;i=37;break}}else i=37;while(0);if((i|0)==37?g:0)i=39;if((i|0)==39)c[e>>2]=c[e>>2]|2;return}function cG(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0;n=i;i=i+16|0;k=n+4|0;l=n;m=b+8|0;m=bd[c[(c[m>>2]|0)+8>>2]&255](m)|0;b=a[m>>0]|0;if(!(b&1))j=(b&255)>>>1;else j=c[m+4>>2]|0;b=a[m+12>>0]|0;if(!(b&1))b=(b&255)>>>1;else b=c[m+16>>2]|0;do if((j|0)!=(0-b|0)){c[l>>2]=c[f>>2];c[k>>2]=c[l>>2];b=cK(e,k,m,m+24|0,h,g,0)|0;j=c[d>>2]|0;if((b|0)==(m|0)&(j|0)==12){c[d>>2]=0;break}if((j|0)<12&(b-m|0)==12)c[d>>2]=j+12}else c[g>>2]=c[g>>2]|4;while(0);i=n;return}function dG(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,2)|0;d=c[f>>2]|0;if((a|0)<61&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function eG(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,1)|0;d=c[f>>2]|0;if((a|0)<7&(d&4|0)==0)c[b>>2]=a;else c[f>>2]=d|4;i=h;return}function fG(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;i=i+16|0;a=h+4|0;j=h;c[j>>2]=c[e>>2];c[a>>2]=c[j>>2];a=qK(d,a,f,g,4)|0;if(!(c[f>>2]&4))c[b>>2]=a+-1900;i=h;return}function gG(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0;a=c[b>>2]|0;do if(a){g=c[a+12>>2]|0;if((g|0)==(c[a+16>>2]|0))a=bd[c[(c[a>>2]|0)+36>>2]&255](a)|0;else a=c[g>>2]|0;if((a|0)==-1){c[b>>2]=0;h=1;break}else{h=(c[b>>2]|0)==0;break}}else h=1;while(0);g=c[d>>2]|0;do if(g){a=c[g+12>>2]|0;if((a|0)==(c[g+16>>2]|0))a=bd[c[(c[g>>2]|0)+36>>2]&255](g)|0;else a=c[a>>2]|0;if((a|0)!=-1)if(h){i=g;j=17;break}else{j=16;break}else{c[d>>2]=0;j=14;break}}else j=14;while(0);if((j|0)==14)if(h)j=16;else{i=0;j=17}a:do if((j|0)==16)c[e>>2]=c[e>>2]|6;else if((j|0)==17){a=c[b>>2]|0;g=c[a+12>>2]|0;if((g|0)==(c[a+16>>2]|0))a=bd[c[(c[a>>2]|0)+36>>2]&255](a)|0;else a=c[g>>2]|0;if((fd[c[(c[f>>2]|0)+52>>2]&127](f,a,0)|0)<<24>>24!=37){c[e>>2]=c[e>>2]|4;break}a=c[b>>2]|0;g=a+12|0;h=c[g>>2]|0;if((h|0)==(c[a+16>>2]|0)){bd[c[(c[a>>2]|0)+40>>2]&255](a)|0;a=c[b>>2]|0;if(!a)g=1;else j=25}else{c[g>>2]=h+4;j=25}do if((j|0)==25){g=c[a+12>>2]|0;if((g|0)==(c[a+16>>2]|0))a=bd[c[(c[a>>2]|0)+36>>2]&255](a)|0;else a=c[g>>2]|0;if((a|0)==-1){c[b>>2]=0;g=1;break}else{g=(c[b>>2]|0)==0;break}}while(0);do if(i){a=c[i+12>>2]|0;if((a|0)==(c[i+16>>2]|0))a=bd[c[(c[i>>2]|0)+36>>2]&255](i)|0;else a=c[a>>2]|0;if((a|0)!=-1)if(g)break a;else break;else{c[d>>2]=0;j=37;break}}else j=37;while(0);if((j|0)==37?!g:0)break;c[e>>2]=c[e>>2]|2}while(0);return}function hG(a){a=a|0;iG(a+8|0);return}function iG(a){a=a|0;var b=0,d=0,e=0;b=c[a>>2]|0;o=0;d=gb(45)|0;e=o;o=0;do if(!(e&1)){if((b|0)!=(d|0)?(o=0,ka(344,c[a>>2]|0),e=o,o=0,e&1):0)break;return}while(0);e=cc(0)|0;oq(e)}function jG(a){a=a|0;iG(a+8|0);Uz(a);return}function kG(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0;l=i;i=i+112|0;k=l+4|0;e=l;c[e>>2]=k+100;lG(b+8|0,k,e,g,h,j);g=c[e>>2]|0;e=c[d>>2]|0;if((k|0)!=(g|0))do{j=a[k>>0]|0;do if(e){f=e+24|0;h=c[f>>2]|0;if((h|0)==(c[e+28>>2]|0)){d=(rd[c[(c[e>>2]|0)+52>>2]&127](e,j&255)|0)==-1;e=d?0:e;break}else{c[f>>2]=h+1;a[h>>0]=j;break}}else e=0;while(0);k=k+1|0}while((k|0)!=(g|0));i=l;return e|0}function lG(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0;m=i;i=i+16|0;l=m;a[l>>0]=37;j=l+1|0;a[j>>0]=g;k=l+2|0;a[k>>0]=h;a[l+3>>0]=0;if(h<<24>>24){a[j>>0]=h;a[k>>0]=g}c[e>>2]=d+(Ub(d|0,(c[e>>2]|0)-d|0,l|0,f|0,c[b>>2]|0)|0);i=m;return}function mG(a){a=a|0;iG(a+8|0);return}function nG(a){a=a|0;iG(a+8|0);Uz(a);return}function oG(a,b,d,e,f,g,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0;j=i;i=i+416|0;e=j+8|0;d=j;c[d>>2]=e+400;pG(a+8|0,e,d,f,g,h);a=c[d>>2]|0;d=c[b>>2]|0;if((e|0)!=(a|0)){f=e;do{e=c[f>>2]|0;if(!d)d=0;else{g=d+24|0;h=c[g>>2]|0;if((h|0)==(c[d+28>>2]|0))e=rd[c[(c[d>>2]|0)+52>>2]&127](d,e)|0;else{c[g>>2]=h+4;c[h>>2]=e}d=(e|0)==-1?0:d}f=f+4|0}while((f|0)!=(a|0))}i=j;return d|0}function pG(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;i=i+128|0;l=h+16|0;m=h+12|0;j=h;k=h+8|0;c[m>>2]=l+100;lG(a,l,m,e,f,g);f=j;c[f>>2]=0;c[f+4>>2]=0;c[k>>2]=l;f=(c[d>>2]|0)-b>>2;g=lB(c[a>>2]|0)|0;o=0;f=kb(66,b|0,k|0,f|0,j|0)|0;a=o;o=0;if(a&1){f=cc()|0;if((g|0)!=0?(o=0,qa(193,g|0)|0,m=o,o=0,m&1):0){m=cc(0)|0;oq(m)}bc(f|0)}if((g|0)!=0?(o=0,qa(193,g|0)|0,m=o,o=0,m&1):0){m=cc(0)|0;oq(m)}if((f|0)==-1)lH(61314);else{c[d>>2]=b+(f<<2);i=h;return}}function qG(a){a=a|0;return}function rG(a){a=a|0;Uz(a);return}function sG(a){a=a|0;return 127}function tG(a){a=a|0;return 127}function uG(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function vG(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function wG(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function xG(a,b){a=a|0;b=b|0;GC(a,1,45);return}function yG(a){a=a|0;return 0}function zG(b,c){b=b|0;c=c|0;a[b>>0]=2;a[b+1>>0]=3;a[b+2>>0]=0;a[b+3>>0]=4;return}function AG(b,c){b=b|0;c=c|0;a[b>>0]=2;a[b+1>>0]=3;a[b+2>>0]=0;a[b+3>>0]=4;return}function BG(a){a=a|0;return}function CG(a){a=a|0;Uz(a);return}function DG(a){a=a|0;return 127}function EG(a){a=a|0;return 127}function FG(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function GG(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function HG(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function IG(a,b){a=a|0;b=b|0;GC(a,1,45);return}function JG(a){a=a|0;return 0}function KG(b,c){b=b|0;c=c|0;a[b>>0]=2;a[b+1>>0]=3;a[b+2>>0]=0;a[b+3>>0]=4;return}function LG(b,c){b=b|0;c=c|0;a[b>>0]=2;a[b+1>>0]=3;a[b+2>>0]=0;a[b+3>>0]=4;return}function MG(a){a=a|0;return}function NG(a){a=a|0;Uz(a);return}function OG(a){a=a|0;return 2147483647}function PG(a){a=a|0;return 2147483647}function QG(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function RG(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function SG(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function TG(a,b){a=a|0;b=b|0;YC(a,1,45);return}function UG(a){a=a|0;return 0}function VG(b,c){b=b|0;c=c|0;a[b>>0]=2;a[b+1>>0]=3;a[b+2>>0]=0;a[b+3>>0]=4;return}function WG(b,c){b=b|0;c=c|0;a[b>>0]=2;a[b+1>>0]=3;a[b+2>>0]=0;a[b+3>>0]=4;return}function XG(a){a=a|0;return}function YG(a){a=a|0;Uz(a);return}function ZG(a){a=a|0;return 2147483647}function _G(a){a=a|0;return 2147483647}function $G(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function aH(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function bH(a,b){a=a|0;b=b|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function cH(a,b){a=a|0;b=b|0;YC(a,1,45);return}function dH(a){a=a|0;return 0}function eH(b,c){b=b|0;c=c|0;a[b>>0]=2;a[b+1>>0]=3;a[b+2>>0]=0;a[b+3>>0]=4;return}function fH(b,c){b=b|0;c=c|0;a[b>>0]=2;a[b+1>>0]=3;a[b+2>>0]=0;a[b+3>>0]=4;return}function gH(a){a=a|0;return}function hH(a){a=a|0;Uz(a);return}function iH(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;B=i;i=i+240|0;z=B+24|0;A=B;b=B+136|0;D=B+16|0;y=B+12|0;C=B+8|0;p=B+134|0;l=B+4|0;x=B+124|0;c[D>>2]=b;E=D+4|0;c[E>>2]=345;m=b+100|0;o=0;k=qa(192,g|0)|0;w=o;o=0;if(!(w&1)){c[C>>2]=k;o=0;b=Wa(115,C|0,40904)|0;w=o;o=0;a:do if(!(w&1)?(a[p>>0]=0,c[l>>2]=c[e>>2],n=c[g+4>>2]|0,o=0,c[z>>2]=c[l>>2],n=ua(42,d|0,z|0,f|0,C|0,n|0,h|0,p|0,b|0,D|0,y|0,m|0)|0,w=o,o=0,!(w&1)):0){b:do if(n){o=0;kb(c[(c[b>>2]|0)+32>>2]|0,b|0,61335,61345,x|0)|0;w=o;o=0;if(w&1){G=10;break a}l=c[y>>2]|0;m=c[D>>2]|0;b=l-m|0;if((b|0)>98){b=yC(b+2|0)|0;k=b;if(!b){o=0;ob(46);w=o;o=0;if(!(w&1)){b=0;G=13}}else G=13}else{k=0;b=z;G=13}do if((G|0)==13){if(a[p>>0]|0){a[b>>0]=45;b=b+1|0}v=x+10|0;w=x;if(m>>>0<l>>>0){n=x+1|0;f=n+1|0;g=f+1|0;p=g+1|0;q=p+1|0;r=q+1|0;s=r+1|0;t=s+1|0;u=t+1|0;do{l=a[m>>0]|0;do if((a[x>>0]|0)!=l<<24>>24)if((a[n>>0]|0)!=l<<24>>24)if((a[f>>0]|0)!=l<<24>>24)if((a[g>>0]|0)!=l<<24>>24)if((a[p>>0]|0)==l<<24>>24)l=p;else{if((a[q>>0]|0)==l<<24>>24){l=q;break}if((a[r>>0]|0)==l<<24>>24){l=r;break}if((a[s>>0]|0)==l<<24>>24){l=s;break}if((a[t>>0]|0)==l<<24>>24){l=t;break}l=(a[u>>0]|0)==l<<24>>24?u:v}else l=g;else l=f;else l=n;else l=x;while(0);a[b>>0]=a[61335+(l-w)>>0]|0;m=m+1|0;b=b+1|0}while(m>>>0<(c[y>>2]|0)>>>0)}a[b>>0]=0;c[A>>2]=j;if((TB(z,61346,A)|0)!=1?(o=0,ka(346,61350),j=o,o=0,j&1):0)break;if(k)zC(k);break b}while(0);b=cc()|0;if(!k){l=b;k=D;break a}zC(k);l=b;k=D;break a}while(0);b=c[d>>2]|0;do if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;b=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;j=o;o=0;if(j&1){G=10;break a}if((b|0)==-1){c[d>>2]=0;b=0;break}else{b=c[d>>2]|0;break}}}else b=0;while(0);k=(b|0)==0;b=c[e>>2]|0;do if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;b=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;j=o;o=0;if(j&1){G=10;break a}if((b|0)==-1){c[e>>2]=0;G=37;break}}if(!k)G=38}else G=37;while(0);if((G|0)==37?k:0)G=38;if((G|0)==38)c[h>>2]=c[h>>2]|2;k=c[d>>2]|0;EL(c[C>>2]|0)|0;b=c[D>>2]|0;c[D>>2]=0;if((b|0)!=0?(o=0,ka(c[E>>2]|0,b|0),G=o,o=0,G&1):0){G=cc(0)|0;oq(G)}i=B;return k|0}else G=10;while(0);if((G|0)==10){l=cc()|0;k=D}EL(c[C>>2]|0)|0;b=c[k>>2]|0;c[k>>2]=0;if(!b)F=l;else{k=c[E>>2]|0;G=45}}else{l=cc()|0;c[D>>2]=0;k=345;G=45}if((G|0)==45){o=0;ka(k|0,b|0);G=o;o=0;if(G&1){G=cc(0)|0;oq(G)}else F=l}bc(F|0);return 0}function jH(a){a=a|0;return}function kH(e,f,g,h,j,k,l,m,n,p,q){e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;p=p|0;q=q|0;var r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0;ba=i;i=i+512|0;P=ba+88|0;u=ba+96|0;da=ba+80|0;T=ba+72|0;S=ba+68|0;U=ba+500|0;Q=ba+497|0;V=ba+496|0;Y=ba+56|0;aa=ba+44|0;_=ba+32|0;Z=ba+20|0;$=ba+8|0;R=ba+4|0;X=ba;c[P>>2]=q;c[da>>2]=u;ca=da+4|0;c[ca>>2]=345;c[T>>2]=u;c[S>>2]=u+400;c[Y>>2]=0;c[Y+4>>2]=0;c[Y+8>>2]=0;c[aa>>2]=0;c[aa+4>>2]=0;c[aa+8>>2]=0;c[_>>2]=0;c[_+4>>2]=0;c[_+8>>2]=0;c[Z>>2]=0;c[Z+4>>2]=0;c[Z+8>>2]=0;c[$>>2]=0;c[$+4>>2]=0;c[$+8>>2]=0;o=0;Ua(42,g|0,h|0,U|0,Q|0,V|0,Y|0,aa|0,_|0,Z|0,R|0);O=o;o=0;a:do if(O&1)m=cc()|0;else{c[p>>2]=c[n>>2];I=m+8|0;J=_+4|0;K=Z+4|0;L=Z+8|0;M=Z+1|0;N=_+8|0;O=_+1|0;z=(j&512|0)!=0;A=aa+8|0;B=aa+1|0;C=aa+4|0;D=$+4|0;E=$+8|0;F=$+1|0;G=U+3|0;H=Y+4|0;y=0;t=0;b:while(1){q=c[e>>2]|0;do if(q){if((c[q+12>>2]|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=24;break b}if((q|0)==-1){c[e>>2]=0;q=0;break}else{q=c[e>>2]|0;break}}}else q=0;while(0);q=(q|0)==0;m=c[f>>2]|0;do if(m){if((c[m+12>>2]|0)!=(c[m+16>>2]|0))if(q){x=m;break}else{W=235;break b}o=0;g=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;x=o;o=0;if(x&1){W=24;break b}if((g|0)!=-1)if(q){x=m;break}else{W=235;break b}else{c[f>>2]=0;W=15;break}}else W=15;while(0);if((W|0)==15){W=0;if(q){W=235;break}else x=0}c:do switch(a[U+y>>0]|0){case 1:{if((y|0)!=3){q=c[e>>2]|0;m=c[q+12>>2]|0;if((m|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;W=o;o=0;if(W&1){W=24;break b}}else q=d[m>>0]|0;if((q&255)<<24>>24<=-1){W=40;break b}if(!(b[(c[I>>2]|0)+(q<<24>>24<<1)>>1]&8192)){W=40;break b}q=c[e>>2]|0;m=q+12|0;g=c[m>>2]|0;if((g|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+40>>2]|0,q|0)|0;W=o;o=0;if(W&1){W=24;break b}}else{c[m>>2]=g+1;q=d[g>>0]|0}o=0;ma(93,$|0,q&255|0);W=o;o=0;if(W&1){W=24;break b}else{q=x;h=x;W=42}}break}case 0:{if((y|0)!=3){q=x;h=x;W=42}break}case 3:{m=a[_>>0]|0;q=(m&1)==0?(m&255)>>>1:c[J>>2]|0;g=a[Z>>0]|0;h=(g&1)==0?(g&255)>>>1:c[K>>2]|0;if((q|0)!=(0-h|0)){if(!q){q=c[e>>2]|0;m=c[q+12>>2]|0;if((m|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=24;break b}m=a[Z>>0]|0}else{q=d[m>>0]|0;m=g}if((q&255)<<24>>24!=(a[((m&1)==0?M:c[L>>2]|0)>>0]|0))break c;q=c[e>>2]|0;m=q+12|0;g=c[m>>2]|0;if((g|0)==(c[q+16>>2]|0)){o=0;qa(c[(c[q>>2]|0)+40>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=24;break b}}else c[m>>2]=g+1;a[l>>0]=1;x=a[Z>>0]|0;t=((x&1)==0?(x&255)>>>1:c[K>>2]|0)>>>0>1?Z:t;break c}j=c[e>>2]|0;r=c[j+12>>2]|0;g=c[j+16>>2]|0;q=(r|0)==(g|0);if(!h){if(q){o=0;q=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;x=o;o=0;if(x&1){W=24;break b}m=a[_>>0]|0}else q=d[r>>0]|0;if((q&255)<<24>>24!=(a[((m&1)==0?O:c[N>>2]|0)>>0]|0)){a[l>>0]=1;break c}q=c[e>>2]|0;m=q+12|0;g=c[m>>2]|0;if((g|0)==(c[q+16>>2]|0)){o=0;qa(c[(c[q>>2]|0)+40>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=24;break b}}else c[m>>2]=g+1;x=a[_>>0]|0;t=((x&1)==0?(x&255)>>>1:c[J>>2]|0)>>>0>1?_:t;break c}if(q){o=0;q=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;x=o;o=0;if(x&1){W=24;break b}g=c[e>>2]|0;m=a[_>>0]|0;j=g;r=c[g+12>>2]|0;g=c[g+16>>2]|0}else q=d[r>>0]|0;h=j+12|0;g=(r|0)==(g|0);if((q&255)<<24>>24==(a[((m&1)==0?O:c[N>>2]|0)>>0]|0)){if(g){o=0;qa(c[(c[j>>2]|0)+40>>2]|0,j|0)|0;x=o;o=0;if(x&1){W=24;break b}}else c[h>>2]=r+1;x=a[_>>0]|0;t=((x&1)==0?(x&255)>>>1:c[J>>2]|0)>>>0>1?_:t;break c}if(g){o=0;q=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;x=o;o=0;if(x&1){W=24;break b}}else q=d[r>>0]|0;if((q&255)<<24>>24!=(a[((a[Z>>0]&1)==0?M:c[L>>2]|0)>>0]|0)){W=104;break b}q=c[e>>2]|0;m=q+12|0;g=c[m>>2]|0;if((g|0)==(c[q+16>>2]|0)){o=0;qa(c[(c[q>>2]|0)+40>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=24;break b}}else c[m>>2]=g+1;a[l>>0]=1;x=a[Z>>0]|0;t=((x&1)==0?(x&255)>>>1:c[K>>2]|0)>>>0>1?Z:t}break}case 2:{if(!(y>>>0<2|(t|0)!=0)?!(z|(y|0)==2&(a[G>>0]|0)!=0):0){t=0;break c}v=a[aa>>0]|0;q=(v&1)==0;w=c[A>>2]|0;g=q?B:w;s=g;d:do if((y|0)!=0?(d[U+(y+-1)>>0]|0)<2:0){r=q?(v&255)>>>1:c[C>>2]|0;h=g+r|0;j=c[I>>2]|0;e:do if(!r)m=s;else{r=g;m=s;do{q=a[r>>0]|0;if(q<<24>>24<=-1)break e;if(!(b[j+(q<<24>>24<<1)>>1]&8192))break e;r=r+1|0;m=r}while((r|0)!=(h|0))}while(0);h=m-s|0;j=a[$>>0]|0;q=(j&1)==0;j=q?(j&255)>>>1:c[D>>2]|0;if(j>>>0>=h>>>0){q=q?F:c[E>>2]|0;r=q+j|0;if((m|0)!=(s|0)){q=q+(j-h)|0;while(1){if((a[q>>0]|0)!=(a[g>>0]|0)){m=s;break d}q=q+1|0;if((q|0)==(r|0))break;else g=g+1|0}}}else m=s}else m=s;while(0);q=(v&1)==0;q=(q?B:w)+(q?(v&255)>>>1:c[C>>2]|0)|0;f:do if((m|0)!=(q|0)){j=x;h=x;q=m;while(1){m=c[e>>2]|0;do if(m){if((c[m+12>>2]|0)==(c[m+16>>2]|0)){o=0;m=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;x=o;o=0;if(x&1){W=21;break b}if((m|0)==-1){c[e>>2]=0;m=0;break}else{m=c[e>>2]|0;break}}}else m=0;while(0);g=(m|0)==0;do if(h){if((c[h+12>>2]|0)!=(c[h+16>>2]|0))if(g){m=j;r=h;break}else break f;o=0;m=qa(c[(c[h>>2]|0)+36>>2]|0,h|0)|0;x=o;o=0;if(x&1){W=21;break b}if((m|0)!=-1)if(g^(j|0)==0){m=j;r=j;break}else break f;else{c[f>>2]=0;m=0;W=131;break}}else{m=j;W=131}while(0);if((W|0)==131){W=0;if(g)break f;else r=0}g=c[e>>2]|0;h=c[g+12>>2]|0;if((h|0)==(c[g+16>>2]|0)){o=0;g=qa(c[(c[g>>2]|0)+36>>2]|0,g|0)|0;x=o;o=0;if(x&1){W=21;break b}}else g=d[h>>0]|0;if((g&255)<<24>>24!=(a[q>>0]|0))break f;g=c[e>>2]|0;h=g+12|0;j=c[h>>2]|0;if((j|0)==(c[g+16>>2]|0)){o=0;qa(c[(c[g>>2]|0)+40>>2]|0,g|0)|0;x=o;o=0;if(x&1){W=21;break b}}else c[h>>2]=j+1;q=q+1|0;g=a[aa>>0]|0;x=(g&1)==0;g=(x?B:c[A>>2]|0)+(x?(g&255)>>>1:c[C>>2]|0)|0;if((q|0)==(g|0)){q=g;break}else{j=m;h=r}}}while(0);if(z?(x=a[aa>>0]|0,w=(x&1)==0,(q|0)!=((w?B:c[A>>2]|0)+(w?(x&255)>>>1:c[C>>2]|0)|0)):0){W=143;break b}break}case 4:{s=a[V>>0]|0;m=x;j=x;q=0;g:while(1){g=c[e>>2]|0;do if(g){if((c[g+12>>2]|0)==(c[g+16>>2]|0)){o=0;g=qa(c[(c[g>>2]|0)+36>>2]|0,g|0)|0;x=o;o=0;if(x&1){W=23;break b}if((g|0)==-1){c[e>>2]=0;g=0;break}else{g=c[e>>2]|0;break}}}else g=0;while(0);h=(g|0)==0;do if(j){if((c[j+12>>2]|0)!=(c[j+16>>2]|0))if(h){r=m;break}else{h=m;break g}o=0;g=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;x=o;o=0;if(x&1){W=23;break b}if((g|0)!=-1)if(h^(m|0)==0){r=m;j=m;break}else{h=m;break g}else{c[f>>2]=0;m=0;W=156;break}}else W=156;while(0);if((W|0)==156){W=0;if(h){h=m;break}else{r=m;j=0}}m=c[e>>2]|0;g=c[m+12>>2]|0;if((g|0)==(c[m+16>>2]|0)){o=0;m=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;x=o;o=0;if(x&1){W=23;break b}}else m=d[g>>0]|0;g=m&255;if(g<<24>>24>-1?(b[(c[I>>2]|0)+(m<<24>>24<<1)>>1]&2048)!=0:0){m=c[p>>2]|0;if((m|0)==(c[P>>2]|0)){o=0;mb(116,n|0,p|0,P|0);x=o;o=0;if(x&1){W=23;break b}m=c[p>>2]|0}c[p>>2]=m+1;a[m>>0]=g;q=q+1|0}else{x=a[Y>>0]|0;if(!(g<<24>>24==s<<24>>24&((q|0)!=0?(((x&1)==0?(x&255)>>>1:c[H>>2]|0)|0)!=0:0))){h=r;break}if((u|0)==(c[S>>2]|0)){o=0;mb(117,da|0,T|0,S|0);x=o;o=0;if(x&1){W=23;break b}u=c[T>>2]|0}x=u+4|0;c[T>>2]=x;c[u>>2]=q;u=x;q=0}m=c[e>>2]|0;g=m+12|0;h=c[g>>2]|0;if((h|0)==(c[m+16>>2]|0)){o=0;qa(c[(c[m>>2]|0)+40>>2]|0,m|0)|0;x=o;o=0;if(x&1){W=23;break b}else{m=r;continue}}else{c[g>>2]=h+1;m=r;continue}}if((q|0)!=0?(c[da>>2]|0)!=(u|0):0){if((u|0)==(c[S>>2]|0)){o=0;mb(117,da|0,T|0,S|0);x=o;o=0;if(x&1){W=24;break b}u=c[T>>2]|0}x=u+4|0;c[T>>2]=x;c[u>>2]=q;u=x}r=c[R>>2]|0;if((r|0)>0){q=c[e>>2]|0;do if(q){if((c[q+12>>2]|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=24;break b}if((q|0)==-1){c[e>>2]=0;q=0;break}else{q=c[e>>2]|0;break}}}else q=0;while(0);q=(q|0)==0;do if(h){if((c[h+12>>2]|0)==(c[h+16>>2]|0)){o=0;m=qa(c[(c[h>>2]|0)+36>>2]|0,h|0)|0;x=o;o=0;if(x&1){W=24;break b}if((m|0)==-1){c[f>>2]=0;W=193;break}}if(!q){W=198;break b}}else W=193;while(0);if((W|0)==193){W=0;if(q){W=198;break b}else h=0}q=c[e>>2]|0;m=c[q+12>>2]|0;if((m|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=24;break b}}else q=d[m>>0]|0;if((q&255)<<24>>24!=(a[Q>>0]|0)){W=198;break b}q=c[e>>2]|0;m=q+12|0;g=c[m>>2]|0;if((g|0)==(c[q+16>>2]|0)){o=0;qa(c[(c[q>>2]|0)+40>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=24;break b}}else c[m>>2]=g+1;if((r|0)>0){j=h;g=h;s=r;while(1){q=c[e>>2]|0;do if(q){if((c[q+12>>2]|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=22;break b}if((q|0)==-1){c[e>>2]=0;q=0;break}else{q=c[e>>2]|0;break}}}else q=0;while(0);m=(q|0)==0;do if(g){if((c[g+12>>2]|0)!=(c[g+16>>2]|0))if(m){q=j;r=g;break}else{W=222;break b}o=0;q=qa(c[(c[g>>2]|0)+36>>2]|0,g|0)|0;x=o;o=0;if(x&1){W=22;break b}if((q|0)!=-1)if(m^(j|0)==0){q=j;r=j;break}else{W=222;break b}else{c[f>>2]=0;q=0;W=215;break}}else{q=j;W=215}while(0);if((W|0)==215){W=0;if(m){W=222;break b}else r=0}m=c[e>>2]|0;g=c[m+12>>2]|0;if((g|0)==(c[m+16>>2]|0)){o=0;m=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;x=o;o=0;if(x&1){W=22;break b}}else m=d[g>>0]|0;if((m&255)<<24>>24<=-1){W=222;break b}if(!(b[(c[I>>2]|0)+(m<<24>>24<<1)>>1]&2048)){W=222;break b}if((c[p>>2]|0)==(c[P>>2]|0)?(o=0,mb(116,n|0,p|0,P|0),x=o,o=0,x&1):0){W=22;break b}m=c[e>>2]|0;g=c[m+12>>2]|0;if((g|0)==(c[m+16>>2]|0)){o=0;m=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;x=o;o=0;if(x&1){W=22;break b}}else m=d[g>>0]|0;g=c[p>>2]|0;c[p>>2]=g+1;a[g>>0]=m;m=s;s=s+-1|0;c[R>>2]=s;g=c[e>>2]|0;h=g+12|0;j=c[h>>2]|0;if((j|0)==(c[g+16>>2]|0)){o=0;qa(c[(c[g>>2]|0)+40>>2]|0,g|0)|0;x=o;o=0;if(x&1){W=22;break b}}else c[h>>2]=j+1;if((m|0)<=1)break;else{j=q;g=r}}}}if((c[p>>2]|0)==(c[n>>2]|0)){W=233;break b}break}default:{}}while(0);h:do if((W|0)==42)while(1){W=0;m=c[e>>2]|0;do if(m){if((c[m+12>>2]|0)==(c[m+16>>2]|0)){o=0;m=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;x=o;o=0;if(x&1){W=20;break b}if((m|0)==-1){c[e>>2]=0;m=0;break}else{m=c[e>>2]|0;break}}}else m=0;while(0);g=(m|0)==0;do if(h){if((c[h+12>>2]|0)!=(c[h+16>>2]|0))if(g){j=q;break}else break h;o=0;m=qa(c[(c[h>>2]|0)+36>>2]|0,h|0)|0;x=o;o=0;if(x&1){W=20;break b}if((m|0)!=-1)if(g^(q|0)==0){j=q;h=q;break}else break h;else{c[f>>2]=0;q=0;W=54;break}}else W=54;while(0);if((W|0)==54){W=0;if(g)break h;else{j=q;h=0}}q=c[e>>2]|0;m=c[q+12>>2]|0;if((m|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;x=o;o=0;if(x&1){W=20;break b}}else q=d[m>>0]|0;if((q&255)<<24>>24<=-1)break h;if(!(b[(c[I>>2]|0)+(q<<24>>24<<1)>>1]&8192))break h;q=c[e>>2]|0;m=q+12|0;g=c[m>>2]|0;if((g|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+40>>2]|0,q|0)|0;W=o;o=0;if(W&1){W=20;break b}}else{c[m>>2]=g+1;q=d[g>>0]|0}o=0;ma(93,$|0,q&255|0);W=o;o=0;if(W&1){W=20;break b}else{q=j;W=42}}while(0);y=y+1|0;if(y>>>0>=4){W=235;break}}i:switch(W|0){case 20:{m=cc()|0;break a}case 21:{m=cc()|0;break a}case 22:{m=cc()|0;break a}case 23:{m=cc()|0;break a}case 24:{m=cc()|0;break a}case 40:{c[k>>2]=c[k>>2]|4;m=0;break}case 104:{c[k>>2]=c[k>>2]|4;m=0;break}case 143:{c[k>>2]=c[k>>2]|4;m=0;break}case 198:{c[k>>2]=c[k>>2]|4;m=0;break}case 222:{c[k>>2]=c[k>>2]|4;m=0;break}case 233:{c[k>>2]=c[k>>2]|4;m=0;break}case 235:{j:do if(t){j=t+1|0;r=t+8|0;s=t+4|0;g=1;k:while(1){q=a[t>>0]|0;if(!(q&1))q=(q&255)>>>1;else q=c[s>>2]|0;if(g>>>0>=q>>>0)break j;q=c[e>>2]|0;do if(q){if((c[q+12>>2]|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;p=o;o=0;if(p&1){W=19;break k}if((q|0)==-1){c[e>>2]=0;q=0;break}else{q=c[e>>2]|0;break}}}else q=0;while(0);m=(q|0)==0;q=c[f>>2]|0;do if(q){if((c[q+12>>2]|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;p=o;o=0;if(p&1){W=19;break k}if((q|0)==-1){c[f>>2]=0;W=253;break}}if(!m){W=260;break k}}else W=253;while(0);if((W|0)==253?(W=0,m):0){W=260;break}q=c[e>>2]|0;m=c[q+12>>2]|0;if((m|0)==(c[q+16>>2]|0)){o=0;q=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;p=o;o=0;if(p&1){W=19;break}}else q=d[m>>0]|0;if(!(a[t>>0]&1))m=j;else m=c[r>>2]|0;if((q&255)<<24>>24!=(a[m+g>>0]|0)){W=260;break}q=g+1|0;m=c[e>>2]|0;g=m+12|0;h=c[g>>2]|0;if((h|0)==(c[m+16>>2]|0)){o=0;qa(c[(c[m>>2]|0)+40>>2]|0,m|0)|0;p=o;o=0;if(p&1){W=19;break}else{g=q;continue}}else{c[g>>2]=h+1;g=q;continue}}if((W|0)==19){m=cc()|0;break a}else if((W|0)==260){c[k>>2]=c[k>>2]|4;m=0;break i}}while(0);q=c[da>>2]|0;if((q|0)!=(u|0)?(c[X>>2]=0,oH(Y,q,u,X),(c[X>>2]|0)!=0):0){c[k>>2]=c[k>>2]|4;m=0}else m=1;break}}IC($);IC(Z);IC(_);IC(aa);IC(Y);q=c[da>>2]|0;c[da>>2]=0;if((q|0)!=0?(o=0,ka(c[ca>>2]|0,q|0),da=o,o=0,da&1):0){da=cc(0)|0;oq(da)}i=ba;return m|0}while(0);IC($);IC(Z);IC(_);IC(aa);IC(Y);q=c[da>>2]|0;c[da>>2]=0;if((q|0)!=0?(o=0,ka(c[ca>>2]|0,q|0),da=o,o=0,da&1):0){da=cc(0)|0;oq(da)}bc(m|0);return 0}function lH(a){a=a|0;var b=0;b=Ob(8)|0;o=0;ma(222,b|0,a|0);a=o;o=0;if(a&1){a=cc()|0;Nb(b|0);bc(a|0)}else Hc(b|0,1800,218)}function mH(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;w=i;i=i+144|0;k=w+24|0;b=w+32|0;x=w+16|0;s=w+8|0;p=w+4|0;q=w+28|0;l=w;c[x>>2]=b;A=x+4|0;c[A>>2]=345;m=b+100|0;o=0;v=qa(192,g|0)|0;n=o;o=0;if(!(n&1)){c[p>>2]=v;o=0;n=Wa(115,p|0,40904)|0;b=o;o=0;a:do if(!(b&1)?(a[q>>0]=0,t=c[e>>2]|0,c[l>>2]=t,r=c[g+4>>2]|0,u=t,o=0,c[k>>2]=c[l>>2],r=ua(42,d|0,k|0,f|0,p|0,r|0,h|0,q|0,n|0,x|0,s|0,m|0)|0,g=o,o=0,!(g&1)):0){if(r){if(!(a[j>>0]&1)){a[j+1>>0]=0;a[j>>0]=0}else{a[c[j+8>>2]>>0]=0;c[j+4>>2]=0}if(a[q>>0]|0){o=0;b=Wa(c[(c[n>>2]|0)+28>>2]|0,n|0,45)|0;g=o;o=0;if(g&1)break;o=0;ma(93,j|0,b|0);g=o;o=0;if(g&1)break}o=0;l=Wa(c[(c[n>>2]|0)+28>>2]|0,n|0,48)|0;g=o;o=0;if(g&1)break;b=c[x>>2]|0;m=c[s>>2]|0;k=m+-1|0;b:do if(b>>>0<k>>>0)do{if((a[b>>0]|0)!=l<<24>>24)break b;b=b+1|0}while(b>>>0<k>>>0);while(0);o=0;ya(122,j|0,b|0,m|0)|0;j=o;o=0;if(j&1)break}b=c[d>>2]|0;do if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;b=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;j=o;o=0;if(j&1)break a;if((b|0)==-1){c[d>>2]=0;b=0;break}else{b=c[d>>2]|0;break}}}else b=0;while(0);k=(b|0)==0;do if(t){if((c[u+12>>2]|0)==(c[u+16>>2]|0)){o=0;b=qa(c[(c[t>>2]|0)+36>>2]|0,u|0)|0;u=o;o=0;if(u&1)break a;if((b|0)==-1){c[e>>2]=0;z=29;break}}if(!k)z=30}else z=29;while(0);if((z|0)==29?k:0)z=30;if((z|0)==30)c[h>>2]=c[h>>2]|2;k=c[d>>2]|0;EL(v)|0;b=c[x>>2]|0;c[x>>2]=0;if((b|0)!=0?(o=0,ka(c[A>>2]|0,b|0),A=o,o=0,A&1):0){A=cc(0)|0;oq(A)}i=w;return k|0}while(0);k=cc()|0;EL(v)|0;b=c[x>>2]|0;c[x>>2]=0;if(!b)y=k;else z=36}else{k=cc()|0;c[x>>2]=0;z=36}if((z|0)==36){o=0;ka(c[A>>2]|0,b|0);A=o;o=0;if(A&1){A=cc(0)|0;oq(A)}else y=k}bc(y|0);return 0}function nH(b,d,e,f,g,h,j,k,l,m){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;z=i;i=i+112|0;n=z+100|0;p=z+88|0;q=z+76|0;r=z+64|0;s=z+52|0;t=z+48|0;u=z+36|0;v=z+24|0;w=z+12|0;x=z;do if(b){b=cI(d,40512)|0;$c[c[(c[b>>2]|0)+44>>2]&511](n,b);x=c[n>>2]|0;a[e>>0]=x;a[e+1>>0]=x>>8;a[e+2>>0]=x>>16;a[e+3>>0]=x>>24;$c[c[(c[b>>2]|0)+32>>2]&511](p,b);if(!(a[l>>0]&1)){a[l+1>>0]=0;a[l>>0]=0}else{a[c[l+8>>2]>>0]=0;c[l+4>>2]=0}o=0;ma(114,l|0,0);e=o;o=0;if(e&1){e=cc(0)|0;oq(e)};c[l>>2]=c[p>>2];c[l+4>>2]=c[p+4>>2];c[l+8>>2]=c[p+8>>2];c[p>>2]=0;c[p+4>>2]=0;c[p+8>>2]=0;IC(p);$c[c[(c[b>>2]|0)+28>>2]&511](q,b);if(!(a[k>>0]&1)){a[k+1>>0]=0;a[k>>0]=0}else{a[c[k+8>>2]>>0]=0;c[k+4>>2]=0}o=0;ma(114,k|0,0);e=o;o=0;if(e&1){e=cc(0)|0;oq(e)};c[k>>2]=c[q>>2];c[k+4>>2]=c[q+4>>2];c[k+8>>2]=c[q+8>>2];c[q>>2]=0;c[q+4>>2]=0;c[q+8>>2]=0;IC(q);a[f>>0]=bd[c[(c[b>>2]|0)+12>>2]&255](b)|0;a[g>>0]=bd[c[(c[b>>2]|0)+16>>2]&255](b)|0;$c[c[(c[b>>2]|0)+20>>2]&511](r,b);if(!(a[h>>0]&1)){a[h+1>>0]=0;a[h>>0]=0}else{a[c[h+8>>2]>>0]=0;c[h+4>>2]=0}o=0;ma(114,h|0,0);g=o;o=0;if(g&1){g=cc(0)|0;oq(g)};c[h>>2]=c[r>>2];c[h+4>>2]=c[r+4>>2];c[h+8>>2]=c[r+8>>2];c[r>>2]=0;c[r+4>>2]=0;c[r+8>>2]=0;IC(r);$c[c[(c[b>>2]|0)+24>>2]&511](s,b);if(!(a[j>>0]&1)){a[j+1>>0]=0;a[j>>0]=0}else{a[c[j+8>>2]>>0]=0;c[j+4>>2]=0}o=0;ma(114,j|0,0);g=o;o=0;if(g&1){g=cc(0)|0;oq(g)}else{c[j>>2]=c[s>>2];c[j+4>>2]=c[s+4>>2];c[j+8>>2]=c[s+8>>2];c[s>>2]=0;c[s+4>>2]=0;c[s+8>>2]=0;IC(s);y=bd[c[(c[b>>2]|0)+36>>2]&255](b)|0;break}}else{b=cI(d,40448)|0;$c[c[(c[b>>2]|0)+44>>2]&511](t,b);t=c[t>>2]|0;a[e>>0]=t;a[e+1>>0]=t>>8;a[e+2>>0]=t>>16;a[e+3>>0]=t>>24;$c[c[(c[b>>2]|0)+32>>2]&511](u,b);if(!(a[l>>0]&1)){a[l+1>>0]=0;a[l>>0]=0}else{a[c[l+8>>2]>>0]=0;c[l+4>>2]=0}o=0;ma(114,l|0,0);e=o;o=0;if(e&1){e=cc(0)|0;oq(e)};c[l>>2]=c[u>>2];c[l+4>>2]=c[u+4>>2];c[l+8>>2]=c[u+8>>2];c[u>>2]=0;c[u+4>>2]=0;c[u+8>>2]=0;IC(u);$c[c[(c[b>>2]|0)+28>>2]&511](v,b);if(!(a[k>>0]&1)){a[k+1>>0]=0;a[k>>0]=0}else{a[c[k+8>>2]>>0]=0;c[k+4>>2]=0}o=0;ma(114,k|0,0);e=o;o=0;if(e&1){e=cc(0)|0;oq(e)};c[k>>2]=c[v>>2];c[k+4>>2]=c[v+4>>2];c[k+8>>2]=c[v+8>>2];c[v>>2]=0;c[v+4>>2]=0;c[v+8>>2]=0;IC(v);a[f>>0]=bd[c[(c[b>>2]|0)+12>>2]&255](b)|0;a[g>>0]=bd[c[(c[b>>2]|0)+16>>2]&255](b)|0;$c[c[(c[b>>2]|0)+20>>2]&511](w,b);if(!(a[h>>0]&1)){a[h+1>>0]=0;a[h>>0]=0}else{a[c[h+8>>2]>>0]=0;c[h+4>>2]=0}o=0;ma(114,h|0,0);g=o;o=0;if(g&1){g=cc(0)|0;oq(g)};c[h>>2]=c[w>>2];c[h+4>>2]=c[w+4>>2];c[h+8>>2]=c[w+8>>2];c[w>>2]=0;c[w+4>>2]=0;c[w+8>>2]=0;IC(w);$c[c[(c[b>>2]|0)+24>>2]&511](x,b);if(!(a[j>>0]&1)){a[j+1>>0]=0;a[j>>0]=0}else{a[c[j+8>>2]>>0]=0;c[j+4>>2]=0}o=0;ma(114,j|0,0);g=o;o=0;if(g&1){g=cc(0)|0;oq(g)}else{c[j>>2]=c[x>>2];c[j+4>>2]=c[x+4>>2];c[j+8>>2]=c[x+8>>2];c[x>>2]=0;c[x+4>>2]=0;c[x+8>>2]=0;IC(x);y=bd[c[(c[b>>2]|0)+36>>2]&255](b)|0;break}}while(0);c[m>>2]=y;i=z;return}function oH(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0;g=a[b>>0]|0;i=b+4|0;h=c[i>>2]|0;a:do if(((g&1)==0?(g&255)>>>1:h)|0){if((d|0)!=(e|0)){g=e+-4|0;if(g>>>0>d>>>0){h=d;do{j=c[h>>2]|0;c[h>>2]=c[g>>2];c[g>>2]=j;h=h+4|0;g=g+-4|0}while(h>>>0<g>>>0)}g=a[b>>0]|0;h=c[i>>2]|0}j=(g&1)==0;i=j?b+1|0:c[b+8>>2]|0;e=e+-4|0;b=i+(j?(g&255)>>>1:h)|0;h=a[i>>0]|0;g=h<<24>>24<1|h<<24>>24==127;b:do if(e>>>0>d>>>0){while(1){if(!g?(h<<24>>24|0)!=(c[d>>2]|0):0)break;i=(b-i|0)>1?i+1|0:i;d=d+4|0;h=a[i>>0]|0;g=h<<24>>24<1|h<<24>>24==127;if(d>>>0>=e>>>0)break b}c[f>>2]=4;break a}while(0);if(!g?((c[e>>2]|0)+-1|0)>>>0>=h<<24>>24>>>0:0)c[f>>2]=4}while(0);return}function pH(a){a=a|0;return}function qH(a){a=a|0;Uz(a);return}function rH(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;B=i;i=i+576|0;x=B+424|0;A=B;b=B+24|0;D=B+16|0;y=B+12|0;C=B+8|0;p=B+464|0;l=B+4|0;z=B+468|0;c[D>>2]=b;F=D+4|0;c[F>>2]=345;m=b+400|0;o=0;k=qa(192,g|0)|0;w=o;o=0;if(!(w&1)){c[C>>2]=k;o=0;b=Wa(115,C|0,40896)|0;w=o;o=0;a:do if(!(w&1)?(a[p>>0]=0,c[l>>2]=c[e>>2],n=c[g+4>>2]|0,o=0,c[x>>2]=c[l>>2],n=ua(43,d|0,x|0,f|0,C|0,n|0,h|0,p|0,b|0,D|0,y|0,m|0)|0,w=o,o=0,!(w&1)):0){b:do if(n){o=0;kb(c[(c[b>>2]|0)+48>>2]|0,b|0,61366,61376,x|0)|0;w=o;o=0;if(w&1){G=10;break a}l=c[y>>2]|0;m=c[D>>2]|0;b=l-m|0;if((b|0)>392){b=yC((b>>2)+2|0)|0;k=b;if(!b){o=0;ob(46);w=o;o=0;if(!(w&1)){b=0;G=13}}else G=13}else{k=0;b=z;G=13}do if((G|0)==13){if(a[p>>0]|0){a[b>>0]=45;b=b+1|0}v=x+40|0;w=x;if(m>>>0<l>>>0){n=x+4|0;f=n+4|0;g=f+4|0;p=g+4|0;q=p+4|0;r=q+4|0;s=r+4|0;t=s+4|0;u=t+4|0;do{l=c[m>>2]|0;do if((c[x>>2]|0)!=(l|0))if((c[n>>2]|0)!=(l|0))if((c[f>>2]|0)!=(l|0))if((c[g>>2]|0)!=(l|0))if((c[p>>2]|0)==(l|0))l=p;else{if((c[q>>2]|0)==(l|0)){l=q;break}if((c[r>>2]|0)==(l|0)){l=r;break}if((c[s>>2]|0)==(l|0)){l=s;break}if((c[t>>2]|0)==(l|0)){l=t;break}l=(c[u>>2]|0)==(l|0)?u:v}else l=g;else l=f;else l=n;else l=x;while(0);a[b>>0]=a[61366+(l-w>>2)>>0]|0;m=m+4|0;b=b+1|0}while(m>>>0<(c[y>>2]|0)>>>0)}a[b>>0]=0;c[A>>2]=j;if((TB(z,61346,A)|0)!=1?(o=0,ka(346,61350),j=o,o=0,j&1):0)break;if(k)zC(k);break b}while(0);b=cc()|0;if(!k){l=b;k=D;break a}zC(k);l=b;k=D;break a}while(0);b=c[d>>2]|0;do if(b){k=c[b+12>>2]|0;if((k|0)==(c[b+16>>2]|0)){o=0;b=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;j=o;o=0;if(j&1){G=10;break a}}else b=c[k>>2]|0;if((b|0)==-1){c[d>>2]=0;l=1;break}else{l=(c[d>>2]|0)==0;break}}else l=1;while(0);b=c[e>>2]|0;do if(b){k=c[b+12>>2]|0;if((k|0)==(c[b+16>>2]|0)){o=0;b=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;j=o;o=0;if(j&1){G=10;break a}}else b=c[k>>2]|0;if((b|0)!=-1)if(l)break;else{G=40;break}else{c[e>>2]=0;G=38;break}}else G=38;while(0);if((G|0)==38?l:0)G=40;if((G|0)==40)c[h>>2]=c[h>>2]|2;k=c[d>>2]|0;EL(c[C>>2]|0)|0;b=c[D>>2]|0;c[D>>2]=0;if((b|0)!=0?(o=0,ka(c[F>>2]|0,b|0),G=o,o=0,G&1):0){G=cc(0)|0;oq(G)}i=B;return k|0}else G=10;while(0);if((G|0)==10){l=cc()|0;k=D}EL(c[C>>2]|0)|0;b=c[k>>2]|0;c[k>>2]=0;if(!b)E=l;else{k=c[F>>2]|0;G=47}}else{l=cc()|0;c[D>>2]=0;k=345;G=47}if((G|0)==47){o=0;ka(k|0,b|0);G=o;o=0;if(G&1){G=cc(0)|0;oq(G)}else E=l}bc(E|0);return 0}
function sH(b,e,f,g,h,j,k,l,m,n,p){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;p=p|0;var q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0;Y=i;i=i+512|0;K=Y+96|0;q=Y+104|0;_=Y+88|0;O=Y+80|0;N=Y+76|0;P=Y+504|0;L=Y+72|0;Q=Y+68|0;T=Y+56|0;X=Y+44|0;V=Y+32|0;U=Y+20|0;W=Y+8|0;M=Y+4|0;S=Y;c[K>>2]=p;c[_>>2]=q;Z=_+4|0;c[Z>>2]=345;c[O>>2]=q;c[N>>2]=q+400;c[T>>2]=0;c[T+4>>2]=0;c[T+8>>2]=0;c[X>>2]=0;c[X+4>>2]=0;c[X+8>>2]=0;c[V>>2]=0;c[V+4>>2]=0;c[V+8>>2]=0;c[U>>2]=0;c[U+4>>2]=0;c[U+8>>2]=0;c[W>>2]=0;c[W+4>>2]=0;c[W+8>>2]=0;o=0;Ua(43,f|0,g|0,P|0,L|0,Q|0,T|0,X|0,V|0,U|0,M|0);J=o;o=0;a:do if(J&1)f=cc()|0;else{c[n>>2]=c[m>>2];G=V+4|0;H=U+4|0;I=U+8|0;J=V+8|0;z=(h&512|0)!=0;A=X+8|0;B=X+4|0;C=W+4|0;D=W+8|0;E=P+3|0;F=T+4|0;y=0;s=0;b:while(1){p=c[b>>2]|0;do if(p){f=c[p+12>>2]|0;if((f|0)==(c[p+16>>2]|0)){o=0;p=qa(c[(c[p>>2]|0)+36>>2]|0,p|0)|0;x=o;o=0;if(x&1){R=26;break b}}else p=c[f>>2]|0;if((p|0)==-1){c[b>>2]=0;g=1;break}else{g=(c[b>>2]|0)==0;break}}else g=1;while(0);f=c[e>>2]|0;do if(f){p=c[f+12>>2]|0;if((p|0)==(c[f+16>>2]|0)){o=0;p=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;x=o;o=0;if(x&1){R=26;break b}}else p=c[p>>2]|0;if((p|0)!=-1)if(g){x=f;break}else{t=q;R=244;break b}else{c[e>>2]=0;R=16;break}}else R=16;while(0);if((R|0)==16){R=0;if(g){t=q;R=244;break}else x=0}c:do switch(a[P+y>>0]|0){case 1:{if((y|0)!=3){p=c[b>>2]|0;f=c[p+12>>2]|0;if((f|0)==(c[p+16>>2]|0)){o=0;p=qa(c[(c[p>>2]|0)+36>>2]|0,p|0)|0;R=o;o=0;if(R&1){R=26;break b}}else p=c[f>>2]|0;o=0;p=ya(c[(c[l>>2]|0)+12>>2]|0,l|0,8192,p|0)|0;R=o;o=0;if(R&1){R=26;break b}if(!p){R=42;break b}p=c[b>>2]|0;f=p+12|0;g=c[f>>2]|0;if((g|0)==(c[p+16>>2]|0)){o=0;p=qa(c[(c[p>>2]|0)+40>>2]|0,p|0)|0;R=o;o=0;if(R&1){R=26;break b}}else{c[f>>2]=g+4;p=c[g>>2]|0}o=0;ma(223,W|0,p|0);R=o;o=0;if(R&1){R=26;break b}else{p=x;h=x;R=44}}else p=q;break}case 0:{if((y|0)==3)p=q;else{p=x;h=x;R=44}break}case 3:{f=a[V>>0]|0;p=(f&1)==0?(f&255)>>>1:c[G>>2]|0;g=a[U>>0]|0;h=(g&1)==0?(g&255)>>>1:c[H>>2]|0;if((p|0)==(0-h|0))p=q;else{if(!p){p=c[b>>2]|0;f=c[p+12>>2]|0;if((f|0)==(c[p+16>>2]|0)){o=0;p=qa(c[(c[p>>2]|0)+36>>2]|0,p|0)|0;x=o;o=0;if(x&1){R=26;break b}f=a[U>>0]|0}else{p=c[f>>2]|0;f=g}if((p|0)!=(c[((f&1)==0?H:c[I>>2]|0)>>2]|0)){p=q;break c}p=c[b>>2]|0;f=p+12|0;g=c[f>>2]|0;if((g|0)==(c[p+16>>2]|0)){o=0;qa(c[(c[p>>2]|0)+40>>2]|0,p|0)|0;x=o;o=0;if(x&1){R=26;break b}}else c[f>>2]=g+4;a[k>>0]=1;x=a[U>>0]|0;p=q;s=((x&1)==0?(x&255)>>>1:c[H>>2]|0)>>>0>1?U:s;break c}r=c[b>>2]|0;t=c[r+12>>2]|0;g=c[r+16>>2]|0;p=(t|0)==(g|0);if(!h){if(p){o=0;p=qa(c[(c[r>>2]|0)+36>>2]|0,r|0)|0;x=o;o=0;if(x&1){R=26;break b}f=a[V>>0]|0}else p=c[t>>2]|0;if((p|0)!=(c[((f&1)==0?G:c[J>>2]|0)>>2]|0)){a[k>>0]=1;p=q;break c}p=c[b>>2]|0;f=p+12|0;g=c[f>>2]|0;if((g|0)==(c[p+16>>2]|0)){o=0;qa(c[(c[p>>2]|0)+40>>2]|0,p|0)|0;x=o;o=0;if(x&1){R=26;break b}}else c[f>>2]=g+4;x=a[V>>0]|0;p=q;s=((x&1)==0?(x&255)>>>1:c[G>>2]|0)>>>0>1?V:s;break c}if(p){o=0;p=qa(c[(c[r>>2]|0)+36>>2]|0,r|0)|0;x=o;o=0;if(x&1){R=26;break b}g=c[b>>2]|0;f=a[V>>0]|0;r=g;t=c[g+12>>2]|0;g=c[g+16>>2]|0}else p=c[t>>2]|0;h=r+12|0;g=(t|0)==(g|0);if((p|0)==(c[((f&1)==0?G:c[J>>2]|0)>>2]|0)){if(g){o=0;qa(c[(c[r>>2]|0)+40>>2]|0,r|0)|0;x=o;o=0;if(x&1){R=26;break b}}else c[h>>2]=t+4;x=a[V>>0]|0;p=q;s=((x&1)==0?(x&255)>>>1:c[G>>2]|0)>>>0>1?V:s;break c}if(g){o=0;p=qa(c[(c[r>>2]|0)+36>>2]|0,r|0)|0;x=o;o=0;if(x&1){R=26;break b}}else p=c[t>>2]|0;if((p|0)!=(c[((a[U>>0]&1)==0?H:c[I>>2]|0)>>2]|0)){R=107;break b}p=c[b>>2]|0;f=p+12|0;g=c[f>>2]|0;if((g|0)==(c[p+16>>2]|0)){o=0;qa(c[(c[p>>2]|0)+40>>2]|0,p|0)|0;x=o;o=0;if(x&1){R=26;break b}}else c[f>>2]=g+4;a[k>>0]=1;x=a[U>>0]|0;p=q;s=((x&1)==0?(x&255)>>>1:c[H>>2]|0)>>>0>1?U:s}break}case 2:{if(!(y>>>0<2|(s|0)!=0)?!(z|(y|0)==2&(a[E>>0]|0)!=0):0){p=q;s=0;break c}h=a[X>>0]|0;g=c[A>>2]|0;f=(h&1)==0?B:g;p=f;d:do if((y|0)!=0?(d[P+(y+-1)>>0]|0)<2:0){w=(h&1)==0;e:do if((f|0)!=((w?B:g)+((w?(h&255)>>>1:c[B>>2]|0)<<2)|0)){h=f;while(1){o=0;f=ya(c[(c[l>>2]|0)+12>>2]|0,l|0,8192,c[h>>2]|0)|0;w=o;o=0;if(w&1){R=23;break b}if(!f)break;h=h+4|0;p=h;f=a[X>>0]|0;g=c[A>>2]|0;w=(f&1)==0;if((h|0)==((w?B:g)+((w?(f&255)>>>1:c[B>>2]|0)<<2)|0)){h=f;break e}}h=a[X>>0]|0;g=c[A>>2]|0}while(0);t=(h&1)==0?B:g;f=t;u=p-f>>2;v=a[W>>0]|0;r=(v&1)==0;v=r?(v&255)>>>1:c[C>>2]|0;if(v>>>0>=u>>>0){r=r?C:c[D>>2]|0;w=r+(v<<2)|0;if(!u)f=p;else{r=r+(v-u<<2)|0;while(1){if((c[r>>2]|0)!=(c[t>>2]|0))break d;r=r+4|0;if((r|0)==(w|0)){f=p;break}else t=t+4|0}}}}else f=p;while(0);p=(h&1)==0;p=(p?B:g)+((p?(h&255)>>>1:c[B>>2]|0)<<2)|0;f:do if((f|0)!=(p|0)){r=x;h=x;p=f;while(1){f=c[b>>2]|0;do if(f){g=c[f+12>>2]|0;if((g|0)==(c[f+16>>2]|0)){o=0;f=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;x=o;o=0;if(x&1){R=22;break b}}else f=c[g>>2]|0;if((f|0)==-1){c[b>>2]=0;g=1;break}else{g=(c[b>>2]|0)==0;break}}else g=1;while(0);do if(h){f=c[h+12>>2]|0;if((f|0)==(c[h+16>>2]|0)){o=0;f=qa(c[(c[h>>2]|0)+36>>2]|0,h|0)|0;x=o;o=0;if(x&1){R=22;break b}}else f=c[f>>2]|0;if((f|0)!=-1)if(g^(r|0)==0){f=r;t=r;break}else break f;else{c[e>>2]=0;f=0;R=136;break}}else{f=r;R=136}while(0);if((R|0)==136){R=0;if(g)break f;else t=0}g=c[b>>2]|0;h=c[g+12>>2]|0;if((h|0)==(c[g+16>>2]|0)){o=0;g=qa(c[(c[g>>2]|0)+36>>2]|0,g|0)|0;x=o;o=0;if(x&1){R=22;break b}}else g=c[h>>2]|0;if((g|0)!=(c[p>>2]|0))break f;g=c[b>>2]|0;h=g+12|0;r=c[h>>2]|0;if((r|0)==(c[g+16>>2]|0)){o=0;qa(c[(c[g>>2]|0)+40>>2]|0,g|0)|0;x=o;o=0;if(x&1){R=22;break b}}else c[h>>2]=r+4;p=p+4|0;g=a[X>>0]|0;x=(g&1)==0;g=(x?B:c[A>>2]|0)+((x?(g&255)>>>1:c[B>>2]|0)<<2)|0;if((p|0)==(g|0)){p=g;break}else{r=f;h=t}}}while(0);if(z?(x=a[X>>0]|0,w=(x&1)==0,(p|0)!=((w?B:c[A>>2]|0)+((w?(x&255)>>>1:c[B>>2]|0)<<2)|0)):0){R=148;break b}else p=q;break}case 4:{v=c[Q>>2]|0;u=x;r=x;p=q;f=0;g:while(1){g=c[b>>2]|0;do if(g){h=c[g+12>>2]|0;if((h|0)==(c[g+16>>2]|0)){o=0;g=qa(c[(c[g>>2]|0)+36>>2]|0,g|0)|0;x=o;o=0;if(x&1){R=25;break b}}else g=c[h>>2]|0;if((g|0)==-1){c[b>>2]=0;h=1;break}else{h=(c[b>>2]|0)==0;break}}else h=1;while(0);do if(r){g=c[r+12>>2]|0;if((g|0)==(c[r+16>>2]|0)){o=0;g=qa(c[(c[r>>2]|0)+36>>2]|0,r|0)|0;x=o;o=0;if(x&1){R=25;break b}}else g=c[g>>2]|0;if((g|0)!=-1)if(h^(u|0)==0){g=u;t=u;break}else{q=u;break g}else{c[e>>2]=0;g=0;R=162;break}}else{g=u;R=162}while(0);if((R|0)==162){R=0;if(h){q=g;break}else t=0}h=c[b>>2]|0;q=c[h+12>>2]|0;if((q|0)==(c[h+16>>2]|0)){o=0;h=qa(c[(c[h>>2]|0)+36>>2]|0,h|0)|0;x=o;o=0;if(x&1){R=25;break b}}else h=c[q>>2]|0;o=0;q=ya(c[(c[l>>2]|0)+12>>2]|0,l|0,2048,h|0)|0;x=o;o=0;if(x&1){R=25;break b}if(q){q=c[n>>2]|0;if((q|0)==(c[K>>2]|0)){o=0;mb(118,m|0,n|0,K|0);x=o;o=0;if(x&1){R=25;break b}q=c[n>>2]|0}c[n>>2]=q+4;c[q>>2]=h;f=f+1|0}else{x=a[T>>0]|0;if(!((h|0)==(v|0)&((f|0)!=0?(((x&1)==0?(x&255)>>>1:c[F>>2]|0)|0)!=0:0))){q=g;break}if((p|0)==(c[N>>2]|0)){o=0;mb(117,_|0,O|0,N|0);x=o;o=0;if(x&1){R=25;break b}p=c[O>>2]|0}x=p+4|0;c[O>>2]=x;c[p>>2]=f;p=x;f=0}h=c[b>>2]|0;q=h+12|0;r=c[q>>2]|0;if((r|0)==(c[h+16>>2]|0)){o=0;qa(c[(c[h>>2]|0)+40>>2]|0,h|0)|0;x=o;o=0;if(x&1){R=25;break b}else{u=g;r=t;continue}}else{c[q>>2]=r+4;u=g;r=t;continue}}if((f|0)!=0?(c[_>>2]|0)!=(p|0):0){if((p|0)==(c[N>>2]|0)){o=0;mb(117,_|0,O|0,N|0);x=o;o=0;if(x&1){R=26;break b}p=c[O>>2]|0}x=p+4|0;c[O>>2]=x;c[p>>2]=f;p=x}t=c[M>>2]|0;if((t|0)>0){f=c[b>>2]|0;do if(f){g=c[f+12>>2]|0;if((g|0)==(c[f+16>>2]|0)){o=0;f=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;x=o;o=0;if(x&1){R=26;break b}}else f=c[g>>2]|0;if((f|0)==-1){c[b>>2]=0;g=1;break}else{g=(c[b>>2]|0)==0;break}}else g=1;while(0);do if(q){f=c[q+12>>2]|0;if((f|0)==(c[q+16>>2]|0)){o=0;f=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;x=o;o=0;if(x&1){R=26;break b}}else f=c[f>>2]|0;if((f|0)!=-1)if(g)break;else{R=206;break b}else{c[e>>2]=0;R=200;break}}else R=200;while(0);if((R|0)==200){R=0;if(g){R=206;break b}else q=0}f=c[b>>2]|0;g=c[f+12>>2]|0;if((g|0)==(c[f+16>>2]|0)){o=0;f=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;x=o;o=0;if(x&1){R=26;break b}}else f=c[g>>2]|0;if((f|0)!=(c[L>>2]|0)){R=206;break b}f=c[b>>2]|0;g=f+12|0;h=c[g>>2]|0;if((h|0)==(c[f+16>>2]|0)){o=0;qa(c[(c[f>>2]|0)+40>>2]|0,f|0)|0;x=o;o=0;if(x&1){R=26;break b}}else c[g>>2]=h+4;if((t|0)>0){r=q;h=q;u=t;while(1){f=c[b>>2]|0;do if(f){g=c[f+12>>2]|0;if((g|0)==(c[f+16>>2]|0)){o=0;f=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;x=o;o=0;if(x&1){R=24;break b}}else f=c[g>>2]|0;if((f|0)==-1){c[b>>2]=0;g=1;break}else{g=(c[b>>2]|0)==0;break}}else g=1;while(0);do if(h){f=c[h+12>>2]|0;if((f|0)==(c[h+16>>2]|0)){o=0;f=qa(c[(c[h>>2]|0)+36>>2]|0,h|0)|0;x=o;o=0;if(x&1){R=24;break b}}else f=c[f>>2]|0;if((f|0)!=-1)if(g^(r|0)==0){f=r;t=r;break}else{R=231;break b}else{c[e>>2]=0;f=0;R=224;break}}else{f=r;R=224}while(0);if((R|0)==224){R=0;if(g){R=231;break b}else t=0}g=c[b>>2]|0;h=c[g+12>>2]|0;if((h|0)==(c[g+16>>2]|0)){o=0;g=qa(c[(c[g>>2]|0)+36>>2]|0,g|0)|0;x=o;o=0;if(x&1){R=24;break b}}else g=c[h>>2]|0;o=0;g=ya(c[(c[l>>2]|0)+12>>2]|0,l|0,2048,g|0)|0;x=o;o=0;if(x&1){R=24;break b}if(!g){R=231;break b}if((c[n>>2]|0)==(c[K>>2]|0)?(o=0,mb(118,m|0,n|0,K|0),x=o,o=0,x&1):0){R=24;break b}g=c[b>>2]|0;h=c[g+12>>2]|0;if((h|0)==(c[g+16>>2]|0)){o=0;g=qa(c[(c[g>>2]|0)+36>>2]|0,g|0)|0;x=o;o=0;if(x&1){R=24;break b}}else g=c[h>>2]|0;h=c[n>>2]|0;c[n>>2]=h+4;c[h>>2]=g;g=u;u=u+-1|0;c[M>>2]=u;h=c[b>>2]|0;q=h+12|0;r=c[q>>2]|0;if((r|0)==(c[h+16>>2]|0)){o=0;qa(c[(c[h>>2]|0)+40>>2]|0,h|0)|0;x=o;o=0;if(x&1){R=24;break b}}else c[q>>2]=r+4;if((g|0)<=1)break;else{r=f;h=t}}}}if((c[n>>2]|0)==(c[m>>2]|0)){R=242;break b}break}default:p=q}while(0);h:do if((R|0)==44)while(1){R=0;f=c[b>>2]|0;do if(f){g=c[f+12>>2]|0;if((g|0)==(c[f+16>>2]|0)){o=0;f=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;x=o;o=0;if(x&1){R=21;break b}}else f=c[g>>2]|0;if((f|0)==-1){c[b>>2]=0;g=1;break}else{g=(c[b>>2]|0)==0;break}}else g=1;while(0);do if(h){f=c[h+12>>2]|0;if((f|0)==(c[h+16>>2]|0)){o=0;f=qa(c[(c[h>>2]|0)+36>>2]|0,h|0)|0;x=o;o=0;if(x&1){R=21;break b}}else f=c[f>>2]|0;if((f|0)!=-1)if(g^(p|0)==0){r=p;h=p;break}else{p=q;break h}else{c[e>>2]=0;p=0;R=57;break}}else R=57;while(0);if((R|0)==57){R=0;if(g){p=q;break h}else{r=p;h=0}}p=c[b>>2]|0;f=c[p+12>>2]|0;if((f|0)==(c[p+16>>2]|0)){o=0;p=qa(c[(c[p>>2]|0)+36>>2]|0,p|0)|0;x=o;o=0;if(x&1){R=21;break b}}else p=c[f>>2]|0;o=0;p=ya(c[(c[l>>2]|0)+12>>2]|0,l|0,8192,p|0)|0;x=o;o=0;if(x&1){R=21;break b}if(!p){p=q;break h}p=c[b>>2]|0;f=p+12|0;g=c[f>>2]|0;if((g|0)==(c[p+16>>2]|0)){o=0;p=qa(c[(c[p>>2]|0)+40>>2]|0,p|0)|0;R=o;o=0;if(R&1){R=21;break b}}else{c[f>>2]=g+4;p=c[g>>2]|0}o=0;ma(223,W|0,p|0);R=o;o=0;if(R&1){R=21;break b}else{p=r;R=44}}while(0);y=y+1|0;if(y>>>0>=4){t=p;R=244;break}else q=p}i:switch(R|0){case 21:{f=cc()|0;break a}case 22:{f=cc()|0;break a}case 23:{f=cc()|0;break a}case 24:{f=cc()|0;break a}case 25:{f=cc()|0;break a}case 26:{f=cc()|0;break a}case 42:{c[j>>2]=c[j>>2]|4;f=0;break}case 107:{c[j>>2]=c[j>>2]|4;f=0;break}case 148:{c[j>>2]=c[j>>2]|4;f=0;break}case 206:{c[j>>2]=c[j>>2]|4;f=0;break}case 231:{c[j>>2]=c[j>>2]|4;f=0;break}case 242:{c[j>>2]=c[j>>2]|4;f=0;break}case 244:{j:do if(s){q=s+4|0;r=s+8|0;h=1;k:while(1){p=a[s>>0]|0;if(!(p&1))p=(p&255)>>>1;else p=c[q>>2]|0;if(h>>>0>=p>>>0)break j;p=c[b>>2]|0;do if(p){f=c[p+12>>2]|0;if((f|0)==(c[p+16>>2]|0)){o=0;p=qa(c[(c[p>>2]|0)+36>>2]|0,p|0)|0;n=o;o=0;if(n&1){R=20;break k}}else p=c[f>>2]|0;if((p|0)==-1){c[b>>2]=0;g=1;break}else{g=(c[b>>2]|0)==0;break}}else g=1;while(0);p=c[e>>2]|0;do if(p){f=c[p+12>>2]|0;if((f|0)==(c[p+16>>2]|0)){o=0;p=qa(c[(c[p>>2]|0)+36>>2]|0,p|0)|0;n=o;o=0;if(n&1){R=20;break k}}else p=c[f>>2]|0;if((p|0)!=-1)if(g)break;else{R=271;break k}else{c[e>>2]=0;R=263;break}}else R=263;while(0);if((R|0)==263?(R=0,g):0){R=271;break}p=c[b>>2]|0;f=c[p+12>>2]|0;if((f|0)==(c[p+16>>2]|0)){o=0;p=qa(c[(c[p>>2]|0)+36>>2]|0,p|0)|0;n=o;o=0;if(n&1){R=20;break}}else p=c[f>>2]|0;if(!(a[s>>0]&1))f=q;else f=c[r>>2]|0;if((p|0)!=(c[f+(h<<2)>>2]|0)){R=271;break}p=h+1|0;f=c[b>>2]|0;g=f+12|0;h=c[g>>2]|0;if((h|0)==(c[f+16>>2]|0)){o=0;qa(c[(c[f>>2]|0)+40>>2]|0,f|0)|0;n=o;o=0;if(n&1){R=20;break}else{h=p;continue}}else{c[g>>2]=h+4;h=p;continue}}if((R|0)==20){f=cc()|0;break a}else if((R|0)==271){c[j>>2]=c[j>>2]|4;f=0;break i}}while(0);p=c[_>>2]|0;if((p|0)!=(t|0)?(c[S>>2]=0,oH(T,p,t,S),(c[S>>2]|0)!=0):0){c[j>>2]=c[j>>2]|4;f=0}else f=1;break}}ZC(W);ZC(U);ZC(V);ZC(X);IC(T);p=c[_>>2]|0;c[_>>2]=0;if((p|0)!=0?(o=0,ka(c[Z>>2]|0,p|0),_=o,o=0,_&1):0){_=cc(0)|0;oq(_)}i=Y;return f|0}while(0);ZC(W);ZC(U);ZC(V);ZC(X);IC(T);p=c[_>>2]|0;c[_>>2]=0;if((p|0)!=0?(o=0,ka(c[Z>>2]|0,p|0),_=o,o=0,_&1):0){_=cc(0)|0;oq(_)}bc(f|0);return 0}function tH(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;w=i;i=i+432|0;k=w+424|0;b=w+24|0;y=w+16|0;s=w+8|0;p=w+4|0;q=w+428|0;l=w;c[y>>2]=b;A=y+4|0;c[A>>2]=345;m=b+400|0;o=0;v=qa(192,g|0)|0;n=o;o=0;if(!(n&1)){c[p>>2]=v;o=0;n=Wa(115,p|0,40896)|0;b=o;o=0;a:do if(!(b&1)?(a[q>>0]=0,t=c[e>>2]|0,c[l>>2]=t,r=c[g+4>>2]|0,u=t,o=0,c[k>>2]=c[l>>2],r=ua(43,d|0,k|0,f|0,p|0,r|0,h|0,q|0,n|0,y|0,s|0,m|0)|0,g=o,o=0,!(g&1)):0){if(r){if(!(a[j>>0]&1))a[j>>0]=0;else c[c[j+8>>2]>>2]=0;c[j+4>>2]=0;if(a[q>>0]|0){o=0;b=Wa(c[(c[n>>2]|0)+44>>2]|0,n|0,45)|0;g=o;o=0;if(g&1)break;o=0;ma(223,j|0,b|0);g=o;o=0;if(g&1)break}o=0;l=Wa(c[(c[n>>2]|0)+44>>2]|0,n|0,48)|0;g=o;o=0;if(g&1)break;b=c[y>>2]|0;m=c[s>>2]|0;k=m+-4|0;b:do if(b>>>0<k>>>0)do{if((c[b>>2]|0)!=(l|0))break b;b=b+4|0}while(b>>>0<k>>>0);while(0);o=0;ya(123,j|0,b|0,m|0)|0;j=o;o=0;if(j&1)break}b=c[d>>2]|0;do if(b){k=c[b+12>>2]|0;if((k|0)==(c[b+16>>2]|0)){o=0;b=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;j=o;o=0;if(j&1)break a}else b=c[k>>2]|0;if((b|0)==-1){c[d>>2]=0;k=1;break}else{k=(c[d>>2]|0)==0;break}}else k=1;while(0);do if(t){b=c[u+12>>2]|0;if((b|0)==(c[u+16>>2]|0)){o=0;b=qa(c[(c[t>>2]|0)+36>>2]|0,u|0)|0;u=o;o=0;if(u&1)break a}else b=c[b>>2]|0;if((b|0)!=-1)if(k)break;else{z=32;break}else{c[e>>2]=0;z=30;break}}else z=30;while(0);if((z|0)==30?k:0)z=32;if((z|0)==32)c[h>>2]=c[h>>2]|2;k=c[d>>2]|0;EL(v)|0;b=c[y>>2]|0;c[y>>2]=0;if((b|0)!=0?(o=0,ka(c[A>>2]|0,b|0),A=o,o=0,A&1):0){A=cc(0)|0;oq(A)}i=w;return k|0}while(0);k=cc()|0;EL(v)|0;b=c[y>>2]|0;c[y>>2]=0;if(!b)x=k;else z=38}else{k=cc()|0;c[y>>2]=0;z=38}if((z|0)==38){o=0;ka(c[A>>2]|0,b|0);A=o;o=0;if(A&1){A=cc(0)|0;oq(A)}else x=k}bc(x|0);return 0}function uH(b,d,e,f,g,h,j,k,l,m){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;z=i;i=i+112|0;n=z+100|0;p=z+88|0;q=z+76|0;r=z+64|0;s=z+52|0;t=z+48|0;u=z+36|0;v=z+24|0;w=z+12|0;x=z;do if(b){b=cI(d,40640)|0;$c[c[(c[b>>2]|0)+44>>2]&511](n,b);x=c[n>>2]|0;a[e>>0]=x;a[e+1>>0]=x>>8;a[e+2>>0]=x>>16;a[e+3>>0]=x>>24;$c[c[(c[b>>2]|0)+32>>2]&511](p,b);if(!(a[l>>0]&1))a[l>>0]=0;else c[c[l+8>>2]>>2]=0;c[l+4>>2]=0;o=0;ma(224,l|0,0);e=o;o=0;if(e&1){e=cc(0)|0;oq(e)};c[l>>2]=c[p>>2];c[l+4>>2]=c[p+4>>2];c[l+8>>2]=c[p+8>>2];c[p>>2]=0;c[p+4>>2]=0;c[p+8>>2]=0;ZC(p);$c[c[(c[b>>2]|0)+28>>2]&511](q,b);if(!(a[k>>0]&1))a[k>>0]=0;else c[c[k+8>>2]>>2]=0;c[k+4>>2]=0;o=0;ma(224,k|0,0);e=o;o=0;if(e&1){e=cc(0)|0;oq(e)};c[k>>2]=c[q>>2];c[k+4>>2]=c[q+4>>2];c[k+8>>2]=c[q+8>>2];c[q>>2]=0;c[q+4>>2]=0;c[q+8>>2]=0;ZC(q);c[f>>2]=bd[c[(c[b>>2]|0)+12>>2]&255](b)|0;c[g>>2]=bd[c[(c[b>>2]|0)+16>>2]&255](b)|0;$c[c[(c[b>>2]|0)+20>>2]&511](r,b);if(!(a[h>>0]&1)){a[h+1>>0]=0;a[h>>0]=0}else{a[c[h+8>>2]>>0]=0;c[h+4>>2]=0}o=0;ma(114,h|0,0);g=o;o=0;if(g&1){g=cc(0)|0;oq(g)};c[h>>2]=c[r>>2];c[h+4>>2]=c[r+4>>2];c[h+8>>2]=c[r+8>>2];c[r>>2]=0;c[r+4>>2]=0;c[r+8>>2]=0;IC(r);$c[c[(c[b>>2]|0)+24>>2]&511](s,b);if(!(a[j>>0]&1))a[j>>0]=0;else c[c[j+8>>2]>>2]=0;c[j+4>>2]=0;o=0;ma(224,j|0,0);g=o;o=0;if(g&1){g=cc(0)|0;oq(g)}else{c[j>>2]=c[s>>2];c[j+4>>2]=c[s+4>>2];c[j+8>>2]=c[s+8>>2];c[s>>2]=0;c[s+4>>2]=0;c[s+8>>2]=0;ZC(s);y=bd[c[(c[b>>2]|0)+36>>2]&255](b)|0;break}}else{b=cI(d,40576)|0;$c[c[(c[b>>2]|0)+44>>2]&511](t,b);t=c[t>>2]|0;a[e>>0]=t;a[e+1>>0]=t>>8;a[e+2>>0]=t>>16;a[e+3>>0]=t>>24;$c[c[(c[b>>2]|0)+32>>2]&511](u,b);if(!(a[l>>0]&1))a[l>>0]=0;else c[c[l+8>>2]>>2]=0;c[l+4>>2]=0;o=0;ma(224,l|0,0);e=o;o=0;if(e&1){e=cc(0)|0;oq(e)};c[l>>2]=c[u>>2];c[l+4>>2]=c[u+4>>2];c[l+8>>2]=c[u+8>>2];c[u>>2]=0;c[u+4>>2]=0;c[u+8>>2]=0;ZC(u);$c[c[(c[b>>2]|0)+28>>2]&511](v,b);if(!(a[k>>0]&1))a[k>>0]=0;else c[c[k+8>>2]>>2]=0;c[k+4>>2]=0;o=0;ma(224,k|0,0);e=o;o=0;if(e&1){e=cc(0)|0;oq(e)};c[k>>2]=c[v>>2];c[k+4>>2]=c[v+4>>2];c[k+8>>2]=c[v+8>>2];c[v>>2]=0;c[v+4>>2]=0;c[v+8>>2]=0;ZC(v);c[f>>2]=bd[c[(c[b>>2]|0)+12>>2]&255](b)|0;c[g>>2]=bd[c[(c[b>>2]|0)+16>>2]&255](b)|0;$c[c[(c[b>>2]|0)+20>>2]&511](w,b);if(!(a[h>>0]&1)){a[h+1>>0]=0;a[h>>0]=0}else{a[c[h+8>>2]>>0]=0;c[h+4>>2]=0}o=0;ma(114,h|0,0);g=o;o=0;if(g&1){g=cc(0)|0;oq(g)};c[h>>2]=c[w>>2];c[h+4>>2]=c[w+4>>2];c[h+8>>2]=c[w+8>>2];c[w>>2]=0;c[w+4>>2]=0;c[w+8>>2]=0;IC(w);$c[c[(c[b>>2]|0)+24>>2]&511](x,b);if(!(a[j>>0]&1))a[j>>0]=0;else c[c[j+8>>2]>>2]=0;c[j+4>>2]=0;o=0;ma(224,j|0,0);g=o;o=0;if(g&1){g=cc(0)|0;oq(g)}else{c[j>>2]=c[x>>2];c[j+4>>2]=c[x+4>>2];c[j+8>>2]=c[x+8>>2];c[x>>2]=0;c[x+4>>2]=0;c[x+8>>2]=0;ZC(x);y=bd[c[(c[b>>2]|0)+36>>2]&255](b)|0;break}}while(0);c[m>>2]=y;i=z;return}function vH(a){a=a|0;return}function wH(a){a=a|0;Uz(a);return}function xH(b,d,e,f,g,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;j=+j;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;D=i;i=i+384|0;v=D+8|0;k=D;m=D+284|0;n=D+72|0;l=D+184|0;F=D+68|0;A=D+80|0;x=D+77|0;B=D+76|0;G=D+56|0;I=D+44|0;H=D+32|0;p=D+28|0;u=D+84|0;z=D+24|0;y=D+20|0;w=D+16|0;c[n>>2]=m;h[v>>3]=j;m=SB(m,100,61377,v)|0;do if(m>>>0>99){o=0;b=gb(45)|0;C=o;o=0;if(!(C&1)?(o=0,h[k>>3]=j,s=kb(65,n|0,b|0,61377,k|0)|0,C=o,o=0,!(C&1)):0){b=c[n>>2]|0;if(!b){o=0;ob(46);C=o;o=0;if(C&1){b=0;k=0;C=7;break}b=c[n>>2]|0}l=yC(s)|0;k=l;if(!l){o=0;ob(46);C=o;o=0;if(C&1)C=7;else{t=0;C=10}}else{t=l;C=10}}else{b=0;k=0;C=7}}else{k=0;b=0;t=l;s=m;C=10}while(0);if((C|0)==10){o=0;l=qa(192,f|0)|0;r=o;o=0;if(r&1)C=7;else{c[F>>2]=l;o=0;r=Wa(115,F|0,40904)|0;q=o;o=0;if(!(q&1)?(q=c[n>>2]|0,o=0,kb(c[(c[r>>2]|0)+32>>2]|0,r|0,q|0,q+s|0,t|0)|0,q=o,o=0,!(q&1)):0){if(!s)q=0;else q=(a[c[n>>2]>>0]|0)==45;c[G>>2]=0;c[G+4>>2]=0;c[G+8>>2]=0;c[I>>2]=0;c[I+4>>2]=0;c[I+8>>2]=0;c[H>>2]=0;c[H+4>>2]=0;c[H+8>>2]=0;o=0;Ua(44,e|0,q|0,F|0,A|0,x|0,B|0,G|0,I|0,H|0,p|0);e=o;o=0;if(!(e&1)){p=c[p>>2]|0;if((s|0)>(p|0)){e=a[H>>0]|0;m=a[I>>0]|0;m=(s-p<<1|1)+p+((e&1)==0?(e&255)>>>1:c[H+4>>2]|0)+((m&1)==0?(m&255)>>>1:c[I+4>>2]|0)|0}else{e=a[H>>0]|0;m=a[I>>0]|0;m=p+2+((e&1)==0?(e&255)>>>1:c[H+4>>2]|0)+((m&1)==0?(m&255)>>>1:c[I+4>>2]|0)|0}if(m>>>0>100){m=yC(m)|0;n=m;if(!m){o=0;ob(46);u=o;o=0;if(!(u&1)){m=0;C=26}}else C=26}else{n=0;m=u;C=26}if((C|0)==26){o=0;Aa(42,m|0,z|0,y|0,c[f+4>>2]|0,t|0,t+s|0,r|0,q|0,A|0,a[x>>0]|0,a[B>>0]|0,G|0,I|0,H|0,p|0);B=o;o=0;if(!(B&1)?(c[w>>2]=c[d>>2],d=c[z>>2]|0,E=c[y>>2]|0,o=0,c[v>>2]=c[w>>2],E=oa(83,v|0,m|0,d|0,E|0,f|0,g|0)|0,d=o,o=0,!(d&1)):0){if(n){zC(n);l=c[F>>2]|0}IC(H);IC(I);IC(G);EL(l)|0;if(k)zC(k);if(b)zC(b);i=D;return E|0}}m=cc()|0;if(n){zC(n);l=c[F>>2]|0}}else m=cc()|0;IC(H);IC(I);IC(G)}else m=cc()|0;EL(l)|0}}if((C|0)==7)m=cc()|0;if(k)zC(k);if(b)zC(b);bc(m|0);return 0}function yH(b,d,e,f,g,h,j,k,l,m){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;D=i;i=i+112|0;q=D+108|0;r=D+96|0;u=D+92|0;v=D+80|0;w=D+68|0;x=D+56|0;y=D+52|0;z=D+40|0;A=D+36|0;B=D+24|0;s=D+12|0;t=D;do if(b){b=cI(e,40512)|0;e=c[b>>2]|0;do if(d){$c[c[e+44>>2]&511](q,b);d=c[q>>2]|0;a[f>>0]=d;a[f+1>>0]=d>>8;a[f+2>>0]=d>>16;a[f+3>>0]=d>>24;$c[c[(c[b>>2]|0)+32>>2]&511](r,b);if(!(a[l>>0]&1)){a[l+1>>0]=0;a[l>>0]=0}else{a[c[l+8>>2]>>0]=0;c[l+4>>2]=0}o=0;ma(114,l|0,0);f=o;o=0;if(f&1){l=cc(0)|0;oq(l)}else{c[l>>2]=c[r>>2];c[l+4>>2]=c[r+4>>2];c[l+8>>2]=c[r+8>>2];c[r>>2]=0;c[r+4>>2]=0;c[r+8>>2]=0;IC(r);p=b;break}}else{$c[c[e+40>>2]&511](u,b);d=c[u>>2]|0;a[f>>0]=d;a[f+1>>0]=d>>8;a[f+2>>0]=d>>16;a[f+3>>0]=d>>24;$c[c[(c[b>>2]|0)+28>>2]&511](v,b);if(!(a[l>>0]&1)){a[l+1>>0]=0;a[l>>0]=0}else{a[c[l+8>>2]>>0]=0;c[l+4>>2]=0}o=0;ma(114,l|0,0);f=o;o=0;if(f&1){l=cc(0)|0;oq(l)}else{c[l>>2]=c[v>>2];c[l+4>>2]=c[v+4>>2];c[l+8>>2]=c[v+8>>2];c[v>>2]=0;c[v+4>>2]=0;c[v+8>>2]=0;IC(v);p=b;break}}while(0);a[g>>0]=bd[c[(c[b>>2]|0)+12>>2]&255](b)|0;a[h>>0]=bd[c[(c[b>>2]|0)+16>>2]&255](b)|0;$c[c[(c[p>>2]|0)+20>>2]&511](w,b);if(!(a[j>>0]&1)){a[j+1>>0]=0;a[j>>0]=0}else{a[c[j+8>>2]>>0]=0;c[j+4>>2]=0}o=0;ma(114,j|0,0);h=o;o=0;if(h&1){h=cc(0)|0;oq(h)};c[j>>2]=c[w>>2];c[j+4>>2]=c[w+4>>2];c[j+8>>2]=c[w+8>>2];c[w>>2]=0;c[w+4>>2]=0;c[w+8>>2]=0;IC(w);$c[c[(c[p>>2]|0)+24>>2]&511](x,b);if(!(a[k>>0]&1)){a[k+1>>0]=0;a[k>>0]=0}else{a[c[k+8>>2]>>0]=0;c[k+4>>2]=0}o=0;ma(114,k|0,0);h=o;o=0;if(h&1){h=cc(0)|0;oq(h)}else{c[k>>2]=c[x>>2];c[k+4>>2]=c[x+4>>2];c[k+8>>2]=c[x+8>>2];c[x>>2]=0;c[x+4>>2]=0;c[x+8>>2]=0;IC(x);C=bd[c[(c[b>>2]|0)+36>>2]&255](b)|0;break}}else{b=cI(e,40448)|0;e=c[b>>2]|0;do if(d){$c[c[e+44>>2]&511](y,b);d=c[y>>2]|0;a[f>>0]=d;a[f+1>>0]=d>>8;a[f+2>>0]=d>>16;a[f+3>>0]=d>>24;$c[c[(c[b>>2]|0)+32>>2]&511](z,b);if(!(a[l>>0]&1)){a[l+1>>0]=0;a[l>>0]=0}else{a[c[l+8>>2]>>0]=0;c[l+4>>2]=0}o=0;ma(114,l|0,0);f=o;o=0;if(f&1){l=cc(0)|0;oq(l)}else{c[l>>2]=c[z>>2];c[l+4>>2]=c[z+4>>2];c[l+8>>2]=c[z+8>>2];c[z>>2]=0;c[z+4>>2]=0;c[z+8>>2]=0;IC(z);n=b;break}}else{$c[c[e+40>>2]&511](A,b);d=c[A>>2]|0;a[f>>0]=d;a[f+1>>0]=d>>8;a[f+2>>0]=d>>16;a[f+3>>0]=d>>24;$c[c[(c[b>>2]|0)+28>>2]&511](B,b);if(!(a[l>>0]&1)){a[l+1>>0]=0;a[l>>0]=0}else{a[c[l+8>>2]>>0]=0;c[l+4>>2]=0}o=0;ma(114,l|0,0);f=o;o=0;if(f&1){l=cc(0)|0;oq(l)}else{c[l>>2]=c[B>>2];c[l+4>>2]=c[B+4>>2];c[l+8>>2]=c[B+8>>2];c[B>>2]=0;c[B+4>>2]=0;c[B+8>>2]=0;IC(B);n=b;break}}while(0);a[g>>0]=bd[c[(c[b>>2]|0)+12>>2]&255](b)|0;a[h>>0]=bd[c[(c[b>>2]|0)+16>>2]&255](b)|0;$c[c[(c[n>>2]|0)+20>>2]&511](s,b);if(!(a[j>>0]&1)){a[j+1>>0]=0;a[j>>0]=0}else{a[c[j+8>>2]>>0]=0;c[j+4>>2]=0}o=0;ma(114,j|0,0);h=o;o=0;if(h&1){h=cc(0)|0;oq(h)};c[j>>2]=c[s>>2];c[j+4>>2]=c[s+4>>2];c[j+8>>2]=c[s+8>>2];c[s>>2]=0;c[s+4>>2]=0;c[s+8>>2]=0;IC(s);$c[c[(c[n>>2]|0)+24>>2]&511](t,b);if(!(a[k>>0]&1)){a[k+1>>0]=0;a[k>>0]=0}else{a[c[k+8>>2]>>0]=0;c[k+4>>2]=0}o=0;ma(114,k|0,0);h=o;o=0;if(h&1){h=cc(0)|0;oq(h)}else{c[k>>2]=c[t>>2];c[k+4>>2]=c[t+4>>2];c[k+8>>2]=c[t+8>>2];c[t>>2]=0;c[t+4>>2]=0;c[t+8>>2]=0;IC(t);C=bd[c[(c[b>>2]|0)+36>>2]&255](b)|0;break}}while(0);c[m>>2]=C;i=D;return}function zH(d,e,f,g,h,i,j,k,l,m,n,o,p,q,r){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;var s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0;c[f>>2]=d;N=q+4|0;O=q+8|0;P=q+1|0;H=p+4|0;I=(g&512|0)==0;J=p+8|0;K=p+1|0;L=j+8|0;M=(r|0)>0;A=o+4|0;B=o+8|0;C=o+1|0;D=r+1|0;F=-2-r-((r|0)<0?~r:-1)|0;G=(r|0)>0;z=0;do{switch(a[l+z>>0]|0){case 0:{c[e>>2]=c[f>>2];break}case 1:{c[e>>2]=c[f>>2];x=rd[c[(c[j>>2]|0)+28>>2]&127](j,32)|0;y=c[f>>2]|0;c[f>>2]=y+1;a[y>>0]=x;break}case 3:{y=a[q>>0]|0;s=(y&1)==0;if((s?(y&255)>>>1:c[N>>2]|0)|0){x=a[(s?P:c[O>>2]|0)>>0]|0;y=c[f>>2]|0;c[f>>2]=y+1;a[y>>0]=x}break}case 2:{u=a[p>>0]|0;s=(u&1)==0;u=s?(u&255)>>>1:c[H>>2]|0;if(!(I|(u|0)==0)){t=s?K:c[J>>2]|0;v=t+u|0;s=c[f>>2]|0;if(u)do{a[s>>0]=a[t>>0]|0;t=t+1|0;s=s+1|0}while((t|0)!=(v|0));c[f>>2]=s}break}case 4:{s=c[f>>2]|0;h=k?h+1|0:h;w=h;v=c[L>>2]|0;a:do if(h>>>0<i>>>0){t=h;do{u=a[t>>0]|0;if(u<<24>>24<=-1)break a;if(!(b[v+(u<<24>>24<<1)>>1]&2048))break a;t=t+1|0}while(t>>>0<i>>>0)}else t=h;while(0);u=t;if(M){x=-2-u-~(u>>>0>w>>>0?w:u)|0;x=F>>>0>x>>>0?F:x;if(t>>>0>h>>>0&G){u=t;w=r;while(1){u=u+-1|0;y=a[u>>0]|0;v=c[f>>2]|0;c[f>>2]=v+1;a[v>>0]=y;v=(w|0)>1;if(!(u>>>0>h>>>0&v))break;else w=w+-1|0}}else v=G;y=D+x|0;u=t+(x+1)|0;if(v)w=rd[c[(c[j>>2]|0)+28>>2]&127](j,48)|0;else w=0;t=c[f>>2]|0;c[f>>2]=t+1;if((y|0)>0){v=y;while(1){a[t>>0]=w;t=c[f>>2]|0;c[f>>2]=t+1;if((v|0)>1)v=v+-1|0;else break}}a[t>>0]=m}else u=t;if((u|0)!=(h|0)){y=a[o>>0]|0;t=(y&1)==0;if(!((t?(y&255)>>>1:c[A>>2]|0)|0))t=-1;else t=a[(t?C:c[B>>2]|0)>>0]|0;if((u|0)!=(h|0)){v=0;w=0;while(1){if((w|0)==(t|0)){y=c[f>>2]|0;c[f>>2]=y+1;a[y>>0]=n;v=v+1|0;y=a[o>>0]|0;t=(y&1)==0;if(v>>>0<(t?(y&255)>>>1:c[A>>2]|0)>>>0){t=a[(t?C:c[B>>2]|0)+v>>0]|0;t=t<<24>>24==127?-1:t<<24>>24;w=0}else{t=w;w=0}}u=u+-1|0;x=a[u>>0]|0;y=c[f>>2]|0;c[f>>2]=y+1;a[y>>0]=x;if((u|0)==(h|0))break;else w=w+1|0}}}else{x=rd[c[(c[j>>2]|0)+28>>2]&127](j,48)|0;y=c[f>>2]|0;c[f>>2]=y+1;a[y>>0]=x}t=c[f>>2]|0;if((s|0)!=(t|0)?(E=t+-1|0,s>>>0<E>>>0):0){t=E;do{y=a[s>>0]|0;a[s>>0]=a[t>>0]|0;a[t>>0]=y;s=s+1|0;t=t+-1|0}while(s>>>0<t>>>0)}break}default:{}}z=z+1|0}while((z|0)!=4);t=a[q>>0]|0;h=(t&1)==0;t=h?(t&255)>>>1:c[N>>2]|0;if(t>>>0>1){s=h?P:c[O>>2]|0;u=s+t|0;h=c[f>>2]|0;if((t|0)!=1){s=s+1|0;do{a[h>>0]=a[s>>0]|0;h=h+1|0;s=s+1|0}while((s|0)!=(u|0))}c[f>>2]=h}switch(g&176|0){case 32:{c[e>>2]=c[f>>2];break}case 16:break;default:c[e>>2]=d}return}function AH(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;z=i;i=i+176|0;r=z+56|0;B=z+52|0;x=z+64|0;u=z+61|0;y=z+60|0;C=z+40|0;E=z+28|0;D=z+16|0;m=z+12|0;q=z+68|0;w=z+8|0;v=z+4|0;s=z;b=lD(f)|0;c[B>>2]=b;o=0;t=Wa(115,B|0,40904)|0;p=o;o=0;do if(p&1)F=13;else{n=a[h>>0]|0;j=(n&1)==0;p=h+4|0;if(!((j?(n&255)>>>1:c[p>>2]|0)|0))n=0;else{j=a[(j?h+1|0:c[h+8>>2]|0)>>0]|0;o=0;k=Wa(c[(c[t>>2]|0)+28>>2]|0,t|0,45)|0;n=o;o=0;if(n&1){F=13;break}n=j<<24>>24==k<<24>>24}c[C>>2]=0;c[C+4>>2]=0;c[C+8>>2]=0;c[E>>2]=0;c[E+4>>2]=0;c[E+8>>2]=0;c[D>>2]=0;c[D+4>>2]=0;c[D+8>>2]=0;o=0;Ua(44,e|0,n|0,B|0,x|0,u|0,y|0,C|0,E|0,D|0,m|0);l=o;o=0;if(!(l&1)){l=a[h>>0]|0;e=c[p>>2]|0;j=(l&1)==0?(l&255)>>>1:e;m=c[m>>2]|0;if((j|0)>(m|0)){G=a[D>>0]|0;k=a[E>>0]|0;j=(j-m<<1|1)+m+((G&1)==0?(G&255)>>>1:c[D+4>>2]|0)+((k&1)==0?(k&255)>>>1:c[E+4>>2]|0)|0}else{G=a[D>>0]|0;j=a[E>>0]|0;j=m+2+((G&1)==0?(G&255)>>>1:c[D+4>>2]|0)+((j&1)==0?(j&255)>>>1:c[E+4>>2]|0)|0}if(j>>>0>100){j=yC(j)|0;k=j;if(!j){o=0;ob(46);G=o;o=0;if(!(G&1)){l=a[h>>0]|0;e=c[p>>2]|0;j=0;F=17}}else F=17}else{k=0;j=q;F=17}if((F|0)==17){G=(l&1)==0;h=G?h+1|0:c[h+8>>2]|0;o=0;Aa(42,j|0,w|0,v|0,c[f+4>>2]|0,h|0,h+(G?(l&255)>>>1:e)|0,t|0,n|0,x|0,a[u>>0]|0,a[y>>0]|0,C|0,E|0,D|0,m|0);G=o;o=0;if(!(G&1)?(c[s>>2]=c[d>>2],G=c[w>>2]|0,A=c[v>>2]|0,o=0,c[r>>2]=c[s>>2],A=oa(83,r|0,j|0,G|0,A|0,f|0,g|0)|0,G=o,o=0,!(G&1)):0){if(k){zC(k);b=c[B>>2]|0}IC(D);IC(E);IC(C);EL(b)|0;i=z;return A|0}}j=cc()|0;if(k){zC(k);b=c[B>>2]|0}}else j=cc()|0;IC(D);IC(E);IC(C)}while(0);if((F|0)==13)j=cc()|0;EL(b)|0;bc(j|0);return 0}function BH(a){a=a|0;return}function CH(a){a=a|0;Uz(a);return}function DH(b,d,e,f,g,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;j=+j;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;D=i;i=i+992|0;v=D+8|0;k=D;m=D+888|0;n=D+880|0;l=D+480|0;F=D+76|0;A=D+884|0;x=D+72|0;B=D+68|0;G=D+56|0;I=D+44|0;H=D+32|0;p=D+28|0;u=D+80|0;z=D+24|0;y=D+20|0;w=D+16|0;c[n>>2]=m;h[v>>3]=j;m=SB(m,100,61377,v)|0;do if(m>>>0>99){o=0;b=gb(45)|0;C=o;o=0;if(!(C&1)?(o=0,h[k>>3]=j,s=kb(65,n|0,b|0,61377,k|0)|0,C=o,o=0,!(C&1)):0){b=c[n>>2]|0;if(!b){o=0;ob(46);C=o;o=0;if(C&1){b=0;k=0;C=7;break}b=c[n>>2]|0}l=yC(s<<2)|0;k=l;if(!l){o=0;ob(46);C=o;o=0;if(C&1)C=7;else{t=0;C=10}}else{t=l;C=10}}else{b=0;k=0;C=7}}else{k=0;b=0;t=l;s=m;C=10}while(0);if((C|0)==10){o=0;l=qa(192,f|0)|0;r=o;o=0;if(r&1)C=7;else{c[F>>2]=l;o=0;r=Wa(115,F|0,40896)|0;q=o;o=0;if(!(q&1)?(q=c[n>>2]|0,o=0,kb(c[(c[r>>2]|0)+48>>2]|0,r|0,q|0,q+s|0,t|0)|0,q=o,o=0,!(q&1)):0){if(!s)q=0;else q=(a[c[n>>2]>>0]|0)==45;c[G>>2]=0;c[G+4>>2]=0;c[G+8>>2]=0;c[I>>2]=0;c[I+4>>2]=0;c[I+8>>2]=0;c[H>>2]=0;c[H+4>>2]=0;c[H+8>>2]=0;o=0;Ua(45,e|0,q|0,F|0,A|0,x|0,B|0,G|0,I|0,H|0,p|0);e=o;o=0;if(!(e&1)){p=c[p>>2]|0;if((s|0)>(p|0)){e=a[H>>0]|0;m=a[I>>0]|0;m=(s-p<<1|1)+p+((e&1)==0?(e&255)>>>1:c[H+4>>2]|0)+((m&1)==0?(m&255)>>>1:c[I+4>>2]|0)|0}else{e=a[H>>0]|0;m=a[I>>0]|0;m=p+2+((e&1)==0?(e&255)>>>1:c[H+4>>2]|0)+((m&1)==0?(m&255)>>>1:c[I+4>>2]|0)|0}if(m>>>0>100){m=yC(m<<2)|0;n=m;if(!m){o=0;ob(46);u=o;o=0;if(!(u&1)){m=0;C=26}}else C=26}else{n=0;m=u;C=26}if((C|0)==26){o=0;Aa(43,m|0,z|0,y|0,c[f+4>>2]|0,t|0,t+(s<<2)|0,r|0,q|0,A|0,c[x>>2]|0,c[B>>2]|0,G|0,I|0,H|0,p|0);B=o;o=0;if(!(B&1)?(c[w>>2]=c[d>>2],d=c[z>>2]|0,E=c[y>>2]|0,o=0,c[v>>2]=c[w>>2],E=oa(84,v|0,m|0,d|0,E|0,f|0,g|0)|0,d=o,o=0,!(d&1)):0){if(n){zC(n);l=c[F>>2]|0}ZC(H);ZC(I);IC(G);EL(l)|0;if(k)zC(k);if(b)zC(b);i=D;return E|0}}m=cc()|0;if(n){zC(n);l=c[F>>2]|0}}else m=cc()|0;ZC(H);ZC(I);IC(G)}else m=cc()|0;EL(l)|0}}if((C|0)==7)m=cc()|0;if(k)zC(k);if(b)zC(b);bc(m|0);return 0}function EH(b,d,e,f,g,h,j,k,l,m){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;B=i;i=i+112|0;n=B+108|0;p=B+96|0;s=B+92|0;t=B+80|0;u=B+68|0;v=B+56|0;w=B+52|0;x=B+40|0;y=B+36|0;z=B+24|0;q=B+12|0;r=B;do if(b){b=cI(e,40640)|0;e=c[b>>2]|0;do if(d){$c[c[e+44>>2]&511](n,b);d=c[n>>2]|0;a[f>>0]=d;a[f+1>>0]=d>>8;a[f+2>>0]=d>>16;a[f+3>>0]=d>>24;$c[c[(c[b>>2]|0)+32>>2]&511](p,b);if(!(a[l>>0]&1))a[l>>0]=0;else c[c[l+8>>2]>>2]=0;c[l+4>>2]=0;o=0;ma(224,l|0,0);f=o;o=0;if(f&1){l=cc(0)|0;oq(l)}else{c[l>>2]=c[p>>2];c[l+4>>2]=c[p+4>>2];c[l+8>>2]=c[p+8>>2];c[p>>2]=0;c[p+4>>2]=0;c[p+8>>2]=0;ZC(p);break}}else{$c[c[e+40>>2]&511](s,b);d=c[s>>2]|0;a[f>>0]=d;a[f+1>>0]=d>>8;a[f+2>>0]=d>>16;a[f+3>>0]=d>>24;$c[c[(c[b>>2]|0)+28>>2]&511](t,b);if(!(a[l>>0]&1))a[l>>0]=0;else c[c[l+8>>2]>>2]=0;c[l+4>>2]=0;o=0;ma(224,l|0,0);f=o;o=0;if(f&1){l=cc(0)|0;oq(l)}else{c[l>>2]=c[t>>2];c[l+4>>2]=c[t+4>>2];c[l+8>>2]=c[t+8>>2];c[t>>2]=0;c[t+4>>2]=0;c[t+8>>2]=0;ZC(t);break}}while(0);c[g>>2]=bd[c[(c[b>>2]|0)+12>>2]&255](b)|0;c[h>>2]=bd[c[(c[b>>2]|0)+16>>2]&255](b)|0;$c[c[(c[b>>2]|0)+20>>2]&511](u,b);if(!(a[j>>0]&1)){a[j+1>>0]=0;a[j>>0]=0}else{a[c[j+8>>2]>>0]=0;c[j+4>>2]=0}o=0;ma(114,j|0,0);h=o;o=0;if(h&1){h=cc(0)|0;oq(h)};c[j>>2]=c[u>>2];c[j+4>>2]=c[u+4>>2];c[j+8>>2]=c[u+8>>2];c[u>>2]=0;c[u+4>>2]=0;c[u+8>>2]=0;IC(u);$c[c[(c[b>>2]|0)+24>>2]&511](v,b);if(!(a[k>>0]&1))a[k>>0]=0;else c[c[k+8>>2]>>2]=0;c[k+4>>2]=0;o=0;ma(224,k|0,0);h=o;o=0;if(h&1){h=cc(0)|0;oq(h)}else{c[k>>2]=c[v>>2];c[k+4>>2]=c[v+4>>2];c[k+8>>2]=c[v+8>>2];c[v>>2]=0;c[v+4>>2]=0;c[v+8>>2]=0;ZC(v);A=bd[c[(c[b>>2]|0)+36>>2]&255](b)|0;break}}else{b=cI(e,40576)|0;e=c[b>>2]|0;do if(d){$c[c[e+44>>2]&511](w,b);d=c[w>>2]|0;a[f>>0]=d;a[f+1>>0]=d>>8;a[f+2>>0]=d>>16;a[f+3>>0]=d>>24;$c[c[(c[b>>2]|0)+32>>2]&511](x,b);if(!(a[l>>0]&1))a[l>>0]=0;else c[c[l+8>>2]>>2]=0;c[l+4>>2]=0;o=0;ma(224,l|0,0);f=o;o=0;if(f&1){l=cc(0)|0;oq(l)}else{c[l>>2]=c[x>>2];c[l+4>>2]=c[x+4>>2];c[l+8>>2]=c[x+8>>2];c[x>>2]=0;c[x+4>>2]=0;c[x+8>>2]=0;ZC(x);break}}else{$c[c[e+40>>2]&511](y,b);d=c[y>>2]|0;a[f>>0]=d;a[f+1>>0]=d>>8;a[f+2>>0]=d>>16;a[f+3>>0]=d>>24;$c[c[(c[b>>2]|0)+28>>2]&511](z,b);if(!(a[l>>0]&1))a[l>>0]=0;else c[c[l+8>>2]>>2]=0;c[l+4>>2]=0;o=0;ma(224,l|0,0);f=o;o=0;if(f&1){l=cc(0)|0;oq(l)}else{c[l>>2]=c[z>>2];c[l+4>>2]=c[z+4>>2];c[l+8>>2]=c[z+8>>2];c[z>>2]=0;c[z+4>>2]=0;c[z+8>>2]=0;ZC(z);break}}while(0);c[g>>2]=bd[c[(c[b>>2]|0)+12>>2]&255](b)|0;c[h>>2]=bd[c[(c[b>>2]|0)+16>>2]&255](b)|0;$c[c[(c[b>>2]|0)+20>>2]&511](q,b);if(!(a[j>>0]&1)){a[j+1>>0]=0;a[j>>0]=0}else{a[c[j+8>>2]>>0]=0;c[j+4>>2]=0}o=0;ma(114,j|0,0);h=o;o=0;if(h&1){h=cc(0)|0;oq(h)};c[j>>2]=c[q>>2];c[j+4>>2]=c[q+4>>2];c[j+8>>2]=c[q+8>>2];c[q>>2]=0;c[q+4>>2]=0;c[q+8>>2]=0;IC(q);$c[c[(c[b>>2]|0)+24>>2]&511](r,b);if(!(a[k>>0]&1))a[k>>0]=0;else c[c[k+8>>2]>>2]=0;c[k+4>>2]=0;o=0;ma(224,k|0,0);h=o;o=0;if(h&1){h=cc(0)|0;oq(h)}else{c[k>>2]=c[r>>2];c[k+4>>2]=c[r+4>>2];c[k+8>>2]=c[r+8>>2];c[r>>2]=0;c[r+4>>2]=0;c[r+8>>2]=0;ZC(r);A=bd[c[(c[b>>2]|0)+36>>2]&255](b)|0;break}}while(0);c[m>>2]=A;i=B;return}function FH(b,d,e,f,g,h,i,j,k,l,m,n,o,p,q){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;var r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0;c[e>>2]=b;J=p+4|0;K=p+8|0;C=o+4|0;D=(f&512|0)==0;E=o+8|0;F=(q|0)>0;G=n+4|0;H=n+8|0;I=n+1|0;A=(q|0)>0;z=0;do{switch(a[k+z>>0]|0){case 0:{c[d>>2]=c[e>>2];break}case 1:{c[d>>2]=c[e>>2];x=rd[c[(c[i>>2]|0)+44>>2]&127](i,32)|0;y=c[e>>2]|0;c[e>>2]=y+4;c[y>>2]=x;break}case 3:{y=a[p>>0]|0;r=(y&1)==0;if((r?(y&255)>>>1:c[J>>2]|0)|0){x=c[(r?J:c[K>>2]|0)>>2]|0;y=c[e>>2]|0;c[e>>2]=y+4;c[y>>2]=x}break}case 2:{v=a[o>>0]|0;r=(v&1)==0;v=r?(v&255)>>>1:c[C>>2]|0;if(!(D|(v|0)==0)){r=r?C:c[E>>2]|0;t=r+(v<<2)|0;u=c[e>>2]|0;if(v){s=u;while(1){c[s>>2]=c[r>>2];r=r+4|0;if((r|0)==(t|0))break;else s=s+4|0}}c[e>>2]=u+(v<<2)}break}case 4:{r=c[e>>2]|0;g=j?g+4|0:g;a:do if(g>>>0<h>>>0){s=g;do{if(!(fd[c[(c[i>>2]|0)+12>>2]&127](i,2048,c[s>>2]|0)|0))break a;s=s+4|0}while(s>>>0<h>>>0)}else s=g;while(0);if(F){if(s>>>0>g>>>0&A){v=c[e>>2]|0;u=q;while(1){s=s+-4|0;t=v+4|0;c[v>>2]=c[s>>2];w=u+-1|0;u=(u|0)>1;if(s>>>0>g>>>0&u){v=t;u=w}else{v=w;break}}c[e>>2]=t;t=v}else{u=A;t=q}if(u)w=rd[c[(c[i>>2]|0)+44>>2]&127](i,48)|0;else w=0;x=c[e>>2]|0;u=t+((t|0)<0?~t:-1)|0;if((t|0)>0){v=x;while(1){c[v>>2]=w;if((t|0)>1){v=v+4|0;t=t+-1|0}else break}}c[e>>2]=x+(u+2<<2);c[x+(u+1<<2)>>2]=l}if((s|0)==(g|0)){x=rd[c[(c[i>>2]|0)+44>>2]&127](i,48)|0;y=c[e>>2]|0;s=y+4|0;c[e>>2]=s;c[y>>2]=x}else{x=a[n>>0]|0;t=(x&1)==0;y=c[G>>2]|0;if(!((t?(x&255)>>>1:y)|0))t=-1;else t=a[(t?I:c[H>>2]|0)>>0]|0;if((s|0)!=(g|0)){w=0;x=0;while(1){u=c[e>>2]|0;if((x|0)==(t|0)){v=u+4|0;c[e>>2]=v;c[u>>2]=m;w=w+1|0;u=a[n>>0]|0;t=(u&1)==0;if(w>>>0<(t?(u&255)>>>1:y)>>>0){t=a[(t?I:c[H>>2]|0)+w>>0]|0;u=v;t=t<<24>>24==127?-1:t<<24>>24;v=0}else{u=v;t=x;v=0}}else v=x;s=s+-4|0;x=c[s>>2]|0;c[e>>2]=u+4;c[u>>2]=x;if((s|0)==(g|0))break;else x=v+1|0}}s=c[e>>2]|0}if((r|0)!=(s|0)?(B=s+-4|0,r>>>0<B>>>0):0){s=B;do{y=c[r>>2]|0;c[r>>2]=c[s>>2];c[s>>2]=y;r=r+4|0;s=s+-4|0}while(r>>>0<s>>>0)}break}default:{}}z=z+1|0}while((z|0)!=4);r=a[p>>0]|0;g=(r&1)==0;r=g?(r&255)>>>1:c[J>>2]|0;if(r>>>0>1){s=g?J:c[K>>2]|0;g=s+4|0;s=s+(r<<2)|0;t=c[e>>2]|0;u=s-g|0;if((r|0)!=1){r=t;while(1){c[r>>2]=c[g>>2];g=g+4|0;if((g|0)==(s|0))break;else r=r+4|0}}c[e>>2]=t+(u>>>2<<2)}switch(f&176|0){case 32:{c[d>>2]=c[e>>2];break}case 16:break;default:c[d>>2]=b}return}function GH(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;z=i;i=i+480|0;q=z+468|0;B=z+464|0;x=z+472|0;u=z+56|0;y=z+52|0;C=z+40|0;E=z+28|0;D=z+16|0;m=z+12|0;p=z+64|0;w=z+8|0;v=z+4|0;r=z;b=lD(f)|0;c[B>>2]=b;o=0;s=Wa(115,B|0,40896)|0;t=o;o=0;do if(t&1)F=13;else{n=a[h>>0]|0;j=(n&1)==0;t=h+4|0;if(!((j?(n&255)>>>1:c[t>>2]|0)|0))n=0;else{j=c[(j?t:c[h+8>>2]|0)>>2]|0;o=0;k=Wa(c[(c[s>>2]|0)+44>>2]|0,s|0,45)|0;n=o;o=0;if(n&1){F=13;break}n=(j|0)==(k|0)}c[C>>2]=0;c[C+4>>2]=0;c[C+8>>2]=0;c[E>>2]=0;c[E+4>>2]=0;c[E+8>>2]=0;c[D>>2]=0;c[D+4>>2]=0;c[D+8>>2]=0;o=0;Ua(45,e|0,n|0,B|0,x|0,u|0,y|0,C|0,E|0,D|0,m|0);l=o;o=0;if(!(l&1)){l=a[h>>0]|0;e=c[t>>2]|0;j=(l&1)==0?(l&255)>>>1:e;m=c[m>>2]|0;if((j|0)>(m|0)){G=a[D>>0]|0;k=a[E>>0]|0;j=(j-m<<1|1)+m+((G&1)==0?(G&255)>>>1:c[D+4>>2]|0)+((k&1)==0?(k&255)>>>1:c[E+4>>2]|0)|0}else{G=a[D>>0]|0;j=a[E>>0]|0;j=m+2+((G&1)==0?(G&255)>>>1:c[D+4>>2]|0)+((j&1)==0?(j&255)>>>1:c[E+4>>2]|0)|0}if(j>>>0>100){j=yC(j<<2)|0;k=j;if(!j){o=0;ob(46);G=o;o=0;if(!(G&1)){l=a[h>>0]|0;e=c[t>>2]|0;j=0;F=17}}else F=17}else{k=0;j=p;F=17}if((F|0)==17){G=(l&1)==0;h=G?t:c[h+8>>2]|0;o=0;Aa(43,j|0,w|0,v|0,c[f+4>>2]|0,h|0,h+((G?(l&255)>>>1:e)<<2)|0,s|0,n|0,x|0,c[u>>2]|0,c[y>>2]|0,C|0,E|0,D|0,m|0);G=o;o=0;if(!(G&1)?(c[r>>2]=c[d>>2],G=c[w>>2]|0,A=c[v>>2]|0,o=0,c[q>>2]=c[r>>2],A=oa(84,q|0,j|0,G|0,A|0,f|0,g|0)|0,G=o,o=0,!(G&1)):0){if(k){zC(k);b=c[B>>2]|0}ZC(D);ZC(E);IC(C);EL(b)|0;i=z;return A|0}}j=cc()|0;if(k){zC(k);b=c[B>>2]|0}}else j=cc()|0;ZC(D);ZC(E);IC(C)}while(0);if((F|0)==13)j=cc()|0;EL(b)|0;bc(j|0);return 0}function HH(a){a=a|0;return}function IH(a){a=a|0;Uz(a);return}function JH(b,d,e){b=b|0;d=d|0;e=e|0;b=gB((a[d>>0]&1)==0?d+1|0:c[d+8>>2]|0,1)|0;return b>>>((b|0)!=(-1|0)&1)|0}function KH(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0;k=i;i=i+16|0;l=k;c[l>>2]=0;c[l+4>>2]=0;c[l+8>>2]=0;j=a[h>>0]|0;m=(j&1)==0;d=m?h+1|0:c[h+8>>2]|0;j=m?(j&255)>>>1:c[h+4>>2]|0;h=d+j|0;a:do if((j|0)>0){while(1){o=0;ma(93,l|0,a[d>>0]|0);m=o;o=0;if(m&1)break;d=d+1|0;if(d>>>0>=h>>>0){j=4;break a}}d=cc()|0;j=7}else j=4;while(0);b:do if((j|0)==4){o=0;d=kb(67,((e|0)==-1?-1:e<<1)|0,f|0,g|0,((a[l>>0]&1)==0?l+1|0:c[l+8>>2]|0)|0)|0;m=o;o=0;if(m&1){d=cc()|0;j=7;break}c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;m=iC(d)|0;h=d+m|0;c:do if((m|0)>0){while(1){o=0;ma(93,b|0,a[d>>0]|0);m=o;o=0;if(m&1)break;d=d+1|0;if(d>>>0>=h>>>0)break c}d=cc()|0;IC(b);break b}while(0);IC(l);i=k;return}while(0);IC(l);bc(d|0)}function LH(a,b){a=a|0;b=b|0;return}function MH(a){a=a|0;return}function NH(a){a=a|0;Uz(a);return}function OH(b,d,e){b=b|0;d=d|0;e=e|0;b=gB((a[d>>0]&1)==0?d+1|0:c[d+8>>2]|0,1)|0;return b>>>((b|0)!=(-1|0)&1)|0}function PH(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0;w=i;i=i+224|0;p=w+184|0;n=w+192|0;m=w+180|0;q=w+176|0;u=w+168|0;t=w+40|0;s=w+32|0;v=w+28|0;x=w+16|0;l=w+8|0;r=w;c[x>>2]=0;c[x+4>>2]=0;c[x+8>>2]=0;c[l+4>>2]=0;c[l>>2]=41380;k=a[h>>0]|0;y=(k&1)==0;j=h+4|0;d=y?j:c[h+8>>2]|0;h=y?(k&255)>>>1:c[j>>2]|0;j=d+(h<<2)|0;k=n+32|0;a:do if((h|0)>0){b:while(1){c[q>>2]=d;o=0;h=qb(c[(c[l>>2]|0)+12>>2]|0,l|0,p|0,d|0,j|0,q|0,n|0,k|0,m|0)|0;y=o;o=0;if(y&1){h=12;break}if((h|0)==2?1:(c[q>>2]|0)==(d|0)){h=5;break}if(n>>>0<(c[m>>2]|0)>>>0){d=n;do{o=0;ma(93,x|0,a[d>>0]|0);y=o;o=0;if(y&1){h=11;break b}d=d+1|0}while(d>>>0<(c[m>>2]|0)>>>0)}d=c[q>>2]|0;if(!((h|0)!=2&d>>>0<j>>>0)){h=9;break a}}if((h|0)==5){o=0;ka(346,61314);o=0;d=cc()|0}else if((h|0)==11)d=cc()|0;else if((h|0)==12)d=cc()|0}else h=9;while(0);c:do if((h|0)==9){o=0;d=kb(67,((e|0)==-1?-1:e<<1)|0,f|0,g|0,((a[x>>0]&1)==0?x+1|0:c[x+8>>2]|0)|0)|0;y=o;o=0;if(y&1){d=cc()|0;break}c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;c[r+4>>2]=0;c[r>>2]=41428;y=iC(d)|0;j=d+y|0;k=j;l=t+128|0;d:do if((y|0)>0){e:while(1){c[v>>2]=d;o=0;h=qb(c[(c[r>>2]|0)+16>>2]|0,r|0,u|0,d|0,((k-d|0)>32?d+32|0:j)|0,v|0,t|0,l|0,s|0)|0;y=o;o=0;if(y&1){h=24;break}if((h|0)==2?1:(c[v>>2]|0)==(d|0)){h=18;break}if(t>>>0<(c[s>>2]|0)>>>0){d=t;do{o=0;ma(223,b|0,c[d>>2]|0);y=o;o=0;if(y&1){h=23;break e}d=d+4|0}while(d>>>0<(c[s>>2]|0)>>>0)}d=c[v>>2]|0;if(!((h|0)!=2&d>>>0<j>>>0))break d}if((h|0)==18){o=0;ka(346,61314);o=0;d=cc()|0}else if((h|0)==23)d=cc()|0;else if((h|0)==24)d=cc()|0;ZC(b);break c}while(0);IC(x);i=w;return}while(0);IC(x);bc(d|0)}function QH(a,b){a=a|0;b=b|0;return}function RH(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;c[b+4>>2]=d+-1;c[b>>2]=40880;h=b+8|0;o=0;ma(225,h|0,28);g=o;o=0;if(g&1)d=cc()|0;else{g=b+144|0;o=0;mb(57,g|0,61244,1);f=o;o=0;if(f&1)d=cc()|0;else{e=c[h>>2]|0;f=b+12|0;d=c[f>>2]|0;if((d|0)!=(e|0)){do d=d+-4|0;while((d|0)!=(e|0));c[f>>2]=d}c[775]=0;c[774]=39808;o=0;ma(226,b|0,3096);f=o;o=0;do if(((((((((((((!(f&1)?(c[777]=0,c[776]=39848,o=0,ma(227,b|0,3104),f=o,o=0,!(f&1)):0)?(c[779]=0,c[778]=40920,c[780]=0,a[3124]=0,c[780]=iI()|0,o=0,ma(228,b|0,3112),f=o,o=0,!(f&1)):0)?(c[783]=0,c[782]=41168,o=0,ma(229,b|0,3128),f=o,o=0,!(f&1)):0)?(c[785]=0,c[784]=41236,o=0,ma(230,b|0,3136),f=o,o=0,!(f&1)):0)?(o=0,ma(231,3144,1),f=o,o=0,!(f&1)):0)?(o=0,ma(232,b|0,3144),f=o,o=0,!(f&1)):0)?(c[791]=0,c[790]=41284,o=0,ma(233,b|0,3160),f=o,o=0,!(f&1)):0)?(c[793]=0,c[792]=41332,o=0,ma(234,b|0,3168),f=o,o=0,!(f&1)):0)?(nJ(3176,1),o=0,ma(235,b|0,3176),f=o,o=0,!(f&1)):0)?(oJ(3200,1),o=0,ma(236,b|0,3200),f=o,o=0,!(f&1)):0)?(c[809]=0,c[808]=39888,o=0,ma(237,b|0,3232),f=o,o=0,!(f&1)):0)?(c[811]=0,c[810]=39960,o=0,ma(238,b|0,3240),f=o,o=0,!(f&1)):0)?(c[813]=0,c[812]=40032,o=0,ma(239,b|0,3248),f=o,o=0,!(f&1)):0){c[815]=0;c[814]=40092;o=0;ma(240,b|0,3256);f=o;o=0;if(f&1){i=42;break}c[817]=0;c[816]=40400;o=0;ma(241,b|0,3264);f=o;o=0;if(f&1){i=42;break}c[819]=0;c[818]=40464;o=0;ma(242,b|0,3272);f=o;o=0;if(f&1){i=42;break}c[821]=0;c[820]=40528;o=0;ma(243,b|0,3280);f=o;o=0;if(f&1){i=42;break}c[823]=0;c[822]=40592;o=0;ma(244,b|0,3288);f=o;o=0;if(f&1){i=42;break}c[825]=0;c[824]=40656;o=0;ma(245,b|0,3296);f=o;o=0;if(f&1){i=42;break}c[827]=0;c[826]=40692;o=0;ma(246,b|0,3304);f=o;o=0;if(f&1){i=42;break}c[829]=0;c[828]=40728;o=0;ma(247,b|0,3312);f=o;o=0;if(f&1){i=42;break}c[831]=0;c[830]=40764;o=0;ma(248,b|0,3320);f=o;o=0;if(f&1){i=42;break}c[833]=0;c[832]=40152;c[834]=40200;o=0;ma(249,b|0,3328);f=o;o=0;if(f&1){i=42;break}c[837]=0;c[836]=40244;c[838]=40292;o=0;ma(250,b|0,3344);f=o;o=0;if(f&1){i=42;break}c[841]=0;c[840]=41148;o=0;d=gb(45)|0;f=o;o=0;if(f&1){d=cc()|0;break}c[842]=d;c[840]=40336;o=0;ma(251,b|0,3360);f=o;o=0;if(f&1){i=42;break}c[845]=0;c[844]=41148;o=0;d=gb(45)|0;f=o;o=0;if(f&1){d=cc()|0;break}c[846]=d;c[844]=40368;o=0;ma(252,b|0,3376);i=o;o=0;if(i&1){i=42;break}c[849]=0;c[848]=40800;o=0;ma(253,b|0,3392);i=o;o=0;if(i&1){i=42;break}c[851]=0;c[850]=40840;o=0;ma(254,b|0,3400);i=o;o=0;if(i&1){i=42;break}return}else i=42;while(0);if((i|0)==42)d=cc()|0;IC(g)}ZK(h)}bc(d|0)}function SH(){var b=0;do if((a[3408]|0)==0?(Hb(3408)|0)!=0:0){o=0;gb(46)|0;b=o;o=0;if(b&1){b=cc()|0;rc(3408);bc(b|0)}else{c[10417]=41664;Cc(3408);break}}while(0);return c[10417]|0}function TH(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;DL(b);f=a+8|0;e=c[f>>2]|0;do if((c[a+12>>2]|0)-e>>2>>>0<=d>>>0){o=0;ma(255,f|0,d+1|0);a=o;o=0;if(!(a&1)){e=c[f>>2]|0;break}e=cc()|0;if(b)EL(b)|0;bc(e|0)}while(0);a=c[e+(d<<2)>>2]|0;if(a){EL(a)|0;e=c[f>>2]|0}c[e+(d<<2)>>2]=b;return}function UH(a){a=a|0;var b=0,d=0,e=0,f=0;c[a>>2]=40880;e=a+8|0;f=a+12|0;b=c[e>>2]|0;if((c[f>>2]|0)!=(b|0)){d=0;do{b=c[b+(d<<2)>>2]|0;if(b)EL(b)|0;d=d+1|0;b=c[e>>2]|0}while(d>>>0<(c[f>>2]|0)-b>>2>>>0)}IC(a+144|0);ZK(e);return}function VH(a){a=a|0;UH(a);Uz(a);return}function WH(a,b){a=a|0;b=b|0;if($K(a,b)|0)return c[(c[a+8>>2]|0)+(b<<2)>>2]|0;else{a=Ob(4)|0;gA(a);Hc(a|0,1824,220)}return 0}function XH(){RH(3416,1);c[10416]=3416;return 41664}function YH(){var a=0;a=c[(SH()|0)>>2]|0;c[10418]=a;DL(a);return 41672}function ZH(){var b=0;do if((a[3576]|0)==0?(Hb(3576)|0)!=0:0){o=0;gb(47)|0;b=o;o=0;if(b&1){b=cc()|0;rc(3576);bc(b|0)}else{c[10419]=41672;Cc(3576);break}}while(0);return c[10419]|0}function _H(a){a=a|0;var b=0,d=0;o=0;b=gb(48)|0;d=o;o=0;if(d&1){d=cc(0)|0;oq(d)}else{d=c[b>>2]|0;c[a>>2]=d;DL(d);return}}function $H(a,b){a=a|0;b=b|0;b=c[b>>2]|0;c[a>>2]=b;DL(b);return}function aI(a){a=a|0;EL(c[a>>2]|0)|0;return}function bI(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;if((c[a>>2]|0)!=-1){c[b>>2]=a;c[b+4>>2]=347;c[b+8>>2]=0;RL(a,b,348)}i=d;return (c[a+4>>2]|0)+-1|0}function cI(a,b){a=a|0;b=b|0;a=c[a>>2]|0;return WH(a,bI(b)|0)|0}function dI(a){a=a|0;Uz(a);return}function eI(a){a=a|0;if(a)_c[c[(c[a>>2]|0)+4>>2]&511](a);return}function fI(a){a=a|0;var b=0;b=c[10223]|0;c[10223]=b+1;c[a+4>>2]=b+1;return}function gI(a){a=a|0;Uz(a);return}function hI(a,c,d){a=a|0;c=c|0;d=d|0;if(d>>>0<128)d=(b[(iI()|0)+(d<<1)>>1]&c)<<16>>16!=0;else d=0;return d|0}function iI(){var a=0,b=0;o=0;a=gb(49)|0;b=o;o=0;if(b&1){b=cc(0)|0;oq(b)}else return c[a>>2]|0;return 0}function jI(a,d,f,g){a=a|0;d=d|0;f=f|0;g=g|0;var h=0,i=0;i=(f-d|0)>>>2;if((d|0)!=(f|0)){h=d;while(1){a=c[h>>2]|0;if(a>>>0<128)a=e[(iI()|0)+(a<<1)>>1]|0;else a=0;b[g>>1]=a;h=h+4|0;if((h|0)==(f|0))break;else g=g+2|0}}return d+(i<<2)|0}function kI(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;a:do if((e|0)==(f|0))e=f;else while(1){a=c[e>>2]|0;if(a>>>0<128?(b[(iI()|0)+(a<<1)>>1]&d)<<16>>16!=0:0)break a;e=e+4|0;if((e|0)==(f|0)){e=f;break}}while(0);return e|0}function lI(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;a:do if((e|0)==(f|0))e=f;else while(1){a=c[e>>2]|0;if(a>>>0>=128)break a;if(!((b[(iI()|0)+(a<<1)>>1]&d)<<16>>16))break a;e=e+4|0;if((e|0)==(f|0)){e=f;break}}while(0);return e|0}function mI(a,b){a=a|0;b=b|0;if(b>>>0<128)b=c[(nI()|0)+(b<<2)>>2]|0;return b|0}function nI(){var a=0,b=0;o=0;a=gb(50)|0;b=o;o=0;if(b&1){b=cc(0)|0;oq(b)}else return c[a>>2]|0;return 0}function oI(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;f=(d-b|0)>>>2;if((b|0)!=(d|0)){e=b;do{a=c[e>>2]|0;if(a>>>0<128)a=c[(nI()|0)+(a<<2)>>2]|0;c[e>>2]=a;e=e+4|0}while((e|0)!=(d|0))}return b+(f<<2)|0}function pI(a,b){a=a|0;b=b|0;if(b>>>0<128)b=c[(qI()|0)+(b<<2)>>2]|0;return b|0}function qI(){var a=0,b=0;o=0;a=gb(51)|0;b=o;o=0;if(b&1){b=cc(0)|0;oq(b)}else return c[a>>2]|0;return 0}function rI(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;f=(d-b|0)>>>2;if((b|0)!=(d|0)){e=b;do{a=c[e>>2]|0;if(a>>>0<128)a=c[(qI()|0)+(a<<2)>>2]|0;c[e>>2]=a;e=e+4|0}while((e|0)!=(d|0))}return b+(f<<2)|0}function sI(a,b){a=a|0;b=b|0;return b<<24>>24|0}function tI(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;if((d|0)!=(e|0))while(1){c[f>>2]=a[d>>0];d=d+1|0;if((d|0)==(e|0))break;else f=f+4|0}return e|0}function uI(a,b,c){a=a|0;b=b|0;c=c|0;return (b>>>0<128?b&255:c)|0}function vI(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0;i=(e-d|0)>>>2;if((d|0)!=(e|0)){h=d;b=g;while(1){g=c[h>>2]|0;a[b>>0]=g>>>0<128?g&255:f;h=h+4|0;if((h|0)==(e|0))break;else b=b+1|0}}return d+(i<<2)|0}function wI(b){b=b|0;var d=0;c[b>>2]=40920;d=c[b+8>>2]|0;if((d|0)!=0?(a[b+12>>0]|0)!=0:0)Vz(d);return}function xI(a){a=a|0;wI(a);Uz(a);return}function yI(a,b){a=a|0;b=b|0;if(b<<24>>24>-1)b=c[(nI()|0)+((b&255)<<2)>>2]&255;return b|0}function zI(b,d,e){b=b|0;d=d|0;e=e|0;if((d|0)!=(e|0)){b=d;do{d=a[b>>0]|0;if(d<<24>>24>-1)d=c[(nI()|0)+(d<<24>>24<<2)>>2]&255;a[b>>0]=d;b=b+1|0}while((b|0)!=(e|0))}return e|0}function AI(a,b){a=a|0;b=b|0;if(b<<24>>24>-1)b=c[(qI()|0)+(b<<24>>24<<2)>>2]&255;return b|0}function BI(b,d,e){b=b|0;d=d|0;e=e|0;if((d|0)!=(e|0)){b=d;do{d=a[b>>0]|0;if(d<<24>>24>-1)d=c[(qI()|0)+(d<<24>>24<<2)>>2]&255;a[b>>0]=d;b=b+1|0}while((b|0)!=(e|0))}return e|0}function CI(a,b){a=a|0;b=b|0;return b|0}function DI(b,c,d,e){b=b|0;c=c|0;d=d|0;e=e|0;if((c|0)!=(d|0))while(1){a[e>>0]=a[c>>0]|0;c=c+1|0;if((c|0)==(d|0))break;else e=e+1|0}return d|0}function EI(a,b,c){a=a|0;b=b|0;c=c|0;return (b<<24>>24>-1?b:c)|0}function FI(b,c,d,e,f){b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;if((c|0)!=(d|0))while(1){b=a[c>>0]|0;a[f>>0]=b<<24>>24>-1?b:e;c=c+1|0;if((c|0)==(d|0))break;else f=f+1|0}return d|0}function GI(a){a=a|0;Uz(a);return}function HI(a,b,d,e,f,g,h,i){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;c[f>>2]=d;c[i>>2]=g;return 3}function II(a,b,d,e,f,g,h,i){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;c[f>>2]=d;c[i>>2]=g;return 3}function JI(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;c[f>>2]=d;return 3}function KI(a){a=a|0;return 1}function LI(a){a=a|0;return 1}function MI(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;a=d-c|0;return (a>>>0<e>>>0?a:e)|0}function NI(a){a=a|0;return 1}function OI(a,b){a=a|0;b=b|0;var d=0;c[a+4>>2]=b+-1;c[a>>2]=40988;o=0;b=gb(45)|0;d=o;o=0;if(d&1){d=cc()|0;bc(d|0)}else{c[a+8>>2]=b;return}}function PI(a){a=a|0;SJ(a);Uz(a);return}function QI(b,d,e,f,g,h,j,k){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;u=i;i=i+16|0;s=u;q=u+8|0;a:do if((e|0)==(f|0))l=f;else{l=e;while(1){if(!(c[l>>2]|0))break a;l=l+4|0;if((l|0)==(f|0)){l=f;break}}}while(0);c[k>>2]=h;c[g>>2]=e;n=j;r=b+8|0;b:do if(!((h|0)==(j|0)|(e|0)==(f|0))){b=h;m=l;c:while(1){w=d;h=c[w+4>>2]|0;l=s;c[l>>2]=c[w>>2];c[l+4>>2]=h;l=lB(c[r>>2]|0)|0;o=0;h=Ya(70,b|0,g|0,m-e>>2|0,n-b|0,d|0)|0;w=o;o=0;if(w&1){v=9;break}if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){v=8;break}switch(h|0){case 0:{p=1;break b}case -1:{l=b;v=14;break c}default:{}}l=(c[k>>2]|0)+h|0;c[k>>2]=l;if((l|0)==(j|0)){v=27;break}if((m|0)==(f|0)){e=c[g>>2]|0;b=l;l=f}else{l=lB(c[r>>2]|0)|0;o=0;e=ya(124,q|0,0,d|0)|0;w=o;o=0;if(w&1){v=35;break}if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){v=34;break}if((e|0)==-1){p=2;break b}if(e>>>0>(n-(c[k>>2]|0)|0)>>>0){p=1;break b}if(e){l=q;while(1){m=a[l>>0]|0;w=c[k>>2]|0;c[k>>2]=w+1;a[w>>0]=m;e=e+-1|0;if(!e)break;else l=l+1|0}}e=(c[g>>2]|0)+4|0;c[g>>2]=e;d:do if((e|0)==(f|0))l=f;else{l=e;while(1){if(!(c[l>>2]|0))break d;l=l+4|0;if((l|0)==(f|0)){l=f;break}}}while(0);b=c[k>>2]|0}if((b|0)==(j|0)|(e|0)==(f|0)){v=47;break b}else m=l}if((v|0)==8){w=cc(0)|0;oq(w)}else if((v|0)==9){e=cc()|0;if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){w=cc(0)|0;oq(w)}bc(e|0)}else if((v|0)==14){c[k>>2]=l;e:do if((e|0)!=(c[g>>2]|0)){while(1){w=c[e>>2]|0;b=lB(c[r>>2]|0)|0;o=0;l=ya(124,l|0,w|0,s|0)|0;w=o;o=0;if(w&1){t=b;break}if((b|0)!=0?(o=0,qa(193,b|0)|0,w=o,o=0,w&1):0){v=18;break}if((l|0)==-1)break e;l=(c[k>>2]|0)+l|0;c[k>>2]=l;e=e+4|0;if((e|0)==(c[g>>2]|0))break e}if((v|0)==18){w=cc(0)|0;oq(w)}e=cc()|0;if((t|0)!=0?(o=0,qa(193,t|0)|0,w=o,o=0,w&1):0){w=cc(0)|0;oq(w)}bc(e|0)}while(0);c[g>>2]=e;p=2;break}else if((v|0)==27){e=c[g>>2]|0;v=47;break}else if((v|0)==34){w=cc(0)|0;oq(w)}else if((v|0)==35){e=cc()|0;if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){w=cc(0)|0;oq(w)}bc(e|0)}}else v=47;while(0);if((v|0)==47)p=(e|0)!=(f|0)&1;i=u;return p|0}function RI(b,d,e,f,g,h,j,k){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;u=i;i=i+16|0;t=u;a:do if((e|0)==(f|0))l=f;else{l=e;while(1){if(!(a[l>>0]|0))break a;l=l+1|0;if((l|0)==(f|0)){l=f;break}}}while(0);c[k>>2]=h;c[g>>2]=e;p=j;r=b+8|0;b:do if(!((h|0)==(j|0)|(e|0)==(f|0))){b=h;n=l;c:while(1){m=d;l=c[m+4>>2]|0;h=t;c[h>>2]=c[m>>2];c[h+4>>2]=l;h=n;l=lB(c[r>>2]|0)|0;o=0;m=Ya(71,b|0,g|0,h-e|0,p-b>>2|0,d|0)|0;w=o;o=0;if(w&1){v=9;break}if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){v=8;break}switch(m|0){case 0:{q=2;break b}case -1:{l=b;v=14;break c}default:{}}b=(c[k>>2]|0)+(m<<2)|0;c[k>>2]=b;if((b|0)==(j|0)){v=31;break}e=c[g>>2]|0;if((n|0)==(f|0))l=f;else{l=lB(c[r>>2]|0)|0;o=0;e=kb(68,b|0,e|0,1,d|0)|0;w=o;o=0;if(w&1){v=38;break}if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){v=37;break}if(e){q=2;break b}c[k>>2]=(c[k>>2]|0)+4;e=(c[g>>2]|0)+1|0;c[g>>2]=e;d:do if((e|0)==(f|0))l=f;else{l=e;while(1){if(!(a[l>>0]|0))break d;l=l+1|0;if((l|0)==(f|0)){l=f;break}}}while(0);b=c[k>>2]|0}if((b|0)==(j|0)|(e|0)==(f|0)){v=47;break b}else n=l}if((v|0)==8){w=cc(0)|0;oq(w)}else if((v|0)==9){e=cc()|0;if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){w=cc(0)|0;oq(w)}bc(e|0)}else if((v|0)==14){c[k>>2]=l;e:do if((e|0)!=(c[g>>2]|0)){b=l;f:while(1){l=lB(c[r>>2]|0)|0;o=0;b=kb(68,b|0,e|0,h-e|0,t|0)|0;w=o;o=0;if(w&1){v=19;break}if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){v=18;break}switch(b|0){case -1:{v=25;break f}case -2:{v=26;break f}case 0:{e=e+1|0;break}default:e=e+b|0}b=(c[k>>2]|0)+4|0;c[k>>2]=b;if((e|0)==(c[g>>2]|0)){s=e;break e}}if((v|0)==18){w=cc(0)|0;oq(w)}else if((v|0)==19){e=cc()|0;if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){w=cc(0)|0;oq(w)}bc(e|0)}else if((v|0)==25){c[g>>2]=e;q=2;break b}else if((v|0)==26){c[g>>2]=e;q=1;break b}}else s=e;while(0);c[g>>2]=s;q=(s|0)!=(f|0)&1;break}else if((v|0)==31){e=c[g>>2]|0;v=47;break}else if((v|0)==37){w=cc(0)|0;oq(w)}else if((v|0)==38){e=cc()|0;if((l|0)!=0?(o=0,qa(193,l|0)|0,w=o,o=0,w&1):0){w=cc(0)|0;oq(w)}bc(e|0)}}else v=47;while(0);if((v|0)==47)q=(e|0)!=(f|0)&1;i=u;return q|0}function SI(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;j=i;i=i+16|0;h=j;c[g>>2]=e;e=lB(c[b+8>>2]|0)|0;o=0;b=ya(124,h|0,0,d|0)|0;d=o;o=0;if(d&1){h=cc()|0;if((e|0)!=0?(o=0,qa(193,e|0)|0,j=o,o=0,j&1):0){j=cc(0)|0;oq(j)}bc(h|0)}if((e|0)!=0?(o=0,qa(193,e|0)|0,d=o,o=0,d&1):0){d=cc(0)|0;oq(d)}switch(b|0){case 0:case -1:{h=2;break}default:{b=b+-1|0;if(b>>>0<=(f-(c[g>>2]|0)|0)>>>0)if(!b)h=0;else while(1){d=a[h>>0]|0;f=c[g>>2]|0;c[g>>2]=f+1;a[f>>0]=d;b=b+-1|0;if(!b){h=0;break}else h=h+1|0}else h=1}}i=j;return h|0}function TI(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0;b=a+8|0;o=0;d=qa(193,c[b>>2]|0)|0;e=o;o=0;do if(e&1)f=16;else{o=0;e=ya(125,0,0,4)|0;a=o;o=0;if(a&1){a=cc(0)|0;if(!d)break;o=0;qa(193,d|0)|0;h=o;o=0;if(!(h&1))break;h=cc(0)|0;oq(h)}if((d|0)!=0?(o=0,qa(193,d|0)|0,h=o,o=0,h&1):0){h=cc(0)|0;oq(h)}if(!e){a=c[b>>2]|0;if(a){o=0;a=qa(193,a|0)|0;h=o;o=0;if(h&1){f=16;break}if((a|0)!=0?(o=0,qa(193,a|0)|0,h=o,o=0,h&1):0){h=cc(0)|0;oq(h)}else g=0}else g=1}else g=-1;return g|0}while(0);if((f|0)==16)a=cc(0)|0;oq(a);return 0}function UI(a){a=a|0;return 0}function VI(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;k=e;j=a+8|0;a:do if((d|0)==(e|0)|(f|0)==0)a=0;else{a=0;i=0;while(1){h=lB(c[j>>2]|0)|0;o=0;g=ya(126,d|0,k-d|0,b|0)|0;n=o;o=0;if(n&1){m=h;break}if((h|0)!=0?(o=0,qa(193,h|0)|0,n=o,o=0,n&1):0){l=5;break}switch(g|0){case -2:case -1:break a;case 0:{d=d+1|0;g=1;break}default:d=d+g|0}a=g+a|0;i=i+1|0;if((d|0)==(e|0)|i>>>0>=f>>>0)break a}if((l|0)==5){n=cc(0)|0;oq(n)}a=cc()|0;if((m|0)!=0?(o=0,qa(193,m|0)|0,n=o,o=0,n&1):0){n=cc(0)|0;oq(n)}bc(a|0)}while(0);return a|0}function WI(a){a=a|0;var b=0,d=0;a=c[a+8>>2]|0;if(a){o=0;a=qa(193,a|0)|0;d=o;o=0;if(d&1){d=cc(0)|0;oq(d)}if((a|0)!=0?(o=0,qa(193,a|0)|0,d=o,o=0,d&1):0){d=cc(0)|0;oq(d)}else b=4}else b=1;return b|0}function XI(a){a=a|0;Uz(a);return}function YI(a,b,d,e,f,g,h,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0;a=i;i=i+16|0;k=a+4|0;b=a;c[k>>2]=d;c[b>>2]=g;h=bL(d,e,k,g,h,b,1114111,0)|0;c[f>>2]=c[k>>2];c[j>>2]=c[b>>2];i=a;return h|0}function ZI(a,b,d,e,f,g,h,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0;a=i;i=i+16|0;k=a+4|0;b=a;c[k>>2]=d;c[b>>2]=g;h=cL(d,e,k,g,h,b,1114111,0)|0;c[f>>2]=c[k>>2];c[j>>2]=c[b>>2];i=a;return h|0}function _I(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;c[f>>2]=d;return 3}function $I(a){a=a|0;return 0}function aJ(a){a=a|0;return 0}function bJ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return dL(c,d,e,1114111,0)|0}function cJ(a){a=a|0;return 4}function dJ(a){a=a|0;Uz(a);return}function eJ(a,b,d,e,f,g,h,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0;a=i;i=i+16|0;k=a+4|0;b=a;c[k>>2]=d;c[b>>2]=g;h=eL(d,e,k,g,h,b,1114111,0)|0;c[f>>2]=c[k>>2];c[j>>2]=c[b>>2];i=a;return h|0}function fJ(a,b,d,e,f,g,h,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0;a=i;i=i+16|0;k=a+4|0;b=a;c[k>>2]=d;c[b>>2]=g;h=fL(d,e,k,g,h,b,1114111,0)|0;c[f>>2]=c[k>>2];c[j>>2]=c[b>>2];i=a;return h|0}function gJ(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;c[f>>2]=d;return 3}function hJ(a){a=a|0;return 0}function iJ(a){a=a|0;return 0}function jJ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return gL(c,d,e,1114111,0)|0}function kJ(a){a=a|0;return 4}function lJ(a){a=a|0;Uz(a);return}function mJ(a){a=a|0;Uz(a);return}function nJ(b,d){b=b|0;d=d|0;c[b+4>>2]=d+-1;c[b>>2]=41068;a[b+8>>0]=46;a[b+9>>0]=44;b=b+12|0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;return}function oJ(a,b){a=a|0;b=b|0;c[a+4>>2]=b+-1;c[a>>2]=41108;c[a+8>>2]=46;c[a+12>>2]=44;a=a+16|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function pJ(a){a=a|0;c[a>>2]=41068;IC(a+12|0);return}function qJ(a){a=a|0;pJ(a);Uz(a);return}function rJ(a){a=a|0;c[a>>2]=41108;IC(a+16|0);return}function sJ(a){a=a|0;rJ(a);Uz(a);return}function tJ(b){b=b|0;return a[b+8>>0]|0}function uJ(a){a=a|0;return c[a+8>>2]|0}function vJ(b){b=b|0;return a[b+9>>0]|0}function wJ(a){a=a|0;return c[a+12>>2]|0}function xJ(a,b){a=a|0;b=b|0;EC(a,b+12|0);return}function yJ(a,b){a=a|0;b=b|0;EC(a,b+16|0);return}function zJ(a,b){a=a|0;b=b|0;FC(a,61383,4);return}function AJ(a,b){a=a|0;b=b|0;XC(a,41680,jC(41680)|0);return}function BJ(a,b){a=a|0;b=b|0;FC(a,61388,5);return}function CJ(a,b){a=a|0;b=b|0;XC(a,41700,jC(41700)|0);return}function DJ(a){a=a|0;switch(c[a+4>>2]&74|0){case 64:{a=8;break}case 8:{a=16;break}case 0:{a=0;break}default:a=10}return a|0}function EJ(b){b=b|0;do if((a[3584]|0)==0?(Hb(3584)|0)!=0:0){if((a[3592]|0)==0?(Hb(3592)|0)!=0:0){b=41724;do{c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;b=b+12|0}while((b|0)!=41892);Ec(349,0,n|0)|0;Cc(3592)}o=0;Wa(108,41724,61394)|0;b=o;o=0;if(((((((((((((!(b&1)?(o=0,Wa(108,41736,61401)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41748,61408)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41760,61416)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41772,61426)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41784,61435)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41796,61442)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41808,61451)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41820,61455)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41832,61459)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41844,61463)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41856,61467)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41868,61471)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,41880,61475)|0,b=o,o=0,!(b&1)):0){c[10473]=41724;Cc(3584);break}b=cc()|0;rc(3584);bc(b|0)}while(0);return c[10473]|0}function FJ(b){b=b|0;do if((a[3600]|0)==0?(Hb(3600)|0)!=0:0){if((a[3608]|0)==0?(Hb(3608)|0)!=0:0){b=41896;do{c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;b=b+12|0}while((b|0)!=42064);Ec(350,0,n|0)|0;Cc(3608)}o=0;Wa(118,41896,42064)|0;b=o;o=0;if(((((((((((((!(b&1)?(o=0,Wa(118,41908,42092)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,41920,42120)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,41932,42152)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,41944,42192)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,41956,42228)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,41968,42256)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,41980,42292)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,41992,42308)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42004,42324)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42016,42340)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42028,42356)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42040,42372)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42052,42388)|0,b=o,o=0,!(b&1)):0){c[10601]=41896;Cc(3600);break}b=cc()|0;rc(3600);bc(b|0)}while(0);return c[10601]|0}function GJ(b){b=b|0;a:do if((a[3616]|0)==0?(Hb(3616)|0)!=0:0){if((a[3624]|0)==0?(Hb(3624)|0)!=0:0){b=42408;do{c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;b=b+12|0}while((b|0)!=42696);Ec(351,0,n|0)|0;Cc(3624)}o=0;Wa(108,42408,61479)|0;b=o;o=0;do if((((((((((((((!(b&1)?(o=0,Wa(108,42420,61487)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42432,61496)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42444,61502)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42456,61508)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42468,61512)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42480,61517)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42492,61522)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42504,61529)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42516,61539)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42528,61547)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42540,61556)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42552,61565)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42564,61569)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(108,42576,61573)|0,b=o,o=0,!(b&1)):0){o=0;Wa(108,42588,61577)|0;b=o;o=0;if(b&1)break;o=0;Wa(108,42600,61508)|0;b=o;o=0;if(b&1)break;o=0;Wa(108,42612,61581)|0;b=o;o=0;if(b&1)break;o=0;Wa(108,42624,61585)|0;b=o;o=0;if(b&1)break;o=0;Wa(108,42636,61589)|0;b=o;o=0;if(b&1)break;o=0;Wa(108,42648,61593)|0;b=o;o=0;if(b&1)break;o=0;Wa(108,42660,61597)|0;b=o;o=0;if(b&1)break;o=0;Wa(108,42672,61601)|0;b=o;o=0;if(b&1)break;o=0;Wa(108,42684,61605)|0;b=o;o=0;if(b&1)break;c[10674]=42408;Cc(3616);break a}while(0);b=cc()|0;rc(3616);bc(b|0)}while(0);return c[10674]|0}function HJ(b){b=b|0;a:do if((a[3632]|0)==0?(Hb(3632)|0)!=0:0){if((a[3640]|0)==0?(Hb(3640)|0)!=0:0){b=42700;do{c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;b=b+12|0}while((b|0)!=42988);Ec(352,0,n|0)|0;Cc(3640)}o=0;Wa(118,42700,42988)|0;b=o;o=0;do if((((((((((((((!(b&1)?(o=0,Wa(118,42712,43020)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42724,43056)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42736,43080)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42748,43104)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42760,43120)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42772,43140)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42784,43160)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42796,43188)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42808,43228)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42820,43260)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42832,43296)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42844,43332)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42856,43348)|0,b=o,o=0,!(b&1)):0)?(o=0,Wa(118,42868,43364)|0,b=o,o=0,!(b&1)):0){o=0;Wa(118,42880,43380)|0;b=o;o=0;if(b&1)break;o=0;Wa(118,42892,43104)|0;b=o;o=0;if(b&1)break;o=0;Wa(118,42904,43396)|0;b=o;o=0;if(b&1)break;o=0;Wa(118,42916,43412)|0;b=o;o=0;if(b&1)break;o=0;Wa(118,42928,43428)|0;b=o;o=0;if(b&1)break;o=0;Wa(118,42940,43444)|0;b=o;o=0;if(b&1)break;o=0;Wa(118,42952,43460)|0;b=o;o=0;if(b&1)break;o=0;Wa(118,42964,43476)|0;b=o;o=0;if(b&1)break;o=0;Wa(118,42976,43492)|0;b=o;o=0;if(b&1)break;c[10877]=42700;Cc(3632);break a}while(0);b=cc()|0;rc(3632);bc(b|0)}while(0);return c[10877]|0}function IJ(b){b=b|0;do if((a[3648]|0)==0?(Hb(3648)|0)!=0:0){if((a[3656]|0)==0?(Hb(3656)|0)!=0:0){b=43512;do{c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;b=b+12|0}while((b|0)!=43800);Ec(353,0,n|0)|0;Cc(3656)}o=0;Wa(108,43512,61609)|0;b=o;o=0;if(!(b&1)?(o=0,Wa(108,43524,61612)|0,b=o,o=0,!(b&1)):0){c[10950]=43512;Cc(3648);break}b=cc()|0;rc(3648);bc(b|0)}while(0);return c[10950]|0}function JJ(b){b=b|0;do if((a[3664]|0)==0?(Hb(3664)|0)!=0:0){if((a[3672]|0)==0?(Hb(3672)|0)!=0:0){b=43804;do{c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;b=b+12|0}while((b|0)!=44092);Ec(354,0,n|0)|0;Cc(3672)}o=0;Wa(118,43804,44092)|0;b=o;o=0;if(!(b&1)?(o=0,Wa(118,43816,44104)|0,b=o,o=0,!(b&1)):0){c[11029]=43804;Cc(3664);break}b=cc()|0;rc(3664);bc(b|0)}while(0);return c[11029]|0}function KJ(b){b=b|0;do if((a[3680]|0)==0?(Hb(3680)|0)!=0:0){o=0;mb(57,44120,61615,8);b=o;o=0;if(b&1){b=cc()|0;rc(3680);bc(b|0)}else{Ec(331,44120,n|0)|0;Cc(3680);break}}while(0);return 44120}function LJ(b){b=b|0;var c=0;do if((a[3688]|0)==0?(Hb(3688)|0)!=0:0){o=0;b=qa(194,44132)|0;c=o;o=0;if(!(c&1)?(o=0,mb(119,44168,44132,b|0),c=o,o=0,!(c&1)):0){Ec(355,44168,n|0)|0;Cc(3688);break}c=cc()|0;rc(3688);bc(c|0)}while(0);return 44168}function MJ(b){b=b|0;do if((a[3696]|0)==0?(Hb(3696)|0)!=0:0){o=0;mb(57,44180,61624,8);b=o;o=0;if(b&1){b=cc()|0;rc(3696);bc(b|0)}else{Ec(331,44180,n|0)|0;Cc(3696);break}}while(0);return 44180}function NJ(b){b=b|0;var c=0;do if((a[3704]|0)==0?(Hb(3704)|0)!=0:0){o=0;b=qa(194,44192)|0;c=o;o=0;if(!(c&1)?(o=0,mb(119,44228,44192,b|0),c=o,o=0,!(c&1)):0){Ec(355,44228,n|0)|0;Cc(3704);break}c=cc()|0;rc(3704);bc(c|0)}while(0);return 44228}function OJ(b){b=b|0;do if((a[3712]|0)==0?(Hb(3712)|0)!=0:0){o=0;mb(57,44240,61633,20);b=o;o=0;if(b&1){b=cc()|0;rc(3712);bc(b|0)}else{Ec(331,44240,n|0)|0;Cc(3712);break}}while(0);return 44240}function PJ(b){b=b|0;var c=0;do if((a[3720]|0)==0?(Hb(3720)|0)!=0:0){o=0;b=qa(194,44252)|0;c=o;o=0;if(!(c&1)?(o=0,mb(119,44336,44252,b|0),c=o,o=0,!(c&1)):0){Ec(355,44336,n|0)|0;Cc(3720);break}c=cc()|0;rc(3720);bc(c|0)}while(0);return 44336}function QJ(b){b=b|0;do if((a[3728]|0)==0?(Hb(3728)|0)!=0:0){o=0;mb(57,44348,61654,11);b=o;o=0;if(b&1){b=cc()|0;rc(3728);bc(b|0)}else{Ec(331,44348,n|0)|0;Cc(3728);break}}while(0);return 44348}function RJ(b){b=b|0;var c=0;do if((a[3736]|0)==0?(Hb(3736)|0)!=0:0){o=0;b=qa(194,44360)|0;c=o;o=0;if(!(c&1)?(o=0,mb(119,44408,44360,b|0),c=o,o=0,!(c&1)):0){Ec(355,44408,n|0)|0;Cc(3736);break}c=cc()|0;rc(3736);bc(c|0)}while(0);return 44408}function SJ(a){a=a|0;var b=0,d=0,e=0;c[a>>2]=40988;a=a+8|0;b=c[a>>2]|0;o=0;d=gb(45)|0;e=o;o=0;do if(!(e&1)){if((b|0)!=(d|0)?(o=0,ka(344,c[a>>2]|0),e=o,o=0,e&1):0)break;return}while(0);e=cc(0)|0;oq(e)}function TJ(b,e,f,g,h,j,k){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;z=i;i=i+112|0;m=z;p=(g-f|0)/12|0;do if(p>>>0>100){m=yC(p)|0;if((m|0)==0?(o=0,ob(46),y=o,o=0,y&1):0){l=0;s=6;break}l=m;s=11}else{l=0;s=11}while(0);a:do if((s|0)==11){if((f|0)==(g|0))n=0;else{s=f;q=0;r=m;while(1){n=a[s>>0]|0;if(!(n&1))n=(n&255)>>>1;else n=c[s+4>>2]|0;if(!n){a[r>>0]=2;n=q+1|0;p=p+-1|0}else{a[r>>0]=1;n=q}s=s+12|0;if((s|0)==(g|0))break;else{q=n;r=r+1|0}}}x=(f|0)==(g|0);y=(f|0)==(g|0);w=0;t=n;b:while(1){n=c[b>>2]|0;do if(n){if((c[n+12>>2]|0)==(c[n+16>>2]|0)){o=0;n=qa(c[(c[n>>2]|0)+36>>2]|0,n|0)|0;v=o;o=0;if(v&1){s=5;break b}if((n|0)==-1){c[b>>2]=0;n=0;break}else{n=c[b>>2]|0;break}}}else n=0;while(0);s=(n|0)==0;q=c[e>>2]|0;if(q){if((c[q+12>>2]|0)==(c[q+16>>2]|0)){o=0;n=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;v=o;o=0;if(v&1){s=5;break}if((n|0)==-1){c[e>>2]=0;q=0}}}else q=0;r=(q|0)==0;n=c[b>>2]|0;if(!((p|0)!=0&(s^r))){s=64;break}q=c[n+12>>2]|0;if((q|0)==(c[n+16>>2]|0)){o=0;n=qa(c[(c[n>>2]|0)+36>>2]|0,n|0)|0;v=o;o=0;if(v&1){s=5;break}}else n=d[q>>0]|0;n=n&255;if(!k){o=0;n=Wa(c[(c[h>>2]|0)+12>>2]|0,h|0,n|0)|0;v=o;o=0;if(v&1){s=5;break}}v=w+1|0;if(x){n=0;s=t}else{r=0;u=f;s=t;t=m;while(1){do if((a[t>>0]|0)==1){if(!(a[u>>0]&1))q=u+1|0;else q=c[u+8>>2]|0;q=a[q+w>>0]|0;if(!k){o=0;q=Wa(c[(c[h>>2]|0)+12>>2]|0,h|0,q|0)|0;A=o;o=0;if(A&1){s=4;break b}}if(n<<24>>24!=q<<24>>24){a[t>>0]=0;q=r;p=p+-1|0;break}q=a[u>>0]|0;if(!(q&1))q=(q&255)>>>1;else q=c[u+4>>2]|0;if((q|0)==(v|0)){a[t>>0]=2;q=1;s=s+1|0;p=p+-1|0}else q=1}else q=r;while(0);u=u+12|0;if((u|0)==(g|0)){n=q;break}else{r=q;t=t+1|0}}}if(!n){w=v;t=s;continue}n=c[b>>2]|0;q=n+12|0;r=c[q>>2]|0;if((r|0)==(c[n+16>>2]|0)){o=0;qa(c[(c[n>>2]|0)+40>>2]|0,n|0)|0;A=o;o=0;if(A&1){s=5;break}}else c[q>>2]=r+1;if((s+p|0)>>>0<2|y){w=v;t=s;continue}else{n=f;r=s;s=m}while(1){if((a[s>>0]|0)==2){q=a[n>>0]|0;if(!(q&1))q=(q&255)>>>1;else q=c[n+4>>2]|0;if((q|0)!=(v|0)){a[s>>0]=0;r=r+-1|0}}n=n+12|0;if((n|0)==(g|0)){w=v;t=r;continue b}else s=s+1|0}}if((s|0)==4){f=cc()|0;break}else if((s|0)==5){f=cc()|0;break}else if((s|0)==64){do if(n){if((c[n+12>>2]|0)==(c[n+16>>2]|0)){o=0;n=qa(c[(c[n>>2]|0)+36>>2]|0,n|0)|0;A=o;o=0;if(A&1){s=6;break a}if((n|0)==-1){c[b>>2]=0;n=0;break}else{n=c[b>>2]|0;break}}}else n=0;while(0);p=(n|0)==0;do if(!r){if((c[q+12>>2]|0)==(c[q+16>>2]|0)){o=0;n=qa(c[(c[q>>2]|0)+36>>2]|0,q|0)|0;A=o;o=0;if(A&1){s=6;break a}if((n|0)==-1){c[e>>2]=0;s=76;break}}if(!p)s=77}else s=76;while(0);if((s|0)==76?p:0)s=77;if((s|0)==77)c[j>>2]=c[j>>2]|2;c:do if((f|0)==(g|0))s=81;else while(1){if((a[m>>0]|0)==2)break c;f=f+12|0;if((f|0)==(g|0)){s=81;break}else m=m+1|0}while(0);if((s|0)==81){c[j>>2]=c[j>>2]|4;f=g}if(l)zC(l);i=z;return f|0}}while(0);if((s|0)==6)f=cc()|0;if(l)zC(l);bc(f|0);return 0}function UJ(b,e,f,g,h,j){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0;A=i;i=i+240|0;t=A+202|0;k=A+200|0;C=A+24|0;B=A+12|0;v=A+8|0;y=A+40|0;z=A+4|0;w=A;u=DJ(g)|0;GE(C,g,t,k);c[B>>2]=0;c[B+4>>2]=0;c[B+8>>2]=0;if(!(a[B>>0]&1))b=10;else b=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,b|0,0);s=o;o=0;a:do if(!(s&1)){q=B+8|0;r=B+1|0;g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g;c[z>>2]=y;c[w>>2]=0;s=B+4|0;p=a[k>>0]|0;b=c[e>>2]|0;b:while(1){if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;k=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;n=o;o=0;if(n&1){D=24;break}if((k|0)==-1){c[e>>2]=0;b=0}}}else b=0;l=(b|0)==0;k=c[f>>2]|0;do if(k){if((c[k+12>>2]|0)!=(c[k+16>>2]|0))if(l)break;else break b;o=0;m=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;n=o;o=0;if(n&1){D=24;break b}if((m|0)!=-1)if(l)break;else break b;else{c[f>>2]=0;D=16;break}}else D=16;while(0);if((D|0)==16){D=0;if(l){k=0;break}else k=0}l=a[B>>0]|0;l=(l&1)==0?(l&255)>>>1:c[s>>2]|0;if((c[v>>2]|0)==(g+l|0)){o=0;mb(80,B|0,l<<1|0,0);n=o;o=0;if(n&1){D=24;break}if(!(a[B>>0]&1))g=10;else g=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,g|0,0);n=o;o=0;if(n&1){D=24;break}g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g+l}m=b+12|0;l=c[m>>2]|0;n=b+16|0;if((l|0)==(c[n>>2]|0)){o=0;l=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;E=o;o=0;if(E&1){D=24;break}}else l=d[l>>0]|0;if(qE(l&255,u,g,v,w,p,C,y,z,t)|0)break;k=c[m>>2]|0;if((k|0)==(c[n>>2]|0)){o=0;qa(c[(c[b>>2]|0)+40>>2]|0,b|0)|0;E=o;o=0;if(E&1){D=24;break}else continue}else{c[m>>2]=k+1;continue}}if((D|0)==24){b=cc()|0;break}E=a[C>>0]|0;if((((E&1)==0?(E&255)>>>1:c[C+4>>2]|0)|0)!=0?(x=c[z>>2]|0,(x-y|0)<160):0){E=c[w>>2]|0;c[z>>2]=x+4;c[x>>2]=E}o=0;g=kb(69,g|0,c[v>>2]|0,h|0,u|0)|0;E=o;o=0;if(!(E&1)){c[j>>2]=g;oH(C,y,c[z>>2]|0,h);if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;g=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;E=o;o=0;if(E&1){D=25;break}if((g|0)==-1){c[e>>2]=0;b=0}}}else b=0;g=(b|0)==0;do if(k){if((c[k+12>>2]|0)==(c[k+16>>2]|0)){o=0;b=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;E=o;o=0;if(E&1){D=25;break a}if((b|0)==-1){c[f>>2]=0;D=49;break}}if(!g)D=50}else D=49;while(0);if((D|0)==49?g:0)D=50;if((D|0)==50)c[h>>2]=c[h>>2]|2;E=c[e>>2]|0;IC(B);IC(C);i=A;return E|0}else D=25}else D=25;while(0);if((D|0)==25)b=cc()|0;IC(B);IC(C);bc(b|0);return 0}function VJ(b,e,f,g,h,j){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0,F=0;A=i;i=i+240|0;t=A+202|0;k=A+200|0;C=A+24|0;B=A+12|0;v=A+8|0;y=A+40|0;z=A+4|0;w=A;u=DJ(g)|0;GE(C,g,t,k);c[B>>2]=0;c[B+4>>2]=0;c[B+8>>2]=0;if(!(a[B>>0]&1))b=10;else b=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,b|0,0);s=o;o=0;a:do if(!(s&1)){q=B+8|0;r=B+1|0;g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g;c[z>>2]=y;c[w>>2]=0;s=B+4|0;p=a[k>>0]|0;b=c[e>>2]|0;b:while(1){if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;k=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;n=o;o=0;if(n&1){E=24;break}if((k|0)==-1){c[e>>2]=0;b=0}}}else b=0;k=(b|0)==0;l=c[f>>2]|0;do if(l){if((c[l+12>>2]|0)!=(c[l+16>>2]|0))if(k)break;else break b;o=0;m=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;n=o;o=0;if(n&1){E=24;break b}if((m|0)!=-1)if(k)break;else break b;else{c[f>>2]=0;E=16;break}}else E=16;while(0);if((E|0)==16){E=0;if(k){l=0;break}else l=0}k=a[B>>0]|0;k=(k&1)==0?(k&255)>>>1:c[s>>2]|0;if((c[v>>2]|0)==(g+k|0)){o=0;mb(80,B|0,k<<1|0,0);n=o;o=0;if(n&1){E=24;break}if(!(a[B>>0]&1))g=10;else g=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,g|0,0);n=o;o=0;if(n&1){E=24;break}g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g+k}m=b+12|0;k=c[m>>2]|0;n=b+16|0;if((k|0)==(c[n>>2]|0)){o=0;k=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;F=o;o=0;if(F&1){E=24;break}}else k=d[k>>0]|0;if(qE(k&255,u,g,v,w,p,C,y,z,t)|0)break;k=c[m>>2]|0;if((k|0)==(c[n>>2]|0)){o=0;qa(c[(c[b>>2]|0)+40>>2]|0,b|0)|0;F=o;o=0;if(F&1){E=24;break}else continue}else{c[m>>2]=k+1;continue}}if((E|0)==24){b=cc()|0;break}F=a[C>>0]|0;if((((F&1)==0?(F&255)>>>1:c[C+4>>2]|0)|0)!=0?(x=c[z>>2]|0,(x-y|0)<160):0){F=c[w>>2]|0;c[z>>2]=x+4;c[x>>2]=F}o=0;g=kb(70,g|0,c[v>>2]|0,h|0,u|0)|0;k=D;F=o;o=0;if(!(F&1)){F=j;c[F>>2]=g;c[F+4>>2]=k;oH(C,y,c[z>>2]|0,h);if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;g=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;F=o;o=0;if(F&1){E=25;break}if((g|0)==-1){c[e>>2]=0;b=0}}}else b=0;g=(b|0)==0;do if(l){if((c[l+12>>2]|0)==(c[l+16>>2]|0)){o=0;b=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;F=o;o=0;if(F&1){E=25;break a}if((b|0)==-1){c[f>>2]=0;E=49;break}}if(!g)E=50}else E=49;while(0);if((E|0)==49?g:0)E=50;if((E|0)==50)c[h>>2]=c[h>>2]|2;F=c[e>>2]|0;IC(B);IC(C);i=A;return F|0}else E=25}else E=25;while(0);if((E|0)==25)b=cc()|0;IC(B);IC(C);bc(b|0);return 0}function WJ(e,f,g,h,j,k){e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0;B=i;i=i+240|0;u=B+202|0;l=B+200|0;D=B+24|0;C=B+12|0;w=B+8|0;z=B+40|0;A=B+4|0;x=B;v=DJ(h)|0;GE(D,h,u,l);c[C>>2]=0;c[C+4>>2]=0;c[C+8>>2]=0;if(!(a[C>>0]&1))e=10;else e=(c[C>>2]&-2)+-1|0;o=0;mb(80,C|0,e|0,0);t=o;o=0;a:do if(!(t&1)){r=C+8|0;s=C+1|0;h=(a[C>>0]&1)==0?s:c[r>>2]|0;c[w>>2]=h;c[A>>2]=z;c[x>>2]=0;t=C+4|0;q=a[l>>0]|0;e=c[f>>2]|0;b:while(1){if(e){if((c[e+12>>2]|0)==(c[e+16>>2]|0)){o=0;l=qa(c[(c[e>>2]|0)+36>>2]|0,e|0)|0;p=o;o=0;if(p&1){E=24;break}if((l|0)==-1){c[f>>2]=0;e=0}}}else e=0;m=(e|0)==0;l=c[g>>2]|0;do if(l){if((c[l+12>>2]|0)!=(c[l+16>>2]|0))if(m)break;else break b;o=0;n=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;p=o;o=0;if(p&1){E=24;break b}if((n|0)!=-1)if(m)break;else break b;else{c[g>>2]=0;E=16;break}}else E=16;while(0);if((E|0)==16){E=0;if(m){l=0;break}else l=0}m=a[C>>0]|0;m=(m&1)==0?(m&255)>>>1:c[t>>2]|0;if((c[w>>2]|0)==(h+m|0)){o=0;mb(80,C|0,m<<1|0,0);p=o;o=0;if(p&1){E=24;break}if(!(a[C>>0]&1))h=10;else h=(c[C>>2]&-2)+-1|0;o=0;mb(80,C|0,h|0,0);p=o;o=0;if(p&1){E=24;break}h=(a[C>>0]&1)==0?s:c[r>>2]|0;c[w>>2]=h+m}n=e+12|0;m=c[n>>2]|0;p=e+16|0;if((m|0)==(c[p>>2]|0)){o=0;m=qa(c[(c[e>>2]|0)+36>>2]|0,e|0)|0;F=o;o=0;if(F&1){E=24;break}}else m=d[m>>0]|0;if(qE(m&255,v,h,w,x,q,D,z,A,u)|0)break;l=c[n>>2]|0;if((l|0)==(c[p>>2]|0)){o=0;qa(c[(c[e>>2]|0)+40>>2]|0,e|0)|0;F=o;o=0;if(F&1){E=24;break}else continue}else{c[n>>2]=l+1;continue}}if((E|0)==24){e=cc()|0;break}F=a[D>>0]|0;if((((F&1)==0?(F&255)>>>1:c[D+4>>2]|0)|0)!=0?(y=c[A>>2]|0,(y-z|0)<160):0){F=c[x>>2]|0;c[A>>2]=y+4;c[y>>2]=F}o=0;h=kb(71,h|0,c[w>>2]|0,j|0,v|0)|0;F=o;o=0;if(!(F&1)){b[k>>1]=h;oH(D,z,c[A>>2]|0,j);if(e){if((c[e+12>>2]|0)==(c[e+16>>2]|0)){o=0;h=qa(c[(c[e>>2]|0)+36>>2]|0,e|0)|0;F=o;o=0;if(F&1){E=25;break}if((h|0)==-1){c[f>>2]=0;e=0}}}else e=0;h=(e|0)==0;do if(l){if((c[l+12>>2]|0)==(c[l+16>>2]|0)){o=0;e=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;F=o;o=0;if(F&1){E=25;break a}if((e|0)==-1){c[g>>2]=0;E=49;break}}if(!h)E=50}else E=49;while(0);if((E|0)==49?h:0)E=50;if((E|0)==50)c[j>>2]=c[j>>2]|2;F=c[f>>2]|0;IC(C);IC(D);i=B;return F|0}else E=25}else E=25;while(0);if((E|0)==25)e=cc()|0;IC(C);IC(D);bc(e|0);return 0}function XJ(b,e,f,g,h,j){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0;A=i;i=i+240|0;t=A+202|0;k=A+200|0;C=A+24|0;B=A+12|0;v=A+8|0;y=A+40|0;z=A+4|0;w=A;u=DJ(g)|0;GE(C,g,t,k);c[B>>2]=0;c[B+4>>2]=0;c[B+8>>2]=0;if(!(a[B>>0]&1))b=10;else b=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,b|0,0);s=o;o=0;a:do if(!(s&1)){q=B+8|0;r=B+1|0;g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g;c[z>>2]=y;c[w>>2]=0;s=B+4|0;p=a[k>>0]|0;b=c[e>>2]|0;b:while(1){if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;k=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;n=o;o=0;if(n&1){D=24;break}if((k|0)==-1){c[e>>2]=0;b=0}}}else b=0;l=(b|0)==0;k=c[f>>2]|0;do if(k){if((c[k+12>>2]|0)!=(c[k+16>>2]|0))if(l)break;else break b;o=0;m=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;n=o;o=0;if(n&1){D=24;break b}if((m|0)!=-1)if(l)break;else break b;else{c[f>>2]=0;D=16;break}}else D=16;while(0);if((D|0)==16){D=0;if(l){k=0;break}else k=0}l=a[B>>0]|0;l=(l&1)==0?(l&255)>>>1:c[s>>2]|0;if((c[v>>2]|0)==(g+l|0)){o=0;mb(80,B|0,l<<1|0,0);n=o;o=0;if(n&1){D=24;break}if(!(a[B>>0]&1))g=10;else g=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,g|0,0);n=o;o=0;if(n&1){D=24;break}g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g+l}m=b+12|0;l=c[m>>2]|0;n=b+16|0;if((l|0)==(c[n>>2]|0)){o=0;l=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;E=o;o=0;if(E&1){D=24;break}}else l=d[l>>0]|0;if(qE(l&255,u,g,v,w,p,C,y,z,t)|0)break;k=c[m>>2]|0;if((k|0)==(c[n>>2]|0)){o=0;qa(c[(c[b>>2]|0)+40>>2]|0,b|0)|0;E=o;o=0;if(E&1){D=24;break}else continue}else{c[m>>2]=k+1;continue}}if((D|0)==24){b=cc()|0;break}E=a[C>>0]|0;if((((E&1)==0?(E&255)>>>1:c[C+4>>2]|0)|0)!=0?(x=c[z>>2]|0,(x-y|0)<160):0){E=c[w>>2]|0;c[z>>2]=x+4;c[x>>2]=E}o=0;g=kb(72,g|0,c[v>>2]|0,h|0,u|0)|0;E=o;o=0;if(!(E&1)){c[j>>2]=g;oH(C,y,c[z>>2]|0,h);if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;g=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;E=o;o=0;if(E&1){D=25;break}if((g|0)==-1){c[e>>2]=0;b=0}}}else b=0;g=(b|0)==0;do if(k){if((c[k+12>>2]|0)==(c[k+16>>2]|0)){o=0;b=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;E=o;o=0;if(E&1){D=25;break a}if((b|0)==-1){c[f>>2]=0;D=49;break}}if(!g)D=50}else D=49;while(0);if((D|0)==49?g:0)D=50;if((D|0)==50)c[h>>2]=c[h>>2]|2;E=c[e>>2]|0;IC(B);IC(C);i=A;return E|0}else D=25}else D=25;while(0);if((D|0)==25)b=cc()|0;IC(B);IC(C);bc(b|0);return 0}function YJ(b,e,f,g,h,j){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0;A=i;i=i+240|0;t=A+202|0;k=A+200|0;C=A+24|0;B=A+12|0;v=A+8|0;y=A+40|0;z=A+4|0;w=A;u=DJ(g)|0;GE(C,g,t,k);c[B>>2]=0;c[B+4>>2]=0;c[B+8>>2]=0;if(!(a[B>>0]&1))b=10;else b=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,b|0,0);s=o;o=0;a:do if(!(s&1)){q=B+8|0;r=B+1|0;g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g;c[z>>2]=y;c[w>>2]=0;s=B+4|0;p=a[k>>0]|0;b=c[e>>2]|0;b:while(1){if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;k=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;n=o;o=0;if(n&1){D=24;break}if((k|0)==-1){c[e>>2]=0;b=0}}}else b=0;l=(b|0)==0;k=c[f>>2]|0;do if(k){if((c[k+12>>2]|0)!=(c[k+16>>2]|0))if(l)break;else break b;o=0;m=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;n=o;o=0;if(n&1){D=24;break b}if((m|0)!=-1)if(l)break;else break b;else{c[f>>2]=0;D=16;break}}else D=16;while(0);if((D|0)==16){D=0;if(l){k=0;break}else k=0}l=a[B>>0]|0;l=(l&1)==0?(l&255)>>>1:c[s>>2]|0;if((c[v>>2]|0)==(g+l|0)){o=0;mb(80,B|0,l<<1|0,0);n=o;o=0;if(n&1){D=24;break}if(!(a[B>>0]&1))g=10;else g=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,g|0,0);n=o;o=0;if(n&1){D=24;break}g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g+l}m=b+12|0;l=c[m>>2]|0;n=b+16|0;if((l|0)==(c[n>>2]|0)){o=0;l=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;E=o;o=0;if(E&1){D=24;break}}else l=d[l>>0]|0;if(qE(l&255,u,g,v,w,p,C,y,z,t)|0)break;k=c[m>>2]|0;if((k|0)==(c[n>>2]|0)){o=0;qa(c[(c[b>>2]|0)+40>>2]|0,b|0)|0;E=o;o=0;if(E&1){D=24;break}else continue}else{c[m>>2]=k+1;continue}}if((D|0)==24){b=cc()|0;break}E=a[C>>0]|0;if((((E&1)==0?(E&255)>>>1:c[C+4>>2]|0)|0)!=0?(x=c[z>>2]|0,(x-y|0)<160):0){E=c[w>>2]|0;c[z>>2]=x+4;c[x>>2]=E}o=0;g=kb(73,g|0,c[v>>2]|0,h|0,u|0)|0;E=o;o=0;if(!(E&1)){c[j>>2]=g;oH(C,y,c[z>>2]|0,h);if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;g=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;E=o;o=0;if(E&1){D=25;break}if((g|0)==-1){c[e>>2]=0;b=0}}}else b=0;g=(b|0)==0;do if(k){if((c[k+12>>2]|0)==(c[k+16>>2]|0)){o=0;b=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;E=o;o=0;if(E&1){D=25;break a}if((b|0)==-1){c[f>>2]=0;D=49;break}}if(!g)D=50}else D=49;while(0);if((D|0)==49?g:0)D=50;if((D|0)==50)c[h>>2]=c[h>>2]|2;E=c[e>>2]|0;IC(B);IC(C);i=A;return E|0}else D=25}else D=25;while(0);if((D|0)==25)b=cc()|0;IC(B);IC(C);bc(b|0);return 0}function ZJ(b,e,f,g,h,j){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0,F=0;A=i;i=i+240|0;t=A+202|0;k=A+200|0;C=A+24|0;B=A+12|0;v=A+8|0;y=A+40|0;z=A+4|0;w=A;u=DJ(g)|0;GE(C,g,t,k);c[B>>2]=0;c[B+4>>2]=0;c[B+8>>2]=0;if(!(a[B>>0]&1))b=10;else b=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,b|0,0);s=o;o=0;a:do if(!(s&1)){q=B+8|0;r=B+1|0;g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g;c[z>>2]=y;c[w>>2]=0;s=B+4|0;p=a[k>>0]|0;b=c[e>>2]|0;b:while(1){if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;k=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;n=o;o=0;if(n&1){E=24;break}if((k|0)==-1){c[e>>2]=0;b=0}}}else b=0;k=(b|0)==0;l=c[f>>2]|0;do if(l){if((c[l+12>>2]|0)!=(c[l+16>>2]|0))if(k)break;else break b;o=0;m=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;n=o;o=0;if(n&1){E=24;break b}if((m|0)!=-1)if(k)break;else break b;else{c[f>>2]=0;E=16;break}}else E=16;while(0);if((E|0)==16){E=0;if(k){l=0;break}else l=0}k=a[B>>0]|0;k=(k&1)==0?(k&255)>>>1:c[s>>2]|0;if((c[v>>2]|0)==(g+k|0)){o=0;mb(80,B|0,k<<1|0,0);n=o;o=0;if(n&1){E=24;break}if(!(a[B>>0]&1))g=10;else g=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,g|0,0);n=o;o=0;if(n&1){E=24;break}g=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=g+k}m=b+12|0;k=c[m>>2]|0;n=b+16|0;if((k|0)==(c[n>>2]|0)){o=0;k=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;F=o;o=0;if(F&1){E=24;break}}else k=d[k>>0]|0;if(qE(k&255,u,g,v,w,p,C,y,z,t)|0)break;k=c[m>>2]|0;if((k|0)==(c[n>>2]|0)){o=0;qa(c[(c[b>>2]|0)+40>>2]|0,b|0)|0;F=o;o=0;if(F&1){E=24;break}else continue}else{c[m>>2]=k+1;continue}}if((E|0)==24){b=cc()|0;break}F=a[C>>0]|0;if((((F&1)==0?(F&255)>>>1:c[C+4>>2]|0)|0)!=0?(x=c[z>>2]|0,(x-y|0)<160):0){F=c[w>>2]|0;c[z>>2]=x+4;c[x>>2]=F}o=0;g=kb(74,g|0,c[v>>2]|0,h|0,u|0)|0;k=D;F=o;o=0;if(!(F&1)){F=j;c[F>>2]=g;c[F+4>>2]=k;oH(C,y,c[z>>2]|0,h);if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;g=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;F=o;o=0;if(F&1){E=25;break}if((g|0)==-1){c[e>>2]=0;b=0}}}else b=0;g=(b|0)==0;do if(l){if((c[l+12>>2]|0)==(c[l+16>>2]|0)){o=0;b=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;F=o;o=0;if(F&1){E=25;break a}if((b|0)==-1){c[f>>2]=0;E=49;break}}if(!g)E=50}else E=49;while(0);if((E|0)==49?g:0)E=50;if((E|0)==50)c[h>>2]=c[h>>2]|2;F=c[e>>2]|0;IC(B);IC(C);i=A;return F|0}else E=25}else E=25;while(0);if((E|0)==25)b=cc()|0;IC(B);IC(C);bc(b|0);return 0}function _J(b,e,f,h,j,k){b=b|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0.0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;E=i;i=i+240|0;w=E+208|0;m=E+203|0;n=E+202|0;G=E+24|0;F=E+12|0;y=E+8|0;C=E+40|0;D=E+4|0;z=E;A=E+201|0;x=E+200|0;HE(G,h,w,m,n);c[F>>2]=0;c[F+4>>2]=0;c[F+8>>2]=0;if(!(a[F>>0]&1))b=10;else b=(c[F>>2]&-2)+-1|0;o=0;mb(80,F|0,b|0,0);v=o;o=0;a:do if(!(v&1)){t=F+8|0;u=F+1|0;h=(a[F>>0]&1)==0?u:c[t>>2]|0;c[y>>2]=h;c[D>>2]=C;c[z>>2]=0;a[A>>0]=1;a[x>>0]=69;v=F+4|0;s=a[m>>0]|0;r=a[n>>0]|0;b=c[e>>2]|0;b:while(1){if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;m=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;q=o;o=0;if(q&1){H=24;break}if((m|0)==-1){c[e>>2]=0;b=0}}}else b=0;n=(b|0)==0;m=c[f>>2]|0;do if(m){if((c[m+12>>2]|0)!=(c[m+16>>2]|0))if(n)break;else break b;o=0;p=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;q=o;o=0;if(q&1){H=24;break b}if((p|0)!=-1)if(n)break;else break b;else{c[f>>2]=0;H=16;break}}else H=16;while(0);if((H|0)==16){H=0;if(n){m=0;break}else m=0}n=a[F>>0]|0;n=(n&1)==0?(n&255)>>>1:c[v>>2]|0;if((c[y>>2]|0)==(h+n|0)){o=0;mb(80,F|0,n<<1|0,0);q=o;o=0;if(q&1){H=24;break}if(!(a[F>>0]&1))h=10;else h=(c[F>>2]&-2)+-1|0;o=0;mb(80,F|0,h|0,0);q=o;o=0;if(q&1){H=24;break}h=(a[F>>0]&1)==0?u:c[t>>2]|0;c[y>>2]=h+n}p=b+12|0;n=c[p>>2]|0;q=b+16|0;if((n|0)==(c[q>>2]|0)){o=0;n=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;I=o;o=0;if(I&1){H=24;break}}else n=d[n>>0]|0;if(IE(n&255,A,x,h,y,s,r,G,C,D,z,w)|0)break;m=c[p>>2]|0;if((m|0)==(c[q>>2]|0)){o=0;qa(c[(c[b>>2]|0)+40>>2]|0,b|0)|0;I=o;o=0;if(I&1){H=24;break}else continue}else{c[p>>2]=m+1;continue}}if((H|0)==24){b=cc()|0;break}I=a[G>>0]|0;if(!((a[A>>0]|0)==0?1:(((I&1)==0?(I&255)>>>1:c[G+4>>2]|0)|0)==0)?(B=c[D>>2]|0,(B-C|0)<160):0){I=c[z>>2]|0;c[D>>2]=B+4;c[B>>2]=I}o=0;l=+_a(44,h|0,c[y>>2]|0,j|0);I=o;o=0;if(!(I&1)){g[k>>2]=l;oH(G,C,c[D>>2]|0,j);if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;h=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;I=o;o=0;if(I&1){H=25;break}if((h|0)==-1){c[e>>2]=0;b=0}}}else b=0;h=(b|0)==0;do if(m){if((c[m+12>>2]|0)==(c[m+16>>2]|0)){o=0;b=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;I=o;o=0;if(I&1){H=25;break a}if((b|0)==-1){c[f>>2]=0;H=49;break}}if(!h)H=50}else H=49;while(0);if((H|0)==49?h:0)H=50;if((H|0)==50)c[j>>2]=c[j>>2]|2;I=c[e>>2]|0;IC(F);IC(G);i=E;return I|0}else H=25}else H=25;while(0);if((H|0)==25)b=cc()|0;IC(F);IC(G);bc(b|0);return 0}function $J(b,e,f,g,j,k){b=b|0;e=e|0;f=f|0;g=g|0;j=j|0;k=k|0;var l=0.0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;E=i;i=i+240|0;w=E+208|0;m=E+203|0;n=E+202|0;G=E+24|0;F=E+12|0;y=E+8|0;C=E+40|0;D=E+4|0;z=E;A=E+201|0;x=E+200|0;HE(G,g,w,m,n);c[F>>2]=0;c[F+4>>2]=0;c[F+8>>2]=0;if(!(a[F>>0]&1))b=10;else b=(c[F>>2]&-2)+-1|0;o=0;mb(80,F|0,b|0,0);v=o;o=0;a:do if(!(v&1)){t=F+8|0;u=F+1|0;g=(a[F>>0]&1)==0?u:c[t>>2]|0;c[y>>2]=g;c[D>>2]=C;c[z>>2]=0;a[A>>0]=1;a[x>>0]=69;v=F+4|0;s=a[m>>0]|0;r=a[n>>0]|0;b=c[e>>2]|0;b:while(1){if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;m=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;q=o;o=0;if(q&1){H=24;break}if((m|0)==-1){c[e>>2]=0;b=0}}}else b=0;n=(b|0)==0;m=c[f>>2]|0;do if(m){if((c[m+12>>2]|0)!=(c[m+16>>2]|0))if(n)break;else break b;o=0;p=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;q=o;o=0;if(q&1){H=24;break b}if((p|0)!=-1)if(n)break;else break b;else{c[f>>2]=0;H=16;break}}else H=16;while(0);if((H|0)==16){H=0;if(n){m=0;break}else m=0}n=a[F>>0]|0;n=(n&1)==0?(n&255)>>>1:c[v>>2]|0;if((c[y>>2]|0)==(g+n|0)){o=0;mb(80,F|0,n<<1|0,0);q=o;o=0;if(q&1){H=24;break}if(!(a[F>>0]&1))g=10;else g=(c[F>>2]&-2)+-1|0;o=0;mb(80,F|0,g|0,0);q=o;o=0;if(q&1){H=24;break}g=(a[F>>0]&1)==0?u:c[t>>2]|0;c[y>>2]=g+n}p=b+12|0;n=c[p>>2]|0;q=b+16|0;if((n|0)==(c[q>>2]|0)){o=0;n=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;I=o;o=0;if(I&1){H=24;break}}else n=d[n>>0]|0;if(IE(n&255,A,x,g,y,s,r,G,C,D,z,w)|0)break;m=c[p>>2]|0;if((m|0)==(c[q>>2]|0)){o=0;qa(c[(c[b>>2]|0)+40>>2]|0,b|0)|0;I=o;o=0;if(I&1){H=24;break}else continue}else{c[p>>2]=m+1;continue}}if((H|0)==24){b=cc()|0;break}I=a[G>>0]|0;if(!((a[A>>0]|0)==0?1:(((I&1)==0?(I&255)>>>1:c[G+4>>2]|0)|0)==0)?(B=c[D>>2]|0,(B-C|0)<160):0){I=c[z>>2]|0;c[D>>2]=B+4;c[B>>2]=I}o=0;l=+_a(45,g|0,c[y>>2]|0,j|0);I=o;o=0;if(!(I&1)){h[k>>3]=l;oH(G,C,c[D>>2]|0,j);if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;g=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;I=o;o=0;if(I&1){H=25;break}if((g|0)==-1){c[e>>2]=0;b=0}}}else b=0;g=(b|0)==0;do if(m){if((c[m+12>>2]|0)==(c[m+16>>2]|0)){o=0;b=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;I=o;o=0;if(I&1){H=25;break a}if((b|0)==-1){c[f>>2]=0;H=49;break}}if(!g)H=50}else H=49;while(0);if((H|0)==49?g:0)H=50;if((H|0)==50)c[j>>2]=c[j>>2]|2;I=c[e>>2]|0;IC(F);IC(G);i=E;return I|0}else H=25}else H=25;while(0);if((H|0)==25)b=cc()|0;IC(F);IC(G);bc(b|0);return 0}function aK(b,e,f,g,j,k){b=b|0;e=e|0;f=f|0;g=g|0;j=j|0;k=k|0;var l=0.0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;E=i;i=i+240|0;w=E+208|0;m=E+203|0;n=E+202|0;G=E+24|0;F=E+12|0;y=E+8|0;C=E+40|0;D=E+4|0;z=E;A=E+201|0;x=E+200|0;HE(G,g,w,m,n);c[F>>2]=0;c[F+4>>2]=0;c[F+8>>2]=0;if(!(a[F>>0]&1))b=10;else b=(c[F>>2]&-2)+-1|0;o=0;mb(80,F|0,b|0,0);v=o;o=0;a:do if(!(v&1)){t=F+8|0;u=F+1|0;g=(a[F>>0]&1)==0?u:c[t>>2]|0;c[y>>2]=g;c[D>>2]=C;c[z>>2]=0;a[A>>0]=1;a[x>>0]=69;v=F+4|0;s=a[m>>0]|0;r=a[n>>0]|0;b=c[e>>2]|0;b:while(1){if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;m=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;q=o;o=0;if(q&1){H=24;break}if((m|0)==-1){c[e>>2]=0;b=0}}}else b=0;n=(b|0)==0;m=c[f>>2]|0;do if(m){if((c[m+12>>2]|0)!=(c[m+16>>2]|0))if(n)break;else break b;o=0;p=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;q=o;o=0;if(q&1){H=24;break b}if((p|0)!=-1)if(n)break;else break b;else{c[f>>2]=0;H=16;break}}else H=16;while(0);if((H|0)==16){H=0;if(n){m=0;break}else m=0}n=a[F>>0]|0;n=(n&1)==0?(n&255)>>>1:c[v>>2]|0;if((c[y>>2]|0)==(g+n|0)){o=0;mb(80,F|0,n<<1|0,0);q=o;o=0;if(q&1){H=24;break}if(!(a[F>>0]&1))g=10;else g=(c[F>>2]&-2)+-1|0;o=0;mb(80,F|0,g|0,0);q=o;o=0;if(q&1){H=24;break}g=(a[F>>0]&1)==0?u:c[t>>2]|0;c[y>>2]=g+n}p=b+12|0;n=c[p>>2]|0;q=b+16|0;if((n|0)==(c[q>>2]|0)){o=0;n=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;I=o;o=0;if(I&1){H=24;break}}else n=d[n>>0]|0;if(IE(n&255,A,x,g,y,s,r,G,C,D,z,w)|0)break;m=c[p>>2]|0;if((m|0)==(c[q>>2]|0)){o=0;qa(c[(c[b>>2]|0)+40>>2]|0,b|0)|0;I=o;o=0;if(I&1){H=24;break}else continue}else{c[p>>2]=m+1;continue}}if((H|0)==24){b=cc()|0;break}I=a[G>>0]|0;if(!((a[A>>0]|0)==0?1:(((I&1)==0?(I&255)>>>1:c[G+4>>2]|0)|0)==0)?(B=c[D>>2]|0,(B-C|0)<160):0){I=c[z>>2]|0;c[D>>2]=B+4;c[B>>2]=I}o=0;l=+_a(46,g|0,c[y>>2]|0,j|0);I=o;o=0;if(!(I&1)){h[k>>3]=l;oH(G,C,c[D>>2]|0,j);if(b){if((c[b+12>>2]|0)==(c[b+16>>2]|0)){o=0;g=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;I=o;o=0;if(I&1){H=25;break}if((g|0)==-1){c[e>>2]=0;b=0}}}else b=0;g=(b|0)==0;do if(m){if((c[m+12>>2]|0)==(c[m+16>>2]|0)){o=0;b=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;I=o;o=0;if(I&1){H=25;break a}if((b|0)==-1){c[f>>2]=0;H=49;break}}if(!g)H=50}else H=49;while(0);if((H|0)==49?g:0)H=50;if((H|0)==50)c[j>>2]=c[j>>2]|2;I=c[e>>2]|0;IC(F);IC(G);i=E;return I|0}else H=25}else H=25;while(0);if((H|0)==25)b=cc()|0;IC(F);IC(G);bc(b|0);return 0}function bK(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0;f=i;i=i+16|0;g=f;c[g>>2]=e;e=lB(b)|0;b=YB(a,d,g)|0;if((e|0)!=0?(o=0,qa(193,e|0)|0,g=o,o=0,g&1):0){g=cc(0)|0;oq(g)}i=f;return b|0}function cK(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;y=i;i=i+112|0;l=y;n=(f-e|0)/12|0;do if(n>>>0>100){l=yC(n)|0;if((l|0)==0?(o=0,ob(46),x=o,o=0,x&1):0){k=0;q=6;break}k=l;q=11}else{k=0;q=11}while(0);a:do if((q|0)==11){if((e|0)==(f|0))m=0;else{r=e;p=0;q=l;while(1){m=a[r>>0]|0;if(!(m&1))m=(m&255)>>>1;else m=c[r+4>>2]|0;if(!m){a[q>>0]=2;m=p+1|0;n=n+-1|0}else{a[q>>0]=1;m=p}r=r+12|0;if((r|0)==(f|0))break;else{p=m;q=q+1|0}}}w=(e|0)==(f|0);x=(e|0)==(f|0);v=0;s=n;b:while(1){n=c[b>>2]|0;do if(n){p=c[n+12>>2]|0;if((p|0)==(c[n+16>>2]|0)){o=0;n=qa(c[(c[n>>2]|0)+36>>2]|0,n|0)|0;u=o;o=0;if(u&1){q=5;break b}}else n=c[p>>2]|0;if((n|0)==-1){c[b>>2]=0;r=1;break}else{r=(c[b>>2]|0)==0;break}}else r=1;while(0);p=c[d>>2]|0;if(p){n=c[p+12>>2]|0;if((n|0)==(c[p+16>>2]|0)){o=0;n=qa(c[(c[p>>2]|0)+36>>2]|0,p|0)|0;u=o;o=0;if(u&1){q=5;break}}else n=c[n>>2]|0;if((n|0)==-1){c[d>>2]=0;p=0;q=1}else q=0}else{p=0;q=1}n=c[b>>2]|0;if(!((s|0)!=0&(r^q))){q=66;break}p=c[n+12>>2]|0;if((p|0)==(c[n+16>>2]|0)){o=0;n=qa(c[(c[n>>2]|0)+36>>2]|0,n|0)|0;u=o;o=0;if(u&1){q=5;break}}else n=c[p>>2]|0;if(!j){o=0;n=Wa(c[(c[g>>2]|0)+28>>2]|0,g|0,n|0)|0;u=o;o=0;if(u&1){q=5;break}}u=v+1|0;if(w){n=0;r=s}else{r=0;t=e;q=s;s=l;while(1){do if((a[s>>0]|0)==1){if(!(a[t>>0]&1))p=t+4|0;else p=c[t+8>>2]|0;p=c[p+(v<<2)>>2]|0;if(!j){o=0;p=Wa(c[(c[g>>2]|0)+28>>2]|0,g|0,p|0)|0;z=o;o=0;if(z&1){q=4;break b}}if((n|0)!=(p|0)){a[s>>0]=0;p=r;q=q+-1|0;break}p=a[t>>0]|0;if(!(p&1))p=(p&255)>>>1;else p=c[t+4>>2]|0;if((p|0)==(u|0)){a[s>>0]=2;p=1;m=m+1|0;q=q+-1|0}else p=1}else p=r;while(0);t=t+12|0;if((t|0)==(f|0)){n=p;r=q;break}else{r=p;s=s+1|0}}}if(!n){v=u;s=r;continue}n=c[b>>2]|0;p=n+12|0;q=c[p>>2]|0;if((q|0)==(c[n+16>>2]|0)){o=0;qa(c[(c[n>>2]|0)+40>>2]|0,n|0)|0;z=o;o=0;if(z&1){q=5;break}}else c[p>>2]=q+4;if((m+r|0)>>>0<2|x){v=u;s=r;continue}else{n=e;q=l}while(1){if((a[q>>0]|0)==2){p=a[n>>0]|0;if(!(p&1))p=(p&255)>>>1;else p=c[n+4>>2]|0;if((p|0)!=(u|0)){a[q>>0]=0;m=m+-1|0}}n=n+12|0;if((n|0)==(f|0)){v=u;s=r;continue b}else q=q+1|0}}if((q|0)==4){e=cc()|0;break}else if((q|0)==5){e=cc()|0;break}else if((q|0)==66){do if(n){m=c[n+12>>2]|0;if((m|0)==(c[n+16>>2]|0)){o=0;m=qa(c[(c[n>>2]|0)+36>>2]|0,n|0)|0;z=o;o=0;if(z&1){q=6;break a}}else m=c[m>>2]|0;if((m|0)==-1){c[b>>2]=0;n=1;break}else{n=(c[b>>2]|0)==0;break}}else n=1;while(0);do if(p){m=c[p+12>>2]|0;if((m|0)==(c[p+16>>2]|0)){o=0;m=qa(c[(c[p>>2]|0)+36>>2]|0,p|0)|0;z=o;o=0;if(z&1){q=6;break a}}else m=c[m>>2]|0;if((m|0)!=-1)if(n)break;else{q=81;break}else{c[d>>2]=0;q=79;break}}else q=79;while(0);if((q|0)==79?n:0)q=81;if((q|0)==81)c[h>>2]=c[h>>2]|2;c:do if((e|0)==(f|0))q=85;else while(1){if((a[l>>0]|0)==2)break c;e=e+12|0;if((e|0)==(f|0)){q=85;break}else l=l+1|0}while(0);if((q|0)==85){c[h>>2]=c[h>>2]|4;e=f}if(k)zC(k);i=y;return e|0}}while(0);if((q|0)==6)e=cc()|0;if(k)zC(k);bc(e|0);return 0}function dK(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;z=i;i=i+320|0;s=z+208|0;j=z+200|0;B=z+24|0;A=z+12|0;u=z+8|0;x=z+40|0;y=z+4|0;v=z;t=DJ(f)|0;JE(B,f,s,j);c[A>>2]=0;c[A+4>>2]=0;c[A+8>>2]=0;if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);r=o;o=0;a:do if(!(r&1)){p=A+8|0;q=A+1|0;b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b;c[y>>2]=x;c[v>>2]=0;r=A+4|0;n=c[j>>2]|0;j=c[d>>2]|0;b:while(1){if(j){f=c[j+12>>2]|0;if((f|0)==(c[j+16>>2]|0)){o=0;f=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;m=o;o=0;if(m&1){C=25;break}}else f=c[f>>2]|0;if((f|0)==-1){c[d>>2]=0;f=0;k=1}else{f=j;k=0}}else{f=0;k=1}l=c[e>>2]|0;do if(l){j=c[l+12>>2]|0;if((j|0)==(c[l+16>>2]|0)){o=0;j=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;m=o;o=0;if(m&1){C=25;break b}}else j=c[j>>2]|0;if((j|0)!=-1)if(k)break;else{j=l;break b}else{c[e>>2]=0;C=17;break}}else C=17;while(0);if((C|0)==17){C=0;if(k){j=0;break}else l=0}j=a[A>>0]|0;j=(j&1)==0?(j&255)>>>1:c[r>>2]|0;if((c[u>>2]|0)==(b+j|0)){o=0;mb(80,A|0,j<<1|0,0);m=o;o=0;if(m&1){C=25;break}if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);m=o;o=0;if(m&1){C=25;break}b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b+j}k=f+12|0;j=c[k>>2]|0;m=f+16|0;if((j|0)==(c[m>>2]|0)){o=0;j=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;D=o;o=0;if(D&1){C=25;break}}else j=c[j>>2]|0;if(FE(j,t,b,u,v,n,B,x,y,s)|0){j=l;break}j=c[k>>2]|0;if((j|0)==(c[m>>2]|0)){o=0;qa(c[(c[f>>2]|0)+40>>2]|0,f|0)|0;D=o;o=0;if(D&1){C=25;break}else{j=f;continue}}else{c[k>>2]=j+4;j=f;continue}}if((C|0)==25){b=cc()|0;break}D=a[B>>0]|0;if((((D&1)==0?(D&255)>>>1:c[B+4>>2]|0)|0)!=0?(w=c[y>>2]|0,(w-x|0)<160):0){D=c[v>>2]|0;c[y>>2]=w+4;c[w>>2]=D}o=0;b=kb(69,b|0,c[u>>2]|0,g|0,t|0)|0;D=o;o=0;if(!(D&1)){c[h>>2]=b;oH(B,x,c[y>>2]|0,g);if(f){b=c[f+12>>2]|0;if((b|0)==(c[f+16>>2]|0)){o=0;b=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;D=o;o=0;if(D&1){C=26;break}}else b=c[b>>2]|0;if((b|0)==-1){c[d>>2]=0;f=1}else f=0}else f=1;do if(j){b=c[j+12>>2]|0;if((b|0)==(c[j+16>>2]|0)){o=0;b=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;D=o;o=0;if(D&1){C=26;break a}}else b=c[b>>2]|0;if((b|0)!=-1)if(f)break;else{C=53;break}else{c[e>>2]=0;C=51;break}}else C=51;while(0);if((C|0)==51?f:0)C=53;if((C|0)==53)c[g>>2]=c[g>>2]|2;D=c[d>>2]|0;IC(A);IC(B);i=z;return D|0}else C=26}else C=26;while(0);if((C|0)==26)b=cc()|0;IC(A);IC(B);bc(b|0);return 0}function eK(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0;z=i;i=i+320|0;s=z+208|0;j=z+200|0;B=z+24|0;A=z+12|0;u=z+8|0;x=z+40|0;y=z+4|0;v=z;t=DJ(f)|0;JE(B,f,s,j);c[A>>2]=0;c[A+4>>2]=0;c[A+8>>2]=0;if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);r=o;o=0;a:do if(!(r&1)){p=A+8|0;q=A+1|0;b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b;c[y>>2]=x;c[v>>2]=0;r=A+4|0;n=c[j>>2]|0;j=c[d>>2]|0;b:while(1){if(j){f=c[j+12>>2]|0;if((f|0)==(c[j+16>>2]|0)){o=0;f=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;m=o;o=0;if(m&1){C=25;break}}else f=c[f>>2]|0;if((f|0)==-1){c[d>>2]=0;j=0;l=1}else l=0}else{j=0;l=1}k=c[e>>2]|0;do if(k){f=c[k+12>>2]|0;if((f|0)==(c[k+16>>2]|0)){o=0;f=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;m=o;o=0;if(m&1){C=25;break b}}else f=c[f>>2]|0;if((f|0)!=-1)if(l)break;else break b;else{c[e>>2]=0;C=17;break}}else C=17;while(0);if((C|0)==17){C=0;if(l){k=0;break}else k=0}f=a[A>>0]|0;f=(f&1)==0?(f&255)>>>1:c[r>>2]|0;if((c[u>>2]|0)==(b+f|0)){o=0;mb(80,A|0,f<<1|0,0);m=o;o=0;if(m&1){C=25;break}if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);m=o;o=0;if(m&1){C=25;break}b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b+f}l=j+12|0;f=c[l>>2]|0;m=j+16|0;if((f|0)==(c[m>>2]|0)){o=0;f=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;E=o;o=0;if(E&1){C=25;break}}else f=c[f>>2]|0;if(FE(f,t,b,u,v,n,B,x,y,s)|0)break;f=c[l>>2]|0;if((f|0)==(c[m>>2]|0)){o=0;qa(c[(c[j>>2]|0)+40>>2]|0,j|0)|0;E=o;o=0;if(E&1){C=25;break}else continue}else{c[l>>2]=f+4;continue}}if((C|0)==25){b=cc()|0;break}E=a[B>>0]|0;if((((E&1)==0?(E&255)>>>1:c[B+4>>2]|0)|0)!=0?(w=c[y>>2]|0,(w-x|0)<160):0){E=c[v>>2]|0;c[y>>2]=w+4;c[w>>2]=E}o=0;b=kb(70,b|0,c[u>>2]|0,g|0,t|0)|0;f=D;E=o;o=0;if(!(E&1)){E=h;c[E>>2]=b;c[E+4>>2]=f;oH(B,x,c[y>>2]|0,g);if(j){b=c[j+12>>2]|0;if((b|0)==(c[j+16>>2]|0)){o=0;b=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;E=o;o=0;if(E&1){C=26;break}}else b=c[b>>2]|0;if((b|0)==-1){c[d>>2]=0;f=1}else f=0}else f=1;do if(k){b=c[k+12>>2]|0;if((b|0)==(c[k+16>>2]|0)){o=0;b=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;E=o;o=0;if(E&1){C=26;break a}}else b=c[b>>2]|0;if((b|0)!=-1)if(f)break;else{C=53;break}else{c[e>>2]=0;C=51;break}}else C=51;while(0);if((C|0)==51?f:0)C=53;if((C|0)==53)c[g>>2]=c[g>>2]|2;E=c[d>>2]|0;IC(A);IC(B);i=z;return E|0}else C=26}else C=26;while(0);if((C|0)==26)b=cc()|0;IC(A);IC(B);bc(b|0);return 0}function fK(d,e,f,g,h,j){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0;A=i;i=i+320|0;t=A+208|0;k=A+200|0;C=A+24|0;B=A+12|0;v=A+8|0;y=A+40|0;z=A+4|0;w=A;u=DJ(g)|0;JE(C,g,t,k);c[B>>2]=0;c[B+4>>2]=0;c[B+8>>2]=0;if(!(a[B>>0]&1))d=10;else d=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,d|0,0);s=o;o=0;a:do if(!(s&1)){q=B+8|0;r=B+1|0;d=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=d;c[z>>2]=y;c[w>>2]=0;s=B+4|0;p=c[k>>2]|0;k=c[e>>2]|0;b:while(1){if(k){g=c[k+12>>2]|0;if((g|0)==(c[k+16>>2]|0)){o=0;g=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;n=o;o=0;if(n&1){D=25;break}}else g=c[g>>2]|0;if((g|0)==-1){c[e>>2]=0;g=0;l=1}else{g=k;l=0}}else{g=0;l=1}m=c[f>>2]|0;do if(m){k=c[m+12>>2]|0;if((k|0)==(c[m+16>>2]|0)){o=0;k=qa(c[(c[m>>2]|0)+36>>2]|0,m|0)|0;n=o;o=0;if(n&1){D=25;break b}}else k=c[k>>2]|0;if((k|0)!=-1)if(l)break;else{k=m;break b}else{c[f>>2]=0;D=17;break}}else D=17;while(0);if((D|0)==17){D=0;if(l){k=0;break}else m=0}k=a[B>>0]|0;k=(k&1)==0?(k&255)>>>1:c[s>>2]|0;if((c[v>>2]|0)==(d+k|0)){o=0;mb(80,B|0,k<<1|0,0);n=o;o=0;if(n&1){D=25;break}if(!(a[B>>0]&1))d=10;else d=(c[B>>2]&-2)+-1|0;o=0;mb(80,B|0,d|0,0);n=o;o=0;if(n&1){D=25;break}d=(a[B>>0]&1)==0?r:c[q>>2]|0;c[v>>2]=d+k}l=g+12|0;k=c[l>>2]|0;n=g+16|0;if((k|0)==(c[n>>2]|0)){o=0;k=qa(c[(c[g>>2]|0)+36>>2]|0,g|0)|0;E=o;o=0;if(E&1){D=25;break}}else k=c[k>>2]|0;if(FE(k,u,d,v,w,p,C,y,z,t)|0){k=m;break}k=c[l>>2]|0;if((k|0)==(c[n>>2]|0)){o=0;qa(c[(c[g>>2]|0)+40>>2]|0,g|0)|0;E=o;o=0;if(E&1){D=25;break}else{k=g;continue}}else{c[l>>2]=k+4;k=g;continue}}if((D|0)==25){d=cc()|0;break}E=a[C>>0]|0;if((((E&1)==0?(E&255)>>>1:c[C+4>>2]|0)|0)!=0?(x=c[z>>2]|0,(x-y|0)<160):0){E=c[w>>2]|0;c[z>>2]=x+4;c[x>>2]=E}o=0;d=kb(71,d|0,c[v>>2]|0,h|0,u|0)|0;E=o;o=0;if(!(E&1)){b[j>>1]=d;oH(C,y,c[z>>2]|0,h);if(g){d=c[g+12>>2]|0;if((d|0)==(c[g+16>>2]|0)){o=0;d=qa(c[(c[g>>2]|0)+36>>2]|0,g|0)|0;E=o;o=0;if(E&1){D=26;break}}else d=c[d>>2]|0;if((d|0)==-1){c[e>>2]=0;g=1}else g=0}else g=1;do if(k){d=c[k+12>>2]|0;if((d|0)==(c[k+16>>2]|0)){o=0;d=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;E=o;o=0;if(E&1){D=26;break a}}else d=c[d>>2]|0;if((d|0)!=-1)if(g)break;else{D=53;break}else{c[f>>2]=0;D=51;break}}else D=51;while(0);if((D|0)==51?g:0)D=53;if((D|0)==53)c[h>>2]=c[h>>2]|2;E=c[e>>2]|0;IC(B);IC(C);i=A;return E|0}else D=26}else D=26;while(0);if((D|0)==26)d=cc()|0;IC(B);IC(C);bc(d|0);return 0}function gK(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;z=i;i=i+320|0;s=z+208|0;j=z+200|0;B=z+24|0;A=z+12|0;u=z+8|0;x=z+40|0;y=z+4|0;v=z;t=DJ(f)|0;JE(B,f,s,j);c[A>>2]=0;c[A+4>>2]=0;c[A+8>>2]=0;if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);r=o;o=0;a:do if(!(r&1)){p=A+8|0;q=A+1|0;b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b;c[y>>2]=x;c[v>>2]=0;r=A+4|0;n=c[j>>2]|0;j=c[d>>2]|0;b:while(1){if(j){f=c[j+12>>2]|0;if((f|0)==(c[j+16>>2]|0)){o=0;f=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;m=o;o=0;if(m&1){C=25;break}}else f=c[f>>2]|0;if((f|0)==-1){c[d>>2]=0;f=0;k=1}else{f=j;k=0}}else{f=0;k=1}l=c[e>>2]|0;do if(l){j=c[l+12>>2]|0;if((j|0)==(c[l+16>>2]|0)){o=0;j=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;m=o;o=0;if(m&1){C=25;break b}}else j=c[j>>2]|0;if((j|0)!=-1)if(k)break;else{j=l;break b}else{c[e>>2]=0;C=17;break}}else C=17;while(0);if((C|0)==17){C=0;if(k){j=0;break}else l=0}j=a[A>>0]|0;j=(j&1)==0?(j&255)>>>1:c[r>>2]|0;if((c[u>>2]|0)==(b+j|0)){o=0;mb(80,A|0,j<<1|0,0);m=o;o=0;if(m&1){C=25;break}if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);m=o;o=0;if(m&1){C=25;break}b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b+j}k=f+12|0;j=c[k>>2]|0;m=f+16|0;if((j|0)==(c[m>>2]|0)){o=0;j=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;D=o;o=0;if(D&1){C=25;break}}else j=c[j>>2]|0;if(FE(j,t,b,u,v,n,B,x,y,s)|0){j=l;break}j=c[k>>2]|0;if((j|0)==(c[m>>2]|0)){o=0;qa(c[(c[f>>2]|0)+40>>2]|0,f|0)|0;D=o;o=0;if(D&1){C=25;break}else{j=f;continue}}else{c[k>>2]=j+4;j=f;continue}}if((C|0)==25){b=cc()|0;break}D=a[B>>0]|0;if((((D&1)==0?(D&255)>>>1:c[B+4>>2]|0)|0)!=0?(w=c[y>>2]|0,(w-x|0)<160):0){D=c[v>>2]|0;c[y>>2]=w+4;c[w>>2]=D}o=0;b=kb(72,b|0,c[u>>2]|0,g|0,t|0)|0;D=o;o=0;if(!(D&1)){c[h>>2]=b;oH(B,x,c[y>>2]|0,g);if(f){b=c[f+12>>2]|0;if((b|0)==(c[f+16>>2]|0)){o=0;b=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;D=o;o=0;if(D&1){C=26;break}}else b=c[b>>2]|0;if((b|0)==-1){c[d>>2]=0;f=1}else f=0}else f=1;do if(j){b=c[j+12>>2]|0;if((b|0)==(c[j+16>>2]|0)){o=0;b=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;D=o;o=0;if(D&1){C=26;break a}}else b=c[b>>2]|0;if((b|0)!=-1)if(f)break;else{C=53;break}else{c[e>>2]=0;C=51;break}}else C=51;while(0);if((C|0)==51?f:0)C=53;if((C|0)==53)c[g>>2]=c[g>>2]|2;D=c[d>>2]|0;IC(A);IC(B);i=z;return D|0}else C=26}else C=26;while(0);if((C|0)==26)b=cc()|0;IC(A);IC(B);bc(b|0);return 0}function hK(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;z=i;i=i+320|0;s=z+208|0;j=z+200|0;B=z+24|0;A=z+12|0;u=z+8|0;x=z+40|0;y=z+4|0;v=z;t=DJ(f)|0;JE(B,f,s,j);c[A>>2]=0;c[A+4>>2]=0;c[A+8>>2]=0;if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);r=o;o=0;a:do if(!(r&1)){p=A+8|0;q=A+1|0;b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b;c[y>>2]=x;c[v>>2]=0;r=A+4|0;n=c[j>>2]|0;j=c[d>>2]|0;b:while(1){if(j){f=c[j+12>>2]|0;if((f|0)==(c[j+16>>2]|0)){o=0;f=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;m=o;o=0;if(m&1){C=25;break}}else f=c[f>>2]|0;if((f|0)==-1){c[d>>2]=0;f=0;k=1}else{f=j;k=0}}else{f=0;k=1}l=c[e>>2]|0;do if(l){j=c[l+12>>2]|0;if((j|0)==(c[l+16>>2]|0)){o=0;j=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;m=o;o=0;if(m&1){C=25;break b}}else j=c[j>>2]|0;if((j|0)!=-1)if(k)break;else{j=l;break b}else{c[e>>2]=0;C=17;break}}else C=17;while(0);if((C|0)==17){C=0;if(k){j=0;break}else l=0}j=a[A>>0]|0;j=(j&1)==0?(j&255)>>>1:c[r>>2]|0;if((c[u>>2]|0)==(b+j|0)){o=0;mb(80,A|0,j<<1|0,0);m=o;o=0;if(m&1){C=25;break}if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);m=o;o=0;if(m&1){C=25;break}b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b+j}k=f+12|0;j=c[k>>2]|0;m=f+16|0;if((j|0)==(c[m>>2]|0)){o=0;j=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;D=o;o=0;if(D&1){C=25;break}}else j=c[j>>2]|0;if(FE(j,t,b,u,v,n,B,x,y,s)|0){j=l;break}j=c[k>>2]|0;if((j|0)==(c[m>>2]|0)){o=0;qa(c[(c[f>>2]|0)+40>>2]|0,f|0)|0;D=o;o=0;if(D&1){C=25;break}else{j=f;continue}}else{c[k>>2]=j+4;j=f;continue}}if((C|0)==25){b=cc()|0;break}D=a[B>>0]|0;if((((D&1)==0?(D&255)>>>1:c[B+4>>2]|0)|0)!=0?(w=c[y>>2]|0,(w-x|0)<160):0){D=c[v>>2]|0;c[y>>2]=w+4;c[w>>2]=D}o=0;b=kb(73,b|0,c[u>>2]|0,g|0,t|0)|0;D=o;o=0;if(!(D&1)){c[h>>2]=b;oH(B,x,c[y>>2]|0,g);if(f){b=c[f+12>>2]|0;if((b|0)==(c[f+16>>2]|0)){o=0;b=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;D=o;o=0;if(D&1){C=26;break}}else b=c[b>>2]|0;if((b|0)==-1){c[d>>2]=0;f=1}else f=0}else f=1;do if(j){b=c[j+12>>2]|0;if((b|0)==(c[j+16>>2]|0)){o=0;b=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;D=o;o=0;if(D&1){C=26;break a}}else b=c[b>>2]|0;if((b|0)!=-1)if(f)break;else{C=53;break}else{c[e>>2]=0;C=51;break}}else C=51;while(0);if((C|0)==51?f:0)C=53;if((C|0)==53)c[g>>2]=c[g>>2]|2;D=c[d>>2]|0;IC(A);IC(B);i=z;return D|0}else C=26}else C=26;while(0);if((C|0)==26)b=cc()|0;IC(A);IC(B);bc(b|0);return 0}function iK(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0;z=i;i=i+320|0;s=z+208|0;j=z+200|0;B=z+24|0;A=z+12|0;u=z+8|0;x=z+40|0;y=z+4|0;v=z;t=DJ(f)|0;JE(B,f,s,j);c[A>>2]=0;c[A+4>>2]=0;c[A+8>>2]=0;if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);r=o;o=0;a:do if(!(r&1)){p=A+8|0;q=A+1|0;b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b;c[y>>2]=x;c[v>>2]=0;r=A+4|0;n=c[j>>2]|0;j=c[d>>2]|0;b:while(1){if(j){f=c[j+12>>2]|0;if((f|0)==(c[j+16>>2]|0)){o=0;f=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;m=o;o=0;if(m&1){C=25;break}}else f=c[f>>2]|0;if((f|0)==-1){c[d>>2]=0;j=0;l=1}else l=0}else{j=0;l=1}k=c[e>>2]|0;do if(k){f=c[k+12>>2]|0;if((f|0)==(c[k+16>>2]|0)){o=0;f=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;m=o;o=0;if(m&1){C=25;break b}}else f=c[f>>2]|0;if((f|0)!=-1)if(l)break;else break b;else{c[e>>2]=0;C=17;break}}else C=17;while(0);if((C|0)==17){C=0;if(l){k=0;break}else k=0}f=a[A>>0]|0;f=(f&1)==0?(f&255)>>>1:c[r>>2]|0;if((c[u>>2]|0)==(b+f|0)){o=0;mb(80,A|0,f<<1|0,0);m=o;o=0;if(m&1){C=25;break}if(!(a[A>>0]&1))b=10;else b=(c[A>>2]&-2)+-1|0;o=0;mb(80,A|0,b|0,0);m=o;o=0;if(m&1){C=25;break}b=(a[A>>0]&1)==0?q:c[p>>2]|0;c[u>>2]=b+f}l=j+12|0;f=c[l>>2]|0;m=j+16|0;if((f|0)==(c[m>>2]|0)){o=0;f=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;E=o;o=0;if(E&1){C=25;break}}else f=c[f>>2]|0;if(FE(f,t,b,u,v,n,B,x,y,s)|0)break;f=c[l>>2]|0;if((f|0)==(c[m>>2]|0)){o=0;qa(c[(c[j>>2]|0)+40>>2]|0,j|0)|0;E=o;o=0;if(E&1){C=25;break}else continue}else{c[l>>2]=f+4;continue}}if((C|0)==25){b=cc()|0;break}E=a[B>>0]|0;if((((E&1)==0?(E&255)>>>1:c[B+4>>2]|0)|0)!=0?(w=c[y>>2]|0,(w-x|0)<160):0){E=c[v>>2]|0;c[y>>2]=w+4;c[w>>2]=E}o=0;b=kb(74,b|0,c[u>>2]|0,g|0,t|0)|0;f=D;E=o;o=0;if(!(E&1)){E=h;c[E>>2]=b;c[E+4>>2]=f;oH(B,x,c[y>>2]|0,g);if(j){b=c[j+12>>2]|0;if((b|0)==(c[j+16>>2]|0)){o=0;b=qa(c[(c[j>>2]|0)+36>>2]|0,j|0)|0;E=o;o=0;if(E&1){C=26;break}}else b=c[b>>2]|0;if((b|0)==-1){c[d>>2]=0;f=1}else f=0}else f=1;do if(k){b=c[k+12>>2]|0;if((b|0)==(c[k+16>>2]|0)){o=0;b=qa(c[(c[k>>2]|0)+36>>2]|0,k|0)|0;E=o;o=0;if(E&1){C=26;break a}}else b=c[b>>2]|0;if((b|0)!=-1)if(f)break;else{C=53;break}else{c[e>>2]=0;C=51;break}}else C=51;while(0);if((C|0)==51?f:0)C=53;if((C|0)==53)c[g>>2]=c[g>>2]|2;E=c[d>>2]|0;IC(A);IC(B);i=z;return E|0}else C=26}else C=26;while(0);if((C|0)==26)b=cc()|0;IC(A);IC(B);bc(b|0);return 0}function jK(b,d,e,f,h,j){b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0.0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0;D=i;i=i+352|0;v=D+208|0;l=D+40|0;m=D+36|0;F=D+24|0;E=D+12|0;x=D+8|0;B=D+48|0;C=D+4|0;y=D;z=D+337|0;w=D+336|0;KE(F,f,v,l,m);c[E>>2]=0;c[E+4>>2]=0;c[E+8>>2]=0;if(!(a[E>>0]&1))b=10;else b=(c[E>>2]&-2)+-1|0;o=0;mb(80,E|0,b|0,0);u=o;o=0;a:do if(!(u&1)){s=E+8|0;t=E+1|0;b=(a[E>>0]&1)==0?t:c[s>>2]|0;c[x>>2]=b;c[C>>2]=B;c[y>>2]=0;a[z>>0]=1;a[w>>0]=69;u=E+4|0;r=c[l>>2]|0;q=c[m>>2]|0;f=c[d>>2]|0;b:while(1){if(f){l=c[f+12>>2]|0;if((l|0)==(c[f+16>>2]|0)){o=0;l=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;p=o;o=0;if(p&1){G=25;break}}else l=c[l>>2]|0;if((l|0)==-1){c[d>>2]=0;f=0;n=1}else n=0}else{f=0;n=1}l=c[e>>2]|0;do if(l){m=c[l+12>>2]|0;if((m|0)==(c[l+16>>2]|0)){o=0;m=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;p=o;o=0;if(p&1){G=25;break b}}else m=c[m>>2]|0;if((m|0)!=-1)if(n)break;else break b;else{c[e>>2]=0;G=17;break}}else G=17;while(0);if((G|0)==17){G=0;if(n){l=0;break}else l=0}m=a[E>>0]|0;m=(m&1)==0?(m&255)>>>1:c[u>>2]|0;if((c[x>>2]|0)==(b+m|0)){o=0;mb(80,E|0,m<<1|0,0);p=o;o=0;if(p&1){G=25;break}if(!(a[E>>0]&1))b=10;else b=(c[E>>2]&-2)+-1|0;o=0;mb(80,E|0,b|0,0);p=o;o=0;if(p&1){G=25;break}b=(a[E>>0]&1)==0?t:c[s>>2]|0;c[x>>2]=b+m}n=f+12|0;m=c[n>>2]|0;p=f+16|0;if((m|0)==(c[p>>2]|0)){o=0;m=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;H=o;o=0;if(H&1){G=25;break}}else m=c[m>>2]|0;if(LE(m,z,w,b,x,r,q,F,B,C,y,v)|0)break;l=c[n>>2]|0;if((l|0)==(c[p>>2]|0)){o=0;qa(c[(c[f>>2]|0)+40>>2]|0,f|0)|0;H=o;o=0;if(H&1){G=25;break}else continue}else{c[n>>2]=l+4;continue}}if((G|0)==25){b=cc()|0;break}H=a[F>>0]|0;if(!((a[z>>0]|0)==0?1:(((H&1)==0?(H&255)>>>1:c[F+4>>2]|0)|0)==0)?(A=c[C>>2]|0,(A-B|0)<160):0){H=c[y>>2]|0;c[C>>2]=A+4;c[A>>2]=H}o=0;k=+_a(44,b|0,c[x>>2]|0,h|0);H=o;o=0;if(!(H&1)){g[j>>2]=k;oH(F,B,c[C>>2]|0,h);if(f){b=c[f+12>>2]|0;if((b|0)==(c[f+16>>2]|0)){o=0;b=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;H=o;o=0;if(H&1){G=26;break}}else b=c[b>>2]|0;if((b|0)==-1){c[d>>2]=0;f=1}else f=0}else f=1;do if(l){b=c[l+12>>2]|0;if((b|0)==(c[l+16>>2]|0)){o=0;b=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;H=o;o=0;if(H&1){G=26;break a}}else b=c[b>>2]|0;if((b|0)!=-1)if(f)break;else{G=53;break}else{c[e>>2]=0;G=51;break}}else G=51;while(0);if((G|0)==51?f:0)G=53;if((G|0)==53)c[h>>2]=c[h>>2]|2;H=c[d>>2]|0;IC(E);IC(F);i=D;return H|0}else G=26}else G=26;while(0);if((G|0)==26)b=cc()|0;IC(E);IC(F);bc(b|0);return 0}function kK(b,d,e,f,g,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;j=j|0;var k=0.0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0;D=i;i=i+352|0;v=D+208|0;l=D+40|0;m=D+36|0;F=D+24|0;E=D+12|0;x=D+8|0;B=D+48|0;C=D+4|0;y=D;z=D+337|0;w=D+336|0;KE(F,f,v,l,m);c[E>>2]=0;c[E+4>>2]=0;c[E+8>>2]=0;if(!(a[E>>0]&1))b=10;else b=(c[E>>2]&-2)+-1|0;o=0;mb(80,E|0,b|0,0);u=o;o=0;a:do if(!(u&1)){s=E+8|0;t=E+1|0;b=(a[E>>0]&1)==0?t:c[s>>2]|0;c[x>>2]=b;c[C>>2]=B;c[y>>2]=0;a[z>>0]=1;a[w>>0]=69;u=E+4|0;r=c[l>>2]|0;q=c[m>>2]|0;f=c[d>>2]|0;b:while(1){if(f){l=c[f+12>>2]|0;if((l|0)==(c[f+16>>2]|0)){o=0;l=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;p=o;o=0;if(p&1){G=25;break}}else l=c[l>>2]|0;if((l|0)==-1){c[d>>2]=0;f=0;n=1}else n=0}else{f=0;n=1}l=c[e>>2]|0;do if(l){m=c[l+12>>2]|0;if((m|0)==(c[l+16>>2]|0)){o=0;m=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;p=o;o=0;if(p&1){G=25;break b}}else m=c[m>>2]|0;if((m|0)!=-1)if(n)break;else break b;else{c[e>>2]=0;G=17;break}}else G=17;while(0);if((G|0)==17){G=0;if(n){l=0;break}else l=0}m=a[E>>0]|0;m=(m&1)==0?(m&255)>>>1:c[u>>2]|0;if((c[x>>2]|0)==(b+m|0)){o=0;mb(80,E|0,m<<1|0,0);p=o;o=0;if(p&1){G=25;break}if(!(a[E>>0]&1))b=10;else b=(c[E>>2]&-2)+-1|0;o=0;mb(80,E|0,b|0,0);p=o;o=0;if(p&1){G=25;break}b=(a[E>>0]&1)==0?t:c[s>>2]|0;c[x>>2]=b+m}n=f+12|0;m=c[n>>2]|0;p=f+16|0;if((m|0)==(c[p>>2]|0)){o=0;m=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;H=o;o=0;if(H&1){G=25;break}}else m=c[m>>2]|0;if(LE(m,z,w,b,x,r,q,F,B,C,y,v)|0)break;l=c[n>>2]|0;if((l|0)==(c[p>>2]|0)){o=0;qa(c[(c[f>>2]|0)+40>>2]|0,f|0)|0;H=o;o=0;if(H&1){G=25;break}else continue}else{c[n>>2]=l+4;continue}}if((G|0)==25){b=cc()|0;break}H=a[F>>0]|0;if(!((a[z>>0]|0)==0?1:(((H&1)==0?(H&255)>>>1:c[F+4>>2]|0)|0)==0)?(A=c[C>>2]|0,(A-B|0)<160):0){H=c[y>>2]|0;c[C>>2]=A+4;c[A>>2]=H}o=0;k=+_a(45,b|0,c[x>>2]|0,g|0);H=o;o=0;if(!(H&1)){h[j>>3]=k;oH(F,B,c[C>>2]|0,g);if(f){b=c[f+12>>2]|0;if((b|0)==(c[f+16>>2]|0)){o=0;b=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;H=o;o=0;if(H&1){G=26;break}}else b=c[b>>2]|0;if((b|0)==-1){c[d>>2]=0;f=1}else f=0}else f=1;do if(l){b=c[l+12>>2]|0;if((b|0)==(c[l+16>>2]|0)){o=0;b=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;H=o;o=0;if(H&1){G=26;break a}}else b=c[b>>2]|0;if((b|0)!=-1)if(f)break;else{G=53;break}else{c[e>>2]=0;G=51;break}}else G=51;while(0);if((G|0)==51?f:0)G=53;if((G|0)==53)c[g>>2]=c[g>>2]|2;H=c[d>>2]|0;IC(E);IC(F);i=D;return H|0}else G=26}else G=26;while(0);if((G|0)==26)b=cc()|0;IC(E);IC(F);bc(b|0);return 0}
function lK(b,d,e,f,g,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;j=j|0;var k=0.0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0;D=i;i=i+352|0;v=D+208|0;l=D+40|0;m=D+36|0;F=D+24|0;E=D+12|0;x=D+8|0;B=D+48|0;C=D+4|0;y=D;z=D+337|0;w=D+336|0;KE(F,f,v,l,m);c[E>>2]=0;c[E+4>>2]=0;c[E+8>>2]=0;if(!(a[E>>0]&1))b=10;else b=(c[E>>2]&-2)+-1|0;o=0;mb(80,E|0,b|0,0);u=o;o=0;a:do if(!(u&1)){s=E+8|0;t=E+1|0;b=(a[E>>0]&1)==0?t:c[s>>2]|0;c[x>>2]=b;c[C>>2]=B;c[y>>2]=0;a[z>>0]=1;a[w>>0]=69;u=E+4|0;r=c[l>>2]|0;q=c[m>>2]|0;f=c[d>>2]|0;b:while(1){if(f){l=c[f+12>>2]|0;if((l|0)==(c[f+16>>2]|0)){o=0;l=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;p=o;o=0;if(p&1){G=25;break}}else l=c[l>>2]|0;if((l|0)==-1){c[d>>2]=0;f=0;n=1}else n=0}else{f=0;n=1}l=c[e>>2]|0;do if(l){m=c[l+12>>2]|0;if((m|0)==(c[l+16>>2]|0)){o=0;m=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;p=o;o=0;if(p&1){G=25;break b}}else m=c[m>>2]|0;if((m|0)!=-1)if(n)break;else break b;else{c[e>>2]=0;G=17;break}}else G=17;while(0);if((G|0)==17){G=0;if(n){l=0;break}else l=0}m=a[E>>0]|0;m=(m&1)==0?(m&255)>>>1:c[u>>2]|0;if((c[x>>2]|0)==(b+m|0)){o=0;mb(80,E|0,m<<1|0,0);p=o;o=0;if(p&1){G=25;break}if(!(a[E>>0]&1))b=10;else b=(c[E>>2]&-2)+-1|0;o=0;mb(80,E|0,b|0,0);p=o;o=0;if(p&1){G=25;break}b=(a[E>>0]&1)==0?t:c[s>>2]|0;c[x>>2]=b+m}n=f+12|0;m=c[n>>2]|0;p=f+16|0;if((m|0)==(c[p>>2]|0)){o=0;m=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;H=o;o=0;if(H&1){G=25;break}}else m=c[m>>2]|0;if(LE(m,z,w,b,x,r,q,F,B,C,y,v)|0)break;l=c[n>>2]|0;if((l|0)==(c[p>>2]|0)){o=0;qa(c[(c[f>>2]|0)+40>>2]|0,f|0)|0;H=o;o=0;if(H&1){G=25;break}else continue}else{c[n>>2]=l+4;continue}}if((G|0)==25){b=cc()|0;break}H=a[F>>0]|0;if(!((a[z>>0]|0)==0?1:(((H&1)==0?(H&255)>>>1:c[F+4>>2]|0)|0)==0)?(A=c[C>>2]|0,(A-B|0)<160):0){H=c[y>>2]|0;c[C>>2]=A+4;c[A>>2]=H}o=0;k=+_a(46,b|0,c[x>>2]|0,g|0);H=o;o=0;if(!(H&1)){h[j>>3]=k;oH(F,B,c[C>>2]|0,g);if(f){b=c[f+12>>2]|0;if((b|0)==(c[f+16>>2]|0)){o=0;b=qa(c[(c[f>>2]|0)+36>>2]|0,f|0)|0;H=o;o=0;if(H&1){G=26;break}}else b=c[b>>2]|0;if((b|0)==-1){c[d>>2]=0;f=1}else f=0}else f=1;do if(l){b=c[l+12>>2]|0;if((b|0)==(c[l+16>>2]|0)){o=0;b=qa(c[(c[l>>2]|0)+36>>2]|0,l|0)|0;H=o;o=0;if(H&1){G=26;break a}}else b=c[b>>2]|0;if((b|0)!=-1)if(f)break;else{G=53;break}else{c[e>>2]=0;G=51;break}}else G=51;while(0);if((G|0)==51?f:0)G=53;if((G|0)==53)c[g>>2]=c[g>>2]|2;H=c[d>>2]|0;IC(E);IC(F);i=D;return H|0}else G=26}else G=26;while(0);if((G|0)==26)b=cc()|0;IC(E);IC(F);bc(b|0);return 0}function mK(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;g=i;i=i+16|0;h=g;c[h>>2]=f;f=lB(d)|0;d=XB(a,b,e,h)|0;if((f|0)!=0?(o=0,qa(193,f|0)|0,h=o,o=0,h&1):0){h=cc(0)|0;oq(h)}i=g;return d|0}function nK(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0;f=i;i=i+16|0;g=f;c[g>>2]=e;e=lB(b)|0;o=0;b=ya(127,a|0,d|0,g|0)|0;a=o;o=0;if(a&1){b=cc()|0;if((e|0)!=0?(o=0,qa(193,e|0)|0,g=o,o=0,g&1):0){g=cc(0)|0;oq(g)}bc(b|0)}else{if((e|0)!=0?(o=0,qa(193,e|0)|0,g=o,o=0,g&1):0){g=cc(0)|0;oq(g)}i=f;return b|0}return 0}function oK(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0;p=i;i=i+16|0;n=p;j=c[b>>2]|0;a:do if(!j)j=0;else{q=d;l=f-q>>2;m=g+12|0;k=c[m>>2]|0;l=(k|0)>(l|0)?k-l|0:0;k=e;q=k-q|0;g=q>>2;if((q|0)>0?(fd[c[(c[j>>2]|0)+48>>2]&127](j,d,g)|0)!=(g|0):0){c[b>>2]=0;j=0;break}do if((l|0)>0){YC(n,l,h);o=0;g=ya(c[(c[j>>2]|0)+48>>2]|0,j|0,((a[n>>0]&1)==0?n+4|0:c[n+8>>2]|0)|0,l|0)|0;q=o;o=0;if(q&1){q=cc()|0;ZC(n);bc(q|0)}if((g|0)==(l|0)){ZC(n);break}else{c[b>>2]=0;ZC(n);j=0;break a}}while(0);q=f-k|0;f=q>>2;if((q|0)>0?(fd[c[(c[j>>2]|0)+48>>2]&127](j,e,f)|0)!=(f|0):0){c[b>>2]=0;j=0;break}c[m>>2]=0}while(0);i=p;return j|0}function pK(a,e,f,g,h){a=a|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;i=c[a>>2]|0;do if(i){if((c[i+12>>2]|0)==(c[i+16>>2]|0))if((bd[c[(c[i>>2]|0)+36>>2]&255](i)|0)==-1){c[a>>2]=0;i=0;break}else{i=c[a>>2]|0;break}}else i=0;while(0);j=(i|0)==0;i=c[e>>2]|0;do if(i){if((c[i+12>>2]|0)==(c[i+16>>2]|0)?(bd[c[(c[i>>2]|0)+36>>2]&255](i)|0)==-1:0){c[e>>2]=0;r=11;break}if(j)r=13;else r=12}else r=11;while(0);if((r|0)==11)if(j)r=12;else{i=0;r=13}a:do if((r|0)==12){c[f>>2]=c[f>>2]|6;i=0}else if((r|0)==13){j=c[a>>2]|0;k=c[j+12>>2]|0;if((k|0)==(c[j+16>>2]|0))j=bd[c[(c[j>>2]|0)+36>>2]&255](j)|0;else j=d[k>>0]|0;k=j&255;if(k<<24>>24>-1?(q=g+8|0,(b[(c[q>>2]|0)+(j<<24>>24<<1)>>1]&2048)!=0):0){m=(fd[c[(c[g>>2]|0)+36>>2]&127](g,k,0)|0)<<24>>24;j=c[a>>2]|0;k=j+12|0;l=c[k>>2]|0;if((l|0)==(c[j+16>>2]|0)){bd[c[(c[j>>2]|0)+40>>2]&255](j)|0;o=h;n=i;h=i;i=m}else{c[k>>2]=l+1;o=h;n=i;h=i;i=m}while(1){i=i+-48|0;p=o+-1|0;j=c[a>>2]|0;do if(j){if((c[j+12>>2]|0)==(c[j+16>>2]|0))if((bd[c[(c[j>>2]|0)+36>>2]&255](j)|0)==-1){c[a>>2]=0;j=0;break}else{j=c[a>>2]|0;break}}else j=0;while(0);l=(j|0)==0;if(h)if((c[h+12>>2]|0)==(c[h+16>>2]|0))if((bd[c[(c[h>>2]|0)+36>>2]&255](h)|0)==-1){c[e>>2]=0;k=0;h=0}else{k=n;h=n}else k=n;else{k=n;h=0}j=c[a>>2]|0;if(!((o|0)>1&(l^(h|0)==0)))break;l=c[j+12>>2]|0;if((l|0)==(c[j+16>>2]|0))j=bd[c[(c[j>>2]|0)+36>>2]&255](j)|0;else j=d[l>>0]|0;l=j&255;if(l<<24>>24<=-1)break a;if(!(b[(c[q>>2]|0)+(j<<24>>24<<1)>>1]&2048))break a;i=((fd[c[(c[g>>2]|0)+36>>2]&127](g,l,0)|0)<<24>>24)+(i*10|0)|0;j=c[a>>2]|0;l=j+12|0;m=c[l>>2]|0;if((m|0)==(c[j+16>>2]|0)){bd[c[(c[j>>2]|0)+40>>2]&255](j)|0;o=p;n=k;continue}else{c[l>>2]=m+1;o=p;n=k;continue}}do if(j){if((c[j+12>>2]|0)==(c[j+16>>2]|0))if((bd[c[(c[j>>2]|0)+36>>2]&255](j)|0)==-1){c[a>>2]=0;j=0;break}else{j=c[a>>2]|0;break}}else j=0;while(0);j=(j|0)==0;do if(k){if((c[k+12>>2]|0)==(c[k+16>>2]|0)?(bd[c[(c[k>>2]|0)+36>>2]&255](k)|0)==-1:0){c[e>>2]=0;r=50;break}if(j)break a}else r=50;while(0);if((r|0)==50?!j:0)break;c[f>>2]=c[f>>2]|2;break}c[f>>2]=c[f>>2]|4;i=0}while(0);return i|0}function qK(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;g=c[a>>2]|0;do if(g){h=c[g+12>>2]|0;if((h|0)==(c[g+16>>2]|0))g=bd[c[(c[g>>2]|0)+36>>2]&255](g)|0;else g=c[h>>2]|0;if((g|0)==-1){c[a>>2]=0;i=1;break}else{i=(c[a>>2]|0)==0;break}}else i=1;while(0);h=c[b>>2]|0;do if(h){g=c[h+12>>2]|0;if((g|0)==(c[h+16>>2]|0))g=bd[c[(c[h>>2]|0)+36>>2]&255](h)|0;else g=c[g>>2]|0;if((g|0)!=-1)if(i){o=17;break}else{o=16;break}else{c[b>>2]=0;o=14;break}}else o=14;while(0);if((o|0)==14)if(i)o=16;else{h=0;o=17}a:do if((o|0)==16){c[d>>2]=c[d>>2]|6;g=0}else if((o|0)==17){g=c[a>>2]|0;i=c[g+12>>2]|0;if((i|0)==(c[g+16>>2]|0))g=bd[c[(c[g>>2]|0)+36>>2]&255](g)|0;else g=c[i>>2]|0;if(!(fd[c[(c[e>>2]|0)+12>>2]&127](e,2048,g)|0)){c[d>>2]=c[d>>2]|4;g=0;break}g=(fd[c[(c[e>>2]|0)+52>>2]&127](e,g,0)|0)<<24>>24;i=c[a>>2]|0;j=i+12|0;k=c[j>>2]|0;if((k|0)==(c[i+16>>2]|0)){bd[c[(c[i>>2]|0)+40>>2]&255](i)|0;m=f;l=h;j=h}else{c[j>>2]=k+4;m=f;l=h;j=h}while(1){g=g+-48|0;n=m+-1|0;h=c[a>>2]|0;do if(h){i=c[h+12>>2]|0;if((i|0)==(c[h+16>>2]|0))h=bd[c[(c[h>>2]|0)+36>>2]&255](h)|0;else h=c[i>>2]|0;if((h|0)==-1){c[a>>2]=0;k=1;break}else{k=(c[a>>2]|0)==0;break}}else k=1;while(0);do if(j){h=c[j+12>>2]|0;if((h|0)==(c[j+16>>2]|0))h=bd[c[(c[j>>2]|0)+36>>2]&255](j)|0;else h=c[h>>2]|0;if((h|0)==-1){c[b>>2]=0;j=0;f=0;h=1;break}else{j=l;f=l;h=(l|0)==0;break}}else{j=l;f=0;h=1}while(0);i=c[a>>2]|0;if(!((m|0)>1&(k^h)))break;h=c[i+12>>2]|0;if((h|0)==(c[i+16>>2]|0))h=bd[c[(c[i>>2]|0)+36>>2]&255](i)|0;else h=c[h>>2]|0;if(!(fd[c[(c[e>>2]|0)+12>>2]&127](e,2048,h)|0))break a;g=((fd[c[(c[e>>2]|0)+52>>2]&127](e,h,0)|0)<<24>>24)+(g*10|0)|0;h=c[a>>2]|0;i=h+12|0;k=c[i>>2]|0;if((k|0)==(c[h+16>>2]|0)){bd[c[(c[h>>2]|0)+40>>2]&255](h)|0;m=n;l=j;j=f;continue}else{c[i>>2]=k+4;m=n;l=j;j=f;continue}}do if(i){h=c[i+12>>2]|0;if((h|0)==(c[i+16>>2]|0))h=bd[c[(c[i>>2]|0)+36>>2]&255](i)|0;else h=c[h>>2]|0;if((h|0)==-1){c[a>>2]=0;i=1;break}else{i=(c[a>>2]|0)==0;break}}else i=1;while(0);do if(j){h=c[j+12>>2]|0;if((h|0)==(c[j+16>>2]|0))h=bd[c[(c[j>>2]|0)+36>>2]&255](j)|0;else h=c[h>>2]|0;if((h|0)!=-1)if(i)break a;else break;else{c[b>>2]=0;o=60;break}}else o=60;while(0);if((o|0)==60?!i:0)break;c[d>>2]=c[d>>2]|2}while(0);return g|0}function rK(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;g=a+4|0;e=(c[g>>2]|0)!=345;i=c[a>>2]|0;h=i;f=(c[d>>2]|0)-h|0;f=f>>>0<2147483647?f<<1:-1;h=(c[b>>2]|0)-h|0;i=BC(e?i:0,f)|0;if(!i)MA();do if(!e){e=c[a>>2]|0;c[a>>2]=i;if(e){o=0;ka(c[g>>2]|0,e|0);i=o;o=0;if(i&1){i=cc(0)|0;oq(i)}else{j=c[a>>2]|0;break}}else j=i}else{c[a>>2]=i;j=i}while(0);c[g>>2]=356;c[b>>2]=j+h;c[d>>2]=(c[a>>2]|0)+f;return}function sK(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;g=a+4|0;e=(c[g>>2]|0)!=345;i=c[a>>2]|0;h=i;f=(c[d>>2]|0)-h|0;f=f>>>0<2147483647?f<<1:-1;h=(c[b>>2]|0)-h>>2;i=BC(e?i:0,f)|0;if(!i)MA();do if(!e){e=c[a>>2]|0;c[a>>2]=i;if(e){o=0;ka(c[g>>2]|0,e|0);i=o;o=0;if(i&1){i=cc(0)|0;oq(i)}else{j=c[a>>2]|0;break}}else j=i}else{c[a>>2]=i;j=i}while(0);c[g>>2]=356;c[b>>2]=j+(h<<2);c[d>>2]=(c[a>>2]|0)+(f>>>2<<2);return}function tK(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0;h=d;f=a[b>>0]|0;if(!(f&1)){g=10;k=(f&255)>>>1}else{f=c[b>>2]|0;g=(f&-2)+-1|0;k=c[b+4>>2]|0;f=f&255}j=e-h|0;do if((e|0)!=(d|0)){if((g-k|0)>>>0<j>>>0){TC(b,g,k+j-g|0,k,k,0,0);f=a[b>>0]|0}if(!(f&1))i=b+1|0;else i=c[b+8>>2]|0;h=e+(k-h)|0;if((d|0)!=(e|0)){f=d;g=i+k|0;while(1){a[g>>0]=a[f>>0]|0;f=f+1|0;if((f|0)==(e|0))break;else g=g+1|0}}a[i+h>>0]=0;f=k+j|0;if(!(a[b>>0]&1)){a[b>>0]=f<<1;break}else{c[b+4>>2]=f;break}}while(0);return b|0}function uK(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;g=a+4|0;e=(c[g>>2]|0)!=345;i=c[a>>2]|0;h=i;f=(c[d>>2]|0)-h|0;f=f>>>0<2147483647?f<<1:-1;h=(c[b>>2]|0)-h>>2;i=BC(e?i:0,f)|0;if(!i)MA();do if(!e){e=c[a>>2]|0;c[a>>2]=i;if(e){o=0;ka(c[g>>2]|0,e|0);i=o;o=0;if(i&1){i=cc(0)|0;oq(i)}else{j=c[a>>2]|0;break}}else j=i}else{c[a>>2]=i;j=i}while(0);c[g>>2]=356;c[b>>2]=j+(h<<2);c[d>>2]=(c[a>>2]|0)+(f>>>2<<2);return}function vK(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0;h=d;f=a[b>>0]|0;if(!(f&1)){g=1;k=(f&255)>>>1}else{f=c[b>>2]|0;g=(f&-2)+-1|0;k=c[b+4>>2]|0;f=f&255}j=e-h>>2;do if(j){if((g-k|0)>>>0<j>>>0){dD(b,g,k+j-g|0,k,k,0,0);f=a[b>>0]|0}if(!(f&1))i=b+4|0;else i=c[b+8>>2]|0;h=k+((e-h|0)>>>2)|0;if((d|0)!=(e|0)){f=d;g=i+(k<<2)|0;while(1){c[g>>2]=c[f>>2];f=f+4|0;if((f|0)==(e|0))break;else g=g+4|0}}c[i+(h<<2)>>2]=0;f=k+j|0;if(!(a[b>>0]&1)){a[b>>0]=f<<1;break}else{c[b+4>>2]=f;break}}while(0);return b|0}function wK(b,d){b=b|0;d=d|0;var e=0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;a[b+128>>0]=0;do if(d){o=0;ma(256,b|0,d|0);e=o;o=0;if(e&1){e=cc()|0;ZK(b);bc(e|0)}else{oL(b,d);break}}while(0);return}function xK(a,b){a=a|0;b=b|0;TH(a,b,bI(39832)|0);return}function yK(a,b){a=a|0;b=b|0;TH(a,b,bI(39872)|0);return}function zK(a,b){a=a|0;b=b|0;TH(a,b,bI(40904)|0);return}function AK(a,b){a=a|0;b=b|0;TH(a,b,bI(40896)|0);return}function BK(a,b){a=a|0;b=b|0;TH(a,b,bI(40964)|0);return}function CK(a,b){a=a|0;b=b|0;TH(a,b,bI(40972)|0);return}function DK(a,b){a=a|0;b=b|0;TH(a,b,bI(41028)|0);return}function EK(a,b){a=a|0;b=b|0;TH(a,b,bI(41036)|0);return}function FK(a,b){a=a|0;b=b|0;TH(a,b,bI(41044)|0);return}function GK(a,b){a=a|0;b=b|0;TH(a,b,bI(41052)|0);return}function HK(a,b){a=a|0;b=b|0;TH(a,b,bI(39944)|0);return}function IK(a,b){a=a|0;b=b|0;TH(a,b,bI(40016)|0);return}function JK(a,b){a=a|0;b=b|0;TH(a,b,bI(40076)|0);return}function KK(a,b){a=a|0;b=b|0;TH(a,b,bI(40136)|0);return}function LK(a,b){a=a|0;b=b|0;TH(a,b,bI(40448)|0);return}function MK(a,b){a=a|0;b=b|0;TH(a,b,bI(40512)|0);return}function NK(a,b){a=a|0;b=b|0;TH(a,b,bI(40576)|0);return}function OK(a,b){a=a|0;b=b|0;TH(a,b,bI(40640)|0);return}function PK(a,b){a=a|0;b=b|0;TH(a,b,bI(40676)|0);return}function QK(a,b){a=a|0;b=b|0;TH(a,b,bI(40712)|0);return}function RK(a,b){a=a|0;b=b|0;TH(a,b,bI(40748)|0);return}function SK(a,b){a=a|0;b=b|0;TH(a,b,bI(40784)|0);return}function TK(a,b){a=a|0;b=b|0;TH(a,b,bI(40228)|0);return}function UK(a,b){a=a|0;b=b|0;TH(a,b,bI(40320)|0);return}function VK(a,b){a=a|0;b=b|0;TH(a,b,bI(40352)|0);return}function WK(a,b){a=a|0;b=b|0;TH(a,b,bI(40384)|0);return}function XK(a,b){a=a|0;b=b|0;TH(a,b,bI(40824)|0);return}function YK(a,b){a=a|0;b=b|0;TH(a,b,bI(40864)|0);return}function ZK(b){b=b|0;var d=0,e=0,f=0;e=c[b>>2]|0;do if(e){f=b+4|0;d=c[f>>2]|0;if((d|0)!=(e|0)){do d=d+-4|0;while((d|0)!=(e|0));c[f>>2]=d}if((b+16|0)==(e|0)){a[b+128>>0]=0;break}else{Uz(e);break}}while(0);return}function _K(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;h=a+4|0;d=c[h>>2]|0;e=c[a>>2]|0;f=d-e>>2;if(f>>>0>=b>>>0){if(f>>>0>b>>>0?(g=e+(b<<2)|0,(d|0)!=(g|0)):0){do d=d+-4|0;while((d|0)!=(g|0));c[h>>2]=d}}else nL(a,b-f|0);return}function $K(a,b){a=a|0;b=b|0;var d=0;d=c[a+8>>2]|0;if((c[a+12>>2]|0)-d>>2>>>0>b>>>0)d=(c[d+(b<<2)>>2]|0)!=0;else d=0;return d|0}function aL(a){a=a|0;var b=0,d=0;d=a+4|0;b=c[d>>2]|0;d=c[d+4>>2]|0;a=(c[a>>2]|0)+(d>>1)|0;if(d&1)b=c[(c[a>>2]|0)+b>>2]|0;_c[b&511](a);return}function bL(d,f,g,h,i,j,k,l){d=d|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;var m=0,n=0;c[g>>2]=d;c[j>>2]=h;if(l&2)if((i-h|0)<3)d=1;else{c[j>>2]=h+1;a[h>>0]=-17;m=c[j>>2]|0;c[j>>2]=m+1;a[m>>0]=-69;m=c[j>>2]|0;c[j>>2]=m+1;a[m>>0]=-65;m=4}else m=4;a:do if((m|0)==4){n=f;d=c[g>>2]|0;if(d>>>0<f>>>0)while(1){l=b[d>>1]|0;m=l&65535;if(m>>>0>k>>>0){d=2;break a}do if((l&65535)<128){d=c[j>>2]|0;if((i-d|0)<1){d=1;break a}c[j>>2]=d+1;a[d>>0]=l}else{if((l&65535)<2048){d=c[j>>2]|0;if((i-d|0)<2){d=1;break a}c[j>>2]=d+1;a[d>>0]=m>>>6|192;h=c[j>>2]|0;c[j>>2]=h+1;a[h>>0]=m&63|128;break}if((l&65535)<55296){d=c[j>>2]|0;if((i-d|0)<3){d=1;break a}c[j>>2]=d+1;a[d>>0]=m>>>12|224;h=c[j>>2]|0;c[j>>2]=h+1;a[h>>0]=m>>>6&63|128;h=c[j>>2]|0;c[j>>2]=h+1;a[h>>0]=m&63|128;break}if((l&65535)>=56320){if((l&65535)<57344){d=2;break a}d=c[j>>2]|0;if((i-d|0)<3){d=1;break a}c[j>>2]=d+1;a[d>>0]=m>>>12|224;h=c[j>>2]|0;c[j>>2]=h+1;a[h>>0]=m>>>6&63|128;h=c[j>>2]|0;c[j>>2]=h+1;a[h>>0]=m&63|128;break}if((n-d|0)<4){d=1;break a}d=d+2|0;l=e[d>>1]|0;if((l&64512|0)!=56320){d=2;break a}if((i-(c[j>>2]|0)|0)<4){d=1;break a}h=m&960;if(((h<<10)+65536|m<<10&64512|l&1023)>>>0>k>>>0){d=2;break a}c[g>>2]=d;d=(h>>>6)+1|0;h=c[j>>2]|0;c[j>>2]=h+1;a[h>>0]=d>>>2|240;h=c[j>>2]|0;c[j>>2]=h+1;a[h>>0]=m>>>2&15|d<<4&48|128;h=c[j>>2]|0;c[j>>2]=h+1;a[h>>0]=m<<4&48|l>>>6&15|128;m=c[j>>2]|0;c[j>>2]=m+1;a[m>>0]=l&63|128}while(0);d=(c[g>>2]|0)+2|0;c[g>>2]=d;if(d>>>0>=f>>>0){d=0;break}}else d=0}while(0);return d|0}function cL(e,f,g,h,i,j,k,l){e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;var m=0,n=0,o=0,p=0,q=0,r=0;c[g>>2]=e;c[j>>2]=h;if(l&4){e=c[g>>2]|0;l=f;if((((l-e|0)>2?(a[e>>0]|0)==-17:0)?(a[e+1>>0]|0)==-69:0)?(a[e+2>>0]|0)==-65:0){c[g>>2]=e+3;m=c[j>>2]|0}else m=h}else{m=h;l=f}q=i;h=c[g>>2]|0;e=h>>>0<f>>>0;a:do if(e&m>>>0<i>>>0)while(1){e=a[h>>0]|0;o=e&255;if(o>>>0>k>>>0){e=2;break a}do if(e<<24>>24>-1){b[m>>1]=e&255;c[g>>2]=h+1}else{if((e&255)<194){e=2;break a}if((e&255)<224){if((l-h|0)<2){e=1;break a}e=d[h+1>>0]|0;if((e&192|0)!=128){e=2;break a}e=e&63|o<<6&1984;if(e>>>0>k>>>0){e=2;break a}b[m>>1]=e;c[g>>2]=h+2;break}if((e&255)<240){if((l-h|0)<3){e=1;break a}n=a[h+1>>0]|0;e=a[h+2>>0]|0;switch(o|0){case 224:{if((n&-32)<<24>>24!=-96){e=2;break a}break}case 237:{if((n&-32)<<24>>24!=-128){e=2;break a}break}default:if((n&-64)<<24>>24!=-128){e=2;break a}}e=e&255;if((e&192|0)!=128){e=2;break a}e=(n&255)<<6&4032|o<<12|e&63;if((e&65535)>>>0>k>>>0){e=2;break a}b[m>>1]=e;c[g>>2]=h+3;break}if((e&255)>=245){e=2;break a}if((l-h|0)<4){e=1;break a}n=a[h+1>>0]|0;e=a[h+2>>0]|0;h=a[h+3>>0]|0;switch(o|0){case 240:{if((n+112&255)>=48){e=2;break a}break}case 244:{if((n&-16)<<24>>24!=-128){e=2;break a}break}default:if((n&-64)<<24>>24!=-128){e=2;break a}}p=e&255;if((p&192|0)!=128){e=2;break a}e=h&255;if((e&192|0)!=128){e=2;break a}if((q-m|0)<4){e=1;break a}o=o&7;h=n&255;n=p<<6;e=e&63;if((h<<12&258048|o<<18|n&4032|e)>>>0>k>>>0){e=2;break a}b[m>>1]=h<<2&60|p>>>4&3|((h>>>4&3|o<<2)<<6)+16320|55296;p=m+2|0;c[j>>2]=p;b[p>>1]=e|n&960|56320;c[g>>2]=(c[g>>2]|0)+4}while(0);m=(c[j>>2]|0)+2|0;c[j>>2]=m;h=c[g>>2]|0;e=h>>>0<f>>>0;if(!(e&m>>>0<i>>>0)){r=39;break}}else r=39;while(0);if((r|0)==39)e=e&1;return e|0}function dL(b,c,e,f,g){b=b|0;c=c|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0;n=c;if((((g&4|0)!=0?(n-b|0)>2:0)?(a[b>>0]|0)==-17:0)?(a[b+1>>0]|0)==-69:0)g=(a[b+2>>0]|0)==-65?b+3|0:b;else g=b;a:do if((e|0)!=0&g>>>0<c>>>0){m=g;h=0;b:while(1){g=a[m>>0]|0;l=g&255;if(l>>>0>f>>>0){g=m;h=42;break a}do if(g<<24>>24>-1)g=m+1|0;else{if((g&255)<194){g=m;h=42;break a}if((g&255)<224){if((n-m|0)<2){g=m;h=42;break a}g=d[m+1>>0]|0;if((g&192|0)!=128){g=m;h=42;break a}if((g&63|l<<6&1984)>>>0>f>>>0){g=m;h=42;break a}g=m+2|0;break}if((g&255)<240){g=m;if((n-g|0)<3){g=m;h=42;break a}j=a[m+1>>0]|0;i=a[m+2>>0]|0;switch(l|0){case 224:{if((j&-32)<<24>>24!=-96){h=20;break b}break}case 237:{if((j&-32)<<24>>24!=-128){h=22;break b}break}default:if((j&-64)<<24>>24!=-128){h=24;break b}}g=i&255;if((g&192|0)!=128){g=m;h=42;break a}if(((j&255)<<6&4032|l<<12&61440|g&63)>>>0>f>>>0){g=m;h=42;break a}g=m+3|0;break}if((g&255)>=245){g=m;h=42;break a}g=m;if((e-h|0)>>>0<2|(n-g|0)<4){g=m;h=42;break a}k=a[m+1>>0]|0;i=a[m+2>>0]|0;j=a[m+3>>0]|0;switch(l|0){case 240:{if((k+112&255)>=48){h=32;break b}break}case 244:{if((k&-16)<<24>>24!=-128){h=34;break b}break}default:if((k&-64)<<24>>24!=-128){h=36;break b}}i=i&255;if((i&192|0)!=128){g=m;h=42;break a}g=j&255;if((g&192|0)!=128){g=m;h=42;break a}if(((k&255)<<12&258048|l<<18&1835008|i<<6&4032|g&63)>>>0>f>>>0){g=m;h=42;break a}g=m+4|0;h=h+1|0}while(0);h=h+1|0;if(!(h>>>0<e>>>0&g>>>0<c>>>0)){h=42;break a}else m=g}if((h|0)==20){g=g-b|0;break}else if((h|0)==22){g=g-b|0;break}else if((h|0)==24){g=g-b|0;break}else if((h|0)==32){g=g-b|0;break}else if((h|0)==34){g=g-b|0;break}else if((h|0)==36){g=g-b|0;break}}else h=42;while(0);if((h|0)==42)g=g-b|0;return g|0}function eL(b,d,e,f,g,h,i,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;var k=0,l=0;c[e>>2]=b;c[h>>2]=f;l=g;if(j&2)if((l-f|0)<3)b=1;else{c[h>>2]=f+1;a[f>>0]=-17;k=c[h>>2]|0;c[h>>2]=k+1;a[k>>0]=-69;k=c[h>>2]|0;c[h>>2]=k+1;a[k>>0]=-65;k=4}else k=4;a:do if((k|0)==4){b=c[e>>2]|0;if(b>>>0<d>>>0)while(1){j=c[b>>2]|0;if(j>>>0>i>>>0|(j&-2048|0)==55296){b=2;break a}do if(j>>>0>=128){if(j>>>0<2048){b=c[h>>2]|0;if((l-b|0)<2){b=1;break a}c[h>>2]=b+1;a[b>>0]=j>>>6|192;k=c[h>>2]|0;c[h>>2]=k+1;a[k>>0]=j&63|128;break}b=c[h>>2]|0;g=l-b|0;if(j>>>0<65536){if((g|0)<3){b=1;break a}c[h>>2]=b+1;a[b>>0]=j>>>12|224;k=c[h>>2]|0;c[h>>2]=k+1;a[k>>0]=j>>>6&63|128;k=c[h>>2]|0;c[h>>2]=k+1;a[k>>0]=j&63|128;break}else{if((g|0)<4){b=1;break a}c[h>>2]=b+1;a[b>>0]=j>>>18|240;k=c[h>>2]|0;c[h>>2]=k+1;a[k>>0]=j>>>12&63|128;k=c[h>>2]|0;c[h>>2]=k+1;a[k>>0]=j>>>6&63|128;k=c[h>>2]|0;c[h>>2]=k+1;a[k>>0]=j&63|128;break}}else{b=c[h>>2]|0;if((l-b|0)<1){b=1;break a}c[h>>2]=b+1;a[b>>0]=j}while(0);b=(c[e>>2]|0)+4|0;c[e>>2]=b;if(b>>>0>=d>>>0){b=0;break}}else b=0}while(0);return b|0}function fL(b,e,f,g,h,i,j,k){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0;c[f>>2]=b;c[i>>2]=g;if(k&4){b=c[f>>2]|0;k=e;if((((k-b|0)>2?(a[b>>0]|0)==-17:0)?(a[b+1>>0]|0)==-69:0)?(a[b+2>>0]|0)==-65:0){c[f>>2]=b+3;g=c[i>>2]|0;p=k}else p=k}else p=e;k=c[f>>2]|0;b=k>>>0<e>>>0;a:do if(b&g>>>0<h>>>0)while(1){b=a[k>>0]|0;o=b&255;do if(b<<24>>24>-1){if(o>>>0>j>>>0){b=2;break a}c[g>>2]=o;c[f>>2]=k+1}else{if((b&255)<194){b=2;break a}if((b&255)<224){if((p-k|0)<2){b=1;break a}b=d[k+1>>0]|0;if((b&192|0)!=128){b=2;break a}b=b&63|o<<6&1984;if(b>>>0>j>>>0){b=2;break a}c[g>>2]=b;c[f>>2]=k+2;break}if((b&255)<240){if((p-k|0)<3){b=1;break a}l=a[k+1>>0]|0;b=a[k+2>>0]|0;switch(o|0){case 224:{if((l&-32)<<24>>24!=-96){b=2;break a}break}case 237:{if((l&-32)<<24>>24!=-128){b=2;break a}break}default:if((l&-64)<<24>>24!=-128){b=2;break a}}b=b&255;if((b&192|0)!=128){b=2;break a}b=(l&255)<<6&4032|o<<12&61440|b&63;if(b>>>0>j>>>0){b=2;break a}c[g>>2]=b;c[f>>2]=k+3;break}if((b&255)>=245){b=2;break a}if((p-k|0)<4){b=1;break a}n=a[k+1>>0]|0;b=a[k+2>>0]|0;l=a[k+3>>0]|0;switch(o|0){case 240:{if((n+112&255)>=48){b=2;break a}break}case 244:{if((n&-16)<<24>>24!=-128){b=2;break a}break}default:if((n&-64)<<24>>24!=-128){b=2;break a}}m=b&255;if((m&192|0)!=128){b=2;break a}b=l&255;if((b&192|0)!=128){b=2;break a}b=(n&255)<<12&258048|o<<18&1835008|m<<6&4032|b&63;if(b>>>0>j>>>0){b=2;break a}c[g>>2]=b;c[f>>2]=k+4}while(0);g=(c[i>>2]|0)+4|0;c[i>>2]=g;k=c[f>>2]|0;b=k>>>0<e>>>0;if(!(b&g>>>0<h>>>0)){q=38;break}}else q=38;while(0);if((q|0)==38)b=b&1;return b|0}function gL(b,c,e,f,g){b=b|0;c=c|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0;n=c;if((((g&4|0)!=0?(n-b|0)>2:0)?(a[b>>0]|0)==-17:0)?(a[b+1>>0]|0)==-69:0)g=(a[b+2>>0]|0)==-65?b+3|0:b;else g=b;a:do if((e|0)!=0&g>>>0<c>>>0){l=g;m=0;b:while(1){g=a[l>>0]|0;k=g&255;do if(g<<24>>24>-1){if(k>>>0>f>>>0){g=l;h=42;break a}g=l+1|0}else{if((g&255)<194){g=l;h=42;break a}if((g&255)<224){if((n-l|0)<2){g=l;h=42;break a}g=d[l+1>>0]|0;if((g&192|0)!=128){g=l;h=42;break a}if((g&63|k<<6&1984)>>>0>f>>>0){g=l;h=42;break a}g=l+2|0;break}if((g&255)<240){g=l;if((n-g|0)<3){g=l;h=42;break a}i=a[l+1>>0]|0;h=a[l+2>>0]|0;switch(k|0){case 224:{if((i&-32)<<24>>24!=-96){h=20;break b}break}case 237:{if((i&-32)<<24>>24!=-128){h=22;break b}break}default:if((i&-64)<<24>>24!=-128){h=24;break b}}g=h&255;if((g&192|0)!=128){g=l;h=42;break a}if(((i&255)<<6&4032|k<<12&61440|g&63)>>>0>f>>>0){g=l;h=42;break a}g=l+3|0;break}if((g&255)>=245){g=l;h=42;break a}g=l;if((n-g|0)<4){g=l;h=42;break a}j=a[l+1>>0]|0;h=a[l+2>>0]|0;i=a[l+3>>0]|0;switch(k|0){case 240:{if((j+112&255)>=48){h=32;break b}break}case 244:{if((j&-16)<<24>>24!=-128){h=34;break b}break}default:if((j&-64)<<24>>24!=-128){h=36;break b}}h=h&255;if((h&192|0)!=128){g=l;h=42;break a}g=i&255;if((g&192|0)!=128){g=l;h=42;break a}if(((j&255)<<12&258048|k<<18&1835008|h<<6&4032|g&63)>>>0>f>>>0){g=l;h=42;break a}g=l+4|0}while(0);m=m+1|0;if(!(m>>>0<e>>>0&g>>>0<c>>>0)){h=42;break a}else l=g}if((h|0)==20){g=g-b|0;break}else if((h|0)==22){g=g-b|0;break}else if((h|0)==24){g=g-b|0;break}else if((h|0)==32){g=g-b|0;break}else if((h|0)==34){g=g-b|0;break}else if((h|0)==36){g=g-b|0;break}}else h=42;while(0);if((h|0)==42)g=g-b|0;return g|0}function hL(a){a=a|0;IC(41880);IC(41868);IC(41856);IC(41844);IC(41832);IC(41820);IC(41808);IC(41796);IC(41784);IC(41772);IC(41760);IC(41748);IC(41736);IC(41724);return}function iL(a){a=a|0;ZC(42052);ZC(42040);ZC(42028);ZC(42016);ZC(42004);ZC(41992);ZC(41980);ZC(41968);ZC(41956);ZC(41944);ZC(41932);ZC(41920);ZC(41908);ZC(41896);return}function jL(a){a=a|0;IC(42684);IC(42672);IC(42660);IC(42648);IC(42636);IC(42624);IC(42612);IC(42600);IC(42588);IC(42576);IC(42564);IC(42552);IC(42540);IC(42528);IC(42516);IC(42504);IC(42492);IC(42480);IC(42468);IC(42456);IC(42444);IC(42432);IC(42420);IC(42408);return}function kL(a){a=a|0;ZC(42976);ZC(42964);ZC(42952);ZC(42940);ZC(42928);ZC(42916);ZC(42904);ZC(42892);ZC(42880);ZC(42868);ZC(42856);ZC(42844);ZC(42832);ZC(42820);ZC(42808);ZC(42796);ZC(42784);ZC(42772);ZC(42760);ZC(42748);ZC(42736);ZC(42724);ZC(42712);ZC(42700);return}function lL(a){a=a|0;IC(43788);IC(43776);IC(43764);IC(43752);IC(43740);IC(43728);IC(43716);IC(43704);IC(43692);IC(43680);IC(43668);IC(43656);IC(43644);IC(43632);IC(43620);IC(43608);IC(43596);IC(43584);IC(43572);IC(43560);IC(43548);IC(43536);IC(43524);IC(43512);return}function mL(a){a=a|0;ZC(44080);ZC(44068);ZC(44056);ZC(44044);ZC(44032);ZC(44020);ZC(44008);ZC(43996);ZC(43984);ZC(43972);ZC(43960);ZC(43948);ZC(43936);ZC(43924);ZC(43912);ZC(43900);ZC(43888);ZC(43876);ZC(43864);ZC(43852);ZC(43840);ZC(43828);ZC(43816);ZC(43804);return}function nL(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+32|0;j=k;g=c[a+8>>2]|0;d=c[a+4>>2]|0;if(g-d>>2>>>0<b>>>0){e=c[a>>2]|0;h=d-e>>2;f=h+b|0;if(f>>>0>1073741823)Qz(a);d=g-e|0;if(d>>2>>>0<536870911){d=d>>1;d=d>>>0<f>>>0?f:d}else d=1073741823;pL(j,d,h,a+16|0);h=j+8|0;g=c[h>>2]|0;ZL(g|0,0,b<<2|0)|0;c[h>>2]=g+(b<<2);qL(a,j);rL(j)}else oL(a,b);i=k;return}function oL(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b>>2]=0;b=(c[d>>2]|0)+4|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function pL(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0;c[b+12>>2]=0;c[b+16>>2]=f;do if(d){g=f+112|0;if(d>>>0<29&(a[g>>0]|0)==0){a[g>>0]=1;break}else{f=Sz(d<<2)|0;break}}else f=0;while(0);c[b>>2]=f;e=f+(e<<2)|0;c[b+8>>2]=e;c[b+4>>2]=e;c[b+12>>2]=f+(d<<2);return}function qL(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;e=c[a>>2]|0;g=a+4|0;d=b+4|0;f=(c[g>>2]|0)-e|0;h=(c[d>>2]|0)+(0-(f>>2)<<2)|0;c[d>>2]=h;XL(h|0,e|0,f|0)|0;f=c[a>>2]|0;c[a>>2]=c[d>>2];c[d>>2]=f;f=b+8|0;e=c[g>>2]|0;c[g>>2]=c[f>>2];c[f>>2]=e;f=a+8|0;a=b+12|0;e=c[f>>2]|0;c[f>>2]=c[a>>2];c[a>>2]=e;c[b>>2]=c[d>>2];return}function rL(b){b=b|0;var d=0,e=0,f=0;e=c[b+4>>2]|0;f=b+8|0;d=c[f>>2]|0;if((d|0)!=(e|0)){do d=d+-4|0;while((d|0)!=(e|0));c[f>>2]=d}e=c[b>>2]|0;do if(e){d=c[b+16>>2]|0;if((d|0)==(e|0)){a[d+112>>0]=0;break}else{Uz(e);break}}while(0);return}function sL(b,d){b=b|0;d=d|0;var e=0;if(d>>>0>1073741823)Qz(b);e=b+128|0;if(d>>>0<29&(a[e>>0]|0)==0){a[e>>0]=1;e=b+16|0}else e=Sz(d<<2)|0;c[b+4>>2]=e;c[b>>2]=e;c[b+8>>2]=e+(d<<2);return}function tL(a,b,d){a=a|0;b=b|0;d=d|0;var e=0.0,f=0,g=0,h=0,j=0;j=i;i=i+16|0;h=j;do if((a|0)!=(b|0)){f=ZA()|0;g=c[f>>2]|0;c[f>>2]=0;e=+ZB(a,h,rE()|0);a=c[f>>2]|0;if(!a)c[f>>2]=g;if((c[h>>2]|0)!=(b|0)){c[d>>2]=4;e=0.0;break}if((a|0)==34)c[d>>2]=4}else{c[d>>2]=4;e=0.0}while(0);i=j;return +e}function uL(a,b,d){a=a|0;b=b|0;d=d|0;var e=0.0,f=0,g=0,h=0,j=0;j=i;i=i+16|0;h=j;do if((a|0)!=(b|0)){f=ZA()|0;g=c[f>>2]|0;c[f>>2]=0;e=+ZB(a,h,rE()|0);a=c[f>>2]|0;if(!a)c[f>>2]=g;if((c[h>>2]|0)!=(b|0)){c[d>>2]=4;e=0.0;break}if((a|0)==34)c[d>>2]=4}else{c[d>>2]=4;e=0.0}while(0);i=j;return +e}function vL(a,b,d){a=a|0;b=b|0;d=d|0;var e=0.0,f=0,g=0,h=0,j=0;j=i;i=i+16|0;h=j;do if((a|0)==(b|0)){c[d>>2]=4;e=0.0}else{f=ZA()|0;g=c[f>>2]|0;c[f>>2]=0;e=+ZB(a,h,rE()|0);a=c[f>>2]|0;if(!a)c[f>>2]=g;if((c[h>>2]|0)!=(b|0)){c[d>>2]=4;e=0.0;break}if((a|0)==34)c[d>>2]=4}while(0);i=j;return +e}function wL(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0;k=i;i=i+16|0;j=k;do if((b|0)!=(d|0)){if((a[b>>0]|0)==45){c[e>>2]=4;f=0;b=0;break}g=ZA()|0;h=c[g>>2]|0;c[g>>2]=0;b=SA(b,j,f,rE()|0)|0;f=c[g>>2]|0;if(!f)c[g>>2]=h;if((c[j>>2]|0)!=(d|0)){c[e>>2]=4;f=0;b=0;break}if((f|0)==34){c[e>>2]=4;f=-1;b=-1}else f=D}else{c[e>>2]=4;f=0;b=0}while(0);D=f;i=k;return b|0}function xL(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0;l=i;i=i+16|0;k=l;do if((b|0)!=(d|0)){if((a[b>>0]|0)==45){c[e>>2]=4;b=0;break}h=ZA()|0;j=c[h>>2]|0;c[h>>2]=0;b=SA(b,k,f,rE()|0)|0;f=D;g=c[h>>2]|0;if(!g)c[h>>2]=j;if((c[k>>2]|0)!=(d|0)){c[e>>2]=4;b=0;break}if(f>>>0>0|(f|0)==0&b>>>0>4294967295|(g|0)==34){c[e>>2]=4;b=-1;break}else break}else{c[e>>2]=4;b=0}while(0);i=l;return b|0}function yL(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0;l=i;i=i+16|0;k=l;do if((b|0)!=(d|0)){if((a[b>>0]|0)==45){c[e>>2]=4;b=0;break}h=ZA()|0;j=c[h>>2]|0;c[h>>2]=0;b=SA(b,k,f,rE()|0)|0;f=D;g=c[h>>2]|0;if(!g)c[h>>2]=j;if((c[k>>2]|0)!=(d|0)){c[e>>2]=4;b=0;break}if(f>>>0>0|(f|0)==0&b>>>0>4294967295|(g|0)==34){c[e>>2]=4;b=-1;break}else break}else{c[e>>2]=4;b=0}while(0);i=l;return b|0}function zL(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0;l=i;i=i+16|0;k=l;do if((b|0)!=(d|0)){if((a[b>>0]|0)==45){c[e>>2]=4;b=0;break}h=ZA()|0;j=c[h>>2]|0;c[h>>2]=0;b=SA(b,k,f,rE()|0)|0;f=D;g=c[h>>2]|0;if(!g)c[h>>2]=j;if((c[k>>2]|0)!=(d|0)){c[e>>2]=4;b=0;break}if(f>>>0>0|(f|0)==0&b>>>0>65535|(g|0)==34){c[e>>2]=4;b=-1;break}else{b=b&65535;break}}else{c[e>>2]=4;b=0}while(0);i=l;return b|0}function AL(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0;k=i;i=i+16|0;j=k;do if((a|0)!=(b|0)){g=ZA()|0;h=c[g>>2]|0;c[g>>2]=0;a=TA(a,j,e,rE()|0)|0;e=D;f=c[g>>2]|0;if(!f)c[g>>2]=h;if((c[j>>2]|0)!=(b|0)){c[d>>2]=4;e=0;a=0;break}if((f|0)==34){c[d>>2]=4;j=(e|0)>0|(e|0)==0&a>>>0>0;D=j?2147483647:-2147483648;i=k;return (j?-1:0)|0}}else{c[d>>2]=4;e=0;a=0}while(0);D=e;i=k;return a|0}function BL(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0;k=i;i=i+16|0;j=k;a:do if((a|0)==(b|0)){c[d>>2]=4;a=0}else{g=ZA()|0;h=c[g>>2]|0;c[g>>2]=0;a=TA(a,j,e,rE()|0)|0;e=D;f=c[g>>2]|0;if(!f)c[g>>2]=h;if((c[j>>2]|0)!=(b|0)){c[d>>2]=4;a=0;break}do if((f|0)==34){c[d>>2]=4;if((e|0)>0|(e|0)==0&a>>>0>0){a=2147483647;break a}}else{if((e|0)<-1|(e|0)==-1&a>>>0<2147483648){c[d>>2]=4;break}if((e|0)>0|(e|0)==0&a>>>0>2147483647){c[d>>2]=4;a=2147483647;break a}else break a}while(0);a=-2147483648}while(0);i=k;return a|0}function CL(a){a=a|0;return}function DL(a){a=a|0;a=a+4|0;c[a>>2]=(c[a>>2]|0)+1;return}function EL(a){a=a|0;var b=0,d=0;d=a+4|0;b=c[d>>2]|0;c[d>>2]=b+-1;if(!b){_c[c[(c[a>>2]|0)+8>>2]&511](a);a=1}else a=0;return a|0}function FL(b,d){b=b|0;d=d|0;c[b>>2]=35224;o=0;ma(257,b+4|0,((a[d>>0]&1)==0?d+1|0:c[d+8>>2]|0)|0);b=o;o=0;if(b&1){b=cc()|0;bc(b|0)}else return}function GL(a,b){a=a|0;b=b|0;c[a>>2]=35224;o=0;ma(257,a+4|0,b|0);a=o;o=0;if(a&1){a=cc()|0;bc(a|0)}else return}function HL(a,b){a=a|0;b=b|0;var d=0,e=0;e=iC(b)|0;d=Sz(e+13|0)|0;c[d>>2]=e;c[d+4>>2]=e;c[d+8>>2]=0;d=d+12|0;XL(d|0,b|0,e+1|0)|0;c[a>>2]=d;return}function IL(a,b,d){a=a|0;b=b|0;d=d|0;c[a>>2]=d;c[a+4>>2]=b;return}function JL(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;f=i;i=i+16|0;e=f;Ad[c[(c[a>>2]|0)+12>>2]&127](e,a,b);if((c[e+4>>2]|0)==(c[d+4>>2]|0))e=(c[e>>2]|0)==(c[d>>2]|0);else e=0;i=f;return e|0}function KL(a,b,d){a=a|0;b=b|0;d=d|0;return ((c[b>>2]|0)==(d|0)?(c[b+4>>2]|0)==(a|0):0)|0}function LL(a,b,c){a=a|0;b=b|0;c=c|0;b=_A(c)|0;FC(a,b,iC(b)|0);return}function ML(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0;j=i;i=i+16|0;h=j;f=c[d>>2]|0;do if(f){g=a[e>>0]|0;if(!(g&1))g=(g&255)>>>1;else g=c[e+4>>2]|0;if(g){PC(e,62197)|0;f=c[d>>2]|0}d=c[d+4>>2]|0;Ad[c[(c[d>>2]|0)+24>>2]&127](h,d,f);d=a[h>>0]|0;g=(d&1)==0;o=0;ya(90,e|0,(g?h+1|0:c[h+8>>2]|0)|0,(g?(d&255)>>>1:c[h+4>>2]|0)|0)|0;d=o;o=0;if(d&1){j=cc()|0;IC(h);bc(j|0)}else{IC(h);break}}while(0);c[b>>2]=c[e>>2];c[b+4>>2]=c[e+4>>2];c[b+8>>2]=c[e+8>>2];c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=0;i=j;return}function NL(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;f=i;i=i+32|0;e=f+12|0;g=f;FC(g,d,iC(d)|0);o=0;mb(120,e|0,b|0,g|0);d=o;o=0;do if(!(d&1)){o=0;ma(258,a|0,e|0);d=o;o=0;if(d&1){f=cc()|0;IC(e);e=f;break}else{IC(e);IC(g);c[a>>2]=44428;d=c[b+4>>2]|0;g=a+8|0;c[g>>2]=c[b>>2];c[g+4>>2]=d;i=f;return}}else e=cc()|0;while(0);IC(g);bc(e|0)}function OL(a){a=a|0;cA(a);return}function PL(a){a=a|0;cA(a);Uz(a);return}function QL(a){a=a|0;return}function RL(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;Pc(44440)|0;if((c[a>>2]|0)==1)do yb(44468,44440)|0;while((c[a>>2]|0)==1);do if(!(c[a>>2]|0)){c[a>>2]=1;o=0;qa(195,44440)|0;e=o;o=0;if((((!(e&1)?(o=0,ka(d|0,b|0),e=o,o=0,!(e&1)):0)?(o=0,qa(196,44440)|0,e=o,o=0,!(e&1)):0)?(c[a>>2]=-1,o=0,qa(195,44440)|0,e=o,o=0,!(e&1)):0)?(o=0,qa(197,44468)|0,e=o,o=0,!(e&1)):0)break;e=cc(0)|0;fc(e|0)|0;o=0;qa(196,44440)|0;e=o;o=0;if((!(e&1)?(c[a>>2]=0,o=0,qa(195,44440)|0,e=o,o=0,!(e&1)):0)?(o=0,qa(197,44468)|0,e=o,o=0,!(e&1)):0){o=0;ob(47);o=0}b=cc()|0;o=0;ob(44);e=o;o=0;if(e&1){e=cc(0)|0;oq(e)}else bc(b|0)}else pc(44440)|0;while(0);return}function SL(){}function TL(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;c=a+c>>>0;return (D=b+d+(c>>>0<a>>>0|0)>>>0,c|0)|0}function UL(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;d=b-d-(c>>>0>a>>>0|0)>>>0;return (D=d,a-c>>>0|0)|0}function VL(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<32){D=b>>c;return a>>>c|(b&(1<<c)-1)<<32-c}D=(b|0)<0?-1:0;return b>>c-32|0}function WL(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<32){D=b>>>c;return a>>>c|(b&(1<<c)-1)<<32-c}D=0;return b>>>c-32|0}function XL(b,d,e){b=b|0;d=d|0;e=e|0;var f=0;if((e|0)>=4096)return _b(b|0,d|0,e|0)|0;f=b|0;if((b&3)==(d&3)){while(b&3){if(!e)return f|0;a[b>>0]=a[d>>0]|0;b=b+1|0;d=d+1|0;e=e-1|0}while((e|0)>=4){c[b>>2]=c[d>>2];b=b+4|0;d=d+4|0;e=e-4|0}}while((e|0)>0){a[b>>0]=a[d>>0]|0;b=b+1|0;d=d+1|0;e=e-1|0}return f|0}function YL(b,c,d){b=b|0;c=c|0;d=d|0;var e=0;if((c|0)<(b|0)&(b|0)<(c+d|0)){e=b;c=c+d|0;b=b+d|0;while((d|0)>0){b=b-1|0;c=c-1|0;d=d-1|0;a[b>>0]=a[c>>0]|0}b=e}else XL(b,c,d)|0;return b|0}function ZL(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;f=b+e|0;if((e|0)>=20){d=d&255;h=b&3;i=d|d<<8|d<<16|d<<24;g=f&~3;if(h){h=b+4-h|0;while((b|0)<(h|0)){a[b>>0]=d;b=b+1|0}}while((b|0)<(g|0)){c[b>>2]=i;b=b+4|0}}while((b|0)<(f|0)){a[b>>0]=d;b=b+1|0}return b-e|0}function _L(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<32){D=b<<c|(a&(1<<c)-1<<32-c)>>>32-c;return a<<c}D=a<<c-32;return 0}function $L(b){b=b|0;var c=0;c=a[m+(b&255)>>0]|0;if((c|0)<8)return c|0;c=a[m+(b>>8&255)>>0]|0;if((c|0)<8)return c+8|0;c=a[m+(b>>16&255)>>0]|0;if((c|0)<8)return c+16|0;return (a[m+(b>>>24)>>0]|0)+24|0}function aM(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0;f=a&65535;e=b&65535;c=$(e,f)|0;d=a>>>16;a=(c>>>16)+($(e,d)|0)|0;e=b>>>16;b=$(e,f)|0;return (D=(a>>>16)+($(e,d)|0)+(((a&65535)+b|0)>>>16)|0,a+b<<16|c&65535|0)|0}function bM(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;j=b>>31|((b|0)<0?-1:0)<<1;i=((b|0)<0?-1:0)>>31|((b|0)<0?-1:0)<<1;f=d>>31|((d|0)<0?-1:0)<<1;e=((d|0)<0?-1:0)>>31|((d|0)<0?-1:0)<<1;h=UL(j^a,i^b,j,i)|0;g=D;a=f^j;b=e^i;return UL((gM(h,g,UL(f^c,e^d,f,e)|0,D,0)|0)^a,D^b,a,b)|0}function cM(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0;f=i;i=i+16|0;j=f|0;h=b>>31|((b|0)<0?-1:0)<<1;g=((b|0)<0?-1:0)>>31|((b|0)<0?-1:0)<<1;l=e>>31|((e|0)<0?-1:0)<<1;k=((e|0)<0?-1:0)>>31|((e|0)<0?-1:0)<<1;a=UL(h^a,g^b,h,g)|0;b=D;gM(a,b,UL(l^d,k^e,l,k)|0,D,j)|0;e=UL(c[j>>2]^h,c[j+4>>2]^g,h,g)|0;d=D;i=f;return (D=d,e)|0}function dM(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0;e=a;f=c;c=aM(e,f)|0;a=D;return (D=($(b,f)|0)+($(d,e)|0)+a|a&0,c|0|0)|0}function eM(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return gM(a,b,c,d,0)|0}function fM(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0;g=i;i=i+16|0;f=g|0;gM(a,b,d,e,f)|0;i=g;return (D=c[f+4>>2]|0,c[f>>2]|0)|0}function gM(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;l=a;j=b;k=j;h=d;n=e;i=n;if(!k){g=(f|0)!=0;if(!i){if(g){c[f>>2]=(l>>>0)%(h>>>0);c[f+4>>2]=0}n=0;f=(l>>>0)/(h>>>0)>>>0;return (D=n,f)|0}else{if(!g){n=0;f=0;return (D=n,f)|0}c[f>>2]=a|0;c[f+4>>2]=b&0;n=0;f=0;return (D=n,f)|0}}g=(i|0)==0;do if(h){if(!g){g=(ba(i|0)|0)-(ba(k|0)|0)|0;if(g>>>0<=31){m=g+1|0;i=31-g|0;b=g-31>>31;h=m;a=l>>>(m>>>0)&b|k<<i;b=k>>>(m>>>0)&b;g=0;i=l<<i;break}if(!f){n=0;f=0;return (D=n,f)|0}c[f>>2]=a|0;c[f+4>>2]=j|b&0;n=0;f=0;return (D=n,f)|0}g=h-1|0;if(g&h){i=(ba(h|0)|0)+33-(ba(k|0)|0)|0;p=64-i|0;m=32-i|0;j=m>>31;o=i-32|0;b=o>>31;h=i;a=m-1>>31&k>>>(o>>>0)|(k<<m|l>>>(i>>>0))&b;b=b&k>>>(i>>>0);g=l<<p&j;i=(k<<p|l>>>(o>>>0))&j|l<<m&i-33>>31;break}if(f){c[f>>2]=g&l;c[f+4>>2]=0}if((h|0)==1){o=j|b&0;p=a|0|0;return (D=o,p)|0}else{p=$L(h|0)|0;o=k>>>(p>>>0)|0;p=k<<32-p|l>>>(p>>>0)|0;return (D=o,p)|0}}else{if(g){if(f){c[f>>2]=(k>>>0)%(h>>>0);c[f+4>>2]=0}o=0;p=(k>>>0)/(h>>>0)>>>0;return (D=o,p)|0}if(!l){if(f){c[f>>2]=0;c[f+4>>2]=(k>>>0)%(i>>>0)}o=0;p=(k>>>0)/(i>>>0)>>>0;return (D=o,p)|0}g=i-1|0;if(!(g&i)){if(f){c[f>>2]=a|0;c[f+4>>2]=g&k|b&0}o=0;p=k>>>(($L(i|0)|0)>>>0);return (D=o,p)|0}g=(ba(i|0)|0)-(ba(k|0)|0)|0;if(g>>>0<=30){b=g+1|0;i=31-g|0;h=b;a=k<<i|l>>>(b>>>0);b=k>>>(b>>>0);g=0;i=l<<i;break}if(!f){o=0;p=0;return (D=o,p)|0}c[f>>2]=a|0;c[f+4>>2]=j|b&0;o=0;p=0;return (D=o,p)|0}while(0);if(!h){k=i;j=0;i=0}else{m=d|0|0;l=n|e&0;k=TL(m|0,l|0,-1,-1)|0;d=D;j=i;i=0;do{e=j;j=g>>>31|j<<1;g=i|g<<1;e=a<<1|e>>>31|0;n=a>>>31|b<<1|0;UL(k,d,e,n)|0;p=D;o=p>>31|((p|0)<0?-1:0)<<1;i=o&1;a=UL(e,n,o&m,(((p|0)<0?-1:0)>>31|((p|0)<0?-1:0)<<1)&l)|0;b=D;h=h-1|0}while((h|0)!=0);k=j;j=0}h=0;if(f){c[f>>2]=a;c[f+4>>2]=b}o=(g|0)>>>31|(k|h)<<1|(h<<1|g>>>31)&0|j;p=(g<<1|0>>>31)&-2|i;return (D=o,p)|0}function hM(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return Xc[a&63](b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function iM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(0,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function jM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(1,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function kM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(2,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function lM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(3,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function mM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(4,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function nM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(5,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function oM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(6,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function pM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(7,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function qM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(8,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function rM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(9,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function sM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(10,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function tM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(11,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function uM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(12,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function vM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(13,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function wM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(14,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function xM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(15,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function yM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(16,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function zM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(17,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function AM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(18,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function BM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return fa(19,a|0,b|0,c|0,d|0,e|0,f|0,g|0)|0}function CM(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;return Yc[a&63](b|0,c|0,d|0,e|0,f|0,+g)|0}function DM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(0,a|0,b|0,c|0,d|0,e|0,+f)|0}function EM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(1,a|0,b|0,c|0,d|0,e|0,+f)|0}function FM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(2,a|0,b|0,c|0,d|0,e|0,+f)|0}function GM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(3,a|0,b|0,c|0,d|0,e|0,+f)|0}function HM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(4,a|0,b|0,c|0,d|0,e|0,+f)|0}function IM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(5,a|0,b|0,c|0,d|0,e|0,+f)|0}function JM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(6,a|0,b|0,c|0,d|0,e|0,+f)|0}function KM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(7,a|0,b|0,c|0,d|0,e|0,+f)|0}function LM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(8,a|0,b|0,c|0,d|0,e|0,+f)|0}function MM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(9,a|0,b|0,c|0,d|0,e|0,+f)|0}function NM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(10,a|0,b|0,c|0,d|0,e|0,+f)|0}function OM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(11,a|0,b|0,c|0,d|0,e|0,+f)|0}function PM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(12,a|0,b|0,c|0,d|0,e|0,+f)|0}function QM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(13,a|0,b|0,c|0,d|0,e|0,+f)|0}function RM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(14,a|0,b|0,c|0,d|0,e|0,+f)|0}function SM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(15,a|0,b|0,c|0,d|0,e|0,+f)|0}function TM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(16,a|0,b|0,c|0,d|0,e|0,+f)|0}function UM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(17,a|0,b|0,c|0,d|0,e|0,+f)|0}function VM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(18,a|0,b|0,c|0,d|0,e|0,+f)|0}function WM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return ha(19,a|0,b|0,c|0,d|0,e|0,+f)|0}function XM(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Zc[a&63](b|0,c|0,d|0,e|0,f|0)}function YM(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(0,a|0,b|0,c|0,d|0,e|0)}function ZM(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(1,a|0,b|0,c|0,d|0,e|0)}function _M(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(2,a|0,b|0,c|0,d|0,e|0)}function $M(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(3,a|0,b|0,c|0,d|0,e|0)}function aN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(4,a|0,b|0,c|0,d|0,e|0)}function bN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(5,a|0,b|0,c|0,d|0,e|0)}function cN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(6,a|0,b|0,c|0,d|0,e|0)}function dN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(7,a|0,b|0,c|0,d|0,e|0)}function eN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(8,a|0,b|0,c|0,d|0,e|0)}function fN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(9,a|0,b|0,c|0,d|0,e|0)}function gN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(10,a|0,b|0,c|0,d|0,e|0)}function hN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(11,a|0,b|0,c|0,d|0,e|0)}function iN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(12,a|0,b|0,c|0,d|0,e|0)}function jN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(13,a|0,b|0,c|0,d|0,e|0)}function kN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(14,a|0,b|0,c|0,d|0,e|0)}function lN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(15,a|0,b|0,c|0,d|0,e|0)}function mN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(16,a|0,b|0,c|0,d|0,e|0)}function nN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(17,a|0,b|0,c|0,d|0,e|0)}function oN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(18,a|0,b|0,c|0,d|0,e|0)}function pN(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ja(19,a|0,b|0,c|0,d|0,e|0)}function qN(a,b){a=a|0;b=b|0;_c[a&511](b|0)}function rN(a){a=a|0;la(0,a|0)}function sN(a){a=a|0;la(1,a|0)}function tN(a){a=a|0;la(2,a|0)}function uN(a){a=a|0;la(3,a|0)}function vN(a){a=a|0;la(4,a|0)}function wN(a){a=a|0;la(5,a|0)}function xN(a){a=a|0;la(6,a|0)}function yN(a){a=a|0;la(7,a|0)}function zN(a){a=a|0;la(8,a|0)}function AN(a){a=a|0;la(9,a|0)}function BN(a){a=a|0;la(10,a|0)}function CN(a){a=a|0;la(11,a|0)}function DN(a){a=a|0;la(12,a|0)}function EN(a){a=a|0;la(13,a|0)}function FN(a){a=a|0;la(14,a|0)}function GN(a){a=a|0;la(15,a|0)}function HN(a){a=a|0;la(16,a|0)}function IN(a){a=a|0;la(17,a|0)}function JN(a){a=a|0;la(18,a|0)}function KN(a){a=a|0;la(19,a|0)}function LN(a,b,c){a=a|0;b=b|0;c=c|0;$c[a&511](b|0,c|0)}function MN(a,b){a=a|0;b=b|0;na(0,a|0,b|0)}function NN(a,b){a=a|0;b=b|0;na(1,a|0,b|0)}function ON(a,b){a=a|0;b=b|0;na(2,a|0,b|0)}function PN(a,b){a=a|0;b=b|0;na(3,a|0,b|0)}function QN(a,b){a=a|0;b=b|0;na(4,a|0,b|0)}function RN(a,b){a=a|0;b=b|0;na(5,a|0,b|0)}function SN(a,b){a=a|0;b=b|0;na(6,a|0,b|0)}function TN(a,b){a=a|0;b=b|0;na(7,a|0,b|0)}function UN(a,b){a=a|0;b=b|0;na(8,a|0,b|0)}function VN(a,b){a=a|0;b=b|0;na(9,a|0,b|0)}function WN(a,b){a=a|0;b=b|0;na(10,a|0,b|0)}function XN(a,b){a=a|0;b=b|0;na(11,a|0,b|0)}function YN(a,b){a=a|0;b=b|0;na(12,a|0,b|0)}function ZN(a,b){a=a|0;b=b|0;na(13,a|0,b|0)}function _N(a,b){a=a|0;b=b|0;na(14,a|0,b|0)}function $N(a,b){a=a|0;b=b|0;na(15,a|0,b|0)}function aO(a,b){a=a|0;b=b|0;na(16,a|0,b|0)}function bO(a,b){a=a|0;b=b|0;na(17,a|0,b|0)}function cO(a,b){a=a|0;b=b|0;na(18,a|0,b|0)}function dO(a,b){a=a|0;b=b|0;na(19,a|0,b|0)}function eO(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;return ad[a&127](b|0,c|0,d|0,e|0,f|0,g|0)|0}function fO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(0,a|0,b|0,c|0,d|0,e|0,f|0)|0}function gO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(1,a|0,b|0,c|0,d|0,e|0,f|0)|0}function hO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(2,a|0,b|0,c|0,d|0,e|0,f|0)|0}function iO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(3,a|0,b|0,c|0,d|0,e|0,f|0)|0}function jO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(4,a|0,b|0,c|0,d|0,e|0,f|0)|0}function kO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(5,a|0,b|0,c|0,d|0,e|0,f|0)|0}function lO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(6,a|0,b|0,c|0,d|0,e|0,f|0)|0}function mO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(7,a|0,b|0,c|0,d|0,e|0,f|0)|0}function nO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(8,a|0,b|0,c|0,d|0,e|0,f|0)|0}function oO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(9,a|0,b|0,c|0,d|0,e|0,f|0)|0}function pO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(10,a|0,b|0,c|0,d|0,e|0,f|0)|0}function qO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(11,a|0,b|0,c|0,d|0,e|0,f|0)|0}function rO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(12,a|0,b|0,c|0,d|0,e|0,f|0)|0}function sO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(13,a|0,b|0,c|0,d|0,e|0,f|0)|0}function tO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(14,a|0,b|0,c|0,d|0,e|0,f|0)|0}function uO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(15,a|0,b|0,c|0,d|0,e|0,f|0)|0}function vO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(16,a|0,b|0,c|0,d|0,e|0,f|0)|0}function wO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(17,a|0,b|0,c|0,d|0,e|0,f|0)|0}function xO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(18,a|0,b|0,c|0,d|0,e|0,f|0)|0}function yO(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return pa(19,a|0,b|0,c|0,d|0,e|0,f|0)|0}function zO(a,b){a=a|0;b=b|0;return bd[a&255](b|0)|0}function AO(a){a=a|0;return ra(0,a|0)|0}function BO(a){a=a|0;return ra(1,a|0)|0}function CO(a){a=a|0;return ra(2,a|0)|0}function DO(a){a=a|0;return ra(3,a|0)|0}function EO(a){a=a|0;return ra(4,a|0)|0}function FO(a){a=a|0;return ra(5,a|0)|0}function GO(a){a=a|0;return ra(6,a|0)|0}function HO(a){a=a|0;return ra(7,a|0)|0}function IO(a){a=a|0;return ra(8,a|0)|0}function JO(a){a=a|0;return ra(9,a|0)|0}function KO(a){a=a|0;return ra(10,a|0)|0}function LO(a){a=a|0;return ra(11,a|0)|0}function MO(a){a=a|0;return ra(12,a|0)|0}function NO(a){a=a|0;return ra(13,a|0)|0}function OO(a){a=a|0;return ra(14,a|0)|0}function PO(a){a=a|0;return ra(15,a|0)|0}function QO(a){a=a|0;return ra(16,a|0)|0}function RO(a){a=a|0;return ra(17,a|0)|0}function SO(a){a=a|0;return ra(18,a|0)|0}function TO(a){a=a|0;return ra(19,a|0)|0}function UO(a,b,c,d,e,f,g,h,i){a=a|0;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;return cd[a&63](+b,+c,+d,+e,+f,+g,+h,+i)|0}function VO(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(0,+a,+b,+c,+d,+e,+f,+g,+h)|0}function WO(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(1,+a,+b,+c,+d,+e,+f,+g,+h)|0}function XO(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(2,+a,+b,+c,+d,+e,+f,+g,+h)|0}function YO(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(3,+a,+b,+c,+d,+e,+f,+g,+h)|0}function ZO(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(4,+a,+b,+c,+d,+e,+f,+g,+h)|0}function _O(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(5,+a,+b,+c,+d,+e,+f,+g,+h)|0}function $O(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(6,+a,+b,+c,+d,+e,+f,+g,+h)|0}function aP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(7,+a,+b,+c,+d,+e,+f,+g,+h)|0}function bP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(8,+a,+b,+c,+d,+e,+f,+g,+h)|0}function cP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(9,+a,+b,+c,+d,+e,+f,+g,+h)|0}function dP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(10,+a,+b,+c,+d,+e,+f,+g,+h)|0}function eP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(11,+a,+b,+c,+d,+e,+f,+g,+h)|0}function fP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(12,+a,+b,+c,+d,+e,+f,+g,+h)|0}function gP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(13,+a,+b,+c,+d,+e,+f,+g,+h)|0}function hP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(14,+a,+b,+c,+d,+e,+f,+g,+h)|0}function iP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(15,+a,+b,+c,+d,+e,+f,+g,+h)|0}function jP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(16,+a,+b,+c,+d,+e,+f,+g,+h)|0}function kP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(17,+a,+b,+c,+d,+e,+f,+g,+h)|0}function lP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(18,+a,+b,+c,+d,+e,+f,+g,+h)|0}function mP(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;return ta(19,+a,+b,+c,+d,+e,+f,+g,+h)|0}function nP(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;return dd[a&63](b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0)|0}function oP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(0,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function pP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(1,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function qP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(2,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function rP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(3,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function sP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(4,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function tP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(5,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function uP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(6,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function vP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(7,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function wP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(8,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function xP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(9,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function yP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(10,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function zP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(11,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function AP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(12,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function BP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(13,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function CP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(14,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function DP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(15,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function EP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(16,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function FP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(17,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function GP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(18,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function HP(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;return va(19,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)|0}function IP(a,b,c,d){a=a|0;b=b|0;c=+c;d=+d;ed[a&63](b|0,+c,+d)}function JP(a,b,c){a=a|0;b=+b;c=+c;xa(0,a|0,+b,+c)}function KP(a,b,c){a=a|0;b=+b;c=+c;xa(1,a|0,+b,+c)}function LP(a,b,c){a=a|0;b=+b;c=+c;xa(2,a|0,+b,+c)}function MP(a,b,c){a=a|0;b=+b;c=+c;xa(3,a|0,+b,+c)}function NP(a,b,c){a=a|0;b=+b;c=+c;xa(4,a|0,+b,+c)}function OP(a,b,c){a=a|0;b=+b;c=+c;xa(5,a|0,+b,+c)}function PP(a,b,c){a=a|0;b=+b;c=+c;xa(6,a|0,+b,+c)}function QP(a,b,c){a=a|0;b=+b;c=+c;xa(7,a|0,+b,+c)}function RP(a,b,c){a=a|0;b=+b;c=+c;xa(8,a|0,+b,+c)}function SP(a,b,c){a=a|0;b=+b;c=+c;xa(9,a|0,+b,+c)}function TP(a,b,c){a=a|0;b=+b;c=+c;xa(10,a|0,+b,+c)}function UP(a,b,c){a=a|0;b=+b;c=+c;xa(11,a|0,+b,+c)}function VP(a,b,c){a=a|0;b=+b;c=+c;xa(12,a|0,+b,+c)}function WP(a,b,c){a=a|0;b=+b;c=+c;xa(13,a|0,+b,+c)}function XP(a,b,c){a=a|0;b=+b;c=+c;xa(14,a|0,+b,+c)}function YP(a,b,c){a=a|0;b=+b;c=+c;xa(15,a|0,+b,+c)}function ZP(a,b,c){a=a|0;b=+b;c=+c;xa(16,a|0,+b,+c)}function _P(a,b,c){a=a|0;b=+b;c=+c;xa(17,a|0,+b,+c)}function $P(a,b,c){a=a|0;b=+b;c=+c;xa(18,a|0,+b,+c)}function aQ(a,b,c){a=a|0;b=+b;c=+c;xa(19,a|0,+b,+c)}function bQ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return fd[a&127](b|0,c|0,d|0)|0}function cQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(0,a|0,b|0,c|0)|0}function dQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(1,a|0,b|0,c|0)|0}function eQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(2,a|0,b|0,c|0)|0}function fQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(3,a|0,b|0,c|0)|0}function gQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(4,a|0,b|0,c|0)|0}function hQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(5,a|0,b|0,c|0)|0}function iQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(6,a|0,b|0,c|0)|0}function jQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(7,a|0,b|0,c|0)|0}function kQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(8,a|0,b|0,c|0)|0}function lQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(9,a|0,b|0,c|0)|0}function mQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(10,a|0,b|0,c|0)|0}function nQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(11,a|0,b|0,c|0)|0}function oQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(12,a|0,b|0,c|0)|0}function pQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(13,a|0,b|0,c|0)|0}function qQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(14,a|0,b|0,c|0)|0}function rQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(15,a|0,b|0,c|0)|0}function sQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(16,a|0,b|0,c|0)|0}function tQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(17,a|0,b|0,c|0)|0}function uQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(18,a|0,b|0,c|0)|0}function vQ(a,b,c){a=a|0;b=b|0;c=c|0;return za(19,a|0,b|0,c|0)|0}function wQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;gd[a&63](b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0,p|0)}function xQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(0,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function yQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(1,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function zQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(2,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function AQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(3,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function BQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(4,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function CQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(5,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function DQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(6,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function EQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(7,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function FQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(8,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function GQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(9,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function HQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(10,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function IQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(11,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function JQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(12,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function KQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(13,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function LQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(14,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function MQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(15,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function NQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(16,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function OQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(17,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function PQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(18,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function QQ(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;Ba(19,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0,l|0,m|0,n|0,o|0)}function RQ(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;hd[a&63](b|0,c|0,d|0,e|0,f|0,g|0)}function SQ(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(0,a|0,b|0,c|0,d|0,e|0,f|0)}function TQ(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(1,a|0,b|0,c|0,d|0,e|0,f|0)}function UQ(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(2,a|0,b|0,c|0,d|0,e|0,f|0)}function VQ(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(3,a|0,b|0,c|0,d|0,e|0,f|0)}function WQ(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(4,a|0,b|0,c|0,d|0,e|0,f|0)}function XQ(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(5,a|0,b|0,c|0,d|0,e|0,f|0)}function YQ(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(6,a|0,b|0,c|0,d|0,e|0,f|0)}function ZQ(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(7,a|0,b|0,c|0,d|0,e|0,f|0)}function _Q(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(8,a|0,b|0,c|0,d|0,e|0,f|0)}function $Q(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(9,a|0,b|0,c|0,d|0,e|0,f|0)}function aR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(10,a|0,b|0,c|0,d|0,e|0,f|0)}function bR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(11,a|0,b|0,c|0,d|0,e|0,f|0)}function cR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(12,a|0,b|0,c|0,d|0,e|0,f|0)}function dR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(13,a|0,b|0,c|0,d|0,e|0,f|0)}function eR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(14,a|0,b|0,c|0,d|0,e|0,f|0)}function fR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(15,a|0,b|0,c|0,d|0,e|0,f|0)}function gR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(16,a|0,b|0,c|0,d|0,e|0,f|0)}function hR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(17,a|0,b|0,c|0,d|0,e|0,f|0)}function iR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(18,a|0,b|0,c|0,d|0,e|0,f|0)}function jR(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;Da(19,a|0,b|0,c|0,d|0,e|0,f|0)}function kR(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return +id[a&63](b|0,c|0,d|0,e|0)}function lR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(0,a|0,b|0,c|0,d|0)}function mR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(1,a|0,b|0,c|0,d|0)}function nR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(2,a|0,b|0,c|0,d|0)}function oR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(3,a|0,b|0,c|0,d|0)}function pR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(4,a|0,b|0,c|0,d|0)}function qR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(5,a|0,b|0,c|0,d|0)}function rR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(6,a|0,b|0,c|0,d|0)}function sR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(7,a|0,b|0,c|0,d|0)}function tR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(8,a|0,b|0,c|0,d|0)}function uR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(9,a|0,b|0,c|0,d|0)}function vR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(10,a|0,b|0,c|0,d|0)}function wR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(11,a|0,b|0,c|0,d|0)}function xR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(12,a|0,b|0,c|0,d|0)}function yR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(13,a|0,b|0,c|0,d|0)}function zR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(14,a|0,b|0,c|0,d|0)}function AR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(15,a|0,b|0,c|0,d|0)}function BR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(16,a|0,b|0,c|0,d|0)}function CR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(17,a|0,b|0,c|0,d|0)}function DR(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(18,a|0,b|0,c|0,d|0)}function ER(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +Fa(19,a|0,b|0,c|0,d|0)}function FR(a,b,c,d,e,f){a=a|0;b=b|0;c=+c;d=d|0;e=e|0;f=+f;return jd[a&63](b|0,+c,d|0,e|0,+f)|0}function GR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(0,a|0,+b,c|0,d|0,+e)|0}function HR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(1,a|0,+b,c|0,d|0,+e)|0}function IR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(2,a|0,+b,c|0,d|0,+e)|0}function JR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(3,a|0,+b,c|0,d|0,+e)|0}function KR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(4,a|0,+b,c|0,d|0,+e)|0}function LR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(5,a|0,+b,c|0,d|0,+e)|0}function MR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(6,a|0,+b,c|0,d|0,+e)|0}function NR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(7,a|0,+b,c|0,d|0,+e)|0}function OR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(8,a|0,+b,c|0,d|0,+e)|0}function PR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(9,a|0,+b,c|0,d|0,+e)|0}function QR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(10,a|0,+b,c|0,d|0,+e)|0}function RR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(11,a|0,+b,c|0,d|0,+e)|0}function SR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(12,a|0,+b,c|0,d|0,+e)|0}function TR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(13,a|0,+b,c|0,d|0,+e)|0}function UR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(14,a|0,+b,c|0,d|0,+e)|0}function VR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(15,a|0,+b,c|0,d|0,+e)|0}function WR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(16,a|0,+b,c|0,d|0,+e)|0}function XR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(17,a|0,+b,c|0,d|0,+e)|0}function YR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(18,a|0,+b,c|0,d|0,+e)|0}function ZR(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;return Ha(19,a|0,+b,c|0,d|0,+e)|0}function _R(a,b,c,d,e){a=a|0;b=b|0;c=+c;d=+d;e=+e;kd[a&63](b|0,+c,+d,+e)}function $R(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(0,a|0,+b,+c,+d)}function aS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(1,a|0,+b,+c,+d)}function bS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(2,a|0,+b,+c,+d)}function cS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(3,a|0,+b,+c,+d)}function dS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(4,a|0,+b,+c,+d)}function eS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(5,a|0,+b,+c,+d)}function fS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(6,a|0,+b,+c,+d)}function gS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(7,a|0,+b,+c,+d)}function hS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(8,a|0,+b,+c,+d)}function iS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(9,a|0,+b,+c,+d)}function jS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(10,a|0,+b,+c,+d)}function kS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(11,a|0,+b,+c,+d)}function lS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(12,a|0,+b,+c,+d)}function mS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(13,a|0,+b,+c,+d)}function nS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(14,a|0,+b,+c,+d)}function oS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(15,a|0,+b,+c,+d)}function pS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(16,a|0,+b,+c,+d)}function qS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(17,a|0,+b,+c,+d)}function rS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(18,a|0,+b,+c,+d)}function sS(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;Ja(19,a|0,+b,+c,+d)}function tS(a,b){a=a|0;b=b|0;return +ld[a&63](b|0)}function uS(a){a=a|0;return +La(0,a|0)}function vS(a){a=a|0;return +La(1,a|0)}function wS(a){a=a|0;return +La(2,a|0)}function xS(a){a=a|0;return +La(3,a|0)}function yS(a){a=a|0;return +La(4,a|0)}function zS(a){a=a|0;return +La(5,a|0)}function AS(a){a=a|0;return +La(6,a|0)}function BS(a){a=a|0;return +La(7,a|0)}function CS(a){a=a|0;return +La(8,a|0)}function DS(a){a=a|0;return +La(9,a|0)}function ES(a){a=a|0;return +La(10,a|0)}function FS(a){a=a|0;return +La(11,a|0)}function GS(a){a=a|0;return +La(12,a|0)}function HS(a){a=a|0;return +La(13,a|0)}function IS(a){a=a|0;return +La(14,a|0)}function JS(a){a=a|0;return +La(15,a|0)}function KS(a){a=a|0;return +La(16,a|0)}function LS(a){a=a|0;return +La(17,a|0)}function MS(a){a=a|0;return +La(18,a|0)}function NS(a){a=a|0;return +La(19,a|0)}function OS(a,b,c,d,e,f,g,h,i,j,k,l,m){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;return md[a&63](b|0,c|0,d|0,e|0,+f,+g,+h,+i,+j,+k,+l,+m)|0}function PS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(0,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function QS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(1,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function RS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(2,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function SS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(3,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function TS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(4,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function US(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(5,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function VS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(6,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function WS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(7,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function XS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(8,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function YS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(9,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function ZS(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(10,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function _S(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(11,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function $S(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(12,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function aT(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(13,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function bT(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(14,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function cT(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(15,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function dT(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(16,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function eT(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(17,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function fT(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(18,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function gT(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;return Na(19,a|0,b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l)|0}function hT(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;nd[a&63](b|0,c|0,d|0,e|0,f|0,g|0,h|0)}function iT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(0,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function jT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(1,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function kT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(2,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function lT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(3,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function mT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(4,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function nT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(5,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function oT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(6,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function pT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(7,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function qT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(8,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function rT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(9,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function sT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(10,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function tT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(11,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function uT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(12,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function vT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(13,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function wT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(14,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function xT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(15,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function yT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(16,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function zT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(17,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function AT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(18,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function BT(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;Pa(19,a|0,b|0,c|0,d|0,e|0,f|0,g|0)}function CT(a,b,c,d,e){a=a|0;b=b|0;c=+c;d=+d;e=+e;return od[a&63](b|0,+c,+d,+e)|0}function DT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(0,a|0,+b,+c,+d)|0}function ET(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(1,a|0,+b,+c,+d)|0}function FT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(2,a|0,+b,+c,+d)|0}function GT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(3,a|0,+b,+c,+d)|0}function HT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(4,a|0,+b,+c,+d)|0}function IT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(5,a|0,+b,+c,+d)|0}function JT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(6,a|0,+b,+c,+d)|0}function KT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(7,a|0,+b,+c,+d)|0}function LT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(8,a|0,+b,+c,+d)|0}function MT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(9,a|0,+b,+c,+d)|0}function NT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(10,a|0,+b,+c,+d)|0}function OT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(11,a|0,+b,+c,+d)|0}function PT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(12,a|0,+b,+c,+d)|0}function QT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(13,a|0,+b,+c,+d)|0}function RT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(14,a|0,+b,+c,+d)|0}function ST(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(15,a|0,+b,+c,+d)|0}function TT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(16,a|0,+b,+c,+d)|0}function UT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(17,a|0,+b,+c,+d)|0}function VT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(18,a|0,+b,+c,+d)|0}function WT(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;return Ra(19,a|0,+b,+c,+d)|0}function XT(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;pd[a&63](b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function YT(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(0,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function ZT(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(1,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function _T(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(2,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function $T(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(3,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function aU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(4,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function bU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(5,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function cU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(6,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function dU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(7,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function eU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(8,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function fU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(9,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function gU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(10,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function hU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(11,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function iU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(12,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function jU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(13,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function kU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(14,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function lU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(15,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function mU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(16,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function nU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(17,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function oU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(18,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function pU(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;Ta(19,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)}function qU(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;qd[a&63](b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0,k|0)}function rU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(0,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function sU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(1,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function tU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(2,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function uU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(3,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function vU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(4,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function wU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(5,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function xU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(6,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function yU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(7,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function zU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(8,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function AU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(9,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function BU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(10,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function CU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(11,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function DU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(12,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function EU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(13,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function FU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(14,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function GU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(15,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function HU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(16,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function IU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(17,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function JU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(18,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function KU(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;Va(19,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0,j|0)}function LU(a,b,c){a=a|0;b=b|0;c=c|0;return rd[a&127](b|0,c|0)|0}function MU(a,b){a=a|0;b=b|0;return Xa(0,a|0,b|0)|0}function NU(a,b){a=a|0;b=b|0;return Xa(1,a|0,b|0)|0}function OU(a,b){a=a|0;b=b|0;return Xa(2,a|0,b|0)|0}function PU(a,b){a=a|0;b=b|0;return Xa(3,a|0,b|0)|0}function QU(a,b){a=a|0;b=b|0;return Xa(4,a|0,b|0)|0}function RU(a,b){a=a|0;b=b|0;return Xa(5,a|0,b|0)|0}function SU(a,b){a=a|0;b=b|0;return Xa(6,a|0,b|0)|0}function TU(a,b){a=a|0;b=b|0;return Xa(7,a|0,b|0)|0}function UU(a,b){a=a|0;b=b|0;return Xa(8,a|0,b|0)|0}function VU(a,b){a=a|0;b=b|0;return Xa(9,a|0,b|0)|0}function WU(a,b){a=a|0;b=b|0;return Xa(10,a|0,b|0)|0}function XU(a,b){a=a|0;b=b|0;return Xa(11,a|0,b|0)|0}function YU(a,b){a=a|0;b=b|0;return Xa(12,a|0,b|0)|0}function ZU(a,b){a=a|0;b=b|0;return Xa(13,a|0,b|0)|0}function _U(a,b){a=a|0;b=b|0;return Xa(14,a|0,b|0)|0}function $U(a,b){a=a|0;b=b|0;return Xa(15,a|0,b|0)|0}function aV(a,b){a=a|0;b=b|0;return Xa(16,a|0,b|0)|0}function bV(a,b){a=a|0;b=b|0;return Xa(17,a|0,b|0)|0}function cV(a,b){a=a|0;b=b|0;return Xa(18,a|0,b|0)|0}function dV(a,b){a=a|0;b=b|0;return Xa(19,a|0,b|0)|0}function eV(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;return sd[a&127](b|0,c|0,d|0,e|0,f|0)|0}function fV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(0,a|0,b|0,c|0,d|0,e|0)|0}function gV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(1,a|0,b|0,c|0,d|0,e|0)|0}function hV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(2,a|0,b|0,c|0,d|0,e|0)|0}function iV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(3,a|0,b|0,c|0,d|0,e|0)|0}function jV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(4,a|0,b|0,c|0,d|0,e|0)|0}function kV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(5,a|0,b|0,c|0,d|0,e|0)|0}function lV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(6,a|0,b|0,c|0,d|0,e|0)|0}function mV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(7,a|0,b|0,c|0,d|0,e|0)|0}function nV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(8,a|0,b|0,c|0,d|0,e|0)|0}function oV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(9,a|0,b|0,c|0,d|0,e|0)|0}function pV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(10,a|0,b|0,c|0,d|0,e|0)|0}function qV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(11,a|0,b|0,c|0,d|0,e|0)|0}function rV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(12,a|0,b|0,c|0,d|0,e|0)|0}function sV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(13,a|0,b|0,c|0,d|0,e|0)|0}function tV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(14,a|0,b|0,c|0,d|0,e|0)|0}function uV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(15,a|0,b|0,c|0,d|0,e|0)|0}function vV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(16,a|0,b|0,c|0,d|0,e|0)|0}function wV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(17,a|0,b|0,c|0,d|0,e|0)|0}function xV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(18,a|0,b|0,c|0,d|0,e|0)|0}function yV(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Za(19,a|0,b|0,c|0,d|0,e|0)|0}function zV(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return +td[a&63](b|0,c|0,d|0)}function AV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(0,a|0,b|0,c|0)}function BV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(1,a|0,b|0,c|0)}function CV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(2,a|0,b|0,c|0)}function DV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(3,a|0,b|0,c|0)}function EV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(4,a|0,b|0,c|0)}function FV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(5,a|0,b|0,c|0)}function GV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(6,a|0,b|0,c|0)}function HV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(7,a|0,b|0,c|0)}function IV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(8,a|0,b|0,c|0)}function JV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(9,a|0,b|0,c|0)}function KV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(10,a|0,b|0,c|0)}function LV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(11,a|0,b|0,c|0)}function MV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(12,a|0,b|0,c|0)}function NV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(13,a|0,b|0,c|0)}function OV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(14,a|0,b|0,c|0)}function PV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(15,a|0,b|0,c|0)}function QV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(16,a|0,b|0,c|0)}function RV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(17,a|0,b|0,c|0)}function SV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(18,a|0,b|0,c|0)}function TV(a,b,c){a=a|0;b=b|0;c=c|0;return +$a(19,a|0,b|0,c|0)}function UV(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;t=+t;return ud[a&63](b|0,c|0,d|0,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s,+t)|0}function VV(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(0,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function WV(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(1,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function XV(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(2,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function YV(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(3,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function ZV(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(4,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function _V(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(5,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function $V(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(6,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function aW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(7,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function bW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(8,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function cW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(9,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function dW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(10,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function eW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(11,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function fW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(12,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function gW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(13,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function hW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(14,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function iW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(15,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function jW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(16,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function kW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(17,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function lW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(18,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function mW(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;return bb(19,a|0,b|0,c|0,+d,+e,+f,+g,+h,+i,+j,+k,+l,+m,+n,+o,+p,+q,+r,+s)|0}function nW(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=+h;i=i|0;vd[a&63](b|0,c|0,d|0,e|0,f|0,g|0,+h,i|0)}function oW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(0,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function pW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(1,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function qW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(2,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function rW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(3,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function sW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(4,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function tW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(5,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function uW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(6,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function vW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(7,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function wW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(8,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function xW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(9,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function yW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(10,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function zW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(11,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function AW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(12,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function BW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(13,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function CW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(14,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function DW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(15,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function EW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(16,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function FW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(17,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function GW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(18,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function HW(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;db(19,a|0,b|0,c|0,d|0,e|0,f|0,+g,h|0)}function IW(a,b,c){a=a|0;b=b|0;c=c|0;return +wd[a&63](b|0,c|0)}function JW(a,b){a=a|0;b=b|0;return +fb(0,a|0,b|0)}function KW(a,b){a=a|0;b=b|0;return +fb(1,a|0,b|0)}function LW(a,b){a=a|0;b=b|0;return +fb(2,a|0,b|0)}function MW(a,b){a=a|0;b=b|0;return +fb(3,a|0,b|0)}function NW(a,b){a=a|0;b=b|0;return +fb(4,a|0,b|0)}function OW(a,b){a=a|0;b=b|0;return +fb(5,a|0,b|0)}function PW(a,b){a=a|0;b=b|0;return +fb(6,a|0,b|0)}function QW(a,b){a=a|0;b=b|0;return +fb(7,a|0,b|0)}function RW(a,b){a=a|0;b=b|0;return +fb(8,a|0,b|0)}function SW(a,b){a=a|0;b=b|0;return +fb(9,a|0,b|0)}function TW(a,b){a=a|0;b=b|0;return +fb(10,a|0,b|0)}function UW(a,b){a=a|0;b=b|0;return +fb(11,a|0,b|0)}function VW(a,b){a=a|0;b=b|0;return +fb(12,a|0,b|0)}function WW(a,b){a=a|0;b=b|0;return +fb(13,a|0,b|0)}function XW(a,b){a=a|0;b=b|0;return +fb(14,a|0,b|0)}function YW(a,b){a=a|0;b=b|0;return +fb(15,a|0,b|0)}function ZW(a,b){a=a|0;b=b|0;return +fb(16,a|0,b|0)}function _W(a,b){a=a|0;b=b|0;return +fb(17,a|0,b|0)}function $W(a,b){a=a|0;b=b|0;return +fb(18,a|0,b|0)}function aX(a,b){a=a|0;b=b|0;return +fb(19,a|0,b|0)}function bX(a){a=a|0;return xd[a&63]()|0}function cX(){return hb(0)|0}function dX(){return hb(1)|0}function eX(){return hb(2)|0}function fX(){return hb(3)|0}function gX(){return hb(4)|0}function hX(){return hb(5)|0}function iX(){return hb(6)|0}function jX(){return hb(7)|0}function kX(){return hb(8)|0}function lX(){return hb(9)|0}function mX(){return hb(10)|0}function nX(){return hb(11)|0}function oX(){return hb(12)|0}function pX(){return hb(13)|0}function qX(){return hb(14)|0}function rX(){return hb(15)|0}function sX(){return hb(16)|0}function tX(){return hb(17)|0}function uX(){return hb(18)|0}function vX(){return hb(19)|0}function wX(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return yd[a&63](b|0,c|0,d|0,+e)|0}function xX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(0,a|0,b|0,c|0,+d)|0}function yX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(1,a|0,b|0,c|0,+d)|0}function zX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(2,a|0,b|0,c|0,+d)|0}function AX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(3,a|0,b|0,c|0,+d)|0}function BX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(4,a|0,b|0,c|0,+d)|0}function CX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(5,a|0,b|0,c|0,+d)|0}function DX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(6,a|0,b|0,c|0,+d)|0}function EX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(7,a|0,b|0,c|0,+d)|0}function FX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(8,a|0,b|0,c|0,+d)|0}function GX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(9,a|0,b|0,c|0,+d)|0}function HX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(10,a|0,b|0,c|0,+d)|0}function IX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(11,a|0,b|0,c|0,+d)|0}function JX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(12,a|0,b|0,c|0,+d)|0}function KX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(13,a|0,b|0,c|0,+d)|0}function LX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(14,a|0,b|0,c|0,+d)|0}function MX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(15,a|0,b|0,c|0,+d)|0}function NX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(16,a|0,b|0,c|0,+d)|0}function OX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(17,a|0,b|0,c|0,+d)|0}function PX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(18,a|0,b|0,c|0,+d)|0}function QX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;return jb(19,a|0,b|0,c|0,+d)|0}function RX(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return zd[a&127](b|0,c|0,d|0,e|0)|0}function SX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(0,a|0,b|0,c|0,d|0)|0}function TX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(1,a|0,b|0,c|0,d|0)|0}function UX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(2,a|0,b|0,c|0,d|0)|0}function VX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(3,a|0,b|0,c|0,d|0)|0}function WX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(4,a|0,b|0,c|0,d|0)|0}function XX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(5,a|0,b|0,c|0,d|0)|0}function YX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(6,a|0,b|0,c|0,d|0)|0}function ZX(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(7,a|0,b|0,c|0,d|0)|0}function _X(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(8,a|0,b|0,c|0,d|0)|0}function $X(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(9,a|0,b|0,c|0,d|0)|0}function aY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(10,a|0,b|0,c|0,d|0)|0}function bY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(11,a|0,b|0,c|0,d|0)|0}function cY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(12,a|0,b|0,c|0,d|0)|0}function dY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(13,a|0,b|0,c|0,d|0)|0}function eY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(14,a|0,b|0,c|0,d|0)|0}function fY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(15,a|0,b|0,c|0,d|0)|0}function gY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(16,a|0,b|0,c|0,d|0)|0}function hY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(17,a|0,b|0,c|0,d|0)|0}function iY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(18,a|0,b|0,c|0,d|0)|0}function jY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return lb(19,a|0,b|0,c|0,d|0)|0}function kY(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;Ad[a&127](b|0,c|0,d|0)}function lY(a,b,c){a=a|0;b=b|0;c=c|0;nb(0,a|0,b|0,c|0)}function mY(a,b,c){a=a|0;b=b|0;c=c|0;nb(1,a|0,b|0,c|0)}function nY(a,b,c){a=a|0;b=b|0;c=c|0;nb(2,a|0,b|0,c|0)}function oY(a,b,c){a=a|0;b=b|0;c=c|0;nb(3,a|0,b|0,c|0)}function pY(a,b,c){a=a|0;b=b|0;c=c|0;nb(4,a|0,b|0,c|0)}function qY(a,b,c){a=a|0;b=b|0;c=c|0;nb(5,a|0,b|0,c|0)}function rY(a,b,c){a=a|0;b=b|0;c=c|0;nb(6,a|0,b|0,c|0)}function sY(a,b,c){a=a|0;b=b|0;c=c|0;nb(7,a|0,b|0,c|0)}function tY(a,b,c){a=a|0;b=b|0;c=c|0;nb(8,a|0,b|0,c|0)}function uY(a,b,c){a=a|0;b=b|0;c=c|0;nb(9,a|0,b|0,c|0)}function vY(a,b,c){a=a|0;b=b|0;c=c|0;nb(10,a|0,b|0,c|0)}function wY(a,b,c){a=a|0;b=b|0;c=c|0;nb(11,a|0,b|0,c|0)}function xY(a,b,c){a=a|0;b=b|0;c=c|0;nb(12,a|0,b|0,c|0)}function yY(a,b,c){a=a|0;b=b|0;c=c|0;nb(13,a|0,b|0,c|0)}function zY(a,b,c){a=a|0;b=b|0;c=c|0;nb(14,a|0,b|0,c|0)}function AY(a,b,c){a=a|0;b=b|0;c=c|0;nb(15,a|0,b|0,c|0)}function BY(a,b,c){a=a|0;b=b|0;c=c|0;nb(16,a|0,b|0,c|0)}function CY(a,b,c){a=a|0;b=b|0;c=c|0;nb(17,a|0,b|0,c|0)}function DY(a,b,c){a=a|0;b=b|0;c=c|0;nb(18,a|0,b|0,c|0)}function EY(a,b,c){a=a|0;b=b|0;c=c|0;nb(19,a|0,b|0,c|0)}function FY(a){a=a|0;Bd[a&63]()}function GY(){pb(0)}function HY(){pb(1)}function IY(){pb(2)}function JY(){pb(3)}function KY(){pb(4)}function LY(){pb(5)}function MY(){pb(6)}function NY(){pb(7)}function OY(){pb(8)}function PY(){pb(9)}function QY(){pb(10)}function RY(){pb(11)}function SY(){pb(12)}function TY(){pb(13)}function UY(){pb(14)}function VY(){pb(15)}function WY(){pb(16)}function XY(){pb(17)}function YY(){pb(18)}function ZY(){pb(19)}function _Y(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;return Cd[a&63](b|0,c|0,d|0,e|0,f|0,g|0,h|0,i|0)|0}function $Y(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(0,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function aZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(1,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function bZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(2,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function cZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(3,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function dZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(4,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function eZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(5,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function fZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(6,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function gZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(7,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function hZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(8,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function iZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(9,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function jZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(10,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function kZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(11,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function lZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(12,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function mZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(13,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function nZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(14,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function oZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(15,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function pZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(16,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function qZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(17,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function rZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(18,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function sZ(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;return rb(19,a|0,b|0,c|0,d|0,e|0,f|0,g|0,h|0)|0}function tZ(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;return Dd[a&63](b|0,c|0,d|0,e|0,+f)|0}function uZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(0,a|0,b|0,c|0,d|0,+e)|0}function vZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(1,a|0,b|0,c|0,d|0,+e)|0}function wZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(2,a|0,b|0,c|0,d|0,+e)|0}function xZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(3,a|0,b|0,c|0,d|0,+e)|0}function yZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(4,a|0,b|0,c|0,d|0,+e)|0}function zZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(5,a|0,b|0,c|0,d|0,+e)|0}function AZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(6,a|0,b|0,c|0,d|0,+e)|0}function BZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(7,a|0,b|0,c|0,d|0,+e)|0}function CZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(8,a|0,b|0,c|0,d|0,+e)|0}function DZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(9,a|0,b|0,c|0,d|0,+e)|0}function EZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(10,a|0,b|0,c|0,d|0,+e)|0}function FZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(11,a|0,b|0,c|0,d|0,+e)|0}function GZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(12,a|0,b|0,c|0,d|0,+e)|0}function HZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(13,a|0,b|0,c|0,d|0,+e)|0}function IZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(14,a|0,b|0,c|0,d|0,+e)|0}function JZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(15,a|0,b|0,c|0,d|0,+e)|0}function KZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(16,a|0,b|0,c|0,d|0,+e)|0}function LZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(17,a|0,b|0,c|0,d|0,+e)|0}function MZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(18,a|0,b|0,c|0,d|0,+e)|0}function NZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;return tb(19,a|0,b|0,c|0,d|0,+e)|0}function OZ(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;Ed[a&127](b|0,c|0,d|0,e|0)}function PZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(0,a|0,b|0,c|0,d|0)}function QZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(1,a|0,b|0,c|0,d|0)}function RZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(2,a|0,b|0,c|0,d|0)}function SZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(3,a|0,b|0,c|0,d|0)}function TZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(4,a|0,b|0,c|0,d|0)}function UZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(5,a|0,b|0,c|0,d|0)}function VZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(6,a|0,b|0,c|0,d|0)}function WZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(7,a|0,b|0,c|0,d|0)}function XZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(8,a|0,b|0,c|0,d|0)}function YZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(9,a|0,b|0,c|0,d|0)}function ZZ(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(10,a|0,b|0,c|0,d|0)}function _Z(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(11,a|0,b|0,c|0,d|0)}function $Z(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(12,a|0,b|0,c|0,d|0)}function a_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(13,a|0,b|0,c|0,d|0)}function b_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(14,a|0,b|0,c|0,d|0)}function c_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(15,a|0,b|0,c|0,d|0)}function d_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(16,a|0,b|0,c|0,d|0)}function e_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(17,a|0,b|0,c|0,d|0)}function f_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(18,a|0,b|0,c|0,d|0)}function g_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;vb(19,a|0,b|0,c|0,d|0)}function h_(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;ca(0);return 0}function i_(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;ca(1);return 0}function j_(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ca(2)}function k_(a){a=a|0;ca(3)}function l_(a,b){a=a|0;b=b|0;ca(4)}function m_(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;ca(5);return 0}function n_(a){a=a|0;ca(6);return 0}function o_(a){a=a|0;return pc(a|0)|0}function p_(a){a=a|0;return Pc(a|0)|0}function q_(a){a=a|0;return Ic(a|0)|0}function r_(a,b,c,d,e,f,g,h){a=+a;b=+b;c=+c;d=+d;e=+e;f=+f;g=+g;h=+h;ca(7);return 0}function s_(a,b,c,d,e,f,g,h,i,j,k){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;ca(8);return 0}function t_(a,b,c){a=a|0;b=+b;c=+c;ca(9)}function u_(a,b,c){a=a|0;b=b|0;c=c|0;ca(10);return 0}function v_(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;ca(11)}function w_(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;ca(12)}function x_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;ca(13);return 0.0}function y_(a,b,c,d,e){a=a|0;b=+b;c=c|0;d=d|0;e=+e;ca(14);return 0}function z_(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;ca(15)}function A_(a){a=a|0;ca(16);return 0.0}function B_(a,b,c,d,e,f,g,h,i,j,k,l){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;ca(17);return 0}function C_(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;ca(18)}function D_(a,b,c,d){a=a|0;b=+b;c=+c;d=+d;ca(19);return 0}function E_(a,b,c,d,e,f,g,h,i){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;ca(20)}function F_(a,b,c,d,e,f,g,h,i,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;ca(21)}function G_(a,b){a=a|0;b=b|0;ca(22);return 0}function H_(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;ca(23);return 0}function I_(a,b,c){a=a|0;b=b|0;c=c|0;ca(24);return 0.0}function J_(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;c=c|0;d=+d;e=+e;f=+f;g=+g;h=+h;i=+i;j=+j;k=+k;l=+l;m=+m;n=+n;o=+o;p=+p;q=+q;r=+r;s=+s;ca(25);return 0}function K_(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;h=h|0;ca(26)}function L_(a,b){a=a|0;b=b|0;ca(27);return 0.0}function M_(){ca(28);return 0}function N_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;ca(29);return 0}function O_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;ca(30);return 0}function P_(a,b,c){a=a|0;b=b|0;c=c|0;ca(31)}function Q_(a,b,c){a=a|0;b=b|0;c=c|0;Hc(a|0,b|0,c|0)}function R_(){ca(32)}function S_(){Uc()}function T_(){$b()}function U_(){Jc()}function V_(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;ca(33);return 0}function W_(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;ca(34);return 0}function X_(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;ca(35)}
function Fd(a){a=a|0;var b=0;b=i;i=i+a|0;i=i+15&-16;return b|0}function Gd(){return i|0}function Hd(a){a=a|0;i=a}function Id(a,b){a=a|0;b=b|0;i=a;j=b}function Jd(a,b){a=a|0;b=b|0;if(!o){o=a;p=b}}function Kd(b){b=b|0;a[k>>0]=a[b>>0];a[k+1>>0]=a[b+1>>0];a[k+2>>0]=a[b+2>>0];a[k+3>>0]=a[b+3>>0]}function Ld(b){b=b|0;a[k>>0]=a[b>>0];a[k+1>>0]=a[b+1>>0];a[k+2>>0]=a[b+2>>0];a[k+3>>0]=a[b+3>>0];a[k+4>>0]=a[b+4>>0];a[k+5>>0]=a[b+5>>0];a[k+6>>0]=a[b+6>>0];a[k+7>>0]=a[b+7>>0]}function Md(a){a=a|0;D=a}function Nd(){return D|0}function Od(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;uj(a,d,e);c[a>>2]=4008;Pd(a+16|0,b);return}function Pd(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=4084;c[a+8>>2]=0;Ae(a,c[b+8>>2]|0);return}function Qd(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0;l=i;i=i+16|0;h=l;k=c[(c[d+24>>2]|0)+8>>2]|0;j=d+8|0;d=c[j>>2]|0;e=$(d,e)|0;g=f+8|0;if(!(c[g>>2]|0)){Rd(h,d);Ae(f,c[h+8>>2]|0);Sd(h)}if((c[j>>2]|0)>0){d=0;do{a[(c[(c[g>>2]|0)+8>>2]|0)+d>>0]=a[k+(d+e)>>0]|0;d=d+1|0}while((d|0)<(c[j>>2]|0))}Pd(b,f);i=l;return}function Rd(a,b){a=a|0;b=b|0;var d=0,e=0;c[a+4>>2]=0;c[a>>2]=4084;c[a+8>>2]=0;o=0;d=qa(111,20)|0;e=o;o=0;do if(!(e&1)){o=0;ma(77,d|0,b|0);e=o;o=0;if(e&1){e=cc()|0;Uz(d);d=e;break}else{Ae(a,d);return}}else d=cc()|0;while(0);bc(d|0)}function Sd(a){a=a|0;var b=0;c[a>>2]=4084;a=a+8|0;b=c[a>>2]|0;if(b)ye(b);c[a>>2]=0;return}function Td(a,b){a=a|0;b=b|0;Pd(a,b+16|0);return}function Ud(a,b){a=a|0;b=b|0;c[a>>2]=0;Ie(a,c[b>>2]|0);return}function Vd(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Wd(a,b){a=a|0;b=b|0;c[a>>2]=0;Je(a,c[b>>2]|0);return}function Xd(a,b,d){a=a|0;b=b|0;d=d|0;d=($(c[a+16>>2]|0,d)|0)+(b>>5)|0;d=(c[(c[a+28>>2]|0)+8>>2]|0)+(d<<2)|0;c[d>>2]=c[d>>2]|1<<(b&31);return}function Yd(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Zd(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;g=i;i=i+32|0;k=g+16|0;f=g+12|0;h=g+8|0;j=g;e=Sz(12)|0;o=0;ka(299,e|0);l=o;o=0;if(l&1){l=cc()|0;Uz(e);e=l}else{c[k>>2]=0;Me(k,e);e=c[k>>2]|0;l=c[(c[e>>2]|0)+12>>2]|0;_d(h,b);$d(j,d);o=0;e=ya(l|0,e|0,h|0,j|0)|0;l=o;o=0;do if(!(l&1)){c[f>>2]=e;o=0;mb(47,a|0,1,f|0);l=o;o=0;if(l&1){e=cc()|0;be(f);break}else{be(f);ze(j+4|0);ce(h);de(k);i=g;return}}else e=cc()|0;while(0);ze(j+4|0);ce(h);de(k)}bc(e|0)}function _d(a,b){a=a|0;b=b|0;c[a>>2]=0;Ne(a,c[b>>2]|0);return}function $d(a,b){a=a|0;b=b|0;c[a>>2]=c[b>>2];we(a+4|0,b+4|0);c[a>>2]=c[b>>2];return}function ae(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;c[a>>2]=0;e=a+4|0;c[e>>2]=0;c[a+8>>2]=0;if(b){o=0;ma(78,a|0,b|0);f=o;o=0;if(f&1){f=cc()|0;me(a);bc(f|0)}a=c[e>>2]|0;do{Pe(a,d);a=(c[e>>2]|0)+4|0;c[e>>2]=a;b=b+-1|0}while((b|0)!=0)}return}function be(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function ce(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function de(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function ee(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;j=i;i=i+16|0;h=j+12|0;e=j+8|0;f=j;g=Sz(20)|0;o=0;ka(300,g|0);k=o;o=0;do if(!(k&1)){c[h>>2]=0;Re(h,g+12|0);k=c[h>>2]|0;g=c[(c[k>>2]|0)+12>>2]|0;_d(e,b);$d(f,d);o=0;ub(g|0,a|0,k|0,e|0,f|0);k=o;o=0;if(k&1){k=cc()|0;ze(f+4|0);ce(e);fe(h);e=k;break}else{ze(f+4|0);ce(e);fe(h);i=j;return}}else{e=cc()|0;Uz(g)}while(0);bc(e|0)}function fe(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function ge(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;g=i;i=i+32|0;k=g+16|0;f=g+12|0;h=g+8|0;j=g;e=Sz(28)|0;o=0;ka(301,e|0);l=o;o=0;if(l&1){l=cc()|0;Uz(e);e=l}else{c[k>>2]=0;Me(k,e);e=c[k>>2]|0;l=c[(c[e>>2]|0)+12>>2]|0;_d(h,b);$d(j,d);o=0;e=ya(l|0,e|0,h|0,j|0)|0;l=o;o=0;do if(!(l&1)){c[f>>2]=e;o=0;mb(47,a|0,1,f|0);l=o;o=0;if(l&1){e=cc()|0;be(f);break}else{be(f);ze(j+4|0);ce(h);de(k);i=g;return}}else e=cc()|0;while(0);ze(j+4|0);ce(h);de(k)}bc(e|0)}function he(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,g=0,h=0,j=0;g=i;i=i+64|0;h=g+24|0;f=g+12|0;d=g+8|0;e=g;_j(h);o=0;ma(79,f|0,h|0);j=o;o=0;do if(!(j&1)){_d(d,b);$d(e,c);o=0;ub(44,a|0,f|0,d|0,e|0);j=o;o=0;if(j&1){j=cc()|0;ze(e+4|0);ce(d);Dj(f);d=j;break}else{ze(e+4|0);ce(d);Dj(f);dk(h);i=g;return}}else d=cc()|0;while(0);dk(h);bc(d|0)}function ie(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=4084;c[a+8>>2]=0;Ae(a,b);return}function je(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;g=i;i=i+32|0;f=g+16|0;d=g+12|0;e=g;Rd(f,$(b,a)|0);Ae(4056,c[f+8>>2]|0);Sd(f);c[1018]=c[(c[1016]|0)+8>>2];f=Sz(28)|0;Pd(e,4056);o=0;ub(56,f|0,e|0,a|0,b|0);a=o;o=0;if(a&1){g=cc()|0;Sd(e);Uz(f);bc(g|0)}else{c[d>>2]=0;Ie(d,f);Ie(4068,c[d>>2]|0);Vd(d);Sd(e);i=g;return c[1018]|0}return 0}function ke(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0.0,j=0,k=0,l=0,m=0,n=0.0,p=0.0,q=0.0,r=0,s=0.0,t=0.0,u=0.0,v=0.0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0;J=i;i=i+176|0;M=J+152|0;K=J+148|0;L=J+144|0;F=J+136|0;e=J+132|0;g=J+128|0;w=J+116|0;x=J+112|0;y=J+104|0;z=J+92|0;A=J+88|0;B=J+80|0;C=J+68|0;E=J+64|0;j=J+56|0;k=J+44|0;l=J+40|0;m=J+32|0;I=J+16|0;G=J+12|0;H=J;c[M>>2]=0;r=M+4|0;c[r>>2]=0;c[M+8>>2]=0;c[K>>2]=0;Le(K,0);c[L>>2]=0;Ne(L,0);$d(F,4500);o=0;f=qa(111,44)|0;N=o;o=0;a:do if(!(N&1)){Ud(e,4068);o=0;ma(80,f|0,e|0);N=o;o=0;if(N&1){N=cc(24,240,8,1792)|0;g=D;Vd(e);Uz(f);e=N;f=g;g=21;break}Le(K,f);Vd(e);o=0;e=qa(111,12)|0;N=o;o=0;if(!(N&1)){c[g>>2]=0;Le(g,c[K>>2]|0);o=0;ma(81,e|0,g|0);N=o;o=0;if(N&1){N=cc(24,240,8,1792)|0;f=D;le(g);Uz(e);e=N;g=21;break}Ne(L,e);le(g);b:do switch(b|0){case 0:{c[x>>2]=0;Ne(x,c[L>>2]|0);$d(y,F);o=0;mb(48,w|0,x|0,y|0);N=o;o=0;if(N&1){e=cc(24,240,8,1792)|0;f=D;ze(y+4|0);ce(x);g=21;break a}else{Se(M);e=c[w>>2]|0;c[M>>2]=e;N=w+4|0;f=c[N>>2]|0;c[r>>2]=f;b=w+8|0;c[M+8>>2]=c[b>>2];c[b>>2]=0;c[N>>2]=0;c[w>>2]=0;me(w);ze(y+4|0);ce(x);break b}}case 1:{c[A>>2]=0;Ne(A,c[L>>2]|0);$d(B,F);o=0;mb(49,z|0,A|0,B|0);N=o;o=0;if(N&1){e=cc(24,240,8,1792)|0;f=D;ze(B+4|0);ce(A);g=21;break a}else{Se(M);e=c[z>>2]|0;c[M>>2]=e;N=z+4|0;f=c[N>>2]|0;c[r>>2]=f;b=z+8|0;c[M+8>>2]=c[b>>2];c[b>>2]=0;c[N>>2]=0;c[z>>2]=0;me(z);ze(B+4|0);ce(A);break b}}case 2:{c[E>>2]=0;Ne(E,c[L>>2]|0);$d(j,F);o=0;mb(50,C|0,E|0,j|0);N=o;o=0;if(N&1){e=cc(24,240,8,1792)|0;f=D;ze(j+4|0);ce(E);g=21;break a}else{Se(M);e=c[C>>2]|0;c[M>>2]=e;N=C+4|0;f=c[N>>2]|0;c[r>>2]=f;b=C+8|0;c[M+8>>2]=c[b>>2];c[b>>2]=0;c[N>>2]=0;c[C>>2]=0;me(C);ze(j+4|0);ce(E);break b}}default:{c[l>>2]=0;Ne(l,c[L>>2]|0);$d(m,F);o=0;mb(51,k|0,l|0,m|0);N=o;o=0;if(N&1){e=cc(24,240,8,1792)|0;f=D;ze(m+4|0);ce(l);g=21;break a}else{Se(M);e=c[k>>2]|0;c[M>>2]=e;N=k+4|0;f=c[N>>2]|0;c[r>>2]=f;b=k+8|0;c[M+8>>2]=c[b>>2];c[b>>2]=0;c[N>>2]=0;c[k>>2]=0;me(k);ze(m+4|0);ce(l);break b}}}while(0);y=e;ze(F+4|0);m=f-e>>2;r=I+8|0;w=I+1|0;x=I+4|0;k=f-e>>2;j=H+8|0;if(!m){e=0;g=51}else{l=0;while(1){f=y+(l<<2)|0;o=0;e=qa(112,c[f>>2]|0)|0;N=o;o=0;if(N&1){g=44;break}c[G>>2]=e;o=0;e=qa(113,e|0)|0;N=o;o=0;if(N&1){g=47;break}o=0;ma(82,I|0,e|0);N=o;o=0;if(N&1){g=47;break}ne(G);o=0;e=qa(114,c[f>>2]|0)|0;N=o;o=0;if(N&1){g=48;break}oe(H,e);g=a[I>>0]|0;e=(g&1)==0;f=e?w:c[r>>2]|0;g=e?(g&255)>>>1:c[x>>2]|0;e=(c[j>>2]|0)+8|0;N=c[c[e>>2]>>2]|0;o=0;n=+Ka(c[(c[N>>2]|0)+8>>2]|0,N|0);N=o;o=0;if(N&1){g=49;break}N=c[c[e>>2]>>2]|0;o=0;p=+Ka(c[(c[N>>2]|0)+12>>2]|0,N|0);N=o;o=0;if(N&1){g=49;break}N=c[(c[e>>2]|0)+4>>2]|0;o=0;q=+Ka(c[(c[N>>2]|0)+8>>2]|0,N|0);N=o;o=0;if(N&1){g=49;break}N=c[(c[e>>2]|0)+4>>2]|0;o=0;s=+Ka(c[(c[N>>2]|0)+12>>2]|0,N|0);N=o;o=0;if(N&1){g=49;break}N=c[(c[e>>2]|0)+8>>2]|0;o=0;t=+Ka(c[(c[N>>2]|0)+8>>2]|0,N|0);N=o;o=0;if(N&1){g=49;break}N=c[(c[e>>2]|0)+8>>2]|0;o=0;u=+Ka(c[(c[N>>2]|0)+12>>2]|0,N|0);N=o;o=0;if(N&1){g=49;break}N=c[(c[e>>2]|0)+12>>2]|0;o=0;v=+Ka(c[(c[N>>2]|0)+8>>2]|0,N|0);N=o;o=0;if(N&1){g=49;break}N=c[(c[e>>2]|0)+12>>2]|0;o=0;h=+Ka(c[(c[N>>2]|0)+12>>2]|0,N|0);N=o;o=0;if(N&1){g=49;break}o=0;Ma(d|0,f|0,g|0,l|0,k|0,+n,+p,+q,+s,+t,+u,+v,+h)|0;N=o;o=0;if(N&1){g=49;break}pe(H);IC(I);l=l+1|0;if(l>>>0>=m>>>0){e=0;g=51;break a}}if((g|0)==44){e=cc()|0;g=46;break}else if((g|0)==47){e=cc()|0;ne(G);break}else if((g|0)==48)e=cc()|0;else if((g|0)==49){e=cc()|0;pe(H)}IC(I)}}else g=8}else g=8;while(0);if((g|0)==8){e=cc(24,240,8,1792)|0;f=D;g=21}c:do if((g|0)==21){ze(F+4|0);do if((f|0)==(Xb(24)|0)){fc(e|0)|0;o=0;ob(44);N=o;o=0;if(!(N&1)){e=-2;g=51;break c}}else{if((f|0)==(Xb(240)|0)){fc(e|0)|0;o=0;ob(44);N=o;o=0;if(N&1)break;else{e=-3;g=51;break c}}if((f|0)==(Xb(8)|0)){fc(e|0)|0;o=0;ob(44);N=o;o=0;if(N&1)break;else{e=-4;g=51;break c}}if((f|0)!=(Xb(1792)|0))break c;fc(e|0)|0;o=0;ob(44);N=o;o=0;if(!(N&1)){e=-5;g=51;break c}}while(0);e=cc()|0;g=46}while(0);if((g|0)!=46)if((g|0)==51){ce(L);le(K);me(M);i=J;return e|0}ce(L);le(K);me(M);bc(e|0);return 0}function le(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function me(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;be(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function ne(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function oe(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=4116;c[a+8>>2]=0;Te(a,c[b+8>>2]|0);return}function pe(a){a=a|0;var b=0;c[a>>2]=4116;a=a+8|0;b=c[a>>2]|0;if(b)ye(b);c[a>>2]=0;return}function qe(a){a=a|0;return ke(0,a)|0}function re(a){a=a|0;return ke(1,a)|0}function se(a){a=a|0;return ke(2,a)|0}function te(a){a=a|0;return ke(3,a)|0}function ue(a){a=a|0;c[a>>2]=4008;Sd(a+16|0);return}function ve(a){a=a|0;ue(a);Uz(a);return}function we(a,b){a=a|0;b=b|0;c[a>>2]=0;xe(a,c[b>>2]|0);return}function xe(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function ye(a){a=a|0;var b=0,d=0;b=a+4|0;d=(c[b>>2]|0)+-1|0;c[b>>2]=d;if(!d){c[b>>2]=-559026175;_c[c[(c[a>>2]|0)+4>>2]&511](a)}return}function ze(a){a=a|0;a=c[a>>2]|0;if(a)ye(a);return}function Ae(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}a=a+8|0;d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Be(a){a=a|0;Sd(a);Uz(a);return}function Ce(b,d){b=b|0;d=d|0;var e=0,f=0;e=i;i=i+16|0;f=e;c[b+4>>2]=0;c[b>>2]=4100;a[f>>0]=0;De(b+8|0,d,f);i=e;return}function De(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;c[b>>2]=0;f=b+4|0;c[f>>2]=0;c[b+8>>2]=0;if(d){o=0;ma(83,b|0,d|0);g=o;o=0;if(g&1){g=cc()|0;He(b);bc(g|0)}b=c[f>>2]|0;do{a[b>>0]=a[e>>0]|0;b=(c[f>>2]|0)+1|0;c[f>>2]=b;d=d+-1|0}while((d|0)!=0)}return}function Ee(a){a=a|0;c[a>>2]=4100;He(a+8|0);return}function Fe(a){a=a|0;c[a>>2]=4100;He(a+8|0);Uz(a);return}function Ge(a,b){a=a|0;b=b|0;var d=0;if((b|0)<0)Qz(a);else{d=Sz(b)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+b;return}}function He(a){a=a|0;var b=0,d=0;d=c[a>>2]|0;if(d){b=a+4|0;a=c[b>>2]|0;if((a|0)!=(d|0)){do a=a+-1|0;while((a|0)!=(d|0));c[b>>2]=a}Uz(d)}return}function Ie(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Je(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Ke(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Le(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Me(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Ne(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Oe(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function Pe(a,b){a=a|0;b=b|0;c[a>>2]=0;Qe(a,c[b>>2]|0);return}function Qe(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Re(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Se(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;be(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0);c[a+8>>2]=0;c[e>>2]=0;c[a>>2]=0}return}function Te(a,b){a=a|0;b=b|0;var d=0;if(b){d=b+4|0;c[d>>2]=(c[d>>2]|0)+1}a=a+8|0;d=c[a>>2]|0;if(d)ye(d);c[a>>2]=b;return}function Ue(a){a=a|0;pe(a);Uz(a);return}function Ve(){Rd(4044,0);Ec(44,4044,n|0)|0;ie(4056,0);Ec(44,4056,n|0)|0;c[1017]=0;Ie(4068,0);Ec(302,4068,n|0)|0;return}function We(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0;l=i;i=i+16|0;j=l+12|0;k=l;Zp(j,d);oe(k,e);o=0;mb(52,b|0,j|0,k|0);e=o;o=0;if(e&1){l=cc()|0;pe(k);Yd(j);bc(l|0)}else{pe(k);Yd(j);c[b>>2]=28776;a[b+24>>0]=f&1;c[b+28>>2]=g;c[b+32>>2]=h;i=l;return}}function Xe(b){b=b|0;return (a[b+24>>0]|0)!=0|0}function Ye(a){a=a|0;return c[a+28>>2]|0}function Ze(a){a=a|0;return c[a+32>>2]|0}function _e(a){a=a|0;c[a+4>>2]=0;c[a>>2]=4132;o=0;ka(303,a+8|0);a=o;o=0;if(a&1){a=cc()|0;bc(a|0)}else return}function $e(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;l=i;i=i+112|0;f=l+100|0;g=l+96|0;r=l+64|0;d=l+56|0;q=l+52|0;p=l+40|0;n=l+36|0;e=l+32|0;m=l+28|0;h=l+16|0;j=l+4|0;k=l;c[d>>2]=Kf(c[b>>2]|0)|0;o=0;ma(84,r|0,d|0);b=o;o=0;if(b&1){r=cc()|0;Yd(d);d=r}else{Yd(d);o=0;d=qa(115,r|0)|0;b=o;o=0;if(b&1)d=cc()|0;else{c[q>>2]=d;o=0;ma(85,p|0,d|0);b=o;o=0;if(b&1)d=cc()|0;else{c[e>>2]=0;_p(e,d);o=0;b=Wa(59,a+8|0,e|0)|0;a=o;o=0;if(a&1){d=cc()|0;$p(e)}else{c[n>>2]=b;$p(e);o=0;a=qa(111,40)|0;e=o;o=0;if(e&1)d=cc()|0;else{o=0;d=qa(116,b|0)|0;e=o;o=0;if(e&1)d=cc()|0;else{c[m>>2]=d;o=0;ma(86,h|0,b|0);e=o;o=0;do if(!(e&1)){oe(j,p);c[k>>2]=1;o=0;c[f>>2]=c[k>>2];ia(45,a|0,m|0,h|0,j|0,f|0);k=o;o=0;if(k&1){d=cc()|0;pe(j);Sd(h);break}else{c[g>>2]=0;Qe(g,a);pe(j);Sd(h);ne(m);aq(n);pe(p);$p(q);c[r>>2]=28792;Yd(r+8|0);i=l;return c[g>>2]|0}}else d=cc()|0;while(0);ne(m)}Uz(a)}aq(n)}pe(p)}$p(q)}c[r>>2]=28792;Yd(r+8|0)}bc(d|0);return 0}function af(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;f=i;i=i+16|0;e=f;d=c[(c[a>>2]|0)+8>>2]|0;_d(e,b);o=0;d=Wa(d|0,a|0,e|0)|0;a=o;o=0;if(a&1){f=cc()|0;ce(e);bc(f|0)}else{ce(e);i=f;return d|0}return 0}function bf(a){a=a|0;c[a>>2]=4132;c[a+8>>2]=28808;$p(a+24|0);return}function cf(a){a=a|0;bf(a);Uz(a);return}function df(a){a=a|0;switch(a<<24>>24|0){case 76:{a=1;break}case 80:{a=4;break}case 77:{a=2;break}case 68:{a=3;break}case 66:{a=5;break}default:a=0}return a|0}function ef(a,b){a=a|0;b=b|0;switch(a|0){case 0:{b=c[28816+(b<<2)>>2]|0;break}case 1:{b=c[28944+(b<<2)>>2]|0;break}case 2:{b=c[29072+(b<<2)>>2]|0;break}case 4:{b=c[29200+(b<<2)>>2]|0;break}case 3:{b=c[29328+(b<<2)>>2]|0;break}default:b=61257}return b|0}function ff(a){a=a|0;c[a+4>>2]=0;c[a>>2]=28808;a=a+16|0;c[a>>2]=0;_p(a,0);return}function gf(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;q=i;i=i+80|0;m=q+64|0;v=q+60|0;g=q+56|0;h=q+52|0;u=q+48|0;j=q+44|0;t=q+40|0;k=q+36|0;s=q+32|0;l=q+28|0;r=q+16|0;n=q+4|0;p=q;f=b+16|0;_p(f,c[d>>2]|0);d=Cg(c[d>>2]|0)|0;c[v>>2]=d;o=0;e=qa(117,c[f>>2]|0)|0;x=o;o=0;a:do if(x&1)w=6;else{do if(!e){o=0;d=qa(118,c[f>>2]|0)|0;x=o;o=0;if(x&1){w=6;break a}c[h>>2]=d;o=0;d=qa(119,h|0)|0;x=o;o=0;if(x&1){d=cc()|0;Yd(h);break a}else{c[g>>2]=d;Ke(v,d);Yd(g);Yd(h);d=c[v>>2]|0;break}}while(0);c[j>>2]=0;Ke(j,d);o=0;d=Wa(60,b|0,j|0)|0;x=o;o=0;if(x&1){d=cc()|0;Yd(j);break}c[u>>2]=d;Yd(j);c[k>>2]=0;Je(k,d);o=0;e=Wa(61,b|0,k|0)|0;x=o;o=0;if(x&1){d=cc()|0;bq(k)}else{c[t>>2]=e;bq(k);c[l>>2]=0;Je(l,e);o=0;h=Wa(62,b|0,l|0)|0;x=o;o=0;if(x&1){d=cc()|0;bq(l)}else{c[s>>2]=h;bq(l);o=0;d=qa(120,e|0)|0;x=o;o=0;if(!(x&1)?(o=0,ma(87,r|0,d|0),x=o,o=0,!(x&1)):0){g=e+4|0;d=e+20|0;e=(c[r+8>>2]|0)+8|0;if((c[g>>2]|0)>0){f=0;do{a[(c[e>>2]|0)+f>>0]=(c[(c[(c[d>>2]|0)+8>>2]|0)+(f>>5<<2)>>2]&1<<(f&31)|0)!=0&1;f=f+1|0}while((f|0)<(c[g>>2]|0))}o=0;d=qa(111,48)|0;x=o;o=0;do if(!(x&1)){Pd(n,r);c[p>>2]=0;cq(p,h);o=0;mb(53,d|0,n|0,p|0);x=o;o=0;if(x&1){x=cc()|0;ne(p);Sd(n);Uz(d);d=x;break}else{c[m>>2]=0;dq(m,d);ne(p);Sd(n);Sd(r);ne(s);bq(t);bq(u);Yd(v);i=q;return c[m>>2]|0}}else d=cc()|0;while(0);Sd(r)}else d=cc()|0;ne(s)}bq(t)}bq(u)}while(0);if((w|0)==6)d=cc()|0;Yd(v);bc(d|0);return 0}function hf(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0;j=i;i=i+16|0;k=j;d=(((ig(c[a>>2]|0)|0)+-1|0)/32|0)<<1|1;e=Sz(32)|0;o=0;f=qa(121,c[a>>2]|0)|0;h=o;o=0;if((!(h&1)?(o=0,b=qa(122,c[a>>2]|0)|0,h=o,o=0,!(h&1)):0)?(o=0,mb(54,e|0,f-d|0,b-d|0),h=o,o=0,!(h&1)):0){c[k>>2]=0;Ke(k,e);h=c[k>>2]|0;b=0;g=0;a:while(1){o=0;d=qa(121,c[a>>2]|0)|0;f=o;o=0;if(f&1){d=11;break}if((g|0)>=(d|0)){d=23;break}o=0;d=qa(121,c[a>>2]|0)|0;f=o;o=0;if(f&1){d=11;break}if(((d|0)/2|0)-g&15){d=0;f=0;while(1){o=0;e=qa(122,c[a>>2]|0)|0;l=o;o=0;if(l&1){d=10;break a}if((f|0)>=(e|0))break;o=0;e=qa(121,c[a>>2]|0)|0;l=o;o=0;if(l&1){d=10;break a}if(((e|0)/2|0)-f&15){if(eq(c[a>>2]|0,g,f)|0)Xd(h,b,d);d=d+1|0}f=f+1|0}b=b+1|0}g=g+1|0}if((d|0)==10)b=cc()|0;else if((d|0)==11)b=cc()|0;else if((d|0)==23){i=j;return h|0}Yd(k)}else{b=cc()|0;Uz(e)}bc(b|0);return 0}function jf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;y=i;i=i+48|0;w=y+36|0;z=y+24|0;g=y+12|0;h=y;c[z>>2]=0;v=z+4|0;c[v>>2]=0;j=z+8|0;c[j>>2]=0;k=a+16|0;o=0;f=qa(117,c[k>>2]|0)|0;u=o;o=0;do if(!(u&1)){o=0;d=qa(123,c[k>>2]|0)|0;e=o;o=0;e=e&1;if(f){if(e){x=7;break}if((d|0)>5){d=Ob(8)|0;o=0;ma(88,d|0,46995);y=o;o=0;if(y&1){y=cc()|0;Nb(d|0);d=y;break}else{o=0;mb(55,d|0,320,76);o=0;x=7;break}}o=0;d=qa(123,c[k>>2]|0)|0;u=o;o=0;if(u&1){x=7;break}o=0;ma(89,g|0,c[29392+(d<<2)>>2]|0);u=o;o=0;if(u&1){x=7;break}gq(z);d=c[g>>2]|0;c[z>>2]=d;u=g+4|0;c[v>>2]=c[u>>2];e=g+8|0;c[j>>2]=c[e>>2];c[g>>2]=0;c[u>>2]=0;c[e>>2]=0;hq(g);o=0;e=qa(123,c[k>>2]|0)|0;u=o;o=0;if(u&1){x=7;break}c[a+8>>2]=c[29412+(e<<2)>>2]}else{if(e){x=7;break}if((d|0)>33){d=Ob(8)|0;o=0;ma(88,d|0,46995);y=o;o=0;if(y&1){y=cc()|0;Nb(d|0);d=y;break}else{o=0;mb(55,d|0,320,76);o=0;x=7;break}}o=0;d=qa(123,c[k>>2]|0)|0;u=o;o=0;if(u&1){x=7;break}o=0;ma(89,h|0,c[29432+(d<<2)>>2]|0);u=o;o=0;if(u&1){x=7;break}gq(z);d=c[h>>2]|0;c[z>>2]=d;u=h+4|0;c[v>>2]=c[u>>2];e=h+8|0;c[j>>2]=c[e>>2];c[h>>2]=0;c[u>>2]=0;c[e>>2]=0;hq(h);o=0;e=qa(123,c[k>>2]|0)|0;u=o;o=0;if(u&1){x=7;break}c[a+8>>2]=c[29564+(e<<2)>>2]}o=0;e=qa(123,c[k>>2]|0)|0;u=o;o=0;if(!(u&1)?(o=0,l=qa(122,c[b>>2]|0)|0,u=o,o=0,!(u&1)):0){if(e){t=0;u=0;s=l;while(1){q=s<<1;a=q+-4|0;k=a+u|0;r=s+-1+t|0;if((a|0)>0){l=0;m=0;while(1){f=m+u|0;g=d+(f>>>5<<2)|0;f=1<<(f&31);h=c[b>>2]|0;j=((m|0)/2|0)+t|0;if(eq(h,l+t|0,j)|0)f=c[g>>2]|f;else f=c[g>>2]&~f;c[g>>2]=f;f=k+m|0;g=d+(f>>>5<<2)|0;f=1<<(f&31);if(eq(h,j,r-l|0)|0)f=c[g>>2]|f;else f=c[g>>2]&~f;c[g>>2]=f;m=m+1|0;if((m|0)>=(a|0))break;else l=(l+1|0)%2|0}}f=q|1;l=(s<<2)+-7+u|0;m=t+-1|0;n=(s*6|0)+-11+u|0;if((f|0)>5){p=0;while(1){h=q-f|0;g=l+h|0;j=d+(g>>>5<<2)|0;g=1<<(g&31);a=c[b>>2]|0;k=m+((f|0)/2|0)|0;if(eq(a,r-p|0,k)|0)g=c[j>>2]|g;else g=c[j>>2]&~g;c[j>>2]=g;g=n+h|0;h=d+(g>>>5<<2)|0;g=1<<(g&31);if(eq(a,k,p+t|0)|0)g=c[h>>2]|g;else g=c[h>>2]&~g;c[h>>2]=g;f=f+-1|0;if((f|0)<=5)break;else p=(p+1|0)%2|0}}e=e+-1|0;if(!e)break;else{t=t+2|0;u=(s<<3)+-16+u|0;s=s+-4|0}}}o=0;d=qa(111,24)|0;b=o;o=0;if(!(b&1)){j=c[v>>2]|0;o=0;ma(90,d|0,j|0);v=o;o=0;if(v&1){y=cc()|0;Uz(d);d=y;break}c[w>>2]=0;Je(w,d);h=c[z>>2]|0;d=c[w>>2]|0;e=d+20|0;if((j|0)>0){g=0;do{f=1<<(g&31);if(c[h+(g>>>5<<2)>>2]&f){x=(c[(c[e>>2]|0)+8>>2]|0)+(g>>5<<2)|0;c[x>>2]=c[x>>2]|f}g=g+1|0}while((g|0)<(j|0))}hq(z);i=y;return d|0}else x=7}else x=7}else x=7;while(0);if((x|0)==7)d=cc()|0;hq(z);bc(d|0);return 0}function kf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;w=i;i=i+48|0;x=w+36|0;z=w+32|0;y=w+20|0;r=w+16|0;p=w+12|0;q=w;iq(z,4360);k=a+16|0;o=0;e=qa(123,c[k>>2]|0)|0;v=o;o=0;a:do if(!(v&1)){do if((e|0)>=3){o=0;e=qa(123,c[k>>2]|0)|0;v=o;o=0;if(v&1){s=4;break a}if((e|0)<9){c[a+12>>2]=8;jq(z,c[1094]|0);break}o=0;e=qa(123,c[k>>2]|0)|0;v=o;o=0;if(v&1){s=4;break a}f=a+12|0;if((e|0)<23){c[f>>2]=10;jq(z,c[1089]|0);break}else{c[f>>2]=12;jq(z,c[1088]|0);break}}else{c[a+12>>2]=6;jq(z,c[1090]|0)}while(0);o=0;v=qa(124,c[k>>2]|0)|0;u=o;o=0;if(!(u&1)?(o=0,g=qa(117,c[k>>2]|0)|0,u=o,o=0,!(u&1)):0){o=0;e=qa(123,c[k>>2]|0)|0;f=o;o=0;f=f&1;if(g){if(f){s=4;break}g=c[29392+(e<<2)>>2]|0;f=a+8|0;h=c[f>>2]|0;j=c[a+12>>2]|0;o=0;e=qa(123,c[k>>2]|0)|0;u=o;o=0;if(u&1){s=4;break}e=29412+(e<<2)|0;m=g-($(j,h)|0)|0}else{if(f){s=4;break}g=c[29432+(e<<2)>>2]|0;f=a+8|0;h=c[f>>2]|0;j=c[a+12>>2]|0;o=0;e=qa(123,c[k>>2]|0)|0;u=o;o=0;if(u&1){s=4;break}e=29564+(e<<2)|0;m=g-($(j,h)|0)|0}l=(c[e>>2]|0)-v|0;o=0;ma(91,y|0,c[f>>2]|0);u=o;o=0;if(!(u&1)){t=a+12|0;u=(c[y+8>>2]|0)+8|0;if((c[f>>2]|0)>0){k=0;do{e=c[t>>2]|0;if((e|0)>=1){j=c[(c[(c[b>>2]|0)+20>>2]|0)+8>>2]|0;g=1;h=1;while(1){s=m-h+e+($(e,k)|0)|0;if(c[j+(s>>5<<2)>>2]&1<<(s&31)){s=(c[u>>2]|0)+(k<<2)|0;c[s>>2]=(c[s>>2]|0)+g}e=c[t>>2]|0;if((h|0)>=(e|0))break;else{g=g<<1;h=h+1|0}}}k=k+1|0}while((k|0)<(c[f>>2]|0))}c[p>>2]=0;jq(p,c[z>>2]|0);o=0;ma(92,r|0,p|0);s=o;o=0;do if(!(s&1)){lq(p);mq(q,y);o=0;mb(56,r|0,q|0,l|0);s=o;o=0;if(s&1){e=cc(256,240)|0;f=D;nq(q);Fh(r);s=35;break}else{nq(q);Fh(r);s=42;break}}else{e=cc(256,240)|0;f=D;lq(p);s=35}while(0);do if((s|0)==35){if((f|0)!=(Xb(256)|0)){if((f|0)!=(Xb(240)|0)){d=e;break}fc(e|0)|0;o=0;ob(44);s=o;o=0;if(s&1){s=27;break}else{s=42;break}}fc(e|0)|0;e=Ob(8)|0;o=0;ma(88,e|0,47012);x=o;o=0;if(x&1){x=cc()|0;Nb(e|0);e=x}else{o=0;mb(55,e|0,320,76);o=0;e=cc()|0}o=0;ob(44);x=o;o=0;if(x&1){x=cc(0)|0;oq(x)}else d=e}while(0);b:do if((s|0)==42){r=a+20|0;c[r>>2]=0;o=0;d=qa(111,24)|0;a=o;o=0;if(a&1)s=27;else{a=$(c[t>>2]|0,v)|0;o=0;ma(90,d|0,a|0);a=o;o=0;if(a&1){x=cc()|0;Uz(d);d=x;break}c[x>>2]=0;Je(x,d);p=c[x>>2]|0;q=p+20|0;c:do if((v|0)>0){b=0;d=0;d:while(1){e=c[t>>2]|0;if((e|0)>0){n=(c[u>>2]|0)+(b<<2)|0;k=e;l=1<<e+-1;m=0;e=0;g=0;while(1){j=(c[n>>2]&l|0)==(l|0);h=e^j;do if((g|0)==(k+-1|0)){if(!h)break d;c[r>>2]=(c[r>>2]|0)+1;e=k;d=d+1|0;f=0;g=0}else{f=h?j:e;g=h?1:g+1|0;if(!j){e=k;break}a=m-d+($(k,b)|0)|0;e=(c[(c[q>>2]|0)+8>>2]|0)+(a>>5<<2)|0;c[e>>2]=c[e>>2]|1<<(a&31);e=c[t>>2]|0}while(0);m=m+1|0;if((m|0)>=(e|0))break;else{k=e;l=l>>>1;e=f}}}b=b+1|0;if((b|0)>=(v|0))break c}d=Ob(8)|0;o=0;ma(88,d|0,47031);w=o;o=0;if(w&1){w=cc()|0;Nb(d|0);d=w}else{o=0;mb(55,d|0,320,76);o=0;d=cc()|0}bq(x);break b}while(0);nq(y);lq(z);i=w;return p|0}}while(0);if((s|0)==27)d=cc()|0;nq(y)}else s=4}else s=4}else s=4;while(0);if((s|0)==4)d=cc()|0;lq(z);bc(d|0);return 0}function lf(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;E=i;i=i+48|0;D=E+44|0;F=E+32|0;u=E+28|0;v=E+24|0;w=E+20|0;x=E+16|0;y=E+12|0;C=E;m=c[b+12>>2]|0;m=$(Ye(c[b+16>>2]|0)|0,m)|0;m=m-(c[b+20>>2]|0)|0;do if((m|0)>(Wf(c[d>>2]|0)|0)){b=Ob(8)|0;o=0;ma(88,b|0,47052);G=o;o=0;if(G&1){G=cc()|0;Nb(b|0);b=G;break}else Hc(b|0,320,76)}else{c[F>>2]=0;c[F+4>>2]=0;c[F+8>>2]=0;n=C+8|0;p=C+4|0;q=C+1|0;b=0;r=0;t=0;h=0;f=0;a:while(1){s=r;r=t?r:f;b:do if(b){if((m-h|0)<5){G=38;break a}Wd(u,d);b=mf(u,h,5)|0;bq(u);e=h+5|0;if(!b){if((m-e|0)<11){G=38;break a}Wd(v,d);b=(mf(v,e,11)|0)+31|0;bq(v);e=h+16|0}if((b|0)>0){g=0;while(1){if((m-e|0)<8){b=0;j=1;g=t;break b}Wd(w,d);l=mf(w,e,8)|0;bq(w);o=0;ma(93,F|0,l&255|0);l=o;o=0;if(l&1){G=10;break a}e=e+8|0;g=g+1|0;if((g|0)>=(b|0)){b=0;j=0;g=t;break}}}else{b=0;j=0;g=t}}else{if((f|0)==5){if((m-h|0)<8){G=38;break a}Wd(x,d);l=mf(x,h,8)|0;bq(x);o=0;ma(93,F|0,l&255|0);l=o;o=0;if(l&1){G=11;break a}else{b=0;j=0;g=t;e=h+8|0;f=5;break}}b=(f|0)==3?4:5;if((m-h|0)<(b|0)){G=38;break a}Wd(y,d);j=mf(y,h,b)|0;bq(y);e=b+h|0;j=ef(f,j)|0;l=iC(j)|0;o=0;mb(57,C|0,j|0,l|0);l=o;o=0;if(l&1){G=11;break a}l=a[C>>0]|0;h=(l&1)==0;k=h?q:c[n>>2]|0;l=h?(l&255)>>>1:c[p>>2]|0;c:do if((l>>>0>=5?(z=k+l|0,A=k,(l|0)>=5):0)?(h=l+-4|0,B=k+h|0,(h|0)!=0):0){b=k;d:while(1){if((a[b>>0]|0)==67){g=b;h=47071;do{h=h+1|0;if((h|0)==47076)break d;g=g+1|0}while((a[g>>0]|0)==(a[h>>0]|0))}b=b+1|0;if((b|0)==(B|0)){G=35;break c}}if((b|0)!=(z|0)?(b-A|0)!=-1:0){b=a[j+5>>0]|0;f=df(b)|0;g=(a[j+6>>0]|0)==83;b=g&b<<24>>24==66;g=g|t}else G=35}else G=35;while(0);if((G|0)==35){G=0;o=0;ya(90,F|0,k|0,l|0)|0;l=o;o=0;if(l&1){G=34;break a}else{b=0;g=t}}IC(C);j=0}while(0);f=t?s:f;if(j){G=38;break}else{t=g&(t^1);h=e}}do if((G|0)==10){b=cc()|0;G=13}else if((G|0)==11){b=cc()|0;G=13}else if((G|0)==34){b=cc()|0;IC(C)}else if((G|0)==38){o=0;b=qa(111,20)|0;C=o;o=0;if(C&1){b=cc()|0;G=13;break}o=0;ma(94,b|0,F|0);C=o;o=0;if(C&1){E=cc()|0;Uz(b);b=E;break}else{c[D>>2]=0;cq(D,b);IC(F);i=E;return c[D>>2]|0}}while(0);IC(F)}while(0);bc(b|0);return 0}function mf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;f=d+b|0;if((d|0)>0){e=c[(c[(c[a>>2]|0)+20>>2]|0)+8>>2]|0;a=b;d=0;do{d=(c[e+(a>>5<<2)>>2]&1<<(a&31)|0)!=0|d<<1;a=a+1|0}while((a|0)<(f|0))}else d=0;return d|0}function nf(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=28792;Zp(a+8|0,b);c[a+16>>2]=0;c[a+20>>2]=0;c[a+24>>2]=0;return}function of(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;q=i;i=i+112|0;m=q+96|0;v=q+92|0;t=q+80|0;d=q+76|0;e=q+64|0;s=q+52|0;f=q+40|0;r=q+36|0;g=q+32|0;h=q+28|0;j=q+24|0;k=q+20|0;l=q+16|0;p=q+12|0;n=q;w=pf(b)|0;c[v>>2]=w;c[d>>2]=0;pq(d,w);o=0;mb(58,t|0,b|0,d|0);w=o;o=0;if(w&1){w=cc()|0;qq(d);d=w}else{qq(d);o=0;ma(95,e|0,t|0);w=o;o=0;do if(!(w&1)){o=0;ma(96,b|0,e|0);w=o;o=0;if(w&1){d=cc()|0;sq(e);break}sq(e);o=0;ma(95,f|0,t|0);w=o;o=0;if(!(w&1)){o=0;mb(59,s|0,b|0,f|0);w=o;o=0;if(w&1){d=cc()|0;sq(f);break}sq(f);Zp(g,b+8|0);e=b+28|0;w=(c[s+8>>2]|0)+8|0;tq(h,(c[w>>2]|0)+(((c[e>>2]|0)%4|0)<<2)|0);tq(j,(c[w>>2]|0)+((((c[e>>2]|0)+3|0)%4|0)<<2)|0);tq(k,(c[w>>2]|0)+((((c[e>>2]|0)+2|0)%4|0)<<2)|0);tq(l,(c[w>>2]|0)+((((c[e>>2]|0)+1|0)%4|0)<<2)|0);o=0;e=oa(81,b|0,g|0,h|0,j|0,k|0,l|0)|0;w=o;o=0;if(w&1){d=cc()|0;uq(l);uq(k);uq(j);uq(h);Yd(g)}else{c[r>>2]=e;uq(l);uq(k);uq(j);uq(h);Yd(g);o=0;d=qa(111,36)|0;w=o;o=0;do if(!(w&1)){c[p>>2]=0;Ke(p,e);oe(n,s);o=0;Ca(49,d|0,p|0,n|0,(a[b+12>>0]|0)!=0|0,c[b+20>>2]|0,c[b+16>>2]|0);w=o;o=0;if(w&1){w=cc()|0;pe(n);Yd(p);Uz(d);d=w;break}else{c[m>>2]=0;_p(m,d);pe(n);Yd(p);Yd(r);pe(s);sq(t);qq(v);i=q;return c[m>>2]|0}}else d=cc()|0;while(0);Yd(r)}pe(s)}else u=11}else u=11;while(0);if((u|0)==11)d=cc()|0;sq(t)}qq(v);bc(d|0);return 0}function pf(a){a=a|0;var b=0,d=0.0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0.0,A=0,B=0.0,C=0,E=0.0,F=0.0,G=0.0,H=0.0,I=0.0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0.0,ba=0,ca=0.0,da=0,ea=0.0,fa=0,ga=0.0,ha=0.0,ja=0.0,ka=0.0,la=0,na=0,oa=0,pa=0,ra=0,sa=0,ta=0,ua=0;na=i;i=i+224|0;_=na+216|0;ra=na+212|0;sa=na+208|0;ta=na+204|0;ua=na+200|0;e=na+188|0;b=na+152|0;f=na+148|0;j=na+144|0;k=na+140|0;l=na+136|0;n=na+132|0;p=na+128|0;r=na+124|0;t=na+120|0;s=na+116|0;u=na+112|0;v=na+108|0;w=na+104|0;x=na+100|0;L=na+88|0;J=na+52|0;M=na+48|0;N=na+44|0;O=na+40|0;P=na+36|0;Q=na+32|0;R=na+28|0;T=na+24|0;U=na+20|0;V=na+16|0;W=na+12|0;X=na+8|0;Y=na+4|0;Z=na;c[ra>>2]=0;vq(ra,0);c[sa>>2]=0;vq(sa,0);c[ta>>2]=0;vq(ta,0);c[ua>>2]=0;vq(ua,0);K=a+8|0;Zp(f,K);o=0;ma(97,b|0,f|0);oa=o;o=0;do if(!(oa&1)){o=0;ma(98,e|0,b|0);oa=o;o=0;if(oa&1){oa=cc(856)|0;e=D;c[b>>2]=29704;Yd(b+8|0);b=oa;oa=6;break}else{c[b>>2]=29704;Yd(b+8|0);Yd(f);vq(ra,c[c[e>>2]>>2]|0);vq(sa,c[(c[e>>2]|0)+4>>2]|0);vq(ta,c[(c[e>>2]|0)+8>>2]|0);vq(ua,c[(c[e>>2]|0)+12>>2]|0);wq(e);oa=22;break}}else{b=cc(856)|0;e=D;oa=6}while(0);a:do if((oa|0)==6){Yd(f);if((e|0)==(Xb(856)|0)){fc(b|0)|0;o=0;b=qa(121,c[K>>2]|0)|0;f=o;o=0;b:do if((!(f&1)?(q=(b|0)/2|0,o=0,g=qa(122,c[K>>2]|0)|0,f=o,o=0,!(f&1)):0)?(m=(g|0)/2|0,o=0,h=qa(111,16)|0,g=o,o=0,!(g&1)):0){e=q+7|0;g=m+-7|0;c[h+4>>2]=0;c[h>>2]=29720;c[h+8>>2]=e;c[h+12>>2]=g;c[l>>2]=0;pq(l,h);o=0;b=Ya(64,a|0,l|0,0,1,-1)|0;h=o;o=0;do if(h&1)b=cc()|0;else{c[k>>2]=b;o=0;b=qa(125,b|0)|0;h=o;o=0;if(h&1){b=cc()|0;qq(k);break}c[j>>2]=b;vq(ra,b);uq(j);qq(k);qq(l);o=0;b=qa(111,16)|0;l=o;o=0;if(l&1){oa=33;break b}f=m+7|0;c[b+4>>2]=0;c[b>>2]=29720;c[b+8>>2]=e;c[b+12>>2]=f;c[r>>2]=0;pq(r,b);o=0;b=Ya(64,a|0,r|0,0,1,1)|0;m=o;o=0;do if(m&1)b=cc()|0;else{c[p>>2]=b;o=0;b=qa(125,b|0)|0;m=o;o=0;if(m&1){b=cc()|0;qq(p);break}c[n>>2]=b;vq(sa,b);uq(n);qq(p);qq(r);o=0;b=qa(111,16)|0;r=o;o=0;if(r&1){oa=33;break b}e=q+-7|0;c[b+4>>2]=0;c[b>>2]=29720;c[b+8>>2]=e;c[b+12>>2]=f;c[u>>2]=0;pq(u,b);o=0;b=Ya(64,a|0,u|0,0,-1,-1)|0;r=o;o=0;do if(r&1)b=cc()|0;else{c[s>>2]=b;o=0;b=qa(125,b|0)|0;r=o;o=0;if(r&1){b=cc()|0;qq(s);break}c[t>>2]=b;vq(ta,b);uq(t);qq(s);qq(u);o=0;b=qa(111,16)|0;u=o;o=0;if(u&1){oa=33;break b}c[b+4>>2]=0;c[b>>2]=29720;c[b+8>>2]=e;c[b+12>>2]=g;c[x>>2]=0;pq(x,b);o=0;b=Ya(64,a|0,x|0,0,-1,-1)|0;u=o;o=0;do if(!(u&1)){c[w>>2]=b;o=0;b=qa(125,b|0)|0;u=o;o=0;if(!(u&1)){c[v>>2]=b;vq(ua,b);uq(v);qq(w);qq(x);o=0;ob(44);oa=o;o=0;if(oa&1){oa=46;break a}else{oa=22;break a}}else{b=cc()|0;qq(w);break}}else b=cc()|0;while(0);qq(x);break b}while(0);qq(u);break b}while(0);qq(r);break b}while(0);qq(l)}else oa=33;while(0);if((oa|0)==33)b=cc()|0;o=0;ob(44);na=o;o=0;if(na&1)oa=89;else pa=b}else pa=b}while(0);c:do if((oa|0)==22){b=c[ra>>2]|0;o=0;d=+Ka(c[(c[b>>2]|0)+8>>2]|0,b|0);x=o;o=0;if(((((((!(x&1)?(y=c[ua>>2]|0,o=0,z=+Ka(c[(c[y>>2]|0)+8>>2]|0,y|0),x=o,o=0,!(x&1)):0)?(A=c[sa>>2]|0,o=0,B=+Ka(c[(c[A>>2]|0)+8>>2]|0,A|0),x=o,o=0,!(x&1)):0)?(C=c[ta>>2]|0,o=0,E=+Ka(c[(c[C>>2]|0)+8>>2]|0,C|0),x=o,o=0,!(x&1)):0)?(S=~~((d+z+B+E)*.25+.5),o=0,F=+Ka(c[(c[b>>2]|0)+12>>2]|0,b|0),x=o,o=0,!(x&1)):0)?(o=0,G=+Ka(c[(c[y>>2]|0)+12>>2]|0,y|0),y=o,o=0,!(y&1)):0)?(o=0,H=+Ka(c[(c[A>>2]|0)+12>>2]|0,A|0),A=o,o=0,!(A&1)):0)?(o=0,I=+Ka(c[(c[C>>2]|0)+12>>2]|0,C|0),C=o,o=0,!(C&1)):0){f=~~((F+G+H+I)*.25+.5);Zp(M,K);o=0;ia(46,J|0,M|0,15,S|0,f|0);K=o;o=0;do if(!(K&1)){o=0;ma(98,L|0,J|0);K=o;o=0;if(K&1){b=cc(856)|0;e=D;c[J>>2]=29704;Yd(J+8|0);oa=50;break}else{c[J>>2]=29704;Yd(J+8|0);Yd(M);vq(ra,c[c[L>>2]>>2]|0);vq(sa,c[(c[L>>2]|0)+4>>2]|0);vq(ta,c[(c[L>>2]|0)+8>>2]|0);vq(ua,c[(c[L>>2]|0)+12>>2]|0);wq(L);break}}else{b=cc(856)|0;e=D;oa=50}while(0);d:do if((oa|0)==50){Yd(M);if((e|0)!=(Xb(856)|0)){pa=b;break c}fc(b|0)|0;o=0;b=qa(111,16)|0;M=o;o=0;e:do if(M&1)oa=74;else{e=S+7|0;g=f+-7|0;c[b+4>>2]=0;c[b>>2]=29720;c[b+8>>2]=e;c[b+12>>2]=g;c[P>>2]=0;pq(P,b);o=0;b=Ya(64,a|0,P|0,0,1,-1)|0;M=o;o=0;do if(M&1)b=cc()|0;else{c[O>>2]=b;o=0;b=qa(125,b|0)|0;M=o;o=0;if(M&1){b=cc()|0;qq(O);break}c[N>>2]=b;vq(ra,b);uq(N);qq(O);qq(P);o=0;b=qa(111,16)|0;P=o;o=0;if(P&1){oa=74;break e}f=f+7|0;c[b+4>>2]=0;c[b>>2]=29720;c[b+8>>2]=e;c[b+12>>2]=f;c[T>>2]=0;pq(T,b);o=0;b=Ya(64,a|0,T|0,0,1,1)|0;P=o;o=0;do if(P&1)b=cc()|0;else{c[R>>2]=b;o=0;b=qa(125,b|0)|0;P=o;o=0;if(P&1){b=cc()|0;qq(R);break}c[Q>>2]=b;vq(sa,b);uq(Q);qq(R);qq(T);o=0;b=qa(111,16)|0;T=o;o=0;if(T&1){oa=74;break e}e=S+-7|0;c[b+4>>2]=0;c[b>>2]=29720;c[b+8>>2]=e;c[b+12>>2]=f;c[W>>2]=0;pq(W,b);o=0;b=Ya(64,a|0,W|0,0,-1,1)|0;T=o;o=0;do if(T&1)b=cc()|0;else{c[V>>2]=b;o=0;b=qa(125,b|0)|0;T=o;o=0;if(T&1){b=cc()|0;qq(V);break}c[U>>2]=b;vq(ta,b);uq(U);qq(V);qq(W);o=0;b=qa(111,16)|0;W=o;o=0;if(W&1){oa=74;break e}c[b+4>>2]=0;c[b>>2]=29720;c[b+8>>2]=e;c[b+12>>2]=g;c[Z>>2]=0;pq(Z,b);o=0;b=Ya(64,a|0,Z|0,0,-1,-1)|0;a=o;o=0;do if(!(a&1)){c[Y>>2]=b;o=0;b=qa(125,b|0)|0;a=o;o=0;if(!(a&1)){c[X>>2]=b;vq(ua,b);uq(X);qq(Y);qq(Z);o=0;ob(44);pa=o;o=0;if(pa&1){oa=46;break c}else break d}else{b=cc()|0;qq(Y);break}}else b=cc()|0;while(0);qq(Z);break e}while(0);qq(W);break e}while(0);qq(T);break e}while(0);qq(P)}while(0);if((oa|0)==74)b=cc()|0;o=0;ob(44);na=o;o=0;if(na&1){oa=89;break c}else{pa=b;break c}}while(0);b=c[ra>>2]|0;o=0;d=+Ka(c[(c[b>>2]|0)+8>>2]|0,b|0);pa=o;o=0;if((((((((!(pa&1)?($=c[ua>>2]|0,o=0,aa=+Ka(c[(c[$>>2]|0)+8>>2]|0,$|0),pa=o,o=0,!(pa&1)):0)?(ba=c[sa>>2]|0,o=0,ca=+Ka(c[(c[ba>>2]|0)+8>>2]|0,ba|0),pa=o,o=0,!(pa&1)):0)?(da=c[ta>>2]|0,o=0,ea=+Ka(c[(c[da>>2]|0)+8>>2]|0,da|0),pa=o,o=0,!(pa&1)):0)?(fa=~~((d+aa+ca+ea)*.25+.5),o=0,ga=+Ka(c[(c[b>>2]|0)+12>>2]|0,b|0),pa=o,o=0,!(pa&1)):0)?(o=0,ha=+Ka(c[(c[$>>2]|0)+12>>2]|0,$|0),pa=o,o=0,!(pa&1)):0)?(o=0,ja=+Ka(c[(c[ba>>2]|0)+12>>2]|0,ba|0),pa=o,o=0,!(pa&1)):0)?(o=0,ka=+Ka(c[(c[da>>2]|0)+12>>2]|0,da|0),pa=o,o=0,!(pa&1)):0)?(o=0,la=qa(111,16)|0,pa=o,o=0,!(pa&1)):0){c[la+4>>2]=0;c[la>>2]=29720;c[la+8>>2]=fa;c[la+12>>2]=~~((ga+ha+ja+ka)*.25+.5);c[_>>2]=0;pq(_,la);uq(ua);uq(ta);uq(sa);uq(ra);i=na;return c[_>>2]|0}else oa=46}else oa=46}while(0);if((oa|0)==46)pa=cc()|0;else if((oa|0)==89){oa=cc(0)|0;oq(oa)}uq(ua);uq(ta);uq(sa);uq(ra);bc(pa|0);return 0}function qf(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0.0,Q=0.0,R=0.0;I=i;i=i+96|0;J=I+92|0;K=I+88|0;L=I+84|0;M=I+80|0;D=I+76|0;n=I+72|0;C=I+68|0;p=I+64|0;B=I+60|0;s=I+56|0;A=I+52|0;t=I+48|0;u=I+44|0;v=I+40|0;w=I+36|0;x=I+32|0;y=I+28|0;z=I+24|0;q=I+20|0;r=I+16|0;E=I+12|0;F=I+8|0;G=I+4|0;H=I;yq(J,e);yq(K,e);yq(L,e);yq(M,e);m=d+24|0;c[m>>2]=1;g=1;while(1){c[n>>2]=0;e=c[J>>2]|0;pq(n,e);o=0;h=Ya(64,d|0,n|0,g|0,1,-1)|0;l=o;o=0;if(l&1){N=11;break}c[D>>2]=h;qq(n);c[p>>2]=0;pq(p,c[K>>2]|0);o=0;j=Ya(64,d|0,p|0,g|0,1,1)|0;l=o;o=0;if(l&1){N=12;break}c[C>>2]=j;qq(p);c[s>>2]=0;pq(s,c[L>>2]|0);o=0;k=Ya(64,d|0,s|0,g|0,-1,1)|0;l=o;o=0;if(l&1){N=13;break}c[B>>2]=k;qq(s);c[t>>2]=0;f=c[M>>2]|0;pq(t,f);o=0;l=Ya(64,d|0,t|0,g|0,-1,-1)|0;O=o;o=0;if(O&1){N=14;break}c[A>>2]=l;qq(t);if((c[m>>2]|0)>2){c[u>>2]=0;pq(u,l);c[v>>2]=0;pq(v,h);Q=+zf(u,v);Q=Q*+(c[m>>2]|0);c[w>>2]=0;pq(w,f);c[x>>2]=0;pq(x,e);P=+zf(w,x);P=Q/(P*+((c[m>>2]|0)+2|0));qq(x);qq(w);qq(v);qq(u);if(!(P<.75|P>1.25)){c[y>>2]=0;pq(y,h);c[z>>2]=0;pq(z,j);c[q>>2]=0;pq(q,k);c[r>>2]=0;pq(r,l);o=0;e=Ya(65,d|0,y|0,z|0,q|0,r|0)|0;O=o;o=0;if(O&1){N=18;break}qq(r);qq(q);qq(z);qq(y);if(e)N=15;else f=0}else f=0}else N=15;if((N|0)==15){N=0;pq(J,h);pq(K,j);pq(L,k);pq(M,l);f=1;g=g^1}qq(A);qq(B);qq(C);qq(D);e=c[m>>2]|0;if(!f){N=22;break}e=e+1|0;c[m>>2]=e;if((e|0)>=9){N=22;break}}a:do if((N|0)==11){e=cc()|0;qq(n)}else if((N|0)==12){e=cc()|0;qq(p);N=21}else if((N|0)==13){e=cc()|0;qq(s);N=20}else if((N|0)==14){e=cc()|0;qq(t);N=19}else if((N|0)==18){e=cc()|0;qq(r);qq(q);qq(z);qq(y);qq(A);N=19}else if((N|0)==22){b:do switch(e|0){case 7:case 5:{a[d+12>>0]=(e|0)==5&1;Q=1.5/+((e<<1)+-3|0);g=c[J>>2]|0;f=c[g+8>>2]|0;p=c[M>>2]|0;n=c[p+8>>2]|0;g=c[g+12>>2]|0;m=c[L>>2]|0;l=c[m+12>>2]|0;R=Q*+(f-n|0);m=~~(+(c[m+8>>2]|0)-R+.5);P=Q*+(g-l|0);l=~~(+(l|0)-P+.5);f=~~(+(f|0)+R+.5);g=~~(+(g|0)+P+.5);j=c[K>>2]|0;h=c[j+8>>2]|0;j=c[j+12>>2]|0;p=c[p+12>>2]|0;P=Q*+(h-n|0);n=~~(+(n|0)-P+.5);Q=Q*+(j-p|0);p=~~(+(p|0)-Q+.5);h=~~(+(h|0)+P+.5);j=~~(+(j|0)+Q+.5);o=0;e=ya(91,d|0,f|0,g|0)|0;O=o;o=0;if(!(O&1)){if(e){o=0;e=ya(91,d|0,h|0,j|0)|0;O=o;o=0;if(O&1)break b;if(e){o=0;e=ya(91,d|0,m|0,l|0)|0;O=o;o=0;if(O&1)break b;if(e){o=0;e=ya(91,d|0,n|0,p|0)|0;O=o;o=0;if(O&1)break b;if(e){c[b>>2]=0;k=b+4|0;c[k>>2]=0;c[b+8>>2]=0;o=0;e=qa(111,16)|0;O=o;o=0;c:do if(!(O&1)){c[e+4>>2]=0;c[e>>2]=29720;c[e+8>>2]=f;c[e+12>>2]=g;c[E>>2]=0;pq(E,e);f=b+8|0;o=0;ma(99,b|0,E|0);O=o;o=0;if(O&1){e=cc()|0;qq(E);break}qq(E);o=0;e=qa(111,16)|0;O=o;o=0;if(!(O&1)){c[e+4>>2]=0;c[e>>2]=29720;c[e+8>>2]=h;c[e+12>>2]=j;c[F>>2]=0;pq(F,e);e=c[k>>2]|0;if(e>>>0>=(c[f>>2]|0)>>>0){o=0;ma(99,b|0,F|0);O=o;o=0;if(O&1){e=cc()|0;qq(F);break}}else{c[e>>2]=0;pq(e,c[F>>2]|0);c[k>>2]=(c[k>>2]|0)+4}qq(F);o=0;e=qa(111,16)|0;O=o;o=0;if(!(O&1)){c[e+4>>2]=0;c[e>>2]=29720;c[e+8>>2]=m;c[e+12>>2]=l;c[G>>2]=0;pq(G,e);e=c[k>>2]|0;if(e>>>0>=(c[f>>2]|0)>>>0){o=0;ma(99,b|0,G|0);O=o;o=0;if(O&1){e=cc()|0;qq(G);break}}else{c[e>>2]=0;pq(e,c[G>>2]|0);c[k>>2]=(c[k>>2]|0)+4}qq(G);o=0;e=qa(111,16)|0;O=o;o=0;if(!(O&1)){c[e+4>>2]=0;c[e>>2]=29720;c[e+8>>2]=n;c[e+12>>2]=p;c[H>>2]=0;pq(H,e);e=c[k>>2]|0;do if(e>>>0<(c[f>>2]|0)>>>0){c[e>>2]=0;pq(e,c[H>>2]|0);c[k>>2]=(c[k>>2]|0)+4}else{o=0;ma(99,b|0,H|0);O=o;o=0;if(!(O&1))break;e=cc()|0;qq(H);break c}while(0);qq(H);qq(M);qq(L);qq(K);qq(J);i=I;return}else N=48}else N=48}else N=48}else N=48;while(0);if((N|0)==48)e=cc()|0;sq(b);break a}}}}O=Ob(8)|0;zq(O,47115);c[O>>2]=29736;o=0;mb(55,O|0,24,146);o=0}break}default:{O=Ob(8)|0;zq(O,47077);c[O>>2]=29736;o=0;mb(55,O|0,24,146);o=0}}while(0);e=cc()|0}while(0);if((N|0)==19){qq(B);N=20}if((N|0)==20){qq(C);N=21}if((N|0)==21)qq(D);qq(M);qq(L);qq(K);qq(J);bc(e|0)}function rf(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;w=i;i=i+64|0;B=w+60|0;e=w+56|0;f=w+52|0;A=w+48|0;g=w+44|0;h=w+40|0;z=w+36|0;k=w+32|0;l=w+28|0;y=w+24|0;n=w+20|0;p=w+16|0;x=w+12|0;v=w+8|0;t=w+4|0;u=w;q=c[b+24>>2]|0;r=q<<1;yq(e,c[d>>2]|0);yq(f,(c[d>>2]|0)+4|0);j=r|1;o=0;m=kb(53,b|0,e|0,f|0,j|0)|0;s=o;o=0;if(s&1){B=cc()|0;qq(f);qq(e);e=B}else{c[B>>2]=m;qq(f);qq(e);yq(g,(c[d>>2]|0)+4|0);yq(h,(c[d>>2]|0)+8|0);o=0;s=kb(53,b|0,g|0,h|0,j|0)|0;f=o;o=0;if(f&1){e=cc()|0;qq(h);qq(g)}else{c[A>>2]=s;qq(h);qq(g);yq(k,(c[d>>2]|0)+8|0);yq(l,(c[d>>2]|0)+12|0);o=0;g=kb(53,b|0,k|0,l|0,j|0)|0;h=o;o=0;if(h&1){e=cc()|0;qq(l);qq(k)}else{c[z>>2]=g;qq(l);qq(k);yq(n,(c[d>>2]|0)+12|0);yq(p,c[d>>2]|0);o=0;f=kb(53,b|0,n|0,p|0,j|0)|0;d=o;o=0;if(d&1){e=cc()|0;qq(p);qq(n)}else{c[y>>2]=f;qq(p);qq(n);k=m+20|0;p=c[(c[k>>2]|0)+8>>2]|0;if((c[p>>2]&1|0)!=0?(c[p+(q>>4<<2)>>2]&1<<(r&30)|0)!=0:0){c[b+28>>2]=0;p=23}else p=13;do if((p|0)==13){p=c[(c[s+20>>2]|0)+8>>2]|0;if((c[p>>2]&1|0)!=0?(c[p+(q>>4<<2)>>2]&1<<(r&30)|0)!=0:0){c[b+28>>2]=1;p=23;break}p=c[(c[g+20>>2]|0)+8>>2]|0;if((c[p>>2]&1|0)!=0?(c[p+(q>>4<<2)>>2]&1<<(r&30)|0)!=0:0){c[b+28>>2]=2;p=23;break}p=c[(c[f+20>>2]|0)+8>>2]|0;if((c[p>>2]&1|0)!=0?(c[p+(q>>4<<2)>>2]&1<<(r&30)|0)!=0:0){c[b+28>>2]=3;p=23;break}p=Ob(8)|0;zq(p,47150);c[p>>2]=29736;o=0;mb(55,p|0,24,146);o=0;p=12}while(0);do if((p|0)==23){o=0;e=qa(111,24)|0;r=o;o=0;if(r&1)p=12;else{n=b+12|0;o=0;ma(90,e|0,((a[n>>0]|0)!=0?28:40)|0);r=o;o=0;if(r&1){x=cc()|0;Uz(e);e=x;break}c[x>>2]=0;Je(x,e);o=0;e=qa(111,24)|0;r=o;o=0;do if(!(r&1)){o=0;ma(90,e|0,((a[n>>0]|0)!=0?28:40)|0);r=o;o=0;if(r&1){w=cc()|0;Uz(e);e=w;break}c[v>>2]=0;Je(v,e);h=s+20|0;j=g+20|0;d=f+20|0;m=(c[v>>2]|0)+20|0;if(!(a[n>>0]|0)){g=0;do{do if((g|0)<5){f=g+2|0;e=f>>5;f=1<<f;if(c[(c[(c[k>>2]|0)+8>>2]|0)+(e<<2)>>2]&f){s=(c[(c[m>>2]|0)+8>>2]|0)+(g>>5<<2)|0;c[s>>2]=c[s>>2]|1<<g}if(c[(c[(c[h>>2]|0)+8>>2]|0)+(e<<2)>>2]&f){r=g+10|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<r}if(c[(c[(c[j>>2]|0)+8>>2]|0)+(e<<2)>>2]&f){r=g+20|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<r}if(!(c[(c[(c[d>>2]|0)+8>>2]|0)+(e<<2)>>2]&f))break;r=g+30|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<(r&31)}else{if((g|0)<=5)break;f=g+2|0;e=f>>5;f=1<<f;if(c[(c[(c[k>>2]|0)+8>>2]|0)+(e<<2)>>2]&f){r=g+-1|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<(r&31)}if(c[(c[(c[h>>2]|0)+8>>2]|0)+(e<<2)>>2]&f){r=g+9|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<r}if(c[(c[(c[j>>2]|0)+8>>2]|0)+(e<<2)>>2]&f){r=g+19|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<r}if(!(c[(c[(c[d>>2]|0)+8>>2]|0)+(e<<2)>>2]&f))break;r=g+29|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<(r&31)}while(0);g=g+1|0}while((g|0)!=11);h=b+28|0;e=c[x>>2]|0;j=e+20|0;f=c[(c[m>>2]|0)+8>>2]|0;g=0;do{s=(((c[h>>2]|0)*10|0)+g|0)%40|0;if(c[f+(s>>5<<2)>>2]&1<<(s&31)){s=(c[(c[j>>2]|0)+8>>2]|0)+(g>>5<<2)|0;c[s>>2]=c[s>>2]|1<<(g&31)}g=g+1|0}while((g|0)!=40)}else{l=c[(c[k>>2]|0)+8>>2]|0;k=c[(c[h>>2]|0)+8>>2]|0;j=c[(c[j>>2]|0)+8>>2]|0;e=c[(c[d>>2]|0)+8>>2]|0;h=0;do{g=h+2|0;f=g>>5;g=1<<g;if(c[l+(f<<2)>>2]&g){s=(c[(c[m>>2]|0)+8>>2]|0)+(h>>5<<2)|0;c[s>>2]=c[s>>2]|1<<h}if(c[k+(f<<2)>>2]&g){r=h+7|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<r}if(c[j+(f<<2)>>2]&g){r=h+14|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<r}if(c[e+(f<<2)>>2]&g){r=h+21|0;s=(c[(c[m>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[s>>2]=c[s>>2]|1<<r}h=h+1|0}while((h|0)!=7);h=b+28|0;e=c[x>>2]|0;j=e+20|0;f=c[(c[m>>2]|0)+8>>2]|0;g=0;do{s=(((c[h>>2]|0)*7|0)+g|0)%28|0;if(c[f+(s>>5<<2)>>2]&1<<(s&31)){s=(c[(c[j>>2]|0)+8>>2]|0)+(g>>5<<2)|0;c[s>>2]=c[s>>2]|1<<g}g=g+1|0}while((g|0)!=28)}c[t>>2]=0;Je(t,e);o=0;ma(100,t|0,(a[n>>0]|0)!=0|0);s=o;o=0;if(s&1){e=cc()|0;bq(t);bq(v);break}else{bq(t);c[u>>2]=0;Je(u,e);wf(b,u);bq(u);bq(v);bq(x);bq(y);bq(z);bq(A);bq(B);i=w;return}}else e=cc()|0;while(0);bq(x)}}while(0);if((p|0)==12)e=cc()|0;bq(y)}bq(z)}bq(A)}bq(B)}bc(e|0)}function sf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0.0,x=0.0,y=0.0;v=i;i=i+16|0;g=v+12|0;k=v+8|0;r=v+4|0;u=v;t=c[b+16>>2]|0;w=+(((t|0)>4|t<<1)+((t+-4|0)/8|0)|0)/(+(c[b+24>>2]|0)*2.0);t=c[d>>2]|0;f=c[t>>2]|0;e=c[f+8>>2]|0;m=c[t+8>>2]|0;l=c[m+8>>2]|0;h=e-l|0;f=c[f+12>>2]|0;m=c[m+12>>2]|0;j=f-m|0;y=w*+(((h|0)>0?1:-1)+h|0);l=~~(+(l|0)-y+.5);x=w*+(((j|0)>0?1:-1)+j|0);m=~~(+(m|0)-x+.5);e=~~(+(e|0)+y+.5);f=~~(+(f|0)+x+.5);j=c[t+4>>2]|0;h=c[j+8>>2]|0;t=c[t+12>>2]|0;s=c[t+8>>2]|0;p=h-s|0;j=c[j+12>>2]|0;t=c[t+12>>2]|0;q=j-t|0;x=w*+(((p|0)>0?1:-1)+p|0);s=~~(+(s|0)-x+.5);w=w*+(((q|0)>0?1:-1)+q|0);t=~~(+(t|0)-w+.5);h=~~(+(h|0)+x+.5);j=~~(+(j|0)+w+.5);if(((xf(b,e,f)|0?xf(b,h,j)|0:0)?xf(b,l,m)|0:0)?xf(b,s,t)|0:0){b=Sz(20)|0;c[b+4>>2]=0;c[b>>2]=29756;n=b+8|0;c[n>>2]=0;p=b+12|0;c[p>>2]=0;q=b+16|0;c[q>>2]=0;d=Sz(16)|0;o=0;wa(42,d|0,+(+(e|0)),+(+(f|0)));f=o;o=0;do if(f&1){v=cc()|0;Uz(d);d=v}else{c[g>>2]=0;vq(g,d);o=0;ma(101,n|0,g|0);f=o;o=0;if(f&1){d=cc()|0;uq(g);break}uq(g);d=Sz(16)|0;o=0;wa(42,d|0,+(+(h|0)),+(+(j|0)));j=o;o=0;if(j&1){v=cc()|0;Uz(d);d=v;break}c[k>>2]=0;vq(k,d);d=c[p>>2]|0;if(d>>>0>=(c[q>>2]|0)>>>0){o=0;ma(101,n|0,k|0);j=o;o=0;if(j&1){d=cc()|0;uq(k);break}}else{c[d>>2]=0;vq(d,c[k>>2]|0);c[p>>2]=(c[p>>2]|0)+4}uq(k);d=Sz(16)|0;o=0;wa(42,d|0,+(+(l|0)),+(+(m|0)));m=o;o=0;if(m&1){v=cc()|0;Uz(d);d=v;break}c[r>>2]=0;vq(r,d);d=c[p>>2]|0;if(d>>>0>=(c[q>>2]|0)>>>0){o=0;ma(101,n|0,r|0);m=o;o=0;if(m&1){d=cc()|0;uq(r);break}}else{c[d>>2]=0;vq(d,c[r>>2]|0);c[p>>2]=(c[p>>2]|0)+4}uq(r);d=Sz(16)|0;o=0;wa(42,d|0,+(+(s|0)),+(+(t|0)));t=o;o=0;if(t&1){v=cc()|0;Uz(d);d=v;break}c[u>>2]=0;vq(u,d);d=c[p>>2]|0;if(d>>>0>=(c[q>>2]|0)>>>0){o=0;ma(101,n|0,u|0);t=o;o=0;if(t&1){d=cc()|0;uq(u);break}}else{c[d>>2]=0;vq(d,c[u>>2]|0);c[p>>2]=(c[p>>2]|0)+4}uq(u);Dq(a,b);i=v;return}while(0);bc(d|0)}v=Ob(8)|0;zq(v,47182);c[v>>2]=29736;Hc(v|0,24,146)}function tf(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0.0,k=0.0,l=0,m=0,n=0.0,p=0.0,q=0.0,r=0.0,s=0.0,t=0.0,u=0.0,v=0,w=0,x=0;x=i;i=i+16|0;w=x+4|0;m=x;l=c[b+16>>2]|0;do if(!(a[b+12>>0]|0)){b=l<<2;if((l|0)<5){b=b+15|0;break}else{b=b+17+(((l+-4|0)/8|0)<<1)|0;break}}else b=(l<<2)+11|0;while(0);Zp(m,d);j=+(b|0)+-.5;d=c[e>>2]|0;o=0;k=+Ka(c[(c[d>>2]|0)+8>>2]|0,d|0);d=o;o=0;if((((((((!(d&1)?(e=c[e>>2]|0,o=0,n=+Ka(c[(c[e>>2]|0)+12>>2]|0,e|0),e=o,o=0,!(e&1)):0)?(e=c[h>>2]|0,o=0,p=+Ka(c[(c[e>>2]|0)+8>>2]|0,e|0),e=o,o=0,!(e&1)):0)?(h=c[h>>2]|0,o=0,q=+Ka(c[(c[h>>2]|0)+12>>2]|0,h|0),h=o,o=0,!(h&1)):0)?(h=c[g>>2]|0,o=0,r=+Ka(c[(c[h>>2]|0)+8>>2]|0,h|0),h=o,o=0,!(h&1)):0)?(h=c[g>>2]|0,o=0,s=+Ka(c[(c[h>>2]|0)+12>>2]|0,h|0),h=o,o=0,!(h&1)):0)?(h=c[f>>2]|0,o=0,t=+Ka(c[(c[h>>2]|0)+8>>2]|0,h|0),h=o,o=0,!(h&1)):0)?(h=c[f>>2]|0,o=0,u=+Ka(c[(c[h>>2]|0)+12>>2]|0,h|0),h=o,o=0,!(h&1)):0)?(o=0,v=ab(42,w|0,m|0,b|0,.5,.5,+j,.5,+j,+j,.5,+j,+k,+n,+p,+q,+r,+s,+t,+u)|0,h=o,o=0,!(h&1)):0){Yd(m);i=x;return v|0}x=cc()|0;Yd(m);bc(x|0);return 0}function uf(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0.0,k=0.0,l=0,m=0.0,n=0.0,p=0,q=0;p=i;i=i+16|0;l=p+8|0;f=p+4|0;g=p;h=Sz(24)|0;o=0;ma(90,h|0,e|0);q=o;o=0;if(q&1){q=cc()|0;Uz(h);bc(q|0)}c[l>>2]=0;Je(l,h);yq(f,b);yq(g,d);n=+zf(f,g);qq(g);qq(f);k=n/+(e+-1|0);g=c[d>>2]|0;d=c[b>>2]|0;f=c[d+8>>2]|0;m=k*+((c[g+8>>2]|0)-f|0)/n;d=c[d+12>>2]|0;n=k*+((c[g+12>>2]|0)-d|0)/n;a=a+8|0;g=c[l>>2]|0;h=g+20|0;if((e|0)>0){b=0;k=+(f|0);j=+(d|0);while(1){if(eq(c[a>>2]|0,~~(k+.5),~~(j+.5))|0){q=(c[(c[h>>2]|0)+8>>2]|0)+(b>>5<<2)|0;c[q>>2]=c[q>>2]|1<<(b&31)}b=b+1|0;if((b|0)>=(e|0))break;else{k=m+k;j=n+j}}}i=p;return g|0}function vf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;t=i;i=i+32|0;u=t+20|0;q=t+16|0;n=t+12|0;p=t;s=b?2:4;k=b?7:10;l=k-s|0;b=Sz(20)|0;o=0;ma(102,b|0,k|0);j=o;o=0;if(j&1){d=cc()|0;Uz(b)}else{Fq(u,b);f=(c[u+8>>2]|0)+8|0;b=c[(c[(c[a>>2]|0)+20>>2]|0)+8>>2]|0;h=0;do{e=(h<<2)+4|0;g=1;j=1;while(1){v=e-j|0;if(c[b+(v>>5<<2)>>2]&1<<(v&31)){v=(c[f>>2]|0)+(h<<2)|0;c[v>>2]=(c[v>>2]|0)+g}j=j+1|0;if((j|0)==5)break;else g=g<<1}h=h+1|0}while((h|0)<(k|0));iq(n,4364);o=0;ma(92,q|0,n|0);v=o;o=0;do if(v&1){e=cc(256)|0;b=D;lq(n);r=16}else{lq(n);mq(p,u);o=0;mb(56,q|0,p|0,l|0);v=o;o=0;if(v&1){e=cc(256)|0;b=D;nq(p);Fh(q);r=16;break}nq(p);Fh(q);o=0;ka(304,c[a>>2]|0);v=o;o=0;if(v&1){d=cc()|0;break}d=c[f>>2]|0;g=0;do{b=(g<<2)+4|0;e=d+(g<<2)|0;f=1;h=1;while(1){if((c[e>>2]&f|0)==(f|0)){r=b-h|0;v=(c[(c[(c[a>>2]|0)+20>>2]|0)+8>>2]|0)+(r>>5<<2)|0;c[v>>2]=c[v>>2]|1<<(r&31)}h=h+1|0;if((h|0)==5)break;else f=f<<1}g=g+1|0}while((g|0)<(s|0));nq(u);i=t;return}while(0);if((r|0)==16)if((b|0)==(Xb(256)|0)){fc(e|0)|0;b=Ob(8)|0;zq(b,47215);c[b>>2]=29736;o=0;mb(55,b|0,24,146);o=0;b=cc()|0;o=0;ob(44);v=o;o=0;if(v&1){v=cc(0)|0;oq(v)}else d=b}else d=e;nq(u)}bc(d|0)}function wf(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;j=b+16|0;c[j>>2]=0;k=b+20|0;c[k>>2]=0;h=(a[b+12>>0]|0)==0;e=h?5:2;f=c[(c[(c[d>>2]|0)+20>>2]|0)+8>>2]|0;b=0;g=0;do{b=b<<1;c[j>>2]=b;if(c[f+(g>>5<<2)>>2]&1<<g){b=b|1;c[j>>2]=b}g=g+1|0}while((g|0)<(e|0));i=b;g=e+(h?11:6)|0;f=c[(c[(c[d>>2]|0)+20>>2]|0)+8>>2]|0;b=0;do{b=b<<1;c[k>>2]=b;if(c[f+(e>>5<<2)>>2]&1<<(e&31)){b=b|1;c[k>>2]=b}e=e+1|0}while((e|0)<(g|0));c[j>>2]=i+1;c[k>>2]=b+1;return}function xf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;if((b|0)>-1?(e=a+8|0,(d|0)>0&(ig(c[e>>2]|0)|0)>(b|0)):0)e=(jg(c[e>>2]|0)|0)>(d|0);else e=0;return e|0}function yf(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0;m=i;i=i+16|0;l=m;b=c[b>>2]|0;k=a+8|0;g=c[b+8>>2]|0;b=c[b+12>>2]|0;while(1){j=b+f|0;h=g+e|0;if(!(xf(a,h,j)|0))break;if((eq(c[k>>2]|0,h,j)|0)^d)break;else{g=h;b=j}}a:do if(xf(a,g,b)|0)do{if((eq(c[k>>2]|0,g,b)|0)^d)break a;g=g+e|0}while(xf(a,g,b)|0);while(0);g=g-e|0;b:do if(xf(a,g,b)|0)do{if((eq(c[k>>2]|0,g,b)|0)^d)break b;b=b+f|0}while(xf(a,g,b)|0);while(0);a=Sz(16)|0;c[a+4>>2]=0;c[a>>2]=29720;c[a+8>>2]=g;c[a+12>>2]=b-f;c[l>>2]=0;pq(l,a);i=m;return c[l>>2]|0}function zf(a,b){a=a|0;b=b|0;var d=0;d=c[a>>2]|0;a=c[b>>2]|0;b=(c[d+8>>2]|0)-(c[a+8>>2]|0)|0;b=$(b,b)|0;a=(c[d+12>>2]|0)-(c[a+12>>2]|0)|0;return +(+P(+(+(($(a,a)|0)+b|0))))}function Af(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0;r=i;i=i+32|0;g=r+28|0;h=r+24|0;j=r+20|0;k=r+16|0;l=r+12|0;m=r+8|0;p=r+4|0;q=r;n=Sz(16)|0;s=c[b>>2]|0;t=(c[s+8>>2]|0)+-3|0;s=(c[s+12>>2]|0)+3|0;c[n+4>>2]=0;c[n>>2]=29720;c[n+8>>2]=t;c[n+12>>2]=s;pq(b,n);n=Sz(16)|0;s=c[d>>2]|0;t=(c[s+8>>2]|0)+-3|0;s=(c[s+12>>2]|0)+-3|0;c[n+4>>2]=0;c[n>>2]=29720;c[n+8>>2]=t;c[n+12>>2]=s;pq(d,n);n=Sz(16)|0;s=c[e>>2]|0;t=(c[s+8>>2]|0)+3|0;s=(c[s+12>>2]|0)+-3|0;c[n+4>>2]=0;c[n>>2]=29720;c[n+8>>2]=t;c[n+12>>2]=s;pq(e,n);n=Sz(16)|0;s=c[f>>2]|0;t=(c[s+8>>2]|0)+3|0;s=(c[s+12>>2]|0)+3|0;c[n+4>>2]=0;c[n>>2]=29720;c[n+8>>2]=t;c[n+12>>2]=s;pq(f,n);yq(g,f);yq(h,b);o=0;n=ya(92,a|0,g|0,h|0)|0;s=o;o=0;a:do if(s&1){t=cc()|0;qq(h);qq(g);g=t}else{qq(h);qq(g);do if(n){yq(j,b);yq(k,d);o=0;g=ya(92,a|0,j|0,k|0)|0;t=o;o=0;if(t&1){g=cc()|0;qq(k);qq(j);break a}qq(k);qq(j);if((g|0)==(n|0)){yq(l,d);yq(m,e);o=0;g=ya(92,a|0,l|0,m|0)|0;t=o;o=0;if(t&1){g=cc()|0;qq(m);qq(l);break a}qq(m);qq(l);if((g|0)==(n|0)){yq(p,e);yq(q,f);o=0;g=ya(92,a|0,p|0,q|0)|0;t=o;o=0;if(t&1){g=cc()|0;qq(q);qq(p);break a}else{qq(q);qq(p);g=(g|0)==(n|0);break}}else g=0}else g=0}else g=0;while(0);i=r;return g|0}while(0);bc(g|0);return 0}function Bf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0.0,f=0,g=0.0,h=0,j=0.0,k=0.0,l=0,m=0.0,n=0;n=i;i=i+16|0;l=n+4|0;f=n;yq(l,b);yq(f,d);m=+zf(l,f);qq(f);qq(l);l=c[d>>2]|0;f=c[b>>2]|0;d=c[f+8>>2]|0;j=+((c[l+8>>2]|0)-d|0)/m;f=c[f+12>>2]|0;k=+((c[l+12>>2]|0)-f|0)/m;a=c[a+8>>2]|0;l=eq(a,d,f)|0;if(m>0.0){b=0;h=0;g=+(d|0);e=+(f|0);do{g=j+g;e=k+e;b=((l^(eq(a,~~(g+.5),~~(e+.5))|0))&1)+b|0;h=h+1|0}while(+(h|0)<m);e=+(b|0)}else e=0.0;e=e/m;if(e>.10000000149011612&e<.8999999761581421)b=0;else b=l^e<=.1?-1:1;i=n;return b|0}function Cf(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=4156;Ud(a+8|0,b);return}function Df(a){a=a|0;c[a>>2]=4156;Vd(a+8|0);return}function Ef(a){a=a|0;c[a>>2]=4156;Vd(a+8|0);Uz(a);return}function Ff(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;Ud(b,a+8|0);i=d;return c[b>>2]|0}function Gf(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=4184;Gq(a+8|0,b);return}function Hf(a){a=a|0;c[a>>2]=4184;le(a+8|0);return}function If(a){a=a|0;c[a>>2]=4184;le(a+8|0);Uz(a);return}function Jf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;f=i;i=i+16|0;e=f;a=c[a+8>>2]|0;g=c[(c[a>>2]|0)+8>>2]|0;Wd(e,d);o=0;d=ya(g|0,a|0,b|0,e|0)|0;b=o;o=0;if(b&1){g=cc()|0;bq(e);bc(g|0)}else{bq(e);i=f;return d|0}return 0}function Kf(a){a=a|0;a=c[a+8>>2]|0;return bd[c[(c[a>>2]|0)+12>>2]&255](a)|0}function Lf(a){a=a|0;var b=0,d=0;b=i;i=i+16|0;d=b;a=Ff(c[a+8>>2]|0)|0;c[d>>2]=a;a=c[a+8>>2]|0;Vd(d);i=b;return a|0}function Mf(a){a=a|0;var b=0,d=0;b=i;i=i+16|0;d=b;a=Ff(c[a+8>>2]|0)|0;c[d>>2]=a;a=c[a+12>>2]|0;Vd(d);i=b;return a|0}function Nf(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0;m=i;i=i+16|0;j=m+12|0;k=m+8|0;l=m+4|0;n=m;p=Sz(12)|0;g=c[a+8>>2]|0;h=c[(c[g>>2]|0)+16>>2]|0;o=0;a=qa(126,g|0)|0;q=o;o=0;if(q&1)a=cc()|0;else{c[n>>2]=a;o=0;a=Ya(c[(c[a>>2]|0)+20>>2]|0,a|0,b|0,d|0,e|0,f|0)|0;q=o;o=0;do if(!(q&1)){c[l>>2]=a;o=0;a=Wa(h|0,g|0,l|0)|0;q=o;o=0;if(q&1){a=cc()|0;Vd(l);break}else{c[k>>2]=a;Gf(p,k);c[j>>2]=0;Ne(j,p);le(k);Vd(l);Vd(n);i=m;return c[j>>2]|0}}else a=cc()|0;while(0);Vd(n)}Uz(p);bc(a|0);return 0}function Of(a){a=a|0;var b=0,d=0,e=0;d=i;i=i+16|0;b=d;a=Ff(c[a+8>>2]|0)|0;c[b>>2]=a;o=0;a=qa(c[(c[a>>2]|0)+24>>2]|0,a|0)|0;e=o;o=0;if(e&1){e=cc()|0;Vd(b);bc(e|0)}else{Vd(b);i=d;return a|0}return 0}function Pf(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0;h=i;i=i+16|0;e=h+12|0;f=h+8|0;g=h+4|0;j=h;k=Sz(12)|0;b=c[a+8>>2]|0;d=c[(c[b>>2]|0)+16>>2]|0;o=0;a=qa(126,b|0)|0;l=o;o=0;if(l&1)a=cc()|0;else{c[j>>2]=a;o=0;a=qa(c[(c[a>>2]|0)+32>>2]|0,a|0)|0;l=o;o=0;do if(!(l&1)){c[g>>2]=a;o=0;a=Wa(d|0,b|0,g|0)|0;l=o;o=0;if(l&1){a=cc()|0;Vd(g);break}else{c[f>>2]=a;Gf(k,f);c[e>>2]=0;Ne(e,k);le(f);Vd(g);Vd(j);i=h;return c[e>>2]|0}}else a=cc()|0;while(0);Vd(j)}Uz(k);bc(a|0);return 0}function Qf(a){a=a|0;c[a+4>>2]=0;c[a>>2]=4200;return}function Rf(a){a=a|0;Aq(a);return}function Sf(a){a=a|0;Aq(a);Uz(a);return}function Tf(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=4220;c[a+8>>2]=b;kq(a+12|0,b+31>>5);return}function Uf(a){a=a|0;c[a>>2]=4220;nq(a+12|0);return}function Vf(a){a=a|0;c[a>>2]=4220;nq(a+12|0);Uz(a);return}function Wf(a){a=a|0;return c[a+8>>2]|0}function Xf(a){a=a|0;var b=0,d=0;d=c[a+20>>2]|0;a=c[d+8>>2]|0;d=(c[d+12>>2]|0)-a|0;b=d>>2;if((d|0)>0){d=0;do{c[a+(d<<2)>>2]=0;d=d+1|0}while((d|0)<(b|0))}return}function Yf(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0;if((d|0)<(b|0)){d=Ob(8)|0;o=0;ka(305,d|0);e=o;o=0;if(e&1){e=cc()|0;Nb(d|0);bc(e|0)}else Hc(d|0,240,66)}a:do if((d|0)==(b|0))d=1;else{i=d+-1|0;j=b>>5;k=i>>5;h=b&31;i=i&31;f=a+20|0;g=j;while(1){if((g|0)>(k|0)){d=1;break a}d=(g|0)>(j|0)?0:h;a=(g|0)<(k|0)?31:i;if(!((d|0)==0&(a|0)==31))if(d>>>0>a>>>0)d=0;else{b=d;d=0;while(1){d=1<<b|d;if((b|0)<(a|0))b=b+1|0;else break}}else d=-1;if((c[(c[(c[f>>2]|0)+8>>2]|0)+(g<<2)>>2]&d|0)==((e?d:0)|0))g=g+1|0;else{d=0;break}}}while(0);return d|0}function Zf(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0;j=i;i=i+16|0;h=j;b=a+20|0;e=c[b>>2]|0;kq(h,(c[e+12>>2]|0)-(c[e+8>>2]|0)>>2);e=c[a+8>>2]|0;f=c[h+8>>2]|0;g=f+8|0;if((e|0)>0){b=c[(c[b>>2]|0)+8>>2]|0;d=0;do{k=e-d+-1|0;if(c[b+(k>>5<<2)>>2]&1<<(k&31)){k=(c[g>>2]|0)+(d>>5<<2)|0;c[k>>2]=c[k>>2]|1<<(d&31)}d=d+1|0}while((e|0)>(d|0))}Hq(a+12|0,f);nq(h);i=j;return}function _f(a,b){a=a|0;b=b|0;Wd(a,b);o=0;ka(306,c[a>>2]|0);b=o;o=0;if(b&1){b=cc()|0;bq(a);bc(b|0)}else return}function $f(a){a=a|0;var b=0;o=0;ka(306,c[a>>2]|0);b=o;o=0;if(b&1){b=cc(0)|0;bq(a);oq(b)}else{bq(a);return}}function ag(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;d=c[a+8>>2]|0;a:do if((d|0)>(b|0)){e=b>>5;f=c[a+20>>2]|0;g=c[f+8>>2]|0;a=c[g+(e<<2)>>2]&-1<<(b&31);if(!a){f=(c[f+12>>2]|0)-g>>2;a=e;while(1){e=a+1|0;if((e|0)==(f|0))break a;a=c[g+(e<<2)>>2]|0;if(!a)a=e;else break}}g=(Iq(a)|0)+(e<<5)|0;d=(g|0)>(d|0)?d:g}while(0);return d|0}function bg(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;d=c[a+8>>2]|0;a:do if((d|0)>(b|0)){e=b>>5;f=c[a+20>>2]|0;g=c[f+8>>2]|0;a=-1<<(b&31)&~c[g+(e<<2)>>2];if(!a){f=(c[f+12>>2]|0)-g>>2;do{e=e+1|0;if((e|0)==(f|0))break a;a=c[g+(e<<2)>>2]|0}while((a|0)==-1);a=~a}g=(Iq(a)|0)+(e<<5)|0;d=(g|0)>(d|0)?d:g}while(0);return d|0}function cg(a,b){a=a|0;b=b|0;var d=0;c[a+4>>2]=0;c[a>>2]=4236;d=a+20|0;c[a+24>>2]=0;c[d>>2]=29772;c[a+28>>2]=0;o=0;mb(60,a|0,b|0,b|0);a=o;o=0;if(a&1){a=cc()|0;nq(d);bc(a|0)}else return}function dg(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;c[a+4>>2]=0;c[a>>2]=4236;e=a+20|0;c[a+24>>2]=0;c[e>>2]=29772;c[a+28>>2]=0;o=0;mb(60,a|0,b|0,d|0);b=o;o=0;if(b&1){b=cc()|0;nq(e);bc(b|0)}else return}function eg(a){a=a|0;c[a>>2]=4236;nq(a+20|0);return}function fg(a){a=a|0;c[a>>2]=4236;nq(a+20|0);Uz(a);return}function gg(a,b,d){a=a|0;b=b|0;d=d|0;d=($(c[a+16>>2]|0,d)|0)+(b>>5)|0;d=(c[(c[a+28>>2]|0)+8>>2]|0)+(d<<2)|0;c[d>>2]=c[d>>2]^1<<(b&31);return}function hg(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0;do if((d|b|0)<0){a=Ob(8)|0;o=0;ma(103,a|0,47247);b=o;o=0;if(b&1){b=cc()|0;Nb(a|0);a=b;break}else Hc(a|0,240,66)}else{if((e|0)<1|(f|0)<1){a=Ob(8)|0;o=0;ma(103,a|0,47280);b=o;o=0;if(b&1){b=cc()|0;Nb(a|0);a=b;break}else Hc(a|0,240,66)}i=e+b|0;j=f+d|0;if((j|0)<=(c[a+12>>2]|0)?(i|0)<=(c[a+8>>2]|0):0){k=a+16|0;h=a+28|0;if((f|0)>0){g=(e|0)>0;do{a=$(c[k>>2]|0,d)|0;if(g){f=c[(c[h>>2]|0)+8>>2]|0;e=b;do{l=f+((e>>5)+a<<2)|0;c[l>>2]=c[l>>2]|1<<(e&31);e=e+1|0}while((e|0)<(i|0))}d=d+1|0}while((d|0)<(j|0))}return}a=Ob(8)|0;o=0;ma(103,a|0,47316);l=o;o=0;if(l&1){l=cc()|0;Nb(a|0);a=l;break}else Hc(a|0,240,66)}while(0);bc(a|0)}function ig(a){a=a|0;return c[a+8>>2]|0}function jg(a){a=a|0;return c[a+12>>2]|0}function kg(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;n=i;i=i+176|0;h=n+152|0;l=n+16|0;k=n;if(e>>>0<=32?(lg(b)|0)>=(e|0):0){m=b+24|0;h=c[m>>2]|0;if((h|0)>0){f=8-h|0;l=(f|0)>(e|0)?e:f;f=f-l|0;j=b+20|0;k=c[j>>2]|0;f=(a[(c[(c[b+16>>2]|0)+8>>2]|0)+k>>0]&255>>>(8-l|0)<<f)>>f;g=e-l|0;h=l+h|0;c[m>>2]=h;if((h|0)==8){c[m>>2]=0;c[j>>2]=k+1;h=0}}else{g=e;f=0}if((g|0)>0){l=b+20|0;e=b+16|0;k=g+((g|0)<7?~g:-8)+8&-8;if((g|0)>7){j=g;do{b=c[l>>2]|0;f=d[(c[(c[e>>2]|0)+8>>2]|0)+b>>0]|f<<8;c[l>>2]=b+1;j=j+-8|0}while((j|0)>7)}g=g-k|0;if((g|0)>0){b=8-g|0;f=(a[(c[(c[e>>2]|0)+8>>2]|0)+(c[l>>2]|0)>>0]&255>>>b<<b)>>b|f<<g;c[m>>2]=h+g}}i=n;return f|0}j=l+56|0;g=l+4|0;c[l>>2]=29792;c[j>>2]=29812;o=0;ma(104,l+56|0,g|0);n=o;o=0;if(n&1)f=cc()|0;else{c[l+128>>2]=0;c[l+132>>2]=-1;c[l>>2]=29832;c[l+56>>2]=29852;o=0;ka(307,g|0);n=o;o=0;do if(n&1)f=cc()|0;else{c[g>>2]=29868;f=l+36|0;c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;c[l+48>>2]=0;c[l+52>>2]=16;c[h>>2]=0;c[h+4>>2]=0;c[h+8>>2]=0;o=0;ma(105,g|0,h|0);n=o;o=0;if(n&1){n=cc()|0;IC(h);IC(f);nD(g);f=n;break}IC(h);o=0;Wa(63,l|0,e|0)|0;n=o;o=0;do if(n&1)f=cc()|0;else{h=Ob(8)|0;o=0;ma(106,k|0,g|0);n=o;o=0;if(!(n&1)){o=0;ma(103,h|0,((a[k>>0]&1)==0?k+1|0:c[k+8>>2]|0)|0);n=o;o=0;if(n&1)g=1;else{o=0;mb(55,h|0,240,66);o=0;g=0}f=cc()|0;IC(k);if(!g)break}else f=cc()|0;Nb(h|0)}while(0);Nq(l);bc(f|0)}while(0)}iD(j);bc(f|0);return 0}function lg(a){a=a|0;var b=0;b=c[a+16>>2]|0;return ((c[b+12>>2]|0)-(c[b+8>>2]|0)-(c[a+20>>2]|0)<<3)-(c[a+24>>2]|0)|0}function mg(){ng(29940,29952);ng(29960,29972);ng(29984,29992);ng(30004,30012);ng(30024,30032);ng(30044,30052);ng(30064,30072);ng(30084,30092);ng(30104,30112);ng(30124,30132);ng(30144,30152);ng(30164,30172);ng(30184,30192);ng(30204,30212);ng(30224,30232);ng(30244,30252);ng(30264,30272);ng(30284,30292);ng(30304,30312);ng(30324,30332);ng(30344,30352);ng(30364,30372);ng(30388,30396);ng(30408,30420);ng(30432,30440);ng(30448,30456);ng(30476,30484);return 1}function ng(a,b){a=a|0;b=b|0;var c=0;c=Sz(16)|0;o=0;mb(61,c|0,a|0,b|0);a=o;o=0;if(a&1){a=cc()|0;Uz(c);bc(a|0)}else return}function og(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0;g=i;i=i+16|0;h=g+12|0;f=g;c[a+4>>2]=0;c[a>>2]=30504;j=a+8|0;c[j>>2]=b;e=a+12|0;c[e>>2]=d;c[h>>2]=0;Oq(h,a);b=c[j>>2]|0;a:do if((c[b>>2]|0)==-1)d=7;else{while(1){o=0;d=Wa(64,4244,b|0)|0;j=o;o=0;if(j&1)break;Oq(d,c[h>>2]|0);b=b+4|0;if((c[b>>2]|0)==-1){d=7;break a}}b=cc()|0;d=6}while(0);b:do if((d|0)==7){d=c[e>>2]|0;b=c[d>>2]|0;c:do if(b){while(1){j=iC(b)|0;o=0;mb(57,f|0,b|0,j|0);j=o;o=0;if(j&1){d=4;break}o=0;b=Wa(65,4256,f|0)|0;j=o;o=0;if(j&1){d=11;break}Oq(b,c[h>>2]|0);IC(f);d=d+4|0;b=c[d>>2]|0;if(!b)break c}if((d|0)==4){b=cc()|0;d=6;break b}else if((d|0)==11){b=cc()|0;IC(f);break b}}while(0);Rq(h);i=g;return}while(0);Rq(h);bc(b|0)}function pg(a){a=a|0;return c[c[a+12>>2]>>2]|0}function qg(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;c[b>>2]=a;if(a>>>0<=899){a=c[(Pq(4244,b)|0)>>2]|0;i=d;return a|0}b=Ob(8)|0;o=0;ka(308,b|0);d=o;o=0;if(d&1){d=cc()|0;Nb(b|0);bc(d|0)}else Hc(b|0,320,76);return 0}function rg(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;c[a+4>>2]=0;c[a>>2]=30520;h=a+8|0;Pd(h,b);g=a+20|0;Sq(g,d);b=a+24|0;Tq(b,e);o=0;ma(82,a+36|0,f|0);a=o;o=0;if(a&1){a=cc()|0;Uq(b);ne(g);Sd(h);bc(a|0)}else return}function sg(a,b,d){a=a|0;b=b|0;d=d|0;c[a+4>>2]=0;c[a>>2]=30520;Pd(a+8|0,b);Sq(a+20|0,d);c[a+28>>2]=0;c[a+24>>2]=30536;c[a+32>>2]=0;a=a+36|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function tg(a,b){a=a|0;b=b|0;Pd(a,b+8|0);return}function ug(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;Sq(b,a+20|0);i=d;return c[b>>2]|0}function vg(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0;c[a+4>>2]=0;c[a>>2]=29704;d=a+8|0;Zp(d,b);o=0;e=qa(121,c[b>>2]|0)|0;h=o;o=0;do if(!(h&1)?(f=a+12|0,c[f>>2]=e,o=0,g=qa(122,c[b>>2]|0)|0,h=o,o=0,!(h&1)):0){c[a+16>>2]=g;h=c[f>>2]|0;e=h-(c[1067]|0)>>1;c[a+20>>2]=e;b=(c[1067]|0)+h>>1;c[a+24>>2]=b;i=g-(c[1067]|0)>>1;c[a+32>>2]=i;f=(c[1067]|0)+g>>1;c[a+28>>2]=f;if((i|e|0)>-1&(f|0)<(g|0)&(b|0)<(h|0))return;else{i=Ob(8)|0;zq(i,47354);c[i>>2]=30552;o=0;mb(55,i|0,856,146);o=0;break}}while(0);i=cc()|0;Yd(d);bc(i|0)}function wg(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0;c[a+4>>2]=0;c[a>>2]=29704;g=a+8|0;Zp(g,b);o=0;h=qa(121,c[b>>2]|0)|0;k=o;o=0;if(!(k&1)?(i=a+12|0,c[i>>2]=h,o=0,j=qa(122,c[b>>2]|0)|0,k=o,o=0,!(k&1)):0){c[a+16>>2]=j;b=d>>1;d=e-b|0;c[a+20>>2]=d;k=b+e|0;c[a+24>>2]=k;e=f-b|0;c[a+32>>2]=e;f=b+f|0;c[a+28>>2]=f;if((e|d|0)>-1&(f|0)<(j|0)?(k|0)<(c[i>>2]|0):0)return;k=Ob(8)|0;zq(k,47354);c[k>>2]=30552;o=0;mb(55,k|0,856,146);o=0}k=cc()|0;Yd(g);bc(k|0)}function xg(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0;B=i;i=i+48|0;F=B+44|0;q=B+40|0;E=B+36|0;r=B+32|0;D=B+28|0;v=B+24|0;C=B+20|0;w=B+16|0;x=B+12|0;y=B+8|0;z=B+4|0;A=B;l=b+12|0;m=b+16|0;n=c[l>>2]|0;p=0;h=c[b+28>>2]|0;k=c[b+20>>2]|0;g=c[b+24>>2]|0;e=c[b+32>>2]|0;while(1){d=0;while(1){if((g|0)>=(n|0)){j=n;break}j=yg(b,e,h,g,0)|0;d=j?1:d;g=(j&1)+g|0;if(!j){u=3;break}}if((u|0)==3){u=0;j=c[l>>2]|0}if((g|0)>=(j|0))break;j=c[m>>2]|0;while(1){if((h|0)>=(j|0)){t=h;break}t=yg(b,k,g,h,1)|0;h=(t&1)+h|0;d=t?1:d;if(!t){u=8;break}}if((u|0)==8){u=0;j=c[m>>2]|0;t=h}if((t|0)>=(j|0))break;if((k|0)>-1){f=k;do{k=yg(b,e,t,f,0)|0;d=k?1:d;f=(k<<31>>31)+f|0}while(k&(f|0)>-1)}else f=k;if((f|0)<0)break;if((e|0)>-1){do{s=yg(b,f,g,e,1)|0;e=(s<<31>>31)+e|0;d=s?1:d}while((e|0)>-1&s);s=e}else s=e;if((s|0)<0)break;k=(d&1)!=0;p=p|k;if(!k){u=19;break}else{h=t;k=f;e=s}}if((u|0)==19?p:0){k=g-f|0;c[F>>2]=0;vq(F,0);e=1;while(1){if((e|0)>=(k|0)){u=26;break}o=0;d=Ya(66,b|0,f|0,t-e|0,e+f|0,t|0)|0;u=o;o=0;if(u&1){u=24;break}c[q>>2]=d;vq(F,d);uq(q);d=c[F>>2]|0;if(!d)e=e+1|0;else{j=d;u=28;break}}if((u|0)==24){d=cc()|0;u=25}else if((u|0)==26){d=c[F>>2]|0;if(!d){d=Ob(8)|0;zq(d,47396);c[d>>2]=30552;o=0;mb(55,d|0,856,146);o=0;d=cc()|0;u=25}else{j=d;u=28}}if((u|0)!=25)if((u|0)==28){c[E>>2]=0;vq(E,0);e=1;while(1){if((e|0)>=(k|0)){u=34;break}o=0;d=Ya(66,b|0,f|0,e+s|0,e+f|0,s|0)|0;u=o;o=0;if(u&1){u=32;break}c[r>>2]=d;vq(E,d);uq(r);d=c[E>>2]|0;if(!d)e=e+1|0;else{h=d;u=36;break}}if((u|0)==32){d=cc()|0;u=33}else if((u|0)==34){d=c[E>>2]|0;if(!d){d=Ob(8)|0;zq(d,47406);c[d>>2]=30552;o=0;mb(55,d|0,856,146);o=0;d=cc()|0;u=33}else{h=d;u=36}}if((u|0)!=33)if((u|0)==36){c[D>>2]=0;vq(D,0);e=1;while(1){if((e|0)>=(k|0)){u=42;break}o=0;d=Ya(66,b|0,g|0,e+s|0,g-e|0,s|0)|0;u=o;o=0;if(u&1){u=40;break}c[v>>2]=d;vq(D,d);uq(v);d=c[D>>2]|0;if(!d)e=e+1|0;else{f=d;u=44;break}}if((u|0)==40){d=cc()|0;u=41}else if((u|0)==42){d=c[D>>2]|0;if(!d){d=Ob(8)|0;zq(d,47416);c[d>>2]=30552;o=0;mb(55,d|0,856,146);o=0;d=cc()|0;u=41}else{f=d;u=44}}if((u|0)!=41)if((u|0)==44){c[C>>2]=0;vq(C,0);e=1;while(1){if((e|0)>=(k|0)){u=50;break}o=0;d=Ya(66,b|0,g|0,t-e|0,g-e|0,t|0)|0;v=o;o=0;if(v&1){u=48;break}c[w>>2]=d;vq(C,d);uq(w);d=c[C>>2]|0;if(!d)e=e+1|0;else{u=52;break}}if((u|0)==48){d=cc()|0;u=49}else if((u|0)==50){d=c[C>>2]|0;if(!d){d=Ob(8)|0;zq(d,47426);c[d>>2]=30552;o=0;mb(55,d|0,856,146);o=0;d=cc()|0;u=49}else u=52}do if((u|0)!=49)if((u|0)==52){c[x>>2]=0;vq(x,d);c[y>>2]=0;vq(y,j);c[z>>2]=0;vq(z,f);c[A>>2]=0;vq(A,h);o=0;Ca(50,a|0,b|0,x|0,y|0,z|0,A|0);b=o;o=0;if(b&1){d=cc()|0;uq(A);uq(z);uq(y);uq(x);break}else{uq(A);uq(z);uq(y);uq(x);uq(C);uq(D);uq(E);uq(F);i=B;return}}while(0);uq(C)}uq(D)}uq(E)}uq(F);bc(d|0)}F=Ob(8)|0;zq(F,47436);c[F>>2]=30552;Hc(F|0,856,146)}function yg(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;a=a+8|0;a:do if(f)while(1){if((b|0)>(d|0)){b=0;break a}if(eq(c[a>>2]|0,b,e)|0){b=1;break}else b=b+1|0}else while(1){if((b|0)>(d|0)){b=0;break a}if(eq(c[a>>2]|0,e,b)|0){b=1;break}else b=b+1|0}while(0);return b|0}function zg(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0.0,k=0.0,l=0.0,m=0.0,n=0,p=0,q=0.0,r=0.0;p=i;i=i+16|0;g=p+4|0;n=p;m=+(b|0);l=+(d|0);j=+(e|0);q=+(f|0);r=m-j;k=l-q;h=~~(+P(+(r*r+k*k))+.5);k=+(h|0);j=(j-m)/k;k=(q-l)/k;b=a+8|0;f=0;while(1){if((f|0)>=(h|0)){b=6;break}r=+(f|0);e=~~(m+j*r+.5);d=~~(l+k*r+.5);if(eq(c[b>>2]|0,e,d)|0){b=4;break}else f=f+1|0}do if((b|0)==4){b=Sz(16)|0;o=0;wa(42,b|0,+(+(e|0)),+(+(d|0)));n=o;o=0;if(n&1){p=cc()|0;Uz(b);bc(p|0)}else{c[g>>2]=0;vq(g,b);break}}else if((b|0)==6){c[n>>2]=0;vq(n,0);c[g>>2]=0;vq(g,c[n>>2]|0);uq(n)}while(0);i=p;return c[g>>2]|0}function Ag(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0.0,j=0.0,k=0.0,l=0.0,m=0.0,n=0.0,p=0,q=0,r=0,s=0,t=0.0,u=0,v=0,w=0.0,x=0,y=0,z=0,A=0,B=0,C=0.0;z=i;i=i+32|0;x=z+28|0;u=z+24|0;r=z+20|0;p=z+16|0;y=z+12|0;v=z+8|0;s=z+4|0;q=z;B=c[d>>2]|0;w=+ld[c[(c[B>>2]|0)+8>>2]&63](B);d=c[d>>2]|0;t=+ld[c[(c[d>>2]|0)+12>>2]&63](d);d=c[e>>2]|0;l=+ld[c[(c[d>>2]|0)+8>>2]&63](d);d=c[e>>2]|0;k=+ld[c[(c[d>>2]|0)+12>>2]&63](d);d=c[f>>2]|0;n=+ld[c[(c[d>>2]|0)+8>>2]&63](d);d=c[f>>2]|0;m=+ld[c[(c[d>>2]|0)+12>>2]&63](d);d=c[g>>2]|0;j=+ld[c[(c[d>>2]|0)+8>>2]&63](d);d=c[g>>2]|0;h=+ld[c[(c[d>>2]|0)+12>>2]&63](d);Vq(a,4);b=w<+(c[b+12>>2]|0)*.5;o=0;d=qa(111,16)|0;e=o;o=0;e=e&1;a:do if(b)if(e)A=11;else{C=+(c[1068]|0);o=0;wa(42,d|0,+(j-C),+(h+C));B=o;o=0;if(B&1){B=cc()|0;Uz(d);d=B;break}c[x>>2]=0;vq(x,d);o=0;d=qa(111,16)|0;B=o;o=0;do if(B&1)d=cc()|0;else{C=+(c[1068]|0);o=0;wa(42,d|0,+(l+C),+(k+C));B=o;o=0;if(B&1){B=cc()|0;Uz(d);d=B;break}c[u>>2]=0;vq(u,d);o=0;d=qa(111,16)|0;B=o;o=0;do if(B&1)d=cc()|0;else{C=+(c[1068]|0);o=0;wa(42,d|0,+(n-C),+(m-C));B=o;o=0;if(B&1){B=cc()|0;Uz(d);d=B;break}c[r>>2]=0;vq(r,d);o=0;d=qa(111,16)|0;B=o;o=0;do if(!(B&1)){C=+(c[1068]|0);o=0;wa(42,d|0,+(w+C),+(t-C));B=o;o=0;if(B&1){B=cc()|0;Uz(d);d=B;break}else{c[p>>2]=0;vq(p,d);vq(c[a>>2]|0,c[x>>2]|0);vq((c[a>>2]|0)+4|0,c[u>>2]|0);vq((c[a>>2]|0)+8|0,c[r>>2]|0);vq((c[a>>2]|0)+12|0,c[p>>2]|0);uq(p);uq(r);uq(u);uq(x);A=41;break a}}else d=cc()|0;while(0);uq(r)}while(0);uq(u)}while(0);uq(x)}else if(e)A=11;else{C=+(c[1068]|0);o=0;wa(42,d|0,+(j+C),+(h+C));B=o;o=0;if(B&1){B=cc()|0;Uz(d);d=B;break}c[y>>2]=0;vq(y,d);o=0;d=qa(111,16)|0;B=o;o=0;do if(B&1)d=cc()|0;else{C=+(c[1068]|0);o=0;wa(42,d|0,+(l+C),+(k-C));B=o;o=0;if(B&1){B=cc()|0;Uz(d);d=B;break}c[v>>2]=0;vq(v,d);o=0;d=qa(111,16)|0;B=o;o=0;do if(B&1)d=cc()|0;else{C=+(c[1068]|0);o=0;wa(42,d|0,+(n-C),+(m+C));B=o;o=0;if(B&1){B=cc()|0;Uz(d);d=B;break}c[s>>2]=0;vq(s,d);o=0;d=qa(111,16)|0;B=o;o=0;do if(!(B&1)){C=+(c[1068]|0);o=0;wa(42,d|0,+(w-C),+(t-C));B=o;o=0;if(B&1){B=cc()|0;Uz(d);d=B;break}else{c[q>>2]=0;vq(q,d);vq(c[a>>2]|0,c[y>>2]|0);vq((c[a>>2]|0)+4|0,c[v>>2]|0);vq((c[a>>2]|0)+8|0,c[s>>2]|0);vq((c[a>>2]|0)+12|0,c[q>>2]|0);uq(q);uq(s);uq(v);uq(y);A=41;break a}}else d=cc()|0;while(0);uq(s)}while(0);uq(v)}while(0);uq(y)}while(0);if((A|0)==11)d=cc()|0;else if((A|0)==41){i=z;return}wq(a);bc(d|0)}function Bg(a,b,d){a=a|0;b=b|0;d=d|0;c[a+4>>2]=0;c[a>>2]=30572;Zp(a+8|0,b);oe(a+12|0,d);return}function Cg(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;Zp(b,a+8|0);i=d;return c[b>>2]|0}function Dg(a,b){a=a|0;b=b|0;oe(a,b+12|0);return}function Eg(a,b){a=a|0;b=b|0;var d=0,e=0;e=i;i=i+16|0;d=e;Ud(d,b);o=0;ma(107,a|0,d|0);b=o;o=0;do if(!(b&1)){Vd(d);c[a>>2]=4284;d=a+12|0;Pd(d,30580);o=0;ma(91,a+24|0,32);b=o;o=0;if(b&1){e=cc()|0;Sd(d);Df(a);d=e;break}else{i=e;return}}else{e=cc()|0;Vd(d);d=e}while(0);bc(d|0)}function Fg(a){a=a|0;c[a>>2]=4284;nq(a+24|0);Sd(a+12|0);Df(a);return}function Gg(a){a=a|0;Fg(a);Uz(a);return}function Hg(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;e=i;i=i+16|0;d=e;f=c[a+20>>2]|0;if(((c[f+12>>2]|0)-(c[f+8>>2]|0)|0)<(b|0)){Rd(d,b);Ae(a+12|0,c[d+8>>2]|0);Sd(d)}d=c[(c[a+32>>2]|0)+8>>2]|0;b=0;do{c[d+(b<<2)>>2]=0;b=b+1|0}while((b|0)!=32);i=e;return}function Ig(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;r=i;i=i+48|0;n=r+40|0;m=r+36|0;q=r+24|0;g=r+12|0;p=r;h=Ff(a)|0;c[m>>2]=h;Vd(m);m=c[h+8>>2]|0;f=c[e>>2]|0;if((f|0)!=0?(Wf(f)|0)>=(m|0):0){Xf(c[e>>2]|0);j=7}else j=3;do if((j|0)==3){f=Sz(24)|0;o=0;ma(90,f|0,m|0);l=o;o=0;if(l&1){r=cc()|0;Uz(f);f=r;break}else{Je(e,f);j=7;break}}while(0);do if((j|0)==7){Hg(a,m);l=c[(c[h>>2]|0)+8>>2]|0;Pd(g,a+12|0);o=0;ub(l|0,q|0,h|0,b|0,g|0);l=o;o=0;if(l&1){f=cc()|0;Sd(g);break}Sd(g);mq(p,a+24|0);h=q+8|0;f=(c[p+8>>2]|0)+8|0;if((m|0)>0){g=0;do{l=(c[f>>2]|0)+((d[(c[(c[h>>2]|0)+8>>2]|0)+g>>0]|0)>>>3<<2)|0;c[l>>2]=(c[l>>2]|0)+1;g=g+1|0}while((g|0)<(m|0))}o=0;l=qa(127,p|0)|0;k=o;o=0;if(k&1){f=cc()|0;nq(p);Sd(q);break}k=c[(c[h>>2]|0)+8>>2]|0;f=m+-1|0;if((f|0)>1){h=d[k+1>>0]|0;a=d[k>>0]|0;b=1;while(1){j=b;b=b+1|0;g=d[k+b>>0]|0;if(((h<<2)-a-g>>1|0)<(l|0)){m=(c[(c[(c[e>>2]|0)+20>>2]|0)+8>>2]|0)+(j>>5<<2)|0;c[m>>2]=c[m>>2]|1<<(j&31)}if((b|0)>=(f|0))break;else{a=h;h=g}}}Wd(n,e);nq(p);Sd(q);i=r;return c[n>>2]|0}while(0);bc(f|0);return 0}function Jg(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;k=c[a+8>>2]|0;l=c[k+8>>2]|0;k=(c[k+12>>2]|0)-l|0;h=k>>2;if((k|0)>0){a=0;f=0;b=0;g=0;while(1){d=c[l+(g<<2)>>2]|0;e=(d|0)>(f|0);a=e?g:a;b=(d|0)>(b|0)?d:b;g=g+1|0;if((g|0)>=(h|0)){g=a;j=b;break}else f=e?d:f}}else{g=0;j=0}if((k|0)>0){a=0;e=0;f=0;while(1){b=f-g|0;b=$($(b,b)|0,c[l+(f<<2)>>2]|0)|0;d=(b|0)>(e|0);a=d?f:a;f=f+1|0;if((f|0)>=(h|0))break;else e=d?b:e}}else a=0;h=(g|0)>(a|0);i=h?g:a;h=h?a:g;if((i-h|0)<=(k>>6|0)){l=Ob(8)|0;c[l+4>>2]=0;c[l>>2]=30552;Hc(l|0,856,146)}a=i+-1|0;if((a|0)>(h|0)){e=a;g=-1;f=a;while(1){b=f-h|0;b=$($(b,b)|0,i-f|0)|0;b=$(b,j-(c[l+(f<<2)>>2]|0)|0)|0;d=(b|0)>(g|0);a=d?f:e;f=f+-1|0;if((f|0)<=(h|0))break;else{e=a;g=d?b:g}}}return a<<3|0}function Kg(a){a=a|0;var b=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;t=i;i=i+64|0;p=t+52|0;q=t+48|0;u=t+36|0;l=t+24|0;m=t+12|0;s=t;n=Ff(a)|0;c[q>>2]=n;Vd(q);q=c[n+8>>2]|0;r=c[n+12>>2]|0;b=Sz(32)|0;o=0;mb(54,b|0,q|0,r|0);k=o;o=0;if(k&1){u=cc()|0;Uz(b);b=u}else{c[p>>2]=0;Ke(p,b);o=0;ma(108,a|0,q|0);k=o;o=0;if(k&1)b=cc()|0;else{mq(u,a+24|0);b=a+12|0;a=(q<<2|0)/5|0;e=(q|0)/5|0;f=l+8|0;g=(c[u+8>>2]|0)+8|0;h=(e|0)<(a|0);k=1;while(1){v=c[(c[n>>2]|0)+8>>2]|0;Pd(m,b);j=($(k,r)|0)/5|0;o=0;ub(v|0,l|0,n|0,j|0,m|0);j=o;o=0;if(j&1){a=10;break}Sd(m);if(h){j=e;do{v=(c[g>>2]|0)+((d[(c[(c[f>>2]|0)+8>>2]|0)+j>>0]|0)>>>3<<2)|0;c[v>>2]=(c[v>>2]|0)+1;j=j+1|0}while((j|0)<(a|0))}Sd(l);k=k+1|0;if((k|0)>=5){a=12;break}}if((a|0)==10){b=cc()|0;Sd(m)}else if((a|0)==12){o=0;j=qa(127,u|0)|0;v=o;o=0;if(!(v&1)?(o=0,ma(c[(c[n>>2]|0)+12>>2]|0,s|0,n|0),v=o,o=0,!(v&1)):0){h=s+8|0;b=c[p>>2]|0;if((r|0)>0){a=(q|0)>0;g=0;do{e=$(g,q)|0;if(a){f=0;do{if((d[(c[(c[h>>2]|0)+8>>2]|0)+(f+e)>>0]|0|0)<(j|0))Xd(b,f,g);f=f+1|0}while((f|0)<(q|0))}g=g+1|0}while((g|0)<(r|0))}Sd(s);nq(u);i=t;return b|0}b=cc()|0}nq(u)}Yd(p)}bc(b|0);return 0}function Lg(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;f=i;i=i+16|0;a=f+4|0;d=f;e=Sz(36)|0;Ud(d,b);o=0;ma(109,e|0,d|0);b=o;o=0;if(b&1){b=cc()|0;Vd(d);Uz(e);bc(b|0)}else{c[a>>2]=0;Le(a,e);Vd(d);i=f;return c[a>>2]|0}return 0}function Mg(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,h=0.0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;p=i;i=i+32|0;s=p+20|0;r=p+8|0;a=p+4|0;q=p;f=Sz(32)|0;o=0;ma(110,f|0,d|0);n=o;o=0;if(n&1){a=cc()|0;Uz(f)}else{c[s>>2]=0;Ke(s,f);g[a>>2]=0.0;o=0;mb(62,r|0,d<<1|0,a|0);n=o;o=0;a:do if(n&1)a=cc()|0;else{m=r+4|0;k=c[s>>2]|0;b:do if((d|0)>0){n=0;while(1){a=c[r>>2]|0;f=(c[m>>2]|0)-a|0;l=f>>2;h=+(n|0)+.5;if((f|0)>0){j=0;do{g[a+(j<<2)>>2]=+(j>>1|0)+.5;g[a+((j|1)<<2)>>2]=h;j=j+2|0}while((j|0)<(l|0))}o=0;ma(111,c[e>>2]|0,r|0);j=o;o=0;if(j&1){f=8;break}Zp(q,b);o=0;ma(112,q|0,r|0);j=o;o=0;if(j&1){f=14;break}Yd(q);if((f|0)>0){a=0;do{j=c[r>>2]|0;if(eq(c[b>>2]|0,~~+g[j+(a<<2)>>2],~~+g[j+((a|1)<<2)>>2])|0)Xd(k,a>>1,n);a=a+2|0}while((a|0)<(l|0))}n=n+1|0;if((n|0)>=(d|0))break b}if((f|0)==8)a=cc()|0;else if((f|0)==14){a=cc()|0;Yd(q)}Xq(r);break a}while(0);Xq(r);i=p;return k|0}while(0);Yd(s)}bc(a|0);return 0}function Ng(b,d){b=b|0;d=d|0;var e=0,f=0,h=0,j=0.0,k=0.0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;q=i;i=i+176|0;r=q+152|0;v=q+16|0;u=q;p=ig(c[b>>2]|0)|0;m=jg(c[b>>2]|0)|0;n=c[d>>2]|0;b=(c[d+4>>2]|0)-n>>2;j=+(m+-1|0);k=+(p+-1|0);a:do if(b){l=0;while(1){f=n+(l<<2)|0;e=~~+g[f>>2];h=n+((l|1)<<2)|0;d=~~+g[h>>2];if((e|0)<-1)break;if((d|0)>(m|0)|((e|0)>(p|0)|(d|0)<-1))break;if((e|0)!=-1){if((e|0)==(p|0))g[f>>2]=k}else g[f>>2]=0.0;if((d|0)!=-1){if((d|0)==(m|0))g[h>>2]=j}else g[h>>2]=0.0;l=l+2|0;if(l>>>0>=b>>>0)break a}f=v+56|0;h=v+4|0;c[v>>2]=29792;c[f>>2]=29812;o=0;ma(104,v+56|0,h|0);q=o;o=0;if(q&1)b=cc()|0;else{c[v+128>>2]=0;c[v+132>>2]=-1;c[v>>2]=29832;c[v+56>>2]=29852;o=0;ka(307,h|0);q=o;o=0;do if(q&1)b=cc()|0;else{c[h>>2]=29868;b=v+36|0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;c[v+48>>2]=0;c[v+52>>2]=16;c[r>>2]=0;c[r+4>>2]=0;c[r+8>>2]=0;o=0;ma(105,h|0,r|0);q=o;o=0;if(q&1){w=cc()|0;IC(r);IC(b);nD(h);b=w;break}IC(r);o=0;b=Wa(66,v|0,47467)|0;r=o;o=0;do if(((!(r&1)?(o=0,s=Wa(63,b|0,e|0)|0,r=o,o=0,!(r&1)):0)?(o=0,t=Wa(66,s|0,52925)|0,s=o,o=0,!(s&1)):0)?(o=0,Wa(63,t|0,d|0)|0,t=o,o=0,!(t&1)):0){b=Ob(8)|0;o=0;ma(106,u|0,h|0);t=o;o=0;if(t&1){u=cc()|0;Nb(b|0);b=u;break}else{zq(b,(a[u>>0]&1)==0?u+1|0:c[u+8>>2]|0);c[b>>2]=29736;o=0;mb(55,b|0,24,146);o=0;b=cc()|0;IC(u);break}}else w=18;while(0);if((w|0)==18)b=cc()|0;Nq(v);bc(b|0)}while(0)}iD(f);bc(b|0)}while(0);i=q;return}function Og(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var h=0,j=0.0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;p=i;i=i+32|0;s=p+20|0;r=p+8|0;a=p+4|0;q=p;h=Sz(32)|0;o=0;mb(54,h|0,d|0,e|0);n=o;o=0;if(n&1){a=cc()|0;Uz(h)}else{c[s>>2]=0;Ke(s,h);g[a>>2]=0.0;o=0;mb(62,r|0,d<<1|0,a|0);n=o;o=0;a:do if(n&1)a=cc()|0;else{m=r+4|0;k=c[s>>2]|0;b:do if((e|0)>0){n=0;while(1){a=c[r>>2]|0;h=(c[m>>2]|0)-a|0;l=h>>2;j=+(n|0)+.5;if((h|0)>0){d=0;do{g[a+(d<<2)>>2]=+(d>>1|0)+.5;g[a+((d|1)<<2)>>2]=j;d=d+2|0}while((d|0)<(l|0))}o=0;ma(111,c[f>>2]|0,r|0);d=o;o=0;if(d&1){h=8;break}Zp(q,b);o=0;ma(112,q|0,r|0);d=o;o=0;if(d&1){h=14;break}Yd(q);if((h|0)>0){a=0;do{d=c[r>>2]|0;if(eq(c[b>>2]|0,~~+g[d+(a<<2)>>2],~~+g[d+((a|1)<<2)>>2])|0)Xd(k,a>>1,n);a=a+2|0}while((a|0)<(l|0))}n=n+1|0;if((n|0)>=(e|0))break b}if((h|0)==8)a=cc()|0;else if((h|0)==14){a=cc()|0;Yd(q)}Xq(r);break a}while(0);Xq(r);i=p;return k|0}while(0);Yd(s)}bc(a|0);return 0}function Pg(a,b,d,e,f,g,h,j,k,l,m,n,p,q,r,s,t,u,v){a=a|0;b=b|0;d=d|0;e=+e;f=+f;g=+g;h=+h;j=+j;k=+k;l=+l;m=+m;n=+n;p=+p;q=+q;r=+r;s=+s;t=+t;u=+u;v=+v;var w=0,x=0,y=0,z=0;z=i;i=i+16|0;y=z+8|0;w=z+4|0;x=z;a=bh(e,f,g,h,j,k,l,m,n,p,q,r,s,t,u,v)|0;c[y>>2]=a;Zp(w,b);c[x>>2]=0;Zq(x,a);o=0;a=kb(54,0,w|0,d|0,x|0)|0;b=o;o=0;if(b&1){z=cc()|0;_q(x);Yd(w);_q(y);bc(z|0)}else{_q(x);Yd(w);_q(y);i=z;return a|0}return 0}function Qg(){return 45623}function Rg(a,b){a=a|0;b=b|0;var d=0,e=0;e=i;i=i+16|0;d=e;Ud(d,b);o=0;ma(109,a|0,d|0);b=o;o=0;if(b&1){e=cc()|0;Vd(d);bc(e|0)}else{Vd(d);c[a>>2]=4312;b=a+36|0;c[b>>2]=0;Ke(b,0);a=a+40|0;c[a>>2]=0;Je(a,0);i=e;return}}function Sg(a){a=a|0;c[a>>2]=4312;bq(a+40|0);Yd(a+36|0);Fg(a);return}function Tg(a){a=a|0;Sg(a);Uz(a);return}function Ug(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;f=i;i=i+16|0;a=f+4|0;d=f;e=Sz(44)|0;Ud(d,b);o=0;ma(80,e|0,d|0);b=o;o=0;if(b&1){b=cc()|0;Vd(d);Uz(e);bc(b|0)}else{c[a>>2]=0;Le(a,e);Vd(d);i=f;return c[a>>2]|0}return 0}function Vg(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;p=i;i=i+80|0;j=p+72|0;b=p+68|0;r=p+56|0;q=p+44|0;h=p+32|0;n=p+28|0;k=p+16|0;l=p+4|0;d=p;m=a+36|0;if(!(c[m>>2]|0)){e=Ff(a)|0;c[b>>2]=e;Vd(b);f=c[e+8>>2]|0;g=c[e+12>>2]|0;a:do if((f|0)>39&(g|0)>39){$c[c[(c[e>>2]|0)+12>>2]&511](r,e);d=((f&7|0)!=0&1)+(f>>3)|0;e=((g&7|0)!=0&1)+(g>>3)|0;Pd(h,r);o=0;Oa(42,q|0,0,h|0,d|0,e|0,f|0,g|0);b=o;o=0;if(b&1){b=cc()|0;Sd(h)}else{Sd(h);o=0;b=qa(111,32)|0;h=o;o=0;do if(!(h&1)){o=0;mb(54,b|0,f|0,g|0);h=o;o=0;if(h&1){p=cc()|0;Uz(b);b=p;break}else{c[n>>2]=0;Ke(n,b);Pd(k,r);mq(l,q);Xg(a,k,d,e,f,g,l,n);nq(l);Sd(k);Ke(m,c[n>>2]|0);Yd(n);nq(q);Sd(r);break a}}else b=cc()|0;while(0);nq(q)}Sd(r);bc(b|0)}else{r=Kg(a)|0;c[d>>2]=r;Ke(m,r);Yd(d)}while(0);Zp(j,m)}else Zp(j,m);i=p;return c[j>>2]|0}function Wg(a,b,e,f,g,h,j){a=a|0;b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;F=i;i=i+16|0;E=F;kq(a,$(g,f)|0);C=j+-8|0;D=h+-8|0;w=e+8|0;x=E+8|0;y=a+8|0;if((g|0)>0){z=(f|0)>0;B=0;do{r=B<<3;r=$((r|0)>(C|0)?C:r,h)|0;s=(B|0)>0;t=$(B+-1|0,f)|0;u=$(B,f)|0;v=u+-1|0;if(z){A=0;do{p=A<<3;q=c[(c[w>>2]|0)+8>>2]|0;j=0;k=255;p=((p|0)>(D|0)?D:p)+r|0;b=0;e=0;while(1){l=0;do{o=d[q+(l+p)>>0]|0;b=o+b|0;k=(o|0)<(k|0)?o:k;j=(o|0)>(j|0)?o:j;l=l+1|0}while((l|0)!=8);if((j-k|0)>24){o=$(8-e|0,h)|0;if((e|0)!=7){m=c[(c[w>>2]|0)+8>>2]|0;n=p;do{n=n+h|0;e=e+1|0;l=0;do{G=l+n|0;b=(d[m+G>>0]|0)+b+(d[m+(G+1)>>0]|0)|0;l=l+2|0}while((l|0)<8)}while((e|0)!=7)}l=p+o|0;e=8}else l=p;e=e+1|0;if((e|0)>=8){e=k;break}else p=l+h|0}b=b>>6;if((j-e|0)<25){b=e>>1;if(s&(A|0)>0){mq(E,a);G=A+t|0;q=c[(c[x>>2]|0)+8>>2]|0;G=(c[q+(v+A<<2)>>2]<<1)+(c[q+(G<<2)>>2]|0)+(c[q+(G+-1<<2)>>2]|0)>>2;nq(E);b=(e|0)<(G|0)?G:b}}c[(c[(c[y>>2]|0)+8>>2]|0)+(A+u<<2)>>2]=b;A=A+1|0}while((A|0)<(f|0))}B=B+1|0}while((B|0)<(g|0))}i=F;return}function Xg(a,b,d,e,f,g,h,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;C=i;i=i+16|0;B=C;x=g+-8|0;y=f+-8|0;z=d+-3|0;A=e+-3|0;t=h+8|0;if((e|0)>0){u=(d|0)>0;w=0;do{p=w<<3;p=(p|0)>(x|0)?x:p;q=(w|0)<2?2:(w|0)>(A|0)?A:w;if(u){v=0;do{r=v<<3;s=(r|0)>(y|0);g=(v|0)<2?2:(v|0)>(z|0)?z:v;h=g+-2|0;k=g+-1|0;l=g+1|0;m=g+2|0;n=c[(c[t>>2]|0)+8>>2]|0;a=0;o=-2;do{D=$(o+q|0,d)|0;a=(c[n+(h+D<<2)>>2]|0)+a+(c[n+(k+D<<2)>>2]|0)+(c[n+(D+g<<2)>>2]|0)+(c[n+(l+D<<2)>>2]|0)+(c[n+(m+D<<2)>>2]|0)|0;o=o+1|0}while((o|0)!=3);Pd(B,b);Yg(0,B,s?y:r,p,(a|0)/25|0,f,j);Sd(B);v=v+1|0}while((v|0)<(d|0))}w=w+1|0}while((w|0)<(e|0))}i=C;return}function Yg(a,b,e,f,g,h,i){a=a|0;b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;var j=0,k=0,l=0;b=b+8|0;j=($(h,f)|0)+e|0;l=0;while(1){a=l+f|0;k=0;do{if((d[(c[(c[b>>2]|0)+8>>2]|0)+(k+j)>>0]|0|0)<=(g|0))Xd(c[i>>2]|0,k+e|0,a);k=k+1|0}while((k|0)!=8);l=l+1|0;if((l|0)==8)break;else j=j+h|0}return}function Zg(a){a=a|0;c[a+4>>2]=0;c[a>>2]=4340;return}function _g(a,b){a=a|0;b=b|0;zq(a,b);c[a>>2]=4340;return}function $g(a){a=a|0;Aq(a);return}function ah(a){a=a|0;Aq(a);Uz(a);return}function bh(a,b,d,e,f,g,h,j,k,l,m,n,p,q,r,s){a=+a;b=+b;d=+d;e=+e;f=+f;g=+g;h=+h;j=+j;k=+k;l=+l;m=+m;n=+n;p=+p;q=+q;r=+r;s=+s;var t=0,u=0,v=0,w=0,x=0,y=0,z=0;x=i;i=i+16|0;y=x+8|0;w=x+4|0;v=x;u=ch(a,b,d,e,f,g,h,j)|0;c[y>>2]=u;o=0;t=sa(42,+k,+l,+m,+n,+p,+q,+r,+s)|0;z=o;o=0;do if(!(z&1)){c[w>>2]=t;c[v>>2]=0;Zq(v,u);o=0;t=Wa(67,t|0,v|0)|0;z=o;o=0;if(z&1){t=cc()|0;_q(v);_q(w);break}else{_q(v);_q(w);_q(y);i=x;return t|0}}else t=cc()|0;while(0);_q(y);bc(t|0);return 0}function ch(a,b,d,e,f,g,h,j){a=+a;b=+b;d=+d;e=+e;f=+f;g=+g;h=+h;j=+j;var k=0,l=0,m=0,n=0;m=i;i=i+16|0;l=m;k=dh(a,b,d,e,f,g,h,j)|0;c[l>>2]=k;o=0;k=qa(128,k|0)|0;n=o;o=0;if(n&1){n=cc()|0;_q(l);bc(n|0)}else{_q(l);i=m;return k|0}return 0}function dh(a,b,d,e,f,h,j,k){a=+a;b=+b;d=+d;e=+e;f=+f;h=+h;j=+j;k=+k;var l=0,m=0.0,n=0.0,o=0,p=0,q=0.0,r=0.0,s=0.0;o=i;i=i+16|0;l=o;m=a-d+f-j;n=b-e+h-k;if(m==0.0&n==0.0){p=Sz(44)|0;c[p+4>>2]=0;c[p>>2]=30600;g[p+8>>2]=d-a;g[p+12>>2]=e-b;g[p+16>>2]=0.0;g[p+20>>2]=f-d;g[p+24>>2]=h-e;g[p+28>>2]=0.0;g[p+32>>2]=a;g[p+36>>2]=b;g[p+40>>2]=1.0;c[l>>2]=0;Zq(l,p)}else{r=d-f;f=j-f;q=e-h;s=k-h;h=r*s-q*f;f=(m*s-f*n)/h;h=(r*n-q*m)/h;p=Sz(44)|0;c[p+4>>2]=0;c[p>>2]=30600;g[p+8>>2]=d-a+f*d;g[p+12>>2]=e-b+f*e;g[p+16>>2]=f;g[p+20>>2]=j-a+h*j;g[p+24>>2]=k-b+h*k;g[p+28>>2]=h;g[p+32>>2]=a;g[p+36>>2]=b;g[p+40>>2]=1.0;c[l>>2]=0;Zq(l,p)}i=o;return c[l>>2]|0}function eh(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,h=0.0,j=0.0,k=0.0,l=0.0,m=0.0,n=0.0,o=0.0,p=0.0,q=0.0,r=0.0,s=0.0,t=0.0,u=0.0,v=0.0,w=0.0,x=0.0,y=0.0,z=0.0;e=i;i=i+16|0;d=e;f=Sz(44)|0;t=+g[a+8>>2];b=c[b>>2]|0;z=+g[b+8>>2];s=+g[a+20>>2];y=+g[b+12>>2];r=+g[a+32>>2];x=+g[b+16>>2];w=+g[b+20>>2];v=+g[b+24>>2];u=+g[b+28>>2];n=+g[b+32>>2];l=+g[b+36>>2];j=+g[b+40>>2];q=+g[a+12>>2];p=+g[a+24>>2];o=+g[a+36>>2];m=+g[a+16>>2];k=+g[a+28>>2];h=+g[a+40>>2];c[f+4>>2]=0;c[f>>2]=30600;g[f+8>>2]=t*z+s*y+r*x;g[f+12>>2]=z*q+y*p+x*o;g[f+16>>2]=z*m+y*k+x*h;g[f+20>>2]=t*w+s*v+r*u;g[f+24>>2]=w*q+v*p+u*o;g[f+28>>2]=w*m+v*k+u*h;g[f+32>>2]=t*n+s*l+r*j;g[f+36>>2]=n*q+l*p+j*o;g[f+40>>2]=n*m+l*k+j*h;c[d>>2]=0;Zq(d,f);i=e;return c[d>>2]|0}function fh(a){a=a|0;var b=0,d=0,e=0,f=0.0,h=0.0,j=0.0,k=0.0,l=0.0,m=0.0,n=0.0,o=0.0,p=0.0;d=i;i=i+16|0;b=d;e=Sz(44)|0;k=+g[a+24>>2];p=+g[a+40>>2];n=+g[a+28>>2];l=+g[a+36>>2];m=+g[a+32>>2];h=+g[a+20>>2];o=+g[a+16>>2];f=+g[a+12>>2];j=+g[a+8>>2];c[e+4>>2]=0;c[e>>2]=30600;g[e+8>>2]=k*p-n*l;g[e+12>>2]=l*o-p*f;g[e+16>>2]=n*f-k*o;g[e+20>>2]=n*m-p*h;g[e+24>>2]=p*j-m*o;g[e+28>>2]=h*o-n*j;g[e+32>>2]=l*h-k*m;g[e+36>>2]=m*f-l*j;g[e+40>>2]=k*j-h*f;c[b>>2]=0;Zq(b,e);i=d;return c[b>>2]|0}function gh(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0.0,q=0.0,r=0.0,s=0;n=c[b>>2]|0;o=(c[b+4>>2]|0)-n|0;j=o>>2;k=a+16|0;l=a+28|0;m=a+40|0;d=a+8|0;e=a+20|0;f=a+32|0;h=a+12|0;i=a+24|0;b=a+36|0;if((o|0)>0){a=0;do{s=n+(a<<2)|0;r=+g[s>>2];o=n+((a|1)<<2)|0;q=+g[o>>2];p=+g[m>>2]+(r*+g[k>>2]+q*+g[l>>2]);g[s>>2]=(+g[f>>2]+(r*+g[d>>2]+q*+g[e>>2]))/p;g[o>>2]=(+g[b>>2]+(r*+g[h>>2]+q*+g[i>>2]))/p;a=a+2|0}while((a|0)<(j|0))}return}function hh(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0;c[b+4>>2]=0;c[b>>2]=30616;g=b+8|0;h=b+32|0;c[g>>2]=0;c[g+4>>2]=0;c[g+8>>2]=0;c[g+12>>2]=0;c[g+16>>2]=0;c[g+20>>2]=0;c[g+24>>2]=0;$q(h,0);i=b+36|0;c[i>>2]=0;$q(i,0);c[b+40>>2]=e;c[b+44>>2]=d;c[b+48>>2]=f;a[b+52>>0]=0;if((e|0)<1?(o=0,ka(309,b|0),e=o,o=0,e&1):0){e=cc()|0;ar(i);ar(h);br(b+20|0);br(g);bc(e|0)}return}function ih(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;t=i;i=i+64|0;m=t+52|0;n=t+40|0;p=t+28|0;q=t+24|0;r=t+12|0;s=t;j=b+8|0;l=b+40|0;cr(j,c[l>>2]|0);k=b+20|0;cr(k,c[l>>2]|0);h=b+44|0;d=c[l>>2]|0;if((d|0)>0){f=c[j>>2]|0;g=0;d=1;while(1){c[f+(g<<2)>>2]=d;e=d<<1;d=c[l>>2]|0;if((e|0)>=(d|0))e=(c[h>>2]^e)&d+-1;g=g+1|0;if((g|0)>=(d|0))break;else d=e}}if((d|0)>1){f=c[j>>2]|0;d=c[k>>2]|0;e=0;do{c[d+(c[f+(e<<2)>>2]<<2)>>2]=e;e=e+1|0}while((e|0)<((c[l>>2]|0)+-1|0))}d=b+32|0;f=Sz(24)|0;o=0;e=qa(111,20)|0;l=o;o=0;do if(l&1){d=cc()|0;u=19}else{o=0;ma(102,e|0,1);l=o;o=0;if(l&1){d=cc()|0;Uz(e);u=19;break}Fq(n,e);o=0;mb(63,f|0,b|0,n|0);l=o;o=0;if(l&1){d=cc()|0;nq(n);u=19;break}c[m>>2]=0;$q(m,f);$q(d,c[m>>2]|0);ar(m);nq(n);vh(p,c[d>>2]|0);c[c[(c[p+8>>2]|0)+8>>2]>>2]=0;nq(p);d=b+36|0;f=Sz(24)|0;o=0;e=qa(111,20)|0;p=o;o=0;do if(!(p&1)){o=0;ma(102,e|0,1);p=o;o=0;if(p&1){d=cc()|0;Uz(e);break}Fq(r,e);o=0;mb(63,f|0,b|0,r|0);p=o;o=0;if(p&1){d=cc()|0;nq(r);break}else{c[q>>2]=0;$q(q,f);$q(d,c[q>>2]|0);ar(q);nq(r);vh(s,c[d>>2]|0);c[c[(c[s+8>>2]|0)+8>>2]>>2]=1;nq(s);a[b+52>>0]=1;i=t;return}}else d=cc()|0;while(0);Uz(f)}while(0);if((u|0)==19)Uz(f);bc(d|0)}function jh(b){b=b|0;if(!(a[b+52>>0]|0))ih(b);return}function kh(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;jh(a);dr(b,a+32|0);i=d;return c[b>>2]|0}function lh(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;jh(a);dr(b,a+36|0);i=d;return c[b>>2]|0}function mh(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0;j=i;i=i+32|0;e=j+24|0;h=j+12|0;g=j;jh(a);a:do if((b|0)<0){e=Ob(8)|0;o=0;ma(103,e|0,47503);j=o;o=0;if(j&1){j=cc()|0;Nb(e|0);e=j;break}else Hc(e|0,240,66)}else{b:do if(!d)dr(e,a+32|0);else{f=Sz(20)|0;o=0;ma(102,f|0,b+1|0);b=o;o=0;if(b&1){e=cc()|0;Uz(f);break a}Fq(h,f);c[c[(c[h+8>>2]|0)+8>>2]>>2]=d;o=0;f=qa(111,24)|0;b=o;o=0;do if(!(b&1)){mq(g,h);o=0;mb(63,f|0,a|0,g|0);a=o;o=0;if(a&1){e=cc()|0;nq(g);Uz(f);break}else{c[e>>2]=0;$q(e,f);nq(g);nq(h);break b}}else e=cc()|0;while(0);nq(h);break a}while(0);i=j;return c[e>>2]|0}while(0);bc(e|0);return 0}function nh(a,b){a=a|0;b=b|0;return b^a|0}function oh(a,b){a=a|0;b=b|0;jh(a);return c[(c[a+8>>2]|0)+(b<<2)>>2]|0}function ph(a,b){a=a|0;b=b|0;jh(a);if(b)return c[(c[a+20>>2]|0)+(b<<2)>>2]|0;b=Ob(8)|0;o=0;ma(103,b|0,47531);a=o;o=0;if(a&1){a=cc()|0;Nb(b|0);bc(a|0)}else Hc(b|0,240,66);return 0}function qh(a,b){a=a|0;b=b|0;jh(a);if(b)return c[(c[a+8>>2]|0)+((c[a+40>>2]|0)+-1-(c[(c[a+20>>2]|0)+(b<<2)>>2]|0)<<2)>>2]|0;b=Ob(8)|0;o=0;ma(103,b|0,47550);a=o;o=0;if(a&1){a=cc()|0;Nb(b|0);bc(a|0)}else Hc(b|0,240,66);return 0}function rh(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;jh(a);if((b|0)==0|(d|0)==0)b=0;else{e=c[a+20>>2]|0;b=c[(c[a+8>>2]|0)+((((c[e+(d<<2)>>2]|0)+(c[e+(b<<2)>>2]|0)|0)%((c[a+40>>2]|0)+-1|0)|0)<<2)>>2]|0}return b|0}function sh(a){a=a|0;return c[a+40>>2]|0}function th(a){a=a|0;return c[a+48>>2]|0}function uh(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0;p=i;i=i+32|0;j=p+16|0;k=p+12|0;l=p;c[a+4>>2]=0;c[a>>2]=30632;c[a+8>>2]=b;n=a+12|0;c[a+16>>2]=0;c[n>>2]=29772;h=a+20|0;c[h>>2]=0;m=d+8|0;d=c[m>>2]|0;e=c[d+8>>2]|0;a=(c[d+12>>2]|0)-e|0;f=a>>2;a:do if(!f){a=Ob(8)|0;o=0;ma(103,a|0,47584);p=o;o=0;if(p&1){p=cc()|0;Nb(a|0);a=p;break}else{o=0;mb(55,a|0,240,66);o=0;q=4;break}}else{do if((a|0)>4?(c[e>>2]|0)==0:0){b:do if((a|0)>4){a=1;while(1){if(c[e+(a<<2)>>2]|0){g=a;break b}a=a+1|0;if((f|0)<=(a|0)){g=a;break}}}else g=1;while(0);o=0;if((f|0)==(g|0)){a=kh(b)|0;m=o;o=0;if(m&1){q=4;break a}c[k>>2]=a;mq(j,a+12|0);Hq(n,c[j+8>>2]|0);nq(j);ar(k);break}a=Sz(20)|0;k=o;o=0;if(k&1){q=4;break a}o=0;ma(102,a|0,f-g|0);k=o;o=0;if(k&1){p=cc()|0;Uz(a);a=p;break a}Fq(l,a);Hq(n,c[l+8>>2]|0);nq(l);n=c[h>>2]|0;e=c[n+8>>2]|0;n=(c[n+12>>2]|0)-e|0;f=n>>2;if((n|0)>0){a=c[(c[m>>2]|0)+8>>2]|0;d=0;do{c[e+(d<<2)>>2]=c[a+(d+g<<2)>>2];d=d+1|0}while((d|0)<(f|0))}}else q=20;while(0);if((q|0)==20)Hq(n,d);i=p;return}while(0);if((q|0)==4)a=cc()|0;nq(n);bc(a|0)}function vh(a,b){a=a|0;b=b|0;mq(a,b+12|0);return}function wh(a){a=a|0;a=c[a+20>>2]|0;return ((c[a+12>>2]|0)-(c[a+8>>2]|0)>>2)+-1|0}function xh(a){a=a|0;return (c[c[(c[a+20>>2]|0)+8>>2]>>2]|0)==0|0}function yh(a,b){a=a|0;b=b|0;var d=0;d=c[a+20>>2]|0;a=c[d+8>>2]|0;return c[a+(((c[d+12>>2]|0)-a>>2)+~b<<2)>>2]|0}function zh(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;g=a+20|0;e=c[g>>2]|0;d=c[e+8>>2]|0;e=(c[e+12>>2]|0)-d|0;h=e>>2;switch(b|0){case 0:{d=c[d+(h+-1<<2)>>2]|0;break}case 1:{if((e|0)>0){a=0;d=0;do{d=nh(d,c[(c[(c[g>>2]|0)+8>>2]|0)+(a<<2)>>2]|0)|0;a=a+1|0}while((a|0)<(h|0))}else d=0;break}default:{d=c[d>>2]|0;f=a+8|0;if((e|0)>4){a=1;do{d=rh(c[f>>2]|0,b,d)|0;d=nh(d,c[(c[(c[g>>2]|0)+8>>2]|0)+(a<<2)>>2]|0)|0;a=a+1|0}while((a|0)<(h|0))}}}return d|0}function Ah(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;p=i;i=i+64|0;d=p+60|0;s=p+48|0;r=p+36|0;f=p+24|0;q=p+12|0;m=p;n=a+8|0;e=c[b>>2]|0;a:do if((c[n>>2]|0)!=(c[e+8>>2]|0)){d=Ob(8)|0;o=0;ma(103,d|0,47602);s=o;o=0;if(s&1){s=cc()|0;Nb(d|0);d=s;break}else Hc(d|0,240,66)}else{b:do if(!(c[c[(c[a+20>>2]|0)+8>>2]>>2]|0))dr(d,b);else{if(!(c[c[(c[e+20>>2]|0)+8>>2]>>2]|0)){c[d>>2]=0;$q(d,a);break}mq(s,a+12|0);mq(r,(c[b>>2]|0)+12|0);a=s+8|0;l=c[a>>2]|0;b=r+8|0;e=c[b>>2]|0;if(((c[l+12>>2]|0)-(c[l+8>>2]|0)|0)>((c[e+12>>2]|0)-(c[e+8>>2]|0)|0)){mq(f,s);Hq(s,e);Hq(r,c[f+8>>2]|0);nq(f)}o=0;e=qa(111,20)|0;l=o;o=0;do if(l&1)d=cc()|0;else{l=c[b>>2]|0;k=l+12|0;l=l+8|0;o=0;ma(102,e|0,(c[k>>2]|0)-(c[l>>2]|0)>>2|0);j=o;o=0;if(j&1){d=cc()|0;Uz(e);break}Fq(q,e);f=c[k>>2]|0;e=c[l>>2]|0;h=c[a>>2]|0;g=h+8|0;h=(f-e>>2)-((c[h+12>>2]|0)-(c[g>>2]|0)>>2)|0;j=(c[q+8>>2]|0)+8|0;if((h|0)>0){b=c[j>>2]|0;a=0;do{c[b+(a<<2)>>2]=c[e+(a<<2)>>2];a=a+1|0}while((a|0)<(h|0))}c:do if((h|0)<(f-e>>2|0)){b=h;while(1){o=0;e=Wa(68,c[(c[g>>2]|0)+(b-h<<2)>>2]|0,c[e+(b<<2)>>2]|0)|0;f=o;o=0;if(f&1)break;c[(c[j>>2]|0)+(b<<2)>>2]=e;b=b+1|0;e=c[l>>2]|0;if((b|0)>=((c[k>>2]|0)-e>>2|0)){b=24;break c}}d=cc()|0;b=21}else b=24;while(0);do if((b|0)==24){o=0;e=qa(111,24)|0;l=o;o=0;if(l&1){d=cc()|0;b=21;break}n=c[n>>2]|0;mq(m,q);o=0;mb(63,e|0,n|0,m|0);n=o;o=0;if(n&1){d=cc()|0;nq(m);Uz(e);break}else{c[d>>2]=0;$q(d,e);nq(m);nq(q);nq(r);nq(s);break b}}while(0);nq(q)}while(0);nq(r);nq(s);break a}while(0);i=p;return c[d>>2]|0}while(0);bc(d|0);return 0}function Bh(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;s=i;i=i+64|0;p=s+48|0;u=s+36|0;v=s+24|0;t=s+12|0;q=s;r=a+8|0;e=c[r>>2]|0;d=c[b>>2]|0;a:do if((e|0)!=(c[d+8>>2]|0)){d=Ob(8)|0;o=0;ma(103,d|0,47602);v=o;o=0;if(v&1){v=cc()|0;Nb(d|0);d=v;break}else Hc(d|0,240,66)}else{b:do if((c[c[(c[a+20>>2]|0)+8>>2]>>2]|0)!=0?(c[c[(c[d+20>>2]|0)+8>>2]>>2]|0)!=0:0){mq(u,a+12|0);e=c[u+8>>2]|0;m=e+8|0;e=(c[e+12>>2]|0)-(c[m>>2]|0)|0;n=e>>2;mq(v,(c[b>>2]|0)+12|0);a=c[v+8>>2]|0;k=a+8|0;a=(c[a+12>>2]|0)-(c[k>>2]|0)|0;l=a>>2;o=0;d=qa(111,20)|0;j=o;o=0;do if(j&1)d=cc()|0;else{o=0;ma(102,d|0,n+-1+l|0);j=o;o=0;if(j&1){t=cc()|0;Uz(d);d=t;break}Fq(t,d);j=(c[t+8>>2]|0)+8|0;c:do if((e|0)>0){e=(a|0)>0;g=0;d:while(1){b=c[(c[m>>2]|0)+(g<<2)>>2]|0;if(e){h=0;do{f=h+g|0;d=c[(c[j>>2]|0)+(f<<2)>>2]|0;o=0;a=ya(93,c[r>>2]|0,b|0,c[(c[k>>2]|0)+(h<<2)>>2]|0)|0;w=o;o=0;if(w&1)break d;o=0;d=Wa(68,d|0,a|0)|0;w=o;o=0;if(w&1)break d;c[(c[j>>2]|0)+(f<<2)>>2]=d;h=h+1|0}while((h|0)<(l|0))}g=g+1|0;if((g|0)>=(n|0)){a=22;break c}}d=cc()|0;a=20}else a=22;while(0);do if((a|0)==22){o=0;d=qa(111,24)|0;w=o;o=0;if(w&1){d=cc()|0;a=20;break}w=c[r>>2]|0;mq(q,t);o=0;mb(63,d|0,w|0,q|0);w=o;o=0;if(w&1){w=cc()|0;nq(q);Uz(d);d=w;break}else{c[p>>2]=0;$q(p,d);nq(q);nq(t);nq(v);nq(u);d=c[p>>2]|0;break b}}while(0);nq(t)}while(0);nq(v);nq(u);break a}else a=7;while(0);if((a|0)==7){d=kh(e)|0;c[p>>2]=d}i=s;return d|0}while(0);bc(d|0);return 0}function Ch(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;m=i;i=i+32|0;d=m+24|0;n=m+12|0;l=m;a:do switch(b|0){case 0:{c[d>>2]=kh(c[a+8>>2]|0)|0;break}case 1:{c[d>>2]=0;$q(d,a);break}default:{k=a+20|0;f=c[k>>2]|0;f=(c[f+12>>2]|0)-(c[f+8>>2]|0)|0;h=f>>2;e=Sz(20)|0;o=0;ma(102,e|0,h|0);j=o;o=0;if(j&1){d=cc()|0;Uz(e)}else{Fq(n,e);j=a+8|0;g=(c[n+8>>2]|0)+8|0;b:do if((f|0)>0){a=0;while(1){o=0;e=ya(93,c[j>>2]|0,c[(c[(c[k>>2]|0)+8>>2]|0)+(a<<2)>>2]|0,b|0)|0;f=o;o=0;if(f&1)break;c[(c[g>>2]|0)+(a<<2)>>2]=e;a=a+1|0;if((a|0)>=(h|0)){a=12;break b}}d=cc()|0;a=11}else a=12;while(0);do if((a|0)==12){o=0;e=qa(111,24)|0;b=o;o=0;if(b&1){d=cc()|0;a=11;break}b=c[j>>2]|0;mq(l,n);o=0;mb(63,e|0,b|0,l|0);b=o;o=0;if(b&1){d=cc()|0;nq(l);Uz(e);break}else{c[d>>2]=0;$q(d,e);nq(l);nq(n);break a}}while(0);nq(n)}bc(d|0)}}while(0);i=m;return c[d>>2]|0}function Dh(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;m=i;i=i+32|0;k=m+24|0;n=m+12|0;l=m;a:do if((b|0)<0){e=Ob(8)|0;o=0;ma(103,e|0,47650);n=o;o=0;if(n&1){n=cc()|0;Nb(e|0);e=n;break}else Hc(e|0,240,66)}else{b:do if(!d){e=kh(c[a+8>>2]|0)|0;c[k>>2]=e}else{h=a+20|0;f=c[h>>2]|0;f=(c[f+12>>2]|0)-(c[f+8>>2]|0)|0;j=f>>2;e=Sz(20)|0;o=0;ma(102,e|0,j+b|0);g=o;o=0;if(g&1){n=cc()|0;Uz(e);e=n;break a}Fq(n,e);g=a+8|0;a=(c[n+8>>2]|0)+8|0;c:do if((f|0)>0){b=0;while(1){o=0;e=ya(93,c[g>>2]|0,c[(c[(c[h>>2]|0)+8>>2]|0)+(b<<2)>>2]|0,d|0)|0;f=o;o=0;if(f&1)break;c[(c[a>>2]|0)+(b<<2)>>2]=e;b=b+1|0;if((b|0)>=(j|0)){b=15;break c}}e=cc()|0;b=14}else b=15;while(0);do if((b|0)==15){o=0;e=qa(111,24)|0;d=o;o=0;if(d&1){e=cc()|0;b=14;break}d=c[g>>2]|0;mq(l,n);o=0;mb(63,e|0,d|0,l|0);d=o;o=0;if(d&1){m=cc()|0;nq(l);Uz(e);e=m;break}else{c[k>>2]=0;$q(k,e);nq(l);nq(n);e=c[k>>2]|0;break b}}while(0);nq(n);break a}while(0);i=m;return e|0}while(0);bc(e|0);return 0}function Eh(a,b){a=a|0;b=b|0;iq(a,b);return}function Fh(a){a=a|0;lq(a);return}function Gh(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0;t=i;i=i+128|0;B=t+112|0;e=t+100|0;A=t+88|0;z=t+84|0;m=t+72|0;y=t+60|0;n=t+56|0;p=t+52|0;x=t+48|0;w=t+44|0;v=t+32|0;q=t+28|0;u=t+16|0;r=t+12|0;s=t;f=Sz(24)|0;l=c[a>>2]|0;mq(e,b);o=0;mb(63,f|0,l|0,e|0);l=o;o=0;if(l&1){B=cc()|0;nq(e);Uz(f);e=B}else{c[B>>2]=0;$q(B,f);nq(e);o=0;ma(91,A|0,d|0);l=o;o=0;a:do if(l&1)e=cc()|0;else{g=c[B>>2]|0;j=c[A+8>>2]|0;h=j+12|0;j=j+8|0;b:do if((d|0)>0){k=0;l=1;while(1){e=c[a>>2]|0;o=0;f=qa(129,e|0)|0;C=o;o=0;if(C&1){f=10;break}o=0;e=Wa(69,e|0,f+k|0)|0;C=o;o=0;if(C&1){f=10;break}o=0;e=Wa(70,g|0,e|0)|0;C=o;o=0;if(C&1){f=10;break}C=c[j>>2]|0;c[C+(((c[h>>2]|0)-C>>2)+~k<<2)>>2]=e;l=l&(e|0)==0;k=k+1|0;if((k|0)>=(d|0)){f=13;break}}do if((f|0)==10){e=cc()|0;f=12}else if((f|0)==13){if(l)break b;o=0;e=qa(111,24)|0;C=o;o=0;if(C&1){e=cc()|0;f=12;break}C=c[a>>2]|0;mq(m,A);o=0;mb(63,e|0,C|0,m|0);C=o;o=0;if(C&1){C=cc()|0;nq(m);Uz(e);e=C;break}c[z>>2]=0;$q(z,e);nq(m);o=0;e=ya(94,c[a>>2]|0,d|0,1)|0;C=o;o=0;do if(C&1)e=cc()|0;else{c[n>>2]=e;c[p>>2]=0;$q(p,c[z>>2]|0);o=0;ia(47,y|0,a|0,n|0,p|0,d|0);C=o;o=0;if(C&1){e=cc()|0;ar(p);ar(n);break}ar(p);ar(n);dr(x,c[y>>2]|0);dr(w,(c[y>>2]|0)+4|0);c[q>>2]=0;$q(q,c[x>>2]|0);o=0;mb(64,v|0,a|0,q|0);C=o;o=0;if(C&1){e=cc()|0;ar(q)}else{ar(q);c[r>>2]=0;$q(r,c[w>>2]|0);mq(s,v);o=0;ub(57,u|0,a|0,r|0,s|0);C=o;o=0;c:do if(C&1){e=cc()|0;nq(s);ar(r)}else{nq(s);ar(r);m=c[v+8>>2]|0;l=m+12|0;m=m+8|0;j=b+8|0;k=(c[u+8>>2]|0)+8|0;e=c[m>>2]|0;d:do if(((c[l>>2]|0)-e|0)>0){h=0;while(1){g=c[j>>2]|0;f=c[g+12>>2]|0;g=c[g+8>>2]|0;o=0;e=Wa(71,c[a>>2]|0,c[e+(h<<2)>>2]|0)|0;C=o;o=0;if(C&1){f=29;break}e=(f-g>>2)+-1-e|0;if((e|0)<0){f=23;break}o=0;f=Wa(68,c[(c[(c[j>>2]|0)+8>>2]|0)+(e<<2)>>2]|0,c[(c[k>>2]|0)+(h<<2)>>2]|0)|0;C=o;o=0;if(C&1){f=29;break}c[(c[(c[j>>2]|0)+8>>2]|0)+(e<<2)>>2]=f;h=h+1|0;e=c[m>>2]|0;if((h|0)>=((c[l>>2]|0)-e>>2|0))break d}if((f|0)==23){e=Ob(8)|0;Kh(e,47681);o=0;mb(55,e|0,256,68);o=0;e=cc()|0}else if((f|0)==29)e=cc()|0;nq(u);break c}while(0);nq(u);nq(v);ar(w);ar(x);fr(y);ar(z);break b}while(0);nq(v)}ar(w);ar(x);fr(y)}while(0);ar(z)}while(0);nq(A);break a}while(0);nq(A);ar(B);i=t;return}while(0);ar(B)}bc(e|0)}function Hh(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;A=i;i=i+80|0;g=A+68|0;F=A+64|0;E=A+60|0;D=A+56|0;C=A+52|0;y=A+48|0;z=A+44|0;v=A+40|0;m=A+36|0;q=A+32|0;n=A+28|0;r=A+24|0;p=A+20|0;s=A+16|0;u=A+12|0;t=A+8|0;B=A+4|0;x=A;l=wh(c[d>>2]|0)|0;if((l|0)<(wh(c[e>>2]|0)|0)){dr(g,d);$q(d,c[e>>2]|0);$q(e,c[g>>2]|0);ar(g)}dr(F,d);dr(E,e);o=0;g=qa(130,c[b>>2]|0)|0;l=o;o=0;if(l&1)d=cc()|0;else{c[D>>2]=g;o=0;d=qa(131,c[b>>2]|0)|0;l=o;o=0;if(l&1)d=cc()|0;else{c[C>>2]=d;l=(f|0)/2|0;e=c[E>>2]|0;a:while(1){o=0;d=qa(132,e|0)|0;k=o;o=0;if(k&1){f=13;break}if((d|0)<(l|0)){f=54;break}c[y>>2]=0;$q(y,c[F>>2]|0);c[z>>2]=0;$q(z,g);$q(F,e);$q(D,c[C>>2]|0);k=c[F>>2]|0;o=0;d=qa(133,k|0)|0;j=o;o=0;if(j&1){f=16;break}if(d){f=10;break}$q(E,c[y>>2]|0);o=0;d=qa(130,c[b>>2]|0)|0;j=o;o=0;if(j&1){f=16;break}c[v>>2]=d;o=0;d=qa(132,k|0)|0;j=o;o=0;if(j&1){f=38;break}o=0;d=Wa(72,k|0,d|0)|0;j=o;o=0;if(j&1){f=38;break}o=0;j=Wa(73,c[b>>2]|0,d|0)|0;h=o;o=0;if(h&1){f=38;break}while(1){e=c[E>>2]|0;o=0;d=qa(132,e|0)|0;h=o;o=0;if(h&1){f=37;break a}o=0;g=qa(132,k|0)|0;h=o;o=0;if(h&1){f=37;break a}if((d|0)<(g|0))break;o=0;d=qa(133,e|0)|0;h=o;o=0;if(h&1){f=37;break a}if(d)break;o=0;d=qa(132,e|0)|0;h=o;o=0;if(h&1){f=37;break a}o=0;g=qa(132,k|0)|0;h=o;o=0;if(h&1){f=37;break a}h=d-g|0;g=c[b>>2]|0;o=0;d=qa(132,e|0)|0;f=o;o=0;if(f&1){f=37;break a}o=0;d=Wa(72,e|0,d|0)|0;f=o;o=0;if(f&1){f=37;break a}o=0;f=ya(93,g|0,d|0,j|0)|0;g=o;o=0;if(g&1){f=37;break a}d=c[v>>2]|0;o=0;g=ya(94,c[b>>2]|0,h|0,f|0)|0;G=o;o=0;if(G&1){f=37;break a}c[q>>2]=g;o=0;d=Wa(74,d|0,q|0)|0;G=o;o=0;if(G&1){f=40;break a}c[m>>2]=d;$q(v,d);ar(m);ar(q);o=0;d=ya(95,k|0,h|0,f|0)|0;G=o;o=0;if(G&1){f=37;break a}c[r>>2]=d;o=0;d=Wa(74,e|0,r|0)|0;G=o;o=0;if(G&1){f=41;break a}c[n>>2]=d;$q(E,d);ar(n);ar(r)}d=c[v>>2]|0;c[u>>2]=0;g=c[D>>2]|0;$q(u,g);o=0;d=Wa(75,d|0,u|0)|0;G=o;o=0;if(G&1){f=48;break}c[s>>2]=d;c[t>>2]=0;$q(t,c[z>>2]|0);o=0;d=Wa(74,d|0,t|0)|0;G=o;o=0;if(G&1){f=49;break}c[p>>2]=d;$q(C,d);ar(p);ar(t);ar(s);ar(u);o=0;f=qa(132,e|0)|0;G=o;o=0;if(G&1){f=38;break}o=0;d=qa(132,k|0)|0;G=o;o=0;if(G&1){f=38;break}if((f|0)>=(d|0)){f=47;break}ar(v);ar(z);ar(y)}b:switch(f|0){case 10:{d=Ob(8)|0;Kh(d,47700);o=0;mb(55,d|0,256,68);o=0;d=cc()|0;f=17;break}case 13:{d=cc()|0;f=15;break}case 16:{d=cc()|0;f=17;break}case 37:{d=cc()|0;f=39;break}case 38:{d=cc()|0;f=39;break}case 40:{d=cc()|0;ar(q);f=52;break}case 41:{d=cc()|0;ar(r);f=52;break}case 47:{d=Ob(8)|0;zq(d,47717);c[d>>2]=30648;o=0;mb(55,d|0,872,146);o=0;d=cc()|0;f=39;break}case 48:{d=cc()|0;f=50;break}case 49:{d=cc()|0;ar(t);ar(s);f=50;break}case 54:{g=c[C>>2]|0;o=0;d=Wa(72,g|0,0)|0;G=o;o=0;do if(!(G&1)){if(!d){G=Ob(8)|0;Kh(G,47765);o=0;mb(55,G|0,256,68);o=0;break}o=0;d=Wa(73,c[b>>2]|0,d|0)|0;G=o;o=0;if(!(G&1)?(o=0,w=Wa(76,g|0,d|0)|0,G=o,o=0,!(G&1)):0){c[B>>2]=w;o=0;d=Wa(76,e|0,d|0)|0;G=o;o=0;do if(!(G&1)){c[x>>2]=d;o=0;ma(113,a|0,2);G=o;o=0;if(G&1){d=cc()|0;ar(x);break}else{$q(c[a>>2]|0,w);$q((c[a>>2]|0)+4|0,d);ar(x);ar(B);ar(C);ar(D);ar(E);ar(F);i=A;return}}else d=cc()|0;while(0);ar(B);break b}}while(0);d=cc()|0;f=15;break}}if((f|0)!=15)if((f|0)==17)f=53;else if((f|0)==39)f=52;else if((f|0)==50){ar(u);f=52}if((f|0)==52){ar(v);f=53}if((f|0)==53){ar(z);ar(y)}ar(C)}ar(D)}ar(E);ar(F);bc(d|0)}function Ih(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;k=l;j=wh(c[d>>2]|0)|0;e=Sz(20)|0;o=0;a:do if((j|0)==1){Eq(e,1);k=o;o=0;if(k&1){f=cc()|0;Uz(e);e=f;f=23;break}Fq(a,e);o=0;e=Wa(72,c[d>>2]|0,1)|0;k=o;o=0;if(k&1){e=cc()|0;nq(a);f=23;break}else{c[c[(c[a+8>>2]|0)+8>>2]>>2]=e;f=22;break}}else{Eq(e,j);h=o;o=0;if(h&1){f=cc()|0;Uz(e);e=f;f=23;break}Fq(k,e);g=(c[k+8>>2]|0)+8|0;e=0;h=1;while(1){o=0;f=qa(134,c[b>>2]|0)|0;m=o;o=0;if(m&1){f=16;break}if(!((e|0)<(j|0)&(h|0)<(f|0))){f=19;break}o=0;f=Wa(70,c[d>>2]|0,h|0)|0;m=o;o=0;if(m&1){f=16;break}if(!f){o=0;f=Wa(73,c[b>>2]|0,h|0)|0;m=o;o=0;if(m&1){f=16;break}c[(c[g>>2]|0)+(e<<2)>>2]=f;e=e+1|0}h=h+1|0}do if((f|0)==16)e=cc()|0;else if((f|0)==19)if((e|0)==(j|0)){mq(a,k);nq(k);f=22;break a}else{e=Ob(8)|0;Kh(e,47788);o=0;mb(55,e|0,256,68);o=0;e=cc()|0;break}while(0);nq(k);f=23}while(0);if((f|0)==22){i=l;return}else if((f|0)==23)bc(e|0)}function Jh(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;l=e+8|0;f=c[l>>2]|0;f=(c[f+12>>2]|0)-(c[f+8>>2]|0)|0;m=f>>2;e=Sz(20)|0;o=0;ma(102,e|0,m|0);k=o;o=0;a:do if(k&1){a=cc()|0;Uz(e);e=a}else{Fq(a,e);k=a+8|0;b:do if((f|0)>0){i=(f|0)>0;j=0;c:while(1){o=0;h=Wa(73,c[b>>2]|0,c[(c[(c[l>>2]|0)+8>>2]|0)+(j<<2)>>2]|0)|0;g=o;o=0;if(g&1){f=11;break}if(i){e=1;g=0;do{if((j|0)!=(g|0)){o=0;f=ya(93,c[b>>2]|0,c[(c[(c[l>>2]|0)+8>>2]|0)+(g<<2)>>2]|0,h|0)|0;n=o;o=0;if(n&1){f=10;break c}o=0;e=ya(93,c[b>>2]|0,e|0,((f&1|0)==0?f|1:f&-2)|0)|0;n=o;o=0;if(n&1){f=10;break c}}g=g+1|0}while((g|0)<(m|0))}else e=1;f=c[b>>2]|0;o=0;g=Wa(70,c[d>>2]|0,h|0)|0;n=o;o=0;if(n&1){f=11;break}o=0;e=Wa(73,c[b>>2]|0,e|0)|0;n=o;o=0;if(n&1){f=11;break}o=0;e=ya(93,f|0,g|0,e|0)|0;n=o;o=0;if(n&1){f=11;break}f=(c[k>>2]|0)+8|0;c[(c[f>>2]|0)+(j<<2)>>2]=e;o=0;e=qa(129,c[b>>2]|0)|0;n=o;o=0;if(n&1){f=11;break}if(e){o=0;e=ya(93,c[b>>2]|0,c[(c[f>>2]|0)+(j<<2)>>2]|0,h|0)|0;n=o;o=0;if(n&1){f=11;break}c[(c[f>>2]|0)+(j<<2)>>2]=e}j=j+1|0;if((j|0)>=(m|0))break b}if((f|0)==10)e=cc()|0;else if((f|0)==11)e=cc()|0;nq(a);break a}while(0);return}while(0);bc(e|0)}function Kh(a,b){a=a|0;b=b|0;zq(a,b);c[a>>2]=4392;return}function Lh(a){a=a|0;Aq(a);return}function Mh(a){a=a|0;Aq(a);Uz(a);return}function Nh(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=30668;EC(a+8|0,b);return}function Oh(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=30668;a=a+8|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;o=0;ma(114,a|0,b|0);b=o;o=0;if(b&1){b=cc()|0;IC(a);bc(b|0)}else return}function Ph(a){a=a|0;return a+8|0}function Qh(b,d){b=b|0;d=d|0;var e=0;e=b+8|0;if(!(a[e>>0]&1))e=e+1|0;else e=c[b+16>>2]|0;return a[e+d>>0]|0}function Rh(b){b=b|0;var d=0;d=a[b+8>>0]|0;if(!(d&1))d=(d&255)>>>1;else d=c[b+12>>2]|0;return d|0}function Sh(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;f=i;i=i+16|0;d=f+12|0;e=f;g=Sz(20)|0;a=a+8|0;o=0;ia(48,e|0,a|0,b|0,-1,a|0);a=o;o=0;do if(!(a&1)){o=0;ma(94,g|0,e|0);a=o;o=0;if(a&1){d=cc()|0;IC(e);break}else{c[d>>2]=0;cq(d,g);IC(e);i=f;return c[d>>2]|0}}else d=cc()|0;while(0);Uz(g);bc(d|0);return 0}function Th(b,d){b=b|0;d=d|0;var e=0,f=0;e=a[d>>0]|0;f=(e&1)==0;RC(b+8|0,f?d+1|0:c[d+8>>2]|0,f?(e&255)>>>1:c[d+4>>2]|0)|0;return}function Uh(a,b){a=a|0;b=b|0;NC(a+8|0,1,b)|0;return}function Vh(b,c,d,e){b=b|0;c=c|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;f=hr(e,4480)|0;a:do if((f|0)==(e+4|0)){if(((d|0)>3?(a[c>>0]|0)==-17:0)?(a[c+1>>0]|0)==-69:0)x=(a[c+2>>0]|0)==-65;else x=0;if((d|0)>0){p=1;n=1;o=1;u=0;m=0;s=0;v=0;w=0;t=0;k=0;j=0;i=0;h=0;g=0;e=0;while(1){q=a[c+u>>0]|0;l=q&255;do if(o){f=(l&128|0)==0;if((e|0)>0){r=f^1;o=r;e=(r<<31>>31)+e|0;break}if(!f)if(l&64){if(!(l&32)){o=1;i=i+1|0;e=e+1|0;break}if(!(l&16)){o=1;h=h+1|0;e=e+2|0;break}else{r=l&8;o=(r|0)==0;g=(r>>>3^1)+g|0;e=e+3|0;break}}else o=0;else o=1}else o=0;while(0);if(p?!(q<<24>>24<0&(q&255)<160):0)if((q&255)>159){p=1;m=(((q&255)<192|(q&-33)<<24>>24==-41)&1)+m|0}else p=1;else p=0;do if(n){if((s|0)>0){f=(q+-64&255)<189&q<<24>>24!=127;n=f;f=(f<<31>>31)+s|0;q=v;r=w;l=t;break}if(!((q&255)>239|(q&-33)<<24>>24==-128)){if((q+95&255)<63){v=w+1|0;n=1;f=s;q=0;r=v;l=t+1|0;j=(w|0)<(j|0)?j:v;break}if(q<<24>>24<0){w=v+1|0;n=1;f=s+1|0;q=w;r=0;l=t;k=(v|0)<(k|0)?k:w}else{n=1;f=s;q=0;r=0;l=t}}else{n=0;f=s;q=v;r=w;l=t}}else{n=0;f=s;q=v;r=w;l=t}while(0);u=u+1|0;if(!((u|0)<(d|0)&(o|(n|p))))break;else{s=f;v=q;w=r;t=l}}}else{p=1;n=1;o=1;m=0;f=0;l=0;k=0;j=0;i=0;h=0;g=0;e=0}f=(f|0)<1&n;do if(o&(e|0)<1){if(!x?(h+i+g|0)<=0:0)break;FC(b,52082,5);break a}while(0);if(!f)if(p){FC(b,47850,9);break}else{FC(b,52082,5);break}if((j|0)>2|(k|0)>2){FC(b,47840,9);break}if(p){FC(b,((l|0)!=2|(j|0)!=2)&(m*10|0)<(d|0)?47850:47840,9);break}else{FC(b,47840,9);break}}else EC(b,f+20|0);while(0);return}function Wh(a){a=a|0;c[a+4>>2]=0;c[a>>2]=4416;o=0;ka(310,a+8|0);a=o;o=0;if(a&1){a=cc()|0;bc(a|0)}else return}function Xh(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;l=i;i=i+80|0;f=l+76|0;g=l+72|0;r=l+60|0;d=l+56|0;q=l+52|0;p=l+40|0;n=l+36|0;e=l+32|0;m=l+28|0;h=l+16|0;j=l+4|0;k=l;c[d>>2]=Kf(c[b>>2]|0)|0;o=0;ma(115,r|0,d|0);b=o;o=0;if(b&1){r=cc()|0;Yd(d);d=r}else{Yd(d);o=0;d=qa(135,r|0)|0;b=o;o=0;if(b&1)d=cc()|0;else{c[q>>2]=d;o=0;ma(85,p|0,d|0);b=o;o=0;if(b&1)d=cc()|0;else{o=0;d=qa(118,d|0)|0;b=o;o=0;do if(b&1)d=cc()|0;else{c[e>>2]=d;o=0;b=Wa(77,a+8|0,e|0)|0;a=o;o=0;if(a&1){d=cc()|0;Yd(e);break}c[n>>2]=b;Yd(e);o=0;e=qa(111,40)|0;a=o;o=0;if(a&1)d=cc()|0;else{o=0;d=qa(116,b|0)|0;a=o;o=0;if(a&1)d=cc()|0;else{c[m>>2]=d;o=0;ma(86,h|0,b|0);a=o;o=0;do if(!(a&1)){oe(j,p);c[k>>2]=6;o=0;c[f>>2]=c[k>>2];ia(45,e|0,m|0,h|0,j|0,f|0);k=o;o=0;if(k&1){d=cc()|0;pe(j);Sd(h);break}else{c[g>>2]=0;Qe(g,e);pe(j);Sd(h);ne(m);aq(n);pe(p);ir(q);c[r>>2]=4440;Yd(r+8|0);i=l;return c[g>>2]|0}}else d=cc()|0;while(0);ne(m)}Uz(e)}aq(n)}while(0);pe(p)}ir(q)}c[r>>2]=4440;Yd(r+8|0)}bc(d|0);return 0}function Yh(a){a=a|0;c[a>>2]=4416;Fh(a+8|0);return}function Zh(a){a=a|0;Yh(a);Uz(a);return}function _h(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0;k=i;i=i+16|0;e=k+12|0;f=k+8|0;g=k+4|0;h=k;c[a+4>>2]=0;c[a>>2]=30684;l=a+8|0;c[l>>2]=0;Ke(l,0);m=a+12|0;c[m>>2]=0;jr(m,0);n=a+16|0;c[n>>2]=0;Ke(n,0);o=0;d=qa(122,c[b>>2]|0)|0;q=o;o=0;do if(!(q&1)){if(!((d+-8|0)>>>0<137&(d&1|0)==0)){p=Ob(8)|0;zq(p,47860);c[p>>2]=29736;o=0;mb(55,p|0,24,146);o=0;p=4;break}Zp(f,b);o=0;d=Wa(78,a|0,f|0)|0;q=o;o=0;if(q&1){d=cc()|0;Yd(f);break}c[e>>2]=d;jr(m,d);kr(e);Yd(f);Zp(h,b);o=0;d=Wa(79,a|0,h|0)|0;q=o;o=0;if(q&1){d=cc()|0;Yd(h);break}c[g>>2]=d;Ke(l,d);Yd(g);Yd(h);o=0;d=qa(111,32)|0;q=o;o=0;if(!(q&1)){o=0;e=qa(121,c[l>>2]|0)|0;q=o;o=0;if((!(q&1)?(o=0,j=qa(122,c[l>>2]|0)|0,q=o,o=0,!(q&1)):0)?(o=0,mb(54,d|0,e|0,j|0),q=o,o=0,!(q&1)):0){Ke(n,d);i=k;return}q=cc()|0;Uz(d);d=q}else p=4}else p=4;while(0);if((p|0)==4)d=cc()|0;Yd(n);kr(m);Yd(l);bc(d|0)}function $h(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;f=i;i=i+16|0;d=f+4|0;e=f;a=a+12|0;do if(!(c[a>>2]|0)){g=jg(c[b>>2]|0)|0;b=ig(c[b>>2]|0)|0;a=_i(c[a>>2]|0,g,b)|0;c[e>>2]=a;if(!a){g=Ob(8)|0;zq(g,47894);c[g>>2]=29736;o=0;mb(55,g|0,24,146);o=0;g=cc()|0;kr(e);bc(g|0)}else{c[d>>2]=0;jr(d,a);kr(e);break}}else lr(d,a);while(0);i=f;return c[d>>2]|0}function ai(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0;y=i;i=i+16|0;f=y;a=a+12|0;d=Ui(c[a>>2]|0)|0;e=Vi(c[a>>2]|0)|0;do if((jg(c[b>>2]|0)|0)!=(d|0)){a=Ob(8)|0;o=0;ma(103,a|0,47918);y=o;o=0;if(y&1){y=cc()|0;Nb(a|0);a=y;break}else Hc(a|0,240,66)}else{x=Wi(c[a>>2]|0)|0;w=Xi(c[a>>2]|0)|0;v=(d|0)/(x|0)|0;u=(e|0)/(w|0)|0;t=$(v,x)|0;s=$(u,w)|0;a=Sz(32)|0;o=0;mb(54,a|0,s|0,t|0);t=o;o=0;if(t&1){y=cc()|0;Uz(a);a=y;break}c[f>>2]=0;Ke(f,a);s=x+2|0;t=w+2|0;a=c[f>>2]|0;if((v|0)>0){d=(u|0)>0;e=(x|0)>0;f=(w|0)>0;p=0;do{g=$(p,x)|0;h=($(p,s)|0)+1|0;if(d){n=0;do{j=$(n,w)|0;k=($(n,t)|0)+1|0;if(e){q=0;do{l=h+q|0;m=q+g|0;if(f){r=0;do{if(eq(c[b>>2]|0,k+r|0,l)|0)Xd(a,r+j|0,m);r=r+1|0}while((r|0)<(w|0))}q=q+1|0}while((q|0)<(x|0))}n=n+1|0}while((n|0)<(u|0))}p=p+1|0}while((p|0)<(v|0))}i=y;return a|0}while(0);bc(a|0);return 0}function bi(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;x=d+12|0;Rd(b,Yi(c[x>>2]|0)|0);e=d+8|0;o=0;v=qa(122,c[e>>2]|0)|0;u=o;o=0;do if(!(u&1)?(o=0,w=qa(121,c[e>>2]|0)|0,u=o,o=0,!(u&1)):0){n=v+-2|0;p=(w&3|0)==0;q=v+4|0;s=w&7;r=(s|0)==0;s=(s|0)==4;t=b+8|0;u=d+16|0;i=0;l=0;m=0;j=0;k=0;f=0;g=4;while(1){e=(i|0)==0;do if(l|e&(g|0)==(v|0)^1){e=e&(g|0)==(n|0);if(!(p|e^1|m)){e=di(d,v,w)|0;a[(c[(c[t>>2]|0)+8>>2]|0)+f>>0]=e;i=i+2|0;e=l;h=1;f=f+1|0;g=g+-2|0;break}if(!(j|r&((i|0)==2&(g|0)==(q|0))^1)){e=ei(d,v,w)|0;a[(c[(c[t>>2]|0)+8>>2]|0)+f>>0]=e;i=i+2|0;e=l;h=m;j=1;f=f+1|0;g=g+-2|0;break}if(!(k|s&e^1)){e=fi(d,v,w)|0;a[(c[(c[t>>2]|0)+8>>2]|0)+f>>0]=e;i=i+2|0;e=l;h=m;k=1;f=f+1|0;g=g+-2|0;break}while(1){if((i|0)>-1&(g|0)<(v|0)?!(eq(c[u>>2]|0,i,g)|0):0){h=gi(d,g,i,v,w)|0;a[(c[(c[t>>2]|0)+8>>2]|0)+f>>0]=h;f=f+1|0}h=g+-2|0;e=i+2|0;if((e|0)<(w|0)&(h|0)>-1){i=e;g=h}else{e=i;break}}h=e+5|0;i=g+-1|0;while(1){if((h|0)<(w|0)&(i|0)>-1?!(eq(c[u>>2]|0,h,i)|0):0){g=gi(d,i,h,v,w)|0;a[(c[(c[t>>2]|0)+8>>2]|0)+f>>0]=g;f=f+1|0}g=i+2|0;e=h+-2|0;if((e|0)>-1&(g|0)<(v|0)){h=e;i=g}else{e=h;g=i;break}}i=e+-1|0;e=l;h=m;g=g+5|0}else{e=ci(d,v,w)|0;a[(c[(c[t>>2]|0)+8>>2]|0)+f>>0]=e;i=i+2|0;e=1;h=m;f=f+1|0;g=g+-2|0}while(0);if((i|0)<(w|0)|(g|0)<(v|0)){l=e;m=h}else break}o=0;e=qa(136,c[x>>2]|0)|0;x=o;o=0;if(!(x&1))if((f|0)==(e|0))return;else{x=Ob(8)|0;zq(x,49835);c[x>>2]=29736;o=0;mb(55,x|0,24,146);o=0;break}}while(0);x=cc()|0;Sd(b);bc(x|0)}function ci(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;e=b+-1|0;d=hi(a,e,0,b,c)|0;d=((hi(a,e,1,b,c)|0)&1|(d?2:0))<<1;e=(d|(hi(a,e,2,b,c)|0)&1)<<1;e=(e|(hi(a,0,c+-2|0,b,c)|0)&1)<<1;d=c+-1|0;e=(e|(hi(a,0,d,b,c)|0)&1)<<1;e=(e|(hi(a,1,d,b,c)|0)&1)<<1;e=(e|(hi(a,2,d,b,c)|0)&1)<<1;return e|(hi(a,3,d,b,c)|0)&1|0}function di(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;e=hi(a,b+-3|0,0,b,c)|0;e=((hi(a,b+-2|0,0,b,c)|0)&1|(e?2:0))<<1;e=(e|(hi(a,b+-1|0,0,b,c)|0)&1)<<1;e=(e|(hi(a,0,c+-4|0,b,c)|0)&1)<<1;e=(e|(hi(a,0,c+-3|0,b,c)|0)&1)<<1;e=(e|(hi(a,0,c+-2|0,b,c)|0)&1)<<1;d=c+-1|0;e=(e|(hi(a,0,d,b,c)|0)&1)<<1;return e|(hi(a,1,d,b,c)|0)&1|0}function ei(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,g=0;f=b+-1|0;g=hi(a,f,0,b,c)|0;d=c+-1|0;g=((hi(a,f,d,b,c)|0)&1|(g?2:0))<<1;f=c+-3|0;g=(g|(hi(a,0,f,b,c)|0)&1)<<1;e=c+-2|0;g=(g|(hi(a,0,e,b,c)|0)&1)<<1;g=(g|(hi(a,0,d,b,c)|0)&1)<<1;f=(g|(hi(a,1,f,b,c)|0)&1)<<1;e=(f|(hi(a,1,e,b,c)|0)&1)<<1;return e|(hi(a,1,d,b,c)|0)&1|0}function fi(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;e=hi(a,b+-3|0,0,b,c)|0;e=((hi(a,b+-2|0,0,b,c)|0)&1|(e?2:0))<<1;e=(e|(hi(a,b+-1|0,0,b,c)|0)&1)<<1;e=(e|(hi(a,0,c+-2|0,b,c)|0)&1)<<1;d=c+-1|0;e=(e|(hi(a,0,d,b,c)|0)&1)<<1;e=(e|(hi(a,1,d,b,c)|0)&1)<<1;e=(e|(hi(a,2,d,b,c)|0)&1)<<1;return e|(hi(a,3,d,b,c)|0)&1|0}function gi(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;h=b+-2|0;g=c+-2|0;i=hi(a,h,g,d,e)|0;f=c+-1|0;i=((hi(a,h,f,d,e)|0)&1|(i?2:0))<<1;h=b+-1|0;i=(i|(hi(a,h,g,d,e)|0)&1)<<1;i=(i|(hi(a,h,f,d,e)|0)&1)<<1;h=(i|(hi(a,h,c,d,e)|0)&1)<<1;g=(h|(hi(a,b,g,d,e)|0)&1)<<1;f=(g|(hi(a,b,f,d,e)|0)&1)<<1;return f|(hi(a,b,c,d,e)|0)&1|0}function hi(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;if((b|0)<0){b=e+b|0;d=d+4-(e+4&7)|0}if((d|0)<0){b=4-(f+4&7)+b|0;d=d+f|0}Xd(c[a+16>>2]|0,d,b);return eq(c[a+8>>2]|0,d,b)|0}function ii(a,b,d){a=a|0;b=b|0;d=d|0;c[a+4>>2]=0;c[a>>2]=30700;c[a+8>>2]=b;Pd(a+12|0,d);return}function ji(a){a=a|0;return c[a+8>>2]|0}function ki(a,b){a=a|0;b=b|0;Pd(a,b+12|0);return}
function qk(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0.0,j=0.0,k=0.0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0;P=i;i=i+304|0;J=P+288|0;K=P+284|0;W=P+272|0;b=P+132|0;V=P+120|0;U=P+108|0;f=P+300|0;T=P+96|0;g=P+92|0;S=P+136|0;B=P+88|0;C=P+76|0;D=P+64|0;R=P+52|0;Q=P+40|0;H=P+36|0;I=P+32|0;O=P+28|0;L=P+16|0;M=P+4|0;N=P;Wd(b,e);o=0;ma(145,W|0,b|0);A=o;o=0;if(A&1){W=cc()|0;bq(b);b=W}else{bq(b);m=c[(c[W>>2]|0)+8>>2]|0;a:do switch(m|0){case 103:{p=101;r=9;break}case 104:{p=100;r=9;break}case 105:{p=99;r=9;break}default:{b=Ob(8)|0;o=0;ka(308,b|0);V=o;o=0;if(V&1){V=cc()|0;Nb(b|0);b=V;break a}else{o=0;mb(55,b|0,320,76);o=0;b=cc()|0;break a}}}while(0);if((r|0)==9){c[V>>2]=0;c[V+4>>2]=0;c[V+8>>2]=0;a[f>>0]=0;o=0;mb(77,U|0,20,f|0);A=o;o=0;if(A&1)b=cc()|0;else{l=c[(c[W>>2]|0)+4>>2]|0;c[g>>2]=0;o=0;mb(75,T|0,6,g|0);A=o;o=0;if(A&1)b=cc()|0;else{f=S+56|0;A=S+4|0;c[S>>2]=29792;c[f>>2]=29812;o=0;ma(104,S+56|0,A|0);z=o;o=0;b:do if(z&1){b=cc()|0;r=23}else{c[S+128>>2]=0;c[S+132>>2]=-1;c[S>>2]=29832;c[S+56>>2]=29852;o=0;ka(307,A|0);z=o;o=0;do if(z&1)b=cc()|0;else{c[A>>2]=29868;b=S+36|0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;c[S+48>>2]=0;c[S+52>>2]=16;c[J>>2]=0;c[J+4>>2]=0;c[J+8>>2]=0;o=0;ma(105,A|0,J|0);z=o;o=0;if(z&1){S=cc()|0;IC(J);IC(b);nD(A);b=S;break}IC(J);w=T+4|0;x=D+8|0;y=D+1|0;z=D+4|0;q=m;n=0;v=0;m=1;g=0;c:while(1){Wd(B,e);o=0;u=ya(100,B|0,T|0,l|0)|0;t=o;o=0;if(t&1){r=27;break}bq(B);t=(u|0)!=106;m=m|t;if(t){g=g+1|0;q=($(u,g)|0)+q|0}f=c[T>>2]|0;s=(c[w>>2]|0)-f|0;r=s>>2;if((s|0)>0){s=0;b=l;do{b=(c[f+(s<<2)>>2]|0)+b|0;s=s+1|0}while((s|0)<(r|0))}else b=l;if((u+-103|0)>>>0<3){r=32;break}d:do switch(p|0){case 101:{if((u|0)<64){o=0;ya(101,V|0,1,u+32&255|0)|0;t=o;o=0;if(t&1){r=24;break c}else{p=101;f=0;r=0;break d}}if((u|0)<96){o=0;ya(101,V|0,1,u+192&255|0)|0;t=o;o=0;if(t&1){r=24;break c}else{p=101;f=0;r=0;break d}}m=m^t;switch(u|0){case 98:{p=100;f=0;r=1;break d}case 106:{p=101;f=1;r=0;break d}case 99:{p=u;f=0;r=0;break d}case 100:{p=u;f=0;r=0;break d}default:{p=101;f=0;r=0;break d}}}case 100:{if((u|0)<96){o=0;ya(101,V|0,1,u+32&255|0)|0;t=o;o=0;if(t&1){r=24;break c}else{p=100;f=0;r=0;break d}}m=m^t;switch(u|0){case 106:{p=100;f=1;r=0;break d}case 99:{p=u;f=0;r=0;break d}case 101:{p=u;f=0;r=0;break d}case 98:{p=101;f=0;r=1;break d}default:{p=100;f=0;r=0;break d}}}case 99:{if((u|0)>=100){m=m^t;switch(u|0){case 106:{p=99;f=1;r=0;break d}case 101:{p=u;f=0;r=0;break d}case 100:{p=u;f=0;r=0;break d}default:{p=99;f=0;r=0;break d}}}if((u|0)<10?(o=0,ya(101,V|0,1,48)|0,t=o,o=0,t&1):0){r=24;break c}o=0;ma(146,S+(c[(c[S>>2]|0)+-12>>2]|0)|0,0);t=o;o=0;if(t&1){r=24;break c}o=0;mb(57,C|0,61257,0);t=o;o=0;if(t&1){r=24;break c}o=0;ma(105,A|0,C|0);t=o;o=0;if(t&1){r=62;break c}IC(C);o=0;Wa(63,S|0,u|0)|0;t=o;o=0;if(t&1){r=24;break c}o=0;ma(106,D|0,A|0);t=o;o=0;if(t&1){r=24;break c}t=a[D>>0]|0;s=(t&1)==0;o=0;ya(90,V|0,(s?y:c[x>>2]|0)|0,(s?(t&255)>>>1:c[z>>2]|0)|0)|0;t=o;o=0;if(t&1){r=63;break c}IC(D);p=99;f=0;r=0;break}default:{f=0;r=0}}while(0);p=v?((p|0)==101?100:101):p;if(f){r=69;break}else{n=u;v=r;l=b}}e:do if((r|0)==24){b=cc()|0;r=26}else if((r|0)==27){b=cc()|0;bq(B)}else if((r|0)==32){b=Ob(8)|0;o=0;ka(308,b|0);R=o;o=0;if(R&1){R=cc()|0;Nb(b|0);b=R;break}else{o=0;mb(55,b|0,320,76);o=0;r=25;break}}else if((r|0)==62){b=cc()|0;IC(C)}else if((r|0)==63){b=cc()|0;IC(D)}else if((r|0)==69){f=b-l|0;o=0;b=Wa(88,c[e>>2]|0,b|0)|0;D=o;o=0;if((!(D&1)?(E=c[e>>2]|0,o=0,F=qa(120,E|0)|0,e=o,o=0,!(e&1)):0)?(G=((b-l|0)/2|0)+b|0,o=0,G=kb(57,E|0,b|0,((G|0)<(F|0)?G:F)|0,0)|0,e=o,o=0,!(e&1)):0){if(!G){r=Ob(8)|0;c[r+4>>2]=0;c[r>>2]=30552;o=0;mb(55,r|0,856,146);o=0;r=25;break}if(((q-($(n,g)|0)|0)%103|0|0)!=(n|0)){r=Ob(8)|0;Qf(r);o=0;mb(55,r|0,160,56);o=0;r=25;break}b=a[V>>0]|0;b=(b&1)==0?(b&255)>>>1:c[V+4>>2]|0;if(!b){r=Ob(8)|0;c[r+4>>2]=0;c[r>>2]=30552;o=0;mb(55,r|0,856,146);o=0;r=25;break}do if(!((b|0)<1|m^1))if((p|0)==99){o=0;ya(102,V|0,b+-2|0,b|0)|0;e=o;o=0;if(e&1){r=25;break e}else break}else{o=0;ya(102,V|0,b+-1|0,b|0)|0;e=o;o=0;if(e&1){r=25;break e}else break}while(0);b=c[W>>2]|0;j=+((c[b>>2]|0)+(c[b+4>>2]|0)|0)*.5;k=+(l|0)+ +(f|0)*.5;b=(c[U+4>>2]|0)-(c[U>>2]|0)|0;o=0;ma(87,R|0,b|0);e=o;o=0;if(e&1){r=25;break}f=(c[R+8>>2]|0)+8|0;if((b|0)>0){g=0;do{a[(c[f>>2]|0)+g>>0]=a[(c[U>>2]|0)+g>>0]|0;g=g+1|0}while((g|0)<(b|0))}o=0;ma(147,Q|0,2);e=o;o=0;if(e&1)b=cc()|0;else{b=(c[Q+8>>2]|0)+8|0;f=c[b>>2]|0;o=0;g=qa(111,16)|0;e=o;o=0;do if(e&1)r=96;else{h=+(d|0);o=0;wa(43,g|0,+j,+h);d=o;o=0;if(d&1){b=cc()|0;Uz(g);break}c[H>>2]=0;os(H,g);vq(f,c[H>>2]|0);ps(H);b=(c[b>>2]|0)+4|0;o=0;f=qa(111,16)|0;d=o;o=0;if(d&1){r=96;break}o=0;wa(43,f|0,+k,+h);d=o;o=0;if(d&1){b=cc()|0;Uz(f);break}c[I>>2]=0;os(I,f);vq(b,c[I>>2]|0);ps(I);o=0;f=qa(111,40)|0;I=o;o=0;if(I&1){r=96;break}o=0;b=qa(111,20)|0;I=o;o=0;do if(!(I&1)){o=0;ma(94,b|0,V|0);I=o;o=0;if(I&1){P=cc()|0;Uz(b);b=P;break}c[O>>2]=0;cq(O,b);Pd(L,R);oe(M,Q);c[N>>2]=5;o=0;c[J>>2]=c[N>>2];ia(45,f|0,O|0,L|0,M|0,J|0);N=o;o=0;if(N&1){b=cc()|0;pe(M);Sd(L);ne(O);break}else{c[K>>2]=0;Qe(K,f);pe(M);Sd(L);ne(O);pe(Q);Sd(R);Nq(S);br(T);He(U);IC(V);br(W);i=P;return c[K>>2]|0}}else b=cc()|0;while(0);Uz(f)}while(0);if((r|0)==96)b=cc()|0;pe(Q)}Sd(R)}else r=25}while(0);if((r|0)==25){b=cc()|0;r=26}Nq(S);break b}while(0);r=23}while(0);if((r|0)==23)iD(f);br(T)}He(U)}IC(V)}br(W)}bc(b|0);return 0}function rk(a){a=a|0;il(a);return}function sk(a){a=a|0;il(a);Uz(a);return}function tk(b,c,d){b=b|0;c=c|0;d=d|0;a[b+8>>0]=c&1;a[b+9>>0]=d&1;OC(b+12|0,20);cr(b+24|0,9);return}function uk(a){a=a|0;var b=0,d=0,e=0;cl(a);c[a>>2]=4824;b=a+12|0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;d=a+24|0;c[d>>2]=0;c[a+28>>2]=0;c[a+32>>2]=0;o=0;mb(78,a|0,0,0);e=o;o=0;if(e&1){e=cc()|0;br(d);IC(b);il(a);bc(e|0)}else return}function vk(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0.0,k=0.0,l=0.0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0;H=i;i=i+112|0;B=H+100|0;C=H+96|0;K=H+84|0;f=H+80|0;q=H+76|0;J=H+72|0;v=H+68|0;w=H+56|0;x=H+52|0;I=H+40|0;z=H+36|0;A=H+32|0;F=H+28|0;G=H+16|0;D=H+4|0;E=H;r=b+24|0;s=b+28|0;u=(c[s>>2]|0)-(c[r>>2]|0)>>2;cr(r,0);cr(r,u);u=b+12|0;if(!(a[u>>0]&1)){a[u+1>>0]=0;a[u>>0]=0}else{a[c[b+20>>2]>>0]=0;c[b+16>>2]=0}Wd(f,e);o=0;mb(79,K|0,f|0,r|0);y=o;o=0;if(y&1){K=cc()|0;bq(f);f=K}else{bq(f);o=0;f=Wa(89,c[e>>2]|0,c[(c[K>>2]|0)+4>>2]|0)|0;y=o;o=0;a:do if(!(y&1)?(o=0,t=qa(120,c[e>>2]|0)|0,y=o,o=0,!(y&1)):0){while(1){Wd(q,e);o=0;mb(76,q|0,f|0,r|0);y=o;o=0;if(y&1){y=14;break}bq(q);g=xk(r)|0;if((g|0)<0){y=9;break}o=0;p=qa(152,g|0)|0;y=o;o=0;if(y&1){y=11;break}o=0;ya(101,u|0,1,p|0)|0;y=o;o=0;if(y&1){y=11;break}h=c[r>>2]|0;y=(c[s>>2]|0)-h|0;m=y>>2;if((y|0)>0){n=0;g=f;do{g=(c[h+(n<<2)>>2]|0)+g|0;n=n+1|0}while((n|0)<(m|0))}else g=f;o=0;g=Wa(89,c[e>>2]|0,g|0)|0;y=o;o=0;if(y&1){y=11;break}if(p<<24>>24==42){q=f;y=21;break}else f=g}if((y|0)==9){J=Ob(8)|0;c[J+4>>2]=0;c[J>>2]=30552;o=0;mb(55,J|0,856,146);o=0;y=12;break}else if((y|0)==11){f=cc()|0;y=13;break}else if((y|0)==14){f=cc()|0;bq(q);break}else if((y|0)==21){f=a[u>>0]|0;if(!(f&1))f=(f&255)>>>1;else f=c[b+16>>2]|0;o=0;mb(80,u|0,f+-1|0,0);e=o;o=0;if(e&1){y=12;break}n=c[r>>2]|0;s=(c[s>>2]|0)-n|0;h=s>>2;if((s|0)>0){m=0;f=0;do{f=(c[n+(m<<2)>>2]|0)+f|0;m=m+1|0}while((m|0)<(h|0));e=f}else e=0;if((g|0)!=(t|0)?(g-q-e>>1|0)<(e|0):0){y=Ob(8)|0;c[y+4>>2]=0;c[y>>2]=30552;o=0;mb(55,y|0,856,146);o=0;y=12;break}do if(a[b+8>>0]|0){g=a[u>>0]|0;if(!(g&1))f=(g&255)>>>1;else f=c[b+16>>2]|0;p=f+-1|0;f=u+1|0;n=b+20|0;g=(g&1)==0;if((p|0)>0){m=0;h=0;do{if(g)g=f;else g=c[n>>2]|0;h=(WC(33384,a[g+m>>0]|0,0)|0)+h|0;m=m+1|0;g=(a[u>>0]&1)==0}while((m|0)<(p|0))}else h=0;if(!g)f=c[n>>2]|0;if((a[f+p>>0]|0)==(a[48499+((h|0)%43|0)>>0]|0)){o=0;mb(80,u|0,p|0,0);t=o;o=0;if(t&1){y=12;break a}else break}else{y=Ob(8)|0;Qf(y);o=0;mb(55,y|0,160,56);o=0;y=12;break a}}while(0);f=a[u>>0]|0;if(!(f&1))f=(f&255)>>>1;else f=c[b+16>>2]|0;if(!f){y=Ob(8)|0;c[y+4>>2]=0;c[y>>2]=30552;o=0;mb(55,y|0,856,146);o=0;y=12;break}c[J>>2]=0;cq(J,0);o=0;do if(!(a[b+9>>0]|0)){f=Sz(20)|0;w=o;o=0;if(!(w&1)){o=0;ma(94,f|0,u|0);w=o;o=0;if(w&1){I=cc()|0;Uz(f);f=I;break}else{c[x>>2]=0;cq(x,f);cq(J,c[x>>2]|0);ne(x);y=58;break}}else y=52}else{EC(w,u);x=o;o=0;if(!(x&1)){o=0;f=qa(153,w|0)|0;x=o;o=0;if(x&1){f=cc()|0;IC(w);break}else{c[v>>2]=f;cq(J,f);ne(v);IC(w);y=58;break}}else y=52}while(0);if((y|0)==58){x=c[K>>2]|0;k=+((c[x>>2]|0)+(c[x+4>>2]|0)|0)*.5;l=+(q|0)+ +(e|0)*.5;o=0;ma(147,I|0,2);x=o;o=0;if(x&1)y=52;else{f=(c[I+8>>2]|0)+8|0;g=c[f>>2]|0;o=0;h=qa(111,16)|0;x=o;o=0;do if(!(x&1)){j=+(d|0);o=0;wa(43,h|0,+k,+j);d=o;o=0;if(d&1){f=cc()|0;Uz(h);break}c[z>>2]=0;os(z,h);vq(g,c[z>>2]|0);ps(z);f=(c[f>>2]|0)+4|0;o=0;g=qa(111,16)|0;z=o;o=0;if(z&1){y=66;break}o=0;wa(43,g|0,+l,+j);z=o;o=0;if(z&1){f=cc()|0;Uz(g);break}c[A>>2]=0;os(A,g);vq(f,c[A>>2]|0);ps(A);o=0;f=qa(111,40)|0;A=o;o=0;if(A&1){y=66;break}c[F>>2]=0;cq(F,c[J>>2]|0);c[G+4>>2]=0;c[G>>2]=4084;c[G+8>>2]=0;oe(D,I);c[E>>2]=3;o=0;c[B>>2]=c[E>>2];ia(45,f|0,F|0,G|0,D|0,B|0);E=o;o=0;if(E&1){H=cc()|0;pe(D);Sd(G);ne(F);Uz(f);f=H;break}else{c[C>>2]=0;Qe(C,f);pe(D);Sd(G);ne(F);pe(I);ne(J);br(K);i=H;return c[C>>2]|0}}else y=66;while(0);if((y|0)==66)f=cc()|0;pe(I)}}if((y|0)==52)f=cc()|0;ne(J);break}}else y=12;while(0);if((y|0)==12){f=cc()|0;y=13}br(K)}bc(f|0);return 0}function wk(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;t=i;i=i+16|0;s=t;r=Wf(c[b>>2]|0)|0;g=ag(c[b>>2]|0,0)|0;f=c[d>>2]|0;e=(c[d+4>>2]|0)-f|0;n=e>>2;o=n+-1|0;p=n+-2|0;q=n+-2|0;a:do if((g|0)<(r|0)){m=(e|0)>8;j=f;k=0;f=g;l=0;e=g;while(1){g=c[b>>2]|0;if(l^(c[(c[(c[g+20>>2]|0)+8>>2]|0)+(f>>5<<2)>>2]&1<<(f&31)|0)!=0){g=j+(k<<2)|0;c[g>>2]=(c[g>>2]|0)+1;g=j;h=l}else{if((k|0)==(o|0)){if((xk(d)|0)==148){k=e-(f-e>>1)|0;if(Yf(g,(k|0)>0?k:0,e,0)|0)break;g=c[d>>2]|0}else g=j;j=c[g+4>>2]|0;h=(c[g>>2]|0)+e|0;if(m){e=2;do{c[g+(e+-2<<2)>>2]=c[g+(e<<2)>>2];e=e+1|0}while((e|0)<(n|0))}c[g+(p<<2)>>2]=0;c[g+(o<<2)>>2]=0;k=q;e=h+j|0}else{g=j;k=k+1|0}c[g+(k<<2)>>2]=1;h=l^1}f=f+1|0;if((f|0)>=(r|0))break a;else{j=g;l=h}}c[s>>2]=0;ms(a,2,s);a=c[a>>2]|0;c[a>>2]=e;c[a+4>>2]=f;i=t;return}while(0);t=Ob(8)|0;c[t+4>>2]=0;c[t>>2]=30552;Hc(t|0,856,146)}function xk(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;n=c[a>>2]|0;k=(c[a+4>>2]|0)-n|0;m=k>>2;h=m+-1|0;i=(k|0)>0;j=(k|0)>0;d=0;while(1){if(i){b=0;a=2147483647;do{g=c[n+(b<<2)>>2]|0;a=(g|0)<(a|0)&(g|0)>(d|0)?g:a;b=b+1|0}while((b|0)<(m|0));d=a}else d=2147483647;if(j){g=0;a=0;f=0;b=0;do{e=c[n+(g<<2)>>2]|0;if((e|0)>(d|0)){a=1<<h-g|a;f=e+f|0;b=b+1|0}g=g+1|0}while((g|0)<(m|0))}else{a=0;f=0;b=0}if((b|0)==3){g=d;l=9;break}if((b|0)<=3){a=-1;break}}a:do if((l|0)==9)if((k|0)>0){e=0;b=3;do{d=c[n+(e<<2)>>2]|0;if((d|0)>(g|0))if((d<<1|0)<(f|0))b=b+-1|0;else{a=-1;break a}e=e+1|0}while((b|0)>0&(e|0)<(m|0))}while(0);return a|0}function yk(b){b=b|0;var d=0;d=0;while(1){if((c[33396+(d<<2)>>2]|0)==(b|0)){b=3;break}d=d+1|0;if((d|0)>=44){b=5;break}}if((b|0)==3)return a[48499+d>>0]|0;else if((b|0)==5){b=Ob(8)|0;zq(b,61257);c[b>>2]=29736;Hc(b|0,24,146)}return 0}function zk(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;m=i;i=i+16|0;l=m+12|0;n=m;d=a[b>>0]|0;if(!(d&1))k=(d&255)>>>1;else k=c[b+4>>2]|0;c[n>>2]=0;c[n+4>>2]=0;c[n+8>>2]=0;h=b+1|0;j=b+8|0;a:do if((k|0)>0){d=0;b:while(1){f=(a[b>>0]&1)==0;if(f)e=h;else e=c[j>>2]|0;g=a[e+d>>0]|0;switch(g<<24>>24){case 47:case 37:case 36:case 43:{d=d+1|0;if(f)e=h;else e=c[j>>2]|0;f=a[e+d>>0]|0;c:do switch(g<<24>>24|0){case 43:{if((f+-65&255)>=26){e=16;break b}e=(f&255)+32&255;break}case 36:{if((f+-65&255)>=26){e=19;break b}e=(f&255)+192&255;break}case 37:{e=f<<24>>24;if((f+-65&255)<5){e=e+218&255;break c}if((f+-70&255)>=18){e=24;break b}e=e+245&255;break}case 47:if((f+-65&255)>=15)if(f<<24>>24==90){e=58;break c}else{e=28;break b}else{e=(f&255)+224&255;break c}default:e=0}while(0);o=0;ya(101,n|0,1,e|0)|0;g=o;o=0;if(g&1){e=11;break b}break}default:{o=0;ya(101,n|0,1,g|0)|0;g=o;o=0;if(g&1){e=11;break b}}}d=d+1|0;if((d|0)>=(k|0)){e=32;break a}}if((e|0)==11){d=cc()|0;e=13;break}else if((e|0)==16){m=Ob(8)|0;zq(m,61257);c[m>>2]=29736;o=0;mb(55,m|0,24,146);o=0;e=12;break}else if((e|0)==19){m=Ob(8)|0;zq(m,61257);c[m>>2]=29736;o=0;mb(55,m|0,24,146);o=0;e=12;break}else if((e|0)==24){m=Ob(8)|0;zq(m,61257);c[m>>2]=29736;o=0;mb(55,m|0,24,146);o=0;e=12;break}else if((e|0)==28){m=Ob(8)|0;zq(m,61257);c[m>>2]=29736;o=0;mb(55,m|0,24,146);o=0;e=12;break}}else e=32;while(0);do if((e|0)==32){o=0;d=qa(111,20)|0;b=o;o=0;if(!(b&1)){o=0;ma(94,d|0,n|0);b=o;o=0;if(b&1){m=cc()|0;Uz(d);d=m;break}else{c[l>>2]=0;cq(l,d);IC(n);i=m;return c[l>>2]|0}}else e=12}while(0);if((e|0)==12){d=cc()|0;e=13}IC(n);bc(d|0);return 0}function Ak(a){a=a|0;var b=0,d=0,e=0;cl(a);c[a>>2]=4852;b=a+8|0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;d=a+20|0;c[d>>2]=0;c[a+24>>2]=0;c[a+28>>2]=0;o=0;ma(114,b|0,20);e=o;o=0;if(!(e&1)?(o=0,ma(148,d|0,6),e=o,o=0,!(e&1)):0)return;e=cc()|0;br(d);IC(b);il(a);bc(e|0)}function Bk(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0.0,k=0.0,l=0.0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;G=i;i=i+80|0;A=G+76|0;B=G+72|0;x=G+64|0;f=G+60|0;q=G+56|0;I=G+52|0;H=G+40|0;y=G+36|0;z=G+32|0;C=G+28|0;D=G+16|0;E=G+4|0;F=G;Wd(f,e);o=0;mb(81,x|0,b|0,f|0);w=o;o=0;do if(!(w&1)){bq(f);v=c[x+4>>2]|0;f=ag(c[e>>2]|0,v)|0;t=Wf(c[e>>2]|0)|0;r=b+20|0;s=b+24|0;u=(c[s>>2]|0)-(c[r>>2]|0)>>2;cr(r,0);cr(r,u);u=b+8|0;if(!(a[u>>0]&1)){a[u+1>>0]=0;a[u>>0]=0}else{a[c[b+16>>2]>>0]=0;c[b+12>>2]=0}while(1){Wd(q,e);o=0;mb(76,q|0,f|0,r|0);w=o;o=0;if(w&1){w=9;break}bq(q);g=Dk(r)|0;if((g|0)<0){w=7;break}p=Ek(g)|0;NC(u,1,p)|0;h=c[r>>2]|0;w=(c[s>>2]|0)-h|0;m=w>>2;if((w|0)>0){n=0;g=f;do{g=(c[h+(n<<2)>>2]|0)+g|0;n=n+1|0}while((n|0)<(m|0))}else g=f;g=ag(c[e>>2]|0,g)|0;if(p<<24>>24==42){p=f;w=13;break}else f=g}if((w|0)==7){I=Ob(8)|0;c[I+4>>2]=0;c[I>>2]=30552;Hc(I|0,856,146)}else if((w|0)==9){f=cc()|0;bq(q);break}else if((w|0)==13){f=a[u>>0]|0;if(!(f&1))f=(f&255)>>>1;else f=c[b+12>>2]|0;MC(u,f+-1|0,0);n=c[r>>2]|0;s=(c[s>>2]|0)-n|0;h=s>>2;if((s|0)>0){m=0;f=0;do{f=(c[n+(m<<2)>>2]|0)+f|0;m=m+1|0}while((m|0)<(h|0));j=+(f|0)*.5}else j=0.0;if((g|0)!=(t|0)?(c[(c[(c[(c[e>>2]|0)+20>>2]|0)+8>>2]|0)+(g>>5<<2)>>2]&1<<(g&31)|0)!=0:0){f=a[u>>0]|0;if(!(f&1))f=(f&255)>>>1;else f=c[b+12>>2]|0;if(f>>>0<2){I=Ob(8)|0;c[I+4>>2]=0;c[I>>2]=30552;Hc(I|0,856,146)}Fk(u);f=a[u>>0]|0;if(!(f&1))f=(f&255)>>>1;else f=c[b+12>>2]|0;MC(u,f+-2|0,0);m=Gk(u)|0;c[I>>2]=m;k=+((c[x>>2]|0)+v|0)*.5;l=+(p|0)+j;o=0;ma(147,H|0,2);x=o;o=0;if(x&1)f=cc()|0;else{f=(c[H+8>>2]|0)+8|0;g=c[f>>2]|0;o=0;h=qa(111,16)|0;x=o;o=0;do if(!(x&1)){j=+(d|0);o=0;wa(43,h|0,+k,+j);d=o;o=0;if(d&1){f=cc()|0;Uz(h);break}c[y>>2]=0;os(y,h);vq(g,c[y>>2]|0);ps(y);f=(c[f>>2]|0)+4|0;o=0;g=qa(111,16)|0;y=o;o=0;if(!(y&1)){o=0;wa(43,g|0,+l,+j);y=o;o=0;if(y&1){f=cc()|0;Uz(g);break}c[z>>2]=0;os(z,g);vq(f,c[z>>2]|0);ps(z);o=0;f=qa(111,40)|0;z=o;o=0;if(!(z&1)){c[C>>2]=0;cq(C,m);c[D+4>>2]=0;c[D>>2]=4084;c[D+8>>2]=0;oe(E,H);c[F>>2]=4;o=0;c[A>>2]=c[F>>2];ia(45,f|0,C|0,D|0,E|0,A|0);F=o;o=0;if(F&1){G=cc()|0;pe(E);Sd(D);ne(C);Uz(f);f=G;break}else{c[B>>2]=0;Qe(B,f);pe(E);Sd(D);ne(C);pe(H);ne(I);i=G;return c[B>>2]|0}}else w=39}else w=39}else w=39;while(0);if((w|0)==39)f=cc()|0;pe(H)}ne(I);break}I=Ob(8)|0;c[I+4>>2]=0;c[I>>2]=30552;Hc(I|0,856,146)}}else{I=cc()|0;bq(f);f=I}while(0);bc(f|0);return 0}function Ck(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;r=Wf(c[d>>2]|0)|0;f=ag(c[d>>2]|0,0)|0;s=b+20|0;b=b+24|0;k=(c[b>>2]|0)-(c[s>>2]|0)>>2;cr(s,0);cr(s,k);k=c[s>>2]|0;b=(c[b>>2]|0)-k|0;l=b>>2;m=l+-1|0;n=k+4|0;o=k+(l+-2<<2)|0;p=k+(m<<2)|0;q=l+-2|0;a:do if((f|0)<(r|0)){j=(b|0)>8;g=0;e=f;i=0;b=f;while(1){if(i^(c[(c[(c[(c[d>>2]|0)+20>>2]|0)+8>>2]|0)+(e>>5<<2)>>2]&1<<(e&31)|0)!=0){f=k+(g<<2)|0;c[f>>2]=(c[f>>2]|0)+1;f=i}else{if((g|0)==(m|0)){h=Dk(s)|0;if((h|0)==(c[8393]|0))break;g=c[n>>2]|0;f=(c[k>>2]|0)+b|0;if(j){b=2;do{c[k+(b+-2<<2)>>2]=c[k+(b<<2)>>2];b=b+1|0}while((b|0)<(l|0))}c[o>>2]=0;c[p>>2]=0;h=q;b=f+g|0}else h=g+1|0;c[k+(h<<2)>>2]=1;g=h;f=i^1}e=e+1|0;if((e|0)>=(r|0))break a;else i=f}c[a>>2]=b;c[a+4>>2]=e;return}while(0);a=Ob(8)|0;c[a+4>>2]=0;c[a>>2]=30552;Hc(a|0,856,146)}function Dk(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0;h=c[a>>2]|0;d=(c[a+4>>2]|0)-h|0;g=d>>2;if((d|0)>0){b=0;a=0;do{a=(c[h+(b<<2)>>2]|0)+a|0;b=b+1|0}while((b|0)<(g|0));f=a}else f=0;a:do if((d|0)>0){e=0;a=0;do{b=((c[h+(e<<2)>>2]|0)*2304|0)/(f|0)|0;b=((b&128)>>>0>127&1)+(b>>8)|0;if((b+-1|0)>>>0>3){a=-1;break a}if(!(e&1)){if((b|0)>0){d=0;do{a=a<<1|1;d=d+1|0}while((d|0)<(b|0))}}else a=a<<b;e=e+1|0}while((e|0)<(g|0))}else a=0;while(0);return a|0}function Ek(b){b=b|0;var d=0;d=0;while(1){if((c[33576+(d<<2)>>2]|0)==(b|0)){b=3;break}d=d+1|0;if((d|0)>=48){b=5;break}}if((b|0)==3)return a[48544+d>>0]|0;else if((b|0)==5){b=Ob(8)|0;c[b+4>>2]=0;c[b>>2]=30552;Hc(b|0,856,146)}return 0}function Fk(b){b=b|0;var d=0;d=a[b>>0]|0;d=(d&1)==0?(d&255)>>>1:c[b+4>>2]|0;Hk(b,d+-2|0,20);Hk(b,d+-1|0,15);return}function Gk(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0;n=i;i=i+16|0;m=n+12|0;p=n;j=a[b>>0]|0;h=c[b+4>>2]|0;c[p>>2]=0;c[p+4>>2]=0;c[p+8>>2]=0;h=(j&1)==0?(j&255)>>>1:h;j=b+8|0;k=b+1|0;l=h+-1|0;a:do if((h|0)>0){d=0;b:while(1){f=(a[b>>0]&1)==0?k:c[j>>2]|0;e=a[f+d>>0]|0;g=e<<24>>24;if((e+-97&255)<4){if((d|0)>=(l|0)){f=4;break}d=d+1|0;f=a[f+d>>0]|0;c:do switch(g|0){case 100:{if((f+-65&255)>=26){f=13;break b}e=(f&255)+32&255;break}case 97:{if((f+-65&255)>=26){f=18;break b}e=(f&255)+192&255;break}case 98:{e=f<<24>>24;if((f+-65&255)<5){e=e+218&255;break c}if((f+-70&255)<5){e=e+245&255;break c}if((f+-75&255)<5){e=e+16&255;break c}if((f&-4)<<24>>24!=80)if((f+-84&255)<7){e=127;break c}else{f=30;break b}else{e=e+43&255;break c}}case 99:if((f+-65&255)>=15)if(f<<24>>24==90){e=58;break c}else{f=36;break b}else{e=(f&255)+224&255;break c}default:e=0}while(0);o=0;ya(101,p|0,1,e|0)|0;g=o;o=0;if(g&1){f=6;break}}else{o=0;ya(101,p|0,1,e|0)|0;g=o;o=0;if(g&1){f=6;break}}d=d+1|0;if((d|0)>=(h|0)){f=42;break a}}if((f|0)==4){d=Ob(8)|0;o=0;e=gb(42)|0;n=o;o=0;if(n&1){n=cc()|0;Nb(d|0);d=n;break}else{rs(d,e);c[d>>2]=4516;o=0;mb(55,d|0,320,76);o=0;f=7;break}}else if((f|0)==6){d=cc()|0;f=8;break}else if((f|0)==13){d=Ob(8)|0;o=0;e=gb(42)|0;n=o;o=0;if(n&1){n=cc()|0;Nb(d|0);d=n;break}else{rs(d,e);c[d>>2]=4516;o=0;mb(55,d|0,320,76);o=0;f=7;break}}else if((f|0)==18){d=Ob(8)|0;o=0;e=gb(42)|0;n=o;o=0;if(n&1){n=cc()|0;Nb(d|0);d=n;break}else{rs(d,e);c[d>>2]=4516;o=0;mb(55,d|0,320,76);o=0;f=7;break}}else if((f|0)==30){d=Ob(8)|0;o=0;e=gb(42)|0;n=o;o=0;if(n&1){n=cc()|0;Nb(d|0);d=n;break}else{rs(d,e);c[d>>2]=4516;o=0;mb(55,d|0,320,76);o=0;f=7;break}}else if((f|0)==36){d=Ob(8)|0;o=0;e=gb(42)|0;n=o;o=0;if(n&1){n=cc()|0;Nb(d|0);d=n;break}else{rs(d,e);c[d>>2]=4516;o=0;mb(55,d|0,320,76);o=0;f=7;break}}}else f=42;while(0);do if((f|0)==42){o=0;d=qa(111,20)|0;b=o;o=0;if(!(b&1)){o=0;ma(94,d|0,p|0);b=o;o=0;if(b&1){n=cc()|0;Uz(d);d=n;break}else{c[m>>2]=0;cq(m,d);IC(p);i=n;return c[m>>2]|0}}else f=7}while(0);if((f|0)==7){d=cc()|0;f=8}IC(p);bc(d|0);return 0}function Hk(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0;j=b+8|0;k=b+1|0;g=(a[b>>0]&1)==0?k:c[j>>2]|0;if((d|0)>0){h=d;f=0;i=1;while(1){l=h;h=h+-1|0;f=($(WC(33768,a[g+h>>0]|0,0)|0,i)|0)+f|0;g=(a[b>>0]&1)==0?k:c[j>>2]|0;if((l|0)<=1)break;else i=(i|0)>=(e|0)?1:i+1|0}f=(f|0)%47|0}else f=0;if((a[g+d>>0]|0)==(a[48544+f>>0]|0))return;else{l=Ob(8)|0;Qf(l);Hc(l|0,160,56)}}function Ik(a){a=a|0;var b=0,d=0;b=i;i=i+16|0;d=b;sl(a);c[a>>2]=4880;c[d>>2]=0;o=0;mb(75,a+20|0,4,d|0);d=o;o=0;if(d&1){d=cc()|0;Cl(a);bc(d|0)}else{i=b;return}}function Jk(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;u=i;i=i+32|0;l=u+16|0;n=u+8|0;m=u+4|0;s=u;t=a+20|0;f=c[t>>2]|0;r=a+24|0;a=c[r>>2]|0;if((a|0)!=(f|0)){do a=a+-4|0;while((a|0)!=(f|0));c[r>>2]=a}cr(t,4);q=Wf(c[b>>2]|0)|0;a=c[d+4>>2]|0;a:do if((a|0)<(q|0)){f=0;k=0;while(1){Wd(l,b);o=0;j=kb(58,l|0,t|0,a|0,5164)|0;h=o;o=0;if(h&1)break;bq(l);NC(e,1,((j|0)%10|0)+48&255)|0;d=c[t>>2]|0;h=(c[r>>2]|0)-d|0;g=h>>2;if((h|0)>0){h=0;do{a=(c[d+(h<<2)>>2]|0)+a|0;h=h+1|0}while((h|0)<(g|0))}if((j|0)>9)f=1<<5-k|f;k=k+1|0;if(!((k|0)<6&(a|0)<(q|0))){p=12;break a}}a=cc()|0;bq(l)}else{f=0;p=12}while(0);b:do if((p|0)==12){Kk(e,f);Wd(m,b);o=0;ia(49,n|0,m|0,a|0,1,5140);p=o;o=0;if(p&1){a=cc()|0;bq(m);break}bq(m);a=c[n+4>>2]|0;c:do if((a|0)<(q|0)){h=0;while(1){Wd(s,b);o=0;f=kb(58,s|0,t|0,a|0,5152)|0;p=o;o=0;if(p&1)break;bq(s);NC(e,1,f+48&255)|0;f=c[t>>2]|0;p=(c[r>>2]|0)-f|0;d=p>>2;if((p|0)>0){g=0;do{a=(c[f+(g<<2)>>2]|0)+a|0;g=g+1|0}while((g|0)<(d|0))}h=h+1|0;if(!((h|0)<6&(a|0)<(q|0)))break c}a=cc()|0;bq(s);break b}while(0);i=u;return a|0}while(0);bc(a|0);return 0}function Kk(a,b){a=a|0;b=b|0;var d=0;d=0;while(1){if((c[33780+(d<<2)>>2]|0)==(b|0)){b=3;break}d=d+1|0;if((d|0)>=10){b=5;break}}if((b|0)==3){UC(a,0,1,d+48&255)|0;return}else if((b|0)==5){a=Ob(8)|0;c[a+4>>2]=0;c[a>>2]=30552;Hc(a|0,856,146)}}function Lk(a){a=a|0;return 8}function Mk(a){a=a|0;var b=0,d=0;b=i;i=i+16|0;d=b;sl(a);c[a>>2]=4928;c[d>>2]=0;o=0;mb(75,a+20|0,4,d|0);d=o;o=0;if(d&1){d=cc()|0;Cl(a);bc(d|0)}else{i=b;return}}function Nk(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;s=i;i=i+32|0;j=s+16|0;l=s+8|0;k=s+4|0;p=s;q=a+20|0;r=c[q>>2]|0;c[r>>2]=0;c[r+4>>2]=0;c[r+8>>2]=0;c[r+12>>2]=0;r=Wf(c[b>>2]|0)|0;d=c[d+4>>2]|0;n=a+24|0;a:do if((d|0)<(r|0)){h=0;while(1){Wd(j,b);o=0;a=kb(58,j|0,q|0,d|0,5152)|0;g=o;o=0;if(g&1)break;bq(j);NC(e,1,a+48&255)|0;a=c[q>>2]|0;g=(c[n>>2]|0)-a|0;f=g>>2;if((g|0)>0){g=0;do{d=(c[a+(g<<2)>>2]|0)+d|0;g=g+1|0}while((g|0)<(f|0))}h=h+1|0;if(!((h|0)<4&(d|0)<(r|0))){m=7;break a}}d=cc()|0;bq(j)}else m=7;while(0);b:do if((m|0)==7){Wd(k,b);o=0;ia(49,l|0,k|0,d|0,1,5140);m=o;o=0;if(m&1){d=cc()|0;bq(k);break}bq(k);d=c[l+4>>2]|0;c:do if((d|0)<(r|0)){h=0;while(1){Wd(p,b);o=0;a=kb(58,p|0,q|0,d|0,5152)|0;m=o;o=0;if(m&1)break;bq(p);NC(e,1,a+48&255)|0;a=c[q>>2]|0;m=(c[n>>2]|0)-a|0;f=m>>2;if((m|0)>0){g=0;do{d=(c[a+(g<<2)>>2]|0)+d|0;g=g+1|0}while((g|0)<(f|0))}h=h+1|0;if(!((h|0)<4&(d|0)<(r|0)))break c}d=cc()|0;bq(p);break b}while(0);i=s;return d|0}while(0);bc(d|0);return 0}function Ok(a){a=a|0;return 7}function Pk(a){a=a|0;cl(a);c[a>>2]=4976;c[a+8>>2]=-1;return}function Qk(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0.0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;v=i;i=i+128|0;p=v+116|0;q=v+112|0;g=v+104|0;e=v+96|0;j=v+88|0;f=v+84|0;A=v+72|0;k=v+68|0;y=v+64|0;x=v+52|0;w=v+40|0;m=v+36|0;n=v+32|0;r=v+28|0;s=v+16|0;t=v+4|0;u=v;Wd(e,d);o=0;mb(82,g|0,a|0,e|0);l=o;o=0;do if(l&1){A=cc()|0;bq(e);e=A}else{bq(e);Wd(f,d);o=0;mb(83,j|0,a|0,f|0);l=o;o=0;if(l&1){e=cc()|0;bq(f);break}bq(f);c[A>>2]=0;c[A+4>>2]=0;c[A+8>>2]=0;Wd(k,d);a=c[g+4>>2]|0;l=c[j>>2]|0;o=0;ub(61,k|0,a|0,l|0,A|0);j=o;o=0;do if(j&1){e=cc()|0;bq(k)}else{bq(k);o=0;e=qa(111,20)|0;k=o;o=0;if(k&1){e=cc()|0;break}o=0;ma(94,e|0,A|0);k=o;o=0;if(k&1){z=cc()|0;Uz(e);e=z;break}c[y>>2]=0;cq(y,e);c[x+4>>2]=0;c[x>>2]=29772;e=x+8|0;c[e>>2]=0;Hq(x,c[8457]|0);j=c[y>>2]|0;o=0;g=qa(154,j|0)|0;k=o;o=0;do if(!(k&1)){f=c[e>>2]|0;e=c[f+8>>2]|0;f=(c[f+12>>2]|0)-e>>2;d=0;while(1){if((d|0)>=(f|0)){z=16;break}if((g|0)==(c[e+(d<<2)>>2]|0))break;else d=d+1|0}if((z|0)==16){e=Ob(8)|0;o=0;ka(308,e|0);w=o;o=0;if(w&1){w=cc()|0;Nb(e|0);e=w;break}else{o=0;mb(55,e|0,320,76);o=0;z=11;break}}o=0;ma(147,w|0,2);k=o;o=0;if(!(k&1)){e=(c[w+8>>2]|0)+8|0;f=c[e>>2]|0;o=0;d=qa(111,16)|0;k=o;o=0;do if(!(k&1)){h=+(b|0);o=0;wa(43,d|0,+(+(a|0)),+h);b=o;o=0;if(b&1){e=cc()|0;Uz(d);break}c[m>>2]=0;os(m,d);vq(f,c[m>>2]|0);ps(m);e=(c[e>>2]|0)+4|0;o=0;f=qa(111,16)|0;m=o;o=0;if(!(m&1)){o=0;wa(43,f|0,+(+(l|0)),+h);m=o;o=0;if(m&1){e=cc()|0;Uz(f);break}c[n>>2]=0;os(n,f);vq(e,c[n>>2]|0);ps(n);o=0;e=qa(111,40)|0;n=o;o=0;if(!(n&1)){c[r>>2]=0;cq(r,j);c[s+4>>2]=0;c[s>>2]=4084;c[s+8>>2]=0;oe(t,w);c[u>>2]=9;o=0;c[p>>2]=c[u>>2];ia(45,e|0,r|0,s|0,t|0,p|0);u=o;o=0;if(u&1){v=cc()|0;pe(t);Sd(s);ne(r);Uz(e);e=v;break}else{c[q>>2]=0;Qe(q,e);pe(t);Sd(s);ne(r);pe(w);nq(x);ne(y);IC(A);i=v;return c[q>>2]|0}}else z=27}else z=27}else z=27;while(0);if((z|0)==27)e=cc()|0;pe(w)}else z=11}else z=11;while(0);if((z|0)==11)e=cc()|0;nq(x);ne(y)}while(0);IC(A)}while(0);bc(e|0);return 0}function Rk(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;j=i;i=i+16|0;e=j+8|0;f=j+4|0;g=j;Wd(e,d);o=0;h=qa(155,e|0)|0;k=o;o=0;do if(!(k&1)){bq(e);Wd(f,d);o=0;ub(62,a|0,f|0,h|0,33832);k=o;o=0;if(k&1){e=cc()|0;bq(f);break}bq(f);k=c[a>>2]|0;c[b+8>>2]=(c[a+4>>2]|0)-k>>2;Wd(g,d);o=0;mb(84,b|0,g|0,k|0);k=o;o=0;if(k&1){e=cc()|0;bq(g);break}else{bq(g);i=j;return}}else{k=cc()|0;bq(e);e=k}while(0);bc(e|0)}function Sk(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;l=i;i=i+32|0;m=l+16|0;e=l+12|0;f=l+8|0;g=l+4|0;h=l;Wd(e,d);o=0;ma(149,m|0,e|0);n=o;o=0;if(n&1){n=cc()|0;bq(e);e=n}else{bq(e);Wd(f,d);o=0;e=qa(155,f|0)|0;n=o;o=0;do if(n&1){e=cc()|0;bq(f)}else{bq(f);Wd(g,d);o=0;ub(62,a|0,g|0,e|0,33844);n=o;o=0;if(n&1){e=cc()|0;bq(g);break}bq(g);Wd(h,d);f=c[a>>2]|0;o=0;mb(84,b|0,h|0,f|0);n=o;o=0;if(n&1){e=cc()|0;bq(h);break}bq(h);o=0;e=qa(120,c[d>>2]|0)|0;n=o;o=0;if(!(n&1)?(j=a+4|0,c[a>>2]=e-(c[j>>2]|0),o=0,k=qa(120,c[d>>2]|0)|0,n=o,o=0,!(n&1)):0){c[j>>2]=k-f;$f(m);i=l;return}e=cc()|0}while(0);$f(m)}bc(e|0)}function Tk(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;l=i;i=i+64|0;q=l+40|0;j=l+36|0;p=l+24|0;k=l+20|0;n=l+8|0;f=l+4|0;m=l;c[j>>2]=0;ms(q,10,j);c[k>>2]=0;o=0;mb(75,p|0,5,k|0);k=o;o=0;if(k&1)b=cc()|0;else{c[f>>2]=0;o=0;mb(75,n|0,5,f|0);k=o;o=0;a:do if(k&1)b=cc()|0;else{k=q+4|0;b:do if((b|0)<(d|0)){while(1){Wd(m,a);o=0;mb(76,m|0,b|0,q|0);j=o;o=0;if(j&1){f=11;break}bq(m);f=c[q>>2]|0;g=c[p>>2]|0;h=c[n>>2]|0;j=0;do{r=j<<1;c[g+(j<<2)>>2]=c[f+(r<<2)>>2];c[h+(j<<2)>>2]=c[f+((r|1)<<2)>>2];j=j+1|0}while((j|0)!=5);o=0;f=qa(156,p|0)|0;r=o;o=0;if(r&1){f=10;break}o=0;ya(101,e|0,1,f+48&255|0)|0;r=o;o=0;if(r&1){f=10;break}o=0;f=qa(156,n|0)|0;r=o;o=0;if(r&1){f=10;break}o=0;ya(101,e|0,1,f+48&255|0)|0;r=o;o=0;if(r&1){f=10;break}g=c[q>>2]|0;r=(c[k>>2]|0)-g|0;h=r>>2;if((r|0)>0){f=0;do{b=(c[g+(f<<2)>>2]|0)+b|0;f=f+1|0}while((f|0)<(h|0))}if((b|0)>=(d|0))break b}if((f|0)==10)b=cc()|0;else if((f|0)==11){b=cc()|0;bq(m)}br(n);break a}while(0);br(n);br(p);br(q);i=l;return}while(0);br(p)}br(q);bc(b|0)}function Uk(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;b=-1;f=107;g=0;while(1){d=gl(a,33856+(g*20|0)|0,199)|0;e=(d|0)<(f|0);b=e?g:b;g=g+1|0;if((g|0)==10)break;else f=e?d:f}if((b|0)>-1)return b|0;else{g=Ob(8)|0;c[g+4>>2]=0;c[g>>2]=30552;Hc(g|0,856,146)}return 0}function Vk(a){a=a|0;var b=0;b=Wf(c[a>>2]|0)|0;a=ag(c[a>>2]|0,0)|0;if((a|0)==(b|0)){b=Ob(8)|0;c[b+4>>2]=0;c[b>>2]=30552;Hc(b|0,856,146)}else return a|0;return 0}function Wk(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;t=i;i=i+16|0;u=t;f=(c[e+4>>2]|0)-(c[e>>2]|0)|0;r=f>>2;ss(u,r);o=0;s=qa(120,c[b>>2]|0)|0;q=o;o=0;a:do if(q&1)d=7;else{n=r+-1|0;p=r+-2|0;q=r+-2|0;b:do if((s|0)>(d|0)){m=(f|0)>8;j=0;h=0;g=d;f=d;while(1){if(h^(c[(c[(c[(c[b>>2]|0)+20>>2]|0)+8>>2]|0)+(f>>5<<2)>>2]&1<<(f&31)|0)!=0){d=(c[u>>2]|0)+(j<<2)|0;c[d>>2]=(c[d>>2]|0)+1;d=j}else{if((j|0)==(n|0)){o=0;d=ya(99,u|0,c[e>>2]|0,199)|0;l=o;o=0;if(l&1){d=6;break}if((d|0)<107){d=12;break}d=c[u>>2]|0;l=c[d+4>>2]|0;j=(c[d>>2]|0)+g|0;if(m){g=2;do{c[d+(g+-2<<2)>>2]=c[d+(g<<2)>>2];g=g+1|0}while((g|0)<(r|0))}c[d+(p<<2)>>2]=0;c[d+(n<<2)>>2]=0;k=q;g=j+l|0}else{d=c[u>>2]|0;k=j+1|0}c[d+(k<<2)>>2]=1;d=k;h=h^1}f=f+1|0;if((f|0)>=(s|0))break b;else j=d}if((d|0)==6){f=cc()|0;break a}else if((d|0)==12){c[a>>2]=g;c[a+4>>2]=f;br(u);i=t;return}}while(0);d=Ob(8)|0;c[d+4>>2]=0;c[d>>2]=30552;o=0;mb(55,d|0,856,146);o=0;d=7}while(0);if((d|0)==7)f=cc()|0;br(u);bc(f|0)}function Xk(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;f=c[a+8>>2]|0;a=f*10|0;a:do if((f|0)>0&(d|0)>0){f=c[(c[(c[b>>2]|0)+20>>2]|0)+8>>2]|0;e=d;d=a;while(1){b=e;e=e+-1|0;if(c[f+(e>>5<<2)>>2]&1<<(e&31)){a=d;break a}a=d+-1|0;if(!((d|0)>1&(b|0)>1))break;else d=a}}while(0);if(!a)return;else{f=Ob(8)|0;c[f+4>>2]=0;c[f>>2]=30552;Hc(f|0,856,146)}}function Yk(a){a=a|0;il(a);return}function Zk(a){a=a|0;il(a);Uz(a);return}function _k(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0;E=i;i=i+112|0;s=E+108|0;e=E+104|0;d=E+100|0;f=E+96|0;g=E+92|0;h=E+88|0;j=E+80|0;k=E+72|0;l=E+68|0;m=E+64|0;p=E+60|0;n=E+56|0;q=E+52|0;r=E+48|0;t=E+44|0;u=E+40|0;v=E+36|0;w=E+32|0;x=E+24|0;y=E+16|0;z=E+12|0;A=E+8|0;B=E+4|0;C=E;cl(a);c[a>>2]=5004;F=a+8|0;c[F>>2]=0;D=a+12|0;c[D>>2]=0;c[a+16>>2]=0;c[e>>2]=8;o=0;c[s>>2]=c[e>>2];e=Wa(90,b|0,s|0)|0;H=o;o=0;a:do if(!(H&1)){if(!e){c[d>>2]=7;o=0;c[s>>2]=c[d>>2];d=Wa(90,b|0,s|0)|0;H=o;o=0;if(H&1){G=15;break}if(!d){c[f>>2]=15;o=0;c[s>>2]=c[f>>2];d=Wa(90,b|0,s|0)|0;H=o;o=0;if(H&1){G=15;break}if(!d){c[g>>2]=16;o=0;c[s>>2]=c[g>>2];d=Wa(90,b|0,s|0)|0;H=o;o=0;if(H&1){G=15;break}if(d)G=9}else G=9}else G=9}else G=9;if((G|0)==9){o=0;d=qa(111,20)|0;H=o;o=0;if(H&1){G=15;break}$d(j,b);o=0;ma(150,d|0,j|0);H=o;o=0;if(H&1){H=cc()|0;ze(j+4|0);Uz(d);d=H;break}c[h>>2]=0;ts(h,d);d=c[D>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(151,F|0,h|0);H=o;o=0;if(H&1){d=cc()|0;vs(h);ze(j+4|0);break}}else{c[d>>2]=0;ts(d,c[h>>2]|0);c[D>>2]=(c[D>>2]|0)+4}vs(h);ze(j+4|0)}c[k>>2]=3;o=0;c[s>>2]=c[k>>2];d=Wa(90,b|0,s|0)|0;H=o;o=0;if(!(H&1)){if(d){o=0;d=qa(111,36)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(315,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[l>>2]=0;ts(l,d);d=c[D>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(151,F|0,l|0);H=o;o=0;if(H&1){d=cc()|0;vs(l);break}}else{c[d>>2]=0;ts(d,c[l>>2]|0);c[D>>2]=(c[D>>2]|0)+4}vs(l)}c[m>>2]=4;o=0;c[s>>2]=c[m>>2];d=Wa(90,b|0,s|0)|0;H=o;o=0;if(!(H&1)){if(d){o=0;d=qa(111,32)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(316,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[p>>2]=0;ts(p,d);d=c[D>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(151,F|0,p|0);H=o;o=0;if(H&1){d=cc()|0;vs(p);break}}else{c[d>>2]=0;ts(d,c[p>>2]|0);c[D>>2]=(c[D>>2]|0)+4}vs(p)}c[n>>2]=5;o=0;c[s>>2]=c[n>>2];d=Wa(90,b|0,s|0)|0;H=o;o=0;if(!(H&1)){if(d){o=0;d=qa(111,8)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(317,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[q>>2]=0;ts(q,d);d=c[D>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(151,F|0,q|0);H=o;o=0;if(H&1){d=cc()|0;vs(q);break}}else{c[d>>2]=0;ts(d,c[q>>2]|0);c[D>>2]=(c[D>>2]|0)+4}vs(q)}c[r>>2]=9;o=0;c[s>>2]=c[r>>2];d=Wa(90,b|0,s|0)|0;H=o;o=0;if(!(H&1)){if(d){o=0;d=qa(111,12)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(318,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[t>>2]=0;ts(t,d);d=c[D>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(151,F|0,t|0);H=o;o=0;if(H&1){d=cc()|0;vs(t);break}}else{c[d>>2]=0;ts(d,c[t>>2]|0);c[D>>2]=(c[D>>2]|0)+4}vs(t)}c[u>>2]=2;o=0;c[s>>2]=c[u>>2];d=Wa(90,b|0,s|0)|0;H=o;o=0;if(!(H&1)){if(d){o=0;d=qa(111,36)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(319,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[v>>2]=0;ts(v,d);d=c[D>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(151,F|0,v|0);H=o;o=0;if(H&1){d=cc()|0;vs(v);break}}else{c[d>>2]=0;ts(d,c[v>>2]|0);c[D>>2]=(c[D>>2]|0)+4}vs(v)}if((c[D>>2]|0)==(c[F>>2]|0)){o=0;d=qa(111,20)|0;H=o;o=0;if(H&1){G=15;break}$d(x,b);o=0;ma(150,d|0,x|0);H=o;o=0;if(H&1){H=cc()|0;ze(x+4|0);Uz(d);d=H;break}c[w>>2]=0;ts(w,d);d=c[D>>2]|0;e=a+16|0;if(d>>>0>=(c[e>>2]|0)>>>0){o=0;ma(151,F|0,w|0);H=o;o=0;if(H&1){d=cc()|0;vs(w);ze(x+4|0);break}}else{c[d>>2]=0;ts(d,c[w>>2]|0);c[D>>2]=(c[D>>2]|0)+4}vs(w);ze(x+4|0);o=0;d=qa(111,36)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(315,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[y>>2]=0;ts(y,d);d=c[D>>2]|0;do if(d>>>0<(c[e>>2]|0)>>>0){c[d>>2]=0;ts(d,c[y>>2]|0);c[D>>2]=(c[D>>2]|0)+4}else{o=0;ma(151,F|0,y|0);H=o;o=0;if(!(H&1))break;d=cc()|0;vs(y);break a}while(0);vs(y);o=0;d=qa(111,36)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(319,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[z>>2]=0;ts(z,d);d=c[D>>2]|0;do if(d>>>0<(c[e>>2]|0)>>>0){c[d>>2]=0;ts(d,c[z>>2]|0);c[D>>2]=(c[D>>2]|0)+4}else{o=0;ma(151,F|0,z|0);H=o;o=0;if(!(H&1))break;d=cc()|0;vs(z);break a}while(0);vs(z);o=0;d=qa(111,32)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(316,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[A>>2]=0;ts(A,d);d=c[D>>2]|0;do if(d>>>0<(c[e>>2]|0)>>>0){c[d>>2]=0;ts(d,c[A>>2]|0);c[D>>2]=(c[D>>2]|0)+4}else{o=0;ma(151,F|0,A|0);H=o;o=0;if(!(H&1))break;d=cc()|0;vs(A);break a}while(0);vs(A);o=0;d=qa(111,8)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(317,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[B>>2]=0;ts(B,d);d=c[D>>2]|0;do if(d>>>0<(c[e>>2]|0)>>>0){c[d>>2]=0;ts(d,c[B>>2]|0);c[D>>2]=(c[D>>2]|0)+4}else{o=0;ma(151,F|0,B|0);H=o;o=0;if(!(H&1))break;d=cc()|0;vs(B);break a}while(0);vs(B);o=0;d=qa(111,12)|0;H=o;o=0;if(H&1){G=15;break}o=0;ka(318,d|0);H=o;o=0;if(H&1){H=cc()|0;Uz(d);d=H;break}c[C>>2]=0;ts(C,d);d=c[D>>2]|0;do if(d>>>0<(c[e>>2]|0)>>>0){c[d>>2]=0;ts(d,c[C>>2]|0);c[D>>2]=(c[D>>2]|0)+4}else{o=0;ma(151,F|0,C|0);H=o;o=0;if(!(H&1))break;d=cc()|0;vs(C);break a}while(0);vs(C)}i=E;return}else G=15}else G=15}else G=15}else G=15}else G=15}else G=15;while(0);if((G|0)==15)d=cc()|0;ws(F);il(a);bc(d|0)}function $k(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;j=i;i=i+16|0;h=j;g=a+8|0;f=(c[a+12>>2]|0)-(c[g>>2]|0)|0;e=f>>2;a:do if((f|0)>0){f=0;while(1){a=c[(c[g>>2]|0)+(f<<2)>>2]|0;k=c[(c[a>>2]|0)+16>>2]|0;Wd(h,d);o=0;a=ya(k|0,a|0,b|0,h|0)|0;k=o;o=0;if(!(k&1)){e=3;break}a=cc(24)|0;k=D;bq(h);if((k|0)!=(Xb(24)|0)){e=7;break}fc(a|0)|0;$b();f=f+1|0;if((f|0)>=(e|0))break a}if((e|0)==3){bq(h);i=j;return a|0}else if((e|0)==7)bc(a|0)}while(0);k=Ob(8)|0;c[k+4>>2]=0;c[k>>2]=30552;Hc(k|0,856,146);return 0}function al(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;s=i;i=i+48|0;j=s+44|0;d=s+40|0;f=s+36|0;e=s+32|0;g=s+28|0;h=s+24|0;k=s+20|0;l=s+16|0;m=s+12|0;n=s+8|0;p=s+4|0;q=s;cl(a);c[a>>2]=5032;t=a+8|0;c[t>>2]=0;r=a+12|0;c[r>>2]=0;c[a+16>>2]=0;c[d>>2]=8;o=0;c[j>>2]=c[d>>2];d=Wa(90,b|0,j|0)|0;v=o;o=0;do if(!(v&1)){if(!d){c[e>>2]=15;o=0;c[j>>2]=c[e>>2];d=Wa(90,b|0,j|0)|0;v=o;o=0;if(v&1){u=9;break}if(d){o=0;d=qa(111,52)|0;v=o;o=0;if(v&1){u=9;break}o=0;ka(321,d|0);v=o;o=0;if(v&1){v=cc()|0;Uz(d);d=v;break}c[g>>2]=0;xs(g,d);d=c[r>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(152,t|0,g|0);v=o;o=0;if(v&1){d=cc()|0;zs(g);break}}else{c[d>>2]=0;xs(d,c[g>>2]|0);c[r>>2]=(c[r>>2]|0)+4}zs(g)}}else{o=0;d=qa(111,32)|0;v=o;o=0;if(v&1){u=9;break}o=0;ka(320,d|0);v=o;o=0;if(v&1){v=cc()|0;Uz(d);d=v;break}c[f>>2]=0;xs(f,d);d=c[r>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(152,t|0,f|0);v=o;o=0;if(v&1){d=cc()|0;zs(f);break}}else{c[d>>2]=0;xs(d,c[f>>2]|0);c[r>>2]=(c[r>>2]|0)+4}zs(f)}c[h>>2]=7;o=0;c[j>>2]=c[h>>2];d=Wa(90,b|0,j|0)|0;v=o;o=0;if(!(v&1)){if(d){o=0;d=qa(111,32)|0;v=o;o=0;if(v&1){u=9;break}o=0;ka(322,d|0);v=o;o=0;if(v&1){v=cc()|0;Uz(d);d=v;break}c[k>>2]=0;xs(k,d);d=c[r>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(152,t|0,k|0);v=o;o=0;if(v&1){d=cc()|0;zs(k);break}}else{c[d>>2]=0;xs(d,c[k>>2]|0);c[r>>2]=(c[r>>2]|0)+4}zs(k)}c[l>>2]=16;o=0;c[j>>2]=c[l>>2];d=Wa(90,b|0,j|0)|0;v=o;o=0;if(!(v&1)){if(d){o=0;d=qa(111,32)|0;v=o;o=0;if(v&1){u=9;break}o=0;ka(323,d|0);v=o;o=0;if(v&1){v=cc()|0;Uz(d);d=v;break}c[m>>2]=0;xs(m,d);d=c[r>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(152,t|0,m|0);v=o;o=0;if(v&1){d=cc()|0;zs(m);break}}else{c[d>>2]=0;xs(d,c[m>>2]|0);c[r>>2]=(c[r>>2]|0)+4}zs(m)}if((c[r>>2]|0)==(c[t>>2]|0)){o=0;d=qa(111,32)|0;v=o;o=0;if(v&1){u=9;break}o=0;ka(320,d|0);v=o;o=0;if(v&1){v=cc()|0;Uz(d);d=v;break}c[n>>2]=0;xs(n,d);d=c[r>>2]|0;e=a+16|0;if(d>>>0>=(c[e>>2]|0)>>>0){o=0;ma(152,t|0,n|0);v=o;o=0;if(v&1){d=cc()|0;zs(n);break}}else{c[d>>2]=0;xs(d,c[n>>2]|0);c[r>>2]=(c[r>>2]|0)+4}zs(n);o=0;d=qa(111,32)|0;v=o;o=0;if(v&1){u=9;break}o=0;ka(322,d|0);v=o;o=0;if(v&1){v=cc()|0;Uz(d);d=v;break}c[p>>2]=0;xs(p,d);d=c[r>>2]|0;if(d>>>0>=(c[e>>2]|0)>>>0){o=0;ma(152,t|0,p|0);v=o;o=0;if(v&1){d=cc()|0;zs(p);break}}else{c[d>>2]=0;xs(d,c[p>>2]|0);c[r>>2]=(c[r>>2]|0)+4}zs(p);o=0;d=qa(111,32)|0;v=o;o=0;if(v&1){u=9;break}o=0;ka(323,d|0);v=o;o=0;if(v&1){v=cc()|0;Uz(d);d=v;break}c[q>>2]=0;xs(q,d);d=c[r>>2]|0;if(d>>>0>=(c[e>>2]|0)>>>0){o=0;ma(152,t|0,q|0);v=o;o=0;if(v&1){d=cc()|0;zs(q);break}}else{c[d>>2]=0;xs(d,c[q>>2]|0);c[r>>2]=(c[r>>2]|0)+4}zs(q)}i=s;return}else u=9}else u=9}else u=9;while(0);if((u|0)==9)d=cc()|0;As(t);il(a);bc(d|0)}function bl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0;s=i;i=i+80|0;m=s+76|0;n=s+72|0;h=s+64|0;e=s+56|0;v=s+52|0;w=s+48|0;j=s+44|0;k=s+40|0;l=s+36|0;t=s+32|0;u=s+28|0;r=s+16|0;p=s+4|0;q=s;Wd(e,d);o=0;ma(153,h|0,e|0);g=o;o=0;a:do if(g&1){x=cc()|0;bq(e);e=x}else{bq(e);g=a+8|0;f=(c[a+12>>2]|0)-(c[g>>2]|0)|0;a=f>>2;b:do if((f|0)>0){f=0;while(1){Bs(v,(c[g>>2]|0)+(f<<2)|0);c[w>>2]=0;Qe(w,0);e=c[v>>2]|0;y=c[(c[e>>2]|0)+28>>2]|0;Wd(k,d);o=0;e=kb(y|0,e|0,b|0,k|0,h|0)|0;y=o;o=0;if(!(y&1)){x=4;break}e=cc(24)|0;y=D;bq(k);if((y|0)!=(Xb(24)|0))break;fc(e|0)|0;o=0;ob(44);y=o;o=0;if(y&1){x=8;break}be(w);zs(v);f=f+1|0;if((f|0)>=(a|0))break b}c:do if((x|0)==4){c[j>>2]=e;Qe(w,e);be(j);bq(k);a=c[w>>2]|0;o=0;e=qa(144,a|0)|0;y=o;o=0;d:do if(!(y&1)){e:do if((e|0)==8){o=0;e=qa(112,a|0)|0;y=o;o=0;if(y&1)break d;c[l>>2]=e;o=0;e=Wa(91,e|0,0)|0;y=o;o=0;if(y&1){e=cc()|0;ne(l);break c}ne(l);if(e<<24>>24==48){o=0;f=qa(111,40)|0;y=o;o=0;if(y&1)break d;o=0;e=qa(112,a|0)|0;y=o;o=0;if(y&1)e=cc()|0;else{c[u>>2]=e;o=0;e=Wa(92,e|0,1)|0;y=o;o=0;if(y&1)e=cc()|0;else{c[t>>2]=e;o=0;ma(129,r|0,a|0);y=o;o=0;if(y&1)e=cc()|0;else{o=0;e=qa(114,a|0)|0;y=o;o=0;do if(!(y&1)){oe(p,e);c[q>>2]=15;o=0;c[m>>2]=c[q>>2];ia(45,f|0,t|0,r|0,p|0,m|0);y=o;o=0;if(y&1){e=cc()|0;pe(p);break}else{c[n>>2]=0;Qe(n,f);pe(p);Sd(r);ne(t);ne(u);be(w);zs(v);e=n;break e}}else e=cc()|0;while(0);Sd(r)}ne(t)}ne(u)}Uz(f);break c}else x=32}else x=32;while(0);if((x|0)==32){c[n>>2]=0;Qe(n,a);be(w);zs(v);e=n}i=s;return c[e>>2]|0}while(0);e=cc()|0;x=10}else if((x|0)==8){e=cc()|0;x=10}while(0);be(w);zs(v);break a}while(0);y=Ob(8)|0;c[y+4>>2]=0;c[y>>2]=30552;Hc(y|0,856,146)}while(0);bc(e|0);return 0}function cl(a){a=a|0;c[a+4>>2]=0;c[a>>2]=5060;return}function dl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0.0,j=0.0,k=0.0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0;p=i;i=i+32|0;q=p+28|0;f=p+24|0;g=p+16|0;r=p+12|0;l=p+8|0;m=p;_d(f,b);$d(g,d);o=0;e=ya(103,a|0,f|0,g|0)|0;t=o;o=0;a:do if(t&1){e=cc(856)|0;t=D;ze(g+4|0);ce(f);if((t|0)==(Xb(856)|0)){f=fc(e|0)|0;o=0;e=qa(157,d|0)|0;t=o;o=0;do if(t&1)n=20;else{if(e){o=0;e=qa(158,c[b>>2]|0)|0;t=o;o=0;if(t&1){n=20;break}if(e){o=0;g=qa(159,c[b>>2]|0)|0;t=o;o=0;if(t&1){n=20;break}c[r>>2]=g;c[l>>2]=0;Ne(l,g);$d(m,d);o=0;e=ya(103,a|0,l|0,m|0)|0;t=o;o=0;if(t&1){e=cc()|0;ze(m+4|0);ce(l)}else{c[q>>2]=e;ze(m+4|0);ce(l);o=0;f=qa(114,e|0)|0;t=o;o=0;b:do if(t&1)n=23;else{d=f+8|0;t=c[d>>2]|0;c:do if((t|0)!=0?(c[t+12>>2]|0)!=(c[t+8>>2]|0):0){o=0;f=qa(143,g|0)|0;t=o;o=0;if(t&1){n=23;break b}k=+(f|0);t=c[d>>2]|0;f=c[t+8>>2]|0;if(((c[t+12>>2]|0)-f|0)>0){b=0;while(1){o=0;g=qa(111,16)|0;t=o;o=0;if(t&1){n=22;break}t=c[(c[(c[d>>2]|0)+8>>2]|0)+(b<<2)>>2]|0;o=0;h=+Ka(c[(c[t>>2]|0)+12>>2]|0,t|0);t=o;o=0;if(t&1){e=g;n=25;break}t=c[(c[(c[d>>2]|0)+8>>2]|0)+(b<<2)>>2]|0;o=0;j=+Ka(c[(c[t>>2]|0)+8>>2]|0,t|0);t=o;o=0;if(t&1){e=g;n=25;break}o=0;wa(43,g|0,+(k-h+-1.0),+j);t=o;o=0;if(t&1){e=g;n=25;break}vq(f+(b<<2)|0,g);b=b+1|0;t=c[d>>2]|0;f=c[t+8>>2]|0;if((b|0)>=((c[t+12>>2]|0)-f>>2|0))break c}if((n|0)==22){e=cc()|0;n=24;break b}else if((n|0)==25){t=cc()|0;Uz(e);e=t;break b}}}while(0);ce(r);$b();break a}while(0);if((n|0)==23){e=cc()|0;n=24}be(q)}ce(r);break}}n=Ob(8)|0;rs(n,f);c[n>>2]=30552;o=0;mb(55,n|0,856,146);o=0;n=20}while(0);if((n|0)==20)e=cc()|0;o=0;ob(44);t=o;o=0;if(t&1){t=cc(0)|0;oq(t)}else s=e}else s=e;bc(s|0)}else{c[q>>2]=e;ze(g+4|0);ce(f)}while(0);i=p;return e|0}function el(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0.0,h=0.0,j=0,k=0,l=0,m=0,n=0.0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0,F=0,G=0;C=i;i=i+48|0;u=C+36|0;E=C+32|0;v=C+28|0;w=C+24|0;x=C+20|0;B=C+8|0;y=C+4|0;A=C;f=Lf(c[b>>2]|0)|0;z=Mf(c[b>>2]|0)|0;e=Sz(24)|0;o=0;ma(90,e|0,f|0);t=o;o=0;if(t&1){F=cc()|0;Uz(e);e=F}else{c[E>>2]=0;Je(E,e);t=z>>1;o=0;e=qa(157,d|0)|0;s=o;o=0;a:do if(s&1)F=7;else{s=z>>(e?8:5);s=(s|0)>1?s:1;q=e?z:15;r=B+8|0;n=+(f|0);b:do if((q|0)>0){p=0;c:while(1){l=p;p=p+1|0;m=p>>1;m=($((l&1|0)==0?m:0-m|0,s)|0)+t|0;if(!((m|0)>-1&(m|0)<(z|0)))break b;e=c[b>>2]|0;c[w>>2]=0;Je(w,c[E>>2]|0);o=0;e=ya(104,e|0,m|0,w|0)|0;l=o;o=0;if(l&1){e=cc(856)|0;m=D;bq(w);if((m|0)!=(Xb(856)|0))break a;fc(e|0)|0;o=0;ob(44);m=o;o=0;if(m&1){F=6;break}}else{c[v>>2]=e;Je(E,e);bq(v);bq(w);k=c[E>>2]|0;l=0;do{d=(l|0)==1;if(d?(o=0,ka(306,k|0),j=o,o=0,j&1):0){F=5;break c}e=c[(c[a>>2]|0)+16>>2]|0;c[x>>2]=0;Je(x,k);o=0;e=ya(e|0,a|0,m|0,x|0)|0;j=o;o=0;if(j&1){e=cc(24)|0;d=D;bq(x)}else{c[u>>2]=e;bq(x);if(!d)break c;o=0;d=qa(114,e|0)|0;j=o;o=0;if(j&1){e=cc(24)|0;d=D}else{oe(B,d);d=c[r>>2]|0;if(!d){F=35;break c}j=d+8|0;d=c[j>>2]|0;o=0;f=qa(111,16)|0;G=o;o=0;d:do if(G&1)F=32;else{G=c[c[j>>2]>>2]|0;o=0;g=+Ka(c[(c[G>>2]|0)+8>>2]|0,G|0);G=o;o=0;do if(!(G&1)){G=c[c[j>>2]>>2]|0;o=0;h=+Ka(c[(c[G>>2]|0)+12>>2]|0,G|0);G=o;o=0;if(G&1)break;o=0;wa(43,f|0,+(n-g+-1.0),+h);G=o;o=0;if(G&1)break;c[y>>2]=0;vq(y,f);vq(d,c[y>>2]|0);uq(y);f=c[j>>2]|0;o=0;d=qa(111,16)|0;G=o;o=0;if(G&1){F=32;break d}G=c[(c[j>>2]|0)+4>>2]|0;o=0;h=+Ka(c[(c[G>>2]|0)+8>>2]|0,G|0);G=o;o=0;do if(!(G&1)){G=c[(c[j>>2]|0)+4>>2]|0;o=0;g=+Ka(c[(c[G>>2]|0)+12>>2]|0,G|0);G=o;o=0;if(G&1)break;o=0;wa(43,d|0,+(n-h+-1.0),+g);G=o;o=0;if(!(G&1)){F=29;break c}}while(0);e=cc(24)|0;G=D;Uz(d);d=G;break d}while(0);e=cc(24)|0;d=D;Uz(f)}while(0);if((F|0)==32){F=0;e=cc(24)|0;d=D}pe(B)}be(u)}if((d|0)!=(Xb(24)|0))break a;fc(e|0)|0;o=0;ob(44);G=o;o=0;if(G&1){F=5;break c}l=l+1|0}while((l|0)<2)}if((p|0)>=(q|0))break b}if((F|0)==5){e=cc()|0;F=8;break a}else if((F|0)==6){e=cc()|0;F=8;break a}else if((F|0)==29){c[A>>2]=0;vq(A,d);vq(f+4|0,c[A>>2]|0);uq(A);F=35}if((F|0)==35)pe(B);bq(E);i=C;return e|0}while(0);F=Ob(8)|0;c[F+4>>2]=0;c[F>>2]=30552;o=0;mb(55,F|0,856,146);o=0;F=7}while(0);if((F|0)==7){e=cc()|0;F=8}bq(E)}bc(e|0);return 0}function fl(a,b,d){a=a|0;b=b|0;d=d|0;return gl(a,c[b>>2]|0,d)|0}function gl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;j=c[a>>2]|0;g=(c[a+4>>2]|0)-j|0;i=g>>2;if((g|0)>0){f=0;a=0;e=0;do{e=(c[j+(f<<2)>>2]|0)+e|0;a=(c[b+(f<<2)>>2]|0)+a|0;f=f+1|0}while((f|0)<(i|0))}else{a=0;e=0}a:do if(e>>>0<a>>>0)a=2147483647;else{h=(e<<8>>>0)/(a>>>0)|0;d=($(h,d)|0)>>8;if((g|0)>0){a=0;g=0;do{f=c[j+(g<<2)>>2]<<8;k=$(c[b+(g<<2)>>2]|0,h)|0;f=(f|0)>(k|0)?f-k|0:k-f|0;if((f|0)>(d|0)){a=2147483647;break a}a=f+a|0;g=g+1|0}while((g|0)<(i|0))}else a=0;a=(a>>>0)/(e>>>0)|0}while(0);return a|0}function hl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;e=c[d>>2]|0;h=(c[d+4>>2]|0)-e|0;i=h>>2;if((h|0)>0){f=0;do{c[e+(f<<2)>>2]=0;f=f+1|0}while((f|0)<(i|0))}h=Wf(c[a>>2]|0)|0;if((h|0)<=(b|0)){l=Ob(8)|0;c[l+4>>2]=0;c[l>>2]=30552;Hc(l|0,856,146)}g=c[(c[(c[a>>2]|0)+20>>2]|0)+8>>2]|0;d=c[d>>2]|0;a:do if((h|0)>(b|0)){e=0;f=b;a=(c[g+(b>>5<<2)>>2]&1<<(b&31)|0)==0;while(1){if(a^(c[g+(f>>5<<2)>>2]&1<<(f&31)|0)!=0){b=d+(e<<2)|0;c[b>>2]=(c[b>>2]|0)+1}else{e=e+1|0;if((e|0)==(i|0))break a;c[d+(e<<2)>>2]=1;a=a^1}f=f+1|0;if((f|0)>=(h|0)){j=e;k=f;l=12;break}}}else{j=0;k=b;l=12}while(0);if(((l|0)==12?(j|0)!=(i|0):0)?!((k|0)==(h|0)&(j|0)==(i+-1|0)):0){l=Ob(8)|0;c[l+4>>2]=0;c[l>>2]=30552;Hc(l|0,856,146)}return}function il(a){a=a|0;return}function jl(a){a=a|0;Uz(a);return}function kl(a,b,d){a=a|0;b=+b;d=+d;ip(a,b,d);c[a>>2]=34064;return}function ll(a){a=a|0;var b=0;sl(a);c[a>>2]=5088;o=0;ka(320,a+20|0);b=o;o=0;if(b&1){b=cc()|0;Cl(a);bc(b|0)}else return}function ml(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;f=i;i=i+16|0;e=f+4|0;g=f;a=a+20|0;h=c[(c[a>>2]|0)+16>>2]|0;Wd(g,d);o=0;d=ya(h|0,a|0,b|0,g|0)|0;a=o;o=0;do if(!(a&1)){c[e>>2]=d;o=0;d=qa(160,e|0)|0;h=o;o=0;if(h&1){d=cc()|0;be(e);break}else{be(e);bq(g);i=f;return d|0}}else d=cc()|0;while(0);bq(g);bc(d|0);return 0}function nl(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0;m=i;i=i+64|0;h=m+56|0;j=m+52|0;d=m+48|0;q=m+44|0;e=m+32|0;p=m+28|0;n=m+16|0;k=m+4|0;l=m;g=ep(c[b>>2]|0)|0;c[d>>2]=g;o=0;g=qa(113,g|0)|0;f=o;o=0;a:do if(f&1){q=cc()|0;ne(d);d=q}else{ne(d);if((a[((a[g>>0]&1)==0?g+1|0:c[g+8>>2]|0)>>0]|0)!=48){d=Ob(8)|0;o=0;ka(308,d|0);q=o;o=0;if(q&1){q=cc()|0;Nb(d|0);d=q;break}else Hc(d|0,320,76)}f=Sz(20)|0;o=0;ia(48,e|0,g|0,1,-1,g|0);g=o;o=0;do if(g&1)d=cc()|0;else{o=0;ma(94,f|0,e|0);g=o;o=0;if(g&1){d=cc()|0;IC(e);break}c[q>>2]=0;cq(q,f);IC(e);o=0;e=qa(111,40)|0;g=o;o=0;if(g&1)d=cc()|0;else{c[p>>2]=0;cq(p,c[q>>2]|0);o=0;ma(129,n|0,c[b>>2]|0);g=o;o=0;if(g&1)d=cc()|0;else{o=0;d=qa(114,c[b>>2]|0)|0;b=o;o=0;do if(!(b&1)){oe(k,d);c[l>>2]=15;o=0;c[h>>2]=c[l>>2];ia(45,e|0,p|0,n|0,k|0,h|0);l=o;o=0;if(l&1){d=cc()|0;pe(k);break}else{c[j>>2]=0;Qe(j,e);pe(k);Sd(n);ne(p);ne(q);i=m;return c[j>>2]|0}}else d=cc()|0;while(0);Sd(n)}ne(p);Uz(e)}ne(q);break a}while(0);Uz(f)}while(0);bc(d|0);return 0}function ol(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0;g=i;i=i+16|0;f=g+4|0;h=g;a=a+20|0;j=c[(c[a>>2]|0)+28>>2]|0;Wd(h,d);o=0;d=kb(j|0,a|0,b|0,h|0,e|0)|0;a=o;o=0;do if(!(a&1)){c[f>>2]=d;o=0;d=qa(160,f|0)|0;j=o;o=0;if(j&1){d=cc()|0;be(f);break}else{be(f);bq(h);i=g;return d|0}}else d=cc()|0;while(0);bq(h);bc(d|0);return 0}function pl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0;f=i;i=i+16|0;e=f+12|0;g=f+8|0;h=f;a=a+20|0;j=c[(c[a>>2]|0)+12>>2]|0;_d(g,b);$d(h,d);o=0;d=ya(j|0,a|0,g|0,h|0)|0;a=o;o=0;do if(!(a&1)){c[e>>2]=d;o=0;d=qa(160,e|0)|0;j=o;o=0;if(j&1){d=cc()|0;be(e);break}else{be(e);ze(h+4|0);ce(g);i=f;return d|0}}else d=cc()|0;while(0);ze(h+4|0);ce(g);bc(d|0);return 0}function ql(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0;f=i;i=i+16|0;e=f;Wd(e,b);o=0;d=kb(42,a+20|0,e|0,c|0,d|0)|0;a=o;o=0;if(a&1){f=cc()|0;bq(e);bc(f|0)}else{bq(e);i=f;return d|0}return 0}function rl(a){a=a|0;return 15}function sl(a){a=a|0;cl(a);c[a>>2]=5184;a=a+8|0;c[a>>2]=0;c[a+4>>2]=0;c[a+8>>2]=0;return}function tl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+32|0;e=k+16|0;f=k+8|0;g=k;h=c[(c[a>>2]|0)+28>>2]|0;Wd(e,d);Wd(g,d);o=0;ma(153,f|0,g|0);d=o;o=0;if(!(d&1)?(o=0,j=kb(h|0,a|0,b|0,e|0,f|0)|0,a=o,o=0,!(a&1)):0){bq(g);bq(e);i=k;return j|0}k=cc()|0;bq(g);bq(e);bc(k|0);return 0}function ul(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0;k=i;i=i+32|0;l=k+16|0;d=k+12|0;h=k;j=k+8|0;e=(c[1283]|0)-(c[1282]|0)>>2;c[d>>2]=0;ms(l,e,d);d=0;e=0;a:while(1){if(d){e=10;break}do{g=(c[1283]|0)-(c[1282]|0)|0;d=g>>2;f=c[l>>2]|0;if((g|0)>0){g=0;do{c[f+(g<<2)>>2]=0;g=g+1|0}while((g|0)<(d|0))}Wd(j,b);o=0;Ca(51,h|0,j|0,e|0,0,5128,l|0);g=o;o=0;if(g&1){e=9;break a}e=h;d=c[e>>2]|0;e=c[e+4>>2]|0;f=a;c[f>>2]=d;c[f+4>>2]=e;bq(j);f=d-e+d|0}while((f|0)<=-1);o=0;d=kb(57,c[b>>2]|0,f|0,d|0,0)|0;g=o;o=0;if(g&1){e=5;break}}if((e|0)==5)d=cc()|0;else if((e|0)==9){d=cc()|0;bq(j)}else if((e|0)==10){br(l);i=k;return}br(l);bc(d|0)}function vl(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0.0,l=0.0,m=0.0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0;y=i;i=i+96|0;s=y+80|0;t=y+76|0;g=y+72|0;p=y+64|0;h=y+56|0;A=y+52|0;z=y+40|0;q=y+36|0;r=y+32|0;u=y+28|0;v=y+16|0;w=y+4|0;x=y;n=b+8|0;if(!(a[n>>0]&1)){a[n+1>>0]=0;a[n>>0]=0}else{a[c[b+16>>2]>>0]=0;c[b+12>>2]=0}j=c[(c[b>>2]|0)+24>>2]|0;Wd(g,e);o=0;j=kb(j|0,b|0,g|0,f|0,n|0)|0;C=o;o=0;do if(C&1){C=cc()|0;bq(g);g=C}else{bq(g);C=c[(c[b>>2]|0)+20>>2]|0;Wd(h,e);o=0;ub(C|0,p|0,b|0,h|0,j|0);C=o;o=0;if(C&1){g=cc()|0;bq(h);break}bq(h);j=p+4|0;g=c[j>>2]|0;h=g-(c[p>>2]|0)+g|0;if((h|0)<(Wf(c[e>>2]|0)|0)?Yf(c[e>>2]|0,g,h,0)|0:0){g=a[n>>0]|0;if(!(g&1))g=(g&255)>>>1;else g=c[b+12>>2]|0;if(g>>>0<8){g=Ob(8)|0;o=0;ka(308,g|0);C=o;o=0;if(C&1){C=cc()|0;Nb(g|0);g=C;break}else Hc(g|0,320,76)}g=Sz(20)|0;o=0;ma(94,g|0,n|0);C=o;o=0;if(C&1){C=cc()|0;Uz(g);g=C;break}c[A>>2]=0;cq(A,g);o=0;g=Wa(c[(c[b>>2]|0)+32>>2]|0,b|0,A|0)|0;C=o;o=0;do if(!(C&1)){if(!g){B=Ob(8)|0;Qf(B);o=0;mb(55,B|0,160,56);o=0;B=23;break}l=+((c[f>>2]|0)+(c[f+4>>2]|0)|0)*.5;m=+((c[p>>2]|0)+(c[j>>2]|0)|0)*.5;o=0;e=qa(c[(c[b>>2]|0)+36>>2]|0,b|0)|0;C=o;o=0;if(!(C&1)?(o=0,ma(147,z|0,2),C=o,o=0,!(C&1)):0){g=(c[z+8>>2]|0)+8|0;h=c[g>>2]|0;o=0;j=qa(111,16)|0;C=o;o=0;do if(!(C&1)){k=+(d|0);o=0;wa(43,j|0,+l,+k);C=o;o=0;if(C&1){g=cc()|0;Uz(j);break}c[q>>2]=0;vq(q,j);vq(h,c[q>>2]|0);uq(q);g=(c[g>>2]|0)+4|0;o=0;h=qa(111,16)|0;C=o;o=0;if(!(C&1)){o=0;wa(43,h|0,+m,+k);C=o;o=0;if(C&1){g=cc()|0;Uz(h);break}c[r>>2]=0;vq(r,h);vq(g,c[r>>2]|0);uq(r);o=0;g=qa(111,40)|0;C=o;o=0;if(C&1){B=33;break}c[u>>2]=0;cq(u,c[A>>2]|0);c[v+4>>2]=0;c[v>>2]=4084;c[v+8>>2]=0;oe(w,z);c[x>>2]=e;o=0;c[s>>2]=c[x>>2];ia(45,g|0,u|0,v|0,w|0,s|0);C=o;o=0;if(C&1){C=cc()|0;pe(w);Sd(v);ne(u);Uz(g);g=C;break}else{c[t>>2]=0;Qe(t,g);pe(w);Sd(v);ne(u);pe(z);ne(A);i=y;return c[t>>2]|0}}else B=33}else B=33;while(0);if((B|0)==33)g=cc()|0;pe(z)}else B=23}else B=23;while(0);if((B|0)==23)g=cc()|0;ne(A);break}C=Ob(8)|0;c[C+4>>2]=0;c[C>>2]=30552;Hc(C|0,856,146)}while(0);bc(g|0);return 0}function wl(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;i=(c[f+4>>2]|0)-(c[f>>2]|0)|0;q=i>>2;r=Wf(c[b>>2]|0)|0;h=c[b>>2]|0;if(e){e=1;d=bg(h,d)|0}else{e=0;d=ag(h,d)|0}n=q+-1|0;o=q+-2|0;p=q+-2|0;a:do if((d|0)<(r|0)){m=(i|0)>8;j=0;i=e;h=d;e=d;while(1){if(i^(c[(c[(c[(c[b>>2]|0)+20>>2]|0)+8>>2]|0)+(e>>5<<2)>>2]&1<<(e&31)|0)!=0){d=(c[g>>2]|0)+(j<<2)|0;c[d>>2]=(c[d>>2]|0)+1;d=j}else{if((j|0)==(n|0)){if((fl(g,f,179)|0)<122)break;d=c[g>>2]|0;l=c[d+4>>2]|0;j=(c[d>>2]|0)+h|0;if(m){h=2;do{c[d+(h+-2<<2)>>2]=c[d+(h<<2)>>2];h=h+1|0}while((h|0)<(q|0))}c[d+(o<<2)>>2]=0;c[d+(n<<2)>>2]=0;k=p;h=j+l|0}else{d=c[g>>2]|0;k=j+1|0}c[d+(k<<2)>>2]=1;d=k;i=i^1}e=e+1|0;if((e|0)>=(r|0))break a;else j=d}c[a>>2]=h;c[a+4>>2]=e;return}while(0);a=Ob(8)|0;c[a+4>>2]=0;c[a>>2]=30552;Hc(a|0,856,146)}function xl(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0;j=i;i=i+32|0;h=j+8|0;k=j+4|0;g=j;l=(c[f+4>>2]|0)-(c[f>>2]|0)>>2;c[k>>2]=0;ms(h,l,k);Wd(g,b);o=0;Ca(51,a|0,g|0,d|0,e|0,f|0,h|0);e=o;o=0;if(e&1){l=cc()|0;bq(g);br(h);bc(l|0)}else{bq(g);br(h);i=j;return}}function yl(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0;e=i;i=i+16|0;b=e;Wd(b,c);o=0;ia(49,a|0,b|0,d|0,0,5128);c=o;o=0;if(c&1){c=cc()|0;bq(b);bc(c|0)}else{bq(b);i=e;return}}function zl(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0;k=i;i=i+16|0;f=k;Wd(f,a);o=0;mb(76,f|0,d|0,b|0);j=o;o=0;if(j&1){k=cc()|0;bq(f);bc(k|0)}bq(f);j=(c[e+4>>2]|0)-(c[e>>2]|0)|0;g=j>>2;if((j|0)>0){f=-1;h=122;j=0;while(1){a=gl(b,c[(c[e>>2]|0)+(j<<2)>>2]|0,179)|0;d=(a|0)<(h|0);f=d?j:f;j=j+1|0;if((j|0)>=(g|0))break;else h=d?a:h}}else f=-1;if((f|0)>-1){i=k;return f|0}else{k=Ob(8)|0;c[k+4>>2]=0;c[k>>2]=30552;Hc(k|0,856,146)}return 0}function Al(a,b){a=a|0;b=b|0;return Bl(b)|0}function Bl(b){b=b|0;var d=0,e=0,f=0,g=0,h=0;b=Ph(c[b>>2]|0)|0;f=a[b>>0]|0;d=(f&1)==0;f=d?(f&255)>>>1:c[b+4>>2]|0;a:do if(!f)b=0;else{g=d?b+1|0:c[b+8>>2]|0;e=f;b=0;while(1){e=e+-2|0;if((e|0)<=-1)break;h=a[g+e>>0]|0;d=(h<<24>>24)+-48|0;if(h<<24>>24<48|(d|0)>9){b=0;break a}else b=d+b|0}b=b*3|0;if((f|0)>0){e=f+-1|0;do{h=a[g+e>>0]|0;d=(h<<24>>24)+-48|0;if(h<<24>>24<48|(d|0)>9){b=0;break a}b=d+b|0;e=e+-2|0}while((e|0)>-1)}b=((b|0)%10|0|0)==0}while(0);return b|0}function Cl(a){a=a|0;c[a>>2]=5184;IC(a+8|0);il(a);return}function Dl(a){a=a|0;Cl(a);Uz(a);return}function El(a){a=a|0;sl(a);c[a>>2]=5232;c[a+20>>2]=0;c[a+24>>2]=0;c[a+28>>2]=0;return}function Fl(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0;q=i;i=i+16|0;n=q;p=a+20|0;f=c[p>>2]|0;m=a+24|0;a=c[m>>2]|0;if((a|0)!=(f|0)){do a=a+-4|0;while((a|0)!=(f|0));c[m>>2]=a}cr(p,4);l=Wf(c[b>>2]|0)|0;a=c[d+4>>2]|0;a:do if((a|0)<(l|0)){f=0;k=0;while(1){Wd(n,b);o=0;j=kb(58,n|0,p|0,a|0,5164)|0;h=o;o=0;if(h&1)break;bq(n);NC(e,1,((j|0)%10|0)+48&255)|0;d=c[p>>2]|0;h=(c[m>>2]|0)-d|0;g=h>>2;if((h|0)>0){h=0;do{a=(c[d+(h<<2)>>2]|0)+a|0;h=h+1|0}while((h|0)<(g|0))}if((j|0)>9)f=1<<5-k|f;k=k+1|0;if(!((k|0)<6&(a|0)<(l|0)))break a}q=cc()|0;bq(n);bc(q|0)}else f=0;while(0);Gl(e,f)|0;i=q;return a|0}function Gl(a,b){a=a|0;b=b|0;var d=0,e=0;d=0;while(1){if((c[34080+(d<<2)>>2]|0)==(b|0)){b=0;e=3;break}d=d+1|0;if((d|0)>=10){d=0;e=6;break}}a:do if((e|0)==6)while(1){e=0;if((c[34120+(d<<2)>>2]|0)==(b|0)){b=1;e=3;break a}d=d+1|0;if((d|0)>=10){d=0;break}else e=6}while(0);if((e|0)==3){UC(a,0,1,b+48&255)|0;NC(a,1,d+48&255)|0;d=1}return d|0}function Hl(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0;e=i;i=i+16|0;b=e;Wd(b,c);o=0;ia(49,a|0,b|0,d|0,1,34160);c=o;o=0;if(c&1){c=cc()|0;bq(b);bc(c|0)}else{bq(b);i=e;return}}function Il(a,b){a=a|0;b=b|0;var d=0,e=0;e=i;i=i+16|0;d=e;c[d>>2]=Jl(b)|0;o=0;b=Wa(47,a|0,d|0)|0;a=o;o=0;if(a&1){e=cc()|0;ne(d);bc(e|0)}else{ne(d);i=e;return b|0}return 0}function Jl(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;q=i;i=i+96|0;g=q+84|0;r=q+72|0;h=q+60|0;k=q+48|0;l=q+36|0;m=q+24|0;n=q+12|0;p=q;f=Ph(c[b>>2]|0)|0;c[r>>2]=0;c[r+4>>2]=0;c[r+8>>2]=0;b=f+8|0;d=f+1|0;o=0;ya(101,r|0,1,a[((a[f>>0]&1)==0?d:c[b>>2]|0)>>0]|0)|0;e=o;o=0;a:do if(!(e&1)){e=a[((a[f>>0]&1)==0?d:c[b>>2]|0)+6>>0]|0;b:do switch(e<<24>>24|0){case 50:case 49:case 48:{o=0;ia(48,h|0,f|0,1,2,f|0);p=o;o=0;if(p&1){s=3;break a}p=a[h>>0]|0;n=(p&1)==0;o=0;ya(90,r|0,(n?h+1|0:c[h+8>>2]|0)|0,(n?(p&255)>>>1:c[h+4>>2]|0)|0)|0;p=o;o=0;if(p&1){b=cc()|0;IC(h);break a}IC(h);o=0;ya(101,r|0,1,e|0)|0;p=o;o=0;if(p&1){s=3;break a}o=0;Wa(93,r|0,48593)|0;p=o;o=0;if(p&1){s=3;break a}o=0;ia(48,k|0,f|0,3,3,f|0);p=o;o=0;if(p&1){s=3;break a}p=a[k>>0]|0;n=(p&1)==0;o=0;ya(90,r|0,(n?k+1|0:c[k+8>>2]|0)|0,(n?(p&255)>>>1:c[k+4>>2]|0)|0)|0;p=o;o=0;if(p&1){b=cc()|0;IC(k);break a}else{IC(k);break b}}case 51:{o=0;ia(48,l|0,f|0,1,3,f|0);p=o;o=0;if(p&1){s=3;break a}p=a[l>>0]|0;n=(p&1)==0;o=0;ya(90,r|0,(n?l+1|0:c[l+8>>2]|0)|0,(n?(p&255)>>>1:c[l+4>>2]|0)|0)|0;p=o;o=0;if(p&1){b=cc()|0;IC(l);break a}IC(l);o=0;Wa(93,r|0,48598)|0;p=o;o=0;if(p&1){s=3;break a}o=0;ia(48,m|0,f|0,4,2,f|0);p=o;o=0;if(p&1){s=3;break a}p=a[m>>0]|0;n=(p&1)==0;o=0;ya(90,r|0,(n?m+1|0:c[m+8>>2]|0)|0,(n?(p&255)>>>1:c[m+4>>2]|0)|0)|0;p=o;o=0;if(p&1){b=cc()|0;IC(m);break a}else{IC(m);break b}}case 52:{o=0;ia(48,n|0,f|0,1,4,f|0);p=o;o=0;if(p&1){s=3;break a}p=a[n>>0]|0;m=(p&1)==0;o=0;ya(90,r|0,(m?n+1|0:c[n+8>>2]|0)|0,(m?(p&255)>>>1:c[n+4>>2]|0)|0)|0;p=o;o=0;if(p&1){b=cc()|0;IC(n);break a}IC(n);o=0;Wa(93,r|0,48598)|0;p=o;o=0;if(p&1){s=3;break a}o=0;ya(101,r|0,1,a[((a[f>>0]&1)==0?d:c[b>>2]|0)+5>>0]|0)|0;p=o;o=0;if(p&1){s=3;break a}break}default:{o=0;ia(48,p|0,f|0,1,5,f|0);n=o;o=0;if(n&1){s=3;break a}n=a[p>>0]|0;m=(n&1)==0;o=0;ya(90,r|0,(m?p+1|0:c[p+8>>2]|0)|0,(m?(n&255)>>>1:c[p+4>>2]|0)|0)|0;n=o;o=0;if(n&1){b=cc()|0;IC(p);break a}IC(p);o=0;Wa(93,r|0,48593)|0;p=o;o=0;if(p&1){s=3;break a}o=0;ya(101,r|0,1,e|0)|0;p=o;o=0;if(p&1){s=3;break a}}}while(0);o=0;ya(101,r|0,1,a[((a[f>>0]&1)==0?d:c[b>>2]|0)+7>>0]|0)|0;p=o;o=0;if(!(p&1)?(o=0,j=qa(111,20)|0,p=o,o=0,!(p&1)):0){o=0;ma(94,j|0,r|0);p=o;o=0;if(p&1){b=cc()|0;Uz(j);break}else{c[g>>2]=0;cq(g,j);IC(r);i=q;return c[g>>2]|0}}else s=3}else s=3;while(0);if((s|0)==3)b=cc()|0;IC(r);bc(b|0);return 0}function Kl(a){a=a|0;return 16}function Ll(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=34180;Zp(a+8|0,b);c[a+56>>2]=0;c[a+52>>2]=29772;c[a+60>>2]=0;c[a+12>>2]=0;c[a+16>>2]=0;c[a+20>>2]=0;c[a+24>>2]=0;c[a+36>>2]=0;c[a+28>>2]=0;c[a+40>>2]=0;c[a+32>>2]=0;c[a+44>>2]=0;c[a+48>>2]=0;c[a+64>>2]=-1;return}function Ml(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0;m=i;i=i+64|0;n=m+48|0;f=m+36|0;h=m+24|0;j=m+12|0;k=m;g=jg(c[b+8>>2]|0)|0;l=b+52|0;d=Sz(20)|0;o=0;ma(102,d|0,929);e=o;o=0;do if(e&1){p=cc()|0;Uz(d);d=p}else{Hq(l,d);d=Sz(20)|0;o=0;ma(102,d|0,929);e=o;o=0;if(e&1){p=cc()|0;Uz(d);d=p;break}Fq(n,d);a:do if((g|0)>0){d=0;e=0;while(1){if((e|0)>89)break;mq(f,n);o=0;d=kb(59,b|0,e|0,f|0,d|0)|0;q=o;o=0;if(q&1){p=12;break}nq(f);e=e+1|0;if((e|0)>=(g|0)){p=13;break a}}if((p|0)==12){d=cc()|0;nq(f);break}d=Ob(8)|0;o=0;ma(88,d|0,48604);q=o;o=0;if(q&1){q=cc()|0;Nb(d|0);d=q;break}else{o=0;mb(55,d|0,320,76);o=0;d=cc()|0;break}}else{d=0;p=13}while(0);do if((p|0)==13){mq(j,l);o=0;mb(85,h|0,j|0,c[b+48>>2]|0);q=o;o=0;if(q&1){d=cc()|0;nq(j);break}Hq(l,c[h+8>>2]|0);nq(h);nq(j);mq(k,n);o=0;mb(85,a|0,k|0,d|0);q=o;o=0;if(q&1){d=cc()|0;nq(k);break}else{nq(k);nq(n);i=m;return}}while(0);nq(n)}while(0);bc(d|0)}function Nl(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;A=i;i=i+16|0;u=A;p=a+8|0;q=ig(c[p>>2]|0)|0;c[u>>2]=-1;y=(b|0)%3|0;r=q+-17|0;s=a+48|0;t=a+60|0;w=d+8|0;n=a+24+(y<<2)|0;x=a+64|0;m=(y|0)==1;v=a+16|0;a:do if((q|0)>0){d=0;l=0;b:while(1){h=l+16|0;j=c[p>>2]|0;g=0;f=0;k=16;while(1){if(eq(j,h-k|0,b)|0){B=_L(1,0,k|0)|0;f=D|f;g=B|g}if((k|0)>0)k=k+-1|0;else break}c[u>>2]=-1;f=Pl(g,f,u)|0;do if((d|0)>0){g=c[u>>2]|0;g=(g|0)<0|(g|0)==(y|0)?f:-1;if((l|0)<(r|0)&(g|0)<0){f=c[s>>2]|0;B=c[t>>2]|0;g=c[B+8>>2]|0;if((f|0)>=((c[B+12>>2]|0)-g>>2|0)){f=9;break b}c[g+(f<<2)>>2]=e;c[s>>2]=(c[s>>2]|0)+1;e=e+1|0;break}else{B=c[w>>2]|0;f=c[B+8>>2]|0;if((e|0)>=((c[B+12>>2]|0)-f>>2|0)){f=14;break b}c[f+(e<<2)>>2]=g;e=e+1|0;break}}else{c[n>>2]=f;if(m&(c[x>>2]|0)<0)c[v>>2]=f}while(0);l=l+17|0;if((l|0)>=(q|0)){f=21;break}else d=d+1|0}do if((f|0)==9){e=Ob(8)|0;o=0;ma(88,e|0,48656);B=o;o=0;if(B&1){B=cc()|0;Nb(e|0);e=B;break}else Hc(e|0,320,76)}else if((f|0)==14){e=Ob(8)|0;o=0;ma(88,e|0,48713);B=o;o=0;if(B&1){B=cc()|0;Nb(e|0);e=B;break}else Hc(e|0,320,76)}else if((f|0)==21){d=(d|0)>0;break a}while(0);bc(e|0)}else d=0;while(0);if(d){e=e+-1|0;d=c[(c[w>>2]|0)+8>>2]|0;f=d+(e<<2)|0;c[a+36+(y<<2)>>2]=c[f>>2];if((y|0)==2){if((c[x>>2]|0)<0?(z=c[f>>2]|0,c[a+20>>2]=z,B=c[v>>2]|0,(z|0)==(B|0)&(B|0)>0):0)c[x>>2]=(((z|0)%30|0)-((c[a+12>>2]|0)%3|0)|0)/3|0;Ql(a,b)|0;d=c[(c[w>>2]|0)+8>>2]|0}c[d+(e<<2)>>2]=0}i=A;return e|0}function Ol(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;do if((d|0)<0){e=Ob(8)|0;o=0;ma(103,e|0,48780);d=o;o=0;if(d&1){d=cc()|0;Nb(e|0);e=d;break}else Hc(e|0,240,66)}else{e=Sz(20)|0;o=0;ma(102,e|0,d|0);f=o;o=0;if(f&1){d=cc()|0;Uz(e);e=d;break}Fq(a,e);if(d){f=c[(c[b+8>>2]|0)+8>>2]|0;e=c[(c[a+8>>2]|0)+8>>2]|0;b=0;do{c[e+(b<<2)>>2]=c[f+(b<<2)>>2];b=b+1|0}while((b|0)!=(d|0))}return}while(0);bc(e|0)}function Pl(a,b,d){a=a|0;b=b|0;d=d|0;a=Rl(a&262143,0)|0;if((a|0)==-1)a=-1;else{a=(c[16424+(a<<2)>>2]|0)+-1|0;if(d)c[d>>2]=(a|0)/929|0;a=(a|0)%929|0}return a|0}function Ql(a,b){a=a|0;b=b|0;Sl(0,a+24|0,a+40|0,b)|0;Sl(0,a+28|0,a+44|0,b)|0;Sl(0,a+32|0,a+36|0,b)|0;return 1}function Rl(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;h=0;d=2787;a:while(1){f=d;while(1){if((h|0)>=(f|0)){d=-1;break a}d=(f+h|0)>>>1;e=c[5276+(d<<2)>>2]|0;g=((e|0)<0)<<31>>31;if((g|0)>(b|0)|(g|0)==(b|0)&e>>>0>a>>>0)f=d;else break}if(!((g|0)<(b|0)|(g|0)==(b|0)&e>>>0<a>>>0))break;h=d+1|0;d=f}return d|0}function Sl(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0;f=c[b>>2]|0;a=c[d>>2]|0;if(!((a|0)==-1|((f|0)==-1|(f|0)==(a|0)))){e=((e|0)/3|0)*30|0;g=e+29|0;if((f|0)<(e|0)|(f|0)>(g|0)){c[b>>2]=-1;a=c[d>>2]|0}if((a|0)<(e|0)|(a|0)>(g|0))c[d>>2]=-1}return 1}function Tl(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0;k=i;i=i+48|0;b=k+32|0;l=k+16|0;h=k;Cs(a,16);d=c[a+8>>2]|0;j=d+8|0;e=c[j>>2]|0;o=0;ma(154,b|0,1);f=o;o=0;do if(!(f&1)){o=0;ma(155,e|0,b|0);f=o;o=0;if(f&1){l=cc()|0;Ds(b+4|0);b=l;break}Ds(b+4|0);o=0;ma(154,l|0,900);g=o;o=0;if(!(g&1)){o=0;ma(155,(c[j>>2]|0)+16|0,l|0);g=o;o=0;a:do if(g&1){b=cc()|0;g=13}else{e=d+12|0;f=h+4|0;b=c[j>>2]|0;b:do if(((c[e>>2]|0)-b|0)>32){d=2;while(1){o=0;mb(86,h|0,b+(d+-1<<4)|0,l|0);g=o;o=0;if(g&1){g=11;break}o=0;ma(155,b+(d<<4)|0,h|0);g=o;o=0;if(g&1){g=14;break}Ds(f);d=d+1|0;b=c[j>>2]|0;if((d|0)>=((c[e>>2]|0)-b>>4|0))break b}if((g|0)==11){b=cc()|0;g=13;break a}else if((g|0)==14){b=cc()|0;Ds(f);break a}}while(0);Ds(l+4|0);i=k;return}while(0);Ds(l+4|0)}else g=9}else g=9;while(0);if((g|0)==9)b=cc()|0;Fs(a);bc(b|0)}function Ul(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;y=i;i=i+128|0;v=y+116|0;z=y+112|0;g=y+100|0;l=y+96|0;n=y+84|0;p=y+80|0;q=y+68|0;r=y+64|0;s=y+52|0;t=y+48|0;u=y+36|0;h=y+32|0;j=y+20|0;k=y+16|0;w=y+4|0;x=y;b=Sz(20)|0;o=0;ma(156,b|0,100);m=o;o=0;if(m&1){z=cc()|0;Uz(b);b=z}else{c[z>>2]=0;cq(z,b);f=a+8|0;b=c[(c[f>>2]|0)+8>>2]|0;m=c[z>>2]|0;a:do if((c[b>>2]|0)>2){b=b+4|0;e=2;b:while(1){switch(c[b>>2]|0){case 900:{mq(g,a);c[l>>2]=0;cq(l,m);o=0;b=ya(105,g|0,e|0,l|0)|0;e=o;o=0;if(e&1){d=9;break b}ne(l);nq(g);break}case 901:{mq(n,a);c[p>>2]=0;cq(p,m);o=0;b=kb(60,901,n|0,e|0,p|0)|0;e=o;o=0;if(e&1){d=12;break b}ne(p);nq(n);break}case 902:{mq(q,a);c[r>>2]=0;cq(r,m);o=0;b=ya(106,q|0,e|0,r|0)|0;e=o;o=0;if(e&1){d=15;break b}ne(r);nq(q);break}case 913:{mq(s,a);c[t>>2]=0;cq(t,m);o=0;b=kb(60,913,s|0,e|0,t|0)|0;e=o;o=0;if(e&1){d=18;break b}ne(t);nq(s);break}case 924:{mq(u,a);c[h>>2]=0;cq(h,m);o=0;b=kb(60,924,u|0,e|0,h|0)|0;e=o;o=0;if(e&1){d=21;break b}ne(h);nq(u);break}default:{mq(j,a);c[k>>2]=0;cq(k,m);o=0;b=ya(105,j|0,e+-1|0,k|0)|0;e=o;o=0;if(e&1){d=24;break b}ne(k);nq(j)}}e=c[f>>2]|0;d=c[e+8>>2]|0;if((b|0)>=((c[e+12>>2]|0)-d>>2|0)){d=27;break}e=b+1|0;if((e|0)>=(c[d>>2]|0)){d=30;break a}else b=d+(b<<2)|0}if((d|0)==9){b=cc()|0;ne(l);nq(g);break}else if((d|0)==12){b=cc()|0;ne(p);nq(n);break}else if((d|0)==15){b=cc()|0;ne(r);nq(q);break}else if((d|0)==18){b=cc()|0;ne(t);nq(s);break}else if((d|0)==21){b=cc()|0;ne(h);nq(u);break}else if((d|0)==24){b=cc()|0;ne(k);nq(j);break}else if((d|0)==27){b=Ob(8)|0;o=0;ka(308,b|0);y=o;o=0;if(y&1){y=cc()|0;Nb(b|0);b=y;break}else{o=0;mb(55,b|0,320,76);o=0;d=6;break}}}else d=30;while(0);do if((d|0)==30){o=0;b=qa(111,48)|0;u=o;o=0;if(!(u&1)){c[w+4>>2]=0;c[w>>2]=4084;c[w+8>>2]=0;c[x>>2]=0;cq(x,m);o=0;mb(53,b|0,w|0,x|0);u=o;o=0;if(u&1){y=cc()|0;ne(x);Sd(w);Uz(b);b=y;break}else{c[v>>2]=0;dq(v,b);ne(x);Sd(w);ne(z);i=y;return c[v>>2]|0}}else d=6}while(0);if((d|0)==6)b=cc()|0;ne(z)}bc(b|0);return 0}function Vl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;r=i;i=i+64|0;s=r+40|0;q=r+28|0;m=r+16|0;n=r+4|0;p=r;a=a+8|0;kq(s,c[c[(c[a>>2]|0)+8>>2]>>2]<<1);o=0;ma(91,q|0,c[c[(c[a>>2]|0)+8>>2]>>2]<<1|0);l=o;o=0;do if(!(l&1)){j=c[(c[a>>2]|0)+8>>2]|0;k=(c[s+8>>2]|0)+8|0;l=(c[q+8>>2]|0)+8|0;a=0;a:while(1){h=c[j>>2]|0;g=0;b:while(1)while(1){if(g|(b|0)>=(h|0))break a;e=b+1|0;f=c[j+(b<<2)>>2]|0;if((f|0)<900){b=e;e=f;f=7;break b}switch(f|0){case 924:case 902:case 901:{g=1;continue b}case 900:{b=e;f=10;break b}case 913:{f=11;break b}default:b=e}}if((f|0)==7){h=c[k>>2]|0;c[h+(a<<2)>>2]=(e|0)/30|0;c[h+(a+1<<2)>>2]=(e|0)%30|0;a=a+2|0;continue}else if((f|0)==10){c[(c[k>>2]|0)+(a<<2)>>2]=900;a=a+1|0;continue}else if((f|0)==11){c[(c[k>>2]|0)+(a<<2)>>2]=913;c[(c[l>>2]|0)+(a<<2)>>2]=c[j+(e<<2)>>2];b=b+2|0;a=a+1|0;continue}}mq(m,s);mq(n,q);Sq(p,d);o=0;ub(63,m|0,n|0,a|0,p|0);d=o;o=0;if(d&1){a=cc()|0;ne(p);nq(n);nq(m);nq(q);break}else{ne(p);nq(n);nq(m);nq(q);nq(s);i=r;return b|0}}else a=cc()|0;while(0);nq(s);bc(a|0);return 0}function Wl(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;u=i;i=i+64|0;t=u+48|0;s=u+36|0;q=u+24|0;p=u+12|0;n=u;a:do switch(b|0){case 901:{b=Sz(20)|0;o=0;ma(77,b|0,6);r=o;o=0;if(r&1){e=cc()|0;Uz(b);h=43;break a}ie(t,b);o=0;b=qa(111,20)|0;r=o;o=0;do if(r&1)e=cc()|0;else{o=0;ma(102,b|0,6);r=o;o=0;if(r&1){e=cc()|0;Uz(b);break}Fq(s,b);m=d+8|0;b=c[(c[m>>2]|0)+8>>2]|0;d=c[b+(e<<2)>>2]|0;r=(c[s+8>>2]|0)+8|0;p=c[t+8>>2]|0;n=p+8|0;p=p+12|0;e=e+1|0;g=c[b>>2]|0;b:do if((e|0)<(g|0)){k=0;h=0;l=b;j=0;c:while(1){b=j+1|0;c[(c[r>>2]|0)+(j<<2)>>2]=d;g=dM(k|0,h|0,900,0)|0;g=TL(d|0,((d|0)<0)<<31>>31|0,g|0,D|0)|0;h=D;d=c[l+(e<<2)>>2]|0;switch(d|0){case 900:case 901:case 902:case 922:case 923:case 924:case 928:{k=g;j=1;break}default:if((j|0)>-1&((b|0)%5|0|0)==0){a[(c[n>>2]|0)+5>>0]=g;g=VL(g|0,h|0,8)|0;a[(c[n>>2]|0)+4>>0]=g;g=VL(g|0,D|0,8)|0;a[(c[n>>2]|0)+3>>0]=g;g=VL(g|0,D|0,8)|0;a[(c[n>>2]|0)+2>>0]=g;g=VL(g|0,D|0,8)|0;a[(c[n>>2]|0)+1>>0]=g;g=VL(g|0,D|0,8)|0;a[c[n>>2]>>0]=g;g=VL(g|0,D|0,8)|0;h=D;b=c[f>>2]|0;l=c[n>>2]|0;o=0;mb(57,q|0,l|0,(c[p>>2]|0)-l|0);l=o;o=0;if(l&1){h=13;break c}o=0;ma(157,b|0,q|0);l=o;o=0;if(l&1){h=19;break c}IC(q);l=c[(c[m>>2]|0)+8>>2]|0;k=g;b=0;j=0}else{k=g;j=0}}e=e+1|0;g=c[l>>2]|0;if(j|(e|0)>=(g|0)){h=20;break b}else j=b}if((h|0)==13){e=cc()|0;h=14;break}else if((h|0)==19){e=cc()|0;IC(q);break}}else{b=0;h=20}while(0);d:do if((h|0)==20){if((d|0)<900&(e|0)==(g|0)){c[(c[r>>2]|0)+(b<<2)>>2]=d;b=b+1|0}e:do if((b|0)>0){d=0;while(1){o=0;ma(158,c[f>>2]|0,c[(c[r>>2]|0)+(d<<2)>>2]&255|0);q=o;o=0;if(q&1)break;d=d+1|0;if((d|0)>=(b|0))break e}e=cc()|0;h=14;break d}while(0);nq(s);Sd(t);h=42;break a}while(0);nq(s)}while(0);Sd(t);h=43;break}case 924:{l=d+8|0;m=p+8|0;b=c[(c[l>>2]|0)+8>>2]|0;if((c[b>>2]|0)>(e|0)){j=0;d=0;h=0;while(1){g=e+1|0;b=c[b+(e<<2)>>2]|0;f:do if((b|0)<900){d=dM(j|0,d|0,900,0)|0;b=TL(b|0,((b|0)<0)<<31>>31|0,d|0,D|0)|0;d=D;e=h+1|0;k=0}else{switch(b|0){case 900:case 901:case 902:case 922:case 923:case 924:case 928:break;default:{b=j;e=h;k=0;break f}}g=e;b=j;e=h;k=1}while(0);if((e|0)>0&((e|0)%5|0|0)==0){e=Sz(20)|0;o=0;ma(77,e|0,6);t=o;o=0;if(t&1){h=35;break}ie(p,e);t=(c[m>>2]|0)+8|0;a[(c[t>>2]|0)+5>>0]=b;e=VL(b|0,d|0,8)|0;a[(c[t>>2]|0)+4>>0]=e;e=VL(e|0,D|0,8)|0;a[(c[t>>2]|0)+3>>0]=e;e=VL(e|0,D|0,8)|0;a[(c[t>>2]|0)+2>>0]=e;e=VL(e|0,D|0,8)|0;a[(c[t>>2]|0)+1>>0]=e;e=VL(e|0,D|0,8)|0;a[c[t>>2]>>0]=e;e=VL(e|0,D|0,8)|0;d=D;b=c[f>>2]|0;o=0;mb(57,n|0,c[t>>2]|0,6);t=o;o=0;if(t&1){h=36;break}o=0;ma(157,b|0,n|0);t=o;o=0;if(t&1){h=40;break}IC(n);Sd(p);j=e;h=0}else{j=b;h=e}b=c[(c[l>>2]|0)+8>>2]|0;if(k|(g|0)>=(c[b>>2]|0)){e=g;h=42;break a}else e=g}if((h|0)==35){u=cc()|0;Uz(e);e=u;h=43;break a}else if((h|0)==36)e=cc()|0;else if((h|0)==40){e=cc()|0;IC(n)}Sd(p);h=43}else h=42;break}default:h=42}while(0);if((h|0)==42){i=u;return e|0}else if((h|0)==43)bc(e|0);return 0}function Xl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0;p=i;i=i+32|0;q=p+16|0;n=p+12|0;m=p;e=Sz(20)|0;o=0;ma(102,e|0,15);l=o;o=0;a:do if(l&1){b=cc()|0;Uz(e)}else{Fq(q,e);k=a+8|0;l=q+8|0;e=c[(c[k>>2]|0)+8>>2]|0;a=c[e>>2]|0;b:do if((a|0)>(b|0)){g=0;f=0;while(1){j=b+1|0;h=c[e+(b<<2)>>2]|0;f=f|(j|0)==(a|0);if((h|0)<900){c[(c[(c[l>>2]|0)+8>>2]|0)+(g<<2)>>2]=h;e=g+1|0;a=7}else switch(h|0){case 900:case 901:case 922:case 923:case 924:case 928:{e=g;f=1;a=9;break}default:{e=g;a=7}}if((a|0)==7){a=0;if(f|((h|0)==902|((e|0)%15|0|0)==0)){b=j;a=9}else{b=j;g=e;f=0}}if((a|0)==9){mq(m,q);o=0;e=Wa(94,m|0,e|0)|0;j=o;o=0;if(j&1){a=13;break}c[n>>2]=e;nq(m);a=c[d>>2]|0;o=0;e=qa(113,e|0)|0;j=o;o=0;if(j&1){a=14;break}o=0;ma(157,a|0,e|0);j=o;o=0;if(j&1){a=14;break}ne(n);g=0}e=c[(c[k>>2]|0)+8>>2]|0;a=c[e>>2]|0;if(!((b|0)<(a|0)&(f^1)))break b}if((a|0)==13){b=cc()|0;nq(m)}else if((a|0)==14){b=cc()|0;ne(n)}nq(q);break a}while(0);nq(q);i=p;return b|0}while(0);bc(b|0);return 0}function Yl(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0;k=b+8|0;h=d+8|0;a:do if((e|0)>0){i=0;j=0;b=0;while(1){d=c[(c[(c[k>>2]|0)+8>>2]|0)+(i<<2)>>2]|0;b:do switch(b|0){case 0:{if((d|0)<26){b=d+65&255;d=0;l=39;break b}switch(d|0){case 26:{b=32;d=0;l=40;break b}case 27:{g=j;b=1;break b}case 28:{g=j;b=2;break b}case 29:{g=0;b=5;break b}case 913:{Uh(c[f>>2]|0,c[(c[(c[h>>2]|0)+8>>2]|0)+(i<<2)>>2]&255);g=j;b=0;break b}default:{g=j;b=0;break b}}}case 1:{if((d|0)<26){b=d+97&255;d=1;l=39;break b}switch(d|0){case 26:{b=32;d=1;l=40;break b}case 27:{g=1;b=4;break b}case 28:{g=j;b=2;break b}case 29:{g=1;b=5;break b}case 913:{Uh(c[f>>2]|0,c[(c[(c[h>>2]|0)+8>>2]|0)+(i<<2)>>2]&255);g=j;b=1;break b}default:{g=j;b=(d|0)!=900&1;break b}}}case 2:{if((d|0)<25){b=a[46657+d>>0]|0;d=2;l=39;break b}switch(d|0){case 25:{g=j;b=3;break b}case 26:{b=32;d=2;l=40;break b}case 27:{g=j;b=1;break b}case 28:{g=j;b=0;break b}case 29:{g=2;b=5;break b}case 913:{Uh(c[f>>2]|0,c[(c[(c[h>>2]|0)+8>>2]|0)+(i<<2)>>2]&255);g=j;b=2;break b}default:{g=j;b=(d|0)==900?0:2;break b}}}case 3:{if((d|0)<29){b=a[46628+d>>0]|0;d=3;l=39;break b}switch(d|0){case 29:{g=j;b=0;break b}case 913:{Uh(c[f>>2]|0,c[(c[(c[h>>2]|0)+8>>2]|0)+(i<<2)>>2]&255);g=j;b=3;break b}default:{g=j;b=(d|0)==900?0:3;break b}}}case 4:{if((d|0)<26){b=d+65&255;d=j;l=39;break b}if((d|0)==26){b=32;d=j;l=40}else{g=j;b=(d|0)==900?0:j}break}case 5:{if((d|0)<29){b=a[46628+d>>0]|0;d=j;l=39;break b}switch(d|0){case 29:{g=j;b=0;break b}case 913:{Uh(c[f>>2]|0,c[(c[(c[h>>2]|0)+8>>2]|0)+(i<<2)>>2]&255);g=j;b=j;break b}default:{g=j;b=(d|0)==900?0:j;break b}}}default:g=j}while(0);if((l|0)==39){l=0;if(!(b<<24>>24)){g=j;b=d}else l=40}if((l|0)==40){l=0;Uh(c[f>>2]|0,b);g=j;b=d}i=i+1|0;if((i|0)>=(e|0))break a;else j=g}}while(0);return}function Zl(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;v=i;i=i+112|0;q=v+104|0;p=v+100|0;r=v+96|0;y=v+80|0;h=v+64|0;j=v+48|0;k=v+32|0;x=v+20|0;w=v+8|0;s=v+4|0;t=v;sp(y,0);e=b+8|0;f=d+-1|0;l=h+4|0;m=j+4|0;n=k+4|0;a:do if((d|0)>0){g=0;while(1){b=c[(c[6895]|0)+8>>2]|0;o=0;ma(154,k|0,c[(c[(c[e>>2]|0)+8>>2]|0)+(g<<2)>>2]|0);z=o;o=0;if(z&1){g=7;break}o=0;mb(86,j|0,b+(f-g<<4)|0,k|0);z=o;o=0;if(z&1){g=10;break}o=0;mb(87,h|0,y|0,j|0);z=o;o=0;if(z&1){g=11;break}o=0;ma(155,y|0,h|0);z=o;o=0;if(z&1){g=12;break}Ds(l);Ds(m);Ds(n);g=g+1|0;if((g|0)>=(d|0)){g=15;break a}}if((g|0)==7){b=cc()|0;g=9;break}else if((g|0)==10)b=cc()|0;else if((g|0)==11){b=cc()|0;g=13}else if((g|0)==12){b=cc()|0;Ds(l);g=13}if((g|0)==13)Ds(m);Ds(n)}else g=15;while(0);do if((g|0)==15){o=0;ma(159,x|0,y|0);z=o;o=0;if(z&1){b=cc()|0;g=9;break}b=a[x>>0]|0;e=(b&1)==0;f=e?x+1|0:c[x+8>>2]|0;do if((a[f>>0]|0)!=49){b=Ob(8)|0;o=0;ma(88,b|0,48823);z=o;o=0;if(z&1){z=cc()|0;Nb(b|0);b=z;break}else{o=0;mb(55,b|0,320,76);o=0;b=cc()|0;break}}else{c[w>>2]=0;c[w+4>>2]=0;c[w+8>>2]=0;c[s>>2]=f+1;c[t>>2]=f+(e?(b&255)>>>1:c[x+4>>2]|0);o=0;c[p>>2]=c[s>>2];c[q>>2]=c[t>>2];ya(107,w|0,p|0,q|0)|0;z=o;o=0;do if(!(z&1)?(o=0,u=qa(111,20)|0,z=o,o=0,!(z&1)):0){o=0;ma(94,u|0,w|0);z=o;o=0;if(z&1){b=cc()|0;Uz(u);break}else{c[r>>2]=0;cq(r,u);IC(w);IC(x);Ds(y+4|0);i=v;return c[r>>2]|0}}else g=23;while(0);if((g|0)==23)b=cc()|0;IC(w)}while(0);IC(x)}while(0);Ds(y+4|0);bc(b|0);return 0}function _l(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;h=i;i=i+144|0;l=h+76|0;d=h+72|0;k=h+60|0;j=h+48|0;a=h+36|0;e=h+24|0;f=h+12|0;g=h;Zp(d,b);o=0;ma(160,l|0,d|0);b=o;o=0;if(b&1){l=cc()|0;Yd(d);d=l}else{Yd(d);o=0;ma(161,k|0,l|0);b=o;o=0;if(b&1)d=cc()|0;else{b=c[k+8>>2]|0;do if((c[b+12>>2]|0)==(c[b+8>>2]|0)){d=Ob(8)|0;o=0;ma(88,d|0,48899);j=o;o=0;if(j&1){j=cc()|0;Nb(d|0);d=j;break}else{o=0;mb(55,d|0,320,76);o=0;d=cc()|0;break}}else{d=1<<(c[l+64>>2]|0)+1;mq(j,l+52|0);mq(a,k);mq(e,j);o=0;ub(64,0,a|0,e|0,d|0);b=o;o=0;do if(!(b&1)){nq(e);nq(a);mq(f,k);o=0;ma(162,f|0,d|0);b=o;o=0;if(b&1){d=cc()|0;nq(f);break}nq(f);mq(g,k);o=0;d=qa(161,g|0)|0;b=o;o=0;if(b&1){d=cc()|0;nq(g);break}else{nq(g);nq(j);nq(k);Is(l);i=h;return d|0}}else{d=cc()|0;nq(e);nq(a)}while(0);nq(j)}while(0);nq(k)}Is(l)}bc(d|0);return 0}function $l(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0;h=i;i=i+32|0;k=h+24|0;a=h+12|0;f=h;g=c[d+8>>2]|0;do if(e>>>0>512?1:((c[g+12>>2]|0)-(c[g+8>>2]|0)>>2|0)>(((e|0)/2|0)+3|0)){a=Ob(8)|0;o=0;ma(88,a|0,48941);k=o;o=0;if(k&1){k=cc()|0;Nb(a|0);a=k;break}else Hc(a|0,320,76)}else{g=Sz(12)|0;o=0;ka(324,g|0);l=o;o=0;if(l&1){a=cc()|0;Uz(g);break}c[k>>2]=0;Js(k,g);l=c[k>>2]|0;mq(a,b);mq(f,d);o=0;ub(65,l|0,a|0,e|0,f|0);l=o;o=0;do if(!(l&1)){nq(f);nq(a);f=c[b+8>>2]|0;a=c[f+8>>2]|0;f=(c[f+12>>2]|0)-a>>2;g=0;while(1){if((g|0)>=(f|0)){j=15;break}if((c[a+(g<<2)>>2]|0)<0)break;else g=g+1|0}if((j|0)==15){Ks(k);i=h;return}a=Ob(8)|0;o=0;ma(88,a|0,49010);l=o;o=0;if(l&1){l=cc()|0;Nb(a|0);a=l;break}else{o=0;mb(55,a|0,320,76);o=0;a=cc()|0;break}}else{l=cc()|0;nq(f);nq(a);a=l}while(0);Ks(k)}while(0);bc(a|0)}function am(a,b){a=a|0;b=b|0;var d=0,e=0;a=c[a+8>>2]|0;d=c[a+8>>2]|0;a=(c[a+12>>2]|0)-d|0;e=a>>2;a:do if((a|0)<16){a=Ob(8)|0;o=0;ma(88,a|0,49071);b=o;o=0;if(b&1){b=cc()|0;Nb(a|0);a=b;break}else Hc(a|0,320,76)}else{a=c[d>>2]|0;if((a|0)>(e|0)){a=Ob(8)|0;o=0;ma(88,a|0,49130);b=o;o=0;if(b&1){b=cc()|0;Nb(a|0);a=b;break}else Hc(a|0,320,76)}do if(!a){if((e|0)>(b|0)){c[d>>2]=e-b;break}a=Ob(8)|0;o=0;ma(88,a|0,49195);b=o;o=0;if(b&1){b=cc()|0;Nb(a|0);a=b;break a}else Hc(a|0,320,76)}while(0);return}while(0);bc(a|0)}function bm(a){a=a|0;c[a+4>>2]=0;c[a>>2]=34196;c[a+8>>2]=27584;return}function cm(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0;A=i;i=i+160|0;J=A+156|0;f=A+144|0;I=A+132|0;H=A+128|0;u=A+116|0;n=A+112|0;p=A+100|0;l=A+96|0;m=A+92|0;G=A+88|0;q=A+76|0;F=A+64|0;r=A+60|0;t=A+56|0;E=A+52|0;D=A+48|0;C=A+36|0;w=A+32|0;B=A+20|0;x=A+16|0;y=A+12|0;v=A;g=Sz(24)|0;z=a+8|0;s=c[z>>2]|0;mq(f,b);o=0;mb(88,g|0,s|0,f|0);s=o;o=0;if(s&1){J=cc()|0;nq(f);Uz(g);f=J}else{c[J>>2]=0;Ls(J,g);nq(f);o=0;f=qa(111,20)|0;s=o;o=0;a:do if(s&1)f=cc()|0;else{o=0;ma(102,f|0,d|0);s=o;o=0;if(s&1){I=cc()|0;Uz(f);f=I;break}Fq(I,f);g=c[J>>2]|0;h=(c[I+8>>2]|0)+8|0;b:do if((d|0)>0){k=0;j=d;while(1){o=0;f=Wa(95,c[z>>2]|0,j|0)|0;s=o;o=0;if(s&1){g=11;break}o=0;f=Wa(96,g|0,f|0)|0;s=o;o=0;if(s&1){g=11;break}c[(c[h>>2]|0)+(d-j<<2)>>2]=f;k=k|(f|0)!=0;if((j|0)<=1){g=14;break}else j=j+-1|0}do if((g|0)==11){f=cc()|0;g=13}else if((g|0)==14){if(!k)break b;o=0;f=qa(162,c[z>>2]|0)|0;s=o;o=0;if(s&1){f=cc()|0;g=13;break}c[H>>2]=f;k=e+8|0;s=b+8|0;j=u+8|0;b=c[k>>2]|0;f=c[b+8>>2]|0;c:do if(((c[b+12>>2]|0)-f|0)>0){h=0;while(1){g=c[s>>2]|0;o=0;g=Wa(95,c[z>>2]|0,((c[g+12>>2]|0)-(c[g+8>>2]|0)>>2)+~c[f+(h<<2)>>2]|0)|0;b=o;o=0;if(b&1){g=25;break}o=0;f=qa(111,20)|0;b=o;o=0;if(b&1){g=25;break}o=0;ma(102,f|0,2);b=o;o=0;if(b&1){g=28;break}Fq(u,f);o=0;f=ya(108,c[z>>2]|0,0,g|0)|0;b=o;o=0;if(b&1){g=29;break}b=c[(c[j>>2]|0)+8>>2]|0;c[b+4>>2]=f;c[b>>2]=1;o=0;f=qa(111,24)|0;b=o;o=0;if(b&1){g=29;break}b=c[z>>2]|0;mq(p,u);o=0;mb(88,f|0,b|0,p|0);b=o;o=0;if(b&1){g=30;break}c[n>>2]=0;Ls(n,f);nq(p);f=c[H>>2]|0;c[m>>2]=0;Ls(m,c[n>>2]|0);o=0;f=Wa(97,f|0,m|0)|0;b=o;o=0;if(b&1){g=31;break}c[l>>2]=f;Ls(H,f);Ms(l);Ms(m);Ms(n);nq(u);h=h+1|0;b=c[k>>2]|0;f=c[b+8>>2]|0;if((h|0)>=((c[b+12>>2]|0)-f>>2|0)){g=33;break c}}if((g|0)==25){f=cc()|0;g=27;break}else if((g|0)==28){G=cc()|0;Uz(f);f=G;break}else if((g|0)==29)f=cc()|0;else if((g|0)==30){G=cc()|0;nq(p);Uz(f);f=G}else if((g|0)==31){f=cc()|0;Ms(m);Ms(n)}nq(u)}else g=33;while(0);do if((g|0)==33){o=0;f=qa(111,24)|0;u=o;o=0;if(u&1){f=cc()|0;g=27;break}u=c[z>>2]|0;mq(q,I);o=0;mb(88,f|0,u|0,q|0);u=o;o=0;if(u&1){G=cc()|0;nq(q);Uz(f);f=G;break}c[G>>2]=0;Ls(G,f);nq(q);o=0;f=ya(109,c[z>>2]|0,d|0,1)|0;u=o;o=0;do if(u&1)f=cc()|0;else{c[r>>2]=f;c[t>>2]=0;Ls(t,c[G>>2]|0);o=0;ia(50,F|0,a|0,r|0,t|0,d|0);u=o;o=0;if(u&1){f=cc()|0;Ms(t);Ms(r);break}Ms(t);Ms(r);Ns(E,c[F>>2]|0);Ns(D,(c[F>>2]|0)+4|0);c[w>>2]=0;f=c[E>>2]|0;Ls(w,f);o=0;mb(89,C|0,a|0,w|0);u=o;o=0;if(u&1){f=cc()|0;Ms(w)}else{Ms(w);c[x>>2]=0;Ls(x,c[D>>2]|0);c[y>>2]=0;Ls(y,f);mq(v,C);o=0;ia(51,B|0,a|0,x|0,y|0,v|0);a=o;o=0;d:do if(a&1){f=cc()|0;nq(v);Ms(y);Ms(x)}else{nq(v);Ms(y);Ms(x);e=c[C+8>>2]|0;k=e+12|0;e=e+8|0;b=(c[B+8>>2]|0)+8|0;f=c[e>>2]|0;e:do if(((c[k>>2]|0)-f|0)>0){j=0;while(1){h=c[s>>2]|0;g=c[h+12>>2]|0;h=c[h+8>>2]|0;o=0;f=Wa(98,c[z>>2]|0,c[f+(j<<2)>>2]|0)|0;a=o;o=0;if(a&1){g=48;break}f=(g-h>>2)+-1-f|0;if((f|0)<0){g=42;break}o=0;g=ya(108,c[z>>2]|0,c[(c[(c[s>>2]|0)+8>>2]|0)+(f<<2)>>2]|0,c[(c[b>>2]|0)+(j<<2)>>2]|0)|0;a=o;o=0;if(a&1){g=48;break}c[(c[(c[s>>2]|0)+8>>2]|0)+(f<<2)>>2]=g;j=j+1|0;f=c[e>>2]|0;if((j|0)>=((c[k>>2]|0)-f>>2|0))break e}if((g|0)==42){f=Ob(8)|0;Kh(f,49260);o=0;mb(55,f|0,256,68);o=0;f=cc()|0}else if((g|0)==48)f=cc()|0;nq(B);break d}while(0);nq(B);nq(C);Ms(D);Ms(E);Os(F);Ms(G);Ms(H);break b}while(0);nq(C)}Ms(D);Ms(E);Os(F)}while(0);Ms(G)}while(0);Ms(H)}while(0);nq(I);break a}while(0);nq(I);Ms(J);i=A;return}while(0);Ms(J)}bc(f|0)}function dm(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0;z=i;i=i+80|0;g=z+72|0;G=z+68|0;F=z+64|0;E=z+60|0;D=z+56|0;A=z+52|0;C=z+48|0;w=z+44|0;l=z+40|0;q=z+36|0;n=z+32|0;r=z+28|0;p=z+24|0;s=z+20|0;t=z+16|0;v=z+12|0;u=z+8|0;B=z+4|0;y=z;m=sm(c[d>>2]|0)|0;if((m|0)<(sm(c[e>>2]|0)|0)){Ns(g,d);Ls(d,c[e>>2]|0);Ls(e,c[g>>2]|0);Ms(g)}Ns(G,d);Ns(F,e);m=b+8|0;o=0;g=qa(163,c[m>>2]|0)|0;k=o;o=0;if(k&1)d=cc()|0;else{c[E>>2]=g;o=0;d=qa(162,c[m>>2]|0)|0;k=o;o=0;if(k&1)d=cc()|0;else{c[D>>2]=d;k=(f|0)/2|0;e=c[F>>2]|0;a:while(1){o=0;d=qa(164,e|0)|0;j=o;o=0;if(j&1){b=13;break}if((d|0)<(k|0)){b=53;break}c[A>>2]=0;Ls(A,c[G>>2]|0);c[C>>2]=0;Ls(C,g);Ls(G,e);Ls(E,c[D>>2]|0);j=c[G>>2]|0;o=0;d=qa(165,j|0)|0;h=o;o=0;if(h&1){b=16;break}if(d){b=10;break}Ls(F,c[A>>2]|0);o=0;d=qa(163,c[m>>2]|0)|0;h=o;o=0;if(h&1){b=16;break}c[w>>2]=d;o=0;d=qa(164,j|0)|0;h=o;o=0;if(h&1){b=38;break}o=0;d=Wa(99,j|0,d|0)|0;h=o;o=0;if(h&1){b=38;break}o=0;h=Wa(100,c[m>>2]|0,d|0)|0;f=o;o=0;if(f&1){b=38;break}while(1){e=c[F>>2]|0;o=0;d=qa(164,e|0)|0;f=o;o=0;if(f&1){b=37;break a}o=0;g=qa(164,j|0)|0;f=o;o=0;if(f&1){b=37;break a}if((d|0)<(g|0))break;o=0;d=qa(165,e|0)|0;f=o;o=0;if(f&1){b=37;break a}if(d)break;o=0;d=qa(164,e|0)|0;f=o;o=0;if(f&1){b=37;break a}o=0;g=qa(164,j|0)|0;f=o;o=0;if(f&1){b=37;break a}f=d-g|0;g=c[m>>2]|0;o=0;d=qa(164,e|0)|0;b=o;o=0;if(b&1){b=37;break a}o=0;d=Wa(99,e|0,d|0)|0;b=o;o=0;if(b&1){b=37;break a}o=0;b=ya(110,g|0,d|0,h|0)|0;g=o;o=0;if(g&1){b=37;break a}d=c[w>>2]|0;o=0;g=ya(109,c[m>>2]|0,f|0,b|0)|0;H=o;o=0;if(H&1){b=37;break a}c[q>>2]=g;o=0;d=Wa(101,d|0,q|0)|0;H=o;o=0;if(H&1){b=40;break a}c[l>>2]=d;Ls(w,d);Ms(l);Ms(q);o=0;d=ya(111,j|0,f|0,b|0)|0;H=o;o=0;if(H&1){b=37;break a}c[r>>2]=d;o=0;d=Wa(102,e|0,r|0)|0;H=o;o=0;if(H&1){b=41;break a}c[n>>2]=d;Ls(F,d);Ms(n);Ms(r)}d=c[w>>2]|0;c[v>>2]=0;g=c[E>>2]|0;Ls(v,g);o=0;d=Wa(97,d|0,v|0)|0;H=o;o=0;if(H&1){b=46;break}c[t>>2]=d;c[u>>2]=0;Ls(u,c[C>>2]|0);o=0;d=Wa(102,d|0,u|0)|0;H=o;o=0;if(H&1){b=47;break}c[s>>2]=d;o=0;d=qa(166,d|0)|0;H=o;o=0;if(H&1){b=48;break}c[p>>2]=d;Ls(D,d);Ms(p);Ms(s);Ms(u);Ms(t);Ms(v);Ms(w);Ms(C);Ms(A)}b:switch(b|0){case 10:{d=Ob(8)|0;Kh(d,49280);o=0;mb(55,d|0,256,68);o=0;d=cc()|0;b=17;break}case 13:{d=cc()|0;b=15;break}case 16:{d=cc()|0;b=17;break}case 37:{d=cc()|0;b=39;break}case 38:{d=cc()|0;b=39;break}case 40:{d=cc()|0;Ms(q);b=51;break}case 41:{d=cc()|0;Ms(r);b=51;break}case 46:{d=cc()|0;b=50;break}case 47:{d=cc()|0;b=49;break}case 48:{d=cc()|0;Ms(s);b=49;break}case 53:{g=c[D>>2]|0;o=0;d=Wa(99,g|0,0)|0;H=o;o=0;do if(!(H&1)){if(!d){H=Ob(8)|0;Kh(H,49320);o=0;mb(55,H|0,256,68);o=0;break}o=0;d=Wa(100,c[m>>2]|0,d|0)|0;H=o;o=0;if(!(H&1)?(o=0,x=Wa(103,g|0,d|0)|0,H=o,o=0,!(H&1)):0){c[B>>2]=x;o=0;d=Wa(103,e|0,d|0)|0;H=o;o=0;do if(!(H&1)){c[y>>2]=d;o=0;ma(163,a|0,2);H=o;o=0;if(H&1){d=cc()|0;Ms(y);break}else{Ls(c[a>>2]|0,x);Ls((c[a>>2]|0)+4|0,d);Ms(y);Ms(B);Ms(D);Ms(E);Ms(F);Ms(G);i=z;return}}else d=cc()|0;while(0);Ms(B);break b}}while(0);d=cc()|0;b=15;break}}if((b|0)!=15)if((b|0)==17)b=52;else if((b|0)==39)b=51;else if((b|0)==49){Ms(u);Ms(t);b=50}if((b|0)==50){Ms(v);b=51}if((b|0)==51){Ms(w);b=52}if((b|0)==52){Ms(C);Ms(A)}Ms(D)}Ms(E)}Ms(F);Ms(G);bc(d|0)}function em(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;i=sm(c[d>>2]|0)|0;e=Sz(20)|0;o=0;ma(102,e|0,i|0);h=o;o=0;if(h&1){a=cc()|0;Uz(e);e=a}else{Fq(a,e);f=b+8|0;g=a+8|0;e=0;h=1;while(1){o=0;b=qa(167,c[f>>2]|0)|0;j=o;o=0;if(j&1){b=10;break}if(!((e|0)<(i|0)&(h|0)<(b|0))){b=13;break}o=0;b=Wa(96,c[d>>2]|0,h|0)|0;j=o;o=0;if(j&1){b=10;break}if(!b){o=0;b=Wa(100,c[f>>2]|0,h|0)|0;j=o;o=0;if(j&1){b=10;break}c[(c[(c[g>>2]|0)+8>>2]|0)+(e<<2)>>2]=b;e=e+1|0}h=h+1|0}do if((b|0)==10)e=cc()|0;else if((b|0)==13)if((e|0)==(i|0))return;else{e=Ob(8)|0;Kh(e,49336);o=0;mb(55,e|0,256,68);o=0;e=cc()|0;break}while(0);nq(a)}bc(e|0)}function fm(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;q=i;i=i+32|0;s=q+16|0;r=q+12|0;l=q;k=sm(c[e>>2]|0)|0;g=Sz(20)|0;o=0;ma(102,g|0,k|0);p=o;o=0;if(p&1){s=cc()|0;Uz(g);g=s}else{Fq(s,g);p=b+8|0;h=(c[s+8>>2]|0)+8|0;a:do if((k|0)<1)n=10;else{j=1;while(1){g=c[p>>2]|0;o=0;b=Wa(99,c[e>>2]|0,j|0)|0;n=o;o=0;if(n&1)break;o=0;g=ya(110,g|0,j|0,b|0)|0;n=o;o=0;if(n&1)break;c[(c[h>>2]|0)+(k-j<<2)>>2]=g;j=j+1|0;if((k|0)<(j|0)){n=10;break a}}g=cc()|0;n=9}while(0);do if((n|0)==10){o=0;g=qa(111,24)|0;m=o;o=0;if(m&1){g=cc()|0;n=9;break}m=c[p>>2]|0;mq(l,s);o=0;mb(88,g|0,m|0,l|0);m=o;o=0;if(m&1){r=cc()|0;nq(l);Uz(g);g=r;break}c[r>>2]=0;Ls(r,g);nq(l);f=f+8|0;b=c[f>>2]|0;b=(c[b+12>>2]|0)-(c[b+8>>2]|0)|0;m=b>>2;o=0;g=qa(111,20)|0;l=o;o=0;b:do if(l&1)g=cc()|0;else{o=0;ma(102,g|0,m|0);l=o;o=0;if(l&1){q=cc()|0;Uz(g);g=q;break}Fq(a,g);e=c[r>>2]|0;l=a+8|0;c:do if((b|0)>0){k=0;while(1){o=0;h=Wa(100,c[p>>2]|0,c[(c[(c[f>>2]|0)+8>>2]|0)+(k<<2)>>2]|0)|0;j=o;o=0;if(j&1)break;g=c[p>>2]|0;o=0;b=Wa(96,c[d>>2]|0,h|0)|0;j=o;o=0;if(j&1)break;o=0;j=ya(108,g|0,0,b|0)|0;b=o;o=0;if(b&1)break;b=c[p>>2]|0;o=0;g=Wa(96,e|0,h|0)|0;h=o;o=0;if(h&1)break;o=0;g=Wa(100,b|0,g|0)|0;h=o;o=0;if(h&1)break;o=0;g=ya(110,c[p>>2]|0,j|0,g|0)|0;j=o;o=0;if(j&1)break;c[(c[(c[l>>2]|0)+8>>2]|0)+(k<<2)>>2]=g;k=k+1|0;if((k|0)>=(m|0))break c}g=cc()|0;nq(a);break b}while(0);Ms(r);nq(s);i=q;return}while(0);Ms(r)}while(0);nq(s)}bc(g|0)}function gm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;n=i;i=i+48|0;q=n+36|0;p=n+24|0;l=n+12|0;m=n;c[a+4>>2]=0;c[a>>2]=29772;h=a+8|0;c[h>>2]=0;r=a+12|0;c[a+16>>2]=0;c[r>>2]=29772;j=a+20|0;c[j>>2]=0;s=a+24|0;c[s>>2]=0;Ls(s,0);t=a+28|0;c[t>>2]=0;Ls(t,0);k=a+32|0;c[k>>2]=b;o=0;e=qa(111,20)|0;g=o;o=0;do if(!(g&1)){o=0;ma(102,e|0,b|0);g=o;o=0;if(g&1){q=cc()|0;Uz(e);e=q;break}Hq(a,e);o=0;e=qa(111,20)|0;g=o;o=0;if(!(g&1)){o=0;ma(102,e|0,c[k>>2]|0);g=o;o=0;if(g&1){q=cc()|0;Uz(e);e=q;break}Hq(r,e);e=c[k>>2]|0;if((e|0)>0){f=c[(c[h>>2]|0)+8>>2]|0;g=0;e=1;while(1){c[f+(g<<2)>>2]=e;b=$(e,d)|0;e=c[k>>2]|0;g=g+1|0;if((g|0)>=(e|0))break;else e=(b|0)%(e|0)|0}}if((e|0)>1){f=c[(c[h>>2]|0)+8>>2]|0;e=c[(c[j>>2]|0)+8>>2]|0;b=0;do{c[e+(c[f+(b<<2)>>2]<<2)>>2]=b;b=b+1|0}while((b|0)<((c[k>>2]|0)+-1|0))}o=0;e=qa(111,20)|0;k=o;o=0;if(!(k&1)){o=0;ma(102,e|0,1);k=o;o=0;if(k&1){q=cc()|0;Uz(e);e=q;break}Fq(q,e);o=0;e=qa(111,20)|0;k=o;o=0;do if(k&1)e=cc()|0;else{o=0;ma(102,e|0,1);k=o;o=0;if(k&1){p=cc()|0;Uz(e);e=p;break}Fq(p,e);c[c[(c[q+8>>2]|0)+8>>2]>>2]=0;c[c[(c[p+8>>2]|0)+8>>2]>>2]=1;o=0;e=qa(111,24)|0;k=o;o=0;do if(!(k&1)){mq(l,q);o=0;mb(88,e|0,a|0,l|0);k=o;o=0;if(k&1){n=cc()|0;nq(l);Uz(e);e=n;break}Ls(s,e);nq(l);o=0;e=qa(111,24)|0;l=o;o=0;if(!(l&1)){mq(m,p);o=0;mb(88,e|0,a|0,m|0);l=o;o=0;if(l&1){n=cc()|0;nq(m);Uz(e);e=n;break}else{Ls(t,e);nq(m);nq(p);nq(q);i=n;return}}else u=26}else u=26;while(0);if((u|0)==26)e=cc()|0;nq(p)}while(0);nq(q)}else u=10}else u=10}else u=10;while(0);if((u|0)==10)e=cc()|0;Ms(t);Ms(s);nq(r);nq(a);bc(e|0)}function hm(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;Ns(b,a+24|0);i=d;return c[b>>2]|0}function im(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;Ns(b,a+28|0);i=d;return c[b>>2]|0}function jm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+32|0;e=k+28|0;j=k+16|0;h=k+12|0;g=k;a:do if((b|0)<0){e=Ob(8)|0;o=0;ma(103,e|0,49364);k=o;o=0;if(k&1){k=cc()|0;Nb(e|0);e=k;break}else Hc(e|0,240,66)}else{b:do if(!d)Ns(e,a+24|0);else{f=Sz(20)|0;o=0;ma(102,f|0,b+1|0);b=o;o=0;if(b&1){e=cc()|0;Uz(f);break a}Fq(j,f);c[c[(c[j+8>>2]|0)+8>>2]>>2]=d;o=0;f=qa(111,24)|0;b=o;o=0;do if(!(b&1)){mq(g,j);o=0;mb(88,f|0,a|0,g|0);a=o;o=0;if(a&1){e=cc()|0;nq(g);Uz(f);break}else{c[h>>2]=0;Ls(h,f);nq(g);c[e>>2]=0;Ls(e,c[h>>2]|0);Ms(h);nq(j);break b}}else e=cc()|0;while(0);nq(j);break a}while(0);i=k;return c[e>>2]|0}while(0);bc(e|0);return 0}function km(a,b,d){a=a|0;b=b|0;d=d|0;return (d+b|0)%(c[a+32>>2]|0)|0|0}function lm(a,b,d){a=a|0;b=b|0;d=d|0;a=c[a+32>>2]|0;return (b-d+a|0)%(a|0)|0|0}function mm(a,b){a=a|0;b=b|0;return c[(c[(c[a+8>>2]|0)+8>>2]|0)+(b<<2)>>2]|0}function nm(a,b){a=a|0;b=b|0;if(b)return c[(c[(c[a+20>>2]|0)+8>>2]|0)+(b<<2)>>2]|0;b=Ob(8)|0;o=0;ma(103,b|0,49386);a=o;o=0;if(a&1){a=cc()|0;Nb(b|0);bc(a|0)}else Hc(b|0,240,66);return 0}function om(a,b){a=a|0;b=b|0;if(b)return c[(c[(c[a+8>>2]|0)+8>>2]|0)+((c[a+32>>2]|0)+-1-(c[(c[(c[a+20>>2]|0)+8>>2]|0)+(b<<2)>>2]|0)<<2)>>2]|0;b=Ob(8)|0;o=0;ma(103,b|0,49399);a=o;o=0;if(a&1){a=cc()|0;Nb(b|0);bc(a|0)}else Hc(b|0,240,66);return 0}function pm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;if((b|0)==0|(d|0)==0)b=0;else{e=c[(c[a+20>>2]|0)+8>>2]|0;b=c[(c[(c[a+8>>2]|0)+8>>2]|0)+((((c[e+(d<<2)>>2]|0)+(c[e+(b<<2)>>2]|0)|0)%((c[a+32>>2]|0)+-1|0)|0)<<2)>>2]|0}return b|0}function qm(a){a=a|0;return c[a+32>>2]|0}function rm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0;s=i;i=i+48|0;j=s+32|0;k=s+28|0;m=s+16|0;n=s+12|0;q=s;c[a+4>>2]=0;c[a>>2]=27628;l=a+8|0;c[l>>2]=b;r=a+12|0;c[a+16>>2]=0;c[r>>2]=29772;p=a+20|0;c[p>>2]=0;a=c[d+8>>2]|0;f=c[a+8>>2]|0;e=(c[a+12>>2]|0)-f|0;g=e>>2;a:do if(!g){a=Ob(8)|0;o=0;ma(103,a|0,49416);s=o;o=0;if(s&1){s=cc()|0;Nb(a|0);a=s;break}else{o=0;mb(55,a|0,240,66);o=0;t=4;break}}else{b:do if((e|0)>4?(c[f>>2]|0)==0:0){c:do if((e|0)>4){a=1;while(1){if(c[f+(a<<2)>>2]|0){h=a;break c}a=a+1|0;if((g|0)<=(a|0)){h=a;break}}}else h=1;while(0);if((g|0)==(h|0)){o=0;a=qa(163,b|0)|0;q=o;o=0;if(q&1){t=4;break a}c[k>>2]=a;mq(j,a+12|0);f=c[j+8>>2]|0;e=c[f+12>>2]|0;f=c[f+8>>2]|0;nq(j);Ms(k);o=0;a=qa(111,20)|0;q=o;o=0;if(q&1){t=4;break a}o=0;ma(102,a|0,e-f>>2|0);q=o;o=0;if(q&1){s=cc()|0;Uz(a);a=s;break a}Hq(r,a);e=c[p>>2]|0;o=0;a=qa(163,c[l>>2]|0)|0;q=o;o=0;if(q&1){t=4;break a}c[n>>2]=a;mq(m,a+12|0);o=0;Wa(104,e|0,c[m+8>>2]|0)|0;q=o;o=0;if(q&1){a=cc()|0;nq(m);Ms(n);break a}else{nq(m);Ms(n);break}}mq(q,d);g=g-h|0;o=0;a=qa(111,20)|0;n=o;o=0;do if(n&1)a=cc()|0;else{o=0;ma(102,a|0,g|0);n=o;o=0;if(n&1){s=cc()|0;Uz(a);a=s;break}Hq(r,a);if((g|0)>0){f=c[(c[q+8>>2]|0)+8>>2]|0;a=c[(c[p>>2]|0)+8>>2]|0;e=0;do{c[a+(e<<2)>>2]=c[f+(e+h<<2)>>2];e=e+1|0}while((e|0)<(g|0))}nq(q);break b}while(0);nq(q);break a}else t=29;while(0);if((t|0)==29)Hq(r,a);i=s;return}while(0);if((t|0)==4)a=cc()|0;nq(r);bc(a|0)}function sm(a){a=a|0;a=c[a+20>>2]|0;return ((c[a+12>>2]|0)-(c[a+8>>2]|0)>>2)+-1|0}function tm(a){a=a|0;return (c[c[(c[a+20>>2]|0)+8>>2]>>2]|0)==0|0}function um(a,b){a=a|0;b=b|0;var d=0;d=c[a+20>>2]|0;a=c[d+8>>2]|0;return c[a+(((c[d+12>>2]|0)-a>>2)+~b<<2)>>2]|0}function vm(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;g=a+20|0;f=c[g>>2]|0;d=c[f+8>>2]|0;f=(c[f+12>>2]|0)-d|0;h=f>>2;switch(b|0){case 0:{d=c[d+(h+-1<<2)>>2]|0;break}case 1:{e=a+8|0;if((f|0)>0){a=0;d=0;do{d=km(c[e>>2]|0,d,c[(c[(c[g>>2]|0)+8>>2]|0)+(a<<2)>>2]|0)|0;a=a+1|0}while((a|0)<(h|0))}else d=0;break}default:{d=c[d>>2]|0;e=a+8|0;if((f|0)>4){a=1;do{f=c[e>>2]|0;d=pm(f,b,d)|0;d=km(f,d,c[(c[(c[g>>2]|0)+8>>2]|0)+(a<<2)>>2]|0)|0;a=a+1|0}while((a|0)<(h|0))}}}return d|0}function wm(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;p=i;i=i+64|0;d=p+60|0;s=p+48|0;r=p+36|0;f=p+24|0;q=p+12|0;m=p;n=a+8|0;e=c[b>>2]|0;a:do if((c[n>>2]|0)!=(c[e+8>>2]|0)){d=Ob(8)|0;o=0;ma(103,d|0,49433);s=o;o=0;if(s&1){s=cc()|0;Nb(d|0);d=s;break}else Hc(d|0,240,66)}else{b:do if(!(c[c[(c[a+20>>2]|0)+8>>2]>>2]|0))Ns(d,b);else{if(!(c[c[(c[e+20>>2]|0)+8>>2]>>2]|0)){c[d>>2]=0;Ls(d,a);break}mq(s,a+12|0);mq(r,(c[b>>2]|0)+12|0);a=s+8|0;l=c[a>>2]|0;b=r+8|0;e=c[b>>2]|0;if(((c[l+12>>2]|0)-(c[l+8>>2]|0)|0)>((c[e+12>>2]|0)-(c[e+8>>2]|0)|0)){mq(f,s);Hq(s,e);Hq(r,c[f+8>>2]|0);nq(f)}o=0;e=qa(111,20)|0;l=o;o=0;do if(l&1)d=cc()|0;else{l=c[b>>2]|0;k=l+12|0;l=l+8|0;o=0;ma(102,e|0,(c[k>>2]|0)-(c[l>>2]|0)>>2|0);j=o;o=0;if(j&1){d=cc()|0;Uz(e);break}Fq(q,e);f=c[k>>2]|0;e=c[l>>2]|0;h=c[a>>2]|0;g=h+8|0;h=(f-e>>2)-((c[h+12>>2]|0)-(c[g>>2]|0)>>2)|0;j=(c[q+8>>2]|0)+8|0;if((h|0)>0){b=c[j>>2]|0;a=0;do{c[b+(a<<2)>>2]=c[e+(a<<2)>>2];a=a+1|0}while((a|0)<(h|0))}c:do if((h|0)<(f-e>>2|0)){b=h;while(1){o=0;e=ya(112,c[n>>2]|0,c[(c[g>>2]|0)+(b-h<<2)>>2]|0,c[e+(b<<2)>>2]|0)|0;f=o;o=0;if(f&1)break;c[(c[j>>2]|0)+(b<<2)>>2]=e;b=b+1|0;e=c[l>>2]|0;if((b|0)>=((c[k>>2]|0)-e>>2|0)){b=24;break c}}d=cc()|0;b=21}else b=24;while(0);do if((b|0)==24){o=0;e=qa(111,24)|0;l=o;o=0;if(l&1){d=cc()|0;b=21;break}n=c[n>>2]|0;mq(m,q);o=0;mb(88,e|0,n|0,m|0);n=o;o=0;if(n&1){d=cc()|0;nq(m);Uz(e);break}else{c[d>>2]=0;Ls(d,e);nq(m);nq(q);nq(r);nq(s);break b}}while(0);nq(q)}while(0);nq(r);nq(s);break a}while(0);i=p;return c[d>>2]|0}while(0);bc(d|0);return 0}function xm(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;f=i;i=i+16|0;d=f+4|0;e=f;b=c[b>>2]|0;a:do if((c[a+8>>2]|0)==(c[b+8>>2]|0)){do if(c[c[(c[b+20>>2]|0)+8>>2]>>2]|0){c[e>>2]=ym(b)|0;o=0;b=Wa(101,a|0,e|0)|0;a=o;o=0;if(a&1){b=cc()|0;Ms(e);break a}else{c[d>>2]=b;Ms(e);break}}else{c[d>>2]=0;Ls(d,a);b=c[d>>2]|0}while(0);i=f;return b|0}else{a=Ob(4)|0;o=0;b=qa(111,8)|0;f=o;o=0;do if(!(f&1)){o=0;ma(103,b|0,49433);f=o;o=0;if(f&1){f=cc()|0;Uz(b);b=f;break}else{c[a>>2]=b;Hc(a|0,896,0)}}else b=cc()|0;while(0);Nb(a|0)}while(0);bc(b|0);return 0}function ym(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0;l=i;i=i+32|0;j=l+24|0;m=l+12|0;k=l;h=a+20|0;d=c[h>>2]|0;d=(c[d+12>>2]|0)-(c[d+8>>2]|0)|0;f=d>>2;b=Sz(20)|0;o=0;ma(102,b|0,f|0);g=o;o=0;if(g&1){m=cc()|0;Uz(b);b=m}else{Fq(m,b);g=a+8|0;e=(c[m+8>>2]|0)+8|0;a:do if((d|0)>0){a=0;while(1){o=0;b=ya(108,c[g>>2]|0,0,c[(c[(c[h>>2]|0)+8>>2]|0)+(a<<2)>>2]|0)|0;d=o;o=0;if(d&1)break;c[(c[e>>2]|0)+(a<<2)>>2]=b;a=a+1|0;if((a|0)>=(f|0)){a=9;break a}}b=cc()|0;a=8}else a=9;while(0);do if((a|0)==9){o=0;b=qa(111,24)|0;h=o;o=0;if(h&1){b=cc()|0;a=8;break}h=c[g>>2]|0;mq(k,m);o=0;mb(88,b|0,h|0,k|0);h=o;o=0;if(h&1){l=cc()|0;nq(k);Uz(b);b=l;break}else{c[j>>2]=0;Ls(j,b);nq(k);nq(m);i=l;return c[j>>2]|0}}while(0);nq(m)}bc(b|0);return 0}function zm(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;t=i;i=i+64|0;q=t+48|0;v=t+36|0;w=t+24|0;u=t+12|0;r=t;s=a+8|0;e=c[s>>2]|0;d=c[b>>2]|0;a:do if((e|0)==(c[d+8>>2]|0)){b:do if((c[c[(c[a+20>>2]|0)+8>>2]>>2]|0)!=0?(c[c[(c[d+20>>2]|0)+8>>2]>>2]|0)!=0:0){mq(v,a+12|0);e=c[v+8>>2]|0;n=e+8|0;e=(c[e+12>>2]|0)-(c[n>>2]|0)|0;p=e>>2;mq(w,(c[b>>2]|0)+12|0);a=c[w+8>>2]|0;l=a+8|0;a=(c[a+12>>2]|0)-(c[l>>2]|0)|0;m=a>>2;o=0;d=qa(111,20)|0;k=o;o=0;do if(k&1)d=cc()|0;else{o=0;ma(102,d|0,p+-1+m|0);k=o;o=0;if(k&1){u=cc()|0;Uz(d);d=u;break}Fq(u,d);k=(c[u+8>>2]|0)+8|0;c:do if((e|0)>0){b=(a|0)>0;h=0;d:while(1){f=c[(c[n>>2]|0)+(h<<2)>>2]|0;if(b){j=0;do{d=c[s>>2]|0;g=j+h|0;a=c[(c[k>>2]|0)+(g<<2)>>2]|0;o=0;e=ya(110,d|0,f|0,c[(c[l>>2]|0)+(j<<2)>>2]|0)|0;x=o;o=0;if(x&1)break d;o=0;d=ya(112,d|0,a|0,e|0)|0;x=o;o=0;if(x&1)break d;c[(c[k>>2]|0)+(g<<2)>>2]=d;j=j+1|0}while((j|0)<(m|0))}h=h+1|0;if((h|0)>=(p|0)){a=25;break c}}d=cc()|0;a=23}else a=25;while(0);do if((a|0)==25){o=0;d=qa(111,24)|0;x=o;o=0;if(x&1){d=cc()|0;a=23;break}x=c[s>>2]|0;mq(r,u);o=0;mb(88,d|0,x|0,r|0);x=o;o=0;if(x&1){x=cc()|0;nq(r);Uz(d);d=x;break}else{c[q>>2]=0;Ls(q,d);nq(r);nq(u);nq(w);nq(v);d=c[q>>2]|0;break b}}while(0);nq(u)}while(0);nq(w);nq(v);break a}else a=10;while(0);if((a|0)==10){d=hm(e)|0;c[q>>2]=d}i=t;return d|0}else{a=Ob(4)|0;o=0;d=qa(111,8)|0;x=o;o=0;do if(!(x&1)){o=0;ma(103,d|0,49433);x=o;o=0;if(x&1){x=cc()|0;Uz(d);d=x;break}else{c[a>>2]=d;Hc(a|0,896,0)}}else d=cc()|0;while(0);Nb(a|0)}while(0);bc(d|0);return 0}function Am(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;m=i;i=i+32|0;d=m+24|0;n=m+12|0;l=m;a:do switch(b|0){case 0:{c[d>>2]=hm(c[a+8>>2]|0)|0;break}case 1:{c[d>>2]=0;Ls(d,a);break}default:{k=a+20|0;f=c[k>>2]|0;f=(c[f+12>>2]|0)-(c[f+8>>2]|0)|0;h=f>>2;e=Sz(20)|0;o=0;ma(102,e|0,h|0);j=o;o=0;if(j&1){d=cc()|0;Uz(e)}else{Fq(n,e);j=a+8|0;g=(c[n+8>>2]|0)+8|0;b:do if((f|0)>0){a=0;while(1){o=0;e=ya(110,c[j>>2]|0,c[(c[(c[k>>2]|0)+8>>2]|0)+(a<<2)>>2]|0,b|0)|0;f=o;o=0;if(f&1)break;c[(c[g>>2]|0)+(a<<2)>>2]=e;a=a+1|0;if((a|0)>=(h|0)){a=12;break b}}d=cc()|0;a=11}else a=12;while(0);do if((a|0)==12){o=0;e=qa(111,24)|0;b=o;o=0;if(b&1){d=cc()|0;a=11;break}b=c[j>>2]|0;mq(l,n);o=0;mb(88,e|0,b|0,l|0);b=o;o=0;if(b&1){d=cc()|0;nq(l);Uz(e);break}else{c[d>>2]=0;Ls(d,e);nq(l);nq(n);break a}}while(0);nq(n)}bc(d|0)}}while(0);i=m;return c[d>>2]|0}function Bm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;m=i;i=i+32|0;k=m+24|0;n=m+12|0;l=m;a:do if((b|0)<0){b=Ob(4)|0;o=0;e=qa(111,8)|0;n=o;o=0;do if(!(n&1)){o=0;ma(103,e|0,49479);n=o;o=0;if(n&1){n=cc()|0;Uz(e);e=n;break}else{c[b>>2]=e;Hc(b|0,896,0)}}else e=cc()|0;while(0);Nb(b|0)}else{b:do if(!d){e=hm(c[a+8>>2]|0)|0;c[k>>2]=e}else{h=a+20|0;f=c[h>>2]|0;f=(c[f+12>>2]|0)-(c[f+8>>2]|0)|0;j=f>>2;e=Sz(20)|0;o=0;ma(102,e|0,j+b|0);g=o;o=0;if(g&1){n=cc()|0;Uz(e);e=n;break a}Fq(n,e);g=a+8|0;a=(c[n+8>>2]|0)+8|0;c:do if((f|0)>0){b=0;while(1){o=0;e=ya(110,c[g>>2]|0,c[(c[(c[h>>2]|0)+8>>2]|0)+(b<<2)>>2]|0,d|0)|0;f=o;o=0;if(f&1)break;c[(c[a>>2]|0)+(b<<2)>>2]=e;b=b+1|0;if((b|0)>=(j|0)){b=18;break c}}e=cc()|0;b=17}else b=18;while(0);do if((b|0)==18){o=0;e=qa(111,24)|0;d=o;o=0;if(d&1){e=cc()|0;b=17;break}d=c[g>>2]|0;mq(l,n);o=0;mb(88,e|0,d|0,l|0);d=o;o=0;if(d&1){m=cc()|0;nq(l);Uz(e);e=m;break}else{c[k>>2]=0;Ls(k,e);nq(l);nq(n);e=c[k>>2]|0;break b}}while(0);nq(n);break a}while(0);i=m;return e|0}while(0);bc(e|0);return 0}function Cm(a){a=a|0;c[a>>2]=27628;nq(a+12|0);return}function Dm(a){a=a|0;c[a>>2]=27628;nq(a+12|0);Uz(a);return}function Em(a,b){a=a|0;b=b|0;_d(a,b);return}function Fm(a,b){a=a|0;b=b|0;var d=0,e=0.0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0;s=i;i=i+112|0;n=s+96|0;x=s+92|0;w=s+80|0;b=s+76|0;f=s+64|0;g=s+60|0;k=s+56|0;h=s+52|0;v=s+48|0;u=s+44|0;l=s+32|0;p=s+28|0;t=s+16|0;q=s+12|0;r=s;j=Kf(c[a>>2]|0)|0;c[x>>2]=j;c[b>>2]=0;Ke(b,j);o=0;mb(90,w|0,b|0,8);d=o;o=0;if(d&1){y=cc()|0;Yd(b);b=y}else{Yd(b);d=w+8|0;b=c[d>>2]|0;do if(!b){c[g>>2]=0;Ke(g,j);o=0;mb(91,f|0,g|0,8);h=o;o=0;if(h&1){b=cc()|0;Yd(g);break}Te(w,c[f+8>>2]|0);pe(f);Yd(g);b=c[d>>2]|0;if(!b){y=Ob(8)|0;zq(y,49496);c[y>>2]=30552;o=0;mb(55,y|0,856,146);o=0;y=8;break}c[k>>2]=0;Ke(k,j);o=0;mb(92,k|0,w|0,1);j=o;o=0;if(j&1){b=cc()|0;Yd(k);break}else{Yd(k);y=15;break}}else{c[h>>2]=0;Ke(h,j);o=0;mb(92,h|0,w|0,0);k=o;o=0;if(k&1){b=cc()|0;Yd(h);break}else{Yd(h);y=15;break}}while(0);do if((y|0)==15){o=0;e=+Ka(45,w|0);k=o;o=0;if(!(k&1)){if(e<1.0){y=Ob(8)|0;zq(y,49515);c[y>>2]=30552;o=0;mb(55,y|0,856,146);o=0;y=8;break}f=b+8|0;d=c[f>>2]|0;o=0;d=sb(46,d+48|0,d+56|0,d+52|0,d+60|0,+e)|0;k=o;o=0;if(!(k&1)){if((d|0)<1){y=Ob(8)|0;zq(y,49533);c[y>>2]=30552;o=0;mb(55,y|0,856,146);o=0;y=8;break}b=c[f>>2]|0;o=0;b=ga(44,0,b+48|0,b+56|0,b+52|0,b+60|0,+e)|0;k=o;o=0;if(!(k&1)?(o=0,m=kb(61,a|0,w|0,d|0,((b|0)<(d|0)?d:b)|0)|0,a=o,o=0,!(a&1)):0){c[v>>2]=m;c[p>>2]=0;Ke(p,m);o=0;mb(93,l|0,p|0,d|0);a=o;o=0;do if(a&1){b=cc()|0;y=31}else{o=0;d=qa(168,l|0)|0;a=o;o=0;if(a&1){b=cc()|0;Yd(l);y=31;break}c[u>>2]=d;Yd(l);Yd(p);o=0;ma(147,t|0,4);p=o;o=0;if(p&1)b=cc()|0;else{b=(c[t+8>>2]|0)+8|0;vq(c[b>>2]|0,c[(c[f>>2]|0)+20>>2]|0);vq((c[b>>2]|0)+4|0,c[(c[f>>2]|0)+16>>2]|0);vq((c[b>>2]|0)+8|0,c[(c[f>>2]|0)+24>>2]|0);vq((c[b>>2]|0)+12|0,c[(c[f>>2]|0)+28>>2]|0);o=0;b=qa(111,24)|0;p=o;o=0;do if(!(p&1)){c[q>>2]=0;Ke(q,d);oe(r,t);o=0;mb(52,b|0,q|0,r|0);p=o;o=0;if(p&1){s=cc()|0;pe(r);Yd(q);Uz(b);b=s;break}else{c[n>>2]=0;Hr(n,b);pe(r);Yd(q);pe(t);Yd(u);Yd(v);pe(w);Yd(x);i=s;return c[n>>2]|0}}else b=cc()|0;while(0);pe(t)}Yd(u)}while(0);if((y|0)==31)Yd(p);Yd(v)}else y=8}else y=8}else y=8}while(0);if((y|0)==8)b=cc()|0;pe(w)}Yd(x);bc(b|0);return 0}function Gm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0.0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;w=i;i=i+96|0;A=w+76|0;y=w+64|0;l=w+52|0;g=w+48|0;p=w+36|0;m=w+32|0;t=w+20|0;r=w+16|0;x=w+4|0;u=w;s=jg(c[b>>2]|0)|0;v=ig(c[b>>2]|0)|0;ns(A,16);o=0;e=qa(111,20)|0;n=o;o=0;do if(n&1)e=cc()|0;else{o=0;ma(102,e|0,8);n=o;o=0;if(n&1){z=cc()|0;Uz(e);e=z;break}Fq(y,e);e=l+8|0;a:do if((s|0)>0){h=0;while(1){Zp(g,b);o=0;Sa(42,l|0,g|0,0,h|0,v|0,0,27636,8,y|0);n=o;o=0;if(n&1){z=13;break}Yd(g);f=c[e>>2]|0;if(f)break;nq(l);h=h+d|0;if((h|0)>=(s|0)){f=0;z=34;break a}}if((z|0)==13){e=cc()|0;Yd(g);break}n=(c[A+8>>2]|0)+8|0;e=c[n>>2]|0;o=0;g=qa(111,16)|0;k=o;o=0;do if(!(k&1)){k=f+8|0;j=+(h|0);o=0;wa(42,g|0,+(+(c[c[k>>2]>>2]|0)),+j);h=o;o=0;if(h&1){e=cc()|0;Uz(g);break}vq(e,g);e=(c[n>>2]|0)+16|0;o=0;f=qa(111,16)|0;h=o;o=0;if(!(h&1)){o=0;wa(42,f|0,+(+(c[(c[k>>2]|0)+4>>2]|0)),+j);k=o;o=0;if(k&1){e=cc()|0;Uz(f);break}vq(e,f);nq(l);e=p+8|0;if((s|0)<=1){f=0;z=34;break a}g=s+-1|0;while(1){Zp(m,b);o=0;Sa(42,p|0,m|0,0,g|0,v|0,0,27636,8,y|0);l=o;o=0;if(l&1){z=27;break}Yd(m);f=c[e>>2]|0;if(f)break;nq(p);g=g-d|0;if((g|0)<=0){f=0;z=34;break a}}if((z|0)==27){e=cc()|0;Yd(m);break a}e=(c[n>>2]|0)+4|0;o=0;h=qa(111,16)|0;m=o;o=0;do if(!(m&1)){k=f+8|0;j=+(g|0);o=0;wa(42,h|0,+(+(c[c[k>>2]>>2]|0)),+j);m=o;o=0;if(m&1){e=cc()|0;Uz(h);break}vq(e,h);e=(c[n>>2]|0)+20|0;o=0;f=qa(111,16)|0;n=o;o=0;if(!(n&1)){o=0;wa(42,f|0,+(+(c[(c[k>>2]|0)+4>>2]|0)),+j);n=o;o=0;if(n&1){e=cc()|0;Uz(f);break}else{vq(e,f);nq(p);f=1;z=34;break a}}else z=28}else z=28;while(0);if((z|0)==28)e=cc()|0;nq(p);break a}else z=14}else z=14;while(0);if((z|0)==14)e=cc()|0;nq(l)}else{f=0;z=34}while(0);b:do if((z|0)==34){o=0;e=qa(111,20)|0;p=o;o=0;if(p&1){e=cc()|0;break}o=0;ma(102,e|0,9);p=o;o=0;if(p&1){z=cc()|0;Uz(e);e=z;break}Hq(y,e);c:do if(f?(q=t+8|0,(s|0)>0):0){f=0;while(1){Zp(r,b);o=0;Sa(42,t|0,r|0,0,f|0,v|0,0,27700,9,y|0);p=o;o=0;if(p&1){z=45;break}Yd(r);e=c[q>>2]|0;if(e)break;nq(t);f=f+d|0;if((f|0)>=(s|0)){z=66;break c}}if((z|0)==45){e=cc()|0;Yd(r);break b}l=(c[A+8>>2]|0)+8|0;g=(c[l>>2]|0)+8|0;o=0;h=qa(111,16)|0;r=o;o=0;do if(!(r&1)){k=e+8|0;j=+(f|0);o=0;wa(42,h|0,+(+(c[(c[k>>2]|0)+4>>2]|0)),+j);r=o;o=0;if(r&1){e=cc()|0;Uz(h);break}vq(g,h);e=(c[l>>2]|0)+24|0;o=0;f=qa(111,16)|0;r=o;o=0;if(!(r&1)){o=0;wa(42,f|0,+(+(c[c[k>>2]>>2]|0)),+j);r=o;o=0;if(r&1){e=cc()|0;Uz(f);break}vq(e,f);nq(t);g=x+8|0;if((s|0)<=1){z=66;break c}f=s+-1|0;while(1){Zp(u,b);o=0;Sa(42,x|0,u|0,0,f|0,v|0,0,27700,9,y|0);t=o;o=0;if(t&1){z=59;break}Yd(u);e=c[g>>2]|0;if(e)break;nq(x);f=f-d|0;if((f|0)<=0){z=66;break c}}if((z|0)==59){e=cc()|0;Yd(u);break b}g=(c[l>>2]|0)+12|0;o=0;h=qa(111,16)|0;d=o;o=0;do if(!(d&1)){k=e+8|0;j=+(f|0);o=0;wa(42,h|0,+(+(c[(c[k>>2]|0)+4>>2]|0)),+j);d=o;o=0;if(d&1){e=cc()|0;Uz(h);break}vq(g,h);e=(c[l>>2]|0)+28|0;o=0;f=qa(111,16)|0;d=o;o=0;if(!(d&1)){o=0;wa(42,f|0,+(+(c[c[k>>2]>>2]|0)),+j);d=o;o=0;if(d&1){e=cc()|0;Uz(f);break}else{vq(e,f);nq(x);oe(a,A);break c}}else z=60}else z=60;while(0);if((z|0)==60)e=cc()|0;nq(x);break b}else z=46}else z=46;while(0);if((z|0)==46)e=cc()|0;nq(t);break b}else z=66;while(0);if((z|0)==66){c[a+4>>2]=0;c[a>>2]=4116;c[a+8>>2]=0}nq(y);pe(A);i=w;return}while(0);nq(y)}while(0);pe(A);bc(e|0)}function Hm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0.0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;x=i;i=i+96|0;B=x+76|0;z=x+64|0;l=x+52|0;g=x+48|0;q=x+36|0;m=x+32|0;t=x+20|0;s=x+16|0;y=x+4|0;u=x;v=jg(c[b>>2]|0)|0;w=(ig(c[b>>2]|0)|0)>>1;ns(B,16);o=0;e=qa(111,20)|0;p=o;o=0;do if(p&1)e=cc()|0;else{o=0;ma(102,e|0,8);p=o;o=0;if(p&1){A=cc()|0;Uz(e);e=A;break}Fq(z,e);p=v+-1|0;e=l+8|0;a:do if((v|0)>1){h=p;while(1){Zp(g,b);o=0;Sa(42,l|0,g|0,w|0,h|0,w|0,1,27668,8,z|0);n=o;o=0;if(n&1){A=13;break}Yd(g);f=c[e>>2]|0;if(f)break;nq(l);h=h-d|0;if((h|0)<=0){f=0;A=33;break a}}if((A|0)==13){e=cc()|0;Yd(g);break}n=(c[B+8>>2]|0)+8|0;e=c[n>>2]|0;o=0;g=qa(111,16)|0;k=o;o=0;do if(!(k&1)){k=f+8|0;j=+(h|0);o=0;wa(42,g|0,+(+(c[(c[k>>2]|0)+4>>2]|0)),+j);h=o;o=0;if(h&1){e=cc()|0;Uz(g);break}vq(e,g);e=(c[n>>2]|0)+16|0;o=0;f=qa(111,16)|0;h=o;o=0;if(!(h&1)){o=0;wa(42,f|0,+(+(c[c[k>>2]>>2]|0)),+j);k=o;o=0;if(k&1){e=cc()|0;Uz(f);break}vq(e,f);nq(l);e=q+8|0;if((v|0)>0)g=0;else{f=0;A=33;break a}while(1){Zp(m,b);o=0;Sa(42,q|0,m|0,w|0,g|0,w|0,1,27668,8,z|0);l=o;o=0;if(l&1){A=26;break}Yd(m);f=c[e>>2]|0;if(f)break;nq(q);g=g+d|0;if((g|0)>=(v|0)){f=0;A=33;break a}}if((A|0)==26){e=cc()|0;Yd(m);break a}e=(c[n>>2]|0)+4|0;o=0;h=qa(111,16)|0;m=o;o=0;do if(!(m&1)){k=f+8|0;j=+(g|0);o=0;wa(42,h|0,+(+(c[(c[k>>2]|0)+4>>2]|0)),+j);m=o;o=0;if(m&1){e=cc()|0;Uz(h);break}vq(e,h);e=(c[n>>2]|0)+20|0;o=0;f=qa(111,16)|0;n=o;o=0;if(!(n&1)){o=0;wa(42,f|0,+(+(c[c[k>>2]>>2]|0)),+j);n=o;o=0;if(n&1){e=cc()|0;Uz(f);break}else{vq(e,f);nq(q);f=1;A=33;break a}}else A=27}else A=27;while(0);if((A|0)==27)e=cc()|0;nq(q);break a}else A=14}else A=14;while(0);if((A|0)==14)e=cc()|0;nq(l)}else{f=0;A=33}while(0);b:do if((A|0)==33){o=0;e=qa(111,20)|0;q=o;o=0;if(q&1){e=cc()|0;break}o=0;ma(102,e|0,9);q=o;o=0;if(q&1){A=cc()|0;Uz(e);e=A;break}Hq(z,e);c:do if(f?(r=t+8|0,(v|0)>1):0){f=p;while(1){Zp(s,b);o=0;Sa(42,t|0,s|0,0,f|0,w|0,0,27736,9,z|0);q=o;o=0;if(q&1){A=44;break}Yd(s);e=c[r>>2]|0;if(e)break;nq(t);f=f-d|0;if((f|0)<=0){A=64;break c}}if((A|0)==44){e=cc()|0;Yd(s);break b}l=(c[B+8>>2]|0)+8|0;g=(c[l>>2]|0)+8|0;o=0;h=qa(111,16)|0;s=o;o=0;do if(!(s&1)){k=e+8|0;j=+(f|0);o=0;wa(42,h|0,+(+(c[c[k>>2]>>2]|0)),+j);s=o;o=0;if(s&1){e=cc()|0;Uz(h);break}vq(g,h);e=(c[l>>2]|0)+24|0;o=0;f=qa(111,16)|0;s=o;o=0;if(!(s&1)){o=0;wa(42,f|0,+(+(c[(c[k>>2]|0)+4>>2]|0)),+j);s=o;o=0;if(s&1){e=cc()|0;Uz(f);break}vq(e,f);nq(t);g=y+8|0;if((v|0)>0)f=0;else{A=64;break c}while(1){Zp(u,b);o=0;Sa(42,y|0,u|0,0,f|0,w|0,0,27736,9,z|0);t=o;o=0;if(t&1){A=57;break}Yd(u);e=c[g>>2]|0;if(e)break;nq(y);f=f+d|0;if((f|0)>=(v|0)){A=64;break c}}if((A|0)==57){e=cc()|0;Yd(u);break b}g=(c[l>>2]|0)+12|0;o=0;h=qa(111,16)|0;d=o;o=0;do if(!(d&1)){k=e+8|0;j=+(f|0);o=0;wa(42,h|0,+(+(c[c[k>>2]>>2]|0)),+j);d=o;o=0;if(d&1){e=cc()|0;Uz(h);break}vq(g,h);e=(c[l>>2]|0)+28|0;o=0;f=qa(111,16)|0;d=o;o=0;if(!(d&1)){o=0;wa(42,f|0,+(+(c[(c[k>>2]|0)+4>>2]|0)),+j);d=o;o=0;if(d&1){e=cc()|0;Uz(f);break}else{vq(e,f);nq(y);oe(a,B);break c}}else A=58}else A=58;while(0);if((A|0)==58)e=cc()|0;nq(y);break b}else A=45}else A=45;while(0);if((A|0)==45)e=cc()|0;nq(t);break b}else A=64;while(0);if((A|0)==64){c[a+4>>2]=0;c[a>>2]=4116;c[a+8>>2]=0}nq(z);pe(B);i=x;return}while(0);nq(z)}while(0);pe(B);bc(e|0)}function Im(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0.0,m=0,n=0;k=i;i=i+16|0;e=k+12|0;f=k+8|0;g=k+4|0;h=k;j=b+8|0;m=c[(c[(c[j>>2]|0)+8>>2]|0)+16>>2]|0;l=+ld[c[(c[m>>2]|0)+12>>2]&63](m);m=c[(c[(c[j>>2]|0)+8>>2]|0)+20>>2]|0;m=+O(+(l-+ld[c[(c[m>>2]|0)+12>>2]&63](m)))<20.0;n=c[(c[(c[j>>2]|0)+8>>2]|0)+24>>2]|0;l=+ld[c[(c[n>>2]|0)+12>>2]&63](n);j=c[(c[(c[j>>2]|0)+8>>2]|0)+28>>2]|0;if(m|+O(+(l-+ld[c[(c[j>>2]|0)+12>>2]&63](j)))<20.0){n=Ob(8)|0;zq(n,49548);c[n>>2]=30552;Hc(n|0,856,146)}Zp(e,a);j=d?1:-1;o=0;Oa(44,e|0,b|0,0,0,8,17,j|0);n=o;o=0;do if(!(n&1)){Yd(e);Zp(f,a);e=d?-1:1;o=0;Oa(44,f|0,b|0,1,0,8,17,e|0);n=o;o=0;if(n&1){e=cc()|0;Yd(f);break}Yd(f);Zp(g,a);o=0;Oa(44,g|0,b|0,2,11,7,18,j|0);n=o;o=0;if(n&1){e=cc()|0;Yd(g);break}Yd(g);Zp(h,a);o=0;Oa(44,h|0,b|0,3,11,7,18,e|0);n=o;o=0;if(n&1){e=cc()|0;Yd(h);break}else{Yd(h);Qm(b,12,4,5,8,10,a);Qm(b,13,4,5,9,11,a);Qm(b,14,6,7,8,10,a);Qm(b,15,6,7,9,11,a);i=k;return}}else{n=cc()|0;Yd(e);e=n}while(0);bc(e|0)}function Jm(a){a=a|0;var b=0.0,d=0.0,e=0,f=0,g=0.0,h=0,j=0,k=0.0,l=0,m=0,n=0,p=0,q=0,r=0;q=i;i=i+32|0;e=q+28|0;f=q+24|0;h=q+20|0;j=q+16|0;l=q+12|0;m=q+8|0;n=q+4|0;p=q;a=a+8|0;tq(e,c[(c[a>>2]|0)+8>>2]|0);tq(f,(c[(c[a>>2]|0)+8>>2]|0)+16|0);o=0;k=+eb(42,e|0,f|0);r=o;o=0;do if(!(r&1)){uq(f);uq(e);tq(h,(c[(c[a>>2]|0)+8>>2]|0)+4|0);tq(j,(c[(c[a>>2]|0)+8>>2]|0)+20|0);o=0;g=+eb(42,h|0,j|0);r=o;o=0;if(r&1){a=cc()|0;uq(j);uq(h);break}uq(j);uq(h);tq(l,(c[(c[a>>2]|0)+8>>2]|0)+24|0);tq(m,(c[(c[a>>2]|0)+8>>2]|0)+8|0);o=0;d=+eb(42,l|0,m|0);r=o;o=0;if(r&1){a=cc()|0;uq(m);uq(l);break}uq(m);uq(l);tq(n,(c[(c[a>>2]|0)+8>>2]|0)+28|0);tq(p,(c[(c[a>>2]|0)+8>>2]|0)+12|0);o=0;b=+eb(42,n|0,p|0);r=o;o=0;if(r&1){a=cc()|0;uq(p);uq(n);break}else{uq(p);uq(n);i=q;return +(((d+b)/36.0+(k+g)/34.0)*.5)}}else{a=cc()|0;uq(f);uq(e)}while(0);bc(a|0);return 0.0}function Km(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;var f=0.0,g=0.0,h=0,j=0,k=0,l=0,m=0;m=i;i=i+16|0;h=m+12|0;j=m+8|0;k=m+4|0;l=m;tq(h,a);tq(j,b);o=0;g=+eb(42,h|0,j|0);b=o;o=0;do if(!(b&1)){uq(j);uq(h);tq(k,c);tq(l,d);o=0;f=+eb(42,k|0,l|0);d=o;o=0;if(d&1){a=cc()|0;uq(l);uq(k);break}else{uq(l);uq(k);l=(~~(f/e+.5)+~~(g/e+.5)>>1)+8|0;i=m;return l-((l|0)%17|0)|0}}else{a=cc()|0;uq(j);uq(h)}while(0);bc(a|0);return 0}function Lm(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;var g=0.0,h=0.0,j=0,k=0,l=0,m=0;m=i;i=i+16|0;a=m+12|0;j=m+8|0;k=m+4|0;l=m;tq(a,b);tq(j,d);o=0;h=+eb(42,a|0,j|0);b=o;o=0;do if(!(b&1)){uq(j);uq(a);tq(k,c);tq(l,e);o=0;g=+eb(42,k|0,l|0);c=o;o=0;if(c&1){a=cc()|0;uq(l);uq(k);break}else{uq(l);uq(k);i=m;return ~~(g/f+.5)+~~(h/f+.5)>>1|0}}else{m=cc()|0;uq(j);uq(a);a=m}while(0);bc(a|0);return 0}function Mm(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0.0,q=0.0,r=0.0,s=0.0,t=0.0,u=0.0,v=0.0,w=0.0,x=0.0;l=i;i=i+16|0;m=l+8|0;j=l+4|0;k=l;g=e<<3;f=d<<2;x=+(g|0);w=+(f|0);e=b+8|0;d=c[(c[(c[e>>2]|0)+8>>2]|0)+48>>2]|0;v=+ld[c[(c[d>>2]|0)+8>>2]&63](d);d=c[(c[(c[e>>2]|0)+8>>2]|0)+48>>2]|0;u=+ld[c[(c[d>>2]|0)+12>>2]&63](d);d=c[(c[(c[e>>2]|0)+8>>2]|0)+56>>2]|0;t=+ld[c[(c[d>>2]|0)+8>>2]&63](d);d=c[(c[(c[e>>2]|0)+8>>2]|0)+56>>2]|0;s=+ld[c[(c[d>>2]|0)+12>>2]&63](d);d=c[(c[(c[e>>2]|0)+8>>2]|0)+52>>2]|0;r=+ld[c[(c[d>>2]|0)+8>>2]&63](d);d=c[(c[(c[e>>2]|0)+8>>2]|0)+52>>2]|0;q=+ld[c[(c[d>>2]|0)+12>>2]&63](d);d=c[(c[(c[e>>2]|0)+8>>2]|0)+60>>2]|0;p=+ld[c[(c[d>>2]|0)+8>>2]&63](d);e=c[(c[(c[e>>2]|0)+8>>2]|0)+60>>2]|0;e=bh(0.0,0.0,x,0.0,0.0,w,x,w,v,u,t,s,r,q,p,+ld[c[(c[e>>2]|0)+12>>2]&63](e))|0;c[m>>2]=e;o=0;d=gb(43)|0;b=o;o=0;do if(!(b&1)?(o=0,h=qa(150,c[a>>2]|0)|0,a=o,o=0,!(a&1)):0){c[j>>2]=h;c[k>>2]=0;Zq(k,e);o=0;e=Ya(68,d|0,j|0,g|0,f|0,k|0)|0;a=o;o=0;if(a&1){e=cc()|0;_q(k);Yd(j);break}else{_q(k);Yd(j);_q(m);i=l;return e|0}}else n=5;while(0);if((n|0)==5)e=cc()|0;_q(m);bc(e|0);return 0}
function py(a){a=a|0;Uz(a);return}function qy(a){a=a|0;c[a>>2]=30572;pe(a+12|0);Yd(a+8|0);return}function ry(a){a=a|0;qy(a);Uz(a);return}function sy(a){a=a|0;Aq(a);Uz(a);return}function ty(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;a=b;b=c[d>>2]|0;do{c[b>>2]=0;vq(b,0);b=(c[d>>2]|0)+4|0;c[d>>2]=b;a=a+-1|0}while((a|0)!=0);return}function uy(a){a=a|0;Uq(a);Uz(a);return}function vy(a){a=a|0;c[a>>2]=30520;IC(a+36|0);Uq(a+24|0);ne(a+20|0);Sd(a+8|0);return}function wy(a){a=a|0;vy(a);Uz(a);return}function xy(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0;b=b+4|0;f=c[b>>2]|0;do if(f){j=a[e>>0]|0;i=(j&1)==0;j=i?(j&255)>>>1:c[e+4>>2]|0;i=i?e+1|0:c[e+8>>2]|0;while(1){e=f+16|0;b=a[e>>0]|0;g=(b&1)==0;b=g?(b&255)>>>1:c[f+20>>2]|0;e=g?e+1|0:c[f+24>>2]|0;g=b>>>0<j>>>0;k=bC(i,e,g?b:j)|0;h=j>>>0<b>>>0;if((((k|0)==0?(h?-2147483648:0):k)|0)<0){b=c[f>>2]|0;if(!b){b=f;e=5;break}}else{k=bC(e,i,h?j:b)|0;if((((k|0)==0?(g?-2147483648:0):k)|0)>=0){b=f;e=10;break}b=f+4|0;e=c[b>>2]|0;if(!e){e=9;break}else b=e}f=b}if((e|0)==5){c[d>>2]=f;break}else if((e|0)==9){c[d>>2]=f;break}else if((e|0)==10){c[d>>2]=b;b=d;break}}else c[d>>2]=b;while(0);return b|0}function yy(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=b;c[d>>2]=e;b=c[a>>2]|0;if(c[b>>2]|0){c[a>>2]=c[b>>2];e=c[d>>2]|0}kw(c[a+4>>2]|0,e);a=a+8|0;c[a>>2]=(c[a>>2]|0)+1;return}function zy(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;g=Sz(32)|0;c[b>>2]=g;c[b+4>>2]=d+4;f=b+8|0;a[f>>0]=0;d=b+9|0;a[d>>0]=0;g=g+16|0;c[g>>2]=c[e>>2];c[g+4>>2]=c[e+4>>2];c[g+8>>2]=c[e+8>>2];c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=0;a[f>>0]=1;b=(c[b>>2]|0)+28|0;c[b>>2]=0;Oq(b,0);a[d>>0]=1;return}function Ay(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;a=a+4|0;e=c[a>>2]|0;do if(e){f=c[d>>2]|0;while(1){a=c[e+16>>2]|0;if((f|0)<(a|0)){a=c[e>>2]|0;if(!a){a=e;d=5;break}}else{if((a|0)>=(f|0)){a=e;d=10;break}a=e+4|0;d=c[a>>2]|0;if(!d){d=9;break}else a=d}e=a}if((d|0)==5){c[b>>2]=e;break}else if((d|0)==9){c[b>>2]=e;break}else if((d|0)==10){c[b>>2]=a;a=b;break}}else c[b>>2]=a;while(0);return a|0}function By(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;e=Sz(24)|0;c[e+16>>2]=c[d>>2];d=e+20|0;c[d>>2]=0;Oq(d,0);c[a>>2]=e;a=a+4|0;c[a>>2]=b+4;c[a+4>>2]=257;return}function Cy(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=b;c[d>>2]=e;b=c[a>>2]|0;if(c[b>>2]|0){c[a>>2]=c[b>>2];e=c[d>>2]|0}kw(c[a+4>>2]|0,e);a=a+8|0;c[a>>2]=(c[a>>2]|0)+1;return}function Dy(a){a=a|0;Uz(a);return}function Ey(a,b){a=a|0;b=b|0;var d=0;d=c[b>>2]|0;c[a>>2]=d;c[a+(c[d+-12>>2]|0)>>2]=c[b+12>>2];Fy(a+4|0);return}function Fy(a){a=a|0;c[a>>2]=29868;IC(a+32|0);nD(a);return}function Gy(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;g=d;f=e-g|0;if(f>>>0>4294967279)Pz(b);if(f>>>0<11){a[b>>0]=f<<1;h=b+1|0}else{i=f+16&-16;h=Sz(i)|0;c[b+8>>2]=h;c[b>>2]=i|1;c[b+4>>2]=f}b=e-g|0;if((d|0)!=(e|0)){f=h;while(1){a[f>>0]=a[d>>0]|0;d=d+1|0;if((d|0)==(e|0))break;else f=f+1|0}}a[h+b>>0]=0;return}function Hy(a){a=a|0;Fy(a);Uz(a);return}function Iy(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0;i=d+44|0;j=c[i>>2]|0;l=d+24|0;m=c[l>>2]|0;if(j>>>0<m>>>0){c[i>>2]=m;j=m}k=j;i=h&24;a:do if(!i){d=b;c[d>>2]=0;c[d+4>>2]=0;d=b+8|0;c[d>>2]=-1;c[d+4>>2]=-1}else{if((g|0)==1&(i|0)==24){d=b;c[d>>2]=0;c[d+4>>2]=0;d=b+8|0;c[d>>2]=-1;c[d+4>>2]=-1;break}b:do switch(g|0){case 0:{i=0;g=0;break}case 1:if(!(h&8)){g=m-(c[d+20>>2]|0)|0;i=g;g=((g|0)<0)<<31>>31;break b}else{g=(c[d+12>>2]|0)-(c[d+8>>2]|0)|0;i=g;g=((g|0)<0)<<31>>31;break b}case 2:{i=d+32|0;if(!(a[i>>0]&1))i=i+1|0;else i=c[d+40>>2]|0;g=j-i|0;i=g;g=((g|0)<0)<<31>>31;break}default:{d=b;c[d>>2]=0;c[d+4>>2]=0;d=b+8|0;c[d>>2]=-1;c[d+4>>2]=-1;break a}}while(0);g=TL(i|0,g|0,e|0,f|0)|0;e=D;if((e|0)>=0){i=d+32|0;if(!(a[i>>0]&1))i=i+1|0;else i=c[d+40>>2]|0;f=j-i|0;j=((f|0)<0)<<31>>31;if(!((j|0)<(e|0)|(j|0)==(e|0)&f>>>0<g>>>0)){i=h&8;if(!((g|0)==0&(e|0)==0)){if((i|0)!=0?(c[d+12>>2]|0)==0:0){d=b;c[d>>2]=0;c[d+4>>2]=0;d=b+8|0;c[d>>2]=-1;c[d+4>>2]=-1;break}if((h&16|0)!=0&(m|0)==0){d=b;c[d>>2]=0;c[d+4>>2]=0;d=b+8|0;c[d>>2]=-1;c[d+4>>2]=-1;break}}if(i){c[d+12>>2]=(c[d+8>>2]|0)+g;c[d+16>>2]=k}if(h&16)c[l>>2]=(c[d+20>>2]|0)+g;d=b;c[d>>2]=0;c[d+4>>2]=0;d=b+8|0;c[d>>2]=g;c[d+4>>2]=e;break}}d=b;c[d>>2]=0;c[d+4>>2]=0;d=b+8|0;c[d>>2]=-1;c[d+4>>2]=-1}while(0);return}function Jy(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;d=d+8|0;hd[c[(c[b>>2]|0)+16>>2]&63](a,b,c[d>>2]|0,c[d+4>>2]|0,0,e);return}function Ky(a){a=a|0;var b=0,e=0,f=0,g=0;b=a+44|0;e=c[b>>2]|0;f=c[a+24>>2]|0;if(e>>>0<f>>>0){c[b>>2]=f;e=f}if(c[a+48>>2]&8){g=a+16|0;b=c[g>>2]|0;f=a+12|0;if(b>>>0<e>>>0){f=c[f>>2]|0;c[g>>2]=e;b=e}else f=c[f>>2]|0;if(f>>>0<b>>>0)b=d[f>>0]|0;else b=-1}else b=-1;return b|0}function Ly(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;f=b+44|0;e=c[f>>2]|0;g=c[b+24>>2]|0;if(e>>>0<g>>>0){c[f>>2]=g;e=g}j=b+8|0;f=c[j>>2]|0;k=b+12|0;h=c[k>>2]|0;i=f;do if(f>>>0<h>>>0){if((d|0)==-1){c[j>>2]=f;c[k>>2]=h+-1;c[b+16>>2]=e;d=0;break}if(!(c[b+48>>2]&16)){g=d&255;f=h+-1|0;if(g<<24>>24!=(a[f>>0]|0)){d=-1;break}}else{g=d&255;f=h+-1|0}c[j>>2]=i;c[k>>2]=f;c[b+16>>2]=e;a[f>>0]=g}else d=-1;while(0);return d|0}function My(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;t=i;i=i+16|0;n=t;a:do if((d|0)!=-1){p=b+12|0;q=b+8|0;r=(c[p>>2]|0)-(c[q>>2]|0)|0;s=b+24|0;e=c[s>>2]|0;m=b+28|0;f=c[m>>2]|0;do if((e|0)==(f|0)){k=b+48|0;if(!(c[k>>2]&16)){e=-1;break a}l=b+20|0;j=c[l>>2]|0;g=e-j|0;h=b+44|0;j=(c[h>>2]|0)-j|0;f=b+32|0;o=0;ma(93,f|0,0);e=o;o=0;if(!(e&1)){if(!(a[f>>0]&1))e=10;else e=(c[f>>2]&-2)+-1|0;o=0;mb(80,f|0,e|0,0);e=o;o=0;if(!(e&1)){e=a[f>>0]|0;if(!(e&1)){f=f+1|0;e=(e&255)>>>1}else{f=c[b+40>>2]|0;e=c[b+36>>2]|0}u=f+e|0;c[l>>2]=f;c[m>>2]=u;l=f+g|0;c[s>>2]=l;e=f+j|0;c[h>>2]=e;f=u;break}}e=cc(0)|0;fc(e|0)|0;$b();e=-1;break a}else{u=b+44|0;k=b+48|0;h=u;l=e;e=c[u>>2]|0}while(0);j=l+1|0;c[n>>2]=j;g=c[(j>>>0<e>>>0?h:n)>>2]|0;c[h>>2]=g;if(c[k>>2]&8){e=b+32|0;if(!(a[e>>0]&1))e=e+1|0;else e=c[b+40>>2]|0;c[q>>2]=e;c[p>>2]=e+r;c[b+16>>2]=g}if((l|0)==(f|0)){e=rd[c[(c[b>>2]|0)+52>>2]&127](b,d&255)|0;break}else{c[s>>2]=j;a[l>>0]=d;e=d&255;break}}else e=0;while(0);i=t;return e|0}function Ny(a){a=a|0;Nq(a);Uz(a);return}function Oy(a){a=a|0;Nq(a+(c[(c[a>>2]|0)+-12>>2]|0)|0);return}function Py(a){a=a|0;Ny(a+(c[(c[a>>2]|0)+-12>>2]|0)|0);return}function Qy(a){a=a|0;nq(a);Uz(a);return}function Ry(a){a=a|0;c[a>>2]=34572;br(a+8|0);return}function Sy(a){a=a|0;c[a>>2]=34572;br(a+8|0);Uz(a);return}function Ty(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Uy(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;tq((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function Vy(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;uq(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function Wy(a){a=a|0;c[a>>2]=29756;wq(a+8|0);return}function Xy(a){a=a|0;c[a>>2]=29756;wq(a+8|0);Uz(a);return}function Yy(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+12>>2]=0;c[a+16>>2]=e;if(!b)e=0;else e=Sz(b<<2)|0;c[a>>2]=e;d=e+(d<<2)|0;c[a+8>>2]=d;c[a+4>>2]=d;c[a+12>>2]=e+(b<<2);return}function Zy(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;e=c[a>>2]|0;f=a+4|0;d=c[f>>2]|0;g=b+4|0;if((d|0)!=(e|0))do{d=d+-4|0;yq((c[g>>2]|0)+-4|0,d);c[g>>2]=(c[g>>2]|0)+-4}while((d|0)!=(e|0));e=c[a>>2]|0;c[a>>2]=c[g>>2];c[g>>2]=e;e=b+8|0;d=c[f>>2]|0;c[f>>2]=c[e>>2];c[e>>2]=d;e=a+8|0;a=b+12|0;f=c[e>>2]|0;c[e>>2]=c[a>>2];c[a>>2]=f;c[b>>2]=c[g>>2];return}function _y(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a+4>>2]|0;e=a+8|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;qq(f);b=c[e>>2]|0}while((b|0)!=(d|0));b=c[a>>2]|0;if(b)Uz(b);return}function $y(a){a=a|0;Aq(a);Uz(a);return}function az(a){a=a|0;Uz(a);return}function bz(a){a=a|0;c[a>>2]=29704;Yd(a+8|0);return}function cz(a){a=a|0;c[a>>2]=29704;Yd(a+8|0);Uz(a);return}function dz(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function ez(a,b,d){a=a|0;b=b|0;d=d|0;a=a+4|0;if((b|0)!=(d|0))do{yq(c[a>>2]|0,b);c[a>>2]=(c[a>>2]|0)+4;b=b+4|0}while((b|0)!=(d|0));return}function fz(a,b){a=a|0;b=b|0;if((b|0)<0)Qz(a);else{b=((b+-1|0)>>>5)+1|0;c[a>>2]=Sz(b<<2)|0;c[a+4>>2]=0;c[a+8>>2]=b;return}}function gz(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;d=c[a+4>>2]|0;if(!d){e=a;d=c[a>>2]|0}else{g=32-d|0;f=g>>>0>b>>>0?b:g;e=c[a>>2]|0;c[e>>2]=c[e>>2]&~(-1>>>(g-f|0)&-1<<d);d=e+4|0;c[a>>2]=d;e=a;b=b-f|0}a=b>>>5;ZL(d|0,0,a<<2|0)|0;d=a<<5;if((d|0)!=(b|0)){g=(c[e>>2]|0)+(a<<2)|0;c[e>>2]=g;c[g>>2]=c[g>>2]&~(-1>>>(32-b+d|0))}return}function hz(a){a=a|0;c[a>>2]=28808;$p(a+16|0);return}function iz(a){a=a|0;c[a>>2]=28808;$p(a+16|0);Uz(a);return}function jz(a){a=a|0;c[a>>2]=28792;Yd(a+8|0);return}function kz(a){a=a|0;c[a>>2]=28792;Yd(a+8|0);Uz(a);return}function lz(a){a=a|0;qy(a);Uz(a);return}function mz(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;Pt(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function nz(a){a=a|0;IC(a+8|0);return}function oz(a){a=a|0;IC(a+12|0);return}function pz(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;vt(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function qz(a){a=a|0;Ms(a+28|0);Ms(a+24|0);nq(a+12|0);nq(a);return}function rz(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;c[a>>2]=0;f=a+4|0;c[f>>2]=0;c[a+8>>2]=0;e=d-b>>2;if(e){o=0;ma(203,a|0,e|0);e=o;o=0;if(e&1){f=cc()|0;br(a);bc(f|0)}if((b|0)!=(d|0)){e=c[f>>2]|0;do{c[e>>2]=c[b>>2];e=e+4|0;b=b+4|0}while((b|0)!=(d|0));c[f>>2]=e}}return}function sz(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;c[a>>2]=0;f=a+4|0;c[f>>2]=0;c[a+8>>2]=0;e=d-b>>4;if(e){o=0;ma(219,a|0,e|0);e=o;o=0;if(e&1){d=cc()|0;tz(a);bc(d|0)}if((b|0)!=(d|0))do{c[c[f>>2]>>2]=b;c[f>>2]=(c[f>>2]|0)+4;b=b+16|0}while((b|0)!=(d|0))}return}function tz(a){a=a|0;var b=0,d=0;d=c[a>>2]|0;if(d){b=a+4|0;a=c[b>>2]|0;if((a|0)!=(d|0)){do a=a+-4|0;while((a|0)!=(d|0));c[b>>2]=a}Uz(d)}return}function uz(a,b){a=a|0;b=b|0;var d=0;if(b>>>0>1073741823)Qz(a);else{d=Sz(b<<2)|0;c[a+4>>2]=d;c[a>>2]=d;c[a+8>>2]=d+(b<<2);return}}function vz(a,b,d){a=a|0;b=b|0;d=d|0;c[a+4>>2]=0;c[a>>2]=34572;rz(a+8|0,b,d);return}function wz(a){a=a|0;ze(a+4|0);return}function xz(a){a=a|0;var b=0,d=0,e=0,f=0;d=c[a>>2]|0;if(d){e=a+4|0;b=c[e>>2]|0;if((b|0)!=(d|0))do{f=b+-4|0;c[e>>2]=f;kr(f);b=c[e>>2]|0}while((b|0)!=(d|0));Uz(c[a>>2]|0)}return}function yz(a){a=a|0;Dz(a);return}function zz(a){a=a|0;Az(a);return}function Az(a){a=a|0;Bz(a,c[a+4>>2]|0);return}function Bz(a,b){a=a|0;b=b|0;if(!b)return;else{Bz(a,c[b>>2]|0);Bz(a,c[b+4>>2]|0);Cz(b+16|0);Uz(b);return}}function Cz(a){a=a|0;Rq(a+12|0);IC(a);return}function Dz(a){a=a|0;Ez(a,c[a+4>>2]|0);return}function Ez(a,b){a=a|0;b=b|0;if(!b)return;else{Ez(a,c[b>>2]|0);Ez(a,c[b+4>>2]|0);Rq(b+20|0);Uz(b);return}}function Fz(a){a=a|0;return hC(c[a+4>>2]|0)|0}function Gz(a){a=a|0;Zb(1920,53383);ac(1936,53388,1,1,0);Kb(1944,53393,1,-128,127);Kb(1976,53398,1,-128,127);Kb(1968,53410,1,0,255);Kb(1984,53424,2,-32768,32767);Kb(1992,53430,2,0,65535);Kb(2e3,53445,4,-2147483648,2147483647);Kb(2008,53449,4,0,-1);Kb(2016,53462,4,-2147483648,2147483647);Kb(2024,53467,4,0,-1);sc(2032,53481,4);sc(2040,53487,8);Tc(1592,53494);Tc(1616,53506);yc(1640,4,53539);Sb(1664,53552);Db(1672,0,53568);Iz(53598);Jz(53635);Kz(53674);Lz(53705);Mz(53745);Nz(53774);Db(1680,4,53812);Db(1688,5,53842);Iz(53881);Jz(53913);Kz(53946);Lz(53979);Mz(54013);Nz(54046);Db(1696,6,54080);Db(1704,7,54111);Db(1712,7,54143);return}function Hz(){Gz(0);return}function Iz(a){a=a|0;Db(1760,0,a|0);return}function Jz(a){a=a|0;Db(1752,1,a|0);return}function Kz(a){a=a|0;Db(1744,2,a|0);return}function Lz(a){a=a|0;Db(1736,3,a|0);return}function Mz(a){a=a|0;Db(1728,4,a|0);return}function Nz(a){a=a|0;Db(1720,5,a|0);return}function Oz(a,b){a=a|0;b=b|0;var d=0;d=i;i=i+16|0;c[d>>2]=b;b=c[8923]|0;VB(b,a,d)|0;QB(10,b)|0;Gb()}function Pz(a){a=a|0;Mb(55126,55155,1164,55241)}function Qz(a){a=a|0;Mb(55262,55285,303,55241)}function Rz(){var a=0,b=0;a=i;i=i+16|0;if(!(oc(35436,45)|0)){b=qc(c[8858]|0)|0;i=a;return b|0}else Oz(55371,a);return 0}function Sz(a){a=a|0;var b=0;b=(a|0)==0?1:a;a=yC(b)|0;a:do if(!a){while(1){a=aA()|0;if(!a)break;Bd[a&63]();a=yC(b)|0;if(a)break a}b=Ob(4)|0;c[b>>2]=35200;Hc(b|0,1776,216)}while(0);return a|0}function Tz(a){a=a|0;return Sz(a)|0}function Uz(a){a=a|0;zC(a);return}function Vz(a){a=a|0;Uz(a);return}function Wz(a){a=a|0;c[a>>2]=35200;return}function Xz(a){a=a|0;return}function Yz(a){a=a|0;Uz(a);return}function Zz(a){a=a|0;return 55420}function _z(a){a=a|0;var b=0;b=i;i=i+16|0;o=0;ob(a|0);a=o;o=0;if(!(a&1)){o=0;ma(220,55435,b|0);o=0}a=cc(0)|0;fc(a|0)|0;o=0;ma(220,55475,b+8|0);o=0;a=cc(0)|0;o=0;ob(44);b=o;o=0;if(b&1){b=cc(0)|0;oq(b)}else oq(a)}function $z(){var a=0,b=0,d=0;o=0;a=gb(44)|0;d=o;o=0;if(d&1){d=cc(0)|0;oq(d)}if(((a|0)!=0?(b=c[a>>2]|0,(b|0)!=0):0)?(d=b+48|0,(c[d>>2]&-256|0)==1126902528?(c[d+4>>2]|0)==1129074247:0):0)_z(c[b+12>>2]|0);d=c[8797]|0;c[8797]=d+0;_z(d)}function aA(){var a=0;a=c[8803]|0;c[8803]=a+0;return a|0}function bA(a){a=a|0;return}function cA(a){a=a|0;c[a>>2]=35224;PA(a+4|0);return}function dA(a){a=a|0;cA(a);Uz(a);return}function eA(a){a=a|0;return c[a+4>>2]|0}function fA(a){a=a|0;return}function gA(a){a=a|0;c[a>>2]=35244;return}function hA(a){a=a|0;return}function iA(a){a=a|0;Uz(a);return}function jA(a){a=a|0;return 55525}function kA(a){a=a|0;return}function lA(a){a=a|0;return}function mA(a){a=a|0;return}function nA(a){a=a|0;Uz(a);return}function oA(a){a=a|0;Uz(a);return}function pA(a){a=a|0;Uz(a);return}function qA(a){a=a|0;Uz(a);return}function rA(a){a=a|0;Uz(a);return}function sA(a,b,c){a=a|0;b=b|0;c=c|0;return (a|0)==(b|0)|0}function tA(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;h=i;i=i+64|0;g=h;if((a|0)!=(b|0))if((b|0)!=0?(f=AA(b,1840,1856,0)|0,(f|0)!=0):0){b=g;e=b+56|0;do{c[b>>2]=0;b=b+4|0}while((b|0)<(e|0));c[g>>2]=f;c[g+8>>2]=a;c[g+12>>2]=-1;c[g+48>>2]=1;Ed[c[(c[f>>2]|0)+28>>2]&127](f,g,c[d>>2]|0,1);if((c[g+24>>2]|0)==1){c[d>>2]=c[g+16>>2];b=1}else b=0}else b=0;else b=1;i=h;return b|0}function uA(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0;b=d+16|0;g=c[b>>2]|0;do if(g){if((g|0)!=(e|0)){f=d+36|0;c[f>>2]=(c[f>>2]|0)+1;c[d+24>>2]=2;a[d+54>>0]=1;break}b=d+24|0;if((c[b>>2]|0)==2)c[b>>2]=f}else{c[b>>2]=e;c[d+24>>2]=f;c[d+36>>2]=1}while(0);return}function vA(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;if((a|0)==(c[b+8>>2]|0))uA(0,b,d,e);return}function wA(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;if((a|0)==(c[b+8>>2]|0))uA(0,b,d,e);else{a=c[a+8>>2]|0;Ed[c[(c[a>>2]|0)+28>>2]&127](a,b,d,e)}return}function xA(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0;g=c[a+4>>2]|0;f=g>>8;if(g&1)f=c[(c[d>>2]|0)+f>>2]|0;a=c[a>>2]|0;Ed[c[(c[a>>2]|0)+28>>2]&127](a,b,d+f|0,(g&2|0)!=0?e:2);return}function yA(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;a:do if((b|0)!=(c[d+8>>2]|0)){h=c[b+12>>2]|0;g=b+16+(h<<3)|0;xA(b+16|0,d,e,f);if((h|0)>1){h=d+54|0;b=b+24|0;do{xA(b,d,e,f);if(a[h>>0]|0)break a;b=b+8|0}while(b>>>0<g>>>0)}}else uA(0,d,e,f);while(0);return}function zA(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;k=i;i=i+64|0;j=k;c[d>>2]=c[c[d>>2]>>2];if(!((a|0)==(b|0)|(b|0)==1928))if(((b|0)!=0?(e=AA(b,1840,1888,0)|0,(e|0)!=0):0)?(c[e+8>>2]&~c[a+8>>2]|0)==0:0){b=c[a+12>>2]|0;a=e+12|0;if(!((b|0)==1920?1:(b|0)==(c[a>>2]|0)))if((((b|0)!=0?(g=AA(b,1840,1856,0)|0,(g|0)!=0):0)?(f=c[a>>2]|0,(f|0)!=0):0)?(h=AA(f,1840,1856,0)|0,(h|0)!=0):0){a=j;b=a+56|0;do{c[a>>2]=0;a=a+4|0}while((a|0)<(b|0));c[j>>2]=h;c[j+8>>2]=g;c[j+12>>2]=-1;c[j+48>>2]=1;Ed[c[(c[h>>2]|0)+28>>2]&127](h,j,c[d>>2]|0,1);if((c[j+24>>2]|0)==1){c[d>>2]=c[j+16>>2];a=1}else a=0}else a=0;else a=1}else a=0;else a=1;i=k;return a|0}function AA(d,e,f,g){d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;r=i;i=i+64|0;q=r;p=c[d>>2]|0;o=d+(c[p+-8>>2]|0)|0;p=c[p+-4>>2]|0;c[q>>2]=f;c[q+4>>2]=d;c[q+8>>2]=e;c[q+12>>2]=g;g=q+16|0;d=q+20|0;e=q+24|0;h=q+28|0;j=q+32|0;k=q+40|0;l=(p|0)==(f|0);m=g;n=m+36|0;do{c[m>>2]=0;m=m+4|0}while((m|0)<(n|0));b[g+36>>1]=0;a[g+38>>0]=0;a:do if(l){c[q+48>>2]=1;hd[c[(c[f>>2]|0)+20>>2]&63](f,q,o,o,1,0);g=(c[e>>2]|0)==1?o:0}else{Zc[c[(c[p>>2]|0)+24>>2]&63](p,q,o,1,0);switch(c[q+36>>2]|0){case 0:{g=(c[k>>2]|0)==1&(c[h>>2]|0)==1&(c[j>>2]|0)==1?c[d>>2]|0:0;break a}case 1:break;default:{g=0;break a}}if((c[e>>2]|0)!=1?!((c[k>>2]|0)==0&(c[h>>2]|0)==1&(c[j>>2]|0)==1):0){g=0;break}g=c[g>>2]|0}while(0);i=r;return g|0}function BA(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;a[d+53>>0]=1;do if((c[d+4>>2]|0)==(f|0)){a[d+52>>0]=1;f=d+16|0;b=c[f>>2]|0;if(!b){c[f>>2]=e;c[d+24>>2]=g;c[d+36>>2]=1;if(!((g|0)==1?(c[d+48>>2]|0)==1:0))break;a[d+54>>0]=1;break}if((b|0)!=(e|0)){g=d+36|0;c[g>>2]=(c[g>>2]|0)+1;a[d+54>>0]=1;break}b=d+24|0;f=c[b>>2]|0;if((f|0)==2){c[b>>2]=g;f=g}if((f|0)==1?(c[d+48>>2]|0)==1:0)a[d+54>>0]=1}while(0);return}function CA(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;a:do if((b|0)==(c[d+8>>2]|0)){if((c[d+4>>2]|0)==(e|0)?(h=d+28|0,(c[h>>2]|0)!=1):0)c[h>>2]=f}else{if((b|0)!=(c[d>>2]|0)){q=c[b+12>>2]|0;j=b+16+(q<<3)|0;EA(b+16|0,d,e,f,g);h=b+24|0;if((q|0)<=1)break;i=c[b+8>>2]|0;if((i&2|0)==0?(k=d+36|0,(c[k>>2]|0)!=1):0){if(!(i&1)){i=d+54|0;while(1){if(a[i>>0]|0)break a;if((c[k>>2]|0)==1)break a;EA(h,d,e,f,g);h=h+8|0;if(h>>>0>=j>>>0)break a}}i=d+24|0;b=d+54|0;while(1){if(a[b>>0]|0)break a;if((c[k>>2]|0)==1?(c[i>>2]|0)==1:0)break a;EA(h,d,e,f,g);h=h+8|0;if(h>>>0>=j>>>0)break a}}i=d+54|0;while(1){if(a[i>>0]|0)break a;EA(h,d,e,f,g);h=h+8|0;if(h>>>0>=j>>>0)break a}}if((c[d+16>>2]|0)!=(e|0)?(p=d+20|0,(c[p>>2]|0)!=(e|0)):0){c[d+32>>2]=f;m=d+44|0;if((c[m>>2]|0)==4)break;i=c[b+12>>2]|0;j=b+16+(i<<3)|0;k=d+52|0;f=d+53|0;n=d+54|0;l=b+8|0;o=d+24|0;b:do if((i|0)>0){i=0;h=0;b=b+16|0;while(1){a[k>>0]=0;a[f>>0]=0;DA(b,d,e,e,1,g);if(a[n>>0]|0){q=20;break b}do if(a[f>>0]|0){if(!(a[k>>0]|0))if(!(c[l>>2]&1)){h=1;q=20;break b}else{h=1;break}if((c[o>>2]|0)==1)break b;if(!(c[l>>2]&2))break b;else{i=1;h=1}}while(0);b=b+8|0;if(b>>>0>=j>>>0){q=20;break}}}else{i=0;h=0;q=20}while(0);do if((q|0)==20){if((!i?(c[p>>2]=e,e=d+40|0,c[e>>2]=(c[e>>2]|0)+1,(c[d+36>>2]|0)==1):0)?(c[o>>2]|0)==2:0){a[n>>0]=1;if(h)break}else q=24;if((q|0)==24?h:0)break;c[m>>2]=4;break a}while(0);c[m>>2]=3;break}if((f|0)==1)c[d+32>>2]=1}while(0);return}function DA(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0;i=c[a+4>>2]|0;h=i>>8;if(i&1)h=c[(c[e>>2]|0)+h>>2]|0;a=c[a>>2]|0;hd[c[(c[a>>2]|0)+20>>2]&63](a,b,d,e+h|0,(i&2|0)!=0?f:2,g);return}function EA(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;h=c[a+4>>2]|0;g=h>>8;if(h&1)g=c[(c[d>>2]|0)+g>>2]|0;a=c[a>>2]|0;Zc[c[(c[a>>2]|0)+24>>2]&63](a,b,d+g|0,(h&2|0)!=0?e:2,f);return}function FA(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0;a:do if((b|0)==(c[d+8>>2]|0)){if((c[d+4>>2]|0)==(e|0)?(h=d+28|0,(c[h>>2]|0)!=1):0)c[h>>2]=f}else{if((b|0)!=(c[d>>2]|0)){j=c[b+8>>2]|0;Zc[c[(c[j>>2]|0)+24>>2]&63](j,d,e,f,g);break}if((c[d+16>>2]|0)!=(e|0)?(i=d+20|0,(c[i>>2]|0)!=(e|0)):0){c[d+32>>2]=f;f=d+44|0;if((c[f>>2]|0)==4)break;h=d+52|0;a[h>>0]=0;k=d+53|0;a[k>>0]=0;b=c[b+8>>2]|0;hd[c[(c[b>>2]|0)+20>>2]&63](b,d,e,e,1,g);if(a[k>>0]|0){if(!(a[h>>0]|0)){h=1;j=13}}else{h=0;j=13}do if((j|0)==13){c[i>>2]=e;k=d+40|0;c[k>>2]=(c[k>>2]|0)+1;if((c[d+36>>2]|0)==1?(c[d+24>>2]|0)==2:0){a[d+54>>0]=1;if(h)break}else j=16;if((j|0)==16?h:0)break;c[f>>2]=4;break a}while(0);c[f>>2]=3;break}if((f|0)==1)c[d+32>>2]=1}while(0);return}function GA(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0;do if((b|0)==(c[d+8>>2]|0)){if((c[d+4>>2]|0)==(e|0)?(i=d+28|0,(c[i>>2]|0)!=1):0)c[i>>2]=f}else if((b|0)==(c[d>>2]|0)){if((c[d+16>>2]|0)!=(e|0)?(h=d+20|0,(c[h>>2]|0)!=(e|0)):0){c[d+32>>2]=f;c[h>>2]=e;g=d+40|0;c[g>>2]=(c[g>>2]|0)+1;if((c[d+36>>2]|0)==1?(c[d+24>>2]|0)==2:0)a[d+54>>0]=1;c[d+44>>2]=4;break}if((f|0)==1)c[d+32>>2]=1}while(0);return}function HA(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;if((b|0)==(c[d+8>>2]|0))BA(0,d,e,f,g);else{m=d+52|0;n=a[m>>0]|0;o=d+53|0;p=a[o>>0]|0;l=c[b+12>>2]|0;i=b+16+(l<<3)|0;a[m>>0]=0;a[o>>0]=0;DA(b+16|0,d,e,f,g,h);a:do if((l|0)>1){j=d+24|0;k=b+8|0;l=d+54|0;b=b+24|0;do{if(a[l>>0]|0)break a;if(!(a[m>>0]|0)){if((a[o>>0]|0)!=0?(c[k>>2]&1|0)==0:0)break a}else{if((c[j>>2]|0)==1)break a;if(!(c[k>>2]&2))break a}a[m>>0]=0;a[o>>0]=0;DA(b,d,e,f,g,h);b=b+8|0}while(b>>>0<i>>>0)}while(0);a[m>>0]=n;a[o>>0]=p}return}function IA(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;if((a|0)==(c[b+8>>2]|0))BA(0,b,d,e,f);else{a=c[a+8>>2]|0;hd[c[(c[a>>2]|0)+20>>2]&63](a,b,d,e,f,g)}return}function JA(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;if((a|0)==(c[b+8>>2]|0))BA(0,b,d,e,f);return}function KA(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;f=i;i=i+16|0;e=f;c[e>>2]=c[d>>2];a=fd[c[(c[a>>2]|0)+16>>2]&127](a,b,e)|0;if(a)c[d>>2]=c[e>>2];i=f;return a&1|0}function LA(a){a=a|0;if(!a)a=0;else a=(AA(a,1840,1888,0)|0)!=0;return a&1|0}function MA(){var a=0;a=Ob(4)|0;Wz(a);Hc(a|0,1776,216)}function NA(){var a=0,b=0,d=0,e=0,f=0,g=0,h=0,j=0;f=i;i=i+48|0;h=f+32|0;d=f+24|0;j=f+16|0;g=f;f=f+36|0;a=Rz()|0;if((a|0)!=0?(e=c[a>>2]|0,(e|0)!=0):0){a=e+48|0;b=c[a>>2]|0;a=c[a+4>>2]|0;if(!((b&-256|0)==1126902528&(a|0)==1129074247)){c[d>>2]=c[8860];Oz(55778,d)}if((b|0)==1126902529&(a|0)==1129074247)a=c[e+44>>2]|0;else a=e+80|0;c[f>>2]=a;e=c[e>>2]|0;a=c[e+4>>2]|0;if(fd[c[(c[1792>>2]|0)+16>>2]&127](1792,e,f)|0){j=c[f>>2]|0;f=c[8860]|0;j=bd[c[(c[j>>2]|0)+8>>2]&255](j)|0;c[g>>2]=f;c[g+4>>2]=a;c[g+8>>2]=j;Oz(55692,g)}else{c[j>>2]=c[8860];c[j+4>>2]=a;Oz(55737,j)}}Oz(55816,h)}function OA(){var a=0;a=i;i=i+16|0;if(!(Qc(35432,342)|0)){i=a;return}else Oz(55539,a)}function PA(a){a=a|0;var b=0,d=0;d=(c[a>>2]|0)+-4|0;b=c[d>>2]|0;c[d>>2]=b+-1;if((b+-1|0)<0)Uz((c[a>>2]|0)+-12|0);return}function QA(a){a=a|0;var b=0;b=i;i=i+16|0;zC(a);if(!(Dc(c[8858]|0,0)|0)){i=b;return}else Oz(55589,b)}function RA(a){a=a|0;Mb(55642,55155,1175,55671)}function SA(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;a=_B(a,b,c)|0;return a|0}function TA(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;a=$B(a,b,c)|0;return a|0}function UA(){return 35700}function VA(){return 35704}function WA(){return 35708}function XA(a){a=a|0;return ((a|0)==32|(a+-9|0)>>>0<5)&1|0}function YA(a){a=a|0;if((a+-48|0)>>>0<10)a=1;else a=((a|32)+-97|0)>>>0<6;return a&1|0}function ZA(){var a=0;if(!(c[8861]|0))a=35712;else a=c[(lc()|0)+60>>2]|0;return a|0}function _A(b){b=b|0;var c=0,e=0;c=0;while(1){if((d[55837+c>>0]|0)==(b|0)){e=2;break}c=c+1|0;if((c|0)==87){c=87;b=55925;e=5;break}}if((e|0)==2)if(!c)b=55925;else{b=55925;e=5}if((e|0)==5)while(1){e=b;while(1){b=e+1|0;if(!(a[e>>0]|0))break;else e=b}c=c+-1|0;if(!c)break;else e=5}return b|0}function $A(b,e,f){b=b|0;e=e|0;f=f|0;var g=0.0,h=0,j=0.0,k=0,l=0,m=0.0,n=0,o=0,p=0,q=0.0,r=0.0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0.0;L=i;i=i+512|0;H=L;switch(e|0){case 0:{K=24;J=-149;A=4;break}case 1:{K=53;J=-1074;A=4;break}case 2:{K=53;J=-1074;A=4;break}default:g=0.0}a:do if((A|0)==4){E=b+4|0;C=b+100|0;do{e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0}else e=cB(b)|0}while((XA(e)|0)!=0);b:do switch(e|0){case 43:case 45:{h=1-(((e|0)==45&1)<<1)|0;e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0;I=h;break b}else{e=cB(b)|0;I=h;break b}}default:I=1}while(0);h=e;e=0;do{if((h|32|0)!=(a[57729+e>>0]|0))break;do if(e>>>0<7){h=c[E>>2]|0;if(h>>>0<(c[C>>2]|0)>>>0){c[E>>2]=h+1;h=d[h>>0]|0;break}else{h=cB(b)|0;break}}while(0);e=e+1|0}while(e>>>0<8);c:do switch(e|0){case 8:break;case 3:{A=23;break}default:{k=(f|0)!=0;if(k&e>>>0>3)if((e|0)==8)break c;else{A=23;break c}d:do if(!e){e=0;do{if((h|32|0)!=(a[59574+e>>0]|0))break d;do if(e>>>0<2){h=c[E>>2]|0;if(h>>>0<(c[C>>2]|0)>>>0){c[E>>2]=h+1;h=d[h>>0]|0;break}else{h=cB(b)|0;break}}while(0);e=e+1|0}while(e>>>0<3)}while(0);switch(e|0){case 3:{e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0}else e=cB(b)|0;if((e|0)==40)e=1;else{if(!(c[C>>2]|0)){g=s;break a}c[E>>2]=(c[E>>2]|0)+-1;g=s;break a}while(1){h=c[E>>2]|0;if(h>>>0<(c[C>>2]|0)>>>0){c[E>>2]=h+1;h=d[h>>0]|0}else h=cB(b)|0;if(!((h+-48|0)>>>0<10|(h+-65|0)>>>0<26)?!((h|0)==95|(h+-97|0)>>>0<26):0)break;e=e+1|0}if((h|0)==41){g=s;break a}h=(c[C>>2]|0)==0;if(!h)c[E>>2]=(c[E>>2]|0)+-1;if(!k){c[(ZA()|0)>>2]=22;bB(b,0);g=0.0;break a}if(!e){g=s;break a}while(1){e=e+-1|0;if(!h)c[E>>2]=(c[E>>2]|0)+-1;if(!e){g=s;break a}}}case 0:{do if((h|0)==48){e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0}else e=cB(b)|0;if((e|32|0)!=120){if(!(c[C>>2]|0)){e=48;break}c[E>>2]=(c[E>>2]|0)+-1;e=48;break}e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0;k=0}else{e=cB(b)|0;k=0}e:while(1){switch(e|0){case 46:{A=74;break e}case 48:break;default:{y=0;l=0;x=0;h=0;n=k;o=0;w=0;m=1.0;k=0;g=0.0;break e}}e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0;k=1;continue}else{e=cB(b)|0;k=1;continue}}if((A|0)==74){e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0}else e=cB(b)|0;if((e|0)==48){k=0;h=0;do{e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0}else e=cB(b)|0;k=TL(k|0,h|0,-1,-1)|0;h=D}while((e|0)==48);y=0;l=0;x=k;n=1;o=1;w=0;m=1.0;k=0;g=0.0}else{y=0;l=0;x=0;h=0;n=k;o=1;w=0;m=1.0;k=0;g=0.0}}while(1){u=e+-48|0;p=e|32;if(u>>>0>=10){v=(e|0)==46;if(!(v|(p+-97|0)>>>0<6)){p=x;u=y;break}if(v)if(!o){v=l;h=y;u=y;o=1;p=w;j=m}else{p=x;u=y;e=46;break}else A=86}else A=86;if((A|0)==86){A=0;e=(e|0)>57?p+-87|0:u;do if(!((y|0)<0|(y|0)==0&l>>>0<8)){if((y|0)<0|(y|0)==0&l>>>0<14){r=m*.0625;p=w;j=r;g=g+r*+(e|0);break}if((w|0)!=0|(e|0)==0){p=w;j=m}else{p=1;j=m;g=g+m*.5}}else{p=w;j=m;k=e+(k<<4)|0}while(0);l=TL(l|0,y|0,1,0)|0;v=x;u=D;n=1}e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;y=u;x=v;e=d[e>>0]|0;w=p;m=j;continue}else{y=u;x=v;e=cB(b)|0;w=p;m=j;continue}}if(!n){e=(c[C>>2]|0)==0;if(!e)c[E>>2]=(c[E>>2]|0)+-1;if(f){if(!e?(z=c[E>>2]|0,c[E>>2]=z+-1,(o|0)!=0):0)c[E>>2]=z+-2}else bB(b,0);g=+(I|0)*0.0;break a}n=(o|0)==0;o=n?l:p;n=n?u:h;if((u|0)<0|(u|0)==0&l>>>0<8){h=u;do{k=k<<4;l=TL(l|0,h|0,1,0)|0;h=D}while((h|0)<0|(h|0)==0&l>>>0<8)}if((e|32|0)==112){h=nC(b,f)|0;e=D;if((h|0)==0&(e|0)==-2147483648){if(!f){bB(b,0);g=0.0;break a}if(!(c[C>>2]|0)){h=0;e=0}else{c[E>>2]=(c[E>>2]|0)+-1;h=0;e=0}}}else if(!(c[C>>2]|0)){h=0;e=0}else{c[E>>2]=(c[E>>2]|0)+-1;h=0;e=0}H=_L(o|0,n|0,2)|0;H=TL(H|0,D|0,-32,-1)|0;e=TL(H|0,D|0,h|0,e|0)|0;h=D;if(!k){g=+(I|0)*0.0;break a}if((h|0)>0|(h|0)==0&e>>>0>(0-J|0)>>>0){c[(ZA()|0)>>2]=34;g=+(I|0)*1797693134862315708145274.0e284*1797693134862315708145274.0e284;break a}H=J+-106|0;G=((H|0)<0)<<31>>31;if((h|0)<(G|0)|(h|0)==(G|0)&e>>>0<H>>>0){c[(ZA()|0)>>2]=34;g=+(I|0)*2.2250738585072014e-308*2.2250738585072014e-308;break a}if((k|0)>-1){do{G=!(g>=.5);H=G&1|k<<1;k=H^1;g=g+(G?g:g+-1.0);e=TL(e|0,h|0,-1,-1)|0;h=D}while((H|0)>-1);l=e;m=g}else{l=e;m=g}e=UL(32,0,J|0,((J|0)<0)<<31>>31|0)|0;e=TL(l|0,h|0,e|0,D|0)|0;J=D;if(0>(J|0)|0==(J|0)&K>>>0>e>>>0)if((e|0)<0){e=0;A=127}else A=125;else{e=K;A=125}if((A|0)==125)if((e|0)<53)A=127;else{h=e;j=+(I|0);g=0.0}if((A|0)==127){g=+(I|0);h=e;j=g;g=+nB(+sB(1.0,84-e|0),g)}K=(k&1|0)==0&(m!=0.0&(h|0)<32);g=j*(K?0.0:m)+(g+j*+(((K&1)+k|0)>>>0))-g;if(!(g!=0.0))c[(ZA()|0)>>2]=34;g=+tB(g,l);break a}else e=h;while(0);F=J+K|0;G=0-F|0;k=0;f:while(1){switch(e|0){case 46:{A=138;break f}case 48:break;default:{h=0;p=0;o=0;break f}}e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0;k=1;continue}else{e=cB(b)|0;k=1;continue}}if((A|0)==138){e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0}else e=cB(b)|0;if((e|0)==48){h=0;e=0;while(1){h=TL(h|0,e|0,-1,-1)|0;k=D;e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0}else e=cB(b)|0;if((e|0)==48)e=k;else{p=k;k=1;o=1;break}}}else{h=0;p=0;o=1}}c[H>>2]=0;n=e+-48|0;l=(e|0)==46;g:do if(l|n>>>0<10){B=H+496|0;y=0;v=0;w=l;A=p;u=k;z=o;k=0;l=0;o=0;h:while(1){do if(w)if(!z){h=y;p=v;z=1}else{p=A;e=y;n=v;break h}else{w=TL(y|0,v|0,1,0)|0;v=D;x=(e|0)!=48;if((l|0)>=125){if(!x){p=A;y=w;break}c[B>>2]=c[B>>2]|1;p=A;y=w;break}p=H+(l<<2)|0;if(k)n=e+-48+((c[p>>2]|0)*10|0)|0;c[p>>2]=n;k=k+1|0;n=(k|0)==9;p=A;y=w;u=1;k=n?0:k;l=(n&1)+l|0;o=x?w:o}while(0);e=c[E>>2]|0;if(e>>>0<(c[C>>2]|0)>>>0){c[E>>2]=e+1;e=d[e>>0]|0}else e=cB(b)|0;n=e+-48|0;w=(e|0)==46;if(!(w|n>>>0<10)){n=z;A=161;break g}else A=p}u=(u|0)!=0;A=169}else{y=0;v=0;u=k;n=o;k=0;l=0;o=0;A=161}while(0);do if((A|0)==161){B=(n|0)==0;h=B?y:h;p=B?v:p;u=(u|0)!=0;if(!((e|32|0)==101&u))if((e|0)>-1){e=y;n=v;A=169;break}else{e=y;n=v;A=171;break}n=nC(b,f)|0;e=D;if((n|0)==0&(e|0)==-2147483648){if(!f){bB(b,0);g=0.0;break}if(!(c[C>>2]|0)){n=0;e=0}else{c[E>>2]=(c[E>>2]|0)+-1;n=0;e=0}}h=TL(n|0,e|0,h|0,p|0)|0;u=y;p=D;n=v;A=173}while(0);if((A|0)==169)if(c[C>>2]|0){c[E>>2]=(c[E>>2]|0)+-1;if(u){u=e;A=173}else A=172}else A=171;if((A|0)==171)if(u){u=e;A=173}else A=172;do if((A|0)==172){c[(ZA()|0)>>2]=22;bB(b,0);g=0.0}else if((A|0)==173){e=c[H>>2]|0;if(!e){g=+(I|0)*0.0;break}if(((n|0)<0|(n|0)==0&u>>>0<10)&((h|0)==(u|0)&(p|0)==(n|0))?K>>>0>30|(e>>>K|0)==0:0){g=+(I|0)*+(e>>>0);break}b=(J|0)/-2|0;E=((b|0)<0)<<31>>31;if((p|0)>(E|0)|(p|0)==(E|0)&h>>>0>b>>>0){c[(ZA()|0)>>2]=34;g=+(I|0)*1797693134862315708145274.0e284*1797693134862315708145274.0e284;break}b=J+-106|0;E=((b|0)<0)<<31>>31;if((p|0)<(E|0)|(p|0)==(E|0)&h>>>0<b>>>0){c[(ZA()|0)>>2]=34;g=+(I|0)*2.2250738585072014e-308*2.2250738585072014e-308;break}if(k){if((k|0)<9){n=H+(l<<2)|0;e=c[n>>2]|0;do{e=e*10|0;k=k+1|0}while((k|0)!=9);c[n>>2]=e}l=l+1|0}if((o|0)<9?(o|0)<=(h|0)&(h|0)<18:0){if((h|0)==9){g=+(I|0)*+((c[H>>2]|0)>>>0);break}if((h|0)<9){g=+(I|0)*+((c[H>>2]|0)>>>0)/+(c[35716+(8-h<<2)>>2]|0);break}b=K+27+($(h,-3)|0)|0;e=c[H>>2]|0;if((b|0)>30|(e>>>b|0)==0){g=+(I|0)*+(e>>>0)*+(c[35716+(h+-10<<2)>>2]|0);break}}e=(h|0)%9|0;if(!e){k=0;e=0}else{u=(h|0)>-1?e:e+9|0;n=c[35716+(8-u<<2)>>2]|0;if(l){o=1e9/(n|0)|0;k=0;e=0;p=0;do{C=H+(p<<2)|0;E=c[C>>2]|0;b=((E>>>0)/(n>>>0)|0)+e|0;c[C>>2]=b;e=$((E>>>0)%(n>>>0)|0,o)|0;b=(p|0)==(k|0)&(b|0)==0;p=p+1|0;h=b?h+-9|0:h;k=b?p&127:k}while((p|0)!=(l|0));if(e){c[H+(l<<2)>>2]=e;l=l+1|0}}else{k=0;l=0}e=0;h=9-u+h|0}i:while(1){v=(h|0)<18;w=(h|0)==18;x=H+(k<<2)|0;do{if(!v){if(!w)break i;if((c[x>>2]|0)>>>0>=9007199){h=18;break i}}n=0;o=l+127|0;while(1){u=o&127;p=H+(u<<2)|0;o=_L(c[p>>2]|0,0,29)|0;o=TL(o|0,D|0,n|0,0)|0;n=D;if(n>>>0>0|(n|0)==0&o>>>0>1e9){b=eM(o|0,n|0,1e9,0)|0;o=fM(o|0,n|0,1e9,0)|0;n=b}else n=0;c[p>>2]=o;b=(u|0)==(k|0);l=(u|0)!=(l+127&127|0)|b?l:(o|0)==0?u:l;if(b)break;else o=u+-1|0}e=e+-29|0}while((n|0)==0);k=k+127&127;if((k|0)==(l|0)){b=l+127&127;l=H+((l+126&127)<<2)|0;c[l>>2]=c[l>>2]|c[H+(b<<2)>>2];l=b}c[H+(k<<2)>>2]=n;h=h+9|0}j:while(1){y=l+1&127;x=H+((l+127&127)<<2)|0;while(1){v=(h|0)==18;w=(h|0)>27?9:1;u=v^1;while(1){o=k&127;p=(o|0)==(l|0);do if(!p){n=c[H+(o<<2)>>2]|0;if(n>>>0<9007199){A=219;break}if(n>>>0>9007199)break;n=k+1&127;if((n|0)==(l|0)){A=219;break}n=c[H+(n<<2)>>2]|0;if(n>>>0<254740991){A=219;break}if(!(n>>>0>254740991|u)){h=o;break j}}else A=219;while(0);if((A|0)==219?(A=0,v):0){A=220;break j}e=e+w|0;if((k|0)==(l|0))k=l;else break}u=(1<<w)+-1|0;v=1e9>>>w;o=k;n=0;p=k;while(1){E=H+(p<<2)|0;b=c[E>>2]|0;k=(b>>>w)+n|0;c[E>>2]=k;n=$(b&u,v)|0;k=(p|0)==(o|0)&(k|0)==0;p=p+1&127;h=k?h+-9|0:h;k=k?p:o;if((p|0)==(l|0))break;else o=k}if(!n)continue;if((y|0)!=(k|0))break;c[x>>2]=c[x>>2]|1}c[H+(l<<2)>>2]=n;l=y}if((A|0)==220)if(p){c[H+(y+-1<<2)>>2]=0;h=l;l=y}else h=o;g=+((c[H+(h<<2)>>2]|0)>>>0);h=k+1&127;if((h|0)==(l|0)){l=k+2&127;c[H+(l+-1<<2)>>2]=0}r=+(I|0);j=r*(g*1.0e9+ +((c[H+(h<<2)>>2]|0)>>>0));v=e+53|0;p=v-J|0;u=(p|0)<(K|0);h=u&1;o=u?((p|0)<0?0:p):K;if((o|0)<53){M=+nB(+sB(1.0,105-o|0),j);m=+pB(j,+sB(1.0,53-o|0));q=M;g=m;m=M+(j-m)}else{q=0.0;g=0.0;m=j}n=k+2&127;do if((n|0)==(l|0))j=g;else{n=c[H+(n<<2)>>2]|0;do if(n>>>0>=5e8){if(n>>>0>5e8){g=r*.75+g;break}if((k+3&127|0)==(l|0)){g=r*.5+g;break}else{g=r*.75+g;break}}else{if((n|0)==0?(k+3&127|0)==(l|0):0)break;g=r*.25+g}while(0);if((53-o|0)<=1){j=g;break}if(+pB(g,1.0)!=0.0){j=g;break}j=g+1.0}while(0);g=m+j-q;do if((v&2147483647|0)>(-2-F|0)){if(+O(+g)>=9007199254740992.0){h=u&(o|0)==(p|0)?0:h;e=e+1|0;g=g*.5}if((e+50|0)<=(G|0)?!(j!=0.0&(h|0)!=0):0)break;c[(ZA()|0)>>2]=34}while(0);g=+tB(g,e)}while(0);break a}default:{if(c[C>>2]|0)c[E>>2]=(c[E>>2]|0)+-1;c[(ZA()|0)>>2]=22;bB(b,0);g=0.0;break a}}}}while(0);if((A|0)==23){h=(c[C>>2]|0)==0;if(!h)c[E>>2]=(c[E>>2]|0)+-1;if((f|0)!=0&e>>>0>3)do{if(!h)c[E>>2]=(c[E>>2]|0)+-1;e=e+-1|0}while(e>>>0>3)}g=+(I|0)*t}while(0);i=L;return +g}function aB(b,e,f,g,h){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;a:do if(e>>>0>36){c[(ZA()|0)>>2]=22;h=0;g=0}else{r=b+4|0;q=b+100|0;do{i=c[r>>2]|0;if(i>>>0<(c[q>>2]|0)>>>0){c[r>>2]=i+1;i=d[i>>0]|0}else i=cB(b)|0}while((XA(i)|0)!=0);b:do switch(i|0){case 43:case 45:{j=((i|0)==45)<<31>>31;i=c[r>>2]|0;if(i>>>0<(c[q>>2]|0)>>>0){c[r>>2]=i+1;i=d[i>>0]|0;p=j;break b}else{i=cB(b)|0;p=j;break b}}default:p=0}while(0);j=(e|0)==0;do if((e&-17|0)==0&(i|0)==48){i=c[r>>2]|0;if(i>>>0<(c[q>>2]|0)>>>0){c[r>>2]=i+1;i=d[i>>0]|0}else i=cB(b)|0;if((i|32|0)!=120)if(j){e=8;n=46;break}else{n=32;break}e=c[r>>2]|0;if(e>>>0<(c[q>>2]|0)>>>0){c[r>>2]=e+1;i=d[e>>0]|0}else i=cB(b)|0;if((d[57738+(i+1)>>0]|0)>15){g=(c[q>>2]|0)==0;if(!g)c[r>>2]=(c[r>>2]|0)+-1;if(!f){bB(b,0);h=0;g=0;break a}if(g){h=0;g=0;break a}c[r>>2]=(c[r>>2]|0)+-1;h=0;g=0;break a}else{e=16;n=46}}else{e=j?10:e;if((d[57738+(i+1)>>0]|0)>>>0<e>>>0)n=32;else{if(c[q>>2]|0)c[r>>2]=(c[r>>2]|0)+-1;bB(b,0);c[(ZA()|0)>>2]=22;h=0;g=0;break a}}while(0);if((n|0)==32)if((e|0)==10){e=i+-48|0;if(e>>>0<10){i=0;while(1){j=(i*10|0)+e|0;e=c[r>>2]|0;if(e>>>0<(c[q>>2]|0)>>>0){c[r>>2]=e+1;i=d[e>>0]|0}else i=cB(b)|0;e=i+-48|0;if(!(e>>>0<10&j>>>0<429496729)){e=j;break}else i=j}j=0}else{e=0;j=0}f=i+-48|0;if(f>>>0<10){while(1){k=dM(e|0,j|0,10,0)|0;l=D;m=((f|0)<0)<<31>>31;o=~m;if(l>>>0>o>>>0|(l|0)==(o|0)&k>>>0>~f>>>0){k=e;break}e=TL(k|0,l|0,f|0,m|0)|0;j=D;i=c[r>>2]|0;if(i>>>0<(c[q>>2]|0)>>>0){c[r>>2]=i+1;i=d[i>>0]|0}else i=cB(b)|0;f=i+-48|0;if(!(f>>>0<10&(j>>>0<429496729|(j|0)==429496729&e>>>0<2576980378))){k=e;break}}if(f>>>0>9){i=k;e=p}else{e=10;n=72}}else{i=e;e=p}}else n=46;c:do if((n|0)==46){if(!(e+-1&e)){n=a[57995+((e*23|0)>>>5&7)>>0]|0;j=a[57738+(i+1)>>0]|0;f=j&255;if(f>>>0<e>>>0){i=0;while(1){k=f|i<<n;i=c[r>>2]|0;if(i>>>0<(c[q>>2]|0)>>>0){c[r>>2]=i+1;i=d[i>>0]|0}else i=cB(b)|0;j=a[57738+(i+1)>>0]|0;f=j&255;if(!(k>>>0<134217728&f>>>0<e>>>0))break;else i=k}f=0}else{f=0;k=0}l=WL(-1,-1,n|0)|0;m=D;if((j&255)>>>0>=e>>>0|(f>>>0>m>>>0|(f|0)==(m|0)&k>>>0>l>>>0)){j=f;n=72;break}else i=f;while(1){k=_L(k|0,i|0,n|0)|0;f=D;k=j&255|k;i=c[r>>2]|0;if(i>>>0<(c[q>>2]|0)>>>0){c[r>>2]=i+1;i=d[i>>0]|0}else i=cB(b)|0;j=a[57738+(i+1)>>0]|0;if((j&255)>>>0>=e>>>0|(f>>>0>m>>>0|(f|0)==(m|0)&k>>>0>l>>>0)){j=f;n=72;break c}else i=f}}j=a[57738+(i+1)>>0]|0;f=j&255;if(f>>>0<e>>>0){i=0;while(1){k=f+($(i,e)|0)|0;i=c[r>>2]|0;if(i>>>0<(c[q>>2]|0)>>>0){c[r>>2]=i+1;i=d[i>>0]|0}else i=cB(b)|0;j=a[57738+(i+1)>>0]|0;f=j&255;if(!(k>>>0<119304647&f>>>0<e>>>0))break;else i=k}f=0}else{k=0;f=0}if((j&255)>>>0<e>>>0){n=eM(-1,-1,e|0,0)|0;o=D;m=f;while(1){if(m>>>0>o>>>0|(m|0)==(o|0)&k>>>0>n>>>0){j=m;n=72;break c}f=dM(k|0,m|0,e|0,0)|0;l=D;j=j&255;if(l>>>0>4294967295|(l|0)==-1&f>>>0>~j>>>0){j=m;n=72;break c}k=TL(j|0,0,f|0,l|0)|0;f=D;i=c[r>>2]|0;if(i>>>0<(c[q>>2]|0)>>>0){c[r>>2]=i+1;i=d[i>>0]|0}else i=cB(b)|0;j=a[57738+(i+1)>>0]|0;if((j&255)>>>0>=e>>>0){j=f;n=72;break}else m=f}}else{j=f;n=72}}while(0);if((n|0)==72)if((d[57738+(i+1)>>0]|0)>>>0<e>>>0){do{i=c[r>>2]|0;if(i>>>0<(c[q>>2]|0)>>>0){c[r>>2]=i+1;i=d[i>>0]|0}else i=cB(b)|0}while((d[57738+(i+1)>>0]|0)>>>0<e>>>0);c[(ZA()|0)>>2]=34;j=h;i=g;e=(g&1|0)==0&0==0?p:0}else{i=k;e=p}if(c[q>>2]|0)c[r>>2]=(c[r>>2]|0)+-1;if(!(j>>>0<h>>>0|(j|0)==(h|0)&i>>>0<g>>>0)){if(!((g&1|0)!=0|0!=0|(e|0)!=0)){c[(ZA()|0)>>2]=34;g=TL(g|0,h|0,-1,-1)|0;h=D;break}if(j>>>0>h>>>0|(j|0)==(h|0)&i>>>0>g>>>0){c[(ZA()|0)>>2]=34;break}}g=((e|0)<0)<<31>>31;g=UL(i^e|0,j^g|0,e|0,g|0)|0;h=D}while(0);D=h;return g|0}function bB(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;c[a+104>>2]=b;d=c[a+4>>2]|0;e=c[a+8>>2]|0;f=e-d|0;c[a+108>>2]=f;if((b|0)!=0&(f|0)>(b|0))c[a+100>>2]=d+b;else c[a+100>>2]=e;return}function cB(b){b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0;f=b+104|0;i=c[f>>2]|0;if((i|0)!=0?(c[b+108>>2]|0)>=(i|0):0)j=4;else{e=OB(b)|0;if((e|0)>=0){h=c[f>>2]|0;f=b+8|0;if(h){g=c[f>>2]|0;i=c[b+4>>2]|0;f=g;h=h-(c[b+108>>2]|0)+-1|0;if((f-i|0)>(h|0))c[b+100>>2]=i+h;else j=9}else{g=c[f>>2]|0;f=g;j=9}if((j|0)==9)c[b+100>>2]=f;f=c[b+4>>2]|0;if(g){b=b+108|0;c[b>>2]=g+1-f+(c[b>>2]|0)}f=f+-1|0;if((d[f>>0]|0|0)!=(e|0))a[f>>0]=e}else j=4}if((j|0)==4){c[b+100>>2]=0;e=-1}return e|0}function dB(a){a=a|0;if(a>>>0>4294963200){c[(ZA()|0)>>2]=0-a;a=-1}return a|0}function eB(a){a=a|0;return 0}function fB(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return d|0}function gB(a,b){a=a|0;b=b|0;return -1|0}function hB(a){a=a|0;zC(a);return}function iB(a,b){a=a|0;b=b|0;return (a+-48|0)>>>0<10|0}function jB(a,b){a=a|0;b=b|0;return YA(a)|0}function kB(b,c,d){b=b|0;c=c|0;d=d|0;if(((a[c>>0]|0)!=0?(fC(c,61244)|0)!=0:0)?(fC(c,58004)|0)!=0:0)d=0;else if(!d)d=AC(1,4)|0;return d|0}function lB(a){a=a|0;var b=0,d=0;b=(lc()|0)+176|0;d=c[b>>2]|0;if(a)c[b>>2]=a;return d|0}function mB(a,b){a=+a;b=+b;var d=0,e=0;h[k>>3]=a;e=c[k>>2]|0;d=c[k+4>>2]|0;h[k>>3]=b;d=c[k+4>>2]&-2147483648|d&2147483647;c[k>>2]=e;c[k+4>>2]=d;return +(+h[k>>3])}function nB(a,b){a=+a;b=+b;return +(+mB(a,b))}function oB(a,b){a=+a;b=+b;var d=0,e=0,f=0,g=0,i=0,j=0,l=0,m=0,n=0,o=0,p=0,q=0;h[k>>3]=a;d=c[k>>2]|0;m=c[k+4>>2]|0;h[k>>3]=b;n=c[k>>2]|0;o=c[k+4>>2]|0;e=WL(d|0,m|0,52)|0;e=e&2047;j=WL(n|0,o|0,52)|0;j=j&2047;p=m&-2147483648;i=_L(n|0,o|0,1)|0;l=D;a:do if(!((i|0)==0&(l|0)==0)?(g=o&2147483647,!(g>>>0>2146435072|(g|0)==2146435072&n>>>0>0|(e|0)==2047)):0){f=_L(d|0,m|0,1)|0;g=D;if(!(g>>>0>l>>>0|(g|0)==(l|0)&f>>>0>i>>>0))return +((f|0)==(i|0)&(g|0)==(l|0)?a*0.0:a);if(!e){e=_L(d|0,m|0,12)|0;f=D;if((f|0)>-1|(f|0)==-1&e>>>0>4294967295){g=e;e=0;do{e=e+-1|0;g=_L(g|0,f|0,1)|0;f=D}while((f|0)>-1|(f|0)==-1&g>>>0>4294967295)}else e=0;d=_L(d|0,m|0,1-e|0)|0;f=D}else f=m&1048575|1048576;if(!j){g=_L(n|0,o|0,12)|0;i=D;if((i|0)>-1|(i|0)==-1&g>>>0>4294967295){j=0;do{j=j+-1|0;g=_L(g|0,i|0,1)|0;i=D}while((i|0)>-1|(i|0)==-1&g>>>0>4294967295)}else j=0;n=_L(n|0,o|0,1-j|0)|0;m=D}else m=o&1048575|1048576;l=UL(d|0,f|0,n|0,m|0)|0;i=D;g=(i|0)>-1|(i|0)==-1&l>>>0>4294967295;b:do if((e|0)>(j|0)){while(1){if(g)if((d|0)==(n|0)&(f|0)==(m|0))break;else{d=l;f=i}d=_L(d|0,f|0,1)|0;f=D;e=e+-1|0;l=UL(d|0,f|0,n|0,m|0)|0;i=D;g=(i|0)>-1|(i|0)==-1&l>>>0>4294967295;if((e|0)<=(j|0))break b}b=a*0.0;break a}while(0);if(g)if((d|0)==(n|0)&(f|0)==(m|0)){b=a*0.0;break}else{f=i;d=l}if(f>>>0<1048576|(f|0)==1048576&d>>>0<0)do{d=_L(d|0,f|0,1)|0;f=D;e=e+-1|0}while(f>>>0<1048576|(f|0)==1048576&d>>>0<0);if((e|0)>0){o=TL(d|0,f|0,0,-1048576)|0;d=D;e=_L(e|0,0,52)|0;d=d|D;e=o|e}else{e=WL(d|0,f|0,1-e|0)|0;d=D}c[k>>2]=e;c[k+4>>2]=d|p;b=+h[k>>3]}else q=3;while(0);if((q|0)==3){b=a*b;b=b/b}return +b}function pB(a,b){a=+a;b=+b;return +(+oB(a,b))}function qB(a,b){a=+a;b=b|0;var d=0,e=0,f=0;h[k>>3]=a;d=c[k>>2]|0;e=c[k+4>>2]|0;f=WL(d|0,e|0,52)|0;f=f&2047;switch(f|0){case 0:{if(a!=0.0){a=+qB(a*18446744073709551616.0,b);d=(c[b>>2]|0)+-64|0}else d=0;c[b>>2]=d;break}case 2047:break;default:{c[b>>2]=f+-1022;c[k>>2]=d;c[k+4>>2]=e&-2146435073|1071644672;a=+h[k>>3]}}return +a}function rB(a,b){a=+a;b=b|0;return +(+qB(a,b))}function sB(a,b){a=+a;b=b|0;var d=0;if((b|0)>1023){a=a*8988465674311579538646525.0e283;d=b+-1023|0;if((d|0)>1023){d=b+-2046|0;d=(d|0)>1023?1023:d;a=a*8988465674311579538646525.0e283}}else if((b|0)<-1022){a=a*2.2250738585072014e-308;d=b+1022|0;if((d|0)<-1022){d=b+2044|0;d=(d|0)<-1022?-1022:d;a=a*2.2250738585072014e-308}}else d=b;d=_L(d+1023|0,0,52)|0;b=D;c[k>>2]=d;c[k+4>>2]=b;return +(a*+h[k>>3])}function tB(a,b){a=+a;b=b|0;return +(+sB(a,b))}function uB(a,b,c){a=a|0;b=b|0;c=c|0;return vB(0,a,b,(c|0)!=0?c:35748)|0}function vB(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;g=l;j=(f|0)==0?35752:f;f=c[j>>2]|0;a:do if(!d)if(!f)f=0;else k=15;else{h=(b|0)==0?g:b;if(!e)f=-2;else{if(!f){f=a[d>>0]|0;g=f&255;if(f<<24>>24>-1){c[h>>2]=g;f=f<<24>>24!=0&1;break}f=g+-194|0;if(f>>>0>50){k=15;break}f=c[35488+(f<<2)>>2]|0;g=e+-1|0;if(g){d=d+1|0;k=9}}else{g=e;k=9}b:do if((k|0)==9){b=a[d>>0]|0;m=(b&255)>>>3;if((m+-16|m+(f>>26))>>>0>7){k=15;break a}while(1){d=d+1|0;f=(b&255)+-128|f<<6;g=g+-1|0;if((f|0)>=0)break;if(!g)break b;b=a[d>>0]|0;if((b&-64)<<24>>24!=-128){k=15;break a}}c[j>>2]=0;c[h>>2]=f;f=e-g|0;break a}while(0);c[j>>2]=f;f=-2}}while(0);if((k|0)==15){c[j>>2]=0;c[(ZA()|0)>>2]=84;f=-1}i=l;return f|0}function wB(a){a=a|0;if(!a)a=1;else a=(c[a>>2]|0)==0;return a&1|0}function xB(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;o=i;i=i+1040|0;l=o+8|0;n=o;k=c[b>>2]|0;c[n>>2]=k;m=(a|0)!=0;e=m?e:256;a=m?a:l;g=k;a:do if((e|0)!=0&(k|0)!=0){j=e;k=g;e=0;while(1){g=d>>>2;h=g>>>0>=j>>>0;if(!(d>>>0>131|h)){g=k;break a}g=h?j:g;d=d-g|0;g=yB(a,n,g,f)|0;if((g|0)==-1){e=d;break}p=(a|0)==(l|0);k=p?0:g;h=j-k|0;a=p?a:a+(g<<2)|0;e=g+e|0;g=c[n>>2]|0;if((j|0)!=(k|0)&(g|0)!=0){j=h;k=g}else{j=h;break a}}d=e;j=0;g=c[n>>2]|0;e=-1}else{j=e;e=0}while(0);b:do if((g|0)!=0?(j|0)!=0&(d|0)!=0:0){h=g;g=a;while(1){a=vB(g,h,d,f)|0;if((a+2|0)>>>0<3)break;h=(c[n>>2]|0)+a|0;c[n>>2]=h;j=j+-1|0;e=e+1|0;if(!((j|0)!=0&(d|0)!=(a|0)))break b;else{d=d-a|0;g=g+4|0}}switch(a|0){case -1:{e=-1;break b}case 0:{c[n>>2]=0;break b}default:{c[f>>2]=0;break b}}}while(0);if(m)c[b>>2]=c[n>>2];i=o;return e|0}function yB(b,e,f,g){b=b|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0;h=c[e>>2]|0;if((g|0)!=0?(i=c[g>>2]|0,(i|0)!=0):0)if(!b){g=f;j=h;m=16}else{c[g>>2]=0;l=b;g=f;k=i;m=37}else if(!b){g=f;m=7}else{i=b;g=f;m=6}a:while(1)if((m|0)==6){if(!g){m=26;break}else b=i;while(1){i=a[h>>0]|0;do if(((i&255)+-1|0)>>>0<127?g>>>0>4&(h&3|0)==0:0){j=h;while(1){h=c[j>>2]|0;if((h+-16843009|h)&-2139062144){i=h;h=j;m=32;break}c[b>>2]=h&255;c[b+4>>2]=d[j+1>>0];c[b+8>>2]=d[j+2>>0];h=j+4|0;i=b+16|0;c[b+12>>2]=d[j+3>>0];g=g+-4|0;if(g>>>0>4){b=i;j=h}else{m=31;break}}if((m|0)==31){b=i;i=a[h>>0]|0;break}else if((m|0)==32){i=i&255;break}}while(0);i=i&255;if((i+-1|0)>>>0>=127)break;h=h+1|0;c[b>>2]=i;g=g+-1|0;if(!g){m=26;break a}else b=b+4|0}i=i+-194|0;if(i>>>0>50){m=48;break}l=b;k=c[35488+(i<<2)>>2]|0;h=h+1|0;m=37;continue}else if((m|0)==7){i=a[h>>0]|0;if(((i&255)+-1|0)>>>0<127?(h&3|0)==0:0){i=c[h>>2]|0;if(!((i+-16843009|i)&-2139062144))do{h=h+4|0;g=g+-4|0;i=c[h>>2]|0}while(((i+-16843009|i)&-2139062144|0)==0);i=i&255}i=i&255;if((i+-1|0)>>>0<127){g=g+-1|0;h=h+1|0;m=7;continue}i=i+-194|0;if(i>>>0>50){m=48;break}i=c[35488+(i<<2)>>2]|0;j=h+1|0;m=16;continue}else if((m|0)==16){m=(d[j>>0]|0)>>>3;if((m+-16|m+(i>>26))>>>0>7){m=17;break}h=j+1|0;if(i&33554432){if((a[h>>0]&-64)<<24>>24!=-128){m=20;break}h=j+2|0;if(i&524288){if((a[h>>0]&-64)<<24>>24!=-128){m=23;break}h=j+3|0}}g=g+-1|0;m=7;continue}else if((m|0)==37){i=d[h>>0]|0;m=i>>>3;if((m+-16|m+(k>>26))>>>0>7){m=38;break}j=h+1|0;b=i+-128|k<<6;if((b|0)<0){i=d[j>>0]|0;if((i&192|0)!=128){m=41;break}j=h+2|0;b=i+-128|b<<6;if((b|0)<0){i=d[j>>0]|0;if((i&192|0)!=128){m=44;break}b=i+-128|b<<6;h=h+3|0}else h=j}else h=j;c[l>>2]=b;i=l+4|0;g=g+-1|0;m=6;continue}if((m|0)==17){h=j+-1|0;m=47}else if((m|0)==20){h=j+-1|0;m=47}else if((m|0)==23){h=j+-1|0;m=47}else if((m|0)==26)c[e>>2]=h;else if((m|0)==38){b=l;i=k;h=h+-1|0;m=47}else if((m|0)==41){g=l;f=h+-1|0;m=52}else if((m|0)==44){g=l;f=h+-1|0;m=52}if((m|0)==47)if(!i)m=48;else{g=b;f=h;m=52}if((m|0)==48)if(!(a[h>>0]|0)){if(b){c[b>>2]=0;c[e>>2]=0}f=f-g|0}else{g=b;f=h;m=52}if((m|0)==52){c[(ZA()|0)>>2]=84;if(!g)f=-1;else{c[e>>2]=f;f=-1}}return f|0}function zB(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0;k=i;i=i+16|0;g=k;a:do if(!e)g=0;else{do if(f){j=(b|0)==0?g:b;g=a[e>>0]|0;b=g&255;if(g<<24>>24>-1){c[j>>2]=b;g=g<<24>>24!=0&1;break a}g=b+-194|0;if(g>>>0<=50){b=e+1|0;h=c[35488+(g<<2)>>2]|0;if(f>>>0<4?(h&-2147483648>>>((f*6|0)+-6|0)|0)!=0:0)break;g=d[b>>0]|0;f=g>>>3;if((f+-16|f+(h>>26))>>>0<=7){g=g+-128|h<<6;if((g|0)>=0){c[j>>2]=g;g=2;break a}b=d[e+2>>0]|0;if((b&192|0)==128){b=b+-128|g<<6;if((b|0)>=0){c[j>>2]=b;g=3;break a}g=d[e+3>>0]|0;if((g&192|0)==128){c[j>>2]=g+-128|b<<6;g=4;break a}}}}}while(0);c[(ZA()|0)>>2]=84;g=-1}while(0);i=k;return g|0}function AB(b,d,e){b=b|0;d=d|0;e=e|0;do if(b){if(d>>>0<128){a[b>>0]=d;b=1;break}if(d>>>0<2048){a[b>>0]=d>>>6|192;a[b+1>>0]=d&63|128;b=2;break}if(d>>>0<55296|(d&-8192|0)==57344){a[b>>0]=d>>>12|224;a[b+1>>0]=d>>>6&63|128;a[b+2>>0]=d&63|128;b=3;break}if((d+-65536|0)>>>0<1048576){a[b>>0]=d>>>18|240;a[b+1>>0]=d>>>12&63|128;a[b+2>>0]=d>>>6&63|128;a[b+3>>0]=d&63|128;b=4;break}else{c[(ZA()|0)>>2]=84;b=-1;break}}else b=1;while(0);return b|0}function BB(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0;m=i;i=i+272|0;j=m+8|0;l=m;h=c[b>>2]|0;c[l>>2]=h;k=(a|0)!=0;f=k?e:256;e=k?a:j;a=h;a:do if((f|0)!=0&(h|0)!=0){h=f;g=a;f=0;while(1){a=d>>>0>=h>>>0;if(!(a|d>>>0>32)){a=g;break a}a=a?h:d;d=d-a|0;a=CB(e,l,a,0)|0;if((a|0)==-1){f=d;break}o=(e|0)==(j|0);n=o?0:a;g=h-n|0;e=o?e:e+a|0;f=a+f|0;a=c[l>>2]|0;if((h|0)!=(n|0)&(a|0)!=0){h=g;g=a}else{h=g;break a}}d=f;h=0;a=c[l>>2]|0;f=-1}else{h=f;f=0}while(0);b:do if((a|0)!=0?(h|0)!=0&(d|0)!=0:0){g=a;a=e;while(1){e=AB(a,c[g>>2]|0,0)|0;if((e+1|0)>>>0<2)break;g=(c[l>>2]|0)+4|0;c[l>>2]=g;d=d+-1|0;f=f+1|0;if(!((h|0)!=(e|0)&(d|0)!=0))break b;else{h=h-e|0;a=a+e|0}}if(!e)c[l>>2]=0;else f=-1}while(0);if(k)c[b>>2]=c[l>>2];i=m;return f|0}function CB(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0;k=i;i=i+16|0;j=k;a:do if(!b){b=c[d>>2]|0;f=c[b>>2]|0;if(!f)e=0;else{e=0;do{if(f>>>0>127){f=AB(j,f,0)|0;if((f|0)==-1){e=-1;break a}}else f=1;e=f+e|0;b=b+4|0;f=c[b>>2]|0}while((f|0)!=0)}}else{b:do if(e>>>0>3){f=e;g=c[d>>2]|0;while(1){h=c[g>>2]|0;if((h+-1|0)>>>0>126){if(!h)break;h=AB(b,h,0)|0;if((h|0)==-1){e=-1;break a}b=b+h|0;f=f-h|0}else{a[b>>0]=h;b=b+1|0;f=f+-1|0;g=c[d>>2]|0}g=g+4|0;c[d>>2]=g;if(f>>>0<=3)break b}a[b>>0]=0;c[d>>2]=0;e=e-f|0;break a}else f=e;while(0);if(f){g=c[d>>2]|0;while(1){h=c[g>>2]|0;if((h+-1|0)>>>0>126){if(!h){g=19;break}h=AB(j,h,0)|0;if((h|0)==-1){e=-1;break a}if(f>>>0<h>>>0){g=22;break}AB(b,c[g>>2]|0,0)|0;b=b+h|0;f=f-h|0}else{a[b>>0]=h;b=b+1|0;f=f+-1|0;g=c[d>>2]|0}g=g+4|0;c[d>>2]=g;if(!f)break a}if((g|0)==19){a[b>>0]=0;c[d>>2]=0;e=e-f|0;break}else if((g|0)==22){e=e-f|0;break}}}while(0);i=k;return e|0}function DB(a,b){a=a|0;b=b|0;if(!a)a=0;else a=AB(a,b,0)|0;return a|0}function EB(a){a=a|0;return 0}function FB(a){a=a|0;return}function GB(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0;m=i;i=i+16|0;l=m;k=e&255;a[l>>0]=k;g=b+16|0;h=c[g>>2]|0;if(!h)if(!(NB(b)|0)){h=c[g>>2]|0;j=4}else f=-1;else j=4;do if((j|0)==4){g=b+20|0;j=c[g>>2]|0;if(j>>>0<h>>>0?(f=e&255,(f|0)!=(a[b+75>>0]|0)):0){c[g>>2]=j+1;a[j>>0]=k;break}if((fd[c[b+36>>2]&127](b,l,1)|0)==1)f=d[l>>0]|0;else f=-1}while(0);i=m;return f|0}function HB(a){a=a|0;var b=0,d=0;b=i;i=i+16|0;d=b;c[d>>2]=c[a+60>>2];a=dB(Lc(6,d|0)|0)|0;i=b;return a|0}function IB(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;f=i;i=i+32|0;g=f;e=f+20|0;c[g>>2]=c[a+60>>2];c[g+4>>2]=0;c[g+8>>2]=b;c[g+12>>2]=e;c[g+16>>2]=d;if((dB(Sc(140,g|0)|0)|0)<0){c[e>>2]=-1;a=-1}else a=c[e>>2]|0;i=f;return a|0}function JB(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;q=i;i=i+48|0;n=q+16|0;m=q;e=q+32|0;o=a+28|0;f=c[o>>2]|0;c[e>>2]=f;p=a+20|0;f=(c[p>>2]|0)-f|0;c[e+4>>2]=f;c[e+8>>2]=b;c[e+12>>2]=d;k=a+60|0;l=a+44|0;b=2;f=f+d|0;while(1){if(!(c[8861]|0)){c[n>>2]=c[k>>2];c[n+4>>2]=e;c[n+8>>2]=b;h=dB(Vc(146,n|0)|0)|0}else{Mc(343,a|0);c[m>>2]=c[k>>2];c[m+4>>2]=e;c[m+8>>2]=b;h=dB(Vc(146,m|0)|0)|0;xb(0)}if((f|0)==(h|0)){f=6;break}if((h|0)<0){f=8;break}f=f-h|0;g=c[e+4>>2]|0;if(h>>>0<=g>>>0)if((b|0)==2){c[o>>2]=(c[o>>2]|0)+h;j=g;b=2}else j=g;else{j=c[l>>2]|0;c[o>>2]=j;c[p>>2]=j;j=c[e+12>>2]|0;h=h-g|0;e=e+8|0;b=b+-1|0}c[e>>2]=(c[e>>2]|0)+h;c[e+4>>2]=j-h}if((f|0)==6){n=c[l>>2]|0;c[a+16>>2]=n+(c[a+48>>2]|0);a=n;c[o>>2]=a;c[p>>2]=a}else if((f|0)==8){c[a+16>>2]=0;c[o>>2]=0;c[p>>2]=0;c[a>>2]=c[a>>2]|32;if((b|0)==2)d=0;else d=d-(c[e+4>>2]|0)|0}i=q;return d|0}function KB(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;g=i;i=i+80|0;f=g;c[b+36>>2]=74;if((c[b>>2]&64|0)==0?(c[f>>2]=c[b+60>>2],c[f+4>>2]=21505,c[f+8>>2]=g+12,(wc(54,f|0)|0)!=0):0)a[b+75>>0]=-1;f=JB(b,d,e)|0;i=g;return f|0}function LB(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=a+84|0;g=c[e>>2]|0;h=d+256|0;f=aC(g,0,h)|0;f=(f|0)==0?h:f-g|0;d=f>>>0<d>>>0?f:d;XL(b|0,g|0,d|0)|0;c[a+4>>2]=g+d;b=g+f|0;c[a+8>>2]=b;c[e>>2]=b;return d|0}function MB(b){b=b|0;var d=0,e=0;d=b+74|0;e=a[d>>0]|0;a[d>>0]=e+255|e;d=b+20|0;e=b+44|0;if((c[d>>2]|0)>>>0>(c[e>>2]|0)>>>0)fd[c[b+36>>2]&127](b,0,0)|0;c[b+16>>2]=0;c[b+28>>2]=0;c[d>>2]=0;d=c[b>>2]|0;if(d&20)if(!(d&4))d=-1;else{c[b>>2]=d|32;d=-1}else{d=c[e>>2]|0;c[b+8>>2]=d;c[b+4>>2]=d;d=0}return d|0}function NB(b){b=b|0;var d=0,e=0;d=b+74|0;e=a[d>>0]|0;a[d>>0]=e+255|e;d=c[b>>2]|0;if(!(d&8)){c[b+8>>2]=0;c[b+4>>2]=0;d=c[b+44>>2]|0;c[b+28>>2]=d;c[b+20>>2]=d;c[b+16>>2]=d+(c[b+48>>2]|0);d=0}else{c[b>>2]=d|32;d=-1}return d|0}function OB(a){a=a|0;var b=0,e=0;e=i;i=i+16|0;b=e;if((c[a+8>>2]|0)==0?(MB(a)|0)!=0:0)b=-1;else if((fd[c[a+32>>2]&127](a,b,1)|0)==1)b=d[b>>0]|0;else b=-1;i=e;return b|0}function PB(a){a=a|0;var b=0,d=0;do if(a){if((c[a+76>>2]|0)<=-1){b=pC(a)|0;break}d=(EB(a)|0)==0;b=pC(a)|0;if(!d)FB(a)}else{if(!(c[8924]|0))b=0;else b=PB(c[8924]|0)|0;zb(35472);a=c[8867]|0;if(a)do{if((c[a+76>>2]|0)>-1)d=EB(a)|0;else d=0;if((c[a+20>>2]|0)>>>0>(c[a+28>>2]|0)>>>0)b=pC(a)|0|b;if(d)FB(a);a=c[a+56>>2]|0}while((a|0)!=0);xc(35472)}while(0);return b|0}function QB(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;if((c[d+76>>2]|0)>=0?(EB(d)|0)!=0:0){if((a[d+75>>0]|0)!=(b|0)?(f=d+20|0,g=c[f>>2]|0,g>>>0<(c[d+16>>2]|0)>>>0):0){c[f>>2]=g+1;a[g>>0]=b;e=b&255}else e=GB(d,b)|0;FB(d)}else i=3;do if((i|0)==3){if((a[d+75>>0]|0)!=(b|0)?(h=d+20|0,e=c[h>>2]|0,e>>>0<(c[d+16>>2]|0)>>>0):0){c[h>>2]=e+1;a[e>>0]=b;e=b&255;break}e=GB(d,b)|0}while(0);return e|0}function RB(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;f=e+16|0;g=c[f>>2]|0;if(!g)if(!(NB(e)|0)){g=c[f>>2]|0;h=4}else f=0;else h=4;a:do if((h|0)==4){i=e+20|0;h=c[i>>2]|0;if((g-h|0)>>>0<d>>>0){f=fd[c[e+36>>2]&127](e,b,d)|0;break}b:do if((a[e+75>>0]|0)>-1){f=d;while(1){if(!f){g=h;f=0;break b}g=f+-1|0;if((a[b+g>>0]|0)==10)break;else f=g}if((fd[c[e+36>>2]&127](e,b,f)|0)>>>0<f>>>0)break a;d=d-f|0;b=b+f|0;g=c[i>>2]|0}else{g=h;f=0}while(0);XL(g|0,b|0,d|0)|0;c[i>>2]=(c[i>>2]|0)+d;f=f+d|0}while(0);return f|0}function SB(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0;f=i;i=i+16|0;g=f;c[g>>2]=e;e=XB(a,b,d,g)|0;i=f;return e|0}function TB(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;i=i+16|0;f=e;c[f>>2]=d;d=YB(a,b,f)|0;i=e;return d|0}function UB(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0;j=i;i=i+16|0;e=j;f=yC(240)|0;do if(f){c[e>>2]=c[d>>2];e=XB(f,240,b,e)|0;if(e>>>0<240){b=BC(f,e+1|0)|0;c[a>>2]=(b|0)!=0?b:f;break}zC(f);if((e|0)>=0?(h=e+1|0,g=yC(h)|0,c[a>>2]=g,(g|0)!=0):0)e=XB(g,h,b,d)|0;else e=-1}else e=-1;while(0);i=j;return e|0}function VB(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;s=i;i=i+224|0;o=s+80|0;r=s+96|0;q=s;p=s+136|0;f=r;g=f+40|0;do{c[f>>2]=0;f=f+4|0}while((f|0)<(g|0));c[o>>2]=c[e>>2];if((qC(0,d,o,q,r)|0)<0)e=-1;else{if((c[b+76>>2]|0)>-1)m=EB(b)|0;else m=0;e=c[b>>2]|0;n=e&32;if((a[b+74>>0]|0)<1)c[b>>2]=e&-33;e=b+48|0;if(!(c[e>>2]|0)){g=b+44|0;h=c[g>>2]|0;c[g>>2]=p;j=b+28|0;c[j>>2]=p;k=b+20|0;c[k>>2]=p;c[e>>2]=80;l=b+16|0;c[l>>2]=p+80;f=qC(b,d,o,q,r)|0;if(h){fd[c[b+36>>2]&127](b,0,0)|0;f=(c[k>>2]|0)==0?-1:f;c[g>>2]=h;c[e>>2]=0;c[l>>2]=0;c[j>>2]=0;c[k>>2]=0}}else f=qC(b,d,o,q,r)|0;e=c[b>>2]|0;c[b>>2]=e|n;if(m)FB(b);e=(e&32|0)==0?f:-1}i=s;return e|0}function WB(e,f,j){e=e|0;f=f|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0.0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0;P=i;i=i+304|0;H=P+16|0;J=P+8|0;I=P+33|0;K=P;y=P+32|0;if((c[e+76>>2]|0)>-1)O=EB(e)|0;else O=0;k=a[f>>0]|0;a:do if(k<<24>>24){L=e+4|0;M=e+100|0;G=e+108|0;z=e+8|0;A=I+10|0;B=I+33|0;C=J+4|0;E=I+46|0;F=I+94|0;m=k;k=0;n=f;s=0;l=0;f=0;b:while(1){c:do if(!(XA(m&255)|0)){m=(a[n>>0]|0)==37;d:do if(m){q=n+1|0;o=a[q>>0]|0;e:do switch(o<<24>>24){case 37:break d;case 42:{x=0;o=n+2|0;break}default:{o=(o&255)+-48|0;if(o>>>0<10?(a[n+2>>0]|0)==36:0){c[H>>2]=c[j>>2];while(1){x=(c[H>>2]|0)+(4-1)&~(4-1);m=c[x>>2]|0;c[H>>2]=x+4;if(o>>>0>1)o=o+-1|0;else break}x=m;o=n+3|0;break e}o=(c[j>>2]|0)+(4-1)&~(4-1);x=c[o>>2]|0;c[j>>2]=o+4;o=q}}while(0);m=a[o>>0]|0;n=m&255;if((n+-48|0)>>>0<10){m=0;while(1){q=(m*10|0)+-48+n|0;o=o+1|0;m=a[o>>0]|0;n=m&255;if((n+-48|0)>>>0>=10)break;else m=q}}else q=0;if(m<<24>>24==109){o=o+1|0;r=a[o>>0]|0;m=(x|0)!=0&1;l=0;f=0}else{r=m;m=0}n=o+1|0;switch(r&255|0){case 104:{w=(a[n>>0]|0)==104;n=w?o+2|0:n;o=w?-2:-1;break}case 108:{w=(a[n>>0]|0)==108;n=w?o+2|0:n;o=w?3:1;break}case 106:{o=3;break}case 116:case 122:{o=1;break}case 76:{o=2;break}case 110:case 112:case 67:case 83:case 91:case 99:case 115:case 88:case 71:case 70:case 69:case 65:case 103:case 102:case 101:case 97:case 120:case 117:case 111:case 105:case 100:{n=o;o=0;break}default:{N=152;break b}}r=d[n>>0]|0;t=(r&47|0)==3;r=t?r|32:r;t=t?1:o;switch(r|0){case 99:{w=s;v=(q|0)<1?1:q;break}case 91:{w=s;v=q;break}case 110:{if(!x){o=s;break c}switch(t|0){case -2:{a[x>>0]=s;o=s;break c}case -1:{b[x>>1]=s;o=s;break c}case 0:{c[x>>2]=s;o=s;break c}case 1:{c[x>>2]=s;o=s;break c}case 3:{o=x;c[o>>2]=s;c[o+4>>2]=((s|0)<0)<<31>>31;o=s;break c}default:{o=s;break c}}}default:{bB(e,0);do{o=c[L>>2]|0;if(o>>>0<(c[M>>2]|0)>>>0){c[L>>2]=o+1;o=d[o>>0]|0}else o=cB(e)|0}while((XA(o)|0)!=0);o=c[L>>2]|0;if(c[M>>2]|0){o=o+-1|0;c[L>>2]=o}w=(c[G>>2]|0)+s+o-(c[z>>2]|0)|0;v=q}}bB(e,v);o=c[L>>2]|0;q=c[M>>2]|0;if(o>>>0<q>>>0)c[L>>2]=o+1;else{if((cB(e)|0)<0){N=152;break b}q=c[M>>2]|0}if(q)c[L>>2]=(c[L>>2]|0)+-1;f:do switch(r|0){case 91:case 99:case 115:{u=(r|0)==99;g:do if((r&239|0)==99){ZL(I|0,-1,257)|0;a[I>>0]=0;if((r|0)==115){a[B>>0]=0;a[A>>0]=0;a[A+1>>0]=0;a[A+2>>0]=0;a[A+3>>0]=0;a[A+4>>0]=0}}else{Q=n+1|0;s=(a[Q>>0]|0)==94;o=s&1;r=s?Q:n;n=s?n+2|0:Q;ZL(I|0,s&1|0,257)|0;a[I>>0]=0;switch(a[n>>0]|0){case 45:{s=(o^1)&255;a[E>>0]=s;n=r+2|0;break}case 93:{s=(o^1)&255;a[F>>0]=s;n=r+2|0;break}default:s=(o^1)&255}while(1){o=a[n>>0]|0;h:do switch(o<<24>>24){case 0:{N=152;break b}case 93:break g;case 45:{r=n+1|0;o=a[r>>0]|0;switch(o<<24>>24){case 93:case 0:{o=45;break h}default:{}}n=a[n+-1>>0]|0;if((n&255)<(o&255)){n=n&255;do{n=n+1|0;a[I+n>>0]=s;o=a[r>>0]|0}while((n|0)<(o&255|0));n=r}else n=r;break}default:{}}while(0);a[I+((o&255)+1)>>0]=s;n=n+1|0}}while(0);r=u?v+1|0:31;s=(t|0)==1;t=(m|0)!=0;i:do if(s){if(t){f=yC(r<<2)|0;if(!f){l=0;N=152;break b}}else f=x;c[J>>2]=0;c[C>>2]=0;l=0;j:while(1){q=(f|0)==0;do{k:while(1){o=c[L>>2]|0;if(o>>>0<(c[M>>2]|0)>>>0){c[L>>2]=o+1;o=d[o>>0]|0}else o=cB(e)|0;if(!(a[I+(o+1)>>0]|0))break j;a[y>>0]=o;switch(vB(K,y,1,J)|0){case -1:{l=0;N=152;break b}case -2:break;default:break k}}if(!q){c[f+(l<<2)>>2]=c[K>>2];l=l+1|0}}while(!(t&(l|0)==(r|0)));l=r<<1|1;o=BC(f,l<<2)|0;if(!o){l=0;N=152;break b}Q=r;r=l;f=o;l=Q}if(!(wB(J)|0)){l=0;N=152;break b}else{q=l;l=0}}else{if(t){l=yC(r)|0;if(!l){l=0;f=0;N=152;break b}else o=0;while(1){do{f=c[L>>2]|0;if(f>>>0<(c[M>>2]|0)>>>0){c[L>>2]=f+1;f=d[f>>0]|0}else f=cB(e)|0;if(!(a[I+(f+1)>>0]|0)){q=o;f=0;break i}a[l+o>>0]=f;o=o+1|0}while((o|0)!=(r|0));f=r<<1|1;o=BC(l,f)|0;if(!o){f=0;N=152;break b}else{Q=r;r=f;l=o;o=Q}}}if(!x){l=q;while(1){f=c[L>>2]|0;if(f>>>0<l>>>0){c[L>>2]=f+1;f=d[f>>0]|0}else f=cB(e)|0;if(!(a[I+(f+1)>>0]|0)){q=0;l=0;f=0;break i}l=c[M>>2]|0}}else{l=0;while(1){f=c[L>>2]|0;if(f>>>0<q>>>0){c[L>>2]=f+1;f=d[f>>0]|0}else f=cB(e)|0;if(!(a[I+(f+1)>>0]|0)){q=l;l=x;f=0;break i}a[x+l>>0]=f;q=c[M>>2]|0;l=l+1|0}}}while(0);o=c[L>>2]|0;if(c[M>>2]|0){o=o+-1|0;c[L>>2]=o}o=o-(c[z>>2]|0)+(c[G>>2]|0)|0;if(!o)break b;if(!((o|0)==(v|0)|u^1))break b;do if(t)if(s){c[x>>2]=f;break}else{c[x>>2]=l;break}while(0);if(!u){if(f)c[f+(q<<2)>>2]=0;if(!l){l=0;break f}a[l+q>>0]=0}break}case 120:case 88:case 112:{o=16;N=134;break}case 111:{o=8;N=134;break}case 117:case 100:{o=10;N=134;break}case 105:{o=0;N=134;break}case 71:case 103:case 70:case 102:case 69:case 101:case 65:case 97:{p=+$A(e,t,0);if((c[G>>2]|0)==((c[z>>2]|0)-(c[L>>2]|0)|0))break b;if(x)switch(t|0){case 0:{g[x>>2]=p;break f}case 1:{h[x>>3]=p;break f}case 2:{h[x>>3]=p;break f}default:break f}break}default:{}}while(0);l:do if((N|0)==134){N=0;o=aB(e,o,0,-1,-1)|0;if((c[G>>2]|0)==((c[z>>2]|0)-(c[L>>2]|0)|0))break b;if((x|0)!=0&(r|0)==112){c[x>>2]=o;break}if(x)switch(t|0){case -2:{a[x>>0]=o;break l}case -1:{b[x>>1]=o;break l}case 0:{c[x>>2]=o;break l}case 1:{c[x>>2]=o;break l}case 3:{Q=x;c[Q>>2]=o;c[Q+4>>2]=D;break l}default:break l}}while(0);k=((x|0)!=0&1)+k|0;o=(c[G>>2]|0)+w+(c[L>>2]|0)-(c[z>>2]|0)|0;break c}while(0);n=n+(m&1)|0;bB(e,0);m=c[L>>2]|0;if(m>>>0<(c[M>>2]|0)>>>0){c[L>>2]=m+1;m=d[m>>0]|0}else m=cB(e)|0;if((m|0)!=(d[n>>0]|0)){N=21;break b}o=s+1|0}else{while(1){m=n+1|0;if(!(XA(d[m>>0]|0)|0))break;else n=m}bB(e,0);do{m=c[L>>2]|0;if(m>>>0<(c[M>>2]|0)>>>0){c[L>>2]=m+1;m=d[m>>0]|0}else m=cB(e)|0}while((XA(m)|0)!=0);m=c[L>>2]|0;if(c[M>>2]|0){m=m+-1|0;c[L>>2]=m}o=(c[G>>2]|0)+s+m-(c[z>>2]|0)|0}while(0);n=n+1|0;m=a[n>>0]|0;if(!(m<<24>>24))break a;else s=o}if((N|0)==21){if(c[M>>2]|0)c[L>>2]=(c[L>>2]|0)+-1;if((k|0)!=0|(m|0)>-1)break;else{k=0;N=153}}else if((N|0)==152)if(!k){k=m;N=153}if((N|0)==153){m=k;k=-1}if(m){zC(l);zC(f)}}else k=0;while(0);if(O)FB(e);i=P;return k|0}function XB(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0;n=i;i=i+128|0;g=n+112|0;m=n;h=m;j=35756;k=h+112|0;do{c[h>>2]=c[j>>2];h=h+4|0;j=j+4|0}while((h|0)<(k|0));if((d+-1|0)>>>0>2147483646)if(!d){d=1;l=4}else{c[(ZA()|0)>>2]=75;d=-1}else{g=b;l=4}if((l|0)==4){l=-2-g|0;l=d>>>0>l>>>0?l:d;c[m+48>>2]=l;b=m+20|0;c[b>>2]=g;c[m+44>>2]=g;d=g+l|0;g=m+16|0;c[g>>2]=d;c[m+28>>2]=d;d=VB(m,e,f)|0;if(l){e=c[b>>2]|0;a[e+(((e|0)==(c[g>>2]|0))<<31>>31)>>0]=0}}i=n;return d|0}function YB(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;g=i;i=i+112|0;e=g;f=e;h=f+112|0;do{c[f>>2]=0;f=f+4|0}while((f|0)<(h|0));c[e+32>>2]=120;c[e+44>>2]=a;c[e+76>>2]=-1;c[e+84>>2]=a;h=WB(e,b,d)|0;i=g;return h|0}function ZB(a,b,c){a=a|0;b=b|0;c=c|0;return +(+sC(a,b,2))}function _B(a,b,c){a=a|0;b=b|0;c=c|0;a=tC(a,b,c,-1,-1)|0;return a|0}function $B(a,b,c){a=a|0;b=b|0;c=c|0;a=tC(a,b,c,0,-2147483648)|0;return a|0}function aC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;h=d&255;f=(e|0)!=0;a:do if(f&(b&3|0)!=0){g=d&255;while(1){if((a[b>>0]|0)==g<<24>>24){i=6;break a}b=b+1|0;e=e+-1|0;f=(e|0)!=0;if(!(f&(b&3|0)!=0)){i=5;break}}}else i=5;while(0);if((i|0)==5)if(f)i=6;else e=0;b:do if((i|0)==6){g=d&255;if((a[b>>0]|0)!=g<<24>>24){f=$(h,16843009)|0;c:do if(e>>>0>3)while(1){h=c[b>>2]^f;if((h&-2139062144^-2139062144)&h+-16843009)break;b=b+4|0;e=e+-4|0;if(e>>>0<=3){i=11;break c}}else i=11;while(0);if((i|0)==11)if(!e){e=0;break}while(1){if((a[b>>0]|0)==g<<24>>24)break b;b=b+1|0;e=e+-1|0;if(!e){e=0;break}}}}while(0);return ((e|0)!=0?b:0)|0}function bC(b,c,d){b=b|0;c=c|0;d=d|0;var e=0,f=0;a:do if(!d)d=0;else{f=d;e=b;while(1){b=a[e>>0]|0;d=a[c>>0]|0;if(b<<24>>24!=d<<24>>24)break;f=f+-1|0;if(!f){d=0;break a}else{e=e+1|0;c=c+1|0}}d=(b&255)-(d&255)|0}while(0);return d|0}function cC(b,d){b=b|0;d=d|0;var e=0,f=0;e=d;a:do if(!((e^b)&3)){if(e&3)do{e=a[d>>0]|0;a[b>>0]=e;if(!(e<<24>>24))break a;d=d+1|0;b=b+1|0}while((d&3|0)!=0);e=c[d>>2]|0;if(!((e&-2139062144^-2139062144)&e+-16843009)){f=b;while(1){d=d+4|0;b=f+4|0;c[f>>2]=e;e=c[d>>2]|0;if((e&-2139062144^-2139062144)&e+-16843009)break;else f=b}}f=8}else f=8;while(0);if((f|0)==8){f=a[d>>0]|0;a[b>>0]=f;if(f<<24>>24)do{d=d+1|0;b=b+1|0;f=a[d>>0]|0;a[b>>0]=f}while(f<<24>>24!=0)}return b|0}function dC(b,c){b=b|0;c=c|0;b=eC(b,c)|0;return ((a[b>>0]|0)==(c&255)<<24>>24?b:0)|0}function eC(b,d){b=b|0;d=d|0;var e=0,f=0,g=0;f=d&255;a:do if(!f)b=b+(iC(b)|0)|0;else{if(b&3){e=d&255;do{g=a[b>>0]|0;if(g<<24>>24==0?1:g<<24>>24==e<<24>>24)break a;b=b+1|0}while((b&3|0)!=0)}f=$(f,16843009)|0;e=c[b>>2]|0;b:do if(!((e&-2139062144^-2139062144)&e+-16843009))do{g=e^f;if((g&-2139062144^-2139062144)&g+-16843009)break b;b=b+4|0;e=c[b>>2]|0}while(((e&-2139062144^-2139062144)&e+-16843009|0)==0);while(0);e=d&255;while(1){g=a[b>>0]|0;if(g<<24>>24==0?1:g<<24>>24==e<<24>>24)break;else b=b+1|0}}while(0);return b|0}function fC(b,c){b=b|0;c=c|0;var d=0,e=0;e=a[b>>0]|0;d=a[c>>0]|0;if(e<<24>>24==0?1:e<<24>>24!=d<<24>>24)c=e;else{do{b=b+1|0;c=c+1|0;e=a[b>>0]|0;d=a[c>>0]|0}while(!(e<<24>>24==0?1:e<<24>>24!=d<<24>>24));c=e}return (c&255)-(d&255)|0}function gC(a,b){a=a|0;b=b|0;cC(a,b)|0;return a|0}function hC(a){a=a|0;var b=0,c=0;c=(iC(a)|0)+1|0;b=yC(c)|0;if(!b)b=0;else XL(b|0,a|0,c|0)|0;return b|0}function iC(b){b=b|0;var d=0,e=0,f=0;f=b;a:do if(!(f&3))e=4;else{d=b;b=f;while(1){if(!(a[d>>0]|0))break a;d=d+1|0;b=d;if(!(b&3)){b=d;e=4;break}}}while(0);if((e|0)==4){while(1){d=c[b>>2]|0;if(!((d&-2139062144^-2139062144)&d+-16843009))b=b+4|0;else break}if((d&255)<<24>>24)do b=b+1|0;while((a[b>>0]|0)!=0)}return b-f|0}function jC(a){a=a|0;var b=0;b=a;while(1)if(!(c[b>>2]|0))break;else b=b+4|0;return b-a>>2|0}function kC(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;if(d){e=a;while(1){d=d+-1|0;c[e>>2]=c[b>>2];if(!d)break;else{b=b+4|0;e=e+4|0}}}return a|0}function lC(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;e=(d|0)==0;if(a-b>>2>>>0<d>>>0){if(!e)do{d=d+-1|0;c[a+(d<<2)>>2]=c[b+(d<<2)>>2]}while((d|0)!=0)}else if(!e){e=b;b=a;while(1){d=d+-1|0;c[b>>2]=c[e>>2];if(!d)break;else{e=e+4|0;b=b+4|0}}}return a|0}function mC(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;if(d){e=a;while(1){d=d+-1|0;c[e>>2]=b;if(!d)break;else e=e+4|0}}return a|0}function nC(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0;i=a+4|0;e=c[i>>2]|0;j=a+100|0;if(e>>>0<(c[j>>2]|0)>>>0){c[i>>2]=e+1;e=d[e>>0]|0}else e=cB(a)|0;switch(e|0){case 43:case 45:{f=(e|0)==45&1;e=c[i>>2]|0;if(e>>>0<(c[j>>2]|0)>>>0){c[i>>2]=e+1;e=d[e>>0]|0}else e=cB(a)|0;if((b|0)!=0&(e+-48|0)>>>0>9?(c[j>>2]|0)!=0:0){c[i>>2]=(c[i>>2]|0)+-1;h=f}else h=f;break}default:h=0}if((e+-48|0)>>>0>9)if(!(c[j>>2]|0)){f=-2147483648;e=0}else{c[i>>2]=(c[i>>2]|0)+-1;f=-2147483648;e=0}else{f=0;do{f=e+-48+(f*10|0)|0;e=c[i>>2]|0;if(e>>>0<(c[j>>2]|0)>>>0){c[i>>2]=e+1;e=d[e>>0]|0}else e=cB(a)|0}while((e+-48|0)>>>0<10&(f|0)<214748364);b=((f|0)<0)<<31>>31;if((e+-48|0)>>>0<10){do{b=dM(f|0,b|0,10,0)|0;f=D;e=TL(e|0,((e|0)<0)<<31>>31|0,-48,-1)|0;f=TL(e|0,D|0,b|0,f|0)|0;b=D;e=c[i>>2]|0;if(e>>>0<(c[j>>2]|0)>>>0){c[i>>2]=e+1;e=d[e>>0]|0}else e=cB(a)|0}while((e+-48|0)>>>0<10&((b|0)<21474836|(b|0)==21474836&f>>>0<2061584302));g=f}else g=f;if((e+-48|0)>>>0<10)do{e=c[i>>2]|0;if(e>>>0<(c[j>>2]|0)>>>0){c[i>>2]=e+1;e=d[e>>0]|0}else e=cB(a)|0}while((e+-48|0)>>>0<10);if(c[j>>2]|0)c[i>>2]=(c[i>>2]|0)+-1;a=(h|0)!=0;e=UL(0,0,g|0,b|0)|0;f=a?D:b;e=a?e:g}D=f;return e|0}function oC(a){a=a|0;if(!(c[a+68>>2]|0))FB(a);return}function pC(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0;b=a+20|0;g=a+28|0;if((c[b>>2]|0)>>>0>(c[g>>2]|0)>>>0?(fd[c[a+36>>2]&127](a,0,0)|0,(c[b>>2]|0)==0):0)b=-1;else{h=a+4|0;d=c[h>>2]|0;e=a+8|0;f=c[e>>2]|0;if(d>>>0<f>>>0)fd[c[a+40>>2]&127](a,d-f|0,1)|0;c[a+16>>2]=0;c[g>>2]=0;c[b>>2]=0;c[e>>2]=0;c[h>>2]=0;b=0}return b|0}function qC(e,f,g,j,l){e=e|0;f=f|0;g=g|0;j=j|0;l=l|0;var m=0,n=0,o=0,p=0,q=0.0,r=0,s=0,t=0,u=0,v=0.0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0;ha=i;i=i+624|0;ca=ha+24|0;ea=ha+16|0;da=ha+588|0;Y=ha+576|0;ba=ha;V=ha+536|0;ga=ha+8|0;fa=ha+528|0;M=(e|0)!=0;N=V+40|0;U=N;V=V+39|0;W=ga+4|0;X=Y+12|0;Y=Y+11|0;Z=da;_=X;aa=_-Z|0;O=-2-Z|0;P=_+2|0;Q=ca+288|0;R=da+9|0;S=R;T=da+8|0;m=0;w=f;n=0;f=0;a:while(1){do if((m|0)>-1)if((n|0)>(2147483647-m|0)){c[(ZA()|0)>>2]=75;m=-1;break}else{m=n+m|0;break}while(0);n=a[w>>0]|0;if(!(n<<24>>24)){L=245;break}else o=w;b:while(1){switch(n<<24>>24){case 37:{n=o;L=9;break b}case 0:{n=o;break b}default:{}}K=o+1|0;n=a[K>>0]|0;o=K}c:do if((L|0)==9)while(1){L=0;if((a[n+1>>0]|0)!=37)break c;o=o+1|0;n=n+2|0;if((a[n>>0]|0)==37)L=9;else break}while(0);y=o-w|0;if(M?(c[e>>2]&32|0)==0:0)RB(w,y,e)|0;if((o|0)!=(w|0)){w=n;n=y;continue}r=n+1|0;o=a[r>>0]|0;p=(o<<24>>24)+-48|0;if(p>>>0<10){K=(a[n+2>>0]|0)==36;r=K?n+3|0:r;o=a[r>>0]|0;u=K?p:-1;f=K?1:f}else u=-1;n=o<<24>>24;d:do if((n&-32|0)==32){p=0;while(1){if(!(1<<n+-32&75913)){s=p;n=r;break d}p=1<<(o<<24>>24)+-32|p;r=r+1|0;o=a[r>>0]|0;n=o<<24>>24;if((n&-32|0)!=32){s=p;n=r;break}}}else{s=0;n=r}while(0);do if(o<<24>>24==42){p=n+1|0;o=(a[p>>0]|0)+-48|0;if(o>>>0<10?(a[n+2>>0]|0)==36:0){c[l+(o<<2)>>2]=10;f=1;n=n+3|0;o=c[j+((a[p>>0]|0)+-48<<3)>>2]|0}else{if(f){m=-1;break a}if(!M){x=s;n=p;f=0;K=0;break}f=(c[g>>2]|0)+(4-1)&~(4-1);o=c[f>>2]|0;c[g>>2]=f+4;f=0;n=p}if((o|0)<0){x=s|8192;K=0-o|0}else{x=s;K=o}}else{p=(o<<24>>24)+-48|0;if(p>>>0<10){o=0;do{o=(o*10|0)+p|0;n=n+1|0;p=(a[n>>0]|0)+-48|0}while(p>>>0<10);if((o|0)<0){m=-1;break a}else{x=s;K=o}}else{x=s;K=0}}while(0);e:do if((a[n>>0]|0)==46){p=n+1|0;o=a[p>>0]|0;if(o<<24>>24!=42){r=(o<<24>>24)+-48|0;if(r>>>0<10){n=p;o=0}else{n=p;r=0;break}while(1){o=(o*10|0)+r|0;n=n+1|0;r=(a[n>>0]|0)+-48|0;if(r>>>0>=10){r=o;break e}}}p=n+2|0;o=(a[p>>0]|0)+-48|0;if(o>>>0<10?(a[n+3>>0]|0)==36:0){c[l+(o<<2)>>2]=10;n=n+4|0;r=c[j+((a[p>>0]|0)+-48<<3)>>2]|0;break}if(f){m=-1;break a}if(M){n=(c[g>>2]|0)+(4-1)&~(4-1);r=c[n>>2]|0;c[g>>2]=n+4;n=p}else{n=p;r=0}}else r=-1;while(0);t=0;while(1){o=(a[n>>0]|0)+-65|0;if(o>>>0>57){m=-1;break a}p=n+1|0;o=a[59050+(t*58|0)+o>>0]|0;s=o&255;if((s+-1|0)>>>0<8){n=p;t=s}else{J=p;break}}if(!(o<<24>>24)){m=-1;break}p=(u|0)>-1;do if(o<<24>>24==19)if(p){m=-1;break a}else L=52;else{if(p){c[l+(u<<2)>>2]=s;H=j+(u<<3)|0;I=c[H+4>>2]|0;L=ba;c[L>>2]=c[H>>2];c[L+4>>2]=I;L=52;break}if(!M){m=0;break a}vC(ba,s,g)}while(0);if((L|0)==52?(L=0,!M):0){w=J;n=y;continue}u=a[n>>0]|0;u=(t|0)!=0&(u&15|0)==3?u&-33:u;p=x&-65537;I=(x&8192|0)==0?x:p;f:do switch(u|0){case 110:switch(t|0){case 0:{c[c[ba>>2]>>2]=m;w=J;n=y;continue a}case 1:{c[c[ba>>2]>>2]=m;w=J;n=y;continue a}case 2:{w=c[ba>>2]|0;c[w>>2]=m;c[w+4>>2]=((m|0)<0)<<31>>31;w=J;n=y;continue a}case 3:{b[c[ba>>2]>>1]=m;w=J;n=y;continue a}case 4:{a[c[ba>>2]>>0]=m;w=J;n=y;continue a}case 6:{c[c[ba>>2]>>2]=m;w=J;n=y;continue a}case 7:{w=c[ba>>2]|0;c[w>>2]=m;c[w+4>>2]=((m|0)<0)<<31>>31;w=J;n=y;continue a}default:{w=J;n=y;continue a}}case 112:{t=I|8;r=r>>>0>8?r:8;u=120;L=64;break}case 88:case 120:{t=I;L=64;break}case 111:{p=ba;o=c[p>>2]|0;p=c[p+4>>2]|0;if((o|0)==0&(p|0)==0)n=N;else{n=N;do{n=n+-1|0;a[n>>0]=o&7|48;o=WL(o|0,p|0,3)|0;p=D}while(!((o|0)==0&(p|0)==0))}if(!(I&8)){o=I;t=0;s=59530;L=77}else{t=U-n+1|0;o=I;r=(r|0)<(t|0)?t:r;t=0;s=59530;L=77}break}case 105:case 100:{o=ba;n=c[o>>2]|0;o=c[o+4>>2]|0;if((o|0)<0){n=UL(0,0,n|0,o|0)|0;o=D;p=ba;c[p>>2]=n;c[p+4>>2]=o;p=1;s=59530;L=76;break f}if(!(I&2048)){s=I&1;p=s;s=(s|0)==0?59530:59532;L=76}else{p=1;s=59531;L=76}break}case 117:{o=ba;n=c[o>>2]|0;o=c[o+4>>2]|0;p=0;s=59530;L=76;break}case 99:{a[V>>0]=c[ba>>2];w=V;o=1;t=0;u=59530;n=N;break}case 109:{n=_A(c[(ZA()|0)>>2]|0)|0;L=82;break}case 115:{n=c[ba>>2]|0;n=(n|0)!=0?n:59540;L=82;break}case 67:{c[ga>>2]=c[ba>>2];c[W>>2]=0;c[ba>>2]=ga;r=-1;L=86;break}case 83:{if(!r){xC(e,32,K,0,I);n=0;L=98}else L=86;break}case 65:case 71:case 70:case 69:case 97:case 103:case 102:case 101:{q=+h[ba>>3];c[ea>>2]=0;h[k>>3]=q;if((c[k+4>>2]|0)>=0)if(!(I&2048)){H=I&1;G=H;H=(H|0)==0?59548:59553}else{G=1;H=59550}else{q=-q;G=1;H=59547}h[k>>3]=q;F=c[k+4>>2]&2146435072;do if(F>>>0<2146435072|(F|0)==2146435072&0<0){v=+rB(q,ea)*2.0;o=v!=0.0;if(o)c[ea>>2]=(c[ea>>2]|0)+-1;C=u|32;if((C|0)==97){w=u&32;y=(w|0)==0?H:H+9|0;x=G|2;n=12-r|0;do if(!(r>>>0>11|(n|0)==0)){q=8.0;do{n=n+-1|0;q=q*16.0}while((n|0)!=0);if((a[y>>0]|0)==45){q=-(q+(-v-q));break}else{q=v+q-q;break}}else q=v;while(0);o=c[ea>>2]|0;n=(o|0)<0?0-o|0:o;n=wC(n,((n|0)<0)<<31>>31,X)|0;if((n|0)==(X|0)){a[Y>>0]=48;n=Y}a[n+-1>>0]=(o>>31&2)+43;t=n+-2|0;a[t>>0]=u+15;s=(r|0)<1;p=(I&8|0)==0;o=da;while(1){H=~~q;n=o+1|0;a[o>>0]=d[59514+H>>0]|w;q=(q-+(H|0))*16.0;do if((n-Z|0)==1){if(p&(s&q==0.0))break;a[n>>0]=46;n=o+2|0}while(0);if(!(q!=0.0))break;else o=n}r=(r|0)!=0&(O+n|0)<(r|0)?P+r-t|0:aa-t+n|0;p=r+x|0;xC(e,32,K,p,I);if(!(c[e>>2]&32))RB(y,x,e)|0;xC(e,48,K,p,I^65536);n=n-Z|0;if(!(c[e>>2]&32))RB(da,n,e)|0;o=_-t|0;xC(e,48,r-(n+o)|0,0,0);if(!(c[e>>2]&32))RB(t,o,e)|0;xC(e,32,K,p,I^8192);n=(p|0)<(K|0)?K:p;break}n=(r|0)<0?6:r;if(o){o=(c[ea>>2]|0)+-28|0;c[ea>>2]=o;q=v*268435456.0}else{q=v;o=c[ea>>2]|0}F=(o|0)<0?ca:Q;E=F;o=F;do{B=~~q>>>0;c[o>>2]=B;o=o+4|0;q=(q-+(B>>>0))*1.0e9}while(q!=0.0);p=o;o=c[ea>>2]|0;if((o|0)>0){s=F;while(1){t=(o|0)>29?29:o;r=p+-4|0;do if(r>>>0<s>>>0)r=s;else{o=0;do{B=_L(c[r>>2]|0,0,t|0)|0;B=TL(B|0,D|0,o|0,0)|0;o=D;A=fM(B|0,o|0,1e9,0)|0;c[r>>2]=A;o=eM(B|0,o|0,1e9,0)|0;r=r+-4|0}while(r>>>0>=s>>>0);if(!o){r=s;break}r=s+-4|0;c[r>>2]=o}while(0);while(1){if(p>>>0<=r>>>0)break;o=p+-4|0;if(!(c[o>>2]|0))p=o;else break}o=(c[ea>>2]|0)-t|0;c[ea>>2]=o;if((o|0)>0)s=r;else break}}else r=F;if((o|0)<0){y=((n+25|0)/9|0)+1|0;z=(C|0)==102;w=r;while(1){x=0-o|0;x=(x|0)>9?9:x;do if(w>>>0<p>>>0){o=(1<<x)+-1|0;s=1e9>>>x;r=0;t=w;do{B=c[t>>2]|0;c[t>>2]=(B>>>x)+r;r=$(B&o,s)|0;t=t+4|0}while(t>>>0<p>>>0);o=(c[w>>2]|0)==0?w+4|0:w;if(!r){r=o;break}c[p>>2]=r;r=o;p=p+4|0}else r=(c[w>>2]|0)==0?w+4|0:w;while(0);o=z?F:r;p=(p-o>>2|0)>(y|0)?o+(y<<2)|0:p;o=(c[ea>>2]|0)+x|0;c[ea>>2]=o;if((o|0)>=0){w=r;break}else w=r}}else w=r;do if(w>>>0<p>>>0){o=(E-w>>2)*9|0;s=c[w>>2]|0;if(s>>>0<10)break;else r=10;do{r=r*10|0;o=o+1|0}while(s>>>0>=r>>>0)}else o=0;while(0);A=(C|0)==103;B=(n|0)!=0;r=n-((C|0)!=102?o:0)+((B&A)<<31>>31)|0;if((r|0)<(((p-E>>2)*9|0)+-9|0)){t=r+9216|0;z=(t|0)/9|0;r=F+(z+-1023<<2)|0;t=((t|0)%9|0)+1|0;if((t|0)<9){s=10;do{s=s*10|0;t=t+1|0}while((t|0)!=9)}else s=10;x=c[r>>2]|0;y=(x>>>0)%(s>>>0)|0;if((y|0)==0?(F+(z+-1022<<2)|0)==(p|0):0)s=w;else L=163;do if((L|0)==163){L=0;v=(((x>>>0)/(s>>>0)|0)&1|0)==0?9007199254740992.0:9007199254740994.0;t=(s|0)/2|0;do if(y>>>0<t>>>0)q=.5;else{if((y|0)==(t|0)?(F+(z+-1022<<2)|0)==(p|0):0){q=1.0;break}q=1.5}while(0);do if(G){if((a[H>>0]|0)!=45)break;v=-v;q=-q}while(0);t=x-y|0;c[r>>2]=t;if(!(v+q!=v)){s=w;break}C=t+s|0;c[r>>2]=C;if(C>>>0>999999999){o=w;while(1){s=r+-4|0;c[r>>2]=0;if(s>>>0<o>>>0){o=o+-4|0;c[o>>2]=0}C=(c[s>>2]|0)+1|0;c[s>>2]=C;if(C>>>0>999999999)r=s;else{w=o;r=s;break}}}o=(E-w>>2)*9|0;t=c[w>>2]|0;if(t>>>0<10){s=w;break}else s=10;do{s=s*10|0;o=o+1|0}while(t>>>0>=s>>>0);s=w}while(0);C=r+4|0;w=s;p=p>>>0>C>>>0?C:p}y=0-o|0;while(1){if(p>>>0<=w>>>0){z=0;C=p;break}r=p+-4|0;if(!(c[r>>2]|0))p=r;else{z=1;C=p;break}}do if(A){n=(B&1^1)+n|0;if((n|0)>(o|0)&(o|0)>-5){u=u+-1|0;n=n+-1-o|0}else{u=u+-2|0;n=n+-1|0}p=I&8;if(p)break;do if(z){p=c[C+-4>>2]|0;if(!p){r=9;break}if(!((p>>>0)%10|0)){s=10;r=0}else{r=0;break}do{s=s*10|0;r=r+1|0}while(((p>>>0)%(s>>>0)|0|0)==0)}else r=9;while(0);p=((C-E>>2)*9|0)+-9|0;if((u|32|0)==102){p=p-r|0;p=(p|0)<0?0:p;n=(n|0)<(p|0)?n:p;p=0;break}else{p=p+o-r|0;p=(p|0)<0?0:p;n=(n|0)<(p|0)?n:p;p=0;break}}else p=I&8;while(0);x=n|p;s=(x|0)!=0&1;t=(u|32|0)==102;if(t){o=(o|0)>0?o:0;u=0}else{r=(o|0)<0?y:o;r=wC(r,((r|0)<0)<<31>>31,X)|0;if((_-r|0)<2)do{r=r+-1|0;a[r>>0]=48}while((_-r|0)<2);a[r+-1>>0]=(o>>31&2)+43;E=r+-2|0;a[E>>0]=u;o=_-E|0;u=E}y=G+1+n+s+o|0;xC(e,32,K,y,I);if(!(c[e>>2]&32))RB(H,G,e)|0;xC(e,48,K,y,I^65536);do if(t){r=w>>>0>F>>>0?F:w;o=r;do{p=wC(c[o>>2]|0,0,R)|0;do if((o|0)==(r|0)){if((p|0)!=(R|0))break;a[T>>0]=48;p=T}else{if(p>>>0<=da>>>0)break;do{p=p+-1|0;a[p>>0]=48}while(p>>>0>da>>>0)}while(0);if(!(c[e>>2]&32))RB(p,S-p|0,e)|0;o=o+4|0}while(o>>>0<=F>>>0);do if(x){if(c[e>>2]&32)break;RB(59582,1,e)|0}while(0);if((n|0)>0&o>>>0<C>>>0){p=o;while(1){o=wC(c[p>>2]|0,0,R)|0;if(o>>>0>da>>>0)do{o=o+-1|0;a[o>>0]=48}while(o>>>0>da>>>0);if(!(c[e>>2]&32))RB(o,(n|0)>9?9:n,e)|0;p=p+4|0;o=n+-9|0;if(!((n|0)>9&p>>>0<C>>>0)){n=o;break}else n=o}}xC(e,48,n+9|0,9,0)}else{t=z?C:w+4|0;if((n|0)>-1){s=(p|0)==0;r=w;do{o=wC(c[r>>2]|0,0,R)|0;if((o|0)==(R|0)){a[T>>0]=48;o=T}do if((r|0)==(w|0)){p=o+1|0;if(!(c[e>>2]&32))RB(o,1,e)|0;if(s&(n|0)<1){o=p;break}if(c[e>>2]&32){o=p;break}RB(59582,1,e)|0;o=p}else{if(o>>>0<=da>>>0)break;do{o=o+-1|0;a[o>>0]=48}while(o>>>0>da>>>0)}while(0);p=S-o|0;if(!(c[e>>2]&32))RB(o,(n|0)>(p|0)?p:n,e)|0;n=n-p|0;r=r+4|0}while(r>>>0<t>>>0&(n|0)>-1)}xC(e,48,n+18|0,18,0);if(c[e>>2]&32)break;RB(u,_-u|0,e)|0}while(0);xC(e,32,K,y,I^8192);n=(y|0)<(K|0)?K:y}else{t=(u&32|0)!=0;s=q!=q|0.0!=0.0;o=s?0:G;r=o+3|0;xC(e,32,K,r,p);n=c[e>>2]|0;if(!(n&32)){RB(H,o,e)|0;n=c[e>>2]|0}if(!(n&32))RB(s?(t?59574:59578):t?59566:59570,3,e)|0;xC(e,32,K,r,I^8192);n=(r|0)<(K|0)?K:r}while(0);w=J;continue a}default:{p=I;o=r;t=0;u=59530;n=N}}while(0);g:do if((L|0)==64){p=ba;o=c[p>>2]|0;p=c[p+4>>2]|0;s=u&32;if(!((o|0)==0&(p|0)==0)){n=N;do{n=n+-1|0;a[n>>0]=d[59514+(o&15)>>0]|s;o=WL(o|0,p|0,4)|0;p=D}while(!((o|0)==0&(p|0)==0));L=ba;if((t&8|0)==0|(c[L>>2]|0)==0&(c[L+4>>2]|0)==0){o=t;t=0;s=59530;L=77}else{o=t;t=2;s=59530+(u>>4)|0;L=77}}else{n=N;o=t;t=0;s=59530;L=77}}else if((L|0)==76){n=wC(n,o,N)|0;o=I;t=p;L=77}else if((L|0)==82){L=0;I=aC(n,0,r)|0;H=(I|0)==0;w=n;o=H?r:I-n|0;t=0;u=59530;n=H?n+r|0:I}else if((L|0)==86){L=0;o=0;n=0;s=c[ba>>2]|0;while(1){p=c[s>>2]|0;if(!p)break;n=DB(fa,p)|0;if((n|0)<0|n>>>0>(r-o|0)>>>0)break;o=n+o|0;if(r>>>0>o>>>0)s=s+4|0;else break}if((n|0)<0){m=-1;break a}xC(e,32,K,o,I);if(!o){n=0;L=98}else{p=0;r=c[ba>>2]|0;while(1){n=c[r>>2]|0;if(!n){n=o;L=98;break g}n=DB(fa,n)|0;p=n+p|0;if((p|0)>(o|0)){n=o;L=98;break g}if(!(c[e>>2]&32))RB(fa,n,e)|0;if(p>>>0>=o>>>0){n=o;L=98;break}else r=r+4|0}}}while(0);if((L|0)==98){L=0;xC(e,32,K,n,I^8192);w=J;n=(K|0)>(n|0)?K:n;continue}if((L|0)==77){L=0;p=(r|0)>-1?o&-65537:o;o=ba;o=(c[o>>2]|0)!=0|(c[o+4>>2]|0)!=0;if((r|0)!=0|o){o=(o&1^1)+(U-n)|0;w=n;o=(r|0)>(o|0)?r:o;u=s;n=N}else{w=N;o=0;u=s;n=N}}s=n-w|0;o=(o|0)<(s|0)?s:o;r=t+o|0;n=(K|0)<(r|0)?r:K;xC(e,32,n,r,p);if(!(c[e>>2]&32))RB(u,t,e)|0;xC(e,48,n,r,p^65536);xC(e,48,o,s,0);if(!(c[e>>2]&32))RB(w,s,e)|0;xC(e,32,n,r,p^8192);w=J}h:do if((L|0)==245)if(!e)if(f){m=1;while(1){f=c[l+(m<<2)>>2]|0;if(!f)break;vC(j+(m<<3)|0,f,g);m=m+1|0;if((m|0)>=10){m=1;break h}}if((m|0)<10)while(1){if(c[l+(m<<2)>>2]|0){m=-1;break h}m=m+1|0;if((m|0)>=10){m=1;break}}else m=1}else m=0;while(0);i=ha;return m|0}function rC(a,b,c){a=a|0;b=b|0;c=c|0;return LB(a,b,c)|0}function sC(a,b,d){a=a|0;b=b|0;d=d|0;var e=0.0,f=0,g=0,h=0,j=0;j=i;i=i+112|0;h=j;f=h;g=f+112|0;do{c[f>>2]=0;f=f+4|0}while((f|0)<(g|0));f=h+4|0;c[f>>2]=a;g=h+8|0;c[g>>2]=-1;c[h+44>>2]=a;c[h+76>>2]=-1;bB(h,0);e=+$A(h,d,1);d=(c[f>>2]|0)-(c[g>>2]|0)+(c[h+108>>2]|0)|0;if(b)c[b>>2]=(d|0)!=0?a+d|0:a;i=j;return +e}function tC(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0;k=i;i=i+112|0;j=k;c[j>>2]=0;g=j+4|0;c[g>>2]=a;c[j+44>>2]=a;h=j+8|0;c[h>>2]=(a|0)<0?-1:a+2147483647|0;c[j+76>>2]=-1;bB(j,0);e=aB(j,d,1,e,f)|0;if(b)c[b>>2]=a+((c[g>>2]|0)+(c[j+108>>2]|0)-(c[h>>2]|0));i=k;return e|0}function uC(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=a+20|0;f=c[e>>2]|0;a=(c[a+16>>2]|0)-f|0;a=a>>>0>d>>>0?d:a;XL(f|0,b|0,a|0)|0;c[e>>2]=(c[e>>2]|0)+a;return d|0}function vC(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0.0;a:do if(b>>>0<=20)do switch(b|0){case 9:{e=(c[d>>2]|0)+(4-1)&~(4-1);b=c[e>>2]|0;c[d>>2]=e+4;c[a>>2]=b;break a}case 10:{e=(c[d>>2]|0)+(4-1)&~(4-1);b=c[e>>2]|0;c[d>>2]=e+4;e=a;c[e>>2]=b;c[e+4>>2]=((b|0)<0)<<31>>31;break a}case 11:{e=(c[d>>2]|0)+(4-1)&~(4-1);b=c[e>>2]|0;c[d>>2]=e+4;e=a;c[e>>2]=b;c[e+4>>2]=0;break a}case 12:{e=(c[d>>2]|0)+(8-1)&~(8-1);b=e;f=c[b>>2]|0;b=c[b+4>>2]|0;c[d>>2]=e+8;e=a;c[e>>2]=f;c[e+4>>2]=b;break a}case 13:{f=(c[d>>2]|0)+(4-1)&~(4-1);e=c[f>>2]|0;c[d>>2]=f+4;e=(e&65535)<<16>>16;f=a;c[f>>2]=e;c[f+4>>2]=((e|0)<0)<<31>>31;break a}case 14:{f=(c[d>>2]|0)+(4-1)&~(4-1);e=c[f>>2]|0;c[d>>2]=f+4;f=a;c[f>>2]=e&65535;c[f+4>>2]=0;break a}case 15:{f=(c[d>>2]|0)+(4-1)&~(4-1);e=c[f>>2]|0;c[d>>2]=f+4;e=(e&255)<<24>>24;f=a;c[f>>2]=e;c[f+4>>2]=((e|0)<0)<<31>>31;break a}case 16:{f=(c[d>>2]|0)+(4-1)&~(4-1);e=c[f>>2]|0;c[d>>2]=f+4;f=a;c[f>>2]=e&255;c[f+4>>2]=0;break a}case 17:{f=(c[d>>2]|0)+(8-1)&~(8-1);g=+h[f>>3];c[d>>2]=f+8;h[a>>3]=g;break a}case 18:{f=(c[d>>2]|0)+(8-1)&~(8-1);g=+h[f>>3];c[d>>2]=f+8;h[a>>3]=g;break a}default:break a}while(0);while(0);return}function wC(b,c,d){b=b|0;c=c|0;d=d|0;var e=0;if(c>>>0>0|(c|0)==0&b>>>0>4294967295)while(1){e=fM(b|0,c|0,10,0)|0;d=d+-1|0;a[d>>0]=e|48;e=eM(b|0,c|0,10,0)|0;if(c>>>0>9|(c|0)==9&b>>>0>4294967295){b=e;c=D}else{b=e;break}}if(b)while(1){d=d+-1|0;a[d>>0]=(b>>>0)%10|0|48;if(b>>>0<10)break;else b=(b>>>0)/10|0}return d|0}function xC(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0;j=i;i=i+256|0;h=j;do if((d|0)>(e|0)&(f&73728|0)==0){f=d-e|0;ZL(h|0,b|0,(f>>>0>256?256:f)|0)|0;b=c[a>>2]|0;g=(b&32|0)==0;if(f>>>0>255){e=d-e|0;do{if(g){RB(h,256,a)|0;b=c[a>>2]|0}f=f+-256|0;g=(b&32|0)==0}while(f>>>0>255);if(g)f=e&255;else break}else if(!g)break;RB(h,f,a)|0}while(0);i=j;return}function yC(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0;do if(a>>>0<245){o=a>>>0<11?16:a+11&-8;a=o>>>3;i=c[9791]|0;d=i>>>a;if(d&3){a=(d&1^1)+a|0;e=a<<1;d=39204+(e<<2)|0;e=39204+(e+2<<2)|0;f=c[e>>2]|0;g=f+8|0;h=c[g>>2]|0;do if((d|0)!=(h|0)){if(h>>>0<(c[9795]|0)>>>0)Gb();b=h+12|0;if((c[b>>2]|0)==(f|0)){c[b>>2]=d;c[e>>2]=h;break}else Gb()}else c[9791]=i&~(1<<a);while(0);M=a<<3;c[f+4>>2]=M|3;M=f+(M|4)|0;c[M>>2]=c[M>>2]|1;M=g;return M|0}h=c[9793]|0;if(o>>>0>h>>>0){if(d){e=2<<a;e=d<<a&(e|0-e);e=(e&0-e)+-1|0;j=e>>>12&16;e=e>>>j;f=e>>>5&8;e=e>>>f;g=e>>>2&4;e=e>>>g;d=e>>>1&2;e=e>>>d;a=e>>>1&1;a=(f|j|g|d|a)+(e>>>a)|0;e=a<<1;d=39204+(e<<2)|0;e=39204+(e+2<<2)|0;g=c[e>>2]|0;j=g+8|0;f=c[j>>2]|0;do if((d|0)!=(f|0)){if(f>>>0<(c[9795]|0)>>>0)Gb();b=f+12|0;if((c[b>>2]|0)==(g|0)){c[b>>2]=d;c[e>>2]=f;k=c[9793]|0;break}else Gb()}else{c[9791]=i&~(1<<a);k=h}while(0);M=a<<3;h=M-o|0;c[g+4>>2]=o|3;i=g+o|0;c[g+(o|4)>>2]=h|1;c[g+M>>2]=h;if(k){f=c[9796]|0;d=k>>>3;b=d<<1;e=39204+(b<<2)|0;a=c[9791]|0;d=1<<d;if(a&d){a=39204+(b+2<<2)|0;b=c[a>>2]|0;if(b>>>0<(c[9795]|0)>>>0)Gb();else{l=a;m=b}}else{c[9791]=a|d;l=39204+(b+2<<2)|0;m=e}c[l>>2]=f;c[m+12>>2]=f;c[f+8>>2]=m;c[f+12>>2]=e}c[9793]=h;c[9796]=i;M=j;return M|0}a=c[9792]|0;if(a){d=(a&0-a)+-1|0;L=d>>>12&16;d=d>>>L;K=d>>>5&8;d=d>>>K;M=d>>>2&4;d=d>>>M;a=d>>>1&2;d=d>>>a;e=d>>>1&1;e=c[39468+((K|L|M|a|e)+(d>>>e)<<2)>>2]|0;d=(c[e+4>>2]&-8)-o|0;a=e;while(1){b=c[a+16>>2]|0;if(!b){b=c[a+20>>2]|0;if(!b){j=d;break}}a=(c[b+4>>2]&-8)-o|0;M=a>>>0<d>>>0;d=M?a:d;a=b;e=M?b:e}g=c[9795]|0;if(e>>>0<g>>>0)Gb();i=e+o|0;if(e>>>0>=i>>>0)Gb();h=c[e+24>>2]|0;d=c[e+12>>2]|0;do if((d|0)==(e|0)){a=e+20|0;b=c[a>>2]|0;if(!b){a=e+16|0;b=c[a>>2]|0;if(!b){n=0;break}}while(1){d=b+20|0;f=c[d>>2]|0;if(f){b=f;a=d;continue}d=b+16|0;f=c[d>>2]|0;if(!f)break;else{b=f;a=d}}if(a>>>0<g>>>0)Gb();else{c[a>>2]=0;n=b;break}}else{f=c[e+8>>2]|0;if(f>>>0<g>>>0)Gb();b=f+12|0;if((c[b>>2]|0)!=(e|0))Gb();a=d+8|0;if((c[a>>2]|0)==(e|0)){c[b>>2]=d;c[a>>2]=f;n=d;break}else Gb()}while(0);do if(h){b=c[e+28>>2]|0;a=39468+(b<<2)|0;if((e|0)==(c[a>>2]|0)){c[a>>2]=n;if(!n){c[9792]=c[9792]&~(1<<b);break}}else{if(h>>>0<(c[9795]|0)>>>0)Gb();b=h+16|0;if((c[b>>2]|0)==(e|0))c[b>>2]=n;else c[h+20>>2]=n;if(!n)break}a=c[9795]|0;if(n>>>0<a>>>0)Gb();c[n+24>>2]=h;b=c[e+16>>2]|0;do if(b)if(b>>>0<a>>>0)Gb();else{c[n+16>>2]=b;c[b+24>>2]=n;break}while(0);b=c[e+20>>2]|0;if(b)if(b>>>0<(c[9795]|0)>>>0)Gb();else{c[n+20>>2]=b;c[b+24>>2]=n;break}}while(0);if(j>>>0<16){M=j+o|0;c[e+4>>2]=M|3;M=e+(M+4)|0;c[M>>2]=c[M>>2]|1}else{c[e+4>>2]=o|3;c[e+(o|4)>>2]=j|1;c[e+(j+o)>>2]=j;b=c[9793]|0;if(b){g=c[9796]|0;d=b>>>3;b=d<<1;f=39204+(b<<2)|0;a=c[9791]|0;d=1<<d;if(a&d){b=39204+(b+2<<2)|0;a=c[b>>2]|0;if(a>>>0<(c[9795]|0)>>>0)Gb();else{p=b;q=a}}else{c[9791]=a|d;p=39204+(b+2<<2)|0;q=f}c[p>>2]=g;c[q+12>>2]=g;c[g+8>>2]=q;c[g+12>>2]=f}c[9793]=j;c[9796]=i}M=e+8|0;return M|0}else q=o}else q=o}else if(a>>>0<=4294967231){a=a+11|0;m=a&-8;l=c[9792]|0;if(l){d=0-m|0;a=a>>>8;if(a)if(m>>>0>16777215)k=31;else{q=(a+1048320|0)>>>16&8;v=a<<q;p=(v+520192|0)>>>16&4;v=v<<p;k=(v+245760|0)>>>16&2;k=14-(p|q|k)+(v<<k>>>15)|0;k=m>>>(k+7|0)&1|k<<1}else k=0;a=c[39468+(k<<2)>>2]|0;a:do if(!a){f=0;a=0;v=86}else{h=d;f=0;i=m<<((k|0)==31?0:25-(k>>>1)|0);j=a;a=0;while(1){g=c[j+4>>2]&-8;d=g-m|0;if(d>>>0<h>>>0)if((g|0)==(m|0)){g=j;a=j;v=90;break a}else a=j;else d=h;v=c[j+20>>2]|0;j=c[j+16+(i>>>31<<2)>>2]|0;f=(v|0)==0|(v|0)==(j|0)?f:v;if(!j){v=86;break}else{h=d;i=i<<1}}}while(0);if((v|0)==86){if((f|0)==0&(a|0)==0){a=2<<k;a=l&(a|0-a);if(!a){q=m;break}a=(a&0-a)+-1|0;n=a>>>12&16;a=a>>>n;l=a>>>5&8;a=a>>>l;p=a>>>2&4;a=a>>>p;q=a>>>1&2;a=a>>>q;f=a>>>1&1;f=c[39468+((l|n|p|q|f)+(a>>>f)<<2)>>2]|0;a=0}if(!f){i=d;j=a}else{g=f;v=90}}if((v|0)==90)while(1){v=0;q=(c[g+4>>2]&-8)-m|0;f=q>>>0<d>>>0;d=f?q:d;a=f?g:a;f=c[g+16>>2]|0;if(f){g=f;v=90;continue}g=c[g+20>>2]|0;if(!g){i=d;j=a;break}else v=90}if((j|0)!=0?i>>>0<((c[9793]|0)-m|0)>>>0:0){f=c[9795]|0;if(j>>>0<f>>>0)Gb();h=j+m|0;if(j>>>0>=h>>>0)Gb();g=c[j+24>>2]|0;d=c[j+12>>2]|0;do if((d|0)==(j|0)){a=j+20|0;b=c[a>>2]|0;if(!b){a=j+16|0;b=c[a>>2]|0;if(!b){o=0;break}}while(1){d=b+20|0;e=c[d>>2]|0;if(e){b=e;a=d;continue}d=b+16|0;e=c[d>>2]|0;if(!e)break;else{b=e;a=d}}if(a>>>0<f>>>0)Gb();else{c[a>>2]=0;o=b;break}}else{e=c[j+8>>2]|0;if(e>>>0<f>>>0)Gb();b=e+12|0;if((c[b>>2]|0)!=(j|0))Gb();a=d+8|0;if((c[a>>2]|0)==(j|0)){c[b>>2]=d;c[a>>2]=e;o=d;break}else Gb()}while(0);do if(g){b=c[j+28>>2]|0;a=39468+(b<<2)|0;if((j|0)==(c[a>>2]|0)){c[a>>2]=o;if(!o){c[9792]=c[9792]&~(1<<b);break}}else{if(g>>>0<(c[9795]|0)>>>0)Gb();b=g+16|0;if((c[b>>2]|0)==(j|0))c[b>>2]=o;else c[g+20>>2]=o;if(!o)break}a=c[9795]|0;if(o>>>0<a>>>0)Gb();c[o+24>>2]=g;b=c[j+16>>2]|0;do if(b)if(b>>>0<a>>>0)Gb();else{c[o+16>>2]=b;c[b+24>>2]=o;break}while(0);b=c[j+20>>2]|0;if(b)if(b>>>0<(c[9795]|0)>>>0)Gb();else{c[o+20>>2]=b;c[b+24>>2]=o;break}}while(0);b:do if(i>>>0>=16){c[j+4>>2]=m|3;c[j+(m|4)>>2]=i|1;c[j+(i+m)>>2]=i;b=i>>>3;if(i>>>0<256){a=b<<1;e=39204+(a<<2)|0;d=c[9791]|0;b=1<<b;if(d&b){b=39204+(a+2<<2)|0;a=c[b>>2]|0;if(a>>>0<(c[9795]|0)>>>0)Gb();else{s=b;t=a}}else{c[9791]=d|b;s=39204+(a+2<<2)|0;t=e}c[s>>2]=h;c[t+12>>2]=h;c[j+(m+8)>>2]=t;c[j+(m+12)>>2]=e;break}b=i>>>8;if(b)if(i>>>0>16777215)e=31;else{L=(b+1048320|0)>>>16&8;M=b<<L;K=(M+520192|0)>>>16&4;M=M<<K;e=(M+245760|0)>>>16&2;e=14-(K|L|e)+(M<<e>>>15)|0;e=i>>>(e+7|0)&1|e<<1}else e=0;b=39468+(e<<2)|0;c[j+(m+28)>>2]=e;c[j+(m+20)>>2]=0;c[j+(m+16)>>2]=0;a=c[9792]|0;d=1<<e;if(!(a&d)){c[9792]=a|d;c[b>>2]=h;c[j+(m+24)>>2]=b;c[j+(m+12)>>2]=h;c[j+(m+8)>>2]=h;break}b=c[b>>2]|0;c:do if((c[b+4>>2]&-8|0)!=(i|0)){e=i<<((e|0)==31?0:25-(e>>>1)|0);while(1){a=b+16+(e>>>31<<2)|0;d=c[a>>2]|0;if(!d)break;if((c[d+4>>2]&-8|0)==(i|0)){y=d;break c}else{e=e<<1;b=d}}if(a>>>0<(c[9795]|0)>>>0)Gb();else{c[a>>2]=h;c[j+(m+24)>>2]=b;c[j+(m+12)>>2]=h;c[j+(m+8)>>2]=h;break b}}else y=b;while(0);b=y+8|0;a=c[b>>2]|0;M=c[9795]|0;if(a>>>0>=M>>>0&y>>>0>=M>>>0){c[a+12>>2]=h;c[b>>2]=h;c[j+(m+8)>>2]=a;c[j+(m+12)>>2]=y;c[j+(m+24)>>2]=0;break}else Gb()}else{M=i+m|0;c[j+4>>2]=M|3;M=j+(M+4)|0;c[M>>2]=c[M>>2]|1}while(0);M=j+8|0;return M|0}else q=m}else q=m}else q=-1;while(0);d=c[9793]|0;if(d>>>0>=q>>>0){b=d-q|0;a=c[9796]|0;if(b>>>0>15){c[9796]=a+q;c[9793]=b;c[a+(q+4)>>2]=b|1;c[a+d>>2]=b;c[a+4>>2]=q|3}else{c[9793]=0;c[9796]=0;c[a+4>>2]=d|3;M=a+(d+4)|0;c[M>>2]=c[M>>2]|1}M=a+8|0;return M|0}a=c[9794]|0;if(a>>>0>q>>>0){L=a-q|0;c[9794]=L;M=c[9797]|0;c[9797]=M+q;c[M+(q+4)>>2]=L|1;c[M+4>>2]=q|3;M=M+8|0;return M|0}do if(!(c[9909]|0)){a=dc(30)|0;if(!(a+-1&a)){c[9911]=a;c[9910]=a;c[9912]=-1;c[9913]=-1;c[9914]=0;c[9902]=0;c[9909]=(Oc(0)|0)&-16^1431655768;break}else Gb()}while(0);j=q+48|0;i=c[9911]|0;k=q+47|0;h=i+k|0;i=0-i|0;l=h&i;if(l>>>0<=q>>>0){M=0;return M|0}a=c[9901]|0;if((a|0)!=0?(t=c[9899]|0,y=t+l|0,y>>>0<=t>>>0|y>>>0>a>>>0):0){M=0;return M|0}d:do if(!(c[9902]&4)){a=c[9797]|0;e:do if(a){f=39612;while(1){d=c[f>>2]|0;if(d>>>0<=a>>>0?(r=f+4|0,(d+(c[r>>2]|0)|0)>>>0>a>>>0):0){g=f;a=r;break}f=c[f+8>>2]|0;if(!f){v=174;break e}}d=h-(c[9794]|0)&i;if(d>>>0<2147483647){f=Yb(d|0)|0;y=(f|0)==((c[g>>2]|0)+(c[a>>2]|0)|0);a=y?d:0;if(y){if((f|0)!=(-1|0)){w=f;p=a;v=194;break d}}else v=184}else a=0}else v=174;while(0);do if((v|0)==174){g=Yb(0)|0;if((g|0)!=(-1|0)){a=g;d=c[9910]|0;f=d+-1|0;if(!(f&a))d=l;else d=l-a+(f+a&0-d)|0;a=c[9899]|0;f=a+d|0;if(d>>>0>q>>>0&d>>>0<2147483647){y=c[9901]|0;if((y|0)!=0?f>>>0<=a>>>0|f>>>0>y>>>0:0){a=0;break}f=Yb(d|0)|0;y=(f|0)==(g|0);a=y?d:0;if(y){w=g;p=a;v=194;break d}else v=184}else a=0}else a=0}while(0);f:do if((v|0)==184){g=0-d|0;do if(j>>>0>d>>>0&(d>>>0<2147483647&(f|0)!=(-1|0))?(u=c[9911]|0,u=k-d+u&0-u,u>>>0<2147483647):0)if((Yb(u|0)|0)==(-1|0)){Yb(g|0)|0;break f}else{d=u+d|0;break}while(0);if((f|0)!=(-1|0)){w=f;p=d;v=194;break d}}while(0);c[9902]=c[9902]|4;v=191}else{a=0;v=191}while(0);if((((v|0)==191?l>>>0<2147483647:0)?(w=Yb(l|0)|0,x=Yb(0)|0,w>>>0<x>>>0&((w|0)!=(-1|0)&(x|0)!=(-1|0))):0)?(z=x-w|0,A=z>>>0>(q+40|0)>>>0,A):0){p=A?z:a;v=194}if((v|0)==194){a=(c[9899]|0)+p|0;c[9899]=a;if(a>>>0>(c[9900]|0)>>>0)c[9900]=a;h=c[9797]|0;g:do if(h){g=39612;do{a=c[g>>2]|0;d=g+4|0;f=c[d>>2]|0;if((w|0)==(a+f|0)){B=a;C=d;D=f;E=g;v=204;break}g=c[g+8>>2]|0}while((g|0)!=0);if(((v|0)==204?(c[E+12>>2]&8|0)==0:0)?h>>>0<w>>>0&h>>>0>=B>>>0:0){c[C>>2]=D+p;M=(c[9794]|0)+p|0;L=h+8|0;L=(L&7|0)==0?0:0-L&7;K=M-L|0;c[9797]=h+L;c[9794]=K;c[h+(L+4)>>2]=K|1;c[h+(M+4)>>2]=40;c[9798]=c[9913];break}a=c[9795]|0;if(w>>>0<a>>>0){c[9795]=w;a=w}d=w+p|0;g=39612;while(1){if((c[g>>2]|0)==(d|0)){f=g;d=g;v=212;break}g=c[g+8>>2]|0;if(!g){d=39612;break}}if((v|0)==212)if(!(c[d+12>>2]&8)){c[f>>2]=w;n=d+4|0;c[n>>2]=(c[n>>2]|0)+p;n=w+8|0;n=(n&7|0)==0?0:0-n&7;k=w+(p+8)|0;k=(k&7|0)==0?0:0-k&7;b=w+(k+p)|0;m=n+q|0;o=w+m|0;l=b-(w+n)-q|0;c[w+(n+4)>>2]=q|3;h:do if((b|0)!=(h|0)){if((b|0)==(c[9796]|0)){M=(c[9793]|0)+l|0;c[9793]=M;c[9796]=o;c[w+(m+4)>>2]=M|1;c[w+(M+m)>>2]=M;break}i=p+4|0;d=c[w+(i+k)>>2]|0;if((d&3|0)==1){j=d&-8;g=d>>>3;i:do if(d>>>0>=256){h=c[w+((k|24)+p)>>2]|0;e=c[w+(p+12+k)>>2]|0;do if((e|0)==(b|0)){f=k|16;e=w+(i+f)|0;d=c[e>>2]|0;if(!d){e=w+(f+p)|0;d=c[e>>2]|0;if(!d){J=0;break}}while(1){f=d+20|0;g=c[f>>2]|0;if(g){d=g;e=f;continue}f=d+16|0;g=c[f>>2]|0;if(!g)break;else{d=g;e=f}}if(e>>>0<a>>>0)Gb();else{c[e>>2]=0;J=d;break}}else{f=c[w+((k|8)+p)>>2]|0;if(f>>>0<a>>>0)Gb();a=f+12|0;if((c[a>>2]|0)!=(b|0))Gb();d=e+8|0;if((c[d>>2]|0)==(b|0)){c[a>>2]=e;c[d>>2]=f;J=e;break}else Gb()}while(0);if(!h)break;a=c[w+(p+28+k)>>2]|0;d=39468+(a<<2)|0;do if((b|0)!=(c[d>>2]|0)){if(h>>>0<(c[9795]|0)>>>0)Gb();a=h+16|0;if((c[a>>2]|0)==(b|0))c[a>>2]=J;else c[h+20>>2]=J;if(!J)break i}else{c[d>>2]=J;if(J)break;c[9792]=c[9792]&~(1<<a);break i}while(0);d=c[9795]|0;if(J>>>0<d>>>0)Gb();c[J+24>>2]=h;b=k|16;a=c[w+(b+p)>>2]|0;do if(a)if(a>>>0<d>>>0)Gb();else{c[J+16>>2]=a;c[a+24>>2]=J;break}while(0);b=c[w+(i+b)>>2]|0;if(!b)break;if(b>>>0<(c[9795]|0)>>>0)Gb();else{c[J+20>>2]=b;c[b+24>>2]=J;break}}else{e=c[w+((k|8)+p)>>2]|0;f=c[w+(p+12+k)>>2]|0;d=39204+(g<<1<<2)|0;do if((e|0)!=(d|0)){if(e>>>0<a>>>0)Gb();if((c[e+12>>2]|0)==(b|0))break;Gb()}while(0);if((f|0)==(e|0)){c[9791]=c[9791]&~(1<<g);break}do if((f|0)==(d|0))F=f+8|0;else{if(f>>>0<a>>>0)Gb();a=f+8|0;if((c[a>>2]|0)==(b|0)){F=a;break}Gb()}while(0);c[e+12>>2]=f;c[F>>2]=e}while(0);b=w+((j|k)+p)|0;f=j+l|0}else f=l;b=b+4|0;c[b>>2]=c[b>>2]&-2;c[w+(m+4)>>2]=f|1;c[w+(f+m)>>2]=f;b=f>>>3;if(f>>>0<256){a=b<<1;e=39204+(a<<2)|0;d=c[9791]|0;b=1<<b;do if(!(d&b)){c[9791]=d|b;K=39204+(a+2<<2)|0;L=e}else{b=39204+(a+2<<2)|0;a=c[b>>2]|0;if(a>>>0>=(c[9795]|0)>>>0){K=b;L=a;break}Gb()}while(0);c[K>>2]=o;c[L+12>>2]=o;c[w+(m+8)>>2]=L;c[w+(m+12)>>2]=e;break}b=f>>>8;do if(!b)e=0;else{if(f>>>0>16777215){e=31;break}K=(b+1048320|0)>>>16&8;L=b<<K;J=(L+520192|0)>>>16&4;L=L<<J;e=(L+245760|0)>>>16&2;e=14-(J|K|e)+(L<<e>>>15)|0;e=f>>>(e+7|0)&1|e<<1}while(0);b=39468+(e<<2)|0;c[w+(m+28)>>2]=e;c[w+(m+20)>>2]=0;c[w+(m+16)>>2]=0;a=c[9792]|0;d=1<<e;if(!(a&d)){c[9792]=a|d;c[b>>2]=o;c[w+(m+24)>>2]=b;c[w+(m+12)>>2]=o;c[w+(m+8)>>2]=o;break}b=c[b>>2]|0;j:do if((c[b+4>>2]&-8|0)!=(f|0)){e=f<<((e|0)==31?0:25-(e>>>1)|0);while(1){a=b+16+(e>>>31<<2)|0;d=c[a>>2]|0;if(!d)break;if((c[d+4>>2]&-8|0)==(f|0)){M=d;break j}else{e=e<<1;b=d}}if(a>>>0<(c[9795]|0)>>>0)Gb();else{c[a>>2]=o;c[w+(m+24)>>2]=b;c[w+(m+12)>>2]=o;c[w+(m+8)>>2]=o;break h}}else M=b;while(0);b=M+8|0;a=c[b>>2]|0;L=c[9795]|0;if(a>>>0>=L>>>0&M>>>0>=L>>>0){c[a+12>>2]=o;c[b>>2]=o;c[w+(m+8)>>2]=a;c[w+(m+12)>>2]=M;c[w+(m+24)>>2]=0;break}else Gb()}else{M=(c[9794]|0)+l|0;c[9794]=M;c[9797]=o;c[w+(m+4)>>2]=M|1}while(0);M=w+(n|8)|0;return M|0}else d=39612;while(1){a=c[d>>2]|0;if(a>>>0<=h>>>0?(b=c[d+4>>2]|0,e=a+b|0,e>>>0>h>>>0):0)break;d=c[d+8>>2]|0}f=a+(b+-39)|0;a=a+(b+-47+((f&7|0)==0?0:0-f&7))|0;f=h+16|0;a=a>>>0<f>>>0?h:a;b=a+8|0;d=w+8|0;d=(d&7|0)==0?0:0-d&7;M=p+-40-d|0;c[9797]=w+d;c[9794]=M;c[w+(d+4)>>2]=M|1;c[w+(p+-36)>>2]=40;c[9798]=c[9913];d=a+4|0;c[d>>2]=27;c[b>>2]=c[9903];c[b+4>>2]=c[9904];c[b+8>>2]=c[9905];c[b+12>>2]=c[9906];c[9903]=w;c[9904]=p;c[9906]=0;c[9905]=b;b=a+28|0;c[b>>2]=7;if((a+32|0)>>>0<e>>>0)do{M=b;b=b+4|0;c[b>>2]=7}while((M+8|0)>>>0<e>>>0);if((a|0)!=(h|0)){g=a-h|0;c[d>>2]=c[d>>2]&-2;c[h+4>>2]=g|1;c[a>>2]=g;b=g>>>3;if(g>>>0<256){a=b<<1;e=39204+(a<<2)|0;d=c[9791]|0;b=1<<b;if(d&b){b=39204+(a+2<<2)|0;a=c[b>>2]|0;if(a>>>0<(c[9795]|0)>>>0)Gb();else{G=b;H=a}}else{c[9791]=d|b;G=39204+(a+2<<2)|0;H=e}c[G>>2]=h;c[H+12>>2]=h;c[h+8>>2]=H;c[h+12>>2]=e;break}b=g>>>8;if(b)if(g>>>0>16777215)e=31;else{L=(b+1048320|0)>>>16&8;M=b<<L;K=(M+520192|0)>>>16&4;M=M<<K;e=(M+245760|0)>>>16&2;e=14-(K|L|e)+(M<<e>>>15)|0;e=g>>>(e+7|0)&1|e<<1}else e=0;d=39468+(e<<2)|0;c[h+28>>2]=e;c[h+20>>2]=0;c[f>>2]=0;b=c[9792]|0;a=1<<e;if(!(b&a)){c[9792]=b|a;c[d>>2]=h;c[h+24>>2]=d;c[h+12>>2]=h;c[h+8>>2]=h;break}b=c[d>>2]|0;k:do if((c[b+4>>2]&-8|0)!=(g|0)){e=g<<((e|0)==31?0:25-(e>>>1)|0);while(1){a=b+16+(e>>>31<<2)|0;d=c[a>>2]|0;if(!d)break;if((c[d+4>>2]&-8|0)==(g|0)){I=d;break k}else{e=e<<1;b=d}}if(a>>>0<(c[9795]|0)>>>0)Gb();else{c[a>>2]=h;c[h+24>>2]=b;c[h+12>>2]=h;c[h+8>>2]=h;break g}}else I=b;while(0);b=I+8|0;a=c[b>>2]|0;M=c[9795]|0;if(a>>>0>=M>>>0&I>>>0>=M>>>0){c[a+12>>2]=h;c[b>>2]=h;c[h+8>>2]=a;c[h+12>>2]=I;c[h+24>>2]=0;break}else Gb()}}else{M=c[9795]|0;if((M|0)==0|w>>>0<M>>>0)c[9795]=w;c[9903]=w;c[9904]=p;c[9906]=0;c[9800]=c[9909];c[9799]=-1;b=0;do{M=b<<1;L=39204+(M<<2)|0;c[39204+(M+3<<2)>>2]=L;c[39204+(M+2<<2)>>2]=L;b=b+1|0}while((b|0)!=32);M=w+8|0;M=(M&7|0)==0?0:0-M&7;L=p+-40-M|0;c[9797]=w+M;c[9794]=L;c[w+(M+4)>>2]=L|1;c[w+(p+-36)>>2]=40;c[9798]=c[9913]}while(0);b=c[9794]|0;if(b>>>0>q>>>0){L=b-q|0;c[9794]=L;M=c[9797]|0;c[9797]=M+q;c[M+(q+4)>>2]=L|1;c[M+4>>2]=q|3;M=M+8|0;return M|0}}c[(ZA()|0)>>2]=12;M=0;return M|0}function zC(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;if(!a)return;b=a+-8|0;i=c[9795]|0;if(b>>>0<i>>>0)Gb();d=c[a+-4>>2]|0;e=d&3;if((e|0)==1)Gb();o=d&-8;q=a+(o+-8)|0;do if(!(d&1)){b=c[b>>2]|0;if(!e)return;j=-8-b|0;l=a+j|0;m=b+o|0;if(l>>>0<i>>>0)Gb();if((l|0)==(c[9796]|0)){b=a+(o+-4)|0;d=c[b>>2]|0;if((d&3|0)!=3){u=l;g=m;break}c[9793]=m;c[b>>2]=d&-2;c[a+(j+4)>>2]=m|1;c[q>>2]=m;return}f=b>>>3;if(b>>>0<256){e=c[a+(j+8)>>2]|0;d=c[a+(j+12)>>2]|0;b=39204+(f<<1<<2)|0;if((e|0)!=(b|0)){if(e>>>0<i>>>0)Gb();if((c[e+12>>2]|0)!=(l|0))Gb()}if((d|0)==(e|0)){c[9791]=c[9791]&~(1<<f);u=l;g=m;break}if((d|0)!=(b|0)){if(d>>>0<i>>>0)Gb();b=d+8|0;if((c[b>>2]|0)==(l|0))h=b;else Gb()}else h=d+8|0;c[e+12>>2]=d;c[h>>2]=e;u=l;g=m;break}h=c[a+(j+24)>>2]|0;e=c[a+(j+12)>>2]|0;do if((e|0)==(l|0)){d=a+(j+20)|0;b=c[d>>2]|0;if(!b){d=a+(j+16)|0;b=c[d>>2]|0;if(!b){k=0;break}}while(1){e=b+20|0;f=c[e>>2]|0;if(f){b=f;d=e;continue}e=b+16|0;f=c[e>>2]|0;if(!f)break;else{b=f;d=e}}if(d>>>0<i>>>0)Gb();else{c[d>>2]=0;k=b;break}}else{f=c[a+(j+8)>>2]|0;if(f>>>0<i>>>0)Gb();b=f+12|0;if((c[b>>2]|0)!=(l|0))Gb();d=e+8|0;if((c[d>>2]|0)==(l|0)){c[b>>2]=e;c[d>>2]=f;k=e;break}else Gb()}while(0);if(h){b=c[a+(j+28)>>2]|0;d=39468+(b<<2)|0;if((l|0)==(c[d>>2]|0)){c[d>>2]=k;if(!k){c[9792]=c[9792]&~(1<<b);u=l;g=m;break}}else{if(h>>>0<(c[9795]|0)>>>0)Gb();b=h+16|0;if((c[b>>2]|0)==(l|0))c[b>>2]=k;else c[h+20>>2]=k;if(!k){u=l;g=m;break}}d=c[9795]|0;if(k>>>0<d>>>0)Gb();c[k+24>>2]=h;b=c[a+(j+16)>>2]|0;do if(b)if(b>>>0<d>>>0)Gb();else{c[k+16>>2]=b;c[b+24>>2]=k;break}while(0);b=c[a+(j+20)>>2]|0;if(b)if(b>>>0<(c[9795]|0)>>>0)Gb();else{c[k+20>>2]=b;c[b+24>>2]=k;u=l;g=m;break}else{u=l;g=m}}else{u=l;g=m}}else{u=b;g=o}while(0);if(u>>>0>=q>>>0)Gb();b=a+(o+-4)|0;d=c[b>>2]|0;if(!(d&1))Gb();if(!(d&2)){if((q|0)==(c[9797]|0)){t=(c[9794]|0)+g|0;c[9794]=t;c[9797]=u;c[u+4>>2]=t|1;if((u|0)!=(c[9796]|0))return;c[9796]=0;c[9793]=0;return}if((q|0)==(c[9796]|0)){t=(c[9793]|0)+g|0;c[9793]=t;c[9796]=u;c[u+4>>2]=t|1;c[u+t>>2]=t;return}g=(d&-8)+g|0;f=d>>>3;do if(d>>>0>=256){h=c[a+(o+16)>>2]|0;b=c[a+(o|4)>>2]|0;do if((b|0)==(q|0)){d=a+(o+12)|0;b=c[d>>2]|0;if(!b){d=a+(o+8)|0;b=c[d>>2]|0;if(!b){p=0;break}}while(1){e=b+20|0;f=c[e>>2]|0;if(f){b=f;d=e;continue}e=b+16|0;f=c[e>>2]|0;if(!f)break;else{b=f;d=e}}if(d>>>0<(c[9795]|0)>>>0)Gb();else{c[d>>2]=0;p=b;break}}else{d=c[a+o>>2]|0;if(d>>>0<(c[9795]|0)>>>0)Gb();e=d+12|0;if((c[e>>2]|0)!=(q|0))Gb();f=b+8|0;if((c[f>>2]|0)==(q|0)){c[e>>2]=b;c[f>>2]=d;p=b;break}else Gb()}while(0);if(h){b=c[a+(o+20)>>2]|0;d=39468+(b<<2)|0;if((q|0)==(c[d>>2]|0)){c[d>>2]=p;if(!p){c[9792]=c[9792]&~(1<<b);break}}else{if(h>>>0<(c[9795]|0)>>>0)Gb();b=h+16|0;if((c[b>>2]|0)==(q|0))c[b>>2]=p;else c[h+20>>2]=p;if(!p)break}d=c[9795]|0;if(p>>>0<d>>>0)Gb();c[p+24>>2]=h;b=c[a+(o+8)>>2]|0;do if(b)if(b>>>0<d>>>0)Gb();else{c[p+16>>2]=b;c[b+24>>2]=p;break}while(0);b=c[a+(o+12)>>2]|0;if(b)if(b>>>0<(c[9795]|0)>>>0)Gb();else{c[p+20>>2]=b;c[b+24>>2]=p;break}}}else{e=c[a+o>>2]|0;d=c[a+(o|4)>>2]|0;b=39204+(f<<1<<2)|0;if((e|0)!=(b|0)){if(e>>>0<(c[9795]|0)>>>0)Gb();if((c[e+12>>2]|0)!=(q|0))Gb()}if((d|0)==(e|0)){c[9791]=c[9791]&~(1<<f);break}if((d|0)!=(b|0)){if(d>>>0<(c[9795]|0)>>>0)Gb();b=d+8|0;if((c[b>>2]|0)==(q|0))n=b;else Gb()}else n=d+8|0;c[e+12>>2]=d;c[n>>2]=e}while(0);c[u+4>>2]=g|1;c[u+g>>2]=g;if((u|0)==(c[9796]|0)){c[9793]=g;return}}else{c[b>>2]=d&-2;c[u+4>>2]=g|1;c[u+g>>2]=g}b=g>>>3;if(g>>>0<256){d=b<<1;f=39204+(d<<2)|0;e=c[9791]|0;b=1<<b;if(e&b){b=39204+(d+2<<2)|0;d=c[b>>2]|0;if(d>>>0<(c[9795]|0)>>>0)Gb();else{r=b;s=d}}else{c[9791]=e|b;r=39204+(d+2<<2)|0;s=f}c[r>>2]=u;c[s+12>>2]=u;c[u+8>>2]=s;c[u+12>>2]=f;return}b=g>>>8;if(b)if(g>>>0>16777215)f=31;else{r=(b+1048320|0)>>>16&8;s=b<<r;q=(s+520192|0)>>>16&4;s=s<<q;f=(s+245760|0)>>>16&2;f=14-(q|r|f)+(s<<f>>>15)|0;f=g>>>(f+7|0)&1|f<<1}else f=0;b=39468+(f<<2)|0;c[u+28>>2]=f;c[u+20>>2]=0;c[u+16>>2]=0;d=c[9792]|0;e=1<<f;a:do if(d&e){b=c[b>>2]|0;b:do if((c[b+4>>2]&-8|0)!=(g|0)){f=g<<((f|0)==31?0:25-(f>>>1)|0);while(1){d=b+16+(f>>>31<<2)|0;e=c[d>>2]|0;if(!e)break;if((c[e+4>>2]&-8|0)==(g|0)){t=e;break b}else{f=f<<1;b=e}}if(d>>>0<(c[9795]|0)>>>0)Gb();else{c[d>>2]=u;c[u+24>>2]=b;c[u+12>>2]=u;c[u+8>>2]=u;break a}}else t=b;while(0);b=t+8|0;d=c[b>>2]|0;s=c[9795]|0;if(d>>>0>=s>>>0&t>>>0>=s>>>0){c[d+12>>2]=u;c[b>>2]=u;c[u+8>>2]=d;c[u+12>>2]=t;c[u+24>>2]=0;break}else Gb()}else{c[9792]=d|e;c[b>>2]=u;c[u+24>>2]=b;c[u+12>>2]=u;c[u+8>>2]=u}while(0);u=(c[9799]|0)+-1|0;c[9799]=u;if(!u)b=39620;else return;while(1){b=c[b>>2]|0;if(!b)break;else b=b+8|0}c[9799]=-1;return}function AC(a,b){a=a|0;b=b|0;var d=0;if(a){d=$(b,a)|0;if((b|a)>>>0>65535)d=((d>>>0)/(a>>>0)|0|0)==(b|0)?d:-1}else d=0;b=yC(d)|0;if(!b)return b|0;if(!(c[b+-4>>2]&3))return b|0;ZL(b|0,0,d|0)|0;return b|0}function BC(a,b){a=a|0;b=b|0;var d=0,e=0;if(!a){a=yC(b)|0;return a|0}if(b>>>0>4294967231){c[(ZA()|0)>>2]=12;a=0;return a|0}d=CC(a+-8|0,b>>>0<11?16:b+11&-8)|0;if(d){a=d+8|0;return a|0}d=yC(b)|0;if(!d){a=0;return a|0}e=c[a+-4>>2]|0;e=(e&-8)-((e&3|0)==0?8:4)|0;XL(d|0,a|0,(e>>>0<b>>>0?e:b)|0)|0;zC(a);a=d;return a|0}function CC(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;o=a+4|0;p=c[o>>2]|0;j=p&-8;l=a+j|0;i=c[9795]|0;d=p&3;if(!((d|0)!=1&a>>>0>=i>>>0&a>>>0<l>>>0))Gb();e=a+(j|4)|0;f=c[e>>2]|0;if(!(f&1))Gb();if(!d){if(b>>>0<256){a=0;return a|0}if(j>>>0>=(b+4|0)>>>0?(j-b|0)>>>0<=c[9911]<<1>>>0:0)return a|0;a=0;return a|0}if(j>>>0>=b>>>0){d=j-b|0;if(d>>>0<=15)return a|0;c[o>>2]=p&1|b|2;c[a+(b+4)>>2]=d|3;c[e>>2]=c[e>>2]|1;DC(a+b|0,d);return a|0}if((l|0)==(c[9797]|0)){d=(c[9794]|0)+j|0;if(d>>>0<=b>>>0){a=0;return a|0}n=d-b|0;c[o>>2]=p&1|b|2;c[a+(b+4)>>2]=n|1;c[9797]=a+b;c[9794]=n;return a|0}if((l|0)==(c[9796]|0)){e=(c[9793]|0)+j|0;if(e>>>0<b>>>0){a=0;return a|0}d=e-b|0;if(d>>>0>15){c[o>>2]=p&1|b|2;c[a+(b+4)>>2]=d|1;c[a+e>>2]=d;e=a+(e+4)|0;c[e>>2]=c[e>>2]&-2;e=a+b|0}else{c[o>>2]=p&1|e|2;e=a+(e+4)|0;c[e>>2]=c[e>>2]|1;e=0;d=0}c[9793]=d;c[9796]=e;return a|0}if(f&2){a=0;return a|0}m=(f&-8)+j|0;if(m>>>0<b>>>0){a=0;return a|0}n=m-b|0;g=f>>>3;do if(f>>>0>=256){h=c[a+(j+24)>>2]|0;g=c[a+(j+12)>>2]|0;do if((g|0)==(l|0)){e=a+(j+20)|0;d=c[e>>2]|0;if(!d){e=a+(j+16)|0;d=c[e>>2]|0;if(!d){k=0;break}}while(1){f=d+20|0;g=c[f>>2]|0;if(g){d=g;e=f;continue}f=d+16|0;g=c[f>>2]|0;if(!g)break;else{d=g;e=f}}if(e>>>0<i>>>0)Gb();else{c[e>>2]=0;k=d;break}}else{f=c[a+(j+8)>>2]|0;if(f>>>0<i>>>0)Gb();d=f+12|0;if((c[d>>2]|0)!=(l|0))Gb();e=g+8|0;if((c[e>>2]|0)==(l|0)){c[d>>2]=g;c[e>>2]=f;k=g;break}else Gb()}while(0);if(h){d=c[a+(j+28)>>2]|0;e=39468+(d<<2)|0;if((l|0)==(c[e>>2]|0)){c[e>>2]=k;if(!k){c[9792]=c[9792]&~(1<<d);break}}else{if(h>>>0<(c[9795]|0)>>>0)Gb();d=h+16|0;if((c[d>>2]|0)==(l|0))c[d>>2]=k;else c[h+20>>2]=k;if(!k)break}e=c[9795]|0;if(k>>>0<e>>>0)Gb();c[k+24>>2]=h;d=c[a+(j+16)>>2]|0;do if(d)if(d>>>0<e>>>0)Gb();else{c[k+16>>2]=d;c[d+24>>2]=k;break}while(0);d=c[a+(j+20)>>2]|0;if(d)if(d>>>0<(c[9795]|0)>>>0)Gb();else{c[k+20>>2]=d;c[d+24>>2]=k;break}}}else{f=c[a+(j+8)>>2]|0;e=c[a+(j+12)>>2]|0;d=39204+(g<<1<<2)|0;if((f|0)!=(d|0)){if(f>>>0<i>>>0)Gb();if((c[f+12>>2]|0)!=(l|0))Gb()}if((e|0)==(f|0)){c[9791]=c[9791]&~(1<<g);break}if((e|0)!=(d|0)){if(e>>>0<i>>>0)Gb();d=e+8|0;if((c[d>>2]|0)==(l|0))h=d;else Gb()}else h=e+8|0;c[f+12>>2]=e;c[h>>2]=f}while(0);if(n>>>0<16){c[o>>2]=m|p&1|2;b=a+(m|4)|0;c[b>>2]=c[b>>2]|1;return a|0}else{c[o>>2]=p&1|b|2;c[a+(b+4)>>2]=n|3;p=a+(m|4)|0;c[p>>2]=c[p>>2]|1;DC(a+b|0,n);return a|0}return 0}function DC(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;q=a+b|0;d=c[a+4>>2]|0;do if(!(d&1)){k=c[a>>2]|0;if(!(d&3))return;n=a+(0-k)|0;m=k+b|0;j=c[9795]|0;if(n>>>0<j>>>0)Gb();if((n|0)==(c[9796]|0)){e=a+(b+4)|0;d=c[e>>2]|0;if((d&3|0)!=3){t=n;h=m;break}c[9793]=m;c[e>>2]=d&-2;c[a+(4-k)>>2]=m|1;c[q>>2]=m;return}g=k>>>3;if(k>>>0<256){f=c[a+(8-k)>>2]|0;e=c[a+(12-k)>>2]|0;d=39204+(g<<1<<2)|0;if((f|0)!=(d|0)){if(f>>>0<j>>>0)Gb();if((c[f+12>>2]|0)!=(n|0))Gb()}if((e|0)==(f|0)){c[9791]=c[9791]&~(1<<g);t=n;h=m;break}if((e|0)!=(d|0)){if(e>>>0<j>>>0)Gb();d=e+8|0;if((c[d>>2]|0)==(n|0))i=d;else Gb()}else i=e+8|0;c[f+12>>2]=e;c[i>>2]=f;t=n;h=m;break}i=c[a+(24-k)>>2]|0;f=c[a+(12-k)>>2]|0;do if((f|0)==(n|0)){f=16-k|0;e=a+(f+4)|0;d=c[e>>2]|0;if(!d){e=a+f|0;d=c[e>>2]|0;if(!d){l=0;break}}while(1){f=d+20|0;g=c[f>>2]|0;if(g){d=g;e=f;continue}f=d+16|0;g=c[f>>2]|0;if(!g)break;else{d=g;e=f}}if(e>>>0<j>>>0)Gb();else{c[e>>2]=0;l=d;break}}else{g=c[a+(8-k)>>2]|0;if(g>>>0<j>>>0)Gb();d=g+12|0;if((c[d>>2]|0)!=(n|0))Gb();e=f+8|0;if((c[e>>2]|0)==(n|0)){c[d>>2]=f;c[e>>2]=g;l=f;break}else Gb()}while(0);if(i){d=c[a+(28-k)>>2]|0;e=39468+(d<<2)|0;if((n|0)==(c[e>>2]|0)){c[e>>2]=l;if(!l){c[9792]=c[9792]&~(1<<d);t=n;h=m;break}}else{if(i>>>0<(c[9795]|0)>>>0)Gb();d=i+16|0;if((c[d>>2]|0)==(n|0))c[d>>2]=l;else c[i+20>>2]=l;if(!l){t=n;h=m;break}}f=c[9795]|0;if(l>>>0<f>>>0)Gb();c[l+24>>2]=i;d=16-k|0;e=c[a+d>>2]|0;do if(e)if(e>>>0<f>>>0)Gb();else{c[l+16>>2]=e;c[e+24>>2]=l;break}while(0);d=c[a+(d+4)>>2]|0;if(d)if(d>>>0<(c[9795]|0)>>>0)Gb();else{c[l+20>>2]=d;c[d+24>>2]=l;t=n;h=m;break}else{t=n;h=m}}else{t=n;h=m}}else{t=a;h=b}while(0);j=c[9795]|0;if(q>>>0<j>>>0)Gb();d=a+(b+4)|0;e=c[d>>2]|0;if(!(e&2)){if((q|0)==(c[9797]|0)){s=(c[9794]|0)+h|0;c[9794]=s;c[9797]=t;c[t+4>>2]=s|1;if((t|0)!=(c[9796]|0))return;c[9796]=0;c[9793]=0;return}if((q|0)==(c[9796]|0)){s=(c[9793]|0)+h|0;c[9793]=s;c[9796]=t;c[t+4>>2]=s|1;c[t+s>>2]=s;return}h=(e&-8)+h|0;g=e>>>3;do if(e>>>0>=256){i=c[a+(b+24)>>2]|0;f=c[a+(b+12)>>2]|0;do if((f|0)==(q|0)){e=a+(b+20)|0;d=c[e>>2]|0;if(!d){e=a+(b+16)|0;d=c[e>>2]|0;if(!d){p=0;break}}while(1){f=d+20|0;g=c[f>>2]|0;if(g){d=g;e=f;continue}f=d+16|0;g=c[f>>2]|0;if(!g)break;else{d=g;e=f}}if(e>>>0<j>>>0)Gb();else{c[e>>2]=0;p=d;break}}else{g=c[a+(b+8)>>2]|0;if(g>>>0<j>>>0)Gb();d=g+12|0;if((c[d>>2]|0)!=(q|0))Gb();e=f+8|0;if((c[e>>2]|0)==(q|0)){c[d>>2]=f;c[e>>2]=g;p=f;break}else Gb()}while(0);if(i){d=c[a+(b+28)>>2]|0;e=39468+(d<<2)|0;if((q|0)==(c[e>>2]|0)){c[e>>2]=p;if(!p){c[9792]=c[9792]&~(1<<d);break}}else{if(i>>>0<(c[9795]|0)>>>0)Gb();d=i+16|0;if((c[d>>2]|0)==(q|0))c[d>>2]=p;else c[i+20>>2]=p;if(!p)break}e=c[9795]|0;if(p>>>0<e>>>0)Gb();c[p+24>>2]=i;d=c[a+(b+16)>>2]|0;do if(d)if(d>>>0<e>>>0)Gb();else{c[p+16>>2]=d;c[d+24>>2]=p;break}while(0);d=c[a+(b+20)>>2]|0;if(d)if(d>>>0<(c[9795]|0)>>>0)Gb();else{c[p+20>>2]=d;c[d+24>>2]=p;break}}}else{f=c[a+(b+8)>>2]|0;e=c[a+(b+12)>>2]|0;d=39204+(g<<1<<2)|0;if((f|0)!=(d|0)){if(f>>>0<j>>>0)Gb();if((c[f+12>>2]|0)!=(q|0))Gb()}if((e|0)==(f|0)){c[9791]=c[9791]&~(1<<g);break}if((e|0)!=(d|0)){if(e>>>0<j>>>0)Gb();d=e+8|0;if((c[d>>2]|0)==(q|0))o=d;else Gb()}else o=e+8|0;c[f+12>>2]=e;c[o>>2]=f}while(0);c[t+4>>2]=h|1;c[t+h>>2]=h;if((t|0)==(c[9796]|0)){c[9793]=h;return}}else{c[d>>2]=e&-2;c[t+4>>2]=h|1;c[t+h>>2]=h}d=h>>>3;if(h>>>0<256){e=d<<1;g=39204+(e<<2)|0;f=c[9791]|0;d=1<<d;if(f&d){d=39204+(e+2<<2)|0;e=c[d>>2]|0;if(e>>>0<(c[9795]|0)>>>0)Gb();else{r=d;s=e}}else{c[9791]=f|d;r=39204+(e+2<<2)|0;s=g}c[r>>2]=t;c[s+12>>2]=t;c[t+8>>2]=s;c[t+12>>2]=g;return}d=h>>>8;if(d)if(h>>>0>16777215)g=31;else{r=(d+1048320|0)>>>16&8;s=d<<r;q=(s+520192|0)>>>16&4;s=s<<q;g=(s+245760|0)>>>16&2;g=14-(q|r|g)+(s<<g>>>15)|0;g=h>>>(g+7|0)&1|g<<1}else g=0;d=39468+(g<<2)|0;c[t+28>>2]=g;c[t+20>>2]=0;c[t+16>>2]=0;e=c[9792]|0;f=1<<g;if(!(e&f)){c[9792]=e|f;c[d>>2]=t;c[t+24>>2]=d;c[t+12>>2]=t;c[t+8>>2]=t;return}d=c[d>>2]|0;a:do if((c[d+4>>2]&-8|0)!=(h|0)){g=h<<((g|0)==31?0:25-(g>>>1)|0);while(1){e=d+16+(g>>>31<<2)|0;f=c[e>>2]|0;if(!f)break;if((c[f+4>>2]&-8|0)==(h|0)){d=f;break a}else{g=g<<1;d=f}}if(e>>>0<(c[9795]|0)>>>0)Gb();c[e>>2]=t;c[t+24>>2]=d;c[t+12>>2]=t;c[t+8>>2]=t;return}while(0);e=d+8|0;f=c[e>>2]|0;s=c[9795]|0;if(!(f>>>0>=s>>>0&d>>>0>=s>>>0))Gb();c[f+12>>2]=t;c[e>>2]=t;c[t+8>>2]=f;c[t+12>>2]=d;c[t+24>>2]=0;return}function EC(b,d){b=b|0;d=d|0;if(!(a[d>>0]&1)){c[b>>2]=c[d>>2];c[b+4>>2]=c[d+4>>2];c[b+8>>2]=c[d+8>>2]}else FC(b,c[d+8>>2]|0,c[d+4>>2]|0);return}function FC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;if(e>>>0>4294967279)Pz(b);if(e>>>0<11){a[b>>0]=e<<1;b=b+1|0}else{g=e+16&-16;f=Sz(g)|0;c[b+8>>2]=f;c[b>>2]=g|1;c[b+4>>2]=e;b=f}XL(b|0,d|0,e|0)|0;a[b+e>>0]=0;return}function GC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;if(d>>>0>4294967279)Pz(b);if(d>>>0<11){a[b>>0]=d<<1;b=b+1|0}else{g=d+16&-16;f=Sz(g)|0;c[b+8>>2]=f;c[b>>2]=g|1;c[b+4>>2]=d;b=f}ZL(b|0,e|0,d|0)|0;a[b+d>>0]=0;return}function HC(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0;h=a[d>>0]|0;g=(h&1)==0;h=g?(h&255)>>>1:c[d+4>>2]|0;if(h>>>0<e>>>0)RA(b);else{h=h-e|0;FC(b,(g?d+1|0:c[d+8>>2]|0)+e|0,h>>>0<f>>>0?h:f);return}}function IC(b){b=b|0;if(a[b>>0]&1)Uz(c[b+8>>2]|0);return}function JC(b,d){b=b|0;d=d|0;var e=0,f=0;if((b|0)!=(d|0)){e=a[d>>0]|0;f=(e&1)==0;LC(b,f?d+1|0:c[d+8>>2]|0,f?(e&255)>>>1:c[d+4>>2]|0)|0}return b|0}function KC(a,b){a=a|0;b=b|0;return LC(a,b,iC(b)|0)|0}function LC(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;f=a[b>>0]|0;if(!(f&1))h=10;else{f=c[b>>2]|0;h=(f&-2)+-1|0;f=f&255}g=(f&1)==0;do if(h>>>0>=e>>>0){if(g)f=b+1|0;else f=c[b+8>>2]|0;YL(f|0,d|0,e|0)|0;a[f+e>>0]=0;if(!(a[b>>0]&1)){a[b>>0]=e<<1;break}else{c[b+4>>2]=e;break}}else{if(g)f=(f&255)>>>1;else f=c[b+4>>2]|0;SC(b,h,e-h|0,f,0,f,e,d)}while(0);return b|0}
function li(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;w=i;i=i+48|0;x=w+28|0;p=w+16|0;n=w+12|0;m=w;q=Zi(e)|0;mr(x,Oi(q)|0);l=x+4|0;e=c[x>>2]|0;a:do if((c[l>>2]|0)==(e|0)){e=0;u=7}else{g=0;f=0;while(1){o=0;e=qa(137,c[e+(g<<2)>>2]|0)|0;u=o;o=0;if(u&1)break;f=e+f|0;g=g+1|0;e=c[x>>2]|0;if(g>>>0>=(c[l>>2]|0)-e>>2>>>0){e=f;u=7;break a}}e=cc()|0;u=6}while(0);do if((u|0)==7){o=0;ma(116,b|0,e|0);u=o;o=0;if(u&1){e=cc()|0;u=6;break}e=c[x>>2]|0;b:do if((c[l>>2]|0)!=(e|0)){k=0;f=0;c:while(1){h=c[e+(k<<2)>>2]|0;j=0;while(1){o=0;e=qa(137,h|0)|0;u=o;o=0;if(u&1){u=17;break c}if((j|0)>=(e|0))break;o=0;g=qa(138,h|0)|0;u=o;o=0;if(u&1){u=17;break c}o=0;e=qa(139,q|0)|0;u=o;o=0;if(u&1){u=17;break c}o=0;ma(87,p|0,e+g|0);u=o;o=0;if(u&1){u=17;break c}o=0;e=qa(111,24)|0;u=o;o=0;if(u&1){u=20;break c}Pd(m,p);ii(e,g,m);c[n>>2]=0;or(n,e);Sd(m);or((c[b>>2]|0)+(f<<2)|0,c[n>>2]|0);pr(n);Sd(p);j=j+1|0;f=f+1|0}k=k+1|0;e=c[x>>2]|0;if(k>>>0>=(c[l>>2]|0)-e>>2>>>0){u=22;break b}}if((u|0)==17){e=cc()|0;u=19;break}else if((u|0)==20){e=cc()|0;Sd(p);break}}else{f=0;u=22}while(0);d:do if((u|0)==22){e=c[b>>2]|0;t=c[(c[e>>2]|0)+20>>2]|0;s=c[t+12>>2]|0;t=c[t+8>>2]|0;l=s-t|0;g=l+1|0;j=(c[b+4>>2]|0)-e>>2;while(1){k=j;j=j+-1|0;if((k|0)<=0){u=29;break}h=c[(c[e+(j<<2)>>2]|0)+20>>2]|0;h=(c[h+12>>2]|0)-(c[h+8>>2]|0)|0;if((h|0)==(l|0)){u=29;break}if((h|0)!=(g|0)){u=26;break}}do if((u|0)==26){e=Ob(8)|0;o=0;ma(103,e|0,49862);w=o;o=0;if(w&1){w=cc()|0;Nb(e|0);e=w;break d}else{o=0;mb(55,e|0,240,66);o=0;break}}else if((u|0)==29?(o=0,v=qa(139,q|0)|0,r=o,o=0,!(r&1)):0){q=l-v|0;d=d+8|0;r=(f|0)>0?f:0;m=(q|0)>0?q:0;if((q|0)>0){e=(f|0)>0;g=0;j=0;while(1){if(e){h=0;l=j;while(1){a[(c[(c[(c[(c[b>>2]|0)+(h<<2)>>2]|0)+20>>2]|0)+8>>2]|0)+g>>0]=a[(c[(c[d>>2]|0)+8>>2]|0)+l>>0]|0;h=h+1|0;if((h|0)>=(f|0))break;else l=l+1|0}}g=g+1|0;if((g|0)>=(q|0))break;else j=r+j|0}}e=$(r,m)|0;g=e+((k|0)>(f|0)?k:f)|0;if((k|0)<(f|0)){h=k;while(1){a[(c[(c[(c[(c[b>>2]|0)+(h<<2)>>2]|0)+20>>2]|0)+8>>2]|0)+q>>0]=a[(c[(c[d>>2]|0)+8>>2]|0)+e>>0]|0;h=h+1|0;if((h|0)>=(f|0))break;else e=e+1|0}}n=g-k|0;p=c[(c[c[b>>2]>>2]|0)+20>>2]|0;p=(c[p+12>>2]|0)-(c[p+8>>2]|0)|0;l=$(r,t+v+((q|0)>(p|0)?q:p)-s|0)|0;if((q|0)<(p|0)){m=(f|0)>0;e=q;h=n;while(1){if(m){g=0;j=h;while(1){a[(c[(c[(c[(c[b>>2]|0)+(g<<2)>>2]|0)+20>>2]|0)+8>>2]|0)+(((g|0)>=(k|0)&1)+e)>>0]=a[(c[(c[d>>2]|0)+8>>2]|0)+j>>0]|0;g=g+1|0;if((g|0)>=(f|0))break;else j=j+1|0}}e=e+1|0;if((e|0)>=(p|0))break;else h=r+h|0}}v=c[d>>2]|0;if((n+l|0)==((c[v+12>>2]|0)-(c[v+8>>2]|0)|0)){qr(x);i=w;return}e=Ob(8)|0;o=0;ma(103,e|0,49901);w=o;o=0;if(w&1){w=cc()|0;Nb(e|0);e=w;break d}else{o=0;mb(55,e|0,240,66);o=0;break}}while(0);e=cc()|0;u=19}while(0);rr(b)}while(0);qr(x);bc(e|0)}function mi(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0;y=i;i=i+432|0;g=y+408|0;e=y+396|0;x=y+392|0;E=y+116|0;D=y+256|0;C=y+120|0;B=y+104|0;l=y+100|0;m=y+96|0;n=y+92|0;p=y+88|0;q=y+84|0;u=y+80|0;r=y+68|0;j=y+56|0;k=y+44|0;A=y+32|0;z=y+28|0;s=y+16|0;v=y+4|0;w=y;h=Sz(28)|0;sr(h,d);c[E>>2]=0;tr(E,h);h=D+56|0;t=D+4|0;c[D>>2]=29792;c[h>>2]=29812;o=0;ma(104,D+56|0,t|0);f=o;o=0;a:do if(f&1){e=cc()|0;g=18}else{c[D+128>>2]=0;c[D+132>>2]=-1;c[D>>2]=29832;c[D+56>>2]=29852;o=0;ka(307,t|0);f=o;o=0;do if(f&1)e=cc()|0;else{c[t>>2]=29868;f=D+36|0;c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;c[D+48>>2]=0;c[D+52>>2]=16;c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=0;o=0;ma(105,t|0,e|0);F=o;o=0;if(F&1){F=cc()|0;IC(e);IC(f);nD(t);e=F;break}IC(e);f=C+56|0;h=C+4|0;c[C>>2]=29792;c[f>>2]=29812;o=0;ma(104,C+56|0,h|0);F=o;o=0;b:do if(F&1){e=cc()|0;g=19}else{c[C+128>>2]=0;c[C+132>>2]=-1;c[C>>2]=29832;c[C+56>>2]=29852;o=0;ka(307,h|0);F=o;o=0;do if(F&1)e=cc()|0;else{c[h>>2]=29868;e=C+36|0;c[e>>2]=0;c[e+4>>2]=0;c[e+8>>2]=0;c[C+48>>2]=0;c[C+52>>2]=16;c[g>>2]=0;c[g+4>>2]=0;c[g+8>>2]=0;o=0;ma(105,h|0,g|0);F=o;o=0;if(F&1){F=cc()|0;IC(g);IC(e);nD(h);e=F;break}IC(g);c[B>>2]=0;c[B+4>>2]=0;c[B+8>>2]=0;g=c[E>>2]|0;e=1;c:while(1){switch(e|0){case 1:{c[l>>2]=0;tr(l,g);o=0;e=kb(55,0,l|0,D|0,C|0)|0;F=o;o=0;if(F&1){g=23;break c}ur(l);if(!e){g=48;break c}break}case 2:{c[m>>2]=0;tr(m,g);o=0;mb(65,b|0,m|0,D|0);F=o;o=0;if(F&1){g=26;break c}ur(m);e=1;break}case 3:{c[n>>2]=0;tr(n,g);o=0;mb(66,b|0,n|0,D|0);F=o;o=0;if(F&1){g=29;break c}ur(n);e=1;break}case 4:{c[p>>2]=0;tr(p,g);o=0;mb(67,b|0,p|0,D|0);F=o;o=0;if(F&1){g=32;break c}ur(p);e=1;break}case 5:{c[q>>2]=0;tr(q,g);o=0;mb(68,0,q|0,D|0);F=o;o=0;if(F&1){g=35;break c}ur(q);e=1;break}case 6:{c[u>>2]=0;tr(u,g);o=0;ma(117,r|0,B|0);F=o;o=0;if(F&1){g=39;break c}o=0;ub(58,b|0,u|0,D|0,r|0);F=o;o=0;if(F&1){g=40;break c}He(r);ur(u);e=1;break}default:{g=42;break c}}o=0;f=qa(140,g|0)|0;F=o;o=0;if(F&1){g=20;break}if((f|0)<=0){g=48;break}}d:switch(g|0){case 20:{e=cc()|0;g=22;break}case 23:{e=cc()|0;ur(l);break}case 26:{e=cc()|0;ur(m);break}case 29:{e=cc()|0;ur(n);break}case 32:{e=cc()|0;ur(p);break}case 35:{e=cc()|0;ur(q);break}case 39:{e=cc()|0;g=41;break}case 40:{e=cc()|0;He(r);g=41;break}case 42:{e=Ob(8)|0;o=0;ma(88,e|0,47969);F=o;o=0;if(F&1){F=cc()|0;Nb(e|0);e=F;break}else{o=0;mb(55,e|0,320,76);o=0;g=21;break}}case 48:{o=0;ma(106,j|0,h|0);F=o;o=0;if(F&1)g=21;else{F=a[j>>0]|0;F=(((F&1)==0?(F&255)>>>1:c[j+4>>2]|0)|0)==0;IC(j);do if(!F){o=0;ma(106,k|0,h|0);F=o;o=0;if(F&1){g=21;break d}o=0;Wa(80,D|0,k|0)|0;F=o;o=0;if(F&1){e=cc()|0;IC(k);break d}else{IC(k);break}}while(0);Pd(A,d);o=0;f=qa(111,20)|0;F=o;o=0;e:do if(F&1)e=cc()|0;else{o=0;ma(106,s|0,t|0);F=o;o=0;do if(F&1)e=cc()|0;else{o=0;ma(94,f|0,s|0);F=o;o=0;if(F&1){e=cc()|0;IC(s);break}c[z>>2]=0;cq(z,f);IC(s);o=0;e=qa(111,48)|0;F=o;o=0;do if(!(F&1)){Pd(v,A);c[w>>2]=0;cq(w,c[z>>2]|0);o=0;mb(53,e|0,v|0,w|0);F=o;o=0;if(F&1){F=cc()|0;ne(w);Sd(v);Uz(e);e=F;break}else{c[x>>2]=0;dq(x,e);ne(w);Sd(v);ne(z);Sd(A);He(B);Nq(C);Nq(D);ur(E);i=y;return c[x>>2]|0}}else e=cc()|0;while(0);ne(z);break e}while(0);Uz(f)}while(0);Sd(A)}break}}if((g|0)==21){e=cc()|0;g=22}else if((g|0)==41)ur(u);He(B);Nq(C);break b}while(0);g=19}while(0);if((g|0)==19)iD(f);Nq(D);break a}while(0);g=18}while(0);if((g|0)==18)iD(h);ur(E);bc(e|0);return 0}function ni(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0;a=0;a:while(1){f=kg(c[b>>2]|0,8)|0;if(!f){b=3;break}if((f|0)<129){b=7;break}if((f|0)==129){a=0;b=27;break}b:do if((f|0)>=230){switch(f|0){case 230:{a=2;b=27;break a}case 231:{a=6;b=28;break a}case 232:{Jq(d,29)|0;break b}default:{}}if((f+-233|0)>>>0>=2)switch(f|0){case 238:{a=4;b=27;break a}case 239:{a=3;b=28;break a}case 240:{b=26;break a}case 235:{a=1;break b}case 236:{Yq(d,48022)|0;Yq(e,48032)|0;break b}case 237:{Yq(d,48038)|0;Yq(e,48032)|0;break b}default:{if((f|0)<=241)break b;if((f|0)!=254){b=22;break a}if(!(lg(c[b>>2]|0)|0))break b;else{b=22;break a}}}}else{f=f+-130|0;if((f|0)<10)Jq(d,48)|0;LD(d,f)|0}while(0);if((lg(c[b>>2]|0)|0)<=0){a=1;b=27;break}}do if((b|0)==3){a=Ob(8)|0;o=0;ma(88,a|0,47996);d=o;o=0;if(d&1){b=cc()|0;Nb(a|0);a=b;b=29;break}else Hc(a|0,320,76)}else if((b|0)==7){Jq(d,(a?f+128|0:f)+255&255)|0;a=1;b=28}else if((b|0)==22){a=Ob(8)|0;o=0;ma(88,a|0,48048);d=o;o=0;if(d&1){b=cc()|0;Nb(a|0);a=b;b=29;break}else Hc(a|0,320,76)}else if((b|0)==26){a=5;b=28}else if((b|0)==27)b=28;while(0);if((b|0)==28)return a|0;else if((b|0)==29)bc(a|0);return 0}function oi(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0;m=i;i=i+16|0;l=m;j=l+4|0;k=l+8|0;g=0;f=0;a:while(1){if((lg(c[d>>2]|0)|0)==8){f=31;break}b=kg(c[d>>2]|0,8)|0;if((b|0)==254){f=31;break}h=(b<<8)+-1+(kg(c[d>>2]|0,8)|0)|0;b=(h|0)/1600|0;c[l>>2]=b;b=h+($(b,-1600)|0)|0;h=(b|0)/40|0;c[j>>2]=h;c[k>>2]=b+($(h,-40)|0);h=0;b=g;do{g=c[l+(h<<2)>>2]|0;b:do switch(b|0){case 0:{if((g|0)<3){b=g+1|0;break b}b=a[45755+g>>0]|0;if(f){Jq(e,(b&255)+128&255)|0;b=0;f=0;break b}else{Jq(e,b)|0;b=0;f=0;break b}}case 1:if(f){Jq(e,g+128&255)|0;b=0;f=0;break b}else{Jq(e,g&255)|0;b=0;f=0;break b}case 2:{if((g|0)>=27){switch(g|0){case 30:{b=0;f=1;break b}case 27:break;default:{f=20;break a}}Jq(e,29)|0;b=0;break b}b=a[45795+g>>0]|0;if(f){Jq(e,(b&255)+128&255)|0;b=0;f=0;break b}else{Jq(e,b)|0;b=0;f=0;break b}}case 3:if(f){Jq(e,g+224&255)|0;b=0;f=0;break b}else{Jq(e,g+96&255)|0;b=0;f=0;break b}default:{f=26;break a}}while(0);h=h+1|0}while((h|0)<3);if((lg(c[d>>2]|0)|0)>0)g=b;else{f=31;break}}do if((f|0)==20){b=Ob(8)|0;o=0;ma(88,b|0,48083);m=o;o=0;if(m&1){m=cc()|0;Nb(b|0);b=m;break}else Hc(b|0,320,76)}else if((f|0)==26){b=Ob(8)|0;o=0;ma(88,b|0,48113);m=o;o=0;if(m&1){m=cc()|0;Nb(b|0);b=m;break}else Hc(b|0,320,76)}else if((f|0)==31){i=m;return}while(0);bc(b|0)}function pi(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0;m=i;i=i+16|0;l=m;j=l+4|0;k=l+8|0;g=0;f=0;a:while(1){if((lg(c[d>>2]|0)|0)==8){f=31;break}b=kg(c[d>>2]|0,8)|0;if((b|0)==254){f=31;break}h=(b<<8)+-1+(kg(c[d>>2]|0,8)|0)|0;b=(h|0)/1600|0;c[l>>2]=b;b=h+($(b,-1600)|0)|0;h=(b|0)/40|0;c[j>>2]=h;c[k>>2]=b+($(h,-40)|0);h=0;b=g;do{g=c[l+(h<<2)>>2]|0;b:do switch(b|0){case 0:{if((g|0)<3){b=g+1|0;break b}b=a[45822+g>>0]|0;if(f){Jq(e,(b&255)+128&255)|0;b=0;f=0;break b}else{Jq(e,b)|0;b=0;f=0;break b}}case 1:if(f){Jq(e,g+128&255)|0;b=0;f=0;break b}else{Jq(e,g&255)|0;b=0;f=0;break b}case 2:{if((g|0)>=27){switch(g|0){case 30:{b=0;f=1;break b}case 27:break;default:{f=20;break a}}Jq(e,29)|0;b=0;break b}b=a[45795+g>>0]|0;if(f){Jq(e,(b&255)+128&255)|0;b=0;f=0;break b}else{Jq(e,b)|0;b=0;f=0;break b}}case 3:{b=a[45862+g>>0]|0;if(f){Jq(e,(b&255)+128&255)|0;b=0;f=0;break b}else{Jq(e,b)|0;b=0;f=0;break b}}default:{f=26;break a}}while(0);h=h+1|0}while((h|0)<3);if((lg(c[d>>2]|0)|0)>0)g=b;else{f=31;break}}do if((f|0)==20){b=Ob(8)|0;o=0;ma(88,b|0,48139);m=o;o=0;if(m&1){m=cc()|0;Nb(b|0);b=m;break}else Hc(b|0,320,76)}else if((f|0)==26){b=Ob(8)|0;o=0;ma(88,b|0,48170);m=o;o=0;if(m&1){m=cc()|0;Nb(b|0);b=m;break}else Hc(b|0,320,76)}else if((f|0)==31){i=m;return}while(0);bc(b|0)}function qi(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;j=i;i=i+16|0;h=j;f=h+4|0;g=h+8|0;a:while(1){if((lg(c[b>>2]|0)|0)==8){k=19;break}a=kg(c[b>>2]|0,8)|0;if((a|0)==254){k=19;break}e=(a<<8)+-1+(kg(c[b>>2]|0,8)|0)|0;a=(e|0)/1600|0;c[h>>2]=a;a=e+($(a,-1600)|0)|0;e=(a|0)/40|0;c[f>>2]=e;c[g>>2]=a+($(e,-40)|0);e=0;do{a=c[h+(e<<2)>>2]|0;b:do switch(a|0){case 0:{Jq(d,13)|0;break}case 1:{Jq(d,42)|0;break}case 2:{Jq(d,62)|0;break}case 3:{Jq(d,32)|0;break}default:{if((a|0)<14){Jq(d,a+44&255)|0;break b}if((a|0)>=40)break a;Jq(d,a+51&255)|0}}while(0);e=e+1|0}while((e|0)<3);if((lg(c[b>>2]|0)|0)<=0){k=19;break}}if((k|0)==19){i=j;return}a=Ob(8)|0;o=0;ma(88,a|0,48197);k=o;o=0;if(k&1){k=cc()|0;Nb(a|0);bc(k|0)}else Hc(a|0,320,76)}function ri(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;a:do{if((lg(c[b>>2]|0)|0)<17)break;a=c[b>>2]|0;e=0;do{a=kg(a,6)|0;if((a|0)==31){h=5;break a}Jq(d,(a<<1&64^64|a)&255)|0;e=e+1|0;a=c[b>>2]|0}while((e|0)<4)}while((lg(a)|0)>0);if((h|0)==5?(f=c[b>>2]|0,g=c[f+24>>2]|0,(g|0)!=0):0)kg(f,8-g|0)|0;return}function si(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0;p=i;i=i+16|0;n=p;m=c[d>>2]|0;b=c[m+20>>2]|0;g=b+2|0;b=(kg(m,8)|0)+255-(((b*149|0)+149|0)%255|0)|0;if(!((b&255)<<24>>24))m=(lg(c[d>>2]|0)|0)/8|0;else m=b<<24>>24;a:do if((m|0)<0){b=Ob(8)|0;o=0;ma(88,b|0,48227);e=o;o=0;if(e&1){e=cc()|0;Nb(b|0);b=e;break}else Hc(b|0,320,76)}else{k=f+4|0;l=f+8|0;b:do if((m|0)>0){j=0;while(1){if((lg(c[d>>2]|0)|0)<8)break;b=(kg(c[d>>2]|0,8)|0)+255-((g*149|0)%255|0)&255;a[n>>0]=b;h=c[k>>2]|0;if((h|0)==(c[l>>2]|0))wr(f,n);else{a[h>>0]=b;c[k>>2]=(c[k>>2]|0)+1}Jq(e,b)|0;j=j+1|0;if((j|0)>=(m|0))break b;else g=g+1|0}b=Ob(8)|0;o=0;ma(88,b|0,48254);e=o;o=0;if(e&1){e=cc()|0;Nb(b|0);b=e;break a}else Hc(b|0,320,76)}while(0);i=p;return}while(0);bc(b|0)}function ti(a){a=a|0;var b=0,c=0;c=i;i=i+16|0;b=c;iq(b,4372);o=0;ma(92,a|0,b|0);a=o;o=0;if(a&1){c=cc()|0;lq(b);bc(c|0)}else{lq(b);i=c;return}}function ui(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0;l=i;i=i+32|0;n=l+12|0;k=l;h=e+8|0;e=c[h>>2]|0;e=(c[e+12>>2]|0)-(c[e+8>>2]|0)|0;kq(n,e);j=(c[n+8>>2]|0)+8|0;if((e|0)>0){g=0;do{c[(c[j>>2]|0)+(g<<2)>>2]=d[(c[(c[h>>2]|0)+8>>2]|0)+g>>0];g=g+1|0}while((g|0)<(e|0))}mq(k,n);o=0;mb(56,b|0,k|0,e-f|0);b=o;o=0;if(!(b&1)){nq(k);if((f|0)>0){e=0;do{a[(c[(c[h>>2]|0)+8>>2]|0)+e>>0]=c[(c[j>>2]|0)+(e<<2)>>2];e=e+1|0}while((e|0)<(f|0))}nq(n);i=l;return}e=cc(256)|0;l=D;nq(k);if((l|0)==(Xb(256)|0)){fc(e|0)|0;e=Ob(8)|0;Qf(e);o=0;mb(55,e|0,160,56);o=0;e=cc()|0;o=0;ob(44);l=o;o=0;if(l&1){l=cc(0)|0;oq(l)}else m=e}else m=e;nq(n);bc(m|0)}function vi(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;q=i;i=i+128|0;v=q+100|0;e=q+96|0;f=q+92|0;g=q+88|0;u=q+76|0;t=q+64|0;h=q+52|0;s=q+40|0;r=q+36|0;p=q+24|0;l=q+12|0;m=q+120|0;n=q;Zp(e,d);o=0;ma(118,v|0,e|0);k=o;o=0;if(k&1){v=cc()|0;Yd(e);e=v}else{Yd(e);Zp(g,d);o=0;e=Wa(78,v|0,g|0)|0;k=o;o=0;do if(k&1){e=cc()|0;Yd(g)}else{c[f>>2]=e;kr(f);Yd(g);o=0;ma(119,u|0,v|0);k=o;o=0;if(k&1){e=cc()|0;break}Pd(h,u);o=0;mb(69,t|0,h|0,e|0);k=o;o=0;if(k&1){e=cc()|0;Sd(h)}else{Sd(h);j=(c[t+4>>2]|0)-(c[t>>2]|0)|0;k=j>>2;a:do if((j|0)>0){f=0;e=0;while(1){o=0;d=qa(141,c[(c[t>>2]|0)+(f<<2)>>2]|0)|0;h=o;o=0;if(h&1)break;e=d+e|0;f=f+1|0;if((f|0)>=(k|0)){d=15;break a}}e=cc()|0;d=14}else{e=0;d=15}while(0);do if((d|0)==15){o=0;ma(87,s|0,e|0);h=o;o=0;if(h&1){e=cc()|0;d=14;break}g=p+8|0;h=(c[s+8>>2]|0)+8|0;b:do if((j|0)>0){f=0;while(1){xr(r,(c[t>>2]|0)+(f<<2)|0);e=c[r>>2]|0;o=0;ma(120,p|0,e|0);j=o;o=0;if(j&1){d=22;break}o=0;e=qa(141,e|0)|0;j=o;o=0;if(j&1){d=23;break}Pd(l,p);o=0;mb(70,b|0,l|0,e|0);j=o;o=0;if(j&1){d=24;break}Sd(l);if((e|0)>0){d=0;do{j=($(d,k)|0)+f|0;a[(c[h>>2]|0)+j>>0]=a[(c[(c[g>>2]|0)+8>>2]|0)+d>>0]|0;d=d+1|0}while((d|0)<(e|0))}Sd(p);pr(r);f=f+1|0;if((f|0)>=(k|0)){d=28;break b}}if((d|0)==22)e=cc()|0;else if((d|0)==23){e=cc()|0;d=26}else if((d|0)==24){e=cc()|0;Sd(l);d=26}if((d|0)==26)Sd(p);pr(r)}else d=28;while(0);do if((d|0)==28){Pd(n,s);o=0;e=Wa(81,m|0,n|0)|0;r=o;o=0;if(r&1){e=cc()|0;Sd(n);break}else{Sd(n);Sd(s);rr(t);Sd(u);yr(v);i=q;return e|0}}while(0);Sd(s)}while(0);rr(t)}Sd(u)}while(0);yr(v)}bc(e|0);return 0}function wi(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a+4>>2]=0;c[a>>2]=30716;tq(a+8|0,d);tq(a+12|0,b);c[a+16>>2]=e;return}function xi(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;tq(b,a+12|0);i=d;return c[b>>2]|0}function yi(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;tq(b,a+8|0);i=d;return c[b>>2]|0}function zi(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=4440;Zp(a+8|0,b);return}function Ai(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,fa=0,ga=0,ha=0,ia=0,ja=0,la=0,na=0,pa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0,Ia=0,Ja=0,Ka=0,La=0,Ma=0,Na=0,Oa=0,Pa=0,Qa=0,Ra=0,Sa=0,Ta=0,Ua=0,Va=0,Xa=0,Za=0,_a=0,$a=0,ab=0,bb=0,cb=0,db=0,eb=0;Ia=i;i=i+432|0;Fa=Ia+420|0;eb=Ia+416|0;b=Ia+412|0;$a=Ia+400|0;ab=Ia+396|0;bb=Ia+392|0;cb=Ia+388|0;db=Ia+384|0;_a=Ia+372|0;e=Ia+368|0;f=Ia+364|0;g=Ia+360|0;h=Ia+356|0;j=Ia+352|0;k=Ia+348|0;m=Ia+344|0;n=Ia+340|0;l=Ia+336|0;p=Ia+332|0;q=Ia+328|0;r=Ia+324|0;Va=Ia+320|0;Xa=Ia+316|0;Za=Ia+304|0;s=Ia+300|0;t=Ia+296|0;u=Ia+292|0;v=Ia+288|0;Ua=Ia+284|0;Sa=Ia+280|0;Ta=Ia+276|0;Qa=Ia+264|0;Na=Ia+260|0;Oa=Ia+256|0;Pa=Ia+252|0;A=Ia+248|0;y=Ia+244|0;x=Ia+240|0;E=Ia+236|0;D=Ia+232|0;C=Ia+228|0;H=Ia+224|0;G=Ia+220|0;F=Ia+216|0;I=Ia+212|0;J=Ia+208|0;K=Ia+204|0;L=Ia+200|0;M=Ia+196|0;N=Ia+192|0;Ka=Ia+188|0;Ma=Ia+184|0;La=Ia+180|0;O=Ia+176|0;P=Ia+172|0;Q=Ia+168|0;R=Ia+164|0;S=Ia+160|0;Y=Ia+156|0;Z=Ia+152|0;_=Ia+148|0;$=Ia+144|0;aa=Ia+140|0;ba=Ia+136|0;sa=Ia+132|0;ta=Ia+128|0;ua=Ia+124|0;va=Ia+120|0;wa=Ia+116|0;Ba=Ia+112|0;Ca=Ia+108|0;Da=Ia+104|0;T=Ia+100|0;U=Ia+96|0;V=Ia+92|0;W=Ia+88|0;X=Ia+84|0;ca=Ia+80|0;ha=Ia+76|0;ia=Ia+72|0;da=Ia+68|0;fa=Ia+64|0;ga=Ia+60|0;ja=Ia+56|0;la=Ia+52|0;na=Ia+48|0;pa=Ia+44|0;ra=Ia+40|0;xa=Ia+36|0;za=Ia+32|0;Aa=Ia+28|0;Ja=Ia+16|0;Ga=Ia+12|0;Ha=Ia;d=Sz(36)|0;Ea=a+8|0;Zp(b,Ea);o=0;ma(97,d|0,b|0);B=o;o=0;if(B&1){eb=cc()|0;Yd(b);Uz(d);b=eb}else{c[eb>>2]=0;zr(eb,d);Yd(b);o=0;ma(98,$a|0,c[eb>>2]|0);B=o;o=0;if(B&1)b=cc()|0;else{tq(ab,c[$a>>2]|0);tq(bb,(c[$a>>2]|0)+4|0);tq(cb,(c[$a>>2]|0)+8|0);tq(db,(c[$a>>2]|0)+12|0);o=0;ma(121,_a|0,4);B=o;o=0;if(B&1)b=cc()|0;else{b=c[_a>>2]|0;c[f>>2]=0;w=c[ab>>2]|0;vq(f,w);c[g>>2]=0;B=c[bb>>2]|0;vq(g,B);o=0;d=ya(96,a|0,f|0,g|0)|0;z=o;o=0;do if(z&1){b=cc()|0;uq(g);uq(f)}else{c[e>>2]=d;Br(b,d);Cr(e);uq(g);uq(f);b=c[_a>>2]|0;c[j>>2]=0;vq(j,w);c[k>>2]=0;z=c[cb>>2]|0;vq(k,z);o=0;d=ya(96,a|0,j|0,k|0)|0;g=o;o=0;if(g&1){b=cc()|0;uq(k);uq(j);break}c[h>>2]=d;Br(b+4|0,d);Cr(h);uq(k);uq(j);b=c[_a>>2]|0;c[n>>2]=0;vq(n,B);c[l>>2]=0;g=c[db>>2]|0;vq(l,g);o=0;d=ya(96,a|0,n|0,l|0)|0;k=o;o=0;if(k&1){b=cc()|0;uq(l);uq(n);break}c[m>>2]=d;Br(b+8|0,d);Cr(m);uq(l);uq(n);b=c[_a>>2]|0;c[q>>2]=0;vq(q,z);c[r>>2]=0;vq(r,g);o=0;d=ya(96,a|0,q|0,r|0)|0;n=o;o=0;if(n&1){b=cc()|0;uq(r);uq(q);break}c[p>>2]=d;Br(b+12|0,d);Cr(p);uq(r);uq(q);Ci(a,_a);Dr(Va,c[_a>>2]|0);Dr(Xa,(c[_a>>2]|0)+4|0);c[Za+4>>2]=0;c[Za+8>>2]=0;f=Za+4|0;c[Za>>2]=f;b=c[Va>>2]|0;c[s>>2]=xi(b)|0;o=0;ma(122,Za|0,s|0);r=o;o=0;do if(r&1){b=cc()|0;uq(s)}else{uq(s);c[t>>2]=yi(b)|0;o=0;ma(122,Za|0,t|0);s=o;o=0;if(s&1){b=cc()|0;uq(t);break}uq(t);b=c[Xa>>2]|0;c[u>>2]=xi(b)|0;o=0;ma(122,Za|0,u|0);t=o;o=0;if(t&1){b=cc()|0;uq(u);break}uq(u);c[v>>2]=yi(b)|0;o=0;ma(122,Za|0,v|0);u=o;o=0;if(u&1){b=cc()|0;uq(v);break}uq(v);c[Ua>>2]=0;vq(Ua,0);c[Sa>>2]=0;vq(Sa,0);c[Ta>>2]=0;vq(Ta,0);b=c[Za>>2]|0;if((b|0)!=(f|0)){e=b;d=b;while(1){b=e+16|0;do if((c[e+20>>2]|0)!=2){b=c[b>>2]|0;if(!(c[Ua>>2]|0)){vq(Ua,b);break}else{vq(Ta,b);break}}else vq(Sa,c[b>>2]|0);while(0);b=Fr(d)|0;if((b|0)==(f|0))break;else{e=b;d=b}}}b=c[Ua>>2]|0;d=c[Sa>>2]|0;e=c[Ta>>2]|0;if(!((b|0)==0|(d|0)==0|(e|0)==0)){o=0;ma(123,Qa|0,3);v=o;o=0;if(v&1)Ra=27;else{vq(c[Qa>>2]|0,b);vq((c[Qa>>2]|0)+4|0,d);vq((c[Qa>>2]|0)+8|0,e);o=0;ka(311,Qa|0);v=o;o=0;if(v&1)b=cc()|0;else{tq(Na,c[Qa>>2]|0);vq(Sa,c[(c[Qa>>2]|0)+4>>2]|0);tq(Oa,(c[Qa>>2]|0)+8|0);c[Pa>>2]=0;vq(Pa,0);c[A>>2]=0;j=c[Na>>2]|0;vq(A,j);o=0;b=Wa(82,w|0,A|0)|0;v=o;o=0;a:do if(v&1){b=cc()|0;Ra=49}else{b:do if(b){uq(A);Ra=51}else{c[y>>2]=0;vq(y,c[Sa>>2]|0);o=0;b=Wa(82,w|0,y|0)|0;v=o;o=0;do if(v&1)b=cc()|0;else{if(b){uq(y);uq(A);Ra=51;break b}c[x>>2]=0;b=c[Oa>>2]|0;vq(x,b);o=0;d=Wa(82,w|0,x|0)|0;v=o;o=0;if(v&1){b=cc()|0;uq(x);break}uq(x);uq(y);uq(A);if(d){Ra=51;break b}vq(Pa,w);f=Oa;break b}while(0);uq(y);Ra=49;break a}while(0);c:do if((Ra|0)==51){c[E>>2]=0;vq(E,j);o=0;b=Wa(82,B|0,E|0)|0;A=o;o=0;d:do if(A&1)b=cc()|0;else{e:do if(b)uq(E);else{c[D>>2]=0;vq(D,c[Sa>>2]|0);o=0;b=Wa(82,B|0,D|0)|0;A=o;o=0;do if(A&1)b=cc()|0;else{if(b){uq(D);uq(E);break e}c[C>>2]=0;b=c[Oa>>2]|0;vq(C,b);o=0;d=Wa(82,B|0,C|0)|0;A=o;o=0;if(A&1){b=cc()|0;uq(C);break}uq(C);uq(D);uq(E);if(d)break e;vq(Pa,B);f=Oa;break c}while(0);uq(D);break d}while(0);c[H>>2]=0;vq(H,j);o=0;b=Wa(82,z|0,H|0)|0;E=o;o=0;f:do if(E&1)b=cc()|0;else{g:do if(b)uq(H);else{c[G>>2]=0;vq(G,c[Sa>>2]|0);o=0;b=Wa(82,z|0,G|0)|0;E=o;o=0;do if(E&1)b=cc()|0;else{if(b){uq(G);uq(H);break g}c[F>>2]=0;b=c[Oa>>2]|0;vq(F,b);o=0;d=Wa(82,z|0,F|0)|0;E=o;o=0;if(E&1){b=cc()|0;uq(F);break}uq(F);uq(G);uq(H);if(d)break g;vq(Pa,z);f=Oa;break c}while(0);uq(G);break f}while(0);vq(Pa,g);f=Oa;b=c[Oa>>2]|0;break c}while(0);uq(H);break a}while(0);uq(E);break a}while(0);c[J>>2]=0;vq(J,b);c[K>>2]=0;g=c[Pa>>2]|0;vq(K,g);o=0;b=ya(96,a|0,J|0,K|0)|0;H=o;o=0;if(H&1){b=cc()|0;uq(K);uq(J);break}c[I>>2]=b;d=c[b+16>>2]|0;Cr(I);uq(K);uq(J);c[M>>2]=0;vq(M,j);c[N>>2]=0;vq(N,g);o=0;b=ya(96,a|0,M|0,N|0)|0;K=o;o=0;if(K&1){b=cc()|0;uq(N);uq(M);break}c[L>>2]=b;K=c[b+16>>2]|0;Cr(L);uq(N);uq(M);b=d+2+(d&1)|0;d=K+2+(K&1)|0;c[Ka>>2]=0;Ke(Ka,0);c[Ma>>2]=0;Zq(Ma,0);c[La>>2]=0;vq(La,0);h:do if((b<<2|0)<(d*7|0)){if((d<<2|0)>=(b*7|0)){Ra=86;break}c[U>>2]=0;e=c[Sa>>2]|0;vq(U,e);c[V>>2]=0;vq(V,j);c[W>>2]=0;f=c[f>>2]|0;vq(W,f);c[X>>2]=0;vq(X,g);o=0;b=oa(82,a|0,U|0,V|0,W|0,X|0,((d|0)>(b|0)?b:d)|0)|0;Da=o;o=0;if(Da&1){b=cc()|0;uq(X);uq(W);uq(V);uq(U);break}c[T>>2]=b;vq(La,b);uq(T);uq(X);uq(W);uq(V);uq(U);d=c[La>>2]|0;if(!d){vq(La,g);d=c[La>>2]|0}c[ha>>2]=0;vq(ha,f);c[ia>>2]=0;vq(ia,d);o=0;b=ya(96,a|0,ha|0,ia|0)|0;Da=o;o=0;do if(!(Da&1)){c[ca>>2]=b;b=c[b+16>>2]|0;c[fa>>2]=0;vq(fa,j);c[ga>>2]=0;vq(ga,d);o=0;g=ya(96,a|0,fa|0,ga|0)|0;Da=o;o=0;if(Da&1){b=cc()|0;uq(ga);uq(fa);Cr(ca);break}c[da>>2]=g;g=c[g+16>>2]|0;g=(b|0)<(g|0)?g:b;Cr(da);uq(ga);uq(fa);Cr(ca);uq(ia);uq(ha);b=g+1|0;g=(b&1|0)==0?b:g+2|0;b=c[(c[a>>2]|0)+8>>2]|0;c[la>>2]=0;vq(la,f);c[na>>2]=0;vq(na,d);c[pa>>2]=0;vq(pa,e);c[ra>>2]=0;vq(ra,j);o=0;b=ea(b|0,a|0,la|0,na|0,pa|0,ra|0,g|0,g|0)|0;a=o;o=0;if(a&1){b=cc()|0;uq(ra);uq(pa);uq(na);uq(la);break h}c[ja>>2]=b;Zq(Ma,b);_q(ja);uq(ra);uq(pa);uq(na);uq(la);Zp(za,Ea);c[Aa>>2]=0;Zq(Aa,c[Ma>>2]|0);o=0;b=Ya(67,0,za|0,g|0,g|0,Aa|0)|0;Ea=o;o=0;if(Ea&1){b=cc()|0;_q(Aa);Yd(za);break h}else{c[xa>>2]=b;Ke(Ka,b);Yd(xa);_q(Aa);Yd(za);Ra=114;break h}}else b=cc()|0;while(0);uq(ia);uq(ha)}else Ra=86;while(0);do if((Ra|0)==86){c[P>>2]=0;e=c[Sa>>2]|0;vq(P,e);c[Q>>2]=0;vq(Q,j);c[R>>2]=0;f=c[f>>2]|0;vq(R,f);c[S>>2]=0;vq(S,g);o=0;b=ea(49,a|0,P|0,Q|0,R|0,S|0,b|0,d|0)|0;Aa=o;o=0;if(Aa&1){b=cc()|0;uq(S);uq(R);uq(Q);uq(P);break}c[O>>2]=b;vq(La,b);uq(O);uq(S);uq(R);uq(Q);uq(P);d=c[La>>2]|0;if(!d){vq(La,g);d=c[La>>2]|0}c[Z>>2]=0;vq(Z,f);c[_>>2]=0;vq(_,d);o=0;b=ya(96,a|0,Z|0,_|0)|0;Aa=o;o=0;if(Aa&1){b=cc()|0;uq(_);uq(Z);break}c[Y>>2]=b;g=c[b+16>>2]|0;Cr(Y);uq(_);uq(Z);c[aa>>2]=0;vq(aa,j);c[ba>>2]=0;vq(ba,d);o=0;b=ya(96,a|0,aa|0,ba|0)|0;Aa=o;o=0;if(Aa&1){b=cc()|0;uq(ba);uq(aa);break}c[$>>2]=b;h=c[b+16>>2]|0;Cr($);uq(ba);uq(aa);g=(g&1)+g|0;h=(h&1)+h|0;b=c[(c[a>>2]|0)+8>>2]|0;c[ta>>2]=0;vq(ta,f);c[ua>>2]=0;vq(ua,d);c[va>>2]=0;vq(va,e);c[wa>>2]=0;vq(wa,j);o=0;b=ea(b|0,a|0,ta|0,ua|0,va|0,wa|0,g|0,h|0)|0;a=o;o=0;if(a&1){b=cc()|0;uq(wa);uq(va);uq(ua);uq(ta);break}c[sa>>2]=b;Zq(Ma,b);_q(sa);uq(wa);uq(va);uq(ua);uq(ta);Zp(Ca,Ea);c[Da>>2]=0;Zq(Da,c[Ma>>2]|0);o=0;b=Ya(67,0,Ca|0,g|0,h|0,Da|0)|0;Ea=o;o=0;if(Ea&1){b=cc()|0;_q(Da);Yd(Ca);break}else{c[Ba>>2]=b;Ke(Ka,b);Yd(Ba);_q(Da);Yd(Ca);Ra=114;break}}while(0);do if((Ra|0)==114){o=0;b=qa(111,20)|0;Ea=o;o=0;if(Ea&1){b=cc()|0;break}o=0;ma(124,b|0,4);Ea=o;o=0;if(Ea&1){Ja=cc()|0;Uz(b);b=Ja;break}Dq(Ja,b);b=(c[Ja+8>>2]|0)+8|0;vq(c[b>>2]|0,f);vq((c[b>>2]|0)+4|0,e);vq((c[b>>2]|0)+8|0,d);vq((c[b>>2]|0)+12|0,j);o=0;b=qa(111,24)|0;Ea=o;o=0;do if(!(Ea&1)){c[Ga>>2]=0;Ke(Ga,c[Ka>>2]|0);oe(Ha,Ja);o=0;mb(52,b|0,Ga|0,Ha|0);Ea=o;o=0;if(Ea&1){Ia=cc()|0;pe(Ha);Yd(Ga);Uz(b);b=Ia;break}else{c[Fa>>2]=0;Hr(Fa,b);pe(Ha);Yd(Ga);pe(Ja);uq(La);_q(Ma);Yd(Ka);uq(Pa);uq(Oa);uq(Na);wq(Qa);uq(Ta);uq(Sa);uq(Ua);Ir(Za);Cr(Xa);Cr(Va);Jr(_a);uq(db);uq(cb);uq(bb);uq(ab);wq($a);Kr(eb);i=Ia;return c[Fa>>2]|0}}else b=cc()|0;while(0);pe(Ja)}while(0);uq(La);_q(Ma);Yd(Ka)}while(0);if((Ra|0)==49)uq(A);uq(Pa);uq(Oa);uq(Na)}wq(Qa)}}else{Ra=Ob(8)|0;c[Ra+4>>2]=0;c[Ra>>2]=30552;o=0;mb(55,Ra|0,856,146);o=0;Ra=27}if((Ra|0)==27)b=cc()|0;uq(Ta);uq(Sa);uq(Ua)}while(0);Ir(Za);Cr(Xa);Cr(Va)}while(0);Jr(_a)}uq(db);uq(cb);uq(bb);uq(ab);wq($a)}Kr(eb)}bc(b|0);return 0}function Bi(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;w=i;i=i+16|0;t=w+8|0;u=w+4|0;v=w;f=c[b>>2]|0;f=~~+ld[c[(c[f>>2]|0)+8>>2]&63](f);e=c[b>>2]|0;e=~~+ld[c[(c[e>>2]|0)+12>>2]&63](e);m=c[d>>2]|0;m=~~+ld[c[(c[m>>2]|0)+8>>2]&63](m);h=c[d>>2]|0;h=~~+ld[c[(c[h>>2]|0)+12>>2]&63](h);l=h-e|0;n=m-f|0;n=(((l|0)>-1?l:0-l|0)|0)>(((n|0)>-1?n:0-n|0)|0);l=n?m:h;m=n?h:m;h=n?f:e;g=n?e:f;p=m-g|0;p=(p|0)>-1?p:0-p|0;q=l-h|0;q=(q|0)>-1?q:0-q|0;r=(l|0)>(h|0)?1:-1;s=(m|0)>(g|0)?1:-1;k=c[a+8>>2]|0;a:do if((m|0)==(g|0))e=0;else{a=0-p>>1;j=eq(k,f,e)|0;e=0;f=h;do{h=eq(k,n?f:g,n?g:f)|0;x=j^h;e=(x&1)+e|0;j=x?h:j;a=a+q|0;if((a|0)>0){if((f|0)==(l|0))break a;a=a-p|0;f=f+r|0}g=g+s|0}while((g|0)!=(m|0))}while(0);a=Sz(20)|0;tq(u,b);tq(v,d);o=0;ub(59,a|0,u|0,v|0,e|0);x=o;o=0;if(x&1){x=cc()|0;uq(v);uq(u);Uz(a);bc(x|0)}else{c[t>>2]=0;Br(t,a);uq(v);uq(u);i=w;return c[t>>2]|0}return 0}function Ci(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0;n=i;i=i+16|0;l=n+12|0;m=n+8|0;g=n+4|0;h=n;j=(c[b+4>>2]|0)-(c[b>>2]|0)>>2;c[l>>2]=0;Br(l,0);c[m>>2]=0;Br(m,0);k=1;a=0;while(1){if((k|0)>=(j|0))if(a){k=1;a=0;continue}else break;d=k+-1|0;Br(l,c[(c[b>>2]|0)+(d<<2)>>2]|0);c[g>>2]=0;e=c[l>>2]|0;Br(g,e);Br(m,c[(c[b>>2]|0)+(k<<2)>>2]|0);c[h>>2]=0;f=c[m>>2]|0;Br(h,f);o=(c[(c[g>>2]|0)+16>>2]|0)>(c[(c[h>>2]|0)+16>>2]|0);Cr(h);Cr(g);if(o){Br((c[b>>2]|0)+(d<<2)|0,f);Br((c[b>>2]|0)+(k<<2)|0,e);a=1}k=k+1|0}Cr(m);Cr(l);i=n;return}function Di(a,b,d,e,f,g,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0.0,p=0,q=0.0,r=0,s=0.0,t=0.0,u=0.0,v=0.0,w=0.0,x=0,y=0,z=0,A=0,B=0.0,C=0.0,D=0.0,E=0.0,F=0.0,G=0.0,H=0,I=0.0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0;Y=i;i=i+112|0;j=Y+100|0;l=Y+96|0;m=Y+92|0;p=Y+88|0;r=Y+84|0;_=Y+80|0;x=Y+76|0;y=Y+72|0;z=Y+68|0;A=Y+64|0;Z=Y+60|0;J=Y+56|0;K=Y+52|0;L=Y+48|0;M=Y+44|0;Q=Y+40|0;R=Y+36|0;N=Y+32|0;O=Y+28|0;P=Y+24|0;S=Y+20|0;W=Y+16|0;X=Y+12|0;T=Y+8|0;U=Y+4|0;V=Y;tq(l,b);tq(m,d);o=0;k=ya(97,0,l|0,m|0)|0;$=o;o=0;do if($&1){j=cc()|0;uq(m);uq(l)}else{v=+(k|0)/+(g|0);uq(m);uq(l);tq(p,e);tq(r,f);o=0;k=ya(97,0,p|0,r|0)|0;$=o;o=0;if($&1){j=cc()|0;uq(r);uq(p);break}uq(r);uq(p);$=c[f>>2]|0;t=+ld[c[(c[$>>2]|0)+8>>2]&63]($);$=c[e>>2]|0;u=+ld[c[(c[$>>2]|0)+8>>2]&63]($);n=+(k|0);k=c[f>>2]|0;q=+ld[c[(c[k>>2]|0)+12>>2]&63](k);k=c[e>>2]|0;q=(q-+ld[c[(c[k>>2]|0)+12>>2]&63](k))/n;k=Sz(16)|0;$=c[f>>2]|0;o=0;s=+Ka(c[(c[$>>2]|0)+8>>2]|0,$|0);$=o;o=0;if((!($&1)?($=c[f>>2]|0,o=0,w=+Ka(c[(c[$>>2]|0)+12>>2]|0,$|0),$=o,o=0,!($&1)):0)?(o=0,wa(42,k|0,+(s+v*((t-u)/n)),+(v*q+w)),$=o,o=0,!($&1)):0){c[_>>2]=0;vq(_,k);tq(x,b);tq(y,e);o=0;k=ya(97,0,x|0,y|0)|0;$=o;o=0;do if($&1){j=cc()|0;uq(y);uq(x)}else{q=+(k|0)/+(h|0);uq(y);uq(x);tq(z,d);tq(A,f);o=0;k=ya(97,0,z|0,A|0)|0;$=o;o=0;if($&1){j=cc()|0;uq(A);uq(z);break}uq(A);uq(z);$=c[f>>2]|0;o=0;n=+Ka(c[(c[$>>2]|0)+8>>2]|0,$|0);$=o;o=0;if((((!($&1)?($=c[d>>2]|0,o=0,E=+Ka(c[(c[$>>2]|0)+8>>2]|0,$|0),$=o,o=0,!($&1)):0)?(B=+(k|0),F=(n-E)/B,$=c[f>>2]|0,o=0,C=+Ka(c[(c[$>>2]|0)+12>>2]|0,$|0),$=o,o=0,!($&1)):0)?($=c[d>>2]|0,o=0,D=+Ka(c[(c[$>>2]|0)+12>>2]|0,$|0),$=o,o=0,!($&1)):0)?(G=(C-D)/B,o=0,H=qa(111,16)|0,$=o,o=0,!($&1)):0){$=c[f>>2]|0;o=0;n=+Ka(c[(c[$>>2]|0)+8>>2]|0,$|0);$=o;o=0;if((!($&1)?($=c[f>>2]|0,o=0,I=+Ka(c[(c[$>>2]|0)+12>>2]|0,$|0),$=o,o=0,!($&1)):0)?(o=0,wa(42,H|0,+(q*F+n),+(q*G+I)),$=o,o=0,!($&1)):0){c[Z>>2]=0;vq(Z,H);c[J>>2]=0;m=c[_>>2]|0;vq(J,m);o=0;k=Wa(83,a|0,J|0)|0;$=o;o=0;a:do if($&1){j=cc()|0;uq(J)}else{uq(J);b:do if(!k){c[K>>2]=0;l=c[Z>>2]|0;vq(K,l);o=0;k=Wa(83,a|0,K|0)|0;$=o;o=0;if($&1){j=cc()|0;uq(K);break a}uq(K);c[j>>2]=0;if(k){vq(j,l);break}else{vq(j,0);break}}else{c[L>>2]=0;p=c[Z>>2]|0;vq(L,p);o=0;k=Wa(83,a|0,L|0)|0;$=o;o=0;if($&1){j=cc()|0;uq(L);break a}uq(L);if(!k){c[j>>2]=0;vq(j,m);break}tq(Q,e);c[R>>2]=0;vq(R,m);o=0;k=ya(96,a|0,Q|0,R|0)|0;$=o;o=0;do if($&1)j=cc()|0;else{c[M>>2]=k;l=g-(c[k+16>>2]|0)|0;tq(O,d);c[P>>2]=0;vq(P,m);o=0;k=ya(96,a|0,O|0,P|0)|0;$=o;o=0;if($&1){j=cc()|0;uq(P);uq(O);Cr(M);break}c[N>>2]=k;m=h-(c[k+16>>2]|0)|0;m=((m|0)>-1?m:0-m|0)+((l|0)>-1?l:0-l|0)|0;Cr(N);uq(P);uq(O);Cr(M);uq(R);uq(Q);tq(W,e);c[X>>2]=0;vq(X,p);o=0;k=ya(96,a|0,W|0,X|0)|0;$=o;o=0;do if(!($&1)){c[S>>2]=k;l=g-(c[k+16>>2]|0)|0;tq(U,d);c[V>>2]=0;vq(V,p);o=0;k=ya(96,a|0,U|0,V|0)|0;$=o;o=0;if($&1){j=cc()|0;uq(V);uq(U);Cr(S);break}else{c[T>>2]=k;$=h-(c[k+16>>2]|0)|0;Cr(T);uq(V);uq(U);Cr(S);uq(X);uq(W);tq(j,(m|0)<=((($|0)>-1?$:0-$|0)+((l|0)>-1?l:0-l|0)|0)?_:Z);break b}}else j=cc()|0;while(0);uq(X);uq(W);break a}while(0);uq(R);uq(Q);break a}while(0);uq(Z);uq(_);i=Y;return c[j>>2]|0}while(0);uq(Z);break}j=cc()|0;Uz(H);break}j=cc()|0}while(0);uq(_);break}j=cc()|0;Uz(k)}while(0);bc(j|0);return 0}function Ei(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;var f=0,g=0,h=0;h=i;i=i+16|0;f=h+4|0;g=h;a=Qg()|0;Zp(f,b);Lr(g,e);o=0;a=Ya(68,a|0,f|0,c|0,d|0,g|0)|0;e=o;o=0;if(e&1){h=cc()|0;_q(g);Yd(f);bc(h|0)}else{_q(g);Yd(f);i=h;return a|0}return 0}function Fi(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0.0,m=0,n=0.0,p=0.0,q=0,r=0.0,s=0,t=0.0,u=0.0,v=0.0,w=0.0,x=0,y=0,z=0,A=0,B=0.0,C=0.0,D=0.0,E=0.0,F=0.0,G=0.0,H=0,I=0.0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0;Y=i;i=i+112|0;h=Y+100|0;k=Y+96|0;m=Y+92|0;q=Y+88|0;s=Y+84|0;_=Y+80|0;x=Y+76|0;y=Y+72|0;z=Y+68|0;A=Y+64|0;Z=Y+60|0;J=Y+56|0;K=Y+52|0;L=Y+48|0;M=Y+44|0;Q=Y+40|0;R=Y+36|0;N=Y+32|0;O=Y+28|0;P=Y+24|0;S=Y+20|0;W=Y+16|0;X=Y+12|0;T=Y+8|0;U=Y+4|0;V=Y;tq(k,b);tq(m,d);o=0;j=ya(97,0,k|0,m|0)|0;$=o;o=0;do if($&1){h=cc()|0;uq(m);uq(k)}else{v=+(g|0);u=+(j|0)/v;uq(m);uq(k);tq(q,e);tq(s,f);o=0;g=ya(97,0,q|0,s|0)|0;$=o;o=0;if($&1){h=cc()|0;uq(s);uq(q);break}uq(s);uq(q);$=c[f>>2]|0;r=+ld[c[(c[$>>2]|0)+8>>2]&63]($);$=c[e>>2]|0;t=+ld[c[(c[$>>2]|0)+8>>2]&63]($);l=+(g|0);g=c[f>>2]|0;n=+ld[c[(c[g>>2]|0)+12>>2]&63](g);g=c[e>>2]|0;n=(n-+ld[c[(c[g>>2]|0)+12>>2]&63](g))/l;g=Sz(16)|0;$=c[f>>2]|0;o=0;p=+Ka(c[(c[$>>2]|0)+8>>2]|0,$|0);$=o;o=0;if((!($&1)?($=c[f>>2]|0,o=0,w=+Ka(c[(c[$>>2]|0)+12>>2]|0,$|0),$=o,o=0,!($&1)):0)?(o=0,wa(42,g|0,+(p+u*((r-t)/l)),+(u*n+w)),$=o,o=0,!($&1)):0){c[_>>2]=0;vq(_,g);tq(x,b);tq(y,e);o=0;g=ya(97,0,x|0,y|0)|0;$=o;o=0;do if($&1){h=cc()|0;uq(y);uq(x)}else{n=+(g|0)/v;uq(y);uq(x);tq(z,d);tq(A,f);o=0;g=ya(97,0,z|0,A|0)|0;$=o;o=0;if($&1){h=cc()|0;uq(A);uq(z);break}uq(A);uq(z);$=c[f>>2]|0;o=0;l=+Ka(c[(c[$>>2]|0)+8>>2]|0,$|0);$=o;o=0;if((((!($&1)?($=c[d>>2]|0,o=0,E=+Ka(c[(c[$>>2]|0)+8>>2]|0,$|0),$=o,o=0,!($&1)):0)?(B=+(g|0),F=(l-E)/B,$=c[f>>2]|0,o=0,C=+Ka(c[(c[$>>2]|0)+12>>2]|0,$|0),$=o,o=0,!($&1)):0)?($=c[d>>2]|0,o=0,D=+Ka(c[(c[$>>2]|0)+12>>2]|0,$|0),$=o,o=0,!($&1)):0)?(G=(C-D)/B,o=0,H=qa(111,16)|0,$=o,o=0,!($&1)):0){$=c[f>>2]|0;o=0;l=+Ka(c[(c[$>>2]|0)+8>>2]|0,$|0);$=o;o=0;if((!($&1)?($=c[f>>2]|0,o=0,I=+Ka(c[(c[$>>2]|0)+12>>2]|0,$|0),$=o,o=0,!($&1)):0)?(o=0,wa(42,H|0,+(n*F+l),+(n*G+I)),$=o,o=0,!($&1)):0){c[Z>>2]=0;vq(Z,H);c[J>>2]=0;k=c[_>>2]|0;vq(J,k);o=0;g=Wa(83,a|0,J|0)|0;$=o;o=0;a:do if($&1){h=cc()|0;uq(J)}else{uq(J);b:do if(!g){c[K>>2]=0;j=c[Z>>2]|0;vq(K,j);o=0;g=Wa(83,a|0,K|0)|0;$=o;o=0;if($&1){h=cc()|0;uq(K);break a}uq(K);c[h>>2]=0;if(g){vq(h,j);break}else{vq(h,0);break}}else{c[L>>2]=0;m=c[Z>>2]|0;vq(L,m);o=0;g=Wa(83,a|0,L|0)|0;$=o;o=0;if($&1){h=cc()|0;uq(L);break a}uq(L);if(!g){c[h>>2]=0;vq(h,k);break}tq(Q,e);c[R>>2]=0;vq(R,k);o=0;g=ya(96,a|0,Q|0,R|0)|0;$=o;o=0;do if($&1)h=cc()|0;else{c[M>>2]=g;j=c[g+16>>2]|0;tq(O,d);c[P>>2]=0;vq(P,k);o=0;g=ya(96,a|0,O|0,P|0)|0;$=o;o=0;if($&1){h=cc()|0;uq(P);uq(O);Cr(M);break}c[N>>2]=g;k=j-(c[g+16>>2]|0)|0;k=(k|0)>-1?k:0-k|0;Cr(N);uq(P);uq(O);Cr(M);uq(R);uq(Q);tq(W,e);c[X>>2]=0;vq(X,m);o=0;g=ya(96,a|0,W|0,X|0)|0;$=o;o=0;do if(!($&1)){c[S>>2]=g;j=c[g+16>>2]|0;tq(U,d);c[V>>2]=0;vq(V,m);o=0;g=ya(96,a|0,U|0,V|0)|0;$=o;o=0;if($&1){h=cc()|0;uq(V);uq(U);Cr(S);break}else{c[T>>2]=g;$=j-(c[g+16>>2]|0)|0;Cr(T);uq(V);uq(U);Cr(S);uq(X);uq(W);tq(h,(k|0)<=((($|0)>-1?$:0-$|0)|0)?_:Z);break b}}else h=cc()|0;while(0);uq(X);uq(W);break a}while(0);uq(R);uq(Q);break a}while(0);uq(Z);uq(_);i=Y;return c[h>>2]|0}while(0);uq(Z);break}h=cc()|0;Uz(H);break}h=cc()|0}while(0);uq(_);break}h=cc()|0;Uz(g)}while(0);bc(h|0);return 0}function Gi(a,b,c){a=a|0;b=b|0;c=c|0;var d=0.0,e=0,f=0;f=i;i=i+16|0;a=f+4|0;e=f;tq(a,b);tq(e,c);o=0;d=+eb(42,a|0,e|0);c=o;o=0;if(c&1){f=cc()|0;uq(e);uq(a);bc(f|0)}else{uq(e);uq(a);i=f;return ~~(d+.5)|0}return 0}function Hi(a,b){a=a|0;b=b|0;var d=0,e=0,f=0.0;e=c[b>>2]|0;if((+ld[c[(c[e>>2]|0)+8>>2]&63](e)>=0.0?(d=c[b>>2]|0,f=+ld[c[(c[d>>2]|0)+8>>2]&63](d),d=a+8|0,f<+(ig(c[d>>2]|0)|0)):0)?(e=c[b>>2]|0,+ld[c[(c[e>>2]|0)+12>>2]&63](e)>0.0):0){e=c[b>>2]|0;f=+ld[c[(c[e>>2]|0)+12>>2]&63](e);d=f<+(jg(c[d>>2]|0)|0)}else d=0;return d|0}function Ii(a,b,d,e,f,g,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0.0,j=0.0,k=0.0,l=0.0,m=0.0,n=0.0,o=0.0,p=0.0,q=0.0;q=+(g|0)+-.5;p=+(h|0)+-.5;a=c[b>>2]|0;o=+ld[c[(c[a>>2]|0)+8>>2]&63](a);b=c[b>>2]|0;n=+ld[c[(c[b>>2]|0)+12>>2]&63](b);b=c[d>>2]|0;m=+ld[c[(c[b>>2]|0)+8>>2]&63](b);d=c[d>>2]|0;l=+ld[c[(c[d>>2]|0)+12>>2]&63](d);d=c[f>>2]|0;k=+ld[c[(c[d>>2]|0)+8>>2]&63](d);d=c[f>>2]|0;j=+ld[c[(c[d>>2]|0)+12>>2]&63](d);d=c[e>>2]|0;i=+ld[c[(c[d>>2]|0)+8>>2]&63](d);d=c[e>>2]|0;return bh(.5,.5,q,.5,q,p,.5,p,o,n,m,l,k,j,i,+ld[c[(c[d>>2]|0)+12>>2]&63](d))|0}function Ji(a){a=a|0;return c[a>>2]|0}function Ki(a){a=a|0;return c[a+4>>2]|0}function Li(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;i=i+16|0;f=e;c[f>>2]=d;c[a>>2]=b;Mr(a+4|0,1,f);i=e;return}function Mi(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;h=i;i=i+16|0;f=h+4|0;g=h;c[f>>2]=d;c[g>>2]=e;c[a>>2]=b;d=a+4|0;Mr(d,1,f);b=a+8|0;f=c[b>>2]|0;if((f|0)==(c[a+12>>2]|0)){o=0;ma(125,d|0,g|0);a=o;o=0;if(a&1){h=cc()|0;qr(d);bc(h|0)}}else{c[f>>2]=e;c[b>>2]=(c[b>>2]|0)+4}i=h;return}function Ni(a){a=a|0;return c[a>>2]|0}function Oi(a){a=a|0;return a+4|0}function Pi(a){a=a|0;var b=0,d=0,e=0;e=a+4|0;d=a+8|0;a=c[e>>2]|0;if((c[d>>2]|0)!=(a|0)){b=0;do{a=c[a+(b<<2)>>2]|0;if(a)Uz(a);b=b+1|0;a=c[e>>2]|0}while(b>>>0<(c[d>>2]|0)-a>>2>>>0)}qr(e);return}function Qi(){var a=0,b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0;K=i;i=i+128|0;d=K+116|0;f=K+112|0;g=K+108|0;h=K+104|0;j=K+100|0;k=K+96|0;l=K+92|0;m=K+88|0;n=K+84|0;p=K+80|0;q=K+76|0;r=K+72|0;s=K+68|0;t=K+64|0;u=K+60|0;v=K+56|0;w=K+52|0;x=K+48|0;y=K+44|0;z=K+40|0;A=K+36|0;B=K+32|0;C=K+28|0;D=K+24|0;E=K+20|0;F=K+16|0;G=K+12|0;H=K+8|0;I=K+4|0;J=K;e=Sz(36)|0;o=0;a=qa(111,16)|0;b=o;o=0;a:do if(b&1){a=cc()|0;L=185}else{o=0;b=qa(111,8)|0;M=o;o=0;if(!(M&1)?(c[b>>2]=1,c[b+4>>2]=3,o=0,mb(71,a|0,5,b|0),M=o,o=0,!(M&1)):0){Ri(e,1,10,10,8,8,a);c[d>>2]=0;jr(d,e);a=c[1114]|0;if(a>>>0>=(c[1115]|0)>>>0){o=0;ma(126,4452,d|0);M=o;o=0;if(M&1){a=cc()|0;kr(d);break}}else{c[a>>2]=0;jr(a,c[d>>2]|0);c[1114]=(c[1114]|0)+4}kr(d);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;if(!(M&1)?(c[b>>2]=1,c[b+4>>2]=5,o=0,mb(71,a|0,7,b|0),M=o,o=0,!(M&1)):0){Ri(d,2,12,12,10,10,a);c[f>>2]=0;jr(f,d);a=c[1114]|0;if(a>>>0>=(c[1115]|0)>>>0){o=0;ma(126,4452,f|0);M=o;o=0;if(M&1){a=cc()|0;kr(f);break}}else{c[a>>2]=0;jr(a,c[f>>2]|0);c[1114]=(c[1114]|0)+4}kr(f);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;if(!(M&1)?(c[b>>2]=1,c[b+4>>2]=8,o=0,mb(71,a|0,10,b|0),M=o,o=0,!(M&1)):0){Ri(d,3,14,14,12,12,a);c[g>>2]=0;jr(g,d);a=c[1114]|0;if(a>>>0>=(c[1115]|0)>>>0){o=0;ma(126,4452,g|0);M=o;o=0;if(M&1){a=cc()|0;kr(g);break}}else{c[a>>2]=0;jr(a,c[g>>2]|0);c[1114]=(c[1114]|0)+4}kr(g);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=12;o=0;mb(71,a|0,12,b|0);M=o;o=0;if(M&1)break;Ri(d,4,16,16,14,14,a);c[h>>2]=0;jr(h,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[h>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,h|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(h);break a}while(0);kr(h);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=18;o=0;mb(71,a|0,14,b|0);M=o;o=0;if(M&1)break;Ri(d,5,18,18,16,16,a);c[j>>2]=0;jr(j,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[j>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,j|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(j);break a}while(0);kr(j);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=22;o=0;mb(71,a|0,18,b|0);M=o;o=0;if(M&1)break;Ri(d,6,20,20,18,18,a);c[k>>2]=0;jr(k,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[k>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,k|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(k);break a}while(0);kr(k);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=30;o=0;mb(71,a|0,20,b|0);M=o;o=0;if(M&1)break;Ri(d,7,22,22,20,20,a);c[l>>2]=0;jr(l,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[l>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,l|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(l);break a}while(0);kr(l);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=36;o=0;mb(71,a|0,24,b|0);M=o;o=0;if(M&1)break;Ri(d,8,24,24,22,22,a);c[m>>2]=0;jr(m,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[m>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,m|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(m);break a}while(0);kr(m);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=44;o=0;mb(71,a|0,28,b|0);M=o;o=0;if(M&1)break;Ri(d,9,26,26,24,24,a);c[n>>2]=0;jr(n,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[n>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,n|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(n);break a}while(0);kr(n);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=62;o=0;mb(71,a|0,36,b|0);M=o;o=0;if(M&1)break;Ri(d,10,32,32,14,14,a);c[p>>2]=0;jr(p,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[p>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,p|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(p);break a}while(0);kr(p);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=86;o=0;mb(71,a|0,42,b|0);M=o;o=0;if(M&1)break;Ri(d,11,36,36,16,16,a);c[q>>2]=0;jr(q,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[q>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,q|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(q);break a}while(0);kr(q);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=114;o=0;mb(71,a|0,48,b|0);M=o;o=0;if(M&1)break;Ri(d,12,40,40,18,18,a);c[r>>2]=0;jr(r,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[r>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,r|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(r);break a}while(0);kr(r);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=144;o=0;mb(71,a|0,56,b|0);M=o;o=0;if(M&1)break;Ri(d,13,44,44,20,20,a);c[s>>2]=0;jr(s,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[s>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,s|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(s);break a}while(0);kr(s);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=174;o=0;mb(71,a|0,68,b|0);M=o;o=0;if(M&1)break;Ri(d,14,48,48,22,22,a);c[t>>2]=0;jr(t,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[t>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,t|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(t);break a}while(0);kr(t);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=2;c[b+4>>2]=102;o=0;mb(71,a|0,42,b|0);M=o;o=0;if(M&1)break;Ri(d,15,52,52,24,24,a);c[u>>2]=0;jr(u,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[u>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,u|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(u);break a}while(0);kr(u);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=2;c[b+4>>2]=140;o=0;mb(71,a|0,56,b|0);M=o;o=0;if(M&1)break;Ri(d,16,64,64,14,14,a);c[v>>2]=0;jr(v,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[v>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,v|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(v);break a}while(0);kr(v);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=4;c[b+4>>2]=92;o=0;mb(71,a|0,36,b|0);M=o;o=0;if(M&1)break;Ri(d,17,72,72,16,16,a);c[w>>2]=0;jr(w,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[w>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,w|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(w);break a}while(0);kr(w);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=4;c[b+4>>2]=114;o=0;mb(71,a|0,48,b|0);M=o;o=0;if(M&1)break;Ri(d,18,80,80,18,18,a);c[x>>2]=0;jr(x,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[x>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,x|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(x);break a}while(0);kr(x);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=4;c[b+4>>2]=144;o=0;mb(71,a|0,56,b|0);M=o;o=0;if(M&1)break;Ri(d,19,88,88,20,20,a);c[y>>2]=0;jr(y,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[y>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,y|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(y);break a}while(0);kr(y);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=4;c[b+4>>2]=174;o=0;mb(71,a|0,68,b|0);M=o;o=0;if(M&1)break;Ri(d,20,96,96,22,22,a);c[z>>2]=0;jr(z,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[z>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,z|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(z);break a}while(0);kr(z);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=6;c[b+4>>2]=136;o=0;mb(71,a|0,56,b|0);M=o;o=0;if(M&1)break;Ri(d,21,104,104,24,24,a);c[A>>2]=0;jr(A,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[A>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,A|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(A);break a}while(0);kr(A);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=6;c[b+4>>2]=175;o=0;mb(71,a|0,68,b|0);M=o;o=0;if(M&1)break;Ri(d,22,120,120,18,18,a);c[B>>2]=0;jr(B,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[B>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,B|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(B);break a}while(0);kr(B);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=8;c[b+4>>2]=163;o=0;mb(71,a|0,62,b|0);M=o;o=0;if(M&1)break;Ri(d,23,132,132,20,20,a);c[C>>2]=0;jr(C,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[C>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,C|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(C);break a}while(0);kr(C);e=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=8;c[b+4>>2]=156;o=0;d=qa(111,8)|0;M=o;o=0;if(M&1)break;c[d>>2]=2;c[d+4>>2]=155;o=0;ub(60,a|0,62,b|0,d|0);M=o;o=0;if(M&1)break;Ri(e,24,144,144,22,22,a);c[D>>2]=0;jr(D,e);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[D>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,D|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(D);break a}while(0);kr(D);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=5;o=0;mb(71,a|0,7,b|0);M=o;o=0;if(M&1)break;Ri(d,25,8,18,6,16,a);c[E>>2]=0;jr(E,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[E>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,E|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(E);break a}while(0);kr(E);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=10;o=0;mb(71,a|0,11,b|0);M=o;o=0;if(M&1)break;Ri(d,26,8,32,6,14,a);c[F>>2]=0;jr(F,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[F>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,F|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(F);break a}while(0);kr(F);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=16;o=0;mb(71,a|0,14,b|0);M=o;o=0;if(M&1)break;Ri(d,27,12,26,10,24,a);c[G>>2]=0;jr(G,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[G>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,G|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(G);break a}while(0);kr(G);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=22;o=0;mb(71,a|0,18,b|0);M=o;o=0;if(M&1)break;Ri(d,28,12,36,10,16,a);c[H>>2]=0;jr(H,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[H>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,H|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(H);break a}while(0);kr(H);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=32;o=0;mb(71,a|0,24,b|0);M=o;o=0;if(M&1)break;Ri(d,29,16,36,14,16,a);c[I>>2]=0;jr(I,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[I>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,I|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(I);break a}while(0);kr(I);d=Sz(36)|0;o=0;a=qa(111,16)|0;M=o;o=0;if(M&1)a=cc()|0;else{o=0;b=qa(111,8)|0;M=o;o=0;do if(!(M&1)){c[b>>2]=1;c[b+4>>2]=49;o=0;mb(71,a|0,28,b|0);M=o;o=0;if(M&1)break;Ri(d,30,16,48,14,22,a);c[J>>2]=0;jr(J,d);a=c[1114]|0;do if(a>>>0<(c[1115]|0)>>>0){c[a>>2]=0;jr(a,c[J>>2]|0);c[1114]=(c[1114]|0)+4}else{o=0;ma(126,4452,J|0);M=o;o=0;if(!(M&1))break;a=cc()|0;kr(J);break a}while(0);kr(J);i=K;return (c[1114]|0)-(c[1113]|0)>>2|0}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(e);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break a}while(0);M=cc()|0;Uz(a);a=M}Uz(d);break}M=cc()|0;Uz(a);a=M}Uz(d);break}M=cc()|0;Uz(a);a=M}Uz(d);break}L=cc()|0;Uz(a);a=L;L=185}while(0);if((L|0)==185)Uz(e);bc(a|0);return 0}function Ri(a,b,d,e,f,g,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;c[a+4>>2]=0;c[a>>2]=4472;c[a+8>>2]=b;c[a+12>>2]=d;c[a+16>>2]=e;c[a+20>>2]=f;c[a+24>>2]=g;c[a+28>>2]=h;b=a+32|0;c[b>>2]=0;a=c[h>>2]|0;d=c[h+4>>2]|0;f=(c[h+8>>2]|0)-d>>2;if(!f)g=0;else{e=0;g=0;do{h=c[d+(e<<2)>>2]|0;g=($((c[h+4>>2]|0)+a|0,c[h>>2]|0)|0)+g|0;e=e+1|0}while((e|0)!=(f|0))}c[b>>2]=g;return}function Si(a){a=a|0;c[a>>2]=4472;a=c[a+28>>2]|0;if(a){Pi(a);Uz(a)}return}function Ti(a){a=a|0;Si(a);Uz(a);return}function Ui(a){a=a|0;return c[a+12>>2]|0}function Vi(a){a=a|0;return c[a+16>>2]|0}function Wi(a){a=a|0;return c[a+20>>2]|0}function Xi(a){a=a|0;return c[a+24>>2]|0}function Yi(a){a=a|0;return c[a+32>>2]|0}function Zi(a){a=a|0;return c[a+28>>2]|0}function _i(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;g=i;i=i+16|0;e=g;if((d|b)&1){g=Ob(8)|0;zq(g,48267);c[g>>2]=29736;Hc(g|0,24,146)}a:do if((c[7681]|0)>0){f=0;while(1){lr(e,(c[1113]|0)+(f<<2)|0);a=c[e>>2]|0;if((c[a+12>>2]|0)==(b|0)?(c[a+16>>2]|0)==(d|0):0)break;kr(e);f=f+1|0;if((f|0)>=(c[7681]|0))break a}i=g;return a|0}while(0);g=Ob(8)|0;zq(g,48307);c[g>>2]=29736;Hc(g|0,24,146);return 0}function $i(a,b,d){a=a|0;b=b|0;d=d|0;$d(a,b);c[a>>2]=c[a>>2]|c[d>>2];a=a+4|0;if(!(c[a>>2]|0))xe(a,c[d+4>>2]|0);return}function aj(a){a=a|0;var b=0;b=a+4|0;c[b>>2]=0;xe(b,0);c[a>>2]=0;return}function bj(a,b){a=a|0;b=b|0;var d=0;d=a+4|0;c[d>>2]=0;xe(d,0);c[a>>2]=b;return}function cj(a,b){a=a|0;b=b|0;do switch(c[b>>2]|0){case 1:{b=2;break}case 2:{b=4;break}case 3:{b=8;break}case 4:{b=16;break}case 5:{b=32;break}case 6:{b=64;break}case 7:{b=128;break}case 8:{b=256;break}case 9:{b=512;break}case 10:{b=1024;break}case 11:{b=2048;break}case 12:{b=4096;break}case 13:{b=8192;break}case 14:{b=16384;break}case 15:{b=32768;break}case 16:{b=65536;break}case 17:{b=131072;break}default:{b=Ob(8)|0;o=0;ma(103,b|0,48331);a=o;o=0;if(a&1){a=cc()|0;Nb(b|0);bc(a|0)}else Hc(b|0,240,66)}}while(0);return (c[a>>2]&b|0)!=0|0}function dj(a){a=a|0;return (c[a>>2]|0)<0|0}function ej(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;we(b,a+4|0);i=d;return c[b>>2]|0}function fj(a){a=a|0;Vz(c[a+4>>2]|0);return}function gj(a){a=a|0;var b=0;if((a|0)!=0?(b=(iC(a)|0)+1|0,(b|0)!=0):0){b=Tz((b|0)>-1?b:-1)|0;gC(b,a)|0}else b=0;return b|0}function hj(a){a=a|0;c[a+4>>2]=0;c[a>>2]=4516;return}function ij(a,b){a=a|0;b=b|0;zq(a,b);c[a>>2]=4516;return}function jj(a){a=a|0;Aq(a);return}function kj(a){a=a|0;Aq(a);Uz(a);return}function lj(){if((a[888]|0)==0?(Hb(888)|0)!=0:0){c[7683]=0;c[7682]=4516;Ec(76,30728,n|0)|0;Cc(888)}return 30728}function mj(a,b){a=a|0;b=b|0;var d=0;d=c[b>>2]|0;uj(a,c[d+8>>2]|0,c[d+12>>2]|0);c[a>>2]=4536;Ud(a+16|0,b);return}function nj(b,e,f,g){b=b|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;k=i;i=i+32|0;h=k+12|0;j=k;l=c[e+16>>2]|0;m=c[(c[l>>2]|0)+8>>2]|0;Pd(j,g);o=0;ub(m|0,h|0,l|0,f|0,j|0);f=o;o=0;if(f&1){m=cc()|0;Sd(j);bc(m|0)}Ae(g,c[h+8>>2]|0);Sd(h);Sd(j);h=c[e+8>>2]|0;j=g+8|0;if((h|0)>0){e=0;do{m=(c[(c[j>>2]|0)+8>>2]|0)+e|0;a[m>>0]=(d[m>>0]|0)^255;e=e+1|0}while((e|0)<(h|0))}Pd(b,g);i=k;return}function oj(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,j=0;j=i;i=i+16|0;h=j;g=c[e+16>>2]|0;$c[c[(c[g>>2]|0)+12>>2]&511](h,g);g=$(c[e+12>>2]|0,c[e+8>>2]|0)|0;o=0;ma(87,b|0,g|0);f=o;o=0;if(f&1){j=cc()|0;Sd(h);bc(j|0)}f=h+8|0;if((g|0)>0){e=(c[b+8>>2]|0)+8|0;b=0;do{a[(c[e>>2]|0)+b>>0]=(d[(c[(c[f>>2]|0)+8>>2]|0)+b>>0]|0)^255;b=b+1|0}while((b|0)<(g|0))}Sd(h);i=j;return}function pj(a){a=a|0;a=c[a+16>>2]|0;return bd[c[(c[a>>2]|0)+16>>2]&255](a)|0}function qj(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0;j=i;i=i+16|0;g=j+4|0;h=j;k=Sz(20)|0;a=c[a+16>>2]|0;o=0;f=Ya(c[(c[a>>2]|0)+20>>2]|0,a|0,b|0,d|0,e|0,f|0)|0;e=o;o=0;do if(!(e&1)){c[h>>2]=f;o=0;ma(127,k|0,h|0);e=o;o=0;if(e&1){f=cc()|0;Vd(h);break}else{c[g>>2]=0;Ie(g,k);Vd(h);i=j;return c[g>>2]|0}}else f=cc()|0;while(0);Uz(k);bc(f|0);return 0}function rj(a){a=a|0;a=c[a+16>>2]|0;return bd[c[(c[a>>2]|0)+24>>2]&255](a)|0}function sj(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;Ud(b,a+16|0);i=d;return c[b>>2]|0}function tj(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;e=i;i=i+16|0;b=e+4|0;d=e;f=Sz(20)|0;a=c[a+16>>2]|0;o=0;a=qa(c[(c[a>>2]|0)+32>>2]|0,a|0)|0;g=o;o=0;do if(!(g&1)){c[d>>2]=a;o=0;ma(127,f|0,d|0);g=o;o=0;if(g&1){a=cc()|0;Vd(d);break}else{c[b>>2]=0;Ie(b,f);Vd(d);i=e;return c[b>>2]|0}}else a=cc()|0;while(0);Uz(f);bc(a|0);return 0}function uj(a,b,d){a=a|0;b=b|0;d=d|0;c[a+4>>2]=0;c[a>>2]=4580;c[a+8>>2]=b;c[a+12>>2]=d;return}function vj(a){a=a|0;return}function wj(a){a=a|0;Uz(a);return}function xj(a){a=a|0;return 0}function yj(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;b=Ob(8)|0;o=0;ma(103,b|0,48358);a=o;o=0;if(a&1){a=cc()|0;Nb(b|0);bc(a|0)}else Hc(b|0,240,66);return 0}function zj(a){a=a|0;return 0}function Aj(a){a=a|0;var b=0;a=Ob(8)|0;o=0;ma(103,a|0,48407);b=o;o=0;if(b&1){b=cc()|0;Nb(a|0);bc(b|0)}else Hc(a|0,240,66);return 0}function Bj(a){a=a|0;var b=0,d=0,e=0,f=0;f=i;i=i+16|0;b=f+4|0;d=f;e=Sz(20)|0;c[d>>2]=0;Ie(d,a);o=0;ma(127,e|0,d|0);a=o;o=0;if(a&1){f=cc()|0;Vd(d);Uz(e);bc(f|0)}else{c[b>>2]=0;Ie(b,e);Vd(d);i=f;return c[b>>2]|0}return 0}function Cj(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=4624;c[a+8>>2]=b;return}function Dj(a){a=a|0;return}function Ej(a){a=a|0;Uz(a);return}function Fj(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0;j=i;i=i+16|0;f=j+8|0;g=j;c[a>>2]=0;h=a+4|0;c[h>>2]=0;c[a+8>>2]=0;_d(f,d);$d(g,e);o=0;Oa(43,b|0,f|0,g|0,a|0,0,0,0);b=o;o=0;do if(!(b&1)){ze(g+4|0);ce(f);if((c[a>>2]|0)==(c[h>>2]|0)){f=Ob(8)|0;zq(f,48456);c[f>>2]=29736;o=0;mb(55,f|0,24,146);o=0;f=cc()|0;break}else{i=j;return}}else{j=cc()|0;ze(g+4|0);ce(f);f=j}while(0);me(a);bc(f|0)}function Gj(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0.0,n=0,p=0.0,q=0,r=0.0,s=0.0,t=0.0,u=0.0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0;Q=i;i=i+128|0;R=Q+112|0;k=Q+108|0;n=Q+104|0;q=Q+96|0;B=Q+92|0;A=Q+88|0;z=Q+84|0;C=Q+80|0;E=Q+76|0;P=Q+64|0;F=Q+60|0;G=Q+56|0;H=Q+48|0;J=Q+40|0;I=Q+32|0;K=Q+24|0;L=Q+16|0;N=Q+8|0;O=Q;do if((j|0)<=4){c[R>>2]=0;Qe(R,0);l=c[b+8>>2]|0;y=c[(c[l>>2]|0)+12>>2]|0;_d(n,d);$d(q,e);o=0;l=ya(y|0,l|0,n|0,q|0)|0;y=o;o=0;a:do if(y&1){k=cc(24)|0;P=D;ze(q+4|0);ce(n);if((P|0)==(Xb(24)|0)){fc(k|0)|0;o=0;ob(44);P=o;o=0;if(P&1)w=6;else w=65}}else{c[k>>2]=l;Qe(R,l);be(k);ze(q+4|0);ce(n);y=f+4|0;k=0;x=0;while(1){l=c[f>>2]|0;if(x>>>0>=(c[y>>2]|0)-l>>2>>>0){w=24;break}Pe(B,l+(x<<2)|0);o=0;l=qa(112,c[B>>2]|0)|0;w=o;o=0;if(w&1){w=19;break}c[A>>2]=l;o=0;n=qa(113,l|0)|0;w=o;o=0;if(w&1){w=20;break}o=0;l=qa(112,c[R>>2]|0)|0;w=o;o=0;if(w&1){w=20;break}c[z>>2]=l;o=0;l=qa(113,l|0)|0;w=o;o=0;if(w&1){w=21;break}q=a[n>>0]|0;w=(q&1)==0;q=w?(q&255)>>>1:c[n+4>>2]|0;S=a[l>>0]|0;v=(S&1)==0;b:do if((q|0)==((v?(S&255)>>>1:c[l+4>>2]|0)|0)){n=w?n+1|0:c[n+8>>2]|0;l=v?l+1|0:c[l+8>>2]|0;if(!w){l=(bC(n,l,q)|0)==0;break}if(!q)l=1;else while(1){if((a[n>>0]|0)!=(a[l>>0]|0)){l=0;break b}q=q+-1|0;if(!q){l=1;break}else{n=n+1|0;l=l+1|0}}}else l=0;while(0);ne(z);ne(A);k=k|l;be(B);if(l){w=24;break}else x=x+1|0}if((w|0)==19)k=cc()|0;else if((w|0)==20){k=cc()|0;w=22}else if((w|0)==21){k=cc()|0;ne(z);w=22}else if((w|0)==24){c:do if(k)k=c[R>>2]|0;else{c[E>>2]=0;k=c[R>>2]|0;Qe(E,k);o=0;l=ya(98,E|0,g|0,h|0)|0;S=o;o=0;do if(S&1)k=cc()|0;else{c[C>>2]=l;n=c[y>>2]|0;if(n>>>0>=(c[f+8>>2]|0)>>>0){o=0;ma(128,f|0,C|0);S=o;o=0;if(S&1){k=cc()|0;be(C);break}}else{c[n>>2]=0;Qe(n,l);c[y>>2]=(c[y>>2]|0)+4}be(C);be(E);break c}while(0);be(E);break a}while(0);o=0;k=qa(114,k|0)|0;S=o;o=0;if(S&1){w=6;break}oe(P,k);q=c[P+8>>2]|0;n=q+12|0;q=q+8|0;d:do if((c[n>>2]|0)!=(c[q>>2]|0)){o=0;v=qa(142,c[d>>2]|0)|0;S=o;o=0;e:do if(!(S&1)?(o=0,M=qa(143,c[d>>2]|0)|0,S=o,o=0,!(S&1)):0){p=+(v|0);m=+(M|0);k=c[q>>2]|0;f:do if(((c[n>>2]|0)-k|0)>0){l=0;r=0.0;s=0.0;while(1){tq(F,k+(l<<2)|0);k=c[F>>2]|0;o=0;t=+Ka(c[(c[k>>2]|0)+8>>2]|0,k|0);S=o;o=0;if(S&1)break;o=0;u=+Ka(c[(c[k>>2]|0)+12>>2]|0,k|0);S=o;o=0;if(S&1)break;p=t<p?t:p;m=u<m?u:m;r=t>r?t:r;s=u>s?u:s;uq(F);l=l+1|0;k=c[q>>2]|0;if((l|0)>=((c[n>>2]|0)-k>>2|0))break f}k=cc()|0;uq(F);break e}else{r=0.0;s=0.0}while(0);do if(p>100.0){o=0;k=Ya(69,c[d>>2]|0,0,0,~~p|0,M|0)|0;S=o;o=0;if(S&1){w=36;break e}c[G>>2]=k;$d(H,e);o=0;Oa(43,b|0,G|0,H|0,f|0,g|0,h|0,j+1|0);S=o;o=0;if(S&1){k=cc()|0;ze(H+4|0);ce(G);break e}else{ze(H+4|0);ce(G);break}}while(0);do if(m>100.0){o=0;k=Ya(69,c[d>>2]|0,0,0,v|0,~~m|0)|0;S=o;o=0;if(S&1){w=36;break e}c[J>>2]=k;$d(I,e);o=0;Oa(43,b|0,J|0,I|0,f|0,g|0,h|0,j+1|0);S=o;o=0;if(S&1){k=cc()|0;ze(I+4|0);ce(J);break e}else{ze(I+4|0);ce(J);break}}while(0);do if(r<+(v+-100|0)){k=~~r;o=0;l=Ya(69,c[d>>2]|0,k|0,0,v-k|0,M|0)|0;S=o;o=0;if(S&1){w=36;break e}c[K>>2]=l;$d(L,e);o=0;Oa(43,b|0,K|0,L|0,f|0,k+g|0,h|0,j+1|0);S=o;o=0;if(S&1){k=cc()|0;ze(L+4|0);ce(K);break e}else{ze(L+4|0);ce(K);break}}while(0);if(!(s<+(M+-100|0)))break d;l=~~s;o=0;k=Ya(69,c[d>>2]|0,0,l|0,v|0,M-l|0)|0;S=o;o=0;if(!(S&1)){c[N>>2]=k;$d(O,e);o=0;Oa(43,b|0,N|0,O|0,f|0,g|0,l+h|0,j+1|0);S=o;o=0;if(S&1){k=cc()|0;ze(O+4|0);ce(N);break}else{ze(O+4|0);ce(N);break d}}else w=36}else w=36;while(0);if((w|0)==36)k=cc()|0;pe(P);break a}while(0);pe(P);w=65;break}if((w|0)==22)ne(A);be(B)}while(0);if((w|0)==6)k=cc()|0;else if((w|0)==65){be(R);break}be(R);bc(k|0)}while(0);i=Q;return}function Hj(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0.0,h=0.0,j=0.0,k=0,l=0,m=0.0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;y=i;i=i+80|0;t=y+68|0;e=y+64|0;A=y+52|0;z=y+40|0;s=y+36|0;r=y+32|0;x=y+28|0;u=y+16|0;v=y+4|0;w=y;oe(A,gp(c[a>>2]|0)|0);q=c[A+8>>2]|0;p=q+12|0;q=q+8|0;a:do if((c[p>>2]|0)==(c[q>>2]|0))Pe(e,a);else{o=0;f=qa(111,20)|0;n=o;o=0;if(n&1)e=cc()|0;else{c[f+4>>2]=0;c[f>>2]=29756;c[f+8>>2]=0;c[f+12>>2]=0;c[f+16>>2]=0;Dq(z,f);l=c[z+8>>2]|0;n=l+8|0;m=+(b|0);j=+(d|0);k=l+12|0;l=l+16|0;f=c[q>>2]|0;b:do if(((c[p>>2]|0)-f|0)>0){d=0;while(1){tq(s,f+(d<<2)|0);o=0;b=qa(111,16)|0;f=o;o=0;if(f&1){f=15;break}f=c[s>>2]|0;o=0;h=+Ka(c[(c[f>>2]|0)+8>>2]|0,f|0);B=o;o=0;if(B&1){e=b;f=16;break}o=0;g=+Ka(c[(c[f>>2]|0)+12>>2]|0,f|0);B=o;o=0;if(B&1){e=b;f=16;break}o=0;wa(42,b|0,+(m+h),+(j+g));B=o;o=0;if(B&1){e=b;f=16;break}c[r>>2]=0;vq(r,b);f=c[k>>2]|0;if(f>>>0>=(c[l>>2]|0)>>>0){o=0;ma(101,n|0,r|0);B=o;o=0;if(B&1){f=17;break}}else{c[f>>2]=0;vq(f,c[r>>2]|0);c[k>>2]=(c[k>>2]|0)+4}uq(r);uq(s);d=d+1|0;f=c[q>>2]|0;if((d|0)>=((c[p>>2]|0)-f>>2|0)){f=19;break b}}if((f|0)==15)e=cc()|0;else if((f|0)==16){B=cc()|0;Uz(e);e=B}else if((f|0)==17){e=cc()|0;uq(r)}uq(s)}else f=19;while(0);do if((f|0)==19){o=0;b=qa(111,40)|0;B=o;o=0;if(B&1){e=cc()|0;break}o=0;f=qa(112,c[a>>2]|0)|0;B=o;o=0;if(B&1)e=cc()|0;else{c[x>>2]=f;o=0;ma(129,u|0,c[a>>2]|0);B=o;o=0;if(B&1)e=cc()|0;else{oe(v,z);o=0;f=qa(144,c[a>>2]|0)|0;B=o;o=0;if(!(B&1)?(c[w>>2]=f,o=0,c[t>>2]=c[w>>2],ia(45,b|0,x|0,u|0,v|0,t|0),B=o,o=0,!(B&1)):0){c[e>>2]=0;Qe(e,b);pe(v);Sd(u);ne(x);pe(z);break a}e=cc()|0;pe(v);Sd(u)}ne(x)}Uz(b)}while(0);pe(z)}pe(A);bc(e|0)}while(0);pe(A);i=y;return c[e>>2]|0}function Ij(a){a=a|0;return}function Jj(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;g=i;i=i+16|0;e=g+8|0;f=g;h=c[(c[b>>2]|0)+12>>2]|0;_d(e,d);$d(f,4500);o=0;ub(h|0,a|0,b|0,e|0,f|0);b=o;o=0;if(b&1){h=cc()|0;ze(f+4|0);ce(e);bc(h|0)}else{ze(f+4|0);ce(e);i=g;return}}function Kj(a,b){a=a|0;b=b|0;var d=0,e=0;e=i;i=i+16|0;d=e;Zp(d,b);o=0;ma(130,a|0,d|0);b=o;o=0;if(b&1){e=cc()|0;Yd(d);bc(e|0)}else{Yd(d);c[a>>2]=4648;i=e;return}}function Lj(a){a=a|0;Qr(a);return}function Mj(a){a=a|0;Qr(a);Uz(a);return}function Nj(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;m=i;i=i+64|0;q=m+56|0;p=m+28|0;g=m+24|0;e=m+20|0;n=m+8|0;k=m+4|0;l=m;f=On(b)|0;c[q>>2]=f;c[g>>2]=0;Ke(g,f);o=0;f=qa(145,d|0)|0;j=o;o=0;do if(j&1){e=cc()|0;r=12}else{c[e>>2]=f;o=0;mb(72,p|0,g|0,e|0);j=o;o=0;if(j&1){r=cc()|0;ze(e);e=r;r=12;break}ze(e);Yd(g);o=0;mb(44,n|0,p|0,d|0);j=o;o=0;a:do if(j&1)e=cc()|0;else{c[a>>2]=0;g=a+4|0;c[g>>2]=0;c[a+8>>2]=0;h=n+4|0;j=a+8|0;e=c[n>>2]|0;b:do if((c[h>>2]|0)!=(e|0)){d=0;while(1){Rr(l,e+(d<<2)|0);o=0;e=Wa(84,b|0,l|0)|0;f=o;o=0;do if(f&1){e=cc(24)|0;f=D;r=16}else{c[k>>2]=e;f=c[g>>2]|0;if(f>>>0>=(c[j>>2]|0)>>>0){o=0;ma(131,a|0,k|0);f=o;o=0;if(f&1){e=cc(24)|0;f=D;ir(k);r=16;break}}else{c[f>>2]=0;Hr(f,e);c[g>>2]=(c[g>>2]|0)+4}ir(k);Tr(l)}while(0);if((r|0)==16){r=0;Tr(l);if((f|0)!=(Xb(24)|0))break;fc(e|0)|0;o=0;ob(44);f=o;o=0;if(f&1){r=19;break}}d=d+1|0;e=c[n>>2]|0;if(d>>>0>=(c[h>>2]|0)-e>>2>>>0)break b}if((r|0)==19)e=cc()|0;Vr(a);Ur(n);break a}while(0);Ur(n);Pj(p);Yd(q);i=m;return}while(0);Pj(p)}while(0);if((r|0)==12)Yd(g);Yd(q);bc(e|0)}function Oj(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;f=i;i=i+16|0;e=f;Zp(e,b);o=0;mb(73,a+4|0,e|0,d|0);d=o;o=0;if(d&1){f=cc()|0;Yd(e);bc(f|0)}else{Yd(e);c[a>>2]=4672;i=f;return}}function Pj(a){a=a|0;Wr(a+4|0);return}function Qj(a){a=a|0;Wr(a+4|0);Uz(a);return}function Rj(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;x=i;i=i+96|0;B=x+84|0;t=x+64|0;A=x+52|0;z=x+40|0;u=x+28|0;v=x+16|0;w=x+12|0;y=x;d=dj(d)|0;p=b+4|0;Zp(B,p);q=c[B>>2]|0;o=0;r=qa(122,q|0)|0;n=o;o=0;a:do if(!(n&1)?(o=0,s=qa(121,q|0)|0,n=o,o=0,!(n&1)):0){n=~~(+(r|0)/(+(c[7026]|0)*4.0)*3.0);g=c[7025]|0;n=d|(n|0)<(g|0)?g:n;g=t+4|0;h=t+8|0;j=t+12|0;k=t+16|0;b:do if((n|0)<=(r|0)){l=(s|0)>0;m=n+-1|0;c:while(1){c[t>>2]=0;c[t+4>>2]=0;c[t+8>>2]=0;c[t+12>>2]=0;c[t+16>>2]=0;if(l){d=0;f=0;do{e=d&1;do if(eq(q,f,m)|0){d=e+d|0;e=t+(d<<2)|0;c[e>>2]=(c[e>>2]|0)+1}else{if(e){e=t+(d<<2)|0;c[e>>2]=(c[e>>2]|0)+1;break}if((d|0)!=4){d=d+1|0;e=t+(d<<2)|0;c[e>>2]=(c[e>>2]|0)+1;break}o=0;d=qa(146,t|0)|0;e=o;o=0;if(e&1){f=5;break c}if(d){o=0;d=kb(56,p|0,t|0,m|0,f|0)|0;e=o;o=0;if(e&1){f=5;break c}if(d){c[t>>2]=0;c[t+4>>2]=0;c[t+8>>2]=0;c[t+12>>2]=0;c[t+16>>2]=0;d=0;break}}c[t>>2]=c[h>>2];c[g>>2]=c[j>>2];c[h>>2]=c[k>>2];c[j>>2]=1;c[k>>2]=0;d=3}while(0);f=f+1|0}while((f|0)<(s|0))}o=0;d=qa(146,t|0)|0;f=o;o=0;if(f&1){f=6;break}if(d?(o=0,kb(56,p|0,t|0,m|0,s|0)|0,f=o,o=0,f&1):0){f=6;break}m=m+n|0;if((m|0)>=(r|0))break b}if((f|0)==5){d=cc()|0;f=8;break a}else if((f|0)==6){d=cc()|0;f=8;break a}}while(0);o=0;ma(132,A|0,b|0);b=o;o=0;if(!(b&1)){c[a>>2]=0;g=a+4|0;c[g>>2]=0;c[a+8>>2]=0;h=A+4|0;j=u+4|0;k=z+4|0;l=u+8|0;m=z+8|0;n=a+8|0;d=c[A>>2]|0;d:do if((c[h>>2]|0)!=(d|0)){f=0;while(1){o=0;ma(133,z|0,d+(f*12|0)|0);b=o;o=0;if(b&1){f=39;break}o=0;ma(133,v|0,z|0);b=o;o=0;if(b&1){f=40;break}o=0;ma(134,u|0,v|0);b=o;o=0;if(b&1){f=41;break}Yr(z);c[z>>2]=c[u>>2];c[k>>2]=c[j>>2];c[m>>2]=c[l>>2];c[l>>2]=0;c[j>>2]=0;c[u>>2]=0;Zr(u);Zr(v);o=0;e=qa(111,20)|0;b=o;o=0;if(b&1){f=40;break}o=0;ma(133,y|0,z|0);b=o;o=0;if(b&1){f=42;break}o=0;ma(135,e|0,y|0);b=o;o=0;if(b&1){f=43;break}c[w>>2]=0;_r(w,e);d=c[g>>2]|0;if(d>>>0>=(c[n>>2]|0)>>>0){o=0;ma(136,a|0,w|0);b=o;o=0;if(b&1){f=44;break}}else{c[d>>2]=0;_r(d,c[w>>2]|0);c[g>>2]=(c[g>>2]|0)+4}Tr(w);Zr(y);Zr(z);f=f+1|0;d=c[A>>2]|0;if(f>>>0>=(((c[h>>2]|0)-d|0)/12|0)>>>0)break d}if((f|0)==39)d=cc()|0;else if((f|0)==40){d=cc()|0;f=46}else if((f|0)==41){d=cc()|0;Zr(v);f=46}else if((f|0)==42){d=cc()|0;f=45}else if((f|0)==43){d=cc()|0;Zr(y);f=45}else if((f|0)==44){d=cc()|0;Tr(w);Zr(y);f=46}if((f|0)==45){Uz(e);f=46}if((f|0)==46)Zr(z);Ur(a);as(A);break a}while(0);as(A);Yd(B);i=x;return}else f=7}else f=7;while(0);if((f|0)==7){d=cc()|0;f=8}Yd(B);bc(d|0)}function Sj(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0.0,j=0.0,k=0.0,l=0.0,m=0.0,n=0.0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0;J=i;i=i+128|0;f=J+124|0;Y=J+112|0;W=J+108|0;X=J+104|0;V=J+100|0;U=J+88|0;B=J+76|0;G=J+64|0;T=J+60|0;M=J+48|0;N=J+44|0;Q=J+40|0;H=J+36|0;I=J+32|0;R=J+28|0;S=J+24|0;C=J+20|0;D=J+16|0;K=J+12|0;L=J+8|0;E=J+4|0;F=J;b=b+8|0;Xr(Y,b);d=c[Y+4>>2]|0;e=c[Y>>2]|0;g=d-e|0;z=g>>2;if((g|0)<12){b=Ob(8)|0;zq(b,48456);c[b>>2]=29736;o=0;mb(55,b|0,24,146);o=0;b=cc()|0}else{c[a>>2]=0;A=a+4|0;c[A>>2]=0;c[a+8>>2]=0;a:do if((z|0)==3){o=0;ma(137,a|0,b|0);X=o;o=0;if(X&1)e=5;else e=82}else{c[f>>2]=85;o=0;mb(74,e|0,d|0,f|0);y=o;o=0;if(!(y&1)){r=z+-2|0;s=z+-1|0;t=U+4|0;u=U+8|0;v=U+8|0;w=B+4|0;x=B+8|0;y=a+8|0;b:do if((g|0)>8){p=0;c:while(1){es(W,(c[Y>>2]|0)+(p<<2)|0);p=p+1|0;d:do if((p|0)<(s|0)){q=p;while(1){es(X,(c[Y>>2]|0)+(q<<2)|0);f=c[W>>2]|0;o=0;h=+Ka(44,f|0);g=o;o=0;if(g&1){e=17;break c}g=c[X>>2]|0;o=0;j=+Ka(44,g|0);e=o;o=0;if(e&1){e=17;break c}o=0;k=+Ka(44,f|0);e=o;o=0;if(e&1){e=17;break c}o=0;l=+Ka(44,g|0);e=o;o=0;if(e&1){e=17;break c}o=0;m=+Ka(44,f|0);e=o;o=0;if(e&1){e=17;break c}o=0;n=+Ka(44,g|0);e=o;o=0;if(e&1){e=17;break c}if(+O(+(m-n))>.5?(h-j)/(l<k?l:k)>=.05000000074505806:0)break;b=q+1|0;e:do if((b|0)<(z|0)){while(1){es(V,(c[Y>>2]|0)+(b<<2)|0);o=0;k=+Ka(44,g|0);e=o;o=0;if(e&1){e=26;break c}e=c[V>>2]|0;o=0;l=+Ka(44,e|0);d=o;o=0;if(d&1){e=26;break c}o=0;m=+Ka(44,g|0);d=o;o=0;if(d&1){e=26;break c}o=0;n=+Ka(44,e|0);d=o;o=0;if(d&1){e=26;break c}o=0;h=+Ka(44,g|0);d=o;o=0;if(d&1){e=26;break c}o=0;j=+Ka(44,e|0);d=o;o=0;if(d&1){e=26;break c}if(+O(+(h-j))>.5?(k-l)/(n<m?n:m)>=.05000000074505806:0)break;c[U>>2]=0;c[t>>2]=0;c[u>>2]=0;o=0;ma(138,U|0,W|0);d=o;o=0;if(d&1){e=51;break c}d=c[t>>2]|0;if((d|0)==(c[v>>2]|0)){o=0;ma(138,U|0,X|0);d=o;o=0;if(d&1){e=51;break c}d=c[t>>2]|0}else{c[d>>2]=0;hs(d,g);d=(c[t>>2]|0)+4|0;c[t>>2]=d}if((d|0)==(c[v>>2]|0)){o=0;ma(138,U|0,V|0);e=o;o=0;if(e&1){e=51;break c}}else{c[d>>2]=0;hs(d,e);c[t>>2]=(c[t>>2]|0)+4}o=0;ma(133,G|0,U|0);e=o;o=0;if(e&1){e=51;break c}o=0;ma(134,B|0,G|0);e=o;o=0;if(e&1){e=52;break c}Yr(U);c[U>>2]=c[B>>2];c[t>>2]=c[w>>2];c[v>>2]=c[x>>2];c[x>>2]=0;c[w>>2]=0;c[B>>2]=0;Zr(B);Zr(G);o=0;d=qa(111,20)|0;e=o;o=0;if(e&1){e=51;break c}o=0;ma(133,M|0,U|0);e=o;o=0;if(e&1){e=53;break c}o=0;ma(135,d|0,M|0);e=o;o=0;if(e&1){e=54;break c}c[T>>2]=0;_r(T,d);Zr(M);e=c[T>>2]|0;o=0;d=qa(147,e|0)|0;Z=o;o=0;if(Z&1){e=56;break c}c[Q>>2]=d;c[N>>2]=0;vq(N,d);o=0;d=qa(148,e|0)|0;Z=o;o=0;if(Z&1){e=57;break c}c[I>>2]=d;c[H>>2]=0;vq(H,d);o=0;l=+eb(43,N|0,H|0);Z=o;o=0;if(Z&1){e=58;break c}uq(H);fs(I);uq(N);fs(Q);o=0;d=qa(149,e|0)|0;Z=o;o=0;if(Z&1){e=56;break c}c[S>>2]=d;c[R>>2]=0;vq(R,d);o=0;d=qa(148,e|0)|0;Z=o;o=0;if(Z&1){e=60;break c}c[D>>2]=d;c[C>>2]=0;vq(C,d);o=0;k=+eb(43,R|0,C|0);Z=o;o=0;if(Z&1){e=61;break c}uq(C);fs(D);uq(R);fs(S);o=0;d=qa(147,e|0)|0;Z=o;o=0;if(Z&1){e=56;break c}c[L>>2]=d;c[K>>2]=0;vq(K,d);o=0;d=qa(149,e|0)|0;Z=o;o=0;if(Z&1){e=63;break c}c[F>>2]=d;c[E>>2]=0;vq(E,d);o=0;h=+eb(43,K|0,E|0);Z=o;o=0;if(Z&1){e=64;break c}uq(E);fs(F);uq(K);fs(L);o=0;j=+Ka(44,f|0);Z=o;o=0;if(Z&1){e=56;break c}n=(l+h)/(j*2.0);do if(!(n>180.0|n<9.0)){if(+O(+((l-h)/(h<l?h:l)))>=.10000000149011612)break;n=+P(+(l*l+h*h));if(+O(+((k-n)/(n<k?n:k)))>=.10000000149011612)break;d=c[A>>2]|0;o=0;if((d|0)==(c[y>>2]|0)){bs(a,U);Z=o;o=0;if(Z&1){e=56;break c}else break}Xr(d,U);Z=o;o=0;if(Z&1){e=56;break c}c[A>>2]=(c[A>>2]|0)+12}while(0);Tr(T);Zr(U);fs(V);b=b+1|0;if((b|0)>=(z|0))break e}fs(V)}while(0);fs(X);q=q+1|0;if((q|0)>=(s|0))break d}fs(X)}while(0);fs(W);if((p|0)>=(r|0))break b}switch(e|0){case 17:{b=cc()|0;break}case 26:{b=cc()|0;e=75;break}case 51:{b=cc()|0;e=74;break}case 52:{b=cc()|0;Zr(G);e=74;break}case 53:{b=cc()|0;e=55;break}case 54:{b=cc()|0;Zr(M);e=55;break}case 56:{b=cc()|0;e=73;break}case 57:{b=cc()|0;e=59;break}case 58:{b=cc()|0;uq(H);fs(I);e=59;break}case 60:{b=cc()|0;e=62;break}case 61:{b=cc()|0;uq(C);fs(D);e=62;break}case 63:{b=cc()|0;e=65;break}case 64:{b=cc()|0;uq(E);fs(F);e=65;break}}if((e|0)==55){Uz(d);e=74}else if((e|0)==59){uq(N);fs(Q);e=73}else if((e|0)==62){uq(R);fs(S);e=73}else if((e|0)==65){uq(K);fs(L);e=73}if((e|0)==73){Tr(T);e=74}if((e|0)==74){Zr(U);e=75}if((e|0)==75)fs(V);fs(X);fs(W);break a}while(0);if((c[a>>2]|0)==(c[A>>2]|0)){e=Ob(8)|0;zq(e,48456);c[e>>2]=29736;o=0;mb(55,e|0,24,146);o=0;e=5}else e=82}else e=5}while(0);if((e|0)==5)b=cc()|0;else if((e|0)==82){Zr(Y);i=J;return}as(a)}Zr(Y);bc(b|0)}function Tj(a){a=a|0;Co(a);c[a+16>>2]=0;c[a>>2]=4692;c[a+12>>2]=4720;return}function Uj(a){a=a|0;Eo(a);return}function Vj(a){a=a|0;Uj(a+-12|0);return}function Wj(a){a=a|0;Uj(a);Uz(a);return}function Xj(a){a=a|0;Wj(a+-12|0);return}function Yj(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;x=i;i=i+112|0;l=x+96|0;z=x+80|0;f=x+76|0;y=x+64|0;g=x+56|0;u=x+52|0;m=x+48|0;v=x+36|0;w=x+32|0;p=x+28|0;q=x+16|0;r=x+4|0;s=x;c[a>>2]=0;t=a+4|0;c[t>>2]=0;c[a+8>>2]=0;o=0;d=qa(150,c[d>>2]|0)|0;k=o;o=0;do if(k&1)d=cc()|0;else{c[f>>2]=d;o=0;ma(139,z|0,f|0);k=o;o=0;if(k&1){d=cc()|0;Yd(f);break}Yd(f);$d(g,e);o=0;mb(43,y|0,z|0,g|0);k=o;o=0;if(k&1){d=cc()|0;ze(g+4|0)}else{ze(g+4|0);e=y+4|0;j=a+8|0;a:do if((c[e>>2]|0)==(c[y>>2]|0))h=37;else{k=0;while(1){o=0;d=qa(151,b|0)|0;g=o;o=0;b:do if(!(g&1)?(o=0,n=qa(118,c[(c[y>>2]|0)+(k<<2)>>2]|0)|0,g=o,o=0,!(g&1)):0){c[m>>2]=n;o=0;d=Wa(86,d|0,m|0)|0;g=o;o=0;if(g&1){d=cc(24)|0;f=D;Yd(m);h=32;break}c[u>>2]=d;Yd(m);o=0;ma(85,v|0,c[(c[y>>2]|0)+(k<<2)>>2]|0);g=o;o=0;if(g&1){d=cc(24)|0;f=D}else{o=0;g=qa(111,40)|0;f=o;o=0;c:do if(f&1){d=cc(24)|0;f=D}else{o=0;f=qa(116,d|0)|0;A=o;o=0;if(A&1){d=cc(24)|0;f=D}else{c[p>>2]=f;o=0;ma(86,q|0,d|0);A=o;o=0;do if(A&1){d=cc(24)|0;f=D}else{oe(r,v);c[s>>2]=12;o=0;c[l>>2]=c[s>>2];ia(45,g|0,p|0,q|0,r|0,l|0);A=o;o=0;if(A&1){d=cc(24)|0;f=D;pe(r);Sd(q);break}c[w>>2]=0;Qe(w,g);pe(r);Sd(q);ne(p);d=c[t>>2]|0;do if((d|0)==(c[j>>2]|0)){o=0;ma(140,a|0,w|0);A=o;o=0;if(!(A&1))break;d=cc(24)|0;f=D;be(w);break c}else{c[d>>2]=0;Qe(d,c[w>>2]|0);c[t>>2]=(c[t>>2]|0)+4}while(0);be(w);pe(v);aq(u);break b}while(0);ne(p)}Uz(g)}while(0);pe(v)}aq(u);h=32}else h=20;while(0);if((h|0)==20){d=cc(24)|0;f=D;h=32}if((h|0)==32){h=0;if((f|0)!=(Xb(24)|0))break a;fc(d|0)|0;o=0;ob(44);A=o;o=0;if(A&1)break}k=k+1|0;if(k>>>0>=(c[e>>2]|0)-(c[y>>2]|0)>>2>>>0){h=37;break a}}d=cc()|0;h=36}while(0);do if((h|0)==37)if((c[a>>2]|0)==(c[t>>2]|0)){d=Ob(8)|0;zq(d,48456);c[d>>2]=29736;o=0;mb(55,d|0,24,146);o=0;d=cc()|0;h=36;break}else{Vr(y);Lj(z);i=x;return}while(0);Vr(y)}Lj(z)}while(0);me(a);bc(d|0)}function Zj(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;Yj(a,b+-12|0,c,d);return}function _j(a){a=a|0;var b=0;c[a+4>>2]=0;c[a>>2]=4744;b=a+8|0;c[b>>2]=0;c[a+12>>2]=0;c[a+16>>2]=0;o=0;ka(312,a+20|0);a=o;o=0;if(a&1){a=cc()|0;js(b);bc(a|0)}else return}function $j(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0;e=i;i=i+16|0;c=e+8|0;d=e;$d(c,4500);o=0;ma(141,a|0,c|0);f=o;o=0;do if(!(f&1)){ze(c+4|0);_d(d,b);o=0;c=Wa(87,a|0,d|0)|0;f=o;o=0;if(f&1){c=cc()|0;ce(d);break}else{ce(d);i=e;return c|0}}else{f=cc()|0;ze(c+4|0);c=f}while(0);bc(c|0);return 0}function ak(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0;S=i;i=i+160|0;B=S+156|0;f=S+152|0;g=S+148|0;k=S+144|0;l=S+140|0;m=S+136|0;n=S+132|0;p=S+128|0;q=S+124|0;r=S+120|0;s=S+116|0;h=S+112|0;j=S+108|0;t=S+104|0;u=S+96|0;v=S+88|0;x=S+84|0;y=S+80|0;z=S+76|0;A=S+72|0;C=S+68|0;D=S+64|0;E=S+60|0;F=S+56|0;G=S+48|0;H=S+40|0;I=S+32|0;J=S+24|0;K=S+20|0;M=S+16|0;N=S+12|0;O=S+8|0;P=S;ks(a+20|0,b)|0;Q=a+8|0;e=c[Q>>2]|0;R=a+12|0;d=c[R>>2]|0;if((d|0)!=(e|0))do{L=d+-4|0;c[R>>2]=L;de(L);d=c[R>>2]|0}while((d|0)!=(e|0));L=dj(b)|0;c[f>>2]=16;c[B>>2]=c[f>>2];if((((((((((!(cj(b,B)|0)?(c[g>>2]=15,c[B>>2]=c[g>>2],!(cj(b,B)|0)):0)?(c[k>>2]=16,c[B>>2]=c[k>>2],!(cj(b,B)|0)):0)?(c[l>>2]=8,c[B>>2]=c[l>>2],!(cj(b,B)|0)):0)?(c[m>>2]=7,c[B>>2]=c[m>>2],!(cj(b,B)|0)):0)?(c[n>>2]=2,c[B>>2]=c[n>>2],!(cj(b,B)|0)):0)?(c[p>>2]=3,c[B>>2]=c[p>>2],!(cj(b,B)|0)):0)?(c[q>>2]=4,c[B>>2]=c[q>>2],!(cj(b,B)|0)):0)?(c[r>>2]=5,c[B>>2]=c[r>>2],!(cj(b,B)|0)):0)?(c[s>>2]=9,c[B>>2]=c[s>>2],!(cj(b,B)|0)):0)?(c[h>>2]=13,c[B>>2]=c[h>>2],!(cj(b,B)|0)):0){c[j>>2]=14;c[B>>2]=c[j>>2];d=cj(b,B)|0}else d=1;e=d^1;do if(L|e)w=23;else{d=Sz(20)|0;$d(u,b);o=0;ma(142,d|0,u|0);s=o;o=0;if(s&1){S=cc()|0;ze(u+4|0);Uz(d);d=S;break}c[t>>2]=0;Me(t,d);d=c[R>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(143,Q|0,t|0);s=o;o=0;if(s&1){d=cc()|0;de(t);ze(u+4|0);break}}else{c[d>>2]=0;Me(d,c[t>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(t);ze(u+4|0);w=23}while(0);a:do if((w|0)==23){c[v>>2]=12;c[B>>2]=c[v>>2];if(cj(b,B)|0){d=Sz(12)|0;o=0;ka(299,d|0);w=o;o=0;if(w&1){S=cc()|0;Uz(d);d=S;break}c[x>>2]=0;Me(x,d);d=c[R>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(143,Q|0,x|0);w=o;o=0;if(w&1){d=cc()|0;de(x);break}}else{c[d>>2]=0;Me(d,c[x>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(x)}c[y>>2]=6;c[B>>2]=c[y>>2];if(cj(b,B)|0){d=Sz(12)|0;o=0;ka(313,d|0);y=o;o=0;if(y&1){S=cc()|0;Uz(d);d=S;break}c[z>>2]=0;Me(z,d);d=c[R>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(143,Q|0,z|0);y=o;o=0;if(y&1){d=cc()|0;de(z);break}}else{c[d>>2]=0;Me(d,c[z>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(z)}c[A>>2]=1;c[B>>2]=c[A>>2];if(cj(b,B)|0){d=Sz(32)|0;o=0;ka(314,d|0);A=o;o=0;if(A&1){S=cc()|0;Uz(d);d=S;break}c[C>>2]=0;Me(C,d);d=c[R>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(143,Q|0,C|0);A=o;o=0;if(A&1){d=cc()|0;de(C);break}}else{c[d>>2]=0;Me(d,c[C>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(C)}c[D>>2]=11;c[B>>2]=c[D>>2];if(cj(b,B)|0){d=Sz(12)|0;c[d>>2]=0;c[d+4>>2]=0;c[d+8>>2]=0;c[d>>2]=27792;c[E>>2]=0;Me(E,d);d=c[R>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(143,Q|0,E|0);D=o;o=0;if(D&1){d=cc()|0;de(E);break}}else{c[d>>2]=0;Me(d,c[E>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(E)}if(!(L^1|e)){d=Sz(20)|0;$d(G,b);o=0;ma(142,d|0,G|0);E=o;o=0;if(E&1){S=cc()|0;ze(G+4|0);Uz(d);d=S;break}c[F>>2]=0;Me(F,d);d=c[R>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(143,Q|0,F|0);E=o;o=0;if(E&1){d=cc()|0;de(F);ze(G+4|0);break}}else{c[d>>2]=0;Me(d,c[F>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(F);ze(G+4|0)}if((c[R>>2]|0)==(c[Q>>2]|0)){if(!L){d=Sz(20)|0;$d(I,b);o=0;ma(142,d|0,I|0);G=o;o=0;if(G&1){S=cc()|0;ze(I+4|0);Uz(d);d=S;break}c[H>>2]=0;Me(H,d);d=c[R>>2]|0;if(d>>>0>=(c[a+16>>2]|0)>>>0){o=0;ma(143,Q|0,H|0);G=o;o=0;if(G&1){d=cc()|0;de(H);ze(I+4|0);break}}else{c[d>>2]=0;Me(d,c[H>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(H);ze(I+4|0)}d=Sz(12)|0;o=0;ka(299,d|0);I=o;o=0;if(I&1){S=cc()|0;Uz(d);d=S;break}c[J>>2]=0;Me(J,d);d=c[R>>2]|0;e=a+16|0;if(d>>>0>=(c[e>>2]|0)>>>0){o=0;ma(143,Q|0,J|0);a=o;o=0;if(a&1){d=cc()|0;de(J);break}}else{c[d>>2]=0;Me(d,c[J>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(J);d=Sz(12)|0;o=0;ka(313,d|0);J=o;o=0;if(J&1){S=cc()|0;Uz(d);d=S;break}c[K>>2]=0;Me(K,d);d=c[R>>2]|0;if(d>>>0>=(c[e>>2]|0)>>>0){o=0;ma(143,Q|0,K|0);J=o;o=0;if(J&1){d=cc()|0;de(K);break}}else{c[d>>2]=0;Me(d,c[K>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(K);d=Sz(32)|0;o=0;ka(314,d|0);K=o;o=0;if(K&1){S=cc()|0;Uz(d);d=S;break}c[M>>2]=0;Me(M,d);d=c[R>>2]|0;if(d>>>0>=(c[e>>2]|0)>>>0){o=0;ma(143,Q|0,M|0);K=o;o=0;if(K&1){d=cc()|0;de(M);break}}else{c[d>>2]=0;Me(d,c[M>>2]|0);c[R>>2]=(c[R>>2]|0)+4}de(M);d=Sz(12)|0;c[d>>2]=0;c[d+4>>2]=0;c[d+8>>2]=0;c[d>>2]=27792;c[N>>2]=0;Me(N,d);d=c[R>>2]|0;do if(d>>>0<(c[e>>2]|0)>>>0){c[d>>2]=0;Me(d,c[N>>2]|0);c[R>>2]=(c[R>>2]|0)+4}else{o=0;ma(143,Q|0,N|0);M=o;o=0;if(!(M&1))break;d=cc()|0;de(N);break a}while(0);de(N);if(L){d=Sz(20)|0;$d(P,b);o=0;ma(142,d|0,P|0);b=o;o=0;if(b&1){S=cc()|0;ze(P+4|0);Uz(d);d=S;break}c[O>>2]=0;Me(O,d);d=c[R>>2]|0;do if(d>>>0<(c[e>>2]|0)>>>0){c[d>>2]=0;Me(d,c[O>>2]|0);c[R>>2]=(c[R>>2]|0)+4}else{o=0;ma(143,Q|0,O|0);R=o;o=0;if(!(R&1))break;d=cc()|0;de(O);ze(P+4|0);break a}while(0);de(O);ze(P+4|0)}}i=S;return}while(0);bc(d|0)}function bk(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0;l=i;i=i+16|0;k=l+8|0;f=l;g=a+12|0;h=a+8|0;e=a+20|0;j=f+4|0;a=c[h>>2]|0;a:do if((c[g>>2]|0)!=(a|0)){d=0;while(1){a=c[a+(d<<2)>>2]|0;m=c[(c[a>>2]|0)+12>>2]|0;_d(k,b);$d(f,e);o=0;a=ya(m|0,a|0,k|0,f|0)|0;m=o;o=0;if(!(m&1)){d=3;break}a=cc(24)|0;m=D;ze(j);ce(k);if((m|0)!=(Xb(24)|0)){d=7;break}fc(a|0)|0;$b();d=d+1|0;a=c[h>>2]|0;if(d>>>0>=(c[g>>2]|0)-a>>2>>>0)break a}if((d|0)==3){ze(j);ce(k);i=l;return a|0}else if((d|0)==7)bc(a|0)}while(0);m=Ob(8)|0;zq(m,48456);c[m>>2]=29736;Hc(m|0,24,146);return 0}function ck(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0;f=i;i=i+16|0;d=f+8|0;e=f;$d(d,c);o=0;ma(141,a|0,d|0);c=o;o=0;do if(!(c&1)){ze(d+4|0);_d(e,b);o=0;d=Wa(87,a|0,e|0)|0;a=o;o=0;if(a&1){d=cc()|0;ce(e);break}else{ce(e);i=f;return d|0}}else{f=cc()|0;ze(d+4|0);d=f}while(0);bc(d|0);return 0}function dk(a){a=a|0;c[a>>2]=4744;ze(a+24|0);js(a+8|0);return}function ek(a){a=a|0;dk(a);Uz(a);return}function fk(a){a=a|0;var b=0,d=0,e=0;d=i;i=i+16|0;e=d;cl(a);c[a>>2]=4768;b=a+8|0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;c[e>>2]=0;o=0;mb(75,a+20|0,80,e|0);e=o;o=0;if(e&1){e=cc()|0;IC(b);il(a);bc(e|0)}else{c[a+32>>2]=0;i=d;return}}function gk(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0.0,j=0,k=0.0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0;A=i;i=i+64|0;u=A+60|0;v=A+56|0;f=A+52|0;B=A+40|0;r=A+36|0;t=A+32|0;w=A+28|0;x=A+16|0;y=A+4|0;z=A;q=b+20|0;s=(c[b+24>>2]|0)-(c[q>>2]|0)>>2;cr(q,0);cr(q,s);Wd(f,e);o=0;ma(144,b|0,f|0);s=o;o=0;if(s&1){C=cc()|0;bq(f);f=C}else{bq(f);e=ik(b)|0;s=b+8|0;if(!(a[s>>0]&1)){a[s+1>>0]=0;a[s>>0]=0;n=b+12|0}else{a[c[b+16>>2]>>0]=0;n=b+12|0;c[n>>2]=0}m=b+32|0;f=e;while(1){l=jk(b,f)|0;if((l|0)==-1){C=7;break}NC(s,1,l&255)|0;g=f+8|0;j=a[s>>0]|0;if(!(j&1))j=(j&255)>>>1;else j=c[n>>2]|0;if(j>>>0>1?kk(48494,a[48473+l>>0]|0)|0:0)break;if((g|0)<(c[m>>2]|0))f=g;else break}if((C|0)==7){C=Ob(8)|0;c[C+4>>2]=0;c[C>>2]=30552;Hc(C|0,856,146)}p=f+7|0;l=c[q>>2]|0;if((g|0)<(c[m>>2]|0)?(c[l+(p<<2)>>2]|0)<(((c[l+(-2+g<<2)>>2]|0)+((c[l+(-3+g<<2)>>2]|0)+((c[l+(-4+g<<2)>>2]|0)+((c[l+(-5+g<<2)>>2]|0)+((c[l+(-6+g<<2)>>2]|0)+((c[l+(-7+g<<2)>>2]|0)+(c[l+(f<<2)>>2]|0))))))|0)/2|0|0):0){C=Ob(8)|0;c[C+4>>2]=0;c[C>>2]=30552;Hc(C|0,856,146)}lk(b,e);f=s+1|0;b=b+16|0;m=0;while(1){g=a[s>>0]|0;l=(g&1)==0;if(l)j=(g&255)>>>1;else j=c[n>>2]|0;if((m|0)>=(j|0)){j=g;break}if(l){g=s+1+m|0;j=f}else{j=c[b>>2]|0;g=j+m|0}a[j+m>>0]=a[48473+(a[g>>0]|0)>>0]|0;m=m+1|0}if(l)g=f;else g=c[b>>2]|0;if(!(kk(48494,a[g>>0]|0)|0)){C=Ob(8)|0;c[C+4>>2]=0;c[C>>2]=30552;Hc(C|0,856,146)}if(l)g=(j&255)>>>1;else{g=c[n>>2]|0;f=c[b>>2]|0}if(!(kk(48494,a[f+(g+-1)>>0]|0)|0)){C=Ob(8)|0;c[C+4>>2]=0;c[C>>2]=30552;Hc(C|0,856,146)}if(l)f=(j&255)>>>1;else f=c[n>>2]|0;if((f|0)<4){C=Ob(8)|0;c[C+4>>2]=0;c[C>>2]=30552;Hc(C|0,856,146)}if(l)f=(j&255)>>>1;else f=c[n>>2]|0;VC(s,f+-1|0,1)|0;VC(s,0,1)|0;if((e|0)>0){g=c[q>>2]|0;j=0;f=0;do{f=(c[g+(j<<2)>>2]|0)+f|0;j=j+1|0}while((j|0)<(e|0));j=f}else j=0;if((e|0)<(p|0)){g=c[q>>2]|0;f=j;do{f=(c[g+(e<<2)>>2]|0)+f|0;e=e+1|0}while((e|0)<(p|0))}else f=j;k=+(f|0);ns(B,2);f=(c[B+8>>2]|0)+8|0;e=c[f>>2]|0;o=0;g=qa(111,16)|0;q=o;o=0;do if(!(q&1)){h=+(d|0);o=0;wa(43,g|0,+(+(j|0)),+h);d=o;o=0;if(d&1){f=cc()|0;Uz(g);break}c[r>>2]=0;os(r,g);vq(e,c[r>>2]|0);ps(r);f=(c[f>>2]|0)+4|0;o=0;e=qa(111,16)|0;r=o;o=0;if(!(r&1)){o=0;wa(43,e|0,+k,+h);r=o;o=0;if(r&1){f=cc()|0;Uz(e);break}c[t>>2]=0;os(t,e);vq(f,c[t>>2]|0);ps(t);o=0;e=qa(111,40)|0;t=o;o=0;if(!(t&1)){o=0;f=qa(111,20)|0;t=o;o=0;do if(!(t&1)){o=0;ma(94,f|0,s|0);t=o;o=0;if(t&1){A=cc()|0;Uz(f);f=A;break}c[w>>2]=0;cq(w,f);c[x+4>>2]=0;c[x>>2]=4084;c[x+8>>2]=0;oe(y,B);c[z>>2]=2;o=0;c[u>>2]=c[z>>2];ia(45,e|0,w|0,x|0,y|0,u|0);z=o;o=0;if(z&1){f=cc()|0;pe(y);Sd(x);ne(w);break}else{c[v>>2]=0;Qe(v,e);pe(y);Sd(x);ne(w);pe(B);i=A;return c[v>>2]|0}}else f=cc()|0;while(0);Uz(e)}else C=58}else C=58}else C=58;while(0);if((C|0)==58)f=cc()|0;pe(B)}bc(f|0);return 0}function hk(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;c[a+32>>2]=0;e=bg(c[b>>2]|0,0)|0;g=Wf(c[b>>2]|0)|0;if((e|0)>=(g|0)){a=Ob(8)|0;c[a+4>>2]=0;c[a>>2]=30552;Hc(a|0,856,146)}if((e|0)<(g|0)){d=0;f=1;do{if(f^(c[(c[(c[(c[b>>2]|0)+20>>2]|0)+8>>2]|0)+(e>>5<<2)>>2]&1<<(e&31)|0)!=0)d=d+1|0;else{mk(a,d);d=1;f=f^1}e=e+1|0}while((e|0)<(g|0))}else d=0;mk(a,d);return}function ik(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;f=c[b+32>>2]|0;g=b+20|0;a:do if((f|0)>1){d=1;h=8;while(1){e=jk(b,d)|0;if((e|0)!=-1?kk(48494,a[48473+e>>0]|0)|0:0){if((d|0)==(h|0))e=0;else{e=d+1|0;i=e+1|0;j=i+1|0;k=j+1|0;l=k+1|0;e=(c[(c[g>>2]|0)+(l+1<<2)>>2]|0)+((c[(c[g>>2]|0)+(l<<2)>>2]|0)+((c[(c[g>>2]|0)+(k<<2)>>2]|0)+((c[(c[g>>2]|0)+(j<<2)>>2]|0)+((c[(c[g>>2]|0)+(i<<2)>>2]|0)+((c[(c[g>>2]|0)+(e<<2)>>2]|0)+(c[(c[g>>2]|0)+(d<<2)>>2]|0))))))|0}if((d|0)==1){d=1;break}if((c[(c[g>>2]|0)+(d+-1<<2)>>2]|0)>=((e|0)/2|0|0))break}d=d+2|0;if((d|0)>=(f|0))break a;else h=h+2|0}return d|0}while(0);l=Ob(8)|0;c[l+4>>2]=0;c[l>>2]=30552;Hc(l|0,856,146);return 0}function jk(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0;a:do if((b+7|0)<(c[a+32>>2]|0)){f=a+20|0;i=c[(c[f>>2]|0)+(b<<2)>>2]|0;a=(i|0)<2147483647?i:2147483647;i=(i|0)>0?i:0;d=b+2|0;g=c[(c[f>>2]|0)+(d<<2)>>2]|0;a=(g|0)<(a|0)?g:a;i=(g|0)>(i|0)?g:i;d=d+2|0;g=c[(c[f>>2]|0)+(d<<2)>>2]|0;a=(g|0)<(a|0)?g:a;i=(g|0)>(i|0)?g:i;d=c[(c[f>>2]|0)+(d+2<<2)>>2]|0;g=b+1|0;e=c[(c[f>>2]|0)+(g<<2)>>2]|0;h=(e|0)<2147483647?e:2147483647;e=(e|0)>0?e:0;g=g+2|0;j=c[(c[f>>2]|0)+(g<<2)>>2]|0;h=(j|0)<(h|0)?j:h;e=(j|0)>(e|0)?j:e;g=c[(c[f>>2]|0)+(g+2<<2)>>2]|0;a=((d|0)>(i|0)?d:i)+((d|0)<(a|0)?d:a)|0;e=((g|0)<(h|0)?g:h)+((g|0)>(e|0)?g:e)|0;f=c[f>>2]|0;g=128;h=0;d=0;do{g=g>>1;d=((c[f+(h+b<<2)>>2]|0)>((((h&1|0)==0?a:e)|0)/2|0|0)?g:0)|d;h=h+1|0}while((h|0)!=7);a=0;while(1){if((c[30736+(a<<2)>>2]|0)==(d|0))break a;a=a+1|0;if((a|0)>=20){a=-1;break}}}else a=-1;while(0);return a|0}function kk(a,b){a=a|0;b=b|0;return (dC(a,b<<24>>24)|0)!=0|0}function lk(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;u=i;i=i+64|0;x=u+52|0;r=u+48|0;w=u+36|0;s=u+32|0;v=u+20|0;l=u+16|0;t=u+4|0;m=u;c[r>>2]=0;ms(x,4,r);c[s>>2]=0;o=0;mb(75,w|0,4,s|0);s=o;o=0;if(s&1)e=cc()|0;else{p=b+8|0;f=a[p>>0]|0;if(!(f&1))e=(f&255)>>>1;else e=c[b+12>>2]|0;r=e+-1|0;s=p+1|0;n=b+20|0;q=b+16|0;e=f;j=0;k=d;while(1){if(!(e&1))e=s;else e=c[q>>2]|0;b=c[x>>2]|0;f=c[w>>2]|0;g=c[n>>2]|0;h=6;e=c[30736+(a[e+j>>0]<<2)>>2]|0;while(1){y=h&1|e<<1&2;z=b+(y<<2)|0;c[z>>2]=(c[z>>2]|0)+(c[g+(h+k<<2)>>2]|0);y=f+(y<<2)|0;c[y>>2]=(c[y>>2]|0)+1;if((h|0)>0){h=h+-1|0;e=e>>1}else break}if((j|0)>=(r|0))break;e=a[p>>0]|0;j=j+1|0;k=k+8|0}c[l>>2]=0;o=0;mb(75,v|0,4,l|0);z=o;o=0;if(z&1)e=cc()|0;else{c[m>>2]=0;o=0;mb(75,t|0,4,m|0);z=o;o=0;do if(!(z&1)){l=c[t>>2]|0;e=c[x>>2]|0;b=c[w>>2]|0;m=c[v>>2]|0;f=0;do{c[l+(f<<2)>>2]=0;z=f+2|0;k=e+(z<<2)|0;y=b+(z<<2)|0;j=((c[k>>2]<<8|0)/(c[y>>2]|0)|0)+((c[e+(f<<2)>>2]<<8|0)/(c[b+(f<<2)>>2]|0)|0)>>1;c[l+(z<<2)>>2]=j;c[m+(f<<2)>>2]=j;c[m+(z<<2)>>2]=(c[k>>2]<<9|384|0)/(c[y>>2]|0)|0;f=f+1|0}while((f|0)!=2);k=(a[p>>0]&1)==0;h=c[n>>2]|0;j=0;a:while(1){if(k)e=s;else e=c[q>>2]|0;g=6;f=c[30736+(a[e+j>>0]<<2)>>2]|0;while(1){e=g&1|f<<1&2;b=c[h+(g+d<<2)>>2]<<8;if((b|0)<(c[l+(e<<2)>>2]|0)){b=25;break a}if((b|0)>(c[m+(e<<2)>>2]|0)){b=25;break a}if((g|0)>0){g=g+-1|0;f=f>>1}else break}if((j|0)>=(r|0)){b=29;break}j=j+1|0;d=d+8|0}if((b|0)==25){e=Ob(8)|0;c[e+4>>2]=0;c[e>>2]=30552;o=0;mb(55,e|0,856,146);o=0;e=cc()|0;br(t);break}else if((b|0)==29){br(t);br(v);br(w);br(x);i=u;return}}else e=cc()|0;while(0);br(v)}br(w)}br(x);bc(e|0)}function mk(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0;l=i;i=i+16|0;d=l;c[d>>2]=b;e=a+32|0;f=c[e>>2]|0;g=a+20|0;h=a+24|0;j=c[h>>2]|0;k=c[g>>2]|0;do if((f|0)>=(j-k>>2|0))if((j|0)==(c[a+28>>2]|0)){qs(g,d);break}else{c[j>>2]=b;c[h>>2]=j+4;break}else c[k+(f<<2)>>2]=b;while(0);c[e>>2]=(c[e>>2]|0)+1;i=l;return}function nk(a){a=a|0;cl(a);c[a>>2]=4796;return}function ok(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;u=i;i=i+32|0;v=u+8|0;e=u+4|0;t=u;s=Wf(c[b>>2]|0)|0;f=ag(c[b>>2]|0,0)|0;c[e>>2]=0;ms(v,6,e);e=c[v>>2]|0;d=(c[v+4>>2]|0)-e|0;n=d>>2;p=n+-1|0;q=n+-2|0;r=n+-2|0;a:do if((f|0)<(s|0)){m=(d|0)>8;d=e;h=0;g=f;l=0;e=f;while(1){if(l^(c[(c[(c[(c[b>>2]|0)+20>>2]|0)+8>>2]|0)+(g>>5<<2)>>2]&1<<(g&31)|0)!=0){f=d+(h<<2)|0;c[f>>2]=(c[f>>2]|0)+1;f=d;j=l}else{if((h|0)==(p|0)){o=0;d=ya(99,v|0,33288,179)|0;k=o;o=0;if(k&1){f=5;break}k=(d|0)<64;d=k?d:64;o=0;f=ya(99,v|0,33312,179)|0;j=o;o=0;if(j&1){f=5;break}h=(f|0)<(d|0);o=0;j=ya(99,v|0,33336,179)|0;w=o;o=0;if(w&1){f=5;break}d=(j|0)<((h?f:d)|0)?105:h?104:k?103:-1;if((d|0)>-1){f=e-((g-e|0)/2|0)|0;o=0;f=kb(57,c[b>>2]|0,((f|0)>0?f:0)|0,e|0,0)|0;w=o;o=0;if(w&1){f=6;break}if(f){f=14;break}}f=c[v>>2]|0;h=c[f+4>>2]|0;e=(c[f>>2]|0)+e|0;if(m){d=2;do{c[f+(d+-2<<2)>>2]=c[f+(d<<2)>>2];d=d+1|0}while((d|0)<(n|0))}c[f+(q<<2)>>2]=0;c[f+(p<<2)>>2]=0;d=r;e=e+h|0}else{f=d;d=h+1|0}c[f+(d<<2)>>2]=1;h=d;j=l^1}g=g+1|0;if((g|0)>=(s|0)){f=22;break a}else{d=f;l=j}}if((f|0)==5){d=cc()|0;break}else if((f|0)==6){d=cc()|0;break}else if((f|0)==14){c[t>>2]=0;o=0;mb(75,a|0,3,t|0);w=o;o=0;if(w&1){f=7;break}w=c[a>>2]|0;c[w>>2]=e;c[w+4>>2]=g;c[w+8>>2]=d;br(v);i=u;return}}else f=22;while(0);if((f|0)==22){w=Ob(8)|0;c[w+4>>2]=0;c[w>>2]=30552;o=0;mb(55,w|0,856,146);o=0;f=7}if((f|0)==7)d=cc()|0;br(v);bc(d|0)}function pk(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;h=i;i=i+16|0;e=h;Wd(e,a);o=0;mb(76,e|0,d|0,b|0);g=o;o=0;if(g&1){h=cc()|0;bq(e);bc(h|0)}bq(e);e=-1;f=64;g=0;while(1){a=gl(b,30816+(g*24|0)|0,179)|0;d=(a|0)<(f|0);e=d?g:e;g=g+1|0;if((g|0)==107)break;else f=d?a:f}if((e|0)>-1){i=h;return e|0}else{h=Ob(8)|0;c[h+4>>2]=0;c[h>>2]=30552;Hc(h|0,856,146)}return 0}
function Nm(a,b,d,e,f,g,h,j,k){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;v=i;i=i+16|0;q=v;p=k+8|0;s=c[p>>2]|0;r=(c[s+12>>2]|0)-(c[s+8>>2]|0)>>2;c[q>>2]=0;Rs(s+8|0,r,q);q=f+d|0;r=j+-1|0;s=j+-2|0;t=j+-2|0;a:do if((f|0)>0){n=(j|0)>2;j=0;m=g;g=d;f=d;while(1){if(m^(eq(c[b>>2]|0,f,e)|0)){d=(c[(c[p>>2]|0)+8>>2]|0)+(j<<2)|0;c[d>>2]=(c[d>>2]|0)+1;d=m}else{if((j|0)==(r|0)){if((Om(k,h,204)|0)<107)break;d=c[(c[p>>2]|0)+8>>2]|0;l=c[d+4>>2]|0;g=(c[d>>2]|0)+g|0;if(n){j=0;do{c[d+(j<<2)>>2]=c[d+(j+2<<2)>>2];j=j+1|0}while((j|0)<(s|0))}c[d+(s<<2)>>2]=0;c[d+(r<<2)>>2]=0;j=t;g=g+l|0}else{d=c[(c[p>>2]|0)+8>>2]|0;j=j+1|0}c[d+(j<<2)>>2]=1;d=m^1}f=f+1|0;if((f|0)>=(q|0)){u=15;break a}else m=d}j=Sz(20)|0;o=0;ma(102,j|0,2);e=o;o=0;if(e&1){v=cc()|0;Uz(j);bc(v|0)}else{Fq(a,j);a=c[(c[a+8>>2]|0)+8>>2]|0;c[a>>2]=g;c[a+4>>2]=f;break}}else u=15;while(0);if((u|0)==15){c[a+4>>2]=0;c[a>>2]=29772;c[a+8>>2]=0}i=v;return}function Om(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;g=c[a+8>>2]|0;i=c[g+8>>2]|0;g=(c[g+12>>2]|0)-i|0;j=g>>2;if((g|0)>0){f=0;a=0;e=0;do{e=(c[i+(f<<2)>>2]|0)+e|0;a=(c[b+(f<<2)>>2]|0)+a|0;f=f+1|0}while((f|0)<(j|0))}else{a=0;e=0}a:do if((e|0)<(a|0))a=2147483647;else{h=(e<<8|0)/(a|0)|0;d=($(h,d)|0)>>8;if((g|0)>0){a=0;g=0;do{f=c[i+(g<<2)>>2]<<8;k=$(c[b+(g<<2)>>2]|0,h)|0;f=(f|0)>(k|0)?f-k|0:k-f|0;if((f|0)>(d|0)){a=2147483647;break a}a=f+a|0;g=g+1|0}while((g|0)<(j|0))}else a=0;a=(a|0)/(e|0)|0}while(0);return a|0}function Pm(a,b,d,e,f,g,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0.0,m=0.0,n=0.0,p=0.0,q=0.0,r=0.0,s=0.0,t=0,u=0,v=0,w=0.0,x=0.0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0;B=i;i=i+16|0;D=B+4|0;C=B;A=b+8|0;tq(D,(c[(c[A>>2]|0)+8>>2]|0)+(d<<2)|0);tq(C,(c[(c[A>>2]|0)+8>>2]|0)+(d+4<<2)|0);b=f+e|0;z=c[C>>2]|0;o=0;l=+Ka(c[(c[z>>2]|0)+8>>2]|0,z|0);z=o;o=0;do if((((!(z&1)?(j=c[D>>2]|0,o=0,m=+Ka(c[(c[j>>2]|0)+8>>2]|0,j|0),z=o,o=0,!(z&1)):0)?(n=l-m,o=0,p=+Ka(c[(c[j>>2]|0)+8>>2]|0,j|0),z=o,o=0,!(z&1)):0)?(q=+(g|0),w=p+ +(e|0)*n/q,o=0,r=+Ka(c[(c[j>>2]|0)+8>>2]|0,j|0),z=o,o=0,!(z&1)):0)?(x=r+ +(b|0)*n/q,k=~~+N(+((w+x)*.5+.5)),o=0,s=+Ka(c[(c[j>>2]|0)+12>>2]|0,j|0),z=o,o=0,!(z&1)):0){z=~~+N(+(s+.5));f=c[a>>2]|0;b=~~((w<x?x:w)+1.0);while(1){o=0;f=qa(121,f|0)|0;y=o;o=0;if(y&1){E=12;break}if((b|0)>=(f|0))break;f=c[a>>2]|0;if(!(eq(f,b+-1|0,z)|0)?eq(f,b,z)|0:0)break;b=b+1|0}if((E|0)==12){b=cc()|0;E=14;break}y=b-k|0;j=z;a:while(1){g=k+y|0;e=g+1|0;t=(k|0)>0;u=k+-1|0;v=k+1|0;while(1){b=c[a>>2]|0;do if(eq(b,k,j)|0){if(eq(b,g,j)|0)f=0;else f=(eq(b,e,j)|0)^1;j=j+h|0;if((j|0)>=1){o=0;b=qa(122,b|0)|0;F=o;o=0;if(F&1){E=11;break a}if((j|0)<(b+-1|0)){b=f;break}}b=1}else{if(t?eq(b,u,j)|0:0){k=u;continue a}o=0;b=qa(121,b|0)|0;F=o;o=0;if(F&1){E=11;break a}if((k|0)<(b+-1|0)?eq(c[a>>2]|0,v,j)|0:0){k=v;continue a}b=1;j=j-((j|0)==(z|0)?0:h)|0}while(0);if(b)break a}}if((E|0)==11){b=cc()|0;E=14;break}b=(c[(c[A>>2]|0)+8>>2]|0)+(d+8<<2)|0;o=0;f=qa(111,16)|0;F=o;o=0;if(!(F&1)){o=0;wa(42,f|0,+(+(k|0)),+(+(j|0)));F=o;o=0;if(F&1){b=cc()|0;Uz(f);break}else{vq(b,f);uq(C);uq(D);i=B;return}}else E=13}else E=13;while(0);if((E|0)==13){b=cc()|0;E=14}uq(C);uq(D);bc(b|0)}function Qm(a,b,d,e,f,h,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0.0,l=0,m=0,n=0.0,p=0,q=0,r=0,s=0,u=0,v=0,w=0.0,x=0.0,y=0.0,z=0.0,A=0.0,B=0.0,C=0.0;q=i;i=i+80|0;r=q+64|0;s=q+48|0;l=q+40|0;v=q+16|0;u=q;p=q+32|0;m=a+8|0;a=c[(c[(c[m>>2]|0)+8>>2]|0)+(d<<2)>>2]|0;C=+ld[c[(c[a>>2]|0)+8>>2]&63](a);d=c[(c[(c[m>>2]|0)+8>>2]|0)+(d<<2)>>2]|0;B=+ld[c[(c[d>>2]|0)+12>>2]&63](d);C=+C;B=+B;d=c[(c[(c[m>>2]|0)+8>>2]|0)+(e<<2)>>2]|0;A=+ld[c[(c[d>>2]|0)+8>>2]&63](d);e=c[(c[(c[m>>2]|0)+8>>2]|0)+(e<<2)>>2]|0;z=+ld[c[(c[e>>2]|0)+12>>2]&63](e);A=+A;z=+z;e=c[(c[(c[m>>2]|0)+8>>2]|0)+(f<<2)>>2]|0;y=+ld[c[(c[e>>2]|0)+8>>2]&63](e);f=c[(c[(c[m>>2]|0)+8>>2]|0)+(f<<2)>>2]|0;x=+ld[c[(c[f>>2]|0)+12>>2]&63](f);y=+y;x=+x;f=c[(c[(c[m>>2]|0)+8>>2]|0)+(h<<2)>>2]|0;w=+ld[c[(c[f>>2]|0)+8>>2]&63](f);h=c[(c[(c[m>>2]|0)+8>>2]|0)+(h<<2)>>2]|0;k=+ld[c[(c[h>>2]|0)+12>>2]&63](h);w=+w;k=+k;h=v;g[h>>2]=C;g[h+4>>2]=B;h=v+8|0;g[h>>2]=A;g[h+4>>2]=z;h=u;g[h>>2]=y;g[h+4>>2]=x;h=u+8|0;g[h>>2]=w;g[h+4>>2]=k;c[s>>2]=c[v>>2];c[s+4>>2]=c[v+4>>2];c[s+8>>2]=c[v+8>>2];c[s+12>>2]=c[v+12>>2];c[r>>2]=c[u>>2];c[r+4>>2]=c[u+4>>2];c[r+8>>2]=c[u+8>>2];c[r+12>>2]=c[u+12>>2];Rm(l,s,r);k=+g[l>>2];if(!(k==t)?(n=+g[l+4>>2],!(n==t)):0){a=~~+N(+(k+.5));d=~~+N(+(n+.5));if(((a|0)>=0?!((d|0)<0|(a|0)>=(ig(c[j>>2]|0)|0)):0)?(d|0)<(jg(c[j>>2]|0)|0):0){a=c[(c[m>>2]|0)+8>>2]|0;d=Sz(16)|0;o=0;wa(42,d|0,+k,+n);v=o;o=0;if(v&1){v=cc()|0;Uz(d);bc(v|0)}else{c[p>>2]=0;vq(p,d);vq(a+(b<<2)|0,c[p>>2]|0);uq(p);i=q;return}}v=Ob(8)|0;zq(v,49648);c[v>>2]=30552;Hc(v|0,856,146)}v=Ob(8)|0;zq(v,49590);c[v>>2]=30552;Hc(v|0,856,146)}function Rm(a,b,c){a=a|0;b=b|0;c=c|0;var d=0.0,e=0.0,f=0.0,h=0.0,i=0.0,j=0.0,k=0.0,l=0.0,m=0.0,n=0.0,o=0.0,p=0.0;p=+g[b>>2];n=+g[b+8>>2];j=p-n;m=+g[c>>2];i=+g[c+8>>2];k=m-i;f=+g[b+4>>2];o=+g[b+12>>2];e=f-o;h=+g[c+4>>2];l=+g[c+12>>2];d=h-l;f=p*o-n*f;h=m*l-i*h;i=j*d-k*e;if(+O(+i)<1.0e-12){e=t;d=t}else{e=(f*d-e*h)/i;d=(k*f-j*h)/i}g[a>>2]=d;g[a+4>>2]=e;return}function Sm(a){a=a|0;var b=0,d=0,e=0,f=0,h=0.0,j=0,k=0,l=0,m=0,n=0,p=0,q=0;p=i;i=i+16|0;q=p;n=c[1318]|0;Ss(q,n);e=q+4|0;b=c[q>>2]|0;a:do if(((c[e>>2]|0)-b|0)>0){d=0;while(1){o=0;ma(164,b+(d*12|0)|0,8);m=o;o=0;if(m&1)break;d=d+1|0;b=c[q>>2]|0;if((d|0)>=(((c[e>>2]|0)-b|0)/12|0|0)){f=7;break a}}b=cc()|0}else f=7;while(0);do if((f|0)==7){o=0;ma(165,a|0,n<<3|0);m=o;o=0;if(m&1){b=cc()|0;break}m=c[q>>2]|0;if((n|0)>0){j=c[a>>2]|0;k=0;l=0;while(1){d=c[5276+(k<<2)>>2]|0;a=c[m+(k*12|0)>>2]|0;e=d&1;f=0;while(1){b=d&1;if((b|0)==(e|0)){h=0.0;do{h=h+1.0;d=d>>1;b=d&1}while((b|0)==(e|0))}else h=0.0;g[a+(7-f<<2)>>2]=h/17.0;f=f+1|0;if((f|0)==8)break;else e=b}b=c[m+(k*12|0)>>2]|0;d=0;e=l;while(1){c[j+(e<<2)>>2]=c[b+(d<<2)>>2];d=d+1|0;if((d|0)==8)break;else e=e+1|0}k=k+1|0;if((k|0)>=(n|0))break;else l=l+8|0}}Us(q);i=p;return}while(0);Us(q);bc(b|0)}function Tm(a,b,d){a=a|0;b=b|0;d=d|0;Zp(a,b);c[a+8>>2]=d;return}function Um(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;p=i;i=i+112|0;l=p+96|0;v=p+84|0;b=p+80|0;u=p+68|0;t=p+56|0;d=p+52|0;s=p+40|0;r=p+28|0;h=p+24|0;j=p+16|0;q=p;n=a+8|0;k=(c[n>>2]|0)/17|0;c[v>>2]=0;c[v+4>>2]=0;c[v+8>>2]=0;Zp(b,a);o=0;mb(94,v|0,k|0,b|0);g=o;o=0;do if(g&1){u=cc()|0;Yd(b);b=u}else{Yd(b);o=0;b=qa(122,c[a>>2]|0)|0;g=o;o=0;if(!(g&1)?(o=0,ma(166,u|0,b|0),g=o,o=0,!(g&1)):0){o=0;b=qa(122,c[a>>2]|0)|0;g=o;o=0;if(!(g&1)?(o=0,ma(166,t|0,b|0),g=o,o=0,!(g&1)):0){Zp(d,a);o=0;ia(52,t|0,k|0,v|0,d|0,u|0);g=o;o=0;do if(g&1){b=cc()|0;Yd(d)}else{Yd(d);o=0;ub(66,s|0,k|0,u|0,t|0);g=o;o=0;if(g&1){b=cc()|0;break}f=s+4|0;o=0;ma(166,r|0,((c[f>>2]|0)-(c[s>>2]|0)|0)/12|0|0);g=o;o=0;if(g&1)b=cc()|0;else{g=j+4|0;b=c[s>>2]|0;a:do if(((c[f>>2]|0)-b|0)>0){e=0;while(1){d=(c[r>>2]|0)+(e*12|0)|0;a=((c[b+(e*12|0)+4>>2]|0)-(c[b+(e*12|0)>>2]|0)|0)/12|0;c[h>>2]=0;o=0;mb(95,d|0,a|0,h|0);a=o;o=0;if(a&1)break;b=c[s>>2]|0;d=c[b+(e*12|0)>>2]|0;if(((c[b+(e*12|0)+4>>2]|0)-d|0)>0){a=0;do{if(c[d+(a*12|0)+8>>2]|0){Ys(j,d+(a*12|0)|0);c[(c[(c[r>>2]|0)+(e*12|0)>>2]|0)+(a<<2)>>2]=c[g>>2]}a=a+1|0;b=c[s>>2]|0;d=c[b+(e*12|0)>>2]|0}while((a|0)<(((c[b+(e*12|0)+4>>2]|0)-d|0)/12|0|0))}e=e+1|0;if((e|0)>=(((c[f>>2]|0)-b|0)/12|0|0)){d=25;break a}}b=cc()|0;d=22}else d=25;while(0);do if((d|0)==25){o=0;mb(96,q|0,k|0,r|0);j=o;o=0;if(j&1){b=cc()|0;d=22;break}o=0;b=ya(113,k|0,r|0,q|0)|0;k=o;o=0;do if((!(k&1)?(o=0,ma(167,r|0,b|0),k=o,o=0,!(k&1)):0)?(o=0,m=qa(111,32)|0,k=o,o=0,!(k&1)):0){o=0;mb(54,m|0,c[n>>2]|0,((c[r+4>>2]|0)-(c[r>>2]|0)|0)/12|0|0);n=o;o=0;if(n&1){b=cc()|0;Uz(m);break}else{c[l>>2]=0;Ke(l,m);_m(r,l);br(q);_s(r);$s(s);_s(t);_s(u);Xq(v);i=p;return c[l>>2]|0}}else d=30;while(0);if((d|0)==30)b=cc()|0;br(q)}while(0);_s(r)}$s(s)}while(0);_s(t)}else b=cc()|0;_s(u);break}b=cc()|0}while(0);Xq(v);bc(b|0);return 0}function Vm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0.0,f=0,h=0,j=0.0,k=0,l=0.0,m=0,n=0,p=0,q=0.0,r=0,s=0,t=0,u=0,v=0,w=0;t=i;i=i+32|0;r=t+24|0;v=t+12|0;s=t+8|0;n=t+4|0;u=t;q=+(ig(c[d>>2]|0)|0);q=(b|0)>0?q/+(b|0):q;g[r>>2]=q;p=ig(c[d>>2]|0)|0;c[s>>2]=0;ms(v,p,s);s=a+4|0;p=a+8|0;l=q;j=l*.75;l=l*1.5;k=1;f=0;m=2;a:while(1){o=0;h=qa(121,c[d>>2]|0)|0;b=o;o=0;if(b&1){h=11;break}b=c[d>>2]|0;if((m|0)<(h|0))h=0;else{h=27;break}while(1){o=0;b=qa(122,b|0)|0;w=o;o=0;if(w&1){h=10;break a}if((h|0)>=(b|0))break;b=c[d>>2]|0;if(eq(b,m,h)|0){w=(c[v>>2]|0)+(m<<2)|0;c[w>>2]=(c[w>>2]|0)+1}h=h+1|0}b=c[(c[v>>2]|0)+(m<<2)>>2]|0;o=0;h=qa(122,c[d>>2]|0)|0;w=o;o=0;if(w&1){h=11;break}b=(b|0)!=(h|0);do if(!(k|b)){e=+(m-f|0);g[n>>2]=e;if(e>j){f=c[s>>2]|0;b=(f|0)==(c[p>>2]|0);if(e>l)do{if(b){o=0;ma(168,a|0,r|0);w=o;o=0;if(w&1){h=9;break a}}else{g[f>>2]=q;c[s>>2]=f+4}e=e-q;g[n>>2]=e;f=c[s>>2]|0;b=(f|0)==(c[p>>2]|0)}while(e>l);if(b){o=0;ma(168,a|0,n|0);w=o;o=0;if(w&1){h=11;break a}else{b=1;f=m;break}}else{g[f>>2]=e;c[s>>2]=f+4;b=1;f=m;break}}else b=0}else b=b^1;while(0);k=b;m=m+1|0}b:do if((h|0)==9)b=cc()|0;else if((h|0)==10)b=cc()|0;else if((h|0)==11)b=cc()|0;else if((h|0)==27){o=0;b=qa(121,b|0)|0;w=o;o=0;do if(!(w&1)){e=+(b-f|0);j=q*1.5;f=c[s>>2]|0;b=(f|0)==(c[p>>2]|0);c:do if(e>j){while(1){if(b){o=0;ma(168,a|0,r|0);w=o;o=0;if(w&1)break}else{g[f>>2]=q;c[s>>2]=f+4}e=e-q;f=c[s>>2]|0;b=(f|0)==(c[p>>2]|0);if(!(e>j))break c}b=cc()|0;g[u>>2]=e;break b}while(0);g[u>>2]=e;if(b){o=0;ma(168,a|0,u|0);w=o;o=0;if(w&1)break}else{g[f>>2]=e;c[s>>2]=f+4}br(v);i=t;return}while(0);b=cc()|0}while(0);br(v);bc(b|0)}function Wm(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0,m=0.0,n=0.0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0.0;E=i;i=i+64|0;t=E+52|0;u=E+48|0;H=E+36|0;x=E+32|0;G=E+20|0;y=E+16|0;F=E+4|0;z=E;A=d+4|0;B=H+4|0;C=b+-1|0;a:do if((jg(c[e>>2]|0)|0)>0){v=(b|0)>1;w=(b|0)>0;D=0;b:while(1){if(((c[A>>2]|0)-(c[d>>2]|0)>>2|0)<(b|0)){j=4;break}h=(c[f>>2]|0)+(D*12|0)|0;c[t>>2]=0;Xs(h,b,t);h=(c[a>>2]|0)+(D*12|0)|0;c[u>>2]=-1;Xs(h,b,u);c[x>>2]=0;ms(H,1,x);h=c[H>>2]|0;c[h>>2]=(c[h>>2]|0)+2;h=0;k=1;l=2;while(1){o=0;j=qa(121,c[e>>2]|0)|0;s=o;o=0;if(s&1){j=11;break b}if((l|0)>=(j|0))break;if(eq(c[e>>2]|0,l,D)|0)if(!k){o=0;ma(148,H|0,((c[B>>2]|0)-(c[H>>2]|0)>>2)+1|0);s=o;o=0;if(s&1){j=11;break b}else{h=h+1|0;k=1}}else k=1;else if(k){o=0;ma(148,H|0,((c[B>>2]|0)-(c[H>>2]|0)>>2)+1|0);s=o;o=0;if(s&1){j=11;break b}else{h=h+1|0;k=0}}else k=0;s=(c[H>>2]|0)+(h<<2)|0;c[s>>2]=(c[s>>2]|0)+1;l=l+1|0}s=h+1|0;o=0;ma(148,H|0,((c[B>>2]|0)-(c[H>>2]|0)>>2)+1|0);r=o;o=0;if(r&1){j=12;break}c[y>>2]=0;o=0;mb(75,G|0,b|0,y|0);r=o;o=0;if(r&1){j=12;break}l=c[G>>2]|0;c[l>>2]=0;p=c[H>>2]|0;q=c[d>>2]|0;if(v&(h|0)>-1){k=1;h=0;j=0;do{h=(c[p+(j<<2)>>2]|0)+h|0;if(+(h|0)>+g[q+(k+-1<<2)>>2]){j=(((j|0)%2|0|0)==1&1)+j|0;h=c[p+(j<<2)>>2]|0;c[l+(k<<2)>>2]=j;k=k+1|0}j=j+1|0}while((k|0)<(b|0)&(j|0)<(s|0))}o=0;ma(169,F|0,b|0);r=o;o=0;if(r&1){j=22;break}if(w){r=0;do{q=(c[F>>2]|0)+(r*12|0)|0;g[z>>2]=0.0;o=0;mb(97,q|0,8,z|0);q=o;o=0;if(q&1){j=31;break b}h=c[G>>2]|0;q=c[h+(r<<2)>>2]|0;if((r|0)==(C|0))h=s;else h=c[h+(r+1<<2)>>2]|0;k=h-q|0;if((k+-7|0)>>>0<=2){h=(k|0)<8?k:8;p=c[H>>2]|0;if((h|0)>0){m=0.0;j=0;do{m=m+ +(c[p+(j+q<<2)>>2]|0);j=j+1|0}while((j|0)<(h|0))}else m=0.0;if((k|0)!=7){l=c[F>>2]|0;h=c[l+(r*12|0)>>2]|0;l=(c[l+(r*12|0)+4>>2]|0)-h|0;j=l>>2;if((l|0)>0){k=0;do{g[h+(k<<2)>>2]=+(c[p+(k+q<<2)>>2]|0)/m;k=k+1|0}while((k|0)<(j|0));p=h}else p=h}else{h=(c[d>>2]|0)+(r<<2)|0;j=(c[F>>2]|0)+(r*12|0)|0;k=c[j>>2]|0;l=0;do{g[k+(l<<2)>>2]=+(c[p+(l+q<<2)>>2]|0)/+g[h>>2];l=l+1|0}while((l|0)<7);n=+g[h>>2];p=c[j>>2]|0;g[p+28>>2]=(n-m)/n}l=c[6943]|0;h=0;m=3402823466385288598117041.0e14;q=0;do{j=q<<3;n=0.0;k=0;while(1){if((k|0)>=8)break;I=+g[l+(k+j<<2)>>2]-+g[p+(k<<2)>>2];n=n+I*I;if(!(n>=m))k=k+1|0;else break}if(n<m){h=c[5276+(q<<2)>>2]|0;m=n}q=q+1|0}while((q|0)!=2787);c[(c[(c[f>>2]|0)+(D*12|0)>>2]|0)+(r<<2)>>2]=h;q=$m(h)|0;c[(c[(c[a>>2]|0)+(D*12|0)>>2]|0)+(r<<2)>>2]=q}r=r+1|0}while((r|0)<(b|0))}Us(F);br(G);br(H);D=D+1|0;if((D|0)>=(jg(c[e>>2]|0)|0))break a}if((j|0)==4){H=Ob(8)|0;zq(H,49693);c[H>>2]=30552;Hc(H|0,856,146)}else if((j|0)==11){h=cc()|0;j=13}else if((j|0)==12){h=cc()|0;j=13}else if((j|0)==22){h=cc()|0;j=49}else if((j|0)==31){h=cc()|0;Us(F);j=49}if((j|0)!=13)if((j|0)==49)br(G);br(H);bc(h|0)}while(0);i=E;return}function Xm(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;z=i;i=i+32|0;A=z+8|0;x=z;ct(b,1);o=0;ma(170,c[b>>2]|0,d|0);y=o;o=0;a:do if(y&1)g=cc()|0;else{c[A+4>>2]=0;t=A+8|0;c[t>>2]=0;c[A>>2]=A+4;u=e+4|0;v=x+4|0;w=b+4|0;b:do if(((c[u>>2]|0)-(c[e>>2]|0)|0)>0){l=0;g=-1;y=0;c:while(1){et(A);s=c[e>>2]|0;if(((c[s+(y*12|0)+4>>2]|0)-(c[s+(y*12|0)>>2]|0)|0)>0){k=0;do{h=(c[(c[f>>2]|0)+(y*12|0)>>2]|0)+(k<<2)|0;if((c[h>>2]|0)!=-1){o=0;h=Wa(105,A|0,h|0)|0;s=o;o=0;if(s&1){h=10;break c}h=c[h>>2]|0;o=0;j=Wa(105,A|0,(c[(c[f>>2]|0)+(y*12|0)>>2]|0)+(k<<2)|0)|0;s=o;o=0;if(s&1){h=10;break c}c[j>>2]=h+1}k=k+1|0;s=c[e>>2]|0}while((k|0)<((c[s+(y*12|0)+4>>2]|0)-(c[s+(y*12|0)>>2]|0)>>2|0))}if(c[t>>2]|0){Ys(x,A);s=(a[x>>0]|0)!=0?g:c[v>>2]|0;h=(g+3|0)%9|0;k=(g|0)!=-1;s=k&(s|0)!=(h|0)?g:s;if(k|(g|0)==-1&(s|0)==0){if(k&(s|0)==(h|0)){j=l+1|0;h=l+2|0;if((((c[w>>2]|0)-(c[b>>2]|0)|0)/12|0|0)<(h|0)){o=0;ma(171,b|0,h|0);r=o;o=0;if(r&1){h=11;break}o=0;ma(170,(c[b>>2]|0)+(j*12|0)|0,d|0);r=o;o=0;if(r&1){h=11;break}}}else j=l;if(k&(s|0)==((g+6|0)%9|0|0)){h=j+2|0;g=j+3|0;if((((c[w>>2]|0)-(c[b>>2]|0)|0)/12|0|0)<(g|0)){o=0;ma(171,b|0,g|0);r=o;o=0;if(r&1){h=11;break}o=0;ma(170,(c[b>>2]|0)+(h*12|0)|0,d|0);r=o;o=0;if(r&1){h=11;break}}}else h=j;l=(s+3|0)%9|0;m=h+2|0;n=h+1|0;p=(s+6|0)%9|0;q=(h|0)>0;r=h+-1|0;k=c[e>>2]|0;g=c[k+(y*12|0)>>2]|0;if(((c[k+(y*12|0)+4>>2]|0)-g|0)>0){k=0;while(1){j=c[(c[(c[f>>2]|0)+(y*12|0)>>2]|0)+(k<<2)>>2]|0;do if((j|0)!=-1){if((j|0)==(s|0)){o=0;g=Wa(105,(c[(c[b>>2]|0)+(h*12|0)>>2]|0)+(k*12|0)|0,g+(k<<2)|0)|0;j=o;o=0;if(j&1){h=9;break c}g=c[g>>2]|0;o=0;j=Wa(105,(c[(c[b>>2]|0)+(h*12|0)>>2]|0)+(k*12|0)|0,(c[(c[e>>2]|0)+(y*12|0)>>2]|0)+(k<<2)|0)|0;B=o;o=0;if(B&1){h=9;break c}c[j>>2]=g+1;break}if((j|0)!=(l|0)){if(!(q&(j|0)==(p|0)))break;o=0;g=Wa(105,(c[(c[b>>2]|0)+(r*12|0)>>2]|0)+(k*12|0)|0,g+(k<<2)|0)|0;B=o;o=0;if(B&1){h=9;break c}g=c[g>>2]|0;o=0;j=Wa(105,(c[(c[b>>2]|0)+(r*12|0)>>2]|0)+(k*12|0)|0,(c[(c[e>>2]|0)+(y*12|0)>>2]|0)+(k<<2)|0)|0;B=o;o=0;if(B&1){h=9;break c}c[j>>2]=g+1;break}j=c[b>>2]|0;if((((c[w>>2]|0)-j|0)/12|0|0)<(m|0)){o=0;ma(171,b|0,m|0);B=o;o=0;if(B&1){h=9;break c}o=0;ma(170,(c[b>>2]|0)+(n*12|0)|0,d|0);B=o;o=0;if(B&1){h=9;break c}j=c[b>>2]|0;g=c[(c[e>>2]|0)+(y*12|0)>>2]|0}o=0;g=Wa(105,(c[j+(n*12|0)>>2]|0)+(k*12|0)|0,g+(k<<2)|0)|0;B=o;o=0;if(B&1){h=9;break c}g=c[g>>2]|0;o=0;j=Wa(105,(c[(c[b>>2]|0)+(n*12|0)>>2]|0)+(k*12|0)|0,(c[(c[e>>2]|0)+(y*12|0)>>2]|0)+(k<<2)|0)|0;B=o;o=0;if(B&1){h=9;break c}c[j>>2]=g+1}while(0);k=k+1|0;B=c[e>>2]|0;g=c[B+(y*12|0)>>2]|0;if((k|0)>=((c[B+(y*12|0)+4>>2]|0)-g>>2|0)){g=s;break}}}else g=s}else{h=l;g=-1}}else h=l;y=y+1|0;if((y|0)>=(((c[u>>2]|0)-(c[e>>2]|0)|0)/12|0|0))break b;else l=h}if((h|0)==9)g=cc()|0;else if((h|0)==10)g=cc()|0;else if((h|0)==11)g=cc()|0;gt(A);break a}while(0);gt(A);i=z;return}while(0);$s(b);bc(g|0)}function Ym(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;x=i;i=i+48|0;s=x+36|0;l=x+32|0;m=x+28|0;p=x+24|0;q=x+20|0;t=x+16|0;u=x+4|0;v=x;c[a>>2]=0;w=a+4|0;c[w>>2]=0;c[a+8>>2]=0;r=d+4|0;e=c[r>>2]|0;f=c[d>>2]|0;a:do if(((e-f|0)/12|0)>>>0>1?(n=a+8|0,(e-f|0)>12):0){k=0;b:while(1){h=c[f+(k*12|0)>>2]|0;j=(c[f+(k*12|0)+4>>2]|0)-h|0;e=j>>2;if((j|0)>0){g=0;do{f=$m(c[h+(g<<2)>>2]|0)|0;g=g+1|0}while((f|0)==-1&(g|0)<(e|0));j=f}else j=-1;do if((k|0)==0&(j|0)>0){c[l>>2]=0;e=c[w>>2]|0;if(e>>>0>=(c[n>>2]|0)>>>0){o=0;ma(172,a|0,l|0);h=o;o=0;if(h&1)break b}else{c[e>>2]=0;c[w>>2]=e+4}if((j|0)>3){c[m>>2]=0;e=c[w>>2]|0;if(e>>>0>=(c[n>>2]|0)>>>0){o=0;ma(172,a|0,m|0);h=o;o=0;if(h&1)break b;else break}else{c[e>>2]=0;c[w>>2]=e+4;break}}}while(0);k=k+1|0;h=c[d>>2]|0;e=c[h+(k*12|0)>>2]|0;h=(c[h+(k*12|0)+4>>2]|0)-e|0;g=h>>2;if((h|0)>0){h=0;do{f=$m(c[e+(h<<2)>>2]|0)|0;h=h+1|0}while((f|0)==-1&(h|0)<(g|0))}else f=-1;do if((f|0)!=-1&((j|0)!=-1?((j+3|0)%9|0|0)!=(f|0):0)){c[p>>2]=k;e=c[w>>2]|0;if(e>>>0>=(c[n>>2]|0)>>>0){o=0;ma(172,a|0,p|0);h=o;o=0;if(h&1)break b}else{c[e>>2]=k;c[w>>2]=e+4}if((j|0)==(f|0)){c[q>>2]=k;e=c[w>>2]|0;if(e>>>0>=(c[n>>2]|0)>>>0){o=0;ma(172,a|0,q|0);j=o;o=0;if(j&1)break b;else break}else{c[e>>2]=k;c[w>>2]=e+4;break}}}while(0);f=c[d>>2]|0;if((k|0)>=((((c[r>>2]|0)-f|0)/12|0)+-1|0)){f=3;break a}}e=cc()|0;f=8}else f=3;while(0);c:do if((f|0)==3){e=c[a>>2]|0;d:do if(((c[w>>2]|0)-e|0)>0){f=0;while(1){c[t>>2]=(c[d>>2]|0)+(((c[e+(f<<2)>>2]|0)+f|0)*12|0);c[v>>2]=0;o=0;mb(75,u|0,b|0,v|0);r=o;o=0;if(r&1){f=6;break}o=0;c[s>>2]=c[t>>2];ya(114,d|0,s|0,u|0)|0;r=o;o=0;if(r&1){f=31;break}br(u);f=f+1|0;e=c[a>>2]|0;if((f|0)>=((c[w>>2]|0)-e>>2|0))break d}if((f|0)==6){e=cc()|0;f=8;break c}else if((f|0)==31){e=cc()|0;br(u);break c}}while(0);i=x;return}while(0);br(a);bc(e|0)}function Zm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0;P=i;i=i+128|0;J=P+120|0;R=P+108|0;Q=P+96|0;S=P+84|0;y=P+80|0;A=P+76|0;z=P+72|0;C=P+68|0;B=P+64|0;D=P+60|0;E=P+56|0;F=P+52|0;G=P+48|0;H=P+44|0;I=P+40|0;x=P+32|0;K=P+24|0;M=P+12|0;N=P+8|0;O=P;c[R+4>>2]=0;c[R+8>>2]=0;c[R>>2]=R+4;c[Q+4>>2]=0;c[Q+8>>2]=0;c[Q>>2]=Q+4;c[S+4>>2]=0;c[S+8>>2]=0;c[S>>2]=S+4;f=c[d>>2]|0;L=d+4|0;e=c[L>>2]|0;if((e|0)!=(f|0)){do e=e+-4|0;while((e|0)!=(f|0));c[L>>2]=e}s=b+4|0;t=x+4|0;u=d+8|0;c[y>>2]=0;a:do if(((c[s>>2]|0)-(c[b>>2]|0)|0)>24){v=0;l=2;w=-1;b:while(1){et(S);e=c[b>>2]|0;f=c[c[e+(v*12|0)>>2]>>2]|0;if(!f)f=-1;else{o=0;f=ya(115,f|0,((f|0)<0)<<31>>31|0,0)|0;r=o;o=0;if(r&1){f=11;break}e=c[b>>2]|0}k=v+1|0;g=c[c[e+(k*12|0)>>2]>>2]|0;if(!g)g=-1;else{o=0;g=ya(115,g|0,((g|0)<0)<<31>>31|0,0)|0;r=o;o=0;if(r&1){f=11;break}e=c[b>>2]|0}h=c[c[e+(l*12|0)>>2]>>2]|0;if(!h)h=-1;else{o=0;h=ya(115,h|0,((h|0)<0)<<31>>31|0,0)|0;r=o;o=0;if(r&1){f=11;break}e=c[b>>2]|0}j=c[e+(v*12|0)>>2]|0;j=c[j+(((c[e+(v*12|0)+4>>2]|0)-j>>2)+-1<<2)>>2]|0;if(!j)r=-1;else{o=0;j=ya(115,j|0,((j|0)<0)<<31>>31|0,0)|0;r=o;o=0;if(r&1){f=11;break}e=c[b>>2]|0;r=j}j=c[e+(k*12|0)>>2]|0;j=c[j+(((c[e+(k*12|0)+4>>2]|0)-j>>2)+-1<<2)>>2]|0;if(!j)j=-1;else{o=0;j=ya(115,j|0,((j|0)<0)<<31>>31|0,0)|0;q=o;o=0;if(q&1){f=11;break}e=c[b>>2]|0}q=c[e+(l*12|0)>>2]|0;e=c[q+(((c[e+(l*12|0)+4>>2]|0)-q>>2)+-1<<2)>>2]|0;if(e){o=0;e=ya(115,e|0,((e|0)<0)<<31>>31|0,0)|0;q=o;o=0;if(q&1){f=11;break}else q=e}else q=-1;l=(f|0)!=-1;m=(g|0)!=-1;if(l&m){e=(g|0)%30|0;c[A>>2]=((e|0)%3|0)+(((f|0)%30|0)*3|0);c[z>>2]=(e|0)/3|0;o=0;e=Wa(105,R|0,A|0)|0;p=o;o=0;if(p&1){f=11;break}e=c[e>>2]|0;o=0;k=Wa(105,R|0,A|0)|0;p=o;o=0;if(p&1){f=11;break}c[k>>2]=e+1;o=0;e=Wa(105,Q|0,z|0)|0;p=o;o=0;if(p&1){f=11;break}e=c[e>>2]|0;o=0;k=Wa(105,Q|0,z|0)|0;p=o;o=0;if(p&1){f=11;break}c[k>>2]=e+1}n=(j|0)!=-1;p=(q|0)!=-1;if(n&p){e=(q|0)%30|0;c[C>>2]=((e|0)%3|0)+(((j|0)%30|0)*3|0);c[B>>2]=(e|0)/3|0;o=0;e=Wa(105,R|0,C|0)|0;k=o;o=0;if(k&1){f=11;break}e=c[e>>2]|0;o=0;k=Wa(105,R|0,C|0)|0;T=o;o=0;if(T&1){f=11;break}c[k>>2]=e+1;o=0;e=Wa(105,Q|0,B|0)|0;T=o;o=0;if(T&1){f=11;break}e=c[e>>2]|0;o=0;k=Wa(105,Q|0,B|0)|0;T=o;o=0;if(T&1){f=11;break}c[k>>2]=e+1}if(l){c[D>>2]=(f|0)/30|0;o=0;e=Wa(105,S|0,D|0)|0;T=o;o=0;if(T&1){f=11;break}e=c[e>>2]|0;o=0;f=Wa(105,S|0,D|0)|0;T=o;o=0;if(T&1){f=11;break}c[f>>2]=e+1}if(m){c[E>>2]=(g|0)/30|0;o=0;e=Wa(105,S|0,E|0)|0;T=o;o=0;if(T&1){f=11;break}e=c[e>>2]|0;o=0;f=Wa(105,S|0,E|0)|0;T=o;o=0;if(T&1){f=11;break}c[f>>2]=e+1}if((h|0)!=-1){c[F>>2]=(h|0)/30|0;o=0;e=Wa(105,S|0,F|0)|0;T=o;o=0;if(T&1){f=11;break}e=c[e>>2]|0;o=0;f=Wa(105,S|0,F|0)|0;T=o;o=0;if(T&1){f=11;break}c[f>>2]=e+1}if((r|0)!=-1){c[G>>2]=(r|0)/30|0;o=0;e=Wa(105,S|0,G|0)|0;T=o;o=0;if(T&1){f=11;break}e=c[e>>2]|0;o=0;f=Wa(105,S|0,G|0)|0;T=o;o=0;if(T&1){f=11;break}c[f>>2]=e+1}if(n){c[H>>2]=(j|0)/30|0;o=0;e=Wa(105,S|0,H|0)|0;T=o;o=0;if(T&1){f=11;break}e=c[e>>2]|0;o=0;f=Wa(105,S|0,H|0)|0;T=o;o=0;if(T&1){f=11;break}c[f>>2]=e+1}if(p){c[I>>2]=(q|0)/30|0;o=0;e=Wa(105,S|0,I|0)|0;T=o;o=0;if(T&1){f=11;break}e=c[e>>2]|0;o=0;f=Wa(105,S|0,I|0)|0;T=o;o=0;if(T&1){f=11;break}c[f>>2]=e+1}Ys(x,S);e=w;w=c[t>>2]|0;e=e+1|0;if((e|0)<(w|0))do{f=c[L>>2]|0;g=c[u>>2]|0;if((f|0)==(g|0)){o=0;ma(173,d|0,y|0);T=o;o=0;if(T&1){f=10;break b}h=c[L>>2]|0;f=c[u>>2]|0}else{c[f>>2]=v;h=f+4|0;c[L>>2]=h;f=g}if((h|0)==(f|0)){o=0;ma(173,d|0,y|0);T=o;o=0;if(T&1){f=10;break b}g=c[L>>2]|0;f=c[u>>2]|0}else{c[h>>2]=v;g=h+4|0;c[L>>2]=g}if((g|0)==(f|0)){o=0;ma(173,d|0,y|0);T=o;o=0;if(T&1){f=10;break b}}else{c[g>>2]=v;c[L>>2]=g+4}e=e+1|0}while((e|0)<(w|0));l=v;v=v+3|0;c[y>>2]=v;l=l+5|0;if((l|0)>=(((c[s>>2]|0)-(c[b>>2]|0)|0)/12|0|0)){f=5;break a}}if((f|0)==10){e=cc()|0;f=12;break}else if((f|0)==11){e=cc()|0;f=12;break}}else f=5;while(0);c:do if((f|0)==5){e=c[d>>2]|0;d:do if(((c[L>>2]|0)-e|0)>0){f=0;while(1){c[K>>2]=(c[b>>2]|0)+(((c[e+(f<<2)>>2]|0)+f|0)*12|0);c[N>>2]=0;o=0;mb(75,M|0,a|0,N|0);T=o;o=0;if(T&1){f=9;break}o=0;c[J>>2]=c[K>>2];ya(114,b|0,J|0,M|0)|0;T=o;o=0;if(T&1){f=80;break}br(M);f=f+1|0;e=c[d>>2]|0;if((f|0)>=((c[L>>2]|0)-e>>2|0))break d}if((f|0)==9){e=cc()|0;f=12;break c}else if((f|0)==80){e=cc()|0;br(M);break c}}while(0);Ys(O,R);T=(c[O+4>>2]|0)+1|0;gt(S);gt(Q);gt(R);i=P;return T|0}while(0);gt(S);gt(Q);gt(R);bc(e|0);return 0}function _m(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;h=a+4|0;d=c[a>>2]|0;if(((c[h>>2]|0)-d|0)>0){g=0;do{if(((c[d+(g*12|0)+4>>2]|0)-(c[d+(g*12|0)>>2]|0)|0)>0){f=0;do{d=f*17|0;e=0;do{if((c[(c[(c[a>>2]|0)+(g*12|0)>>2]|0)+(f<<2)>>2]&1<<16-e|0)>0)Xd(c[b>>2]|0,e+d|0,g);e=e+1|0}while((e|0)!=17);f=f+1|0;d=c[a>>2]|0}while((f|0)<((c[d+(g*12|0)+4>>2]|0)-(c[d+(g*12|0)>>2]|0)>>2|0))}g=g+1|0}while((g|0)<(((c[h>>2]|0)-d|0)/12|0|0))}return}function $m(a){a=a|0;var b=0,c=0,d=0,e=0;if(!a)b=-1;else{c=0;d=1;b=0;e=0;do{do if((1<<e&a|0)>0){c=(d&1^1)+c|0;if(!(c&1)){d=1;b=b+1|0;break}else{d=1;b=b+-1|0;break}}else d=0;while(0);e=e+1|0}while((e|0)!=17);b=(b+9|0)%9|0}return b|0}function an(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;t=i;i=i+80|0;n=t+76|0;p=t+72|0;z=t+68|0;y=t+64|0;e=t+60|0;x=t+56|0;v=t+44|0;k=t+40|0;l=t+36|0;m=t+32|0;u=t+28|0;q=t+16|0;r=t+4|0;s=t;c[z>>2]=0;dq(z,0);_d(e,b);o=0;ma(174,y|0,e|0);g=o;o=0;if(g&1){y=cc()|0;ce(e);e=y}else{ce(e);o=0;f=Wa(106,y|0,d|0)|0;g=o;o=0;if(g&1)e=cc()|0;else{c[x>>2]=f;o=0;ma(85,v|0,f|0);g=o;o=0;if(g&1)e=cc()|0;else{a:do if(c[d>>2]|0){o=0;g=qa(145,d|0)|0;b=o;o=0;if(b&1)w=13;else{c[k>>2]=g;b:do if((g|0)!=0?(j=v+8|0,b=c[j>>2]|0,h=c[b+8>>2]|0,((c[b+12>>2]|0)-h|0)>0):0){e=h;b=0;while(1){o=0;ma(c[(c[g>>2]|0)+8>>2]|0,g|0,c[e+(b<<2)>>2]|0);h=o;o=0;if(h&1)break;b=b+1|0;h=c[j>>2]|0;e=c[h+8>>2]|0;if((b|0)>=((c[h+12>>2]|0)-e>>2|0))break b}e=cc()|0;ze(k);break a}while(0);ze(k);w=16}}else w=16;while(0);do if((w|0)==16){o=0;e=qa(118,f|0)|0;k=o;o=0;if(!(k&1)){c[m>>2]=e;o=0;e=ya(116,a+8|0,m|0,d|0)|0;a=o;o=0;if(a&1){e=cc()|0;Yd(m);break}c[l>>2]=e;dq(z,e);aq(l);Yd(m);o=0;f=qa(111,40)|0;m=o;o=0;if(!(m&1)){e=c[z>>2]|0;o=0;b=qa(116,e|0)|0;m=o;o=0;if(m&1)e=cc()|0;else{c[u>>2]=b;o=0;ma(86,q|0,e|0);m=o;o=0;do if(!(m&1)){oe(r,v);c[s>>2]=11;o=0;c[n>>2]=c[s>>2];ia(45,f|0,u|0,q|0,r|0,n|0);s=o;o=0;if(s&1){e=cc()|0;pe(r);Sd(q);break}else{c[p>>2]=0;Qe(p,f);pe(r);Sd(q);ne(u);pe(v);ir(x);ce(y);aq(z);i=t;return c[p>>2]|0}}else e=cc()|0;while(0);ne(u)}Uz(f)}else w=13}else w=13}while(0);if((w|0)==13)e=cc()|0;pe(v)}ir(x)}ce(y)}aq(z);bc(e|0);return 0}function bn(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;return (eq(c[a+8>>2]|0,b,d)|0)&1|e<<1|0}function cn(a,b){a=a|0;b=b|0;var d=0,e=0;c[a+4>>2]=0;c[a>>2]=34212;e=a+8|0;Zp(e,b);c[a+12>>2]=0;d=a+16|0;c[d>>2]=0;kt(d,0);o=0;a=qa(122,c[b>>2]|0)|0;b=o;o=0;do if(!(b&1))if(a>>>0>20&(a&3|0)==1)return;else{b=Ob(8)|0;zq(b,49738);c[b>>2]=29736;o=0;mb(55,b|0,24,146);o=0;break}while(0);b=cc()|0;lt(d);Yd(e);bc(b|0)}function dn(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;l=i;i=i+16|0;f=l+4|0;g=l;j=a+16|0;do if(!(c[j>>2]|0)){h=bn(a,8,0,bn(a,8,1,bn(a,8,2,bn(a,8,3,bn(a,8,4,bn(a,8,5,bn(a,8,7,bn(a,8,8,bn(a,7,8,bn(a,5,8,bn(a,4,8,bn(a,3,8,bn(a,2,8,bn(a,1,8,bn(a,0,8,0)|0)|0)|0)|0)|0)|0)|0)|0)|0)|0)|0)|0)|0)|0)|0;k=jg(c[a+8>>2]|0)|0;d=k+-6|0;b=0;e=k;do{m=e;e=e+-1|0;b=bn(a,8,e,b)|0}while((m|0)>(d|0));m=k+-8|0;k=m+1|0;e=k+1|0;d=e+1|0;n=d+1|0;o=n+1|0;p=o+1|0;m=Ao(h,bn(a,p+1|0,8,bn(a,p,8,bn(a,o,8,bn(a,n,8,bn(a,d,8,bn(a,e,8,bn(a,k,8,bn(a,m,8,b)|0)|0)|0)|0)|0)|0)|0)|0)|0;c[g>>2]=m;kt(j,m);lt(g);if(!(c[j>>2]|0)){p=Ob(8)|0;zq(p,49774);c[p>>2]=29736;Hc(p|0,24,146)}else{mt(f,j);break}}else mt(f,j);while(0);i=l;return c[f>>2]|0}function en(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0;i=a+12|0;b=c[i>>2]|0;do if(!b){h=jg(c[a+8>>2]|0)|0;b=h+-17>>2;if((b|0)<7){b=Vo(b)|0;break}g=h+-9|0;d=g+-1|0;e=d+-1|0;b=0;f=5;while(1){b=bn(a,e,f,bn(a,d,f,bn(a,g,f,b)|0)|0)|0;if((f|0)>0)f=f+-1|0;else break}b=Zo(b)|0;c[i>>2]=b;if((b|0)!=0?(So(b)|0)==(h|0):0){b=c[i>>2]|0;break}d=g+-1|0;e=d+-1|0;b=0;f=5;while(1){b=bn(a,f,e,bn(a,f,d,bn(a,f,g,b)|0)|0)|0;if((f|0)>0)f=f+-1|0;else break}b=Zo(b)|0;c[i>>2]=b;if((b|0)!=0?(So(b)|0)==(h|0):0){b=c[i>>2]|0;break}i=Ob(8)|0;zq(i,49810);c[i>>2]=29736;Hc(i|0,24,146)}while(0);return b|0}function fn(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;v=i;i=i+16|0;x=v+4|0;w=v;e=dn(d)|0;c[x>>2]=e;o=0;u=qa(169,d|0)|0;q=o;o=0;if(((((!(q&1)?(o=0,f=qa(170,e|0)|0,q=o,o=0,!(q&1)):0)?(o=0,g=qa(171,f<<24>>24|0)|0,q=o,o=0,!(q&1)):0)?(r=d+8|0,o=0,s=qa(122,c[r>>2]|0)|0,q=o,o=0,!(q&1)):0)?(o=0,mb(98,g|0,c[r>>2]|0,s|0),q=o,o=0,!(q&1)):0)?(o=0,t=qa(172,u|0)|0,q=o,o=0,!(q&1)):0){c[w>>2]=t;o=0;e=qa(173,u|0)|0;q=o;o=0;if(!(q&1)?(o=0,ma(87,b|0,e|0),q=o,o=0,!(q&1)):0){m=s+-1|0;n=b+8|0;if((s|0)>1){p=(s|0)>0;g=0;d=0;q=1;f=0;e=m;while(1){l=(((e|0)==6)<<31>>31)+e|0;if(p){k=0;e=d;do{j=q?m-k|0:k;h=0;do{d=l-h|0;if(!(eq(t,d,j)|0)){g=g+1|0;e=(eq(c[r>>2]|0,d,j)|0)&1|e<<1;if((g|0)==8){a[(c[(c[n>>2]|0)+8>>2]|0)+f>>0]=e;g=0;e=0;f=f+1|0}}h=h+1|0}while((h|0)!=2);k=k+1|0}while((k|0)<(s|0))}else e=d;if((l|0)>2){d=e;q=q^1;e=l+-2|0}else break}}else f=0;o=0;e=qa(173,u|0)|0;u=o;o=0;do if(!(u&1))if((f|0)==(e|0)){Yd(w);lt(x);i=v;return}else{v=Ob(8)|0;zq(v,49835);c[v>>2]=29736;o=0;mb(55,v|0,24,146);o=0;break}while(0);e=cc()|0;Sd(b)}else e=cc()|0;Yd(w)}else e=cc()|0;lt(x);bc(e|0)}function gn(a,b,d){a=a|0;b=b|0;d=d|0;c[a+4>>2]=0;c[a>>2]=34228;c[a+8>>2]=b;Pd(a+12|0,d);return}function hn(a){a=a|0;return c[a+8>>2]|0}function jn(a,b){a=a|0;b=b|0;Pd(a,b+12|0);return}function kn(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;w=i;i=i+48|0;x=w+28|0;p=w+16|0;n=w+12|0;m=w;q=To(e,f)|0;nt(x,Mo(q)|0);l=x+4|0;f=c[x>>2]|0;a:do if((c[l>>2]|0)==(f|0)){f=0;u=7}else{g=0;e=0;while(1){o=0;f=qa(174,c[f+(g<<2)>>2]|0)|0;u=o;o=0;if(u&1)break;e=f+e|0;g=g+1|0;f=c[x>>2]|0;if(g>>>0>=(c[l>>2]|0)-f>>2>>>0){f=e;u=7;break a}}f=cc()|0;u=6}while(0);do if((u|0)==7){o=0;ma(175,b|0,f|0);u=o;o=0;if(u&1){f=cc()|0;u=6;break}f=c[x>>2]|0;b:do if((c[l>>2]|0)!=(f|0)){k=0;e=0;c:while(1){h=c[f+(k<<2)>>2]|0;j=0;while(1){o=0;f=qa(174,h|0)|0;u=o;o=0;if(u&1){u=17;break c}if((j|0)>=(f|0))break;o=0;g=qa(175,h|0)|0;u=o;o=0;if(u&1){u=17;break c}o=0;f=qa(176,q|0)|0;u=o;o=0;if(u&1){u=17;break c}o=0;ma(87,p|0,f+g|0);u=o;o=0;if(u&1){u=17;break c}o=0;f=qa(111,24)|0;u=o;o=0;if(u&1){u=20;break c}Pd(m,p);gn(f,g,m);c[n>>2]=0;pt(n,f);Sd(m);pt((c[b>>2]|0)+(e<<2)|0,c[n>>2]|0);qt(n);Sd(p);j=j+1|0;e=e+1|0}k=k+1|0;f=c[x>>2]|0;if(k>>>0>=(c[l>>2]|0)-f>>2>>>0){u=22;break b}}if((u|0)==17){f=cc()|0;u=19;break}else if((u|0)==20){f=cc()|0;Sd(p);break}}else{e=0;u=22}while(0);d:do if((u|0)==22){f=c[b>>2]|0;t=c[(c[f>>2]|0)+20>>2]|0;s=c[t+12>>2]|0;t=c[t+8>>2]|0;l=s-t|0;g=l+1|0;j=(c[b+4>>2]|0)-f>>2;while(1){k=j;j=j+-1|0;if((k|0)<=0){u=29;break}h=c[(c[f+(j<<2)>>2]|0)+20>>2]|0;h=(c[h+12>>2]|0)-(c[h+8>>2]|0)|0;if((h|0)==(l|0)){u=29;break}if((h|0)!=(g|0)){u=26;break}}do if((u|0)==26){f=Ob(8)|0;o=0;ma(103,f|0,49862);w=o;o=0;if(w&1){w=cc()|0;Nb(f|0);f=w;break d}else{o=0;mb(55,f|0,240,66);o=0;break}}else if((u|0)==29?(o=0,v=qa(176,q|0)|0,r=o,o=0,!(r&1)):0){q=l-v|0;d=d+8|0;r=(e|0)>0?e:0;m=(q|0)>0?q:0;if((q|0)>0){f=(e|0)>0;g=0;j=0;while(1){if(f){h=0;l=j;while(1){a[(c[(c[(c[(c[b>>2]|0)+(h<<2)>>2]|0)+20>>2]|0)+8>>2]|0)+g>>0]=a[(c[(c[d>>2]|0)+8>>2]|0)+l>>0]|0;h=h+1|0;if((h|0)>=(e|0))break;else l=l+1|0}}g=g+1|0;if((g|0)>=(q|0))break;else j=r+j|0}}f=$(r,m)|0;g=f+((k|0)>(e|0)?k:e)|0;if((k|0)<(e|0)){h=k;while(1){a[(c[(c[(c[(c[b>>2]|0)+(h<<2)>>2]|0)+20>>2]|0)+8>>2]|0)+q>>0]=a[(c[(c[d>>2]|0)+8>>2]|0)+f>>0]|0;h=h+1|0;if((h|0)>=(e|0))break;else f=f+1|0}}n=g-k|0;p=c[(c[c[b>>2]>>2]|0)+20>>2]|0;p=(c[p+12>>2]|0)-(c[p+8>>2]|0)|0;l=$(r,t+v+((q|0)>(p|0)?q:p)-s|0)|0;if((q|0)<(p|0)){m=(e|0)>0;f=q;h=n;while(1){if(m){g=0;j=h;while(1){a[(c[(c[(c[(c[b>>2]|0)+(g<<2)>>2]|0)+20>>2]|0)+8>>2]|0)+(((g|0)>=(k|0)&1)+f)>>0]=a[(c[(c[d>>2]|0)+8>>2]|0)+j>>0]|0;g=g+1|0;if((g|0)>=(e|0))break;else j=j+1|0}}f=f+1|0;if((f|0)>=(p|0))break;else h=r+h|0}}v=c[d>>2]|0;if((n+l|0)==((c[v+12>>2]|0)-(c[v+8>>2]|0)|0)){rt(x);i=w;return}f=Ob(8)|0;o=0;ma(103,f|0,49901);w=o;o=0;if(w&1){w=cc()|0;Nb(f|0);f=w;break d}else{o=0;mb(55,f|0,240,66);o=0;break}}while(0);f=cc()|0;u=19}while(0);st(b)}while(0);rt(x);bc(f|0)}function ln(){var a=0,b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;m=i;i=i+32|0;a=m+28|0;d=m+24|0;f=m+20|0;g=m+16|0;h=m+12|0;j=m+8|0;k=m+4|0;l=m;b=Sz(8)|0;n=b;c[n>>2]=0;c[n+4>>2]=0;c[b+4>>2]=0;c[b>>2]=34244;c[a>>2]=0;tt(a,b);b=c[6953]|0;if(b>>>0>=(c[6954]|0)>>>0){o=0;ma(176,27808,a|0);n=o;o=0;if(n&1){n=cc()|0;vt(a);a=n}else e=4}else{c[b>>2]=0;tt(b,c[a>>2]|0);c[6953]=(c[6953]|0)+4;e=4}do if((e|0)==4){vt(a);a=Sz(8)|0;n=a;c[n>>2]=0;c[n+4>>2]=0;c[a+4>>2]=0;c[a>>2]=34264;c[d>>2]=0;tt(d,a);a=c[6953]|0;if(a>>>0>=(c[6954]|0)>>>0){o=0;ma(176,27808,d|0);n=o;o=0;if(n&1){a=cc()|0;vt(d);break}}else{c[a>>2]=0;tt(a,c[d>>2]|0);c[6953]=(c[6953]|0)+4}vt(d);a=Sz(8)|0;n=a;c[n>>2]=0;c[n+4>>2]=0;c[a+4>>2]=0;c[a>>2]=34284;c[f>>2]=0;tt(f,a);a=c[6953]|0;if(a>>>0>=(c[6954]|0)>>>0){o=0;ma(176,27808,f|0);n=o;o=0;if(n&1){a=cc()|0;vt(f);break}}else{c[a>>2]=0;tt(a,c[f>>2]|0);c[6953]=(c[6953]|0)+4}vt(f);a=Sz(8)|0;n=a;c[n>>2]=0;c[n+4>>2]=0;c[a+4>>2]=0;c[a>>2]=34304;c[g>>2]=0;tt(g,a);a=c[6953]|0;if(a>>>0>=(c[6954]|0)>>>0){o=0;ma(176,27808,g|0);n=o;o=0;if(n&1){a=cc()|0;vt(g);break}}else{c[a>>2]=0;tt(a,c[g>>2]|0);c[6953]=(c[6953]|0)+4}vt(g);a=Sz(8)|0;n=a;c[n>>2]=0;c[n+4>>2]=0;c[a+4>>2]=0;c[a>>2]=34324;c[h>>2]=0;tt(h,a);a=c[6953]|0;if(a>>>0>=(c[6954]|0)>>>0){o=0;ma(176,27808,h|0);n=o;o=0;if(n&1){a=cc()|0;vt(h);break}}else{c[a>>2]=0;tt(a,c[h>>2]|0);c[6953]=(c[6953]|0)+4}vt(h);a=Sz(8)|0;n=a;c[n>>2]=0;c[n+4>>2]=0;c[a+4>>2]=0;c[a>>2]=34344;c[j>>2]=0;tt(j,a);a=c[6953]|0;if(a>>>0>=(c[6954]|0)>>>0){o=0;ma(176,27808,j|0);n=o;o=0;if(n&1){a=cc()|0;vt(j);break}}else{c[a>>2]=0;tt(a,c[j>>2]|0);c[6953]=(c[6953]|0)+4}vt(j);a=Sz(8)|0;n=a;c[n>>2]=0;c[n+4>>2]=0;c[a+4>>2]=0;c[a>>2]=34364;c[k>>2]=0;tt(k,a);a=c[6953]|0;if(a>>>0>=(c[6954]|0)>>>0){o=0;ma(176,27808,k|0);n=o;o=0;if(n&1){a=cc()|0;vt(k);break}}else{c[a>>2]=0;tt(a,c[k>>2]|0);c[6953]=(c[6953]|0)+4}vt(k);a=Sz(8)|0;n=a;c[n>>2]=0;c[n+4>>2]=0;c[a+4>>2]=0;c[a>>2]=34384;c[l>>2]=0;tt(l,a);a=c[6953]|0;if(a>>>0>=(c[6954]|0)>>>0){o=0;ma(176,27808,l|0);n=o;o=0;if(n&1){a=cc()|0;vt(l);break}}else{c[a>>2]=0;tt(a,c[l>>2]|0);c[6953]=(c[6953]|0)+4}vt(l);i=m;return (c[6953]|0)-(c[6952]|0)>>2|0}while(0);bc(a|0);return 0}function mn(a){a=a|0;var b=0;if(a>>>0<=7)return c[(c[6952]|0)+(a<<2)>>2]|0;a=Ob(8)|0;o=0;ma(103,a|0,49943);b=o;o=0;if(b&1){b=cc()|0;Nb(a|0);bc(b|0)}else Hc(a|0,240,66);return 0}function nn(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;if(d){e=(d|0)==0;g=0;do{if(!e){f=0;do{if(fd[c[(c[a>>2]|0)+8>>2]&127](a,g,f)|0)gg(b,f,g);f=f+1|0}while((f|0)!=(d|0))}g=g+1|0}while((g|0)!=(d|0))}return}function on(a){a=a|0;return}function pn(b,d,e){b=b|0;d=d|0;e=e|0;var f=0;e=a[d>>0]|0;f=(e&1)==0;RC(b,f?d+1|0:c[d+8>>2]|0,f?(e&255)>>>1:c[d+4>>2]|0)|0;return}function qn(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0;f=c[b>>2]|0;do if((e*13|0)>(lg(f)|0)){b=Ob(8)|0;o=0;ka(308,b|0);i=o;o=0;if(i&1){i=cc()|0;Nb(b|0);break}else Hc(b|0,320,76)}else{g=e<<1;h=Tz(g)|0;if((e|0)>0){b=e;e=0;while(1){j=kg(f,13)|0;j=((j|0)/96|0)<<8|((j|0)%96|0);j=((j|0)<959?41377:42657)+j|0;a[h+e>>0]=j>>>8;a[h+(e|1)>>0]=j;if((b|0)>1){b=b+-1|0;e=e+2|0}else break}}o=0;ya(90,d|0,h|0,g|0)|0;j=o;o=0;if(!(j&1)){Vz(h);return}b=cc(24)|0;j=D;if((j|0)==(Xb(24)|0)){fc(b|0)|0;Vz(h);b=Ob(8)|0;o=0;ka(308,b|0);j=o;o=0;if(j&1){j=cc()|0;Nb(b|0);b=j}else{o=0;mb(55,b|0,320,76);o=0;b=cc()|0}o=0;ob(44);j=o;o=0;if(j&1){j=cc(0)|0;oq(j)}else i=b}else i=b}while(0);bc(i|0)}function rn(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0;g=e<<1;h=Tz(g)|0;if((e|0)>0){f=0;while(1){j=kg(c[b>>2]|0,13)|0;j=((j|0)/192|0)<<8|((j|0)%192|0);j=((j|0)<7936?33088:49472)+j|0;a[h+f>>0]=j>>>8;a[h+(f|1)>>0]=j;if((e|0)>1){e=e+-1|0;f=f+2|0}else break}}o=0;ya(90,d|0,h|0,g|0)|0;j=o;o=0;if(!(j&1)){Vz(h);return}e=cc(24)|0;j=D;if((j|0)==(Xb(24)|0)){fc(e|0)|0;Vz(h);e=Ob(8)|0;o=0;ka(308,e|0);j=o;o=0;if(j&1){j=cc()|0;Nb(e|0);e=j}else{o=0;mb(55,e|0,320,76);o=0;e=cc()|0}o=0;ob(44);j=o;o=0;if(j&1){j=cc(0)|0;oq(j)}else i=e}else i=e;bc(i|0)}function sn(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;r=i;i=i+48|0;t=r+24|0;s=r+12|0;n=r;b=c[b>>2]|0;do if((e<<3|0)>(lg(b)|0)){j=Ob(8)|0;o=0;ka(308,j|0);t=o;o=0;if(t&1){t=cc()|0;Nb(j|0);j=t;break}else Hc(j|0,320,76)}else{Rd(t,e);p=c[(c[t+8>>2]|0)+8>>2]|0;a:do if((e|0)>0){l=0;while(1){o=0;k=Wa(107,b|0,8)|0;u=o;o=0;if(u&1)break;a[p+l>>0]=k;l=l+1|0;if((l|0)>=(e|0)){q=9;break a}}j=cc()|0}else q=9;while(0);if((q|0)==9){c[s>>2]=0;c[s+4>>2]=0;c[s+8>>2]=0;o=0;do if(!f){Vh(n,p,e,h);u=o;o=0;if(!(u&1)){if(!(a[s>>0]&1)){a[s+1>>0]=0;a[s>>0]=0}else{a[c[s+8>>2]>>0]=0;c[s+4>>2]=0}o=0;ma(114,s|0,0);u=o;o=0;if(u&1){u=cc(0)|0;oq(u)}else{c[s>>2]=c[n>>2];c[s+4>>2]=c[n+4>>2];c[s+8>>2]=c[n+8>>2];c[n>>2]=0;c[n+4>>2]=0;c[n+8>>2]=0;IC(n);q=20;break}}else q=17}else{b=pg(f)|0;u=o;o=0;if(!(u&1)?(o=0,Wa(108,s|0,b|0)|0,u=o,o=0,!(u&1)):0)q=20;else q=17}while(0);do if((q|0)==20){o=0;ya(90,d|0,p|0,e|0)|0;u=o;o=0;if(!(u&1)){j=c[g+8>>2]|0;b=j+12|0;k=c[b>>2]|0;if((k|0)==(c[j+16>>2]|0)){o=0;ma(177,j+8|0,t|0);u=o;o=0;if(u&1){q=17;break}}else{Pd(k,t);c[b>>2]=(c[b>>2]|0)+12}IC(s);Sd(t);i=r;return}b=cc(24)|0;u=D;if((u|0)==(Xb(24)|0)){fc(b|0)|0;b=Ob(8)|0;o=0;ka(308,b|0);u=o;o=0;if(u&1){u=cc()|0;Nb(b|0);b=u}else{o=0;mb(55,b|0,320,76);o=0;b=cc()|0}o=0;ob(44);u=o;o=0;if(u&1){u=cc(0)|0;oq(u)}else j=b}else j=b}while(0);if((q|0)==17)j=cc()|0;IC(s)}Sd(t)}while(0);bc(j|0)}function tn(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;k=i;i=i+464|0;s=k+452|0;m=k+304|0;l=k+440|0;q=k+152|0;n=k+288|0;r=k+16|0;p=k;t=Tz((e|0)>-1?e:-1)|0;a:do if((e|0)>2){f=e;h=0;while(1){if((lg(c[b>>2]|0)|0)<10){u=3;break}g=kg(c[b>>2]|0,10)|0;if((g|0)>999)break;a[t+h>>0]=a[46777+((g|0)/100|0)>>0]|0;a[t+(h+1)>>0]=a[46777+(((g|0)/10|0|0)%10|0)>>0]|0;j=h+3|0;a[t+(h+2)>>0]=a[46777+((g|0)%10|0)>>0]|0;f=f+-3|0;if((f|0)>2)h=j;else{g=j;u=21;break a}}if((u|0)==3){Vz(t);u=Ob(8)|0;zq(u,49977);c[u>>2]=29736;Hc(u|0,24,146)}h=m+56|0;j=m+4|0;c[m>>2]=29792;c[h>>2]=29812;o=0;ma(104,m+56|0,j|0);r=o;o=0;if(r&1)f=cc()|0;else{c[m+128>>2]=0;c[m+132>>2]=-1;c[m>>2]=29832;c[m+56>>2]=29852;o=0;ka(307,j|0);r=o;o=0;do if(r&1)f=cc()|0;else{c[j>>2]=29868;f=m+36|0;c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;c[m+48>>2]=0;c[m+52>>2]=16;c[s>>2]=0;c[s+4>>2]=0;c[s+8>>2]=0;o=0;ma(105,j|0,s|0);r=o;o=0;if(r&1){u=cc()|0;IC(s);IC(f);nD(j);f=u;break}IC(s);o=0;f=Wa(66,m|0,49994)|0;s=o;o=0;do if(!(s&1)?(o=0,Wa(63,f|0,g|0)|0,s=o,o=0,!(s&1)):0){Vz(t);f=Ob(8)|0;o=0;ma(106,l|0,j|0);t=o;o=0;if(t&1){t=cc()|0;Nb(f|0);f=t;break}else{zq(f,(a[l>>0]&1)==0?l+1|0:c[l+8>>2]|0);c[f>>2]=29736;o=0;mb(55,f|0,24,146);o=0;f=cc()|0;IC(l);break}}else u=17;while(0);if((u|0)==17)f=cc()|0;Nq(m);break a}while(0)}iD(h);bc(f|0)}else{f=e;g=0;u=21}while(0);b:do if((u|0)==21){c:do switch(f|0){case 2:{if((lg(c[b>>2]|0)|0)<7){Vz(t);u=Ob(8)|0;zq(u,49977);c[u>>2]=29736;Hc(u|0,24,146)}j=kg(c[b>>2]|0,7)|0;if((j|0)<=99){a[t+g>>0]=a[46777+((j|0)/10|0)>>0]|0;a[t+(g+1)>>0]=a[46777+((j|0)%10|0)>>0]|0;break c}g=q+56|0;h=q+4|0;c[q>>2]=29792;c[g>>2]=29812;o=0;ma(104,q+56|0,h|0);r=o;o=0;if(r&1)f=cc()|0;else{c[q+128>>2]=0;c[q+132>>2]=-1;c[q>>2]=29832;c[q+56>>2]=29852;o=0;ka(307,h|0);r=o;o=0;do if(r&1)f=cc()|0;else{c[h>>2]=29868;f=q+36|0;c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;c[q+48>>2]=0;c[q+52>>2]=16;c[s>>2]=0;c[s+4>>2]=0;c[s+8>>2]=0;o=0;ma(105,h|0,s|0);r=o;o=0;if(r&1){u=cc()|0;IC(s);IC(f);nD(h);f=u;break}IC(s);o=0;f=Wa(66,q|0,50027)|0;s=o;o=0;do if(!(s&1)?(o=0,Wa(63,f|0,j|0)|0,s=o,o=0,!(s&1)):0){Vz(t);f=Ob(8)|0;o=0;ma(106,n|0,h|0);t=o;o=0;if(t&1){t=cc()|0;Nb(f|0);f=t;break}else{zq(f,(a[n>>0]&1)==0?n+1|0:c[n+8>>2]|0);c[f>>2]=29736;o=0;mb(55,f|0,24,146);o=0;f=cc()|0;IC(n);break}}else u=37;while(0);if((u|0)==37)f=cc()|0;Nq(q);break b}while(0)}iD(g);bc(f|0)}case 1:{if((lg(c[b>>2]|0)|0)<4){Vz(t);u=Ob(8)|0;zq(u,49977);c[u>>2]=29736;Hc(u|0,24,146)}j=kg(c[b>>2]|0,4)|0;if((j|0)<=9){a[t+g>>0]=a[46777+j>>0]|0;break c}g=r+56|0;h=r+4|0;c[r>>2]=29792;c[g>>2]=29812;o=0;ma(104,r+56|0,h|0);q=o;o=0;if(q&1)f=cc()|0;else{c[r+128>>2]=0;c[r+132>>2]=-1;c[r>>2]=29832;c[r+56>>2]=29852;o=0;ka(307,h|0);q=o;o=0;do if(q&1)f=cc()|0;else{c[h>>2]=29868;f=r+36|0;c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;c[r+48>>2]=0;c[r+52>>2]=16;c[s>>2]=0;c[s+4>>2]=0;c[s+8>>2]=0;o=0;ma(105,h|0,s|0);q=o;o=0;if(q&1){u=cc()|0;IC(s);IC(f);nD(h);f=u;break}IC(s);o=0;f=Wa(66,r|0,50060)|0;s=o;o=0;do if(!(s&1)?(o=0,Wa(63,f|0,j|0)|0,s=o,o=0,!(s&1)):0){Vz(t);f=Ob(8)|0;o=0;ma(106,p|0,h|0);t=o;o=0;if(t&1){t=cc()|0;Nb(f|0);f=t;break}else{zq(f,(a[p>>0]&1)==0?p+1|0:c[p+8>>2]|0);c[f>>2]=29736;o=0;mb(55,f|0,24,146);o=0;f=cc()|0;IC(p);break}}else u=56;while(0);if((u|0)==56)f=cc()|0;Nq(r);break b}while(0)}iD(g);bc(f|0)}default:{}}while(0);RC(d,t,e)|0;Vz(t);i=k;return}while(0);bc(f|0)}function un(b){b=b|0;var c=0;if(b>>>0<=44)return a[46777+b>>0]|0;b=Ob(8)|0;o=0;ka(308,b|0);c=o;o=0;if(c&1){c=cc()|0;Nb(b|0);bc(c|0)}else Hc(b|0,320,76);return 0}function vn(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0;r=i;i=i+320|0;l=r+300|0;u=r+152|0;s=r+288|0;q=r+16|0;n=r;j=c[b>>2]|0;h=u+56|0;k=u+4|0;c[u>>2]=29792;c[h>>2]=29812;o=0;ma(104,u+56|0,k|0);m=o;o=0;if(m&1)g=cc()|0;else{c[u+128>>2]=0;c[u+132>>2]=-1;c[u>>2]=29832;c[u+56>>2]=29852;o=0;ka(307,k|0);m=o;o=0;do if(m&1)g=cc()|0;else{c[k>>2]=29868;b=u+36|0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;c[u+48>>2]=0;c[u+52>>2]=16;c[l>>2]=0;c[l+4>>2]=0;c[l+8>>2]=0;o=0;ma(105,k|0,l|0);m=o;o=0;if(m&1){g=cc()|0;IC(l);IC(b);nD(k);break}IC(l);a:do if((e|0)>1){b=e;while(1){o=0;e=qa(140,j|0)|0;m=o;o=0;if(m&1){t=14;break}if((e|0)<11)break;o=0;e=Wa(107,j|0,11)|0;m=o;o=0;if(m&1){t=14;break}o=0;h=qa(177,(e|0)/45|0|0)|0;m=o;o=0;if(m&1){t=14;break}o=0;Wa(109,u|0,h|0)|0;m=o;o=0;if(m&1){t=14;break}o=0;e=qa(177,(e|0)%45|0|0)|0;m=o;o=0;if(m&1){t=14;break}o=0;Wa(109,u|0,e|0)|0;m=o;o=0;if(m&1){t=14;break}b=b+-2|0;if((b|0)<=1){t=24;break a}}if((t|0)==14){g=cc()|0;t=16;break}g=Ob(8)|0;o=0;ka(308,g|0);s=o;o=0;if(s&1){s=cc()|0;Nb(g|0);g=s;break}else{o=0;mb(55,g|0,320,76);o=0;t=15;break}}else{b=e;t=24}while(0);b:do if((t|0)==24){do if((b|0)==1){o=0;b=qa(140,j|0)|0;m=o;o=0;if(m&1){t=15;break b}if((b|0)<6){g=Ob(8)|0;o=0;ka(308,g|0);s=o;o=0;if(s&1){s=cc()|0;Nb(g|0);g=s;break b}else{o=0;mb(55,g|0,320,76);o=0;t=15;break b}}else{o=0;b=Wa(107,j|0,6)|0;m=o;o=0;if(m&1){t=15;break b}o=0;b=qa(177,b|0)|0;m=o;o=0;if(m&1){t=15;break b}o=0;Wa(109,u|0,b|0)|0;m=o;o=0;if(m&1){t=15;break b}else break}}while(0);o=0;ma(106,s|0,k|0);m=o;o=0;if(m&1)t=15;else{c:do if(f){e=q+56|0;m=q+4|0;c[q>>2]=29792;c[e>>2]=29812;o=0;ma(104,q+56|0,m|0);f=o;o=0;if(f&1)g=cc()|0;else{c[q+128>>2]=0;c[q+132>>2]=-1;c[q>>2]=29832;c[q+56>>2]=29852;o=0;ka(307,m|0);f=o;o=0;do if(f&1)g=cc()|0;else{c[m>>2]=29868;b=q+36|0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;c[q+48>>2]=0;c[q+52>>2]=16;c[l>>2]=0;c[l+4>>2]=0;c[l+8>>2]=0;o=0;ma(105,m|0,l|0);f=o;o=0;if(f&1){g=cc()|0;IC(l);IC(b);nD(m);break}IC(l);k=s+4|0;f=s+8|0;l=s+1|0;e=a[s>>0]|0;b=(e&1)==0;e=b?(e&255)>>>1:c[k>>2]|0;d:do if(!e)t=56;else{j=0;e:while(1){h=b?l:c[f>>2]|0;b=a[h+j>>0]|0;f:do if(b<<24>>24==37){do if(j>>>0<(e+-1|0)>>>0){b=j+1|0;if((a[h+b>>0]|0)!=37)break;o=0;Wa(109,q|0,37)|0;j=o;o=0;if(j&1)break e;else break f}while(0);o=0;Wa(109,q|0,29)|0;h=o;o=0;if(h&1)break e;else b=j}else{o=0;Wa(109,q|0,b|0)|0;h=o;o=0;if(h&1)break e;else b=j}while(0);j=b+1|0;e=a[s>>0]|0;b=(e&1)==0;e=b?(e&255)>>>1:c[k>>2]|0;if(j>>>0>=e>>>0){t=56;break d}}g=cc()|0}while(0);do if((t|0)==56){o=0;ma(106,n|0,m|0);p=o;o=0;if(p&1){g=cc()|0;break}if(!(a[s>>0]&1)){a[l>>0]=0;a[s>>0]=0}else{a[c[f>>2]>>0]=0;c[k>>2]=0}o=0;ma(114,s|0,0);p=o;o=0;if(p&1){r=cc(0)|0;oq(r)}else{c[s>>2]=c[n>>2];c[s+4>>2]=c[n+4>>2];c[s+8>>2]=c[n+8>>2];c[n>>2]=0;c[n+4>>2]=0;c[n+8>>2]=0;IC(n);Nq(q);t=63;break c}}while(0);Nq(q);break c}while(0)}iD(e);t=47}else t=63;while(0);do if((t|0)==63){o=0;mb(99,d|0,s|0,c[1101]|0);t=o;o=0;if(t&1){g=cc()|0;t=47;break}else{IC(s);Nq(u);i=r;return}}while(0);IC(s)}}while(0);if((t|0)==15){g=cc()|0;t=16}Nq(u);bc(g|0)}while(0)}iD(h);bc(g|0)}function wn(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;t=i;i=i+80|0;r=t+76|0;x=t+72|0;z=t+60|0;y=t+48|0;l=t+44|0;m=t+40|0;n=t+36|0;p=t+32|0;q=t+28|0;v=t+16|0;u=t+12|0;s=t;j=Sz(28)|0;sr(j,a);c[x>>2]=0;tr(x,j);j=c[x>>2]|0;c[z>>2]=0;c[z+4>>2]=0;c[z+8>>2]=0;o=0;ma(114,z|0,50);k=o;o=0;do if(!(k&1)?(o=0,ma(178,y|0,0),k=o,o=0,!(k&1)):0){f=0;k=0;a:while(1){o=0;g=qa(140,j|0)|0;h=o;o=0;if(h&1){h=7;break}if((g|0)<4){h=75;break}o=0;g=Wa(107,j|0,4)|0;h=o;o=0;if(h&1){h=12;break}o=0;h=qa(178,g|0)|0;g=o;o=0;if(g&1){h=12;break}if((h|0)==27820){h=75;break}if((h|0)==27988|(h|0)==28012){h=f;k=1;f=h;continue}if((h|0)==27892){o=0;g=qa(140,j|0)|0;h=o;o=0;if(h&1){h=7;break}if((g|0)<16){h=19;break}o=0;Wa(107,j|0,16)|0;h=o;o=0;if(h&1){h=7;break}else{g=k;h=f;k=g;f=h;continue}}if((h|0)==27940){o=0;g=Wa(107,j|0,8)|0;h=o;o=0;if(h&1){h=7;break}do if(!(g&128))f=g&127;else{if((g&192|0)==128){o=0;f=Wa(107,j|0,8)|0;h=o;o=0;if(h&1){h=7;break a}f=f|g<<8&16128;break}if((g&224|0)!=192){h=33;break a}o=0;f=Wa(107,j|0,16)|0;h=o;o=0;if(h&1){h=7;break a}f=f|g<<16&2031616}while(0);o=0;f=qa(179,f|0)|0;h=o;o=0;if(h&1){h=7;break}if(!f){h=38;break}else{h=k;k=h;continue}}o=0;if((h|0)==28036){h=kg(j,4)|0;g=o;o=0;if(g&1){h=7;break}o=0;g=Wa(110,28036,b|0)|0;A=o;o=0;if(A&1){h=7;break}o=0;g=Wa(107,j|0,g|0)|0;A=o;o=0;if(A&1){h=7;break}if((h|0)!=1){h=k;A=f;k=h;f=A;continue}c[l>>2]=0;tr(l,j);o=0;mb(100,l|0,z|0,g|0);A=o;o=0;if(A&1){h=48;break}ur(l);h=k;A=f;k=h;f=A;continue}g=Cn(h,b)|0;A=o;o=0;if(A&1){h=7;break}o=0;g=Wa(107,j|0,g|0)|0;A=o;o=0;if(A&1){h=7;break}if((h|0)==27844){c[m>>2]=0;tr(m,j);o=0;mb(101,m|0,z|0,g|0);A=o;o=0;if(A&1){h=54;break}ur(m);h=k;A=f;k=h;f=A;continue}if((h|0)==27868){c[n>>2]=0;tr(n,j);o=0;ub(67,n|0,z|0,g|0,k|0);A=o;o=0;if(A&1){h=58;break}ur(n);h=k;A=f;k=h;f=A;continue}if((h|0)==27916){c[p>>2]=0;tr(p,j);o=0;Ca(52,p|0,z|0,g|0,f|0,y|0,e|0);A=o;o=0;if(A&1){h=62;break}ur(p);h=k;A=f;k=h;f=A;continue}if((h|0)!=27964){h=67;break}c[q>>2]=0;tr(q,j);o=0;mb(102,q|0,z|0,g|0);A=o;o=0;if(A&1){h=66;break}ur(q);h=k;A=f;k=h;f=A}switch(h|0){case 7:{f=cc(240)|0;g=D;h=9;break}case 12:{f=cc(240)|0;g=D;if((g|0)==(Xb(240)|0)){g=fc(f|0)|0;f=Ob(8)|0;rs(f,g);c[f>>2]=4340;o=0;mb(55,f|0,240,66);o=0;f=cc(240)|0;g=D;o=0;ob(44);A=o;o=0;if(A&1)h=91;else h=70}else h=70;break}case 19:{f=Ob(8)|0;o=0;ka(308,f|0);A=o;o=0;if(A&1){h=cc(240)|0;g=D;Nb(f|0);f=h;h=70;break}else{o=0;mb(55,f|0,320,76);o=0;h=8;break}}case 33:{f=Ob(8)|0;o=0;ka(308,f|0);A=o;o=0;if(A&1){h=cc(240)|0;g=D;Nb(f|0);f=h;h=9;break}else{o=0;mb(55,f|0,320,76);o=0;h=8;break}}case 38:{f=Ob(8)|0;o=0;ka(308,f|0);A=o;o=0;if(A&1){h=cc(240)|0;g=D;Nb(f|0);f=h;h=70;break}else{o=0;mb(55,f|0,320,76);o=0;h=8;break}}case 48:{f=cc(240)|0;g=D;ur(l);h=70;break}case 54:{f=cc(240)|0;g=D;ur(m);h=70;break}case 58:{f=cc(240)|0;g=D;ur(n);h=70;break}case 62:{f=cc(240)|0;g=D;ur(p);h=70;break}case 66:{f=cc(240)|0;g=D;ur(q);h=70;break}case 67:{f=Ob(8)|0;o=0;ka(308,f|0);A=o;o=0;if(A&1){h=cc(240)|0;g=D;Nb(f|0);f=h;h=70;break}else{o=0;mb(55,f|0,320,76);o=0;h=8;break}}case 75:{o=0;g=qa(111,48)|0;A=o;o=0;if(A&1){f=cc()|0;h=89;break}Pd(v,a);o=0;f=qa(111,20)|0;A=o;o=0;do if(A&1)f=cc()|0;else{o=0;ma(94,f|0,z|0);A=o;o=0;if(A&1){A=cc()|0;Uz(f);f=A;break}c[u>>2]=0;cq(u,f);o=0;f=qa(180,d|0)|0;A=o;o=0;do if(!(A&1)?(o=0,ma(82,s|0,f|0),A=o,o=0,!(A&1)):0){o=0;ia(53,g|0,v|0,u|0,y|0,s|0);A=o;o=0;if(A&1){f=cc()|0;IC(s);break}else{c[r>>2]=0;dq(r,g);IC(s);ne(u);Sd(v);Uq(y);IC(z);ur(x);i=t;return c[r>>2]|0}}else h=85;while(0);if((h|0)==85)f=cc()|0;ne(u)}while(0);Sd(v);Uz(g);h=89;break}}if((h|0)==8){f=cc(240)|0;g=D;h=9}if((h|0)==9)h=70;if((h|0)==70)if((g|0)==(Xb(240)|0)){fc(f|0)|0;f=Ob(8)|0;o=0;ka(308,f|0);A=o;o=0;if(A&1){A=cc()|0;Nb(f|0);f=A}else{o=0;mb(55,f|0,320,76);o=0;f=cc()|0}o=0;ob(44);A=o;o=0;if(A&1)h=91;else h=89}else h=89;if((h|0)==89){Uq(y);w=f;break}else if((h|0)==91){A=cc(0)|0;oq(A)}}else h=6;while(0);if((h|0)==6)w=cc()|0;IC(z);ur(x);bc(w|0);return 0}function xn(a){a=a|0;var b=0,c=0;c=i;i=i+16|0;b=c;iq(b,4368);o=0;ma(92,a|0,b|0);a=o;o=0;if(a&1){c=cc()|0;lq(b);bc(c|0)}else{lq(b);i=c;return}}function yn(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0;l=i;i=i+32|0;n=l+12|0;k=l;h=e+8|0;e=c[h>>2]|0;e=(c[e+12>>2]|0)-(c[e+8>>2]|0)|0;kq(n,e);j=(c[n+8>>2]|0)+8|0;if((e|0)>0){g=0;do{c[(c[j>>2]|0)+(g<<2)>>2]=d[(c[(c[h>>2]|0)+8>>2]|0)+g>>0];g=g+1|0}while((g|0)<(e|0))}mq(k,n);o=0;mb(56,b|0,k|0,e-f|0);b=o;o=0;if(!(b&1)){nq(k);if((f|0)>0){e=0;do{a[(c[(c[h>>2]|0)+8>>2]|0)+e>>0]=c[(c[j>>2]|0)+(e<<2)>>2];e=e+1|0}while((e|0)<(f|0))}nq(n);i=l;return}e=cc(256)|0;l=D;nq(k);if((l|0)==(Xb(256)|0)){fc(e|0)|0;e=Ob(8)|0;Qf(e);o=0;mb(55,e|0,160,56);o=0;e=cc()|0;o=0;ob(44);l=o;o=0;if(l&1){l=cc(0)|0;oq(l)}else m=e}else m=e;nq(n);bc(m|0)}function zn(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;u=i;i=i+128|0;z=u+108|0;e=u+104|0;g=u+100|0;y=u+88|0;x=u+76|0;h=u+64|0;w=u+52|0;v=u+48|0;t=u+36|0;q=u+24|0;r=u+12|0;s=u;Zp(e,d);o=0;ma(179,z|0,e|0);p=o;o=0;if(p&1){z=cc()|0;Yd(e);e=z}else{Yd(e);o=0;p=qa(169,z|0)|0;n=o;o=0;do if(!(n&1)?(o=0,f=qa(181,z|0)|0,n=o,o=0,!(n&1)):0){c[g>>2]=f;o=0;n=qa(182,f|0)|0;m=o;o=0;if(m&1){e=cc()|0;lt(g);break}lt(g);o=0;ma(180,y|0,z|0);m=o;o=0;if(!(m&1)){Pd(h,y);o=0;ub(68,x|0,h|0,p|0,n|0);m=o;o=0;if(m&1){e=cc()|0;Sd(h)}else{Sd(h);m=x+4|0;e=c[x>>2]|0;a:do if((c[m>>2]|0)==(e|0)){e=0;j=17}else{f=0;d=0;while(1){o=0;e=qa(183,c[e+(f<<2)>>2]|0)|0;l=o;o=0;if(l&1)break;d=e+d|0;f=f+1|0;e=c[x>>2]|0;if(f>>>0>=(c[m>>2]|0)-e>>2>>>0){e=d;j=17;break a}}e=cc()|0;j=16}while(0);do if((j|0)==17){o=0;ma(87,w|0,e|0);l=o;o=0;if(l&1){e=cc()|0;j=16;break}k=t+8|0;l=(c[w+8>>2]|0)+8|0;e=c[x>>2]|0;b:do if((c[m>>2]|0)==(e|0))j=30;else{h=0;j=0;while(1){yt(v,e+(h<<2)|0);e=c[v>>2]|0;o=0;ma(181,t|0,e|0);g=o;o=0;if(g&1){j=24;break}o=0;e=qa(183,e|0)|0;g=o;o=0;if(g&1){j=25;break}Pd(q,t);o=0;mb(103,b|0,q|0,e|0);g=o;o=0;if(g&1){j=26;break}Sd(q);g=(e|0)>0?e:0;if((e|0)>0){d=0;f=j;while(1){a[(c[l>>2]|0)+f>>0]=a[(c[(c[k>>2]|0)+8>>2]|0)+d>>0]|0;d=d+1|0;if((d|0)>=(e|0))break;else f=f+1|0}}Sd(t);qt(v);h=h+1|0;e=c[x>>2]|0;if(h>>>0>=(c[m>>2]|0)-e>>2>>>0){j=30;break b}else j=j+g|0}if((j|0)==24)e=cc()|0;else if((j|0)==25){e=cc()|0;j=28}else if((j|0)==26){e=cc()|0;Sd(q);j=28}if((j|0)==28)Sd(t);qt(v)}while(0);do if((j|0)==30){Pd(r,w);c[s+4>>2]=0;c[s+8>>2]=0;c[s>>2]=s+4;o=0;e=kb(62,r|0,p|0,n|0,s|0)|0;v=o;o=0;if(v&1){e=cc()|0;zt(s);Sd(r);break}else{zt(s);Sd(r);Sd(w);st(x);Sd(y);At(z);i=u;return e|0}}while(0);Sd(w)}while(0);st(x)}Sd(y)}else j=11}else j=11;while(0);if((j|0)==11)e=cc()|0;At(z)}bc(e|0);return 0}function An(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;c[a>>2]=b;c[a+4>>2]=d;c[a+8>>2]=e;FC(a+12|0,g,iC(g)|0);return}function Bn(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0;e=i;i=i+176|0;f=e+152|0;j=e+16|0;h=e;do switch(b|0){case 0:{d=27820;break}case 1:{d=27844;break}case 2:{d=27868;break}case 3:{d=27892;break}case 4:{d=27916;break}case 5:{d=27988;break}case 7:{d=27940;break}case 8:{d=27964;break}case 9:{d=28012;break}case 13:{d=28036;break}default:{e=j+56|0;g=j+4|0;c[j>>2]=29792;c[e>>2]=29812;o=0;ma(104,j+56|0,g|0);d=o;o=0;if(d&1)d=cc()|0;else{c[j+128>>2]=0;c[j+132>>2]=-1;c[j>>2]=29832;c[j+56>>2]=29852;o=0;ka(307,g|0);d=o;o=0;do if(d&1)d=cc()|0;else{c[g>>2]=29868;d=j+36|0;c[d>>2]=0;c[d+4>>2]=0;c[d+8>>2]=0;c[j+48>>2]=0;c[j+52>>2]=16;c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;o=0;ma(105,g|0,f|0);l=o;o=0;if(l&1){l=cc()|0;IC(f);IC(d);nD(g);d=l;break}IC(f);o=0;d=Wa(66,j|0,50091)|0;l=o;o=0;do if(!(l&1)?(o=0,Wa(63,d|0,b|0)|0,l=o,o=0,!(l&1)):0){d=Ob(8)|0;o=0;ma(106,h|0,g|0);l=o;o=0;if(l&1){l=cc()|0;Nb(d|0);d=l;break}else{zq(d,(a[h>>0]&1)==0?h+1|0:c[h+8>>2]|0);c[d>>2]=29736;o=0;mb(55,d|0,24,146);o=0;d=cc()|0;IC(h);break}}else k=23;while(0);if((k|0)==23)d=cc()|0;Nq(j);bc(d|0)}while(0)}iD(e);bc(d|0)}}while(0);i=e;return d|0}function Cn(a,b){a=a|0;b=b|0;b=Po(b)|0;do if((b|0)>=10)if((b|0)<27){a=a+4|0;break}else{a=a+8|0;break}while(0);return c[a>>2]|0}function Dn(a,b,d,e){a=a|0;b=+b;d=+d;e=+e;ip(a,b,d);c[a>>2]=34404;g[a+16>>2]=e;return}function En(a,b,d,e){a=a|0;b=+b;d=+d;e=+e;if(+O(+(d-+ld[c[(c[a>>2]|0)+12>>2]&63](a)))<=b?+O(+(e-+ld[c[(c[a>>2]|0)+8>>2]&63](a)))<=b:0){e=+g[a+16>>2];d=+O(+(b-e));if(!(d<=1.0))a=d<=e;else a=1}else a=0;return a|0}function Fn(a,b,d,e){a=a|0;b=+b;d=+d;e=+e;var f=0,h=0,j=0,k=0.0;h=i;i=i+16|0;f=h;k=(+ld[c[(c[a>>2]|0)+8>>2]&63](a)+d)*.5;d=(+ld[c[(c[a>>2]|0)+12>>2]&63](a)+b)*.5;b=+g[a+16>>2];a=Sz(20)|0;o=0;wa(42,a|0,+k,+d);j=o;o=0;if(j&1){j=cc()|0;Uz(a);bc(j|0)}else{c[a>>2]=34404;g[a+16>>2]=(b+e)*.5;c[f>>2]=0;Bt(f,a);i=h;return c[f>>2]|0}return 0}function Gn(a,b){a=a|0;b=b|0;var d=0.0,e=0.0;d=+g[a+32>>2];e=d*.5;a=c[b>>2]|0;b=0;while(1){if((b|0)>=3){a=1;break}if(!(+O(+(d-+(c[a+(b<<2)>>2]|0)))>=e))b=b+1|0;else{a=0;break}}return a|0}function Hn(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0.0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,t=0;t=i;i=i+16|0;r=t+4|0;o=t;j=a+8|0;p=jg(c[j>>2]|0)|0;c[o>>2]=0;ms(r,3,o);a:do if((b|0)>-1){h=b;while(1){k=c[j>>2]|0;o=eq(k,d,h)|0;m=c[r>>2]|0;l=m+4|0;n=c[l>>2]|0;if((n|0)>(e|0)|o^1)break;c[l>>2]=n+1;if((h|0)>0)h=h+-1|0;else{g=s;break a}}l=m+4|0;if((n|0)<=(e|0)){b:do if((h|0)>-1)while(1){if(eq(k,d,h)|0){q=7;break b}j=c[m>>2]|0;if((j|0)>(e|0)){o=j;break b}c[m>>2]=j+1;if((h|0)>0)h=h+-1|0;else{q=7;break}}else q=7;while(0);if((q|0)==7)o=c[m>>2]|0;if((o|0)<=(e|0)){h=b+1|0;c:do if((h|0)<(p|0)){j=n;while(1){if((j|0)>(e|0)|(eq(k,d,h)|0)^1){n=j;break c}j=j+1|0;c[l>>2]=j;h=h+1|0;if((h|0)>=(p|0)){n=j;break}}}while(0);if(!((h|0)==(p|0)|(n|0)>(e|0))){l=m+8|0;d:do if((h|0)<(p|0))while(1){if(eq(k,d,h)|0){q=17;break d}j=c[l>>2]|0;if((j|0)>(e|0))break d;c[l>>2]=j+1;h=h+1|0;if((h|0)>=(p|0)){q=17;break}}else q=17;while(0);if((q|0)==17)j=c[m+8>>2]|0;if(((j|0)<=(e|0)?(q=j-f+o+n|0,(((q|0)>-1?q:0-q|0)*5|0)<(f<<1|0)):0)?Gn(a,r)|0:0)g=+(h-j|0)-+(n|0)*.5;else g=s}else g=s}else g=s}else g=s}else g=s;while(0);br(r);i=t;return +g}function In(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,h=0,j=0.0,l=0.0,m=0.0,n=0,p=0,q=0,r=0,s=0,t=0;s=i;i=i+16|0;r=s+12|0;n=s+8|0;p=s+4|0;q=s;f=c[b>>2]|0;t=c[f+4>>2]|0;h=c[f+8>>2]|0;m=+(e-h|0)-+(t|0)*.5;l=+Hn(a,d,~~m,t<<1,t+(c[f>>2]|0)+h|0);a:do if(((g[k>>2]=l,c[k>>2]|0)&2147483647)>>>0>2139095040)d=18;else{h=c[b>>2]|0;j=+((c[h+4>>2]|0)+(c[h>>2]|0)+(c[h+8>>2]|0)|0)/3.0;h=a+12|0;t=c[h>>2]|0;t=(c[t+4>>2]|0)-(c[t>>2]|0)|0;d=t>>2;b:do if((t|0)>0){f=0;while(1){e=c[(c[c[h>>2]>>2]|0)+(f<<2)>>2]|0;c[n>>2]=0;Bt(n,e);e=c[n>>2]|0;o=0;b=Qa(42,e|0,+j,+l,+m)|0;t=o;o=0;if(t&1){d=7;break}if(b){d=5;break}Ct(n);f=f+1|0;if((f|0)>=(d|0)){d=11;break b}}do if((d|0)==5){o=0;e=Qa(43,e|0,+l,+m,+j)|0;t=o;o=0;if(t&1){e=cc()|0;break}else{c[r>>2]=e;Ct(n);break a}}else if((d|0)==7)e=cc()|0;while(0);Ct(n)}else d=11;while(0);do if((d|0)==11){f=Sz(20)|0;o=0;Ia(42,f|0,+m,+l,+j);t=o;o=0;if(t&1){e=cc()|0;Uz(f);break}c[p>>2]=f;e=f+4|0;c[e>>2]=(c[e>>2]|0)+1;e=c[h>>2]|0;d=e+4|0;b=c[d>>2]|0;if((b|0)==(c[e+8>>2]|0))Dt(e,p);else{c[b>>2]=f;c[d>>2]=(c[d>>2]|0)+4}e=c[a+36>>2]|0;if(!e){d=18;break a}$c[c[(c[e>>2]|0)+8>>2]&511](e,f);d=18;break a}while(0);bc(e|0)}while(0);if((d|0)==18){c[q>>2]=0;Bt(q,0);c[r>>2]=0;Bt(r,c[q>>2]|0);Ct(q);e=c[r>>2]|0}i=s;return e|0}function Jn(a,b,d,e,f,h,i,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;i=+i;j=j|0;var k=0,l=0;c[a+4>>2]=0;c[a>>2]=28068;k=a+8|0;Zp(k,b);o=0;b=qa(111,12)|0;l=o;o=0;if(l&1){l=cc()|0;Yd(k);bc(l|0)}else{c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;c[a+12>>2]=b;c[a+16>>2]=d;c[a+20>>2]=e;c[a+24>>2]=f;c[a+28>>2]=h;g[a+32>>2]=i;we(a+36|0,j);return}}function Kn(a){a=a|0;var b=0,d=0,e=0,f=0;c[a>>2]=28068;f=a+12|0;b=c[f>>2]|0;d=c[b>>2]|0;if(((c[b+4>>2]|0)-d|0)>0){e=0;do{ye(c[d+(e<<2)>>2]|0);c[(c[c[f>>2]>>2]|0)+(e<<2)>>2]=0;e=e+1|0;b=c[f>>2]|0;d=c[b>>2]|0}while((e|0)<((c[b+4>>2]|0)-d>>2|0))}if(b){Et(b);Uz(b)}ze(a+36|0);Yd(a+8|0);return}function Ln(a){a=a|0;Kn(a);Uz(a);return}function Mn(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;q=i;i=i+32|0;p=q+16|0;r=q+4|0;j=q;k=a+16|0;l=(c[a+24>>2]|0)+(c[k>>2]|0)|0;m=a+28|0;h=(c[m>>2]>>1)+(c[a+20>>2]|0)|0;c[j>>2]=0;ms(r,3,j);j=a+8|0;a:do if((c[m>>2]|0)>0){n=0;b:while(1){b=n;n=n+1|0;g=n>>1;g=h+((b&1|0)==0?g:0-g|0)|0;b=c[r>>2]|0;c[b>>2]=0;c[b+4>>2]=0;c[b+8>>2]=0;d=c[k>>2]|0;c:do if((d|0)<(l|0)){e=c[j>>2]|0;do{if(eq(e,d,g)|0)break c;d=d+1|0}while((d|0)<(l|0))}while(0);if((d|0)<(l|0)){f=0;while(1){e=(f|0)==1;do if(eq(c[j>>2]|0,d,g)|0){if(e){e=b+4|0;c[e>>2]=(c[e>>2]|0)+1;e=1;break}if((f|0)!=2){e=f+1|0;f=b+(e<<2)|0;c[f>>2]=(c[f>>2]|0)+1;break}if(Gn(a,r)|0){o=0;b=kb(63,a|0,r|0,g|0,d|0)|0;f=o;o=0;if(f&1){d=28;break b}c[p>>2]=b;if(b){d=27;break a}Ct(p);b=c[r>>2]|0}e=b+8|0;c[b>>2]=c[e>>2];c[b+4>>2]=1;c[e>>2]=0;e=1}else{e=(e&1)+f|0;f=b+(e<<2)|0;c[f>>2]=(c[f>>2]|0)+1}while(0);d=d+1|0;if((d|0)>=(l|0))break;else f=e}}if(Gn(a,r)|0){o=0;b=kb(63,a|0,r|0,g|0,l|0)|0;g=o;o=0;if(g&1){d=29;break}c[p>>2]=b;if(b){d=27;break a}Ct(p)}if((n|0)>=(c[m>>2]|0)){d=24;break a}}if((d|0)==28){b=cc()|0;d=30;break}else if((d|0)==29){b=cc()|0;d=30;break}}else d=24;while(0);do if((d|0)==24){a=c[a+12>>2]|0;b=c[a>>2]|0;if((c[a+4>>2]|0)==(b|0)){b=Ob(8)|0;zq(b,50111);c[b>>2]=29736;o=0;mb(55,b|0,24,146);o=0;b=cc()|0;d=30;break}else{b=c[b>>2]|0;c[p>>2]=0;Bt(p,b);b=c[p>>2]|0;d=27;break}}while(0);if((d|0)==27){br(r);i=q;return b|0}else if((d|0)==30){br(r);bc(b|0)}return 0}function Nn(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=28084;Zp(a+8|0,b);a=a+12|0;c[a>>2]=0;xe(a,0);return}function On(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;Zp(b,a+8|0);i=d;return c[b>>2]|0}function Pn(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0;j=i;i=i+48|0;e=j+40|0;k=j+16|0;f=j+12|0;d=j+8|0;h=j+4|0;g=j;m=ej(b)|0;c[e>>2]=m;xe(a+12|0,m);ze(e);Zp(f,a+8|0);o=0;e=qa(145,b|0)|0;m=o;o=0;do if(m&1){d=cc()|0;l=8}else{c[d>>2]=e;o=0;mb(73,k|0,f|0,d|0);m=o;o=0;if(m&1){l=cc()|0;ze(d);d=l;l=8;break}ze(d);Yd(f);o=0;d=Wa(111,k|0,b|0)|0;m=o;o=0;do if(!(m&1)){c[h>>2]=d;c[g>>2]=0;_r(g,d);o=0;d=Wa(84,a|0,g|0)|0;m=o;o=0;if(m&1){d=cc()|0;Tr(g);Tr(h);break}else{Tr(g);Tr(h);Wr(k);i=j;return d|0}}else d=cc()|0;while(0);Wr(k)}while(0);if((l|0)==8)Yd(f);bc(d|0);return 0}function Qn(a,b){a=a|0;b=b|0;var d=0,e=0.0,f=0.0,g=0.0,h=0.0,j=0.0,k=0.0,l=0,m=0,n=0,p=0,q=0,r=0,s=0.0,t=0.0,u=0.0,v=0.0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0;L=i;i=i+112|0;I=L+104|0;T=L+100|0;S=L+96|0;R=L+92|0;d=L+88|0;l=L+84|0;m=L+80|0;n=L+76|0;p=L+72|0;q=L+68|0;P=L+64|0;x=L+60|0;O=L+56|0;A=L+52|0;B=L+48|0;y=L+44|0;z=L+40|0;N=L+36|0;C=L+32|0;E=L+28|0;M=L+16|0;J=L+12|0;K=L;G=qo(c[b>>2]|0)|0;c[T>>2]=G;o=0;F=qa(149,c[b>>2]|0)|0;H=o;o=0;if(H&1)b=cc()|0;else{c[S>>2]=F;o=0;H=qa(148,c[b>>2]|0)|0;w=o;o=0;if(w&1)b=cc()|0;else{c[R>>2]=H;c[d>>2]=0;vq(d,G);c[l>>2]=0;vq(l,F);c[m>>2]=0;vq(m,H);o=0;v=+Ea(42,a|0,d|0,l|0,m|0);w=o;o=0;do if(w&1){b=cc()|0;uq(m);uq(l);uq(d)}else{uq(m);uq(l);uq(d);if(!(v<1.0)){c[n>>2]=0;vq(n,G);c[p>>2]=0;vq(p,F);c[q>>2]=0;vq(q,H);o=0;w=ib(42,n|0,p|0,q|0,+v)|0;m=o;o=0;if(m&1){b=cc()|0;uq(q);uq(p);uq(n);break}uq(q);uq(p);uq(n);o=0;b=qa(184,w|0)|0;q=o;o=0;if(!(q&1)?(o=0,r=qa(185,b|0)|0,q=o,o=0,!(q&1)):0){d=r+-7|0;c[P>>2]=0;Bt(P,0);o=0;b=qa(186,b|0)|0;r=o;o=0;a:do if(r&1)Q=30;else{b:do if((c[b+4>>2]|0)!=(c[b>>2]|0)){o=0;g=+Ka(c[(c[F>>2]|0)+8>>2]|0,F|0);r=o;o=0;if(r&1){Q=30;break a}o=0;h=+Ka(c[(c[G>>2]|0)+8>>2]|0,G|0);r=o;o=0;if(r&1){Q=30;break a}o=0;j=+Ka(c[(c[H>>2]|0)+8>>2]|0,H|0);r=o;o=0;if(r&1){Q=30;break a}o=0;s=+Ka(c[(c[F>>2]|0)+12>>2]|0,F|0);r=o;o=0;if(r&1){Q=30;break a}o=0;t=+Ka(c[(c[G>>2]|0)+12>>2]|0,G|0);r=o;o=0;if(r&1){Q=30;break a}o=0;u=+Ka(c[(c[H>>2]|0)+12>>2]|0,H|0);r=o;o=0;if(r&1){Q=30;break a}k=1.0-3.0/+(d|0);o=0;e=+Ka(c[(c[G>>2]|0)+8>>2]|0,G|0);r=o;o=0;if(r&1){Q=30;break a}o=0;f=+Ka(c[(c[G>>2]|0)+8>>2]|0,G|0);r=o;o=0;if(r&1){Q=30;break a}m=~~(e+k*(g-h+j-f));o=0;e=+Ka(c[(c[G>>2]|0)+12>>2]|0,G|0);r=o;o=0;if(r&1){Q=30;break a}o=0;f=+Ka(c[(c[G>>2]|0)+12>>2]|0,G|0);r=o;o=0;if(r&1){Q=30;break a}d=~~(e+k*(s-t+u-f));l=4;while(1){o=0;b=Ga(42,a|0,+v,m|0,d|0,+(+(l|0)))|0;r=o;o=0;if(!(r&1)){Q=27;break}b=cc(24)|0;r=D;if((r|0)!=(Xb(24)|0))break a;fc(b|0)|0;o=0;ob(44);r=o;o=0;if(r&1){Q=29;break}l=l<<1;if((l|0)>=17)break b}if((Q|0)==27){c[x>>2]=b;Bt(P,b);Ct(x);break}else if((Q|0)==29){b=cc()|0;Q=31;break a}}while(0);b=c[(c[a>>2]|0)+8>>2]|0;c[A>>2]=0;vq(A,G);c[B>>2]=0;vq(B,F);c[y>>2]=0;vq(y,H);c[z>>2]=0;d=c[P>>2]|0;vq(z,d);o=0;b=oa(b|0,a|0,A|0,B|0,y|0,z|0,w|0)|0;x=o;o=0;if(x&1){b=cc()|0;uq(z);uq(y);uq(B);uq(A);break}c[O>>2]=b;uq(z);uq(y);uq(B);uq(A);Zp(C,a+8|0);c[E>>2]=0;Zq(E,b);o=0;l=ya(117,C|0,w|0,E|0)|0;a=o;o=0;if(a&1){b=cc()|0;_q(E);Yd(C)}else{c[N>>2]=l;_q(E);Yd(C);o=0;b=qa(111,20)|0;E=o;o=0;do if(E&1)b=cc()|0;else{o=0;ma(124,b|0,4);E=o;o=0;if(E&1){M=cc()|0;Uz(b);b=M;break}Dq(M,b);b=(c[M+8>>2]|0)+8|0;vq(c[b>>2]|0,H);vq((c[b>>2]|0)+4|0,G);vq((c[b>>2]|0)+8|0,F);do if(!d){o=0;h=+Ka(c[(c[F>>2]|0)+8>>2]|0,F|0);E=o;o=0;if(E&1){Q=45;break}o=0;j=+Ka(c[(c[G>>2]|0)+8>>2]|0,G|0);E=o;o=0;if(E&1){Q=45;break}o=0;k=+Ka(c[(c[H>>2]|0)+8>>2]|0,H|0);E=o;o=0;if(E&1){Q=45;break}o=0;g=+Ka(c[(c[F>>2]|0)+12>>2]|0,F|0);F=o;o=0;if(F&1){Q=45;break}o=0;f=+Ka(c[(c[G>>2]|0)+12>>2]|0,G|0);G=o;o=0;if(G&1){Q=45;break}o=0;e=+Ka(c[(c[H>>2]|0)+12>>2]|0,H|0);H=o;o=0;if(H&1){Q=45;break}b=(c[b>>2]|0)+12|0;o=0;d=qa(111,16)|0;H=o;o=0;if(H&1){Q=45;break}o=0;wa(42,d|0,+(h-j+k),+(g-f+e));H=o;o=0;if(H&1){b=cc()|0;Uz(d);break}else{vq(b,d);Q=56;break}}else{vq((c[b>>2]|0)+12|0,d);Q=56}while(0);do if((Q|0)==56){o=0;b=qa(111,24)|0;H=o;o=0;if(H&1){Q=45;break}c[J>>2]=0;Ke(J,l);oe(K,M);o=0;mb(52,b|0,J|0,K|0);H=o;o=0;if(H&1){L=cc()|0;pe(K);Yd(J);Uz(b);b=L;break}else{c[I>>2]=0;Hr(I,b);pe(K);Yd(J);pe(M);Yd(N);_q(O);Ct(P);fs(R);fs(S);fs(T);i=L;return c[I>>2]|0}}while(0);if((Q|0)==45)b=cc()|0;pe(M)}while(0);Yd(N)}_q(O)}while(0);if((Q|0)==30){b=cc()|0;Q=31}Ct(P);break}}else{Q=Ob(8)|0;zq(Q,50144);c[Q>>2]=29736;o=0;mb(55,Q|0,24,146);o=0}b=cc()|0}while(0);fs(R)}fs(S)}fs(T);bc(b|0);return 0}function Rn(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0.0,f=0.0,g=0,h=0,j=0,k=0,l=0;j=i;i=i+16|0;k=j+12|0;l=j+8|0;g=j+4|0;h=j;tq(k,b);tq(l,c);o=0;f=+_a(42,a|0,k|0,l|0);c=o;o=0;do if(!(c&1)){tq(g,b);tq(h,d);o=0;e=+_a(42,a|0,g|0,h|0);b=o;o=0;if(b&1){c=cc()|0;uq(h);uq(g);break}else{uq(h);uq(g);uq(l);uq(k);i=j;return +((f+e)*.5)}}else c=cc()|0;while(0);uq(l);uq(k);bc(c|0);return 0.0}function Sn(b,d,e,f){b=b|0;d=d|0;e=e|0;f=+f;var g=0,h=0,j=0.0,k=0.0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;n=i;i=i+176|0;p=n+164|0;g=n+160|0;h=n+20|0;l=n+16|0;m=n+12|0;r=n+24|0;q=n;tq(g,b);tq(h,d);o=0;k=+eb(42,g|0,h|0);d=o;o=0;a:do if(d&1){d=cc()|0;uq(h);uq(g)}else{uq(h);uq(g);tq(l,b);tq(m,e);o=0;j=+eb(42,l|0,m|0);b=o;o=0;if(b&1){d=cc()|0;uq(m);uq(l);break}uq(m);uq(l);g=~~(j/f+.5)+~~(k/f+.5)>>1;d=g+7|0;switch(d&3|0){case 0:{d=g+8|0;break}case 2:{d=g+6|0;break}case 3:{h=r+56|0;e=r+4|0;c[r>>2]=29792;c[h>>2]=29812;o=0;ma(104,r+56|0,e|0);n=o;o=0;if(n&1)d=cc()|0;else{c[r+128>>2]=0;c[r+132>>2]=-1;c[r>>2]=29832;c[r+56>>2]=29852;o=0;ka(307,e|0);n=o;o=0;do if(n&1)d=cc()|0;else{c[e>>2]=29868;g=r+36|0;c[g>>2]=0;c[g+4>>2]=0;c[g+8>>2]=0;c[r+48>>2]=0;c[r+52>>2]=16;c[p>>2]=0;c[p+4>>2]=0;c[p+8>>2]=0;o=0;ma(105,e|0,p|0);n=o;o=0;if(n&1){d=cc()|0;IC(p);IC(g);nD(e);break}IC(p);o=0;g=Wa(66,r|0,50160)|0;p=o;o=0;do if(!(p&1)?(o=0,Wa(63,g|0,d|0)|0,p=o,o=0,!(p&1)):0){d=Ob(8)|0;o=0;ma(106,q|0,e|0);p=o;o=0;if(p&1){q=cc()|0;Nb(d|0);d=q;break}else{zq(d,(a[q>>0]&1)==0?q+1|0:c[q+8>>2]|0);c[d>>2]=29736;o=0;mb(55,d|0,24,146);o=0;d=cc()|0;IC(q);break}}else s=20;while(0);if((s|0)==20)d=cc()|0;Nq(r);break a}while(0)}iD(h);bc(d|0)}default:{}}i=n;return d|0}while(0);bc(d|0);return 0}function Tn(a,b,d,e,f){a=a|0;b=+b;d=d|0;e=e|0;f=+f;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0;p=i;i=i+48|0;n=p+8|0;m=p;h=~~(b*f);k=d-h|0;k=(k|0)>0?k:0;l=a+8|0;g=(ig(c[l>>2]|0)|0)+-1|0;j=h+d|0;g=((j|0)<(g|0)?j:g)-k|0;f=b*3.0;if(+(g|0)<f){p=Ob(8)|0;zq(p,50176);c[p>>2]=29736;Hc(p|0,24,146)}j=e-h|0;j=(j|0)>0?j:0;d=(jg(c[l>>2]|0)|0)+-1|0;e=h+e|0;d=((e|0)<(d|0)?e:d)-j|0;if(+(d|0)<f){p=Ob(8)|0;zq(p,50176);c[p>>2]=29736;Hc(p|0,24,146)}Zp(m,l);o=0;cb(42,n|0,m|0,k|0,j|0,g|0,d|0,+b,a+12|0);a=o;o=0;do if(!(a&1)){Yd(m);o=0;d=qa(187,n|0)|0;a=o;o=0;if(a&1){d=cc()|0;Kn(n);break}else{Kn(n);i=p;return d|0}}else{d=cc()|0;Yd(m)}while(0);bc(d|0);return 0}function Un(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,g=0;f=i;i=i+16|0;d=f+4|0;e=f;g=Qg()|0;Zp(d,a);Lr(e,c);o=0;b=kb(54,g|0,d|0,b|0,e|0)|0;c=o;o=0;if(c&1){g=cc()|0;_q(e);Yd(d);bc(g|0)}else{_q(e);Yd(d);i=f;return b|0}return 0}function Vn(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0.0,i=0.0,j=0.0,k=0.0,l=0.0,m=0.0,n=0.0,o=0.0,p=0.0;k=+(g|0)+-3.5;g=c[f>>2]|0;if(!g){f=c[d>>2]|0;h=+ld[c[(c[f>>2]|0)+8>>2]&63](f);f=c[b>>2]|0;h=h-+ld[c[(c[f>>2]|0)+8>>2]&63](f);f=c[e>>2]|0;h=h+ +ld[c[(c[f>>2]|0)+8>>2]&63](f);f=c[d>>2]|0;i=+ld[c[(c[f>>2]|0)+12>>2]&63](f);f=c[b>>2]|0;i=i-+ld[c[(c[f>>2]|0)+12>>2]&63](f);f=c[e>>2]|0;a=e;g=b;i=i+ +ld[c[(c[f>>2]|0)+12>>2]&63](f);j=k}else{h=+ld[c[(c[g>>2]|0)+8>>2]&63](g);f=c[f>>2]|0;a=e;g=b;i=+ld[c[(c[f>>2]|0)+12>>2]&63](f);j=k+-3.0}b=c[g>>2]|0;p=+ld[c[(c[b>>2]|0)+8>>2]&63](b);b=c[g>>2]|0;o=+ld[c[(c[b>>2]|0)+12>>2]&63](b);b=c[d>>2]|0;n=+ld[c[(c[b>>2]|0)+8>>2]&63](b);b=c[d>>2]|0;m=+ld[c[(c[b>>2]|0)+12>>2]&63](b);b=c[a>>2]|0;l=+ld[c[(c[b>>2]|0)+8>>2]&63](b);b=c[a>>2]|0;return bh(3.5,3.5,k,3.5,j,j,3.5,k,p,o,n,m,h,i,l,+ld[c[(c[b>>2]|0)+12>>2]&63](b))|0}function Wn(a,b,d){a=a|0;b=b|0;d=d|0;var e=0.0,f=0.0,h=0,i=0,j=0,l=0;l=c[b>>2]|0;l=~~+ld[c[(c[l>>2]|0)+8>>2]&63](l);j=c[b>>2]|0;j=~~+ld[c[(c[j>>2]|0)+12>>2]&63](j);h=c[d>>2]|0;h=~~+ld[c[(c[h>>2]|0)+8>>2]&63](h);i=c[d>>2]|0;e=+Xn(a,l,j,h,~~+ld[c[(c[i>>2]|0)+12>>2]&63](i));i=c[d>>2]|0;i=~~+ld[c[(c[i>>2]|0)+8>>2]&63](i);h=c[d>>2]|0;h=~~+ld[c[(c[h>>2]|0)+12>>2]&63](h);d=c[b>>2]|0;d=~~+ld[c[(c[d>>2]|0)+8>>2]&63](d);b=c[b>>2]|0;f=+Xn(a,i,h,d,~~+ld[c[(c[b>>2]|0)+12>>2]&63](b));if(((g[k>>2]=e,c[k>>2]|0)&2147483647)>>>0<=2139095040){if(((g[k>>2]=f,c[k>>2]|0)&2147483647)>>>0<=2139095040)e=(e+f)/14.0}else e=f;return +e}function Xn(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0.0,h=0,i=0,j=0.0,k=0,l=0.0;l=+Yn(a,b,d,e,f);i=e-b|0;e=b-i|0;if((e|0)>=0){h=a+8|0;if((e|0)<(ig(c[h>>2]|0)|0)){k=e;g=1.0}else{g=+((ig(c[h>>2]|0)|0)+~b|0)/+(0-i|0);k=(ig(c[h>>2]|0)|0)+-1|0}}else{k=0;g=+(b|0)/+(i|0)}j=+(d|0);h=~~(j-+(f-d|0)*g);if((h|0)>=0){e=a+8|0;if((h|0)<(jg(c[e>>2]|0)|0)){e=h;g=1.0}else{g=+((jg(c[e>>2]|0)|0)+~d|0)/+(h-d|0);e=(jg(c[e>>2]|0)|0)+-1|0}}else{e=0;g=j/+(d-h|0)}return +(l+ +Yn(a,b,d,~~(+(b|0)+ +(k-b|0)*g),e)+-1.0)}function Yn(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0.0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;q=f-d|0;o=e-b|0;o=(((q|0)>-1?q:0-q|0)|0)>(((o|0)>-1?o:0-o|0)|0);q=o?e:f;l=o?f:e;p=o?b:d;n=o?d:b;j=l-n|0;j=(j|0)>-1?j:0-j|0;m=q-p|0;k=(m|0)>-1?m:0-m|0;h=(l|0)>(n|0)?1:-1;i=(q|0)>(p|0)?1:-1;l=h+l|0;a:do if((l|0)==(n|0)){e=0;r=11}else{a=c[a+8>>2]|0;b=0-j>>1;e=0;f=n;d=p;while(1){if(!((e|0)==1^(eq(a,o?d:f,o?f:d)|0))){if((e|0)==2){e=d;break}e=e+1|0}b=b+k|0;if((b|0)>0){if((d|0)==(q|0)){r=11;break a}b=b-j|0;d=d+i|0}f=f+h|0;if((f|0)==(l|0)){r=11;break a}}q=f-n|0;p=e-p|0;g=+P(+(+(($(p,p)|0)+($(q,q)|0)|0)))}while(0);if((r|0)==11)if((e|0)==2){r=l-n|0;g=+P(+(+(($(r,r)|0)+($(m,m)|0)|0)))}else g=s;return +g}function Zn(a,b,d,e){a=a|0;b=+b;d=+d;e=+e;ip(a,b,d);c[a>>2]=34428;g[a+16>>2]=e;c[a+20>>2]=1;return}function _n(a){a=a|0;return c[a+20>>2]|0}function $n(a){a=a|0;return +(+g[a+16>>2])}function ao(a,b,d,e){a=a|0;b=+b;d=+d;e=+e;if(+O(+(d-+ld[c[(c[a>>2]|0)+12>>2]&63](a)))<=b?+O(+(e-+ld[c[(c[a>>2]|0)+8>>2]&63](a)))<=b:0){e=+g[a+16>>2];d=+O(+(b-e));if(!(d<=1.0))a=d<=e;else a=1}else a=0;return a|0}function bo(a,b,d,e){a=a|0;b=+b;d=+d;e=+e;var f=0,h=0,j=0.0,k=0,l=0,m=0,n=0.0;l=i;i=i+16|0;h=l;f=a+20|0;m=c[f>>2]|0;k=m+1|0;j=+(k|0);n=(+(m|0)*+ld[c[(c[a>>2]|0)+8>>2]&63](a)+d)/j;d=+(c[f>>2]|0);d=(d*+ld[c[(c[a>>2]|0)+12>>2]&63](a)+b)/j;f=c[f>>2]|0;b=+g[a+16>>2];a=Sz(24)|0;o=0;wa(42,a|0,+n,+d);m=o;o=0;if(m&1){m=cc()|0;Uz(a);bc(m|0)}else{c[a>>2]=34428;g[a+16>>2]=(+(f|0)*b+e)/j;c[a+20>>2]=k;c[h>>2]=0;hs(h,a);i=l;return c[h>>2]|0}return 0}function co(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0.0,j=0.0;b=c[a>>2]|0;if((((((((((b|0)!=0?(d=c[a+4>>2]|0,(d|0)!=0):0)?(e=c[a+8>>2]|0,(e|0)!=0):0)?(f=c[a+12>>2]|0,(f|0)!=0):0)?(g=c[a+16>>2]|0,(g|0)!=0):0)?(h=g+(f+(e+(d+b)))|0,(h|0)>=7):0)?(i=+(h|0)/7.0,j=i*.5,+O(+(i-+(c[a>>2]|0)))<j):0)?+O(+(i-+(c[a+4>>2]|0)))<j:0)?+O(+(i*3.0-+(c[a+8>>2]|0)))<j*3.0:0)?+O(+(i-+(c[a+12>>2]|0)))<j:0)b=+O(+(i-+(c[a+16>>2]|0)))<j;else b=0;return b|0}function eo(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0.0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,t=0,u=0;u=i;i=i+32|0;r=u;n=jg(c[a>>2]|0)|0;c[r>>2]=0;c[r+4>>2]=0;c[r+8>>2]=0;c[r+12>>2]=0;c[r+16>>2]=0;p=r+8|0;a:do if((b|0)>-1){a=c[a>>2]|0;h=b;while(1){if(!(eq(a,d,h)|0)){m=a;break}c[p>>2]=(c[p>>2]|0)+1;if((h|0)>0)h=h+-1|0;else{g=s;break a}}j=r+4|0;if((h|0)>-1){while(1){l=eq(m,d,h)|0;a=c[j>>2]|0;if(l|(a|0)>(e|0)){l=a;break}c[j>>2]=a+1;if((h|0)>0)h=h+-1|0;else{g=s;break a}}if((l|0)<=(e|0)){b:do if((h|0)>-1)while(1){if(!(eq(m,d,h)|0)){t=11;break b}a=c[r>>2]|0;if((a|0)>(e|0)){k=a;break b}c[r>>2]=a+1;if((h|0)>0)h=h+-1|0;else{t=11;break}}else t=11;while(0);if((t|0)==11)k=c[r>>2]|0;if((k|0)<=(e|0)){a=b+1|0;c:do if((a|0)<(n|0))do{if(!(eq(m,d,a)|0))break c;c[p>>2]=(c[p>>2]|0)+1;a=a+1|0}while((a|0)<(n|0));while(0);if((a|0)!=(n|0)){j=r+12|0;d:do if((a|0)<(n|0))do{if(eq(m,d,a)|0)break d;h=c[j>>2]|0;if((h|0)>=(e|0))break d;c[j>>2]=h+1;a=a+1|0}while((a|0)<(n|0));while(0);if((a|0)!=(n|0)?(o=c[j>>2]|0,(o|0)<(e|0)):0){j=r+16|0;e:do if((a|0)<(n|0))while(1){if(!(eq(m,d,a)|0)){t=27;break e}h=c[j>>2]|0;if((h|0)>=(e|0))break e;c[j>>2]=h+1;a=a+1|0;if((a|0)>=(n|0)){t=27;break}}else t=27;while(0);if((t|0)==27)h=c[j>>2]|0;if(((h|0)<(e|0)?(q=c[p>>2]|0,t=h-f+k+l+q+o|0,(((t|0)>-1?t:0-t|0)*5|0)<(f<<1|0)):0)?co(r)|0:0)g=+(a-h-o|0)-+(q|0)*.5;else g=s}else g=s}else g=s}else g=s}else g=s}else g=s}else g=s;while(0);i=u;return +g}function fo(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0.0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,t=0,u=0;u=i;i=i+32|0;r=u;n=ig(c[a>>2]|0)|0;c[r>>2]=0;c[r+4>>2]=0;c[r+8>>2]=0;c[r+12>>2]=0;c[r+16>>2]=0;p=r+8|0;a:do if((b|0)>-1){a=c[a>>2]|0;h=b;while(1){if(!(eq(a,h,d)|0)){m=a;break}c[p>>2]=(c[p>>2]|0)+1;if((h|0)>0)h=h+-1|0;else{g=s;break a}}j=r+4|0;if((h|0)>-1){while(1){l=eq(m,h,d)|0;a=c[j>>2]|0;if(l|(a|0)>(e|0)){l=a;break}c[j>>2]=a+1;if((h|0)>0)h=h+-1|0;else{g=s;break a}}if((l|0)<=(e|0)){b:do if((h|0)>-1)while(1){if(!(eq(m,h,d)|0)){t=11;break b}a=c[r>>2]|0;if((a|0)>(e|0)){k=a;break b}c[r>>2]=a+1;if((h|0)>0)h=h+-1|0;else{t=11;break}}else t=11;while(0);if((t|0)==11)k=c[r>>2]|0;if((k|0)<=(e|0)){a=b+1|0;c:do if((a|0)<(n|0))do{if(!(eq(m,a,d)|0))break c;c[p>>2]=(c[p>>2]|0)+1;a=a+1|0}while((a|0)<(n|0));while(0);if((a|0)!=(n|0)){j=r+12|0;d:do if((a|0)<(n|0))do{if(eq(m,a,d)|0)break d;h=c[j>>2]|0;if((h|0)>=(e|0))break d;c[j>>2]=h+1;a=a+1|0}while((a|0)<(n|0));while(0);if((a|0)!=(n|0)?(o=c[j>>2]|0,(o|0)<(e|0)):0){j=r+16|0;e:do if((a|0)<(n|0))while(1){if(!(eq(m,a,d)|0)){t=27;break e}h=c[j>>2]|0;if((h|0)>=(e|0))break e;c[j>>2]=h+1;a=a+1|0;if((a|0)>=(n|0)){t=27;break}}else t=27;while(0);if((t|0)==27)h=c[j>>2]|0;if(((h|0)<(e|0)?(q=c[p>>2]|0,t=h-f+k+l+q+o|0,(((t|0)>-1?t:0-t|0)*5|0)<(f|0)):0)?co(r)|0:0)g=+(a-h-o|0)-+(q|0)*.5;else g=s}else g=s}else g=s}else g=s}else g=s}else g=s}else g=s;while(0);i=u;return +g}function go(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,h=0,j=0.0,l=0,m=0.0,n=0,p=0,q=0.0,r=0,s=0,t=0,u=0;s=i;i=i+16|0;r=s+8|0;p=s+4|0;n=s;h=b+8|0;l=c[h>>2]|0;u=c[b+12>>2]|0;t=c[b+16>>2]|0;f=(c[b+4>>2]|0)+(c[b>>2]|0)+l+u+t|0;b=~~(+(e-u-t|0)-+(l|0)*.5)>>>0;m=+eo(a,d,b,l,f);a:do if(((g[k>>2]=m,c[k>>2]|0)&2147483647)>>>0<=2139095040?(q=+fo(a,b,~~m>>>0,c[h>>2]|0,f),((g[k>>2]=q,c[k>>2]|0)&2147483647)>>>0<=2139095040):0){j=+(f|0)/7.0;l=a+4|0;h=a+8|0;e=(c[h>>2]|0)-(c[l>>2]|0)>>2;b:do if(!e)d=12;else{f=0;while(1){es(r,(c[l>>2]|0)+(f<<2)|0);b=c[r>>2]|0;o=0;d=Qa(44,b|0,+j,+m,+q)|0;u=o;o=0;if(u&1){d=9;break}if(d){d=6;break}fs(r);f=f+1|0;if(f>>>0>=e>>>0){d=12;break b}}do if((d|0)==6){e=c[l>>2]|0;o=0;b=Qa(45,b|0,+m,+q,+j)|0;u=o;o=0;if(u&1){b=cc()|0;break}else{c[p>>2]=b;hs(e+(f<<2)|0,b);fs(p);fs(r);b=1;break a}}else if((d|0)==9)b=cc()|0;while(0);fs(r)}while(0);do if((d|0)==12){b=Sz(24)|0;o=0;Ia(43,b|0,+q,+m,+j);u=o;o=0;if(u&1){u=cc()|0;Uz(b);b=u;break}c[n>>2]=0;hs(n,b);b=c[h>>2]|0;if((b|0)==(c[a+12>>2]|0)){o=0;ma(138,l|0,n|0);u=o;o=0;if(!(u&1))d=16}else{c[b>>2]=0;hs(b,c[n>>2]|0);c[h>>2]=(c[h>>2]|0)+4;d=16}do if((d|0)==16){b=c[a+20>>2]|0;if((b|0)!=0?(o=0,ma(c[(c[b>>2]|0)+8>>2]|0,b|0,c[n>>2]|0),u=o,o=0,u&1):0)break;fs(n);b=1;break a}while(0);b=cc()|0;fs(n)}while(0);bc(b|0)}else b=0;while(0);i=s;return b|0}function ho(b){b=b|0;var d=0,e=0.0,f=0,g=0,h=0,j=0,k=0,l=0.0,m=0.0,n=0.0,p=0.0,q=0,r=0,s=0;s=i;i=i+16|0;r=s+4|0;q=s;h=b+4|0;j=(c[b+8>>2]|0)-(c[h>>2]|0)>>2;if(j>>>0<2)d=0;else{c[r>>2]=0;hs(r,0);a:do if(!j)d=0;else{k=0;while(1){es(q,(c[h>>2]|0)+(k<<2)|0);d=c[q>>2]|0;o=0;f=qa(188,d|0)|0;g=o;o=0;if(g&1){f=14;break}if((f|0)>=(c[7024]|0)){g=c[r>>2]|0;if(g){f=7;break}hs(r,d)}fs(q);k=k+1|0;if(k>>>0>=j>>>0){d=0;break a}}if((f|0)==7){a[b+16>>0]=1;o=0;e=+Ka(c[(c[g>>2]|0)+8>>2]|0,g|0);b=o;o=0;if(((!(b&1)?(o=0,l=+Ka(c[(c[d>>2]|0)+8>>2]|0,d|0),b=o,o=0,!(b&1)):0)?(m=+O(+(e-l)),o=0,n=+Ka(c[(c[g>>2]|0)+12>>2]|0,g|0),b=o,o=0,!(b&1)):0)?(o=0,p=+Ka(c[(c[d>>2]|0)+12>>2]|0,d|0),b=o,o=0,!(b&1)):0){d=(~~(m-+O(+(n-p)))|0)/2|0;fs(q);break}d=cc()|0}else if((f|0)==14)d=cc()|0;fs(q);fs(r);bc(d|0)}while(0);fs(r)}i=s;return d|0}function io(a){a=a|0;var b=0.0,d=0.0,e=0.0,f=0,g=0,h=0.0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0;q=i;i=i+16|0;k=q+4|0;p=q;n=a+4|0;m=(c[a+8>>2]|0)-(c[n>>2]|0)>>2;a:do if(!m){a=0;h=0.0;l=8}else{a=0;j=0;d=0.0;while(1){es(k,(c[n>>2]|0)+(j<<2)|0);f=c[k>>2]|0;o=0;g=qa(188,f|0)|0;r=o;o=0;if(r&1)break;if((g|0)<(c[7024]|0))b=d;else{o=0;b=+Ka(44,f|0);r=o;o=0;if(r&1)break;a=a+1|0;b=d+b}fs(k);j=j+1|0;if(j>>>0>=m>>>0){h=b;l=8;break a}else d=b}a=cc()|0;fs(k)}while(0);b:do if((l|0)==8){if((a|0)<3)a=0;else{e=h/+(m>>>0);c:do if(!m)b=0.0;else{a=0;b=0.0;while(1){es(p,(c[n>>2]|0)+(a<<2)|0);o=0;d=+Ka(44,c[p>>2]|0);r=o;o=0;if(r&1)break;b=b+ +O(+(d-e));fs(p);a=a+1|0;if(a>>>0>=m>>>0)break c}a=cc()|0;fs(p);break b}while(0);a=b<=h*.05000000074505806}i=q;return a|0}while(0);bc(a|0);return 0}function jo(a,b){a=a|0;b=b|0;var d=0,e=0.0,f=0.0,h=0,j=0,k=0,l=0,m=0.0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0.0;t=i;i=i+16|0;p=t;o=t+12|0;q=t+8|0;r=t+4|0;s=b+4|0;n=b+8|0;b=c[n>>2]|0;d=c[s>>2]|0;h=b-d>>2;if(h>>>0<3){t=Ob(8)|0;zq(t,50219);c[t>>2]=29736;Hc(t|0,24,146)}if(h>>>0>3){if(!h){f=0.0;e=0.0}else{b=0;f=0.0;e=0.0;do{m=+$n(c[(c[s>>2]|0)+(b<<2)>>2]|0);e=e+m;f=f+m*m;b=b+1|0}while((b|0)!=(h|0))}u=+(h>>>0);m=e/u;f=+P(+(f/u-m*m));d=c[s>>2]|0;b=c[n>>2]|0;g[p>>2]=m;Ft(d,b,p);e=m*.20000000298023224;e=e<f?f:e;b=c[n>>2]|0;d=c[s>>2]|0;if(b-d>>2>>>0>3){l=0;do{if(+O(+(+$n(c[d+(l<<2)>>2]|0)-m))>e){h=c[s>>2]|0;j=h+((l<<2>>2)+1<<2)|0;k=c[n>>2]|0;if((j|0)!=(k|0)){b=h+(l<<2)|0;d=j;while(1){hs(b,c[d>>2]|0);d=d+4|0;if((d|0)==(k|0))break;else b=b+4|0}}d=h+(((k-j|0)>>>2)+l<<2)|0;b=c[n>>2]|0;if((b|0)!=(d|0))do{k=b+-4|0;c[n>>2]=k;fs(k);b=c[n>>2]|0}while((b|0)!=(d|0));b=l+-1|0}else b=l;l=b+1|0;b=c[n>>2]|0;d=c[s>>2]|0;k=b-d>>2}while(l>>>0<k>>>0&k>>>0>3)}}if(b-d>>2>>>0>3){h=b-d>>2;if(!h)e=0.0;else{j=0;e=0.0;do{e=e+ +$n(c[d+(j<<2)>>2]|0);j=j+1|0;b=c[n>>2]|0;d=c[s>>2]|0;h=b-d>>2}while(j>>>0<h>>>0)}g[p>>2]=e/+(h>>>0);Gt(d,b,p);b=c[n>>2]|0;d=c[s>>2]|0}if(b-d>>2>>>0>3){c[q>>2]=d+12;c[r>>2]=b;c[o>>2]=c[q>>2];c[p>>2]=c[r>>2];Ht(s,o,p)|0}It(a,3);hs(c[a>>2]|0,c[c[s>>2]>>2]|0);hs((c[a>>2]|0)+4|0,c[(c[s>>2]|0)+4>>2]|0);hs((c[a>>2]|0)+8|0,c[(c[s>>2]|0)+8>>2]|0);i=t;return}function ko(a,b){a=a|0;b=b|0;var d=0,e=0.0,f=0,g=0.0,h=0,j=0,k=0,l=0,m=0.0,n=0.0,p=0.0,q=0.0,r=0,s=0.0,t=0.0,u=0,v=0.0,w=0.0,x=0.0,y=0.0,z=0.0,A=0,B=0,C=0,D=0,E=0,F=0;E=i;i=i+48|0;d=E+36|0;f=E+32|0;h=E+28|0;j=E+24|0;k=E+20|0;l=E+16|0;C=E+12|0;D=E+8|0;A=E+4|0;B=E;Jt(d,c[b>>2]|0);Jt(f,(c[b>>2]|0)+4|0);o=0;m=+eb(43,d|0,f|0);F=o;o=0;do if(F&1){F=cc()|0;uq(f);uq(d);d=F}else{uq(f);uq(d);Jt(h,(c[b>>2]|0)+4|0);Jt(j,(c[b>>2]|0)+8|0);o=0;g=+eb(43,h|0,j|0);F=o;o=0;if(F&1){d=cc()|0;uq(j);uq(h);break}uq(j);uq(h);Jt(k,c[b>>2]|0);Jt(l,(c[b>>2]|0)+8|0);o=0;e=+eb(43,k|0,l|0);F=o;o=0;if(F&1){d=cc()|0;uq(l);uq(k);break}uq(l);uq(k);c[C>>2]=0;hs(C,0);c[D>>2]=0;hs(D,0);c[A>>2]=0;hs(A,0);do if(!(g>=m)|!(g>=e)){d=c[b>>2]|0;if(!(e>=g)|!(e>=m)){hs(C,c[d+8>>2]|0);hs(D,c[c[b>>2]>>2]|0);hs(A,c[(c[b>>2]|0)+4>>2]|0);break}else{hs(C,c[d+4>>2]|0);hs(D,c[c[b>>2]>>2]|0);hs(A,c[(c[b>>2]|0)+8>>2]|0);break}}else{hs(C,c[c[b>>2]>>2]|0);hs(D,c[(c[b>>2]|0)+4>>2]|0);hs(A,c[(c[b>>2]|0)+8>>2]|0)}while(0);d=c[A>>2]|0;o=0;e=+Ka(c[(c[d>>2]|0)+12>>2]|0,d|0);F=o;o=0;if(((((((!(F&1)?(r=c[C>>2]|0,o=0,s=+Ka(c[(c[r>>2]|0)+12>>2]|0,r|0),F=o,o=0,!(F&1)):0)?(t=e-s,u=c[D>>2]|0,o=0,v=+Ka(c[(c[u>>2]|0)+8>>2]|0,u|0),F=o,o=0,!(F&1)):0)?(o=0,w=+Ka(c[(c[r>>2]|0)+8>>2]|0,r|0),F=o,o=0,!(F&1)):0)?(x=t*(v-w),o=0,y=+Ka(c[(c[d>>2]|0)+8>>2]|0,d|0),F=o,o=0,!(F&1)):0)?(o=0,z=+Ka(c[(c[r>>2]|0)+8>>2]|0,r|0),F=o,o=0,!(F&1)):0)?(n=y-z,o=0,p=+Ka(c[(c[u>>2]|0)+12>>2]|0,u|0),F=o,o=0,!(F&1)):0)?(o=0,q=+Ka(c[(c[r>>2]|0)+12>>2]|0,r|0),F=o,o=0,!(F&1)):0){if(x<n*(p-q)){c[B>>2]=0;hs(B,u);hs(D,d);hs(A,c[B>>2]|0);fs(B)}o=0;ma(182,a|0,3);F=o;o=0;if(!(F&1)){hs(c[a>>2]|0,c[A>>2]|0);hs((c[a>>2]|0)+4|0,r);hs((c[a>>2]|0)+8|0,c[D>>2]|0);fs(A);fs(D);fs(C);i=E;return}}d=cc()|0;fs(A);fs(D);fs(C)}while(0);bc(d|0)}function lo(a,b){a=a|0;b=b|0;var d=0.0,e=0.0,f=0;f=c[a>>2]|0;e=+ld[c[(c[f>>2]|0)+8>>2]&63](f);f=c[b>>2]|0;e=e-+ld[c[(c[f>>2]|0)+8>>2]&63](f);a=c[a>>2]|0;d=+ld[c[(c[a>>2]|0)+12>>2]&63](a);b=c[b>>2]|0;d=d-+ld[c[(c[b>>2]|0)+12>>2]&63](b);return +(+P(+(e*e+d*d)))}function mo(b,d,e){b=b|0;d=d|0;e=e|0;Zp(b,d);d=b+4|0;c[d>>2]=0;c[d+4>>2]=0;c[d+8>>2]=0;a[d+12>>0]=0;we(b+20|0,e);return}function no(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0;A=i;i=i+80|0;y=A+68|0;x=A+48|0;B=A+36|0;v=A+24|0;w=A+12|0;z=A;d=dj(d)|0;t=jg(c[b>>2]|0)|0;u=ig(c[b>>2]|0)|0;e=((t*3|0)>>>0)/(c[7026]<<2>>>0)|0;k=c[7025]|0;e=d|(e|0)<(k|0)?k:e;k=c[b>>2]|0;d=e+-1|0;l=x+4|0;m=x+8|0;n=x+12|0;p=x+16|0;q=b+16|0;r=u+-1|0;if(d>>>0<t>>>0){s=(u|0)==0;do{c[x>>2]=0;c[x+4>>2]=0;c[x+8>>2]=0;c[x+12>>2]=0;c[x+16>>2]=0;if(s)f=0;else{j=0;h=0;f=0;do{g=j&1;do if(eq(k,f,d)|0){j=g+j|0;g=x+(j<<2)|0;c[g>>2]=(c[g>>2]|0)+1}else{if(g){g=x+(j<<2)|0;c[g>>2]=(c[g>>2]|0)+1;break}if((j|0)!=4){j=j+1|0;g=x+(j<<2)|0;c[g>>2]=(c[g>>2]|0)+1;break}if(!(co(x)|0)){c[x>>2]=c[m>>2];c[l>>2]=c[n>>2];c[m>>2]=c[p>>2];c[n>>2]=1;c[p>>2]=0;j=3;break}if(!(go(b,x,d,f)|0)){c[x>>2]=c[m>>2];c[l>>2]=c[n>>2];c[m>>2]=c[p>>2];c[n>>2]=1;c[p>>2]=0;j=3;break}if(!(a[q>>0]|0)){e=ho(b)|0;g=c[m>>2]|0;if((e|0)>(g|0)){d=d+-2+e-g|0;f=r}}else h=io(b)|0;c[x>>2]=0;c[x+4>>2]=0;c[x+8>>2]=0;c[x+12>>2]=0;c[x+16>>2]=0;j=0;e=2}while(0);f=f+1|0}while(f>>>0<u>>>0);f=h}if(co(x)|0?go(b,x,d,u)|0:0){e=c[x>>2]|0;if(a[q>>0]|0)f=io(b)|0}d=e+d|0}while(!(d>>>0>=t>>>0|f))}jo(B,b);o=0;ma(133,w|0,B|0);b=o;o=0;do if(!(b&1)){o=0;ma(134,v|0,w|0);b=o;o=0;if(b&1){d=cc()|0;Zr(w);break}Yr(B);c[B>>2]=c[v>>2];e=v+4|0;c[B+4>>2]=c[e>>2];b=v+8|0;c[B+8>>2]=c[b>>2];c[b>>2]=0;c[e>>2]=0;c[v>>2]=0;Zr(v);Zr(w);o=0;e=qa(111,20)|0;b=o;o=0;if(!(b&1)){o=0;ma(133,z|0,B|0);b=o;o=0;do if(!(b&1)){o=0;ma(135,e|0,z|0);b=o;o=0;if(b&1){d=cc()|0;Zr(z);break}else{c[y>>2]=0;_r(y,e);Zr(z);Zr(B);i=A;return c[y>>2]|0}}else d=cc()|0;while(0);Uz(e)}else C=31}else C=31;while(0);if((C|0)==31)d=cc()|0;Zr(B);bc(d|0);return 0}function oo(a,b){a=a|0;b=b|0;c[a+4>>2]=0;c[a>>2]=34452;es(a+8|0,c[b>>2]|0);es(a+12|0,(c[b>>2]|0)+4|0);es(a+16|0,(c[b>>2]|0)+8|0);return}function po(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;es(b,a+8|0);i=d;return c[b>>2]|0}function qo(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;es(b,a+12|0);i=d;return c[b>>2]|0}function ro(a){a=a|0;var b=0,d=0;d=i;i=i+16|0;b=d;es(b,a+16|0);i=d;return c[b>>2]|0}function so(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[a>>2]=b;c[a+4>>2]=d;FC(a+8|0,e,iC(e)|0);return}function to(a){a=a|0;return c[a>>2]|0}function uo(a){a=a|0;return a+8|0}function vo(a){a=a|0;if((a|0)>-1&(c[7027]|0)>(a|0))return c[28192+(a<<2)>>2]|0;else{a=Ob(8)|0;zq(a,50256);c[a>>2]=29736;Hc(a|0,24,146)}return 0}function wo(b,d){b=b|0;d=d|0;c[b+4>>2]=0;c[b>>2]=34468;c[b+8>>2]=vo(d>>>3&3)|0;a[b+12>>0]=d&7;return}function xo(a){a=a|0;return c[a+8>>2]|0}function yo(b){b=b|0;return a[b+12>>0]|0}function zo(a,b){a=a|0;b=b|0;b=b^a;return (c[28472+((b>>>4&15)<<2)>>2]|0)+(c[28472+((b&15)<<2)>>2]|0)+(c[28472+((b>>>8&15)<<2)>>2]|0)+(c[28472+((b>>>12&15)<<2)>>2]|0)+(c[28472+((b>>>16&15)<<2)>>2]|0)+(c[28472+((b>>>20&15)<<2)>>2]|0)+(c[28472+((b>>>24&15)<<2)>>2]|0)+(c[28472+(b>>>28<<2)>>2]|0)|0}function Ao(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;g=i;i=i+16|0;e=g+4|0;f=g;d=Bo(a,b)|0;c[f>>2]=d;do if(!d){d=c[7052]|0;o=0;d=Wa(112,d^a|0,d^b|0)|0;b=o;o=0;if(b&1){g=cc()|0;lt(f);bc(g|0)}else{c[e>>2]=d;break}}else{c[e>>2]=0;kt(e,d);d=c[e>>2]|0}while(0);lt(f);i=g;return d|0}function Bo(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0;p=i;i=i+16|0;d=p+4|0;n=p;k=c[7117]|0;m=(a|0)==(b|0);a:do if((k|0)>0){e=2147483647;h=0;f=0;while(1){j=c[28212+(f<<3)>>2]|0;if((j|0)==(a|0)|(j|0)==(b|0))break;g=zo(a,j)|0;if((g|0)<(e|0)){e=g;g=c[28212+(f<<3)+4>>2]|0}else g=h;if(!m?(l=zo(b,j)|0,(l|0)<(e|0)):0){e=l;g=c[28212+(f<<3)+4>>2]|0}f=f+1|0;if((f|0)>=(k|0)){f=g;g=12;break a}else h=g}e=Sz(16)|0;o=0;ma(183,e|0,c[28212+(f<<3)+4>>2]|0);n=o;o=0;if(n&1){d=cc()|0;Uz(e);g=18;break}else{c[d>>2]=0;kt(d,e);g=17;break}}else{e=2147483647;f=0;g=12}while(0);do if((g|0)==12){if((e|0)>=4){c[n>>2]=0;kt(n,0);c[d>>2]=0;kt(d,c[n>>2]|0);lt(n);g=17;break}e=Sz(16)|0;o=0;ma(183,e|0,f|0);n=o;o=0;if(n&1){d=cc()|0;Uz(e);g=18;break}else{c[d>>2]=0;kt(d,e);g=17;break}}while(0);if((g|0)==17){i=p;return c[d>>2]|0}else if((g|0)==18)bc(d|0);return 0}function Co(a){a=a|0;c[a+4>>2]=0;c[a>>2]=28544;o=0;ka(325,a+8|0);a=o;o=0;if(a&1){a=cc()|0;bc(a|0)}else return}function Do(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0;m=i;i=i+96|0;g=m+84|0;h=m+80|0;s=m+64|0;e=m+56|0;r=m+52|0;q=m+40|0;p=m+36|0;f=m+32|0;n=m+28|0;j=m+16|0;k=m+4|0;l=m;c[e>>2]=Kf(c[b>>2]|0)|0;o=0;ma(130,s|0,e|0);b=o;o=0;if(b&1){s=cc()|0;Yd(e);e=s}else{Yd(e);o=0;e=Wa(113,s|0,d|0)|0;b=o;o=0;if(b&1)e=cc()|0;else{c[r>>2]=e;o=0;ma(85,q|0,e|0);b=o;o=0;if(b&1)e=cc()|0;else{o=0;e=qa(118,e|0)|0;b=o;o=0;do if(b&1)e=cc()|0;else{c[f>>2]=e;o=0;d=Wa(86,a+8|0,f|0)|0;a=o;o=0;if(a&1){e=cc()|0;Yd(f);break}c[p>>2]=d;Yd(f);o=0;b=qa(111,40)|0;f=o;o=0;if(f&1)e=cc()|0;else{o=0;e=qa(116,d|0)|0;f=o;o=0;if(f&1)e=cc()|0;else{c[n>>2]=e;o=0;ma(86,j|0,d|0);f=o;o=0;do if(!(f&1)){oe(k,q);c[l>>2]=12;o=0;c[g>>2]=c[l>>2];ia(45,b|0,n|0,j|0,k|0,g|0);l=o;o=0;if(l&1){e=cc()|0;pe(k);Sd(j);break}else{c[h>>2]=0;Qe(h,b);pe(k);Sd(j);ne(n);aq(p);pe(q);ir(r);Qr(s);i=m;return c[h>>2]|0}}else e=cc()|0;while(0);ne(n)}Uz(b)}aq(p)}while(0);pe(q)}ir(r)}Qr(s)}bc(e|0);return 0}function Eo(a){a=a|0;c[a>>2]=28544;Fh(a+8|0);return}function Fo(a){a=a|0;Eo(a);Uz(a);return}function Go(a){a=a|0;return a+8|0}function Ho(a){a=a|0;return c[a>>2]|0}function Io(a){a=a|0;return c[a+4>>2]|0}function Jo(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;i=i+16|0;f=e;c[f>>2]=d;c[a>>2]=b;Kt(a+4|0,1,f);i=e;return}function Ko(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;h=i;i=i+16|0;f=h+4|0;g=h;c[f>>2]=d;c[g>>2]=e;c[a>>2]=b;d=a+4|0;Kt(d,1,f);b=a+8|0;f=c[b>>2]|0;if((f|0)==(c[a+12>>2]|0)){o=0;ma(184,d|0,g|0);a=o;o=0;if(a&1){h=cc()|0;rt(d);bc(h|0)}}else{c[f>>2]=e;c[b>>2]=(c[b>>2]|0)+4}i=h;return}function Lo(a){a=a|0;return c[a>>2]|0}function Mo(a){a=a|0;return a+4|0}function No(a){a=a|0;var b=0,d=0,e=0;e=a+4|0;d=a+8|0;a=c[e>>2]|0;if((c[d>>2]|0)!=(a|0)){b=0;do{a=c[a+(b<<2)>>2]|0;if(a)Uz(a);b=b+1|0;a=c[e>>2]|0}while(b>>>0<(c[d>>2]|0)-a>>2>>>0)}rt(e);return}
function Oo(){var a=0,b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,na=0,oa=0,pa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0,Ia=0,Ja=0,Ka=0,La=0,Ma=0,Na=0;La=i;i=i+960|0;Ja=La+768|0;Ha=La+736|0;Fa=La+704|0;Da=La+672|0;Ba=La+640|0;za=La+608|0;xa=La+584|0;va=La+560|0;ta=La+536|0;ra=La+512|0;oa=La+488|0;la=La+464|0;ja=La+440|0;ha=La+416|0;fa=La+392|0;da=La+368|0;ba=La+344|0;$=La+320|0;Z=La+296|0;X=La+272|0;V=La+256|0;T=La+240|0;R=La+224|0;P=La+208|0;N=La+192|0;L=La+176|0;J=La+160|0;H=La+144|0;F=La+128|0;D=La+112|0;B=La+96|0;z=La+80|0;x=La+64|0;v=La+48|0;t=La+40|0;r=La+32|0;p=La+24|0;m=La+16|0;k=La+8|0;h=La+952|0;l=La+948|0;n=La+944|0;q=La+940|0;s=La+936|0;u=La+932|0;w=La+928|0;y=La+924|0;A=La+920|0;C=La+916|0;E=La+912|0;G=La+908|0;I=La+904|0;K=La+900|0;M=La+896|0;O=La+892|0;Q=La+888|0;S=La+884|0;U=La+880|0;W=La+876|0;Y=La+872|0;_=La+868|0;aa=La+864|0;ca=La+860|0;ea=La+856|0;ga=La+852|0;ia=La+848|0;ka=La+844|0;na=La+840|0;pa=La+836|0;sa=La+832|0;ua=La+828|0;wa=La+824|0;ya=La+820|0;Aa=La+816|0;Ca=La+812|0;Ea=La+808|0;Ga=La+804|0;Ia=La+800|0;Ka=La+796|0;j=Sz(32)|0;o=0;f=Wa(114,0,La|0)|0;e=o;o=0;a:do if(!(e&1)?(o=0,g=qa(111,16)|0,e=o,o=0,!(e&1)):0){o=0;a=qa(111,8)|0;e=o;o=0;if(!(e&1)?(c[a>>2]=1,c[a+4>>2]=19,o=0,mb(104,g|0,7,a|0),e=o,o=0,!(e&1)):0){o=0;e=qa(111,16)|0;d=o;o=0;if(d&1){Ma=810;break}o=0;a=qa(111,8)|0;d=o;o=0;if(!(d&1)?(c[a>>2]=1,c[a+4>>2]=16,o=0,mb(104,e|0,10,a|0),d=o,o=0,!(d&1)):0){o=0;d=qa(111,16)|0;b=o;o=0;if(b&1){Ma=810;break}o=0;a=qa(111,8)|0;b=o;o=0;if(!(b&1)?(c[a>>2]=1,c[a+4>>2]=13,o=0,mb(104,d|0,13,a|0),b=o,o=0,!(b&1)):0){o=0;a=qa(111,16)|0;b=o;o=0;if(b&1){Ma=810;break}o=0;b=qa(111,8)|0;Na=o;o=0;if(!(Na&1)?(c[b>>2]=1,c[b+4>>2]=9,o=0,mb(104,a|0,17,b|0),Na=o,o=0,!(Na&1)):0){o=0;Oa(45,j|0,1,f|0,g|0,e|0,d|0,a|0);Na=o;o=0;if(Na&1){Ma=810;break}c[h>>2]=0;Nt(h,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[h>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,h|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(h);break a}while(0);Pt(h);h=Sz(32)|0;o=0;c[k>>2]=6;c[k+4>>2]=18;f=Wa(114,2,k|0)|0;Na=o;o=0;b:do if(Na&1)Ma=817;else{o=0;g=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=817;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=34;o=0;mb(104,g|0,10,a|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=817;break b}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=28;o=0;mb(104,e|0,16,a|0);Na=o;o=0;if(Na&1)break;o=0;d=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=817;break b}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=22;o=0;mb(104,d|0,22,a|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=817;break b}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=1;c[b+4>>2]=16;o=0;mb(104,a|0,28,b|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,h|0,2,f|0,g|0,e|0,d|0,a|0);Na=o;o=0;if(Na&1){Ma=817;break b}c[l>>2]=0;Nt(l,h);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[l>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,l|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(l);break a}while(0);Pt(l);h=Sz(32)|0;o=0;c[m>>2]=6;c[m+4>>2]=22;f=Wa(114,2,m|0)|0;Na=o;o=0;c:do if(Na&1)Ma=824;else{o=0;g=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=824;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=55;o=0;mb(104,g|0,15,a|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=824;break c}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=44;o=0;mb(104,e|0,26,a|0);Na=o;o=0;if(Na&1)break;o=0;d=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=824;break c}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=17;o=0;mb(104,d|0,18,a|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=824;break c}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=2;c[b+4>>2]=13;o=0;mb(104,a|0,22,b|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,h|0,3,f|0,g|0,e|0,d|0,a|0);Na=o;o=0;if(Na&1){Ma=824;break c}c[n>>2]=0;Nt(n,h);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[n>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,n|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(n);break a}while(0);Pt(n);h=Sz(32)|0;o=0;c[p>>2]=6;c[p+4>>2]=26;f=Wa(114,2,p|0)|0;Na=o;o=0;d:do if(Na&1)Ma=831;else{o=0;g=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=831;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=80;o=0;mb(104,g|0,20,a|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=831;break d}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=32;o=0;mb(104,e|0,18,a|0);Na=o;o=0;if(Na&1)break;o=0;d=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=831;break d}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=24;o=0;mb(104,d|0,26,a|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=831;break d}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=4;c[b+4>>2]=9;o=0;mb(104,a|0,16,b|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,h|0,4,f|0,g|0,e|0,d|0,a|0);Na=o;o=0;if(Na&1){Ma=831;break d}c[q>>2]=0;Nt(q,h);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[q>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,q|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(q);break a}while(0);Pt(q);j=Sz(32)|0;o=0;c[r>>2]=6;c[r+4>>2]=30;g=Wa(114,2,r|0)|0;Na=o;o=0;e:do if(Na&1)Ma=838;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=838;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=108;o=0;mb(104,h|0,26,a|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=838;break e}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=43;o=0;mb(104,f|0,24,a|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=838;break e}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=15;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=16;o=0;ub(69,e|0,18,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=838;break e}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=2;c[b+4>>2]=11;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=2;c[d+4>>2]=12;o=0;ub(69,a|0,22,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,5,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=838;break e}c[s>>2]=0;Nt(s,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[s>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,s|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(s);break a}while(0);Pt(s);h=Sz(32)|0;o=0;c[t>>2]=6;c[t+4>>2]=34;f=Wa(114,2,t|0)|0;Na=o;o=0;f:do if(Na&1)Ma=845;else{o=0;g=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=845;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=68;o=0;mb(104,g|0,18,a|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=845;break f}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=27;o=0;mb(104,e|0,16,a|0);Na=o;o=0;if(Na&1)break;o=0;d=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=845;break f}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=19;o=0;mb(104,d|0,24,a|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=845;break f}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=4;c[b+4>>2]=15;o=0;mb(104,a|0,28,b|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,h|0,6,f|0,g|0,e|0,d|0,a|0);Na=o;o=0;if(Na&1){Ma=845;break f}c[u>>2]=0;Nt(u,h);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[u>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,u|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(u);break a}while(0);Pt(u);j=Sz(32)|0;o=0;c[v>>2]=6;c[v+4>>2]=22;c[v+8>>2]=38;g=Wa(114,3,v|0)|0;Na=o;o=0;g:do if(Na&1)Ma=852;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=852;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=78;o=0;mb(104,h|0,20,a|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=852;break g}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=31;o=0;mb(104,f|0,18,a|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=852;break g}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=14;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=15;o=0;ub(69,e|0,18,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=852;break g}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=4;c[b+4>>2]=13;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=1;c[d+4>>2]=14;o=0;ub(69,a|0,26,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,7,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=852;break g}c[w>>2]=0;Nt(w,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[w>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,w|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(w);break a}while(0);Pt(w);j=Sz(32)|0;o=0;c[x>>2]=6;c[x+4>>2]=24;c[x+8>>2]=42;g=Wa(114,3,x|0)|0;Na=o;o=0;h:do if(Na&1)Ma=859;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=859;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=97;o=0;mb(104,h|0,24,a|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=859;break h}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=38;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=39;o=0;ub(69,f|0,22,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=859;break h}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=18;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=19;o=0;ub(69,e|0,22,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=859;break h}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=4;c[b+4>>2]=14;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=2;c[d+4>>2]=15;o=0;ub(69,a|0,26,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,8,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=859;break h}c[y>>2]=0;Nt(y,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[y>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,y|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(y);break a}while(0);Pt(y);j=Sz(32)|0;o=0;c[z>>2]=6;c[z+4>>2]=26;c[z+8>>2]=46;g=Wa(114,3,z|0)|0;Na=o;o=0;i:do if(Na&1)Ma=866;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=866;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=116;o=0;mb(104,h|0,30,a|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=866;break i}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=3;c[a+4>>2]=36;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=37;o=0;ub(69,f|0,22,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=866;break i}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=16;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=17;o=0;ub(69,e|0,20,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=866;break i}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=4;c[b+4>>2]=12;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=4;c[d+4>>2]=13;o=0;ub(69,a|0,24,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,9,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=866;break i}c[A>>2]=0;Nt(A,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[A>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,A|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(A);break a}while(0);Pt(A);j=Sz(32)|0;o=0;c[B>>2]=6;c[B+4>>2]=28;c[B+8>>2]=50;g=Wa(114,3,B|0)|0;Na=o;o=0;j:do if(Na&1)Ma=873;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=873;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=68;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=69;o=0;ub(69,h|0,18,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=873;break j}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=43;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=44;o=0;ub(69,f|0,26,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=873;break j}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=6;c[a+4>>2]=19;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=20;o=0;ub(69,e|0,24,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=873;break j}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=6;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=2;c[d+4>>2]=16;o=0;ub(69,a|0,28,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,10,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=873;break j}c[C>>2]=0;Nt(C,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[C>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,C|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(C);break a}while(0);Pt(C);j=Sz(32)|0;o=0;c[D>>2]=6;c[D+4>>2]=30;c[D+8>>2]=54;g=Wa(114,3,D|0)|0;Na=o;o=0;k:do if(Na&1)Ma=880;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=880;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=81;o=0;mb(104,h|0,20,a|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=880;break k}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=50;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=51;o=0;ub(69,f|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=880;break k}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=22;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=23;o=0;ub(69,e|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=880;break k}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=3;c[b+4>>2]=12;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=8;c[d+4>>2]=13;o=0;ub(69,a|0,24,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,11,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=880;break k}c[E>>2]=0;Nt(E,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[E>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,E|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(E);break a}while(0);Pt(E);j=Sz(32)|0;o=0;c[F>>2]=6;c[F+4>>2]=32;c[F+8>>2]=58;g=Wa(114,3,F|0)|0;Na=o;o=0;l:do if(Na&1)Ma=887;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=887;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=92;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=93;o=0;ub(69,h|0,24,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=887;break l}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=6;c[a+4>>2]=36;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=37;o=0;ub(69,f|0,22,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=887;break l}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=20;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=6;c[b+4>>2]=21;o=0;ub(69,e|0,26,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=887;break l}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=7;c[b+4>>2]=14;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=4;c[d+4>>2]=15;o=0;ub(69,a|0,28,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,12,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=887;break l}c[G>>2]=0;Nt(G,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[G>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,G|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(G);break a}while(0);Pt(G);j=Sz(32)|0;o=0;c[H>>2]=6;c[H+4>>2]=34;c[H+8>>2]=62;g=Wa(114,3,H|0)|0;Na=o;o=0;m:do if(Na&1)Ma=894;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=894;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=107;o=0;mb(104,h|0,26,a|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=894;break m}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=8;c[a+4>>2]=37;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=38;o=0;ub(69,f|0,22,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=894;break m}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=8;c[a+4>>2]=20;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=21;o=0;ub(69,e|0,24,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=894;break m}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=12;c[b+4>>2]=11;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=4;c[d+4>>2]=12;o=0;ub(69,a|0,22,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,13,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=894;break m}c[I>>2]=0;Nt(I,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[I>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,I|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(I);break a}while(0);Pt(I);j=Sz(32)|0;o=0;c[J>>2]=6;c[J+4>>2]=26;c[J+8>>2]=46;c[J+12>>2]=66;g=Wa(114,4,J|0)|0;Na=o;o=0;n:do if(Na&1)Ma=901;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=901;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=3;c[a+4>>2]=115;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=116;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=901;break n}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=40;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=5;c[b+4>>2]=41;o=0;ub(69,f|0,24,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=901;break n}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=11;c[a+4>>2]=16;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=5;c[b+4>>2]=17;o=0;ub(69,e|0,20,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=901;break n}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=11;c[b+4>>2]=12;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=5;c[d+4>>2]=13;o=0;ub(69,a|0,24,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,14,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=901;break n}c[K>>2]=0;Nt(K,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[K>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,K|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(K);break a}while(0);Pt(K);j=Sz(32)|0;o=0;c[L>>2]=6;c[L+4>>2]=26;c[L+8>>2]=48;c[L+12>>2]=70;g=Wa(114,4,L|0)|0;Na=o;o=0;o:do if(Na&1)Ma=908;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=908;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=5;c[a+4>>2]=87;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=88;o=0;ub(69,h|0,22,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=908;break o}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=5;c[a+4>>2]=41;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=5;c[b+4>>2]=42;o=0;ub(69,f|0,24,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=908;break o}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=5;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=7;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=908;break o}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=11;c[b+4>>2]=12;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=7;c[d+4>>2]=13;o=0;ub(69,a|0,24,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,15,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=908;break o}c[M>>2]=0;Nt(M,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[M>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,M|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(M);break a}while(0);Pt(M);j=Sz(32)|0;o=0;c[N>>2]=6;c[N+4>>2]=26;c[N+8>>2]=50;c[N+12>>2]=74;g=Wa(114,4,N|0)|0;Na=o;o=0;p:do if(Na&1)Ma=915;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=915;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=5;c[a+4>>2]=98;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=99;o=0;ub(69,h|0,24,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=915;break p}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=7;c[a+4>>2]=45;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=3;c[b+4>>2]=46;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=915;break p}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=15;c[a+4>>2]=19;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=20;o=0;ub(69,e|0,24,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=915;break p}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=3;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=13;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,16,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=915;break p}c[O>>2]=0;Nt(O,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[O>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,O|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(O);break a}while(0);Pt(O);j=Sz(32)|0;o=0;c[P>>2]=6;c[P+4>>2]=30;c[P+8>>2]=54;c[P+12>>2]=78;g=Wa(114,4,P|0)|0;Na=o;o=0;q:do if(Na&1)Ma=922;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=922;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=107;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=5;c[b+4>>2]=108;o=0;ub(69,h|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=922;break q}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=10;c[a+4>>2]=46;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=47;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=922;break q}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=22;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=15;c[b+4>>2]=23;o=0;ub(69,e|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=922;break q}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=2;c[b+4>>2]=14;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=17;c[d+4>>2]=15;o=0;ub(69,a|0,28,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,17,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=922;break q}c[Q>>2]=0;Nt(Q,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[Q>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,Q|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(Q);break a}while(0);Pt(Q);j=Sz(32)|0;o=0;c[R>>2]=6;c[R+4>>2]=30;c[R+8>>2]=56;c[R+12>>2]=82;g=Wa(114,4,R|0)|0;Na=o;o=0;r:do if(Na&1)Ma=929;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=929;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=5;c[a+4>>2]=120;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=121;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=929;break r}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=9;c[a+4>>2]=43;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=44;o=0;ub(69,f|0,26,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=929;break r}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=17;c[a+4>>2]=22;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=23;o=0;ub(69,e|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=929;break r}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=2;c[b+4>>2]=14;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=19;c[d+4>>2]=15;o=0;ub(69,a|0,28,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,18,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=929;break r}c[S>>2]=0;Nt(S,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[S>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,S|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(S);break a}while(0);Pt(S);j=Sz(32)|0;o=0;c[T>>2]=6;c[T+4>>2]=30;c[T+8>>2]=58;c[T+12>>2]=86;g=Wa(114,4,T|0)|0;Na=o;o=0;s:do if(Na&1)Ma=936;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=936;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=3;c[a+4>>2]=113;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=114;o=0;ub(69,h|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=936;break s}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=3;c[a+4>>2]=44;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=11;c[b+4>>2]=45;o=0;ub(69,f|0,26,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=936;break s}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=17;c[a+4>>2]=21;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=22;o=0;ub(69,e|0,26,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=936;break s}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=9;c[b+4>>2]=13;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=16;c[d+4>>2]=14;o=0;ub(69,a|0,26,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,19,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=936;break s}c[U>>2]=0;Nt(U,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[U>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,U|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(U);break a}while(0);Pt(U);j=Sz(32)|0;o=0;c[V>>2]=6;c[V+4>>2]=34;c[V+8>>2]=62;c[V+12>>2]=90;g=Wa(114,4,V|0)|0;Na=o;o=0;t:do if(Na&1)Ma=943;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=943;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=3;c[a+4>>2]=107;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=5;c[b+4>>2]=108;o=0;ub(69,h|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=943;break t}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=3;c[a+4>>2]=41;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=13;c[b+4>>2]=42;o=0;ub(69,f|0,26,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=943;break t}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=15;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=5;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=943;break t}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=15;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=10;c[d+4>>2]=16;o=0;ub(69,a|0,28,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,20,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=943;break t}c[W>>2]=0;Nt(W,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[W>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,W|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(W);break a}while(0);Pt(W);j=Sz(32)|0;o=0;c[X>>2]=6;c[X+4>>2]=28;c[X+8>>2]=50;c[X+12>>2]=72;c[X+16>>2]=94;g=Wa(114,5,X|0)|0;Na=o;o=0;u:do if(Na&1)Ma=950;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=950;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=116;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=117;o=0;ub(69,h|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=950;break u}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=17;c[a+4>>2]=42;o=0;mb(104,f|0,26,a|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=950;break u}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=17;c[a+4>>2]=22;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=6;c[b+4>>2]=23;o=0;ub(69,e|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=950;break u}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=19;c[b+4>>2]=16;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=6;c[d+4>>2]=17;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,21,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=950;break u}c[Y>>2]=0;Nt(Y,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[Y>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,Y|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(Y);break a}while(0);Pt(Y);h=Sz(32)|0;o=0;c[Z>>2]=6;c[Z+4>>2]=26;c[Z+8>>2]=50;c[Z+12>>2]=74;c[Z+16>>2]=98;f=Wa(114,5,Z|0)|0;Na=o;o=0;v:do if(Na&1)Ma=957;else{o=0;g=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=957;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=111;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=7;c[b+4>>2]=112;o=0;ub(69,g|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=957;break v}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=17;c[a+4>>2]=46;o=0;mb(104,e|0,28,a|0);Na=o;o=0;if(Na&1)break;o=0;d=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=957;break v}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=7;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=16;c[b+4>>2]=25;o=0;ub(69,d|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=957;break v}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=34;c[b+4>>2]=13;o=0;mb(104,a|0,24,b|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,h|0,22,f|0,g|0,e|0,d|0,a|0);Na=o;o=0;if(Na&1){Ma=957;break v}c[_>>2]=0;Nt(_,h);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[_>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,_|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(_);break a}while(0);Pt(_);j=Sz(32)|0;o=0;c[$>>2]=6;c[$+4>>2]=30;c[$+8>>2]=54;c[$+12>>2]=78;c[$+16>>2]=102;g=Wa(114,5,$|0)|0;Na=o;o=0;w:do if(Na&1)Ma=964;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=964;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=121;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=5;c[b+4>>2]=122;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=964;break w}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=47;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=14;c[b+4>>2]=48;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=964;break w}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=11;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=14;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=964;break w}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=16;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=14;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,23,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=964;break w}c[aa>>2]=0;Nt(aa,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[aa>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,aa|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(aa);break a}while(0);Pt(aa);j=Sz(32)|0;o=0;c[ba>>2]=6;c[ba+4>>2]=28;c[ba+8>>2]=54;c[ba+12>>2]=80;c[ba+16>>2]=106;g=Wa(114,5,ba|0)|0;Na=o;o=0;x:do if(Na&1)Ma=971;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=971;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=6;c[a+4>>2]=117;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=118;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=971;break x}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=6;c[a+4>>2]=45;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=14;c[b+4>>2]=46;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=971;break x}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=11;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=16;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=971;break x}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=30;c[b+4>>2]=16;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=2;c[d+4>>2]=17;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,24,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=971;break x}c[ca>>2]=0;Nt(ca,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[ca>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,ca|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(ca);break a}while(0);Pt(ca);j=Sz(32)|0;o=0;c[da>>2]=6;c[da+4>>2]=32;c[da+8>>2]=58;c[da+12>>2]=84;c[da+16>>2]=110;g=Wa(114,5,da|0)|0;Na=o;o=0;y:do if(Na&1)Ma=978;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=978;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=8;c[a+4>>2]=106;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=107;o=0;ub(69,h|0,26,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=978;break y}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=8;c[a+4>>2]=47;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=13;c[b+4>>2]=48;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=978;break y}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=7;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=22;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=978;break y}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=22;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=13;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,25,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=978;break y}c[ea>>2]=0;Nt(ea,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[ea>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,ea|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(ea);break a}while(0);Pt(ea);j=Sz(32)|0;o=0;c[fa>>2]=6;c[fa+4>>2]=30;c[fa+8>>2]=58;c[fa+12>>2]=86;c[fa+16>>2]=114;g=Wa(114,5,fa|0)|0;Na=o;o=0;z:do if(Na&1)Ma=985;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=985;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=10;c[a+4>>2]=114;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=2;c[b+4>>2]=115;o=0;ub(69,h|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=985;break z}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=19;c[a+4>>2]=46;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=47;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=985;break z}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=28;c[a+4>>2]=22;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=6;c[b+4>>2]=23;o=0;ub(69,e|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=985;break z}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=33;c[b+4>>2]=16;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=4;c[d+4>>2]=17;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,26,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=985;break z}c[ga>>2]=0;Nt(ga,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[ga>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,ga|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(ga);break a}while(0);Pt(ga);j=Sz(32)|0;o=0;c[ha>>2]=6;c[ha+4>>2]=34;c[ha+8>>2]=62;c[ha+12>>2]=90;c[ha+16>>2]=118;g=Wa(114,5,ha|0)|0;Na=o;o=0;A:do if(Na&1)Ma=992;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=992;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=8;c[a+4>>2]=122;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=123;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=992;break A}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=22;c[a+4>>2]=45;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=3;c[b+4>>2]=46;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=992;break A}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=8;c[a+4>>2]=23;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=26;c[b+4>>2]=24;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=992;break A}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=12;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=28;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,27,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=992;break A}c[ia>>2]=0;Nt(ia,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[ia>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,ia|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(ia);break a}while(0);Pt(ia);j=Sz(32)|0;o=0;c[ja>>2]=6;c[ja+4>>2]=26;c[ja+8>>2]=50;c[ja+12>>2]=74;c[ja+16>>2]=98;c[ja+20>>2]=122;g=Wa(114,6,ja|0)|0;Na=o;o=0;B:do if(Na&1)Ma=999;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=999;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=3;c[a+4>>2]=117;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=10;c[b+4>>2]=118;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=999;break B}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=3;c[a+4>>2]=45;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=23;c[b+4>>2]=46;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=999;break B}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=31;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=999;break B}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=11;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=31;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,28,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=999;break B}c[ka>>2]=0;Nt(ka,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[ka>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,ka|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(ka);break a}while(0);Pt(ka);j=Sz(32)|0;o=0;c[la>>2]=6;c[la+4>>2]=30;c[la+8>>2]=54;c[la+12>>2]=78;c[la+16>>2]=102;c[la+20>>2]=126;g=Wa(114,6,la|0)|0;Na=o;o=0;C:do if(Na&1)Ma=1006;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1006;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=7;c[a+4>>2]=116;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=7;c[b+4>>2]=117;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1006;break C}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=21;c[a+4>>2]=45;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=7;c[b+4>>2]=46;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1006;break C}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=1;c[a+4>>2]=23;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=37;c[b+4>>2]=24;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1006;break C}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=19;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=26;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,29,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1006;break C}c[na>>2]=0;Nt(na,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[na>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,na|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(na);break a}while(0);Pt(na);j=Sz(32)|0;o=0;c[oa>>2]=6;c[oa+4>>2]=26;c[oa+8>>2]=52;c[oa+12>>2]=78;c[oa+16>>2]=104;c[oa+20>>2]=130;g=Wa(114,6,oa|0)|0;Na=o;o=0;D:do if(Na&1)Ma=1013;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1013;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=5;c[a+4>>2]=115;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=10;c[b+4>>2]=116;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1013;break D}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=19;c[a+4>>2]=47;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=10;c[b+4>>2]=48;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1013;break D}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=15;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=25;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1013;break D}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=23;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=25;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,30,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1013;break D}c[pa>>2]=0;Nt(pa,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[pa>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,pa|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(pa);break a}while(0);Pt(pa);j=Sz(32)|0;o=0;c[ra>>2]=6;c[ra+4>>2]=30;c[ra+8>>2]=56;c[ra+12>>2]=82;c[ra+16>>2]=108;c[ra+20>>2]=134;g=Wa(114,6,ra|0)|0;Na=o;o=0;E:do if(Na&1)Ma=1020;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1020;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=13;c[a+4>>2]=115;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=3;c[b+4>>2]=116;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1020;break E}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=2;c[a+4>>2]=46;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=29;c[b+4>>2]=47;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1020;break E}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=42;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1020;break E}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=23;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=28;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,31,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1020;break E}c[sa>>2]=0;Nt(sa,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[sa>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,sa|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(sa);break a}while(0);Pt(sa);j=Sz(32)|0;o=0;c[ta>>2]=6;c[ta+4>>2]=34;c[ta+8>>2]=60;c[ta+12>>2]=86;c[ta+16>>2]=112;c[ta+20>>2]=138;g=Wa(114,6,ta|0)|0;Na=o;o=0;F:do if(Na&1)Ma=1027;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1027;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=17;c[a+4>>2]=115;o=0;mb(104,h|0,30,a|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1027;break F}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=10;c[a+4>>2]=46;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=23;c[b+4>>2]=47;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1027;break F}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=10;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=35;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1027;break F}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=19;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=35;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,32,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1027;break F}c[ua>>2]=0;Nt(ua,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[ua>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,ua|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(ua);break a}while(0);Pt(ua);j=Sz(32)|0;o=0;c[va>>2]=6;c[va+4>>2]=30;c[va+8>>2]=58;c[va+12>>2]=86;c[va+16>>2]=114;c[va+20>>2]=142;g=Wa(114,6,va|0)|0;Na=o;o=0;G:do if(Na&1)Ma=1034;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1034;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=17;c[a+4>>2]=115;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=1;c[b+4>>2]=116;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1034;break G}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=14;c[a+4>>2]=46;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=21;c[b+4>>2]=47;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1034;break G}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=29;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=19;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1034;break G}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=11;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=46;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,33,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1034;break G}c[wa>>2]=0;Nt(wa,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[wa>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,wa|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(wa);break a}while(0);Pt(wa);j=Sz(32)|0;o=0;c[xa>>2]=6;c[xa+4>>2]=34;c[xa+8>>2]=62;c[xa+12>>2]=90;c[xa+16>>2]=118;c[xa+20>>2]=146;g=Wa(114,6,xa|0)|0;Na=o;o=0;H:do if(Na&1)Ma=1041;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1041;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=13;c[a+4>>2]=115;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=6;c[b+4>>2]=116;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1041;break H}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=14;c[a+4>>2]=46;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=23;c[b+4>>2]=47;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1041;break H}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=44;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=7;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1041;break H}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=59;c[b+4>>2]=16;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=1;c[d+4>>2]=17;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,34,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1041;break H}c[ya>>2]=0;Nt(ya,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[ya>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,ya|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(ya);break a}while(0);Pt(ya);j=Sz(32)|0;o=0;c[za>>2]=6;c[za+4>>2]=30;c[za+8>>2]=54;c[za+12>>2]=78;c[za+16>>2]=102;c[za+20>>2]=126;c[za+24>>2]=150;g=Wa(114,7,za|0)|0;Na=o;o=0;I:do if(Na&1)Ma=1048;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1048;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=12;c[a+4>>2]=121;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=7;c[b+4>>2]=122;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1048;break I}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=12;c[a+4>>2]=47;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=26;c[b+4>>2]=48;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1048;break I}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=39;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=14;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1048;break I}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=22;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=41;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,35,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1048;break I}c[Aa>>2]=0;Nt(Aa,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[Aa>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,Aa|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(Aa);break a}while(0);Pt(Aa);j=Sz(32)|0;o=0;c[Ba>>2]=6;c[Ba+4>>2]=24;c[Ba+8>>2]=50;c[Ba+12>>2]=76;c[Ba+16>>2]=102;c[Ba+20>>2]=128;c[Ba+24>>2]=154;g=Wa(114,7,Ba|0)|0;Na=o;o=0;J:do if(Na&1)Ma=1055;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1055;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=6;c[a+4>>2]=121;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=14;c[b+4>>2]=122;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1055;break J}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=6;c[a+4>>2]=47;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=34;c[b+4>>2]=48;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1055;break J}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=46;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=10;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1055;break J}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=2;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=64;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,36,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1055;break J}c[Ca>>2]=0;Nt(Ca,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[Ca>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,Ca|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(Ca);break a}while(0);Pt(Ca);j=Sz(32)|0;o=0;c[Da>>2]=6;c[Da+4>>2]=28;c[Da+8>>2]=54;c[Da+12>>2]=80;c[Da+16>>2]=106;c[Da+20>>2]=132;c[Da+24>>2]=158;g=Wa(114,7,Da|0)|0;Na=o;o=0;K:do if(Na&1)Ma=1062;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1062;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=17;c[a+4>>2]=122;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=123;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1062;break K}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=29;c[a+4>>2]=46;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=14;c[b+4>>2]=47;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1062;break K}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=49;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=10;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1062;break K}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=24;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=46;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,37,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1062;break K}c[Ea>>2]=0;Nt(Ea,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[Ea>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,Ea|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(Ea);break a}while(0);Pt(Ea);j=Sz(32)|0;o=0;c[Fa>>2]=6;c[Fa+4>>2]=32;c[Fa+8>>2]=58;c[Fa+12>>2]=84;c[Fa+16>>2]=110;c[Fa+20>>2]=136;c[Fa+24>>2]=162;g=Wa(114,7,Fa|0)|0;Na=o;o=0;L:do if(Na&1)Ma=1069;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1069;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=4;c[a+4>>2]=122;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=18;c[b+4>>2]=123;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1069;break L}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=13;c[a+4>>2]=46;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=32;c[b+4>>2]=47;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1069;break L}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=48;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=14;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1069;break L}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=42;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=32;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,38,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1069;break L}c[Ga>>2]=0;Nt(Ga,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[Ga>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,Ga|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(Ga);break a}while(0);Pt(Ga);j=Sz(32)|0;o=0;c[Ha>>2]=6;c[Ha+4>>2]=26;c[Ha+8>>2]=54;c[Ha+12>>2]=82;c[Ha+16>>2]=110;c[Ha+20>>2]=138;c[Ha+24>>2]=166;g=Wa(114,7,Ha|0)|0;Na=o;o=0;M:do if(Na&1)Ma=1076;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1076;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=20;c[a+4>>2]=117;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=4;c[b+4>>2]=118;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1076;break M}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=40;c[a+4>>2]=47;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=7;c[b+4>>2]=48;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1076;break M}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=43;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=22;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1076;break M}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=10;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=67;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,39,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1076;break M}c[Ia>>2]=0;Nt(Ia,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[Ia>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,Ia|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(Ia);break a}while(0);Pt(Ia);j=Sz(32)|0;o=0;c[Ja>>2]=6;c[Ja+4>>2]=30;c[Ja+8>>2]=58;c[Ja+12>>2]=86;c[Ja+16>>2]=114;c[Ja+20>>2]=142;c[Ja+24>>2]=170;g=Wa(114,7,Ja|0)|0;Na=o;o=0;N:do if(Na&1)Ma=1083;else{o=0;h=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1083;break}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=19;c[a+4>>2]=118;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=6;c[b+4>>2]=119;o=0;ub(69,h|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;f=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1083;break N}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=18;c[a+4>>2]=47;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=31;c[b+4>>2]=48;o=0;ub(69,f|0,28,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;e=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1083;break N}o=0;a=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[a>>2]=34;c[a+4>>2]=24;o=0;b=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[b>>2]=34;c[b+4>>2]=25;o=0;ub(69,e|0,30,a|0,b|0);Na=o;o=0;if(Na&1)break;o=0;a=qa(111,16)|0;Na=o;o=0;if(Na&1){Ma=1083;break N}o=0;b=qa(111,8)|0;Na=o;o=0;do if(!(Na&1)){c[b>>2]=20;c[b+4>>2]=15;o=0;d=qa(111,8)|0;Na=o;o=0;if(Na&1)break;c[d>>2]=61;c[d+4>>2]=16;o=0;ub(69,a|0,30,b|0,d|0);Na=o;o=0;if(Na&1)break;o=0;Oa(45,j|0,40,g|0,h|0,f|0,e|0,a|0);Na=o;o=0;if(Na&1){Ma=1083;break N}c[Ka>>2]=0;Nt(Ka,j);a=c[7176]|0;do if(a>>>0<(c[7177]|0)>>>0){c[a>>2]=0;Nt(a,c[Ka>>2]|0);c[7176]=(c[7176]|0)+4}else{o=0;ma(185,28700,Ka|0);Na=o;o=0;if(!(Na&1))break;a=cc()|0;Pt(Ka);break a}while(0);Pt(Ka);i=La;return (c[7176]|0)-(c[7175]|0)>>2|0}while(0);Na=cc()|0;Uz(a);a=Na;break N}while(0);a=cc()|0;Uz(e);break N}while(0);a=cc()|0;Uz(f);break N}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1083)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break M}while(0);a=cc()|0;Uz(e);break M}while(0);a=cc()|0;Uz(f);break M}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1076)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break L}while(0);a=cc()|0;Uz(e);break L}while(0);a=cc()|0;Uz(f);break L}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1069)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break K}while(0);a=cc()|0;Uz(e);break K}while(0);a=cc()|0;Uz(f);break K}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1062)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break J}while(0);a=cc()|0;Uz(e);break J}while(0);a=cc()|0;Uz(f);break J}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1055)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break I}while(0);a=cc()|0;Uz(e);break I}while(0);a=cc()|0;Uz(f);break I}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1048)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break H}while(0);a=cc()|0;Uz(e);break H}while(0);a=cc()|0;Uz(f);break H}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1041)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break G}while(0);a=cc()|0;Uz(e);break G}while(0);a=cc()|0;Uz(f);break G}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1034)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break F}while(0);a=cc()|0;Uz(e);break F}while(0);a=cc()|0;Uz(f);break F}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1027)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break E}while(0);a=cc()|0;Uz(e);break E}while(0);a=cc()|0;Uz(f);break E}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1020)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break D}while(0);a=cc()|0;Uz(e);break D}while(0);a=cc()|0;Uz(f);break D}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1013)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break C}while(0);a=cc()|0;Uz(e);break C}while(0);a=cc()|0;Uz(f);break C}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==1006)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break B}while(0);a=cc()|0;Uz(e);break B}while(0);a=cc()|0;Uz(f);break B}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==999)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break A}while(0);a=cc()|0;Uz(e);break A}while(0);a=cc()|0;Uz(f);break A}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==992)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break z}while(0);a=cc()|0;Uz(e);break z}while(0);a=cc()|0;Uz(f);break z}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==985)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break y}while(0);a=cc()|0;Uz(e);break y}while(0);a=cc()|0;Uz(f);break y}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==978)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break x}while(0);a=cc()|0;Uz(e);break x}while(0);a=cc()|0;Uz(f);break x}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==971)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break w}while(0);a=cc()|0;Uz(e);break w}while(0);a=cc()|0;Uz(f);break w}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==964)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break v}while(0);a=cc()|0;Uz(d);break v}while(0);a=cc()|0;Uz(e);break v}while(0);a=cc()|0;Uz(g)}while(0);if((Ma|0)==957)a=cc()|0;Uz(h);break a}while(0);Na=cc()|0;Uz(a);a=Na;break u}while(0);a=cc()|0;Uz(e);break u}while(0);a=cc()|0;Uz(f);break u}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==950)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break t}while(0);a=cc()|0;Uz(e);break t}while(0);a=cc()|0;Uz(f);break t}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==943)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break s}while(0);a=cc()|0;Uz(e);break s}while(0);a=cc()|0;Uz(f);break s}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==936)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break r}while(0);a=cc()|0;Uz(e);break r}while(0);a=cc()|0;Uz(f);break r}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==929)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break q}while(0);a=cc()|0;Uz(e);break q}while(0);a=cc()|0;Uz(f);break q}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==922)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break p}while(0);a=cc()|0;Uz(e);break p}while(0);a=cc()|0;Uz(f);break p}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==915)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break o}while(0);a=cc()|0;Uz(e);break o}while(0);a=cc()|0;Uz(f);break o}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==908)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break n}while(0);a=cc()|0;Uz(e);break n}while(0);a=cc()|0;Uz(f);break n}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==901)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break m}while(0);a=cc()|0;Uz(e);break m}while(0);a=cc()|0;Uz(f);break m}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==894)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break l}while(0);a=cc()|0;Uz(e);break l}while(0);a=cc()|0;Uz(f);break l}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==887)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break k}while(0);a=cc()|0;Uz(e);break k}while(0);a=cc()|0;Uz(f);break k}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==880)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break j}while(0);a=cc()|0;Uz(e);break j}while(0);a=cc()|0;Uz(f);break j}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==873)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break i}while(0);a=cc()|0;Uz(e);break i}while(0);a=cc()|0;Uz(f);break i}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==866)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break h}while(0);a=cc()|0;Uz(e);break h}while(0);a=cc()|0;Uz(f);break h}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==859)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break g}while(0);a=cc()|0;Uz(e);break g}while(0);a=cc()|0;Uz(f);break g}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==852)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break f}while(0);a=cc()|0;Uz(d);break f}while(0);a=cc()|0;Uz(e);break f}while(0);a=cc()|0;Uz(g)}while(0);if((Ma|0)==845)a=cc()|0;Uz(h);break a}while(0);Na=cc()|0;Uz(a);a=Na;break e}while(0);a=cc()|0;Uz(e);break e}while(0);a=cc()|0;Uz(f);break e}while(0);a=cc()|0;Uz(h)}while(0);if((Ma|0)==838)a=cc()|0;Uz(j);break a}while(0);Na=cc()|0;Uz(a);a=Na;break d}while(0);a=cc()|0;Uz(d);break d}while(0);a=cc()|0;Uz(e);break d}while(0);a=cc()|0;Uz(g)}while(0);if((Ma|0)==831)a=cc()|0;Uz(h);break a}while(0);Na=cc()|0;Uz(a);a=Na;break c}while(0);a=cc()|0;Uz(d);break c}while(0);a=cc()|0;Uz(e);break c}while(0);a=cc()|0;Uz(g)}while(0);if((Ma|0)==824)a=cc()|0;Uz(h);break a}while(0);Na=cc()|0;Uz(a);a=Na;break b}while(0);a=cc()|0;Uz(d);break b}while(0);a=cc()|0;Uz(e);break b}while(0);a=cc()|0;Uz(g)}while(0);if((Ma|0)==817)a=cc()|0;Uz(h);break}Ma=cc()|0;Uz(a);a=Ma;Ma=815;break}a=cc()|0;Uz(d);Ma=815;break}a=cc()|0;Uz(e);Ma=815;break}a=cc()|0;Uz(g);Ma=815}else Ma=810;while(0);if((Ma|0)==810){a=cc()|0;Ma=815}if((Ma|0)==815)Uz(j);bc(a|0);return 0}

// EMSCRIPTEN_END_FUNCS
var Xc=[h_,h_,iM,h_,jM,h_,kM,h_,lM,h_,mM,h_,nM,h_,oM,h_,pM,h_,qM,h_,rM,h_,sM,h_,tM,h_,uM,h_,vM,h_,wM,h_,xM,h_,yM,h_,zM,h_,AM,h_,BM,h_,Ii,kG,oG,iH,mH,rH,tH,Di,TJ,cK,h_,h_,h_,h_,h_,h_,h_,h_,h_,h_,h_,h_];var Yc=[i_,i_,DM,i_,EM,i_,FM,i_,GM,i_,HM,i_,IM,i_,JM,i_,KM,i_,LM,i_,MM,i_,NM,i_,OM,i_,PM,i_,QM,i_,RM,i_,SM,i_,TM,i_,UM,i_,VM,i_,WM,i_,xH,DH,Lm,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_,i_];var Zc=[j_,j_,YM,j_,ZM,j_,_M,j_,$M,j_,aN,j_,bN,j_,cN,j_,dN,j_,eN,j_,fN,j_,gN,j_,hN,j_,iN,j_,jN,j_,kN,j_,lN,j_,mN,j_,nN,j_,oN,j_,pN,j_,GA,FA,CA,bp,wg,Hh,HC,xl,dm,fm,Wm,rg,hg,j_,j_,j_,j_,j_,j_,j_,j_,j_];var _c=[k_,k_,rN,k_,sN,k_,tN,k_,uN,k_,vN,k_,wN,k_,xN,k_,yN,k_,zN,k_,AN,k_,BN,k_,CN,k_,DN,k_,EN,k_,FN,k_,GN,k_,HN,k_,IN,k_,JN,k_,KN,k_,ue,ve,Sd,Be,Ee,Fe,pe,Ue,bf,cf,Df,Ef,Hf,If,Rf,Sf,Uf,Vf,eg,fg,Fg,Gg,Sg,Tg,$g,ah,Lh,Mh,Yh,Zh,eu,fu,Si,Ti,jj,kj,gu,hu,vj,wj,Dj,Ej,Lj,Mj,Pj,Qj,Uj,Wj,Vj,Xj,dk,ek,iu,ju,rk,sk,ku,lu,mu,nu,ou,pu,qu,ru,Yk,Zk,su,tu,uu,vu,il,jl,wu,xu,Cl,Dl,yu,zu,Cm,Dm,$o,Au,Kn,Ln,Qr,Bu,Eo,Fo,Xo,Yo,cp,dp,jp,kp,qy,lz,jz,kz,hz,iz,bz,cz,Nu,az,Aq,$y,Wy,Xy,nq,Qy,FD,HD,GD,ID,Nq,Ny,Oy,Py,Fy,Hy,Dy,vy,wy,Uq,uy,sy,ry,py,ny,oy,ky,ly,hy,fy,gy,yr,cy,ay,by,Tx,Ux,Ww,Is,Vw,Mw,At,Pv,Nv,Ov,on,Jv,Dv,Bv,zv,xv,vv,tv,rv,fv,bv,Pu,Qu,Ou,mv,nv,Fs,Nw,Tw,Uw,cx,Yx,Zx,Ry,Sy,Xz,Yz,cA,dA,hA,iA,kA,nA,lA,mA,oA,pA,qA,rA,nD,oD,QD,RD,hD,SD,QL,TD,UD,WD,eI,_D,$D,dE,eE,sE,tE,ME,NE,$E,aF,mF,nF,LF,MF,hG,jG,mG,nG,qG,rG,BG,CG,MG,NG,XG,YG,gH,hH,pH,qH,vH,wH,BH,CH,HH,IH,MH,NH,UH,VH,wI,xI,SJ,PI,pJ,qJ,rJ,sJ,VD,dI,gI,GI,XI,dJ,lJ,mJ,OL,PL,Co,Tj,_j,Vd,ff,Xf,Zg,Zf,pD,hj,ih,ti,op,aj,Wh,_e,uk,Ak,nk,Pk,fk,Ik,ll,Mk,El,bm,xn,yz,zz,lq,xz,wz,IC,br,tz,qz,Xq,pz,oz,nz,mz,fj,DD,QA,oC,hB,jH,lH,fI,aL,hL,iL,jL,kL,lL,mL,ZC,zC,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_,k_];var $c=[l_,l_,MN,l_,NN,l_,ON,l_,PN,l_,QN,l_,RN,l_,SN,l_,TN,l_,UN,l_,VN,l_,WN,l_,XN,l_,YN,l_,ZN,l_,_N,l_,$N,l_,aO,l_,bO,l_,cO,l_,dO,l_,Td,oj,qD,uG,vG,wG,xG,zG,AG,FG,GG,HG,IG,KG,LG,QG,RG,SG,TG,VG,WG,$G,aH,bH,cH,eH,fH,LH,QH,xJ,zJ,BJ,yJ,AJ,CJ,Ce,Oe,Cj,Rg,Gf,EC,Ge,nf,Dg,tg,Rd,ij,fq,Tf,kq,Eh,QC,Nh,rq,rf,vg,xg,Bq,vf,Cq,Eq,_g,mD,Lq,Mq,Cf,Hg,Eg,cg,gh,Ng,er,OC,zi,nr,vr,_h,bi,ki,Ar,Er,Vq,Gr,Nr,Or,mj,Pr,fp,Nn,Sr,Sj,Xr,ko,oo,$r,bs,gs,Kj,is,ak,_k,ls,hk,ok,gD,ns,cr,_f,al,us,ys,ul,sp,rp,Oh,Th,Uh,wp,Ll,Ml,am,Ps,Ts,Vs,Ws,Zs,at,Ss,dt,ht,it,qs,Em,ot,ut,wt,xt,cn,fn,jn,It,wo,Lt,Ot,St,Hp,vp,Wt,Xt,Yt,cu,Tt,yp,dz,Mx,Ew,iy,Jx,_x,Rx,Ru,Iw,Ow,Kw,Gw,Dw,tw,Tv,Mu,Lv,hv,ss,Du,kv,Rw,Ut,JD,uz,Oz,kD,GL,bD,aD,wK,xK,yK,zK,AK,BK,OI,CK,DK,EK,FK,GK,HK,IK,JK,KK,LK,MK,NK,OK,PK,QK,RK,SK,TK,UK,VK,WK,XK,YK,_K,sL,HL,FL,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_,l_];var ad=[m_,m_,fO,m_,gO,m_,hO,m_,iO,m_,jO,m_,kO,m_,lO,m_,mO,m_,nO,m_,oO,m_,pO,m_,qO,m_,rO,m_,sO,m_,tO,m_,uO,m_,vO,m_,wO,m_,xO,m_,yO,m_,Vn,fE,gE,hE,iE,jE,kE,lE,mE,nE,oE,pE,uE,vE,wE,xE,yE,zE,AE,BE,CE,DE,EE,TE,VE,eF,gF,pF,qF,rF,tF,vF,OF,PF,QF,SF,UF,AH,GH,tf,Fi,ey,oK,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_,m_];var bd=[n_,n_,AO,n_,BO,n_,CO,n_,DO,n_,EO,n_,FO,n_,GO,n_,HO,n_,IO,n_,JO,n_,KO,n_,LO,n_,MO,n_,NO,n_,OO,n_,PO,n_,QO,n_,RO,n_,SO,n_,TO,n_,xj,zj,Bj,Aj,du,Kg,Vg,pj,rj,sj,tj,Lk,Ok,rl,Kl,uD,vD,Ky,yD,Zz,eA,jA,HB,xD,MD,oF,EJ,GJ,IJ,OJ,QJ,KJ,MJ,NF,FJ,HJ,JJ,PJ,RJ,LJ,NJ,sG,tG,yG,DG,EG,JG,OG,PG,UG,ZG,_G,dH,TI,UI,WI,tJ,vJ,uJ,wJ,KI,LI,NI,$I,aJ,cJ,hJ,iJ,kJ,Sz,ep,Ph,gp,of,ug,Xe,Cg,hf,Wf,ig,jg,Ze,Ye,xq,Ff,Jg,fh,th,kh,lh,wh,xh,sh,Ai,Yi,Ji,Ki,Ni,lg,ji,Lf,Mf,hp,ej,co,qo,po,ro,Kf,Go,yk,zk,Rh,Vk,Uk,dj,Of,Pf,nl,Ul,im,hm,sm,tm,ym,qm,Um,en,yo,mn,_o,Ro,Ho,Io,Lo,un,Bn,qg,uo,dn,xo,hn,Uo,So,Qo,Mn,_n,Vo,Ap,gj,lD,lB,jC,o_,p_,q_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_,n_];var cd=[r_,r_,VO,r_,WO,r_,XO,r_,YO,r_,ZO,r_,_O,r_,$O,r_,aP,r_,bP,r_,cP,r_,dP,r_,eP,r_,fP,r_,gP,r_,hP,r_,iP,r_,jP,r_,kP,r_,lP,r_,mP,r_,dh,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_,r_];var dd=[s_,s_,oP,s_,pP,s_,qP,s_,rP,s_,sP,s_,tP,s_,uP,s_,vP,s_,wP,s_,xP,s_,yP,s_,zP,s_,AP,s_,BP,s_,CP,s_,DP,s_,EP,s_,FP,s_,GP,s_,HP,s_,kH,sH,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_,s_];var ed=[t_,t_,JP,t_,KP,t_,LP,t_,MP,t_,NP,t_,OP,t_,PP,t_,QP,t_,RP,t_,SP,t_,TP,t_,UP,t_,VP,t_,WP,t_,XP,t_,YP,t_,ZP,t_,_P,t_,$P,t_,aQ,t_,ip,kl,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_,t_];var fd=[u_,u_,cQ,u_,dQ,u_,eQ,u_,fQ,u_,gQ,u_,hQ,u_,iQ,u_,jQ,u_,kQ,u_,lQ,u_,mQ,u_,nQ,u_,oQ,u_,pQ,u_,qQ,u_,rQ,u_,sQ,u_,tQ,u_,uQ,u_,vQ,u_,af,Ig,Xh,Do,ck,dl,gk,qk,vk,Bk,tl,Qk,$k,bl,pl,ml,an,rD,wD,AD,Kv,Ev,Cv,Av,yv,wv,uv,sv,sA,tA,zA,uC,JB,IB,KB,JL,KL,ZD,cE,JH,OH,zI,BI,EI,hI,oI,rI,uI,RC,xf,Bf,rh,mh,Dh,Bi,Gi,Hj,gl,pk,NC,VC,el,Jf,Vl,Xl,Hs,lm,jm,pm,Bm,km,Zm,jt,Pl,_l,Un,Yu,Tu,rC,kB,tK,vK,AB,zB,uB,UB];var gd=[v_,v_,xQ,v_,yQ,v_,zQ,v_,AQ,v_,BQ,v_,CQ,v_,DQ,v_,EQ,v_,FQ,v_,GQ,v_,HQ,v_,IQ,v_,JQ,v_,KQ,v_,LQ,v_,MQ,v_,NQ,v_,OQ,v_,PQ,v_,QQ,v_,zH,FH,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_,v_];var hd=[w_,w_,SQ,w_,TQ,w_,UQ,w_,VQ,w_,WQ,w_,XQ,w_,YQ,w_,ZQ,w_,_Q,w_,$Q,w_,aR,w_,bR,w_,cR,w_,dR,w_,eR,w_,fR,w_,gR,w_,hR,w_,iR,w_,jR,w_,Iy,JA,IA,HA,sD,KH,PH,We,Ag,wl,sn,w_,w_,w_,w_,w_,w_,w_,w_,w_,w_,w_];var id=[x_,x_,lR,x_,mR,x_,nR,x_,oR,x_,pR,x_,qR,x_,rR,x_,sR,x_,tR,x_,uR,x_,vR,x_,wR,x_,xR,x_,yR,x_,zR,x_,AR,x_,BR,x_,CR,x_,DR,x_,ER,x_,Rn,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_,x_];var jd=[y_,y_,GR,y_,HR,y_,IR,y_,JR,y_,KR,y_,LR,y_,MR,y_,NR,y_,OR,y_,PR,y_,QR,y_,RR,y_,SR,y_,TR,y_,UR,y_,VR,y_,WR,y_,XR,y_,YR,y_,ZR,y_,Tn,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_,y_];var kd=[z_,z_,$R,z_,aS,z_,bS,z_,cS,z_,dS,z_,eS,z_,fS,z_,gS,z_,hS,z_,iS,z_,jS,z_,kS,z_,lS,z_,mS,z_,nS,z_,oS,z_,pS,z_,qS,z_,rS,z_,sS,z_,Dn,Zn,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_,z_];var ld=[A_,A_,uS,A_,vS,A_,wS,A_,xS,A_,yS,A_,zS,A_,AS,A_,BS,A_,CS,A_,DS,A_,ES,A_,FS,A_,GS,A_,HS,A_,IS,A_,JS,A_,KS,A_,LS,A_,MS,A_,NS,A_,lp,mp,$n,Jm,A_,A_,A_,A_,A_,A_,A_,A_,A_,A_,A_,A_,A_,A_,A_,A_,A_,A_];var md=[B_,B_,PS,B_,QS,B_,RS,B_,SS,B_,TS,B_,US,B_,VS,B_,WS,B_,XS,B_,YS,B_,ZS,B_,_S,B_,$S,B_,aT,B_,bT,B_,cT,B_,dT,B_,eT,B_,fT,B_,gT,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_,B_];var nd=[C_,C_,iT,C_,jT,C_,kT,C_,lT,C_,mT,C_,nT,C_,oT,C_,pT,C_,qT,C_,rT,C_,sT,C_,tT,C_,uT,C_,vT,C_,wT,C_,xT,C_,yT,C_,zT,C_,AT,C_,BT,C_,Wg,Gj,Pm,Wo,SE,YE,dF,iF,C_,C_,C_,C_,C_,C_,C_,C_,C_,C_,C_,C_,C_,C_];var od=[D_,D_,DT,D_,ET,D_,FT,D_,GT,D_,HT,D_,IT,D_,JT,D_,KT,D_,LT,D_,MT,D_,NT,D_,OT,D_,PT,D_,QT,D_,RT,D_,ST,D_,TT,D_,UT,D_,VT,D_,WT,D_,En,Fn,ao,bo,D_,D_,D_,D_,D_,D_,D_,D_,D_,D_,D_,D_,D_,D_,D_,D_,D_,D_];var pd=[E_,E_,YT,E_,ZT,E_,_T,E_,$T,E_,aU,E_,bU,E_,cU,E_,dU,E_,eU,E_,fU,E_,gU,E_,hU,E_,iU,E_,jU,E_,kU,E_,lU,E_,mU,E_,nU,E_,oU,E_,pU,E_,Nm,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_,E_];var qd=[F_,F_,rU,F_,sU,F_,tU,F_,uU,F_,vU,F_,wU,F_,xU,F_,yU,F_,zU,F_,AU,F_,BU,F_,CU,F_,DU,F_,EU,F_,FU,F_,GU,F_,HU,F_,IU,F_,JU,F_,KU,F_,nH,uH,yH,EH,F_,F_,F_,F_,F_,F_,F_,F_,F_,F_,F_,F_,F_,F_,F_,F_,F_,F_];var rd=[G_,G_,MU,G_,NU,G_,OU,G_,PU,G_,QU,G_,RU,G_,SU,G_,TU,G_,UU,G_,VU,G_,WU,G_,XU,G_,YU,G_,ZU,G_,_U,G_,$U,G_,aV,G_,bV,G_,cV,G_,dV,G_,$e,Lg,Ug,ap,$j,Al,Il,Ly,My,zD,BD,yI,AI,CI,mI,pI,sI,gf,jf,kf,lf,LD,Pq,Qq,Yq,eh,nh,oh,zh,ph,yh,qh,Ah,Bh,Ch,vi,$h,ai,gr,mi,np,Hi,Qn,cs,zn,bk,bg,ag,cj,Qh,Sh,PC,Zl,mm,vm,zm,nm,um,om,wm,xm,Am,Qs,ft,Fm,kg,KC,Jq,Cn,no,Bo,Pn,Mt,cI,jB,iB,_C,G_,G_,G_,G_,G_,G_,G_,G_,G_];var sd=[H_,H_,fV,H_,gV,H_,hV,H_,iV,H_,jV,H_,kV,H_,lV,H_,mV,H_,nV,H_,oV,H_,pV,H_,qV,H_,rV,H_,sV,H_,tV,H_,uV,H_,vV,H_,wV,H_,xV,H_,yV,H_,yj,qj,XD,aE,OE,PE,UE,_E,bF,cF,fF,kF,FI,SI,VI,vI,JI,MI,_I,bJ,gJ,jJ,yf,Af,zg,Ei,Og,Nf,BB,xB,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_,H_];var td=[I_,I_,AV,I_,BV,I_,CV,I_,DV,I_,EV,I_,FV,I_,GV,I_,HV,I_,IV,I_,JV,I_,KV,I_,LV,I_,MV,I_,NV,I_,OV,I_,PV,I_,QV,I_,RV,I_,SV,I_,TV,I_,Wn,pp,vL,uL,tL,I_,I_,I_,I_,I_,I_,I_,I_,I_,I_,I_,I_,I_,I_,I_,I_,I_];var ud=[J_,J_,VV,J_,WV,J_,XV,J_,YV,J_,ZV,J_,_V,J_,$V,J_,aW,J_,bW,J_,cW,J_,dW,J_,eW,J_,fW,J_,gW,J_,hW,J_,iW,J_,jW,J_,kW,J_,lW,J_,mW,J_,Pg,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_,J_];var vd=[K_,K_,oW,K_,pW,K_,qW,K_,rW,K_,sW,K_,tW,K_,uW,K_,vW,K_,wW,K_,xW,K_,yW,K_,zW,K_,AW,K_,BW,K_,CW,K_,DW,K_,EW,K_,FW,K_,GW,K_,HW,K_,Jn,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_,K_];var wd=[L_,L_,JW,L_,KW,L_,LW,L_,MW,L_,NW,L_,OW,L_,PW,L_,QW,L_,RW,L_,SW,L_,TW,L_,UW,L_,VW,L_,WW,L_,XW,L_,YW,L_,ZW,L_,_W,L_,$W,L_,aX,L_,qp,lo,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_,L_];var xd=[M_,M_,cX,M_,dX,M_,eX,M_,fX,M_,gX,M_,hX,M_,iX,M_,jX,M_,kX,M_,lX,M_,mX,M_,nX,M_,oX,M_,pX,M_,qX,M_,rX,M_,sX,M_,tX,M_,uX,M_,vX,M_,lj,Qg,Rz,rE,XH,YH,ZH,UA,WA,VA,M_,M_,M_,M_,M_,M_,M_,M_,M_,M_,M_,M_];var yd=[N_,N_,xX,N_,yX,N_,zX,N_,AX,N_,BX,N_,CX,N_,DX,N_,EX,N_,FX,N_,GX,N_,HX,N_,IX,N_,JX,N_,KX,N_,LX,N_,MX,N_,NX,N_,OX,N_,PX,N_,QX,N_,Sn,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_,N_];var zd=[O_,O_,SX,O_,TX,O_,UX,O_,VX,O_,WX,O_,XX,O_,YX,O_,ZX,O_,_X,O_,$X,O_,aY,O_,bY,O_,cY,O_,dY,O_,eY,O_,fY,O_,gY,O_,hY,O_,iY,O_,jY,O_,Jk,vl,Nk,ql,ol,Fl,DI,jI,kI,lI,tI,uf,Mg,ni,go,Yf,zl,Nl,Wl,Mm,wn,In,bK,nK,yB,fB,vB,BL,AL,zL,yL,xL,wL,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_,O_];var Ad=[P_,P_,lY,P_,mY,P_,nY,P_,oY,P_,pY,P_,qY,P_,rY,P_,sY,P_,tY,P_,uY,P_,vY,P_,wY,P_,xY,P_,yY,P_,zY,P_,AY,P_,BY,P_,CY,P_,DY,P_,EY,P_,Jj,Nj,Rj,IL,ND,ae,Zd,ee,ge,he,Bg,sg,dg,Q_,Gh,FC,qf,sf,Kq,og,Wq,uh,Ih,oi,pi,qi,ri,li,ui,Li,Oj,mo,ds,ms,hl,De,tk,wk,MC,Ck,Rk,Sk,Xk,Ol,Es,Gs,rm,em,Gm,Hm,Im,Tm,Vm,Xs,Ym,bt,nn,pn,qn,tn,rn,yn,Jo,tp,up,Cp,Dp,Ep,Fp,vz,Lx,jv,Qw,PD,rK,sK,uK,XC,ML,P_,P_,P_,P_,P_,P_,P_];var Bd=[R_,R_,GY,R_,HY,R_,IY,R_,JY,R_,KY,R_,LY,R_,MY,R_,NY,R_,OY,R_,PY,R_,QY,R_,RY,R_,SY,R_,TY,R_,UY,R_,VY,R_,WY,R_,XY,R_,YY,R_,ZY,R_,S_,NA,T_,OA,MA,U_,R_,R_,R_,R_,R_,R_,R_,R_,R_,R_,R_,R_,R_,R_,R_,R_];var Cd=[V_,V_,$Y,V_,aZ,V_,bZ,V_,cZ,V_,dZ,V_,eZ,V_,fZ,V_,gZ,V_,hZ,V_,iZ,V_,jZ,V_,kZ,V_,lZ,V_,mZ,V_,nZ,V_,oZ,V_,pZ,V_,qZ,V_,rZ,V_,sZ,V_,xF,WF,QI,RI,HI,II,YI,ZI,eJ,fJ,V_,V_,V_,V_,V_,V_,V_,V_,V_,V_,V_,V_];var Dd=[W_,W_,uZ,W_,vZ,W_,wZ,W_,xZ,W_,yZ,W_,zZ,W_,AZ,W_,BZ,W_,CZ,W_,DZ,W_,EZ,W_,FZ,W_,GZ,W_,HZ,W_,IZ,W_,JZ,W_,KZ,W_,LZ,W_,MZ,W_,NZ,W_,WE,ZE,hF,jF,Km,W_,W_,W_,W_,W_,W_,W_,W_,W_,W_,W_,W_,W_,W_,W_,W_,W_];var Ed=[X_,X_,PZ,X_,QZ,X_,RZ,X_,SZ,X_,TZ,X_,UZ,X_,VZ,X_,WZ,X_,XZ,X_,YZ,X_,ZZ,X_,_Z,X_,$Z,X_,a_,X_,b_,X_,c_,X_,d_,X_,e_,X_,f_,X_,g_,X_,Qd,nj,Fj,Yj,Zj,yl,Hl,Jy,vA,wA,yA,tD,YD,bE,Od,Jh,si,wi,Mi,Tk,Wk,Yl,$l,cm,Xm,vn,kn,Ko,hh,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_,X_];return{___cxa_can_catch:KA,_resize:je,_memcpy:XL,___cxa_is_pointer_type:LA,_i64Add:TL,_memmove:YL,_bitshift64Ashr:VL,_decode_any:se,_memset:ZL,_malloc:yC,_free:zC,_decode_multi:te,_decode_qr_multi:re,___getTypeName:Fz,_bitshift64Lshr:WL,_fflush:PB,_decode_qr:qe,_i64Subtract:UL,___errno_location:ZA,_bitshift64Shl:_L,__GLOBAL__sub_I_zxing_js_cpp:Ve,__GLOBAL__sub_I_CharacterSetECI_cpp:Ip,__GLOBAL__sub_I_GlobalHistogramBinarizer_cpp:Jp,__GLOBAL__sub_I_GenericGF_cpp:Kp,__GLOBAL__sub_I_Version_cpp:Lp,__GLOBAL__sub_I_DecodeHints_cpp:Mp,__GLOBAL__sub_I_Code39Reader_cpp:Np,__GLOBAL__sub_I_Code93Reader_cpp:Op,__GLOBAL__sub_I_ITFReader_cpp:Pp,__GLOBAL__sub_I_UPCEANReader_cpp:Qp,__GLOBAL__sub_I_UPCEReader_cpp:Rp,__GLOBAL__sub_I_DecodedBitStreamParser_cpp:Sp,__GLOBAL__sub_I_ModulusGF_cpp:Tp,__GLOBAL__sub_I_LinesSampler_cpp:Up,__GLOBAL__sub_I_DataMask_cpp:Vp,__GLOBAL__sub_I_Mode_cpp:Wp,__GLOBAL__sub_I_ErrorCorrectionLevel_cpp:Xp,__GLOBAL__sub_I_Version_cpp733:Yp,__GLOBAL__sub_I_bind_cpp:Hz,runPostSets:SL,stackAlloc:Fd,stackSave:Gd,stackRestore:Hd,establishStackSpace:Id,setThrew:Jd,setTempRet0:Md,getTempRet0:Nd,dynCall_iiiiiiii:hM,dynCall_iiiiiid:CM,dynCall_viiiii:XM,dynCall_vi:qN,dynCall_vii:LN,dynCall_iiiiiii:eO,dynCall_ii:zO,dynCall_idddddddd:UO,dynCall_iiiiiiiiiiii:nP,dynCall_vidd:IP,dynCall_iiii:bQ,dynCall_viiiiiiiiiiiiiii:wQ,dynCall_viiiiii:RQ,dynCall_diiii:kR,dynCall_iidiid:FR,dynCall_viddd:_R,dynCall_di:tS,dynCall_iiiiidddddddd:OS,dynCall_viiiiiii:hT,dynCall_iiddd:CT,dynCall_viiiiiiiii:XT,dynCall_viiiiiiiiii:qU,dynCall_iii:LU,dynCall_iiiiii:eV,dynCall_diii:zV,dynCall_iiiidddddddddddddddd:UV,dynCall_viiiiiidi:nW,dynCall_dii:IW,dynCall_i:bX,dynCall_iiiid:wX,dynCall_iiiii:RX,dynCall_viii:kY,dynCall_v:FY,dynCall_iiiiiiiii:_Y,dynCall_iiiiid:tZ,dynCall_viiii:OZ}})


// EMSCRIPTEN_END_ASM
(Module.asmGlobalArg,Module.asmLibraryArg,buffer);var __GLOBAL__sub_I_zxing_js_cpp=Module["__GLOBAL__sub_I_zxing_js_cpp"]=asm["__GLOBAL__sub_I_zxing_js_cpp"];var __GLOBAL__sub_I_GenericGF_cpp=Module["__GLOBAL__sub_I_GenericGF_cpp"]=asm["__GLOBAL__sub_I_GenericGF_cpp"];var __GLOBAL__sub_I_CharacterSetECI_cpp=Module["__GLOBAL__sub_I_CharacterSetECI_cpp"]=asm["__GLOBAL__sub_I_CharacterSetECI_cpp"];var __GLOBAL__sub_I_ErrorCorrectionLevel_cpp=Module["__GLOBAL__sub_I_ErrorCorrectionLevel_cpp"]=asm["__GLOBAL__sub_I_ErrorCorrectionLevel_cpp"];var _memset=Module["_memset"]=asm["_memset"];var __GLOBAL__sub_I_UPCEReader_cpp=Module["__GLOBAL__sub_I_UPCEReader_cpp"]=asm["__GLOBAL__sub_I_UPCEReader_cpp"];var _bitshift64Lshr=Module["_bitshift64Lshr"]=asm["_bitshift64Lshr"];var __GLOBAL__sub_I_Version_cpp733=Module["__GLOBAL__sub_I_Version_cpp733"]=asm["__GLOBAL__sub_I_Version_cpp733"];var _bitshift64Shl=Module["_bitshift64Shl"]=asm["_bitshift64Shl"];var __GLOBAL__sub_I_Code93Reader_cpp=Module["__GLOBAL__sub_I_Code93Reader_cpp"]=asm["__GLOBAL__sub_I_Code93Reader_cpp"];var _fflush=Module["_fflush"]=asm["_fflush"];var ___cxa_is_pointer_type=Module["___cxa_is_pointer_type"]=asm["___cxa_is_pointer_type"];var __GLOBAL__sub_I_Version_cpp=Module["__GLOBAL__sub_I_Version_cpp"]=asm["__GLOBAL__sub_I_Version_cpp"];var _bitshift64Ashr=Module["_bitshift64Ashr"]=asm["_bitshift64Ashr"];var _decode_any=Module["_decode_any"]=asm["_decode_any"];var __GLOBAL__sub_I_LinesSampler_cpp=Module["__GLOBAL__sub_I_LinesSampler_cpp"]=asm["__GLOBAL__sub_I_LinesSampler_cpp"];var _decode_qr=Module["_decode_qr"]=asm["_decode_qr"];var __GLOBAL__sub_I_DataMask_cpp=Module["__GLOBAL__sub_I_DataMask_cpp"]=asm["__GLOBAL__sub_I_DataMask_cpp"];var __GLOBAL__sub_I_GlobalHistogramBinarizer_cpp=Module["__GLOBAL__sub_I_GlobalHistogramBinarizer_cpp"]=asm["__GLOBAL__sub_I_GlobalHistogramBinarizer_cpp"];var _i64Subtract=Module["_i64Subtract"]=asm["_i64Subtract"];var __GLOBAL__sub_I_bind_cpp=Module["__GLOBAL__sub_I_bind_cpp"]=asm["__GLOBAL__sub_I_bind_cpp"];var _resize=Module["_resize"]=asm["_resize"];var _i64Add=Module["_i64Add"]=asm["_i64Add"];var ___getTypeName=Module["___getTypeName"]=asm["___getTypeName"];var __GLOBAL__sub_I_DecodedBitStreamParser_cpp=Module["__GLOBAL__sub_I_DecodedBitStreamParser_cpp"]=asm["__GLOBAL__sub_I_DecodedBitStreamParser_cpp"];var __GLOBAL__sub_I_UPCEANReader_cpp=Module["__GLOBAL__sub_I_UPCEANReader_cpp"]=asm["__GLOBAL__sub_I_UPCEANReader_cpp"];var ___errno_location=Module["___errno_location"]=asm["___errno_location"];var __GLOBAL__sub_I_ModulusGF_cpp=Module["__GLOBAL__sub_I_ModulusGF_cpp"]=asm["__GLOBAL__sub_I_ModulusGF_cpp"];var ___cxa_can_catch=Module["___cxa_can_catch"]=asm["___cxa_can_catch"];var _free=Module["_free"]=asm["_free"];var runPostSets=Module["runPostSets"]=asm["runPostSets"];var _memmove=Module["_memmove"]=asm["_memmove"];var __GLOBAL__sub_I_Mode_cpp=Module["__GLOBAL__sub_I_Mode_cpp"]=asm["__GLOBAL__sub_I_Mode_cpp"];var _malloc=Module["_malloc"]=asm["_malloc"];var _memcpy=Module["_memcpy"]=asm["_memcpy"];var _decode_multi=Module["_decode_multi"]=asm["_decode_multi"];var _decode_qr_multi=Module["_decode_qr_multi"]=asm["_decode_qr_multi"];var __GLOBAL__sub_I_Code39Reader_cpp=Module["__GLOBAL__sub_I_Code39Reader_cpp"]=asm["__GLOBAL__sub_I_Code39Reader_cpp"];var __GLOBAL__sub_I_DecodeHints_cpp=Module["__GLOBAL__sub_I_DecodeHints_cpp"]=asm["__GLOBAL__sub_I_DecodeHints_cpp"];var __GLOBAL__sub_I_ITFReader_cpp=Module["__GLOBAL__sub_I_ITFReader_cpp"]=asm["__GLOBAL__sub_I_ITFReader_cpp"];var dynCall_iiiiiiii=Module["dynCall_iiiiiiii"]=asm["dynCall_iiiiiiii"];var dynCall_iiiiiid=Module["dynCall_iiiiiid"]=asm["dynCall_iiiiiid"];var dynCall_viiiii=Module["dynCall_viiiii"]=asm["dynCall_viiiii"];var dynCall_vi=Module["dynCall_vi"]=asm["dynCall_vi"];var dynCall_vii=Module["dynCall_vii"]=asm["dynCall_vii"];var dynCall_iiiiiii=Module["dynCall_iiiiiii"]=asm["dynCall_iiiiiii"];var dynCall_ii=Module["dynCall_ii"]=asm["dynCall_ii"];var dynCall_idddddddd=Module["dynCall_idddddddd"]=asm["dynCall_idddddddd"];var dynCall_iiiiiiiiiiii=Module["dynCall_iiiiiiiiiiii"]=asm["dynCall_iiiiiiiiiiii"];var dynCall_vidd=Module["dynCall_vidd"]=asm["dynCall_vidd"];var dynCall_iiii=Module["dynCall_iiii"]=asm["dynCall_iiii"];var dynCall_viiiiiiiiiiiiiii=Module["dynCall_viiiiiiiiiiiiiii"]=asm["dynCall_viiiiiiiiiiiiiii"];var dynCall_viiiiii=Module["dynCall_viiiiii"]=asm["dynCall_viiiiii"];var dynCall_diiii=Module["dynCall_diiii"]=asm["dynCall_diiii"];var dynCall_iidiid=Module["dynCall_iidiid"]=asm["dynCall_iidiid"];var dynCall_viddd=Module["dynCall_viddd"]=asm["dynCall_viddd"];var dynCall_di=Module["dynCall_di"]=asm["dynCall_di"];var dynCall_iiiiidddddddd=Module["dynCall_iiiiidddddddd"]=asm["dynCall_iiiiidddddddd"];var dynCall_viiiiiii=Module["dynCall_viiiiiii"]=asm["dynCall_viiiiiii"];var dynCall_iiddd=Module["dynCall_iiddd"]=asm["dynCall_iiddd"];var dynCall_viiiiiiiii=Module["dynCall_viiiiiiiii"]=asm["dynCall_viiiiiiiii"];var dynCall_viiiiiiiiii=Module["dynCall_viiiiiiiiii"]=asm["dynCall_viiiiiiiiii"];var dynCall_iii=Module["dynCall_iii"]=asm["dynCall_iii"];var dynCall_iiiiii=Module["dynCall_iiiiii"]=asm["dynCall_iiiiii"];var dynCall_diii=Module["dynCall_diii"]=asm["dynCall_diii"];var dynCall_iiiidddddddddddddddd=Module["dynCall_iiiidddddddddddddddd"]=asm["dynCall_iiiidddddddddddddddd"];var dynCall_viiiiiidi=Module["dynCall_viiiiiidi"]=asm["dynCall_viiiiiidi"];var dynCall_dii=Module["dynCall_dii"]=asm["dynCall_dii"];var dynCall_i=Module["dynCall_i"]=asm["dynCall_i"];var dynCall_iiiid=Module["dynCall_iiiid"]=asm["dynCall_iiiid"];var dynCall_iiiii=Module["dynCall_iiiii"]=asm["dynCall_iiiii"];var dynCall_viii=Module["dynCall_viii"]=asm["dynCall_viii"];var dynCall_v=Module["dynCall_v"]=asm["dynCall_v"];var dynCall_iiiiiiiii=Module["dynCall_iiiiiiiii"]=asm["dynCall_iiiiiiiii"];var dynCall_iiiiid=Module["dynCall_iiiiid"]=asm["dynCall_iiiiid"];var dynCall_viiii=Module["dynCall_viiii"]=asm["dynCall_viiii"];Runtime.stackAlloc=asm["stackAlloc"];Runtime.stackSave=asm["stackSave"];Runtime.stackRestore=asm["stackRestore"];Runtime.establishStackSpace=asm["establishStackSpace"];Runtime.setTempRet0=asm["setTempRet0"];Runtime.getTempRet0=asm["getTempRet0"];function ExitStatus(status){this.name="ExitStatus";this.message="Program terminated with exit("+status+")";this.status=status}ExitStatus.prototype=new Error;ExitStatus.prototype.constructor=ExitStatus;var initialStackTop;var preloadStartTime=null;var calledMain=false;dependenciesFulfilled=function runCaller(){if(!Module["calledRun"])run();if(!Module["calledRun"])dependenciesFulfilled=runCaller};Module["callMain"]=Module.callMain=function callMain(args){assert(runDependencies==0,"cannot call main when async dependencies remain! (listen on __ATMAIN__)");assert(__ATPRERUN__.length==0,"cannot call main when preRun functions remain to be called");args=args||[];ensureInitRuntime();var argc=args.length+1;function pad(){for(var i=0;i<4-1;i++){argv.push(0)}}var argv=[allocate(intArrayFromString(Module["thisProgram"]),"i8",ALLOC_NORMAL)];pad();for(var i=0;i<argc-1;i=i+1){argv.push(allocate(intArrayFromString(args[i]),"i8",ALLOC_NORMAL));pad()}argv.push(0);argv=allocate(argv,"i32",ALLOC_NORMAL);try{var ret=Module["_main"](argc,argv,0);exit(ret,true)}catch(e){if(e instanceof ExitStatus){return}else if(e=="SimulateInfiniteLoop"){Module["noExitRuntime"]=true;return}else{if(e&&typeof e==="object"&&e.stack)Module.printErr("exception thrown: "+[e,e.stack]);throw e}}finally{calledMain=true}};function run(args){args=args||Module["arguments"];if(preloadStartTime===null)preloadStartTime=Date.now();if(runDependencies>0){return}preRun();if(runDependencies>0)return;if(Module["calledRun"])return;function doRun(){if(Module["calledRun"])return;Module["calledRun"]=true;if(ABORT)return;ensureInitRuntime();preMain();if(Module["onRuntimeInitialized"])Module["onRuntimeInitialized"]();if(Module["_main"]&&shouldRunNow)Module["callMain"](args);postRun()}if(Module["setStatus"]){Module["setStatus"]("Running...");setTimeout((function(){setTimeout((function(){Module["setStatus"]("")}),1);doRun()}),1)}else{doRun()}}Module["run"]=Module.run=run;function exit(status,implicit){if(implicit&&Module["noExitRuntime"]){return}if(Module["noExitRuntime"]){}else{ABORT=true;EXITSTATUS=status;STACKTOP=initialStackTop;exitRuntime();if(Module["onExit"])Module["onExit"](status)}if(ENVIRONMENT_IS_NODE){process["stdout"]["once"]("drain",(function(){process["exit"](status)}));console.log(" ");setTimeout((function(){process["exit"](status)}),500)}else if(ENVIRONMENT_IS_SHELL&&typeof quit==="function"){quit(status)}throw new ExitStatus(status)}Module["exit"]=Module.exit=exit;var abortDecorators=[];function abort(what){if(what!==undefined){Module.print(what);Module.printErr(what);what=JSON.stringify(what)}else{what=""}ABORT=true;EXITSTATUS=1;var extra="\nIf this abort() is unexpected, build with -s ASSERTIONS=1 which can give more information.";var output="abort("+what+") at "+stackTrace()+extra;if(abortDecorators){abortDecorators.forEach((function(decorator){output=decorator(output,what)}))}throw output}Module["abort"]=Module.abort=abort;if(Module["preInit"]){if(typeof Module["preInit"]=="function")Module["preInit"]=[Module["preInit"]];while(Module["preInit"].length>0){Module["preInit"].pop()()}}var shouldRunNow=true;if(Module["noInitialRun"]){shouldRunNow=false}run()





  return Module;
};

}).call(this,require('_process'),require("buffer").Buffer,"/node_modules/instascan/src")
},{"_process":649,"buffer":96,"crypto":552,"fs":94,"path":640}],628:[function(require,module,exports){
(function (global){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.20';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],629:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var HashBase = require('hash-base')
var Buffer = require('safe-buffer').Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5

},{"hash-base":590,"inherits":622,"safe-buffer":676}],630:[function(require,module,exports){
var bn = require('bn.js');
var brorand = require('brorand');

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};

},{"bn.js":631,"brorand":48}],631:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"buffer":49,"dup":15}],632:[function(require,module,exports){
module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};

},{}],633:[function(require,module,exports){
'use strict';

var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};

},{}],634:[function(require,module,exports){
'use strict';

var Config = {
    DEBUG: false,
    LIB_VERSION: '2.40.0'
};

// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var window$1;
if (typeof(window) === 'undefined') {
    var loc = {
        hostname: ''
    };
    window$1 = {
        navigator: { userAgent: '' },
        document: {
            location: loc,
            referrer: ''
        },
        screen: { width: 0, height: 0 },
        location: loc
    };
} else {
    window$1 = window;
}

/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */

var ArrayProto = Array.prototype;
var FuncProto = Function.prototype;
var ObjProto = Object.prototype;
var slice = ArrayProto.slice;
var toString = ObjProto.toString;
var hasOwnProperty = ObjProto.hasOwnProperty;
var windowConsole = window$1.console;
var navigator$1 = window$1.navigator;
var document$1 = window$1.document;
var windowOpera = window$1.opera;
var screen = window$1.screen;
var userAgent = navigator$1.userAgent;
var nativeBind = FuncProto.bind;
var nativeForEach = ArrayProto.forEach;
var nativeIndexOf = ArrayProto.indexOf;
var nativeMap = ArrayProto.map;
var nativeIsArray = Array.isArray;
var breaker = {};
var _ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};

// Console override
var console$1 = {
    /** @type {function(...*)} */
    log: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            try {
                windowConsole.log.apply(windowConsole, arguments);
            } catch (err) {
                _.each(arguments, function(arg) {
                    windowConsole.log(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */
    error: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */
    critical: function() {
        if (!_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    }
};

var log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply(console$1, arguments);
    };
};
var console_with_prefix = function(prefix) {
    return {
        log: log_func_with_prefix(console$1.log, prefix),
        error: log_func_with_prefix(console$1.error, prefix),
        critical: log_func_with_prefix(console$1.critical, prefix)
    };
};


// UNDERSCORE
// Embed part of the Underscore Library
_.bind = function(func, context) {
    var args, bound;
    if (nativeBind && func.bind === nativeBind) {
        return nativeBind.apply(func, slice.call(arguments, 1));
    }
    if (!_.isFunction(func)) {
        throw new TypeError();
    }
    args = slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) {
            return func.apply(context, args.concat(slice.call(arguments)));
        }
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat(slice.call(arguments)));
        if (Object(result) === result) {
            return result;
        }
        return self;
    };
    return bound;
};

_.bind_instance_methods = function(obj) {
    for (var func in obj) {
        if (typeof(obj[func]) === 'function') {
            obj[func] = _.bind(obj[func], obj);
        }
    }
};

/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */
_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) {
        return;
    }
    if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
    } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
            if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) {
                return;
            }
        }
    } else {
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                if (iterator.call(context, obj[key], key, obj) === breaker) {
                    return;
                }
            }
        }
    }
};

_.escapeHTML = function(s) {
    var escaped = s;
    if (escaped && _.isString(escaped)) {
        escaped = escaped
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }
    return escaped;
};

_.extend = function(obj) {
    _.each(slice.call(arguments, 1), function(source) {
        for (var prop in source) {
            if (source[prop] !== void 0) {
                obj[prop] = source[prop];
            }
        }
    });
    return obj;
};

_.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
};

// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};

_.isArguments = function(obj) {
    return !!(obj && hasOwnProperty.call(obj, 'callee'));
};

_.toArray = function(iterable) {
    if (!iterable) {
        return [];
    }
    if (iterable.toArray) {
        return iterable.toArray();
    }
    if (_.isArray(iterable)) {
        return slice.call(iterable);
    }
    if (_.isArguments(iterable)) {
        return slice.call(iterable);
    }
    return _.values(iterable);
};

_.map = function(arr, callback, context) {
    if (nativeMap && arr.map === nativeMap) {
        return arr.map(callback, context);
    } else {
        var results = [];
        _.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};

_.keys = function(obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};

_.values = function(obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};

_.identity = function(value) {
    return value;
};

_.include = function(obj, target) {
    var found = false;
    if (obj === null) {
        return found;
    }
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) {
        return obj.indexOf(target) != -1;
    }
    _.each(obj, function(value) {
        if (found || (found = (value === target))) {
            return breaker;
        }
    });
    return found;
};

_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};

// Underscore Addons
_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};

_.isObject = function(obj) {
    return (obj === Object(obj) && !_.isArray(obj));
};

_.isEmptyObject = function(obj) {
    if (_.isObject(obj)) {
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
};

_.isUndefined = function(obj) {
    return obj === void 0;
};

_.isString = function(obj) {
    return toString.call(obj) == '[object String]';
};

_.isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
};

_.isNumber = function(obj) {
    return toString.call(obj) == '[object Number]';
};

_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};

_.encodeDates = function(obj) {
    _.each(obj, function(v, k) {
        if (_.isDate(v)) {
            obj[k] = _.formatDate(v);
        } else if (_.isObject(v)) {
            obj[k] = _.encodeDates(v); // recurse
        }
    });
    return obj;
};

_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};

_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' +
        pad(d.getUTCMonth() + 1) + '-' +
        pad(d.getUTCDate()) + 'T' +
        pad(d.getUTCHours()) + ':' +
        pad(d.getUTCMinutes()) + ':' +
        pad(d.getUTCSeconds());
};

_.safewrap = function(f) {
    return function() {
        try {
            return f.apply(this, arguments);
        } catch (e) {
            console$1.critical('Implementation error. Please turn on debug and contact support@mixpanel.com.');
            if (Config.DEBUG){
                console$1.critical(e);
            }
        }
    };
};

_.safewrap_class = function(klass, functions) {
    for (var i = 0; i < functions.length; i++) {
        klass.prototype[functions[i]] = _.safewrap(klass.prototype[functions[i]]);
    }
};

_.safewrap_instance_methods = function(obj) {
    for (var func in obj) {
        if (typeof(obj[func]) === 'function') {
            obj[func] = _.safewrap(obj[func]);
        }
    }
};

_.strip_empty_properties = function(p) {
    var ret = {};
    _.each(p, function(v, k) {
        if (_.isString(v) && v.length > 0) {
            ret[k] = v;
        }
    });
    return ret;
};

/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */
_.truncate = function(obj, length) {
    var ret;

    if (typeof(obj) === 'string') {
        ret = obj.slice(0, length);
    } else if (_.isArray(obj)) {
        ret = [];
        _.each(obj, function(val) {
            ret.push(_.truncate(val, length));
        });
    } else if (_.isObject(obj)) {
        ret = {};
        _.each(obj, function(val, key) {
            ret[key] = _.truncate(val, length);
        });
    } else {
        ret = obj;
    }

    return ret;
};

_.JSONEncode = (function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = { // table of character substitutions
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };

            escapable.lastIndex = 0;
            return escapable.test(string) ?
                '"' + string.replace(escapable, function(a) {
                    var c = meta[a];
                    return typeof c === 'string' ? c :
                        '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                }) + '"' :
                '"' + string + '"';
        };

        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];

            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' &&
                typeof value.toJSON === 'function') {
                value = value.toJSON(key);
            }

            // What happens next depends on the value's type.
            switch (typeof value) {
                case 'string':
                    return quote(value);

                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';

                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.

                    return String(value);

                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) {
                        return 'null';
                    }

                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];

                    // Is the value an array?
                    if (toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.

                        length = value.length;
                        for (i = 0; i < length; i += 1) {
                            partial[i] = str(i, value) || 'null';
                        }

                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' :
                            gap ? '[\n' + gap +
                            partial.join(',\n' + gap) + '\n' +
                            mind + ']' :
                                '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }

                    // Iterate through all of the keys in the object.
                    for (k in value) {
                        if (hasOwnProperty.call(value, k)) {
                            v = str(k, value);
                            if (v) {
                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
                            }
                        }
                    }

                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' :
                        gap ? '{' + partial.join(',') + '' +
                        mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };

        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
})();

/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */
_.JSONDecode = (function() {
    var at, // The index of the current character
        ch, // The current character
        escapee = {
            '"': '"',
            '\\': '\\',
            '/': '/',
            'b': '\b',
            'f': '\f',
            'n': '\n',
            'r': '\r',
            't': '\t'
        },
        text,
        error = function(m) {
            var e = new SyntaxError(m);
            e.at = at;
            e.text = text;
            throw e;
        },
        next = function(c) {
            // If a c parameter is provided, verify that it matches the current character.
            if (c && c !== ch) {
                error('Expected \'' + c + '\' instead of \'' + ch + '\'');
            }
            // Get the next character. When there are no more characters,
            // return the empty string.
            ch = text.charAt(at);
            at += 1;
            return ch;
        },
        number = function() {
            // Parse a number value.
            var number,
                string = '';

            if (ch === '-') {
                string = '-';
                next('-');
            }
            while (ch >= '0' && ch <= '9') {
                string += ch;
                next();
            }
            if (ch === '.') {
                string += '.';
                while (next() && ch >= '0' && ch <= '9') {
                    string += ch;
                }
            }
            if (ch === 'e' || ch === 'E') {
                string += ch;
                next();
                if (ch === '-' || ch === '+') {
                    string += ch;
                    next();
                }
                while (ch >= '0' && ch <= '9') {
                    string += ch;
                    next();
                }
            }
            number = +string;
            if (!isFinite(number)) {
                error('Bad number');
            } else {
                return number;
            }
        },

        string = function() {
            // Parse a string value.
            var hex,
                i,
                string = '',
                uffff;
            // When parsing for string values, we must look for " and \ characters.
            if (ch === '"') {
                while (next()) {
                    if (ch === '"') {
                        next();
                        return string;
                    }
                    if (ch === '\\') {
                        next();
                        if (ch === 'u') {
                            uffff = 0;
                            for (i = 0; i < 4; i += 1) {
                                hex = parseInt(next(), 16);
                                if (!isFinite(hex)) {
                                    break;
                                }
                                uffff = uffff * 16 + hex;
                            }
                            string += String.fromCharCode(uffff);
                        } else if (typeof escapee[ch] === 'string') {
                            string += escapee[ch];
                        } else {
                            break;
                        }
                    } else {
                        string += ch;
                    }
                }
            }
            error('Bad string');
        },
        white = function() {
            // Skip whitespace.
            while (ch && ch <= ' ') {
                next();
            }
        },
        word = function() {
            // true, false, or null.
            switch (ch) {
                case 't':
                    next('t');
                    next('r');
                    next('u');
                    next('e');
                    return true;
                case 'f':
                    next('f');
                    next('a');
                    next('l');
                    next('s');
                    next('e');
                    return false;
                case 'n':
                    next('n');
                    next('u');
                    next('l');
                    next('l');
                    return null;
            }
            error('Unexpected "' + ch + '"');
        },
        value, // Placeholder for the value function.
        array = function() {
            // Parse an array value.
            var array = [];

            if (ch === '[') {
                next('[');
                white();
                if (ch === ']') {
                    next(']');
                    return array; // empty array
                }
                while (ch) {
                    array.push(value());
                    white();
                    if (ch === ']') {
                        next(']');
                        return array;
                    }
                    next(',');
                    white();
                }
            }
            error('Bad array');
        },
        object = function() {
            // Parse an object value.
            var key,
                object = {};

            if (ch === '{') {
                next('{');
                white();
                if (ch === '}') {
                    next('}');
                    return object; // empty object
                }
                while (ch) {
                    key = string();
                    white();
                    next(':');
                    if (Object.hasOwnProperty.call(object, key)) {
                        error('Duplicate key "' + key + '"');
                    }
                    object[key] = value();
                    white();
                    if (ch === '}') {
                        next('}');
                        return object;
                    }
                    next(',');
                    white();
                }
            }
            error('Bad object');
        };

    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch (ch) {
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };

    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;

        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) {
            error('Syntax error');
        }

        return result;
    };
})();

_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
        ac = 0,
        enc = '',
        tmp_arr = [];

    if (!data) {
        return data;
    }

    data = _.utf8Encode(data);

    do { // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);

        bits = o1 << 16 | o2 << 8 | o3;

        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;

        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);

    enc = tmp_arr.join('');

    switch (data.length % 3) {
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }

    return enc;
};

_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    var utftext = '',
        start,
        end;
    var stringl = 0,
        n;

    start = end = 0;
    stringl = string.length;

    for (n = 0; n < stringl; n++) {
        var c1 = string.charCodeAt(n);
        var enc = null;

        if (c1 < 128) {
            end++;
        } else if ((c1 > 127) && (c1 < 2048)) {
            enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
        } else {
            enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
        }
        if (enc !== null) {
            if (end > start) {
                utftext += string.substring(start, end);
            }
            utftext += enc;
            start = end = n + 1;
        }
    }

    if (end > start) {
        utftext += string.substring(start, string.length);
    }

    return utftext;
};

_.UUID = (function() {

    // Time/ticks information
    // 1*new Date() is a cross browser version of Date.now()
    var T = function() {
        var d = 1 * new Date(),
            i = 0;

        // this while loop figures how many browser ticks go by
        // before 1*new Date() returns a new number, ie the amount
        // of ticks that go by per millisecond
        while (d == 1 * new Date()) {
            i++;
        }

        return d.toString(16) + i.toString(16);
    };

    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace('.', '');
    };

    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = userAgent,
            i, ch, buffer = [],
            ret = 0;

        function xor(result, byte_array) {
            var j, tmp = 0;
            for (j = 0; j < byte_array.length; j++) {
                tmp |= (buffer[j] << j * 8);
            }
            return result ^ tmp;
        }

        for (i = 0; i < ua.length; i++) {
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }

        if (buffer.length > 0) {
            ret = xor(ret, buffer);
        }

        return ret.toString(16);
    };

    return function() {
        var se = (screen.height * screen.width).toString(16);
        return (T() + '-' + R() + '-' + UA() + '-' + se + '-' + T());
    };
})();

// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
_.isBlockedUA = function(ua) {
    if (/(google web preview|baiduspider|yandexbot|bingbot|googlebot|yahoo! slurp)/i.test(ua)) {
        return true;
    }
    return false;
};

/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */
_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];

    if (_.isUndefined(arg_separator)) {
        arg_separator = '&';
    }

    _.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });

    return tmp_arr.join(arg_separator);
};

_.getQueryParam = function(url, param) {
    // Expects a raw URL

    param = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)',
        regex = new RegExp(regexS),
        results = regex.exec(url);
    if (results === null || (results && typeof(results[1]) !== 'string' && results[1].length)) {
        return '';
    } else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch(err) {
            console$1.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};

_.getHashParam = function(hash, param) {
    var matches = hash.match(new RegExp(param + '=([^&]*)'));
    return matches ? matches[1] : null;
};

// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = document$1.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    },

    parse: function(name) {
        var cookie;
        try {
            cookie = _.JSONDecode(_.cookie.get(name)) || {};
        } catch (err) {
            // noop
        }
        return cookie;
    },

    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '',
            expires = '',
            secure = '';

        if (domain_override) {
            cdomain = '; domain=' + domain_override;
        } else if (is_cross_subdomain) {
            var domain = extract_domain(document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }

        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + (seconds * 1000));
            expires = '; expires=' + date.toGMTString();
        }

        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) {
            secure += '; secure';
        }

        document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },

    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';

        if (domain_override) {
            cdomain = '; domain=' + domain_override;
        } else if (is_cross_subdomain) {
            var domain = extract_domain(document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toGMTString();
        }

        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) {
            secure += '; secure';
        }

        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },

    remove: function(name, is_cross_subdomain, domain_override) {
        _.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};

var _localStorageSupported = null;
var localStorageSupported = function(storage, forceCheck) {
    if (_localStorageSupported !== null && !forceCheck) {
        return _localStorageSupported;
    }

    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = '__mplss_' + cheap_guid(8),
            val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) {
            supported = false;
        }
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }

    _localStorageSupported = supported;
    return supported;
};

// _.localStorage
_.localStorage = {
    is_supported: function(force_check) {
        var supported = localStorageSupported(null, force_check);
        if (!supported) {
            console$1.error('localStorage unsupported; falling back to cookie store');
        }
        return supported;
    },

    error: function(msg) {
        console$1.error('localStorage error: ' + msg);
    },

    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
        return null;
    },

    parse: function(name) {
        try {
            return _.JSONDecode(_.localStorage.get(name)) || {};
        } catch (err) {
            // noop
        }
        return null;
    },

    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            _.localStorage.error(err);
        }
    },

    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
    }
};

_.register_event = (function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440

    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */
    var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            console$1.error('No valid element provided to register_event');
            return;
        }

        if (element.addEventListener && !oldSchool) {
            element.addEventListener(type, handler, !!useCapture);
        } else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };

    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);

            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) {
                return undefined;
            }

            var ret = true;
            var old_result, new_result;

            if (_.isFunction(old_handlers)) {
                old_result = old_handlers(event);
            }
            new_result = new_handler.call(element, event);

            if ((false === old_result) || (false === new_result)) {
                ret = false;
            }

            return ret;
        };

        return handler;
    }

    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };

    return register_event;
})();


var TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');

_.dom_query = (function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */

    function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }

    var bad_whitespace = /[\t\r\n]/g;

    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return ((' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0);
    }

    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!document$1.getElementsByTagName) {
            return [];
        }
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [document$1];
        for (i = 0; i < tokens.length; i++) {
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = document$1.getElementById(id);
                if (!element || (tagName && element.nodeName.toLowerCase() != tagName)) {
                    // element not found or tag with that ID not found, return false
                    return [];
                }
                // Set currentContext to contain just this element
                currentContext = [element];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) {
                    tagName = '*';
                }
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (found[j].className &&
                        _.isString(found[j].className) && // some SVG elements have classNames which are not strings
                        hasClass(found[j], className)
                    ) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match(TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) {
                    tagName = '*';
                }
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch (attrOperator) {
                    case '=': // Equality
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName) == attrValue);
                        };
                        break;
                    case '~': // Match one of space seperated words
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b')));
                        };
                        break;
                    case '|': // Match start with value followed by optional hyphen
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?')));
                        };
                        break;
                    case '^': // Match starts with value
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).indexOf(attrValue) === 0);
                        };
                        break;
                    case '$': // Match ends with value - fails with "Warning" in Opera 7
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length);
                        };
                        break;
                    case '*': // Match ends with value
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).indexOf(attrValue) > -1);
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (checkFunction(found[j])) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                // alert('Attribute Selector: '+tagName+' '+attrName+' '+attrOperator+' '+attrValue);
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for (j = 0; j < currentContext.length; j++) {
                elements = currentContext[j].getElementsByTagName(tagName);
                for (k = 0; k < elements.length; k++) {
                    found[foundCount++] = elements[k];
                }
            }
            currentContext = found;
        }
        return currentContext;
    }

    return function(query) {
        if (_.isElement(query)) {
            return [query];
        } else if (_.isObject(query) && !_.isUndefined(query.length)) {
            return query;
        } else {
            return getElementsBySelector.call(this, query);
        }
    };
})();

_.info = {
    campaignParams: function() {
        var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '),
            kw = '',
            params = {};
        _.each(campaign_keywords, function(kwkey) {
            kw = _.getQueryParam(document$1.URL, kwkey);
            if (kw.length) {
                params[kwkey] = kw;
            }
        });

        return params;
    },

    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
            return 'google';
        } else if (referrer.search('https?://(.*)bing.com') === 0) {
            return 'bing';
        } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
            return 'yahoo';
        } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
            return 'duckduckgo';
        } else {
            return null;
        }
    },

    searchInfo: function(referrer) {
        var search = _.info.searchEngine(referrer),
            param = (search != 'yahoo') ? 'q' : 'p',
            ret = {};

        if (search !== null) {
            ret['$search_engine'] = search;

            var keyword = _.getQueryParam(referrer, param);
            if (keyword.length) {
                ret['mp_keyword'] = keyword;
            }
        }

        return ret;
    },

    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */
    browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || _.includes(user_agent, ' OPR/')) {
            if (_.includes(user_agent, 'Mini')) {
                return 'Opera Mini';
            }
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (_.includes(user_agent, 'IEMobile') || _.includes(user_agent, 'WPDesktop')) {
            return 'Internet Explorer Mobile';
        } else if (_.includes(user_agent, 'SamsungBrowser/')) {
            // https://developer.samsung.com/internet/user-agent-string-format
            return 'Samsung Internet';
        } else if (_.includes(user_agent, 'Edge') || _.includes(user_agent, 'Edg/')) {
            return 'Microsoft Edge';
        } else if (_.includes(user_agent, 'FBIOS')) {
            return 'Facebook Mobile';
        } else if (_.includes(user_agent, 'Chrome')) {
            return 'Chrome';
        } else if (_.includes(user_agent, 'CriOS')) {
            return 'Chrome iOS';
        } else if (_.includes(user_agent, 'UCWEB') || _.includes(user_agent, 'UCBrowser')) {
            return 'UC Browser';
        } else if (_.includes(user_agent, 'FxiOS')) {
            return 'Firefox iOS';
        } else if (_.includes(vendor, 'Apple')) {
            if (_.includes(user_agent, 'Mobile')) {
                return 'Mobile Safari';
            }
            return 'Safari';
        } else if (_.includes(user_agent, 'Android')) {
            return 'Android Mobile';
        } else if (_.includes(user_agent, 'Konqueror')) {
            return 'Konqueror';
        } else if (_.includes(user_agent, 'Firefox')) {
            return 'Firefox';
        } else if (_.includes(user_agent, 'MSIE') || _.includes(user_agent, 'Trident/')) {
            return 'Internet Explorer';
        } else if (_.includes(user_agent, 'Gecko')) {
            return 'Mozilla';
        } else {
            return '';
        }
    },

    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */
    browserVersion: function(userAgent, vendor, opera) {
        var browser = _.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser' : /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) {
            return null;
        }
        var matches = userAgent.match(regex);
        if (!matches) {
            return null;
        }
        return parseFloat(matches[matches.length - 2]);
    },

    os: function() {
        var a = userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) {
                return 'Windows Phone';
            }
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) {
            return 'iOS';
        } else if (/Android/.test(a)) {
            return 'Android';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
            return 'BlackBerry';
        } else if (/Mac/i.test(a)) {
            return 'Mac OS X';
        } else if (/Linux/.test(a)) {
            return 'Linux';
        } else if (/CrOS/.test(a)) {
            return 'Chrome OS';
        } else {
            return '';
        }
    },

    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
            return 'Windows Phone';
        } else if (/iPad/.test(user_agent)) {
            return 'iPad';
        } else if (/iPod/.test(user_agent)) {
            return 'iPod Touch';
        } else if (/iPhone/.test(user_agent)) {
            return 'iPhone';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (/Android/.test(user_agent)) {
            return 'Android';
        } else {
            return '';
        }
    },

    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) {
            return split[2];
        }
        return '';
    },

    properties: function() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera),
            '$referrer': document$1.referrer,
            '$referring_domain': _.info.referringDomain(document$1.referrer),
            '$device': _.info.device(userAgent)
        }), {
            '$current_url': window$1.location.href,
            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, windowOpera),
            '$screen_height': screen.height,
            '$screen_width': screen.width,
            'mp_lib': 'web',
            '$lib_version': Config.LIB_VERSION,
            '$insert_id': cheap_guid(),
            'time': _.timestamp() / 1000 // epoch time in seconds
        });
    },

    people_properties: function() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera)
        }), {
            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, windowOpera)
        });
    },

    pageviewInfo: function(page) {
        return _.strip_empty_properties({
            'mp_page': page,
            'mp_referrer': document$1.referrer,
            'mp_browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera),
            'mp_platform': _.info.os()
        });
    }
};

var cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};

/**
 * Check deterministically whether to include or exclude from a feature rollout/test based on the
 * given string and the desired percentage to include.
 * @param {String} str - string to run the check against (for instance a project's token)
 * @param {String} feature - name of feature (for inclusion in hash, to ensure different results
 * for different features)
 * @param {Number} percent_allowed - percentage chance that a given string will be included
 * @returns {Boolean} whether the given string should be included
 */
var determine_eligibility = _.safewrap(function(str, feature, percent_allowed) {
    str = str + feature;

    // Bernstein's hash: http://www.cse.yorku.ca/~oz/hash.html#djb2
    var hash = 5381;
    for (var i = 0; i < str.length; i++) {
        hash = ((hash << 5) + hash) + str.charCodeAt(i);
        hash = hash & hash;
    }
    var dart = (hash >>> 0) % 100;
    return dart < percent_allowed;
});

// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */
var extract_domain = function(hostname) {
    var domain_regex = DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') {
        domain_regex = SIMPLE_DOMAIN_MATCH_REGEX;
    }
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};

var JSONStringify = null;
var JSONParse = null;
if (typeof JSON !== 'undefined') {
    JSONStringify = JSON.stringify;
    JSONParse = JSON.parse;
}
JSONStringify = JSONStringify || _.JSONEncode;
JSONParse = JSONParse || _.JSONDecode;

// EXPORTS (for closure compiler)
_['toArray']                = _.toArray;
_['isObject']               = _.isObject;
_['JSONEncode']             = _.JSONEncode;
_['JSONDecode']             = _.JSONDecode;
_['isBlockedUA']            = _.isBlockedUA;
_['isEmptyObject']          = _.isEmptyObject;
_['info']                   = _.info;
_['info']['device']         = _.info.device;
_['info']['browser']        = _.info.browser;
_['info']['browserVersion'] = _.info.browserVersion;
_['info']['properties']     = _.info.properties;

/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */
function getClassName(el) {
    switch(typeof el.className) {
        case 'string':
            return el.className;
        case 'object': // handle cases where className might be SVGAnimatedString or some other type
            return el.className.baseVal || el.getAttribute('class') || '';
        default: // future proof
            return '';
    }
}

/*
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @returns {string} the element's direct text content
 */
function getSafeText(el) {
    var elText = '';

    if (shouldTrackElement(el) && el.childNodes && el.childNodes.length) {
        _.each(el.childNodes, function(child) {
            if (isTextNode(child) && child.textContent) {
                elText += _.trim(child.textContent)
                    // scrub potentially sensitive values
                    .split(/(\s+)/).filter(shouldTrackValue).join('')
                    // normalize whitespace
                    .replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ')
                    // truncate
                    .substring(0, 255);
            }
        });
    }

    return _.trim(elText);
}

/*
 * Check whether an element has nodeType Node.ELEMENT_NODE
 * @param {Element} el - element to check
 * @returns {boolean} whether el is of the correct nodeType
 */
function isElementNode(el) {
    return el && el.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}

/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */
function isTag(el, tag) {
    return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}

/*
 * Check whether an element has nodeType Node.TEXT_NODE
 * @param {Element} el - element to check
 * @returns {boolean} whether el is of the correct nodeType
 */
function isTextNode(el) {
    return el && el.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}

/*
 * Check whether a DOM event should be "tracked" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} event - event to check
 * @returns {boolean} whether the event should be tracked
 */
function shouldTrackDomEvent(el, event) {
    if (!el || isTag(el, 'html') || !isElementNode(el)) {
        return false;
    }
    var tag = el.tagName.toLowerCase();
    switch (tag) {
        case 'html':
            return false;
        case 'form':
            return event.type === 'submit';
        case 'input':
            if (['button', 'submit'].indexOf(el.getAttribute('type')) === -1) {
                return event.type === 'change';
            } else {
                return event.type === 'click';
            }
        case 'select':
        case 'textarea':
            return event.type === 'change';
        default:
            return event.type === 'click';
    }
}

/*
 * Check whether a DOM element should be "tracked" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @returns {boolean} whether the element should be tracked
 */
function shouldTrackElement(el) {
    for (var curEl = el; curEl.parentNode && !isTag(curEl, 'body'); curEl = curEl.parentNode) {
        var classes = getClassName(curEl).split(' ');
        if (_.includes(classes, 'mp-sensitive') || _.includes(classes, 'mp-no-track')) {
            return false;
        }
    }

    if (_.includes(getClassName(el).split(' '), 'mp-include')) {
        return true;
    }

    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    if (
        isTag(el, 'input') ||
        isTag(el, 'select') ||
        isTag(el, 'textarea') ||
        el.getAttribute('contenteditable') === 'true'
    ) {
        return false;
    }

    // don't include hidden or password fields
    var type = el.type || '';
    if (typeof type === 'string') { // it's possible for el.type to be a DOM element if el is a form with a child input[name="type"]
        switch(type.toLowerCase()) {
            case 'hidden':
                return false;
            case 'password':
                return false;
        }
    }

    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || '';
    if (typeof name === 'string') { // it's possible for el.name or el.id to be a DOM element if el is a form with a child input[name="name"]
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) {
            return false;
        }
    }

    return true;
}

/*
 * Check whether a string value should be "tracked" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be tracked
 */
function shouldTrackValue(value) {
    if (value === null || _.isUndefined(value)) {
        return false;
    }

    if (typeof value === 'string') {
        value = _.trim(value);

        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || '').replace(/[- ]/g, ''))) {
            return false;
        }

        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) {
            return false;
        }
    }

    return true;
}

var autotrack = {
    _initializedTokens: [],

    _previousElementSibling: function(el) {
        if (el.previousElementSibling) {
            return el.previousElementSibling;
        } else {
            do {
                el = el.previousSibling;
            } while (el && !isElementNode(el));
            return el;
        }
    },

    _loadScript: function(scriptUrlToLoad, callback) {
        var scriptTag = document.createElement('script');
        scriptTag.type = 'text/javascript';
        scriptTag.src = scriptUrlToLoad;
        scriptTag.onload = callback;

        var scripts = document.getElementsByTagName('script');
        if (scripts.length > 0) {
            scripts[0].parentNode.insertBefore(scriptTag, scripts[0]);
        } else {
            document.body.appendChild(scriptTag);
        }
    },

    _getPropertiesFromElement: function(elem) {
        var props = {
            'classes': getClassName(elem).split(' '),
            'tag_name': elem.tagName.toLowerCase()
        };

        if (shouldTrackElement(elem)) {
            _.each(elem.attributes, function(attr) {
                if (shouldTrackValue(attr.value)) {
                    props['attr__' + attr.name] = attr.value;
                }
            });
        }

        var nthChild = 1;
        var nthOfType = 1;
        var currentElem = elem;
        while (currentElem = this._previousElementSibling(currentElem)) { // eslint-disable-line no-cond-assign
            nthChild++;
            if (currentElem.tagName === elem.tagName) {
                nthOfType++;
            }
        }
        props['nth_child'] = nthChild;
        props['nth_of_type'] = nthOfType;

        return props;
    },

    _getDefaultProperties: function(eventType) {
        return {
            '$event_type': eventType,
            '$ce_version': 1,
            '$host': window.location.host,
            '$pathname': window.location.pathname
        };
    },

    _extractCustomPropertyValue: function(customProperty) {
        var propValues = [];
        _.each(document.querySelectorAll(customProperty['css_selector']), function(matchedElem) {
            var value;

            if (['input', 'select'].indexOf(matchedElem.tagName.toLowerCase()) > -1) {
                value = matchedElem['value'];
            } else if (matchedElem['textContent']) {
                value = matchedElem['textContent'];
            }

            if (shouldTrackValue(value)) {
                propValues.push(value);
            }
        });
        return propValues.join(', ');
    },

    _getCustomProperties: function(targetElementList) {
        var props = {};
        _.each(this._customProperties, function(customProperty) {
            _.each(customProperty['event_selectors'], function(eventSelector) {
                var eventElements = document.querySelectorAll(eventSelector);
                _.each(eventElements, function(eventElement) {
                    if (_.includes(targetElementList, eventElement) && shouldTrackElement(eventElement)) {
                        props[customProperty['name']] = this._extractCustomPropertyValue(customProperty);
                    }
                }, this);
            }, this);
        }, this);
        return props;
    },

    _getEventTarget: function(e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Event/target#Compatibility_notes
        if (typeof e.target === 'undefined') {
            return e.srcElement;
        } else {
            return e.target;
        }
    },

    _trackEvent: function(e, instance) {
        /*** Don't mess with this code without running IE8 tests on it ***/
        var target = this._getEventTarget(e);
        if (isTextNode(target)) { // defeat Safari bug (see: http://www.quirksmode.org/js/events_properties.html)
            target = target.parentNode;
        }

        if (shouldTrackDomEvent(target, e)) {
            var targetElementList = [target];
            var curEl = target;
            while (curEl.parentNode && !isTag(curEl, 'body')) {
                targetElementList.push(curEl.parentNode);
                curEl = curEl.parentNode;
            }

            var elementsJson = [];
            var href, explicitNoTrack = false;
            _.each(targetElementList, function(el) {
                var shouldTrackEl = shouldTrackElement(el);

                // if the element or a parent element is an anchor tag
                // include the href as a property
                if (el.tagName.toLowerCase() === 'a') {
                    href = el.getAttribute('href');
                    href = shouldTrackEl && shouldTrackValue(href) && href;
                }

                // allow users to programatically prevent tracking of elements by adding class 'mp-no-track'
                var classes = getClassName(el).split(' ');
                if (_.includes(classes, 'mp-no-track')) {
                    explicitNoTrack = true;
                }

                elementsJson.push(this._getPropertiesFromElement(el));
            }, this);

            if (explicitNoTrack) {
                return false;
            }

            // only populate text content from target element (not parents)
            // to prevent text within a sensitive element from being collected
            // as part of a parent's el.textContent
            var elementText;
            var safeElementText = getSafeText(target);
            if (safeElementText && safeElementText.length) {
                elementText = safeElementText;
            }

            var props = _.extend(
                this._getDefaultProperties(e.type),
                {
                    '$elements':  elementsJson,
                    '$el_attr__href': href,
                    '$el_text': elementText
                },
                this._getCustomProperties(targetElementList)
            );

            instance.track('$web_event', props);
            return true;
        }
    },

    // only reason is to stub for unit tests
    // since you can't override window.location props
    _navigate: function(href) {
        window.location.href = href;
    },

    _addDomEventHandlers: function(instance) {
        var handler = _.bind(function(e) {
            e = e || window.event;
            this._trackEvent(e, instance);
        }, this);
        _.register_event(document, 'submit', handler, false, true);
        _.register_event(document, 'change', handler, false, true);
        _.register_event(document, 'click', handler, false, true);
    },

    _customProperties: {},
    init: function(instance) {
        if (!(document && document.body)) {
            console.log('document not ready yet, trying again in 500 milliseconds...');
            var that = this;
            setTimeout(function() { that.init(instance); }, 500);
            return;
        }

        var token = instance.get_config('token');
        if (this._initializedTokens.indexOf(token) > -1) {
            console.log('autotrack already initialized for token "' + token + '"');
            return;
        }
        this._initializedTokens.push(token);

        if (!this._maybeLoadEditor(instance)) { // don't autotrack actions when the editor is enabled
            var parseDecideResponse = _.bind(function(response) {
                if (response && response['config'] && response['config']['enable_collect_everything'] === true) {

                    if (response['custom_properties']) {
                        this._customProperties = response['custom_properties'];
                    }

                    instance.track('$web_event', _.extend({
                        '$title': document.title
                    }, this._getDefaultProperties('pageview')));

                    this._addDomEventHandlers(instance);

                } else {
                    instance['__autotrack_enabled'] = false;
                }
            }, this);

            instance._send_request(
                instance.get_config('api_host') + '/decide/', {
                    'verbose': true,
                    'version': '1',
                    'lib': 'web',
                    'token': token
                },
                {method: 'GET', transport: 'XHR'},
                instance._prepare_callback(parseDecideResponse)
            );
        }
    },

    _editorParamsFromHash: function(instance, hash) {
        var editorParams;
        try {
            var state = _.getHashParam(hash, 'state');
            state = JSON.parse(decodeURIComponent(state));
            var expiresInSeconds = _.getHashParam(hash, 'expires_in');
            editorParams = {
                'accessToken': _.getHashParam(hash, 'access_token'),
                'accessTokenExpiresAt': (new Date()).getTime() + (Number(expiresInSeconds) * 1000),
                'bookmarkletMode': !!state['bookmarkletMode'],
                'projectId': state['projectId'],
                'projectOwnerId': state['projectOwnerId'],
                'projectToken': state['token'],
                'readOnly': state['readOnly'],
                'userFlags': state['userFlags'],
                'userId': state['userId']
            };
            window.sessionStorage.setItem('editorParams', JSON.stringify(editorParams));

            if (state['desiredHash']) {
                window.location.hash = state['desiredHash'];
            } else if (window.history) {
                history.replaceState('', document.title, window.location.pathname + window.location.search); // completely remove hash
            } else {
                window.location.hash = ''; // clear hash (but leaves # unfortunately)
            }
        } catch (e) {
            console.error('Unable to parse data from hash', e);
        }
        return editorParams;
    },

    /**
     * To load the visual editor, we need an access token and other state. That state comes from one of three places:
     * 1. In the URL hash params if the customer is using an old snippet
     * 2. From session storage under the key `_mpcehash` if the snippet already parsed the hash
     * 3. From session storage under the key `editorParams` if the editor was initialized on a previous page
     */
    _maybeLoadEditor: function(instance) {
        try {
            var parseFromUrl = false;
            if (_.getHashParam(window.location.hash, 'state')) {
                var state = _.getHashParam(window.location.hash, 'state');
                state = JSON.parse(decodeURIComponent(state));
                parseFromUrl = state['action'] === 'mpeditor';
            }
            var parseFromStorage = !!window.sessionStorage.getItem('_mpcehash');
            var editorParams;

            if (parseFromUrl) { // happens if they are initializing the editor using an old snippet
                editorParams = this._editorParamsFromHash(instance, window.location.hash);
            } else if (parseFromStorage) { // happens if they are initialized the editor and using the new snippet
                editorParams = this._editorParamsFromHash(instance, window.sessionStorage.getItem('_mpcehash'));
                window.sessionStorage.removeItem('_mpcehash');
            } else { // get credentials from sessionStorage from a previous initialzation
                editorParams = JSON.parse(window.sessionStorage.getItem('editorParams') || '{}');
            }

            if (editorParams['projectToken'] && instance.get_config('token') === editorParams['projectToken']) {
                this._loadEditor(instance, editorParams);
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    },

    _loadEditor: function(instance, editorParams) {
        if (!window['_mpEditorLoaded']) { // only load the codeless event editor once, even if there are multiple instances of MixpanelLib
            window['_mpEditorLoaded'] = true;
            var editorUrl = instance.get_config('app_host')
              + '/js-bundle/reports/collect-everything/editor.js?_ts='
              + (new Date()).getTime();
            this._loadScript(editorUrl, function() {
                window['mp_load_editor'](editorParams);
            });
            return true;
        }
        return false;
    },

    // this is a mechanism to ramp up CE with no server-side interaction.
    // when CE is active, every page load results in a decide request. we
    // need to gently ramp this up so we don't overload decide. this decides
    // deterministically if CE is enabled for this project by modding the char
    // value of the project token.
    enabledForProject: function(token, numBuckets, numEnabledBuckets) {
        numBuckets = !_.isUndefined(numBuckets) ? numBuckets : 10;
        numEnabledBuckets = !_.isUndefined(numEnabledBuckets) ? numEnabledBuckets : 10;
        var charCodeSum = 0;
        for (var i = 0; i < token.length; i++) {
            charCodeSum += token.charCodeAt(i);
        }
        return (charCodeSum % numBuckets) < numEnabledBuckets;
    },

    isBrowserSupported: function() {
        return _.isFunction(document.querySelectorAll);
    }
};

_.bind_instance_methods(autotrack);
_.safewrap_instance_methods(autotrack);

/**
 * DomTracker Object
 * @constructor
 */
var DomTracker = function() {};


// interface
DomTracker.prototype.create_properties = function() {};
DomTracker.prototype.event_handler = function() {};
DomTracker.prototype.after_track_handler = function() {};

DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};

/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */
DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = _.dom_query(query);

    if (elements.length === 0) {
        console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }

    _.each(elements, function(element) {
        _.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');

            that.event_handler(e, this, options);

            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);

            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);

    return true;
};

/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */
DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;

    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) { return; }
        options.callback_fired = true;

        if (user_callback && user_callback(timeout_occured, props) === false) {
            // user can prevent the default functionality by
            // returning false from their callback
            return;
        }

        that.after_track_handler(props, options, timeout_occured);
    };
};

DomTracker.prototype.create_properties = function(properties, element) {
    var props;

    if (typeof(properties) === 'function') {
        props = properties(element);
    } else {
        props = _.extend({}, properties);
    }

    return props;
};

/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */
var LinkTracker = function() {
    this.override_event = 'click';
};
_.inherit(LinkTracker, DomTracker);

LinkTracker.prototype.create_properties = function(properties, element) {
    var props = LinkTracker.superclass.create_properties.apply(this, arguments);

    if (element.href) { props['url'] = element.href; }

    return props;
};

LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = (
        evt.which === 2 ||
        evt.metaKey ||
        evt.ctrlKey ||
        element.target === '_blank'
    );
    options.href = element.href;

    if (!options.new_tab) {
        evt.preventDefault();
    }
};

LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) { return; }

    setTimeout(function() {
        window.location = options.href;
    }, 0);
};

/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */
var FormTracker = function() {
    this.override_event = 'submit';
};
_.inherit(FormTracker, DomTracker);

FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};

FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};

// eslint-disable-line camelcase

var logger$2 = console_with_prefix('lock');

/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */
var SharedLock = function(key, options) {
    options = options || {};

    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};

// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== 'function') {
        pid = errorCB;
        errorCB = null;
    }

    var i = pid || (new Date().getTime() + '|' + Math.random());
    var startTime = new Date().getTime();

    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;

    var keyX = key + ':X';
    var keyY = key + ':Y';
    var keyZ = key + ':Z';

    var reportError = function(err) {
        errorCB && errorCB(err);
    };

    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            logger$2.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch(err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };

    var waitFor = function(predicate, cb) {
        if (predicate()) {
            cb();
        } else {
            delay(function() {
                waitFor(predicate, cb);
            });
        }
    };

    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) { // if Y == i then this process already has the lock (useful for test cases)
            return false;
        } else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) {
                return true;
            } else {
                if (!localStorageSupported(storage, true)) {
                    throw new Error('localStorage support dropped while acquiring lock');
                }
                return false;
            }
        }
    };

    var loop = function() {
        storage.setItem(keyX, i);

        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }

            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };

    var criticalSection = function() {
        storage.setItem(keyZ, '1');
        try {
            lockedCB();
        } finally {
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) {
                storage.removeItem(keyY);
            }
            if (storage.getItem(keyX) === i) {
                storage.removeItem(keyX);
            }
        }
    };

    try {
        if (localStorageSupported(storage, true)) {
            loop();
        } else {
            throw new Error('localStorage support check failed');
        }
    } catch(err) {
        reportError(err);
    }
};

// eslint-disable-line camelcase

var logger$1 = console_with_prefix('batch');

/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */
var RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.lock = new SharedLock(storageKey, {storage: this.storage});

    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios

    this.memQueue = [];
};

/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */
RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        'id': cheap_guid(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };

    this.lock.withLock(_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) {
                // only add to in-memory queue when storage succeeds
                this.memQueue.push(queueEntry);
            }
        } catch(err) {
            logger$1.error('Error enqueueing item', item);
            succeeded = false;
        }
        if (cb) {
            cb(succeeded);
        }
    }, this), function lockFailure(err) {
        logger$1.error('Error acquiring storage lock', err);
        if (cb) {
            cb(false);
        }
    }, this.pid);
};

/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */
RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            _.each(batch, function(item) { idsInBatch[item['id']] = true; });

            for (var i = 0; i < storedQueue.length; i++) {
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) {
                        break;
                    }
                }
            }
        }
    }
    return batch;
};

/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */
var filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    _.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) {
            filteredItems.push(item);
        }
    });
    return filteredItems;
};

/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */
RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    _.each(ids, function(id) { idSet[id] = true; });

    this.memQueue = filterOutIDsAndInvalid(this.memQueue, idSet);
    this.lock.withLock(_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = filterOutIDsAndInvalid(storedQueue, idSet);
            succeeded = this.saveToStorage(storedQueue);
        } catch(err) {
            logger$1.error('Error removing items', ids);
            succeeded = false;
        }
        if (cb) {
            cb(succeeded);
        }
    }, this), function lockFailure(err) {
        logger$1.error('Error acquiring storage lock', err);
        if (cb) {
            cb(false);
        }
    }, this.pid);
};

// internal helper for RequestQueue.updatePayloads
var updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    _.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else {
            // no update
            newItems.push(item);
        }
    });
    return newItems;
};

/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */
RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = updatePayloads(this.memQueue, itemsToUpdate);
    this.lock.withLock(_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch(err) {
            logger$1.error('Error updating items', itemsToUpdate);
            succeeded = false;
        }
        if (cb) {
            cb(succeeded);
        }
    }, this), function lockFailure(err) {
        logger$1.error('Error acquiring storage lock', err);
        if (cb) {
            cb(false);
        }
    }, this.pid);
};

/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */
RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = JSONParse(storageEntry);
            if (!_.isArray(storageEntry)) {
                logger$1.error('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        logger$1.error('Error retrieving queue', err);
        storageEntry = null;
    }
    return storageEntry || [];
};

/**
 * Serialize the given items array to localStorage.
 */
RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, JSONStringify(queue));
        return true;
    } catch (err) {
        logger$1.error('Error saving queue', err);
        return false;
    }
};

/**
 * Clear out queues (memory and localStorage).
 */
RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    this.storage.removeItem(this.storageKey);
};

// eslint-disable-line camelcase

// maximum interval between request retries after exponential backoff
var MAX_RETRY_INTERVAL_MS = 10 * 60 * 1000; // 10 minutes

var logger = console_with_prefix('batch');

/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */
var RequestBatcher = function(storageKey, options) {
    this.queue = new RequestQueue(storageKey, {storage: options.storage});

    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;

    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];

    this.stopped = !this.libConfig['batch_autostart'];
};

/**
 * Add one item to queue.
 */
RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};

/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */
RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.flush();
};

/**
 * Stop flushing batches. Can be restarted by calling start().
 */
RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};

/**
 * Clear out queue.
 */
RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};

/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */
RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};

/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */
RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};

/**
 * Schedule the next flush in the given number of milliseconds.
 */
RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) { // don't schedule anymore if batching has been stopped
        this.timeoutID = setTimeout(_.bind(this.flush, this), this.flushInterval);
    }
};

/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */
RequestBatcher.prototype.flush = function(options) {
    try {

        if (this.requestInProgress) {
            logger.log('Flush: Request already in progress');
            return;
        }

        options = options || {};
        var timeoutMS = this.libConfig['batch_request_timeout_ms'];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        var dataForRequest = [];
        var transformedItems = {};
        _.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) {
                payload = this.beforeSendHook(payload);
            }
            if (payload) {
                dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }

        this.requestInProgress = true;

        var batchSendCallback = _.bind(function(res) {
            this.requestInProgress = false;

            try {

                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong

                var removeItemsFromQueue = false;
                if (options.unloading) {
                    // update persisted data to include hook transformations
                    this.queue.updatePayloads(transformedItems);
                } else if (
                    _.isObject(res) &&
                    res.error === 'timeout' &&
                    new Date().getTime() - startTime >= timeoutMS
                ) {
                    logger.error('Network timeout; retrying');
                    this.flush();
                } else if (
                    _.isObject(res) &&
                    res.xhr_req &&
                    (res.xhr_req['status'] >= 500 || res.xhr_req['status'] <= 0)
                ) {
                    // network or API error, retry
                    var retryMS = this.flushInterval * 2;
                    var headers = res.xhr_req['responseHeaders'];
                    if (headers) {
                        var retryAfter = headers['Retry-After'];
                        if (retryAfter) {
                            retryMS = (parseInt(retryAfter, 10) * 1000) || retryMS;
                        }
                    }
                    retryMS = Math.min(MAX_RETRY_INTERVAL_MS, retryMS);
                    logger.error('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                } else if (_.isObject(res) && res.xhr_req && res.xhr_req['status'] === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        logger.error('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                    } else {
                        logger.error('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else {
                    // successful network request+response; remove each item in batch from queue
                    // (even if it was e.g. a 400, in which case retrying won't help)
                    removeItemsFromQueue = true;
                }

                if (removeItemsFromQueue) {
                    this.queue.removeItemsByID(
                        _.map(batch, function(item) { return item['id']; }),
                        _.bind(this.flush, this) // handle next batch if the queue isn't empty
                    );
                }

            } catch(err) {
                logger.error('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true, // eslint-disable-line camelcase
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) {
            requestOptions.transport = 'sendBeacon';
        }
        logger.log('MIXPANEL REQUEST:', dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);

    } catch(err) {
        logger.error('Error flushing request queue', err);
        this.resetFlush();
    }
};

/**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */

/** Public **/

var GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';

/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function optIn(token, options) {
    _optInOut(true, token, options);
}

/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */
function optOut(token, options) {
    _optInOut(false, token, options);
}

/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */
function hasOptedIn(token, options) {
    return _getStorageValue(token, options) === '1';
}

/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */
function hasOptedOut(token, options) {
    if (_hasDoNotTrackFlagOn(options)) {
        return true;
    }
    return _getStorageValue(token, options) === '0';
}

/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelLib(method) {
    return _addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}

/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelPeople(method) {
    return _addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}

/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelGroup(method) {
    return _addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}

/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function clearOptInOut(token, options) {
    options = options || {};
    _getStorage(options).remove(
        _getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain
    );
}

/** Private **/

/**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */
function _getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? _.localStorage : _.cookie;
}

/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */
function _getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}

/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */
function _getStorageValue(token, options) {
    return _getStorage(options).get(_getStorageKey(token, options));
}

/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */
function _hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) {
        return false;
    }
    var win = (options && options.window) || window$1;
    var nav = win['navigator'] || {};
    var hasDntOn = false;

    _.each([
        nav['doNotTrack'], // standard
        nav['msDoNotTrack'],
        win['doNotTrack']
    ], function(dntValue) {
        if (_.includes([true, 1, '1', 'yes'], dntValue)) {
            hasDntOn = true;
        }
    });

    return hasDntOn;
}

/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function _optInOut(optValue, token, options) {
    if (!_.isString(token) || !token.length) {
        console.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }

    options = options || {};

    _getStorage(options).set(
        _getStorageKey(token, options),
        optValue ? 1 : 0,
        _.isNumber(options.cookieExpiration) ? options.cookieExpiration : null,
        !!options.crossSubdomainCookie,
        !!options.secureCookie,
        !!options.crossSiteCookie,
        options.cookieDomain
    );

    if (options.track && optValue) { // only track event if opting in (optValue=true)
        options.track(options.trackEventName || '$opt_in', options.trackProperties, {
            'send_immediately': true
        });
    }
}

/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function _addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;

        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests

            if (token) { // if there was an issue getting the token, continue method execution as normal
                optedOut = hasOptedOut(token, {
                    ignoreDnt: ignoreDnt,
                    persistenceType: persistenceType,
                    persistencePrefix: persistencePrefix,
                    window: win
                });
            }
        } catch(err) {
            console.error('Unexpected error when checking tracking opt-out status: ' + err);
        }

        if (!optedOut) {
            return method.apply(this, arguments);
        }

        var callback = arguments[arguments.length - 1];
        if (typeof(callback) === 'function') {
            callback(0);
        }

        return;
    };
}

/** @const */ var SET_ACTION      = '$set';
/** @const */ var SET_ONCE_ACTION = '$set_once';
/** @const */ var UNSET_ACTION    = '$unset';
/** @const */ var ADD_ACTION      = '$add';
/** @const */ var APPEND_ACTION   = '$append';
/** @const */ var UNION_ACTION    = '$union';
/** @const */ var REMOVE_ACTION   = '$remove';
/** @const */ var DELETE_ACTION   = '$delete';

// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if (_.isObject(prop)) {
            _.each(prop, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $set[k] = v;
                }
            }, this);
        } else {
            $set[prop] = to;
        }

        data[SET_ACTION] = $set;
        return data;
    },

    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!_.isArray(prop)) {
            prop = [prop];
        }

        _.each(prop, function(k) {
            if (!this._is_reserved_property(k)) {
                $unset.push(k);
            }
        }, this);

        data[UNSET_ACTION] = $unset;
        return data;
    },

    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if (_.isObject(prop)) {
            _.each(prop, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $set_once[k] = v;
                }
            }, this);
        } else {
            $set_once[prop] = to;
        }
        data[SET_ONCE_ACTION] = $set_once;
        return data;
    },

    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if (_.isObject(list_name)) {
            _.each(list_name, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $union[k] = _.isArray(v) ? v : [v];
                }
            }, this);
        } else {
            $union[list_name] = _.isArray(values) ? values : [values];
        }
        data[UNION_ACTION] = $union;
        return data;
    },

    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if (_.isObject(list_name)) {
            _.each(list_name, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $append[k] = v;
                }
            }, this);
        } else {
            $append[list_name] = value;
        }
        data[APPEND_ACTION] = $append;
        return data;
    },

    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if (_.isObject(list_name)) {
            _.each(list_name, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $remove[k] = v;
                }
            }, this);
        } else {
            $remove[list_name] = value;
        }
        data[REMOVE_ACTION] = $remove;
        return data;
    },

    delete_action: function() {
        var data = {};
        data[DELETE_ACTION] = '';
        return data;
    }
};

/**
 * Mixpanel Group Object
 * @constructor
 */
var MixpanelGroup = function() {};

_.extend(MixpanelGroup.prototype, apiActions);

MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};

/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.set = addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    return this._send_request(data, callback);
});

/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.set_once = addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    return this._send_request(data, callback);
});

/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.unset = addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});

/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.union = addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if (_.isObject(list_name)) {
        callback = values;
    }
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});

/**
 * Permanently delete a group.
 *
 * ### Usage:
 *     mixpanel.get_group('company', 'mixpanel').delete();
 */
MixpanelGroup.prototype['delete'] = addOptOutCheckMixpanelGroup(function(callback) {
    var data = this.delete_action();
    return this._send_request(data, callback);
});

/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.remove = addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});

MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');

    var date_encoded_data = _.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/groups/',
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};

MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};

MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};

MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};

// MixpanelGroup Exports
MixpanelGroup.prototype['remove']   = MixpanelGroup.prototype.remove;
MixpanelGroup.prototype['set']      = MixpanelGroup.prototype.set;
MixpanelGroup.prototype['set_once'] = MixpanelGroup.prototype.set_once;
MixpanelGroup.prototype['union']    = MixpanelGroup.prototype.union;
MixpanelGroup.prototype['unset']    = MixpanelGroup.prototype.unset;
MixpanelGroup.prototype['toString'] = MixpanelGroup.prototype.toString;

/*
 * Constants
 */
/** @const */ var SET_QUEUE_KEY          = '__mps';
/** @const */ var SET_ONCE_QUEUE_KEY     = '__mpso';
/** @const */ var UNSET_QUEUE_KEY        = '__mpus';
/** @const */ var ADD_QUEUE_KEY          = '__mpa';
/** @const */ var APPEND_QUEUE_KEY       = '__mpap';
/** @const */ var REMOVE_QUEUE_KEY       = '__mpr';
/** @const */ var UNION_QUEUE_KEY        = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var ALIAS_ID_KEY           = '__alias';
/** @const */ var CAMPAIGN_IDS_KEY       = '__cmpns';
/** @const */ var EVENT_TIMERS_KEY       = '__timers';
/** @const */ var RESERVED_PROPERTIES = [
    SET_QUEUE_KEY,
    SET_ONCE_QUEUE_KEY,
    UNSET_QUEUE_KEY,
    ADD_QUEUE_KEY,
    APPEND_QUEUE_KEY,
    REMOVE_QUEUE_KEY,
    UNION_QUEUE_KEY,
    PEOPLE_DISTINCT_ID_KEY,
    ALIAS_ID_KEY,
    CAMPAIGN_IDS_KEY,
    EVENT_TIMERS_KEY
];

/**
 * Mixpanel Persistence Object
 * @constructor
 */
var MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;

    if (config['persistence_name']) {
        this.name = 'mp_' + config['persistence_name'];
    } else {
        this.name = 'mp_' + config['token'] + '_mixpanel';
    }

    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }

    if (storage_type === 'localStorage' && _.localStorage.is_supported()) {
        this.storage = _.localStorage;
    } else {
        this.storage = _.cookie;
    }

    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};

MixpanelPersistence.prototype.properties = function() {
    var p = {};
    // Filter out reserved properties
    _.each(this['props'], function(v, k) {
        if (!_.include(RESERVED_PROPERTIES, k)) {
            p[k] = v;
        }
    });
    return p;
};

MixpanelPersistence.prototype.load = function() {
    if (this.disabled) { return; }

    var entry = this.storage.parse(this.name);

    if (entry) {
        this['props'] = _.extend({}, entry);
    }
};

MixpanelPersistence.prototype.upgrade = function(config) {
    var upgrade_from_old_lib = config['upgrade'],
        old_cookie_name,
        old_cookie;

    if (upgrade_from_old_lib) {
        old_cookie_name = 'mp_super_properties';
        // Case where they had a custom cookie name before.
        if (typeof(upgrade_from_old_lib) === 'string') {
            old_cookie_name = upgrade_from_old_lib;
        }

        old_cookie = this.storage.parse(old_cookie_name);

        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);

        if (old_cookie) {
            this['props'] = _.extend(
                this['props'],
                old_cookie['all'],
                old_cookie['events']
            );
        }
    }

    if (!config['cookie_name'] && config['name'] !== 'mixpanel') {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = 'mp_' + config['token'] + '_' + config['name'];
        old_cookie = this.storage.parse(old_cookie_name);

        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);

            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }

    if (this.storage === _.localStorage) {
        old_cookie = _.cookie.parse(this.name);

        _.cookie.remove(this.name);
        _.cookie.remove(this.name, true);

        if (old_cookie) {
            this.register_once(old_cookie);
        }
    }
};

MixpanelPersistence.prototype.save = function() {
    if (this.disabled) { return; }
    this._expire_notification_campaigns();
    this.storage.set(
        this.name,
        _.JSONEncode(this['props']),
        this.expire_days,
        this.cross_subdomain,
        this.secure,
        this.cross_site,
        this.cookie_domain
    );
};

MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};

// removes the storage entry and deletes all loaded data
// forced name for tests
MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};

/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/
MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if (_.isObject(props)) {
        if (typeof(default_value) === 'undefined') { default_value = 'None'; }
        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;

        _.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) {
                this['props'][prop] = val;
            }
        }, this);

        this.save();

        return true;
    }
    return false;
};

/**
* @param {Object} props
* @param {number=} days
*/
MixpanelPersistence.prototype.register = function(props, days) {
    if (_.isObject(props)) {
        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;

        _.extend(this['props'], props);

        this.save();

        return true;
    }
    return false;
};

MixpanelPersistence.prototype.unregister = function(prop) {
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};

MixpanelPersistence.prototype._expire_notification_campaigns = _.safewrap(function() {
    var campaigns_shown = this['props'][CAMPAIGN_IDS_KEY],
        EXPIRY_TIME = Config.DEBUG ? 60 * 1000 : 60 * 60 * 1000; // 1 minute (Config.DEBUG) / 1 hour (PDXN)
    if (!campaigns_shown) {
        return;
    }
    for (var campaign_id in campaigns_shown) {
        if (1 * new Date() - campaigns_shown[campaign_id] > EXPIRY_TIME) {
            delete campaigns_shown[campaign_id];
        }
    }
    if (_.isEmptyObject(campaigns_shown)) {
        delete this['props'][CAMPAIGN_IDS_KEY];
    }
});

MixpanelPersistence.prototype.update_campaign_params = function() {
    if (!this.campaign_params_saved) {
        this.register_once(_.info.campaignParams());
        this.campaign_params_saved = true;
    }
};

MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register(_.info.searchInfo(referrer));
};

// EXPORTED METHOD, we test this directly.
MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': _.info.referringDomain(referrer) || '$direct'
    }, '');
};

MixpanelPersistence.prototype.get_referrer_info = function() {
    return _.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};

// safely fills the passed in object with stored properties,
// does not override any properties defined in both
// returns the passed in object
MixpanelPersistence.prototype.safe_merge = function(props) {
    _.each(this['props'], function(val, prop) {
        if (!(prop in props)) {
            props[prop] = val;
        }
    });

    return props;
};

MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};

MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) {
        this.remove();
    } else {
        this.save();
    }
};

MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};

MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};

MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue),
        q_data = data[queue],
        set_q = this._get_or_create_queue(SET_ACTION),
        set_once_q = this._get_or_create_queue(SET_ONCE_ACTION),
        unset_q = this._get_or_create_queue(UNSET_ACTION),
        add_q = this._get_or_create_queue(ADD_ACTION),
        union_q = this._get_or_create_queue(UNION_ACTION),
        remove_q = this._get_or_create_queue(REMOVE_ACTION, []),
        append_q = this._get_or_create_queue(APPEND_ACTION, []);

    if (q_key === SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        _.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue(ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue(UNION_ACTION, q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        _.each(q_data, function(v, k) {
            if (!(k in set_once_q)) {
                set_once_q[k] = v;
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNSET_QUEUE_KEY) {
        _.each(q_data, function(prop) {

            // undo previously-queued actions on this key
            _.each([set_q, set_once_q, add_q, union_q], function(enqueued_obj) {
                if (prop in enqueued_obj) {
                    delete enqueued_obj[prop];
                }
            });
            _.each(append_q, function(append_obj) {
                if (prop in append_obj) {
                    delete append_obj[prop];
                }
            });

            unset_q[prop] = true;

        });
    } else if (q_key === ADD_QUEUE_KEY) {
        _.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) {
                set_q[k] += v;
            } else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) {
                    add_q[k] = 0;
                }
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNION_QUEUE_KEY) {
        _.each(q_data, function(v, k) {
            if (_.isArray(v)) {
                if (!(k in union_q)) {
                    union_q[k] = [];
                }
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue(APPEND_ACTION, q_data);
    } else if (q_key === APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    }

    console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    console$1.log(data);

    this.save();
};

MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this._get_queue(queue);
    if (!_.isUndefined(q)) {
        _.each(data, function(v, k) {
            if (queue === APPEND_ACTION || queue === REMOVE_ACTION) {
                // list actions: only remove if both k+v match
                // e.g. remove should not override append in a case like
                // append({foo: 'bar'}); remove({foo: 'qux'})
                _.each(q, function(queued_action) {
                    if (queued_action[k] === v) {
                        delete queued_action[k];
                    }
                });
            } else {
                delete q[k];
            }
        }, this);

        this.save();
    }
};

MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === SET_ACTION) {
        return SET_QUEUE_KEY;
    } else if (queue === SET_ONCE_ACTION) {
        return SET_ONCE_QUEUE_KEY;
    } else if (queue === UNSET_ACTION) {
        return UNSET_QUEUE_KEY;
    } else if (queue === ADD_ACTION) {
        return ADD_QUEUE_KEY;
    } else if (queue === APPEND_ACTION) {
        return APPEND_QUEUE_KEY;
    } else if (queue === REMOVE_ACTION) {
        return REMOVE_QUEUE_KEY;
    } else if (queue === UNION_ACTION) {
        return UNION_QUEUE_KEY;
    } else {
        console$1.error('Invalid queue:', queue);
    }
};

MixpanelPersistence.prototype._get_queue = function(queue) {
    return this['props'][this._get_queue_key(queue)];
};
MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = _.isUndefined(default_val) ? {} : default_val;

    return this['props'][key] || (this['props'][key] = default_val);
};

MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this['props'][EVENT_TIMERS_KEY] || {};
    timers[event_name] = timestamp;
    this['props'][EVENT_TIMERS_KEY] = timers;
    this.save();
};

MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this['props'][EVENT_TIMERS_KEY] || {};
    var timestamp = timers[event_name];
    if (!_.isUndefined(timestamp)) {
        delete this['props'][EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};

/*
 * This file is a js implementation for a subset in eval_node.c
 */

/*
 * Constants
 */
// Metadata keys
/** @const */   var OPERATOR_KEY                  = 'operator';
/** @const */   var PROPERTY_KEY                  = 'property';
/** @const */   var WINDOW_KEY                    = 'window';
/** @const */   var UNIT_KEY                      = 'unit';
/** @const */   var VALUE_KEY                     = 'value';
/** @const */   var HOUR_KEY                      = 'hour';
/** @const */   var DAY_KEY                       = 'day';
/** @const */   var WEEK_KEY                      = 'week';
/** @const */   var MONTH_KEY                     = 'month';

// Operands
/** @const */   var EVENT_PROPERTY         = 'event';
/** @const */   var LITERAL_PROPERTY       = 'literal';

// Binary Operators
/** @const */   var AND_OPERATOR           = 'and';
/** @const */   var OR_OPERATOR            = 'or';
/** @const */   var IN_OPERATOR            = 'in';
/** @const */   var NOT_IN_OPERATOR        = 'not in';
/** @const */   var PLUS_OPERATOR          = '+';
/** @const */   var MINUS_OPERATOR         = '-';
/** @const */   var MUL_OPERATOR           = '*';
/** @const */   var DIV_OPERATOR           = '/';
/** @const */   var MOD_OPERATOR           = '%';
/** @const */   var EQUALS_OPERATOR        = '==';
/** @const */   var NOT_EQUALS_OPERATOR    = '!=';
/** @const */   var GREATER_OPERATOR       = '>';
/** @const */   var LESS_OPERATOR          = '<';
/** @const */   var GREATER_EQUAL_OPERATOR = '>=';
/** @const */   var LESS_EQUAL_OPERATOR    = '<=';

// Typecast Operators
/** @const */   var BOOLEAN_OPERATOR       = 'boolean';
/** @const */   var DATETIME_OPERATOR      = 'datetime';
/** @const */   var LIST_OPERATOR          = 'list';
/** @const */   var NUMBER_OPERATOR        = 'number';
/** @const */   var STRING_OPERATOR        = 'string';

// Unary Operators
/** @const */   var NOT_OPERATOR           = 'not';
/** @const */   var DEFINED_OPERATOR       = 'defined';
/** @const */   var NOT_DEFINED_OPERATOR   = 'not defined';

// Special literals
/** @const */   var NOW_LITERAL            = 'now';

// Type cast functions
function toNumber(value) {
    if (value === null) {
        return null;
    }

    switch (typeof(value)) {
        case 'object':
            if (_.isDate(value) && value.getTime() >= 0) {
                return value.getTime();
            }
            return null;
        case 'boolean':
            return Number(value);
        case 'number':
            return value;
        case 'string':
            value = Number(value);
            if (!isNaN(value)) {
                return value;
            }
            return 0;
    }
    return null;
}

function evaluateNumber(op, properties) {
    if (!op['operator'] || op['operator'] !== NUMBER_OPERATOR || !op['children'] || op['children'].length !== 1) {
        throw ('Invalid cast operator: number ' + op);
    }

    return toNumber(evaluateSelector(op['children'][0], properties));
}

function toBoolean(value) {
    if (value === null) {
        return false;
    }

    switch (typeof value) {
        case 'boolean':
            return value;
        case 'number':
            return value !== 0.0;
        case 'string':
            return value.length > 0;
        case 'object':
            if (_.isArray(value) && value.length > 0) {
                return true;
            }
            if (_.isDate(value) && value.getTime() > 0) {
                return true;
            }
            if (_.isObject(value) && !_.isEmptyObject(value)) {
                return true;
            }
            return false;
    }
    return false;
}

function evaluateBoolean(op, properties) {
    if (!op['operator'] || op['operator'] !== BOOLEAN_OPERATOR || !op['children'] || op['children'].length !== 1) {
        throw ('Invalid cast operator: boolean ' + op);
    }

    return toBoolean(evaluateSelector(op['children'][0], properties));
}

function evaluateDateTime(op, properties) {
    if (!op['operator'] || op['operator'] !== DATETIME_OPERATOR || !op['children'] || op['children'].length !== 1) {
        throw ('Invalid cast operator: datetime ' + op);
    }

    var v = evaluateSelector(op['children'][0], properties);
    if (v === null) {
        return null;
    }

    switch (typeof(v)) {
        case 'number':
        case 'string':
            var d = new Date(v);
            if (isNaN(d.getTime())) {
                return null;
            }
            return d;
        case 'object':
            if (_.isDate(v)) {
                return v;
            }
    }

    return null;
}

function evaluateList(op, properties) {
    if (!op['operator'] || op['operator'] !== LIST_OPERATOR || !op['children'] || op['children'].length !== 1) {
        throw ('Invalid cast operator: list ' + op);
    }

    var v = evaluateSelector(op['children'][0], properties);
    if (v === null) {
        return null;
    }

    if (_.isArray(v)) {
        return v;
    }

    return null;
}

function evaluateString(op, properties) {
    if (!op['operator'] || op['operator'] !== STRING_OPERATOR || !op['children'] || op['children'].length !== 1) {
        throw ('Invalid cast operator: string ' + op);
    }

    var v = evaluateSelector(op['children'][0], properties);
    switch (typeof(v)) {
        case 'object':
            if (_.isDate(v)) {
                return v.toJSON();
            }
            return JSON.stringify(v);
    }
    return String(v);
}

// Operators
function evaluateAnd(op, properties) {
    if (!op['operator'] || op['operator'] !== AND_OPERATOR || !op['children'] || op['children'].length !== 2) {
        throw ('Invalid operator: AND ' + op);
    }

    return toBoolean(evaluateSelector(op['children'][0], properties)) && toBoolean(evaluateSelector(op['children'][1], properties));
}

function evaluateOr(op, properties) {
    if (!op['operator'] || op['operator'] !== OR_OPERATOR || !op['children'] || op['children'].length !== 2) {
        throw ('Invalid operator: OR ' + op);
    }

    return toBoolean(evaluateSelector(op['children'][0], properties)) || toBoolean(evaluateSelector(op['children'][1], properties));
}

function evaluateIn(op, properties) {
    if (!op['operator'] || [IN_OPERATOR, NOT_IN_OPERATOR].indexOf(op['operator']) === -1 || !op['children'] || op['children'].length !== 2) {
        throw ('Invalid operator: IN/NOT IN ' + op);
    }
    var leftValue = evaluateSelector(op['children'][0], properties);
    var rightValue = evaluateSelector(op['children'][1], properties);

    if (!_.isArray(rightValue) && !_.isString(rightValue)) {
        throw ('Invalid operand for operator IN: invalid type' + rightValue);
    }

    var v = rightValue.indexOf(leftValue) > -1;
    if (op['operator'] === NOT_IN_OPERATOR) {
        return !v;
    }
    return v;
}

function evaluatePlus(op, properties) {
    if (!op['operator'] || op['operator'] !== PLUS_OPERATOR || !op['children'] || op['children'].length < 2) {
        throw ('Invalid operator: PLUS ' + op);
    }
    var l = evaluateSelector(op['children'][0], properties);
    var r = evaluateSelector(op['children'][1], properties);

    if (typeof l === 'number' && typeof r === 'number') {
        return l + r;
    }
    if (typeof l === 'string' && typeof r === 'string') {
        return l + r;
    }
    return null;
}

function evaluateArithmetic(op, properties) {
    if (!op['operator'] || [MINUS_OPERATOR, MUL_OPERATOR, DIV_OPERATOR, MOD_OPERATOR].indexOf(op['operator']) === -1 ||
        !op['children'] || op['children'].length < 2) {
        throw ('Invalid arithmetic operator ' + op);
    }

    var l = evaluateSelector(op['children'][0], properties);
    var r = evaluateSelector(op['children'][1], properties);

    if (typeof l === 'number' && typeof r === 'number') {
        switch (op['operator']) {
            case MINUS_OPERATOR:
                return l - r;
            case MUL_OPERATOR:
                return l * r;
            case DIV_OPERATOR:
                if (r !== 0) {
                    return l / r;
                }
                return null;
            case MOD_OPERATOR:
                if (r === 0) {
                    return null;
                }
                if (l === 0) {
                    return 0;
                }
                if ((l < 0 && r > 0) || (l > 0 && r < 0)) {
                    /* Mimic python modulo - result takes sign of the divisor
                     * if one operand is negative. */
                    return -(Math.floor(l / r) * r - l);
                }
                return l % r;
            default:
                throw('Unknown operator: ' + op['operator']);
        }
    }

    return null;
}

function _isArrayEqual(l, r) {
    if (l === r) return true;
    if (l === null || r === null) return false;
    if (l.length !== r.length) return false;

    for (var i = 0; i < l.length; i++) {
        if (l[i] !== r[i]) {
            return false;
        }
    }

    return true;
}

function _isEqual(l, r) {
    if ( l === null && l === r ) {
        return true;
    }
    if (typeof l === typeof r) {
        switch (typeof l) {
            case 'number':
            case 'string':
            case 'boolean':
                return l === r;
            case 'object':
                if (_.isArray(l) && _.isArray(r)) {
                    return _isArrayEqual(l, r);
                }
                if (_.isDate(l) && _.isDate(r)) {
                    return l.getTime() === r.getTime();
                }
                if (_.isObject(l) && _.isObject(r)) {
                    return JSON.stringify(l) === JSON.stringify(r);
                }
        }
    }
    return false;
}

function evaluateEquality(op, properties) {
    if (!op['operator'] || [EQUALS_OPERATOR, NOT_EQUALS_OPERATOR].indexOf(op['operator']) === -1 || !op['children'] || op['children'].length !== 2) {
        throw ('Invalid equality operator ' + op);
    }

    var v = _isEqual(evaluateSelector(op['children'][0], properties), evaluateSelector(op['children'][1], properties));

    switch (op['operator']) {
        case EQUALS_OPERATOR:
            return v;
        case NOT_EQUALS_OPERATOR:
            return !v;
    }
}

function evaluateComparison(op, properties) {
    if (!op['operator'] ||
        [GREATER_OPERATOR, GREATER_EQUAL_OPERATOR, LESS_OPERATOR, LESS_EQUAL_OPERATOR].indexOf(op['operator']) === -1 ||
        !op['children'] || op['children'].length !== 2) {
        throw ('Invalid comparison operator ' + op);
    }
    var l = evaluateSelector(op['children'][0], properties);
    var r = evaluateSelector(op['children'][1], properties);

    if (typeof(l) === typeof(r)) {
        if (typeof(r) === 'number' || _.isDate(r)) {
            l = toNumber(l);
            r = toNumber(r);
            switch (op['operator']) {
                case GREATER_OPERATOR:
                    return l > r;
                case GREATER_EQUAL_OPERATOR:
                    return l >= r;
                case LESS_OPERATOR:
                    return l < r;
                case LESS_EQUAL_OPERATOR:
                    return l <= r;
            }
        } else if (typeof(r) === 'string') {
            var compare = l.localeCompare(r);
            switch (op['operator']) {
                case GREATER_OPERATOR:
                    return compare > 0;
                case GREATER_EQUAL_OPERATOR:
                    return compare >= 0;
                case LESS_OPERATOR:
                    return compare < 0;
                case LESS_EQUAL_OPERATOR:
                    return compare <= 0;
            }
        }
    }

    return null;
}

function evaluateDefined(op, properties) {
    if (!op['operator'] || [DEFINED_OPERATOR, NOT_DEFINED_OPERATOR].indexOf(op['operator']) === -1 ||
        !op['children'] || op['children'].length !== 1) {
        throw ('Invalid defined/not defined operator: ' + op);
    }

    var b = evaluateSelector(op['children'][0], properties) !== null;
    if (op['operator'] === NOT_DEFINED_OPERATOR) {
        return !b;
    }

    return b;
}

function evaluateNot(op, properties) {
    if (!op['operator'] || op['operator'] !== NOT_OPERATOR || !op['children'] || op['children'].length !== 1) {
        throw ('Invalid not operator: ' + op);
    }

    var v = evaluateSelector(op['children'][0], properties);
    if (v === null) {
        return true;
    }

    if (typeof(v) === 'boolean') {
        return !v;
    }

    return null;
}

function evaluateOperator(op, properties) {
    if (!op['operator']) {
        throw ('Invalid operator: operator key missing ' + op);
    }

    switch (op['operator']) {
        case AND_OPERATOR:
            return evaluateAnd(op, properties);
        case OR_OPERATOR:
            return evaluateOr(op, properties);
        case IN_OPERATOR:
        case NOT_IN_OPERATOR:
            return evaluateIn(op, properties);
        case PLUS_OPERATOR:
            return evaluatePlus(op, properties);
        case MINUS_OPERATOR:
        case MUL_OPERATOR:
        case DIV_OPERATOR:
        case MOD_OPERATOR:
            return evaluateArithmetic(op, properties);
        case EQUALS_OPERATOR:
        case NOT_EQUALS_OPERATOR:
            return evaluateEquality(op, properties);
        case GREATER_OPERATOR:
        case LESS_OPERATOR:
        case GREATER_EQUAL_OPERATOR:
        case LESS_EQUAL_OPERATOR:
            return evaluateComparison(op, properties);
        case BOOLEAN_OPERATOR:
            return evaluateBoolean(op, properties);
        case DATETIME_OPERATOR:
            return evaluateDateTime(op, properties);
        case LIST_OPERATOR:
            return evaluateList(op, properties);
        case NUMBER_OPERATOR:
            return evaluateNumber(op, properties);
        case STRING_OPERATOR:
            return evaluateString(op, properties);
        case DEFINED_OPERATOR:
        case NOT_DEFINED_OPERATOR:
            return evaluateDefined(op, properties);
        case NOT_OPERATOR:
            return evaluateNot(op, properties);
    }
}

function evaluateWindow(value) {
    var win = value[WINDOW_KEY];
    if (!win || !win[UNIT_KEY] || !win[VALUE_KEY]) {
        throw('Invalid window: missing required keys ' + JSON.stringify(value));
    }
    var out = new Date();
    switch (win[UNIT_KEY]) {
        case HOUR_KEY:
            out.setTime(out.getTime() + (win[VALUE_KEY]*-1*60*60*1000));
            break;
        case DAY_KEY:
            out.setTime(out.getTime() + (win[VALUE_KEY]*-1*24*60*60*1000));
            break;
        case WEEK_KEY:
            out.setTime(out.getTime() + (win[VALUE_KEY]*-1*7*24*60*60*1000));
            break;
        case MONTH_KEY:
            out.setTime(out.getTime() + (win[VALUE_KEY]*-1*30*24*60*60*1000));
            break;
        default:
            throw('Invalid unit: ' + win[UNIT_KEY]);
    }

    return out;
}

function evaluateOperand(op, properties) {
    if (!op['property'] || !op['value']) {
        throw('Invalid operand: missing required keys ' + op);
    }
    switch (op['property']) {
        case EVENT_PROPERTY:
            if (properties[op['value']] !== undefined) {
                return properties[op['value']];
            }
            return null;
        case LITERAL_PROPERTY:
            if (op['value'] === NOW_LITERAL) {
                return new Date();
            }
            if (typeof(op['value']) === 'object') {
                return evaluateWindow(op['value']);
            }
            return op['value'];
        default:
            throw('Invalid operand: Invalid property type ' + op['property']);
    }
}

function evaluateSelector(filters, properties) {
    if (filters[PROPERTY_KEY]) {
        return evaluateOperand(filters, properties);
    }
    if (filters[OPERATOR_KEY]) {
        return evaluateOperator(filters, properties);
    }
}

// Internal class for notification display

var MixpanelNotification = function(notif_data, mixpanel_instance) {
    _.bind_instance_methods(this);

    this.mixpanel          = mixpanel_instance;
    this.persistence       = this.mixpanel['persistence'];
    this.resource_protocol = this.mixpanel.get_config('inapp_protocol');
    this.cdn_host          = this.mixpanel.get_config('cdn');

    this.campaign_id = _.escapeHTML(notif_data['id']);
    this.message_id  = _.escapeHTML(notif_data['message_id']);

    this.body            = (_.escapeHTML(notif_data['body']) || '').replace(/\n/g, '<br/>');
    this.cta             = _.escapeHTML(notif_data['cta']) || 'Close';
    this.notif_type      = _.escapeHTML(notif_data['type']) || 'takeover';
    this.style           = _.escapeHTML(notif_data['style']) || 'light';
    this.title           = _.escapeHTML(notif_data['title']) || '';
    this.video_width     = MixpanelNotification.VIDEO_WIDTH;
    this.video_height    = MixpanelNotification.VIDEO_HEIGHT;

    this.display_triggers = notif_data['display_triggers'] || [];

    // These fields are url-sanitized in the backend already.
    this.dest_url        = notif_data['cta_url'] || null;
    this.image_url       = notif_data['image_url'] || null;
    this.thumb_image_url = notif_data['thumb_image_url'] || null;
    this.video_url       = notif_data['video_url'] || null;

    if (this.thumb_image_url && this.thumb_image_url.indexOf('//') === 0) {
        this.thumb_image_url = this.thumb_image_url.replace('//', this.resource_protocol);
    }

    this.clickthrough = true;
    if (!this.dest_url) {
        this.dest_url = '#dismiss';
        this.clickthrough = false;
    }

    this.mini = this.notif_type === 'mini';
    if (!this.mini) {
        this.notif_type = 'takeover';
    }
    this.notif_width = !this.mini ? MixpanelNotification.NOTIF_WIDTH : MixpanelNotification.NOTIF_WIDTH_MINI;

    this._set_client_config();
    this.imgs_to_preload = this._init_image_html();
    this._init_video();
};

MixpanelNotification.ANIM_TIME         = 200;
MixpanelNotification.MARKUP_PREFIX     = 'mixpanel-notification';
MixpanelNotification.BG_OPACITY        = 0.6;
MixpanelNotification.NOTIF_TOP         = 25;
MixpanelNotification.NOTIF_START_TOP   = 200;
MixpanelNotification.NOTIF_WIDTH       = 388;
MixpanelNotification.NOTIF_WIDTH_MINI  = 420;
MixpanelNotification.NOTIF_HEIGHT_MINI = 85;
MixpanelNotification.THUMB_BORDER_SIZE = 5;
MixpanelNotification.THUMB_IMG_SIZE    = 60;
MixpanelNotification.THUMB_OFFSET      = Math.round(MixpanelNotification.THUMB_IMG_SIZE / 2);
MixpanelNotification.VIDEO_WIDTH       = 595;
MixpanelNotification.VIDEO_HEIGHT      = 334;

MixpanelNotification.prototype.show = function() {
    var self = this;
    this._set_client_config();

    // don't display until HTML body exists
    if (!this.body_el) {
        setTimeout(function() { self.show(); }, 300);
        return;
    }

    this._init_styles();
    this._init_notification_el();

    // wait for any images to load before showing notification
    this._preload_images(this._attach_and_animate);
};

MixpanelNotification.prototype.dismiss = _.safewrap(function() {
    if (!this.marked_as_shown) {
        // unexpected condition: user interacted with notif even though we didn't consider it
        // visible (see _mark_as_shown()); send tracking signals to mark delivery
        this._mark_delivery({'invisible': true});
    }

    var exiting_el = this.showing_video ? this._get_el('video') : this._get_notification_display_el();
    if (this.use_transitions) {
        this._remove_class('bg', 'visible');
        this._add_class(exiting_el, 'exiting');
        setTimeout(this._remove_notification_el, MixpanelNotification.ANIM_TIME);
    } else {
        var notif_attr, notif_start, notif_goal;
        if (this.mini) {
            notif_attr  = 'right';
            notif_start = 20;
            notif_goal  = -100;
        } else {
            notif_attr  = 'top';
            notif_start = MixpanelNotification.NOTIF_TOP;
            notif_goal  = MixpanelNotification.NOTIF_START_TOP + MixpanelNotification.NOTIF_TOP;
        }
        this._animate_els([
            {
                el:    this._get_el('bg'),
                attr:  'opacity',
                start: MixpanelNotification.BG_OPACITY,
                goal:  0.0
            },
            {
                el:    exiting_el,
                attr:  'opacity',
                start: 1.0,
                goal:  0.0
            },
            {
                el:    exiting_el,
                attr:  notif_attr,
                start: notif_start,
                goal:  notif_goal
            }
        ], MixpanelNotification.ANIM_TIME, this._remove_notification_el);
    }
});

MixpanelNotification.prototype._add_class = _.safewrap(function(el, class_name) {
    class_name = MixpanelNotification.MARKUP_PREFIX + '-' + class_name;
    if (typeof el === 'string') {
        el = this._get_el(el);
    }
    if (!el.className) {
        el.className = class_name;
    } else if (!~(' ' + el.className + ' ').indexOf(' ' + class_name + ' ')) {
        el.className += ' ' + class_name;
    }
});
MixpanelNotification.prototype._remove_class = _.safewrap(function(el, class_name) {
    class_name = MixpanelNotification.MARKUP_PREFIX + '-' + class_name;
    if (typeof el === 'string') {
        el = this._get_el(el);
    }
    if (el.className) {
        el.className = (' ' + el.className + ' ')
            .replace(' ' + class_name + ' ', '')
            .replace(/^[\s\xA0]+/, '')
            .replace(/[\s\xA0]+$/, '');
    }
});

MixpanelNotification.prototype._animate_els = _.safewrap(function(anims, mss, done_cb, start_time) {
    var self = this,
        in_progress = false,
        ai, anim,
        cur_time = 1 * new Date(), time_diff;

    start_time = start_time || cur_time;
    time_diff = cur_time - start_time;

    for (ai = 0; ai < anims.length; ai++) {
        anim = anims[ai];
        if (typeof anim.val === 'undefined') {
            anim.val = anim.start;
        }
        if (anim.val !== anim.goal) {
            in_progress = true;
            var anim_diff = anim.goal - anim.start,
                anim_dir = anim.goal >= anim.start ? 1 : -1;
            anim.val = anim.start + anim_diff * time_diff / mss;
            if (anim.attr !== 'opacity') {
                anim.val = Math.round(anim.val);
            }
            if ((anim_dir > 0 && anim.val >= anim.goal) || (anim_dir < 0 && anim.val <= anim.goal)) {
                anim.val = anim.goal;
            }
        }
    }
    if (!in_progress) {
        if (done_cb) {
            done_cb();
        }
        return;
    }

    for (ai = 0; ai < anims.length; ai++) {
        anim = anims[ai];
        if (anim.el) {
            var suffix = anim.attr === 'opacity' ? '' : 'px';
            anim.el.style[anim.attr] = String(anim.val) + suffix;
        }
    }
    setTimeout(function() { self._animate_els(anims, mss, done_cb, start_time); }, 10);
});

MixpanelNotification.prototype._attach_and_animate = _.safewrap(function() {
    var self = this;

    // no possibility to double-display
    if (this.shown || this._get_shown_campaigns()[this.campaign_id]) {
        return;
    }
    this.shown = true;

    this.body_el.appendChild(this.notification_el);
    setTimeout(function() {
        var notif_el = self._get_notification_display_el();
        if (self.use_transitions) {
            if (!self.mini) {
                self._add_class('bg', 'visible');
            }
            self._add_class(notif_el, 'visible');
            self._mark_as_shown();
        } else {
            var notif_attr, notif_start, notif_goal;
            if (self.mini) {
                notif_attr  = 'right';
                notif_start = -100;
                notif_goal  = 20;
            } else {
                notif_attr  = 'top';
                notif_start = MixpanelNotification.NOTIF_START_TOP + MixpanelNotification.NOTIF_TOP;
                notif_goal  = MixpanelNotification.NOTIF_TOP;
            }
            self._animate_els([
                {
                    el:    self._get_el('bg'),
                    attr:  'opacity',
                    start: 0.0,
                    goal:  MixpanelNotification.BG_OPACITY
                },
                {
                    el:    notif_el,
                    attr:  'opacity',
                    start: 0.0,
                    goal:  1.0
                },
                {
                    el:    notif_el,
                    attr:  notif_attr,
                    start: notif_start,
                    goal:  notif_goal
                }
            ], MixpanelNotification.ANIM_TIME, self._mark_as_shown);
        }
    }, 100);
    _.register_event(self._get_el('cancel'), 'click', function(e) {
        e.preventDefault();
        self.dismiss();
    });
    var click_el = self._get_el('button') ||
                        self._get_el('mini-content');
    _.register_event(click_el, 'click', function(e) {
        e.preventDefault();
        if (self.show_video) {
            self._track_event('$campaign_open', {'$resource_type': 'video'});
            self._switch_to_video();
        } else {
            self.dismiss();
            if (self.clickthrough) {
                var tracking_cb = null;
                if (self.mixpanel.get_config('inapp_link_new_window')) {
                    window.open(self.dest_url);
                } else {
                    tracking_cb = function() {
                        window.location.href = self.dest_url;
                    };
                }
                self._track_event('$campaign_open', {'$resource_type': 'link'}, tracking_cb);
            }
        }
    });
});

MixpanelNotification.prototype._get_el = function(id) {
    return document.getElementById(MixpanelNotification.MARKUP_PREFIX + '-' + id);
};

MixpanelNotification.prototype._get_notification_display_el = function() {
    return this._get_el(this.notif_type);
};

MixpanelNotification.prototype._get_shown_campaigns = function() {
    return this.persistence['props'][CAMPAIGN_IDS_KEY] || (this.persistence['props'][CAMPAIGN_IDS_KEY] = {});
};

MixpanelNotification.prototype._matches_event_data = _.safewrap(function(event_data) {
    var event_name = event_data['event'] || '';
    for (var i = 0; i < this.display_triggers.length; i++) {
        var display_trigger = this.display_triggers[i];
        var match_event = display_trigger['event'] || '';
        if (match_event === '$any_event' || event_name === display_trigger['event']) {
            if (display_trigger['selector'] && !_.isEmptyObject(display_trigger['selector'])) {
                if (evaluateSelector(display_trigger['selector'], event_data['properties'])) {
                    return true;
                }
            } else {
                return true;
            }
        }
    }
    return false;
});


MixpanelNotification.prototype._browser_lte = function(browser, version) {
    return this.browser_versions[browser] && this.browser_versions[browser] <= version;
};

MixpanelNotification.prototype._init_image_html = function() {
    var imgs_to_preload = [];

    if (!this.mini) {
        if (this.image_url) {
            imgs_to_preload.push(this.image_url);
            this.img_html = '<img id="img" src="' + this.image_url + '"/>';
        } else {
            this.img_html = '';
        }
        if (this.thumb_image_url) {
            imgs_to_preload.push(this.thumb_image_url);
            this.thumb_img_html =
                    '<div id="thumbborder-wrapper"><div id="thumbborder"></div></div>' +
                    '<img id="thumbnail"' +
                        ' src="' + this.thumb_image_url + '"' +
                        ' width="' + MixpanelNotification.THUMB_IMG_SIZE + '"' +
                        ' height="' + MixpanelNotification.THUMB_IMG_SIZE + '"' +
                    '/>' +
                    '<div id="thumbspacer"></div>';
        } else {
            this.thumb_img_html = '';
        }
    } else {
        this.thumb_image_url = this.thumb_image_url || (this.cdn_host + '/site_media/images/icons/notifications/mini-news-dark.png');
        imgs_to_preload.push(this.thumb_image_url);
    }

    return imgs_to_preload;
};

MixpanelNotification.prototype._init_notification_el = function() {
    var notification_html = '';
    var video_src         = '';
    var video_html        = '';
    var cancel_html       = '<div id="cancel">' +
                                    '<div id="cancel-icon"></div>' +
                                '</div>';

    this.notification_el = document.createElement('div');
    this.notification_el.id = MixpanelNotification.MARKUP_PREFIX + '-wrapper';
    if (!this.mini) {
        // TAKEOVER notification
        var close_html  = (this.clickthrough || this.show_video) ? '' : '<div id="button-close"></div>',
            play_html   = this.show_video ? '<div id="button-play"></div>' : '';
        if (this._browser_lte('ie', 7)) {
            close_html = '';
            play_html = '';
        }
        notification_html =
                '<div id="takeover">' +
                    this.thumb_img_html +
                    '<div id="mainbox">' +
                        cancel_html +
                        '<div id="content">' +
                            this.img_html +
                            '<div id="title">' + this.title + '</div>' +
                            '<div id="body">' + this.body + '</div>' +
                            '<div id="tagline">' +
                                '<a href="http://mixpanel.com?from=inapp" target="_blank">POWERED BY MIXPANEL</a>' +
                            '</div>' +
                        '</div>' +
                        '<div id="button">' +
                            close_html +
                            '<a id="button-link" href="' + this.dest_url + '">' + this.cta + '</a>' +
                            play_html +
                        '</div>' +
                    '</div>' +
                '</div>';
    } else {
        // MINI notification
        notification_html =
                '<div id="mini">' +
                    '<div id="mainbox">' +
                        cancel_html +
                        '<div id="mini-content">' +
                            '<div id="mini-icon">' +
                                '<div id="mini-icon-img"></div>' +
                            '</div>' +
                            '<div id="body">' +
                                '<div id="body-text"><div>' + this.body + '</div></div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div id="mini-border"></div>' +
                '</div>';
    }
    if (this.youtube_video) {
        video_src = this.resource_protocol + 'www.youtube.com/embed/' + this.youtube_video +
                '?wmode=transparent&showinfo=0&modestbranding=0&rel=0&autoplay=1&loop=0&vq=hd1080';
        if (this.yt_custom) {
            video_src += '&enablejsapi=1&html5=1&controls=0';
            video_html =
                    '<div id="video-controls">' +
                        '<div id="video-progress" class="video-progress-el">' +
                            '<div id="video-progress-total" class="video-progress-el"></div>' +
                            '<div id="video-elapsed" class="video-progress-el"></div>' +
                        '</div>' +
                        '<div id="video-time" class="video-progress-el"></div>' +
                    '</div>';
        }
    } else if (this.vimeo_video) {
        video_src = this.resource_protocol + 'player.vimeo.com/video/' + this.vimeo_video + '?autoplay=1&title=0&byline=0&portrait=0';
    }
    if (this.show_video) {
        this.video_iframe =
                '<iframe id="' + MixpanelNotification.MARKUP_PREFIX + '-video-frame" ' +
                    'width="' + this.video_width + '" height="' + this.video_height + '" ' +
                    ' src="' + video_src + '"' +
                    ' frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen="1" scrolling="no"' +
                '></iframe>';
        video_html =
                '<div id="video-' + (this.flip_animate ? '' : 'no') + 'flip">' +
                    '<div id="video">' +
                        '<div id="video-holder"></div>' +
                        video_html +
                    '</div>' +
                '</div>';
    }
    var main_html = video_html + notification_html;
    if (this.flip_animate) {
        main_html =
                (this.mini ? notification_html : '') +
                '<div id="flipcontainer"><div id="flipper">' +
                    (this.mini ? video_html : main_html) +
                '</div></div>';
    }

    this.notification_el.innerHTML =
        ('<div id="overlay" class="' + this.notif_type + '">' +
            '<div id="campaignid-' + this.campaign_id + '">' +
                '<div id="bgwrapper">' +
                    '<div id="bg"></div>' +
                    main_html +
                '</div>' +
            '</div>' +
        '</div>')
            .replace(/class="/g, 'class="' + MixpanelNotification.MARKUP_PREFIX + '-')
            .replace(/id="/g, 'id="' + MixpanelNotification.MARKUP_PREFIX + '-');
};

MixpanelNotification.prototype._init_styles = function() {
    if (this.style === 'dark') {
        this.style_vals = {
            bg:             '#1d1f25',
            bg_actions:     '#282b32',
            bg_hover:       '#3a4147',
            bg_light:       '#4a5157',
            border_gray:    '#32353c',
            cancel_opacity: '0.4',
            mini_hover:     '#2a3137',
            text_title:     '#fff',
            text_main:      '#9498a3',
            text_tagline:   '#464851',
            text_hover:     '#ddd'
        };
    } else {
        this.style_vals = {
            bg:             '#fff',
            bg_actions:     '#e7eaee',
            bg_hover:       '#eceff3',
            bg_light:       '#f5f5f5',
            border_gray:    '#e4ecf2',
            cancel_opacity: '1.0',
            mini_hover:     '#fafafa',
            text_title:     '#5c6578',
            text_main:      '#8b949b',
            text_tagline:   '#ced9e6',
            text_hover:     '#7c8598'
        };
    }
    var shadow = '0px 0px 35px 0px rgba(45, 49, 56, 0.7)',
        video_shadow = shadow,
        mini_shadow = shadow,
        thumb_total_size = MixpanelNotification.THUMB_IMG_SIZE + MixpanelNotification.THUMB_BORDER_SIZE * 2,
        anim_seconds = (MixpanelNotification.ANIM_TIME / 1000) + 's';
    if (this.mini) {
        shadow = 'none';
    }

    // don't display on small viewports
    var notif_media_queries = {},
        min_width = MixpanelNotification.NOTIF_WIDTH_MINI + 20;
    notif_media_queries['@media only screen and (max-width: ' + (min_width - 1) + 'px)'] = {
        '#overlay': {
            'display': 'none'
        }
    };
    var notif_styles = {
        '.flipped': {
            'transform': 'rotateY(180deg)'
        },
        '#overlay': {
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
            'overflow': 'auto',
            'text-align': 'center',
            'z-index': '10000',
            'font-family': '"Helvetica", "Arial", sans-serif',
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale'
        },
        '#overlay.mini': {
            'height': '0',
            'overflow': 'visible'
        },
        '#overlay a': {
            'width': 'initial',
            'padding': '0',
            'text-decoration': 'none',
            'text-transform': 'none',
            'color': 'inherit'
        },
        '#bgwrapper': {
            'position': 'relative',
            'width': '100%',
            'height': '100%'
        },
        '#bg': {
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
            'min-width': this.doc_width * 4 + 'px',
            'min-height': this.doc_height * 4 + 'px',
            'background-color': 'black',
            'opacity': '0.0',
            '-ms-filter': 'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)', // IE8
            'filter': 'alpha(opacity=60)', // IE5-7
            'transition': 'opacity ' + anim_seconds
        },
        '#bg.visible': {
            'opacity': MixpanelNotification.BG_OPACITY
        },
        '.mini #bg': {
            'width': '0',
            'height': '0',
            'min-width': '0'
        },
        '#flipcontainer': {
            'perspective': '1000px',
            'position': 'absolute',
            'width': '100%'
        },
        '#flipper': {
            'position': 'relative',
            'transform-style': 'preserve-3d',
            'transition': '0.3s'
        },
        '#takeover': {
            'position': 'absolute',
            'left': '50%',
            'width': MixpanelNotification.NOTIF_WIDTH + 'px',
            'margin-left': Math.round(-MixpanelNotification.NOTIF_WIDTH / 2) + 'px',
            'backface-visibility': 'hidden',
            'transform': 'rotateY(0deg)',
            'opacity': '0.0',
            'top': MixpanelNotification.NOTIF_START_TOP + 'px',
            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
        },
        '#takeover.visible': {
            'opacity': '1.0',
            'top': MixpanelNotification.NOTIF_TOP + 'px'
        },
        '#takeover.exiting': {
            'opacity': '0.0',
            'top': MixpanelNotification.NOTIF_START_TOP + 'px'
        },
        '#thumbspacer': {
            'height': MixpanelNotification.THUMB_OFFSET + 'px'
        },
        '#thumbborder-wrapper': {
            'position': 'absolute',
            'top': (-MixpanelNotification.THUMB_BORDER_SIZE) + 'px',
            'left': (MixpanelNotification.NOTIF_WIDTH / 2 - MixpanelNotification.THUMB_OFFSET - MixpanelNotification.THUMB_BORDER_SIZE) + 'px',
            'width': thumb_total_size + 'px',
            'height': (thumb_total_size / 2) + 'px',
            'overflow': 'hidden'
        },
        '#thumbborder': {
            'position': 'absolute',
            'width': thumb_total_size + 'px',
            'height': thumb_total_size + 'px',
            'border-radius': thumb_total_size + 'px',
            'background-color': this.style_vals.bg_actions,
            'opacity': '0.5'
        },
        '#thumbnail': {
            'position': 'absolute',
            'top': '0px',
            'left': (MixpanelNotification.NOTIF_WIDTH / 2 - MixpanelNotification.THUMB_OFFSET) + 'px',
            'width': MixpanelNotification.THUMB_IMG_SIZE + 'px',
            'height': MixpanelNotification.THUMB_IMG_SIZE + 'px',
            'overflow': 'hidden',
            'z-index': '100',
            'border-radius': MixpanelNotification.THUMB_IMG_SIZE + 'px'
        },
        '#mini': {
            'position': 'absolute',
            'right': '20px',
            'top': MixpanelNotification.NOTIF_TOP + 'px',
            'width': this.notif_width + 'px',
            'height': MixpanelNotification.NOTIF_HEIGHT_MINI * 2 + 'px',
            'margin-top': 20 - MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
            'backface-visibility': 'hidden',
            'opacity': '0.0',
            'transform': 'rotateX(90deg)',
            'transition': 'opacity 0.3s, transform 0.3s, right 0.3s'
        },
        '#mini.visible': {
            'opacity': '1.0',
            'transform': 'rotateX(0deg)'
        },
        '#mini.exiting': {
            'opacity': '0.0',
            'right': '-150px'
        },
        '#mainbox': {
            'border-radius': '4px',
            'box-shadow': shadow,
            'text-align': 'center',
            'background-color': this.style_vals.bg,
            'font-size': '14px',
            'color': this.style_vals.text_main
        },
        '#mini #mainbox': {
            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
            'margin-top': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
            'border-radius': '3px',
            'transition': 'background-color ' + anim_seconds
        },
        '#mini-border': {
            'height': (MixpanelNotification.NOTIF_HEIGHT_MINI + 6) + 'px',
            'width': (MixpanelNotification.NOTIF_WIDTH_MINI + 6) + 'px',
            'position': 'absolute',
            'top': '-3px',
            'left': '-3px',
            'margin-top': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
            'border-radius': '6px',
            'opacity': '0.25',
            'background-color': '#fff',
            'z-index': '-1',
            'box-shadow': mini_shadow
        },
        '#mini-icon': {
            'position': 'relative',
            'display': 'inline-block',
            'width': '75px',
            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
            'border-radius': '3px 0 0 3px',
            'background-color': this.style_vals.bg_actions,
            'background': 'linear-gradient(135deg, ' + this.style_vals.bg_light + ' 0%, ' + this.style_vals.bg_actions + ' 100%)',
            'transition': 'background-color ' + anim_seconds
        },
        '#mini:hover #mini-icon': {
            'background-color': this.style_vals.mini_hover
        },
        '#mini:hover #mainbox': {
            'background-color': this.style_vals.mini_hover
        },
        '#mini-icon-img': {
            'position': 'absolute',
            'background-image': 'url(' + this.thumb_image_url + ')',
            'width': '48px',
            'height': '48px',
            'top': '20px',
            'left': '12px'
        },
        '#content': {
            'padding': '30px 20px 0px 20px'
        },
        '#mini-content': {
            'text-align': 'left',
            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
            'cursor': 'pointer'
        },
        '#img': {
            'width': '328px',
            'margin-top': '30px',
            'border-radius': '5px'
        },
        '#title': {
            'max-height': '600px',
            'overflow': 'hidden',
            'word-wrap': 'break-word',
            'padding': '25px 0px 20px 0px',
            'font-size': '19px',
            'font-weight': 'bold',
            'color': this.style_vals.text_title
        },
        '#body': {
            'max-height': '600px',
            'margin-bottom': '25px',
            'overflow': 'hidden',
            'word-wrap': 'break-word',
            'line-height': '21px',
            'font-size': '15px',
            'font-weight': 'normal',
            'text-align': 'left'
        },
        '#mini #body': {
            'display': 'inline-block',
            'max-width': '250px',
            'margin': '0 0 0 30px',
            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
            'font-size': '16px',
            'letter-spacing': '0.8px',
            'color': this.style_vals.text_title
        },
        '#mini #body-text': {
            'display': 'table',
            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px'
        },
        '#mini #body-text div': {
            'display': 'table-cell',
            'vertical-align': 'middle'
        },
        '#tagline': {
            'margin-bottom': '15px',
            'font-size': '10px',
            'font-weight': '600',
            'letter-spacing': '0.8px',
            'color': '#ccd7e0',
            'text-align': 'left'
        },
        '#tagline a': {
            'color': this.style_vals.text_tagline,
            'transition': 'color ' + anim_seconds
        },
        '#tagline a:hover': {
            'color': this.style_vals.text_hover
        },
        '#cancel': {
            'position': 'absolute',
            'right': '0',
            'width': '8px',
            'height': '8px',
            'padding': '10px',
            'border-radius': '20px',
            'margin': '12px 12px 0 0',
            'box-sizing': 'content-box',
            'cursor': 'pointer',
            'transition': 'background-color ' + anim_seconds
        },
        '#mini #cancel': {
            'margin': '7px 7px 0 0'
        },
        '#cancel-icon': {
            'width': '8px',
            'height': '8px',
            'overflow': 'hidden',
            'background-image': 'url(' + this.cdn_host + '/site_media/images/icons/notifications/cancel-x.png)',
            'opacity': this.style_vals.cancel_opacity
        },
        '#cancel:hover': {
            'background-color': this.style_vals.bg_hover
        },
        '#button': {
            'display': 'block',
            'height': '60px',
            'line-height': '60px',
            'text-align': 'center',
            'background-color': this.style_vals.bg_actions,
            'border-radius': '0 0 4px 4px',
            'overflow': 'hidden',
            'cursor': 'pointer',
            'transition': 'background-color ' + anim_seconds
        },
        '#button-close': {
            'display': 'inline-block',
            'width': '9px',
            'height': '60px',
            'margin-right': '8px',
            'vertical-align': 'top',
            'background-image': 'url(' + this.cdn_host + '/site_media/images/icons/notifications/close-x-' + this.style + '.png)',
            'background-repeat': 'no-repeat',
            'background-position': '0px 25px'
        },
        '#button-play': {
            'display': 'inline-block',
            'width': '30px',
            'height': '60px',
            'margin-left': '15px',
            'background-image': 'url(' + this.cdn_host + '/site_media/images/icons/notifications/play-' + this.style + '-small.png)',
            'background-repeat': 'no-repeat',
            'background-position': '0px 15px'
        },
        'a#button-link': {
            'display': 'inline-block',
            'vertical-align': 'top',
            'text-align': 'center',
            'font-size': '17px',
            'font-weight': 'bold',
            'overflow': 'hidden',
            'word-wrap': 'break-word',
            'color': this.style_vals.text_title,
            'transition': 'color ' + anim_seconds
        },
        '#button:hover': {
            'background-color': this.style_vals.bg_hover,
            'color': this.style_vals.text_hover
        },
        '#button:hover a': {
            'color': this.style_vals.text_hover
        },

        '#video-noflip': {
            'position': 'relative',
            'top': (-this.video_height * 2) + 'px'
        },
        '#video-flip': {
            'backface-visibility': 'hidden',
            'transform': 'rotateY(180deg)'
        },
        '#video': {
            'position': 'absolute',
            'width': (this.video_width - 1) + 'px',
            'height': this.video_height + 'px',
            'top': MixpanelNotification.NOTIF_TOP + 'px',
            'margin-top': '100px',
            'left': '50%',
            'margin-left': Math.round(-this.video_width / 2) + 'px',
            'overflow': 'hidden',
            'border-radius': '5px',
            'box-shadow': video_shadow,
            'transform': 'translateZ(1px)', // webkit rendering bug http://stackoverflow.com/questions/18167981/clickable-link-area-unexpectedly-smaller-after-css-transform
            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
        },
        '#video.exiting': {
            'opacity': '0.0',
            'top': this.video_height + 'px'
        },
        '#video-holder': {
            'position': 'absolute',
            'width': (this.video_width - 1) + 'px',
            'height': this.video_height + 'px',
            'overflow': 'hidden',
            'border-radius': '5px'
        },
        '#video-frame': {
            'margin-left': '-1px',
            'width': this.video_width + 'px'
        },
        '#video-controls': {
            'opacity': '0',
            'transition': 'opacity 0.5s'
        },
        '#video:hover #video-controls': {
            'opacity': '1.0'
        },
        '#video .video-progress-el': {
            'position': 'absolute',
            'bottom': '0',
            'height': '25px',
            'border-radius': '0 0 0 5px'
        },
        '#video-progress': {
            'width': '90%'
        },
        '#video-progress-total': {
            'width': '100%',
            'background-color': this.style_vals.bg,
            'opacity': '0.7'
        },
        '#video-elapsed': {
            'width': '0',
            'background-color': '#6cb6f5',
            'opacity': '0.9'
        },
        '#video #video-time': {
            'width': '10%',
            'right': '0',
            'font-size': '11px',
            'line-height': '25px',
            'color': this.style_vals.text_main,
            'background-color': '#666',
            'border-radius': '0 0 5px 0'
        }
    };

    // IE hacks
    if (this._browser_lte('ie', 8)) {
        _.extend(notif_styles, {
            '* html #overlay': {
                'position': 'absolute'
            },
            '* html #bg': {
                'position': 'absolute'
            },
            'html, body': {
                'height': '100%'
            }
        });
    }
    if (this._browser_lte('ie', 7)) {
        _.extend(notif_styles, {
            '#mini #body': {
                'display': 'inline',
                'zoom': '1',
                'border': '1px solid ' + this.style_vals.bg_hover
            },
            '#mini #body-text': {
                'padding': '20px'
            },
            '#mini #mini-icon': {
                'display': 'none'
            }
        });
    }

    // add vendor-prefixed style rules
    var VENDOR_STYLES = [
            'backface-visibility', 'border-radius', 'box-shadow', 'opacity',
            'perspective', 'transform', 'transform-style', 'transition'
        ],
        VENDOR_PREFIXES = ['khtml', 'moz', 'ms', 'o', 'webkit'];
    for (var selector in notif_styles) {
        for (var si = 0; si < VENDOR_STYLES.length; si++) {
            var prop = VENDOR_STYLES[si];
            if (prop in notif_styles[selector]) {
                var val = notif_styles[selector][prop];
                for (var pi = 0; pi < VENDOR_PREFIXES.length; pi++) {
                    notif_styles[selector]['-' + VENDOR_PREFIXES[pi] + '-' + prop] = val;
                }
            }
        }
    }

    var inject_styles = function(styles, media_queries) {
        var create_style_text = function(style_defs) {
            var st = '';
            for (var selector in style_defs) {
                var mp_selector = selector
                    .replace(/#/g, '#' + MixpanelNotification.MARKUP_PREFIX + '-')
                    .replace(/\./g, '.' + MixpanelNotification.MARKUP_PREFIX + '-');
                st += '\n' + mp_selector + ' {';
                var props = style_defs[selector];
                for (var k in props) {
                    st += k + ':' + props[k] + ';';
                }
                st += '}';
            }
            return st;
        };
        var create_media_query_text = function(mq_defs) {
            var mqt = '';
            for (var mq in mq_defs) {
                mqt += '\n' + mq + ' {' + create_style_text(mq_defs[mq]) + '\n}';
            }
            return mqt;
        };

        var style_text = create_style_text(styles) + create_media_query_text(media_queries),
            head_el = document.head || document.getElementsByTagName('head')[0] || document.documentElement,
            style_el = document.createElement('style');
        head_el.appendChild(style_el);
        style_el.setAttribute('type', 'text/css');
        if (style_el.styleSheet) { // IE
            style_el.styleSheet.cssText = style_text;
        } else {
            style_el.textContent = style_text;
        }
    };
    inject_styles(notif_styles, notif_media_queries);
};

MixpanelNotification.prototype._init_video = _.safewrap(function() {
    if (!this.video_url) {
        return;
    }
    var self = this;

    // Youtube iframe API compatibility
    self.yt_custom = 'postMessage' in window;

    self.dest_url = self.video_url;
    var youtube_match = self.video_url.match(
            // http://stackoverflow.com/questions/2936467/parse-youtube-video-id-using-preg-match
            /(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i
        ),
        vimeo_match = self.video_url.match(
            /vimeo\.com\/.*?(\d+)/i
        );
    if (youtube_match) {
        self.show_video = true;
        self.youtube_video = youtube_match[1];

        if (self.yt_custom) {
            window['onYouTubeIframeAPIReady'] = function() {
                if (self._get_el('video-frame')) {
                    self._yt_video_ready();
                }
            };

            // load Youtube iframe API; see https://developers.google.com/youtube/iframe_api_reference
            var tag = document.createElement('script');
            tag.src = self.resource_protocol + 'www.youtube.com/iframe_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    } else if (vimeo_match) {
        self.show_video = true;
        self.vimeo_video = vimeo_match[1];
    }

    // IE <= 7, FF <= 3: fall through to video link rather than embedded player
    if (self._browser_lte('ie', 7) || self._browser_lte('firefox', 3)) {
        self.show_video = false;
        self.clickthrough = true;
    }
});

MixpanelNotification.prototype._mark_as_shown = _.safewrap(function() {
    // click on background to dismiss
    var self = this;
    _.register_event(self._get_el('bg'), 'click', function() {
        self.dismiss();
    });

    var get_style = function(el, style_name) {
        var styles = {};
        if (document.defaultView && document.defaultView.getComputedStyle) {
            styles = document.defaultView.getComputedStyle(el, null); // FF3 requires both args
        } else if (el.currentStyle) { // IE
            styles = el.currentStyle;
        }
        return styles[style_name];
    };

    if (this.campaign_id) {
        var notif_el = this._get_el('overlay');
        if (notif_el && get_style(notif_el, 'visibility') !== 'hidden' && get_style(notif_el, 'display') !== 'none') {
            this._mark_delivery();
        }
    }
});

MixpanelNotification.prototype._mark_delivery = _.safewrap(function(extra_props) {
    if (!this.marked_as_shown) {
        this.marked_as_shown = true;

        if (this.campaign_id) {
            // mark notification shown (local cache)
            this._get_shown_campaigns()[this.campaign_id] = 1 * new Date();
            this.persistence.save();
        }

        // track delivery
        this._track_event('$campaign_delivery', extra_props);

        // mark notification shown (mixpanel property)
        this.mixpanel['people']['append']({
            '$campaigns': this.campaign_id,
            '$notifications': {
                'campaign_id': this.campaign_id,
                'message_id':  this.message_id,
                'type':        'web',
                'time':        new Date()
            }
        });
    }
});

MixpanelNotification.prototype._preload_images = function(all_loaded_cb) {
    var self = this;
    if (this.imgs_to_preload.length === 0) {
        all_loaded_cb();
        return;
    }

    var preloaded_imgs = 0;
    var img_objs = [];
    var onload = function() {
        preloaded_imgs++;
        if (preloaded_imgs === self.imgs_to_preload.length && all_loaded_cb) {
            all_loaded_cb();
            all_loaded_cb = null;
        }
    };
    for (var i = 0; i < this.imgs_to_preload.length; i++) {
        var img = new Image();
        img.onload = onload;
        img.src = this.imgs_to_preload[i];
        if (img.complete) {
            onload();
        }
        img_objs.push(img);
    }

    // IE6/7 doesn't fire onload reliably
    if (this._browser_lte('ie', 7)) {
        setTimeout(function() {
            var imgs_loaded = true;
            for (i = 0; i < img_objs.length; i++) {
                if (!img_objs[i].complete) {
                    imgs_loaded = false;
                }
            }
            if (imgs_loaded && all_loaded_cb) {
                all_loaded_cb();
                all_loaded_cb = null;
            }
        }, 500);
    }
};

MixpanelNotification.prototype._remove_notification_el = _.safewrap(function() {
    window.clearInterval(this._video_progress_checker);
    this.notification_el.style.visibility = 'hidden';
    this.body_el.removeChild(this.notification_el);
});

MixpanelNotification.prototype._set_client_config = function() {
    var get_browser_version = function(browser_ex) {
        var match = navigator.userAgent.match(browser_ex);
        return match && match[1];
    };
    this.browser_versions = {};
    this.browser_versions['chrome']  = get_browser_version(/Chrome\/(\d+)/);
    this.browser_versions['firefox'] = get_browser_version(/Firefox\/(\d+)/);
    this.browser_versions['ie']      = get_browser_version(/MSIE (\d+).+/);
    if (!this.browser_versions['ie'] && !(window.ActiveXObject) && 'ActiveXObject' in window) {
        this.browser_versions['ie'] = 11;
    }

    this.body_el = document.body || document.getElementsByTagName('body')[0];
    if (this.body_el) {
        this.doc_width = Math.max(
            this.body_el.scrollWidth, document.documentElement.scrollWidth,
            this.body_el.offsetWidth, document.documentElement.offsetWidth,
            this.body_el.clientWidth, document.documentElement.clientWidth
        );
        this.doc_height = Math.max(
            this.body_el.scrollHeight, document.documentElement.scrollHeight,
            this.body_el.offsetHeight, document.documentElement.offsetHeight,
            this.body_el.clientHeight, document.documentElement.clientHeight
        );
    }

    // detect CSS compatibility
    var ie_ver = this.browser_versions['ie'];
    var sample_styles = document.createElement('div').style,
        is_css_compatible = function(rule) {
            if (rule in sample_styles) {
                return true;
            }
            if (!ie_ver) {
                rule = rule[0].toUpperCase() + rule.slice(1);
                var props = ['O' + rule, 'Webkit' + rule, 'Moz' + rule];
                for (var i = 0; i < props.length; i++) {
                    if (props[i] in sample_styles) {
                        return true;
                    }
                }
            }
            return false;
        };
    this.use_transitions = this.body_el &&
        is_css_compatible('transition') &&
        is_css_compatible('transform');
    this.flip_animate = (this.browser_versions['chrome'] >= 33 || this.browser_versions['firefox'] >= 15) &&
        this.body_el &&
        is_css_compatible('backfaceVisibility') &&
        is_css_compatible('perspective') &&
        is_css_compatible('transform');
};

MixpanelNotification.prototype._switch_to_video = _.safewrap(function() {
    var self = this,
        anims = [
            {
                el:    self._get_notification_display_el(),
                attr:  'opacity',
                start: 1.0,
                goal:  0.0
            },
            {
                el:    self._get_notification_display_el(),
                attr:  'top',
                start: MixpanelNotification.NOTIF_TOP,
                goal:  -500
            },
            {
                el:    self._get_el('video-noflip'),
                attr:  'opacity',
                start: 0.0,
                goal:  1.0
            },
            {
                el:    self._get_el('video-noflip'),
                attr:  'top',
                start: -self.video_height * 2,
                goal:  0
            }
        ];

    if (self.mini) {
        var bg = self._get_el('bg'),
            overlay = self._get_el('overlay');
        bg.style.width = '100%';
        bg.style.height = '100%';
        overlay.style.width = '100%';

        self._add_class(self._get_notification_display_el(), 'exiting');
        self._add_class(bg, 'visible');

        anims.push({
            el:    self._get_el('bg'),
            attr:  'opacity',
            start: 0.0,
            goal:  MixpanelNotification.BG_OPACITY
        });
    }

    var video_el = self._get_el('video-holder');
    video_el.innerHTML = self.video_iframe;

    var video_ready = function() {
        if (window['YT'] && window['YT']['loaded']) {
            self._yt_video_ready();
        }
        self.showing_video = true;
        self._get_notification_display_el().style.visibility = 'hidden';
    };
    if (self.flip_animate) {
        self._add_class('flipper', 'flipped');
        setTimeout(video_ready, MixpanelNotification.ANIM_TIME);
    } else {
        self._animate_els(anims, MixpanelNotification.ANIM_TIME, video_ready);
    }
});

MixpanelNotification.prototype._track_event = function(event_name, properties, cb) {
    if (this.campaign_id) {
        properties = properties || {};
        properties = _.extend(properties, {
            'campaign_id':     this.campaign_id,
            'message_id':      this.message_id,
            'message_type':    'web_inapp',
            'message_subtype': this.notif_type
        });
        this.mixpanel['track'](event_name, properties, cb);
    } else if (cb) {
        cb.call();
    }
};

MixpanelNotification.prototype._yt_video_ready = _.safewrap(function() {
    var self = this;
    if (self.video_inited) {
        return;
    }
    self.video_inited = true;

    var progress_bar  = self._get_el('video-elapsed'),
        progress_time = self._get_el('video-time'),
        progress_el   = self._get_el('video-progress');

    new window['YT']['Player'](MixpanelNotification.MARKUP_PREFIX + '-video-frame', {
        'events': {
            'onReady': function(event) {
                var ytplayer = event['target'],
                    video_duration = ytplayer['getDuration'](),
                    pad = function(i) {
                        return ('00' + i).slice(-2);
                    },
                    update_video_time = function(current_time) {
                        var secs = Math.round(video_duration - current_time),
                            mins = Math.floor(secs / 60),
                            hours = Math.floor(mins / 60);
                        secs -= mins * 60;
                        mins -= hours * 60;
                        progress_time.innerHTML = '-' + (hours ? hours + ':' : '') + pad(mins) + ':' + pad(secs);
                    };
                update_video_time(0);
                self._video_progress_checker = window.setInterval(function() {
                    var current_time = ytplayer['getCurrentTime']();
                    progress_bar.style.width = (current_time / video_duration * 100) + '%';
                    update_video_time(current_time);
                }, 250);
                _.register_event(progress_el, 'click', function(e) {
                    var clickx = Math.max(0, e.pageX - progress_el.getBoundingClientRect().left);
                    ytplayer['seekTo'](video_duration * clickx / progress_el.clientWidth, true);
                });
            }
        }
    });
});

/**
 * Mixpanel People Object
 * @constructor
 */
var MixpanelPeople = function() {};

_.extend(MixpanelPeople.prototype, apiActions);

MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};

/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.set = addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) {
        this._mixpanel['persistence'].update_referrer_info(document.referrer);
    }

    // update $set object with default people properties
    data[SET_ACTION] = _.extend(
        {},
        _.info.people_properties(),
        this._mixpanel['persistence'].get_referrer_info(),
        data[SET_ACTION]
    );
    return this._send_request(data, callback);
});

/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.set_once = addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    return this._send_request(data, callback);
});

/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.unset = addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});

/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.increment = addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if (_.isObject(prop)) {
        _.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else {
                    $add[k] = v;
                }
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if (_.isUndefined(by)) {
            by = 1;
        }
        $add[prop] = by;
    }
    data[ADD_ACTION] = $add;

    return this._send_request(data, callback);
});

/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.append = addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if (_.isObject(list_name)) {
        callback = value;
    }
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});

/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.remove = addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if (_.isObject(list_name)) {
        callback = value;
    }
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});

/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.union = addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if (_.isObject(list_name)) {
        callback = values;
    }
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});

/*
* Record that you have charged the current user a certain amount
* of money. Charges recorded with track_charge() will appear in the
* Mixpanel revenue report.
*
* ### Usage:
*
*     // charge a user $50
*     mixpanel.people.track_charge(50);
*
*     // charge a user $30.50 on the 2nd of january
*     mixpanel.people.track_charge(30.50, {
*         '$time': new Date('jan 1 2012')
*     });
*
* @param {Number} amount The amount of money charged to the current user
* @param {Object} [properties] An associative array of properties associated with the charge
* @param {Function} [callback] If provided, the callback will be called when the server responds
*/
MixpanelPeople.prototype.track_charge = addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            console$1.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }

    return this.append('$transactions', _.extend({
        '$amount': amount
    }, properties), callback);
});

/*
* Permanently clear all revenue report transactions from the
* current user's people analytics profile.
*
* ### Usage:
*
*     mixpanel.people.clear_charges();
*
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};

/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/
MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {'$delete': this._mixpanel.get_distinct_id()};
    return this._send_request(data);
};

MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};

MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) {
        data['$device_id'] = device_id;
    }
    if (user_id) {
        data['$user_id'] = user_id;
    }
    if (had_persisted_distinct_id) {
        data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    }

    var date_encoded_data = _.encodeDates(data);

    if (!this._identify_called()) {
        this._enqueue(data);
        if (!_.isUndefined(callback)) {
            if (this._get_config('verbose')) {
                callback({status: -1, error: null});
            } else {
                callback(-1);
            }
        }
        return _.truncate(date_encoded_data, 255);
    }

    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/engage/',
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};

MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};

MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};

// Queue up engage operations if identify hasn't been called yet.
MixpanelPeople.prototype._enqueue = function(data) {
    if (SET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ACTION, data);
    } else if (SET_ONCE_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ONCE_ACTION, data);
    } else if (UNSET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNSET_ACTION, data);
    } else if (ADD_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(ADD_ACTION, data);
    } else if (APPEND_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, data);
    } else if (REMOVE_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(REMOVE_ACTION, data);
    } else if (UNION_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNION_ACTION, data);
    } else {
        console$1.error('Invalid call to _enqueue():', data);
    }
};

MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = _.extend({}, this._mixpanel['persistence']._get_queue(action));
    var action_params = queued_data;

    if (!_.isUndefined(queued_data) && _.isObject(queued_data) && !_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        if (queue_to_params_fn) {
            action_params = queue_to_params_fn(queued_data);
        }
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            }
            if (!_.isUndefined(callback)) {
                callback(response, data);
            }
        });
    }
};

// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
MixpanelPeople.prototype._flush = function(
    _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback
) {
    var _this = this;
    var $append_queue = this._mixpanel['persistence']._get_queue(APPEND_ACTION);
    var $remove_queue = this._mixpanel['persistence']._get_queue(REMOVE_ACTION);

    this._flush_one_queue(SET_ACTION, this.set, _set_callback);
    this._flush_one_queue(SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue(UNSET_ACTION, this.unset, _unset_callback, function(queue) { return _.keys(queue); });
    this._flush_one_queue(ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue(UNION_ACTION, this.union, _union_callback);

    // we have to fire off each $append individually since there is
    // no concat method server side
    if (!_.isUndefined($append_queue) && _.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, $append_item);
            }
            if (!_.isUndefined(_append_callback)) {
                _append_callback(response, data);
            }
        };
        for (var i = $append_queue.length - 1; i >= 0; i--) {
            $append_item = $append_queue.pop();
            if (!_.isEmptyObject($append_item)) {
                _this.append($append_item, append_callback);
            }
        }
        // Save the shortened append queue
        _this._mixpanel['persistence'].save();
    }

    // same for $remove
    if (!_.isUndefined($remove_queue) && _.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(REMOVE_ACTION, $remove_item);
            }
            if (!_.isUndefined(_remove_callback)) {
                _remove_callback(response, data);
            }
        };
        for (var j = $remove_queue.length - 1; j >= 0; j--) {
            $remove_item = $remove_queue.pop();
            if (!_.isEmptyObject($remove_item)) {
                _this.remove($remove_item, remove_callback);
            }
        }
        _this._mixpanel['persistence'].save();
    }
};

MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};

// MixpanelPeople Exports
MixpanelPeople.prototype['set']           = MixpanelPeople.prototype.set;
MixpanelPeople.prototype['set_once']      = MixpanelPeople.prototype.set_once;
MixpanelPeople.prototype['unset']         = MixpanelPeople.prototype.unset;
MixpanelPeople.prototype['increment']     = MixpanelPeople.prototype.increment;
MixpanelPeople.prototype['append']        = MixpanelPeople.prototype.append;
MixpanelPeople.prototype['remove']        = MixpanelPeople.prototype.remove;
MixpanelPeople.prototype['union']         = MixpanelPeople.prototype.union;
MixpanelPeople.prototype['track_charge']  = MixpanelPeople.prototype.track_charge;
MixpanelPeople.prototype['clear_charges'] = MixpanelPeople.prototype.clear_charges;
MixpanelPeople.prototype['delete_user']   = MixpanelPeople.prototype.delete_user;
MixpanelPeople.prototype['toString']      = MixpanelPeople.prototype.toString;

/*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */

// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==

/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/

var init_type;       // MODULE or SNIPPET loader
var mixpanel_master; // main mixpanel instance / object
var INIT_MODULE  = 0;
var INIT_SNIPPET = 1;

var IDENTITY_FUNC = function(x) {return x;};
var NOOP_FUNC = function() {};

/** @const */ var PRIMARY_INSTANCE_NAME = 'mixpanel';


/*
 * Dynamic... constants? Is that an oxymoron?
 */
// http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var USE_XHR = (window$1.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest());

// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var ENQUEUE_REQUESTS = !USE_XHR && (userAgent.indexOf('MSIE') === -1) && (userAgent.indexOf('Mozilla') === -1);

// save reference to navigator.sendBeacon so it can be minified
var sendBeacon = null;
if (navigator$1['sendBeacon']) {
    sendBeacon = function() {
        // late reference to navigator.sendBeacon to allow patching/spying
        return navigator$1['sendBeacon'].apply(navigator$1, arguments);
    };
}

/*
 * Module-level globals
 */
var DEFAULT_CONFIG = {
    'api_host':                          'https://api-js.mixpanel.com',
    'api_method':                        'POST',
    'api_transport':                     'XHR',
    'app_host':                          'https://mixpanel.com',
    'autotrack':                         true,
    'cdn':                               'https://cdn.mxpnl.com',
    'cross_site_cookie':                 false,
    'cross_subdomain_cookie':            true,
    'persistence':                       'cookie',
    'persistence_name':                  '',
    'cookie_domain':                     '',
    'cookie_name':                       '',
    'loaded':                            NOOP_FUNC,
    'store_google':                      true,
    'save_referrer':                     true,
    'test':                              false,
    'verbose':                           false,
    'img':                               false,
    'debug':                             false,
    'track_links_timeout':               300,
    'cookie_expiration':                 365,
    'upgrade':                           false,
    'disable_persistence':               false,
    'disable_cookie':                    false,
    'secure_cookie':                     false,
    'ip':                                true,
    'opt_out_tracking_by_default':       false,
    'opt_out_persistence_by_default':    false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix':    null,
    'property_blacklist':                [],
    'xhr_headers':                       {}, // { header: value, header2: value }
    'inapp_protocol':                    '//',
    'inapp_link_new_window':             false,
    'ignore_dnt':                        false,
    'batch_requests':                    false, // for now
    'batch_size':                        50,
    'batch_flush_interval_ms':           5000,
    'batch_request_timeout_ms':          90000,
    'batch_autostart':                   true,
    'hooks':                             {}
};

var DOM_LOADED = false;

/**
 * Mixpanel Library Object
 * @constructor
 */
var MixpanelLib = function() {};


/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */
var create_mplib = function(token, config, name) {
    var instance,
        target = (name === PRIMARY_INSTANCE_NAME) ? mixpanel_master : mixpanel_master[name];

    if (target && init_type === INIT_MODULE) {
        instance = target;
    } else {
        if (target && !_.isArray(target)) {
            console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new MixpanelLib();
    }

    instance._cached_groups = {}; // cache groups in a pool
    instance._user_decide_check_complete = false;
    instance._events_tracked_before_user_decide_check_complete = [];

    instance._init(token, config, name);

    instance['people'] = new MixpanelPeople();
    instance['people']._init(instance);

    // if any instance on the page has debug = true, we set the
    // global debug to be true
    Config.DEBUG = Config.DEBUG || instance.get_config('debug');

    instance['__autotrack_enabled'] = instance.get_config('autotrack');
    if (instance.get_config('autotrack')) {
        var num_buckets = 100;
        var num_enabled_buckets = 100;
        if (!autotrack.enabledForProject(instance.get_config('token'), num_buckets, num_enabled_buckets)) {
            instance['__autotrack_enabled'] = false;
            console$1.log('Not in active bucket: disabling Automatic Event Collection.');
        } else if (!autotrack.isBrowserSupported()) {
            instance['__autotrack_enabled'] = false;
            console$1.log('Disabling Automatic Event Collection because this browser is not supported');
        } else {
            autotrack.init(instance);
        }
    }

    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!_.isUndefined(target) && _.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }

    return instance;
};

var encode_data_for_request = function(data) {
    var json_data = _.JSONEncode(data);
    var encoded_data = _.base64Encode(json_data);
    return {'data': encoded_data};
};

// Initialization methods

/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/8b2e1f7b/src/mixpanel-core.js#L87-L110">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */
MixpanelLib.prototype.init = function (token, config, name) {
    if (_.isUndefined(name)) {
        console$1.error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === PRIMARY_INSTANCE_NAME) {
        console$1.error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }

    var instance = create_mplib(token, config, name);
    mixpanel_master[name] = instance;
    instance._loaded();

    return instance;
};

// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};

    this['__loaded'] = true;
    this['config'] = {};
    this['_triggered_notifs'] = [];

    // rollout: enable batch_requests by default for 60% of projects
    // (only if they have not specified a value in their init config
    // and they aren't using a custom API host)
    var variable_features = {};
    var api_host = config['api_host'];
    var is_custom_api = !!api_host && !api_host.match(/\.mixpanel\.com$/);
    if (!('batch_requests' in config) && !is_custom_api && determine_eligibility(token, 'batch', 60)) {
        variable_features['batch_requests'] = true;
    }

    this.set_config(_.extend({}, DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': ((name === PRIMARY_INSTANCE_NAME) ? name : PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));

    this['_jsc'] = NOOP_FUNC;

    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };

    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!_.localStorage.is_supported(true) || !USE_XHR) {
            this._batch_requests = false;
            console$1.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
        } else {
            this.init_batchers();
            if (sendBeacon && window$1.addEventListener) {
                window$1.addEventListener('unload', _.bind(function() {
                    // Before page closes, attempt to flush any events queued up via navigator.sendBeacon.
                    // Since sendBeacon doesn't report success/failure, events will not be removed from
                    // the persistent store; if the site is loaded again, the events will be flushed again
                    // on startup and deduplicated on the Mixpanel server side.
                    if (!this.request_batchers.events.stopped) {
                        this.request_batchers.events.flush({unloading: true});
                    }
                }, this));
            }
        }
    }

    this['persistence'] = this['cookie'] = new MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();

    var uuid = _.UUID();
    if (!this.get_distinct_id()) {
        // There is no need to set the distinct id
        // or the device id if something was already stored
        // in the persitence
        this.register_once({
            'distinct_id': uuid,
            '$device_id': uuid
        }, '');
    }
};

// Private methods

MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
};

// update persistence with info on referrer, UTM params, etc
MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword(document$1.referrer);
    if (this.get_config('store_google')) {
        this['persistence'].update_campaign_params();
    }
    if (this.get_config('save_referrer')) {
        this['persistence'].update_referrer_info(document$1.referrer);
    }
};

MixpanelLib.prototype._dom_loaded = function() {
    _.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);

    if (!this.has_opted_out_tracking()) {
        _.each(this.__request_queue, function(item) {
            this._send_request.apply(this, item);
        }, this);
    }

    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};

MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        console$1.error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }

    if (!DOM_LOADED) {
        this.__dom_loaded_queue.push([DomClass, args]);
        return false;
    }

    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};

/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */
MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if (_.isUndefined(callback)) {
        return null;
    }

    if (USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};

MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;

    if (ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }

    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;

    if (!callback && (_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = _.extend(DEFAULT_OPTIONS, options || {});
    if (!USE_XHR) {
        options.method = 'GET';
    }
    var use_post = options.method === 'POST';
    var use_sendBeacon = sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';

    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) { verbose_mode = true; }

    if (this.get_config('test')) { data['test'] = 1; }
    if (verbose_mode) { data['verbose'] = 1; }
    if (this.get_config('img')) { data['img'] = 1; }
    if (!USE_XHR) {
        if (callback) {
            data['callback'] = callback;
        } else if (verbose_mode || this.get_config('test')) {
            // Verbose output (from verbose mode, or an error in test mode) is a json blob,
            // which by itself is not valid javascript. Without a callback, this verbose output will
            // cause an error when returned via jsonp, so we force a no-op callback param.
            // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
            data['callback'] = '(function(){})';
        }
    }

    data['ip'] = this.get_config('ip')?1:0;
    data['_'] = new Date().getTime().toString();

    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }

    url += '?' + _.HTTPBuildQuery(data);

    if ('img' in data) {
        var img = document$1.createElement('img');
        img.src = url;
        document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = sendBeacon(url, body_data);
        } catch (e) {
            console$1.error(e);
            succeeded = false;
        }
        try {
            if (callback) {
                callback(succeeded ? 1 : 0);
            }
        } catch (e) {
            console$1.error(e);
        }
    } else if (USE_XHR) {
        try {
            var req = new XMLHttpRequest();
            req.open(options.method, url, true);

            var headers = this.get_config('xhr_headers');
            if (use_post) {
                headers['Content-Type'] = 'application/x-www-form-urlencoded';
            }
            _.each(headers, function(headerValue, headerName) {
                req.setRequestHeader(headerName, headerValue);
            });

            if (options.timeout_ms && typeof req.timeout !== 'undefined') {
                req.timeout = options.timeout_ms;
                var start_time = new Date().getTime();
            }

            // send the mp_optout cookie
            // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
            req.withCredentials = true;
            req.onreadystatechange = function () {
                if (req.readyState === 4) { // XMLHttpRequest.DONE == 4, except in safari 4
                    if (req.status === 200) {
                        if (callback) {
                            if (verbose_mode) {
                                var response;
                                try {
                                    response = _.JSONDecode(req.responseText);
                                } catch (e) {
                                    console$1.error(e);
                                    if (options.ignore_json_errors) {
                                        response = req.responseText;
                                    } else {
                                        return;
                                    }
                                }
                                callback(response);
                            } else {
                                callback(Number(req.responseText));
                            }
                        }
                    } else {
                        var error;
                        if (
                            req.timeout &&
                            !req.status &&
                            new Date().getTime() - start_time >= req.timeout
                        ) {
                            error = 'timeout';
                        } else {
                            error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                        }
                        console$1.error(error);
                        if (callback) {
                            if (verbose_mode) {
                                callback({status: 0, error: error, xhr_req: req});
                            } else {
                                callback(0);
                            }
                        }
                    }
                }
            };
            req.send(body_data);
        } catch (e) {
            console$1.error(e);
            succeeded = false;
        }
    } else {
        var script = document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }

    return succeeded;
};

/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */
MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    _.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if (_.isArray(fn_name)) {
                tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            } else if (typeof(item) === 'function') {
                item.call(this);
            } else if (_.isArray(item) && fn_name === 'alias') {
                alias_calls.push(item);
            } else if (_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof(this[fn_name]) === 'function') {
                tracking_calls.push(item);
            } else {
                other_calls.push(item);
            }
        }
    }, this);

    var execute = function(calls, context) {
        _.each(calls, function(item) {
            if (_.isArray(item[0])) {
                // chained call
                var caller = context;
                _.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else {
                this[item[0]].apply(this, item.slice(1));
            }
        }, context);
    };

    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};

// request queueing utils

MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};

MixpanelLib.prototype.init_batchers = function() {
    var token = this.get_config('token');
    if (!this.are_batchers_initialized()) {
        var batcher_for = _.bind(function(attrs) {
            return new RequestBatcher(
                '__mpq_' + token + attrs.queue_suffix,
                {
                    libConfig: this['config'],
                    sendRequestFunc: _.bind(function(data, options, cb) {
                        this._send_request(
                            this.get_config('api_host') + attrs.endpoint,
                            encode_data_for_request(data),
                            options,
                            this._prepare_callback(cb, data)
                        );
                    }, this),
                    beforeSendHook: _.bind(function(item) {
                        return this._run_hook('before_send_' + attrs.type, item);
                    }, this)
                }
            );
        }, this);
        this.request_batchers = {
            events: batcher_for({type: 'events', endpoint: '/track/', queue_suffix: '_ev'}),
            people: batcher_for({type: 'people', endpoint: '/engage/', queue_suffix: '_pp'}),
            groups: batcher_for({type: 'groups', endpoint: '/groups/', queue_suffix: '_gr'})
        };
    }
    if (this.get_config('batch_autostart')) {
        this.start_batch_senders();
    }
};

MixpanelLib.prototype.start_batch_senders = function() {
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        _.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};

MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    _.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};

/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */
MixpanelLib.prototype.push = function(item) {
    this._execute_array([item]);
};

/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */
MixpanelLib.prototype.disable = function(events) {
    if (typeof(events) === 'undefined') {
        this._flags.disable_all_events = true;
    } else {
        this.__disabled_events = this.__disabled_events.concat(events);
    }
};

// internal method for handling track vs batch-enqueue logic
MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = _.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || NOOP_FUNC;

    var request_enqueued_or_initiated = true;
    var send_request_immediately = _.bind(function() {
        if (!send_request_options.skip_hooks) {
            truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        }
        if (truncated_data) {
            console$1.log('MIXPANEL REQUEST:');
            console$1.log(truncated_data);
            return this._send_request(
                endpoint,
                encode_data_for_request(truncated_data),
                send_request_options,
                this._prepare_callback(callback, truncated_data)
            );
        } else {
            return null;
        }
    }, this);

    if (this._batch_requests && !should_send_immediately) {
        batcher.enqueue(truncated_data, function(succeeded) {
            if (succeeded) {
                callback(1, truncated_data);
            } else {
                send_request_immediately();
            }
        });
    } else {
        request_enqueued_or_initiated = send_request_immediately();
    }

    return request_enqueued_or_initiated && truncated_data;
};

/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */
MixpanelLib.prototype.track = addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) {
        options.transport = transport; // 'transport' prop name can be minified internally
    }
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') {
        callback = NOOP_FUNC;
    }

    if (_.isUndefined(event_name)) {
        console$1.error('No event name provided to mixpanel.track');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }

    // set defaults
    properties = properties || {};
    properties['token'] = this.get_config('token');

    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }

    this._set_default_superprops();

    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object

    // update properties with pageview info and super-properties
    properties = _.extend(
        {},
        _.info.properties(),
        this['persistence'].properties(),
        this.unpersisted_superprops,
        properties
    );

    var property_blacklist = this.get_config('property_blacklist');
    if (_.isArray(property_blacklist)) {
        _.each(property_blacklist, function(blacklisted_prop) {
            delete properties[blacklisted_prop];
        });
    } else {
        console$1.error('Invalid value for property_blacklist config: ' + property_blacklist);
    }

    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_config('api_host') + '/track/',
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);

    this._check_and_handle_triggered_notifications(data);

    return ret;
});

/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */
MixpanelLib.prototype.set_group = addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!_.isArray(group_ids)) {
        group_ids = [group_ids];
    }
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});

/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */
MixpanelLib.prototype.add_group = addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    if (old_values === undefined) {
        var prop = {};
        prop[group_key] = [group_id];
        this.register(prop);
    } else {
        if (old_values.indexOf(group_id) === -1) {
            old_values.push(group_id);
            this.register(prop);
        }
    }
    return this['people'].union(group_key, group_id, callback);
});

/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */
MixpanelLib.prototype.remove_group = addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({group_key: old_value});
        }
        if (old_value.length === 0) {
            this.unregister(group_key);
        }
    }
    return this['people'].remove(group_key, group_id, callback);
});

/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */
MixpanelLib.prototype.track_with_groups = addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = _.extend({}, properties || {});
    _.each(groups, function(v, k) {
        if (v !== null && v !== undefined) {
            tracking_props[k] = v;
        }
    });
    return this.track(event_name, tracking_props, callback);
});

MixpanelLib.prototype._create_map_key = function (group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};

MixpanelLib.prototype._remove_group_from_cache = function (group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};

/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */
MixpanelLib.prototype.get_group = function (group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};

/**
 * Track mp_page_view event. This is now ignored by the server.
 *
 * @param {String} [page] The url of the page to record. If you don't include this, it defaults to the current url.
 * @deprecated
 */
MixpanelLib.prototype.track_pageview = function(page) {
    if (_.isUndefined(page)) {
        page = document$1.location.href;
    }
    this.track('mp_page_view', _.info.pageviewInfo(page));
};

/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */
MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, LinkTracker, arguments);
};

/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */
MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, FormTracker, arguments);
};

/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */
MixpanelLib.prototype.time_event = function(event_name) {
    if (_.isUndefined(event_name)) {
        console$1.error('No event name provided to mixpanel.time_event');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        return;
    }

    this['persistence'].set_event_timer(event_name,  new Date().getTime());
};

var REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */
var options_for_register = function(days_or_options) {
    var options;
    if (_.isObject(days_or_options)) {
        options = days_or_options;
    } else if (!_.isUndefined(days_or_options)) {
        options = {'days': days_or_options};
    } else {
        options = {};
    }
    return _.extend({}, REGISTER_DEFAULTS, options);
};

/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */
MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = options_for_register(days_or_options);
    if (options['persistent']) {
        this['persistence'].register(props, options['days']);
    } else {
        _.extend(this.unpersisted_superprops, props);
    }
};

/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */
MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = options_for_register(days_or_options);
    if (options['persistent']) {
        this['persistence'].register_once(props, default_value, options['days']);
    } else {
        if (typeof(default_value) === 'undefined') {
            default_value = 'None';
        }
        _.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) {
                this.unpersisted_superprops[prop] = val;
            }
        }, this);
    }
};

/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */
MixpanelLib.prototype.unregister = function(property, options) {
    options = options_for_register(options);
    if (options['persistent']) {
        this['persistence'].unregister(property);
    } else {
        delete this.unpersisted_superprops[property];
    }
};

MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};

/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */
MixpanelLib.prototype.identify = function(
    new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback
) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed

    var previous_distinct_id = this.get_distinct_id();
    this.register({'$user_id': new_distinct_id});

    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }

    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property(ALIAS_ID_KEY)) {
        this.unregister(ALIAS_ID_KEY);
        this.register({'distinct_id': new_distinct_id});
    }
    this._check_and_handle_notifications(this.get_distinct_id());
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);

    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) {
        this.track('$identify', {
            'distinct_id': new_distinct_id,
            '$anon_distinct_id': previous_distinct_id
        }, {skip_hooks: true});
    }
};

/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */
MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = _.UUID();
    this.register_once({
        'distinct_id': uuid,
        '$device_id': uuid
    }, '');
};

/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */
MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};

/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */
MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property(PEOPLE_DISTINCT_ID_KEY)) {
        console$1.critical('Attempting to create alias for existing People user - aborting.');
        return -2;
    }

    var _this = this;
    if (_.isUndefined(original)) {
        original = this.get_distinct_id();
    }
    if (alias !== original) {
        this._register_single(ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        console$1.error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};

/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */
MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};

/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // turn on request-batching/queueing/retry
 *       batch_requests: false,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // protocol for fetching in-app message resources, e.g.
 *       // 'https://' or 'http://'; defaults to '//' (which defers to the
 *       // current page's protocol)
 *       inapp_protocol: '//'
 *
 *       // whether to open in-app message link in new tab/window
 *       inapp_link_new_window: false
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */
MixpanelLib.prototype.set_config = function(config) {
    if (_.isObject(config)) {
        _.extend(this['config'], config);

        var new_batch_size = config['batch_size'];
        if (new_batch_size) {
            _.each(this.request_batchers, function(batcher) {
                batcher.resetBatchSize();
            });
        }

        if (!this.get_config('persistence_name')) {
            this['config']['persistence_name'] = this['config']['cookie_name'];
        }
        if (!this.get_config('disable_persistence')) {
            this['config']['disable_persistence'] = this['config']['disable_cookie'];
        }

        if (this['persistence']) {
            this['persistence'].update_config(this['config']);
        }
        Config.DEBUG = Config.DEBUG || this.get_config('debug');
    }
};

/**
 * returns the current config object for the library.
 */
MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};

/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */
MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || IDENTITY_FUNC).apply(this, slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        console$1.error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};

/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */
MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence']['props'][property_name];
};

MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== PRIMARY_INSTANCE_NAME) {
        name = PRIMARY_INSTANCE_NAME + '.' + name;
    }
    return name;
};

MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return _.isBlockedUA(userAgent) ||
        this._flags.disable_all_events ||
        _.include(this.__disabled_events, event_name);
};

MixpanelLib.prototype._check_and_handle_triggered_notifications = addOptOutCheckMixpanelLib(function(event_data) {
    if (!this._user_decide_check_complete) {
        this._events_tracked_before_user_decide_check_complete.push(event_data);
    } else {
        var arr = this['_triggered_notifs'];
        for (var i = 0; i < arr.length; i++) {
            var notif = new MixpanelNotification(arr[i], this);
            if (notif._matches_event_data(event_data)) {
                this._show_notification(arr[i]);
                return;
            }
        }
    }
});

MixpanelLib.prototype._check_and_handle_notifications = addOptOutCheckMixpanelLib(function(distinct_id) {
    if (
        !distinct_id ||
        this._flags.identify_called ||
        this.get_config('disable_notifications')
    ) {
        return;
    }

    console$1.log('MIXPANEL NOTIFICATION CHECK');

    var data = {
        'verbose':     true,
        'version':     '3',
        'lib':         'web',
        'token':       this.get_config('token'),
        'distinct_id': distinct_id
    };
    this._send_request(
        this.get_config('api_host') + '/decide/',
        data,
        {method: 'GET', transport: 'XHR'},
        this._prepare_callback(_.bind(function(result) {
            if (result['notifications'] && result['notifications'].length > 0) {
                this['_triggered_notifs'] = [];
                var notifications = [];
                _.each(result['notifications'], function(notif) {
                    (notif['display_triggers'] && notif['display_triggers'].length > 0 ? this['_triggered_notifs'] : notifications).push(notif);
                }, this);
                if (notifications.length > 0) {
                    this._show_notification.call(this, notifications[0]);
                }
            }
            this._handle_user_decide_check_complete();
        }, this))
    );
});

MixpanelLib.prototype._handle_user_decide_check_complete = function() {
    this._user_decide_check_complete = true;

    // check notifications against events that were tracked before decide call completed
    var events = this._events_tracked_before_user_decide_check_complete;
    while (events.length > 0) {
        var data = events.shift(); // replay in the same order they came in
        this._check_and_handle_triggered_notifications(data);
    }
};

MixpanelLib.prototype._show_notification = function(notif_data) {
    var notification = new MixpanelNotification(notif_data, this);
    notification.show();
};

// perform some housekeeping around GDPR opt-in/out state
MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';

    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && _.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({'persistence_type': 'cookie'})) {
            this.opt_in_tracking({'enable_persistence': false});
        }
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({'persistence_type': 'cookie'})) {
            this.opt_out_tracking({'clear_persistence': false});
        }
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }

    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) {
        this._gdpr_update_persistence({'clear_persistence': true});

    // check whether we should opt out by default
    // note: we don't clear persistence here by default since opt-out default state is often
    //       used as an initial state while GDPR information is being collected
    } else if (!this.has_opted_in_tracking() && (
        this.get_config('opt_out_tracking_by_default') || _.cookie.get('mp_optout')
    )) {
        _.cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};

/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */
MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) {
        disabled = true;
    } else if (options && options['enable_persistence']) {
        disabled = false;
    } else {
        return;
    }

    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) {
        this['persistence'].set_disabled(disabled);
    }

    if (disabled) {
        _.each(this.request_batchers, function(batcher) {
            batcher.clear();
        });
    }
};

// call a base gdpr function after constructing the appropriate token and options args
MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = _.extend({
        'track': _.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);

    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!_.localStorage.is_supported()) {
        options['persistence_type'] = 'cookie';
    }

    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};

/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = _.extend({
        'enable_persistence': true
    }, options);

    this._gdpr_call_func(optIn, options);
    this._gdpr_update_persistence(options);
};

/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = _.extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);

    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }

    this._gdpr_call_func(optOut, options);
    this._gdpr_update_persistence(options);
};

/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */
MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func(hasOptedIn, options);
};

/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */
MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func(hasOptedOut, options);
};

/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = _.extend({
        'enable_persistence': true
    }, options);

    this._gdpr_call_func(clearOptInOut, options);
    this._gdpr_update_persistence(options);
};

// EXPORTS (for closure compiler)

// MixpanelLib Exports
MixpanelLib.prototype['init']                               = MixpanelLib.prototype.init;
MixpanelLib.prototype['reset']                              = MixpanelLib.prototype.reset;
MixpanelLib.prototype['disable']                            = MixpanelLib.prototype.disable;
MixpanelLib.prototype['time_event']                         = MixpanelLib.prototype.time_event;
MixpanelLib.prototype['track']                              = MixpanelLib.prototype.track;
MixpanelLib.prototype['track_links']                        = MixpanelLib.prototype.track_links;
MixpanelLib.prototype['track_forms']                        = MixpanelLib.prototype.track_forms;
MixpanelLib.prototype['track_pageview']                     = MixpanelLib.prototype.track_pageview;
MixpanelLib.prototype['register']                           = MixpanelLib.prototype.register;
MixpanelLib.prototype['register_once']                      = MixpanelLib.prototype.register_once;
MixpanelLib.prototype['unregister']                         = MixpanelLib.prototype.unregister;
MixpanelLib.prototype['identify']                           = MixpanelLib.prototype.identify;
MixpanelLib.prototype['alias']                              = MixpanelLib.prototype.alias;
MixpanelLib.prototype['name_tag']                           = MixpanelLib.prototype.name_tag;
MixpanelLib.prototype['set_config']                         = MixpanelLib.prototype.set_config;
MixpanelLib.prototype['get_config']                         = MixpanelLib.prototype.get_config;
MixpanelLib.prototype['get_property']                       = MixpanelLib.prototype.get_property;
MixpanelLib.prototype['get_distinct_id']                    = MixpanelLib.prototype.get_distinct_id;
MixpanelLib.prototype['toString']                           = MixpanelLib.prototype.toString;
MixpanelLib.prototype['_check_and_handle_notifications']    = MixpanelLib.prototype._check_and_handle_notifications;
MixpanelLib.prototype['_handle_user_decide_check_complete'] = MixpanelLib.prototype._handle_user_decide_check_complete;
MixpanelLib.prototype['_show_notification']                 = MixpanelLib.prototype._show_notification;
MixpanelLib.prototype['opt_out_tracking']                   = MixpanelLib.prototype.opt_out_tracking;
MixpanelLib.prototype['opt_in_tracking']                    = MixpanelLib.prototype.opt_in_tracking;
MixpanelLib.prototype['has_opted_out_tracking']             = MixpanelLib.prototype.has_opted_out_tracking;
MixpanelLib.prototype['has_opted_in_tracking']              = MixpanelLib.prototype.has_opted_in_tracking;
MixpanelLib.prototype['clear_opt_in_out_tracking']          = MixpanelLib.prototype.clear_opt_in_out_tracking;
MixpanelLib.prototype['get_group']                          = MixpanelLib.prototype.get_group;
MixpanelLib.prototype['set_group']                          = MixpanelLib.prototype.set_group;
MixpanelLib.prototype['add_group']                          = MixpanelLib.prototype.add_group;
MixpanelLib.prototype['remove_group']                       = MixpanelLib.prototype.remove_group;
MixpanelLib.prototype['track_with_groups']                  = MixpanelLib.prototype.track_with_groups;
MixpanelLib.prototype['start_batch_senders']                = MixpanelLib.prototype.start_batch_senders;
MixpanelLib.prototype['stop_batch_senders']                 = MixpanelLib.prototype.stop_batch_senders;

// MixpanelPersistence Exports
MixpanelPersistence.prototype['properties']            = MixpanelPersistence.prototype.properties;
MixpanelPersistence.prototype['update_search_keyword'] = MixpanelPersistence.prototype.update_search_keyword;
MixpanelPersistence.prototype['update_referrer_info']  = MixpanelPersistence.prototype.update_referrer_info;
MixpanelPersistence.prototype['get_cross_subdomain']   = MixpanelPersistence.prototype.get_cross_subdomain;
MixpanelPersistence.prototype['clear']                 = MixpanelPersistence.prototype.clear;

_.safewrap_class(MixpanelLib, ['identify', '_check_and_handle_notifications', '_show_notification']);


var instances = {};
var extend_mp = function() {
    // add all the sub mixpanel instances
    _.each(instances, function(instance, name) {
        if (name !== PRIMARY_INSTANCE_NAME) { mixpanel_master[name] = instance; }
    });

    // add private functions as _
    mixpanel_master['_'] = _;
};

var override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!mixpanel_master[name]) {
                mixpanel_master[name] = instances[name] = create_mplib(token, config, name);
                mixpanel_master[name]._loaded();
            }
            return mixpanel_master[name];
        } else {
            var instance = mixpanel_master;

            if (instances[PRIMARY_INSTANCE_NAME]) {
                // main mixpanel lib already initialized
                instance = instances[PRIMARY_INSTANCE_NAME];
            } else if (token) {
                // intialize the main mixpanel lib
                instance = create_mplib(token, config, PRIMARY_INSTANCE_NAME);
                instance._loaded();
                instances[PRIMARY_INSTANCE_NAME] = instance;
            }

            mixpanel_master = instance;
            if (init_type === INIT_SNIPPET) {
                window$1[PRIMARY_INSTANCE_NAME] = mixpanel_master;
            }
            extend_mp();
        }
    };
};

var add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) { return; }
        dom_loaded_handler.done = true;

        DOM_LOADED = true;
        ENQUEUE_REQUESTS = false;

        _.each(instances, function(inst) {
            inst._dom_loaded();
        });
    }

    function do_scroll_check() {
        try {
            document$1.documentElement.doScroll('left');
        } catch(e) {
            setTimeout(do_scroll_check, 1);
            return;
        }

        dom_loaded_handler();
    }

    if (document$1.addEventListener) {
        if (document$1.readyState === 'complete') {
            // safari 4 can fire the DOMContentLoaded event before loading all
            // external JS (including this file). you will see some copypasta
            // on the internet that checks for 'complete' and 'loaded', but
            // 'loaded' is an IE thing
            dom_loaded_handler();
        } else {
            document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
        }
    } else if (document$1.attachEvent) {
        // IE
        document$1.attachEvent('onreadystatechange', dom_loaded_handler);

        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = window$1.frameElement === null;
        } catch(e) {
            // noop
        }

        if (document$1.documentElement.doScroll && toplevel) {
            do_scroll_check();
        }
    }

    // fallback handler, always will work
    _.register_event(window$1, 'load', dom_loaded_handler, true);
};

function init_as_module() {
    init_type = INIT_MODULE;
    mixpanel_master = new MixpanelLib();

    override_mp_init_func();
    mixpanel_master['init']();
    add_dom_loaded_handler();

    return mixpanel_master;
}

var mixpanel = init_as_module();

module.exports = mixpanel;
},{}],635:[function(require,module,exports){
module.exports={"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
}
},{}],636:[function(require,module,exports){
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
'use strict'

var asn1 = require('asn1.js')

exports.certificate = require('./certificate')

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})

},{"./certificate":637,"asn1.js":1}],637:[function(require,module,exports){
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen

'use strict'

var asn = require('asn1.js')

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate

},{"asn1.js":1}],638:[function(require,module,exports){
// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m
var evp = require('evp_bytestokey')
var ciphers = require('browserify-aes')
var Buffer = require('safe-buffer').Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

},{"browserify-aes":52,"evp_bytestokey":585,"safe-buffer":676}],639:[function(require,module,exports){
var asn1 = require('./asn1')
var aesid = require('./aesid.json')
var fixProc = require('./fixProc')
var ciphers = require('browserify-aes')
var compat = require('pbkdf2')
var Buffer = require('safe-buffer').Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

},{"./aesid.json":635,"./asn1":636,"./fixProc":638,"browserify-aes":52,"pbkdf2":641,"safe-buffer":676}],640:[function(require,module,exports){
(function (process){
// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this,require('_process'))
},{"_process":649}],641:[function(require,module,exports){
exports.pbkdf2 = require('./lib/async')
exports.pbkdf2Sync = require('./lib/sync')

},{"./lib/async":642,"./lib/sync":645}],642:[function(require,module,exports){
(function (process,global){
var Buffer = require('safe-buffer').Buffer

var checkParameters = require('./precondition')
var defaultEncoding = require('./default-encoding')
var sync = require('./sync')
var toBuffer = require('./to-buffer')

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  sha: 'SHA-1',
  'sha-1': 'SHA-1',
  sha1: 'SHA-1',
  sha256: 'SHA-256',
  'sha-256': 'SHA-256',
  sha384: 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  sha512: 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./default-encoding":643,"./precondition":644,"./sync":645,"./to-buffer":646,"_process":649,"safe-buffer":676}],643:[function(require,module,exports){
(function (process){
var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else if (process.version) {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
} else {
  defaultEncoding = 'utf-8'
}
module.exports = defaultEncoding

}).call(this,require('_process'))
},{"_process":649}],644:[function(require,module,exports){
var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

module.exports = function (iterations, keylen) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

},{}],645:[function(require,module,exports){
var md5 = require('create-hash/md5')
var RIPEMD160 = require('ripemd160')
var sha = require('sha.js')
var Buffer = require('safe-buffer').Buffer

var checkParameters = require('./precondition')
var defaultEncoding = require('./default-encoding')
var toBuffer = require('./to-buffer')

var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2

},{"./default-encoding":643,"./precondition":644,"./to-buffer":646,"create-hash/md5":549,"ripemd160":675,"safe-buffer":676,"sha.js":681}],646:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

module.exports = function (thing, encoding, name) {
  if (Buffer.isBuffer(thing)) {
    return thing
  } else if (typeof thing === 'string') {
    return Buffer.from(thing, encoding)
  } else if (ArrayBuffer.isView(thing)) {
    return Buffer.from(thing.buffer)
  } else {
    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
  }
}

},{"safe-buffer":676}],647:[function(require,module,exports){
"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e="undefined"!=typeof window?window:void 0,t="undefined"!=typeof globalThis?globalThis:e,i=Array.prototype,r=i.forEach,s=i.indexOf,n=null==t?void 0:t.navigator,o=null==t?void 0:t.document,a=null==t?void 0:t.location,l=null==t?void 0:t.fetch,u=null!=t&&t.XMLHttpRequest&&"withCredentials"in new t.XMLHttpRequest?t.XMLHttpRequest:void 0,c=null==t?void 0:t.AbortController,d=null==n?void 0:n.userAgent,h=null!=e?e:{},_={DEBUG:!1,LIB_VERSION:"1.202.0"},p={},v=function(e){return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")};function g(e,t,i){if(A(e))if(r&&e.forEach===r)e.forEach(t,i);else if("length"in e&&e.length===+e.length)for(var s=0,n=e.length;s<n;s++)if(s in e&&t.call(i,e[s],s)===p)return}function f(e,t,i){if(!z(e)){if(A(e))return g(e,t,i);if(V(e)){for(var r of e.entries())if(t.call(i,r[1],r[0])===p)return}else for(var s in e)if(L.call(e,s)&&t.call(i,e[s],s)===p)return}}var m=function(e){for(var t=arguments.length,i=new Array(t>1?t-1:0),r=1;r<t;r++)i[r-1]=arguments[r];return g(i,(function(t){for(var i in t)void 0!==t[i]&&(e[i]=t[i])})),e};function b(e,t){return-1!==e.indexOf(t)}function y(e){for(var t=Object.keys(e),i=t.length,r=new Array(i);i--;)r[i]=[t[i],e[t[i]]];return r}var w=function(e){try{return e()}catch(e){return}},S=function(e){return function(){try{for(var t=arguments.length,i=new Array(t),r=0;r<t;r++)i[r]=arguments[r];return e.apply(this,i)}catch(e){Y.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."),Y.critical(e)}}},E=function(e){var t={};return f(e,(function(e,i){H(e)&&e.length>0&&(t[i]=e)})),t},k=function(e){return e.replace(/^\$/,"")};function x(e,t){return i=e,r=e=>H(e)&&!j(t)?e.slice(0,t):e,s=new Set,function e(t,i){return t!==Object(t)?r?r(t,i):t:s.has(t)?void 0:(s.add(t),A(t)?(n=[],g(t,(t=>{n.push(e(t))}))):(n={},f(t,((t,i)=>{s.has(t)||(n[i]=e(t,i))}))),n);var n}(i);var i,r,s}var C=function(e){var t,i,r,s,n="";for(t=i=0,r=(e=(e+"").replace(/\r\n/g,"\n").replace(/\r/g,"\n")).length,s=0;s<r;s++){var o=e.charCodeAt(s),a=null;o<128?i++:a=o>127&&o<2048?String.fromCharCode(o>>6|192,63&o|128):String.fromCharCode(o>>12|224,o>>6&63|128,63&o|128),j(a)||(i>t&&(n+=e.substring(t,i)),n+=a,t=i=s+1)}return i>t&&(n+=e.substring(t,e.length)),n},I=function(){function t(e){return e&&(e.preventDefault=t.preventDefault,e.stopPropagation=t.stopPropagation),e}return t.preventDefault=function(){this.returnValue=!1},t.stopPropagation=function(){this.cancelBubble=!0},function(i,r,s,n,o){if(i)if(i.addEventListener&&!n)i.addEventListener(r,s,!!o);else{var a="on"+r,l=i[a];i[a]=function(i,r,s){return function(n){if(n=n||t(null==e?void 0:e.event)){var o,a=!0;D(s)&&(o=s(n));var l=r.call(i,n);return!1!==o&&!1!==l||(a=!1),a}}}(i,s,l)}else Y.error("No valid element provided to register_event")}}();function P(e,t){for(var i=0;i<e.length;i++)if(t(e[i]))return e[i]}var T,F="$copy_autocapture",R=["$snapshot","$pageview","$pageleave","$set","survey dismissed","survey sent","survey shown","$identify","$groupidentify","$create_alias","$$client_ingestion_warning","$web_experiment_applied","$feature_enrollment_update","$feature_flag_called"];exports.Compression=void 0,(T=exports.Compression||(exports.Compression={})).GZipJS="gzip-js",T.Base64="base64";var $=Array.isArray,O=Object.prototype,L=O.hasOwnProperty,M=O.toString,A=$||function(e){return"[object Array]"===M.call(e)},D=e=>"function"==typeof e,N=e=>e===Object(e)&&!A(e),q=e=>{if(N(e)){for(var t in e)if(L.call(e,t))return!1;return!0}return!1},B=e=>void 0===e,H=e=>"[object String]"==M.call(e),U=e=>H(e)&&0===e.trim().length,j=e=>null===e,z=e=>B(e)||j(e),W=e=>"[object Number]"==M.call(e),G=e=>"[object Boolean]"===M.call(e),V=e=>e instanceof FormData,Q=e=>b(R,e),J=t=>{var i={_log:function(i){if(e&&(_.DEBUG||h.POSTHOG_DEBUG)&&!B(e.console)&&e.console){for(var r=("__rrweb_original__"in e.console[i]?e.console[i].__rrweb_original__:e.console[i]),s=arguments.length,n=new Array(s>1?s-1:0),o=1;o<s;o++)n[o-1]=arguments[o];r(t,...n)}},info:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];i._log("log",...t)},warn:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];i._log("warn",...t)},error:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];i._log("error",...t)},critical:function(){for(var e=arguments.length,i=new Array(e),r=0;r<e;r++)i[r]=arguments[r];console.error(t,...i)},uninitializedWarning:e=>{i.error("You must initialize PostHog before calling ".concat(e))},createLogger:e=>J("".concat(t," ").concat(e))};return i},Y=J("[PostHog.js]"),K=Y.createLogger,X=K("[ExternalScriptsLoader]"),Z=(e,t,i)=>{if(e.config.disable_external_dependency_loading)return X.warn("".concat(t," was requested but loading of external scripts is disabled.")),i("Loading of external scripts is disabled");var r=()=>{if(!o)return i("document not found");var e=o.createElement("script");e.type="text/javascript",e.crossOrigin="anonymous",e.src=t,e.onload=e=>i(void 0,e),e.onerror=e=>i(e);var r,s=o.querySelectorAll("body > script");s.length>0?null===(r=s[0].parentNode)||void 0===r||r.insertBefore(e,s[0]):o.body.appendChild(e)};null!=o&&o.body?r():null==o||o.addEventListener("DOMContentLoaded",r)};function ee(e,t){var i=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),i.push.apply(i,r)}return i}function te(e){for(var t=1;t<arguments.length;t++){var i=null!=arguments[t]?arguments[t]:{};t%2?ee(Object(i),!0).forEach((function(t){ie(e,t,i[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(i)):ee(Object(i)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(i,t))}))}return e}function ie(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}function re(e,t){if(null==e)return{};var i,r,s=function(e,t){if(null==e)return{};var i,r,s={},n=Object.keys(e);for(r=0;r<n.length;r++)i=n[r],t.indexOf(i)>=0||(s[i]=e[i]);return s}(e,t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);for(r=0;r<n.length;r++)i=n[r],t.indexOf(i)>=0||Object.prototype.propertyIsEnumerable.call(e,i)&&(s[i]=e[i])}return s}h.__PosthogExtensions__=h.__PosthogExtensions__||{},h.__PosthogExtensions__.loadExternalDependency=(e,t,i)=>{var r="/static/".concat(t,".js")+"?v=".concat(e.version);if("remote-config"===t&&(r="/array/".concat(e.config.token,"/config.js")),"toolbar"===t){var s=3e5,n=Math.floor(Date.now()/s)*s;r="".concat(r,"&t=").concat(n)}var o=e.requestRouter.endpointFor("assets",r);Z(e,o,i)},h.__PosthogExtensions__.loadSiteApp=(e,t,i)=>{var r=e.requestRouter.endpointFor("api",t);Z(e,r,i)};var se="$people_distinct_id",ne="__alias",oe="__timers",ae="$autocapture_disabled_server_side",le="$heatmaps_enabled_server_side",ue="$exception_capture_enabled_server_side",ce="$web_vitals_enabled_server_side",de="$dead_clicks_enabled_server_side",he="$web_vitals_allowed_metrics",_e="$session_recording_enabled_server_side",pe="$console_log_recording_enabled_server_side",ve="$session_recording_network_payload_capture",ge="$session_recording_canvas_recording",fe="$replay_sample_rate",me="$replay_minimum_duration",be="$replay_script_config",ye="$sesid",we="$session_is_sampled",Se="$session_recording_url_trigger_activated_session",Ee="$session_recording_event_trigger_activated_session",ke="$enabled_feature_flags",xe="$early_access_features",Ce="$stored_person_properties",Ie="$stored_group_properties",Pe="$surveys",Te="$surveys_activated",Fe="$flag_call_reported",Re="$user_state",$e="$client_session_props",Oe="$capture_rate_limit",Le="$initial_campaign_params",Me="$initial_referrer_info",Ae="$initial_person_info",De="$epp",Ne="__POSTHOG_TOOLBAR__",qe="$posthog_cklsh",Be=[se,ne,"__cmpns",oe,_e,le,ye,ke,Re,xe,Ie,Ce,Pe,Fe,$e,Oe,Le,Me,De],He=K("[FeatureFlags]"),Ue="$active_feature_flags",je="$override_feature_flags",ze="$feature_flag_payloads",We=e=>{var t={};for(var[i,r]of y(e||{}))r&&(t[i]=r);return t};class Ge{constructor(e){ie(this,"_override_warning",!1),ie(this,"_hasLoadedFlags",!1),ie(this,"_requestInFlight",!1),ie(this,"_reloadingDisabled",!1),ie(this,"_additionalReloadRequested",!1),ie(this,"_decideCalled",!1),ie(this,"_flagsLoadedFromRemote",!1),this.instance=e,this.featureFlagEventHandlers=[]}decide(){if(this.instance.config.__preview_remote_config)this._decideCalled=!0;else{var e=!this._reloadDebouncer&&(this.instance.config.advanced_disable_feature_flags||this.instance.config.advanced_disable_feature_flags_on_first_load);this._callDecideEndpoint({disableFlags:e})}}get hasLoadedFlags(){return this._hasLoadedFlags}getFlags(){return Object.keys(this.getFlagVariants())}getFlagVariants(){var e=this.instance.get_property(ke),t=this.instance.get_property(je);if(!t)return e||{};for(var i=m({},e),r=Object.keys(t),s=0;s<r.length;s++)i[r[s]]=t[r[s]];return this._override_warning||(He.warn(" Overriding feature flags!",{enabledFlags:e,overriddenFlags:t,finalFlags:i}),this._override_warning=!0),i}getFlagPayloads(){return this.instance.get_property(ze)||{}}reloadFeatureFlags(){this._reloadingDisabled||this.instance.config.advanced_disable_feature_flags||this._reloadDebouncer||(this._reloadDebouncer=setTimeout((()=>{this._callDecideEndpoint()}),5))}clearDebouncer(){clearTimeout(this._reloadDebouncer),this._reloadDebouncer=void 0}ensureFlagsLoaded(){this._hasLoadedFlags||this._requestInFlight||this._reloadDebouncer||this.reloadFeatureFlags()}setAnonymousDistinctId(e){this.$anon_distinct_id=e}setReloadingPaused(e){this._reloadingDisabled=e}_callDecideEndpoint(e){if(this.clearDebouncer(),!this.instance.config.advanced_disable_decide)if(this._requestInFlight)this._additionalReloadRequested=!0;else{var t={token:this.instance.config.token,distinct_id:this.instance.get_distinct_id(),groups:this.instance.getGroups(),$anon_distinct_id:this.$anon_distinct_id,person_properties:this.instance.get_property(Ce),group_properties:this.instance.get_property(Ie)};(null!=e&&e.disableFlags||this.instance.config.advanced_disable_feature_flags)&&(t.disable_flags=!0),this._requestInFlight=!0,this.instance._send_request({method:"POST",url:this.instance.requestRouter.endpointFor("api","/decide/?v=3"),data:t,compression:this.instance.config.disable_compression?void 0:exports.Compression.Base64,timeout:this.instance.config.feature_flag_request_timeout_ms,callback:e=>{var i,r,s=!0;(200===e.statusCode&&(this.$anon_distinct_id=void 0,s=!1),this._requestInFlight=!1,this._decideCalled)||(this._decideCalled=!0,this.instance._onRemoteConfig(null!==(r=e.json)&&void 0!==r?r:{}));t.disable_flags||(this._flagsLoadedFromRemote=!s,this.receivedFeatureFlags(null!==(i=e.json)&&void 0!==i?i:{},s),this._additionalReloadRequested&&(this._additionalReloadRequested=!1,this._callDecideEndpoint()))}})}}getFeatureFlag(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(this._hasLoadedFlags||this.getFlags()&&this.getFlags().length>0){var i,r,s,n,o,a=this.getFlagVariants()[e],l="".concat(a),u=this.instance.get_property(Fe)||{};if(t.send_event||!("send_event"in t))if(!(e in u)||!u[e].includes(l))A(u[e])?u[e].push(l):u[e]=[l],null===(i=this.instance.persistence)||void 0===i||i.register({[Fe]:u}),this.instance.capture("$feature_flag_called",{$feature_flag:e,$feature_flag_response:a,$feature_flag_payload:this.getFeatureFlagPayload(e)||null,$feature_flag_bootstrapped_response:(null===(r=this.instance.config.bootstrap)||void 0===r||null===(s=r.featureFlags)||void 0===s?void 0:s[e])||null,$feature_flag_bootstrapped_payload:(null===(n=this.instance.config.bootstrap)||void 0===n||null===(o=n.featureFlagPayloads)||void 0===o?void 0:o[e])||null,$used_bootstrap_value:!this._flagsLoadedFromRemote});return a}He.warn('getFeatureFlag for key "'+e+"\" failed. Feature flags didn't load in time.")}getFeatureFlagPayload(e){return this.getFlagPayloads()[e]}isFeatureEnabled(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(this._hasLoadedFlags||this.getFlags()&&this.getFlags().length>0)return!!this.getFeatureFlag(e,t);He.warn('isFeatureEnabled for key "'+e+"\" failed. Feature flags didn't load in time.")}addFeatureFlagsHandler(e){this.featureFlagEventHandlers.push(e)}removeFeatureFlagsHandler(e){this.featureFlagEventHandlers=this.featureFlagEventHandlers.filter((t=>t!==e))}receivedFeatureFlags(e,t){if(this.instance.persistence){this._hasLoadedFlags=!0;var i=this.getFlagVariants(),r=this.getFlagPayloads();!function(e,t){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},s=e.featureFlags,n=e.featureFlagPayloads;if(s)if(A(s)){var o={};if(s)for(var a=0;a<s.length;a++)o[s[a]]=!0;t&&t.register({[Ue]:s,[ke]:o})}else{var l=s,u=n;e.errorsWhileComputingFlags&&(l=te(te({},i),l),u=te(te({},r),u)),t&&t.register({[Ue]:Object.keys(We(l)),[ke]:l||{},[ze]:u||{}})}}(e,this.instance.persistence,i,r),this._fireFeatureFlagsCallbacks(t)}}override(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(!this.instance.__loaded||!this.instance.persistence)return He.uninitializedWarning("posthog.feature_flags.override");if(this._override_warning=t,!1===e)this.instance.persistence.unregister(je);else if(A(e)){for(var i={},r=0;r<e.length;r++)i[e[r]]=!0;this.instance.persistence.register({[je]:i})}else this.instance.persistence.register({[je]:e})}onFeatureFlags(e){if(this.addFeatureFlagsHandler(e),this._hasLoadedFlags){var{flags:t,flagVariants:i}=this._prepareFeatureFlagsForCallbacks();e(t,i)}return()=>this.removeFeatureFlagsHandler(e)}updateEarlyAccessFeatureEnrollment(e,t){var i,r={["$feature_enrollment/".concat(e)]:t};this.instance.capture("$feature_enrollment_update",{$feature_flag:e,$feature_enrollment:t,$set:r}),this.setPersonPropertiesForFlags(r,!1);var s=te(te({},this.getFlagVariants()),{},{[e]:t});null===(i=this.instance.persistence)||void 0===i||i.register({[Ue]:Object.keys(We(s)),[ke]:s}),this._fireFeatureFlagsCallbacks()}getEarlyAccessFeatures(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=this.instance.get_property(xe);if(i&&!t)return e(i);this.instance._send_request({transport:"fetch",url:this.instance.requestRouter.endpointFor("api","/api/early_access_features/?token=".concat(this.instance.config.token)),method:"GET",callback:t=>{var i;if(t.json){var r=t.json.earlyAccessFeatures;return null===(i=this.instance.persistence)||void 0===i||i.register({[xe]:r}),e(r)}}})}_prepareFeatureFlagsForCallbacks(){var e=this.getFlags(),t=this.getFlagVariants();return{flags:e.filter((e=>t[e])),flagVariants:Object.keys(t).filter((e=>t[e])).reduce(((e,i)=>(e[i]=t[i],e)),{})}}_fireFeatureFlagsCallbacks(e){var{flags:t,flagVariants:i}=this._prepareFeatureFlagsForCallbacks();this.featureFlagEventHandlers.forEach((r=>r(t,i,{errorsLoading:e})))}setPersonPropertiesForFlags(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=this.instance.get_property(Ce)||{};this.instance.register({[Ce]:te(te({},i),e)}),t&&this.instance.reloadFeatureFlags()}resetPersonPropertiesForFlags(){this.instance.unregister(Ce)}setGroupPropertiesForFlags(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=this.instance.get_property(Ie)||{};0!==Object.keys(i).length&&Object.keys(i).forEach((t=>{i[t]=te(te({},i[t]),e[t]),delete e[t]})),this.instance.register({[Ie]:te(te({},i),e)}),t&&this.instance.reloadFeatureFlags()}resetGroupPropertiesForFlags(e){if(e){var t=this.instance.get_property(Ie)||{};this.instance.register({[Ie]:te(te({},t),{},{[e]:{}})})}else this.instance.unregister(Ie)}}Math.trunc||(Math.trunc=function(e){return e<0?Math.ceil(e):Math.floor(e)}),Number.isInteger||(Number.isInteger=function(e){return W(e)&&isFinite(e)&&Math.floor(e)===e});var Ve="0123456789abcdef";class Qe{constructor(e){if(this.bytes=e,16!==e.length)throw new TypeError("not 128-bit length")}static fromFieldsV7(e,t,i,r){if(!Number.isInteger(e)||!Number.isInteger(t)||!Number.isInteger(i)||!Number.isInteger(r)||e<0||t<0||i<0||r<0||e>0xffffffffffff||t>4095||i>1073741823||r>4294967295)throw new RangeError("invalid field value");var s=new Uint8Array(16);return s[0]=e/Math.pow(2,40),s[1]=e/Math.pow(2,32),s[2]=e/Math.pow(2,24),s[3]=e/Math.pow(2,16),s[4]=e/Math.pow(2,8),s[5]=e,s[6]=112|t>>>8,s[7]=t,s[8]=128|i>>>24,s[9]=i>>>16,s[10]=i>>>8,s[11]=i,s[12]=r>>>24,s[13]=r>>>16,s[14]=r>>>8,s[15]=r,new Qe(s)}toString(){for(var e="",t=0;t<this.bytes.length;t++)e=e+Ve.charAt(this.bytes[t]>>>4)+Ve.charAt(15&this.bytes[t]),3!==t&&5!==t&&7!==t&&9!==t||(e+="-");if(36!==e.length)throw new Error("Invalid UUIDv7 was generated");return e}clone(){return new Qe(this.bytes.slice(0))}equals(e){return 0===this.compareTo(e)}compareTo(e){for(var t=0;t<16;t++){var i=this.bytes[t]-e.bytes[t];if(0!==i)return Math.sign(i)}return 0}}class Je{constructor(){ie(this,"timestamp",0),ie(this,"counter",0),ie(this,"random",new Xe)}generate(){var e=this.generateOrAbort();if(B(e)){this.timestamp=0;var t=this.generateOrAbort();if(B(t))throw new Error("Could not generate UUID after timestamp reset");return t}return e}generateOrAbort(){var e=Date.now();if(e>this.timestamp)this.timestamp=e,this.resetCounter();else{if(!(e+1e4>this.timestamp))return;this.counter++,this.counter>4398046511103&&(this.timestamp++,this.resetCounter())}return Qe.fromFieldsV7(this.timestamp,Math.trunc(this.counter/Math.pow(2,30)),this.counter&Math.pow(2,30)-1,this.random.nextUint32())}resetCounter(){this.counter=1024*this.random.nextUint32()+(1023&this.random.nextUint32())}}var Ye,Ke=e=>{if("undefined"!=typeof UUIDV7_DENY_WEAK_RNG&&UUIDV7_DENY_WEAK_RNG)throw new Error("no cryptographically strong RNG available");for(var t=0;t<e.length;t++)e[t]=65536*Math.trunc(65536*Math.random())+Math.trunc(65536*Math.random());return e};e&&!B(e.crypto)&&crypto.getRandomValues&&(Ke=e=>crypto.getRandomValues(e));class Xe{constructor(){ie(this,"buffer",new Uint32Array(8)),ie(this,"cursor",1/0)}nextUint32(){return this.cursor>=this.buffer.length&&(Ke(this.buffer),this.cursor=0),this.buffer[this.cursor++]}}var Ze=()=>et().toString(),et=()=>(Ye||(Ye=new Je)).generate(),tt="Thu, 01 Jan 1970 00:00:00 GMT",it="";var rt=/[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;function st(e,t){if(t){var i=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o;if(it)return it;if(!t)return"";if(["localhost","127.0.0.1"].includes(e))return"";for(var i=e.split("."),r=Math.min(i.length,8),s="dmn_chk_"+Ze(),n=new RegExp("(^|;)\\s*"+s+"=1");!it&&r--;){var a=i.slice(r).join("."),l=s+"=1;domain=."+a;t.cookie=l,n.test(t.cookie)&&(t.cookie=l+";expires="+tt,it=a)}return it}(e);if(!i){var r=(e=>{var t=e.match(rt);return t?t[0]:""})(e);r!==i&&Y.info("Warning: cookie subdomain discovery mismatch",r,i),i=r}return i?"; domain=."+i:""}return""}var nt={is_supported:()=>!!o,error:function(e){Y.error("cookieStore error: "+e)},get:function(e){if(o){try{for(var t=e+"=",i=o.cookie.split(";").filter((e=>e.length)),r=0;r<i.length;r++){for(var s=i[r];" "==s.charAt(0);)s=s.substring(1,s.length);if(0===s.indexOf(t))return decodeURIComponent(s.substring(t.length,s.length))}}catch(e){}return null}},parse:function(e){var t;try{t=JSON.parse(nt.get(e))||{}}catch(e){}return t},set:function(e,t,i,r,s){if(o)try{var n="",a="",l=st(o.location.hostname,r);if(i){var u=new Date;u.setTime(u.getTime()+24*i*60*60*1e3),n="; expires="+u.toUTCString()}s&&(a="; secure");var c=e+"="+encodeURIComponent(JSON.stringify(t))+n+"; SameSite=Lax; path=/"+l+a;return c.length>3686.4&&Y.warn("cookieStore warning: large cookie, len="+c.length),o.cookie=c,c}catch(e){return}},remove:function(e,t){try{nt.set(e,"",-1,t)}catch(e){return}}},ot=null,at={is_supported:function(){if(!j(ot))return ot;var t=!0;if(B(e))t=!1;else try{var i="__mplssupport__";at.set(i,"xyz"),'"xyz"'!==at.get(i)&&(t=!1),at.remove(i)}catch(e){t=!1}return t||Y.error("localStorage unsupported; falling back to cookie store"),ot=t,t},error:function(e){Y.error("localStorage error: "+e)},get:function(t){try{return null==e?void 0:e.localStorage.getItem(t)}catch(e){at.error(e)}return null},parse:function(e){try{return JSON.parse(at.get(e))||{}}catch(e){}return null},set:function(t,i){try{null==e||e.localStorage.setItem(t,JSON.stringify(i))}catch(e){at.error(e)}},remove:function(t){try{null==e||e.localStorage.removeItem(t)}catch(e){at.error(e)}}},lt=["distinct_id",ye,we,De,Ae],ut=te(te({},at),{},{parse:function(e){try{var t={};try{t=nt.parse(e)||{}}catch(e){}var i=m(t,JSON.parse(at.get(e)||"{}"));return at.set(e,i),i}catch(e){}return null},set:function(e,t,i,r,s,n){try{at.set(e,t,void 0,void 0,n);var o={};lt.forEach((e=>{t[e]&&(o[e]=t[e])})),Object.keys(o).length&&nt.set(e,o,i,r,s,n)}catch(e){at.error(e)}},remove:function(t,i){try{null==e||e.localStorage.removeItem(t),nt.remove(t,i)}catch(e){at.error(e)}}}),ct={},dt={is_supported:function(){return!0},error:function(e){Y.error("memoryStorage error: "+e)},get:function(e){return ct[e]||null},parse:function(e){return ct[e]||null},set:function(e,t){ct[e]=t},remove:function(e){delete ct[e]}},ht=null,_t={is_supported:function(){if(!j(ht))return ht;if(ht=!0,B(e))ht=!1;else try{var t="__support__";_t.set(t,"xyz"),'"xyz"'!==_t.get(t)&&(ht=!1),_t.remove(t)}catch(e){ht=!1}return ht},error:function(e){Y.error("sessionStorage error: ",e)},get:function(t){try{return null==e?void 0:e.sessionStorage.getItem(t)}catch(e){_t.error(e)}return null},parse:function(e){try{return JSON.parse(_t.get(e))||null}catch(e){}return null},set:function(t,i){try{null==e||e.sessionStorage.setItem(t,JSON.stringify(i))}catch(e){_t.error(e)}},remove:function(t){try{null==e||e.sessionStorage.removeItem(t)}catch(e){_t.error(e)}}},pt=["localhost","127.0.0.1"],vt=e=>{var t=null==o?void 0:o.createElement("a");return B(t)?null:(t.href=e,t)},gt=function(e,t){return!!function(e){try{new RegExp(e)}catch(e){return!1}return!0}(t)&&new RegExp(t).test(e)},ft=function(e){var t,i,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"&",s=[];return f(e,(function(e,r){B(e)||B(r)||"undefined"===r||(t=encodeURIComponent((e=>e instanceof File)(e)?e.name:e.toString()),i=encodeURIComponent(r),s[s.length]=i+"="+t)})),s.join(r)},mt=function(e,t){for(var i,r=((e.split("#")[0]||"").split("?")[1]||"").split("&"),s=0;s<r.length;s++){var n=r[s].split("=");if(n[0]===t){i=n;break}}if(!A(i)||i.length<2)return"";var o=i[1];try{o=decodeURIComponent(o)}catch(e){Y.error("Skipping decoding for malformed query param: "+o)}return o.replace(/\+/g," ")},bt=function(e,t){var i=e.match(new RegExp(t+"=([^&]*)"));return i?i[1]:null},yt="Mobile",wt="iOS",St="Android",Et="Tablet",kt=St+" "+Et,xt="iPad",Ct="Apple",It=Ct+" Watch",Pt="Safari",Tt="BlackBerry",Ft="Samsung",Rt=Ft+"Browser",$t=Ft+" Internet",Ot="Chrome",Lt=Ot+" OS",Mt=Ot+" "+wt,At="Internet Explorer",Dt=At+" "+yt,Nt="Opera",qt=Nt+" Mini",Bt="Edge",Ht="Microsoft "+Bt,Ut="Firefox",jt=Ut+" "+wt,zt="Nintendo",Wt="PlayStation",Gt="Xbox",Vt=St+" "+yt,Qt=yt+" "+Pt,Jt="Windows",Yt=Jt+" Phone",Kt="Nokia",Xt="Ouya",Zt="Generic",ei=Zt+" "+yt.toLowerCase(),ti=Zt+" "+Et.toLowerCase(),ii="Konqueror",ri="(\\d+(\\.\\d+)?)",si=new RegExp("Version/"+ri),ni=new RegExp(Gt,"i"),oi=new RegExp(Wt+" \\w+","i"),ai=new RegExp(zt+" \\w+","i"),li=new RegExp(Tt+"|PlayBook|BB10","i"),ui={"NT3.51":"NT 3.11","NT4.0":"NT 4.0","5.0":"2000",5.1:"XP",5.2:"XP","6.0":"Vista",6.1:"7",6.2:"8",6.3:"8.1",6.4:"10","10.0":"10"};var ci=(e,t)=>t&&b(t,Ct)||function(e){return b(e,Pt)&&!b(e,Ot)&&!b(e,St)}(e),di=function(e,t){return t=t||"",b(e," OPR/")&&b(e,"Mini")?qt:b(e," OPR/")?Nt:li.test(e)?Tt:b(e,"IE"+yt)||b(e,"WPDesktop")?Dt:b(e,Rt)?$t:b(e,Bt)||b(e,"Edg/")?Ht:b(e,"FBIOS")?"Facebook "+yt:b(e,"UCWEB")||b(e,"UCBrowser")?"UC Browser":b(e,"CriOS")?Mt:b(e,"CrMo")||b(e,Ot)?Ot:b(e,St)&&b(e,Pt)?Vt:b(e,"FxiOS")?jt:b(e.toLowerCase(),ii.toLowerCase())?ii:ci(e,t)?b(e,yt)?Qt:Pt:b(e,Ut)?Ut:b(e,"MSIE")||b(e,"Trident/")?At:b(e,"Gecko")?Ut:""},hi={[Dt]:[new RegExp("rv:"+ri)],[Ht]:[new RegExp(Bt+"?\\/"+ri)],[Ot]:[new RegExp("("+Ot+"|CrMo)\\/"+ri)],[Mt]:[new RegExp("CriOS\\/"+ri)],"UC Browser":[new RegExp("(UCBrowser|UCWEB)\\/"+ri)],[Pt]:[si],[Qt]:[si],[Nt]:[new RegExp("(Opera|OPR)\\/"+ri)],[Ut]:[new RegExp(Ut+"\\/"+ri)],[jt]:[new RegExp("FxiOS\\/"+ri)],[ii]:[new RegExp("Konqueror[:/]?"+ri,"i")],[Tt]:[new RegExp(Tt+" "+ri),si],[Vt]:[new RegExp("android\\s"+ri,"i")],[$t]:[new RegExp(Rt+"\\/"+ri)],[At]:[new RegExp("(rv:|MSIE )"+ri)],Mozilla:[new RegExp("rv:"+ri)]},_i=[[new RegExp(Gt+"; "+Gt+" (.*?)[);]","i"),e=>[Gt,e&&e[1]||""]],[new RegExp(zt,"i"),[zt,""]],[new RegExp(Wt,"i"),[Wt,""]],[li,[Tt,""]],[new RegExp(Jt,"i"),(e,t)=>{if(/Phone/.test(t)||/WPDesktop/.test(t))return[Yt,""];if(new RegExp(yt).test(t)&&!/IEMobile\b/.test(t))return[Jt+" "+yt,""];var i=/Windows NT ([0-9.]+)/i.exec(t);if(i&&i[1]){var r=i[1],s=ui[r]||"";return/arm/i.test(t)&&(s="RT"),[Jt,s]}return[Jt,""]}],[/((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,e=>{if(e&&e[3]){var t=[e[3],e[4],e[5]||"0"];return[wt,t.join(".")]}return[wt,""]}],[/(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,e=>{var t="";return e&&e.length>=3&&(t=B(e[2])?e[3]:e[2]),["watchOS",t]}],[new RegExp("("+St+" (\\d+)\\.(\\d+)\\.?(\\d+)?|"+St+")","i"),e=>{if(e&&e[2]){var t=[e[2],e[3],e[4]||"0"];return[St,t.join(".")]}return[St,""]}],[/Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,e=>{var t=["Mac OS X",""];if(e&&e[1]){var i=[e[1],e[2],e[3]||"0"];t[1]=i.join(".")}return t}],[/Mac/i,["Mac OS X",""]],[/CrOS/,[Lt,""]],[/Linux|debian/i,["Linux",""]]],pi=function(e){return ai.test(e)?zt:oi.test(e)?Wt:ni.test(e)?Gt:new RegExp(Xt,"i").test(e)?Xt:new RegExp("("+Yt+"|WPDesktop)","i").test(e)?Yt:/iPad/.test(e)?xt:/iPod/.test(e)?"iPod Touch":/iPhone/.test(e)?"iPhone":/(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e)?It:li.test(e)?Tt:/(kobo)\s(ereader|touch)/i.test(e)?"Kobo":new RegExp(Kt,"i").test(e)?Kt:/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e)||/(kf[a-z]+)( bui|\)).+silk\//i.test(e)?"Kindle Fire":/(Android|ZTE)/i.test(e)?!new RegExp(yt).test(e)||/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e)?/pixel[\daxl ]{1,6}/i.test(e)&&!/pixel c/i.test(e)||/(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e)||/lmy47v/i.test(e)&&!/QTAQZ3/i.test(e)?St:kt:St:new RegExp("(pda|"+yt+")","i").test(e)?ei:new RegExp(Et,"i").test(e)&&!new RegExp(Et+" pc","i").test(e)?ti:""},vi="https?://(.*)",gi=["utm_source","utm_medium","utm_campaign","utm_content","utm_term","gclid","gad_source","gclsrc","dclid","gbraid","wbraid","fbclid","msclkid","twclid","li_fat_id","mc_cid","igshid","ttclid","rdt_cid"],fi={campaignParams:function(e){return o?this._campaignParamsFromUrl(o.URL,e):{}},_campaignParamsFromUrl:function(e,t){var i=gi.concat(t||[]),r={};return f(i,(function(t){var i=mt(e,t);r[t]=i||null})),r},_searchEngine:function(e){return e?0===e.search(vi+"google.([^/?]*)")?"google":0===e.search(vi+"bing.com")?"bing":0===e.search(vi+"yahoo.com")?"yahoo":0===e.search(vi+"duckduckgo.com")?"duckduckgo":null:null},_searchInfoFromReferrer:function(e){var t=fi._searchEngine(e),i="yahoo"!=t?"q":"p",r={};if(!j(t)){r.$search_engine=t;var s=o?mt(o.referrer,i):"";s.length&&(r.ph_keyword=s)}return r},searchInfo:function(){var e=null==o?void 0:o.referrer;return e?this._searchInfoFromReferrer(e):{}},browser:di,browserVersion:function(e,t){var i=di(e,t),r=hi[i];if(B(r))return null;for(var s=0;s<r.length;s++){var n=r[s],o=e.match(n);if(o)return parseFloat(o[o.length-2])}return null},browserLanguage:function(){return navigator.language||navigator.userLanguage},browserLanguagePrefix:function(){var e=this.browserLanguage();return"string"==typeof e?e.split("-")[0]:void 0},os:function(e){for(var t=0;t<_i.length;t++){var[i,r]=_i[t],s=i.exec(e),n=s&&(D(r)?r(s,e):r);if(n)return n}return["",""]},device:pi,deviceType:function(e){var t=pi(e);return t===xt||t===kt||"Kobo"===t||"Kindle Fire"===t||t===ti?Et:t===zt||t===Gt||t===Wt||t===Xt?"Console":t===It?"Wearable":t?yt:"Desktop"},referrer:function(){return(null==o?void 0:o.referrer)||"$direct"},referringDomain:function(){var e;return null!=o&&o.referrer&&(null===(e=vt(o.referrer))||void 0===e?void 0:e.host)||"$direct"},referrerInfo:function(){return{$referrer:this.referrer(),$referring_domain:this.referringDomain()}},initialPersonInfo:function(){return{r:this.referrer().substring(0,1e3),u:null==a?void 0:a.href.substring(0,1e3)}},initialPersonPropsFromInfo:function(e){var t,{r:i,u:r}=e,s={$initial_referrer:i,$initial_referring_domain:null==i?void 0:"$direct"==i?"$direct":null===(t=vt(i))||void 0===t?void 0:t.host};if(r){s.$initial_current_url=r;var n=vt(r);s.$initial_host=null==n?void 0:n.host,s.$initial_pathname=null==n?void 0:n.pathname,f(this._campaignParamsFromUrl(r),(function(e,t){s["$initial_"+k(t)]=e}))}i&&f(this._searchInfoFromReferrer(i),(function(e,t){s["$initial_"+k(t)]=e}));return s},timezone:function(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone}catch(e){return}},timezoneOffset:function(){try{return(new Date).getTimezoneOffset()}catch(e){return}},properties:function(){if(!d)return{};var[t,i]=fi.os(d);return m(E({$os:t,$os_version:i,$browser:fi.browser(d,navigator.vendor),$device:fi.device(d),$device_type:fi.deviceType(d),$timezone:fi.timezone(),$timezone_offset:fi.timezoneOffset()}),{$current_url:null==a?void 0:a.href,$host:null==a?void 0:a.host,$pathname:null==a?void 0:a.pathname,$raw_user_agent:d.length>1e3?d.substring(0,997)+"...":d,$browser_version:fi.browserVersion(d,navigator.vendor),$browser_language:fi.browserLanguage(),$browser_language_prefix:fi.browserLanguagePrefix(),$screen_height:null==e?void 0:e.screen.height,$screen_width:null==e?void 0:e.screen.width,$viewport_height:null==e?void 0:e.innerHeight,$viewport_width:null==e?void 0:e.innerWidth,$lib:"web",$lib_version:_.LIB_VERSION,$insert_id:Math.random().toString(36).substring(2,10)+Math.random().toString(36).substring(2,10),$time:Date.now()/1e3})},people_properties:function(){if(!d)return{};var[e,t]=fi.os(d);return m(E({$os:e,$os_version:t,$browser:fi.browser(d,navigator.vendor)}),{$browser_version:fi.browserVersion(d,navigator.vendor)})}},mi=["cookie","localstorage","localstorage+cookie","sessionstorage","memory"];class bi{constructor(e){this.config=e,this.props={},this.campaign_params_saved=!1,this.name=(e=>{var t="";return e.token&&(t=e.token.replace(/\+/g,"PL").replace(/\//g,"SL").replace(/=/g,"EQ")),e.persistence_name?"ph_"+e.persistence_name:"ph_"+t+"_posthog"})(e),this.storage=this.buildStorage(e),this.load(),e.debug&&Y.info("Persistence loaded",e.persistence,te({},this.props)),this.update_config(e,e),this.save()}buildStorage(e){-1===mi.indexOf(e.persistence.toLowerCase())&&(Y.critical("Unknown persistence type "+e.persistence+"; falling back to localStorage+cookie"),e.persistence="localStorage+cookie");var t=e.persistence.toLowerCase();return"localstorage"===t&&at.is_supported()?at:"localstorage+cookie"===t&&ut.is_supported()?ut:"sessionstorage"===t&&_t.is_supported()?_t:"memory"===t?dt:"cookie"===t?nt:ut.is_supported()?ut:nt}properties(){var e={};return f(this.props,(function(t,i){if(i===ke&&N(t))for(var r=Object.keys(t),n=0;n<r.length;n++)e["$feature/".concat(r[n])]=t[r[n]];else a=i,l=!1,(j(o=Be)?l:s&&o.indexOf===s?-1!=o.indexOf(a):(f(o,(function(e){if(l||(l=e===a))return p})),l))||(e[i]=t);var o,a,l})),e}load(){if(!this.disabled){var e=this.storage.parse(this.name);e&&(this.props=m({},e))}}save(){this.disabled||this.storage.set(this.name,this.props,this.expire_days,this.cross_subdomain,this.secure,this.config.debug)}remove(){this.storage.remove(this.name,!1),this.storage.remove(this.name,!0)}clear(){this.remove(),this.props={}}register_once(e,t,i){if(N(e)){B(t)&&(t="None"),this.expire_days=B(i)?this.default_expiry:i;var r=!1;if(f(e,((e,i)=>{this.props.hasOwnProperty(i)&&this.props[i]!==t||(this.props[i]=e,r=!0)})),r)return this.save(),!0}return!1}register(e,t){if(N(e)){this.expire_days=B(t)?this.default_expiry:t;var i=!1;if(f(e,((t,r)=>{e.hasOwnProperty(r)&&this.props[r]!==t&&(this.props[r]=t,i=!0)})),i)return this.save(),!0}return!1}unregister(e){e in this.props&&(delete this.props[e],this.save())}update_campaign_params(){if(!this.campaign_params_saved){var e=fi.campaignParams(this.config.custom_campaign_params);q(E(e))||this.register(e),this.campaign_params_saved=!0}}update_search_keyword(){this.register(fi.searchInfo())}update_referrer_info(){this.register_once(fi.referrerInfo(),void 0)}set_initial_person_info(){this.props[Le]||this.props[Me]||this.register_once({[Ae]:fi.initialPersonInfo()},void 0)}get_referrer_info(){return E({$referrer:this.props.$referrer,$referring_domain:this.props.$referring_domain})}get_initial_props(){var e={};f([Me,Le],(t=>{var i=this.props[t];i&&f(i,(function(t,i){e["$initial_"+k(i)]=t}))}));var t=this.props[Ae];if(t){var i=fi.initialPersonPropsFromInfo(t);m(e,i)}return e}safe_merge(e){return f(this.props,(function(t,i){i in e||(e[i]=t)})),e}update_config(e,t){if(this.default_expiry=this.expire_days=e.cookie_expiration,this.set_disabled(e.disable_persistence),this.set_cross_subdomain(e.cross_subdomain_cookie),this.set_secure(e.secure_cookie),e.persistence!==t.persistence){var i=this.buildStorage(e),r=this.props;this.clear(),this.storage=i,this.props=r,this.save()}}set_disabled(e){this.disabled=e,this.disabled?this.remove():this.save()}set_cross_subdomain(e){e!==this.cross_subdomain&&(this.cross_subdomain=e,this.remove(),this.save())}get_cross_subdomain(){return!!this.cross_subdomain}set_secure(e){e!==this.secure&&(this.secure=e,this.remove(),this.save())}set_event_timer(e,t){var i=this.props[oe]||{};i[e]=t,this.props[oe]=i,this.save()}remove_event_timer(e){var t=(this.props[oe]||{})[e];return B(t)||(delete this.props[oe][e],this.save()),t}get_property(e){return this.props[e]}set_property(e,t){this.props[e]=t,this.save()}}function yi(e){var t,i;return(null===(t=JSON.stringify(e,(i=[],function(e,t){if(N(t)){for(;i.length>0&&i[i.length-1]!==this;)i.pop();return i.includes(t)?"[Circular]":(i.push(t),t)}return t})))||void 0===t?void 0:t.length)||0}function wi(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:6606028.8;if(e.size>=t&&e.data.length>1){var i=Math.floor(e.data.length/2),r=e.data.slice(0,i),s=e.data.slice(i);return[wi({size:yi(r),data:r,sessionId:e.sessionId,windowId:e.windowId}),wi({size:yi(s),data:s,sessionId:e.sessionId,windowId:e.windowId})].flatMap((e=>e))}return[e]}var Si=(e=>(e[e.DomContentLoaded=0]="DomContentLoaded",e[e.Load=1]="Load",e[e.FullSnapshot=2]="FullSnapshot",e[e.IncrementalSnapshot=3]="IncrementalSnapshot",e[e.Meta=4]="Meta",e[e.Custom=5]="Custom",e[e.Plugin=6]="Plugin",e))(Si||{}),Ei=(e=>(e[e.Mutation=0]="Mutation",e[e.MouseMove=1]="MouseMove",e[e.MouseInteraction=2]="MouseInteraction",e[e.Scroll=3]="Scroll",e[e.ViewportResize=4]="ViewportResize",e[e.Input=5]="Input",e[e.TouchMove=6]="TouchMove",e[e.MediaInteraction=7]="MediaInteraction",e[e.StyleSheetRule=8]="StyleSheetRule",e[e.CanvasMutation=9]="CanvasMutation",e[e.Font=10]="Font",e[e.Log=11]="Log",e[e.Drag=12]="Drag",e[e.StyleDeclaration=13]="StyleDeclaration",e[e.Selection=14]="Selection",e[e.AdoptedStyleSheet=15]="AdoptedStyleSheet",e[e.CustomElement=16]="CustomElement",e))(Ei||{});function ki(e){var t;return e.id===Ne||!(null===(t=e.closest)||void 0===t||!t.call(e,".toolbar-global-fade-container"))}function xi(e){return!!e&&1===e.nodeType}function Ci(e,t){return!!e&&!!e.tagName&&e.tagName.toLowerCase()===t.toLowerCase()}function Ii(e){return!!e&&3===e.nodeType}function Pi(e){return!!e&&11===e.nodeType}function Ti(e){return e?v(e).split(/\s+/):[]}function Fi(t){var i=null==e?void 0:e.location.href;return!!(i&&t&&t.some((e=>i.match(e))))}function Ri(e){var t="";switch(typeof e.className){case"string":t=e.className;break;case"object":t=(e.className&&"baseVal"in e.className?e.className.baseVal:null)||e.getAttribute("class")||"";break;default:t=""}return Ti(t)}function $i(e){return z(e)?null:v(e).split(/(\s+)/).filter((e=>Gi(e))).join("").replace(/[\r\n]/g," ").replace(/[ ]+/g," ").substring(0,255)}function Oi(e){var t="";return Ni(e)&&!qi(e)&&e.childNodes&&e.childNodes.length&&f(e.childNodes,(function(e){var i;Ii(e)&&e.textContent&&(t+=null!==(i=$i(e.textContent))&&void 0!==i?i:"")})),v(t)}function Li(e){return B(e.target)?e.srcElement||null:null!==(t=e.target)&&void 0!==t&&t.shadowRoot?e.composedPath()[0]||null:e.target||null;var t}var Mi=["a","button","form","input","select","textarea","label"];function Ai(e){var t=e.parentNode;return!(!t||!xi(t))&&t}function Di(t,i){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,s=arguments.length>3?arguments[3]:void 0,n=arguments.length>4?arguments[4]:void 0;if(!e||!t||Ci(t,"html")||!xi(t))return!1;if(null!=r&&r.url_allowlist&&!Fi(r.url_allowlist))return!1;if(null!=r&&r.url_ignorelist&&Fi(r.url_ignorelist))return!1;if(null!=r&&r.dom_event_allowlist){var o=r.dom_event_allowlist;if(o&&!o.some((e=>i.type===e)))return!1}for(var a=!1,l=[t],u=!0,c=t;c.parentNode&&!Ci(c,"body");)if(Pi(c.parentNode))l.push(c.parentNode.host),c=c.parentNode.host;else{if(!(u=Ai(c)))break;if(s||Mi.indexOf(u.tagName.toLowerCase())>-1)a=!0;else{var d=e.getComputedStyle(u);d&&"pointer"===d.getPropertyValue("cursor")&&(a=!0)}l.push(u),c=u}if(!function(e,t){var i=null==t?void 0:t.element_allowlist;if(B(i))return!0;var r=function(e){if(i.some((t=>e.tagName.toLowerCase()===t)))return{v:!0}};for(var s of e){var n=r(s);if("object"==typeof n)return n.v}return!1}(l,r))return!1;if(!function(e,t){var i=null==t?void 0:t.css_selector_allowlist;if(B(i))return!0;var r=function(e){if(i.some((t=>e.matches(t))))return{v:!0}};for(var s of e){var n=r(s);if("object"==typeof n)return n.v}return!1}(l,r))return!1;var h=e.getComputedStyle(t);if(h&&"pointer"===h.getPropertyValue("cursor")&&"click"===i.type)return!0;var _=t.tagName.toLowerCase();switch(_){case"html":return!1;case"form":return(n||["submit"]).indexOf(i.type)>=0;case"input":case"select":case"textarea":return(n||["change","click"]).indexOf(i.type)>=0;default:return a?(n||["click"]).indexOf(i.type)>=0:(n||["click"]).indexOf(i.type)>=0&&(Mi.indexOf(_)>-1||"true"===t.getAttribute("contenteditable"))}}function Ni(e){for(var t=e;t.parentNode&&!Ci(t,"body");t=t.parentNode){var i=Ri(t);if(b(i,"ph-sensitive")||b(i,"ph-no-capture"))return!1}if(b(Ri(e),"ph-include"))return!0;var r=e.type||"";if(H(r))switch(r.toLowerCase()){case"hidden":case"password":return!1}var s=e.name||e.id||"";if(H(s)){if(/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g,"")))return!1}return!0}function qi(e){return!!(Ci(e,"input")&&!["button","checkbox","submit","reset"].includes(e.type)||Ci(e,"select")||Ci(e,"textarea")||"true"===e.getAttribute("contenteditable"))}var Bi="(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})",Hi=new RegExp("^(?:".concat(Bi,")$")),Ui=new RegExp(Bi),ji="\\d{3}-?\\d{2}-?\\d{4}",zi=new RegExp("^(".concat(ji,")$")),Wi=new RegExp("(".concat(ji,")"));function Gi(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(z(e))return!1;if(H(e)){if(e=v(e),(t?Hi:Ui).test((e||"").replace(/[- ]/g,"")))return!1;if((t?zi:Wi).test(e))return!1}return!0}function Vi(e){var t=Oi(e);return Gi(t="".concat(t," ").concat(Qi(e)).trim())?t:""}function Qi(e){var t="";return e&&e.childNodes&&e.childNodes.length&&f(e.childNodes,(function(e){var i;if(e&&"span"===(null===(i=e.tagName)||void 0===i?void 0:i.toLowerCase()))try{var r=Oi(e);t="".concat(t," ").concat(r).trim(),e.childNodes&&e.childNodes.length&&(t="".concat(t," ").concat(Qi(e)).trim())}catch(e){Y.error("[AutoCapture]",e)}})),t}function Ji(e){return function(e){var t=e.map((e=>{var t,i,r="";if(e.tag_name&&(r+=e.tag_name),e.attr_class)for(var s of(e.attr_class.sort(),e.attr_class))r+=".".concat(s.replace(/"/g,""));var n=te(te(te(te({},e.text?{text:e.text}:{}),{},{"nth-child":null!==(t=e.nth_child)&&void 0!==t?t:0,"nth-of-type":null!==(i=e.nth_of_type)&&void 0!==i?i:0},e.href?{href:e.href}:{}),e.attr_id?{attr_id:e.attr_id}:{}),e.attributes),o={};return y(n).sort(((e,t)=>{var[i]=e,[r]=t;return i.localeCompare(r)})).forEach((e=>{var[t,i]=e;return o[Yi(t.toString())]=Yi(i.toString())})),r+=":",r+=y(n).map((e=>{var[t,i]=e;return"".concat(t,'="').concat(i,'"')})).join("")}));return t.join(";")}(function(e){return e.map((e=>{var t,i,r={text:null===(t=e.$el_text)||void 0===t?void 0:t.slice(0,400),tag_name:e.tag_name,href:null===(i=e.attr__href)||void 0===i?void 0:i.slice(0,2048),attr_class:Ki(e),attr_id:e.attr__id,nth_child:e.nth_child,nth_of_type:e.nth_of_type,attributes:{}};return y(e).filter((e=>{var[t]=e;return 0===t.indexOf("attr__")})).forEach((e=>{var[t,i]=e;return r.attributes[t]=i})),r}))}(e))}function Yi(e){return e.replace(/"|\\"/g,'\\"')}function Ki(e){var t=e.attr__class;return t?A(t)?t:Ti(t):void 0}var Xi="[SessionRecording]",Zi="redacted",er={initiatorTypes:["audio","beacon","body","css","early-hint","embed","fetch","frame","iframe","icon","image","img","input","link","navigation","object","ping","script","track","video","xmlhttprequest"],maskRequestFn:e=>e,recordHeaders:!1,recordBody:!1,recordInitialRequests:!1,recordPerformance:!1,performanceEntryTypeToObserve:["first-input","navigation","paint","resource"],payloadSizeLimitBytes:1e6,payloadHostDenyList:[".lr-ingest.io",".ingest.sentry.io"]},tr=["authorization","x-forwarded-for","authorization","cookie","set-cookie","x-api-key","x-real-ip","remote-addr","forwarded","proxy-authorization","x-csrf-token","x-csrftoken","x-xsrf-token"],ir=["password","secret","passwd","api_key","apikey","auth","credentials","mysql_pwd","privatekey","private_key","token"],rr=["/s/","/e/","/i/"];function sr(e,t,i,r){if(z(e))return e;var s=(null==t?void 0:t["content-length"])||function(e){return new Blob([e]).size}(e);return H(s)&&(s=parseInt(s)),s>i?Xi+" ".concat(r," body too large to record (").concat(s," bytes)"):e}function nr(e,t){if(z(e))return e;var i=e;return Gi(i,!1)||(i=Xi+" "+t+" body "+Zi),f(ir,(e=>{var r,s;null!==(r=i)&&void 0!==r&&r.length&&-1!==(null===(s=i)||void 0===s?void 0:s.indexOf(e))&&(i=Xi+" "+t+" body "+Zi+" as might contain: "+e)})),i}var or=(e,t)=>{var i,r,s,n={payloadSizeLimitBytes:er.payloadSizeLimitBytes,performanceEntryTypeToObserve:[...er.performanceEntryTypeToObserve],payloadHostDenyList:[...t.payloadHostDenyList||[],...er.payloadHostDenyList]},o=!1!==e.session_recording.recordHeaders&&t.recordHeaders,a=!1!==e.session_recording.recordBody&&t.recordBody,l=!1!==e.capture_performance&&t.recordPerformance,u=(i=n,s=Math.min(1e6,null!==(r=i.payloadSizeLimitBytes)&&void 0!==r?r:1e6),e=>(null!=e&&e.requestBody&&(e.requestBody=sr(e.requestBody,e.requestHeaders,s,"Request")),null!=e&&e.responseBody&&(e.responseBody=sr(e.responseBody,e.responseHeaders,s,"Response")),e)),c=t=>{return u(((e,t)=>{var i,r=vt(e.name),s=0===t.indexOf("http")?null===(i=vt(t))||void 0===i?void 0:i.pathname:t;"/"===s&&(s="");var n=null==r?void 0:r.pathname.replace(s||"","");if(!(r&&n&&rr.some((e=>0===n.indexOf(e)))))return e})((r=(i=t).requestHeaders,z(r)||f(Object.keys(null!=r?r:{}),(e=>{tr.includes(e.toLowerCase())&&(r[e]=Zi)})),i),e.api_host));var i,r},d=D(e.session_recording.maskNetworkRequestFn);return d&&D(e.session_recording.maskCapturedNetworkRequestFn)&&Y.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."),d&&(e.session_recording.maskCapturedNetworkRequestFn=t=>{var i=e.session_recording.maskNetworkRequestFn({url:t.name});return te(te({},t),{},{name:null==i?void 0:i.url})}),n.maskRequestFn=D(e.session_recording.maskCapturedNetworkRequestFn)?t=>{var i,r,s,n=c(t);return n&&null!==(i=null===(r=(s=e.session_recording).maskCapturedNetworkRequestFn)||void 0===r?void 0:r.call(s,n))&&void 0!==i?i:void 0}:e=>function(e){if(!B(e))return e.requestBody=nr(e.requestBody,"Request"),e.responseBody=nr(e.responseBody,"Response"),e}(c(e)),te(te(te({},er),n),{},{recordHeaders:o,recordBody:a,recordPerformance:l,recordInitialRequests:l})};function ar(e,t,i,r,s){return t>i&&(Y.warn("min cannot be greater than max."),t=i),W(e)?e>i?(r&&Y.warn(r+" cannot be  greater than max: "+i+". Using max value instead."),i):e<t?(r&&Y.warn(r+" cannot be less than min: "+t+". Using min value instead."),t):e:(r&&Y.warn(r+" must be a number. using max or fallback. max: "+i+", fallback: "+s),ar(s||i,t,i,r))}class lr{constructor(e){var t,i,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};ie(this,"bucketSize",100),ie(this,"refillRate",10),ie(this,"mutationBuckets",{}),ie(this,"loggedTracker",{}),ie(this,"refillBuckets",(()=>{Object.keys(this.mutationBuckets).forEach((e=>{this.mutationBuckets[e]=this.mutationBuckets[e]+this.refillRate,this.mutationBuckets[e]>=this.bucketSize&&delete this.mutationBuckets[e]}))})),ie(this,"getNodeOrRelevantParent",(e=>{var t=this.rrweb.mirror.getNode(e);if("svg"!==(null==t?void 0:t.nodeName)&&t instanceof Element){var i=t.closest("svg");if(i)return[this.rrweb.mirror.getId(i),i]}return[e,t]})),ie(this,"numberOfChanges",(e=>{var t,i,r,s,n,o,a,l;return(null!==(t=null===(i=e.removes)||void 0===i?void 0:i.length)&&void 0!==t?t:0)+(null!==(r=null===(s=e.attributes)||void 0===s?void 0:s.length)&&void 0!==r?r:0)+(null!==(n=null===(o=e.texts)||void 0===o?void 0:o.length)&&void 0!==n?n:0)+(null!==(a=null===(l=e.adds)||void 0===l?void 0:l.length)&&void 0!==a?a:0)})),ie(this,"throttleMutations",(e=>{if(3!==e.type||0!==e.data.source)return e;var t=e.data,i=this.numberOfChanges(t);t.attributes&&(t.attributes=t.attributes.filter((e=>{var t,i,r,[s,n]=this.getNodeOrRelevantParent(e.id);if(0===this.mutationBuckets[s])return!1;(this.mutationBuckets[s]=null!==(t=this.mutationBuckets[s])&&void 0!==t?t:this.bucketSize,this.mutationBuckets[s]=Math.max(this.mutationBuckets[s]-1,0),0===this.mutationBuckets[s])&&(this.loggedTracker[s]||(this.loggedTracker[s]=!0,null===(i=(r=this.options).onBlockedNode)||void 0===i||i.call(r,s,n)));return e})));var r=this.numberOfChanges(t);return 0!==r||i===r?e:void 0})),this.rrweb=e,this.options=r,this.refillRate=ar(null!==(t=this.options.refillRate)&&void 0!==t?t:this.refillRate,0,100,"mutation throttling refill rate"),this.bucketSize=ar(null!==(i=this.options.bucketSize)&&void 0!==i?i:this.bucketSize,0,100,"mutation throttling bucket size"),setInterval((()=>{this.refillBuckets()}),1e3)}}var ur=Uint8Array,cr=Uint16Array,dr=Uint32Array,hr=new ur([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),_r=new ur([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),pr=new ur([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),vr=function(e,t){for(var i=new cr(31),r=0;r<31;++r)i[r]=t+=1<<e[r-1];var s=new dr(i[30]);for(r=1;r<30;++r)for(var n=i[r];n<i[r+1];++n)s[n]=n-i[r]<<5|r;return[i,s]},gr=vr(hr,2),fr=gr[0],mr=gr[1];fr[28]=258,mr[258]=28;for(var br=vr(_r,0)[1],yr=new cr(32768),wr=0;wr<32768;++wr){var Sr=(43690&wr)>>>1|(21845&wr)<<1;Sr=(61680&(Sr=(52428&Sr)>>>2|(13107&Sr)<<2))>>>4|(3855&Sr)<<4,yr[wr]=((65280&Sr)>>>8|(255&Sr)<<8)>>>1}var Er=function(e,t,i){for(var r=e.length,s=0,n=new cr(t);s<r;++s)++n[e[s]-1];var o,a=new cr(t);for(s=0;s<t;++s)a[s]=a[s-1]+n[s-1]<<1;if(i){o=new cr(1<<t);var l=15-t;for(s=0;s<r;++s)if(e[s])for(var u=s<<4|e[s],c=t-e[s],d=a[e[s]-1]++<<c,h=d|(1<<c)-1;d<=h;++d)o[yr[d]>>>l]=u}else for(o=new cr(r),s=0;s<r;++s)o[s]=yr[a[e[s]-1]++]>>>15-e[s];return o},kr=new ur(288);for(wr=0;wr<144;++wr)kr[wr]=8;for(wr=144;wr<256;++wr)kr[wr]=9;for(wr=256;wr<280;++wr)kr[wr]=7;for(wr=280;wr<288;++wr)kr[wr]=8;var xr=new ur(32);for(wr=0;wr<32;++wr)xr[wr]=5;var Cr=Er(kr,9,0),Ir=Er(xr,5,0),Pr=function(e){return(e/8>>0)+(7&e&&1)},Tr=function(e,t,i){(null==i||i>e.length)&&(i=e.length);var r=new(e instanceof cr?cr:e instanceof dr?dr:ur)(i-t);return r.set(e.subarray(t,i)),r},Fr=function(e,t,i){i<<=7&t;var r=t/8>>0;e[r]|=i,e[r+1]|=i>>>8},Rr=function(e,t,i){i<<=7&t;var r=t/8>>0;e[r]|=i,e[r+1]|=i>>>8,e[r+2]|=i>>>16},$r=function(e,t){for(var i=[],r=0;r<e.length;++r)e[r]&&i.push({s:r,f:e[r]});var s=i.length,n=i.slice();if(!s)return[new ur(0),0];if(1==s){var o=new ur(i[0].s+1);return o[i[0].s]=1,[o,1]}i.sort((function(e,t){return e.f-t.f})),i.push({s:-1,f:25001});var a=i[0],l=i[1],u=0,c=1,d=2;for(i[0]={s:-1,f:a.f+l.f,l:a,r:l};c!=s-1;)a=i[i[u].f<i[d].f?u++:d++],l=i[u!=c&&i[u].f<i[d].f?u++:d++],i[c++]={s:-1,f:a.f+l.f,l:a,r:l};var h=n[0].s;for(r=1;r<s;++r)n[r].s>h&&(h=n[r].s);var _=new cr(h+1),p=Or(i[c-1],_,0);if(p>t){r=0;var v=0,g=p-t,f=1<<g;for(n.sort((function(e,t){return _[t.s]-_[e.s]||e.f-t.f}));r<s;++r){var m=n[r].s;if(!(_[m]>t))break;v+=f-(1<<p-_[m]),_[m]=t}for(v>>>=g;v>0;){var b=n[r].s;_[b]<t?v-=1<<t-_[b]++-1:++r}for(;r>=0&&v;--r){var y=n[r].s;_[y]==t&&(--_[y],++v)}p=t}return[new ur(_),p]},Or=function(e,t,i){return-1==e.s?Math.max(Or(e.l,t,i+1),Or(e.r,t,i+1)):t[e.s]=i},Lr=function(e){for(var t=e.length;t&&!e[--t];);for(var i=new cr(++t),r=0,s=e[0],n=1,o=function(e){i[r++]=e},a=1;a<=t;++a)if(e[a]==s&&a!=t)++n;else{if(!s&&n>2){for(;n>138;n-=138)o(32754);n>2&&(o(n>10?n-11<<5|28690:n-3<<5|12305),n=0)}else if(n>3){for(o(s),--n;n>6;n-=6)o(8304);n>2&&(o(n-3<<5|8208),n=0)}for(;n--;)o(s);n=1,s=e[a]}return[i.subarray(0,r),t]},Mr=function(e,t){for(var i=0,r=0;r<t.length;++r)i+=e[r]*t[r];return i},Ar=function(e,t,i){var r=i.length,s=Pr(t+2);e[s]=255&r,e[s+1]=r>>>8,e[s+2]=255^e[s],e[s+3]=255^e[s+1];for(var n=0;n<r;++n)e[s+n+4]=i[n];return 8*(s+4+r)},Dr=function(e,t,i,r,s,n,o,a,l,u,c){Fr(t,c++,i),++s[256];for(var d=$r(s,15),h=d[0],_=d[1],p=$r(n,15),v=p[0],g=p[1],f=Lr(h),m=f[0],b=f[1],y=Lr(v),w=y[0],S=y[1],E=new cr(19),k=0;k<m.length;++k)E[31&m[k]]++;for(k=0;k<w.length;++k)E[31&w[k]]++;for(var x=$r(E,7),C=x[0],I=x[1],P=19;P>4&&!C[pr[P-1]];--P);var T,F,R,$,O=u+5<<3,L=Mr(s,kr)+Mr(n,xr)+o,M=Mr(s,h)+Mr(n,v)+o+14+3*P+Mr(E,C)+(2*E[16]+3*E[17]+7*E[18]);if(O<=L&&O<=M)return Ar(t,c,e.subarray(l,l+u));if(Fr(t,c,1+(M<L)),c+=2,M<L){T=Er(h,_,0),F=h,R=Er(v,g,0),$=v;var A=Er(C,I,0);Fr(t,c,b-257),Fr(t,c+5,S-1),Fr(t,c+10,P-4),c+=14;for(k=0;k<P;++k)Fr(t,c+3*k,C[pr[k]]);c+=3*P;for(var D=[m,w],N=0;N<2;++N){var q=D[N];for(k=0;k<q.length;++k){var B=31&q[k];Fr(t,c,A[B]),c+=C[B],B>15&&(Fr(t,c,q[k]>>>5&127),c+=q[k]>>>12)}}}else T=Cr,F=kr,R=Ir,$=xr;for(k=0;k<a;++k)if(r[k]>255){B=r[k]>>>18&31;Rr(t,c,T[B+257]),c+=F[B+257],B>7&&(Fr(t,c,r[k]>>>23&31),c+=hr[B]);var H=31&r[k];Rr(t,c,R[H]),c+=$[H],H>3&&(Rr(t,c,r[k]>>>5&8191),c+=_r[H])}else Rr(t,c,T[r[k]]),c+=F[r[k]];return Rr(t,c,T[256]),c+F[256]},Nr=new dr([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),qr=function(){for(var e=new dr(256),t=0;t<256;++t){for(var i=t,r=9;--r;)i=(1&i&&3988292384)^i>>>1;e[t]=i}return e}(),Br=function(){var e=4294967295;return{p:function(t){for(var i=e,r=0;r<t.length;++r)i=qr[255&i^t[r]]^i>>>8;e=i},d:function(){return 4294967295^e}}},Hr=function(e,t,i,r,s){return function(e,t,i,r,s,n){var o=e.length,a=new ur(r+o+5*(1+Math.floor(o/7e3))+s),l=a.subarray(r,a.length-s),u=0;if(!t||o<8)for(var c=0;c<=o;c+=65535){var d=c+65535;d<o?u=Ar(l,u,e.subarray(c,d)):(l[c]=n,u=Ar(l,u,e.subarray(c,o)))}else{for(var h=Nr[t-1],_=h>>>13,p=8191&h,v=(1<<i)-1,g=new cr(32768),f=new cr(v+1),m=Math.ceil(i/3),b=2*m,y=function(t){return(e[t]^e[t+1]<<m^e[t+2]<<b)&v},w=new dr(25e3),S=new cr(288),E=new cr(32),k=0,x=0,C=(c=0,0),I=0,P=0;c<o;++c){var T=y(c),F=32767&c,R=f[T];if(g[F]=R,f[T]=F,I<=c){var $=o-c;if((k>7e3||C>24576)&&$>423){u=Dr(e,l,0,w,S,E,x,C,P,c-P,u),C=k=x=0,P=c;for(var O=0;O<286;++O)S[O]=0;for(O=0;O<30;++O)E[O]=0}var L=2,M=0,A=p,D=F-R&32767;if($>2&&T==y(c-D))for(var N=Math.min(_,$)-1,q=Math.min(32767,c),B=Math.min(258,$);D<=q&&--A&&F!=R;){if(e[c+L]==e[c+L-D]){for(var H=0;H<B&&e[c+H]==e[c+H-D];++H);if(H>L){if(L=H,M=D,H>N)break;var U=Math.min(D,H-2),j=0;for(O=0;O<U;++O){var z=c-D+O+32768&32767,W=z-g[z]+32768&32767;W>j&&(j=W,R=z)}}}D+=(F=R)-(R=g[F])+32768&32767}if(M){w[C++]=268435456|mr[L]<<18|br[M];var G=31&mr[L],V=31&br[M];x+=hr[G]+_r[V],++S[257+G],++E[V],I=c+L,++k}else w[C++]=e[c],++S[e[c]]}}u=Dr(e,l,n,w,S,E,x,C,P,c-P,u)}return Tr(a,0,r+Pr(u)+s)}(e,null==t.level?6:t.level,null==t.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(e.length)))):12+t.mem,i,r,!s)},Ur=function(e,t,i){for(;i;++t)e[t]=i,i>>>=8},jr=function(e,t){var i=t.filename;if(e[0]=31,e[1]=139,e[2]=8,e[8]=t.level<2?4:9==t.level?2:0,e[9]=3,0!=t.mtime&&Ur(e,4,Math.floor(new Date(t.mtime||Date.now())/1e3)),i){e[3]=8;for(var r=0;r<=i.length;++r)e[r+10]=i.charCodeAt(r)}},zr=function(e){return 10+(e.filename&&e.filename.length+1||0)};function Wr(e,t){void 0===t&&(t={});var i=Br(),r=e.length;i.p(e);var s=Hr(e,t,zr(t),8),n=s.length;return jr(s,t),Ur(s,n-8,i.d()),Ur(s,n-4,r),s}function Gr(e,t){var i=e.length;if("undefined"!=typeof TextEncoder)return(new TextEncoder).encode(e);for(var r=new ur(e.length+(e.length>>>1)),s=0,n=function(e){r[s++]=e},o=0;o<i;++o){if(s+5>r.length){var a=new ur(s+8+(i-o<<1));a.set(r),r=a}var l=e.charCodeAt(o);l<128||t?n(l):l<2048?(n(192|l>>>6),n(128|63&l)):l>55295&&l<57344?(n(240|(l=65536+(1047552&l)|1023&e.charCodeAt(++o))>>>18),n(128|l>>>12&63),n(128|l>>>6&63),n(128|63&l)):(n(224|l>>>12),n(128|l>>>6&63),n(128|63&l))}return Tr(r,0,s)}var Vr="[SessionRecording]",Qr=K(Vr),Jr=3e5,Yr=[Ei.MouseMove,Ei.MouseInteraction,Ei.Scroll,Ei.ViewportResize,Ei.Input,Ei.TouchMove,Ei.MediaInteraction,Ei.Drag],Kr=e=>({rrwebMethod:e,enqueuedAt:Date.now(),attempt:1});function Xr(e){return function(e,t){for(var i="",r=0;r<e.length;){var s=e[r++];s<128||t?i+=String.fromCharCode(s):s<224?i+=String.fromCharCode((31&s)<<6|63&e[r++]):s<240?i+=String.fromCharCode((15&s)<<12|(63&e[r++])<<6|63&e[r++]):(s=((15&s)<<18|(63&e[r++])<<12|(63&e[r++])<<6|63&e[r++])-65536,i+=String.fromCharCode(55296|s>>10,56320|1023&s))}return i}(Wr(Gr(JSON.stringify(e))),!0)}function Zr(e){return e.type===Si.Custom&&"sessionIdle"===e.data.tag}function es(e,t){return t.some((t=>"regex"===t.matching&&new RegExp(t.url).test(e)))}class ts{get sessionIdleThresholdMilliseconds(){return this.instance.config.session_recording.session_idle_threshold_ms||3e5}get rrwebRecord(){var e,t;return null==h||null===(e=h.__PosthogExtensions__)||void 0===e||null===(t=e.rrweb)||void 0===t?void 0:t.record}get started(){return this._captureStarted}get sessionManager(){if(!this.instance.sessionManager)throw new Error(Vr+" must be started with a valid sessionManager.");return this.instance.sessionManager}get fullSnapshotIntervalMillis(){var e,t;return"trigger_pending"===this.triggerStatus?6e4:null!==(e=null===(t=this.instance.config.session_recording)||void 0===t?void 0:t.full_snapshot_interval_millis)&&void 0!==e?e:Jr}get isSampled(){var e=this.instance.get_property(we);return G(e)?e:null}get sessionDuration(){var e,t,i=null===(e=this.buffer)||void 0===e?void 0:e.data[(null===(t=this.buffer)||void 0===t?void 0:t.data.length)-1],{sessionStartTimestamp:r}=this.sessionManager.checkAndGetSessionAndWindowId(!0);return i?i.timestamp-r:null}get isRecordingEnabled(){var t=!!this.instance.get_property(_e),i=!this.instance.config.disable_session_recording;return e&&t&&i}get isConsoleLogCaptureEnabled(){var e=!!this.instance.get_property(pe),t=this.instance.config.enable_recording_console_log;return null!=t?t:e}get canvasRecording(){var e,t,i,r,s,n,o=this.instance.config.session_recording.captureCanvas,a=this.instance.get_property(ge),l=null!==(e=null!==(t=null==o?void 0:o.recordCanvas)&&void 0!==t?t:null==a?void 0:a.enabled)&&void 0!==e&&e,u=null!==(i=null!==(r=null==o?void 0:o.canvasFps)&&void 0!==r?r:null==a?void 0:a.fps)&&void 0!==i?i:0,c=null!==(s=null!==(n=null==o?void 0:o.canvasQuality)&&void 0!==n?n:null==a?void 0:a.quality)&&void 0!==s?s:0;return{enabled:l,fps:ar(u,0,12,"canvas recording fps"),quality:ar(c,0,1,"canvas recording quality")}}get networkPayloadCapture(){var e,t,i=this.instance.get_property(ve),r={recordHeaders:null===(e=this.instance.config.session_recording)||void 0===e?void 0:e.recordHeaders,recordBody:null===(t=this.instance.config.session_recording)||void 0===t?void 0:t.recordBody},s=(null==r?void 0:r.recordHeaders)||(null==i?void 0:i.recordHeaders),n=(null==r?void 0:r.recordBody)||(null==i?void 0:i.recordBody),o=N(this.instance.config.capture_performance)?this.instance.config.capture_performance.network_timing:this.instance.config.capture_performance,a=!!(G(o)?o:null==i?void 0:i.capturePerformance);return s||n||a?{recordHeaders:s,recordBody:n,recordPerformance:a}:void 0}get sampleRate(){var e=this.instance.get_property(fe);return W(e)?e:null}get minimumDuration(){var e=this.instance.get_property(me);return W(e)?e:null}get status(){return this.receivedDecide?this.isRecordingEnabled?this._urlBlocked?"paused":z(this._linkedFlag)||this._linkedFlagSeen?"trigger_pending"===this.triggerStatus?"buffering":G(this.isSampled)?this.isSampled?"sampled":"disabled":"active":"buffering":"disabled":"buffering"}get urlTriggerStatus(){var e;return 0===this._urlTriggers.length?"trigger_disabled":(null===(e=this.instance)||void 0===e?void 0:e.get_property(Se))===this.sessionId?"trigger_activated":"trigger_pending"}get eventTriggerStatus(){var e;return 0===this._eventTriggers.length?"trigger_disabled":(null===(e=this.instance)||void 0===e?void 0:e.get_property(Ee))===this.sessionId?"trigger_activated":"trigger_pending"}get triggerStatus(){var e="trigger_activated"===this.eventTriggerStatus||"trigger_activated"===this.urlTriggerStatus,t="trigger_pending"===this.eventTriggerStatus||"trigger_pending"===this.urlTriggerStatus;return e?"trigger_activated":t?"trigger_pending":"trigger_disabled"}constructor(e){if(ie(this,"queuedRRWebEvents",[]),ie(this,"isIdle",!1),ie(this,"_linkedFlagSeen",!1),ie(this,"_lastActivityTimestamp",Date.now()),ie(this,"_linkedFlag",null),ie(this,"_removePageViewCaptureHook",void 0),ie(this,"_onSessionIdListener",void 0),ie(this,"_persistDecideOnSessionListener",void 0),ie(this,"_samplingSessionListener",void 0),ie(this,"_urlTriggers",[]),ie(this,"_urlBlocklist",[]),ie(this,"_urlBlocked",!1),ie(this,"_eventTriggers",[]),ie(this,"_removeEventTriggerCaptureHook",void 0),ie(this,"_forceAllowLocalhostNetworkCapture",!1),ie(this,"_onBeforeUnload",(()=>{this._flushBuffer()})),ie(this,"_onOffline",(()=>{this._tryAddCustomEvent("browser offline",{})})),ie(this,"_onOnline",(()=>{this._tryAddCustomEvent("browser online",{})})),ie(this,"_onVisibilityChange",(()=>{if(null!=o&&o.visibilityState){var e="window "+o.visibilityState;this._tryAddCustomEvent(e,{})}})),this.instance=e,this._captureStarted=!1,this._endpoint="/s/",this.stopRrweb=void 0,this.receivedDecide=!1,!this.instance.sessionManager)throw Qr.error("started without valid sessionManager"),new Error(Vr+" started without valid sessionManager. This is a bug.");if(this.instance.config.__preview_experimental_cookieless_mode)throw new Error(Vr+" cannot be used with __preview_experimental_cookieless_mode.");var{sessionId:t,windowId:i}=this.sessionManager.checkAndGetSessionAndWindowId();this.sessionId=t,this.windowId=i,this.buffer=this.clearBuffer(),this.sessionIdleThresholdMilliseconds>=this.sessionManager.sessionTimeoutMs&&Qr.warn("session_idle_threshold_ms (".concat(this.sessionIdleThresholdMilliseconds,") is greater than the session timeout (").concat(this.sessionManager.sessionTimeoutMs,"). Session will never be detected as idle"))}startIfEnabledOrStop(t){this.isRecordingEnabled?(this._startCapture(t),null==e||e.addEventListener("beforeunload",this._onBeforeUnload),null==e||e.addEventListener("offline",this._onOffline),null==e||e.addEventListener("online",this._onOnline),null==e||e.addEventListener("visibilitychange",this._onVisibilityChange),this._setupSampling(),this._addEventTriggerListener(),z(this._removePageViewCaptureHook)&&(this._removePageViewCaptureHook=this.instance.on("eventCaptured",(e=>{try{if("$pageview"===e.event){var t=null!=e&&e.properties.$current_url?this._maskUrl(null==e?void 0:e.properties.$current_url):"";if(!t)return;this._tryAddCustomEvent("$pageview",{href:t})}}catch(e){Qr.error("Could not add $pageview to rrweb session",e)}}))),this._onSessionIdListener||(this._onSessionIdListener=this.sessionManager.onSessionId(((e,t,i)=>{var r,s,n,o;i&&(this._tryAddCustomEvent("$session_id_change",{sessionId:e,windowId:t,changeReason:i}),null===(r=this.instance)||void 0===r||null===(s=r.persistence)||void 0===s||s.unregister(Ee),null===(n=this.instance)||void 0===n||null===(o=n.persistence)||void 0===o||o.unregister(Se))})))):this.stopRecording()}stopRecording(){var t,i,r,s;this._captureStarted&&this.stopRrweb&&(this.stopRrweb(),this.stopRrweb=void 0,this._captureStarted=!1,null==e||e.removeEventListener("beforeunload",this._onBeforeUnload),null==e||e.removeEventListener("offline",this._onOffline),null==e||e.removeEventListener("online",this._onOnline),null==e||e.removeEventListener("visibilitychange",this._onVisibilityChange),this.clearBuffer(),clearInterval(this._fullSnapshotTimer),null===(t=this._removePageViewCaptureHook)||void 0===t||t.call(this),this._removePageViewCaptureHook=void 0,null===(i=this._removeEventTriggerCaptureHook)||void 0===i||i.call(this),this._removeEventTriggerCaptureHook=void 0,null===(r=this._onSessionIdListener)||void 0===r||r.call(this),this._onSessionIdListener=void 0,null===(s=this._samplingSessionListener)||void 0===s||s.call(this),this._samplingSessionListener=void 0,Qr.info("stopped"))}makeSamplingDecision(e){var t,i=this.sessionId!==e,r=this.sampleRate;if(W(r)){var s,n=this.isSampled,o=i||!G(n);if(o)s=Math.random()<r;else s=n;o&&(s?this._reportStarted("sampled"):Qr.warn("Sample rate (".concat(r,") has determined that this sessionId (").concat(e,") will not be sent to the server.")),this._tryAddCustomEvent("samplingDecisionMade",{sampleRate:r,isSampled:s})),null===(t=this.instance.persistence)||void 0===t||t.register({[we]:s})}else{var a;null===(a=this.instance.persistence)||void 0===a||a.register({[we]:null})}}onRemoteConfig(e){var t,i,r,s,n,o;(this._persistRemoteConfig(e),this._linkedFlag=(null===(t=e.sessionRecording)||void 0===t?void 0:t.linkedFlag)||null,null!==(i=e.sessionRecording)&&void 0!==i&&i.endpoint)&&(this._endpoint=null===(o=e.sessionRecording)||void 0===o?void 0:o.endpoint);if(this._setupSampling(),!z(this._linkedFlag)&&!this._linkedFlagSeen){var a=H(this._linkedFlag)?this._linkedFlag:this._linkedFlag.flag,l=H(this._linkedFlag)?null:this._linkedFlag.variant;this.instance.onFeatureFlags(((e,t)=>{var i=N(t)&&a in t,r=l?t[a]===l:i;r&&this._reportStarted("linked_flag_matched",{linkedFlag:a,linkedVariant:l}),this._linkedFlagSeen=r}))}null!==(r=e.sessionRecording)&&void 0!==r&&r.urlTriggers&&(this._urlTriggers=e.sessionRecording.urlTriggers),null!==(s=e.sessionRecording)&&void 0!==s&&s.urlBlocklist&&(this._urlBlocklist=e.sessionRecording.urlBlocklist),null!==(n=e.sessionRecording)&&void 0!==n&&n.eventTriggers&&(this._eventTriggers=e.sessionRecording.eventTriggers),this.receivedDecide=!0,this.startIfEnabledOrStop()}_setupSampling(){W(this.sampleRate)&&z(this._samplingSessionListener)&&(this._samplingSessionListener=this.sessionManager.onSessionId((e=>{this.makeSamplingDecision(e)})))}_persistRemoteConfig(e){if(this.instance.persistence){var t,i=this.instance.persistence,r=()=>{var t,r,s,n,o,a,l,u,c=null===(t=e.sessionRecording)||void 0===t?void 0:t.sampleRate,d=z(c)?null:parseFloat(c),h=null===(r=e.sessionRecording)||void 0===r?void 0:r.minimumDurationMilliseconds;i.register({[_e]:!!e.sessionRecording,[pe]:null===(s=e.sessionRecording)||void 0===s?void 0:s.consoleLogRecordingEnabled,[ve]:te({capturePerformance:e.capturePerformance},null===(n=e.sessionRecording)||void 0===n?void 0:n.networkPayloadCapture),[ge]:{enabled:null===(o=e.sessionRecording)||void 0===o?void 0:o.recordCanvas,fps:null===(a=e.sessionRecording)||void 0===a?void 0:a.canvasFps,quality:null===(l=e.sessionRecording)||void 0===l?void 0:l.canvasQuality},[fe]:d,[me]:B(h)?null:h,[be]:null===(u=e.sessionRecording)||void 0===u?void 0:u.scriptConfig})};r(),null===(t=this._persistDecideOnSessionListener)||void 0===t||t.call(this),this._persistDecideOnSessionListener=this.sessionManager.onSessionId(r)}}log(e){var t,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"log";null===(t=this.instance.sessionRecording)||void 0===t||t.onRRwebEmit({type:6,data:{plugin:"rrweb/console@1",payload:{level:i,trace:[],payload:[JSON.stringify(e)]}},timestamp:Date.now()})}_startCapture(e){if(!B(Object.assign)&&!B(Array.from)&&!(this._captureStarted||this.instance.config.disable_session_recording||this.instance.consent.isOptedOut())){var t,i;if(this._captureStarted=!0,this.sessionManager.checkAndGetSessionAndWindowId(),this.rrwebRecord)this._onScriptLoaded();else null===(t=h.__PosthogExtensions__)||void 0===t||null===(i=t.loadExternalDependency)||void 0===i||i.call(t,this.instance,this.scriptName,(e=>{if(e)return Qr.error("could not load recorder",e);this._onScriptLoaded()}));Qr.info("starting"),"active"===this.status&&this._reportStarted(e||"recording_initialized")}}get scriptName(){var e,t,i;return(null===(e=this.instance)||void 0===e||null===(t=e.persistence)||void 0===t||null===(i=t.get_property(be))||void 0===i?void 0:i.script)||"recorder"}isInteractiveEvent(e){var t;return 3===e.type&&-1!==Yr.indexOf(null===(t=e.data)||void 0===t?void 0:t.source)}_updateWindowAndSessionIds(e){var t=this.isInteractiveEvent(e);t||this.isIdle||e.timestamp-this._lastActivityTimestamp>this.sessionIdleThresholdMilliseconds&&(this.isIdle=!0,clearInterval(this._fullSnapshotTimer),this._tryAddCustomEvent("sessionIdle",{eventTimestamp:e.timestamp,lastActivityTimestamp:this._lastActivityTimestamp,threshold:this.sessionIdleThresholdMilliseconds,bufferLength:this.buffer.data.length,bufferSize:this.buffer.size}),this._flushBuffer());var i=!1;if(t&&(this._lastActivityTimestamp=e.timestamp,this.isIdle&&(this.isIdle=!1,this._tryAddCustomEvent("sessionNoLongerIdle",{reason:"user activity",type:e.type}),i=!0)),!this.isIdle){var{windowId:r,sessionId:s}=this.sessionManager.checkAndGetSessionAndWindowId(!t,e.timestamp),n=this.sessionId!==s,o=this.windowId!==r;this.windowId=r,this.sessionId=s,n||o?(this.stopRecording(),this.startIfEnabledOrStop("session_id_changed")):i&&this._scheduleFullSnapshot()}}_tryRRWebMethod(e){try{return e.rrwebMethod(),!0}catch(t){return this.queuedRRWebEvents.length<10?this.queuedRRWebEvents.push({enqueuedAt:e.enqueuedAt||Date.now(),attempt:e.attempt++,rrwebMethod:e.rrwebMethod}):Qr.warn("could not emit queued rrweb event.",t,e),!1}}_tryAddCustomEvent(e,t){return this._tryRRWebMethod(Kr((()=>this.rrwebRecord.addCustomEvent(e,t))))}_tryTakeFullSnapshot(){return this._tryRRWebMethod(Kr((()=>this.rrwebRecord.takeFullSnapshot())))}_onScriptLoaded(){var e,t={blockClass:"ph-no-capture",blockSelector:void 0,ignoreClass:"ph-ignore-input",maskTextClass:"ph-mask",maskTextSelector:void 0,maskTextFn:void 0,maskAllInputs:!0,maskInputOptions:{password:!0},maskInputFn:void 0,slimDOMOptions:{},collectFonts:!1,inlineStylesheet:!0,recordCrossOriginIframes:!1},i=this.instance.config.session_recording;for(var[r,s]of Object.entries(i||{}))r in t&&("maskInputOptions"===r?t.maskInputOptions=te({password:!0},s):t[r]=s);if(this.canvasRecording&&this.canvasRecording.enabled&&(t.recordCanvas=!0,t.sampling={canvas:this.canvasRecording.fps},t.dataURLOptions={type:"image/webp",quality:this.canvasRecording.quality}),this.rrwebRecord){this.mutationRateLimiter=null!==(e=this.mutationRateLimiter)&&void 0!==e?e:new lr(this.rrwebRecord,{refillRate:this.instance.config.session_recording.__mutationRateLimiterRefillRate,bucketSize:this.instance.config.session_recording.__mutationRateLimiterBucketSize,onBlockedNode:(e,t)=>{var i="Too many mutations on node '".concat(e,"'. Rate limiting. This could be due to SVG animations or something similar");Qr.info(i,{node:t}),this.log(Vr+" "+i,"warn")}});var n=this._gatherRRWebPlugins();this.stopRrweb=this.rrwebRecord(te({emit:e=>{this.onRRwebEmit(e)},plugins:n},t)),this._lastActivityTimestamp=Date.now(),this.isIdle=!1,this._tryAddCustomEvent("$session_options",{sessionRecordingOptions:t,activePlugins:n.map((e=>null==e?void 0:e.name))}),this._tryAddCustomEvent("$posthog_config",{config:this.instance.config})}else Qr.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.")}_scheduleFullSnapshot(){if(this._fullSnapshotTimer&&clearInterval(this._fullSnapshotTimer),!this.isIdle){var e=this.fullSnapshotIntervalMillis;e&&(this._fullSnapshotTimer=setInterval((()=>{this._tryTakeFullSnapshot()}),e))}}_gatherRRWebPlugins(){var e,t,i,r,s=[],n=null===(e=h.__PosthogExtensions__)||void 0===e||null===(t=e.rrwebPlugins)||void 0===t?void 0:t.getRecordConsolePlugin;n&&this.isConsoleLogCaptureEnabled&&s.push(n());var o=null===(i=h.__PosthogExtensions__)||void 0===i||null===(r=i.rrwebPlugins)||void 0===r?void 0:r.getRecordNetworkPlugin;this.networkPayloadCapture&&D(o)&&(!pt.includes(location.hostname)||this._forceAllowLocalhostNetworkCapture?s.push(o(or(this.instance.config,this.networkPayloadCapture))):Qr.info("NetworkCapture not started because we are on localhost."));return s}onRRwebEmit(e){var t;if(this._processQueuedEvents(),e&&N(e)){if(e.type===Si.Meta){var i=this._maskUrl(e.data.href);if(this._lastHref=i,!i)return;e.data.href=i}else this._pageViewFallBack();if(this._checkUrlTriggerConditions(),"paused"!==this.status||function(e){return e.type===Si.Custom&&"recording paused"===e.data.tag}(e)){e.type===Si.FullSnapshot&&this._scheduleFullSnapshot(),e.type===Si.FullSnapshot&&"trigger_pending"===this.triggerStatus&&this.clearBuffer();var r=this.mutationRateLimiter?this.mutationRateLimiter.throttleMutations(e):e;if(r){var s=function(e){var t=e;if(t&&N(t)&&6===t.type&&N(t.data)&&"rrweb/console@1"===t.data.plugin){t.data.payload.payload.length>10&&(t.data.payload.payload=t.data.payload.payload.slice(0,10),t.data.payload.payload.push("...[truncated]"));for(var i=[],r=0;r<t.data.payload.payload.length;r++)t.data.payload.payload[r]&&t.data.payload.payload[r].length>2e3?i.push(t.data.payload.payload[r].slice(0,2e3)+"...[truncated]"):i.push(t.data.payload.payload[r]);return t.data.payload.payload=i,e}return e}(r);if(this._updateWindowAndSessionIds(s),!this.isIdle||Zr(s)){if(Zr(s)){var n=s.data.payload;if(n){var o=n.lastActivityTimestamp,a=n.threshold;s.timestamp=o+a}}var l=null===(t=this.instance.config.session_recording.compress_events)||void 0===t||t?function(e){if(yi(e)<1024)return e;try{if(e.type===Si.FullSnapshot)return te(te({},e),{},{data:Xr(e.data),cv:"2024-10"});if(e.type===Si.IncrementalSnapshot&&e.data.source===Ei.Mutation)return te(te({},e),{},{cv:"2024-10",data:te(te({},e.data),{},{texts:Xr(e.data.texts),attributes:Xr(e.data.attributes),removes:Xr(e.data.removes),adds:Xr(e.data.adds)})});if(e.type===Si.IncrementalSnapshot&&e.data.source===Ei.StyleSheetRule)return te(te({},e),{},{cv:"2024-10",data:te(te({},e.data),{},{adds:Xr(e.data.adds),removes:Xr(e.data.removes)})})}catch(e){Qr.error("could not compress event - will use uncompressed event",e)}return e}(s):s,u={$snapshot_bytes:yi(l),$snapshot_data:l,$session_id:this.sessionId,$window_id:this.windowId};"disabled"!==this.status?this._captureSnapshotBuffered(u):this.clearBuffer()}}}}}_pageViewFallBack(){if(!this.instance.config.capture_pageview&&e){var t=this._maskUrl(e.location.href);this._lastHref!==t&&(this._tryAddCustomEvent("$url_changed",{href:t}),this._lastHref=t)}}_processQueuedEvents(){if(this.queuedRRWebEvents.length){var e=[...this.queuedRRWebEvents];this.queuedRRWebEvents=[],e.forEach((e=>{Date.now()-e.enqueuedAt<=2e3&&this._tryRRWebMethod(e)}))}}_maskUrl(e){var t=this.instance.config.session_recording;if(t.maskNetworkRequestFn){var i,r={url:e};return null===(i=r=t.maskNetworkRequestFn(r))||void 0===i?void 0:i.url}return e}clearBuffer(){return this.buffer={size:0,data:[],sessionId:this.sessionId,windowId:this.windowId},this.buffer}_flushBuffer(){this.flushBufferTimer&&(clearTimeout(this.flushBufferTimer),this.flushBufferTimer=void 0);var e=this.minimumDuration,t=this.sessionDuration,i=W(t)&&t>=0,r=W(e)&&i&&t<e;if("buffering"===this.status||r)return this.flushBufferTimer=setTimeout((()=>{this._flushBuffer()}),2e3),this.buffer;this.buffer.data.length>0&&wi(this.buffer).forEach((e=>{this._captureSnapshot({$snapshot_bytes:e.size,$snapshot_data:e.data,$session_id:e.sessionId,$window_id:e.windowId,$lib:"web",$lib_version:_.LIB_VERSION})}));return this.clearBuffer()}_captureSnapshotBuffered(e){var t,i=2+((null===(t=this.buffer)||void 0===t?void 0:t.data.length)||0);!this.isIdle&&(this.buffer.size+e.$snapshot_bytes+i>943718.4||this.buffer.sessionId!==this.sessionId)&&(this.buffer=this._flushBuffer()),this.buffer.size+=e.$snapshot_bytes,this.buffer.data.push(e.$snapshot_data),this.flushBufferTimer||this.isIdle||(this.flushBufferTimer=setTimeout((()=>{this._flushBuffer()}),2e3))}_captureSnapshot(e){this.instance.capture("$snapshot",e,{_url:this.instance.requestRouter.endpointFor("api",this._endpoint),_noTruncate:!0,_batchKey:"recordings",skip_client_rate_limiting:!0})}_checkUrlTriggerConditions(){if(void 0!==e&&e.location.href){var t=e.location.href,i="paused"===this.status,r=es(t,this._urlBlocklist);r&&!i?this._pauseRecording():!r&&i&&this._resumeRecording(),es(t,this._urlTriggers)&&this._activateTrigger("url")}}_activateTrigger(e){var t,i;"trigger_pending"===this.triggerStatus&&(null===(t=this.instance)||void 0===t||null===(i=t.persistence)||void 0===i||i.register({["url"===e?Se:Ee]:this.sessionId}),this._flushBuffer(),this._reportStarted(e+"_trigger_matched"))}_pauseRecording(){var e,t;"paused"!==this.status&&(this._urlBlocked=!0,null==o||null===(e=o.body)||void 0===e||null===(t=e.classList)||void 0===t||t.add("ph-no-capture"),clearInterval(this._fullSnapshotTimer),setTimeout((()=>{this._flushBuffer()}),100),Qr.info("recording paused due to URL blocker"),this._tryAddCustomEvent("recording paused",{reason:"url blocker"}))}_resumeRecording(){var e,t;"paused"===this.status&&(this._urlBlocked=!1,null==o||null===(e=o.body)||void 0===e||null===(t=e.classList)||void 0===t||t.remove("ph-no-capture"),this._tryTakeFullSnapshot(),this._scheduleFullSnapshot(),this._tryAddCustomEvent("recording resumed",{reason:"left blocked url"}),Qr.info("recording resumed"))}_addEventTriggerListener(){0!==this._eventTriggers.length&&z(this._removeEventTriggerCaptureHook)&&(this._removeEventTriggerCaptureHook=this.instance.on("eventCaptured",(e=>{try{this._eventTriggers.includes(e.event)&&this._activateTrigger("event")}catch(e){Qr.error("Could not activate event trigger",e)}})))}overrideLinkedFlag(){this._linkedFlagSeen=!0,this._reportStarted("linked_flag_overridden")}overrideSampling(){var e;null===(e=this.instance.persistence)||void 0===e||e.register({[we]:!0}),this._reportStarted("sampling_overridden")}overrideTrigger(e){this._activateTrigger(e)}_reportStarted(e,t){this.instance.register_for_session({$session_recording_start_reason:e}),Qr.info(e.replace("_"," "),t),b(["recording_initialized","session_id_changed"],e)||this._tryAddCustomEvent(e,t)}}var is=K("[Decide]");class rs{constructor(e){this.instance=e}_loadRemoteConfigJs(e){var t,i,r;null!==(t=h.__PosthogExtensions__)&&void 0!==t&&t.loadExternalDependency?null===(i=h.__PosthogExtensions__)||void 0===i||null===(r=i.loadExternalDependency)||void 0===r||r.call(i,this.instance,"remote-config",(()=>e(h._POSTHOG_CONFIG))):(is.error("PostHog Extensions not found. Cannot load remote config."),e())}_loadRemoteConfigJSON(e){this.instance._send_request({method:"GET",url:this.instance.requestRouter.endpointFor("assets","/array/".concat(this.instance.config.token,"/config")),callback:t=>{e(t.json)}})}load(){try{if(h._POSTHOG_CONFIG)return is.info("Using preloaded remote config",h._POSTHOG_CONFIG),void this.onRemoteConfig(h._POSTHOG_CONFIG);if(this.instance.config.advanced_disable_decide)return void is.warn("Remote config is disabled. Falling back to local config.");this._loadRemoteConfigJs((e=>{if(!e)return is.info("No config found after loading remote JS config. Falling back to JSON."),void this._loadRemoteConfigJSON((e=>{this.onRemoteConfig(e)}));this.onRemoteConfig(e)}))}catch(e){is.error("Error loading remote config",e)}}onRemoteConfig(e){e?this.instance.config.__preview_remote_config?(this.instance._onRemoteConfig(e),!1!==e.hasFeatureFlags&&this.instance.featureFlags.ensureFlagsLoaded()):is.info("__preview_remote_config is disabled. Logging config instead",e):is.error("Failed to fetch remote config from PostHog.")}}var ss,ns=null!=e&&e.location?bt(e.location.hash,"__posthog")||bt(location.hash,"state"):null,os="_postHogToolbarParams";!function(e){e[e.UNINITIALIZED=0]="UNINITIALIZED",e[e.LOADING=1]="LOADING",e[e.LOADED=2]="LOADED"}(ss||(ss={}));class as{constructor(e){this.instance=e}setToolbarState(e){h.ph_toolbar_state=e}getToolbarState(){var e;return null!==(e=h.ph_toolbar_state)&&void 0!==e?e:ss.UNINITIALIZED}maybeLoadToolbar(){var t,i,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:void 0,s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:void 0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;if(!e||!o)return!1;r=null!==(t=r)&&void 0!==t?t:e.location,n=null!==(i=n)&&void 0!==i?i:e.history;try{if(!s){try{e.localStorage.setItem("test","test"),e.localStorage.removeItem("test")}catch(e){return!1}s=null==e?void 0:e.localStorage}var a,l=ns||bt(r.hash,"__posthog")||bt(r.hash,"state"),u=l?w((()=>JSON.parse(atob(decodeURIComponent(l)))))||w((()=>JSON.parse(decodeURIComponent(l)))):null;return u&&"ph_authorize"===u.action?((a=u).source="url",a&&Object.keys(a).length>0&&(u.desiredHash?r.hash=u.desiredHash:n?n.replaceState(n.state,"",r.pathname+r.search):r.hash="")):((a=JSON.parse(s.getItem(os)||"{}")).source="localstorage",delete a.userIntent),!(!a.token||this.instance.config.token!==a.token)&&(this.loadToolbar(a),!0)}catch(e){return!1}}_callLoadToolbar(e){(h.ph_load_toolbar||h.ph_load_editor)(e,this.instance)}loadToolbar(t){var i=!(null==o||!o.getElementById(Ne));if(!e||i)return!1;var r="custom"===this.instance.requestRouter.region&&this.instance.config.advanced_disable_toolbar_metrics,s=te(te({token:this.instance.config.token},t),{},{apiURL:this.instance.requestRouter.endpointFor("ui")},r?{instrument:!1}:{});if(e.localStorage.setItem(os,JSON.stringify(te(te({},s),{},{source:void 0}))),this.getToolbarState()===ss.LOADED)this._callLoadToolbar(s);else if(this.getToolbarState()===ss.UNINITIALIZED){var n,a;this.setToolbarState(ss.LOADING),null===(n=h.__PosthogExtensions__)||void 0===n||null===(a=n.loadExternalDependency)||void 0===a||a.call(n,this.instance,"toolbar",(e=>{if(e)return Y.error("[Toolbar] Failed to load",e),void this.setToolbarState(ss.UNINITIALIZED);this.setToolbarState(ss.LOADED),this._callLoadToolbar(s)})),I(e,"turbolinks:load",(()=>{this.setToolbarState(ss.UNINITIALIZED),this.loadToolbar(s)}))}return!0}_loadEditor(e){return this.loadToolbar(e)}maybeLoadEditor(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:void 0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:void 0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;return this.maybeLoadToolbar(e,t,i)}}class ls{constructor(e){ie(this,"isPaused",!0),ie(this,"queue",[]),ie(this,"flushTimeoutMs",3e3),this.sendRequest=e}enqueue(e){this.queue.push(e),this.flushTimeout||this.setFlushTimeout()}unload(){this.clearFlushTimeout();var e=this.queue.length>0?this.formatQueue():{},t=Object.values(e),i=[...t.filter((e=>0===e.url.indexOf("/e"))),...t.filter((e=>0!==e.url.indexOf("/e")))];i.map((e=>{this.sendRequest(te(te({},e),{},{transport:"sendBeacon"}))}))}enable(){this.isPaused=!1,this.setFlushTimeout()}setFlushTimeout(){var e=this;this.isPaused||(this.flushTimeout=setTimeout((()=>{if(this.clearFlushTimeout(),this.queue.length>0){var t=this.formatQueue(),i=function(i){var r=t[i],s=(new Date).getTime();r.data&&A(r.data)&&f(r.data,(e=>{e.offset=Math.abs(e.timestamp-s),delete e.timestamp})),e.sendRequest(r)};for(var r in t)i(r)}}),this.flushTimeoutMs))}clearFlushTimeout(){clearTimeout(this.flushTimeout),this.flushTimeout=void 0}formatQueue(){var e={};return f(this.queue,(t=>{var i,r=t,s=(r?r.batchKey:null)||r.url;B(e[s])&&(e[s]=te(te({},r),{},{data:[]})),null===(i=e[s].data)||void 0===i||i.push(r.data)})),this.queue=[],e}}var us=!!u||!!l,cs="text/plain",ds=(e,t)=>{var[i,r]=e.split("?"),s=te({},t);null==r||r.split("&").forEach((e=>{var[t]=e.split("=");delete s[t]}));var n=ft(s);return n=n?(r?r+"&":"")+n:r,"".concat(i,"?").concat(n)},hs=(e,t)=>JSON.stringify(e,((e,t)=>"bigint"==typeof t?t.toString():t),t),_s=e=>{var{data:t,compression:i}=e;if(t){if(i===exports.Compression.GZipJS){var r=Wr(Gr(hs(t)),{mtime:0}),s=new Blob([r],{type:cs});return{contentType:cs,body:s,estimatedSize:s.size}}if(i===exports.Compression.Base64){var n=function(e){var t,i,r,s,n,o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",a=0,l=0,u="",c=[];if(!e)return e;e=C(e);do{t=(n=e.charCodeAt(a++)<<16|e.charCodeAt(a++)<<8|e.charCodeAt(a++))>>18&63,i=n>>12&63,r=n>>6&63,s=63&n,c[l++]=o.charAt(t)+o.charAt(i)+o.charAt(r)+o.charAt(s)}while(a<e.length);switch(u=c.join(""),e.length%3){case 1:u=u.slice(0,-2)+"==";break;case 2:u=u.slice(0,-1)+"="}return u}(hs(t)),o=(e=>"data="+encodeURIComponent("string"==typeof e?e:hs(e)))(n);return{contentType:"application/x-www-form-urlencoded",body:o,estimatedSize:new Blob([o]).size}}var a=hs(t);return{contentType:"application/json",body:a,estimatedSize:new Blob([a]).size}}},ps=[];u&&ps.push({transport:"XHR",method:e=>{var t,i=new u;i.open(e.method||"GET",e.url,!0);var{contentType:r,body:s}=null!==(t=_s(e))&&void 0!==t?t:{};f(e.headers,(function(e,t){i.setRequestHeader(t,e)})),r&&i.setRequestHeader("Content-Type",r),e.timeout&&(i.timeout=e.timeout),i.withCredentials=!0,i.onreadystatechange=()=>{if(4===i.readyState){var t,r={statusCode:i.status,text:i.responseText};if(200===i.status)try{r.json=JSON.parse(i.responseText)}catch(e){}null===(t=e.callback)||void 0===t||t.call(e,r)}},i.send(s)}}),l&&ps.push({transport:"fetch",method:e=>{var t,i,{contentType:r,body:s,estimatedSize:n}=null!==(t=_s(e))&&void 0!==t?t:{},o=new Headers;f(e.headers,(function(e,t){o.append(t,e)})),r&&o.append("Content-Type",r);var a=e.url,u=null;if(c){var d=new c;u={signal:d.signal,timeout:setTimeout((()=>d.abort()),e.timeout)}}l(a,te({method:(null==e?void 0:e.method)||"GET",headers:o,keepalive:"POST"===e.method&&(n||0)<52428.8,body:s,signal:null===(i=u)||void 0===i?void 0:i.signal},e.fetchOptions)).then((t=>t.text().then((i=>{var r,s={statusCode:t.status,text:i};if(200===t.status)try{s.json=JSON.parse(i)}catch(e){Y.error(e)}null===(r=e.callback)||void 0===r||r.call(e,s)})))).catch((t=>{var i;Y.error(t),null===(i=e.callback)||void 0===i||i.call(e,{statusCode:0,text:t})})).finally((()=>u?clearTimeout(u.timeout):null))}}),null!=n&&n.sendBeacon&&ps.push({transport:"sendBeacon",method:e=>{var t=ds(e.url,{beacon:"1"});try{var i,{contentType:r,body:s}=null!==(i=_s(e))&&void 0!==i?i:{},o="string"==typeof s?new Blob([s],{type:r}):s;n.sendBeacon(t,o)}catch(e){}}});var vs=["retriesPerformedSoFar"];class gs{constructor(t){ie(this,"isPolling",!1),ie(this,"pollIntervalMs",3e3),ie(this,"queue",[]),this.instance=t,this.queue=[],this.areWeOnline=!0,!B(e)&&"onLine"in e.navigator&&(this.areWeOnline=e.navigator.onLine,e.addEventListener("online",(()=>{this.areWeOnline=!0,this.flush()})),e.addEventListener("offline",(()=>{this.areWeOnline=!1})))}retriableRequest(e){var{retriesPerformedSoFar:t}=e,i=re(e,vs);W(t)&&t>0&&(i.url=ds(i.url,{retry_count:t})),this.instance._send_request(te(te({},i),{},{callback:e=>{var r;200!==e.statusCode&&(e.statusCode<400||e.statusCode>=500)&&(null!=t?t:0)<10?this.enqueue(te({retriesPerformedSoFar:t},i)):null===(r=i.callback)||void 0===r||r.call(i,e)}}))}enqueue(e){var t=e.retriesPerformedSoFar||0;e.retriesPerformedSoFar=t+1;var i=function(e){var t=3e3*Math.pow(2,e),i=t/2,r=Math.min(18e5,t),s=(Math.random()-.5)*(r-i);return Math.ceil(r+s)}(t),r=Date.now()+i;this.queue.push({retryAt:r,requestOptions:e});var s="Enqueued failed request for retry in ".concat(i);navigator.onLine||(s+=" (Browser is offline)"),Y.warn(s),this.isPolling||(this.isPolling=!0,this.poll())}poll(){this.poller&&clearTimeout(this.poller),this.poller=setTimeout((()=>{this.areWeOnline&&this.queue.length>0&&this.flush(),this.poll()}),this.pollIntervalMs)}flush(){var e=Date.now(),t=[],i=this.queue.filter((i=>i.retryAt<e||(t.push(i),!1)));if(this.queue=t,i.length>0)for(var{requestOptions:r}of i)this.retriableRequest(r)}unload(){for(var{requestOptions:e}of(this.poller&&(clearTimeout(this.poller),this.poller=void 0),this.queue))try{this.instance._send_request(te(te({},e),{},{transport:"sendBeacon"}))}catch(e){Y.error(e)}this.queue=[]}}var fs,ms=K("[SessionId]");class bs{constructor(e,t,i){var r;if(ie(this,"_sessionIdChangedHandlers",[]),!e.persistence)throw new Error("SessionIdManager requires a PostHogPersistence instance");if(e.config.__preview_experimental_cookieless_mode)throw new Error("SessionIdManager cannot be used with __preview_experimental_cookieless_mode");this.config=e.config,this.persistence=e.persistence,this._windowId=void 0,this._sessionId=void 0,this._sessionStartTimestamp=null,this._sessionActivityTimestamp=null,this._sessionIdGenerator=t||Ze,this._windowIdGenerator=i||Ze;var s=this.config.persistence_name||this.config.token,n=this.config.session_idle_timeout_seconds||1800;if(this._sessionTimeoutMs=1e3*ar(n,60,36e3,"session_idle_timeout_seconds",1800),e.register({$configured_session_timeout_ms:this._sessionTimeoutMs}),this.resetIdleTimer(),this._window_id_storage_key="ph_"+s+"_window_id",this._primary_window_exists_storage_key="ph_"+s+"_primary_window_exists",this._canUseSessionStorage()){var o=_t.parse(this._window_id_storage_key),a=_t.parse(this._primary_window_exists_storage_key);o&&!a?this._windowId=o:_t.remove(this._window_id_storage_key),_t.set(this._primary_window_exists_storage_key,!0)}if(null!==(r=this.config.bootstrap)&&void 0!==r&&r.sessionID)try{var l=(e=>{var t=e.replace(/-/g,"");if(32!==t.length)throw new Error("Not a valid UUID");if("7"!==t[12])throw new Error("Not a UUIDv7");return parseInt(t.substring(0,12),16)})(this.config.bootstrap.sessionID);this._setSessionId(this.config.bootstrap.sessionID,(new Date).getTime(),l)}catch(e){ms.error("Invalid sessionID in bootstrap",e)}this._listenToReloadWindow()}get sessionTimeoutMs(){return this._sessionTimeoutMs}onSessionId(e){return B(this._sessionIdChangedHandlers)&&(this._sessionIdChangedHandlers=[]),this._sessionIdChangedHandlers.push(e),this._sessionId&&e(this._sessionId,this._windowId),()=>{this._sessionIdChangedHandlers=this._sessionIdChangedHandlers.filter((t=>t!==e))}}_canUseSessionStorage(){return"memory"!==this.config.persistence&&!this.persistence.disabled&&_t.is_supported()}_setWindowId(e){e!==this._windowId&&(this._windowId=e,this._canUseSessionStorage()&&_t.set(this._window_id_storage_key,e))}_getWindowId(){return this._windowId?this._windowId:this._canUseSessionStorage()?_t.parse(this._window_id_storage_key):null}_setSessionId(e,t,i){e===this._sessionId&&t===this._sessionActivityTimestamp&&i===this._sessionStartTimestamp||(this._sessionStartTimestamp=i,this._sessionActivityTimestamp=t,this._sessionId=e,this.persistence.register({[ye]:[t,e,i]}))}_getSessionId(){if(this._sessionId&&this._sessionActivityTimestamp&&this._sessionStartTimestamp)return[this._sessionActivityTimestamp,this._sessionId,this._sessionStartTimestamp];var e=this.persistence.props[ye];return A(e)&&2===e.length&&e.push(e[0]),e||[0,null,0]}resetSessionId(){this._setSessionId(null,null,null)}_listenToReloadWindow(){null==e||e.addEventListener("beforeunload",(()=>{this._canUseSessionStorage()&&_t.remove(this._primary_window_exists_storage_key)}))}checkAndGetSessionAndWindowId(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(this.config.__preview_experimental_cookieless_mode)throw new Error("checkAndGetSessionAndWindowId should not be called in __preview_experimental_cookieless_mode");var i=t||(new Date).getTime(),[r,s,n]=this._getSessionId(),o=this._getWindowId(),a=W(n)&&n>0&&Math.abs(i-n)>864e5,l=!1,u=!s,c=!e&&Math.abs(i-r)>this.sessionTimeoutMs;u||c||a?(s=this._sessionIdGenerator(),o=this._windowIdGenerator(),ms.info("new session ID generated",{sessionId:s,windowId:o,changeReason:{noSessionId:u,activityTimeout:c,sessionPastMaximumLength:a}}),n=i,l=!0):o||(o=this._windowIdGenerator(),l=!0);var d=0===r||!e||a?i:r,h=0===n?(new Date).getTime():n;return this._setWindowId(o),this._setSessionId(s,d,h),e||this.resetIdleTimer(),l&&this._sessionIdChangedHandlers.forEach((e=>e(s,o,l?{noSessionId:u,activityTimeout:c,sessionPastMaximumLength:a}:void 0))),{sessionId:s,windowId:o,sessionStartTimestamp:h,changeReason:l?{noSessionId:u,activityTimeout:c,sessionPastMaximumLength:a}:void 0,lastActivityTimestamp:r}}resetIdleTimer(){clearTimeout(this._enforceIdleTimeout),this._enforceIdleTimeout=setTimeout((()=>{this.resetSessionId()}),1.1*this.sessionTimeoutMs)}}!function(e){e.US="us",e.EU="eu",e.CUSTOM="custom"}(fs||(fs={}));var ys="i.posthog.com";class ws{constructor(e){ie(this,"_regionCache",{}),this.instance=e}get apiHost(){var e=this.instance.config.api_host.trim().replace(/\/$/,"");return"https://app.posthog.com"===e?"https://us.i.posthog.com":e}get uiHost(){var e,t=null===(e=this.instance.config.ui_host)||void 0===e?void 0:e.replace(/\/$/,"");return t||(t=this.apiHost.replace(".".concat(ys),".posthog.com")),"https://app.posthog.com"===t?"https://us.posthog.com":t}get region(){return this._regionCache[this.apiHost]||(/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost)?this._regionCache[this.apiHost]=fs.US:/https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost)?this._regionCache[this.apiHost]=fs.EU:this._regionCache[this.apiHost]=fs.CUSTOM),this._regionCache[this.apiHost]}endpointFor(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";if(t&&(t="/"===t[0]?t:"/".concat(t)),"ui"===e)return this.uiHost+t;if(this.region===fs.CUSTOM)return this.apiHost+t;var i=ys+t;switch(e){case"assets":return"https://".concat(this.region,"-assets.").concat(i);case"api":return"https://".concat(this.region,".").concat(i)}}}var Ss="posthog-js";function Es(e){var{organization:t,projectId:i,prefix:r,severityAllowList:s=["error"]}=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return n=>{var o,a,l,u,c;if(!("*"===s||s.includes(n.level))||!e.__loaded)return n;n.tags||(n.tags={});var d=e.requestRouter.endpointFor("ui","/project/".concat(e.config.token,"/person/").concat(e.get_distinct_id()));n.tags["PostHog Person URL"]=d,e.sessionRecordingStarted()&&(n.tags["PostHog Recording URL"]=e.get_session_replay_url({withTimestamp:!0}));var h=(null===(o=n.exception)||void 0===o?void 0:o.values)||[];h.map((e=>{e.stacktrace&&(e.stacktrace.type="raw")}));var _={$exception_message:(null===(a=h[0])||void 0===a?void 0:a.value)||n.message,$exception_type:null===(l=h[0])||void 0===l?void 0:l.type,$exception_personURL:d,$exception_level:n.level,$exception_list:h,$sentry_event_id:n.event_id,$sentry_exception:n.exception,$sentry_exception_message:(null===(u=h[0])||void 0===u?void 0:u.value)||n.message,$sentry_exception_type:null===(c=h[0])||void 0===c?void 0:c.type,$sentry_tags:n.tags};return t&&i&&(_.$sentry_url=(r||"https://sentry.io/organizations/")+t+"/issues/?project="+i+"&query="+n.event_id),e.exceptions.sendExceptionEvent(_),n}}class ks{constructor(e,t,i,r,s){this.name=Ss,this.setupOnce=function(n){n(Es(e,{organization:t,projectId:i,prefix:r,severityAllowList:s}))}}}var xs,Cs,Is,Ps=K("[SegmentIntegration]");function Ts(e,t){var i=e.config.segment;if(!i)return t();!function(e,t){var i=e.config.segment;if(!i)return t();var r=i=>{var r=()=>i.anonymousId()||Ze();e.config.get_device_id=r,i.id()&&(e.register({distinct_id:i.id(),$device_id:r()}),e.persistence.set_property(Re,"identified")),t()},s=i.user();"then"in s&&D(s.then)?s.then((e=>r(e))):r(s)}(e,(()=>{i.register((e=>{Promise&&Promise.resolve||Ps.warn("This browser does not have Promise support, and can not use the segment integration");var t=(t,i)=>{var r;if(!i)return t;t.event.userId||t.event.anonymousId===e.get_distinct_id()||(Ps.info("No userId set, resetting PostHog"),e.reset()),t.event.userId&&t.event.userId!==e.get_distinct_id()&&(Ps.info("UserId set, identifying with PostHog"),e.identify(t.event.userId));var s=e._calculate_event_properties(i,null!==(r=t.event.properties)&&void 0!==r?r:{},new Date);return t.event.properties=Object.assign({},s,t.event.properties),t};return{name:"PostHog JS",type:"enrichment",version:"1.0.0",isLoaded:()=>!0,load:()=>Promise.resolve(),track:e=>t(e,e.event.event),page:e=>t(e,"$pageview"),identify:e=>t(e,"$identify"),screen:e=>t(e,"$screen")}})(e)).then((()=>{t()}))}))}class Fs{constructor(e){this._instance=e}doPageView(t){var i,r=this._previousPageViewProperties(t);return this._currentPath=null!==(i=null==e?void 0:e.location.pathname)&&void 0!==i?i:"",this._instance.scrollManager.resetContext(),this._prevPageviewTimestamp=t,r}doPageLeave(e){return this._previousPageViewProperties(e)}_previousPageViewProperties(e){var t=this._currentPath,i=this._prevPageviewTimestamp,r=this._instance.scrollManager.getContext();if(!i)return{};var s={};if(r){var{maxScrollHeight:n,lastScrollY:o,maxScrollY:a,maxContentHeight:l,lastContentY:u,maxContentY:c}=r;if(!(B(n)||B(o)||B(a)||B(l)||B(u)||B(c)))n=Math.ceil(n),o=Math.ceil(o),a=Math.ceil(a),l=Math.ceil(l),u=Math.ceil(u),c=Math.ceil(c),s={$prev_pageview_last_scroll:o,$prev_pageview_last_scroll_percentage:n<=1?1:ar(o/n,0,1),$prev_pageview_max_scroll:a,$prev_pageview_max_scroll_percentage:n<=1?1:ar(a/n,0,1),$prev_pageview_last_content:u,$prev_pageview_last_content_percentage:l<=1?1:ar(u/l,0,1),$prev_pageview_max_content:c,$prev_pageview_max_content_percentage:l<=1?1:ar(c/l,0,1)}}return t&&(s.$prev_pageview_pathname=t),i&&(s.$prev_pageview_duration=(e.getTime()-i.getTime())/1e3),s}}exports.SurveyType=void 0,(xs=exports.SurveyType||(exports.SurveyType={})).Popover="popover",xs.API="api",xs.Widget="widget",exports.SurveyQuestionType=void 0,(Cs=exports.SurveyQuestionType||(exports.SurveyQuestionType={})).Open="open",Cs.MultipleChoice="multiple_choice",Cs.SingleChoice="single_choice",Cs.Rating="rating",Cs.Link="link",exports.SurveyQuestionBranchingType=void 0,(Is=exports.SurveyQuestionBranchingType||(exports.SurveyQuestionBranchingType={})).NextQuestion="next_question",Is.End="end",Is.ResponseBased="response_based",Is.SpecificQuestion="specific_question";class Rs{constructor(){ie(this,"events",{}),this.events={}}on(e,t){return this.events[e]||(this.events[e]=[]),this.events[e].push(t),()=>{this.events[e]=this.events[e].filter((e=>e!==t))}}emit(e,t){for(var i of this.events[e]||[])i(t);for(var r of this.events["*"]||[])r(e,t)}}class $s{constructor(e){ie(this,"_debugEventEmitter",new Rs),ie(this,"checkStep",((e,t)=>this.checkStepEvent(e,t)&&this.checkStepUrl(e,t)&&this.checkStepElement(e,t))),ie(this,"checkStepEvent",((e,t)=>null==t||!t.event||(null==e?void 0:e.event)===(null==t?void 0:t.event))),this.instance=e,this.actionEvents=new Set,this.actionRegistry=new Set}init(){var e;if(!B(null===(e=this.instance)||void 0===e?void 0:e._addCaptureHook)){var t;null===(t=this.instance)||void 0===t||t._addCaptureHook(((e,t)=>{this.on(e,t)}))}}register(e){var t,i;if(!B(null===(t=this.instance)||void 0===t?void 0:t._addCaptureHook)&&(e.forEach((e=>{var t,i;null===(t=this.actionRegistry)||void 0===t||t.add(e),null===(i=e.steps)||void 0===i||i.forEach((e=>{var t;null===(t=this.actionEvents)||void 0===t||t.add((null==e?void 0:e.event)||"")}))})),null!==(i=this.instance)&&void 0!==i&&i.autocapture)){var r,s=new Set;e.forEach((e=>{var t;null===(t=e.steps)||void 0===t||t.forEach((e=>{null!=e&&e.selector&&s.add(null==e?void 0:e.selector)}))})),null===(r=this.instance)||void 0===r||r.autocapture.setElementSelectors(s)}}on(e,t){var i;null!=t&&0!=e.length&&(this.actionEvents.has(e)||this.actionEvents.has(null==t?void 0:t.event))&&this.actionRegistry&&(null===(i=this.actionRegistry)||void 0===i?void 0:i.size)>0&&this.actionRegistry.forEach((e=>{this.checkAction(t,e)&&this._debugEventEmitter.emit("actionCaptured",e.name)}))}_addActionHook(e){this.onAction("actionCaptured",(t=>e(t)))}checkAction(e,t){if(null==(null==t?void 0:t.steps))return!1;for(var i of t.steps)if(this.checkStep(e,i))return!0;return!1}onAction(e,t){return this._debugEventEmitter.on(e,t)}checkStepUrl(e,t){if(null!=t&&t.url){var i,r=null==e||null===(i=e.properties)||void 0===i?void 0:i.$current_url;if(!r||"string"!=typeof r)return!1;if(!$s.matchString(r,null==t?void 0:t.url,(null==t?void 0:t.url_matching)||"contains"))return!1}return!0}static matchString(t,i,r){switch(r){case"regex":return!!e&&gt(t,i);case"exact":return i===t;case"contains":var s=$s.escapeStringRegexp(i).replace(/_/g,".").replace(/%/g,".*");return gt(t,s);default:return!1}}static escapeStringRegexp(e){return e.replace(/[|\\{}()[\]^$+*?.]/g,"\\$&").replace(/-/g,"\\x2d")}checkStepElement(e,t){if((null!=t&&t.href||null!=t&&t.tag_name||null!=t&&t.text)&&!this.getElementsList(e).some((e=>!(null!=t&&t.href&&!$s.matchString(e.href||"",null==t?void 0:t.href,(null==t?void 0:t.href_matching)||"exact"))&&((null==t||!t.tag_name||e.tag_name===(null==t?void 0:t.tag_name))&&!(null!=t&&t.text&&!$s.matchString(e.text||"",null==t?void 0:t.text,(null==t?void 0:t.text_matching)||"exact")&&!$s.matchString(e.$el_text||"",null==t?void 0:t.text,(null==t?void 0:t.text_matching)||"exact"))))))return!1;if(null!=t&&t.selector){var i,r=null==e||null===(i=e.properties)||void 0===i?void 0:i.$element_selectors;if(!r)return!1;if(!r.includes(null==t?void 0:t.selector))return!1}return!0}getElementsList(e){return null==(null==e?void 0:e.properties.$elements)?[]:null==e?void 0:e.properties.$elements}}class Os{constructor(e){this.instance=e,this.eventToSurveys=new Map,this.actionToSurveys=new Map}register(e){var t;B(null===(t=this.instance)||void 0===t?void 0:t._addCaptureHook)||(this.setupEventBasedSurveys(e),this.setupActionBasedSurveys(e))}setupActionBasedSurveys(e){var t=e.filter((e=>{var t,i,r,s;return(null===(t=e.conditions)||void 0===t?void 0:t.actions)&&(null===(i=e.conditions)||void 0===i||null===(r=i.actions)||void 0===r||null===(s=r.values)||void 0===s?void 0:s.length)>0}));if(0!==t.length){if(null==this.actionMatcher){this.actionMatcher=new $s(this.instance),this.actionMatcher.init();this.actionMatcher._addActionHook((e=>{this.onAction(e)}))}t.forEach((e=>{var t,i,r,s,n,o,a,l,u,c;e.conditions&&null!==(t=e.conditions)&&void 0!==t&&t.actions&&null!==(i=e.conditions)&&void 0!==i&&null!==(r=i.actions)&&void 0!==r&&r.values&&(null===(s=e.conditions)||void 0===s||null===(n=s.actions)||void 0===n||null===(o=n.values)||void 0===o?void 0:o.length)>0&&(null===(a=this.actionMatcher)||void 0===a||a.register(e.conditions.actions.values),null===(l=e.conditions)||void 0===l||null===(u=l.actions)||void 0===u||null===(c=u.values)||void 0===c||c.forEach((t=>{if(t&&t.name){var i=this.actionToSurveys.get(t.name);i&&i.push(e.id),this.actionToSurveys.set(t.name,i||[e.id])}})))}))}}setupEventBasedSurveys(e){var t;if(0!==e.filter((e=>{var t,i,r,s;return(null===(t=e.conditions)||void 0===t?void 0:t.events)&&(null===(i=e.conditions)||void 0===i||null===(r=i.events)||void 0===r||null===(s=r.values)||void 0===s?void 0:s.length)>0})).length){null===(t=this.instance)||void 0===t||t._addCaptureHook(((e,t)=>{this.onEvent(e,t)})),e.forEach((e=>{var t,i,r;null===(t=e.conditions)||void 0===t||null===(i=t.events)||void 0===i||null===(r=i.values)||void 0===r||r.forEach((t=>{if(t&&t.name){var i=this.eventToSurveys.get(t.name);i&&i.push(e.id),this.eventToSurveys.set(t.name,i||[e.id])}}))}))}}onEvent(e,t){var i,r,s=(null===(i=this.instance)||void 0===i||null===(r=i.persistence)||void 0===r?void 0:r.props[Te])||[];if(Os.SURVEY_SHOWN_EVENT_NAME==e&&t&&s.length>0){var n,o=null==t||null===(n=t.properties)||void 0===n?void 0:n.$survey_id;if(o){var a=s.indexOf(o);a>=0&&(s.splice(a,1),this._updateActivatedSurveys(s))}}else this.eventToSurveys.has(e)&&this._updateActivatedSurveys(s.concat(this.eventToSurveys.get(e)||[]))}onAction(e){var t,i,r=(null===(t=this.instance)||void 0===t||null===(i=t.persistence)||void 0===i?void 0:i.props[Te])||[];this.actionToSurveys.has(e)&&this._updateActivatedSurveys(r.concat(this.actionToSurveys.get(e)||[]))}_updateActivatedSurveys(e){var t,i;null===(t=this.instance)||void 0===t||null===(i=t.persistence)||void 0===i||i.register({[Te]:[...new Set(e)]})}getSurveys(){var e,t,i=null===(e=this.instance)||void 0===e||null===(t=e.persistence)||void 0===t?void 0:t.props[Te];return i||[]}getEventToSurveys(){return this.eventToSurveys}_getActionMatcher(){return this.actionMatcher}}ie(Os,"SURVEY_SHOWN_EVENT_NAME","survey shown");var Ls,Ms,As,Ds,Ns,qs,Bs,Hs,Us={},js=[],zs=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,Ws=Array.isArray;function Gs(e,t){for(var i in t)e[i]=t[i];return e}function Vs(e){var t=e.parentNode;t&&t.removeChild(e)}function Qs(e,t,i,r,s){var n={type:e,props:t,key:i,ref:r,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,constructor:void 0,__v:null==s?++As:s,__i:-1,__u:0};return null==s&&null!=Ms.vnode&&Ms.vnode(n),n}function Js(e){return e.children}function Ys(e,t){this.props=e,this.context=t}function Ks(e,t){if(null==t)return e.__?Ks(e.__,e.__i+1):null;for(var i;t<e.__k.length;t++)if(null!=(i=e.__k[t])&&null!=i.__e)return i.__e;return"function"==typeof e.type?Ks(e):null}function Xs(e){var t,i;if(null!=(e=e.__)&&null!=e.__c){for(e.__e=e.__c.base=null,t=0;t<e.__k.length;t++)if(null!=(i=e.__k[t])&&null!=i.__e){e.__e=e.__c.base=i.__e;break}return Xs(e)}}function Zs(e){(!e.__d&&(e.__d=!0)&&Ds.push(e)&&!en.__r++||Ns!==Ms.debounceRendering)&&((Ns=Ms.debounceRendering)||qs)(en)}function en(){var e,t,i,r,s,n,o,a,l;for(Ds.sort(Bs);e=Ds.shift();)e.__d&&(t=Ds.length,r=void 0,n=(s=(i=e).__v).__e,a=[],l=[],(o=i.__P)&&((r=Gs({},s)).__v=s.__v+1,Ms.vnode&&Ms.vnode(r),cn(o,r,s,i.__n,void 0!==o.ownerSVGElement,32&s.__u?[n]:null,a,null==n?Ks(s):n,!!(32&s.__u),l),r.__.__k[r.__i]=r,dn(a,r,l),r.__e!=n&&Xs(r)),Ds.length>t&&Ds.sort(Bs));en.__r=0}function tn(e,t,i,r,s,n,o,a,l,u,c){var d,h,_,p,v,g=r&&r.__k||js,f=t.length;for(i.__d=l,rn(i,t,g),l=i.__d,d=0;d<f;d++)null!=(_=i.__k[d])&&"boolean"!=typeof _&&"function"!=typeof _&&(h=-1===_.__i?Us:g[_.__i]||Us,_.__i=d,cn(e,_,h,s,n,o,a,l,u,c),p=_.__e,_.ref&&h.ref!=_.ref&&(h.ref&&_n(h.ref,null,_),c.push(_.ref,_.__c||p,_)),null==v&&null!=p&&(v=p),65536&_.__u||h.__k===_.__k?l=sn(_,l,e):"function"==typeof _.type&&void 0!==_.__d?l=_.__d:p&&(l=p.nextSibling),_.__d=void 0,_.__u&=-196609);i.__d=l,i.__e=v}function rn(e,t,i){var r,s,n,o,a,l=t.length,u=i.length,c=u,d=0;for(e.__k=[],r=0;r<l;r++)null!=(s=e.__k[r]=null==(s=t[r])||"boolean"==typeof s||"function"==typeof s?null:"string"==typeof s||"number"==typeof s||"bigint"==typeof s||s.constructor==String?Qs(null,s,null,null,s):Ws(s)?Qs(Js,{children:s},null,null,null):void 0===s.constructor&&s.__b>0?Qs(s.type,s.props,s.key,s.ref?s.ref:null,s.__v):s)?(s.__=e,s.__b=e.__b+1,a=nn(s,i,o=r+d,c),s.__i=a,n=null,-1!==a&&(c--,(n=i[a])&&(n.__u|=131072)),null==n||null===n.__v?(-1==a&&d--,"function"!=typeof s.type&&(s.__u|=65536)):a!==o&&(a===o+1?d++:a>o?c>l-o?d+=a-o:d--:d=a<o&&a==o-1?a-o:0,a!==r+d&&(s.__u|=65536))):(n=i[r])&&null==n.key&&n.__e&&(n.__e==e.__d&&(e.__d=Ks(n)),pn(n,n,!1),i[r]=null,c--);if(c)for(r=0;r<u;r++)null!=(n=i[r])&&0==(131072&n.__u)&&(n.__e==e.__d&&(e.__d=Ks(n)),pn(n,n))}function sn(e,t,i){var r,s;if("function"==typeof e.type){for(r=e.__k,s=0;r&&s<r.length;s++)r[s]&&(r[s].__=e,t=sn(r[s],t,i));return t}return e.__e!=t&&(i.insertBefore(e.__e,t||null),t=e.__e),t&&t.nextSibling}function nn(e,t,i,r){var s=e.key,n=e.type,o=i-1,a=i+1,l=t[i];if(null===l||l&&s==l.key&&n===l.type)return i;if(r>(null!=l&&0==(131072&l.__u)?1:0))for(;o>=0||a<t.length;){if(o>=0){if((l=t[o])&&0==(131072&l.__u)&&s==l.key&&n===l.type)return o;o--}if(a<t.length){if((l=t[a])&&0==(131072&l.__u)&&s==l.key&&n===l.type)return a;a++}}return-1}function on(e,t,i){"-"===t[0]?e.setProperty(t,null==i?"":i):e[t]=null==i?"":"number"!=typeof i||zs.test(t)?i:i+"px"}function an(e,t,i,r,s){var n;e:if("style"===t)if("string"==typeof i)e.style.cssText=i;else{if("string"==typeof r&&(e.style.cssText=r=""),r)for(t in r)i&&t in i||on(e.style,t,"");if(i)for(t in i)r&&i[t]===r[t]||on(e.style,t,i[t])}else if("o"===t[0]&&"n"===t[1])n=t!==(t=t.replace(/(PointerCapture)$|Capture$/,"$1")),t=t.toLowerCase()in e?t.toLowerCase().slice(2):t.slice(2),e.l||(e.l={}),e.l[t+n]=i,i?r?i.u=r.u:(i.u=Date.now(),e.addEventListener(t,n?un:ln,n)):e.removeEventListener(t,n?un:ln,n);else{if(s)t=t.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!==t&&"height"!==t&&"href"!==t&&"list"!==t&&"form"!==t&&"tabIndex"!==t&&"download"!==t&&"rowSpan"!==t&&"colSpan"!==t&&"role"!==t&&t in e)try{e[t]=null==i?"":i;break e}catch(e){}"function"==typeof i||(null==i||!1===i&&"-"!==t[4]?e.removeAttribute(t):e.setAttribute(t,i))}}function ln(e){var t=this.l[e.type+!1];if(e.t){if(e.t<=t.u)return}else e.t=Date.now();return t(Ms.event?Ms.event(e):e)}function un(e){return this.l[e.type+!0](Ms.event?Ms.event(e):e)}function cn(e,t,i,r,s,n,o,a,l,u){var c,d,h,_,p,v,g,f,m,b,y,w,S,E,k,x=t.type;if(void 0!==t.constructor)return null;128&i.__u&&(l=!!(32&i.__u),n=[a=t.__e=i.__e]),(c=Ms.__b)&&c(t);e:if("function"==typeof x)try{if(f=t.props,m=(c=x.contextType)&&r[c.__c],b=c?m?m.props.value:c.__:r,i.__c?g=(d=t.__c=i.__c).__=d.__E:("prototype"in x&&x.prototype.render?t.__c=d=new x(f,b):(t.__c=d=new Ys(f,b),d.constructor=x,d.render=vn),m&&m.sub(d),d.props=f,d.state||(d.state={}),d.context=b,d.__n=r,h=d.__d=!0,d.__h=[],d._sb=[]),null==d.__s&&(d.__s=d.state),null!=x.getDerivedStateFromProps&&(d.__s==d.state&&(d.__s=Gs({},d.__s)),Gs(d.__s,x.getDerivedStateFromProps(f,d.__s))),_=d.props,p=d.state,d.__v=t,h)null==x.getDerivedStateFromProps&&null!=d.componentWillMount&&d.componentWillMount(),null!=d.componentDidMount&&d.__h.push(d.componentDidMount);else{if(null==x.getDerivedStateFromProps&&f!==_&&null!=d.componentWillReceiveProps&&d.componentWillReceiveProps(f,b),!d.__e&&(null!=d.shouldComponentUpdate&&!1===d.shouldComponentUpdate(f,d.__s,b)||t.__v===i.__v)){for(t.__v!==i.__v&&(d.props=f,d.state=d.__s,d.__d=!1),t.__e=i.__e,t.__k=i.__k,t.__k.forEach((function(e){e&&(e.__=t)})),y=0;y<d._sb.length;y++)d.__h.push(d._sb[y]);d._sb=[],d.__h.length&&o.push(d);break e}null!=d.componentWillUpdate&&d.componentWillUpdate(f,d.__s,b),null!=d.componentDidUpdate&&d.__h.push((function(){d.componentDidUpdate(_,p,v)}))}if(d.context=b,d.props=f,d.__P=e,d.__e=!1,w=Ms.__r,S=0,"prototype"in x&&x.prototype.render){for(d.state=d.__s,d.__d=!1,w&&w(t),c=d.render(d.props,d.state,d.context),E=0;E<d._sb.length;E++)d.__h.push(d._sb[E]);d._sb=[]}else do{d.__d=!1,w&&w(t),c=d.render(d.props,d.state,d.context),d.state=d.__s}while(d.__d&&++S<25);d.state=d.__s,null!=d.getChildContext&&(r=Gs(Gs({},r),d.getChildContext())),h||null==d.getSnapshotBeforeUpdate||(v=d.getSnapshotBeforeUpdate(_,p)),tn(e,Ws(k=null!=c&&c.type===Js&&null==c.key?c.props.children:c)?k:[k],t,i,r,s,n,o,a,l,u),d.base=t.__e,t.__u&=-161,d.__h.length&&o.push(d),g&&(d.__E=d.__=null)}catch(e){t.__v=null,l||null!=n?(t.__e=a,t.__u|=l?160:32,n[n.indexOf(a)]=null):(t.__e=i.__e,t.__k=i.__k),Ms.__e(e,t,i)}else null==n&&t.__v===i.__v?(t.__k=i.__k,t.__e=i.__e):t.__e=hn(i.__e,t,i,r,s,n,o,l,u);(c=Ms.diffed)&&c(t)}function dn(e,t,i){t.__d=void 0;for(var r=0;r<i.length;r++)_n(i[r],i[++r],i[++r]);Ms.__c&&Ms.__c(t,e),e.some((function(t){try{e=t.__h,t.__h=[],e.some((function(e){e.call(t)}))}catch(e){Ms.__e(e,t.__v)}}))}function hn(e,t,i,r,s,n,o,a,l){var u,c,d,h,_,p,v,g=i.props,f=t.props,m=t.type;if("svg"===m&&(s=!0),null!=n)for(u=0;u<n.length;u++)if((_=n[u])&&"setAttribute"in _==!!m&&(m?_.localName===m:3===_.nodeType)){e=_,n[u]=null;break}if(null==e){if(null===m)return document.createTextNode(f);e=s?document.createElementNS("http://www.w3.org/2000/svg",m):document.createElement(m,f.is&&f),n=null,a=!1}if(null===m)g===f||a&&e.data===f||(e.data=f);else{if(n=n&&Ls.call(e.childNodes),g=i.props||Us,!a&&null!=n)for(g={},u=0;u<e.attributes.length;u++)g[(_=e.attributes[u]).name]=_.value;for(u in g)_=g[u],"children"==u||("dangerouslySetInnerHTML"==u?d=_:"key"===u||u in f||an(e,u,null,_,s));for(u in f)_=f[u],"children"==u?h=_:"dangerouslySetInnerHTML"==u?c=_:"value"==u?p=_:"checked"==u?v=_:"key"===u||a&&"function"!=typeof _||g[u]===_||an(e,u,_,g[u],s);if(c)a||d&&(c.__html===d.__html||c.__html===e.innerHTML)||(e.innerHTML=c.__html),t.__k=[];else if(d&&(e.innerHTML=""),tn(e,Ws(h)?h:[h],t,i,r,s&&"foreignObject"!==m,n,o,n?n[0]:i.__k&&Ks(i,0),a,l),null!=n)for(u=n.length;u--;)null!=n[u]&&Vs(n[u]);a||(u="value",void 0!==p&&(p!==e[u]||"progress"===m&&!p||"option"===m&&p!==g[u])&&an(e,u,p,g[u],!1),u="checked",void 0!==v&&v!==e[u]&&an(e,u,v,g[u],!1))}return e}function _n(e,t,i){try{"function"==typeof e?e(t):e.current=t}catch(e){Ms.__e(e,i)}}function pn(e,t,i){var r,s;if(Ms.unmount&&Ms.unmount(e),(r=e.ref)&&(r.current&&r.current!==e.__e||_n(r,null,t)),null!=(r=e.__c)){if(r.componentWillUnmount)try{r.componentWillUnmount()}catch(e){Ms.__e(e,t)}r.base=r.__P=null,e.__c=void 0}if(r=e.__k)for(s=0;s<r.length;s++)r[s]&&pn(r[s],t,i||"function"!=typeof e.type);i||null==e.__e||Vs(e.__e),e.__=e.__e=e.__d=void 0}function vn(e,t,i){return this.constructor(e,i)}Ls=js.slice,Ms={__e:function(e,t,i,r){for(var s,n,o;t=t.__;)if((s=t.__c)&&!s.__)try{if((n=s.constructor)&&null!=n.getDerivedStateFromError&&(s.setState(n.getDerivedStateFromError(e)),o=s.__d),null!=s.componentDidCatch&&(s.componentDidCatch(e,r||{}),o=s.__d),o)return s.__E=s}catch(t){e=t}throw e}},As=0,Ys.prototype.setState=function(e,t){var i;i=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=Gs({},this.state),"function"==typeof e&&(e=e(Gs({},i),this.props)),e&&Gs(i,e),null!=e&&this.__v&&(t&&this._sb.push(t),Zs(this))},Ys.prototype.forceUpdate=function(e){this.__v&&(this.__e=!0,e&&this.__h.push(e),Zs(this))},Ys.prototype.render=Js,Ds=[],qs="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,Bs=function(e,t){return e.__v.__b-t.__v.__b},en.__r=0,Hs=0;!function(e,t){var i={__c:t="__cC"+Hs++,__:e,Consumer:function(e,t){return e.children(t)},Provider:function(e){var i,r;return this.getChildContext||(i=[],(r={})[t]=this,this.getChildContext=function(){return r},this.shouldComponentUpdate=function(e){this.props.value!==e.value&&i.some((function(e){e.__e=!0,Zs(e)}))},this.sub=function(e){i.push(e);var t=e.componentWillUnmount;e.componentWillUnmount=function(){i.splice(i.indexOf(e),1),t&&t.call(e)}}),e.children}};i.Provider.__=i.Consumer.contextType=i}({isPreviewMode:!1,previewPageIndex:0,handleCloseSurveyPopup:()=>{},isPopup:!0});var gn=K("[Surveys]"),fn={icontains:t=>!!e&&e.location.href.toLowerCase().indexOf(t.toLowerCase())>-1,not_icontains:t=>!!e&&-1===e.location.href.toLowerCase().indexOf(t.toLowerCase()),regex:t=>!!e&&gt(e.location.href,t),not_regex:t=>!!e&&!gt(e.location.href,t),exact:t=>(null==e?void 0:e.location.href)===t,is_not:t=>(null==e?void 0:e.location.href)!==t};class mn{constructor(e){this.instance=e,this._surveyEventReceiver=null}onRemoteConfig(e){this._decideServerResponse=!!e.surveys,this.loadIfEnabled()}reset(){localStorage.removeItem("lastSeenSurveyDate");var e=(()=>{for(var e=[],t=0;t<localStorage.length;t++){var i=localStorage.key(t);null!=i&&i.startsWith("seenSurvey_")&&e.push(i)}return e})();e.forEach((e=>localStorage.removeItem(e)))}loadIfEnabled(){var e,t,i,r=null==h||null===(e=h.__PosthogExtensions__)||void 0===e?void 0:e.generateSurveys;this.instance.config.disable_surveys||!this._decideServerResponse||r||(null==this._surveyEventReceiver&&(this._surveyEventReceiver=new Os(this.instance)),null===(t=h.__PosthogExtensions__)||void 0===t||null===(i=t.loadExternalDependency)||void 0===i||i.call(t,this.instance,"surveys",(e=>{var t,i;if(e)return gn.error("Could not load surveys script",e);this._surveyManager=null===(t=h.__PosthogExtensions__)||void 0===t||null===(i=t.generateSurveys)||void 0===i?void 0:i.call(t,this.instance)})))}getSurveys(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.instance.config.disable_surveys)return e([]);null==this._surveyEventReceiver&&(this._surveyEventReceiver=new Os(this.instance));var i=this.instance.get_property(Pe);if(i&&!t)return e(i);this.instance._send_request({url:this.instance.requestRouter.endpointFor("api","/api/surveys/?token=".concat(this.instance.config.token)),method:"GET",transport:"fetch",callback:t=>{var i;if(200!==t.statusCode||!t.json)return e([]);var r,s=t.json.surveys||[],n=s.filter((e=>{var t,i,r,s,n,o,a,l,u,c,d,h;return(null===(t=e.conditions)||void 0===t?void 0:t.events)&&(null===(i=e.conditions)||void 0===i||null===(r=i.events)||void 0===r?void 0:r.values)&&(null===(s=e.conditions)||void 0===s||null===(n=s.events)||void 0===n||null===(o=n.values)||void 0===o?void 0:o.length)>0||(null===(a=e.conditions)||void 0===a?void 0:a.actions)&&(null===(l=e.conditions)||void 0===l||null===(u=l.actions)||void 0===u?void 0:u.values)&&(null===(c=e.conditions)||void 0===c||null===(d=c.actions)||void 0===d||null===(h=d.values)||void 0===h?void 0:h.length)>0}));n.length>0&&(null===(r=this._surveyEventReceiver)||void 0===r||r.register(n));return null===(i=this.instance.persistence)||void 0===i||i.register({[Pe]:s}),e(s)}})}getActiveMatchingSurveys(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];this.getSurveys((t=>{var i,r=t.filter((e=>!(!e.start_date||e.end_date))).filter((e=>{var t,i,r,s;if(!e.conditions)return!0;var n=null===(t=e.conditions)||void 0===t||!t.url||fn[null!==(i=null===(r=e.conditions)||void 0===r?void 0:r.urlMatchType)&&void 0!==i?i:"icontains"](e.conditions.url),a=null===(s=e.conditions)||void 0===s||!s.selector||(null==o?void 0:o.querySelector(e.conditions.selector));return n&&a})),s=null===(i=this._surveyEventReceiver)||void 0===i?void 0:i.getSurveys(),n=r.filter((e=>{var t,i,r,n,o,a,l,u,c,d,h;if(!(e.linked_flag_key||e.targeting_flag_key||e.internal_targeting_flag_key||null!==(t=e.feature_flag_keys)&&void 0!==t&&t.length))return!0;var _=!e.linked_flag_key||this.instance.featureFlags.isFeatureEnabled(e.linked_flag_key),p=!e.targeting_flag_key||this.instance.featureFlags.isFeatureEnabled(e.targeting_flag_key),v=(null===(i=e.conditions)||void 0===i?void 0:i.events)&&(null===(r=e.conditions)||void 0===r||null===(n=r.events)||void 0===n?void 0:n.values)&&(null===(o=e.conditions)||void 0===o||null===(a=o.events)||void 0===a?void 0:a.values.length)>0,g=(null===(l=e.conditions)||void 0===l?void 0:l.actions)&&(null===(u=e.conditions)||void 0===u||null===(c=u.actions)||void 0===c?void 0:c.values)&&(null===(d=e.conditions)||void 0===d||null===(h=d.actions)||void 0===h?void 0:h.values.length)>0,f=!v&&!g||(null==s?void 0:s.includes(e.id)),m=this._canActivateRepeatedly(e),b=!(e.internal_targeting_flag_key&&!m)||this.instance.featureFlags.isFeatureEnabled(e.internal_targeting_flag_key),y=this.checkFlags(e);return _&&p&&b&&f&&y}));return e(n)}),t)}checkFlags(e){var t;return null===(t=e.feature_flag_keys)||void 0===t||!t.length||e.feature_flag_keys.every((e=>{var{key:t,value:i}=e;return!t||!i||this.instance.featureFlags.isFeatureEnabled(i)}))}getNextSurveyStep(e,t,i){var r,s=e.questions[t],n=t+1;if(null===(r=s.branching)||void 0===r||!r.type)return t===e.questions.length-1?exports.SurveyQuestionBranchingType.End:n;if(s.branching.type===exports.SurveyQuestionBranchingType.End)return exports.SurveyQuestionBranchingType.End;if(s.branching.type===exports.SurveyQuestionBranchingType.SpecificQuestion){if(Number.isInteger(s.branching.index))return s.branching.index}else if(s.branching.type===exports.SurveyQuestionBranchingType.ResponseBased){if(s.type===exports.SurveyQuestionType.SingleChoice){var o,a,l=s.choices.indexOf("".concat(i));if(null!==(o=s.branching)&&void 0!==o&&null!==(a=o.responseValues)&&void 0!==a&&a.hasOwnProperty(l)){var u=s.branching.responseValues[l];return Number.isInteger(u)?u:u===exports.SurveyQuestionBranchingType.End?exports.SurveyQuestionBranchingType.End:n}}else if(s.type===exports.SurveyQuestionType.Rating){var c,d;if("number"!=typeof i||!Number.isInteger(i))throw new Error("The response type must be an integer");var h=function(e,t){if(3===t){if(e<1||e>3)throw new Error("The response must be in range 1-3");return 1===e?"negative":2===e?"neutral":"positive"}if(5===t){if(e<1||e>5)throw new Error("The response must be in range 1-5");return e<=2?"negative":3===e?"neutral":"positive"}if(7===t){if(e<1||e>7)throw new Error("The response must be in range 1-7");return e<=3?"negative":4===e?"neutral":"positive"}if(10===t){if(e<0||e>10)throw new Error("The response must be in range 0-10");return e<=6?"detractors":e<=8?"passives":"promoters"}throw new Error("The scale must be one of: 3, 5, 7, 10")}(i,s.scale);if(null!==(c=s.branching)&&void 0!==c&&null!==(d=c.responseValues)&&void 0!==d&&d.hasOwnProperty(h)){var _=s.branching.responseValues[h];return Number.isInteger(_)?_:_===exports.SurveyQuestionBranchingType.End?exports.SurveyQuestionBranchingType.End:n}}return n}return gn.warn("Falling back to next question index due to unexpected branching type"),n}_canActivateRepeatedly(e){var t;return z(null===(t=h.__PosthogExtensions__)||void 0===t?void 0:t.canActivateRepeatedly)?(gn.warn("init was not called"),!1):h.__PosthogExtensions__.canActivateRepeatedly(e)}canRenderSurvey(e){z(this._surveyManager)?gn.warn("init was not called"):this.getSurveys((t=>{var i=t.filter((t=>t.id===e))[0];this._surveyManager.canRenderSurvey(i)}))}renderSurvey(e,t){z(this._surveyManager)?gn.warn("init was not called"):this.getSurveys((i=>{var r=i.filter((t=>t.id===e))[0];this._surveyManager.renderSurvey(r,null==o?void 0:o.querySelector(t))}))}}var bn=K("[RateLimiter]");class yn{constructor(e){var t,i;ie(this,"serverLimits",{}),ie(this,"lastEventRateLimited",!1),ie(this,"checkForLimiting",(e=>{var t=e.text;if(t&&t.length)try{(JSON.parse(t).quota_limited||[]).forEach((e=>{bn.info("".concat(e||"events"," is quota limited.")),this.serverLimits[e]=(new Date).getTime()+6e4}))}catch(e){return void bn.warn('could not rate limit - continuing. Error: "'.concat(null==e?void 0:e.message,'"'),{text:t})}})),this.instance=e,this.captureEventsPerSecond=(null===(t=e.config.rate_limiting)||void 0===t?void 0:t.events_per_second)||10,this.captureEventsBurstLimit=Math.max((null===(i=e.config.rate_limiting)||void 0===i?void 0:i.events_burst_limit)||10*this.captureEventsPerSecond,this.captureEventsPerSecond),this.lastEventRateLimited=this.clientRateLimitContext(!0).isRateLimited}clientRateLimitContext(){var e,t,i,r=arguments.length>0&&void 0!==arguments[0]&&arguments[0],s=(new Date).getTime(),n=null!==(e=null===(t=this.instance.persistence)||void 0===t?void 0:t.get_property(Oe))&&void 0!==e?e:{tokens:this.captureEventsBurstLimit,last:s};n.tokens+=(s-n.last)/1e3*this.captureEventsPerSecond,n.last=s,n.tokens>this.captureEventsBurstLimit&&(n.tokens=this.captureEventsBurstLimit);var o=n.tokens<1;return o||r||(n.tokens=Math.max(0,n.tokens-1)),!o||this.lastEventRateLimited||r||this.instance.capture("$$client_ingestion_warning",{$$client_ingestion_warning_message:"posthog-js client rate limited. Config is set to ".concat(this.captureEventsPerSecond," events per second and ").concat(this.captureEventsBurstLimit," events burst limit.")},{skip_client_rate_limiting:!0}),this.lastEventRateLimited=o,null===(i=this.instance.persistence)||void 0===i||i.set_property(Oe,n),{isRateLimited:o,remainingTokens:n.tokens}}isServerRateLimited(e){var t=this.serverLimits[e||"events"]||!1;return!1!==t&&(new Date).getTime()<t}}var wn=()=>te({initialPathName:(null==a?void 0:a.pathname)||"",referringDomain:fi.referringDomain()},fi.campaignParams());class Sn{constructor(e,t,i){ie(this,"_onSessionIdCallback",(e=>{var t=this._getStoredProps();if(!t||t.sessionId!==e){var i={sessionId:e,props:this._sessionSourceParamGenerator()};this._persistence.register({[$e]:i})}})),this._sessionIdManager=e,this._persistence=t,this._sessionSourceParamGenerator=i||wn,this._sessionIdManager.onSessionId(this._onSessionIdCallback)}_getStoredProps(){return this._persistence.props[$e]}getSessionProps(){var e,t=null===(e=this._getStoredProps())||void 0===e?void 0:e.props;return t?{$client_session_initial_referring_host:t.referringDomain,$client_session_initial_pathname:t.initialPathName,$client_session_initial_utm_source:t.utm_source,$client_session_initial_utm_campaign:t.utm_campaign,$client_session_initial_utm_medium:t.utm_medium,$client_session_initial_utm_content:t.utm_content,$client_session_initial_utm_term:t.utm_term}:{}}}var En=["ahrefsbot","ahrefssiteaudit","applebot","baiduspider","bingbot","bingpreview","bot.htm","bot.php","crawler","deepscan","duckduckbot","facebookexternal","facebookcatalog","gptbot","http://yandex.com/bots","hubspot","ia_archiver","linkedinbot","mj12bot","msnbot","nessus","petalbot","pinterest","prerender","rogerbot","screaming frog","semrushbot","sitebulb","slurp","turnitin","twitterbot","vercelbot","yahoo! slurp","yandexbot","headlesschrome","cypress","Google-HotelAdsVerifier","adsbot-google","apis-google","duplexweb-google","feedfetcher-google","google favicon","google web preview","google-read-aloud","googlebot","googleweblight","mediapartners-google","storebot-google","Bytespider;"],kn=function(e,t){if(!e)return!1;var i=e.toLowerCase();return En.concat(t||[]).some((e=>{var t=e.toLowerCase();return-1!==i.indexOf(t)}))},xn=function(e,t){if(!e)return!1;var i=e.userAgent;if(i&&kn(i,t))return!0;try{var r=null==e?void 0:e.userAgentData;if(null!=r&&r.brands&&r.brands.some((e=>kn(null==e?void 0:e.brand,t))))return!0}catch(e){}return!!e.webdriver};class Cn{constructor(){this.clicks=[]}isRageClick(e,t,i){var r=this.clicks[this.clicks.length-1];if(r&&Math.abs(e-r.x)+Math.abs(t-r.y)<30&&i-r.timestamp<1e3){if(this.clicks.push({x:e,y:t,timestamp:i}),3===this.clicks.length)return!0}else this.clicks=[{x:e,y:t,timestamp:i}];return!1}}var In=K("[Dead Clicks]"),Pn=()=>!0,Tn=e=>{var t,i=!(null===(t=e.instance.persistence)||void 0===t||!t.get_property(de)),r=e.instance.config.capture_dead_clicks;return G(r)?r:i};class Fn{get lazyLoadedDeadClicksAutocapture(){return this._lazyLoadedDeadClicksAutocapture}constructor(e,t,i){this.instance=e,this.isEnabled=t,this.onCapture=i,this.startIfEnabled()}onRemoteConfig(e){this.instance.persistence&&this.instance.persistence.register({[de]:null==e?void 0:e.captureDeadClicks}),this.startIfEnabled()}startIfEnabled(){this.isEnabled(this)&&this.loadScript((()=>{this.start()}))}loadScript(e){var t,i,r;null!==(t=h.__PosthogExtensions__)&&void 0!==t&&t.initDeadClicksAutocapture&&e(),null===(i=h.__PosthogExtensions__)||void 0===i||null===(r=i.loadExternalDependency)||void 0===r||r.call(i,this.instance,"dead-clicks-autocapture",(t=>{t?In.error("failed to load script",t):e()}))}start(){var e;if(o){if(!this._lazyLoadedDeadClicksAutocapture&&null!==(e=h.__PosthogExtensions__)&&void 0!==e&&e.initDeadClicksAutocapture){var t=N(this.instance.config.capture_dead_clicks)?this.instance.config.capture_dead_clicks:{};t.__onCapture=this.onCapture,this._lazyLoadedDeadClicksAutocapture=h.__PosthogExtensions__.initDeadClicksAutocapture(this.instance,t),this._lazyLoadedDeadClicksAutocapture.start(o),In.info("starting...")}}else In.error("`document` not found. Cannot start.")}stop(){this._lazyLoadedDeadClicksAutocapture&&(this._lazyLoadedDeadClicksAutocapture.stop(),this._lazyLoadedDeadClicksAutocapture=void 0,In.info("stopping..."))}}var Rn=K("[Heatmaps]");class $n{constructor(t){var i;ie(this,"rageclicks",new Cn),ie(this,"_enabledServerSide",!1),ie(this,"_initialized",!1),ie(this,"_flushInterval",null),this.instance=t,this._enabledServerSide=!(null===(i=this.instance.persistence)||void 0===i||!i.props[le]),null==e||e.addEventListener("beforeunload",(()=>{this.flush()}))}get flushIntervalMilliseconds(){var e=5e3;return N(this.instance.config.capture_heatmaps)&&this.instance.config.capture_heatmaps.flush_interval_milliseconds&&(e=this.instance.config.capture_heatmaps.flush_interval_milliseconds),e}get isEnabled(){return B(this.instance.config.capture_heatmaps)?B(this.instance.config.enable_heatmaps)?this._enabledServerSide:this.instance.config.enable_heatmaps:!1!==this.instance.config.capture_heatmaps}startIfEnabled(){if(this.isEnabled){if(this._initialized)return;Rn.info("starting..."),this._setupListeners(),this._flushInterval=setInterval(this.flush.bind(this),this.flushIntervalMilliseconds)}else{var e,t;clearInterval(null!==(e=this._flushInterval)&&void 0!==e?e:void 0),null===(t=this.deadClicksCapture)||void 0===t||t.stop(),this.getAndClearBuffer()}}onRemoteConfig(e){var t=!!e.heatmaps;this.instance.persistence&&this.instance.persistence.register({[le]:t}),this._enabledServerSide=t,this.startIfEnabled()}getAndClearBuffer(){var e=this.buffer;return this.buffer=void 0,e}_onDeadClick(e){this._onClick(e.originalEvent,"deadclick")}_setupListeners(){e&&o&&(I(o,"click",(t=>this._onClick(t||(null==e?void 0:e.event))),!1,!0),I(o,"mousemove",(t=>this._onMouseMove(t||(null==e?void 0:e.event))),!1,!0),this.deadClicksCapture=new Fn(this.instance,Pn,this._onDeadClick.bind(this)),this.deadClicksCapture.startIfEnabled(),this._initialized=!0)}_getProperties(t,i){var r=this.instance.scrollManager.scrollY(),s=this.instance.scrollManager.scrollX(),n=this.instance.scrollManager.scrollElement(),o=function(t,i,r){for(var s=t;s&&xi(s)&&!Ci(s,"body");){if(s===r)return!1;if(b(i,null==e?void 0:e.getComputedStyle(s).position))return!0;s=Ai(s)}return!1}(Li(t),["fixed","sticky"],n);return{x:t.clientX+(o?0:s),y:t.clientY+(o?0:r),target_fixed:o,type:i}}_onClick(e){var t,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"click";if(!ki(e.target)){var r=this._getProperties(e,i);null!==(t=this.rageclicks)&&void 0!==t&&t.isRageClick(e.clientX,e.clientY,(new Date).getTime())&&this._capture(te(te({},r),{},{type:"rageclick"})),this._capture(r)}}_onMouseMove(e){ki(e.target)||(clearTimeout(this._mouseMoveTimeout),this._mouseMoveTimeout=setTimeout((()=>{this._capture(this._getProperties(e,"mousemove"))}),500))}_capture(t){if(e){var i=e.location.href;this.buffer=this.buffer||{},this.buffer[i]||(this.buffer[i]=[]),this.buffer[i].push(t)}}flush(){this.buffer&&!q(this.buffer)&&this.instance.capture("$$heatmap",{$heatmap_data:this.getAndClearBuffer()})}}class On{constructor(e){ie(this,"_updateScrollData",(()=>{var e,t,i,r;this.context||(this.context={});var s=this.scrollElement(),n=this.scrollY(),o=s?Math.max(0,s.scrollHeight-s.clientHeight):0,a=n+((null==s?void 0:s.clientHeight)||0),l=(null==s?void 0:s.scrollHeight)||0;this.context.lastScrollY=Math.ceil(n),this.context.maxScrollY=Math.max(n,null!==(e=this.context.maxScrollY)&&void 0!==e?e:0),this.context.maxScrollHeight=Math.max(o,null!==(t=this.context.maxScrollHeight)&&void 0!==t?t:0),this.context.lastContentY=a,this.context.maxContentY=Math.max(a,null!==(i=this.context.maxContentY)&&void 0!==i?i:0),this.context.maxContentHeight=Math.max(l,null!==(r=this.context.maxContentHeight)&&void 0!==r?r:0)})),this.instance=e}getContext(){return this.context}resetContext(){var e=this.context;return setTimeout(this._updateScrollData,0),e}startMeasuringScrollPosition(){null==e||e.addEventListener("scroll",this._updateScrollData,!0),null==e||e.addEventListener("scrollend",this._updateScrollData,!0),null==e||e.addEventListener("resize",this._updateScrollData)}scrollElement(){if(!this.instance.config.scroll_root_selector)return null==e?void 0:e.document.documentElement;var t=A(this.instance.config.scroll_root_selector)?this.instance.config.scroll_root_selector:[this.instance.config.scroll_root_selector];for(var i of t){var r=null==e?void 0:e.document.querySelector(i);if(r)return r}}scrollY(){if(this.instance.config.scroll_root_selector){var t=this.scrollElement();return t&&t.scrollTop||0}return e&&(e.scrollY||e.pageYOffset||e.document.documentElement.scrollTop)||0}scrollX(){if(this.instance.config.scroll_root_selector){var t=this.scrollElement();return t&&t.scrollLeft||0}return e&&(e.scrollX||e.pageXOffset||e.document.documentElement.scrollLeft)||0}}var Ln=K("[AutoCapture]");function Mn(e,t){return t.length>e?t.slice(0,e)+"...":t}function An(e){if(e.previousElementSibling)return e.previousElementSibling;var t=e;do{t=t.previousSibling}while(t&&!xi(t));return t}function Dn(e,t,i,r){var s=e.tagName.toLowerCase(),n={tag_name:s};Mi.indexOf(s)>-1&&!i&&("a"===s.toLowerCase()||"button"===s.toLowerCase()?n.$el_text=Mn(1024,Vi(e)):n.$el_text=Mn(1024,Oi(e)));var o=Ri(e);o.length>0&&(n.classes=o.filter((function(e){return""!==e}))),f(e.attributes,(function(i){var s;if((!qi(e)||-1!==["name","id","class","aria-label"].indexOf(i.name))&&((null==r||!r.includes(i.name))&&!t&&Gi(i.value)&&(s=i.name,!H(s)||"_ngcontent"!==s.substring(0,10)&&"_nghost"!==s.substring(0,7)))){var o=i.value;"class"===i.name&&(o=Ti(o).join(" ")),n["attr__"+i.name]=Mn(1024,o)}}));for(var a=1,l=1,u=e;u=An(u);)a++,u.tagName===e.tagName&&l++;return n.nth_child=a,n.nth_of_type=l,n}function Nn(t,i){for(var r,s,{e:n,maskAllElementAttributes:o,maskAllText:a,elementAttributeIgnoreList:l,elementsChainAsString:u}=i,c=[t],d=t;d.parentNode&&!Ci(d,"body");)Pi(d.parentNode)?(c.push(d.parentNode.host),d=d.parentNode.host):(c.push(d.parentNode),d=d.parentNode);var h,_=[],p={},v=!1,g=!1;if(f(c,(e=>{var t=Ni(e);"a"===e.tagName.toLowerCase()&&(v=e.getAttribute("href"),v=t&&v&&Gi(v)&&v),b(Ri(e),"ph-no-capture")&&(g=!0),_.push(Dn(e,o,a,l));var i=function(e){if(!Ni(e))return{};var t={};return f(e.attributes,(function(e){if(e.name&&0===e.name.indexOf("data-ph-capture-attribute")){var i=e.name.replace("data-ph-capture-attribute-",""),r=e.value;i&&r&&Gi(r)&&(t[i]=r)}})),t}(e);m(p,i)})),g)return{props:{},explicitNoCapture:g};if(a||("a"===t.tagName.toLowerCase()||"button"===t.tagName.toLowerCase()?_[0].$el_text=Vi(t):_[0].$el_text=Oi(t)),v){var y,w;_[0].attr__href=v;var S=null===(y=vt(v))||void 0===y?void 0:y.host,E=null==e||null===(w=e.location)||void 0===w?void 0:w.host;S&&E&&S!==E&&(h=v)}return{props:m({$event_type:n.type,$ce_version:1},u?{}:{$elements:_},{$elements_chain:Ji(_)},null!==(r=_[0])&&void 0!==r&&r.$el_text?{$el_text:null===(s=_[0])||void 0===s?void 0:s.$el_text}:{},h&&"click"===n.type?{$external_click_url:h}:{},p)}}class qn{constructor(e){ie(this,"_initialized",!1),ie(this,"_isDisabledServerSide",null),ie(this,"rageclicks",new Cn),ie(this,"_elementsChainAsString",!1),this.instance=e,this._elementSelectors=null}get config(){var e,t,i=N(this.instance.config.autocapture)?this.instance.config.autocapture:{};return i.url_allowlist=null===(e=i.url_allowlist)||void 0===e?void 0:e.map((e=>new RegExp(e))),i.url_ignorelist=null===(t=i.url_ignorelist)||void 0===t?void 0:t.map((e=>new RegExp(e))),i}_addDomEventHandlers(){if(this.isBrowserSupported()){if(e&&o){var t=t=>{t=t||(null==e?void 0:e.event);try{this._captureEvent(t)}catch(e){Ln.error("Failed to capture event",e)}},i=t=>{t=t||(null==e?void 0:e.event),this._captureEvent(t,F)};I(o,"submit",t,!1,!0),I(o,"change",t,!1,!0),I(o,"click",t,!1,!0),this.config.capture_copied_text&&(I(o,"copy",i,!1,!0),I(o,"cut",i,!1,!0))}}else Ln.info("Disabling Automatic Event Collection because this browser is not supported")}startIfEnabled(){this.isEnabled&&!this._initialized&&(this._addDomEventHandlers(),this._initialized=!0)}onRemoteConfig(e){e.elementsChainAsString&&(this._elementsChainAsString=e.elementsChainAsString),this.instance.persistence&&this.instance.persistence.register({[ae]:!!e.autocapture_opt_out}),this._isDisabledServerSide=!!e.autocapture_opt_out,this.startIfEnabled()}setElementSelectors(e){this._elementSelectors=e}getElementSelectors(e){var t,i=[];return null===(t=this._elementSelectors)||void 0===t||t.forEach((t=>{var r=null==o?void 0:o.querySelectorAll(t);null==r||r.forEach((r=>{e===r&&i.push(t)}))})),i}get isEnabled(){var e,t,i=null===(e=this.instance.persistence)||void 0===e?void 0:e.props[ae],r=this._isDisabledServerSide;if(j(r)&&!G(i)&&!this.instance.config.advanced_disable_decide)return!1;var s=null!==(t=this._isDisabledServerSide)&&void 0!==t?t:!!i;return!!this.instance.config.autocapture&&!s}_captureEvent(t){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"$autocapture";if(this.isEnabled){var r,s=Li(t);if(Ii(s)&&(s=s.parentNode||null),"$autocapture"===i&&"click"===t.type&&t instanceof MouseEvent)this.instance.config.rageclick&&null!==(r=this.rageclicks)&&void 0!==r&&r.isRageClick(t.clientX,t.clientY,(new Date).getTime())&&this._captureEvent(t,"$rageclick");var n=i===F;if(s&&Di(s,t,this.config,n,n?["copy","cut"]:void 0)){var{props:o,explicitNoCapture:a}=Nn(s,{e:t,maskAllElementAttributes:this.instance.config.mask_all_element_attributes,maskAllText:this.instance.config.mask_all_text,elementAttributeIgnoreList:this.config.element_attribute_ignorelist,elementsChainAsString:this._elementsChainAsString});if(a)return!1;var l=this.getElementSelectors(s);if(l&&l.length>0&&(o.$element_selectors=l),i===F){var u,c=$i(null==e||null===(u=e.getSelection())||void 0===u?void 0:u.toString()),d=t.type||"clipboard";if(!c)return!1;o.$selected_content=c,o.$copy_type=d}return this.instance.capture(i,o),!0}}}isBrowserSupported(){return D(null==o?void 0:o.querySelectorAll)}}var Bn=K("[TracingHeaders]");class Hn{constructor(e){ie(this,"_restoreXHRPatch",void 0),ie(this,"_restoreFetchPatch",void 0),ie(this,"_startCapturing",(()=>{var e,t,i,r;B(this._restoreXHRPatch)&&(null===(e=h.__PosthogExtensions__)||void 0===e||null===(t=e.tracingHeadersPatchFns)||void 0===t||t._patchXHR(this.instance.sessionManager));B(this._restoreFetchPatch)&&(null===(i=h.__PosthogExtensions__)||void 0===i||null===(r=i.tracingHeadersPatchFns)||void 0===r||r._patchFetch(this.instance.sessionManager))})),this.instance=e}_loadScript(e){var t,i,r;null!==(t=h.__PosthogExtensions__)&&void 0!==t&&t.tracingHeadersPatchFns&&e(),null===(i=h.__PosthogExtensions__)||void 0===i||null===(r=i.loadExternalDependency)||void 0===r||r.call(i,this.instance,"tracing-headers",(t=>{if(t)return Bn.error("failed to load script",t);e()}))}startIfEnabledOrStop(){var e,t;this.instance.config.__add_tracing_headers?this._loadScript(this._startCapturing):(null===(e=this._restoreXHRPatch)||void 0===e||e.call(this),null===(t=this._restoreFetchPatch)||void 0===t||t.call(this),this._restoreXHRPatch=void 0,this._restoreFetchPatch=void 0)}}var Un;!function(e){e[e.PENDING=-1]="PENDING",e[e.DENIED=0]="DENIED",e[e.GRANTED=1]="GRANTED"}(Un||(Un={}));class jn{constructor(e){this.instance=e}get config(){return this.instance.config}get consent(){return this.getDnt()?Un.DENIED:this.storedConsent}isOptedOut(){return this.consent===Un.DENIED||this.consent===Un.PENDING&&this.config.opt_out_capturing_by_default}isOptedIn(){return!this.isOptedOut()}optInOut(e){this.storage.set(this.storageKey,e?1:0,this.config.cookie_expiration,this.config.cross_subdomain_cookie,this.config.secure_cookie)}reset(){this.storage.remove(this.storageKey,this.config.cross_subdomain_cookie)}get storageKey(){var{token:e,opt_out_capturing_cookie_prefix:t}=this.instance.config;return(t||"__ph_opt_in_out_")+e}get storedConsent(){var e=this.storage.get(this.storageKey);return"1"===e?Un.GRANTED:"0"===e?Un.DENIED:Un.PENDING}get storage(){if(!this._storage){var e=this.config.opt_out_capturing_persistence_type;this._storage="localStorage"===e?at:nt;var t="localStorage"===e?nt:at;t.get(this.storageKey)&&(this._storage.get(this.storageKey)||this.optInOut("1"===t.get(this.storageKey)),t.remove(this.storageKey,this.config.cross_subdomain_cookie))}return this._storage}getDnt(){return!!this.config.respect_dnt&&!!P([null==n?void 0:n.doNotTrack,null==n?void 0:n.msDoNotTrack,h.doNotTrack],(e=>b([!0,1,"1","yes"],e)))}}var zn=K("[ExceptionAutocapture]");class Wn{constructor(t){var i;ie(this,"originalOnUnhandledRejectionHandler",void 0),ie(this,"startCapturing",(()=>{var t,i,r,s;if(e&&this.isEnabled&&!this.hasHandlers&&!this.isCapturing){var n=null===(t=h.__PosthogExtensions__)||void 0===t||null===(i=t.errorWrappingFunctions)||void 0===i?void 0:i.wrapOnError,o=null===(r=h.__PosthogExtensions__)||void 0===r||null===(s=r.errorWrappingFunctions)||void 0===s?void 0:s.wrapUnhandledRejection;if(n&&o)try{this.unwrapOnError=n(this.captureException.bind(this)),this.unwrapUnhandledRejection=o(this.captureException.bind(this))}catch(e){zn.error("failed to start",e),this.stopCapturing()}else zn.error("failed to load error wrapping functions - cannot start")}})),this.instance=t,this.remoteEnabled=!(null===(i=this.instance.persistence)||void 0===i||!i.props[ue]),this.startIfEnabled()}get isEnabled(){var e;return null!==(e=this.remoteEnabled)&&void 0!==e&&e}get isCapturing(){var t;return!(null==e||null===(t=e.onerror)||void 0===t||!t.__POSTHOG_INSTRUMENTED__)}get hasHandlers(){return this.originalOnUnhandledRejectionHandler||this.unwrapOnError}startIfEnabled(){this.isEnabled&&!this.isCapturing&&(zn.info("enabled, starting..."),this.loadScript(this.startCapturing))}loadScript(e){var t,i;this.hasHandlers&&e(),null===(t=h.__PosthogExtensions__)||void 0===t||null===(i=t.loadExternalDependency)||void 0===i||i.call(t,this.instance,"exception-autocapture",(t=>{if(t)return zn.error("failed to load script",t);e()}))}stopCapturing(){var e,t;null===(e=this.unwrapOnError)||void 0===e||e.call(this),null===(t=this.unwrapUnhandledRejection)||void 0===t||t.call(this)}onRemoteConfig(e){var t=e.autocaptureExceptions;this.remoteEnabled=!!t||!1,this.instance.persistence&&this.instance.persistence.register({[ue]:this.remoteEnabled}),this.startIfEnabled()}captureException(e){var t=this.instance.requestRouter.endpointFor("ui");e.$exception_personURL="".concat(t,"/project/").concat(this.instance.config.token,"/person/").concat(this.instance.get_distinct_id()),this.instance.exceptions.sendExceptionEvent(e)}}var Gn=K("[Web Vitals]"),Vn=9e5;class Qn{constructor(e){var t;ie(this,"_enabledServerSide",!1),ie(this,"_initialized",!1),ie(this,"buffer",{url:void 0,metrics:[],firstMetricTimestamp:void 0}),ie(this,"_flushToCapture",(()=>{clearTimeout(this._delayedFlushTimer),0!==this.buffer.metrics.length&&(this.instance.capture("$web_vitals",this.buffer.metrics.reduce(((e,t)=>te(te({},e),{},{["$web_vitals_".concat(t.name,"_event")]:te({},t),["$web_vitals_".concat(t.name,"_value")]:t.value})),{})),this.buffer={url:void 0,metrics:[],firstMetricTimestamp:void 0})})),ie(this,"_addToBuffer",(e=>{var t,i=null===(t=this.instance.sessionManager)||void 0===t?void 0:t.checkAndGetSessionAndWindowId(!0);if(B(i))Gn.error("Could not read session ID. Dropping metrics!");else{this.buffer=this.buffer||{url:void 0,metrics:[],firstMetricTimestamp:void 0};var r=this._currentURL();if(!B(r))if(z(null==e?void 0:e.name)||z(null==e?void 0:e.value))Gn.error("Invalid metric received",e);else if(this._maxAllowedValue&&e.value>=this._maxAllowedValue)Gn.error("Ignoring metric with value >= "+this._maxAllowedValue,e);else this.buffer.url!==r&&(this._flushToCapture(),this._delayedFlushTimer=setTimeout(this._flushToCapture,this.flushToCaptureTimeoutMs)),B(this.buffer.url)&&(this.buffer.url=r),this.buffer.firstMetricTimestamp=B(this.buffer.firstMetricTimestamp)?Date.now():this.buffer.firstMetricTimestamp,e.attribution&&e.attribution.interactionTargetElement&&(e.attribution.interactionTargetElement=void 0),this.buffer.metrics.push(te(te({},e),{},{$current_url:r,$session_id:i.sessionId,$window_id:i.windowId,timestamp:Date.now()})),this.buffer.metrics.length===this.allowedMetrics.length&&this._flushToCapture()}})),ie(this,"_startCapturing",(()=>{var e,t,i,r,s=h.__PosthogExtensions__;B(s)||B(s.postHogWebVitalsCallbacks)||({onLCP:e,onCLS:t,onFCP:i,onINP:r}=s.postHogWebVitalsCallbacks),e&&t&&i&&r?(this.allowedMetrics.indexOf("LCP")>-1&&e(this._addToBuffer.bind(this)),this.allowedMetrics.indexOf("CLS")>-1&&t(this._addToBuffer.bind(this)),this.allowedMetrics.indexOf("FCP")>-1&&i(this._addToBuffer.bind(this)),this.allowedMetrics.indexOf("INP")>-1&&r(this._addToBuffer.bind(this)),this._initialized=!0):Gn.error("web vitals callbacks not loaded - not starting")})),this.instance=e,this._enabledServerSide=!(null===(t=this.instance.persistence)||void 0===t||!t.props[ce]),this.startIfEnabled()}get allowedMetrics(){var e,t,i=N(this.instance.config.capture_performance)?null===(e=this.instance.config.capture_performance)||void 0===e?void 0:e.web_vitals_allowed_metrics:void 0;return B(i)?(null===(t=this.instance.persistence)||void 0===t?void 0:t.props[he])||["CLS","FCP","INP","LCP"]:i}get flushToCaptureTimeoutMs(){return(N(this.instance.config.capture_performance)?this.instance.config.capture_performance.web_vitals_delayed_flush_ms:void 0)||5e3}get _maxAllowedValue(){var e=N(this.instance.config.capture_performance)&&W(this.instance.config.capture_performance.__web_vitals_max_value)?this.instance.config.capture_performance.__web_vitals_max_value:Vn;return 0<e&&e<=6e4?Vn:e}get isEnabled(){var e=N(this.instance.config.capture_performance)?this.instance.config.capture_performance.web_vitals:void 0;return G(e)?e:this._enabledServerSide}startIfEnabled(){this.isEnabled&&!this._initialized&&(Gn.info("enabled, starting..."),this.loadScript(this._startCapturing))}onRemoteConfig(e){var t=N(e.capturePerformance)&&!!e.capturePerformance.web_vitals,i=N(e.capturePerformance)?e.capturePerformance.web_vitals_allowed_metrics:void 0;this.instance.persistence&&(this.instance.persistence.register({[ce]:t}),this.instance.persistence.register({[he]:i})),this._enabledServerSide=t,this.startIfEnabled()}loadScript(e){var t,i,r;null!==(t=h.__PosthogExtensions__)&&void 0!==t&&t.postHogWebVitalsCallbacks&&e(),null===(i=h.__PosthogExtensions__)||void 0===i||null===(r=i.loadExternalDependency)||void 0===r||r.call(i,this.instance,"web-vitals",(t=>{t?Gn.error("failed to load script",t):e()}))}_currentURL(){var t=e?e.location.href:void 0;return t||Gn.error("Could not determine current URL"),t}}var Jn={icontains:(t,i)=>!!e&&i.href.toLowerCase().indexOf(t.toLowerCase())>-1,not_icontains:(t,i)=>!!e&&-1===i.href.toLowerCase().indexOf(t.toLowerCase()),regex:(t,i)=>!!e&&gt(i.href,t),not_regex:(t,i)=>!!e&&!gt(i.href,t),exact:(e,t)=>t.href===e,is_not:(e,t)=>t.href!==e};class Yn{constructor(e){var t=this;ie(this,"getWebExperimentsAndEvaluateDisplayLogic",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];t.getWebExperiments((e=>{Yn.logInfo("retrieved web experiments from the server"),t._flagToExperiments=new Map,e.forEach((e=>{if(e.feature_flag_key){var i;if(t._flagToExperiments)Yn.logInfo("setting flag key ",e.feature_flag_key," to web experiment ",e),null===(i=t._flagToExperiments)||void 0===i||i.set(e.feature_flag_key,e);var r=t.instance.getFeatureFlag(e.feature_flag_key);H(r)&&e.variants[r]&&t.applyTransforms(e.name,r,e.variants[r].transforms)}else if(e.variants)for(var s in e.variants){var n=e.variants[s];Yn.matchesTestVariant(n)&&t.applyTransforms(e.name,s,n.transforms)}}))}),e)})),this.instance=e,this.instance.onFeatureFlags((e=>{this.onFeatureFlags(e)}))}onFeatureFlags(e){if(this._is_bot())Yn.logInfo("Refusing to render web experiment since the viewer is a likely bot");else if(!this.instance.config.disable_web_experiments){if(z(this._flagToExperiments))return this._flagToExperiments=new Map,this.loadIfEnabled(),void this.previewWebExperiment();Yn.logInfo("applying feature flags",e),e.forEach((e=>{var t;if(this._flagToExperiments&&null!==(t=this._flagToExperiments)&&void 0!==t&&t.has(e)){var i,r=this.instance.getFeatureFlag(e),s=null===(i=this._flagToExperiments)||void 0===i?void 0:i.get(e);r&&null!=s&&s.variants[r]&&this.applyTransforms(s.name,r,s.variants[r].transforms)}}))}}previewWebExperiment(){var e=Yn.getWindowLocation();if(null!=e&&e.search){var t=mt(null==e?void 0:e.search,"__experiment_id"),i=mt(null==e?void 0:e.search,"__experiment_variant");t&&i&&(Yn.logInfo("previewing web experiments ".concat(t," && ").concat(i)),this.getWebExperiments((e=>{this.showPreviewWebExperiment(parseInt(t),i,e)}),!1,!0))}}loadIfEnabled(){this.instance.config.disable_web_experiments||this.getWebExperimentsAndEvaluateDisplayLogic()}getWebExperiments(e,t,i){if(this.instance.config.disable_web_experiments&&!i)return e([]);var r=this.instance.get_property("$web_experiments");if(r&&!t)return e(r);this.instance._send_request({url:this.instance.requestRouter.endpointFor("api","/api/web_experiments/?token=".concat(this.instance.config.token)),method:"GET",transport:"fetch",callback:t=>{if(200!==t.statusCode||!t.json)return e([]);var i=t.json.experiments||[];return e(i)}})}showPreviewWebExperiment(e,t,i){var r=i.filter((t=>t.id===e));r&&r.length>0&&(Yn.logInfo("Previewing web experiment [".concat(r[0].name,"] with variant [").concat(t,"]")),this.applyTransforms(r[0].name,t,r[0].variants[t].transforms,!0))}static matchesTestVariant(e){return!z(e.conditions)&&(Yn.matchUrlConditions(e)&&Yn.matchUTMConditions(e))}static matchUrlConditions(e){var t;if(z(e.conditions)||z(null===(t=e.conditions)||void 0===t?void 0:t.url))return!0;var i,r,s,n=Yn.getWindowLocation();return!!n&&(null===(i=e.conditions)||void 0===i||!i.url||Jn[null!==(r=null===(s=e.conditions)||void 0===s?void 0:s.urlMatchType)&&void 0!==r?r:"icontains"](e.conditions.url,n))}static getWindowLocation(){return null==e?void 0:e.location}static matchUTMConditions(e){var t;if(z(e.conditions)||z(null===(t=e.conditions)||void 0===t?void 0:t.utm))return!0;var i=fi.campaignParams();if(i.utm_source){var r,s,n,o,a,l,u,c,d,h,_,p,v,g,f,m,b=null===(r=e.conditions)||void 0===r||null===(s=r.utm)||void 0===s||!s.utm_campaign||(null===(n=e.conditions)||void 0===n||null===(o=n.utm)||void 0===o?void 0:o.utm_campaign)==i.utm_campaign,y=null===(a=e.conditions)||void 0===a||null===(l=a.utm)||void 0===l||!l.utm_source||(null===(u=e.conditions)||void 0===u||null===(c=u.utm)||void 0===c?void 0:c.utm_source)==i.utm_source,w=null===(d=e.conditions)||void 0===d||null===(h=d.utm)||void 0===h||!h.utm_medium||(null===(_=e.conditions)||void 0===_||null===(p=_.utm)||void 0===p?void 0:p.utm_medium)==i.utm_medium,S=null===(v=e.conditions)||void 0===v||null===(g=v.utm)||void 0===g||!g.utm_term||(null===(f=e.conditions)||void 0===f||null===(m=f.utm)||void 0===m?void 0:m.utm_term)==i.utm_term;return b&&w&&S&&y}return!1}static logInfo(e){for(var t=arguments.length,i=new Array(t>1?t-1:0),r=1;r<t;r++)i[r-1]=arguments[r];Y.info("[WebExperiments] ".concat(e),i)}applyTransforms(e,t,i,r){var s;this._is_bot()?Yn.logInfo("Refusing to render web experiment since the viewer is a likely bot"):"control"!==t?i.forEach((i=>{if(i.selector){var s;Yn.logInfo("applying transform of variant ".concat(t," for experiment ").concat(e," "),i);var n,o=0,a=null===(s=document)||void 0===s?void 0:s.querySelectorAll(i.selector);if(null==a||a.forEach((e=>{var t=e;o+=1,i.attributes&&i.attributes.forEach((e=>{switch(e.name){case"text":t.innerText=e.value;break;case"html":t.innerHTML=e.value;break;case"cssClass":t.className=e.value;break;default:t.setAttribute(e.name,e.value)}})),i.text&&(t.innerText=i.text),i.html&&(t.parentElement?t.parentElement.innerHTML=i.html:t.innerHTML=i.html),i.css&&t.setAttribute("style",i.css)})),this.instance&&this.instance.capture)this.instance.capture("$web_experiment_applied",{$web_experiment_name:e,$web_experiment_variant:t,$web_experiment_preview:r,$web_experiment_document_url:null===(n=Yn.getWindowLocation())||void 0===n?void 0:n.href,$web_experiment_elements_modified:o})}})):(Yn.logInfo("Control variants leave the page unmodified."),this.instance&&this.instance.capture&&this.instance.capture("$web_experiment_applied",{$web_experiment_name:e,$web_experiment_preview:r,$web_experiment_variant:t,$web_experiment_document_url:null===(s=Yn.getWindowLocation())||void 0===s?void 0:s.href,$web_experiment_elements_modified:0}))}_is_bot(){return n&&this.instance?xn(n,this.instance.config.custom_blocked_useragents):void 0}}class Kn{constructor(e){this.instance=e}sendExceptionEvent(e){this.instance.capture("$exception",e,{_noTruncate:!0,_batchKey:"exceptionEvent"})}}var Xn=["$set_once","$set"],Zn=K("[SiteApps]");class eo{constructor(e){this.instance=e,this.bufferedInvocations=[],this.apps={}}get isEnabled(){return!!this.instance.config.opt_in_site_apps}eventCollector(e,t){if(t){var i=this.globalsForEvent(t);this.bufferedInvocations.push(i),this.bufferedInvocations.length>1e3&&(this.bufferedInvocations=this.bufferedInvocations.slice(10))}}init(){if(this.isEnabled){var e=this.instance._addCaptureHook(this.eventCollector.bind(this));this.stopBuffering=()=>{e(),this.bufferedInvocations=[],this.stopBuffering=void 0}}}globalsForEvent(e){var t,i,r,s,n,o,a;if(!e)throw new Error("Event payload is required");var l={},u=this.instance.get_property("$groups")||[],c=this.instance.get_property("$stored_group_properties")||{};for(var[d,h]of Object.entries(c))l[d]={id:u[d],type:d,properties:h};var{$set_once:_,$set:p}=e;return{event:te(te({},re(e,Xn)),{},{properties:te(te(te({},e.properties),p?{$set:te(te({},null!==(t=null===(i=e.properties)||void 0===i?void 0:i.$set)&&void 0!==t?t:{}),p)}:{}),_?{$set_once:te(te({},null!==(r=null===(s=e.properties)||void 0===s?void 0:s.$set_once)&&void 0!==r?r:{}),_)}:{}),elements_chain:null!==(n=null===(o=e.properties)||void 0===o?void 0:o.$elements_chain)&&void 0!==n?n:"",distinct_id:null===(a=e.properties)||void 0===a?void 0:a.distinct_id}),person:{properties:this.instance.get_property("$stored_person_properties")},groups:l}}setupSiteApp(e){var t={id:e.id,loaded:!1,errored:!1};this.apps[e.id]=t;var i=i=>{var r;for(var s of(this.apps[e.id].errored=!i,this.apps[e.id].loaded=!0,Zn.info("Site app with id ".concat(e.id," ").concat(i?"loaded":"errored")),i&&this.bufferedInvocations.length&&(Zn.info("Processing ".concat(this.bufferedInvocations.length," events for site app with id ").concat(e.id)),this.bufferedInvocations.forEach((e=>{var i;return null===(i=t.processEvent)||void 0===i?void 0:i.call(t,e)}))),Object.values(this.apps)))if(!s.loaded)return;null===(r=this.stopBuffering)||void 0===r||r.call(this)};try{var{processEvent:r}=e.init({posthog:this.instance,callback:e=>{i(e)}});r&&(t.processEvent=r)}catch(t){Zn.error("Error while initializing PostHog app with config id ".concat(e.id),t),i(!1)}}onCapturedEvent(e){if(0!==Object.keys(this.apps).length){var t=this.globalsForEvent(e);for(var i of Object.values(this.apps))try{var r;null===(r=i.processEvent)||void 0===r||r.call(i,t)}catch(t){Zn.error("Error while processing event ".concat(e.event," for site app ").concat(i.id),t)}}}onRemoteConfig(e){var t,i,r=this;if(A(h._POSTHOG_JS_APPS)){if(!this.isEnabled)return void Zn.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');for(var s of h._POSTHOG_JS_APPS)this.setupSiteApp(s);var n;h._POSTHOG_JS_APPS.length?this.instance.on("eventCaptured",(e=>this.onCapturedEvent(e))):null===(n=this.stopBuffering)||void 0===n||n.call(this)}else if(null===(t=this.stopBuffering)||void 0===t||t.call(this),null!==(i=e.siteApps)&&void 0!==i&&i.length)if(this.isEnabled){var o=function(e,t){var i,s;h["__$$ph_site_app_".concat(e)]=r.instance,null===(i=h.__PosthogExtensions__)||void 0===i||null===(s=i.loadSiteApp)||void 0===s||s.call(i,r.instance,t,(t=>{if(t)return Zn.error("Error while initializing PostHog app with config id ".concat(e),t)}))};for(var{id:a,url:l}of e.siteApps)o(a,l)}else Zn.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.')}}var to={},io=()=>{},ro="posthog",so=!us&&-1===(null==d?void 0:d.indexOf("MSIE"))&&-1===(null==d?void 0:d.indexOf("Mozilla")),no=()=>{var t,i,r;return{api_host:"https://us.i.posthog.com",ui_host:null,token:"",autocapture:!0,rageclick:!0,cross_subdomain_cookie:(i=null==o?void 0:o.location,r=null==i?void 0:i.hostname,!!H(r)&&"herokuapp.com"!==r.split(".").slice(-2).join(".")),persistence:"localStorage+cookie",persistence_name:"",loaded:io,store_google:!0,custom_campaign_params:[],custom_blocked_useragents:[],save_referrer:!0,capture_pageview:!0,capture_pageleave:"if_capture_pageview",debug:a&&H(null==a?void 0:a.search)&&-1!==a.search.indexOf("__posthog_debug=true")||!1,verbose:!1,cookie_expiration:365,upgrade:!1,disable_session_recording:!1,disable_persistence:!1,disable_web_experiments:!0,disable_surveys:!1,enable_recording_console_log:void 0,secure_cookie:"https:"===(null==e||null===(t=e.location)||void 0===t?void 0:t.protocol),ip:!0,opt_out_capturing_by_default:!1,opt_out_persistence_by_default:!1,opt_out_useragent_filter:!1,opt_out_capturing_persistence_type:"localStorage",opt_out_capturing_cookie_prefix:null,opt_in_site_apps:!1,property_denylist:[],respect_dnt:!1,sanitize_properties:null,request_headers:{},inapp_protocol:"//",inapp_link_new_window:!1,request_batching:!0,properties_string_max_length:65535,session_recording:{},mask_all_element_attributes:!1,mask_all_text:!1,advanced_disable_decide:!1,advanced_disable_feature_flags:!1,advanced_disable_feature_flags_on_first_load:!1,advanced_disable_toolbar_metrics:!1,feature_flag_request_timeout_ms:3e3,on_request_error:e=>{var t="Bad HTTP status: "+e.statusCode+" "+e.text;Y.error(t)},get_device_id:e=>e,_onCapture:io,capture_performance:void 0,name:"posthog",bootstrap:{},disable_compression:!1,session_idle_timeout_seconds:1800,person_profiles:"identified_only",__add_tracing_headers:!1,before_send:void 0}},oo=e=>{var t={};B(e.process_person)||(t.person_profiles=e.process_person),B(e.xhr_headers)||(t.request_headers=e.xhr_headers),B(e.cookie_name)||(t.persistence_name=e.cookie_name),B(e.disable_cookie)||(t.disable_persistence=e.disable_cookie);var i=m({},t,e);return A(e.property_blacklist)&&(B(e.property_denylist)?i.property_denylist=e.property_blacklist:A(e.property_denylist)?i.property_denylist=[...e.property_blacklist,...e.property_denylist]:Y.error("Invalid value for property_denylist config: "+e.property_denylist)),i};class ao{constructor(){ie(this,"__forceAllowLocalhost",!1)}get _forceAllowLocalhost(){return this.__forceAllowLocalhost}set _forceAllowLocalhost(e){Y.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"),this.__forceAllowLocalhost=e}}class lo{get decideEndpointWasHit(){var e,t;return null!==(e=null===(t=this.featureFlags)||void 0===t?void 0:t.hasLoadedFlags)&&void 0!==e&&e}constructor(){ie(this,"webPerformance",new ao),ie(this,"version",_.LIB_VERSION),ie(this,"_internalEventEmitter",new Rs),this.config=no(),this.SentryIntegration=ks,this.sentryIntegration=e=>function(e,t){var i=Es(e,t);return{name:Ss,processEvent:e=>i(e)}}(this,e),this.__request_queue=[],this.__loaded=!1,this.analyticsDefaultEndpoint="/e/",this._initialPageviewCaptured=!1,this._initialPersonProfilesConfig=null,this.featureFlags=new Ge(this),this.toolbar=new as(this),this.scrollManager=new On(this),this.pageViewManager=new Fs(this),this.surveys=new mn(this),this.experiments=new Yn(this),this.exceptions=new Kn(this),this.rateLimiter=new yn(this),this.requestRouter=new ws(this),this.consent=new jn(this),this.people={set:(e,t,i)=>{var r=H(e)?{[e]:t}:e;this.setPersonProperties(r),null==i||i({})},set_once:(e,t,i)=>{var r=H(e)?{[e]:t}:e;this.setPersonProperties(void 0,r),null==i||i({})}},this.on("eventCaptured",(e=>Y.info('send "'.concat(null==e?void 0:e.event,'"'),e)))}init(e,t,i){if(i&&i!==ro){var r,s=null!==(r=to[i])&&void 0!==r?r:new lo;return s._init(e,t,i),to[i]=s,to[ro][i]=s,s}return this._init(e,t,i)}_init(t){var i,r,s,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=arguments.length>2?arguments[2]:void 0;if(B(t)||U(t))return Y.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"),this;if(this.__loaded)return Y.warn("You have already initialized PostHog! Re-initializing is a no-op"),this;this.__loaded=!0,this.config={},this._triggered_notifs=[],n.person_profiles&&(this._initialPersonProfilesConfig=n.person_profiles),this.set_config(m({},no(),oo(n),{name:o,token:t})),this.config.on_xhr_error&&Y.error("on_xhr_error is deprecated. Use on_request_error instead"),this.compression=n.disable_compression?void 0:exports.Compression.GZipJS,this.persistence=new bi(this.config),this.sessionPersistence="sessionStorage"===this.config.persistence||"memory"===this.config.persistence?this.persistence:new bi(te(te({},this.config),{},{persistence:"sessionStorage"}));var a=te({},this.persistence.props),l=te({},this.sessionPersistence.props);if(this._requestQueue=new ls((e=>this._send_retriable_request(e))),this._retryQueue=new gs(this),this.__request_queue=[],this.config.__preview_experimental_cookieless_mode||(this.sessionManager=new bs(this),this.sessionPropsManager=new Sn(this.sessionManager,this.persistence)),new Hn(this).startIfEnabledOrStop(),this.siteApps=new eo(this),null===(i=this.siteApps)||void 0===i||i.init(),this.config.__preview_experimental_cookieless_mode||(this.sessionRecording=new ts(this),this.sessionRecording.startIfEnabledOrStop()),this.config.disable_scroll_properties||this.scrollManager.startMeasuringScrollPosition(),this.autocapture=new qn(this),this.autocapture.startIfEnabled(),this.surveys.loadIfEnabled(),this.heatmaps=new $n(this),this.heatmaps.startIfEnabled(),this.webVitalsAutocapture=new Qn(this),this.exceptionObserver=new Wn(this),this.exceptionObserver.startIfEnabled(),this.deadClicksAutocapture=new Fn(this,Tn),this.deadClicksAutocapture.startIfEnabled(),_.DEBUG=_.DEBUG||this.config.debug,_.DEBUG&&Y.info("Starting in debug mode",{this:this,config:n,thisC:te({},this.config),p:a,s:l}),this._sync_opt_out_with_persistence(),void 0!==(null===(r=n.bootstrap)||void 0===r?void 0:r.distinctID)){var u,c,d=this.config.get_device_id(Ze()),h=null!==(u=n.bootstrap)&&void 0!==u&&u.isIdentifiedID?d:n.bootstrap.distinctID;this.persistence.set_property(Re,null!==(c=n.bootstrap)&&void 0!==c&&c.isIdentifiedID?"identified":"anonymous"),this.register({distinct_id:n.bootstrap.distinctID,$device_id:h})}if(this._hasBootstrappedFeatureFlags()){var p,v,g=Object.keys((null===(p=n.bootstrap)||void 0===p?void 0:p.featureFlags)||{}).filter((e=>{var t,i;return!(null===(t=n.bootstrap)||void 0===t||null===(i=t.featureFlags)||void 0===i||!i[e])})).reduce(((e,t)=>{var i,r;return e[t]=(null===(i=n.bootstrap)||void 0===i||null===(r=i.featureFlags)||void 0===r?void 0:r[t])||!1,e}),{}),f=Object.keys((null===(v=n.bootstrap)||void 0===v?void 0:v.featureFlagPayloads)||{}).filter((e=>g[e])).reduce(((e,t)=>{var i,r,s,o;null!==(i=n.bootstrap)&&void 0!==i&&null!==(r=i.featureFlagPayloads)&&void 0!==r&&r[t]&&(e[t]=null===(s=n.bootstrap)||void 0===s||null===(o=s.featureFlagPayloads)||void 0===o?void 0:o[t]);return e}),{});this.featureFlags.receivedFeatureFlags({featureFlags:g,featureFlagPayloads:f})}if(this.config.__preview_experimental_cookieless_mode)this.register_once({distinct_id:qe,$device_id:null},"");else if(!this.get_distinct_id()){var b=this.config.get_device_id(Ze());this.register_once({distinct_id:b,$device_id:b},""),this.persistence.set_property(Re,"anonymous")}return null==e||null===(s=e.addEventListener)||void 0===s||s.call(e,"onpagehide"in self?"pagehide":"unload",this._handle_unload.bind(this)),this.toolbar.maybeLoadToolbar(),n.segment?Ts(this,(()=>this._loaded())):this._loaded(),D(this.config._onCapture)&&this.config._onCapture!==io&&(Y.warn("onCapture is deprecated. Please use `before_send` instead"),this.on("eventCaptured",(e=>this.config._onCapture(e.event,e)))),this}_onRemoteConfig(e){var t,i,r,s,n,a,l,u,c;if(!o||!o.body)return Y.info("document not ready yet, trying again in 500 milliseconds..."),void setTimeout((()=>{this._onRemoteConfig(e)}),500);this.compression=void 0,e.supportedCompression&&!this.config.disable_compression&&(this.compression=b(e.supportedCompression,exports.Compression.GZipJS)?exports.Compression.GZipJS:b(e.supportedCompression,exports.Compression.Base64)?exports.Compression.Base64:void 0),null!==(t=e.analytics)&&void 0!==t&&t.endpoint&&(this.analyticsDefaultEndpoint=e.analytics.endpoint),this.set_config({person_profiles:this._initialPersonProfilesConfig?this._initialPersonProfilesConfig:e.defaultIdentifiedOnly?"identified_only":"always"}),null===(i=this.siteApps)||void 0===i||i.onRemoteConfig(e),null===(r=this.sessionRecording)||void 0===r||r.onRemoteConfig(e),null===(s=this.autocapture)||void 0===s||s.onRemoteConfig(e),null===(n=this.heatmaps)||void 0===n||n.onRemoteConfig(e),null===(a=this.surveys)||void 0===a||a.onRemoteConfig(e),null===(l=this.webVitalsAutocapture)||void 0===l||l.onRemoteConfig(e),null===(u=this.exceptionObserver)||void 0===u||u.onRemoteConfig(e),null===(c=this.deadClicksAutocapture)||void 0===c||c.onRemoteConfig(e)}_loaded(){try{this.config.loaded(this)}catch(e){Y.critical("`loaded` function failed",e)}this._start_queue_if_opted_in(),this.config.capture_pageview&&setTimeout((()=>{this.consent.isOptedIn()&&this._captureInitialPageview()}),1),new rs(this).load(),this.featureFlags.decide()}_start_queue_if_opted_in(){var e;this.has_opted_out_capturing()||this.config.request_batching&&(null===(e=this._requestQueue)||void 0===e||e.enable())}_dom_loaded(){this.has_opted_out_capturing()||g(this.__request_queue,(e=>this._send_retriable_request(e))),this.__request_queue=[],this._start_queue_if_opted_in()}_handle_unload(){var e,t;this.config.request_batching?(this._shouldCapturePageleave()&&this.capture("$pageleave"),null===(e=this._requestQueue)||void 0===e||e.unload(),null===(t=this._retryQueue)||void 0===t||t.unload()):this._shouldCapturePageleave()&&this.capture("$pageleave",null,{transport:"sendBeacon"})}_send_request(e){this.__loaded&&(so?this.__request_queue.push(e):this.rateLimiter.isServerRateLimited(e.batchKey)||(e.transport=e.transport||this.config.api_transport,e.url=ds(e.url,{ip:this.config.ip?1:0}),e.headers=te({},this.config.request_headers),e.compression="best-available"===e.compression?this.compression:e.compression,e.fetchOptions=e.fetchOptions||this.config.fetch_options,(e=>{var t,i,r,s=te({},e);s.timeout=s.timeout||6e4,s.url=ds(s.url,{_:(new Date).getTime().toString(),ver:_.LIB_VERSION,compression:s.compression});var n=null!==(t=s.transport)&&void 0!==t?t:"fetch",o=null!==(i=null===(r=P(ps,(e=>e.transport===n)))||void 0===r?void 0:r.method)&&void 0!==i?i:ps[0].method;if(!o)throw new Error("No available transport method");o(s)})(te(te({},e),{},{callback:t=>{var i,r,s;(this.rateLimiter.checkForLimiting(t),t.statusCode>=400)&&(null===(r=(s=this.config).on_request_error)||void 0===r||r.call(s,t));null===(i=e.callback)||void 0===i||i.call(e,t)}}))))}_send_retriable_request(e){this._retryQueue?this._retryQueue.retriableRequest(e):this._send_request(e)}_execute_array(e){var t,i=[],r=[],s=[];g(e,(e=>{e&&(t=e[0],A(t)?s.push(e):D(e)?e.call(this):A(e)&&"alias"===t?i.push(e):A(e)&&-1!==t.indexOf("capture")&&D(this[t])?s.push(e):r.push(e))}));var n=function(e,t){g(e,(function(e){if(A(e[0])){var i=t;f(e,(function(e){i=i[e[0]].apply(i,e.slice(1))}))}else this[e[0]].apply(this,e.slice(1))}),t)};n(i,this),n(r,this),n(s,this)}_hasBootstrappedFeatureFlags(){var e,t;return(null===(e=this.config.bootstrap)||void 0===e?void 0:e.featureFlags)&&Object.keys(null===(t=this.config.bootstrap)||void 0===t?void 0:t.featureFlags).length>0||!1}push(e){this._execute_array([e])}capture(e,t,i){var r;if(this.__loaded&&this.persistence&&this.sessionPersistence&&this._requestQueue){if(!this.consent.isOptedOut())if(!B(e)&&H(e)){if(this.config.opt_out_useragent_filter||!this._is_bot()){var s=null!=i&&i.skip_client_rate_limiting?void 0:this.rateLimiter.clientRateLimitContext();if(null==s||!s.isRateLimited){this.sessionPersistence.update_search_keyword(),this.config.store_google&&this.sessionPersistence.update_campaign_params(),this.config.save_referrer&&this.sessionPersistence.update_referrer_info(),(this.config.store_google||this.config.save_referrer)&&this.persistence.set_initial_person_info();var n=new Date,o=(null==i?void 0:i.timestamp)||n,a={uuid:Ze(),event:e,properties:this._calculate_event_properties(e,t||{},o)};s&&(a.properties.$lib_rate_limit_remaining_tokens=s.remainingTokens),(null==i?void 0:i.$set)&&(a.$set=null==i?void 0:i.$set);var l=this._calculate_set_once_properties(null==i?void 0:i.$set_once);l&&(a.$set_once=l),(a=x(a,null!=i&&i._noTruncate?null:this.config.properties_string_max_length)).timestamp=o,B(null==i?void 0:i.timestamp)||(a.properties.$event_time_override_provided=!0,a.properties.$event_time_override_system_time=n);var u=te(te({},a.properties.$set),a.$set);if(q(u)||this.setPersonPropertiesForFlags(u),!z(this.config.before_send)){var c=this._runBeforeSend(a);if(!c)return;a=c}this._internalEventEmitter.emit("eventCaptured",a);var d={method:"POST",url:null!==(r=null==i?void 0:i._url)&&void 0!==r?r:this.requestRouter.endpointFor("api",this.analyticsDefaultEndpoint),data:a,compression:"best-available",batchKey:null==i?void 0:i._batchKey};return!this.config.request_batching||i&&(null==i||!i._batchKey)||null!=i&&i.send_instantly?this._send_retriable_request(d):this._requestQueue.enqueue(d),a}Y.critical("This capture call is ignored due to client rate limiting.")}}else Y.error("No event name provided to posthog.capture")}else Y.uninitializedWarning("posthog.capture")}_addCaptureHook(e){return this.on("eventCaptured",(t=>e(t.event,t)))}_calculate_event_properties(e,t,i){if(i=i||new Date,!this.persistence||!this.sessionPersistence)return t;var r=this.persistence.remove_event_timer(e),s=te({},t);if(s.token=this.config.token,this.config.__preview_experimental_cookieless_mode&&(s.$cklsh_mode=!0),"$snapshot"===e){var n=te(te({},this.persistence.properties()),this.sessionPersistence.properties());return s.distinct_id=n.distinct_id,(!H(s.distinct_id)&&!W(s.distinct_id)||U(s.distinct_id))&&Y.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"),s}var a=fi.properties();if(this.sessionManager){var{sessionId:l,windowId:u}=this.sessionManager.checkAndGetSessionAndWindowId();s.$session_id=l,s.$window_id=u}if(this.sessionRecording&&(s.$recording_status=this.sessionRecording.status),this.requestRouter.region===fs.CUSTOM&&(s.$lib_custom_api_host=this.config.api_host),this.sessionPropsManager&&this.config.__preview_send_client_session_params&&("$pageview"===e||"$pageleave"===e||"$autocapture"===e)){var c=this.sessionPropsManager.getSessionProps();s=m(s,c)}if(!this.config.disable_scroll_properties){var h={};"$pageview"===e?h=this.pageViewManager.doPageView(i):"$pageleave"===e&&(h=this.pageViewManager.doPageLeave(i)),s=m(s,h)}if("$pageview"===e&&o&&(s.title=o.title),!B(r)){var _=i.getTime()-r;s.$duration=parseFloat((_/1e3).toFixed(3))}d&&this.config.opt_out_useragent_filter&&(s.$browser_type=this._is_bot()?"bot":"browser"),(s=m({},a,this.persistence.properties(),this.sessionPersistence.properties(),s)).$is_identified=this._isIdentified(),A(this.config.property_denylist)?f(this.config.property_denylist,(function(e){delete s[e]})):Y.error("Invalid value for property_denylist config: "+this.config.property_denylist+" or property_blacklist config: "+this.config.property_blacklist);var p=this.config.sanitize_properties;p&&(s=p(s,e));var v=this._hasPersonProcessing();return s.$process_person_profile=v,v&&this._requirePersonProcessing("_calculate_event_properties"),s}_calculate_set_once_properties(e){if(!this.persistence||!this._hasPersonProcessing())return e;var t=m({},this.persistence.get_initial_props(),e||{}),i=this.config.sanitize_properties;return i&&(t=i(t,"$set_once")),q(t)?void 0:t}register(e,t){var i;null===(i=this.persistence)||void 0===i||i.register(e,t)}register_once(e,t,i){var r;null===(r=this.persistence)||void 0===r||r.register_once(e,t,i)}register_for_session(e){var t;null===(t=this.sessionPersistence)||void 0===t||t.register(e)}unregister(e){var t;null===(t=this.persistence)||void 0===t||t.unregister(e)}unregister_for_session(e){var t;null===(t=this.sessionPersistence)||void 0===t||t.unregister(e)}_register_single(e,t){this.register({[e]:t})}getFeatureFlag(e,t){return this.featureFlags.getFeatureFlag(e,t)}getFeatureFlagPayload(e){var t=this.featureFlags.getFeatureFlagPayload(e);try{return JSON.parse(t)}catch(e){return t}}isFeatureEnabled(e,t){return this.featureFlags.isFeatureEnabled(e,t)}reloadFeatureFlags(){this.featureFlags.reloadFeatureFlags()}updateEarlyAccessFeatureEnrollment(e,t){this.featureFlags.updateEarlyAccessFeatureEnrollment(e,t)}getEarlyAccessFeatures(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return this.featureFlags.getEarlyAccessFeatures(e,t)}on(e,t){return this._internalEventEmitter.on(e,t)}onFeatureFlags(e){return this.featureFlags.onFeatureFlags(e)}onSessionId(e){var t,i;return null!==(t=null===(i=this.sessionManager)||void 0===i?void 0:i.onSessionId(e))&&void 0!==t?t:()=>{}}getSurveys(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];this.surveys.getSurveys(e,t)}getActiveMatchingSurveys(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];this.surveys.getActiveMatchingSurveys(e,t)}renderSurvey(e,t){this.surveys.renderSurvey(e,t)}canRenderSurvey(e){this.surveys.canRenderSurvey(e)}getNextSurveyStep(e,t,i){return this.surveys.getNextSurveyStep(e,t,i)}identify(e,t,i){if(!this.__loaded||!this.persistence)return Y.uninitializedWarning("posthog.identify");if(W(e)&&(e=e.toString(),Y.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")),e){if(["distinct_id","distinctid"].includes(e.toLowerCase()))Y.critical('The string "'.concat(e,'" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'));else if(this._requirePersonProcessing("posthog.identify")){var r=this.get_distinct_id();if(this.register({$user_id:e}),!this.get_property("$device_id")){var s=r;this.register_once({$had_persisted_distinct_id:!0,$device_id:s},"")}e!==r&&e!==this.get_property(ne)&&(this.unregister(ne),this.register({distinct_id:e}));var n="anonymous"===(this.persistence.get_property(Re)||"anonymous");e!==r&&n?(this.persistence.set_property(Re,"identified"),this.setPersonPropertiesForFlags(t||{},!1),this.capture("$identify",{distinct_id:e,$anon_distinct_id:r},{$set:t||{},$set_once:i||{}}),this.featureFlags.setAnonymousDistinctId(r)):(t||i)&&this.setPersonProperties(t,i),e!==r&&(this.reloadFeatureFlags(),this.unregister(Fe))}}else Y.error("Unique user id has not been set in posthog.identify")}setPersonProperties(e,t){(e||t)&&this._requirePersonProcessing("posthog.setPersonProperties")&&(this.setPersonPropertiesForFlags(e||{}),this.capture("$set",{$set:e||{},$set_once:t||{}}))}group(e,t,i){if(e&&t){if(this._requirePersonProcessing("posthog.group")){var r=this.getGroups();r[e]!==t&&this.resetGroupPropertiesForFlags(e),this.register({$groups:te(te({},r),{},{[e]:t})}),i&&(this.capture("$groupidentify",{$group_type:e,$group_key:t,$group_set:i}),this.setGroupPropertiesForFlags({[e]:i})),r[e]===t||i||this.reloadFeatureFlags()}}else Y.error("posthog.group requires a group type and group key")}resetGroups(){this.register({$groups:{}}),this.resetGroupPropertiesForFlags(),this.reloadFeatureFlags()}setPersonPropertiesForFlags(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];this.featureFlags.setPersonPropertiesForFlags(e,t)}resetPersonPropertiesForFlags(){this.featureFlags.resetPersonPropertiesForFlags()}setGroupPropertiesForFlags(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];this._requirePersonProcessing("posthog.setGroupPropertiesForFlags")&&this.featureFlags.setGroupPropertiesForFlags(e,t)}resetGroupPropertiesForFlags(e){this.featureFlags.resetGroupPropertiesForFlags(e)}reset(e){var t,i,r,s,n;if(Y.info("reset"),!this.__loaded)return Y.uninitializedWarning("posthog.reset");var o=this.get_property("$device_id");if(this.consent.reset(),null===(t=this.persistence)||void 0===t||t.clear(),null===(i=this.sessionPersistence)||void 0===i||i.clear(),null===(r=this.surveys)||void 0===r||r.reset(),null===(s=this.persistence)||void 0===s||s.set_property(Re,"anonymous"),null===(n=this.sessionManager)||void 0===n||n.resetSessionId(),this.config.__preview_experimental_cookieless_mode)this.register_once({distinct_id:qe,$device_id:null},"");else{var a=this.config.get_device_id(Ze());this.register_once({distinct_id:a,$device_id:e?a:o},"")}}get_distinct_id(){return this.get_property("distinct_id")}getGroups(){return this.get_property("$groups")||{}}get_session_id(){var e,t;return null!==(e=null===(t=this.sessionManager)||void 0===t?void 0:t.checkAndGetSessionAndWindowId(!0).sessionId)&&void 0!==e?e:""}get_session_replay_url(e){if(!this.sessionManager)return"";var{sessionId:t,sessionStartTimestamp:i}=this.sessionManager.checkAndGetSessionAndWindowId(!0),r=this.requestRouter.endpointFor("ui","/project/".concat(this.config.token,"/replay/").concat(t));if(null!=e&&e.withTimestamp&&i){var s,n=null!==(s=e.timestampLookBack)&&void 0!==s?s:10;if(!i)return r;var o=Math.max(Math.floor(((new Date).getTime()-i)/1e3)-n,0);r+="?t=".concat(o)}return r}alias(e,t){return e===this.get_property(se)?(Y.critical("Attempting to create alias for existing People user - aborting."),-2):this._requirePersonProcessing("posthog.alias")?(B(t)&&(t=this.get_distinct_id()),e!==t?(this._register_single(ne,e),this.capture("$create_alias",{alias:e,distinct_id:t})):(Y.warn("alias matches current distinct_id - skipping api call."),this.identify(e),-1)):void 0}set_config(e){var t,i,r,s,n=te({},this.config);N(e)&&(m(this.config,oo(e)),null===(t=this.persistence)||void 0===t||t.update_config(this.config,n),this.sessionPersistence="sessionStorage"===this.config.persistence||"memory"===this.config.persistence?this.persistence:new bi(te(te({},this.config),{},{persistence:"sessionStorage"})),at.is_supported()&&"true"===at.get("ph_debug")&&(this.config.debug=!0),this.config.debug&&(_.DEBUG=!0,Y.info("set_config",{config:e,oldConfig:n,newConfig:te({},this.config)})),null===(i=this.sessionRecording)||void 0===i||i.startIfEnabledOrStop(),null===(r=this.autocapture)||void 0===r||r.startIfEnabled(),null===(s=this.heatmaps)||void 0===s||s.startIfEnabled(),this.surveys.loadIfEnabled(),this._sync_opt_out_with_persistence())}startSessionRecording(e){var t=!0===e,i={sampling:t||!(null==e||!e.sampling),linked_flag:t||!(null==e||!e.linked_flag),url_trigger:t||!(null==e||!e.url_trigger),event_trigger:t||!(null==e||!e.event_trigger)};if(Object.values(i).some(Boolean)){var r,s,n,o,a;if(null===(r=this.sessionManager)||void 0===r||r.checkAndGetSessionAndWindowId(),i.sampling)null===(s=this.sessionRecording)||void 0===s||s.overrideSampling();if(i.linked_flag)null===(n=this.sessionRecording)||void 0===n||n.overrideLinkedFlag();if(i.url_trigger)null===(o=this.sessionRecording)||void 0===o||o.overrideTrigger("url");if(i.event_trigger)null===(a=this.sessionRecording)||void 0===a||a.overrideTrigger("event")}this.set_config({disable_session_recording:!1})}stopSessionRecording(){this.set_config({disable_session_recording:!0})}sessionRecordingStarted(){var e;return!(null===(e=this.sessionRecording)||void 0===e||!e.started)}captureException(e,t){var i,r=new Error("PostHog syntheticException"),s=D(null===(i=h.__PosthogExtensions__)||void 0===i?void 0:i.parseErrorAsProperties)?h.__PosthogExtensions__.parseErrorAsProperties([e.message,void 0,void 0,void 0,e],{syntheticException:r}):te({$exception_level:"error",$exception_list:[{type:e.name,value:e.message,mechanism:{handled:!0,synthetic:!1}}]},t);this.exceptions.sendExceptionEvent(s)}loadToolbar(e){return this.toolbar.loadToolbar(e)}get_property(e){var t;return null===(t=this.persistence)||void 0===t?void 0:t.props[e]}getSessionProperty(e){var t;return null===(t=this.sessionPersistence)||void 0===t?void 0:t.props[e]}toString(){var e,t=null!==(e=this.config.name)&&void 0!==e?e:ro;return t!==ro&&(t=ro+"."+t),t}_isIdentified(){var e,t;return"identified"===(null===(e=this.persistence)||void 0===e?void 0:e.get_property(Re))||"identified"===(null===(t=this.sessionPersistence)||void 0===t?void 0:t.get_property(Re))}_hasPersonProcessing(){var e,t,i,r;return!("never"===this.config.person_profiles||"identified_only"===this.config.person_profiles&&!this._isIdentified()&&q(this.getGroups())&&(null===(e=this.persistence)||void 0===e||null===(t=e.props)||void 0===t||!t[ne])&&(null===(i=this.persistence)||void 0===i||null===(r=i.props)||void 0===r||!r[De]))}_shouldCapturePageleave(){return!0===this.config.capture_pageleave||"if_capture_pageview"===this.config.capture_pageleave&&this.config.capture_pageview}createPersonProfile(){this._hasPersonProcessing()||this._requirePersonProcessing("posthog.createPersonProfile")&&this.setPersonProperties({},{})}_requirePersonProcessing(e){return"never"===this.config.person_profiles?(Y.error(e+' was called, but process_person is set to "never". This call will be ignored.'),!1):(this._register_single(De,!0),!0)}_sync_opt_out_with_persistence(){var e,t,i,r,s=this.consent.isOptedOut(),n=this.config.opt_out_persistence_by_default,o=this.config.disable_persistence||s&&!!n;(null===(e=this.persistence)||void 0===e?void 0:e.disabled)!==o&&(null===(i=this.persistence)||void 0===i||i.set_disabled(o));(null===(t=this.sessionPersistence)||void 0===t?void 0:t.disabled)!==o&&(null===(r=this.sessionPersistence)||void 0===r||r.set_disabled(o))}opt_in_capturing(e){var t;(this.consent.optInOut(!0),this._sync_opt_out_with_persistence(),B(null==e?void 0:e.captureEventName)||null!=e&&e.captureEventName)&&this.capture(null!==(t=null==e?void 0:e.captureEventName)&&void 0!==t?t:"$opt_in",null==e?void 0:e.captureProperties,{send_instantly:!0});this.config.capture_pageview&&this._captureInitialPageview()}opt_out_capturing(){this.consent.optInOut(!1),this._sync_opt_out_with_persistence()}has_opted_in_capturing(){return this.consent.isOptedIn()}has_opted_out_capturing(){return this.consent.isOptedOut()}clear_opt_in_out_capturing(){this.consent.reset(),this._sync_opt_out_with_persistence()}_is_bot(){return n?xn(n,this.config.custom_blocked_useragents):void 0}_captureInitialPageview(){o&&!this._initialPageviewCaptured&&(this._initialPageviewCaptured=!0,this.capture("$pageview",{title:o.title},{send_instantly:!0}))}debug(t){!1===t?(null==e||e.console.log("You've disabled debug mode."),localStorage&&localStorage.removeItem("ph_debug"),this.set_config({debug:!1})):(null==e||e.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."),localStorage&&localStorage.setItem("ph_debug","true"),this.set_config({debug:!0}))}_runBeforeSend(e){if(z(this.config.before_send))return e;var t=A(this.config.before_send)?this.config.before_send:[this.config.before_send],i=e;for(var r of t){if(i=r(i),z(i)){var s="Event '".concat(e.event,"' was rejected in beforeSend function");return Q(e.event)?Y.warn("".concat(s,". This can cause unexpected behavior.")):Y.info(s),null}i.properties&&!q(i.properties)||Y.warn("Event '".concat(e.event,"' has no properties after beforeSend function, this is likely an error."))}return i}}!function(e,t){for(var i=0;i<t.length;i++)e.prototype[t[i]]=S(e.prototype[t[i]])}(lo,["identify"]);var uo,co=(uo=to[ro]=new lo,function(){function t(){t.done||(t.done=!0,so=!1,f(to,(function(e){e._dom_loaded()})))}null!=o&&o.addEventListener&&("complete"===o.readyState?t():o.addEventListener("DOMContentLoaded",t,!1)),e&&I(e,"load",t,!0)}(),uo);exports.COPY_AUTOCAPTURE_EVENT=F,exports.PostHog=lo,exports.default=co,exports.knownUnsafeEditableEvent=R,exports.posthog=co,exports.severityLevels=["fatal","error","warning","log","info","debug"];


},{}],648:[function(require,module,exports){
(function (process){
'use strict';

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


}).call(this,require('_process'))
},{"_process":649}],649:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],650:[function(require,module,exports){
exports.publicEncrypt = require('./publicEncrypt')
exports.privateDecrypt = require('./privateDecrypt')

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}

},{"./privateDecrypt":653,"./publicEncrypt":654}],651:[function(require,module,exports){
var createHash = require('create-hash')
var Buffer = require('safe-buffer').Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}

},{"create-hash":548,"safe-buffer":676}],652:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"buffer":49,"dup":15}],653:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var crt = require('browserify-rsa')
var createHash = require('create-hash')
var withPublic = require('./withPublic')
var Buffer = require('safe-buffer').Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}

},{"./mgf":651,"./withPublic":655,"./xor":656,"bn.js":652,"browserify-rsa":70,"create-hash":548,"parse-asn1":639,"safe-buffer":676}],654:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var randomBytes = require('randombytes')
var createHash = require('create-hash')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var withPublic = require('./withPublic')
var crt = require('browserify-rsa')
var Buffer = require('safe-buffer').Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}

},{"./mgf":651,"./withPublic":655,"./xor":656,"bn.js":652,"browserify-rsa":70,"create-hash":548,"parse-asn1":639,"randombytes":657,"safe-buffer":676}],655:[function(require,module,exports){
var BN = require('bn.js')
var Buffer = require('safe-buffer').Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic

},{"bn.js":652,"safe-buffer":676}],656:[function(require,module,exports){
module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}

},{}],657:[function(require,module,exports){
(function (process,global){
'use strict'

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = require('safe-buffer').Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":649,"safe-buffer":676}],658:[function(require,module,exports){
(function (process,global){
'use strict'

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = require('safe-buffer')
var randombytes = require('randombytes')
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":649,"randombytes":657,"safe-buffer":676}],659:[function(require,module,exports){
module.exports = require('./lib/_stream_duplex.js');

},{"./lib/_stream_duplex.js":660}],660:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};
},{"./_stream_readable":662,"./_stream_writable":664,"core-util-is":545,"inherits":622,"process-nextick-args":648}],661:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;

var Transform = require('./_stream_transform');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":663,"core-util-is":545,"inherits":622}],662:[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = require('isarray');
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var debugUtil = require('util');
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/BufferList');
var destroyImpl = require('./internal/streams/destroy');
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./_stream_duplex":660,"./internal/streams/BufferList":665,"./internal/streams/destroy":666,"./internal/streams/stream":667,"_process":649,"core-util-is":545,"events":584,"inherits":622,"isarray":668,"process-nextick-args":648,"safe-buffer":676,"string_decoder/":669,"util":49}],663:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;

var Duplex = require('./_stream_duplex');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}
},{"./_stream_duplex":660,"core-util-is":545,"inherits":622}],664:[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = require('./internal/streams/destroy');

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./_stream_duplex":660,"./internal/streams/destroy":666,"./internal/streams/stream":667,"_process":649,"core-util-is":545,"inherits":622,"process-nextick-args":648,"safe-buffer":676,"util-deprecate":693}],665:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = require('safe-buffer').Buffer;
var util = require('util');

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}
},{"safe-buffer":676,"util":49}],666:[function(require,module,exports){
'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};
},{"process-nextick-args":648}],667:[function(require,module,exports){
arguments[4][90][0].apply(exports,arguments)
},{"dup":90,"events":584}],668:[function(require,module,exports){
arguments[4][97][0].apply(exports,arguments)
},{"dup":97}],669:[function(require,module,exports){
arguments[4][93][0].apply(exports,arguments)
},{"dup":93,"safe-buffer":676}],670:[function(require,module,exports){
module.exports = require('./readable').PassThrough

},{"./readable":671}],671:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');

},{"./lib/_stream_duplex.js":660,"./lib/_stream_passthrough.js":661,"./lib/_stream_readable.js":662,"./lib/_stream_transform.js":663,"./lib/_stream_writable.js":664}],672:[function(require,module,exports){
module.exports = require('./readable').Transform

},{"./readable":671}],673:[function(require,module,exports){
module.exports = require('./lib/_stream_writable.js');

},{"./lib/_stream_writable.js":664}],674:[function(require,module,exports){
(function (global){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],675:[function(require,module,exports){
'use strict'
var Buffer = require('buffer').Buffer
var inherits = require('inherits')
var HashBase = require('hash-base')

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160

},{"buffer":96,"hash-base":590,"inherits":622}],676:[function(require,module,exports){
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":96}],677:[function(require,module,exports){
(function (process){
/* eslint-disable node/no-deprecated-api */

'use strict'

var buffer = require('buffer')
var Buffer = buffer.Buffer

var safer = {}

var key

for (key in buffer) {
  if (!buffer.hasOwnProperty(key)) continue
  if (key === 'SlowBuffer' || key === 'Buffer') continue
  safer[key] = buffer[key]
}

var Safer = safer.Buffer = {}
for (key in Buffer) {
  if (!Buffer.hasOwnProperty(key)) continue
  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
  Safer[key] = Buffer[key]
}

safer.Buffer.prototype = Buffer.prototype

if (!Safer.from || Safer.from === Uint8Array.from) {
  Safer.from = function (value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
    }
    if (value && typeof value.length === 'undefined') {
      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
    }
    return Buffer(value, encodingOrOffset, length)
  }
}

if (!Safer.alloc) {
  Safer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
    }
    if (size < 0 || size >= 2 * (1 << 30)) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
    var buf = Buffer(size)
    if (!fill || fill.length === 0) {
      buf.fill(0)
    } else if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
    return buf
  }
}

if (!safer.kStringMaxLength) {
  try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
  } catch (e) {
    // we can't determine kStringMaxLength in environments where process.binding
    // is unsupported, so let's not set it
  }
}

if (!safer.constants) {
  safer.constants = {
    MAX_LENGTH: safer.kMaxLength
  }
  if (safer.kStringMaxLength) {
    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
  }
}

module.exports = safer

}).call(this,require('_process'))
},{"_process":649,"buffer":96}],678:[function(require,module,exports){
 /* eslint-env node */
'use strict';

// SDP helpers.
var SDPUtils = {};

// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
SDPUtils.generateIdentifier = function() {
  return Math.random().toString(36).substr(2, 10);
};

// The RTCP CNAME used by all peerconnections from the same JS.
SDPUtils.localCName = SDPUtils.generateIdentifier();

// Splits SDP into lines, dealing with both CRLF and LF.
SDPUtils.splitLines = function(blob) {
  return blob.trim().split('\n').map(function(line) {
    return line.trim();
  });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
SDPUtils.splitSections = function(blob) {
  var parts = blob.split('\nm=');
  return parts.map(function(part, index) {
    return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
  });
};

// Returns lines that start with a certain prefix.
SDPUtils.matchPrefix = function(blob, prefix) {
  return SDPUtils.splitLines(blob).filter(function(line) {
    return line.indexOf(prefix) === 0;
  });
};

// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
SDPUtils.parseCandidate = function(line) {
  var parts;
  // Parse both variants.
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }

  var candidate = {
    foundation: parts[0],
    component: parts[1],
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    port: parseInt(parts[5], 10),
    // skip parts[6] == 'typ'
    type: parts[7]
  };

  for (var i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;
      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;
      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;
      default: // extension handling, in particular ufrag
        candidate[parts[i]] = parts[i + 1];
        break;
    }
  }
  return candidate;
};

// Translates a candidate object into SDP candidate attribute.
SDPUtils.writeCandidate = function(candidate) {
  var sdp = [];
  sdp.push(candidate.foundation);
  sdp.push(candidate.component);
  sdp.push(candidate.protocol.toUpperCase());
  sdp.push(candidate.priority);
  sdp.push(candidate.ip);
  sdp.push(candidate.port);

  var type = candidate.type;
  sdp.push('typ');
  sdp.push(type);
  if (type !== 'host' && candidate.relatedAddress &&
      candidate.relatedPort) {
    sdp.push('raddr');
    sdp.push(candidate.relatedAddress); // was: relAddr
    sdp.push('rport');
    sdp.push(candidate.relatedPort); // was: relPort
  }
  if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
    sdp.push('tcptype');
    sdp.push(candidate.tcpType);
  }
  return 'candidate:' + sdp.join(' ');
};

// Parses an ice-options line, returns an array of option tags.
// a=ice-options:foo bar
SDPUtils.parseIceOptions = function(line) {
  return line.substr(14).split(' ');
}

// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
SDPUtils.parseRtpMap = function(line) {
  var parts = line.substr(9).split(' ');
  var parsed = {
    payloadType: parseInt(parts.shift(), 10) // was: id
  };

  parts = parts[0].split('/');

  parsed.name = parts[0];
  parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
  // was: channels
  parsed.numChannels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
  return parsed;
};

// Generate an a=rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
SDPUtils.writeRtpMap = function(codec) {
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate +
      (codec.numChannels !== 1 ? '/' + codec.numChannels : '') + '\r\n';
};

// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
SDPUtils.parseExtmap = function(line) {
  var parts = line.substr(9).split(' ');
  return {
    id: parseInt(parts[0], 10),
    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
    uri: parts[1]
  };
};

// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
SDPUtils.writeExtmap = function(headerExtension) {
  return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) +
      (headerExtension.direction && headerExtension.direction !== 'sendrecv'
          ? '/' + headerExtension.direction
          : '') +
      ' ' + headerExtension.uri + '\r\n';
};

// Parses an ftmp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
SDPUtils.parseFmtp = function(line) {
  var parsed = {};
  var kv;
  var parts = line.substr(line.indexOf(' ') + 1).split(';');
  for (var j = 0; j < parts.length; j++) {
    kv = parts[j].trim().split('=');
    parsed[kv[0].trim()] = kv[1];
  }
  return parsed;
};

// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeFmtp = function(codec) {
  var line = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.parameters && Object.keys(codec.parameters).length) {
    var params = [];
    Object.keys(codec.parameters).forEach(function(param) {
      params.push(param + '=' + codec.parameters[param]);
    });
    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
  }
  return line;
};

// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
SDPUtils.parseRtcpFb = function(line) {
  var parts = line.substr(line.indexOf(' ') + 1).split(' ');
  return {
    type: parts.shift(),
    parameter: parts.join(' ')
  };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeRtcpFb = function(codec) {
  var lines = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
    // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function(fb) {
      lines += 'a=rtcp-fb:' + pt + ' ' + fb.type +
      (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') +
          '\r\n';
    });
  }
  return lines;
};

// Parses an RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
SDPUtils.parseSsrcMedia = function(line) {
  var sp = line.indexOf(' ');
  var parts = {
    ssrc: parseInt(line.substr(7, sp - 7), 10)
  };
  var colon = line.indexOf(':', sp);
  if (colon > -1) {
    parts.attribute = line.substr(sp + 1, colon - sp - 1);
    parts.value = line.substr(colon + 1);
  } else {
    parts.attribute = line.substr(sp + 1);
  }
  return parts;
};

// Extracts the MID (RFC 5888) from a media section.
// returns the MID or undefined if no mid line was found.
SDPUtils.getMid = function(mediaSection) {
  var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
  if (mid) {
    return mid.substr(6);
  }
}

SDPUtils.parseFingerprint = function(line) {
  var parts = line.substr(14).split(' ');
  return {
    algorithm: parts[0].toLowerCase(), // algorithm is case-sensitive in Edge.
    value: parts[1]
  };
};

// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
      'a=fingerprint:');
  // Note: a=setup line is ignored since we use the 'auto' role.
  // Note2: 'algorithm' is not case sensitive except in Edge.
  return {
    role: 'auto',
    fingerprints: lines.map(SDPUtils.parseFingerprint)
  };
};

// Serializes DTLS parameters to SDP.
SDPUtils.writeDtlsParameters = function(params, setupType) {
  var sdp = 'a=setup:' + setupType + '\r\n';
  params.fingerprints.forEach(function(fp) {
    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
  });
  return sdp;
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.splitLines(mediaSection);
  // Search in session part, too.
  lines = lines.concat(SDPUtils.splitLines(sessionpart));
  var iceParameters = {
    usernameFragment: lines.filter(function(line) {
      return line.indexOf('a=ice-ufrag:') === 0;
    })[0].substr(12),
    password: lines.filter(function(line) {
      return line.indexOf('a=ice-pwd:') === 0;
    })[0].substr(10)
  };
  return iceParameters;
};

// Serializes ICE parameters to SDP.
SDPUtils.writeIceParameters = function(params) {
  return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' +
      'a=ice-pwd:' + params.password + '\r\n';
};

// Parses the SDP media section and returns RTCRtpParameters.
SDPUtils.parseRtpParameters = function(mediaSection) {
  var description = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: [],
    rtcp: []
  };
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  for (var i = 3; i < mline.length; i++) { // find all codecs from mline[3..]
    var pt = mline[i];
    var rtpmapline = SDPUtils.matchPrefix(
        mediaSection, 'a=rtpmap:' + pt + ' ')[0];
    if (rtpmapline) {
      var codec = SDPUtils.parseRtpMap(rtpmapline);
      var fmtps = SDPUtils.matchPrefix(
          mediaSection, 'a=fmtp:' + pt + ' ');
      // Only the first a=fmtp:<pt> is considered.
      codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
      codec.rtcpFeedback = SDPUtils.matchPrefix(
          mediaSection, 'a=rtcp-fb:' + pt + ' ')
        .map(SDPUtils.parseRtcpFb);
      description.codecs.push(codec);
      // parse FEC mechanisms from rtpmap lines.
      switch (codec.name.toUpperCase()) {
        case 'RED':
        case 'ULPFEC':
          description.fecMechanisms.push(codec.name.toUpperCase());
          break;
        default: // only RED and ULPFEC are recognized as FEC mechanisms.
          break;
      }
    }
  }
  SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function(line) {
    description.headerExtensions.push(SDPUtils.parseExtmap(line));
  });
  // FIXME: parse rtcp.
  return description;
};

// Generates parts of the SDP media section describing the capabilities /
// parameters.
SDPUtils.writeRtpDescription = function(kind, caps) {
  var sdp = '';

  // Build the mline.
  sdp += 'm=' + kind + ' ';
  sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
  sdp += ' UDP/TLS/RTP/SAVPF ';
  sdp += caps.codecs.map(function(codec) {
    if (codec.preferredPayloadType !== undefined) {
      return codec.preferredPayloadType;
    }
    return codec.payloadType;
  }).join(' ') + '\r\n';

  sdp += 'c=IN IP4 0.0.0.0\r\n';
  sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';

  // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
  caps.codecs.forEach(function(codec) {
    sdp += SDPUtils.writeRtpMap(codec);
    sdp += SDPUtils.writeFmtp(codec);
    sdp += SDPUtils.writeRtcpFb(codec);
  });
  var maxptime = 0;
  caps.codecs.forEach(function(codec) {
    if (codec.maxptime > maxptime) {
      maxptime = codec.maxptime;
    }
  });
  if (maxptime > 0) {
    sdp += 'a=maxptime:' + maxptime + '\r\n';
  }
  sdp += 'a=rtcp-mux\r\n';

  caps.headerExtensions.forEach(function(extension) {
    sdp += SDPUtils.writeExtmap(extension);
  });
  // FIXME: write fecMechanisms.
  return sdp;
};

// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
  var encodingParameters = [];
  var description = SDPUtils.parseRtpParameters(mediaSection);
  var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
  var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;

  // filter a=ssrc:... cname:, ignore PlanB-msid
  var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
  .map(function(line) {
    return SDPUtils.parseSsrcMedia(line);
  })
  .filter(function(parts) {
    return parts.attribute === 'cname';
  });
  var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
  var secondarySsrc;

  var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID')
  .map(function(line) {
    var parts = line.split(' ');
    parts.shift();
    return parts.map(function(part) {
      return parseInt(part, 10);
    });
  });
  if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
    secondarySsrc = flows[0][1];
  }

  description.codecs.forEach(function(codec) {
    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
      var encParam = {
        ssrc: primarySsrc,
        codecPayloadType: parseInt(codec.parameters.apt, 10),
        rtx: {
          ssrc: secondarySsrc
        }
      };
      encodingParameters.push(encParam);
      if (hasRed) {
        encParam = JSON.parse(JSON.stringify(encParam));
        encParam.fec = {
          ssrc: secondarySsrc,
          mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
        };
        encodingParameters.push(encParam);
      }
    }
  });
  if (encodingParameters.length === 0 && primarySsrc) {
    encodingParameters.push({
      ssrc: primarySsrc
    });
  }

  // we support both b=AS and b=TIAS but interpret AS as TIAS.
  var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
  if (bandwidth.length) {
    if (bandwidth[0].indexOf('b=TIAS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(7), 10);
    } else if (bandwidth[0].indexOf('b=AS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(5), 10);
    }
    encodingParameters.forEach(function(params) {
      params.maxBitrate = bandwidth;
    });
  }
  return encodingParameters;
};

// parses http://draft.ortc.org/#rtcrtcpparameters*
SDPUtils.parseRtcpParameters = function(mediaSection) {
  var rtcpParameters = {};

  var cname;
  // Gets the first SSRC. Note that with RTX there might be multiple
  // SSRCs.
  var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
      .map(function(line) {
        return SDPUtils.parseSsrcMedia(line);
      })
      .filter(function(obj) {
        return obj.attribute === 'cname';
      })[0];
  if (remoteSsrc) {
    rtcpParameters.cname = remoteSsrc.value;
    rtcpParameters.ssrc = remoteSsrc.ssrc;
  }

  // Edge uses the compound attribute instead of reducedSize
  // compound is !reducedSize
  var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
  rtcpParameters.reducedSize = rsize.length > 0;
  rtcpParameters.compound = rsize.length === 0;

  // parses the rtcp-mux attrіbute.
  // Note that Edge does not support unmuxed RTCP.
  var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
  rtcpParameters.mux = mux.length > 0;

  return rtcpParameters;
};

// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
SDPUtils.parseMsid = function(mediaSection) {
  var parts;
  var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
  if (spec.length === 1) {
    parts = spec[0].substr(7).split(' ');
    return {stream: parts[0], track: parts[1]};
  }
  var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
  .map(function(line) {
    return SDPUtils.parseSsrcMedia(line);
  })
  .filter(function(parts) {
    return parts.attribute === 'msid';
  });
  if (planB.length > 0) {
    parts = planB[0].value.split(' ');
    return {stream: parts[0], track: parts[1]};
  }
};

SDPUtils.writeSessionBoilerplate = function() {
  // FIXME: sess-id should be an NTP timestamp.
  return 'v=0\r\n' +
      'o=thisisadapterortc 8169639915646943137 2 IN IP4 127.0.0.1\r\n' +
      's=-\r\n' +
      't=0 0\r\n';
};

SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);

  // Map ICE parameters (ufrag, pwd) to SDP.
  sdp += SDPUtils.writeIceParameters(
      transceiver.iceGatherer.getLocalParameters());

  // Map DTLS parameters to SDP.
  sdp += SDPUtils.writeDtlsParameters(
      transceiver.dtlsTransport.getLocalParameters(),
      type === 'offer' ? 'actpass' : 'active');

  sdp += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.direction) {
    sdp += 'a=' + transceiver.direction + '\r\n';
  } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    // spec.
    var msid = 'msid:' + stream.id + ' ' +
        transceiver.rtpSender.track.id + '\r\n';
    sdp += 'a=' + msid;

    // for Chrome.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  // FIXME: this should be written by writeRtpDescription.
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
};

// Gets the direction from the mediaSection or the sessionpart.
SDPUtils.getDirection = function(mediaSection, sessionpart) {
  // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
  var lines = SDPUtils.splitLines(mediaSection);
  for (var i = 0; i < lines.length; i++) {
    switch (lines[i]) {
      case 'a=sendrecv':
      case 'a=sendonly':
      case 'a=recvonly':
      case 'a=inactive':
        return lines[i].substr(2);
      default:
        // FIXME: What should happen here?
    }
  }
  if (sessionpart) {
    return SDPUtils.getDirection(sessionpart);
  }
  return 'sendrecv';
};

SDPUtils.getKind = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  return mline[0].substr(2);
};

SDPUtils.isRejected = function(mediaSection) {
  return mediaSection.split(' ', 2)[1] === '0';
};

// Expose public methods.
module.exports = SDPUtils;

},{}],679:[function(require,module,exports){
function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;

},{}],680:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash

},{"safe-buffer":676}],681:[function(require,module,exports){
var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = require('./sha')
exports.sha1 = require('./sha1')
exports.sha224 = require('./sha224')
exports.sha256 = require('./sha256')
exports.sha384 = require('./sha384')
exports.sha512 = require('./sha512')

},{"./sha":682,"./sha1":683,"./sha224":684,"./sha256":685,"./sha384":686,"./sha512":687}],682:[function(require,module,exports){
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha

},{"./hash":680,"inherits":622,"safe-buffer":676}],683:[function(require,module,exports){
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1

},{"./hash":680,"inherits":622,"safe-buffer":676}],684:[function(require,module,exports){
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits')
var Sha256 = require('./sha256')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224

},{"./hash":680,"./sha256":685,"inherits":622,"safe-buffer":676}],685:[function(require,module,exports){
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256

},{"./hash":680,"inherits":622,"safe-buffer":676}],686:[function(require,module,exports){
var inherits = require('inherits')
var SHA512 = require('./sha512')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384

},{"./hash":680,"./sha512":687,"inherits":622,"safe-buffer":676}],687:[function(require,module,exports){
var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512

},{"./hash":680,"inherits":622,"safe-buffer":676}],688:[function(require,module,exports){
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Sortable = factory());
}(this, function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  var version = "1.10.2";

  function userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) {
      return !!
      /*@__PURE__*/
      navigator.userAgent.match(pattern);
    }
  }

  var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
  var Edge = userAgent(/Edge/i);
  var FireFox = userAgent(/firefox/i);
  var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
  var IOS = userAgent(/iP(ad|od|hone)/i);
  var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

  var captureMode = {
    capture: false,
    passive: false
  };

  function on(el, event, fn) {
    el.addEventListener(event, fn, !IE11OrLess && captureMode);
  }

  function off(el, event, fn) {
    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
  }

  function matches(
  /**HTMLElement*/
  el,
  /**String*/
  selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));

    if (el) {
      try {
        if (el.matches) {
          return el.matches(selector);
        } else if (el.msMatchesSelector) {
          return el.msMatchesSelector(selector);
        } else if (el.webkitMatchesSelector) {
          return el.webkitMatchesSelector(selector);
        }
      } catch (_) {
        return false;
      }
    }

    return false;
  }

  function getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
  }

  function closest(
  /**HTMLElement*/
  el,
  /**String*/
  selector,
  /**HTMLElement*/
  ctx, includeCTX) {
    if (el) {
      ctx = ctx || document;

      do {
        if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
          return el;
        }

        if (el === ctx) break;
        /* jshint boss:true */
      } while (el = getParentOrHost(el));
    }

    return null;
  }

  var R_SPACE = /\s+/g;

  function toggleClass(el, name, state) {
    if (el && name) {
      if (el.classList) {
        el.classList[state ? 'add' : 'remove'](name);
      } else {
        var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
        el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
      }
    }
  }

  function css(el, prop, val) {
    var style = el && el.style;

    if (style) {
      if (val === void 0) {
        if (document.defaultView && document.defaultView.getComputedStyle) {
          val = document.defaultView.getComputedStyle(el, '');
        } else if (el.currentStyle) {
          val = el.currentStyle;
        }

        return prop === void 0 ? val : val[prop];
      } else {
        if (!(prop in style) && prop.indexOf('webkit') === -1) {
          prop = '-webkit-' + prop;
        }

        style[prop] = val + (typeof val === 'string' ? '' : 'px');
      }
    }
  }

  function matrix(el, selfOnly) {
    var appliedTransforms = '';

    if (typeof el === 'string') {
      appliedTransforms = el;
    } else {
      do {
        var transform = css(el, 'transform');

        if (transform && transform !== 'none') {
          appliedTransforms = transform + ' ' + appliedTransforms;
        }
        /* jshint boss:true */

      } while (!selfOnly && (el = el.parentNode));
    }

    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */

    return matrixFn && new matrixFn(appliedTransforms);
  }

  function find(ctx, tagName, iterator) {
    if (ctx) {
      var list = ctx.getElementsByTagName(tagName),
          i = 0,
          n = list.length;

      if (iterator) {
        for (; i < n; i++) {
          iterator(list[i], i);
        }
      }

      return list;
    }

    return [];
  }

  function getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;

    if (scrollingElement) {
      return scrollingElement;
    } else {
      return document.documentElement;
    }
  }
  /**
   * Returns the "bounding client rect" of given element
   * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
   * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
   * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
   * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
   * @param  {[HTMLElement]} container              The parent the element will be placed in
   * @return {Object}                               The boundingClientRect of el, with specified adjustments
   */


  function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;

    if (el !== window && el !== getWindowScrollingElement()) {
      elRect = el.getBoundingClientRect();
      top = elRect.top;
      left = elRect.left;
      bottom = elRect.bottom;
      right = elRect.right;
      height = elRect.height;
      width = elRect.width;
    } else {
      top = 0;
      left = 0;
      bottom = window.innerHeight;
      right = window.innerWidth;
      height = window.innerHeight;
      width = window.innerWidth;
    }

    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
      // Adjust for translate()
      container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
      // Not needed on <= IE11

      if (!IE11OrLess) {
        do {
          if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
            var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

            top -= containerRect.top + parseInt(css(container, 'border-top-width'));
            left -= containerRect.left + parseInt(css(container, 'border-left-width'));
            bottom = top + elRect.height;
            right = left + elRect.width;
            break;
          }
          /* jshint boss:true */

        } while (container = container.parentNode);
      }
    }

    if (undoScale && el !== window) {
      // Adjust for scale()
      var elMatrix = matrix(container || el),
          scaleX = elMatrix && elMatrix.a,
          scaleY = elMatrix && elMatrix.d;

      if (elMatrix) {
        top /= scaleY;
        left /= scaleX;
        width /= scaleX;
        height /= scaleY;
        bottom = top + height;
        right = left + width;
      }
    }

    return {
      top: top,
      left: left,
      bottom: bottom,
      right: right,
      width: width,
      height: height
    };
  }
  /**
   * Checks if a side of an element is scrolled past a side of its parents
   * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
   * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
   * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
   * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
   */


  function isScrolledPast(el, elSide, parentSide) {
    var parent = getParentAutoScrollElement(el, true),
        elSideVal = getRect(el)[elSide];
    /* jshint boss:true */

    while (parent) {
      var parentSideVal = getRect(parent)[parentSide],
          visible = void 0;

      if (parentSide === 'top' || parentSide === 'left') {
        visible = elSideVal >= parentSideVal;
      } else {
        visible = elSideVal <= parentSideVal;
      }

      if (!visible) return parent;
      if (parent === getWindowScrollingElement()) break;
      parent = getParentAutoScrollElement(parent, false);
    }

    return false;
  }
  /**
   * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
   * and non-draggable elements
   * @param  {HTMLElement} el       The parent element
   * @param  {Number} childNum      The index of the child
   * @param  {Object} options       Parent Sortable's options
   * @return {HTMLElement}          The child at index childNum, or null if not found
   */


  function getChild(el, childNum, options) {
    var currentChild = 0,
        i = 0,
        children = el.children;

    while (i < children.length) {
      if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
        if (currentChild === childNum) {
          return children[i];
        }

        currentChild++;
      }

      i++;
    }

    return null;
  }
  /**
   * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
   * @param  {HTMLElement} el       Parent element
   * @param  {selector} selector    Any other elements that should be ignored
   * @return {HTMLElement}          The last child, ignoring ghostEl
   */


  function lastChild(el, selector) {
    var last = el.lastElementChild;

    while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
      last = last.previousElementSibling;
    }

    return last || null;
  }
  /**
   * Returns the index of an element within its parent for a selected set of
   * elements
   * @param  {HTMLElement} el
   * @param  {selector} selector
   * @return {number}
   */


  function index(el, selector) {
    var index = 0;

    if (!el || !el.parentNode) {
      return -1;
    }
    /* jshint boss:true */


    while (el = el.previousElementSibling) {
      if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
        index++;
      }
    }

    return index;
  }
  /**
   * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
   * The value is returned in real pixels.
   * @param  {HTMLElement} el
   * @return {Array}             Offsets in the format of [left, top]
   */


  function getRelativeScrollOffset(el) {
    var offsetLeft = 0,
        offsetTop = 0,
        winScroller = getWindowScrollingElement();

    if (el) {
      do {
        var elMatrix = matrix(el),
            scaleX = elMatrix.a,
            scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
      } while (el !== winScroller && (el = el.parentNode));
    }

    return [offsetLeft, offsetTop];
  }
  /**
   * Returns the index of the object within the given array
   * @param  {Array} arr   Array that may or may not hold the object
   * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
   * @return {Number}      The index of the object in the array, or -1
   */


  function indexOfObject(arr, obj) {
    for (var i in arr) {
      if (!arr.hasOwnProperty(i)) continue;

      for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
      }
    }

    return -1;
  }

  function getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;

    do {
      // we don't need to get elem css if it isn't even overflowing in the first place (performance)
      if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = css(elem);

        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
          if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
          if (gotSelf || includeSelf) return elem;
          gotSelf = true;
        }
      }
      /* jshint boss:true */

    } while (elem = elem.parentNode);

    return getWindowScrollingElement();
  }

  function extend(dst, src) {
    if (dst && src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) {
          dst[key] = src[key];
        }
      }
    }

    return dst;
  }

  function isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
  }

  var _throttleTimeout;

  function throttle(callback, ms) {
    return function () {
      if (!_throttleTimeout) {
        var args = arguments,
            _this = this;

        if (args.length === 1) {
          callback.call(_this, args[0]);
        } else {
          callback.apply(_this, args);
        }

        _throttleTimeout = setTimeout(function () {
          _throttleTimeout = void 0;
        }, ms);
      }
    };
  }

  function cancelThrottle() {
    clearTimeout(_throttleTimeout);
    _throttleTimeout = void 0;
  }

  function scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
  }

  function clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;

    if (Polymer && Polymer.dom) {
      return Polymer.dom(el).cloneNode(true);
    } else if ($) {
      return $(el).clone(true)[0];
    } else {
      return el.cloneNode(true);
    }
  }

  function setRect(el, rect) {
    css(el, 'position', 'absolute');
    css(el, 'top', rect.top);
    css(el, 'left', rect.left);
    css(el, 'width', rect.width);
    css(el, 'height', rect.height);
  }

  function unsetRect(el) {
    css(el, 'position', '');
    css(el, 'top', '');
    css(el, 'left', '');
    css(el, 'width', '');
    css(el, 'height', '');
  }

  var expando = 'Sortable' + new Date().getTime();

  function AnimationStateManager() {
    var animationStates = [],
        animationCallbackId;
    return {
      captureAnimationState: function captureAnimationState() {
        animationStates = [];
        if (!this.options.animation) return;
        var children = [].slice.call(this.el.children);
        children.forEach(function (child) {
          if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
          animationStates.push({
            target: child,
            rect: getRect(child)
          });

          var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


          if (child.thisAnimationDuration) {
            var childMatrix = matrix(child, true);

            if (childMatrix) {
              fromRect.top -= childMatrix.f;
              fromRect.left -= childMatrix.e;
            }
          }

          child.fromRect = fromRect;
        });
      },
      addAnimationState: function addAnimationState(state) {
        animationStates.push(state);
      },
      removeAnimationState: function removeAnimationState(target) {
        animationStates.splice(indexOfObject(animationStates, {
          target: target
        }), 1);
      },
      animateAll: function animateAll(callback) {
        var _this = this;

        if (!this.options.animation) {
          clearTimeout(animationCallbackId);
          if (typeof callback === 'function') callback();
          return;
        }

        var animating = false,
            animationTime = 0;
        animationStates.forEach(function (state) {
          var time = 0,
              target = state.target,
              fromRect = target.fromRect,
              toRect = getRect(target),
              prevFromRect = target.prevFromRect,
              prevToRect = target.prevToRect,
              animatingRect = state.rect,
              targetMatrix = matrix(target, true);

          if (targetMatrix) {
            // Compensate for current animation
            toRect.top -= targetMatrix.f;
            toRect.left -= targetMatrix.e;
          }

          target.toRect = toRect;

          if (target.thisAnimationDuration) {
            // Could also check if animatingRect is between fromRect and toRect
            if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
              // If returning to same place as started from animation and on same axis
              time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
            }
          } // if fromRect != toRect: animate


          if (!isRectEqual(toRect, fromRect)) {
            target.prevFromRect = fromRect;
            target.prevToRect = toRect;

            if (!time) {
              time = _this.options.animation;
            }

            _this.animate(target, animatingRect, toRect, time);
          }

          if (time) {
            animating = true;
            animationTime = Math.max(animationTime, time);
            clearTimeout(target.animationResetTimer);
            target.animationResetTimer = setTimeout(function () {
              target.animationTime = 0;
              target.prevFromRect = null;
              target.fromRect = null;
              target.prevToRect = null;
              target.thisAnimationDuration = null;
            }, time);
            target.thisAnimationDuration = time;
          }
        });
        clearTimeout(animationCallbackId);

        if (!animating) {
          if (typeof callback === 'function') callback();
        } else {
          animationCallbackId = setTimeout(function () {
            if (typeof callback === 'function') callback();
          }, animationTime);
        }

        animationStates = [];
      },
      animate: function animate(target, currentRect, toRect, duration) {
        if (duration) {
          css(target, 'transition', '');
          css(target, 'transform', '');
          var elMatrix = matrix(this.el),
              scaleX = elMatrix && elMatrix.a,
              scaleY = elMatrix && elMatrix.d,
              translateX = (currentRect.left - toRect.left) / (scaleX || 1),
              translateY = (currentRect.top - toRect.top) / (scaleY || 1);
          target.animatingX = !!translateX;
          target.animatingY = !!translateY;
          css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
          repaint(target); // repaint

          css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
          css(target, 'transform', 'translate3d(0,0,0)');
          typeof target.animated === 'number' && clearTimeout(target.animated);
          target.animated = setTimeout(function () {
            css(target, 'transition', '');
            css(target, 'transform', '');
            target.animated = false;
            target.animatingX = false;
            target.animatingY = false;
          }, duration);
        }
      }
    };
  }

  function repaint(target) {
    return target.offsetWidth;
  }

  function calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
  }

  var plugins = [];
  var defaults = {
    initializeByDefault: true
  };
  var PluginManager = {
    mount: function mount(plugin) {
      // Set default static properties
      for (var option in defaults) {
        if (defaults.hasOwnProperty(option) && !(option in plugin)) {
          plugin[option] = defaults[option];
        }
      }

      plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
      var _this = this;

      this.eventCanceled = false;

      evt.cancel = function () {
        _this.eventCanceled = true;
      };

      var eventNameGlobal = eventName + 'Global';
      plugins.forEach(function (plugin) {
        if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

        if (sortable[plugin.pluginName][eventNameGlobal]) {
          sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
            sortable: sortable
          }, evt));
        } // Only fire plugin event if plugin is enabled in this sortable,
        // and plugin has event defined


        if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
          sortable[plugin.pluginName][eventName](_objectSpread({
            sortable: sortable
          }, evt));
        }
      });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
      plugins.forEach(function (plugin) {
        var pluginName = plugin.pluginName;
        if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
        var initialized = new plugin(sortable, el, sortable.options);
        initialized.sortable = sortable;
        initialized.options = sortable.options;
        sortable[pluginName] = initialized; // Add default options from plugin

        _extends(defaults, initialized.defaults);
      });

      for (var option in sortable.options) {
        if (!sortable.options.hasOwnProperty(option)) continue;
        var modified = this.modifyOption(sortable, option, sortable.options[option]);

        if (typeof modified !== 'undefined') {
          sortable.options[option] = modified;
        }
      }
    },
    getEventProperties: function getEventProperties(name, sortable) {
      var eventProperties = {};
      plugins.forEach(function (plugin) {
        if (typeof plugin.eventProperties !== 'function') return;

        _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
      });
      return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
      var modifiedValue;
      plugins.forEach(function (plugin) {
        // Plugin must exist on the Sortable
        if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

        if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
          modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        }
      });
      return modifiedValue;
    }
  };

  function dispatchEvent(_ref) {
    var sortable = _ref.sortable,
        rootEl = _ref.rootEl,
        name = _ref.name,
        targetEl = _ref.targetEl,
        cloneEl = _ref.cloneEl,
        toEl = _ref.toEl,
        fromEl = _ref.fromEl,
        oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex,
        oldDraggableIndex = _ref.oldDraggableIndex,
        newDraggableIndex = _ref.newDraggableIndex,
        originalEvent = _ref.originalEvent,
        putSortable = _ref.putSortable,
        extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[expando];
    if (!sortable) return;
    var evt,
        options = sortable.options,
        onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent(name, true, true);
    }

    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

    var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

    for (var option in allEventProperties) {
      evt[option] = allEventProperties[option];
    }

    if (rootEl) {
      rootEl.dispatchEvent(evt);
    }

    if (options[onName]) {
      options[onName].call(sortable, evt);
    }
  }

  var pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        originalEvent = _ref.evt,
        data = _objectWithoutProperties(_ref, ["evt"]);

    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
      dragEl: dragEl,
      parentEl: parentEl,
      ghostEl: ghostEl,
      rootEl: rootEl,
      nextEl: nextEl,
      lastDownEl: lastDownEl,
      cloneEl: cloneEl,
      cloneHidden: cloneHidden,
      dragStarted: moved,
      putSortable: putSortable,
      activeSortable: Sortable.active,
      originalEvent: originalEvent,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex,
      hideGhostForTarget: _hideGhostForTarget,
      unhideGhostForTarget: _unhideGhostForTarget,
      cloneNowHidden: function cloneNowHidden() {
        cloneHidden = true;
      },
      cloneNowShown: function cloneNowShown() {
        cloneHidden = false;
      },
      dispatchSortableEvent: function dispatchSortableEvent(name) {
        _dispatchEvent({
          sortable: sortable,
          name: name,
          originalEvent: originalEvent
        });
      }
    }, data));
  };

  function _dispatchEvent(info) {
    dispatchEvent(_objectSpread({
      putSortable: putSortable,
      cloneEl: cloneEl,
      targetEl: dragEl,
      rootEl: rootEl,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex
    }, info));
  }

  var dragEl,
      parentEl,
      ghostEl,
      rootEl,
      nextEl,
      lastDownEl,
      cloneEl,
      cloneHidden,
      oldIndex,
      newIndex,
      oldDraggableIndex,
      newDraggableIndex,
      activeGroup,
      putSortable,
      awaitingDragStarted = false,
      ignoreNextClick = false,
      sortables = [],
      tapEvt,
      touchEvt,
      lastDx,
      lastDy,
      tapDistanceLeft,
      tapDistanceTop,
      moved,
      lastTarget,
      lastDirection,
      pastFirstInvertThresh = false,
      isCircumstantialInvert = false,
      targetMoveDistance,
      // For positioning ghost absolutely
  ghostRelativeParent,
      ghostRelativeParentInitialScroll = [],
      // (left, top)
  _silent = false,
      savedInputChecked = [];
  /** @const */

  var documentExists = typeof document !== 'undefined',
      PositionGhostAbsolutely = IOS,
      CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
      // This will not pass for IE9, because IE9 DnD only works on anchors
  supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
      supportCssPointerEvents = function () {
    if (!documentExists) return; // false when <= IE11

    if (IE11OrLess) {
      return false;
    }

    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
  }(),
      _detectDirection = function _detectDirection(el, options) {
    var elCSS = css(el),
        elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
        child1 = getChild(el, 0, options),
        child2 = getChild(el, 1, options),
        firstChildCSS = child1 && css(child1),
        secondChildCSS = child2 && css(child2),
        firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
        secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

    if (elCSS.display === 'flex') {
      return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    }

    if (elCSS.display === 'grid') {
      return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    }

    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
      var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
      return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }

    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
  },
      _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
        dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
        dragElOppLength = vertical ? dragRect.width : dragRect.height,
        targetS1Opp = vertical ? targetRect.left : targetRect.top,
        targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
        targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
  },

  /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */
  _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    sortables.some(function (sortable) {
      if (lastChild(sortable)) return;
      var rect = getRect(sortable),
          threshold = sortable[expando].options.emptyInsertThreshold,
          insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
          insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

      if (threshold && insideHorizontally && insideVertically) {
        return ret = sortable;
      }
    });
    return ret;
  },
      _prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
      return function (to, from, dragEl, evt) {
        var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

        if (value == null && (pull || sameGroup)) {
          // Default pull value
          // Default pull and put value if same group
          return true;
        } else if (value == null || value === false) {
          return false;
        } else if (pull && value === 'clone') {
          return value;
        } else if (typeof value === 'function') {
          return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
        } else {
          var otherGroup = (pull ? to : from).options.group.name;
          return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
        }
      };
    }

    var group = {};
    var originalGroup = options.group;

    if (!originalGroup || _typeof(originalGroup) != 'object') {
      originalGroup = {
        name: originalGroup
      };
    }

    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
  },
      _hideGhostForTarget = function _hideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', 'none');
    }
  },
      _unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', '');
    }
  }; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


  if (documentExists) {
    document.addEventListener('click', function (evt) {
      if (ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        ignoreNextClick = false;
        return false;
      }
    }, true);
  }

  var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if (dragEl) {
      evt = evt.touches ? evt.touches[0] : evt;

      var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

      if (nearest) {
        // Create imitation event
        var event = {};

        for (var i in evt) {
          if (evt.hasOwnProperty(i)) {
            event[i] = evt[i];
          }
        }

        event.target = event.rootEl = nearest;
        event.preventDefault = void 0;
        event.stopPropagation = void 0;

        nearest[expando]._onDragOver(event);
      }
    }
  };

  var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if (dragEl) {
      dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
    }
  };
  /**
   * @class  Sortable
   * @param  {HTMLElement}  el
   * @param  {Object}       [options]
   */


  function Sortable(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) {
      throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
    }

    this.el = el; // root element

    this.options = options = _extends({}, options); // Export instance

    el[expando] = this;
    var defaults = {
      group: null,
      sort: true,
      disabled: false,
      store: null,
      handle: null,
      draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
      swapThreshold: 1,
      // percentage; 0 <= x <= 1
      invertSwap: false,
      // invert always
      invertedSwapThreshold: null,
      // will be set to same as swapThreshold if default
      removeCloneOnHide: true,
      direction: function direction() {
        return _detectDirection(el, this.options);
      },
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      ignore: 'a, img',
      filter: null,
      preventOnFilter: true,
      animation: 0,
      easing: null,
      setData: function setData(dataTransfer, dragEl) {
        dataTransfer.setData('Text', dragEl.textContent);
      },
      dropBubble: false,
      dragoverBubble: false,
      dataIdAttr: 'data-id',
      delay: 0,
      delayOnTouchOnly: false,
      touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
      forceFallback: false,
      fallbackClass: 'sortable-fallback',
      fallbackOnBody: false,
      fallbackTolerance: 0,
      fallbackOffset: {
        x: 0,
        y: 0
      },
      supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
      emptyInsertThreshold: 5
    };
    PluginManager.initializePlugins(this, el, defaults); // Set default options

    for (var name in defaults) {
      !(name in options) && (options[name] = defaults[name]);
    }

    _prepareGroup(options); // Bind all private methods


    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    } // Setup drag mode


    this.nativeDraggable = options.forceFallback ? false : supportDraggable;

    if (this.nativeDraggable) {
      // Touch start threshold cannot be greater than the native dragstart threshold
      this.options.touchStartThreshold = 1;
    } // Bind events


    if (options.supportPointer) {
      on(el, 'pointerdown', this._onTapStart);
    } else {
      on(el, 'mousedown', this._onTapStart);
      on(el, 'touchstart', this._onTapStart);
    }

    if (this.nativeDraggable) {
      on(el, 'dragover', this);
      on(el, 'dragenter', this);
    }

    sortables.push(this.el); // Restore sorting

    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

    _extends(this, AnimationStateManager());
  }

  Sortable.prototype =
  /** @lends Sortable.prototype */
  {
    constructor: Sortable,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
      if (!this.el.contains(target) && target !== this.el) {
        lastTarget = null;
      }
    },
    _getDirection: function _getDirection(evt, target) {
      return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(
    /** Event|TouchEvent */
    evt) {
      if (!evt.cancelable) return;

      var _this = this,
          el = this.el,
          options = this.options,
          preventOnFilter = options.preventOnFilter,
          type = evt.type,
          touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
          target = (touch || evt).target,
          originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
          filter = options.filter;

      _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


      if (dragEl) {
        return;
      }

      if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
        return; // only left button and enabled
      } // cancel dnd if original target is content editable


      if (originalTarget.isContentEditable) {
        return;
      }

      target = closest(target, options.draggable, el, false);

      if (target && target.animated) {
        return;
      }

      if (lastDownEl === target) {
        // Ignoring duplicate `down`
        return;
      } // Get the index of the dragged element within its parent


      oldIndex = index(target);
      oldDraggableIndex = index(target, options.draggable); // Check filter

      if (typeof filter === 'function') {
        if (filter.call(this, evt, target, this)) {
          _dispatchEvent({
            sortable: _this,
            rootEl: originalTarget,
            name: 'filter',
            targetEl: target,
            toEl: el,
            fromEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          preventOnFilter && evt.cancelable && evt.preventDefault();
          return; // cancel dnd
        }
      } else if (filter) {
        filter = filter.split(',').some(function (criteria) {
          criteria = closest(originalTarget, criteria.trim(), el, false);

          if (criteria) {
            _dispatchEvent({
              sortable: _this,
              rootEl: criteria,
              name: 'filter',
              targetEl: target,
              fromEl: el,
              toEl: el
            });

            pluginEvent('filter', _this, {
              evt: evt
            });
            return true;
          }
        });

        if (filter) {
          preventOnFilter && evt.cancelable && evt.preventDefault();
          return; // cancel dnd
        }
      }

      if (options.handle && !closest(originalTarget, options.handle, el, false)) {
        return;
      } // Prepare `dragstart`


      this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(
    /** Event */
    evt,
    /** Touch */
    touch,
    /** HTMLElement */
    target) {
      var _this = this,
          el = _this.el,
          options = _this.options,
          ownerDocument = el.ownerDocument,
          dragStartFn;

      if (target && !dragEl && target.parentNode === el) {
        var dragRect = getRect(target);
        rootEl = el;
        dragEl = target;
        parentEl = dragEl.parentNode;
        nextEl = dragEl.nextSibling;
        lastDownEl = target;
        activeGroup = options.group;
        Sortable.dragged = dragEl;
        tapEvt = {
          target: dragEl,
          clientX: (touch || evt).clientX,
          clientY: (touch || evt).clientY
        };
        tapDistanceLeft = tapEvt.clientX - dragRect.left;
        tapDistanceTop = tapEvt.clientY - dragRect.top;
        this._lastX = (touch || evt).clientX;
        this._lastY = (touch || evt).clientY;
        dragEl.style['will-change'] = 'all';

        dragStartFn = function dragStartFn() {
          pluginEvent('delayEnded', _this, {
            evt: evt
          });

          if (Sortable.eventCanceled) {
            _this._onDrop();

            return;
          } // Delayed drag has been triggered
          // we can re-enable the events: touchmove/mousemove


          _this._disableDelayedDragEvents();

          if (!FireFox && _this.nativeDraggable) {
            dragEl.draggable = true;
          } // Bind the events: dragstart/dragend


          _this._triggerDragStart(evt, touch); // Drag start event


          _dispatchEvent({
            sortable: _this,
            name: 'choose',
            originalEvent: evt
          }); // Chosen item


          toggleClass(dragEl, options.chosenClass, true);
        }; // Disable "draggable"


        options.ignore.split(',').forEach(function (criteria) {
          find(dragEl, criteria.trim(), _disableDraggable);
        });
        on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'mouseup', _this._onDrop);
        on(ownerDocument, 'touchend', _this._onDrop);
        on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

        if (FireFox && this.nativeDraggable) {
          this.options.touchStartThreshold = 4;
          dragEl.draggable = true;
        }

        pluginEvent('delayStart', this, {
          evt: evt
        }); // Delay is impossible for native DnD in Edge or IE

        if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
          if (Sortable.eventCanceled) {
            this._onDrop();

            return;
          } // If the user moves the pointer or let go the click or touch
          // before the delay has been reached:
          // disable the delayed drag


          on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
          on(ownerDocument, 'touchend', _this._disableDelayedDrag);
          on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
          on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
          on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
          options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
          _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
        } else {
          dragStartFn();
        }
      }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
    /** TouchEvent|PointerEvent **/
    e) {
      var touch = e.touches ? e.touches[0] : e;

      if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
        this._disableDelayedDrag();
      }
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
      dragEl && _disableDraggable(dragEl);
      clearTimeout(this._dragStartTimer);

      this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._disableDelayedDrag);
      off(ownerDocument, 'touchend', this._disableDelayedDrag);
      off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
      off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(
    /** Event */
    evt,
    /** Touch */
    touch) {
      touch = touch || evt.pointerType == 'touch' && evt;

      if (!this.nativeDraggable || touch) {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._onTouchMove);
        } else if (touch) {
          on(document, 'touchmove', this._onTouchMove);
        } else {
          on(document, 'mousemove', this._onTouchMove);
        }
      } else {
        on(dragEl, 'dragend', this);
        on(rootEl, 'dragstart', this._onDragStart);
      }

      try {
        if (document.selection) {
          // Timeout neccessary for IE9
          _nextTick(function () {
            document.selection.empty();
          });
        } else {
          window.getSelection().removeAllRanges();
        }
      } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {

      awaitingDragStarted = false;

      if (rootEl && dragEl) {
        pluginEvent('dragStarted', this, {
          evt: evt
        });

        if (this.nativeDraggable) {
          on(document, 'dragover', _checkOutsideTargetEl);
        }

        var options = this.options; // Apply effect

        !fallback && toggleClass(dragEl, options.dragClass, false);
        toggleClass(dragEl, options.ghostClass, true);
        Sortable.active = this;
        fallback && this._appendGhost(); // Drag start event

        _dispatchEvent({
          sortable: this,
          name: 'start',
          originalEvent: evt
        });
      } else {
        this._nulling();
      }
    },
    _emulateDragOver: function _emulateDragOver() {
      if (touchEvt) {
        this._lastX = touchEvt.clientX;
        this._lastY = touchEvt.clientY;

        _hideGhostForTarget();

        var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        var parent = target;

        while (target && target.shadowRoot) {
          target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
          if (target === parent) break;
          parent = target;
        }

        dragEl.parentNode[expando]._isOutsideThisEl(target);

        if (parent) {
          do {
            if (parent[expando]) {
              var inserted = void 0;
              inserted = parent[expando]._onDragOver({
                clientX: touchEvt.clientX,
                clientY: touchEvt.clientY,
                target: target,
                rootEl: parent
              });

              if (inserted && !this.options.dragoverBubble) {
                break;
              }
            }

            target = parent; // store last element
          }
          /* jshint boss:true */
          while (parent = parent.parentNode);
        }

        _unhideGhostForTarget();
      }
    },
    _onTouchMove: function _onTouchMove(
    /**TouchEvent*/
    evt) {
      if (tapEvt) {
        var options = this.options,
            fallbackTolerance = options.fallbackTolerance,
            fallbackOffset = options.fallbackOffset,
            touch = evt.touches ? evt.touches[0] : evt,
            ghostMatrix = ghostEl && matrix(ghostEl, true),
            scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
            scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
            relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
            dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
            dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

        if (!Sortable.active && !awaitingDragStarted) {
          if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
            return;
          }

          this._onDragStart(evt, true);
        }

        if (ghostEl) {
          if (ghostMatrix) {
            ghostMatrix.e += dx - (lastDx || 0);
            ghostMatrix.f += dy - (lastDy || 0);
          } else {
            ghostMatrix = {
              a: 1,
              b: 0,
              c: 0,
              d: 1,
              e: dx,
              f: dy
            };
          }

          var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
          css(ghostEl, 'webkitTransform', cssMatrix);
          css(ghostEl, 'mozTransform', cssMatrix);
          css(ghostEl, 'msTransform', cssMatrix);
          css(ghostEl, 'transform', cssMatrix);
          lastDx = dx;
          lastDy = dy;
          touchEvt = touch;
        }

        evt.cancelable && evt.preventDefault();
      }
    },
    _appendGhost: function _appendGhost() {
      // Bug if using scale(): https://stackoverflow.com/questions/2637058
      // Not being adjusted for
      if (!ghostEl) {
        var container = this.options.fallbackOnBody ? document.body : rootEl,
            rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
            options = this.options; // Position absolutely

        if (PositionGhostAbsolutely) {
          // Get relatively positioned parent
          ghostRelativeParent = container;

          while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
            ghostRelativeParent = ghostRelativeParent.parentNode;
          }

          if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
            if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
            rect.top += ghostRelativeParent.scrollTop;
            rect.left += ghostRelativeParent.scrollLeft;
          } else {
            ghostRelativeParent = getWindowScrollingElement();
          }

          ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
        }

        ghostEl = dragEl.cloneNode(true);
        toggleClass(ghostEl, options.ghostClass, false);
        toggleClass(ghostEl, options.fallbackClass, true);
        toggleClass(ghostEl, options.dragClass, true);
        css(ghostEl, 'transition', '');
        css(ghostEl, 'transform', '');
        css(ghostEl, 'box-sizing', 'border-box');
        css(ghostEl, 'margin', 0);
        css(ghostEl, 'top', rect.top);
        css(ghostEl, 'left', rect.left);
        css(ghostEl, 'width', rect.width);
        css(ghostEl, 'height', rect.height);
        css(ghostEl, 'opacity', '0.8');
        css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
        css(ghostEl, 'zIndex', '100000');
        css(ghostEl, 'pointerEvents', 'none');
        Sortable.ghost = ghostEl;
        container.appendChild(ghostEl); // Set transform-origin

        css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
      }
    },
    _onDragStart: function _onDragStart(
    /**Event*/
    evt,
    /**boolean*/
    fallback) {
      var _this = this;

      var dataTransfer = evt.dataTransfer;
      var options = _this.options;
      pluginEvent('dragStart', this, {
        evt: evt
      });

      if (Sortable.eventCanceled) {
        this._onDrop();

        return;
      }

      pluginEvent('setupClone', this);

      if (!Sortable.eventCanceled) {
        cloneEl = clone(dragEl);
        cloneEl.draggable = false;
        cloneEl.style['will-change'] = '';

        this._hideClone();

        toggleClass(cloneEl, this.options.chosenClass, false);
        Sortable.clone = cloneEl;
      } // #1143: IFrame support workaround


      _this.cloneId = _nextTick(function () {
        pluginEvent('clone', _this);
        if (Sortable.eventCanceled) return;

        if (!_this.options.removeCloneOnHide) {
          rootEl.insertBefore(cloneEl, dragEl);
        }

        _this._hideClone();

        _dispatchEvent({
          sortable: _this,
          name: 'clone'
        });
      });
      !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

      if (fallback) {
        ignoreNextClick = true;
        _this._loopId = setInterval(_this._emulateDragOver, 50);
      } else {
        // Undo what was set in _prepareDragStart before drag started
        off(document, 'mouseup', _this._onDrop);
        off(document, 'touchend', _this._onDrop);
        off(document, 'touchcancel', _this._onDrop);

        if (dataTransfer) {
          dataTransfer.effectAllowed = 'move';
          options.setData && options.setData.call(_this, dataTransfer, dragEl);
        }

        on(document, 'drop', _this); // #1276 fix:

        css(dragEl, 'transform', 'translateZ(0)');
      }

      awaitingDragStarted = true;
      _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
      on(document, 'selectstart', _this);
      moved = true;

      if (Safari) {
        css(document.body, 'user-select', 'none');
      }
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(
    /**Event*/
    evt) {
      var el = this.el,
          target = evt.target,
          dragRect,
          targetRect,
          revert,
          options = this.options,
          group = options.group,
          activeSortable = Sortable.active,
          isOwner = activeGroup === group,
          canSort = options.sort,
          fromSortable = putSortable || activeSortable,
          vertical,
          _this = this,
          completedFired = false;

      if (_silent) return;

      function dragOverEvent(name, extra) {
        pluginEvent(name, _this, _objectSpread({
          evt: evt,
          isOwner: isOwner,
          axis: vertical ? 'vertical' : 'horizontal',
          revert: revert,
          dragRect: dragRect,
          targetRect: targetRect,
          canSort: canSort,
          fromSortable: fromSortable,
          target: target,
          completed: completed,
          onMove: function onMove(target, after) {
            return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
          },
          changed: changed
        }, extra));
      } // Capture animation state


      function capture() {
        dragOverEvent('dragOverAnimationCapture');

        _this.captureAnimationState();

        if (_this !== fromSortable) {
          fromSortable.captureAnimationState();
        }
      } // Return invocation when dragEl is inserted (or completed)


      function completed(insertion) {
        dragOverEvent('dragOverCompleted', {
          insertion: insertion
        });

        if (insertion) {
          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
          if (isOwner) {
            activeSortable._hideClone();
          } else {
            activeSortable._showClone(_this);
          }

          if (_this !== fromSortable) {
            // Set ghost class to new sortable's ghost class
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
            toggleClass(dragEl, options.ghostClass, true);
          }

          if (putSortable !== _this && _this !== Sortable.active) {
            putSortable = _this;
          } else if (_this === Sortable.active && putSortable) {
            putSortable = null;
          } // Animation


          if (fromSortable === _this) {
            _this._ignoreWhileAnimating = target;
          }

          _this.animateAll(function () {
            dragOverEvent('dragOverAnimationComplete');
            _this._ignoreWhileAnimating = null;
          });

          if (_this !== fromSortable) {
            fromSortable.animateAll();
            fromSortable._ignoreWhileAnimating = null;
          }
        } // Null lastTarget if it is not inside a previously swapped element


        if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
          lastTarget = null;
        } // no bubbling and not fallback


        if (!options.dragoverBubble && !evt.rootEl && target !== document) {
          dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


          !insertion && nearestEmptyInsertDetectEvent(evt);
        }

        !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
        return completedFired = true;
      } // Call when dragEl has been inserted


      function changed() {
        newIndex = index(dragEl);
        newDraggableIndex = index(dragEl, options.draggable);

        _dispatchEvent({
          sortable: _this,
          name: 'change',
          toEl: el,
          newIndex: newIndex,
          newDraggableIndex: newDraggableIndex,
          originalEvent: evt
        });
      }

      if (evt.preventDefault !== void 0) {
        evt.cancelable && evt.preventDefault();
      }

      target = closest(target, options.draggable, el, true);
      dragOverEvent('dragOver');
      if (Sortable.eventCanceled) return completedFired;

      if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
        return completed(false);
      }

      ignoreNextClick = false;

      if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
      : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
        vertical = this._getDirection(evt, target) === 'vertical';
        dragRect = getRect(dragEl);
        dragOverEvent('dragOverValid');
        if (Sortable.eventCanceled) return completedFired;

        if (revert) {
          parentEl = rootEl; // actualization

          capture();

          this._hideClone();

          dragOverEvent('revert');

          if (!Sortable.eventCanceled) {
            if (nextEl) {
              rootEl.insertBefore(dragEl, nextEl);
            } else {
              rootEl.appendChild(dragEl);
            }
          }

          return completed(true);
        }

        var elLastChild = lastChild(el, options.draggable);

        if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
          // If already at end of list: Do not insert
          if (elLastChild === dragEl) {
            return completed(false);
          } // assign target only if condition is true


          if (elLastChild && el === evt.target) {
            target = elLastChild;
          }

          if (target) {
            targetRect = getRect(target);
          }

          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
            capture();
            el.appendChild(dragEl);
            parentEl = el; // actualization

            changed();
            return completed(true);
          }
        } else if (target.parentNode === el) {
          targetRect = getRect(target);
          var direction = 0,
              targetBeforeFirstSwap,
              differentLevel = dragEl.parentNode !== el,
              differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
              side1 = vertical ? 'top' : 'left',
              scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
              scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

          if (lastTarget !== target) {
            targetBeforeFirstSwap = targetRect[side1];
            pastFirstInvertThresh = false;
            isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
          }

          direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
          var sibling;

          if (direction !== 0) {
            // Check if target is beside dragEl in respective direction (ignoring hidden elements)
            var dragIndex = index(dragEl);

            do {
              dragIndex -= direction;
              sibling = parentEl.children[dragIndex];
            } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
          } // If dragEl is already beside target: Do not insert


          if (direction === 0 || sibling === target) {
            return completed(false);
          }

          lastTarget = target;
          lastDirection = direction;
          var nextSibling = target.nextElementSibling,
              after = false;
          after = direction === 1;

          var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

          if (moveVector !== false) {
            if (moveVector === 1 || moveVector === -1) {
              after = moveVector === 1;
            }

            _silent = true;
            setTimeout(_unsilent, 30);
            capture();

            if (after && !nextSibling) {
              el.appendChild(dragEl);
            } else {
              target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
            } // Undo chrome's scroll adjustment (has no effect on other browsers)


            if (scrolledPastTop) {
              scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
            }

            parentEl = dragEl.parentNode; // actualization
            // must be done before animation

            if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
              targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
            }

            changed();
            return completed(true);
          }
        }

        if (el.contains(dragEl)) {
          return completed(false);
        }
      }

      return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
      off(document, 'mousemove', this._onTouchMove);
      off(document, 'touchmove', this._onTouchMove);
      off(document, 'pointermove', this._onTouchMove);
      off(document, 'dragover', nearestEmptyInsertDetectEvent);
      off(document, 'mousemove', nearestEmptyInsertDetectEvent);
      off(document, 'touchmove', nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._onDrop);
      off(ownerDocument, 'touchend', this._onDrop);
      off(ownerDocument, 'pointerup', this._onDrop);
      off(ownerDocument, 'touchcancel', this._onDrop);
      off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(
    /**Event*/
    evt) {
      var el = this.el,
          options = this.options; // Get the index of the dragged element within its parent

      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      pluginEvent('drop', this, {
        evt: evt
      });
      parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      if (Sortable.eventCanceled) {
        this._nulling();

        return;
      }

      awaitingDragStarted = false;
      isCircumstantialInvert = false;
      pastFirstInvertThresh = false;
      clearInterval(this._loopId);
      clearTimeout(this._dragStartTimer);

      _cancelNextTick(this.cloneId);

      _cancelNextTick(this._dragStartId); // Unbind events


      if (this.nativeDraggable) {
        off(document, 'drop', this);
        off(el, 'dragstart', this._onDragStart);
      }

      this._offMoveEvents();

      this._offUpEvents();

      if (Safari) {
        css(document.body, 'user-select', '');
      }

      css(dragEl, 'transform', '');

      if (evt) {
        if (moved) {
          evt.cancelable && evt.preventDefault();
          !options.dropBubble && evt.stopPropagation();
        }

        ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
          // Remove clone(s)
          cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
        }

        if (dragEl) {
          if (this.nativeDraggable) {
            off(dragEl, 'dragend', this);
          }

          _disableDraggable(dragEl);

          dragEl.style['will-change'] = ''; // Remove classes
          // ghostClass is added in dragStarted

          if (moved && !awaitingDragStarted) {
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
          }

          toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

          _dispatchEvent({
            sortable: this,
            name: 'unchoose',
            toEl: parentEl,
            newIndex: null,
            newDraggableIndex: null,
            originalEvent: evt
          });

          if (rootEl !== parentEl) {
            if (newIndex >= 0) {
              // Add event
              _dispatchEvent({
                rootEl: parentEl,
                name: 'add',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              }); // Remove event


              _dispatchEvent({
                sortable: this,
                name: 'remove',
                toEl: parentEl,
                originalEvent: evt
              }); // drag from one list and drop into another


              _dispatchEvent({
                rootEl: parentEl,
                name: 'sort',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }

            putSortable && putSortable.save();
          } else {
            if (newIndex !== oldIndex) {
              if (newIndex >= 0) {
                // drag & drop within the same list
                _dispatchEvent({
                  sortable: this,
                  name: 'update',
                  toEl: parentEl,
                  originalEvent: evt
                });

                _dispatchEvent({
                  sortable: this,
                  name: 'sort',
                  toEl: parentEl,
                  originalEvent: evt
                });
              }
            }
          }

          if (Sortable.active) {
            /* jshint eqnull:true */
            if (newIndex == null || newIndex === -1) {
              newIndex = oldIndex;
              newDraggableIndex = oldDraggableIndex;
            }

            _dispatchEvent({
              sortable: this,
              name: 'end',
              toEl: parentEl,
              originalEvent: evt
            }); // Save sorting


            this.save();
          }
        }
      }

      this._nulling();
    },
    _nulling: function _nulling() {
      pluginEvent('nulling', this);
      rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
      savedInputChecked.forEach(function (el) {
        el.checked = true;
      });
      savedInputChecked.length = lastDx = lastDy = 0;
    },
    handleEvent: function handleEvent(
    /**Event*/
    evt) {
      switch (evt.type) {
        case 'drop':
        case 'dragend':
          this._onDrop(evt);

          break;

        case 'dragenter':
        case 'dragover':
          if (dragEl) {
            this._onDragOver(evt);

            _globalDragOver(evt);
          }

          break;

        case 'selectstart':
          evt.preventDefault();
          break;
      }
    },

    /**
     * Serializes the item into an array of string.
     * @returns {String[]}
     */
    toArray: function toArray() {
      var order = [],
          el,
          children = this.el.children,
          i = 0,
          n = children.length,
          options = this.options;

      for (; i < n; i++) {
        el = children[i];

        if (closest(el, options.draggable, this.el, false)) {
          order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
        }
      }

      return order;
    },

    /**
     * Sorts the elements according to the array.
     * @param  {String[]}  order  order of the items
     */
    sort: function sort(order) {
      var items = {},
          rootEl = this.el;
      this.toArray().forEach(function (id, i) {
        var el = rootEl.children[i];

        if (closest(el, this.options.draggable, rootEl, false)) {
          items[id] = el;
        }
      }, this);
      order.forEach(function (id) {
        if (items[id]) {
          rootEl.removeChild(items[id]);
          rootEl.appendChild(items[id]);
        }
      });
    },

    /**
     * Save the current sorting
     */
    save: function save() {
      var store = this.options.store;
      store && store.set && store.set(this);
    },

    /**
     * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
     * @param   {HTMLElement}  el
     * @param   {String}       [selector]  default: `options.draggable`
     * @returns {HTMLElement|null}
     */
    closest: function closest$1(el, selector) {
      return closest(el, selector || this.options.draggable, this.el, false);
    },

    /**
     * Set/get option
     * @param   {string} name
     * @param   {*}      [value]
     * @returns {*}
     */
    option: function option(name, value) {
      var options = this.options;

      if (value === void 0) {
        return options[name];
      } else {
        var modifiedValue = PluginManager.modifyOption(this, name, value);

        if (typeof modifiedValue !== 'undefined') {
          options[name] = modifiedValue;
        } else {
          options[name] = value;
        }

        if (name === 'group') {
          _prepareGroup(options);
        }
      }
    },

    /**
     * Destroy
     */
    destroy: function destroy() {
      pluginEvent('destroy', this);
      var el = this.el;
      el[expando] = null;
      off(el, 'mousedown', this._onTapStart);
      off(el, 'touchstart', this._onTapStart);
      off(el, 'pointerdown', this._onTapStart);

      if (this.nativeDraggable) {
        off(el, 'dragover', this);
        off(el, 'dragenter', this);
      } // Remove draggable attributes


      Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
        el.removeAttribute('draggable');
      });

      this._onDrop();

      this._disableDelayedDragEvents();

      sortables.splice(sortables.indexOf(this.el), 1);
      this.el = el = null;
    },
    _hideClone: function _hideClone() {
      if (!cloneHidden) {
        pluginEvent('hideClone', this);
        if (Sortable.eventCanceled) return;
        css(cloneEl, 'display', 'none');

        if (this.options.removeCloneOnHide && cloneEl.parentNode) {
          cloneEl.parentNode.removeChild(cloneEl);
        }

        cloneHidden = true;
      }
    },
    _showClone: function _showClone(putSortable) {
      if (putSortable.lastPutMode !== 'clone') {
        this._hideClone();

        return;
      }

      if (cloneHidden) {
        pluginEvent('showClone', this);
        if (Sortable.eventCanceled) return; // show clone at dragEl or original position

        if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
          rootEl.insertBefore(cloneEl, dragEl);
        } else if (nextEl) {
          rootEl.insertBefore(cloneEl, nextEl);
        } else {
          rootEl.appendChild(cloneEl);
        }

        if (this.options.group.revertClone) {
          this.animate(dragEl, cloneEl);
        }

        css(cloneEl, 'display', '');
        cloneHidden = false;
      }
    }
  };

  function _globalDragOver(
  /**Event*/
  evt) {
    if (evt.dataTransfer) {
      evt.dataTransfer.dropEffect = 'move';
    }

    evt.cancelable && evt.preventDefault();
  }

  function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt,
        sortable = fromEl[expando],
        onMoveFn = sortable.options.onMove,
        retVal; // Support for new CustomEvent feature

    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent('move', true, true);
    }

    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);

    if (onMoveFn) {
      retVal = onMoveFn.call(sortable, evt, originalEvent);
    }

    return retVal;
  }

  function _disableDraggable(el) {
    el.draggable = false;
  }

  function _unsilent() {
    _silent = false;
  }

  function _ghostIsLast(evt, vertical, sortable) {
    var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
    var spacer = 10;
    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
  }

  function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
        targetLength = vertical ? targetRect.height : targetRect.width,
        targetS1 = vertical ? targetRect.top : targetRect.left,
        targetS2 = vertical ? targetRect.bottom : targetRect.right,
        invert = false;

    if (!invertSwap) {
      // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
      if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
        // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
        // check if past first invert threshold on side opposite of lastDirection
        if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
          // past first invert threshold, do not restrict inverted threshold to dragEl shadow
          pastFirstInvertThresh = true;
        }

        if (!pastFirstInvertThresh) {
          // dragEl shadow (target move distance shadow)
          if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
          : mouseOnAxis > targetS2 - targetMoveDistance) {
            return -lastDirection;
          }
        } else {
          invert = true;
        }
      } else {
        // Regular
        if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
          return _getInsertDirection(target);
        }
      }
    }

    invert = invert || invertSwap;

    if (invert) {
      // Invert of regular
      if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
        return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
      }
    }

    return 0;
  }
  /**
   * Gets the direction dragEl must be swapped relative to target in order to make it
   * seem that dragEl has been "inserted" into that element's position
   * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
   * @return {Number}                   Direction dragEl must be swapped
   */


  function _getInsertDirection(target) {
    if (index(dragEl) < index(target)) {
      return 1;
    } else {
      return -1;
    }
  }
  /**
   * Generate id
   * @param   {HTMLElement} el
   * @returns {String}
   * @private
   */


  function _generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent,
        i = str.length,
        sum = 0;

    while (i--) {
      sum += str.charCodeAt(i);
    }

    return sum.toString(36);
  }

  function _saveInputCheckedState(root) {
    savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;

    while (idx--) {
      var el = inputs[idx];
      el.checked && savedInputChecked.push(el);
    }
  }

  function _nextTick(fn) {
    return setTimeout(fn, 0);
  }

  function _cancelNextTick(id) {
    return clearTimeout(id);
  } // Fixed #973:


  if (documentExists) {
    on(document, 'touchmove', function (evt) {
      if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
        evt.preventDefault();
      }
    });
  } // Export utils


  Sortable.utils = {
    on: on,
    off: off,
    css: css,
    find: find,
    is: function is(el, selector) {
      return !!closest(el, selector, el, false);
    },
    extend: extend,
    throttle: throttle,
    closest: closest,
    toggleClass: toggleClass,
    clone: clone,
    index: index,
    nextTick: _nextTick,
    cancelNextTick: _cancelNextTick,
    detectDirection: _detectDirection,
    getChild: getChild
  };
  /**
   * Get the Sortable instance of an element
   * @param  {HTMLElement} element The element
   * @return {Sortable|undefined}         The instance of Sortable
   */

  Sortable.get = function (element) {
    return element[expando];
  };
  /**
   * Mount a plugin to Sortable
   * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
   */


  Sortable.mount = function () {
    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function (plugin) {
      if (!plugin.prototype || !plugin.prototype.constructor) {
        throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
      }

      if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
      PluginManager.mount(plugin);
    });
  };
  /**
   * Create sortable instance
   * @param {HTMLElement}  el
   * @param {Object}      [options]
   */


  Sortable.create = function (el, options) {
    return new Sortable(el, options);
  }; // Export


  Sortable.version = version;

  var autoScrolls = [],
      scrollEl,
      scrollRootEl,
      scrolling = false,
      lastAutoScrollX,
      lastAutoScrollY,
      touchEvt$1,
      pointerElemChangedInterval;

  function AutoScrollPlugin() {
    function AutoScroll() {
      this.defaults = {
        scroll: true,
        scrollSensitivity: 30,
        scrollSpeed: 10,
        bubbleScroll: true
      }; // Bind all private methods

      for (var fn in this) {
        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
          this[fn] = this[fn].bind(this);
        }
      }
    }

    AutoScroll.prototype = {
      dragStarted: function dragStarted(_ref) {
        var originalEvent = _ref.originalEvent;

        if (this.sortable.nativeDraggable) {
          on(document, 'dragover', this._handleAutoScroll);
        } else {
          if (this.options.supportPointer) {
            on(document, 'pointermove', this._handleFallbackAutoScroll);
          } else if (originalEvent.touches) {
            on(document, 'touchmove', this._handleFallbackAutoScroll);
          } else {
            on(document, 'mousemove', this._handleFallbackAutoScroll);
          }
        }
      },
      dragOverCompleted: function dragOverCompleted(_ref2) {
        var originalEvent = _ref2.originalEvent;

        // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
        if (!this.options.dragOverBubble && !originalEvent.rootEl) {
          this._handleAutoScroll(originalEvent);
        }
      },
      drop: function drop() {
        if (this.sortable.nativeDraggable) {
          off(document, 'dragover', this._handleAutoScroll);
        } else {
          off(document, 'pointermove', this._handleFallbackAutoScroll);
          off(document, 'touchmove', this._handleFallbackAutoScroll);
          off(document, 'mousemove', this._handleFallbackAutoScroll);
        }

        clearPointerElemChangedInterval();
        clearAutoScrolls();
        cancelThrottle();
      },
      nulling: function nulling() {
        touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
        autoScrolls.length = 0;
      },
      _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
        this._handleAutoScroll(evt, true);
      },
      _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
        var _this = this;

        var x = (evt.touches ? evt.touches[0] : evt).clientX,
            y = (evt.touches ? evt.touches[0] : evt).clientY,
            elem = document.elementFromPoint(x, y);
        touchEvt$1 = evt; // IE does not seem to have native autoscroll,
        // Edge's autoscroll seems too conditional,
        // MACOS Safari does not have autoscroll,
        // Firefox and Chrome are good

        if (fallback || Edge || IE11OrLess || Safari) {
          autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

          var ogElemScroller = getParentAutoScrollElement(elem, true);

          if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
            pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

            pointerElemChangedInterval = setInterval(function () {
              var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

              if (newElem !== ogElemScroller) {
                ogElemScroller = newElem;
                clearAutoScrolls();
              }

              autoScroll(evt, _this.options, newElem, fallback);
            }, 10);
            lastAutoScrollX = x;
            lastAutoScrollY = y;
          }
        } else {
          // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
          if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
            clearAutoScrolls();
            return;
          }

          autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
        }
      }
    };
    return _extends(AutoScroll, {
      pluginName: 'scroll',
      initializeByDefault: true
    });
  }

  function clearAutoScrolls() {
    autoScrolls.forEach(function (autoScroll) {
      clearInterval(autoScroll.pid);
    });
    autoScrolls = [];
  }

  function clearPointerElemChangedInterval() {
    clearInterval(pointerElemChangedInterval);
  }

  var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX,
        y = (evt.touches ? evt.touches[0] : evt).clientY,
        sens = options.scrollSensitivity,
        speed = options.scrollSpeed,
        winScroller = getWindowScrollingElement();
    var scrollThisInstance = false,
        scrollCustomFn; // New scroll root, set scrollEl

    if (scrollRootEl !== rootEl) {
      scrollRootEl = rootEl;
      clearAutoScrolls();
      scrollEl = options.scroll;
      scrollCustomFn = options.scrollFn;

      if (scrollEl === true) {
        scrollEl = getParentAutoScrollElement(rootEl, true);
      }
    }

    var layersOut = 0;
    var currentParent = scrollEl;

    do {
      var el = currentParent,
          rect = getRect(el),
          top = rect.top,
          bottom = rect.bottom,
          left = rect.left,
          right = rect.right,
          width = rect.width,
          height = rect.height,
          canScrollX = void 0,
          canScrollY = void 0,
          scrollWidth = el.scrollWidth,
          scrollHeight = el.scrollHeight,
          elCSS = css(el),
          scrollPosX = el.scrollLeft,
          scrollPosY = el.scrollTop;

      if (el === winScroller) {
        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
      } else {
        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
      }

      var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
      var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

      if (!autoScrolls[layersOut]) {
        for (var i = 0; i <= layersOut; i++) {
          if (!autoScrolls[i]) {
            autoScrolls[i] = {};
          }
        }
      }

      if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
        autoScrolls[layersOut].el = el;
        autoScrolls[layersOut].vx = vx;
        autoScrolls[layersOut].vy = vy;
        clearInterval(autoScrolls[layersOut].pid);

        if (vx != 0 || vy != 0) {
          scrollThisInstance = true;
          /* jshint loopfunc:true */

          autoScrolls[layersOut].pid = setInterval(function () {
            // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
            if (isFallback && this.layer === 0) {
              Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

            }

            var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
            var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

            if (typeof scrollCustomFn === 'function') {
              if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
                return;
              }
            }

            scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
          }.bind({
            layer: layersOut
          }), 24);
        }
      }

      layersOut++;
    } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

    scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
  }, 30);

  var drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent,
        putSortable = _ref.putSortable,
        dragEl = _ref.dragEl,
        activeSortable = _ref.activeSortable,
        dispatchSortableEvent = _ref.dispatchSortableEvent,
        hideGhostForTarget = _ref.hideGhostForTarget,
        unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();

    if (toSortable && !toSortable.el.contains(target)) {
      dispatchSortableEvent('spill');
      this.onSpill({
        dragEl: dragEl,
        putSortable: putSortable
      });
    }
  };

  function Revert() {}

  Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
      var oldDraggableIndex = _ref2.oldDraggableIndex;
      this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
      var dragEl = _ref3.dragEl,
          putSortable = _ref3.putSortable;
      this.sortable.captureAnimationState();

      if (putSortable) {
        putSortable.captureAnimationState();
      }

      var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

      if (nextSibling) {
        this.sortable.el.insertBefore(dragEl, nextSibling);
      } else {
        this.sortable.el.appendChild(dragEl);
      }

      this.sortable.animateAll();

      if (putSortable) {
        putSortable.animateAll();
      }
    },
    drop: drop
  };

  _extends(Revert, {
    pluginName: 'revertOnSpill'
  });

  function Remove() {}

  Remove.prototype = {
    onSpill: function onSpill(_ref4) {
      var dragEl = _ref4.dragEl,
          putSortable = _ref4.putSortable;
      var parentSortable = putSortable || this.sortable;
      parentSortable.captureAnimationState();
      dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
      parentSortable.animateAll();
    },
    drop: drop
  };

  _extends(Remove, {
    pluginName: 'removeOnSpill'
  });

  var lastSwapEl;

  function SwapPlugin() {
    function Swap() {
      this.defaults = {
        swapClass: 'sortable-swap-highlight'
      };
    }

    Swap.prototype = {
      dragStart: function dragStart(_ref) {
        var dragEl = _ref.dragEl;
        lastSwapEl = dragEl;
      },
      dragOverValid: function dragOverValid(_ref2) {
        var completed = _ref2.completed,
            target = _ref2.target,
            onMove = _ref2.onMove,
            activeSortable = _ref2.activeSortable,
            changed = _ref2.changed,
            cancel = _ref2.cancel;
        if (!activeSortable.options.swap) return;
        var el = this.sortable.el,
            options = this.options;

        if (target && target !== el) {
          var prevSwapEl = lastSwapEl;

          if (onMove(target) !== false) {
            toggleClass(target, options.swapClass, true);
            lastSwapEl = target;
          } else {
            lastSwapEl = null;
          }

          if (prevSwapEl && prevSwapEl !== lastSwapEl) {
            toggleClass(prevSwapEl, options.swapClass, false);
          }
        }

        changed();
        completed(true);
        cancel();
      },
      drop: function drop(_ref3) {
        var activeSortable = _ref3.activeSortable,
            putSortable = _ref3.putSortable,
            dragEl = _ref3.dragEl;
        var toSortable = putSortable || this.sortable;
        var options = this.options;
        lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

        if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
          if (dragEl !== lastSwapEl) {
            toSortable.captureAnimationState();
            if (toSortable !== activeSortable) activeSortable.captureAnimationState();
            swapNodes(dragEl, lastSwapEl);
            toSortable.animateAll();
            if (toSortable !== activeSortable) activeSortable.animateAll();
          }
        }
      },
      nulling: function nulling() {
        lastSwapEl = null;
      }
    };
    return _extends(Swap, {
      pluginName: 'swap',
      eventProperties: function eventProperties() {
        return {
          swapItem: lastSwapEl
        };
      }
    });
  }

  function swapNodes(n1, n2) {
    var p1 = n1.parentNode,
        p2 = n2.parentNode,
        i1,
        i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = index(n1);
    i2 = index(n2);

    if (p1.isEqualNode(p2) && i1 < i2) {
      i2++;
    }

    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
  }

  var multiDragElements = [],
      multiDragClones = [],
      lastMultiDragSelect,
      // for selection with modifier key down (SHIFT)
  multiDragSortable,
      initialFolding = false,
      // Initial multi-drag fold when drag started
  folding = false,
      // Folding any other time
  dragStarted = false,
      dragEl$1,
      clonesFromRect,
      clonesHidden;

  function MultiDragPlugin() {
    function MultiDrag(sortable) {
      // Bind all private methods
      for (var fn in this) {
        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
          this[fn] = this[fn].bind(this);
        }
      }

      if (sortable.options.supportPointer) {
        on(document, 'pointerup', this._deselectMultiDrag);
      } else {
        on(document, 'mouseup', this._deselectMultiDrag);
        on(document, 'touchend', this._deselectMultiDrag);
      }

      on(document, 'keydown', this._checkKeyDown);
      on(document, 'keyup', this._checkKeyUp);
      this.defaults = {
        selectedClass: 'sortable-selected',
        multiDragKey: null,
        setData: function setData(dataTransfer, dragEl) {
          var data = '';

          if (multiDragElements.length && multiDragSortable === sortable) {
            multiDragElements.forEach(function (multiDragElement, i) {
              data += (!i ? '' : ', ') + multiDragElement.textContent;
            });
          } else {
            data = dragEl.textContent;
          }

          dataTransfer.setData('Text', data);
        }
      };
    }

    MultiDrag.prototype = {
      multiDragKeyDown: false,
      isMultiDrag: false,
      delayStartGlobal: function delayStartGlobal(_ref) {
        var dragged = _ref.dragEl;
        dragEl$1 = dragged;
      },
      delayEnded: function delayEnded() {
        this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
      },
      setupClone: function setupClone(_ref2) {
        var sortable = _ref2.sortable,
            cancel = _ref2.cancel;
        if (!this.isMultiDrag) return;

        for (var i = 0; i < multiDragElements.length; i++) {
          multiDragClones.push(clone(multiDragElements[i]));
          multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
          multiDragClones[i].draggable = false;
          multiDragClones[i].style['will-change'] = '';
          toggleClass(multiDragClones[i], this.options.selectedClass, false);
          multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
        }

        sortable._hideClone();

        cancel();
      },
      clone: function clone(_ref3) {
        var sortable = _ref3.sortable,
            rootEl = _ref3.rootEl,
            dispatchSortableEvent = _ref3.dispatchSortableEvent,
            cancel = _ref3.cancel;
        if (!this.isMultiDrag) return;

        if (!this.options.removeCloneOnHide) {
          if (multiDragElements.length && multiDragSortable === sortable) {
            insertMultiDragClones(true, rootEl);
            dispatchSortableEvent('clone');
            cancel();
          }
        }
      },
      showClone: function showClone(_ref4) {
        var cloneNowShown = _ref4.cloneNowShown,
            rootEl = _ref4.rootEl,
            cancel = _ref4.cancel;
        if (!this.isMultiDrag) return;
        insertMultiDragClones(false, rootEl);
        multiDragClones.forEach(function (clone) {
          css(clone, 'display', '');
        });
        cloneNowShown();
        clonesHidden = false;
        cancel();
      },
      hideClone: function hideClone(_ref5) {
        var _this = this;

        var sortable = _ref5.sortable,
            cloneNowHidden = _ref5.cloneNowHidden,
            cancel = _ref5.cancel;
        if (!this.isMultiDrag) return;
        multiDragClones.forEach(function (clone) {
          css(clone, 'display', 'none');

          if (_this.options.removeCloneOnHide && clone.parentNode) {
            clone.parentNode.removeChild(clone);
          }
        });
        cloneNowHidden();
        clonesHidden = true;
        cancel();
      },
      dragStartGlobal: function dragStartGlobal(_ref6) {
        var sortable = _ref6.sortable;

        if (!this.isMultiDrag && multiDragSortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();
        }

        multiDragElements.forEach(function (multiDragElement) {
          multiDragElement.sortableIndex = index(multiDragElement);
        }); // Sort multi-drag elements

        multiDragElements = multiDragElements.sort(function (a, b) {
          return a.sortableIndex - b.sortableIndex;
        });
        dragStarted = true;
      },
      dragStarted: function dragStarted(_ref7) {
        var _this2 = this;

        var sortable = _ref7.sortable;
        if (!this.isMultiDrag) return;

        if (this.options.sort) {
          // Capture rects,
          // hide multi drag elements (by positioning them absolute),
          // set multi drag elements rects to dragRect,
          // show multi drag elements,
          // animate to rects,
          // unset rects & remove from DOM
          sortable.captureAnimationState();

          if (this.options.animation) {
            multiDragElements.forEach(function (multiDragElement) {
              if (multiDragElement === dragEl$1) return;
              css(multiDragElement, 'position', 'absolute');
            });
            var dragRect = getRect(dragEl$1, false, true, true);
            multiDragElements.forEach(function (multiDragElement) {
              if (multiDragElement === dragEl$1) return;
              setRect(multiDragElement, dragRect);
            });
            folding = true;
            initialFolding = true;
          }
        }

        sortable.animateAll(function () {
          folding = false;
          initialFolding = false;

          if (_this2.options.animation) {
            multiDragElements.forEach(function (multiDragElement) {
              unsetRect(multiDragElement);
            });
          } // Remove all auxiliary multidrag items from el, if sorting enabled


          if (_this2.options.sort) {
            removeMultiDragElements();
          }
        });
      },
      dragOver: function dragOver(_ref8) {
        var target = _ref8.target,
            completed = _ref8.completed,
            cancel = _ref8.cancel;

        if (folding && ~multiDragElements.indexOf(target)) {
          completed(false);
          cancel();
        }
      },
      revert: function revert(_ref9) {
        var fromSortable = _ref9.fromSortable,
            rootEl = _ref9.rootEl,
            sortable = _ref9.sortable,
            dragRect = _ref9.dragRect;

        if (multiDragElements.length > 1) {
          // Setup unfold animation
          multiDragElements.forEach(function (multiDragElement) {
            sortable.addAnimationState({
              target: multiDragElement,
              rect: folding ? getRect(multiDragElement) : dragRect
            });
            unsetRect(multiDragElement);
            multiDragElement.fromRect = dragRect;
            fromSortable.removeAnimationState(multiDragElement);
          });
          folding = false;
          insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
        }
      },
      dragOverCompleted: function dragOverCompleted(_ref10) {
        var sortable = _ref10.sortable,
            isOwner = _ref10.isOwner,
            insertion = _ref10.insertion,
            activeSortable = _ref10.activeSortable,
            parentEl = _ref10.parentEl,
            putSortable = _ref10.putSortable;
        var options = this.options;

        if (insertion) {
          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
          if (isOwner) {
            activeSortable._hideClone();
          }

          initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

          if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
            // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
            var dragRectAbsolute = getRect(dragEl$1, false, true, true);
            multiDragElements.forEach(function (multiDragElement) {
              if (multiDragElement === dragEl$1) return;
              setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
              // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

              parentEl.appendChild(multiDragElement);
            });
            folding = true;
          } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


          if (!isOwner) {
            // Only remove if not folding (folding will remove them anyways)
            if (!folding) {
              removeMultiDragElements();
            }

            if (multiDragElements.length > 1) {
              var clonesHiddenBefore = clonesHidden;

              activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


              if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
                multiDragClones.forEach(function (clone) {
                  activeSortable.addAnimationState({
                    target: clone,
                    rect: clonesFromRect
                  });
                  clone.fromRect = clonesFromRect;
                  clone.thisAnimationDuration = null;
                });
              }
            } else {
              activeSortable._showClone(sortable);
            }
          }
        }
      },
      dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
        var dragRect = _ref11.dragRect,
            isOwner = _ref11.isOwner,
            activeSortable = _ref11.activeSortable;
        multiDragElements.forEach(function (multiDragElement) {
          multiDragElement.thisAnimationDuration = null;
        });

        if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
          clonesFromRect = _extends({}, dragRect);
          var dragMatrix = matrix(dragEl$1, true);
          clonesFromRect.top -= dragMatrix.f;
          clonesFromRect.left -= dragMatrix.e;
        }
      },
      dragOverAnimationComplete: function dragOverAnimationComplete() {
        if (folding) {
          folding = false;
          removeMultiDragElements();
        }
      },
      drop: function drop(_ref12) {
        var evt = _ref12.originalEvent,
            rootEl = _ref12.rootEl,
            parentEl = _ref12.parentEl,
            sortable = _ref12.sortable,
            dispatchSortableEvent = _ref12.dispatchSortableEvent,
            oldIndex = _ref12.oldIndex,
            putSortable = _ref12.putSortable;
        var toSortable = putSortable || this.sortable;
        if (!evt) return;
        var options = this.options,
            children = parentEl.children; // Multi-drag selection

        if (!dragStarted) {
          if (options.multiDragKey && !this.multiDragKeyDown) {
            this._deselectMultiDrag();
          }

          toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

          if (!~multiDragElements.indexOf(dragEl$1)) {
            multiDragElements.push(dragEl$1);
            dispatchEvent({
              sortable: sortable,
              rootEl: rootEl,
              name: 'select',
              targetEl: dragEl$1,
              originalEvt: evt
            }); // Modifier activated, select from last to dragEl

            if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
              var lastIndex = index(lastMultiDragSelect),
                  currentIndex = index(dragEl$1);

              if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                // (but previous selection existed)
                var n, i;

                if (currentIndex > lastIndex) {
                  i = lastIndex;
                  n = currentIndex;
                } else {
                  i = currentIndex;
                  n = lastIndex + 1;
                }

                for (; i < n; i++) {
                  if (~multiDragElements.indexOf(children[i])) continue;
                  toggleClass(children[i], options.selectedClass, true);
                  multiDragElements.push(children[i]);
                  dispatchEvent({
                    sortable: sortable,
                    rootEl: rootEl,
                    name: 'select',
                    targetEl: children[i],
                    originalEvt: evt
                  });
                }
              }
            } else {
              lastMultiDragSelect = dragEl$1;
            }

            multiDragSortable = toSortable;
          } else {
            multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
            lastMultiDragSelect = null;
            dispatchEvent({
              sortable: sortable,
              rootEl: rootEl,
              name: 'deselect',
              targetEl: dragEl$1,
              originalEvt: evt
            });
          }
        } // Multi-drag drop


        if (dragStarted && this.isMultiDrag) {
          // Do not "unfold" after around dragEl if reverted
          if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
            var dragRect = getRect(dragEl$1),
                multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
            if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
            toSortable.captureAnimationState();

            if (!initialFolding) {
              if (options.animation) {
                dragEl$1.fromRect = dragRect;
                multiDragElements.forEach(function (multiDragElement) {
                  multiDragElement.thisAnimationDuration = null;

                  if (multiDragElement !== dragEl$1) {
                    var rect = folding ? getRect(multiDragElement) : dragRect;
                    multiDragElement.fromRect = rect; // Prepare unfold animation

                    toSortable.addAnimationState({
                      target: multiDragElement,
                      rect: rect
                    });
                  }
                });
              } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
              // properly they must all be removed


              removeMultiDragElements();
              multiDragElements.forEach(function (multiDragElement) {
                if (children[multiDragIndex]) {
                  parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                } else {
                  parentEl.appendChild(multiDragElement);
                }

                multiDragIndex++;
              }); // If initial folding is done, the elements may have changed position because they are now
              // unfolding around dragEl, even though dragEl may not have his index changed, so update event
              // must be fired here as Sortable will not.

              if (oldIndex === index(dragEl$1)) {
                var update = false;
                multiDragElements.forEach(function (multiDragElement) {
                  if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                    update = true;
                    return;
                  }
                });

                if (update) {
                  dispatchSortableEvent('update');
                }
              }
            } // Must be done after capturing individual rects (scroll bar)


            multiDragElements.forEach(function (multiDragElement) {
              unsetRect(multiDragElement);
            });
            toSortable.animateAll();
          }

          multiDragSortable = toSortable;
        } // Remove clones if necessary


        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
          multiDragClones.forEach(function (clone) {
            clone.parentNode && clone.parentNode.removeChild(clone);
          });
        }
      },
      nullingGlobal: function nullingGlobal() {
        this.isMultiDrag = dragStarted = false;
        multiDragClones.length = 0;
      },
      destroyGlobal: function destroyGlobal() {
        this._deselectMultiDrag();

        off(document, 'pointerup', this._deselectMultiDrag);
        off(document, 'mouseup', this._deselectMultiDrag);
        off(document, 'touchend', this._deselectMultiDrag);
        off(document, 'keydown', this._checkKeyDown);
        off(document, 'keyup', this._checkKeyUp);
      },
      _deselectMultiDrag: function _deselectMultiDrag(evt) {
        if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

        if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

        if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

        if (evt && evt.button !== 0) return;

        while (multiDragElements.length) {
          var el = multiDragElements[0];
          toggleClass(el, this.options.selectedClass, false);
          multiDragElements.shift();
          dispatchEvent({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: 'deselect',
            targetEl: el,
            originalEvt: evt
          });
        }
      },
      _checkKeyDown: function _checkKeyDown(evt) {
        if (evt.key === this.options.multiDragKey) {
          this.multiDragKeyDown = true;
        }
      },
      _checkKeyUp: function _checkKeyUp(evt) {
        if (evt.key === this.options.multiDragKey) {
          this.multiDragKeyDown = false;
        }
      }
    };
    return _extends(MultiDrag, {
      // Static methods & properties
      pluginName: 'multiDrag',
      utils: {
        /**
         * Selects the provided multi-drag item
         * @param  {HTMLElement} el    The element to be selected
         */
        select: function select(el) {
          var sortable = el.parentNode[expando];
          if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

          if (multiDragSortable && multiDragSortable !== sortable) {
            multiDragSortable.multiDrag._deselectMultiDrag();

            multiDragSortable = sortable;
          }

          toggleClass(el, sortable.options.selectedClass, true);
          multiDragElements.push(el);
        },

        /**
         * Deselects the provided multi-drag item
         * @param  {HTMLElement} el    The element to be deselected
         */
        deselect: function deselect(el) {
          var sortable = el.parentNode[expando],
              index = multiDragElements.indexOf(el);
          if (!sortable || !sortable.options.multiDrag || !~index) return;
          toggleClass(el, sortable.options.selectedClass, false);
          multiDragElements.splice(index, 1);
        }
      },
      eventProperties: function eventProperties() {
        var _this3 = this;

        var oldIndicies = [],
            newIndicies = [];
        multiDragElements.forEach(function (multiDragElement) {
          oldIndicies.push({
            multiDragElement: multiDragElement,
            index: multiDragElement.sortableIndex
          }); // multiDragElements will already be sorted if folding

          var newIndex;

          if (folding && multiDragElement !== dragEl$1) {
            newIndex = -1;
          } else if (folding) {
            newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
          } else {
            newIndex = index(multiDragElement);
          }

          newIndicies.push({
            multiDragElement: multiDragElement,
            index: newIndex
          });
        });
        return {
          items: _toConsumableArray(multiDragElements),
          clones: [].concat(multiDragClones),
          oldIndicies: oldIndicies,
          newIndicies: newIndicies
        };
      },
      optionListeners: {
        multiDragKey: function multiDragKey(key) {
          key = key.toLowerCase();

          if (key === 'ctrl') {
            key = 'Control';
          } else if (key.length > 1) {
            key = key.charAt(0).toUpperCase() + key.substr(1);
          }

          return key;
        }
      }
    });
  }

  function insertMultiDragElements(clonesInserted, rootEl) {
    multiDragElements.forEach(function (multiDragElement, i) {
      var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

      if (target) {
        rootEl.insertBefore(multiDragElement, target);
      } else {
        rootEl.appendChild(multiDragElement);
      }
    });
  }
  /**
   * Insert multi-drag clones
   * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
   * @param  {HTMLElement} rootEl
   */


  function insertMultiDragClones(elementsInserted, rootEl) {
    multiDragClones.forEach(function (clone, i) {
      var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

      if (target) {
        rootEl.insertBefore(clone, target);
      } else {
        rootEl.appendChild(clone);
      }
    });
  }

  function removeMultiDragElements() {
    multiDragElements.forEach(function (multiDragElement) {
      if (multiDragElement === dragEl$1) return;
      multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
  }

  Sortable.mount(new AutoScrollPlugin());
  Sortable.mount(Remove, Revert);

  Sortable.mount(new SwapPlugin());
  Sortable.mount(new MultiDragPlugin());

  return Sortable;

}));

},{}],689:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * The 'src' argument plays the command role.
 * The returned values is always of the same type as the 'src'.
 * @param dst
 * @param src
 * @returns {*}
 */
function mergeOne(dst, src) {
  if (src === undefined) { return dst; }

  // According to specification arrays must be concatenated.
  // Also, the '.concat' creates a new array instance. Overrides the 'dst'.
  if (isArray(src)) { return (isArray(dst) ? dst : []).concat(src); }

  // Now deal with non plain 'src' object. 'src' overrides 'dst'
  // Note that functions are also assigned! We do not deep merge functions.
  if (!isPlainObject(src)) { return src; }

  // See if 'dst' is allowed to be mutated. If not - it's overridden with a new plain object.
  var returnValue = isObject(dst) ? dst : {};

  var keys = Object.keys(src);
  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];

    var srcValue = src[key];
    // Do not merge properties with the 'undefined' value.
    if (srcValue !== undefined) {
      var dstValue = returnValue[key];
      // Recursive calls to mergeOne() must allow only plain objects or arrays in dst
      var newDst = isPlainObject(dstValue) || isArray(srcValue) ? dstValue : {};

      // deep merge each property. Recursion!
      returnValue[key] = mergeOne(newDst, srcValue);
    }
  }

  return returnValue;
}

var merge = function (dst) {
  var srcs = [], len = arguments.length - 1;
  while ( len-- > 0 ) srcs[ len ] = arguments[ len + 1 ];

  return srcs.reduce(mergeOne, dst);
};

function isFunction(obj) {
  return typeof obj === 'function';
}

function isObject(obj) {
  var type = typeof obj;
  return !!obj && (type === 'object' || type === 'function');
}

var assign = Object.assign || function assign(to) {
  var args = arguments;
  for (var s = 1; s < args.length; s += 1) {
    var from = args[s];
    if (from) {
      var keys = Object.keys(from);
      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        to[key] = from[key];
      }
    }
  }

  return to;
};

var isArray = Array.isArray;

function isPlainObject(value) {
  return !!value && typeof value === 'object' &&
    Object.getPrototypeOf(value) === Object.prototype;
}


var concat = Array.prototype.concat;
function extractFunctions() {
  var fns = concat.apply([], arguments).filter(isFunction);
  return fns.length === 0 ? undefined : fns;
}

function concatAssignFunctions(dstObject, srcArray, propName) {
  if (!isArray(srcArray)) { return; }

  var length = srcArray.length;
  var dstArray = dstObject[propName] || [];
  dstObject[propName] = dstArray;
  for (var i = 0; i < length; i += 1) {
    var fn = srcArray[i];
    if (isFunction(fn) && dstArray.indexOf(fn) < 0) {
      dstArray.push(fn);
    }
  }
}


function combineProperties(dstObject, srcObject, propName, action) {
  if (!isObject(srcObject[propName])) { return; }
  if (!isObject(dstObject[propName])) { dstObject[propName] = {}; }
  action(dstObject[propName], srcObject[propName]);
}

function deepMergeAssign(dstObject, srcObject, propName) {
  combineProperties(dstObject, srcObject, propName, merge);
}
function mergeAssign(dstObject, srcObject, propName) {
  combineProperties(dstObject, srcObject, propName, assign);
}

/**
 * Converts stampit extended descriptor to a standard one.
 * @param [methods]
 * @param [properties]
 * @param [props]
 * @param [refs]
 * @param [initializers]
 * @param [init]
 * @param [deepProperties]
 * @param [deepProps]
 * @param [propertyDescriptors]
 * @param [staticProperties]
 * @param [statics]
 * @param [staticDeepProperties]
 * @param [deepStatics]
 * @param [staticPropertyDescriptors]
 * @param [configuration]
 * @param [conf]
 * @param [deepConfiguration]
 * @param [deepConf]
 * @param [composers]
 * @returns {Descriptor}
 */
var standardiseDescriptor = function (ref) {
  if ( ref === void 0 ) ref = {};
  var methods = ref.methods;
  var properties = ref.properties;
  var props = ref.props;
  var refs = ref.refs;
  var initializers = ref.initializers;
  var init = ref.init;
  var composers = ref.composers;
  var deepProperties = ref.deepProperties;
  var deepProps = ref.deepProps;
  var propertyDescriptors = ref.propertyDescriptors;
  var staticProperties = ref.staticProperties;
  var statics = ref.statics;
  var staticDeepProperties = ref.staticDeepProperties;
  var deepStatics = ref.deepStatics;
  var staticPropertyDescriptors = ref.staticPropertyDescriptors;
  var configuration = ref.configuration;
  var conf = ref.conf;
  var deepConfiguration = ref.deepConfiguration;
  var deepConf = ref.deepConf;

  var p = isObject(props) || isObject(refs) || isObject(properties) ?
    assign({}, props, refs, properties) : undefined;

  var dp = isObject(deepProps) ? merge({}, deepProps) : undefined;
  dp = isObject(deepProperties) ? merge(dp, deepProperties) : dp;

  var sp = isObject(statics) || isObject(staticProperties) ?
    assign({}, statics, staticProperties) : undefined;

  var dsp = isObject(deepStatics) ? merge({}, deepStatics) : undefined;
  dsp = isObject(staticDeepProperties) ? merge(dsp, staticDeepProperties) : dsp;

  var c = isObject(conf) || isObject(configuration) ?
    assign({}, conf, configuration) : undefined;

  var dc = isObject(deepConf) ? merge({}, deepConf) : undefined;
  dc = isObject(deepConfiguration) ? merge(dc, deepConfiguration) : dc;

  var ii = extractFunctions(init, initializers);

  var composerFunctions = extractFunctions(composers);
  if (composerFunctions) {
    dc = dc || {};
    concatAssignFunctions(dc, composerFunctions, 'composers');
  }

  var descriptor = {};
  if (methods) { descriptor.methods = methods; }
  if (p) { descriptor.properties = p; }
  if (ii) { descriptor.initializers = ii; }
  if (dp) { descriptor.deepProperties = dp; }
  if (sp) { descriptor.staticProperties = sp; }
  if (methods) { descriptor.methods = methods; }
  if (dsp) { descriptor.staticDeepProperties = dsp; }
  if (propertyDescriptors) { descriptor.propertyDescriptors = propertyDescriptors; }
  if (staticPropertyDescriptors) { descriptor.staticPropertyDescriptors = staticPropertyDescriptors; }
  if (c) { descriptor.configuration = c; }
  if (dc) { descriptor.deepConfiguration = dc; }

  return descriptor;
};

/**
 * Creates new factory instance.
 * @param {Descriptor} descriptor The information about the object the factory will be creating.
 * @returns {Function} The new factory function.
 */
function createFactory(descriptor) {
  return function Stamp(options) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

    // Next line was optimized for most JS VMs. Please, be careful here!
    var obj = Object.create(descriptor.methods || null);

    merge(obj, descriptor.deepProperties);
    assign(obj, descriptor.properties);
    Object.defineProperties(obj, descriptor.propertyDescriptors || {});

    if (!descriptor.initializers || descriptor.initializers.length === 0) { return obj; }

    if (options === undefined) { options = {}; }
    var inits = descriptor.initializers;
    var length = inits.length;
    for (var i = 0; i < length; i += 1) {
      var initializer = inits[i];
      if (isFunction(initializer)) {
        var returnedValue = initializer.call(obj, options,
          {instance: obj, stamp: Stamp, args: [options].concat(args)});
        obj = returnedValue === undefined ? obj : returnedValue;
      }
    }

    return obj;
  };
}

/**
 * Returns a new stamp given a descriptor and a compose function implementation.
 * @param {Descriptor} [descriptor={}] The information about the object the stamp will be creating.
 * @param {Compose} composeFunction The "compose" function implementation.
 * @returns {Stamp}
 */
function createStamp(descriptor, composeFunction) {
  var Stamp = createFactory(descriptor);

  merge(Stamp, descriptor.staticDeepProperties);
  assign(Stamp, descriptor.staticProperties);
  Object.defineProperties(Stamp, descriptor.staticPropertyDescriptors || {});

  var composeImplementation = isFunction(Stamp.compose) ? Stamp.compose : composeFunction;
  Stamp.compose = function _compose() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    return composeImplementation.apply(this, args);
  };
  assign(Stamp.compose, descriptor);

  return Stamp;
}

/**
 * Mutates the dstDescriptor by merging the srcComposable data into it.
 * @param {Descriptor} dstDescriptor The descriptor object to merge into.
 * @param {Composable} [srcComposable] The composable
 * (either descriptor or stamp) to merge data form.
 * @returns {Descriptor} Returns the dstDescriptor argument.
 */
function mergeComposable(dstDescriptor, srcComposable) {
  var srcDescriptor = (srcComposable && srcComposable.compose) || srcComposable;
  if (!isObject(srcDescriptor)) { return dstDescriptor; }

  mergeAssign(dstDescriptor, srcDescriptor, 'methods');
  mergeAssign(dstDescriptor, srcDescriptor, 'properties');
  deepMergeAssign(dstDescriptor, srcDescriptor, 'deepProperties');
  mergeAssign(dstDescriptor, srcDescriptor, 'propertyDescriptors');
  mergeAssign(dstDescriptor, srcDescriptor, 'staticProperties');
  deepMergeAssign(dstDescriptor, srcDescriptor, 'staticDeepProperties');
  mergeAssign(dstDescriptor, srcDescriptor, 'staticPropertyDescriptors');
  mergeAssign(dstDescriptor, srcDescriptor, 'configuration');
  deepMergeAssign(dstDescriptor, srcDescriptor, 'deepConfiguration');
  concatAssignFunctions(dstDescriptor, srcDescriptor.initializers, 'initializers');

  return dstDescriptor;
}

/**
 * Given the list of composables (stamp descriptors and stamps) returns
 * a new stamp (composable factory function).
 * @typedef {Function} Compose
 * @param {...(Composable)} [composables] The list of composables.
 * @returns {Stamp} A new stamp (aka composable factory function)
 */
function compose() {
  var composables = [], len = arguments.length;
  while ( len-- ) composables[ len ] = arguments[ len ];

  var descriptor = [this]
    .concat(composables)
    .filter(isObject)
    .reduce(mergeComposable, {});
  return createStamp(descriptor, compose);
}


/**
 * The Stamp Descriptor
 * @typedef {Function|Object} Descriptor
 * @returns {Stamp} A new stamp based on this Stamp
 * @property {Object} [methods] Methods or other data used as object instances' prototype
 * @property {Array<Function>} [initializers] List of initializers called for each object instance
 * @property {Object} [properties] Shallow assigned properties of object instances
 * @property {Object} [deepProperties] Deeply merged properties of object instances
 * @property {Object} [staticProperties] Shallow assigned properties of Stamps
 * @property {Object} [staticDeepProperties] Deeply merged properties of Stamps
 * @property {Object} [configuration] Shallow assigned properties of Stamp arbitrary metadata
 * @property {Object} [deepConfiguration] Deeply merged properties of Stamp arbitrary metadata
 * @property {Object} [propertyDescriptors] ES5 Property Descriptors applied to object instances
 * @property {Object} [staticPropertyDescriptors] ES5 Property Descriptors applied to Stamps
 */

/**
 * The Stamp factory function
 * @typedef {Function} Stamp
 * @returns {*} Instantiated object
 * @property {Descriptor} compose - The Stamp descriptor and composition function
 */

/**
 * A composable object - stamp or descriptor
 * @typedef {Stamp|Descriptor} Composable
 */

/**
 * Returns true if argument is a stamp.
 * @param {*} obj
 * @returns {Boolean}
 */
function isStamp(obj) {
  return isFunction(obj) && isFunction(obj.compose);
}

function createUtilityFunction(propName, action) {
  return function composeUtil() {
    var i = arguments.length, argsArray = Array(i);
    while ( i-- ) argsArray[i] = arguments[i];

    return ((this && this.compose) || stampit).call(this, ( obj = {}, obj[propName] = action.apply(void 0, [ {} ].concat( argsArray )), obj ));
    var obj;
  };
}

var methods = createUtilityFunction('methods', assign);

var properties = createUtilityFunction('properties', assign);
function initializers() {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return ((this && this.compose) || stampit).call(this, {
    initializers: extractFunctions.apply(void 0, args)
  });
}
function composers() {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return ((this && this.compose) || stampit).call(this, {
    composers: extractFunctions.apply(void 0, args)
  });
}

var deepProperties = createUtilityFunction('deepProperties', merge);
var staticProperties = createUtilityFunction('staticProperties', assign);
var staticDeepProperties = createUtilityFunction('staticDeepProperties', merge);
var configuration = createUtilityFunction('configuration', assign);
var deepConfiguration = createUtilityFunction('deepConfiguration', merge);
var propertyDescriptors = createUtilityFunction('propertyDescriptors', assign);

var staticPropertyDescriptors = createUtilityFunction('staticPropertyDescriptors', assign);

var allUtilities = {
  methods: methods,

  properties: properties,
  refs: properties,
  props: properties,

  initializers: initializers,
  init: initializers,

  composers: composers,

  deepProperties: deepProperties,
  deepProps: deepProperties,

  staticProperties: staticProperties,
  statics: staticProperties,

  staticDeepProperties: staticDeepProperties,
  deepStatics: staticDeepProperties,

  configuration: configuration,
  conf: configuration,

  deepConfiguration: deepConfiguration,
  deepConf: deepConfiguration,

  propertyDescriptors: propertyDescriptors,

  staticPropertyDescriptors: staticPropertyDescriptors
};

/**
 * Infected stamp. Used as a storage of the infection metadata
 * @type {Function}
 * @return {Stamp}
 */
var baseStampit = compose(
  {staticProperties: allUtilities},
  {
    staticProperties: {
      create: function create() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return this.apply(void 0, args);
      },
      compose: stampit // infecting
    }
  }
);

/**
 * Infected compose
 * @param {...(Composable)} [args] The list of composables.
 * @return {Stamp}
 */
function stampit() {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var composables = args.filter(isObject)
    .map(function (arg) { return isStamp(arg) ? arg : standardiseDescriptor(arg); });

  // Calling the standard pure compose function here.
  var stamp = compose.apply(this || baseStampit, composables);

  var composerFunctions = stamp.compose.deepConfiguration &&
    stamp.compose.deepConfiguration.composers;
  if (isArray(composerFunctions) && composerFunctions.length > 0) {
    var uniqueComposers = [];
    for (var i = 0; i < composerFunctions.length; i += 1) {
      var composer = composerFunctions[i];
      if (isFunction(composer) && uniqueComposers.indexOf(composer) < 0) {
        uniqueComposers.push(composer);
      }
    }
    stamp.compose.deepConfiguration.composers = uniqueComposers;

    if (isStamp(this)) { composables.unshift(this); }
    for (var i$1 = 0; i$1 < uniqueComposers.length; i$1 += 1) {
      var composer$1 = uniqueComposers[i$1];
      var returnedValue = composer$1({stamp: stamp, composables: composables});
      stamp = isStamp(returnedValue) ? returnedValue : stamp;
    }
  }

  return stamp;
}

var exportedCompose = stampit.bind(); // bind to 'undefined'
stampit.compose = exportedCompose;

// Setting up the shortcut functions
var stampit$1 = assign(stampit, allUtilities);

exports.methods = methods;
exports.properties = properties;
exports.refs = properties;
exports.props = properties;
exports.initializers = initializers;
exports.init = initializers;
exports.composers = composers;
exports.deepProperties = deepProperties;
exports.deepProps = deepProperties;
exports.staticProperties = staticProperties;
exports.statics = staticProperties;
exports.staticDeepProperties = staticDeepProperties;
exports.deepStatics = staticDeepProperties;
exports.configuration = configuration;
exports.conf = configuration;
exports.deepConfiguration = deepConfiguration;
exports.deepConf = deepConfiguration;
exports.propertyDescriptors = propertyDescriptors;
exports.staticPropertyDescriptors = staticPropertyDescriptors;
exports.compose = exportedCompose;
exports['default'] = stampit$1;
module.exports = exports['default'];


},{}],690:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = require('events').EventEmitter;
var inherits = require('inherits');

inherits(Stream, EE);
Stream.Readable = require('readable-stream/readable.js');
Stream.Writable = require('readable-stream/writable.js');
Stream.Duplex = require('readable-stream/duplex.js');
Stream.Transform = require('readable-stream/transform.js');
Stream.PassThrough = require('readable-stream/passthrough.js');

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"events":584,"inherits":622,"readable-stream/duplex.js":659,"readable-stream/passthrough.js":670,"readable-stream/readable.js":671,"readable-stream/transform.js":672,"readable-stream/writable.js":673}],691:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Buffer = require('buffer').Buffer;

var isBufferEncoding = Buffer.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     }


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
var StringDecoder = exports.StringDecoder = function(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
};


// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}

},{"buffer":96}],692:[function(require,module,exports){
function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;

},{}],693:[function(require,module,exports){
(function (global){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],694:[function(require,module,exports){
module.exports = require('./lib/visibility.timers.js')

},{"./lib/visibility.timers.js":696}],695:[function(require,module,exports){
;(function (global) {
    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);

},{}],696:[function(require,module,exports){
;(function (window) {
    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(require('./visibility.core'));
    } else {
        install(window.Visibility || require('./visibility.core'))
    }

})(window);

},{"./visibility.core":695}],697:[function(require,module,exports){
;(function () {

  var vSortable = {}
  var Sortable = typeof require === 'function'
      ? require('sortablejs')
      : window.Sortable

  if (!Sortable) {
    throw new Error('[vue-sortable] cannot locate Sortable.js.')
  }

  // exposed global options
  vSortable.config = {}

  vSortable.install = function (Vue) {
    Vue.directive('sortable', function (options) {
      options = options || {}

      var sortable = new Sortable(this.el, options)

      if (this.arg && !this.vm.sortable) {
        this.vm.sortable = {}
      }

      //  Throw an error if the given ID is not unique
      if (this.arg && this.vm.sortable[this.arg]) {
        console.warn('[vue-sortable] cannot set already defined sortable id: \'' + this.arg + '\'')
      } else if( this.arg ) {
        this.vm.sortable[this.arg] = sortable
      }
    })
  }

  if (typeof exports == "object") {
    module.exports = vSortable
  } else if (typeof define == "function" && define.amd) {
    define([], function () {
      return vSortable
    })
  } else if (window.Vue) {
    window.vSortable = vSortable
    Vue.use(vSortable)
  }

})()

},{"sortablejs":688}],698:[function(require,module,exports){
(function (process){
/*!
 * Vue.js v1.0.28
 * (c) 2016 Evan You
 * Released under the MIT License.
 */
'use strict';

function set(obj, key, val) {
  if (hasOwn(obj, key)) {
    obj[key] = val;
    return;
  }
  if (obj._isVue) {
    set(obj._data, key, val);
    return;
  }
  var ob = obj.__ob__;
  if (!ob) {
    obj[key] = val;
    return;
  }
  ob.convert(key, val);
  ob.dep.notify();
  if (ob.vms) {
    var i = ob.vms.length;
    while (i--) {
      var vm = ob.vms[i];
      vm._proxy(key);
      vm._digest();
    }
  }
  return val;
}

/**
 * Delete a property and trigger change if necessary.
 *
 * @param {Object} obj
 * @param {String} key
 */

function del(obj, key) {
  if (!hasOwn(obj, key)) {
    return;
  }
  delete obj[key];
  var ob = obj.__ob__;
  if (!ob) {
    if (obj._isVue) {
      delete obj._data[key];
      obj._digest();
    }
    return;
  }
  ob.dep.notify();
  if (ob.vms) {
    var i = ob.vms.length;
    while (i--) {
      var vm = ob.vms[i];
      vm._unproxy(key);
      vm._digest();
    }
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Check whether the object has the property.
 *
 * @param {Object} obj
 * @param {String} key
 * @return {Boolean}
 */

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}

/**
 * Check if an expression is a literal value.
 *
 * @param {String} exp
 * @return {Boolean}
 */

var literalValueRE = /^\s?(true|false|-?[\d\.]+|'[^']*'|"[^"]*")\s?$/;

function isLiteral(exp) {
  return literalValueRE.test(exp);
}

/**
 * Check if a string starts with $ or _
 *
 * @param {String} str
 * @return {Boolean}
 */

function isReserved(str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F;
}

/**
 * Guard text output, make sure undefined outputs
 * empty string
 *
 * @param {*} value
 * @return {String}
 */

function _toString(value) {
  return value == null ? '' : value.toString();
}

/**
 * Check and convert possible numeric strings to numbers
 * before setting back to data
 *
 * @param {*} value
 * @return {*|Number}
 */

function toNumber(value) {
  if (typeof value !== 'string') {
    return value;
  } else {
    var parsed = Number(value);
    return isNaN(parsed) ? value : parsed;
  }
}

/**
 * Convert string boolean literals into real booleans.
 *
 * @param {*} value
 * @return {*|Boolean}
 */

function toBoolean(value) {
  return value === 'true' ? true : value === 'false' ? false : value;
}

/**
 * Strip quotes from a string
 *
 * @param {String} str
 * @return {String | false}
 */

function stripQuotes(str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}

/**
 * Camelize a hyphen-delimited string.
 *
 * @param {String} str
 * @return {String}
 */

var camelizeRE = /-(\w)/g;

function camelize(str) {
  return str.replace(camelizeRE, toUpper);
}

function toUpper(_, c) {
  return c ? c.toUpperCase() : '';
}

/**
 * Hyphenate a camelCase string.
 *
 * @param {String} str
 * @return {String}
 */

var hyphenateRE = /([^-])([A-Z])/g;

function hyphenate(str) {
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
}

/**
 * Converts hyphen/underscore/slash delimitered names into
 * camelized classNames.
 *
 * e.g. my-component => MyComponent
 *      some_else    => SomeElse
 *      some/comp    => SomeComp
 *
 * @param {String} str
 * @return {String}
 */

var classifyRE = /(?:^|[-_\/])(\w)/g;

function classify(str) {
  return str.replace(classifyRE, toUpper);
}

/**
 * Simple bind, faster than native
 *
 * @param {Function} fn
 * @param {Object} ctx
 * @return {Function}
 */

function bind(fn, ctx) {
  return function (a) {
    var l = arguments.length;
    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
  };
}

/**
 * Convert an Array-like object to a real Array.
 *
 * @param {Array-like} list
 * @param {Number} [start] - start index
 * @return {Array}
 */

function toArray(list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret;
}

/**
 * Mix properties into target object.
 *
 * @param {Object} to
 * @param {Object} from
 */

function extend(to, from) {
  var keys = Object.keys(from);
  var i = keys.length;
  while (i--) {
    to[keys[i]] = from[keys[i]];
  }
  return to;
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 *
 * @param {*} obj
 * @return {Boolean}
 */

function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 *
 * @param {*} obj
 * @return {Boolean}
 */

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';

function isPlainObject(obj) {
  return toString.call(obj) === OBJECT_STRING;
}

/**
 * Array type check.
 *
 * @param {*} obj
 * @return {Boolean}
 */

var isArray = Array.isArray;

/**
 * Define a property.
 *
 * @param {Object} obj
 * @param {String} key
 * @param {*} val
 * @param {Boolean} [enumerable]
 */

function def(obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Debounce a function so it only gets called after the
 * input stops arriving after the given wait period.
 *
 * @param {Function} func
 * @param {Number} wait
 * @return {Function} - the debounced function
 */

function _debounce(func, wait) {
  var timeout, args, context, timestamp, result;
  var later = function later() {
    var last = Date.now() - timestamp;
    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    }
  };
  return function () {
    context = this;
    args = arguments;
    timestamp = Date.now();
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }
    return result;
  };
}

/**
 * Manual indexOf because it's slightly faster than
 * native.
 *
 * @param {Array} arr
 * @param {*} obj
 */

function indexOf(arr, obj) {
  var i = arr.length;
  while (i--) {
    if (arr[i] === obj) return i;
  }
  return -1;
}

/**
 * Make a cancellable version of an async callback.
 *
 * @param {Function} fn
 * @return {Function}
 */

function cancellable(fn) {
  var cb = function cb() {
    if (!cb.cancelled) {
      return fn.apply(this, arguments);
    }
  };
  cb.cancel = function () {
    cb.cancelled = true;
  };
  return cb;
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 *
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 */

function looseEqual(a, b) {
  /* eslint-disable eqeqeq */
  return a == b || (isObject(a) && isObject(b) ? JSON.stringify(a) === JSON.stringify(b) : false);
  /* eslint-enable eqeqeq */
}

var hasProto = ('__proto__' in {});

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

// UA sniffing for working around browser-specific quirks
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && UA.indexOf('trident') > 0;
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);

var transitionProp = undefined;
var transitionEndEvent = undefined;
var animationProp = undefined;
var animationEndEvent = undefined;

// Transition property/event sniffing
if (inBrowser && !isIE9) {
  var isWebkitTrans = window.ontransitionend === undefined && window.onwebkittransitionend !== undefined;
  var isWebkitAnim = window.onanimationend === undefined && window.onwebkitanimationend !== undefined;
  transitionProp = isWebkitTrans ? 'WebkitTransition' : 'transition';
  transitionEndEvent = isWebkitTrans ? 'webkitTransitionEnd' : 'transitionend';
  animationProp = isWebkitAnim ? 'WebkitAnimation' : 'animation';
  animationEndEvent = isWebkitAnim ? 'webkitAnimationEnd' : 'animationend';
}

/* istanbul ignore next */
function isNative(Ctor) {
  return (/native code/.test(Ctor.toString())
  );
}

/**
 * Defer a task to execute it asynchronously. Ideally this
 * should be executed as a microtask, so we leverage
 * MutationObserver if it's available, and fallback to
 * setTimeout(0).
 *
 * @param {Function} cb
 * @param {Object} ctx
 */

var nextTick = (function () {
  var callbacks = [];
  var pending = false;
  var timerFunc = undefined;

  function nextTickHandler() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // the nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore if */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();
    var noop = function noop() {};
    timerFunc = function () {
      p.then(nextTickHandler);
      // in problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS) setTimeout(noop);
    };
  } else if (typeof MutationObserver !== 'undefined') {
    // use MutationObserver where native Promise is not available,
    // e.g. IE11, iOS7, Android 4.4
    var counter = 1;
    var observer = new MutationObserver(nextTickHandler);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });
    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };
  } else {
    // fallback to setTimeout
    /* istanbul ignore next */
    timerFunc = setTimeout;
  }

  return function (cb, ctx) {
    var func = ctx ? function () {
      cb.call(ctx);
    } : cb;
    callbacks.push(func);
    if (pending) return;
    pending = true;
    timerFunc(nextTickHandler, 0);
  };
})();

var _Set = undefined;
/* istanbul ignore if */
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = function () {
    this.set = Object.create(null);
  };
  _Set.prototype.has = function (key) {
    return this.set[key] !== undefined;
  };
  _Set.prototype.add = function (key) {
    this.set[key] = 1;
  };
  _Set.prototype.clear = function () {
    this.set = Object.create(null);
  };
}

function Cache(limit) {
  this.size = 0;
  this.limit = limit;
  this.head = this.tail = undefined;
  this._keymap = Object.create(null);
}

var p = Cache.prototype;

/**
 * Put <value> into the cache associated with <key>.
 * Returns the entry which was removed to make room for
 * the new entry. Otherwise undefined is returned.
 * (i.e. if there was enough room already).
 *
 * @param {String} key
 * @param {*} value
 * @return {Entry|undefined}
 */

p.put = function (key, value) {
  var removed;

  var entry = this.get(key, true);
  if (!entry) {
    if (this.size === this.limit) {
      removed = this.shift();
    }
    entry = {
      key: key
    };
    this._keymap[key] = entry;
    if (this.tail) {
      this.tail.newer = entry;
      entry.older = this.tail;
    } else {
      this.head = entry;
    }
    this.tail = entry;
    this.size++;
  }
  entry.value = value;

  return removed;
};

/**
 * Purge the least recently used (oldest) entry from the
 * cache. Returns the removed entry or undefined if the
 * cache was empty.
 */

p.shift = function () {
  var entry = this.head;
  if (entry) {
    this.head = this.head.newer;
    this.head.older = undefined;
    entry.newer = entry.older = undefined;
    this._keymap[entry.key] = undefined;
    this.size--;
  }
  return entry;
};

/**
 * Get and register recent use of <key>. Returns the value
 * associated with <key> or undefined if not in cache.
 *
 * @param {String} key
 * @param {Boolean} returnEntry
 * @return {Entry|*}
 */

p.get = function (key, returnEntry) {
  var entry = this._keymap[key];
  if (entry === undefined) return;
  if (entry === this.tail) {
    return returnEntry ? entry : entry.value;
  }
  // HEAD--------------TAIL
  //   <.older   .newer>
  //  <--- add direction --
  //   A  B  C  <D>  E
  if (entry.newer) {
    if (entry === this.head) {
      this.head = entry.newer;
    }
    entry.newer.older = entry.older; // C <-- E.
  }
  if (entry.older) {
    entry.older.newer = entry.newer; // C. --> E
  }
  entry.newer = undefined; // D --x
  entry.older = this.tail; // D. --> E
  if (this.tail) {
    this.tail.newer = entry; // E. <-- D
  }
  this.tail = entry;
  return returnEntry ? entry : entry.value;
};

var cache$1 = new Cache(1000);
var reservedArgRE = /^in$|^-?\d+/;

/**
 * Parser state
 */

var str;
var dir;
var len;
var index;
var chr;
var state;
var startState = 0;
var filterState = 1;
var filterNameState = 2;
var filterArgState = 3;

var doubleChr = 0x22;
var singleChr = 0x27;
var pipeChr = 0x7C;
var escapeChr = 0x5C;
var spaceChr = 0x20;

var expStartChr = { 0x5B: 1, 0x7B: 1, 0x28: 1 };
var expChrPair = { 0x5B: 0x5D, 0x7B: 0x7D, 0x28: 0x29 };

function peek() {
  return str.charCodeAt(index + 1);
}

function next() {
  return str.charCodeAt(++index);
}

function eof() {
  return index >= len;
}

function eatSpace() {
  while (peek() === spaceChr) {
    next();
  }
}

function isStringStart(chr) {
  return chr === doubleChr || chr === singleChr;
}

function isExpStart(chr) {
  return expStartChr[chr];
}

function isExpEnd(start, chr) {
  return expChrPair[start] === chr;
}

function parseString() {
  var stringQuote = next();
  var chr;
  while (!eof()) {
    chr = next();
    // escape char
    if (chr === escapeChr) {
      next();
    } else if (chr === stringQuote) {
      break;
    }
  }
}

function parseSpecialExp(chr) {
  var inExp = 0;
  var startChr = chr;

  while (!eof()) {
    chr = peek();
    if (isStringStart(chr)) {
      parseString();
      continue;
    }

    if (startChr === chr) {
      inExp++;
    }
    if (isExpEnd(startChr, chr)) {
      inExp--;
    }

    next();

    if (inExp === 0) {
      break;
    }
  }
}

/**
 * syntax:
 * expression | filterName  [arg  arg [| filterName arg arg]]
 */

function parseExpression() {
  var start = index;
  while (!eof()) {
    chr = peek();
    if (isStringStart(chr)) {
      parseString();
    } else if (isExpStart(chr)) {
      parseSpecialExp(chr);
    } else if (chr === pipeChr) {
      next();
      chr = peek();
      if (chr === pipeChr) {
        next();
      } else {
        if (state === startState || state === filterArgState) {
          state = filterState;
        }
        break;
      }
    } else if (chr === spaceChr && (state === filterNameState || state === filterArgState)) {
      eatSpace();
      break;
    } else {
      if (state === filterState) {
        state = filterNameState;
      }
      next();
    }
  }

  return str.slice(start + 1, index) || null;
}

function parseFilterList() {
  var filters = [];
  while (!eof()) {
    filters.push(parseFilter());
  }
  return filters;
}

function parseFilter() {
  var filter = {};
  var args;

  state = filterState;
  filter.name = parseExpression().trim();

  state = filterArgState;
  args = parseFilterArguments();

  if (args.length) {
    filter.args = args;
  }
  return filter;
}

function parseFilterArguments() {
  var args = [];
  while (!eof() && state !== filterState) {
    var arg = parseExpression();
    if (!arg) {
      break;
    }
    args.push(processFilterArg(arg));
  }

  return args;
}

/**
 * Check if an argument is dynamic and strip quotes.
 *
 * @param {String} arg
 * @return {Object}
 */

function processFilterArg(arg) {
  if (reservedArgRE.test(arg)) {
    return {
      value: toNumber(arg),
      dynamic: false
    };
  } else {
    var stripped = stripQuotes(arg);
    var dynamic = stripped === arg;
    return {
      value: dynamic ? arg : stripped,
      dynamic: dynamic
    };
  }
}

/**
 * Parse a directive value and extract the expression
 * and its filters into a descriptor.
 *
 * Example:
 *
 * "a + 1 | uppercase" will yield:
 * {
 *   expression: 'a + 1',
 *   filters: [
 *     { name: 'uppercase', args: null }
 *   ]
 * }
 *
 * @param {String} s
 * @return {Object}
 */

function parseDirective(s) {
  var hit = cache$1.get(s);
  if (hit) {
    return hit;
  }

  // reset parser state
  str = s;
  dir = {};
  len = str.length;
  index = -1;
  chr = '';
  state = startState;

  var filters;

  if (str.indexOf('|') < 0) {
    dir.expression = str.trim();
  } else {
    dir.expression = parseExpression().trim();
    filters = parseFilterList();
    if (filters.length) {
      dir.filters = filters;
    }
  }

  cache$1.put(s, dir);
  return dir;
}

var directive = Object.freeze({
  parseDirective: parseDirective
});

var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
var cache = undefined;
var tagRE = undefined;
var htmlRE = undefined;
/**
 * Escape a string so it can be used in a RegExp
 * constructor.
 *
 * @param {String} str
 */

function escapeRegex(str) {
  return str.replace(regexEscapeRE, '\\$&');
}

function compileRegex() {
  var open = escapeRegex(config.delimiters[0]);
  var close = escapeRegex(config.delimiters[1]);
  var unsafeOpen = escapeRegex(config.unsafeDelimiters[0]);
  var unsafeClose = escapeRegex(config.unsafeDelimiters[1]);
  tagRE = new RegExp(unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '|' + open + '((?:.|\\n)+?)' + close, 'g');
  htmlRE = new RegExp('^' + unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '$');
  // reset cache
  cache = new Cache(1000);
}

/**
 * Parse a template text string into an array of tokens.
 *
 * @param {String} text
 * @return {Array<Object> | null}
 *               - {String} type
 *               - {String} value
 *               - {Boolean} [html]
 *               - {Boolean} [oneTime]
 */

function parseText(text) {
  if (!cache) {
    compileRegex();
  }
  var hit = cache.get(text);
  if (hit) {
    return hit;
  }
  if (!tagRE.test(text)) {
    return null;
  }
  var tokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, html, value, first, oneTime;
  /* eslint-disable no-cond-assign */
  while (match = tagRE.exec(text)) {
    /* eslint-enable no-cond-assign */
    index = match.index;
    // push text token
    if (index > lastIndex) {
      tokens.push({
        value: text.slice(lastIndex, index)
      });
    }
    // tag token
    html = htmlRE.test(match[0]);
    value = html ? match[1] : match[2];
    first = value.charCodeAt(0);
    oneTime = first === 42; // *
    value = oneTime ? value.slice(1) : value;
    tokens.push({
      tag: true,
      value: value.trim(),
      html: html,
      oneTime: oneTime
    });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    tokens.push({
      value: text.slice(lastIndex)
    });
  }
  cache.put(text, tokens);
  return tokens;
}

/**
 * Format a list of tokens into an expression.
 * e.g. tokens parsed from 'a {{b}} c' can be serialized
 * into one single expression as '"a " + b + " c"'.
 *
 * @param {Array} tokens
 * @param {Vue} [vm]
 * @return {String}
 */

function tokensToExp(tokens, vm) {
  if (tokens.length > 1) {
    return tokens.map(function (token) {
      return formatToken(token, vm);
    }).join('+');
  } else {
    return formatToken(tokens[0], vm, true);
  }
}

/**
 * Format a single token.
 *
 * @param {Object} token
 * @param {Vue} [vm]
 * @param {Boolean} [single]
 * @return {String}
 */

function formatToken(token, vm, single) {
  return token.tag ? token.oneTime && vm ? '"' + vm.$eval(token.value) + '"' : inlineFilters(token.value, single) : '"' + token.value + '"';
}

/**
 * For an attribute with multiple interpolation tags,
 * e.g. attr="some-{{thing | filter}}", in order to combine
 * the whole thing into a single watchable expression, we
 * have to inline those filters. This function does exactly
 * that. This is a bit hacky but it avoids heavy changes
 * to directive parser and watcher mechanism.
 *
 * @param {String} exp
 * @param {Boolean} single
 * @return {String}
 */

var filterRE = /[^|]\|[^|]/;
function inlineFilters(exp, single) {
  if (!filterRE.test(exp)) {
    return single ? exp : '(' + exp + ')';
  } else {
    var dir = parseDirective(exp);
    if (!dir.filters) {
      return '(' + exp + ')';
    } else {
      return 'this._applyFilters(' + dir.expression + // value
      ',null,' + // oldValue (null for read)
      JSON.stringify(dir.filters) + // filter descriptors
      ',false)'; // write?
    }
  }
}

var text = Object.freeze({
  compileRegex: compileRegex,
  parseText: parseText,
  tokensToExp: tokensToExp
});

var delimiters = ['{{', '}}'];
var unsafeDelimiters = ['{{{', '}}}'];

var config = Object.defineProperties({

  /**
   * Whether to print debug messages.
   * Also enables stack trace for warnings.
   *
   * @type {Boolean}
   */

  debug: false,

  /**
   * Whether to suppress warnings.
   *
   * @type {Boolean}
   */

  silent: false,

  /**
   * Whether to use async rendering.
   */

  async: true,

  /**
   * Whether to warn against errors caught when evaluating
   * expressions.
   */

  warnExpressionErrors: true,

  /**
   * Whether to allow devtools inspection.
   * Disabled by default in production builds.
   */

  devtools: process.env.NODE_ENV !== 'production',

  /**
   * Internal flag to indicate the delimiters have been
   * changed.
   *
   * @type {Boolean}
   */

  _delimitersChanged: true,

  /**
   * List of asset types that a component can own.
   *
   * @type {Array}
   */

  _assetTypes: ['component', 'directive', 'elementDirective', 'filter', 'transition', 'partial'],

  /**
   * prop binding modes
   */

  _propBindingModes: {
    ONE_WAY: 0,
    TWO_WAY: 1,
    ONE_TIME: 2
  },

  /**
   * Max circular updates allowed in a batcher flush cycle.
   */

  _maxUpdateCount: 100

}, {
  delimiters: { /**
                 * Interpolation delimiters. Changing these would trigger
                 * the text parser to re-compile the regular expressions.
                 *
                 * @type {Array<String>}
                 */

    get: function get() {
      return delimiters;
    },
    set: function set(val) {
      delimiters = val;
      compileRegex();
    },
    configurable: true,
    enumerable: true
  },
  unsafeDelimiters: {
    get: function get() {
      return unsafeDelimiters;
    },
    set: function set(val) {
      unsafeDelimiters = val;
      compileRegex();
    },
    configurable: true,
    enumerable: true
  }
});

var warn = undefined;
var formatComponentName = undefined;

if (process.env.NODE_ENV !== 'production') {
  (function () {
    var hasConsole = typeof console !== 'undefined';

    warn = function (msg, vm) {
      if (hasConsole && !config.silent) {
        console.error('[Vue warn]: ' + msg + (vm ? formatComponentName(vm) : ''));
      }
    };

    formatComponentName = function (vm) {
      var name = vm._isVue ? vm.$options.name : vm.name;
      return name ? ' (found in component: <' + hyphenate(name) + '>)' : '';
    };
  })();
}

/**
 * Append with transition.
 *
 * @param {Element} el
 * @param {Element} target
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function appendWithTransition(el, target, vm, cb) {
  applyTransition(el, 1, function () {
    target.appendChild(el);
  }, vm, cb);
}

/**
 * InsertBefore with transition.
 *
 * @param {Element} el
 * @param {Element} target
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function beforeWithTransition(el, target, vm, cb) {
  applyTransition(el, 1, function () {
    before(el, target);
  }, vm, cb);
}

/**
 * Remove with transition.
 *
 * @param {Element} el
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function removeWithTransition(el, vm, cb) {
  applyTransition(el, -1, function () {
    remove(el);
  }, vm, cb);
}

/**
 * Apply transitions with an operation callback.
 *
 * @param {Element} el
 * @param {Number} direction
 *                  1: enter
 *                 -1: leave
 * @param {Function} op - the actual DOM operation
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function applyTransition(el, direction, op, vm, cb) {
  var transition = el.__v_trans;
  if (!transition ||
  // skip if there are no js hooks and CSS transition is
  // not supported
  !transition.hooks && !transitionEndEvent ||
  // skip transitions for initial compile
  !vm._isCompiled ||
  // if the vm is being manipulated by a parent directive
  // during the parent's compilation phase, skip the
  // animation.
  vm.$parent && !vm.$parent._isCompiled) {
    op();
    if (cb) cb();
    return;
  }
  var action = direction > 0 ? 'enter' : 'leave';
  transition[action](op, cb);
}

var transition = Object.freeze({
  appendWithTransition: appendWithTransition,
  beforeWithTransition: beforeWithTransition,
  removeWithTransition: removeWithTransition,
  applyTransition: applyTransition
});

/**
 * Query an element selector if it's not an element already.
 *
 * @param {String|Element} el
 * @return {Element}
 */

function query(el) {
  if (typeof el === 'string') {
    var selector = el;
    el = document.querySelector(el);
    if (!el) {
      process.env.NODE_ENV !== 'production' && warn('Cannot find element: ' + selector);
    }
  }
  return el;
}

/**
 * Check if a node is in the document.
 * Note: document.documentElement.contains should work here
 * but always returns false for comment nodes in phantomjs,
 * making unit tests difficult. This is fixed by doing the
 * contains() check on the node's parentNode instead of
 * the node itself.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function inDoc(node) {
  if (!node) return false;
  var doc = node.ownerDocument.documentElement;
  var parent = node.parentNode;
  return doc === node || doc === parent || !!(parent && parent.nodeType === 1 && doc.contains(parent));
}

/**
 * Get and remove an attribute from a node.
 *
 * @param {Node} node
 * @param {String} _attr
 */

function getAttr(node, _attr) {
  var val = node.getAttribute(_attr);
  if (val !== null) {
    node.removeAttribute(_attr);
  }
  return val;
}

/**
 * Get an attribute with colon or v-bind: prefix.
 *
 * @param {Node} node
 * @param {String} name
 * @return {String|null}
 */

function getBindAttr(node, name) {
  var val = getAttr(node, ':' + name);
  if (val === null) {
    val = getAttr(node, 'v-bind:' + name);
  }
  return val;
}

/**
 * Check the presence of a bind attribute.
 *
 * @param {Node} node
 * @param {String} name
 * @return {Boolean}
 */

function hasBindAttr(node, name) {
  return node.hasAttribute(name) || node.hasAttribute(':' + name) || node.hasAttribute('v-bind:' + name);
}

/**
 * Insert el before target
 *
 * @param {Element} el
 * @param {Element} target
 */

function before(el, target) {
  target.parentNode.insertBefore(el, target);
}

/**
 * Insert el after target
 *
 * @param {Element} el
 * @param {Element} target
 */

function after(el, target) {
  if (target.nextSibling) {
    before(el, target.nextSibling);
  } else {
    target.parentNode.appendChild(el);
  }
}

/**
 * Remove el from DOM
 *
 * @param {Element} el
 */

function remove(el) {
  el.parentNode.removeChild(el);
}

/**
 * Prepend el to target
 *
 * @param {Element} el
 * @param {Element} target
 */

function prepend(el, target) {
  if (target.firstChild) {
    before(el, target.firstChild);
  } else {
    target.appendChild(el);
  }
}

/**
 * Replace target with el
 *
 * @param {Element} target
 * @param {Element} el
 */

function replace(target, el) {
  var parent = target.parentNode;
  if (parent) {
    parent.replaceChild(el, target);
  }
}

/**
 * Add event listener shorthand.
 *
 * @param {Element} el
 * @param {String} event
 * @param {Function} cb
 * @param {Boolean} [useCapture]
 */

function on(el, event, cb, useCapture) {
  el.addEventListener(event, cb, useCapture);
}

/**
 * Remove event listener shorthand.
 *
 * @param {Element} el
 * @param {String} event
 * @param {Function} cb
 */

function off(el, event, cb) {
  el.removeEventListener(event, cb);
}

/**
 * For IE9 compat: when both class and :class are present
 * getAttribute('class') returns wrong value...
 *
 * @param {Element} el
 * @return {String}
 */

function getClass(el) {
  var classname = el.className;
  if (typeof classname === 'object') {
    classname = classname.baseVal || '';
  }
  return classname;
}

/**
 * In IE9, setAttribute('class') will result in empty class
 * if the element also has the :class attribute; However in
 * PhantomJS, setting `className` does not work on SVG elements...
 * So we have to do a conditional check here.
 *
 * @param {Element} el
 * @param {String} cls
 */

function setClass(el, cls) {
  /* istanbul ignore if */
  if (isIE9 && !/svg$/.test(el.namespaceURI)) {
    el.className = cls;
  } else {
    el.setAttribute('class', cls);
  }
}

/**
 * Add class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */

function addClass(el, cls) {
  if (el.classList) {
    el.classList.add(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      setClass(el, (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */

function removeClass(el, cls) {
  if (el.classList) {
    el.classList.remove(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    setClass(el, cur.trim());
  }
  if (!el.className) {
    el.removeAttribute('class');
  }
}

/**
 * Extract raw content inside an element into a temporary
 * container div
 *
 * @param {Element} el
 * @param {Boolean} asFragment
 * @return {Element|DocumentFragment}
 */

function extractContent(el, asFragment) {
  var child;
  var rawContent;
  /* istanbul ignore if */
  if (isTemplate(el) && isFragment(el.content)) {
    el = el.content;
  }
  if (el.hasChildNodes()) {
    trimNode(el);
    rawContent = asFragment ? document.createDocumentFragment() : document.createElement('div');
    /* eslint-disable no-cond-assign */
    while (child = el.firstChild) {
      /* eslint-enable no-cond-assign */
      rawContent.appendChild(child);
    }
  }
  return rawContent;
}

/**
 * Trim possible empty head/tail text and comment
 * nodes inside a parent.
 *
 * @param {Node} node
 */

function trimNode(node) {
  var child;
  /* eslint-disable no-sequences */
  while ((child = node.firstChild, isTrimmable(child))) {
    node.removeChild(child);
  }
  while ((child = node.lastChild, isTrimmable(child))) {
    node.removeChild(child);
  }
  /* eslint-enable no-sequences */
}

function isTrimmable(node) {
  return node && (node.nodeType === 3 && !node.data.trim() || node.nodeType === 8);
}

/**
 * Check if an element is a template tag.
 * Note if the template appears inside an SVG its tagName
 * will be in lowercase.
 *
 * @param {Element} el
 */

function isTemplate(el) {
  return el.tagName && el.tagName.toLowerCase() === 'template';
}

/**
 * Create an "anchor" for performing dom insertion/removals.
 * This is used in a number of scenarios:
 * - fragment instance
 * - v-html
 * - v-if
 * - v-for
 * - component
 *
 * @param {String} content
 * @param {Boolean} persist - IE trashes empty textNodes on
 *                            cloneNode(true), so in certain
 *                            cases the anchor needs to be
 *                            non-empty to be persisted in
 *                            templates.
 * @return {Comment|Text}
 */

function createAnchor(content, persist) {
  var anchor = config.debug ? document.createComment(content) : document.createTextNode(persist ? ' ' : '');
  anchor.__v_anchor = true;
  return anchor;
}

/**
 * Find a component ref attribute that starts with $.
 *
 * @param {Element} node
 * @return {String|undefined}
 */

var refRE = /^v-ref:/;

function findRef(node) {
  if (node.hasAttributes()) {
    var attrs = node.attributes;
    for (var i = 0, l = attrs.length; i < l; i++) {
      var name = attrs[i].name;
      if (refRE.test(name)) {
        return camelize(name.replace(refRE, ''));
      }
    }
  }
}

/**
 * Map a function to a range of nodes .
 *
 * @param {Node} node
 * @param {Node} end
 * @param {Function} op
 */

function mapNodeRange(node, end, op) {
  var next;
  while (node !== end) {
    next = node.nextSibling;
    op(node);
    node = next;
  }
  op(end);
}

/**
 * Remove a range of nodes with transition, store
 * the nodes in a fragment with correct ordering,
 * and call callback when done.
 *
 * @param {Node} start
 * @param {Node} end
 * @param {Vue} vm
 * @param {DocumentFragment} frag
 * @param {Function} cb
 */

function removeNodeRange(start, end, vm, frag, cb) {
  var done = false;
  var removed = 0;
  var nodes = [];
  mapNodeRange(start, end, function (node) {
    if (node === end) done = true;
    nodes.push(node);
    removeWithTransition(node, vm, onRemoved);
  });
  function onRemoved() {
    removed++;
    if (done && removed >= nodes.length) {
      for (var i = 0; i < nodes.length; i++) {
        frag.appendChild(nodes[i]);
      }
      cb && cb();
    }
  }
}

/**
 * Check if a node is a DocumentFragment.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function isFragment(node) {
  return node && node.nodeType === 11;
}

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 *
 * @param {Element} el
 * @return {String}
 */

function getOuterHTML(el) {
  if (el.outerHTML) {
    return el.outerHTML;
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML;
  }
}

var commonTagRE = /^(div|p|span|img|a|b|i|br|ul|ol|li|h1|h2|h3|h4|h5|h6|code|pre|table|th|td|tr|form|label|input|select|option|nav|article|section|header|footer)$/i;
var reservedTagRE = /^(slot|partial|component)$/i;

var isUnknownElement = undefined;
if (process.env.NODE_ENV !== 'production') {
  isUnknownElement = function (el, tag) {
    if (tag.indexOf('-') > -1) {
      // http://stackoverflow.com/a/28210364/1070244
      return el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    } else {
      return (/HTMLUnknownElement/.test(el.toString()) &&
        // Chrome returns unknown for several HTML5 elements.
        // https://code.google.com/p/chromium/issues/detail?id=540526
        // Firefox returns unknown for some "Interactive elements."
        !/^(data|time|rtc|rb|details|dialog|summary)$/.test(tag)
      );
    }
  };
}

/**
 * Check if an element is a component, if yes return its
 * component id.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Object|undefined}
 */

function checkComponentAttr(el, options) {
  var tag = el.tagName.toLowerCase();
  var hasAttrs = el.hasAttributes();
  if (!commonTagRE.test(tag) && !reservedTagRE.test(tag)) {
    if (resolveAsset(options, 'components', tag)) {
      return { id: tag };
    } else {
      var is = hasAttrs && getIsBinding(el, options);
      if (is) {
        return is;
      } else if (process.env.NODE_ENV !== 'production') {
        var expectedTag = options._componentNameMap && options._componentNameMap[tag];
        if (expectedTag) {
          warn('Unknown custom element: <' + tag + '> - ' + 'did you mean <' + expectedTag + '>? ' + 'HTML is case-insensitive, remember to use kebab-case in templates.');
        } else if (isUnknownElement(el, tag)) {
          warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.');
        }
      }
    }
  } else if (hasAttrs) {
    return getIsBinding(el, options);
  }
}

/**
 * Get "is" binding from an element.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Object|undefined}
 */

function getIsBinding(el, options) {
  // dynamic syntax
  var exp = el.getAttribute('is');
  if (exp != null) {
    if (resolveAsset(options, 'components', exp)) {
      el.removeAttribute('is');
      return { id: exp };
    }
  } else {
    exp = getBindAttr(el, 'is');
    if (exp != null) {
      return { id: exp, dynamic: true };
    }
  }
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 *
 * All strategy functions follow the same signature:
 *
 * @param {*} parentVal
 * @param {*} childVal
 * @param {Vue} [vm]
 */

var strats = config.optionMergeStrategies = Object.create(null);

/**
 * Helper that recursively merges two data objects together.
 */

function mergeData(to, from) {
  var key, toVal, fromVal;
  for (key in from) {
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isObject(toVal) && isObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to;
}

/**
 * Data
 */

strats.data = function (parentVal, childVal, vm) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal;
    }
    if (typeof childVal !== 'function') {
      process.env.NODE_ENV !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
      return parentVal;
    }
    if (!parentVal) {
      return childVal;
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn() {
      return mergeData(childVal.call(this), parentVal.call(this));
    };
  } else if (parentVal || childVal) {
    return function mergedInstanceDataFn() {
      // instance merge
      var instanceData = typeof childVal === 'function' ? childVal.call(vm) : childVal;
      var defaultData = typeof parentVal === 'function' ? parentVal.call(vm) : undefined;
      if (instanceData) {
        return mergeData(instanceData, defaultData);
      } else {
        return defaultData;
      }
    };
  }
};

/**
 * El
 */

strats.el = function (parentVal, childVal, vm) {
  if (!vm && childVal && typeof childVal !== 'function') {
    process.env.NODE_ENV !== 'production' && warn('The "el" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
    return;
  }
  var ret = childVal || parentVal;
  // invoke the element factory if this is instance merge
  return vm && typeof ret === 'function' ? ret.call(vm) : ret;
};

/**
 * Hooks and param attributes are merged as arrays.
 */

strats.init = strats.created = strats.ready = strats.attached = strats.detached = strats.beforeCompile = strats.compiled = strats.beforeDestroy = strats.destroyed = strats.activate = function (parentVal, childVal) {
  return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
};

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */

function mergeAssets(parentVal, childVal) {
  var res = Object.create(parentVal || null);
  return childVal ? extend(res, guardArrayAssets(childVal)) : res;
}

config._assetTypes.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Events & Watchers.
 *
 * Events & watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */

strats.watch = strats.events = function (parentVal, childVal) {
  if (!childVal) return parentVal;
  if (!parentVal) return childVal;
  var ret = {};
  extend(ret, parentVal);
  for (var key in childVal) {
    var parent = ret[key];
    var child = childVal[key];
    if (parent && !isArray(parent)) {
      parent = [parent];
    }
    ret[key] = parent ? parent.concat(child) : [child];
  }
  return ret;
};

/**
 * Other object hashes.
 */

strats.props = strats.methods = strats.computed = function (parentVal, childVal) {
  if (!childVal) return parentVal;
  if (!parentVal) return childVal;
  var ret = Object.create(null);
  extend(ret, parentVal);
  extend(ret, childVal);
  return ret;
};

/**
 * Default strategy.
 */

var defaultStrat = function defaultStrat(parentVal, childVal) {
  return childVal === undefined ? parentVal : childVal;
};

/**
 * Make sure component options get converted to actual
 * constructors.
 *
 * @param {Object} options
 */

function guardComponents(options) {
  if (options.components) {
    var components = options.components = guardArrayAssets(options.components);
    var ids = Object.keys(components);
    var def;
    if (process.env.NODE_ENV !== 'production') {
      var map = options._componentNameMap = {};
    }
    for (var i = 0, l = ids.length; i < l; i++) {
      var key = ids[i];
      if (commonTagRE.test(key) || reservedTagRE.test(key)) {
        process.env.NODE_ENV !== 'production' && warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + key);
        continue;
      }
      // record a all lowercase <-> kebab-case mapping for
      // possible custom element case error warning
      if (process.env.NODE_ENV !== 'production') {
        map[key.replace(/-/g, '').toLowerCase()] = hyphenate(key);
      }
      def = components[key];
      if (isPlainObject(def)) {
        components[key] = Vue.extend(def);
      }
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 *
 * @param {Object} options
 */

function guardProps(options) {
  var props = options.props;
  var i, val;
  if (isArray(props)) {
    options.props = {};
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        options.props[val] = null;
      } else if (val.name) {
        options.props[val.name] = val;
      }
    }
  } else if (isPlainObject(props)) {
    var keys = Object.keys(props);
    i = keys.length;
    while (i--) {
      val = props[keys[i]];
      if (typeof val === 'function') {
        props[keys[i]] = { type: val };
      }
    }
  }
}

/**
 * Guard an Array-format assets option and converted it
 * into the key-value Object format.
 *
 * @param {Object|Array} assets
 * @return {Object}
 */

function guardArrayAssets(assets) {
  if (isArray(assets)) {
    var res = {};
    var i = assets.length;
    var asset;
    while (i--) {
      asset = assets[i];
      var id = typeof asset === 'function' ? asset.options && asset.options.name || asset.id : asset.name || asset.id;
      if (!id) {
        process.env.NODE_ENV !== 'production' && warn('Array-syntax assets must provide a "name" or "id" field.');
      } else {
        res[id] = asset;
      }
    }
    return res;
  }
  return assets;
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 *
 * @param {Object} parent
 * @param {Object} child
 * @param {Vue} [vm] - if vm is present, indicates this is
 *                     an instantiation merge.
 */

function mergeOptions(parent, child, vm) {
  guardComponents(child);
  guardProps(child);
  if (process.env.NODE_ENV !== 'production') {
    if (child.propsData && !vm) {
      warn('propsData can only be used as an instantiation option.');
    }
  }
  var options = {};
  var key;
  if (child['extends']) {
    parent = typeof child['extends'] === 'function' ? mergeOptions(parent, child['extends'].options, vm) : mergeOptions(parent, child['extends'], vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      var mixin = child.mixins[i];
      var mixinOptions = mixin.prototype instanceof Vue ? mixin.options : mixin;
      parent = mergeOptions(parent, mixinOptions, vm);
    }
  }
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField(key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options;
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 *
 * @param {Object} options
 * @param {String} type
 * @param {String} id
 * @param {Boolean} warnMissing
 * @return {Object|Function}
 */

function resolveAsset(options, type, id, warnMissing) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return;
  }
  var assets = options[type];
  var camelizedId;
  var res = assets[id] ||
  // camelCase ID
  assets[camelizedId = camelize(id)] ||
  // Pascal Case ID
  assets[camelizedId.charAt(0).toUpperCase() + camelizedId.slice(1)];
  if (process.env.NODE_ENV !== 'production' && warnMissing && !res) {
    warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
  }
  return res;
}

var uid$1 = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 *
 * @constructor
 */
function Dep() {
  this.id = uid$1++;
  this.subs = [];
}

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;

/**
 * Add a directive subscriber.
 *
 * @param {Directive} sub
 */

Dep.prototype.addSub = function (sub) {
  this.subs.push(sub);
};

/**
 * Remove a directive subscriber.
 *
 * @param {Directive} sub
 */

Dep.prototype.removeSub = function (sub) {
  this.subs.$remove(sub);
};

/**
 * Add self as a dependency to the target watcher.
 */

Dep.prototype.depend = function () {
  Dep.target.addDep(this);
};

/**
 * Notify all subscribers of a new value.
 */

Dep.prototype.notify = function () {
  // stablize the subscriber list first
  var subs = toArray(this.subs);
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto)

/**
 * Intercept mutating methods and emit events
 */

;['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'].forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator() {
    // avoid leaking arguments:
    // http://jsperf.com/closure-with-arguments
    var i = arguments.length;
    var args = new Array(i);
    while (i--) {
      args[i] = arguments[i];
    }
    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
        inserted = args;
        break;
      case 'unshift':
        inserted = args;
        break;
      case 'splice':
        inserted = args.slice(2);
        break;
    }
    if (inserted) ob.observeArray(inserted);
    // notify change
    ob.dep.notify();
    return result;
  });
});

/**
 * Swap the element at the given index with a new value
 * and emits corresponding event.
 *
 * @param {Number} index
 * @param {*} val
 * @return {*} - replaced element
 */

def(arrayProto, '$set', function $set(index, val) {
  if (index >= this.length) {
    this.length = Number(index) + 1;
  }
  return this.splice(index, 1, val)[0];
});

/**
 * Convenience method to remove the element at given index or target element reference.
 *
 * @param {*} item
 */

def(arrayProto, '$remove', function $remove(item) {
  /* istanbul ignore if */
  if (!this.length) return;
  var index = indexOf(this, item);
  if (index > -1) {
    return this.splice(index, 1);
  }
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However in certain cases, e.g.
 * v-for scope alias and props, we don't want to force conversion
 * because the value may be a nested value under a frozen data structure.
 *
 * So whenever we want to set a reactive property without forcing
 * conversion on the new value, we wrap that call inside this function.
 */

var shouldConvert = true;

function withoutConversion(fn) {
  shouldConvert = false;
  fn();
  shouldConvert = true;
}

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 *
 * @param {Array|Object} value
 * @constructor
 */

function Observer(value) {
  this.value = value;
  this.dep = new Dep();
  def(value, '__ob__', this);
  if (isArray(value)) {
    var augment = hasProto ? protoAugment : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
}

// Instance methods

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 *
 * @param {Object} obj
 */

Observer.prototype.walk = function (obj) {
  var keys = Object.keys(obj);
  for (var i = 0, l = keys.length; i < l; i++) {
    this.convert(keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 *
 * @param {Array} items
 */

Observer.prototype.observeArray = function (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

/**
 * Convert a property into getter/setter so we can emit
 * the events when the property is accessed/changed.
 *
 * @param {String} key
 * @param {*} val
 */

Observer.prototype.convert = function (key, val) {
  defineReactive(this.value, key, val);
};

/**
 * Add an owner vm, so that when $set/$delete mutations
 * happen we can notify owner vms to proxy the keys and
 * digest the watchers. This is only called when the object
 * is observed as an instance's root $data.
 *
 * @param {Vue} vm
 */

Observer.prototype.addVm = function (vm) {
  (this.vms || (this.vms = [])).push(vm);
};

/**
 * Remove an owner vm. This is called when the object is
 * swapped out as an instance's $data object.
 *
 * @param {Vue} vm
 */

Observer.prototype.removeVm = function (vm) {
  this.vms.$remove(vm);
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 *
 * @param {Object|Array} target
 * @param {Object} src
 */

function protoAugment(target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 *
 * @param {Object|Array} target
 * @param {Object} proto
 */

function copyAugment(target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 *
 * @param {*} value
 * @param {Vue} [vm]
 * @return {Observer|undefined}
 * @static
 */

function observe(value, vm) {
  if (!value || typeof value !== 'object') {
    return;
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (shouldConvert && (isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
    ob = new Observer(value);
  }
  if (ob && vm) {
    ob.addVm(vm);
  }
  return ob;
}

/**
 * Define a reactive property on an Object.
 *
 * @param {Object} obj
 * @param {String} key
 * @param {*} val
 */

function defineReactive(obj, key, val) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return;
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter() {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
        }
        if (isArray(value)) {
          for (var e, i = 0, l = value.length; i < l; i++) {
            e = value[i];
            e && e.__ob__ && e.__ob__.dep.depend();
          }
        }
      }
      return value;
    },
    set: function reactiveSetter(newVal) {
      var value = getter ? getter.call(obj) : val;
      if (newVal === value) {
        return;
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = observe(newVal);
      dep.notify();
    }
  });
}



var util = Object.freeze({
	defineReactive: defineReactive,
	set: set,
	del: del,
	hasOwn: hasOwn,
	isLiteral: isLiteral,
	isReserved: isReserved,
	_toString: _toString,
	toNumber: toNumber,
	toBoolean: toBoolean,
	stripQuotes: stripQuotes,
	camelize: camelize,
	hyphenate: hyphenate,
	classify: classify,
	bind: bind,
	toArray: toArray,
	extend: extend,
	isObject: isObject,
	isPlainObject: isPlainObject,
	def: def,
	debounce: _debounce,
	indexOf: indexOf,
	cancellable: cancellable,
	looseEqual: looseEqual,
	isArray: isArray,
	hasProto: hasProto,
	inBrowser: inBrowser,
	devtools: devtools,
	isIE: isIE,
	isIE9: isIE9,
	isAndroid: isAndroid,
	isIOS: isIOS,
	get transitionProp () { return transitionProp; },
	get transitionEndEvent () { return transitionEndEvent; },
	get animationProp () { return animationProp; },
	get animationEndEvent () { return animationEndEvent; },
	nextTick: nextTick,
	get _Set () { return _Set; },
	query: query,
	inDoc: inDoc,
	getAttr: getAttr,
	getBindAttr: getBindAttr,
	hasBindAttr: hasBindAttr,
	before: before,
	after: after,
	remove: remove,
	prepend: prepend,
	replace: replace,
	on: on,
	off: off,
	setClass: setClass,
	addClass: addClass,
	removeClass: removeClass,
	extractContent: extractContent,
	trimNode: trimNode,
	isTemplate: isTemplate,
	createAnchor: createAnchor,
	findRef: findRef,
	mapNodeRange: mapNodeRange,
	removeNodeRange: removeNodeRange,
	isFragment: isFragment,
	getOuterHTML: getOuterHTML,
	mergeOptions: mergeOptions,
	resolveAsset: resolveAsset,
	checkComponentAttr: checkComponentAttr,
	commonTagRE: commonTagRE,
	reservedTagRE: reservedTagRE,
	get warn () { return warn; }
});

var uid = 0;

function initMixin (Vue) {
  /**
   * The main init sequence. This is called for every
   * instance, including ones that are created from extended
   * constructors.
   *
   * @param {Object} options - this options object should be
   *                           the result of merging class
   *                           options and the options passed
   *                           in to the constructor.
   */

  Vue.prototype._init = function (options) {
    options = options || {};

    this.$el = null;
    this.$parent = options.parent;
    this.$root = this.$parent ? this.$parent.$root : this;
    this.$children = [];
    this.$refs = {}; // child vm references
    this.$els = {}; // element references
    this._watchers = []; // all watchers as an array
    this._directives = []; // all directives

    // a uid
    this._uid = uid++;

    // a flag to avoid this being observed
    this._isVue = true;

    // events bookkeeping
    this._events = {}; // registered callbacks
    this._eventsCount = {}; // for $broadcast optimization

    // fragment instance properties
    this._isFragment = false;
    this._fragment = // @type {DocumentFragment}
    this._fragmentStart = // @type {Text|Comment}
    this._fragmentEnd = null; // @type {Text|Comment}

    // lifecycle state
    this._isCompiled = this._isDestroyed = this._isReady = this._isAttached = this._isBeingDestroyed = this._vForRemoving = false;
    this._unlinkFn = null;

    // context:
    // if this is a transcluded component, context
    // will be the common parent vm of this instance
    // and its host.
    this._context = options._context || this.$parent;

    // scope:
    // if this is inside an inline v-for, the scope
    // will be the intermediate scope created for this
    // repeat fragment. this is used for linking props
    // and container directives.
    this._scope = options._scope;

    // fragment:
    // if this instance is compiled inside a Fragment, it
    // needs to register itself as a child of that fragment
    // for attach/detach to work properly.
    this._frag = options._frag;
    if (this._frag) {
      this._frag.children.push(this);
    }

    // push self into parent / transclusion host
    if (this.$parent) {
      this.$parent.$children.push(this);
    }

    // merge options.
    options = this.$options = mergeOptions(this.constructor.options, options, this);

    // set ref
    this._updateRef();

    // initialize data as empty object.
    // it will be filled up in _initData().
    this._data = {};

    // call init hook
    this._callHook('init');

    // initialize data observation and scope inheritance.
    this._initState();

    // setup event system and option events.
    this._initEvents();

    // call created hook
    this._callHook('created');

    // if `el` option is passed, start compilation.
    if (options.el) {
      this.$mount(options.el);
    }
  };
}

var pathCache = new Cache(1000);

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Determine the type of a character in a keypath.
 *
 * @param {Char} ch
 * @return {String} type
 */

function getPathCharType(ch) {
  if (ch === undefined) {
    return 'eof';
  }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
    case 0x30:
      // 0
      return ch;

    case 0x5F: // _
    case 0x24:
      // $
      return 'ident';

    case 0x20: // Space
    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0: // No-break space
    case 0xFEFF: // Byte Order Mark
    case 0x2028: // Line Separator
    case 0x2029:
      // Paragraph Separator
      return 'ws';
  }

  // a-z, A-Z
  if (code >= 0x61 && code <= 0x7A || code >= 0x41 && code <= 0x5A) {
    return 'ident';
  }

  // 1-9
  if (code >= 0x31 && code <= 0x39) {
    return 'number';
  }

  return 'else';
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 *
 * @param {String} path
 * @return {String}
 */

function formatSubPath(path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) {
    return false;
  }
  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed;
}

/**
 * Parse a string path into an array of segments
 *
 * @param {String} path
 * @return {Array|undefined}
 */

function parse(path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c, newChar, key, type, transition, action, typeMap;

  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      key = formatSubPath(key);
      if (key === false) {
        return false;
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote() {
    var nextChar = path[index + 1];
    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true;
    }
  }

  while (mode != null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue;
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return; // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined ? c : newChar;
      if (action() === false) {
        return;
      }
    }

    if (mode === AFTER_PATH) {
      keys.raw = path;
      return keys;
    }
  }
}

/**
 * External parse that check for a cache hit first
 *
 * @param {String} path
 * @return {Array|undefined}
 */

function parsePath(path) {
  var hit = pathCache.get(path);
  if (!hit) {
    hit = parse(path);
    if (hit) {
      pathCache.put(path, hit);
    }
  }
  return hit;
}

/**
 * Get from an object from a path string
 *
 * @param {Object} obj
 * @param {String} path
 */

function getPath(obj, path) {
  return parseExpression$1(path).get(obj);
}

/**
 * Warn against setting non-existent root path on a vm.
 */

var warnNonExistent;
if (process.env.NODE_ENV !== 'production') {
  warnNonExistent = function (path, vm) {
    warn('You are setting a non-existent path "' + path.raw + '" ' + 'on a vm instance. Consider pre-initializing the property ' + 'with the "data" option for more reliable reactivity ' + 'and better performance.', vm);
  };
}

/**
 * Set on an object from a path
 *
 * @param {Object} obj
 * @param {String | Array} path
 * @param {*} val
 */

function setPath(obj, path, val) {
  var original = obj;
  if (typeof path === 'string') {
    path = parse(path);
  }
  if (!path || !isObject(obj)) {
    return false;
  }
  var last, key;
  for (var i = 0, l = path.length; i < l; i++) {
    last = obj;
    key = path[i];
    if (key.charAt(0) === '*') {
      key = parseExpression$1(key.slice(1)).get.call(original, original);
    }
    if (i < l - 1) {
      obj = obj[key];
      if (!isObject(obj)) {
        obj = {};
        if (process.env.NODE_ENV !== 'production' && last._isVue) {
          warnNonExistent(path, last);
        }
        set(last, key, obj);
      }
    } else {
      if (isArray(obj)) {
        obj.$set(key, val);
      } else if (key in obj) {
        obj[key] = val;
      } else {
        if (process.env.NODE_ENV !== 'production' && obj._isVue) {
          warnNonExistent(path, obj);
        }
        set(obj, key, val);
      }
    }
  }
  return true;
}

var path = Object.freeze({
  parsePath: parsePath,
  getPath: getPath,
  setPath: setPath
});

var expressionCache = new Cache(1000);

var allowedKeywords = 'Math,Date,this,true,false,null,undefined,Infinity,NaN,' + 'isNaN,isFinite,decodeURI,decodeURIComponent,encodeURI,' + 'encodeURIComponent,parseInt,parseFloat';
var allowedKeywordsRE = new RegExp('^(' + allowedKeywords.replace(/,/g, '\\b|') + '\\b)');

// keywords that don't make sense inside expressions
var improperKeywords = 'break,case,class,catch,const,continue,debugger,default,' + 'delete,do,else,export,extends,finally,for,function,if,' + 'import,in,instanceof,let,return,super,switch,throw,try,' + 'var,while,with,yield,enum,await,implements,package,' + 'protected,static,interface,private,public';
var improperKeywordsRE = new RegExp('^(' + improperKeywords.replace(/,/g, '\\b|') + '\\b)');

var wsRE = /\s/g;
var newlineRE = /\n/g;
var saveRE = /[\{,]\s*[\w\$_]+\s*:|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\"']|\\.)*`|`(?:[^`\\]|\\.)*`)|new |typeof |void /g;
var restoreRE = /"(\d+)"/g;
var pathTestRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/;
var identRE = /[^\w$\.](?:[A-Za-z_$][\w$]*)/g;
var literalValueRE$1 = /^(?:true|false|null|undefined|Infinity|NaN)$/;

function noop() {}

/**
 * Save / Rewrite / Restore
 *
 * When rewriting paths found in an expression, it is
 * possible for the same letter sequences to be found in
 * strings and Object literal property keys. Therefore we
 * remove and store these parts in a temporary array, and
 * restore them after the path rewrite.
 */

var saved = [];

/**
 * Save replacer
 *
 * The save regex can match two possible cases:
 * 1. An opening object literal
 * 2. A string
 * If matched as a plain string, we need to escape its
 * newlines, since the string needs to be preserved when
 * generating the function body.
 *
 * @param {String} str
 * @param {String} isString - str if matched as a string
 * @return {String} - placeholder with index
 */

function save(str, isString) {
  var i = saved.length;
  saved[i] = isString ? str.replace(newlineRE, '\\n') : str;
  return '"' + i + '"';
}

/**
 * Path rewrite replacer
 *
 * @param {String} raw
 * @return {String}
 */

function rewrite(raw) {
  var c = raw.charAt(0);
  var path = raw.slice(1);
  if (allowedKeywordsRE.test(path)) {
    return raw;
  } else {
    path = path.indexOf('"') > -1 ? path.replace(restoreRE, restore) : path;
    return c + 'scope.' + path;
  }
}

/**
 * Restore replacer
 *
 * @param {String} str
 * @param {String} i - matched save index
 * @return {String}
 */

function restore(str, i) {
  return saved[i];
}

/**
 * Rewrite an expression, prefixing all path accessors with
 * `scope.` and generate getter/setter functions.
 *
 * @param {String} exp
 * @return {Function}
 */

function compileGetter(exp) {
  if (improperKeywordsRE.test(exp)) {
    process.env.NODE_ENV !== 'production' && warn('Avoid using reserved keywords in expression: ' + exp);
  }
  // reset state
  saved.length = 0;
  // save strings and object literal keys
  var body = exp.replace(saveRE, save).replace(wsRE, '');
  // rewrite all paths
  // pad 1 space here because the regex matches 1 extra char
  body = (' ' + body).replace(identRE, rewrite).replace(restoreRE, restore);
  return makeGetterFn(body);
}

/**
 * Build a getter function. Requires eval.
 *
 * We isolate the try/catch so it doesn't affect the
 * optimization of the parse function when it is not called.
 *
 * @param {String} body
 * @return {Function|undefined}
 */

function makeGetterFn(body) {
  try {
    /* eslint-disable no-new-func */
    return new Function('scope', 'return ' + body + ';');
    /* eslint-enable no-new-func */
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      /* istanbul ignore if */
      if (e.toString().match(/unsafe-eval|CSP/)) {
        warn('It seems you are using the default build of Vue.js in an environment ' + 'with Content Security Policy that prohibits unsafe-eval. ' + 'Use the CSP-compliant build instead: ' + 'http://vuejs.org/guide/installation.html#CSP-compliant-build');
      } else {
        warn('Invalid expression. ' + 'Generated function body: ' + body);
      }
    }
    return noop;
  }
}

/**
 * Compile a setter function for the expression.
 *
 * @param {String} exp
 * @return {Function|undefined}
 */

function compileSetter(exp) {
  var path = parsePath(exp);
  if (path) {
    return function (scope, val) {
      setPath(scope, path, val);
    };
  } else {
    process.env.NODE_ENV !== 'production' && warn('Invalid setter expression: ' + exp);
  }
}

/**
 * Parse an expression into re-written getter/setters.
 *
 * @param {String} exp
 * @param {Boolean} needSet
 * @return {Function}
 */

function parseExpression$1(exp, needSet) {
  exp = exp.trim();
  // try cache
  var hit = expressionCache.get(exp);
  if (hit) {
    if (needSet && !hit.set) {
      hit.set = compileSetter(hit.exp);
    }
    return hit;
  }
  var res = { exp: exp };
  res.get = isSimplePath(exp) && exp.indexOf('[') < 0
  // optimized super simple getter
  ? makeGetterFn('scope.' + exp)
  // dynamic getter
  : compileGetter(exp);
  if (needSet) {
    res.set = compileSetter(exp);
  }
  expressionCache.put(exp, res);
  return res;
}

/**
 * Check if an expression is a simple path.
 *
 * @param {String} exp
 * @return {Boolean}
 */

function isSimplePath(exp) {
  return pathTestRE.test(exp) &&
  // don't treat literal values as paths
  !literalValueRE$1.test(exp) &&
  // Math constants e.g. Math.PI, Math.E etc.
  exp.slice(0, 5) !== 'Math.';
}

var expression = Object.freeze({
  parseExpression: parseExpression$1,
  isSimplePath: isSimplePath
});

// we have two separate queues: one for directive updates
// and one for user watcher registered via $watch().
// we want to guarantee directive updates to be called
// before user watchers so that when user watchers are
// triggered, the DOM would have already been in updated
// state.

var queue = [];
var userQueue = [];
var has = {};
var circular = {};
var waiting = false;

/**
 * Reset the batcher's state.
 */

function resetBatcherState() {
  queue.length = 0;
  userQueue.length = 0;
  has = {};
  circular = {};
  waiting = false;
}

/**
 * Flush both queues and run the watchers.
 */

function flushBatcherQueue() {
  var _again = true;

  _function: while (_again) {
    _again = false;

    runBatcherQueue(queue);
    runBatcherQueue(userQueue);
    // user watchers triggered more watchers,
    // keep flushing until it depletes
    if (queue.length) {
      _again = true;
      continue _function;
    }
    // dev tool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
      devtools.emit('flush');
    }
    resetBatcherState();
  }
}

/**
 * Run the watchers in a single queue.
 *
 * @param {Array} queue
 */

function runBatcherQueue(queue) {
  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (var i = 0; i < queue.length; i++) {
    var watcher = queue[i];
    var id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (process.env.NODE_ENV !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > config._maxUpdateCount) {
        warn('You may have an infinite update loop for watcher ' + 'with expression "' + watcher.expression + '"', watcher.vm);
        break;
      }
    }
  }
  queue.length = 0;
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 *
 * @param {Watcher} watcher
 *   properties:
 *   - {Number} id
 *   - {Function} run
 */

function pushWatcher(watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    // push watcher into appropriate queue
    var q = watcher.user ? userQueue : queue;
    has[id] = q.length;
    q.push(watcher);
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushBatcherQueue);
    }
  }
}

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 *
 * @param {Vue} vm
 * @param {String|Function} expOrFn
 * @param {Function} cb
 * @param {Object} options
 *                 - {Array} filters
 *                 - {Boolean} twoWay
 *                 - {Boolean} deep
 *                 - {Boolean} user
 *                 - {Boolean} sync
 *                 - {Boolean} lazy
 *                 - {Function} [preProcess]
 *                 - {Function} [postProcess]
 * @constructor
 */
function Watcher(vm, expOrFn, cb, options) {
  // mix in options
  if (options) {
    extend(this, options);
  }
  var isFn = typeof expOrFn === 'function';
  this.vm = vm;
  vm._watchers.push(this);
  this.expression = expOrFn;
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.prevError = null; // for async error stacks
  // parse expression for getter/setter
  if (isFn) {
    this.getter = expOrFn;
    this.setter = undefined;
  } else {
    var res = parseExpression$1(expOrFn, this.twoWay);
    this.getter = res.get;
    this.setter = res.set;
  }
  this.value = this.lazy ? undefined : this.get();
  // state for avoiding false triggers for deep and Array
  // watchers during vm._digest()
  this.queued = this.shallow = false;
}

/**
 * Evaluate the getter, and re-collect dependencies.
 */

Watcher.prototype.get = function () {
  this.beforeGet();
  var scope = this.scope || this.vm;
  var value;
  try {
    value = this.getter.call(scope, scope);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production' && config.warnExpressionErrors) {
      warn('Error when evaluating expression ' + '"' + this.expression + '": ' + e.toString(), this.vm);
    }
  }
  // "touch" every property so they are all tracked as
  // dependencies for deep watching
  if (this.deep) {
    traverse(value);
  }
  if (this.preProcess) {
    value = this.preProcess(value);
  }
  if (this.filters) {
    value = scope._applyFilters(value, null, this.filters, false);
  }
  if (this.postProcess) {
    value = this.postProcess(value);
  }
  this.afterGet();
  return value;
};

/**
 * Set the corresponding value with the setter.
 *
 * @param {*} value
 */

Watcher.prototype.set = function (value) {
  var scope = this.scope || this.vm;
  if (this.filters) {
    value = scope._applyFilters(value, this.value, this.filters, true);
  }
  try {
    this.setter.call(scope, scope, value);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production' && config.warnExpressionErrors) {
      warn('Error when evaluating setter ' + '"' + this.expression + '": ' + e.toString(), this.vm);
    }
  }
  // two-way sync for v-for alias
  var forContext = scope.$forContext;
  if (forContext && forContext.alias === this.expression) {
    if (forContext.filters) {
      process.env.NODE_ENV !== 'production' && warn('It seems you are using two-way binding on ' + 'a v-for alias (' + this.expression + '), and the ' + 'v-for has filters. This will not work properly. ' + 'Either remove the filters or use an array of ' + 'objects and bind to object properties instead.', this.vm);
      return;
    }
    forContext._withLock(function () {
      if (scope.$key) {
        // original is an object
        forContext.rawValue[scope.$key] = value;
      } else {
        forContext.rawValue.$set(scope.$index, value);
      }
    });
  }
};

/**
 * Prepare for dependency collection.
 */

Watcher.prototype.beforeGet = function () {
  Dep.target = this;
};

/**
 * Add a dependency to this directive.
 *
 * @param {Dep} dep
 */

Watcher.prototype.addDep = function (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */

Watcher.prototype.afterGet = function () {
  Dep.target = null;
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 *
 * @param {Boolean} shallow
 */

Watcher.prototype.update = function (shallow) {
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync || !config.async) {
    this.run();
  } else {
    // if queued, only overwrite shallow with non-shallow,
    // but not the other way around.
    this.shallow = this.queued ? shallow ? this.shallow : false : !!shallow;
    this.queued = true;
    // record before-push error stack in debug mode
    /* istanbul ignore if */
    if (process.env.NODE_ENV !== 'production' && config.debug) {
      this.prevError = new Error('[vue] async stack trace');
    }
    pushWatcher(this);
  }
};

/**
 * Batcher job interface.
 * Will be called by the batcher.
 */

Watcher.prototype.run = function () {
  if (this.active) {
    var value = this.get();
    if (value !== this.value ||
    // Deep watchers and watchers on Object/Arrays should fire even
    // when the value is the same, because the value may
    // have mutated; but only do so if this is a
    // non-shallow update (caused by a vm digest).
    (isObject(value) || this.deep) && !this.shallow) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      // in debug + async mode, when a watcher callbacks
      // throws, we also throw the saved before-push error
      // so the full cross-tick stack trace is available.
      var prevError = this.prevError;
      /* istanbul ignore if */
      if (process.env.NODE_ENV !== 'production' && config.debug && prevError) {
        this.prevError = null;
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          nextTick(function () {
            throw prevError;
          }, 0);
          throw e;
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
    this.queued = this.shallow = false;
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */

Watcher.prototype.evaluate = function () {
  // avoid overwriting another watcher that is being
  // collected.
  var current = Dep.target;
  this.value = this.get();
  this.dirty = false;
  Dep.target = current;
};

/**
 * Depend on all deps collected by this watcher.
 */

Watcher.prototype.depend = function () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subcriber list.
 */

Watcher.prototype.teardown = function () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed or is performing a v-for
    // re-render (the watcher list is then filtered by v-for).
    if (!this.vm._isBeingDestroyed && !this.vm._vForRemoving) {
      this.vm._watchers.$remove(this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
    this.vm = this.cb = this.value = null;
  }
};

/**
 * Recrusively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 *
 * @param {*} val
 */

var seenObjects = new _Set();
function traverse(val, seen) {
  var i = undefined,
      keys = undefined;
  if (!seen) {
    seen = seenObjects;
    seen.clear();
  }
  var isA = isArray(val);
  var isO = isObject(val);
  if ((isA || isO) && Object.isExtensible(val)) {
    if (val.__ob__) {
      var depId = val.__ob__.dep.id;
      if (seen.has(depId)) {
        return;
      } else {
        seen.add(depId);
      }
    }
    if (isA) {
      i = val.length;
      while (i--) traverse(val[i], seen);
    } else if (isO) {
      keys = Object.keys(val);
      i = keys.length;
      while (i--) traverse(val[keys[i]], seen);
    }
  }
}

var text$1 = {

  bind: function bind() {
    this.attr = this.el.nodeType === 3 ? 'data' : 'textContent';
  },

  update: function update(value) {
    this.el[this.attr] = _toString(value);
  }
};

var templateCache = new Cache(1000);
var idSelectorCache = new Cache(1000);

var map = {
  efault: [0, '', ''],
  legend: [1, '<fieldset>', '</fieldset>'],
  tr: [2, '<table><tbody>', '</tbody></table>'],
  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>']
};

map.td = map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

map.option = map.optgroup = [1, '<select multiple="multiple">', '</select>'];

map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [1, '<table>', '</table>'];

map.g = map.defs = map.symbol = map.use = map.image = map.text = map.circle = map.ellipse = map.line = map.path = map.polygon = map.polyline = map.rect = [1, '<svg ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'xmlns:ev="http://www.w3.org/2001/xml-events"' + 'version="1.1">', '</svg>'];

/**
 * Check if a node is a supported template node with a
 * DocumentFragment content.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function isRealTemplate(node) {
  return isTemplate(node) && isFragment(node.content);
}

var tagRE$1 = /<([\w:-]+)/;
var entityRE = /&#?\w+?;/;
var commentRE = /<!--/;

/**
 * Convert a string template to a DocumentFragment.
 * Determines correct wrapping by tag types. Wrapping
 * strategy found in jQuery & component/domify.
 *
 * @param {String} templateString
 * @param {Boolean} raw
 * @return {DocumentFragment}
 */

function stringToFragment(templateString, raw) {
  // try a cache hit first
  var cacheKey = raw ? templateString : templateString.trim();
  var hit = templateCache.get(cacheKey);
  if (hit) {
    return hit;
  }

  var frag = document.createDocumentFragment();
  var tagMatch = templateString.match(tagRE$1);
  var entityMatch = entityRE.test(templateString);
  var commentMatch = commentRE.test(templateString);

  if (!tagMatch && !entityMatch && !commentMatch) {
    // text only, return a single text node.
    frag.appendChild(document.createTextNode(templateString));
  } else {
    var tag = tagMatch && tagMatch[1];
    var wrap = map[tag] || map.efault;
    var depth = wrap[0];
    var prefix = wrap[1];
    var suffix = wrap[2];
    var node = document.createElement('div');

    node.innerHTML = prefix + templateString + suffix;
    while (depth--) {
      node = node.lastChild;
    }

    var child;
    /* eslint-disable no-cond-assign */
    while (child = node.firstChild) {
      /* eslint-enable no-cond-assign */
      frag.appendChild(child);
    }
  }
  if (!raw) {
    trimNode(frag);
  }
  templateCache.put(cacheKey, frag);
  return frag;
}

/**
 * Convert a template node to a DocumentFragment.
 *
 * @param {Node} node
 * @return {DocumentFragment}
 */

function nodeToFragment(node) {
  // if its a template tag and the browser supports it,
  // its content is already a document fragment. However, iOS Safari has
  // bug when using directly cloned template content with touch
  // events and can cause crashes when the nodes are removed from DOM, so we
  // have to treat template elements as string templates. (#2805)
  /* istanbul ignore if */
  if (isRealTemplate(node)) {
    return stringToFragment(node.innerHTML);
  }
  // script template
  if (node.tagName === 'SCRIPT') {
    return stringToFragment(node.textContent);
  }
  // normal node, clone it to avoid mutating the original
  var clonedNode = cloneNode(node);
  var frag = document.createDocumentFragment();
  var child;
  /* eslint-disable no-cond-assign */
  while (child = clonedNode.firstChild) {
    /* eslint-enable no-cond-assign */
    frag.appendChild(child);
  }
  trimNode(frag);
  return frag;
}

// Test for the presence of the Safari template cloning bug
// https://bugs.webkit.org/showug.cgi?id=137755
var hasBrokenTemplate = (function () {
  /* istanbul ignore else */
  if (inBrowser) {
    var a = document.createElement('div');
    a.innerHTML = '<template>1</template>';
    return !a.cloneNode(true).firstChild.innerHTML;
  } else {
    return false;
  }
})();

// Test for IE10/11 textarea placeholder clone bug
var hasTextareaCloneBug = (function () {
  /* istanbul ignore else */
  if (inBrowser) {
    var t = document.createElement('textarea');
    t.placeholder = 't';
    return t.cloneNode(true).value === 't';
  } else {
    return false;
  }
})();

/**
 * 1. Deal with Safari cloning nested <template> bug by
 *    manually cloning all template instances.
 * 2. Deal with IE10/11 textarea placeholder bug by setting
 *    the correct value after cloning.
 *
 * @param {Element|DocumentFragment} node
 * @return {Element|DocumentFragment}
 */

function cloneNode(node) {
  /* istanbul ignore if */
  if (!node.querySelectorAll) {
    return node.cloneNode();
  }
  var res = node.cloneNode(true);
  var i, original, cloned;
  /* istanbul ignore if */
  if (hasBrokenTemplate) {
    var tempClone = res;
    if (isRealTemplate(node)) {
      node = node.content;
      tempClone = res.content;
    }
    original = node.querySelectorAll('template');
    if (original.length) {
      cloned = tempClone.querySelectorAll('template');
      i = cloned.length;
      while (i--) {
        cloned[i].parentNode.replaceChild(cloneNode(original[i]), cloned[i]);
      }
    }
  }
  /* istanbul ignore if */
  if (hasTextareaCloneBug) {
    if (node.tagName === 'TEXTAREA') {
      res.value = node.value;
    } else {
      original = node.querySelectorAll('textarea');
      if (original.length) {
        cloned = res.querySelectorAll('textarea');
        i = cloned.length;
        while (i--) {
          cloned[i].value = original[i].value;
        }
      }
    }
  }
  return res;
}

/**
 * Process the template option and normalizes it into a
 * a DocumentFragment that can be used as a partial or a
 * instance template.
 *
 * @param {*} template
 *        Possible values include:
 *        - DocumentFragment object
 *        - Node object of type Template
 *        - id selector: '#some-template-id'
 *        - template string: '<div><span>{{msg}}</span></div>'
 * @param {Boolean} shouldClone
 * @param {Boolean} raw
 *        inline HTML interpolation. Do not check for id
 *        selector and keep whitespace in the string.
 * @return {DocumentFragment|undefined}
 */

function parseTemplate(template, shouldClone, raw) {
  var node, frag;

  // if the template is already a document fragment,
  // do nothing
  if (isFragment(template)) {
    trimNode(template);
    return shouldClone ? cloneNode(template) : template;
  }

  if (typeof template === 'string') {
    // id selector
    if (!raw && template.charAt(0) === '#') {
      // id selector can be cached too
      frag = idSelectorCache.get(template);
      if (!frag) {
        node = document.getElementById(template.slice(1));
        if (node) {
          frag = nodeToFragment(node);
          // save selector to cache
          idSelectorCache.put(template, frag);
        }
      }
    } else {
      // normal string template
      frag = stringToFragment(template, raw);
    }
  } else if (template.nodeType) {
    // a direct node
    frag = nodeToFragment(template);
  }

  return frag && shouldClone ? cloneNode(frag) : frag;
}

var template = Object.freeze({
  cloneNode: cloneNode,
  parseTemplate: parseTemplate
});

var html = {

  bind: function bind() {
    // a comment node means this is a binding for
    // {{{ inline unescaped html }}}
    if (this.el.nodeType === 8) {
      // hold nodes
      this.nodes = [];
      // replace the placeholder with proper anchor
      this.anchor = createAnchor('v-html');
      replace(this.el, this.anchor);
    }
  },

  update: function update(value) {
    value = _toString(value);
    if (this.nodes) {
      this.swap(value);
    } else {
      this.el.innerHTML = value;
    }
  },

  swap: function swap(value) {
    // remove old nodes
    var i = this.nodes.length;
    while (i--) {
      remove(this.nodes[i]);
    }
    // convert new value to a fragment
    // do not attempt to retrieve from id selector
    var frag = parseTemplate(value, true, true);
    // save a reference to these nodes so we can remove later
    this.nodes = toArray(frag.childNodes);
    before(frag, this.anchor);
  }
};

/**
 * Abstraction for a partially-compiled fragment.
 * Can optionally compile content with a child scope.
 *
 * @param {Function} linker
 * @param {Vue} vm
 * @param {DocumentFragment} frag
 * @param {Vue} [host]
 * @param {Object} [scope]
 * @param {Fragment} [parentFrag]
 */
function Fragment(linker, vm, frag, host, scope, parentFrag) {
  this.children = [];
  this.childFrags = [];
  this.vm = vm;
  this.scope = scope;
  this.inserted = false;
  this.parentFrag = parentFrag;
  if (parentFrag) {
    parentFrag.childFrags.push(this);
  }
  this.unlink = linker(vm, frag, host, scope, this);
  var single = this.single = frag.childNodes.length === 1 &&
  // do not go single mode if the only node is an anchor
  !frag.childNodes[0].__v_anchor;
  if (single) {
    this.node = frag.childNodes[0];
    this.before = singleBefore;
    this.remove = singleRemove;
  } else {
    this.node = createAnchor('fragment-start');
    this.end = createAnchor('fragment-end');
    this.frag = frag;
    prepend(this.node, frag);
    frag.appendChild(this.end);
    this.before = multiBefore;
    this.remove = multiRemove;
  }
  this.node.__v_frag = this;
}

/**
 * Call attach/detach for all components contained within
 * this fragment. Also do so recursively for all child
 * fragments.
 *
 * @param {Function} hook
 */

Fragment.prototype.callHook = function (hook) {
  var i, l;
  for (i = 0, l = this.childFrags.length; i < l; i++) {
    this.childFrags[i].callHook(hook);
  }
  for (i = 0, l = this.children.length; i < l; i++) {
    hook(this.children[i]);
  }
};

/**
 * Insert fragment before target, single node version
 *
 * @param {Node} target
 * @param {Boolean} withTransition
 */

function singleBefore(target, withTransition) {
  this.inserted = true;
  var method = withTransition !== false ? beforeWithTransition : before;
  method(this.node, target, this.vm);
  if (inDoc(this.node)) {
    this.callHook(attach);
  }
}

/**
 * Remove fragment, single node version
 */

function singleRemove() {
  this.inserted = false;
  var shouldCallRemove = inDoc(this.node);
  var self = this;
  this.beforeRemove();
  removeWithTransition(this.node, this.vm, function () {
    if (shouldCallRemove) {
      self.callHook(detach);
    }
    self.destroy();
  });
}

/**
 * Insert fragment before target, multi-nodes version
 *
 * @param {Node} target
 * @param {Boolean} withTransition
 */

function multiBefore(target, withTransition) {
  this.inserted = true;
  var vm = this.vm;
  var method = withTransition !== false ? beforeWithTransition : before;
  mapNodeRange(this.node, this.end, function (node) {
    method(node, target, vm);
  });
  if (inDoc(this.node)) {
    this.callHook(attach);
  }
}

/**
 * Remove fragment, multi-nodes version
 */

function multiRemove() {
  this.inserted = false;
  var self = this;
  var shouldCallRemove = inDoc(this.node);
  this.beforeRemove();
  removeNodeRange(this.node, this.end, this.vm, this.frag, function () {
    if (shouldCallRemove) {
      self.callHook(detach);
    }
    self.destroy();
  });
}

/**
 * Prepare the fragment for removal.
 */

Fragment.prototype.beforeRemove = function () {
  var i, l;
  for (i = 0, l = this.childFrags.length; i < l; i++) {
    // call the same method recursively on child
    // fragments, depth-first
    this.childFrags[i].beforeRemove(false);
  }
  for (i = 0, l = this.children.length; i < l; i++) {
    // Call destroy for all contained instances,
    // with remove:false and defer:true.
    // Defer is necessary because we need to
    // keep the children to call detach hooks
    // on them.
    this.children[i].$destroy(false, true);
  }
  var dirs = this.unlink.dirs;
  for (i = 0, l = dirs.length; i < l; i++) {
    // disable the watchers on all the directives
    // so that the rendered content stays the same
    // during removal.
    dirs[i]._watcher && dirs[i]._watcher.teardown();
  }
};

/**
 * Destroy the fragment.
 */

Fragment.prototype.destroy = function () {
  if (this.parentFrag) {
    this.parentFrag.childFrags.$remove(this);
  }
  this.node.__v_frag = null;
  this.unlink();
};

/**
 * Call attach hook for a Vue instance.
 *
 * @param {Vue} child
 */

function attach(child) {
  if (!child._isAttached && inDoc(child.$el)) {
    child._callHook('attached');
  }
}

/**
 * Call detach hook for a Vue instance.
 *
 * @param {Vue} child
 */

function detach(child) {
  if (child._isAttached && !inDoc(child.$el)) {
    child._callHook('detached');
  }
}

var linkerCache = new Cache(5000);

/**
 * A factory that can be used to create instances of a
 * fragment. Caches the compiled linker if possible.
 *
 * @param {Vue} vm
 * @param {Element|String} el
 */
function FragmentFactory(vm, el) {
  this.vm = vm;
  var template;
  var isString = typeof el === 'string';
  if (isString || isTemplate(el) && !el.hasAttribute('v-if')) {
    template = parseTemplate(el, true);
  } else {
    template = document.createDocumentFragment();
    template.appendChild(el);
  }
  this.template = template;
  // linker can be cached, but only for components
  var linker;
  var cid = vm.constructor.cid;
  if (cid > 0) {
    var cacheId = cid + (isString ? el : getOuterHTML(el));
    linker = linkerCache.get(cacheId);
    if (!linker) {
      linker = compile(template, vm.$options, true);
      linkerCache.put(cacheId, linker);
    }
  } else {
    linker = compile(template, vm.$options, true);
  }
  this.linker = linker;
}

/**
 * Create a fragment instance with given host and scope.
 *
 * @param {Vue} host
 * @param {Object} scope
 * @param {Fragment} parentFrag
 */

FragmentFactory.prototype.create = function (host, scope, parentFrag) {
  var frag = cloneNode(this.template);
  return new Fragment(this.linker, this.vm, frag, host, scope, parentFrag);
};

var ON = 700;
var MODEL = 800;
var BIND = 850;
var TRANSITION = 1100;
var EL = 1500;
var COMPONENT = 1500;
var PARTIAL = 1750;
var IF = 2100;
var FOR = 2200;
var SLOT = 2300;

var uid$3 = 0;

var vFor = {

  priority: FOR,
  terminal: true,

  params: ['track-by', 'stagger', 'enter-stagger', 'leave-stagger'],

  bind: function bind() {
    if (process.env.NODE_ENV !== 'production' && this.el.hasAttribute('v-if')) {
      warn('<' + this.el.tagName.toLowerCase() + ' v-for="' + this.expression + '" v-if="' + this.el.getAttribute('v-if') + '">: ' + 'Using v-if and v-for on the same element is not recommended - ' + 'consider filtering the source Array instead.', this.vm);
    }

    // support "item in/of items" syntax
    var inMatch = this.expression.match(/(.*) (?:in|of) (.*)/);
    if (inMatch) {
      var itMatch = inMatch[1].match(/\((.*),(.*)\)/);
      if (itMatch) {
        this.iterator = itMatch[1].trim();
        this.alias = itMatch[2].trim();
      } else {
        this.alias = inMatch[1].trim();
      }
      this.expression = inMatch[2];
    }

    if (!this.alias) {
      process.env.NODE_ENV !== 'production' && warn('Invalid v-for expression "' + this.descriptor.raw + '": ' + 'alias is required.', this.vm);
      return;
    }

    // uid as a cache identifier
    this.id = '__v-for__' + ++uid$3;

    // check if this is an option list,
    // so that we know if we need to update the <select>'s
    // v-model when the option list has changed.
    // because v-model has a lower priority than v-for,
    // the v-model is not bound here yet, so we have to
    // retrive it in the actual updateModel() function.
    var tag = this.el.tagName;
    this.isOption = (tag === 'OPTION' || tag === 'OPTGROUP') && this.el.parentNode.tagName === 'SELECT';

    // setup anchor nodes
    this.start = createAnchor('v-for-start');
    this.end = createAnchor('v-for-end');
    replace(this.el, this.end);
    before(this.start, this.end);

    // cache
    this.cache = Object.create(null);

    // fragment factory
    this.factory = new FragmentFactory(this.vm, this.el);
  },

  update: function update(data) {
    this.diff(data);
    this.updateRef();
    this.updateModel();
  },

  /**
   * Diff, based on new data and old data, determine the
   * minimum amount of DOM manipulations needed to make the
   * DOM reflect the new data Array.
   *
   * The algorithm diffs the new data Array by storing a
   * hidden reference to an owner vm instance on previously
   * seen data. This allows us to achieve O(n) which is
   * better than a levenshtein distance based algorithm,
   * which is O(m * n).
   *
   * @param {Array} data
   */

  diff: function diff(data) {
    // check if the Array was converted from an Object
    var item = data[0];
    var convertedFromObject = this.fromObject = isObject(item) && hasOwn(item, '$key') && hasOwn(item, '$value');

    var trackByKey = this.params.trackBy;
    var oldFrags = this.frags;
    var frags = this.frags = new Array(data.length);
    var alias = this.alias;
    var iterator = this.iterator;
    var start = this.start;
    var end = this.end;
    var inDocument = inDoc(start);
    var init = !oldFrags;
    var i, l, frag, key, value, primitive;

    // First pass, go through the new Array and fill up
    // the new frags array. If a piece of data has a cached
    // instance for it, we reuse it. Otherwise build a new
    // instance.
    for (i = 0, l = data.length; i < l; i++) {
      item = data[i];
      key = convertedFromObject ? item.$key : null;
      value = convertedFromObject ? item.$value : item;
      primitive = !isObject(value);
      frag = !init && this.getCachedFrag(value, i, key);
      if (frag) {
        // reusable fragment
        frag.reused = true;
        // update $index
        frag.scope.$index = i;
        // update $key
        if (key) {
          frag.scope.$key = key;
        }
        // update iterator
        if (iterator) {
          frag.scope[iterator] = key !== null ? key : i;
        }
        // update data for track-by, object repeat &
        // primitive values.
        if (trackByKey || convertedFromObject || primitive) {
          withoutConversion(function () {
            frag.scope[alias] = value;
          });
        }
      } else {
        // new instance
        frag = this.create(value, alias, i, key);
        frag.fresh = !init;
      }
      frags[i] = frag;
      if (init) {
        frag.before(end);
      }
    }

    // we're done for the initial render.
    if (init) {
      return;
    }

    // Second pass, go through the old fragments and
    // destroy those who are not reused (and remove them
    // from cache)
    var removalIndex = 0;
    var totalRemoved = oldFrags.length - frags.length;
    // when removing a large number of fragments, watcher removal
    // turns out to be a perf bottleneck, so we batch the watcher
    // removals into a single filter call!
    this.vm._vForRemoving = true;
    for (i = 0, l = oldFrags.length; i < l; i++) {
      frag = oldFrags[i];
      if (!frag.reused) {
        this.deleteCachedFrag(frag);
        this.remove(frag, removalIndex++, totalRemoved, inDocument);
      }
    }
    this.vm._vForRemoving = false;
    if (removalIndex) {
      this.vm._watchers = this.vm._watchers.filter(function (w) {
        return w.active;
      });
    }

    // Final pass, move/insert new fragments into the
    // right place.
    var targetPrev, prevEl, currentPrev;
    var insertionIndex = 0;
    for (i = 0, l = frags.length; i < l; i++) {
      frag = frags[i];
      // this is the frag that we should be after
      targetPrev = frags[i - 1];
      prevEl = targetPrev ? targetPrev.staggerCb ? targetPrev.staggerAnchor : targetPrev.end || targetPrev.node : start;
      if (frag.reused && !frag.staggerCb) {
        currentPrev = findPrevFrag(frag, start, this.id);
        if (currentPrev !== targetPrev && (!currentPrev ||
        // optimization for moving a single item.
        // thanks to suggestions by @livoras in #1807
        findPrevFrag(currentPrev, start, this.id) !== targetPrev)) {
          this.move(frag, prevEl);
        }
      } else {
        // new instance, or still in stagger.
        // insert with updated stagger index.
        this.insert(frag, insertionIndex++, prevEl, inDocument);
      }
      frag.reused = frag.fresh = false;
    }
  },

  /**
   * Create a new fragment instance.
   *
   * @param {*} value
   * @param {String} alias
   * @param {Number} index
   * @param {String} [key]
   * @return {Fragment}
   */

  create: function create(value, alias, index, key) {
    var host = this._host;
    // create iteration scope
    var parentScope = this._scope || this.vm;
    var scope = Object.create(parentScope);
    // ref holder for the scope
    scope.$refs = Object.create(parentScope.$refs);
    scope.$els = Object.create(parentScope.$els);
    // make sure point $parent to parent scope
    scope.$parent = parentScope;
    // for two-way binding on alias
    scope.$forContext = this;
    // define scope properties
    // important: define the scope alias without forced conversion
    // so that frozen data structures remain non-reactive.
    withoutConversion(function () {
      defineReactive(scope, alias, value);
    });
    defineReactive(scope, '$index', index);
    if (key) {
      defineReactive(scope, '$key', key);
    } else if (scope.$key) {
      // avoid accidental fallback
      def(scope, '$key', null);
    }
    if (this.iterator) {
      defineReactive(scope, this.iterator, key !== null ? key : index);
    }
    var frag = this.factory.create(host, scope, this._frag);
    frag.forId = this.id;
    this.cacheFrag(value, frag, index, key);
    return frag;
  },

  /**
   * Update the v-ref on owner vm.
   */

  updateRef: function updateRef() {
    var ref = this.descriptor.ref;
    if (!ref) return;
    var hash = (this._scope || this.vm).$refs;
    var refs;
    if (!this.fromObject) {
      refs = this.frags.map(findVmFromFrag);
    } else {
      refs = {};
      this.frags.forEach(function (frag) {
        refs[frag.scope.$key] = findVmFromFrag(frag);
      });
    }
    hash[ref] = refs;
  },

  /**
   * For option lists, update the containing v-model on
   * parent <select>.
   */

  updateModel: function updateModel() {
    if (this.isOption) {
      var parent = this.start.parentNode;
      var model = parent && parent.__v_model;
      if (model) {
        model.forceUpdate();
      }
    }
  },

  /**
   * Insert a fragment. Handles staggering.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Node} prevEl
   * @param {Boolean} inDocument
   */

  insert: function insert(frag, index, prevEl, inDocument) {
    if (frag.staggerCb) {
      frag.staggerCb.cancel();
      frag.staggerCb = null;
    }
    var staggerAmount = this.getStagger(frag, index, null, 'enter');
    if (inDocument && staggerAmount) {
      // create an anchor and insert it synchronously,
      // so that we can resolve the correct order without
      // worrying about some elements not inserted yet
      var anchor = frag.staggerAnchor;
      if (!anchor) {
        anchor = frag.staggerAnchor = createAnchor('stagger-anchor');
        anchor.__v_frag = frag;
      }
      after(anchor, prevEl);
      var op = frag.staggerCb = cancellable(function () {
        frag.staggerCb = null;
        frag.before(anchor);
        remove(anchor);
      });
      setTimeout(op, staggerAmount);
    } else {
      var target = prevEl.nextSibling;
      /* istanbul ignore if */
      if (!target) {
        // reset end anchor position in case the position was messed up
        // by an external drag-n-drop library.
        after(this.end, prevEl);
        target = this.end;
      }
      frag.before(target);
    }
  },

  /**
   * Remove a fragment. Handles staggering.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Number} total
   * @param {Boolean} inDocument
   */

  remove: function remove(frag, index, total, inDocument) {
    if (frag.staggerCb) {
      frag.staggerCb.cancel();
      frag.staggerCb = null;
      // it's not possible for the same frag to be removed
      // twice, so if we have a pending stagger callback,
      // it means this frag is queued for enter but removed
      // before its transition started. Since it is already
      // destroyed, we can just leave it in detached state.
      return;
    }
    var staggerAmount = this.getStagger(frag, index, total, 'leave');
    if (inDocument && staggerAmount) {
      var op = frag.staggerCb = cancellable(function () {
        frag.staggerCb = null;
        frag.remove();
      });
      setTimeout(op, staggerAmount);
    } else {
      frag.remove();
    }
  },

  /**
   * Move a fragment to a new position.
   * Force no transition.
   *
   * @param {Fragment} frag
   * @param {Node} prevEl
   */

  move: function move(frag, prevEl) {
    // fix a common issue with Sortable:
    // if prevEl doesn't have nextSibling, this means it's
    // been dragged after the end anchor. Just re-position
    // the end anchor to the end of the container.
    /* istanbul ignore if */
    if (!prevEl.nextSibling) {
      this.end.parentNode.appendChild(this.end);
    }
    frag.before(prevEl.nextSibling, false);
  },

  /**
   * Cache a fragment using track-by or the object key.
   *
   * @param {*} value
   * @param {Fragment} frag
   * @param {Number} index
   * @param {String} [key]
   */

  cacheFrag: function cacheFrag(value, frag, index, key) {
    var trackByKey = this.params.trackBy;
    var cache = this.cache;
    var primitive = !isObject(value);
    var id;
    if (key || trackByKey || primitive) {
      id = getTrackByKey(index, key, value, trackByKey);
      if (!cache[id]) {
        cache[id] = frag;
      } else if (trackByKey !== '$index') {
        process.env.NODE_ENV !== 'production' && this.warnDuplicate(value);
      }
    } else {
      id = this.id;
      if (hasOwn(value, id)) {
        if (value[id] === null) {
          value[id] = frag;
        } else {
          process.env.NODE_ENV !== 'production' && this.warnDuplicate(value);
        }
      } else if (Object.isExtensible(value)) {
        def(value, id, frag);
      } else if (process.env.NODE_ENV !== 'production') {
        warn('Frozen v-for objects cannot be automatically tracked, make sure to ' + 'provide a track-by key.');
      }
    }
    frag.raw = value;
  },

  /**
   * Get a cached fragment from the value/index/key
   *
   * @param {*} value
   * @param {Number} index
   * @param {String} key
   * @return {Fragment}
   */

  getCachedFrag: function getCachedFrag(value, index, key) {
    var trackByKey = this.params.trackBy;
    var primitive = !isObject(value);
    var frag;
    if (key || trackByKey || primitive) {
      var id = getTrackByKey(index, key, value, trackByKey);
      frag = this.cache[id];
    } else {
      frag = value[this.id];
    }
    if (frag && (frag.reused || frag.fresh)) {
      process.env.NODE_ENV !== 'production' && this.warnDuplicate(value);
    }
    return frag;
  },

  /**
   * Delete a fragment from cache.
   *
   * @param {Fragment} frag
   */

  deleteCachedFrag: function deleteCachedFrag(frag) {
    var value = frag.raw;
    var trackByKey = this.params.trackBy;
    var scope = frag.scope;
    var index = scope.$index;
    // fix #948: avoid accidentally fall through to
    // a parent repeater which happens to have $key.
    var key = hasOwn(scope, '$key') && scope.$key;
    var primitive = !isObject(value);
    if (trackByKey || key || primitive) {
      var id = getTrackByKey(index, key, value, trackByKey);
      this.cache[id] = null;
    } else {
      value[this.id] = null;
      frag.raw = null;
    }
  },

  /**
   * Get the stagger amount for an insertion/removal.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Number} total
   * @param {String} type
   */

  getStagger: function getStagger(frag, index, total, type) {
    type = type + 'Stagger';
    var trans = frag.node.__v_trans;
    var hooks = trans && trans.hooks;
    var hook = hooks && (hooks[type] || hooks.stagger);
    return hook ? hook.call(frag, index, total) : index * parseInt(this.params[type] || this.params.stagger, 10);
  },

  /**
   * Pre-process the value before piping it through the
   * filters. This is passed to and called by the watcher.
   */

  _preProcess: function _preProcess(value) {
    // regardless of type, store the un-filtered raw value.
    this.rawValue = value;
    return value;
  },

  /**
   * Post-process the value after it has been piped through
   * the filters. This is passed to and called by the watcher.
   *
   * It is necessary for this to be called during the
   * watcher's dependency collection phase because we want
   * the v-for to update when the source Object is mutated.
   */

  _postProcess: function _postProcess(value) {
    if (isArray(value)) {
      return value;
    } else if (isPlainObject(value)) {
      // convert plain object to array.
      var keys = Object.keys(value);
      var i = keys.length;
      var res = new Array(i);
      var key;
      while (i--) {
        key = keys[i];
        res[i] = {
          $key: key,
          $value: value[key]
        };
      }
      return res;
    } else {
      if (typeof value === 'number' && !isNaN(value)) {
        value = range(value);
      }
      return value || [];
    }
  },

  unbind: function unbind() {
    if (this.descriptor.ref) {
      (this._scope || this.vm).$refs[this.descriptor.ref] = null;
    }
    if (this.frags) {
      var i = this.frags.length;
      var frag;
      while (i--) {
        frag = this.frags[i];
        this.deleteCachedFrag(frag);
        frag.destroy();
      }
    }
  }
};

/**
 * Helper to find the previous element that is a fragment
 * anchor. This is necessary because a destroyed frag's
 * element could still be lingering in the DOM before its
 * leaving transition finishes, but its inserted flag
 * should have been set to false so we can skip them.
 *
 * If this is a block repeat, we want to make sure we only
 * return frag that is bound to this v-for. (see #929)
 *
 * @param {Fragment} frag
 * @param {Comment|Text} anchor
 * @param {String} id
 * @return {Fragment}
 */

function findPrevFrag(frag, anchor, id) {
  var el = frag.node.previousSibling;
  /* istanbul ignore if */
  if (!el) return;
  frag = el.__v_frag;
  while ((!frag || frag.forId !== id || !frag.inserted) && el !== anchor) {
    el = el.previousSibling;
    /* istanbul ignore if */
    if (!el) return;
    frag = el.__v_frag;
  }
  return frag;
}

/**
 * Create a range array from given number.
 *
 * @param {Number} n
 * @return {Array}
 */

function range(n) {
  var i = -1;
  var ret = new Array(Math.floor(n));
  while (++i < n) {
    ret[i] = i;
  }
  return ret;
}

/**
 * Get the track by key for an item.
 *
 * @param {Number} index
 * @param {String} key
 * @param {*} value
 * @param {String} [trackByKey]
 */

function getTrackByKey(index, key, value, trackByKey) {
  return trackByKey ? trackByKey === '$index' ? index : trackByKey.charAt(0).match(/\w/) ? getPath(value, trackByKey) : value[trackByKey] : key || value;
}

if (process.env.NODE_ENV !== 'production') {
  vFor.warnDuplicate = function (value) {
    warn('Duplicate value found in v-for="' + this.descriptor.raw + '": ' + JSON.stringify(value) + '. Use track-by="$index" if ' + 'you are expecting duplicate values.', this.vm);
  };
}

/**
 * Find a vm from a fragment.
 *
 * @param {Fragment} frag
 * @return {Vue|undefined}
 */

function findVmFromFrag(frag) {
  var node = frag.node;
  // handle multi-node frag
  if (frag.end) {
    while (!node.__vue__ && node !== frag.end && node.nextSibling) {
      node = node.nextSibling;
    }
  }
  return node.__vue__;
}

var vIf = {

  priority: IF,
  terminal: true,

  bind: function bind() {
    var el = this.el;
    if (!el.__vue__) {
      // check else block
      var next = el.nextElementSibling;
      if (next && getAttr(next, 'v-else') !== null) {
        remove(next);
        this.elseEl = next;
      }
      // check main block
      this.anchor = createAnchor('v-if');
      replace(el, this.anchor);
    } else {
      process.env.NODE_ENV !== 'production' && warn('v-if="' + this.expression + '" cannot be ' + 'used on an instance root element.', this.vm);
      this.invalid = true;
    }
  },

  update: function update(value) {
    if (this.invalid) return;
    if (value) {
      if (!this.frag) {
        this.insert();
      }
    } else {
      this.remove();
    }
  },

  insert: function insert() {
    if (this.elseFrag) {
      this.elseFrag.remove();
      this.elseFrag = null;
    }
    // lazy init factory
    if (!this.factory) {
      this.factory = new FragmentFactory(this.vm, this.el);
    }
    this.frag = this.factory.create(this._host, this._scope, this._frag);
    this.frag.before(this.anchor);
  },

  remove: function remove() {
    if (this.frag) {
      this.frag.remove();
      this.frag = null;
    }
    if (this.elseEl && !this.elseFrag) {
      if (!this.elseFactory) {
        this.elseFactory = new FragmentFactory(this.elseEl._context || this.vm, this.elseEl);
      }
      this.elseFrag = this.elseFactory.create(this._host, this._scope, this._frag);
      this.elseFrag.before(this.anchor);
    }
  },

  unbind: function unbind() {
    if (this.frag) {
      this.frag.destroy();
    }
    if (this.elseFrag) {
      this.elseFrag.destroy();
    }
  }
};

var show = {

  bind: function bind() {
    // check else block
    var next = this.el.nextElementSibling;
    if (next && getAttr(next, 'v-else') !== null) {
      this.elseEl = next;
    }
  },

  update: function update(value) {
    this.apply(this.el, value);
    if (this.elseEl) {
      this.apply(this.elseEl, !value);
    }
  },

  apply: function apply(el, value) {
    if (inDoc(el)) {
      applyTransition(el, value ? 1 : -1, toggle, this.vm);
    } else {
      toggle();
    }
    function toggle() {
      el.style.display = value ? '' : 'none';
    }
  }
};

var text$2 = {

  bind: function bind() {
    var self = this;
    var el = this.el;
    var isRange = el.type === 'range';
    var lazy = this.params.lazy;
    var number = this.params.number;
    var debounce = this.params.debounce;

    // handle composition events.
    //   http://blog.evanyou.me/2014/01/03/composition-event/
    // skip this for Android because it handles composition
    // events quite differently. Android doesn't trigger
    // composition events for language input methods e.g.
    // Chinese, but instead triggers them for spelling
    // suggestions... (see Discussion/#162)
    var composing = false;
    if (!isAndroid && !isRange) {
      this.on('compositionstart', function () {
        composing = true;
      });
      this.on('compositionend', function () {
        composing = false;
        // in IE11 the "compositionend" event fires AFTER
        // the "input" event, so the input handler is blocked
        // at the end... have to call it here.
        //
        // #1327: in lazy mode this is unecessary.
        if (!lazy) {
          self.listener();
        }
      });
    }

    // prevent messing with the input when user is typing,
    // and force update on blur.
    this.focused = false;
    if (!isRange && !lazy) {
      this.on('focus', function () {
        self.focused = true;
      });
      this.on('blur', function () {
        self.focused = false;
        // do not sync value after fragment removal (#2017)
        if (!self._frag || self._frag.inserted) {
          self.rawListener();
        }
      });
    }

    // Now attach the main listener
    this.listener = this.rawListener = function () {
      if (composing || !self._bound) {
        return;
      }
      var val = number || isRange ? toNumber(el.value) : el.value;
      self.set(val);
      // force update on next tick to avoid lock & same value
      // also only update when user is not typing
      nextTick(function () {
        if (self._bound && !self.focused) {
          self.update(self._watcher.value);
        }
      });
    };

    // apply debounce
    if (debounce) {
      this.listener = _debounce(this.listener, debounce);
    }

    // Support jQuery events, since jQuery.trigger() doesn't
    // trigger native events in some cases and some plugins
    // rely on $.trigger()
    //
    // We want to make sure if a listener is attached using
    // jQuery, it is also removed with jQuery, that's why
    // we do the check for each directive instance and
    // store that check result on itself. This also allows
    // easier test coverage control by unsetting the global
    // jQuery variable in tests.
    this.hasjQuery = typeof jQuery === 'function';
    if (this.hasjQuery) {
      var method = jQuery.fn.on ? 'on' : 'bind';
      jQuery(el)[method]('change', this.rawListener);
      if (!lazy) {
        jQuery(el)[method]('input', this.listener);
      }
    } else {
      this.on('change', this.rawListener);
      if (!lazy) {
        this.on('input', this.listener);
      }
    }

    // IE9 doesn't fire input event on backspace/del/cut
    if (!lazy && isIE9) {
      this.on('cut', function () {
        nextTick(self.listener);
      });
      this.on('keyup', function (e) {
        if (e.keyCode === 46 || e.keyCode === 8) {
          self.listener();
        }
      });
    }

    // set initial value if present
    if (el.hasAttribute('value') || el.tagName === 'TEXTAREA' && el.value.trim()) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    // #3029 only update when the value changes. This prevent
    // browsers from overwriting values like selectionStart
    value = _toString(value);
    if (value !== this.el.value) this.el.value = value;
  },

  unbind: function unbind() {
    var el = this.el;
    if (this.hasjQuery) {
      var method = jQuery.fn.off ? 'off' : 'unbind';
      jQuery(el)[method]('change', this.listener);
      jQuery(el)[method]('input', this.listener);
    }
  }
};

var radio = {

  bind: function bind() {
    var self = this;
    var el = this.el;

    this.getValue = function () {
      // value overwrite via v-bind:value
      if (el.hasOwnProperty('_value')) {
        return el._value;
      }
      var val = el.value;
      if (self.params.number) {
        val = toNumber(val);
      }
      return val;
    };

    this.listener = function () {
      self.set(self.getValue());
    };
    this.on('change', this.listener);

    if (el.hasAttribute('checked')) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    this.el.checked = looseEqual(value, this.getValue());
  }
};

var select = {

  bind: function bind() {
    var _this = this;

    var self = this;
    var el = this.el;

    // method to force update DOM using latest value.
    this.forceUpdate = function () {
      if (self._watcher) {
        self.update(self._watcher.get());
      }
    };

    // check if this is a multiple select
    var multiple = this.multiple = el.hasAttribute('multiple');

    // attach listener
    this.listener = function () {
      var value = getValue(el, multiple);
      value = self.params.number ? isArray(value) ? value.map(toNumber) : toNumber(value) : value;
      self.set(value);
    };
    this.on('change', this.listener);

    // if has initial value, set afterBind
    var initValue = getValue(el, multiple, true);
    if (multiple && initValue.length || !multiple && initValue !== null) {
      this.afterBind = this.listener;
    }

    // All major browsers except Firefox resets
    // selectedIndex with value -1 to 0 when the element
    // is appended to a new parent, therefore we have to
    // force a DOM update whenever that happens...
    this.vm.$on('hook:attached', function () {
      nextTick(_this.forceUpdate);
    });
    if (!inDoc(el)) {
      nextTick(this.forceUpdate);
    }
  },

  update: function update(value) {
    var el = this.el;
    el.selectedIndex = -1;
    var multi = this.multiple && isArray(value);
    var options = el.options;
    var i = options.length;
    var op, val;
    while (i--) {
      op = options[i];
      val = op.hasOwnProperty('_value') ? op._value : op.value;
      /* eslint-disable eqeqeq */
      op.selected = multi ? indexOf$1(value, val) > -1 : looseEqual(value, val);
      /* eslint-enable eqeqeq */
    }
  },

  unbind: function unbind() {
    /* istanbul ignore next */
    this.vm.$off('hook:attached', this.forceUpdate);
  }
};

/**
 * Get select value
 *
 * @param {SelectElement} el
 * @param {Boolean} multi
 * @param {Boolean} init
 * @return {Array|*}
 */

function getValue(el, multi, init) {
  var res = multi ? [] : null;
  var op, val, selected;
  for (var i = 0, l = el.options.length; i < l; i++) {
    op = el.options[i];
    selected = init ? op.hasAttribute('selected') : op.selected;
    if (selected) {
      val = op.hasOwnProperty('_value') ? op._value : op.value;
      if (multi) {
        res.push(val);
      } else {
        return val;
      }
    }
  }
  return res;
}

/**
 * Native Array.indexOf uses strict equal, but in this
 * case we need to match string/numbers with custom equal.
 *
 * @param {Array} arr
 * @param {*} val
 */

function indexOf$1(arr, val) {
  var i = arr.length;
  while (i--) {
    if (looseEqual(arr[i], val)) {
      return i;
    }
  }
  return -1;
}

var checkbox = {

  bind: function bind() {
    var self = this;
    var el = this.el;

    this.getValue = function () {
      return el.hasOwnProperty('_value') ? el._value : self.params.number ? toNumber(el.value) : el.value;
    };

    function getBooleanValue() {
      var val = el.checked;
      if (val && el.hasOwnProperty('_trueValue')) {
        return el._trueValue;
      }
      if (!val && el.hasOwnProperty('_falseValue')) {
        return el._falseValue;
      }
      return val;
    }

    this.listener = function () {
      var model = self._watcher.get();
      if (isArray(model)) {
        var val = self.getValue();
        var i = indexOf(model, val);
        if (el.checked) {
          if (i < 0) {
            self.set(model.concat(val));
          }
        } else if (i > -1) {
          self.set(model.slice(0, i).concat(model.slice(i + 1)));
        }
      } else {
        self.set(getBooleanValue());
      }
    };

    this.on('change', this.listener);
    if (el.hasAttribute('checked')) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    var el = this.el;
    if (isArray(value)) {
      el.checked = indexOf(value, this.getValue()) > -1;
    } else {
      if (el.hasOwnProperty('_trueValue')) {
        el.checked = looseEqual(value, el._trueValue);
      } else {
        el.checked = !!value;
      }
    }
  }
};

var handlers = {
  text: text$2,
  radio: radio,
  select: select,
  checkbox: checkbox
};

var model = {

  priority: MODEL,
  twoWay: true,
  handlers: handlers,
  params: ['lazy', 'number', 'debounce'],

  /**
   * Possible elements:
   *   <select>
   *   <textarea>
   *   <input type="*">
   *     - text
   *     - checkbox
   *     - radio
   *     - number
   */

  bind: function bind() {
    // friendly warning...
    this.checkFilters();
    if (this.hasRead && !this.hasWrite) {
      process.env.NODE_ENV !== 'production' && warn('It seems you are using a read-only filter with ' + 'v-model="' + this.descriptor.raw + '". ' + 'You might want to use a two-way filter to ensure correct behavior.', this.vm);
    }
    var el = this.el;
    var tag = el.tagName;
    var handler;
    if (tag === 'INPUT') {
      handler = handlers[el.type] || handlers.text;
    } else if (tag === 'SELECT') {
      handler = handlers.select;
    } else if (tag === 'TEXTAREA') {
      handler = handlers.text;
    } else {
      process.env.NODE_ENV !== 'production' && warn('v-model does not support element type: ' + tag, this.vm);
      return;
    }
    el.__v_model = this;
    handler.bind.call(this);
    this.update = handler.update;
    this._unbind = handler.unbind;
  },

  /**
   * Check read/write filter stats.
   */

  checkFilters: function checkFilters() {
    var filters = this.filters;
    if (!filters) return;
    var i = filters.length;
    while (i--) {
      var filter = resolveAsset(this.vm.$options, 'filters', filters[i].name);
      if (typeof filter === 'function' || filter.read) {
        this.hasRead = true;
      }
      if (filter.write) {
        this.hasWrite = true;
      }
    }
  },

  unbind: function unbind() {
    this.el.__v_model = null;
    this._unbind && this._unbind();
  }
};

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  'delete': [8, 46],
  up: 38,
  left: 37,
  right: 39,
  down: 40
};

function keyFilter(handler, keys) {
  var codes = keys.map(function (key) {
    var charCode = key.charCodeAt(0);
    if (charCode > 47 && charCode < 58) {
      return parseInt(key, 10);
    }
    if (key.length === 1) {
      charCode = key.toUpperCase().charCodeAt(0);
      if (charCode > 64 && charCode < 91) {
        return charCode;
      }
    }
    return keyCodes[key];
  });
  codes = [].concat.apply([], codes);
  return function keyHandler(e) {
    if (codes.indexOf(e.keyCode) > -1) {
      return handler.call(this, e);
    }
  };
}

function stopFilter(handler) {
  return function stopHandler(e) {
    e.stopPropagation();
    return handler.call(this, e);
  };
}

function preventFilter(handler) {
  return function preventHandler(e) {
    e.preventDefault();
    return handler.call(this, e);
  };
}

function selfFilter(handler) {
  return function selfHandler(e) {
    if (e.target === e.currentTarget) {
      return handler.call(this, e);
    }
  };
}

var on$1 = {

  priority: ON,
  acceptStatement: true,
  keyCodes: keyCodes,

  bind: function bind() {
    // deal with iframes
    if (this.el.tagName === 'IFRAME' && this.arg !== 'load') {
      var self = this;
      this.iframeBind = function () {
        on(self.el.contentWindow, self.arg, self.handler, self.modifiers.capture);
      };
      this.on('load', this.iframeBind);
    }
  },

  update: function update(handler) {
    // stub a noop for v-on with no value,
    // e.g. @mousedown.prevent
    if (!this.descriptor.raw) {
      handler = function () {};
    }

    if (typeof handler !== 'function') {
      process.env.NODE_ENV !== 'production' && warn('v-on:' + this.arg + '="' + this.expression + '" expects a function value, ' + 'got ' + handler, this.vm);
      return;
    }

    // apply modifiers
    if (this.modifiers.stop) {
      handler = stopFilter(handler);
    }
    if (this.modifiers.prevent) {
      handler = preventFilter(handler);
    }
    if (this.modifiers.self) {
      handler = selfFilter(handler);
    }
    // key filter
    var keys = Object.keys(this.modifiers).filter(function (key) {
      return key !== 'stop' && key !== 'prevent' && key !== 'self' && key !== 'capture';
    });
    if (keys.length) {
      handler = keyFilter(handler, keys);
    }

    this.reset();
    this.handler = handler;

    if (this.iframeBind) {
      this.iframeBind();
    } else {
      on(this.el, this.arg, this.handler, this.modifiers.capture);
    }
  },

  reset: function reset() {
    var el = this.iframeBind ? this.el.contentWindow : this.el;
    if (this.handler) {
      off(el, this.arg, this.handler);
    }
  },

  unbind: function unbind() {
    this.reset();
  }
};

var prefixes = ['-webkit-', '-moz-', '-ms-'];
var camelPrefixes = ['Webkit', 'Moz', 'ms'];
var importantRE = /!important;?$/;
var propCache = Object.create(null);

var testEl = null;

var style = {

  deep: true,

  update: function update(value) {
    if (typeof value === 'string') {
      this.el.style.cssText = value;
    } else if (isArray(value)) {
      this.handleObject(value.reduce(extend, {}));
    } else {
      this.handleObject(value || {});
    }
  },

  handleObject: function handleObject(value) {
    // cache object styles so that only changed props
    // are actually updated.
    var cache = this.cache || (this.cache = {});
    var name, val;
    for (name in cache) {
      if (!(name in value)) {
        this.handleSingle(name, null);
        delete cache[name];
      }
    }
    for (name in value) {
      val = value[name];
      if (val !== cache[name]) {
        cache[name] = val;
        this.handleSingle(name, val);
      }
    }
  },

  handleSingle: function handleSingle(prop, value) {
    prop = normalize(prop);
    if (!prop) return; // unsupported prop
    // cast possible numbers/booleans into strings
    if (value != null) value += '';
    if (value) {
      var isImportant = importantRE.test(value) ? 'important' : '';
      if (isImportant) {
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production') {
          warn('It\'s probably a bad idea to use !important with inline rules. ' + 'This feature will be deprecated in a future version of Vue.');
        }
        value = value.replace(importantRE, '').trim();
        this.el.style.setProperty(prop.kebab, value, isImportant);
      } else {
        this.el.style[prop.camel] = value;
      }
    } else {
      this.el.style[prop.camel] = '';
    }
  }

};

/**
 * Normalize a CSS property name.
 * - cache result
 * - auto prefix
 * - camelCase -> dash-case
 *
 * @param {String} prop
 * @return {String}
 */

function normalize(prop) {
  if (propCache[prop]) {
    return propCache[prop];
  }
  var res = prefix(prop);
  propCache[prop] = propCache[res] = res;
  return res;
}

/**
 * Auto detect the appropriate prefix for a CSS property.
 * https://gist.github.com/paulirish/523692
 *
 * @param {String} prop
 * @return {String}
 */

function prefix(prop) {
  prop = hyphenate(prop);
  var camel = camelize(prop);
  var upper = camel.charAt(0).toUpperCase() + camel.slice(1);
  if (!testEl) {
    testEl = document.createElement('div');
  }
  var i = prefixes.length;
  var prefixed;
  if (camel !== 'filter' && camel in testEl.style) {
    return {
      kebab: prop,
      camel: camel
    };
  }
  while (i--) {
    prefixed = camelPrefixes[i] + upper;
    if (prefixed in testEl.style) {
      return {
        kebab: prefixes[i] + prop,
        camel: prefixed
      };
    }
  }
}

// xlink
var xlinkNS = 'http://www.w3.org/1999/xlink';
var xlinkRE = /^xlink:/;

// check for attributes that prohibit interpolations
var disallowedInterpAttrRE = /^v-|^:|^@|^(?:is|transition|transition-mode|debounce|track-by|stagger|enter-stagger|leave-stagger)$/;
// these attributes should also set their corresponding properties
// because they only affect the initial state of the element
var attrWithPropsRE = /^(?:value|checked|selected|muted)$/;
// these attributes expect enumrated values of "true" or "false"
// but are not boolean attributes
var enumeratedAttrRE = /^(?:draggable|contenteditable|spellcheck)$/;

// these attributes should set a hidden property for
// binding v-model to object values
var modelProps = {
  value: '_value',
  'true-value': '_trueValue',
  'false-value': '_falseValue'
};

var bind$1 = {

  priority: BIND,

  bind: function bind() {
    var attr = this.arg;
    var tag = this.el.tagName;
    // should be deep watch on object mode
    if (!attr) {
      this.deep = true;
    }
    // handle interpolation bindings
    var descriptor = this.descriptor;
    var tokens = descriptor.interp;
    if (tokens) {
      // handle interpolations with one-time tokens
      if (descriptor.hasOneTime) {
        this.expression = tokensToExp(tokens, this._scope || this.vm);
      }

      // only allow binding on native attributes
      if (disallowedInterpAttrRE.test(attr) || attr === 'name' && (tag === 'PARTIAL' || tag === 'SLOT')) {
        process.env.NODE_ENV !== 'production' && warn(attr + '="' + descriptor.raw + '": ' + 'attribute interpolation is not allowed in Vue.js ' + 'directives and special attributes.', this.vm);
        this.el.removeAttribute(attr);
        this.invalid = true;
      }

      /* istanbul ignore if */
      if (process.env.NODE_ENV !== 'production') {
        var raw = attr + '="' + descriptor.raw + '": ';
        // warn src
        if (attr === 'src') {
          warn(raw + 'interpolation in "src" attribute will cause ' + 'a 404 request. Use v-bind:src instead.', this.vm);
        }

        // warn style
        if (attr === 'style') {
          warn(raw + 'interpolation in "style" attribute will cause ' + 'the attribute to be discarded in Internet Explorer. ' + 'Use v-bind:style instead.', this.vm);
        }
      }
    }
  },

  update: function update(value) {
    if (this.invalid) {
      return;
    }
    var attr = this.arg;
    if (this.arg) {
      this.handleSingle(attr, value);
    } else {
      this.handleObject(value || {});
    }
  },

  // share object handler with v-bind:class
  handleObject: style.handleObject,

  handleSingle: function handleSingle(attr, value) {
    var el = this.el;
    var interp = this.descriptor.interp;
    if (this.modifiers.camel) {
      attr = camelize(attr);
    }
    if (!interp && attrWithPropsRE.test(attr) && attr in el) {
      var attrValue = attr === 'value' ? value == null // IE9 will set input.value to "null" for null...
      ? '' : value : value;

      if (el[attr] !== attrValue) {
        el[attr] = attrValue;
      }
    }
    // set model props
    var modelProp = modelProps[attr];
    if (!interp && modelProp) {
      el[modelProp] = value;
      // update v-model if present
      var model = el.__v_model;
      if (model) {
        model.listener();
      }
    }
    // do not set value attribute for textarea
    if (attr === 'value' && el.tagName === 'TEXTAREA') {
      el.removeAttribute(attr);
      return;
    }
    // update attribute
    if (enumeratedAttrRE.test(attr)) {
      el.setAttribute(attr, value ? 'true' : 'false');
    } else if (value != null && value !== false) {
      if (attr === 'class') {
        // handle edge case #1960:
        // class interpolation should not overwrite Vue transition class
        if (el.__v_trans) {
          value += ' ' + el.__v_trans.id + '-transition';
        }
        setClass(el, value);
      } else if (xlinkRE.test(attr)) {
        el.setAttributeNS(xlinkNS, attr, value === true ? '' : value);
      } else {
        el.setAttribute(attr, value === true ? '' : value);
      }
    } else {
      el.removeAttribute(attr);
    }
  }
};

var el = {

  priority: EL,

  bind: function bind() {
    /* istanbul ignore if */
    if (!this.arg) {
      return;
    }
    var id = this.id = camelize(this.arg);
    var refs = (this._scope || this.vm).$els;
    if (hasOwn(refs, id)) {
      refs[id] = this.el;
    } else {
      defineReactive(refs, id, this.el);
    }
  },

  unbind: function unbind() {
    var refs = (this._scope || this.vm).$els;
    if (refs[this.id] === this.el) {
      refs[this.id] = null;
    }
  }
};

var ref = {
  bind: function bind() {
    process.env.NODE_ENV !== 'production' && warn('v-ref:' + this.arg + ' must be used on a child ' + 'component. Found on <' + this.el.tagName.toLowerCase() + '>.', this.vm);
  }
};

var cloak = {
  bind: function bind() {
    var el = this.el;
    this.vm.$once('pre-hook:compiled', function () {
      el.removeAttribute('v-cloak');
    });
  }
};

// logic control
// two-way binding
// event handling
// attributes
// ref & el
// cloak
// must export plain object
var directives = {
  text: text$1,
  html: html,
  'for': vFor,
  'if': vIf,
  show: show,
  model: model,
  on: on$1,
  bind: bind$1,
  el: el,
  ref: ref,
  cloak: cloak
};

var vClass = {

  deep: true,

  update: function update(value) {
    if (!value) {
      this.cleanup();
    } else if (typeof value === 'string') {
      this.setClass(value.trim().split(/\s+/));
    } else {
      this.setClass(normalize$1(value));
    }
  },

  setClass: function setClass(value) {
    this.cleanup(value);
    for (var i = 0, l = value.length; i < l; i++) {
      var val = value[i];
      if (val) {
        apply(this.el, val, addClass);
      }
    }
    this.prevKeys = value;
  },

  cleanup: function cleanup(value) {
    var prevKeys = this.prevKeys;
    if (!prevKeys) return;
    var i = prevKeys.length;
    while (i--) {
      var key = prevKeys[i];
      if (!value || value.indexOf(key) < 0) {
        apply(this.el, key, removeClass);
      }
    }
  }
};

/**
 * Normalize objects and arrays (potentially containing objects)
 * into array of strings.
 *
 * @param {Object|Array<String|Object>} value
 * @return {Array<String>}
 */

function normalize$1(value) {
  var res = [];
  if (isArray(value)) {
    for (var i = 0, l = value.length; i < l; i++) {
      var _key = value[i];
      if (_key) {
        if (typeof _key === 'string') {
          res.push(_key);
        } else {
          for (var k in _key) {
            if (_key[k]) res.push(k);
          }
        }
      }
    }
  } else if (isObject(value)) {
    for (var key in value) {
      if (value[key]) res.push(key);
    }
  }
  return res;
}

/**
 * Add or remove a class/classes on an element
 *
 * @param {Element} el
 * @param {String} key The class name. This may or may not
 *                     contain a space character, in such a
 *                     case we'll deal with multiple class
 *                     names at once.
 * @param {Function} fn
 */

function apply(el, key, fn) {
  key = key.trim();
  if (key.indexOf(' ') === -1) {
    fn(el, key);
    return;
  }
  // The key contains one or more space characters.
  // Since a class name doesn't accept such characters, we
  // treat it as multiple classes.
  var keys = key.split(/\s+/);
  for (var i = 0, l = keys.length; i < l; i++) {
    fn(el, keys[i]);
  }
}

var component = {

  priority: COMPONENT,

  params: ['keep-alive', 'transition-mode', 'inline-template'],

  /**
   * Setup. Two possible usages:
   *
   * - static:
   *   <comp> or <div v-component="comp">
   *
   * - dynamic:
   *   <component :is="view">
   */

  bind: function bind() {
    if (!this.el.__vue__) {
      // keep-alive cache
      this.keepAlive = this.params.keepAlive;
      if (this.keepAlive) {
        this.cache = {};
      }
      // check inline-template
      if (this.params.inlineTemplate) {
        // extract inline template as a DocumentFragment
        this.inlineTemplate = extractContent(this.el, true);
      }
      // component resolution related state
      this.pendingComponentCb = this.Component = null;
      // transition related state
      this.pendingRemovals = 0;
      this.pendingRemovalCb = null;
      // create a ref anchor
      this.anchor = createAnchor('v-component');
      replace(this.el, this.anchor);
      // remove is attribute.
      // this is removed during compilation, but because compilation is
      // cached, when the component is used elsewhere this attribute
      // will remain at link time.
      this.el.removeAttribute('is');
      this.el.removeAttribute(':is');
      // remove ref, same as above
      if (this.descriptor.ref) {
        this.el.removeAttribute('v-ref:' + hyphenate(this.descriptor.ref));
      }
      // if static, build right now.
      if (this.literal) {
        this.setComponent(this.expression);
      }
    } else {
      process.env.NODE_ENV !== 'production' && warn('cannot mount component "' + this.expression + '" ' + 'on already mounted element: ' + this.el);
    }
  },

  /**
   * Public update, called by the watcher in the dynamic
   * literal scenario, e.g. <component :is="view">
   */

  update: function update(value) {
    if (!this.literal) {
      this.setComponent(value);
    }
  },

  /**
   * Switch dynamic components. May resolve the component
   * asynchronously, and perform transition based on
   * specified transition mode. Accepts a few additional
   * arguments specifically for vue-router.
   *
   * The callback is called when the full transition is
   * finished.
   *
   * @param {String} value
   * @param {Function} [cb]
   */

  setComponent: function setComponent(value, cb) {
    this.invalidatePending();
    if (!value) {
      // just remove current
      this.unbuild(true);
      this.remove(this.childVM, cb);
      this.childVM = null;
    } else {
      var self = this;
      this.resolveComponent(value, function () {
        self.mountComponent(cb);
      });
    }
  },

  /**
   * Resolve the component constructor to use when creating
   * the child vm.
   *
   * @param {String|Function} value
   * @param {Function} cb
   */

  resolveComponent: function resolveComponent(value, cb) {
    var self = this;
    this.pendingComponentCb = cancellable(function (Component) {
      self.ComponentName = Component.options.name || (typeof value === 'string' ? value : null);
      self.Component = Component;
      cb();
    });
    this.vm._resolveComponent(value, this.pendingComponentCb);
  },

  /**
   * Create a new instance using the current constructor and
   * replace the existing instance. This method doesn't care
   * whether the new component and the old one are actually
   * the same.
   *
   * @param {Function} [cb]
   */

  mountComponent: function mountComponent(cb) {
    // actual mount
    this.unbuild(true);
    var self = this;
    var activateHooks = this.Component.options.activate;
    var cached = this.getCached();
    var newComponent = this.build();
    if (activateHooks && !cached) {
      this.waitingFor = newComponent;
      callActivateHooks(activateHooks, newComponent, function () {
        if (self.waitingFor !== newComponent) {
          return;
        }
        self.waitingFor = null;
        self.transition(newComponent, cb);
      });
    } else {
      // update ref for kept-alive component
      if (cached) {
        newComponent._updateRef();
      }
      this.transition(newComponent, cb);
    }
  },

  /**
   * When the component changes or unbinds before an async
   * constructor is resolved, we need to invalidate its
   * pending callback.
   */

  invalidatePending: function invalidatePending() {
    if (this.pendingComponentCb) {
      this.pendingComponentCb.cancel();
      this.pendingComponentCb = null;
    }
  },

  /**
   * Instantiate/insert a new child vm.
   * If keep alive and has cached instance, insert that
   * instance; otherwise build a new one and cache it.
   *
   * @param {Object} [extraOptions]
   * @return {Vue} - the created instance
   */

  build: function build(extraOptions) {
    var cached = this.getCached();
    if (cached) {
      return cached;
    }
    if (this.Component) {
      // default options
      var options = {
        name: this.ComponentName,
        el: cloneNode(this.el),
        template: this.inlineTemplate,
        // make sure to add the child with correct parent
        // if this is a transcluded component, its parent
        // should be the transclusion host.
        parent: this._host || this.vm,
        // if no inline-template, then the compiled
        // linker can be cached for better performance.
        _linkerCachable: !this.inlineTemplate,
        _ref: this.descriptor.ref,
        _asComponent: true,
        _isRouterView: this._isRouterView,
        // if this is a transcluded component, context
        // will be the common parent vm of this instance
        // and its host.
        _context: this.vm,
        // if this is inside an inline v-for, the scope
        // will be the intermediate scope created for this
        // repeat fragment. this is used for linking props
        // and container directives.
        _scope: this._scope,
        // pass in the owner fragment of this component.
        // this is necessary so that the fragment can keep
        // track of its contained components in order to
        // call attach/detach hooks for them.
        _frag: this._frag
      };
      // extra options
      // in 1.0.0 this is used by vue-router only
      /* istanbul ignore if */
      if (extraOptions) {
        extend(options, extraOptions);
      }
      var child = new this.Component(options);
      if (this.keepAlive) {
        this.cache[this.Component.cid] = child;
      }
      /* istanbul ignore if */
      if (process.env.NODE_ENV !== 'production' && this.el.hasAttribute('transition') && child._isFragment) {
        warn('Transitions will not work on a fragment instance. ' + 'Template: ' + child.$options.template, child);
      }
      return child;
    }
  },

  /**
   * Try to get a cached instance of the current component.
   *
   * @return {Vue|undefined}
   */

  getCached: function getCached() {
    return this.keepAlive && this.cache[this.Component.cid];
  },

  /**
   * Teardown the current child, but defers cleanup so
   * that we can separate the destroy and removal steps.
   *
   * @param {Boolean} defer
   */

  unbuild: function unbuild(defer) {
    if (this.waitingFor) {
      if (!this.keepAlive) {
        this.waitingFor.$destroy();
      }
      this.waitingFor = null;
    }
    var child = this.childVM;
    if (!child || this.keepAlive) {
      if (child) {
        // remove ref
        child._inactive = true;
        child._updateRef(true);
      }
      return;
    }
    // the sole purpose of `deferCleanup` is so that we can
    // "deactivate" the vm right now and perform DOM removal
    // later.
    child.$destroy(false, defer);
  },

  /**
   * Remove current destroyed child and manually do
   * the cleanup after removal.
   *
   * @param {Function} cb
   */

  remove: function remove(child, cb) {
    var keepAlive = this.keepAlive;
    if (child) {
      // we may have a component switch when a previous
      // component is still being transitioned out.
      // we want to trigger only one lastest insertion cb
      // when the existing transition finishes. (#1119)
      this.pendingRemovals++;
      this.pendingRemovalCb = cb;
      var self = this;
      child.$remove(function () {
        self.pendingRemovals--;
        if (!keepAlive) child._cleanup();
        if (!self.pendingRemovals && self.pendingRemovalCb) {
          self.pendingRemovalCb();
          self.pendingRemovalCb = null;
        }
      });
    } else if (cb) {
      cb();
    }
  },

  /**
   * Actually swap the components, depending on the
   * transition mode. Defaults to simultaneous.
   *
   * @param {Vue} target
   * @param {Function} [cb]
   */

  transition: function transition(target, cb) {
    var self = this;
    var current = this.childVM;
    // for devtool inspection
    if (current) current._inactive = true;
    target._inactive = false;
    this.childVM = target;
    switch (self.params.transitionMode) {
      case 'in-out':
        target.$before(self.anchor, function () {
          self.remove(current, cb);
        });
        break;
      case 'out-in':
        self.remove(current, function () {
          target.$before(self.anchor, cb);
        });
        break;
      default:
        self.remove(current);
        target.$before(self.anchor, cb);
    }
  },

  /**
   * Unbind.
   */

  unbind: function unbind() {
    this.invalidatePending();
    // Do not defer cleanup when unbinding
    this.unbuild();
    // destroy all keep-alive cached instances
    if (this.cache) {
      for (var key in this.cache) {
        this.cache[key].$destroy();
      }
      this.cache = null;
    }
  }
};

/**
 * Call activate hooks in order (asynchronous)
 *
 * @param {Array} hooks
 * @param {Vue} vm
 * @param {Function} cb
 */

function callActivateHooks(hooks, vm, cb) {
  var total = hooks.length;
  var called = 0;
  hooks[0].call(vm, next);
  function next() {
    if (++called >= total) {
      cb();
    } else {
      hooks[called].call(vm, next);
    }
  }
}

var propBindingModes = config._propBindingModes;
var empty = {};

// regexes
var identRE$1 = /^[$_a-zA-Z]+[\w$]*$/;
var settablePathRE = /^[A-Za-z_$][\w$]*(\.[A-Za-z_$][\w$]*|\[[^\[\]]+\])*$/;

/**
 * Compile props on a root element and return
 * a props link function.
 *
 * @param {Element|DocumentFragment} el
 * @param {Array} propOptions
 * @param {Vue} vm
 * @return {Function} propsLinkFn
 */

function compileProps(el, propOptions, vm) {
  var props = [];
  var propsData = vm.$options.propsData;
  var names = Object.keys(propOptions);
  var i = names.length;
  var options, name, attr, value, path, parsed, prop;
  while (i--) {
    name = names[i];
    options = propOptions[name] || empty;

    if (process.env.NODE_ENV !== 'production' && name === '$data') {
      warn('Do not use $data as prop.', vm);
      continue;
    }

    // props could contain dashes, which will be
    // interpreted as minus calculations by the parser
    // so we need to camelize the path here
    path = camelize(name);
    if (!identRE$1.test(path)) {
      process.env.NODE_ENV !== 'production' && warn('Invalid prop key: "' + name + '". Prop keys ' + 'must be valid identifiers.', vm);
      continue;
    }

    prop = {
      name: name,
      path: path,
      options: options,
      mode: propBindingModes.ONE_WAY,
      raw: null
    };

    attr = hyphenate(name);
    // first check dynamic version
    if ((value = getBindAttr(el, attr)) === null) {
      if ((value = getBindAttr(el, attr + '.sync')) !== null) {
        prop.mode = propBindingModes.TWO_WAY;
      } else if ((value = getBindAttr(el, attr + '.once')) !== null) {
        prop.mode = propBindingModes.ONE_TIME;
      }
    }
    if (value !== null) {
      // has dynamic binding!
      prop.raw = value;
      parsed = parseDirective(value);
      value = parsed.expression;
      prop.filters = parsed.filters;
      // check binding type
      if (isLiteral(value) && !parsed.filters) {
        // for expressions containing literal numbers and
        // booleans, there's no need to setup a prop binding,
        // so we can optimize them as a one-time set.
        prop.optimizedLiteral = true;
      } else {
        prop.dynamic = true;
        // check non-settable path for two-way bindings
        if (process.env.NODE_ENV !== 'production' && prop.mode === propBindingModes.TWO_WAY && !settablePathRE.test(value)) {
          prop.mode = propBindingModes.ONE_WAY;
          warn('Cannot bind two-way prop with non-settable ' + 'parent path: ' + value, vm);
        }
      }
      prop.parentPath = value;

      // warn required two-way
      if (process.env.NODE_ENV !== 'production' && options.twoWay && prop.mode !== propBindingModes.TWO_WAY) {
        warn('Prop "' + name + '" expects a two-way binding type.', vm);
      }
    } else if ((value = getAttr(el, attr)) !== null) {
      // has literal binding!
      prop.raw = value;
    } else if (propsData && (value = propsData[name] || propsData[path]) !== null) {
      // has propsData
      prop.raw = value;
    } else if (process.env.NODE_ENV !== 'production') {
      // check possible camelCase prop usage
      var lowerCaseName = path.toLowerCase();
      value = /[A-Z\-]/.test(name) && (el.getAttribute(lowerCaseName) || el.getAttribute(':' + lowerCaseName) || el.getAttribute('v-bind:' + lowerCaseName) || el.getAttribute(':' + lowerCaseName + '.once') || el.getAttribute('v-bind:' + lowerCaseName + '.once') || el.getAttribute(':' + lowerCaseName + '.sync') || el.getAttribute('v-bind:' + lowerCaseName + '.sync'));
      if (value) {
        warn('Possible usage error for prop `' + lowerCaseName + '` - ' + 'did you mean `' + attr + '`? HTML is case-insensitive, remember to use ' + 'kebab-case for props in templates.', vm);
      } else if (options.required && (!propsData || !(name in propsData) && !(path in propsData))) {
        // warn missing required
        warn('Missing required prop: ' + name, vm);
      }
    }
    // push prop
    props.push(prop);
  }
  return makePropsLinkFn(props);
}

/**
 * Build a function that applies props to a vm.
 *
 * @param {Array} props
 * @return {Function} propsLinkFn
 */

function makePropsLinkFn(props) {
  return function propsLinkFn(vm, scope) {
    // store resolved props info
    vm._props = {};
    var inlineProps = vm.$options.propsData;
    var i = props.length;
    var prop, path, options, value, raw;
    while (i--) {
      prop = props[i];
      raw = prop.raw;
      path = prop.path;
      options = prop.options;
      vm._props[path] = prop;
      if (inlineProps && hasOwn(inlineProps, path)) {
        initProp(vm, prop, inlineProps[path]);
      }if (raw === null) {
        // initialize absent prop
        initProp(vm, prop, undefined);
      } else if (prop.dynamic) {
        // dynamic prop
        if (prop.mode === propBindingModes.ONE_TIME) {
          // one time binding
          value = (scope || vm._context || vm).$get(prop.parentPath);
          initProp(vm, prop, value);
        } else {
          if (vm._context) {
            // dynamic binding
            vm._bindDir({
              name: 'prop',
              def: propDef,
              prop: prop
            }, null, null, scope); // el, host, scope
          } else {
              // root instance
              initProp(vm, prop, vm.$get(prop.parentPath));
            }
        }
      } else if (prop.optimizedLiteral) {
        // optimized literal, cast it and just set once
        var stripped = stripQuotes(raw);
        value = stripped === raw ? toBoolean(toNumber(raw)) : stripped;
        initProp(vm, prop, value);
      } else {
        // string literal, but we need to cater for
        // Boolean props with no value, or with same
        // literal value (e.g. disabled="disabled")
        // see https://github.com/vuejs/vue-loader/issues/182
        value = options.type === Boolean && (raw === '' || raw === hyphenate(prop.name)) ? true : raw;
        initProp(vm, prop, value);
      }
    }
  };
}

/**
 * Process a prop with a rawValue, applying necessary coersions,
 * default values & assertions and call the given callback with
 * processed value.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} rawValue
 * @param {Function} fn
 */

function processPropValue(vm, prop, rawValue, fn) {
  var isSimple = prop.dynamic && isSimplePath(prop.parentPath);
  var value = rawValue;
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop);
  }
  value = coerceProp(prop, value, vm);
  var coerced = value !== rawValue;
  if (!assertProp(prop, value, vm)) {
    value = undefined;
  }
  if (isSimple && !coerced) {
    withoutConversion(function () {
      fn(value);
    });
  } else {
    fn(value);
  }
}

/**
 * Set a prop's initial value on a vm and its data object.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} value
 */

function initProp(vm, prop, value) {
  processPropValue(vm, prop, value, function (value) {
    defineReactive(vm, prop.path, value);
  });
}

/**
 * Update a prop's value on a vm.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} value
 */

function updateProp(vm, prop, value) {
  processPropValue(vm, prop, value, function (value) {
    vm[prop.path] = value;
  });
}

/**
 * Get the default value of a prop.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @return {*}
 */

function getPropDefaultValue(vm, prop) {
  // no default, return undefined
  var options = prop.options;
  if (!hasOwn(options, 'default')) {
    // absent boolean value defaults to false
    return options.type === Boolean ? false : undefined;
  }
  var def = options['default'];
  // warn against non-factory defaults for Object & Array
  if (isObject(def)) {
    process.env.NODE_ENV !== 'production' && warn('Invalid default value for prop "' + prop.name + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
  }
  // call factory function for non-Function types
  return typeof def === 'function' && options.type !== Function ? def.call(vm) : def;
}

/**
 * Assert whether a prop is valid.
 *
 * @param {Object} prop
 * @param {*} value
 * @param {Vue} vm
 */

function assertProp(prop, value, vm) {
  if (!prop.options.required && ( // non-required
  prop.raw === null || // abscent
  value == null) // null or undefined
  ) {
      return true;
    }
  var options = prop.options;
  var type = options.type;
  var valid = !type;
  var expectedTypes = [];
  if (type) {
    if (!isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType);
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    if (process.env.NODE_ENV !== 'production') {
      warn('Invalid prop: type check failed for prop "' + prop.name + '".' + ' Expected ' + expectedTypes.map(formatType).join(', ') + ', got ' + formatValue(value) + '.', vm);
    }
    return false;
  }
  var validator = options.validator;
  if (validator) {
    if (!validator(value)) {
      process.env.NODE_ENV !== 'production' && warn('Invalid prop: custom validator check failed for prop "' + prop.name + '".', vm);
      return false;
    }
  }
  return true;
}

/**
 * Force parsing value with coerce option.
 *
 * @param {*} value
 * @param {Object} options
 * @return {*}
 */

function coerceProp(prop, value, vm) {
  var coerce = prop.options.coerce;
  if (!coerce) {
    return value;
  }
  if (typeof coerce === 'function') {
    return coerce(value);
  } else {
    process.env.NODE_ENV !== 'production' && warn('Invalid coerce for prop "' + prop.name + '": expected function, got ' + typeof coerce + '.', vm);
    return value;
  }
}

/**
 * Assert the type of a value
 *
 * @param {*} value
 * @param {Function} type
 * @return {Object}
 */

function assertType(value, type) {
  var valid;
  var expectedType;
  if (type === String) {
    expectedType = 'string';
    valid = typeof value === expectedType;
  } else if (type === Number) {
    expectedType = 'number';
    valid = typeof value === expectedType;
  } else if (type === Boolean) {
    expectedType = 'boolean';
    valid = typeof value === expectedType;
  } else if (type === Function) {
    expectedType = 'function';
    valid = typeof value === expectedType;
  } else if (type === Object) {
    expectedType = 'object';
    valid = isPlainObject(value);
  } else if (type === Array) {
    expectedType = 'array';
    valid = isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  };
}

/**
 * Format type for output
 *
 * @param {String} type
 * @return {String}
 */

function formatType(type) {
  return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'custom type';
}

/**
 * Format value
 *
 * @param {*} value
 * @return {String}
 */

function formatValue(val) {
  return Object.prototype.toString.call(val).slice(8, -1);
}

var bindingModes = config._propBindingModes;

var propDef = {

  bind: function bind() {
    var child = this.vm;
    var parent = child._context;
    // passed in from compiler directly
    var prop = this.descriptor.prop;
    var childKey = prop.path;
    var parentKey = prop.parentPath;
    var twoWay = prop.mode === bindingModes.TWO_WAY;

    var parentWatcher = this.parentWatcher = new Watcher(parent, parentKey, function (val) {
      updateProp(child, prop, val);
    }, {
      twoWay: twoWay,
      filters: prop.filters,
      // important: props need to be observed on the
      // v-for scope if present
      scope: this._scope
    });

    // set the child initial value.
    initProp(child, prop, parentWatcher.value);

    // setup two-way binding
    if (twoWay) {
      // important: defer the child watcher creation until
      // the created hook (after data observation)
      var self = this;
      child.$once('pre-hook:created', function () {
        self.childWatcher = new Watcher(child, childKey, function (val) {
          parentWatcher.set(val);
        }, {
          // ensure sync upward before parent sync down.
          // this is necessary in cases e.g. the child
          // mutates a prop array, then replaces it. (#1683)
          sync: true
        });
      });
    }
  },

  unbind: function unbind() {
    this.parentWatcher.teardown();
    if (this.childWatcher) {
      this.childWatcher.teardown();
    }
  }
};

var queue$1 = [];
var queued = false;

/**
 * Push a job into the queue.
 *
 * @param {Function} job
 */

function pushJob(job) {
  queue$1.push(job);
  if (!queued) {
    queued = true;
    nextTick(flush);
  }
}

/**
 * Flush the queue, and do one forced reflow before
 * triggering transitions.
 */

function flush() {
  // Force layout
  var f = document.documentElement.offsetHeight;
  for (var i = 0; i < queue$1.length; i++) {
    queue$1[i]();
  }
  queue$1 = [];
  queued = false;
  // dummy return, so js linters don't complain about
  // unused variable f
  return f;
}

var TYPE_TRANSITION = 'transition';
var TYPE_ANIMATION = 'animation';
var transDurationProp = transitionProp + 'Duration';
var animDurationProp = animationProp + 'Duration';

/**
 * If a just-entered element is applied the
 * leave class while its enter transition hasn't started yet,
 * and the transitioned property has the same value for both
 * enter/leave, then the leave transition will be skipped and
 * the transitionend event never fires. This function ensures
 * its callback to be called after a transition has started
 * by waiting for double raf.
 *
 * It falls back to setTimeout on devices that support CSS
 * transitions but not raf (e.g. Android 4.2 browser) - since
 * these environments are usually slow, we are giving it a
 * relatively large timeout.
 */

var raf = inBrowser && window.requestAnimationFrame;
var waitForTransitionStart = raf
/* istanbul ignore next */
? function (fn) {
  raf(function () {
    raf(fn);
  });
} : function (fn) {
  setTimeout(fn, 50);
};

/**
 * A Transition object that encapsulates the state and logic
 * of the transition.
 *
 * @param {Element} el
 * @param {String} id
 * @param {Object} hooks
 * @param {Vue} vm
 */
function Transition(el, id, hooks, vm) {
  this.id = id;
  this.el = el;
  this.enterClass = hooks && hooks.enterClass || id + '-enter';
  this.leaveClass = hooks && hooks.leaveClass || id + '-leave';
  this.hooks = hooks;
  this.vm = vm;
  // async state
  this.pendingCssEvent = this.pendingCssCb = this.cancel = this.pendingJsCb = this.op = this.cb = null;
  this.justEntered = false;
  this.entered = this.left = false;
  this.typeCache = {};
  // check css transition type
  this.type = hooks && hooks.type;
  /* istanbul ignore if */
  if (process.env.NODE_ENV !== 'production') {
    if (this.type && this.type !== TYPE_TRANSITION && this.type !== TYPE_ANIMATION) {
      warn('invalid CSS transition type for transition="' + this.id + '": ' + this.type, vm);
    }
  }
  // bind
  var self = this;['enterNextTick', 'enterDone', 'leaveNextTick', 'leaveDone'].forEach(function (m) {
    self[m] = bind(self[m], self);
  });
}

var p$1 = Transition.prototype;

/**
 * Start an entering transition.
 *
 * 1. enter transition triggered
 * 2. call beforeEnter hook
 * 3. add enter class
 * 4. insert/show element
 * 5. call enter hook (with possible explicit js callback)
 * 6. reflow
 * 7. based on transition type:
 *    - transition:
 *        remove class now, wait for transitionend,
 *        then done if there's no explicit js callback.
 *    - animation:
 *        wait for animationend, remove class,
 *        then done if there's no explicit js callback.
 *    - no css transition:
 *        done now if there's no explicit js callback.
 * 8. wait for either done or js callback, then call
 *    afterEnter hook.
 *
 * @param {Function} op - insert/show the element
 * @param {Function} [cb]
 */

p$1.enter = function (op, cb) {
  this.cancelPending();
  this.callHook('beforeEnter');
  this.cb = cb;
  addClass(this.el, this.enterClass);
  op();
  this.entered = false;
  this.callHookWithCb('enter');
  if (this.entered) {
    return; // user called done synchronously.
  }
  this.cancel = this.hooks && this.hooks.enterCancelled;
  pushJob(this.enterNextTick);
};

/**
 * The "nextTick" phase of an entering transition, which is
 * to be pushed into a queue and executed after a reflow so
 * that removing the class can trigger a CSS transition.
 */

p$1.enterNextTick = function () {
  var _this = this;

  // prevent transition skipping
  this.justEntered = true;
  waitForTransitionStart(function () {
    _this.justEntered = false;
  });
  var enterDone = this.enterDone;
  var type = this.getCssTransitionType(this.enterClass);
  if (!this.pendingJsCb) {
    if (type === TYPE_TRANSITION) {
      // trigger transition by removing enter class now
      removeClass(this.el, this.enterClass);
      this.setupCssCb(transitionEndEvent, enterDone);
    } else if (type === TYPE_ANIMATION) {
      this.setupCssCb(animationEndEvent, enterDone);
    } else {
      enterDone();
    }
  } else if (type === TYPE_TRANSITION) {
    removeClass(this.el, this.enterClass);
  }
};

/**
 * The "cleanup" phase of an entering transition.
 */

p$1.enterDone = function () {
  this.entered = true;
  this.cancel = this.pendingJsCb = null;
  removeClass(this.el, this.enterClass);
  this.callHook('afterEnter');
  if (this.cb) this.cb();
};

/**
 * Start a leaving transition.
 *
 * 1. leave transition triggered.
 * 2. call beforeLeave hook
 * 3. add leave class (trigger css transition)
 * 4. call leave hook (with possible explicit js callback)
 * 5. reflow if no explicit js callback is provided
 * 6. based on transition type:
 *    - transition or animation:
 *        wait for end event, remove class, then done if
 *        there's no explicit js callback.
 *    - no css transition:
 *        done if there's no explicit js callback.
 * 7. wait for either done or js callback, then call
 *    afterLeave hook.
 *
 * @param {Function} op - remove/hide the element
 * @param {Function} [cb]
 */

p$1.leave = function (op, cb) {
  this.cancelPending();
  this.callHook('beforeLeave');
  this.op = op;
  this.cb = cb;
  addClass(this.el, this.leaveClass);
  this.left = false;
  this.callHookWithCb('leave');
  if (this.left) {
    return; // user called done synchronously.
  }
  this.cancel = this.hooks && this.hooks.leaveCancelled;
  // only need to handle leaveDone if
  // 1. the transition is already done (synchronously called
  //    by the user, which causes this.op set to null)
  // 2. there's no explicit js callback
  if (this.op && !this.pendingJsCb) {
    // if a CSS transition leaves immediately after enter,
    // the transitionend event never fires. therefore we
    // detect such cases and end the leave immediately.
    if (this.justEntered) {
      this.leaveDone();
    } else {
      pushJob(this.leaveNextTick);
    }
  }
};

/**
 * The "nextTick" phase of a leaving transition.
 */

p$1.leaveNextTick = function () {
  var type = this.getCssTransitionType(this.leaveClass);
  if (type) {
    var event = type === TYPE_TRANSITION ? transitionEndEvent : animationEndEvent;
    this.setupCssCb(event, this.leaveDone);
  } else {
    this.leaveDone();
  }
};

/**
 * The "cleanup" phase of a leaving transition.
 */

p$1.leaveDone = function () {
  this.left = true;
  this.cancel = this.pendingJsCb = null;
  this.op();
  removeClass(this.el, this.leaveClass);
  this.callHook('afterLeave');
  if (this.cb) this.cb();
  this.op = null;
};

/**
 * Cancel any pending callbacks from a previously running
 * but not finished transition.
 */

p$1.cancelPending = function () {
  this.op = this.cb = null;
  var hasPending = false;
  if (this.pendingCssCb) {
    hasPending = true;
    off(this.el, this.pendingCssEvent, this.pendingCssCb);
    this.pendingCssEvent = this.pendingCssCb = null;
  }
  if (this.pendingJsCb) {
    hasPending = true;
    this.pendingJsCb.cancel();
    this.pendingJsCb = null;
  }
  if (hasPending) {
    removeClass(this.el, this.enterClass);
    removeClass(this.el, this.leaveClass);
  }
  if (this.cancel) {
    this.cancel.call(this.vm, this.el);
    this.cancel = null;
  }
};

/**
 * Call a user-provided synchronous hook function.
 *
 * @param {String} type
 */

p$1.callHook = function (type) {
  if (this.hooks && this.hooks[type]) {
    this.hooks[type].call(this.vm, this.el);
  }
};

/**
 * Call a user-provided, potentially-async hook function.
 * We check for the length of arguments to see if the hook
 * expects a `done` callback. If true, the transition's end
 * will be determined by when the user calls that callback;
 * otherwise, the end is determined by the CSS transition or
 * animation.
 *
 * @param {String} type
 */

p$1.callHookWithCb = function (type) {
  var hook = this.hooks && this.hooks[type];
  if (hook) {
    if (hook.length > 1) {
      this.pendingJsCb = cancellable(this[type + 'Done']);
    }
    hook.call(this.vm, this.el, this.pendingJsCb);
  }
};

/**
 * Get an element's transition type based on the
 * calculated styles.
 *
 * @param {String} className
 * @return {Number}
 */

p$1.getCssTransitionType = function (className) {
  /* istanbul ignore if */
  if (!transitionEndEvent ||
  // skip CSS transitions if page is not visible -
  // this solves the issue of transitionend events not
  // firing until the page is visible again.
  // pageVisibility API is supported in IE10+, same as
  // CSS transitions.
  document.hidden ||
  // explicit js-only transition
  this.hooks && this.hooks.css === false ||
  // element is hidden
  isHidden(this.el)) {
    return;
  }
  var type = this.type || this.typeCache[className];
  if (type) return type;
  var inlineStyles = this.el.style;
  var computedStyles = window.getComputedStyle(this.el);
  var transDuration = inlineStyles[transDurationProp] || computedStyles[transDurationProp];
  if (transDuration && transDuration !== '0s') {
    type = TYPE_TRANSITION;
  } else {
    var animDuration = inlineStyles[animDurationProp] || computedStyles[animDurationProp];
    if (animDuration && animDuration !== '0s') {
      type = TYPE_ANIMATION;
    }
  }
  if (type) {
    this.typeCache[className] = type;
  }
  return type;
};

/**
 * Setup a CSS transitionend/animationend callback.
 *
 * @param {String} event
 * @param {Function} cb
 */

p$1.setupCssCb = function (event, cb) {
  this.pendingCssEvent = event;
  var self = this;
  var el = this.el;
  var onEnd = this.pendingCssCb = function (e) {
    if (e.target === el) {
      off(el, event, onEnd);
      self.pendingCssEvent = self.pendingCssCb = null;
      if (!self.pendingJsCb && cb) {
        cb();
      }
    }
  };
  on(el, event, onEnd);
};

/**
 * Check if an element is hidden - in that case we can just
 * skip the transition alltogether.
 *
 * @param {Element} el
 * @return {Boolean}
 */

function isHidden(el) {
  if (/svg$/.test(el.namespaceURI)) {
    // SVG elements do not have offset(Width|Height)
    // so we need to check the client rect
    var rect = el.getBoundingClientRect();
    return !(rect.width || rect.height);
  } else {
    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }
}

var transition$1 = {

  priority: TRANSITION,

  update: function update(id, oldId) {
    var el = this.el;
    // resolve on owner vm
    var hooks = resolveAsset(this.vm.$options, 'transitions', id);
    id = id || 'v';
    oldId = oldId || 'v';
    el.__v_trans = new Transition(el, id, hooks, this.vm);
    removeClass(el, oldId + '-transition');
    addClass(el, id + '-transition');
  }
};

var internalDirectives = {
  style: style,
  'class': vClass,
  component: component,
  prop: propDef,
  transition: transition$1
};

// special binding prefixes
var bindRE = /^v-bind:|^:/;
var onRE = /^v-on:|^@/;
var dirAttrRE = /^v-([^:]+)(?:$|:(.*)$)/;
var modifierRE = /\.[^\.]+/g;
var transitionRE = /^(v-bind:|:)?transition$/;

// default directive priority
var DEFAULT_PRIORITY = 1000;
var DEFAULT_TERMINAL_PRIORITY = 2000;

/**
 * Compile a template and return a reusable composite link
 * function, which recursively contains more link functions
 * inside. This top level compile function would normally
 * be called on instance root nodes, but can also be used
 * for partial compilation if the partial argument is true.
 *
 * The returned composite link function, when called, will
 * return an unlink function that tearsdown all directives
 * created during the linking phase.
 *
 * @param {Element|DocumentFragment} el
 * @param {Object} options
 * @param {Boolean} partial
 * @return {Function}
 */

function compile(el, options, partial) {
  // link function for the node itself.
  var nodeLinkFn = partial || !options._asComponent ? compileNode(el, options) : null;
  // link function for the childNodes
  var childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && !isScript(el) && el.hasChildNodes() ? compileNodeList(el.childNodes, options) : null;

  /**
   * A composite linker function to be called on a already
   * compiled piece of DOM, which instantiates all directive
   * instances.
   *
   * @param {Vue} vm
   * @param {Element|DocumentFragment} el
   * @param {Vue} [host] - host vm of transcluded content
   * @param {Object} [scope] - v-for scope
   * @param {Fragment} [frag] - link context fragment
   * @return {Function|undefined}
   */

  return function compositeLinkFn(vm, el, host, scope, frag) {
    // cache childNodes before linking parent, fix #657
    var childNodes = toArray(el.childNodes);
    // link
    var dirs = linkAndCapture(function compositeLinkCapturer() {
      if (nodeLinkFn) nodeLinkFn(vm, el, host, scope, frag);
      if (childLinkFn) childLinkFn(vm, childNodes, host, scope, frag);
    }, vm);
    return makeUnlinkFn(vm, dirs);
  };
}

/**
 * Apply a linker to a vm/element pair and capture the
 * directives created during the process.
 *
 * @param {Function} linker
 * @param {Vue} vm
 */

function linkAndCapture(linker, vm) {
  /* istanbul ignore if */
  if (process.env.NODE_ENV === 'production') {
    // reset directives before every capture in production
    // mode, so that when unlinking we don't need to splice
    // them out (which turns out to be a perf hit).
    // they are kept in development mode because they are
    // useful for Vue's own tests.
    vm._directives = [];
  }
  var originalDirCount = vm._directives.length;
  linker();
  var dirs = vm._directives.slice(originalDirCount);
  sortDirectives(dirs);
  for (var i = 0, l = dirs.length; i < l; i++) {
    dirs[i]._bind();
  }
  return dirs;
}

/**
 * sort directives by priority (stable sort)
 *
 * @param {Array} dirs
 */
function sortDirectives(dirs) {
  if (dirs.length === 0) return;

  var groupedMap = {};
  var i, j, k, l;
  var index = 0;
  var priorities = [];
  for (i = 0, j = dirs.length; i < j; i++) {
    var dir = dirs[i];
    var priority = dir.descriptor.def.priority || DEFAULT_PRIORITY;
    var array = groupedMap[priority];
    if (!array) {
      array = groupedMap[priority] = [];
      priorities.push(priority);
    }
    array.push(dir);
  }

  priorities.sort(function (a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
  });
  for (i = 0, j = priorities.length; i < j; i++) {
    var group = groupedMap[priorities[i]];
    for (k = 0, l = group.length; k < l; k++) {
      dirs[index++] = group[k];
    }
  }
}

/**
 * Linker functions return an unlink function that
 * tearsdown all directives instances generated during
 * the process.
 *
 * We create unlink functions with only the necessary
 * information to avoid retaining additional closures.
 *
 * @param {Vue} vm
 * @param {Array} dirs
 * @param {Vue} [context]
 * @param {Array} [contextDirs]
 * @return {Function}
 */

function makeUnlinkFn(vm, dirs, context, contextDirs) {
  function unlink(destroying) {
    teardownDirs(vm, dirs, destroying);
    if (context && contextDirs) {
      teardownDirs(context, contextDirs);
    }
  }
  // expose linked directives
  unlink.dirs = dirs;
  return unlink;
}

/**
 * Teardown partial linked directives.
 *
 * @param {Vue} vm
 * @param {Array} dirs
 * @param {Boolean} destroying
 */

function teardownDirs(vm, dirs, destroying) {
  var i = dirs.length;
  while (i--) {
    dirs[i]._teardown();
    if (process.env.NODE_ENV !== 'production' && !destroying) {
      vm._directives.$remove(dirs[i]);
    }
  }
}

/**
 * Compile link props on an instance.
 *
 * @param {Vue} vm
 * @param {Element} el
 * @param {Object} props
 * @param {Object} [scope]
 * @return {Function}
 */

function compileAndLinkProps(vm, el, props, scope) {
  var propsLinkFn = compileProps(el, props, vm);
  var propDirs = linkAndCapture(function () {
    propsLinkFn(vm, scope);
  }, vm);
  return makeUnlinkFn(vm, propDirs);
}

/**
 * Compile the root element of an instance.
 *
 * 1. attrs on context container (context scope)
 * 2. attrs on the component template root node, if
 *    replace:true (child scope)
 *
 * If this is a fragment instance, we only need to compile 1.
 *
 * @param {Element} el
 * @param {Object} options
 * @param {Object} contextOptions
 * @return {Function}
 */

function compileRoot(el, options, contextOptions) {
  var containerAttrs = options._containerAttrs;
  var replacerAttrs = options._replacerAttrs;
  var contextLinkFn, replacerLinkFn;

  // only need to compile other attributes for
  // non-fragment instances
  if (el.nodeType !== 11) {
    // for components, container and replacer need to be
    // compiled separately and linked in different scopes.
    if (options._asComponent) {
      // 2. container attributes
      if (containerAttrs && contextOptions) {
        contextLinkFn = compileDirectives(containerAttrs, contextOptions);
      }
      if (replacerAttrs) {
        // 3. replacer attributes
        replacerLinkFn = compileDirectives(replacerAttrs, options);
      }
    } else {
      // non-component, just compile as a normal element.
      replacerLinkFn = compileDirectives(el.attributes, options);
    }
  } else if (process.env.NODE_ENV !== 'production' && containerAttrs) {
    // warn container directives for fragment instances
    var names = containerAttrs.filter(function (attr) {
      // allow vue-loader/vueify scoped css attributes
      return attr.name.indexOf('_v-') < 0 &&
      // allow event listeners
      !onRE.test(attr.name) &&
      // allow slots
      attr.name !== 'slot';
    }).map(function (attr) {
      return '"' + attr.name + '"';
    });
    if (names.length) {
      var plural = names.length > 1;

      var componentName = options.el.tagName.toLowerCase();
      if (componentName === 'component' && options.name) {
        componentName += ':' + options.name;
      }

      warn('Attribute' + (plural ? 's ' : ' ') + names.join(', ') + (plural ? ' are' : ' is') + ' ignored on component ' + '<' + componentName + '> because ' + 'the component is a fragment instance: ' + 'http://vuejs.org/guide/components.html#Fragment-Instance');
    }
  }

  options._containerAttrs = options._replacerAttrs = null;
  return function rootLinkFn(vm, el, scope) {
    // link context scope dirs
    var context = vm._context;
    var contextDirs;
    if (context && contextLinkFn) {
      contextDirs = linkAndCapture(function () {
        contextLinkFn(context, el, null, scope);
      }, context);
    }

    // link self
    var selfDirs = linkAndCapture(function () {
      if (replacerLinkFn) replacerLinkFn(vm, el);
    }, vm);

    // return the unlink function that tearsdown context
    // container directives.
    return makeUnlinkFn(vm, selfDirs, context, contextDirs);
  };
}

/**
 * Compile a node and return a nodeLinkFn based on the
 * node type.
 *
 * @param {Node} node
 * @param {Object} options
 * @return {Function|null}
 */

function compileNode(node, options) {
  var type = node.nodeType;
  if (type === 1 && !isScript(node)) {
    return compileElement(node, options);
  } else if (type === 3 && node.data.trim()) {
    return compileTextNode(node, options);
  } else {
    return null;
  }
}

/**
 * Compile an element and return a nodeLinkFn.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Function|null}
 */

function compileElement(el, options) {
  // preprocess textareas.
  // textarea treats its text content as the initial value.
  // just bind it as an attr directive for value.
  if (el.tagName === 'TEXTAREA') {
    // a textarea which has v-pre attr should skip complie.
    if (getAttr(el, 'v-pre') !== null) {
      return skip;
    }
    var tokens = parseText(el.value);
    if (tokens) {
      el.setAttribute(':value', tokensToExp(tokens));
      el.value = '';
    }
  }
  var linkFn;
  var hasAttrs = el.hasAttributes();
  var attrs = hasAttrs && toArray(el.attributes);
  // check terminal directives (for & if)
  if (hasAttrs) {
    linkFn = checkTerminalDirectives(el, attrs, options);
  }
  // check element directives
  if (!linkFn) {
    linkFn = checkElementDirectives(el, options);
  }
  // check component
  if (!linkFn) {
    linkFn = checkComponent(el, options);
  }
  // normal directives
  if (!linkFn && hasAttrs) {
    linkFn = compileDirectives(attrs, options);
  }
  return linkFn;
}

/**
 * Compile a textNode and return a nodeLinkFn.
 *
 * @param {TextNode} node
 * @param {Object} options
 * @return {Function|null} textNodeLinkFn
 */

function compileTextNode(node, options) {
  // skip marked text nodes
  if (node._skip) {
    return removeText;
  }

  var tokens = parseText(node.wholeText);
  if (!tokens) {
    return null;
  }

  // mark adjacent text nodes as skipped,
  // because we are using node.wholeText to compile
  // all adjacent text nodes together. This fixes
  // issues in IE where sometimes it splits up a single
  // text node into multiple ones.
  var next = node.nextSibling;
  while (next && next.nodeType === 3) {
    next._skip = true;
    next = next.nextSibling;
  }

  var frag = document.createDocumentFragment();
  var el, token;
  for (var i = 0, l = tokens.length; i < l; i++) {
    token = tokens[i];
    el = token.tag ? processTextToken(token, options) : document.createTextNode(token.value);
    frag.appendChild(el);
  }
  return makeTextNodeLinkFn(tokens, frag, options);
}

/**
 * Linker for an skipped text node.
 *
 * @param {Vue} vm
 * @param {Text} node
 */

function removeText(vm, node) {
  remove(node);
}

/**
 * Process a single text token.
 *
 * @param {Object} token
 * @param {Object} options
 * @return {Node}
 */

function processTextToken(token, options) {
  var el;
  if (token.oneTime) {
    el = document.createTextNode(token.value);
  } else {
    if (token.html) {
      el = document.createComment('v-html');
      setTokenType('html');
    } else {
      // IE will clean up empty textNodes during
      // frag.cloneNode(true), so we have to give it
      // something here...
      el = document.createTextNode(' ');
      setTokenType('text');
    }
  }
  function setTokenType(type) {
    if (token.descriptor) return;
    var parsed = parseDirective(token.value);
    token.descriptor = {
      name: type,
      def: directives[type],
      expression: parsed.expression,
      filters: parsed.filters
    };
  }
  return el;
}

/**
 * Build a function that processes a textNode.
 *
 * @param {Array<Object>} tokens
 * @param {DocumentFragment} frag
 */

function makeTextNodeLinkFn(tokens, frag) {
  return function textNodeLinkFn(vm, el, host, scope) {
    var fragClone = frag.cloneNode(true);
    var childNodes = toArray(fragClone.childNodes);
    var token, value, node;
    for (var i = 0, l = tokens.length; i < l; i++) {
      token = tokens[i];
      value = token.value;
      if (token.tag) {
        node = childNodes[i];
        if (token.oneTime) {
          value = (scope || vm).$eval(value);
          if (token.html) {
            replace(node, parseTemplate(value, true));
          } else {
            node.data = _toString(value);
          }
        } else {
          vm._bindDir(token.descriptor, node, host, scope);
        }
      }
    }
    replace(el, fragClone);
  };
}

/**
 * Compile a node list and return a childLinkFn.
 *
 * @param {NodeList} nodeList
 * @param {Object} options
 * @return {Function|undefined}
 */

function compileNodeList(nodeList, options) {
  var linkFns = [];
  var nodeLinkFn, childLinkFn, node;
  for (var i = 0, l = nodeList.length; i < l; i++) {
    node = nodeList[i];
    nodeLinkFn = compileNode(node, options);
    childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && node.tagName !== 'SCRIPT' && node.hasChildNodes() ? compileNodeList(node.childNodes, options) : null;
    linkFns.push(nodeLinkFn, childLinkFn);
  }
  return linkFns.length ? makeChildLinkFn(linkFns) : null;
}

/**
 * Make a child link function for a node's childNodes.
 *
 * @param {Array<Function>} linkFns
 * @return {Function} childLinkFn
 */

function makeChildLinkFn(linkFns) {
  return function childLinkFn(vm, nodes, host, scope, frag) {
    var node, nodeLinkFn, childrenLinkFn;
    for (var i = 0, n = 0, l = linkFns.length; i < l; n++) {
      node = nodes[n];
      nodeLinkFn = linkFns[i++];
      childrenLinkFn = linkFns[i++];
      // cache childNodes before linking parent, fix #657
      var childNodes = toArray(node.childNodes);
      if (nodeLinkFn) {
        nodeLinkFn(vm, node, host, scope, frag);
      }
      if (childrenLinkFn) {
        childrenLinkFn(vm, childNodes, host, scope, frag);
      }
    }
  };
}

/**
 * Check for element directives (custom elements that should
 * be resovled as terminal directives).
 *
 * @param {Element} el
 * @param {Object} options
 */

function checkElementDirectives(el, options) {
  var tag = el.tagName.toLowerCase();
  if (commonTagRE.test(tag)) {
    return;
  }
  var def = resolveAsset(options, 'elementDirectives', tag);
  if (def) {
    return makeTerminalNodeLinkFn(el, tag, '', options, def);
  }
}

/**
 * Check if an element is a component. If yes, return
 * a component link function.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Function|undefined}
 */

function checkComponent(el, options) {
  var component = checkComponentAttr(el, options);
  if (component) {
    var ref = findRef(el);
    var descriptor = {
      name: 'component',
      ref: ref,
      expression: component.id,
      def: internalDirectives.component,
      modifiers: {
        literal: !component.dynamic
      }
    };
    var componentLinkFn = function componentLinkFn(vm, el, host, scope, frag) {
      if (ref) {
        defineReactive((scope || vm).$refs, ref, null);
      }
      vm._bindDir(descriptor, el, host, scope, frag);
    };
    componentLinkFn.terminal = true;
    return componentLinkFn;
  }
}

/**
 * Check an element for terminal directives in fixed order.
 * If it finds one, return a terminal link function.
 *
 * @param {Element} el
 * @param {Array} attrs
 * @param {Object} options
 * @return {Function} terminalLinkFn
 */

function checkTerminalDirectives(el, attrs, options) {
  // skip v-pre
  if (getAttr(el, 'v-pre') !== null) {
    return skip;
  }
  // skip v-else block, but only if following v-if
  if (el.hasAttribute('v-else')) {
    var prev = el.previousElementSibling;
    if (prev && prev.hasAttribute('v-if')) {
      return skip;
    }
  }

  var attr, name, value, modifiers, matched, dirName, rawName, arg, def, termDef;
  for (var i = 0, j = attrs.length; i < j; i++) {
    attr = attrs[i];
    name = attr.name.replace(modifierRE, '');
    if (matched = name.match(dirAttrRE)) {
      def = resolveAsset(options, 'directives', matched[1]);
      if (def && def.terminal) {
        if (!termDef || (def.priority || DEFAULT_TERMINAL_PRIORITY) > termDef.priority) {
          termDef = def;
          rawName = attr.name;
          modifiers = parseModifiers(attr.name);
          value = attr.value;
          dirName = matched[1];
          arg = matched[2];
        }
      }
    }
  }

  if (termDef) {
    return makeTerminalNodeLinkFn(el, dirName, value, options, termDef, rawName, arg, modifiers);
  }
}

function skip() {}
skip.terminal = true;

/**
 * Build a node link function for a terminal directive.
 * A terminal link function terminates the current
 * compilation recursion and handles compilation of the
 * subtree in the directive.
 *
 * @param {Element} el
 * @param {String} dirName
 * @param {String} value
 * @param {Object} options
 * @param {Object} def
 * @param {String} [rawName]
 * @param {String} [arg]
 * @param {Object} [modifiers]
 * @return {Function} terminalLinkFn
 */

function makeTerminalNodeLinkFn(el, dirName, value, options, def, rawName, arg, modifiers) {
  var parsed = parseDirective(value);
  var descriptor = {
    name: dirName,
    arg: arg,
    expression: parsed.expression,
    filters: parsed.filters,
    raw: value,
    attr: rawName,
    modifiers: modifiers,
    def: def
  };
  // check ref for v-for, v-if and router-view
  if (dirName === 'for' || dirName === 'router-view') {
    descriptor.ref = findRef(el);
  }
  var fn = function terminalNodeLinkFn(vm, el, host, scope, frag) {
    if (descriptor.ref) {
      defineReactive((scope || vm).$refs, descriptor.ref, null);
    }
    vm._bindDir(descriptor, el, host, scope, frag);
  };
  fn.terminal = true;
  return fn;
}

/**
 * Compile the directives on an element and return a linker.
 *
 * @param {Array|NamedNodeMap} attrs
 * @param {Object} options
 * @return {Function}
 */

function compileDirectives(attrs, options) {
  var i = attrs.length;
  var dirs = [];
  var attr, name, value, rawName, rawValue, dirName, arg, modifiers, dirDef, tokens, matched;
  while (i--) {
    attr = attrs[i];
    name = rawName = attr.name;
    value = rawValue = attr.value;
    tokens = parseText(value);
    // reset arg
    arg = null;
    // check modifiers
    modifiers = parseModifiers(name);
    name = name.replace(modifierRE, '');

    // attribute interpolations
    if (tokens) {
      value = tokensToExp(tokens);
      arg = name;
      pushDir('bind', directives.bind, tokens);
      // warn against mixing mustaches with v-bind
      if (process.env.NODE_ENV !== 'production') {
        if (name === 'class' && Array.prototype.some.call(attrs, function (attr) {
          return attr.name === ':class' || attr.name === 'v-bind:class';
        })) {
          warn('class="' + rawValue + '": Do not mix mustache interpolation ' + 'and v-bind for "class" on the same element. Use one or the other.', options);
        }
      }
    } else

      // special attribute: transition
      if (transitionRE.test(name)) {
        modifiers.literal = !bindRE.test(name);
        pushDir('transition', internalDirectives.transition);
      } else

        // event handlers
        if (onRE.test(name)) {
          arg = name.replace(onRE, '');
          pushDir('on', directives.on);
        } else

          // attribute bindings
          if (bindRE.test(name)) {
            dirName = name.replace(bindRE, '');
            if (dirName === 'style' || dirName === 'class') {
              pushDir(dirName, internalDirectives[dirName]);
            } else {
              arg = dirName;
              pushDir('bind', directives.bind);
            }
          } else

            // normal directives
            if (matched = name.match(dirAttrRE)) {
              dirName = matched[1];
              arg = matched[2];

              // skip v-else (when used with v-show)
              if (dirName === 'else') {
                continue;
              }

              dirDef = resolveAsset(options, 'directives', dirName, true);
              if (dirDef) {
                pushDir(dirName, dirDef);
              }
            }
  }

  /**
   * Push a directive.
   *
   * @param {String} dirName
   * @param {Object|Function} def
   * @param {Array} [interpTokens]
   */

  function pushDir(dirName, def, interpTokens) {
    var hasOneTimeToken = interpTokens && hasOneTime(interpTokens);
    var parsed = !hasOneTimeToken && parseDirective(value);
    dirs.push({
      name: dirName,
      attr: rawName,
      raw: rawValue,
      def: def,
      arg: arg,
      modifiers: modifiers,
      // conversion from interpolation strings with one-time token
      // to expression is differed until directive bind time so that we
      // have access to the actual vm context for one-time bindings.
      expression: parsed && parsed.expression,
      filters: parsed && parsed.filters,
      interp: interpTokens,
      hasOneTime: hasOneTimeToken
    });
  }

  if (dirs.length) {
    return makeNodeLinkFn(dirs);
  }
}

/**
 * Parse modifiers from directive attribute name.
 *
 * @param {String} name
 * @return {Object}
 */

function parseModifiers(name) {
  var res = Object.create(null);
  var match = name.match(modifierRE);
  if (match) {
    var i = match.length;
    while (i--) {
      res[match[i].slice(1)] = true;
    }
  }
  return res;
}

/**
 * Build a link function for all directives on a single node.
 *
 * @param {Array} directives
 * @return {Function} directivesLinkFn
 */

function makeNodeLinkFn(directives) {
  return function nodeLinkFn(vm, el, host, scope, frag) {
    // reverse apply because it's sorted low to high
    var i = directives.length;
    while (i--) {
      vm._bindDir(directives[i], el, host, scope, frag);
    }
  };
}

/**
 * Check if an interpolation string contains one-time tokens.
 *
 * @param {Array} tokens
 * @return {Boolean}
 */

function hasOneTime(tokens) {
  var i = tokens.length;
  while (i--) {
    if (tokens[i].oneTime) return true;
  }
}

function isScript(el) {
  return el.tagName === 'SCRIPT' && (!el.hasAttribute('type') || el.getAttribute('type') === 'text/javascript');
}

var specialCharRE = /[^\w\-:\.]/;

/**
 * Process an element or a DocumentFragment based on a
 * instance option object. This allows us to transclude
 * a template node/fragment before the instance is created,
 * so the processed fragment can then be cloned and reused
 * in v-for.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Element|DocumentFragment}
 */

function transclude(el, options) {
  // extract container attributes to pass them down
  // to compiler, because they need to be compiled in
  // parent scope. we are mutating the options object here
  // assuming the same object will be used for compile
  // right after this.
  if (options) {
    options._containerAttrs = extractAttrs(el);
  }
  // for template tags, what we want is its content as
  // a documentFragment (for fragment instances)
  if (isTemplate(el)) {
    el = parseTemplate(el);
  }
  if (options) {
    if (options._asComponent && !options.template) {
      options.template = '<slot></slot>';
    }
    if (options.template) {
      options._content = extractContent(el);
      el = transcludeTemplate(el, options);
    }
  }
  if (isFragment(el)) {
    // anchors for fragment instance
    // passing in `persist: true` to avoid them being
    // discarded by IE during template cloning
    prepend(createAnchor('v-start', true), el);
    el.appendChild(createAnchor('v-end', true));
  }
  return el;
}

/**
 * Process the template option.
 * If the replace option is true this will swap the $el.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Element|DocumentFragment}
 */

function transcludeTemplate(el, options) {
  var template = options.template;
  var frag = parseTemplate(template, true);
  if (frag) {
    var replacer = frag.firstChild;
    if (!replacer) {
      return frag;
    }
    var tag = replacer.tagName && replacer.tagName.toLowerCase();
    if (options.replace) {
      /* istanbul ignore if */
      if (el === document.body) {
        process.env.NODE_ENV !== 'production' && warn('You are mounting an instance with a template to ' + '<body>. This will replace <body> entirely. You ' + 'should probably use `replace: false` here.');
      }
      // there are many cases where the instance must
      // become a fragment instance: basically anything that
      // can create more than 1 root nodes.
      if (
      // multi-children template
      frag.childNodes.length > 1 ||
      // non-element template
      replacer.nodeType !== 1 ||
      // single nested component
      tag === 'component' || resolveAsset(options, 'components', tag) || hasBindAttr(replacer, 'is') ||
      // element directive
      resolveAsset(options, 'elementDirectives', tag) ||
      // for block
      replacer.hasAttribute('v-for') ||
      // if block
      replacer.hasAttribute('v-if')) {
        return frag;
      } else {
        options._replacerAttrs = extractAttrs(replacer);
        mergeAttrs(el, replacer);
        return replacer;
      }
    } else {
      el.appendChild(frag);
      return el;
    }
  } else {
    process.env.NODE_ENV !== 'production' && warn('Invalid template option: ' + template);
  }
}

/**
 * Helper to extract a component container's attributes
 * into a plain object array.
 *
 * @param {Element} el
 * @return {Array}
 */

function extractAttrs(el) {
  if (el.nodeType === 1 && el.hasAttributes()) {
    return toArray(el.attributes);
  }
}

/**
 * Merge the attributes of two elements, and make sure
 * the class names are merged properly.
 *
 * @param {Element} from
 * @param {Element} to
 */

function mergeAttrs(from, to) {
  var attrs = from.attributes;
  var i = attrs.length;
  var name, value;
  while (i--) {
    name = attrs[i].name;
    value = attrs[i].value;
    if (!to.hasAttribute(name) && !specialCharRE.test(name)) {
      to.setAttribute(name, value);
    } else if (name === 'class' && !parseText(value) && (value = value.trim())) {
      value.split(/\s+/).forEach(function (cls) {
        addClass(to, cls);
      });
    }
  }
}

/**
 * Scan and determine slot content distribution.
 * We do this during transclusion instead at compile time so that
 * the distribution is decoupled from the compilation order of
 * the slots.
 *
 * @param {Element|DocumentFragment} template
 * @param {Element} content
 * @param {Vue} vm
 */

function resolveSlots(vm, content) {
  if (!content) {
    return;
  }
  var contents = vm._slotContents = Object.create(null);
  var el, name;
  for (var i = 0, l = content.children.length; i < l; i++) {
    el = content.children[i];
    /* eslint-disable no-cond-assign */
    if (name = el.getAttribute('slot')) {
      (contents[name] || (contents[name] = [])).push(el);
    }
    /* eslint-enable no-cond-assign */
    if (process.env.NODE_ENV !== 'production' && getBindAttr(el, 'slot')) {
      warn('The "slot" attribute must be static.', vm.$parent);
    }
  }
  for (name in contents) {
    contents[name] = extractFragment(contents[name], content);
  }
  if (content.hasChildNodes()) {
    var nodes = content.childNodes;
    if (nodes.length === 1 && nodes[0].nodeType === 3 && !nodes[0].data.trim()) {
      return;
    }
    contents['default'] = extractFragment(content.childNodes, content);
  }
}

/**
 * Extract qualified content nodes from a node list.
 *
 * @param {NodeList} nodes
 * @return {DocumentFragment}
 */

function extractFragment(nodes, parent) {
  var frag = document.createDocumentFragment();
  nodes = toArray(nodes);
  for (var i = 0, l = nodes.length; i < l; i++) {
    var node = nodes[i];
    if (isTemplate(node) && !node.hasAttribute('v-if') && !node.hasAttribute('v-for')) {
      parent.removeChild(node);
      node = parseTemplate(node, true);
    }
    frag.appendChild(node);
  }
  return frag;
}



var compiler = Object.freeze({
	compile: compile,
	compileAndLinkProps: compileAndLinkProps,
	compileRoot: compileRoot,
	transclude: transclude,
	resolveSlots: resolveSlots
});

function stateMixin (Vue) {
  /**
   * Accessor for `$data` property, since setting $data
   * requires observing the new object and updating
   * proxied properties.
   */

  Object.defineProperty(Vue.prototype, '$data', {
    get: function get() {
      return this._data;
    },
    set: function set(newData) {
      if (newData !== this._data) {
        this._setData(newData);
      }
    }
  });

  /**
   * Setup the scope of an instance, which contains:
   * - observed data
   * - computed properties
   * - user methods
   * - meta properties
   */

  Vue.prototype._initState = function () {
    this._initProps();
    this._initMeta();
    this._initMethods();
    this._initData();
    this._initComputed();
  };

  /**
   * Initialize props.
   */

  Vue.prototype._initProps = function () {
    var options = this.$options;
    var el = options.el;
    var props = options.props;
    if (props && !el) {
      process.env.NODE_ENV !== 'production' && warn('Props will not be compiled if no `el` option is ' + 'provided at instantiation.', this);
    }
    // make sure to convert string selectors into element now
    el = options.el = query(el);
    this._propsUnlinkFn = el && el.nodeType === 1 && props
    // props must be linked in proper scope if inside v-for
    ? compileAndLinkProps(this, el, props, this._scope) : null;
  };

  /**
   * Initialize the data.
   */

  Vue.prototype._initData = function () {
    var dataFn = this.$options.data;
    var data = this._data = dataFn ? dataFn() : {};
    if (!isPlainObject(data)) {
      data = {};
      process.env.NODE_ENV !== 'production' && warn('data functions should return an object.', this);
    }
    var props = this._props;
    // proxy data on instance
    var keys = Object.keys(data);
    var i, key;
    i = keys.length;
    while (i--) {
      key = keys[i];
      // there are two scenarios where we can proxy a data key:
      // 1. it's not already defined as a prop
      // 2. it's provided via a instantiation option AND there are no
      //    template prop present
      if (!props || !hasOwn(props, key)) {
        this._proxy(key);
      } else if (process.env.NODE_ENV !== 'production') {
        warn('Data field "' + key + '" is already defined ' + 'as a prop. To provide default value for a prop, use the "default" ' + 'prop option; if you want to pass prop values to an instantiation ' + 'call, use the "propsData" option.', this);
      }
    }
    // observe data
    observe(data, this);
  };

  /**
   * Swap the instance's $data. Called in $data's setter.
   *
   * @param {Object} newData
   */

  Vue.prototype._setData = function (newData) {
    newData = newData || {};
    var oldData = this._data;
    this._data = newData;
    var keys, key, i;
    // unproxy keys not present in new data
    keys = Object.keys(oldData);
    i = keys.length;
    while (i--) {
      key = keys[i];
      if (!(key in newData)) {
        this._unproxy(key);
      }
    }
    // proxy keys not already proxied,
    // and trigger change for changed values
    keys = Object.keys(newData);
    i = keys.length;
    while (i--) {
      key = keys[i];
      if (!hasOwn(this, key)) {
        // new property
        this._proxy(key);
      }
    }
    oldData.__ob__.removeVm(this);
    observe(newData, this);
    this._digest();
  };

  /**
   * Proxy a property, so that
   * vm.prop === vm._data.prop
   *
   * @param {String} key
   */

  Vue.prototype._proxy = function (key) {
    if (!isReserved(key)) {
      // need to store ref to self here
      // because these getter/setters might
      // be called by child scopes via
      // prototype inheritance.
      var self = this;
      Object.defineProperty(self, key, {
        configurable: true,
        enumerable: true,
        get: function proxyGetter() {
          return self._data[key];
        },
        set: function proxySetter(val) {
          self._data[key] = val;
        }
      });
    }
  };

  /**
   * Unproxy a property.
   *
   * @param {String} key
   */

  Vue.prototype._unproxy = function (key) {
    if (!isReserved(key)) {
      delete this[key];
    }
  };

  /**
   * Force update on every watcher in scope.
   */

  Vue.prototype._digest = function () {
    for (var i = 0, l = this._watchers.length; i < l; i++) {
      this._watchers[i].update(true); // shallow updates
    }
  };

  /**
   * Setup computed properties. They are essentially
   * special getter/setters
   */

  function noop() {}
  Vue.prototype._initComputed = function () {
    var computed = this.$options.computed;
    if (computed) {
      for (var key in computed) {
        var userDef = computed[key];
        var def = {
          enumerable: true,
          configurable: true
        };
        if (typeof userDef === 'function') {
          def.get = makeComputedGetter(userDef, this);
          def.set = noop;
        } else {
          def.get = userDef.get ? userDef.cache !== false ? makeComputedGetter(userDef.get, this) : bind(userDef.get, this) : noop;
          def.set = userDef.set ? bind(userDef.set, this) : noop;
        }
        Object.defineProperty(this, key, def);
      }
    }
  };

  function makeComputedGetter(getter, owner) {
    var watcher = new Watcher(owner, getter, null, {
      lazy: true
    });
    return function computedGetter() {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value;
    };
  }

  /**
   * Setup instance methods. Methods must be bound to the
   * instance since they might be passed down as a prop to
   * child components.
   */

  Vue.prototype._initMethods = function () {
    var methods = this.$options.methods;
    if (methods) {
      for (var key in methods) {
        this[key] = bind(methods[key], this);
      }
    }
  };

  /**
   * Initialize meta information like $index, $key & $value.
   */

  Vue.prototype._initMeta = function () {
    var metas = this.$options._meta;
    if (metas) {
      for (var key in metas) {
        defineReactive(this, key, metas[key]);
      }
    }
  };
}

var eventRE = /^v-on:|^@/;

function eventsMixin (Vue) {
  /**
   * Setup the instance's option events & watchers.
   * If the value is a string, we pull it from the
   * instance's methods by name.
   */

  Vue.prototype._initEvents = function () {
    var options = this.$options;
    if (options._asComponent) {
      registerComponentEvents(this, options.el);
    }
    registerCallbacks(this, '$on', options.events);
    registerCallbacks(this, '$watch', options.watch);
  };

  /**
   * Register v-on events on a child component
   *
   * @param {Vue} vm
   * @param {Element} el
   */

  function registerComponentEvents(vm, el) {
    var attrs = el.attributes;
    var name, value, handler;
    for (var i = 0, l = attrs.length; i < l; i++) {
      name = attrs[i].name;
      if (eventRE.test(name)) {
        name = name.replace(eventRE, '');
        // force the expression into a statement so that
        // it always dynamically resolves the method to call (#2670)
        // kinda ugly hack, but does the job.
        value = attrs[i].value;
        if (isSimplePath(value)) {
          value += '.apply(this, $arguments)';
        }
        handler = (vm._scope || vm._context).$eval(value, true);
        handler._fromParent = true;
        vm.$on(name.replace(eventRE), handler);
      }
    }
  }

  /**
   * Register callbacks for option events and watchers.
   *
   * @param {Vue} vm
   * @param {String} action
   * @param {Object} hash
   */

  function registerCallbacks(vm, action, hash) {
    if (!hash) return;
    var handlers, key, i, j;
    for (key in hash) {
      handlers = hash[key];
      if (isArray(handlers)) {
        for (i = 0, j = handlers.length; i < j; i++) {
          register(vm, action, key, handlers[i]);
        }
      } else {
        register(vm, action, key, handlers);
      }
    }
  }

  /**
   * Helper to register an event/watch callback.
   *
   * @param {Vue} vm
   * @param {String} action
   * @param {String} key
   * @param {Function|String|Object} handler
   * @param {Object} [options]
   */

  function register(vm, action, key, handler, options) {
    var type = typeof handler;
    if (type === 'function') {
      vm[action](key, handler, options);
    } else if (type === 'string') {
      var methods = vm.$options.methods;
      var method = methods && methods[handler];
      if (method) {
        vm[action](key, method, options);
      } else {
        process.env.NODE_ENV !== 'production' && warn('Unknown method: "' + handler + '" when ' + 'registering callback for ' + action + ': "' + key + '".', vm);
      }
    } else if (handler && type === 'object') {
      register(vm, action, key, handler.handler, handler);
    }
  }

  /**
   * Setup recursive attached/detached calls
   */

  Vue.prototype._initDOMHooks = function () {
    this.$on('hook:attached', onAttached);
    this.$on('hook:detached', onDetached);
  };

  /**
   * Callback to recursively call attached hook on children
   */

  function onAttached() {
    if (!this._isAttached) {
      this._isAttached = true;
      this.$children.forEach(callAttach);
    }
  }

  /**
   * Iterator to call attached hook
   *
   * @param {Vue} child
   */

  function callAttach(child) {
    if (!child._isAttached && inDoc(child.$el)) {
      child._callHook('attached');
    }
  }

  /**
   * Callback to recursively call detached hook on children
   */

  function onDetached() {
    if (this._isAttached) {
      this._isAttached = false;
      this.$children.forEach(callDetach);
    }
  }

  /**
   * Iterator to call detached hook
   *
   * @param {Vue} child
   */

  function callDetach(child) {
    if (child._isAttached && !inDoc(child.$el)) {
      child._callHook('detached');
    }
  }

  /**
   * Trigger all handlers for a hook
   *
   * @param {String} hook
   */

  Vue.prototype._callHook = function (hook) {
    this.$emit('pre-hook:' + hook);
    var handlers = this.$options[hook];
    if (handlers) {
      for (var i = 0, j = handlers.length; i < j; i++) {
        handlers[i].call(this);
      }
    }
    this.$emit('hook:' + hook);
  };
}

function noop$1() {}

/**
 * A directive links a DOM element with a piece of data,
 * which is the result of evaluating an expression.
 * It registers a watcher with the expression and calls
 * the DOM update function when a change is triggered.
 *
 * @param {Object} descriptor
 *                 - {String} name
 *                 - {Object} def
 *                 - {String} expression
 *                 - {Array<Object>} [filters]
 *                 - {Object} [modifiers]
 *                 - {Boolean} literal
 *                 - {String} attr
 *                 - {String} arg
 *                 - {String} raw
 *                 - {String} [ref]
 *                 - {Array<Object>} [interp]
 *                 - {Boolean} [hasOneTime]
 * @param {Vue} vm
 * @param {Node} el
 * @param {Vue} [host] - transclusion host component
 * @param {Object} [scope] - v-for scope
 * @param {Fragment} [frag] - owner fragment
 * @constructor
 */
function Directive(descriptor, vm, el, host, scope, frag) {
  this.vm = vm;
  this.el = el;
  // copy descriptor properties
  this.descriptor = descriptor;
  this.name = descriptor.name;
  this.expression = descriptor.expression;
  this.arg = descriptor.arg;
  this.modifiers = descriptor.modifiers;
  this.filters = descriptor.filters;
  this.literal = this.modifiers && this.modifiers.literal;
  // private
  this._locked = false;
  this._bound = false;
  this._listeners = null;
  // link context
  this._host = host;
  this._scope = scope;
  this._frag = frag;
  // store directives on node in dev mode
  if (process.env.NODE_ENV !== 'production' && this.el) {
    this.el._vue_directives = this.el._vue_directives || [];
    this.el._vue_directives.push(this);
  }
}

/**
 * Initialize the directive, mixin definition properties,
 * setup the watcher, call definition bind() and update()
 * if present.
 */

Directive.prototype._bind = function () {
  var name = this.name;
  var descriptor = this.descriptor;

  // remove attribute
  if ((name !== 'cloak' || this.vm._isCompiled) && this.el && this.el.removeAttribute) {
    var attr = descriptor.attr || 'v-' + name;
    this.el.removeAttribute(attr);
  }

  // copy def properties
  var def = descriptor.def;
  if (typeof def === 'function') {
    this.update = def;
  } else {
    extend(this, def);
  }

  // setup directive params
  this._setupParams();

  // initial bind
  if (this.bind) {
    this.bind();
  }
  this._bound = true;

  if (this.literal) {
    this.update && this.update(descriptor.raw);
  } else if ((this.expression || this.modifiers) && (this.update || this.twoWay) && !this._checkStatement()) {
    // wrapped updater for context
    var dir = this;
    if (this.update) {
      this._update = function (val, oldVal) {
        if (!dir._locked) {
          dir.update(val, oldVal);
        }
      };
    } else {
      this._update = noop$1;
    }
    var preProcess = this._preProcess ? bind(this._preProcess, this) : null;
    var postProcess = this._postProcess ? bind(this._postProcess, this) : null;
    var watcher = this._watcher = new Watcher(this.vm, this.expression, this._update, // callback
    {
      filters: this.filters,
      twoWay: this.twoWay,
      deep: this.deep,
      preProcess: preProcess,
      postProcess: postProcess,
      scope: this._scope
    });
    // v-model with inital inline value need to sync back to
    // model instead of update to DOM on init. They would
    // set the afterBind hook to indicate that.
    if (this.afterBind) {
      this.afterBind();
    } else if (this.update) {
      this.update(watcher.value);
    }
  }
};

/**
 * Setup all param attributes, e.g. track-by,
 * transition-mode, etc...
 */

Directive.prototype._setupParams = function () {
  if (!this.params) {
    return;
  }
  var params = this.params;
  // swap the params array with a fresh object.
  this.params = Object.create(null);
  var i = params.length;
  var key, val, mappedKey;
  while (i--) {
    key = hyphenate(params[i]);
    mappedKey = camelize(key);
    val = getBindAttr(this.el, key);
    if (val != null) {
      // dynamic
      this._setupParamWatcher(mappedKey, val);
    } else {
      // static
      val = getAttr(this.el, key);
      if (val != null) {
        this.params[mappedKey] = val === '' ? true : val;
      }
    }
  }
};

/**
 * Setup a watcher for a dynamic param.
 *
 * @param {String} key
 * @param {String} expression
 */

Directive.prototype._setupParamWatcher = function (key, expression) {
  var self = this;
  var called = false;
  var unwatch = (this._scope || this.vm).$watch(expression, function (val, oldVal) {
    self.params[key] = val;
    // since we are in immediate mode,
    // only call the param change callbacks if this is not the first update.
    if (called) {
      var cb = self.paramWatchers && self.paramWatchers[key];
      if (cb) {
        cb.call(self, val, oldVal);
      }
    } else {
      called = true;
    }
  }, {
    immediate: true,
    user: false
  });(this._paramUnwatchFns || (this._paramUnwatchFns = [])).push(unwatch);
};

/**
 * Check if the directive is a function caller
 * and if the expression is a callable one. If both true,
 * we wrap up the expression and use it as the event
 * handler.
 *
 * e.g. on-click="a++"
 *
 * @return {Boolean}
 */

Directive.prototype._checkStatement = function () {
  var expression = this.expression;
  if (expression && this.acceptStatement && !isSimplePath(expression)) {
    var fn = parseExpression$1(expression).get;
    var scope = this._scope || this.vm;
    var handler = function handler(e) {
      scope.$event = e;
      fn.call(scope, scope);
      scope.$event = null;
    };
    if (this.filters) {
      handler = scope._applyFilters(handler, null, this.filters);
    }
    this.update(handler);
    return true;
  }
};

/**
 * Set the corresponding value with the setter.
 * This should only be used in two-way directives
 * e.g. v-model.
 *
 * @param {*} value
 * @public
 */

Directive.prototype.set = function (value) {
  /* istanbul ignore else */
  if (this.twoWay) {
    this._withLock(function () {
      this._watcher.set(value);
    });
  } else if (process.env.NODE_ENV !== 'production') {
    warn('Directive.set() can only be used inside twoWay' + 'directives.');
  }
};

/**
 * Execute a function while preventing that function from
 * triggering updates on this directive instance.
 *
 * @param {Function} fn
 */

Directive.prototype._withLock = function (fn) {
  var self = this;
  self._locked = true;
  fn.call(self);
  nextTick(function () {
    self._locked = false;
  });
};

/**
 * Convenience method that attaches a DOM event listener
 * to the directive element and autometically tears it down
 * during unbind.
 *
 * @param {String} event
 * @param {Function} handler
 * @param {Boolean} [useCapture]
 */

Directive.prototype.on = function (event, handler, useCapture) {
  on(this.el, event, handler, useCapture);(this._listeners || (this._listeners = [])).push([event, handler]);
};

/**
 * Teardown the watcher and call unbind.
 */

Directive.prototype._teardown = function () {
  if (this._bound) {
    this._bound = false;
    if (this.unbind) {
      this.unbind();
    }
    if (this._watcher) {
      this._watcher.teardown();
    }
    var listeners = this._listeners;
    var i;
    if (listeners) {
      i = listeners.length;
      while (i--) {
        off(this.el, listeners[i][0], listeners[i][1]);
      }
    }
    var unwatchFns = this._paramUnwatchFns;
    if (unwatchFns) {
      i = unwatchFns.length;
      while (i--) {
        unwatchFns[i]();
      }
    }
    if (process.env.NODE_ENV !== 'production' && this.el) {
      this.el._vue_directives.$remove(this);
    }
    this.vm = this.el = this._watcher = this._listeners = null;
  }
};

function lifecycleMixin (Vue) {
  /**
   * Update v-ref for component.
   *
   * @param {Boolean} remove
   */

  Vue.prototype._updateRef = function (remove) {
    var ref = this.$options._ref;
    if (ref) {
      var refs = (this._scope || this._context).$refs;
      if (remove) {
        if (refs[ref] === this) {
          refs[ref] = null;
        }
      } else {
        refs[ref] = this;
      }
    }
  };

  /**
   * Transclude, compile and link element.
   *
   * If a pre-compiled linker is available, that means the
   * passed in element will be pre-transcluded and compiled
   * as well - all we need to do is to call the linker.
   *
   * Otherwise we need to call transclude/compile/link here.
   *
   * @param {Element} el
   */

  Vue.prototype._compile = function (el) {
    var options = this.$options;

    // transclude and init element
    // transclude can potentially replace original
    // so we need to keep reference; this step also injects
    // the template and caches the original attributes
    // on the container node and replacer node.
    var original = el;
    el = transclude(el, options);
    this._initElement(el);

    // handle v-pre on root node (#2026)
    if (el.nodeType === 1 && getAttr(el, 'v-pre') !== null) {
      return;
    }

    // root is always compiled per-instance, because
    // container attrs and props can be different every time.
    var contextOptions = this._context && this._context.$options;
    var rootLinker = compileRoot(el, options, contextOptions);

    // resolve slot distribution
    resolveSlots(this, options._content);

    // compile and link the rest
    var contentLinkFn;
    var ctor = this.constructor;
    // component compilation can be cached
    // as long as it's not using inline-template
    if (options._linkerCachable) {
      contentLinkFn = ctor.linker;
      if (!contentLinkFn) {
        contentLinkFn = ctor.linker = compile(el, options);
      }
    }

    // link phase
    // make sure to link root with prop scope!
    var rootUnlinkFn = rootLinker(this, el, this._scope);
    var contentUnlinkFn = contentLinkFn ? contentLinkFn(this, el) : compile(el, options)(this, el);

    // register composite unlink function
    // to be called during instance destruction
    this._unlinkFn = function () {
      rootUnlinkFn();
      // passing destroying: true to avoid searching and
      // splicing the directives
      contentUnlinkFn(true);
    };

    // finally replace original
    if (options.replace) {
      replace(original, el);
    }

    this._isCompiled = true;
    this._callHook('compiled');
  };

  /**
   * Initialize instance element. Called in the public
   * $mount() method.
   *
   * @param {Element} el
   */

  Vue.prototype._initElement = function (el) {
    if (isFragment(el)) {
      this._isFragment = true;
      this.$el = this._fragmentStart = el.firstChild;
      this._fragmentEnd = el.lastChild;
      // set persisted text anchors to empty
      if (this._fragmentStart.nodeType === 3) {
        this._fragmentStart.data = this._fragmentEnd.data = '';
      }
      this._fragment = el;
    } else {
      this.$el = el;
    }
    this.$el.__vue__ = this;
    this._callHook('beforeCompile');
  };

  /**
   * Create and bind a directive to an element.
   *
   * @param {Object} descriptor - parsed directive descriptor
   * @param {Node} node   - target node
   * @param {Vue} [host] - transclusion host component
   * @param {Object} [scope] - v-for scope
   * @param {Fragment} [frag] - owner fragment
   */

  Vue.prototype._bindDir = function (descriptor, node, host, scope, frag) {
    this._directives.push(new Directive(descriptor, this, node, host, scope, frag));
  };

  /**
   * Teardown an instance, unobserves the data, unbind all the
   * directives, turn off all the event listeners, etc.
   *
   * @param {Boolean} remove - whether to remove the DOM node.
   * @param {Boolean} deferCleanup - if true, defer cleanup to
   *                                 be called later
   */

  Vue.prototype._destroy = function (remove, deferCleanup) {
    if (this._isBeingDestroyed) {
      if (!deferCleanup) {
        this._cleanup();
      }
      return;
    }

    var destroyReady;
    var pendingRemoval;

    var self = this;
    // Cleanup should be called either synchronously or asynchronoysly as
    // callback of this.$remove(), or if remove and deferCleanup are false.
    // In any case it should be called after all other removing, unbinding and
    // turning of is done
    var cleanupIfPossible = function cleanupIfPossible() {
      if (destroyReady && !pendingRemoval && !deferCleanup) {
        self._cleanup();
      }
    };

    // remove DOM element
    if (remove && this.$el) {
      pendingRemoval = true;
      this.$remove(function () {
        pendingRemoval = false;
        cleanupIfPossible();
      });
    }

    this._callHook('beforeDestroy');
    this._isBeingDestroyed = true;
    var i;
    // remove self from parent. only necessary
    // if parent is not being destroyed as well.
    var parent = this.$parent;
    if (parent && !parent._isBeingDestroyed) {
      parent.$children.$remove(this);
      // unregister ref (remove: true)
      this._updateRef(true);
    }
    // destroy all children.
    i = this.$children.length;
    while (i--) {
      this.$children[i].$destroy();
    }
    // teardown props
    if (this._propsUnlinkFn) {
      this._propsUnlinkFn();
    }
    // teardown all directives. this also tearsdown all
    // directive-owned watchers.
    if (this._unlinkFn) {
      this._unlinkFn();
    }
    i = this._watchers.length;
    while (i--) {
      this._watchers[i].teardown();
    }
    // remove reference to self on $el
    if (this.$el) {
      this.$el.__vue__ = null;
    }

    destroyReady = true;
    cleanupIfPossible();
  };

  /**
   * Clean up to ensure garbage collection.
   * This is called after the leave transition if there
   * is any.
   */

  Vue.prototype._cleanup = function () {
    if (this._isDestroyed) {
      return;
    }
    // remove self from owner fragment
    // do it in cleanup so that we can call $destroy with
    // defer right when a fragment is about to be removed.
    if (this._frag) {
      this._frag.children.$remove(this);
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (this._data && this._data.__ob__) {
      this._data.__ob__.removeVm(this);
    }
    // Clean up references to private properties and other
    // instances. preserve reference to _data so that proxy
    // accessors still work. The only potential side effect
    // here is that mutating the instance after it's destroyed
    // may affect the state of other components that are still
    // observing the same object, but that seems to be a
    // reasonable responsibility for the user rather than
    // always throwing an error on them.
    this.$el = this.$parent = this.$root = this.$children = this._watchers = this._context = this._scope = this._directives = null;
    // call the last hook...
    this._isDestroyed = true;
    this._callHook('destroyed');
    // turn off all instance listeners.
    this.$off();
  };
}

function miscMixin (Vue) {
  /**
   * Apply a list of filter (descriptors) to a value.
   * Using plain for loops here because this will be called in
   * the getter of any watcher with filters so it is very
   * performance sensitive.
   *
   * @param {*} value
   * @param {*} [oldValue]
   * @param {Array} filters
   * @param {Boolean} write
   * @return {*}
   */

  Vue.prototype._applyFilters = function (value, oldValue, filters, write) {
    var filter, fn, args, arg, offset, i, l, j, k;
    for (i = 0, l = filters.length; i < l; i++) {
      filter = filters[write ? l - i - 1 : i];
      fn = resolveAsset(this.$options, 'filters', filter.name, true);
      if (!fn) continue;
      fn = write ? fn.write : fn.read || fn;
      if (typeof fn !== 'function') continue;
      args = write ? [value, oldValue] : [value];
      offset = write ? 2 : 1;
      if (filter.args) {
        for (j = 0, k = filter.args.length; j < k; j++) {
          arg = filter.args[j];
          args[j + offset] = arg.dynamic ? this.$get(arg.value) : arg.value;
        }
      }
      value = fn.apply(this, args);
    }
    return value;
  };

  /**
   * Resolve a component, depending on whether the component
   * is defined normally or using an async factory function.
   * Resolves synchronously if already resolved, otherwise
   * resolves asynchronously and caches the resolved
   * constructor on the factory.
   *
   * @param {String|Function} value
   * @param {Function} cb
   */

  Vue.prototype._resolveComponent = function (value, cb) {
    var factory;
    if (typeof value === 'function') {
      factory = value;
    } else {
      factory = resolveAsset(this.$options, 'components', value, true);
    }
    /* istanbul ignore if */
    if (!factory) {
      return;
    }
    // async component factory
    if (!factory.options) {
      if (factory.resolved) {
        // cached
        cb(factory.resolved);
      } else if (factory.requested) {
        // pool callbacks
        factory.pendingCallbacks.push(cb);
      } else {
        factory.requested = true;
        var cbs = factory.pendingCallbacks = [cb];
        factory.call(this, function resolve(res) {
          if (isPlainObject(res)) {
            res = Vue.extend(res);
          }
          // cache resolved
          factory.resolved = res;
          // invoke callbacks
          for (var i = 0, l = cbs.length; i < l; i++) {
            cbs[i](res);
          }
        }, function reject(reason) {
          process.env.NODE_ENV !== 'production' && warn('Failed to resolve async component' + (typeof value === 'string' ? ': ' + value : '') + '. ' + (reason ? '\nReason: ' + reason : ''));
        });
      }
    } else {
      // normal component
      cb(factory);
    }
  };
}

var filterRE$1 = /[^|]\|[^|]/;

function dataAPI (Vue) {
  /**
   * Get the value from an expression on this vm.
   *
   * @param {String} exp
   * @param {Boolean} [asStatement]
   * @return {*}
   */

  Vue.prototype.$get = function (exp, asStatement) {
    var res = parseExpression$1(exp);
    if (res) {
      if (asStatement) {
        var self = this;
        return function statementHandler() {
          self.$arguments = toArray(arguments);
          var result = res.get.call(self, self);
          self.$arguments = null;
          return result;
        };
      } else {
        try {
          return res.get.call(this, this);
        } catch (e) {}
      }
    }
  };

  /**
   * Set the value from an expression on this vm.
   * The expression must be a valid left-hand
   * expression in an assignment.
   *
   * @param {String} exp
   * @param {*} val
   */

  Vue.prototype.$set = function (exp, val) {
    var res = parseExpression$1(exp, true);
    if (res && res.set) {
      res.set.call(this, this, val);
    }
  };

  /**
   * Delete a property on the VM
   *
   * @param {String} key
   */

  Vue.prototype.$delete = function (key) {
    del(this._data, key);
  };

  /**
   * Watch an expression, trigger callback when its
   * value changes.
   *
   * @param {String|Function} expOrFn
   * @param {Function} cb
   * @param {Object} [options]
   *                 - {Boolean} deep
   *                 - {Boolean} immediate
   * @return {Function} - unwatchFn
   */

  Vue.prototype.$watch = function (expOrFn, cb, options) {
    var vm = this;
    var parsed;
    if (typeof expOrFn === 'string') {
      parsed = parseDirective(expOrFn);
      expOrFn = parsed.expression;
    }
    var watcher = new Watcher(vm, expOrFn, cb, {
      deep: options && options.deep,
      sync: options && options.sync,
      filters: parsed && parsed.filters,
      user: !options || options.user !== false
    });
    if (options && options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn() {
      watcher.teardown();
    };
  };

  /**
   * Evaluate a text directive, including filters.
   *
   * @param {String} text
   * @param {Boolean} [asStatement]
   * @return {String}
   */

  Vue.prototype.$eval = function (text, asStatement) {
    // check for filters.
    if (filterRE$1.test(text)) {
      var dir = parseDirective(text);
      // the filter regex check might give false positive
      // for pipes inside strings, so it's possible that
      // we don't get any filters here
      var val = this.$get(dir.expression, asStatement);
      return dir.filters ? this._applyFilters(val, null, dir.filters) : val;
    } else {
      // no filter
      return this.$get(text, asStatement);
    }
  };

  /**
   * Interpolate a piece of template text.
   *
   * @param {String} text
   * @return {String}
   */

  Vue.prototype.$interpolate = function (text) {
    var tokens = parseText(text);
    var vm = this;
    if (tokens) {
      if (tokens.length === 1) {
        return vm.$eval(tokens[0].value) + '';
      } else {
        return tokens.map(function (token) {
          return token.tag ? vm.$eval(token.value) : token.value;
        }).join('');
      }
    } else {
      return text;
    }
  };

  /**
   * Log instance data as a plain JS object
   * so that it is easier to inspect in console.
   * This method assumes console is available.
   *
   * @param {String} [path]
   */

  Vue.prototype.$log = function (path) {
    var data = path ? getPath(this._data, path) : this._data;
    if (data) {
      data = clean(data);
    }
    // include computed fields
    if (!path) {
      var key;
      for (key in this.$options.computed) {
        data[key] = clean(this[key]);
      }
      if (this._props) {
        for (key in this._props) {
          data[key] = clean(this[key]);
        }
      }
    }
    console.log(data);
  };

  /**
   * "clean" a getter/setter converted object into a plain
   * object copy.
   *
   * @param {Object} - obj
   * @return {Object}
   */

  function clean(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
}

function domAPI (Vue) {
  /**
   * Convenience on-instance nextTick. The callback is
   * auto-bound to the instance, and this avoids component
   * modules having to rely on the global Vue.
   *
   * @param {Function} fn
   */

  Vue.prototype.$nextTick = function (fn) {
    nextTick(fn, this);
  };

  /**
   * Append instance to target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$appendTo = function (target, cb, withTransition) {
    return insert(this, target, cb, withTransition, append, appendWithTransition);
  };

  /**
   * Prepend instance to target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$prependTo = function (target, cb, withTransition) {
    target = query(target);
    if (target.hasChildNodes()) {
      this.$before(target.firstChild, cb, withTransition);
    } else {
      this.$appendTo(target, cb, withTransition);
    }
    return this;
  };

  /**
   * Insert instance before target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$before = function (target, cb, withTransition) {
    return insert(this, target, cb, withTransition, beforeWithCb, beforeWithTransition);
  };

  /**
   * Insert instance after target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$after = function (target, cb, withTransition) {
    target = query(target);
    if (target.nextSibling) {
      this.$before(target.nextSibling, cb, withTransition);
    } else {
      this.$appendTo(target.parentNode, cb, withTransition);
    }
    return this;
  };

  /**
   * Remove instance from DOM
   *
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$remove = function (cb, withTransition) {
    if (!this.$el.parentNode) {
      return cb && cb();
    }
    var inDocument = this._isAttached && inDoc(this.$el);
    // if we are not in document, no need to check
    // for transitions
    if (!inDocument) withTransition = false;
    var self = this;
    var realCb = function realCb() {
      if (inDocument) self._callHook('detached');
      if (cb) cb();
    };
    if (this._isFragment) {
      removeNodeRange(this._fragmentStart, this._fragmentEnd, this, this._fragment, realCb);
    } else {
      var op = withTransition === false ? removeWithCb : removeWithTransition;
      op(this.$el, this, realCb);
    }
    return this;
  };

  /**
   * Shared DOM insertion function.
   *
   * @param {Vue} vm
   * @param {Element} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition]
   * @param {Function} op1 - op for non-transition insert
   * @param {Function} op2 - op for transition insert
   * @return vm
   */

  function insert(vm, target, cb, withTransition, op1, op2) {
    target = query(target);
    var targetIsDetached = !inDoc(target);
    var op = withTransition === false || targetIsDetached ? op1 : op2;
    var shouldCallHook = !targetIsDetached && !vm._isAttached && !inDoc(vm.$el);
    if (vm._isFragment) {
      mapNodeRange(vm._fragmentStart, vm._fragmentEnd, function (node) {
        op(node, target, vm);
      });
      cb && cb();
    } else {
      op(vm.$el, target, vm, cb);
    }
    if (shouldCallHook) {
      vm._callHook('attached');
    }
    return vm;
  }

  /**
   * Check for selectors
   *
   * @param {String|Element} el
   */

  function query(el) {
    return typeof el === 'string' ? document.querySelector(el) : el;
  }

  /**
   * Append operation that takes a callback.
   *
   * @param {Node} el
   * @param {Node} target
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function append(el, target, vm, cb) {
    target.appendChild(el);
    if (cb) cb();
  }

  /**
   * InsertBefore operation that takes a callback.
   *
   * @param {Node} el
   * @param {Node} target
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function beforeWithCb(el, target, vm, cb) {
    before(el, target);
    if (cb) cb();
  }

  /**
   * Remove operation that takes a callback.
   *
   * @param {Node} el
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function removeWithCb(el, vm, cb) {
    remove(el);
    if (cb) cb();
  }
}

function eventsAPI (Vue) {
  /**
   * Listen on the given `event` with `fn`.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$on = function (event, fn) {
    (this._events[event] || (this._events[event] = [])).push(fn);
    modifyListenerCount(this, event, 1);
    return this;
  };

  /**
   * Adds an `event` listener that will be invoked a single
   * time then automatically removed.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$once = function (event, fn) {
    var self = this;
    function on() {
      self.$off(event, on);
      fn.apply(this, arguments);
    }
    on.fn = fn;
    this.$on(event, on);
    return this;
  };

  /**
   * Remove the given callback for `event` or all
   * registered callbacks.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$off = function (event, fn) {
    var cbs;
    // all
    if (!arguments.length) {
      if (this.$parent) {
        for (event in this._events) {
          cbs = this._events[event];
          if (cbs) {
            modifyListenerCount(this, event, -cbs.length);
          }
        }
      }
      this._events = {};
      return this;
    }
    // specific event
    cbs = this._events[event];
    if (!cbs) {
      return this;
    }
    if (arguments.length === 1) {
      modifyListenerCount(this, event, -cbs.length);
      this._events[event] = null;
      return this;
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        modifyListenerCount(this, event, -1);
        cbs.splice(i, 1);
        break;
      }
    }
    return this;
  };

  /**
   * Trigger an event on self.
   *
   * @param {String|Object} event
   * @return {Boolean} shouldPropagate
   */

  Vue.prototype.$emit = function (event) {
    var isSource = typeof event === 'string';
    event = isSource ? event : event.name;
    var cbs = this._events[event];
    var shouldPropagate = isSource || !cbs;
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      // this is a somewhat hacky solution to the question raised
      // in #2102: for an inline component listener like <comp @test="doThis">,
      // the propagation handling is somewhat broken. Therefore we
      // need to treat these inline callbacks differently.
      var hasParentCbs = isSource && cbs.some(function (cb) {
        return cb._fromParent;
      });
      if (hasParentCbs) {
        shouldPropagate = false;
      }
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        var cb = cbs[i];
        var res = cb.apply(this, args);
        if (res === true && (!hasParentCbs || cb._fromParent)) {
          shouldPropagate = true;
        }
      }
    }
    return shouldPropagate;
  };

  /**
   * Recursively broadcast an event to all children instances.
   *
   * @param {String|Object} event
   * @param {...*} additional arguments
   */

  Vue.prototype.$broadcast = function (event) {
    var isSource = typeof event === 'string';
    event = isSource ? event : event.name;
    // if no child has registered for this event,
    // then there's no need to broadcast.
    if (!this._eventsCount[event]) return;
    var children = this.$children;
    var args = toArray(arguments);
    if (isSource) {
      // use object event to indicate non-source emit
      // on children
      args[0] = { name: event, source: this };
    }
    for (var i = 0, l = children.length; i < l; i++) {
      var child = children[i];
      var shouldPropagate = child.$emit.apply(child, args);
      if (shouldPropagate) {
        child.$broadcast.apply(child, args);
      }
    }
    return this;
  };

  /**
   * Recursively propagate an event up the parent chain.
   *
   * @param {String} event
   * @param {...*} additional arguments
   */

  Vue.prototype.$dispatch = function (event) {
    var shouldPropagate = this.$emit.apply(this, arguments);
    if (!shouldPropagate) return;
    var parent = this.$parent;
    var args = toArray(arguments);
    // use object event to indicate non-source emit
    // on parents
    args[0] = { name: event, source: this };
    while (parent) {
      shouldPropagate = parent.$emit.apply(parent, args);
      parent = shouldPropagate ? parent.$parent : null;
    }
    return this;
  };

  /**
   * Modify the listener counts on all parents.
   * This bookkeeping allows $broadcast to return early when
   * no child has listened to a certain event.
   *
   * @param {Vue} vm
   * @param {String} event
   * @param {Number} count
   */

  var hookRE = /^hook:/;
  function modifyListenerCount(vm, event, count) {
    var parent = vm.$parent;
    // hooks do not get broadcasted so no need
    // to do bookkeeping for them
    if (!parent || !count || hookRE.test(event)) return;
    while (parent) {
      parent._eventsCount[event] = (parent._eventsCount[event] || 0) + count;
      parent = parent.$parent;
    }
  }
}

function lifecycleAPI (Vue) {
  /**
   * Set instance target element and kick off the compilation
   * process. The passed in `el` can be a selector string, an
   * existing Element, or a DocumentFragment (for block
   * instances).
   *
   * @param {Element|DocumentFragment|string} el
   * @public
   */

  Vue.prototype.$mount = function (el) {
    if (this._isCompiled) {
      process.env.NODE_ENV !== 'production' && warn('$mount() should be called only once.', this);
      return;
    }
    el = query(el);
    if (!el) {
      el = document.createElement('div');
    }
    this._compile(el);
    this._initDOMHooks();
    if (inDoc(this.$el)) {
      this._callHook('attached');
      ready.call(this);
    } else {
      this.$once('hook:attached', ready);
    }
    return this;
  };

  /**
   * Mark an instance as ready.
   */

  function ready() {
    this._isAttached = true;
    this._isReady = true;
    this._callHook('ready');
  }

  /**
   * Teardown the instance, simply delegate to the internal
   * _destroy.
   *
   * @param {Boolean} remove
   * @param {Boolean} deferCleanup
   */

  Vue.prototype.$destroy = function (remove, deferCleanup) {
    this._destroy(remove, deferCleanup);
  };

  /**
   * Partially compile a piece of DOM and return a
   * decompile function.
   *
   * @param {Element|DocumentFragment} el
   * @param {Vue} [host]
   * @param {Object} [scope]
   * @param {Fragment} [frag]
   * @return {Function}
   */

  Vue.prototype.$compile = function (el, host, scope, frag) {
    return compile(el, this.$options, true)(this, el, host, scope, frag);
  };
}

/**
 * The exposed Vue constructor.
 *
 * API conventions:
 * - public API methods/properties are prefixed with `$`
 * - internal methods/properties are prefixed with `_`
 * - non-prefixed properties are assumed to be proxied user
 *   data.
 *
 * @constructor
 * @param {Object} [options]
 * @public
 */

function Vue(options) {
  this._init(options);
}

// install internals
initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
miscMixin(Vue);

// install instance APIs
dataAPI(Vue);
domAPI(Vue);
eventsAPI(Vue);
lifecycleAPI(Vue);

var slot = {

  priority: SLOT,
  params: ['name'],

  bind: function bind() {
    // this was resolved during component transclusion
    var name = this.params.name || 'default';
    var content = this.vm._slotContents && this.vm._slotContents[name];
    if (!content || !content.hasChildNodes()) {
      this.fallback();
    } else {
      this.compile(content.cloneNode(true), this.vm._context, this.vm);
    }
  },

  compile: function compile(content, context, host) {
    if (content && context) {
      if (this.el.hasChildNodes() && content.childNodes.length === 1 && content.childNodes[0].nodeType === 1 && content.childNodes[0].hasAttribute('v-if')) {
        // if the inserted slot has v-if
        // inject fallback content as the v-else
        var elseBlock = document.createElement('template');
        elseBlock.setAttribute('v-else', '');
        elseBlock.innerHTML = this.el.innerHTML;
        // the else block should be compiled in child scope
        elseBlock._context = this.vm;
        content.appendChild(elseBlock);
      }
      var scope = host ? host._scope : this._scope;
      this.unlink = context.$compile(content, host, scope, this._frag);
    }
    if (content) {
      replace(this.el, content);
    } else {
      remove(this.el);
    }
  },

  fallback: function fallback() {
    this.compile(extractContent(this.el, true), this.vm);
  },

  unbind: function unbind() {
    if (this.unlink) {
      this.unlink();
    }
  }
};

var partial = {

  priority: PARTIAL,

  params: ['name'],

  // watch changes to name for dynamic partials
  paramWatchers: {
    name: function name(value) {
      vIf.remove.call(this);
      if (value) {
        this.insert(value);
      }
    }
  },

  bind: function bind() {
    this.anchor = createAnchor('v-partial');
    replace(this.el, this.anchor);
    this.insert(this.params.name);
  },

  insert: function insert(id) {
    var partial = resolveAsset(this.vm.$options, 'partials', id, true);
    if (partial) {
      this.factory = new FragmentFactory(this.vm, partial);
      vIf.insert.call(this);
    }
  },

  unbind: function unbind() {
    if (this.frag) {
      this.frag.destroy();
    }
  }
};

var elementDirectives = {
  slot: slot,
  partial: partial
};

var convertArray = vFor._postProcess;

/**
 * Limit filter for arrays
 *
 * @param {Number} n
 * @param {Number} offset (Decimal expected)
 */

function limitBy(arr, n, offset) {
  offset = offset ? parseInt(offset, 10) : 0;
  n = toNumber(n);
  return typeof n === 'number' ? arr.slice(offset, offset + n) : arr;
}

/**
 * Filter filter for arrays
 *
 * @param {String} search
 * @param {String} [delimiter]
 * @param {String} ...dataKeys
 */

function filterBy(arr, search, delimiter) {
  arr = convertArray(arr);
  if (search == null) {
    return arr;
  }
  if (typeof search === 'function') {
    return arr.filter(search);
  }
  // cast to lowercase string
  search = ('' + search).toLowerCase();
  // allow optional `in` delimiter
  // because why not
  var n = delimiter === 'in' ? 3 : 2;
  // extract and flatten keys
  var keys = Array.prototype.concat.apply([], toArray(arguments, n));
  var res = [];
  var item, key, val, j;
  for (var i = 0, l = arr.length; i < l; i++) {
    item = arr[i];
    val = item && item.$value || item;
    j = keys.length;
    if (j) {
      while (j--) {
        key = keys[j];
        if (key === '$key' && contains(item.$key, search) || contains(getPath(val, key), search)) {
          res.push(item);
          break;
        }
      }
    } else if (contains(item, search)) {
      res.push(item);
    }
  }
  return res;
}

/**
 * Order filter for arrays
 *
 * @param {String|Array<String>|Function} ...sortKeys
 * @param {Number} [order]
 */

function orderBy(arr) {
  var comparator = null;
  var sortKeys = undefined;
  arr = convertArray(arr);

  // determine order (last argument)
  var args = toArray(arguments, 1);
  var order = args[args.length - 1];
  if (typeof order === 'number') {
    order = order < 0 ? -1 : 1;
    args = args.length > 1 ? args.slice(0, -1) : args;
  } else {
    order = 1;
  }

  // determine sortKeys & comparator
  var firstArg = args[0];
  if (!firstArg) {
    return arr;
  } else if (typeof firstArg === 'function') {
    // custom comparator
    comparator = function (a, b) {
      return firstArg(a, b) * order;
    };
  } else {
    // string keys. flatten first
    sortKeys = Array.prototype.concat.apply([], args);
    comparator = function (a, b, i) {
      i = i || 0;
      return i >= sortKeys.length - 1 ? baseCompare(a, b, i) : baseCompare(a, b, i) || comparator(a, b, i + 1);
    };
  }

  function baseCompare(a, b, sortKeyIndex) {
    var sortKey = sortKeys[sortKeyIndex];
    if (sortKey) {
      if (sortKey !== '$key') {
        if (isObject(a) && '$value' in a) a = a.$value;
        if (isObject(b) && '$value' in b) b = b.$value;
      }
      a = isObject(a) ? getPath(a, sortKey) : a;
      b = isObject(b) ? getPath(b, sortKey) : b;
    }
    return a === b ? 0 : a > b ? order : -order;
  }

  // sort on a copy to avoid mutating original array
  return arr.slice().sort(comparator);
}

/**
 * String contain helper
 *
 * @param {*} val
 * @param {String} search
 */

function contains(val, search) {
  var i;
  if (isPlainObject(val)) {
    var keys = Object.keys(val);
    i = keys.length;
    while (i--) {
      if (contains(val[keys[i]], search)) {
        return true;
      }
    }
  } else if (isArray(val)) {
    i = val.length;
    while (i--) {
      if (contains(val[i], search)) {
        return true;
      }
    }
  } else if (val != null) {
    return val.toString().toLowerCase().indexOf(search) > -1;
  }
}

var digitsRE = /(\d{3})(?=\d)/g;

// asset collections must be a plain object.
var filters = {

  orderBy: orderBy,
  filterBy: filterBy,
  limitBy: limitBy,

  /**
   * Stringify value.
   *
   * @param {Number} indent
   */

  json: {
    read: function read(value, indent) {
      return typeof value === 'string' ? value : JSON.stringify(value, null, arguments.length > 1 ? indent : 2);
    },
    write: function write(value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
  },

  /**
   * 'abc' => 'Abc'
   */

  capitalize: function capitalize(value) {
    if (!value && value !== 0) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },

  /**
   * 'abc' => 'ABC'
   */

  uppercase: function uppercase(value) {
    return value || value === 0 ? value.toString().toUpperCase() : '';
  },

  /**
   * 'AbC' => 'abc'
   */

  lowercase: function lowercase(value) {
    return value || value === 0 ? value.toString().toLowerCase() : '';
  },

  /**
   * 12345 => $12,345.00
   *
   * @param {String} sign
   * @param {Number} decimals Decimal places
   */

  currency: function currency(value, _currency, decimals) {
    value = parseFloat(value);
    if (!isFinite(value) || !value && value !== 0) return '';
    _currency = _currency != null ? _currency : '$';
    decimals = decimals != null ? decimals : 2;
    var stringified = Math.abs(value).toFixed(decimals);
    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    var i = _int.length % 3;
    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
    var _float = decimals ? stringified.slice(-1 - decimals) : '';
    var sign = value < 0 ? '-' : '';
    return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
  },

  /**
   * 'item' => 'items'
   *
   * @params
   *  an array of strings corresponding to
   *  the single, double, triple ... forms of the word to
   *  be pluralized. When the number to be pluralized
   *  exceeds the length of the args, it will use the last
   *  entry in the array.
   *
   *  e.g. ['single', 'double', 'triple', 'multiple']
   */

  pluralize: function pluralize(value) {
    var args = toArray(arguments, 1);
    var length = args.length;
    if (length > 1) {
      var index = value % 10 - 1;
      return index in args ? args[index] : args[length - 1];
    } else {
      return args[0] + (value === 1 ? '' : 's');
    }
  },

  /**
   * Debounce a handler function.
   *
   * @param {Function} handler
   * @param {Number} delay = 300
   * @return {Function}
   */

  debounce: function debounce(handler, delay) {
    if (!handler) return;
    if (!delay) {
      delay = 300;
    }
    return _debounce(handler, delay);
  }
};

function installGlobalAPI (Vue) {
  /**
   * Vue and every constructor that extends Vue has an
   * associated options object, which can be accessed during
   * compilation steps as `this.constructor.options`.
   *
   * These can be seen as the default options of every
   * Vue instance.
   */

  Vue.options = {
    directives: directives,
    elementDirectives: elementDirectives,
    filters: filters,
    transitions: {},
    components: {},
    partials: {},
    replace: true
  };

  /**
   * Expose useful internals
   */

  Vue.util = util;
  Vue.config = config;
  Vue.set = set;
  Vue['delete'] = del;
  Vue.nextTick = nextTick;

  /**
   * The following are exposed for advanced usage / plugins
   */

  Vue.compiler = compiler;
  Vue.FragmentFactory = FragmentFactory;
  Vue.internalDirectives = internalDirectives;
  Vue.parsers = {
    path: path,
    text: text,
    template: template,
    directive: directive,
    expression: expression
  };

  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */

  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   *
   * @param {Object} extendOptions
   */

  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var isFirstExtend = Super.cid === 0;
    if (isFirstExtend && extendOptions._Ctor) {
      return extendOptions._Ctor;
    }
    var name = extendOptions.name || Super.options.name;
    if (process.env.NODE_ENV !== 'production') {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn('Invalid component name: "' + name + '". Component names ' + 'can only contain alphanumeric characaters and the hyphen.');
        name = null;
      }
    }
    var Sub = createClass(name || 'VueComponent');
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(Super.options, extendOptions);
    Sub['super'] = Super;
    // allow further extension
    Sub.extend = Super.extend;
    // create asset registers, so extended classes
    // can have their private assets too.
    config._assetTypes.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }
    // cache constructor
    if (isFirstExtend) {
      extendOptions._Ctor = Sub;
    }
    return Sub;
  };

  /**
   * A function that returns a sub-class constructor with the
   * given name. This gives us much nicer output when
   * logging instances in the console.
   *
   * @param {String} name
   * @return {Function}
   */

  function createClass(name) {
    /* eslint-disable no-new-func */
    return new Function('return function ' + classify(name) + ' (options) { this._init(options) }')();
    /* eslint-enable no-new-func */
  }

  /**
   * Plugin system
   *
   * @param {Object} plugin
   */

  Vue.use = function (plugin) {
    /* istanbul ignore if */
    if (plugin.installed) {
      return;
    }
    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else {
      plugin.apply(null, args);
    }
    plugin.installed = true;
    return this;
  };

  /**
   * Apply a global mixin by merging it into the default
   * options.
   */

  Vue.mixin = function (mixin) {
    Vue.options = mergeOptions(Vue.options, mixin);
  };

  /**
   * Create asset registration methods with the following
   * signature:
   *
   * @param {String} id
   * @param {*} definition
   */

  config._assetTypes.forEach(function (type) {
    Vue[type] = function (id, definition) {
      if (!definition) {
        return this.options[type + 's'][id];
      } else {
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production') {
          if (type === 'component' && (commonTagRE.test(id) || reservedTagRE.test(id))) {
            warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + id);
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          if (!definition.name) {
            definition.name = id;
          }
          definition = Vue.extend(definition);
        }
        this.options[type + 's'][id] = definition;
        return definition;
      }
    };
  });

  // expose internal transition API
  extend(Vue.transition, transition);
}

installGlobalAPI(Vue);

Vue.version = '1.0.28';

// devtools global hook
/* istanbul ignore next */
setTimeout(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue);
    } else if (process.env.NODE_ENV !== 'production' && inBrowser && /Chrome\/\d+/.test(window.navigator.userAgent)) {
      console.log('Download the Vue Devtools for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
    }
  }
}, 0);

module.exports = Vue;
}).call(this,require('_process'))
},{"_process":649}],699:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */

'use strict';

// Shimming starts here.
(function() {
  // Utils.
  var logging = require('./utils').log;
  var browserDetails = require('./utils').browserDetails;
  // Export to the adapter global object visible in the browser.
  module.exports.browserDetails = browserDetails;
  module.exports.extractVersion = require('./utils').extractVersion;
  module.exports.disableLog = require('./utils').disableLog;

  // Uncomment the line below if you want logging to occur, including logging
  // for the switch statement below. Can also be turned on in the browser via
  // adapter.disableLog(false), but then logging from the switch statement below
  // will not appear.
  // require('./utils').disableLog(false);

  // Browser shims.
  var chromeShim = require('./chrome/chrome_shim') || null;
  var edgeShim = require('./edge/edge_shim') || null;
  var firefoxShim = require('./firefox/firefox_shim') || null;
  var safariShim = require('./safari/safari_shim') || null;

  // Shim browser if found.
  switch (browserDetails.browser) {
    case 'opera': // fallthrough as it uses chrome shims
    case 'chrome':
      if (!chromeShim || !chromeShim.shimPeerConnection) {
        logging('Chrome shim is not included in this adapter release.');
        return;
      }
      logging('adapter.js shimming chrome.');
      // Export to the adapter global object visible in the browser.
      module.exports.browserShim = chromeShim;

      chromeShim.shimGetUserMedia();
      chromeShim.shimMediaStream();
      chromeShim.shimSourceObject();
      chromeShim.shimPeerConnection();
      chromeShim.shimOnTrack();
      break;
    case 'firefox':
      if (!firefoxShim || !firefoxShim.shimPeerConnection) {
        logging('Firefox shim is not included in this adapter release.');
        return;
      }
      logging('adapter.js shimming firefox.');
      // Export to the adapter global object visible in the browser.
      module.exports.browserShim = firefoxShim;

      firefoxShim.shimGetUserMedia();
      firefoxShim.shimSourceObject();
      firefoxShim.shimPeerConnection();
      firefoxShim.shimOnTrack();
      break;
    case 'edge':
      if (!edgeShim || !edgeShim.shimPeerConnection) {
        logging('MS edge shim is not included in this adapter release.');
        return;
      }
      logging('adapter.js shimming edge.');
      // Export to the adapter global object visible in the browser.
      module.exports.browserShim = edgeShim;

      edgeShim.shimGetUserMedia();
      edgeShim.shimPeerConnection();
      break;
    case 'safari':
      if (!safariShim) {
        logging('Safari shim is not included in this adapter release.');
        return;
      }
      logging('adapter.js shimming safari.');
      // Export to the adapter global object visible in the browser.
      module.exports.browserShim = safariShim;

      safariShim.shimGetUserMedia();
      break;
    default:
      logging('Unsupported browser!');
  }
})();

},{"./chrome/chrome_shim":700,"./edge/edge_shim":702,"./firefox/firefox_shim":704,"./safari/safari_shim":706,"./utils":707}],700:[function(require,module,exports){

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */
'use strict';
var logging = require('../utils.js').log;
var browserDetails = require('../utils.js').browserDetails;

var chromeShim = {
  shimMediaStream: function() {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
  },

  shimOnTrack: function() {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          var self = this;
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
            this.removeEventListener('addstream', this._ontrackpoly);
          }
          this.addEventListener('track', this._ontrack = f);
          this.addEventListener('addstream', this._ontrackpoly = function(e) {
            // onaddstream does not fire when a track is added to an existing
            // stream. But stream.onaddtrack is implemented so we use that.
            e.stream.addEventListener('addtrack', function(te) {
              var event = new Event('track');
              event.track = te.track;
              event.receiver = {track: te.track};
              event.streams = [e.stream];
              self.dispatchEvent(event);
            });
            e.stream.getTracks().forEach(function(track) {
              var event = new Event('track');
              event.track = track;
              event.receiver = {track: track};
              event.streams = [e.stream];
              this.dispatchEvent(event);
            }.bind(this));
          }.bind(this));
        }
      });
    }
  },

  shimSourceObject: function() {
    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        // Shim the srcObject property, once, when HTMLMediaElement is found.
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this._srcObject;
          },
          set: function(stream) {
            var self = this;
            // Use _srcObject as a private property for this shim
            this._srcObject = stream;
            if (this.src) {
              URL.revokeObjectURL(this.src);
            }

            if (!stream) {
              this.src = '';
              return;
            }
            this.src = URL.createObjectURL(stream);
            // We need to recreate the blob url when a track is added or
            // removed. Doing it manually since we want to avoid a recursion.
            stream.addEventListener('addtrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
            stream.addEventListener('removetrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
          }
        });
      }
    }
  },

  shimPeerConnection: function() {
    // The RTCPeerConnection object.
    window.RTCPeerConnection = function(pcConfig, pcConstraints) {
      // Translate iceTransportPolicy to iceTransports,
      // see https://code.google.com/p/webrtc/issues/detail?id=4869
      logging('PeerConnection');
      if (pcConfig && pcConfig.iceTransportPolicy) {
        pcConfig.iceTransports = pcConfig.iceTransportPolicy;
      }

      var pc = new webkitRTCPeerConnection(pcConfig, pcConstraints);
      var origGetStats = pc.getStats.bind(pc);
      pc.getStats = function(selector, successCallback, errorCallback) {
        var self = this;
        var args = arguments;

        // If selector is a function then we are in the old style stats so just
        // pass back the original getStats format to avoid breaking old users.
        if (arguments.length > 0 && typeof selector === 'function') {
          return origGetStats(selector, successCallback);
        }

        var fixChromeStats_ = function(response) {
          var standardReport = {};
          var reports = response.result();
          reports.forEach(function(report) {
            var standardStats = {
              id: report.id,
              timestamp: report.timestamp,
              type: report.type
            };
            report.names().forEach(function(name) {
              standardStats[name] = report.stat(name);
            });
            standardReport[standardStats.id] = standardStats;
          });

          return standardReport;
        };

        // shim getStats with maplike support
        var makeMapStats = function(stats, legacyStats) {
          var map = new Map(Object.keys(stats).map(function(key) {
            return[key, stats[key]];
          }));
          legacyStats = legacyStats || stats;
          Object.keys(legacyStats).forEach(function(key) {
            map[key] = legacyStats[key];
          });
          return map;
        };

        if (arguments.length >= 2) {
          var successCallbackWrapper_ = function(response) {
            args[1](makeMapStats(fixChromeStats_(response)));
          };

          return origGetStats.apply(this, [successCallbackWrapper_,
              arguments[0]]);
        }

        // promise-support
        return new Promise(function(resolve, reject) {
          if (args.length === 1 && typeof selector === 'object') {
            origGetStats.apply(self, [
              function(response) {
                resolve(makeMapStats(fixChromeStats_(response)));
              }, reject]);
          } else {
            // Preserve legacy chrome stats only on legacy access of stats obj
            origGetStats.apply(self, [
              function(response) {
                resolve(makeMapStats(fixChromeStats_(response),
                    response.result()));
              }, reject]);
          }
        }).then(successCallback, errorCallback);
      };

      return pc;
    };
    window.RTCPeerConnection.prototype = webkitRTCPeerConnection.prototype;

    // wrap static methods. Currently just generateCertificate.
    if (webkitRTCPeerConnection.generateCertificate) {
      Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get: function() {
          return webkitRTCPeerConnection.generateCertificate;
        }
      });
    }

    ['createOffer', 'createAnswer'].forEach(function(method) {
      var nativeMethod = webkitRTCPeerConnection.prototype[method];
      webkitRTCPeerConnection.prototype[method] = function() {
        var self = this;
        if (arguments.length < 1 || (arguments.length === 1 &&
            typeof arguments[0] === 'object')) {
          var opts = arguments.length === 1 ? arguments[0] : undefined;
          return new Promise(function(resolve, reject) {
            nativeMethod.apply(self, [resolve, reject, opts]);
          });
        }
        return nativeMethod.apply(this, arguments);
      };
    });

    // add promise support -- natively available in Chrome 51
    if (browserDetails.version < 51) {
      ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
          .forEach(function(method) {
            var nativeMethod = webkitRTCPeerConnection.prototype[method];
            webkitRTCPeerConnection.prototype[method] = function() {
              var args = arguments;
              var self = this;
              var promise = new Promise(function(resolve, reject) {
                nativeMethod.apply(self, [args[0], resolve, reject]);
              });
              if (args.length < 2) {
                return promise;
              }
              return promise.then(function() {
                args[1].apply(null, []);
              },
              function(err) {
                if (args.length >= 3) {
                  args[2].apply(null, [err]);
                }
              });
            };
          });
    }

    // support for addIceCandidate(null)
    var nativeAddIceCandidate =
        RTCPeerConnection.prototype.addIceCandidate;
    RTCPeerConnection.prototype.addIceCandidate = function() {
      return arguments[0] === null ? Promise.resolve()
          : nativeAddIceCandidate.apply(this, arguments);
    };

    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = webkitRTCPeerConnection.prototype[method];
          webkitRTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                RTCIceCandidate : RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });
  },

  // Attach a media stream to an element.
  attachMediaStream: function(element, stream) {
    logging('DEPRECATED, attachMediaStream will soon be removed.');
    if (browserDetails.version >= 43) {
      element.srcObject = stream;
    } else if (typeof element.src !== 'undefined') {
      element.src = URL.createObjectURL(stream);
    } else {
      logging('Error attaching stream to element.');
    }
  },

  reattachMediaStream: function(to, from) {
    logging('DEPRECATED, reattachMediaStream will soon be removed.');
    if (browserDetails.version >= 43) {
      to.srcObject = from.srcObject;
    } else {
      to.src = from.src;
    }
  }
};


// Expose public methods.
module.exports = {
  shimMediaStream: chromeShim.shimMediaStream,
  shimOnTrack: chromeShim.shimOnTrack,
  shimSourceObject: chromeShim.shimSourceObject,
  shimPeerConnection: chromeShim.shimPeerConnection,
  shimGetUserMedia: require('./getusermedia'),
  attachMediaStream: chromeShim.attachMediaStream,
  reattachMediaStream: chromeShim.reattachMediaStream
};

},{"../utils.js":707,"./getusermedia":701}],701:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */
'use strict';
var logging = require('../utils.js').log;

// Expose public methods.
module.exports = function() {
  var constraintsToChrome_ = function(c) {
    if (typeof c !== 'object' || c.mandatory || c.optional) {
      return c;
    }
    var cc = {};
    Object.keys(c).forEach(function(key) {
      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
        return;
      }
      var r = (typeof c[key] === 'object') ? c[key] : {ideal: c[key]};
      if (r.exact !== undefined && typeof r.exact === 'number') {
        r.min = r.max = r.exact;
      }
      var oldname_ = function(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }
        return (name === 'deviceId') ? 'sourceId' : name;
      };
      if (r.ideal !== undefined) {
        cc.optional = cc.optional || [];
        var oc = {};
        if (typeof r.ideal === 'number') {
          oc[oldname_('min', key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_('max', key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_('', key)] = r.ideal;
          cc.optional.push(oc);
        }
      }
      if (r.exact !== undefined && typeof r.exact !== 'number') {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_('', key)] = r.exact;
      } else {
        ['min', 'max'].forEach(function(mix) {
          if (r[mix] !== undefined) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });
    if (c.advanced) {
      cc.optional = (cc.optional || []).concat(c.advanced);
    }
    return cc;
  };

  var shimConstraints_ = function(constraints, func) {
    constraints = JSON.parse(JSON.stringify(constraints));
    if (constraints && constraints.audio) {
      constraints.audio = constraintsToChrome_(constraints.audio);
    }
    if (constraints && typeof constraints.video === 'object') {
      // Shim facingMode for mobile, where it defaults to "user".
      var face = constraints.video.facingMode;
      face = face && ((typeof face === 'object') ? face : {ideal: face});

      if ((face && (face.exact === 'user' || face.exact === 'environment' ||
                    face.ideal === 'user' || face.ideal === 'environment')) &&
          !(navigator.mediaDevices.getSupportedConstraints &&
            navigator.mediaDevices.getSupportedConstraints().facingMode)) {
        delete constraints.video.facingMode;
        if (face.exact === 'environment' || face.ideal === 'environment') {
          // Look for "back" in label, or use last cam (typically back cam).
          return navigator.mediaDevices.enumerateDevices()
          .then(function(devices) {
            devices = devices.filter(function(d) {
              return d.kind === 'videoinput';
            });
            var back = devices.find(function(d) {
              return d.label.toLowerCase().indexOf('back') !== -1;
            }) || (devices.length && devices[devices.length - 1]);
            if (back) {
              constraints.video.deviceId = face.exact ? {exact: back.deviceId} :
                                                        {ideal: back.deviceId};
            }
            constraints.video = constraintsToChrome_(constraints.video);
            logging('chrome: ' + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }
      constraints.video = constraintsToChrome_(constraints.video);
    }
    logging('chrome: ' + JSON.stringify(constraints));
    return func(constraints);
  };

  var shimError_ = function(e) {
    return {
      name: {
        PermissionDeniedError: 'NotAllowedError',
        ConstraintNotSatisfiedError: 'OverconstrainedError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraintName,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  var getUserMedia_ = function(constraints, onSuccess, onError) {
    shimConstraints_(constraints, function(c) {
      navigator.webkitGetUserMedia(c, onSuccess, function(e) {
        onError(shimError_(e));
      });
    });
  };

  navigator.getUserMedia = getUserMedia_;

  // Returns the result of getUserMedia as a Promise.
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      navigator.getUserMedia(constraints, resolve, reject);
    });
  };

  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {
      getUserMedia: getUserMediaPromise_,
      enumerateDevices: function() {
        return new Promise(function(resolve) {
          var kinds = {audio: 'audioinput', video: 'videoinput'};
          return MediaStreamTrack.getSources(function(devices) {
            resolve(devices.map(function(device) {
              return {label: device.label,
                      kind: kinds[device.kind],
                      deviceId: device.id,
                      groupId: ''};
            }));
          });
        });
      }
    };
  }

  // A shim for getUserMedia method on the mediaDevices object.
  // TODO(KaptenJansson) remove once implemented in Chrome stable.
  if (!navigator.mediaDevices.getUserMedia) {
    navigator.mediaDevices.getUserMedia = function(constraints) {
      return getUserMediaPromise_(constraints);
    };
  } else {
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(cs) {
      return shimConstraints_(cs, function(c) {
        return origGetUserMedia(c).catch(function(e) {
          return Promise.reject(shimError_(e));
        });
      });
    };
  }

  // Dummy devicechange event methods.
  // TODO(KaptenJansson) remove once implemented in Chrome stable.
  if (typeof navigator.mediaDevices.addEventListener === 'undefined') {
    navigator.mediaDevices.addEventListener = function() {
      logging('Dummy mediaDevices.addEventListener called.');
    };
  }
  if (typeof navigator.mediaDevices.removeEventListener === 'undefined') {
    navigator.mediaDevices.removeEventListener = function() {
      logging('Dummy mediaDevices.removeEventListener called.');
    };
  }
};

},{"../utils.js":707}],702:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */
'use strict';

var SDPUtils = require('sdp');
var logging = require('../utils').log;

var edgeShim = {
  shimPeerConnection: function() {
    if (window.RTCIceGatherer) {
      // ORTC defines an RTCIceCandidate object but no constructor.
      // Not implemented in Edge.
      if (!window.RTCIceCandidate) {
        window.RTCIceCandidate = function(args) {
          return args;
        };
      }
      // ORTC does not have a session description object but
      // other browsers (i.e. Chrome) that will support both PC and ORTC
      // in the future might have this defined already.
      if (!window.RTCSessionDescription) {
        window.RTCSessionDescription = function(args) {
          return args;
        };
      }
    }

    window.RTCPeerConnection = function(config) {
      var self = this;

      var _eventTarget = document.createDocumentFragment();
      ['addEventListener', 'removeEventListener', 'dispatchEvent']
          .forEach(function(method) {
            self[method] = _eventTarget[method].bind(_eventTarget);
          });

      this.onicecandidate = null;
      this.onaddstream = null;
      this.ontrack = null;
      this.onremovestream = null;
      this.onsignalingstatechange = null;
      this.oniceconnectionstatechange = null;
      this.onnegotiationneeded = null;
      this.ondatachannel = null;

      this.localStreams = [];
      this.remoteStreams = [];
      this.getLocalStreams = function() {
        return self.localStreams;
      };
      this.getRemoteStreams = function() {
        return self.remoteStreams;
      };

      this.localDescription = new RTCSessionDescription({
        type: '',
        sdp: ''
      });
      this.remoteDescription = new RTCSessionDescription({
        type: '',
        sdp: ''
      });
      this.signalingState = 'stable';
      this.iceConnectionState = 'new';
      this.iceGatheringState = 'new';

      this.iceOptions = {
        gatherPolicy: 'all',
        iceServers: []
      };
      if (config && config.iceTransportPolicy) {
        switch (config.iceTransportPolicy) {
          case 'all':
          case 'relay':
            this.iceOptions.gatherPolicy = config.iceTransportPolicy;
            break;
          case 'none':
            // FIXME: remove once implementation and spec have added this.
            throw new TypeError('iceTransportPolicy "none" not supported');
          default:
            // don't set iceTransportPolicy.
            break;
        }
      }
      this.usingBundle = config && config.bundlePolicy === 'max-bundle';

      if (config && config.iceServers) {
        // Edge does not like
        // 1) stun:
        // 2) turn: that does not have all of turn:host:port?transport=udp
        var iceServers = JSON.parse(JSON.stringify(config.iceServers));
        this.iceOptions.iceServers = iceServers.filter(function(server) {
          if (server && server.urls) {
            var urls = server.urls;
            if (typeof urls === 'string') {
              urls = [urls];
            }
            urls = urls.filter(function(url) {
              return url.indexOf('turn:') === 0 &&
                  url.indexOf('transport=udp') !== -1;
            })[0];
            return !!urls;
          }
          return false;
        });
      }

      // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
      // everything that is needed to describe a SDP m-line.
      this.transceivers = [];

      // since the iceGatherer is currently created in createOffer but we
      // must not emit candidates until after setLocalDescription we buffer
      // them in this array.
      this._localIceCandidatesBuffer = [];
    };

    window.RTCPeerConnection.prototype._emitBufferedCandidates = function() {
      var self = this;
      var sections = SDPUtils.splitSections(self.localDescription.sdp);
      // FIXME: need to apply ice candidates in a way which is async but
      // in-order
      this._localIceCandidatesBuffer.forEach(function(event) {
        var end = !event.candidate || Object.keys(event.candidate).length === 0;
        if (end) {
          for (var j = 1; j < sections.length; j++) {
            if (sections[j].indexOf('\r\na=end-of-candidates\r\n') === -1) {
              sections[j] += 'a=end-of-candidates\r\n';
            }
          }
        } else if (event.candidate.candidate.indexOf('typ endOfCandidates')
            === -1) {
          sections[event.candidate.sdpMLineIndex + 1] +=
              'a=' + event.candidate.candidate + '\r\n';
        }
        self.localDescription.sdp = sections.join('');
        self.dispatchEvent(event);
        if (self.onicecandidate !== null) {
          self.onicecandidate(event);
        }
        if (!event.candidate && self.iceGatheringState !== 'complete') {
          var complete = self.transceivers.every(function(transceiver) {
            return transceiver.iceGatherer &&
                transceiver.iceGatherer.state === 'completed';
          });
          if (complete) {
            self.iceGatheringState = 'complete';
          }
        }
      });
      this._localIceCandidatesBuffer = [];
    };

    window.RTCPeerConnection.prototype.addStream = function(stream) {
      // Clone is necessary for local demos mostly, attaching directly
      // to two different senders does not work (build 10547).
      this.localStreams.push(stream.clone());
      this._maybeFireNegotiationNeeded();
    };

    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      var idx = this.localStreams.indexOf(stream);
      if (idx > -1) {
        this.localStreams.splice(idx, 1);
        this._maybeFireNegotiationNeeded();
      }
    };

    window.RTCPeerConnection.prototype.getSenders = function() {
      return this.transceivers.filter(function(transceiver) {
        return !!transceiver.rtpSender;
      })
      .map(function(transceiver) {
        return transceiver.rtpSender;
      });
    };

    window.RTCPeerConnection.prototype.getReceivers = function() {
      return this.transceivers.filter(function(transceiver) {
        return !!transceiver.rtpReceiver;
      })
      .map(function(transceiver) {
        return transceiver.rtpReceiver;
      });
    };

    // Determines the intersection of local and remote capabilities.
    window.RTCPeerConnection.prototype._getCommonCapabilities =
        function(localCapabilities, remoteCapabilities) {
          var commonCapabilities = {
            codecs: [],
            headerExtensions: [],
            fecMechanisms: []
          };
          localCapabilities.codecs.forEach(function(lCodec) {
            for (var i = 0; i < remoteCapabilities.codecs.length; i++) {
              var rCodec = remoteCapabilities.codecs[i];
              if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() &&
                  lCodec.clockRate === rCodec.clockRate &&
                  lCodec.numChannels === rCodec.numChannels) {
                // push rCodec so we reply with offerer payload type
                commonCapabilities.codecs.push(rCodec);

                // FIXME: also need to determine intersection between
                // .rtcpFeedback and .parameters
                break;
              }
            }
          });

          localCapabilities.headerExtensions
              .forEach(function(lHeaderExtension) {
                for (var i = 0; i < remoteCapabilities.headerExtensions.length;
                     i++) {
                  var rHeaderExtension = remoteCapabilities.headerExtensions[i];
                  if (lHeaderExtension.uri === rHeaderExtension.uri) {
                    commonCapabilities.headerExtensions.push(rHeaderExtension);
                    break;
                  }
                }
              });

          // FIXME: fecMechanisms
          return commonCapabilities;
        };

    // Create ICE gatherer, ICE transport and DTLS transport.
    window.RTCPeerConnection.prototype._createIceAndDtlsTransports =
        function(mid, sdpMLineIndex) {
          var self = this;
          var iceGatherer = new RTCIceGatherer(self.iceOptions);
          var iceTransport = new RTCIceTransport(iceGatherer);
          iceGatherer.onlocalcandidate = function(evt) {
            var event = new Event('icecandidate');
            event.candidate = {sdpMid: mid, sdpMLineIndex: sdpMLineIndex};

            var cand = evt.candidate;
            var end = !cand || Object.keys(cand).length === 0;
            // Edge emits an empty object for RTCIceCandidateComplete‥
            if (end) {
              // polyfill since RTCIceGatherer.state is not implemented in
              // Edge 10547 yet.
              if (iceGatherer.state === undefined) {
                iceGatherer.state = 'completed';
              }

              // Emit a candidate with type endOfCandidates to make the samples
              // work. Edge requires addIceCandidate with this empty candidate
              // to start checking. The real solution is to signal
              // end-of-candidates to the other side when getting the null
              // candidate but some apps (like the samples) don't do that.
              event.candidate.candidate =
                  'candidate:1 1 udp 1 0.0.0.0 9 typ endOfCandidates';
            } else {
              // RTCIceCandidate doesn't have a component, needs to be added
              cand.component = iceTransport.component === 'RTCP' ? 2 : 1;
              event.candidate.candidate = SDPUtils.writeCandidate(cand);
            }

            // update local description.
            var sections = SDPUtils.splitSections(self.localDescription.sdp);
            if (event.candidate.candidate.indexOf('typ endOfCandidates')
                === -1) {
              sections[event.candidate.sdpMLineIndex + 1] +=
                  'a=' + event.candidate.candidate + '\r\n';
            } else {
              sections[event.candidate.sdpMLineIndex + 1] +=
                  'a=end-of-candidates\r\n';
            }
            self.localDescription.sdp = sections.join('');

            var complete = self.transceivers.every(function(transceiver) {
              return transceiver.iceGatherer &&
                  transceiver.iceGatherer.state === 'completed';
            });

            // Emit candidate if localDescription is set.
            // Also emits null candidate when all gatherers are complete.
            switch (self.iceGatheringState) {
              case 'new':
                self._localIceCandidatesBuffer.push(event);
                if (end && complete) {
                  self._localIceCandidatesBuffer.push(
                      new Event('icecandidate'));
                }
                break;
              case 'gathering':
                self._emitBufferedCandidates();
                self.dispatchEvent(event);
                if (self.onicecandidate !== null) {
                  self.onicecandidate(event);
                }
                if (complete) {
                  self.dispatchEvent(new Event('icecandidate'));
                  if (self.onicecandidate !== null) {
                    self.onicecandidate(new Event('icecandidate'));
                  }
                  self.iceGatheringState = 'complete';
                }
                break;
              case 'complete':
                // should not happen... currently!
                break;
              default: // no-op.
                break;
            }
          };
          iceTransport.onicestatechange = function() {
            self._updateConnectionState();
          };

          var dtlsTransport = new RTCDtlsTransport(iceTransport);
          dtlsTransport.ondtlsstatechange = function() {
            self._updateConnectionState();
          };
          dtlsTransport.onerror = function() {
            // onerror does not set state to failed by itself.
            dtlsTransport.state = 'failed';
            self._updateConnectionState();
          };

          return {
            iceGatherer: iceGatherer,
            iceTransport: iceTransport,
            dtlsTransport: dtlsTransport
          };
        };

    // Start the RTP Sender and Receiver for a transceiver.
    window.RTCPeerConnection.prototype._transceive = function(transceiver,
        send, recv) {
      var params = this._getCommonCapabilities(transceiver.localCapabilities,
          transceiver.remoteCapabilities);
      if (send && transceiver.rtpSender) {
        params.encodings = transceiver.sendEncodingParameters;
        params.rtcp = {
          cname: SDPUtils.localCName
        };
        if (transceiver.recvEncodingParameters.length) {
          params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
        }
        transceiver.rtpSender.send(params);
      }
      if (recv && transceiver.rtpReceiver) {
        params.encodings = transceiver.recvEncodingParameters;
        params.rtcp = {
          cname: transceiver.cname
        };
        if (transceiver.sendEncodingParameters.length) {
          params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
        }
        transceiver.rtpReceiver.receive(params);
      }
    };

    window.RTCPeerConnection.prototype.setLocalDescription =
        function(description) {
          var self = this;
          var sections;
          var sessionpart;
          if (description.type === 'offer') {
            // FIXME: What was the purpose of this empty if statement?
            // if (!this._pendingOffer) {
            // } else {
            if (this._pendingOffer) {
              // VERY limited support for SDP munging. Limited to:
              // * changing the order of codecs
              sections = SDPUtils.splitSections(description.sdp);
              sessionpart = sections.shift();
              sections.forEach(function(mediaSection, sdpMLineIndex) {
                var caps = SDPUtils.parseRtpParameters(mediaSection);
                self._pendingOffer[sdpMLineIndex].localCapabilities = caps;
              });
              this.transceivers = this._pendingOffer;
              delete this._pendingOffer;
            }
          } else if (description.type === 'answer') {
            sections = SDPUtils.splitSections(self.remoteDescription.sdp);
            sessionpart = sections.shift();
            var isIceLite = SDPUtils.matchPrefix(sessionpart,
                'a=ice-lite').length > 0;
            sections.forEach(function(mediaSection, sdpMLineIndex) {
              var transceiver = self.transceivers[sdpMLineIndex];
              var iceGatherer = transceiver.iceGatherer;
              var iceTransport = transceiver.iceTransport;
              var dtlsTransport = transceiver.dtlsTransport;
              var localCapabilities = transceiver.localCapabilities;
              var remoteCapabilities = transceiver.remoteCapabilities;
              var rejected = mediaSection.split('\n', 1)[0]
                  .split(' ', 2)[1] === '0';

              if (!rejected) {
                var remoteIceParameters = SDPUtils.getIceParameters(
                    mediaSection, sessionpart);
                if (isIceLite) {
                  var cands = SDPUtils.matchPrefix(mediaSection, 'a=candidate:')
                  .map(function(cand) {
                    return SDPUtils.parseCandidate(cand);
                  })
                  .filter(function(cand) {
                    return cand.component === '1';
                  });
                  // ice-lite only includes host candidates in the SDP so we can
                  // use setRemoteCandidates (which implies an
                  // RTCIceCandidateComplete)
                  if (cands.length) {
                    iceTransport.setRemoteCandidates(cands);
                  }
                }
                var remoteDtlsParameters = SDPUtils.getDtlsParameters(
                    mediaSection, sessionpart);
                if (isIceLite) {
                  remoteDtlsParameters.role = 'server';
                }

                if (!self.usingBundle || sdpMLineIndex === 0) {
                  iceTransport.start(iceGatherer, remoteIceParameters,
                      isIceLite ? 'controlling' : 'controlled');
                  dtlsTransport.start(remoteDtlsParameters);
                }

                // Calculate intersection of capabilities.
                var params = self._getCommonCapabilities(localCapabilities,
                    remoteCapabilities);

                // Start the RTCRtpSender. The RTCRtpReceiver for this
                // transceiver has already been started in setRemoteDescription.
                self._transceive(transceiver,
                    params.codecs.length > 0,
                    false);
              }
            });
          }

          this.localDescription = {
            type: description.type,
            sdp: description.sdp
          };
          switch (description.type) {
            case 'offer':
              this._updateSignalingState('have-local-offer');
              break;
            case 'answer':
              this._updateSignalingState('stable');
              break;
            default:
              throw new TypeError('unsupported type "' + description.type +
                  '"');
          }

          // If a success callback was provided, emit ICE candidates after it
          // has been executed. Otherwise, emit callback after the Promise is
          // resolved.
          var hasCallback = arguments.length > 1 &&
            typeof arguments[1] === 'function';
          if (hasCallback) {
            var cb = arguments[1];
            window.setTimeout(function() {
              cb();
              if (self.iceGatheringState === 'new') {
                self.iceGatheringState = 'gathering';
              }
              self._emitBufferedCandidates();
            }, 0);
          }
          var p = Promise.resolve();
          p.then(function() {
            if (!hasCallback) {
              if (self.iceGatheringState === 'new') {
                self.iceGatheringState = 'gathering';
              }
              // Usually candidates will be emitted earlier.
              window.setTimeout(self._emitBufferedCandidates.bind(self), 500);
            }
          });
          return p;
        };

    window.RTCPeerConnection.prototype.setRemoteDescription =
        function(description) {
          var self = this;
          var stream = new MediaStream();
          var receiverList = [];
          var sections = SDPUtils.splitSections(description.sdp);
          var sessionpart = sections.shift();
          var isIceLite = SDPUtils.matchPrefix(sessionpart,
              'a=ice-lite').length > 0;
          this.usingBundle = SDPUtils.matchPrefix(sessionpart,
              'a=group:BUNDLE ').length > 0;
          sections.forEach(function(mediaSection, sdpMLineIndex) {
            var lines = SDPUtils.splitLines(mediaSection);
            var mline = lines[0].substr(2).split(' ');
            var kind = mline[0];
            var rejected = mline[1] === '0';
            var direction = SDPUtils.getDirection(mediaSection, sessionpart);

            var transceiver;
            var iceGatherer;
            var iceTransport;
            var dtlsTransport;
            var rtpSender;
            var rtpReceiver;
            var sendEncodingParameters;
            var recvEncodingParameters;
            var localCapabilities;

            var track;
            // FIXME: ensure the mediaSection has rtcp-mux set.
            var remoteCapabilities = SDPUtils.parseRtpParameters(mediaSection);
            var remoteIceParameters;
            var remoteDtlsParameters;
            if (!rejected) {
              remoteIceParameters = SDPUtils.getIceParameters(mediaSection,
                  sessionpart);
              remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection,
                  sessionpart);
              remoteDtlsParameters.role = 'client';
            }
            recvEncodingParameters =
                SDPUtils.parseRtpEncodingParameters(mediaSection);

            var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:');
            if (mid.length) {
              mid = mid[0].substr(6);
            } else {
              mid = SDPUtils.generateIdentifier();
            }

            var cname;
            // Gets the first SSRC. Note that with RTX there might be multiple
            // SSRCs.
            var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
                .map(function(line) {
                  return SDPUtils.parseSsrcMedia(line);
                })
                .filter(function(obj) {
                  return obj.attribute === 'cname';
                })[0];
            if (remoteSsrc) {
              cname = remoteSsrc.value;
            }

            var isComplete = SDPUtils.matchPrefix(mediaSection,
                'a=end-of-candidates').length > 0;
            var cands = SDPUtils.matchPrefix(mediaSection, 'a=candidate:')
                .map(function(cand) {
                  return SDPUtils.parseCandidate(cand);
                })
                .filter(function(cand) {
                  return cand.component === '1';
                });
            if (description.type === 'offer' && !rejected) {
              var transports = self.usingBundle && sdpMLineIndex > 0 ? {
                iceGatherer: self.transceivers[0].iceGatherer,
                iceTransport: self.transceivers[0].iceTransport,
                dtlsTransport: self.transceivers[0].dtlsTransport
              } : self._createIceAndDtlsTransports(mid, sdpMLineIndex);

              if (isComplete) {
                transports.iceTransport.setRemoteCandidates(cands);
              }

              localCapabilities = RTCRtpReceiver.getCapabilities(kind);
              sendEncodingParameters = [{
                ssrc: (2 * sdpMLineIndex + 2) * 1001
              }];

              rtpReceiver = new RTCRtpReceiver(transports.dtlsTransport, kind);

              track = rtpReceiver.track;
              receiverList.push([track, rtpReceiver]);
              // FIXME: not correct when there are multiple streams but that is
              // not currently supported in this shim.
              stream.addTrack(track);

              // FIXME: look at direction.
              if (self.localStreams.length > 0 &&
                  self.localStreams[0].getTracks().length >= sdpMLineIndex) {
                // FIXME: actually more complicated, needs to match types etc
                var localtrack = self.localStreams[0]
                    .getTracks()[sdpMLineIndex];
                rtpSender = new RTCRtpSender(localtrack,
                    transports.dtlsTransport);
              }

              self.transceivers[sdpMLineIndex] = {
                iceGatherer: transports.iceGatherer,
                iceTransport: transports.iceTransport,
                dtlsTransport: transports.dtlsTransport,
                localCapabilities: localCapabilities,
                remoteCapabilities: remoteCapabilities,
                rtpSender: rtpSender,
                rtpReceiver: rtpReceiver,
                kind: kind,
                mid: mid,
                cname: cname,
                sendEncodingParameters: sendEncodingParameters,
                recvEncodingParameters: recvEncodingParameters
              };
              // Start the RTCRtpReceiver now. The RTPSender is started in
              // setLocalDescription.
              self._transceive(self.transceivers[sdpMLineIndex],
                  false,
                  direction === 'sendrecv' || direction === 'sendonly');
            } else if (description.type === 'answer' && !rejected) {
              transceiver = self.transceivers[sdpMLineIndex];
              iceGatherer = transceiver.iceGatherer;
              iceTransport = transceiver.iceTransport;
              dtlsTransport = transceiver.dtlsTransport;
              rtpSender = transceiver.rtpSender;
              rtpReceiver = transceiver.rtpReceiver;
              sendEncodingParameters = transceiver.sendEncodingParameters;
              localCapabilities = transceiver.localCapabilities;

              self.transceivers[sdpMLineIndex].recvEncodingParameters =
                  recvEncodingParameters;
              self.transceivers[sdpMLineIndex].remoteCapabilities =
                  remoteCapabilities;
              self.transceivers[sdpMLineIndex].cname = cname;

              if ((isIceLite || isComplete) && cands.length) {
                iceTransport.setRemoteCandidates(cands);
              }
              if (!self.usingBundle || sdpMLineIndex === 0) {
                iceTransport.start(iceGatherer, remoteIceParameters,
                    'controlling');
                dtlsTransport.start(remoteDtlsParameters);
              }

              self._transceive(transceiver,
                  direction === 'sendrecv' || direction === 'recvonly',
                  direction === 'sendrecv' || direction === 'sendonly');

              if (rtpReceiver &&
                  (direction === 'sendrecv' || direction === 'sendonly')) {
                track = rtpReceiver.track;
                receiverList.push([track, rtpReceiver]);
                stream.addTrack(track);
              } else {
                // FIXME: actually the receiver should be created later.
                delete transceiver.rtpReceiver;
              }
            }
          });

          this.remoteDescription = {
            type: description.type,
            sdp: description.sdp
          };
          switch (description.type) {
            case 'offer':
              this._updateSignalingState('have-remote-offer');
              break;
            case 'answer':
              this._updateSignalingState('stable');
              break;
            default:
              throw new TypeError('unsupported type "' + description.type +
                  '"');
          }
          if (stream.getTracks().length) {
            self.remoteStreams.push(stream);
            window.setTimeout(function() {
              var event = new Event('addstream');
              event.stream = stream;
              self.dispatchEvent(event);
              if (self.onaddstream !== null) {
                window.setTimeout(function() {
                  self.onaddstream(event);
                }, 0);
              }

              receiverList.forEach(function(item) {
                var track = item[0];
                var receiver = item[1];
                var trackEvent = new Event('track');
                trackEvent.track = track;
                trackEvent.receiver = receiver;
                trackEvent.streams = [stream];
                self.dispatchEvent(event);
                if (self.ontrack !== null) {
                  window.setTimeout(function() {
                    self.ontrack(trackEvent);
                  }, 0);
                }
              });
            }, 0);
          }
          if (arguments.length > 1 && typeof arguments[1] === 'function') {
            window.setTimeout(arguments[1], 0);
          }
          return Promise.resolve();
        };

    window.RTCPeerConnection.prototype.close = function() {
      this.transceivers.forEach(function(transceiver) {
        /* not yet
        if (transceiver.iceGatherer) {
          transceiver.iceGatherer.close();
        }
        */
        if (transceiver.iceTransport) {
          transceiver.iceTransport.stop();
        }
        if (transceiver.dtlsTransport) {
          transceiver.dtlsTransport.stop();
        }
        if (transceiver.rtpSender) {
          transceiver.rtpSender.stop();
        }
        if (transceiver.rtpReceiver) {
          transceiver.rtpReceiver.stop();
        }
      });
      // FIXME: clean up tracks, local streams, remote streams, etc
      this._updateSignalingState('closed');
    };

    // Update the signaling state.
    window.RTCPeerConnection.prototype._updateSignalingState =
        function(newState) {
          this.signalingState = newState;
          var event = new Event('signalingstatechange');
          this.dispatchEvent(event);
          if (this.onsignalingstatechange !== null) {
            this.onsignalingstatechange(event);
          }
        };

    // Determine whether to fire the negotiationneeded event.
    window.RTCPeerConnection.prototype._maybeFireNegotiationNeeded =
        function() {
          // Fire away (for now).
          var event = new Event('negotiationneeded');
          this.dispatchEvent(event);
          if (this.onnegotiationneeded !== null) {
            this.onnegotiationneeded(event);
          }
        };

    // Update the connection state.
    window.RTCPeerConnection.prototype._updateConnectionState = function() {
      var self = this;
      var newState;
      var states = {
        'new': 0,
        closed: 0,
        connecting: 0,
        checking: 0,
        connected: 0,
        completed: 0,
        failed: 0
      };
      this.transceivers.forEach(function(transceiver) {
        states[transceiver.iceTransport.state]++;
        states[transceiver.dtlsTransport.state]++;
      });
      // ICETransport.completed and connected are the same for this purpose.
      states.connected += states.completed;

      newState = 'new';
      if (states.failed > 0) {
        newState = 'failed';
      } else if (states.connecting > 0 || states.checking > 0) {
        newState = 'connecting';
      } else if (states.disconnected > 0) {
        newState = 'disconnected';
      } else if (states.new > 0) {
        newState = 'new';
      } else if (states.connected > 0 || states.completed > 0) {
        newState = 'connected';
      }

      if (newState !== self.iceConnectionState) {
        self.iceConnectionState = newState;
        var event = new Event('iceconnectionstatechange');
        this.dispatchEvent(event);
        if (this.oniceconnectionstatechange !== null) {
          this.oniceconnectionstatechange(event);
        }
      }
    };

    window.RTCPeerConnection.prototype.createOffer = function() {
      var self = this;
      if (this._pendingOffer) {
        throw new Error('createOffer called while there is a pending offer.');
      }
      var offerOptions;
      if (arguments.length === 1 && typeof arguments[0] !== 'function') {
        offerOptions = arguments[0];
      } else if (arguments.length === 3) {
        offerOptions = arguments[2];
      }

      var tracks = [];
      var numAudioTracks = 0;
      var numVideoTracks = 0;
      // Default to sendrecv.
      if (this.localStreams.length) {
        numAudioTracks = this.localStreams[0].getAudioTracks().length;
        numVideoTracks = this.localStreams[0].getVideoTracks().length;
      }
      // Determine number of audio and video tracks we need to send/recv.
      if (offerOptions) {
        // Reject Chrome legacy constraints.
        if (offerOptions.mandatory || offerOptions.optional) {
          throw new TypeError(
              'Legacy mandatory/optional constraints not supported.');
        }
        if (offerOptions.offerToReceiveAudio !== undefined) {
          numAudioTracks = offerOptions.offerToReceiveAudio;
        }
        if (offerOptions.offerToReceiveVideo !== undefined) {
          numVideoTracks = offerOptions.offerToReceiveVideo;
        }
      }
      if (this.localStreams.length) {
        // Push local streams.
        this.localStreams[0].getTracks().forEach(function(track) {
          tracks.push({
            kind: track.kind,
            track: track,
            wantReceive: track.kind === 'audio' ?
                numAudioTracks > 0 : numVideoTracks > 0
          });
          if (track.kind === 'audio') {
            numAudioTracks--;
          } else if (track.kind === 'video') {
            numVideoTracks--;
          }
        });
      }
      // Create M-lines for recvonly streams.
      while (numAudioTracks > 0 || numVideoTracks > 0) {
        if (numAudioTracks > 0) {
          tracks.push({
            kind: 'audio',
            wantReceive: true
          });
          numAudioTracks--;
        }
        if (numVideoTracks > 0) {
          tracks.push({
            kind: 'video',
            wantReceive: true
          });
          numVideoTracks--;
        }
      }

      var sdp = SDPUtils.writeSessionBoilerplate();
      var transceivers = [];
      tracks.forEach(function(mline, sdpMLineIndex) {
        // For each track, create an ice gatherer, ice transport,
        // dtls transport, potentially rtpsender and rtpreceiver.
        var track = mline.track;
        var kind = mline.kind;
        var mid = SDPUtils.generateIdentifier();

        var transports = self.usingBundle && sdpMLineIndex > 0 ? {
          iceGatherer: transceivers[0].iceGatherer,
          iceTransport: transceivers[0].iceTransport,
          dtlsTransport: transceivers[0].dtlsTransport
        } : self._createIceAndDtlsTransports(mid, sdpMLineIndex);

        var localCapabilities = RTCRtpSender.getCapabilities(kind);
        var rtpSender;
        var rtpReceiver;

        // generate an ssrc now, to be used later in rtpSender.send
        var sendEncodingParameters = [{
          ssrc: (2 * sdpMLineIndex + 1) * 1001
        }];
        if (track) {
          rtpSender = new RTCRtpSender(track, transports.dtlsTransport);
        }

        if (mline.wantReceive) {
          rtpReceiver = new RTCRtpReceiver(transports.dtlsTransport, kind);
        }

        transceivers[sdpMLineIndex] = {
          iceGatherer: transports.iceGatherer,
          iceTransport: transports.iceTransport,
          dtlsTransport: transports.dtlsTransport,
          localCapabilities: localCapabilities,
          remoteCapabilities: null,
          rtpSender: rtpSender,
          rtpReceiver: rtpReceiver,
          kind: kind,
          mid: mid,
          sendEncodingParameters: sendEncodingParameters,
          recvEncodingParameters: null
        };
      });
      if (this.usingBundle) {
        sdp += 'a=group:BUNDLE ' + transceivers.map(function(t) {
          return t.mid;
        }).join(' ') + '\r\n';
      }
      tracks.forEach(function(mline, sdpMLineIndex) {
        var transceiver = transceivers[sdpMLineIndex];
        sdp += SDPUtils.writeMediaSection(transceiver,
            transceiver.localCapabilities, 'offer', self.localStreams[0]);
      });

      this._pendingOffer = transceivers;
      var desc = new RTCSessionDescription({
        type: 'offer',
        sdp: sdp
      });
      if (arguments.length && typeof arguments[0] === 'function') {
        window.setTimeout(arguments[0], 0, desc);
      }
      return Promise.resolve(desc);
    };

    window.RTCPeerConnection.prototype.createAnswer = function() {
      var self = this;

      var sdp = SDPUtils.writeSessionBoilerplate();
      if (this.usingBundle) {
        sdp += 'a=group:BUNDLE ' + this.transceivers.map(function(t) {
          return t.mid;
        }).join(' ') + '\r\n';
      }
      this.transceivers.forEach(function(transceiver) {
        // Calculate intersection of capabilities.
        var commonCapabilities = self._getCommonCapabilities(
            transceiver.localCapabilities,
            transceiver.remoteCapabilities);

        sdp += SDPUtils.writeMediaSection(transceiver, commonCapabilities,
            'answer', self.localStreams[0]);
      });

      var desc = new RTCSessionDescription({
        type: 'answer',
        sdp: sdp
      });
      if (arguments.length && typeof arguments[0] === 'function') {
        window.setTimeout(arguments[0], 0, desc);
      }
      return Promise.resolve(desc);
    };

    window.RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
      if (candidate === null) {
        this.transceivers.forEach(function(transceiver) {
          transceiver.iceTransport.addRemoteCandidate({});
        });
      } else {
        var mLineIndex = candidate.sdpMLineIndex;
        if (candidate.sdpMid) {
          for (var i = 0; i < this.transceivers.length; i++) {
            if (this.transceivers[i].mid === candidate.sdpMid) {
              mLineIndex = i;
              break;
            }
          }
        }
        var transceiver = this.transceivers[mLineIndex];
        if (transceiver) {
          var cand = Object.keys(candidate.candidate).length > 0 ?
              SDPUtils.parseCandidate(candidate.candidate) : {};
          // Ignore Chrome's invalid candidates since Edge does not like them.
          if (cand.protocol === 'tcp' && cand.port === 0) {
            return;
          }
          // Ignore RTCP candidates, we assume RTCP-MUX.
          if (cand.component !== '1') {
            return;
          }
          // A dirty hack to make samples work.
          if (cand.type === 'endOfCandidates') {
            cand = {};
          }
          transceiver.iceTransport.addRemoteCandidate(cand);

          // update the remoteDescription.
          var sections = SDPUtils.splitSections(this.remoteDescription.sdp);
          sections[mLineIndex + 1] += (cand.type ? candidate.candidate.trim()
              : 'a=end-of-candidates') + '\r\n';
          this.remoteDescription.sdp = sections.join('');
        }
      }
      if (arguments.length > 1 && typeof arguments[1] === 'function') {
        window.setTimeout(arguments[1], 0);
      }
      return Promise.resolve();
    };

    window.RTCPeerConnection.prototype.getStats = function() {
      var promises = [];
      this.transceivers.forEach(function(transceiver) {
        ['rtpSender', 'rtpReceiver', 'iceGatherer', 'iceTransport',
            'dtlsTransport'].forEach(function(method) {
              if (transceiver[method]) {
                promises.push(transceiver[method].getStats());
              }
            });
      });
      var cb = arguments.length > 1 && typeof arguments[1] === 'function' &&
          arguments[1];
      return new Promise(function(resolve) {
        // shim getStats with maplike support
        var results = new Map();
        Promise.all(promises).then(function(res) {
          res.forEach(function(result) {
            Object.keys(result).forEach(function(id) {
              results.set(id, result[id]);
              results[id] = result[id];
            });
          });
          if (cb) {
            window.setTimeout(cb, 0, results);
          }
          resolve(results);
        });
      });
    };
  },

  // Attach a media stream to an element.
  attachMediaStream: function(element, stream) {
    logging('DEPRECATED, attachMediaStream will soon be removed.');
    element.srcObject = stream;
  },

  reattachMediaStream: function(to, from) {
    logging('DEPRECATED, reattachMediaStream will soon be removed.');
    to.srcObject = from.srcObject;
  }
};

// Expose public methods.
module.exports = {
  shimPeerConnection: edgeShim.shimPeerConnection,
  shimGetUserMedia: require('./getusermedia'),
  attachMediaStream: edgeShim.attachMediaStream,
  reattachMediaStream: edgeShim.reattachMediaStream
};

},{"../utils":707,"./getusermedia":703,"sdp":678}],703:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */
'use strict';

// Expose public methods.
module.exports = function() {
  var shimError_ = function(e) {
    return {
      name: {PermissionDeniedError: 'NotAllowedError'}[e.name] || e.name,
      message: e.message,
      constraint: e.constraint,
      toString: function() {
        return this.name;
      }
    };
  };

  // getUserMedia error shim.
  var origGetUserMedia = navigator.mediaDevices.getUserMedia.
      bind(navigator.mediaDevices);
  navigator.mediaDevices.getUserMedia = function(c) {
    return origGetUserMedia(c).catch(function(e) {
      return Promise.reject(shimError_(e));
    });
  };
};

},{}],704:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */
'use strict';

var logging = require('../utils').log;
var browserDetails = require('../utils').browserDetails;

var firefoxShim = {
  shimOnTrack: function() {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
            this.removeEventListener('addstream', this._ontrackpoly);
          }
          this.addEventListener('track', this._ontrack = f);
          this.addEventListener('addstream', this._ontrackpoly = function(e) {
            e.stream.getTracks().forEach(function(track) {
              var event = new Event('track');
              event.track = track;
              event.receiver = {track: track};
              event.streams = [e.stream];
              this.dispatchEvent(event);
            }.bind(this));
          }.bind(this));
        }
      });
    }
  },

  shimSourceObject: function() {
    // Firefox has supported mozSrcObject since FF22, unprefixed in 42.
    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        // Shim the srcObject property, once, when HTMLMediaElement is found.
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this.mozSrcObject;
          },
          set: function(stream) {
            this.mozSrcObject = stream;
          }
        });
      }
    }
  },

  shimPeerConnection: function() {
    if (typeof window !== 'object' || !(window.RTCPeerConnection ||
        window.mozRTCPeerConnection)) {
      return; // probably media.peerconnection.enabled=false in about:config
    }
    // The RTCPeerConnection object.
    if (!window.RTCPeerConnection) {
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        if (browserDetails.version < 38) {
          // .urls is not supported in FF < 38.
          // create RTCIceServers with a single url.
          if (pcConfig && pcConfig.iceServers) {
            var newIceServers = [];
            for (var i = 0; i < pcConfig.iceServers.length; i++) {
              var server = pcConfig.iceServers[i];
              if (server.hasOwnProperty('urls')) {
                for (var j = 0; j < server.urls.length; j++) {
                  var newServer = {
                    url: server.urls[j]
                  };
                  if (server.urls[j].indexOf('turn') === 0) {
                    newServer.username = server.username;
                    newServer.credential = server.credential;
                  }
                  newIceServers.push(newServer);
                }
              } else {
                newIceServers.push(pcConfig.iceServers[i]);
              }
            }
            pcConfig.iceServers = newIceServers;
          }
        }
        return new mozRTCPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype = mozRTCPeerConnection.prototype;

      // wrap static methods. Currently just generateCertificate.
      if (mozRTCPeerConnection.generateCertificate) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function() {
            return mozRTCPeerConnection.generateCertificate;
          }
        });
      }

      window.RTCSessionDescription = mozRTCSessionDescription;
      window.RTCIceCandidate = mozRTCIceCandidate;
    }

    // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = RTCPeerConnection.prototype[method];
          RTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                RTCIceCandidate : RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });

    // support for addIceCandidate(null)
    var nativeAddIceCandidate =
        RTCPeerConnection.prototype.addIceCandidate;
    RTCPeerConnection.prototype.addIceCandidate = function() {
      return arguments[0] === null ? Promise.resolve()
          : nativeAddIceCandidate.apply(this, arguments);
    };

    // shim getStats with maplike support
    var makeMapStats = function(stats) {
      var map = new Map();
      Object.keys(stats).forEach(function(key) {
        map.set(key, stats[key]);
        map[key] = stats[key];
      });
      return map;
    };

    var nativeGetStats = RTCPeerConnection.prototype.getStats;
    RTCPeerConnection.prototype.getStats = function(selector, onSucc, onErr) {
      return nativeGetStats.apply(this, [selector || null])
        .then(function(stats) {
          return makeMapStats(stats);
        })
        .then(onSucc, onErr);
    };
  },

  // Attach a media stream to an element.
  attachMediaStream: function(element, stream) {
    logging('DEPRECATED, attachMediaStream will soon be removed.');
    element.srcObject = stream;
  },

  reattachMediaStream: function(to, from) {
    logging('DEPRECATED, reattachMediaStream will soon be removed.');
    to.srcObject = from.srcObject;
  }
};

// Expose public methods.
module.exports = {
  shimOnTrack: firefoxShim.shimOnTrack,
  shimSourceObject: firefoxShim.shimSourceObject,
  shimPeerConnection: firefoxShim.shimPeerConnection,
  shimGetUserMedia: require('./getusermedia'),
  attachMediaStream: firefoxShim.attachMediaStream,
  reattachMediaStream: firefoxShim.reattachMediaStream
};

},{"../utils":707,"./getusermedia":705}],705:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */
'use strict';

var logging = require('../utils').log;
var browserDetails = require('../utils').browserDetails;

// Expose public methods.
module.exports = function() {
  var shimError_ = function(e) {
    return {
      name: {
        SecurityError: 'NotAllowedError',
        PermissionDeniedError: 'NotAllowedError'
      }[e.name] || e.name,
      message: {
        'The operation is insecure.': 'The request is not allowed by the ' +
        'user agent or the platform in the current context.'
      }[e.message] || e.message,
      constraint: e.constraint,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  // getUserMedia constraints shim.
  var getUserMedia_ = function(constraints, onSuccess, onError) {
    var constraintsToFF37_ = function(c) {
      if (typeof c !== 'object' || c.require) {
        return c;
      }
      var require = [];
      Object.keys(c).forEach(function(key) {
        if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
          return;
        }
        var r = c[key] = (typeof c[key] === 'object') ?
            c[key] : {ideal: c[key]};
        if (r.min !== undefined ||
            r.max !== undefined || r.exact !== undefined) {
          require.push(key);
        }
        if (r.exact !== undefined) {
          if (typeof r.exact === 'number') {
            r. min = r.max = r.exact;
          } else {
            c[key] = r.exact;
          }
          delete r.exact;
        }
        if (r.ideal !== undefined) {
          c.advanced = c.advanced || [];
          var oc = {};
          if (typeof r.ideal === 'number') {
            oc[key] = {min: r.ideal, max: r.ideal};
          } else {
            oc[key] = r.ideal;
          }
          c.advanced.push(oc);
          delete r.ideal;
          if (!Object.keys(r).length) {
            delete c[key];
          }
        }
      });
      if (require.length) {
        c.require = require;
      }
      return c;
    };
    constraints = JSON.parse(JSON.stringify(constraints));
    if (browserDetails.version < 38) {
      logging('spec: ' + JSON.stringify(constraints));
      if (constraints.audio) {
        constraints.audio = constraintsToFF37_(constraints.audio);
      }
      if (constraints.video) {
        constraints.video = constraintsToFF37_(constraints.video);
      }
      logging('ff37: ' + JSON.stringify(constraints));
    }
    return navigator.mozGetUserMedia(constraints, onSuccess, function(e) {
      onError(shimError_(e));
    });
  };

  // Returns the result of getUserMedia as a Promise.
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      getUserMedia_(constraints, resolve, reject);
    });
  };

  // Shim for mediaDevices on older versions.
  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {getUserMedia: getUserMediaPromise_,
      addEventListener: function() { },
      removeEventListener: function() { }
    };
  }
  navigator.mediaDevices.enumerateDevices =
      navigator.mediaDevices.enumerateDevices || function() {
        return new Promise(function(resolve) {
          var infos = [
            {kind: 'audioinput', deviceId: 'default', label: '', groupId: ''},
            {kind: 'videoinput', deviceId: 'default', label: '', groupId: ''}
          ];
          resolve(infos);
        });
      };

  if (browserDetails.version < 41) {
    // Work around http://bugzil.la/1169665
    var orgEnumerateDevices =
        navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices);
    navigator.mediaDevices.enumerateDevices = function() {
      return orgEnumerateDevices().then(undefined, function(e) {
        if (e.name === 'NotFoundError') {
          return [];
        }
        throw e;
      });
    };
  }
  if (browserDetails.version < 49) {
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      return origGetUserMedia(c).catch(function(e) {
        return Promise.reject(shimError_(e));
      });
    };
  }
  navigator.getUserMedia = function(constraints, onSuccess, onError) {
    if (browserDetails.version < 44) {
      return getUserMedia_(constraints, onSuccess, onError);
    }
    // Replace Firefox 44+'s deprecation warning with unprefixed version.
    console.warn('navigator.getUserMedia has been replaced by ' +
                 'navigator.mediaDevices.getUserMedia');
    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };
};

},{"../utils":707}],706:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
'use strict';
var safariShim = {
  // TODO: DrAlex, should be here, double check against LayoutTests
  // shimOnTrack: function() { },

  // TODO: DrAlex
  // attachMediaStream: function(element, stream) { },
  // reattachMediaStream: function(to, from) { },

  // TODO: once the back-end for the mac port is done, add.
  // TODO: check for webkitGTK+
  // shimPeerConnection: function() { },

  shimGetUserMedia: function() {
    navigator.getUserMedia = navigator.webkitGetUserMedia;
  }
};

// Expose public methods.
module.exports = {
  shimGetUserMedia: safariShim.shimGetUserMedia
  // TODO
  // shimOnTrack: safariShim.shimOnTrack,
  // shimPeerConnection: safariShim.shimPeerConnection,
  // attachMediaStream: safariShim.attachMediaStream,
  // reattachMediaStream: safariShim.reattachMediaStream
};

},{}],707:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */
'use strict';

var logDisabled_ = true;

// Utility methods.
var utils = {
  disableLog: function(bool) {
    if (typeof bool !== 'boolean') {
      return new Error('Argument type: ' + typeof bool +
          '. Please use a boolean.');
    }
    logDisabled_ = bool;
    return (bool) ? 'adapter.js logging disabled' :
        'adapter.js logging enabled';
  },

  log: function() {
    if (typeof window === 'object') {
      if (logDisabled_) {
        return;
      }
      if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log.apply(console, arguments);
      }
    }
  },

  /**
   * Extract browser version out of the provided user agent string.
   *
   * @param {!string} uastring userAgent string.
   * @param {!string} expr Regular expression used as match criteria.
   * @param {!number} pos position in the version string to be returned.
   * @return {!number} browser version.
   */
  extractVersion: function(uastring, expr, pos) {
    var match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
  },

  /**
   * Browser detector.
   *
   * @return {object} result containing browser, version and minVersion
   *     properties.
   */
  detectBrowser: function() {
    // Returned result object.
    var result = {};
    result.browser = null;
    result.version = null;
    result.minVersion = null;

    // Fail early if it's not a browser
    if (typeof window === 'undefined' || !window.navigator) {
      result.browser = 'Not a browser.';
      return result;
    }

    // Firefox.
    if (navigator.mozGetUserMedia) {
      result.browser = 'firefox';
      result.version = this.extractVersion(navigator.userAgent,
          /Firefox\/([0-9]+)\./, 1);
      result.minVersion = 31;

    // all webkit-based browsers
    } else if (navigator.webkitGetUserMedia) {
      // Chrome, Chromium, Webview, Opera, all use the chrome shim for now
      if (window.webkitRTCPeerConnection) {
        result.browser = 'chrome';
        result.version = this.extractVersion(navigator.userAgent,
          /Chrom(e|ium)\/([0-9]+)\./, 2);
        result.minVersion = 38;

      // Safari or unknown webkit-based
      // for the time being Safari has support for MediaStreams but not webRTC
      } else {
        // Safari UA substrings of interest for reference:
        // - webkit version:           AppleWebKit/602.1.25 (also used in Op,Cr)
        // - safari UI version:        Version/9.0.3 (unique to Safari)
        // - safari UI webkit version: Safari/601.4.4 (also used in Op,Cr)
        //
        // if the webkit version and safari UI webkit versions are equals,
        // ... this is a stable version.
        //
        // only the internal webkit version is important today to know if
        // media streams are supported
        //
        if (navigator.userAgent.match(/Version\/(\d+).(\d+)/)) {
          result.browser = 'safari';
          result.version = this.extractVersion(navigator.userAgent,
            /AppleWebKit\/([0-9]+)\./, 1);
          result.minVersion = 602;

        // unknown webkit-based browser
        } else {
          result.browser = 'Unsupported webkit-based browser ' +
              'with GUM support but no WebRTC support.';
          return result;
        }
      }

    // Edge.
    } else if (navigator.mediaDevices &&
        navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
      result.browser = 'edge';
      result.version = this.extractVersion(navigator.userAgent,
          /Edge\/(\d+).(\d+)$/, 2);
      result.minVersion = 10547;

    // Default fallthrough: not supported.
    } else {
      result.browser = 'Not a supported browser.';
      return result;
    }

    // Warn if version is less than minVersion.
    if (result.version < result.minVersion) {
      utils.log('Browser: ' + result.browser + ' Version: ' + result.version +
          ' < minimum supported version: ' + result.minVersion +
          '\n some things might not work!');
    }

    return result;
  }
};

// Export.
module.exports = {
  log: utils.log,
  disableLog: utils.disableLog,
  browserDetails: utils.detectBrowser(),
  extractVersion: utils.extractVersion
};

},{}],708:[function(require,module,exports){
'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods = require('./methods.js');

var _methods2 = _interopRequireDefault(_methods);

var _select = require('./store/select.js');

var _select2 = _interopRequireDefault(_select);

var _localstorage = require('./store/localstorage.js');

var _localstorage2 = _interopRequireDefault(_localstorage);

var _object = require('./store/object.js');

var _object2 = _interopRequireDefault(_object);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.api = new function () {
    var _this = this;

    var store = (0, _select2.default)(new _localstorage2.default(), new _object2.default()),
        isConnected = true,
        tainted = false,
        hasQueue = function hasQueue() {
        if (!store.has('queue_barntrax')) {
            return false;
        }
        return window.user_id in store.get('queue_barntrax');
    },
        getQueue = function getQueue() {
        return store.get('queue_barntrax')[window.user_id || 0];
    },
        setQueue = function setQueue(queue) {
        if (store.has('queue_barntrax')) {
            var queues = store.get('queue_barntrax');
            queues[window.user_id || 0] = queue;
            store.set('queue_barntrax', queues);
        } else {
            store.set('queue_barntrax', (0, _defineProperty3.default)({}, window.user_id || 0, queue));
        }
    },
        disconnected = function disconnected() {
        if (!isConnected) return;
        isConnected = false;
        $('#callout-offline').fadeIn();
    },
        connected = function connected() {
        if (tainted && !getQueue().length) {
            tainted = false;
            if (confirm('The synchronization after your offline work has finished. ' + 'You might need to refresh the page to see changes. \n' + 'Do you want to refresh now?')) {
                window.location.reload();
            }
        }
        if (isConnected) return;
        isConnected = true;
        $('#callout-offline').fadeOut();
    },
        clearStore = function clearStore() {
        // we cannot erase the queue, because
        var queues = store.has('queue_barntrax') ? store.get('queue_barntrax') : {};
        var initialRegistration = store.has('initialRegistration') ? store.get('initialRegistration') : null;
        store.clear();
        store.set('queue_barntrax', queues);

        if (initialRegistration) {
            store.set('initialRegistration', initialRegistration);
        }
    },
        renderQueue = function renderQueue() {
        $('#callout-offline .item').remove();
        var queue = getQueue();
        if (queue.length) {
            $('#callout-offline .queue-title').show();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(queue), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    $('#callout-offline .queue').append($('<li class="item">' + item.title + '</li>'));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else {
            $('#callout-offline .queue-title').hide();
        }
    },
        enqueue = function enqueue(method, args, title) {
        // console.warn('Enqueued action method', method, args);
        tainted = true;
        var queue = getQueue();
        if (title instanceof Function) {
            title = title.apply(undefined, (0, _toConsumableArray3.default)(args));
        }
        queue.push({ method: method, arguments: args, title: title });
        setQueue(queue);
        renderQueue();
    },
        handleQueueItem = function handleQueueItem(method, args, title) {
        // console.info('Dequeue action method', method, args);
        methods[method].apply(this, args).catch(function (response) {
            if (!response.status) {
                // back into the queue if internet is diconnected again
                enqueue(method, args, title);
            }
        });
    },
        handleQueue = function handleQueue() {
        var queue = getQueue();
        if (!queue.length) return;
        setQueue([]);
        renderQueue();
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = (0, _getIterator3.default)(queue), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                handleQueueItem(item.method, item.arguments, item.title);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    },
        mkVerbAction = function mkVerbAction(verb) {
        return function () {
            var _Vue$http;

            return (_Vue$http = Vue.http)[verb].apply(_Vue$http, arguments).then(function (response) {
                return response.data;
            });
        };
    },
        methods = _methods2.default.apply(undefined, (0, _toConsumableArray3.default)(['get', 'post', 'put', 'delete'].map(mkVerbAction)));

    // clear data from another user
    // ideally, we should do this on logout
    if (store.get('__user_id') !== window.user_id) {
        clearStore();
        store.set('__user_id', window.user_id);
    }

    if (!hasQueue()) {
        setQueue([]);
    }
    if (getQueue().length) {
        tainted = true;
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        var _loop = function _loop() {
            var method = _step3.value;

            _this[method] = function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                var func = methods[method],
                    JSON = window.JSON;

                var isImport = ['importFile', 'importLedgersFile', 'importPedigree', 'addAttachment'].includes(method);

                if (args[0] && (0, _typeof3.default)(args[0]) === 'object' && args[0] !== null && !isImport) {
                    args[0] = (0, _extends3.default)({}, args[0], { timezone: timezone });
                }

                return func.apply(undefined, args).then(function (data) {
                    connected();
                    handleQueue();
                    return data;
                }, function (response) {
                    if (response.status) {
                        // Not an internet problem
                        connected();
                        handleQueue();
                        return _promise2.default.reject(response);
                    }
                    disconnected();
                    if (func.queued) {
                        enqueue(method, args, func.queued);
                    }
                    if ('default' in func) {
                        return JSON.parse(JSON.stringify(func.default instanceof Function ? func.default.apply(func, args) : func.default));
                    }
                    return _promise2.default.reject(response);
                });
            };
        };

        for (var _iterator3 = (0, _getIterator3.default)((0, _keys2.default)(methods)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
}();

},{"./methods.js":709,"./store/localstorage.js":710,"./store/object.js":711,"./store/select.js":712,"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/object/keys":27,"babel-runtime/core-js/promise":30,"babel-runtime/helpers/defineProperty":36,"babel-runtime/helpers/extends":37,"babel-runtime/helpers/toConsumableArray":41,"babel-runtime/helpers/typeof":42}],709:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (get, post, put, del) {
    var save = function save(base, model) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
        return model[key] ? put(base + '/' + model[key], model) : post(base, model);
    },

    /* By default, api methods queued */
    api = function api(func, options, default_) {
        func.queued = options && options.queued || false;
        if (typeof default_ !== 'undefined') {
            func.default = default_;
        }
        return func;
    },

    /* These methods are queued and retried when the internet connection is restored */
    queued = function queued(func, title, default_) {
        return api(func, { queued: title }, default_);
    };

    /**
     * Each queued function can specify queue item title as a string or a callback,
     * and each default value can be a value or a factory. For either parameter in case of
     * function they will receive the same arguments the method did when it failed.
     */

    return {
        subscribe: api(function (data, userId) {
            return post(userId ? '/admin/users/' + userId + '/subscribe' : '/subscription', data);
        }),

        addCancelDiscount: api(function (userId) {
            return post('/admin/users/' + userId + '/cancel-discount');
        }),

        offerDiscountBeforeCancellation: queued(function () {
            return get('subscription/offer-discount-before-cancellation');
        }),

        pauseSubscription: queued(function () {
            return get('/admin/pause-subscription');
        }),

        resumeSubscription: queued(function () {
            return get('/subscription/resume-subscription');
        }),

        getUserLoginLogs: queued(function (data, userId) {
            return get('/admin/users/' + userId + '/login-logs', data);
        }),

        validateReferrer: api(function (email) {
            return put('/admin/users/referrer/dry', { email: email });
        }),

        updateReferrer: api(function (email) {
            return put('/admin/users/referrer', { email: email });
        }),

        previewSubscription: queued(function (data, userId) {
            return post(userId ? '/admin/users/' + userId + '/subscribe/preview' : '/subscription/preview', data);
        }),

        unsubscribeData: api(function (data) {
            return get('/subscription/unsubscribe', data);
        }),

        unsubscribe: api(function (data) {
            return del('/subscription', data);
        }),

        getDeathReasons: queued(function () {
            return get('/admin/users/getDeathReasons');
        }),

        getUpcoming: queued(function () {
            return get('/admin/users/upcoming');
        }),

        getTransferBreeders: queued(function () {
            return get('/admin/transfers/breeders');
        }),

        getUsersPlans: queued(function () {
            return get('/admin/users/plans');
        }),

        getBreedersList: queued(function (query) {
            return get('/admin/breeders/getList', query || {});
        }),

        getBreedersListOpen: queued(function (query) {
            return get('/admin/breeders/list/open', query || {});
        }),

        getPrefixesList: queued(function () {
            return get('/admin/breeders/getPrefixesList');
        }),

        getLitters: queued(function (query) {
            return get('/admin/litters', query || {});
        }),

        getLitterKitsWeighOfType: queued(function (litter_id, type) {
            return get('/admin/litters/' + litter_id + '/weigh', { animal_type: type });
        }),
        getCageKitsWeighOfType: queued(function (cage_id, type) {
            return get('/admin/cages/' + cage_id + '/weigh', { animal_type: type });
        }),

        getKitsAutocomplete: queued(function () {
            return get('/admin/kits/autocomplete');
        }),

        getDummyEvents: queued(function (date) {
            return get('/admin/events/breedPlanDummyEvents', { date: date });
        }),
        getLitterDummyEvents: queued(function (date) {
            return get('/admin/events/litterPlanDummyEvents', { date: date });
        }),

        getPlanEvents: queued(function (plan_id) {
            return get('/admin/plans/' + plan_id + '/events');
        }),

        getEvent: queued(function (event_id) {
            return get('/admin/events/' + event_id);
        }),

        getEvents: queued(function (query) {
            return get('/admin/events', query || {});
        }),

        getPlans: queued(function (query) {
            return get('/admin/plans', query || {});
        }),
        getPlan: queued(function (id) {
            return get('/admin/plans/' + id);
        }),

        getPlansBreeders: queued(function () {
            return get('/admin/plans/breeders');
        }),

        getLittersList: queued(function (query) {
            return get('/admin/litters/getList', query || {});
        }),

        getTypeEvents: queued(function (type, id, query) {
            return get('/admin/' + type + (id ? '/' + id : '') + '/events', query || {});
        }),

        getBreeders: queued(function (query) {
            return get('/admin/breeders', query);
        }),

        getBreederCategories: queued(function () {
            return get('/admin/breeders/categories');
        }),

        getBreederCategoriesAutocomplete: queued(function () {
            return get('/admin/breeders/categories/autocomplete');
        }),

        getUserSettingsData: queued(function (user_id) {
            return get('/admin/users/' + user_id + '/settings/getData');
        }),

        getCurrentUserSettingsData: queued(function () {
            return get('/admin/users/settings/getDataCurrent');
        }),

        getReportsStatistics: queued(function (query) {
            return get('/admin/reports/statistics', query);
        }),
        getReportsDoes: queued(function (query) {
            return get('/admin/reports/does', query);
        }),
        getReportsBucks: queued(function (query) {
            return get('/admin/reports/bucks', query);
        }),
        // reports v2
        productionReport: queued(function (query) {
            return get('/admin/reports/production', query);
        }),
        getTopBreeders: queued(function (query) {
            return get('/admin/reports/top-breeders', query);
        }),
        getGestationDays: queued(function (query) {
            return get('/admin/reports/gestation-days', query);
        }),
        getDoeMisses: queued(function (query) {
            return get('/admin/reports/doe-misses', query);
        }),
        getBuckMisses: queued(function (query) {
            return get('/admin/reports/buck-misses', query);
        }),
        getLitterSize: queued(function (query) {
            return get('/admin/reports/litter-size', query);
        }),
        getDoeCosts: queued(function (query) {
            return get('/admin/reports/doe-costs', query);
        }),
        getSurvivalRates: queued(function (query) {
            return get('/admin/reports/survival-rates', query);
        }),
        getLiveAndDeadKits: queued(function (query) {
            return get('/admin/reports/live-and-dead-kits', query);
        }),
        getAverageKitsWeight: queued(function (query) {
            return get('/admin/reports/average-kits-weight', query);
        }),
        getLitterGrowthRate: queued(function (query) {
            return get('/admin/reports/litter-growth-rate', query);
        }),
        getMeatProduced: queued(function (query) {
            return get('/admin/reports/meat-produced', query);
        }),
        getButcherAge: queued(function (query) {
            return get('/admin/reports/butcher-age', query);
        }),
        getCauseOfDeath: queued(function (query) {
            return get('/admin/reports/cause-of-death', query);
        }),
        getBreederMortality: queued(function (query) {
            return get('/admin/reports/breeder-mortality', query);
        }),
        getKitMortality: queued(function (query) {
            return get('/admin/reports/kit-mortality', query);
        }),
        getInactiveBreeders: queued(function (query) {
            return get('/admin/reports/inactive-breeders', query);
        }),

        getBreederLitterReportsData: queued(function (breeder_id) {
            return get('/admin/reports/' + breeder_id + '/litter/production');
        }),
        getProfileReportsData: queued(function (query) {
            return get('/admin/reports/profile', query);
        }),
        getLitterProfileReportsData: queued(function (query) {
            return get('/admin/reports/litter-profile', query);
        }),

        getProfileStatistics: queued(function (query) {
            return get('/admin/reports/profile-statistics', query);
        }),
        getLitterProfileStatistics: queued(function (query) {
            return get('/admin/reports/litter-profile-statistics', query);
        }),
        getLitterProductionData: queued(function (query, litter_id) {
            return get('/admin/reports/litter/' + litter_id + '/production', query);
        }),

        getSignUpReport: queued(function (query) {
            return get('/admin/reports/sign-up', query);
        }),
        getCancelReasonsReport: queued(function (query) {
            return get('/admin/reports/cancel-reasons', query);
        }),

        getCancellationCount: queued(function (query) {
            return get('/admin/cancellation/get-count', query);
        }),

        marketingSourcesChart: queued(function (query) {
            return get('/admin/reports/marketing-sources-Chart', query);
        }),

        referralMethodTable: queued(function (query) {
            return get('/admin/reports/referral-method-table', query);
        }),

        userListReferralMethodTable: queued(function (query) {
            return get('/admin/reports/user-list-referral-method-table', query);
        }),

        getSignUpDeviceReporn: queued(function (query) {
            return get('/admin/reports/signup-device', query);
        }),

        getCohortaverageDaystoPayingReport: queued(function (query) {
            return get('/admin/reports/cohort-average-paying', query);
        }),

        getNewTrialReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/new-trials', query);
        }),
        getNewPayingReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/new-paying-users', query);
        }),
        getUpgradesUserReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/upgrades-users', query);
        }),
        getDowngradesUserReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/downgrades-users', query);
        }),
        getCanceledUserReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/canceled-users', query);
        }),
        getTotalPayingReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/total-paying-users', query);
        }),
        getChurnedUsersReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/churned-users', query);
        }),
        getChurnedUsersPercentageReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/churned-users-percentage', query);
        }),
        getReactivationUsersReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/reactivation', query);
        }),
        getMrrTotalReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/mrr-total', query);
        }),
        getNetNewCustomersReport: queued(function (query) {
            return get('/admin/mrr-subscriber-reports/net-new-customers', query);
        }),

        checkBreederId: queued(function (breeder_id, id) {
            return get('/admin/breeders/checkId', { breeder_id: breeder_id, id: id });
        }),

        checkBreedersLimit: queued(function (archived, userId) {
            return get(userId ? '/admin/users/' + userId + '/breeders/check' + (archived ? 'Archived' : '') + 'Limit' : '/admin/breeders/check' + (archived ? 'Archived' : '') + 'Limit');
        }, { ok: true }),

        getCages: queued(function (query) {
            return get('/admin/cages', query);
        }),
        getCageKits: queued(function (cage_id) {
            return get('admin/cages/' + cage_id + '/getKits');
        }),
        getKits: queued(function (query) {
            return get('/admin/kits', query);
        }),

        getKit: queued(function (id) {
            return get('/admin/kits/' + id);
        }),
        getKitBirthCertificateInfo: queued(function (id) {
            return get('/admin/birth-certificate/kit/' + id);
        }),

        getKitPedigree: queued(function (id, query) {
            return get('/admin/kits/' + id + '/getPedigree', query || {});
        }),

        getLedgerStatistics: queued(function (query) {
            return get('/admin/ledger/statistics', query || {});
        }),

        getLedgerCategories: queued(function () {
            return get('/admin/ledger/categories');
        }),

        getLedgerAutocomplete: queued(function () {
            return get('/admin/ledger/autocomplete');
        }),

        getLedgerEntries: queued(function (query) {
            return get('/admin/ledger/entries', query || {});
        }),

        getLedgerCategoriesAutocomplete: queued(function () {
            return get('/admin/ledger/categories/autocomplete');
        }),

        getLitterKits: queued(function (litter_id) {
            return get('admin/litters/' + litter_id + '/getKits');
        }),
        getLitterFosteredKits: queued(function (litter_id) {
            return get('admin/litters/' + litter_id + '/getFosteredKits');
        }),

        getLitterDied: queued(function (litter_id) {
            return get('admin/litters/' + litter_id + '/getDied');
        }),

        getLitter: queued(function (id) {
            return get('/admin/litters/' + id);
        }),

        getPedigree: queued(function (id) {
            return get('/admin/pedigrees/' + id);
        }),

        getBreederPedigree: queued(function (breeder_id, query) {
            return get('/admin/breeders/' + breeder_id + '/getPedigree', query || {});
        }),

        getBreeder: queued(function (id, query) {
            return get('/admin/breeders/' + id, query);
        }),

        getBreederLitters: queued(function (breeder_id, query) {
            return get('/admin/breeders/' + breeder_id + '/getLitters', query);
        }),

        getRolesList: queued(function () {
            return get('/admin/roles/getList');
        }),

        getSubUsers: queued(function (query) {
            return get('/admin/users/sub-users', query);
        }),
        inviteSubUser: queued(function (data) {
            return post('/admin/users/sub-users/invite', data);
        }),
        updateSubUser: queued(function (data) {
            return put('/admin/users/sub-users/invite/' + data.id, data);
        }),
        deleteSubUser: queued(function (data) {
            return del('/admin/users/sub-users/invite/' + data.id, data);
        }),
        getSubUserActivity: queued(function (data) {
            return get('/admin/users/sub-users/' + data.id + '/activity', data);
        }),

        getUserRoles: queued(function (query) {
            return get('/admin/roles/owned', query);
        }),
        addRole: queued(function (data) {
            return post('/admin/roles', data);
        }),
        editRole: queued(function (data) {
            return put('/admin/roles/' + data.id, data);
        }),
        deleteRole: queued(function (data) {
            return del('/admin/roles/' + data.id, data);
        }),

        getUser: queued(function (id) {
            return get('/admin/users/' + id);
        }),

        inAppPayments: queued(function (id) {
            return get('/admin/users/in-app/' + id);
        }),

        androidPayments: queued(function (id) {
            return get('/admin/users/android-payments/' + id);
        }),

        getUsers: queued(function (query) {
            return get('/admin/users', query || {}).then(function (data) {
                return data.users;
            });
        }),

        getUsersOverLimit: queued(function (query) {
            return get('/admin/users/over-limit', query || {}).then(function (data) {
                return data.data;
            });
        }),

        getSubscriptionInvoices: queued(function () {
            return get('subscription/invoices').then(function (data) {
                return data.invoices;
            });
        }),

        getSubscriptionPlans: queued(function () {
            var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            return get('subscription/plans/' + all).then(function (data) {
                return data.plans;
            });
        }),

        getSubscription: queued(function () {
            return get('subscription');
        }),

        verifyCoupon: queued(function (data) {
            return post('subscription/coupon/verify', data);
        }),

        getUsersDashboard: queued(function () {
            return get('/admin/users/dashboard');
        }),

        getUserReferrals: queued(function () {
            return get('/admin/users/referrals');
        }),

        refundUserInvoice: queued(function (id, data) {
            return post('admin/users/' + id + '/refund-invoice', data);
        }),

        getUserInvoices: queued(function (id) {
            return get('admin/users/' + id + '/invoices');
        }),

        saveLedgerEntry: queued(function (entry) {
            return save('/admin/ledger/entries', entry);
        }, function (entry) {
            return (entry.id ? 'Edit' : 'Add') + ' ledger item "' + entry.name + '" (' + (entry.debit ? '+' : '-') + '$' + entry.amount + ')';
        }, function (entry) {
            return entry;
        }),

        deleteLedgerEntry: queued(function (entry) {
            return del('/admin/ledger/entries/' + entry.id);
        }, function (entry) {
            return 'Delete ledger item "' + entry.name + '"';
        }, []),

        archiveLedgerEntry: queued(function (entry) {
            return post('/admin/ledger/entries/' + entry.id + '/archive', { archived: 1 });
        }, function (entry) {
            return 'Archive ledger item "' + entry.name + '"';
        }, []),

        unarchiveLedgerEntry: queued(function (entry) {
            return post('/admin/ledger/entries/' + entry.id + '/unarchive', { archived: 0 });
        }, function (entry) {
            return 'Unarchive ledger item "' + entry.name + '"';
        }, []),

        saveLedgerCategory: queued(function (category) {
            return save('/admin/ledger/categories', category);
        }, function (category) {
            return (category.id ? 'Edit' : 'Add') + ' ledger category "' + category.name + '"';
        }, function (category) {
            return category;
        }),

        deleteLedgerCategory: queued(function (category) {
            return del('/admin/ledger/categories/' + category.id);
        }, function (category) {
            return 'Delete ledger category "' + category.name;
        }, []),

        getFarms: queued(function (data) {
            return get('/admin/farms', data);
        }),
        getFarmsList: queued(function (data) {
            return get('/admin/farms/list', data);
        }),
        addFarm: queued(function (data) {
            return post('/admin/farms', data);
        }),
        editFarm: queued(function (data) {
            return put('/admin/farms/' + data.id, data);
        }),
        deleteFarm: queued(function (data) {
            return del('/admin/farms/' + data.id, data);
        }),

        getAttachments: queued(function (query) {
            return get('/admin/attachments', query || {});
        }),

        getAllAttachments: queued(function (query) {
            return get('/admin/attachments/all', query || {});
        }),

        addAttachment: queued(function (data, file) {
            var formData = new FormData();
            for (var prop in data) {
                formData.append(prop, data[prop] || '');
            }
            if (file) {
                formData.append('file', file);
            }

            return post('/admin/attachments', formData);
        }, function (attachment) {
            return (attachment.id ? 'Edit' : 'Add') + ' attachments #' + attachment.id;
        }, []),

        updateAttachment: queued(function (id, data) {
            return put('/admin/attachments/' + id, data);
        }, 'Update attachment', []),

        getAttachmentUrl: queued(function (id, data) {
            return get('/admin/attachments/' + id + '/url', data);
        }, 'Get attachment Url', []),

        deleteAttachment: queued(function (attachment) {
            return del('/admin/attachments/' + attachment.id);
        }, function (entry) {
            return 'Delete attachment "' + entry.filename + '"';
        }, []),

        saveBreederCategory: queued(function (category) {
            return save('/admin/breeders/categories', category);
        }, function (category) {
            return (category.id ? 'Edit' : 'Add') + ' breeders category "' + category.name + '"';
        }, function (category) {
            return category;
        }),

        saveBreederImage: queued(function (id, data) {
            return put('/admin/breeders/' + id + '/image', data);
        }, 'Update breeder image', []),

        deleteBreederCategory: queued(function (category) {
            return del('/admin/breeders/categories/' + category.id);
        }, function (category) {
            return 'Delete ledger category "' + category.name;
        }, []),

        missBirth: queued(function (birth) {
            return post('/admin/plans/' + birth.breedplan + '/missed');
        }, 'Miss a birth', []),

        undoMissedPlan: queued(function (id) {
            return post('/admin/plans/' + id + '/undo-missed');
        }, 'Undo missed plan', []),

        recordBirth: queued(function (birth) {
            return post('/admin/litters', birth);
        }, 'Record a birth', []),

        saveKit: queued(function (kit) {
            return save('/admin/kits', kit);
        }, function (kit) {
            return (kit.id ? 'Edit' : 'Add') + ' rabbit kit #' + kit.given_id;
        }, function (kit) {
            return kit;
        }),

        deleteKit: queued(function (kit) {
            return del('/admin/kits/' + kit.id);
        }, function (kit) {
            return 'Delete rabbit kit #' + kit.given_id;
        }, []),

        archiveKit: queued(function (kit) {
            return post('/admin/kits/' + kit.id + '/archive', { archived: 1 });
        }, function (kit) {
            return 'Archive rabbit kit #' + kit.given_id;
        }, []),

        unarchiveKit: queued(function (kit) {
            return post('/admin/kits/' + kit.id + '/archive', { archived: 0 });
        }, function (kit) {
            return 'Unarchive kit #' + kit.given_id;
        }, []),

        cullKit: queued(function (kit) {
            return post('/admin/kits/' + kit.id + '/cull', { culled: 1 });
        }, function (kit) {
            return 'Cull rabbit kit #' + kit.given_id;
        }, []),

        uncullKit: queued(function (kit) {
            return post('/admin/kits/' + kit.id + '/cull', { culled: 0 });
        }, function (kit) {
            return 'Uncull kit #' + kit.given_id;
        }, []),

        sellKit: queued(function (kit, value) {
            return post('/admin/kits/' + kit.id + '/sold', { sold: 1, value: value });
        }, function (kit, value) {
            return 'Sell kit #' + kit.given_id + ' for $' + value;
        }, []),

        unsellKit: queued(function (kit) {
            return post('/admin/kits/' + kit.id + '/sold', { sold: 0 });
        }, function (kit) {
            return 'Undo sell kit #' + kit.given_id;
        }, []),

        transferKit: queued(function (kit, email) {
            return post('/admin/kits/' + kit.id + '/transfer', { email: email });
        }, function (kit, email) {
            return 'Transfer kit #' + kit.given_id + ' to &lt;' + email + '&gt;';
        }, []),

        verifyTransferableKit: queued(function (kit, email) {
            return post('/admin/kits/' + kit.id + '/transfer/check', { email: email });
        }, function (kit, email) {
            return 'Verify transfer kit #' + kit.given_id + ' to &lt;' + email + '&gt;';
        }, []),

        dieKit: queued(function (kit, query) {
            return get('/admin/kits/' + kit.id + '/died', query);
        }, function (kit) {
            return 'Mark kit #' + kit.given_id + ' as dead';
        }, []),

        reviveKit: queued(function (kit) {
            return post('/admin/kits/' + kit.id + '/revived');
        }, function (kit) {
            return 'Remove died mark from kit #' + kit.given_id;
        }, []),

        makeBreeder: queued(function (kit) {
            return get('/admin/kits/' + kit.id + '/makeBreeder');
        }, function (kit) {
            return 'Create a breeder from kit #' + kit.given_id;
        }, []),

        undoBreeder: queued(function (kit) {
            return get('/admin/kits/' + kit.id + '/undoBreeder');
        }, function (kit) {
            return 'Undo breeder upgrade for kit #' + kit.given_id;
        }, []),

        saveBreeder: queued(function (breeder) {
            return save('/admin/breeders', breeder);
        }, function (breeder) {
            return (breeder.id ? 'Edit' : 'Add') + ' breeder "' + breeder.name + '"';
        }, function (breeder) {
            return breeder;
        }),

        saveBreeders: queued(function (breeders, fields, emptyBreeder) {
            return post('/admin/breeders/bulk', { breeders: breeders, fields: fields, emptyBreeder: emptyBreeder });
        }, 'Save breeders', []),

        saveLedgers: queued(function (ledgers, emptyLedger) {
            return post('/admin/ledgers/bulk', { ledgers: ledgers, emptyLedger: emptyLedger });
        }, 'Save ledgers', []),

        save: queued(function (breeders, fields, emptyBreeder) {
            return post('/admin/breeders/bulk', { breeders: breeders, fields: fields, emptyBreeder: emptyBreeder });
        }, 'Save breeders', []),
        archiveBreeder: queued(function (breeder) {
            return post('/admin/breeders/' + breeder.id + '/archive', { archived: 1 });
        }, function (breeder) {
            return 'Archive breeder "' + breeder.name + '"';
        }, []),

        unarchiveBreeder: queued(function (breeder) {
            return post('/admin/breeders/' + breeder.id + '/archive', { archived: 0 });
        }, function (breeder) {
            return 'Unarchive rabbit breeder "' + breeder.name + '"';
        }, []),

        cullBreeder: queued(function (breeder) {
            return post('/admin/breeders/' + breeder.id + '/cull', { culled: 1 });
        }, function (breeder) {
            return 'Cull breeder "' + breeder.name + '"';
        }, []),

        uncullBreeder: queued(function (breeder) {
            return post('/admin/breeders/' + breeder.id + '/cull', { culled: 0 });
        }, function (breeder) {
            return 'Uncull rabbit breeder "' + breeder.name + '"';
        }, []),

        addToCullListBreeder: queued(function (breeder) {
            return post('/admin/breeders/' + breeder.id + '/to-cull', { to_cull: 1, date: breeder.to_cull_date });
        }, function (breeder) {
            return 'Add breeder to cull list: "' + breeder.name + '"';
        }, []),
        removeFromCullListBreeder: queued(function (breeder) {
            return post('/admin/breeders/' + breeder.id + '/to-cull', { to_cull: 0, date: breeder.to_cull_date });
        }, function (breeder) {
            return 'Remove breeder from cull list: "' + breeder.name + '"';
        }, []),

        postMarketplaceProfile: queued(function (data) {
            return post('admin/marketplace-profiles', data);
        }, function (data) {
            return 'Create marketplace profile"';
        }, []),

        getMarketplaceListings: queued(function (query) {
            return get('/admin/marketplace-listings', query);
        }),

        getMarketplaceListing: queued(function (query) {
            return get('/admin/marketplace-listings/' + query.id, query);
        }),

        markAsSold: queued(function (animal) {
            return post('admin/marketplace-listings/' + animal.id + '/sold', animal);
        }, function (animal) {
            return 'Mark animal as sold ';
        }, []),

        markAsInactiveListing: queued(function (animal) {
            return post('admin/marketplace-listings/' + animal.id + '/status', animal);
        }, function (animal) {
            return 'Mark animal as inactive';
        }, []),

        markForSale: queued(function (animal) {
            return post('admin/marketplace-listings', animal);
        }, function (animal) {
            return 'Mark animal for sale "' + animal.name + '" for $' + animal.amount;
        }, []),

        removeForSale: queued(function (animal) {
            return del('admin/marketplace-listings/' + animal.id);
        }, function (animal) {
            return 'Remove animal for sale';
        }, []),

        sellBreeder: queued(function (breeder, data) {
            return post('/admin/breeders/' + breeder.id + '/sold', (0, _extends3.default)({ sold: 1 }, data));
        }, function (breeder, data) {
            return 'Sell breeder "' + breeder.name + '" for $' + data.value;
        }, []),

        unsellBreeder: queued(function (breeder) {
            return post('/admin/breeders/' + breeder.id + '/sold', { sold: 0 });
        }, function (breeder) {
            return 'Undo sell breeder "' + breeder.name + '"';
        }, []),

        transferBreeder: queued(function (breeder, email) {
            return post('/admin/breeders/' + breeder.id + '/transfer', { email: email });
        }, function (breeder, email) {
            return 'Transfer breeder "' + breeder.name + '" to &lt;' + email + '&gt;';
        }, []),

        verifyTransferableBreeder: queued(function (breeder, email) {
            return post('/admin/breeders/' + breeder.id + '/transfer/check', { email: email });
        }, function (breeder, email) {
            return 'Transfer breeder "' + breeder.name + '" to &lt;' + email + '&gt;';
        }, []),

        deleteBreeder: queued(function (breeder) {
            return del('/admin/breeders/' + breeder.id);
        }, function (breeder) {
            return 'Delete breeder "' + breeder.name + '"';
        }, []),

        savePedigree: queued(function (pedigree) {
            return save('/admin/pedigrees', pedigree);
        }, function (pedigree) {
            return (pedigree.id ? 'Edit' : 'Add') + ' pedigree record "' + pedigree.name + '"';
        }, []),

        savePlan: queued(function (plan) {
            return save(plan.id ? '/admin/plans' : '/admin/events/makeBreedPlan', plan);
        }, function (plan) {
            return (plan.id ? 'Edit' : 'Add') + ' breeding plan';
        }, function (plan) {
            return plan;
        }),

        deletePlan: queued(function (plan) {
            return del('/admin/plans/' + plan.id);
        }, 'Delete a breeding plan', []),

        saveEvent: queued(function (event) {
            return save('/admin/events', event);
        }, function (event) {
            return (event.id ? 'Edit' : 'Add') + ' task';
        }, function (event) {
            return event;
        }),

        closeEvent: queued(function (event) {
            return get('/admin/events/' + event.id + '/close');
        }, 'Close task', []),

        reopenEvent: queued(function (event) {
            return get('/admin/events/' + event.id + '/reopen');
        }, 'Reopen task', []),

        archiveEvent: queued(function (event) {
            return post('/admin/events/' + event.id + '/archive');
        }, 'Archive task', []),

        unarchiveEvent: queued(function (event) {
            return post('/admin/events/' + event.id + '/unarchive');
        }, 'Unarchive task', []),

        deleteEvent: queued(function (event) {
            return del('/admin/events/' + event.id);
        }, 'Delete task', []),

        pregnancyCheck: queued(function (data) {
            return post('/admin/events/' + data.event_id + '/pregnancy-check', data);
        }, 'Update pregnancy check task', []),

        archiveEvents: queued(function (events) {
            return post('/admin/events/archiveEvents', { events: events });
        }, function (events) {
            return 'Archive group of ' + events.length + ' tasks';
        }, []),

        updateCage: queued(function (cage) {
            return put('/admin/cages/' + cage.cage_id, cage);
        }, 'Update cage', []),

        updateMultipleCages: queued(function (cage) {
            return post('/admin/cages/multiple', cage);
        }, 'Update multiple cages', []),

        deleteMultipleCages: queued(function (cage) {
            return del('/admin/cages/multiple', cage);
        }, 'Delete multiple cages', []),

        updateMultipleKits: queued(function (kit) {
            return post('/admin/kits/multiple', kit);
        }, 'Update multiple kits', []),

        deleteMultipleKits: queued(function (kit) {
            return del('/admin/kits/multiple', kit);
        }, 'Delete multiple kits', []),

        updateMultipleLitters: queued(function (litter) {
            return post('/admin/litters/multiple', litter);
        }, 'Update multiple litters', []),

        deleteMultipleLitters: queued(function (litter) {
            return del('/admin/litters/multiple', litter);
        }, 'Delete multiple litters', []),

        updateMultipleBreeders: queued(function (breeder) {
            return post('/admin/breeders/multiple', breeder);
        }, 'Update multiple breeders', []),

        deleteMultipleBreeders: queued(function (breeder) {
            return del('/admin/breeders/multiple', breeder);
        }, 'Delete multiple breeders', []),

        archiveMultipleBreeders: queued(function (breeder) {
            return post('/admin/breeders/multiple/archive', breeder);
        }, 'Archive multiple breeders', []),

        cullMultipleBreeders: queued(function (breeder) {
            return post('/admin/breeders/multiple/cull', breeder);
        }, 'Cull multiple breeders', []),

        sellMultipleBreeders: queued(function (breeder) {
            return post('/admin/breeders/multiple/sell', breeder);
        }, 'Sell multiple breeders', []),

        transferMultipleBreeders: queued(function (breeder) {
            return post('/admin/breeders/multiple/transfer', breeder);
        }, 'Sell multiple breeders', []),

        checkTransferMultipleBreeders: queued(function (breeder) {
            return post('/admin/breeders/multiple/transfer/check', breeder);
        }, 'Sell multiple breeders', []),

        butcherMultipleBreeders: queued(function (breeder) {
            return post('/admin/breeders/multiple/butcher', breeder);
        }, 'Butcher multiple breeders', []),

        saveLitter: queued(function (litter) {
            return save('/admin/litters', litter);
        }, function (litter) {
            return (litter.id ? 'Edit' : 'Add') + ' litter #' + litter.id;
        }, []),

        archiveLitter: queued(function (litter) {
            return post('/admin/litters/' + litter.id + '/archive', { archived: 1 });
        }, function (litter) {
            return 'Archive litter #' + litter.id;
        }, []),

        unarchiveLitter: queued(function (litter) {
            return post('/admin/litters/' + litter.id + '/archive', { archived: 0 });
        }, function (litter) {
            return 'Unarchive litter #' + litter.id;
        }, []),

        deleteLitter: queued(function (litter) {
            return del('/admin/litters/' + litter.id);
        }, function (litter) {
            return 'Delete litter #' + litter.id;
        }, []),

        acceptTransfer: queued(function (transfer) {
            return get('/admin/transfer/' + (transfer.transfer_id || transfer.id));
        }, function (transfer) {
            return 'Accept transfer of breeder ' + (transfer.name ? '"' + transfer.name + '"' : '#' + transfer.tattoo);
        }, []),

        declineTransfer: queued(function (transfer) {
            return del('/admin/transfer/' + (transfer.transfer_id || transfer.id));
        }, function (transfer) {
            return 'Decline transfer of breeder ' + (transfer.name ? '"' + transfer.name + '"' : '#' + transfer.tattoo);
        }, []),

        saveUser: queued(function (user) {
            return save('/admin/users', user);
        }, function (user) {
            return (user.id ? 'Edit' : 'Add') + ' user "' + user.name + '"';
        }, function (user) {
            return user;
        }),

        deleteUser: queued(function (user) {
            return del('/admin/users/' + user.id);
        }, function (user) {
            return 'Delete user "' + user.name + '"';
        }, []),

        loginAsUser: queued(function (user_id) {
            return post('/admin/users/' + user_id + '/login-as-user');
        }),

        postLitterButcherValue: queued(function (litter_id, value) {
            return post('/admin/litters/' + litter_id + '/butcherValue', { value: value });
        }, function (litter_id, value) {
            return 'Butcher litter #' + litter_id + ' ($' + value + ')';
        }, []),

        postBreederButcherValue: queued(function (breeder_id, value) {
            return post('/admin/breeders/' + breeder_id + '/butcherValue', { value: value });
        }, function (breeder_id, value) {
            return 'Butcher breeder #' + breeder_id + ' ($' + value + ')';
        }, []),

        postBreederDeathReasonValue: queued(function (breeder_id, value) {
            return post('/admin/breeders/' + breeder_id + '/deathReasonValue', { value: value });
        }, function (breeder_id, value) {
            return 'Death reason breeder #' + breeder_id + ' ($' + value + ')';
        }, []),

        postKitDeathReasonValue: queued(function (kit_id, value) {
            return post('/admin/kits/' + kit_id + '/deathReasonValue', { value: value });
        }, function (kit_id, value) {
            return 'Death reason kit #' + kit_id + ' ($' + value + ')';
        }, []),

        addBreedChain: queued(function (name) {
            return post('/admin/chains', { name: name });
        }, function () {
            return 'Add breed chain';
        }, []),
        addLitterChain: queued(function (name) {
            return post('/admin/chains', { name: name, type: 'litter' });
        }, function () {
            return 'Add litter chain';
        }, []),
        addTreatmentChain: queued(function (name) {
            return post('/admin/chains', { name: name, type: 'treatment' });
        }, function () {
            return 'Add treatment chain';
        }, []),

        updateBreedChain: queued(function (id, name) {
            var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return put('/admin/chains/' + id, { name: name, data: data });
        }, function () {
            return 'Add breed chain';
        }, []),

        deleteBreedChain: queued(function (id) {
            return del('/admin/chains/' + id);
        }, function () {
            return 'Add breed chain';
        }, []),

        postUserSettings: queued(function (user_id, settings) {
            return post('/admin/users/' + user_id + '/settings', settings);
        }, function () {
            return 'Update user settings';
        }, []),

        postPedigreeSettings: queued(function (user_id, settings) {
            return post('/admin/users/' + user_id + '/pedigree/settings', settings);
        }, function () {
            return 'Update pedigree settings';
        }, []),

        postLitterWeigh: queued(function (litter, data) {
            return post('/admin/litters/' + litter.id + '/weigh', data);
        }, function (litter, data) {
            return 'Send litter weight';
        }, []),

        postEntireLitterWeigh: queued(function (litter, data) {
            return post('/admin/litters/' + litter.id + '/weigh/bulk', data);
        }, function (litter, data) {
            return 'Send bulk litter weight';
        }, []),

        postCageWeigh: queued(function (cage, data) {
            return post('/admin/cages/' + cage.id + '/weigh', data);
        }, function (cage, data) {
            return 'Send cage weight';
        }, []),

        postEntireCageWeigh: queued(function (cage, data) {
            return post('/admin/cages/' + cage.id + '/weigh/bulk', data);
        }, function (cage, data) {
            return 'Send bulk cage weight';
        }, []),

        postLitterSell: queued(function (litter, data) {
            return post('/admin/litters/' + litter.id + '/sell', data);
        }, function (litter, data) {
            return 'Send litter sell';
        }, []),

        postCageSell: queued(function (cage, data) {
            return post('/admin/cages/' + cage.id + '/sell', data);
        }, function (cage, data) {
            return 'Send cage sell';
        }, []),

        archiveCage: queued(function (data) {
            return post('/admin/cages/archive', data);
        }, function (data) {
            return 'Archive cage #' + data.cage_id;
        }, []),

        cullCage: queued(function (data) {
            return post('/admin/cages/cull', data);
        }, function (data) {
            return 'Cull cage #' + data.cage_id;
        }, []),

        diedCage: queued(function (data) {
            return post('/admin/cages/dead', data);
        }, function (data) {
            return 'Mark kits as dead in cage #' + data.cage_id;
        }, []),

        breedCage: queued(function (data) {
            return post('/admin/cages/breeders', data);
        }, function (data) {
            return 'Mark kits as breeders in cage #' + data.cage_id;
        }, []),

        butcherKits: queued(function (data) {
            return post('/admin/kits/butch', data);
        }, function (data) {
            return 'Butcher litter #' + data.litter_id;
        }, []),

        undoButcheredKits: queued(function (litter, data) {
            return post('/admin/kits/butch/undo/' + litter.id, data);
        }, function (data) {
            return 'Undo Butcher litter #' + data.litter_id;
        }, []),

        butcherBreeder: queued(function (breeder, data) {
            return post('/admin/breeders/' + breeder.id + '/butch', data);
        }, function (data) {
            return 'Butcher Breeder #' + data.breeder_id;
        }, []),

        diedBreeder: queued(function (breeder, data) {
            return post('/admin/breeders/' + breeder.id + '/died', data);
        }, function (data) {
            return 'Died Breeder #' + data.breeder_id;
        }, []),

        emailPedigreePdf: queued(function (data) {
            return post('/admin/breeders/' + data.id + '/pdf/email', data);
        }, function (data) {
            return 'Send Pedigree (email) #' + data.id;
        }, []),

        addReferral: queued(function (email) {
            return post('/admin/users/referrals', { email: email });
        }, function (email) {
            return 'Add &lt;' + email + '&gt; as your referral';
        }, []),

        getOptionsForCopyPedigree: queued(function (type, id) {
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return get('/admin/pedigrees/copy/options', (0, _assign2.default)({ type: type, exclude: id }, params)).then(function (data) {
                return data.options;
            });
        }),

        copyPedigree: queued(function (type, from, to, line) {
            return post('/admin/pedigrees/copy', { type: type, from: from, to: to, line: line });
        }, function (type, from, to) {
            return 'Copy pedigree';
        }, []),

        saveImportedPedigree: queued(function (breeder_id, generations) {
            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'breeder';
            return post('/admin/pedigrees/saveImported', { breeder_id: breeder_id, generations: generations, type: type });
        }, function (breeder_id, generations) {
            return 'Save imported pedigree';
        }, []),

        findPedigrees: queued(function (query) {
            return get('/admin/pedigrees/find', query);
        }),

        getNextLitterId: queued(function (query) {
            return get('/admin/users/nextLitterId/', query);
        }),

        getUserSocialAccounts: queued(function () {
            return get('/admin/user/socials').then(function (data) {
                return data.social_accounts;
            });
        }),

        disconnectSocial: queued(function (social_id) {
            return del('/admin/user/socials/' + social_id);
        }, function () {
            return 'Disconnect social account';
        }),

        importFile: queued(function (file) {
            var data = new FormData();
            data.append('import', file);
            return post('/admin/import', data);
        }, function () {
            return 'Upload file for import';
        }),

        importLedgersFile: queued(function (file) {
            var data = new FormData();
            data.append('import', file);
            return post('/admin/import/ledgers', data);
        }, function () {
            return 'Upload file for import';
        }),

        importPedigree: queued(function (breederId, file, url) {
            var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'breeder';
            var ocr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

            var data = new FormData();
            data.append('breeder_id', breederId);
            data.append('import', file);
            data.append('url', url);
            data.append('type', type);
            data.append('ocr', ocr);
            return post('/admin/import/pedigree', data);
        }, function () {
            return 'Upload file for import';
        }),

        saveWebPushEndpoint: queued(function (endpoint, resetCreds, publicKey, authToken) {
            return post('/admin/user/web-push-endpoint', {
                endpoint: endpoint, 'reset-creds': resetCreds, publicKey: publicKey, authToken: authToken
            });
        }, function () {
            return 'Subscribe to notifications';
        }),

        requestTestNotification: queued(function () {
            return post('/admin/user/request-test-notification');
        }, function () {
            return 'Request test notification';
        }),

        /**
         * Cage card templates routes.
         */
        // Get list of all templates.
        getCageCardsTemplates: queued(function (query) {
            return get('/admin/cage-cards/templates', query);
        }),

        getCageCardTemplateFieldsOptionsList: queued(function (query) {
            return get('/admin/cage-cards/fields-list');
        }),

        // Delete template.
        deleteCageCardTemplate: queued(function (template) {
            return del('/admin/cage-cards/templates/' + template.id);
        }, function (template) {
            return 'Delete template "' + template.name + '"';
        }, []),

        // Delete template.
        copyCageCardTemplate: queued(function (template) {
            return post('/admin/cage-cards/templates/' + template.id + '/copy');
        }, function (template) {
            return 'Copy template "' + template.name + '"';
        }, []),

        // Store cage card template.
        storeCageCardTemplate: queued(function (template) {
            return save('/admin/cage-cards/templates', template);
        }, function (template) {
            return 'Add template "' + template.name + '"';
        }, function (template) {
            return template;
        }),

        // Update cage card template.
        updateCageCardTemplate: queued(function (template) {
            return save('/admin/cage-cards/templates', template);
        }, function (template) {
            return 'Edit template "' + template.name + '"';
        }, function (template) {
            return template;
        }),

        // Get first entities for preview (breeder and litter).
        getFirstEntitiesForPreview: queued(function (query) {
            return get('/admin/cage-cards/first-entities', query);
        }),

        // Get list of user's breeders.
        getCageCardBreedersList: queued(function (query) {
            return get('/admin/cage-cards/breeders', query);
        }),

        // Get list of user's litters.
        getCageCardLittersList: queued(function (query) {
            return get('/admin/cage-cards/litters', query);
        }),

        // Print batch.
        printBatch: queued(function (query) {
            return post('/admin/cage-cards/print-batch', query);
        }),

        /**
         * Finances - Contacts
         */

        // Fetch all contacts
        getContacts: queued(function (query) {
            return get('/admin/finances/contacts', query);
        }),

        // Create a contact
        storeContact: queued(function (contact) {
            return post('/admin/finances/contacts', contact);
        }, function (contact) {
            return 'Add contact "' + contact.name + '"';
        }, function (contact) {
            return contact;
        }),

        // Update a contact
        updateContact: queued(function (contact) {
            return put('/admin/finances/contacts/' + contact.id, contact);
        }, function (contact) {
            return 'Edit contact "' + contact.name + '"';
        }, function (contact) {
            return contact;
        }),

        // Delete a contact
        deleteContact: queued(function (contact) {
            return del('/admin/finances/contacts/' + contact.id);
        }, function (contact) {
            return 'Delete contact "' + contact.name + '"';
        }, []),

        /**
         * Health Tracker
         */
        // ailments
        getAilments: queued(function (query) {
            return get('/admin/ailments', query);
        }),
        getAilment: queued(function (query) {
            return get('/admin/ailments/' + query.id, query);
        }),
        storeAilment: queued(function (query) {
            return post('/admin/ailments', query);
        }),
        updateAilment: queued(function (query) {
            return put('/admin/ailments/' + query.id, query);
        }),
        deleteAilment: queued(function (query) {
            return del('/admin/ailments/' + query.id);
        }),
        // treatments
        getTreatments: queued(function (query) {
            return get('/admin/treatments', query);
        }),
        getTreatment: queued(function (query) {
            return get('/admin/treatments/' + query.id, query);
        }),
        storeTreatment: queued(function (query) {
            return post('/admin/treatments', query);
        }),
        updateTreatment: queued(function (query) {
            return put('/admin/treatments/' + query.id, query);
        }),
        deleteTreatment: queued(function (query) {
            return del('/admin/treatments/' + query.id);
        }),

        /**
         * Feature Flagging
         */

        // Fetch all features
        getFeatures: queued(function (query) {
            return get('/admin/features', query);
        }),
        getFeatureFeedbacks: queued(function (query) {
            return get('/admin/features/' + query.id + '/feedbacks', query);
        }),
        checkFeatures: queued(function (query) {
            return get('/admin/features/check', query);
        }),

        // Fetch a single feature
        getFeature: queued(function (query) {
            return get('/admin/features/' + query.id, query);
        }),

        // Fetch all users under a feature
        fetchFeatureUsers: queued(function (params) {
            return get('/admin/features/' + params.id + '/users', params);
        }),

        // Remove users under a feature
        removeFeatureUsers: queued(function (params) {
            return post('/admin/features/' + params.id + '/users/remove', params);
        }),

        // Create a feature
        storeFeature: queued(function (feature) {
            return post('/admin/features', feature);
        }, function (feature) {
            return 'Add feature "' + feature.key + '"';
        }, function (feature) {
            return feature;
        }),
        storeFeatureFeedbacks: queued(function (params) {
            return post('/admin/features/' + params.id + '/feedbacks', params);
        }),

        // Update a feature
        updateFeature: queued(function (feature) {
            return put('/admin/features/' + feature.id, feature);
        }, function (feature) {
            return 'Edit feature "' + feature.key + '"';
        }, function (feature) {
            return feature;
        }),

        // Opt in to a feature
        optInFeature: queued(function (feature) {
            return post('/admin/features/' + feature.id + '/opt-in', feature);
        }, function (feature) {
            return 'Opt in to feature "' + feature.key + '"';
        }, function (feature) {
            return feature;
        }),

        // Delete a feature
        deleteFeature: queued(function (feature) {
            return del('/admin/features/' + feature.id);
        }, function (feature) {
            return 'Delete feature "' + feature.key + '"';
        }, []),

        // Get breeder by id
        fetchBreeder: queued(function (id) {
            return get('/admin/fetchBreeder/' + id);
        }),

        // Get Rabbit Genotype
        getRebbitGenes: api(function (data) {
            return post('/admin/getRebbitGenes', data);
        }),

        // Create Genotype Table
        getRebbitgenotypes: api(function (data) {
            return post('/admin/fetchGenotypes', data);
        }),

        getBroadcastList: queued(function () {
            return get('/admin/broadcast');
        }),

        storeBroadcast: queued(function (broadcast) {
            return post('/admin/broadcast', { broadcast: broadcast });
        }, 'Save BroadCast', []),

        updateBroadcast: queued(function (id, broadcast) {
            return put('/admin/broadcast/' + id, { broadcast: broadcast });
        }, 'Update BroadCast', []),

        deleteBroadcast: queued(function (broadcast) {
            return del('/admin/broadcast/' + broadcast.id);
        }, 'Delete a broadcast plan', []),

        /**
         * Extra routes
         */
        fetchCountries: queued(function () {
            return get('/data/countries');
        }),
        fetchStates: queued(function () {
            return get('/data/states');
        }),
        fetchBreeds: queued(function () {
            return get('/data/breeds');
        }),
        fetchGenotypes: queued(function () {
            return get('/data/genotypes');
        }),
        fetchAilments: queued(function (query) {
            return get('/data/ailments', query);
        }),
        fetchPedigreeCardBody: queued(function (query) {
            return get('/data/pedigrees/card-body', query);
        }),

        /**
         * Blogs
         */
        getBlogPosts: queued(function (data) {
            return get('/data/blogs', data);
        }),

        /**
         * Dashboard Message
         */
        getDashboardMessage: queued(function (query) {
            return get('/data/dashboard/message', query);
        }),

        /**
         * Referrals
         */
        sendReferralInvite: queued(function (data) {
            return post('/referrals/email', data);
        }),

        /**
         * Data deletion
         */
        dataDelete: queued(function () {
            return del('/auth/data-delete');
        }),

        /*
         * Line Breeding COI calculation
         */
        getLineBreedingCoi: api(function (data) {
            return post('admin/breeders/line-breeding', data);
        })
    };
};

},{"babel-runtime/core-js/object/assign":22,"babel-runtime/helpers/extends":37}],710:[function(require,module,exports){
'use strict';

/**
 * Class implementing store with a user of a browser-provided html5 store implementation,
 * something like localStorage (default) or sessionStorage.
 * The instances of this class (with save arguments) are is fact using a common store
 * @param type
 * @constructor
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';

    var JSON = window.JSON,
        getStore = function getStore() {
        return window[type];
    };

    this.isAvailable = function () {
        try {
            var store = getStore();
            store.setItem('__test__', '__test__');
            var test = store.getItem('__test__');
            store.removeItem('__test__');
            return test === '__test__';
        } catch (e) {
            return false;
        }
    };

    this.clear = function () {
        getStore().clear();
    };

    this.set = function (key, value) {
        getStore().setItem(key, JSON.stringify(value));
    };

    this.has = function (key) {
        var store = getStore();
        return _.range(0, store.length, 1).some(function (i) {
            return store.key(i) === key;
        });
    };

    this.get = function (key) {
        var serialized = getStore().getItem(key);
        try {
            return JSON.parse(serialized);
        } catch (e) {
            return undefined;
        }
    };

    this.delete = function (key) {
        getStore().removeItem(key);
    };
};

;

},{}],711:[function(require,module,exports){
'use strict';

/**
 * Class implementing store interface via a plane object
 * (such a storage will not be persistent)
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var JSON = window.JSON;
    var store = void 0;

    var init = function init() {
        if (store) return;
        store = {};
    };

    this.isAvailable = function () {
        return true;
    };

    this.clear = function () {
        store = {};
    };

    this.set = function (key, value) {
        init();
        store[key] = JSON.stringify(value);
    };

    this.has = function (key) {
        init();
        return key in store;
    };

    this.get = function (key) {
        init();
        var serialized = store[key];
        try {
            return JSON.parse(serialized);
        } catch (e) {
            return undefined;
        }
    };

    this.delete = function (key) {
        init();
        delete store[key];
    };
};

;

},{}],712:[function(require,module,exports){
'use strict';

//export default (...stores) => stores.find(store => store.isAvailable());

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  for (var _len = arguments.length, stores = Array(_len), _key = 0; _key < _len; _key++) {
    stores[_key] = arguments[_key];
  }

  return stores.filter(function (store) {
    return store.isAvailable();
  })[0];
};

},{}],713:[function(require,module,exports){
"use strict";

App.Components.AccountSettingsV2 = App.Components.AccountSettings.extend({
    template: "#account-settings-v2-template"
});

},{}],714:[function(require,module,exports){
"use strict";

var _referrals = require("../mixins/referrals.js");

var _referrals2 = _interopRequireDefault(_referrals);

var _socials = require("../mixins/socials.js");

var _socials2 = _interopRequireDefault(_socials);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.AccountSettings = Vue.extend({
  template: "#account-settings-template",
  data: function data() {
    return {
      user: {},
      user_id: "",
      success: {},
      errors: {},
      loaded: false,
      update_settings_loading: false,
      subscription_updated: moment().unix(),
      is_copy_text: false,
      isNewCard: false,
      currentTab: "subscriptions",
      btn_name: []
    };
  },

  computed: {
    isSubscribed: function isSubscribed() {
      return this.subscription_updated && App.isSubscribed;
    },
    isInAppUser: function isInAppUser() {
      return App.isInAppUSer;
    },
    isGeneralStatus: function isGeneralStatus() {
      return App.user_status;
    }
  },
  watch: {
    isNewCard: function isNewCard(newData) {
      if (newData) {
        if (["settings", "subscriptions"].includes(this.currentTab)) {
          cardElement.mount("#card-element");
        }
      }
    }
  },
  methods: {
    getCurrentData: function getCurrentData() {
      var btn_name = localStorage.getItem("help_section");
      this.btn_name = JSON.parse(btn_name);
    },
    updateSettings: function updateSettings() {
      var _this = this;

      this.success = {};
      this.errors = {};
      this.update_settings_loading = true;

      api.postUserSettings(this.user_id, this.user).then(function (data) {
        _this.update_settings_loading = false;
        _this.success = data;
        _this.isNewCard = false;
        _this.showAlert({
          type: "success",
          text: "Successfully updated account details."
        });
      }, function (response) {
        _this.update_settings_loading = false;
        _this.errors = response.data.errors;
      });
    },
    copyReferralLink: function copyReferralLink() {
      var copyText = document.getElementById("copyReferralLink");
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      document.execCommand("copy");
      this.is_copy_text = true;
    },
    toggleChangeCard: function toggleChangeCard() {
      this.changeCard();
      this.isNewCard = true;
    },
    initializeNewsletter: function initializeNewsletter() {
      var _this2 = this;

      $("#user-newsletter").iCheck({
        checkboxClass: "icheckbox_square-green",
        radioClass: "iradio_square-green",
        inheritClass: true
      }).on("ifChecked", function (event) {
        _this2.user.newsletter = true;
      }).on("ifUnchecked", function (event) {
        _this2.user.newsletter = false;
      });
    },
    initializeTabs: function initializeTabs() {
      var self = this;
      $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        var target = $(e.target).attr("href");
        target = target.replace("#", "");

        self.currentTab = target;

        self.$nextTick(function () {
          if (!self.card.attached || self.isUnsubscribed) {
            self.toggleChangeCard();
          }

          if (["settings", "subscriptions"].includes(target)) {
            cardElement.mount("#card-element");
          }
        });
      });
    }
  },
  ready: function ready() {
    var _this3 = this;

    this.initializeNewsletter();
    this.initializeTabs();

    api.getUserSettingsData(this.user_id).then(function (data) {
      _this3.user = data.user;
      _this3.$nextTick(function () {
        _this3.loaded = true;
        _this3.initializeNewsletter();
      });
    });

    this.getCurrentData();
  },

  mixins: [_referrals2.default, _socials2.default, App.Mixins.Subscribes, App.Mixins.Generic, App.Mixins.Alerts]
});

},{"../mixins/referrals.js":901,"../mixins/socials.js":903}],715:[function(require,module,exports){
"use strict";

App.Components.AilmentForm = Vue.extend({
  template: "#ailment-form-template",
  data: function data() {
    return {
      loading: 1,
      errors: [],
      isKit: false,
      selectedLitter: null,
      kits: []
    };
  },

  props: ["activeAilment", "breeders", "litters"],
  computed: {},
  components: {},
  watch: {
    selectedLitter: function selectedLitter(newData, oldData) {
      if (newData) {
        this.fetchLitterKits();

        if (oldData && newData != oldData) {
          this.activeAilment.kit_id = null;
        }
      } else {
        this.kits = [];
      }
    }
  },
  events: {
    "add-new-ailment": function addNewAilment() {
      this.openAilmentModal();
      this.activeAilment.status = "active";
    },
    "edit-ailment": function editAilment(ailment) {
      this.openAilmentModal(ailment);
    }
  },
  methods: {
    fetchLitterKits: function fetchLitterKits() {
      var _this = this;

      api.getLitterKits(this.selectedLitter).then(function (kits) {
        _this.kits = kits;
      });
    },
    resetActiveAilment: function resetActiveAilment() {
      this.activeAilment = {};
      $("#ailment-modal").modal("hide");
      this.$dispatch("reload-ailments");
      this.$dispatch("reload-treatments");
    },
    openAilmentModal: function openAilmentModal() {
      var ailment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.activeAilment = $.extend({}, ailment);
      this.errors = [];
      this.toggleLayout(false);

      if (ailment.id && ailment.breeder) {
        this.$set("activeAilment.breeder_id", ailment.breeder.id);
      } else {
        this.$set("activeAilment.breeder_id", null);
      }

      if (ailment.id && ailment.kit) {
        this.toggleLayout(true);
        this.selectedLitter = ailment.kit.litter_id;
        this.$set("activeAilment.kit_id", ailment.kit.id);
      } else {
        this.$set("activeAilment.kit_id", null);
      }

      $("#ailment-modal").modal("show");
    },
    saveAilment: function saveAilment() {
      this.loading = 1;
      this.cleanUpRelation();
      if (this.activeAilment.id) {
        this.updateAilment();
      } else {
        this.storeAilment();
      }
    },
    cleanUpRelation: function cleanUpRelation() {
      if (!this.isKit) {
        delete this.activeAilment.kit_id;
      } else {
        delete this.activeAilment.breeder_id;
      }
    },
    storeAilment: function storeAilment() {
      var _this2 = this;

      api.storeAilment(this.activeAilment).then(function (data) {
        _this2.loading = 0;
        _this2.resetActiveAilment();
      }, function (response) {
        _this2.loading = 0;
        _this2.errors = response.data.errors;
      });
    },
    updateAilment: function updateAilment() {
      var _this3 = this;

      api.updateAilment(this.activeAilment).then(function (data) {
        _this3.loading = 0;
        _this3.resetActiveAilment();
      }, function (response) {
        _this3.loading = 0;
        _this3.errors = response.data.errors;
      });
    },
    initRabbitType: function initRabbitType(type) {
      var _this4 = this;

      $("#" + type + "-rabbit-type").netlivaSwitch({
        width: "35px"
      }).on("netlivaSwitch.change", function (event, state, element) {
        _this4.isKit = state;
      });
    },
    toggleLayout: function toggleLayout() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      $("#ailment-rabbit-type").netlivaSwitch("state", state);
      this.isKit = state;
    }
  },
  ready: function ready() {
    this.loading = 0;
    this.initRabbitType("ailment");
  },


  mixins: [App.Mixins.Generic, App.Mixins.BreedersFilter, App.Mixins.Filterable, App.Mixins.Alerts, App.Mixins.FieldDescription]
});

},{}],716:[function(require,module,exports){
"use strict";

App.Components.AilmentsList = Vue.extend({
  template: "#ailments-list-template",
  data: function data() {
    return {
      loading: 1,
      saveLoading: 0,
      page: 1,
      perPage: 10,
      totalPages: 1,
      totalCount: 0,
      description: {},
      currentSort: "start_date",
      currentOrder: "asc",
      ailments: {},
      activeAilment: {},
      activeTreatment: {},
      errors: [],
      openAilments: [],
      actionableAilments: [],
      preloadedAilments: []
    };
  },

  props: ["displayItems", "searchQuery", "perPage", "filters", "breeders", "breeder", "isBreeder", "litters"],
  computed: {
    pages: function pages() {
      // set a minimum of 1 page
      var maxPages = this.totalPages > 0 ? this.totalPages : 1;
      var pages = [];
      while (maxPages > 0) {
        var page = {
          title: maxPages,
          isActive: this.page == maxPages
        };
        pages.push(page);

        maxPages--;
      }

      return pages.reverse();
    }
  },
  components: {
    "ailment-form": App.Components.AilmentForm,
    "treatment-form": App.Components.TreatmentForm
  },
  watch: {
    totalCount: function totalCount(newData) {
      this.$dispatch("total-count-updated", newData);
    },
    searchQuery: function searchQuery(newData, oldData) {
      this.page = 1;
      this.fetchPreloadedAilments();
    },
    perPage: function perPage(newData) {
      this.page = 1;
      localStorage.setItem("perPage", newData);
      this.fetchPreloadedAilments();
    },

    filters: {
      handler: function handler(newVal, oldVal) {
        this.page = 1;
        this.loadAilments();
      },

      deep: true
    },
    currentSort: function currentSort(newData) {
      this.loadAilments();
    },
    currentOrder: function currentOrder(newData) {
      this.loadAilments();
    }
  },
  events: {
    "reload-ailments": function reloadAilments() {
      this.loadAilments();
    }
  },
  methods: {
    loadAilments: function loadAilments() {
      // previous ailments fetching // TODO: for removal
    },
    openAddTreatmentModal: function openAddTreatmentModal(ailment) {
      this.activeAilment = ailment;
      this.$broadcast("add-new-treatment");
    },
    openEditAilmentModal: function openEditAilmentModal(ailment) {
      this.activeAilment = ailment;
      this.$broadcast("edit-ailment", ailment);
    },
    openDeleteAilmentModal: function openDeleteAilmentModal(ailment) {
      this.activeAilment = ailment;
      $("#delete-ailment").modal("show");
    },
    deleteAilment: function deleteAilment() {
      var _this = this;

      var ailment = this.activeAilment;
      if (ailment && ailment.id) {
        api.deleteAilment(ailment).then(function () {
          $("#delete-ailment").modal("hide");
          _this.activeAilment = {};
          _this.loadAilments();
        });
      }
    },
    ailmentContainerClicked: function ailmentContainerClicked(id, element) {
      var action = $(element).data("action") || "open";

      if (action == "close") {
        $(".treatments-container-" + id).hide();
        this.closeAilments(id);
      } else {
        $(".treatments-container-" + id).show();
        this.openAilments.push(id); // add to open ailments
      }
    },
    closeAilments: function closeAilments(id) {
      // remove from open ailments
      var key = this.openAilments.indexOf(id);
      if (key > -1) {
        this.openAilments.splice(key, 1);

        this.closeAilments(id); //recursive call to clear all keys (in case it's saved multiple times)
      }
    },
    isAilmentOpen: function isAilmentOpen(id) {
      var key = this.openAilments.indexOf(id);
      if (key > -1) {
        return true;
      } else {
        return false;
      }
    },
    initializeAilmentCheckbox: function initializeAilmentCheckbox() {
      var _this2 = this;

      this.actionableAilments = [];
      $(".ailment-checkbox").iCheck({
        checkboxClass: "icheckbox_square-green",
        radioClass: "iradio_square-green"
      }).on("ifChecked", function (event) {
        var ailment = _this2.getAilmentById(event.target.name);
        _this2.actionableAilments.push(ailment);
      }).on("ifUnchecked", function (event) {
        var ailment = _this2.getAilmentById(event.target.name);
        _this2.actionableAilments = _.filter(_this2.actionableAilments, function (item) {
          return item.id != ailment.id;
        });
      });
    },
    addMultipleTreatments: function addMultipleTreatments() {
      this.$broadcast("add-multiple-treatment");
    },
    getAilmentById: function getAilmentById(id) {
      id = id.replace("ailment-", "");
      var ailment = _.find(this.ailments, function (ailment) {
        return ailment.id == id;
      });

      return ailment;
    },
    fetchPreloadedAilments: function fetchPreloadedAilments() {
      var _this3 = this;

      this.loading = 1;
      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var filter = {
        query: this.searchQuery,
        perPage: this.perPage,
        page: this.page
      };

      api.fetchAilments(filter).then(function (data) {
        var ailments = data.ailments;
        _this3.loading = 0;
        _this3.preloadedAilments = ailments.data;

        // For new version
        _this3.totalPages = ailments.last_page;
        _this3.totalCount = ailments.total;
        _this3.description = {
          from: ailments.from,
          to: ailments.to,
          total: ailments.total
        };
      });
    },
    getSymptoms: function getSymptoms(ailment) {
      var symptoms = ailment.symptoms.map(function (symptom) {
        return symptom.symptomRelated;
      }).join(", ");

      return symptoms;
    },
    getTreatments: function getTreatments(ailment) {
      var treatments = ailment.treatments.map(function (treatment) {
        return treatment.treatment;
      }).join(", ");

      return treatments;
    }
  },
  ready: function ready() {
    this.perPage = localStorage.getItem("perPage") || 10;
    this.loadAilments();
    this.fetchPreloadedAilments();
  },


  mixins: [App.Mixins.Generic, App.Mixins.BreedersFilter, App.Mixins.Filterable, App.Mixins.Alerts, App.Mixins.FieldDescription, App.Mixins.Cullable]
});

},{}],717:[function(require,module,exports){
'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.AttachmentForm = {
    template: "#attachment-form-template",
    data: function data() {
        return {
            errors: {},
            file: null,
            fileErrors: {},
            loading: false,
            dropzoneOptions: {
                autoProcessQueue: false,
                maxFiles: 1
            },
            vdropzoneOptions: {
                hideProgress: true
            },
            localAttachment: {}
        };
    },
    props: ['associated_type', 'associated', 'attachment'],
    computed: {
        disabled: function disabled() {
            return this.fileErrors && (0, _keys2.default)(this.fileErrors).length > 0;
        }
    },
    components: {
        'vdropzone': App.Components.Vdropzone
    },
    watch: {
        attachment: function attachment(newData) {
            this.localAttachment = (0, _extends3.default)({}, newData);
        }
    },
    events: {
        'new-attachment-open': function newAttachmentOpen(modalId) {
            this.errors = {};
            if (this.$refs.vdropzone) {
                this.$refs.vdropzone.removeFiles();
            }
            $('#' + modalId).modal('show');
        },
        'edit-attachment-open': function editAttachmentOpen(modalId) {
            this.errors = {};
            $('#' + modalId).modal('show');
        }
    },
    methods: {
        addFile: function addFile(file) {
            this.file = file;
        },
        removeFile: function removeFile(file) {
            if (this.file === file) {
                this.file = null;
            }
            Vue.delete(this.fileErrors, file.upload.uuid);
            if ((0, _keys2.default)(this.fileErrors).length) {
                Vue.set(this.errors, 'file', (0, _values2.default)(this.fileErrors));
            } else {
                Vue.delete(this.errors, 'file');
            }
        },
        handleFileError: function handleFileError(file, message) {
            Vue.set(this.fileErrors, file.upload.uuid, message);
            Vue.set(this.errors, 'file', (0, _values2.default)(this.fileErrors));
        },
        save: function save() {
            var _this = this;

            this.loading = true;

            if (this.localAttachment.id) {
                api.updateAttachment(this.localAttachment.id, { title: this.localAttachment.title, description: this.localAttachment.description }).then(function () {
                    _this.loading = false;
                    _this.attachment = (0, _extends3.default)({}, _this.localAttachment);
                    _this.$dispatch('attachment-saved', _this.localAttachment.id);
                }, function (response) {
                    _this.loading = false;
                    _this.errors = response.data.errors;
                });
            } else {
                var attachment = (0, _assign2.default)({}, this.localAttachment);

                api.addAttachment(attachment, this.file).then(function () {
                    _this.loading = false;
                    _this.attachment = (0, _extends3.default)({}, _this.localAttachment);
                    _this.$dispatch('attachment-saved', _this.localAttachment.id);
                }, function (response) {
                    _this.loading = false;
                    _this.errors = response.data.errors;
                });
            }
        }
    },
    mixins: [App.Mixins.Attachments]
};

},{"babel-runtime/core-js/object/assign":22,"babel-runtime/core-js/object/keys":27,"babel-runtime/core-js/object/values":29,"babel-runtime/helpers/extends":37}],718:[function(require,module,exports){
"use strict";

App.Components.AttachmentsTableV2 = App.Components.AttachmentsTable.extend({
    template: "#attachments-table-v2-template"
});

},{}],719:[function(require,module,exports){
'use strict';

App.emptyAttachment = {
    id: null,
    title: null,
    group: null,
    associated_id: null,
    associated_type: null,
    description: null
};

App.Components.AttachmentsTable = Vue.extend({
    template: "#attachments-table-template",
    data: function data() {
        return {
            attachment: {},
            attachments: [],
            total: 0,
            usedStorage: 0,
            modalUnique: 'attachments',
            order: 'title|asc',
            showSubscribe: false,
            disableLoadMore: true,
            loading: true
        };
    },
    props: ['associated_type', 'associated'],
    components: {
        'attachment-form': App.Components.AttachmentForm
    },
    computed: {
        maxStorage: function maxStorage() {
            return App.maxStorage;
        },
        remainStorage: function remainStorage() {
            return this.maxStorage - this.usedStorage;
        }
    },
    watch: {
        order: function order() {
            this.updateList();
        },
        associated: function associated() {
            this.updateList();
        }
    },
    methods: {
        changeOrder: function changeOrder(value) {
            this.order = value;
        },
        updateList: function updateList() {
            if (this.hasAccess(App.access.attachments)) {
                this.itemsLoaded = 0;

                this.loadMore();
            }
        },
        newAttachment: function newAttachment() {
            this.attachment = _.extend({}, App.emptyAttachment);
            this.attachment.associated_id = this.associated.id;
            this.attachment.associated_type = this.associated_type;
            this.$broadcast('new-attachment-open', 'attachment-form-attachments-table');
        },
        editAttachment: function editAttachment(attachment) {
            this.attachment = attachment;
            this.$broadcast('edit-attachment-open', 'attachment-form-attachments-table');
        },
        loadMore: function loadMore() {
            var _this = this;

            if (this.hasAccess(App.access.attachments) && this.associated.id) {

                var data = this.getListPostData();

                api.getAttachments(data).then(function (data) {
                    _this.loading = false;

                    _this.usedStorage = data.used_storage;
                    _this.total = data.items.total;
                    _this.itemsLoaded = parseInt(data.items.current_page);
                    if (data.items.current_page > 1) {
                        _this.mergeByProperty(_this.attachments, data.items.data, 'id');
                    } else {
                        _this.attachments = data.items.data;
                    }
                    _this.disableLoadMore = data.items.last_page <= data.items.current_page;
                }, function (response) {
                    _this.loading = false;
                    if (response.status === 403) {
                        _this.showSubscribe = true;
                    }
                });
            }
        },
        getListPostData: function getListPostData() {
            var data = {
                associatedType: this.associated_type,
                associatedId: this.associated.id,
                page: this.itemsLoaded + 1
            };

            data.searchQuery = this.searchQuery;

            if (this.order) {
                data.order = this.order;
            }

            return data;
        },
        isEditMode: function isEditMode() {
            return this.associated_type !== 'breeder' || this.isBreederActive(this.associated);
        }
    },
    events: {
        'attachment-saved': function attachmentSaved() {
            $('#attachment-form-attachments-table').modal('hide');
            this.updateList();
        }
    },
    ready: function ready() {
        this.updateList();
    },
    mixins: [App.Mixins.Filterable, App.Mixins.Breeders, App.Mixins.Auth, App.Mixins.Attachments]
});

},{}],720:[function(require,module,exports){
'use strict';

App.Components.Attachments = {
    template: "#attachments-template",
    data: function data() {
        return {
            attachment: {},
            attachments: [],
            total: 0,
            modalUnique: 'attachments',
            order: 'title|asc',
            disableLoadMore: true,
            loading: true
        };
    },
    watch: {
        order: function order() {
            this.updateList();
        }
    },
    methods: {
        changeOrder: function changeOrder(value) {
            this.order = value;
        },
        updateList: function updateList() {
            if (this.hasAccess(App.access.attachments)) {
                this.itemsLoaded = 0;

                this.loadMore();
            }
        },
        editAttachment: function editAttachment(attachment) {
            this.attachment = attachment;
            $('#attachment-form-attachments-table').modal('show');
        },
        loadMore: function loadMore() {
            var _this = this;

            if (this.hasAccess(App.access.attachments)) {

                var data = this.getListPostData();

                api.getAllAttachments(data).then(function (data) {
                    _this.loading = false;

                    _this.total = data.total;
                    _this.itemsLoaded = parseInt(data.current_page);
                    if (data.current_page > 1) {
                        _this.mergeByProperty(_this.attachments, data.data, 'id');
                    } else {
                        _this.attachments = data.data;
                    }
                    _this.disableLoadMore = data.last_page <= data.current_page;
                }, function () {
                    _this.loading = false;
                });
            }
        },
        getListPostData: function getListPostData() {
            var data = {
                page: this.itemsLoaded + 1
            };

            data.searchQuery = this.searchQuery;

            if (this.order) {
                data.order = this.order;
            }

            return data;
        }
    },
    ready: function ready() {
        this.updateList();
    },
    mixins: [App.Mixins.Filterable, App.Mixins.Auth, App.Mixins.Attachments]
};

},{}],721:[function(require,module,exports){
'use strict';

var _eventBus = require('../event-bus');

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.AutoUpgradeSubscription = {
    template: "#auto-upgrade-subscription-template",
    data: function data() {
        return {
            model: {}
        };
    },
    ready: function ready() {
        var _this = this;

        $(function () {
            _eventBus2.default.$on('auto-upgrade-subscription', function (data) {
                _this.model = data;
                _this.$nextTick(function () {
                    $('#auto-upgrade-subscription-modal').modal('show');
                });
            });
        });
    }
};

},{"../event-bus":882}],722:[function(require,module,exports){
"use strict";

App.Components.BirthCertificate = {
  template: "#birth-certificate-template",
  data: function data() {
    return {
      breeder: {
        color: null,
        father: null,
        mother: null,
        pedigree_father: null,
        pedigree_mother: null
      }
    };
  },
  components: {},
  props: {
    breeder: null
  },
  computed: {
    breederColor: function breederColor() {
      return this.breeder.color && this.breeder.color !== null && this.breeder.color !== "" ? this.breeder.color : "N/A";
    },
    fatherName: function fatherName() {
      if (this.breeder.father && this.breeder.father.name !== null && this.breeder.father.name !== "") {
        return this.breeder.father.name;
      } else if (this.breeder.pedigree_father[0] && this.breeder.pedigree_father[0].name !== null && this.breeder.pedigree_father[0].name !== "") {
        return this.breeder.pedigree_father[0].name;
      } else {
        return "N/A";
      }
    },
    fatherColor: function fatherColor() {
      if (this.breeder.father && this.breeder.father.color !== null && this.breeder.father.color !== "") {
        return this.breeder.father.color;
      } else if (this.breeder.pedigree_father[0] && this.breeder.pedigree_father[0].color !== null && this.breeder.pedigree_father[0].color !== "") {
        return this.breeder.pedigree_father[0].color;
      } else {
        return "N/A";
      }
    },
    motherName: function motherName() {
      if (this.breeder.mother && this.breeder.mother.name !== null && this.breeder.mother.name !== "") {
        return this.breeder.mother.name;
      } else if (this.breeder.pedigree_mother[0] && this.breeder.pedigree_mother[0].name !== null && this.breeder.pedigree_mother[0].name !== "") {
        return this.breeder.pedigree_mother[0].name;
      } else {
        return "N/A";
      }
    },
    motherColor: function motherColor() {
      if (this.breeder.mother && this.breeder.mother.color !== null && this.breeder.mother.color !== "") {
        return this.breeder.mother.color;
      } else if (this.breeder.pedigree_mother[0] && this.breeder.pedigree_mother[0].color !== null && this.breeder.pedigree_mother[0].color !== "") {
        return this.breeder.pedigree_mother[0].color;
      } else {
        return "N/A";
      }
    }
  },
  watch: {},
  methods: {
    downloadPDF: function downloadPDF(url) {
      document.location.href = url;
    }
  },
  events: {},
  ready: function ready() {}
};

},{}],723:[function(require,module,exports){
"use strict";

App.Components.BirthFormV2 = App.Components.BirthForm.extend({
    template: "#birth-form-v2-template"
});

},{}],724:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.BirthForm = App.Components.Exploitable.Section.extend({
    template: "#birth-form-template",
    data: function data() {
        return {
            modalUnique: 'plan',
            errors: {},
            doe: {},
            pregnancyCheck: {
                date: moment(new Date()).format(App.dateFormat),
                result: "pregnant",
                action: "yes"
            },
            planEvents: [],
            activeTemplate: {},
            events: [],
            loadingBirth: false,
            isShowMissed: true
        };
    },
    props: ['plans', 'activeBirth', 'activeTask', 'isGlobal', 'isLitter'],
    watch: {
        'activeBirth.breedplan': function activeBirthBreedplan(val) {
            var _this = this;

            if (['string', 'number'].includes(typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) && val != -1 && App.generateLitterIdFlag) {
                api.getNextLitterId({ plan_id: val }).then(function (response) {
                    _this.$set('activeBirth.given_id', response.nextLitterId);
                    _this.doe = response.doe;
                });
            } else {
                this.$set('activeBirth.given_id', '');
            }
        },
        'activeBirth.born': function activeBirthBorn(newValue, oldValue) {
            if (newValue && oldValue) {
                var date = App.parseMoment(newValue);
                var oldDate = App.parseMoment(oldValue);
                var diff = date.diff(oldDate, 'days');
                _.each(this.events, function (item) {
                    item.date = App.parseMoment(item.date).add(diff, 'days').format(App.dateFormat);
                });
            }
        },
        'activeTemplate': function activeTemplate() {
            this.events = this.activeTemplate.events;
            this.activeBirth.breed_chain_id = this.activeTemplate.breed_chain.id;
        }
    },
    components: {},
    computed: {
        pregnancyCheckForm: function pregnancyCheckForm() {
            if (!this.isGlobal) {
                return $('#pregnancy-check-modal').modal('hide');
            } else {
                return $('#global-pregnancy-check-modal').modal('hide');
            }
        },
        missedPregnancyCheckForm: function missedPregnancyCheckForm() {
            if (!this.isGlobal) {
                return $('#missed-pregnancy-check-modal').modal('hide');
            } else {
                return $('#global-missed-pregnancy-check-modal').modal('hide');
            }
        },
        birthPregnancyCheckForm: function birthPregnancyCheckForm() {
            if (!this.isGlobal) {
                return $('#birth-pregnancy-check-modal').modal('hide');
            } else {
                return $('#global-birth-pregnancy-check-modal').modal('hide');
            }
        },
        modalName: function modalName() {
            if (!this.isGlobal) return 'birth-form-modal';
            if (this.isLitter) return 'global-birth-form-modal-litter';
            return 'global-birth-form-modal';
        }
    },
    events: {
        doMissedModel: function doMissedModel(plan) {
            var _this2 = this;

            api.missBirth(this.activeBirth).then(function () {
                if (!_this2.isGlobal) {
                    $('#birth-form-modal').modal('hide');
                    $('#missing-modal-birth-plan').modal('hide');
                    $('#litter-form').modal('hide');
                } else {
                    $('#global-missing-modal-birth-plan').modal('hide');
                    $('#global-birth-form-modal').modal('hide');
                    $('#global-birth-form-modal-litter').modal('hide');
                    $('#global-litter-form').modal('hide');
                }

                if (_this2.isLitter) {
                    _this2.$dispatch('set-breeding-doe', _this2.doe);
                }

                if (_this2.doe && _this2.doe.id) {
                    if (!_this2.isGlobal) {
                        $('#birth-schedule-next-modal').modal('show');
                    } else {
                        $('#global-birth-schedule-next-modal').modal('show');
                    }
                }
                _this2.$dispatch('reload-tasks', { typeOfTask: 'all', page: null });
            });
        },
        'new-birth-modal-open': function newBirthModalOpen() {
            var isShowMissed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.isShowMissed = isShowMissed;
            this.errors = {};
            var today = moment(new Date()).format(App.dateFormat);
            this.generateEvents(today);
        },
        'new-pregnancy-check': function newPregnancyCheck() {
            // reset to pregnant, don't reset date
            this.pregnancyCheck.result = "pregnant";
            this.pregnancyCheck.action = "yes";
        }
    },
    methods: {
        shortDate: function shortDate(date) {
            return App.parseMoment(date).format(App.dateFormatShort);
        },
        recordBirth: function recordBirth() {
            var _this3 = this;

            this.loadingBirth = true;
            api.recordBirth(this.activeBirth).then(function () {
                _this3.loadingBirth = false;
                if (!_this3.isGlobal) {
                    $('#birth-form-modal').modal('hide');
                    $('#litter-form').modal('hide');
                } else {
                    $('#global-birth-form-modal').modal('hide');
                    $('#global-litter-form').modal('hide');
                    $('#global-birth-form-modal-litter').modal('hide');
                    _this3.$root.$emit('global-notification-tab-reload');
                }

                if (_this3.isLitter) {
                    _this3.$dispatch('set-breeding-doe', _this3.doe);
                }

                if (_this3.doe && _this3.doe.id) {
                    if (!_this3.isGlobal) {
                        $('#birth-schedule-next-modal').modal('show');
                    } else {
                        $('#global-birth-schedule-next-modal').modal('show');
                    }
                }

                _this3.$root.$emit('reload-tasks');
                _this3.$root.$emit('reload-tasks-calendar');
            }, function (response) {
                _this3.loadingBirth = false;
                _this3.errors = response.data.errors;

                if (_this3.activeBirth.breedplan == -1) {
                    _this3.errors = (0, _extends3.default)({}, _this3.errors, {
                        breedplan: ['A breed plan is required before recording birth.']
                    });
                }
            });
        },
        showMissed: function showMissed() {
            if (!this.isGlobal) {
                $('#missing-modal-birth-plan').modal('show');
            } else {
                $('#global-missing-modal-birth-plan').modal('show');
            }
        },
        showBreedModal: function showBreedModal() {
            $('#empty-breedplans-modal').modal('hide');
            this.$dispatch('showBreedModal');
        },

        scheduleNextBreed: function scheduleNextBreed(doeId) {
            if (!this.isGlobal) {
                $('#birth-schedule-next-modal').modal('hide');
                this.$dispatch('open-breed-modal', doeId);
            } else {
                $('#global-birth-schedule-next-modal').modal('hide');
                this.$root.$emit('open-global-breed-form-doe', doeId);
            }
        },
        submitPregnancyCheck: function submitPregnancyCheck() {
            var _this4 = this;

            var data = {
                date: this.pregnancyCheck.date,
                result: this.pregnancyCheck.result,
                event_id: this.activeTask.id
            };

            api.pregnancyCheck(data).then(function (response) {
                $(_this4.pregnancyCheckForm).modal('hide');

                if (_this4.pregnancyCheck.action == 'yes') {
                    if (_this4.pregnancyCheck.result == 'miss') {
                        _this4.missedPregnancyCheck();
                    } else if (_this4.pregnancyCheck.result == 'birth') {
                        _this4.birthPregnancyCheck();
                    }
                }

                _this4.$root.$emit('reload-tasks');
            });
        },
        missedPregnancyCheck: function missedPregnancyCheck() {
            var _this5 = this;

            api.missBirth(this.activeBirth).then(function () {
                $(_this5.missedPregnancyCheckForm).modal('hide');
            });
        },
        birthPregnancyCheck: function birthPregnancyCheck() {
            $(this.birthPregnancyCheckForm).modal('hide');
            if (!this.isGlobal) {
                $('#birth-form-modal').modal('show');
            } else {
                $('#global-birth-form-modal').modal('show');
            }
        },
        generateEvents: function generateEvents(date) {
            var _this6 = this;

            api.getLitterDummyEvents(date).then(function (planEvents) {
                _this6.planEvents = planEvents;

                if (App.active_litter_chain_id) {
                    _this6.activeTemplate = _.find(planEvents, function (plan) {
                        return plan.breed_chain.id == App.active_litter_chain_id;
                    });
                } else {
                    _this6.activeTemplate = _.first(planEvents);
                }
            });
        }
    },
    ready: function ready() {
        // clear doe data on modal close
        var self = this;
        $("#birth-schedule-next-modal, #global-birth-schedule-next-modal").on("hidden.bs.modal", function () {
            self.doe = {};
        });
    },
    mixins: [App.Mixins.FieldDescription]
});

},{"babel-runtime/helpers/extends":37,"babel-runtime/helpers/typeof":42}],725:[function(require,module,exports){
'use strict';

App.Components.BreedForm = App.Components.Exploitable.Section.extend({
    template: "#breed-form-template",
    data: function data() {
        return {
            loading: 1,
            modalUnique: 'breed-plan',
            type_of_tasks: 'all',
            genotype_response: null,
            linebreeding_response: null,
            events: [],
            newDoeId: null,
            newBuckId: null,
            reloadTasks: false,
            isEditAction: false,
            plan: {},
            plansEvents: [],
            activePlanEvents: {},
            breeders: {
                bucks: [],
                does: []
            },
            predict_breeders: {
                bucks: [],
                does: []
            },
            errors: {},
            doe: {},
            predict_doe: {},

            genes_doe: null,
            genes_buck: null,
            rebbitBuckGenes: null,
            rebbitDoeGenes: null,
            errors_buck: null,
            errors_doe: null,
            isFirstEdit: false,

            line_doe_id: null,
            line_buck_id: null,
            errors_line_buck: null,
            errors_line_doe: null
        };
    },
    props: ['isGlobal', 'isMultiple', 'does'],
    watch: {
        'plan.is_future_breeding': function planIs_future_breeding(newData) {
            if (newData) {
                $(this.formModal + ' #future-breeding').iCheck("check");
            } else {
                $(this.formModal + ' #breeding-occured').iCheck("check");
            }
        },
        isGlobal: function isGlobal(newData) {
            if (newData) {
                this.formModal = '#global-breed-form-modal';
                this.predictModal = '#global-predict-form-modal';
                this.lineBreedingModal = '#global-line-breeding-form-modal';
                this.missingModal = '#global-missing-modal-breed-plan';
            } else {
                this.formModal = '#breed-form-modal';
                this.lineBreedingModal = '#line-breeding-form-modal';
                this.predictModal = '#predict-form-modal';
                this.missingModal = '#missing-modal-breed-plan';
            }
        },

        'plan': function plan() {
            this.resetArchivedFilterBreeders();
        },
        'plan.doe': function planDoe() {
            this.setFilterBreeders(this.plan.doe, this.plan.buck);
        },
        'plan.buck': function planBuck() {
            this.setFilterBreeders(this.plan.doe, this.plan.buck);
        },
        'plan.date': function planDate(newValue, oldValue) {
            if (newValue && oldValue) {
                var date = App.parseMoment(newValue);
                var oldDate = App.parseMoment(oldValue);
                var diff = date.diff(oldDate, 'days');
                _.each(this.events, function (item) {
                    item.date = App.parseMoment(item.date).add(diff, 'days').format(App.dateFormat);
                });
            }
        },
        'activePlanEvents': function activePlanEvents() {
            if (this.activePlanEvents) {
                this.events = this.activePlanEvents.events;
                this.plan.breed_chain_id = this.activePlanEvents.breed_chain.id;
            }
        }
    },
    components: {},
    computed: {
        formModal: function formModal() {
            return this.isGlobal ? '#global-breed-form-modal' : '#breed-form-modal';
        },
        predictModal: function predictModal() {
            return this.isGlobal ? '#global-predict-form-modal' : '#predict-form-modal';
        },
        missingModal: function missingModal() {
            return this.isGlobal ? '#global-missing-modal-breed-plan' : '#missing-modal-breed-plan';
        },
        lineBreedingModal: function lineBreedingModal() {
            return this.isGlobal ? '#global-line-breeding-form-modal' : '#line-breeding-form-modal';
        }
    },
    events: {
        'new-breed': function newBreed(reloadTasks) {
            this.reloadTasks = reloadTasks;
            this.isEditAction = false;
            this.errors = {};
            this.openModal();
        },
        'global-new-breed': function globalNewBreed() {
            this.reloadTasks = true;
            if (this.isGlobal) {
                this.isEditAction = false;
                this.errors = {};
                this.openModal();
            }
        },
        'new-breed-with-buck': function newBreedWithBuck(buckId, reloadTasks) {
            this.reloadTasks = reloadTasks;
            this.isEditAction = false;
            this.newBuckId = buckId;
            this.errors = {};
            this.openModal();
        },
        'new-breed-with-doe': function newBreedWithDoe(doeId, reloadTasks) {
            this.reloadTasks = reloadTasks;
            this.isEditAction = false;
            this.newDoeId = doeId;
            this.errors = {};
            this.openModal();
        },
        'new-breed-multiple': function newBreedMultiple() {
            this.isEditAction = false;
            this.errors = {};
            this.openModal();
        },
        'open-edit-breed-form': function openEditBreedForm(plan) {
            this.reloadTasks = true;
            this.type_of_tasks = 'plans';
            this.isEditAction = true;
            this.openModal(plan);
        },
        'doMissedModel': function doMissedModel() {
            var _this = this;

            this.type_of_tasks = 'plans';
            api.missBirth({ breedplan: this.plan.id }).then(function () {
                $(_this.missingModal).modal('hide');
                $(_this.formModal).modal('hide');
                _this.$dispatch('reload-tasks', { typeOfTask: _this.type_of_tasks, page: null });
            });
        },
        'globle-genetic-prediction-form': function globleGeneticPredictionForm() {
            var _this2 = this;

            this.loading = 1;
            api.getPlansBreeders().then(function (data) {
                _this2.loading = 0;
                _this2.breeders = data;
                _this2.predict_breeders = data;
                _this2.errors = [];
                _this2.events = [];
                _this2.open_predict_modal();
            });
        },
        'global-line-breeding-form': function globalLineBreedingForm() {
            var _this3 = this;

            this.loading = 1;
            console.log("breed-form.js");
            api.getPlansBreeders().then(function (data) {
                _this3.loading = 0;
                _this3.breeders = data;
                _this3.predict_breeders = data;
                _this3.errors = [];
                _this3.events = [];
                _this3.open_line_breeding_modal();
            });
        }
    },
    methods: {
        openModal: function openModal(plan) {
            var _this4 = this;

            this.loading = 1;
            this.isFirstEdit = false;
            var path = this.$route.path.split('?')[0]; // tweak to remove query params, documentation does not work
            this.$router.go(path); // replace route

            api.getPlansBreeders().then(function (data) {
                _this4.loading = 0;
                _this4.breeders = data;
                _this4.predict_breeders = data;
                _this4.errors = [];
                _this4.events = [];

                if (plan) {
                    _this4.plan = plan;
                    _this4.plansEvents.push(plan);
                    _this4.activePlanEvents = plan;

                    var doe = _this4.plan.breeders.filter(function (breeder) {
                        return breeder.sex === 'doe';
                    }).shift();

                    if (doe) {
                        _this4.plan.doe = doe.id;
                    }

                    var buck = _this4.plan.breeders.filter(function (breeder) {
                        return breeder.sex === 'buck';
                    }).shift();

                    if (buck) {
                        _this4.plan.buck = buck.id;
                    }

                    if (_this4.plan.is_future_breeding) {
                        _this4.plan.is_future_breeding = false;
                        _this4.isFirstEdit = true;
                        _this4.generateEvents(_this4.plan.date);
                    } else {
                        _this4.loadPlanEvents(plan);
                    }
                } else {

                    var buckDefaultId = _this4.newBuckId || -1;
                    var doeDefaultId = _this4.newDoeId || -1;

                    var today = moment(new Date()).format(App.dateFormat);

                    _this4.plan = {
                        doe: doeDefaultId,
                        buck: buckDefaultId,
                        date: today,
                        is_future_breeding: true
                    };

                    _this4.generateEvents(today);
                }

                _this4.newBuckId = null;
                _this4.newDoeId = null;

                $(_this4.formModal).modal('show');
            });
        },
        open_predict_modal: function open_predict_modal() {

            this.genes_doe = null;
            this.genes_buck = null;
            this.rebbitBuckGenes = null;
            this.rebbitDoeGenes = null;
            this.errors_buck = null;
            this.errors_doe = null;
            this.genotype_response = null;

            $(this.formModal).modal('hide');
            $(this.predictModal).modal('show');
        },
        open_line_breeding_modal: function open_line_breeding_modal() {
            this.line_doe_id = null;
            this.line_buck_id = null;
            this.errors_line_buck = null;
            this.errors_line_doe = null;
            this.linebreeding_response = null;

            $(this.formModal).modal('hide');
            $(this.lineBreedingModal).modal('show');
        },
        hide_line_breeding_modal_and_show_breed_form: function hide_line_breeding_modal_and_show_breed_form() {
            $(this.lineBreedingModal).modal('hide');
            $(this.formModal).modal('show');
        },
        hide_predict_modal_and_show_breed_form: function hide_predict_modal_and_show_breed_form() {
            $(this.predictModal).modal('hide');
            $(this.formModal).modal('show');
        },
        onChangeBuck: function onChangeBuck() {
            var _this5 = this;

            var buck_data = { "genes_id": this.genes_buck };
            api.getRebbitGenes(buck_data).then(function (response) {
                if (response.genotype != "") {
                    _this5.errors_buck = null;
                    _this5.rebbitBuckGenes = response.genotype;
                } else {
                    _this5.rebbitBuckGenes = null;
                    _this5.genotype_response = null;
                    _this5.errors_buck = "Genotype Not Found Please Add ";
                }

                if (_this5.rebbitDoeGenes && _this5.rebbitBuckGenes) {
                    var data = { "buck": _this5.genes_buck, "doe": _this5.genes_doe };
                    api.getRebbitgenotypes(data).then(function (response) {
                        _this5.genotype_response = response;
                    });
                }
            });
        },
        onChangeDoe: function onChangeDoe() {
            var _this6 = this;

            var doe_data = { "genes_id": this.genes_doe };

            api.getRebbitGenes(doe_data).then(function (response) {
                if (response.genotype != "") {
                    _this6.errors_doe = null;
                    _this6.rebbitDoeGenes = response.genotype;
                } else {
                    _this6.rebbitDoeGenes = null;
                    _this6.genotype_response = null;
                    _this6.errors_doe = "Genotype Not Found Please Add";
                }

                if (_this6.rebbitDoeGenes && _this6.rebbitBuckGenes) {
                    var data = { "buck": _this6.genes_buck, "doe": _this6.genes_doe };
                    api.getRebbitgenotypes(data).then(function (response) {
                        _this6.genotype_response = response;
                    });
                }
            });
        },
        onChangeBuckCoi: function onChangeBuckCoi() {
            var _this7 = this;

            this.errors_line_buck = null;
            if (!this.line_doe_id) {
                this.errors_line_doe = "Please select a Doe.";
            } else {
                api.getLineBreedingCoi({
                    "buck_id": this.line_buck_id,
                    "doe_id": this.line_doe_id
                }).then(function (response) {
                    _this7.linebreeding_response = response;
                    _this7.linebreeding_response['ancestors_count'] = response.ancestors.length;
                    console.log(_this7.linebreeding_response);
                });
            }
        },
        onChangeDoeCoi: function onChangeDoeCoi() {
            var _this8 = this;

            this.errors_line_doe = null;
            if (!this.line_buck_id) {
                this.errors_line_buck = "Please select a Buck.";
            } else {
                api.getLineBreedingCoi({
                    "buck_id": this.line_buck_id,
                    "doe_id": this.line_doe_id
                }).then(function (response) {
                    _this8.linebreeding_response = response;
                    _this8.linebreeding_response['ancestors_count'] = response.ancestors.length;
                    console.log(_this8.linebreeding_response);
                });
            }
        },
        updatePlan: function updatePlan(plan) {
            var _this9 = this;

            this.loading = 1;

            if (this.isMultiple) {
                delete plan.doe;
                plan.does = _.pluck(this.does, "id");
            }

            api.savePlan(plan).then(function (data) {
                _this9.loading = 0;
                $(_this9.formModal).modal('hide');

                // reload both tasks and plans data
                if (_this9.reloadTasks) {
                    _this9.$dispatch('reload-tasks', { typeOfTask: 'plans', page: null });
                    _this9.$dispatch('reload-tasks', { typeOfTask: 'all', page: null });
                }

                // show success message
                var message = data.is_future_breeding ? 'Breeding has been scheduled.' : 'Breeding tasks created successfully.';
                _this9.showAlert({
                    type: 'success',
                    text: message,
                    link: _this9.isGlobal ? '/#!/schedule?tab=plans&plan_id=' + (plan.id || data.id) : false,
                    linkText: 'Open breeding here.'
                });
            }, function (response) {
                _this9.loading = 0;
                _this9.errors = response.data.errors;
            });
        },
        generateEvents: function generateEvents(date) {
            var _this10 = this;

            this.loading = 1;

            api.getDummyEvents(date).then(function (plansEvents) {
                _this10.loading = 0;
                _this10.plansEvents = plansEvents;

                if (App.active_breed_chains_id) {
                    _this10.activePlanEvents = _.find(plansEvents, function (plan) {
                        return plan.breed_chain.id == App.active_breed_chains_id;
                    });
                } else {
                    _this10.activePlanEvents = _.first(plansEvents);
                }
            });
        },
        loadPlanEvents: function loadPlanEvents(plan) {
            var _this11 = this;

            this.loading = 1;

            api.getPlanEvents(plan.id).then(function (events) {
                _this11.loading = 0;
                _this11.events = events;
            });
        },
        showMissed: function showMissed(plan) {
            if (plan) {
                $(this.missingModal).modal('show');
            }
        },
        missed: function missed() {
            this.$emit('doMissedModel');
        },
        initializeRadioButtons: function initializeRadioButtons() {
            var _this12 = this;

            var iCheckClass = {
                checkboxClass: "icheckbox_square-blue",
                radioClass: "iradio_square-blue",
                inheritClass: true
            };

            $(this.formModal + ' #future-breeding').iCheck(iCheckClass).on("ifChecked", function (event) {
                _this12.plan.is_future_breeding = true;
            });

            $(this.formModal + ' #breeding-occured').iCheck(iCheckClass).on("ifChecked", function (event) {
                _this12.plan.is_future_breeding = false;
            });
        }
    },
    ready: function ready() {
        this.initializeRadioButtons();
    },

    mixins: [App.Mixins.BreedersFilter, App.Mixins.Filterable, App.Mixins.Alerts]
});

},{}],726:[function(require,module,exports){
'use strict';

App.Components.BreederButcher = {
    template: "#breeder-butcher-template",
    data: function data() {
        return {
            errors: {},
            date: moment(new Date()).format(App.dateFormat),
            loaded: 0,
            current: 0,
            currency: '',
            preButcherWeight: 0
        };
    },
    props: ['breeder'],
    components: {
        'lbs-oz-input': App.Components.LbsOzInput
    },
    watch: {
        breeder: function breeder(newData) {
            this.preButcherWeight = Array.isArray(newData.weight) ? newData.weight[0] : newData.weight;
        }
    },
    methods: {
        getGenderClass: function getGenderClass(sex) {
            if (!sex) {
                return "bg-gray-active";
            }
            return sex === "buck" ? "bg-aqua" : "bg-maroon";
        },
        sendToButcher: function sendToButcher() {
            var _this = this;

            this.breeder.weight = this.preButcherWeight;
            var data = {
                breeder: this.breeder,
                date: this.date,
                butchered: 1
            };

            api.butcherBreeder(this.breeder, data).then(function (res) {
                _this.breeder.butchered = true;
                _this.breeder.butchered_at = _this.date;
                _this.breeder.weight_slug = res[0].weight_slug;
                _this.breeder.butchered_weight_slug = res[0].butchered_weight_slug;
                // this.$dispatch('breederButchered', this.breeder.id);

                _this.showAlert({
                    type: 'warning',
                    text: _this.breeder.name + ' has been butchered.'
                });
            });

            $('#breeder-butcher-modal').modal('hide');
        }

    },
    ready: function ready() {

        this.currency = App.currency;
    },

    mixins: [App.Mixins.Weightable, App.Mixins.Alerts]

};

},{}],727:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _from = require("babel-runtime/core-js/array/from");

var _from2 = _interopRequireDefault(_from);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _mixpanelBrowser = require("mixpanel-browser");

var _mixpanelBrowser2 = _interopRequireDefault(_mixpanelBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.BreederForm = Vue.extend({
    template: "#breeder-form-template",
    data: function data() {
        return {
            bucks: [],
            does: [],
            categories: [],
            loading: 1,
            newBuck: {
                sex: "buck"
            },
            newDoe: {
                sex: "doe"
            },
            errors: {},
            warnings: {},
            breeds: [],
            breedersList: [],
            emptyModel: {
                category_id: null,
                category_name: ''
            },
            weight_units: 'Pounds',
            mother_name: '',
            father_name: '',
            mother_input_focused: false,
            father_input_focused: false,
            getBygenotypeCodeValue: "",
            tempDateStore: [],
            existing_weight_date: '',
            currentTab: 1,
            tabs: {
                rabbit: 1,
                history: 2,
                weight: 3,
                show_record: 4,
                photos: 5
            },
            breederAttachments: [],
            isShowShow: true,
            tabErrors: {
                rabbit: null,
                history: null,
                weight: null,
                show_record: null,
                photos: null
            },
            isBrokenChecked: false
        };
    },
    props: ['breeder', 'breeders', 'isGlobal'],
    components: {
        'image-upload': App.Components.ImageUpload,
        'sex-select': App.Components.SexSelect,
        'lbs-oz-input': App.Components.LbsOzInput,
        'vdropzone': App.Components.Vdropzone,
        'weigh-form': App.Components.WeighForm
    },
    computed: {
        breederForm: function breederForm() {
            return this.isGlobal ? '#global-breeder-form' : '#breeder-form';
        },

        flattenBreeders: function flattenBreeders() {
            return _.flatten([].concat(this.does, this.bucks));
        },
        breeder_weight: function breeder_weight() {

            if (this.breeder.existing_weight_date != null && this.breeder.existing_weight_date != undefined && this.breeder.existing_weight_date != '') {
                this.existing_weight_date = this.breeder.existing_weight_date;
            }

            return _.map(this.breeder.weight, function (val, i) {
                var formatted_date = "&nbsp;";
                if (this.breeder.weight_date != null && this.breeder.weight_date[i] != undefined && this.breeder.weight_date[i] != 'null' && this.breeder.weight_date[i] != null) {
                    if (App.dateFormat == "DD/MM/YYYY") {
                        if (isNaN(this.breeder.weight_date[i])) {
                            var weight_date = this.breeder.weight_date[i];
                            var d = new Date(weight_date.split("/").reverse().join("-"));
                            var dd = d.getDate();
                            var mm = d.getMonth() + 1;
                            var yy = d.getFullYear();
                            var new_date = mm + "/" + dd + "/" + yy;
                            this.breeder.weight_date[i] = new Date(new_date).getTime();
                        }
                    }
                } else {
                    if (this.breeder.weight_date == null) {
                        this.breeder.weight_date = [];
                        this.breeder.weight_date[i] = Date.now();
                    } else {
                        this.breeder.weight_date[i] = Date.now();
                    }
                }

                this.breeder.existing_weight_date = this.existing_weight_date;

                formatted_date = moment(new Date(this.breeder.weight_date[i])).format(App.dateFormat);
                // var formatted_date = (this.kit.weight_date[i] == undefined || this.kit.weight_date[i] == 'null') ? '&nbsp;' : moment(new Date(this.kit.weight_date[i])).format(App.dateFormat);
                return { id: i, value: val, wdate: formatted_date };
            }.bind(this));
        },
        showBreederWeight: function showBreederWeight() {
            return this.breeder.weight && this.breeder.weight.length > 0 && this.breeder.weight_unit != 'Pound/Ounces';
        }
    },
    watch: {
        breeder: function breeder() {
            $('.js_icheck-breeder-blue, .js_icheck-breeder-red').iCheck('update');
            $('#breeder-prefix').typeahead('val', this.breeder.prefix);
            $('#breeder-cage').typeahead('val', this.breeder.cage);
            $('#breeder-tattoo').typeahead('val', this.breeder.tattoo);
            $('#breeder-color').typeahead('val', this.breeder.color);
            $('#breeder-breed').typeahead('val', this.breeder.breed);
            this.setFilterBreeders(this.breeder.mother_id, this.breeder.father_id);
            this.resetArchivedFilterBreeders();
            this.initAttachments();
            this.initTabs();

            if (this.$refs.vdropzone) {
                this.$refs.vdropzone.removeFiles();
            }
        },
        'breeder.mother_id': function breederMother_id() {
            this.setFilterBreeders(this.breeder.mother_id, this.breeder.father_id);
            for (var i = 0; i < this.does.length; i++) {
                if (+this.does[i].id === +this.breeder.mother_id) {
                    this.mother_name = this.does[i].name;
                }
            }
            this.mother_input_focused = false;
        },
        'breeder.father_id': function breederFather_id() {
            this.setFilterBreeders(this.breeder.mother_id, this.breeder.father_id);
            for (var i = 0; i < this.bucks.length; i++) {
                if (+this.bucks[i].id === +this.breeder.father_id) {
                    this.father_name = this.bucks[i].name;
                }
            }
            this.father_input_focused = false;
        },
        getBygenotypeCodeValue: function getBygenotypeCodeValue(newData) {
            this.setBygenotypeCodeV2();
        },

        "breeder.images": function breederImages(newData) {
            if (newData.length < 5) {
                this.$refs.vdropzone.enable();
                this.$set('dropzoneOptions.dictDefaultMessage', "Upload your photo");
            } else {
                this.$refs.vdropzone.disable();
                this.$set('dropzoneOptions.dictDefaultMessage', "You have reached the upload limit for this breeder");
            }
        },
        "breeder.genotype[10]": function breederGenotype10() {
            if (this.breeder.genotype[10] == "En" && this.breeder.genotype[11] == "en") {
                this.isBrokenChecked = true;
            } else {
                this.isBrokenChecked = false;
            }
        },
        "breeder.genotype[11]": function breederGenotype11() {
            if (this.breeder.genotype[10] == "En" && this.breeder.genotype[11] == "en") {
                this.isBrokenChecked = true;
            } else {
                this.isBrokenChecked = false;
            }
        }
    },
    events: {
        'breeder-add-new': function breederAddNew() {
            this.loadCategories();
            this.initModal(true);
        },
        'global-breeder-add-new': function globalBreederAddNew() {
            if (this.isGlobal) {
                this.loadCategories();
                this.initModal(true);
            }
        },
        'breeder-edit': function breederEdit() {
            this.loadCategories();
            this.initModal();
        },
        'global-breeder-edit': function globalBreederEdit() {
            if (this.isGlobal) {
                this.loadCategories();
                this.initModal();
            }
        }
    },
    methods: {
        showGlobalFormsModal: function showGlobalFormsModal() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "genetic-prediction-form";

            switch (type) {
                case "genetic-prediction-form":
                    this.$root.$emit('global-predict-form-modal');
                    break;
                case "line-breeding-form":
                    console.log(type);
                    this.$root.$emit('line-breeding-form-modal');
                    break;
                default:
                    break;
            }
        },

        brokenChecked: function brokenChecked() {
            if (this.isBrokenChecked) {
                this.$set('breeder.genotype[10]', "En");
            } else {
                this.$set('breeder.genotype[10]', "en");
            }
            this.$set('breeder.genotype[11]', "en");
        },
        add_existing_weight_date: function add_existing_weight_date(type) {
            if (type == "show") {
                if (this.breeder.existing_weight_date) {
                    this.sendBreeder();
                } else {
                    $('#add_date_weight').modal('show');
                }
            } else if (type == "add") {
                if (this.breeder.store_existing_weight_date) {
                    this.existing_weight_date = this.breeder.store_existing_weight_date;
                    this.breeder.weight_date[0] = this.breeder.store_existing_weight_date;
                    this.breeder_weight;
                    $('#add_date_weight').modal('hide');
                }
            }
        },
        initModal: function initModal() {
            var _this = this;

            var create = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.loading = 1;
            this.errors = {};
            this.checkErrors();
            this.initTabs();
            // this.$broadcast('breederWeigh');
            $("#breeder-documents").filestyle('clear');

            api.getBreedersList().then(function (breeders) {
                _this.weight_units = App.weight_units;
                _this.bucks = breeders.bucks;
                _this.does = breeders.does;

                _this.bucks = breeders.bucks;
                _this.does = breeders.does;

                for (var i = 0; i < _this.bucks.length; i++) {
                    if (+_this.bucks[i].id === +_this.breeder.father_id) {
                        _this.father_name = _this.bucks[i].name;
                    }
                }

                for (var _i = 0; _i < _this.does.length; _i++) {
                    if (+_this.does[_i].id === +_this.breeder.mother_id) {
                        _this.mother_name = _this.does[_i].name;
                    }
                }

                var tattooes = _this.uniqueFieldSet(_this.flattenBreeders, "tattoo");
                var cages = _this.uniqueFieldSet(_this.flattenBreeders, "cage");
                var colors = _this.uniqueFieldSet(_this.flattenBreeders, "color");
                var prefixes = _this.uniqueFieldSet(_this.flattenBreeders, "prefix");

                $('#breeder-cage').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: _this.substringMatcher(cages)
                });

                $('#breeder-tattoo').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: _this.substringMatcher(tattooes)
                });

                $('#breeder-color').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: _this.substringMatcher(colors)
                });

                $('#breeder-prefix').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: _this.substringMatcher(prefixes)
                });

                if (create) {
                    _this.setDefaultTattoo(tattooes);
                    _this.breeder.breed = App.default_breed;
                    _this.breeder.prefix = App.default_prefix;
                    _this.breeder.weight_unit_short = App.weight_slug;
                }

                _this.loading = 0;
            });

            $(this.breederForm).modal({
                backdrop: 'static',
                keyboard: false
            });
            $(this.breederForm).modal('show');
        },

        sendBreeder: function sendBreeder() {
            var _this2 = this;

            this.cleanUpGenotypes();
            this.loading = 1;
            // if(this.isBrokenChecked == true){
            //     this.isBrokenChecked = false;
            // }
            var breeder = (0, _assign2.default)({}, this.breeder);
            // var breeder = _.extend({}, this.breeder);

            if (breeder.weight_date != null) {
                this.tempDateStore = [];
                for (var i = 1; i <= breeder.weight_date.length; i++) {
                    var myDate = breeder.weight_date[i - 1];
                    var dateTimestemp = new Date(myDate).getTime();
                    this.tempDateStore.push(dateTimestemp);
                }
                breeder.weight_date = this.tempDateStore;
            }

            breeder.weight_changed = 1;
            if (breeder.new_weight) {

                if (!breeder.weight) {
                    breeder.weight = [];
                }

                breeder.weight.push(breeder.new_weight);

                if (breeder.today_date) {
                    if (App.dateFormat == "DD/MM/YYYY") {
                        var weight_date = breeder.today_date;
                        var d = new Date(weight_date.split("/").reverse().join("-"));
                        var dd = d.getDate();
                        var mm = d.getMonth() + 1;
                        var yy = d.getFullYear();
                        var new_date = mm + "/" + dd + "/" + yy;
                        var new_weight_date = new Date(new_date).getTime();
                    } else {
                        var new_weight_date = new Date(breeder.today_date).getTime();
                    }
                } else {
                    var new_weight_date = Date.now();
                }

                if (breeder.weight_date == null) {
                    breeder.weight_date = [];
                }

                // Handle existing weights without date
                var diff_length = breeder.weight.length - 1 - breeder.weight_date.length;
                for (var i = 1; i <= diff_length; i++) {
                    breeder.weight_date.push('null');
                }
                breeder.weight_date.push(new_weight_date);
            }

            if (Array.isArray(breeder.notes)) {
                breeder.notes = (0, _stringify2.default)(breeder.notes);
            }

            breeder.update_weight_format = true;

            var files = [];
            if (document.querySelector("#breeder-documents")) {
                files = document.querySelector("#breeder-documents").files;
            }

            api.saveBreeder(breeder).then(function (data) {
                _this2.loading = 0;
                _this2.$dispatch('breeder-saved');
                $(_this2.breederForm).modal('hide');
                _this2.$root.$emit('close-breeder');
                if (breeder.id == 0) {
                    _this2.breeders.push(data.breeder);
                    if (data.subscription.upgraded) {
                        _eventBus2.default.$emit('auto-upgrade-subscription', data.subscription);
                    }

                    _this2.showAlert({
                        type: 'success',
                        text: "New breeder \u201C" + data.breeder.name + "\u201D added.",
                        link: '/#!/profile/' + data.breeder.id,
                        linkText: 'View breeder profile here.'
                    });

                    _mixpanelBrowser2.default.track("Create breeder", { "Breeder ID": data.breeder.id });
                } else {
                    var match = _.find(_this2.breeders, function (item) {
                        return item.id === breeder.id;
                    });
                    if (match) {
                        _.extendOwn(match, data);
                    }
                    _this2.breeder = data;

                    _this2.showAlert({
                        type: 'success',
                        text: "Breeder \u201C" + data.name + "\u201D is updated.",
                        link: '/#!/profile/' + data.id,
                        linkText: 'View breeder profile here.'
                    });
                    _mixpanelBrowser2.default.track("Update breeder", { "Breeder ID": data.id });
                }

                if (files.length) {
                    _this2.saveDocuments(files, data.id || data.breeder.id);
                }

                _this2.$broadcast('breederWeigh');
                if (breeder.task_id) {
                    _this2.$root.$emit('close-task', breeder.task_id);
                }
            }, function (response) {
                _this2.loading = 0;
                _this2.errors = response.data.errors;
                _this2.checkErrors();
            });
        },
        closeModal: function closeModal() {
            this.$root.$emit('close-breeder');
            $(this.breederForm).modal('hide');
        },
        saveDocuments: function saveDocuments(files) {
            var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var attachment = {
                associated_id: id,
                associated_type: "breeder",
                title: "Document"
            };

            (0, _from2.default)(files).forEach(function (file) {
                attachment.title = file.name;
                api.addAttachment(attachment, file).then(function (data) {});
            });
        },


        checkDoubledId: function checkDoubledId() {
            var _this3 = this;

            api.checkBreederId(this.breeder.id, this.breeder.tattoo).then(function (check) {
                if (check.idDoubled) {
                    _this3.errors = { tattoo: ['Sorry, this Breeder ID already exists. Please choose a unique Breeder ID or archive the rabbit with the duplicate ID first.'] };
                } else {
                    _this3.errors = {};
                }
            });
        },

        addNewBuck: function addNewBuck() {
            var _this4 = this;

            this.loading = 1;
            api.saveBreeder(_.extend({}, App.emptyBreeder, this.newBuck)).then(function (data) {
                _this4.loading = 0;
                if (data.id) {
                    _this4.bucks.push(data);
                    _this4.breeder.father_id = data.id;
                }
                _this4.newBuck = { sex: "buck" };
            });
        },

        addNewDoe: function addNewDoe() {
            var _this5 = this;

            this.loading = 1;
            api.saveBreeder($.extend({}, App.emptyBreeder, this.newDoe)).then(function (data) {
                _this5.loading = 0;
                if (data.id) {
                    _this5.does.push(data);
                    _this5.breeder.mother_id = data.id;
                }
                _this5.newDoe = { sex: "doe" };
            });
        },
        loadCategories: function loadCategories() {
            var _this6 = this;

            if (App.isSubscribed) {
                this.loading = 1;
                api.getBreederCategories().then(function (data) {
                    _this6.loading = 0;
                    _this6.categories = data.categories;
                    _this6.emptyModel.category_id = _this6.breeder.category_id || _this6.categories.find(function (cat) {
                        return cat.default;
                    }).id;
                });
            }
        },

        initTypeahead: function initTypeahead() {
            this.breedersList = this.getBreedersAutocompleteList().sort(function (a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });
        },

        setDefaultTattoo: function setDefaultTattoo(tattooes) {
            var biggestTattoo = 0;

            tattooes.map(function (tattoo) {
                var numTattoo = parseInt(tattoo);
                if (numTattoo > biggestTattoo) {
                    biggestTattoo = numTattoo;
                }
            });

            this.breeder.tattoo = ++biggestTattoo;
        },
        setBygenotypeCode: function setBygenotypeCode() {
            this.breeder.genotype = [];
            var geno = this.getBygenotypeCodeValue.split("/");
            for (var i = 0; i < 10; i++) {
                this.breeder.genotype[i] = geno[i];
            }
            this.breeder.genotype[10] = "en";
            this.breeder.genotype[11] = "en";
        },
        setBygenotypeCodeV2: function setBygenotypeCodeV2() {
            var genotype = [];
            var geno = this.getBygenotypeCodeValue.split("/");
            for (var i = 0; i < 10; i++) {
                genotype[i] = geno[i];
            }
            genotype[10] = "en";
            genotype[11] = "en";
            this.isBrokenChecked = false;

            this.$set('breeder.genotype', genotype);
        },
        initTabContent: function initTabContent() {
            if (!this.breeder.id) {
                this.tabs.weight = 0;
                this.tabs.show_record = 3;
                this.tabs.photos = 4;
            }

            // init tabs if show record isn't available
            if (!App.isShowShow) {
                this.tabs.show_record = 0;
                if (this.breeder.id) {
                    this.tabs.weight = 3;
                    this.tabs.photos = 4;
                } else {
                    this.tabs.weight = 0;
                    this.tabs.photos = 3;
                }
            }
        },
        initTabs: function initTabs() {
            var _this7 = this;

            this.initTabContent();
            this.currentTab = 1;
            $('.nav-pills a[href="#rabbit"]').tab('show');

            var self = this;
            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                var target = $(e.target).attr("href");
                target = target.replace("#", "");

                self.currentTab = self.tabs[target];
            });

            this.$nextTick(function () {
                if (_this7.breeder.isWeight) {
                    $(_this7.breederForm + ' .nav-pills a[href="#weight_tab"]').tab('show');
                }
            });
        },
        nextTab: function nextTab() {
            var _this8 = this;

            var tab = this.currentTab + 1;
            var keys = (0, _keys2.default)(this.tabs);
            keys.forEach(function (key, index) {
                if (_this8.tabs[key] == tab) {
                    $('.nav-pills a[href="#' + key + '"]').tab('show');
                }
            });
        },
        initAttachments: function initAttachments() {
            var _this9 = this;

            this.breederAttachments = [];

            if (this.hasAccess(App.access.attachments) && this.breeder.id) {
                var data = {
                    associatedType: "breeder",
                    associatedId: this.breeder.id,
                    page: 1,
                    perPage: 5,
                    order: "created_at|desc"
                };

                api.getAttachments(data).then(function (data) {
                    _this9.breederAttachments = data.items.data;
                });
            }
        },
        checkErrors: function checkErrors() {
            var _this10 = this;

            var errors = this.errors;
            this.tabErrors = {
                rabbit: null,
                history: null,
                weight: null,
                show_record: null,
                photos: null
            };
            var fields = {
                rabbit: ['category_id', 'prefix', 'name', 'tattoo', 'cage', 'color', 'breed', 'sex'],
                history: ['date_of_birth', 'aquired', 'father_id', 'mother_id', 'genotype'],
                show_record: ['registration_number', 'champion_number', 'legs'],
                weight: ['weight', 'weight_date'],
                photos: ['image', 'images']
            };

            _.map(fields, function (item, key) {
                _.map(item, function (field) {
                    if (errors.hasOwnProperty(field)) {
                        _this10.tabErrors[key] = true;
                    }
                });
            });
        }
    },
    ready: function ready() {
        this.initTabs();
        this.initTypeahead();
        this.initGenotypes();

        $('.js_icheck-breeder-blue').iCheck({
            checkboxClass: 'icheckbox_square-blue',
            radioClass: 'iradio_square-blue'
        }).on('ifChecked', function (event) {
            this.breeder.sex = "buck";
        }.bind(this));

        //Red color scheme for iCheck
        $('.js_icheck-breeder-red').iCheck({
            checkboxClass: 'icheckbox_square-red',
            radioClass: 'iradio_square-red'
        }).on('ifChecked', function (event) {
            this.breeder.sex = "doe";
        }.bind(this));

        // init filestyle
        $("#breeder-documents").filestyle({
            // buttonText: "Upload"
        });

        this.isShowShow = App.isShowShow;
    },

    mixins: [App.Mixins.Auth, App.Mixins.BreedersFilter, App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.Weightable, App.Mixins.FieldDescription, App.Mixins.Alerts, App.Mixins.Attachments, App.Mixins.Photos]
});

},{"../event-bus":882,"babel-runtime/core-js/array/from":17,"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22,"babel-runtime/core-js/object/keys":27,"mixpanel-browser":634}],728:[function(require,module,exports){
'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.BreederImagesForm = {
    template: "#breeder-images-form-template",
    data: function data() {
        return {
            loading: 0
        };
    },
    props: ['breeder'],
    components: {
        'image-upload': App.Components.ImageUpload
    },
    events: {
        'breeder-images-edit': function breederImagesEdit() {
            this.initModal();
        }
    },
    methods: {
        initModal: function initModal() {
            var create = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            $('#breeder-images-form').modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#breeder-images-form').modal('show');
            $('#breeder-images-form').on('shown.bs.modal', function (e) {
                $('#breeder-images-form').removeClass('in');
            });
        },

        saveImages: function saveImages() {
            var _this = this;

            this.loading = 1;

            var breeder = (0, _assign2.default)({}, this.breeder);

            api.saveBreederImage(breeder.id, breeder).then(function (response) {
                _this.loading = 0;
                _this.breeder.image = response.image;
                _this.breeder.images = response.images;
                $('#breeder-images-form').modal('hide');
            }, function (response) {
                _this.errors = response.data.errors;
            });
        }
    }
};

},{"babel-runtime/core-js/object/assign":22}],729:[function(require,module,exports){
"use strict";

App.Components.BreederCategoriesOld = App.Components.BreederCategories.extend({
    template: "#breeder-category-old-template"
});

},{}],730:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.BreederCategories = App.Components.Exploitable.Section.extend({
    template: "#breeder-category-template",
    data: function data() {
        return {
            categories: [],
            hasArchive: false,
            loading: 1,
            deleter: api.deleteBreederCategory,
            subDropdownOpend: false,
            newCategory: null,
            categoryIndexToEdit: {},
            isShowInvalidName: false
        };
    },

    props: ['isGlobal'],
    computed: {
        models: function models() {
            return this.categories;
        },
        categoryModal: function categoryModal() {
            return this.isGlobal ? "#global-breeder-categories-modal" : "#breeder-categories-modal";
        },
        categoryForm: function categoryForm() {
            return this.isGlobal ? "#global-breeder-category-form" : "#breeder-category-form";
        }
    },
    components: {
        'breeder-category-form': App.Components.BreederCategoryForm
    },
    events: {
        'formAdded': function formAdded() {
            App.vent.trigger('sidebar-reload-breeder-categories');
        },
        'formUpdated': function formUpdated() {
            App.vent.trigger('sidebar-reload-breeder-categories');
        },
        'deletedModel': function deletedModel() {
            App.vent.trigger('sidebar-reload-breeder-categories');
        }
    },
    watch: {
        categoryIndexToEdit: {
            handler: function handler(newData, oldData) {
                if (oldData.index !== undefined && newData.index != oldData.index) {
                    _.map(this.categories, function (category) {
                        if (oldData.id == category.id) {
                            category.name = oldData.name;
                            category.description = oldData.description;
                        }
                    });
                }
            },
            deep: true
        }
    },
    methods: {
        addCategory: function addCategory() {
            if (this.categories[0].id != 0) {
                var category = {
                    id: 0,
                    index: 0,
                    name: "",
                    description: "",
                    count: 0
                };

                this.categories.unshift(category);
            }

            this.categoryIndexToEdit = (0, _extends3.default)({}, this.categories[0]);
        },
        editCategory: function editCategory(category, index) {
            if (this.isInvalidName()) {
                return false;
            }

            this.categoryIndexToEdit = {
                id: category.id,
                index: index,
                name: category.name,
                description: category.description
            };
        },
        addModel: function addModel() {
            $(this.categoryForm).modal('show');
        },
        hoverSubdropdown: function hoverSubdropdown(event) {
            var elem = event.target;
            if (elem.classList.contains('hoverClass')) this.subDropdownOpend = true;else this.subDropdownOpend = false;
        },
        updateList: function updateList() {
            var _this = this;

            if (App.isSubscribed) {
                api.getBreederCategories().then(function (data) {
                    _this.loading = 0;
                    _this.categories = data.categories;
                });
            }
        },
        handleChange: function handleChange() {
            if (this.$route.query.newModal) {
                this.addNew();
            }
            if (this.$route.query.editModal) {
                this.showEditCategoryModal();
            }
        },
        showEditCategoryModal: function showEditCategoryModal() {
            var _this2 = this;

            var category = this.categories.find(function (x) {
                return x.id === parseInt(_this2.$route.query.editModal);
            });
            if (category) {
                this.editModel(category);
            }
        },
        showDeleteBreederCategory: function showDeleteBreederCategory() {
            $('#delete-breeder-category-modal').modal('show');
        },
        removeAddedCategory: function removeAddedCategory() {
            if (this.categories[0].id == 0) {
                this.categories.shift();
                this.categoryIndexToEdit = {};
            }
        },
        cancelCategoryEdit: function cancelCategoryEdit() {
            this.categoryIndexToEdit = {};
            this.updateList();
        },
        saveCategoryEdit: function saveCategoryEdit() {
            var _this3 = this;

            if (this.isInvalidName()) {
                return false;
            }

            this.categoryIndexToEdit = {};

            this.$nextTick(function () {
                _.map(_this3.categories, function (category) {
                    api.saveBreederCategory(category).then(function (data) {
                        _this3.loading = 0;_this3.$emit('submitted', data);
                    }, function (response) {
                        _this3.loading = 0;_this3.$emit('submitError', response.data);
                    });
                });
            });

            $(this.categoryModal).modal('hide');
        },
        isInvalidName: function isInvalidName() {
            var _this4 = this;

            if (this.categoryIndexToEdit.index !== undefined) {
                var id = this.categoryIndexToEdit.id;
                var name = this.categoryIndexToEdit.name;
                var description = this.categoryIndexToEdit.description;

                if (id == 0 && name == "" && description == "") {
                    this.isShowInvalidName = false;
                    return false;
                }

                if (name == "" || name.length < 3) {
                    this.isShowInvalidName = "The name must be at least 3 characters.";
                    return true;
                }

                var nameCheck = false;
                _.map(this.categories, function (category) {
                    if (category.name == name && category.id != id) {
                        _this4.isShowInvalidName = "The name must be unique.";
                        nameCheck = true;
                    }
                });

                return nameCheck;
            }

            this.isShowInvalidName = false;
            return false;
        }
    },
    ready: function ready() {
        var _this5 = this;

        this.updateList();

        if (this.$route.query.newModal) {
            this.addModel();
        }

        if (this.$route.query.editModal) {
            this.showEditCategoryModal();
        }

        this.$watch('$route.query.newModal', this.handleChange, { deep: true });
        this.$watch('$route.query.editModal', this.handleChange, { deep: true });

        $(document).on('hide.bs.modal', this.categoryForm, function (event) {
            if ($(event.target).is(_this5.categoryForm) && _this5.$route.query.editModal) {
                _this5.$route.router.go('/breeders/categories');
            }
        });

        $(this.categoryModal).on('shown.bs.modal', function () {
            _this5.updateList();
        });
    }
});

},{"babel-runtime/helpers/extends":37}],731:[function(require,module,exports){
'use strict';

App.Components.BreederCategoryForm = App.Components.Exploitable.Form.extend({
    template: "#breeder-category-form-template",
    data: function data() {
        return {
            modal_id: '#breeder-category-form',
            emptyModel: {
                description: ''
            },
            category: {},
            saver: api.saveBreederCategory
        };
    },
    computed: {
        model: {
            get: function get() {
                return this.category;
            },
            set: function set(model) {
                this.category = model;
            }
        }
    },
    watch: {
        category: function category() {
            $('#category-name').typeahead('val', this.category.name);
        }
    },
    methods: {
        initTypeahead: function initTypeahead() {
            api.getBreederCategoriesAutocomplete().then(function (data) {
                var names = data.name;
                $('#category-name').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: function source(req, callback) {
                        callback(names.filter(function (name) {
                            return name.toLowerCase().indexOf(req.toLowerCase()) !== -1;
                        }));
                    }
                });
            });
        }
    },
    ready: function ready() {
        this.initTypeahead();
    }
});

},{}],732:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.emptyBreeder = {
    "id": 0,
    "category_id": '1',
    "prefix": '',
    "name": '',
    "breed": '',
    "cage": '',
    "tattoo": '',
    "sex": 'doe',
    "weight": '',
    "father_id": 0,
    "mother_id": 0,
    "father_name": null,
    "mother_name": null,
    "color": '',
    "date_of_birth": null,
    "aquired": moment(new Date()).format(App.dateFormat),
    "registration_number": "",
    "champion_number": "",
    "legs": "",
    "archived": 0,
    "culled": 0,
    "died": 0,
    "died_at": null,
    "butchered": 0,
    "butchered_at": null,
    "sold_at": null,
    "status": "",
    "status_date": null,
    "image": {
        "name": '',
        "path": '',
        "temp": true,
        "oldImage": '',
        "delete": false
    },
    "images": [],
    "notes": '',
    "level": '',
    "genotype": [],
    "weight_unit": App.weight_units || "",
    "weight_unit_short": ''
};

App.Components.Breeders = Vue.extend({
    template: "#breeders-template",
    data: function data() {
        return {
            breeder: _.extend({}, App.emptyBreeder),
            breeders: [],
            transfers: [],
            pages: 1,
            activeBreeder: {},
            plans: [],
            activeBirth: {},
            loading: 1,
            litters: [],
            order: 'tattoo|asc',
            soldValue: 0,
            soldAt: null,
            transferTo: '',
            transferErrors: {},
            categories: [],
            preFilters: {
                name: '',
                breed: '',
                cage: '',
                color: '',
                prefix: '',
                tattoo: '',
                date_of_birth: {
                    from: null,
                    to: null
                },
                aquired: {
                    from: null,
                    to: null
                },
                category_id: '',
                bred: null
            },
            filters: {
                name: '',
                breed: '',
                cage: '',
                color: '',
                prefix: '',
                tattoo: '',
                date_of_birth: {
                    from: null,
                    to: null
                },
                aquired: {
                    from: null,
                    to: null
                },
                category_id: '',
                bred: null
            },
            preFilterRanges: {
                date_of_birth: [],
                aquired: []
            },
            filterRanges: {
                date_of_birth: [],
                aquired: []
            },
            filterRules: {
                name: 'string',
                breed: 'string',
                cage: 'string',
                color: 'string',
                tattoo: 'string',
                date_of_birth: 'daterange',
                aquired: 'daterange',
                category_id: 'number',
                bred: 'bool'
            },
            searchFields: ['name', 'breed', 'cage', 'color', 'tattoo', 'notes'],
            subDropdownOpend: false,
            subEditFunctionsOpened: null,
            bredArr: [{
                name: 'All',
                value: null
            }, {
                name: 'Bred',
                value: true
            }, {
                name: 'Open',
                value: false
            }],
            openDoes: false,
            template: {},
            limitContent: {
                title: "You have exceeded the maximum amount of breeders",
                message: "Please upgrade your account to add more!",
                meta: {}
            },
            isTileView: true,
            query: "",
            page: 1,
            perPage: 10,
            totalPages: 1,
            totalCount: 0,
            description: {},
            currentSort: 'created_at',
            currentOrder: 'asc',
            displayItems: {
                rabbit_name: true,
                gender: true,
                photo: true,
                id: true,
                breed: true,
                age: true,
                weight: true,
                no_litters: true,
                no_kits: true,
                color: true,
                category: false,
                cage: false,
                status: true
            },
            closableDropdown: true,
            breedersList: [],
            newFilters: [],
            btn_name: [],
            newSexFilter: "all",
            actionableBreeders: []
        };
    },
    props: [],
    components: {
        'breed-form': App.Components.BreedForm,
        'birth-form': App.Components.BirthForm,
        'breeder-form': App.Components.BreederForm,
        'breeder-categories': App.Components.BreederCategories,
        'litter-weight': App.Components.LitterWeight,
        'litter-butcher': App.Components.LitterButcher,
        'multiple-breeder-form': App.Components.MultipleBreederForm
    },
    computed: {
        filter: function filter() {
            return this.$route.params.action;
        },
        category: function category() {
            return this.$route.params.category;
        },
        currentRoute: function currentRoute() {
            return this.$route.path.split('?')[0];
        },
        confirmTarget: function confirmTarget() {
            return this.activeBreeder.name;
        },
        confirmTargetDied: function confirmTargetDied() {
            return this.activeBreeder.died;
        },
        pages: function pages() {
            // set a minimum of 1 page
            var maxPages = this.totalPages > 0 ? this.totalPages : 1;
            var pages = [];
            while (maxPages > 0) {
                var page = {
                    title: maxPages,
                    isActive: this.page == maxPages
                };
                pages.push(page);

                maxPages--;
            }

            return pages.reverse();
        },

        newOrder: function newOrder() {
            return this.currentSort + "|" + this.currentOrder;
        },
        disableActive: function disableActive() {
            return !!(this.newFilters.length && !this.newFilters.includes('open'));
        },
        isMultipleBreed: function isMultipleBreed() {
            var hasDoe = _.find(this.actionableBreeders, function (breeder) {
                return breeder.sex == 'doe';
            });

            return hasDoe;
        },
        actionableDoes: function actionableDoes() {
            return _.filter(this.actionableBreeders, function (breeder) {
                return breeder.sex == 'doe';
            });
        }
    },

    watch: {
        searchQuery: function searchQuery(newData, oldData) {
            console.log('searchQuery');
            this.page = 1;
            if (this.isTileView) {
                this.itemsLoaded = 0;
                this.disableLoadMore = false;
                this.loadMore();
            } else {
                this.updateList();
            }

            if (oldData == "") {
                this.newFilters = [];
                this.$router.go({ path: '/breeders/all' });
            }
        },

        category: function category() {
            this.page = 1;
            this.updateList();
        },
        filters: {
            handler: function handler(newVal, oldVal) {
                this.page = 1;
                this.saveFilters();
                this.updateList();
            },
            deep: true
        },
        '$route.path': function $routePath() {
            this.page = 1;
            if (this.$route.path.indexOf('opendoes') >= 0) {
                this.openDoes = true;
                this.filters.bred = false;
            } else {
                this.openDoes = false;
                this.filters.bred = null;
            }
        }
    },
    events: {
        'open-breed-modal': function openBreedModal(msg) {
            this.$broadcast('new-breed-with-doe', msg);
        },
        'breeder-saved': function breederSaved() {
            this.loadCategories();
        }
    },
    methods: {
        showGlobalFormsModal: function showGlobalFormsModal() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "genetic-prediction-form";

            switch (type) {
                case "genetic-prediction-form":
                    this.$root.$emit('global-predict-form-modal');
                    break;
                case "line-breeding-form":
                    console.log("breeder.js");
                    this.$root.$emit('global-line-breeding-form-modal');
                    break;
                default:
                    break;
            }
        },

        applyWatchers: function applyWatchers() {
            var _this = this;

            this.$watch('isTileView', function (newData, oldData) {
                _this.$nextTick(function () {
                    _this.initializeDisplayItems();
                });
            });

            this.$watch('filter', function (newData, oldData) {
                _this.page = 1;
                _this.updateList();
            });

            this.$watch('perPage', function (newData, oldData) {
                _this.page = 1;
                _this.updateList();
            });

            this.$watch('order', function (newData, oldData) {
                var data = newData.split('|');
                _this.currentSort = data[0];
                _this.currentOrder = data[1];
                _this.updateList();
            });
        },
        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        isShowIcon: function isShowIcon(breeder) {
            var isShow = !breeder.pregnant && !breeder.butchered && this.getBreederStatus(breeder) != 'Active';

            if (breeder.sex == 'doe' && !breeder.pregnant) {
                if (!this.searchQuery && !(this.newFilters && this.newFilters.includes('open'))) {
                    isShow = false;
                }
            }

            return isShow;
        },

        isDoe: function isDoe(sex) {
            return sex === 'doe';
        },
        breedModal: function breedModal(breeder) {
            if (this.isDoe(breeder.sex)) {
                this.$broadcast('new-breed-with-doe', breeder.id);
            } else {
                this.$broadcast('new-breed-with-buck', breeder.id);
            }
        },
        birthModal: function birthModal(plan_id) {
            var _this2 = this;

            this.activeBirth = { breedplan: plan_id || '-1', born: moment(new Date()).format(App.dateFormat) };
            this.$broadcast('new-birth-modal-open');
            api.getUsersPlans().then(function (plans) {
                _this2.plans = plans;
                $('#birth-form-modal').modal('show');
            });
        },
        hoverSubdropdown: function hoverSubdropdown(event) {
            var elem = event.target;
            if (elem.classList.contains('hoverClass')) this.subDropdownOpend = true;else this.subDropdownOpend = false;
        },
        saveFilters: function saveFilters() {
            localStorage.setItem('filters', (0, _stringify2.default)(this.filters));
            localStorage.setItem('newFilters', (0, _stringify2.default)(this.newFilters));
        },
        getFilters: function getFilters() {
            return JSON.parse(localStorage.getItem('filters'));
        },
        getNewFilters: function getNewFilters() {
            return JSON.parse(localStorage.getItem('newFilters'));
        },
        buildFilters: function buildFilters() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var isActiveFilter = (this.newFilters || []).length;

            data.all = this.filter === 'all' ? 1 : 0;
            data.archived = ['archive', isActiveFilter ? 'active' : 'inactive'].includes(this.filter) ? 1 : 0;
            data.culled = ['culled', isActiveFilter ? 'active' : 'inactive'].includes(this.filter) ? 1 : 0;
            data.to_cull = ['to_cull', isActiveFilter ? 'active' : 'inactive'].includes(this.filter) ? 1 : 0;
            data.sold = ['sold', isActiveFilter ? 'active' : 'inactive'].includes(this.filter) ? 1 : 0;
            data.butchered = ['butchered', isActiveFilter ? 'active' : 'inactive'].includes(this.filter) ? 1 : 0;
            data.died = ['died', isActiveFilter ? 'active' : 'inactive'].includes(this.filter) ? 1 : 0;
            data.sex = this.newSexFilter != 'all' ? this.newSexFilter : null;

            _.each(this.newFilters, function (filter) {
                data[filter] = 1;
            });

            // build bred data filters
            if (this.newFilters && this.newFilters.includes('open')) {
                this.openDoes = true;
                this.filters.bred = false;
            } else {
                this.openDoes = false;
                this.filters.bred = null;
            }

            return data;
        },

        updateList: function updateList() {
            var _this3 = this;

            this.loading = 1;
            this.perPage = localStorage.getItem('perPage') || 10;
            var data = { page: this.page, perPage: this.perPage };
            if (this.order) {
                data.order = this.order;
            }

            this.filters.category_id = this.category || this.filters.category_id;

            data = this.buildFilters(data);

            switch (this.filter) {
                case 'bucks':
                    data.sex = 'buck';
                    break;
                case 'does':
                    data.sex = 'doe';
                    break;
            }

            data.filters = this.filters;
            data.searchQuery = this.searchQuery;

            api.getTransferBreeders().then(function (data) {
                _this3.transfers = data.breeders;
            });

            data.update_weight_format = true;
            api.getBreeders(data).then(function (data) {
                _this3.breeders = data.breeders.data;
                _this3.pages = data.breeders.last_page;
                _this3.order = data.order;
                _this3.loading = 0;
                _this3.itemsLoaded = data.breeders.current_page;
                _this3.disableLoadMore = !_this3.isTileView;
                _this3.totalItems = data.breeders.total;

                // for list view
                _this3.totalPages = data.breeders.last_page;
                _this3.totalCount = data.breeders.total;
                _this3.description = {
                    from: data.breeders.from,
                    to: data.breeders.to,
                    total: data.breeders.total
                };
                $('#f-breeder-date_of_birth').trigger('triggerDaterangepicker');
                $('#f-breeder-aquired').trigger('triggerDaterangepicker');

                _this3.$nextTick(function () {
                    _this3.initializeBreederCheckbox();
                });
            });

            this.loadCategories();
        },

        acceptTransfer: function acceptTransfer(transfer) {
            var _this4 = this;

            this.claimLoading = 1;
            api.checkBreedersLimit().then(function (data) {
                if (data.ok === true) {
                    api.acceptTransfer(transfer).then(function (data) {
                        if (data.result) {
                            _this4.$router.go(data.result.url.split('/#!').pop());
                        }
                    });
                } else {
                    _this4.showBreederLimit(data);
                }

                _this4.claimLoading = 0;
            });
        },

        addNew: function addNew() {
            var _this5 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok === true) {
                    _this5.breeder = JSON.parse((0, _stringify2.default)(App.emptyBreeder));
                    _this5.$broadcast('breeder-add-new');
                } else {
                    _this5.showBreederLimit(data);
                }
            });
        },

        editModal: function editModal(breeder) {
            this.breeder = _.extend({}, breeder);
            this.$broadcast('breeder-edit');
        },

        initUploader: function initUploader() {
            var self = this;
            $(self.$els['image']).fileupload({
                dataType: 'json',
                paramName: 'image',
                formData: {
                    "_token": App.token,
                    "_method": "POST"
                },
                url: '/admin/images/uploadImage',
                done: function done(e, data) {
                    self.breeder.image.name = data.result.image.name;
                    self.breeder.image.path = data.result.image.path;
                    self.breeder.image.temp = data.result.image.temp;
                }
            });
        },

        getGenderClass: function getGenderClass(sex) {
            return sex == "buck" ? "bg-aqua-active" : "bg-maroon-active";
        },

        onlyNumbers: function onlyNumbers(e) {
            return e.charCode >= 48 && e.charCode <= 57;
        },

        prevPage: function prevPage() {
            if (this.page - 1 > 0) {
                this.$router.go({
                    path: this.currentRoute,
                    query: {
                        page: this.page - 1
                    }
                });
            }
        },

        nextPage: function nextPage() {
            if (Number(this.page) + 1 <= this.pages) {
                this.$router.go({
                    path: this.currentRoute,
                    query: {
                        page: Number(this.page) + 1
                    }
                });
            }
        },

        deleteImage: function deleteImage() {
            this.breeder.image = { name: "", path: "", temp: true, oldImage: "", delete: false };
        },

        archiveModal: function archiveModal(breeder) {
            var _this6 = this;

            api.checkBreedersLimit(true).then(function (data) {
                if (data.ok) {
                    _this6.activeBreeder = breeder;
                    $('#archive-breed-modal').modal('show');
                } else {
                    _this6.showBreederLimit(data);
                }
            });
        },
        archive: function archive() {
            var _this7 = this;

            $('#archive-breed-modal').modal('hide');
            api.archiveBreeder(this.activeBreeder).then(function () {
                _this7.refreshData();
                _this7.showAlert({
                    type: 'warning',
                    text: _this7.activeBreeder.name + " has been archived."
                });
            }, function (response) {
                if (response.data === 'breeders-limit-exceeded') {
                    _this7.showBreederLimit(false);
                }
            });
        },
        markForSaleModal: function markForSaleModal(breeder) {
            if (App.hasMarketplaceProfile) {
                this.activeBreeder = breeder;
                $('#mark-for-sale-modal').modal('show');
            } else {
                $('#no-marketplace-profile-modal').modal('show');
            }
        },
        markForSale: function markForSale() {
            var _this8 = this;

            var params = (0, _extends3.default)({
                listable_id: this.activeBreeder.id,
                listable_type: "breeder",
                amount: this.listingAmount || 0,
                is_active: this.isListOnMarketplace,
                description: this.listingNotes
            }, this.marketplaceFields);

            api.markForSale(params).then(function (data) {
                _this8.refreshData();

                if (_this8.isListOnMarketplace) {
                    _this8.showAlert({
                        type: 'success',
                        text: "\n                                Congratulations! You've listed <b>" + _this8.activeBreeder.name + "</b> on the Everbreed Marketplace.<br/><br/>\n                                Here is a link to the public listing that you can share on social media or with potential buyers:",
                        link: _this8.marketplaceUrl + '/listings/' + data.listing.id + '/details',
                        linkText: 'Link to listing',
                        newTab: true,
                        hideAfter: 10000
                    });
                } else {
                    _this8.showAlert({
                        type: 'success',
                        text: _this8.activeBreeder.name + " has been marked as for sale."
                    });
                }

                _this8.isListOnMarketplace = false;
                _this8.isAgreeToTerms = false;
                _this8.listingAmount = 0;
                _this8.listingNotes = "";
                _this8.marketplaceFields = {
                    name: true,
                    tattoo: true,
                    breed: true,
                    date_of_birth: true,
                    sex: true,
                    image: true,
                    weight: true,
                    genotype: true,
                    pedigree: true
                };
                $('#mark-for-sale-modal').modal('hide');
            }, function (response) {});
        },

        removeForSaleModal: function removeForSaleModal(breeder) {
            var _this9 = this;

            api.checkBreedersLimit(true).then(function (data) {
                if (data.ok) {
                    _this9.activeBreeder = breeder;
                    $('#remove-for-sale-modal').modal('show');
                } else {
                    _this9.showBreederLimit(data);
                }
            });
        },
        removeForSale: function removeForSale() {
            var _this10 = this;

            var params = {
                id: this.activeBreeder.for_sale.id
            };

            api.removeForSale(params).then(function (data) {
                _this10.refreshData();
                _this10.showAlert({
                    type: 'success',
                    text: _this10.activeBreeder.name + " has been removed for sale."
                });

                $('#remove-for-sale-modal').modal('hide');
            }, function (response) {});
        },


        /**
         * (START) New sell/transfer flow
         * NOTE: to be transferred to exploitable->sections
         */
        soldModal: function soldModal(breeder) {
            var _this11 = this;

            api.checkBreedersLimit(true).then(function (data) {
                if (data.ok) {
                    _this11.activeBreeder = breeder;
                    $('#sold-breed-modal').modal('show');
                } else {
                    _this11.showBreederLimit(data);
                }
            });
        },
        closeSoldModal: function closeSoldModal() {
            $('#sold-breed-modal').modal('hide');
            this.transferErrors = {};
            this.transferTo = '';
            this.soldValue = 0;
            this.soldAt = null;
            this.refreshData();
        },
        sold: function sold() {
            var _this12 = this;

            // add checker if sold to field has value
            if (this.transferTo && this.transferTo != "add") {
                // verify if the email is valid
                api.verifyTransferableBreeder(this.activeBreeder, this.transferTo).then(function () {
                    // show confirm transfer modal
                    $('#sold-breed-modal').modal('hide');
                    $('#confirm-transfer-breed-modal').modal('show');
                }, function (error) {
                    // show errors on form
                    _this12.transferErrors = error.data.errors;
                });
            } else {
                // sell breeder directly if sold to field is empty
                var payload = { value: this.soldValue, date: this.soldAt };
                api.sellBreeder(this.activeBreeder, payload).then(function () {
                    _this12.closeSoldModal();
                    _this12.showAlert({
                        type: 'success',
                        text: _this12.activeBreeder.name + " has been sold."
                    });
                }, function (error) {
                    if (response.data == 'breeders-limit-exceeded') {
                        _this12.showBreederLimit(false);
                    }
                });
            }
        },
        confirmTransfer: function confirmTransfer() {
            var _this13 = this;

            // hide confirm transfer modal
            $('#confirm-transfer-breed-modal').modal('hide');

            // sell breeder
            var payload = { value: this.soldValue, date: this.soldAt };
            api.sellBreeder(this.activeBreeder, payload).then(function () {
                // transfer breeder to new owner
                api.transferBreeder(_this13.activeBreeder, _this13.transferTo).then(function () {
                    _this13.closeSoldModal();
                    _this13.showAlert({
                        type: 'success',
                        text: _this13.activeBreeder.name + " has been transfered."
                    });
                }, function (response) {
                    _this13.transferErrors = response.data.errors;
                    _this13.unconfirmTransfer();
                });
            });
        },
        unconfirmTransfer: function unconfirmTransfer() {
            $('#confirm-transfer-breed-modal').modal('hide');
            $('#sold-breed-modal').modal('show');
        },
        /**
         * (END) New sell/transfer flow
         */

        declineTransferModal: function declineTransferModal(transfer) {
            this.activeBreeder = transfer;
            $('#decline-transfer-breed-modal').modal('show');
        },
        declineTransfer: function declineTransfer() {
            var _this14 = this;

            $('#decline-transfer-breed-modal').modal('hide');
            api.declineTransfer(this.activeBreeder).then(function () {
                if (_this14.isTileView) {
                    $('#transfer_id_' + _this14.activeBreeder.transfer_id).slideUp(200);
                } else {
                    _this14.refreshData();
                }
            });
        },

        unsoldModal: function unsoldModal(breeder) {
            var _this15 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    _this15.activeBreeder = breeder;
                    $('#unsold-breed-modal').modal('show');
                } else {
                    _this15.showBreederLimit(data);
                }
            });
        },
        unsold: function unsold() {
            var _this16 = this;

            $('#unsold-breed-modal').modal('hide');
            api.unsellBreeder(this.activeBreeder).then(function () {
                _this16.refreshData();
                _this16.showAlert({
                    type: 'success',
                    text: _this16.activeBreeder.name + " has been unsold."
                });
            }, function (response) {
                if (response.data === 'breeders-limit-exceeded') {
                    _this16.showBreederLimit(false);
                } else {
                    _this16.showAlert({
                        type: 'danger',
                        text: response.data.error
                    });
                }
            });
        },

        unarchiveModal: function unarchiveModal(breeder) {
            var _this17 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    _this17.activeBreeder = breeder;
                    $('#unarchive-breed-modal').modal('show');
                } else {
                    _this17.showBreederLimit(data);
                }
            });
        },
        unarchive: function unarchive() {
            var _this18 = this;

            $('#unarchive-breed-modal').modal('hide');
            api.unarchiveBreeder(this.activeBreeder).then(function () {
                _this18.refreshData();
                _this18.showAlert({
                    type: 'success',
                    text: _this18.activeBreeder.name + " has been unarchived."
                });
            }, function (response) {
                if (response.data === 'breeders-limit-exceeded') {
                    _this18.showBreederLimit(false);
                } else {
                    _this18.showAlert({
                        type: 'danger',
                        text: response.data.error
                    });
                }
            });
        },

        cullModal: function cullModal(breeder) {
            this.activeBreeder = breeder;
            $('#cull-breed-modal').modal('show');
        },

        cull: function cull() {
            var _this19 = this;

            $('#cull-breed-modal').modal('hide');
            api.cullBreeder(this.activeBreeder).then(function () {
                _this19.refreshData();
                _this19.showAlert({
                    type: 'warning',
                    text: _this19.activeBreeder.name + " has been culled."
                });
            }, function (response) {
                if (response.data === 'breeders-limit-exceeded') {
                    _this19.showBreederLimit(false);
                }
            });
        },

        uncullModal: function uncullModal(breeder) {
            var _this20 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    _this20.activeBreeder = breeder;
                    $('#uncull-breed-modal').modal('show');
                } else {
                    _this20.showBreederLimit(data);
                }
            });
        },

        uncull: function uncull() {
            var _this21 = this;

            $('#uncull-breed-modal').modal('hide');
            api.uncullBreeder(this.activeBreeder).then(function () {
                _this21.refreshData();
                _this21.showAlert({
                    type: 'success',
                    text: _this21.activeBreeder.name + " has been unculled."
                });
            }, function (response) {
                if (response.data === 'breeders-limit-exceeded') {
                    _this21.showBreederLimit(false);
                } else {
                    _this21.showAlert({
                        type: 'danger',
                        text: response.data.error
                    });
                }
            });
        },

        deleteModal: function deleteModal(breeder) {
            this.activeBreeder = breeder;
            $('#delete-breed-modal').modal('show');
        },
        delete: function _delete() {
            var _this22 = this;

            $('#delete-breed-modal').modal('hide');
            api.deleteBreeder(this.activeBreeder).then(function () {
                _this22.refreshData();
                _this22.showAlert({
                    type: 'warning',
                    text: _this22.activeBreeder.name + " has been deleted."
                });
            });
        },
        loadLitters: function loadLitters() {
            var _this23 = this;

            var data = { page: this.page };
            data.archived = this.filter == "archive" ? 1 : 0;

            api.getLitters(data).then(function (res) {
                _this23.loading = 0;
                _this23.litters = res.data;
            });
        },

        handleChange: function handleChange() {
            if (this.$route.query.newModal) {
                this.addNew();
            }
        },
        loadMore: function loadMore() {
            var _this24 = this;

            if (!this.isTileView) {
                return false;
            }

            var data = { page: parseInt(this.itemsLoaded) + 1 };
            if (this.order) {
                data.order = this.order;
            }

            data = this.buildFilters(data);

            switch (this.filter) {
                case 'bucks':
                    data.sex = 'buck';
                    break;
                case 'does':
                    data.sex = 'doe';
                    break;
            }

            data.filters = this.filters;
            data.searchQuery = this.searchQuery;
            data.update_weight_format = true;

            api.getBreeders(data).then(function (data) {
                _this24.loading = 0;
                _this24.mergeByProperty(_this24.breeders, data.breeders.data, 'id');
                _this24.pages = data.breeders.last_page;
                _this24.order = data.order;
                _this24.itemsLoaded = data.breeders.current_page;
                _this24.totalItems = data.breeders.total;
                if (data.breeders.last_page <= data.breeders.current_page) {
                    _this24.disableLoadMore = true;
                } else {
                    _this24.disableLoadMore = false;
                }
            });
        },
        loadCategories: function loadCategories() {
            var _this25 = this;

            if (App.isSubscribed) {
                api.getBreederCategories().then(function (data) {
                    _this25.categories = data.categories;
                });
            }
        },
        fetchCategoryNameById: function fetchCategoryNameById(id) {
            var category = _.find(this.categories, function (category) {
                return category.id === id;
            });

            return category.name;
        },


        /**
         * butcher unbutcher
         *
         */
        butcherBreederModal: function butcherBreederModal() {
            $('#breeder-butcher-modal').modal('show');
        },

        undoButcher: function undoButcher(breed) {
            var _this26 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    _this26.activeBreeder = breed;
                    var params = {
                        breeders: breed,
                        butchered: 0
                    };

                    api.butcherBreeder(breed, params).then(function () {
                        _this26.refreshData();
                        _this26.showAlert({
                            type: 'success',
                            text: _this26.activeBreeder.name + " has been unbutchered."
                        });
                    }, function (response) {
                        _this26.showAlert({
                            type: 'danger',
                            text: response.data.error
                        });
                    });
                } else {
                    _this26.showBreederLimit(data);
                }
            });
        },
        openBreeder: function openBreeder(item, id) {
            localStorage.setItem('action', item);
            this.$route.router.go('/profile/' + id);
        },
        changeLayout: function changeLayout() {
            this.isTileView = !this.isTileView;
            localStorage.setItem('isTileView', this.isTileView);
            this.breeders = [];
            this.page = 1;
            this.updateList();
        },
        updatePage: function updatePage(page) {
            // NOTE: catch frontend bug where disabled link still triggers
            if (page == this.page || page <= 0 || page > this.totalPages) {
                return true;
            }

            this.page = page; // set new page
            this.updateList();
        },
        updatePerPage: function updatePerPage() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

            localStorage.setItem('perPage', value);
            this.perPage = value;
        },
        initializeDisplayItems: function initializeDisplayItems() {
            var _this27 = this;

            $('.display-settings').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            }).on('ifChecked', function (event) {
                _this27.displayItems[event.target.name] = true;
                localStorage.setItem('breedlistDisplayV2', (0, _stringify2.default)(_this27.displayItems));
            }).on('ifUnchecked', function (event) {
                _this27.displayItems[event.target.name] = false;
                localStorage.setItem('breedlistDisplayV2', (0, _stringify2.default)(_this27.displayItems));
            });

            var breedlistDisplay = JSON.parse(localStorage.getItem('breedlistDisplayV2'));
            if (breedlistDisplay) {
                this.displayItems = breedlistDisplay;
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.displayItems)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    if (this.displayItems[key]) {
                        $("input[class='display-settings'][name='" + key + "']").iCheck("check");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        applyPreFilters: function applyPreFilters() {
            this.filters = (0, _extends3.default)({}, this.preFilters);
            this.filterRanges = (0, _extends3.default)({}, this.preFilterRanges);
            this.$router.go({ path: '/breeders/all' });
        },
        resetPreFilters: function resetPreFilters() {
            this.preFilters = {
                name: '',
                breed: '',
                cage: '',
                color: '',
                prefix: '',
                tattoo: '',
                date_of_birth: {
                    from: null,
                    to: null
                },
                aquired: {
                    from: null,
                    to: null
                },
                category_id: '',
                bred: null
            };

            this.preFilterRanges = {
                date_of_birth: [],
                aquired: []
            };

            this.newFilters = [];
            this.newSexFilter = "all";

            this.applyPreFilters();
        },
        removeFilter: function removeFilter() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var resetContent = "";

            if (type == 'aquired' || type == 'date_of_birth') {
                resetContent = {
                    from: null,
                    to: null
                };

                this.preFilterRanges[type] = resetContent;
            }

            if (type) {
                this.preFilters[type] = resetContent;
                this.applyPreFilters();
            }
        },
        removeNewFilter: function removeNewFilter(filter) {
            var index = this.newFilters.indexOf(filter);
            if (index > -1) {
                this.newFilters.splice(index, 1);
            }

            this.applyPreFilters();
        },
        removeSexFilter: function removeSexFilter() {
            this.newSexFilter = 'all';
            this.applyPreFilters();
        },
        initTypeahead: function initTypeahead() {
            var _this28 = this;

            this.breedersList = this.getBreedersAutocompleteList().sort(function (a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });

            api.getBreedersList().then(function (breeders) {
                var allBreeders = _.flatten([].concat(breeders.does, breeders.bucks));
                var colors = _this28.uniqueFieldSet(allBreeders, "color");
                var prefixes = _this28.uniqueFieldSet(allBreeders, "prefix");
                var cages = _this28.uniqueFieldSet(allBreeders, "cage");
                $('#f-breeder-color').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    limit: 100,
                    source: _this28.substringMatcher(colors)
                });

                $('#f-breeder-prefix').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    limit: 100,
                    source: _this28.substringMatcher(prefixes)
                });

                $('#f-breeder-cage').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    limit: 100,
                    source: _this28.substringMatcher(cages)
                });
            });
        },
        showCategories: function showCategories() {
            $('#breeder-categories-modal').modal('show');
        },
        refreshData: function refreshData() {
            $('#id_' + this.activeBreeder.id).slideUp(200);
            this.updateList();
        },
        weighModal: function weighModal(breeder) {
            this.activeBreeder = breeder;
            this.$broadcast('breederWeigh');
        },
        initializeBreederCheckbox: function initializeBreederCheckbox() {
            var _this29 = this;

            this.actionableBreeders = [];
            $('.breeder-checkbox').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            }).on('ifChecked', function (event) {
                var breeder = _this29.getBreederById(event.target.name);
                _this29.actionableBreeders.push(breeder);
            }).on("ifUnchecked", function (event) {
                var breeder = _this29.getBreederById(event.target.name);
                _this29.actionableBreeders = _.filter(_this29.actionableBreeders, function (item) {
                    return item.id != breeder.id;
                });
            });
        },
        openBreedMultiple: function openBreedMultiple() {
            this.$broadcast('new-breed-multiple', this.actionableDoes);
        },
        editMultiple: function editMultiple() {
            if (this.actionableBreeders.length == 1 && !this.filter) {
                var breeder = this.actionableBreeders[0];
                this.editModal(breeder);
            } else {
                this.editMultipleBreeders();
            }
        },
        editMultipleBreeders: function editMultipleBreeders() {
            this.$broadcast('open-multiple-breeder-form');
        },
        openMultiple: function openMultiple() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'delete';

            var form = $("#delete-multiple-breeders-modal");
            if (type == 'delete') form = $("#delete-multiple-breeders-modal");else if (type == 'archive') form = $("#archive-multiple-breeders-modal");else if (type == 'cull') form = $("#cull-multiple-breeders-modal");else if (type == 'sell') form = $("#sell-multiple-breeders-modal");else if (type == 'butcher') form = $("#butcher-multiple-breeders-modal");

            form.modal('show');
        },
        deleteMultipleBreeders: function deleteMultipleBreeders() {
            var _this30 = this;

            this.loading = 1;
            var breeders = _.pluck(this.actionableBreeders, 'id');

            api.deleteMultipleBreeders({ breeders: breeders }).then(function (data) {
                _this30.loading = 0;
                $("#delete-multiple-breeders-modal").modal("hide");
                _this30.updateList();
            }, function (response) {
                _this30.loading = 0;
                _this30.errors = response.data.errors;
            });
        },
        archiveMultipleBreeders: function archiveMultipleBreeders() {
            var _this31 = this;

            this.loading = 1;
            var breeders = _.pluck(this.actionableBreeders, 'id');

            api.archiveMultipleBreeders({ breeders: breeders }).then(function (data) {
                _this31.loading = 0;
                $("#archive-multiple-breeders-modal").modal("hide");
                _this31.updateList();
            }, function (response) {
                _this31.loading = 0;
                _this31.errors = response.data.errors;
            });
        },
        cullMultipleBreeders: function cullMultipleBreeders() {
            var _this32 = this;

            this.loading = 1;
            var breeders = _.pluck(this.actionableBreeders, 'id');

            api.cullMultipleBreeders({ breeders: breeders }).then(function (data) {
                _this32.loading = 0;
                $("#cull-multiple-breeders-modal").modal("hide");
                _this32.updateList();
            }, function (response) {
                _this32.loading = 0;
                _this32.errors = response.data.errors;
            });
        },
        sellMultipleBreeders: function sellMultipleBreeders() {
            var _this33 = this;

            var breeders = _.pluck(this.actionableBreeders, 'id');
            var payload = {
                breeders: breeders,
                value: this.soldValue,
                email: this.transferTo

                // add checker if sold to field has value
            };if (this.transferTo && this.transferTo != "add") {
                // verify if the email is valid
                api.checkTransferMultipleBreeders(payload).then(function () {
                    // show confirm transfer modal
                    $("#sell-multiple-breeders-modal").modal("hide");
                    $('#confirm-transfer-multiple-modal').modal('show');
                }, function (error) {
                    // show errors on form
                    _this33.transferErrors = error.data.errors;
                });
            } else {
                // sell breeder directly if sold to field is empty
                this.loading = 1;
                api.sellMultipleBreeders(payload).then(function (data) {
                    _this33.loading = 0;
                    $("#sell-multiple-breeders-modal").modal("hide");
                    _this33.closeSoldModal();
                }, function (response) {
                    _this33.loading = 0;
                    _this33.errors = response.data.errors;
                });
            }
        },
        confirmMultipleTransfers: function confirmMultipleTransfers() {
            var _this34 = this;

            var breeders = _.pluck(this.actionableBreeders, 'id');
            var payload = {
                breeders: breeders,
                value: this.soldValue,
                email: this.transferTo

                // hide confirm transfer modal
            };$('#confirm-transfer-multiple-modal').modal('hide');

            // sell breeder
            this.loading = 1;
            api.sellMultipleBreeders(payload).then(function () {
                // transfer breeder to new owner
                api.transferMultipleBreeders(payload).then(function () {
                    _this34.loading = 0;
                    _this34.closeSoldModal();
                    _this34.showAlert({
                        type: 'success',
                        text: 'Breeders have been transfered.'
                    });
                }, function (response) {
                    _this34.loading = 0;
                    _this34.transferErrors = response.data.errors;
                    _this34.unconfirmTransfer();
                });
            });
        },

        cancelTransferMultiple: function cancelTransferMultiple() {
            $('#confirm-transfer-multiple-modal').modal('hide');
            $('#sell-multiple-breeders-modal').modal('show');
        },
        butcherMultipleBreeders: function butcherMultipleBreeders() {
            var _this35 = this;

            this.loading = 1;
            var breeders = _.pluck(this.actionableBreeders, 'id');

            api.butcherMultipleBreeders({ breeders: breeders }).then(function (data) {
                _this35.loading = 0;
                $("#butcher-multiple-breeders-modal").modal("hide");
                _this35.updateList();
            }, function (response) {
                _this35.loading = 0;
                _this35.errors = response.data.errors;
            });
        },
        getBreederById: function getBreederById(id) {
            id = id.replace('breeder-', '');
            var breeder = _.find(this.breeders, function (breeder) {
                return breeder.id == id;
            });

            return breeder;
        }
    },
    ready: function ready() {
        var _this36 = this;

        this.initTypeahead();
        this.initializeDisplayItems();

        this.isTileView = localStorage.getItem('isTileView') == 'true' ? true : false;

        if (this.getFilters()) {
            this.filters = this.getFilters();
            this.preFilters = (0, _extends3.default)({}, this.filters);
        }

        if (this.getNewFilters()) {
            this.newFilters = this.getNewFilters();
        }

        if (this.newFilters.length) {
            this.$router.go({ path: '/breeders/all' });
        }

        if (this.$route.path.indexOf('opendoes') >= 0) {
            this.openDoes = true;
            this.filters.bred = false;
        } else {
            this.openDoes = false;
            this.filters.bred = null;
        }

        this.initUploader();

        this.updateList();

        App.vent.on('breeders.new', this.addNew.bind(this));

        this.$watch('$route.query.newModal', this.handleChange, { deep: true });

        var self = this;

        if (this.$route.query.newModal) {
            this.addNew();
        }
        $(document).on('hide.bs.modal', '#breeder-form', function (event) {
            if ($(event.target).is('#breeder-form') && self.$route.query.newModal) {
                self.$route.router.go('breeders');
            }
        });
        App.MobileTypes();
        this.loadLitters();

        // tweak for dropdown
        $(document).on('click', '.dropdown-menu.main-filters', function (e) {
            if ($(e.target).data("dismiss") != "dropdown") {
                e.stopPropagation();
            }
        });
        $('#breeder-status-id').on("select2:unselect", function (e) {
            if (!e.params.originalEvent) {
                return;
            }
            e.params.originalEvent.stopPropagation();
        });

        // listen for breeder tour
        _eventBus2.default.$on('start-breeder-tour', function () {
            _this36.startTour('breeders');
        });

        if (App.tourShowed == 1) {
            App.tourShowed = 2;
            this.$http.post('/admin/users/tourShowed', { value: 2 });
            this.startTour('breeders');
        }

        this.getCurrentData();

        this.applyWatchers();
    },
    mixins: [App.Mixins.Butcherable, App.Mixins.Filterable, App.Mixins.Breeders, App.Mixins.Transferable, App.Mixins.Generic, App.Mixins.Tours, App.Mixins.Typeahead]
});

},{"../event-bus":882,"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37}],733:[function(require,module,exports){
"use strict";

App.Components.BreederMenu = App.Components.Generic.Menu.extend({
  props: ["breeder"],
  ready: function ready() {
    var _this = this;

    var menu = ["Edit", "Breed", "Birth", "Cage Card", "Sell", "Unsold", "Butcher", "Undo Butcher", "Died", "Undo died", "Archive", "Unarchive", "Cull", "Uncull", "Delete"];

    menu.forEach(function (item) {
      switch (item) {
        case "Edit":
          _this.menuList.push({
            title: item,
            icon: "fa-pencil-square-o",
            event: "edit",
            data: _this.breeder,
            show: _this.isBreederActive(_this.breeder)
          });
          break;
        case "Breed":
          _this.menuList.push({
            title: item,
            icon: "fa-venus-mars",
            event: "breedModal",
            data: _this.breeder,
            show: _this.isBreederActive(_this.breeder)
          });
          break;
        case "Birth":
          _this.menuList.push({
            title: item,
            icon: "fa-birthday-cake",
            event: "birthModal",
            data: _this.breeder,
            show: _this.isBreederActive(_this.breeder)
          });
          break;
        case "Cage Card":
          _this.menuList.push({
            title: item,
            icon: "fa-list-alt",
            event: "cageCard",
            data: _this.breeder,
            show: _this.isBreederActive(_this.breeder) && _this.hasAccess(App.access.cage_cards)
          });
          break;
        case "Sell":
          _this.menuList.push({
            title: item,
            icon: "fa-dollar",
            event: "soldModal",
            data: _this.breeder.id,
            show: _this.isBreederActive(_this.breeder)
          });
          break;
        case "Unsold":
          _this.menuList.push({
            title: item,
            icon: "fa-dollar",
            event: "unsoldModal",
            data: _this.breeder,
            show: _this.breeder.sold_at
          });
          break;
        case "Butcher":
          _this.menuList.push({
            title: item,
            icon: "fa-cutlery",
            event: "butcherBreederModal",
            data: _this.breeder,
            show: _this.isBreederActive(_this.breeder) && _this.isShowButcher
          });
          break;
        case "Undo Butcher":
          _this.menuList.push({
            title: item,
            icon: "fa-cutlery",
            event: "undoButcher",
            data: _this.breeder,
            show: _this.breeder.butchered && _this.isShowButcher
          });
          break;
        case "Died":
          _this.menuList.push({
            title: item,
            icon: "fa-heart",
            event: "showDied",
            data: _this.breeder,
            show: _this.isBreederActive(_this.breeder)
          });
          break;
        case "Undo died":
          _this.menuList.push({
            title: item,
            icon: "fa-heart",
            event: "showDied",
            data: _this.breeder,
            show: _this.breeder.died
          });
          break;
        case "Archive":
          _this.menuList.push({
            title: item,
            icon: "fa-archive",
            event: "archiveModal",
            data: _this.breeder.id,
            show: _this.isBreederActive(_this.breeder)
          });
          break;
        case "Unarchive":
          _this.menuList.push({
            title: item,
            icon: "fa-expand",
            event: "unarchiveModal",
            data: _this.breeder,
            show: _this.breeder.archived
          });
          break;
        case "Cull":
          _this.menuList.push({
            title: item,
            icon: "fa-cut",
            event: "cullModal",
            data: _this.breeder,
            show: _this.isBreederActive(_this.breeder)
          });
          break;
        case "Uncull":
          _this.menuList.push({
            title: item,
            icon: "fa-cut",
            event: "uncullModal",
            data: _this.breeder,
            show: _this.breeder.culled
          });
          break;
        case "Delete":
          _this.menuList.push({
            title: item,
            icon: "fa-trash",
            event: "deleteModal",
            data: _this.breeder.id,
            show: true
          });
          break;
      }
    });
  },

  mixins: [App.Mixins.Butcherable, App.Mixins.Breeders, App.Mixins.Auth, App.Mixins.Generic]
});

},{}],734:[function(require,module,exports){
"use strict";

App.Components.BreedplansList = App.Components.UpcommingTasks.extend({
    template: "#breedplans-list-template"
});

},{}],735:[function(require,module,exports){
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.BroadcastAlert = {
    template: "#broadcast-alert-template",
    data: function data() {
        return {
            existing: false,
            loading: null,
            show: true,
            broadcasts: [],
            feature: {}
        };
    },

    methods: {
        dismiss: function dismiss(broadcast) {
            var _this = this;

            this.$http.delete('/admin/broadcast/active/' + broadcast.id).then(function () {
                _this.load();
            });
        },
        load: function load() {
            var _this2 = this;

            this.$http.get('/admin/broadcast/active/web').then(function (response) {
                if (response.data.broadcast) {
                    var getBroadcast = response.data.broadcast;
                    if (_this2.existing = !!getBroadcast) {
                        _this2.broadcasts = getBroadcast;
                        _this2.$nextTick(function () {
                            window.dispatchEvent(new Event('resize'));
                        });
                    }

                    if (_this2.loading) {
                        window.clearTimeout(_this2.loading);
                    }
                    _this2.loading = window.setTimeout(function () {
                        _this2.load();
                    }, 600000);
                }

                if (response.data.pending_features.length) {
                    _this2.features = response.data.pending_features;
                    _this2.showFeatureOptInMessage(response.data.pending_features);
                }
            });
        },
        showFeatureOptInMessage: function showFeatureOptInMessage() {
            var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            if (features.length) {
                this.feature = features[0];

                $("#feature-opt-in-message").html(this.feature.opt_in_message);
                $("#feature-opt-in-modal").modal({
                    backdrop: 'static',
                    keyboard: false
                });
            }
        },
        acceptFeature: function acceptFeature() {
            var _this3 = this;

            var isAccept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var params = (0, _extends3.default)({}, this.feature);
            params.is_accept = isAccept;

            api.optInFeature(params).then(function (data) {
                $("#feature-opt-in-modal").modal("hide");
                _this3.$nextTick(function () {
                    if (params.is_accept) {
                        window.location.reload();
                    } else {
                        _this3.features = _.filter(_this3.features, function (item) {
                            return item.id != _this3.feature.id;
                        });

                        _this3.showFeatureOptInMessage(_this3.features);
                    }
                });
            }, function (error) {});
        }
    },
    compiled: function compiled() {
        // $('body').on('broadcast.hide', () => this.show = false);
        // $('body').on('broadcast.show', () => this.show = true);
    },
    ready: function ready() {
        this.load();
    }
};

},{"babel-runtime/helpers/extends":37}],736:[function(require,module,exports){
'use strict';

App.Components.BroadcastForm = {
    template: "#broadcast-template",
    data: function data() {
        return {
            title: '',
            content: '',
            existing: false,
            errors: {}
        };
    },

    methods: {
        saveNew: function saveNew() {
            var _this = this;

            this.errors = {};
            this.$http.post('/admin/broadcast', { title: this.title, content: this.content }).then(function () {
                $('#broadcast-modal').modal('hide');
            }, function (response) {
                _this.errors = response.data.errors;
            });
        },
        update: function update() {
            var _this2 = this;

            this.errors = {};
            this.$http.put('/admin/broadcast', { title: this.title, content: this.content }).then(function () {
                $('#broadcast-modal').modal('hide');
            }, function (response) {
                _this2.errors = response.data.errors;
            });
        },
        delete: function _delete() {
            var _this3 = this;

            this.errors = {};
            this.$http.delete('/admin/broadcast').then(function () {
                $('#broadcast-modal').modal('hide');
            }, function (response) {
                _this3.errors = response.data.errors;
            });
        }
    },
    ready: function ready() {
        var _this4 = this;

        $(function () {
            $('#broadcast-modal-trigger').click(function (e) {
                e.preventDefault();
                _this4.$http.get('/admin/broadcast').then(function (response) {
                    if (_this4.existing = response.data.exists) {
                        _this4.title = response.data.title;
                        _this4.content = response.data.content;
                    } else {
                        _this4.title = _this4.content = '';
                    }
                    $('#broadcast-modal').modal('show');
                });
            });
        });
    }
};

},{}],737:[function(require,module,exports){
'use strict';

App.Components.broadcastList = {
    template: "#broadcasts-template",
    data: function data() {
        return {
            broadcasts_data: [],
            pages: 1,
            isAdmin: 0,
            add_edit_modal_hide_show: false,
            delete_modal_hide_show: false,
            subscriptionPlans: [],
            broadcast_until: '',
            existing: false,
            typeOfPlans: 'active',
            errors: {},
            broadcast: {
                id: '',
                title: '',
                content: '',
                status: '',
                disabled_at: '',
                plan_status_id: [],
                update_row_index: '',
                platforms: ['web', 'mobile']
            },
            success: "",
            broadcast_form_modal_mode: 'create'
        };
    },
    props: [],
    computed: {
        page: function page() {
            return this.$route.query.page || 1;
        },
        currentRoute: function currentRoute() {
            return this.$route.path.split('?')[0];
        }
    },
    watch: {
        'broadcast.status': function broadcastStatus() {
            if (this.broadcast.status == "all" || this.broadcast.status == "trial") {
                this.broadcast.plan_status_id = [];
            }
        },
        'broadcast.plan_status_id': function broadcastPlan_status_id() {},
        currentRoute: function currentRoute() {
            return this.$route.path.split('?')[0];
        },
        page: function page() {
            this.updateList();
        },
        add_edit_modal_hide_show: function add_edit_modal_hide_show(newData) {
            var _this = this;

            if (newData) {
                this.$nextTick(function () {
                    $("#broadcast-wysiwyg-content").Editor();
                    $("#broadcast-wysiwyg-content").Editor("setText", _this.broadcast.content);
                });
            }
        }
    },
    events: {},

    methods: {
        checkPlan: function checkPlan() {
            if (this.broadcast.status == "all" || this.broadcast.status == "trial" || this.broadcast.status == "") {
                this.broadcast.plan_status_id = [];
            }
        },
        showPlanName: function showPlanName(plan_id, status) {
            var _this2 = this;

            if (plan_id != "" && plan_id != "null" && plan_id != null) {
                if (status == "all" || status == "trial") {
                    return status;
                } else {
                    var temp_plan_storage = [];
                    plan_id.map(function (p_val) {
                        var get_plan_name = "";
                        _this2.subscriptionPlans.map(function (s_val) {
                            if (s_val.id == p_val) {
                                get_plan_name = ' ' + s_val.name + ' ' + s_val.period;
                            }
                        });
                        temp_plan_storage.push(get_plan_name);
                    });
                    return temp_plan_storage.toString();
                }
            }
        },
        confirmDelete: function confirmDelete(user, deleteIndex) {

            this.delete_modal_hide_show = true;
            this.toDelete = user;
            this.deleteIndex = deleteIndex;
        },

        deleteBroadcast: function deleteBroadcast() {
            var _this3 = this;

            api.deleteBroadcast(this.toDelete).then(function (data) {
                _this3.broadcasts_data.splice(_this3.deleteIndex, 1);
                _this3.delete_modal_hide_show = false;
            });
        },

        loadMore: function loadMore() {
            // var data = {page: parseInt(this.itemsLoaded) + 1}; 
            // data.filters = this.filters;
            // data.searchQuery = this.searchQuery; 
        },
        loadPlans: function loadPlans() {
            var _this4 = this;

            api.getSubscriptionPlans("all").then(function (plans) {
                _this4.subscriptionPlans = plans;
                _this4.loadBroadcasts();
            });
        },
        loadBroadcasts: function loadBroadcasts() {
            var _this5 = this;

            api.getBroadcastList().then(function (data) {
                _this5.broadcasts_data = data.broadcast;
            });
        },
        updateBroadcast: function updateBroadcast(data, index) {
            this.clearForm();
            this.broadcast.update_row_index = index;

            var formatDate = new Date(data.disabled_at).getTime();
            data.disabled_at = moment(formatDate).format(App.dateFormat);

            this.broadcast.id = data.id;
            this.broadcast.title = data.title;
            this.broadcast.content = data.content;
            this.broadcast.disabled_at = data.disabled_at;
            this.broadcast.platforms = data.platforms;
            if (data.status == "paying") {
                this.broadcast.status = "paying";
                this.broadcast.plan_status_id = data.plan_status_id.map(parseFloat);
            } else {
                this.broadcast.status = data.status;
                this.broadcast.plan_status_id = [];
            }
            this.broadcast_form_modal_mode = "update";
            this.add_edit_modal_hide_show = true;
        },
        clearForm: function clearForm() {
            this.broadcast.update_row_index = "";
            this.broadcast.id = "";
            this.broadcast.title = "";
            this.broadcast.content = "";
            this.broadcast.disabled_at = "";
            this.broadcast.status = "";
            this.broadcast.plan_status_id = [];
            this.broadcast.platforms = [];
            this.broadcast_form_modal_mode = "create";
            this.errors = {};
        },
        closeModal: function closeModal() {
            this.clearForm();
            this.add_edit_modal_hide_show = false;
            this.broadcast_form_modal_mode = "create";
        },
        saveBroadcast: function saveBroadcast() {
            var _this6 = this;

            this.errors = {};

            this.broadcast.content = $("#broadcast-wysiwyg-content").Editor("getText");

            if (this.broadcast_form_modal_mode == "create") {
                api.storeBroadcast(this.broadcast).then(function (data) {

                    _this6.broadcasts_data.push(data);
                    _this6.clearForm();
                    _this6.success = "Broadcast Created Successfully";
                    _this6.add_edit_modal_hide_show = false;
                    setTimeout(function () {
                        _this6.success = "";
                    }, 5000);
                }, function (response) {
                    _this6.errors = response.data.errors;
                });
            } else {
                api.updateBroadcast(this.broadcast.id, this.broadcast).then(function (data) {

                    _this6.broadcasts_data[_this6.broadcast.update_row_index].id = data.id;
                    _this6.broadcasts_data[_this6.broadcast.update_row_index].title = data.title;
                    _this6.broadcasts_data[_this6.broadcast.update_row_index].content = data.content;
                    _this6.broadcasts_data[_this6.broadcast.update_row_index].disabled_at = data.disabled_at;
                    _this6.broadcasts_data[_this6.broadcast.update_row_index].status = data.status;
                    _this6.broadcasts_data[_this6.broadcast.update_row_index].plan_status_id = data.plan_status_id;
                    _this6.broadcasts_data[_this6.broadcast.update_row_index].platforms = data.platforms;

                    _this6.success = "Broadcast Update Successfully";
                    _this6.clearForm();
                    _this6.add_edit_modal_hide_show = false;
                    setTimeout(function () {
                        _this6.success = "";
                    }, 5000);
                }, function (response) {
                    _this6.errors = response.data.errors;
                });
            }
        }
    },
    ready: function ready() {
        if (App.admin || App.user_role == "marketer") {
            this.loadPlans();
        }
    }
};

},{}],738:[function(require,module,exports){
'use strict';

App.Components.CageArchive = {
    template: "#cage-archive-template",
    data: function data() {
        return {
            errors: {},
            date: moment(new Date()).format(App.dateFormat),
            loaded: 0,
            current: 0,
            selectedCage: 0,
            loading: false
        };
    },
    props: ['cages', 'cage', 'kits', 'filterKit', 'isGlobal'],
    computed: {
        archiveForm: function archiveForm() {
            var form = '#cage-archive-modal';

            return form;
        }
    },
    watch: {
        cage: function cage(_cage, old_cage) {
            if (_cage && _cage.id) {
                this.selectedCage = _cage.id;
            }
        }
    },
    methods: {
        saveEntireCage: function saveEntireCage() {
            var _this = this;

            this.loading = true;
            var data = {
                date: this.date,
                cage_id: this.selectedCage
            };

            api.archiveCage(data).then(function () {
                _this.$dispatch('refresh-cages');
                _this.loading = false;
            }, function () {
                _this.loading = false;
            });

            $(this.archiveForm).modal('hide');
        }
    },
    ready: function ready() {
        this.loading = false;
    }
};

},{}],739:[function(require,module,exports){
'use strict';

App.Components.CageBreed = {
    template: "#cage-breed-template",
    data: function data() {
        return {
            errors: {},
            date: moment(new Date()).format(App.dateFormat),
            loaded: 0,
            current: 0,
            selectedCage: 0,
            loading: false
        };
    },
    props: ['cages', 'cage', 'kits', 'filterKit', 'isGlobal'],
    computed: {
        breedForm: function breedForm() {
            var form = '#cage-breed-modal';

            return form;
        }
    },
    watch: {
        cage: function cage(_cage, old_cage) {
            if (_cage && _cage.id) {
                this.selectedCage = _cage.id;
            }
        }
    },
    methods: {
        saveEntireCage: function saveEntireCage() {
            var _this = this;

            this.loading = true;
            var data = {
                date: this.date,
                cage_id: this.selectedCage
            };

            api.breedCage(data).then(function () {
                _this.$dispatch('refresh-cages');
                _this.loading = false;
            }, function () {
                _this.loading = false;
            });

            $(this.breedForm).modal('hide');
        }
    },
    ready: function ready() {
        this.loading = false;
    }
};

},{}],740:[function(require,module,exports){
'use strict';

App.Components.CageButcher = {
    template: "#cage-butcher-template",
    data: function data() {
        return {
            errors: {},
            date: moment(new Date()).format(App.dateFormat),
            loaded: 0,
            current: 0,
            selectedCage: 0,
            currency: '',
            loading: false,
            isEntireCage: false,
            entireCage: {
                current_weight: 0,
                butcher_weight: 0,
                butcher_value: 0
            }
        };
    },
    props: ['cages', 'cage', 'kits', 'filterKit', 'isGlobal'],
    components: {
        'lbs-oz-input': App.Components.LbsOzInput
    },
    computed: {
        butcherForm: function butcherForm() {
            var form = '#cage-butcher-modal';
            if (this.isGlobal) form = '#global-cage-butcher-modal';

            return form;
        }
    },
    watch: {
        cage: function cage(_cage, old_cage) {
            var _this = this;

            console.log(_cage);
            if (_cage && _cage.id) {
                this.selectedCage = _cage.id;
                $(this.$els.checkall).prop('checked', false);
                if (this.selectedCage) {
                    api.getCageKitsWeighOfType(this.selectedCage, 'rabbitkit').then(function (kits) {
                        _this.kits = kits;
                        _this.filterKits();
                    });
                }
            }
        },
        selectedCage: function selectedCage(selected, oldSelected) {
            if (oldSelected || this.cage && !this.cage.id) {
                this.cage = _.find(this.cages, function (item) {
                    return item.id == selected;
                });

                this.resetButcher();
            }
        },
        filterKit: function filterKit(newData) {
            var _this2 = this;

            this.loading = true;
            this.kits = [];
            api.getCageKitsWeighOfType(this.selectedCage, 'rabbitkit').then(function (kits) {
                _this2.loading = false;
                _this2.kits = kits;

                if (newData) {
                    _this2.filterKits();
                }
            }, function () {
                _this2.loading = false;
            });
        }
    },
    methods: {
        resetButcher: function resetButcher() {
            this.toggleLayout(false);
            this.entireCage = {
                current_weight: 0,
                butcher_weight: 0,
                butcher_value: 0
            };
        },
        filterKits: function filterKits() {
            var _this3 = this;

            var filteredKit = _.find(this.kits, function (kit) {
                return kit.id == _this3.filterKit;
            });

            if (filteredKit) {
                this.kits = [filteredKit];
            }
        },
        selectedField: function selectedField(index) {
            this.kits[index].selected = true;
        },
        getGenderClass: function getGenderClass(sex) {
            if (!sex) {
                return "border-gray-active";
            }
            return sex == "buck" ? "border-aqua-v1" : "border-maroon-v1";
        },
        saveEntireCage: function saveEntireCage() {
            var count = this.kits.length;
            var current_weight = this.entireCage.current_weight / count;
            var butcher_weight = this.entireCage.butcher_weight / count;
            var butcher_value = this.entireCage.butcher_value / count;

            _.map(this.kits, function (kit) {
                kit.selected = true;
                kit.current_weight = current_weight;
                kit.butcher_weight = butcher_weight;
                kit.butcher_value = butcher_value;
            });

            this.sendToButcher();
        },
        sendToButcher: function sendToButcher() {
            var _this4 = this;

            var selectedKits = _.filter(this.kits, function (kit) {
                return kit.selected;
            });
            var data = {
                kits: selectedKits,
                date: this.date,
                cage_id: this.selectedCage
            };

            api.butcherKits(data).then(function () {
                _this4.$dispatch('refresh-kits');
                _this4.$dispatch('cage-archived', { cage: _this4.selectedCage });
                if (selectedKits.length) {
                    // this.$dispatch('cageButchered', {cage_id:this.selectedCage,butcher_value:22});
                    _this4.$dispatch('reload-tasks', { typeOfTask: 'all', page: null });
                }
            });

            $(this.butcherForm).modal('hide');
            if (this.isGlobal) this.$root.$emit('global-notification-tab-reload');
        },
        initWeighType: function initWeighType() {
            var _this5 = this;

            $("#butcher-type-switch" + this.globalSuffix).netlivaSwitch({
                width: "35px"
            }).on("netlivaSwitch.change", function (event, state, element) {
                _this5.isEntireCage = state;
            });
        },
        toggleLayout: function toggleLayout() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            $("#butcher-type-switch" + this.globalSuffix).netlivaSwitch('state', state);
            this.isEntireCage = state;
        }
    },
    ready: function ready() {
        this.initWeighType();
        $(this.$els.checkall).on('click', function () {
            if (this.checked) {
                $('.js_butcher_checkbox').prop('checked', false).trigger('click');
            } else {
                $('.js_butcher_checkbox').prop('checked', true).trigger('click');
            }
        });

        this.currency = App.currency;
    },


    mixins: [App.Mixins.Weightable, App.Mixins.Generic]
};

},{}],741:[function(require,module,exports){
'use strict';

/**
 * Cage cards print component.
 */
App.Components.CageCardsPrint = {
    template: '#cage-cards-print-template',
    data: function data() {
        return {
            breeders: {},
            litters: {},
            breedersFilter: 'all',
            selectedBreeders: [],
            selectedLitters: [],
            breederCategories: {},
            breedersFilterCategory: 0,
            errors: {}
        };
    },
    props: ['template', 'alltemplates', 'profileid', 'isprofilepage'],
    computed: {},
    methods: {
        /**
         * Select all print models.
         */
        selectAllPrintModels: function selectAllPrintModels(type) {
            var _this = this;

            var printArrName = type === 'breeder' ? 'selectedBreeders' : 'selectedLitters',
                allModels = type === 'breeder' ? this.breeders : this.litters;

            if ($('#print-' + type + '-all').is(':checked')) {
                $.each(allModels, function (index, value) {
                    if ($.inArray(value.id, _this[printArrName]) == -1) {
                        _this[printArrName].push(value.id);
                    }
                });
            } else {
                this[printArrName] = [];
            }
        },

        /**
         * Select print model.
         */
        selectPrintModel: function selectPrintModel(type, id) {
            var printArrName = type === 'breeder' ? 'selectedBreeders' : 'selectedLitters';

            if ($('#print-' + type + '-' + id).is(':checked')) {
                this[printArrName].push(id);
            } else if ($.inArray(id, this[printArrName]) > -1) {
                var index = this[printArrName].indexOf(id);
                this[printArrName].splice(index, 1);
            }
        },

        /**
         * Get litter's parents joined name.
         *
         * @param litter
         * @returns {string}
         */
        getLitterParentsName: function getLitterParentsName(litter) {
            var father = litter.father,
                mother = litter.mother,
                name = '';

            if (father && mother) {
                name = this.trimStrTo(father.name, 5) + ' + ' + this.trimStrTo(mother.name, 5);
            }

            return name;
        },

        /**
         * Get list of breeders.
         */
        getListOfBreeders: function getListOfBreeders() {
            var _this2 = this;

            var request = {
                filter: this.breedersFilter,
                category: this.breedersFilterCategory
            };

            api.getCageCardBreedersList(request).then(function (data) {
                _this2.breeders = data;
            });

            // Reset selected models.
            this.resetSelectedModels();
        },

        /**
         * Get list of breeders categories.
         */
        getBreedersCategories: function getBreedersCategories() {
            var _this3 = this;

            if (App.isSubscribed) {
                api.getBreederCategories().then(function (data) {
                    _this3.breederCategories = data.categories;
                });
            }
        },

        /**
         * Get list of litters.
         */
        getListOfLitters: function getListOfLitters() {
            var _this4 = this;

            api.getCageCardLittersList().then(function (data) {
                _this4.litters = data;
            });

            // Reset selected models.
            this.resetSelectedModels();
        },

        /**
         * Change template.
         */
        changeTemplate: function changeTemplate(e) {
            var _this5 = this;

            $.each(this.alltemplates, function (index, value) {
                if (value.id == e.target.value) {
                    _this5.template = value;
                }
            });

            // Reset selected models.
            this.resetSelectedModels();
        },

        /**
         * Choose breeder category.
         */
        chooseBreedersCategory: function chooseBreedersCategory(e) {
            this.breedersFilterCategory = e.target.value;
            this.getListOfBreeders();
        },

        /**
         * Close modal handler.
         */
        closeModalHandler: function closeModalHandler() {
            App.vent.trigger('closeModal');
        },

        /**
         * Reset selected models.
         */
        resetSelectedModels: function resetSelectedModels() {
            this.selectedBreeders = this.selectedLitters = [];
        },

        /**
         * Print batch.
         */
        printBatch: function printBatch() {
            var _this6 = this;

            var request = {
                template: {
                    type: this.template.type,
                    size: this.template.size
                },
                modelIds: this.template.type === 'breeder' ? this.selectedBreeders : this.selectedLitters
            };

            // Clear erros before new request.
            this.errors = {};

            api.printBatch(request).then(function (data) {
                _this6.$router.go({
                    path: '/cage-cards/stream/1_breeder_4_7_large_2017_05_23_16_57_35.pdf'
                });
            }, function (response) {
                _this6.errors = response.data.errors;
            });
        },

        /**
         * Listeners.
         */
        listeners: function listeners() {
            var _this7 = this;

            // Close modal event handler.
            App.vent.on('closeModal', function () {
                // Reset state.
                _this7.resetSelectedModels();
                _this7.breedersFilter = 'all';
                _this7.breedersFilterCategory = 0;
            });
        },

        /**
         * Get selected models ids str.
         */
        getSelectedModelsIdsStr: function getSelectedModelsIdsStr() {
            var ids = this.template.type === 'breeder' ? this.selectedLitters.join(',') : this.selectedBreeders.join(',');

            if (this.profileid !== undefined && this.profileid != 0) {
                ids = this.profileid;
            }

            return ids;
        },

        /**
         * Is print btn visible.
         */
        isPrintBtnVisible: function isPrintBtnVisible() {
            var selectedIds = this.getSelectedModelsIdsStr();

            return selectedIds && this.template.id;
        },

        /**
         * Trim str to.
         *
         * @param str
         * @param length
         */
        trimStrTo: function trimStrTo(str, length) {
            var trimmed = str.substr(0, length);

            if (str.length > length) {
                trimmed += '...';
            }

            return trimmed;
        }
    },
    ready: function ready() {
        // Listeners for triggers.
        this.listeners();

        if (this.isprofilepage !== true) {
            // Get list of breeders for print page.
            this.getListOfBreeders();

            // Get list of breeders categories.
            this.getBreedersCategories();

            // Get list of litters for print page.
            this.getListOfLitters();
        }
    }
};

},{}],742:[function(require,module,exports){
'use strict';

/**
 * Cage cards template form component.
 */
App.Components.CageCardsTemplateForm = {
    template: '#cage-cards-template-form-template',
    data: function data() {
        return {
            errors: {},
            type: '',
            size: '',
            orientation: '',
            breederFields: [],
            litterFields: [],
            customFieldsIds: [],
            previewItem: '',
            firstBreeder: {},
            firstLitter: {},
            cageCardPrintModal: {},
            cageCardTemplateFormModal: {},
            loading: 0
        };
    },
    props: ['template', 'alltemplates', 'fieldsoptions', 'paginatedtemplates'],
    computed: {
        currentRoute: function currentRoute() {
            return this.$route.path.split('?')[0];
        }
    },
    methods: {
        /**
         * Get list of fields form DB for breeders and litters.
         */
        getListOfFields: function getListOfFields() {
            var _this = this;

            this.loading = 1;
            api.getCageCardTemplateFieldsOptionsList().then(function (data) {
                _this.loading = 0;
                _this.breederFields = data.breeder;
                _this.litterFields = data.litter;
            });
        },

        /**
         * Get field name in readable format.
         */
        getReadableOptionsFieldName: function getReadableOptionsFieldName(field) {
            var cleared = field.replace(/_id|_/g, ' '),
                decorated = this.fieldNameDecorator(cleared.trim());

            return decorated.substr(0, 1).toUpperCase() + decorated.substr(1);
        },

        updateLitterTableFields: function updateLitterTableFields() {
            if (this.template.fields.table === 'yes' && this.template.type === 'litter' && this.template.size !== '2_3_business') {
                this.template.fields.litter_table_1 = this.template.fields.litter_table_1 || 'id';
                this.template.fields.litter_table_2 = this.template.fields.litter_table_2 || 'color';
                this.template.fields.litter_table_3 = this.template.fields.litter_table_3 || 'sex';
            }
        },

        /**
         * Add selected field to fields scope.
         */
        addSelectedFieldToFields: function addSelectedFieldToFields(e) {
            var parts = e.target.value.split(':'),
                id = parts[0].match(/^[0-9]+$/) ? Number(parts[0]) : parts[0],
                field = parts[1];

            this.template.fields[parts[0]] = parts[1];

            this.updateLitterTableFields();

            // Custom field.
            var customFieldIdIndex = this.customFieldsIds.indexOf(id);

            if (field === 'custom') {
                // Add custom field to arr.
                if (customFieldIdIndex === -1) {
                    this.customFieldsIds.push(id);
                } // Remove custom field.
            } else if (customFieldIdIndex !== -1) {
                this.customFieldsIds.splice(customFieldIdIndex, 1);
            }
        },

        /**
         * Depending on type we set different set of fields options for template form.
         */
        setFieldsOptions: function setFieldsOptions(e) {
            var type = e.target.value,
                fieldsArr = type + 'Fields';

            this.fieldsoptions = this[fieldsArr];

            // Reset fields.
            this.resetSelectableFieldsStatement();
        },

        /**
         * Reset selectable fields scope if we changed type or size.
         */
        resetSelectableFieldsStatement: function resetSelectableFieldsStatement() {
            App.vent.trigger('resetSelectableFieldsStatement');

            this.template.fields = {
                table: 'no'
            };
            this.customFieldsIds = [];
        },

        /**
         * Store cage card template.
         */
        storeCageCardTemplate: function storeCageCardTemplate() {
            var _this2 = this;

            this.loading = 1;
            var template = this.template;

            api.storeCageCardTemplate(template).then(function (data) {
                _this2.loading = 0;
                App.vent.trigger('cageCardTemplate.saved');

                $('#cage-cards-template-form-modal').modal('hide');

                // Add new template to paginated and all templates scopes.
                _this2.alltemplates.unshift(data);

                if (_this2.currentRoute === '/cage-cards/templates') {
                    _this2.paginatedtemplates.unshift(data);
                }

                // Go to first page.
                _this2.$router.go('/cage-cards/templates');
            }, function (response) {
                _this2.loading = 0;
                _this2.errors = response.data.errors;
            });
        },

        /**
         * Update cage card template.
         */
        updateCageCardTemplate: function updateCageCardTemplate() {
            var _this3 = this;

            this.loading = 1;
            var scope = this,
                template = scope.template;

            api.updateCageCardTemplate(template).then(function (data) {
                _this3.loading = 0;
                App.vent.trigger('cageCardTemplate.updated');

                $('#cage-cards-template-form-modal').modal('hide');

                // Update alltemplates and paginated templates scopes.
                $.each([scope.paginatedtemplates, scope.alltemplates], function (i, templates) {
                    var match = _.find(templates, function (item) {
                        return item.id === template.id;
                    });

                    if (match) {
                        _.extendOwn(match, data);
                    }
                });

                scope.template = data;
            }, function (response) {
                _this3.loading = 0;
                scope.errors = response.data;
            });
        },

        /**
         * Check whether select fields is selected.
         *
         * @param field
         * @param id
         */
        isSelectFieldValue: function isSelectFieldValue(field, id) {
            return this.template.fields[id] !== undefined && this.template.fields[id].indexOf(field) > -1;
        },

        /**
         * Check whether custom field is selected.
         *
         * @param id
         */
        isCustomFieldVisible: function isCustomFieldVisible(id) {
            return this.customFieldsIds.indexOf(id) > -1 || this.template.fields[id] && this.template.fields[id].indexOf('custom') > -1;
        },

        /**
         * Get custom field value.
         *
         * @param id
         */
        getCustomFieldValue: function getCustomFieldValue(id) {
            var val = '';

            if (this.isCustomFieldVisible(id)) {
                val = this.template.fields[id].split(':')[1];
            }

            return val;
        },

        /**
         * Set custom field.
         *
         * @param id
         * @param value
         */
        setCustomField: function setCustomField(id, value) {
            this.template.fields[id] = 'custom:' + value;
        },

        /**
         * Get preview.
         */
        getPreview: function getPreview() {
            var size = this.template.size,
                type = this.template.type;

            App.vent.trigger('cageCardTemplate.preview');

            this.previewItem = [type, size].join('.');
        },

        /**
         * Close modal handler.
         */
        closeModalHandler: function closeModalHandler() {
            App.vent.trigger('closeModal');
        },

        /**
         * Field name decorator.
         *
         * @param fieldName
         */
        fieldNameDecorator: function fieldNameDecorator(fieldName) {
            var map = {};

            // Breeder.
            if (this.template.type === 'breeder') {
                map = {
                    'tattoo': 'id',
                    'aquired': 'acquired'
                };
            }

            // Litter.
            if (this.template.type === 'litter') {
                map = {
                    'given': 'id'
                };
            }

            if (map[fieldName]) {
                fieldName = map[fieldName];
            }

            return fieldName;
        },

        /**
         * Get preview field name.
         *
         * @param model
         * @param id
         * @param defaultValue
         */
        getPreviewFieldName: function getPreviewFieldName(model, id, defaultValue) {
            var name = '',
                fieldName = this.template.fields[id] !== undefined ? this.template.fields[id] : '';

            if (!$.isEmptyObject(model)) {
                if (model[fieldName] !== undefined && model[fieldName]) {
                    name = this.getReadableOptionsFieldName(fieldName);
                }

                // Custom or blank fields.
                if (fieldName === 'custom' || fieldName === 'blank') {
                    name = '';
                }
            } else if (defaultValue !== undefined && defaultValue.length) {
                name = defaultValue;
            }

            return name.length ? name + ': ' : '';
        },

        /**
         * Get preview field value.
         *
         * @param model
         * @param id
         * @param defaultValue
         */
        getPreviewFieldValue: function getPreviewFieldValue(model, id, defaultValue) {
            var value = '',
                fieldName = this.template.fields[id] !== undefined ? this.template.fields[id] : '';

            if (!$.isEmptyObject(model)) {
                if (model[fieldName] !== undefined && model[fieldName]) {
                    value = model[fieldName];

                    // Get value for relation.
                    if (fieldName.indexOf('_id') > -1) {
                        var relation = fieldName.split('_id')[0];

                        if (model[relation] !== undefined && model[relation].name !== undefined) {
                            value = model[relation].name;
                        }
                    }

                    // Litters special fields.
                    if (this.template.type === 'litter') {
                        // Mother and father.
                        if ($.inArray(fieldName, ['mother', 'father']) > -1) {
                            value = value.length && value[0].name !== undefined ? value[0].name : '';
                        }

                        // Given id.
                        if (fieldName === 'given_id') {
                            value = model[fieldName];
                        }
                    }
                }

                // Custom.
                if (fieldName.indexOf('custom') > -1) {
                    value = fieldName.split(':')[1];
                }

                // Blank.
                if (fieldName === 'blank') {
                    value = '<p></p>';
                }
            } else if (defaultValue.length) {
                value = defaultValue;
            }

            return value;
        },

        /**
         * Open print modal.
         */
        printModal: function printModal(template) {
            this.cageCardTemplateFormModal.modal('hide');
            this.template = _.extend({}, template);
            this.cageCardPrintModal.modal('show');
        },

        /**
         * Listeners.
         */
        listeners: function listeners() {
            var _this4 = this;

            // Reset selectable fields statement event handler.
            App.vent.on('resetSelectableFieldsStatement', function () {
                _this4.previewItem = '';
            });

            // Close modal event handler.
            App.vent.on('closeModal', function () {
                _this4.previewItem = '';
                _this4.errors = {};
                _this4.resetSelectableFieldsStatement();
            });
        }
    },
    ready: function ready() {
        var _this5 = this;

        var scope = this;

        // Jquery elements assignment.
        scope.cageCardPrintModal = $('#cage-cards-print-modal');
        scope.cageCardTemplateFormModal = $('#cage-cards-template-form-modal');

        // Listeners for triggers.
        scope.listeners();

        // Get list of fields for breeder and litter.
        scope.getListOfFields();

        // Get first entities data.
        api.getFirstEntitiesForPreview().then(function (data) {
            _this5.firstBreeder = data.breeder;
            _this5.firstLitter = data.litter;
        }, function (response) {
            _this5.errors = response.data.errors;
        });
    },
    mixins: [App.Mixins.FieldDescription]
};

},{}],743:[function(require,module,exports){
'use strict';

/**
 * Empty cage card template.
 */
App.emptyCageCardTemplate = {
    id: 0,
    name: '',
    type: '',
    size: '',
    hole: '0',
    fields: {
        table: 'no'
    },
    orientation: 'vertical'
};

/**
 * Cage cards templates list component.
 */
App.Components.CageCardsTemplatesList = {
    template: '#cage-cards-templates-list',
    data: function data() {
        return {
            template: _.extend({}, App.emptyCageCardTemplate),
            paginatedtemplates: [],
            alltemplates: [],
            deleteCageCardTemplateModal: {},
            copyCageCardTemplateModal: {},
            activeCageCardTemplate: {},
            cageCardTemplateFormModal: {},
            cageCardPrintModal: {},
            page: 1,
            fieldsoptions: [],
            btn_name: [],
            disableLoadMore: true,
            visibleItemsPerPage: 10
        };
    },
    components: {
        'cage-cards-print': App.Components.CageCardsPrint,
        'cage-cards-template-form': App.Components.CageCardsTemplateForm
    },
    computed: {
        confirmTarget: function confirmTarget() {
            return this.activeCageCardTemplate.name;
        },
        currentRoute: function currentRoute() {
            return this.$route.path.split('?')[0];
        }
    },
    methods: {
        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        addNew: function addNew() {
            $('#cage-cards-template-form-modal').modal('show');
        },
        /**
         * Update list of templates action.
         */
        updateList: function updateList() {
            var _this = this;

            var request = { page: this.page };

            api.getCageCardsTemplates(request).then(function (data) {
                _this.disableLoadMore = data.totalPages < 2;
                _this.paginatedtemplates = data.templates;
            });
        },

        /**
         * Load more.
         */
        loadMore: function loadMore() {
            var scope = this;

            ++scope.page;

            api.getCageCardsTemplates({ page: scope.page }).then(function (data) {
                scope.paginatedtemplates = scope.paginatedtemplates.concat(data.templates);

                scope.disableLoadMore = scope.page == data.totalPages;
            });
        },

        /**
         * Delete template modal show.
         */
        deleteModal: function deleteModal(template) {
            this.activeCageCardTemplate = template;
            this.deleteCageCardTemplateModal.modal('show');
        },

        /**
         * Delete action.
         */
        delete: function _delete() {
            var _this2 = this;

            this.deleteCageCardTemplateModal.modal('hide');

            api.deleteCageCardTemplate(this.activeCageCardTemplate).then(function () {
                _this2.updateList();
            });
        },

        /**
         * Copy template action.
         */
        copy: function copy(template) {
            var _this3 = this;

            this.activeCageCardTemplate = template;

            api.copyCageCardTemplate(this.activeCageCardTemplate).then(function () {
                _this3.updateList();
            });
        },

        /**
         * Add template modal.
         */
        addNewCageCardTemplateModal: function addNewCageCardTemplateModal() {
            App.vent.trigger('cageCardTemplate.modal.open');

            this.template = _.extend({}, App.emptyCageCardTemplate);

            this.cageCardTemplateFormModal.modal({
                backdrop: 'static',
                keyboard: false
            });
            this.cageCardTemplateFormModal.modal('show');
        },

        /**
         * Edit template modal.
         */
        editCageCardTemplateModal: function editCageCardTemplateModal(template) {
            var _this4 = this;

            App.vent.trigger('cage-card-template.modal.open');

            this.template = _.extend({}, template);

            this.cageCardTemplateFormModal.modal({
                backdrop: 'static',
                keyboard: false
            });
            this.cageCardTemplateFormModal.modal('show');

            api.getCageCardTemplateFieldsOptionsList().then(function (data) {
                _this4.fieldsoptions = _this4.template.type === 'litter' ? data.litter : data.breeder;
            });
        },

        /**
         * Add new template modal form request.
         */
        newCageCardTemplateModalRequest: function newCageCardTemplateModalRequest() {
            if (this.$route.query.newCageCardTemplateModal) {
                this.addNewCageCardTemplateModal();
            }
        },

        /**
         * Print batch request.
         */
        printBatchModalRequest: function printBatchModalRequest() {
            if (this.$route.query.printBatchModal) {
                this.printModal();
            }
        },

        /**
         * Open print modal.
         */
        printModal: function printModal(template) {
            this.template = template !== undefined ? _.extend({}, template) : {};

            this.cageCardPrintModal.modal('show');
        },

        /**
         * Add new cage card template modal sidebar link handler.
         */
        addNewModalSidebarLinkHandler: function addNewModalSidebarLinkHandler(template) {
            var scope = this;

            // Add new modal request.
            scope.$watch('$route.query.newCageCardTemplateModal', scope.newCageCardTemplateModalRequest, { deep: true });

            if (scope.$route.query.newCageCardTemplateModal) {
                scope.addNewCageCardTemplateModal();
            }

            // Dismiss modal handling.
            $(document).on('hide.bs.modal', '#cage-cards-template-form-modal', function (event) {
                if ($(event.target).is('#cage-cards-template-form-modal') && scope.$route.query.newCageCardTemplateModal) {
                    scope.$route.router.go('/cage-cards/templates');
                }
            });
        },

        /**
         * Print batch sidebar link handler.
         */
        printBatchSidebarLinkHandler: function printBatchSidebarLinkHandler(template) {
            var scope = this;

            // Print batch modal request.
            scope.$watch('$route.query.printBatchModal', scope.printBatchModalRequest, { deep: true });

            if (scope.$route.query.printBatchModal) {
                scope.printModal();
            }

            // Dismiss modal handling.
            $(document).on('hide.bs.modal', '#cage-cards-print-modal', function (event) {
                if ($(event.target).is('#cage-cards-print-modal') && scope.$route.query.printBatchModal) {
                    scope.$route.router.go('/cage-cards/templates');
                }
            });
        }
    },
    ready: function ready() {
        var _this5 = this;

        var scope = this;

        // Jquery elements assignment.
        scope.deleteCageCardTemplateModal = $('#delete-cage-cards-template-modal');
        scope.copyCageCardTemplateModal = $('#copy-cage-cards-template-modal');
        scope.cageCardTemplateFormModal = $('#cage-cards-template-form-modal');
        scope.cageCardPrintModal = $('#cage-cards-print-modal');

        // Update list.
        scope.updateList();

        // Sidebar link handlers.
        scope.addNewModalSidebarLinkHandler();
        scope.printBatchSidebarLinkHandler();

        // Get list of all templates.
        if (!this.alltemplates.length) {
            api.getCageCardsTemplates({}).then(function (data) {
                _this5.alltemplates = data.templates;
            });
        }
        if (this.$route.query.newModal) {
            this.addNew();
        }

        this.getCurrentData();
    }
};

},{}],744:[function(require,module,exports){
'use strict';

App.Components.CageCull = {
    template: "#cage-cull-template",
    data: function data() {
        return {
            errors: {},
            date: moment(new Date()).format(App.dateFormat),
            loaded: 0,
            current: 0,
            selectedCage: 0,
            loading: false
        };
    },
    props: ['cages', 'cage', 'kits', 'filterKit', 'isGlobal'],
    computed: {
        cullForm: function cullForm() {
            var form = '#cage-cull-modal';

            return form;
        }
    },
    watch: {
        cage: function cage(_cage, old_cage) {
            if (_cage && _cage.id) {
                this.selectedCage = _cage.id;
            }
        }
    },
    methods: {
        saveEntireCage: function saveEntireCage() {
            var _this = this;

            this.loading = true;
            var data = {
                date: this.date,
                cage_id: this.selectedCage
            };

            api.cullCage(data).then(function () {
                _this.$dispatch('refresh-cages');
                _this.loading = false;
            }, function () {
                _this.loading = false;
            });

            $(this.cullForm).modal('hide');
        }
    },
    ready: function ready() {
        this.loading = false;
    }
};

},{}],745:[function(require,module,exports){
'use strict';

App.Components.CageDied = {
    template: "#cage-died-template",
    data: function data() {
        return {
            reason: '',
            errors: {},
            date: moment(new Date()).format(App.dateFormat),
            loaded: 0,
            current: 0,
            selectedCage: 0,
            loading: false
        };
    },
    props: ['cages', 'cage', 'kits', 'filterKit', 'isGlobal'],
    computed: {
        diedForm: function diedForm() {
            var form = '#cage-died-modal';

            return form;
        }
    },
    watch: {
        cage: function cage(_cage, old_cage) {
            if (_cage && _cage.id) {
                this.selectedCage = _cage.id;
            }
        }
    },
    methods: {
        saveEntireCage: function saveEntireCage() {
            var _this = this;

            this.loading = true;
            var data = {
                date: this.date,
                reason: this.reason,
                cage_id: this.selectedCage
            };

            api.diedCage(data).then(function () {
                _this.$dispatch('refresh-cages');
                _this.loading = false;
            }, function () {
                _this.loading = false;
            });

            $(this.diedForm).modal('hide');
        }
    },
    ready: function ready() {
        this.loading = false;
    }
};

},{}],746:[function(require,module,exports){
'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.CageForm = {
  template: "#cage-form-template",
  data: function data() {
    return {
      errors: {},
      selectedCage: null,
      loading: false,
      input: {
        name: null
      }
    };
  },
  props: ['cages', 'cage', 'kits', 'filterKit', 'isGlobal'],
  computed: {
    cageForm: function cageForm() {
      var form = '#cage-form-modal';

      return form;
    }
  },
  events: {
    "open-cage-form": function openCageForm() {
      this.initFormData();
      var form = $("#cage-form-modal");
      form.modal({
        backdrop: "static",
        keyboard: false
      });
    }
  },
  watch: {
    cage: function cage(_cage, old_cage) {
      if (_cage && _cage.id) {
        this.selectedCage = _cage.id;
      }
    }
  },
  methods: {
    initFormData: function initFormData() {
      this.input = {
        name: null
      };
    },
    sendCage: function sendCage() {
      var _this = this;

      this.loading = 1;
      var cage = (0, _assign2.default)({}, this.input);
      cage.cage_id = this.cage.id;

      if (Array.isArray(cage.notes)) {
        cage.notes = (0, _stringify2.default)(cage.notes);
      }

      api.updateCage(cage).then(function (data) {
        _this.loading = 0;
        $("#cage-form-modal").modal("hide");
        _this.$dispatch("refresh-cages");
      }, function (response) {
        _this.loading = 0;
        _this.errors = response.data.errors;
      });
    }
  },
  ready: function ready() {
    this.loading = 0;
  },

  mixins: [App.Mixins.FieldDescription]
};

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22}],747:[function(require,module,exports){
"use strict";

App.Components.CageSell = {
  template: "#cage-sell-template",
  data: function data() {
    return {
      bucks: [],
      does: [],
      errors: {},
      date: moment(new Date()).format(App.dateFormat),
      activeKit: {},
      loaded: 0,
      selectedCage: 0,
      soldKits: [],
      saving: false,
      isEntireCage: false,
      entireCageValue: 0,
      transferTo: "",
      transferErrors: {}
    };
  },

  props: ["cages", "cage", "kits", "isGlobal"],
  components: {
    "image-upload": App.Components.ImageUpload,
    "sex-select": App.Components.SexSelect,
    "lbs-oz-input": App.Components.LbsOzInput
  },
  computed: {
    actualKitsCount: function actualKitsCount() {
      return this.kits.length;
    },
    averageKitsSale: function averageKitsSale() {
      var sale = this.actualKitsCount ? this.entireCageValue / this.actualKitsCount : 0;

      return this.currencySign() + " " + sale.toFixed(2);
    },
    isDisableSave: function isDisableSave() {
      if (this.isEntireCage) {
        return !(this.isEntireCage && this.entireCageValue);
      } else {
        return this.kits && this.kits.length != this.soldKits.length;
      }
    }
  },
  watch: {
    cage: function cage() {
      var _this = this;

      if (this.cage && this.cage.id) {
        api.getCageKitsWeighOfType(this.cage.id, "rabbitkit").then(function (kits) {
          _this.kits = kits;
        });
        this.selectedCage = this.cage.id;
      }
    },
    selectedCage: function selectedCage(a, b) {
      this.cage = _.find(this.cages, function (item) {
        return item.id == this.selectedCage;
      }.bind(this));

      this.soldKits = [];
      this.transferTo = "";
      this.transferErrors = {};
    },
    kits: function kits() {
      this.loaded = 1;
      this.activeKit = this.kits[0];
      this.entireCageValue = 0;
    },
    transferTo: function transferTo() {
      this.transferErrors = {};
    }
  },
  methods: {
    getGenderClass: function getGenderClass(sex) {
      if (!sex) {
        return "bg-gray-active";
      }
      return sex == "buck" ? "bg-aqua" : "bg-maroon";
    },
    saveSale: function saveSale(kit) {
      var isSold = _.find(this.soldKits, function (item) {
        return item.id == kit.id;
      });
      if (!isSold) {
        this.soldKits.push(kit);
      }
    },
    sellALl: function sellALl() {
      if (this.isEntireCage) {
        this.sellEntireCage();
      } else {
        this.presellCage();
      }
    },
    sellEntireCage: function sellEntireCage() {
      var count = this.kits.length;
      var value = this.entireCageValue / count;

      _.map(this.kits, function (kit) {
        kit.sale_value = value;
      });

      this.presellCage();
    },
    presellCage: function presellCage() {
      var _this2 = this;

      this.saving = true;
      var data = {
        date: this.date,
        kits: this.kits,
        transfer_to: this.transferTo
      };

      if (this.transferTo && this.transferTo != "add") {
        // verify if the email is valid
        api.verifyTransferableKit(this.kits[0], this.transferTo).then(function () {
          _this2.sellCage(data);
        }, function (error) {
          // show errors on form
          _this2.transferErrors = error.data.errors;
          _this2.saving = false;
        });
      } else {
        this.sellCage(data);
      }
    },
    sellCage: function sellCage(data) {
      var _this3 = this;

      api.postCageSell(this.cage, data).then(function () {
        _this3.$dispatch("refresh-kits");
        _this3.$dispatch("weighted");
        _this3.$dispatch("cage-updated");
        _this3.$dispatch("reload-tasks", { typeOfTask: "all", page: null });
        if (!_this3.isGlobal) {
          $("#cage-sell-modal").modal("hide");
        } else {
          $("#global-sell-weight-modal").modal("hide");
        }
        _this3.showAlert({
          type: 'success',
          text: _this3.cage.given_id + "'s kits has been sold."
        });
        _this3.refreshForm();
        _this3.saving = false;
      }, function (response) {
        _this3.$dispatch("refresh-kits");
        _this3.$dispatch("weighted");
        _this3.errors = response.data.errors;
        _this3.saving = false;
      });
    },
    refreshForm: function refreshForm() {
      this.cage = {};
      this.selectedCage = 0;
      this.entireCageValue = 0;
      this.transferTo = "";
      this.transferErrors = {};
    },
    getOptionTitle: function getOptionTitle(item) {
      var title = "";

      if (item) {
        if (item.parents && item.parents.length > 1) {
          title += item.parents[0].name + "+" + item.parents[1].name;
        }

        title += " - " + item.given_id;
      }

      return title;
    },
    initSellType: function initSellType() {
      var _this4 = this;

      $("#sell-type-switch").netlivaSwitch({
        width: "35px"
      }).on("netlivaSwitch.change", function (event, state, element) {
        _this4.isEntireCage = state;
      });
    },
    toggleLayout: function toggleLayout() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      $("#sell-type-switch").netlivaSwitch("state", state);
      this.isEntireCage = state;
    }
  },
  ready: function ready() {
    this.initSellType();
  },


  mixins: [App.Mixins.Auth, App.Mixins.Contacts, App.Mixins.Transferable, App.Mixins.Currency, App.Mixins.Alerts, App.Mixins.FieldDescription]
};

},{}],748:[function(require,module,exports){
"use strict";

App.Components.CageWeight = {
  template: "#cage-weight-template",
  data: function data() {
    return {
      bucks: [],
      does: [],
      errors: {},
      date: moment(new Date()).format(App.dateFormat),
      activeKit: {},
      loaded: 0,
      current: 0,
      showNavigator: 1,
      colors: [],
      weights: [],
      generate: false,
      listen: 0,
      changed: -1,
      selectedCage: 0,
      weighedKits: [],
      saving: false,
      isEntireCage: false,
      entireCageWeight: 0
    };
  },

  props: ["cages", "cage", "kits", "isGlobal"],
  components: {
    "image-upload": App.Components.ImageUpload,
    "sex-select": App.Components.SexSelect,
    "lbs-oz-input": App.Components.LbsOzInput
  },
  computed: {
    first: function first() {
      return this.cage.id && !parseFloat(this.cage.combined_weight);
    },
    weighForm: function weighForm() {
      var form = "#cage-weight-modal";
      if (this.isGlobal) form = "#global-cage-weight-modal";

      return form;
    },
    averageKitsWeight: function averageKitsWeight() {
      var weight = this.actualKitsCount ? this.entireCageWeight / this.actualKitsCount : 0;

      if (this.weightSlug == "lbs-oz") {
        var lbs = weight ? Math.floor(weight / 16) : 0;
        var oz = weight ? parseFloat((weight - lbs * 16).toFixed(3)) : 0;

        return lbs + " lbs " + oz + " oz";
      } else {
        return weight.toFixed(2) + " " + this.weightSlug;
      }
    },
    isDisableSave: function isDisableSave() {
      if (this.isEntireCage) {
        return !(this.isEntireCage && this.entireCageWeight);
      } else {
        return this.kits && this.kits.length != this.weighedKits.length;
      }
    }
  },
  watch: {
    cage: function cage() {
      var _this = this;

      if (this.cage && this.cage.id) {
        api.getCageKitsWeighOfType(this.cage.id, "rabbitkit").then(function (kits) {
          _this.kits = kits;
        });
        this.selectedCage = this.cage.id;
        this.current = 0;
      }
    },
    selectedCage: function selectedCage(a, b) {
      this.cage = _.find(this.cages, function (item) {
        return item.id == this.selectedCage;
      }.bind(this));
    }
  },
  methods: {
    saveAll: function saveAll() {
      if (this.isEntireCage) {
        this.saveEntireCage();
      } else {
        if (this.first && this.changed) {
          if (!this.kits.length || this.kits.length == this.weighedKits.length) {
            this.sendKitsFirstWeigh();
          } else {
            this.saveKit(_.extend({}, this.activeKit), this.sendKits.bind(this));
          }
        } else {
          this.sendKits();
        }
      }
    },
    saveEntireCage: function saveEntireCage() {
      var _this2 = this;

      this.saving = true;
      var data = {
        date: this.date,
        weight: this.entireCageWeight
      };

      api.postEntireCageWeigh(this.cage, data).then(function () {
        _this2.$dispatch("refresh-kits");
        _this2.$dispatch("weighted");
        _this2.$dispatch("reload-tasks", { typeOfTask: "all", page: null });
        $(_this2.weighForm).modal("hide");
        _this2.refreshForm();
        _this2.saving = false;
      }, function (response) {
        _this2.$dispatch("refresh-kits");
        _this2.$dispatch("weighted");
        $(_this2.weighForm).modal("hide");
        _this2.errors = response.data.errors;
        _this2.saving = false;
      });
    },
    sendKits: function sendKits() {
      var _this3 = this;

      this.errors = {};
      this.saving = true;

      var data = {
        date: this.date,
        kits: this.kits,
        kits_weighed: this.weighedKits.length
      };

      _.each(this.kits, function (kit) {
        if (kit.weight_unit_short === "lbs-oz") {
          if (kit.current_weight[0]) {
            kit.current_weight = parseFloat(kit.current_weight[0] * 16) + (kit.current_weight[1] ? parseFloat(kit.current_weight[1]) : 0);
            kit.weight.push(kit.current_weight);
          }
        }
      });

      api.postCageWeigh(this.cage, data).then(function () {
        _this3.$dispatch("refresh-kits");
        _this3.$dispatch("weighted");
        _this3.$dispatch("reload-tasks", { typeOfTask: "all", page: null });
        $(_this3.weighForm).modal("hide");
        _this3.refreshForm();
        _this3.saving = false;
      }, function (response) {
        _this3.$dispatch("refresh-kits");
        _this3.$dispatch("weighted");
        $(_this3.weighForm).modal("hide");
        _this3.errors = response.data.errors;
        _this3.saving = false;
      });
    },
    sendKitsFirstWeigh: function sendKitsFirstWeigh() {
      var _this4 = this;

      this.errors = {};
      this.saving = true;

      var data = {
        date: this.date,
        kits: this.kits,
        first: true
      };

      api.postCageWeigh(this.cage, data).then(function () {
        _this4.$dispatch("refresh-kits");
        _this4.$dispatch("weighted");
        _this4.$dispatch("reload-tasks", { typeOfTask: "all", page: null });
        $(_this4.weighForm).modal("hide");
        if (_this4.isGlobal) _this4.$root.$emit("global-notification-tab-reload");
        _this4.cage.total_weight = 0;
        $.each(_this4.kits, function (i, kit) {
          if (kit.current_weight) {
            _this4.cage.total_weight += kit.current_weight;
          }
        });
        _this4.refreshForm();
        _this4.saving = false;
      }, function (response) {
        _this4.$dispatch("refresh-kits");
        _this4.$dispatch("weighted");
        $(_this4.weighForm).modal("hide");
        _this4.errors = response.data.errors;
        _this4.saving = false;
      });
    },
    refreshForm: function refreshForm() {
      this.selectedCage = 0;
      this.cage = {};
      this.entireCageWeight = 0;
    },
    diedNextKit: function diedNextKit() {
      this.diedKit(this.activeKit);
      if (this.current >= this.kits.length) {
        this.current = 0;
      }
      this.changed = -1;
    },
    imageUploaded: function imageUploaded(image) {
      this.activeKit.image = image;
    },
    father: function father() {
      return _.find(this.cage.parents, function (item) {
        return item.sex === "buck";
      });
    },
    mother: function mother() {
      return _.find(this.cage.parents, function (item) {
        return item.sex === "doe";
      });
    },
    initWeighType: function initWeighType() {
      var _this5 = this;

      $("#weigh-type-switch" + this.globalSuffix).netlivaSwitch({
        width: "35px"
      }).on("netlivaSwitch.change", function (event, state, element) {
        _this5.isEntireCage = state;
      });
    },
    toggleLayout: function toggleLayout() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      $("#weigh-type-switch" + this.globalSuffix).netlivaSwitch("state", state);
      this.isEntireCage = state;
    }
  },
  ready: function ready() {
    this.initWeighType();
  },


  mixins: [App.Mixins.Weightable, App.Mixins.Generic, App.Mixins.WeighForm]
};

},{}],749:[function(require,module,exports){
"use strict";

App.Components.CagesList = {
  template: "#cages-list-template",
  data: function data() {
    return {
      activeKit: {},
      activeKits: [],
      activeCage: {},
      cages: [],
      openCages: [],
      errors: {},
      loading: 1,
      order: "name|asc",
      page: 1,
      totalPages: 1,
      totalCount: 0
    };
  },

  props: ["displayItems", "searchQuery", "perPage", "filters", "actionableCages", "litters"],
  watch: {
    order: function order() {
      this.updateList();
    },
    searchQuery: function searchQuery() {
      this.updateList();
    },
    totalCount: function totalCount(newData) {
      this.$dispatch("total-count-updated", newData);
    }
  },
  computed: {},
  components: {
    "multiple-cage-form": App.Components.MultipleCageForm,
    "litter-box-v2": App.Components.LitterBoxV2,
    "kit-form": App.Components.KitForm,
    "cage-weight": App.Components.CageWeight,
    "cage-sell": App.Components.CageSell,
    'cage-butcher': App.Components.CageButcher,
    "cage-archive": App.Components.CageArchive,
    "cage-cull": App.Components.CageCull,
    "cage-died": App.Components.CageDied,
    "cage-breed": App.Components.CageBreed,
    "cage-form": App.Components.CageForm
  },
  events: {
    "refresh-cages": function refreshCages() {
      this.openCages = [];
      this.updateList();
    },
    "open-multiple-cage-form": function openMultipleCageForm() {
      this.$broadcast("open-multiple-cage-form");
    },
    "open-delete-multiple-cages": function openDeleteMultipleCages() {
      this.$broadcast("open-delete-multiple-cages");
    },
    "open-cage-form": function openCageForm() {
      this.$broadcast("open-cage-form");
    }
  },
  methods: {
    buildFilters: function buildFilters() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var allowedFilters = ["order", "orderDirection"];

      data.filters = _.filter(this.filters, function (value, key) {
        return allowedFilters.includes(key);
      });

      return data;
    },
    updateList: function updateList() {
      var _this = this;

      this.loading = 1;
      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var data = { page: this.page, perPage: this.perPage };
      if (this.order) {
        data.order = this.order;
      }
      data = this.buildFilters(data);
      data.searchQuery = this.searchQuery;

      api.getCages(data).then(function (data) {
        _this.cages = data.cages.data;
        _this.pages = data.cages.last_page;
        _this.order = data.order;
        _this.loading = 0;
        _this.itemsLoaded = data.cages.current_page;
        _this.totalItems = data.cages.total;

        // for list view
        _this.totalPages = data.cages.last_page;
        _this.totalCount = data.cages.total;
        _this.description = {
          from: data.cages.from,
          to: data.cages.to,
          total: data.cages.total
        };

        _this.$nextTick(function () {
          _this.initializeCagesCheckbox();
        });
      });
    },
    initializeCagesCheckbox: function initializeCagesCheckbox() {
      var _this2 = this;

      this.actionableCages = [];
      $(".cage-checkbox").iCheck({
        checkboxClass: "icheckbox_square-green",
        radioClass: "iradio_square-green"
      }).on("ifChecked", function (event) {
        var cage = _this2.getCageById(event.target.name);
        _this2.actionableCages.push(cage);
      }).on("ifUnchecked", function (event) {
        var cage = _this2.getCageById(event.target.name);
        _this2.actionableCages = _.filter(_this2.actionableCages, function (item) {
          return item.id != cage.id;
        });
      });
    },
    getCageById: function getCageById(id) {
      id = id.replace("cage-", "");
      var cage = _.find(this.cages, function (cage) {
        return cage.id == id;
      });

      return cage;
    },
    cageContainerClicked: function cageContainerClicked(id, element) {
      var action = $(element).data("action") || "open";

      if (action == "close") {
        $(".kits-cage-container-" + id).hide();
        this.closeCages(id);
      } else {
        $(".kits-cage-container-" + id).show();
        this.openCages.push(id); // add to open cages
      }
    },
    closeCages: function closeCages(id) {
      // remove from open cages
      var key = this.openCages.indexOf(id);
      if (key > -1) {
        this.openCages.splice(key, 1);

        this.closeCages(id); //recursive call to clear all keys (in case it's saved multiple times)
      }
    },
    isCageOpen: function isCageOpen(id) {
      var key = this.openCages.indexOf(id);
      if (key > -1) {
        return true;
      } else {
        return false;
      }
    },
    editKit: function editKit(kit) {
      this.activeKit = kit;
      var form = $("#kit-form-modal");
      form.modal({
        backdrop: "static",
        keyboard: false
      });
      form.modal("show");
    },
    refreshKits: function refreshKits() {
      this.$broadcast("refresh-kits-global", this.activeKit.cage_id);
    },
    weighCage: function weighCage(cage) {
      this.activeCage = cage;
      $("#cage-weight-modal").modal({
        backdrop: "static",
        keyboard: false
      });
    },
    sellCage: function sellCage(cage) {
      this.activeCage = cage;
      $("#cage-sell-modal").modal({
        backdrop: "static",
        keyboard: false
      });
    },
    butcherCage: function butcherCage(cage) {
      this.activeCage = cage;
      $("#cage-butcher-modal").modal({
        backdrop: "static",
        keyboard: false
      });
    },
    archiveCage: function archiveCage(cage) {
      this.activeCage = cage;
      $("#cage-archive-modal").modal({
        backdrop: "static",
        keyboard: false
      });
    },
    cullCage: function cullCage(cage) {
      this.activeCage = cage;
      $("#cage-cull-modal").modal({
        backdrop: "static",
        keyboard: false
      });
    },
    diedCage: function diedCage(cage) {
      this.activeCage = cage;
      $("#cage-died-modal").modal({
        backdrop: "static",
        keyboard: false
      });
    },
    breedCage: function breedCage(cage) {
      this.activeCage = cage;
      $("#cage-breed-modal").modal({
        backdrop: "static",
        keyboard: false
      });
    },
    editCage: function editCage(cage) {
      this.activeCage = cage;
      this.$broadcast('open-cage-form');
    }
  },
  ready: function ready() {
    this.updateList();
  },

  mixins: [App.Mixins.Generic, App.Mixins.Alerts, App.Mixins.BreedersFilter, App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.Butcherable, App.Mixins.DeathReason, App.Mixins.Weightable, App.Mixins.Transferable, App.Mixins.Photos, App.Mixins.FieldDescription, App.Mixins.Filterable]
};

},{}],750:[function(require,module,exports){
"use strict";

App.Components.CancellationCount = {
  template: "#cancellation-count-template",
  data: function data() {
    return {
      months: [],
      selectedMonth: "",
      selectedYear: "",
      monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      cancellationCountData: [],
      blank: ''
    };
  },
  props: [],
  computed: {},
  components: {},
  events: {},
  watch: {},
  methods: {
    getPreviousMonthYear: function getPreviousMonthYear() {
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var currentMonth = currentDate.getMonth();
      var monthsArray = [];
      for (var year = currentYear - 1; year <= currentYear; year++) {
        var startMonth = year === currentYear - 1 ? 0 : 1;
        var endMonth = year === currentYear ? currentMonth : 11;

        for (var i = startMonth; i <= endMonth; i++) {
          var month = {
            name: this.monthNames[i] + "-" + year,
            id: (year - currentYear + 1) * 12 + i + 1
          };
          monthsArray.push(month);
        }
      }

      this.months = monthsArray;
    },
    changeMonth: function changeMonth(event) {
      var _this = this;

      this.selectedMonth = event && event.target && event.target.value ? event.target.value : this.selectedMonth;

      api.getCancellationCount({
        month: this.selectedMonth
      }).then(function (data) {
        _this.cancellationCountData = data;

        var androidData = _this.cancellationCountData.find(function (item) {
          return item.platform === "Android";
        });
        var iOSData = _this.cancellationCountData.find(function (item) {
          return item.platform === "iOS";
        });

        var isAndroidCountZero = androidData && androidData.count_c === 0;
        var isiOSCountZero = iOSData && iOSData.count_c === 0;
        if (_this.selectedYear <= 2023 && _this.monthNames.indexOf(_this.selectedMonth.split("-")[0]) + 1 <= 6) {
          _this.blank = isAndroidCountZero && isiOSCountZero ? 'No cancellation records found for in-app subscriptions.' : null;
        }
      });
    }
  },
  ready: function ready() {
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();
    this.selectedMonth = this.monthNames[currentMonth] + "-" + currentYear;
    this.selectedYear = this.selectedMonth.split("-")[1];
    this.getPreviousMonthYear();
    this.changeMonth();
  },
  mixins: []
};

},{}],751:[function(require,module,exports){
"use strict";

App.Components.DashboardV2 = App.Components.Dashboard.extend({
    template: "#dashboard-v2-template"
});

},{}],752:[function(require,module,exports){
'use strict';

App.Components.Dashboard = Vue.extend({
    template: "#dashboard-template",
    data: function data() {
        return {
            litter: {},
            litters: [],
            kits: [],
            breeders: [],
            activeBreed: {},
            activeBirth: {},
            plans: [],
            dummyEvents: [],
            blogs: [],
            loadingBlogs: true
        };
    },
    props: [],
    computed: {
        isShowButcher: function isShowButcher() {
            return App.isShowButcher;
        }
    },
    components: {
        'litter-weight': App.Components.LitterWeight,
        'litter-butcher': App.Components.LitterButcher,
        'upcomming-tasks': App.Components.UpcommingTasks,
        'schedule-calendar': App.Components.ScheduleCalendar,
        'birth-form': App.Components.BirthForm,
        'reports-main': App.Components.ReportsMain,
        'schedule-main': App.Components.ScheduleMain
    },
    events: {
        'reload-tasks': function reloadTasks(msg) {
            if (!msg.calendarOnly) {
                this.$broadcast('upcomming-tasks-reload', msg);
            }

            this.$broadcast('schedule-calendar-reload', msg);
        },
        'task-managing': function taskManaging(msg) {
            this.$broadcast('upcoming-tasks-managing', msg);
        },
        'open-breed-modal': function openBreedModal(msg) {
            this.$broadcast('new-breed-with-doe', msg, true);
        },
        showBreedModal: function showBreedModal() {
            this.breedModal();
        }
    },
    methods: {
        newLitter: function newLitter() {
            this.$route.router.go({
                name: 'Litter Type',
                params: { action: 'new' }
            });
        },

        newBreeder: function newBreeder() {
            this.$route.router.go({
                name: 'Breeder Type',
                params: { action: 'new' }
            });
        },
        shortDate: function shortDate(date) {
            return App.parseMoment(date).format(App.dateFormatShort);
        },
        breedModal: function breedModal() {
            this.$broadcast('new-breed', true);
        },
        birthModal: function birthModal(plan_id) {
            this.$root.$emit('open-global-birth-form', { breed_id: plan_id || '-1' });
            delete App.dashboard_birth_breed;
        },
        generalBirthModal: function generalBirthModal() {
            var _this = this;

            api.getUsersPlans().then(function (plans) {
                _this.plans = plans;

                if (_this.plans.length) {
                    _this.birthModal();
                } else {
                    $('#empty-breedplans-modal').modal('show');
                }
            });
        },

        weightModal: function weightModal(litter_id) {
            var litters = litter_id ? [this.litters.find(function (litter) {
                return litter.id == litter_id;
            })] : this.litters;
            this.$root.$emit('open-global-litter-weight', { litters: litters || '-1' });
            delete App.dashboard_weight_litter;
        },

        butcherModal: function butcherModal(litter_id) {
            var litters = litter_id ? [this.litters.find(function (litter) {
                return litter.id == litter_id;
            })] : this.litters;
            this.$root.$emit('open-global-litter-butcher', { litters: litters || '-1' });
            delete App.dashboard_butch_litter;
        },
        loadBreeders: function loadBreeders() {
            var _this2 = this;

            api.getBreedersList().then(function (breeders) {
                _this2.breeders = breeders;
            });
        },
        showGlobalForms: function showGlobalForms() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder-form';

            switch (type) {
                case 'breeder-form':
                    this.$root.$emit('open-global-new-breeder-form');
                    break;
                case 'breeder-many':
                    this.$route.router.go('/wizard/breeders');
                    break;
                case 'litter-form':
                    this.$root.$emit('open-global-new-litter-form');
                    break;
                case 'categories-form':
                    this.$root.$emit('open-global-categories-form');
                    break;
                case 'breed-form':
                    this.$root.$emit('open-global-breed-form');
                    break;
                case 'ledger-form':
                    this.$root.$emit('open-global-ledger-form');
                    break;
                case 'weigh-form':
                    this.$root.$emit('open-global-litter-weight', { litters: this.litters });
                    break;
                case 'butcher-form':
                    this.$root.$emit('open-global-litter-butcher', { litters: this.litters });
                    break;
            }
        },
        initializeBlogs: function initializeBlogs() {
            var _this3 = this;

            api.getBlogPosts().then(function (data) {
                _this3.blogs = data;
                _this3.loadingBlogs = false;
            }, function (error) {
                _this3.loadingBlogs = false;
            });
        }
    },
    ready: function ready() {
        var _this4 = this;

        api.getLittersList({ archived: false }).then(function (res) {
            _this4.litters = res;
            if (App.dashboard_birth_breed) {
                _this4.birthModal(App.dashboard_birth_breed);
            }
            if (App.dashboard_butch_litter) {
                _this4.butcherModal(App.dashboard_butch_litter);
            }
            if (App.dashboard_weight_litter) {
                _this4.weightModal(App.dashboard_weight_litter);
            }
            App.vent.on('dashboard-birth-breed', function (el, breed_id) {
                _this4.birthModal(breed_id);
            });
            App.vent.on('dashboard-butch-litter', function (el, litter_id) {
                _this4.butcherModal(litter_id);
            });
            App.vent.on('dashboard-weight-litter', function (el, litter_id) {
                _this4.weightModal(litter_id);
            });
        });
        this.$emit('reload-tasks', { typeOfTask: 'all' });
        $('body').off('tour.show').on('tour.show', function () {
            _this4.startTour('dashboard');
        });
        if (!App.tourShowed) {
            App.tourShowed = 1;
            this.$http.post('/admin/users/tourShowed');
            $('body').trigger('tour.show');
        }

        // this.initializeBlogs(); // NOTE: temporarily remove, causing issues on loading
    },
    destroyed: function destroyed() {
        App.vent.off('dashboard-birth-breed');
        App.vent.off('dashboard-butch-litter');
        App.vent.off('dashboard-weight-litter');
    },

    mixins: [App.Mixins.Butcherable, App.Mixins.Tours, App.Mixins.DashboardMessage]
});

},{}],753:[function(require,module,exports){
"use strict";

App.Components.DataDelete = {
  template: "#data-delete-template",
  computed: {
    dateToday: function dateToday() {
      return moment().format("dddd, MMMM Do, YYYY");
    },
    name: function name() {
      return App.user_name;
    }
  },
  methods: {
    deleteData: function deleteData() {
      api.dataDelete().then(function (response) {
        window.location.href = "/logout";
      });
    }
  }
};

},{}],754:[function(require,module,exports){
'use strict';

if (!('Exploitable' in App.Components)) {
    App.Components.Exploitable = {};
}

/**
 * Required data to work:
 * * saver (api method, will be passed a model)
 * * modal_id
 * * model (setter/getter)
 * * emptyModel (getter)
 */
App.Components.Exploitable.Form = Vue.extend({
    data: function data() {
        return {
            errors: {},
            loading: 0
        };
    },
    methods: {
        send: function send() {
            var _this = this;

            this.loading = 1;
            this.saver(this.model).then(function (data) {
                _this.loading = 0;_this.$emit('submitted', data);
            }, function (response) {
                _this.loading = 0;_this.$emit('submitError', response.data);
            });
        },
        closeModal: function closeModal() {
            $(this.modal_id).modal('hide');
        },
        showModal: function showModal() {
            $(this.modal_id).modal('show');
            this.$emit('modalShown');
        },
        showArchive: function showArchive() {
            this.$dispatch('showArchiveModel', this.model);
        },
        showDelete: function showDelete() {
            this.$dispatch('showDeleteModel', this.model);
        },
        showDied: function showDied() {
            this.$dispatch('showDiedModel', this.model);
        },
        showUnarchive: function showUnarchive() {
            this.$dispatch('showUnarchive', this.model);
        }
    },
    events: {
        submitted: function submitted(response) {
            if (!this.model.id) {
                this.$dispatch('formAdded', response);
            } else {
                this.$dispatch('formUpdated', response);
            }
            this.closeModal();
            this.model = {};
        },
        submitError: function submitError(response) {
            this.errors = response.errors;
        },
        editModel: function editModel(model) {
            this.model = _.extendOwn({}, model);
            this.errors = {};
            this.showModal();
        },
        addModel: function addModel() {
            this.model = _.extendOwn({}, this.emptyModel);
            this.errors = {};
            this.showModal();
        },
        archivedModel: function archivedModel(model) {
            if (this.model.id == model.id) {
                this.closeModal();
            }
        },
        unarchivedModel: function unarchivedModel(model) {
            if (this.model.id == model.id) {
                this.closeModal();
            }
        },
        culledModel: function culledModel(model) {
            if (this.model.id == model.id) {
                this.closeModal();
            }
        },
        unculleModel: function unculleModel(model) {
            if (this.model.id == model.id) {
                this.closeModal();
            }
        },
        deletedModel: function deletedModel(model) {
            if (this.model.id == model.id) {
                this.closeModal();
            }
        },
        diedModel: function diedModel(model) {
            if (this.model.id == model.id) {
                this.closeModal();
            }
        }
    }
});

},{}],755:[function(require,module,exports){
'use strict';

if (!('Exploitable' in App.Components)) {
    App.Components.Exploitable = {};
}

/**
 * Required data to work:
 * * models (array)
 *
 * * deleter (optional)
 * * archiver (optional)
 * * unarchiver (optional)
 * * seller (optional)
 * * unseller (optional)
 * * transferer (optional)
 * * dier (optional)
 */
App.Components.Exploitable.Section = Vue.extend({
    data: function data() {
        return {
            activeModel: {},
            hasArchive: true,
            modalUnique: null,
            soldValue: 0,
            transferTo: '',
            transferErrors: {}
        };
    },
    computed: {
        confirmTarget: function confirmTarget() {
            return this.activeModel.name;
        }
    },
    events: {
        formAdded: function formAdded(model) {
            this.models.push(model);
        },
        formUpdated: function formUpdated(model) {
            var match = _.find(this.models, this.compareModels.bind(this, model));
            if (match) {
                _.extendOwn(match, model);
            } else {
                this.$trigger('formAdded', model);
            }
        },
        showArchiveModel: function showArchiveModel(model) {
            this.activeModel = model;
            $(this.modalId('#archive-breed-modal'), this.$el).modal('show');
        },
        doArchiveModel: function doArchiveModel() {
            var _this = this;

            $(this.modalId('#archive-breed-modal'), this.$el).modal('hide');
            this.archiver(this.activeModel).then(function () {
                _this.excludeModel(_this.activeModel);
                _this.$emit('archivedModel', _this.activeModel);
                _this.$broadcast('archivedModel', _this.activeModel);
                _this.activeModel = {};
            });
        },

        showSoldModel: function showSoldModel(model) {
            this.activeModel = model;
            $(this.modalId('#sold-breed-modal'), this.$el).modal('show');
        },
        doSoldModel: function doSoldModel() {
            var _this2 = this;

            $(this.modalId('#sold-breed-modal'), this.$el).modal('hide');
            this.seller(this.activeModel, this.soldValue).then(function () {
                _this2.excludeModel(_this2.activeModel);
                _this2.$emit('soldModel', _this2.activeModel);
                _this2.$broadcast('soldModel', _this2.activeModel);
                _this2.soldValue = 0;
            });
            $(this.modalId('#transfer-breed-modal'), this.$el).modal('show');
        },

        doTransferModel: function doTransferModel() {
            $(this.modalId('#transfer-breed-modal'), this.$el).modal('hide');
            $(this.modalId('#confirm-transfer-breed-modal'), this.$el).modal('show');
        },

        doCloseTransferModal: function doCloseTransferModal() {
            $(this.modalId('#transfer-breed-modal'), this.$el).modal('hide');
        },

        doConfirmTransferModel: function doConfirmTransferModel() {
            var _this3 = this;

            this.transferer(this.activeModel, this.transferTo).then(function () {
                $(_this3.modalId('#confirm-transfer-breed-modal'), _this3.$el).modal('hide');
                _this3.excludeModel(_this3.activeModel);
                _this3.$emit('transferModel', _this3.activeModel);
                _this3.$broadcast('transferModel', _this3.activeModel);
                _this3.activeModel = {};
                _this3.transferTo = '';
                _this3.transferErrors = {};
            }, function (response) {
                _this3.transferErrors = response.data.errors;
                _this3.unconfirmTransfer();
            });
        },
        doUnconfirmTransferModel: function doUnconfirmTransferModel() {
            $(this.modalId('#confirm-transfer-breed-modal'), this.$el).modal('hide');
            $(this.modalId('#transfer-breed-modal'), this.$el).modal('show');
        },
        doDeclineTransferModel: function doDeclineTransferModel() {
            $(this.modalId('#decline-transfer-breed-modal'), this.$el).modal('hide');
            api.declineTransfer(this.activeModel).then(function () {});
        },

        showUnsoldModel: function showUnsoldModel(model) {
            this.activeModel = model;
            $(this.modalId('#unsold-breed-modal'), this.$el).modal('show');
        },
        doUnsoldModel: function doUnsoldModel() {
            var _this4 = this;

            $(this.modalId('#unsold-breed-modal'), this.$el).modal('hide');
            this.unseller(this.activeModel).then(function () {
                _this4.excludeModel(_this4.activeModel);
                _this4.$emit('unsoldModel', _this4.activeModel);
                _this4.$broadcast('unsoldModel', _this4.activeModel);
                _this4.activeModel = {};
            });
        },

        showUnarchiveModel: function showUnarchiveModel(model) {
            this.activeModel = model;
            $(this.modalId('#unarchive-breed-modal'), this.$el).modal('show');
        },
        doUnarchiveModel: function doUnarchiveModel() {
            var _this5 = this;

            $(this.modalId('#unarchive-breed-modal'), this.$el).modal('hide');
            this.unarchiver(this.activeModel).then(function () {
                _this5.excludeModel(_this5.activeModel);
                _this5.$emit('unarchivedModel', _this5.activeModel);
                _this5.$broadcast('unarchivedModel', _this5.activeModel);
                _this5.activeModel = {};
            });
        },

        showCullModel: function showCullModel(model) {
            this.activeModel = model;
            $(this.modalId('#cull-breed-modal'), this.$el).modal('show');
        },
        doCullModel: function doCullModel() {
            var _this6 = this;

            $(this.modalId('#cull-breed-modal'), this.$el).modal('hide');
            this.culler(this.activeModel).then(function () {
                _this6.excludeModel(_this6.activeModel);
                _this6.$emit('culledModel', _this6.activeModel);
                _this6.$broadcast('culledModel', _this6.activeModel);
                _this6.activeModel = {};
            });
        },

        showUncullModel: function showUncullModel(model) {
            this.activeModel = model;
            $(this.modalId('#uncull-breed-modal'), this.$el).modal('show');
        },
        doUncullModel: function doUncullModel() {
            var _this7 = this;

            $(this.modalId('#uncull-breed-modal'), this.$el).modal('hide');
            this.unculler(this.activeModel).then(function () {
                _this7.excludeModel(_this7.activeModel);
                _this7.$emit('unculledModel', _this7.activeModel);
                _this7.$broadcast('unculledModel', _this7.activeModel);
                _this7.activeModel = {};
            });
        },

        showDeleteModel: function showDeleteModel(model) {
            this.activeModel = model;
            if (this.hasArchive) {
                $(this.modalId('#delete-breed-modal'), this.$el).modal('show');
            } else {
                $(this.modalId('#delete-pure-modal'), this.$el).modal('show');
            }
        },
        doDeleteModel: function doDeleteModel() {
            var _this8 = this;

            this.deleter(this.activeModel).then(function () {
                $(_this8.modalId('#delete-breed-modal') + ', ' + _this8.modalId('#delete-pure-modal'), _this8.$el).modal('hide');
                _this8.excludeModel(_this8.activeModel);
                _this8.$emit('deletedModel', _this8.activeModel);
                _this8.$broadcast('deletedModel', _this8.activeModel);
                _this8.activeModel = {};
            });
        },

        showDiedModel: function showDiedModel(model) {
            this.activeModel = model;
            $(this.modalId('#died-modal'), this.$el).modal('show');
        },
        doDiedModel: function doDiedModel() {
            var _this9 = this;

            this.dier(this.activeModel).then(function () {
                $(_this9.modalId('#died-modal'), _this9.$el).modal('hide');
                _this9.excludeModel(_this9.activeModel);
                _this9.$emit('diedModel', _this9.activeModel);
                _this9.$broadcast('diedModel', _this9.activeModel);
                _this9.activeModel = {};
            });
        }
    },
    methods: {
        modalId: function modalId(_modalId) {
            var res = this.modalUnique ? _modalId + '-' + this.modalUnique : _modalId;
            return res;
        },
        compareModels: function compareModels(model1, model2) {
            // this is a default implementation, please fill free to override it as neede
            return model1.id == model2.id;
        },
        editModel: function editModel(model) {
            this.$emit('editModel', model);
            this.$broadcast('editModel', model);
        },
        excludeModel: function excludeModel(model) {
            var index = _.findIndex(this.models, this.compareModels.bind(this, model));
            if (index !== -1) {
                this.models.splice(index, 1);
            }
        },
        addModel: function addModel() {
            this.$emit('addModel');
            this.$broadcast('addModel');
        },
        showArchive: function showArchive(model) {
            this.$emit('showArchiveModel', model);
        },
        showSold: function showSold(model) {
            this.$emit('showSoldModel', model);
        },
        sold: function sold() {
            this.$emit('doSoldModel');
        },
        transfer: function transfer() {
            this.$emit('doTransferModel');
        },
        closeTransfer: function closeTransfer() {
            this.$emit('doCloseTransferModal');
        },
        confirmTransfer: function confirmTransfer() {
            this.$emit('doConfirmTransferModel');
        },
        unconfirmTransfer: function unconfirmTransfer() {
            this.$emit('doUnconfirmTransferModel');
        },
        declineTransfer: function declineTransfer() {
            this.$emit('doDeclineTransferModel');
        },
        showUnsold: function showUnsold(model) {
            this.$emit('showUnsoldModel', model);
        },
        unsold: function unsold(model) {
            this.$emit('doUnsoldModel');
        },
        archive: function archive() {
            this.$emit('doArchiveModel');
        },
        showUnarchive: function showUnarchive(model) {
            this.$emit('showUnarchiveModel', model);
        },
        unarchive: function unarchive() {
            this.$emit('doUnarchiveModel');
        },
        showCull: function showCull(model) {
            this.$emit('showCullModel', model);
        },
        cull: function cull() {
            this.$emit('doCullModel');
        },
        showUncull: function showUncull(model) {
            this.$emit('showUncullModel', model);
        },
        uncull: function uncull() {
            this.$emit('doUncullModel');
        },
        showDelete: function showDelete(model) {
            this.$emit('showDeleteModel', model);
        },
        delete: function _delete() {
            this.$emit('doDeleteModel');
        },
        showDied: function showDied(model) {
            this.$emit('showDiedModel', model);
        },
        died: function died() {
            this.$emit('doDiedModel');
        },
        missed: function missed() {
            this.$emit('doMissedModel');
        }
    }
});

},{}],756:[function(require,module,exports){
'use strict';

var _eventBus = require('../event-bus');

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component('export-ledgers-contacts', {
    template: '<a href="#" v-on:click.prevent="export()">Export to CSV</a>',
    methods: {
        export: function _export() {
            if (!this.hasAccess(App.access.ledger)) {
                _eventBus2.default.$emit('restrict-access');
                return;
            }
            window.location.href = '/admin/ledgers/contacts/export';
        }
    },
    mixins: [App.Mixins.Auth]
});

},{"../event-bus":882}],757:[function(require,module,exports){
'use strict';

var _eventBus = require('../event-bus');

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component('export-ledgers', {
    template: '<a href="#" v-on:click.prevent="export()">Export</a>',
    methods: {
        export: function _export() {
            if (!this.hasAccess(App.access.ledger)) {
                _eventBus2.default.$emit('restrict-access');
                return;
            }
            window.location.href = '/admin/ledgers/export';
        }
    },
    mixins: [App.Mixins.Auth]
});

},{"../event-bus":882}],758:[function(require,module,exports){
"use strict";

App.Components.FarmManagement = {
  template: "#farm-management-template",
  data: function data() {
    return {
      inactiveFarm: null,
      activeFarm: null,
      farms: [],
      loading: false
    };
  },

  watch: {
    activeFarm: function activeFarm(newData, oldData) {
      if (this.inactiveFarm && this.inactiveFarm != newData) {
        this.changeFarmWarning(newData);
      }

      if (newData == this.inactiveFarm) {
        this.inactiveFarm = "open";
      } else {
        this.inactiveFarm = oldData || "open";
      }
    }
  },
  methods: {
    changeFarmWarning: function changeFarmWarning() {
      this.$root.$emit("open-switch-farm-modal", {
        farms: this.farms,
        activeFarm: this.activeFarm
      });
    },
    changeFarm: function changeFarm() {
      this.fetchFarms(true);
    },
    revertFarm: function revertFarm() {
      this.activeFarm = this.inactiveFarm;
    },
    fetchFarms: function fetchFarms() {
      var _this = this;

      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.activeFarm) {
        localStorage.setItem("activeFarmId", this.activeFarm);
      }

      var params = {
        active_farm_id: this.activeFarm
      };

      api.getFarmsList(params).then(function (data) {
        _this.farms = data.farms;

        if (!_this.activeFarm) {
          _this.activeFarm = _this.farms[0].id;
          _this.fetchFarms();
        }

        if (data.is_initial || refresh) {
          window.location.reload();
        }
      });
    }
  },
  ready: function ready() {
    var _this2 = this;

    this.activeFarm = localStorage.getItem("activeFarmId");
    this.fetchFarms();

    this.$root.$on("change-farm", function () {
      _this2.changeFarm();
    });

    this.$root.$on("revert-farm", function () {
      _this2.revertFarm();
    });

    this.$root.$on("fetch-farms", function () {
      _this2.fetchFarms();
    });

    $(document).on("click", ".farm-dropdown.dropdown-menu", function (e) {
      e.stopPropagation();
    });
  }
};

},{}],759:[function(require,module,exports){
"use strict";

App.Components.FarmSwitch = {
  template: "#farm-switch-template",
  props: ["farms", "activeFarm"],
  methods: {
    getFarmNameById: function getFarmNameById(id) {
      var farm = _.find(this.farms, function (farm) {
        return farm.id == id;
      });

      if (farm) {
        return farm.name;
      }

      return "farm";
    },
    changeFarm: function changeFarm() {
      this.$root.$emit("change-farm");
    },
    revertFarm: function revertFarm() {
      $("#change-farm-modal").modal("hide");
      this.$root.$emit("revert-farm");
    }
  }
};

},{}],760:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Farms = Vue.extend({
  template: "#farms-template",
  data: function data() {
    var _ref;

    return _ref = {
      farms: [],
      farm: {
        name: "",
        location: "",
        description: ""
      },
      perPage: 10,
      totalCount: 0,
      loading: 1,
      order: "name|asc",
      searchQuery: "",
      page: 1,
      totalPages: 1
    }, (0, _defineProperty3.default)(_ref, "loading", false), (0, _defineProperty3.default)(_ref, "displayItems", {
      breeders_count: true,
      date_added: true,
      location: true,
      description: true
    }), (0, _defineProperty3.default)(_ref, "errors", {}), _ref;
  },

  computed: {},
  watch: {
    perPage: function perPage() {
      this.updateList();
    },
    order: function order() {
      this.updateList();
    },
    searchQuery: function searchQuery() {
      this.updateList();
    }
  },
  methods: {
    buildFilters: function buildFilters() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var allowedFilters = ["order", "orderDirection"];

      data.filters = _.filter(this.filters, function (value, key) {
        return allowedFilters.includes(key);
      });

      return data;
    },
    updateList: function updateList() {
      var _this = this;

      this.loading = 1;
      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var data = { page: this.page, perPage: this.perPage };
      if (this.order) {
        data.order = this.order;
      }
      data = this.buildFilters(data);
      data.searchQuery = this.searchQuery;

      api.getFarms(data).then(function (data) {
        _this.farms = data.farms.data;
        _this.pages = data.farms.last_page;
        _this.order = data.order;
        _this.totalItems = data.farms.total;
        _this.loading = 0;

        // for list view
        _this.totalPages = data.farms.last_page;
        _this.totalCount = data.farms.total;
        _this.description = {
          from: data.farms.from,
          to: data.farms.to,
          total: data.farms.total
        };

        // refetch farms list on navbar
        _this.$root.$emit("fetch-farms");
      });
    },
    initializeDisplayItems: function initializeDisplayItems() {
      var _this2 = this;

      $(".display-settings").iCheck({
        checkboxClass: "icheckbox_square-green",
        radioClass: "iradio_square-green"
      }).on("ifChecked", function (event) {
        _this2.displayItems[event.target.name] = true;
        localStorage.setItem("farmsDisplay", (0, _stringify2.default)(_this2.displayItems));
      }).on("ifUnchecked", function (event) {
        _this2.displayItems[event.target.name] = false;
        localStorage.setItem("farmsDisplay", (0, _stringify2.default)(_this2.displayItems));
      });

      var farmsDisplay = JSON.parse(localStorage.getItem("farmsDisplay"));
      if (farmsDisplay) {
        this.displayItems = farmsDisplay;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.displayItems)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (this.displayItems[key]) {
            $("input[class='display-settings'][name='" + key + "']").iCheck("check");
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    clearAddFarmModal: function clearAddFarmModal() {
      this.errors = {};
      $("#add-farm-modal").modal("hide");
    },
    addFarmModal: function addFarmModal() {
      this.clearAddFarmModal();
      $("#add-farm-modal").modal("show");
    },
    saveFarm: function saveFarm() {
      if (this.farm.id) {
        this.saveEditFarm();
      } else {
        this.addFarm();
      }
    },
    addFarm: function addFarm() {
      var _this3 = this;

      api.addFarm(this.farm).then(function (data) {
        _this3.showAlert({
          type: "success",
          text: "Successfully created " + _this3.farm.name + "!"
        });

        _this3.clearAddFarmModal();
        _this3.updateList();
      }, function (response) {
        _this3.errors = response.data.errors;
      });
    },
    saveEditFarm: function saveEditFarm() {
      var _this4 = this;

      api.editFarm(this.farm).then(function (data) {
        _this4.showAlert({
          type: "success",
          text: "Successfully updated " + _this4.farm.name + "!"
        });

        _this4.clearAddFarmModal();
        _this4.updateList();
      }, function (response) {
        _this4.errors = response.data.errors;
      });
    },
    downloadFarms: function downloadFarms() {
      this.showAlert({
        type: "warning",
        text: "This feature is under construction."
      });
    },
    editFarmModal: function editFarmModal(farm) {
      this.farm = farm;
      $("#add-farm-modal").modal("show");
    },
    deleteFarmModal: function deleteFarmModal(farm) {
      this.farm = farm;
      $("#delete-farm-modal").modal("show");
    },
    deleteFarm: function deleteFarm() {
      var _this5 = this;

      api.deleteFarm(this.farm).then(function (data) {
        _this5.showAlert({
          type: "success",
          text: "Successfully deleted " + _this5.farm.name + "!"
        });

        $("#delete-farm-modal").modal("hide");
        _this5.clearAddFarmModal();
        _this5.updateList();
      }, function (response) {
        _this5.showAlert({
          type: "error",
          text: response.data.message
        });
        $("#delete-farm-modal").modal("hide");
        _this5.clearAddFarmModal();
      });
    },
    redirectToUsers: function redirectToUsers() {
      this.$router.go({ path: "/sub-users" });
    }
  },
  ready: function ready() {
    this.updateList();
    this.initializeDisplayItems();

    var self = this;
    $("#add-farm-modal").on("hidden.bs.modal", function () {
      self.farm = {
        name: "",
        location: "",
        description: ""
      };
    });
  },

  mixins: [App.Mixins.Auth, App.Mixins.Generic, App.Mixins.Filterable, App.Mixins.Alerts]
});

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/defineProperty":36}],761:[function(require,module,exports){
"use strict";

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.FeatureFeedback = {
  template: "#feature-feedback-template",
  data: function data() {
    return {
      feature: {},
      feedback: {
        rating: 0,
        feedback: ""
      },
      starHovered: 0,
      isRetry: false,
      loading: false
    };
  },
  computed: {
    checkLater: function checkLater() {
      var checkLater = localStorage.getItem("feedbackLater");
      return checkLater ? JSON.parse(checkLater) : { id: 0, date: moment() };
    }
  },
  methods: {
    checkFeedback: function checkFeedback() {
      var _this = this;

      api.checkFeatures().then(function (data) {
        if (data.feature) {
          _this.feature = data.feature;

          if (_this.feature.id != _this.checkLater.id) {
            $("#feature-feedback").modal({
              backdrop: "static",
              keyboard: false
            });
          } else {
            _this.checkFeedbackLater();
          }
        } else {
          _this.feature = {};
        }
      });
    },
    checkFeedbackLater: function checkFeedbackLater() {
      var today = moment();

      if (today.diff(this.checkLater.date, "days") >= 2) {
        this.feature = this.checkLater;
        this.isRetry = true;
        $("#feature-feedback").modal({
          backdrop: "static",
          keyboard: false
        });
      }
    },
    saveFeedback: function saveFeedback() {
      var _this2 = this;

      this.loading = true;
      var data = (0, _extends3.default)({ id: this.feature.id }, this.feedback);
      api.storeFeatureFeedbacks(data).then(function (data) {
        localStorage.removeItem("feedbackLater");
        $("#feature-feedback").modal("hide");
        _this2.loading = false;
      });
    },
    skipFeedback: function skipFeedback() {
      var _this3 = this;

      this.loading = true;
      var data = { id: this.feature.id, rating: 99, feedback: null };
      api.storeFeatureFeedbacks(data).then(function (data) {
        localStorage.removeItem("feedbackLater");
        $("#feature-feedback").modal("hide");
        _this3.loading = false;
      });
    },
    askMeLater: function askMeLater() {
      var data = (0, _extends3.default)({}, this.feature, { date: moment() });
      localStorage.setItem("feedbackLater", (0, _stringify2.default)(data));
      $("#feature-feedback").modal("hide");
    }
  },
  ready: function ready() {
    this.checkFeedback();
  }
};

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/helpers/extends":37}],762:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Feature = {
  template: "#feature-template",
  data: function data() {
    return {
      feature: _.extend({}, App.emptyFeature),
      user: {},
      errors: {},
      loading: false,
      usersLoading: false,
      users: [],
      plans: [],
      roles: [],
      featureFeedbacks: [],
      potentialUsersFromSegments: 0,
      featureUsers: [],
      query: "",
      page: 1,
      totalPages: 1,
      totalCount: 0,
      description: {},
      featureUsersLoading: false,
      featureFeedbacksLoading: false,
      currentTab: "feature"
    };
  },
  props: [],
  computed: {
    selectedPercentage: function selectedPercentage() {
      var percentage = parseInt(this.feature.active_users_count) / parseInt(this.feature.selected_users_count);
      percentage = percentage * 100;

      return percentage.toLocaleString();
    },
    allActivePercentage: function allActivePercentage() {
      var percentage = parseInt(this.feature.active_users_count) / parseInt(this.users.length);
      percentage = percentage * 100;

      return percentage.toLocaleString();
    },
    pages: function pages() {
      // set a minimum of 1 page
      var maxPages = this.totalPages > 0 ? this.totalPages : 1;
      var pages = [];
      while (maxPages > 0) {
        var page = {
          title: maxPages,
          isActive: this.page == maxPages
        };
        pages.push(page);

        maxPages--;
      }

      return pages.reverse();
    },

    order: function order() {
      return this.currentSort + "|" + this.currentOrder;
    },
    segments: function segments() {
      var segments = [{
        name: "ALL USERS",
        value: "all_users"
      }];
      var data = {
        plan: this.plans,
        role: this.roles
      };

      (0, _keys2.default)(data).forEach(function (key) {
        var identifier = key == "plan" ? "name" : "display_name";

        data[key].forEach(function (item) {
          segments.push({
            name: (key + " - " + item[identifier]).toUpperCase(),
            value: key + "_" + item[identifier]
          });
        });
      });

      segments = _.uniq(segments, function (item, key, a) {
        return item.value;
      });

      return segments;
    },
    potentialUsersCount: function potentialUsersCount() {
      var segments_count = this.potentialUsersFromSegments || 0;
      var users = this.feature.users || [];
      var users_count = users.length;

      return segments_count + users_count;
    }
  },
  components: {},
  events: {},
  watch: {
    query: function query(newData) {
      this.page = 1;
      this.fetchByTab();
    },
    order: function order(newData) {
      this.fetchByTab();
    },

    feature: {
      handler: function handler(newData, oldData) {
        if (newData.segments && newData.segments.length) {
          this.countSegments(newData.segments);
        } else {
          this.potentialUsersFromSegments = 0;
        }
      },

      deep: true
    }
  },
  methods: {
    fetchByTab: function fetchByTab() {
      this.totalPages = 0;
      this.totalCount = 0;
      this.description = {
        from: 0,
        to: 0,
        total: 0
      };

      if (this.currentTab == "users") {
        this.fetchFeatureUsers();
      } else if (this.currentTab == "feedbacks") {
        this.fetchFeatureFeedbacks();
      }
    },
    fetchFeature: function fetchFeature() {
      var _this = this;

      this.loading = true;
      var params = {
        id: this.$route.params.id
      };

      api.getFeature(params).then(function (data) {
        _this.feature = (0, _extends3.default)({}, data);
        _this.loading = false;

        _this.$nextTick(function () {
          $("#opt-in-message").Editor("setText", data.opt_in_message);
        });
      }, function (error) {
        _this.loading = false;
      });
    },
    fetchFeatureFeedbacks: function fetchFeatureFeedbacks() {
      var _this2 = this;

      this.featureFeedbacksLoading = true;
      this.featureFeedbacks = [];

      var sort = this.currentSort;
      if (!["created_at", "feedback", "rating", "breeders_count", "user.id", "user.name"].includes(this.currentSort)) {
        sort = "created_at";
      }

      var params = {
        id: this.feature.id,
        perPage: 10,
        page: this.page,
        sort: sort,
        order: this.currentOrder,
        query: this.query
      };

      api.getFeatureFeedbacks(params).then(function (data) {
        _this2.featureFeedbacksLoading = false;
        _this2.featureFeedbacks = data.feedbacks.data;
        _this2.totalPages = data.feedbacks.last_page;
        _this2.totalCount = data.feedbacks.total;
        _this2.description = {
          from: data.feedbacks.from,
          to: data.feedbacks.to,
          total: data.feedbacks.total
        };
      }, function (error) {
        _this2.featureFeedbacksLoading = false;
      });
    },
    fetchFeatureUsers: function fetchFeatureUsers() {
      var _this3 = this;

      this.featureUsersLoading = true;
      this.featureUsers = [];

      var sort = this.currentSort;
      if (!["id", "name", "email", "plans.max_breeders", "created_at", "breeders_count", "featurables.origin", "featurables.opt_in_date"].includes(this.currentSort)) {
        sort = "featurables.opt_in_date";
      }

      var params = {
        id: this.feature.id,
        forFeatureUsers: 1,
        perPage: 10,
        page: this.page,
        sort: sort,
        order: this.currentOrder,
        query: this.query
      };

      api.fetchFeatureUsers(params).then(function (data) {
        _this3.featureUsersLoading = false;
        _this3.featureUsers = data.users.data;
        _this3.totalPages = data.users.last_page;
        _this3.totalCount = data.users.total;
        _this3.description = {
          from: data.users.from,
          to: data.users.to,
          total: data.users.total
        };
      }, function (error) {
        _this3.featureUsersLoading = false;
      });
    },
    updateFeature: function updateFeature(params) {
      var _this4 = this;

      var isTagUsers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.loading = true;

      if (!isTagUsers) {
        params.segments = null;
        params.users = null;
        params.release_percentage = null;
      }

      if (params.opt_in_required) {
        params.opt_in_message = $("#opt-in-message").Editor("getText");
      }

      params.selected_users = null;
      params.active_users = null;

      api.updateFeature(params).then(function (data) {
        _this4.loading = false;
        _this4.fetchFeature();

        $("#success-modal").modal("show");
      }, function (error) {
        _this4.loading = false;
        _this4.errors = error.data.errors;
      });
    },
    showRemoveModal: function showRemoveModal(user) {
      this.user = (0, _extends3.default)({}, user);
      $("#remove-modal").modal("show");
    },
    removeUser: function removeUser() {
      var _this5 = this;

      var params = {
        id: this.feature.id,
        users: [this.user.id]
      };

      api.removeFeatureUsers(params).then(function (data) {
        $("#remove-modal").modal("hide");
        _this5.fetchFeature();
      }, function (error) {
        $("#remove-modal").modal("hide");
      });
    },
    moveToUsersTab: function moveToUsersTab() {
      $("#users-tab").click();
      window.scrollTo(0, 0);
    },
    countSegments: function countSegments() {
      var _this6 = this;

      var segments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var params = { for_segments: 1, segments: segments };
      api.getUsers(params).then(function (data) {
        _this6.potentialUsersFromSegments = data.count;
      });
    },
    initializeSegments: function initializeSegments() {
      var _this7 = this;

      api.getRolesList().then(function (data) {
        _this7.roles = data;
      });
      api.getSubscriptionPlans().then(function (data) {
        _this7.plans = data;
      });
    },
    initializeUsers: function initializeUsers() {
      var _this8 = this;

      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.usersLoading = true;
      api.getUsers({ for_features: 1, query: query }).then(function (data) {
        _this8.users = data;
        _this8.usersLoading = false;
      });
    },

    /**
     * FOR FEATURE USERS
     */
    updatePage: function updatePage(page) {
      // NOTE: catch frontend bug where disabled link still triggers
      if (page == this.page || page <= 0 || page > this.totalPages) {
        return true;
      }

      this.page = page; // set new page
      this.fetchByTab(); // refetch features data from api
    },
    getAverageRatingClass: function getAverageRatingClass() {
      var value = parseFloat(this.feature.average_rating || 0);
      var className = "color-hutch";

      if (value < 2) {
        className = "text-danger";
      } else if (value < 3) {
        className = "text-warning";
      }

      return className;
    },
    initTabs: function initTabs() {
      var self = this;
      $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        var target = $(e.target).attr("href");
        target = target.replace("#", "");

        self.currentTab = target;
        self.fetchByTab();
      });
    }
  },
  ready: function ready() {
    this.initTabs();
    this.fetchFeature();
    this.initializeSegments();
    this.initializeUsers();

    //set default sorting
    this.currentSort = "featurables.opt_in_date";

    this.$nextTick(function () {
      $("#opt-in-message").Editor();
    });
  },
  mixins: [App.Mixins.Filterable]
};

},{"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37}],763:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.emptyFeature = {
  id: 0,
  title: "",
  key: "",
  description: "",
  active_at: null,
  launched_at: null,
  opt_in_required: false,
  opt_in_message: "",
  status: "active"
};

App.Components.Features = {
  template: "#features-template",
  data: function data() {
    return {
      feature: _.extend({}, App.emptyFeature),
      features: [],
      errors: {},
      loading: false,
      currentSort: "created_at",
      currentOrder: "desc",
      query: "",
      isArchived: false,
      page: 1,
      totalPages: 1,
      totalCount: 0,
      description: {},
      usersLoading: false,
      users: [],
      plans: [],
      roles: [],
      potentialUsersFromSegments: 0
    };
  },
  props: [],
  computed: {
    //set pages as object
    pages: function pages() {
      // set a minimum of 1 page
      var maxPages = this.totalPages > 0 ? this.totalPages : 1;
      var pages = [];
      while (maxPages > 0) {
        var page = {
          title: maxPages,
          isActive: this.page == maxPages
        };
        pages.push(page);

        maxPages--;
      }

      return pages.reverse();
    },
    segments: function segments() {
      var segments = [];
      var data = {
        plan: this.plans,
        role: this.roles
      };

      (0, _keys2.default)(data).forEach(function (key) {
        var identifier = key == "plan" ? "name" : "display_name";

        data[key].forEach(function (item) {
          segments.push({
            name: (key + " - " + item[identifier]).toUpperCase(),
            value: key + "_" + item[identifier]
          });
        });
      });

      segments = _.uniq(segments, function (item, key, a) {
        return item.value;
      });

      return segments;
    },
    potentialUsersCount: function potentialUsersCount() {
      var segments_count = this.potentialUsersFromSegments || 0;
      var users = this.feature.users || [];
      var users_count = users.length;

      return segments_count + users_count;
    }
  },
  components: {},
  events: {},
  watch: {
    query: function query(newData) {
      this.page = 1;
      this.fetchFeatures();
    },

    // refetch data from api on sort change
    order: function order(newData) {
      this.fetchFeatures();
    },
    isArchived: function isArchived(newData) {
      this.fetchFeatures();
    }
  },
  methods: {
    fetchFeatures: function fetchFeatures() {
      var _this = this;

      this.loading = true;
      var params = {
        page: this.page,
        sort: this.currentSort,
        order: this.currentOrder,
        archived: this.isArchived,
        query: this.query
      };

      api.getFeatures(params).then(function (data) {
        _this.features = data.features.data;
        _this.totalPages = data.features.last_page;
        _this.totalCount = data.features.total;
        _this.description = {
          from: data.features.from,
          to: data.features.to,
          total: data.features.total
        };
        _this.loading = false;

        _this.$nextTick(function () {
          _this.initializeToggles();
        });
      });
    },
    createFeature: function createFeature() {
      var _this2 = this;

      this.loading = true;
      var params = this.feature;

      api.storeFeature(params).then(function (data) {
        _this2.loading = false;
        _this2.fetchFeatures();
        _this2.closeModalHandler();
      }, function (error) {
        _this2.loading = false;
        _this2.errors = error.data.errors;
      });
    },
    updateFeature: function updateFeature(params) {
      var _this3 = this;

      this.loading = true;

      api.updateFeature(params).then(function (data) {
        _this3.loading = false;
        _this3.fetchFeatures();
        _this3.closeModalHandler();
      }, function (error) {
        _this3.loading = false;
        _this3.errors = error.data.errors;
      });
    },
    toggleFeatureStatus: function toggleFeatureStatus() {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "inactive";

      var params = this.feature;
      params.status = status;
      params.active_at = null;

      this.updateFeature(params);
    },
    showArchiveModal: function showArchiveModal(feature) {
      this.feature = feature;
      $("#archive-feature").modal("show");
    },
    showUnarchiveModal: function showUnarchiveModal(feature) {
      this.feature = feature;
      $("#unarchive-feature").modal("show");
    },
    showDefineModal: function showDefineModal() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "create";
      var feature = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.feature = _.extend({}, App.emptyFeature);
      $("#define-feature").modal("show");
    },
    countSegments: function countSegments() {
      var _this4 = this;

      var segments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var params = { for_segments: 1, segments: segments };
      api.getUsers(params).then(function (data) {
        _this4.potentialUsersFromSegments = data.count;
      });
    },
    closeModalHandler: function closeModalHandler() {
      this.errors = {};
      $("#define-feature").modal("hide");
    },
    updatePage: function updatePage(page) {
      // NOTE: catch frontend bug where disabled link still triggers
      if (page == this.page || page <= 0 || page > this.totalPages) {
        return true;
      }

      this.page = page; // set new page
      this.fetchFeatures(); // refetch features data from api
    },
    toggleArchivedFilter: function toggleArchivedFilter(status) {
      this.isArchived = !status;
      $("#status-toggle").netlivaSwitch("state", status);
    },
    initializeToggles: function initializeToggles() {
      var _this5 = this;

      this.features.forEach(function (feature) {
        $("#" + feature.key + "-status-toggle").netlivaSwitch();
        $("#" + feature.key + "-status-toggle").on("netlivaSwitch.change", function (event, state, element) {
          var params = feature;
          if (state) {
            params.active_at = moment().format("YYYY-MM-DD HH:mm:ss");
          } else {
            params.active_at = null;
          }

          _this5.updateFeature(params);
        });
        $("#" + feature.key + "-status-toggle").netlivaSwitch("state", !!feature.active_at);
      });
    }
  },
  ready: function ready() {
    var _this6 = this;

    this.fetchFeatures();

    // initialize status toggle
    $("#status-toggle").netlivaSwitch();
    $("#status-toggle").on("netlivaSwitch.change", function (event, state, element) {
      _this6.isArchived = !state;
    });
    $("#status-toggle").netlivaSwitch("state", true);

    // set modal close
    $("#define-feature").on("hidden.bs.modal", function () {
      _this6.closeModalHandler();
    });
  }
};

},{"babel-runtime/core-js/object/keys":27}],764:[function(require,module,exports){
"use strict";

/**
 * Contact form component.
 */
App.Components.ContactForm = {
  template: "#contact-form-template",
  data: function data() {
    return {
      countries: [],
      states: [],
      errors: {},
      contactFormModal: {},
      loading: 0
    };
  },

  props: ["contact", "contacts"],
  computed: {},
  watch: {
    contact: {
      // check for changes on contact data
      handler: function handler(newData) {
        /**
         * set states data depending on selected country
         */
        if (newData.country) {
          var country = _.find(this.countries, function (country) {
            return country.name == newData.country;
          });

          this.states = country ? country.states : [];
        } else {
          this.states = [];
        }
      },

      deep: true // for nested objects
    }
  },
  methods: {
    /**
     * Handle modal close
     */
    closeModalHandler: function closeModalHandler() {
      this.errors = {};
      this.contactFormModal.modal("hide");
    },

    /**
     * Store new contact
     *
     * @param {*} contact
     */
    storeContact: function storeContact(contact) {
      var _this = this;

      this.loading = 1;

      api.storeContact(this.contact).then(function (data) {
        _this.loading = 0;
        _this.$dispatch("refreshContacts", "add");
        _this.closeModalHandler();
      }, function (error) {
        _this.loading = 0;
        _this.errors = error.data.errors;
      });
    },

    /**
     * Update existing contact
     *
     * @param {*} contact
     */
    updateContact: function updateContact(contact) {
      var _this2 = this;

      this.loading = 1;

      api.updateContact(this.contact).then(function (data) {
        _this2.loading = 0;
        _this2.$dispatch("refreshContacts", "update");
        _this2.closeModalHandler();
      }, function (error) {
        _this2.loading = 0;
        _this2.errors = error.data.errors;
      });
    },

    /**
     * Fetch list of countries
     */
    fetchCountries: function fetchCountries() {
      var _this3 = this;

      this.loading = 1;

      api.fetchCountries().then(function (data) {
        _this3.loading = 0;
        _this3.countries = data;
      });
    }
  },
  ready: function ready() {
    // initialize modal
    this.contactFormModal = $("#contact-form-modal");
    this.fetchCountries(); // fetch countries on mount

    // initialize phone input
    $("#phone").keypress(function (e) {
      var keyCode = e.which;

      // allow numbers, periods, parentheses, plus signs, and spaces
      if ((keyCode != 8 || keyCode == 32) && (keyCode < 48 || keyCode > 57) && keyCode != 43 && keyCode != 40 && keyCode != 41 && keyCode != 32 && keyCode != 190 && keyCode != 46) {
        return false;
      }
    });
  }
};

},{}],765:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Empty contact template.
 */
App.emptyContact = {
  id: 0,
  name: "",
  company_name: "",
  address: "",
  city: "",
  state: "",
  country: "",
  zip_code: "",
  phone: "",
  email: "",
  notes: "",
  type: "lead"
};

/**
 * Contacts list component.
 */
App.Components.Contacts = {
  template: "#contacts-template",
  data: function data() {
    return {
      contact: _.extend({}, App.emptyContact),
      contacts: [],
      btn_name: [],
      page: 1,
      totalPages: 1,
      totalCount: 0,
      description: {},
      contactFormModal: {},
      deleteContactModal: {},
      archiveContactModal: {},
      unarchiveContactModal: {},
      currentSort: "created_at",
      currentOrder: "desc",
      query: "",
      loading: false,
      preFilters: {
        is_archived: 0
      },
      perPage: 10,
      pagination: {
        from: 0,
        to: 0,
        total: 0
      },
      paginationLinks: []
    };
  },

  components: {
    "contact-form": App.Components.ContactForm // import contact form component
  },
  computed: {
    // set target name
    confirmTarget: function confirmTarget() {
      return this.contact.name || "this contact";
    },

    // check if route is archived
    isArchived: function isArchived() {
      return this.$route.params.status == "archive";
    },

    order: function order() {
      return this.currentSort + "|" + this.currentOrder;
    }
  },
  watch: {
    // check for route change
    $route: function $route(from, to) {
      this.fetchContacts();
    },
    query: function query(newData) {
      this.page = 1;
      this.fetchContacts();
    },

    // refetch data from api on sort change
    order: function order(newData) {
      this.fetchContacts();
    }
  },
  methods: {
    getCurrentData: function getCurrentData() {
      var btn_name = localStorage.getItem("help_section");
      this.btn_name = JSON.parse(btn_name);
    },
    pageFromUrl: function pageFromUrl(sPageURL) {
      var sParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'page';

      var sURLVariables = sPageURL.substring(sPageURL.indexOf('?') + 1).split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        console.log(sParameterName);

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? 1 : decodeURIComponent(sParameterName[1]);
        }
      }
      return 1;
    },
    applyStatusFilters: function applyStatusFilters() {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.page = 1;
      this.preFilters.is_archived = status;

      this.fetchContacts();
    },
    updatePerPage: function updatePerPage() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

      this.page = 1;
      this.perPage = value;

      this.fetchContacts();
    },

    /**
     * Fetch all contacts form api
     */
    fetchContacts: function fetchContacts() {
      var _this = this;

      // set loading and empty contacts
      this.loading = true;
      this.contacts = [];

      var params = {
        perPage: this.perPage,
        page: this.page,
        sort: this.currentSort,
        order: this.currentOrder,
        archived: this.preFilters.is_archived,
        query: this.query
      };

      api.getContacts(params).then(function (data) {
        _this.contacts = data.contacts.data;
        _this.totalPages = data.contacts.last_page;
        _this.totalCount = data.contacts.total;
        _this.paginationLinks = data.contacts.links;
        _this.pagination = {
          from: data.contacts.from,
          to: data.contacts.to,
          total: data.contacts.total
        };
        _this.loading = false;
      });
    },

    /**
     * Show add new contact modal
     */
    showNewContactModal: function showNewContactModal() {
      this.contact = _.extend({}, App.emptyContact);
      this.contactFormModal.modal({
        backdrop: "static",
        keyboard: false
      });
      this.contactFormModal.modal("show");
    },

    /**
     * Show edit contact modal
     */
    showEditContactModal: function showEditContactModal(contact) {
      this.contact = _.extend({}, contact);
      this.contactFormModal.modal({
        backdrop: "static",
        keyboard: false
      });
      this.contactFormModal.modal("show");
    },

    /**
     * Show delete contact modal
     */
    showDeleteContactModal: function showDeleteContactModal(contact) {
      this.contact = _.extend({}, contact);
      this.deleteContactModal.modal("show");
    },

    /**
     * Delete contact data
     */
    deleteContact: function deleteContact() {
      var _this2 = this;

      api.deleteContact(this.contact).then(function (data) {
        _this2.deleteContactModal.modal("hide");
        _this2.fetchContacts();
      });
    },

    /**
     * Show archive contact modal
     */
    showArchiveContactModal: function showArchiveContactModal(contact) {
      this.contact = _.extend({}, contact);
      this.archiveContactModal.modal("show");
    },

    /**
     * Archive contact data
     */
    archiveContact: function archiveContact() {
      var _this3 = this;

      api.updateContact((0, _extends3.default)({}, this.contact, { archived: true })).then(function (data) {
        _this3.archiveContactModal.modal("hide");
        _this3.fetchContacts();
      });
    },

    /**
     * Show unarchive contact modal
     */
    showUnarchiveContactModal: function showUnarchiveContactModal(contact) {
      this.contact = _.extend({}, contact);
      this.unarchiveContactModal.modal("show");
    },

    /**
     * Unarchive contact data
     */
    unarchiveContact: function unarchiveContact() {
      var _this4 = this;

      api.updateContact((0, _extends3.default)({}, this.contact, { archived: false })).then(function (data) {
        _this4.unarchiveContactModal.modal("hide");
        _this4.fetchContacts();
      });
    },

    /**
     * Update page data
     *
     * @param {string} page
     */
    updatePage: function updatePage(page) {
      // NOTE: catch frontend bug where disabled link still triggers
      if (page == this.page || page <= 0 || page > this.totalPages) {
        return true;
      }

      // set new page
      this.page = page;
      // refetch contacts data from api
      this.fetchContacts();
    }
  },
  events: {
    /**
     * Refresh contacts data
     */
    refreshContacts: function refreshContacts() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "add";

      // refresh filters if adding a new contact
      if (type == "add") {
        this.page = 1;
        this.currentSort = "created_at";
        this.currentOrder = "desc";
        this.query = "";
      }

      // refetch contacts data from api
      this.fetchContacts();
    }
  },
  ready: function ready() {
    // initialize modals
    this.contactFormModal = $("#contact-form-modal");
    this.deleteContactModal = $("#delete-contact-modal");
    this.archiveContactModal = $("#archive-contact-modal");
    this.unarchiveContactModal = $("#unarchive-contact-modal");

    // Update list.
    this.fetchContacts();

    // Check if add new link is clicked
    if (this.$route.query.addNewContact) {
      this.showNewContactModal();
    }

    this.getCurrentData();
  },

  mixins: [App.Mixins.Filterable]
};

},{"babel-runtime/helpers/extends":37}],766:[function(require,module,exports){
"use strict";

if (!("Generic" in App.Components)) {
  App.Components.Generic = {};
}

App.Components.Generic.Menu = Vue.extend({
  template: "#menu-template",
  data: function data() {
    return {
      /**
       * Menu Data:
       * {
       *    title: 'Title', // menu title | string
       *    icon: "fa-dollar", // font-awesome icon | string
       *    event: "openModal", // method to be dispatched | string
       *    data: {}, // data to be passed as a parameter to the method | mixed
       *    show: true, // show or hide menu | boolean
       * }
       */
      menuList: []
    };
  },

  props: ["icon", "icon-only"],
  computed: {
    filteredMenuList: function filteredMenuList() {
      return _.filter(this.menuList, function (item) {
        return item.show;
      });
    }
  },
  events: {},
  watch: {},
  methods: {
    dispatchEvent: function dispatchEvent(eventName, data) {
      this.$dispatch("menuClicked", eventName, data);
    }
  },
  ready: function ready() {}
});

},{}],767:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.GlobalForms = {
  template: "#global-forms-template",
  data: function data() {
    var _ref;

    return _ref = {
      activeTask: {},
      activeTasks: [],
      litter: {},
      litters: [],
      activeBirth: {},
      plans: [],
      breeder: _.extend({}, App.emptyBreeder),
      breeders: []
    }, (0, _defineProperty3.default)(_ref, "litter", _.extend({}, App.emptyLitter)), (0, _defineProperty3.default)(_ref, "litters", []), (0, _defineProperty3.default)(_ref, "farms", []), (0, _defineProperty3.default)(_ref, "activeFarm", []), _ref;
  },
  computed: {
    isGlobal: function isGlobal() {
      return true;
    }
  },
  components: {
    "litter-weight": App.Components.LitterWeight,
    "litter-butcher": App.Components.LitterButcher,
    "birth-form": App.Components.BirthForm,
    "task-form": App.Components.TaskForm,
    "breed-form": App.Components.BreedForm,
    "breeder-form": App.Components.BreederForm,
    "kit-form": App.Components.KitForm,
    "litter-form": App.Components.LitterForm,
    "ledger-form": App.Components.LedgerForm,
    "breeder-categories": App.Components.BreederCategories,
    "farm-switch": App.Components.FarmSwitch
  },
  methods: {},
  ready: function ready() {
    var _this = this;

    this.$root.$on("open-global-task-form", function (task) {
      _this.activeTask = task;
      _this.$broadcast("tasks-managing", task);
    });
    this.$root.$on("open-global-litter-weight", function (task) {
      _this.litter = task.litters.length ? task.litters[0] : {};
      _this.litters = task.litters;
      $("#global-litter-weight-modal").modal("show");
    });
    this.$root.$on("open-global-litter-butcher", function (task) {
      _this.litter = task.litters.length ? task.litters[0] : {};
      _this.litters = task.litters;
      $("#global-litter-butcher-modal").modal("show");
    });
    this.$root.$on("open-global-birth-form", function (task) {
      _this.activeTask = task;
      _this.$broadcast("new-birth-modal-open", task.isShowMissed);
      api.getUsersPlans().then(function (plans) {
        _this.plans = plans;
        _this.activeBirth = {
          breedplan: task.breed_id || "-1",
          born: moment(new Date()).format(App.dateFormat)
        };

        $("#global-birth-form-modal.modal").modal("show");
      });
    });
    this.$root.$on("open-global-breed-form-doe", function (doeId) {
      _this.$broadcast("new-breed-with-doe", doeId);
    });
    this.$root.$on("open-global-new-breeder-form", function () {
      _this.breeder = _.extend({}, App.emptyBreeder);
      _this.$broadcast("global-breeder-add-new");
    });
    this.$root.$on("open-global-edit-breeder-form", function (breeder) {
      _this.breeder = (0, _extends3.default)({}, breeder);
      _this.$broadcast("global-breeder-edit");
    });
    this.$root.$on("open-global-new-litter-form", function () {
      _this.litter = _.extend({}, App.emptyLitter);
      $("#global-litter-form").modal("show");
    });
    this.$root.$on("open-global-categories-form", function () {
      $("#global-breeder-categories-modal").modal("show");
    });
    this.$root.$on("open-global-breed-form", function () {
      _this.$broadcast("global-new-breed", true);
    });
    this.$root.$on("open-global-breed-form-existing", function (task) {
      api.getPlan(task.breed_id).then(function (plan) {
        _this.$broadcast("open-edit-breed-form", plan);
      }, function (reponse) {
        _this.showAlert({
          type: "warning",
          text: "The attached breed plan for " + task.name + " does not exist."
        });
      });
    });
    this.$root.$on("open-global-ledger-form", function () {
      _this.$broadcast("add-global-ledger");
    });
    this.$root.$on("open-global-pregnancy-check-form", function (task) {
      _this.activeTask = task;
      _this.activeBirth = {
        breedplan: task.breed_id || "-1",
        born: moment(new Date()).format(App.dateFormat)
      };
      _this.$broadcast("new-pregnancy-check");
      api.getUsersPlans().then(function (plans) {
        _this.plans = plans;
        $("#global-pregnancy-check-modal").modal("show");
      });
    });
    this.$root.$on("open-switch-farm-modal", function (data) {
      _this.activeFarm = data.activeFarm;
      _this.farms = data.farms;
      $("#change-farm-modal").modal("show");
    });

    this.$root.$on("global-predict-form-modal", function (data) {
      _this.$broadcast("globle-genetic-prediction-form");
    });

    this.$root.$on("global-line-breeding-form-modal", function (data) {
      console.log("global-form.js");
      _this.$broadcast("global-line-breeding-form");
    });
  }
};

},{"babel-runtime/helpers/defineProperty":36,"babel-runtime/helpers/extends":37}],768:[function(require,module,exports){
"use strict";

Vue.component("header-breadcrumbs", {
  template: "\n    <li>\n        <span class=\"breadcrumbs\">\n            <a href=\"/#!\">Home</a> / <a href=\"/#!{{ uri }}\">{{ text }}</a>\n        </span>\n    </li>\n  ",
  data: function data() {
    return {
      uri: "",
      text: ""
    };
  },

  watch: {
    $route: function $route() {
      this.uri = this.$route.path;
      this.text = this.$route.name || "Component";
    }
  },
  methods: {
    /* getHelpButtons:function(){
      api.getCurrentUserSettingsData().then(data => {
        localStorage.setItem("help_section", JSON.stringify(data.help_section));
      });
    } */
  },
  ready: function ready() {
    this.uri = this.$route.path;
    this.text = this.$route.name || "Component";
    //this.getHelpButtons();
  }
});

},{}],769:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.HealthRecordForm = App.Components.TreatmentForm.extend({
  template: "#health-record-form-template",
  watch: {
    activeAilment: function activeAilment(newData) {
      // set pre-selected ailment
      if (newData && newData.id) {
        this.$set("activeTreatment.ailment_id", newData.id);

        if (newData.breeder && newData.breeder.id) {
          this.toggleLayout(false);
          this.$set("activeTreatment.breeder_id", newData.breeder.id);
        }

        if (newData.kit && newData.kit.id) {
          this.toggleLayout(true);
          this.selectedLitter = newData.kit.litter_id;
          this.$set("activeTreatment.kit_id", newData.kit.id);
        }
      }
    },
    activeExistingTreatment: function activeExistingTreatment(newData) {
      if (newData) {
        var treatment = _.find(this.treatmentChains, function (chain) {
          return chain.id == newData;
        });

        if (treatment) {
          var treatmentData = treatment.data || {};
          this.activeTreatment = (0, _extends3.default)({}, this.activeTreatment, treatmentData);
        }
      }
    },
    selectedLitter: function selectedLitter(newData, oldData) {
      if (newData) {
        this.fetchLitterKits();

        if (oldData && newData != oldData) {
          this.activeTreatment.kit_id = null;
        }
      } else {
        this.kits = [];
      }
    },
    isKit: function isKit(newData) {
      this.ailments = [];

      if (!newData && this.activeTreatment.breeder_id) {
        this.fetchAilmentsFromBreeder(this.activeTreatment.breeder_id);
      }

      if (newData && this.activeTreatment.kit_id) {
        this.fetchLitterKits();
      }
    }
  },
  methods: {
    fetchAilments: function fetchAilments() {
      var _this = this;

      api.getLitterKits(this.selectedLitter).then(function (kits) {
        _this.kits = kits;

        if (_this.activeTreatment.kit_id) {
          _this.fetchAilmentsFromKit(_this.activeTreatment.kit_id);
        }
      });
    },
    initTypeahead: function initTypeahead() {
      var self = this;
      var ailments = this.ailmentsList.map(function (item) {
        return item.name;
      });
      var treatments = this.treatmentsList;

      $("#health-record-ailment-name").typeahead({
        hint: true,
        highlight: true,
        minLength: 0
      }, {
        source: this.substringMatcher(ailments)
      }).bind("typeahead:selected", function (obj, selected) {
        var ailment = self.ailmentsList.find(function (item) {
          return item.name === selected;
        });

        self.activeAilment = $.extend((0, _extends3.default)({}, self.activeAilment), {
          symptom: ailment.symptoms.map(function (symptom) {
            return symptom.symptomRelated;
          }).join(", ")
        });
      });

      $("#health-record-treatment-name").typeahead({
        hint: true,
        highlight: true,
        minLength: 0
      }, {
        source: this.substringMatcher(treatments)
      });
    },
    fetchPreloadedAilments: function fetchPreloadedAilments() {
      var _this2 = this;

      api.fetchAilments({ all: true }).then(function (data) {
        _this2.ailmentsList = data.ailments;

        _this2.$nextTick(function () {
          _this2.initTypeahead();
        });
      });
    }
  },
  ready: function ready() {
    this.fetchPreloadedAilments();
  }
});

},{"babel-runtime/helpers/extends":37}],770:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.HealthRecordsList = App.Components.TreatmentsList.extend({
  template: "#health-records-list-template",
  events: {
    "reload-ailments": function reloadAilments() {
      this.loadAilments();
    }
  },
  watch: (_watch = {
    currentSort: function currentSort(newData) {
      this.loadAilments();
    },
    currentOrder: function currentOrder(newData) {
      this.loadAilments();
    },
    searchQuery: function searchQuery(newData, oldData) {
      this.page = 1;
      this.loadAilments();
    },
    perPage: function perPage(newData) {
      this.page = 1;
      localStorage.setItem("perPage", newData);
      this.loadAilments();
    },

    filters: {
      handler: function handler(newData) {
        this.page = 1;
        this.loadAilments();
      },

      deep: true
    }
  }, (0, _defineProperty3.default)(_watch, "currentSort", function currentSort(newData) {
    this.loadAilments();
  }), (0, _defineProperty3.default)(_watch, "currentOrder", function currentOrder(newData) {
    this.loadAilments();
  }), _watch),
  methods: {
    loadTreatments: function loadTreatments() {
      var _this = this;

      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var filter = { filters: (0, _extends3.default)({}, this.filters) };
      filter.query = this.searchQuery;
      filter.perPage = this.perPage;
      filter.page = this.page;
      filter.sort = this.currentSort;
      filter.order = this.currentOrder;

      if (this.isBreeder) {
        filter.breeder_id = this.breeder.id;
      }

      this.loading = 1;
      api.getTreatments(filter).then(function (data) {
        var treatments = data.treatments;
        _this.loading = 0;
        _this.treatments = treatments.data;
      });
    },
    loadAilments: function loadAilments() {
      var _this2 = this;

      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var filter = { filters: (0, _extends3.default)({}, this.filters) };
      filter.query = this.searchQuery;
      filter.perPage = this.perPage;
      filter.page = this.page;
      filter.sort = this.currentSort;
      filter.order = this.currentOrder;
      filter.isHealthRecord = true;

      if (this.isBreeder) {
        filter.breeder_id = this.breeder.id;
      }

      this.loading = 1;
      api.getAilments(filter).then(function (data) {
        var ailments = data.ailments;
        _this2.loading = 0;
        _this2.ailments = ailments.data;

        // For new version
        _this2.totalPages = ailments.last_page;
        _this2.totalCount = ailments.total;
        _this2.description = {
          from: ailments.from,
          to: ailments.to,
          total: ailments.total
        };
      });
    },
    openAddTreatmentModal: function openAddTreatmentModal(ailment) {
      this.activeAilment = ailment;
      this.$broadcast("add-new-treatment");
    },
    openEditAilmentModal: function openEditAilmentModal(ailment) {
      this.activeAilment = ailment;
      this.$broadcast("edit-ailment", ailment);
    },
    openDeleteAilmentModal: function openDeleteAilmentModal(ailment) {
      this.activeAilment = ailment;
      $("#delete-ailment").modal("show");
    },
    deleteAilment: function deleteAilment() {
      var _this3 = this;

      var ailment = this.activeAilment;
      if (ailment && ailment.id) {
        api.deleteAilment(ailment).then(function () {
          $("#delete-ailment").modal("hide");
          _this3.activeAilment = {};
          _this3.loadAilments();
        });
      }
    },
    ailmentContainerClicked: function ailmentContainerClicked(id, element) {
      var action = $(element).data("action") || "open";

      if (action == "close") {
        $(".treatments-container-" + id).hide();
        this.closeAilments(id);
      } else {
        $(".treatments-container-" + id).show();
        this.openAilments.push(id); // add to open ailments
      }
    },
    closeAilments: function closeAilments(id) {
      // remove from open ailments
      var key = this.openAilments.indexOf(id);
      if (key > -1) {
        this.openAilments.splice(key, 1);

        this.closeAilments(id); //recursive call to clear all keys (in case it's saved multiple times)
      }
    },
    isAilmentOpen: function isAilmentOpen(id) {
      var key = this.openAilments.indexOf(id);
      if (key > -1) {
        return true;
      } else {
        return false;
      }
    },
    getLatestTreatmentStatus: function getLatestTreatmentStatus(ailment) {
      if (!ailment.treatments.length) {
        return "None Assigned";
      }

      var status = ailment.treatments[ailment.treatments.length - 1].status;
      return status == "active" ? "Ongoing" : status;
    },
    getLatestTreatment: function getLatestTreatment(ailment) {
      var isLatest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (!ailment.treatments.length) {
        return { name: "—", start_date: "—" };
      }

      return ailment.treatments[isLatest ? ailment.treatments.length - 1 : 0];
    }
  },
  ready: function ready() {
    this.perPage = localStorage.getItem("perPage") || 10;
    this.loadAilments();
  },


  mixins: [App.Mixins.Generic]
});

},{"babel-runtime/helpers/defineProperty":36,"babel-runtime/helpers/extends":37}],771:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Health = Vue.extend({
  template: "#health-template",
  data: function data() {
    return {
      breeders: [],
      litters: [],
      perPage: 10,
      type: "ailment",
      displayItems: {
        name: true,
        breeder: true,
        start_date: true,
        symptom: true,
        notes: true,
        status: true,
        cured_date: true,
        cage_number: true,
        breed: true,
        breeder_id: true,
        withdrawal_end: true,
        ailment_name: true,
        medication: true,
        method: true,
        type: true
      },
      searchQuery: "",
      totalCount: 0,
      filters: {
        ailment_status: "",
        treatment_status: "",
        date_detected: {
          from: null,
          to: null
        }
      },
      preFilters: {
        ailment_status: "",
        treatment_status: "",
        date_detected: {
          from: null,
          to: null
        }
      },
      filterRanges: {
        date_detected: []
      },
      preFilterRanges: {
        date_detected: []
      },
      filterRules: {
        ailment_status: "string",
        treatment_status: "string",
        date_detected: "daterange"
      },
      currentSort: "date",
      currentOrder: "asc",
      btn_name: []
    };
  },

  props: ["breeder", "isBreeder"],
  computed: {
    typeLabel: function typeLabel() {
      if (this.type == "health-records") {
        return "Search health records";
      }

      return "Search ailments, symptoms, or treatments";
    }
  },
  components: {
    "ailments-list": App.Components.AilmentsList,
    "treatments-list": App.Components.TreatmentsList,
    "health-records-list": App.Components.HealthRecordsList
  },
  watch: {
    filters: {
      handler: function handler(newVal, oldVal) {
        this.saveFilters();
      },

      deep: true
    },
    type: function type(newData) {
      this.initializeDisplayItems();
    }
  },
  events: {
    "total-count-updated": function totalCountUpdated(data) {
      this.totalCount = data;
    }
  },
  methods: {
    getCurrentData: function getCurrentData() {
      var btn_name = localStorage.getItem("help_section");
      this.btn_name = JSON.parse(btn_name);
    },
    updatePerPage: function updatePerPage() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

      localStorage.setItem("perPage", value);
      this.perPage = value;
    },
    initializeBreeders: function initializeBreeders() {
      var _this = this;

      api.getBreedersList({ ailments: 1 }).then(function (breeders) {
        _this.breeders = breeders.bucks.concat(breeders.does);
      });
    },
    initializeLitters: function initializeLitters() {
      var _this2 = this;

      api.getLittersList({ archived: 0, butchered: 0 }).then(function (res) {
        _this2.litters = res;
      });
    },
    initializeDisplayItems: function initializeDisplayItems() {
      var _this3 = this;

      $(".display-settings").iCheck({
        checkboxClass: "icheckbox_square-green",
        radioClass: "iradio_square-green"
      }).on("ifChecked", function (event) {
        _this3.displayItems[event.target.name] = true;
        localStorage.setItem("healthDisplay", (0, _stringify2.default)(_this3.displayItems));
      }).on("ifUnchecked", function (event) {
        _this3.displayItems[event.target.name] = false;
        localStorage.setItem("healthDisplay", (0, _stringify2.default)(_this3.displayItems));
      });

      var healthDisplay = JSON.parse(localStorage.getItem("healthDisplay"));
      if (healthDisplay) {
        this.displayItems = healthDisplay;
      }
      this.perPage = parseInt(localStorage.getItem("perPage")) || 10;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.displayItems)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (this.displayItems[key]) {
            $("input[class='display-settings'][name='" + key + "']").iCheck("check");
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    initializeTabs: function initializeTabs() {
      var self = this;
      $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        var target = $(e.target).attr("href");
        target = target.replace("#", "");

        // set selected tab
        self.type = target;
      });
    },
    applyPreFilters: function applyPreFilters() {
      this.filters = (0, _extends3.default)({}, this.preFilters);
      this.filterRanges = (0, _extends3.default)({}, this.preFilterRanges);
    },
    resetPreFilters: function resetPreFilters() {
      this.preFilters = {
        ailment_status: "",
        treatment_status: "",
        date_detected: {
          from: null,
          to: null
        }
      };

      this.preFilterRanges = {
        date_detected: []
      };

      this.applyPreFilters();
    },
    removeFilter: function removeFilter() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var resetContent = "";

      if (type == "date_detected") {
        resetContent = {
          from: null,
          to: null
        };

        this.preFilterRanges[type] = resetContent;
      } else if (type) {
        this.preFilters[type] = "";
      }

      this.applyPreFilters();
    },
    saveFilters: function saveFilters() {
      localStorage.setItem("healthFilters_v3", (0, _stringify2.default)(this.filters));
    },
    getFilters: function getFilters() {
      return JSON.parse(localStorage.getItem("healthFilters_v3"));
    },
    addNew: function addNew() {
      this.$broadcast("add-new-" + this.type);
    },
    addHealthRecord: function addHealthRecord() {
      this.$broadcast("add-health-record");
    },
    exportHealth: function exportHealth() {
      this.showAlert({
        type: "success",
        text: "The export feature is still under construction."
      });
    }
  },
  ready: function ready() {
    var _this4 = this;

    this.getCurrentData();
    this.initializeTabs();
    this.initializeBreeders();
    this.initializeLitters();

    // initialize filters
    $("#ailment-date").trigger("triggerDaterangepicker");

    // tweak for dropdown
    $(document).on("click", ".dropdown-menu.main-filters", function (e) {
      if ($(e.target).data("dismiss") != "dropdown") {
        e.stopPropagation();
      }
    });

    $(".dropdown-filter").on("select2:unselect", function (e) {
      if (!e.params.originalEvent) {
        return;
      }
      e.params.originalEvent.stopPropagation();
    });

    this.$nextTick(function () {
      _this4.initializeDisplayItems();

      if (_this4.getFilters()) {
        _this4.filters = _this4.getFilters();
        _this4.preFilters = (0, _extends3.default)({}, _this4.filters);
      }
    });

    // listen for health tour
    _eventBus2.default.$on("start-health-tour", function () {
      _this4.startTour("health");
    });
  },

  mixins: [App.Mixins.Breeders, App.Mixins.Filterable, App.Mixins.Generic, App.Mixins.Tours, App.Mixins.Alerts]
});

},{"../event-bus":882,"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37}],772:[function(require,module,exports){
"use strict";

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.ImageUpload = Vue.extend({
    template: "#image-upload-template",
    data: function data() {
        return {
            progress: 0,
            loading: 0,
            plus_minus_rotate_num: 90,
            store_rotate_num: 0,
            storeinput: null,
            cropcontainer: null
        };
    },
    props: {
        breeder: null,
        fieldLabel: null,
        multiple: false,
        hideLabel: false,
        cloud_settings_name: {
            type: String,
            default: "upload_images"
        },
        newVersion: false
    },
    events: {
        'add-photo': function addPhoto() {
            $(this.$els['image']).click();
        },
        'crop-photo': function cropPhoto(file) {
            if (this.breeder.images.length < 5) {
                this.imageCropperModal({
                    files: [file]
                }, false);
            }
        }
    },
    methods: {
        rotate_left_right: function rotate_left_right(left_right) {
            var self = this;
            if (left_right == "right") {
                self.store_rotate_num = self.plus_minus_rotate_num;
            } else {
                self.store_rotate_num = "-" + self.plus_minus_rotate_num;
            }
            this.cropcontainer.cropper('rotate', this.store_rotate_num);
        },
        // Image resize/cropper
        // =====================================
        imageCropperModal: function imageCropperModal(input) {
            var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (store) {
                this.storeinput = input;
            }

            var self = this;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                var $cropmodal = $(self.$els['imageUploadCropperModal']);
                var $cropcontainer = $cropmodal.find('.image-cropper-container');
                reader.onload = function (e) {
                    $cropcontainer.attr('src', e.target.result);
                    var cropper_margintop = $cropmodal.parents('.modal.in').scrollTop();
                    $cropmodal.find('.modal-dialog').css('margin-top', cropper_margintop + 'px');
                    $cropmodal.modal('show');
                    $cropcontainer.cropper({
                        aspectRatio: 1,
                        autoCropArea: 0.3,
                        rotatable: true
                    });
                };
                reader.readAsDataURL(input.files[0]);
                $cropcontainer.data('img-type', input.files[0].type);
                this.cropcontainer = $cropcontainer;

                $(document).one('hide.bs.modal', '.image-upload-cropper-modal', function (event) {
                    if ($(event.target).is('.image-upload-cropper-modal')) {
                        $cropcontainer.cropper('destroy');
                        $(input).val('');
                    }
                });
            }
        },
        uploadImage: function uploadImage() {
            var self = this;
            self.loading = 1;
            var $cropmodal = $(self.$els['imageUploadCropperModal']);
            var $cropcontainer = $cropmodal.find('.image-cropper-container');
            $cropcontainer.cropper('getCroppedCanvas', {
                width: 800,
                height: 800
            }).toBlob(function (blob) {
                self.store_rotate_num = 0;
                $cropmodal.modal('hide');
                var formData = new FormData();
                formData.append('file', blob);
                formData.append('upload_preset', App.cloud_preset);
                var cloud_upload_url = App.cloud_api_base_url + '/image/upload';
                $.ajax({
                    url: cloud_upload_url,
                    method: "POST",
                    data: formData,
                    processData: false,
                    contentType: false
                }).done(function (res) {
                    if (!self.multiple || !self.breeder.images.length) {
                        self.breeder.image = (0, _assign2.default)({}, {
                            name: res.public_id,
                            path: res.url,
                            temp: false,
                            oldImage: '',
                            delete: self.breeder.image.delete
                        });
                    }
                    if (self.multiple) {
                        self.breeder.images.push({
                            name: res.public_id,
                            path: res.url,
                            temp: false,
                            oldImage: '',
                            delete: self.breeder.image.delete
                        });
                    }
                    self.$broadcast('image-uploaded', res.image);
                }).fail(function (err) {
                    console.log('Upload error');
                    console.log(err);
                }).complete(function () {
                    self.loading = 0;
                    self.initUploader();
                });
            }, $cropcontainer.data('img-type'));
        },

        initUploader: function initUploader() {
            var self = this;
            $(this.$els['image']).on('change', function (event) {
                self.imageCropperModal(this);
            });
        },
        // =====================================
        uploaderHelper: function uploaderHelper() {
            if (!this.loading) {
                $(this.$els['image']).click();
            }
        },
        handleClick: function handleClick(e) {
            var _this = this;

            // removing
            if ($(e.target).hasClass('image-remove-icon')) {
                e.stopImmediatePropagation();
                e.stopPropagation();

                var index = 1 * e.target.getAttribute('data-delete');

                if (!this.multiple) {
                    this.breeder.image = { name: "", path: "", temp: true, oldImage: "", delete: false };
                } else {
                    if (index === null) {
                        this.breeder.images = this.breeder.images.filter(function (image) {
                            return image.path !== _this.breeder.image.path;
                        });

                        if (this.breeder.images.length) {
                            this.breeder.image = (0, _assign2.default)({}, this.breeder.images[0]);
                        } else {
                            this.breeder.image = { name: "", path: "", temp: true, oldImage: "", delete: false };
                        }
                    } else {
                        if (this.breeder.images[index].path === this.breeder.image.path) {
                            this.breeder.images.splice(index, 1);

                            if (this.breeder.images.length) {
                                this.breeder.image = (0, _assign2.default)({}, this.breeder.images[0]);
                            } else {
                                this.breeder.image = { name: "", path: "", temp: true, oldImage: "", delete: false };
                            }
                        } else {
                            this.breeder.images.splice(index, 1);
                        }
                    }
                }
            }

            //adding
            if (e.target.getAttribute('data-add') && !this.loading) {
                e.stopImmediatePropagation();
                e.stopPropagation();
                console.log($(this.$els['image']));
                $(this.$els['image']).click();
            }
        },
        resetFileField: function resetFileField(e) {
            e.wrap('<form>').closest('form').get(0).reset();
            e.unwrap();
        },
        closeCropperModal: function closeCropperModal(e) {
            this.store_rotate_num = 0;
            $('.image-upload-cropper-modal').modal('hide');
        },
        updateOrder: function updateOrder(evt) {
            this.breeder.images.splice(evt.newIndex, 0, this.breeder.images.splice(evt.oldIndex, 1)[0]);
            this.setImageActive();
        },
        setImageActive: function setImageActive() {
            this.breeder.image = (0, _assign2.default)({}, this.breeder.images[0]);
        }
    },
    ready: function ready() {
        this.initUploader();
    }
});

},{"babel-runtime/core-js/object/assign":22}],773:[function(require,module,exports){
"use strict";

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component("import-ledgers-file", {
  template: '<a href="#" v-on:click.prevent="openImportConfirmationModal()">Import</a><input @change="parseLedgerFile($event)" type="file" v-el:ledgersfileinput id="import-ledgers-file" style="display: none">',
  props: ["confirmImport"],
  watch: {
    confirmImport: function confirmImport(newData) {
      if (newData) {
        this.confirmImport = false;
        this.triggerFileInput();
      }
    }
  },
  methods: {
    triggerFileInput: function triggerFileInput() {
      if (!this.hasAccess(App.access.ledger)) {
        _eventBus2.default.$emit("restrict-access");
        return;
      }

      this.$els.ledgersfileinput.click();
    },
    parseLedgerFile: function parseLedgerFile(e) {
      this.$router.ledgersFileInput = e;
      this.$route.router.go("/wizard/ledgers");
    },
    openImportConfirmationModal: function openImportConfirmationModal() {
      $("#confirm-import-modal").modal("show");
    }
  },
  mixins: [App.Mixins.Auth]
});

},{"../event-bus":882}],774:[function(require,module,exports){
"use strict";

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.InAppAppleUpgradeSubscription = {
  template: "#in-app-apple-upgrade-subscription-template",
  data: function data() {
    return {
      model: {}
    };
  },
  ready: function ready() {
    var _this = this;

    $(function () {
      _eventBus2.default.$on("in-app-apple-upgrade-subscription", function (data) {
        _this.model = data;
        _this.$nextTick(function () {
          $("#in-app-apple-upgrade-subscription-modal").modal("show");
        });
      });
    });
  },

  mixins: [App.Mixins.Generic]
};

},{"../event-bus":882}],775:[function(require,module,exports){
"use strict";

App.Components.KitBirthCertificate = {
  template: "#birth-certificate-template",
  data: function data() {
    return {
      id: this.$route.params.id,
      breeder: {
        color: null,
        father: null,
        mother: null,
        pedigree_father: null,
        pedigree_mother: null
      }
    };
  },
  components: {},
  computed: {
    breederColor: function breederColor() {
      return this.breeder.color && this.breeder.color !== null && this.breeder.color !== "" ? this.breeder.color : "N/A";
    },
    fatherName: function fatherName() {
      return this.breeder.father_name;
    },
    fatherColor: function fatherColor() {
      return this.breeder.father_color;
    },
    motherName: function motherName() {
      return this.breeder.mother_name;
    },
    motherColor: function motherColor() {
      return this.breeder.mother_color;
    }
  },
  watch: {},
  methods: {
    downloadPDF: function downloadPDF(url) {
      document.location.href = url + "?type=kit";
    }
  },
  events: {},
  ready: function ready() {
    var _this = this;

    api.getKitBirthCertificateInfo(this.id).then(function (res) {
      _this.breeder = res.rabbit;
    });
  }
};

},{}],776:[function(require,module,exports){
'use strict';

App.Components.KitButcher = {
    template: "#kit-butcher-template",
    data: function data() {
        return {
            errors: {},
            date: moment(new Date()).format(App.dateFormat),
            loaded: 0,
            current: 0,
            selectedLitter: 0,
            currency: '',
            loading: false
        };
    },
    props: ['litters', 'litter', 'kits', 'filterKit', 'isGlobal'],
    components: {
        'lbs-oz-input': App.Components.LbsOzInput
    },
    computed: {
        butcherForm: function butcherForm() {
            var form = '#kit-butcher-modal';

            return form;
        }
    },
    watch: {
        litter: function litter(_litter, old_litter) {
            if (_litter && _litter.id) {
                this.selectedLitter = _litter.id;
                $(this.$els.checkall).prop('checked', false);
            }
        },
        selectedLitter: function selectedLitter(selected, oldSelected) {
            if (oldSelected || this.litter && !this.litter.id) {
                this.litter = _.find(this.litters, function (item) {
                    return item.id == selected;
                });

                this.resetButcher();
            }
        }
    },
    methods: {
        resetButcher: function resetButcher() {
            this.toggleLayout(false);
            this.entireLitter = {
                current_weight: 0,
                butcher_weight: 0,
                butcher_value: 0
            };
        },
        sendToButcher: function sendToButcher() {
            var _this = this;

            var selectedKits = this.kits;
            var data = {
                kits: selectedKits,
                date: this.date,
                litter_id: this.selectedLitter
            };

            api.butcherKits(data).then(function () {
                _this.$dispatch('refresh-kits');
                _this.$dispatch('litter-archived', { litter: _this.selectedLitter });
                if (selectedKits.length) {
                    // this.$dispatch('litterButchered', {litter_id:this.selectedLitter,butcher_value:22});
                    _this.$dispatch('reload-tasks', { typeOfTask: 'all', page: null });
                }
            });

            $(this.butcherForm).modal('hide');
            if (this.isGlobal) this.$root.$emit('global-notification-tab-reload');
        }
    },
    ready: function ready() {
        this.currency = App.currency;
    },


    mixins: [App.Mixins.Weightable, App.Mixins.Generic]
};

},{}],777:[function(require,module,exports){
"use strict";

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _mixpanelBrowser = require("mixpanel-browser");

var _mixpanelBrowser2 = _interopRequireDefault(_mixpanelBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.KitForm = App.Components.Exploitable.Section.extend({
    template: "#kit-form-template",
    data: function data() {
        return {
            modalUnique: 'kit',
            deathModalUnique: 'kit',
            loading: 1,
            saver: api.saveKit,
            archiver: api.archiveKit,
            unarchiver: api.unarchiveKit,
            culler: api.cullKit,
            unculler: api.uncullKit,
            deleter: api.deleteKit,
            dier: api.dieKit,
            seller: api.sellKit,
            unseller: api.unsellKit,
            transferer: api.transferKit,
            litters: {},
            littersLoading: 1,
            breedersList: [],
            foster: '',
            tempDateStore: []

        };
    },
    props: ['kit', 'litter'],
    watch: {
        kit: function kit() {
            $('.js_icheck-kit-blue, .js_icheck-kit-red').iCheck('update');
            $(this.$els.color).typeahead('val', this.kit.color);
            $(this.$els.prefix).typeahead('val', this.kit.prefix);
            this.foster = this.kit.litter_id;
        }
    },
    components: {
        'image-upload': App.Components.ImageUpload,
        'lbs-oz-input': App.Components.LbsOzInput,
        'weigh-form': App.Components.WeighForm,
        'vdropzone': App.Components.Vdropzone
    },
    computed: {
        confirmTarget: function confirmTarget() {
            return "this kit";
        },
        weight_unit_short: function weight_unit_short() {

            if (this.litter.weight_unit_short) {
                return this.litter.weight_unit_short;
            }
        },
        kit_weight: function kit_weight() {
            return _.map(this.kit.weight, function (val, i) {
                var formatted_date = "&nbsp;";
                if (this.kit.weight_date != null && this.kit.weight_date[i] != undefined && this.kit.weight_date[i] != 'null' && this.kit.weight_date[i] != null) {
                    if (App.dateFormat == "DD/MM/YYYY") {
                        if (isNaN(this.kit.weight_date[i])) {
                            var weight_date = this.kit.weight_date[i];
                            var d = new Date(weight_date.split("/").reverse().join("-"));
                            var dd = d.getDate();
                            var mm = d.getMonth() + 1;
                            var yy = d.getFullYear();
                            var new_date = mm + "/" + dd + "/" + yy;
                            this.kit.weight_date[i] = new Date(new_date).getTime();
                        }
                    }
                } else {
                    if (this.kit.weight_date == null) {
                        this.kit.weight_date = [];
                        this.kit.weight_date[i] = Date.now();
                    } else {
                        this.kit.weight_date[i] = Date.now();
                    }
                }
                formatted_date = moment(new Date(this.kit.weight_date[i])).format(App.dateFormat);
                // var formatted_date = (this.kit.weight_date[i] == undefined || this.kit.weight_date[i] == 'null') ? '&nbsp;' : moment(new Date(this.kit.weight_date[i])).format(App.dateFormat);
                return { id: i, value: val, wdate: formatted_date };
            }.bind(this));
        },
        models: function models() {
            return this.litter;
        },
        showKitWeight: function showKitWeight() {
            return this.kit.weight && this.kit.weight.length > 0 && this.kit.weight_unit != 'Pound/Ounces';
        }
    },
    events: {
        archivedModel: function archivedModel(kit) {
            this.$dispatch('refresh-kits', kit);
            $('#kit-form-modal').modal('hide');
        },
        culledModel: function culledModel(kit) {
            this.$dispatch('refresh-kits', kit);
            $('#kit-form-modal').modal('hide');
        },
        deletedModel: function deletedModel(kit) {
            this.$dispatch('refresh-kits', kit);
            $('#kit-form-modal').modal('hide');
        },
        diedModel: function diedModel(kit) {
            this.$dispatch('refresh-kits', kit);
            $('#kit-form-modal').modal('hide');
            this.$emit('kitDied', kit);
        },
        soldModel: function soldModel(kit) {
            this.$dispatch('refresh-kits', kit);
            $('#kit-form-modal').modal('hide');
        },
        unsoldModel: function unsoldModel(kit) {
            this.$dispatch('refresh-kits', kit);
            $('#kit-form-modal').modal('hide');
        }
    },
    methods: {
        isButchered: function isButchered(kit) {
            return kit.alive == 0 && kit.foster == 0 && kit.survived == 1 && kit.improved == 0 && kit.archived != 1;
        },

        /**
         * Butcher a single kit
         */
        butcherModal: function butcherModal() {
            this.$dispatch('butcher-kit', this.kit);
        },
        undoButcherModal: function undoButcherModal() {
            $('#undo-butcher-breed-modal-kit').modal('show');
        },
        undoButcher: function undoButcher() {
            var _this = this;

            $('#undo-butcher-breed-modal-kit').modal('hide');
            var data = {
                kits: [this.kit],
                litter_id: this.litter.id
            };

            api.undoButcheredKits(this.litter, data).then(function () {
                $('#kit-form-modal').modal('hide');
                _this.$dispatch('refresh-kits');
            });
        },
        kitDied: function kitDied(kit) {
            var _this2 = this;

            api.dieKit(kit).then(function () {
                _this2.$dispatch('refresh-kits', kit);

                _mixpanelBrowser2.default.track("Kit died", { "Kit ID": kit.id });
            });
            $('#kit-form-modal').modal('hide');
        },

        showMakeBreeder: function showMakeBreeder(model) {
            $('#make-breeder-modal').modal('show');
        },
        makeBreeder: function makeBreeder(kit) {
            var _this3 = this;

            kit._method = "PUT";
            kit.weight_changed = 1;
            api.saveKit(kit).then(function () {
                api.makeBreeder(kit).then(function (res) {
                    $('#kit-form-modal').modal('hide');
                    if (res.subscription.upgraded) {
                        _eventBus2.default.$emit('auto-upgrade-subscription', res.subscription);
                    }

                    _mixpanelBrowser2.default.track("Kit transformed to breeder", { "Kit ID": kit.id, "Breeder ID": res.breeder.id });
                    if (res.breeder.id) {
                        _this3.$router.go({ path: '/profile/' + res.breeder.id });
                    }
                });
            });
        },

        /**
         * (START) New sell/transfer flow
         * NOTE: to be transferred to exploitable->sections
         */
        showSoldModal: function showSoldModal(kit) {
            this.kit = kit;
            $('#sold-breed-modal-' + this.modalUnique).modal('show');
        },
        closeSoldModal: function closeSoldModal() {
            this.transferErrors = {};
            this.transferTo = '';
            this.soldValue = 0;
            $('#sold-breed-modal-' + this.modalUnique).modal('hide');
            this.$dispatch('refresh-kits', this.kit);
            $('#kit-form-modal').modal('hide');
        },
        sold: function sold() {
            var _this4 = this;

            // add checker if sold to field has value
            if (this.transferTo && this.transferTo != "add") {
                // verify if the email is valid
                api.verifyTransferableKit(this.kit, this.transferTo).then(function () {
                    // show confirm transfer modal
                    $('#sold-breed-modal-' + _this4.modalUnique).modal('hide');
                    $('#confirm-transfer-breed-modal-' + _this4.modalUnique).modal('show');
                }, function (error) {
                    // show errors on form
                    _this4.transferErrors = error.data.errors;
                });
            } else {
                // sell kit directly if sold to field is empty
                api.sellKit(this.kit, this.soldValue).then(function () {
                    _mixpanelBrowser2.default.track("Kit marked as sold", { "Kit ID": _this4.kit.id });
                    _this4.closeSoldModal();
                });
            }
        },
        confirmTransfer: function confirmTransfer() {
            var _this5 = this;

            // hide confirm transfer modal
            $('#confirm-transfer-breed-modal-' + this.modalUnique).modal('hide');

            // sell kit
            api.sellKit(this.kit, this.soldValue).then(function () {
                // transfer kit to new owner
                api.transferKit(_this5.kit, _this5.transferTo).then(function () {
                    _mixpanelBrowser2.default.track("Kit transfered", { "Kit ID": _this5.kit.id, "Transfer to": _this5.transferTo });
                    _this5.closeSoldModal();
                }, function (response) {
                    _this5.transferErrors = response.data.errors;
                    _this5.unconfirmTransfer();
                });
            });
        },
        unconfirmTransfer: function unconfirmTransfer() {
            $('#confirm-transfer-breed-modal-' + this.modalUnique).modal('hide');
            $('#sold-breed-modal-' + this.modalUnique).modal('show');
        },
        /**
         * (END) New sell/transfer flow
         */

        unarchive: function unarchive(kit) {
            var _this6 = this;

            api.unarchiveKit(kit).then(function () {
                _this6.$dispatch('refresh-kits', kit);
            });
            $('#kit-form-modal').modal('hide');
        },

        uncull: function uncull(kit) {
            var _this7 = this;

            api.uncullKit(kit).then(function () {
                _this7.$dispatch('refresh-kits', kit);
            });
            $('#kit-form-modal').modal('hide');
        },

        showUndoBreederModal: function showUndoBreederModal() {
            $('#undo-breeder-modal-' + this.modalUnique).modal('show');
        },
        undoBreeder: function undoBreeder() {
            var _this8 = this;

            $('#undo-breeder-modal-' + this.modalUnique).modal('hide');
            api.undoBreeder(this.kit).then(function () {
                _this8.$dispatch('refresh-kits');
            });
        },

        saveKit: function saveKit(_kit) {
            var _this9 = this;

            this.loading = 1;
            var kit = _.extend({}, _kit);

            if (kit.weight_date != null) {
                this.tempDateStore = [];
                for (var i = 1; i <= kit.weight_date.length; i++) {
                    var myDate = kit.weight_date[i - 1];
                    var dateTimestemp = new Date(myDate).getTime();
                    this.tempDateStore.push(dateTimestemp);
                }
                kit.weight_date = this.tempDateStore;
            }

            kit.weight_changed = 1;
            if (kit.new_weight) {
                if (kit.weight == null) {
                    kit.weight = [];
                }
                kit.weight.push(kit.new_weight);
                if (kit.today_date) {
                    if (App.dateFormat == "DD/MM/YYYY") {
                        var weight_date = kit.today_date;
                        var d = new Date(weight_date.split("/").reverse().join("-"));
                        var dd = d.getDate();
                        var mm = d.getMonth() + 1;
                        var yy = d.getFullYear();
                        var new_date = mm + "/" + dd + "/" + yy;
                        var new_weight_date = new Date(new_date).getTime();
                    } else {
                        var new_weight_date = new Date(kit.today_date).getTime();
                    }
                } else {
                    var new_weight_date = Date.now();
                }

                if (kit.weight_date == null) {
                    kit.weight_date = [];
                }

                // Handle existing weights without date
                var diff_length = kit.weight.length - 1 - kit.weight_date.length;
                for (var i = 1; i <= diff_length; i++) {
                    kit.weight_date.push('null');
                }
                kit.weight_date.push(new_weight_date);
            }

            api.saveKit(kit).then(function () {
                _this9.loading = 0;
                $('#kit-form-modal').unbind('hide.bs.modal').modal('hide');
                _this9.$dispatch('refresh-kits', kit);

                if (kit.id) {
                    _mixpanelBrowser2.default.track("Update kit", { "Kit ID": kit.id });
                } else {
                    _mixpanelBrowser2.default.track("Create kit");
                }

                _this9.showAlert({
                    type: "success",
                    text: "Successfully " + (kit.id ? 'updated' : 'created') + " " + kit.given_id
                });
            }, function () {
                _this9.loading = 0;
            });
        },

        father: function father() {
            return _.find(this.litter.parents, function (item) {
                return item.sex === "buck";
            });
        },
        mother: function mother() {
            return _.find(this.litter.parents, function (item) {
                return item.sex === "doe";
            });
        },
        showFosterLittersModel: function showFosterLittersModel() {
            $('#foster-litter-modal').modal('show');
        },

        fosterUpdate: function fosterUpdate(kitId) {
            var litterId = this.foster;
            var datastring = { 'kit_id': kitId, 'litter_id': litterId };
            var vs = this;
            api.getKitPedigree(kitId).then(function (data) {
                vs.$http.post('/admin/foster-update', datastring, function (data) {
                    $('#foster-litter-modal').modal('hide');
                    $('#kit-form-modal').modal('hide');
                });
            });
        },
        initBreedTypeahead: function initBreedTypeahead() {
            this.breedersList = this.getBreedersAutocompleteList();
        },
        redirectToBreeder: function redirectToBreeder(kit) {
            var path = kit.breeder ? '/profile/' + kit.breeder.id : '/breeders';

            this.$router.go({
                path: path
            });
        }
    },
    ready: function ready() {
        var _this10 = this;

        api.getLittersList({ archived: 0, butchered: 0 }).then(function (res) {
            _this10.litters = res;
            _this10.littersLoading = 0;
        });
        this.loading = 1;
        this.initBreedTypeahead();
        api.getKitsAutocomplete().then(function (data) {
            _this10.loading = 0;
            var colors = data.color;
            $(_this10.$els.color).typeahead({
                hint: true,
                highlight: true,
                minLength: 0
            }, {
                source: function source(req, callback) {
                    callback(colors.filter(function (color) {
                        return color.toLowerCase();
                    }));
                }
            });
        });
        api.getBreedersList().then(function (breeders) {
            var prefixes = _this10.uniqueFieldSet(_.flatten([].concat(breeders.does, breeders.bucks)), 'prefix');
            $(_this10.$els.prefix).typeahead({
                hint: true,
                highlight: true,
                minLength: 0
            }, {
                source: _this10.substringMatcher(prefixes)
            });
        });

        $('.js_icheck-kit-blue').iCheck({
            checkboxClass: 'icheckbox_square-blue',
            radioClass: 'iradio_square-blue'
        }).on('ifChecked', function (event) {
            this.kit.sex = "buck";
        }.bind(this));

        //Red color scheme for iCheck
        $('.js_icheck-kit-red').iCheck({
            checkboxClass: 'icheckbox_square-red',
            radioClass: 'iradio_square-red'
        }).on('ifChecked', function (event) {
            this.kit.sex = "doe";
        }.bind(this));
    },
    mixins: [App.Mixins.Butcherable, App.Mixins.DeathReason, App.Mixins.Typeahead, App.Mixins.Breeders, App.Mixins.Weightable, App.Mixins.Transferable, App.Mixins.Photos, App.Mixins.FieldDescription, App.Mixins.Alerts]
});

},{"../event-bus":882,"mixpanel-browser":634}],778:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.KitsList = {
  template: "#kits-list-template",
  data: function data() {
    return {
      kits: [],
      activeKit: {},
      errors: {},
      loading: 1,
      order: this.customOrder == "born|desc" ? this.customOrder : "given_id|asc",
      page: 1,
      totalPages: 1,
      totalCount: 0
    };
  },

  props: ["displayItems", "searchQuery", "perPage", "filters", "actionableKits", "litters", "customOrder"],
  watch: {
    order: function order() {
      this.updateList();
    },
    searchQuery: function searchQuery() {
      this.updateList();
    },
    totalCount: function totalCount(newData) {
      this.$dispatch("total-count-updated", newData);
    },

    filters: {
      handler: function handler(newData, oldData) {
        if (newData.doe == -1) this.filters.doe = "";
        if (newData.buck == -1) this.filters.buck = "";

        this.page = 1;
        this.updateList();
      },
      deep: true
    }
  },
  computed: {
    confirmTarget: function confirmTarget() {
      return this.activeKit.name || this.activeKit.given_id;
    },
    modalUnique: function modalUnique() {
      return "kits-list";
    },
    deathModalUnique: function deathModalUnique() {
      return "kits-list";
    }
  },
  components: {
    "multiple-kit-form": App.Components.MultipleKitForm,
    "kit-form": App.Components.KitForm
  },
  events: {
    "refresh-kits": function refreshKits() {
      this.updateList();
    },
    "open-multiple-kit-form": function openMultipleKitForm() {
      if (this.actionableKits.length == 1) {
        var kit = this.actionableKits[0];
        this.editKit(kit);
      } else {
        this.$broadcast("open-multiple-kit-form");
      }
    },
    "open-delete-multiple-kits": function openDeleteMultipleKits() {
      if (this.actionableKits.length == 1) {
        var kit = this.actionableKits[0];
        this.showDeleteModal(kit);
      } else {
        this.$broadcast("open-delete-multiple-kits");
      }
    }
  },
  methods: {
    buildFilters: function buildFilters() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      data.all = ["", "all"].includes(this.filters.status) ? 1 : 0;
      data.to_cull = this.filters.status === "to_cull" ? 1 : 0;
      data.culled = ["culled", "inactive"].includes(this.filters.status) ? 1 : 0;
      data.sold = ["sold", "inactive"].includes(this.filters.status) ? 1 : 0;
      data.died = ["died", "inactive"].includes(this.filters.status) ? 1 : 0;
      data.archived = ["archived", "inactive"].includes(this.filters.status) ? 1 : 0;
      data.butchered = ["butchered", "inactive"].includes(this.filters.status) ? 1 : 0;
      data.sex = this.filters.sex;

      var allowedFilters = ["sex", "archived", "culled", "sold", "butchered", "died", "order", "to_cull", "orderDirection"];

      var filterModel = {
        litter_id: null,
        buck: null,
        doe: null
      };

      data.filters = _.pick(this.filters, _.keys(filterModel));

      return data;
    },
    refreshKits: function refreshKits() {
      this.updateList();
    },
    updateList: function updateList() {
      var _this = this;

      this.loading = 1;
      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var data = { page: this.page, perPage: this.perPage };
      if (this.order) {
        data.order = this.order;
      }
      data = this.buildFilters(data);
      data.searchQuery = this.searchQuery;

      api.getKits(data).then(function (data) {
        _this.kits = data.kits.data;
        _this.pages = data.kits.last_page;
        _this.order = data.order;
        _this.loading = 0;
        _this.itemsLoaded = data.kits.current_page;
        _this.totalItems = data.kits.total;

        var orderSort = data.order.split("|");
        _this.currentSort = orderSort[0];
        _this.currentOrder = orderSort[1];

        // for list view
        _this.totalPages = data.kits.last_page;
        _this.totalCount = data.kits.total;
        _this.description = {
          from: data.kits.from,
          to: data.kits.to,
          total: data.kits.total
        };

        _this.$nextTick(function () {
          _this.initializeKitsCheckbox();
        });
      });
    },
    initializeKitsCheckbox: function initializeKitsCheckbox() {
      var _this2 = this;

      this.actionableKits = [];
      $(".kit-checkbox").iCheck({
        checkboxClass: "icheckbox_square-green",
        radioClass: "iradio_square-green"
      }).on("ifChecked", function (event) {
        var kit = _this2.getKitById(event.target.name);
        _this2.actionableKits.push(kit);
      }).on("ifUnchecked", function (event) {
        var kit = _this2.getKitById(event.target.name);
        _this2.actionableKits = _.filter(_this2.actionableKits, function (item) {
          return item.id != kit.id;
        });
      });
    },
    getKitById: function getKitById(id) {
      id = id.replace("kit-", "");
      var kit = _.find(this.kits, function (kit) {
        return kit.id == id;
      });

      return kit;
    },
    getKitParent: function getKitParent(kit) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "f";

      var litter = kit.litter || {};
      var parents = litter.parents;
      var parent = {};

      if (type == "f") {
        parent = parents.find(function (item) {
          return item.sex === "buck";
        });
      } else {
        parent = parents.find(function (item) {
          return item.sex === "doe";
        });
      }

      return parent || {};
    },
    editKit: function editKit(kit) {
      this.activeKit = kit;
      var form = $("#kit-form-modal");
      form.modal({
        backdrop: "static",
        keyboard: false
      });
      form.modal("show");
    },
    markForSaleModal: function markForSaleModal(kit) {
      if (App.hasMarketplaceProfile) {
        this.activeKit = kit;
        $('#mark-for-sale-modal-kits-list').modal('show');
      } else {
        $('#no-marketplace-profile-modal').modal('show');
      }
    },
    markForSale: function markForSale() {
      var _this3 = this;

      var params = (0, _extends3.default)({
        listable_id: this.activeKit.id,
        listable_type: "kit",
        amount: this.listingAmount || 0,
        is_active: this.isListOnMarketplace,
        description: this.listingNotes
      }, this.marketplaceFields);

      api.markForSale(params).then(function (data) {
        _this3.updateList();

        if (_this3.isListOnMarketplace) {
          _this3.showAlert({
            type: 'success',
            text: "\n                          Congratulations! You've listed <b>" + (_this3.activeKit.name || _this3.activeKit.given_id) + "</b> on the Everbreed Marketplace.<br/><br/>\n                          Here is a link to the public listing that you can share on social media or with potential buyers:",
            link: _this3.marketplaceUrl + '/listings/' + data.listing.id + '/details',
            linkText: 'Link to listing',
            newTab: true,
            hideAfter: 10000
          });
        } else {
          _this3.showAlert({
            type: 'success',
            text: (_this3.activeKit.name || _this3.activeKit.given_id) + " has been marked as for sale."
          });
        }

        _this3.isListOnMarketplace = false;
        _this3.isAgreeToTerms = false;
        _this3.listingAmount = 0;
        _this3.listingNotes = "";
        _this3.marketplaceFields = {
          name: true,
          tattoo: true,
          breed: true,
          date_of_birth: true,
          sex: true,
          image: true,
          weight: true,
          genotype: true,
          pedigree: true
        };
        $('#mark-for-sale-modal-kits-list').modal('hide');
      }, function (response) {});
    },

    removeForSaleModal: function removeForSaleModal(kit) {
      this.activeKit = kit;
      $('#remove-for-sale-modal-kits-list').modal('show');
    },
    removeForSale: function removeForSale() {
      var _this4 = this;

      var params = {
        id: this.activeKit.for_sale.id
      };

      api.removeForSale(params).then(function (data) {
        _this4.updateList();
        _this4.showAlert({
          type: 'success',
          text: (_this4.activeKit.name || _this4.activeKit.given_id) + " has been removed for sale."
        });

        $('#remove-for-sale-modal-kits-list').modal('hide');
      }, function (response) {});
    }
  },
  ready: function ready() {
    this.updateList();
  },

  mixins: [App.Mixins.Generic, App.Mixins.BreedersFilter, App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.Butcherable, App.Mixins.DeathReason, App.Mixins.Weightable, App.Mixins.Transferable, App.Mixins.Photos, App.Mixins.FieldDescription, App.Mixins.Filterable, App.Mixins.Kits]
};

},{"babel-runtime/helpers/extends":37}],779:[function(require,module,exports){
'use strict';

App.Components.LbsOzInput = {
    twoWay: true,
    deep: true,
    template: '<div>' + '<div class="input-group" :class="{\'no-curve\': hideSlug}">' + '<input type="number" min="0" pattern="\d*" class="form-control number-without-arrows lbs" v-model="lbs" debounce="20000" @input="inputEvent()">' + '<span class="input-group-btn" style="width:0px;"></span>' + '<input type="number" min="0" class="form-control number-without-arrows oz" v-model="oz"  debounce="20000" @input="inputEvent()">' + '<span v-if="!hideSlug && weightSlug" class="input-group-addon p6">{{ weightSlug }}</span>' + '</div>' + '</div>',

    data: function data() {
        return {
            localWeight: 0
        };
    },
    props: ['weight', 'model', 'reset', 'slug', 'hideSlug'],
    computed: {
        lbs: {
            get: function get() {
                return this.weight ? Math.floor(this.weight / 16) : null;
            },
            set: function set(newValue) {
                this.weight = newValue * 16 + (this.oz ? parseFloat(this.oz) : 0);
            }
        },

        oz: {
            get: function get() {
                if (this.weight) {
                    var oz = parseFloat((this.weight - this.lbs * 16).toFixed(3));
                    if (oz != 0) {
                        return oz;
                    }
                }
                return null;
            },
            set: function set(newValue) {
                this.weight = this.lbs * 16 + (newValue ? parseFloat(newValue) : 0);
            }
        },
        weightSlug: function weightSlug() {
            return this.slug ? this.slug.replace('-', '/') : this.getWeightSlug();
        }
    },
    components: {},
    watch: {
        model: function model() {
            this.localWeight = this.weight;
        }
    },
    events: {},
    methods: {
        inputEvent: function inputEvent() {
            this.$dispatch('input-event', this.model);
        }
    },

    ready: function ready() {
        if (this.reset) {
            this.weight = '';
        }
    },
    mixins: [App.Mixins.Weightable]
};

},{}],780:[function(require,module,exports){
'use strict';

App.Components.LedgerForm = App.Components.Exploitable.Form.extend({
    template: "#ledger-form-template",
    data: function data() {
        return {
            category_names: [],
            categories: [],
            emptyModel: {
                category_id: null,
                debit: true,
                description: '',
                category_name: '',
                image: {
                    "name": '',
                    "path": '',
                    "temp": true,
                    "oldImage": '',
                    "delete": false
                },
                images: []
            },
            entry: { debit: 0 },
            litters: [],
            breeders: [],
            loading: 1,
            disableModal: 0,
            select2Options: {}
        };
    },
    props: ['associated_type', 'associated_id', 'isGlobal'],
    components: {
        'image-upload': App.Components.ImageUpload
    },
    computed: {
        modal_id: function modal_id() {
            return this.isGlobal ? '#global-ledger-form' : '#ledger-form';
        },

        category: function category() {
            return _.find(this.categories, function (category) {
                return this.entry.category_id == category.id;
            }.bind(this));
        },
        associated: function associated() {
            if (!this.category) return false;

            var isAssociated = ['breeder', 'litter'].indexOf(this.category.special) !== -1;

            if (isAssociated) {
                if (!this.entry.associated_id) {
                    this.entry.associated_id = null;
                }
                return this.category.special;
            }

            return isAssociated;
        },
        associated_record: function associated_record() {
            var options = this.category.special === 'breeder' ? this.breeders : this.litters;
            return options.find(function (option) {
                return option.id == this.associated_id;
            }.bind(this));
        },
        associations: function associations() {
            if (!this.category || ['breeder', 'litter'].indexOf(this.category.special) === -1) return [];
            return this[this.category.special + 's'];
        },
        default_category: function default_category() {
            return this.categories.filter(function (category) {
                return category.special === 'general';
            })[0];
        },
        model: {
            get: function get() {
                return this.entry;
            },
            set: function set(model) {
                this.entry = model;
                if (!this.entry.id) {
                    this.entry.debit = 0;
                }
            }
        }
    },
    watch: {
        associated: function associated(value) {
            console.log('associated', value);
            var self = this;

            if (value == 'breeder') {
                this.select2Options = {
                    ajax: {
                        url: '/admin/breeders/getList',
                        data: this.dataQuery,
                        processResults: function processResults(data) {
                            data = data.bucks.concat(data.does);
                            var test = data.map(function (item) {
                                item.text = self.representAssociation(item);

                                return item;
                            });
                            return {
                                results: test
                            };
                        }
                    }
                };
            } else if (value == 'litter') {
                this.select2Options = {
                    ajax: {
                        url: '/admin/litters/getList',
                        data: this.dataQuery,
                        processResults: function processResults(data) {
                            var test = data.map(function (item) {
                                item.name = (item.parents[0] || { name: '' }).name + '/' + (item.parents[1] || { name: '' }).name;
                                item.text = self.representAssociation(item);

                                return item;
                            });
                            return {
                                results: test
                            };
                        }
                    }
                };
            }
        },
        entry: function entry(_entry) {
            if (!('debit' in _entry)) {
                _entry.debit = 1;
            }
            this.resetArchivedFilterBreeders();
            $('.js_icheck-ledger-green, .js_icheck-ledger-red').iCheck('update');
            $('#entry-name').typeahead('val', this.entry.name);
            $('#entry-amount').typeahead('val', this.entry.amount);

            //reset new contact field
            if (this.entry.contact_id != -1) {
                this.resetNewContact();
            }

            /**
             * Reset images array on empty model
             * Note: can't figure out why empty model
             * updates when adding an image
             */
            this.emptyModel.images = [];
        },
        'entry.associated_id': function entryAssociated_id(value) {
            console.log('associated_id', value);
            this.setFilterBreedersEntry(value);
        },
        disableModal: function disableModal(newData) {
            this.$dispatch('updateDisableModal', newData);
        }
    },
    methods: {
        dataQuery: function dataQuery(params) {
            var query = {
                type: 'options',
                searchQuery: params.term,
                page: params.page || 1
            };

            return query;
        },
        loadCategories: function loadCategories() {
            var _this = this;

            this.loading = 1;
            this.disableModal = 1;
            api.getLedgerCategories().then(function (data) {
                _this.loading = 0;
                _this.disableModal = 0;
                _this.categories = data.categories;
                _this.emptyModel.category_id = _this.entry.category_id || _this.default_category.id;
            });
        },
        loadLitters: function loadLitters() {
            var _this2 = this;

            this.loading = 1;
            api.getLittersList().then(function (litters) {
                _this2.loading = 0;
                _this2.litters = litters.map(function (item) {
                    item.name = (item.parents[0] || { name: '' }).name + '/' + (item.parents[1] || { name: '' }).name;
                    return item;
                });
            });
        },
        loadBreeders: function loadBreeders() {
            var _this3 = this;

            this.loading = 1;
            api.getBreedersList().then(function (data) {
                _this3.loading = 0;
                _this3.breeders = data.bucks.concat(data.does);
            });
        },
        representAssociation: function representAssociation(association) {
            return this.category.special === 'breeder' ? association.name + ': ' + association.tattoo : association.given_id + ': ' + association.name;
        },
        initTypeahead: function initTypeahead() {
            var _this4 = this;

            this.loading = 1;
            api.getLedgerAutocomplete().then(function (data) {
                _this4.loading = 0;
                var names = data.name,
                    amounts = data.amount;

                _this4.category_names = data.category_name;

                $('#entry-name').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: function source(req, callback) {
                        callback(names.filter(function (name) {
                            return name.toLowerCase().indexOf(req.toLowerCase()) !== -1;
                        }));
                    }
                });

                $('#entry-amount').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: function source(req, callback) {
                        callback(amounts.filter(function (amount) {
                            return amount.toLowerCase().indexOf(req.toLowerCase()) !== -1;
                        }));
                    }
                });
            });
        },
        filterEntriesBreeders: function filterEntriesBreeders(value) {
            if (this.withArchivedBreeders) {
                return true;
            }
            return this.entry.associated_id == value.id || value.archived === 0 && value.sold_at == null;
        },
        save: function save() {
            var _this5 = this;

            this.loading = 1;

            api.saveLedgerEntry(this.model).then(function (data) {
                _this5.loading = 0;
                $(_this5.modal_id).modal('hide');
                _this5.$dispatch('ledgerSaved', data);
            }, function (response) {
                _this5.loading = 0;
                _this5.errors = response.data.errors;
            });
        }
    },
    events: {
        modalShown: function modalShown() {
            if (this.associated_type) {
                this.entry.category_id = this.categories.find(function (category) {
                    return category.special === this.associated_type;
                }.bind(this)).id;
                this.entry.associated_id = this.associated_id;
                this.setFilterBreedersEntry(this.entry.associated_id);
            }
        },
        'add-global-ledger': function addGlobalLedger() {
            if (this.isGlobal) {
                this.showModal();
            }
        }
    },
    ready: function ready() {
        this.initTypeahead();
        this.loadCategories();

        this.$watch('entry.category_id', function (val) {
            if (val) return;

            $('#entry-category-name').typeahead({
                hint: true,
                highlight: true,
                minLength: 0
            }, {
                source: function (req, callback) {
                    callback(this.category_names.filter(function (name) {
                        return name.toLowerCase().indexOf(req.toLowerCase()) !== -1;
                    }));
                }.bind(this)
            });

            $('#entry-category-name').typeahead('val', this.entry.category_name);
        });

        $('.js_icheck-ledger-green').iCheck({
            checkboxClass: 'icheckbox_square-green',
            radioClass: 'iradio_square-green'
        }).on('ifChecked', function (event) {
            this.entry.debit = true;
        }.bind(this));

        //Red color scheme for iCheck
        $('.js_icheck-ledger-red').iCheck({
            checkboxClass: 'icheckbox_square-red',
            radioClass: 'iradio_square-red'
        }).on('ifChecked', function (event) {
            this.entry.debit = false;
        }.bind(this));
    },

    mixins: [App.Mixins.BreedersFilter, App.Mixins.Auth, App.Mixins.Contacts]
});

},{}],781:[function(require,module,exports){
"use strict";

App.Components.LedgerTableV2 = App.Components.LedgerTable.extend({
    template: "#ledger-table-v2-template"
});

},{}],782:[function(require,module,exports){
'use strict';

App.Components.LedgerTable = App.Components.Exploitable.Section.extend({
    template: "#ledger-table-template",
    data: function data() {
        return {
            itemsLoaded: 0,
            ledger: [],
            daterange: [],
            total: 0,
            type: '',
            loading: true,
            modalUnique: 'ledger-table',
            showSubscribe: false,
            categories: [],
            subDropdownOpend: false,
            filters: {
                name: '',
                description: '',
                category: ''
            },
            filterRules: {
                name: 'string',
                description: 'string',
                category: {
                    type: 'relation',
                    relationName: 'category',
                    relationFilterField: 'id',
                    valueType: 'number'
                }
            },
            searchFields: ['name', 'amount', 'description'],

            deleter: api.deleteLedgerEntry,
            archiver: api.archiveLedgerEntry,
            unarchiver: api.unarchiveLedgerEntry,
            disableModal: 0,
            oldOrder: 'date|desc'
        };
    },
    props: ['associated_type', 'associated_id', 'associated'],
    components: {
        'ledger-form': App.Components.LedgerForm
    },
    computed: {
        dateFrom: function dateFrom() {
            if (!this.daterange || !this.daterange.length) {
                return null;
            }
            return this.daterange[0].format(App.dateFormat);
        },
        dateTo: function dateTo() {
            if (!this.daterange || !this.daterange.length) {
                return null;
            }
            return this.daterange[1].format(App.dateFormat);
        },
        order: function order() {
            return this.currentSort + '|' + this.currentOrder;
        }
    },
    watch: {
        type: function type() {
            this.updateList();
        },
        daterange: function daterange() {
            this.updateList();
        },
        order: function order() {
            this.updateList();
        },
        oldOrder: function oldOrder(newData) {
            data = newData.split('|');
            this.changeOrder(data[0], data[1]);
        }
    },
    events: {
        updateDisableModal: function updateDisableModal(value) {
            this.disableModal = value;
        },

        ledgerSaved: function ledgerSaved() {
            this.updateList();
            return true;
        },
        deletedModel: function deletedModel() {
            this.updateList();
            return true;
        },
        archivedModel: function archivedModel() {
            this.updateList();
            return true;
        },
        unarchivedModel: function unarchivedModel() {
            this.updateList();
            return true;
        },
        load_ledger: function load_ledger() {
            this.updateList();
        }
    },
    methods: {
        changeOrderOld: function changeOrderOld(value) {
            this.oldOrder = value;
        },
        changeType: function changeType(value) {
            this.type = value;
        },
        hoverSubdropdown: function hoverSubdropdown(event) {
            var elem = event.target;
            this.subDropdownOpend = elem.classList.contains('hoverClass');
        },
        updateList: function updateList() {
            this.itemsLoaded = 0;

            this.loadMore();
        },

        loadMore: function loadMore() {
            var _this = this;

            if (this.hasAccess(App.access.ledger)) {
                var _data = this.getListPostData();

                api.getLedgerEntries(_data).then(function (data) {
                    if (_this.itemsLoaded === 0) {
                        _this.ledger = data.ledger.data;
                    } else {
                        _this.mergeByProperty(_this.ledger, data.ledger.data, 'id');
                    }

                    _this.updated(data);
                    _this.$nextTick(function () {
                        $('#reservation').trigger('triggerDaterangepicker');
                    });
                }, function (response) {
                    _this.loading = false;
                    if (response.status === 403) {
                        _this.showSubscribe = true;
                    }
                });
            }
        },
        getListPostData: function getListPostData() {
            var data = {
                page: this.itemsLoaded + 1
            };

            if (this.type === "archive") {
                data.archived = 1;
            } else if (this.type) {
                data.debit = this.type === "income" ? 1 : 0;
            }

            if (this.associated_type) {
                data.associated_type = this.associated_type;
                data.associated_id = this.associated_id;
            }

            if (this.order) {
                data.order = this.order;
            }

            if (this.dateFrom) {
                data.from = this.dateFrom;
            }
            if (this.dateTo) {
                data.to = this.dateTo;
            }

            data.filters = this.filters;
            data.searchQuery = this.searchQuery;

            return data;
        },
        updated: function updated(data) {
            this.loading = false;

            this.order = data.order;
            this.total = data.total;

            this.itemsLoaded = parseInt(data.ledger.current_page);
            this.totalItems = data.ledger.total;
            this.disableLoadMore = data.ledger.last_page <= data.ledger.current_page;
        },
        clickDateRange: function clickDateRange() {
            $(this.$els.dateRangeInput).click();
        },
        isEditMode: function isEditMode() {
            return this.associated_type !== 'breeder' || this.isBreederActive(this.associated);
        },
        openAttachments: function openAttachments(entry) {
            _.each(entry.images, function (image) {
                window.open(image.path.replace(',h_150,w_150', ''));
            });
        }
    },
    ready: function ready() {
        // set default sorting
        this.currentSort = 'date';
        this.currentOrder = 'desc';
    },

    mixins: [App.Mixins.Currency, App.Mixins.Filterable, App.Mixins.Auth, App.Mixins.Breeders]
});

},{}],783:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.emptyLedger = {
    "id": 0,
    "debit": 0,
    "date": '',
    "name": '',
    "amount": 0,
    "description": "",
    "category_id": 1,
    "associated_id": '',
    "image": {
        "name": '',
        "path": '',
        "temp": true,
        "oldImage": '',
        "delete": false
    },
    "images": []
};

App.Components.Ledger = App.Components.Exploitable.Section.extend({
    template: "#ledger-template",
    data: function data() {
        return {
            itemsLoaded: 0,
            ledger: [],
            daterange: [],
            total: 0,
            modalUnique: 'ledgers',
            categories: [],
            btn_name: [],
            statistics: {},
            subDropdownOpend: false,
            showSubscribe: false,
            disableLoadMore: true,
            loading: true,
            preFilters: {
                name: '',
                description: '',
                contact: '',
                amount_range: {
                    from: null,
                    to: null
                },
                type: '',
                date: {
                    from: null,
                    to: null
                },
                category: ''
            },
            filters: {
                name: '',
                description: '',
                contact: '',
                amount_range: {
                    from: null,
                    to: null
                },
                type: '',
                date: {
                    from: null,
                    to: null
                },
                category: ''
            },
            filterRules: {
                name: 'string',
                description: 'string',
                category: {
                    type: 'relation',
                    relationName: 'category',
                    relationFilterField: 'id',
                    valueType: 'number'
                }
            },
            preFilterRanges: {
                date: []
            },
            filterRanges: {
                date: []
            },
            searchFields: ['name', 'amount', 'description', 'contact.name', 'contact.company_name', 'category.name'],
            displayItems: {
                date: true,
                name: true,
                contact: true,
                category: true,
                amount: true,
                type: false
            },
            page: 1,
            perPage: 10,
            pagination: {
                from: 0,
                to: 0,
                total: 0
            },
            paginationLinks: [],
            deleter: api.deleteLedgerEntry,
            archiver: api.archiveLedgerEntry,
            unarchiver: api.unarchiveLedgerEntry,
            confirmImport: false
        };
    },
    components: {
        'ledger-form': App.Components.LedgerForm
    },
    watch: {
        type: function type() {
            this.updateList();
        },
        category: function category() {
            this.updateList();
        },
        daterange: function daterange() {
            this.updateList();
        },
        order: function order() {
            this.updateList();
        },
        preFilters: {
            handler: function handler(val) {
                if (val.amount_range.from > val.amount_range.to) {
                    this.preFilters.amount_range.to = val.amount_range.from;
                }
            },
            deep: true
        }
    },
    computed: {
        type: function type() {
            return this.$route.params.type;
        },
        category: function category() {
            return this.$route.params.category;
        },
        currentRoute: function currentRoute() {
            return this.$route.path.split('?')[0];
        },
        dateFrom: function dateFrom() {
            if (!this.daterange || !this.daterange.length) {
                return null;
            }
            return this.daterange[0].format(App.dateFormat);
        },
        dateTo: function dateTo() {
            if (!this.daterange || !this.daterange.length) {
                return null;
            }
            return this.daterange[1].format(App.dateFormat);
        },
        order: function order() {
            return this.currentSort + '|' + this.currentOrder;
        }
    },
    methods: {
        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        hoverSubdropdown: function hoverSubdropdown(event) {
            var elem = event.target;
            this.subDropdownOpend = elem.classList.contains('hoverClass');
        },
        updateList: function updateList() {
            if (this.hasAccess(App.access.ledger)) {
                this.updating();

                this.itemsLoaded = 0;

                this.loadMore();
            }
        },
        updatePerPage: function updatePerPage() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

            this.perPage = value;

            this.loadMore();
        },
        updatePage: function updatePage() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            this.page = page;

            this.loadMore();
        },

        pageFromUrl: function pageFromUrl(sPageURL) {
            var sParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'page';

            var sURLVariables = sPageURL.substring(sPageURL.indexOf('?') + 1).split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? 1 : decodeURIComponent(sParameterName[1]);
                }
            }
            return 1;
        },
        loadMore: function loadMore() {
            var _this = this;

            if (this.hasAccess(App.access.ledger)) {

                this.updating();
                var data = this.getListPostData();

                api.getLedgerEntries(data).then(function (data) {
                    _this.ledger = data.ledger.data;
                    _this.paginationLinks = data.ledger.links;
                    _this.pagination.from = data.ledger.from;
                    _this.pagination.to = data.ledger.to;
                    _this.pagination.total = data.ledger.total;

                    _this.updated(data);
                    _this.$nextTick(function () {
                        $('#reservation').trigger('triggerDaterangepicker');
                    });
                }, function (response) {
                    _this.loading = false;
                    if (response.status === 403) {
                        _this.showSubscribe = true;
                    }
                });
            }
        },

        loadCategories: function loadCategories() {
            var _this2 = this;

            return api.getLedgerCategories().then(function (data) {
                _this2.categories = data.categories;
            });
        },
        updating: function updating() {
            var _this3 = this;

            if (this.hasAccess(App.access.ledger)) {
                var data = {};

                if (this.type === "archive") {
                    data.archived = 1;
                } else if (this.type) {
                    data.debit = this.type === "income" ? 1 : 0;
                }

                api.getLedgerStatistics(data).then(function (data) {
                    _this3.statistics = data;
                });
            }
        },
        updated: function updated(data) {
            var _this4 = this;

            this.loading = false;

            this.order = data.order;
            this.total = data.total;

            this.itemsLoaded = parseInt(data.ledger.current_page);
            this.totalItems = data.ledger.total;
            this.disableLoadMore = data.ledger.last_page <= data.ledger.current_page;

            this.$nextTick(function () {
                if (_this4.$route.query.new) {
                    _this4.addModel();
                }
            });
        },
        getListPostData: function getListPostData() {
            var data = {
                page: this.page,
                perPage: this.perPage
            };

            if (this.type === "archive") {
                data.archived = 1;
            } else if (this.type) {
                data.debit = this.type === "income" ? 1 : 0;
            }

            if (this.associated_type) {
                data.associated_type = this.associated_type;
                data.associated_id = this.associated_id;
            }

            if (this.order) {
                data.order = this.order;
            }

            if (this.dateFrom) {
                data.from = this.dateFrom;
            }
            if (this.dateTo) {
                data.to = this.dateTo;
            }

            this.filters.category = this.category || this.preFilters.category;

            if (this.filters.type == 'income') data.debit = 1;else if (this.filters.type == 'expense') data.debit = 0;

            data.filters = this.filters;
            data.searchQuery = this.searchQuery;

            return data;
        },
        clickDateRange: function clickDateRange() {
            $(this.$els.dateRangeInput).click();
        },
        triggerConfirmImport: function triggerConfirmImport() {
            this.confirmImport = true;
        },
        deleteImage: function deleteImage() {
            this.ledger.image = { name: "", path: "", temp: true, oldImage: "", delete: false };
        },
        openAttachments: function openAttachments(entry) {
            _.each(entry.images, function (image) {
                window.open(image.path.replace(',h_150,w_150', ''));
            });
        },
        initializeDisplayItems: function initializeDisplayItems() {
            var _this5 = this;

            $('.display-settings').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            }).on('ifChecked', function (event) {
                _this5.displayItems[event.target.name] = true;
            }).on('ifUnchecked', function (event) {
                _this5.displayItems[event.target.name] = false;
            });

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.displayItems)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    if (this.displayItems[key]) {
                        $("input[class='display-settings'][name='" + key + "']").iCheck("check");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        applyPreFilters: function applyPreFilters() {
            this.filterRanges = (0, _extends3.default)({}, this.preFilterRanges);
            this.filters = (0, _extends3.default)({}, this.preFilters, { amount_range: (0, _extends3.default)({}, this.preFilters.amount_range) });
        },
        resetPreFilters: function resetPreFilters() {
            this.preFilters = {
                name: '',
                description: '',
                contact: '',
                amount_range: {
                    from: null,
                    to: null
                },
                type: '',
                date: {
                    from: null,
                    to: null
                },
                category: ''
            };

            this.preFilterRanges = {
                date: []
            };

            this.amount_range = {
                from: null,
                to: null
            };

            this.applyPreFilters();
        },
        removeFilter: function removeFilter() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var resetContent = "";

            if (type == 'date') {
                resetContent = {
                    from: null,
                    to: null
                };

                this.preFilterRanges[type] = resetContent;
            }

            if (type == 'amount_range') {
                resetContent = {
                    from: null,
                    to: null
                };

                this.amount_range = {
                    from: null,
                    to: null
                };
            }

            if (type) {
                this.preFilters[type] = resetContent;
                this.applyPreFilters();
            }
        },
        fetchCategoryNameById: function fetchCategoryNameById(id) {
            var category = _.find(this.categories, function (category) {
                return category.id === id;
            });

            return category.name;
        }
    },
    events: {
        ledgerSaved: function ledgerSaved() {
            this.updateList();
            return true;
        },
        deletedModel: function deletedModel() {
            this.updateList();
            return true;
        },
        archivedModel: function archivedModel() {
            this.updateList();
            return true;
        },
        unarchivedModel: function unarchivedModel() {
            this.updateList();
            return true;
        }
    },
    ready: function ready() {
        var _this6 = this;

        this.initializeDisplayItems();
        this.$watch('$route.query.new', function (val) {
            if (val) {
                _this6.addModel();
            }
        });
        $(document).on('hide.bs.modal', '#ledger-form', function (e) {
            setTimeout(function () {
                if (!$(e.target).is(':visible') && _this6.$route.query.new) {
                    _this6.$route.router.go('/ledger');
                }
            }, 20);
        });
        this.updateList();
        this.loadCategories();

        // set default sorting
        this.currentSort = 'date';
        this.currentOrder = 'desc';

        this.getCurrentData();

        // tweak for dropdown
        $(document).on('click', '.dropdown-menu.main-filters', function (e) {
            if ($(e.target).data("dismiss") != "dropdown") {
                e.stopPropagation();
            }
        });

        $('#f-daterange').trigger('triggerDaterangepicker');
    },
    mixins: [App.Mixins.Currency, App.Mixins.Filterable, App.Mixins.Auth, App.Mixins.Generic]
});

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37}],784:[function(require,module,exports){
'use strict';

App.Components.LedgerCategories = App.Components.Exploitable.Section.extend({
    template: "#category-template",
    data: function data() {
        return {
            categories: [],
            btn_name: [],
            hasArchive: false,
            loading: 1,
            deleter: api.deleteLedgerCategory
        };
    },
    computed: {
        models: function models() {
            return this.categories;
        }
    },
    events: {
        'formAdded': function formAdded() {
            App.vent.trigger('sidebar-reload-ledger-categories');
        },
        'formUpdated': function formUpdated() {
            App.vent.trigger('sidebar-reload-ledger-categories');
        },
        'deletedModel': function deletedModel() {
            App.vent.trigger('sidebar-reload-ledger-categories');
        }
    },
    components: {
        'category-form': App.Components.LedgerCategoryForm
    },
    methods: {
        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        updateList: function updateList() {
            var _this = this;

            api.getLedgerCategories().then(function (data) {
                _this.loading = 0;
                _this.categories = data.categories;
            });
        }
    },
    ready: function ready() {
        this.updateList();
        this.getCurrentData();
    }
});

},{}],785:[function(require,module,exports){
'use strict';

App.Components.LedgerCategoryForm = App.Components.Exploitable.Form.extend({
    template: "#category-form-template",
    data: function data() {
        return {
            modal_id: '#ledger-category-form',
            emptyModel: {
                description: ''
            },
            category: {},
            saver: api.saveLedgerCategory
        };
    },
    computed: {
        model: {
            get: function get() {
                return this.category;
            },
            set: function set(model) {
                this.category = model;
            }
        }
    },
    watch: {
        category: function category() {
            $('#category-name').typeahead('val', this.category.name);
        }
    },
    methods: {
        addNew: function addNew() {
            $('#ledger-category-form').modal('show');
        },
        initTypeahead: function initTypeahead() {
            api.getLedgerCategoriesAutocomplete().then(function (data) {
                var names = data.name;
                $('#category-name').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: function source(req, callback) {
                        callback(names.filter(function (name) {
                            return name.toLowerCase().indexOf(req.toLowerCase()) !== -1;
                        }));
                    }
                });
            });
        }
    },
    ready: function ready() {
        if (this.$route.query.new) {
            this.addNew();
        }
        this.initTypeahead();
    }
});

},{}],786:[function(require,module,exports){
"use strict";

App.Components.LitterBoxV2 = App.Components.LitterBox.extend({
    template: "#litter-box-v2-template"
});

},{}],787:[function(require,module,exports){
"use strict";

App.Components.LitterBoxV3 = App.Components.LitterBox.extend({
    template: "#litter-box-v3-template"
});

},{}],788:[function(require,module,exports){
"use strict";

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.LitterBox = Vue.extend({
    template: "#litter-box-template",
    data: function data() {
        return {
            activeKit: {},
            kits: [],
            diedKits: [],
            fosteredKits: [],
            foster: null,
            soldValue: 0,
            littersLoading: 1,
            kitsLoading: 1,
            transferTo: "",
            transferErrors: null,
            limitContent: {
                title: "You have exceeded the maximum amount of breeders",
                message: "Please upgrade your account to add more!",
                meta: {}
            },
            withArchivedLitter: false
        };
    },
    props: ['litter', 'activeLitter', 'litters', 'isBreederProfile', "cage", "isCage", "showKits"],
    components: {},
    watch: {
        litters: function litters(value) {
            if (value) {
                this.littersLoading = 0;
            }
        },
        showKits: function showKits(value) {
            var _this = this;

            this.kits = value;
            this.kitsLoading = 0;

            this.$nextTick(function () {
                _this.initializePopovers();
            });
        }
    },
    computed: {
        modalUnique: function modalUnique() {
            return 'litter-box';
        },
        deathModalUnique: function deathModalUnique() {
            return 'litter-box';
        },
        confirmTarget: function confirmTarget() {
            return this.activeKit.name || 'this kit';
        },
        age_days: function age_days() {
            var born = App.parseMoment(this.litter.born);
            var now = moment().startOf('day');
            var days;
            if (this.litter.butchered_at) {
                var butchered = moment(this.litter.butchered_at, 'YYYY-MM-DD H:i:s');
                days = butchered.diff(born, "days");
            } else {
                days = now.diff(born, "days");
            }

            return days <= 0 ? "Today" : days + ' days';
        },
        aliveDiedKits: function aliveDiedKits() {
            return [].concat((0, _toConsumableArray3.default)(this.kits), (0, _toConsumableArray3.default)(this.diedKits));
        }
    },
    events: {
        'cancel-death-reason': function cancelDeathReason() {
            this.refreshKits();
        },
        'send-death-reason': function sendDeathReason() {
            this.refreshKits();
        }
    },
    methods: {
        filterLitters: function filterLitters(value) {
            if (this.withArchivedLitter) {
                return true;
            }

            return !value.archived;
        },
        refreshKits: function refreshKits() {
            this.$dispatch('refresh-kits', this.activeKit);
            this.getKits();
        },

        getGenderClass: function getGenderClass(kit) {
            if (kit.sold_at) {
                return 'bg-green';
            }
            if (this.isArchived(kit) || this.isCulled(kit)) {
                return "bg-gray";
            }
            if (!kit.sex || this.isButchered(kit)) {
                return "bg-gray-active";
            }
            if (kit.improved == 1) {
                return "bg-gray-active";
            }
            return kit.sex === "buck" ? "bg-aqua" : "bg-maroon";
        },
        getKits: function getKits() {
            var _this2 = this;

            this.kitsLoading = 1;
            var fetch = function fetch() {};

            if (this.isCage) {
                fetch = api.getCageKits(this.cage.id);
            } else {
                fetch = api.getLitterKits(this.litter.id);
            }

            fetch.then(function (kits) {
                _this2.kits = kits;
                var alive = 0;
                $.each(kits, function (i, val) {
                    if ((val.alive == 1 || val.improved == 1) && val.archived == 0) {
                        alive++;
                    }
                });
                _this2.$dispatch('alive-kits', alive);

                _this2.kitsLoading = 0;

                _this2.$nextTick(function () {
                    _this2.initializePopovers();
                });
            });

            if (!this.isCage) {
                api.getLitterDied(this.litter.id).then(function (died) {
                    _this2.diedKits = died;

                    _this2.$nextTick(function () {
                        _this2.initializeDeadKits();
                    });
                });

                api.getLitterFosteredKits(this.litter.id).then(function (data) {
                    _this2.fosteredKits = data;
                });
            }
        },
        showWeights: function showWeights(kit) {
            if (kit) {
                if (kit.weight_unit_short === "lbs-oz") {
                    return kit.weight_slug_array.join(' - ');
                } else if (kit.weight) {
                    return kit.weight.join(' - ') + ' ' + kit.weight_unit_short;
                }
            }
        },

        showNameId: function showNameId(kit) {
            if (kit.name) {
                return kit.name + ': ' + kit.given_id;
            }
            return kit.given_id;
        },

        addKitModal: function addKitModal() {
            this.$dispatch('add-kit', this.litter);
        },

        editKitModal: function editKitModal(kit) {
            this.$dispatch('edit-kit', kit);
        },

        isButchered: function isButchered(kit) {
            return kit.alive == 0 && kit.survived == 1 && kit.improved == 0 && kit.archived != 1 && kit.culled != 1;
        },

        isArchived: function isArchived(kit) {
            return kit.archived == 1;
        },

        isCulled: function isCulled(kit) {
            return kit.culled == 1;
        },

        revive: function revive(kit) {
            var _this3 = this;

            api.reviveKit(kit).then(function () {
                _this3.$dispatch('refresh-kits');
            });
        },
        reviveMultiple: function reviveMultiple() {
            var _this4 = this;

            var isShowSuccess = false;

            _.map(this.diedKits, function (kit) {
                if (kit.alive) {
                    _this4.revive(kit);
                    isShowSuccess = true;
                }
            });

            if (isShowSuccess) {
                this.showAlert({
                    type: 'success',
                    text: 'Successfully revived kits'
                });
            }
            $('#undo-dead-kits-modal-v2').hide();
        },
        showUndoDeadKitsModal: function showUndoDeadKitsModal() {
            $('#undo-dead-kits-modal-v2').show();
        },
        closeReviveKitsModal: function closeReviveKitsModal() {
            this.$broadcast('refresh-kits');
            $('#undo-dead-kits-modal-v2').hide();
        },
        initializeDeadKits: function initializeDeadKits() {
            var _this5 = this;

            $('.dead-kit').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            }).on('ifChecked', function (event) {
                var id = event.target.id.replace('dead-kit-', '');
                _.map(_this5.diedKits, function (kit) {
                    if (kit.id == id) {
                        kit.alive = 1;
                    }
                });
            }).on('ifUnchecked', function (event) {
                var id = event.target.id.replace('dead-kit-', '');
                _.map(_this5.diedKits, function (kit) {
                    if (kit.id == id) {
                        kit.alive = 0;
                    }
                });
            });
        },


        showFosterLittersModal: function showFosterLittersModal(kit) {
            this.foster = kit.litter_id ? kit.litter_id : this.litter.id;
            this.activeKit = kit;
            $('#foster-litter-modal-' + this.modalUnique).modal('show');
        },
        fosterUpdate: function fosterUpdate() {
            var _this6 = this;

            var datastring = { 'kit_id': this.activeKit.id, 'litter_id': this.foster };
            api.getKitPedigree(this.activeKit.id).then(function (data) {
                _this6.$http.post('/admin/foster-update', datastring, function (data) {
                    $('#foster-litter-modal-' + _this6.modalUnique).modal('hide');
                    _this6.refreshKits();
                });
            });
        }
    },
    ready: function ready() {
        var _this7 = this;

        if (this.showKits) {
            this.kits = this.showKits;
            this.kitsLoading = 0;

            this.$nextTick(function () {
                _this7.initializePopovers();
            });

            return;
        }

        this.getKits();

        var model = this.isCage ? this.cage : this.litter;
        this.$on('refresh-kits-global', function (id) {
            if (id == model.id) {
                this.getKits();
            }
        });
    },
    mixins: [App.Mixins.Butcherable, App.Mixins.DeathReason, App.Mixins.DateHelper, App.Mixins.Transferable, App.Mixins.Litters, App.Mixins.Generic, App.Mixins.FieldDescription, App.Mixins.Alerts, App.Mixins.Kits]
});

},{"../event-bus":882,"babel-runtime/helpers/toConsumableArray":41}],789:[function(require,module,exports){
'use strict';

App.Components.LitterButcher = {
    template: "#litter-butcher-template",
    data: function data() {
        return {
            errors: {},
            date: moment(new Date()).format(App.dateFormat),
            loaded: 0,
            current: 0,
            selectedLitter: 0,
            currency: '',
            loading: false,
            isEntireLitter: false,
            entireLitter: {
                current_weight: 0,
                butcher_weight: 0,
                butcher_value: 0
            }
        };
    },
    props: ['litters', 'litter', 'kits', 'filterKit', 'isGlobal'],
    components: {
        'lbs-oz-input': App.Components.LbsOzInput
    },
    computed: {
        butcherForm: function butcherForm() {
            var form = '#litter-butcher-modal';
            if (this.isGlobal) form = '#global-litter-butcher-modal';

            return form;
        }
    },
    watch: {
        litter: function litter(_litter, old_litter) {
            var _this = this;

            if (_litter && _litter.id) {
                this.selectedLitter = _litter.id;
                $(this.$els.checkall).prop('checked', false);
                if (this.selectedLitter) {
                    api.getLitterKitsWeighOfType(this.selectedLitter, 'rabbitkit').then(function (kits) {
                        _this.kits = kits;
                        _this.filterKits();
                    });
                }
            }
        },
        selectedLitter: function selectedLitter(selected, oldSelected) {
            if (oldSelected || this.litter && !this.litter.id) {
                this.litter = _.find(this.litters, function (item) {
                    return item.id == selected;
                });

                this.resetButcher();
            }
        },
        filterKit: function filterKit(newData) {
            var _this2 = this;

            this.loading = true;
            this.kits = [];
            api.getLitterKitsWeighOfType(this.selectedLitter, 'rabbitkit').then(function (kits) {
                _this2.loading = false;
                _this2.kits = kits;

                if (newData) {
                    _this2.filterKits();
                }
            }, function () {
                _this2.loading = false;
            });
        }
    },
    methods: {
        resetButcher: function resetButcher() {
            this.toggleLayout(false);
            this.entireLitter = {
                current_weight: 0,
                butcher_weight: 0,
                butcher_value: 0
            };
        },
        filterKits: function filterKits() {
            var _this3 = this;

            var filteredKit = _.find(this.kits, function (kit) {
                return kit.id == _this3.filterKit;
            });

            if (filteredKit) {
                this.kits = [filteredKit];
            }
        },
        selectedField: function selectedField(index) {
            this.kits[index].selected = true;
        },
        getGenderClass: function getGenderClass(sex) {
            if (!sex) {
                return "border-gray-active";
            }
            return sex == "buck" ? "border-aqua-v1" : "border-maroon-v1";
        },
        saveEntireLitter: function saveEntireLitter() {
            var count = this.kits.length;
            var current_weight = this.entireLitter.current_weight / count;
            var butcher_weight = this.entireLitter.butcher_weight / count;
            var butcher_value = this.entireLitter.butcher_value / count;

            _.map(this.kits, function (kit) {
                kit.selected = true;
                kit.current_weight = current_weight;
                kit.butcher_weight = butcher_weight;
                kit.butcher_value = butcher_value;
            });

            this.sendToButcher();
        },
        sendToButcher: function sendToButcher() {
            var _this4 = this;

            var selectedKits = _.filter(this.kits, function (kit) {
                return kit.selected;
            });
            var data = {
                kits: selectedKits,
                date: this.date,
                litter_id: this.selectedLitter
            };

            api.butcherKits(data).then(function () {
                _this4.$dispatch('refresh-kits');
                _this4.$dispatch('litter-archived', { litter: _this4.selectedLitter });
                if (selectedKits.length) {
                    // this.$dispatch('litterButchered', {litter_id:this.selectedLitter,butcher_value:22});
                    _this4.$dispatch('reload-tasks', { typeOfTask: 'all', page: null });
                }
            });

            $(this.butcherForm).modal('hide');
            if (this.isGlobal) this.$root.$emit('global-notification-tab-reload');
        },

        getOptionTitle: function getOptionTitle(item) {
            var title = '';

            if (item) {
                if (item.parents && item.parents.length > 1) {
                    title += item.parents[0].name + '+' + item.parents[1].name;
                }

                title += ' - ' + item.given_id;
            }

            return title;
        },
        initWeighType: function initWeighType() {
            var _this5 = this;

            $("#butcher-type-switch" + this.globalSuffix).netlivaSwitch({
                width: "35px"
            }).on("netlivaSwitch.change", function (event, state, element) {
                _this5.isEntireLitter = state;
            });
        },
        toggleLayout: function toggleLayout() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            $("#butcher-type-switch" + this.globalSuffix).netlivaSwitch('state', state);
            this.isEntireLitter = state;
        }
    },
    ready: function ready() {
        this.initWeighType();
        $(this.$els.checkall).on('click', function () {
            if (this.checked) {
                $('.js_butcher_checkbox').prop('checked', false).trigger('click');
            } else {
                $('.js_butcher_checkbox').prop('checked', true).trigger('click');
            }
        });

        this.currency = App.currency;
    },


    mixins: [App.Mixins.Weightable, App.Mixins.Generic]
};

},{}],790:[function(require,module,exports){
"use strict";

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.LitterForm = {
  template: "#litter-form-template",
  data: function data() {
    return {
      bucks: [],
      does: [],
      breedersList: [],
      errors: {},
      loading: 1,
      newBuck: {
        sex: "buck"
      },
      newDoe: {
        sex: "doe"
      },
      butchered: false,
      isBreedPlan: false,
      addLitterChain: false,
      plans: [],
      planEvents: [],
      activeTemplate: {},
      breedingDoe: {},
      initialized: false
    };
  },

  props: ["litter", "litters", "isGlobal"],
  components: {
    "birth-form": App.Components.BirthFormV2
  },
  events: {
    "set-breeding-doe": function setBreedingDoe(doe) {
      this.breedingDoe = doe;
    }
  },
  watch: {
    isBreedPlan: function isBreedPlan(newData) {
      if (newData) {
        $(this.litterForm + " #existing-breeding").iCheck("check");
        this.$broadcast("new-birth-modal-open");
      } else {
        $(this.litterForm + " #manual-breeding").iCheck("check");
      }
    },
    litter: function litter(value) {
      if (!value) return;
      this.errors = {};
      this.setFilterBreeders(value.mother_id, value.father_id);
      this.resetArchivedFilterBreeders();
      this.fetchNextLitterId();
      this.butchered = value.butchered;
      if (this.litter.prefix) {
        $("#litter-prefix, #birth-prefix").typeahead("val", this.litter.prefix);
      }
      $("#litter-breed, #birth-breed").typeahead("val", this.litter.breed);
    },


    "litter.mother_id": function litterMother_id() {
      if (this.litter) {
        this.setFilterBreeders(this.litter.mother_id, this.litter.father_id);
        this.fetchNextLitterId();
      }
    },

    "litter.father_id": function litterFather_id() {
      if (this.litter) {
        this.setFilterBreeders(this.litter.mother_id, this.litter.father_id);
      }
    },
    butchered: function butchered(newValue, oldValue) {
      $(this.$els.litter_butchered).iCheck("update");
    },
    activeTemplate: function activeTemplate() {
      this.events = this.activeTemplate.events;
    }
  },
  computed: {
    litterForm: function litterForm() {
      return this.isGlobal ? "#global-litter-form" : "#litter-form";
    }
  },
  methods: {
    scheduleNextBreed: function scheduleNextBreed(doeId) {
      if (!this.isGlobal) {
        $("#birth-schedule-next-modal").modal("hide");
      } else {
        $("#global-birth-schedule-next-modal").modal("hide");
      }

      this.$root.$emit("open-global-breed-form-doe", doeId);
    },
    generateEvents: function generateEvents(date) {
      var _this = this;

      api.getLitterDummyEvents(date).then(function (planEvents) {
        _this.planEvents = planEvents;

        if (App.active_litter_chain_id) {
          _this.activeTemplate = _.find(planEvents, function (plan) {
            return plan.breed_chain.id == App.active_litter_chain_id;
          });
        } else {
          _this.activeTemplate = _.first(planEvents);
        }
      });
    },
    initModal: function initModal() {
      var _this2 = this;

      this.loading = 1;
      this.isBreedPlan = false;
      this.addLitterChain = false;
      var today = moment(new Date()).format(App.dateFormat);
      this.generateEvents(today);

      api.getBreedersList().then(function (breeders) {
        _this2.loading = 0;
        _this2.bucks = breeders.bucks;
        _this2.does = breeders.does;
      });

      this.initBreedTypeahead();

      api.getLittersList().then(function (litters) {
        var prefixes = _this2.uniqueFieldSet(litters, "prefix");

        $("#litter-prefix, #birth-prefix").typeahead({
          hint: true,
          highlight: true,
          minLength: 0
        }, {
          source: _this2.substringMatcher(prefixes)
        });
      });

      if (!this.litter.id) {
        this.litter.prefix = App.default_prefix;
        $("#litter-prefix, #birth-prefix").typeahead("val", this.litter.prefix);
      }

      $(this.$els.litter_butchered).iCheck({
        checkboxClass: "icheckbox_square-blue",
        radioClass: "iradio_square-blue",
        increaseArea: "20%" // optional
      }).on("ifChecked", function (event) {
        _this2.butchered = true;
      }).on("ifUnchecked", function (event) {
        _this2.butchered = false;
      });

      api.getUsersPlans().then(function (plans) {
        _this2.plans = plans;
      });
    },
    sendLitter: function sendLitter() {
      var _this3 = this;

      this.$validate(true);
      if (this.$activeLitterValidator.touched && this.$activeLitterValidator.invalid) return;

      if (isNaN(this.litter.kits_amount)) {
        this.$activeLitterValidator.kits_amount.touched = true;
        this.$activeLitterValidator.kits_amount.invalid = true;
        this.$activeLitterValidator.kits_amount.error_msg = "The Kits must be an integer.";
        return false;
      }

      this.loading = 1;
      this.litter.animal_type = "rabbit";
      this.litter.butchered = this.butchered;

      this.litter._method = this.litter.id != 0 ? "PUT" : "POST";

      var litter = (0, _assign2.default)({}, this.litter);

      if (Array.isArray(litter.notes)) {
        litter.notes = (0, _stringify2.default)(litter.notes);
      }

      if (this.litter.id == 0 && this.addLitterChain) {
        litter.breed_chain_id = this.activeTemplate.breed_chain.id;
      }

      api.saveLitter(litter).then(function (data) {
        _this3.loading = 0;
        $(_this3.litterForm).modal("hide");
        if (litter.id == 0) {
          data.archived = 0;
          _this3.litters.push(data);

          // schedule next breeding
          _this3.breedingDoe = { id: litter.mother_id };
          if (!_this3.isGlobal) {
            $("#birth-schedule-next-modal").modal("show");
          } else {
            $("#global-birth-schedule-next-modal").modal("show");
          }
        } else {
          _this3.litter = data;
          _this3.litter.butchered_date = moment(_this3.litter.butchered_at, "YYYY-MM-DD H:i:s").format(App.dateFormat);
        }
        _this3.$dispatch("litter-updated", _this3.litter.id);
      }, function (response) {
        _this3.loading = 0;
        _this3.errors = response.data.errors;
      });
    },
    addNewBuck: function addNewBuck() {
      var _this4 = this;

      this.loading = 1;
      api.saveBreeder(_.extend({}, App.emptyBreeder, this.newBuck)).then(function (data) {
        _this4.loading = 0;
        if (data.id) {
          _this4.bucks.push(data);
          _this4.litter.father_id = data.id;
          _this4.newBuck = { sex: "buck" };
        }
      });
    },
    addNewDoe: function addNewDoe() {
      var _this5 = this;

      this.loading = 1;
      api.saveBreeder($.extend({}, App.emptyBreeder, this.newDoe)).then(function (data) {
        _this5.loading = 0;
        if (data.id) {
          _this5.does.push(data);
          _this5.litter.mother_id = data.id;
          _this5.newDoe = { sex: "doe" };
        }
      });
    },
    initBreedTypeahead: function initBreedTypeahead() {
      this.breedersList = this.getBreedersAutocompleteList();
    },
    initializeRadioButtons: function initializeRadioButtons() {
      var _this6 = this;

      var iCheckClass = {
        checkboxClass: "icheckbox_square-blue",
        radioClass: "iradio_square-blue",
        inheritClass: true
      };

      $(this.litterForm + " #existing-breeding").iCheck(iCheckClass).on("ifChecked", function (event) {
        _this6.isBreedPlan = true;
      });

      $(this.litterForm + " #manual-breeding").iCheck(iCheckClass).on("ifChecked", function (event) {
        _this6.isBreedPlan = false;
      });

      $(this.litterForm + " #add-litter-chain").iCheck(iCheckClass).on("ifChecked", function (event) {
        _this6.addLitterChain = true;
      }).on("ifUnchecked", function (event) {
        _this6.addLitterChain = false;
      });

      $(this.litterForm + " #manual-breeding").iCheck("check");
    },
    fetchNextLitterId: function fetchNextLitterId() {
      var _this7 = this;

      if (App.generateLitterIdFlag && !this.litter.id) {
        api.getNextLitterId({ breeder_id: this.litter.mother_id }).then(function (response) {
          _this7.$set("litter.given_id", response.nextLitterId);
        });
      }
    }
  },
  ready: function ready() {
    var self = this;
    self.initializeRadioButtons();

    $(this.litterForm).on('show.bs.modal', function () {
      if (!self.initialized) {
        self.initModal();

        self.initialized = true;
      }
    });
  },

  mixins: [App.Mixins.BreedersFilter, App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.FieldDescription]
};

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22}],791:[function(require,module,exports){
"use strict";

App.Components.LitterProfileReports = Vue.extend({
  template: "#litter-profile-reports-template",
  data: function data() {
    var _this = this;

    return {
      loadingStatics: 1,
      loadingReportsData: 1,
      statistics: {},
      weightSlug: "",
      weightData: [],
      report_date_range: {
        from: null,
        to: null
      },
      show: {
        production: true,
        kitsStatus: true
      },
      datasets: {
        production: [],
        kitsStatus: []
      },
      labels: {
        production: [],
        kitsStatus: []
      },
      options: {
        production: {
          tooltips: {
            enabled: true,
            mode: "single",
            callbacks: {
              title: function title(tooltipItem, data) {
                return data.datasets[tooltipItem[0].datasetIndex].data[tooltipItem[0].index].title;
              },
              label: function label(tooltipItem, data) {
                return _this.showWeights(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y, _this.weightSlug);
              }
            }
          },
          legend: {
            display: false
          },
          legendCallback: function legendCallback(chart) {
            var text = [];
            text.push('<ul class="chart-legend inline">');

            if (chart.data.datasets.length) {
              for (var i = 0; i < chart.data.datasets.length; ++i) {
                var color = chart.data.datasets[i].borderColor;
                text.push("<li>\n                    <i class=\"fa fa-circle\"\n                    style=\"color:" + color + ";cursor:pointer;\"\n                    ></i> \n                  ");
                if (chart.data.datasets[i].data[0].title) {
                  text.push(_this.capitalize(chart.data.datasets[i].data[0].title));
                }
                text.push("</li>");
              }
            }

            text.push("</ul>");

            return text.join("");
          },
          scales: {
            yAxes: [{
              ticks: {
                callback: function callback(value, index, values) {
                  if (_this.weightSlug === "lbs-oz") {
                    return Math.round(value / 16);
                  } else if (_this.weightSlug === "lbs") {
                    return value;
                  }
                  return Math.round(value * 100) / 100;
                },
                beginAtZero: true,
                min: 0
              },
              scaleLabel: {
                display: true,
                labelString: "Weight (" + App.weight_units + ")",
                fontStyle: "bold"
              }
            }],
            xAxes: [{
              id: "xAxis1",
              type: "linear",
              ticks: {
                callback: function callback(label) {
                  return label;
                },
                autoSkip: true,
                maxTicksLimit: 20,
                beginAtZero: true,
                min: 0
              },
              scaleLabel: {
                display: true,
                labelString: "Age (Days)",
                fontStyle: "bold"
              }
            }]
          }
        },
        kitsStatus: {
          tooltips: {
            enabled: true,
            mode: "single",
            callbacks: {
              title: function title() {},
              label: function label(tooltipItem, data) {
                var item = data.datasets[tooltipItem.datasetIndex];
                var id = tooltipItem.index;
                return _this.capitalize(item.key[id]) + " (" + item.data[id] + " / " + item.percentage[id].toFixed() + "%)";
              }
            }
          },
          legend: {
            display: false
          },
          legendCallback: function legendCallback(chart) {
            var text = [];
            text.push('<ul class="' + chart.id + '-legend">');

            if (chart.data.datasets.length) {
              for (var i = 0; i < chart.data.datasets[0].data.length; ++i) {
                text.push('<li><i class="fa fa-circle item-' + chart.data.labels[i] + '"></i> ');
                if (chart.data.labels[i]) {
                  text.push(_this.capitalize(chart.data.labels[i]));
                  text.push(" (" + chart.data.datasets[0].data[i] + " / " + chart.data.datasets[0].percentage[i].toFixed() + "%)");
                }
                text.push("</li>");
              }
            }

            text.push("</ul>");

            return text.join("");
          }
        }
      },
      colours: ["red", "green", "yellow", "aqua", "light-blue", "teal", "purple", "maroon", "orange", "black"],
      productionFilter: "day",
      productionData: {},
      kitsStatus: {}
    };
  },
  props: ["litter"],
  computed: {},
  components: {
    "line-chart": App.Components.LineChart
  },
  events: {
    "load-litter-profile-reports": function loadLitterProfileReports() {
      var _this2 = this;

      this.loadingStatics = 1;

      var data = {};

      if (this.report_date_range[0] && this.report_date_range[1]) {
        data = this.setDateFromDateRangePicker(this.report_date_range);
      }

      data.id = this.litter.id;

      api.getLitterProfileStatistics(data).then(function (data) {
        _this2.loadingStatics = 0;
        _this2.statistics = data.statistics;
        _this2.weightSlug = data.weightSlug;
        _this2.kitsStatus = data.kitsStatus || {};

        _this2.loadReportsData();
      });
    }
  },
  watch: {
    report_date_range: function report_date_range() {
      this.datasets = {
        production: []
      };
      this.labels = {
        production: []
      };
      this.$emit("load-litter-profile-reports");
    }
  },
  methods: {
    loadReportsData: function loadReportsData() {
      var _this3 = this;

      this.loadingReportsData = 1;

      var data = {};

      if (this.report_date_range[0] && this.report_date_range[1]) {
        data = this.setDateFromDateRangePicker(this.report_date_range);
      }

      data.id = this.litter.id;

      api.getLitterProfileReportsData(data).then(function (data) {
        _this3.loadingReportsData = 0;
        _this3.weightData = data;

        if (!_.isEmpty(_this3.weightData)) {
          _this3.calculateKitStatus();
          _this3.fetchLitterProductionData();
        } else {
          for (var key in _this3.show) {
            if (_this3.show.hasOwnProperty(key)) {
              _this3.show[key] = false;
            }
          }
        }

        _this3.$nextTick(function () {
          $("#report-date-range").trigger("triggerDaterangepicker");
        });
      });
    },
    showProduction: function showProduction() {
      var data = this.productionData[this.productionFilter];

      this.show.production = data.datasets ? data.datasets.length > 0 : false;
      this.labels.production = data.labels || [];
      this.datasets.production = data.datasets || [];
    },


    setDateFromDateRangePicker: function setDateFromDateRangePicker(daterange) {
      return {
        from: daterange[0].format("YYYY-MM-DD"),
        to: daterange[1].format("YYYY-MM-DD")
      };
    },
    clickDateRange: function clickDateRange() {
      $(this.$els.dateRangeInput).click();
    },
    calculateKitStatus: function calculateKitStatus() {
      var datasets = [{
        data: [],
        backgroundColor: [],
        key: [],
        percentage: []
      }];

      var colors = {
        active: "#03985d",
        breeder: "#009BC2",
        butchered: "#F72728",
        sold: "#00DDC5",
        died: "#DA0F5C",
        culled: "#964EFF",
        archived: "#FF8900"
      };

      if (!this.statistics.kitsTotal) {
        this.show.kitsStatus = false;
        return;
      }

      _.map(this.kitsStatus, function (item, key) {
        datasets[0].data.push(item.count);
        datasets[0].backgroundColor.push(colors[key] || colors.active);
        datasets[0].key.push(key);
        datasets[0].percentage.push(item.percentage);
      });

      this.show.kitsStatus = datasets[0].data.length > 0;
      this.labels.kitsStatus = datasets[0].key;
      this.datasets.kitsStatus = datasets;
    },
    setProductionFilter: function setProductionFilter() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "day";

      this.setProductionLabel(filter);
      this.productionFilter = filter;
      this.showProduction();
    },
    setProductionLabel: function setProductionLabel() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "day";

      switch (filter) {
        case "month":
          this.options.production.scales.xAxes[0].scaleLabel.labelString = "Age (Months)";
          break;
        case "week":
          this.options.production.scales.xAxes[0].scaleLabel.labelString = "Age (Weeks)";
          break;
        case "day":
        default:
          this.options.production.scales.xAxes[0].scaleLabel.labelString = "Age (Days)";
      }
    },
    fetchLitterProductionData: function fetchLitterProductionData() {
      var _this4 = this;

      this.loadingReportsData = 1;
      var data = {};

      if (this.report_date_range[0] && this.report_date_range[1]) {
        data = this.setDateFromDateRangePicker(this.report_date_range);
      }

      api.getLitterProductionData(data, this.litter.id).then(function (data) {
        _this4.loadingReportsData = 0;
        _this4.productionData = data.datasets;
        _this4.showProduction();

        _this4.$nextTick(function () {
          this.$broadcast("show-chart");
        });
      });
    },

    capitalize: function capitalize(string) {
      return string.replace(/^./, function (match) {
        return match.toUpperCase();
      });
    }
  },
  ready: function ready() {},
  mixins: [App.Mixins.Currency, App.Mixins.Reports, App.Mixins.Weightable, App.Mixins.Butcherable]
});

},{}],792:[function(require,module,exports){
"use strict";

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.emptyKit = {
    "id": 0,
    "given_id": '',
    "litter_id": 0,
    "original_litter_id": 0,
    "prefix": '',
    "name": '',
    "breed": '',
    "sex": 'doe',
    "current_weight": '',
    "color": '',
    "image": {
        "name": '',
        "path": '',
        "temp": true,
        "oldImage": '',
        "delete": false
    },
    "images": [],
    "notes": '',
    "level": ''
};

App.Components.LitterProfile = Vue.extend({
    template: "#litter-profile-template",
    data: function data() {
        return {
            breeder: {
                image: {},
                images: {}
            },
            litter: {
                id: this.$route.params.id,
                parents: []
            },
            litters: [],
            activeLitter: {},
            activeKit: {},
            activeTask: {},
            activeKits: [],
            filterKit: [],
            litterLoad: false,
            aliveKitsAmount: null,
            activeTimeline: [],
            tasksType: '',
            plans: [],
            activeBirth: {},
            activeSex: null,

            // Cage card template.
            template: {},
            alltemplates: {},
            profileid: 0,

            // Notes
            newNote: null,
            noteIndexToEdit: {},
            noteIndexToDelete: {},
            btn_name: [],
            noteError: "",
            currentTab: "kits",
            loading: 0
        };
    },
    props: [],
    computed: {
        confirmTarget: function confirmTarget() {
            return "this litter";
        },
        aliveKits: function aliveKits() {
            return this.aliveKitsAmount != null ? this.aliveKitsAmount : ""; /*litter.kits_amount - litter.kits_died*/
        },
        isEmptyTimeline: function isEmptyTimeline() {
            return !this.activeTimeline.length || !this.activeTimeline[0].length;
        }
    },
    components: {
        'schedule-tasks': App.Components.ScheduleTasks,
        'kit-form': App.Components.KitForm,
        'litter-box': App.Components.LitterBox,
        'litter-box-v3': App.Components.LitterBoxV3,
        'litter-form': App.Components.LitterForm,
        'litter-weight': App.Components.LitterWeight,
        'litter-butcher': App.Components.LitterButcher,
        'breeder-images-form': App.Components.BreederImagesForm,
        'task-form': App.Components.TaskForm,
        'ledger-table': App.Components.LedgerTable,
        "ledger-table-v2": App.Components.LedgerTableV2,
        'cage-cards-print': App.Components.CageCardsPrint,
        'litter-profile-reports': App.Components.LitterProfileReports,
        'litter-sell': App.Components.LitterSell
    },
    watch: {
        litter: function litter() {
            this.parseNotes();
        },
        loading: function loading(newValue) {
            console.log('loading', newValue);
        }
    },
    events: {
        'litter-updated': function litterUpdated(msg) {
            this.$broadcast('refresh-kits-global', this.litter.id);
        },
        'butcher-kit': function butcherKit(kit) {
            this.filterKit = kit.id;
            $('#litter-butcher-modal').modal('show');
        }
    },
    methods: {
        activeTab: function activeTab(tab) {
            if (tab == 0) {
                $('.litter_help_btn').css('display', 'block');
                $('.task_help_btn').css('display', 'none');
                $('.ledger_help_btn').css('display', 'none');
            } else if (tab == 1) {
                $('.task_help_btn').css('display', 'block');
                $('.litter_help_btn').css('display', 'none');
                $('.ledger_help_btn').css('display', 'none');
            } else if (tab == 2) {
                $('.ledger_help_btn').css('display', 'block');
                $('.task_help_btn').css('display', 'none');
                $('.litter_help_btn').css('display', 'none');
            }
        },

        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        loadLitter: function loadLitter() {
            var _this = this;

            api.getLitter(this.litter.id).then(function (res) {
                _this.litter = res;
                if (res.butchered_at) {
                    _this.butchered = true;
                    _this.litter.butchered_date = moment(_this.litter.butchered_at, 'YYYY-MM-DD H:i:s').format(App.dateFormat);
                }
                _this.litterLoad = true;
            });
        },
        loadAllLitters: function loadAllLitters() {
            var _this2 = this;

            api.getLittersList({ all: 1 }).then(function (data) {
                _this2.litters = data;
            });
        },
        loadReports: function loadReports() {
            this.$broadcast('load-litter-profile-reports');
        },
        updateSettings: function updateSettings() {},
        addKit: function addKit(litter) {
            var kitId = litter.kits_amount + 1;
            this.activeKit = _.extend({}, App.emptyKit);
            kitId = kitId < 100 ? '0' + kitId : kitId;
            this.activeKit.given_id = litter.id + kitId;
            this.activeKit.litter_id = litter.id;
            this.activeKit.original_litter_id = litter.id;
            this.activeKit.prefix = litter.prefix || App.default_prefix;
            this.activeKit.breed = litter.breed || App.default_breed;

            var form = $('#kit-form-modal');
            form.modal({
                backdrop: 'static',
                keyboard: false
            });
            form.modal('show');
            App.emptyLitter.breed = App.default_breed;
        },
        editKit: function editKit(kit) {
            this.activeKit = kit;
            var form = $('#kit-form-modal');
            form.modal({
                backdrop: 'static',
                keyboard: false
            });
            form.modal('show');
        },
        refreshKits: function refreshKits() {
            this.loadLitter();
            $('#kit-form-modal').modal('hide');
            this.$broadcast('refresh-kits-global', this.litter.id);
        },

        father: function father() {
            return _.find(this.litter.parents, function (item) {
                return item.sex === "buck";
            });
        },
        mother: function mother() {
            return _.find(this.litter.parents, function (item) {
                return item.sex === "doe";
            });
        },

        updateAlive: function updateAlive(data) {
            this.aliveKitsAmount = data;
        },

        editModal: function editModal() {
            var self = this;
            var form = $('#litter-form');
            form.modal({
                backdrop: 'static',
                keyboard: false
            });
            form.modal('show');
            $(document).one('hide.bs.modal', '#litter-form', function (event) {
                if ($(event.target).is('#litter-form')) {
                    self.loadLitter();
                }
            });
        },

        weightModal: function weightModal() {
            var _this3 = this;

            this.activeLitter = _.extend({}, this.litter);
            api.getLitterKitsWeighOfType(this.litter.id, 'rabbitkit').then(function (kits) {
                _this3.activeKits = kits;
            });
            $('#litter-weight-modal').modal('show');
        },
        sellModal: function sellModal() {
            var _this4 = this;

            this.activeLitter = _.extend({}, this.litter);
            api.getLitterKitsWeighOfType(this.litter.id, 'rabbitkit').then(function (kits) {
                _this4.activeKits = kits;
            });
            $('#litter-sell-modal').modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#litter-sell-modal').modal('show');
        },

        butcherModal: function butcherModal(litter) {
            this.filterKit = null;
            $('#litter-butcher-modal').modal('show');
        },

        undoButcherModal: function undoButcherModal(litter) {
            $('#undo-butcher-breed-modal').modal('show');
        },
        undoButcher: function undoButcher() {
            var _this5 = this;

            $('#undo-butcher-breed-modal').modal('hide');
            var data = {
                litter_id: this.litter.id
            };

            api.undoButcheredKits(this.litter, data).then(function () {
                _this5.litter.butchered = 0;
                _this5.refreshKits();
            });
        },

        archiveModal: function archiveModal() {
            $('#archive-breed-modal').modal('show');
        },
        archive: function archive() {
            var _this6 = this;

            $('#archive-breed-modal').modal('hide');
            api.archiveLitter(this.litter).then(function () {
                _this6.$router.go({ path: '/litters' });
            });
        },

        unarchiveModal: function unarchiveModal() {
            $('#unarchive-breed-modal').modal('show');
        },
        unarchive: function unarchive() {
            var _this7 = this;

            $('#unarchive-breed-modal').modal('hide');
            api.unarchiveLitter(this.litter).then(function () {
                _this7.$router.go({ path: '/litters' });
            });
        },

        deleteModal: function deleteModal() {
            $('#delete-breed-modal').modal('show');
        },

        delete: function _delete() {
            var _this8 = this;

            $('#delete-breed-modal').modal('hide');
            api.deleteLitter(this.litter).then(function () {
                _this8.$router.go({ path: '/litters' });
            });
        },

        getTimeLeft: function getTimeLeft(task) {
            var oToday = new Date();
            var oDeadLineDate = new Date(task.date);
            var nDaysLeft = oDeadLineDate > oToday ? Math.ceil((oDeadLineDate - oToday) / (1000 * 60 * 60 * 24)) : null;
            if (!nDaysLeft) return 'Today';

            if (nDaysLeft == 1) return nDaysLeft + ' day';
            return nDaysLeft + ' days';
        },
        birthModal: function birthModal() {
            var _this9 = this;

            api.getUsersPlans().then(function (plans) {
                _this9.plans = plans;
            });
            this.activeBirth = { breedplan: '-1', born: moment(new Date()).format(App.dateFormat) };
        },
        recordBirth: function recordBirth() {
            var _this10 = this;

            api.recordBirth(this.activeBirth).then(function () {
                _this10.activeBirth = {};
                $('#birth').modal('hide');
            });
        },

        openTaskForm: function openTaskForm(task) {
            this.activeTask = task;
            this.$broadcast('tasks-managing', task);
        },

        openOwnerTaskForm: function openOwnerTaskForm(task) {
            var newTask = {};
            newTask.type = 'litter';
            newTask.relation = {};
            newTask.relation.id = this.litter.id;
            this.$broadcast('tasks-managing', task, newTask);
        },

        showRequestForm: function showRequestForm(task) {
            this.activeTask = task;
            $('#delete_task').modal('show');
        },

        loadLedger: function loadLedger() {
            this.$broadcast('load_ledger');
        },

        editFatherImages: function editFatherImages() {
            this.breeder = this.father();
            this.$broadcast('breeder-images-edit');
        },

        editMotherImages: function editMotherImages() {
            this.breeder = this.mother();
            this.$broadcast('breeder-images-edit');
        },

        /**
         * Cage card.
         */
        cageCard: function cageCard() {
            var _this11 = this;

            var request = { type: 'litter' };
            this.template = {};

            api.getCageCardsTemplates(request).then(function (data) {
                _this11.alltemplates = data.templates;
            });

            this.profileid = this.litter.id;

            $('#cage-cards-print-modal').modal('show');
        },

        // function for notes
        updateNotes: function updateNotes() {
            var _this12 = this;

            var litter = (0, _assign2.default)({}, this.litter);

            litter.notes = (0, _stringify2.default)(litter.notes);
            litter.is_notes_update = 1;
            this.loading = 1;
            api.saveLitter(litter).then(function (data) {
                _this12.loading = 0;
                if (litter.id == 0) {
                    data.archived = 0;
                    _this12.litters.push(data);
                } else {
                    _this12.litter = data;
                    _this12.litter.butchered_date = moment(_this12.litter.butchered_at, 'YYYY-MM-DD H:i:s').format(App.dateFormat);
                }
                _this12.$dispatch('litter-updated', _this12.litter.id);
                _this12.newNote = "";
            }, function (response) {
                _this12.loading = 0;
                _this12.errors = response.data.errors;
                _this12.newNote = "";
            });
        },
        parseNotes: function parseNotes() {
            var arr = [];

            if (this.litter.notes) {
                try {
                    if (isNaN(this.litter.notes)) {
                        arr = JSON.parse(this.litter.notes);
                    } else {
                        arr.push(this.litter.notes);
                    }
                } catch (err) {
                    arr.push(this.litter.notes);
                }
            }

            this.litter.notes = arr;
        },
        addNote: function addNote() {
            if (this.newNote == "" || this.newNote == null) {
                this.noteError = "You can't add empty notes.";
                return false;
            }

            var newNote = this.sanitizeNote(this.newNote);
            this.litter.notes.push(newNote);
            this.litter.new_notes.push({ value: newNote, date: moment().format('YYYY-MM-DD') });

            this.updateNotes();
        },
        sanitizeNote: function sanitizeNote() {
            var note = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            return note.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        },

        editNote: function editNote() {
            this.litter.notes.$set(this.noteIndexToEdit.num, this.noteIndexToEdit.note);

            this.updateNotes();

            this.noteIndexToEdit = {
                index: -1,
                note: ''
            };
        },
        deleteNoteModal: function deleteNoteModal(index, note) {
            this.noteIndexToDelete = {
                index: index,
                note: note
            };
            $('#delete-note-modal').modal('show');
        },
        deleteNote: function deleteNote() {
            this.litter.notes.splice(this.noteIndexToDelete.index, 1);
            this.updateNotes();
            this.noteIndexToDelete = {
                index: -1,
                note: ''
            };
            $('#delete-note-modal').modal('hide');
        },
        setNote: function setNote(note, index) {
            this.noteIndexToEdit = {
                note: note,
                num: index
            };
        },
        initTabs: function initTabs() {
            var self = this;
            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                var target = $(e.target).attr("href");
                target = target.replace("#", "");

                self.currentTab = target;
            });
        }
    },
    ready: function ready() {
        App.MobileTypes();
        this.loadLitter();
        this.loadAllLitters();
        this.birthModal();
        this.initTabs();

        var action = localStorage.getItem('action');
        if (action === "edit") this.editModal();else if (action === "cageCard") this.cageCard();

        localStorage.removeItem('action');

        this.hideEmptyTimeline();

        this.getCurrentData();

        $('.litter_help_btn').css('display', 'block');
        $('.ledger_help_btn').css('display', 'none');
        $('.task_help_btn').css('display', 'none');
    },
    mixins: [App.Mixins.Butcherable, App.Mixins.Litters, App.Mixins.Generic]
});

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22}],793:[function(require,module,exports){
"use strict";

App.Components.LitterSell = {
  template: "#litter-sell-template",
  data: function data() {
    return {
      bucks: [],
      does: [],
      errors: {},
      date: moment(new Date()).format(App.dateFormat),
      activeKit: {},
      loaded: 0,
      selectedLitter: 0,
      soldKits: [],
      saving: false,
      isEntireLitter: false,
      entireLitterValue: 0,
      transferTo: "",
      transferErrors: {}
    };
  },

  props: ["litters", "litter", "kits", "isGlobal"],
  components: {
    "image-upload": App.Components.ImageUpload,
    "sex-select": App.Components.SexSelect,
    "lbs-oz-input": App.Components.LbsOzInput
  },
  computed: {
    actualKitsCount: function actualKitsCount() {
      return this.kits.length;
    },
    averageKitsSale: function averageKitsSale() {
      var sale = this.actualKitsCount ? this.entireLitterValue / this.actualKitsCount : 0;

      return this.currencySign() + " " + sale.toFixed(2);
    },
    isDisableSave: function isDisableSave() {
      if (this.isEntireLitter) {
        return !(this.isEntireLitter && this.entireLitterValue);
      } else {
        return this.kits && this.kits.length != this.soldKits.length;
      }
    }
  },
  watch: {
    litter: function litter() {
      var _this = this;

      if (this.litter && this.litter.id) {
        api.getLitterKitsWeighOfType(this.litter.id, "rabbitkit").then(function (kits) {
          _this.kits = kits;
        });
        this.selectedLitter = this.litter.id;
      }
    },
    selectedLitter: function selectedLitter(a, b) {
      this.litter = _.find(this.litters, function (item) {
        return item.id == this.selectedLitter;
      }.bind(this));

      this.soldKits = [];
      this.transferTo = "";
      this.transferErrors = {};
    },
    kits: function kits() {
      this.loaded = 1;
      this.activeKit = this.kits[0];
      this.entireLitterValue = 0;
    },
    transferTo: function transferTo() {
      this.transferErrors = {};
    }
  },
  methods: {
    getGenderClass: function getGenderClass(sex) {
      if (!sex) {
        return "bg-gray-active";
      }
      return sex == "buck" ? "bg-aqua" : "bg-maroon";
    },
    saveSale: function saveSale(kit) {
      var isSold = _.find(this.soldKits, function (item) {
        return item.id == kit.id;
      });
      if (!isSold) {
        this.soldKits.push(kit);
      }
    },
    sellALl: function sellALl() {
      if (this.isEntireLitter) {
        this.sellEntireLitter();
      } else {
        this.presellLitter();
      }
    },
    sellEntireLitter: function sellEntireLitter() {
      var count = this.kits.length;
      var value = this.entireLitterValue / count;

      _.map(this.kits, function (kit) {
        kit.sale_value = value;
      });

      this.presellLitter();
    },
    presellLitter: function presellLitter() {
      var _this2 = this;

      this.saving = true;
      var data = {
        date: this.date,
        kits: this.kits,
        transfer_to: this.transferTo
      };

      if (this.transferTo && this.transferTo != "add") {
        // verify if the email is valid
        api.verifyTransferableKit(this.kits[0], this.transferTo).then(function () {
          _this2.sellLitter(data);
        }, function (error) {
          // show errors on form
          _this2.transferErrors = error.data.errors;
          _this2.saving = false;
        });
      } else {
        this.sellLitter(data);
      }
    },
    sellLitter: function sellLitter(data) {
      var _this3 = this;

      api.postLitterSell(this.litter, data).then(function () {
        _this3.$dispatch("refresh-kits");
        _this3.$dispatch("weighted");
        _this3.$dispatch("litter-updated");
        _this3.$dispatch("reload-tasks", { typeOfTask: "all", page: null });
        if (!_this3.isGlobal) {
          $("#litter-sell-modal").modal("hide");
        } else {
          $("#global-sell-weight-modal").modal("hide");
        }
        _this3.showAlert({
          type: 'success',
          text: _this3.litter.given_id + "'s kits has been sold."
        });
        _this3.refreshForm();
        _this3.saving = false;
      }, function (response) {
        _this3.$dispatch("refresh-kits");
        _this3.$dispatch("weighted");
        _this3.errors = response.data.errors;
        _this3.saving = false;
      });
    },
    refreshForm: function refreshForm() {
      this.litter = {};
      this.selectedLitter = 0;
      this.entireLitterValue = 0;
      this.transferTo = "";
      this.transferErrors = {};
    },
    getOptionTitle: function getOptionTitle(item) {
      var title = "";

      if (item) {
        if (item.parents && item.parents.length > 1) {
          title += item.parents[0].name + "+" + item.parents[1].name;
        }

        title += " - " + item.given_id;
      }

      return title;
    },
    initSellType: function initSellType() {
      var _this4 = this;

      $("#sell-type-switch").netlivaSwitch({
        width: "35px"
      }).on("netlivaSwitch.change", function (event, state, element) {
        _this4.isEntireLitter = state;
      });
    },
    toggleLayout: function toggleLayout() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      $("#sell-type-switch").netlivaSwitch("state", state);
      this.isEntireLitter = state;
    }
  },
  ready: function ready() {
    this.initSellType();
  },


  mixins: [App.Mixins.Auth, App.Mixins.Contacts, App.Mixins.Transferable, App.Mixins.Currency, App.Mixins.Alerts, App.Mixins.FieldDescription]
};

},{}],794:[function(require,module,exports){
"use strict";

App.Components.LitterWeight = {
  template: "#litter-weight-template",
  data: function data() {
    return {
      bucks: [],
      does: [],
      errors: {},
      date: moment(new Date()).format(App.dateFormat),
      activeKit: {},
      loaded: 0,
      current: 0,
      showNavigator: 1,
      colors: [],
      weights: [],
      generate: false,
      listen: 0,
      changed: -1,
      selectedLitter: 0,
      weighedKits: [],
      saving: false,
      isEntireLitter: false,
      entireLitterWeight: 0
    };
  },
  props: ["litters", "litter", "kits", "isGlobal"],
  components: {
    "image-upload": App.Components.ImageUpload,
    "sex-select": App.Components.SexSelect,
    "lbs-oz-input": App.Components.LbsOzInput
  },
  computed: {
    first: function first() {
      return this.litter.id && !parseFloat(this.litter.total_weight);
    },
    actualKitsCount: function actualKitsCount() {
      return this.kits.length;
    },
    averageKitsWeight: function averageKitsWeight() {
      var weight = this.actualKitsCount ? this.entireLitterWeight / this.actualKitsCount : 0;

      if (this.weightSlug == "lbs-oz") {
        var lbs = weight ? Math.floor(weight / 16) : 0;
        var oz = weight ? parseFloat((weight - lbs * 16).toFixed(3)) : 0;

        return lbs + " lbs " + oz + " oz";
      } else {
        return weight.toFixed(2) + " " + this.weightSlug;
      }
    },
    weightSlug: function weightSlug() {
      return App.weight_slug;
    },
    weightUnits: function weightUnits() {
      return App.weight_units;
    },
    isDisableSave: function isDisableSave() {
      if (this.isEntireLitter) {
        return !(this.isEntireLitter && this.entireLitterWeight);
      } else {
        return this.kits && this.kits.length != this.weighedKits.length;
      }
    },
    weighForm: function weighForm() {
      var form = "#litter-weight-modal";
      if (this.isGlobal) form = "#global-litter-weight-modal";

      return form;
    }
  },
  watch: {
    litter: function litter() {
      var _this = this;

      if (this.litter && this.litter.id) {
        api.getLitterKitsWeighOfType(this.litter.id, "rabbitkit").then(function (kits) {
          _this.kits = kits;
        });
        this.selectedLitter = this.litter.id;
        this.current = 0;
      }
    },
    selectedLitter: function selectedLitter(a, b) {
      this.litter = _.find(this.litters, function (item) {
        return item.id == this.selectedLitter;
      }.bind(this));
    },
    kits: function kits() {
      var self = this;
      this.activeKit = this.kits[this.current];
      this.loaded = 1;
      this.weighedKits = [];
      if (this.first) {
        $.each(this.kits, function (i, kit) {
          if (kit.current_weight) {
            var isWeighed = _.find(self.weighedKits, function (item) {
              return item.id == kit.id;
            });
            if (!isWeighed) {
              self.weighedKits.push(kit);
            }
          }
        });
      }
    },
    current: function current() {
      if (this.kits[this.current]) {
        this.activeKit = this.kits[this.current];
      } else {
        this.current = this.kits.length - 1;
      }
    }
  },
  methods: {
    getGenderClass: function getGenderClass(sex) {
      if (!sex) {
        return "bg-gray-active";
      }
      return sex == "buck" ? "bg-aqua" : "bg-maroon";
    },

    generateIds: function generateIds() {
      var self = this;
      if (this.current == 0 && this.generate) {
        $.each(this.kits, function (i) {
          if (i) {
            this.given_id = isNaN(parseInt(self.kits[0].given_id)) ? self.kits[0].given_id + i : parseInt(self.kits[0].given_id) + i;
          }
        });
      }
    },

    showWeights: function showWeights(kit) {
      if (kit) {
        if (kit.weight && kit.weight.length) {
          if (kit.weight_unit_short === "lbs-oz") {
            return kit.weight_slug_array.join(" - ");
          } else if (kit.weight) {
            return kit.weight.join(" - ") + " " + this.getWeightSlug();
          }
        } else {
          if (kit.weight_unit_short === "lbs-oz" && kit.current_weight) {
            return this.calcLbsOunces(kit.current_weight);
          }
          return (kit.current_weight || 0) + " " + this.getWeightSlug();
        }
      }
    },

    saveAll: function saveAll() {
      this.saving = true;

      if (this.isEntireLitter) {
        this.saveEntireLitter();
      } else {
        if (this.first && this.changed) {
          if (!this.kits.length || this.kits.length == this.weighedKits.length) {
            this.sendKitsFirstWeigh();
          } else {
            this.saveKit(_.extend({}, this.activeKit), this.sendKits.bind(this));
          }
        } else {
          this.sendKits();
        }
      }
    },

    saveEntireLitter: function saveEntireLitter() {
      var _this2 = this;

      this.saving = true;
      var data = {
        date: this.date,
        weight: this.entireLitterWeight
      };

      api.postEntireLitterWeigh(this.litter, data).then(function () {
        _this2.$dispatch("refresh-kits");
        _this2.$dispatch("weighted");
        _this2.$dispatch("reload-tasks", { typeOfTask: "all", page: null });
        $(_this2.weighForm).modal("hide");
        _this2.refreshForm();
        _this2.saving = false;
      }, function (response) {
        _this2.$dispatch("refresh-kits");
        _this2.$dispatch("weighted");
        $(_this2.weighForm).modal("hide");
        _this2.errors = response.data.errors;
        _this2.saving = false;
      });
    },


    sendKits: function sendKits() {
      var _this3 = this;

      this.errors = {};
      this.saving = true;

      var data = {
        date: this.date,
        kits: this.kits,
        kits_weighed: this.weighedKits.length
      };

      _.each(this.kits, function (kit) {
        if (kit.weight_unit_short === "lbs-oz") {
          if (kit.current_weight[0]) {
            kit.current_weight = parseFloat(kit.current_weight[0] * 16) + (kit.current_weight[1] ? parseFloat(kit.current_weight[1]) : 0);
            kit.weight.push(kit.current_weight);
          }
        }
      });

      api.postLitterWeigh(this.litter, data).then(function () {
        _this3.$dispatch("refresh-kits");
        _this3.$dispatch("weighted");
        _this3.$dispatch("reload-tasks", { typeOfTask: "all", page: null });
        $(_this3.weighForm).modal("hide");
        _this3.refreshForm();
        _this3.saving = false;
      }, function (response) {
        _this3.$dispatch("refresh-kits");
        _this3.$dispatch("weighted");
        $(_this3.weighForm).modal("hide");
        _this3.errors = response.data.errors;
        _this3.saving = false;
      });
    },

    sendKitsFirstWeigh: function sendKitsFirstWeigh() {
      var _this4 = this;

      this.errors = {};
      this.saving = true;

      var data = {
        date: this.date,
        kits: this.kits,
        first: true
      };

      api.postLitterWeigh(this.litter, data).then(function () {
        _this4.$dispatch("refresh-kits");
        _this4.$dispatch("weighted");
        _this4.$dispatch("reload-tasks", { typeOfTask: "all", page: null });
        $(_this4.weighForm).modal("hide");
        if (_this4.isGlobal) _this4.$root.$emit("global-notification-tab-reload");
        _this4.litter.total_weight = 0;
        $.each(_this4.kits, function (i, kit) {
          if (kit.current_weight) {
            _this4.litter.total_weight += kit.current_weight;
          }
        });
        _this4.refreshForm();
        _this4.saving = false;
      }, function (response) {
        _this4.$dispatch("refresh-kits");
        _this4.$dispatch("weighted");
        $(_this4.weighForm).modal("hide");
        _this4.errors = response.data.errors;
        _this4.saving = false;
      });
    },

    refreshForm: function refreshForm() {
      this.selectedLitter = 0;
      this.litter = {};
      this.saving = false;
      this.entireLitterWeight = 0;
    },

    diedKit: function diedKit(kit) {
      $("#kit-" + kit.id).fadeOut(500);
      this.kits = _.reject(this.kits, function (_kit) {
        return _kit.id == kit.id;
      });
      api.dieKit(kit, { default_death_reason: true });
      return false;
    },

    setActiveKit: function setActiveKit(kit, index) {
      if (this.first) {
        this.changed && this.saveKit(_.extend({}, this.activeKit));
        this.changed = -1;

        this.activeKit = kit;
        this.current = index;
      }
    },

    saveWeight: function saveWeight(kit) {
      kit.current_weight_date = this.getTimestamp(this.date);
      var isWeighed = _.find(this.weighedKits, function (item) {
        return item.id == kit.id;
      });
      if (!isWeighed) {
        this.weighedKits.push(kit);
      }
    },

    saveKit: function saveKit(kit, callback) {
      var _kit = kit || _.extend({}, this.activeKit);

      if (_kit.weight == null) {
        _kit.weight = [];
      }

      var _current_weight_date = this.getTimestamp(this.date);
      _kit.current_weight_date = _current_weight_date;
      this.activeKit.current_weight_date = _current_weight_date;

      _kit.return_count = 1;
      var self = this;
      self.weighedKits = [];
      $.each(self.kits, function (i, kit) {
        if (kit.current_weight) {
          var isWeighed = _.find(self.weighedKits, function (item) {
            return item.id == kit.id;
          });
          if (!isWeighed) {
            self.weighedKits.push(kit);
          }
        }
      });
    },

    prevKit: function prevKit() {
      if (this.kits.length > 1) {
        this.activeKit.current_weight && this.changed && this.saveKit();
      }
      this.changed = -1;

      this.current--;
    },
    nextKit: function nextKit() {
      if (this.kits.length >= 1) {
        this.activeKit.current_weight && this.changed && this.saveKit();
      }
      this.changed = -1;
      this.generateIds();

      if (this.current + 1 >= this.kits.length) {
        this.current = 0;
      } else {
        this.current++;
      }
    },

    diedNextKit: function diedNextKit() {
      this.diedKit(this.activeKit);
      if (this.current >= this.kits.length) {
        this.current = 0;
      }
      this.changed = -1;
    },

    imageUploaded: function imageUploaded(image) {
      this.activeKit.image = image;
    },

    father: function father() {
      return _.find(this.litter.parents, function (item) {
        return item.sex === "buck";
      });
    },
    mother: function mother() {
      return _.find(this.litter.parents, function (item) {
        return item.sex === "doe";
      });
    },

    getTimestamp: function getTimestamp(dateString) {
      if (App.dateFormat == "DD/MM/YYYY") {
        var dateParts = dateString.split("/");
        dateString = dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
      }
      return new Date(dateString).getTime();
    },

    initTypeahead: function initTypeahead() {
      var _this5 = this;

      api.getKitsAutocomplete().then(function (data) {
        _this5.colors = data.color;
        _this5.weights = data.weight;
      });
    },
    getParentName: function getParentName(item, index) {
      return item.parents[index] ? item.parents[1].name : "";
    },

    getOptionTitle: function getOptionTitle(item) {
      var title = "";

      if (item) {
        if (item.parents && item.parents.length > 1) {
          title += item.parents[0].name + "+" + item.parents[1].name;
        }

        title += " - " + item.given_id;
      }

      return title;
    },
    initWeighType: function initWeighType() {
      var _this6 = this;

      $("#weigh-type-switch" + this.globalSuffix).netlivaSwitch({
        width: "35px"
      }).on("netlivaSwitch.change", function (event, state, element) {
        _this6.isEntireLitter = state;
      });
    },
    toggleLayout: function toggleLayout() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      $("#weigh-type-switch" + this.globalSuffix).netlivaSwitch("state", state);
      this.isEntireLitter = state;
    }
  },
  ready: function ready() {
    this.initTypeahead();
    this.initWeighType();
  },

  mixins: [App.Mixins.Weightable, App.Mixins.Generic]
};

},{}],795:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.emptyLitter = {
    "id": 0,
    "given_id": '',
    "breed": '',
    "cage": '',
    "kits_amount": '',
    "kits": [],
    "father_id": 0,
    "mother_id": 0,
    "bred": moment(new Date()).format(App.dateFormat),
    "born": moment(new Date()).format(App.dateFormat),
    "notes": ''
};

App.Components.Litters = Vue.extend({
    template: "#litters-template",
    data: function data() {
        var activeTab = this.$route.query.tab == 'kits' || this.$route.query.tab == 'cages' ? this.$route.query.tab : 'litters';

        return {
            litter: _.extend({}, App.emptyLitter),
            litters: [],
            pages: 1,
            activeLitter: {},
            activeKits: [],
            activeKit: {},
            loading: 1,
            plans: [],
            activeBirth: {},
            order: activeTab != 'litters' ? 'given_id|asc' : null,
            bucks: [],
            does: [],
            preFilters: {
                given_id: '',
                cage: '',
                prefix: '',
                buck: '',
                doe: '',
                born: {
                    from: null,
                    to: null
                },
                bred: {
                    from: null,
                    to: null
                }
            },
            preFiltersKits: {
                given_id: '',
                buck: '',
                doe: '',
                sex: '',
                status: ''
            },
            filters: {
                given_id: '',
                cage: '',
                prefix: '',
                buck: '',
                doe: '',
                born: {
                    from: null,
                    to: null
                },
                bred: {
                    from: null,
                    to: null
                }
            },
            filtersKits: {
                given_id: '',
                buck: '',
                doe: '',
                sex: '',
                status: ''
            },
            preFilterRanges: {
                born: [],
                bred: []
            },
            preFilterRangesKits: {
                born: [],
                bred: []
            },
            filterRanges: {
                born: [],
                bred: []
            },
            filterRangesKits: {
                born: [],
                bred: []
            },
            filterRules: {
                given_id: 'string',
                buck: {
                    type: 'relation',
                    relationName: 'parents',
                    relationFilterField: 'id',
                    relationField: 'sex',
                    valueType: 'number'
                },
                doe: {
                    type: 'relation',
                    relationName: 'parents',
                    relationFilterField: 'id',
                    relationField: 'sex',
                    valueType: 'number'
                },
                born: 'daterange',
                bred: 'daterange',
                cage: 'string'
            },
            searchFields: ['skipSearchFilter'],
            isTileView: true,
            openLitters: [],
            description: {},
            totalPages: 1,
            totalCount: 0,
            page: 1,
            perPage: 10,
            currentSort: 'created_at',
            currentOrder: 'asc',
            displayItems: {
                litter_id: true,
                buck: true,
                doe: true,
                cage: true,
                age: true,
                bred: false,
                born: false,
                total_weight: true,
                avg_weight: true,
                no_kits: true,
                no_live: true,
                no_dead: true,
                no_sold: true
            },
            displayKitItems: {
                kit_id: true,
                born: true,
                buck: true,
                doe: true,
                kit_name: true,
                color: true,
                sex: true,
                weight: true,
                status: true,
                litter_id: true,
                cage_no: true
            },
            newFilters: [],
            actionableLitters: [],
            actionableKits: [],
            actionableCages: [],
            currentTab: 'litters',
            isShowTableActions: true,
            isShowKitsTableActions: true,
            kitsOrder: '',
            btn_name: [],
            filterKit: [],
            butcherKit: []
        };
    },
    props: [],
    components: {
        'breeder-form': App.Components.BreederForm,
        'kit-form': App.Components.KitForm,
        'litter-form': App.Components.LitterForm,
        'litter-sell': App.Components.LitterSell,
        'litter-weight': App.Components.LitterWeight,
        'litter-butcher': App.Components.LitterButcher,
        'kit-butcher': App.Components.KitButcher,
        'litter-box-v2': App.Components.LitterBoxV2,
        'multiple-litter-form': App.Components.MultipleLitterForm,
        'kits-list': App.Components.KitsList,
        'cages-list': App.Components.CagesList
    },
    computed: {
        filter: function filter() {
            return this.$route.params.action;
        },
        currentRoute: function currentRoute() {
            return this.$route.path.split('?')[0];
        },
        confirmTarget: function confirmTarget() {
            return this.activeLitter.given_id || "this litter";
        },
        newOrder: function newOrder() {
            return this.currentSort + "|" + this.currentOrder;
        },
        disableActive: function disableActive() {
            return !!this.newFilters.length;
        }
    },

    watch: {
        searchQuery: function searchQuery(newData, oldData) {
            if (this.currentTab == 'litters') {
                this.page = 1;
                this.litters = [];
                if (this.isTileView) {
                    this.itemsLoaded = 0;
                    this.disableLoadMore = false;
                    this.loadMore();
                } else {
                    this.updateList();
                }

                if (oldData == "") {
                    this.newFilters = [];
                    this.$router.go({ path: '/litters/all' });
                }
            }
        },

        filter: function filter() {
            this.page = 1;
            this.updateList();
        },
        order: function order(newData) {
            var data = newData.split("|");
            this.currentSort = data[0];
            this.currentOrder = data[1];
            this.updateList();
        },

        filters: {
            handler: function handler(newData, oldData) {
                if (newData.doe == -1) this.filters.doe = "";
                if (newData.buck == -1) this.filters.buck = "";

                this.page = 1;
                this.saveFilters();
                this.updateList();
            },
            deep: true
        },
        filtersKits: {
            handler: function handler(newData, oldData) {
                if (newData.doe == -1) this.filtersKits.doe = "";
                if (newData.buck == -1) this.filtersKits.buck = "";

                this.saveFilters();
            },
            deep: true
        },
        perPage: function perPage(newData) {
            this.page = 1;
            this.updateList();
        },
        page: function page(newData) {
            this.updateList();
        },
        isTileView: function isTileView(newData) {
            var _this = this;

            this.$nextTick(function () {
                _this.initializeDisplayItems();
            });
        },
        currentTab: function currentTab(newData) {
            var _this2 = this;

            if (newData == 'kits' || newData == 'litters') {
                this.$nextTick(function () {
                    _this2.initializeDisplayItems();
                });
            }
        }
    },

    events: {
        'litter-archived': function litterArchived(msg) {
            $('#id_' + msg.litter).slideUp(200);
            this.updateList();
        },
        'butcher-kit': function butcherKit(kit) {
            this.activeLitter = kit.litter;
            this.filterKit = kit.id;
            this.butcherKit = [kit];
            $('#kit-butcher-modal').modal('show');
        },
        'total-count-updated': function totalCountUpdated(data) {
            this.totalItems = data;
        }
    },

    methods: {
        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        saveFilters: function saveFilters() {
            localStorage.setItem('filters2', (0, _stringify2.default)(this.filters));
            localStorage.setItem('filtersKits', (0, _stringify2.default)(this.filtersKits));
            localStorage.setItem('newLitterFilters', (0, _stringify2.default)(this.newFilters));
        },
        getFilters: function getFilters() {
            return JSON.parse(localStorage.getItem('filters2'));
        },
        getFiltersKits: function getFiltersKits() {
            return JSON.parse(localStorage.getItem('filtersKits'));
        },
        getNewFilters: function getNewFilters() {
            return JSON.parse(localStorage.getItem('newLitterFilters'));
        },
        changeOrderOld: function changeOrderOld(value) {
            this.order = value;
        },
        age: function age(litter) {
            var from = App.parseMoment(litter.born);
            var to = litter.butchered_at ? moment(litter.butchered_at, 'YYYY-MM-DD H:i:s').startOf('day') : moment().startOf('day');

            return this.formatAge(from, to);
        },
        buildFilters: function buildFilters() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            data.all = this.filter === 'all' ? 1 : 0;
            data.inactive = this.filter === 'inactive' ? 1 : 0;
            data.archived = ['archive', 'inactive'].includes(this.filter) ? 1 : 0;
            data.butchered = ['butchered', 'inactive'].includes(this.filter) ? 1 : 0;

            _.each(this.newFilters, function (filter) {
                data[filter] = 1;
            });

            return data;
        },

        updateList: function updateList() {
            var _this3 = this;

            this.loading = 1;
            this.perPage = localStorage.getItem('perPage') || this.perPage;
            var data = { page: this.page, perPage: this.perPage };
            if (this.order) {
                data.order = this.order;
            }
            data = this.buildFilters(data);
            data.filters = this.filters;
            data.searchQuery = this.searchQuery;

            api.getLitters(data).then(function (data) {
                _this3.litters = data.litters.data;
                _this3.pages = data.litters.last_page;
                _this3.order = data.order;
                _this3.loading = 0;
                _this3.itemsLoaded = data.litters.current_page;
                _this3.disableLoadMore = !_this3.isTileView;
                _this3.totalItems = data.litters.total;

                // for list view
                _this3.totalPages = data.litters.last_page;
                _this3.totalCount = data.litters.total;
                _this3.description = {
                    from: data.litters.from,
                    to: data.litters.to,
                    total: data.litters.total
                };
                $('#f-litter-born').trigger('triggerDaterangepicker');
                $('#f-litter-breed').trigger('triggerDaterangepicker');

                _this3.$nextTick(function () {
                    _this3.initializeLitterCheckbox();
                });
            });
        },

        newLitter: function newLitter() {
            this.litter = _.extend({}, App.emptyLitter);
            $('#litter-form').modal('show');
        },
        editLitter: function editLitter(litter) {
            var self = this;
            this.litter = litter;
            this.litter.father_id = this.getLitterParent(litter, 'f').id;
            this.litter.mother_id = this.getLitterParent(litter, 'm').id;

            $('#litter-form').modal('show');
            $(document).one('hide.bs.modal', '#litter-form', function (event) {
                if ($(event.target).is('#litter-form')) {
                    self.updateList();
                }
            });
        },


        getGenderClass: function getGenderClass(sex) {
            return sex === "male" ? "bg-aqua-active" : "bg-maroon-active";
        },

        onlyNumbers: function onlyNumbers(e) {
            return e.charCode >= 48 && e.charCode <= 57;
        },

        prevPage: function prevPage() {
            if (this.page - 1 > 0) {
                this.$router.go({
                    path: this.currentRoute,
                    query: {
                        page: this.page - 1
                    }
                });
            }
        },

        nextPage: function nextPage() {
            if (Number(this.page) + 1 <= this.pages) {
                this.$router.go({
                    path: this.currentRoute,
                    query: {
                        page: Number(this.page) + 1
                    }
                });
            }
        },

        editModal: function editModal(litter) {
            this.litter = litter;
            $('#litter-form').modal('show');
        },

        loadKits: function loadKits() {
            var _this4 = this;

            api.getLitterKitsWeighOfType(this.activeLitter.id, 'rabbitkit').then(function (kits) {
                _this4.activeKits = kits;
            });
        },

        sellModal: function sellModal(litter) {
            this.activeLitter = litter;
            $('#litter-sell-modal').modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#litter-sell-modal').modal('show');
        },

        weightModal: function weightModal(litter) {
            this.activeLitter = litter;
            //this.loadKits();
            $('#litter-weight-modal').modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#litter-weight-modal').modal('show');
        },

        butcherModal: function butcherModal(litter) {
            this.activeLitter = litter;
            //this.loadKits();
            $('#litter-butcher-modal').modal('show');
        },

        undoButcherModal: function undoButcherModal(litter) {
            this.activeLitter = litter;
            $('#undo-butcher-breed-modal').modal('show');
        },
        undoButcher: function undoButcher() {
            var _this5 = this;

            $('#undo-butcher-breed-modal').modal('hide');
            var data = {
                litter_id: this.activeLitter.id
            };

            api.undoButcheredKits(this.activeLitter, data).then(function () {
                _this5.activeLitter.butchered = 0;
                _this5.updateList();
            });
        },

        archiveModal: function archiveModal(litter) {
            this.activeLitter = litter;
            $('#archive-breed-modal').modal('show');
        },
        archive: function archive() {
            var _this6 = this;

            $('#archive-breed-modal').modal('hide');
            api.archiveLitter(this.activeLitter).then(function () {
                _this6.refreshData();
            });
        },

        unarchiveModal: function unarchiveModal(litter) {
            this.activeLitter = litter;
            $('#unarchive-breed-modal').modal('show');
        },
        unarchive: function unarchive() {
            var _this7 = this;

            $('#unarchive-breed-modal').modal('hide');
            api.unarchiveLitter(this.activeLitter).then(function () {
                _this7.refreshData();
            });
        },

        deleteModal: function deleteModal(litter) {
            this.activeLitter = litter;
            $('#delete-breed-modal').modal('show');
        },
        delete: function _delete() {
            var _this8 = this;

            $('#delete-breed-modal').modal('hide');
            api.deleteLitter(this.activeLitter).then(function () {
                _this8.refreshData();
            });
        },

        calcKits: function calcKits(litter) {
            return litter.kits_died ? litter.kits_amount - litter.kits_died : litter.kits_amount;
        },
        birthModal: function birthModal() {
            var _this9 = this;

            api.getUsersPlans().then(function (plans) {
                _this9.plans = plans;
            });
            this.activeBirth = { breedplan: '-1', born: moment(new Date()).format(App.dateFormat) };
        },
        recordBirth: function recordBirth() {
            var _this10 = this;

            api.recordBirth(this.activeBirth).then(function () {
                _this10.activeBirth = {};
                $('#birth').modal('hide');
            });
        },

        handleChange: function handleChange() {
            if (this.$route.query.newModal) {
                this.newLitter();
            }
        },

        loadMore: function loadMore() {
            var _this11 = this;

            if (!this.isTileView) {
                return false;
            }

            var data = { page: parseInt(this.itemsLoaded) + 1, perPage: this.perPage };

            if (this.order) {
                data.order = this.order;
            }

            data = this.buildFilters(data);
            data.filters = this.filters;
            data.searchQuery = this.searchQuery;

            api.getLitters(data).then(function (data) {
                _this11.loading = 0;
                _this11.mergeByProperty(_this11.litters, data.litters.data, 'id');
                _this11.pages = data.litters.last_page;
                _this11.order = data.order;

                _this11.itemsLoaded = data.litters.current_page;
                _this11.disableLoadMore = false;
                _this11.totalItems = data.litters.total;

                _this11.itemsLoaded = data.litters.current_page;
                _this11.totalItems = data.litters.total;
                if (data.litters.last_page <= data.litters.current_page) {
                    _this11.disableLoadMore = true;
                } else {
                    _this11.disableLoadMore = false;
                }
            });
        },

        getParents: function getParents() {
            var _this12 = this;

            api.getBreedersList().then(function (breeders) {
                _this12.bucks = breeders.bucks;
                _this12.does = breeders.does;
                // set filters after does and bucks are loaded
                _this12.preFilters = (0, _extends3.default)({}, _this12.filters);
                _this12.preFiltersKits = (0, _extends3.default)({}, _this12.filtersKits);
            });
        },

        getBreederData: function getBreederData(id) {
            var breeders = this.bucks.concat(this.does);
            return _.find(breeders, function (breeder) {
                return breeder.id == id;
            });
        },
        getBreederStatusData: function getBreederStatusData(id) {
            var breeders = this.getBreederStatusList();
            return _.find(breeders, function (breeder) {
                return breeder.id == id;
            });
        },


        openLitter: function openLitter(item, id) {
            localStorage.setItem('action', item);
            this.$route.router.go('/litterprofile/' + id);
        },

        setDefaultBreed: function setDefaultBreed() {
            App.emptyLitter.breed = App.default_breed;
        },

        addKit: function addKit(litter) {
            var kitId = litter.kits_amount + 1;
            this.activeKit = _.extend({}, App.emptyKit);
            kitId = kitId < 100 ? '0' + kitId : kitId;
            this.activeKit.given_id = litter.id + kitId;
            this.activeKit.litter_id = litter.id;
            this.activeKit.original_litter_id = litter.id;
            this.activeKit.prefix = litter.prefix || App.default_prefix;
            this.activeKit.breed = litter.breed || App.default_breed;

            var form = $('#kit-form-modal');
            form.modal({
                backdrop: 'static',
                keyboard: false
            });
            form.modal('show');
            App.emptyLitter.breed = App.default_breed;
        },
        editKit: function editKit(kit) {
            this.activeKit = kit;
            var form = $('#kit-form-modal');
            form.modal({
                backdrop: 'static',
                keyboard: false
            });
            form.modal('show');
        },
        refreshKits: function refreshKits() {
            this.$broadcast('refresh-kits-global', this.activeKit.litter_id);
        },
        editMultipleLitters: function editMultipleLitters() {
            this.$broadcast('open-multiple-litter-form');
        },
        changeLayout: function changeLayout() {
            this.isTileView = !this.isTileView;
            localStorage.setItem('isLitterTileView', this.isTileView);
            this.litters = [];
            this.page = 1;
            this.updateList();
        },
        getLitterParent: function getLitterParent(litter) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'f';

            var parents = litter.parents;
            var parent = {};

            if (type == 'f') {
                parent = parents.find(function (item) {
                    return item.sex === 'buck';
                });
            } else {
                parent = parents.find(function (item) {
                    return item.sex === 'doe';
                });
            }

            return parent || {};
        },
        litterContainerClicked: function litterContainerClicked(id, element) {
            var action = $(element).data('action') || 'open';

            if (action == 'close') {
                $('.kits-container-' + id).hide();
                this.closeLitters(id);
            } else {
                $('.kits-container-' + id).show();
                this.openLitters.push(id); // add to open litters
            }
        },
        closeLitters: function closeLitters(id) {
            // remove from open litters
            var key = this.openLitters.indexOf(id);
            if (key > -1) {
                this.openLitters.splice(key, 1);

                this.closeLitters(id); //recursive call to clear all keys (in case it's saved multiple times)
            }
        },
        isLitterOpen: function isLitterOpen(id) {
            var key = this.openLitters.indexOf(id);
            if (key > -1) {
                return true;
            } else {
                return false;
            }
        },
        applyPreFilters: function applyPreFilters() {
            this.filters = (0, _extends3.default)({}, this.preFilters);
            this.filterRanges = (0, _extends3.default)({}, this.preFilterRanges);
            this.$router.go({ path: '/litters/all' });
        },
        applyPreFiltersKits: function applyPreFiltersKits() {
            this.filtersKits = (0, _extends3.default)({}, this.preFiltersKits);
            this.filterRangesKits = (0, _extends3.default)({}, this.preFilterRangesKits);
        },
        applyStatusFiltersKits: function applyStatusFiltersKits() {
            var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.preFiltersKits.status = status;
            this.filtersKits = (0, _extends3.default)({}, this.preFiltersKits);
        },
        resetPreFilters: function resetPreFilters() {
            this.preFilters = {
                given_id: '',
                cage: '',
                prefix: '',
                buck: '',
                doe: '',
                born: {
                    from: null,
                    to: null
                },
                bred: {
                    from: null,
                    to: null
                }
            };

            this.preFilterRanges = {
                born: [],
                bred: []
            };

            this.newFilters = [];
            this.applyPreFilters();
        },
        resetPreFiltersKits: function resetPreFiltersKits() {
            this.preFiltersKits = {
                given_id: '',
                buck: '',
                doe: '',
                sex: '',
                status: ''
            };

            this.preFilterRangesKits = {
                born: [],
                bred: []
            };

            this.applyPreFiltersKits();
        },
        removeFilter: function removeFilter() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var resetContent = "";

            if (type == 'born' || type == 'bred') {
                resetContent = {
                    from: null,
                    to: null
                };

                this.preFilterRanges[type] = resetContent;
            }

            if (type) {
                this.preFilters[type] = resetContent;
                this.applyPreFilters();
            }
        },
        removeFilterKits: function removeFilterKits() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var resetContent = "";

            if (type == 'born' || type == 'bred') {
                resetContent = {
                    from: null,
                    to: null
                };

                this.preFilterRangesKits[type] = resetContent;
            }

            if (type) {
                this.preFiltersKits[type] = resetContent;
                this.applyPreFiltersKits();
            }
        },
        removeNewFilter: function removeNewFilter(filter) {
            var index = this.newFilters.indexOf(filter);
            if (index > -1) {
                this.newFilters.splice(index, 1);
            }

            this.applyPreFilters();
        },
        initializeDisplayItems: function initializeDisplayItems() {
            var _this13 = this;

            $('.display-actions:not(.kit-lists) .display-settings').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            }).on('ifChecked', function (event) {
                _this13.displayItems[event.target.name] = true;
                localStorage.setItem('litterlistDisplay', (0, _stringify2.default)(_this13.displayItems));
            }).on('ifUnchecked', function (event) {
                _this13.displayItems[event.target.name] = false;
                localStorage.setItem('litterlistDisplay', (0, _stringify2.default)(_this13.displayItems));
            });

            $('.display-actions.kit-lists .display-settings').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            }).on('ifChecked', function (event) {
                _this13.displayKitItems[event.target.name] = true;
                localStorage.setItem('litterlistKitDisplay', (0, _stringify2.default)(_this13.displayKitItems));
            }).on('ifUnchecked', function (event) {
                _this13.displayKitItems[event.target.name] = false;
                localStorage.setItem('litterlistKitDisplay', (0, _stringify2.default)(_this13.displayKitItems));
            });

            var litterlistDisplay = JSON.parse(localStorage.getItem('litterlistDisplay'));
            if (litterlistDisplay) {
                this.displayItems = (0, _extends3.default)({}, this.displayItems, litterlistDisplay);
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.displayItems)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    if (this.displayItems[key]) {
                        $('.display-actions:not(.kit-lists)').find("input[class='display-settings'][name='" + key + "']").iCheck("check");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var litterlistKitDisplay = JSON.parse(localStorage.getItem('litterlistKitDisplay'));
            if (litterlistKitDisplay) {
                this.displayKitItems = (0, _extends3.default)({}, this.displayKitItems, litterlistKitDisplay);
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(this.displayKitItems)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _key = _step2.value;

                    if (this.displayKitItems[_key]) {
                        $('.display-actions.kit-lists').find("input[class='display-settings'][name='" + _key + "']").iCheck("check");
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        refreshData: function refreshData() {
            $('#id_' + this.activeLitter.id).slideUp(200);
            this.updateList();
        },
        initTypeahead: function initTypeahead() {
            var _this14 = this;

            api.getLittersList().then(function (litters) {
                var givenId = _this14.uniqueFieldSet(litters, "given_id");
                var cage = _this14.uniqueFieldSet(litters, "cage");
                var prefix = _this14.uniqueFieldSet(litters, "prefix");

                $('#f-litter-given_id-main').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    limit: 100,
                    source: _this14.substringMatcher(givenId)
                });

                $('#f-litter-cage-main').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    limit: 100,
                    source: _this14.substringMatcher(cage)
                });

                $('#f-litter-prefix-main').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    limit: 100,
                    source: _this14.substringMatcher(prefix)
                });
            });
        },
        initializeLitterCheckbox: function initializeLitterCheckbox() {
            var _this15 = this;

            this.actionableLitters = [];
            $('.litter-checkbox').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            }).on('ifChecked', function (event) {
                var litter = _this15.getLitterById(event.target.name);
                _this15.actionableLitters.push(litter);
            }).on("ifUnchecked", function (event) {
                var litter = _this15.getLitterById(event.target.name);
                _this15.actionableLitters = _.filter(_this15.actionableLitters, function (item) {
                    return item.id != litter.id;
                });
            });
        },
        editMultiple: function editMultiple() {
            if (this.currentTab == 'litters') {

                if (this.actionableLitters.length == 1) {
                    var litter = this.actionableLitters[0];
                    this.editLitter(litter);
                } else {
                    this.editMultipleLitters();
                }
            } else if (this.currentTab == 'cages') {
                this.$broadcast('open-multiple-cage-form');
            } else {
                this.$broadcast('open-multiple-kit-form');
            }
        },
        openDeleteMultiple: function openDeleteMultiple() {
            if (this.currentTab == 'litters') {
                this.openDeleteMultipleLittersModal();
            } else if (this.currentTab == 'cages') {
                this.$broadcast('open-delete-multiple-cages');
            } else {
                this.$broadcast('open-delete-multiple-kits');
            }
        },
        openDeleteMultipleLittersModal: function openDeleteMultipleLittersModal() {
            var form = $("#delete-multiple-litter-modal");
            form.modal('show');
        },
        deleteMultipleLitters: function deleteMultipleLitters() {
            var _this16 = this;

            this.loading = 1;
            var litters = _.pluck(this.actionableLitters, 'id');

            api.deleteMultipleLitters({ litters: litters }).then(function (data) {
                _this16.loading = 0;
                $("#delete-multiple-litter-modal").modal("hide");
                _this16.updateList();
            }, function (response) {
                _this16.loading = 0;
                _this16.errors = response.data.errors;
            });
        },
        getLitterById: function getLitterById(id) {
            id = id.replace('litter-', '');
            var litter = _.find(this.litters, function (litter) {
                return litter.id == id;
            });

            return litter;
        },
        initializeTabs: function initializeTabs() {
            var self = this;
            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                var target = $(e.target).attr("href");
                target = target.replace("#", "");
                target = target.replace("-content", "");
                self.currentTab = target;
                self.isShowTableActions = true;

                if (target == 'kits') {
                    self.isShowTableActions = false;
                } else if (target == 'cages') {
                    self.isShowTableActions = false;
                }
            });
        }
    },
    ready: function ready() {
        var activeTab = this.$route.query.tab == 'kits' || this.$route.query.tab == 'cages' ? this.$route.query.tab : 'litters';

        if (activeTab == 'kits') {
            this.isShowTableActions = false;
            this.kitsOrder = 'born|desc';
            this.order = 'given_id|asc';
        } else if (activeTab == 'cages') {
            this.isShowTableActions = false;
        }

        this.currentTab = activeTab;
        this.isTileView = localStorage.getItem('isLitterTileView') == 'true' ? true : false;
        var tmpFilters = this.getFilters();
        if (tmpFilters) {
            this.filters = tmpFilters;
            this.preFilters = (0, _extends3.default)({}, this.filters);
        } else {
            this.order = 'born|desc';
        }
        if (this.getFiltersKits()) {
            this.filtersKits = this.getFiltersKits();
            if (this.$route.query.kitsFilter != "true") {
                this.preFiltersKits = (0, _extends3.default)({}, this.filtersKits);
            }
        }
        if (this.getNewFilters()) {
            this.newFilters = this.getNewFilters();
        }
        if (this.newFilters.length) {
            this.$router.go({ path: '/litters/all' });
        }
        this.initializeTabs();
        this.initializeDisplayItems();
        this.initTypeahead();
        App.MobileTypes();
        this.getParents();
        App.vent.on('litters.new', this.newLitter.bind(this));
        this.$watch('$route.query.newModal', this.handleChange, { deep: true });
        var self = this;
        if (this.$route.query.newModal) {
            this.newLitter();
        }
        $(document).on('hide.bs.modal', '#litter-form', function (event) {
            if ($(event.target).is('#litter-form') && self.$route.query.newModal) {
                self.$route.router.go('litters');
            }
        });
        this.$on('weighted', this.updateList.bind(this));
        this.setDefaultBreed();
        this.birthModal();

        // tweak for dropdown
        $(document).on('click', '.dropdown-menu.main-filters', function (e) {
            if ($(e.target).data("dismiss") != "dropdown") {
                e.stopPropagation();
            }
        });

        this.getCurrentData();
    },
    mixins: [App.Mixins.Butcherable, App.Mixins.Filterable, App.Mixins.DateHelper, App.Mixins.Litters, App.Mixins.Breeders, App.Mixins.Generic, App.Mixins.Typeahead]
});

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37}],796:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.MarketplaceList = Vue.extend({
  template: "#marketplace-list-template",
  data: function data() {
    return {
      listings: [],
      activeListing: {},
      inquiries: [],
      loading: 1,
      inquiriesLoading: 0,
      order: "created_at|desc",
      filters: {
        status: "active"
      },
      query: "",
      page: 1,
      perPage: 10,
      totalPages: 1,
      totalCount: 0,
      totalItems: 0,
      description: {},
      currentSort: "created_at",
      currentOrder: "desc",
      displayItems: {
        rabbit_name: true,
        photo: true,
        date_listed: true,
        views_count: true,
        inquiries_count: true,
        status: true
      }
    };
  },
  props: [],
  components: {},
  computed: {
    confirmTarget: function confirmTarget() {
      return this.activeListing.data.name;
    }
  },
  watch: {
    perPage: function perPage(newData, oldData) {
      this.page = 1;
      this.updateList();
    },
    searchQuery: function searchQuery(newData, oldData) {
      this.page = 1;
      this.filters.status = "";
      this.updateList();
    }
  },
  events: {},
  methods: {
    updateList: function updateList() {
      var _this = this;

      this.loading = 1;
      this.perPage = localStorage.getItem("perPage") || 10;
      var data = { page: this.page, perPage: this.perPage };
      if (this.order) {
        data.order = this.order;
      }

      data.search = this.searchQuery;
      data.status = this.filters.status;
      data.owner = App.user_id;
      api.getMarketplaceListings(data).then(function (data) {
        _this.listings = data.listings.data;
        _this.pages = data.listings.last_page;
        _this.order = data.order;
        _this.totalItems = data.listings.total;
        _this.loading = 0;

        // for list view
        _this.totalPages = data.listings.last_page;
        _this.totalCount = data.listings.total;
        _this.description = {
          from: data.listings.from,
          to: data.listings.to,
          total: data.listings.total
        };
      });
    },
    getStatus: function getStatus(listing) {
      var status = "For Sale";
      if (!listing.is_active) status = "Inactive";
      if (listing.is_sold) status = "Sold";

      return status;
    },
    applyStatusFilter: function applyStatusFilter() {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.filters.status = status;
      this.page = 1;
      this.updateList();
    },
    updatePage: function updatePage(page) {
      // NOTE: catch frontend bug where disabled link still triggers
      if (page == this.page || page <= 0 || page > this.totalPages) {
        return true;
      }

      this.page = page; // set new page
      this.updateList();
    },
    updatePerPage: function updatePerPage() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

      localStorage.setItem("perPage", value);
      this.perPage = value;
    },
    initializeDisplayItems: function initializeDisplayItems() {
      var _this2 = this;

      $(".display-settings").iCheck({
        checkboxClass: "icheckbox_square-green",
        radioClass: "iradio_square-green"
      }).on("ifChecked", function (event) {
        _this2.displayItems[event.target.name] = true;
        localStorage.setItem("marketplaceListDisplayV2", (0, _stringify2.default)(_this2.displayItems));
      }).on("ifUnchecked", function (event) {
        _this2.displayItems[event.target.name] = false;
        localStorage.setItem("marketplaceListDisplayV2", (0, _stringify2.default)(_this2.displayItems));
      });

      var marketplaceListDisplay = JSON.parse(localStorage.getItem("marketplaceListDisplayV2"));
      if (marketplaceListDisplay) {
        this.displayItems = marketplaceListDisplay;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.displayItems)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (this.displayItems[key]) {
            $("input[class='display-settings'][name='" + key + "']").iCheck("check");
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    removeForSaleModal: function removeForSaleModal(listing) {
      this.activeListing = listing;
      $("#remove-for-sale-modal-marketplace-list").modal("show");
    },
    removeForSale: function removeForSale() {
      var _this3 = this;

      var params = {
        id: this.activeListing.id
      };

      api.removeForSale(params).then(function (data) {
        _this3.updateList();
        _this3.showAlert({
          type: "success",
          text: _this3.activeListing.data.name + " has been removed for sale."
        });

        $("#remove-for-sale-modal-marketplace-list").modal("hide");
      }, function (response) {});
    },
    markInactiveListingModal: function markInactiveListingModal(listing) {
      this.activeListing = listing;
      $("#mark-inactive-listing-modal-marketplace-list").modal("show");
    },
    markInactiveListing: function markInactiveListing() {
      var _this4 = this;

      var params = {
        id: this.activeListing.id,
        status: 0
      };

      api.markAsInactiveListing(params).then(function (data) {
        _this4.updateList();
        _this4.showAlert({
          type: "success",
          text: _this4.activeListing.data.name + " has been marked as inactive (archived)."
        });

        $("#mark-inactive-listing-modal-marketplace-list").modal("hide");
      }, function (response) {});
    },
    markAsSoldModal: function markAsSoldModal(listing) {
      this.activeListing = listing;
      $("#mark-as-sold-modal-marketplace-list").modal("show");
    },
    markAsSold: function markAsSold() {
      var _this5 = this;

      var params = {
        id: this.activeListing.id,
        sold: 1
      };

      api.markAsSold(params).then(function (data) {
        _this5.updateList();
        _this5.showAlert({
          type: "success",
          text: _this5.activeListing.data.name + " has been marked as sold."
        });

        $("#mark-as-sold-modal-marketplace-list").modal("hide");
      }, function (response) {});
    },
    viewInquiries: function viewInquiries(listing) {
      var _this6 = this;

      this.activeListing = listing;
      var params = {
        id: this.activeListing.id,
        inquiries: 1
      };

      $("#listing-inquiries-modal").modal("show");

      this.inquiriesLoading = 1;
      api.getMarketplaceListing(params).then(function (data) {
        _this6.inquiries = data.listing.inquiries;
        _this6.inquiriesLoading = 0;
      }, function (response) {
        _this6.inquiriesLoading = 0;
      });
    },
    editListing: function editListing(listing) {
      var _this7 = this;

      this.activeListing = listing;
      var params = {
        id: this.activeListing.id,
        animal: 1
      };

      api.getMarketplaceListing(params).then(function (data) {
        var activeAnimal = data.listing.animal;

        if (listing.listable_type == "breeder") {
          _this7.$root.$emit("open-global-edit-breeder-form", activeAnimal);
        }
      }, function (response) {});
    }
  },
  ready: function ready() {
    var _this8 = this;

    this.initializeDisplayItems();
    this.updateList();

    this.$root.$on('close-breeder', function () {
      _this8.updateList();
    });
  },

  mixins: [App.Mixins.Butcherable, App.Mixins.Filterable, App.Mixins.Breeders, App.Mixins.Transferable, App.Mixins.Generic, App.Mixins.Tours, App.Mixins.Typeahead]
});

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/keys":27}],797:[function(require,module,exports){
"use strict";

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.MultipleBreederForm = {
  template: "#multiple-breeder-form-template",
  data: function data() {
    return {
      breedersList: [],
      categories: [],
      errors: {},
      loading: 1,
      breeder: {
        category_id: null,
        prefix: null,
        cage: null,
        color: null,
        breed: null,
        sex: null
      }
    };
  },

  props: ["breeders"],
  watch: {
    breeder: function breeder(newValue) {
      if (!newValue) return;
      this.errors = {};
    }
  },
  components: {
    "sex-select": App.Components.SexSelect
  },
  computed: {
    hasInactiveBreeder: function hasInactiveBreeder() {
      var _this = this;

      var hasInactive = false;

      _.each(this.breeders, function (breeder) {
        if (!_this.getBreederStatus(breeder).includes("Active")) {
          hasInactive = true;
        }
      });

      return hasInactive;
    }
  },
  events: {
    "open-multiple-breeder-form": function openMultipleBreederForm() {
      this.initFormData();
      var form = $("#multiple-breeder-form");
      form.modal({
        backdrop: "static",
        keyboard: false
      });
    }
  },
  methods: {
    initFormData: function initFormData() {
      this.breeder = {
        category_id: null,
        prefix: null,
        cage: null,
        color: null,
        breed: null,
        sex: null
      };
    },
    initModal: function initModal() {
      var _this2 = this;

      this.loading = 1;
      this.initBreedTypeahead();
      this.loadCategories();

      api.getBreedersList().then(function (breeders) {
        var prefixes = _this2.uniqueFieldSet(breeders, "prefix");

        $("#breeder-prefix").typeahead({
          hint: true,
          highlight: true,
          minLength: 0
        }, {
          source: _this2.substringMatcher(prefixes)
        });
      });

      this.loading = 0;
    },
    sendBreeder: function sendBreeder() {
      var _this3 = this;

      this.loading = 1;
      var breeder = (0, _assign2.default)({}, this.breeder);
      breeder.breeders = _.pluck(this.breeders, "id");

      api.updateMultipleBreeders(breeder).then(function (data) {
        _this3.loading = 0;
        $("#multiple-breeder-form").modal("hide");
        _this3.$dispatch("refresh-breeders");
      }, function (response) {
        _this3.loading = 0;
        _this3.errors = response.data.errors;
      });
    },
    loadCategories: function loadCategories() {
      var _this4 = this;

      this.loading = 1;
      api.getBreederCategories().then(function (data) {
        _this4.loading = 0;
        _this4.categories = data.categories;
        _this4.breeder.category_id = _this4.breeder.category_id || _this4.categories.find(function (cat) {
          return cat.default;
        }).id;
      });
    },
    initBreedTypeahead: function initBreedTypeahead() {
      this.breedersList = this.getBreedersAutocompleteList();
    }
  },
  ready: function ready() {
    this.initModal();
  },

  mixins: [App.Mixins.BreedersFilter, App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.FieldDescription]
};

},{"babel-runtime/core-js/object/assign":22}],798:[function(require,module,exports){
"use strict";

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.MultipleCageForm = {
  template: "#multiple-cage-form-template",
  data: function data() {
    return {
      errors: {},
      loading: 1,
      cage: {
        name: null
      }
    };
  },

  props: ["cages"],
  watch: {
    cage: function cage(newValue) {
      if (!newValue) return;
      this.errors = {};
    }
  },
  computed: {},
  events: {
    "open-multiple-cage-form": function openMultipleCageForm() {
      this.initFormData();
      var form = $("#multiple-cage-form");
      form.modal({
        backdrop: "static",
        keyboard: false
      });
    },
    "open-delete-multiple-cages": function openDeleteMultipleCages() {
      this.openDeleteMultipleCagesModal();
    }
  },
  methods: {
    initFormData: function initFormData() {
      this.cage = {
        name: null
      };
    },
    sendCage: function sendCage() {
      var _this = this;

      this.loading = 1;
      var cage = (0, _assign2.default)({}, this.cage);
      cage.cages = _.pluck(this.cages, "id");

      if (Array.isArray(cage.notes)) {
        cage.notes = (0, _stringify2.default)(cage.notes);
      }

      api.updateMultipleCages(cage).then(function (data) {
        _this.loading = 0;
        $("#multiple-cage-form").modal("hide");
        _this.$dispatch("refresh-cages");
      }, function (response) {
        _this.loading = 0;
        _this.errors = response.data.errors;
      });
    },
    openDeleteMultipleCagesModal: function openDeleteMultipleCagesModal() {
      var form = $("#delete-multiple-cages-modal");
      form.modal("show");
    },
    deleteMultipleCages: function deleteMultipleCages() {
      var _this2 = this;

      this.loading = 1;
      var cages = _.pluck(this.cages, "id");

      api.deleteMultipleCages({ cages: cages }).then(function (data) {
        _this2.loading = 0;
        $("#delete-multiple-cages-modal").modal("hide");
        _this2.$dispatch("refresh-cages");
      }, function (response) {
        _this2.loading = 0;
        _this2.errors = response.data.errors;
      });
    }
  },
  ready: function ready() {
    this.loading = 0;
  },

  mixins: [App.Mixins.BreedersFilter, App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.FieldDescription]
};

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22}],799:[function(require,module,exports){
"use strict";

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.MultipleKitForm = {
  template: "#multiple-kit-form-template",
  data: function data() {
    return {
      breedersList: [],
      errors: {},
      loading: 1,
      kit: {
        sex: null,
        cage: null,
        breed: null,
        color: null,
        name: null,
        prefix: null
      }
    };
  },

  props: ["kits"],
  watch: {
    kit: function kit(newValue) {
      if (!newValue) return;
      this.errors = {};
    }
  },
  computed: {},
  events: {
    "open-multiple-kit-form": function openMultipleKitForm() {
      this.initFormData();
      var form = $("#multiple-kit-form");
      form.modal({
        backdrop: "static",
        keyboard: false
      });
    },
    "open-delete-multiple-kits": function openDeleteMultipleKits() {
      this.openDeleteMultipleKitsModal();
    }
  },
  methods: {
    initFormData: function initFormData() {
      this.kit = {
        sex: null,
        cage: null,
        breed: null,
        color: null,
        name: null,
        prefix: null
      };
    },
    initModal: function initModal() {
      var _this = this;

      this.loading = 1;
      this.initBreedTypeahead();

      api.getLittersList().then(function (kits) {
        var prefixes = _this.uniqueFieldSet(kits, "prefix");

        $("#kit-prefix").typeahead({
          hint: true,
          highlight: true,
          minLength: 0
        }, {
          source: _this.substringMatcher(prefixes)
        });
      });

      this.loading = 0;
    },
    sendKit: function sendKit() {
      var _this2 = this;

      this.loading = 1;
      var kit = (0, _assign2.default)({}, this.kit);
      kit.kits = _.pluck(this.kits, "id");

      if (Array.isArray(kit.notes)) {
        kit.notes = (0, _stringify2.default)(kit.notes);
      }

      api.updateMultipleKits(kit).then(function (data) {
        _this2.loading = 0;
        $("#multiple-kit-form").modal("hide");
        _this2.$dispatch("refresh-kits");
      }, function (response) {
        _this2.loading = 0;
        _this2.errors = response.data.errors;
      });
    },
    initBreedTypeahead: function initBreedTypeahead() {
      this.breedersList = this.getBreedersAutocompleteList();
    },
    openDeleteMultipleKitsModal: function openDeleteMultipleKitsModal() {
      var form = $("#delete-multiple-kits-modal");
      form.modal("show");
    },
    deleteMultipleKits: function deleteMultipleKits() {
      var _this3 = this;

      this.loading = 1;
      var kits = _.pluck(this.kits, "id");

      api.deleteMultipleKits({ kits: kits }).then(function (data) {
        _this3.loading = 0;
        $("#delete-multiple-kits-modal").modal("hide");
        _this3.$dispatch("refresh-kits");
      }, function (response) {
        _this3.loading = 0;
        _this3.errors = response.data.errors;
      });
    }
  },
  ready: function ready() {
    this.initModal();

    $(".js_icheck-kit-blue").iCheck({
      checkboxClass: "icheckbox_square-blue",
      radioClass: "iradio_square-blue"
    }).on("ifChecked", function (event) {
      this.kit.sex = "buck";
    }.bind(this));

    //Red color scheme for iCheck
    $(".js_icheck-kit-red").iCheck({
      checkboxClass: "icheckbox_square-red",
      radioClass: "iradio_square-red"
    }).on("ifChecked", function (event) {
      this.kit.sex = "doe";
    }.bind(this));
  },

  mixins: [App.Mixins.BreedersFilter, App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.FieldDescription]
};

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22}],800:[function(require,module,exports){
"use strict";

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.MultipleLitterForm = {
  template: "#multiple-litter-form-template",
  data: function data() {
    return {
      breedersList: [],
      errors: {},
      loading: 1,
      litter: {
        notes: null,
        cage: null,
        breed: null,
        born: null,
        bred: null,
        prefix: null
      }
    };
  },

  props: ["litters"],
  watch: {
    litter: function litter(newValue) {
      if (!newValue) return;
      this.errors = {};
    }
  },
  computed: {},
  events: {
    "open-multiple-litter-form": function openMultipleLitterForm() {
      this.initFormData();
      var form = $("#multiple-litter-form");
      form.modal({
        backdrop: "static",
        keyboard: false
      });
    }
  },
  methods: {
    initFormData: function initFormData() {
      this.litter = {
        notes: null,
        cage: null,
        breed: null,
        born: null,
        bred: null,
        prefix: null
      };
    },
    initModal: function initModal() {
      var _this = this;

      this.loading = 1;
      this.initBreedTypeahead();

      api.getLittersList().then(function (litters) {
        var prefixes = _this.uniqueFieldSet(litters, "prefix");

        $("#litter-prefix, #birth-prefix").typeahead({
          hint: true,
          highlight: true,
          minLength: 0
        }, {
          source: _this.substringMatcher(prefixes)
        });
      });

      this.loading = 0;
    },
    sendLitter: function sendLitter() {
      var _this2 = this;

      this.loading = 1;
      var litter = (0, _assign2.default)({}, this.litter);
      litter.litters = _.pluck(this.litters, "id");

      if (Array.isArray(litter.notes)) {
        litter.notes = (0, _stringify2.default)(litter.notes);
      }

      api.updateMultipleLitters(litter).then(function (data) {
        _this2.loading = 0;
        $("#multiple-litter-form").modal("hide");
        _this2.$dispatch("refresh-litters");
      }, function (response) {
        _this2.loading = 0;
        _this2.errors = response.data.errors;
      });
    },
    initBreedTypeahead: function initBreedTypeahead() {
      this.breedersList = this.getBreedersAutocompleteList();
    }
  },
  ready: function ready() {
    this.initModal();
  },

  mixins: [App.Mixins.BreedersFilter, App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.FieldDescription]
};

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22}],801:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.NotificationTab = {
  template: "#notification-tab-template",
  data: function data() {
    return {
      activeTask: {},
      activeTasks: [],
      activeTasksCount: 0,
      transfers: [],
      transfersCount: 0,
      unseenCount: null
    };
  },
  components: {
    "litter-weight": App.Components.LitterWeight,
    "litter-butcher": App.Components.LitterButcher
  },
  events: {
    "notification-tab-reload-tasks": function notificationTabReloadTasks(msg) {
      this.load();
    }
  },
  methods: {
    onlyUnseen: function onlyUnseen(objects) {
      return objects.filter(function (object) {
        return !object.seen;
      });
    },
    openManagingModal: function openManagingModal(task) {
      this.activeTask = task;
      if (!task.read) {
        this.toggle(task);
      }

      if (task.type === "breeder" && task.subtype === "birth") {
        this.$root.$emit("open-global-birth-form", task);
      } else if (task.type === "breeder" && task.subtype === "breed") {
        this.$root.$emit("open-global-breed-form-existing", task);
      } else if (task.type === "breeder" && task.subtype === "weigh") {
        var breeder = task.breeders.length ? (0, _extends3.default)({}, task.breeders[0], { isWeight: true, task_id: task.id }) : {};
        this.$root.$emit("open-global-edit-breeder-form", breeder);
      } else if (task.type === "breeder" && task.subtype === "check") {
        this.$root.$emit("open-global-pregnancy-check-form", task);
      } else if (task.type === "litter" && task.subtype === "weigh") {
        this.$root.$emit("open-global-litter-weight", task);
      } else if (task.type === "litter" && task.subtype === "butch") {
        this.$root.$emit("open-global-litter-butcher", task);
      } else {
        this.$root.$emit("open-global-task-form", task);
      }
    },
    getFullTaskName: function getFullTaskName(task) {
      if (task.holderName) {
        if (task.type === "breeder") {
          return task.holderName + ": " + task.name;
        }
        if (task.type === "litter") {
          return "Litter " + task.holderName + ": " + task.name;
        }
      }
      return task.name;
    },
    getTaskPrefix: function getTaskPrefix(task) {
      if (task.holderName) {
        if (task.type === "breeder") {
          return task.holderName;
        }
        if (task.type === "litter") {
          return "Litter " + task.holderName;
        }
      }
      return task.name;
    },
    load: function load() {
      var _this = this;

      if (App.isSubscribed) {
        this.$http.get("/admin/notifications").then(function (response) {
          var data = response.data;
          _this.activeTasks = data.events.notifications.filter(function (event) {
            return event.closed != "1";
          });
          _this.transfers = data.transfers.notifications;
          _this.unseenCount = data.events.unseen_count + data.transfers.unseen_count;
          _this.activeTasksCount = data.events.unseen_count;
          _this.transfersCount = data.transfers.unseen_count;
          setTimeout(function () {
            _this.load();
          }, 600000);
        });
      }
    },
    acceptTransfer: function acceptTransfer(transfer) {
      if (!transfer.read) {
        this.toggle(transfer);
      }

      this.$router.go({ path: "/breeders" });
    },
    toggle: function toggle(object) {
      object.read = !object.read;
      this.$http.post("/admin/notifications/" + object.notification_id + "/read", { read: object.read });
    },
    opened: function opened() {
      var notifications = this.activeTasks.filter(function (task) {
        return !task.seen;
      }).concat(this.transfers.filter(function (transfer) {
        return !transfer.seen;
      }));
      if (notifications.length) {
        this.$http.post("/admin/notifications/seen", {
          ids: notifications.map(function (object) {
            return object.notification_id;
          })
        });
        notifications.forEach(function (notification) {
          notification.seen = true;
        });
      }
    }
  },
  ready: function ready() {
    var _this2 = this;

    this.load();

    this.$root.$on("global-notification-tab-reload", function () {
      _this2.load();
    });
  }
};

},{"babel-runtime/helpers/extends":37}],802:[function(require,module,exports){
'use strict';

var _eventBus = require('../event-bus');

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.OnOutdatedPlan = {
    template: "#on-outdated-plan-template",
    data: function data() {
        return {
            nextBillingCircle: null
        };
    },
    ready: function ready() {
        var _this = this;

        $(function () {
            _eventBus2.default.$on('on-outdated-plan', function () {
                _this.$router.go({ path: '/account' });
                api.getSubscription().then(function (data) {
                    _this.nextBillingCircle = data.plan.current_period_end || data.plan.trial_ends_at;
                    _this.$nextTick(function () {
                        setTimeout(function () {
                            $('#on-outdated-plan-modal').modal('show');
                        }, 0);
                    });
                });
            });
        });
    }
};

},{"../event-bus":882}],803:[function(require,module,exports){
'use strict';

App.Components.CopyPedigreeForm = {
    template: "#copy-pedigree-form-template",
    data: function data() {
        return {
            options: [],
            copyId: '',
            withArchived: false,
            line: 'both'
        };
    },

    props: ['type', 'id', 'name'],
    methods: {
        copy: function copy() {
            var _this = this;

            api.copyPedigree(this.type, this.copyId, this.id, this.line).then(function () {
                $('#copy-pedigree-form').modal('hide');
                _this.$dispatch('loadPedigree');
            });
        },
        load: function load() {
            var _this2 = this;

            api.getOptionsForCopyPedigree(this.type, this.id, { archived: this.withArchived }).then(function (options) {
                _this2.options = options;
            });
        }
    },
    watch: {
        withArchived: function withArchived() {
            this.load();
        },
        type: function type() {
            this.load();
        },
        id: function id() {
            this.load();
        }
    },
    created: function created() {
        this.load();
    }
};

},{}],804:[function(require,module,exports){
'use strict';

App.Components.KitPedigree = Vue.extend(App.Components.Pedigree).extend({
    template: '#pedigree-kit-template',
    data: function data() {
        return {
            id: this.$route.params.id,
            token: ''
        };
    },
    methods: {
        loadLitters: function loadLitters() {
            var _this = this;

            this.loadingPedigree = 1;

            api.getKit(this.id).then(function (data) {
                _this.token = data.token;
            });

            var params = {
                generations: this.settings.generations,
                pedigree_id: this.pedigreeId
            };
            api.getKitPedigree(this.id, params).then(function (data) {
                _this.generations = data;
                _this.loadingPedigree = 0;
            });
        }
    },
    ready: function ready() {
        var _this2 = this;

        $('#copy-pedigree-form').on('hidden.bs.modal', function (e) {
            _this2.loadLitters();
        });

        this.type = "kit";
    }
});

},{}],805:[function(require,module,exports){
"use strict";

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.PedigreeCard = {
  template: "#pedigree-card-template",
  data: function data() {
    return {
      newNote: "",
      noteIndexToEdit: {}
    };
  },

  props: ["generation", "generationKey", "pedigree", "settings", "cardBody"],
  components: {
    "breeder-menu": App.Components.BreederMenu
  },
  computed: {
    parseNotes: function parseNotes() {
      var notes = this.pedigree.notes;
      return JSON.parse(notes);
    }
  },
  events: {
    expandCards: function expandCards(state) {
      if (!this.isGeneration(1)) {
        var element = $("#expand-" + this.getGenerationSlug());

        if (String(state) != element.attr("aria-expanded")) {
          element.click();
        }
      }
    }
  },
  watch: {},
  methods: {
    isGeneration: function isGeneration() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return "g" + key == this.generation;
    },
    getGenerationSlug: function getGenerationSlug() {
      var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "-";

      return this.generation + separator + this.generationKey || "1";
    },

    redirectTo: function redirectTo(kit) {

      var path = kit.rabbit_breeders_id != null ? '/profile/' + kit.rabbit_breeders_id : '/litterprofile/' + kit.kit.litter_id;

      $('.profile-tabs li').removeClass('active');
      $('.profile-tabs li:first-child').addClass('active');
      $('.tab-content .tab-pane').removeClass('active');
      $('.tab-content .tab-pane:first-child').addClass('active');

      this.$router.go({
        path: path
      });
    },
    getGenerationLabel: function getGenerationLabel(level) {
      if (level == "me" || !level) {
        return "1ST GENERATION";
      }

      var _level$split = level.split("."),
          _level$split2 = (0, _slicedToArray3.default)(_level$split, 2),
          slug = _level$split2[0],
          type = _level$split2[1];

      var gen = slug.replace("g", "");

      return this.toOrdinal(gen) + " GENERATION";
    },
    getCardLayout: function getCardLayout() {
      var borderType = this.settings.borderType;
      var colorScheme = this.settings.colorScheme;
      var color = this.pedigree.css.color.replace("bg-", "") + "-" + colorScheme;
      var className = "border-" + borderType + " border-" + color + " ";

      if (borderType == "v1" || borderType == "v4") {
        className += "header-" + color;
      }

      return className;
    },
    dispatchEvent: function dispatchEvent(event, data) {
      this.$dispatch(event, data);
    },
    openNote: function openNote() {
      var note = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.noteIndexToEdit = {
        key: index,
        note: note
      };
    },
    deleteNote: function deleteNote(index) {
      this.openNote(null, index);
      this.defineNote();
    },
    defineNote: function defineNote() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "update";

      var pedigree = this.pedigree;

      // build notes data
      var notes = JSON.parse(pedigree.notes || "[]");

      // alter notes data
      if (action == "update") {
        if (this.noteIndexToEdit.note != null) {
          var note = this.sanitizeNote(this.noteIndexToEdit.note);
          notes[this.noteIndexToEdit.key] = note;
        } else {
          notes.splice(this.noteIndexToEdit.key, 1);
        }
      } else {
        if (!this.newNote) {
          return false;
        }

        var _note = this.sanitizeNote(this.newNote);
        notes.push(_note);

        this.newNote = ""; // reset new note data
      }

      // set notes data
      pedigree.notes = (0, _stringify2.default)(notes);

      // reset data
      this.noteIndexToEdit = {};

      this.dispatchEvent("notesUpdated", pedigree);
    },
    sanitizeNote: function sanitizeNote() {
      var note = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      return note.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
  },
  ready: function ready() {
    $("#notes-toggle-" + this.getGenerationSlug()).netlivaSwitch({
      width: "35px"
    });
  },

  mixins: [App.Mixins.Currency]
};

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/helpers/slicedToArray":40}],806:[function(require,module,exports){
"use strict";

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.PedigreeForm = {
    template: "#pedigree-form-template",
    data: function data() {
        return {
            bucks: [],
            does: [],
            newBuck: {
                sex: "buck"
            },
            newDoe: {
                sex: "doe"
            },
            errors: {},
            warnings: {},
            options: [],
            typeaheadPedigrees: [],
            rabbit: '',
            loading: 0,
            checked: false,
            updateAll: false,
            breedersList: [],
            getBygenotypeCodeValue: "",
            isBrokenChecked: false,
            editBreederId: null
        };
    },
    created: function created() {
        this.fetchBreeders();
    },
    props: ['breeder', 'breeders', 'pedigree'],
    components: {
        'image-upload': App.Components.ImageUpload,
        'lbs-oz-input': App.Components.LbsOzInput
    },
    computed: {
        weight_unit: function weight_unit() {
            if (this.breeder.breeder) {
                return this.breeder.breeder.weight_unit;
            } else if (this.breeder.kit) {
                return this.breeder.kit.weight_unit;
            }
        },
        weight_unit_short: function weight_unit_short() {
            if (this.breeder.breeder) {
                return this.breeder.breeder.weight_unit_short;
            } else if (this.breeder.kit) {
                return this.breeder.kit.weight_unit_short;
            }
        },
        flattenBreeders: function flattenBreeders() {
            return _.flatten([].concat(this.does, this.bucks));
        },
        flattenPedigreeBreeders: function flattenPedigreeBreeders() {
            return this.flattenBreederData(this.pedigree);
        }
    },
    watch: {
        breeder: function breeder() {
            $('#breederSelect').val(this.breeder.rabbit_breeders_id).trigger('change');
            this.checked = this.breeder.rabbit_breeders_id || !(this.breeder.prefix || this.breeder.name || this.breeder.color || this.breeder.breed || this.breeder.aquired || this.breeder.weight || this.breeder.registration_number || this.breeder.champion_number || this.breeder.legs);

            this.updatePedigreeFields();
            this.updateAll = false;

            if (this.breeder.id != this.editBreederId) {
                this.editBreederId = this.breeder.id;
            }
        },
        checked: function checked(val) {
            var _this = this;

            if (!val) {
                this.initTypeahead();
                this.refreshPedigreeTypeaheads();
                $('#update-manually').iCheck("check");
            } else {
                $('#import-breeder').iCheck("check");

                this.$nextTick(function () {
                    $('#breederSelect').val(_this.breeder.rabbit_breeders_id).trigger('change');
                });
            }
        },
        rabbit: function rabbit(val, oldVal) {
            var _this2 = this;

            if (val !== "") {
                this.typeaheadPedigrees = [];
                api.fetchBreeder(val).then(function (resp) {
                    // remove the .data if not sent by server
                    _this2.fillPedigree(resp);
                    _this2.updateAll = true;
                }).bind(this);
            } else {
                this.checked = false;
            }
        },
        editBreederId: function editBreederId(newVal) {
            if (this.breeder.id != newVal) {
                this.breeder = _.find(this.flattenPedigreeBreeders, function (breeder) {
                    return breeder.id == newVal;
                });;
            }
        }
    },
    methods: {
        flattenBreederData: function flattenBreederData(data) {
            var pedigree = [];
            var self = this;
            (0, _keys2.default)(data).forEach(function (key) {
                if (data[key].level) {
                    pedigree.push(data[key]);
                } else {
                    var item_data = self.flattenBreederData(data[key]);
                    pedigree = [].concat((0, _toConsumableArray3.default)(pedigree), (0, _toConsumableArray3.default)(item_data.reverse()));
                }
            });

            // remove first element (level = me)
            return _.filter(pedigree, function (breeder) {
                return breeder.level != 'me';
            });
        },

        brokenChecked: function brokenChecked() {
            if (this.isBrokenChecked) {
                this.$set('breeder.genotype[10]', "En");
            } else {
                this.$set('breeder.genotype[10]', "en");
            }
            this.$set('breeder.genotype[11]', "en");
        },
        updatePedigreeFields: function updatePedigreeFields() {
            $('#pedigree-prefix').typeahead('val', this.breeder.prefix);
            $('#pedigree-color').typeahead('val', this.breeder.color);
            this.$nextTick(function () {
                return $('#icheck-breeder-blue-pedigree, #icheck-breeder-red-pedigree').iCheck('update');
            });
        },
        fillPedigree: function fillPedigree(data) {
            var pedigree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.breeder.prefix = data.prefix;
            this.breeder.name = data.name;
            this.breeder.color = data.color;
            this.breeder.breed = data.breed;
            this.breeder.aquired = data.aquired;
            this.breeder.weight = data.weight;
            this.breeder.registration_number = data.registration_number;
            this.breeder.champion_number = data.champion_number;
            this.breeder.legs = data.legs;
            this.breeder.image = data.image;

            if (pedigree) {
                this.breeder.custom_id = data.custom_id;
                this.breeder.notes = data.notes;
                this.breeder.day_of_birth = data.day_of_birth;

                this.updatePedigreeFields();
            } else {
                this.breeder.sex = data.sex;
                this.breeder.custom_id = data.tattoo;
                this.breeder.day_of_birth = data.date_of_birth;
            }
        },
        fetchBreeders: function fetchBreeders() {
            var _this3 = this;

            this.$http.get('/admin/fetchBreeders').then(function (resp) {
                // remove the .data if not sent by server
                _this3.options = resp;
            }).bind(this);
        },

        initModal: function initModal() {
            var _this6 = this;

            api.getBreedersList().then(function (breeders) {
                _this6.bucks = breeders.bucks;
                _this6.does = breeders.does;
                _this6.initTypeahead();
            });
            this.refreshPedigreeTypeaheads();
        },

        initTypeahead: function initTypeahead() {
            var colors = this.uniqueFieldSet(this.flattenBreeders, "color");
            var prefixes = this.uniqueFieldSet(this.flattenBreeders, "prefix");

            $('#pedigree-prefix').typeahead({
                hint: true,
                highlight: true,
                minLength: 0
            }, {
                source: this.substringMatcher(prefixes)
            });

            $('#pedigree-color').typeahead({
                hint: true,
                highlight: true,
                minLength: 0
            }, {
                source: this.substringMatcher(colors)
            });
        },

        sendBreeder: function sendBreeder() {
            var notesOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var _this7 = this;

            var closeModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var isPrevious = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this.cleanUpGenotypes();
            this.loading = 1;
            this.breeder.weight_date = Date.now();
            if (this.isBrokenChecked == true) {
                this.isBrokenChecked = false;
            }
            var breeder = this.breeder;

            if (!notesOnly) {
                breeder.rabbit_breeders_id = this.checked ? $('#breederSelect option:selected').val() : null;
            }

            api.savePedigree(breeder).then(function (data) {
                _this7.loading = 0;

                var pedigreeData = (0, _extends3.default)({}, data, { localLevel: breeder.localLevel || null });
                _this7.$dispatch('pedigreeSaved', pedigreeData, _this7.updateAll);
                _this7.rabbit = '';

                if (closeModal) {
                    $('#pedigree-form').modal('hide');
                } else {
                    var allBreeders = _this7.flattenPedigreeBreeders;
                    var currentIndex = null;
                    _.map(allBreeders, function (item, index) {
                        if (item.id == breeder.id) {
                            currentIndex = isPrevious ? index - 1 : index + 1;
                        }
                    });

                    var nextBreeder = _.find(allBreeders, function (item, index) {
                        if (currentIndex == index) {
                            return true;
                        }
                    });

                    if (!nextBreeder) {
                        nextBreeder = isPrevious ? allBreeders[allBreeders.length - 1] : allBreeders[0];
                    }

                    _this7.editBreederId = nextBreeder.id;
                }
            }, function (response) {
                _this7.loading = 0;
                _this7.errors = response.data.errors;
            });
        },


        checkDoubledId: function checkDoubledId() {
            var _this8 = this;

            api.checkBreederId(this.breeder.tattoo).then(function (check) {
                if (check.idDoubled) {
                    _this8.warnings = { tattoo: ['Sorry, this Breeder ID already exists. Please choose a unique Breeder ID or archive the rabbit with the duplicate ID first.'] };
                } else {
                    _this8.warnings = {};
                }
            });
        },

        addNewBuck: function addNewBuck() {
            var _this4 = this;

            this.loading = 1;
            api.saveBreeder(_.extend({}, App.emptyBreeder, this.newBuck)).then(function (data) {
                _this4.loading = 0;
                if (data.id) {
                    _this4.breeder.prefix = '';
                    _this4.bucks.push(data);
                    _this4.breeder.father_id = data.id;
                    _this4.newBuck = { sex: "buck" };
                }
            });
        },

        addNewDoe: function addNewDoe() {
            var _this5 = this;

            this.loading = 1;
            api.saveBreeder($.extend({}, App.emptyBreeder, this.newDoe)).then(function (data) {
                _this5.loading = 0;
                if (data.id) {
                    _this5.does.push(data);
                    _this5.breeder.mother_id = data.id;
                    _this5.newDoe = { sex: "doe" };
                }
            });
        },
        initBreedersListTypeahead: function initBreedersListTypeahead() {
            this.breedersList = this.getBreedersAutocompleteList();
        },
        findPedigrees: function findPedigrees(field, value) {
            var _this9 = this;

            if (!value || value.length < 2) {
                return;
            }

            var data = {};
            data[field] = value;

            api.findPedigrees(data).then(function (response) {
                _this9.typeaheadPedigrees = response.map(function (item, i) {
                    if (i !== 0) {
                        return { 'obj': item, 'value': item[field], 'label': item.name + ': ' + item.custom_id };
                    }

                    if (response.length === 1) {
                        return { 'obj': item, 'value': item[field], 'label': 'Import From Existing?' };
                    } else if (response.length >= 1) {
                        return { 'obj': item, 'value': item[field], 'label': 'Select Existing' };
                    }
                });
                _this9.initPedigreeTypeahead(field);
            });

            if (value === 'custom_id') {
                this.checkDoubledId(value);
            }
        },
        initPedigreeTypeahead: function initPedigreeTypeahead(field) {
            var _this10 = this;

            $('#pedigree-' + field).typeahead('destroy');
            $('#pedigree-' + field).typeahead({
                hint: true,
                highlight: true,
                order: "asc",
                minLength: 0
            }, {
                limit: 100,
                source: function source(req, callback) {
                    callback(_this10.typeaheadPedigrees);
                },
                displayKey: 'value',
                templates: {
                    suggestion: function suggestion(pedigree) {
                        if (pedigree.obj.id === _this10.typeaheadPedigrees[0].obj.id) {
                            return '<div class="tt-suggestion tt-selectable pedigree-typeahead-select"><i class="fa fa-check"></i>&nbsp;' + pedigree.label + '</div>';
                        }
                        return '<div class="tt-suggestion tt-selectable">' + pedigree.label + '</div>';
                    }
                }
            }).bind('typeahead:select', function (ev, suggestion) {
                _this10.fillPedigree(suggestion.obj, true);
            });
            $('#pedigree-' + field).focus();
        },
        refreshPedigreeTypeaheads: function refreshPedigreeTypeaheads() {
            this.typeaheadPedigrees = [];
            this.initPedigreeTypeahead('custom_id');
            this.initPedigreeTypeahead('name');
        },
        setBygenotypeCode: function setBygenotypeCode() {
            this.breeder.genotype = [];
            var geno = this.getBygenotypeCodeValue.split("/");
            for (var i = 0; i < 10; i++) {
                this.breeder.genotype[i] = geno[i];
            }
            this.breeder.genotype[10] = "en";
            this.breeder.genotype[11] = "en";
        },
        initializeRadioButtons: function initializeRadioButtons() {
            var _this11 = this;

            var iCheckClass = {
                checkboxClass: "icheckbox_square-blue",
                radioClass: "iradio_square-blue",
                inheritClass: true
            };

            $('#import-breeder').iCheck(iCheckClass).on("ifChecked", function (event) {
                _this11.checked = true;
            });

            $('#update-manually').iCheck(iCheckClass).on("ifChecked", function (event) {
                _this11.checked = false;

                _this11.$nextTick(function () {
                    $("#icheck-breeder-blue-pedigree").iCheck(iCheckClass).on("ifChecked", function (event) {
                        _this11.breeder.sex = "buck";
                    });

                    $("#icheck-breeder-red-pedigree").iCheck((0, _extends3.default)({}, iCheckClass, {
                        checkboxClass: "icheckbox_square-red",
                        radioClass: "iradio_square-red"
                    })).on("ifChecked", function (event) {
                        _this11.breeder.sex = "doe";
                    });
                });
            });
        },
        parseGeneration: function parseGeneration(level) {
            var _level$split = level.split("."),
                _level$split2 = (0, _slicedToArray3.default)(_level$split, 2),
                slug = _level$split2[0],
                type = _level$split2[1];

            var gen = slug.replace("g", "");

            return gen;
        },
        getBreederName: function getBreederName(breeder) {
            var isPrevious = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var allBreeders = this.flattenPedigreeBreeders;
            var currentIndex = null;
            _.map(allBreeders, function (item, index) {
                if (item.id == breeder.id) {
                    currentIndex = isPrevious ? index - 1 : index + 1;
                }
            });

            var nextBreeder = _.find(allBreeders, function (item, index) {
                if (currentIndex == index) {
                    return true;
                }
            });

            if (!nextBreeder) {
                nextBreeder = isPrevious ? allBreeders[allBreeders.length - 1] : allBreeders[0];
            }

            return nextBreeder.name || (isPrevious ? 'Previous' : 'Next') + " Breeder";
        }
    },
    ready: function ready() {
        this.initModal();
        this.initBreedersListTypeahead();
        this.initGenotypes();
        this.initializeRadioButtons();
    },
    events: {
        pedigree_form_refresh: function pedigree_form_refresh() {
            this.refreshPedigreeTypeaheads();
        },
        notesUpdated: function notesUpdated(pedigree) {
            this.breeder = pedigree;
            this.sendBreeder(true);
        }
    },

    mixins: [App.Mixins.Generic, App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.Weightable, App.Mixins.FieldDescription]
};

},{"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37,"babel-runtime/helpers/slicedToArray":40,"babel-runtime/helpers/toConsumableArray":41}],807:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.PedigreeLayout = {
  template: "#pedigree-layout-template",
  data: function data() {
    return {
      cardBody: {}
    };
  },

  props: ["generations", "settings"],
  components: {
    "pedigree-card": App.Components.PedigreeCard,
    "parent-layout": App.Components.PedigreeParentLayout
  },
  computed: {
    sortedGenerations: function sortedGenerations() {
      var unordered = this.generations;
      var ordered = {};

      (0, _keys2.default)(unordered).sort().forEach(function (key) {
        ordered[key] = unordered[key];
      });

      return ordered;
    },

    /**
     * Build tree pedigree data for easier data presentation
     */
    generationsTree: function generationsTree() {
      var generations = this.generations;

      if (!generations.g2) {
        return [];
      }

      var tree = {
        father: this.getPedigreeParents(generations.g2.f1, "g2.f1"),
        mother: this.getPedigreeParents(generations.g2.m1, "g2.m1")
      };

      return tree;
    }
  },
  events: {},
  watch: {},
  methods: {
    /**
     * Recursively fetch pedigree parent data
     *
     * @param {*} pedigree
     * @param {*} level
     */
    getPedigreeParents: function getPedigreeParents(pedigree, level) {
      pedigree.localLevel = level;

      if (!pedigree.parents) {
        return pedigree;
      }

      var generation = pedigree.parents.father.generation;
      var father_key = pedigree.parents.father.key;
      var mother_key = pedigree.parents.mother.key;

      var father = this.getPedigreeParents(this.generations[generation][father_key], generation + "." + father_key);
      var mother = this.getPedigreeParents(this.generations[generation][mother_key], generation + "." + mother_key);

      var parents = {
        father: father,
        mother: mother
      };

      pedigree.children = parents;

      return pedigree;
    },
    pairedGeneration: function pairedGeneration(key) {
      var pedigrees = this.generations[key];
      var generationLength = Math.pow(2, parseInt(key.replace(/^\D+/g, "")) - 1) / 2;
      var pairedPedigrees = {};

      for (var i = 1; i <= generationLength; i++) {
        pairedPedigrees[i] = {
          m: pedigrees["m" + i],
          f: pedigrees["f" + i]
        };
      }

      return pairedPedigrees;
    },
    initializeCardBody: function initializeCardBody() {
      var _this = this;

      api.fetchPedigreeCardBody({ layout: this.settings.web_layout }).then(function (data) {
        _this.cardBody = data.body;
      });
    }
  },
  ready: function ready() {
    this.initializeCardBody();
    $(".mindmap").mindmap();
  }
};

},{"babel-runtime/core-js/object/keys":27}],808:[function(require,module,exports){
"use strict";

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.PedigreeParentLayout = {
  name: "parent-layout",
  template: "#pedigree-parent-layout-template",
  data: function data() {},

  props: ["settings", "node", "cardBody"],
  components: {
    "pedigree-card": App.Components.PedigreeCard
  },
  computed: {
    generation: function generation() {
      var _node$localLevel$spli = this.node.localLevel.split("."),
          _node$localLevel$spli2 = (0, _slicedToArray3.default)(_node$localLevel$spli, 2),
          slug = _node$localLevel$spli2[0],
          type = _node$localLevel$spli2[1];

      return slug;
    },
    generationKey: function generationKey() {
      var _node$localLevel$spli3 = this.node.localLevel.split("."),
          _node$localLevel$spli4 = (0, _slicedToArray3.default)(_node$localLevel$spli3, 2),
          slug = _node$localLevel$spli4[0],
          type = _node$localLevel$spli4[1];

      return type;
    }
  },
  events: {},
  watch: {},
  methods: {},
  ready: function ready() {}
};

},{"babel-runtime/helpers/slicedToArray":40}],809:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.PedigreeSettings = {
  template: "#pedigree-settings-template",
  data: function data() {
    return {
      toggles: {
        prefix: true,
        name: true,
        photo: true,
        breed: true,
        birthdate: true,
        champ_number: true,
        ear_number: true,
        weight: true,
        genotype: true,
        color: true,
        reg_number: true,
        legs: true,
        acquired_date: true
      },
      borderType: "v1",
      colorScheme: "v1",
      layout: "horizontal",
      web_layout: "horizontal",
      generations: 4
    };
  },
  props: ["settings"],
  components: {},
  computed: {},
  watch: {},
  methods: {
    saveSettings: function saveSettings() {
      var _this = this;

      var data = {
        toggles: this.toggles,
        border_type: this.borderType,
        color_scheme: this.colorScheme,
        layout: this.layout,
        web_layout: this.web_layout,
        generations: this.generations
      };

      api.postPedigreeSettings(window.user_id, data).then(function (res) {
        $("#pedigree-settings").modal("hide");

        var settings = {
          toggles: _this.toggles,
          borderType: _this.borderType,
          colorScheme: _this.colorScheme,
          layout: _this.layout,
          web_layout: _this.web_layout,
          generations: _this.generations
        };

        _this.$dispatch("settingsUpdated", settings);
      });
    },
    setSettingsData: function setSettingsData() {
      var _this2 = this;

      $("input[name='borderType'][value='" + this.borderType + "']").iCheck("check");
      $("input[name='colorScheme'][value='" + this.colorScheme + "']").iCheck("check");
      $("input[name='web_layout'][value='" + this.web_layout + "']").iCheck("check");

      (0, _keys2.default)(this.toggles).forEach(function (key) {
        $("#" + key + "-toggle").netlivaSwitch("state", _this2.toggles[key]);
      });
    }
  },
  events: {
    initializeSettings: function initializeSettings(data) {
      var _this3 = this;

      (0, _keys2.default)(data).forEach(function (key) {
        _this3[key] = data[key];
      });

      this.setSettingsData();
    }
  },
  ready: function ready() {
    var _this4 = this;

    // initialize radio buttons
    $(".js_icheck-green").iCheck({
      checkboxClass: "icheckbox_square-green",
      radioClass: "iradio_square-green"
    }).on("ifChecked", function (event) {
      _this4[event.target.name] = event.target.value;
    });

    // initialize data toggles
    (0, _keys2.default)(this.toggles).forEach(function (key) {
      $("#" + key + "-toggle").netlivaSwitch({ width: "35px" }).on("netlivaSwitch.change", function (event, state, element) {
        _this4.toggles[key] = state;
      });
    });

    // set radio buttons initial values
    this.setSettingsData();
  },
  mixins: [App.Mixins.Generic]
};

},{"babel-runtime/core-js/object/keys":27}],810:[function(require,module,exports){
'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Pedigree = {
    template: "#pedigree-template",
    data: function data() {
        return {
            breeder: {
                image: {}
            },
            mainBreeder: {},
            generations: {
                g1: {}
            },
            loadingPedigree: 1,
            importError: '',
            importedPedigree: false,
            hutchImportUrl: '',
            token: '',
            layout: 'horizontal',
            currentZoom: 1,
            settings: {
                toggles: {
                    prefix: true,
                    name: true,
                    photo: true,
                    breed: true,
                    birthdate: true,
                    champ_number: true,
                    ear_number: true,
                    weight: true,
                    genotype: true,
                    color: true,
                    reg_number: true,
                    legs: true,
                    acquired_date: true
                },
                borderType: "v1",
                colorScheme: "v1",
                layout: "horizontal",
                generations: 4
            },
            pedigreeId: null,
            downloadUrl: "",
            selectedFieldsCount: 0,
            isPreventWarning: false,
            type: 'breeder',
            btn_name: [],
            pedigreeEmailTo: '',
            loadingEmail: 0,
            pedigreeEmailErrors: {}
        };
    },
    components: {
        'pedigree-form': App.Components.PedigreeForm,
        'copy-pedigree-form': App.Components.CopyPedigreeForm,
        'pedigree-settings': App.Components.PedigreeSettings,
        'pedigree-layout': App.Components.PedigreeLayout
    },
    props: {
        id: null,
        token: {
            type: null,
            default: ''
        }
    },
    computed: {
        breedSex: function breedSex() {
            if (this.breeder.sex === "doe") {
                return "Doe";
            } else if (this.breeder.sex === "buck") {
                return "Buck";
            } else {
                return "Breed";
            }
        },
        breedName: function breedName() {
            return this.breeder.name;
        },
        breedSexClass: function breedSexClass() {
            if (this.breeder.sex === "doe") {
                return "box-danger";
            } else if (this.breeder.sex === "buck") {
                return "box-info";
            }
        },
        confirmTarget: function confirmTarget() {
            return this.breeder.name;
        },
        generationSize: function generationSize() {
            return this.settings.generations;
        }
    },
    watch: {
        loadingPedigree: function loadingPedigree(newData) {
            var _this = this;

            if (!newData) {
                // setup zoom
                this.currentZoom = 1;
                for (var i = 4; i < this.generationSize; i++) {
                    this.currentZoom -= .15;
                }

                // for breeder profile page
                this.initializeExpandAll();

                // execute zoom and scroll after all elements are loaded
                this.$nextTick(function () {
                    if (_this.generationSize > 4) {
                        $(".mindmap").animate({ 'zoom': _this.currentZoom }, 'slow', function () {
                            $("#main-card").get(0).scrollIntoView({ block: 'center' });
                        }).css("-moz-transform", "scale(" + _this.currentZoom + ")").css("-moz-transform-origin", "top left");
                    }
                });
            }
        },
        pedigreeEmailTo: function pedigreeEmailTo(newData) {
            this.pedigreeEmailErrors = {};
        }
    },
    methods: {
        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        viewExtendedPedigree: function viewExtendedPedigree(id) {
            // refresh data
            this.pedigreeId = id;
            this.loadLitters();
        },
        zoomIn: function zoomIn() {
            $(".mindmap").animate({ 'zoom': this.currentZoom += .15 }, 'slow').css("-moz-transform", "scale(" + this.currentZoom + ")").css("-moz-transform-origin", "top left");
        },
        zoomOut: function zoomOut() {
            $(".mindmap").animate({ 'zoom': this.currentZoom -= .15 }, 'slow').css("-moz-transform", "scale(" + this.currentZoom + ")").css("-moz-transform-origin", "top left");
        },
        resetZoom: function resetZoom() {
            this.currentZoom = 1;
            this.viewExtendedPedigree(null);
            $(".mindmap").animate({ 'zoom': 1 }, 'slow').css("-moz-transform", "scale(1)").css("-moz-transform-origin", "top left");
        },

        showProfile: function showProfile(id, callback) {
            var _this2 = this;

            var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            api.getPedigree(id).then(function (data) {
                _this2.breeder = data;

                if (level) {
                    _this2.breeder.localLevel = level;
                }
                if (callback != undefined) {
                    callback();
                }
            });
        },
        loadLitters: function loadLitters() {
            var _this3 = this;

            this.loadingPedigree = 1;

            var params = {
                generations: this.settings.generations,
                pedigree_id: this.pedigreeId
            };

            if (this.id) {
                api.getBreederPedigree(this.id, params).then(function (data) {
                    _this3.generations = data;
                    _this3.mainBreeder = data.g1.breeder;
                    _this3.loadingPedigree = 0;
                });
            }
        },
        loadPedigreeSettings: function loadPedigreeSettings() {
            var _this4 = this;

            api.getUserSettingsData(window.user_id).then(function (data) {
                if (data.user.pedigree_settings) {
                    _this4.settings = (0, _extends3.default)({}, data.user.pedigree_settings);
                    _this4.settings.borderType = _this4.settings.border_type || 'v1';
                    _this4.settings.colorScheme = _this4.settings.color_scheme || 'v1';
                }

                _this4.initializeSettings();
                _this4.loadLitters();
            });
        },


        edit: function edit(id) {
            var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (this.importedPedigree || !this.isBreederActive(this.mainBreeder)) {
                return;
            }

            this.showProfile(id, this.showModal, level);
        },

        showModal: function showModal() {
            this.$broadcast('pedigree_form_refresh');
            $('#pedigree-form').modal('show');
        },
        showCopy: function showCopy() {
            $('#copy-pedigree-form').modal('show');
        },


        showHutchImportModal: function showHutchImportModal() {
            $('#hutch-import-modal').modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#hutch-import-modal').modal('show');
        },
        hutchImport: function hutchImport() {
            var _this5 = this;

            if (this.loadingPedigree || !this.hutchImportUrl) {
                return;
            }

            this.importError = '';
            this.loadingPedigree = 1;

            api.importPedigree(this.id, null, this.hutchImportUrl, this.type).then(function (data) {
                _this5.generations = data;
                _this5.loadingPedigree = 0;
                _this5.importedPedigree = true;
            }).catch(function (response) {
                _this5.importError = 'Error while importing Everbreed pedigree';
                _this5.loadingPedigree = 0;
                _this5.importedPedigree = false;
            });

            $('#hutch-import-modal').modal('hide');
        },
        importImage: function importImage(e) {
            var _this6 = this;

            if (this.loadingPedigree || !$(e.target).val()) {
                return;
            }

            this.importError = '';
            this.loadingPedigree = 1;

            api.importPedigree(this.id, e.target.files[0], null, this.type, true).then(function (data) {
                _this6.generations = data;
                _this6.loadingPedigree = 0;
                _this6.importedPedigree = true;
            }).catch(function (response) {
                _this6.importError = 'Error while importing pedigree image';
                _this6.loadingPedigree = 0;
                _this6.importedPedigree = false;
            });
        },
        import: function _import(e) {
            var _this7 = this;

            if (this.loadingPedigree || !$(e.target).val()) {
                return;
            }

            this.importError = '';
            this.loadingPedigree = 1;

            api.importPedigree(this.id, e.target.files[0], null, this.type).then(function (data) {
                _this7.generations = data;
                _this7.loadingPedigree = 0;
                _this7.importedPedigree = true;
            }).catch(function (response) {
                _this7.importError = 'Error while importing Evans pedigree';
                _this7.loadingPedigree = 0;
                _this7.importedPedigree = false;
            });
        },
        saveImportedPedigree: function saveImportedPedigree() {
            var _this8 = this;

            this.importedPedigree = false;
            api.saveImportedPedigree(this.id, this.generations, this.type).then(function (data) {
                _this8.loadLitters();
            });
        },
        cancelImportedPedigree: function cancelImportedPedigree() {
            this.importedPedigree = false;
            this.loadLitters();
        },
        updatePedigree: function updatePedigree(pedigreeData) {
            var match = void 0;

            if (pedigreeData.level === 'me' || pedigreeData.localLevel && pedigreeData.localLevel.includes('g1')) {
                match = this.generations['g1'];
            } else {
                var level = pedigreeData.localLevel || pedigreeData.level;

                var _level$split = level.split('.'),
                    _level$split2 = (0, _slicedToArray3.default)(_level$split, 2),
                    gen = _level$split2[0],
                    type = _level$split2[1];

                match = this.generations[gen][type];
            }

            if (match) {
                _.extend(match, pedigreeData);
            }
        },
        switchLayout: function switchLayout() {
            this.layout = this.layout === 'vertical' ? 'horizontal' : 'vertical';
        },
        triggerImportFile: function triggerImportFile() {
            this.$els.importfile.click();
        },
        triggerImportFileImage: function triggerImportFileImage() {
            this.$els.importfileimage.click();
        },
        showSettings: function showSettings() {
            this.initializeSettings();
            $('#pedigree-settings').modal('show');
        },
        initializeSettings: function initializeSettings() {
            try {
                var settings = (0, _extends3.default)({}, this.settings);
                settings.toggles = (0, _extends3.default)({}, this.settings.toggles), this.$broadcast('initializeSettings', settings);
            } catch (e) {}
        },
        expandCards: function expandCards(state) {
            this.$broadcast('expandCards', state);
        },
        initializeExpandAll: function initializeExpandAll() {
            var _this9 = this;

            $("#pedigree-expand-all").netlivaSwitch({
                width: "35px"
            }).on("netlivaSwitch.change", function (event, state, element) {
                _this9.expandCards(state);
            });
        },
        downloadPDF: function downloadPDF(url) {
            var _this10 = this;

            this.downloadUrl = url;
            var isPreventWarning = JSON.parse(localStorage.getItem('preventPedigreePdfWarning'));
            var settings = (0, _keys2.default)(this.settings.toggles).filter(function (key) {
                return _this10.settings.toggles[key] == true && !['name', 'photo', 'prefix'].includes(key);
            });

            if ((0, _keys2.default)(settings).length > 8 && !isPreventWarning) {
                this.selectedFieldsCount = (0, _keys2.default)(settings).length;
                $('#pedigree-pdf-warning').modal('show');
            } else {
                this.executeDownload();
            }
        },
        emailPDF: function emailPDF() {
            $('#email-pedigree-modal').modal('show');
        },
        sendEmail: function sendEmail() {
            var _this11 = this;

            this.loadingEmail = 1;
            api.emailPedigreePdf({ id: this.mainBreeder.id, email: this.pedigreeEmailTo }).then(function (data) {
                $('#email-pedigree-modal').modal('hide');
                _this11.showAlert({
                    type: 'success',
                    text: 'Your request is being processed. The Pedigree PDF will be sent to your email shortly.'
                });

                _this11.pedigreeEmailTo = '';
                _this11.loadingEmail = 0;
            }).catch(function (response) {
                _this11.pedigreeEmailErrors = response.data.errors;
                _this11.loadingEmail = 0;
            });;
        },
        executeDownload: function executeDownload() {
            localStorage.setItem('preventPedigreePdfWarning', !!this.isPreventWarning);
            document.location.href = this.downloadUrl;
            $('#pedigree-pdf-warning').modal('hide');
        }
    },
    events: {
        viewPedigree: function viewPedigree(id) {
            this.viewExtendedPedigree(id);
        },

        loadPedigree: function loadPedigree() {
            this.loadPedigreeSettings();
        },
        pedigreeSaved: function pedigreeSaved(data, updateAll) {
            if (updateAll) {
                this.loadLitters();
            } else {
                this.updatePedigree(data);
            }
        },
        editPedigree: function editPedigree(data) {
            this.edit(data.id, data.level);
        },
        notesUpdated: function notesUpdated(data) {
            this.$broadcast("notesUpdated", data);
        },
        settingsUpdated: function settingsUpdated(data) {
            var oldSettings = this.settings;
            this.settings = (0, _extends3.default)({}, data);

            if (oldSettings.generations != this.settings.generations) {
                this.loadPedigreeSettings();
            }
        }
    },
    ready: function ready() {
        this.initializeExpandAll();
        this.loadPedigreeSettings();
        this.getCurrentData();
    },

    mixins: [App.Mixins.Generic, App.Mixins.Breeders, App.Mixins.Alerts]
};

},{"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37,"babel-runtime/helpers/slicedToArray":40}],811:[function(require,module,exports){
"use strict";

App.Components.ProfileHealth = App.Components.Health.extend({
  template: "#profile-health-template",
  methods: {
    changeType: function changeType() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "health-records";

      this.type = type;
    }
  },
  ready: function ready() {
    this.type = "health-records";
  }
});

},{}],812:[function(require,module,exports){
"use strict";

App.Components.ProfileReportsV2 = App.Components.ProfileReports.extend({
    template: "#profile-reports-v2-template"
});

},{}],813:[function(require,module,exports){
"use strict";

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.ProfileReports = Vue.extend({
    template: "#profile-reports-template",
    data: function data() {
        var _this = this;

        return {
            meatProduction: {
                limit: 9,
                otherColor: "#CCC"
            },
            loadingStatics: 1,
            loadingReportsData: 1,
            loadingBucks: 1,
            weightSlug: "",
            statistics: {},
            activeLitter: {},
            missedType: 'does',
            weightData: [],
            meatData: [],
            selectedDoesInGrowthRatePerLitterChart: [],
            showReasonForDeathChart: false,
            totalMeat: 0,
            report_date_range: {
                from: null,
                to: null
            },
            show: {
                production: true,
                meatProduction: true,
                butcherAge: true,
                liveAndDied: true,
                missed: true,
                avgLitterSize: true,
                costsPerBreeder: true,
                avgKitWeightPerLitter: true,
                growthRatePerLitter: true,
                kitsStatus: true
            },
            datasets: {
                production: [],
                meatProduction: [],
                butcherAge: [],
                liveAndDied: [],
                missed: [],
                avgLitterSize: [],
                costsPerBreeder: [],
                avgKitWeightPerLitter: [],
                growthRatePerLitter: [],
                kitsStatus: []
            },
            labels: {
                production: [],
                meatProduction: [],
                butcherAge: [],
                liveAndDied: [],
                missed: [],
                avgLitterSize: [],
                costsPerBreeder: [],
                avgKitWeightPerLitter: [],
                growthRatePerLitter: [],
                kitsStatus: []
            },
            options: {
                production: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            title: function title(tooltipItem, data) {
                                return data.datasets[tooltipItem[0].datasetIndex].data[tooltipItem[0].index].title;
                            },
                            label: function label(tooltipItem, data) {
                                return _this.showWeights(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y, _this.weightSlug);
                            }
                        }
                    },
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                callback: function callback(value, index, values) {
                                    if (_this.weightSlug === "lbs-oz") {
                                        return Math.round(value / 16);
                                    } else if (_this.weightSlug === "lbs") {
                                        return value;
                                    }
                                    return Math.round(value * 100) / 100;
                                },
                                beginAtZero: true,
                                min: 0
                            },
                            scaleLabel: {
                                display: true,
                                labelString: "Weight (" + App.weight_units + ")",
                                fontStyle: "bold"
                            }
                        }],
                        xAxes: [{
                            id: 'xAxis1',
                            type: "linear",
                            ticks: {
                                callback: function callback(label) {
                                    return label;
                                },
                                autoSkip: true,
                                maxTicksLimit: 20,
                                beginAtZero: true,
                                min: 0
                            },
                            scaleLabel: {
                                display: true,
                                labelString: "Age (Days)",
                                fontStyle: "bold"
                            }
                        }]
                    }
                },
                butcherAge: {
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                },
                liveAndDead: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            stacked: true
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            stacked: true
                        }]
                    },
                    legend: {
                        display: false
                    }
                },
                missed: {
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                                stepSize: 1
                            }
                        }]
                    }
                },
                meatProduction: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            title: function title() {},
                            label: function label(tooltipItem, data) {
                                return _this.showWeights(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], _this.weightSlug);
                            }
                        }
                    },
                    legend: {
                        display: false
                    },
                    legendCallback: function legendCallback(chart) {
                        var text = [];
                        text.push('<ul class="' + chart.id + '-legend">');

                        if (chart.data.datasets.length) {
                            for (var i = 0; i < chart.data.datasets[0].data.length; ++i) {
                                text.push('<li><i class="fa fa-circle-o text-' + _this.colours[i % 10] + ' }}"></i> ');
                                if (chart.data.labels[i]) {
                                    text.push(chart.data.labels[i]);
                                    text.push(' - ' + _this.showWeights(chart.data.datasets[0].data[i], _this.weightSlug));
                                }
                                text.push('</li>');
                            }
                        }

                        text.push('</ul>');

                        return text.join("");
                    }
                },
                kitsStatus: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            title: function title() {},
                            label: function label(tooltipItem, data) {
                                var item = data.datasets[tooltipItem.datasetIndex];
                                var id = tooltipItem.index;
                                return _this.capitalize(item.key[id]) + " (" + item.data[id] + " / " + item.percentage[id].toFixed() + "%)";
                            }
                        }
                    },
                    legend: {
                        display: false
                    },
                    legendCallback: function legendCallback(chart) {
                        var text = [];
                        text.push('<ul class="' + chart.id + '-legend">');

                        if (chart.data.datasets.length) {
                            for (var i = 0; i < chart.data.datasets[0].data.length; ++i) {
                                text.push('<li><i class="fa fa-circle item-' + chart.data.labels[i] + '"></i> ');
                                if (chart.data.labels[i]) {
                                    text.push(_this.capitalize(chart.data.labels[i]));
                                    text.push(" (" + chart.data.datasets[0].data[i] + " / " + chart.data.datasets[0].percentage[i].toFixed() + "%)");
                                }
                                text.push('</li>');
                            }
                        }

                        text.push('</ul>');

                        return text.join("");
                    }
                },
                avgLitterSize: {
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                min: 0
                            }
                        }]
                    }
                },
                costsPerBreeder: {
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: false,
                                min: 0

                            }
                        }]
                    }
                },
                avgKitWeightPerLitter: {
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: false,
                                min: 0
                            }
                        }]
                    }
                },
                growthRatePerLitter: {
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: false,
                                min: 0
                            }
                        }]
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItem, data) {
                                var litter = data.datasets[tooltipItem.datasetIndex].litterData[tooltipItem.index];
                                return [_this.showWeights(litter.total_weight, _this.weightSlug) + ' in ' + litter.weeksAlive + ' weeks', 'Litter Growth Rate: ' + litter.growthRate];
                            }
                        }
                    }
                }
            },
            colours: ['red', 'green', 'yellow', 'aqua', 'light-blue', 'teal', 'purple', 'maroon', 'orange', 'black'],
            productionType: "litter",
            productionFilter: "day",
            productionData: {},
            breederProductionData: {},
            litterProductionData: {},
            loadingLitterProduction: true,
            kitsStatus: {}
        };
    },
    props: ['breeder'],
    computed: {},
    components: {
        'line-chart': App.Components.LineChart
    },
    events: {
        'load-profile-reports': function loadProfileReports() {
            var _this2 = this;

            this.loadingStatics = 1;

            var data = {};

            if (this.report_date_range[0] && this.report_date_range[1]) {
                data = this.setDateFromDateRangePicker(this.report_date_range);
            }

            data.id = this.breeder.id;

            api.getProfileStatistics(data).then(function (data) {
                _this2.loadingStatics = 0;
                _this2.statistics = data.statistics;
                _this2.weightSlug = data.weightSlug;
                _this2.kitsStatus = data.kitsStatus || {};

                _this2.loadReportsData();
            });
        }
    },
    watch: {
        report_date_range: function report_date_range() {
            this.datasets = {
                production: [],
                meatProduction: [],
                butcherAge: [],
                liveAndDied: [],
                missed: [],
                avgLitterSize: [],
                costsPerBreeder: [],
                avgKitWeightPerLitter: [],
                growthRatePerLitter: []
            };
            this.labels = {
                production: [],
                meatProduction: [],
                butcherAge: [],
                liveAndDied: [],
                missed: [],
                avgLitterSize: [],
                costsPerBreeder: [],
                avgKitWeightPerLitter: [],
                growthRatePerLitter: []
            };
            this.$emit('load-profile-reports');
        },
        breeder: function breeder() {
            if (this.isBuck()) {
                this.show.avgLitterSize = false;
                this.show.avgDaysOfGestationPerDoe = false;
            }
        }
    },
    methods: {
        isBuck: function isBuck() {
            return this.breeder.sex === 'buck';
        },
        loadReportsData: function loadReportsData() {
            var _this3 = this;

            this.loadingReportsData = 1;

            var data = {};

            if (this.report_date_range[0] && this.report_date_range[1]) {
                data = this.setDateFromDateRangePicker(this.report_date_range);
            }

            data.id = this.breeder.id;

            api.getProfileReportsData(data).then(function (data) {
                _this3.loadingReportsData = 0;
                _this3.weightData = data.weight;
                _this3.meatData = data.meat;
                _this3.productionData = data.datasets || {};
                _this3.breederProductionData = data.breeder_production || {};

                if (!_.isEmpty(_this3.weightData)) {
                    _this3.showProduction();
                    _this3.calculateKitStatus();
                    _this3.calculateMeatProduction();
                    _this3.calculateButcherAge();
                    _this3.calculateLiveAndDied();
                    _this3.calculateMisses();
                    _this3.showCostsPerBreeder();
                    _this3.showAvgKitWeightPerLitter();
                    _this3.showGrowthRatePerLitter();

                    if (!_this3.isBuck()) {
                        _this3.showAvgLitterSize();
                    } else {
                        _this3.show.avgLitterSize = false;
                        _this3.show.avgDaysOfGestationPerDoe = false;
                    }

                    // fetch litter specific reports
                    _this3.fetchLitterProduction();
                } else {
                    for (var key in _this3.show) {
                        if (_this3.show.hasOwnProperty(key)) {
                            _this3.show[key] = false;
                        }
                    }
                }

                _this3.$nextTick(function () {
                    $('#report-date-range').trigger('triggerDaterangepicker');
                    this.$broadcast('show-chart');
                });
            });
        },
        setActiveLitter: function setActiveLitter(litter) {
            this.activeLitter = litter;
            this.showLitterProduction(litter);
        },
        setActiveLitters: function setActiveLitters() {
            this.activeLitter = null;
            this.showProduction();
        },
        calculateKitStatus: function calculateKitStatus() {
            var datasets = [{
                data: [],
                backgroundColor: [],
                key: [],
                percentage: []
            }];

            var colors = {
                active: "#03985d",
                breeder: "#009BC2",
                butchered: "#F72728",
                sold: "#00DDC5",
                died: "#DA0F5C",
                culled: "#964EFF",
                archived: "#FF8900"
            };

            if (!this.statistics.kitsTotal) {
                this.show.kitsStatus = false;
                return;
            }

            _.map(this.kitsStatus, function (item, key) {
                datasets[0].data.push(item.count);
                datasets[0].backgroundColor.push(colors[key] || colors.active);
                datasets[0].key.push(key);
                datasets[0].percentage.push(item.percentage);
            });

            this.show.kitsStatus = datasets[0].data.length > 0;
            this.labels.kitsStatus = datasets[0].key;
            this.datasets.kitsStatus = datasets;
        },

        calculateMeatProduction: function calculateMeatProduction() {
            var other = 0;
            var data = [];
            var meats = [];

            this.totalMeat = 0;

            if (!this.meatData) {
                this.show.meatProduction = false;
                return;
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.meatData.littersTopMeat), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var litter = _step.value;

                    if (litter.totalMeat > 0) {
                        var meat = parseFloat(litter.totalMeat);
                        this.totalMeat += meat;
                        // if (meats.length > this.meatProduction.limit - 1) {
                        //     other += meat;
                        // } else {
                        data.push({
                            name: litter.given_id,
                            meat: meat,
                            color: Chart.defaults.global.colours[data.length % Chart.defaults.global.colours.length].borderColor
                        });
                        // }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (other) {
                data.push({
                    name: 'other',
                    meat: other,
                    color: this.meatProduction.otherColor
                });
            }

            var labels = _.map(data, 'name');

            var datasets = [{
                data: _.map(data, 'meat'),
                backgroundColor: _.map(data, 'color')
            }];

            this.show.meatProduction = data.length > 0;
            this.labels.meatProduction = labels;
            this.datasets.meatProduction = datasets;
        },

        calculateMisses: function calculateMisses() {
            var data = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.weightData.misses), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var breeder = _step2.value;

                    data.push({ name: breeder.name, misses: breeder.misses_count });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            data = _.sortBy(data, 'misses').reverse();

            var labels = _.map(data, 'name');
            var datasets = [];

            if (!this.isBuck()) {
                datasets = [{
                    label: '',
                    data: _.map(data, 'misses'),
                    backgroundColor: "rgba(0,192,239,0.5)",
                    borderWidth: 1,
                    borderColor: "rgba(0,192,239,1)"
                }];
            } else {
                datasets = [{
                    label: '',
                    data: _.map(data, 'misses')
                }];
            }

            this.show.missed = data.length > 0;
            this.labels.missed = labels;
            this.datasets.missed = datasets;
        },


        calculateButcherAge: function calculateButcherAge() {
            var data = [];

            _.each(this.weightData.litters, function (litter) {
                if (litter.butchered === 1) {
                    var born = App.parseMoment(litter.born);
                    var butchered = moment(litter.butchered_at, 'YYYY-MM-DD H:i:s').startOf('day');
                    var days = butchered.diff(born, "days");
                    data.push({
                        name: litter.given_id,
                        days: days
                    });
                }
            });

            data = _.sortBy(data, 'days').reverse();

            var labels = _.map(data, 'name');
            var datasets = [{
                label: '',
                data: _.map(data, 'days')
            }];

            this.show.butcherAge = data.length > 0;
            this.labels.butcherAge = labels;
            this.datasets.butcherAge = datasets;
        },

        calculateLiveAndDied: function calculateLiveAndDied() {
            var data = [];

            _.each(this.weightData.litters, function (litter) {
                var died = litter.kits_died == null ? 0 : litter.kits_died;
                var liveKits = parseInt(litter.kits_amount - died);
                var diedKits = parseInt(died);

                if (liveKits || diedKits) {
                    data.push({
                        name: litter.given_id,
                        liveKits: liveKits,
                        diedKits: diedKits
                    });
                }
            });

            data = _.sortBy(data, 'liveKits').reverse();

            var labels = _.map(data, 'name');
            var datasets = [{
                data: _.map(data, 'liveKits'),
                backgroundColor: "rgba(0,166,90,0.5)",
                borderWidth: 1,
                borderColor: "rgba(0,166,90,1)",
                label: "Live Kits"
            }, {
                data: _.map(data, 'diedKits'),
                backgroundColor: "rgba(255,80,90,0.5)",
                borderWidth: 1,
                borderColor: "rgba(255,80,90,1)",
                label: "Dead Kits"
            }];

            this.show.liveAndDied = data.length > 0;
            this.labels.liveAndDied = labels;
            this.datasets.liveAndDied = datasets;
        },

        showAvgLitterSize: function showAvgLitterSize() {
            var data = [];

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(this.weightData.litters), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var litter = _step3.value;

                    if (litter.kits_amount > 0) {
                        data.push({ name: litter.given_id, kits_amount: parseInt(litter.kits_amount) });
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            data = _.sortBy(data, 'kits_amount').reverse();

            var labels = _.map(data, 'name');
            var datasets = [{
                label: "Kits Amount",
                data: _.map(data, 'kits_amount')
            }];

            this.show.avgLitterSize = data.length > 0;
            this.labels.avgLitterSize = labels;
            this.datasets.avgLitterSize = datasets;
        },

        showCostsPerBreeder: function showCostsPerBreeder() {
            var data = [];

            if (this.weightData.totalCost > 0) {
                data.push({ name: this.weightData.name, cost: this.weightData.totalCost });
            }

            data = _.sortBy(data, 'cost').reverse();

            var labels = _.map(data, 'name');
            var datasets = [{
                label: '',
                data: _.map(data, 'cost'),
                backgroundColor: "rgba(253,145,25,0.5)"
            }];

            this.show.costsPerBreeder = data.length > 0;
            this.labels.costsPerBreeder = labels;
            this.datasets.costsPerBreeder = datasets;
        },

        showGrowthRatePerLitter: function showGrowthRatePerLitter() {
            var data = [];

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(this.weightData.litters), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var litter = _step4.value;

                    if (litter.growthRate > 0) {
                        data.push({
                            name: litter.given_id,
                            growthRate: Math.round(litter.growthRate * 1e2) / 1e2,
                            litter: litter,
                            color: Chart.defaults.global.colours[data.length % Chart.defaults.global.colours.length]
                        });
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            data = _.sortBy(data, 'growthRate').reverse();

            var labels = _.map(data, 'name');

            var datasets = [{
                label: "Growth Rat",
                data: _.map(data, 'growthRate'),
                litterData: _.map(data, 'litter'),
                backgroundColor: _.map(data, function (d) {
                    return d.color.backgroundColor;
                }),
                borderColor: _.map(data, function (d) {
                    return d.color.borderColor;
                }),
                borderWidth: 1,
                hoverBackgroundColor: _.map(data, function (d) {
                    return d.color.hoverBackgroundColor;
                }),
                hoverBorderColor: _.map(data, function (d) {
                    return d.color.hoverBorderColor;
                })
            }];

            this.show.growthRatePerLitter = data.length > 0;
            this.labels.growthRatePerLitter = labels;
            this.datasets.growthRatePerLitter = datasets;
        },

        showProduction: function showProduction() {
            var data = {};
            if (this.productionType == 'litter') {
                data = this.productionData[this.productionFilter];
            } else {
                data = this.breederProductionData[this.productionFilter];
            }
            this.labels.production = data.labels || [];
            this.datasets.production = data.datasets || [];
        },

        showLitterProduction: function showLitterProduction(litter) {
            var data = this.litterProductionData[this.productionFilter][litter.id];

            this.labels.production = data.labels || [];
            this.datasets.production = data.datasets || [];
        },

        showAvgKitWeightPerLitter: function showAvgKitWeightPerLitter() {
            var data = this.getAvgKitWeightPerLitterData(this.weightData);

            this.show.avgKitWeightPerLitter = data.datasets.length > 0;
            this.labels.avgKitWeightPerLitter = data.labels;
            this.datasets.avgKitWeightPerLitter = data.datasets;
        },

        setDateFromDateRangePicker: function setDateFromDateRangePicker(daterange) {
            return {
                from: daterange[0].format('YYYY-MM-DD'),
                to: daterange[1].format('YYYY-MM-DD')
            };
        },
        clickDateRange: function clickDateRange() {
            $(this.$els.dateRangeInput).click();
        },
        setProductionFilter: function setProductionFilter() {
            var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'day';

            this.setProductionLabel(filter);
            this.productionFilter = filter;

            if (this.activeLitter && this.activeLitter.id) {
                this.showLitterProduction(this.activeLitter);
            } else {
                this.showProduction();
            }
        },
        setProductionType: function setProductionType() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'litter';

            this.productionType = type;
            this.setProductionFilter();
        },
        setProductionLabel: function setProductionLabel() {
            var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'day';

            switch (filter) {
                case 'month':
                    this.options.production.scales.xAxes[0].scaleLabel.labelString = 'Age (Months)';
                    break;
                case 'week':
                    this.options.production.scales.xAxes[0].scaleLabel.labelString = 'Age (Weeks)';
                    break;
                case 'day':
                default:
                    this.options.production.scales.xAxes[0].scaleLabel.labelString = 'Age (Days)';
            }
        },
        fetchLitterProduction: function fetchLitterProduction() {
            var _this4 = this;

            api.getBreederLitterReportsData(this.breeder.id).then(function (data) {
                _this4.litterProductionData = data.datasets;
                _this4.loadingLitterProduction = false;
            });
        },

        capitalize: function capitalize(string) {
            return string.replace(/^./, function (match) {
                return match.toUpperCase();
            });
        }
    },
    ready: function ready() {},
    mixins: [App.Mixins.Currency, App.Mixins.Reports, App.Mixins.Weightable, App.Mixins.Butcherable]
});

},{"babel-runtime/core-js/get-iterator":18}],814:[function(require,module,exports){
'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Profile = App.Components.Exploitable.Section.extend({
    template: "#profile-template",
    data: function data() {
        return {
            breeder: {
                image: {},
                images: {}
            },
            breeders: [],
            bucks: [],
            does: [],
            plans: [],
            errors: {},
            litters: [],
            activeKits: [],
            deadKits: [],
            loadingDeadKits: false,
            activeKit: {},
            activeLitter: {},
            activeTimeline: [],
            activeTask: {},
            activeBirth: {},
            subscriptionAutoUpgrade: {},
            loadingLitters: 0,
            loadingTasks: 0,
            tasksType: '',
            loading: 0,
            loadingProfile: true,
            soldValue: 0,
            soldAt: null,
            transferTo: '',
            transferErrors: {},
            // Cage card template.
            template: {},
            alltemplates: {},
            profileid: 0,
            confirmTarget: 'breeder',
            deathModalUnique: 'breeder',

            newNote: null,
            noteIndexToEdit: {},
            litterNoteIndexToEdit: {},
            noteIndexToDelete: {},
            litterNoteIndexToDelete: {},
            isLitterNoteExist: 0,
            litterDrop: false,
            //litters
            littersOrderOld: 'born|asc',
            littersType: '',
            littersFilters: {
                given_id: '',
                cage: '',
                buck: '',
                doe: '',
                born: {
                    from: null,
                    to: null
                },
                bred: {
                    from: null,
                    to: null
                }
            },
            littersFilterRanges: {
                born: [],
                bred: []
            },
            limitContent: {
                title: "You have exceeded the maximum amount of breeders",
                message: "Please upgrade your account to add more!",
                meta: {}
            },
            litterSearchQuery: "",
            filterKit: [],
            openLitters: [],
            btn_name: [],
            noteError: "",
            isLitterTileView: false,
            currentTab: "profile",
            notesType: "breeder",
            showAliveKits: true
        };
    },
    props: [],
    components: {
        'birth-certificate': App.Components.BirthCertificate,
        'schedule-tasks': App.Components.ScheduleTasks,
        'breed-form': App.Components.BreedForm,
        'kit-form': App.Components.KitForm,
        'litter-box': App.Components.LitterBox,
        'litter-box-v2': App.Components.LitterBoxV2,
        'litter-box-v3': App.Components.LitterBoxV3,
        'breeder-form': App.Components.BreederForm,
        'breeder-images-form': App.Components.BreederImagesForm,
        'litter-weight': App.Components.LitterWeight,
        'litter-sell': App.Components.LitterSell,
        'litter-butcher': App.Components.LitterButcher,
        'breeder-butcher': App.Components.BreederButcher,
        'litter-form': App.Components.LitterForm,
        'task-form': App.Components.TaskForm,
        'breeder-pedigree': App.Components.Pedigree,
        'old-breeder-pedigree': App.Components.OldPedigree,
        "ledger-table": App.Components.LedgerTable,
        "ledger-table-v2": App.Components.LedgerTableV2,
        "attachments-table": App.Components.AttachmentsTable,
        "attachments-table-v2": App.Components.AttachmentsTableV2,
        'cage-cards-print': App.Components.CageCardsPrint,
        'profile-reports': App.Components.ProfileReports,
        'profile-reports-v2': App.Components.ProfileReportsV2,
        'profile-health': App.Components.ProfileHealth
    },
    computed: {
        totalLittersNotes: function totalLittersNotes() {
            var count = 0;
            this.litters.forEach(function (litter) {
                // Parse the notes JSON string into an array
                var notes = JSON.parse(litter.notes);

                // Add the number of notes in this litter to the count
                count += notes.length;
            });
            return count;
        },

        id: function id() {
            return this.$route.params.id;
        },
        breedSex: function breedSex() {
            this.getRabbitSex(this.breeder);
        },
        breedName: function breedName() {
            return this.breeder.name;
        },
        breedSexClass: function breedSexClass() {
            if (this.breeder.sex === "doe") {
                return "box-danger";
            } else if (this.breeder.sex === "buck") {
                return "box-info";
            }
        },
        confirmTarget: function confirmTarget() {
            return this.breeder.name;
        },
        confirmTargetDied: function confirmTargetDied() {
            return this.breeder.died;
        },
        isEmptyTimeline: function isEmptyTimeline() {
            return !this.activeTimeline.length || !this.activeTimeline[0].length;
        },
        isDoe: function isDoe() {
            return this.breeder.sex === 'doe';
        },
        profileData: function profileData() {
            var data = this.breeder;
            var formattedData = [{
                title: 'Status',
                value: this.getBreederStatus(data, true)
            }, {
                title: 'Cage',
                value: data.cage || '—'
            }, {
                title: 'Weight',
                value: data.weight_slug || '—'
            }, {
                title: 'Breed',
                value: data.breed || '—'
            }, {
                title: 'Color',
                value: data.color || '—'
            }, {
                title: 'Acquired',
                value: data.aquired || '—'
            }, {
                title: 'Born',
                value: data.date_of_birth || '—'
            }, {
                title: 'Age',
                value: data.age || '—'
            }, {
                title: 'Legs',
                value: data.legs || '—'
            }, {
                title: 'Parents',
                value: ""
            }, {
                title: 'Genotype',
                value: data.genotype ? data.genotype.join(" ") : "—"
            }];

            if (data.butchered && App.isShowButcher) {
                var butcheredData = [{
                    title: "Butchered Date",
                    value: moment(data.butchered_at, 'YYYY-MM-DD H:i:s').format(App.dateFormat) || '—'
                }, {
                    title: "Butchered Weight",
                    value: data.butchered_weight_slug || '—'
                }];

                formattedData = formattedData.concat(butcheredData);
            }

            // filter show related fields 
            if (!App.isShowShow) {
                formattedData = _.filter(formattedData, function (item) {
                    return !['Legs', 'Champion Number', 'Registration Number'].includes(item.title);
                });
            }

            return formattedData;
        },
        littersOrder: function littersOrder() {
            return this.currentSort + '|' + this.currentOrder;
        },

        showKits: function showKits() {
            var data = void 0;

            if (this.showAliveKits) {
                data = _.filter(this.breeder.all_kits, function (kit) {
                    return kit.alive == 1;
                });
            } else data = this.breeder.all_kits;

            return data;
        }
    },
    watch: {
        litterSearchQuery: function litterSearchQuery(newData, oldData) {
            if (oldData == "") {
                this.littersType = "all";
            }
            this.loadLitters();
        },
        littersOrder: function littersOrder() {
            this.loadLitters();
        },

        '$route': function $route() {
            this.loadData();
        },
        littersFilters: {
            handler: function handler() {
                this.loadLitters();
            },
            deep: true
        },
        littersFilterRanges: {
            handler: function handler(newValue) {
                _.each(newValue, function (value, key) {
                    if (value && value[0] && value[1]) {
                        this.littersFilters[key]['from'] = value[0].format(App.dateFormat);
                        this.littersFilters[key]['to'] = value[1].format(App.dateFormat);
                    } else {
                        this.littersFilters[key]['from'] = this.littersFilters[key]['to'] = null;
                    }
                }.bind(this));
            },
            deep: true
        },
        breeder: function breeder() {
            this.parseNotes();
        },
        newNote: function newNote(newData) {
            if (newData) {
                this.noteError = "";
            }
        }
    },
    events: {
        'breeder-saved': function breederSaved() {
            this.$broadcast('loadPedigree');
        },
        'open-breed-modal': function openBreedModal(msg) {
            this.$broadcast('new-breed-with-doe', msg);
        },
        doMissedModel: function doMissedModel() {
            var _this = this;

            var plan_id = this.breeder.plan_id;
            var activeBirth = {};
            activeBirth = { breedplan: plan_id || '-1', born: moment(new Date()).format(App.dateFormat) };
            if (typeof plan_id === 'string' && plan_id !== -1 && App.generateLitterIdFlag) {
                api.getNextLitterId({ breeder_id: this.breeder.id }).then(function (response) {
                    activeBirth.given_id = response.nextLitterId;
                    _this.missBirth(activeBirth);
                });
            } else {
                activeBirth.given_id = '';
                this.missBirth(activeBirth);
            }
        },
        doCloseTransferModal: function doCloseTransferModal() {
            $('#transfer-breed-modal').modal('hide');
        },

        'litter-updated': function litterUpdated() {
            this.loadLitters();
        },
        'butcher-kit': function butcherKit(kit) {
            this.filterKit = kit.id;
            $('#litter-butcher-modal').modal('show');
        },
        /**
         * Call specific methods based on menu click
         * 
         * @param {string} method 
         * @param {mixed} data 
         */
        menuClicked: function menuClicked(method, data) {
            this[method](data);
        }
    },
    methods: (0, _defineProperty3.default)({
        changeActiveTab: function changeActiveTab(tab) {
            if (tab == 0) {
                $('.breeder_btn').css('display', 'block');
                $('.litter_btn').css('display', 'none');
                $('.task_btn').css('display', 'none');
                $('.pedigree_btn').css('display', 'none');
                $('.ledger_btn').css('display', 'none');
                $('.birth_certificate_btn').css('display', 'none');
            } else if (tab == 1) {
                $('.litter_btn').css('display', 'block');
                $('.breeder_btn').css('display', 'none');
                $('.task_btn').css('display', 'none');
                $('.pedigree_btn').css('display', 'none');
                $('.ledger_btn').css('display', 'none');
                $('.birth_certificate_btn').css('display', 'none');
            } else if (tab == 2) {
                $('.task_btn').css('display', 'block');
                $('.litter_btn').css('display', 'none');
                $('.pedigree_btn').css('display', 'none');
                $('.ledger_btn').css('display', 'none');
                $('.breeder_btn').css('display', 'none');
                $('.birth_certificate_btn').css('display', 'none');
            } else if (tab == 3) {
                $('.pedigree_btn').css('display', 'block');
                $('.litter_btn').css('display', 'none');
                $('.task_btn').css('display', 'none');
                $('.ledger_btn').css('display', 'none');
                $('.breeder_btn').css('display', 'none');
                $('.birth_certificate_btn').css('display', 'none');
            } else if (tab == 4) {
                $('.ledger_btn').css('display', 'block');
                $('.litter_btn').css('display', 'none');
                $('.task_btn').css('display', 'none');
                $('.pedigree_btn').css('display', 'none');
                $('.breeder_btn').css('display', 'none');
                $('.birth_certificate_btn').css('display', 'none');
            } else if (tab == 5) {
                $('.birth_certificate_btn').css('display', 'block');
                $('.ledger_btn').css('display', 'none');
                $('.litter_btn').css('display', 'none');
                $('.task_btn').css('display', 'none');
                $('.pedigree_btn').css('display', 'none');
                $('.breeder_btn').css('display', 'none');
            }
        },
        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        breedModal: function breedModal() {
            if (this.isDoe) {
                this.$broadcast('new-breed-with-doe', this.breeder.id);
            } else {
                this.$broadcast('new-breed-with-buck', this.breeder.id);
            }
        },
        birthModal: function birthModal() {
            this.$root.$emit('open-global-birth-form', { breed_id: this.breeder.plan_id || '-1', isShowMissed: false });
        },
        missBirth: function missBirth(activeBirth) {
            var self = this;
            api.missBirth(activeBirth).then(function () {
                $('#missing-modal-birth-plan').modal('hide');
                self.showProfile();
            });
        },
        showProfile: function showProfile() {
            var _this2 = this;

            api.getBreeder(this.id, { update_weight_format: true }).then(function (data) {
                _this2.breeder = data;
                _this2.loadingProfile = false;
            }, function (response) {
                _this2.loadingProfile = false;
            });
        },
        edit: function edit() {
            this.$broadcast('breeder-edit');
        },
        getParent: function getParent(parent) {
            return parent ? parent.name + ": " + parent.tattoo : "Unknown";
        },

        genotypeByName: function genotypeByName(genotype) {
            return genotype.join(' ');
        },


        /**
         * (START) New sell/transfer flow
         * NOTE: to be transferred to exploitable->sections
         */
        soldModal: function soldModal(id) {
            $('#sold-breed-modal-breeder').modal('show');
        },
        closeSoldModal: function closeSoldModal() {
            $('#sold-breed-modal-breeder').modal('hide');
            this.transferErrors = {};
            this.transferTo = '';
            this.soldValue = 0;
            this.soldAt = null;
            this.loadData();
        },
        sold: function sold() {
            var _this3 = this;

            // add checker if sold to field has value
            if (this.transferTo && this.transferTo != "add") {
                // verify if the email is valid
                api.verifyTransferableBreeder(this.breeder, this.transferTo).then(function () {
                    // show confirm transfer modal
                    $('#sold-breed-modal-breeder').modal('hide');
                    $('#confirm-transfer-breed-modal').modal('show');
                }, function (error) {
                    // show errors on form
                    _this3.transferErrors = error.data.errors;
                });
            } else {
                // sell breeder directly if sold to field is empty
                var payload = { value: this.soldValue, date: this.soldAt };
                api.sellBreeder(this.breeder, payload).then(function () {
                    _this3.closeSoldModal();
                    _this3.showAlert({
                        type: 'success',
                        text: _this3.breeder.name + ' has been sold.'
                    });
                }, function (error) {
                    if (response.data == 'breeders-limit-exceeded') {
                        _this3.showBreederLimit(false);
                    }
                });
            }
        },
        confirmTransfer: function confirmTransfer() {
            var _this4 = this;

            // hide confirm transfer modal
            $('#confirm-transfer-breed-modal').modal('hide');

            // sell breeder
            var payload = { value: this.soldValue, date: this.soldAt };
            api.sellBreeder(this.breeder, payload).then(function () {
                // transfer breeder to new owner
                api.transferBreeder(_this4.breeder, _this4.transferTo).then(function () {
                    _this4.closeSoldModal();
                    _this4.showAlert({
                        type: 'success',
                        text: _this4.breeder.name + ' has been transfered.'
                    });
                }, function (response) {
                    _this4.transferErrors = response.data.errors;
                    _this4.unconfirmTransfer();
                });
            });
        },
        unconfirmTransfer: function unconfirmTransfer() {
            $('#confirm-transfer-breed-modal').modal('hide');
            $('#sold-breed-modal').modal('show');
        },
        /**
         * (END) New sell/transfer flow
         */

        unsoldModal: function unsoldModal(breeder) {
            var _this5 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    _this5.breeder = breeder;
                    $('#unsold-breed-modal').modal('show');
                } else {
                    _this5.showBreederLimit(data);
                }
            });
        },

        unsold: function unsold() {
            var _this6 = this;

            $('#unsold-breed-modal').modal('hide');
            api.unsellBreeder(this.breeder).then(function () {
                _this6.loadData();
                _this6.showAlert({
                    type: 'success',
                    text: _this6.breeder.name + ' has been unsold.'
                });
            }, function (response) {
                if (response.data === 'breeders-limit-exceeded') {
                    _this6.showBreederLimit(false);
                } else {
                    _this6.showAlert({
                        type: 'danger',
                        text: response.data.error
                    });
                }
            });
        },

        archiveModal: function archiveModal(id) {
            $('#archive-breed-modal').modal('show');
        },
        archive: function archive() {
            var _this7 = this;

            $('#archive-breed-modal').modal('hide');
            api.archiveBreeder(this.breeder).then(function () {
                _this7.loadData();
                _this7.showAlert({
                    type: 'warning',
                    text: _this7.breeder.name + ' has been archived.'
                });
            });
        },

        unarchiveModal: function unarchiveModal(breeder) {
            var _this8 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    _this8.breeder = breeder;
                    $('#unarchive-breed-modal').modal('show');
                } else {
                    _this8.showBreederLimit(data);
                }
            });
        },

        unarchive: function unarchive() {
            var _this9 = this;

            $('#unarchive-breed-modal').modal('hide');
            api.unarchiveBreeder(this.breeder).then(function () {
                _this9.loadData();
                _this9.showAlert({
                    type: 'success',
                    text: _this9.breeder.name + ' has been unarchived.'
                });
            }, function (response) {
                if (response.data === 'breeders-limit-exceeded') {
                    _this9.showBreederLimit(false);
                } else {
                    _this9.showAlert({
                        type: 'danger',
                        text: response.data.error
                    });
                }
            });
        },

        cullModal: function cullModal() {
            $('#cull-breed-modal').modal('show');
        },
        cull: function cull() {
            var _this10 = this;

            $('#cull-breed-modal').modal('hide');
            api.cullBreeder(this.breeder).then(function () {
                _this10.loadData();
                _this10.showAlert({
                    type: 'warning',
                    text: _this10.breeder.name + ' has been culled.'
                });
            });
        },

        uncullModal: function uncullModal() {
            var _this11 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    $('#uncull-breed-modal').modal('show');
                } else {
                    _this11.showBreederLimit(data);
                }
            });
        },

        uncull: function uncull() {
            var _this12 = this;

            $('#uncull-breed-modal').modal('hide');
            api.uncullBreeder(this.breeder).then(function () {
                _this12.loadData();
                _this12.showAlert({
                    type: 'success',
                    text: _this12.breeder.name + ' has been unculled.'
                });
            }, function (response) {
                if (response.data === 'breeders-limit-exceeded') {
                    _this12.showBreederLimit(false);
                } else {
                    _this12.showAlert({
                        type: 'danger',
                        text: response.data.error
                    });
                }
            });
        },

        deleteModal: function deleteModal(id) {
            $('#delete-breed-modal').modal('show');
        },
        delete: function _delete() {
            var _this13 = this;

            $('#delete-breed-modal').modal('hide');
            api.deleteBreeder(this.breeder).then(function () {
                _this13.$router.go({ path: '/breeders' });
            });
        },

        changeLittersType: function changeLittersType(value) {
            this.littersType = value;
            this.loadLitters();
        },

        changeLittersOrder: function changeLittersOrder(value) {
            this.littersOrderOld = value;
            this.loadLitters();
        },

        loadLitters: function loadLitters() {
            var _this14 = this;

            this.loadingLitters = 1;
            this.openLitters = [];

            var data = {};

            if (this.littersOrderOld) {
                data.order = this.littersOrderOld;
            } else {
                data.order = this.littersOrder;
            }

            data.all = this.littersType === 'all' ? 1 : 0;
            data.archived = this.littersType === "inactive" ? 1 : 0;
            data.butchered = this.littersType === "inactive" ? 1 : 0;

            data.filters = this.littersFilters;
            data.searchQuery = this.litterSearchQuery;
            data.perPage = 100; // TODO: add proper pagination

            api.getBreederLitters(this.id, data).then(function (litters) {
                _this14.litters = litters.data;
                _this14.loadingLitters = 0;

                $('#f-litter-born').trigger('triggerDaterangepicker');
                $('#f-litter-breed').trigger('triggerDaterangepicker');
            });
        },

        resetLittersFilter: function resetLittersFilter() {
            _.each(this.littersFilterRanges, function (value, key) {
                this.littersFilterRanges[key] = null;
            }.bind(this));

            this.littersFilters = {
                given_id: '',
                cage: '',
                buck: '',
                doe: '',
                born: {
                    from: null,
                    to: null
                },
                bred: {
                    from: null,
                    to: null
                }
            };
        },

        loadPedigree: function loadPedigree() {
            this.$broadcast('loadPedigree');
        },

        loadLedger: function loadLedger() {
            this.$broadcast('load_ledger');
        },

        weightLitter: function weightLitter(litter) {
            var _this15 = this;

            this.activeLitter = litter;
            api.getLitterKitsWeighOfType(this.activeLitter.id, 'rabbitkit').then(function (kits) {
                _this15.activeKits = kits;
            });
            $('#litter-weight-modal').modal('show');
        },

        sellLitter: function sellLitter(litter) {
            var _this16 = this;

            this.activeLitter = litter;
            api.getLitterKitsWeighOfType(this.activeLitter.id, 'rabbitkit').then(function (kits) {
                _this16.activeKits = kits;
            });
            $('#litter-sell-modal').modal('show');
        },

        butcherModal: function butcherModal(litter) {
            var _this17 = this;

            this.activeLitter = litter;
            api.getLitterKitsWeighOfType(this.activeLitter.id, 'rabbitkit').then(function (kits) {
                _this17.activeKits = kits;
            });
            $('#litter-butcher-modal').modal('show');
        },

        editLitterModal: function editLitterModal(litter) {
            this.activeLitter = litter;
            $('#litter-form').modal('show');
        },

        archiveLitterModal: function archiveLitterModal(litter) {
            this.activelitter = litter;
            $('#archive-litter-modal').modal('show');
        },
        archiveLitter: function archiveLitter() {
            var _this18 = this;

            $('#archive-litter-modal').modal('hide');
            api.archiveLitter(this.activelitter).then(function () {
                $('#id_' + _this18.activelitter.id).slideUp(200);
                _this18.refreshKits();
            });
        },

        deleteLitterModal: function deleteLitterModal(litter) {
            this.activelitter = litter;
            $('#delete-litter-modal').modal('show');
        },

        showMissed: function showMissed() {
            $('#missing-modal-birth-plan').modal('show');
        },

        deleteLitter: function deleteLitter() {
            var _this19 = this;

            $('#delete-litter-modal').modal('hide');
            api.deleteLitter(this.activelitter).then(function () {
                $('#id_' + _this19.activelitter.id).slideUp(200);
                _this19.refreshKits();
            });
        },

        openTaskForm: function openTaskForm(task) {
            this.activeTask = task;
            this.$broadcast('tasks-managing', task);
        },

        openOwnerTaskForm: function openOwnerTaskForm(task) {
            var newTask = {};
            newTask.type = 'breeder';
            newTask.relation = {};
            newTask.relation.id = this.breeder.id;
            this.$broadcast('tasks-managing', task, newTask);
        },

        showRequestForm: function showRequestForm(task) {
            this.activeTask = task;
            $('#delete_task').modal('show');
        },
        editImages: function editImages() {
            if (this.isBreederActive(this.breeder)) {
                this.$broadcast('breeder-images-edit');
            } else {
                this.showAlert({
                    type: 'warning',
                    text: 'You can\'t update inactive breeders.'
                });
            }
        },

        addKit: function addKit(litter) {
            var kitId = litter.kits_amount + 1;
            this.activeKit = _.extend({}, App.emptyKit);
            kitId = kitId < 100 ? '0' + kitId : kitId;
            this.activeKit.given_id = litter.id + kitId;
            this.activeKit.litter_id = litter.id;
            this.activeKit.original_litter_id = litter.id;
            this.activeKit.prefix = litter.prefix || App.default_prefix;
            this.activeKit.breed = litter.breed || App.default_breed;

            var form = $('#kit-form-modal');
            form.modal({
                backdrop: 'static',
                keyboard: false
            });
            form.modal('show');
            App.emptyLitter.breed = App.default_breed;
        },
        editKit: function editKit(kit) {
            this.activeKit = kit;
            var form = $('#kit-form-modal');
            form.modal({
                backdrop: 'static',
                keyboard: false
            });
            form.modal('show');
        },
        refreshKits: function refreshKits() {
            var kit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (!kit || !kit.litter_id) {
                this.loadLitters();
                this.showProfile();
            } else {
                this.$broadcast('refresh-kits-global', kit.litter_id);
            }
        },


        makeDate: function makeDate(date) {
            return App.formatDate(date);
        },

        addNewLitter: function addNewLitter() {
            this.activeLitter = _.extend({}, this.activeLitter, App.emptyLitter);
            if (this.breeder.sex === 'buck') {
                this.activeLitter.father_id = this.breeder.id;
            } else {
                this.activeLitter.mother_id = this.breeder.id;
            }

            this.activeLitter.prefix = App.default_prefix;
            this.activeLitter.breed = App.default_breed;

            $('#litter-form').modal('show');
        },

        loadReports: function loadReports() {
            this.$broadcast('load-profile-reports');
        },

        getTimeLeft: function getTimeLeft(task) {
            var oToday = new Date();
            var oDeadLineDate = new Date(task.date);
            var nDaysLeft = oDeadLineDate > oToday ? Math.ceil((oDeadLineDate - oToday) / (1000 * 60 * 60 * 24)) : null;
            if (!nDaysLeft) return 'Today';

            if (nDaysLeft === 1) return nDaysLeft + ' day';
            return nDaysLeft + ' days';
        },

        getSecondParentSex: function getSecondParentSex(litter) {
            var parent = this.getBreederPartner(litter);
            return parent ? this.getRabbitSex(parent) : undefined;
        },

        getSecondParentName: function getSecondParentName(litter) {
            var parent = this.getBreederPartner(litter);
            return parent ? parent.name : undefined;
        },

        getBreederPartner: function getBreederPartner(litter) {
            var self = this;
            return _.find(litter.parents, function (parent) {
                return self.breeder.id != parent.id;
            });
        },
        getRabbitSex: function getRabbitSex(rabbit) {
            if (rabbit.sex === "doe") {
                return "Doe";
            } else if (rabbit.sex === "buck") {
                return "Buck";
            } else {
                return "Breed";
            }
        },
        getLitterFather: function getLitterFather(litter) {
            var parents = litter.parents;
            var father = parents.find(function (item) {
                return item.sex === 'buck';
            });

            return father || null;
        },

        sendBreeder: function sendBreeder() {
            var _this20 = this;

            var breeder = this.breeder;

            if (breeder.id != 0) {
                breeder._method = "PUT";
            }

            this.$http.post('/admin/breeders/' + this.breeder.id + '/image', breeder).then(function (response) {
                var breederResponse = response.data;
                if (breeder.id == 0) {
                    _this20.breeders.push(breederResponse);
                } else {
                    var match = _.find(_this20.breeders, function (item) {
                        return item.id === breeder.id;
                    });
                    if (match) {
                        _.extendOwn(match, breederResponse);
                    }
                    _this20.breeder = breederResponse;
                }
            }).catch(function (response) {
                this.errors = response.data.errors;
            });
        },

        butcherBreederModal: function butcherBreederModal() {
            $('#breeder-butcher-modal').modal('show');
        },

        undoButcher: function undoButcher() {
            var _this21 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    var params = {
                        breeders: [_this21.breeder],
                        butchered: 0
                    };

                    api.butcherBreeder(_this21.breeder, params).then(function () {
                        _this21.breeder.butchered = 0;
                        _this21.showAlert({
                            type: 'success',
                            text: _this21.breeder.name + ' has been unbutchered.'
                        });
                    }, function (response) {
                        _this21.showAlert({
                            type: 'danger',
                            text: response.data.error
                        });
                    });
                } else {
                    _this21.showBreederLimit(data);
                }
            });
        },

        showDied: function showDied() {
            $('#died-modal-breeder').modal('show');
        },
        showUndoDied: function showUndoDied() {
            var _this22 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    _this22.showDied();
                } else {
                    _this22.showBreederLimit(data);
                }
            });
        },


        undoDied: function undoDied() {
            var _this23 = this;

            api.checkBreedersLimit().then(function (data) {
                if (data.ok) {
                    var params = {};

                    if (_this23.breeder.died) {
                        params = { died: 0 };
                    }

                    api.diedBreeder(_this23.breeder, params).then(function () {
                        _this23.breeder.died = false;
                        _this23.showAlert({
                            type: 'success',
                            text: _this23.breeder.name + ' has been revived.'
                        });
                    }, function (response) {
                        _this23.showAlert({
                            type: 'danger',
                            text: response.data.error
                        });
                    });
                } else {
                    _this23.showBreederLimit(data);
                }
            });
        },

        died: function died() {
            var _this24 = this;

            var data = void 0;
            if (this.breeder.died) {
                data = {};
            } else {
                data = {
                    died: 1
                };
            }

            api.diedBreeder(this.breeder, data).then(function () {
                $('#died-modal-breeder').modal('hide');
                var isDead = _this24.breeder.died;
                _this24.loadData();
                if (!isDead) {
                    // save death reason
                    _this24.newDeathReason = _this24.reasonValue;
                    _this24.deathBreederId = _this24.breeder.id;
                    _this24.type = 'breeder';
                    _this24.addNewReason();
                    _this24.sendReasonValue();
                }
                _this24.showAlert({
                    type: _this24.breeder.died ? 'warning' : 'success',
                    text: _this24.breeder.name + ' has been ' + (_this24.breeder.died ? 'marked as dead' : 'revived') + '.'
                });
            });
        },


        /**
         * Cage card.
         */
        cageCard: function cageCard() {
            var _this25 = this;

            var request = { type: 'breeder' };
            this.template = {};

            api.getCageCardsTemplates(request).then(function (data) {
                _this25.alltemplates = data.templates;
            });

            this.profileid = this.breeder.id;

            $('#cage-cards-print-modal').modal('show');
        },

        // function for notes
        updateNotes: function updateNotes() {
            var _this26 = this;

            var breeder = (0, _assign2.default)({}, this.breeder);

            breeder.notes = (0, _stringify2.default)(breeder.notes);
            breeder.update_weight_format = true;
            this.loading = 1;
            api.saveBreeder(breeder).then(function (data) {
                _this26.loading = 0;
                _this26.$dispatch('breeder-saved');
                if (breeder.id == 0) {
                    _this26.breeders.push(data);
                } else {
                    var match = _.find(_this26.breeders, function (item) {
                        return item.id === breeder.id;
                    });
                    if (match) {
                        _.extendOwn(match, data);
                    }
                    _this26.breeder = data;
                }
                _this26.newNote = "";
            }, function (response) {
                _this26.loading = 0;
                _this26.errors = response.data.errors;
            });
        },
        parseNotes: function parseNotes() {
            var arr = [];

            if (this.breeder.notes) {
                try {
                    if (isNaN(this.breeder.notes)) {
                        arr = JSON.parse(this.breeder.notes);
                    } else {
                        arr.push(this.breeder.notes);
                    }
                } catch (err) {
                    arr.push(this.breeder.notes);
                }
            }

            this.breeder.notes = arr;
        },
        addNote: function addNote() {
            if (this.newNote == "" || this.newNote == null) {
                this.noteError = "You can't add empty notes.";
                return false;
            }

            var newNote = this.sanitizeNote(this.newNote);
            this.breeder.notes.push(newNote);
            this.breeder.new_notes.push({ value: newNote, date: moment().format('YYYY-MM-DD') });

            this.updateNotes();
        },
        sanitizeNote: function sanitizeNote() {
            var note = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            return note.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        },

        editNote: function editNote() {
            this.breeder.notes.$set(this.noteIndexToEdit.num, this.noteIndexToEdit.note);

            this.updateNotes();

            this.noteIndexToEdit = {
                index: -1,
                note: ''
            };
        },
        editLitterNote: function editLitterNote(index5, index6) {

            this.litters[index5].new_notes[index6].value = this.litterNoteIndexToEdit.value;

            var newNotesArray = this.litters[index5].new_notes.map(function (note) {
                return note.value;
            });

            this.litters[index5].notes = newNotesArray;
            this.updateLitterNotes(this.litters[index5]);
            this.litterNoteIndexToEdit = {
                index: -1,
                value: ''
            };
        },

        updateLitterNotes: function updateLitterNotes(litter) {
            var _this27 = this;

            // function for notes

            litter.notes = (0, _stringify2.default)(litter.notes);
            litter.is_notes_update = 1;
            this.loading = 1;
            api.saveLitter(litter).then(function (data) {
                _this27.loading = 0;
            }, function (response) {
                _this27.loading = 0;
            });
        },
        deleteLitterNoteModal: function deleteLitterNoteModal(litterIndex, noteIndex, note) {
            this.litterNoteIndexToDelete = {
                litterIndex: litterIndex,
                noteIndex: noteIndex,
                note: note
            };
            $('#delete-litter-note-modal').modal('show');
        },
        deleteLitterNote: function deleteLitterNote() {
            this.litters[this.litterNoteIndexToDelete.litterIndex].new_notes.splice(this.litterNoteIndexToDelete.noteIndex, 1);
            var newNotesArray = this.litters[this.litterNoteIndexToDelete.litterIndex].new_notes.map(function (note) {
                return note.value;
            });
            this.litters[this.litterNoteIndexToDelete.litterIndex].notes = newNotesArray;
            this.updateLitterNotes(this.litters[this.litterNoteIndexToDelete.litterIndex]);
            this.litterNoteIndexToDelete = {
                litterIndex: -1,
                noteIndex: -1,
                note: ''
            };
            $('#delete-litter-note-modal').modal('hide');
        },
        checkLitterNoteExist: function checkLitterNoteExist() {
            this.isLitterNoteExist = 1;
        },
        deleteNoteModal: function deleteNoteModal(index, note) {
            this.noteIndexToDelete = {
                index: index,
                note: note
            };
            $('#delete-note-modal').modal('show');
        },
        deleteNote: function deleteNote() {
            this.breeder.notes.splice(this.noteIndexToDelete.index, 1);
            this.updateNotes();
            this.noteIndexToDelete = {
                index: -1,
                note: ''
            };
            $('#delete-note-modal').modal('hide');
        },
        setNote: function setNote(note, index) {
            this.noteIndexToEdit = {
                note: note,
                num: index
            };
        },
        setLitterNote: function setLitterNote(note, index) {
            this.litterNoteIndexToEdit = {
                value: note,
                num: index
            };
        },
        openLitter: function openLitter(item, id) {
            localStorage.setItem('action', item);
            this.$route.router.go('/litterprofile/' + id);
        },
        loadBucksAndDoes: function loadBucksAndDoes() {
            var _this28 = this;

            api.getBreedersList().then(function (breeders) {
                _this28.bucks = breeders.bucks;
                _this28.does = breeders.does;
            });
        },
        loadData: function loadData() {
            this.showProfile();
            this.loadBucksAndDoes();
            this.loadLitters();
            App.MobileTypes();
            this.$on('refresh-kits', this.refreshKits.bind(this));

            var action = localStorage.getItem('action');
            if (action === "cageCard") this.cageCard();else if (action === "butcher") this.butcherBreederModal();else if (action === "undoButcher") this.undoButcher();else if (action === "died") this.showDied();else if (action === "undoDied") this.showUndoDied();

            localStorage.removeItem('action');
        },
        triggerLoadingPedigree: function triggerLoadingPedigree() {
            this.$els['pedigreeTab'].click();
        },
        openProfile: function openProfile(id) {
            if (id && id != '0') {
                window.open('/#!/profile/' + id, '_blank');
            }
        },
        litterContainerClicked: function litterContainerClicked(id, element) {
            var action = $(element).data('action') || 'open';

            if (action == 'close') {
                $('.kits-container-' + id).hide();
                this.closeLitters(id);
            } else {
                $('.kits-container-' + id).show();
                this.openLitters.push(id); // add to open litters
            }
        },
        closeLitters: function closeLitters(id) {
            // remove from open litters
            var key = this.openLitters.indexOf(id);
            if (key > -1) {
                this.openLitters.splice(key, 1);

                this.closeLitters(id); //recursive call to clear all keys (in case it's saved multiple times)
            }
        },
        isLitterOpen: function isLitterOpen(id) {
            var key = this.openLitters.indexOf(id);
            if (key > -1) {
                return true;
            } else {
                return false;
            }
        },
        weighModal: function weighModal() {
            this.$broadcast('breederWeigh');
        },
        changeLitterLayout: function changeLitterLayout() {
            this.isLitterTileView = !this.isLitterTileView;
            localStorage.setItem('isLitterTileView', this.isLitterTileView);
        },
        showUndoDeadKitsModal: function showUndoDeadKitsModal(litter) {
            var _this29 = this;

            this.loadingDeadKits = true;
            this.activeLitter = litter;
            api.getLitterDied(litter.id).then(function (died) {
                _this29.deadKits = died;
                _this29.loadingDeadKits = false;
            });
            $('#undo-dead-kits-modal').show();
        },
        revive: function revive(kit) {
            var _this30 = this;

            api.reviveKit(kit).then(function () {
                _this30.deadKits = _.filter(_this30.deadKits, function (item) {
                    return item.id != kit.id;
                });
            });
        },
        closeReviveKitsModal: function closeReviveKitsModal() {
            this.$broadcast('refresh-kits-global', this.activeLitter.id);
            $('#undo-dead-kits-modal').hide();
        },
        initTabs: function initTabs() {
            var self = this;
            $('a[data-toggle="tab"]:not(.edit-kit-tab)').on('shown.bs.tab', function (e) {
                var target = $(e.target).attr("href");
                target = target.replace("#", "");

                self.currentTab = target;
            });

            $('a.edit-kit-tab[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                var target = $(e.target).attr("href");

                $('#kit-form-modal .tab-pane').removeClass('active');
                $('#kit-form-modal').find(target).addClass('active');
            });
        },
        switchNotesType: function switchNotesType() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder';

            this.notesType = type;
        },
        viewEvent: function viewEvent(note) {
            var _this31 = this;

            api.getEvent(note.id).then(function (task) {
                _this31.$root.$emit('open-global-task-form', task);
            });
        },
        showKitsFilter: function showKitsFilter() {
            var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            if (!show) this.showAliveKits = false;else this.showAliveKits = true;

            var doeId = "";
            var buckId = "";
            this.isDoe ? doeId = this.breeder.id : buckId = this.breeder.id;
            var preFiltersKits = {
                doe: doeId,
                buck: buckId,
                status: show == "alive" ? "active" : "",
                sex: ""
            };
            localStorage.setItem('filtersKits', (0, _stringify2.default)(preFiltersKits));
            this.$router.go("/litters?tab=kits&kitsFilter=true");
        },
        markForSaleModal: function markForSaleModal(breeder) {
            if (App.hasMarketplaceProfile) {
                $('#mark-for-sale-modal').modal('show');
            } else {
                $('#no-marketplace-profile-modal').modal('show');
            }
        },
        markForSale: function markForSale() {
            var _this32 = this;

            var params = (0, _extends3.default)({
                listable_id: this.breeder.id,
                listable_type: "breeder",
                amount: this.listingAmount || 0,
                is_active: this.isListOnMarketplace,
                description: this.listingNotes
            }, this.marketplaceFields);

            api.markForSale(params).then(function (data) {
                _this32.loadData();

                if (_this32.isListOnMarketplace) {
                    _this32.showAlert({
                        type: 'success',
                        text: '\n                                Congratulations! You\'ve listed <b>' + _this32.breeder.name + '</b> on the Everbreed Marketplace.<br/><br/>\n                                Here is a link to the public listing that you can share on social media or with potential buyers:',
                        link: _this32.marketplaceUrl + '/listings/' + data.listing.id + '/details',
                        linkText: 'Link to listing',
                        newTab: true,
                        hideAfter: 10000
                    });
                } else {
                    _this32.showAlert({
                        type: 'success',
                        text: _this32.breeder.name + ' has been marked as for sale.'
                    });
                }

                _this32.isListOnMarketplace = false;
                _this32.isAgreeToTerms = false;
                _this32.listingAmount = 0;
                _this32.listingNotes = "";
                _this32.marketplaceFields = {
                    name: true,
                    tattoo: true,
                    breed: true,
                    date_of_birth: true,
                    sex: true,
                    image: true,
                    weight: true,
                    genotype: true,
                    pedigree: true
                };
                $('#mark-for-sale-modal').modal('hide');
            }, function (response) {});
        },
        removeForSaleModal: function removeForSaleModal(breeder) {
            var _this33 = this;

            api.checkBreedersLimit(true).then(function (data) {
                if (data.ok) {
                    $('#remove-for-sale-modal').modal('show');
                } else {
                    _this33.showBreederLimit(data);
                }
            });
        },
        removeForSale: function removeForSale() {
            var _this34 = this;

            var params = {
                id: this.breeder.for_sale.id
            };

            api.removeForSale(params).then(function (data) {
                _this34.loadData();
                _this34.showAlert({
                    type: 'success',
                    text: _this34.breeder.name + ' has been removed for sale.'
                });

                $('#remove-for-sale-modal').modal('hide');
            }, function (response) {});
        }
    }, 'showKitsFilter', function showKitsFilter() {
        var alive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        var doeId = this.isDoe ? this.breeder.id : "";
        var buckId = !this.isDoe ? this.breeder.id : "";
        var preFiltersKits = {
            doe: doeId,
            buck: buckId,
            status: alive ? "active" : "",
            sex: ""
        };
        localStorage.setItem('filtersKits', (0, _stringify2.default)(preFiltersKits));
        this.$router.go("/litters?tab=kits&kitsFilter=true");
    }),
    ready: function ready() {
        this.loadData();
        this.initTabs();
        this.hideEmptyTimeline();
        this.isLitterTileView = localStorage.getItem('isLitterTileView') == 'true' ? true : false;

        // set default sorting
        this.currentSort = 'born';
        this.currentOrder = 'asc';

        this.getCurrentData();

        $('.litter_btn').css('display', 'none');
        $('.task_btn').css('display', 'none');
        $('.pedigree_btn').css('display', 'none');
        $('.ledger_btn').css('display', 'none');
        $('.birth_certificate_btn').css('display', 'none');
    },
    mixins: [App.Mixins.Butcherable, App.Mixins.DeathReason, App.Mixins.Breeders, App.Mixins.Transferable, App.Mixins.Filterable, App.Mixins.Generic, App.Mixins.Litters, App.Mixins.Alerts]
});

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22,"babel-runtime/helpers/defineProperty":36,"babel-runtime/helpers/extends":37}],815:[function(require,module,exports){
'use strict';

var Instascan = require('instascan');

var QRComponent = Vue.extend({
    template: "#qrcode-template",
    data: function data() {
        return {
            scanner: null,
            activeCamera: null,
            cameras: [],
            scans: []
        };
    },
    methods: {
        load: function load() {
            var self = this;
            self.scanner = new Instascan.Scanner({ video: document.getElementById('preview'), scanPeriod: 5, mirror: false });
            self.scanner.addListener('scan', function (content, image) {
                self.scans.unshift({ date: +Date.now(), content: content });
                if (content.search('http') == 0) window.location.href = content;else alert('Invalid qr code.');
            });
            Instascan.Camera.getCameras().then(function (cameras) {
                self.cameras = cameras;
                if (cameras.length > 0) {
                    if (cameras.length > 1) {
                        $('#camera_change').css('display', 'block');
                        self.activeCamera = cameras[1];
                    } else {
                        $('#camera_change').css('display', 'none');
                        self.activeCamera = cameras[0];
                    }

                    $('#preview').css('display', 'block');
                    $('#file_input_container').css('display', 'none');
                }
            }).catch(function (e) {});
        },

        formatName: function formatName(name) {
            return name || '(unknown)';
        },
        selectCamera: function selectCamera(camera) {
            this.activeCamera = camera;
            this.scanner.start(this.activeCamera);
        },
        startCamera: function startCamera() {
            this.scanner.start(this.activeCamera);
        },
        stopCamera: function stopCamera() {
            this.scanner.stop();
        },
        changeCamera: function changeCamera() {
            if (this.activeCamera == this.cameras[0]) {
                this.scanner.stop();
                this.scanner.start(this.cameras[1]);
            } else {
                this.scanner.stop();
                this.scanner.start(this.cameras[0]);
            }
        }
    },

    ready: function ready() {
        this.load();
    }
});

var vm = new Vue({
    el: '#qrcode',
    components: {
        'qrcode': QRComponent
    }
});

$('#qrModal').on('hidden.bs.modal', function () {
    // do something…
    vm.$refs.qrref.stopCamera();
});

$('.sidebar-qrcode').on('click', function () {
    $('#qrModal').modal();
    vm.$refs.qrref.startCamera();
});

$('#camera_change').on('click', function () {
    vm.$refs.qrref.changeCamera();
});

},{"instascan":624}],816:[function(require,module,exports){
"use strict";

var _referrals = require("../mixins/referrals.js");

var _referrals2 = _interopRequireDefault(_referrals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Referrals = Vue.extend({
  template: "#referrals-template",
  data: function data() {
    return {
      user: {},
      user_id: "",
      success: {},
      errors: {
        emailTo: null,
        emailMessage: null
      },
      loaded: false,
      update_settings_loading: false,
      subscription_updated: moment().unix(),
      is_copy_text: false,
      isNewCard: false,
      currentTab: "subscriptions",
      emailTo: "",
      emailMessage: "I’ve been using Everbreed lately and am loving it. It’s a great program to help rabbit breeders manage their records. \n" + "I thought you would like it, too, so I’m sending you this link. \n" + "When you sign up using this specific link, you’ll also get an added $5 off when you sign up."
    };
  },

  computed: {
    isSubscribed: function isSubscribed() {
      return this.subscription_updated && App.isSubscribed;
    },
    isInAppUser: function isInAppUser() {
      return App.isInAppUSer;
    }
  },
  watch: {},
  methods: {
    copyInviteLink: function copyInviteLink() {
      var copyText = document.getElementById("referral-link-text").innerText;
      var input = document.createElement("textarea");
      input.value = copyText;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      input.remove();

      this.showAlert({
        type: "success",
        text: "Referral link copied to clipboard!"
      });
    },
    initializeTabs: function initializeTabs() {
      var self = this;
      $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        var target = $(e.target).attr("href");
        target = target.replace("#", "");

        self.currentTab = target;
      });
    },
    clearErrors: function clearErrors() {
      this.errors = {
        emailTo: null,
        emailMessage: null
      };
    },
    sendInvite: function sendInvite() {
      var _this = this;

      this.clearErrors();

      if (!this.emailTo) this.errors["emailTo"] = "Please add the email recipient.";
      if (!this.emailMessage) this.errors["emailMessage"] = "Please add your message.";

      var data = {
        email_to: this.emailTo,
        email_message: this.emailMessage
      };

      api.sendReferralInvite(data).then(function (data) {
        _this.showAlert({
          type: "success",
          text: "Successfully sent referral invite to " + _this.emailTo + "!"
        });
      }, function (error) {
        _this.showAlert({
          type: "danger",
          text: "Failed sending referral invite to " + _this.emailTo + ". Please try again later."
        });
      });
    },
    postToSocials: function postToSocials() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "facebook";

      var message = encodeURIComponent("This is a best app for your rabbitry!");
      var link = encodeURIComponent("https://everbreed.com");
      var instagramLink = "https://www.instagram.com/everbreed/";

      if (type == "facebook") {
        window.open("https://www.facebook.com/sharer/sharer.php?u=" + link + "&description=" + message, "pop", "width=600, height=400, scrollbars=no");
      }

      if (type == "twitter") {
        window.open("http://twitter.com/intent/tweet?url=" + link + "&text=" + message, "pop", "width=600, height=400, scrollbars=no");
      }

      if (type == "instagram") {
        window.open(instagramLink);
      }
    },
    reviewApp: function reviewApp() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "appStore";

      var appStoreLink = "https://apps.apple.com/ph/app/everbreed-rabbit-records/id1506912544?action=write-review";
      var playStoreLink = "https://play.google.com/store/apps/details?id=com.barntrax.hutch&hl=en&gl=US";

      if (type == "appStore") {
        window.open(appStoreLink);
      } else {
        window.open(playStoreLink);
      }
    }
  },
  ready: function ready() {
    var _this2 = this;

    this.initializeTabs();

    api.getUserSettingsData(App.user_id).then(function (data) {
      _this2.user = data.user;
      _this2.$nextTick(function () {
        _this2.loaded = true;
      });
    });
  },

  mixins: [_referrals2.default, App.Mixins.Generic, App.Mixins.Alerts]
});

},{"../mixins/referrals.js":901}],817:[function(require,module,exports){
'use strict';

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.AdminReports = {
    template: '#admin-reports-template',
    data: function data() {
        return {
            planCounts: {},
            usersTotal: 0,
            breedersTotal: 0,
            littersTotal: 0,
            kitsTotal: 0,
            overLimit: {}
        };
    },
    props: [],
    computed: {
        overLimitCount: function overLimitCount() {
            var count = 0;
            _.map(this.overLimit, function (plan) {
                count += parseInt(plan.total) || 0;
            });

            return count;
        },
        flatOverLimitUsers: function flatOverLimitUsers() {
            var users = [];
            _.map(this.overLimit, function (plan) {
                _.map(plan.users, function (user) {
                    user.plan = plan.name;
                    user.limit = plan.limit;
                    user.isInApp = !user.stripe_status && user.receipt_data;
                    users.push(user);
                });
            });

            return users;
        },

        planCountsTotal: function planCountsTotal() {
            var total = 0;

            (0, _values2.default)(this.planCounts).forEach(function (item) {
                return total += item.count;
            });

            return total;
        },
        recurringTotal: function recurringTotal() {
            var total = 0;

            (0, _values2.default)(this.planCounts).forEach(function (item) {
                if (item.key_name !== 'forever') {
                    total += item.count * item.price;
                }
            });

            return total.toFixed(2);
        }
    },
    components: {
        'sign-up-report': App.Components.Reports.SignUpReport,
        'marketing-sources-chart': App.Components.Reports.MarketingSourcesChart,
        'cancel-reasons-report': App.Components.Reports.CancelReasonsReport,
        'referral-method-table': App.Components.Reports.ReferralMethodTable,
        'signup-device-report': App.Components.Reports.SignupDeviceReport,
        'user-list-referral-method-table': App.Components.Reports.UserListReferralMethodTable,
        'referral-credit-report': App.Components.Reports.ReferralCreditReport,
        'referral-source-report': App.Components.Reports.ReferralSourceReport,
        'cohort-average-days-to-paying-report': App.Components.CohortaverageDaystoPayingReport,
        'trial-logins-and-conversions': App.Components.Reports.TrialLoginsAndConversionsReport
    },
    events: {},
    watch: {
        overLimitCount: function overLimitCount() {
            this.initializePopovers();
        }
    },
    methods: {
        showOverLimitModal: function showOverLimitModal() {
            $('#users-over-limit-modal').modal('show');
        },
        notifyOverLimit: function notifyOverLimit(user) {
            // Temporary warning
            this.showAlert({
                type: "warning",
                text: "This feature is unavailable as of the moment."
            });
        }
    },
    ready: function ready() {
        var _this = this;

        api.getUsersDashboard().then(function (data) {
            _this.planCounts = data.planCounts;
            _this.breedersTotal = data.breedersTotal;
            _this.littersTotal = data.littersTotal;
            _this.kitsTotal = data.kitsTotal;
        });

        api.getUsers({}).then(function (users) {
            _this.usersTotal = users.total;
        });

        api.getUsersOverLimit().then(function (data) {
            _this.overLimit = data;
        });
    },
    mixins: [App.Mixins.Alerts, App.Mixins.FieldDescription]
};

},{"babel-runtime/core-js/object/values":29}],818:[function(require,module,exports){
'use strict';

App.Components.Reports.CancelReasonsReport = {
    template: '#cancel-reasons-report-template',
    data: function data() {
        return {
            chart: null,
            rows: null,
            average_days: null,

            datasets: [],
            labels: [],
            options: {
                legend: {
                    display: false
                }
            },
            loading: 1,
            order: 'cancel_date|desc',
            currentSort: 'cancel_date',
            currentOrder: 'desc',
            date_range: null,
            cancel_reason: ""
        };
    },
    props: ['cancellationsPage'],
    computed: {},
    components: {
        'line-chart': App.Components.LineChart
    },
    events: {},
    watch: {
        date_range: function date_range() {
            this.datasets = [];
            this.labels = [];

            this.getData();
        },
        order: function order(newData) {
            this.getData();
        },
        cancel_reason: function cancel_reason(newData) {
            this.getData();
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = 1;

            api.getCancelReasonsReport({
                from: this.date_range ? this.date_range[0].format('YYYY-MM-DD') : null,
                to: this.date_range ? this.date_range[1].format('YYYY-MM-DD') : null,
                order: this.order,
                cancel_reason: this.cancel_reason
            }).then(function (data) {
                _this.loading = 0;
                _this.setData(data);

                _this.$nextTick(function () {
                    this.$broadcast('show-chart');
                });
            });
        },

        setData: function setData(data) {
            this.chart = data.chart;
            this.rows = data.rows;
            this.average_days = data.average_days;

            var labels = [];
            var reasons = [];

            _.each(data.chart, function (r, key) {
                labels.push(r.reason);
                reasons.push(r.count);
            });

            this.labels = labels;
            this.datasets = [{
                data: reasons,
                label: 'Reasons'
            }];
        },

        clickDateRange: function clickDateRange() {
            $(this.$els.dateRangeInput).click();
        }
    },
    ready: function ready() {
        this.date_range = [moment().subtract(3, 'month'), moment()];

        $('#cancel-reasons-report-date-range').trigger('triggerDaterangepicker');

        this.cancel_reason = "";
    },
    mixins: [App.Mixins.Filterable]
};

},{}],819:[function(require,module,exports){
"use strict";

App.Components.Reports.CanceledUserReport = {
    template: '#canceled-user-report-template',
    data: function data() {
        return {
            canceledUserData: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterCanceled: function dateFilterCanceled(fromDate, toDate) {
            this.fetchCanceledUserReport(fromDate, toDate);
        },
        fetchCanceledUserReport: function fetchCanceledUserReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };
            api.getCanceledUserReport(params).then(function (response) {
                _this.canceledUserData = response;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchCanceledUserReport();
    }
};

},{}],820:[function(require,module,exports){
"use strict";

App.Components.Reports.ChurnedUsersPercentageReport = {
    template: '#churned-users-percentage-report-template',
    data: function data() {
        return {
            churnedUsersdata: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterChurnedPercentage: function dateFilterChurnedPercentage(fromDate, toDate) {
            this.fetchChurnedUsersPercentageReport(fromDate, toDate);
        },
        fetchChurnedUsersPercentageReport: function fetchChurnedUsersPercentageReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };
            api.getChurnedUsersPercentageReport(params).then(function (response) {
                _this.churnedUsersdata = response;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchChurnedUsersPercentageReport();
    }
};

},{}],821:[function(require,module,exports){
"use strict";

App.Components.Reports.ChurnedUsersReport = {
    template: '#churned-users-report-template',
    data: function data() {
        return {
            churnedUsersdata: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterChurned: function dateFilterChurned(fromDate, toDate) {
            this.fetchChurnedUsersReport(fromDate, toDate);
        },
        fetchChurnedUsersReport: function fetchChurnedUsersReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };
            api.getChurnedUsersReport(params).then(function (response) {
                _this.churnedUsersdata = response;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchChurnedUsersReport();
    }
};

},{}],822:[function(require,module,exports){
"use strict";

App.Components.CohortaverageDaystoPayingReport = {
    template: '#cohort-average-days-to-paying-report-template',
    data: function data() {
        return {
            dataset: {}, // main data content
            total_cohort: {}, // total of Cohort data
            loading: false, // loading checker
            date_range: null // date range filter
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {
        date_range: function date_range(newData) {
            // check if date range is cleared
            if (!newData[0]) {
                this.resetDateRange();
                return;
            }

            // validate date range input
            if (moment(newData[1]).diff(newData[0], "months") > 12) {
                this.date_range = [newData[0], moment(newData[0]).add(1, "years")];
            } else {
                // fetch data from api if data is valid
                this.dataset = {};
                this.fetchCohortAverageDayToPayingReport();
            }
        }
    },
    methods: {
        fetchCohortAverageDayToPayingReport: function fetchCohortAverageDayToPayingReport() {
            var _this = this;

            /**
             * Fetch referral credits summary from api
             *
             * @param {string} url
             */
            this.loading = true;
            var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
            var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;

            var params = { from: fromDate, to: toDate };

            api.getCohortaverageDaystoPayingReport(params).then(function (response) {
                _this.dataset = response.user_summary;
                _this.total_cohort = response.total_summary;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        },


        clickDateRange: function clickDateRange() {
            $(this.$els.dateRangeInput).click();
        }
    },
    ready: function ready() {

        $('#cohort-average-days-to-paying-report-date-range').trigger('triggerDaterangepicker', {
            showDropdowns: true,
            dateLimit: {
                months: 12 // used 12months instead of 1year (eg. 01-01-2019 to 01-30-2020 = 12m but > 1y)
            }
        });

        this.resetDateRange(); // set initial date range
    }
};

},{}],823:[function(require,module,exports){
'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.LineChart = {
    twoWay: true,
    template: '<canvas width="{{ width }}" height="{{ height }}" v-el:canvas></canvas>',
    data: function data() {
        return {
            ctx: null,
            chart: null
        };
    },
    props: ['type', 'width', 'height', 'data', 'options', 'datasets', 'labels', 'legend', 'noRefresh'],
    computed: {},
    components: {},
    watch: {},
    events: {
        'show-chart': function showChart() {
            if (!this.datasets || !this.labels || !this.type) {
                return;
            }

            if (Chart.defaults.global.colours) {
                if (this.type === 'pie' || this.type === 'doughnut') {
                    _.each(this.datasets, function (dataset, index) {
                        if (dataset.backgroundColor === undefined) {
                            dataset.backgroundColor = [];
                            _.each(Chart.defaults.global.colours, function (color) {
                                dataset.backgroundColor.push(color.borderColor);
                            });
                        }
                    });
                } else {
                    _.each(this.datasets, function (dataset, index) {
                        if (dataset.borderColor === undefined) {
                            _.extend(dataset, Chart.defaults.global.colours[index % Chart.defaults.global.colours.length]);
                        }
                    });
                }
            }

            this.chart = new Chart(this.ctx, {
                type: this.type,
                data: {
                    labels: JSON.parse((0, _stringify2.default)(this.labels)),
                    datasets: JSON.parse((0, _stringify2.default)(this.datasets))
                },
                options: this.options
            });

            if (this.legend) {
                $(this.legend).html(this.chart.generateLegend());
            }
        },
        'refresh-chart': function refreshChart() {
            if (this.noRefresh) return;
            this.refreshChart();
        },
        'force-refresh-chart': function forceRefreshChart() {
            if (!this.noRefresh) return;
            this.refreshChart();
        }
    },
    methods: {
        refreshChart: function refreshChart() {
            if (this.chart) {
                this.chart.destroy();
            }

            this.$emit('show-chart');
        }
    },
    ready: function ready() {
        this.ctx = $(this.$els.canvas).get(0).getContext("2d");
        this.$watch('datasets', function (newVal, oldVal) {
            if (this.chart) {
                this.chart.destroy();
                this.$emit('show-chart');
            }
        });
    }
};

},{"babel-runtime/core-js/json/stringify":20}],824:[function(require,module,exports){
'use strict';

App.Components.Reports.MarketingSourcesChart = {
    template: '#marketing-sources-chart-template',
    data: function data() {
        return {
            datasets: [],
            labels: [],
            options: {
                legend: {
                    display: true,
                    position: 'bottom'
                }
            },
            loading: 1,

            does: [],
            period: 'daily',
            date_range: null,
            ignore_empty: true
        };
    },
    props: [],
    computed: {},
    components: {
        'line-chart': App.Components.LineChart
    },
    events: {},
    watch: {
        period: function period() {
            this.datasets = [];
            this.labels = [];
        },
        date_range: function date_range() {
            this.datasets = [];
            this.labels = [];

            this.getData();
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = 1;
            api.marketingSourcesChart({
                ignore_empty: this.ignore_empty,
                period: this.period,
                from: this.date_range ? this.date_range[0].format('YYYY-MM-DD') : null,
                to: this.date_range ? this.date_range[1].format('YYYY-MM-DD') : null
            }).then(function (data) {
                _this.loading = 0;
                _this.setData(data);
                _this.$nextTick(function () {
                    this.$broadcast('show-chart');
                });
            });
        },

        setData: function setData(data) {
            var labels = [];
            var trial = [];
            var paying = [];
            var reactivation = [];

            _.each(data, function (r, key) {
                labels.push(r.label + " %");
                trial.push(r.pr);
            });

            this.labels = labels;
            this.datasets = [{
                label: 'Trial signups',
                data: trial,
                backgroundColor: ["#41B883", "#E46651", "#00D8FF", "#2bca5c", "#7eca2b", "#921b9a59", "#ef2f4a59", "#98913659", "#63636359", "#8041a0"],
                borderWidth: 3
            }];
        },

        clickDateRange: function clickDateRange() {
            $(this.$els.dateRangeInput).click();
        }
    },
    ready: function ready() {
        this.date_range = [moment().subtract(3, 'month').add(1, 'day'), moment()];
        $('#marketing-sources-chart-date-range').trigger('triggerDaterangepicker');
    }
};

},{}],825:[function(require,module,exports){
'use strict';

App.Components.MrrSubscriberReports = {
    template: '#mrr-subscriber-reports-template',
    data: function data() {
        return {
            parentData: "Initial Value",
            date_range: null // date range filter,

        };
    },

    props: [],
    computed: {},
    components: {
        'trials-report': App.Components.Reports.NewTrialsReport,
        'new-paying-users-report': App.Components.Reports.NewPayingUserReport,
        'total-paying-users-report': App.Components.Reports.TotalPayingUserReport,
        'upgrades-users-report': App.Components.Reports.UpgradesUserReport,
        'downgrades-users-report': App.Components.Reports.DowngradesUserdataReport,
        'canceled-users-report': App.Components.Reports.CanceledUserReport,
        'churned-users-report': App.Components.Reports.ChurnedUsersReport,
        'churned-users-percentage-report': App.Components.Reports.ChurnedUsersPercentageReport,
        'reactivation-users-report': App.Components.Reports.ReactivationUsersReport,
        'mrr-total-report': App.Components.Reports.MrrTotalReport,
        'net-new-customer': App.Components.Reports.NetNewCustomersReport
    },
    events: {},
    watch: {
        date_range: function date_range(newData) {
            // check if date range is cleared
            if (!newData[0]) {
                this.resetDateRange();
                return;
            }

            // validate date range input
            if (moment(newData[1]).diff(newData[0], "months") > 12) {
                this.date_range = [newData[0], moment(newData[0]).add(1, "years")];
            } else {
                this.loadAllComponentData();
            }
        }
    },
    methods: {
        loadAllComponentData: function loadAllComponentData() {

            var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
            var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;

            if (this.$refs.childtrial) {
                this.$refs.childtrial.dateFilterTrial(fromDate, toDate);
            }
            if (this.$refs.newpaying) {
                this.$refs.newpaying.dateFilterNewPaying(fromDate, toDate);
            }
            if (this.$refs.upgrades) {
                this.$refs.upgrades.dateFilterUpgrades(fromDate, toDate);
            }
            if (this.$refs.downgrades) {
                this.$refs.downgrades.dateFilterDowngrades(fromDate, toDate);
            }
            if (this.$refs.canceled) {
                this.$refs.canceled.dateFilterCanceled(fromDate, toDate);
            }
            if (this.$refs.totalpaying) {
                this.$refs.totalpaying.dateFilterTotalPaying(fromDate, toDate);
            }
            if (this.$refs.churned) {
                this.$refs.churned.dateFilterChurned(fromDate, toDate);
            }
            if (this.$refs.churnedpercentage) {
                this.$refs.churnedpercentage.dateFilterChurnedPercentage(fromDate, toDate);
            }
            if (this.$refs.reactivation) {
                this.$refs.reactivation.dateFilterReactivation(fromDate, toDate);
            }
            if (this.$refs.mrrtotalreport) {
                this.$refs.mrrtotalreport.dateFilterMrrtotal(fromDate, toDate);
            }
            if (this.$refs.netnewcustomer) {
                this.$refs.netnewcustomer.dateFilterNetNewCustomers(fromDate, toDate);
            }
        },
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        },

        clickDateRange: function clickDateRange() {
            $(this.$els.dateRangeInput).click();
        }
    },
    ready: function ready() {
        $('#users-report-date-range').trigger('triggerDaterangepicker', {
            showDropdowns: true,
            dateLimit: {
                months: 12 // used 12months instead of 1year (eg. 01-01-2019 to 01-30-2020 = 12m but > 1y)
            }
        });
        this.resetDateRange(); // set initial date range
    },
    mixins: [App.Mixins.Alerts, App.Mixins.FieldDescription]
};

},{}],826:[function(require,module,exports){
"use strict";

App.Components.Reports.MrrTotalReport = {
    template: '#mrr-total-report-template',
    data: function data() {
        return {
            mrrTotalData: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterMrrtotal: function dateFilterMrrtotal(fromDate, toDate) {
            this.fetchMrrTotalReport(fromDate, toDate);
        },
        fetchMrrTotalReport: function fetchMrrTotalReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };
            api.getMrrTotalReport(params).then(function (response) {
                _this.mrrTotalData = response;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchMrrTotalReport();
    }
};

},{}],827:[function(require,module,exports){
"use strict";

App.Components.Reports.NetNewCustomersReport = {
    template: '#net-new-customers-report-template',
    data: function data() {
        return {
            netNewCustomers: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterNetNewCustomers: function dateFilterNetNewCustomers(fromDate, toDate) {
            this.fetchNetNewCustomersUserReport(fromDate, toDate);
        },
        fetchNetNewCustomersUserReport: function fetchNetNewCustomersUserReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };
            api.getNetNewCustomersReport(params).then(function (response) {
                _this.netNewCustomers = response;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchNetNewCustomersUserReport();
    }
};

},{}],828:[function(require,module,exports){
"use strict";

App.Components.Reports.NewPayingUserReport = {
    template: '#new-paying-user-report-template',
    data: function data() {
        return {
            newPayingUserdata: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterNewPaying: function dateFilterNewPaying(fromDate, toDate) {
            this.fetchNewpayingUserReport(fromDate, toDate);
        },
        fetchNewpayingUserReport: function fetchNewpayingUserReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };
            api.getNewPayingReport(params).then(function (response) {
                _this.newPayingUserdata = response;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchNewpayingUserReport();
    }
};

},{}],829:[function(require,module,exports){
"use strict";

App.Components.Reports.NewTrialsReport = {
    template: '#new-trials-report-template',
    data: function data() {
        return {
            newTrialdata: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterTrial: function dateFilterTrial(fromDate, toDate) {
            this.fetchNewTrialReport(fromDate, toDate);
        },
        fetchNewTrialReport: function fetchNewTrialReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }

            var params = { from: fromDate, to: toDate };
            api.getNewTrialReport(params).then(function (response) {
                _this.newTrialdata = response;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchNewTrialReport();
    }
};

},{}],830:[function(require,module,exports){
"use strict";

App.Components.Reports.ReactivationUsersReport = {
    template: '#reactivation-users-report-template',
    data: function data() {
        return {
            reactivationUsersdata: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: {},
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterReactivation: function dateFilterReactivation(fromDate, toDate) {
            this.fetchReactivationUsersReport(fromDate, toDate);
        },
        fetchReactivationUsersReport: function fetchReactivationUsersReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";


            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };
            api.getReactivationUsersReport(params).then(function (response) {
                _this.reactivationUsersdata = response;
                _this.loading = false;
            });
        },
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchReactivationUsersReport();
    }
};

},{}],831:[function(require,module,exports){
"use strict";

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _App$Components$Repor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Reports.ReferralCreditReport = (_App$Components$Repor = {
  template: "#referral-credits-table-template",
  data: function data() {
    return {
      dataset: {}, // main data content
      loading: false, // loading checker
      date_range: null // date range filter
    };
  },

  props: [],
  computed: {},
  events: {},
  watch: {
    date_range: function date_range(newData) {
      // check if date range is cleared
      if (!newData[0]) {
        this.resetDateRange();
        return;
      }

      // validate date range input
      if (moment(newData[1]).diff(newData[0], "months") > 12) {
        this.date_range = [newData[0], moment(newData[0]).add(1, "years")];
      } else {
        // fetch data from api if data is valid
        this.datasets = {};
        this.fetchReferralCreditReport();
      }
    }
  }
}, (0, _defineProperty3.default)(_App$Components$Repor, "computed", {}), (0, _defineProperty3.default)(_App$Components$Repor, "methods", {
  /**
   * Fetch referral credits summary from api
   *
   * @param {string} url
   */
  fetchReferralCreditReport: function fetchReferralCreditReport() {
    var _this = this;

    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/admin/reports/referral-credits";

    this.loading = true;
    var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
    var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;

    var params = { from: fromDate, to: toDate };

    // api call
    this.$http.get(url, params).then(function (response) {
      _this.dataset = (0, _extends3.default)({}, response.data);
      _this.loading = false;
    });
  },

  /**
   * Reset date range filter
   */
  resetDateRange: function resetDateRange() {
    this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
  },

  /**
   * Show date range filter
   */
  clickDateRange: function clickDateRange() {
    $(this.$els.dateRangeInput).click();
  }
}), (0, _defineProperty3.default)(_App$Components$Repor, "ready", function ready() {
  // set custom options for date range picker
  $("#referral-credits-table-date-range").trigger("triggerDaterangepicker", {
    showDropdowns: true,
    dateLimit: {
      months: 12 // used 12months instead of 1year (eg. 01-01-2019 to 01-30-2020 = 12m but > 1y)
    }
  });
  this.resetDateRange(); // set initial date range
}), _App$Components$Repor);

},{"babel-runtime/helpers/defineProperty":36,"babel-runtime/helpers/extends":37}],832:[function(require,module,exports){
'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _App$Components$Repor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Reports.ReferralMethodTable = (_App$Components$Repor = {
    template: '#referral-method-table-template',
    data: function data() {
        return {
            datasets: [],
            labels: [],
            loading: 1,
            does: [],
            period: 'daily',
            date_range: null,
            ignore_empty: true,
            referral_method_datas: [],
            currentSort: 'number_of_user_referral_method',
            currentSortDir: 'desc',
            user_list_referral_method_datas: [],
            next_page_url: "",
            is_last_page: false,
            total_referral_method_datas: []
        };
    },
    props: [],
    computed: {},
    events: {},
    watch: {
        period: function period() {
            this.datasets = [];
            this.labels = [];
        },
        date_range: function date_range() {
            this.datasets = [];
            this.labels = [];
            this.getData();
        }
    }
}, (0, _defineProperty3.default)(_App$Components$Repor, 'computed', {
    sortedMethod: function sortedMethod() {
        var _this = this;

        return this.referral_method_datas.sort(function (a, b) {
            var modifier = 1;
            if (_this.currentSortDir === 'desc') modifier = -1;
            if (_this.currentSort == "percentage_of_user_referral_method") {
                if (Math.ceil(a[_this.currentSort]) < Math.ceil(b[_this.currentSort])) return -1 * modifier;
                if (Math.ceil(a[_this.currentSort]) > Math.ceil(b[_this.currentSort])) return 1 * modifier;
            } else {
                if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
                if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
            }
            return 0;
        });
    }
}), (0, _defineProperty3.default)(_App$Components$Repor, 'methods', {
    getData: function getData() {
        var _this2 = this;

        this.loading = 1;
        api.referralMethodTable({
            ignore_empty: this.ignore_empty,
            period: this.period,
            from: this.date_range ? this.date_range[0].format('YYYY-MM-DD') : null,
            to: this.date_range ? this.date_range[1].format('YYYY-MM-DD') : null
        }).then(function (data) {
            _this2.loading = 0;
            _this2.referral_method_datas = data.referral_methods;
            _this2.total_referral_method_datas = data.total_referral_methods_data;
        });
        this.user_list_referral_method_datas = [];
        this.detailsGetData();
    },
    detailsGetData: function detailsGetData() {
        var _this3 = this;

        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/admin/reports/user-list-referral-method-table";


        var fromDate = this.date_range ? this.date_range[0].format('YYYY-MM-DD') : null;
        var toDate = this.date_range ? this.date_range[1].format('YYYY-MM-DD') : null;

        this.loading = 1;
        this.$http.get(url, { 'from': fromDate, 'to': toDate }).then(function (response) {
            var data = response.data;
            var getData = data.data;

            if (data.current_page == data.last_page) {
                _this3.is_last_page = true;
            }

            _this3.next_page_url = data.next_page_url;
            _this3.loading = 0;

            if (getData.length > 0) {
                for (var i = 0; i < getData.length; i++) {
                    var pushData = {
                        "name": getData[i].name,
                        "created_at": getData[i].created_at,
                        "referral_methods": getData[i].referral_methods,
                        "referral_method_details": getData[i].referral_method_details
                    };
                    _this3.user_list_referral_method_datas.push(pushData);
                }
            }
            $(".customer_referral_method").animate({ scrollTop: $(document).height() }, 1000);
        });
    },
    loadMore: function loadMore() {
        this.detailsGetData(this.next_page_url);
    },
    clickDateRange: function clickDateRange() {
        $(this.$els.dateRangeInput).click();
    },
    sort: function sort(srt) {
        if (srt === this.currentSort) {
            this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
        }
        this.currentSort = srt;
    }
}), (0, _defineProperty3.default)(_App$Components$Repor, 'ready', function ready() {
    this.date_range = [moment().subtract(3, 'month').add(1, 'day'), moment()];
    $('#referral-method-table-date-range').trigger('triggerDaterangepicker');
}), _App$Components$Repor);

},{"babel-runtime/helpers/defineProperty":36}],833:[function(require,module,exports){
"use strict";

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _App$Components$Repor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Reports.ReferralSourceReport = (_App$Components$Repor = {
  template: "#referral-source-table-template",
  data: function data() {
    return {
      dataset: {}, // main data content
      loading: false, // loading checker
      date_range: null // date range filter
    };
  },

  props: [],
  computed: {},
  events: {},
  watch: {
    date_range: function date_range(newData) {
      // check if date range is cleared
      if (!newData[0]) {
        this.resetDateRange();
        return;
      }

      // fetch data from api if data is valid
      this.datasets = {};
      this.fetchReferralSourceReport();
    }
  }
}, (0, _defineProperty3.default)(_App$Components$Repor, "computed", {}), (0, _defineProperty3.default)(_App$Components$Repor, "methods", {
  /**
   * Fetch referral source summary from api
   *
   * @param {string} url
   */
  fetchReferralSourceReport: function fetchReferralSourceReport() {
    var _this = this;

    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/admin/reports/referral-source";

    this.loading = true;
    var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
    var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;

    var params = { from: fromDate, to: toDate };

    // api call
    this.$http.get(url, params).then(function (response) {
      _this.dataset = (0, _extends3.default)({}, response.data);
      _this.loading = false;
    });
  },

  /**
   * Reset date range filter
   */
  resetDateRange: function resetDateRange() {
    this.date_range = [moment().subtract(1, "months"), moment().endOf("day")];
  },

  /**
   * Show date range filter
   */
  clickDateRange: function clickDateRange() {
    $(this.$els.dateRangeInput).click();
  }
}), (0, _defineProperty3.default)(_App$Components$Repor, "ready", function ready() {
  // set custom options for date range picker
  $("#referral-source-table-date-range").trigger("triggerDaterangepicker", {
    showDropdowns: true,
    dateLimit: {
      months: 12 // used 12months instead of 1year (eg. 01-01-2019 to 01-30-2020 = 12m but > 1y)
    }
  });
  this.resetDateRange(); // set initial date range
}), _App$Components$Repor);

},{"babel-runtime/helpers/defineProperty":36,"babel-runtime/helpers/extends":37}],834:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.ReferralsReports = {
    template: "#referral-reports-template",
    data: function data() {
        return {
            referrals: {},
            loading: false,
            order: "referral_paid_count|desc",
            currentSort: "referral_paid_count",
            currentOrder: "desc",
            page: 1,
            perPage: 10,
            pagination: {
                from: 0,
                to: 0,
                total: 0
            },
            paginationLinks: [],
            filters: {
                plan: '',
                report_date_range: {
                    from: null,
                    to: null
                }
            },
            preFilters: {
                plan: '',
                report_date_range: {
                    from: null,
                    to: null
                }
            },
            filterRanges: {
                report_date_range: {
                    from: null,
                    to: null
                }
            },
            preFilterRanges: {
                report_date_range: {
                    from: null,
                    to: null
                }
            },
            filterRules: {
                plan: 'string',
                report_date_range: 'daterange'
            },
            plans: {}
        };
    },
    props: [],
    computed: {
        subscriptionStatusesFilter: function subscriptionStatusesFilter() {
            var result = [{
                value: '',
                title: 'All'
            }];

            (0, _values2.default)(this.plans).forEach(function (item) {
                result.push({
                    value: item.key_name,
                    title: item.key_name === 'forever' ? item.name : item.name + ' ' + item.period
                });
            });

            return result;
        }
    },
    components: {},
    events: {},
    watch: {
        order: function order(newData) {
            this.updateList();
        },
        searchQuery: function searchQuery(newData, oldData) {
            this.page = 1;
            this.updateList();
        }
    },
    methods: {
        updateList: function updateList() {
            var _this = this;

            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/admin/reports/referral-reports";

            this.loading = true;
            var data = { page: this.page, perPage: localStorage.getItem("perPage") || this.perPage };
            if (this.order) {
                data.order = this.order;
            }
            data.filters = this.filters;
            data.searchQuery = this.searchQuery;

            // api call
            this.$http.get(url, data).then(function (response) {
                _this.referrals = (0, _extends3.default)({}, response.data.referrals.data);
                _this.paginationLinks = response.data.referrals.links;
                _this.pagination.from = response.data.referrals.from;
                _this.pagination.to = response.data.referrals.to;
                _this.pagination.total = response.data.referrals.total;
                _this.loading = false;
            });
        },
        updatePage: function updatePage() {
            var _this2 = this;

            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/admin/reports/referral-reports";

            // api call
            this.$http.get(url).then(function (response) {
                _this2.referrals = (0, _extends3.default)({}, response.data.referrals.data);
                _this2.paginationLinks = response.data.referrals.links;
                _this2.pagination.from = response.data.referrals.from;
                _this2.pagination.to = response.data.referrals.to;
                _this2.pagination.total = response.data.referrals.total;
                _this2.loading = false;
            });
        },
        applyPreFilters: function applyPreFilters() {
            var _this3 = this;

            this.filterRanges = (0, _extends3.default)({}, this.preFilterRanges);
            this.filters = (0, _extends3.default)({}, this.preFilters);

            this.$nextTick(function () {
                _this3.updateList();
            });
        },
        removeFilter: function removeFilter() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var resetContent = "";
            this.page = 1;

            if (type == 'report_date_range') {
                resetContent = {
                    from: null,
                    to: null
                };

                this.preFilterRanges[type] = resetContent;
            }

            if (type) {
                this.preFilters[type] = resetContent;
                this.applyPreFilters();
            }
        },
        resetPreFilters: function resetPreFilters() {
            this.preFilters = {
                plan: '',
                report_date_range: {
                    from: null,
                    to: null
                }
            };

            this.preFilterRanges = {
                report_date_range: {
                    from: null,
                    to: null
                }
            };

            this.applyPreFilters();
        }
    },
    ready: function ready() {
        var _this4 = this;

        this.updateList();

        $(document).on('click', '.dropdown-menu.main-filters', function (e) {
            if ($(e.target).data("dismiss") != "dropdown") {
                e.stopPropagation();
            }
        });

        this.$nextTick(function () {
            $('#report-date-range').trigger('triggerDaterangepicker');
        });

        api.getSubscriptionPlans().then(function (data) {
            _this4.plans = data;
        });
    },
    mixins: [App.Mixins.Filterable, App.Mixins.Generic]
};

},{"babel-runtime/core-js/object/values":29,"babel-runtime/helpers/extends":37}],835:[function(require,module,exports){
"use strict";

App.Components.ReportsMain = App.Components.Reports.extend({
    template: "#reports-main-template"
});

},{}],836:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Reports = Vue.extend({
    template: "#reports-template",
    data: function data() {
        var _this = this,
            _ref;

        return _ref = {
            breederCategories: [],
            meatProduction: {
                limit: 9,
                otherColor: "#CCC"
            },
            selectedCategory: null
        }, (0, _defineProperty3.default)(_ref, "breederCategories", []), (0, _defineProperty3.default)(_ref, "loadingSubReports", 1), (0, _defineProperty3.default)(_ref, "loadingStatics", 1), (0, _defineProperty3.default)(_ref, "loadingDoes", 1), (0, _defineProperty3.default)(_ref, "loadingBucks", 1), (0, _defineProperty3.default)(_ref, "loadingProductionReport", 1), (0, _defineProperty3.default)(_ref, "weightSlug", ""), (0, _defineProperty3.default)(_ref, "statistics", {}), (0, _defineProperty3.default)(_ref, "does", []), (0, _defineProperty3.default)(_ref, "topMeatdoes", []), (0, _defineProperty3.default)(_ref, "activeDoes", []), (0, _defineProperty3.default)(_ref, "selectedDoesInGrowthRatePerLitterChart", []), (0, _defineProperty3.default)(_ref, "showReasonForDeathChart", false), (0, _defineProperty3.default)(_ref, "report_date_range", {
            from: null,
            to: null
        }), (0, _defineProperty3.default)(_ref, "mortality_report_date_range", {
            from: null,
            to: null
        }), (0, _defineProperty3.default)(_ref, "mortality_report_filters", []), (0, _defineProperty3.default)(_ref, "datasets", {
            production: [],
            meatProduction: [],
            butcherAge: [],
            suirvivalRate: [],
            liveAndDied: [],
            reasonsForDeath: [],
            missedBreedings: [],
            missedBucksBreedings: [],
            avgLitterSizePerDoe: [],
            avgDaysOfGestationPerDoe: [],
            costsPerDoe: [],
            avgKitWeightPerLitter: [],
            growthRatePerLitter: []
        }), (0, _defineProperty3.default)(_ref, "labels", {
            production: [],
            meatProduction: [],
            butcherAge: [],
            suirvivalRate: [],
            liveAndDied: [],
            reasonsForDeath: [],
            missedBreedings: [],
            missedBucksBreedings: [],
            avgLitterSizePerDoe: [],
            avgDaysOfGestationPerDoe: [],
            costsPerDoe: [],
            avgKitWeightPerLitter: [],
            growthRatePerLitter: []
        }), (0, _defineProperty3.default)(_ref, "options", {
            production: {
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        title: function title(tooltipItem, data) {
                            return data.datasets[tooltipItem[0].datasetIndex].data[tooltipItem[0].index].litter;
                        },
                        label: function label(tooltipItem, data) {
                            return _this.showWeights(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y, _this.weightSlug);
                        }
                    }
                },
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            callback: function callback(value, index, values) {
                                if (_this.weightSlug === "lbs-oz") {
                                    return Math.round(value / 16);
                                } else if (_this.weightSlug === "lbs") {
                                    return value;
                                }
                                return Math.round(value * 100) / 100;
                            },
                            beginAtZero: true,
                            min: 0
                        },
                        scaleLabel: {
                            display: true,
                            labelString: "Weight (" + App.weight_units + ")",
                            fontStyle: "bold"
                        }
                    }],
                    xAxes: [{
                        id: 'xAxis1',
                        type: "linear",
                        ticks: {
                            callback: function callback(label) {
                                return label;
                            },
                            stepSize: 1,
                            beginAtZero: true,
                            min: 0
                        },
                        scaleLabel: {
                            display: true,
                            labelString: "Age (Days)",
                            fontStyle: "bold"
                        }
                    }]
                }
            },
            butcherAge: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            },
            missedBreedings: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            stepSize: 1
                        }
                    }]
                }
            },
            missedBucksBreedings: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            stepSize: 1
                        }
                    }]
                }
            },
            meatProduction: {
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        title: function title() {},
                        label: function label(tooltipItem, data) {
                            return _this.showWeights(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], _this.weightSlug);
                        }
                    }
                },
                legend: {
                    display: false
                },
                legendCallback: function legendCallback(chart) {
                    var text = [];
                    text.push('<ul class="' + chart.id + '-legend">');

                    if (chart.data.datasets.length) {
                        for (var i = 0; i < chart.data.datasets[0].data.length; ++i) {
                            text.push('<li><i class="fa fa-circle-o text-' + _this.colours[i % 10] + ' }}"></i> ');
                            if (chart.data.labels[i]) {
                                text.push(chart.data.labels[i]);
                                text.push(' - ' + _this.showWeights(chart.data.datasets[0].data[i], _this.weightSlug));
                            }
                            text.push('</li>');
                        }
                    }

                    text.push('</ul>');

                    return text.join("");
                }
            },

            reasonsForDeath: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            min: 0
                            // max: 4
                        }
                    }]
                }
            },

            avgLitterSizePerDoe: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            min: 0
                        }
                    }]
                },
                onClick: function (e) {
                    var chart = this.$refs.avglittersizeperdoechart.chart;
                    var activeElement = chart.getElementAtEvent(e);

                    if (activeElement.length > 0) {
                        var datasetIndex = activeElement[0]._datasetIndex;
                        var dataIndex = activeElement[0]._index;

                        if (this.datasets.avgLitterSizePerDoe[datasetIndex].view === 'doe') {
                            var subData = this.datasets.avgLitterSizePerDoe[datasetIndex].subData[dataIndex];
                            this.showKitSizePerLitter(subData);
                        } else {
                            this.showAvgLitterSizePerDoe(this.does);
                        }
                    } else {
                        this.showAvgLitterSizePerDoe(this.does);
                    }
                }.bind(this)
            },

            avgDaysOfGestationPerDoe: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false,
                            min: 0
                        }
                    }]
                }
            },

            costsPerDoe: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false,
                            min: 0
                        }
                    }]
                }
            },

            avgKitWeightPerLitter: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false,
                            min: 0
                        }
                    }]
                },
                onClick: function (e) {
                    var chart = this.$refs.avgkitweightchart.chart;
                    var activeElement = chart.getElementAtEvent(e);

                    if (activeElement.length > 0) {
                        var datasetIndex = activeElement[0]._datasetIndex;
                        var dataIndex = activeElement[0]._index;

                        if (this.datasets.avgKitWeightPerLitter[datasetIndex].view === 'doe') {
                            var subData = this.datasets.avgKitWeightPerLitter[datasetIndex].subData[dataIndex];
                            this.showAvgKitWeightPerLitter(subData);
                        } else {
                            this.showAvgLitterWeightPerDoe(this.does);
                        }
                    } else {
                        this.showAvgLitterWeightPerDoe(this.does);
                    }
                }.bind(this)
            },

            growthRatePerLitter: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false,
                            min: 0
                        }
                    }]
                },
                onClick: function (e) {
                    var chart = this.$refs.growthrateperlitterchart.chart;
                    var activeElement = chart.getElementAtEvent(e);

                    if (activeElement.length > 0) {
                        var datasetIndex = activeElement[0]._datasetIndex;
                        var dataIndex = activeElement[0]._index;

                        if (this.datasets.growthRatePerLitter[datasetIndex].view === 'doe') {
                            var subData = this.datasets.growthRatePerLitter[datasetIndex].subData[dataIndex];
                            this.showGrowthRatePerLitter(subData);
                        } else {
                            this.showGrowthRatePerDoe(this.does);
                        }
                    } else {
                        this.showGrowthRatePerDoe(this.does);
                    }
                }.bind(this),
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        label: function (tooltipItem, data) {
                            if (data.datasets[tooltipItem.datasetIndex].view === 'litter') {
                                var litter = data.datasets[tooltipItem.datasetIndex].subData[tooltipItem.index];
                                return [this.showWeights(litter.total_weight, this.weightSlug) + ' in ' + litter.weeksAlive + ' weeks', 'Litter Growth Rate: ' + litter.growthRate];
                            } else {
                                return 'Doe Growth Rate: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            }
                        }.bind(this)
                    }
                }
            }
        }), (0, _defineProperty3.default)(_ref, "colours", ['red', 'green', 'yellow', 'aqua', 'light-blue', 'teal', 'purple', 'maroon', 'orange', 'black']), (0, _defineProperty3.default)(_ref, "activeSubReport", "gestationDays"), (0, _defineProperty3.default)(_ref, "gestationDays", []), (0, _defineProperty3.default)(_ref, "doeMisses", []), (0, _defineProperty3.default)(_ref, "buckMisses", []), (0, _defineProperty3.default)(_ref, "litterSize", []), (0, _defineProperty3.default)(_ref, "doeCosts", []), (0, _defineProperty3.default)(_ref, "survivalRates", []), (0, _defineProperty3.default)(_ref, "liveAndDeadKits", []), (0, _defineProperty3.default)(_ref, "averageKitsWeight", []), (0, _defineProperty3.default)(_ref, "litterGrowthRate", []), (0, _defineProperty3.default)(_ref, "meatProduced", []), (0, _defineProperty3.default)(_ref, "butcherAge", []), (0, _defineProperty3.default)(_ref, "causeOfDeath", []), (0, _defineProperty3.default)(_ref, "breederMortality", []), (0, _defineProperty3.default)(_ref, "kitMortality", []), (0, _defineProperty3.default)(_ref, "deathReasons", []), (0, _defineProperty3.default)(_ref, "inactiveBreeders", []), (0, _defineProperty3.default)(_ref, "isTableView", false), (0, _defineProperty3.default)(_ref, "subreportDatasets", {}), (0, _defineProperty3.default)(_ref, "subreportLabels", {}), (0, _defineProperty3.default)(_ref, "productionFilter", "day"), (0, _defineProperty3.default)(_ref, "productionData", []), (0, _defineProperty3.default)(_ref, "filterByDoeID", 0), (0, _defineProperty3.default)(_ref, "activeTables", {
            gestationDays: null,
            doeMisses: null,
            buckMisses: null,
            litterSize: null,
            doeCosts: null,
            survivalRates: null,
            liveAndDeadKits: null,
            averageKitsWeight: null,
            litterGrowthRate: null,
            meatProduced: null,
            butcherAge: null,
            causeOfDeath: null,
            breederMortality: null,
            kitMortality: null,
            inactiveBreeders: null
        }), (0, _defineProperty3.default)(_ref, "daysInactive", 30), (0, _defineProperty3.default)(_ref, "loadingTopBreeders", false), (0, _defineProperty3.default)(_ref, "topBreeders", []), _ref;
    },
    props: [],
    computed: {
        isShowButcher: function isShowButcher() {
            return App.isShowButcher;
        },
        isLoading: function isLoading() {
            return this.loadingProductionReport;
        },
        isShowViewSwitch: function isShowViewSwitch() {
            return !['breederMortality', 'kitMortality'].includes(this.activeSubReport);
        }
    },
    components: {
        'line-chart': App.Components.LineChart
    },
    events: {
        'load-statistics': function loadStatistics() {
            var _this2 = this;

            this.loadingStatics = 1;
            var req_data = {};
            if (this.report_date_range[0] && this.report_date_range[1]) {
                req_data = this.setDateFromDateRangePicker(this.report_date_range);
            }
            api.getReportsStatistics(req_data).then(function (data) {
                _this2.loadingStatics = 0;
                _this2.statistics = data.statistics;
                _this2.weightSlug = data.weightSlug;
                _this2.showReasonsForDeath();
            });
        },
        'load-does': function loadDoes() {
            var _this3 = this;

            this.loadingDoes = 1;
            var req_data = {};
            if (this.report_date_range[0] && this.report_date_range[1]) {
                req_data = this.setDateFromDateRangePicker(this.report_date_range);
            }
            api.getReportsDoes(req_data).then(function (data) {

                _this3.loadingDoes = 0;
                _this3.does = data.topWeightDoes.filter(function (doe) {
                    return doe.litters && doe.litters.length;
                });
                _this3.topMeatdoes = data.topMeatDoes;
                _this3.activeDoes = _this3.does;

                _this3.calculateMeatProduction(_this3.topMeatdoes);
                _this3.calculateButcherAge(_this3.does);
                _this3.calculateSuirvivalRate(_this3.does);
                _this3.calculateLiveAndDied(_this3.does);
                _this3.calculateMisses(data.topWeightDoes);
                _this3.showAvgLitterSizePerDoe(_this3.does);
                _this3.showAvgDaysOfGestationPerDoe(_this3.does);
                _this3.showCostsPerDoe(_this3.does);
                _this3.showAvgLitterWeightPerDoe(_this3.does);
                _this3.showGrowthRatePerDoe(_this3.does);

                _this3.$nextTick(function () {
                    $('#report-date-range').trigger('triggerDaterangepicker');
                    this.$broadcast('show-chart');
                });
            });
        },
        'load-bucks': function loadBucks() {
            var _this4 = this;

            var req_data = {};
            this.loadingBucks = 1;
            if (this.report_date_range[0] && this.report_date_range[1]) {
                req_data = this.setDateFromDateRangePicker(this.report_date_range);
            }
            api.getReportsBucks(req_data).then(function (data) {
                _this4.loadingBucks = 0;
                _this4.calculateMisses(data.bucks, true);

                _this4.$nextTick(function () {
                    $('#report-date-range').trigger('triggerDaterangepicker');
                    _this4.$broadcast('show-chart');
                });
            });
        }
    },
    watch: {
        selectedCategory: function selectedCategory() {
            this.resetSubreports(this.activeSubReport, false);
        },
        daysInactive: function daysInactive() {
            this.resetSubreports(this.activeSubReport, false);
        },
        activeDoes: function activeDoes() {
            this.showProduction(this.activeDoes);
        },

        report_date_range: function report_date_range() {
            this.datasets = {
                production: [],
                meatProduction: [],
                butcherAge: [],
                suirvivalRate: [],
                liveAndDied: [],
                reasonsForDeath: [],
                missedBreedings: [],
                missedBucksBreedings: [],
                avgLitterSizePerDoe: [],
                avgDaysOfGestationPerDoe: [],
                costsPerDoe: [],
                avgKitWeightPerLitter: [],
                growthRatePerLitter: []
            };
            this.labels = {
                production: [],
                meatProduction: [],
                butcherAge: [],
                suirvivalRate: [],
                liveAndDied: [],
                reasonsForDeath: [],
                missedBreedings: [],
                missedBucksBreedings: [],
                avgLitterSizePerDoe: [],
                avgDaysOfGestationPerDoe: [],
                costsPerDoe: [],
                avgKitWeightPerLitter: [],
                growthRatePerLitter: []
            };

            this.$emit('load-statistics');
            this.resetSubreports();
            this.loadProductionReport();
        },
        mortality_report_date_range: function mortality_report_date_range() {
            this.resetSubreports(this.activeSubReport, false);
        },
        mortality_report_filters: function mortality_report_filters(newData, oldData) {
            if (newData == null && oldData == false) {
                return;
            }

            this.resetSubreports(this.activeSubReport, false);
        }
    },
    methods: {
        resetSubreports: function resetSubreports() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'gestationDays';
            var isFullReset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (isFullReset) $('.nav-pills a[href="#gestation-days"]').tab('show');

            _.map(this.activeTables, function (table) {
                if (table) table.destroy();
            });

            this.activeTables = {
                gestationDays: null,
                doeMisses: null,
                buckMisses: null,
                litterSize: null,
                doeCosts: null,
                survivalRates: null,
                liveAndDeadKits: null,
                averageKitsWeight: null,
                litterGrowthRate: null,
                meatProduced: null,
                butcherAge: null,
                causeOfDeath: null,
                breederMortality: null,
                kitMortality: null,
                inactiveBreeders: null
            };

            this.loadSubReport(type, true);
        },

        setActiveDoe: function setActiveDoe(doe) {
            this.activeDoes = [doe];
        },
        setActiveDoes: function setActiveDoes() {
            this.activeDoes = this.does;
        },
        toggleDoe: function toggleDoe(doe, index) {
            if (this.activeDoes[index] == {}) {
                this.activeDoes[index] = doe;
            } else {
                this.activeDoes[index] = '';
            }
        },

        showProduction: function showProduction(does) {
            var data = this.getProductionData(does);

            this.labels.production = data.labels;
            this.datasets.production = data.datasets;
        },

        calculateMeatProduction: function calculateMeatProduction(does) {
            var _this5 = this;

            var other = 0;
            var datasets = [];
            var meats = [];
            var labels = [];
            this.statistics.totalMeat = 0;
            _.each(does, function (doe, key) {
                var dataset = {};
                var meat = parseFloat(doe.totalMeat);
                dataset.lable = doe.name;
                _this5.statistics.totalMeat += meat;
                labels.push(doe.name);
                meats.push(meat);
            });

            this.statistics.totalMeat = this.statistics.totalMeat.toFixed(2);

            if (other) {
                meats.push(other);
                labels.push('other');
            }

            datasets.push({
                data: meats
            });
            _.each(datasets, function (dataset, index) {
                dataset.backgroundColor = [];
                _.each(Chart.defaults.global.colours, function (color, key) {
                    if (key < _this5.meatProduction.limit) {
                        dataset.backgroundColor.push(color.borderColor);
                    } else {
                        dataset.backgroundColor.push(_this5.meatProduction.otherColor);
                    }
                });
            });

            this.datasets.meatProduction = datasets;
            this.labels.meatProduction = labels;
        },

        calculateMisses: function calculateMisses(breeders) {
            var bucks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var misses = [],
                labels = [];
            var data = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(breeders), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var breeder = _step.value;

                    if (!breeder.misses_count) {
                        continue;
                    }
                    data.push({ name: breeder.name, misses: breeder.misses_count });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            data = _.sortBy(data, 'misses').reverse();
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _breeder = _step2.value;

                    misses.push(_breeder.misses);
                    labels.push(_breeder.name);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (bucks) {
                this.labels.missedBucksBreedings = labels;
                this.datasets.missedBucksBreedings.push({
                    data: misses,
                    label: '',
                    backgroundColor: "rgba(0,192,239,0.5)",
                    borderWidth: 1,
                    borderColor: "rgba(0,192,239,1)"
                });
            } else {
                this.labels.missedBreedings = labels;
                this.datasets.missedBreedings.push({ data: misses, label: '' });
            }
        },


        calculateButcherAge: function calculateButcherAge(does) {
            var labels = [];
            var result = [];
            var days = [];
            _.each(does, function (doe, key) {
                var dataset = {};
                var totalDays = 0;
                var butcheredLitters = 0;
                var hasButchered = false;
                _.each(doe.litters, function (litter) {
                    if (litter.butchered == 1) {
                        var born = App.parseMoment(litter.born);
                        var butchered = moment(litter.butchered_at, 'YYYY-MM-DD H:i:s').startOf('day');
                        var days = butchered.diff(born, "days");
                        totalDays = totalDays + days;
                        butcheredLitters++;
                        hasButchered = true;
                    }
                });

                dataset.data = [Math.round(totalDays / butcheredLitters)];

                if (hasButchered) {
                    result.push({
                        name: doe.name,
                        days: Math.round(totalDays / butcheredLitters)
                    });
                }
            });

            result = _.sortBy(result, 'days');
            _.each(result.reverse(), function (item) {
                labels.push(item.name);
                days.push(item.days);
            });

            this.labels.butcherAge = labels;
            this.datasets.butcherAge.push({ data: days, label: '' });
        },

        calculateSuirvivalRate: function calculateSuirvivalRate(does) {
            var labels = [];
            var result = [];
            var survivalRateTotal = [];
            _.each(does, function (doe, key) {
                var survivalRate = 0;
                _.each(doe.litters, function (litter) {
                    survivalRate = survivalRate + parseFloat(litter.survival_rate);
                });
                if (doe.litters_count) {
                    result.push({
                        name: doe.name,
                        survivalRate: parseFloat((survivalRate / doe.litters_count).toFixed(1))
                    });
                }
            });

            result = _.sortBy(result, 'survivalRate');
            _.each(result.reverse(), function (item) {
                labels.push(item.name);
                survivalRateTotal.push(item.survivalRate);
            });
            this.labels.suirvivalRate = labels;
            this.datasets.suirvivalRate.push({
                data: survivalRateTotal,
                label: '',
                backgroundColor: "rgba(0,166,90,0.5)",
                borderWidth: 1,
                borderColor: "rgba(0,166,90,1)"
            });
        },

        calculateLiveAndDied: function calculateLiveAndDied(does) {
            var labels = [];
            var result = [];

            _.each(does, function (doe, key) {
                var liveKits = 0;
                var diedKits = 0;
                _.each(doe.litters, function (litter) {
                    var died = litter.kits_died == null ? 0 : litter.kits_died;
                    liveKits += parseInt(litter.kits_amount - died);
                    diedKits += parseInt(died);
                });
                if (liveKits || diedKits) {
                    result.push({
                        name: doe.name,
                        liveKits: liveKits,
                        diedKits: diedKits
                    });
                }
            });

            var liveKits = [];
            var diedKits = [];

            result = _.sortBy(result, 'liveKits');
            _.each(result.reverse(), function (item) {
                labels.push(item.name);
                liveKits.push(item.liveKits);
                diedKits.push(item.diedKits);
            });

            this.labels.liveAndDied = labels;
            this.datasets.liveAndDied.push({
                data: liveKits,
                backgroundColor: "rgba(0,166,90,0.5)",
                borderWidth: 1,
                borderColor: "rgba(0,166,90,1)"
            });
            this.datasets.liveAndDied.push({
                data: diedKits,
                backgroundColor: "rgba(255,80,90,0.5)",
                borderWidth: 1,
                borderColor: "rgba(255,80,90,1)"
            });
        },

        showReasonsForDeath: function showReasonsForDeath() {
            if (this.statistics.reasonsForDeath) {
                var reasons = this.statistics.reasonsForDeath;
                var labels = [];
                var data = [];
                _.each(reasons, function (count, reason) {
                    labels.push(reason);
                    data.push(count);
                });

                if (labels.length > 0) {
                    this.showReasonForDeathChart = true;
                }

                this.labels.reasonsForDeath = labels;
                this.datasets.reasonsForDeath.push({
                    data: data,
                    backgroundColor: "rgba(255,80,90,0.5)",
                    borderWidth: 1,
                    borderColor: "rgba(255,80,90,1)"
                });
            }
        },

        showAvgLitterSizePerDoe: function showAvgLitterSizePerDoe(breeders) {
            var data = [];

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(breeders), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var breeder = _step3.value;

                    var kitsSum = 0;
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = (0, _getIterator3.default)(breeder.litters), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var litter = _step4.value;

                            kitsSum += parseInt(litter.kits_amount);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    if (kitsSum > 0) {
                        data.push({
                            name: breeder.name,
                            avg: kitsSum / breeder.litters.length,
                            litters: breeder.litters
                        });
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            data = _.sortBy(data, 'avg').reverse();

            var labels = _.map(data, 'name');
            var datasets = [{
                label: "",
                data: _.map(data, 'avg'),
                subData: _.map(data, 'litters'),
                view: 'doe'
            }];

            this.labels.avgLitterSizePerDoe = labels;
            this.datasets.avgLitterSizePerDoe = datasets;
        },

        showKitSizePerLitter: function showKitSizePerLitter(litters) {
            var data = [];

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = (0, _getIterator3.default)(litters), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var litter = _step5.value;

                    if (litter.kits_amount > 0) {
                        data.push({ name: 'Litter ' + litter.given_id, kits_amount: parseInt(litter.kits_amount) });
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            data = _.sortBy(data, 'kits_amount').reverse();
            var labels = _.map(data, 'name');
            var datasets = [{
                label: "Kits Amount",
                data: _.map(data, 'kits_amount'),
                view: 'litter'
            }];

            this.labels.avgLitterSizePerDoe = labels;
            this.datasets.avgLitterSizePerDoe = datasets;
        },

        showAvgDaysOfGestationPerDoe: function showAvgDaysOfGestationPerDoe(does) {
            var avgs = [],
                labels = [];
            var data = [];

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = (0, _getIterator3.default)(does), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var doe = _step6.value;

                    var daysOfGestation = 0;
                    var _iteratorNormalCompletion8 = true;
                    var _didIteratorError8 = false;
                    var _iteratorError8 = undefined;

                    try {
                        for (var _iterator8 = (0, _getIterator3.default)(doe.litters), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var litter = _step8.value;

                            daysOfGestation += parseInt(litter.daysOfGestation);
                        }
                    } catch (err) {
                        _didIteratorError8 = true;
                        _iteratorError8 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                _iterator8.return();
                            }
                        } finally {
                            if (_didIteratorError8) {
                                throw _iteratorError8;
                            }
                        }
                    }

                    if (daysOfGestation > 0) {
                        data.push({ name: doe.name, avg: daysOfGestation / doe.litters.length });
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            data = _.sortBy(data, 'avg').reverse();
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = (0, _getIterator3.default)(data), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _doe = _step7.value;

                    avgs.push(_doe.avg);
                    labels.push(_doe.name);
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            this.labels.avgDaysOfGestationPerDoe = labels;
            this.datasets.avgDaysOfGestationPerDoe.push({
                data: avgs,
                label: '',
                backgroundColor: "rgba(253,145,25,0.5)"
            });
        },

        showCostsPerDoe: function showCostsPerDoe(does) {
            var costs = [],
                labels = [];
            var data = [];

            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = (0, _getIterator3.default)(does), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var doe = _step9.value;

                    if (doe.totalCost > 0) {
                        data.push({ name: doe.name, cost: doe.totalCost });
                    }
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            data = _.sortBy(data, 'cost').reverse();
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
                for (var _iterator10 = (0, _getIterator3.default)(data), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var _doe2 = _step10.value;

                    costs.push(_doe2.cost);
                    labels.push(_doe2.name);
                }
            } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                        _iterator10.return();
                    }
                } finally {
                    if (_didIteratorError10) {
                        throw _iteratorError10;
                    }
                }
            }

            this.labels.costsPerDoe = labels;
            this.datasets.costsPerDoe.push({
                data: costs,
                label: '',
                backgroundColor: "rgba(253,145,25,0.5)"
            });
        },

        showAvgLitterWeightPerDoe: function showAvgLitterWeightPerDoe(does) {
            var colors = [];

            var doesWithWeight = _.filter(does, function (d) {
                return d.avgLitterWeight > 0;
            });

            doesWithWeight = _.sortBy(doesWithWeight, 'avgLitterWeight').reverse();

            _.each(doesWithWeight, function (doe) {
                var doeExternalKey = _.findIndex(does, function (externalDoe) {
                    return externalDoe.id == doe.id;
                });
                colors.push(Chart.defaults.global.colours[doeExternalKey % Chart.defaults.global.colours.length]);
            });

            var labels = _.map(doesWithWeight, 'name');
            var datasets = [{
                label: "Avg. Litter Weight",
                data: _.map(doesWithWeight, function (doe) {
                    return Math.round(doe.avgLitterWeight * 1e2) / 1e2;
                }),
                subData: _.map(doesWithWeight, 'litters'),
                view: 'doe',
                backgroundColor: _.map(colors, 'backgroundColor'),
                borderColor: _.map(colors, 'borderColor'),
                borderWidth: 1,
                hoverBackgroundColor: _.map(colors, 'hoverBackgroundColor'),
                hoverBorderColor: _.map(colors, 'hoverBorderColor')
            }];

            this.labels.avgKitWeightPerLitter = labels;
            this.datasets.avgKitWeightPerLitter = datasets;
        },

        showAvgKitWeightPerLitter: function showAvgKitWeightPerLitter(litters) {
            var littersWithWeight = _.filter(litters, function (d) {
                return d.avgKitWeight > 0;
            });

            littersWithWeight = _.sortBy(littersWithWeight, 'avgKitWeight').reverse();

            var labels = _.map(littersWithWeight, function (litter) {
                return 'Litter ' + litter.given_id;
            });

            var datasets = [{
                label: "Avg. Kit Weight",
                data: _.map(littersWithWeight, function (d) {
                    return Math.round(d.avgKitWeight * 1e2) / 1e2;
                }),
                view: 'litter'
            }];

            var doeExternalKey = _.findIndex(this.does, function (externalDoe) {
                return _.isEqual(externalDoe.litters, litters);
            });
            _.extend(datasets[0], Chart.defaults.global.colours[doeExternalKey % Chart.defaults.global.colours.length]);

            this.labels.avgKitWeightPerLitter = labels;
            this.datasets.avgKitWeightPerLitter = datasets;
        },

        showGrowthRatePerDoe: function showGrowthRatePerDoe(does) {
            var colors = [];
            var doesWithGrowthRate = _.filter(does, function (d) {
                var littersWithGrowthRate = _.filter(d.litters, function (l) {
                    return l.growthRate > 0;
                });
                return littersWithGrowthRate.length > 0;
            });

            var doesGrowthRate = [];

            _.each(doesWithGrowthRate, function (doe) {
                var doeExternalKey = _.findIndex(does, function (externalDoe) {
                    return externalDoe.id == doe.id;
                });
                colors.push(Chart.defaults.global.colours[doeExternalKey % Chart.defaults.global.colours.length]);

                var sum = 0;
                _.each(doe.litters, function (litter) {
                    sum += litter.growthRate;
                });
                var mean = sum / doe.litters.length;
                mean = Math.round(mean * 1e2) / 1e2;
                doesGrowthRate.push({ name: doe.name, growthRate: mean });
            });

            doesGrowthRate = _.sortBy(doesGrowthRate, 'growthRate').reverse();

            var labels = _.map(doesGrowthRate, 'name');
            var datasets = [{
                label: "Growth Rate per Doe",
                data: _.map(doesGrowthRate, 'growthRate'),
                subData: _.map(doesWithGrowthRate, 'litters'),
                view: 'doe',
                backgroundColor: _.map(colors, 'backgroundColor'),
                borderColor: _.map(colors, 'borderColor'),
                borderWidth: 1,
                hoverBackgroundColor: _.map(colors, 'hoverBackgroundColor'),
                hoverBorderColor: _.map(colors, 'hoverBorderColor')
            }];

            this.labels.growthRatePerLitter = labels;
            this.datasets.growthRatePerLitter = datasets;
        },
        showGrowthRatePerLitter: function showGrowthRatePerLitter(litters) {
            var littersWithGrowthRate = _.filter(litters, function (d) {
                return d.growthRate > 0;
            });

            littersWithGrowthRate = _.sortBy(littersWithGrowthRate, 'growthRate').reverse();

            var labels = _.map(littersWithGrowthRate, function (litter) {
                return 'Litter ' + litter.given_id;
            });

            var datasets = [{
                data: _.map(littersWithGrowthRate, function (l) {
                    return Math.round(l.growthRate * 1e2) / 1e2;
                }),
                subData: littersWithGrowthRate,
                view: 'litter'
            }];

            var doeExternalKey = _.findIndex(this.does, function (externalDoe) {
                return _.isEqual(externalDoe.litters, litters);
            });
            _.extend(datasets[0], Chart.defaults.global.colours[doeExternalKey % Chart.defaults.global.colours.length]);

            this.labels.growthRatePerLitter = labels;
            this.datasets.growthRatePerLitter = datasets;
        },
        setDateFromDateRangePicker: function setDateFromDateRangePicker(daterange) {
            var retrun_val = {
                from: null,
                to: null
            };
            retrun_val.from = daterange[0].format('YYYY-MM-DD');
            retrun_val.to = daterange[1].format('YYYY-MM-DD');
            return retrun_val;
        },
        clickDateRange: function clickDateRange() {
            $(this.$els.dateRangeInput).click();
        },
        loadProductionReport: function loadProductionReport() {
            var _this6 = this;

            var isInitial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var params = {};
            this.loadingProductionReport = true;

            if (this.report_date_range[0] && this.report_date_range[1]) {
                params = this.setDateFromDateRangePicker(this.report_date_range);
            }

            api.productionReport(params).then(function (data) {
                _this6.loadingProductionReport = false;
                _this6.productionData = data;
                _this6.buildProduction();

                _this6.$nextTick(function () {
                    $('#report-date-range').trigger('triggerDaterangepicker');
                    _this6.$broadcast('show-chart');

                    if (isInitial) {
                        _this6.loadSubReport('gestationDays');
                    }
                });
            });
        },
        loadDeathReasons: function loadDeathReasons() {
            var _this7 = this;

            api.getDeathReasons().then(function (data) {
                _this7.deathReasons = data;
            });
        },
        loadSubReport: function loadSubReport() {
            var _this8 = this;

            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var params = {};
            var key = '';
            var secondaryKey = '';
            this.loadingSubReports = 1;

            if (type) {
                this.activeSubReport = type;
            } else {
                type = this.activeSubReport;
            }

            // check if report is already loaded
            if (this.activeTables[type] && !force) {
                this.loadingSubReports = 0;
                return true;
            }

            if (['breederMortality', 'kitMortality'].includes(type)) {
                if (this.mortality_report_date_range[0] && this.mortality_report_date_range[1]) {
                    params = this.setDateFromDateRangePicker(this.mortality_report_date_range);
                }

                params.filters = this.mortality_report_filters;
            } else {
                if (this.report_date_range[0] && this.report_date_range[1]) {
                    params = this.setDateFromDateRangePicker(this.report_date_range);
                }
            }

            params.category_id = this.selectedCategory || '';
            params.days_inactive = this.daysInactive || '';
            var methodCall = function methodCall() {};

            switch (type) {
                case 'gestationDays':
                    methodCall = api.getGestationDays(params);
                    key = 'gestation_days';
                    break;
                case 'doeMisses':
                    methodCall = api.getDoeMisses(params);
                    key = 'missed_plans_count';
                    break;
                case 'buckMisses':
                    methodCall = api.getBuckMisses(params);
                    key = 'missed_plans_count';
                    break;
                case 'litterSize':
                    methodCall = api.getLitterSize(params);
                    key = 'litter_size';
                    break;
                case 'doeCosts':
                    methodCall = api.getDoeCosts(params);
                    key = 'doe_costs';
                    break;
                case 'survivalRates':
                    methodCall = api.getSurvivalRates(params);
                    key = 'survival_rate';
                    break;
                case 'liveAndDeadKits':
                    methodCall = api.getLiveAndDeadKits(params);
                    key = 'live_kits';
                    secondaryKey = 'dead_kits';
                    break;
                case 'averageKitsWeight':
                    methodCall = api.getAverageKitsWeight(params);
                    key = 'kit_weight';
                    break;
                case 'litterGrowthRate':
                    methodCall = api.getLitterGrowthRate(params);
                    key = 'growth_rate';
                    break;
                case 'meatProduced':
                    methodCall = api.getMeatProduced(params);
                    key = 'meat_produced';
                    break;
                case 'butcherAge':
                    methodCall = api.getButcherAge(params);
                    key = 'butcher_age';
                    break;
                case 'causeOfDeath':
                    methodCall = api.getCauseOfDeath(params);
                    break;
                case 'breederMortality':
                    methodCall = api.getBreederMortality(params);
                    break;
                case 'kitMortality':
                    methodCall = api.getKitMortality(params);
                    break;
                case 'inactiveBreeders':
                    methodCall = api.getInactiveBreeders(params);
                    break;
            }

            try {
                methodCall.then(function (data) {
                    _this8.loadingSubReports = 0;
                    _this8[type] = data;

                    if (!['breederMortality', 'kitMortality'].includes(type)) {
                        _this8.buildChart(data, type, key, secondaryKey);
                    } else {
                        $('#mortality-report-date-range').trigger('triggerDaterangepicker');
                    }

                    _this8.initializeTable();
                });
            } catch ($e) {}
        },
        buildChart: function buildChart(data, type, key, secondaryKey) {
            var _this9 = this;

            var avgs = _.pluck(data, key);
            var secondaryAvgs = _.pluck(data, secondaryKey);
            var labels = _.pluck(data, 'name');

            if (type == 'causeOfDeath') {
                avgs = (0, _values2.default)(data.death_reasons);
                labels = (0, _keys2.default)(data.death_reasons);
            }

            this.subreportLabels[type] = labels;
            this.subreportDatasets[type] = [{
                data: avgs,
                label: ''
            }];

            if (secondaryKey) {
                this.subreportDatasets[type].push({
                    data: secondaryAvgs,
                    label: ''
                });
            }

            switch (type) {
                case 'buckMisses':
                    _.extend(this.subreportDatasets[type][0], Chart.defaults.global.colours[3]);
                    break;
                case 'doeCosts':
                    _.extend(this.subreportDatasets[type][0], Chart.defaults.global.colours[2]);
                    break;
                case 'survivalRates':
                    _.extend(this.subreportDatasets[type][0], Chart.defaults.global.colours[1]);
                    break;
                case 'liveAndDeadKits':
                    _.extend(this.subreportDatasets[type][0], Chart.defaults.global.colours[1]);
                    _.extend(this.subreportDatasets[type][1], Chart.defaults.global.colours[0]);
                    break;
            }

            this.$nextTick(function () {
                _this9.$broadcast('refresh-chart');
            });
        },
        buildProduction: function buildProduction() {
            var _this10 = this;

            var isAutoFiltered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var data = this.buildProductionData(this.productionData);

            this.labels.production = data.labels;
            this.datasets.production = data.datasets;

            if (!isAutoFiltered) {
                if (this.productionFilter == 'day' && data.max > 60) {
                    this.setProductionFilter('week', false);
                    return;
                } else if (this.productionFilter == 'week' && data.max > 52) {
                    this.setProductionFilter('month', false);
                    return;
                } else if (this.productionFilter == 'month' && data.max < 12) {
                    this.setProductionFilter('week', false);
                    return;
                } else if (this.productionFilter == 'week' && data.max < 8) {
                    this.setProductionFilter('day', false);
                    return;
                }
            }

            this.$nextTick(function () {
                _this10.$broadcast('force-refresh-chart');
            });
        },
        setProductionFilter: function setProductionFilter() {
            var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'day';
            var isAutoFiltered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this.setProductionLabel(filter);
            this.productionFilter = filter;

            this.buildProduction(isAutoFiltered);
        },
        setProductionLabel: function setProductionLabel() {
            var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'day';

            switch (filter) {
                case 'month':
                    this.options.production.scales.xAxes[0].scaleLabel.labelString = 'Age (Months)';
                    this.options.production.scales.xAxes[0].ticks.suggestedMax = 12;
                    break;
                case 'week':
                    this.options.production.scales.xAxes[0].scaleLabel.labelString = 'Age (Weeks)';
                    this.options.production.scales.xAxes[0].ticks.suggestedMax = 8;
                    break;
                case 'day':
                default:
                    this.options.production.scales.xAxes[0].scaleLabel.labelString = 'Age (Days)';
                    this.options.production.scales.xAxes[0].ticks.suggestedMax = 31;
            }
        },
        setActiveProductionDoes: function setActiveProductionDoes() {
            var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            this.filterByDoeID = id;
            this.buildProduction();
        },
        switchTableView: function switchTableView() {
            var _this11 = this;

            this.isTableView = !this.isTableView;
            this.$nextTick(function () {
                _this11.$broadcast('refresh-chart');
            });
        },
        initializeTable: function initializeTable() {
            var _this12 = this;

            var key = 'gestation-days';
            switch (this.activeSubReport) {
                case 'gestationDays':
                    key = 'gestation-days';
                    break;
                case 'doeMisses':
                    key = 'doe-misses';
                    break;
                case 'buckMisses':
                    key = 'buck-misses';
                    break;
                case 'litterSize':
                    key = 'litter-size';
                    break;
                case 'doeCosts':
                    key = 'doe-cost';
                    break;
                case 'survivalRates':
                    key = 'survival-rates';
                    break;
                case 'liveAndDeadKits':
                    key = 'live-and-dead-kits';
                    break;
                case 'averageKitsWeight':
                    key = 'kit-weight';
                    break;
                case 'litterGrowthRate':
                    key = 'growth-rate';
                    break;
                case 'meatProduced':
                    key = 'meat-produced';
                    break;
                case 'butcherAge':
                    key = 'butcher-age';
                    break;
                case 'causeOfDeath':
                    key = 'cause-of-death';
                    break;
                case 'breederMortality':
                    key = 'breeder-mortality';
                    break;
                case 'kitMortality':
                    key = 'kit-mortality';
                    break;
                case 'inactiveBreeders':
                    key = 'inactive-breeders';
                    break;
            }

            this.$nextTick(function () {
                if (!_this12.activeTables[_this12.activeSubReport] && _this12[_this12.activeSubReport].length) {
                    _this12.activeTables[_this12.activeSubReport] = $("#" + key + " table").DataTable({
                        dom: 'Bfrtip',
                        searching: false,
                        buttons: [{
                            extend: 'csvHtml5',
                            text: 'Export data',
                            filename: key,
                            exportOptions: {
                                modifier: {
                                    search: 'none'
                                }
                            }
                        }],
                        language: {
                            paginate: {
                                next: '&raquo;',
                                previous: '&laquo;'
                            }
                        },
                        order: [[2, "asc"]]
                    });
                    _this12.activeTables[_this12.activeSubReport].buttons().container().appendTo($("#" + key + "-hidden-btn"));
                }
            });
        },
        downloadAsCSV: function downloadAsCSV() {
            this.activeTables[this.activeSubReport].button(0).trigger();
        },
        fetchBreederCategories: function fetchBreederCategories() {
            var _this13 = this;

            api.getBreederCategories().then(function (data) {
                _this13.breederCategories = data.categories || [];
            });
        },
        getFirstEvent: function getFirstEvent() {
            var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var key = arguments[1];

            console.log(events);
            if (events.length) {
                var event = events[0];
                return event[key];
            }

            return '—';
        },
        loadTopBreeders: function loadTopBreeders() {
            var _this14 = this;

            this.loadingTopBreeders = true;
            api.getTopBreeders().then(function (data) {
                _this14.loadingTopBreeders = false;
                _this14.topBreeders = data || [];
            }, function (response) {
                _this14.loadingTopBreeders = false;
            });
        }
    },
    ready: function ready() {
        this.$emit('load-statistics');
        this.loadDeathReasons();
        this.loadProductionReport(true);
        this.fetchBreederCategories();
        this.loadTopBreeders();
    },
    mixins: [App.Mixins.Currency, App.Mixins.Reports, App.Mixins.Weightable, App.Mixins.Alerts, App.Mixins.Generic, App.Mixins.DateHelper, App.Mixins.FieldDescription]
});

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/object/keys":27,"babel-runtime/core-js/object/values":29,"babel-runtime/helpers/defineProperty":36}],837:[function(require,module,exports){
'use strict';

App.Components.Reports.SignUpReport = {
    template: '#sign-up-report-template',
    data: function data() {
        return {
            datasets: [],
            labels: [],
            options: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            },
            loading: 1,

            does: [],
            period: 'daily',
            date_range: null,
            ignore_empty: true
        };
    },
    props: [],
    computed: {},
    components: {
        'line-chart': App.Components.LineChart
    },
    events: {},
    watch: {
        period: function period() {
            this.datasets = [];
            this.labels = [];
        },
        date_range: function date_range() {
            this.datasets = [];
            this.labels = [];

            this.getData();
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = 1;

            api.getSignUpReport({
                ignore_empty: this.ignore_empty,
                period: this.period,
                from: this.date_range ? this.date_range[0].format('YYYY-MM-DD') : null,
                to: this.date_range ? this.date_range[1].format('YYYY-MM-DD') : null
            }).then(function (data) {
                _this.loading = 0;
                _this.setData(data);

                _this.$nextTick(function () {
                    this.$broadcast('show-chart');
                });
            });
        },

        setData: function setData(data) {
            var labels = [];
            var trial = [];
            var paying = [];
            var reactivation = [];

            _.each(data, function (r, key) {
                labels.push(r.created);
                trial.push(r.total);
                paying.push(r.paying);
                reactivation.push(r.reactivation);
            });

            this.labels = labels;
            this.datasets = [{
                label: 'Trial signups',
                data: trial,
                backgroundColor: Chart.defaults.global.colours[0].backgroundColor,
                borderColor: Chart.defaults.global.colours[0].borderColor,
                borderWidth: 1
            }, {
                label: 'Paying signups',
                data: paying,
                backgroundColor: Chart.defaults.global.colours[1].backgroundColor,
                borderColor: Chart.defaults.global.colours[1].borderColor,
                borderWidth: 1
            }, {
                label: 'Reactivation',
                data: reactivation,
                backgroundColor: Chart.defaults.global.colours[2].backgroundColor,
                borderColor: Chart.defaults.global.colours[2].borderColor,
                borderWidth: 1
            }];
        },

        clickDateRange: function clickDateRange() {
            $(this.$els.dateRangeInput).click();
        }
    },
    ready: function ready() {
        this.date_range = [moment().startOf('month'), moment()];

        $('#sign-up-report-date-range').trigger('triggerDaterangepicker');
    }
};

},{}],838:[function(require,module,exports){
'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _App$Components$Repor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Reports.SignupDeviceReport = (_App$Components$Repor = {
    template: '#signup-device-report-template',
    data: function data() {
        return {
            datasets: [],
            labels: [],
            loading: 1,
            does: [],
            period: 'daily',
            date_range: null,
            ignore_empty: true,
            signup_device_report_data: [],
            currentSort: 'number_of_user_singup_device',
            currentSortDir: 'desc',
            user_list_signup_device_report_data: [],
            next_page_url: "",
            is_last_page: false,
            total_signup_device_report_data: []
        };
    },
    props: [],
    computed: {},
    events: {},
    watch: {
        period: function period() {
            this.datasets = [];
            this.labels = [];
        },
        date_range: function date_range() {
            this.datasets = [];
            this.labels = [];
            this.getData();
        }
    }
}, (0, _defineProperty3.default)(_App$Components$Repor, 'computed', {
    sortedMethod: function sortedMethod() {
        var _this = this;

        return this.signup_device_report_data.sort(function (a, b) {
            var modifier = 1;
            if (_this.currentSortDir === 'desc') modifier = -1;
            if (_this.currentSort == "percentage_of_user_singup_device") {
                if (Math.ceil(a[_this.currentSort]) < Math.ceil(b[_this.currentSort])) return -1 * modifier;
                if (Math.ceil(a[_this.currentSort]) > Math.ceil(b[_this.currentSort])) return 1 * modifier;
            } else {
                if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
                if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
            }
            return 0;
        });
    }
}), (0, _defineProperty3.default)(_App$Components$Repor, 'methods', {
    getData: function getData() {
        var _this2 = this;

        this.loading = 1;
        api.getSignUpDeviceReporn({
            ignore_empty: this.ignore_empty,
            period: this.period,
            from: this.date_range ? this.date_range[0].format('YYYY-MM-DD') : null,
            to: this.date_range ? this.date_range[1].format('YYYY-MM-DD') : null,
            report_type: "signup_device"
        }).then(function (data) {
            _this2.loading = 0;
            _this2.signup_device_report_data = data.referral_methods;
            _this2.total_signup_device_report_data = data.total_referral_methods_data;
        });
        this.user_list_signup_device_report_data = [];
        this.detailsGetData();
    },
    detailsGetData: function detailsGetData() {
        var _this3 = this;

        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/admin/reports/user-list-signup-device";


        var fromDate = this.date_range ? this.date_range[0].format('YYYY-MM-DD') : null;
        var toDate = this.date_range ? this.date_range[1].format('YYYY-MM-DD') : null;

        this.loading = 1;
        this.$http.get(url, { 'from': fromDate, 'to': toDate }).then(function (response) {
            var data = response.data;
            var getData = data.data;

            if (data.current_page == data.last_page) {
                _this3.is_last_page = true;
            }

            _this3.next_page_url = data.next_page_url;
            _this3.loading = 0;

            if (getData.length > 0) {
                for (var i = 0; i < getData.length; i++) {
                    var pushData = {
                        "name": getData[i].name,
                        "created_at": getData[i].created_at,
                        "signup_device": getData[i].signup_device
                    };
                    _this3.user_list_signup_device_report_data.push(pushData);
                }
            }
            $(".signup_device_report_method").animate({ scrollTop: $(document).height() }, 1000);
        });
    },
    loadMore: function loadMore() {
        this.detailsGetData(this.next_page_url);
    },
    clickDateRange: function clickDateRange() {
        $(this.$els.dateRangeInput).click();
    },
    sort: function sort(srt) {
        if (srt === this.currentSort) {
            this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
        }
        this.currentSort = srt;
    }
}), (0, _defineProperty3.default)(_App$Components$Repor, 'ready', function ready() {
    this.date_range = [moment().subtract(3, 'month').add(1, 'day'), moment()];
    $('#signup-device-date-range').trigger('triggerDaterangepicker');
}), _App$Components$Repor);

},{"babel-runtime/helpers/defineProperty":36}],839:[function(require,module,exports){
"use strict";

App.Components.Reports.TotalPayingUserReport = {
    template: '#total-paying-user-report-template',
    data: function data() {
        return {
            totalPayingUserdata: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterTotalPaying: function dateFilterTotalPaying(fromDate, toDate) {
            this.fetchTotalpayingUserReport(fromDate, toDate);
        },
        fetchTotalpayingUserReport: function fetchTotalpayingUserReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };

            api.getTotalPayingReport(params).then(function (response) {
                _this.totalPayingUserdata = response;
                _this.loading = false;
            });
        },
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchTotalpayingUserReport();
    }
};

},{}],840:[function(require,module,exports){
"use strict";

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _App$Components$Repor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Reports.TrialLoginsAndConversionsReport = (_App$Components$Repor = {
  template: "#trial-logins-and-conversions-template",
  data: function data() {
    return {
      dataset: {}, // main table content
      averages: {}, // all data summary
      loading: false, // loading checker
      date_range: null // date range filter
    };
  },

  props: [],
  computed: {},
  events: {},
  watch: {
    date_range: function date_range(newData) {
      // check if date range is cleared
      if (!newData[0]) {
        this.resetDateRange();
        return;
      }

      // fetch data from api if data is valid
      this.clearData();
      this.fetchTrialLoginsAndConversions();
    }
  }
}, (0, _defineProperty3.default)(_App$Components$Repor, "computed", {}), (0, _defineProperty3.default)(_App$Components$Repor, "methods", {
  /**
   * Fetch referral credits summary from api
   *
   * @param {string} url
   */
  fetchTrialLoginsAndConversions: function fetchTrialLoginsAndConversions() {
    var _this = this;

    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/admin/reports/trial-logins-and-conversions";

    this.loading = true;
    var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
    var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;

    var params = { from: fromDate, to: toDate };

    // api call
    this.$http.get(url, params).then(function (response) {
      _this.dataset = (0, _extends3.default)({}, response.data.table_data);
      _this.averages = (0, _extends3.default)({}, response.data);
      _this.loading = false;
      console.log(response, _this.dataset, _this.averages);
    });
  },

  /**
   * Cleanup current data
   */
  clearData: function clearData() {
    this.datasets = {};
    this.averages = {};
  },

  /**
   * Reset date range filter
   */
  resetDateRange: function resetDateRange() {
    this.date_range = [moment().subtract(6, "months"), moment().endOf("day")];
  },

  /**
   * Show date range filter
   */
  clickDateRange: function clickDateRange() {
    $(this.$els.dateRangeInput).click();
  }
}), (0, _defineProperty3.default)(_App$Components$Repor, "ready", function ready() {
  // set custom options for date range picker
  $("#trial-logins-and-conversions-date-range").trigger("triggerDaterangepicker");
  this.resetDateRange(); // set initial date range
}), _App$Components$Repor);

},{"babel-runtime/helpers/defineProperty":36,"babel-runtime/helpers/extends":37}],841:[function(require,module,exports){
"use strict";

App.Components.Reports.DowngradesUserdataReport = {
    template: '#downgrades-user-report-template',
    data: function data() {
        return {
            downgradesUserdata: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterDowngrades: function dateFilterDowngrades(fromDate, toDate) {
            this.fetchDowngradesReport(fromDate, toDate);
        },
        fetchDowngradesReport: function fetchDowngradesReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };
            api.getDowngradesUserReport(params).then(function (response) {
                _this.downgradesUserdata = response;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchDowngradesReport();
    }
};

},{}],842:[function(require,module,exports){
'use strict';

App.Components.Reports.UserListReferralMethodTable = {
    template: '#user-list-referral-method-table-template',
    data: function data() {
        return {
            datasets: [],
            labels: [],
            loading: 1,
            does: [],
            period: 'daily',
            date_range: null,
            ignore_empty: true,
            user_list_referral_method_datas: [],
            next_page_url: "",
            is_last_page: false
        };
    },
    props: [],
    computed: {},
    events: {},
    watch: {},
    methods: {
        getData: function getData() {
            var _this = this;

            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/admin/reports/user-list-referral-method-table";


            this.loading = 1;
            this.$http.get(url).then(function (response) {
                var data = response.data;
                var getData = data.data;

                if (data.current_page == data.last_page) {
                    _this.is_last_page = true;
                }

                _this.next_page_url = data.next_page_url;
                _this.loading = 0;

                if (getData.length > 0) {
                    for (var i = 0; i < getData.length; i++) {
                        var pushData = {
                            "name": getData[i].name,
                            "created_at": getData[i].created_at,
                            "referral_methods": getData[i].referral_methods,
                            "referral_method_details": getData[i].referral_method_details
                        };
                        _this.user_list_referral_method_datas.push(pushData);
                    }
                }
                $(".customer_referral_method").animate({ scrollTop: $(document).height() }, 1000);
            });
        },
        loadMore: function loadMore() {
            this.getData(this.next_page_url);
        }
    },
    ready: function ready() {
        this.getData();
    }
};

},{}],843:[function(require,module,exports){
"use strict";

App.Components.Reports.UpgradesUserReport = {
    template: '#upgrades-user-report-template',
    data: function data() {
        return {
            upgradesUserdata: [], // main data content
            loading: false, // loading checker
            date_range: null // date range filter,
        };
    },
    props: [],
    computed: {},
    components: {},
    events: {},
    watch: {},
    methods: {
        dateFilterUpgrades: function dateFilterUpgrades(fromDate, toDate) {
            this.fetchUpgradeUserReport(fromDate, toDate);
        },
        fetchUpgradeUserReport: function fetchUpgradeUserReport() {
            var _this = this;

            var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this.loading = true;
            if (fromDate == "" || toDate == "") {
                this.resetDateRange();
                var fromDate = this.date_range[0] ? this.date_range[0].format("YYYY-MM-DD") : null;
                var toDate = this.date_range[1] ? this.date_range[1].format("YYYY-MM-DD") : null;
            }
            var params = { from: fromDate, to: toDate };
            api.getUpgradesUserReport(params).then(function (response) {
                _this.upgradesUserdata = response;
                _this.loading = false;
            });
        },

        /**
         * Reset date range filter
         */
        resetDateRange: function resetDateRange() {
            this.date_range = [moment().subtract(11, "months"), moment().endOf("day")];
        }
    },
    ready: function ready() {
        this.fetchUpgradeUserReport();
    }
};

},{}],844:[function(require,module,exports){
'use strict';

var _eventBus = require('../event-bus');

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.RestrictAccess = {
    template: "#restrict-access-template",
    data: function data() {
        return {};
    },
    ready: function ready() {
        var _this = this;

        $(function () {
            _eventBus2.default.$on('restrict-access', function () {
                _this.$router.go({ path: '/account' });
                _this.$nextTick(function () {
                    $('#restrict-access-modal').modal('show');
                });
            });
        });
    }
};

},{"../event-bus":882}],845:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.ScheduleCalendar = Vue.extend({
    template: "#schedule-calendar-template",
    data: function data() {
        return {
            activeTasks: [],
            activeTask: {},
            breeders: [],
            litters: [],
            generals: [],
            calendar_events: [],
            week: [],
            activeTasksForOneRabbit: [],
            activeRabbit: {},
            errors: { name: null, date: null, icon: null },
            type_of_task: null,
            perPage: 12,
            more_task_modal_title: '',
            scrollableElementId: "#schedule-calendar-scroll-box",
            scrollableElement: null,
            skipBreeders: 0,
            skipLitters: 0,
            firstLoadAllTasks: true,
            isCalendarView: false,
            calendarViewData: [],
            calendarDateFilters: {
                start_date: null,
                end_date: null
            },
            loading: false,
            type: 'calendar',
            activeBirth: {},
            plans: [],
            litter: {},
            isCalendarLoaded: false
        };
    },
    props: ['externalTasks', 'filters'],
    computed: {},
    watch: {
        isCalendarView: function isCalendarView(newData) {
            /**
             * Initialize calendar view on layout switch
             */
            if (newData) {
                this.initializeCalendarView(this.type_of_task);
            } else {
                this.calendar_events = [];
                this.loadCalendarEvents(this.type_of_task);
            }

            // save layout choice to local storage
            localStorage.setItem('calendarView', newData);
        },
        calendarViewData: function calendarViewData(newData) {
            /**
             * Update calendar events
             */
            if (this.isCalendarView) {
                $('#calendar-view').fullCalendar('removeEvents');
                $('#calendar-view').fullCalendar('addEventSource', newData);
                $('#calendar-view').fullCalendar('refetchEvents');
            }
        },
        filters: {
            handler: function handler(newVal, oldVal) {
                var isRefresh = false;

                _.map(newVal, function (value, key) {
                    _.map(oldVal, function (item, index) {
                        if (key == index && value != item) {
                            isRefresh = true;
                        }
                    });
                });

                if (isRefresh) {
                    if (this.isCalendarView) {
                        this.fetchEvents(this.type_of_task);
                    } else {
                        this.calendar_events = [];
                        this.loadCalendarEvents(this.type_of_task);
                    }
                }
            },
            deep: true
        }
    },
    components: {},
    events: {
        'schedule-calendar-filtering': function scheduleCalendarFiltering(msg) {
            this.loadCalendarEvents(msg);
        },
        'schedule-calendar-all-task-of-current-week': function scheduleCalendarAllTaskOfCurrentWeek(msg) {
            this.showTasksForCurrentWeek(msg);
        },
        'type-events-was-changed': function typeEventsWasChanged(msg) {
            this.calendar_events = [];
            this.type_of_task = msg.typeOfTask;
            this.$emit('schedule-calendar-filtering', msg.typeOfTask);
        },
        'schedule-calendar-more-tasks-show': function scheduleCalendarMoreTasksShow(msg) {
            this.more_task_modal_title = msg;

            if (this.$route.name != 'Dashboard') {
                if (this.type == 'chain') {
                    $('#more_tasks_chain').modal('show');
                } else {
                    $('#more_tasks_calendar').modal('show');
                }
            }
        },
        'schedule-calendar-more-tasks-hide': function scheduleCalendarMoreTasksHide(msg) {
            $('#more_tasks').modal('hide');
        },
        'schedule-calendar-download-was-done': function scheduleCalendarDownloadWasDone(msg) {
            this.loading = false;
        },
        'schedule-calendar-reload': function scheduleCalendarReload(msg) {
            if (this.isCalendarView) {
                if (msg.typeOfTask == 'all') {
                    msg.typeOfTask = 'general,litter,breeder';
                }
                this.fetchEvents(msg.typeOfTask);
            } else if (!msg.calendarOnly) {
                this.$emit('schedule-calendar-filtering', msg.typeOfTask);
            }
        },
        'schedule-calendar-lazy-load-tasks': function scheduleCalendarLazyLoadTasks(msg) {
            var self = this;
            this.loadGeneralTasks(self.firstLoadAllTasks, function () {
                self.lazyLoadTasks();
                self.firstLoadAllTasks = false;
            });
        }
    },
    methods: {
        /**
         * Fetch all calendar events
         */
        fetchEvents: function fetchEvents(type, date) {
            // check if calendar is loaded
            if (!this.isCalendarLoaded) {
                return false;
            }

            // catch type to clear data
            if (type == 'clear' || type == 'plans') {
                this.calendarViewData = [];
                return;
            }

            var status = type == 'archived' ? 'archived' : ''; // add 'all' status to show everything
            if (type == 'archived') type = null;

            // initialize variables
            var self = this;
            var events_data = [];
            var filters = (0, _extends3.default)({
                type: type || 'breeder,litter,general',
                perPage: 'all',
                status: status
            }, self.calendarDateFilters, {
                filters: (0, _extends3.default)({}, self.filters)

                // fetch all events from api
            });api.getEvents(filters).then(function (events) {
                events.forEach(function (event) {
                    // push necessary data for calendar event object
                    events_data.push({
                        icon: event.icon || 'fa-list',
                        title: event.type == 'breeder' ? event.holderName : event.type == 'litter' ? event.holderName ? 'Litter: ' + event.holderName : 'Litter' : 'General Tasks',
                        description: "<i class=\"fa " + event.icon + " custom-circle-icon\"></i> " + event.name,
                        start: moment(event.date, App.dateFormat).format('YYYY-MM-DD'),
                        data: event,
                        allDay: true,
                        color: '',
                        className: event.type == 'breeder' ? 'breeder-event' : event.type == 'litter' ? 'litter-event' : 'general-event'
                    });
                });

                self.calendarViewData = events_data;
            });
        },
        /**
         * Initialize data and structure of calendar view layout
         */
        initializeCalendarView: function initializeCalendarView() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var self = this;

            $('#calendar-view').fullCalendar({
                header: {
                    left: '',
                    center: 'prev,title,next',
                    right: ''
                },
                defaultView: 'month',
                eventLimit: true, //limit events to maintain UI, exceeding events can be accessed via a popup window,
                height: 700,
                eventClick: function eventClick(eventObj) {
                    var rabbit = eventObj.data.breeders[0] || [];
                    var events = { event: eventObj.data, count: 1

                        // open task form on event click
                    };self.openTaskForm(events, rabbit, eventObj.data.type === 'general' ? 'users' : eventObj.data.type + 's');
                },
                eventRender: function eventRender(event, element) {
                    // add strikethrough if event is done
                    if (event.data.closed) {
                        element.css("text-decoration", "line-through");
                    }

                    // append icon to event element
                    if (event.icon) {
                        element.find(".fc-title").prepend("<i class='fa " + event.icon + " custom-circle-icon' style=\"margin-right:5px;\"></i>");
                    }

                    // show event details on hover
                    element.popover({
                        title: event.description,
                        trigger: 'hover',
                        placement: 'top',
                        container: 'body',
                        html: true,
                        template: "<div class=\"popover\" role=\"tooltip\">\n                                <div class=\"arrow\"></div>\n                                <h3 class=\"popover-title\"></h3>\n                            </div>"
                    });
                },
                viewRender: function viewRender(view, element) {
                    self.calendarDateFilters = {
                        start_date: view.start.format(),
                        end_date: view.end.format()
                    };

                    self.isCalendarLoaded = true;
                    self.fetchEvents(type);
                }
            });
        },
        getDateLeft: function getDateLeft(date, days) {
            var dateCopy = new Date(date);
            dateCopy.setDate(date.getDate() + days);
            return dateCopy;
        },
        addRecurringTasks: function addRecurringTasks(recurringTasks, item) {
            var recurringEveryWeekId = 2; // need add 7 times
            var recurring2WeekId = 3; // need add 4 times
            var recurringEveryMonthId = 4; // need add 2 times

            var calendarDays = 49; // for 7 weeks
            var currentDate = new Date(item.date);
            var lastDay = this.getDateLeft(currentDate, calendarDays);

            if (!recurringTasks[App.formatDate(currentDate)]) recurringTasks[App.formatDate(currentDate)] = [];
            recurringTasks[App.formatDate(currentDate)].push(item);

            if (item.recurring == recurringEveryWeekId) {
                while (currentDate <= lastDay) {
                    currentDate.setDate(currentDate.getDate() + 7);

                    var itemNew = $.extend({}, item);
                    itemNew.date = App.formatDate(currentDate);

                    if (!recurringTasks[App.formatDate(currentDate)]) recurringTasks[App.formatDate(currentDate)] = [];
                    recurringTasks[App.formatDate(currentDate)].push(itemNew);
                }
            }

            if (item.recurring == recurring2WeekId) {
                while (currentDate <= lastDay) {
                    currentDate.setDate(currentDate.getDate() + 14);
                    var itemNew = $.extend({}, item);
                    itemNew.date = App.formatDate(currentDate);

                    if (!recurringTasks[App.formatDate(currentDate)]) recurringTasks[App.formatDate(currentDate)] = [];
                    recurringTasks[App.formatDate(currentDate)].push(itemNew);
                }
            }

            if (item.recurring == recurringEveryMonthId) {
                while (currentDate <= lastDay) {
                    currentDate.setMonth(currentDate.getMonth() + 1);

                    var itemNew = $.extend({}, item);
                    itemNew.date = App.formatDate(currentDate);

                    if (!recurringTasks[App.formatDate(currentDate)]) recurringTasks[App.formatDate(currentDate)] = [];
                    recurringTasks[App.formatDate(currentDate)].push(itemNew);
                }
            }
        },
        showAllTasksForRabbit: function showAllTasksForRabbit(rabbit, type) {
            var _this = this;

            this.activeRabbit = rabbit;

            var titleForModal = '';
            var self = this;
            var recurringOnceId = 1;
            var ntype = type === 'general' ? 'users' : type;

            api.getTypeEvents(ntype, this.activeRabbit.id, { archived: 0 }).then(function (data) {
                var recurringTasks = {};

                data.forEach(function (item) {
                    if (item.recurring > recurringOnceId) {
                        self.addRecurringTasks(recurringTasks, item);
                    }
                });

                if (type === 'general') {
                    var temp = [];
                    data.forEach(function (item) {
                        if (item.type === 'general') temp.push(item);
                    });
                    _this.activeTasks = temp;
                    titleForModal = 'All General Tasks.';
                } else {
                    _this.activeTasks = [];

                    data.forEach(function (item) {
                        self.activeTasks.push($.extend({}, item));

                        $.each(recurringTasks, function (recurringTaskDate) {
                            if (recurringTaskDate == item.date) {
                                recurringTasks[recurringTaskDate].forEach(function (recurringItem) {
                                    if (recurringTaskDate != item.date) {
                                        self.activeTasks.push($.extend({}, recurringItem));
                                    }
                                });

                                delete recurringTasks[recurringTaskDate];
                            }
                        });
                    });

                    $.each(recurringTasks, function (recurringTaskDate) {
                        recurringTasks[recurringTaskDate].forEach(function (item) {
                            self.activeTasks.push($.extend({}, item));
                        });
                    });

                    titleForModal = ntype === 'litters' ? 'All Tasks for Litter ' + _this.activeRabbit.given_id : 'All Tasks for Breeder ' + _this.activeRabbit.name;
                }

                _this.$emit('schedule-calendar-more-tasks-show', titleForModal);
            });
        },
        showTasksForCurrentWeek: function showTasksForCurrentWeek(msg) {
            var _this2 = this;

            this.activeRabbit = msg.rabbit;
            var weekStart = msg.events.start_date;
            var type = msg.type == 'general' ? 'users' : msg.type;

            api.getTypeEvents(type, type == 'users' ? null : this.activeRabbit.id, { weekStart: weekStart }).then(function (data) {
                _this2.activeTasks = data;
                _this2.$emit('schedule-calendar-download-was-done');
            });

            this.$emit('schedule-calendar-more-tasks-show', 'All Tasks for ' + this.activeRabbit.name);
        },
        parseWeeklyEvents: function parseWeeklyEvents(events, arrayData) {
            var eventsForDates = [];
            arrayData.forEach(function (itemData, dateIndex, arr) {
                eventsForDates[dateIndex] = [];
                events.forEach(function (itemEvent) {
                    if (itemData.date === itemEvent['date']) {
                        eventsForDates[dateIndex].push(itemEvent);
                    }
                });
            });
            return eventsForDates;
        },
        loadBreederTasks: function loadBreederTasks() {
            var _this3 = this;

            api.getEvents({ 'for': 'breeder', perPage: this.perPage, filters: (0, _extends3.default)({}, this.filters) }).then(function (data) {
                var temp = [];
                data['data'].forEach(function (item) {
                    item.type = 'breeders';
                    temp.push(item);
                });
                _this3.calendar_events = temp;
                _this3.skipBreeders = data.to;
                _this3.$emit('schedule-calendar-download-was-done');
            });
        },
        clearTasks: function clearTasks() {
            this.calendar_events = [];
            this.$emit('schedule-calendar-download-was-done');
        },
        loadGeneralTasks: function loadGeneralTasks(attachGeneralTasks, callbackFunction) {
            var _this4 = this;

            api.getEvents({ 'for': 'user', perPage: this.perPage, filters: (0, _extends3.default)({}, this.filters) }).then(function (data) {
                if (attachGeneralTasks) {
                    var general_events = [];
                    var dataIsEmpty = false;

                    data.forEach(function (item) {
                        if (item.count) dataIsEmpty = true;
                    });

                    if (dataIsEmpty) general_events.push({ events: data, type: 'general' });

                    _this4.calendar_events = general_events;
                }

                if (callbackFunction) callbackFunction();

                if (!callbackFunction) _this4.$emit('schedule-calendar-download-was-done');
            });
        },
        loadLitterTasks: function loadLitterTasks() {
            var _this5 = this;

            api.getEvents({
                'for': 'litter', weekStart: App.formatDate(this.getFirstDayOfWeek()), perPage: this.perPage, filters: (0, _extends3.default)({}, this.filters)
            }).then(function (data) {
                var temp = [];
                data['data'].forEach(function (item) {
                    item.type = 'litters';
                    temp.push(item);
                });
                _this5.calendar_events = temp;
                _this5.skipLitters = data.to;
                _this5.$emit('schedule-calendar-download-was-done');
            });
        },
        loadCalendarEvents: function loadCalendarEvents(type) {
            this.loading = true;

            switch (type) {
                case 'general':
                    if (this.isCalendarView) {
                        this.initializeCalendarView('general');break;
                    }
                    this.loadGeneralTasks(true);break;
                case 'litter':
                    if (this.isCalendarView) {
                        this.initializeCalendarView('litter');break;
                    }
                    this.skipLitters = 0;
                    this.skipBreeders = 'all';
                    this.firstLoadAllTasks = false;
                    this.loadLitterTasks();break;
                case 'breeder':
                    if (this.isCalendarView) {
                        this.initializeCalendarView('breeder');break;
                    }
                    this.skipBreeders = 0;
                    this.skipLitters = 'all';
                    this.firstLoadAllTasks = false;
                    this.loadBreederTasks();break;
                case 'archived':
                    if (this.isCalendarView) {
                        this.initializeCalendarView(type);break;
                    }
                case 'plans':
                    if (this.isCalendarView) {
                        this.initializeCalendarView('clear');break;
                    }
                    this.clearTasks();break;
                case 'all':
                default:
                    if (this.isCalendarView) {
                        this.initializeCalendarView();break;
                    }
                    this.perPage = 12;
                    this.skipBreeders = 0;
                    this.skipLitters = 0;
                    this.firstLoadAllTasks = true;
                    this.$emit('schedule-calendar-lazy-load-tasks', { cleanCalendar: true });
            }
        },
        openTaskForm: function openTaskForm(events, rabbit, type) {
            if (events.event) {
                if (!events.event.type) {
                    events.event.type = type.replace('s', ''); // remove plural
                }
                this.$root.$emit('open-actual-task', events.event);
                return true;
            }

            if (events.count == 1) {
                if (!events.event.breed_id || this.isCalendarView) {
                    this.$dispatch('task-managing', events.event);
                }
            } else if (!events.count) {
                this.$dispatch('task-managing', events);
            } else {
                this.$dispatch('schedule-calendar-all-task-of-current-week', {
                    rabbit: rabbit, events: events, type: type
                });
            }
        },
        makeTimelineDate: function makeTimelineDate(date) {
            return App.formatDate(date);
        },
        getFirstDayOfWeek: function getFirstDayOfWeek(date) {
            date = date ? new Date(date) : new Date();

            date.setDate(date.getDate() - (date.getDay() - 1));

            return new Date(date);
        },
        makeCalendarLabels: function makeCalendarLabels() {
            this.week = [];

            var daysInWeek = 7;
            var monday = this.getFirstDayOfWeek();

            this.week.push({
                date: App.formatDate(new Date()),
                comment: 'Today'
            });

            for (var i = 1; i < daysInWeek; i++) {
                monday.setDate(monday.getDate() + daysInWeek);

                this.week.push({
                    date: App.formatDate(monday),
                    comment: null
                });
            }
        },
        showRequestForm: function showRequestForm(task) {
            this.$dispatch('events-for-deleting', task);
            this.$emit('schedule-calendar-more-tasks-hide', task);
        },
        lazyLoadTasks: function lazyLoadTasks() {
            var _this6 = this;

            var self = this;
            api.getEvents({
                'for': 'all',
                'perPage': this.perPage,
                'skipBreeders': this.skipBreeders,
                'skipLitters': this.skipLitters,
                filters: (0, _extends3.default)({}, this.filters)
            }).then(function (data) {
                var fetchedAll;

                if (data['breeders'] && data['breeders'].length) {
                    var countOfRabbits = 0;
                    fetchedAll = false;

                    data['breeders'].forEach(function (item) {
                        if (item.events) {
                            item['type'] = 'breeders';

                            var doesExist = _.find(self.calendar_events, function (breeder) {
                                return breeder.id == item.id && breeder.type == item.type;
                            });

                            if (!doesExist) {
                                self.calendar_events.push(item);
                                countOfRabbits++;
                            }
                        } else if (item == 'fetchedAll') {
                            fetchedAll = true;
                        }
                    });

                    _this6.skipBreeders = fetchedAll ? 'all' : countOfRabbits;
                }

                if (data['litters'] && data['litters'].length) {
                    var countOfLitters = 0;
                    fetchedAll = false;

                    data['litters'].forEach(function (item) {
                        if (item.events) {
                            item['type'] = 'litters';

                            var doesExist = _.find(self.calendar_events, function (litter) {
                                return litter.id == item.id && litter.type == item.type;
                            });

                            if (!doesExist) {
                                self.calendar_events.push(item);
                                countOfLitters++;
                            }
                        } else if (item == 'fetchedAll') {
                            fetchedAll = true;
                        }
                    });
                    _this6.skipLitters = fetchedAll ? 'all' : countOfLitters;
                }

                _this6.$emit('schedule-calendar-download-was-done');
            });
        },

        scrollHandlerLazyLoad: function scrollHandlerLazyLoad() {
            var newScrollLeft = this.scrollableElement.scrollLeft();
            var width = this.scrollableElement.width();
            var scrollWidth = this.scrollableElement.get(0).scrollWidth;

            if (scrollWidth - newScrollLeft - width <= 1) {
                // skip if all entries are fetched
                if (this.skipBreeders != 'all' || this.skipLitters != 'all') {
                    this.$emit('schedule-calendar-lazy-load-tasks', {});
                }
            }
        },

        eventTitle: function eventTitle(event) {
            if (event.name && event.recurring_events[0] && event.recurring_events[0].date) {
                return event.name + ': ' + event.recurring_events[0].date;
            }
            if (event.name && event.date) {
                return event.name + ': ' + event.date;
            }

            return "View All";
        },

        toggleLayout: function toggleLayout() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            $("#view-toggle").netlivaSwitch('state', value);
            this.isCalendarView = value;
            this.type = value ? 'calendar' : 'chain';
        }
    },
    ready: function ready() {
        var _this7 = this;

        var self = this;
        this.makeCalendarLabels();
        this.scrollableElement = $(this.scrollableElementId);

        // initialize toggle button
        $('#view-toggle').netlivaSwitch();
        $("#view-toggle").on('netlivaSwitch.change', function (event, state, element) {
            self.isCalendarView = state;
        });

        // set layout from local storage
        $("#view-toggle").netlivaSwitch('state', this.isCalendarView);

        // event listeners
        this.$root.$on('reload-tasks-calendar', function () {
            _this7.loadCalendarEvents(_this7.type_of_task);
        });
    },

    mixins: [App.Mixins.Generic]
});

},{"babel-runtime/helpers/extends":37}],846:[function(require,module,exports){
"use strict";

App.Components.ScheduleMain = App.Components.Schedule.extend({
    template: "#schedule-main-template"
});

},{}],847:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.ScheduleTasks = App.Components.Schedule.extend({
  template: "#schedule-tasks-template",
  props: ["breeder", "isBreeder", "isLitter", "litter"],
  methods: {
    applyPreFilters: function applyPreFilters() {
      this.filters = (0, _extends3.default)({}, this.preFilters);
    },
    initializeTabs: function initializeTabs() {
      return false;
    },
    openOwnerTaskForm: function openOwnerTaskForm() {
      var newTask = {};
      var type = this.isBreeder ? 'breeder' : 'litter';
      newTask.type = type;
      newTask.relation = {};

      if (type != "breeder") {
        newTask.relation.id = this.litter.id;
      } else {
        newTask.relation.id = this.breeder.id;
      }

      this.$broadcast("upcoming-tasks-new-task-with-data", newTask);
    }
  }
});

},{"babel-runtime/helpers/extends":37}],848:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Schedule = Vue.extend({
    template: "#schedule-template",
    data: function data() {
        return {
            activeTasks: [],
            perPage: 10,
            litters: [],
            plans: [],
            activeBirth: {},
            tasksFilters: {},
            type_of_task: 'all',
            displayItems: {
                task_name: true,
                type: true,
                who: true,
                due_date: true,
                cage: true,
                plan_doe: true,
                plan_buck: true,
                plan_date: true,
                plan_due_date: true,
                plan_chain: true,
                plan_tasks: true,
                plan_status: true
            },
            view: 'list',
            searchQuery: "",
            totalCount: 0,
            breedList: [],
            btn_name: [],
            filters: {
                breed: '',
                type: '',
                subtype: ''
            },
            preFilters: {
                breed: '',
                type: '',
                subtype: ''
            },
            currentSort: 'date',
            currentOrder: 'asc',
            isShowTableActions: true,
            planStatus: 'active',
            firstTaskId: null,
            filter: null,
            isShowArchivedFilter: true
        };
    },
    props: [],
    computed: {
        printTaskListLinkQuery: function printTaskListLinkQuery() {
            var filters = (0, _assign2.default)({}, this.tasksFilters);

            filters.page = null;
            filters.perPage = null;

            return $.param(filters);
        }
    },
    components: {
        'upcomming-tasks': App.Components.UpcommingTasks,
        'tasks-list': App.Components.TasksList,
        'breedplans-list': App.Components.BreedplansList,
        'schedule-calendar': App.Components.ScheduleCalendar,
        'tasks-chain': App.Components.TasksChain,
        'tasks-calendar': App.Components.TasksCalendar,
        'notification-tab': App.Components.NotificationTab
    },
    watch: {
        filter: function filter() {
            var _this = this;

            this.changeTypeForFilter(this.filter);

            this.$nextTick(function () {
                _this.initializeDisplayItems();
            });
        },
        view: function view(newData) {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.initializeDisplayItems();
            });
        },

        filters: {
            handler: function handler(newVal, oldVal) {
                this.saveFilters();
            },
            deep: true
        },
        planStatus: function planStatus(newData) {
            this.$broadcast('update-plan-status', newData);
        },
        firstTaskId: function firstTaskId(newData) {
            if (App.tourShowed < 3) {
                App.tourShowed = 3;
                this.$http.post('/admin/users/tourShowed', { value: 3 });
                this.startTour('schedule');
            }
        }
    },
    events: {
        'task-managing': function taskManaging(msg) {
            this.$broadcast('upcoming-tasks-managing', msg);
        },
        'schedule-calendar-reload': function scheduleCalendarReload(msg) {
            this.$broadcast('schedule-calendar-filtering', msg);
        },
        'reload-tasks': function reloadTasks(msg) {
            if (!msg.calendarOnly) {
                this.$broadcast('upcomming-tasks-reload', msg);
            }

            this.$broadcast('schedule-calendar-reload', msg);
        },
        'type-events-was-changed': function typeEventsWasChanged(msg) {
            this.$broadcast('type-events-was-changed', msg);
        },
        'events-for-deleting': function eventsForDeleting(msg) {
            this.$broadcast('upcomming-tasks-delete-task', msg);
        },
        'upcomming-tasks-filters-changed': function upcommingTasksFiltersChanged(data) {
            this.tasksFilters = data;
        },
        'total-count-updated': function totalCountUpdated(data) {
            this.totalCount = data;
        },
        'first-task-updated': function firstTaskUpdated(id) {
            this.firstTaskId = id;
        }
    },
    methods: {
        tabChange: function tabChange(tab) {
            if (tab == 0) {
                $('.schedule-btn').css('display', 'block');
                $('.schedule-btn-sync').css('display', 'none');
            } else if (tab == 1) {
                $('.schedule-btn').css('display', 'none');
                $('.schedule-btn-sync').css('display', 'block');
            }
        },
        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        changeTypeForFilter: function changeTypeForFilter(typeOfTask, page) {
            this.type_of_task = typeOfTask;
            this.$dispatch('type-events-was-changed', { typeOfTask: typeOfTask, page: page });
            this.$dispatch('reload-tasks', { // tweak for calendar view
                typeOfTask: typeOfTask,
                calendarOnly: true
            });

            if (typeOfTask == 'plans') {
                $('.nav-pills a[href="#breed-plans"]').tab('show');
            }
        },

        activeItemClass: function activeItemClass(typeOfTask) {
            if (this.type_of_task == typeOfTask) {
                return 'bold';
            }
        },
        lostLitters: function lostLitters() {
            var _this3 = this;

            var data = { page: this.page };
            data.archived = this.filter === "archived" ? 1 : 0;

            api.getLitters(data).then(function (litters) {
                _this3.loading = 0;
                _this3.litters = litters.data;
                _this3.pages = litters.last_page;
            });
        },
        birthModal: function birthModal() {
            var _this4 = this;

            api.getUsersPlans().then(function (plans) {
                _this4.plans = plans;
            });
            this.activeBirth = { breedplan: '-1', born: moment(new Date()).format(App.dateFormat) };
        },
        recordBirth: function recordBirth() {
            var _this5 = this;

            api.recordBirth(this.activeBirth).then(function () {
                _this5.activeBirth = {};
                $('#birth').modal('hide');
            });
        },
        openTaskForm: function openTaskForm() {
            this.$broadcast('upcomming-tasks-new-task');
        },
        updatePerPage: function updatePerPage() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

            localStorage.setItem('perPage', value);
            this.perPage = value;
        },
        initializeDisplayItems: function initializeDisplayItems() {
            var _this6 = this;

            $('.display-settings').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            }).on('ifChecked', function (event) {
                _this6.displayItems[event.target.name] = true;
                localStorage.setItem('tasksDisplayV2', (0, _stringify2.default)(_this6.displayItems));
            }).on('ifUnchecked', function (event) {
                _this6.displayItems[event.target.name] = false;
                localStorage.setItem('tasksDisplayV2', (0, _stringify2.default)(_this6.displayItems));
            });

            var tasksDisplay = JSON.parse(localStorage.getItem('tasksDisplayV2'));
            if (tasksDisplay) {
                this.displayItems = tasksDisplay;
            }
            this.perPage = parseInt(localStorage.getItem('perPage')) || 10;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.displayItems)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    if (this.displayItems[key]) {
                        $("input[class='display-settings'][name='" + key + "']").iCheck("check");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        initializeTabs: function initializeTabs() {
            var self = this;
            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                var target = $(e.target).attr("href");
                target = target.replace("#", "");
                self.isShowTableActions = true;
                self.isShowArchivedFilter = true;
                var typeOfTask = 'all';

                if (target == 'calendar') {
                    self.$broadcast('switch-to-calendar-view');
                    self.$dispatch('reload-tasks', { // tweak for calendar view
                        typeOfTask: typeOfTask,
                        calendarOnly: true
                    });
                } else if (target == 'chain') {
                    self.$broadcast('switch-to-chain-view');
                    self.isShowArchivedFilter = false;
                } else if (target == 'breed-plans') {
                    typeOfTask = 'plans';
                }

                self.type_of_task = typeOfTask;
                self.filter = typeOfTask == 'all' ? null : typeOfTask;
            });

            if (this.$route.query.tab == 'plans') {
                $('.nav-pills a[href="#breed-plans"]').tab('show');
            }
        },
        applyPreFilters: function applyPreFilters() {
            this.filters = (0, _extends3.default)({}, this.preFilters);
            this.$router.go({ path: '/schedule' });
        },
        resetPreFilters: function resetPreFilters() {
            this.preFilters = {
                breed: '',
                type: '',
                subtype: ''
            }, this.applyPreFilters();
        },
        removeFilter: function removeFilter() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (type) {
                this.preFilters[type] = '';
                this.applyPreFilters();
            }
        },
        saveFilters: function saveFilters() {
            localStorage.setItem('taskFilters', (0, _stringify2.default)(this.filters));
        },
        getFilters: function getFilters() {
            return JSON.parse(localStorage.getItem('taskFilters'));
        },
        updateStatus: function updateStatus() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (this.type_of_task == 'plans') {
                this.planStatus = type;
            } else {
                this.filter = type;
            }
        },
        openBreedForm: function openBreedForm() {
            this.$broadcast('new-breed', true);
        },
        addNew: function addNew() {
            if (this.type_of_task != 'plans') {
                this.openTaskForm();
            } else {
                this.openBreedForm();
            }
        }
    },
    ready: function ready() {
        var _this7 = this;

        var self = this;
        this.lostLitters();
        this.birthModal();
        this.initializeTabs();

        if (this.$route.query.new) {
            this.openTaskForm();
        }
        this.$watch('$route.query.new', function () {
            if (this.$route.query.new) {
                this.openTaskForm();
            }
        });
        $(document).on('hide.bs.modal', '#new_task', function (event) {
            if ($(event.target).is('#new_task') && self.$route.query.new) {
                self.$router.go('/schedule');
            }
        });
        this.changeTypeForFilter(this.filter);

        // tweak for dropdown
        $(document).on('click', '.dropdown-menu.main-filters', function (e) {
            if ($(e.target).data("dismiss") != "dropdown") {
                e.stopPropagation();
            }
        });
        $('#task-breed-filter', '#task-category-filter', '#task-type-filter').on("select2:unselect", function (e) {
            if (!e.params.originalEvent) {
                return;
            }
            e.params.originalEvent.stopPropagation();
        });

        this.$nextTick(function () {
            _this7.initializeDisplayItems();

            _this7.breedList = _this7.getBreedersAutocompleteList().sort(function (a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });

            if (_this7.getFilters()) {
                _this7.filters = _this7.getFilters();
                _this7.preFilters = (0, _extends3.default)({}, _this7.filters);

                if (_this7.isBreeder) {
                    _this7.filters.type = 'breeder';
                } else if (_this7.isLitter) {
                    _this7.filters.type = 'litter';
                }
            }
        });

        // listen for schedule tour
        _eventBus2.default.$on('start-schedule-tour', function () {
            _this7.startTour('schedule');
        });

        //hide btn schedule-btn-sync
        $('.schedule-btn-sync').css('display', 'none');

        this.getCurrentData();
    },
    mixins: [App.Mixins.Butcherable, App.Mixins.Breeders, App.Mixins.Generic, App.Mixins.Tours]
});

},{"../event-bus":882,"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22,"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37}],849:[function(require,module,exports){
"use strict";

App.Components.SettingsImageUpload = App.Components.ImageUpload.extend({
  template: "#settings-image-upload-template",
  data: function data() {
    return {
      progress: 0,
      loading: 0
    };
  },
  props: ["image", "title"],
  watch: {},
  computed: {
    imageName: function imageName() {
      return this.image ? this.image.name : "";
    }
  },
  methods: {
    initUploader: function initUploader() {
      var self = this;

      $(this.$els["image"]).unsigned_cloudinary_upload("upload_logos", { cloud_name: App.cloud_name }, { multiple: false }).bind("fileuploadstart", function (e, data) {
        self.loading = 1;
      }).bind("cloudinarydone", function (e, data) {
        self.loading = 0;
        self.image.name = data.result.public_id;
        self.image.path = data.result.url;
        self.image.temp = true;
        self.$broadcast("image-uploaded", data.result.image);
      }).bind("fileuploadfail", function (e, data) {
        self.loading = 0;
      });
    },
    uploaderHelper: function uploaderHelper() {
      $(this.$els["image"]).click();
    },
    deleteImage: function deleteImage() {
      this.image = {
        name: "",
        path: "",
        temp: true,
        oldImage: "",
        delete: false
      };
      $(this.$els["image"]).change();
    }
  },
  ready: function ready() {
    this.initUploader();
  }
});

},{}],850:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Settings = {
    template: "#settings-v2-template",
    data: function data() {
        return {
            user: {},
            activeChain: {},
            activeLitterChain: {},
            activeTreatmentChain: {},
            chains: [],
            litterChains: [],
            treatmentChains: [],
            user_id: "",
            success: {},
            errors: {},
            loaded: false,
            digest_enabled: false,
            temp_digest_day: -1,
            success_general: {},
            success_schedule: {},
            success_pedigree: {},
            success_notifications: {},
            chainName: '',
            chainItemName: '',
            chainItemDays: null,
            breedersList: [],
            states: [],
            statesList: [],
            citiesList: [],
            chainItemIcon: '',
            iconBackground: {
                'bg-red': false, 'bg-blue': false, 'bg-maroon': false, 'bg-green': false, 'bg-yellow': false,
                'bg-grey': false, 'bg-purple': false, 'fa-calendar': false, 'fa-heart': false,
                'fa-asterisk': false, 'fa-bookmark': false, 'fa-eye': false, 'fa-flag': false,
                'fa-medkit': false, 'fa-paw': false, 'fa-trophy': false, 'fa-inbox': false
            },
            supports_notifications: false,
            notifications_disabled: false,
            notifications_subscribed: false,
            active_breed_chains_id: null,
            active_litter_chain_id: null,
            active_treatment_chain_id: null,
            countries: [],
            rabbitry_info: {
                name: null,
                first_name: null,
                last_name: null,
                address: null,
                city: null,
                state: null,
                country: null,
                zip: null,
                phone: null,
                email: null,
                website: null,
                additional_information: null
            },
            marketplace_info: {
                description: "",
                name: "",
                city: "",
                state: "",
                country: "",
                phone_number: "",
                email: "",
                website: "",
                buyer_requirements: "",
                transportation: ""
            },
            marketplace_flags: {
                description_flag: true,
                name_flag: true,
                city_flag: true,
                state_flag: true,
                country_flag: true,
                phone_number_flag: true,
                email_flag: true,
                website_flag: true,
                buyer_requirements_flag: true,
                transportation_flag: true
            },
            activeChainType: 'breeder',
            loading: false,
            isBreedExists: false,
            btn_name: [],
            emptyTreatmentData: {
                name: "",
                schedule_value: "",
                schedule_type: "",
                medication: "",
                type: "",
                withdrawal_value: "",
                withdrawal_type: "",
                method: "",
                dosage_value: "",
                dosage_type: "ml",
                weight_value: "",
                weight_type: ""
            },
            isShowRabbitry: false
        };
    },
    props: [],
    components: {
        'settings-image-upload': App.Components.SettingsImageUpload,
        'farms': App.Components.Farms
    },
    computed: {
        isSubscribed: function isSubscribed() {
            return App.isSubscribed;
        }

    },
    watch: {
        'chainItemIcon': function chainItemIcon(newValue, oldValue) {
            if (newValue) {
                var newClass = newValue.split(' ')[1];
                var oldClass = oldValue ? oldValue.split(' ')[1] : '';

                if (newClass === 'bg-gray') newClass = newValue.split(' ')[0];
                if (oldClass === 'bg-gray') oldClass = oldValue ? oldValue.split(' ')[0] : '';

                this.iconBackground[newClass] = true;

                if (oldValue) {
                    this.iconBackground[oldClass] = false;
                }
            }
        },

        'digest_enabled': function digest_enabled(newValue, oldValue) {
            $(this.$els.digest_enabled).iCheck('update');
            if (this.loaded) {
                if (newValue == false) {
                    this.temp_digest_day = this.user.digest_day;
                    this.user.digest_day = -1;
                } else {
                    this.user.digest_day = this.temp_digest_day;
                }
            }
        },

        'user.pedigree_pdf_qr_code': function userPedigree_pdf_qr_code(newValue, oldValue) {
            $(this.$els.pedigree_pdf_qr_code).iCheck('update');
        },

        'user.pedigree_pdf_ref_link': function userPedigree_pdf_ref_link(newValue, oldValue) {
            $(this.$els.pedigree_pdf_ref_link).iCheck('update');
        },

        'user.pedigree_pdf_genotype': function userPedigree_pdf_genotype(newValue, oldValue) {
            $(this.$els.pedigree_pdf_genotype).iCheck('update');
        },

        'marketplace_info.state': function marketplace_infoState(newValue, oldValue) {
            try {
                this.citiesList = this.states[newValue];
            } catch (error) {
                this.citiesList = [];
            }

            $('#marketplace-city').typeahead('destroy');
            $('#marketplace-city').typeahead({
                hint: true,
                highlight: true,
                minLength: 0
            }, {
                source: this.substringMatcher(this.citiesList)
            });
        }
    },
    methods: {
        activeTab: function activeTab(tab) {
            if (tab == 0) {
                $('.setting_btn').css('display', 'block');
                $('.setting-general-btn').css('display', 'block');
                $('.breeder_task_btn').css('display', 'none');
                $('.litter_task_btn').css('display', 'none');
            } else if (tab == 1) {
                $('.breeder_task_btn').css('display', 'block');
                $('.setting-general-btn').css('display', 'none');
                $('.litter_task_btn').css('display', 'none');
            } else if (tab == 2) {
                $('.litter_task_btn').css('display', 'block');
                $('.breeder_task_btn').css('display', 'none');
                $('.setting-general-btn').css('display', 'none');
            } else if (tab == 3) {
                $('.breeder_task_btn').css('display', 'block');
                $('.litter_task_btn').css('display', 'none');
                $('.setting_btn').css('display', 'none');
                $('.setting-general-btn').css('display', 'none');
            }
        },

        getCurrentData: function getCurrentData() {
            var btn_name = localStorage.getItem("help_section");
            this.btn_name = JSON.parse(btn_name);
        },
        preparePostData: function preparePostData() {
            this.cleanUsagePurposeData(); //cleanup usage purpose on data preparation

            var data = this.user;
            var chains = this.chains.concat(this.litterChains).concat(this.treatmentChains);
            data.rabbitry_info = (0, _extends3.default)({}, this.rabbitry_info);
            data.breedchains = {};

            for (var i = 0; i < chains.length; ++i) {
                data.breedchains[chains[i].id] = {
                    icon: {},
                    days: {},
                    name: {}
                };
                for (var j = 0; j < chains[i].items.length; ++j) {
                    data.breedchains[chains[i].id].icon[chains[i].items[j].id] = chains[i].items[j].icon;
                    data.breedchains[chains[i].id].days[chains[i].items[j].id] = chains[i].items[j].days;
                    data.breedchains[chains[i].id].name[chains[i].items[j].id] = chains[i].items[j].name;
                }
            }

            return data;
        },
        updateMarketplace: function updateMarketplace() {
            var _this = this;

            var payload = (0, _extends3.default)({}, this.marketplace_info, this.marketplace_flags, { user_id: this.user_id });
            this.errors = {};
            this.loading = true;
            api.postMarketplaceProfile(payload).then(function (res) {
                _this.loading = false;
                App.hasMarketplaceProfile = true;
                _this.showAlert({
                    type: 'success',
                    text: "Marketplace Settings Updated."
                });
            }, function (response) {
                _this.loading = false;
                _this.errors = response.data.errors;
            });
        },

        updateSettings: function updateSettings(from) {
            var _this2 = this;

            this.success = {};
            this.errors = {};
            this.success_general = {};
            this.success_pedigree = {};
            this.success_schedule = {};
            this.loading = true;
            var data = this.preparePostData();
            data.active_breed_chains_id = this.activeChain.id;
            data.active_litter_chain_id = this.activeLitterChain.id;
            data.active_treatment_chain_id = this.activeTreatmentChain.id;
            api.postUserSettings(this.user_id, data).then(function (res) {
                _this2.loading = false;
                var successMessage = "Settings Updated.";

                if (from === 'general') {
                    successMessage = "General " + successMessage;
                    _this2.success_general = res;
                    App.currency = _this2.user.currency;
                    App.weight_units = _this2.user.general_weight_units;
                    App.weight_slug = _this2.user.weight_slug;
                    App.default_prefix = _this2.user.default_prefix;
                    _this2.load().then(function () {
                        App.generateLitterIdFlag = _this2.user.generate_litter_id;
                        App.dateFormat = _this2.user.date_format_js;
                        App.dateFormatShort = _this2.user.date_format_js_short;
                        App.isShowButcher = _this2.user.is_show_butcher;
                        App.isShowShow = _this2.user.is_show_show;
                    });
                } else if (from === 'pedigree') {
                    successMessage = "Rabbitry " + successMessage;
                    _this2.success_pedigree = res;
                } else if (from === 'schedule') {
                    successMessage = "Schedule " + successMessage;
                    _this2.success_schedule = res;
                    App.active_breed_chains_id = _this2.activeChain.id;
                    App.active_litter_chain_id = _this2.activeLitterChain.id;
                    App.active_treatment_chain_id = _this2.activeTreatmentChain.id;
                } else {
                    _this2.success = res;
                }
                api.getUserSettingsData(_this2.user_id).then(function (data) {
                    _this2.chains = data.chains;
                    _this2.activeChain = data.chains.find(function (item) {
                        return item.id === _this2.activeChain.id;
                    });
                    App.isShowButcher = data.user.is_show_butcher; // update show butcher flag
                });

                _this2.showAlert({
                    type: 'success',
                    text: successMessage
                });
            }, function (response) {
                _this2.loading = false;
                _this2.errors = response.data.errors;
            });
        },

        addChain: function addChain() {
            var _this3 = this;

            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder';

            if (!this.chainName) {
                alert('You must specify Name');
                return false;
            }

            if (type == 'breeder') {
                api.addBreedChain(this.chainName).then(function (data) {
                    _this3.activeChain = data.chain;
                    _this3.chains.push(data.chain);

                    _this3.showAlert({
                        type: 'success',
                        text: 'Successfully added a breeder chain'
                    });
                    $('#new_chain').modal('hide');
                });
            } else if (type == 'litter') {
                api.addLitterChain(this.chainName).then(function (data) {
                    _this3.activeLitterChain = data.chain;
                    _this3.litterChains.push(data.chain);

                    _this3.showAlert({
                        type: 'success',
                        text: 'Successfully added a litter chain'
                    });
                    $('#new_chain').modal('hide');
                });
            } else if (type == 'treatment') {
                api.addTreatmentChain(this.chainName).then(function (data) {
                    _this3.activeTreatmentChain = data.chain;
                    _this3.$set('activeTreatmentChain.data', data.chain.data || _this3.emptyTreatmentData);
                    _this3.treatmentChains.push(data.chain);

                    _this3.showAlert({
                        type: 'success',
                        text: 'Successfully added a treatment chain'
                    });
                    $('#new_chain').modal('hide');
                });
            }

            this.chainName = '';
        },
        newChain: function newChain() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder';

            this.activeChainType = type;
            this.chainName = this.activeChain.name;
            $('#new_chain').modal('show');
        },
        editChain: function editChain() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder';

            this.activeChainType = type;
            this.chainName = this.activeChain.name;
            $('#edit_chain').modal('show');
        },
        updateChain: function updateChain() {
            var _this4 = this;

            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder';
            var isTreatment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!this.chainName && !isTreatment) {
                alert('You must specify Name');
                return false;
            }

            var name = !isTreatment ? this.chainName : this.activeTreatmentChain.name;
            var activeChain = type == 'breeder' ? this.activeChain : type == 'litter' ? this.activeLitterChain : this.activeTreatmentChain;

            api.updateBreedChain(activeChain.id, name, activeChain.data).then(function (data) {
                activeChain.name = name;

                _this4.showAlert({
                    type: 'success',
                    text: "Successfully updated a " + type + " chain"
                });
                $('#edit_chain').modal('hide');
            });

            this.chainName = '';
        },
        showDeleteChain: function showDeleteChain() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder';

            this.activeChainType = type;
            var activeChain = type == 'breeder' ? this.activeChain : type == 'litter' ? this.activeLitterChain : this.activeTreatmentChain;
            this.chainName = activeChain.name;
            $('#delete_chain').modal('show');
        },
        deleteChain: function deleteChain() {
            var _this5 = this;

            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder';

            var activeChain = type == 'breeder' ? this.activeChain : type == 'litter' ? this.activeLitterChain : this.activeTreatmentChain;
            var id = activeChain.id;

            api.deleteBreedChain(activeChain.id).then(function (data) {
                _this5.showAlert({
                    type: 'danger',
                    text: "Successfully deleted a " + type + " chain"
                });
                $('#delete_chain').modal('hide');
                _this5.chainName = '';

                if (type == 'breeder') {
                    _this5.chains = _this5.chains.filter(function (item) {
                        return item.id != id;
                    });
                    _this5.activeChain = _.first(_this5.chains);
                } else if (type == 'litter') {
                    _this5.litterChains = _this5.litterChains.filter(function (item) {
                        return item.id != id;
                    });
                    _this5.activeLitterChain = _.first(_this5.litterChains);
                } else if (type == 'treatment') {
                    _this5.treatmentChains = _this5.treatmentChains.filter(function (item) {
                        return item.id != id;
                    });
                    _this5.activeTreatmentChain = _.first(_this5.treatmentChains);
                    _this5.$set('activeTreatmentChain.data', _this5.activeTreatmentChain.data || _this5.emptyTreatmentData);
                }
            });
        },
        addChainItem: function addChainItem() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder';

            if (!this.chainItemName) {
                alert('You must specify Name');
                return false;
            }
            if (!this.chainItemDays) {
                alert('You must specify Days');
                return false;
            }

            var activeChain = type == 'breeder' ? this.activeChain : type == 'litter' ? this.activeLitterChain : this.activeTreatmentChain;

            var chain = {
                name: this.chainItemName,
                days: this.chainItemDays,
                icon: this.chainItemIcon,
                id: 'new_' + new Date().getTime()
            };

            activeChain.items.push(chain);
            activeChain.items = _.sortBy(activeChain.items, function (obj) {
                return parseInt(obj.days);
            });

            $('#new_chain_item').modal('hide');

            this.chainItemName = '';
            this.chainItemDays = '';
        },
        removeChainItem: function removeChainItem(id) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'breeder';

            if (type == 'breeder') {
                this.activeChain.items = this.activeChain.items.filter(function (item) {
                    return item.id != id;
                });
            } else if (type == 'litter') {
                this.activeLitterChain.items = this.activeLitterChain.items.filter(function (item) {
                    return item.id != id;
                });
            } else if (type == 'treatment') {
                this.activeTreatmentChain.items = this.activeTreatmentChain.items.filter(function (item) {
                    return item.id != id;
                });
            }
        },
        canRemove: function canRemove(chain) {
            return ['fa-venus-mars bg-blue original', 'fa-birthday-cake bg-green original', 'fa-balance-scale bg-yellow first-weight'].indexOf(chain.icon) === -1;
        },


        load: function load() {
            var _this6 = this;

            return api.getUserSettingsData(this.user_id).then(function (data) {
                var self = _this6;
                _this6.user = data.user;
                _this6.chains = data.chains;
                _this6.litterChains = data.litter_chains;
                _this6.treatmentChains = data.treatment_chains;

                if (data.marketplace) {
                    _this6.marketplace_info.description = data.marketplace.description;
                    _this6.marketplace_info = (0, _extends3.default)({}, _this6.marketplace_info, data.marketplace.all_data);
                    var flags = data.marketplace.flags;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(flags)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var key = _step.value;

                            _this6.marketplace_flags[key + '_flag'] = flags[key];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }

                if (data.rabbitry) {
                    _this6.rabbitry_info = data.rabbitry;
                } else {
                    _this6.rabbitry_info.additional_information = _this6.user.pedigree_rabbitry_information;
                }

                if (_this6.user.active_breed_chains_id !== null && _this6.user.active_breed_chains_id !== '') {
                    _this6.active_breed_chains_id = _this6.user.active_breed_chains_id;
                    var store_active_chains = "";
                    store_active_chains = data.chains.filter(function (el) {
                        return el.id === self.active_breed_chains_id;
                    });
                    _this6.activeChain = store_active_chains[0];
                } else {
                    _this6.activeChain = _.first(data.chains);
                }

                if (_this6.user.active_litter_chain_id !== null && _this6.user.active_litter_chain_id !== '') {
                    _this6.active_litter_chain_id = _this6.user.active_litter_chain_id;
                    var _store_active_chains = "";
                    _store_active_chains = data.litter_chains.filter(function (el) {
                        return el.id === self.active_litter_chain_id;
                    });
                    _this6.activeLitterChain = _store_active_chains[0];
                } else {
                    _this6.activeLitterChain = _.first(data.litter_chains);
                }

                if (_this6.user.active_treatment_chain_id !== null && _this6.user.active_treatment_chain_id !== '') {
                    _this6.active_treatment_chain_id = _this6.user.active_treatment_chain_id;
                    var _store_active_chains2 = "";
                    _store_active_chains2 = data.treatment_chains.filter(function (el) {
                        return el.id === self.active_treatment_chain_id;
                    });
                    _this6.activeTreatmentChain = _store_active_chains2[0];
                } else {
                    _this6.activeTreatmentChain = _.first(data.treatment_chains);
                }
                _this6.$set('activeTreatmentChain.data', _this6.activeTreatmentChain.data || _this6.emptyTreatmentData);

                _this6.digest_enabled = _this6.user.digest_day !== -1;

                // set usage purpose if present
                var usage = data.user.usage_purpose || [];
                _this6.prepareUsagePurposeData(usage);

                _this6.initTypeahead();

                _this6.initICheck('digest_enabled', _this6);
                _this6.initICheck('pedigree_pdf_qr_code', _this6.user);
                _this6.initICheck('pedigree_pdf_ref_link', _this6.user);
                _this6.initICheck('pedigree_pdf_genotype', _this6.user);

                _this6.$nextTick(function () {
                    this.loaded = true;
                });
            });
        },

        updateNotificationManagerState: function updateNotificationManagerState() {
            var _this7 = this;

            var manager = window.NotificationManager;

            manager.isAvailable().then(function (available) {
                _this7.supports_notifications = available;
                _this7.$nextTick(function () {
                    _this7.initializePopovers();
                });
            });
            manager.isDisabled().then(function (disabled) {
                _this7.notifications_disabled = disabled;
                _this7.$nextTick(function () {
                    _this7.initializePopovers();
                });
            });
            manager.isSubscribed().then(function (subscribed) {
                _this7.notifications_subscribed = subscribed;
                _this7.$nextTick(function () {
                    _this7.initializePopovers();
                });
            });
        },
        disableNotifications: function disableNotifications() {
            var _this8 = this;

            NotificationManager.unsubscribe(function () {
                _this8.updateNotificationManagerState();
            });
        },
        subscribeToNotifications: function subscribeToNotifications() {
            var _this9 = this;

            NotificationManager.subscribe(function () {
                _this9.updateNotificationManagerState();
            }, function () {
                _this9.updateNotificationManagerState();
            });
        },
        sendTestNotification: function sendTestNotification() {
            api.requestTestNotification();
        },


        initTypeahead: function initTypeahead() {
            var _this10 = this;

            api.getPrefixesList().then(function (prefixes) {
                $('#default-prefix').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: _this10.substringMatcher(prefixes)
                });
            });
        },

        initICheck: function initICheck(field, obj) {
            $(this.$els[field]).iCheck({
                checkboxClass: 'icheckbox_square-blue',
                radioClass: 'iradio_square-blue',
                increaseArea: '20%' // optional
            }).on('ifChecked', function (event) {
                obj[field] = true;
            }.bind(this)).on('ifUnchecked', function (event) {
                obj[field] = false;
            }.bind(this));
        },
        fetchCountries: function fetchCountries() {
            var _this11 = this;

            api.fetchCountries().then(function (data) {
                _this11.countries = data;
                _this11.isShowRabbitry = true;
            });
        },
        fetchStates: function fetchStates() {
            var _this12 = this;

            api.fetchStates().then(function (data) {
                _this12.states = data;
                _this12.statesList = (0, _keys2.default)(data);

                $('#marketplace-state').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: _this12.substringMatcher(_this12.statesList)
                });
            });
        },
        addTask: function addTask() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'breeder';

            this.activeChainType = type;

            if (type == 'breeder') {
                this.isBreedExists = _.find(this.activeChain.items, function (item) {
                    return item.icon.indexOf("fa-venus-mars bg-blue") > -1;
                });
            } else {
                this.isBreedExists = true;
            }

            $('#new_chain_item').modal('show');
        },
        isBreedTaskIcon: function isBreedTaskIcon() {
            var icon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            return icon.indexOf("fa-venus-mars bg-blue") > -1;
        }
    },
    ready: function ready() {
        var _this13 = this;

        this.fetchCountries();
        this.fetchStates();
        this.load();
        this.breedersList = this.getBreedersAutocompleteList();
        this.updateNotificationManagerState();

        setInterval(function () {
            _this13.updateNotificationManagerState();
        }, 1000);

        if (this.$route.query.tab == 'schedule') {
            $('.nav-pills a[href="#schedule"]').tab('show');
        } else if (this.$route.query.tab == 'farms') {
            $('.nav-pills a[href="#farms"]').tab('show');
        } else if (this.$route.query.tab == 'marketplace') {
            $('.nav-pills a[href="#marketplace"]').tab('show');
        }

        this.getCurrentData();
        $('.breeder_task_btn').css('display', 'none');
        $('.litter_task_btn').css('display', 'none');
        this.emptyTreatmentData.weight_type = this.getTreatmentWeightType();
    },

    mixins: [App.Mixins.Typeahead, App.Mixins.Breeders, App.Mixins.UsagePurpose, App.Mixins.FieldDescription, App.Mixins.Alerts, App.Mixins.Generic]
};

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37}],851:[function(require,module,exports){
"use strict";

App.Components.SexSelect = {
  template: "#sex-select-template",
  data: function data() {
    return {};
  },
  props: ["model", "isInline"],
  computed: {},
  watch: {
    model: function model() {
      $(this.$els.buck).iCheck("update");
      $(this.$els.doe).iCheck("update");
    }
  },
  methods: {},
  ready: function ready() {
    $(this.$els.buck).iCheck({
      checkboxClass: "icheckbox_square-blue",
      radioClass: "iradio_square-blue",
      inheritClass: true
    }).on("ifChecked", function (event) {
      this.model.sex = "buck";
    }.bind(this));

    //Red color scheme for iCheck
    $(this.$els.doe).iCheck({
      checkboxClass: "icheckbox_square-red",
      radioClass: "iradio_square-red",
      inheritClass: true
    }).on("ifChecked", function (event) {
      this.model.sex = "doe";
    }.bind(this));
  }
};

},{}],852:[function(require,module,exports){
"use strict";

App.Components.Sidebar = {
  template: "#sidebar-template",
  data: function data() {
    return {
      breederCategories: [],
      ledgerCategories: []
    };
  },
  computed: {
    isShowButcher: function isShowButcher() {
      return App.isShowButcher;
    }
  },
  methods: {
    load: function load() {
      this.loadBreederCategories();
      this.loadLedgerCategories();
    },
    loadBreederCategories: function loadBreederCategories() {
      var _this = this;

      if (App.isSubscribed) {
        api.getBreederCategories().then(function (response) {
          _this.breederCategories = response.categories;
        });
      }
    },
    loadLedgerCategories: function loadLedgerCategories() {
      var _this2 = this;

      if (this.hasAccess(App.access.ledger)) {
        api.getLedgerCategories().then(function (response) {
          _this2.ledgerCategories = response.categories;
        });
      }
    }
  },
  ready: function ready() {
    var _this3 = this;

    this.load();

    App.vent.on("sidebar-reload-breeder-categories", function () {
      return _this3.loadBreederCategories();
    });
    if (this.hasAccess(App.access.ledger)) {
      App.vent.on("sidebar-reload-ledger-categories", function () {
        return _this3.loadLedgerCategories();
      });
    }

    this.$nextTick(function () {
      $.AdminLTE.tree(".sidebar");

      //Enable control sidebar
      $.AdminLTE.controlSidebar.activate();
    });
  },
  mixins: [App.Mixins.Auth, App.Mixins.Currency, App.Mixins.Generic]
};

},{}],853:[function(require,module,exports){
"use strict";

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.SubUserActivity = Vue.extend({
  template: "#sub-user-activity-template",
  data: function data() {
    var _ref;

    return _ref = {
      subUser: {
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        role_id: null,
        send_invite: false
      },
      userActivity: [],
      perPage: 10,
      totalCount: 0,
      loading: 1,
      order: "created_at|desc",
      searchQuery: "",
      page: 1,
      totalPages: 1
    }, (0, _defineProperty3.default)(_ref, "loading", false), (0, _defineProperty3.default)(_ref, "description", {}), _ref;
  },

  watch: {
    page: function page() {
      this.fetchActivity();
    },
    order: function order() {
      this.fetchActivity();
    },
    searchQuery: function searchQuery() {
      this.fetchActivity();
    }
  },
  methods: {
    fetchActivity: function fetchActivity() {
      var _this = this;

      if (!this.subUser || !this.subUser.id) {
        this.userActivity = [];
        return;
      }

      this.loading = 1;
      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var data = {
        id: this.subUser.id,
        page: this.page,
        perPage: this.perPage
      };

      api.getSubUserActivity(data).then(function (data) {
        _this.userActivity = data.logs.data;
        _this.pages = data.logs.last_page;
        _this.order = data.order;
        _this.totalItems = data.logs.total;
        _this.loading = 0;

        // for list view
        _this.totalPages = data.logs.last_page;
        _this.totalCount = data.logs.total;
        _this.description = {
          from: data.logs.from,
          to: data.logs.to,
          total: data.logs.total
        };
      });
    }
  },
  ready: function ready() {
    var _this2 = this;

    var self = this;
    $("#show-activity-modal").on("hidden.bs.modal", function () {
      self.subUser = {
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        role_id: null,
        send_invite: false
      };
    });

    this.$root.$on("show-sub-user-activity", function (subUser) {
      $("#show-activity-modal").modal("show");
      self.subUser = subUser;
      _this2.fetchActivity();
    });
  },

  mixins: [App.Mixins.Auth, App.Mixins.Generic, App.Mixins.Filterable, App.Mixins.Alerts]
});

},{"babel-runtime/helpers/defineProperty":36}],854:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.defaultPermissions = {
  breeders_litters_kits_view: false,
  breeders_litters_kits_edit: false,
  breeders_litters_kits_delete: false,
  schedule_view: false,
  schedule_edit: false,
  schedule_delete: false,
  health_view: false,
  health_edit: false,
  health_delete: false,
  finances_view: false,
  finances_edit: false,
  finances_delete: false,
  cage_cards_view: false,
  cage_cards_edit: false,
  cage_cards_delete: false,
  reports_view: false,
  reports_edit: false,
  reports_delete: false,
  attachments_view: false,
  attachments_edit: false,
  attachments_delete: false
}, App.Components.SubUsers = Vue.extend({
  template: "#sub-users-template",
  data: function data() {
    var _ref;

    return _ref = {
      subUsers: [],
      inviteUser: {
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        role_id: null,
        farm_id: null,
        send_invite: false
      },
      roles: [],
      role: {
        display_name: "",
        description: "",
        permissions: (0, _extends3.default)({}, App.defaultPermissions)
      },
      roleOptions: [],
      farmOptions: [],
      userActivity: [],
      perPage: 10,
      totalCount: 0,
      loading: 1,
      order: "name|asc",
      searchQuery: "",
      page: 1,
      totalPages: 1
    }, (0, _defineProperty3.default)(_ref, "loading", false), (0, _defineProperty3.default)(_ref, "displayItems", {
      name: true,
      email: true,
      role: true,
      registered: true,
      invited: true
    }), (0, _defineProperty3.default)(_ref, "errors", {}), (0, _defineProperty3.default)(_ref, "currentTab", "users"), _ref;
  },

  components: {
    "sub-user-activity": App.Components.SubUserActivity
  },
  computed: {},
  watch: {
    order: function order() {
      this.updateList();
    },
    searchQuery: function searchQuery() {
      this.updateList();
    }
  },
  methods: {
    buildFilters: function buildFilters() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var allowedFilters = ["order", "orderDirection"];

      data.filters = _.filter(this.filters, function (value, key) {
        return allowedFilters.includes(key);
      });

      return data;
    },
    updateList: function updateList() {
      var _this = this;

      this.loading = 1;
      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var data = { page: this.page, perPage: this.perPage };
      if (this.order) {
        data.order = this.order;
      }
      data = this.buildFilters(data);
      data.searchQuery = this.searchQuery;

      api.getSubUsers(data).then(function (data) {
        _this.subUsers = data.users.data;
        _this.pages = data.users.last_page;
        _this.order = data.order;
        _this.totalItems = data.users.total;
        _this.loading = 0;

        // for list view
        _this.totalPages = data.users.last_page;
        _this.totalCount = data.users.total;
        _this.description = {
          from: data.users.from,
          to: data.users.to,
          total: data.users.total
        };
      });
    },
    fetchRoles: function fetchRoles() {
      var _this2 = this;

      this.loading = 1;
      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var data = { page: this.page, perPage: this.perPage };
      if (this.order) {
        data.order = this.order;
      }
      data = this.buildFilters(data);
      data.searchQuery = this.searchQuery;

      api.getUserRoles(data).then(function (data) {
        _this2.roles = data.roles.data;
        _this2.pages = data.roles.last_page;
        _this2.totalItems = data.roles.total;
        _this2.loading = 0;

        // for list view
        _this2.totalPages = data.roles.last_page;
        _this2.totalCount = data.roles.total;
        _this2.description = {
          from: data.roles.from,
          to: data.roles.to,
          total: data.roles.total
        };

        // fetch role options every reload
        _this2.fetchRoleOptions();
      });
    },
    fetchRoleOptions: function fetchRoleOptions() {
      var _this3 = this;

      var data = {
        is_options: true
      };

      api.getUserRoles(data).then(function (data) {
        _this3.roleOptions = data.roles;
      });
    },
    fetchFarmOptions: function fetchFarmOptions() {
      var _this4 = this;

      var data = {
        is_options: true
      };

      api.getFarmsList(data).then(function (data) {
        _this4.farmOptions = data.farms;
      });
    },
    initializeDisplayItems: function initializeDisplayItems() {
      var _this5 = this;

      $(".display-settings").iCheck({
        checkboxClass: "icheckbox_square-green",
        radioClass: "iradio_square-green"
      }).on("ifChecked", function (event) {
        _this5.displayItems[event.target.name] = true;
        localStorage.setItem("subUsersDisplay", (0, _stringify2.default)(_this5.displayItems));
      }).on("ifUnchecked", function (event) {
        _this5.displayItems[event.target.name] = false;
        localStorage.setItem("subUsersDisplay", (0, _stringify2.default)(_this5.displayItems));
      });

      var subUsersDisplay = JSON.parse(localStorage.getItem("subUsersDisplay"));
      if (subUsersDisplay) {
        this.displayItems = subUsersDisplay;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.displayItems)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (this.displayItems[key]) {
            $("input[class='display-settings'][name='" + key + "']").iCheck("check");
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    openAddRoleModal: function openAddRoleModal() {
      this.clearAddRoleModal();
      $("#add-role-modal").modal("show");
    },
    clearAddRoleModal: function clearAddRoleModal() {
      this.errors = {};
      $("#add-role-modal").modal("hide");
    },
    saveRole: function saveRole() {
      if (this.role.id) {
        this.saveEditRole();
      } else {
        this.addRole();
      }
    },
    addRole: function addRole() {
      var _this6 = this;

      api.addRole(this.role).then(function (data) {
        _this6.showAlert({
          type: "success",
          text: "Successfully created " + _this6.role.display_name + "!"
        });

        _this6.clearAddRoleModal();
        _this6.fetchRoles();
      }, function (response) {
        _this6.errors = response.data.errors;
      });
    },
    saveEditRole: function saveEditRole() {
      var _this7 = this;

      api.editRole(this.role).then(function (data) {
        _this7.showAlert({
          type: "success",
          text: "Successfully updated " + _this7.role.display_name + "!"
        });

        _this7.clearAddRoleModal();
        _this7.fetchRoles();
      }, function (response) {
        _this7.errors = response.data.errors;
      });
    },
    openInviteUserModal: function openInviteUserModal() {
      $("#invite-sub-user-modal").modal("show");
    },
    clearInviteUserModal: function clearInviteUserModal() {
      this.errors = {};
      $("#invite-sub-user-modal").modal("hide");
      $("#delete-sub-user-modal").modal("hide");
    },
    saveSubUser: function saveSubUser() {
      if (this.inviteUser.id) {
        this.saveEditSubUser();
      } else {
        this.inviteSubUser();
      }
    },
    inviteSubUser: function inviteSubUser() {
      var _this8 = this;

      api.inviteSubUser(this.inviteUser).then(function (data) {
        _this8.showAlert({
          type: "success",
          text: "Successfully created " + _this8.inviteUser.email + "!"
        });

        _this8.clearInviteUserModal();
        _this8.updateList();
      }, function (response) {
        _this8.errors = response.data.errors;
      });
    },
    saveEditSubUser: function saveEditSubUser() {
      var _this9 = this;

      api.updateSubUser(this.inviteUser).then(function (data) {
        _this9.showAlert({
          type: "success",
          text: "Successfully updated " + _this9.inviteUser.email + "!"
        });

        _this9.clearInviteUserModal();
        _this9.updateList();
      }, function (response) {
        _this9.errors = response.data.errors;
      });
    },
    viewUser: function viewUser(user) {
      this.$root.$emit('show-sub-user-activity', user);
    },
    downloadUserList: function downloadUserList() {
      this.showAlert({
        type: "warning",
        text: "This feature is under construction."
      });
    },
    editSubUser: function editSubUser(user) {
      this.inviteUser = (0, _extends3.default)({}, user);
      if (this.inviteUser.is_invited) {
        this.inviteUser.send_invite = true;
      }

      this.openInviteUserModal();
    },
    showDeleteSubUserModal: function showDeleteSubUserModal(user) {
      this.inviteUser = user;
      $("#delete-sub-user-modal").modal("show");
    },
    deleteSubUser: function deleteSubUser() {
      var _this10 = this;

      api.deleteSubUser(this.inviteUser).then(function (data) {
        _this10.showAlert({
          type: "success",
          text: "Successfully deleted " + _this10.inviteUser.email + "!"
        });

        _this10.clearInviteUserModal();
        _this10.updateList();
      }, function (response) {
        _this10.errors = response.data.errors;
      });
    },
    editRole: function editRole(role) {
      var _this11 = this;

      var permissions = role.permissions;
      this.role = role;
      this.role.permissions = (0, _extends3.default)({}, App.defaultPermissions);

      _.map(permissions, function (item) {
        _this11.role.permissions[item] = true;
      });

      $("#add-role-modal").modal("show");
    },
    showDeleteRoleModal: function showDeleteRoleModal(role) {
      this.role = role;
      $("#delete-role-modal").modal("show");
    },
    deleteRole: function deleteRole() {
      var _this12 = this;

      api.deleteRole(this.role).then(function (data) {
        _this12.showAlert({
          type: "success",
          text: "Successfully deleted " + _this12.role.display_name + "!"
        });

        $("#delete-role-modal").modal("hide");
        _this12.clearAddRoleModal();
        _this12.fetchRoles();
      }, function (response) {
        _this12.errors = response.data.errors;
      });
    },
    initializeTabs: function initializeTabs() {
      var self = this;
      $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        var target = $(e.target).attr("href");
        target = target.replace("#", "");

        self.currentTab = target;

        self.$nextTick(function () {
          if (target == "user-list") {
            self.updateList();
          } else {
            self.fetchRoles();
          }
        });
      });
    },
    getRoleNameById: function getRoleNameById(role_id) {
      var role = _.find(this.roleOptions, function (role) {
        return role.id == role_id;
      });

      if (role) {
        return role.display_name;
      }

      return null;
    }
  },
  ready: function ready() {
    this.updateList();
    this.fetchRoleOptions();
    this.fetchFarmOptions();
    this.initializeTabs();
    this.initializeDisplayItems();

    var self = this;
    $("#invite-sub-user-modal").on("hidden.bs.modal", function () {
      self.inviteUser = {
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        role_id: null,
        farm_id: null,
        send_invite: false
      };
    });
    $("#add-role-modal").on("hidden.bs.modal", function () {
      self.role = {
        display_name: "",
        description: "",
        permissions: (0, _extends3.default)({}, App.defaultPermissions)
      };
    });
  },

  mixins: [App.Mixins.Auth, App.Mixins.Generic, App.Mixins.Filterable, App.Mixins.Alerts, App.Mixins.FieldDescription]
});

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/defineProperty":36,"babel-runtime/helpers/extends":37}],855:[function(require,module,exports){
"use strict";

App.Components.Cancellations = {
  template: "#cancellations-template",
  data: function data() {
    return {};
  },
  props: [],
  computed: {},
  components: {
    "cancel-reasons-report": App.Components.Reports.CancelReasonsReport,
    "cancellation-count": App.Components.CancellationCount
  },
  events: {},
  watch: {},
  methods: {},
  ready: function ready() {},
  mixins: []
};

},{}],856:[function(require,module,exports){
'use strict';

App.Components.TaskForm = {
    template: "#task-form-template",
    data: function data() {
        return {
            originalTask: {},
            rabbits: [],
            breeder_litter: [],
            week: [],
            label: 'label',
            label_color: 'label-danger',
            activeRabbit: {},
            info_panel_class: ' bg-info',
            button_class: ' btn-primary',
            name_of_modal: 'New Task',
            modeOfTask: 'create',
            errors: { name: null, date: null, icon: null },
            type_of_tasks: 'all',
            iconBackground: {
                'bg-red': false, 'bg-blue': false, 'bg-maroon': false, 'bg-green': false,
                'bg-yellow': false, 'bg-grey': false, 'fa-calendar': false, 'fa-heart': false,
                'fa-asterisk': false, 'fa-bookmark': false, 'fa-eye': false, 'fa-flag': false,
                'bg-orange': false, 'fa-paw': false, 'fa-trophy': false, 'bg-purple': false
            },
            loading: 1
        };
    },
    props: {
        activeTask: {
            type: Object,
            default: function _default() {
                return {
                    'relation': {}
                };
            }
        },
        isGlobal: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        }
    },
    computed: {
        capitalizedType: function capitalizedType() {
            return this.activeTask && this.activeTask.type ? this.capitalize(this.activeTask.type) : '';
        }
    },
    watch: {
        'activeTask.icon': function activeTaskIcon(newValue, oldValue) {
            if (newValue) {
                var newClass = newValue.split(' ')[1];
                var oldClass = oldValue ? oldValue.split(' ')[1] : '';

                if (newClass == 'bg-gray') newClass = newValue.split(' ')[0];
                if (oldClass == 'bg-gray') oldClass = oldValue ? oldValue.split(' ')[0] : '';

                this.iconBackground[newClass] = true;
                if (oldValue) this.iconBackground[oldClass] = false;
            }
        },
        'activeTask.type': function activeTaskType(newValue, oldValue) {
            switch (newValue) {
                case 'breeder':
                    {
                        this.loadBreeders();break;
                    }
                case 'litter':
                    {
                        this.loadLitters();break;
                    }
                default:
                    {
                        this.breeder_litter = [];
                    }
            }
        }
    },
    events: {
        'tasks-managing': function tasksManaging(task, newTask) {
            this.openTaskForm(task, newTask);
        },
        'tasks-delete-task': function tasksDeleteTask(msg) {
            this.showRequestForm(msg);
        },
        activeTask: function activeTask() {
            this.resetArchivedFilterBreeders();
        },
        'activeTask.relation.id': function activeTaskRelationId(value) {
            this.setFilterBreedersEntry(value);
        }
    },
    methods: {
        filterTasksBreeders: function filterTasksBreeders(value) {
            if (this.withArchivedBreeders) {
                return true;
            }
            return this.activeTask.relation && this.activeTask.relation.id == value.id || value.archived === 0 && value.sold_at == null;
        },
        capitalize: function capitalize(string) {
            return string.replace(/^./, function (match) {
                return match.toUpperCase();
            });
        },
        openTaskForm: function openTaskForm(task, newTask) {
            var _this = this;

            if (task) {
                this.info_panel_class = "bg-info";
                this.name_of_modal = "Edit Task";
                this.button_class = "btn-primary";
                this.modeOfTask = 'edit';
                this.loading = 1;
                api.getEvent(task.id).then(function (task) {
                    _this.loading = 0;
                    _this.activeTask = $.extend({}, task);
                    _this.originalTask = $.extend({}, task);
                    _this.activeTask.relation = {};
                    if (_this.activeTask.litters || _this.activeTask.breeders) {
                        _this.activeTask.relation = _this.activeTask.litters ? _this.activeTask.litters[0] : _this.activeTask.breeders[0];
                    }

                    _this.cleanupTaskIcon();
                });
            } else {
                this.modeOfTask = 'create';
                this.name_of_modal = "Create Task";
                this.info_panel_class = "bg-success";
                this.button_class = "btn-success";
                this.errors = { name: null, date: null, icon: null };
                this.activeTask = {
                    'name': null,
                    'date': App.formatDate(new Date()),
                    'recurring': "1", 'type': "general", 'icon': 'fa-cutlery bg-red',
                    relation: { id: '' }
                };
                if (newTask) {
                    this.activeTask = $.extend(this.activeTask, newTask);
                }
            }

            if (!this.isGlobal) {
                $('#new_task').modal('show');
            } else {
                $('#global_new_task').modal('show');
            }
        },
        createTask: function createTask(mode) {
            var _this2 = this;

            var self = this;
            this.$validate(true);
            if (this.$activeTaskValidator.touched && this.$activeTaskValidator.invalid) return;
            this.loading = 1;
            if (mode == 'edit') {
                this.activeTask.type_id = this.activeTask.relation.id || null;
                this.activeTask.type_changed = this.originalTask.type !== this.activeTask.type || this.originalTask.type_id !== this.activeTask.type_id;
                api.saveEvent(this.activeTask).then(function () {
                    if (self.activeTask.closed == '0') {
                        api.reopenEvent(self.activeTask);
                    } else {
                        api.closeEvent(self.activeTask);
                    }
                    _this2.$dispatch('litter-reload-tasks', { typeOfTask: _this2.type_of_task, page: _this2.page });
                    _this2.$dispatch('reload-tasks', { typeOfTask: _this2.type_of_task, page: _this2.page });
                    self.loading = 0;
                    if (!_this2.isGlobal) {
                        $('#new_task').modal('hide');
                    } else {
                        $('#global_new_task').modal('hide');
                        _this2.$root.$emit('global-notification-tab-reload');
                    }
                });
            } else {
                this.activeTask.type_id = this.activeTask.relation ? this.activeTask.relation.id : null;
                api.saveEvent(this.activeTask).then(function () {
                    _this2.$dispatch('litter-reload-tasks', { typeOfTask: _this2.type_of_task, page: _this2.page });
                    _this2.$dispatch('reload-tasks', { typeOfTask: _this2.type_of_task, page: _this2.page });
                    self.loading = 0;
                    if (!_this2.isGlobal) {
                        $('#new_task').modal('hide');
                    } else {
                        $('#global_new_task').modal('hide');
                        _this2.$root.$emit('global-notification-tab-reload');
                    }
                });
            }
        },

        finishTask: function finishTask(task) {
            if (task.closed == '1') {
                api.reopenEvent(task).then(function () {
                    task.closed = '0';
                });
            } else {
                api.closeEvent(task).then(function () {
                    task.closed = '1';
                });
            }
        },
        getFullTaskName: function getFullTaskName(task) {
            if (task.holderName) {
                if (task.type == 'breeder') {
                    return task.holderName + ': ' + task.name;
                }
                if (task.type == 'litter') {
                    return 'Litter ' + task.holderName + ': ' + task.name;
                }
            }
            return task.name;
        },
        loadBreeders: function loadBreeders() {
            var _this3 = this;

            this.loading = 1;
            api.getBreedersList().then(function (breeders) {
                _this3.loading = 0;
                _this3.breeder_litter = breeders.bucks.concat(breeders.does);
            });
        },
        loadLitters: function loadLitters() {
            var _this4 = this;

            this.loading = 1;
            api.getLittersList().then(function (litters) {
                _this4.loading = 0;
                var tempRabbits = [];
                litters.forEach(function (item) {
                    var name = '';
                    if (item.parents[0]) {
                        name = item.parents[0].name;
                    }
                    if (item.parents[1]) {
                        name = name + '/' + item.parents[1].name;
                    }
                    tempRabbits.push({ 'given_id': item.given_id, 'id': item.id, 'name': name });
                });
                _this4.breeder_litter = tempRabbits;
            });
        },
        showRequestForm: function showRequestForm(task) {
            this.activeTask = task;
            $('#delete_task').modal('show');
        }
    },
    mixins: [App.Mixins.Generic, App.Mixins.BreedersFilter, App.Mixins.FieldDescription]
};

},{}],857:[function(require,module,exports){
'use strict';

App.Components.TasksCalendar = App.Components.ScheduleCalendar.extend({
    template: "#tasks-calendar-template",
    events: {
        'switch-to-calendar-view': function switchToCalendarView() {
            this.isCalendarView = true;
        }
    },
    ready: function ready() {
        this.type = 'calendar';
    }
});

},{}],858:[function(require,module,exports){
'use strict';

App.Components.TasksChain = App.Components.ScheduleCalendar.extend({
    template: "#tasks-chain-template",
    events: {
        'switch-to-chain-view': function switchToChainView() {
            this.isCalendarView = false;
        }
    },
    ready: function ready() {
        this.type = 'chain';
    }
});

},{}],859:[function(require,module,exports){
"use strict";

App.Components.TasksList = App.Components.UpcommingTasks.extend({
    template: "#tasks-list-template"
});

},{}],860:[function(require,module,exports){
"use strict";

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.TourLink = {
  template: '<a href="#" @click.prevent="startTour()"><i class="fa fas fa-shuttle-van"></i> Tour</a>',

  events: {
    "notification-tab-reload-tasks": function notificationTabReloadTasks(msg) {
      this.load();
    }
  },
  methods: {
    startTour: function startTour() {
      var currentRoute = this.$route.name;
      switch (currentRoute) {
        case "Dashboard":
          $("body").trigger("tour.show");
          break;
        case "Breeders":
        case "Breeder Type":
        case "Breeder Categories":
        case "Breeder Category":
          _eventBus2.default.$emit("start-breeder-tour");
          break;
        case "Schedule":
          _eventBus2.default.$emit("start-schedule-tour");
          break;
        default:
          this.showAlert({
            type: "warning",
            text: "The tour for \u201C" + currentRoute + "\u201D is unavailable as of the moment."
          });
          break;
      }
    }
  },
  mixins: [App.Mixins.Alerts]
};

},{"../event-bus":882}],861:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.TreatmentForm = Vue.extend({
  template: "#treatment-form-template",
  data: function data() {
    return {
      loading: 1,
      ailments: [],
      ailmentsList: [],
      errors: [],
      treatmentChains: [],
      isExistingTreatment: false,
      activeExistingTreatment: null,
      isKit: false,
      selectedLitter: null,
      kits: [],
      isMultiple: false
    };
  },

  props: ["activeTreatment", "activeAilment", "breeders", "litters", "actionableAilments"],
  computed: {
    treatmentsList: function treatmentsList() {
      return ["Surgical intervention", "Hepatic medications", "Renal medications", "Anti-inflammatory/Antipyretic medications", "Antibiotics for sytemic support", "Antibiotics for systemic support", "Cardiovascular medications", "Antiparasitic medications", "Antiprotozoals", "Antimicrobial eye drops", "Supportive Therapy", "Antifungal medications", "Antimicrobials", "Analgesic/Pain medications", "Topical eye medications", "Gastrointestinal medications", "Vaccines/Antiviral medications", "Euthanasia/Culling", "Chemotherapeutic medications", "Neurologic medications", "Anti-inflammatory/Anti-pyretic medications"];
    }
  },
  watch: {
    activeAilment: function activeAilment(newData) {
      // set pre-selected ailment
      if (newData && newData.id) {
        this.$set("activeTreatment.ailment_id", newData.id);

        if (newData.breeder && newData.breeder.id) {
          this.toggleLayout(false);
          this.$set("activeTreatment.breeder_id", newData.breeder.id);
        }

        if (newData.kit && newData.kit.id) {
          this.toggleLayout(true);
          this.selectedLitter = newData.kit.litter_id;
          this.$set("activeTreatment.kit_id", newData.kit.id);
        }
      }
    },
    activeExistingTreatment: function activeExistingTreatment(newData) {
      if (newData) {
        var treatment = _.find(this.treatmentChains, function (chain) {
          return chain.id == newData;
        });

        if (treatment) {
          var treatmentData = treatment.data || {};
          this.activeTreatment = (0, _extends3.default)({}, this.activeTreatment, treatmentData);
        }
      }
    },
    selectedLitter: function selectedLitter(newData, oldData) {
      if (newData) {
        this.fetchLitterKits();

        if (oldData && newData != oldData) {
          this.activeTreatment.kit_id = null;
        }
      } else {
        this.kits = [];
      }
    },
    isKit: function isKit(newData) {
      this.ailments = [];

      if (!newData && this.activeTreatment.breeder_id) {
        this.fetchAilmentsFromBreeder(this.activeTreatment.breeder_id);
      }

      if (newData && this.activeTreatment.kit_id) {
        this.fetchLitterKits();
      }
    }
  },
  events: {
    "add-new-treatment": function addNewTreatment() {
      this.isMultiple = false;
      this.openTreatmentModal();
    },
    "add-health-record": function addHealthRecord() {
      this.isMultiple = false;
      this.openHealthRecordModal();
    },
    "add-multiple-treatment": function addMultipleTreatment() {
      this.isMultiple = true;
      this.openTreatmentModal();
    },
    "edit-treatment": function editTreatment(treatment) {
      this.isMultiple = false;
      this.openTreatmentModal(treatment);
    }
  },
  methods: {
    fetchLitterKits: function fetchLitterKits() {
      var _this = this;

      api.getLitterKits(this.selectedLitter).then(function (kits) {
        _this.kits = kits;

        if (_this.activeTreatment.kit_id) {
          _this.fetchAilmentsFromKit(_this.activeTreatment.kit_id);
        }
      });
    },
    fetchAilmentsFromBreeder: function fetchAilmentsFromBreeder(id) {
      var breeder = _.find(this.breeders, function (breeder) {
        return breeder.id == id;
      });

      this.ailments = breeder ? breeder.ailments : [];
    },
    fetchAilmentsFromKit: function fetchAilmentsFromKit(id) {
      var kit = _.find(this.kits, function (kit) {
        return kit.id == id;
      });

      this.ailments = kit ? kit.ailments : [];
    },
    fetchEmptyAilments: function fetchEmptyAilments() {
      var _this2 = this;

      api.getAilments({ all: true }).then(function (data) {
        _this2.ailments = data.ailments;
      });
    },
    resetActiveTreatment: function resetActiveTreatment() {
      this.activeTreatment = {};
      this.activeExistingTreatment = null;
      this.isMultiple = false;
      $("#treatment-modal").modal("hide");
      $("#health-record-modal").modal("hide");
      this.$dispatch("reload-treatments");
      this.$dispatch("reload-ailments");
    },
    openTreatmentModal: function openTreatmentModal() {
      var treatment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.activeTreatment = $.extend(treatment, {
        start_date: moment().format(App.dateFormat)
      });
      this.errors = [];

      if (treatment.id && treatment.breeder) {
        this.toggleLayout(false);
        this.$set("activeTreatment.breeder_id", treatment.breeder.id);
      } else {
        this.$set("activeTreatment.breeder_id", null);
      }

      if (treatment.id && treatment.kit) {
        this.toggleLayout(true);
        this.selectedLitter = treatment.kit.litter_id;
        this.$set("activeTreatment.kit_id", treatment.kit.id);
      } else {
        this.$set("activeTreatment.kit_id", null);
      }

      if (!this.activeTreatment.id) {
        this.activeTreatment.dosage_type = "ml";
        this.activeTreatment.weight_type = this.getTreatmentWeightType();
      }

      $("#treatment-modal").modal("show");
    },
    openHealthRecordModal: function openHealthRecordModal() {
      var treatment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.activeTreatment = $.extend({}, (0, _extends3.default)({
        status: "active",
        start_date: moment().format(App.dateFormat)
      }, treatment));
      this.activeAilment = $.extend({}, { status: "active", start_date: moment().format(App.dateFormat) });
      this.errors = [];

      if (treatment.id && treatment.breeder) {
        this.toggleLayout(false);
        this.$set("activeTreatment.breeder_id", treatment.breeder.id);
      } else {
        this.$set("activeTreatment.breeder_id", null);
      }

      if (treatment.id && treatment.kit) {
        this.toggleLayout(true);
        this.selectedLitter = treatment.kit.litter_id;
        this.$set("activeTreatment.kit_id", treatment.kit.id);
      } else {
        this.$set("activeTreatment.kit_id", null);
      }

      if (!this.activeTreatment.id) {
        this.activeTreatment.dosage_type = "ml";
        this.activeTreatment.weight_type = this.getTreatmentWeightType();
      }

      $("#health-record-modal").modal("show");
    },
    cleanUpRelation: function cleanUpRelation() {
      if (this.isMultiple) {
        delete this.activeTreatment.kit_id;
        delete this.activeTreatment.breeder_id;
      } else if (!this.isKit) {
        delete this.activeTreatment.kit_id;
      } else {
        delete this.activeTreatment.breeder_id;
      }
    },
    saveTreatment: function saveTreatment() {
      var _this3 = this;

      var isHealthRecord = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.saveLoading = 1;

      if (!isHealthRecord) {
        this.cleanUpRelation();
        if (this.isMultiple) {
          this.activeTreatment.ailments = _.pluck(this.actionableAilments, "id");
          this.storeTreatment();
        } else if (this.activeTreatment.id) {
          this.updateTreatment();
        } else {
          this.storeTreatment();
        }
      } else {
        if (!this.activeTreatment.breeder_id && !this.activeTreatment.kit_id) {
          this.errors = {
            breeder_id: ["Please select a breeder."],
            kit_id: ["Please select a kit."]
          };
          return;
        }

        if (!this.activeAilment.name) {
          this.errors = {
            ailments: {
              name: ["The name field is required."]
            }
          };
          return;
        }

        // TODO: rework to reuse existing ailment
        if (!this.activeTreatment.ailment_id) {
          api.storeAilment((0, _extends3.default)({}, this.activeAilment, {
            breeder_id: this.activeTreatment.breeder_id,
            kit_id: this.activeTreatment.kit_id,
            start_date: this.activeAilment.start_date || moment().format(App.dateFormat)
          })).then(function (data) {
            _this3.activeTreatment.ailment_id = data.id;

            _this3.cleanUpRelation();

            // only run if treatment data is updated
            if (_this3.activeTreatment.name) {
              if (_this3.isMultiple) {
                _this3.activeTreatment.ailments = _.pluck(_this3.actionableAilments, "id");
                _this3.storeTreatment();
              } else if (_this3.activeTreatment.id) {
                _this3.updateTreatment();
              } else {
                _this3.storeTreatment();
              }
            } else {
              _this3.resetActiveTreatment();
            }
          }, function (response) {
            _this3.errors = { ailments: response.data.errors };
          });
        } else {
          this.cleanUpRelation();
          if (this.isMultiple) {
            this.activeTreatment.ailments = _.pluck(this.actionableAilments, "id");
            this.storeTreatment();
          } else if (this.activeTreatment.id) {
            this.updateTreatment();
          } else {
            this.storeTreatment();
          }
        }
      }
    },
    storeTreatment: function storeTreatment() {
      var _this4 = this;

      api.storeTreatment(this.activeTreatment).then(function (data) {
        _this4.saveLoading = 0;
        _this4.showAlert({
          type: "success",
          text: "Successfully added a treatment - " + _this4.activeTreatment.name + "."
        });
        _this4.resetActiveTreatment();
      }, function (response) {
        _this4.saveLoading = 0;
        _this4.errors = response.data.errors;
      });
    },
    updateTreatment: function updateTreatment() {
      var _this5 = this;

      api.updateTreatment(this.activeTreatment).then(function (data) {
        _this5.saveLoading = 0;
        _this5.resetActiveTreatment();
      }, function (response) {
        _this5.saveLoading = 0;
        _this5.errors = response.data.errors;
      });
    },
    fetchTreatmentChains: function fetchTreatmentChains() {
      var _this6 = this;

      var userId = App.user_id;
      api.getUserSettingsData(userId).then(function (data) {
        _this6.treatmentChains = data.treatment_chains;
      });
    },
    initTreatmentSwitch: function initTreatmentSwitch() {
      var _this7 = this;

      $("#existing-treatment").netlivaSwitch({
        width: "35px"
      }).on("netlivaSwitch.change", function (event, state, element) {
        _this7.isExistingTreatment = state;
      });
      $("#existing-treatment-health-record").netlivaSwitch({
        width: "35px"
      }).on("netlivaSwitch.change", function (event, state, element) {
        _this7.isExistingTreatment = state;
      });

      // initialize as true
      $("#existing-treatment").netlivaSwitch("state", this.isExistingTreatment);
      $("#existing-treatment-health-record").netlivaSwitch("state", this.isExistingTreatment);
    },
    initRabbitType: function initRabbitType(type) {
      var _this8 = this;

      $("#" + type + "-rabbit-type").netlivaSwitch({
        width: "35px"
      }).on("netlivaSwitch.change", function (event, state, element) {
        _this8.isKit = state;
      });
    },
    toggleLayout: function toggleLayout() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      $("#treatment-rabbit-type").netlivaSwitch("state", state);
      this.isKit = state;
    },
    initTreatmentTypeahead: function initTreatmentTypeahead() {
      var treatments = this.treatmentsList;

      $("#treatment-form-treatment-name").typeahead({
        hint: true,
        highlight: true,
        minLength: 0
      }, {
        source: this.substringMatcher(treatments)
      });
    }
  },
  ready: function ready() {
    this.fetchEmptyAilments();
    this.initRabbitType("treatment");
    this.initTreatmentSwitch();
    this.fetchTreatmentChains();
    this.initTreatmentTypeahead();
  },


  mixins: [App.Mixins.Generic, App.Mixins.BreedersFilter, App.Mixins.Filterable, App.Mixins.Alerts, App.Mixins.FieldDescription, App.Mixins.Typeahead]
});

},{"babel-runtime/helpers/extends":37}],862:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.TreatmentsList = Vue.extend({
  template: "#treatments-list-template",
  data: function data() {
    return {
      loading: 1,
      page: 1,
      perPage: 10,
      totalPages: 1,
      totalCount: 0,
      description: {},
      currentSort: "start_date",
      currentOrder: "asc",
      treatments: [],
      activeTreatment: {},
      activeAilment: {},
      ailments: [],
      errors: [],
      openAilments: []
    };
  },

  props: ["displayItems", "searchQuery", "perPage", "filters", "breeders", "breeder", "isBreeder", "litters"],
  computed: {
    pages: function pages() {
      // set a minimum of 1 page
      var maxPages = this.totalPages > 0 ? this.totalPages : 1;
      var pages = [];
      while (maxPages > 0) {
        var page = {
          title: maxPages,
          isActive: this.page == maxPages
        };
        pages.push(page);

        maxPages--;
      }

      return pages.reverse();
    }
  },
  components: {
    "ailment-form": App.Components.AilmentForm,
    "treatment-form": App.Components.TreatmentForm,
    "health-record-form": App.Components.HealthRecordForm
  },
  watch: {
    totalCount: function totalCount(newData) {
      this.$dispatch("total-count-updated", newData);
    },
    searchQuery: function searchQuery(newData, oldData) {
      this.page = 1;
      // this.loadTreatments();
    },
    perPage: function perPage(newData) {
      this.page = 1;
      localStorage.setItem("perPage", newData);
      // this.loadTreatments();
    },

    filters: {
      handler: function handler(newData) {
        this.page = 1;
        // this.loadTreatments();
      },

      deep: true
    },
    currentSort: function currentSort(newData) {
      // this.loadTreatments();
    },
    currentOrder: function currentOrder(newData) {
      // this.loadTreatments();
    }
  },
  events: {
    "reload-treatments": function reloadTreatments() {
      this.loadTreatments();
    }
  },
  methods: {
    loadTreatments: function loadTreatments() {
      var _this = this;

      this.perPage = localStorage.getItem("perPage") || this.perPage;
      var filter = { filters: (0, _extends3.default)({}, this.filters) };
      filter.query = this.searchQuery;
      filter.perPage = this.perPage;
      filter.page = this.page;
      filter.sort = this.currentSort;
      filter.order = this.currentOrder;
      filter.isV2 = 1;

      if (this.isBreeder) {
        filter.breeder_id = this.breeder.id;
      }

      this.loading = 1;
      api.getTreatments(filter).then(function (data) {
        var treatments = data.treatments;
        _this.loading = 0;
        _this.treatments = treatments.data;

        // For new version
        _this.totalPages = treatments.last_page;
        _this.totalCount = treatments.total;
        _this.description = {
          from: treatments.from,
          to: treatments.to,
          total: treatments.total
        };
      });
    },
    openEditTreatmentModal: function openEditTreatmentModal(treatment) {
      this.activeTreatment = treatment;
      this.$broadcast("edit-treatment", treatment);
    },
    openDeleteTreatmentModal: function openDeleteTreatmentModal(treatment) {
      this.activeTreatment = treatment;
      $("#delete-treatment").modal("show");
    },
    deleteTreatment: function deleteTreatment() {
      var _this2 = this;

      var treatment = this.activeTreatment;
      if (treatment && treatment.id) {
        api.deleteTreatment(treatment).then(function () {
          $("#delete-treatment").modal("hide");
          _this2.activeTreatment = {};
          _this2.loadTreatments();
        });
      }
    },
    getRabbitData: function getRabbitData(treatment) {
      var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "breed";

      if (treatment.breeder) {
        return treatment.breeder[field] || "—";
      }
      if (treatment.kit) {
        if (field == "tattoo") field = "given_id";
        return treatment.kit[field] || "—";
      }

      return "—";
    }
  },
  ready: function ready() {
    this.perPage = localStorage.getItem("perPage") || 10;
    this.loadTreatments();
  },


  mixins: [App.Mixins.Generic, App.Mixins.BreedersFilter, App.Mixins.Filterable, App.Mixins.Alerts, App.Mixins.FieldDescription]
});

},{"babel-runtime/helpers/extends":37}],863:[function(require,module,exports){
"use strict";

Vue.component("trial-remaining", {
  template: "\n    <li>\n        <span class=\"breadcrumbs\">\n          {{ days }} {{ days == 1 ? 'day' : 'days' }} left of free trial.\n        </span>\n    </li>\n    <li>\n        <button type=\"button\" class=\"btn btn-default margin\" v-link=\"{ path: '/account' }\">\n          UPGRADE NOW\n        </button>\n    </li>\n  ",
  computed: {
    days: function days() {
      return App.user_trial_remaining_days;
    }
  }
});

},{}],864:[function(require,module,exports){
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.UpcommingTasks = Vue.extend({
    template: "#upcomming-tasks-template",
    data: function data() {
        var _ref;

        return _ref = {
            loading: 1,
            tasksLoading: false,
            plansLoading: false,
            activeTasks: [],
            plans: [],
            activeTask: {
                relation: {}
            },
            activePlan: {},
            originalTask: {},
            rabbits: [],
            breeder_litter: [],
            breeders: [],
            week: [],
            label: 'label',
            label_color: 'label-danger',
            type_of_task: 'all',
            current_page: null,
            last_page: null,
            perPage: 10,
            pagination_page: [],
            activeTasksForOneRabbit: [],
            activeRabbit: {},
            info_panel_class: ' bg-info',
            button_class: ' btn-primary',
            name_of_modal: 'New Task',
            modeOfTask: 'create',
            errors: { name: null, date: null, icon: null },
            type_of_tasks: 'all',
            typeOfPlans: 'active',
            iconBackground: {
                'bg-red': false, 'bg-blue': false, 'bg-maroon': false, 'bg-green': false,
                'bg-yellow': false, 'bg-grey': false, 'fa-calendar': false, 'fa-heart': false,
                'fa-asterisk': false, 'fa-bookmark': false, 'fa-eye': false, 'fa-flag': false,
                'fa-medkit': false, 'fa-paw': false, 'fa-trophy': false, 'bg-purple': false,
                'bg-orange': false
            },
            searchFields: ['name', 'holderName'],
            page: 1,
            totalPages: 1,
            totalCount: 0,
            description: {},
            currentSort: 'date',
            currentOrder: 'asc',
            activeBirth: {}
        }, (0, _defineProperty3.default)(_ref, 'plans', []), (0, _defineProperty3.default)(_ref, 'litters', []), (0, _defineProperty3.default)(_ref, 'litter', {}), (0, _defineProperty3.default)(_ref, 'breeder', {}), (0, _defineProperty3.default)(_ref, 'alerts', {}), _ref;
    },
    props: ['externalTasks', 'displayItems', 'searchQuery', 'perPage', 'filters', 'isPlansOnly', 'breeder', 'isBreeder', 'litter', 'isLitter'],
    computed: {
        capitalizedType: function capitalizedType() {
            return this.activeTask && this.activeTask.type ? this.capitalize(this.activeTask.type) : '';
        },
        pages: function pages() {
            // set a minimum of 1 page
            var maxPages = this.totalPages > 0 ? this.totalPages : 1;
            var pages = [];
            while (maxPages > 0) {
                var page = {
                    title: maxPages,
                    isActive: this.page == maxPages
                };
                pages.push(page);

                maxPages--;
            }

            return pages.reverse();
        }
    },
    components: {
        'breed-form': App.Components.BreedForm,
        'birth-form': App.Components.BirthForm,
        'litter-weight': App.Components.LitterWeight,
        'litter-butcher': App.Components.LitterButcher,
        'breeder-form': App.Components.BreederForm
    },
    watch: {
        activeTask: function activeTask(newData) {
            this.resetArchivedFilterBreeders();
        },

        'activeTask.relation.id': function activeTaskRelationId(value) {
            this.setFilterBreedersEntry(value);
        },
        'activeTask.type': function activeTaskType(newValue, oldValue) {
            switch (newValue) {
                case 'breeder':
                    {
                        this.loadBreeders();
                        break;
                    }
                case 'litter':
                    {
                        this.loadLitters();
                        break;
                    }
                case 'plans':
                    {
                        this.loadPlans();
                        break;
                    }
                default:
                    {
                        this.breeder_litter = [];
                    }
            }

            this.initializePopovers();
        },
        'externalTasks': function externalTasks(newValue, oldValue) {
            this.activeTasks = newValue;
        },
        'activeTask.icon': function activeTaskIcon(newValue, oldValue) {
            if (newValue) {
                var newClass = newValue.split(' ')[1];
                var oldClass = oldValue ? oldValue.split(' ')[1] : '';

                if (newClass === 'bg-gray') newClass = newValue.split(' ')[0];
                if (oldClass === 'bg-gray') oldClass = oldValue ? oldValue.split(' ')[0] : '';

                this.iconBackground[newClass] = true;
                if (oldValue) this.iconBackground[oldClass] = false;
            }
        },
        searchQuery: function searchQuery(newData, oldData) {
            this.page = 1;
            this.loadTasks(this.type_of_task);

            if (oldData == "" && this.type_of_task != 'plans') {
                this.$router.go({ path: '/schedule' });
            }
        },
        totalCount: function totalCount(newData) {
            this.$dispatch('total-count-updated', newData);
        },
        perPage: function perPage(newData) {
            this.page = 1;
            this.loadTasks();
        },

        filters: {
            handler: function handler(newVal, oldVal) {
                this.page = 1;
                this.loadTasks();
            },
            deep: true
        },
        currentSort: function currentSort(newData) {
            this.loadTasks();
        },
        currentOrder: function currentOrder(newData) {
            this.loadTasks();
        }
    },
    events: {
        'upcoming-tasks-new-task-with-data': function upcomingTasksNewTaskWithData(task) {
            this.openTaskForm(null, task);
        },
        'upcoming-tasks-managing': function upcomingTasksManaging(task) {
            this.openTaskForm(task);
        },
        'upcomming-tasks-reload': function upcommingTasksReload(msg) {
            if (this.isPlansOnly && msg.typeOfTask != 'plans') return false;
            this.loadTasks(msg.typeOfTask);
        },
        'type-events-was-changed': function typeEventsWasChanged(msg) {
            this.type_of_task = msg.typeOfTask;
            this.page = 1;
            this.$dispatch('upcomming-tasks-reload', msg);
        },
        'upcomming-tasks-delete-task': function upcommingTasksDeleteTask(msg) {
            this.showRequestForm(msg);
        },
        'upcomming-tasks-new-task': function upcommingTasksNewTask() {
            this.openTaskForm();
        },
        'update-plan-status': function updatePlanStatus(type) {
            this.changeTypeOfPlans(type);
        },
        'open-breed-modal': function openBreedModal(msg) {
            this.$broadcast('new-breed-with-doe', msg);
        }
    },
    methods: {
        shortDate: function shortDate(date) {
            return App.parseMoment(date).format(App.dateFormatShort);
        },

        capitalize: function capitalize(string) {
            return string.replace(/^./, function (match) {
                return match.toUpperCase();
            });
        },
        getTypeId: function getTypeId(type) {
            var types = { 'general': 1, 'litter': '2', 'breeder': 3 };
            return types[type];
        },
        openTaskForm: function openTaskForm(task, newTask) {
            var _this = this;

            try {
                this.$resetValidation();
            } catch (ex) {}

            if (task) {
                this.info_panel_class = "bg-info";
                this.name_of_modal = "Edit Task";
                this.button_class = "btn-primary";
                this.modeOfTask = 'edit';
                this.loading = 1;
                api.getEvent(task.id).then(function (task) {
                    _this.loading = 0;
                    _this.activeTask = $.extend({}, task);
                    _this.originalTask = $.extend({}, task);
                    _this.activeTask.relation = {};
                    if (_this.activeTask.litters || _this.activeTask.breeders) {
                        _this.activeTask.relation = _this.activeTask.litters ? _this.activeTask.litters[0] : _this.activeTask.breeders[0];
                    }

                    _this.cleanupTaskIcon();
                });
            } else {
                this.modeOfTask = 'create';
                this.name_of_modal = "Create Task";
                this.info_panel_class = "bg-success";
                this.button_class = "btn-success";
                this.errors = { name: null, date: null, icon: null };
                this.activeTask = {
                    'name': null, 'date': App.formatDate(new Date()), 'recurring': "1",
                    'type': "general", 'icon': this.isShowButcher ? 'fa-cutlery bg-red' : 'fa-venus-mars bg-blue', relation: { id: '' }
                };
                if (newTask) {
                    this.activeTask = $.extend(this.activeTask, newTask);
                }
            }

            // WIP: separate template for task form
            $('#new_task').modal('show');
            $('#more_tasks').modal('hide');
        },

        createTask: function createTask(mode) {
            var _this2 = this;

            this.$validate(true);
            if (this.$activeTaskValidator.touched && this.$activeTaskValidator.invalid) return;
            this.loading = 1;
            if (mode === 'edit') {
                this.activeTask.type_id = this.activeTask.relation.id || null;
                this.activeTask.type_changed = this.originalTask.type !== this.activeTask.type || this.originalTask.type_id !== this.activeTask.type_id;
                api.saveEvent(this.activeTask).then(function () {
                    if (_this2.activeTask.closed == '0') {
                        api.reopenEvent(_this2.activeTask);
                    } else {
                        api.closeEvent(_this2.activeTask);
                    }
                    _this2.$dispatch('reload-tasks', { typeOfTask: _this2.type_of_task, page: _this2.page });
                    _this2.loading = 0;
                    $('#new_task').modal('hide');

                    var helpText = '';
                    if (_this2.activeTask.subtype == 'breed') {
                        helpText = 'All succeeding tasks from this breeding will be rescheduled accordingly.';
                    }

                    _this2.showAlert({
                        type: 'success',
                        text: '<b>' + _this2.activeTask.name.toUpperCase() + '</b> has been updated. ' + helpText,
                        hideAfter: 5000
                    });
                });
            } else {
                this.activeTask._method = "POST";
                this.activeTask.type_id = this.activeTask.relation ? this.activeTask.relation.id : null;
                api.saveEvent(this.activeTask).then(function () {
                    _this2.$dispatch('reload-tasks', { typeOfTask: _this2.type_of_task, page: _this2.page });
                    _this2.loading = 0;
                    $('#new_task').modal('hide');
                });
            }
        },
        isOnAlert: function isOnAlert(task) {
            return this.alerts[task.id];
        },
        onTaskHide: function onTaskHide(task) {
            this.alerts[task.id] = false;

            var isRefresh = true;
            _.map(this.alerts, function (item) {
                if (item) {
                    isRefresh = false;
                }
            });

            if (isRefresh) {
                this.loadTasks();
            } else {
                // remove task without refreshing the entire page
                this.activeTasks = _.filter(this.activeTasks, function (item) {
                    return item.id != task.id;
                });
            }
        },
        showTaskAlert: function showTaskAlert(task) {
            var _this3 = this;

            var isClosed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            // reload task list
            var alert = this.showAlert({
                type: isClosed ? 'warning' : 'success',
                text: task.name + ' has been ' + (isClosed ? 'closed' : 'reopened') + '.',
                hideAfter: 3000,
                afterHidden: this.onTaskHide,
                afterHiddenParameter: task,
                extraButton: '\n                    <button id="undo-' + task.id + '" class="btn btn-default btn-sm btn-undo undo-task">Undo</button>\n                '
            });

            // set alerts reactivity
            this.$set('alerts[' + task.id + ']', alert);

            this.$nextTick(function () {
                var self = _this3;
                $(".undo-task").on('click', function (event) {
                    var undoTask = self.getTaskById(event.target.id);
                    self.alerts[undoTask.id].reset();
                    self.alerts[undoTask.id] = false;
                    self.finishTask(undoTask, true);
                });
            });
        },
        finishTask: function finishTask(task) {
            var _this4 = this;

            var isUndo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (task.closed == '1') {
                api.reopenEvent(task).then(function () {
                    task.closed = '0';
                    $('input[class=\'task-checkbox\'][name=\'task-' + task.id + '\']').iCheck("uncheck");
                    if (!isUndo) {
                        _this4.showTaskAlert(task, false);
                    }
                });
            } else {
                api.closeEvent(task).then(function () {
                    task.closed = '1';
                    $('input[class=\'task-checkbox\'][name=\'task-' + task.id + '\']').iCheck("check");
                    if (!isUndo) {
                        _this4.showTaskAlert(task, true);
                    }
                });
            }

            this.$nextTick(function () {
                _this4.initializeTaskCheckbox();
            });

            // reload events calendar
            var msg = {
                typeOfTask: this.type_of_task,
                calendarOnly: true
            };
            this.$dispatch('reload-tasks', msg);
        },

        loadTasks: function loadTasks(typeOfTask) {
            var _this5 = this;

            if (!typeOfTask) {
                typeOfTask = this.type_of_task;
            }

            if (this.isPlansOnly && typeOfTask != 'plans') return;

            if (typeOfTask === 'plans') {
                this.loadPlans(this.page);
                return;
            }

            var filter = {};
            if (typeOfTask === 'archived') {
                filter.type = 'general,litter,breeder';
                filter.archived = 'true';
                filter.expired = 'true';
            } else if (typeOfTask === 'expired') {
                filter.type = 'general,litter,breeder';
                filter.expired = 'true';
            } else {
                switch (typeOfTask) {
                    case 'general':
                    case 'breeder':
                    case 'litter':
                        filter.type = typeOfTask;
                        break;
                    default:
                        filter.active = 'true';
                        filter.type = 'general,litter,breeder';
                }
            }

            this.perPage = localStorage.getItem('perPage') || this.perPage;

            filter.searchQuery = this.searchQuery;
            filter.perPage = this.perPage;
            filter.page = this.page;
            filter.order = this.currentSort + '|' + this.currentOrder;

            // Merge old and new filters
            filter = (0, _extends3.default)({}, filter, { filters: (0, _extends3.default)({}, this.filters) });

            if (this.breeder && this.breeder.id && this.isBreeder) {
                filter.breeder_id = this.breeder.id;
            } else {
                filter.breeder_id = 0;
            }

            if (this.litter && this.litter.id && this.isLitter) {
                filter.litter_id = this.litter.id;
            } else {
                filter.litter_id = 0;
            }

            this.$dispatch('upcomming-tasks-filters-changed', filter);

            this.loading = 1;
            this.tasksLoading = true;

            api.getEvents(filter).then(function (tasks) {
                _this5.loading = 0;
                _this5.tasksLoading = false;
                _this5.activeTasks = tasks.data;
                _this5.current_page = tasks.current_page;
                _this5.last_page = tasks.last_page;
                _this5.makeTaskPaginationData(_this5.last_page);

                // For new version
                _this5.totalPages = tasks.last_page;
                _this5.totalCount = tasks.total;
                _this5.description = {
                    from: tasks.from,
                    to: tasks.to,
                    total: tasks.total
                };

                // for tour
                _this5.$dispatch('first-task-updated', _this5.activeTasks.length ? _this5.activeTasks[0].id : 0);

                _this5.$nextTick(function () {
                    _this5.initializeTaskCheckbox();
                });
            });
        },
        loadPlans: function loadPlans() {
            var _this6 = this;

            var filter = {};
            this.loading = 1;
            this.plansLoading = true;

            filter.type = this.typeOfPlans;
            filter.searchQuery = this.searchQuery;
            filter.perPage = this.perPage;
            filter.page = this.page;

            api.getPlans(filter).then(function (plans) {
                _this6.loading = 0;
                _this6.plansLoading = false;
                _this6.plans = plans['data'];
                _this6.current_page = plans['current_page'];
                _this6.last_page = plans['last_page'];
                _this6.makeTaskPaginationData(_this6.last_page);

                // For new version
                _this6.totalPages = plans.last_page;
                _this6.totalCount = plans.total;
                _this6.description = {
                    from: plans.from,
                    to: plans.to,
                    total: plans.total
                };

                if (_this6.$route.query.plan_id) {
                    var plan = _this6.getPlanById(parseInt(_this6.$route.query.plan_id));
                    _this6.openPlanForm(plan);
                }
            });
        },
        changeTypeOfPlans: function changeTypeOfPlans(type) {
            this.page = 1;
            this.typeOfPlans = type;
            this.loadPlans();
        },
        getFullTaskName: function getFullTaskName(task) {
            if (task.holderName) {
                if (task.type === 'breeder') {
                    return task.holderName + ': ' + task.name;
                }
                if (task.type === 'litter') {
                    return 'Litter ' + task.holderName + ': ' + task.name;
                }
            }
            return task.name;
        },
        getCage: function getCage(task) {
            if (task.type === 'breeder') {
                return task.breeders[0].cage;
            } else if (task.type === 'litter') {
                return task.litters[0].cage;
            }

            return "—";
        },
        getOwner: function getOwner(task) {
            if (task.type === 'litter') {
                return task.holderName ? 'Litter: ' + task.holderName : null;
            }

            return task.holderName;
        },
        getOwnerLink: function getOwnerLink(task) {
            if (task.type === 'breeder') {
                return '#!/profile/' + task.breeders[0].id;
            } else if (task.type === 'litter') {
                return '#!/litterprofile/' + task.litters[0].id;
            }

            return '#';
        },

        unarchiveTask: function unarchiveTask(task) {
            var _this7 = this;

            if (task && task.id) {
                task.archived = 0;
                api.unarchiveEvent(task).then(function () {
                    var msg = {};
                    $('#id_task_' + task.id).slideUp(200);
                    $("#unarchive_task").modal('hide');
                    _this7.activeTask = {};
                    msg.typeOfTask = _this7.type_of_task;
                    _this7.$dispatch('reload-tasks', msg);
                });
            }
        },
        deleteTask: function deleteTask(task) {
            var _this8 = this;

            if (task && task.id) {
                api.deleteEvent(task).then(function () {
                    var msg = {};
                    $('#id_task_' + task.id).slideUp(200);
                    $("#delete_task").modal('hide');
                    _this8.activeTask = {};

                    msg.typeOfTask = _this8.type_of_task;
                    _this8.$dispatch('reload-tasks', msg);
                });
            } else {
                var tasksForDelete = [];

                api.archiveEvents(tasksForDelete).then(function () {
                    var msg = { typeOfTask: _this8.type_of_task };
                    $("#archive_task").modal('hide');
                    _this8.$dispatch('reload-tasks', msg);
                });
            }
        },
        deletePlan: function deletePlan(plan) {
            var _this9 = this;

            if (plan && plan.id) {
                api.deletePlan(plan).then(function () {
                    $('#id_plan_' + plan.id).slideUp(200);
                    $("#delete_plan").modal('hide');
                    _this9.activePlan = {};
                    _this9.loadPlans();
                });
            }
        },
        loadBreeders: function loadBreeders() {
            var _this10 = this;

            this.loading = 1;
            api.getBreedersList().then(function (breeders) {
                _this10.loading = 0;
                _this10.breeder_litter = breeders.bucks.concat(breeders.does);
                _this10.breeders = breeders;
            });
        },
        loadLitters: function loadLitters() {
            var _this11 = this;

            this.loading = 1;
            api.getLittersList().then(function (litters) {
                _this11.loading = 0;
                var tempRabbits = [];
                litters.forEach(function (item) {
                    var name = item.parents.map(function (elem) {
                        return elem.name;
                    }).join("/");
                    tempRabbits.push({ 'given_id': item.given_id, 'id': item.id, 'name': name });
                });
                _this11.breeder_litter = tempRabbits;
            });
        },

        getTimeLeft: function getTimeLeft(task) {
            var nDaysLeft = this.getTimeDaysLeft(task);

            switch (true) {
                case nDaysLeft === 0:
                    return 'today';
                case nDaysLeft === 1:
                    return nDaysLeft + ' day';
                case nDaysLeft > 1:
                    return nDaysLeft + ' days';
                default:
                    return 'expired';
            }
        },
        getTimeDaysLeft: function getTimeDaysLeft(task) {
            var oToday = moment().startOf("day").utcOffset(0);
            var oDeadLineDate = App.parseMoment(task.date);

            return oDeadLineDate.diff(oToday, "days");
        },
        getColorForDate: function getColorForDate(task) {
            var labelClass = "label ";
            var dangerDay = 1; // label-danger
            var warningDay = 7; //label-warning

            var nDaysLeft = this.getTimeDaysLeft(task);

            switch (true) {
                case nDaysLeft <= dangerDay:
                    return labelClass + "label-danger";
                case nDaysLeft <= warningDay:
                    return labelClass + "label-warning";
                default:
                    return false;
            }
        },
        makeTaskPaginationData: function makeTaskPaginationData(last_page) {
            if (last_page === 1) {
                this.pagination_page = [];
                return;
            }
            this.pagination_page = [];
            for (var i = 1; i <= last_page; i++) {
                this.pagination_page.push(i);
            }
        },
        showRequestForm: function showRequestForm(task) {
            this.activeTask = task;
            if (task) {
                $('#delete_task').modal('show');
            } else {
                $('#archive_task').modal('show');
            }
        },
        showPlanDeletingForm: function showPlanDeletingForm(plan) {
            this.activePlan = plan;
            $('#delete_plan').modal('show');
        },
        showUnarchiveForm: function showUnarchiveForm(task) {
            this.activeTask = task;
            if (task) {
                $('#unarchive_task').modal('show');
            }
        },
        filterTasksBreeders: function filterTasksBreeders(value) {
            if (this.withArchivedBreeders) {
                return true;
            }
            return this.activeTask.relation && this.activeTask.relation.id == value.id || value.archived === 0 && value.sold_at == null;
        },
        openPlanForm: function openPlanForm(plan) {
            this.$broadcast('open-edit-breed-form', plan);
        },
        openBreedForm: function openBreedForm() {
            this.$broadcast('new-breed', true);
        },
        undoMissedPlan: function undoMissedPlan(id) {
            var _this12 = this;

            this.loading = 1;
            api.undoMissedPlan(id).then(function (response) {
                _this12.loadPlans();
            });
        },
        initializeTaskCheckbox: function initializeTaskCheckbox() {
            var _this13 = this;

            if (this.isPlansOnly) return;

            $('.task-checkbox').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            }).on('ifClicked', function (event) {
                var task = _this13.getTaskById(event.target.name);
                var isActionable = _this13.isActionAvailable(task);
                if (isActionable && !task.closed) {
                    _this13.openActualTask(task, true);
                } else {
                    _this13.finishTask(task);
                }
            });

            _.map(this.activeTasks, function (task) {
                if (task.closed == 1) {
                    $('input[class=\'task-checkbox\'][name=\'task-' + task.id + '\']').iCheck("check");
                } else {
                    $('input[class=\'task-checkbox\'][name=\'task-' + task.id + '\']').iCheck("uncheck");
                }
            });
        },
        getTaskById: function getTaskById(id) {
            id = id.replace('task-', ''); // for events
            id = id.replace('undo-', ''); // for undo
            var task = _.find(this.activeTasks, function (task) {
                return task.id == id;
            });

            return task;
        },
        getPlanById: function getPlanById(id) {
            var plan = _.find(this.plans, function (plan) {
                return plan.id == id;
            });

            return plan;
        },
        updatePage: function updatePage(page) {
            // NOTE: catch frontend bug where disabled link still triggers
            if (page == this.page || page <= 0 || page > this.totalPages) {
                return true;
            }

            this.page = page; // set new page
            this.loadTasks();
        },
        updatePerPage: function updatePerPage() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

            localStorage.setItem('perPage', value);
            this.perPage = value;
        },
        getPlanBreeder: function getPlanBreeder(plan) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'f';

            var breeders = plan.breeders;
            var breeder = {};

            if (type == 'f') {
                breeder = breeders.find(function (item) {
                    return item.sex === 'buck';
                });
            } else {
                breeder = breeders.find(function (item) {
                    return item.sex === 'doe';
                });
            }

            return breeder || {};
        },
        getPlanStatus: function getPlanStatus(plan) {
            if (plan.missed) {
                return 'Missed';
            } else if (plan.birthed) {
                return 'Birthed';
            } else {
                return 'Active';
            }
        },
        getPlanEvents: function getPlanEvents(plan) {
            var total = plan.events.length;
            var active = plan.active_events.length;

            if (total) {
                return total - active + '/' + total;
            } else {
                return '—';
            }
        },
        openActualTask: function openActualTask(task) {
            var _this14 = this;

            var isCheckbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.activeTask = $.extend({}, task);

            if (task.type === "breeder" && task.subtype === "birth") {
                this.$broadcast('new-birth-modal-open');
                api.getUsersPlans().then(function (plans) {
                    _this14.plans = plans;
                    _this14.activeBirth = { breedplan: task.breed_id || '-1', born: moment(new Date()).format(App.dateFormat) };

                    $('#birth-form-modal').modal('show');
                });
            } else if (task.type === "breeder" && task.subtype === "breed") {
                api.getPlan(task.breed_id).then(function (plan) {
                    if (plan.is_future_breeding) {
                        _this14.openPlanForm(plan);
                    } else {
                        if (isCheckbox) {
                            _this14.finishTask(task);
                        } else {
                            _this14.openTaskForm(task);
                        }
                    }
                }, function (reponse) {
                    _this14.showAlert({
                        type: 'warning',
                        text: 'The attached breed plan for ' + task.name + ' does not exist.'
                    });
                });
            } else if (task.type === "breeder" && task.subtype === "weigh") {
                this.breeder = task.breeders.length ? (0, _extends3.default)({}, task.breeders[0], { isWeight: true, task_id: task.id }) : {};
                this.$nextTick(function () {
                    _this14.$broadcast('breeder-edit');
                });
            } else if (task.type === "litter" && task.subtype === "weigh") {
                this.litter = task.litters.length ? task.litters[0] : {};
                this.litters = [this.litter];
                $('#litter-weight-modal').modal('show');
            } else if (task.type === "litter" && task.subtype === "butch") {
                this.litter = task.litters.length ? task.litters[0] : {};
                this.litters = [this.litter];
                $('#litter-butcher-modal').modal('show');
            } else if (task.type === "breeder" && task.subtype === "check") {
                this.activeBirth = { breedplan: task.breed_id || '-1', born: moment(new Date()).format(App.dateFormat) };
                this.$broadcast('new-pregnancy-check');
                api.getUsersPlans().then(function (plans) {
                    _this14.plans = plans;
                    $('#pregnancy-check-modal').modal('show');
                });
            } else {
                // generic catch
                if (isCheckbox) {
                    this.finishTask(task);
                } else {
                    this.openTaskForm(task);
                }
            }

            this.$nextTick(function () {
                // if a task is doable, it should still open
                $('input[class=\'task-checkbox\'][name=\'task-' + task.id + '\']').iCheck('uncheck');
            });
        },
        isActionAvailable: function isActionAvailable(task) {
            var isAvailable = false;

            if (task.type === "breeder" && task.subtype === "birth") {
                isAvailable = true;
            } else if (task.type === "breeder" && task.subtype === "breed") {
                isAvailable = true;
            } else if (task.type === "breeder" && task.subtype === "weigh") {
                isAvailable = true;
            } else if (task.type === "litter" && task.subtype === "weigh") {
                isAvailable = true;
            } else if (task.type === "litter" && task.subtype === "butch") {
                isAvailable = true;
            } else if (task.type === "breeder" && task.subtype === "check") {
                isAvailable = true;
            }

            return isAvailable;
        }
    },
    ready: function ready() {
        var _this15 = this;

        /**
         * use js format since we only need the dom
         * NOTE: remove this after dashboard v2 is deployed
         */
        if (document.getElementById('todo-list-fastclick')) FastClick.attach(document.getElementById('todo-list-fastclick'));

        this.loadBreeders();
        this.loadLitters();

        // event listeners
        this.$root.$on('close-breeder', function () {
            if (!_this15.isBreeder) _this15.breeder = {};
            if (!_this15.isLitter) _this15.litter = {};
        });
        this.$root.$on('open-actual-task', function (task) {
            _this15.openActualTask(task);
        });
        this.$root.$on('close-task', function (id) {
            if (!_this15.isBreeder) _this15.breeder = {};
            if (!_this15.isLitter) _this15.litter = {};
            var task = _this15.getTaskById(id.toString());
            _this15.finishTask(task);
        });
        this.$root.$on('reload-tasks', function () {
            _this15.loadTasks();
        });
    },

    mixins: [App.Mixins.Generic, App.Mixins.BreedersFilter, App.Mixins.Filterable, App.Mixins.Alerts, App.Mixins.FieldDescription]
});

},{"babel-runtime/helpers/defineProperty":36,"babel-runtime/helpers/extends":37}],865:[function(require,module,exports){
"use strict";

var _mixpanelBrowser = require("mixpanel-browser");

App.Components.User = {
    template: "#user-template",
    data: function data() {
        return {
            userRoles: [],
            plans: [],
            errors: [],
            loading: false,
            editMode: false,
            refundInvoiceId: null,
            refundSum: null,
            toPlanId: null,
            token: null,
            subscriptionErrorMessage: '',
            plan: {},
            confirmSum: {},
            countRequest: 0,
            user: {
                trial_ends: "",
                image: {
                    name: '',
                    path: '',
                    temp: true,
                    oldImage: '',
                    delete: false
                }
            },
            inAppPayments: [],
            androidAppPayments: [],
            countAndroidRequest: 0,
            isAdmin: 0,
            loadingLogs: false,
            logsPage: 1,
            disableLoadMoreLogs: true,
            userLoginLogs: []
        };
    },
    computed: {
        plan: function plan() {
            var _this = this;

            return this.plans.find(function (plan) {
                return plan.id === _this.toPlanId;
            });
        },
        switchType: function switchType() {
            return this.plan && this.user.plan.offered && this.user.plan.max_breeders > this.plan.max_breeders ? 'downgraded' : 'upgraded';
        }
    },
    events: {
        dataHere: function dataHere() {
            this.$nextTick(function () {
                this.initUploader();
            });
        }
    },
    methods: {
        getSubscriptionActionClass: function getSubscriptionActionClass(name) {
            switch (name) {
                case 'canceled':
                    return 'alert-danger';
                case 'created':
                case 'resumed':
                    return 'alert-success';
                default:
                    return 'alert-info';
            }
        },
        deleteImage: function deleteImage() {
            this.user.image.path = '';
            this.user.image.delete = true;
        },
        sendUser: function sendUser() {
            var _this2 = this;

            this.errors = [];
            if (this.editMode) this.user._method = "PUT";
            //this.user.image = this.images;
            api.saveUser(this.user).then(function () {
                _this2.$route.router.go({ path: '/users' });
            }, function (response) {
                if (response.data) {
                    _this2.errors = response.data.errors;
                }
            });
        },
        initUploader: function initUploader() {
            var self = this;
            $(self.$els['image']).fileupload({
                dataType: 'json',
                paramName: 'image',
                formData: {
                    "_token": $('meta[name="csrf-token"]').attr('content'),
                    "_method": "POST",
                    "user_id": self.user.id
                },
                url: '/admin/images/uploadImage',
                done: function done(e, data) {
                    self.user.image.name = data.result.image.name;
                    self.user.image.path = data.result.image.path;
                    self.user.image.temp = data.result.image.temp;
                }
            });
        },
        formatDate: function formatDate(date) {
            return App.formatDate(date);
        },
        refundInvoice: function refundInvoice(invoiceId) {
            this.refundInvoiceId = invoiceId;
            $('#confirm-invoice-refund-modal').modal('show');
        },
        doRefundInvoice: function doRefundInvoice() {
            var _this3 = this;

            api.refundUserInvoice(this.user.id, { id: this.refundInvoiceId, refund_sum: this.refundSum }).then(function (response) {
                if (response.success) {
                    _this3.refundInvoiceId = null;
                    _this3.refundSum = null;
                    $('#confirm-invoice-refund-modal').modal('hide');
                    api.getUserInvoices(_this3.$route.params.userId).then(function (response) {
                        _this3.user.invoices = response;
                    });
                } else {
                    Vue.set(_this3.errors, 'refund_invoice', response.error);
                }
            }, function (response) {
                Vue.set(_this3.errors, 'refund_invoice', response.data.refund_sum ? response.data.refund_sum[0] : 'An error occurred');
            });
        },

        changeSubscriptionPreview: function changeSubscriptionPreview() {
            var _this4 = this;

            this.errors = [];

            if (!this.plan) {
                Vue.set(this.errors, 'plan', 'Invalid plan');
                return;
            }

            this.loading = true;

            api.previewSubscription({ plan_id: this.plan.key_name }, this.user.id).then(function (data) {
                _this4.confirmSum = data;
                _this4.loading = false;
                $('#confirm-change-subscription-modal').modal('show');
            }, function (response) {
                _this4.loading = false;
                _this4.subscriptionErrorMessage = !response.status ? 'Your internet connection is not working. Please try again later.' : response.data;
                $('#change-subscription-error-modal').modal('show');
            });
        },
        changeSubscription: function changeSubscription() {
            var _this5 = this;

            if (this.loading) {
                return;
            }

            this.loading = true;

            api.checkBreedersLimit(false, this.user.id).then(function (response) {
                if (response.count > _this5.plan.max_breeders) {
                    _this5.loading = false;
                    _this5.subscriptionErrorMessage = "The user currently has " + response.count + " breeding rabbits in his account, and the\n                        " + _this5.plan.name + " plan allows only " + _this5.plan.max_breeders + " breeders.";
                    _this5.hideChangeSubscriptionPreviewModal();
                    $('#change-subscription-error-modal').modal('show');
                    return;
                }
                api.subscribe({ token: _this5.token, plan_id: _this5.plan.key_name, confirm_sum: _this5.confirmSum.total }, _this5.user.id).then(function () {
                    _this5.loading = false;
                    $('#confirm-change-subscription-modal').modal('hide');
                    _this5.loadUser();
                }, function (response) {
                    _this5.loading = false;
                    _this5.subscriptionErrorMessage = !response.status ? 'Your internet connection is not working. Please try again later.' : response.data;

                    _this5.hideChangeSubscriptionPreviewModal();
                    $('#change-subscription-error-modal').modal('show');
                });
            });
        },
        hideChangeSubscriptionPreviewModal: function hideChangeSubscriptionPreviewModal() {
            $('#confirm-change-subscription-modal').modal('hide');
        },

        loadRoles: function loadRoles() {
            var _this6 = this;

            api.getRolesList().then(function (rolesList) {
                _this6.userRoles = rolesList;
            });
        },
        loadPlans: function loadPlans() {
            var _this7 = this;

            api.getSubscriptionPlans().then(function (plans) {
                _this7.plans = plans;
            });
        },
        loadUser: function loadUser() {
            var _this8 = this;

            api.getUser(this.$route.params.userId).then(function (user) {
                _this8.user = user;
            });
        },
        loadInAppPayments: function loadInAppPayments() {
            var _this9 = this;

            api.inAppPayments(this.$route.params.userId).then(function (payments) {
                if (payments.length == 0 && _this9.countRequest <= 3) {
                    _this9.countRequest++;
                    _this9.loadInAppPayments();
                }
                _this9.inAppPayments = payments;
            });
        },
        loadAndroidPayments: function loadAndroidPayments() {
            var _this10 = this;

            api.androidPayments(this.$route.params.userId).then(function (payments) {
                if (payments.length == 0 && _this10.countAndroidRequest <= 3) {
                    _this10.countAndroidRequest++;
                    _this10.loadAndroidPayments();
                }
                _this10.androidAppPayments = payments;
            });
        },
        loadUserLoginLogs: function loadUserLoginLogs() {
            var _this11 = this;

            this.loadingLogs = true;
            api.getUserLoginLogs({ page: this.logsPage }, this.$route.params.userId).then(function (data) {
                _this11.loadingLogs = false;
                if (_this11.logsPage > 1) {
                    _this11.mergeByProperty(_this11.userLoginLogs, data.data, 'id');
                } else {
                    _this11.userLoginLogs = data.data;
                }

                _this11.disableLoadMoreLogs = data.is_last_page;
            }, function (response) {
                _this11.loadingLogs = false;
            });
        },
        loadMoreLogs: function loadMoreLogs() {
            this.logsPage += 1;
            this.loadUserLoginLogs();
        },

        loginAsUser: function loginAsUser() {
            api.loginAsUser(this.user.id).then(function (r) {
                window.location = r;
            });
        }
    },
    ready: function ready() {
        this.isAdmin = App.admin;

        this.loadUser();
        this.loadRoles();
        this.loadPlans();
        this.loadInAppPayments();
        this.loadAndroidPayments();
        this.loadUserLoginLogs();

        if (this.$route.params.userId) {
            this.editMode = true;
        }

        this.initUploader();
    },
    mixins: [App.Mixins.Filterable]
};

},{"mixpanel-browser":634}],866:[function(require,module,exports){
'use strict';

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Users = {
    template: "#users-template",
    data: function data() {
        return {
            test: ['asd'],
            users: [],
            plans: {},
            usersTotal: 0,
            /*breedersTotal: 0,
            littersTotal: 0,
            kitsTotal: 0,*/
            pages: 1,
            order: 'last_login_at|desc',
            filters: {
                id: '',
                email: '',
                name: '',
                stripe_id: '',
                subscription_status: '',
                user_type: '',
                trial_ends_at: {
                    from: null,
                    to: null
                },
                general_status: '',
                payment_method_id: ''
            },
            filterRules: {
                id: 'number',
                email: 'string',
                name: 'string',
                stripe_id: 'string',
                trial_ends_at: 'daterange',
                subscription_status: 'string',
                user_type: 'number',
                general_status: 'string',
                payment_method_id: 'number'
            },
            searchFields: ['id', 'email', 'name', 'stripe_id'],
            isAdmin: 0,
            userRoles: [],
            loading: false
        };
    },
    props: [],
    computed: {
        page: function page() {
            return this.$route.query.page || 1;
        },
        currentRoute: function currentRoute() {
            return this.$route.path.split('?')[0];
        },
        subscriptionStatusesFilter: function subscriptionStatusesFilter() {
            var result = [{
                value: '',
                title: 'All'
            }];

            (0, _values2.default)(this.plans).forEach(function (item) {
                result.push({
                    value: item.key_name,
                    title: item.key_name === 'forever' ? item.name : item.name + ' ' + item.period
                });
            });

            return result;
        }
    },
    watch: {
        currentRoute: function currentRoute() {
            return this.$route.path.split('?')[0];
        },
        page: function page() {
            this.updateList();
        },
        order: function order() {
            this.updateList();
        }
    },

    methods: {
        changeOrder: function changeOrder(value) {
            this.order = value;
        },
        confirmDelete: function confirmDelete(user) {
            $('#delete').modal('show');
            this.toDelete = user;
        },
        deleteUser: function deleteUser() {
            var _this = this;

            var user = this.toDelete;
            api.deleteUser(user).then(function () {
                _this.users = _.without(_this.users, _.findWhere(_this.users, { id: user.id }));
            }, function () {});
        },
        loginAsUser: function loginAsUser(id) {
            api.loginAsUser(id).then(function (r) {
                window.location = r;
            });
        },
        prevPage: function prevPage() {
            if (this.page - 1 > 0) {
                this.$router.go({
                    path: this.currentRoute,
                    query: {
                        page: this.page - 1
                    }
                });
            }
        },

        nextPage: function nextPage() {
            if (Number(this.page) + 1 <= this.pages) {
                this.$router.go({
                    path: this.currentRoute,
                    query: {
                        page: Number(this.page) + 1
                    }
                });
            }
        },

        updateList: function updateList() {
            var _this2 = this;

            var data = { page: this.page, paginated: 1 };

            data.filters = this.filters;
            data.searchQuery = this.searchQuery;
            data.isUserList = true;

            if (this.order) {
                data.order = this.order;
            }

            this.loading = true;
            api.getUsers(data).then(function (users) {
                _this2.users = users.data;
                _this2.usersTotal = users.total;
                _this2.pages = users.last_page;

                _this2.itemsLoaded = users.current_page;
                _this2.disableLoadMore = false;
                _this2.totalItems = users.total;
                _this2.loading = false;
            });
        },

        loadRoles: function loadRoles() {
            var _this3 = this;

            api.getRolesList().then(function (rolesList) {
                _this3.userRoles = rolesList;
            });
        },

        loadMore: function loadMore() {
            var _this4 = this;

            var data = { page: parseInt(this.itemsLoaded) + 1 };

            data.filters = this.filters;
            data.searchQuery = this.searchQuery;
            data.isUserList = true;

            if (this.order) {
                data.order = this.order;
            }

            this.loading = true;
            api.getUsers(data).then(function (users) {
                _this4.mergeByProperty(_this4.users, users.data, 'id');
                _this4.usersTotal = users.total;
                _this4.pages = users.last_page;

                _this4.itemsLoaded = users.current_page;
                _this4.disableLoadMore = false;
                _this4.totalItems = users.total;
                _this4.itemsLoaded = users.current_page;
                if (users.last_page <= users.current_page) {
                    _this4.disableLoadMore = true;
                } else {
                    _this4.disableLoadMore = false;
                }
                _this4.loading = false;
            });
        }
    },
    ready: function ready() {
        var _this5 = this;

        this.isAdmin = App.admin;

        this.updateList();
        this.loadRoles();
        api.getSubscriptionPlans().then(function (data) {
            _this5.plans = data;
        });
    },
    mixins: [App.Mixins.Filterable]
};

},{"babel-runtime/core-js/object/values":29}],867:[function(require,module,exports){
'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.Vdropzone = {
    template: '\n        <div v-el:dropzone class=\'dropzone\'></div>',
    data: function data() {
        return {
            dropzone: {}
        };
    },
    props: {
        dzOptions: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        options: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    computed: {
        dropzoneSettings: function dropzoneSettings() {
            var result = {
                url: 'url',
                autoProcessQueue: false,
                addRemoveLinks: true,
                thumbnailWidth: 200,
                thumbnailHeight: 200,
                maxFileSize: 100
            };

            (0, _keys2.default)(this.dzOptions).forEach(function (key) {
                result[key] = this.dzOptions[key];
            }, this);

            return result;
        },
        settings: function settings() {
            var result = {
                hideProgress: false
            };

            (0, _keys2.default)(this.options).forEach(function (key) {
                result[key] = this.options[key];
            }, this);

            return result;
        }
    },
    methods: {
        removeFiles: function removeFiles() {
            this.dropzone.removeAllFiles(true);
        },
        disable: function disable() {
            this.dropzone.disable();
        },
        enable: function enable() {
            this.dropzone.enable();
        }
    },
    ready: function ready() {
        Dropzone.autoDiscover = false;
        var vm = this;

        var dropzoneSettings = (0, _assign2.default)({}, this.dropzoneSettings);

        dropzoneSettings.init = function () {
            var _this = this;

            this.on('addedfile', function (file) {
                if (vm.settings.hideProgress) {
                    $(_this.previewsContainer).find('.dz-progress').hide();
                }
                if (!dropzoneSettings.maxFiles || dropzoneSettings.maxFiles >= _this.files.length) {
                    vm.$dispatch('added-file', file);
                }
            });
            this.on('removedfile', function (file) {
                vm.$dispatch('removed-file', file);
            });
            this.on('error', function (file, message) {
                vm.$dispatch('error', file, message);
            });
        };

        this.dropzone = new Dropzone(this.$els.dropzone, dropzoneSettings);
    }
};

},{"babel-runtime/core-js/object/assign":22,"babel-runtime/core-js/object/keys":27}],868:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.WeighForm = Vue.extend({
  template: "#weigh-form-template",
  data: function data() {
    return {
      weights: [],
      newWeight: {
        id: 0,
        value: null,
        date: null,
        isSaved: false
      },
      deleteWeight: {},
      error: null,
      loading: 0,
      page: 1
    };
  },
  props: ["breeder", "type", "datepickerContainer"],
  components: {
    "lbs-oz-input": App.Components.LbsOzInput
  },
  computed: {
    isValidated: function isValidated() {
      var weight = this.newWeight;
      return weight.value && weight.date;
    },
    pages: function pages() {
      // set a minimum of 1 page
      var maxPages = this.totalPages > 0 ? this.totalPages : 1;
      var pages = [];
      while (maxPages > 0) {
        var page = {
          title: maxPages,
          isActive: this.page == maxPages
        };
        pages.push(page);

        maxPages--;
      }

      return pages.reverse();
    },
    paginatedWeights: function paginatedWeights() {
      return this.weights.slice(this.description.from - 1, this.description.to);
    },
    description: function description() {
      return {
        from: (this.page - 1) * 6 + 1,
        to: this.page * 6 <= this.weights.length ? this.page * 6 : this.weights.length,
        total: this.weights.length
      };
    },
    totalCount: function totalCount() {
      return this.weights.length;
    },
    totalPages: function totalPages() {
      return Math.ceil(this.weights.length / 6);
    }
  },
  watch: {
    "breeder.id": function breederId(newData) {
      this.setCurrentWeights();
    }
  },
  methods: {
    setCurrentWeights: function setCurrentWeights() {
      var weights = this.breeder.weight;
      var weight_dates = this.breeder.weight_date;
      this.weights = [];
      this.error = null;

      this.weights = _.map(weights, function (value, key) {
        return {
          id: key + 1,
          value: value,
          date: moment(new Date(weight_dates[key])).format(App.dateFormat),
          isSaved: true
        };
      });

      this.page = 1;
    },
    updatePage: function updatePage(page) {
      // NOTE: catch frontend bug where disabled link still triggers
      if (page == this.page || page <= 0 || page > this.totalPages) {
        return true;
      }

      this.page = page; // set new page
    },
    buildBreederWeights: function buildBreederWeights() {
      var weights = [];
      var weight_dates = [];

      _.map(this.weights, function (weight) {
        var date = moment(weight.date, App.dateFormat).format("MM/DD/YYYY");
        weights.push(weight.value);
        weight_dates.push(new Date(date).getTime());
      });

      this.breeder.weight = weights;
      this.breeder.weight_date = weight_dates;
      this.breeder.update_weight_format = true;
    },
    weigh: function weigh() {
      var _this = this;

      this.loading = 1;
      this.buildBreederWeights();

      if (this.type && this.type == 'kit') {
        api.saveKit(this.breeder).then(function (data) {
          _this.loading = 0;
          _this.$dispatch("breeder-saved");

          _this.showAlert({
            type: "success",
            text: "Successfully updated " + data.name + "'s weight data."
          });
        }, function (response) {
          _this.loading = 0;
          _this.error = "An error has occured.";
        });
      } else {
        api.saveBreeder(this.breeder).then(function (data) {
          _this.loading = 0;
          _this.$dispatch("breeder-saved");

          _this.showAlert({
            type: "success",
            text: "Successfully updated " + data.name + "'s weight data."
          });
        }, function (response) {
          _this.loading = 0;
          _this.error = "An error has occured.";
        });
      }
    },
    add: function add() {
      var _this2 = this;

      if (!this.isValidated) {
        this.error = "Both fields are required.";
        return;
      } else {
        this.error = null;
      }

      var id = 1;

      if (!this.newWeight.id) {
        // ADD
        if (this.weights.length) {
          id = this.weights[0].id !== 1 ? this.weights[0].id + 1 : this.weights[this.weights.length - 1].id + 1;
        }

        this.newWeight.id = id;
        this.weights.unshift((0, _extends3.default)({}, this.newWeight));
      } else {
        // EDIT
        id = this.newWeight.id;
        this.weights = _.map(this.weights, function (weight) {
          if (weight.id == id) {
            weight = (0, _extends3.default)({}, _this2.newWeight);
          }

          return weight;
        });
      }

      this.weigh();
      // this.buildBreederWeights();
      this.resetNewWeight();
    },
    edit: function edit(weight) {
      this.newWeight = (0, _extends3.default)({}, weight);
    },
    showDeleteModal: function showDeleteModal(weight) {
      this.deleteWeight = (0, _extends3.default)({}, weight);
      $("#delete-weight-modal").modal("show");
    },
    delete: function _delete() {
      var id = this.deleteWeight.id;
      this.weights = _.filter(this.weights, function (weight) {
        return weight.id != id;
      });

      this.deleteWeight = {};
      this.buildBreederWeights();
      $("#delete-weight-modal").modal("hide");
    },
    resetNewWeight: function resetNewWeight() {
      this.newWeight = {
        id: 0,
        value: null,
        date: null,
        isSaved: false
      };
    }
  },
  events: {
    breederWeigh: function breederWeigh() {
      this.setCurrentWeights();
    }
  },
  ready: function ready() {
    this.setCurrentWeights();
  },

  mixins: [App.Mixins.FieldDescription, App.Mixins.Weightable, App.Mixins.Alerts]
});

},{"babel-runtime/helpers/extends":37}],869:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _mixpanelBrowser = require("mixpanel-browser");

var _mixpanelBrowser2 = _interopRequireDefault(_mixpanelBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.GamifySettings = App.Components.WizardSettings.extend({
  template: "#gamify-settings-template",
  methods: {
    updateSettings: function updateSettings() {
      var _this = this;

      this.success = {};
      this.errors = {};
      this.loading = true;

      this.cleanUsagePurposeData();
      this.user.is_onboarded = true;
      this.user.gamify = true;
      this.user.rabbitry_info = (0, _extends3.default)({}, this.rabbitry_info);

      // parse based on language
      var language = window.navigator.userLanguage || window.navigator.language;
      language = language.toLowerCase();

      if (language != "en-us") {
        this.user.date_format = "INT";
        this.user.general_weight_units = "Kilograms";
      }

      api.postUserSettings(this.user.id, this.user).then(function (data) {
        _this.loading = false;
        _this.success = data;
        App.isOnboarded = 1;
        _mixpanelBrowser2.default.track("Complete onboarding settings wizard");
        _this.$router.go("/");
      }, function (error) {
        _this.loading = false;
        _this.errors = error.data.errors;
      });
    }
  }
});

},{"babel-runtime/helpers/extends":37,"mixpanel-browser":634}],870:[function(require,module,exports){
"use strict";

App.Components.Wizard = {
    template: "#wizard-template",
    data: function data() {
        window.NotificationManager.subscribe();
        return {
            user: {},
            chains: [],
            user_id: "",
            success: {},
            errors: {},
            loaded: false,
            digest_enabled: false,
            temp_digest_day: -1,
            success_general: {},
            success_schedule: {},
            success_pedigree: {},
            iconBackground: {
                'bg-red': false, 'bg-blue': false, 'bg-maroon': false, 'bg-green': false, 'bg-yellow': false,
                'bg-grey': false, 'bg-purple': false, 'fa-calendar': false, 'fa-heart': false,
                'fa-asterisk': false, 'fa-bookmark': false, 'fa-eye': false, 'fa-flag': false,
                'fa-medkit': false, 'fa-paw': false, 'fa-trophy': false, 'fa-inbox': false
            }
        };
    },
    props: [],
    computed: {},
    watch: {},
    methods: {},
    ready: function ready() {},

    route: {
        activate: function activate() {
            $('body').addClass('sidebar-collapse');
            $('.content').css({ overflow: 'hidden' });
            $('body').trigger('broadcast.hide');
            $('#callout-trial').hide();
        },
        deactivate: function deactivate(transition) {
            $('body').removeClass('sidebar-collapse');
            $('.content').css({ overflow: 'auto' });
            $('body').trigger('broadcast.show');
            $('#callout-trial').show();
            transition.next();
        }
    }
};

},{}],871:[function(require,module,exports){
'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _eventBus = require('../../event-bus');

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyBreeder = App.emptyBreeder;
emptyBreeder.aquired = null;

App.Components.ImageUploadRow = App.Components.ImageUpload.extend({
    template: '#image-upload-row-template',

    methods: {
        initUploader: function initUploader() {
            var self = this;
            $(this.$els.image).unsigned_cloudinary_upload(this.cloud_settings_name, { cloud_name: App.cloud_name }, { multiple: false }).bind('fileuploadstart', function (e, data) {

                self.loading = 1;
            }).bind('cloudinarydone', function (e, data) {
                self.loading = 0;
                self.breeder.image = (0, _assign2.default)({}, {
                    name: data.result.public_id,
                    path: data.result.url,
                    temp: false,
                    oldImage: self.breeder.image.oldImage,
                    delete: self.breeder.image.delete
                });
                self.breeder.images = [{
                    name: data.result.public_id,
                    path: data.result.url,
                    temp: false,
                    oldImage: self.breeder.image.oldImage,
                    delete: self.breeder.image.delete
                }];
            }).bind('fileuploadfail', function (e, data) {
                self.loading = 0;
            });
        }
    }
});

var WizardBreeder = {
    template: "#wizard__breeder-template",
    data: function data() {
        return {};
    },
    props: ['breeder', 'fields', 'user', 'autocomplete', 'categories'],
    components: {
        'lbs-oz-input': App.Components.LbsOzInput,
        'image-upload': App.Components.ImageUploadRow
    },
    computed: {
        isUserLbsOunces: function isUserLbsOunces() {
            return this.user && this.user.general_weight_units ? this.isLbsOunces(this.user.general_weight_units) : false;
        }
    },
    methods: {
        setSex: function setSex(sex) {
            this.breeder.sex = sex;
        },

        deleteEntry: function deleteEntry() {
            this.$remove();
            this.$parent.breeders.$remove(this.breeder);
            this.$parent.breedersNumber -= 1;
        },

        initTypeahead: function initTypeahead() {
            var _this = this;

            var _loop = function _loop(field) {
                $(_this.$els[field]).typeahead({
                    hint: true,
                    highlight: true,
                    order: "asc",
                    minLength: 0
                }, {
                    limit: 100,
                    source: function source(req, callback) {
                        callback(_this.autocomplete[field].filter(function (name) {
                            return name.toLowerCase().indexOf(req.toLowerCase()) !== -1;
                        }));
                    }
                });
            };

            for (var field in this.fields) {
                _loop(field);
            }
        }
    },
    ready: function ready() {
        this.initTypeahead();
    },

    mixins: [App.Mixins.Weightable]
};

var WizardBreederForm = {
    template: "#wizard__breeder-form-template",
    data: function data() {
        return {
            initialized: false,
            breedersList: []
        };
    },
    props: ['breeder', 'user', 'fields', 'autocomplete', 'current'],
    components: {
        'image-upload': App.Components.ImageUpload,
        'sex-select': App.Components.SexSelect,
        'lbs-oz-input': App.Components.LbsOzInput
    },
    computed: {
        isUserLbsOunces: function isUserLbsOunces() {
            return this.user && this.user.general_weight_units ? this.isLbsOunces(this.user.general_weight_units) : false;
        }
    },
    methods: {
        initTypeahead: function initTypeahead() {
            var _this2 = this;

            this.breedersList = this.getBreedersAutocompleteList();

            var _loop2 = function _loop2(field) {
                $(_this2.$els[field]).typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: function source(req, callback) {
                        callback(_this2.autocomplete[field].filter(function (name) {
                            return name.toLowerCase().indexOf(req.toLowerCase()) !== -1;
                        }));
                    }
                });
            };

            for (var field in this.autocomplete) {
                _loop2(field);
            }
        }
    },

    ready: function ready() {
        this.initTypeahead();
    },

    mixins: [App.Mixins.Breeders, App.Mixins.Weightable]
};

App.Components.WizardBreeders = {
    template: "#wizard__breeders-template",
    data: function data() {
        return {
            user: {},
            breedersLimit: 0,
            breedersCount: 0,
            breedersNumber: 0,
            fields: {},
            mode: null,
            breeders: [],
            prefixes: [],
            current: {},
            loading: false,
            autocomplete: {},
            loadingEvans: false,
            loadingCsv: false,
            categories: []
        };
    },
    props: [],
    components: {
        'settings-image-upload': App.Components.SettingsImageUpload,
        'breeder': WizardBreeder,
        'breeder-form': WizardBreederForm

    },
    computed: {
        isSubscribed: function isSubscribed() {
            return App.isSubscribed;
        },

        names: function names() {
            return this.processAutocompleteField('name');
        },

        tattoos: function tattoos() {
            return this.processAutocompleteField('tattoo');
        },

        breeds: function breeds() {
            return this.processAutocompleteField('breed');
        },

        cages: function cages() {
            return this.processAutocompleteField('cage');
        },

        colors: function colors() {
            return this.processAutocompleteField('color');
        },

        autocomplete: function autocomplete() {
            return {
                prefix: this.prefixes,
                name: this.names,
                tattoo: this.tattoos,
                cage: this.cages,
                breed: this.getBreedersAutocompleteList(),
                color: this.colors
            };
        },

        totalCount: function totalCount() {
            return +this.breedersNumber + this.breedersCount;
        },

        limitLeft: function limitLeft() {
            return this.breedersLimit - this.breedersCount;
        },

        isUserLbsOunces: function isUserLbsOunces() {
            return this.user && this.user.general_weight_units ? this.isLbsOunces(this.user.general_weight_units) : false;
        }
    },
    watch: {
        breedersNumber: function breedersNumber(value, oldValue) {
            if (value < oldValue) {
                this.breeders = this.breeders.slice(0, value - 1);
            }

            if (App.admin || App.user_role == "special") {
                this.setBreedersRows(value);
            } else {
                if (value > 50) {
                    value = 50;
                    this.breedersNumber = 50;
                } else {
                    this.setBreedersRows(value);
                }
            }
        }
    },
    methods: {
        addRow: function addRow() {
            this.breedersNumber += 1;
        },
        processAutocompleteField: function processAutocompleteField(field) {
            return _.uniq(_.filter(_.pluck(this.breeders, field), function (val) {
                return val != "";
            }));
        },
        setBreedersRows: function setBreedersRows(value) {
            if (value > this.limitLeft) {
                value = this.limitLeft;
            }

            while (this.breeders.length < value) {
                var breeder = (0, _assign2.default)({}, emptyBreeder);
                this.breeders.push(breeder);
            }
        },
        saveBreeders: function saveBreeders() {
            var _this3 = this;

            var fromModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!this.loading) {
                var self = this;
                this.loading = true;
                api.saveBreeders(this.breeders, this.fields, emptyBreeder).then(function (response) {
                    _this3.loading = false;

                    if (fromModal) {
                        $('#wizard-breeder-modal').modal('hide');
                    }

                    setTimeout(function () {
                        self.$router.go({ path: '/breeders' });
                    }, 300);

                    setTimeout(function () {
                        if (response.subscription.upgraded) {
                            _eventBus2.default.$emit('auto-upgrade-subscription', response.subscription);
                        }
                    }, 1000);
                }, function () {
                    _this3.loading = false;
                });
            }
        },
        nextBreeder: function nextBreeder() {
            if (this.current < this.breedersNumber) {
                this.current += 1;
            }
        },
        previousBreeder: function previousBreeder() {
            if (this.current > 0) {
                this.current--;
            }
        },
        parseFile: function parseFile(e) {
            var _this4 = this;

            if (!this.loadingCsv || !this.loadingEvans) {
                if (e.target.id === 'import-file') {
                    this.loadingCsv = true;
                } else if (e.target.id === 'import-html') {
                    this.loadingEvans = true;
                }
                if (!$(e.target).val()) {
                    return;
                }
                api.importFile(e.target.files[0]).then(function (data) {
                    _this4.loadCategories();
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        var _loop3 = function _loop3(_step, _iterator2) {
                            var breeder = _step.value;

                            breeder.aquired = breeder.acquired;
                            delete breeder.acquired;

                            var mapObj = {
                                Pedigree: "",
                                pedigree: ""
                            };

                            breeder.breed = breeder.breed.replace(/Pedigree|pedigree/gi, function (matched) {
                                return mapObj[matched];
                            });

                            for (var key in breeder) {
                                if (key !== 'father_name' && key !== 'mother_name') {
                                    if (breeder.hasOwnProperty(key) && !breeder[key]) {
                                        delete breeder[key];
                                    }
                                }
                            }

                            _this4.breeders.push((0, _assign2.default)({}, emptyBreeder, breeder));
                            _this4.breedersNumber += 1;

                            if (e.target.id === 'import-file') {
                                _this4.loadingCsv = false;
                            } else if (e.target.id === 'import-html') {
                                _this4.loadingEvans = false;
                            }
                        };

                        for (var _iterator2 = (0, _getIterator3.default)(data.breeders), _step; !(_iteratorNormalCompletion = (_step = _iterator2.next()).done); _iteratorNormalCompletion = true) {
                            _loop3(_step, _iterator2);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                        if (e.target.id === 'import-file') {
                            _this4.loadingCsv = false;
                        } else if (e.target.id === 'import-html') {
                            _this4.loadingEvans = false;
                        }
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        if (e.target.id === 'import-file') {
                            _this4.loadingCsv = false;
                        } else if (e.target.id === 'import-html') {
                            _this4.loadingEvans = false;
                        }
                    }

                    _this4.mode = 'import';
                }, function (errors) {
                    _this4.importErrors = errors.data;
                    if (e.target.id === 'import-file') {
                        $('#import-file').val(null);
                        _this4.loadingCsv = false;
                    } else if (e.target.id === 'import-html') {
                        $('#import-html').val(null);
                        _this4.loadingEvans = false;
                    }

                    _this4.showAlert({
                        type: 'danger',
                        text: errors.data.message
                    });
                });
            }
        },
        beginManual: function beginManual() {
            this.breedersNumber = 2;
            this.mode = 'manual';
        },

        loadPrefixes: function loadPrefixes() {
            var _this5 = this;

            api.getPrefixesList().then(function (prefixes) {
                _this5.prefixes = prefixes;
            });
        },
        getUserSettings: function getUserSettings() {
            var _this6 = this;

            api.getCurrentUserSettingsData().then(function (data) {
                _this6.user = data.user;
                _this6.setBreedersRows(_this6.breedersNumber);
                _this6.loadPrefixes();

                for (var field in emptyBreeder) {
                    if (emptyBreeder.hasOwnProperty(field)) {
                        _this6.fields[field] = true;
                        _this6.fields = (0, _assign2.default)({}, _this6.fields);

                        _this6.autocomplete[field] = [];
                        _this6.autocomplete = (0, _assign2.default)({}, _this6.autocomplete);
                    }
                }
                _this6.current = 0;
            });
        },


        loadCategories: function loadCategories() {
            var _this7 = this;

            api.getBreederCategories().then(function (data) {
                _this7.categories = data.categories;
            });
        }
    },

    ready: function ready() {
        var _this8 = this;

        api.checkBreedersLimit().then(function (data) {
            _this8.breedersLimit = data.limit;
            _this8.breedersCount = data.count;

            _this8.getUserSettings();
        });

        this.loadCategories();
    },
    route: {
        activate: function activate() {
            window.scrollTo(0, 0);
        }
    },

    mixins: [App.Mixins.Breeders, App.Mixins.Typeahead, App.Mixins.Weightable, App.Mixins.Alerts]
};

},{"../../event-bus":882,"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/object/assign":22}],872:[function(require,module,exports){
'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyLedger = App.emptyLedger;
emptyLedger.aquired = null;

var WizardLedger = {
    template: "#wizard__ledger-template",
    data: function data() {
        return {};
    },
    props: ['ledger', 'user', 'autocomplete', 'categories', 'breeders', 'litters'],
    components: {},
    methods: {
        checkIfAssociated: function checkIfAssociated(ledger) {
            for (var i = 0; i < this.categories.length; i++) {
                var category = this.categories[i];
                if (category.id == ledger.category_id) {
                    if (category.special == 'breeder' || category.special == 'litter') {
                        return true;
                    }
                }
            }
            return false;
        },
        getAssociationType: function getAssociationType(ledger) {
            var currentCategory = null;
            if (typeof ledger.category_id !== 'undefined' && ledger.category_id != '') {
                for (var i = 0; i < this.categories.length; i++) {
                    var category = this.categories[i];
                    if (category.id == ledger.category_id) {
                        currentCategory = category;
                        break;
                    }
                }
                if (currentCategory.special == 'breeder' || currentCategory.special == 'litter') {
                    if (currentCategory.special == 'litter') {
                        return 'litter';
                    }
                    if (currentCategory.special == 'breeder') {
                        return 'breeder';
                    }
                }
            }
            return 'none';
        },
        representAssociation: function representAssociation(ledger, association) {
            var currentCategory = null;
            for (var i = 0; i < this.categories.length; i++) {
                var category = this.categories[i];
                if (category.id == ledger.category_id) {
                    currentCategory = category;
                    break;
                }
            }
            return currentCategory.special === 'breeder' ? association.name + ': ' + association.tattoo : association.given_id + ': ' + association.name;
        }
    },
    ready: function ready() {}
};

var WizardLedgerForm = {
    template: "#wizard__ledger-form-template",
    data: function data() {
        return {
            initialized: false
        };
    },
    props: ['ledger', 'user', 'autocomplete', 'current'],
    components: {},

    methods: {},

    ready: function ready() {}
};

App.Components.WizardLedgers = {
    template: "#wizard__ledgers-template",
    data: function data() {
        return {
            user: {},
            ledgersNumber: 0,
            mode: null,
            ledgers: [],
            current: {},
            loading: false,
            autocomplete: {},
            categories: [],
            breeders: [],
            litters: []
        };
    },
    props: [],
    components: {
        'ledger': WizardLedger,
        'ledger-form': WizardLedgerForm

    },
    computed: {},
    watch: {
        ledgersNumber: function ledgersNumber(value, oldValue) {
            if (value < oldValue) {
                this.ledgers = this.ledgers.slice(0, value - 1);
            }

            if (value > 50) {
                value = 50;
                this.ledgersNumber = 50;
            } else {
                this.setLedgersRows(value);
            }
        }
    },
    methods: {
        addRow: function addRow() {
            // let ledger = Object.assign({}, emptyLedger);
            // this.ledgers.push(ledger);
            this.ledgersNumber += 1;
        },
        setLedgersRows: function setLedgersRows(value) {
            while (this.ledgers.length < value) {
                var ledger = (0, _assign2.default)({}, emptyLedger);
                this.ledgers.push(ledger);
            }
        },
        saveLedgers: function saveLedgers() {
            var _this = this;

            if (!this.loading) {

                this.loading = true;

                api.saveLedgers(this.ledgers, emptyLedger).then(function (response) {
                    _this.loading = false;
                    _this.$router.go({ path: '/ledger' });
                }, function (response) {
                    _this.loading = false;
                });
            }
        },
        nextLedger: function nextLedger() {
            if (this.current < this.ledgersNumber - 1) {
                this.current += 1;
            } else {
                $('#wizard-ledger-modal').modal('hide');
            }
        },
        previousLedger: function previousLedger() {
            if (this.current > 0) {
                this.current--;
            }
        },
        parseFile: function parseFile(e) {
            var _this2 = this;

            if (!$(e.target).val()) {
                return;
            }
            api.importLedgersFile(e.target.files[0]).then(function (data) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(data.ledgers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var ledger = _step.value;

                        ledger.aquired = ledger.acquired;
                        delete ledger.acquired;

                        for (var key in ledger) {
                            if (ledger.hasOwnProperty(key) && !ledger[key]) {
                                delete ledger[key];
                            }
                        }

                        _this2.ledgers.push((0, _assign2.default)({}, emptyLedger, ledger));
                        _this2.ledgersNumber += 1;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                _this2.mode = 'import';
            }, function (errors) {
                _this2.importErrors = errors.data;

                _this2.ledgers.push((0, _assign2.default)({}, emptyLedger));
                _this2.ledgersNumber = 1;
                _this2.mode = 'import';
            });
        },
        beginManual: function beginManual() {
            this.ledgersNumber = 2;
            this.mode = 'manual';
        },

        loadCategories: function loadCategories() {
            var _this3 = this;

            api.getLedgerCategories().then(function (data) {
                _this3.categories = data.categories;
            });
        },
        loadLitters: function loadLitters() {
            var _this4 = this;

            api.getLittersList().then(function (litters) {
                _this4.litters = litters.map(function (item) {
                    item.name = (item.parents[0] || { name: '' }).name + '/' + (item.parents[1] || { name: '' }).name;
                    return item;
                });
            });
        },
        loadBreeders: function loadBreeders() {
            var _this5 = this;

            api.getBreedersList().then(function (data) {
                _this5.breeders = data.bucks.concat(data.does);
            });
        }
    },

    ready: function ready() {
        this.parseFile(this.$router.ledgersFileInput);
        this.loadCategories();
        this.loadBreeders();
        this.loadLitters();
    },
    route: {
        activate: function activate() {
            window.scrollTo(0, 0);
        }
    }
};

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/object/assign":22}],873:[function(require,module,exports){
"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _mixpanelBrowser = require("mixpanel-browser");

var _mixpanelBrowser2 = _interopRequireDefault(_mixpanelBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

App.Components.WizardSettings = Vue.extend({
    template: "#wizard__settings-template",
    data: function data() {
        return {
            user: {
                breedchains: {
                    icon: {},
                    days: {},
                    name: {}
                }
            },
            chains: [],
            user_id: "",
            success: {},
            errors: {},
            loaded: false,
            chainName: '',
            chainDays: '',
            chainIcon: '',
            iconBackground: {
                'bg-red': false, 'bg-blue': false, 'bg-maroon': false, 'bg-green': false, 'bg-yellow': false,
                'bg-grey': false, 'bg-purple': false, 'fa-calendar': false, 'fa-heart': false,
                'fa-asterisk': false, 'fa-bookmark': false, 'fa-eye': false, 'fa-flag': false,
                'fa-medkit': false, 'fa-paw': false, 'fa-trophy': false, 'fa-inbox': false
            },
            loading: false,
            step: 1,
            supports_notifications: false,
            notifications_disabled: false,
            notifications_subscribed: false,
            is_ads: false,
            rabbitry_info: {
                name: null,
                first_name: null,
                last_name: null,
                address: null,
                city: null,
                state: null,
                country: null,
                zip: null,
                phone: null,
                email: null,
                website: null,
                additional_information: null
            }
        };
    },
    props: [],
    components: {
        'settings-image-upload': App.Components.SettingsImageUpload
    },
    computed: {
        isSubscribed: function isSubscribed() {
            return App.isSubscribed;
        }
    },
    watch: {
        'chainIcon': function chainIcon(newValue, oldValue) {
            if (newValue) {
                var newClass = newValue.split(' ')[1];
                var oldClass = oldValue ? oldValue.split(' ')[1] : '';

                if (newClass == 'bg-gray') newClass = newValue.split(' ')[0];
                if (oldClass == 'bg-gray') oldClass = oldValue ? oldValue.split(' ')[0] : '';

                this.iconBackground[newClass] = true;
                if (oldValue) this.iconBackground[oldClass] = false;
            }
        },
        'digest_enabled': function digest_enabled(newValue, oldValue) {
            $(this.$els.digest_enabled).iCheck('update');
            if (this.loaded) {
                if (newValue == false) {
                    this.temp_digest_day = this.user.digest_day;
                    this.user.digest_day = -1;
                } else {
                    this.user.digest_day = this.temp_digest_day;
                }
            }
        },
        'step': function step(newValue, oldValue) {
            if (newValue == 4) {
                addtohome.show();
            } else if (newValue == 3) {
                if (!this.supports_notifications) {
                    this.step = 4;
                }
            }
        },

        'user.pedigree_pdf_qr_code': function userPedigree_pdf_qr_code(newValue, oldValue) {
            $(this.$els.pedigree_pdf_qr_code).iCheck('update');
        },

        'user.pedigree_pdf_ref_link': function userPedigree_pdf_ref_link(newValue, oldValue) {
            $(this.$els.pedigree_pdf_ref_link).iCheck('update');
        },

        'user.pedigree_pdf_genotype': function userPedigree_pdf_genotype(newValue, oldValue) {
            $(this.$els.pedigree_pdf_genotype).iCheck('update');
        }

    },
    methods: {
        updateSettings: function updateSettings() {
            var _this = this;

            this.success = {};
            this.errors = {};
            this.loading = true;

            if (this.step == 2) {
                this.cleanUsagePurposeData();
            }

            this.user.rabbitry_info = (0, _extends3.default)({}, this.rabbitry_info);

            api.postUserSettings(this.user.id, this.user).then(function (res) {
                _this.loading = false;
                _this.success = res;
                if (_this.step == 3 && !App.allmobiles()) {
                    _mixpanelBrowser2.default.track("Complete settings wizard");
                    _this.$route.router.go('/');
                } else if (_this.step == 4) {
                    _mixpanelBrowser2.default.track("Complete settings wizard");
                    _this.$route.router.go('/');
                } else {
                    _this.step = _this.step + 1;
                }
            }, function (response) {
                _this.loading = false;
                _this.errors = response.data.errors;
            });
        },
        skipSettings: function skipSettings() {
            var _this = this;
            if (_this.step == 3 && !App.allmobiles()) {
                _mixpanelBrowser2.default.track("Complete settings wizard");
                _this.$route.router.go('/');
            } else if (_this.step == 4) {
                _mixpanelBrowser2.default.track("Complete settings wizard");
                _this.$route.router.go('/');
            } else {
                _this.step = _this.step + 1;
            }
        },
        addChain: function addChain() {
            if (!this.chainName) {
                alert('You must specify Name');
                return false;
            }
            if (!this.chainDays) {
                alert('You must specify Days');
                return false;
            }
            var chain = {
                name: this.chainName,
                days: this.chainDays,
                icon: this.chainIcon,
                id: 'new_' + new Date().getTime()
            };

            this.chains.push(chain);
            this.chains = _.sortBy(this.chains, 'days');

            this.user.breedchains.icon[chain.id] = chain.icon;
            this.user.breedchains.days[chain.id] = chain.days;
            this.user.breedchains.name[chain.id] = chain.name;

            $('#new_chain').modal('hide');

            this.chainName = '';
            this.chainDays = '';
        },

        removeChain: function removeChain(id) {
            $('li.' + id).remove();
            delete this.user.breedchains.icon[id];
            delete this.user.breedchains.days[id];
            delete this.user.breedchains.name[id];
            this.chains = this.chains.filter(function (chain) {
                return chain.id != id;
            });
        },

        updateNotificationManagerState: function updateNotificationManagerState() {
            var _this2 = this;

            var manager = window.NotificationManager;

            manager.isAvailable().then(function (available) {
                _this2.supports_notifications = available;
            });
            manager.isDisabled().then(function (disabled) {
                _this2.notifications_disabled = disabled;
            });
            manager.isSubscribed().then(function (subscribed) {
                _this2.notifications_subscribed = subscribed;
            });
        },
        disableNotifications: function disableNotifications() {
            var _this3 = this;

            NotificationManager.unsubscribe(function () {
                _this3.updateNotificationManagerState();
            });
        },
        subscribeToNotifications: function subscribeToNotifications() {
            var _this4 = this;

            NotificationManager.subscribe(function () {
                _this4.updateNotificationManagerState();
            }, function () {
                _this4.updateNotificationManagerState();
            });
        },
        sendTestNotification: function sendTestNotification() {
            api.requestTestNotification();
        },
        initICheck: function initICheck(field, obj) {
            $(this.$els[field]).iCheck({
                checkboxClass: 'icheckbox_square-blue',
                radioClass: 'iradio_square-blue',
                increaseArea: '20%' // optional
            }).on('ifChecked', function (event) {
                obj[field] = true;
            }.bind(this)).on('ifUnchecked', function (event) {
                obj[field] = false;
            }.bind(this));
        },
        changeReferralMethods: function changeReferralMethods() {
            this.user.referral_method_details = null;
        }
    },
    ready: function ready() {
        var _this5 = this;

        api.getCurrentUserSettingsData().then(function (data) {
            data.user.breedchains = {
                icon: {},
                days: {},
                name: {}
            };
            for (var i = 0; i < data.chains.length; ++i) {
                data.user.breedchains.icon[data.chains[i].id] = data.chains[i].icon;
                data.user.breedchains.days[data.chains[i].id] = data.chains[i].days;
                data.user.breedchains.name[data.chains[i].id] = data.chains[i].name;
            }
            _this5.user = data.user;

            if (_this5.user.referral_methods == "Adwords") {
                _this5.is_ads = true;
            }

            if (_this5.user.referral_methods == "FB Ads") {
                _this5.is_ads = true;
            }

            _this5.user.pedigree_number_generations = 4;
            _this5.chains = data.chains;
            _this5.digest_enabled = _this5.user.digest_day != -1;

            // set usage purpose if present
            var usage = data.user.usage_purpose || [];
            _this5.prepareUsagePurposeData(usage);

            // set rabbitry info
            if (data.rabbitry) {
                _this5.rabbitry_info = data.rabbitry;
            } else {
                _this5.rabbitry_info.additional_information = _this5.user.pedigree_rabbitry_information;
            }

            _this5.initICheck('digest_enabled', _this5);
            _this5.initICheck('pedigree_pdf_qr_code', _this5.user);
            _this5.initICheck('pedigree_pdf_ref_link', _this5.user);
            _this5.initICheck('pedigree_pdf_genotype', _this5.user);

            _this5.$nextTick(function () {
                this.loaded = true;
            });
        });

        this.updateNotificationManagerState();
        setInterval(function () {
            _this5.updateNotificationManagerState();
        }, 1000);
    },
    mixins: [App.Mixins.UsagePurpose]
});

},{"babel-runtime/helpers/extends":37,"mixpanel-browser":634}],874:[function(require,module,exports){
"use strict";

(function () {
    App.dateFormat = window.userDateFormat || "MM/DD/YYYY";
    App.dateFormatShort = window.userDateFormatShort || "MM/DD";
    App.access = {
        ledger: 'ledger',
        cage_cards: 'cage_cards',
        attachments: 'attachments',
        contacts: 'contacts',
        health: 'health'
    };
})();

},{}],875:[function(require,module,exports){
'use strict';

var _clipboard = require('clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _clipboard2.default('.btn');

(function (viewport) {

    App.settings = {
        debug: false,
        tablet: -1 != navigator.userAgent.indexOf("iPad"),
        desktop: null === navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i),
        mobile: -1 != navigator.userAgent.indexOf("iPhone"),
        android: -1 != navigator.userAgent.toLowerCase().indexOf("android"),
        timer: null
    };

    App.allmobiles = function () {
        //return true;
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    $(function () {
        App.vent.on('export-schedule', function () {
            $('#export-schedule-modal').modal('show');
            $('#export-schedule-url').focus().select();
        });
        App.vent.on('export-schedule-download', function () {
            $('#export-schedule-modal').modal('hide');
            // window.location = $(this).attr('href');
        });

        $(document).on('keypress', '.js_only-numbers', function (eve) {
            if ((eve.which != 46 || $(this).val().indexOf('.') != -1) && (eve.which < 48 || eve.which > 57) || eve.which == 46 && $(this).caret().start == 0) {
                eve.preventDefault();
            }
        });

        $(document).on('keyup', '.js_only-numbers', function (eve) {
            if ($(this).val().indexOf('.') == 0) {
                $(this).val($(this).val().substring(1));
            }
        });

        $(document).keydown(function (e) {
            if (e.keyCode == 27) {
                $('.modal').modal('hide');
            }
        });

        $('.box-tools').on('click', function (e) {
            e.preventDefault();
            return false;
        });

        $('#sidebar-new-breeder').on('click', function () {
            App.vent.trigger('breeders.new');
            return false;
        });

        $('#sidebar-new-litter').on('click', function () {
            App.vent.trigger('litters.new');
            return false;
        });

        $('#sidebar-new-ledger').on('click', function (e) {
            e.preventDefault();
            App.vent.trigger('ledger.new');
        });

        $(window).on('popstate', function () {
            $('.modal').not('.popstate-opened').modal('hide');
        });

        $(document) //Issue #89
        .on('shown.bs.modal', function () {
            var $body = $('body');
            $body.css({
                position: 'fixed', width: '100%',
                'margin-top': -1 * ($body.position().top || $body.scrollTop()) + 'px'
            });
        }).on('hidden.bs.modal', function () {
            var $body = $('body'),
                top = -1 * parseFloat($body.css('margin-top'));
            $body.css({ position: '', width: '', 'margin-top': 0 });
            $('html,body').scrollTop(top);
        });

        if (viewport.is("xs")) {
            App.viewportXS = true;
        }

        $(document).on('click', 'aside.main-sidebar li:not(.treeview) a', function () {
            if (App.viewportXS) {
                $('.sidebar-toggle').trigger('click');
            }
        });

        $(window).resize(viewport.changed(function () {
            if (viewport.is('xs')) {
                App.viewportXS = true;
            } else {
                App.viewportXS = false;
            }
        }));

        App.parseMoment = function (date) {
            return typeof date === 'string' && date.indexOf("-") === -1 ? moment(date, App.dateFormat) : moment(date);
        };

        App.formatDate = function (date) {
            return App.parseMoment(date).format(App.dateFormat);
        };

        /**
         * Rounds number to toDigits number is total (or to integral value, if it already has >= toDigits digits).
         *
         * Examples:
         * App.roundTo(10.43526, 2) = 10
         * App.roundTo(6.354534, 2) = 6.4
         * App.roundTo(0.4366, 2)   = 0.4
         *
         * @param n
         * @param toDigits
         */
        App.roundTo = function (n, toDigits) {
            var int = Math.ceil(n);
            var floatDigits = toDigits - int.toString().length;
            if (floatDigits < 0) {
                floatDigits = 0;
            }
            var mult = Math.pow(10, floatDigits);

            return Math.round(n * mult) / mult;
        };

        App.vent.openBirthModal = function (breed_id) {
            var router = new VueRouter();

            App.dashboard_birth_breed = breed_id;
            router.go({ path: '/' });
            App.vent.trigger('dashboard-birth-breed', [breed_id]);
            return false;
        };

        App.vent.butcherModal = function (litter_id) {
            var router = new VueRouter();

            App.dashboard_butch_litter = litter_id;
            router.go({ path: '/' });
            App.vent.trigger('dashboard-butch-litter', [litter_id]);
            return false;
        };

        App.vent.weightModal = function (litter_id) {
            var router = new VueRouter();

            App.dashboard_weight_litter = litter_id;
            router.go({ path: '/' });
            App.vent.trigger('dashboard-weight-litter', [litter_id]);
            return false;
        };

        function hexToRgb(hex) {
            var bigint = parseInt(hex, 16);
            var r = bigint >> 16 & 255;
            var g = bigint >> 8 & 255;
            var b = bigint & 255;

            return [r, g, b].join();
        }

        var colours = ['dd4b39', '00a65a', 'f39c12', '00c0ef', '3c8dbc', '39cccc', '605ca8', 'd81b60', 'ff851b', '111111'];

        Chart.defaults.global.colours = [];
        _.each(colours, function (color) {
            var rgb = hexToRgb(color);
            Chart.defaults.global.colours.push({
                backgroundColor: "rgba(" + rgb + ",0.2)",
                borderColor: "rgba(" + rgb + ",1)",
                borderWidth: 1,
                hoverBackgroundColor: "rgba(" + rgb + ",0.4)",
                hoverBorderColor: "rgba(" + rgb + ",1)"
            });
        });
    });
})(ResponsiveBootstrapToolkit);

},{"clipboard":100}],876:[function(require,module,exports){
'use strict';

Vue.directive('autocomplete', {
    twoWay: true,
    params: ['source'],
    bind: function bind() {
        var _this = this;

        this.vm.$nextTick(function () {
            var vm = _this.vm;

            if (!vm) {
                return false;
            }

            var data = vm.$get(_this.params.source);

            $(_this.el).typeahead({
                hint: true,
                highlight: true,
                order: "asc",
                minLength: 0
            }, {
                limit: 100,
                source: function source(req, callback) {
                    callback(data.filter(function (item) {
                        return item.toString().toLowerCase().indexOf(req.toLowerCase()) !== -1;
                    }));
                }
            }).on('typeahead:select', function (item) {
                var val = $(item.target).val();
                vm.$emit('input', val);
                vm.$emit('change', val);
            });
        });
    },
    update: function update(value) {
        if (value === undefined) {
            value = '';
        }
        $(this.el).val(value);
        $(this.el).typeahead('val', value);
    },
    unbind: function unbind() {
        $(this.el).typeahead('destroy');
    }
});

},{}],877:[function(require,module,exports){
'use strict';

Vue.directive('datepicker', {
    twoWay: true,
    params: ['container'],
    bind: function bind() {
        var vm = this.vm;
        var key = this.expression;
        var self = this;
        var disable_past = $(this.el).find('input').data('disable-past');
        var hasActivated = false;
        this.editing = false;
        $(this.el).datepicker({
            format: App.dateFormat.toLowerCase(),
            todayBtn: "linked",
            autoclose: true,
            clearBtn: true,
            todayHighlight: true,
            disableTouchKeyboard: true,
            toggleActive: true,
            defaultDate: new Date(),
            startDate: disable_past ? new Date() : 0,
            forceParse: true,
            orientation: "auto",
            container: self.params && self.params.container ? self.params.container : 'body'
        }).on('changeDate', function (e) {
            if ($(self.el).find('input').val().length > 7) {
                self.vm.$set(key, e.format());
            }
        }).on('clearDate', function (e) {
            self.vm.$set(key, null);
        });

        $(this.el).find('input').on('change paste keyup', function () {
            if (this.value == '') {
                self.vm.$set(key, '');
            }
            self.value = $(this.el).find('input').val();
        }).on('click', function () {
            $(this).select();
        });
    },
    update: function update(value) {
        $(this.el).find('input').val(value);
        if (!value || value == '') {
            value = '';
            $(this.el).datepicker('update', '');
        } else {
            $(this.el).datepicker('setDate', value);
        }
        $(this.el).val(value);
    },
    unbind: function unbind() {
        $(this.el).datepicker('destroy');
    }
});

},{}],878:[function(require,module,exports){
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sadly enough, directives binding seems to happen before nodes are inserted into DOM, whereas
 * authors of daterangepicker use some dom api upon initilizing. So the only way to make this all work seems to be:
 * * first, bind event when binding directive
 * * then, on each usage, trigger document event when elements are inserted
 */
Vue.directive('daterangepicker', {
    twoWay: true,
    params: ["defaultValue"],
    bind: function bind() {
        if (!this.el.id) {
            console.error('daterangepicker directive cannot work on element without id, sorry!');
        }
        this.reset = false;
        this.getFrom = function (value) {
            if (!value || !value.length) {
                this.reset = true;
                return null;
            }
            return value[0];
        };
        this.getTo = function (value) {
            if (!value || !value.length) return null;
            return value[1];
        };
        this.hasActivated = false;

        $(document).on('triggerDaterangepicker', '#' + this.el.id, function (e) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (this.hasActivated) return;
            this.hasActivated = true;
            $(this.el).daterangepicker((0, _extends3.default)({}, options, {
                timePicker: false,
                format: App.dateFormat,
                locale: {
                    cancelLabel: 'Clear'
                },
                autoUpdateInput: true,
                opens: 'center'
            }), function (start, end, label) {
                this.vm.$set(this.expression, [start, end]);
            }.bind(this));

            // prevent event bubbling  
            $("div.daterangepicker").click(function (e) {
                e.stopPropagation();
            });

            $(this.el).on('cancel.daterangepicker', function (ev, picker) {
                $(this.el).val('');
                this.vm.$set(this.expression, []);
            }.bind(this)).on('apply.daterangepicker', function (ev, picker) {
                this.vm.$set(this.expression, [picker.startDate, picker.endDate]);
            }.bind(this));

            if (this.value) {
                $(this.el).data('daterangepicker').setStartDate(this.getFrom(this.value));
                $(this.el).data('daterangepicker').setEndDate(this.getTo(this.value));
            } else if (this.params && this.params.defaultValue && this.params.defaultValue.from && this.params.defaultValue.to) {
                $(this.el).data('daterangepicker').setStartDate(this.params.defaultValue.from);
                $(this.el).data('daterangepicker').setEndDate(this.params.defaultValue.to);
                this.vm.$set(this.expression, [moment(this.params.defaultValue.from, App.dateFormat), moment(this.params.defaultValue.to, App.dateFormat)]);
            }
        }.bind(this));
    },
    update: function update(value) {
        var from = this.getFrom(value);
        var to = this.getTo(value);

        if (this.hasActivated) {
            if (this.reset) {
                $(this.el).data('daterangepicker').setStartDate(moment());
                $(this.el).data('daterangepicker').setEndDate(moment());
                $(this.el).val('');
            } else {
                $(this.el).data('daterangepicker').setStartDate(from);
                $(this.el).data('daterangepicker').setEndDate(to);
            }
        }
        this.reset = false;
    },
    unbind: function unbind() {
        $(document).off('triggerDaterangepicker', '#' + this.el.id);
    }
});

},{"babel-runtime/helpers/extends":37}],879:[function(require,module,exports){
'use strict';

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (global, factory) {
    (typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : factory(global.infiniteScroll = global.infiniteScroll || {});
})(undefined, function (exports) {
    'use strict';

    var throttle = function throttle(fn, delay) {
        var now, lastExec, timer, context, args; //eslint-disable-line

        var execute = function execute() {
            fn.apply(context, args);
            lastExec = now;
        };

        return function () {
            context = this;
            args = arguments;

            now = Date.now();

            if (timer) {
                clearTimeout(timer);
                timer = null;
            }

            if (lastExec) {
                var diff = delay - (now - lastExec);
                if (diff < 0) {
                    execute();
                } else {
                    timer = setTimeout(function () {
                        execute();
                    }, diff);
                }
            } else {
                execute();
            }
        };
    };

    var getScrollTop = function getScrollTop(element) {
        if (element === window) {
            return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop);
        }

        return element.scrollTop;
    };

    var getComputedStyle = document.defaultView.getComputedStyle;

    var getScrollEventTarget = function getScrollEventTarget(element) {
        var currentNode = element;
        // bugfix, see http://w3help.org/zh-cn/causes/SD9013 and http://stackoverflow.com/questions/17016740/onscroll-function-is-not-working-for-chrome
        while (currentNode && currentNode.tagName !== 'HTML' && currentNode.tagName !== 'BODY' && currentNode.nodeType === 1) {
            var overflowY = getComputedStyle(currentNode).overflowY;
            if (overflowY === 'scroll' || overflowY === 'auto') {
                return currentNode;
            }
            currentNode = currentNode.parentNode;
        }
        return window;
    };

    var getVisibleHeight = function getVisibleHeight(element) {
        if (element === window) {
            return document.documentElement.clientHeight;
        }

        return element.clientHeight;
    };

    var getElementTop = function getElementTop(element) {
        if (element === window) {
            return getScrollTop(window);
        }
        return element.getBoundingClientRect().top + getScrollTop(window);
    };

    var isAttached = function isAttached(element) {
        var currentNode = element.parentNode;
        while (currentNode) {
            if (currentNode.tagName === 'HTML') {
                return true;
            }
            if (currentNode.nodeType === 11) {
                return false;
            }
            currentNode = currentNode.parentNode;
        }
        return false;
    };

    var infiniteScroll = {
        doBind: function doBind() {
            if (this.binded) return; // eslint-disable-line
            this.binded = true;

            var directive = this;
            var element = directive.el;

            directive.scrollEventTarget = getScrollEventTarget(element);
            directive.scrollListener = throttle(directive.doCheck.bind(directive), 200);
            directive.scrollEventTarget.addEventListener('scroll', directive.scrollListener);

            var disabledExpr = element.getAttribute('infinite-scroll-disabled');
            var disabled = false;

            if (disabledExpr) {
                this.vm.$watch(disabledExpr, function (value) {
                    directive.disabled = value;
                    if (!value && directive.immediateCheck) {
                        directive.doCheck();
                    }
                });
                disabled = Boolean(directive.vm.$get(disabledExpr));
            }
            directive.disabled = disabled;

            var distanceExpr = element.getAttribute('infinite-scroll-distance');
            var distance = 0;
            if (distanceExpr) {
                distance = Number(directive.vm.$get(distanceExpr));
                if (isNaN(distance)) {
                    distance = 0;
                }
            }
            directive.distance = distance;

            var immediateCheckExpr = element.getAttribute('infinite-scroll-immediate-check');
            var immediateCheck = true;
            if (immediateCheckExpr) {
                immediateCheck = Boolean(directive.vm.$get(immediateCheckExpr));
            }
            directive.immediateCheck = immediateCheck;

            if (immediateCheck) {
                directive.doCheck();
            }

            var eventName = element.getAttribute('infinite-scroll-listen-for-event');
            if (eventName) {
                directive.vm.$on(eventName, function () {
                    directive.doCheck();
                });
            }
        },

        doCheck: function doCheck(force) {
            var scrollEventTarget = this.scrollEventTarget;
            var element = this.el;
            var distance = this.distance;

            if (force !== true && this.disabled) return; //eslint-disable-line
            var viewportScrollTop = getScrollTop(scrollEventTarget);
            var viewportBottom = viewportScrollTop + getVisibleHeight(scrollEventTarget);

            var shouldTrigger = false;

            if (scrollEventTarget === element) {
                shouldTrigger = scrollEventTarget.scrollHeight - viewportBottom <= distance;
            } else {
                var elementBottom = getElementTop(element) - getElementTop(scrollEventTarget) + element.offsetHeight + viewportScrollTop;

                shouldTrigger = viewportBottom + distance >= elementBottom;
            }

            if (shouldTrigger && this.expression) {
                this.vm.$get(this.expression);
            }
        },

        bind: function bind() {
            var directive = this;
            var element = this.el;

            directive.vm.$on('hook:ready', function () {
                if (isAttached(element)) {
                    directive.doBind();
                }
            });

            this.bindTryCount = 0;

            var tryBind = function tryBind() {
                if (directive.bindTryCount > 10) return; //eslint-disable-line
                directive.bindTryCount++;
                if (isAttached(element)) {
                    directive.doBind();
                } else {
                    setTimeout(tryBind, 50);
                }
            };

            tryBind();
        },

        unbind: function unbind() {
            this.scrollEventTarget.removeEventListener('scroll', this.scrollListener);
        }
    };

    if (window.Vue) {
        window.infiniteScroll = infiniteScroll;
        Vue.use(install);
    }

    function install(Vue) {
        Vue.directive('infiniteScroll', infiniteScroll);
    }

    exports.install = install;
    exports.infiniteScroll = infiniteScroll;
});

},{"babel-runtime/helpers/typeof":42}],880:[function(require,module,exports){
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatOption(data) {
    var country = $(data.element).data('country');

    if (!country) {
        return data.text;
    }

    var $option = $('<span class="flag-icon flag-icon-' + country.toLowerCase() + ' flag-icon-squared img-circle"></span>' + '<span class="option-title" style="margin-left:10px;">' + data.text + '</span>');

    return $option;
}

Vue.directive('select2-ajax', {
    twoWay: true,
    priority: 1000,
    params: ['options'],
    bind: function bind(el, binding) {
        var _this = this;

        this.vm.$nextTick(function () {
            var self = _this;
            var modifiers = {};
            (0, _keys2.default)(self.modifiers).forEach(function (key) {
                var modifier = key.replace(/-./g, function (x) {
                    return x.toUpperCase()[1];
                });
                modifiers[modifier] = true;
            });

            console.log(self);

            $(_this.el).select2((0, _extends3.default)({}, self.params.options, {
                dropdownAutoWidth: true,
                // allowClear: true, // remove x button
                placeholder: $(_this.el).attr("placeholder") || "Choose",
                templateResult: formatOption,
                templateSelection: formatOption
            })).on('select2:select', function () {
                if (!self.modifiers.multiple) {
                    self.set(this.value);
                }
            }).on('change', function () {
                if (self.modifiers.multiple) {
                    self.set($(self.el).val()); // this.value does not work on multiple mode
                }
            }).on('select2:open', function () {
                $('span.select2-results').parent().parent().addClass('auto-width-dropdown');
            }).on("select2:unselecting", function (e) {
                self.set("");
            });

            /**
             * Open select2 dropdown on focus
             * Reference: https://stackoverflow.com/questions/20989458/select2-open-dropdown-on-focus
             */
            $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
                $(this).closest(".select2-container").siblings('select:enabled').select2('open');
            });

            $('select.select2').on('select2:closing', function (e) {
                $(e.target).data("select2").$selection.one('focus focusin', function (e) {
                    e.stopPropagation();
                });
            });
        });
    },
    update: function update(value) {
        this.currValue = value;
        $(this.el).val(value).trigger('change');
    },
    unbind: function unbind() {
        if ($(this.el).off().data('select2')) {
            $(this.el).off().select2('destroy');
        }
    },
    paramWatchers: {
        options: function options(value) {
            console.log('options', value);
            $(this.el).select2((0, _extends3.default)({}, value, {
                dropdownAutoWidth: true,
                // allowClear: true, // remove x button
                placeholder: $(this.el).attr("placeholder") || "Choose",
                templateResult: formatOption,
                templateSelection: formatOption
            }));
        }
    }
});

},{"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37}],881:[function(require,module,exports){
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatOption(data) {
    var country = $(data.element).data('country');

    if (!country) {
        return data.text;
    }

    var $option = $('<span class="flag-icon flag-icon-' + country.toLowerCase() + ' flag-icon-squared img-circle"></span>' + '<span class="option-title" style="margin-left:10px;">' + data.text + '</span>');

    return $option;
}

Vue.directive('select2', {
    twoWay: true,
    priority: 1000,
    params: ['options'],
    bind: function bind() {
        var _this = this;

        this.vm.$nextTick(function () {
            var self = _this;
            var modifiers = {};
            (0, _keys2.default)(self.modifiers).forEach(function (key) {
                var modifier = key.replace(/-./g, function (x) {
                    return x.toUpperCase()[1];
                });
                modifiers[modifier] = true;
            });

            $(_this.el).select2((0, _extends3.default)({}, modifiers, {
                dropdownAutoWidth: true,
                // allowClear: true, // remove x button
                placeholder: $(_this.el).attr("placeholder") || "Choose",
                templateResult: formatOption,
                templateSelection: formatOption
            })).on('select2:select', function () {
                if (!self.modifiers.multiple) {
                    self.set(this.value);
                }
            }).on('change', function () {
                if (self.modifiers.multiple) {
                    self.set($(self.el).val()); // this.value does not work on multiple mode
                }
            }).on('select2:open', function () {
                $('span.select2-results').parent().parent().addClass('auto-width-dropdown');
            }).on("select2:unselecting", function (e) {
                self.set("");
            });

            /**
             * Open select2 dropdown on focus
             * Reference: https://stackoverflow.com/questions/20989458/select2-open-dropdown-on-focus
             */
            $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
                $(this).closest(".select2-container").siblings('select:enabled').select2('open');
            });

            $('select.select2').on('select2:closing', function (e) {
                $(e.target).data("select2").$selection.one('focus focusin', function (e) {
                    e.stopPropagation();
                });
            });
        });
    },
    update: function update(value) {
        this.currValue = value;
        $(this.el).val(value).trigger('change');
    },
    unbind: function unbind() {
        if ($(this.el).off().data('select2')) {
            $(this.el).off().select2('destroy');
        }
    },
    paramWatchers: {
        options: function options() {
            if (typeof this.currValue !== 'undefined') {
                $(this.el).val(this.currValue).trigger('change');
            }
        }
    }
});

},{"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/extends":37}],882:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBus = new _vue2.default(); // event-bus.js
exports.default = EventBus;

},{"vue":698}],883:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Alerts = {
  methods: {
    showAlert: function showAlert() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var type = content.type || "success";
      var text = content.text || "";
      var showIcon = content.showIcon || true;
      var hideAfter = content.hideAfter || 3000;
      var _afterHidden = content.afterHidden || function () {};
      var afterHiddenParameter = content.afterHiddenParameter || false;
      var extraButton = content.extraButton || false;
      var link = content.link || false;
      var linkText = content.linkText || false;
      var newTab = content.newTab || false;

      var icons = {
        success: "check-circle",
        info: "info-circle",
        warning: "exclamation-triangle",
        danger: "times-circle"
      };

      var colors = {
        success: "var(--success)",
        info: "var(--primary)",
        warning: "var(--warning)",
        danger: "var(--danger)"
      };

      var body = "\n        <div class=\"w-100\">\n          <div class=\"flex-center\">\n              " + (showIcon ? '<i class="fa fa-' + icons[type] + '"></i>' : "") + "\n              <span class=\"ml-10\">" + text + "</span>\n          </div>\n          " + (link ? '<div class="text-center mt-10"><a href="' + link + '" ' + (newTab ? 'target="_blank"' : "") + ">" + linkText + "</a></div>" : "") + "\n        </div>\n      ";

      if (extraButton) {
        body += extraButton;
      }

      return $.toast({
        text: body,
        position: "top-right",
        stack: 6,
        bgColor: colors[type],
        textColor: "var(--primary-white)",
        loaderBg: "var(--primary-green)",
        showHideTransition: "slide",
        hideAfter: hideAfter,
        afterHidden: function afterHidden() {
          if (afterHiddenParameter) {
            _afterHidden(afterHiddenParameter);
          } else {
            _afterHidden();
          }
        }
      });
    }
  }
};

},{}],884:[function(require,module,exports){
'use strict';

if (!App.Mixins) {
    App.Mixins = {};
}

App.Mixins.Attachments = {
    data: function data() {
        return {
            deleting: false
        };
    },
    methods: {
        view: function view(id) {
            api.getAttachmentUrl(id).then(function (response) {
                var link = document.createElement('a');
                link.href = response;
                link.setAttribute('target', '_blank');
                document.body.appendChild(link);
                link.click();
            }, function (response) {
                console.log('Error: ', response);
            });
        },
        download: function download(id) {
            api.getAttachmentUrl(id, { attachment: 1 }).then(function (response) {
                var link = document.createElement('a');
                link.href = response;
                link.setAttribute('download', 'file.png');
                document.body.appendChild(link);
                link.click();
            }, function (response) {
                console.log('Error: ', response);
            });
        },
        showDelete: function showDelete(attachment) {
            this.attachment = attachment;
            $('#delete-attachment-modal').modal('show');
        },
        delete: function _delete() {
            var _this = this;

            this.deleting = true;
            api.deleteAttachment(this.attachment).then(function () {
                _this.deleting = false;
                $('#delete-attachment-modal').modal('hide');
                _this.updateList();
            }, function () {
                _this.deleting = false;
            });
        }
    }
};

},{}],885:[function(require,module,exports){
'use strict';

if (!App.Mixins) {
    App.Mixins = {};
}

App.Mixins.Auth = {
    methods: {
        hasAccess: function hasAccess(feature) {
            return App.isTrial || App.admin || App.plan && App.plan[feature];
        },
        onMaxPlan: function onMaxPlan() {
            return App.plan.key_name.indexOf('max_') === 0;
        }
    }
};

},{}],886:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Breeders = {
  data: function data() {
    return {
      claimLoading: 0,
      isListOnMarketplace: false,
      listingAmount: 0,
      listingNotes: "",
      isAgreeToTerms: false,
      marketplaceFields: {
        name: true,
        tattoo: true,
        breed: true,
        date_of_birth: true,
        sex: true,
        image: true,
        weight: true,
        genotype: true,
        pedigree: true
      },
      genotypes: []
    };
  },

  methods: {
    getBreedersAutocompleteList: function getBreedersAutocompleteList() {
      return App.breeds;
    },
    initGenotypes: function initGenotypes() {
      var _this = this;

      api.fetchGenotypes().then(function (data) {
        _this.genotypes = data;
      });
    },
    isBreederActive: function isBreederActive(breeder) {
      return !breeder.culled && !breeder.died && !breeder.sold_at && !breeder.butchered && !breeder.archived;
    },
    humanize: function humanize() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      return text.toLowerCase().replace('aquired', 'acquired').replace(/(^|_)(\w)/g, function ($0, $1, $2) {
        return ($1 && ' ') + $2.toUpperCase();
      });
    },
    getBreederStatusList: function getBreederStatusList() {
      var list = [{ id: 'inactive', name: 'Inactive' }, { id: 'active', name: 'Active' }, { id: 'to_cull', name: 'To Cull' }, { id: 'culled', name: 'Culled' }, { id: 'sold', name: 'Sold' }, { id: 'butchered', name: 'Butchered' }, { id: 'archived', name: 'Archived' }, { id: 'died', name: 'Died' }];

      return list;
    },
    getBreederStatus: function getBreederStatus(breeder) {
      var isShowDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var status = 'Active';
      if (breeder.sex == 'doe' && !breeder.pregnant) status = 'Active (Open)';
      if (breeder.to_cull && breeder.to_cull.id) status = 'Active (To Cull)';
      if (breeder.butchered) status = isShowDate ? "Butchered (" + moment(breeder.butchered_at).format(App.dateFormat) + ")" : 'Butchered';
      if (breeder.sold_at) status = isShowDate ? "Sold (" + moment(breeder.sold_at).format(App.dateFormat) + ")" : 'Sold';
      if (breeder.culled) status = isShowDate ? "Culled (" + moment(breeder.updated_at).format(App.dateFormat) + ")" : 'Culled';
      if (breeder.archived) status = isShowDate ? "Archived (" + moment(breeder.updated_at).format(App.dateFormat) + ")" : 'Archived';
      if (breeder.died) status = isShowDate ? "Died (" + moment(breeder.died_at).format(App.dateFormat) + ")" : 'Died';
      if (breeder.for_sale) status = isShowDate ? "For Sale (" + moment(breeder.for_sale.created_at).format(App.dateFormat) + ")" : 'For Sale';

      return status;
    },
    getBreederStatusIcon: function getBreederStatusIcon(breeder) {
      var icon = 'fas fa-font';
      var status = this.getBreederStatus(breeder);

      if (status == 'Active') icon = 'fas fa-font';
      if (status == 'Active (Open)') icon = 'far fa-circle';
      if (status == 'Sold') icon = 'fas fa-dollar-sign';
      if (status == 'Culled') icon = 'fas fa-cut';
      if (status == 'Archived') icon = 'fas fa-archive';
      if (status == 'Died') icon = 'fas fa-heart';

      return icon;
    },
    getFather: function getFather(breeder) {
      if (breeder.father) {
        return breeder.father.name;
      }

      if (breeder.pedigree_father.length) {
        return breeder.pedigree_father[0].name || 'N/A';
      }

      return 'N/A';
    },
    getMother: function getMother(breeder) {
      if (breeder.mother) {
        return breeder.mother.name;
      }

      if (breeder.pedigree_mother.length) {
        return breeder.pedigree_mother[0].name || 'N/A';
      }

      return 'N/A';
    },
    cleanUpGenotypes: function cleanUpGenotypes() {
      if (typeof this.breeder.v_w_du_genotype !== "undefined") {
        if (this.breeder.v_w_du_genotype[0] == "" || this.breeder.v_w_du_genotype[1] == "") {
          this.breeder.v_w_du_genotype[0] = "";
          this.breeder.v_w_du_genotype[1] = "";
        }

        if (this.breeder.v_w_du_genotype[2] == "" || this.breeder.v_w_du_genotype[3] == "") {
          this.breeder.v_w_du_genotype[2] = "";
          this.breeder.v_w_du_genotype[3] = "";
        }

        if (this.breeder.v_w_du_genotype[4] == "" || this.breeder.v_w_du_genotype[5] == "") {
          this.breeder.v_w_du_genotype[4] = "";
          this.breeder.v_w_du_genotype[5] = "";
        }

        if (this.breeder.v_w_du_genotype[6] == "" || this.breeder.v_w_du_genotype[7] == "") {
          this.breeder.v_w_du_genotype[6] = "";
          this.breeder.v_w_du_genotype[7] = "";
        }
      }
    },
    parseBreederNoteDate: function parseBreederNoteDate(value) {
      var notes = this.breeder.new_notes || [];
      var note = _.find(notes, function (note) {
        return note.value == value;
      });

      return note ? moment(note.date, 'YYYY-MM-DD').format(App.dateFormat) : moment(this.breeder.created_at).format(App.dateFormat);
    }
  }
};

},{}],887:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
    App.Mixins = {};
}

App.Mixins.BreedersFilter = {
    data: function data() {
        return {
            withArchivedFather: false,
            withArchivedMother: false,
            withArchivedBreeders: false,
            //old
            mother_id: null,
            father_id: null,
            //old end
            entry_id: null
        };
    },
    watch: {},

    methods: {
        //old
        setFilterBreeders: function setFilterBreeders(mother_id, father_id) {
            this.father_id = father_id;
            this.mother_id = mother_id;
        },
        setFilterBreedersEntry: function setFilterBreedersEntry(id) {
            this.entry_id = id;
        },


        filterFatherBreeders: function filterFatherBreeders(value) {
            if (this.withArchivedFather) {
                return true;
            }
            return this.father_id == value.id || value.archived === 0 && value.butchered === 0 && value.died === 0 && value.sold_at == null;
        },

        filterMotherBreeders: function filterMotherBreeders(value) {
            if (this.withArchivedMother) {
                return true;
            }
            return this.mother_id == value.id || value.archived === 0 && value.butchered === 0 && value.died === 0 && value.sold_at == null;
        },

        excludeSelf: function excludeSelf(value) {
            return this.breeder.id != value.id;
        },


        resetArchivedFilterBreeders: function resetArchivedFilterBreeders() {
            this.withArchivedMother = false;
            this.withArchivedFather = false;
            this.withArchivedBreeders = false;
        },

        cleanupTaskIcon: function cleanupTaskIcon() {
            var icon = this.activeTask.icon;
            icon = icon.replace(" original", "");
            icon = icon.replace(" first-weight", "");

            this.$set("activeTask.icon", icon);
        }
    }
};

},{}],888:[function(require,module,exports){
'use strict';

if (!App.Mixins) {
    App.Mixins = {};
}

App.Mixins.Butcherable = {
    data: function data() {
        return {
            butcherValue: '',
            butcheredLitterId: null,
            butcherType: 'litter',
            butcheredBreederId: null
        };
    },
    computed: {
        isShowButcher: function isShowButcher() {
            return !!App.isShowButcher;
        }
    },
    events: {
        litterButchered: function litterButchered(id) {
            console.log('litterButchered event!');
            this.butcheredLitterId = id;
            this.butcherValue = '';
            this.butcherType = 'litter';
            $('#litter-butcher-value').modal('show');
        },

        breederButchered: function breederButchered(id) {
            console.log('breederButchered event!');
            this.butcheredBreederId = id;
            this.butcherValue = '';
            this.butcherType = 'breeder';
            $('#litter-butcher-value').modal('show');
        }
    },
    methods: {
        sendButcherValue: function sendButcherValue() {
            $('#litter-butcher-value').modal('hide');

            if (this.butcherType === 'litter') {
                api.postLitterButcherValue(this.butcheredLitterId, this.butcherValue);
                if (this.$router._currentRoute.name === 'Litter Profile') {
                    this.$router.go({ path: '/litters' });
                }
            }
            if (this.butcherType === 'breeder') {
                api.postBreederButcherValue(this.butcheredBreederId, this.butcherValue);
            }
        },
        closeButcherValueModal: function closeButcherValueModal() {
            $('#litter-butcher-value').modal('hide');

            if (this.butcherType === 'litter') {
                if (this.$router._currentRoute.name === 'Litter Profile') {
                    this.$router.go({ path: '/litters' });
                }
            }
        }
    }
};

},{}],889:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Contacts = {
  data: function data() {
    return {
      contacts: [],
      withArchivedContacts: false,
      newContact: {
        name: "",
        email: "",
        type: ""
      },
      contactErrors: null
    };
  },

  methods: {
    /**
     * Fetch contacts from API
     */
    loadContacts: function loadContacts() {
      var _this = this;

      if (!this.hasAccess("contacts")) {
        return false;
      }

      api.getContacts({ all: true }).then(function (data) {
        _this.contacts = data.contacts;
      });
    },
    /**
     * Filter contacts data
     */
    filterContacts: function filterContacts(value) {
      if (this.withArchivedContacts) {
        return true;
      }

      return value.archived === 0;
    },
    /**
     * Create new contact
     */
    addNewContact: function addNewContact(type, section) {
      var _this2 = this;

      this.newContact.type = type;
      api.storeContact(this.newContact).then(function (data) {
        if (data.id) {
          _this2.loadContacts();
          _this2.resetNewContact();

          switch (section) {
            case "ledger":
              _this2.entry.contact_id = data.id;
              break;
            case "transfer":
              _this2.transferTo = data.email;
              break;

            default:
              break;
          }
        }
      }, function (error) {
        _this2.contactErrors = error.data;
      });
    },
    /**
     * Reset contact data
     */
    resetNewContact: function resetNewContact() {
      this.newContact = {
        name: "",
        email: "",
        type: ""
      };
      this.contactErrors = null;
    }
  },
  ready: function ready() {
    this.loadContacts(); //fetch contacts on component mount
  },

  mixins: [App.Mixins.Auth]
};

},{}],890:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Cullable = {
  data: function data() {
    return {
      activeBreeder: {}
    };
  },

  methods: {
    openAddToCullListModal: function openAddToCullListModal(breeder) {
      this.activeBreeder = breeder;
      $("#add-to-cull-list").modal("show");
    },
    addToCullList: function addToCullList() {
      var _this = this;

      var breeder = this.activeBreeder;
      if (breeder && breeder.id) {
        api.addToCullListBreeder(breeder).then(function () {
          $("#add-to-cull-list").modal("hide");
          _this.activeBreeder = {};

          // list all possible data reloads
          _this.$dispatch("reload-ailments");
        });
      }
    },
    openRemoveFromCullListModal: function openRemoveFromCullListModal(breeder) {
      this.activeBreeder = breeder;
      $("#remove-from-cull-list").modal("show");
    },
    removeFromCullList: function removeFromCullList() {
      var _this2 = this;

      var breeder = this.activeBreeder;
      if (breeder && breeder.id) {
        api.removeFromCullListBreeder(breeder).then(function () {
          $("#remove-from-cull-list").modal("hide");
          _this2.activeBreeder = {};

          // list all possible data reloads
          _this2.$dispatch("reload-ailments");
        });
      }
    }
  }
};

},{}],891:[function(require,module,exports){
"use strict";

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Currency = {
  methods: {
    /**
     * Fetch sign based on user selected currency
     */
    currencySign: function currencySign() {
      var signs = {
        ALL: "L",
        AFN: "؋",
        ARS: "$",
        AWG: "ƒ",
        AUD: "$",
        AZN: "₼",
        BSD: "$",
        BBD: "$",
        BYR: "p.",
        BZD: "BZ$",
        BMD: "$",
        BOB: "Bs.",
        BAM: "KM",
        BWP: "P",
        BGN: "лв",
        BRL: "R$",
        BND: "$",
        KHR: "៛",
        CAD: "$",
        KYD: "$",
        CLP: "$",
        CNY: "¥",
        COP: "$",
        CRC: "₡",
        HRK: "kn",
        CUP: "₱",
        CZK: "Kč",
        DKK: "kr",
        DOP: "RD$",
        XCD: "$",
        EGP: "£",
        SVC: "$",
        EEK: "kr",
        EUR: "€",
        FKP: "£",
        FJD: "$",
        GHC: "₵",
        GIP: "£",
        GTQ: "Q",
        GGP: "£",
        GYD: "$",
        HNL: "L",
        HKD: "$",
        HUF: "Ft",
        ISK: "kr",
        INR: "₹",
        IDR: "Rp",
        IRR: "﷼",
        IMP: "£",
        ILS: "₪",
        JMD: "J$",
        JPY: "¥",
        JEP: "£",
        KES: "KSh",
        KZT: "лв",
        KPW: "₩",
        KRW: "₩",
        KGS: "лв",
        LAK: "₭",
        LVL: "Ls",
        LBP: "£",
        LRD: "$",
        LTL: "Lt",
        MKD: "ден",
        MYR: "RM",
        MUR: "₨",
        MXN: "$",
        MNT: "₮",
        MZN: "MT",
        NAD: "$",
        NPR: "₨",
        ANG: "ƒ",
        NZD: "$",
        NIO: "C$",
        NGN: "₦",
        NOK: "kr",
        OMR: "﷼",
        PKR: "₨",
        PAB: "B/.",
        PYG: "Gs",
        PEN: "S/.",
        PHP: "₱",
        PLN: "zł",
        QAR: "﷼",
        RON: "lei",
        RUB: "₽",
        RMB: "￥",
        SHP: "£",
        SAR: "﷼",
        RSD: "Дин.",
        SCR: "₨",
        SGD: "$",
        SBD: "$",
        SOS: "S",
        ZAR: "R",
        LKR: "₨",
        SEK: "kr",
        CHF: "CHF",
        SRD: "$",
        SYP: "£",
        TZS: "TSh",
        TWD: "NT$",
        THB: "฿",
        TTD: "TT$",
        TRY: "₺",
        TRL: "₤",
        TVD: "$",
        UGX: "USh",
        UAH: "₴",
        GBP: "£",
        USD: "$",
        UYU: "$U",
        UZS: "лв",
        VEF: "Bs",
        VND: "₫",
        YER: "﷼",
        ZWD: "Z$"
      };
      var currencyCode = App.currency;
      if (signs.hasOwnProperty(currencyCode)) {
        return signs[currencyCode];
      } else {
        return undefined;
      }
    },

    /**
     * Fetch icon based on user selected currency
     */
    currencyIcon: function currencyIcon() {
      var icons = {
        dollar: ["ARS", "AUD", "BSD", "BBD", "BZD", "BMD", "BRL", "BND", "CAD", "KYD", "CLP", "COP", "DOP", "XCD", "SVC", "FJD", "GYD", "HKD", "JMD", "LRD", "MXN", "NAD", "NZD", "NIO", "SGD", "SBD", "SRD", "TWD", "TTD", "TVD", "USD", "UYU", "ZWD"],
        euro: ["EUR"],
        won: ["KPW", "KRW"],
        yen: ["CNY", "JPY", "RMB"],
        ruble: ["RUB"],
        try: ["TRY"],
        ils: ["ILS"],
        gbp: ["EGP", "FKP", "GIP", "GGP", "IMP", "JEP", "LBP", "SHP", "SYP", "GBP"],
        rupee: ["INR"]
      };

      // set initial icon data
      var currencyCode = App.currency;
      var icon = "dollar";

      // check if current currency is declared in icons object
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(icons)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
              key = _step$value[0],
              data = _step$value[1];

          if (data.includes(currencyCode)) {
            icon = key;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return icon;
    },

    /**
     * Get ordinal format of a number
     *
     * @param {int} i
     */
    toOrdinal: function toOrdinal(i) {
      var j = i % 10,
          k = i % 100;
      if (j == 1 && k != 11) {
        return i + "ST";
      }
      if (j == 2 && k != 12) {
        return i + "ND";
      }
      if (j == 3 && k != 13) {
        return i + "RD";
      }
      return i + "TH";
    }
  }
};

},{"babel-runtime/core-js/get-iterator":18,"babel-runtime/core-js/object/entries":25,"babel-runtime/helpers/slicedToArray":40}],892:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.DashboardMessage = {
  data: function data() {
    return {
      isShowDashboardMessage: false,
      dashboardTitle: "Welcome to Everbreed, " + App.user_name + "!",
      dashboardDescription: "Let's get started with your rabbitry...",
      dashboardType: 1,
      dashboardImage: "media/logo/dashboard/main.png"
    };
  },

  computed: {
    dateToday: function dateToday() {
      return moment().format("dddd, MMMM Do, YYYY");
    },
    userName: function userName() {
      return App.user_name;
    }
  },
  watch: {
    isShowDashboardMessage: function isShowDashboardMessage(newData) {
      localStorage.setItem("isShowDashboardMessage", newData);
    }
  },
  methods: {
    loadDashboardMessage: function loadDashboardMessage() {
      var _this = this;

      var lastType = localStorage.getItem("currentDashboardMessageType") || 0;

      api.getDashboardMessage({ last_type: lastType }).then(function (data) {
        _this.dashboardType = data.type;
        _this.dashboardTitle = data.title;
        _this.dashboardDescription = _this.parseDashboardMessage(data.message);
        _this.dashboardImage = data.image;
        localStorage.setItem("currentDashboardMessageType", _this.dashboardType);

        if (lastType < _this.dashboardType) {
          _this.isShowDashboardMessage = true;
        } else {
          _this.isShowDashboardMessage = localStorage.getItem("isShowDashboardMessage") == "false" ? false : true;
        }
      });
    },
    closeDashboardMessage: function closeDashboardMessage() {
      this.isShowDashboardMessage = false;
    },
    parseDashboardMessage: function parseDashboardMessage(message) {
      try {
        if (message.indexOf("##") > -1) {
          var rawData = message.split("##")[1];
          var finalElement = "";
          if (rawData.indexOf("||") > -1) {
            var data = rawData.split("||");
            if (data[0] == "internal") {
              // check if ledger NOTE: to be improved
              if (data[2] == "ledger") {
                finalElement = "<a href=\"/#!/ledger\">" + data[1] + "</a>";
              }
            } else {
              finalElement = "<a target=\"_blank\" href=" + data[2] + ">" + data[1] + "</a>";
            }
          }

          message = message.replace("##" + rawData + "##", finalElement);
          if (message.indexOf("##") > -1) {
            // recursive call to cater all elements
            return this.parseDashboardMessage(message);
          }
        }
      } catch (e) {
        console.log(e);
      }

      return message;
    }
  },
  ready: function ready() {
    this.loadDashboardMessage();
  },

  mixins: []
};

},{}],893:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.DateHelper = {
  methods: {
    formatAge: function formatAge(from, to) {
      var age = to.diff(from, "days");

      if (age < 1) {
        return "Today";
      }

      var weeks = Math.floor(age / 7);
      var days = age % 7;

      var result = "";

      if (weeks) {
        result = weeks + " w";
      }

      if (days) {
        result += " " + days + " d";
      }

      return result;
    },
    ageFromNow: function ageFromNow(date, type) {
      var value = moment(date, App.dateFormat).startOf("day");
      var today = moment().startOf("day");
      var difference = today.diff(value, type);

      return difference.toString() + " " + (difference == 1 ? type.replace("s", "") : type);
    }
  }
};

},{}],894:[function(require,module,exports){
'use strict';

if (!App.Mixins) {
    App.Mixins = {};
}

App.Mixins.DeathReason = {
    data: function data() {
        return {
            reasonValue: '',
            deathKitId: null,
            type: 'kit',
            deathBreederId: null,
            reasons: [],
            deathModalUnique: null,
            deathReasons: [],
            newDeathReason: '',
            addNew: false
        };
    },
    events: {
        kitDied: function kitDied(kit) {
            this.deathKitId = kit.id;
            this.reasonValue = '';
            this.type = 'kit';
            $(this.deathModalId('#death-reason-modal')).modal('show');
        },

        breederDied: function breederDied(id) {
            this.deathBreederId = id;
            this.reasonValue = '';
            this.type = 'breeder';
            $(this.deathModalId('#death-reason-modal')).modal('show');
        }
    },
    methods: {
        deathModalId: function deathModalId(modalId) {
            return this.deathModalUnique ? modalId + '-' + this.deathModalUnique : modalId;
        },
        cancelReasonValue: function cancelReasonValue() {
            $(this.deathModalId('#death-reason-modal')).modal('hide');
            this.$dispatch('cancel-death-reason');
        },
        sendReasonValue: function sendReasonValue() {
            if (this.type === 'kit') {
                api.postKitDeathReasonValue(this.deathKitId, this.reasonValue);
            }
            if (this.type === 'breeder') {
                api.postBreederDeathReasonValue(this.deathBreederId, this.reasonValue);
            }
            $(this.deathModalId('#death-reason-modal')).modal('hide');
            this.$dispatch('send-death-reason');
            this.reasonValue = "";
        },

        initTypeahead: function initTypeahead() {
            var _this = this;

            api.getDeathReasons().then(function (data) {
                _this.reasons = data.reasons;

                $(_this.$els.reason).typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 0
                }, {
                    source: function source(req, callback) {
                        callback(_this.reasons.filter(function (name) {
                            return name.toLowerCase().indexOf(req.toLowerCase()) !== -1;
                        }));
                    }
                });
            });
        },
        getDeathReasons: function getDeathReasons() {
            var _this2 = this;

            this.$http.get('/admin/users/getDeathReasonsList').then(function (response) {
                _this2.deathReasons = response.data.reasons;
            });
        },
        addNewReason: function addNewReason() {
            var _this3 = this;

            this.$http.post('/admin/users/saveDeathReasonsList', {
                name: this.newDeathReason
            }).then(function () {
                _this3.getDeathReasons();
                _this3.reasonValue = _this3.newDeathReason;
                _this3.newDeathReason = '';
                _this3.addNew = false;
            }, function (response) {
                _this3.errors = response.data.errors;
            });
        },
        reasonCancel: function reasonCancel() {
            this.newDeathReason = '';
            this.addNew = false;
        },
        addNewFunc: function addNewFunc() {
            this.addNew = true;
        }
    },
    ready: function ready() {
        var _this4 = this;

        this.$nextTick(function () {
            return _this4.initTypeahead();
        });

        this.getDeathReasons();
    }
};

},{}],895:[function(require,module,exports){
"use strict";

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.FieldDescription = {
  data: function data() {
    var _ref;

    return _ref = {
      fieldDescriptions: {
        category: "You can organize your rabbits into categories, such as their purpose (show rabbits vs meat rabbits), where they came from, etc.",
        prefix: "The prefix refers to who owns/owned that rabbit. Most breeders use a short prefixes for their rabbitry name. For example, Funny Bunny Rabbitry’s prefix could be “FBR”. You can add your rabbitry’s prefix under “Settings” to make it the default.",
        name: "The common name of the rabbit you are editing, or the name you give the rabbit.",
        id: "Sometimes called an “ear tattoo”, this ID is found on the left ear of a rabbit. You can use the auto generated ID here or type your own.",
        cage: "The number or location of the rabbit in your rabbitry.",
        color: "The main color of the rabbit.",
        breed: "The breed of the rabbit as stated by ARBA.",
        gender: "Whether the rabbit you are adding is a Buck (Male) or a Doe (Female).",
        weight: "The last recorded weight of the rabbit. You can change how the Weight Units appear in your account Settings.",
        born: "The date the rabbit was born.",
        acquired: "The date you received this rabbit. If the rabbit was born on your property, it should be the same as the birthdate.",
        father: "Select the direct father of the rabbit in question. If you do not own these rabbits, you can leave it blank or add them later. Click the checkbox to show Archived breeders in the list.",
        mother: "Select the direct mother  of the rabbit in question. If you do not own these rabbits, you can leave it blank or add them later. Click the checkbox to show Archived breeders in the list.",
        reg_number: "The \u201CRegistration Number\u201D is given to select rabbits by an ARBA registrar at a rabbit show, tattooed on the right ear of the rabbit. A rabbit has to be registered with ARBA to receive a Championship number.",
        champ_number: "The Championship number is reserved for rabbits who have won at least 3 ARBA sanctioned shows. Visit ARBA.net to learn more about rabbit Championship numbers.",
        legs: "Legs are the awards given to a rabbit if they have won any rabbit show sanctioned by ARBA. A rabbit needs 3 legs (at least one senior leg is required) to receive a Championship number.",
        genotype: "The genetic color code of the rabbit. If your rabbit has a unique genotype not listed here, you can customize the genotype below."
      },
      cageFieldDescriptions: {
        name: "The name of the cage."
      },
      litterFieldDescriptions: {
        litterId: "You can assign an ID to a litter as a way to help keep track of it. This may be the first part of your individual kit IDs or the Sire and Dam\u2019s initials.",
        prefix: "The prefix refers to who own\u2019s/owned the rabbit. Most breeders use a short prefix for their rabbitry name. For example, Funny Bunny Rabbitry\u2019s prefix could be \u201CFBR\u201D. You can add your rabbitry\u2019s prefix under \u201CSettings\u201D to make it the default.",
        cage: "The location of the rabbits in your rabbitry.",
        breed: "The breed of the rabbits as stated by the ARBA.",
        buck: "The Sire to the Litter.",
        doe: "The Dam to the Litter.",
        bred: "The date the Sire and Dam were bred to make this Litter.",
        born: "The date the Litter was born.",
        notes: "Notes for this litter."
      },
      kitFieldDescriptions: {
        prefix: "The prefix refers to who own\u2019s/owned the rabbit. Most breeders use a short prefix for their rabbitry name. For example, Funny Bunny Rabbitry\u2019s prefix could be \u201CFBR\u201D. You can add your rabbitry\u2019s prefix under \u201CSettings\u201D to make it the default.",
        name: "The common name of the rabbit, or the name you give the rabbit.",
        id: "Sometimes called an \u201Cear tattoo\u201D, This ID is found on the left ear of the rabbit. You can use the autogenerated ID, or create your own.",
        color: "The color of the rabbit.",
        breed: "The breed of the rabbit as stated by the ARBA.",
        sex: "Whether the rabbit you are adding is a Buck (Male) or Doe (Female).",
        weight: "How much the kit weighs."
      },
      templateTaskFieldDescriptions: {
        name: "The name of the task you would like displayed in the template.",
        days: "The number of days after the start of the template that this task should be scheduled. For example, in a Breeder Task Template, this would be the number of days after the breeding occurs. In a Litter Task Template, this would be the number of days after the litter is born.",
        icon: "Select the type of task you would like to perform. Later, you will be able to click the icon in your task list to perform the task. For example, a \u201Cweigh\u201D task will open the form to weigh your rabbits."
      },
      taskFieldDescriptions: {
        type: "Breeder tasks will be linked to a specific breeder, Litter tasks will be linked to a specific litter, and General tasks will not be linked to any specific rabbit and can be used for anything.",
        task: "Select the type of task you would like perform. Later, you will be able to click the icon in your task list to perform the task.",
        who: "This is the specific breeder or litter this task applies to. Option not available for General tasks.",
        name: "The name you would like displayed for this task.",
        date: "The date the task should occur.",
        recurring: "If you would like this task to repeat on a schedule, select how often you would like it to repeat.",
        notes: "Any notes you\u2019d like to remember about this task."
      },
      birthFieldDescriptions: {
        breeders: "The parents of the litter. A breeding needs to have been recorded before a birth can be recorded.",
        date: "The date the litter was born.",
        litterId: "You can assign an ID to a litter as a way to help keep track of it. This may be the first part of your individual kit IDs or the Sire and Dam\u2019s initials.",
        liveKits: "The number of kits born alive.",
        deadKits: "The number of kits born dead, or that passed shortly after.",
        litterTemplate: "Choose a template that fits the litter\u2019s needs as they age. Litter Task Templates can be created and edited within Settings."
      }
    }, (0, _defineProperty3.default)(_ref, "litterFieldDescriptions", {
      litterId: "You can assign an ID to a litter as a way to help keep track of it. This may be the first part of your individual kit IDs or the Sire and Dam\u2019s initials.",
      prefix: "The prefix refers to who own\u2019s/owned the rabbit. Most breeders use a short prefix for their rabbitry name. For example, Funny Bunny Rabbitry\u2019s prefix could be \u201CFBR\u201D. You can add your rabbitry\u2019s prefix under \u201CSettings\u201D to make it the default.",
      cage: "The location of the rabbits in your rabbitry.",
      breed: "The breed of the rabbits as stated by the ARBA.",
      buck: "The Sire to the Litter.",
      doe: "The Dam to the Litter.",
      bred: "The date the Sire and Dam were bred to make this Litter.",
      born: "The date the Litter was born.",
      notes: "Notes for this litter."
    }), (0, _defineProperty3.default)(_ref, "kitFieldDescriptions", {
      prefix: "The prefix refers to who own\u2019s/owned the rabbit. Most breeders use a short prefix for their rabbitry name. For example, Funny Bunny Rabbitry\u2019s prefix could be \u201CFBR\u201D. You can add your rabbitry\u2019s prefix under \u201CSettings\u201D to make it the default.",
      name: "The common name of the rabbit, or the name you give the rabbit.",
      id: "Sometimes called an \u201Cear tattoo\u201D, This ID is found on the left ear of the rabbit. You can use the autogenerated ID, or create your own.",
      color: "The color of the rabbit.",
      breed: "The breed of the rabbit as stated by the ARBA.",
      sex: "Whether the rabbit you are adding is a Buck (Male) or Doe (Female).",
      weight: "How much the kit weighs."
    }), (0, _defineProperty3.default)(_ref, "reportsDescriptions", {
      productionReport: "Total litter weights listed by age. Only active litters are visible.",
      gestationDays: "Average number of days from breeding until kindling listed per doe.",
      doeMisses: "Total missed breedings listed per doe.",
      buckMisses: "Total missed breedings listed per buck.",
      litterSize: "Average litter size listed per doe.",
      doeCosts: "Total cost per doe based on entered finances.",
      survivalRates: "Kit survival rate listed per doe based on active and inactive litters.",
      liveAndDeadKits: "Total number of live and dead kits listed per doe.",
      averageKitsWeight: "Average kit weight per litter listed per doe.",
      litterGrowthRate: "Average litter growth rate divided by weeks and listed per doe. Includes active and inactive litters.",
      meatProduced: "Total meat produced from butchered kits listed per doe.",
      butcherAge: "Average age litters are butchered listed per doe.",
      causeOfDeath: "Cause of death for breeders and kits.",
      breederMortality: "Detailed report for breeder mortality data.",
      kitMortality: "Detailed report for kit mortality data.",
      inactiveBreeders: "The Inactive Breeders Report shows any breeders that have not had any breedings, pregnancy checks, or litters born within the last x days."
    }), (0, _defineProperty3.default)(_ref, "pedigreeFieldDescriptions", {
      importBreeder: "This option imports all data from this breeder into this pedigree card, including other cards in their lineage.",
      updateManually: "This option allows you to update the data in this card manually."
    }), (0, _defineProperty3.default)(_ref, "ailmentFieldDescriptions", {
      ailment: "The issue the rabbit is facing.",
      symptom: "The signs the rabbit is showing.",
      start_date: "A specific date field for when the ailment was first noticed. This helps track the onset of symptoms separately from the treatment start date",
      notes: "Any notes you\u2019d like to remember about this ailment.",
      cured_date: "When the animal recovered from the ailment."
    }), (0, _defineProperty3.default)(_ref, "treatmentFieldDescriptions", {
      treatment: "The treatment the rabbit is about to receive. Use the toggle to create a new treatment or use an existing one.",
      existing_treatment: "You can save Treatments that are used often within Treatment Task Templates. If an Existing Treatment is selected, the form will automatically be filled in. ",
      medication: "The type of medication required for the treatment. ",
      method: "The method in which the Medication is given (oral, injection, etc.).",
      type: "How the medication is given (subcutaneous, intermuscular, etc.).",
      dosage: "The amount of medication that needs to be given. ",
      schedule: "How often the Treatment needs to reoccur.",
      start_date: "The date that the treatment begins. ",
      withdrawal_period: "The period in which the animal is not fit for human consumption. This can be found on the medication\u2019s packaging.  ",
      administered_by: "The person who performed the treatment.",
      notes: "Any notes you\u2019d like to remember about this treatment."
    }), (0, _defineProperty3.default)(_ref, "cageCardFieldDescriptions", {
      name: "The name you would like to give the new cage card template you\u2019re creating.",
      type: "Whether this template is for breeder or litter cage cards",
      size: "The paper size the card will be printed on (Also, it says 2 x 3 but it should be 2\u201D x 3\u201D so it\u2019s clear that this is in inches)",
      orientation: "Whether the card will be printed vertically or horizontally",
      hole: "Whether a space should be left for a hole in the card."
    }), _ref;
  },

  methods: {
    initializePopovers: function initializePopovers() {
      $(".field-description").popover({
        template: "<div class=\"popover field-popover\" role=\"tooltip\">\n                        <div class=\"arrow\"></div>\n                        <div class=\"popover-content\" style=\"white-space:pre-wrap;\"></div>\n                    </div>"
      });
    }
  },
  computed: {
    weeklyDigestDescription: function weeklyDigestDescription() {
      return "If enabled, we will send you an automated weekly email reminding you of your scheduled tasks.";
    },
    defaultPrefixDescription: function defaultPrefixDescription() {
      return "If you enter a prefix for your rabbitry here, it will appear automatically when creating new rabbits. Prefix are usually a short abbreviation to identify the owner of the rabbit. For example: \u201CFBR = Funny Bunny Rabbitry\u201D";
    },
    defaultBreedDescription: function defaultBreedDescription() {
      return "Select the breed you would like to appear by default when creating new rabbits.";
    },
    notificationsDescription: function notificationsDescription() {
      return "Enable notifications to receive reminders about upcoming tasks in your rabbitry.";
    },
    taskTemplateDescription: function taskTemplateDescription() {
      return "Task Templates allow you to define a set of tasks that will be created automatically when a breeding occurs. You can customize which types of tasks you want to happen on each day following the breeding. Once a breeding occurs, you can find these tasks on the Schedule page.";
    },
    generateLitterIdDescription: function generateLitterIdDescription() {
      return "The Litter ID field is a unique identifier you can assign to a specific litter in your rabbitry. You will always need to manually input the first litter ID. If this field is set to 'automatic', Everbreed will automatically fill this with the next available ID. You can always change it to your own.";
    },
    roleDescription: function roleDescription() {
      return "If the desired role is not listed, go to the Roles tab to add it.";
    },
    farmDescription: function farmDescription() {
      return "Tag the farms that this user can handle.";
    },
    apiKeyDescription: function apiKeyDescription() {
      return "Attach on header as 'x-api-key' field. Can be used to access various api endpoints.";
    }
  },
  ready: function ready() {
    // init popover details
    this.initializePopovers();
  }
};

},{"babel-runtime/helpers/defineProperty":36}],896:[function(require,module,exports){
"use strict";

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Filterable = {
  data: function data() {
    return {
      itemsLoaded: 1,
      disableLoadMore: false,
      filters: {},
      filterRules: {},
      totalItems: null,
      searchQuery: "",
      searchFields: [],
      currentSort: "created_at",
      currentOrder: "desc"
    };
  },
  watch: {
    filters: {
      handler: function handler() {
        this.itemsLoaded = 0;
        this.disableLoadMore = false;
        this.loadMore();
      },
      deep: true
    },
    searchQuery: function searchQuery() {
      this.itemsLoaded = 0;
      this.disableLoadMore = false;
      this.loadMore();
    },
    filterRanges: {
      handler: function handler(newValue) {
        _.each(newValue, function (value, key) {
          if (value && value[0] && value[1]) {
            this.filters[key]["from"] = value[0].format(App.dateFormat);
            this.filters[key]["to"] = value[1].format(App.dateFormat);
          } else {
            this.filters[key]["from"] = this.filters[key]["to"] = null;
          }
        }.bind(this));
      },
      deep: true
    }
  },
  computed: {
    /**
     * Check if data is filtered
     */
    isFiltered: function isFiltered() {
      return this.type || this.category || this.searchQuery || this.daterange && this.daterange.length;
    },
    pages: function pages() {
      // set a minimum of 1 page
      var maxPages = this.totalPages > 0 ? this.totalPages : 1;
      var pages = [];
      while (maxPages > 0) {
        var page = {
          title: maxPages,
          isActive: this.page == maxPages
        };
        pages.push(page);

        maxPages--;
      }

      return pages.reverse();
    }
  },
  methods: {
    filteredItems: function filteredItems(item) {
      return this.$eval(item + " | filterBy itemFilter");
    },
    itemFilter: function itemFilter(item) {
      var passed = true;
      var searchPassed = false;
      _.each(this.filters, function (value, key) {
        // pregant filter
        if (passed && value != null && this.filterRules[key] === "bool") {
          if (item.pregnant != value || item.sex !== "doe") {
            passed = false;
          }
        }
        // pregant filter end
        if (passed && value && this.filterRules[key] === "number") {
          if (item[key]) {
            if (item[key] != value) {
              passed = false;
            }
          } else {
            passed = false;
          }
        }
        if (passed && value && this.filterRules[key] === "string") {
          if (item[key]) {
            var testKey = item[key].toString();
            if (testKey.toLowerCase().indexOf(value.toLowerCase()) === -1) {
              passed = false;
            }
          } else {
            passed = false;
          }
        }
        if (passed && this.filterRules[key] === "daterange") {
          if (value.from) {
            if (!item[key] || App.parseMoment(item[key]).isBefore(value.from)) {
              passed = false;
            }
          }
          if (value.to) {
            if (!item[key] || App.parseMoment(item[key]).isAfter(value.to)) {
              passed = false;
            }
          }
        }
        if (passed && this.filterRules[key] === "daterangepicker") {
          if (value[0]) {
            if (!item[key] || App.parseMoment(item[key]).isBefore(value[0])) {
              passed = false;
            }

            if (!item[key] || App.parseMoment(item[key]).isAfter(value[1])) {
              passed = false;
            }
          }
        }
        if (passed && (0, _typeof3.default)(this.filterRules[key]) === "object" && this.filterRules[key].type === "relation") {
          var filter = this.filterRules[key];
          if (value) {
            if (item[filter.relationName] instanceof Array && !item[filter.relationName].length) {
              passed = false;
            } else {
              var relationPassed = false;
              if (item[filter.relationName] instanceof Array) {
                _.each(item[filter.relationName], function (relationItem) {
                  if (this.checkRelation(key, relationItem, filter, value)) {
                    relationPassed = true;
                  }
                }.bind(this));
              } else {
                relationPassed = this.checkRelation(key, item[filter.relationName], filter, value);
              }
              if (!relationPassed) {
                passed = false;
              }
            }
          }
        }
      }.bind(this));

      if (this.searchQuery && !this.searchFields.includes("skipSearchFilter")) {
        _.each(this.searchFields, function (key) {
          if (key.indexOf(".") !== -1) {
            key = key.split(".");

            if (item[key[0]] && item[key[0]][key[1]] && item[key[0]][key[1]].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1) {
              searchPassed = true;
            }
          } else if (item[key] && item[key].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1) {
            searchPassed = true;
          }
        }.bind(this));
      } else {
        searchPassed = true;
      }

      return passed && searchPassed;
    },


    resetFilter: function resetFilter() {
      _.each(this.filters, function (value, key) {
        if (value && (this.filterRules[key] === "string" || this.filterRules[key] === "number" || (0, _typeof3.default)(this.filterRules[key]) === "object")) {
          this.filters[key] = "";
        }
        if (this.filterRules[key] === "daterange") {
          this.filters[key].from = null;
          this.filters[key].to = null;
        }
        if (this.filterRules[key] === "bool") {
          this.filters[key] = null;
        }
      }.bind(this));
      _.each(this.filterRanges, function (value, key) {
        this.filterRanges[key] = null;
      }.bind(this));
    },

    mergeByProperty: function mergeByProperty(arr1, arr2, prop) {
      _.each(arr2, function (arr2obj) {
        var arr1obj = _.find(arr1, function (arr1obj) {
          return arr1obj[prop] === arr2obj[prop];
        });

        //If the object already exist extend it with the new values from arr2, otherwise just add the new object to arr1
        arr1obj ? _.extend(arr1obj, arr2obj) : arr1.push(arr2obj);
      });
    },

    loadMore: function loadMore() {
      //implement
    },

    checkRelation: function checkRelation(key, relationItem, filter, value) {
      if (filter.relationField) {
        if (relationItem[filter.relationField] == key && this.checkValue(value, filter, relationItem)) {
          return true;
        }
      } else if (this.checkValue(value, filter, relationItem)) {
        return true;
      }
      return false;
    },

    checkValue: function checkValue(value, filter, relationItem) {
      if (filter.valueType === "number") {
        return relationItem[filter.relationFilterField] == value;
      }
      return relationItem[filter.relationFilterField].toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },

    /**
     * NEW FILTERING METHODS
     */

    /**
     * Update sort/order values
     *
     * @param {string} value
     */
    changeOrder: function changeOrder(value) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (value.indexOf("|") > -1) {
        // set for old code
        this.order = value;

        value = value.split("|")[0];
      }

      if (order) {
        this.currentOrder = order;
      } else {
        if (value == this.currentSort) {
          this.currentOrder = this.currentOrder == "asc" ? "desc" : "asc";
        } else {
          this.currentOrder = "desc";
        }
      }

      this.currentSort = value;

      // set for old code
      this.order = this.currentSort + "|" + this.currentOrder;
    },
    /**
     * Check if sort value is active
     * @param {string} value
     */
    isSortActive: function isSortActive(value) {
      return this.currentSort == value ? "active" : "";
    },
    /**
     * Check if order value is ascending (return icon class)
     */
    isOrderAscending: function isOrderAscending() {
      return this.currentOrder == "asc" ? "fa-caret-up" : "fa-caret-down";
    },
    /**
     * Reset all filters
     *
     * @param {string} type
     */
    clearFilters: function clearFilters(type) {
      if (type == "ledger") {
        this.searchQuery = "";
        this.daterange = [];
        this.$router.go({ path: "/ledger" });
      }
    },
    /**
     * Generate filter description
     * TODO: optimize
     */
    getFilterDescription: function getFilterDescription() {
      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ledger";

      var models = {
        ledger: "transactions",
        contact: "contacts"
      };
      var description = "Showing";

      if (this.type) {
        description += " <b>" + this.type + "</b> " + models[model];
      } else {
        description += " <b>all</b> " + models[model];
      }

      if (this.category) {
        var categories = ["general", "breeder", "litter"];
        description += " from <b>" + categories[this.category - 1] + "</b>";
      }

      if (this.daterange && this.daterange.length) {
        description += " between <b>" + this.dateFrom + "</b> and <b>" + this.dateTo + "</b>";
      }

      if (this.searchQuery) {
        description += ", filtered by the query: <b>" + this.searchQuery + "</b>";
      }

      return description + ".";
    },
    updatePage: function updatePage(page) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // NOTE: catch frontend bug where disabled link still triggers
      if (page == this.page || page <= 0 || page > this.totalPages) {
        return true;
      }

      this.page = page; // set new page

      if (callback) {
        callback();
      } else {
        this.updateList();
      }
    },
    updatePerPage: function updatePerPage() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

      localStorage.setItem("perPage", value);
      this.perPage = value;
    }
  }
};

},{"babel-runtime/helpers/typeof":42}],897:[function(require,module,exports){
"use strict";

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _eventBus = require("../event-bus");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Generic = {
  computed: {
    marketplaceUrl: function marketplaceUrl() {
      return App.marketplaceUrl;
    },
    isSpecial: function isSpecial() {
      return App.admin || App.isSpecial;
    },
    isAdmin: function isAdmin() {
      return App.admin;
    },
    isShowShow: function isShowShow() {
      return App.isShowShow;
    },
    isAndroid: function isAndroid() {
      return App.isInAppUserAndroid;
    },
    isShowButcher: function isShowButcher() {
      return App.isShowButcher;
    },
    isSubUser: function isSubUser() {
      return App.isSubUser;
    },
    childColSpan: function childColSpan() {
      var count = 1; // set initially as 1 (actions column)
      _.each(this.displayItems, function (item) {
        if (item) {
          count++;
        }
      });

      return count;
    },
    globalSuffix: function globalSuffix() {
      return this.isGlobal ? "-global" : "";
    },
    isBirthCertificate: function isBirthCertificate() {
      return App.isBirthCertificate;
    },
    isLineBreedingCoi: function isLineBreedingCoi() {
      return App.isLineBreedingCoi;
    }
  },
  methods: (0, _defineProperty3.default)({
    updatePage: function updatePage(page) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // NOTE: catch frontend bug where disabled link still triggers
      if (page == this.page || page <= 0 || page > this.totalPages) {
        return true;
      }

      this.page = page; // set new page

      if (callback) {
        callback();
      }
    },
    parseUnits: function parseUnits(value) {
      var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "baseline";

      var element = "";
      var values = value.split(" ");

      values.forEach(function (item) {
        if (!isNaN(item)) {
          element += item;
        } else {
          element += "<span class='unit align-" + align + "'>" + item + "</span> ";
        }
      });

      return element;
    },
    humanize: function humanize() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      return text.toLowerCase().replace("aquired", "acquired").replace(/(^|_)(\w)/g, function ($0, $1, $2) {
        return ($1 && " ") + $2.toUpperCase();
      });
    },
    capitalize: function capitalize(string) {
      return string.replace(/^./, function (match) {
        return match.toUpperCase();
      });
    },
    setUserDateFormat: function setUserDateFormat() {
      var user_id = App.user_id;

      api.getUserSettingsData(user_id).then(function (data) {
        App.dateFormat = data.user.date_format_js;
        App.dateFormatShort = data.user.date_format_js_short;
      });
    },
    hideEmptyTimeline: function hideEmptyTimeline() {
      $("ul.timeline").not(":has(li.timeline-item-container)").remove();
    },
    showBreederLimit: function showBreederLimit() {
      var withContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (App.isInAppUSer === true) {
        _eventBus2.default.$emit("in-app-apple-upgrade-subscription");
      } else {
        if (withContent) this.limitContent = withContent;
        $("#breeder-limit-alert").modal("show");
      }
    },
    getTreatmentWeightType: function getTreatmentWeightType() {
      var weightType = App.weight_slug;
      switch (weightType) {
        case "lbs-oz":
          weightType = "lbs";
          break;
        case "g":
          weightType = "grams";
          break;
      }

      return weightType;
    },
    getWithdrawalPeriod: function getWithdrawalPeriod(treatment) {
      if (treatment.withdrawal_type && treatment.withdrawal_value) {
        return treatment.withdrawal_value + " " + treatment.withdrawal_type;
      }

      return "0 days";
    },
    getStatusClass: function getStatusClass(status) {
      // default to cured
      var className = "label-success";

      switch (status) {
        case "active":
          className = "label-warning";
          break;
        case "suspended":
          className = "label-danger";
          break;
      }

      return className;
    },
    isShowPage: function isShowPage(page, activePage, total) {
      if (page == activePage) return true;
      if (total <= 12) return true;
      if (page <= 3 || total - page < 3) return true;
      if (page > 3 && total - page >= 3) {
        var absPage = Math.abs(activePage - page);
        if (absPage <= 2) {
          return true;
        }
      }

      return false;
    },
    pluralCheck: function pluralCheck(string, value) {
      if (value == 1) {
        return string.substring(0, string.length - 1);
      }

      return string;
    },

    /**
     * Custom calculation whether or not to show the ellipsis on pagination
     */
    isShowEllipsis: function isShowEllipsis(page, activePage, total) {
      var before = this.isShowPage(page - 1, activePage, total);
      var after = this.isShowPage(page, activePage, total);

      return !before && after || before && !after;
    }
  }, "getTreatmentWeightType", function getTreatmentWeightType() {
    var weightType = App.weight_slug;
    switch (weightType) {
      case "lbs-oz":
        weightType = "lbs";
        break;
      case "g":
        weightType = "grams";
        break;
    }

    return weightType;
  })
};

},{"../event-bus":882,"babel-runtime/helpers/defineProperty":36}],898:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Kits = {
  data: function data() {
    return {};
  },

  methods: {
    isButchered: function isButchered(kit) {
      return kit.is_butchered == 1;
    },
    isArchived: function isArchived(kit) {
      return kit.archived == 1;
    },
    isCulled: function isCulled(kit) {
      return kit.culled == 1;
    },
    showUnarchiveModal: function showUnarchiveModal(kit) {
      this.activeKit = kit;
      $("#unarchive-breed-modal-" + this.modalUnique).modal("show");
    },
    unarchive: function unarchive() {
      var _this = this;

      $("#unarchive-breed-modal-" + this.modalUnique).modal("hide");
      api.unarchiveKit(this.activeKit).then(function () {
        _this.refreshKits();
        _this.showAlert({
          type: "success",
          text: "Successfully unarchived " + _this.activeKit.given_id
        });
      });
    },
    showUncullModal: function showUncullModal(kit) {
      this.activeKit = kit;
      $("#uncull-breed-modal-" + this.modalUnique).modal("show");
    },
    uncull: function uncull() {
      var _this2 = this;

      $("#uncull-breed-modal-" + this.modalUnique).modal("hide");
      api.uncullKit(this.activeKit).then(function () {
        _this2.refreshKits();
        _this2.showAlert({
          type: "success",
          text: "Successfully unculled " + _this2.activeKit.given_id
        });
      });
    },
    showUndoBreederModal: function showUndoBreederModal(kit) {
      this.activeKit = kit;
      $("#undo-breeder-modal-" + this.modalUnique).modal("show");
    },
    undoBreeder: function undoBreeder() {
      var _this3 = this;

      $("#undo-breeder-modal-" + this.modalUnique).modal("hide");
      api.undoBreeder(this.activeKit).then(function () {
        _this3.refreshKits();
        _this3.showAlert({
          type: "success",
          text: "Successfully undone breeder - " + _this3.activeKit.given_id
        });
      });
    },
    showMakeBreederModal: function showMakeBreederModal(kit) {
      var _this4 = this;

      api.checkBreedersLimit().then(function (data) {
        if (data.ok === true) {
          _this4.activeKit = kit;
          $("#make-breeder-modal-" + _this4.modalUnique).modal("show");
        } else {
          if (App.isInAppUSer === true) {
            EventBus.$emit("in-app-apple-upgrade-subscription");
            return false;
          } else {
            if (App.isInAppUSer === true) {
              EventBus.$emit("in-app-apple-upgrade-subscription");
              return false;
            } else {
              _this4.limitContent = data;
              $("#breeder-limit-alert").modal("show");
            }
          }
        }
      });
    },
    makeBreeder: function makeBreeder() {
      var _this5 = this;

      this.activeKit._method = "PUT";
      this.activeKit.weight_changed = 1;
      api.saveKit(this.activeKit).then(function () {
        api.makeBreeder(_this5.activeKit).then(function (res) {
          $("#make-breeder-modal-" + _this5.modalUnique).modal("hide");
          if (res.subscription.upgraded) {
            EventBus.$emit("auto-upgrade-subscription", res.subscription);
          }
          if (res.breeder.id) {
            _this5.showAlert({
              type: "success",
              text: "Successfully transformed " + _this5.activeKit.given_id + " to breeder"
            });
            _this5.$router.go({ path: "/profile/" + res.breeder.id });
          }
        });
      });
    },
    showArchiveModal: function showArchiveModal(kit) {
      this.activeKit = kit;
      $("#archive-breed-modal-" + this.modalUnique).modal("show");
    },
    archive: function archive() {
      var _this6 = this;

      $("#archive-breed-modal-" + this.modalUnique).modal("hide");
      api.archiveKit(this.activeKit).then(function () {
        _this6.refreshKits();
        _this6.showAlert({
          type: "success",
          text: "Successfully archived " + _this6.activeKit.given_id
        });
      });
    },
    showCullModal: function showCullModal(kit) {
      this.activeKit = kit;
      $("#cull-breed-modal-" + this.modalUnique).modal("show");
    },
    cull: function cull() {
      var _this7 = this;

      $("#cull-breed-modal-" + this.modalUnique).modal("hide");
      api.cullKit(this.activeKit).then(function () {
        _this7.refreshKits();
        _this7.showAlert({
          type: "success",
          text: "Successfully culled " + _this7.activeKit.given_id
        });
      });
    },

    /**
     * (START) New sell/transfer flow
     * NOTE: to be transferred to exploitable->sections
     */
    showSoldModal: function showSoldModal(kit) {
      this.activeKit = kit;
      $("#sold-breed-modal-" + this.modalUnique).modal("show");
    },
    closeSoldModal: function closeSoldModal() {
      this.transferErrors = {};
      this.transferTo = "";
      this.soldValue = 0;
      $("#sold-breed-modal-" + this.modalUnique).modal("hide");
      this.refreshKits();
      this.showAlert({
        type: "success",
        text: "Successfully sold/transferred " + this.activeKit.given_id
      });
    },
    sold: function sold() {
      var _this8 = this;

      // add checker if sold to field has value
      if (this.transferTo && this.transferTo != "add") {
        // verify if the email is valid
        api.verifyTransferableKit(this.activeKit, this.transferTo).then(function () {
          // show confirm transfer modal
          $("#sold-breed-modal-" + _this8.modalUnique).modal("hide");
          $("#confirm-transfer-breed-modal-" + _this8.modalUnique).modal("show");
        }, function (error) {
          // show errors on form
          _this8.transferErrors = error.data.errors;
        });
      } else {
        // sell kit directly if sold to field is empty
        api.sellKit(this.activeKit, this.soldValue).then(function () {
          _this8.closeSoldModal();
        });
      }
    },
    confirmTransfer: function confirmTransfer() {
      var _this9 = this;

      // hide confirm transfer modal
      $("#confirm-transfer-breed-modal-" + this.modalUnique).modal("hide");

      // sell kit
      api.sellKit(this.activeKit, this.soldValue).then(function () {
        // transfer kit to new owner
        api.transferKit(_this9.activeKit, _this9.transferTo).then(function () {
          _this9.closeSoldModal();
        }, function (response) {
          _this9.transferErrors = response.data.errors;
          _this9.unconfirmTransfer();
        });
      });
    },
    unconfirmTransfer: function unconfirmTransfer() {
      $("#confirm-transfer-breed-modal-" + this.modalUnique).modal("hide");
      $("#sold-breed-modal-" + this.modalUnique).modal("show");
    },

    /**
     * (END) New sell/transfer flow
     */
    declineTransfer: function declineTransfer() {
      var _this10 = this;

      $("#decline-transfer-breed-modal-" + this.modalUnique).modal("hide");
      api.declineTransfer(this.activeModel).then(function () {
        _this10.refreshKits();
        _this10.showAlert({
          type: "success",
          text: "Successfully declined transfer - " + _this10.activeKit.given_id
        });
      });
    },
    showUnsoldModal: function showUnsoldModal(kit) {
      this.activeKit = kit;
      $("#unsold-breed-modal-" + this.modalUnique).modal("show");
    },
    unsold: function unsold() {
      var _this11 = this;

      $("#unsold-breed-modal-" + this.modalUnique).modal("hide");
      api.unsellKit(this.activeKit).then(function () {
        _this11.refreshKits();
        _this11.showAlert({
          type: "success",
          text: "Successfully unsold - " + _this11.activeKit.given_id
        });
      });
    },
    showDeleteModal: function showDeleteModal(kit) {
      this.activeKit = kit;
      $("#delete-breed-modal-" + this.modalUnique).modal("show");
    },
    delete: function _delete() {
      var _this12 = this;

      $("#delete-breed-modal-" + this.modalUnique).modal("hide");
      api.deleteKit(this.activeKit).then(function () {
        _this12.refreshKits();
        _this12.showAlert({
          type: "success",
          text: "Successfully deleted " + _this12.activeKit.given_id
        });
      });
    },
    showDiedModal: function showDiedModal(kit) {
      this.activeKit = kit;
      $("#died-modal-" + this.deathModalUnique).modal("show");
    },
    died: function died() {
      var _this13 = this;

      api.dieKit(this.activeKit).then(function () {
        $("#died-modal-" + _this13.deathModalUnique).modal("hide");
        // save death reason
        _this13.newDeathReason = _this13.reasonValue;
        _this13.deathKitId = _this13.activeKit.id;
        _this13.type = "kit";
        _this13.addNewReason();
        _this13.sendReasonValue();
        _this13.showAlert({
          type: "success",
          text: "Successfully marked " + _this13.activeKit.given_id + " as dead"
        });
      });
    },

    /**
     * Butcher a single kit
     */
    butcherModal: function butcherModal(kit) {
      this.activeKit = kit;
      this.$dispatch("butcher-kit", this.activeKit);
    },
    undoButcherModal: function undoButcherModal(kit) {
      this.activeKit = kit;
      $("#undo-butcher-breed-modal-" + this.modalUnique).modal("show");
    },
    undoButcher: function undoButcher() {
      var _this14 = this;

      $("#undo-butcher-breed-modal-" + this.modalUnique).modal("hide");

      /* Commented because isCage is not found */
      // let litter = this.isCage ? this.activeKit.litter : this.litter
      var litter = this.activeKit.litter ? this.activeKit.litter : this.litter;
      var data = {
        kits: [this.activeKit],
        litter_id: litter.id
      };

      api.undoButcheredKits(litter, data).then(function () {
        _this14.$dispatch("refresh-kits");
        _this14.showAlert({
          type: "success",
          text: "Successfully undone butcher - " + _this14.activeKit.given_id
        });
      });
    },
    redirectToBreeder: function redirectToBreeder(kit) {
      var path = kit.breeder ? "/profile/" + kit.breeder.id : "/breeders";

      this.$router.go({
        path: path
      });
    },
    redirectToLitter: function redirectToLitter(kit) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "original_litter_id";

      var path = kit[type] ? "/litterprofile/" + kit[type] : "/litters";
      var isRefresh = this.$route.name == "Litter Profile";

      this.$router.go({
        path: path
      });

      if (isRefresh) {
        window.location.reload();
      }
    },
    getStatus: function getStatus(kit) {
      var status = "Active";
      var butchered = this.isButchered(kit);

      if (kit.foster) status = "Fostered";
      if (kit.culled) status = "Culled";
      if (kit.sold_at) status = "Sold";
      if (kit.improved) status = "Transformed to Breeder";
      if (butchered) status = "Butchered";
      if (kit.archived) status = "Archived";
      if (kit.for_sale) status = "For Sale";
      if (kit.death_reason && kit.alive == 0 && !butchered && !kit.culled) status = "Dead";

      return status;
    },
    getStatusIcon: function getStatusIcon(kit) {
      var icon = "fa-font bg-primary-v2";
      var butchered = this.isButchered(kit);

      if (kit.foster) icon = "fa-copy bg-info-v2";
      if (kit.culled) icon = "fa-cut bg-warning-v2";
      if (kit.sold_at) icon = "fa-dollar bg-primary-v2";
      if (kit.improved) icon = "fa-venus-mars bg-info-v2";
      if (butchered) icon = "fa-cutlery bg-danger-v2";
      if (kit.archived) icon = "fa-archive bg-secondary-v2";
      if (kit.for_sale) icon = "fa-dollar bg-primary-v2";
      if (kit.death_reason && kit.alive == 0 && !butchered && !kit.culled) icon = "fa-skull bg-danger-v2";

      return icon;
    }
  },
  mixins: [App.Mixins.Alerts, App.Mixins.DeathReason]
};

},{}],899:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Litters = {
  data: function data() {
    return {
      allLitters: []
    };
  },

  methods: {
    // check if litter is active
    isLitterActive: function isLitterActive(litter) {
      return !litter.butchered && !litter.archived;
    },
    father: function father(parents) {
      return _.find(parents, function (item) {
        return item.sex == "buck";
      });
    },
    mother: function mother(parents) {
      return _.find(parents, function (item) {
        return item.sex == "doe";
      });
    },
    loadLittersSelection: function loadLittersSelection() {
      var _this = this;

      api.getLittersList({ all: 1 }).then(function (data) {
        _this.allLitters = data;
      });
    },
    parseLitterNoteDate: function parseLitterNoteDate(value) {
      var notes = this.litter.new_notes || [];
      var note = _.find(notes, function (note) {
        return note.value == value;
      });

      return note ? moment(note.date, 'YYYY-MM-DD').format(App.dateFormat) : moment(this.litter.created_at).format(App.dateFormat);
    }
  },
  ready: function ready() {
    this.loadLittersSelection();
  }
};

},{}],900:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Photos = {
  data: function data() {
    return {
      dropzoneOptions: {
        autoProcessQueue: false,
        maxFiles: 1,
        dictDefaultMessage: "Upload your photo"
      },
      vdropzoneOptions: {
        hideProgress: true
      }
    };
  },

  methods: {
    addPhoto: function addPhoto() {
      this.$broadcast("add-photo");
    },
    cropPhoto: function cropPhoto(file) {
      this.$broadcast("crop-photo", file);
      if (this.$refs.vdropzone) {
        this.$refs.vdropzone.removeFiles();
      }
    }
  }
};

},{}],901:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      refs: [],
      referral: "",
      referralErrors: {},
      referred_by: "",
      referrer: "",
      referrerErrors: {},
      referralSent: false,
      referralsCredit: 0,
      loadingReferrals: false
    };
  },

  methods: {
    addReferral: function addReferral() {
      var _this = this;

      this.referralSent = false;
      api.addReferral(this.referral).then(function () {
        _this.referralSent = true;
        _this.referralErrors = {};
        _this.referral = "";
        _this.loadReferralsData();
      }, function (response) {
        _this.referralErrors = response.data.errors;
      });
    },
    setReferrer: function setReferrer() {
      var _this2 = this;

      api.validateReferrer(this.referrer).then(function () {
        _this2.referrerErrors = {};
        $("#referred-by-modal").modal("show");
      }, function (response) {
        _this2.referrerErrors = response.data.errors;
      });
    },
    cancelReferrer: function cancelReferrer() {
      $("#referred-by-modal").modal("hide");
      this.referrer = "";
    },
    saveReferrer: function saveReferrer() {
      var _this3 = this;

      $("#referred-by-modal").modal("hide");
      api.updateReferrer(this.referrer).then(function () {
        _this3.loadReferralsData();
        _this3.referrerErrors = {};
        _this3.referrer = "";
      }, function (response) {
        _this3.referrerErrors = response.data.errors;
      });
    },
    loadReferralsData: function loadReferralsData() {
      var _this4 = this;

      this.loadingReferrals = true;
      api.getUserReferrals().then(function (data) {
        _this4.refs = data.referrals;
        _this4.referred_by = data.referred_by;
        _this4.referralsCredit = data.referrals_credit;
        _this4.loadingReferrals = false;

        _this4.$nextTick(function () {
          if (_this4.refs.length) {
            $("#referrals-table").DataTable({
              language: {
                paginate: {
                  next: "&raquo;",
                  previous: "&laquo;"
                }
              },
              columns: [{ type: "html" }, { type: "html" }, { type: "date" }, { type: "html" }],
              order: [[2, "desc"]]
            });
          }
        });
      });
    },
    getReferralStatusLabel: function getReferralStatusLabel(status) {
      var text = status.toLowerCase();
      var label = "label-success";

      if (text.includes("trial") || text.includes("canceled")) {
        label = "label-warning";
      }

      return label;
    },
    clearReferralSent: function clearReferralSent() {
      this.referralSent = false;
    }
  },
  created: function created() {
    if (this.$route.query.referrer) {
      var referrer = this.$route.query.referrer;
      this.$router.go({ path: "/account" });
      this.referrer = referrer;
      this.setReferrer();
    }
    this.loadReferralsData();
  }
};

},{}],902:[function(require,module,exports){
'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!App.Mixins) {
    App.Mixins = {};
}

App.Mixins.Reports = {
    data: function data() {
        return {
            production: {
                littersPerBreeder: 4
            }
        };
    },
    methods: {
        buildProductionData: function buildProductionData(does) {
            var _this = this;

            var datasets = [];
            var arrWeightDates = [];

            _.each(does, function (doe, index) {
                if (_this.filterByDoeID && _this.filterByDoeID != doe.id) {
                    return;
                }

                _.each(doe.litters, function (litter, key) {
                    var dataset = {};
                    var allLittersWeighs = [];
                    var litterProduction = litter.production[_this.productionFilter];

                    if (litterProduction.weightSum.length) {
                        for (var i = 0; i < litterProduction.weightSum.length; i++) {
                            var weights = {
                                x: litterProduction.datesMax[i],
                                y: litterProduction.weightSum[i],
                                litter: litter.given_id,
                                litterId: litter.id
                            };

                            allLittersWeighs.push(weights);
                        }
                    }

                    if (litterProduction.datesMax.length) {
                        _.each(litterProduction.datesMax, function (d) {
                            if (d !== 0 && d != null) {
                                arrWeightDates.push(d);
                            }
                        });
                    }

                    dataset.data = allLittersWeighs;
                    dataset.label = 'weight';
                    dataset.fill = false;
                    dataset.id = 'xAxis1';

                    // for all view, use doe as key
                    var colorKey = _this.filterByDoeID ? key : index;
                    _.extend(dataset, Chart.defaults.global.colours[colorKey % Chart.defaults.global.colours.length]); //set colors

                    dataset.lineTension = 0.1;
                    datasets.push(dataset);
                });
            });

            return {
                labels: [],
                datasets: datasets,
                max: Math.max.apply(Math, arrWeightDates)
            };
        },

        getProductionData: function getProductionData(does) {
            var _this2 = this;

            var datasets = [];
            var labels = [];
            var arrWeightDates = [];

            _.each(does, function (doe) {
                var dataset = {};
                var allLittersWeighs = [];

                _.each(doe.litters, function (litter, key) {
                    if (key < _this2.production.littersPerBreeder) {
                        var litterProduction = _this2.calculateLitterProduction(litter);

                        if (litterProduction.weightSum.length) {
                            for (var i = 0; i < litterProduction.weightSum.length; i++) {
                                allLittersWeighs.push({
                                    x: litterProduction.datesMax[i],
                                    y: litterProduction.weightSum[i],
                                    litter: 'Litter ' + litter.given_id,
                                    litterId: litter.id
                                });
                            }
                        }

                        if (litterProduction.datesMax.length) {
                            _.each(litterProduction.datesMax, function (d) {
                                if (d !== 0 && d != null) {
                                    arrWeightDates.push(d);
                                }
                            });
                        }
                    }
                });

                dataset.data = allLittersWeighs;
                dataset.label = 'weight';
                dataset.fill = false;
                dataset.id = 'xAxis1';

                var doeExternalKey = _.findIndex(does, function (externalDoe) {
                    return externalDoe.id === doe.id;
                });
                _.extend(dataset, Chart.defaults.global.colours[doeExternalKey % Chart.defaults.global.colours.length]); //set colors

                dataset.lineTension = 0.1;
                datasets.push(dataset);
            });

            var maxDate = _.max(arrWeightDates);
            for (var i = 0; i <= maxDate; i++) {
                labels.push(i);
            }

            return {
                labels: labels,
                datasets: datasets
            };
        },
        getBreederProductionData: function getBreederProductionData(litters) {
            var _this3 = this;

            var datasets = [];

            _.each(litters, function (litter, key) {
                var allLittersWeighs = [];

                var litterProduction = _this3.calculateLitterProduction(litter);

                if (litterProduction.weightSum.length) {
                    for (var i = 0; i < litterProduction.weightSum.length; i++) {
                        allLittersWeighs.push({
                            x: litterProduction.datesMax[i],
                            y: litterProduction.weightSum[i],
                            title: 'Litter ' + litter.given_id,
                            litterData: litter,
                            view: 'litter'
                        });
                    }
                }

                var dataset = {
                    label: "weight",
                    data: allLittersWeighs,
                    fill: false,
                    id: 'xAxis1',
                    lineTension: 0.1
                };

                var litterExternalKey = _.findIndex(litters, function (externalLitter) {
                    return externalLitter.id === litter.id;
                });
                _.extend(dataset, Chart.defaults.global.colours[litterExternalKey % Chart.defaults.global.colours.length]); //set colors

                datasets.push(dataset);
            });

            return {
                labels: [],
                datasets: datasets
            };
        },
        getLitterProductionData: function getLitterProductionData(litter) {
            var datasets = [];

            var dateFormat = litter.user ? litter.user.date_format_js : 'DD/MM/YYYY';

            var born = moment(litter.born, dateFormat);

            _.each(litter.survived_kits, function (kit) {
                if (!kit.weight) {
                    return;
                }

                if (!kit.weight_date) {
                    kit.weight_date = Array.apply(null, Array(kit.weight.length));
                }

                var data = [];

                for (var i = 0; i < kit.weight.length; i++) {
                    var weightDate = null;

                    if (kit.weight_date[i]) {
                        weightDate = kit.weight_date[i];
                    } else {
                        weightDate = born.clone();
                        weightDate.add(1, 'days');
                    }

                    var daysDiff = Math.abs(born.diff(moment(weightDate), 'days'));
                    if (isNaN(daysDiff)) {
                        daysDiff = i > 0 ? kit.weight_date[i - 1] + 7 : 7;
                    }

                    data.push({
                        x: daysDiff,
                        y: kit.weight[i],
                        title: 'Kit ' + kit.given_id,
                        view: 'kit'
                    });
                }

                data.push({
                    x: 0,
                    y: 0,
                    title: 'Kit ' + kit.given_id,
                    view: 'kit'
                });

                data = _.sortBy(data, 'x').reverse();

                var dataset = {
                    label: "weight",
                    data: data,
                    fill: false,
                    id: 'xAxis1',
                    lineTension: 0.1
                };

                var kitExternalKey = _.findIndex(litter.survived_kits, function (externalKit) {
                    return externalKit.id === kit.id;
                });
                _.extend(dataset, Chart.defaults.global.colours[kitExternalKey % Chart.defaults.global.colours.length]); //set colors

                datasets.push(dataset);
            });

            return {
                labels: [],
                datasets: datasets
            };
        },
        calculateLitterProduction: function calculateLitterProduction(litter) {
            var weightSum = [];
            var datesMax = [];

            var weights = [];
            var dates = [];

            var dateFormat = litter.user ? litter.user.date_format_js : 'DD/MM/YYYY';

            var born = moment(litter.born, dateFormat);

            _.each(litter.survived_kits, function (kit) {
                if (kit.weight) {
                    weights.push(kit.weight);
                    if (kit.weight_date) {
                        dates.push(kit.weight_date);
                    } else {
                        dates.push(Array.apply(null, Array(kit.weight.length)));
                    }
                }
            });

            for (var i = 0; i < weights.length; i++) {
                for (var j = 0; j < weights[i].length; j++) {
                    if (typeof weightSum[j] === 'undefined') {
                        weightSum[j] = 0.0;
                    }
                    if (typeof datesMax[j] === 'undefined') {
                        datesMax[j] = 0.0;
                    }
                    weightSum[j] += parseFloat(weights[i][j]);
                    weightSum[j] = parseFloat(weightSum[j].toFixed(2));

                    if (dates[i][j] == null) {
                        dates[i][j] = born.clone();
                        dates[i][j].add(1, 'days');
                    }
                    var daysDiff = Math.abs(born.diff(moment(dates[i][j]), 'days'));
                    if (isNaN(daysDiff)) {
                        daysDiff = j > 0 ? datesMax[j - 1] + 7 : 7;
                    }
                    datesMax[j] = daysDiff;
                }
            }

            weightSum.unshift(0);
            datesMax.unshift(0);

            /**
             * Add proper data presentation/sorting on litter age to weights graph
             */
            var finalData = [];
            datesMax.forEach(function (item, key) {
                finalData.push({
                    weight: weightSum[key],
                    date: datesMax[key]
                });
            });

            finalData.sort(function (a, b) {
                return a.date - b.date;
            });

            var finalWeights = [];
            var finalDates = [];
            finalData.forEach(function (item) {
                finalWeights.push(item.weight);
                finalDates.push(item.date);
            });

            // fix bug where the end of line graph returns back to 0
            // need to set it to null so it gets cut off
            finalWeights.push(null);

            return {
                weightSum: finalWeights,
                datesMax: finalDates
            };
        },
        getAvgKitWeightPerLitterData: function getAvgKitWeightPerLitterData(weightData) {
            var data = [],
                labels = [],
                datasets = [];

            if (weightData.avgLitterWeight > 0) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(weightData.litters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var litter = _step.value;

                        if (litter.avgKitWeight > 0) {
                            data.push({
                                name: 'Litter ' + litter.given_id,
                                weight: Math.round(litter.avgKitWeight * 100) / 100,
                                color: Chart.defaults.global.colours[data.length % Chart.defaults.global.colours.length]
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            if (!_.isEmpty(data)) {
                data = _.sortBy(data, 'weight').reverse();

                labels = _.map(data, 'name');

                datasets = [{
                    label: "Avg. Kit Weight",
                    data: _.map(data, 'weight'),
                    backgroundColor: _.map(data, function (d) {
                        return d.color.backgroundColor;
                    }),
                    borderColor: _.map(data, function (d) {
                        return d.color.borderColor;
                    }),
                    borderWidth: 1,
                    hoverBackgroundColor: _.map(data, function (d) {
                        return d.color.hoverBackgroundColor;
                    }),
                    hoverBorderColor: _.map(data, function (d) {
                        return d.color.hoverBorderColor;
                    })
                }];
            }

            return {
                labels: labels,
                datasets: datasets
            };
        }
    },
    created: function created() {}
};

},{"babel-runtime/core-js/get-iterator":18}],903:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            socials: [],
            socialError: ''
        };
    },

    methods: {
        disconnectSocial: function disconnectSocial(social_id) {
            var _this = this;

            api.disconnectSocial(social_id).then(function () {
                _this.loadSocials();
                _this.socialError = '';
            }, function (response) {
                _this.socialError = response.data.error;
            });
        },
        loadSocials: function loadSocials() {
            var _this2 = this;

            if (App.isSubscribed) {
                api.getUserSocialAccounts().then(function (accounts) {
                    _this2.socials = accounts;
                });
            }
        }
    },
    created: function created() {
        this.loadSocials();
    }
};

},{}],904:[function(require,module,exports){
"use strict";

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Subscribes = {
  data: function data() {
    return {
      planType: null,
      currentPlan: {},
      plans: [],
      card: this.defaultCard(),
      cardErrors: {},
      cardSuccess: {},
      subscribing: false,
      successfulSubscription: false,
      discountCode: "",
      subscribingShowLoading: true,
      errorMessage: "",
      subscriptionDowngradeCount: null,
      invoices: [],
      confirmSum: {},
      updateInfo: {},
      unsubscribeData: {},
      payment_method: null,
      cancelReason: null,
      cancelDetails: null,
      is_trial: null,
      outDatedPlanId: null,
      outDatedPlanEndsAt: null,
      planPeriod: "month",
      step: "plans",
      typeForever: "forever",
      loadingInvoices: false,
      isSubscribing: false,
      currentPlanPage: false,
      isUnsubscribed: false,
      activeBreeders: [],
      forArchive: [],
      flexiblePlan: [],
      isActiveDiscount: false,
      isActivePauseSubscription: App.isPausedSubscription,
      pauseSubscriptionLoader: 0,
      resumeMyAccountLoading: 0,
      cancelMyAccountLoader: 0,
      downgradePlanLoading: 0,
      pauseSubscriptionResumesAt: App.isPauseSubscriptionResumesAt
    };
  },

  computed: {
    isExceedingLimit: function isExceedingLimit() {
      return App.isExceedingLimit;
    },
    planId: function planId() {
      return this.planType === this.typeForever ? this.planType : this.planType + "_" + this.planShortPeriod;
    },
    planShortPeriod: function planShortPeriod() {
      return this.planPeriod === "month" ? "mo" : "yr";
    },
    plan: function plan() {
      var _this = this;

      return this.plans.find(function (plan) {
        return plan.key_name == _this.planId;
      });
    },
    subscriptionChanged: function subscriptionChanged() {
      return this.planId !== this.currentPlan.id;
    },
    startPrice: function startPrice() {
      var key = "start_yr";
      if (this.planPeriod === "month") key = "start_mo";

      var selectedPlan = this.plans.find(function (plan) {
        return plan.key_name === key;
      });
      return selectedPlan.price;
    },
    growPrice: function growPrice() {
      var key = "grow_yr";
      if (this.planPeriod === "month") key = "grow_mo";

      var selectedPlan = this.plans.find(function (plan) {
        return plan.key_name === key;
      });
      return selectedPlan.price;
    },
    plusPrice: function plusPrice() {
      var key = "plus_yr";
      if (this.planPeriod === "month") key = "plus_mo";

      var selectedPlan = this.plans.find(function (plan) {
        return plan.key_name === key;
      });
      return selectedPlan.price;
    },
    maxPrice: function maxPrice() {
      var key = "max_yr";
      if (this.planPeriod === "month") key = "max_mo";

      var selectedPlan = this.plans.find(function (plan) {
        return plan.key_name === key;
      });
      return selectedPlan.price;
    },
    exclusivePrice: function exclusivePrice() {
      var key = "exclusive_yr";
      if (this.planPeriod === "month") key = "exclusive_mo";

      var selectedPlan = this.plans.find(function (plan) {
        return plan.key_name === key;
      });
      return selectedPlan.price;
    },
    startButtonTitle: function startButtonTitle() {
      return this.planButtonTitle("start_" + this.planShortPeriod);
    },
    growButtonTitle: function growButtonTitle() {
      return this.planButtonTitle("grow_" + this.planShortPeriod);
    },
    plusButtonTitle: function plusButtonTitle() {
      return this.planButtonTitle("plus_" + this.planShortPeriod);
    },
    maxButtonTitle: function maxButtonTitle() {
      return this.planButtonTitle("max_" + this.planShortPeriod);
    },
    exclusiveButtonTitle: function exclusiveButtonTitle() {
      return this.planButtonTitle("exclusive_" + this.planShortPeriod);
    },
    switchType: function switchType() {
      var _this2 = this;

      return this.planId && this.currentPlan.id && this.currentPlan.offered && this.currentPlan.max_breeders > this.plans.find(function (plan) {
        return plan.key_name === _this2.planId;
      }).max_breeders ? "downgraded" : "upgraded";
    },
    showLegacyMessage: function showLegacyMessage() {
      return this.outDatedPlanId && this.outDatedPlanEndsAt && moment(this.outDatedPlanEndsAt, "YYYY-MM-DD H:i:s").diff(Date.now()) > 0 && this.currentPlan.coupon && this.currentPlan.coupon.percent_off === 50;
    },
    outDatedPlanEndsAtFormatted: function outDatedPlanEndsAtFormatted() {
      return moment(this.outDatedPlanEndsAt, "YYYY-MM-DD H:i:s").format("ll");
    },
    currentDiscount: function currentDiscount() {
      if (!this.currentPlan.coupon) {
        if (this.cardSuccess.code) {
          return this.cardSuccess.code[0];
        }

        return "";
      }

      if (this.currentPlan.coupon.description) {
        return this.currentPlan.coupon.description;
      }

      var duration = "";

      if (this.currentPlan.coupon.duration_in_months) {
        var count = this.currentPlan.period === "month" ? this.currentPlan.coupon.duration_in_months : Math.ceil(this.currentPlan.coupon.duration_in_months / 12);

        duration = "for " + count + (this.currentPlan.period === "month" ? count === 1 ? " month" : " months" : count === 1 ? " year" : " years");
      } else {
        duration = this.currentPlan.coupon.duration;
      }

      if (this.currentPlan.coupon.percent_off) {
        return this.currentPlan.coupon.percent_off + "% off " + duration;
      }

      return "$" + this.currentPlan.coupon.amount_off + " off " + duration;
    },
    isCurrentPlanForever: function isCurrentPlanForever() {
      return this.currentPlan.id === this.typeForever;
    },
    cancelDiscountPrice: function cancelDiscountPrice() {
      var planPrice = this.plan.price || 0;
      var discountedPrice = planPrice / 2;
      return parseInt(discountedPrice * 100) / 100; // tweak so it doesn't round the result
    }
  },
  watch: {
    planPeriod: function planPeriod() {
      $(".plan-period").iCheck("update");
    }
  },
  filters: {
    date_format: function date_format(date) {
      return moment.unix(date).format(App.dateFormat);
    }
  },
  methods: {
    verifyCoupon: function verifyCoupon() {
      var _this3 = this;

      this.subscribing = true;
      api.verifyCoupon({ code: this.discountCode }).then(function (data) {
        _this3.subscribing = false;
        _this3.cardSuccess = data;
        _this3.cardErrors = {};
      }, function (response) {
        _this3.subscribing = false;
        _this3.cardErrors = response.data;
        _this3.cardSuccess = {};
      });

      // refresh subscription preview on apply
      api.previewSubscription({ plan_id: this.planId, code: this.discountCode }).then(function (data) {
        _this3.confirmSum = data;
      });
    },
    returnToPlans: function returnToPlans() {
      this.isSubscribing = false;
      this.loadCardData(true);
    },
    returnToCurrentPlan: function returnToCurrentPlan() {
      this.isSubscribing = false;
      this.currentPlanPage = true;
      this.subscribingShowLoading = false;
    },
    planButtonTitle: function planButtonTitle(planId) {
      if (!this.currentPlan.id || !this.currentPlan.offered || App.user_status == "Expired Subscription (In-App)") {
        return "Start Subscription";
      }
      if (this.currentPlan.id === planId) {
        return "Current plan";
      }
      return this.currentPlan.max_breeders > this.plans.find(function (plan) {
        return plan.key_name === planId;
      }).max_breeders ? "Downgrade" : "Upgrade";
    },
    defaultCard: function defaultCard() {
      return {
        attached: false,
        exp_month: "",
        exp_year: moment().format("YY")
      };
    },
    changeCard: function changeCard() {
      this.toCard();
      this.card = this.defaultCard();
    },
    resumePlan: function resumePlan() {
      var _this4 = this;

      this.subscribing = true;
      api.checkBreedersLimit().then(function (response) {
        if (response.count > _this4.plan.max_breeders) {
          _this4.subscriptionDowngradeCount = response.count;
          _this4.downgradeSubscriptionModal();
          return;
        }
        api.subscribe({ plan_id: _this4.currentPlan.id }).then(function (data) {
          _this4.saveUpdateInfoAndReload(data.update_info);
        }, function (response) {
          _this4.loadInvoices(false);
          _this4.subscribing = false;
          _this4.cardErrors = response.data.errors;
          if (!response.status) {
            // Internet error
            alert("Your internet connection is not working. Please try again later.");
          }
        });
      });
    },
    showUnsubscribe: function showUnsubscribe() {
      var _this5 = this;

      this.subscribing = true;
      api.unsubscribeData().then(function (response) {
        _this5.unsubscribeData = response;
        _this5.subscribing = false;
        $("#cancel-account-modal").modal("show");
      });
    },
    unsubscribe: function unsubscribe(model) {
      var _this6 = this;

      this.subscribing = false;

      if (model == "discount_model") {
        $("#cancel-account-modal").modal("hide");
        if (this.isActiveDiscount == true) {
          $("#offer-discount-modal").modal("hide");
          $("#flexible-discount-modal").modal("show");
        } else {
          $("#offer-discount-modal").modal("show");
        }
      } else if (model == "flexible_option_model") {
        $("#offer-discount-modal").modal("hide");
        $("#flexible-discount-modal").modal("show");
      } else if (model == "final_unsubscribe_model") {
        $("#flexible-discount-modal").modal("hide");
        $("#final-unsubscribe-modal").modal("show");
      } else {
        this.cancelMyAccountLoader = 1;
        api.unsubscribe({
          cancel_reason: this.cancelReason,
          cancel_details: this.cancelDetails
        }).then(function (data) {
          _this6.cancelMyAccountLoader = 0;
          _this6.saveUpdateInfoAndReload(data.update_info);
        }, function (response) {
          _this6.subscribing = false;
          _this6.cardErrors = response.data;
          _this6.cancelMyAccountLoader = 0;

          if (!response.status) {
            // Internet error
            alert("Your internet connection is not working. Please try again later.");
          }
        });
      }
    },
    beforeCancellationDowngradePlan: function beforeCancellationDowngradePlan(plan) {
      var _this7 = this;

      if (this.subscribing) return;
      this.downgradePlanLoading = 1;
      this.subscribing = true;
      api.checkBreedersLimit().then(function (response) {
        if (response.count > plan.max_breeders) {
          _this7.subscribing = false;
          return;
        }
        _this7.errorMessage = "";
        var trackSumTotal = _this7.confirmSum.total;
        if (isNaN(trackSumTotal) || trackSumTotal < 0) {
          trackSumTotal = 0;
        }

        var self = _this7;
        api.subscribe({
          payment_method: _this7.payment_method,
          plan_id: plan.key_name,
          code: null,
          confirm_sum: _this7.confirmSum.total,
          is_downgrade_during_cancelation: 1
        }).then(function (data) {
          fbq("track", "Subscribe", {
            value: trackSumTotal,
            currency: "USD",
            predicted_ltv: _this7.confirmSum.total
          });
          dataLayer.push({ event: "PaidGoal" });
          _this7.saveUpdateInfo(data.update_info);

          _this7.showAlert({
            type: 'success',
            text: "Your plan has been successfully downgraded!"
          });

          setTimeout(function () {
            document.location.reload(true);
          }, 2000);
        }, function (response) {
          _this7.subscribing = false;
          _this7.cardErrors = response.data;
          if (!response.status) {
            // Internet error
            _this7.errorMessage = "Your internet connection is not working. Please try again later.";
          } else {
            _this7.errorMessage = "It looks like your payment didn’t go through. Please check the balance on your card or try a different card.";
          }

          _this7.showAlert({
            type: 'warning',
            text: _this7.errorMessage
          });
          setTimeout(function () {
            document.location.reload(true);
          }, 1000);
        });
      });
    },
    pauseSubscription: function pauseSubscription() {
      var _this8 = this;

      this.subscribing = false;
      this.pauseSubscriptionLoader = 1;
      api.pauseSubscription().then(function (data) {
        _this8.showAlert({
          type: 'success',
          text: data.message
        });

        setTimeout(function () {
          document.location.reload(true);
        }, 1000);
      }, function (response) {
        _this8.pauseSubscriptionLoader = 0;
        _this8.showAlert({
          type: 'danger',
          text: response.data.message
        });
      });
    },
    resumeSubscription: function resumeSubscription() {
      var _this9 = this;

      this.subscribing = false;
      this.resumeMyAccountLoading = 1;
      api.resumeSubscription().then(function (data) {
        _this9.showAlert({
          type: 'success',
          text: data.message
        });

        setTimeout(function () {
          document.location.reload(true);
        }, 1000);
      }, function (response) {
        _this9.showAlert({
          type: 'danger',
          text: response.data.message
        });
      });
    },
    applyDiscount: function applyDiscount() {
      var _this10 = this;

      this.subscribing = true;
      api.addCancelDiscount(this.user_id).then(function (data) {
        _this10.showAlert({
          type: 'success',
          text: data.message
        });

        setTimeout(function () {
          document.location.reload(true);
        }, 1000);
      }, function (response) {
        _this10.subscribing = false;
        _this10.showAlert({
          type: 'danger',
          text: response.data.message
        });
      });
    },
    loadInvoices: function loadInvoices() {
      var _this11 = this;

      var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.loadingInvoices = true;
      api.getSubscriptionInvoices().then(function (invoices) {
        _this11.invoices = invoices;
        _this11.loadingInvoices = false;

        _this11.$nextTick(function () {
          if (_this11.invoices.length && initial) {
            $("#receipts-table").DataTable({
              language: {
                paginate: {
                  next: "&raquo;",
                  previous: "&laquo;"
                }
              },
              columns: [{ type: "date" }, { type: "num-fmt" }, { type: "html" }],
              order: [[0, "desc"]]
            });
          }
        });
      });
    },
    loadPlans: function loadPlans() {
      var _this12 = this;

      api.getSubscriptionPlans().then(function (plans) {
        _this12.plans = plans;
      });
    },
    showPlans: function showPlans() {
      this.currentPlanPage = false;
    },
    loadCardData: function loadCardData() {
      var _this13 = this;

      var isReturn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      api.getSubscription().then(function (data) {
        _this13.subscribingShowLoading = false;
        if (data.card) {
          _this13.card = (0, _assign2.default)(_this13.defaultCard(), data.card);
        } else {
          _this13.card = _this13.defaultCard();
        }
        _this13.isUnsubscribed = data.unsubscribed || false;
        _this13.currentPlan = data.plan;
        _this13.planType = data.plan.type;
        _this13.planPeriod = data.plan.period;
        _this13.outDatedPlanId = data.plan.outdated_plan_id;
        _this13.outDatedPlanEndsAt = data.plan.outdated_plan_ends_at;

        if (_this13.currentPlan.id && !isReturn) {
          if (App.user_status != "Expired Subscription (In-App)") {
            _this13.currentPlanPage = true;
          }
        }

        if ((0, _keys2.default)(_this13.updateInfo || {}).length) {
          _this13.$nextTick(function () {
            $("html, body").animate({
              scrollTop: 0
            }, 2000);
          });
        }
      });
    },
    subscribe: function subscribe() {
      var _this14 = this;

      if (this.subscribing) return;
      this.subscribing = true;
      api.checkBreedersLimit().then(function (response) {
        if (response.count > _this14.plan.max_breeders) {
          _this14.subscribing = false;
          _this14.subscriptionDowngradeCount = response.count;
          $("#preview-subscription-modal").modal("hide");
          _this14.downgradeSubscriptionModal();
          return;
        }
        _this14.errorMessage = "";

        var trackSumTotal = _this14.confirmSum.total;
        if (isNaN(trackSumTotal) || trackSumTotal < 0) {
          trackSumTotal = 0;
        }

        var self = _this14;
        api.subscribe({
          payment_method: _this14.payment_method,
          plan_id: _this14.planId,
          code: _this14.discountCode,
          confirm_sum: _this14.confirmSum.total
        }).then(function (data) {
          fbq("track", "Subscribe", {
            value: trackSumTotal,
            currency: "USD",
            predicted_ltv: _this14.confirmSum.total
          });
          dataLayer.push({ event: "PaidGoal" });
          if (_this14.is_trial == "Y") {
            _this14.is_trial = "N";

            /*ga("send", "event", "Paid", this.planId, trackSumTotal, {
              hitCallback() {
                self.saveUpdateInfoAndReload(data.update_info);
              },
            });*/

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'purchase', 'currency': 'USD', 'value': trackSumTotal, 'plan': _this14.planId,
              'eventCallback': function eventCallback() {
                self.saveUpdateInfoAndReload(data.update_info);
              }
            });
          } else {
            self.saveUpdateInfoAndReload(data.update_info);
          }
        }, function (response) {
          _this14.subscribing = false;
          _this14.cardErrors = response.data;
          if (!response.status) {
            // Internet error
            _this14.errorMessage = "Your internet connection is not working. Please try again later.";
          } else {
            _this14.errorMessage = "It looks like your payment didn’t go through. Please check the balance on your card or try a different card.";
          }

          $("#updated-subscription-preview-modal").modal("hide");
          $("#updated-subscription-error-modal").modal("show");
        });
      });
    },
    submitSubscription: function submitSubscription() {
      if (this.card && this.card.attached) {
        this.previewUpdatedSubscription();
      } else {
        this.processCardSubscription(true);
      }
    },
    previewUpdatedSubscription: function previewUpdatedSubscription() {
      var _this15 = this;

      this.subscribing = true;

      api.previewSubscription({ plan_id: this.planId, code: this.discountCode }).then(function (data) {
        _this15.confirmSum = data;
        _this15.subscribing = false;
        $("#updated-subscription-preview-modal").modal({
          backdrop: "static",
          keyboard: false
        });
      }, function (response) {
        _this15.subscribing = false;
        _this15.cardErrors = response.data;
        if (!response.status) {
          // Internet error
          alert("Your internet connection is not working. Please try again later.");
        }
      });
    },
    subscribeWithPreview: function subscribeWithPreview() {
      var _this16 = this;

      api.previewSubscription({ plan_id: this.planId, code: this.discountCode }).then(function (data) {
        _this16.confirmSum = data;
        _this16.subscribing = false;
        $("#preview-subscription-modal").modal("show");

        _this16.isSubscribing = true;

        if (!_this16.card.attached || _this16.isUnsubscribed) {
          _this16.toggleChangeCard();
        }

        _this16.$nextTick(function () {
          cardElement.mount("#card-element");
        });
      }, function (response) {
        _this16.subscribing = false;
        _this16.cardErrors = response.data;
        if (!response.status) {
          // Internet error
          alert("Your internet connection is not working. Please try again later.");
        }
      });
    },
    processSubscriptionToken: function processSubscriptionToken(preview, code, result) {
      switch (code) {
        case 200:
          this.payment_method = result.id;
          if (preview) {
            this.previewUpdatedSubscription();
          } else {
            this.subscribing = false; // @XXX must have
            this.subscribe();
          }
          return;
        case 402:
          var param;
          switch (result.error.param) {
            case "exp_month":
            case "exp_year":
              param = "expiration";
              break;
            default:
              param = result.error.param;
          }
          this.subscribing = false;
          this.$set("cardErrors." + param, [result.error.message]);
          return;
        default:
          this.subscribing = false;
          this.cardErrors.number = ["Unknown error"];
      }
    },
    validate: function validate() {
      this.cardErrors = {};
      if (!this.planType) {
        this.cardErrors.plan_id = ["Please select subscription plan"];
      }
      return _.isEmpty(this.cardErrors);
    },
    processCardSubscription: function processCardSubscription() {
      var _this17 = this;

      var preview = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.subscribing || !this.validate()) return;
      this.subscribing = true;
      // let selectedPlan = this.planType + "_" + this.planShortPeriod;
      // let isPreviewSubscription =
      //   !this.currentPlan.id || this.currentPlan.id != selectedPlan;
      var isPreviewSubscription = preview;

      stripe.createPaymentMethod({
        type: "card",
        card: cardElement
      }).then(function (result) {
        // error handling
        if (result.error) {
          _this17.$set("cardErrors.card", [result.error.message]);
          _this17.subscribing = false;
        } else {
          _this17.$set("card.attached", true);
          _this17.processSubscriptionToken(isPreviewSubscription, 200, result.paymentMethod);
        }
      });
    },
    getSavePrice: function getSavePrice(planType) {
      var monthPlan = this.plans.find(function (plan) {
        return plan.key_name === planType + "_mo";
      });
      var yearPlan = this.plans.find(function (plan) {
        return plan.key_name === planType + "_yr";
      });

      return (monthPlan.price * 12 - yearPlan.price).toFixed(2);
    },
    changePlanPeriod: function changePlanPeriod(period) {
      if (period == "toggle") {
        this.planPeriod = this.planPeriod == "month" ? "year" : "month";
      } else {
        this.planPeriod = period;
      }
    },
    subscribeTo: function subscribeTo(planType) {
      var _this18 = this;

      if (this.currentPlan.id === planType + "_" + this.planShortPeriod) {
        this.currentPlanPage = true;
        return;
      }

      this.planType = planType;
      this.subscribing = true;
      api.checkBreedersLimit().then(function (response) {
        if (response.count > _this18.plan.max_breeders) {
          _this18.subscribing = false;
          _this18.subscriptionDowngradeCount = response.count;
          $("#preview-subscription-modal").modal("hide");
          _this18.downgradeSubscriptionModal();
          return;
        }
        _this18.subscribeWithPreview();
      });
    },
    toCard: function toCard() {
      this.cardErrors = {};
    },
    hideConfirmationModal: function hideConfirmationModal() {
      $("#preview-subscription-modal").modal("hide");
    },
    saveUpdateInfo: function saveUpdateInfo(updateInfo) {
      localStorage.setItem("update_info", (0, _stringify2.default)(updateInfo));
    },
    loadUpdateInfo: function loadUpdateInfo() {
      try {
        this.updateInfo = JSON.parse(localStorage.getItem("update_info"));
      } catch (e) {}

      localStorage.setItem("update_info", (0, _stringify2.default)({}));
    },
    saveUpdateInfoAndReload: function saveUpdateInfoAndReload(updateInfo) {
      this.saveUpdateInfo(updateInfo);
      document.location.reload(true);
    },
    checkIfExpiredSubscription: function checkIfExpiredSubscription() {
      if (App.user_status == "Expired Subscription (In-App)") {
        this.currentPlanPage = false;
      }
    },
    downgradeSubscriptionModal: function downgradeSubscriptionModal() {
      var _this19 = this;

      api.getBreedersListOpen({ active: true }).then(function (breeders) {
        _this19.activeBreeders = [].concat((0, _toConsumableArray3.default)(breeders.bucks), (0, _toConsumableArray3.default)(breeders.does));

        _this19.$nextTick(function () {
          _this19.activeBreeders.forEach(function (breeder) {
            $("#breeder-status-" + breeder.id).netlivaSwitch({
              state: true,
              width: "35px"
            }).on("netlivaSwitch.change", function (event, state, element) {
              if (!state) {
                _this19.forArchive.push(breeder.id);
              } else {
                _this19.forArchive = _this19.forArchive.filter(function (id) {
                  return id !== breeder.id;
                });
              }
            });
          });
        });

        // show modal
        $("#downgrade-subscription-modal").modal("show");
      });
    },
    archiveBreeders: function archiveBreeders() {
      var _this20 = this;

      this.loading = 1;
      if (!this.forArchive.length) {
        this.showAlert({
          type: 'warning',
          text: 'No breeders selected for archiving.'
        });

        return true;
      }

      api.archiveMultipleBreeders({ breeders: this.forArchive }).then(function (data) {
        _this20.loading = 0;
        _this20.showAlert({
          type: 'success',
          text: "Successfully archived " + _this20.forArchive.length + " breeder" + (_this20.forArchive.length > 1 ? 's' : '') + "."
        });

        _this20.forArchive = [];
        $("#downgrade-subscription-modal").modal("hide");
      }, function (response) {
        _this20.loading = 0;
        _this20.errors = response.data.errors;
      });
    },
    loadBeforeCancellationOptionData: function loadBeforeCancellationOptionData() {
      var _this21 = this;

      api.offerDiscountBeforeCancellation().then(function (data) {
        _this21.flexiblePlan = data.plans;
        _this21.isActiveDiscount = data.is_active_discount;
        _this21.isActivePauseSubscription = data.is_active_pause_subscription;
        _this21.pauseSubscriptionResumesAt = data.pause_subscription_resumes_at;
      }).catch(function (response) {
        console.log(response, "response");
      });
    }
  },
  ready: function ready() {
    var _this22 = this;

    this.loadPlans();
    this.loadCardData();
    this.loadInvoices();
    this.loadUpdateInfo();
    this.checkIfExpiredSubscription();
    this.loadBeforeCancellationOptionData();
    api.getUserSettingsData(this.user_id).then(function (data) {
      _this22.is_trial = data.user.is_trial;
      _this22.$nextTick(function () {
        $(".plan-period").iCheck({
          checkboxClass: "icheckbox_square-blue",
          radioClass: "iradio_square-blue"
        }).on("ifChecked", function (event) {
          this.planPeriod = $(event.target).val();
        }.bind(_this22));
        _this22.loaded = true;

        if (_this22.$route.query.plan && _this22.$route.query.period) {
          _this22.planPeriod = _this22.$route.query.period;
          _this22.subscribeTo(_this22.$route.query.plan);
        }
      });
    });
  },

  mixins: [App.Mixins.Generic, App.Mixins.Alerts]
};

},{"babel-runtime/core-js/json/stringify":20,"babel-runtime/core-js/object/assign":22,"babel-runtime/core-js/object/keys":27,"babel-runtime/helpers/toConsumableArray":41}],905:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Tours = {
  computed: {
    isShowButcher: function isShowButcher() {
      return App.isShowButcher;
    }
  },
  methods: {
    startTour: function startTour(section) {
      var _this = this;

      var currentRoute = this.$route.name;
      this.$http.get("/js/tours/steps.json?key=" + new Date().getTime()).then(function (response) {
        var intro = introJs();
        var data = response.data[section];
        var firstBreederId = 0;
        var firstTaskId = 0;

        // remove butcher depending on usage_purpose
        if (!_this.isShowButcher && section == "dashboard") {
          data.splice(4, 1);
        }

        // setup data for breeders list tour
        if (section == "breeders") {
          firstBreederId = _this.breeders.length ? _this.breeders[0].id : 0;

          if (!firstBreederId) {
            data.splice(6, 2);
          } else {
            _.map(data, function (item) {
              if (item.element && item.element.includes("{id}")) {
                item.element = item.element.replace("{id}", firstBreederId);
              }
            });
          }
        }

        // setup data for schedules list tour
        if (section == "schedule") {
          firstTaskId = _this.firstTaskId;
          if (!firstTaskId) {
            data.splice(3, 3);
          } else {
            _.map(data, function (item) {
              if (item.element && item.element.includes("{id}")) {
                item.element = item.element.replace("{id}", firstTaskId);
              }
            });
          }
        }

        intro.setOptions({
          steps: data,
          showBullets: false
        }).onbeforechange(function (targetElement) {
          var id = section == 'breeders' ? firstBreederId : firstTaskId;
          _this.hideDropdowns(id);

          switch (targetElement.id) {
            case "breeder-main-filters":
              $("#breeder-main-filters").parent().addClass("open");
              break;
            case "breeder-display-filters":
              $("#breeder-display-filters").parent().addClass("open");
              break;
            case "edit-id-" + firstBreederId:
              $("#edit-id-" + firstBreederId).parent().addClass("open");
              break;
            case "action-settings":
              $("#action-dropdown").parent().addClass("open");
              break;
            case "task-actions-" + firstTaskId:
              $("#task-actions-" + firstTaskId).parent().addClass("open");
              break;
            case "tasks-chain":
              $('.nav-pills a[href="#chain"]').tab('show');
              break;
            case "tasks-calendar":
              $('.nav-pills a[href="#calendar"]').tab('show');
              break;
            case "tasks-breedplans":
              $('.nav-pills a[href="#breed-plans"]').tab('show');
              break;
            case "":
              if (section == 'schedule') {
                $('.nav-pills a[href="#list"]').tab('show');
              }
              break;
          }
        }).oncomplete(function () {
          _this.showAlert({
            type: "success",
            text: currentRoute + " tour completed."
          });
        }).start();
      });
    },
    hideDropdowns: function hideDropdowns(id) {
      $("#breeder-main-filters").parent().removeClass("open");
      $("#breeder-display-filters").parent().removeClass("open");
      $("#edit-id-" + id).parent().removeClass("open");
      $("#action-dropdown").parent().removeClass("open");
      $("#task-actions-" + id).parent().removeClass("open");
    }
  },
  mixins: [App.Mixins.Alerts]
};

},{}],906:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.Transferable = {
  computed: {
    transferEmailDescription: function transferEmailDescription() {
      return "• If this user has an Everbreed account, " + "we will automatically transfer all rabbit data to their account so they do not have to enter it. \n\n" + "• None of your personal data or other records will be transferred. \n\n" + "• For buyers who do not have an Everbreed account, we will send them a link to download the rabbit's information. \n\n" + "• If you do not wish to send the rabbit's information to the buyer, or wish to do it manually, you can leave this field blank.";
    }
  },
  methods: {
    /**
     * Filter contacts data (only fetch contacts with email)
     */
    filterContacts: function filterContacts(value) {
      if (this.withArchivedContacts && value.email) {
        return true;
      }

      return value.archived === 0 && value.email;
    }
  },
  ready: function ready() {
    // initialize popover for transfer email description
    $("#email-popover").popover({
      template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content" style="white-space:pre-wrap;"></div></div>'
    });
  },

  mixins: [App.Mixins.Currency, App.Mixins.Contacts]
};

},{}],907:[function(require,module,exports){
'use strict';

if (!App.Mixins) {
    App.Mixins = {};
}

App.Mixins.Typeahead = {
    methods: {
        uniqueFieldSet: function uniqueFieldSet(data, field) {
            return _.sortBy(_.compact(_.unique(_.pluck(data, field))), function (item) {
                return item.toLowerCase();
            });
        },
        substringMatcher: function substringMatcher(strs) {
            return function findMatches(q, cb) {
                var matches, substrRegex;

                // an array that will be populated with substring matches
                matches = [];

                // regex used to determine if a string contains the substring `q`
                substrRegex = new RegExp(q, 'i');

                // iterate through the pool of strings and for any string that
                // contains the substring `q`, add it to the `matches` array
                $.each(strs, function (i, str) {
                    if (substrRegex.test(str)) {
                        matches.push(str);
                    }
                });

                cb(matches);
            };
        }
    }
};

},{}],908:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.UsagePurpose = {
  data: function data() {
    return {
      usage_purpose: {
        pets: false,
        show: false,
        wool: false,
        pelts: false,
        meat: false
      }
    };
  },

  computed: {
    usagePurposeDescription: function usagePurposeDescription() {
      return 'For example, butchering options will only be available if you select "Pelts" or "Meat". \n\n' + "You can change these later from the Settings page at any time.";
    }
  },
  methods: {
    /**
     * Custom data cleanup for usage purpose field
     */
    cleanUsagePurposeData: function cleanUsagePurposeData() {
      var usage = this.usage_purpose;
      var selected_usage = [];
      for (var key in usage) {
        if (usage[key]) {
          selected_usage.push(key);
        }
      }

      this.user.usage_purpose = selected_usage;

      if (selected_usage.includes("pelts") || selected_usage.includes("meat")) {
        App.isShowButcher = true;
      } else {
        App.isShowButcher = false;
      }
    },

    /**
     * Set usage purpose data from backend
     */
    prepareUsagePurposeData: function prepareUsagePurposeData(usage) {
      for (var key in usage) {
        this.usage_purpose[usage[key]] = true;
      }
    }
  },
  ready: function ready() {
    $("#usage-popover").popover({
      template: "<div class=\"popover field-popover\" role=\"tooltip\">\n            <div class=\"arrow\"></div>\n            <div class=\"popover-content\" style=\"white-space:pre-wrap;\"></div>\n        </div>"
    });
  }
};

},{}],909:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
  App.Mixins = {};
}

App.Mixins.WeighForm = {
  computed: {
    actualKitsCount: function actualKitsCount() {
      return this.kits.length;
    },
    weightSlug: function weightSlug() {
      return App.weight_slug;
    },
    weightUnits: function weightUnits() {
      return App.weight_units;
    }
  },
  watch: {
    kits: function kits() {
      var self = this;
      this.activeKit = this.kits[this.current];
      this.loaded = 1;
      this.weighedKits = [];
      if (this.first) {
        $.each(this.kits, function (i, kit) {
          if (kit.current_weight) {
            var isWeighed = _.find(self.weighedKits, function (item) {
              return item.id == kit.id;
            });
            if (!isWeighed) {
              self.weighedKits.push(kit);
            }
          }
        });
      }
    },
    current: function current() {
      if (this.kits[this.current]) {
        this.activeKit = this.kits[this.current];
      } else {
        this.current = this.kits.length - 1;
      }
    }
  },
  methods: {
    getGenderClass: function getGenderClass(sex) {
      if (!sex) {
        return "bg-gray-active";
      }
      return sex == "buck" ? "bg-aqua" : "bg-maroon";
    },
    generateIds: function generateIds() {
      var self = this;
      if (this.current == 0 && this.generate) {
        $.each(this.kits, function (i) {
          if (i) {
            this.given_id = isNaN(parseInt(self.kits[0].given_id)) ? self.kits[0].given_id + i : parseInt(self.kits[0].given_id) + i;
          }
        });
      }
    },
    showWeights: function showWeights(kit) {
      if (kit) {
        if (kit.weight && kit.weight.length) {
          if (kit.weight_unit_short === "lbs-oz") {
            return kit.weight_slug_array.join(" - ");
          } else if (kit.weight) {
            return kit.weight.join(" - ") + " " + this.getWeightSlug();
          }
        } else {
          if (kit.weight_unit_short === "lbs-oz" && kit.current_weight) {
            return this.calcLbsOunces(kit.current_weight);
          }
          return (kit.current_weight || 0) + " " + this.getWeightSlug();
        }
      }
    },
    diedKit: function diedKit(kit) {
      $("#kit-" + kit.id).fadeOut(500);
      this.kits = _.reject(this.kits, function (_kit) {
        return _kit.id == kit.id;
      });
      api.dieKit(kit, { default_death_reason: true });
      return false;
    },
    setActiveKit: function setActiveKit(kit, index) {
      if (this.first) {
        this.changed && this.saveKit(_.extend({}, this.activeKit));
        this.changed = -1;

        this.activeKit = kit;
        this.current = index;
      }
    },
    saveWeight: function saveWeight(kit) {
      kit.current_weight_date = this.getTimestamp(this.date);
      var isWeighed = _.find(this.weighedKits, function (item) {
        return item.id == kit.id;
      });
      if (!isWeighed) {
        this.weighedKits.push(kit);
      }
    },
    saveKit: function saveKit(kit, callback) {
      var _kit = kit || _.extend({}, this.activeKit);

      if (_kit.weight == null) {
        _kit.weight = [];
      }

      var _current_weight_date = this.getTimestamp(this.date);
      _kit.current_weight_date = _current_weight_date;
      this.activeKit.current_weight_date = _current_weight_date;

      _kit.return_count = 1;
      var self = this;
      self.weighedKits = [];
      $.each(self.kits, function (i, kit) {
        if (kit.current_weight) {
          var isWeighed = _.find(self.weighedKits, function (item) {
            return item.id == kit.id;
          });
          if (!isWeighed) {
            self.weighedKits.push(kit);
          }
        }
      });
    },
    prevKit: function prevKit() {
      if (this.kits.length > 1) {
        this.activeKit.current_weight && this.changed && this.saveKit();
      }
      this.changed = -1;

      this.current--;
    },
    nextKit: function nextKit() {
      if (this.kits.length >= 1) {
        this.activeKit.current_weight && this.changed && this.saveKit();
      }
      this.changed = -1;
      this.generateIds();

      if (this.current + 1 >= this.kits.length) {
        this.current = 0;
      } else {
        this.current++;
      }
    },
    getTimestamp: function getTimestamp(dateString) {
      if (App.dateFormat == "DD/MM/YYYY") {
        var dateParts = dateString.split("/");
        dateString = dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
      }
      return new Date(dateString).getTime();
    },
    initTypeahead: function initTypeahead() {
      var _this = this;

      api.getKitsAutocomplete().then(function (data) {
        _this.colors = data.color;
        _this.weights = data.weight;
      });
    },
    getParentName: function getParentName(item, index) {
      return item.parents[index] ? item.parents[1].name : "";
    },
    getOptionTitle: function getOptionTitle(item) {
      var title = "";

      if (item) {
        if (item.parents && item.parents.length > 1) {
          title += item.parents[0].name + "+" + item.parents[1].name;
        }

        title += " - " + item.given_id;
      }

      return title;
    }
  },
  ready: function ready() {
    this.initTypeahead();
  }
};

},{}],910:[function(require,module,exports){
"use strict";

if (!App.Mixins) {
    App.Mixins = {};
}

App.Mixins.Weightable = {
    methods: {
        showWeights: function showWeights(weight, slug) {
            if (slug === "lbs-oz") {
                return this.calcLbsOunces(weight);
            }
            return parseFloat(weight).toFixed(2) + " " + slug;
        },
        calcLbsOunces: function calcLbsOunces(weight) {
            if (weight === 0) {
                return '0.00 lbs';
            }

            var lbs = Math.floor(weight / 16);
            var oz = weight % 16;

            var txt = (lbs > 0 ? lbs + ' lbs ' : '') + (oz > 0 ? oz.toFixed(2) + ' oz' : '');

            return txt.trim();
        },
        getWeightSlug: function getWeightSlug() {
            return App.weight_slug.replace('-', '/');
        },
        isLbsOunces: function isLbsOunces(weight) {
            return weight === 'Pound/Ounces';
        }
    }
};

},{}],911:[function(require,module,exports){
'use strict';

;(function () {

    App.MobileTypes = function () {

        if (!App.allmobiles()) {
            return false;
        }

        $('[data-mobile-type]').each(function (i, el) {
            var $this = $(el);
            var type = $this.data('mobile-type');

            $this.attr('type', type);

            if (type == "date") {
                $this.focusout(function () {
                    $this.attr('type', 'text');
                    $this.val(App.formatDate($this.val()));
                }).on('touchstart', function () {
                    if ($this.attr('type') == "text") {
                        $this.attr('type', type);
                    }
                });
            }
        });
    };
})();

},{}],912:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _posthogJs = require('posthog-js');

var _posthogJs2 = _interopRequireDefault(_posthogJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  install: function install(Vue) {
    _posthogJs2.default.init(App.posthog_api_key, {
      api_host: App.posthog_api_host,
      autocapture: false
    });

    _posthogJs2.default.identify(App.user_id, { email: App.user_email, name: App.user_name });

    Vue.prototype.$posthog = _posthogJs2.default;
  }
}; // src/plugins/posthog.js

},{"posthog-js":647}],913:[function(require,module,exports){
'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Notification manager which just uses the one available implementation out of provided list.
 * All of the managers must implement similar interface (public part).
 * @param managers
 * @constructor
 */
var CompositeNotificationManager = function CompositeNotificationManager(managers) {
    this._managers = managers;
    this._manager = undefined;
};

// Functions required for any notifications manager (public interface)

CompositeNotificationManager.prototype.isAvailable = function () {
    return this.getManager().then(function () {
        return true;
    }, function () {
        return false;
    });
};

CompositeNotificationManager.prototype.isDisabled = function () {
    return this.getManager().then(function (manager) {
        return manager.isDisabled();
    }, function () {
        return false;
    });
};

CompositeNotificationManager.prototype.isSubscribed = function () {
    return this.getManager().then(function (manager) {
        return manager.isSubscribed();
    }, function () {
        return false;
    });
};

CompositeNotificationManager.prototype.subscribe = function () {
    return this.getManager().then(function (manager) {
        return manager.subscribe();
    });
};

CompositeNotificationManager.prototype.unsubscribe = function () {
    return this.getManager().then(function (manager) {
        return manager.unsubscribe();
    });
};

CompositeNotificationManager.prototype.updateServer = function () {
    return this.getManager().then(function (manager) {
        return manager.updateServer();
    }, function () {});
};

// Privates

CompositeNotificationManager.prototype.getManager = function () {
    var _this = this;

    if (typeof this._manager !== 'undefined') {
        return this._manager ? _promise2.default.resolve(this._manager) : _promise2.default.reject();
    }

    return this._managers.reduce(function (promise, manager) {
        // Let's initiate inquiry before waiting for result of previous
        var managerAvailable = manager.isAvailable();
        // So, check if any of the previous managers are available
        return promise.then(function (available) {
            // ... and if so, just pass the first available manager
            if (available) {
                return _promise2.default.resolve(available);
            }
            // Otherwise, check if current manager is available
            return managerAvailable.then(function (res) {
                return res ? manager : null;
            });
        });
    }, _promise2.default.resolve(null)).then(function (manager) {
        // Cache the found manager for consistency
        if (manager === null) {
            return _promise2.default.reject();
        }

        _this._manager = manager;

        return manager;
    });
};

CompositeNotificationManager.prototype.reload = function () {
    delete this._manager;
};

// Export

window.NotificationManager = new CompositeNotificationManager([
// List here all the web notifications implementations
window.WebPushNotificationManager]);

},{"babel-runtime/core-js/promise":30}],914:[function(require,module,exports){
'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var urlB64ToUint8Array = function urlB64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
},
    bufferToB64 = function bufferToB64(buffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
};

var WebPushNotificationManager = function WebPushNotificationManager() {};

// Functions required for any notifications manager

WebPushNotificationManager.prototype.isAvailable = function () {
    return _promise2.default.resolve('serviceWorker' in navigator && 'PushManager' in window);
};

WebPushNotificationManager.prototype.isDisabled = function () {
    return this.getServiceWorker().then(function (swReg) {
        return swReg.pushManager.permissionState({ userVisibleOnly: true }).then(function (state) {
            return state === 'denied';
        });
    });
};

WebPushNotificationManager.prototype.isSubscribed = function () {
    return this.getSubscription().then(function (sub) {
        return !!sub;
    });
};

WebPushNotificationManager.prototype.subscribe = function () {
    var _this = this;

    return this.getSubscription().then(function (sub) {
        if (sub) {
            _this.saveCredentials(sub, false);
        } else {
            return _this.reSubscribe().then(function (sub) {
                _this.saveCredentials(sub, true).then(function () {});
            });
        }
    });
};

WebPushNotificationManager.prototype.unsubscribe = function () {
    return this.getSubscription().then(function (sub) {
        if (!sub) return;
        return sub.unsubscribe();
    });
};

WebPushNotificationManager.prototype.updateServer = function () {
    var _this2 = this;

    return this.getSubscription().then(function (sub) {
        if (sub) {
            _this2.saveCredentials(sub, false);
        }
    }, function () {});
};

// Functions specific to this service

WebPushNotificationManager.prototype.saveCredentials = function (sub, reset) {
    var publicKey = null,
        authToken = null;
    if (typeof sub.getKey === 'function') {
        // At least Firefox documentation claims this method is specific to them,
        // but Chrome also has it
        publicKey = bufferToB64(sub.getKey('p256dh'));
        authToken = bufferToB64(sub.getKey('auth'));
    }
    return api.saveWebPushEndpoint(sub.endpoint, reset, publicKey, authToken);
};

WebPushNotificationManager.prototype.getServiceWorker = function () {
    if (!this.isAvailable()) return _promise2.default.reject('service_workers_not_available');

    return navigator.serviceWorker.register('service-worker.js?v2');
};

WebPushNotificationManager.prototype.getSubscription = function () {
    return this.getServiceWorker().then(function (swReg) {
        return swReg.pushManager.getSubscription();
    });
};

WebPushNotificationManager.prototype.reSubscribe = function () {
    return this.getServiceWorker().then(function (swReg) {
        return swReg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlB64ToUint8Array(window.web_push_public)
        }).then(function (sub) {
            console.log('Successfully subscribed', sub, sub.endpoint, '<<');
            swReg.showNotification('Everbreed Notifications Enabled!', {
                body: 'Thanks for subscribing to Everbreed Notifications.',
                icon: 'img/favicon/favicon-96x96.png'
            });
            return sub;
        }, function (err) {
            console.log('Error while trying to subscribe: ', err);
            return _promise2.default.reject(err);
        });
    });
};

// Export the manager

window.WebPushNotificationManager = new WebPushNotificationManager();

},{"babel-runtime/core-js/promise":30}],915:[function(require,module,exports){
'use strict';

var _vueSortable = require('vue-sortable');

var _vueSortable2 = _interopRequireDefault(_vueSortable);

var _eventBus = require('./event-bus');

var _eventBus2 = _interopRequireDefault(_eventBus);

var _mixpanelBrowser = require('mixpanel-browser');

var _mixpanelBrowser2 = _interopRequireDefault(_mixpanelBrowser);

var _posthog = require('./service/posthog');

var _posthog2 = _interopRequireDefault(_posthog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Global app eVents
App.vent = $('body');


App.init = function () {
    if (window.user_id) {
        _mixpanelBrowser2.default.init(App.mixpanel_key);
        _mixpanelBrowser2.default.identify(window.user_id);
        _mixpanelBrowser2.default.people.set({
            "$email": App.user_email,
            "sign_up_date": App.user_signup_date,
            "user_id": window.user_id,
            "plan": App.plan ? App.plan.key_name : 'N/A'
        });
    }

    if (window.location.hash == '#_=_') {
        window.location.hash = '#';
    }

    Vue.use(VueResource);
    Vue.use(VueRouter);
    Vue.use(VueValidator);
    Vue.use(_vueSortable2.default);
    Vue.use(_posthog2.default);

    Vue.filter('caseInsensitiveOrderBy', function (arr, sortKey, reverse) {
        // arr = convertArray(arr)
        if (!sortKey) {
            return arr;
        }
        var order = reverse && reverse < 0 ? -1 : 1;
        // sort on a copy to avoid mutating original array
        return arr.slice().sort(function (a, b) {
            if (sortKey !== '$key') {
                if (Vue.util.isObject(a) && '$value' in a) a = a.$value;
                if (Vue.util.isObject(b) && '$value' in b) b = b.$value;
            }
            a = Vue.util.isObject(a) ? Vue.parsers.path.getPath(a, sortKey) : a;
            b = Vue.util.isObject(b) ? Vue.parsers.path.getPath(b, sortKey) : b;

            a = a.toLowerCase();
            b = b.toLowerCase();

            return a === b ? 0 : a > b ? order : -order;
        });
    });

    Vue.filter('capitalize', function (value) {
        if (!value) {
            return '';
        }
        value = value.toString();

        return value.charAt(0).toUpperCase() + value.slice(1);
    });

    Vue.filter('formatDate', function (value) {
        if (value) {
            return moment(value).format(App.dateFormat);
        }
    });

    Vue.filter('formatDateTime', function (value) {
        if (value) {
            return moment(value).format(App.dateFormat + ' HH:mm:ss');
        }
    });

    Vue.filter('toFixed', function (value, precision) {
        if (value) {
            return value.toFixed(precision);
        }
    });

    Vue.http.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');

    var router = new VueRouter();
    router.afterEach(function (transition) {
        if (transition.from.path) {
            $('#app-error,#app-success').fadeOut();
        }
    });

    router.beforeEach(function (transition) {

        if (!App.isSubscribed && transition.to.path !== "/account") {
            transition.abort();
            router.go("/account");
        } else if (App.isPausedSubscription && transition.to.path !== "/account") {
            transition.abort();
            router.go("/account");
        } else if (App.onOutdatedPlan && transition.to.path !== "/account") {
            transition.abort();
            _eventBus2.default.$emit("on-outdated-plan");
        } else if (!App.isOnboarded && App.isSubscribed && transition.to.path !== "/wizard/settings") {
            transition.abort();
            router.go("/wizard/settings");
        } else if (!App.isTrial && !App.admin && ((!App.plan || !App.plan[App.access.ledger]) && transition.to.path.indexOf("/ledger") === 0 || (!App.plan || !App.plan[App.access.cage_cards]) && transition.to.path.indexOf("/cage-cards") === 0 || (!App.plan || !App.plan[App.access.contacts]) && transition.to.path.indexOf("/finances/contacts") === 0 || (!App.plan || !App.plan[App.access.health]) && transition.to.path.indexOf("/health") === 0)) {
            transition.abort();
            _eventBus2.default.$emit("restrict-access");
        } else {
            transition.next();
        }
    });
    router.afterEach(function (transition) {
        /*
        try {
            ga('send', {
                hitType: 'pageview',
                page: transition.to.path
            })
        } catch(error) {}
        GA4 removed*/

        if (window.user_id) {
            _mixpanelBrowser2.default.track("Page view", { "Transition From": transition.from.path, "Transition To": transition.to.path });
        }
    });

    router.map({
        '/': {
            component: App.Components.DashboardV2,
            name: 'Dashboard'
        },
        '/breeders': {
            component: App.Components.Breeders,
            name: 'Breeders'
        },
        '/breeders/categories': {
            component: App.Components.BreederCategoriesOld,
            name: 'Breeder Categories'
        },
        '/breeders/category/:category': {
            component: App.Components.Breeders,
            name: 'Breeder Category'
        },
        '/breeders/:action': {
            component: App.Components.Breeders,
            name: 'Breeder Type'
        },
        '/litters': {
            component: App.Components.Litters,
            name: 'Litters'
        },
        '/litters/:action': {
            component: App.Components.Litters,
            name: 'Litter Type'
        },
        '/profile/:id': {
            component: App.Components.Profile,
            name: 'Breeder Profile'
        },
        '/pedigree/:id': {
            component: App.Components.Pedigree,
            name: 'Breeder Pedigree'
        },
        '/pedigree/kit/:id': {
            component: App.Components.KitPedigree,
            name: 'Kit Pedigree'
        },
        '/birth-certificate/kit/:id': {
            component: App.Components.KitBirthCertificate,
            name: 'Kit Birth Certificate'
        },
        '/litterprofile/:id': {
            component: App.Components.LitterProfile,
            name: 'Litter Profile'
        },
        '/sub-users': {
            component: App.Components.SubUsers,
            name: 'Sub Users'
        },
        '/users': {
            component: App.Components.Users,
            name: 'Users'
        },
        '/users/:userId/edit': {
            component: App.Components.User,
            name: 'User Edit'
        },
        '/users/create': {
            component: App.Components.User,
            name: 'User Create'
        },
        '/attachments': {
            component: App.Components.Attachments,
            name: 'Attachments'
        },
        '/schedule': {
            component: App.Components.Schedule,
            name: 'Schedule'
        },
        '/health': {
            component: App.Components.Health,
            name: 'Health'
        },
        '/settings': {
            component: App.Components.Settings,
            name: 'Settings'
        },
        '/account': {
            component: App.Components.AccountSettingsV2,
            name: 'Account'
        },
        '/referrals': {
            component: App.Components.Referrals,
            name: 'Referrals'
        },
        '/marketplace': {
            component: App.Components.MarketplaceList,
            name: 'Marketplace'
        },
        '/ledger': {
            component: App.Components.Ledger,
            name: 'Ledger'
        },
        '/ledger/categories': {
            component: App.Components.LedgerCategories,
            name: 'Ledger Categories'
        },
        '/ledger/category/:category': {
            component: App.Components.Ledger,
            name: 'Ledger Category'
        },
        '/ledger/:type': {
            component: App.Components.Ledger,
            name: 'Ledget Type'
        },
        '/reports': {
            component: App.Components.Reports,
            name: 'Reports'
        },
        '/admin-reports': {
            component: App.Components.AdminReports,
            name: 'Admin Reports'
        },
        '/referrals-reports': {
            component: App.Components.ReferralsReports,
            name: 'Referrals Reports'
        },
        '/cancellations': {
            component: App.Components.Cancellations,
            name: 'Cancellations'
        },
        '/wizard': {
            component: App.Components.Wizard,
            name: 'Wizard',
            subRoutes: {
                '/settings': {
                    component: App.Components.GamifySettings,
                    name: 'Settings Wizard'
                },
                '/breeders': {
                    component: App.Components.WizardBreeders,
                    name: 'Breeders Wizard'
                },
                '/ledgers': {
                    component: App.Components.WizardLedgers,
                    name: 'Ledgers Wizard'
                }
            }
        },
        '/cage-cards/templates': {
            component: App.Components.CageCardsTemplatesList,
            name: 'Cage Cards'
        },
        '/finances/contacts': {
            component: App.Components.Contacts,
            name: 'Contacts'
        },
        '/finances/contacts/:status': {
            component: App.Components.Contacts,
            name: 'Contact Status'
        },
        '/broadcast': {
            component: App.Components.broadcastList,
            name: 'Broadcast'
        },
        '/features': {
            component: App.Components.Features,
            name: 'Feature Flags'
        },
        '/features/:id': {
            component: App.Components.Feature,
            name: 'Feature Flag'
        },
        '/data-delete': {
            component: App.Components.DataDelete,
            name: 'Data Delete'
        },
        '/mrr-subscriber-reports': {
            component: App.Components.MrrSubscriberReports,
            name: 'Mrr Subscriber Reports'
        }
    });
    router.start({
        components: {
            'broadcast-form': App.Components.BroadcastForm,
            'broadcast-alert': App.Components.BroadcastAlert,
            'sidebar': App.Components.Sidebar,
            'auto-upgrade-subscription': App.Components.AutoUpgradeSubscription,
            'in-app-apple-upgrade-subscription': App.Components.InAppAppleUpgradeSubscription,
            'restrict-access': App.Components.RestrictAccess,
            'on-outdated-plan': App.Components.OnOutdatedPlan,
            'tour-link': App.Components.TourLink,
            'notification-tab': App.Components.NotificationTab,
            'farm-management': App.Components.FarmManagement,
            'global-forms': App.Components.GlobalForms,
            'feature-feedback': App.Components.FeatureFeedback
        }
    }, '#vue-app');

    if (window.user_id) {
        // Only invoke for authenticated users
        window.NotificationManager.updateServer();
    }
};

},{"./event-bus":882,"./service/posthog":912,"mixpanel-browser":634,"vue-sortable":697}]},{},[874,882,708,885,897,883,914,913,889,886,888,890,893,894,891,896,904,887,907,902,910,884,906,899,908,895,905,900,892,898,909,867,754,755,851,779,772,823,849,877,878,876,881,880,736,735,815,879,856,724,723,725,868,727,728,726,766,733,806,803,809,805,808,807,790,799,798,746,800,797,788,786,787,789,794,793,748,747,740,738,744,745,739,776,777,773,757,756,813,812,866,865,853,854,845,858,857,864,859,734,848,847,846,715,861,769,716,862,770,771,811,836,835,752,751,722,775,731,730,729,732,791,796,778,749,795,780,782,781,717,719,718,720,741,792,810,814,760,850,870,873,869,871,714,713,816,852,768,863,759,767,761,801,758,860,804,783,785,784,872,721,774,844,802,837,818,750,824,832,838,842,831,833,822,840,817,834,855,763,762,875,911,742,743,764,765,753,915,737,829,843,841,819,828,839,821,820,830,826,827,825]);
